(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(self, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 105:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CameraControls)
/* harmony export */ });
/*!
 * camera-controls
 * https://github.com/yomotsu/camera-controls
 * (c) 2017 @yomotsu
 * Released under the MIT License.
 */
// see https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/buttons#value
const MOUSE_BUTTON = {
    LEFT: 1,
    RIGHT: 2,
    MIDDLE: 4,
};
const ACTION = Object.freeze({
    NONE: 0,
    ROTATE: 1,
    TRUCK: 2,
    OFFSET: 4,
    DOLLY: 8,
    ZOOM: 16,
    TOUCH_ROTATE: 32,
    TOUCH_TRUCK: 64,
    TOUCH_OFFSET: 128,
    TOUCH_DOLLY: 256,
    TOUCH_ZOOM: 512,
    TOUCH_DOLLY_TRUCK: 1024,
    TOUCH_DOLLY_OFFSET: 2048,
    TOUCH_DOLLY_ROTATE: 4096,
    TOUCH_ZOOM_TRUCK: 8192,
    TOUCH_ZOOM_OFFSET: 16384,
    TOUCH_ZOOM_ROTATE: 32768,
});
const DOLLY_DIRECTION = {
    NONE: 0,
    IN: 1,
    OUT: -1,
};
function isPerspectiveCamera(camera) {
    return camera.isPerspectiveCamera;
}
function isOrthographicCamera(camera) {
    return camera.isOrthographicCamera;
}

const PI_2 = Math.PI * 2;
const PI_HALF = Math.PI / 2;

const EPSILON = 1e-5;
const DEG2RAD = Math.PI / 180;
function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
function approxZero(number, error = EPSILON) {
    return Math.abs(number) < error;
}
function approxEquals(a, b, error = EPSILON) {
    return approxZero(a - b, error);
}
function roundToStep(value, step) {
    return Math.round(value / step) * step;
}
function infinityToMaxNumber(value) {
    if (isFinite(value))
        return value;
    if (value < 0)
        return -Number.MAX_VALUE;
    return Number.MAX_VALUE;
}
function maxNumberToInfinity(value) {
    if (Math.abs(value) < Number.MAX_VALUE)
        return value;
    return value * Infinity;
}
// https://docs.unity3d.com/ScriptReference/Mathf.SmoothDamp.html
// https://github.com/Unity-Technologies/UnityCsReference/blob/a2bdfe9b3c4cd4476f44bf52f848063bfaf7b6b9/Runtime/Export/Math/Mathf.cs#L308
function smoothDamp(current, target, currentVelocityRef, smoothTime, maxSpeed = Infinity, deltaTime) {
    // Based on Game Programming Gems 4 Chapter 1.10
    smoothTime = Math.max(0.0001, smoothTime);
    const omega = 2 / smoothTime;
    const x = omega * deltaTime;
    const exp = 1 / (1 + x + 0.48 * x * x + 0.235 * x * x * x);
    let change = current - target;
    const originalTo = target;
    // Clamp maximum speed
    const maxChange = maxSpeed * smoothTime;
    change = clamp(change, -maxChange, maxChange);
    target = current - change;
    const temp = (currentVelocityRef.value + omega * change) * deltaTime;
    currentVelocityRef.value = (currentVelocityRef.value - omega * temp) * exp;
    let output = target + (change + temp) * exp;
    // Prevent overshooting
    if (originalTo - current > 0.0 === output > originalTo) {
        output = originalTo;
        currentVelocityRef.value = (output - originalTo) / deltaTime;
    }
    return output;
}
// https://docs.unity3d.com/ScriptReference/Vector3.SmoothDamp.html
// https://github.com/Unity-Technologies/UnityCsReference/blob/a2bdfe9b3c4cd4476f44bf52f848063bfaf7b6b9/Runtime/Export/Math/Vector3.cs#L97
function smoothDampVec3(current, target, currentVelocityRef, smoothTime, maxSpeed = Infinity, deltaTime, out) {
    // Based on Game Programming Gems 4 Chapter 1.10
    smoothTime = Math.max(0.0001, smoothTime);
    const omega = 2 / smoothTime;
    const x = omega * deltaTime;
    const exp = 1 / (1 + x + 0.48 * x * x + 0.235 * x * x * x);
    let targetX = target.x;
    let targetY = target.y;
    let targetZ = target.z;
    let changeX = current.x - targetX;
    let changeY = current.y - targetY;
    let changeZ = current.z - targetZ;
    const originalToX = targetX;
    const originalToY = targetY;
    const originalToZ = targetZ;
    // Clamp maximum speed
    const maxChange = maxSpeed * smoothTime;
    const maxChangeSq = maxChange * maxChange;
    const magnitudeSq = changeX * changeX + changeY * changeY + changeZ * changeZ;
    if (magnitudeSq > maxChangeSq) {
        const magnitude = Math.sqrt(magnitudeSq);
        changeX = changeX / magnitude * maxChange;
        changeY = changeY / magnitude * maxChange;
        changeZ = changeZ / magnitude * maxChange;
    }
    targetX = current.x - changeX;
    targetY = current.y - changeY;
    targetZ = current.z - changeZ;
    const tempX = (currentVelocityRef.x + omega * changeX) * deltaTime;
    const tempY = (currentVelocityRef.y + omega * changeY) * deltaTime;
    const tempZ = (currentVelocityRef.z + omega * changeZ) * deltaTime;
    currentVelocityRef.x = (currentVelocityRef.x - omega * tempX) * exp;
    currentVelocityRef.y = (currentVelocityRef.y - omega * tempY) * exp;
    currentVelocityRef.z = (currentVelocityRef.z - omega * tempZ) * exp;
    out.x = targetX + (changeX + tempX) * exp;
    out.y = targetY + (changeY + tempY) * exp;
    out.z = targetZ + (changeZ + tempZ) * exp;
    // Prevent overshooting
    const origMinusCurrentX = originalToX - current.x;
    const origMinusCurrentY = originalToY - current.y;
    const origMinusCurrentZ = originalToZ - current.z;
    const outMinusOrigX = out.x - originalToX;
    const outMinusOrigY = out.y - originalToY;
    const outMinusOrigZ = out.z - originalToZ;
    if (origMinusCurrentX * outMinusOrigX + origMinusCurrentY * outMinusOrigY + origMinusCurrentZ * outMinusOrigZ > 0) {
        out.x = originalToX;
        out.y = originalToY;
        out.z = originalToZ;
        currentVelocityRef.x = (out.x - originalToX) / deltaTime;
        currentVelocityRef.y = (out.y - originalToY) / deltaTime;
        currentVelocityRef.z = (out.z - originalToZ) / deltaTime;
    }
    return out;
}

function extractClientCoordFromEvent(pointers, out) {
    out.set(0, 0);
    pointers.forEach((pointer) => {
        out.x += pointer.clientX;
        out.y += pointer.clientY;
    });
    out.x /= pointers.length;
    out.y /= pointers.length;
}

function notSupportedInOrthographicCamera(camera, message) {
    if (isOrthographicCamera(camera)) {
        console.warn(`${message} is not supported in OrthographicCamera`);
        return true;
    }
    return false;
}

class EventDispatcher {
    constructor() {
        this._listeners = {};
    }
    /**
     * Adds the specified event listener.
     * @param type event name
     * @param listener handler function
     * @category Methods
     */
    addEventListener(type, listener) {
        const listeners = this._listeners;
        if (listeners[type] === undefined)
            listeners[type] = [];
        if (listeners[type].indexOf(listener) === -1)
            listeners[type].push(listener);
    }
    /**
     * Presence of the specified event listener.
     * @param type event name
     * @param listener handler function
     * @category Methods
     */
    hasEventListener(type, listener) {
        const listeners = this._listeners;
        return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
    }
    /**
     * Removes the specified event listener
     * @param type event name
     * @param listener handler function
     * @category Methods
     */
    removeEventListener(type, listener) {
        const listeners = this._listeners;
        const listenerArray = listeners[type];
        if (listenerArray !== undefined) {
            const index = listenerArray.indexOf(listener);
            if (index !== -1)
                listenerArray.splice(index, 1);
        }
    }
    /**
     * Removes all event listeners
     * @param type event name
     * @category Methods
     */
    removeAllEventListeners(type) {
        if (!type) {
            this._listeners = {};
            return;
        }
        if (Array.isArray(this._listeners[type]))
            this._listeners[type].length = 0;
    }
    /**
     * Fire an event type.
     * @param event DispatcherEvent
     * @category Methods
     */
    dispatchEvent(event) {
        const listeners = this._listeners;
        const listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            const array = listenerArray.slice(0);
            for (let i = 0, l = array.length; i < l; i++) {
                array[i].call(this, event);
            }
        }
    }
}

const VERSION = '2.7.1'; // will be replaced with `version` in package.json during the build process.
const TOUCH_DOLLY_FACTOR = 1 / 8;
const isBrowser = typeof window !== 'undefined';
const isMac = isBrowser && /Mac/.test(navigator.platform);
const isPointerEventsNotSupported = !(isBrowser && 'PointerEvent' in window); // macOS Safari 12 does not support PointerEvents API
let THREE;
let _ORIGIN;
let _AXIS_Y;
let _AXIS_Z;
let _v2;
let _v3A;
let _v3B;
let _v3C;
let _cameraDirection;
let _xColumn;
let _yColumn;
let _zColumn;
let _deltaTarget;
let _deltaOffset;
let _sphericalA;
let _sphericalB;
let _box3A;
let _box3B;
let _sphere;
let _quaternionA;
let _quaternionB;
let _rotationMatrix;
let _raycaster;
class CameraControls extends EventDispatcher {
    /**
     * Injects THREE as the dependency. You can then proceed to use CameraControls.
     *
     * e.g
     * ```javascript
     * CameraControls.install( { THREE: THREE } );
     * ```
     *
     * Note: If you do not wish to use enter three.js to reduce file size(tree-shaking for example), make a subset to install.
     *
     * ```js
     * import {
     * 	Vector2,
     * 	Vector3,
     * 	Vector4,
     * 	Quaternion,
     * 	Matrix4,
     * 	Spherical,
     * 	Box3,
     * 	Sphere,
     * 	Raycaster,
     * 	MathUtils,
     * } from 'three';
     *
     * const subsetOfTHREE = {
     * 	Vector2   : Vector2,
     * 	Vector3   : Vector3,
     * 	Vector4   : Vector4,
     * 	Quaternion: Quaternion,
     * 	Matrix4   : Matrix4,
     * 	Spherical : Spherical,
     * 	Box3      : Box3,
     * 	Sphere    : Sphere,
     * 	Raycaster : Raycaster,
     * };

     * CameraControls.install( { THREE: subsetOfTHREE } );
     * ```
     * @category Statics
     */
    static install(libs) {
        THREE = libs.THREE;
        _ORIGIN = Object.freeze(new THREE.Vector3(0, 0, 0));
        _AXIS_Y = Object.freeze(new THREE.Vector3(0, 1, 0));
        _AXIS_Z = Object.freeze(new THREE.Vector3(0, 0, 1));
        _v2 = new THREE.Vector2();
        _v3A = new THREE.Vector3();
        _v3B = new THREE.Vector3();
        _v3C = new THREE.Vector3();
        _cameraDirection = new THREE.Vector3();
        _xColumn = new THREE.Vector3();
        _yColumn = new THREE.Vector3();
        _zColumn = new THREE.Vector3();
        _deltaTarget = new THREE.Vector3();
        _deltaOffset = new THREE.Vector3();
        _sphericalA = new THREE.Spherical();
        _sphericalB = new THREE.Spherical();
        _box3A = new THREE.Box3();
        _box3B = new THREE.Box3();
        _sphere = new THREE.Sphere();
        _quaternionA = new THREE.Quaternion();
        _quaternionB = new THREE.Quaternion();
        _rotationMatrix = new THREE.Matrix4();
        _raycaster = new THREE.Raycaster();
    }
    /**
     * list all ACTIONs
     * @category Statics
     */
    static get ACTION() {
        return ACTION;
    }
    /**
     * Creates a `CameraControls` instance.
     *
     * Note:
     * You **must install** three.js before using camera-controls. see [#install](#install)
     * Not doing so will lead to runtime errors (`undefined` references to THREE).
     *
     * e.g.
     * ```
     * CameraControls.install( { THREE } );
     * const cameraControls = new CameraControls( camera, domElement );
     * ```
     *
     * @param camera A `THREE.PerspectiveCamera` or `THREE.OrthographicCamera` to be controlled.
     * @param domElement A `HTMLElement` for the draggable area, usually `renderer.domElement`.
     * @category Constructor
     */
    constructor(camera, domElement) {
        super();
        /**
         * Minimum vertical angle in radians.
         * The angle has to be between `0` and `.maxPolarAngle` inclusive.
         * The default value is `0`.
         *
         * e.g.
         * ```
         * cameraControls.maxPolarAngle = 0;
         * ```
         * @category Properties
         */
        this.minPolarAngle = 0; // radians
        /**
         * Maximum vertical angle in radians.
         * The angle has to be between `.maxPolarAngle` and `Math.PI` inclusive.
         * The default value is `Math.PI`.
         *
         * e.g.
         * ```
         * cameraControls.maxPolarAngle = Math.PI;
         * ```
         * @category Properties
         */
        this.maxPolarAngle = Math.PI; // radians
        /**
         * Minimum horizontal angle in radians.
         * The angle has to be less than `.maxAzimuthAngle`.
         * The default value is `- Infinity`.
         *
         * e.g.
         * ```
         * cameraControls.minAzimuthAngle = - Infinity;
         * ```
         * @category Properties
         */
        this.minAzimuthAngle = -Infinity; // radians
        /**
         * Maximum horizontal angle in radians.
         * The angle has to be greater than `.minAzimuthAngle`.
         * The default value is `Infinity`.
         *
         * e.g.
         * ```
         * cameraControls.maxAzimuthAngle = Infinity;
         * ```
         * @category Properties
         */
        this.maxAzimuthAngle = Infinity; // radians
        // How far you can dolly in and out ( PerspectiveCamera only )
        /**
         * Minimum distance for dolly. The value must be higher than `0`. Default is `Number.EPSILON`.
         * PerspectiveCamera only.
         * @category Properties
         */
        this.minDistance = Number.EPSILON;
        /**
         * Maximum distance for dolly. The value must be higher than `minDistance`. Default is `Infinity`.
         * PerspectiveCamera only.
         * @category Properties
         */
        this.maxDistance = Infinity;
        /**
         * `true` to enable Infinity Dolly for wheel and pinch. Use this with `minDistance` and `maxDistance`
         * If the Dolly distance is less (or over) than the `minDistance` (or `maxDistance`), `infinityDolly` will keep the distance and pushes the target position instead.
         * @category Properties
         */
        this.infinityDolly = false;
        /**
         * Minimum camera zoom.
         * @category Properties
         */
        this.minZoom = 0.01;
        /**
         * Maximum camera zoom.
         * @category Properties
         */
        this.maxZoom = Infinity;
        /**
         * Approximate time in seconds to reach the target. A smaller value will reach the target faster.
         * @category Properties
         */
        this.smoothTime = 0.25;
        /**
         * the smoothTime while dragging
         * @category Properties
         */
        this.draggingSmoothTime = 0.125;
        /**
         * Max transition speed in unit-per-seconds
         * @category Properties
         */
        this.maxSpeed = Infinity;
        /**
         * Speed of azimuth (horizontal) rotation.
         * @category Properties
         */
        this.azimuthRotateSpeed = 1.0;
        /**
         * Speed of polar (vertical) rotation.
         * @category Properties
         */
        this.polarRotateSpeed = 1.0;
        /**
         * Speed of mouse-wheel dollying.
         * @category Properties
         */
        this.dollySpeed = 1.0;
        /**
         * `true` to invert direction when dollying or zooming via drag
         * @category Properties
         */
        this.dollyDragInverted = false;
        /**
         * Speed of drag for truck and pedestal.
         * @category Properties
         */
        this.truckSpeed = 2.0;
        /**
         * `true` to enable Dolly-in to the mouse cursor coords.
         * @category Properties
         */
        this.dollyToCursor = false;
        /**
         * @category Properties
         */
        this.dragToOffset = false;
        /**
         * The same as `.screenSpacePanning` in three.js's OrbitControls.
         * @category Properties
         */
        this.verticalDragToForward = false;
        /**
         * Friction ratio of the boundary.
         * @category Properties
         */
        this.boundaryFriction = 0.0;
        /**
         * Controls how soon the `rest` event fires as the camera slows.
         * @category Properties
         */
        this.restThreshold = 0.01;
        /**
         * An array of Meshes to collide with camera.
         * Be aware colliderMeshes may decrease performance. The collision test uses 4 raycasters from the camera since the near plane has 4 corners.
         * @category Properties
         */
        this.colliderMeshes = [];
        /**
         * Force cancel user dragging.
         * @category Methods
         */
        // cancel will be overwritten in the constructor.
        this.cancel = () => { };
        this._enabled = true;
        this._state = ACTION.NONE;
        this._viewport = null;
        this._changedDolly = 0;
        this._changedZoom = 0;
        this._hasRested = true;
        this._boundaryEnclosesCamera = false;
        this._needsUpdate = true;
        this._updatedLastTime = false;
        this._elementRect = new DOMRect();
        this._isDragging = false;
        this._activePointers = [];
        this._lockedPointer = null;
        this._interactiveArea = new DOMRect(0, 0, 1, 1);
        // Use draggingSmoothTime over smoothTime while true.
        // set automatically true on user-dragging start.
        // set automatically false on programmable methods call.
        this._isUserControllingRotate = false;
        this._isUserControllingDolly = false;
        this._isUserControllingTruck = false;
        this._isUserControllingOffset = false;
        this._isUserControllingZoom = false;
        this._lastDollyDirection = DOLLY_DIRECTION.NONE;
        // velocities for smoothDamp
        this._thetaVelocity = { value: 0 };
        this._phiVelocity = { value: 0 };
        this._radiusVelocity = { value: 0 };
        this._targetVelocity = new THREE.Vector3();
        this._focalOffsetVelocity = new THREE.Vector3();
        this._zoomVelocity = { value: 0 };
        this._truckInternal = (deltaX, deltaY, dragToOffset) => {
            let truckX;
            let pedestalY;
            if (isPerspectiveCamera(this._camera)) {
                const offset = _v3A.copy(this._camera.position).sub(this._target);
                // half of the fov is center to top of screen
                const fov = this._camera.getEffectiveFOV() * DEG2RAD;
                const targetDistance = offset.length() * Math.tan(fov * 0.5);
                truckX = (this.truckSpeed * deltaX * targetDistance / this._elementRect.height);
                pedestalY = (this.truckSpeed * deltaY * targetDistance / this._elementRect.height);
            }
            else if (isOrthographicCamera(this._camera)) {
                const camera = this._camera;
                truckX = deltaX * (camera.right - camera.left) / camera.zoom / this._elementRect.width;
                pedestalY = deltaY * (camera.top - camera.bottom) / camera.zoom / this._elementRect.height;
            }
            else {
                return;
            }
            if (this.verticalDragToForward) {
                dragToOffset ?
                    this.setFocalOffset(this._focalOffsetEnd.x + truckX, this._focalOffsetEnd.y, this._focalOffsetEnd.z, true) :
                    this.truck(truckX, 0, true);
                this.forward(-pedestalY, true);
            }
            else {
                dragToOffset ?
                    this.setFocalOffset(this._focalOffsetEnd.x + truckX, this._focalOffsetEnd.y + pedestalY, this._focalOffsetEnd.z, true) :
                    this.truck(truckX, pedestalY, true);
            }
        };
        this._rotateInternal = (deltaX, deltaY) => {
            const theta = PI_2 * this.azimuthRotateSpeed * deltaX / this._elementRect.height; // divide by *height* to refer the resolution
            const phi = PI_2 * this.polarRotateSpeed * deltaY / this._elementRect.height;
            this.rotate(theta, phi, true);
        };
        this._dollyInternal = (delta, x, y) => {
            const dollyScale = Math.pow(0.95, -delta * this.dollySpeed);
            const lastDistance = this._sphericalEnd.radius;
            const distance = this._sphericalEnd.radius * dollyScale;
            const clampedDistance = clamp(distance, this.minDistance, this.maxDistance);
            const overflowedDistance = clampedDistance - distance;
            if (this.infinityDolly && this.dollyToCursor) {
                this._dollyToNoClamp(distance, true);
            }
            else if (this.infinityDolly && !this.dollyToCursor) {
                this.dollyInFixed(overflowedDistance, true);
                this._dollyToNoClamp(clampedDistance, true);
            }
            else {
                this._dollyToNoClamp(clampedDistance, true);
            }
            if (this.dollyToCursor) {
                this._changedDolly += (this.infinityDolly ? distance : clampedDistance) - lastDistance;
                this._dollyControlCoord.set(x, y);
            }
            this._lastDollyDirection = Math.sign(-delta);
        };
        this._zoomInternal = (delta, x, y) => {
            const zoomScale = Math.pow(0.95, delta * this.dollySpeed);
            const lastZoom = this._zoom;
            const zoom = this._zoom * zoomScale;
            // for both PerspectiveCamera and OrthographicCamera
            this.zoomTo(zoom, true);
            if (this.dollyToCursor) {
                this._changedZoom += zoom - lastZoom;
                this._dollyControlCoord.set(x, y);
            }
        };
        // Check if the user has installed THREE
        if (typeof THREE === 'undefined') {
            console.error('camera-controls: `THREE` is undefined. You must first run `CameraControls.install( { THREE: THREE } )`. Check the docs for further information.');
        }
        this._camera = camera;
        this._yAxisUpSpace = new THREE.Quaternion().setFromUnitVectors(this._camera.up, _AXIS_Y);
        this._yAxisUpSpaceInverse = this._yAxisUpSpace.clone().invert();
        this._state = ACTION.NONE;
        // the location
        this._target = new THREE.Vector3();
        this._targetEnd = this._target.clone();
        this._focalOffset = new THREE.Vector3();
        this._focalOffsetEnd = this._focalOffset.clone();
        // rotation
        this._spherical = new THREE.Spherical().setFromVector3(_v3A.copy(this._camera.position).applyQuaternion(this._yAxisUpSpace));
        this._sphericalEnd = this._spherical.clone();
        this._lastDistance = this._spherical.radius;
        this._zoom = this._camera.zoom;
        this._zoomEnd = this._zoom;
        this._lastZoom = this._zoom;
        // collisionTest uses nearPlane.s
        this._nearPlaneCorners = [
            new THREE.Vector3(),
            new THREE.Vector3(),
            new THREE.Vector3(),
            new THREE.Vector3(),
        ];
        this._updateNearPlaneCorners();
        // Target cannot move outside of this box
        this._boundary = new THREE.Box3(new THREE.Vector3(-Infinity, -Infinity, -Infinity), new THREE.Vector3(Infinity, Infinity, Infinity));
        // reset
        this._cameraUp0 = this._camera.up.clone();
        this._target0 = this._target.clone();
        this._position0 = this._camera.position.clone();
        this._zoom0 = this._zoom;
        this._focalOffset0 = this._focalOffset.clone();
        this._dollyControlCoord = new THREE.Vector2();
        // configs
        this.mouseButtons = {
            left: ACTION.ROTATE,
            middle: ACTION.DOLLY,
            right: ACTION.TRUCK,
            wheel: isPerspectiveCamera(this._camera) ? ACTION.DOLLY :
                isOrthographicCamera(this._camera) ? ACTION.ZOOM :
                    ACTION.NONE,
        };
        this.touches = {
            one: ACTION.TOUCH_ROTATE,
            two: isPerspectiveCamera(this._camera) ? ACTION.TOUCH_DOLLY_TRUCK :
                isOrthographicCamera(this._camera) ? ACTION.TOUCH_ZOOM_TRUCK :
                    ACTION.NONE,
            three: ACTION.TOUCH_TRUCK,
        };
        const dragStartPosition = new THREE.Vector2();
        const lastDragPosition = new THREE.Vector2();
        const dollyStart = new THREE.Vector2();
        const onPointerDown = (event) => {
            if (!this._enabled || !this._domElement)
                return;
            if (this._interactiveArea.left !== 0 ||
                this._interactiveArea.top !== 0 ||
                this._interactiveArea.width !== 1 ||
                this._interactiveArea.height !== 1) {
                const elRect = this._domElement.getBoundingClientRect();
                const left = event.clientX / elRect.width;
                const top = event.clientY / elRect.height;
                // check if the interactiveArea contains the drag start position.
                if (left < this._interactiveArea.left ||
                    left > this._interactiveArea.right ||
                    top < this._interactiveArea.top ||
                    top > this._interactiveArea.bottom)
                    return;
            }
            // Don't call `event.preventDefault()` on the pointerdown event
            // to keep receiving pointermove evens outside dragging iframe
            // https://taye.me/blog/tips/2015/11/16/mouse-drag-outside-iframe/
            const mouseButton = event.pointerType !== 'mouse' ? null :
                (event.buttons & MOUSE_BUTTON.LEFT) === MOUSE_BUTTON.LEFT ? MOUSE_BUTTON.LEFT :
                    (event.buttons & MOUSE_BUTTON.MIDDLE) === MOUSE_BUTTON.MIDDLE ? MOUSE_BUTTON.MIDDLE :
                        (event.buttons & MOUSE_BUTTON.RIGHT) === MOUSE_BUTTON.RIGHT ? MOUSE_BUTTON.RIGHT :
                            null;
            if (mouseButton !== null) {
                const zombiePointer = this._findPointerByMouseButton(mouseButton);
                zombiePointer && this._disposePointer(zombiePointer);
            }
            if ((event.buttons & MOUSE_BUTTON.LEFT) === MOUSE_BUTTON.LEFT && this._lockedPointer)
                return;
            const pointer = {
                pointerId: event.pointerId,
                clientX: event.clientX,
                clientY: event.clientY,
                deltaX: 0,
                deltaY: 0,
                mouseButton,
            };
            this._activePointers.push(pointer);
            // eslint-disable-next-line no-undef
            this._domElement.ownerDocument.removeEventListener('pointermove', onPointerMove, { passive: false });
            this._domElement.ownerDocument.removeEventListener('pointerup', onPointerUp);
            this._domElement.ownerDocument.addEventListener('pointermove', onPointerMove, { passive: false });
            this._domElement.ownerDocument.addEventListener('pointerup', onPointerUp);
            this._isDragging = true;
            startDragging(event);
        };
        const onMouseDown = (event) => {
            if (!this._enabled || !this._domElement || this._lockedPointer)
                return;
            if (this._interactiveArea.left !== 0 ||
                this._interactiveArea.top !== 0 ||
                this._interactiveArea.width !== 1 ||
                this._interactiveArea.height !== 1) {
                const elRect = this._domElement.getBoundingClientRect();
                const left = event.clientX / elRect.width;
                const top = event.clientY / elRect.height;
                // check if the interactiveArea contains the drag start position.
                if (left < this._interactiveArea.left ||
                    left > this._interactiveArea.right ||
                    top < this._interactiveArea.top ||
                    top > this._interactiveArea.bottom)
                    return;
            }
            const mouseButton = (event.buttons & MOUSE_BUTTON.LEFT) === MOUSE_BUTTON.LEFT ? MOUSE_BUTTON.LEFT :
                (event.buttons & MOUSE_BUTTON.MIDDLE) === MOUSE_BUTTON.MIDDLE ? MOUSE_BUTTON.MIDDLE :
                    (event.buttons & MOUSE_BUTTON.RIGHT) === MOUSE_BUTTON.RIGHT ? MOUSE_BUTTON.RIGHT :
                        null;
            if (mouseButton !== null) {
                const zombiePointer = this._findPointerByMouseButton(mouseButton);
                zombiePointer && this._disposePointer(zombiePointer);
            }
            const pointer = {
                pointerId: 1,
                clientX: event.clientX,
                clientY: event.clientY,
                deltaX: 0,
                deltaY: 0,
                mouseButton: (event.buttons & MOUSE_BUTTON.LEFT) === MOUSE_BUTTON.LEFT ? MOUSE_BUTTON.LEFT :
                    (event.buttons & MOUSE_BUTTON.MIDDLE) === MOUSE_BUTTON.LEFT ? MOUSE_BUTTON.MIDDLE :
                        (event.buttons & MOUSE_BUTTON.RIGHT) === MOUSE_BUTTON.LEFT ? MOUSE_BUTTON.RIGHT :
                            null,
            };
            this._activePointers.push(pointer);
            // see https://github.com/microsoft/TypeScript/issues/32912#issuecomment-522142969
            // eslint-disable-next-line no-undef
            this._domElement.ownerDocument.removeEventListener('mousemove', onMouseMove);
            this._domElement.ownerDocument.removeEventListener('mouseup', onMouseUp);
            this._domElement.ownerDocument.addEventListener('mousemove', onMouseMove);
            this._domElement.ownerDocument.addEventListener('mouseup', onMouseUp);
            this._isDragging = true;
            startDragging(event);
        };
        const onPointerMove = (event) => {
            if (event.cancelable)
                event.preventDefault();
            const pointerId = event.pointerId;
            const pointer = this._lockedPointer || this._findPointerById(pointerId);
            if (!pointer)
                return;
            pointer.clientX = event.clientX;
            pointer.clientY = event.clientY;
            pointer.deltaX = event.movementX;
            pointer.deltaY = event.movementY;
            this._state = 0;
            if (event.pointerType === 'touch') {
                switch (this._activePointers.length) {
                    case 1:
                        this._state = this.touches.one;
                        break;
                    case 2:
                        this._state = this.touches.two;
                        break;
                    case 3:
                        this._state = this.touches.three;
                        break;
                }
            }
            else {
                if ((!this._isDragging && this._lockedPointer) ||
                    this._isDragging && (event.buttons & MOUSE_BUTTON.LEFT) === MOUSE_BUTTON.LEFT) {
                    this._state = this._state | this.mouseButtons.left;
                }
                if (this._isDragging && (event.buttons & MOUSE_BUTTON.MIDDLE) === MOUSE_BUTTON.MIDDLE) {
                    this._state = this._state | this.mouseButtons.middle;
                }
                if (this._isDragging && (event.buttons & MOUSE_BUTTON.RIGHT) === MOUSE_BUTTON.RIGHT) {
                    this._state = this._state | this.mouseButtons.right;
                }
            }
            dragging();
        };
        const onMouseMove = (event) => {
            const pointer = this._lockedPointer || this._findPointerById(1);
            if (!pointer)
                return;
            pointer.clientX = event.clientX;
            pointer.clientY = event.clientY;
            pointer.deltaX = event.movementX;
            pointer.deltaY = event.movementY;
            this._state = 0;
            if (this._lockedPointer ||
                (event.buttons & MOUSE_BUTTON.LEFT) === MOUSE_BUTTON.LEFT) {
                this._state = this._state | this.mouseButtons.left;
            }
            if ((event.buttons & MOUSE_BUTTON.MIDDLE) === MOUSE_BUTTON.MIDDLE) {
                this._state = this._state | this.mouseButtons.middle;
            }
            if ((event.buttons & MOUSE_BUTTON.RIGHT) === MOUSE_BUTTON.RIGHT) {
                this._state = this._state | this.mouseButtons.right;
            }
            dragging();
        };
        const onPointerUp = (event) => {
            const pointer = this._findPointerById(event.pointerId);
            if (pointer && pointer === this._lockedPointer)
                return;
            pointer && this._disposePointer(pointer);
            if (event.pointerType === 'touch') {
                switch (this._activePointers.length) {
                    case 0:
                        this._state = ACTION.NONE;
                        break;
                    case 1:
                        this._state = this.touches.one;
                        break;
                    case 2:
                        this._state = this.touches.two;
                        break;
                    case 3:
                        this._state = this.touches.three;
                        break;
                }
            }
            else {
                this._state = ACTION.NONE;
            }
            endDragging();
        };
        const onMouseUp = () => {
            const pointer = this._findPointerById(1);
            if (pointer && pointer === this._lockedPointer)
                return;
            pointer && this._disposePointer(pointer);
            this._state = ACTION.NONE;
            endDragging();
        };
        let lastScrollTimeStamp = -1;
        const onMouseWheel = (event) => {
            if (!this._domElement)
                return;
            if (!this._enabled || this.mouseButtons.wheel === ACTION.NONE)
                return;
            if (this._interactiveArea.left !== 0 ||
                this._interactiveArea.top !== 0 ||
                this._interactiveArea.width !== 1 ||
                this._interactiveArea.height !== 1) {
                const elRect = this._domElement.getBoundingClientRect();
                const left = event.clientX / elRect.width;
                const top = event.clientY / elRect.height;
                // check if the interactiveArea contains the drag start position.
                if (left < this._interactiveArea.left ||
                    left > this._interactiveArea.right ||
                    top < this._interactiveArea.top ||
                    top > this._interactiveArea.bottom)
                    return;
            }
            event.preventDefault();
            if (this.dollyToCursor ||
                this.mouseButtons.wheel === ACTION.ROTATE ||
                this.mouseButtons.wheel === ACTION.TRUCK) {
                const now = performance.now();
                // only need to fire this at scroll start.
                if (lastScrollTimeStamp - now < 1000)
                    this._getClientRect(this._elementRect);
                lastScrollTimeStamp = now;
            }
            // Ref: https://github.com/cedricpinson/osgjs/blob/00e5a7e9d9206c06fdde0436e1d62ab7cb5ce853/sources/osgViewer/input/source/InputSourceMouse.js#L89-L103
            const deltaYFactor = isMac ? -1 : -3;
            const delta = (event.deltaMode === 1) ? event.deltaY / deltaYFactor : event.deltaY / (deltaYFactor * 10);
            const x = this.dollyToCursor ? (event.clientX - this._elementRect.x) / this._elementRect.width * 2 - 1 : 0;
            const y = this.dollyToCursor ? (event.clientY - this._elementRect.y) / this._elementRect.height * -2 + 1 : 0;
            switch (this.mouseButtons.wheel) {
                case ACTION.ROTATE: {
                    this._rotateInternal(event.deltaX, event.deltaY);
                    this._isUserControllingRotate = true;
                    break;
                }
                case ACTION.TRUCK: {
                    this._truckInternal(event.deltaX, event.deltaY, false);
                    this._isUserControllingTruck = true;
                    break;
                }
                case ACTION.OFFSET: {
                    this._truckInternal(event.deltaX, event.deltaY, true);
                    this._isUserControllingOffset = true;
                    break;
                }
                case ACTION.DOLLY: {
                    this._dollyInternal(-delta, x, y);
                    this._isUserControllingDolly = true;
                    break;
                }
                case ACTION.ZOOM: {
                    this._zoomInternal(-delta, x, y);
                    this._isUserControllingZoom = true;
                    break;
                }
            }
            this.dispatchEvent({ type: 'control' });
        };
        const onContextMenu = (event) => {
            if (!this._domElement || !this._enabled)
                return;
            // contextmenu event is fired right after pointerdown/mousedown.
            // remove attached handlers and active pointer, if interrupted by contextmenu.
            if (this.mouseButtons.right === CameraControls.ACTION.NONE) {
                const pointerId = event instanceof PointerEvent ? event.pointerId :
                    event instanceof MouseEvent ? 0 :
                        0;
                const pointer = this._findPointerById(pointerId);
                pointer && this._disposePointer(pointer);
                // eslint-disable-next-line no-undef
                this._domElement.ownerDocument.removeEventListener('pointermove', onPointerMove, { passive: false });
                this._domElement.ownerDocument.removeEventListener('pointerup', onPointerUp);
                this._domElement.ownerDocument.removeEventListener('mousemove', onMouseMove);
                this._domElement.ownerDocument.removeEventListener('mouseup', onMouseUp);
                return;
            }
            event.preventDefault();
        };
        const startDragging = (event) => {
            if (!this._enabled)
                return;
            extractClientCoordFromEvent(this._activePointers, _v2);
            this._getClientRect(this._elementRect);
            dragStartPosition.copy(_v2);
            lastDragPosition.copy(_v2);
            const isMultiTouch = this._activePointers.length >= 2;
            if (isMultiTouch) {
                // 2 finger pinch
                const dx = _v2.x - this._activePointers[1].clientX;
                const dy = _v2.y - this._activePointers[1].clientY;
                const distance = Math.sqrt(dx * dx + dy * dy);
                dollyStart.set(0, distance);
                // center coords of 2 finger truck
                const x = (this._activePointers[0].clientX + this._activePointers[1].clientX) * 0.5;
                const y = (this._activePointers[0].clientY + this._activePointers[1].clientY) * 0.5;
                lastDragPosition.set(x, y);
            }
            this._state = 0;
            if (!event) {
                if (this._lockedPointer)
                    this._state = this._state | this.mouseButtons.left;
            }
            else if ('pointerType' in event && event.pointerType === 'touch') {
                switch (this._activePointers.length) {
                    case 1:
                        this._state = this.touches.one;
                        break;
                    case 2:
                        this._state = this.touches.two;
                        break;
                    case 3:
                        this._state = this.touches.three;
                        break;
                }
            }
            else {
                if (!this._lockedPointer && (event.buttons & MOUSE_BUTTON.LEFT) === MOUSE_BUTTON.LEFT) {
                    this._state = this._state | this.mouseButtons.left;
                }
                if ((event.buttons & MOUSE_BUTTON.MIDDLE) === MOUSE_BUTTON.MIDDLE) {
                    this._state = this._state | this.mouseButtons.middle;
                }
                if ((event.buttons & MOUSE_BUTTON.RIGHT) === MOUSE_BUTTON.RIGHT) {
                    this._state = this._state | this.mouseButtons.right;
                }
            }
            // stop current movement on drag start
            if ((this._state & ACTION.ROTATE) === ACTION.ROTATE ||
                (this._state & ACTION.TOUCH_ROTATE) === ACTION.TOUCH_ROTATE ||
                (this._state & ACTION.TOUCH_DOLLY_ROTATE) === ACTION.TOUCH_DOLLY_ROTATE ||
                (this._state & ACTION.TOUCH_ZOOM_ROTATE) === ACTION.TOUCH_ZOOM_ROTATE) {
                this._sphericalEnd.theta = this._spherical.theta;
                this._sphericalEnd.phi = this._spherical.phi;
                this._thetaVelocity.value = 0;
                this._phiVelocity.value = 0;
            }
            if ((this._state & ACTION.TRUCK) === ACTION.TRUCK ||
                (this._state & ACTION.TOUCH_TRUCK) === ACTION.TOUCH_TRUCK ||
                (this._state & ACTION.TOUCH_DOLLY_TRUCK) === ACTION.TOUCH_DOLLY_TRUCK ||
                (this._state & ACTION.TOUCH_ZOOM_TRUCK) === ACTION.TOUCH_ZOOM_TRUCK) {
                this._targetEnd.copy(this._target);
                this._targetVelocity.set(0, 0, 0);
            }
            if ((this._state & ACTION.DOLLY) === ACTION.DOLLY ||
                (this._state & ACTION.TOUCH_DOLLY) === ACTION.TOUCH_DOLLY ||
                (this._state & ACTION.TOUCH_DOLLY_TRUCK) === ACTION.TOUCH_DOLLY_TRUCK ||
                (this._state & ACTION.TOUCH_DOLLY_OFFSET) === ACTION.TOUCH_DOLLY_OFFSET ||
                (this._state & ACTION.TOUCH_DOLLY_ROTATE) === ACTION.TOUCH_DOLLY_ROTATE) {
                this._sphericalEnd.radius = this._spherical.radius;
                this._radiusVelocity.value = 0;
            }
            if ((this._state & ACTION.ZOOM) === ACTION.ZOOM ||
                (this._state & ACTION.TOUCH_ZOOM) === ACTION.TOUCH_ZOOM ||
                (this._state & ACTION.TOUCH_ZOOM_TRUCK) === ACTION.TOUCH_ZOOM_TRUCK ||
                (this._state & ACTION.TOUCH_ZOOM_OFFSET) === ACTION.TOUCH_ZOOM_OFFSET ||
                (this._state & ACTION.TOUCH_ZOOM_ROTATE) === ACTION.TOUCH_ZOOM_ROTATE) {
                this._zoomEnd = this._zoom;
                this._zoomVelocity.value = 0;
            }
            if ((this._state & ACTION.OFFSET) === ACTION.OFFSET ||
                (this._state & ACTION.TOUCH_OFFSET) === ACTION.TOUCH_OFFSET ||
                (this._state & ACTION.TOUCH_DOLLY_OFFSET) === ACTION.TOUCH_DOLLY_OFFSET ||
                (this._state & ACTION.TOUCH_ZOOM_OFFSET) === ACTION.TOUCH_ZOOM_OFFSET) {
                this._focalOffsetEnd.copy(this._focalOffset);
                this._focalOffsetVelocity.set(0, 0, 0);
            }
            this.dispatchEvent({ type: 'controlstart' });
        };
        const dragging = () => {
            if (!this._enabled)
                return;
            extractClientCoordFromEvent(this._activePointers, _v2);
            // When pointer lock is enabled clientX, clientY, screenX, and screenY remain 0.
            // If pointer lock is enabled, use the Delta directory, and assume active-pointer is not multiple.
            const isPointerLockActive = this._domElement && document.pointerLockElement === this._domElement;
            const lockedPointer = isPointerLockActive ? this._lockedPointer || this._activePointers[0] : null;
            const deltaX = lockedPointer ? -lockedPointer.deltaX : lastDragPosition.x - _v2.x;
            const deltaY = lockedPointer ? -lockedPointer.deltaY : lastDragPosition.y - _v2.y;
            lastDragPosition.copy(_v2);
            if ((this._state & ACTION.ROTATE) === ACTION.ROTATE ||
                (this._state & ACTION.TOUCH_ROTATE) === ACTION.TOUCH_ROTATE ||
                (this._state & ACTION.TOUCH_DOLLY_ROTATE) === ACTION.TOUCH_DOLLY_ROTATE ||
                (this._state & ACTION.TOUCH_ZOOM_ROTATE) === ACTION.TOUCH_ZOOM_ROTATE) {
                this._rotateInternal(deltaX, deltaY);
                this._isUserControllingRotate = true;
            }
            if ((this._state & ACTION.DOLLY) === ACTION.DOLLY ||
                (this._state & ACTION.ZOOM) === ACTION.ZOOM) {
                const dollyX = this.dollyToCursor ? (dragStartPosition.x - this._elementRect.x) / this._elementRect.width * 2 - 1 : 0;
                const dollyY = this.dollyToCursor ? (dragStartPosition.y - this._elementRect.y) / this._elementRect.height * -2 + 1 : 0;
                const dollyDirection = this.dollyDragInverted ? -1 : 1;
                if ((this._state & ACTION.DOLLY) === ACTION.DOLLY) {
                    this._dollyInternal(dollyDirection * deltaY * TOUCH_DOLLY_FACTOR, dollyX, dollyY);
                    this._isUserControllingDolly = true;
                }
                else {
                    this._zoomInternal(dollyDirection * deltaY * TOUCH_DOLLY_FACTOR, dollyX, dollyY);
                    this._isUserControllingZoom = true;
                }
            }
            if ((this._state & ACTION.TOUCH_DOLLY) === ACTION.TOUCH_DOLLY ||
                (this._state & ACTION.TOUCH_ZOOM) === ACTION.TOUCH_ZOOM ||
                (this._state & ACTION.TOUCH_DOLLY_TRUCK) === ACTION.TOUCH_DOLLY_TRUCK ||
                (this._state & ACTION.TOUCH_ZOOM_TRUCK) === ACTION.TOUCH_ZOOM_TRUCK ||
                (this._state & ACTION.TOUCH_DOLLY_OFFSET) === ACTION.TOUCH_DOLLY_OFFSET ||
                (this._state & ACTION.TOUCH_ZOOM_OFFSET) === ACTION.TOUCH_ZOOM_OFFSET ||
                (this._state & ACTION.TOUCH_DOLLY_ROTATE) === ACTION.TOUCH_DOLLY_ROTATE ||
                (this._state & ACTION.TOUCH_ZOOM_ROTATE) === ACTION.TOUCH_ZOOM_ROTATE) {
                const dx = _v2.x - this._activePointers[1].clientX;
                const dy = _v2.y - this._activePointers[1].clientY;
                const distance = Math.sqrt(dx * dx + dy * dy);
                const dollyDelta = dollyStart.y - distance;
                dollyStart.set(0, distance);
                const dollyX = this.dollyToCursor ? (lastDragPosition.x - this._elementRect.x) / this._elementRect.width * 2 - 1 : 0;
                const dollyY = this.dollyToCursor ? (lastDragPosition.y - this._elementRect.y) / this._elementRect.height * -2 + 1 : 0;
                if ((this._state & ACTION.TOUCH_DOLLY) === ACTION.TOUCH_DOLLY ||
                    (this._state & ACTION.TOUCH_DOLLY_ROTATE) === ACTION.TOUCH_DOLLY_ROTATE ||
                    (this._state & ACTION.TOUCH_DOLLY_TRUCK) === ACTION.TOUCH_DOLLY_TRUCK ||
                    (this._state & ACTION.TOUCH_DOLLY_OFFSET) === ACTION.TOUCH_DOLLY_OFFSET) {
                    this._dollyInternal(dollyDelta * TOUCH_DOLLY_FACTOR, dollyX, dollyY);
                    this._isUserControllingDolly = true;
                }
                else {
                    this._zoomInternal(dollyDelta * TOUCH_DOLLY_FACTOR, dollyX, dollyY);
                    this._isUserControllingZoom = true;
                }
            }
            if ((this._state & ACTION.TRUCK) === ACTION.TRUCK ||
                (this._state & ACTION.TOUCH_TRUCK) === ACTION.TOUCH_TRUCK ||
                (this._state & ACTION.TOUCH_DOLLY_TRUCK) === ACTION.TOUCH_DOLLY_TRUCK ||
                (this._state & ACTION.TOUCH_ZOOM_TRUCK) === ACTION.TOUCH_ZOOM_TRUCK) {
                this._truckInternal(deltaX, deltaY, false);
                this._isUserControllingTruck = true;
            }
            if ((this._state & ACTION.OFFSET) === ACTION.OFFSET ||
                (this._state & ACTION.TOUCH_OFFSET) === ACTION.TOUCH_OFFSET ||
                (this._state & ACTION.TOUCH_DOLLY_OFFSET) === ACTION.TOUCH_DOLLY_OFFSET ||
                (this._state & ACTION.TOUCH_ZOOM_OFFSET) === ACTION.TOUCH_ZOOM_OFFSET) {
                this._truckInternal(deltaX, deltaY, true);
                this._isUserControllingOffset = true;
            }
            this.dispatchEvent({ type: 'control' });
        };
        const endDragging = () => {
            extractClientCoordFromEvent(this._activePointers, _v2);
            lastDragPosition.copy(_v2);
            if (this._activePointers.length === 0 ||
                (this._activePointers.length === 1 && this._activePointers[0] === this._lockedPointer)) {
                this._isDragging = false;
            }
            if (this._activePointers.length === 0 && this._domElement) {
                // eslint-disable-next-line no-undef
                this._domElement.ownerDocument.removeEventListener('pointermove', onPointerMove, { passive: false });
                this._domElement.ownerDocument.removeEventListener('mousemove', onMouseMove);
                this._domElement.ownerDocument.removeEventListener('pointerup', onPointerUp);
                this._domElement.ownerDocument.removeEventListener('mouseup', onMouseUp);
                this.dispatchEvent({ type: 'controlend' });
            }
        };
        this.lockPointer = () => {
            if (!this._enabled || !this._domElement)
                return;
            this.cancel();
            // Element.requestPointerLock is allowed to happen without any pointer active - create a faux one for compatibility with controls
            this._lockedPointer = {
                pointerId: -1,
                clientX: 0,
                clientY: 0,
                deltaX: 0,
                deltaY: 0,
                mouseButton: null,
            };
            this._activePointers.push(this._lockedPointer);
            // eslint-disable-next-line no-undef
            this._domElement.ownerDocument.removeEventListener('pointermove', onPointerMove, { passive: false });
            this._domElement.ownerDocument.removeEventListener('pointerup', onPointerUp);
            this._domElement.requestPointerLock();
            this._domElement.ownerDocument.addEventListener('pointerlockchange', onPointerLockChange);
            this._domElement.ownerDocument.addEventListener('pointerlockerror', onPointerLockError);
            this._domElement.ownerDocument.addEventListener('pointermove', onPointerMove, { passive: false });
            this._domElement.ownerDocument.addEventListener('pointerup', onPointerUp);
            startDragging();
        };
        this.unlockPointer = () => {
            if (this._lockedPointer !== null) {
                this._disposePointer(this._lockedPointer);
                this._lockedPointer = null;
            }
            document.exitPointerLock();
            this.cancel();
            if (!this._domElement)
                return;
            this._domElement.ownerDocument.removeEventListener('pointerlockchange', onPointerLockChange);
            this._domElement.ownerDocument.removeEventListener('pointerlockerror', onPointerLockError);
        };
        const onPointerLockChange = () => {
            const isPointerLockActive = this._domElement && this._domElement.ownerDocument.pointerLockElement === this._domElement;
            if (!isPointerLockActive)
                this.unlockPointer();
        };
        const onPointerLockError = () => {
            this.unlockPointer();
        };
        this._addAllEventListeners = (domElement) => {
            this._domElement = domElement;
            this._domElement.style.touchAction = 'none';
            this._domElement.style.userSelect = 'none';
            this._domElement.style.webkitUserSelect = 'none';
            this._domElement.addEventListener('pointerdown', onPointerDown);
            isPointerEventsNotSupported && this._domElement.addEventListener('mousedown', onMouseDown);
            this._domElement.addEventListener('pointercancel', onPointerUp);
            this._domElement.addEventListener('wheel', onMouseWheel, { passive: false });
            this._domElement.addEventListener('contextmenu', onContextMenu);
        };
        this._removeAllEventListeners = () => {
            if (!this._domElement)
                return;
            this._domElement.style.touchAction = '';
            this._domElement.style.userSelect = '';
            this._domElement.style.webkitUserSelect = '';
            this._domElement.removeEventListener('pointerdown', onPointerDown);
            this._domElement.removeEventListener('mousedown', onMouseDown);
            this._domElement.removeEventListener('pointercancel', onPointerUp);
            // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener#matching_event_listeners_for_removal
            // > it's probably wise to use the same values used for the call to `addEventListener()` when calling `removeEventListener()`
            // see https://github.com/microsoft/TypeScript/issues/32912#issuecomment-522142969
            // eslint-disable-next-line no-undef
            this._domElement.removeEventListener('wheel', onMouseWheel, { passive: false });
            this._domElement.removeEventListener('contextmenu', onContextMenu);
            // eslint-disable-next-line no-undef
            this._domElement.ownerDocument.removeEventListener('pointermove', onPointerMove, { passive: false });
            this._domElement.ownerDocument.removeEventListener('mousemove', onMouseMove);
            this._domElement.ownerDocument.removeEventListener('pointerup', onPointerUp);
            this._domElement.ownerDocument.removeEventListener('mouseup', onMouseUp);
            this._domElement.ownerDocument.removeEventListener('pointerlockchange', onPointerLockChange);
            this._domElement.ownerDocument.removeEventListener('pointerlockerror', onPointerLockError);
        };
        this.cancel = () => {
            if (this._state === ACTION.NONE)
                return;
            this._state = ACTION.NONE;
            this._activePointers.length = 0;
            endDragging();
        };
        if (domElement)
            this.connect(domElement);
        this.update(0);
    }
    /**
     * The camera to be controlled
     * @category Properties
     */
    get camera() {
        return this._camera;
    }
    set camera(camera) {
        this._camera = camera;
        this.updateCameraUp();
        this._camera.updateProjectionMatrix();
        this._updateNearPlaneCorners();
        this._needsUpdate = true;
    }
    /**
     * Whether or not the controls are enabled.
     * `false` to disable user dragging/touch-move, but all methods works.
     * @category Properties
     */
    get enabled() {
        return this._enabled;
    }
    set enabled(enabled) {
        this._enabled = enabled;
        if (!this._domElement)
            return;
        if (enabled) {
            this._domElement.style.touchAction = 'none';
            this._domElement.style.userSelect = 'none';
            this._domElement.style.webkitUserSelect = 'none';
        }
        else {
            this.cancel();
            this._domElement.style.touchAction = '';
            this._domElement.style.userSelect = '';
            this._domElement.style.webkitUserSelect = '';
        }
    }
    /**
     * Returns `true` if the controls are active updating.
     * readonly value.
     * @category Properties
     */
    get active() {
        return !this._hasRested;
    }
    /**
     * Getter for the current `ACTION`.
     * readonly value.
     * @category Properties
     */
    get currentAction() {
        return this._state;
    }
    /**
     * get/set Current distance.
     * @category Properties
     */
    get distance() {
        return this._spherical.radius;
    }
    set distance(distance) {
        if (this._spherical.radius === distance &&
            this._sphericalEnd.radius === distance)
            return;
        this._spherical.radius = distance;
        this._sphericalEnd.radius = distance;
        this._needsUpdate = true;
    }
    // horizontal angle
    /**
     * get/set the azimuth angle (horizontal) in radians.
     * Every 360 degrees turn is added to `.azimuthAngle` value, which is accumulative.
     * @category Properties
     */
    get azimuthAngle() {
        return this._spherical.theta;
    }
    set azimuthAngle(azimuthAngle) {
        if (this._spherical.theta === azimuthAngle &&
            this._sphericalEnd.theta === azimuthAngle)
            return;
        this._spherical.theta = azimuthAngle;
        this._sphericalEnd.theta = azimuthAngle;
        this._needsUpdate = true;
    }
    // vertical angle
    /**
     * get/set the polar angle (vertical) in radians.
     * @category Properties
     */
    get polarAngle() {
        return this._spherical.phi;
    }
    set polarAngle(polarAngle) {
        if (this._spherical.phi === polarAngle &&
            this._sphericalEnd.phi === polarAngle)
            return;
        this._spherical.phi = polarAngle;
        this._sphericalEnd.phi = polarAngle;
        this._needsUpdate = true;
    }
    /**
     * Whether camera position should be enclosed in the boundary or not.
     * @category Properties
     */
    get boundaryEnclosesCamera() {
        return this._boundaryEnclosesCamera;
    }
    set boundaryEnclosesCamera(boundaryEnclosesCamera) {
        this._boundaryEnclosesCamera = boundaryEnclosesCamera;
        this._needsUpdate = true;
    }
    /**
     * Set drag-start, touches and wheel enable area in the domElement.
     * each values are between `0` and `1` inclusive, where `0` is left/top and `1` is right/bottom of the screen.
     * e.g. `{ x: 0, y: 0, width: 1, height: 1 }` for entire area.
     * @category Properties
     */
    set interactiveArea(interactiveArea) {
        this._interactiveArea.width = clamp(interactiveArea.width, 0, 1);
        this._interactiveArea.height = clamp(interactiveArea.height, 0, 1);
        this._interactiveArea.x = clamp(interactiveArea.x, 0, 1 - this._interactiveArea.width);
        this._interactiveArea.y = clamp(interactiveArea.x, 0, 1 - this._interactiveArea.height);
    }
    /**
     * Adds the specified event listener.
     * Applicable event types (which is `K`) are:
     * | Event name          | Timing |
     * | ------------------- | ------ |
     * | `'controlstart'`    | When the user starts to control the camera via mouse / touches. ¹ |
     * | `'control'`         | When the user controls the camera (dragging). |
     * | `'controlend'`      | When the user ends to control the camera. ¹ |
     * | `'transitionstart'` | When any kind of transition starts, either user control or using a method with `enableTransition = true` |
     * | `'update'`          | When the camera position is updated. |
     * | `'wake'`            | When the camera starts moving. |
     * | `'rest'`            | When the camera movement is below `.restThreshold` ². |
     * | `'sleep'`           | When the camera end moving. |
     *
     * 1. `mouseButtons.wheel` (Mouse wheel control) does not emit `'controlstart'` and `'controlend'`. `mouseButtons.wheel` uses scroll-event internally, and scroll-event happens intermittently. That means "start" and "end" cannot be detected.
     * 2. Due to damping, `sleep` will usually fire a few seconds after the camera _appears_ to have stopped moving. If you want to do something (e.g. enable UI, perform another transition) at the point when the camera has stopped, you probably want the `rest` event. This can be fine tuned using the `.restThreshold` parameter. See the [Rest and Sleep Example](https://yomotsu.github.io/camera-controls/examples/rest-and-sleep.html).
     *
     * e.g.
     * ```
     * cameraControl.addEventListener( 'controlstart', myCallbackFunction );
     * ```
     * @param type event name
     * @param listener handler function
     * @category Methods
     */
    addEventListener(type, listener) {
        super.addEventListener(type, listener);
    }
    /**
     * Removes the specified event listener
     * e.g.
     * ```
     * cameraControl.addEventListener( 'controlstart', myCallbackFunction );
     * ```
     * @param type event name
     * @param listener handler function
     * @category Methods
     */
    removeEventListener(type, listener) {
        super.removeEventListener(type, listener);
    }
    /**
     * Rotate azimuthal angle(horizontal) and polar angle(vertical).
     * Every value is added to the current value.
     * @param azimuthAngle Azimuth rotate angle. In radian.
     * @param polarAngle Polar rotate angle. In radian.
     * @param enableTransition Whether to move smoothly or immediately
     * @category Methods
     */
    rotate(azimuthAngle, polarAngle, enableTransition = false) {
        return this.rotateTo(this._sphericalEnd.theta + azimuthAngle, this._sphericalEnd.phi + polarAngle, enableTransition);
    }
    /**
     * Rotate azimuthal angle(horizontal) to the given angle and keep the same polar angle(vertical) target.
     *
     * e.g.
     * ```
     * cameraControls.rotateAzimuthTo( 30 * THREE.MathUtils.DEG2RAD, true );
     * ```
     * @param azimuthAngle Azimuth rotate angle. In radian.
     * @param enableTransition Whether to move smoothly or immediately
     * @category Methods
     */
    rotateAzimuthTo(azimuthAngle, enableTransition = false) {
        return this.rotateTo(azimuthAngle, this._sphericalEnd.phi, enableTransition);
    }
    /**
     * Rotate polar angle(vertical) to the given angle and keep the same azimuthal angle(horizontal) target.
     *
     * e.g.
     * ```
     * cameraControls.rotatePolarTo( 30 * THREE.MathUtils.DEG2RAD, true );
     * ```
     * @param polarAngle Polar rotate angle. In radian.
     * @param enableTransition Whether to move smoothly or immediately
     * @category Methods
     */
    rotatePolarTo(polarAngle, enableTransition = false) {
        return this.rotateTo(this._sphericalEnd.theta, polarAngle, enableTransition);
    }
    /**
     * Rotate azimuthal angle(horizontal) and polar angle(vertical) to the given angle.
     * Camera view will rotate over the orbit pivot absolutely:
     *
     * azimuthAngle
     * ```
     *       0º
     *         \
     * 90º -----+----- -90º
     *           \
     *           180º
     * ```
     * | direction | angle                  |
     * | --------- | ---------------------- |
     * | front     | 0º                     |
     * | left      | 90º (`Math.PI / 2`)    |
     * | right     | -90º (`- Math.PI / 2`) |
     * | back      | 180º (`Math.PI`)       |
     *
     * polarAngle
     * ```
     *     180º
     *      |
     *      90º
     *      |
     *      0º
     * ```
     * | direction            | angle                  |
     * | -------------------- | ---------------------- |
     * | top/sky              | 180º (`Math.PI`)       |
     * | horizontal from view | 90º (`Math.PI / 2`)    |
     * | bottom/floor         | 0º                     |
     *
     * @param azimuthAngle Azimuth rotate angle to. In radian.
     * @param polarAngle Polar rotate angle to. In radian.
     * @param enableTransition  Whether to move smoothly or immediately
     * @category Methods
     */
    rotateTo(azimuthAngle, polarAngle, enableTransition = false) {
        this._isUserControllingRotate = false;
        const theta = clamp(azimuthAngle, this.minAzimuthAngle, this.maxAzimuthAngle);
        const phi = clamp(polarAngle, this.minPolarAngle, this.maxPolarAngle);
        this._sphericalEnd.theta = theta;
        this._sphericalEnd.phi = phi;
        this._sphericalEnd.makeSafe();
        this._needsUpdate = true;
        if (!enableTransition) {
            this._spherical.theta = this._sphericalEnd.theta;
            this._spherical.phi = this._sphericalEnd.phi;
        }
        const resolveImmediately = !enableTransition ||
            approxEquals(this._spherical.theta, this._sphericalEnd.theta, this.restThreshold) &&
                approxEquals(this._spherical.phi, this._sphericalEnd.phi, this.restThreshold);
        return this._createOnRestPromise(resolveImmediately);
    }
    /**
     * Dolly in/out camera position.
     * @param distance Distance of dollyIn. Negative number for dollyOut.
     * @param enableTransition Whether to move smoothly or immediately.
     * @category Methods
     */
    dolly(distance, enableTransition = false) {
        return this.dollyTo(this._sphericalEnd.radius - distance, enableTransition);
    }
    /**
     * Dolly in/out camera position to given distance.
     * @param distance Distance of dolly.
     * @param enableTransition Whether to move smoothly or immediately.
     * @category Methods
     */
    dollyTo(distance, enableTransition = false) {
        this._isUserControllingDolly = false;
        this._lastDollyDirection = DOLLY_DIRECTION.NONE;
        this._changedDolly = 0;
        return this._dollyToNoClamp(clamp(distance, this.minDistance, this.maxDistance), enableTransition);
    }
    _dollyToNoClamp(distance, enableTransition = false) {
        const lastRadius = this._sphericalEnd.radius;
        const hasCollider = this.colliderMeshes.length >= 1;
        if (hasCollider) {
            const maxDistanceByCollisionTest = this._collisionTest();
            const isCollided = approxEquals(maxDistanceByCollisionTest, this._spherical.radius);
            const isDollyIn = lastRadius > distance;
            if (!isDollyIn && isCollided)
                return Promise.resolve();
            this._sphericalEnd.radius = Math.min(distance, maxDistanceByCollisionTest);
        }
        else {
            this._sphericalEnd.radius = distance;
        }
        this._needsUpdate = true;
        if (!enableTransition) {
            this._spherical.radius = this._sphericalEnd.radius;
        }
        const resolveImmediately = !enableTransition || approxEquals(this._spherical.radius, this._sphericalEnd.radius, this.restThreshold);
        return this._createOnRestPromise(resolveImmediately);
    }
    /**
     * Dolly in, but does not change the distance between the target and the camera, and moves the target position instead.
     * Specify a negative value for dolly out.
     * @param distance Distance of dolly.
     * @param enableTransition Whether to move smoothly or immediately.
     * @category Methods
     */
    dollyInFixed(distance, enableTransition = false) {
        this._targetEnd.add(this._getCameraDirection(_cameraDirection).multiplyScalar(distance));
        if (!enableTransition) {
            this._target.copy(this._targetEnd);
        }
        const resolveImmediately = !enableTransition ||
            approxEquals(this._target.x, this._targetEnd.x, this.restThreshold) &&
                approxEquals(this._target.y, this._targetEnd.y, this.restThreshold) &&
                approxEquals(this._target.z, this._targetEnd.z, this.restThreshold);
        return this._createOnRestPromise(resolveImmediately);
    }
    /**
     * Zoom in/out camera. The value is added to camera zoom.
     * Limits set with `.minZoom` and `.maxZoom`
     * @param zoomStep zoom scale
     * @param enableTransition Whether to move smoothly or immediately
     * @category Methods
     */
    zoom(zoomStep, enableTransition = false) {
        return this.zoomTo(this._zoomEnd + zoomStep, enableTransition);
    }
    /**
     * Zoom in/out camera to given scale. The value overwrites camera zoom.
     * Limits set with .minZoom and .maxZoom
     * @param zoom
     * @param enableTransition
     * @category Methods
     */
    zoomTo(zoom, enableTransition = false) {
        this._isUserControllingZoom = false;
        this._zoomEnd = clamp(zoom, this.minZoom, this.maxZoom);
        this._needsUpdate = true;
        if (!enableTransition) {
            this._zoom = this._zoomEnd;
        }
        const resolveImmediately = !enableTransition || approxEquals(this._zoom, this._zoomEnd, this.restThreshold);
        this._changedZoom = 0;
        return this._createOnRestPromise(resolveImmediately);
    }
    /**
     * @deprecated `pan()` has been renamed to `truck()`
     * @category Methods
     */
    pan(x, y, enableTransition = false) {
        console.warn('`pan` has been renamed to `truck`');
        return this.truck(x, y, enableTransition);
    }
    /**
     * Truck and pedestal camera using current azimuthal angle
     * @param x Horizontal translate amount
     * @param y Vertical translate amount
     * @param enableTransition Whether to move smoothly or immediately
     * @category Methods
     */
    truck(x, y, enableTransition = false) {
        this._camera.updateMatrix();
        _xColumn.setFromMatrixColumn(this._camera.matrix, 0);
        _yColumn.setFromMatrixColumn(this._camera.matrix, 1);
        _xColumn.multiplyScalar(x);
        _yColumn.multiplyScalar(-y);
        const offset = _v3A.copy(_xColumn).add(_yColumn);
        const to = _v3B.copy(this._targetEnd).add(offset);
        return this.moveTo(to.x, to.y, to.z, enableTransition);
    }
    /**
     * Move forward / backward.
     * @param distance Amount to move forward / backward. Negative value to move backward
     * @param enableTransition Whether to move smoothly or immediately
     * @category Methods
     */
    forward(distance, enableTransition = false) {
        _v3A.setFromMatrixColumn(this._camera.matrix, 0);
        _v3A.crossVectors(this._camera.up, _v3A);
        _v3A.multiplyScalar(distance);
        const to = _v3B.copy(this._targetEnd).add(_v3A);
        return this.moveTo(to.x, to.y, to.z, enableTransition);
    }
    /**
     * Move up / down.
     * @param height Amount to move up / down. Negative value to move down
     * @param enableTransition Whether to move smoothly or immediately
     * @category Methods
     */
    elevate(height, enableTransition = false) {
        _v3A.copy(this._camera.up).multiplyScalar(height);
        return this.moveTo(this._targetEnd.x + _v3A.x, this._targetEnd.y + _v3A.y, this._targetEnd.z + _v3A.z, enableTransition);
    }
    /**
     * Move target position to given point.
     * @param x x coord to move center position
     * @param y y coord to move center position
     * @param z z coord to move center position
     * @param enableTransition Whether to move smoothly or immediately
     * @category Methods
     */
    moveTo(x, y, z, enableTransition = false) {
        this._isUserControllingTruck = false;
        const offset = _v3A.set(x, y, z).sub(this._targetEnd);
        this._encloseToBoundary(this._targetEnd, offset, this.boundaryFriction);
        this._needsUpdate = true;
        if (!enableTransition) {
            this._target.copy(this._targetEnd);
        }
        const resolveImmediately = !enableTransition ||
            approxEquals(this._target.x, this._targetEnd.x, this.restThreshold) &&
                approxEquals(this._target.y, this._targetEnd.y, this.restThreshold) &&
                approxEquals(this._target.z, this._targetEnd.z, this.restThreshold);
        return this._createOnRestPromise(resolveImmediately);
    }
    /**
     * Look in the given point direction.
     * @param x point x.
     * @param y point y.
     * @param z point z.
     * @param enableTransition Whether to move smoothly or immediately.
     * @returns Transition end promise
     * @category Methods
     */
    lookInDirectionOf(x, y, z, enableTransition = false) {
        const point = _v3A.set(x, y, z);
        const direction = point.sub(this._targetEnd).normalize();
        const position = direction.multiplyScalar(-this._sphericalEnd.radius);
        return this.setPosition(position.x, position.y, position.z, enableTransition);
    }
    /**
     * Fit the viewport to the box or the bounding box of the object, using the nearest axis. paddings are in unit.
     * set `cover: true` to fill enter screen.
     * e.g.
     * ```
     * cameraControls.fitToBox( myMesh );
     * ```
     * @param box3OrObject Axis aligned bounding box to fit the view.
     * @param enableTransition Whether to move smoothly or immediately.
     * @param options | `<object>` { cover: boolean, paddingTop: number, paddingLeft: number, paddingBottom: number, paddingRight: number }
     * @returns Transition end promise
     * @category Methods
     */
    fitToBox(box3OrObject, enableTransition, { cover = false, paddingLeft = 0, paddingRight = 0, paddingBottom = 0, paddingTop = 0 } = {}) {
        const promises = [];
        const aabb = box3OrObject.isBox3
            ? _box3A.copy(box3OrObject)
            : _box3A.setFromObject(box3OrObject);
        if (aabb.isEmpty()) {
            console.warn('camera-controls: fitTo() cannot be used with an empty box. Aborting');
            Promise.resolve();
        }
        // round to closest axis ( forward | backward | right | left | top | bottom )
        const theta = roundToStep(this._sphericalEnd.theta, PI_HALF);
        const phi = roundToStep(this._sphericalEnd.phi, PI_HALF);
        promises.push(this.rotateTo(theta, phi, enableTransition));
        const normal = _v3A.setFromSpherical(this._sphericalEnd).normalize();
        const rotation = _quaternionA.setFromUnitVectors(normal, _AXIS_Z);
        const viewFromPolar = approxEquals(Math.abs(normal.y), 1);
        if (viewFromPolar) {
            rotation.multiply(_quaternionB.setFromAxisAngle(_AXIS_Y, theta));
        }
        rotation.multiply(this._yAxisUpSpaceInverse);
        // make oriented bounding box
        const bb = _box3B.makeEmpty();
        // left bottom back corner
        _v3B.copy(aabb.min).applyQuaternion(rotation);
        bb.expandByPoint(_v3B);
        // right bottom back corner
        _v3B.copy(aabb.min).setX(aabb.max.x).applyQuaternion(rotation);
        bb.expandByPoint(_v3B);
        // left top back corner
        _v3B.copy(aabb.min).setY(aabb.max.y).applyQuaternion(rotation);
        bb.expandByPoint(_v3B);
        // right top back corner
        _v3B.copy(aabb.max).setZ(aabb.min.z).applyQuaternion(rotation);
        bb.expandByPoint(_v3B);
        // left bottom front corner
        _v3B.copy(aabb.min).setZ(aabb.max.z).applyQuaternion(rotation);
        bb.expandByPoint(_v3B);
        // right bottom front corner
        _v3B.copy(aabb.max).setY(aabb.min.y).applyQuaternion(rotation);
        bb.expandByPoint(_v3B);
        // left top front corner
        _v3B.copy(aabb.max).setX(aabb.min.x).applyQuaternion(rotation);
        bb.expandByPoint(_v3B);
        // right top front corner
        _v3B.copy(aabb.max).applyQuaternion(rotation);
        bb.expandByPoint(_v3B);
        // add padding
        bb.min.x -= paddingLeft;
        bb.min.y -= paddingBottom;
        bb.max.x += paddingRight;
        bb.max.y += paddingTop;
        rotation.setFromUnitVectors(_AXIS_Z, normal);
        if (viewFromPolar) {
            rotation.premultiply(_quaternionB.invert());
        }
        rotation.premultiply(this._yAxisUpSpace);
        const bbSize = bb.getSize(_v3A);
        const center = bb.getCenter(_v3B).applyQuaternion(rotation);
        if (isPerspectiveCamera(this._camera)) {
            const distance = this.getDistanceToFitBox(bbSize.x, bbSize.y, bbSize.z, cover);
            promises.push(this.moveTo(center.x, center.y, center.z, enableTransition));
            promises.push(this.dollyTo(distance, enableTransition));
            promises.push(this.setFocalOffset(0, 0, 0, enableTransition));
        }
        else if (isOrthographicCamera(this._camera)) {
            const camera = this._camera;
            const width = camera.right - camera.left;
            const height = camera.top - camera.bottom;
            const zoom = cover ? Math.max(width / bbSize.x, height / bbSize.y) : Math.min(width / bbSize.x, height / bbSize.y);
            promises.push(this.moveTo(center.x, center.y, center.z, enableTransition));
            promises.push(this.zoomTo(zoom, enableTransition));
            promises.push(this.setFocalOffset(0, 0, 0, enableTransition));
        }
        return Promise.all(promises);
    }
    /**
     * Fit the viewport to the sphere or the bounding sphere of the object.
     * @param sphereOrMesh
     * @param enableTransition
     * @category Methods
     */
    fitToSphere(sphereOrMesh, enableTransition) {
        const promises = [];
        const isSphere = sphereOrMesh instanceof THREE.Sphere;
        const boundingSphere = isSphere ?
            _sphere.copy(sphereOrMesh) :
            CameraControls.createBoundingSphere(sphereOrMesh, _sphere);
        promises.push(this.moveTo(boundingSphere.center.x, boundingSphere.center.y, boundingSphere.center.z, enableTransition));
        if (isPerspectiveCamera(this._camera)) {
            const distanceToFit = this.getDistanceToFitSphere(boundingSphere.radius);
            promises.push(this.dollyTo(distanceToFit, enableTransition));
        }
        else if (isOrthographicCamera(this._camera)) {
            const width = this._camera.right - this._camera.left;
            const height = this._camera.top - this._camera.bottom;
            const diameter = 2 * boundingSphere.radius;
            const zoom = Math.min(width / diameter, height / diameter);
            promises.push(this.zoomTo(zoom, enableTransition));
        }
        promises.push(this.setFocalOffset(0, 0, 0, enableTransition));
        return Promise.all(promises);
    }
    /**
     * Look at the `target` from the `position`.
     * @param positionX
     * @param positionY
     * @param positionZ
     * @param targetX
     * @param targetY
     * @param targetZ
     * @param enableTransition
     * @category Methods
     */
    setLookAt(positionX, positionY, positionZ, targetX, targetY, targetZ, enableTransition = false) {
        this._isUserControllingRotate = false;
        this._isUserControllingDolly = false;
        this._isUserControllingTruck = false;
        this._lastDollyDirection = DOLLY_DIRECTION.NONE;
        this._changedDolly = 0;
        const target = _v3B.set(targetX, targetY, targetZ);
        const position = _v3A.set(positionX, positionY, positionZ);
        this._targetEnd.copy(target);
        this._sphericalEnd.setFromVector3(position.sub(target).applyQuaternion(this._yAxisUpSpace));
        this.normalizeRotations();
        this._needsUpdate = true;
        if (!enableTransition) {
            this._target.copy(this._targetEnd);
            this._spherical.copy(this._sphericalEnd);
        }
        const resolveImmediately = !enableTransition ||
            approxEquals(this._target.x, this._targetEnd.x, this.restThreshold) &&
                approxEquals(this._target.y, this._targetEnd.y, this.restThreshold) &&
                approxEquals(this._target.z, this._targetEnd.z, this.restThreshold) &&
                approxEquals(this._spherical.theta, this._sphericalEnd.theta, this.restThreshold) &&
                approxEquals(this._spherical.phi, this._sphericalEnd.phi, this.restThreshold) &&
                approxEquals(this._spherical.radius, this._sphericalEnd.radius, this.restThreshold);
        return this._createOnRestPromise(resolveImmediately);
    }
    /**
     * Similar to setLookAt, but it interpolates between two states.
     * @param positionAX
     * @param positionAY
     * @param positionAZ
     * @param targetAX
     * @param targetAY
     * @param targetAZ
     * @param positionBX
     * @param positionBY
     * @param positionBZ
     * @param targetBX
     * @param targetBY
     * @param targetBZ
     * @param t
     * @param enableTransition
     * @category Methods
     */
    lerpLookAt(positionAX, positionAY, positionAZ, targetAX, targetAY, targetAZ, positionBX, positionBY, positionBZ, targetBX, targetBY, targetBZ, t, enableTransition = false) {
        this._isUserControllingRotate = false;
        this._isUserControllingDolly = false;
        this._isUserControllingTruck = false;
        this._lastDollyDirection = DOLLY_DIRECTION.NONE;
        this._changedDolly = 0;
        const targetA = _v3A.set(targetAX, targetAY, targetAZ);
        const positionA = _v3B.set(positionAX, positionAY, positionAZ);
        _sphericalA.setFromVector3(positionA.sub(targetA).applyQuaternion(this._yAxisUpSpace));
        const targetB = _v3C.set(targetBX, targetBY, targetBZ);
        const positionB = _v3B.set(positionBX, positionBY, positionBZ);
        _sphericalB.setFromVector3(positionB.sub(targetB).applyQuaternion(this._yAxisUpSpace));
        this._targetEnd.copy(targetA.lerp(targetB, t)); // tricky
        const deltaTheta = _sphericalB.theta - _sphericalA.theta;
        const deltaPhi = _sphericalB.phi - _sphericalA.phi;
        const deltaRadius = _sphericalB.radius - _sphericalA.radius;
        this._sphericalEnd.set(_sphericalA.radius + deltaRadius * t, _sphericalA.phi + deltaPhi * t, _sphericalA.theta + deltaTheta * t);
        this.normalizeRotations();
        this._needsUpdate = true;
        if (!enableTransition) {
            this._target.copy(this._targetEnd);
            this._spherical.copy(this._sphericalEnd);
        }
        const resolveImmediately = !enableTransition ||
            approxEquals(this._target.x, this._targetEnd.x, this.restThreshold) &&
                approxEquals(this._target.y, this._targetEnd.y, this.restThreshold) &&
                approxEquals(this._target.z, this._targetEnd.z, this.restThreshold) &&
                approxEquals(this._spherical.theta, this._sphericalEnd.theta, this.restThreshold) &&
                approxEquals(this._spherical.phi, this._sphericalEnd.phi, this.restThreshold) &&
                approxEquals(this._spherical.radius, this._sphericalEnd.radius, this.restThreshold);
        return this._createOnRestPromise(resolveImmediately);
    }
    /**
     * Set angle and distance by given position.
     * An alias of `setLookAt()`, without target change. Thus keep gazing at the current target
     * @param positionX
     * @param positionY
     * @param positionZ
     * @param enableTransition
     * @category Methods
     */
    setPosition(positionX, positionY, positionZ, enableTransition = false) {
        return this.setLookAt(positionX, positionY, positionZ, this._targetEnd.x, this._targetEnd.y, this._targetEnd.z, enableTransition);
    }
    /**
     * Set the target position where gaze at.
     * An alias of `setLookAt()`, without position change. Thus keep the same position.
     * @param targetX
     * @param targetY
     * @param targetZ
     * @param enableTransition
     * @category Methods
     */
    setTarget(targetX, targetY, targetZ, enableTransition = false) {
        const pos = this.getPosition(_v3A);
        const promise = this.setLookAt(pos.x, pos.y, pos.z, targetX, targetY, targetZ, enableTransition);
        // see https://github.com/yomotsu/camera-controls/issues/335
        this._sphericalEnd.phi = clamp(this._sphericalEnd.phi, this.minPolarAngle, this.maxPolarAngle);
        return promise;
    }
    /**
     * Set focal offset using the screen parallel coordinates. z doesn't affect in Orthographic as with Dolly.
     * @param x
     * @param y
     * @param z
     * @param enableTransition
     * @category Methods
     */
    setFocalOffset(x, y, z, enableTransition = false) {
        this._isUserControllingOffset = false;
        this._focalOffsetEnd.set(x, y, z);
        this._needsUpdate = true;
        if (!enableTransition)
            this._focalOffset.copy(this._focalOffsetEnd);
        const resolveImmediately = !enableTransition ||
            approxEquals(this._focalOffset.x, this._focalOffsetEnd.x, this.restThreshold) &&
                approxEquals(this._focalOffset.y, this._focalOffsetEnd.y, this.restThreshold) &&
                approxEquals(this._focalOffset.z, this._focalOffsetEnd.z, this.restThreshold);
        return this._createOnRestPromise(resolveImmediately);
    }
    /**
     * Set orbit point without moving the camera.
     * SHOULD NOT RUN DURING ANIMATIONS. `setOrbitPoint()` will immediately fix the positions.
     * @param targetX
     * @param targetY
     * @param targetZ
     * @category Methods
     */
    setOrbitPoint(targetX, targetY, targetZ) {
        this._camera.updateMatrixWorld();
        _xColumn.setFromMatrixColumn(this._camera.matrixWorldInverse, 0);
        _yColumn.setFromMatrixColumn(this._camera.matrixWorldInverse, 1);
        _zColumn.setFromMatrixColumn(this._camera.matrixWorldInverse, 2);
        const position = _v3A.set(targetX, targetY, targetZ);
        const distance = position.distanceTo(this._camera.position);
        const cameraToPoint = position.sub(this._camera.position);
        _xColumn.multiplyScalar(cameraToPoint.x);
        _yColumn.multiplyScalar(cameraToPoint.y);
        _zColumn.multiplyScalar(cameraToPoint.z);
        _v3A.copy(_xColumn).add(_yColumn).add(_zColumn);
        _v3A.z = _v3A.z + distance;
        this.dollyTo(distance, false);
        this.setFocalOffset(-_v3A.x, _v3A.y, -_v3A.z, false);
        this.moveTo(targetX, targetY, targetZ, false);
    }
    /**
     * Set the boundary box that encloses the target of the camera. box3 is in THREE.Box3
     * @param box3
     * @category Methods
     */
    setBoundary(box3) {
        if (!box3) {
            this._boundary.min.set(-Infinity, -Infinity, -Infinity);
            this._boundary.max.set(Infinity, Infinity, Infinity);
            this._needsUpdate = true;
            return;
        }
        this._boundary.copy(box3);
        this._boundary.clampPoint(this._targetEnd, this._targetEnd);
        this._needsUpdate = true;
    }
    /**
     * Set (or unset) the current viewport.
     * Set this when you want to use renderer viewport and .dollyToCursor feature at the same time.
     * @param viewportOrX
     * @param y
     * @param width
     * @param height
     * @category Methods
     */
    setViewport(viewportOrX, y, width, height) {
        if (viewportOrX === null) { // null
            this._viewport = null;
            return;
        }
        this._viewport = this._viewport || new THREE.Vector4();
        if (typeof viewportOrX === 'number') { // number
            this._viewport.set(viewportOrX, y, width, height);
        }
        else { // Vector4
            this._viewport.copy(viewportOrX);
        }
    }
    /**
     * Calculate the distance to fit the box.
     * @param width box width
     * @param height box height
     * @param depth box depth
     * @returns distance
     * @category Methods
     */
    getDistanceToFitBox(width, height, depth, cover = false) {
        if (notSupportedInOrthographicCamera(this._camera, 'getDistanceToFitBox'))
            return this._spherical.radius;
        const boundingRectAspect = width / height;
        const fov = this._camera.getEffectiveFOV() * DEG2RAD;
        const aspect = this._camera.aspect;
        const heightToFit = (cover ? boundingRectAspect > aspect : boundingRectAspect < aspect) ? height : width / aspect;
        return heightToFit * 0.5 / Math.tan(fov * 0.5) + depth * 0.5;
    }
    /**
     * Calculate the distance to fit the sphere.
     * @param radius sphere radius
     * @returns distance
     * @category Methods
     */
    getDistanceToFitSphere(radius) {
        if (notSupportedInOrthographicCamera(this._camera, 'getDistanceToFitSphere'))
            return this._spherical.radius;
        // https://stackoverflow.com/a/44849975
        const vFOV = this._camera.getEffectiveFOV() * DEG2RAD;
        const hFOV = Math.atan(Math.tan(vFOV * 0.5) * this._camera.aspect) * 2;
        const fov = 1 < this._camera.aspect ? vFOV : hFOV;
        return radius / (Math.sin(fov * 0.5));
    }
    /**
     * Returns the orbit center position, where the camera looking at.
     * @param out The receiving Vector3 instance to copy the result
     * @param receiveEndValue Whether receive the transition end coords or current. default is `true`
     * @category Methods
     */
    getTarget(out, receiveEndValue = true) {
        const _out = !!out && out.isVector3 ? out : new THREE.Vector3();
        return _out.copy(receiveEndValue ? this._targetEnd : this._target);
    }
    /**
     * Returns the camera position.
     * @param out The receiving Vector3 instance to copy the result
     * @param receiveEndValue Whether receive the transition end coords or current. default is `true`
     * @category Methods
     */
    getPosition(out, receiveEndValue = true) {
        const _out = !!out && out.isVector3 ? out : new THREE.Vector3();
        return _out.setFromSpherical(receiveEndValue ? this._sphericalEnd : this._spherical).applyQuaternion(this._yAxisUpSpaceInverse).add(receiveEndValue ? this._targetEnd : this._target);
    }
    /**
     * Returns the spherical coordinates of the orbit.
     * @param out The receiving Spherical instance to copy the result
     * @param receiveEndValue Whether receive the transition end coords or current. default is `true`
     * @category Methods
     */
    getSpherical(out, receiveEndValue = true) {
        const _out = !!out && out instanceof THREE.Spherical ? out : new THREE.Spherical();
        return _out.copy(receiveEndValue ? this._sphericalEnd : this._spherical);
    }
    /**
     * Returns the focal offset, which is how much the camera appears to be translated in screen parallel coordinates.
     * @param out The receiving Vector3 instance to copy the result
     * @param receiveEndValue Whether receive the transition end coords or current. default is `true`
     * @category Methods
     */
    getFocalOffset(out, receiveEndValue = true) {
        const _out = !!out && out.isVector3 ? out : new THREE.Vector3();
        return _out.copy(receiveEndValue ? this._focalOffsetEnd : this._focalOffset);
    }
    /**
     * Normalize camera azimuth angle rotation between 0 and 360 degrees.
     * @category Methods
     */
    normalizeRotations() {
        this._sphericalEnd.theta = this._sphericalEnd.theta % PI_2;
        if (this._sphericalEnd.theta < 0)
            this._sphericalEnd.theta += PI_2;
        this._spherical.theta += PI_2 * Math.round((this._sphericalEnd.theta - this._spherical.theta) / PI_2);
    }
    /**
     * Reset all rotation and position to defaults.
     * @param enableTransition
     * @category Methods
     */
    reset(enableTransition = false) {
        if (!approxEquals(this._camera.up.x, this._cameraUp0.x) ||
            !approxEquals(this._camera.up.y, this._cameraUp0.y) ||
            !approxEquals(this._camera.up.z, this._cameraUp0.z)) {
            this._camera.up.copy(this._cameraUp0);
            const position = this.getPosition(_v3A);
            this.updateCameraUp();
            this.setPosition(position.x, position.y, position.z);
        }
        const promises = [
            this.setLookAt(this._position0.x, this._position0.y, this._position0.z, this._target0.x, this._target0.y, this._target0.z, enableTransition),
            this.setFocalOffset(this._focalOffset0.x, this._focalOffset0.y, this._focalOffset0.z, enableTransition),
            this.zoomTo(this._zoom0, enableTransition),
        ];
        return Promise.all(promises);
    }
    /**
     * Set current camera position as the default position.
     * @category Methods
     */
    saveState() {
        this._cameraUp0.copy(this._camera.up);
        this.getTarget(this._target0);
        this.getPosition(this._position0);
        this._zoom0 = this._zoom;
        this._focalOffset0.copy(this._focalOffset);
    }
    /**
     * Sync camera-up direction.
     * When camera-up vector is changed, `.updateCameraUp()` must be called.
     * @category Methods
     */
    updateCameraUp() {
        this._yAxisUpSpace.setFromUnitVectors(this._camera.up, _AXIS_Y);
        this._yAxisUpSpaceInverse.copy(this._yAxisUpSpace).invert();
    }
    /**
     * Apply current camera-up direction to the camera.
     * The orbit system will be re-initialized with the current position.
     * @category Methods
     */
    applyCameraUp() {
        const cameraDirection = _v3A.subVectors(this._target, this._camera.position).normalize();
        // So first find the vector off to the side, orthogonal to both this.object.up and
        // the "view" vector.
        const side = _v3B.crossVectors(cameraDirection, this._camera.up);
        // Then find the vector orthogonal to both this "side" vector and the "view" vector.
        // This vector will be the new "up" vector.
        this._camera.up.crossVectors(side, cameraDirection).normalize();
        this._camera.updateMatrixWorld();
        const position = this.getPosition(_v3A);
        this.updateCameraUp();
        this.setPosition(position.x, position.y, position.z);
    }
    /**
     * Update camera position and directions.
     * This should be called in your tick loop every time, and returns true if re-rendering is needed.
     * @param delta
     * @returns updated
     * @category Methods
     */
    update(delta) {
        const deltaTheta = this._sphericalEnd.theta - this._spherical.theta;
        const deltaPhi = this._sphericalEnd.phi - this._spherical.phi;
        const deltaRadius = this._sphericalEnd.radius - this._spherical.radius;
        const deltaTarget = _deltaTarget.subVectors(this._targetEnd, this._target);
        const deltaOffset = _deltaOffset.subVectors(this._focalOffsetEnd, this._focalOffset);
        const deltaZoom = this._zoomEnd - this._zoom;
        // update theta
        if (approxZero(deltaTheta)) {
            this._thetaVelocity.value = 0;
            this._spherical.theta = this._sphericalEnd.theta;
        }
        else {
            const smoothTime = this._isUserControllingRotate ? this.draggingSmoothTime : this.smoothTime;
            this._spherical.theta = smoothDamp(this._spherical.theta, this._sphericalEnd.theta, this._thetaVelocity, smoothTime, Infinity, delta);
            this._needsUpdate = true;
        }
        // update phi
        if (approxZero(deltaPhi)) {
            this._phiVelocity.value = 0;
            this._spherical.phi = this._sphericalEnd.phi;
        }
        else {
            const smoothTime = this._isUserControllingRotate ? this.draggingSmoothTime : this.smoothTime;
            this._spherical.phi = smoothDamp(this._spherical.phi, this._sphericalEnd.phi, this._phiVelocity, smoothTime, Infinity, delta);
            this._needsUpdate = true;
        }
        // update distance
        if (approxZero(deltaRadius)) {
            this._radiusVelocity.value = 0;
            this._spherical.radius = this._sphericalEnd.radius;
        }
        else {
            const smoothTime = this._isUserControllingDolly ? this.draggingSmoothTime : this.smoothTime;
            this._spherical.radius = smoothDamp(this._spherical.radius, this._sphericalEnd.radius, this._radiusVelocity, smoothTime, this.maxSpeed, delta);
            this._needsUpdate = true;
        }
        // update target position
        if (approxZero(deltaTarget.x) && approxZero(deltaTarget.y) && approxZero(deltaTarget.z)) {
            this._targetVelocity.set(0, 0, 0);
            this._target.copy(this._targetEnd);
        }
        else {
            const smoothTime = this._isUserControllingTruck ? this.draggingSmoothTime : this.smoothTime;
            smoothDampVec3(this._target, this._targetEnd, this._targetVelocity, smoothTime, this.maxSpeed, delta, this._target);
            this._needsUpdate = true;
        }
        // update focalOffset
        if (approxZero(deltaOffset.x) && approxZero(deltaOffset.y) && approxZero(deltaOffset.z)) {
            this._focalOffsetVelocity.set(0, 0, 0);
            this._focalOffset.copy(this._focalOffsetEnd);
        }
        else {
            const smoothTime = this._isUserControllingOffset ? this.draggingSmoothTime : this.smoothTime;
            smoothDampVec3(this._focalOffset, this._focalOffsetEnd, this._focalOffsetVelocity, smoothTime, this.maxSpeed, delta, this._focalOffset);
            this._needsUpdate = true;
        }
        // update zoom
        if (approxZero(deltaZoom)) {
            this._zoomVelocity.value = 0;
            this._zoom = this._zoomEnd;
        }
        else {
            const smoothTime = this._isUserControllingZoom ? this.draggingSmoothTime : this.smoothTime;
            this._zoom = smoothDamp(this._zoom, this._zoomEnd, this._zoomVelocity, smoothTime, Infinity, delta);
        }
        if (this.dollyToCursor) {
            if (isPerspectiveCamera(this._camera) && this._changedDolly !== 0) {
                const dollyControlAmount = this._spherical.radius - this._lastDistance;
                const camera = this._camera;
                const cameraDirection = this._getCameraDirection(_cameraDirection);
                const planeX = _v3A.copy(cameraDirection).cross(camera.up).normalize();
                if (planeX.lengthSq() === 0)
                    planeX.x = 1.0;
                const planeY = _v3B.crossVectors(planeX, cameraDirection);
                const worldToScreen = this._sphericalEnd.radius * Math.tan(camera.getEffectiveFOV() * DEG2RAD * 0.5);
                const prevRadius = this._sphericalEnd.radius - dollyControlAmount;
                const lerpRatio = (prevRadius - this._sphericalEnd.radius) / this._sphericalEnd.radius;
                const cursor = _v3C.copy(this._targetEnd)
                    .add(planeX.multiplyScalar(this._dollyControlCoord.x * worldToScreen * camera.aspect))
                    .add(planeY.multiplyScalar(this._dollyControlCoord.y * worldToScreen));
                const newTargetEnd = _v3A.copy(this._targetEnd).lerp(cursor, lerpRatio);
                const isMin = this._lastDollyDirection === DOLLY_DIRECTION.IN && this._spherical.radius <= this.minDistance;
                const isMax = this._lastDollyDirection === DOLLY_DIRECTION.OUT && this.maxDistance <= this._spherical.radius;
                if (this.infinityDolly && (isMin || isMax)) {
                    this._sphericalEnd.radius -= dollyControlAmount;
                    this._spherical.radius -= dollyControlAmount;
                    const dollyAmount = _v3B.copy(cameraDirection).multiplyScalar(-dollyControlAmount);
                    newTargetEnd.add(dollyAmount);
                }
                // target position may be moved beyond boundary.
                this._boundary.clampPoint(newTargetEnd, newTargetEnd);
                const targetEndDiff = _v3B.subVectors(newTargetEnd, this._targetEnd);
                this._targetEnd.copy(newTargetEnd);
                this._target.add(targetEndDiff);
                this._changedDolly -= dollyControlAmount;
                if (approxZero(this._changedDolly))
                    this._changedDolly = 0;
            }
            else if (isOrthographicCamera(this._camera) && this._changedZoom !== 0) {
                const dollyControlAmount = this._zoom - this._lastZoom;
                const camera = this._camera;
                const worldCursorPosition = _v3A.set(this._dollyControlCoord.x, this._dollyControlCoord.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera);
                const quaternion = _v3B.set(0, 0, -1).applyQuaternion(camera.quaternion);
                const cursor = _v3C.copy(worldCursorPosition).add(quaternion.multiplyScalar(-worldCursorPosition.dot(camera.up)));
                const prevZoom = this._zoom - dollyControlAmount;
                const lerpRatio = -(prevZoom - this._zoom) / this._zoom;
                // find the "distance" (aka plane constant in three.js) of Plane
                // from a given position (this._targetEnd) and normal vector (cameraDirection)
                // https://www.maplesoft.com/support/help/maple/view.aspx?path=MathApps%2FEquationOfAPlaneNormal#bkmrk0
                const cameraDirection = this._getCameraDirection(_cameraDirection);
                const prevPlaneConstant = this._targetEnd.dot(cameraDirection);
                const newTargetEnd = _v3A.copy(this._targetEnd).lerp(cursor, lerpRatio);
                const newPlaneConstant = newTargetEnd.dot(cameraDirection);
                // Pull back the camera depth that has moved, to be the camera stationary as zoom
                const pullBack = cameraDirection.multiplyScalar(newPlaneConstant - prevPlaneConstant);
                newTargetEnd.sub(pullBack);
                // target position may be moved beyond boundary.
                this._boundary.clampPoint(newTargetEnd, newTargetEnd);
                const targetEndDiff = _v3B.subVectors(newTargetEnd, this._targetEnd);
                this._targetEnd.copy(newTargetEnd);
                this._target.add(targetEndDiff);
                // this._target.copy( this._targetEnd );
                this._changedZoom -= dollyControlAmount;
                if (approxZero(this._changedZoom))
                    this._changedZoom = 0;
            }
        }
        if (this._camera.zoom !== this._zoom) {
            this._camera.zoom = this._zoom;
            this._camera.updateProjectionMatrix();
            this._updateNearPlaneCorners();
            this._needsUpdate = true;
        }
        // collision detection
        const maxDistance = this._collisionTest();
        this._spherical.radius = Math.min(this._spherical.radius, maxDistance);
        // decompose spherical to the camera position
        this._spherical.makeSafe();
        this._camera.position.setFromSpherical(this._spherical).applyQuaternion(this._yAxisUpSpaceInverse).add(this._target);
        this._camera.lookAt(this._target);
        // set offset after the orbit movement
        const affectOffset = !approxZero(this._focalOffset.x) ||
            !approxZero(this._focalOffset.y) ||
            !approxZero(this._focalOffset.z);
        if (affectOffset) {
            this._camera.updateMatrixWorld();
            _xColumn.setFromMatrixColumn(this._camera.matrix, 0);
            _yColumn.setFromMatrixColumn(this._camera.matrix, 1);
            _zColumn.setFromMatrixColumn(this._camera.matrix, 2);
            _xColumn.multiplyScalar(this._focalOffset.x);
            _yColumn.multiplyScalar(-this._focalOffset.y);
            _zColumn.multiplyScalar(this._focalOffset.z); // notice: z-offset will not affect in Orthographic.
            _v3A.copy(_xColumn).add(_yColumn).add(_zColumn);
            this._camera.position.add(_v3A);
        }
        if (this._boundaryEnclosesCamera) {
            this._encloseToBoundary(this._camera.position.copy(this._target), _v3A.setFromSpherical(this._spherical).applyQuaternion(this._yAxisUpSpaceInverse), 1.0);
        }
        const updated = this._needsUpdate;
        if (updated && !this._updatedLastTime) {
            this._hasRested = false;
            this.dispatchEvent({ type: 'wake' });
            this.dispatchEvent({ type: 'update' });
        }
        else if (updated) {
            this.dispatchEvent({ type: 'update' });
            if (approxZero(deltaTheta, this.restThreshold) &&
                approxZero(deltaPhi, this.restThreshold) &&
                approxZero(deltaRadius, this.restThreshold) &&
                approxZero(deltaTarget.x, this.restThreshold) &&
                approxZero(deltaTarget.y, this.restThreshold) &&
                approxZero(deltaTarget.z, this.restThreshold) &&
                approxZero(deltaOffset.x, this.restThreshold) &&
                approxZero(deltaOffset.y, this.restThreshold) &&
                approxZero(deltaOffset.z, this.restThreshold) &&
                approxZero(deltaZoom, this.restThreshold) &&
                !this._hasRested) {
                this._hasRested = true;
                this.dispatchEvent({ type: 'rest' });
            }
        }
        else if (!updated && this._updatedLastTime) {
            this.dispatchEvent({ type: 'sleep' });
        }
        this._lastDistance = this._spherical.radius;
        this._lastZoom = this._zoom;
        this._updatedLastTime = updated;
        this._needsUpdate = false;
        return updated;
    }
    /**
     * Get all state in JSON string
     * @category Methods
     */
    toJSON() {
        return JSON.stringify({
            enabled: this._enabled,
            minDistance: this.minDistance,
            maxDistance: infinityToMaxNumber(this.maxDistance),
            minZoom: this.minZoom,
            maxZoom: infinityToMaxNumber(this.maxZoom),
            minPolarAngle: this.minPolarAngle,
            maxPolarAngle: infinityToMaxNumber(this.maxPolarAngle),
            minAzimuthAngle: infinityToMaxNumber(this.minAzimuthAngle),
            maxAzimuthAngle: infinityToMaxNumber(this.maxAzimuthAngle),
            smoothTime: this.smoothTime,
            draggingSmoothTime: this.draggingSmoothTime,
            dollySpeed: this.dollySpeed,
            truckSpeed: this.truckSpeed,
            dollyToCursor: this.dollyToCursor,
            verticalDragToForward: this.verticalDragToForward,
            target: this._targetEnd.toArray(),
            position: _v3A.setFromSpherical(this._sphericalEnd).add(this._targetEnd).toArray(),
            zoom: this._zoomEnd,
            focalOffset: this._focalOffsetEnd.toArray(),
            target0: this._target0.toArray(),
            position0: this._position0.toArray(),
            zoom0: this._zoom0,
            focalOffset0: this._focalOffset0.toArray(),
        });
    }
    /**
     * Reproduce the control state with JSON. enableTransition is where anim or not in a boolean.
     * @param json
     * @param enableTransition
     * @category Methods
     */
    fromJSON(json, enableTransition = false) {
        const obj = JSON.parse(json);
        this.enabled = obj.enabled;
        this.minDistance = obj.minDistance;
        this.maxDistance = maxNumberToInfinity(obj.maxDistance);
        this.minZoom = obj.minZoom;
        this.maxZoom = maxNumberToInfinity(obj.maxZoom);
        this.minPolarAngle = obj.minPolarAngle;
        this.maxPolarAngle = maxNumberToInfinity(obj.maxPolarAngle);
        this.minAzimuthAngle = maxNumberToInfinity(obj.minAzimuthAngle);
        this.maxAzimuthAngle = maxNumberToInfinity(obj.maxAzimuthAngle);
        this.smoothTime = obj.smoothTime;
        this.draggingSmoothTime = obj.draggingSmoothTime;
        this.dollySpeed = obj.dollySpeed;
        this.truckSpeed = obj.truckSpeed;
        this.dollyToCursor = obj.dollyToCursor;
        this.verticalDragToForward = obj.verticalDragToForward;
        this._target0.fromArray(obj.target0);
        this._position0.fromArray(obj.position0);
        this._zoom0 = obj.zoom0;
        this._focalOffset0.fromArray(obj.focalOffset0);
        this.moveTo(obj.target[0], obj.target[1], obj.target[2], enableTransition);
        _sphericalA.setFromVector3(_v3A.fromArray(obj.position).sub(this._targetEnd).applyQuaternion(this._yAxisUpSpace));
        this.rotateTo(_sphericalA.theta, _sphericalA.phi, enableTransition);
        this.dollyTo(_sphericalA.radius, enableTransition);
        this.zoomTo(obj.zoom, enableTransition);
        this.setFocalOffset(obj.focalOffset[0], obj.focalOffset[1], obj.focalOffset[2], enableTransition);
        this._needsUpdate = true;
    }
    /**
     * Attach all internal event handlers to enable drag control.
     * @category Methods
     */
    connect(domElement) {
        if (this._domElement) {
            console.warn('camera-controls is already connected.');
            return;
        }
        domElement.setAttribute('data-camera-controls-version', VERSION);
        this._addAllEventListeners(domElement);
    }
    /**
     * Detach all internal event handlers to disable drag control.
     */
    disconnect() {
        this.cancel();
        this._removeAllEventListeners();
        if (this._domElement) {
            this._domElement.removeAttribute('data-camera-controls-version');
            this._domElement = undefined;
        }
    }
    /**
     * Dispose the cameraControls instance itself, remove all eventListeners.
     * @category Methods
     */
    dispose() {
        // remove all user event listeners
        this.removeAllEventListeners();
        // remove all internal event listeners
        this.disconnect();
    }
    // it's okay to expose public though
    _getTargetDirection(out) {
        // divide by distance to normalize, lighter than `Vector3.prototype.normalize()`
        return out.setFromSpherical(this._spherical).divideScalar(this._spherical.radius).applyQuaternion(this._yAxisUpSpaceInverse);
    }
    // it's okay to expose public though
    _getCameraDirection(out) {
        return this._getTargetDirection(out).negate();
    }
    _findPointerById(pointerId) {
        return this._activePointers.find((activePointer) => activePointer.pointerId === pointerId);
    }
    _findPointerByMouseButton(mouseButton) {
        return this._activePointers.find((activePointer) => activePointer.mouseButton === mouseButton);
    }
    _disposePointer(pointer) {
        this._activePointers.splice(this._activePointers.indexOf(pointer), 1);
    }
    _encloseToBoundary(position, offset, friction) {
        const offsetLength2 = offset.lengthSq();
        if (offsetLength2 === 0.0) { // sanity check
            return position;
        }
        // See: https://twitter.com/FMS_Cat/status/1106508958640988161
        const newTarget = _v3B.copy(offset).add(position); // target
        const clampedTarget = this._boundary.clampPoint(newTarget, _v3C); // clamped target
        const deltaClampedTarget = clampedTarget.sub(newTarget); // newTarget -> clampedTarget
        const deltaClampedTargetLength2 = deltaClampedTarget.lengthSq(); // squared length of deltaClampedTarget
        if (deltaClampedTargetLength2 === 0.0) { // when the position doesn't have to be clamped
            return position.add(offset);
        }
        else if (deltaClampedTargetLength2 === offsetLength2) { // when the position is completely stuck
            return position;
        }
        else if (friction === 0.0) {
            return position.add(offset).add(deltaClampedTarget);
        }
        else {
            const offsetFactor = 1.0 + friction * deltaClampedTargetLength2 / offset.dot(deltaClampedTarget);
            return position
                .add(_v3B.copy(offset).multiplyScalar(offsetFactor))
                .add(deltaClampedTarget.multiplyScalar(1.0 - friction));
        }
    }
    _updateNearPlaneCorners() {
        if (isPerspectiveCamera(this._camera)) {
            const camera = this._camera;
            const near = camera.near;
            const fov = camera.getEffectiveFOV() * DEG2RAD;
            const heightHalf = Math.tan(fov * 0.5) * near; // near plain half height
            const widthHalf = heightHalf * camera.aspect; // near plain half width
            this._nearPlaneCorners[0].set(-widthHalf, -heightHalf, 0);
            this._nearPlaneCorners[1].set(widthHalf, -heightHalf, 0);
            this._nearPlaneCorners[2].set(widthHalf, heightHalf, 0);
            this._nearPlaneCorners[3].set(-widthHalf, heightHalf, 0);
        }
        else if (isOrthographicCamera(this._camera)) {
            const camera = this._camera;
            const zoomInv = 1 / camera.zoom;
            const left = camera.left * zoomInv;
            const right = camera.right * zoomInv;
            const top = camera.top * zoomInv;
            const bottom = camera.bottom * zoomInv;
            this._nearPlaneCorners[0].set(left, top, 0);
            this._nearPlaneCorners[1].set(right, top, 0);
            this._nearPlaneCorners[2].set(right, bottom, 0);
            this._nearPlaneCorners[3].set(left, bottom, 0);
        }
    }
    // lateUpdate
    _collisionTest() {
        let distance = Infinity;
        const hasCollider = this.colliderMeshes.length >= 1;
        if (!hasCollider)
            return distance;
        if (notSupportedInOrthographicCamera(this._camera, '_collisionTest'))
            return distance;
        const rayDirection = this._getTargetDirection(_cameraDirection);
        _rotationMatrix.lookAt(_ORIGIN, rayDirection, this._camera.up);
        for (let i = 0; i < 4; i++) {
            const nearPlaneCorner = _v3B.copy(this._nearPlaneCorners[i]);
            nearPlaneCorner.applyMatrix4(_rotationMatrix);
            const origin = _v3C.addVectors(this._target, nearPlaneCorner);
            _raycaster.set(origin, rayDirection);
            _raycaster.far = this._spherical.radius + 1;
            const intersects = _raycaster.intersectObjects(this.colliderMeshes);
            if (intersects.length !== 0 && intersects[0].distance < distance) {
                distance = intersects[0].distance;
            }
        }
        return distance;
    }
    /**
     * Get its client rect and package into given `DOMRect` .
     */
    _getClientRect(target) {
        if (!this._domElement)
            return;
        const rect = this._domElement.getBoundingClientRect();
        target.x = rect.left;
        target.y = rect.top;
        if (this._viewport) {
            target.x += this._viewport.x;
            target.y += rect.height - this._viewport.w - this._viewport.y;
            target.width = this._viewport.z;
            target.height = this._viewport.w;
        }
        else {
            target.width = rect.width;
            target.height = rect.height;
        }
        return target;
    }
    _createOnRestPromise(resolveImmediately) {
        if (resolveImmediately)
            return Promise.resolve();
        this._hasRested = false;
        this.dispatchEvent({ type: 'transitionstart' });
        return new Promise((resolve) => {
            const onResolve = () => {
                this.removeEventListener('rest', onResolve);
                resolve();
            };
            this.addEventListener('rest', onResolve);
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _addAllEventListeners(_domElement) { }
    _removeAllEventListeners() { }
    /**
     * backward compatible
     * @deprecated use smoothTime (in seconds) instead
     * @category Properties
     */
    get dampingFactor() {
        console.warn('.dampingFactor has been deprecated. use smoothTime (in seconds) instead.');
        return 0;
    }
    /**
     * backward compatible
     * @deprecated use smoothTime (in seconds) instead
     * @category Properties
     */
    set dampingFactor(_) {
        console.warn('.dampingFactor has been deprecated. use smoothTime (in seconds) instead.');
    }
    /**
     * backward compatible
     * @deprecated use draggingSmoothTime (in seconds) instead
     * @category Properties
     */
    get draggingDampingFactor() {
        console.warn('.draggingDampingFactor has been deprecated. use draggingSmoothTime (in seconds) instead.');
        return 0;
    }
    /**
     * backward compatible
     * @deprecated use draggingSmoothTime (in seconds) instead
     * @category Properties
     */
    set draggingDampingFactor(_) {
        console.warn('.draggingDampingFactor has been deprecated. use draggingSmoothTime (in seconds) instead.');
    }
    static createBoundingSphere(object3d, out = new THREE.Sphere()) {
        const boundingSphere = out;
        const center = boundingSphere.center;
        _box3A.makeEmpty();
        // find the center
        object3d.traverseVisible((object) => {
            if (!object.isMesh)
                return;
            _box3A.expandByObject(object);
        });
        _box3A.getCenter(center);
        // find the radius
        let maxRadiusSq = 0;
        object3d.traverseVisible((object) => {
            if (!object.isMesh)
                return;
            const mesh = object;
            const geometry = mesh.geometry.clone();
            geometry.applyMatrix4(mesh.matrixWorld);
            const bufferGeometry = geometry;
            const position = bufferGeometry.attributes.position;
            for (let i = 0, l = position.count; i < l; i++) {
                _v3A.fromBufferAttribute(position, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(_v3A));
            }
        });
        boundingSphere.radius = Math.sqrt(maxRadiusSq);
        return boundingSphere;
    }
}




/***/ }),

/***/ 2175:
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectionBox_tech {
    border: 1px solid #55aaff;
    background-color: rgba(75, 160, 255, 0.3);
    position: fixed;
}
.selectBox_minus::before {
    content: "-";
    position: absolute;
    top: -30px;
    left: 0px;
    color: white;
    font-size: 30px;
}
.selectBox_plus::before {
    content: "+";
    position: absolute;
    top: -25px;
    left: 0px;
    color: white;
    font-size: 20px;
}
.selectBox_blue {
    border: 1px solid #55aaff;
    background-color: rgba(75, 160, 255, 0.3);
    position: fixed;
}
.selectBox_green {
    border: 1px dashed #00ff55c3;
    background-color: rgba(78, 255, 75, 0.249);
    position: fixed;
}
`, ""]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 305:
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.camera-pivot-marker {
    color: #ffffff;
    width: 7px;
    height: 7px;
    border-radius: 55px;
    border: 1px solid #ebebeb;
    background: black;
    z-index: 10000;
    pointer-events: none;
}
`, ""]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 6693:
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cube__wrap {
    width: 10px;
    height: 10px;
    perspective: 400px;
    position: absolute;
    right: 90px;
    bottom: 90px;
    z-index: 2;
}
.cube {
    width: 100px;
    height: 100px;
    position: relative;
    transform-style: preserve-3d;
    transform: translateZ(-300px);
    text-transform: uppercase;
}

.cube__face {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    width: 90px;
    height: 90px;
    line-height: 100px;
    font-size: 25px;
    font-weight: bold;
    color: #7d7d7d;
    text-align: center;
    background: #ddd;
    transition: all 0.2s;
    cursor: pointer;
    user-select: none;
}
.cube__face:hover {
    background: #7d7d7d;
    color: #fff;
}
.cube__face--bottom {
    transform: rotateX(270deg) translateZ(-60px);
}

.cube__face--right {
    transform: rotateY(90deg) rotateX(180deg) translateZ(-60px);
}

.cube__face--top {
    transform: rotateY(180deg) rotateX(90deg) rotateZ(180deg) translateZ(-60px);
}

.cube__face--left {
    transform: rotateY(-90deg) rotateX(180deg) translateZ(-60px);
}

.cube__face--front {
    transform: rotateX(180deg) translateZ(-60px);
}

.cube__face--back {
    transform: rotateZ(180deg) translateZ(-60px);
}
.cube__face__face__edge {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;

    line-height: 100px;
    font-size: 25px;
    font-weight: bold;
    color: #7d7d7d;
    text-align: center;
    background: #ddd;
    transition: all 0.2s;
    cursor: pointer;
    user-select: none;
}

.cube__face__face__edge__wrap {
    transform-style: preserve-3d;
}
.cube__face__face__edge__wrap:hover {
    background: #7d7d7d;
    color: #fff;
}

.cube__face--top--left {
    width: 90px;
    height: 15px;
    transform: rotateX(-90deg) rotateZ(90deg) translateZ(97.5px)
        translateY(52.5px);
}
.cube__face--left--top {
    width: 90px;
    height: 15px;
    transform: rotateY(-90deg) rotateX(180deg) translateZ(-60px)
        translateY(-90px);
}
.cube__face--top--right {
    width: 90px;
    height: 15px;
    transform: rotateY(90deg) rotateX(90deg) translateZ(-97.5px)
        translateY(52.5px);
}
.cube__face--right--top {
    width: 90px;
    height: 15px;
    transform: rotateY(-90deg) rotateX(180deg) translateZ(60px)
        translateY(-90px);
}
.cube__face--bottom--left {
    width: 90px;
    height: 15px;
    transform: rotateX(-90deg) rotateZ(90deg) translateZ(-22.5px)
        translateY(52.5px);
}
.cube__face--left--bottom {
    width: 90px;
    height: 15px;
    transform: rotateY(-90deg) rotateX(180deg) translateZ(-60px)
        translateY(15px);
}
.cube__face--bottom--right {
    width: 90px;
    height: 15px;
    transform: rotateY(90deg) rotateX(90deg) translateZ(22.5px)
        translateY(52.5px);
}
.cube__face--right--bottom {
    width: 90px;
    height: 15px;
    transform: rotateY(-90deg) rotateX(180deg) translateZ(60px) translateY(15px);
}
.cube__face--front--bottom {
    width: 90px;
    height: 15px;
    transform: rotateX(180deg) translateZ(-60px) translateY(15px);
}

.cube__face--bottom--front {
    width: 90px;
    height: 15px;
    transform: rotateY(180deg) rotateX(90deg) rotateZ(180deg) translateZ(22.5px)
        translateY(52.5px);
}
.cube__face--back--bottom {
    width: 90px;
    height: 15px;
    transform: translateZ(-60px) translateY(-15px);
}
.cube__face--bottom--back {
    width: 90px;
    height: 15px;
    transform: rotateY(180deg) rotateX(90deg) rotateZ(180deg) translateZ(22.5px)
        translateY(-52.5px);
}
.cube__face--front--top {
    width: 90px;
    height: 15px;
    transform: rotateX(180deg) translateZ(-60px) translateY(-90px);
}
.cube__face--top--front {
    width: 90px;
    height: 15px;
    transform: rotateY(180deg) rotateX(90deg) rotateZ(180deg)
        translateZ(-97.5px) translateY(52.5px);
}

.cube__face--back--top {
    width: 90px;
    height: 15px;
    transform: translateZ(-60px) translateY(90px);
}
.cube__face--top--back {
    width: 90px;
    height: 15px;
    transform: rotateY(180deg) rotateX(90deg) rotateZ(180deg)
        translateZ(-97.5px) translateY(-52.5px);
}

.cube__face--back--left {
    width: 15px;
    height: 90px;
    transform: translateZ(-60px) translateX(90px);
}
.cube__face--left--back {
    width: 15px;
    height: 90px;
    transform: rotateY(-90deg) rotateX(180deg) translateZ(97.5px)
        translateX(-52.5px);
}

.cube__face--back--right {
    width: 15px;
    height: 90px;
    transform: translateZ(-60px) translateX(-15px);
}
.cube__face--right--back {
    width: 15px;
    height: 90px;
    transform: rotateY(90deg) rotateX(180deg) translateZ(22.5px)
        translateX(52.5px);
}

.cube__face--front--right {
    width: 15px;
    height: 90px;
    transform: rotateX(180deg) translateZ(-60px) translateX(90px);
}
.cube__face--right--front {
    width: 15px;
    height: 90px;
    transform: rotateY(90deg) rotateX(180deg) translateZ(-97.5px)
        translateX(-52.5px);
}

.cube__face--front--left {
    width: 15px;
    height: 90px;
    transform: rotateX(180deg) translateZ(-60px) translateX(-15px);
}
.cube__face--left--front {
    width: 15px;
    height: 90px;
    transform: rotateY(-90deg) rotateX(180deg) translateZ(-22.5px)
        translateX(52.5px);
}

.cube__edge--left--front--top {
    width: 15px;
    height: 15px;
    transform: rotateY(-90deg) translateX(52.5px) translateZ(22.5px)
        translateY(90.5px);
}
.cube__edge--front--left--top {
    width: 15px;
    height: 15px;
    transform: translateX(-15px) translateZ(60px) translateY(90.5px);
}
.cube__edge--top--left--front {
    width: 15px;
    height: 15px;
    transform: rotateX(-90deg) translateX(-15px) translateZ(97.5px)
        translateY(-52.5px);
}

.cube__edge--right--front--top {
    width: 15px;
    height: 15px;
    transform: rotateY(-90deg) translateX(52.5px) translateZ(-97.5px)
        translateY(90.5px);
}
.cube__edge--front--right--top {
    width: 15px;
    height: 15px;
    transform: translateX(90px) translateZ(60px) translateY(90.5px);
}
.cube__edge--top--right--front {
    width: 15px;
    height: 15px;
    transform: rotateX(-90deg) translateX(90px) translateZ(97.5px)
        translateY(-52.5px);
}

.cube__edge--back--left--top {
    width: 15px;
    height: 15px;
    transform: rotateY(-90deg) translateX(-52.5px) translateZ(-97.5px)
        translateY(90.5px);
}
.cube__edge--left--back--top {
    width: 15px;
    height: 15px;
    transform: translateX(90px) translateZ(-60px) translateY(90.5px);
}
.cube__edge--top--left--back {
    width: 15px;
    height: 15px;
    transform: rotateX(-90deg) translateX(90px) translateZ(97px)
        translateY(52.5px);
}

.cube__edge--back--right--top {
    width: 15px;
    height: 15px;
    transform: rotateY(-90deg) translateX(-52.5px) translateZ(22.5px)
        translateY(90.5px);
}
.cube__edge--right--back--top {
    width: 15px;
    height: 15px;
    transform: translateX(-15px) translateZ(-60px) translateY(90.5px);
}
.cube__edge--top--right--back {
    width: 15px;
    height: 15px;
    transform: rotateX(-90deg) translateX(-15px) translateZ(98px)
        translateY(52.5px);
}

.cube__edge--left--front--bottom {
    width: 15px;
    height: 15px;
    transform: rotateY(-90deg) translateX(52.5px) translateZ(22.5px)
        translateY(-15px);
}
.cube__edge--front--left--bottom {
    width: 15px;
    height: 15px;
    transform: translateX(-15px) translateZ(60px) translateY(-15px);
}
.cube__edge--bottom--left--front {
    width: 15px;
    height: 15px;
    transform: rotateX(-90deg) translateX(-15px) translateZ(-22.5px)
        translateY(-52.5px);
}

.cube__edge--right--front--bottom {
    width: 15px;
    height: 15px;
    transform: rotateY(-90deg) translateX(52.5px) translateZ(-97px)
        translateY(-15px);
}
.cube__edge--front--right--bottom {
    width: 15px;
    height: 15px;
    transform: translateX(90px) translateZ(60px) translateY(-15px);
}
.cube__edge--bottom--right--front {
    width: 15px;
    height: 15px;
    transform: rotateX(-90deg) translateX(90px) translateZ(-22.5px)
        translateY(-52.5px);
}

.cube__edge--back--left--bottom {
    width: 15px;
    height: 15px;
    transform: rotateY(-90deg) translateX(-52.5px) translateZ(-97px)
        translateY(-15px);
}
.cube__edge--left--back--bottom {
    width: 15px;
    height: 15px;
    transform: translateX(90px) translateZ(-60px) translateY(-15px);
}
.cube__edge--bottom--left--back {
    width: 15px;
    height: 15px;
    transform: rotateX(-90deg) translateX(90px) translateZ(-22.5px)
        translateY(52.5px);
}

.cube__edge--back--right--bottom {
    width: 15px;
    height: 15px;
    transform: rotateY(-90deg) translateX(-52.5px) translateZ(22.5px)
        translateY(-15px);
}
.cube__edge--right--back--bottom {
    width: 15px;
    height: 15px;
    transform: translateX(-15px) translateZ(-60px) translateY(-15px);
}
.cube__edge--bottom--right--back {
    width: 15px;
    height: 15px;
    transform: rotateX(-90deg) translateX(-15px) translateZ(-22.5px)
        translateY(52.5px);
}
`, ""]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 3645:
/***/ ((module) => {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
module.exports = function (cssWithMappingToString) {
  var list = [];

  // return the list of modules as css string
  list.toString = function toString() {
    return this.map(function (item) {
      var content = "";
      var needLayer = typeof item[5] !== "undefined";
      if (item[4]) {
        content += "@supports (".concat(item[4], ") {");
      }
      if (item[2]) {
        content += "@media ".concat(item[2], " {");
      }
      if (needLayer) {
        content += "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {");
      }
      content += cssWithMappingToString(item);
      if (needLayer) {
        content += "}";
      }
      if (item[2]) {
        content += "}";
      }
      if (item[4]) {
        content += "}";
      }
      return content;
    }).join("");
  };

  // import a list of modules into the list
  list.i = function i(modules, media, dedupe, supports, layer) {
    if (typeof modules === "string") {
      modules = [[null, modules, undefined]];
    }
    var alreadyImportedModules = {};
    if (dedupe) {
      for (var k = 0; k < this.length; k++) {
        var id = this[k][0];
        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }
    for (var _k = 0; _k < modules.length; _k++) {
      var item = [].concat(modules[_k]);
      if (dedupe && alreadyImportedModules[item[0]]) {
        continue;
      }
      if (typeof layer !== "undefined") {
        if (typeof item[5] === "undefined") {
          item[5] = layer;
        } else {
          item[1] = "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {").concat(item[1], "}");
          item[5] = layer;
        }
      }
      if (media) {
        if (!item[2]) {
          item[2] = media;
        } else {
          item[1] = "@media ".concat(item[2], " {").concat(item[1], "}");
          item[2] = media;
        }
      }
      if (supports) {
        if (!item[4]) {
          item[4] = "".concat(supports);
        } else {
          item[1] = "@supports (".concat(item[4], ") {").concat(item[1], "}");
          item[4] = supports;
        }
      }
      list.push(item);
    }
  };
  return list;
};

/***/ }),

/***/ 8081:
/***/ ((module) => {

"use strict";


module.exports = function (i) {
  return i[1];
};

/***/ }),

/***/ 324:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_SelectionHelper_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2175);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_dist_cjs_js_SelectionHelper_css__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_node_modules_css_loader_dist_cjs_js_SelectionHelper_css__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z && _node_modules_css_loader_dist_cjs_js_SelectionHelper_css__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z.locals ? _node_modules_css_loader_dist_cjs_js_SelectionHelper_css__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z.locals : undefined);


/***/ }),

/***/ 7586:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_Dimentions_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(305);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_dist_cjs_js_Dimentions_css__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_node_modules_css_loader_dist_cjs_js_Dimentions_css__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z && _node_modules_css_loader_dist_cjs_js_Dimentions_css__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z.locals ? _node_modules_css_loader_dist_cjs_js_Dimentions_css__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z.locals : undefined);


/***/ }),

/***/ 8309:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_navigationCube_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6693);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_dist_cjs_js_navigationCube_css__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_node_modules_css_loader_dist_cjs_js_navigationCube_css__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z && _node_modules_css_loader_dist_cjs_js_navigationCube_css__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z.locals ? _node_modules_css_loader_dist_cjs_js_navigationCube_css__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z.locals : undefined);


/***/ }),

/***/ 3379:
/***/ ((module) => {

"use strict";


var stylesInDOM = [];
function getIndexByIdentifier(identifier) {
  var result = -1;
  for (var i = 0; i < stylesInDOM.length; i++) {
    if (stylesInDOM[i].identifier === identifier) {
      result = i;
      break;
    }
  }
  return result;
}
function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var indexByIdentifier = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3],
      supports: item[4],
      layer: item[5]
    };
    if (indexByIdentifier !== -1) {
      stylesInDOM[indexByIdentifier].references++;
      stylesInDOM[indexByIdentifier].updater(obj);
    } else {
      var updater = addElementStyle(obj, options);
      options.byIndex = i;
      stylesInDOM.splice(i, 0, {
        identifier: identifier,
        updater: updater,
        references: 1
      });
    }
    identifiers.push(identifier);
  }
  return identifiers;
}
function addElementStyle(obj, options) {
  var api = options.domAPI(options);
  api.update(obj);
  var updater = function updater(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
        return;
      }
      api.update(obj = newObj);
    } else {
      api.remove();
    }
  };
  return updater;
}
module.exports = function (list, options) {
  options = options || {};
  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];
    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDOM[index].references--;
    }
    var newLastIdentifiers = modulesToDom(newList, options);
    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];
      var _index = getIndexByIdentifier(_identifier);
      if (stylesInDOM[_index].references === 0) {
        stylesInDOM[_index].updater();
        stylesInDOM.splice(_index, 1);
      }
    }
    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 569:
/***/ ((module) => {

"use strict";


var memo = {};

/* istanbul ignore next  */
function getTarget(target) {
  if (typeof memo[target] === "undefined") {
    var styleTarget = document.querySelector(target);

    // Special case to return head of iframe instead of iframe itself
    if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
      try {
        // This will throw an exception if access to iframe is blocked
        // due to cross-origin restrictions
        styleTarget = styleTarget.contentDocument.head;
      } catch (e) {
        // istanbul ignore next
        styleTarget = null;
      }
    }
    memo[target] = styleTarget;
  }
  return memo[target];
}

/* istanbul ignore next  */
function insertBySelector(insert, style) {
  var target = getTarget(insert);
  if (!target) {
    throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
  }
  target.appendChild(style);
}
module.exports = insertBySelector;

/***/ }),

/***/ 9216:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function insertStyleElement(options) {
  var element = document.createElement("style");
  options.setAttributes(element, options.attributes);
  options.insert(element, options.options);
  return element;
}
module.exports = insertStyleElement;

/***/ }),

/***/ 3565:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce =  true ? __webpack_require__.nc : 0;
  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}
module.exports = setAttributesWithoutAttributes;

/***/ }),

/***/ 7795:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function apply(styleElement, options, obj) {
  var css = "";
  if (obj.supports) {
    css += "@supports (".concat(obj.supports, ") {");
  }
  if (obj.media) {
    css += "@media ".concat(obj.media, " {");
  }
  var needLayer = typeof obj.layer !== "undefined";
  if (needLayer) {
    css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
  }
  css += obj.css;
  if (needLayer) {
    css += "}";
  }
  if (obj.media) {
    css += "}";
  }
  if (obj.supports) {
    css += "}";
  }
  var sourceMap = obj.sourceMap;
  if (sourceMap && typeof btoa !== "undefined") {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  }

  // For old IE
  /* istanbul ignore if  */
  options.styleTagTransform(css, styleElement, options.options);
}
function removeStyleElement(styleElement) {
  // istanbul ignore if
  if (styleElement.parentNode === null) {
    return false;
  }
  styleElement.parentNode.removeChild(styleElement);
}

/* istanbul ignore next  */
function domAPI(options) {
  if (typeof document === "undefined") {
    return {
      update: function update() {},
      remove: function remove() {}
    };
  }
  var styleElement = options.insertStyleElement(options);
  return {
    update: function update(obj) {
      apply(styleElement, options, obj);
    },
    remove: function remove() {
      removeStyleElement(styleElement);
    }
  };
}
module.exports = domAPI;

/***/ }),

/***/ 4589:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function styleTagTransform(css, styleElement) {
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }
    styleElement.appendChild(document.createTextNode(css));
  }
}
module.exports = styleTagTransform;

/***/ }),

/***/ 8896:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Camera = void 0;
const three_1 = __webpack_require__(5232);
class Camera {
    constructor(context, fov, near, far) {
        this.context = context;
        this.lookAt = (target) => {
            this.threeCamera.lookAt(target);
            this.threeCamera.updateProjectionMatrix();
            this.threeCamera.updateMatrixWorld();
        };
        this.setPosition = (position) => {
            this.threeCamera.position.set(position.x, position.y, position.z);
            this.threeCamera.updateProjectionMatrix();
            this.threeCamera.updateMatrixWorld();
        };
        const sizes = this.context.sizes;
        this.threeCamera = new three_1.PerspectiveCamera(fov, sizes.width / sizes.height, near, far);
        this.threeCamera.position.set(15, 15, 15);
        this.threeCamera.updateProjectionMatrix();
        this.threeCamera.updateMatrixWorld();
    }
}
exports.Camera = Camera;


/***/ }),

/***/ 823:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Context = void 0;
const three_1 = __webpack_require__(5232);
const Camera_1 = __webpack_require__(8896);
const Controls_1 = __webpack_require__(3733);
const Sizes_1 = __webpack_require__(1972);
const Environment_1 = __webpack_require__(6586);
const Postproduction_1 = __webpack_require__(1075);
const Renderer_1 = __webpack_require__(1510);
const Scene_1 = __webpack_require__(9746);
class Context {
    constructor(context, settings) {
        this.context = context;
        this.mouse = {
            position: new three_1.Vector2(),
            cords: new three_1.Vector2(),
        };
        this.mouseMoveHandleBind = this.mouseMoveHandle.bind(this);
        this.sizes = new Sizes_1.Sizes(this);
        this.textureLoader = new three_1.TextureLoader();
        this.scene = new Scene_1.Scene(this, settings.useDefaultTexture);
        this.camera = new Camera_1.Camera(this, 45, 0.1, 1000);
        this.scene.threeScene.add(this.camera.threeCamera);
        this.renderer = new Renderer_1.Renderer(this);
        this.domElement = this.renderer.threeRenderer.domElement;
        this.controls = new Controls_1.Controls(this);
        this.environment = new Environment_1.Environment(this);
        this.postproduction = new Postproduction_1.Postproduction(this);
        context.container.appendChild(this.domElement);
        this.domElement.addEventListener("mousemove", this.mouseMoveHandleBind);
        this.clock = new three_1.Clock();
    }
    mouseMoveHandle(event) {
        const bounds = this.context.container.getBoundingClientRect();
        this.mouse.cords.x = event.clientX;
        this.mouse.cords.y = event.clientY;
        this.mouse.position.x =
            ((event.clientX - bounds.left) / (bounds.right - bounds.left)) * 2 -
                1;
        this.mouse.position.y =
            -((event.clientY - bounds.top) / (bounds.bottom - bounds.top)) * 2 +
                1;
    }
    resizeViewer(width, height) {
        if (width)
            this.context.container.style.width = width;
        if (height)
            this.context.container.style.height = height;
        this.sizes.resize();
    }
}
exports.Context = Context;


/***/ }),

/***/ 3733:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Controls = exports.modeEnum = void 0;
const THREE = __webpack_require__(5232);
const camera_controls_1 = __webpack_require__(105);
const DragControls_js_1 = __webpack_require__(3199);
const MW = __webpack_require__(9618);
camera_controls_1.default.install({ THREE: THREE });
exports.modeEnum = {
    Orthographic: 0,
    Perspective: 1,
    "1stPerson": 2,
    "3rdPerson": 3,
};
class Controls {
    get activeMode() {
        return this._activeMode;
    }
    set activeMode(mode) {
        this._activeMode = mode;
        var state = {
            _a: false,
            _s: false,
            _d: false,
            _w: false,
            _up: false,
            _down: false,
            _right: false,
            _left: false,
            _c: false,
            _space: false,
        };
        switch (mode) {
            case "1stPerson":
                try {
                    this.context.controls.cameraControl.lockPointer();
                }
                catch (_b) { }
                this.settings.polarRotateSpeed =
                    this.context.controls.cameraControl.polarRotateSpeed;
                this.settings.azimuthRotateSpeed =
                    this.context.controls.cameraControl.azimuthRotateSpeed;
                this.context.controls.cameraControl.polarRotateSpeed = 0.5;
                this.context.controls.cameraControl.azimuthRotateSpeed = 0.5;
                if (!document)
                    return;
                this._activeModeKeyDownEvents = (e) => {
                    switch (e.code) {
                        case "KeyW":
                            state._w = true;
                            break;
                        case "ArrowUp":
                            state._up = true;
                            break;
                        case "KeyS":
                            state._s = true;
                            break;
                        case "ArrowDown":
                            state._down = true;
                            break;
                        case "KeyA":
                            state._a = true;
                            break;
                        case "ArrowLeft":
                            state._left = true;
                            break;
                        case "KeyD":
                            state._d = true;
                            break;
                        case "ArrowRight":
                            state._right = true;
                            break;
                        case "ShiftLeft":
                            state._c = true;
                            break;
                        case "Space":
                            state._space = true;
                            break;
                    }
                };
                document.addEventListener("keydown", this._activeModeKeyDownEvents);
                this._activeModeKeyUpEvents = (e) => {
                    switch (e.code) {
                        case "KeyW":
                            state._w = false;
                            break;
                        case "ArrowUp":
                            state._up = false;
                            break;
                        case "KeyS":
                            state._s = false;
                            break;
                        case "ArrowDown":
                            state._down = false;
                            break;
                        case "KeyA":
                            state._a = false;
                            break;
                        case "ArrowLeft":
                            state._left = false;
                            break;
                        case "KeyD":
                            state._d = false;
                            break;
                        case "ArrowRight":
                            state._right = false;
                            break;
                        case "ShiftLeft":
                            state._c = false;
                            break;
                        case "Space":
                            state._space = false;
                            break;
                    }
                };
                document.addEventListener("keyup", this._activeModeKeyUpEvents);
                this._activeModeRendererEvent = () => {
                    if (state["_a"]) {
                        this.context.controls.cameraControl.truck(-this.settings.speed / 2, 0);
                    }
                    if (state["_left"]) {
                        this.context.controls.cameraControl.rotateAzimuthTo(this.context.controls.cameraControl.azimuthAngle +
                            this.settings.rotateSpeed);
                    }
                    if (state["_d"]) {
                        this.context.controls.cameraControl.truck(this.settings.speed / 2, 0);
                    }
                    if (state["_right"]) {
                        this.context.controls.cameraControl.rotateAzimuthTo(this.context.controls.cameraControl.azimuthAngle -
                            this.settings.rotateSpeed);
                    }
                    if (state["_w"]) {
                        this.context.controls.cameraControl.dollyInFixed(this.settings.speed);
                    }
                    if (state["_s"]) {
                        this.context.controls.cameraControl.dollyInFixed(-this.settings.speed);
                    }
                    if (state["_up"]) {
                        this.context.controls.cameraControl.rotatePolarTo(this.context.controls.cameraControl.polarAngle +
                            this.settings.upSpeed);
                    }
                    if (state["_down"]) {
                        this.context.controls.cameraControl.rotatePolarTo(this.context.controls.cameraControl.polarAngle -
                            this.settings.upSpeed);
                    }
                    if (state["_c"]) {
                        this.context.controls.cameraControl.truck(0, this.settings.speed / 2);
                    }
                    if (state["_space"]) {
                        this.context.controls.cameraControl.truck(0, -this.settings.speed / 2);
                    }
                };
                this.context.renderer.addCallback(this._activeModeRendererEvent);
                break;
            case "3rdPerson":
                const world = new MW.World();
                const octree = new MW.Octree();
                for (const model of Object.values(this.context.context.models)) {
                    for (const child of model.threeGeometry.children) {
                        const mesh = child;
                        octree.addGraphNode(mesh);
                    }
                }
                const ground = new THREE.Mesh(new THREE.PlaneGeometry(50, 50, 10, 10), new THREE.MeshBasicMaterial({
                    color: "red",
                }));
                ground.traverse((geom) => {
                    console.log(geom);
                });
                this.context.scene.threeScene.add(ground);
                octree.addGraphNode(ground);
                const bb = this.context.context.models[0].boundingBox;
                ground.position.set((bb.max.x + bb.min.x) / 2, bb.min.y, (bb.max.z + bb.min.z) / 2);
                ground.rotation.x = -90 * THREE.MathUtils.DEG2RAD;
                world.add(octree);
                const playerObjectHolder = new THREE.Object3D();
                this.context.scene.threeScene.add(playerObjectHolder);
                const sphere = new THREE.Mesh(new THREE.SphereGeometry(0.75, 16, 16), new THREE.MeshBasicMaterial({
                    color: 0xff0000,
                    wireframe: true,
                }));
                sphere.position.y = 0.75;
                playerObjectHolder.add(sphere);
                const playerController = new MW.CharacterController(playerObjectHolder, 0.75);
                playerController.teleport(0, 10, 0);
                world.add(playerController);
                const keyInputControl = new MW.KeyInputControl();
                const tpsCameraControls = new MW.TPSCameraControls(this.context.camera.threeCamera, playerObjectHolder, world, this.context.renderer.threeRenderer.domElement);
                keyInputControl.addEventListener("movekeyon", () => (playerController.isRunning = true));
                keyInputControl.addEventListener("movekeyoff", () => (playerController.isRunning = false));
                keyInputControl.addEventListener("jumpkeypress", () => playerController.jump());
                keyInputControl.addEventListener("movekeychange", () => {
                    const cameraFrontAngle = tpsCameraControls.frontAngle;
                    const characterFrontAngle = keyInputControl.frontAngle;
                    playerController.direction =
                        cameraFrontAngle + characterFrontAngle;
                });
                tpsCameraControls.addEventListener("update", () => {
                    if (!playerController.isRunning)
                        return;
                    const cameraFrontAngle = tpsCameraControls.frontAngle;
                    const characterFrontAngle = keyInputControl.frontAngle;
                    playerController.direction =
                        cameraFrontAngle + characterFrontAngle;
                });
                this.context.renderer.addCallback(() => {
                    const delta = this.context.context.context.clock.getDelta();
                    world.fixedUpdate();
                    tpsCameraControls.update(delta);
                });
                break;
            case "Orthographic":
                try {
                    this.context.controls.cameraControl.unlockPointer();
                }
                catch (_e) { }
                this.context.controls.cameraControl.polarRotateSpeed =
                    this.settings.polarRotateSpeed;
                this.context.controls.cameraControl.azimuthRotateSpeed =
                    this.settings.polarRotateSpeed;
                this._activeModeKeyDownEvents &&
                    document.removeEventListener("keydown", this._activeModeKeyDownEvents);
                this._activeModeKeyUpEvents &&
                    document.removeEventListener("keyup", this._activeModeKeyUpEvents);
                this._activeModeRendererEvent &&
                    this.context.renderer.removeCallback(this._activeModeRendererEvent);
                break;
            case "Perspective":
                try {
                    this.context.controls.cameraControl.unlockPointer();
                }
                catch (_f) { }
                this.context.controls.cameraControl.polarRotateSpeed =
                    this.settings.polarRotateSpeed;
                this.context.controls.cameraControl.azimuthRotateSpeed =
                    this.settings.polarRotateSpeed;
                this._activeModeKeyDownEvents &&
                    document.removeEventListener("keydown", this._activeModeKeyDownEvents);
                this._activeModeKeyUpEvents &&
                    document.removeEventListener("keyup", this._activeModeKeyUpEvents);
                this._activeModeRendererEvent &&
                    this.context.renderer.removeCallback(this._activeModeRendererEvent);
                break;
        }
    }
    constructor(context) {
        this.context = context;
        this._moving = false;
        this._position = new THREE.Vector3();
        this.settings = {
            speed: 0.05,
            rotateSpeed: 0.001,
            upSpeed: 0.001,
            polarRotateSpeed: 1,
            azimuthRotateSpeed: 0.6,
        };
        this.createDragControl = (objects) => {
            return new DragControls_js_1.DragControls(objects, this.context.camera.threeCamera, this.context.domElement);
        };
        this.getIntersects = (objects = Object.values(this.context.context.selector.selectorModels).flat()) => {
            const intersects = [];
            for (const object of objects) {
                this.getIntersect(object).forEach((p) => intersects.push(p));
            }
            return intersects.sort((a, b) => a.distance - b.distance);
        };
        this.onControl = this._onControl.bind(this);
        this._activeMode = "Orthographic";
        this.cameraControl = new camera_controls_1.default(this.context.camera.threeCamera, this.context.domElement);
        this.cameraControl.truckSpeed = 1.3;
        this.cameraControl.dollySpeed = 0.6;
        this.cameraControl.azimuthRotateSpeed = 0.6;
        this.cameraControl.draggingSmoothTime = 0.05;
        this.cameraControl.smoothTime = 0.1;
        this.cameraControl.dollyToCursor = true;
        this.cameraControl.infinityDolly = true;
        this.cameraControl.minDistance = 3;
        this.raycaster = new THREE.Raycaster();
        this.addEvents();
    }
    get moving() {
        return this._moving;
    }
    set moving(moving) {
        this._moving = moving;
    }
    getIntersect(object) {
        const mesh = object;
        if (!mesh) {
            return [];
        }
        if (mesh.geometry.boundsTree) {
            let intersect = mesh.geometry.boundsTree.raycast(this.context.context.context.controls.raycaster.ray, this.context.context.selector.useDoubleSideMaterial
                ? THREE.DoubleSide
                : THREE.FrontSide);
            return intersect
                .map((p) => {
                p.object = mesh;
                return p;
            })
                .filter((p) => this.checkIntersect(p));
        }
        else {
            const intersects = this.raycaster.intersectObjects([object]);
            return intersects.filter((p) => this.checkIntersect(p));
        }
    }
    checkIntersect(intersect) {
        const clipper = this.context.context.utils.clippingUtils;
        if (clipper.active && clipper.planes.length) {
            let flag = true;
            for (const plane of clipper.planes) {
                if (plane.distanceToPoint(intersect.point) <= 0) {
                    flag = false;
                    break;
                }
            }
            return flag;
        }
        return true;
    }
    addEvents() {
        this.cameraControl.addEventListener("controlstart", () => {
            this.cameraControl.getPosition(this._position);
            this.cameraControl.addEventListener("control", this.onControl);
        });
        this.cameraControl.addEventListener("controlend", () => {
            if (this.cameraControl.enabled) {
                setTimeout(() => {
                    this._moving = false;
                }, 10);
            }
            this.cameraControl.removeEventListener("control", this.onControl);
        });
    }
    _onControl() {
        if (!this._moving) {
            const pos = new THREE.Vector3();
            this.cameraControl.getPosition(pos);
            if (pos.distanceTo(this._position) > 0.1) {
                this._moving = true;
            }
        }
    }
    setOrbitByClick() {
        const intersect = this.context.context.selector.preSelection.preSelectElement;
        if (intersect) {
            this.cameraControl.setOrbitPoint(intersect.point.x, intersect.point.y, intersect.point.z);
        }
    }
    setOrbitByTarget(target) {
        this.cameraControl.setOrbitPoint(target.x, target.y, target.z);
    }
}
exports.Controls = Controls;


/***/ }),

/***/ 1972:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Sizes = void 0;
const three_1 = __webpack_require__(5232);
class Sizes {
    constructor(context) {
        this.context = context;
        this.modelSize = new three_1.Box3();
        this.width = context.context.container.offsetWidth;
        this.height = context.context.container.offsetHeight;
        window.addEventListener("resize", this.resize.bind(this));
    }
    resize() {
        this.width = this.context.context.container.offsetWidth;
        this.height = this.context.context.container.offsetHeight;
        this.context.renderer.resize();
    }
}
exports.Sizes = Sizes;


/***/ }),

/***/ 6586:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Environment = void 0;
const three_1 = __webpack_require__(5232);
class Environment {
    constructor(context) {
        this.context = context;
        this.lights = new Lights(this);
    }
}
exports.Environment = Environment;
class Lights {
    constructor(context) {
        this.context = context;
        this.ambientLight = new three_1.AmbientLight(0xffffff, 1.2);
        this.directionalLight1 = new three_1.DirectionalLight(0xffffff, 2);
        this.directionalLight2 = new three_1.DirectionalLight(0xffffff, 2);
        const target = new three_1.Vector3();
        this.context.context.controls.cameraControl.getTarget(target);
        this.directionalLight1.lookAt(target);
        this.directionalLight2.lookAt(target);
        this.context.context.scene.threeScene.add(this.ambientLight);
        this.context.context.scene.threeScene.add(this.directionalLight1);
        this.context.context.scene.threeScene.add(this.directionalLight2);
    }
    updateLightPosition(box) {
        const max = box.max;
        const min = box.min;
        this.directionalLight1.position.set(max.x * 1.3, max.y + 10, max.z * 1.3);
        this.directionalLight2.position.set(min.x * 1.3, max.y + 10, min.z * 1.3);
        const sceneCenter = new three_1.Vector3();
        box.getCenter(sceneCenter);
        this.directionalLight1.lookAt(sceneCenter);
        this.directionalLight2.lookAt(sceneCenter);
    }
}


/***/ }),

/***/ 1075:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Postproduction = void 0;
const three_1 = __webpack_require__(5232);
class Postproduction {
    constructor(context) {
        this.context = context;
        this._castShadow = false;
    }
    set castShadow(castShadow) {
        this._castShadow = castShadow;
        if (this.context.context.models) {
            this.context.environment.lights.directionalLight1.castShadow =
                castShadow;
            this.context.renderer.threeRenderer.shadowMap.enabled = castShadow;
            const points = [];
            for (const model of Object.values(this.context.context.models)) {
                model.threeGeometry.children.forEach((ch) => {
                    ch.castShadow = castShadow;
                    ch.receiveShadow = castShadow;
                });
                points.push(model.boundingBox.max, model.boundingBox.min);
            }
            const fullBox = new three_1.Box3();
            fullBox.setFromPoints(points);
            const L = fullBox.min.distanceTo(fullBox.max) / 2 + 10;
            this.context.environment.lights.directionalLight1.shadow.mapSize.set(2048, 2048);
            this.context.environment.lights.directionalLight1.shadow.normalBias = 2;
            this.context.environment.lights.directionalLight1.shadow.camera.left =
                -L;
            this.context.environment.lights.directionalLight1.shadow.camera.bottom =
                -L;
            this.context.environment.lights.directionalLight1.shadow.camera.right =
                L;
            this.context.environment.lights.directionalLight1.shadow.camera.top =
                L;
            setTimeout(() => {
                const cameraPos = this.context.environment.lights.directionalLight1.shadow
                    .camera.position;
                this.context.environment.lights.directionalLight1.shadow.camera.near =
                    cameraPos.distanceTo(fullBox.max) - L / 2;
                this.context.environment.lights.directionalLight1.shadow.camera.far =
                    cameraPos.distanceTo(fullBox.min) + L / 2;
            }, 50);
        }
    }
}
exports.Postproduction = Postproduction;


/***/ }),

/***/ 1510:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Renderer = void 0;
const three_1 = __webpack_require__(5232);
const CSS2DRenderer_js_1 = __webpack_require__(1764);
const CSS3DRenderer_js_1 = __webpack_require__(9471);
class Renderer {
    constructor(context) {
        this.context = context;
        this.animationCallbackList = [];
        this.clock = new three_1.Clock();
        this.needUpdate = true;
        this.threeRenderer = new three_1.WebGLRenderer({
            powerPreference: "high-performance",
            logarithmicDepthBuffer: true,
            antialias: true,
            alpha: true,
        });
        this.threeRenderer2D = new CSS2DRenderer_js_1.CSS2DRenderer();
        this.threeRenderer2D.domElement.style.position = "absolute";
        this.threeRenderer2D.domElement.style.top = "0px";
        this.threeRenderer2D.domElement.style.pointerEvents = "none";
        context.context.container.appendChild(this.threeRenderer2D.domElement);
        this.threeRenderer3D = new CSS3DRenderer_js_1.CSS3DRenderer();
        this.threeRenderer3D.domElement.style.position = "absolute";
        this.threeRenderer3D.domElement.style.top = "0px";
        this.threeRenderer3D.domElement.style.pointerEvents = "none";
        context.context.container.appendChild(this.threeRenderer3D.domElement);
        this.resize();
        this.animation();
        this.threeRenderer.setPixelRatio(window.devicePixelRatio);
        this.threeRenderer.outputColorSpace = three_1.SRGBColorSpace;
        this.threeRenderer.setClearColor(0x000000, 0);
    }
    newScreenshot(camera) {
        const domElement = this.context.domElement;
        const tempCanvas = domElement.cloneNode(true);
        const tempRenderer = new three_1.WebGLRenderer({
            canvas: tempCanvas,
            logarithmicDepthBuffer: true,
            antialias: true,
            alpha: true,
        });
        tempRenderer.localClippingEnabled = true;
        const scene = this.context.scene.threeScene;
        const cameraToRender = camera || this.context.camera.threeCamera;
        tempRenderer.render(scene, cameraToRender);
        const result = tempRenderer.domElement.toDataURL();
        tempRenderer.dispose();
        return result;
    }
    resize() {
        this.threeRenderer.setSize(this.context.sizes.width, this.context.sizes.height);
        this.threeRenderer2D.setSize(this.context.sizes.width, this.context.sizes.height);
        this.threeRenderer3D.setSize(this.context.sizes.width, this.context.sizes.height);
        if (this.context.camera.threeCamera instanceof three_1.PerspectiveCamera) {
            this.context.camera.threeCamera.aspect =
                this.context.sizes.width / this.context.sizes.height;
        }
        this.threeRenderer.setPixelRatio(window.devicePixelRatio);
        this.context.camera.threeCamera.updateProjectionMatrix();
    }
    animation() {
        var _a, _b;
        requestAnimationFrame(() => {
            this.animation();
        });
        if ((_a = this.context.context.utils) === null || _a === void 0 ? void 0 : _a.stats) {
            this.context.context.utils.stats.begin();
        }
        if (this.needUpdate && this.context.controls && this.context.mouse) {
            this.context.controls.raycaster.setFromCamera(this.context.mouse.position, this.context.camera.threeCamera);
        }
        for (const callback of this.animationCallbackList) {
            callback();
        }
        const delta = this.clock.getDelta();
        if (this.context.controls) {
            const hasControlsUpdated = this.context.controls.cameraControl.update(delta);
        }
        if (this.needUpdate) {
            this.render();
        }
        if ((_b = this.context.context.utils) === null || _b === void 0 ? void 0 : _b.stats) {
            this.context.context.utils.stats.end();
        }
    }
    addCallback(callback) {
        this.animationCallbackList.push(callback);
    }
    removeCallback(callback) {
        this.animationCallbackList = this.animationCallbackList.filter((f) => f !== callback);
    }
    render() {
        this.threeRenderer.render(this.context.scene.threeScene, this.context.camera.threeCamera);
        this.threeRenderer2D.render(this.context.scene.threeScene, this.context.camera.threeCamera);
        this.threeRenderer3D.render(this.context.scene.threeScene, this.context.camera.threeCamera);
    }
}
exports.Renderer = Renderer;


/***/ }),

/***/ 9746:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Scene = void 0;
const THREE = __webpack_require__(5232);
class Scene {
    constructor(context, useDefaultTexture = true) {
        this.context = context;
        this.threeScene = new THREE.Scene();
        if (useDefaultTexture) {
            this.context.textureLoader.load("Resources/scene_bg.jpg", (texture) => {
                this.threeScene.background = texture;
            });
        }
    }
}
exports.Scene = Scene;


/***/ }),

/***/ 2828:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BMTConverter = void 0;
const Model_1 = __webpack_require__(6118);
const __1 = __webpack_require__(713);
class BMTConverter {
    constructor(context) {
        this.context = context;
    }
    convertIfcToBmt(data, useMinVersion) {
        return __awaiter(this, void 0, void 0, function* () {
            const start = Date.now();
            console.log("start converting");
            const { propsData, group, structure } = yield this.context.ifcLoader.getModelDataFromBuffer(data);
            return yield this.exportBMT({
                propsData,
                group,
                structure,
                start,
                minVersion: useMinVersion,
            });
        });
    }
    jsonStringifySync(data) {
        return new Promise((resolve) => {
            resolve(JSON.stringify(data));
        });
    }
    exportIfcModel(modelID, activeView, minVersion, fileName) {
        return __awaiter(this, void 0, void 0, function* () {
            const start = Date.now();
            yield this.exportBMT({
                modelID,
                activeView,
                minVersion,
                start,
                fileName,
            });
        });
    }
    exportBMT(config) {
        return __awaiter(this, void 0, void 0, function* () {
            const minVersion = config.minVersion;
            const activeView = config.activeView;
            if (!config.fileName) {
                config.fileName = "file";
            }
            const model = config.modelID !== undefined &&
                this.context.context instanceof __1.default
                ? this.context.context.models[config.modelID]
                : {
                    properties: {
                        data: config.propsData,
                        structure: config.structure,
                    },
                    threeGeometry: config.group,
                };
            const blobArr = [];
            var enc = new TextEncoder();
            const settingsData = {};
            if (!minVersion) {
                const elementIds = Object.keys(model.properties.data);
                let i = 0;
                for (const key of elementIds) {
                    const data = model.properties.data[Number(key)];
                    const data_str = yield this.jsonStringifySync(data);
                    const encData = this.context.context.utils.decoder.deflate(enc.encode(data_str));
                    blobArr.push(new Uint8Array(new Uint32Array([encData.length]).buffer));
                    blobArr.push(encData);
                    i += encData.length + 4;
                }
                settingsData["props"] = i;
            }
            if (this.context.context.loaders.coordinationMatrix) {
                settingsData["matrix"] = JSON.stringify(this.context.context.loaders.coordinationMatrix.toArray());
            }
            const state = model instanceof Model_1.Model ? model.defaultState : undefined;
            const decodedPos = [];
            for (const child of model.threeGeometry.children) {
                const mesh = child;
                const posArr = mesh.geometry.attributes.position;
                const idsArr = mesh.geometry.attributes.ids;
                const posArrDec = this.context.context.utils.decoder.deflate(new Uint8Array(posArr.array.buffer));
                const idsPosDec = this.context.context.utils.decoder.deflate(new Uint8Array(idsArr.array.buffer));
                const ind = activeView || !state
                    ? mesh.geometry.index.array
                    : state.indMap[Number(mesh.name)];
                const indPosDec = this.context.context.utils.decoder.deflate(new Uint8Array(new Uint32Array(ind).buffer));
                decodedPos.push(posArrDec, idsPosDec, indPosDec);
                const color = mesh.material.color;
                const opasity = mesh.material.opacity;
                const colorId = `[${Math.round(color.r * 255)},${Math.round(color.g * 255)},${Math.round(color.b * 255)},${opasity},${mesh.name}]`;
                settingsData[colorId] = [
                    posArrDec.length,
                    idsPosDec.length,
                    indPosDec.length,
                ];
            }
            const settingsData_str = JSON.stringify(settingsData);
            blobArr.unshift(enc.encode(settingsData_str));
            for (const posArr of decodedPos) {
                blobArr.push(posArr);
            }
            if (!minVersion) {
                const structure = model.properties.structure;
                const structure_str = yield this.jsonStringifySync(structure);
                const encStructureData = this.context.context.utils.decoder.deflate(enc.encode(structure_str));
                blobArr.push(encStructureData);
            }
            let json;
            if (minVersion) {
                json = yield this.jsonStringifySync({
                    props: model.properties.data,
                    structure: model.properties.structure,
                });
            }
            console.log("optimizing: ", Date.now() - config.start);
            return { data: blobArr, props: json };
        });
    }
}
exports.BMTConverter = BMTConverter;


/***/ }),

/***/ 8744:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BMTLoader = void 0;
const three_1 = __webpack_require__(5232);
const Model_1 = __webpack_require__(6118);
const decoder_1 = __webpack_require__(730);
const __1 = __webpack_require__(713);
class BMTLoader {
    constructor(context) {
        this.context = context;
        this.curMatrix = new three_1.Matrix4();
    }
    streamToBlob(data, start) {
        return __awaiter(this, void 0, void 0, function* () {
            const ds = new DecompressionStream("gzip");
            const stream = data.stream().pipeThrough(ds);
            const reader = stream.getReader();
            let done = false;
            const resData = [];
            while (!done) {
                const result = yield reader.read();
                done = result.done;
                if (result.value) {
                    resData.push(result.value);
                }
            }
            return new Blob(resData);
        });
    }
    loadModel(path, fitToView) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.context.context instanceof __1.BimatterConverter) {
                return;
            }
            const response = yield fetch(path);
            const data = yield response.blob();
            const start = Date.now();
            console.log("Parsing BMT model");
            try {
                const buffer = yield data.arrayBuffer();
                let data2 = new Uint8Array(buffer);
                if (!data2)
                    throw new Error("wrong input data");
                if (typeof data2 === "string")
                    throw new Error(data2);
                const modelIds = Object.keys(this.context.context.models).map((p) => Number(p));
                const modelID = modelIds.length ? Math.max(...modelIds) + 1 : 0;
                if (this.context.context.utils.stats) {
                    console.log("decoding:", Date.now() - start, "ms");
                }
                let modelData = yield this.parseBinaryFile(data2, start);
                if (this.context.context.utils.stats) {
                    console.log("parsing file:", Date.now() - start, "ms");
                }
                const [group, idsState, indState, defIdsState, defIndState] = this.parseModelData(modelData[1]);
                if (this.context.context.utils.stats) {
                    console.log("parsing geometry:", Date.now() - start, "ms");
                }
                const model = new Model_1.Model(this.context.context, modelID, fitToView, group, modelData[0], modelData[2], indState, idsState, defIndState, defIdsState, start);
                console.log(`Loaded by ${Date.now() - start} ms`);
                return model;
            }
            catch (e) {
                console.log(e);
                throw new Error(e);
            }
        });
    }
    parseBinaryFile(data, start) {
        return __awaiter(this, void 0, void 0, function* () {
            let flag = false;
            let i = 0;
            let j = 0;
            let m = 0;
            const textDecoder = new TextDecoder("utf-8");
            const settingsStart = data.indexOf(123);
            const settingsEnd = data.indexOf(125);
            const settingsPart = data.subarray(settingsStart, settingsEnd + 1);
            const settings = JSON.parse(textDecoder.decode(settingsPart));
            const propsCount = settings["props"];
            delete settings["props"];
            const matrix = settings["matrix"];
            if (matrix) {
                delete settings["matrix"];
                const matrixArr = JSON.parse(matrix);
                this.curMatrix = new three_1.Matrix4().fromArray(matrixArr).invert();
                if (!this.context.coordinationMatrix) {
                    this.context.coordinationMatrix = this.curMatrix
                        .clone()
                        .invert();
                }
            }
            let curStart = settingsEnd + 1;
            const propsData = {};
            let offset = 0;
            const propStart = curStart;
            while (curStart < propStart + propsCount) {
                const curCount = Array.from(new Uint32Array(new Uint8Array(data.subarray(curStart, curStart + 4)).buffer))[0];
                const curPropData = decoder_1.default.ungzip(data.subarray(curStart + 4, curStart + 4 + curCount));
                const prop = JSON.parse(textDecoder.decode(curPropData));
                propsData[prop.id] = prop;
                curStart += 4 + curCount;
            }
            const posData = {};
            for (const matId of Object.keys(settings)) {
                const [posCount, idsCount, indCount] = settings[matId];
                const posStart = curStart;
                const posEnd = posStart + posCount;
                const idsStart = posEnd;
                const idsEnd = idsStart + idsCount;
                const indStart = idsEnd;
                const indEnd = indStart + indCount;
                const subPos = data.subarray(posStart, posEnd);
                const subIds = data.subarray(idsStart, idsEnd);
                const subInd = data.subarray(indStart, indEnd);
                const posArr = new Float32Array(new Uint8Array(decoder_1.default.ungzip(subPos)).buffer);
                const idsArr = new Uint32Array(new Uint8Array(decoder_1.default.ungzip(subIds)).buffer);
                const indArr = Array.from(new Uint32Array(new Uint8Array(decoder_1.default.ungzip(subInd)).buffer));
                const curData = [posArr, idsArr];
                posData[matId] = curData;
                if (indArr && indArr.length) {
                    curData.push(indArr);
                }
                curStart = indEnd;
            }
            const endPart = data.subarray(curStart);
            let structure = { id: 1, type: "none", children: [] };
            if (endPart.length) {
                const curStructureData = decoder_1.default.ungzip(endPart);
                structure = JSON.parse(textDecoder.decode(curStructureData));
            }
            return [propsData, posData, structure];
        });
    }
    parseModelData(modelData) {
        const group = new three_1.Group();
        const idsState = {};
        const indState = {};
        const defIdsState = {};
        const defIndState = {};
        let matId = 0;
        for (const matData_str of Object.keys(modelData)) {
            let matData;
            let chunkName = matId.toString();
            let opacity;
            try {
                matData = JSON.parse(matData_str);
                if (matData_str.includes(".")) {
                    opacity = matData[3];
                    chunkName = matData[4];
                }
                else {
                    opacity = matData[4]
                        ? `${matData[3]}.${matData[4]}`
                        : matData[3];
                }
            }
            catch (_a) {
                const splited = matData_str
                    .substring(1, matData_str.length - 1)
                    .split(",");
                if (splited.length === 5) {
                    matData = [
                        Number(splited[0]),
                        Number(splited[1]),
                        Number(splited[2]),
                        Number(splited[3]),
                        Number(splited[4]),
                    ];
                }
                else {
                    matData = [125, 125, 125, 1, 0];
                }
                opacity = matData[4]
                    ? `${matData[3]}.${matData[4]}`
                    : matData[3];
            }
            const chunkData = modelData[matData_str];
            const curMaterial = new three_1.MeshLambertMaterial({
                color: new three_1.Color(matData[0] / 255, matData[1] / 255, matData[2] / 255),
                transparent: Number(opacity) < 1,
                opacity: Number(opacity),
                premultipliedAlpha: true,
                name: chunkName,
                side: three_1.DoubleSide,
            });
            const geom = new three_1.BufferGeometry();
            geom.setAttribute("position", new three_1.BufferAttribute(chunkData[0], 3));
            geom.setAttribute("ids", new three_1.BufferAttribute(chunkData[1], 1));
            let indexArr;
            if (chunkData[2]) {
                indexArr = chunkData[2];
            }
            else {
                indexArr = Array.from(Array(chunkData[1].length).keys());
            }
            indState[chunkName] = new Uint32Array(indexArr);
            defIndState[chunkName] = new Uint32Array(indexArr);
            geom.setIndex(indexArr);
            geom.computeVertexNormals();
            geom.computeBoundingBox();
            const idsAttr = geom.attributes.ids;
            const indAttr = geom.index;
            for (let i = 0; i < (indAttr ? indAttr.count : idsAttr.count); i++) {
                const index = indAttr ? indAttr.getX(i) : i;
                const element = idsAttr.getX(index);
                const elData = idsState[element];
                if (elData) {
                    const elMatData = elData[chunkName];
                    if (elMatData) {
                        elMatData.push(index);
                        defIdsState[element][chunkName].push(index);
                    }
                    else {
                        elData[chunkName] = [index];
                        defIdsState[element][chunkName] = [index];
                    }
                }
                else {
                    idsState[element] = { [chunkName]: [index] };
                    defIdsState[element] = { [chunkName]: [index] };
                }
            }
            if (this.context.context instanceof __1.default &&
                Object.keys(this.context.context.models).length &&
                this.context.coordinationMatrix) {
                geom.applyMatrix4(this.curMatrix);
                geom.applyMatrix4(this.context.coordinationMatrix);
            }
            const mesh = new three_1.Mesh(geom, curMaterial);
            mesh.name = chunkName.toString();
            group.add(mesh);
            matId++;
        }
        return [group, idsState, indState, defIdsState, defIndState];
    }
}
exports.BMTLoader = BMTLoader;


/***/ }),

/***/ 4686:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.IfcParser = exports.IFCLoader = void 0;
const Model_1 = __webpack_require__(6118);
const BufferGeometryUtils_1 = __webpack_require__(140);
const PropertySerializer_1 = __webpack_require__(3262);
const three_1 = __webpack_require__(5232);
const web_ifc_api_node_1 = __webpack_require__(829);
const __1 = __webpack_require__(713);
class IFCLoader {
    constructor(context) {
        this.context = context;
        this._wasmPath = "./";
        this.chunk = 1000;
        this.curModelId = -1;
        this.parser = new web_ifc_api_node_1.IfcAPI();
        this.parser.SetWasmPath(this._wasmPath, false);
        this.propertySerializer = new PropertySerializer_1.PropertySerializer(this);
    }
    getPath(path, dir) {
        return "ifc-parser.wasm";
    }
    initParser(func) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.parser.Init(func);
            this.parser.SetLogLevel(4);
        });
    }
    set wasmPath(path) {
        this._wasmPath = path;
    }
    get _parser() {
        return this.parser;
    }
    set _parser(parser) {
        this.parser = parser;
    }
    loadModel(path, fitToView, onLoadCallback) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.context.context instanceof __1.BimatterConverter) {
                return;
            }
            yield this.initParser(this.getPath);
            this.context.loadingProgressUtils.setOnLoadCallback(onLoadCallback);
            const startTime = Date.now();
            const { structure, propsData, group, modelID } = yield this.getModelData(path);
            this.context.loadingProgressUtils.initializeLoadingState("Preparing...", 0);
            const model = new Model_1.Model(this.context.context, modelID, fitToView, group, propsData, structure, undefined, undefined, undefined, undefined, startTime);
            console.log(`Loaded by ${Date.now() - startTime} ms`);
            return model;
        });
    }
    getModelData(path) {
        return new Promise((resolve, reject) => {
            fetch(path)
                .then((response) => response.arrayBuffer())
                .then((file) => __awaiter(this, void 0, void 0, function* () {
                if (this.parser) {
                    const res = yield this.getModelDataFromBuffer(file);
                    resolve(res);
                }
                reject("model loading error");
            }))
                .catch((e) => {
                console.log(e);
                reject("model loading error");
            });
        });
    }
    getModelDataFromBuffer(file) {
        return __awaiter(this, void 0, void 0, function* () {
            const start = Date.now();
            let ifcModelID = -1;
            try {
                ifcModelID = this.parser.OpenModel(new Uint8Array(file), {
                    COORDINATE_TO_ORIGIN: !this.context.coordinationMatrix,
                    OPTIMIZE_PROFILES: true,
                    USE_FAST_BOOLS: true,
                });
            }
            catch (e) {
                console.log(e);
            }
            console.log("spend to read ifc file: ", Date.now() - start, "ms");
            if (ifcModelID === -1) {
                console.error("Model loading error");
            }
            if (this.context.coordinationMatrix) {
                this.parser.SetGeometryTransformation(ifcModelID, this.context.coordinationMatrix.toArray());
            }
            const ifcParser = new IfcParser(this.parser, ifcModelID, this.context.loadingProgressUtils);
            const schema = this.parser.GetModelSchema(ifcModelID);
            console.log("Parsing", schema, "model");
            const allIds = new Set();
            const group = ifcParser.parseData(allIds);
            const modelIds = Object.keys(this.context.context.models).map((p) => Number(p));
            const modelID = modelIds.length ? Math.max(...modelIds) + 1 : 0;
            const propsData = yield this.propertySerializer.serializeAllProperties(ifcModelID, allIds);
            const structure = yield this.propertySerializer.getSpatialStructure(ifcModelID, false);
            if (!this.context.coordinationMatrix) {
                const matrixArr = this.parser.GetCoordinationMatrix(ifcModelID);
                const matrix = new three_1.Matrix4().fromArray(matrixArr);
                this.context.coordinationMatrix = matrix;
            }
            this.parser.CloseModel(ifcModelID);
            return { structure, propsData, group, modelID };
        });
    }
}
exports.IFCLoader = IFCLoader;
class IfcParser {
    constructor(parser, ifcModelID, progressUtils) {
        this.parser = parser;
        this.ifcModelID = ifcModelID;
        this.progressUtils = progressUtils;
        this.materials = {};
    }
    parseData(allIds) {
        var _a, _b, _c, _d;
        const matMap = new Map();
        const group = new three_1.Group();
        const shapes = this.parser.GetLineIDsWithType(this.ifcModelID, web_ifc_api_node_1.IFCPRODUCTDEFINITIONSHAPE);
        (_a = this.progressUtils) === null || _a === void 0 ? void 0 : _a.initializeLoadingState("Parsing geometry", shapes.size());
        this.parser.StreamAllMeshes(this.ifcModelID, (mesh) => {
            var _a;
            const placedGeometries = mesh.geometries;
            (_a = this.progressUtils) === null || _a === void 0 ? void 0 : _a.updateLoadingState("Parsing geometry");
            let stateIndexOffset = 0;
            const state = {};
            for (let i = 0; i < placedGeometries.size(); i++) {
                const placedGeometry = placedGeometries.get(i);
                const [placedMesh, material] = this.getPlacedGeometry(placedGeometry, mesh.expressID);
                let geometry = placedMesh.geometry.applyMatrix4(placedMesh.matrix);
                allIds.add(mesh.expressID);
                if (matMap.has(material.name)) {
                    matMap.get(material.name).push(geometry);
                }
                else {
                    matMap.set(material.name, [geometry]);
                }
            }
        });
        (_b = this.progressUtils) === null || _b === void 0 ? void 0 : _b.endLoading("Parsing geometry");
        (_c = this.progressUtils) === null || _c === void 0 ? void 0 : _c.initializeLoadingState("Building geometry", matMap.size);
        let materialId = 0;
        matMap.forEach((geomArr, matId) => {
            var _a;
            function addGeom(geom, material) {
                geom.computeBoundingBox();
                geom.computeBoundingSphere();
                const mesh = new three_1.Mesh(geom, material);
                mesh.name = materialId.toString();
                group.add(mesh);
            }
            function mergeGeom(arr, material) {
                const geom = (0, BufferGeometryUtils_1.mergeGeometries)(arr);
                geom.computeBoundingBox();
                geom.computeBoundingSphere();
                const mesh = new three_1.Mesh(geom, material);
                mesh.name = materialId.toString();
                group.add(mesh);
            }
            function getGeomByChuncks(materials, div = 2) {
                console.log(`try to slice geom arr with ${geomArr.length} geoms`);
                let tryIter = 0;
                let chunkDiv = div;
                let curArr = geomArr;
                let successed = 0;
                while (true) {
                    console.log("try to slice geom arr with div ", chunkDiv);
                    let check = true;
                    const chunk = Math.floor(curArr.length / chunkDiv);
                    let endIndex = 0;
                    for (let i = 0; i < curArr.length; i += chunk) {
                        try {
                            const cChunk = curArr.slice(i, i + chunk);
                            console.log(cChunk.length);
                            if (cChunk.length === 1) {
                                addGeom(cChunk[0], materials[matId]);
                            }
                            else {
                                mergeGeom(cChunk, materials[matId]);
                            }
                            endIndex = i + chunk;
                            materialId++;
                            successed += cChunk.length;
                        }
                        catch (_a) {
                            check = false;
                            break;
                        }
                    }
                    if (check) {
                        console.log(`slice geom arr success ${successed} geoms`);
                        break;
                    }
                    else {
                        curArr = curArr.slice(endIndex);
                    }
                    tryIter++;
                    chunkDiv *= 4;
                    if (tryIter > 20) {
                        console.error("tryIter > 10");
                        break;
                    }
                }
            }
            try {
                mergeGeom(geomArr, this.materials[matId]);
                materialId++;
            }
            catch (_b) {
                getGeomByChuncks(this.materials);
            }
            geomArr.forEach((geom) => {
                geom.dispose();
            });
            (_a = this.progressUtils) === null || _a === void 0 ? void 0 : _a.updateLoadingState("Building geometry");
        });
        (_d = this.progressUtils) === null || _d === void 0 ? void 0 : _d.endLoading("Building geometry");
        return group;
    }
    getPlacedGeometry(placedGeometry, elementId) {
        const geometry = this.getBufferGeometry(placedGeometry, elementId);
        const material = this.getMeshMaterial(placedGeometry.color);
        const mesh = new three_1.Mesh(geometry);
        mesh.matrix = this.getMeshMatrix(placedGeometry.flatTransformation);
        mesh.matrixAutoUpdate = false;
        return [mesh, material];
    }
    getBufferGeometry(placedGeometry, elementId) {
        const geometry = this.parser.GetGeometry(this.ifcModelID, placedGeometry.geometryExpressID);
        const verts = this.parser.GetVertexArray(geometry.GetVertexData(), geometry.GetVertexDataSize());
        const indices = this.parser.GetIndexArray(geometry.GetIndexData(), geometry.GetIndexDataSize());
        const bufferGeometry = this.ifcGeometryToBuffer(verts, elementId, indices);
        geometry.delete();
        return bufferGeometry;
    }
    getMeshMaterial(color) {
        let colID = `${color.x}${color.y}${color.z}${color.w}`;
        if (this.materials[colID]) {
            return this.materials[colID];
        }
        const col = new three_1.Color(color.x, color.y, color.z);
        const material = new three_1.MeshLambertMaterial({
            color: col,
            premultipliedAlpha: true,
            name: colID,
            side: three_1.DoubleSide,
        });
        material.transparent = color.w !== 1;
        if (material.transparent)
            material.opacity = color.w;
        this.materials[colID] = material;
        return material;
    }
    getMeshMatrix(matrix) {
        const mat = new three_1.Matrix4();
        mat.fromArray(matrix);
        return mat;
    }
    ifcGeometryToBuffer(vertexData, id, indexData) {
        const geometry = new three_1.BufferGeometry();
        const posFloats = new Float32Array(vertexData.length / 2);
        const normFloats = new Float32Array(vertexData.length / 2);
        const idAttribute = new Uint32Array(vertexData.length / 6);
        for (let i = 0; i < vertexData.length; i += 6) {
            let posx = vertexData[i];
            let posy = vertexData[i + 1];
            let posz = vertexData[i + 2];
            const normx = vertexData[i + 3];
            const normy = vertexData[i + 4];
            const normz = vertexData[i + 5];
            posFloats[i / 2] = posx ? posx : 0;
            posFloats[i / 2 + 1] = posy ? posy : 0;
            posFloats[i / 2 + 2] = posz ? posz : 0;
            normFloats[i / 2] = normx ? normx : 0;
            normFloats[i / 2 + 1] = normy ? normy : 0;
            normFloats[i / 2 + 2] = normz ? normz : 0;
            idAttribute[i / 6] = id;
        }
        geometry.setAttribute("position", new three_1.BufferAttribute(posFloats, 3));
        geometry.setAttribute("normal", new three_1.BufferAttribute(normFloats, 3));
        geometry.setAttribute("ids", new three_1.BufferAttribute(idAttribute, 1));
        geometry.setIndex(new three_1.BufferAttribute(indexData, 1));
        return geometry;
    }
}
exports.IfcParser = IfcParser;


/***/ }),

/***/ 3262:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PropertySerializer = void 0;
const web_ifc_api_node_1 = __webpack_require__(829);
class PropertySerializer {
    constructor(context) {
        this.context = context;
        this.PropsNames = {
            aggregates: {
                name: web_ifc_api_node_1.IFCRELAGGREGATES,
                relating: "RelatingObject",
                related: "RelatedObjects",
                key: "children",
            },
            spatial: {
                name: web_ifc_api_node_1.IFCRELCONTAINEDINSPATIALSTRUCTURE,
                relating: "RelatingStructure",
                related: "RelatedElements",
                key: "children",
            },
            psets: {
                name: web_ifc_api_node_1.IFCRELDEFINESBYPROPERTIES,
                relating: "RelatingPropertyDefinition",
                related: "RelatedObjects",
                key: "IsDefinedBy",
            },
            materials: {
                name: web_ifc_api_node_1.IFCRELASSOCIATESMATERIAL,
                relating: "RelatingMaterial",
                related: "RelatedObjects",
                key: "HasAssociations",
            },
            type: {
                name: web_ifc_api_node_1.IFCRELDEFINESBYTYPE,
                relating: "RelatingType",
                related: "RelatedObjects",
                key: "IsDefinedBy",
            },
        };
    }
    serializeAllProperties(modelID, ids, onLoadCallback) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.getPropertiesAsBlobs(modelID, ids, onLoadCallback);
        });
    }
    getPropertiesAsBlobs(modelID, ids, onLoadCallback) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            const relDefineByPropsSet = yield this.getAllRelDefinesByProps(modelID);
            (_a = this.context.context) === null || _a === void 0 ? void 0 : _a.loadingProgressUtils.initializeLoadingState("Parsing properties", relDefineByPropsSet.size + ids.size);
            let properties = {};
            const allLines = this.context._parser.GetLineIDsWithType(modelID, web_ifc_api_node_1.IFCPROJECT);
            const projectID = allLines.get(0);
            const elementProps = yield this.getItemProperty(modelID, projectID);
            elementProps.sets = [];
            properties[projectID] = elementProps;
            for (const relDefineByPropsId of relDefineByPropsSet) {
                (_b = this.context.context) === null || _b === void 0 ? void 0 : _b.loadingProgressUtils.updateLoadingState("Parsing properties");
                const relDefineByProps = yield this.getItemProperty(modelID, relDefineByPropsId);
                if (relDefineByProps) {
                    const propertieDef = relDefineByProps.RelatingPropertyDefinition;
                    const propertie = yield this.getItemProperty(modelID, propertieDef, true);
                    let curProp = {
                        id: propertieDef,
                        guid: "null",
                        name: "null",
                        props: [],
                        isQuantities: false,
                    };
                    if (propertie &&
                        (propertie.HasProperties || propertie.Quantities)) {
                        if (propertie.Quantities) {
                            for (const q of propertie.Quantities) {
                                this.formatItemProperties(q);
                            }
                        }
                        if (propertie.HasProperties) {
                            for (const p of propertie.HasProperties) {
                                this.formatItemProperties(p);
                            }
                        }
                        curProp = {
                            id: propertieDef,
                            guid: propertie.GlobalId,
                            name: propertie.Name,
                            props: propertie.HasProperties
                                ? propertie.HasProperties
                                : propertie.Quantities
                                    ? propertie.Quantities
                                    : [],
                            isQuantities: !!propertie.Quantities,
                        };
                    }
                    const elements = relDefineByProps.RelatedObjects;
                    for (const element_id of elements) {
                        if (!properties[element_id]) {
                            const elementProps = yield this.getItemProperty(modelID, element_id);
                            if (elementProps) {
                                const guid = elementProps.GlobalId;
                                const name = elementProps.Name;
                                const typeName = elementProps.ObjectType;
                                const longName = elementProps.LongName;
                                const type = elementProps.type;
                                const curElProp = {
                                    id: element_id,
                                    guid,
                                    props: {
                                        name,
                                        typeName,
                                        longName,
                                        type,
                                        elevation: undefined,
                                    },
                                    sets: [curProp],
                                };
                                properties[element_id] = curElProp;
                                if (type === "IfcBuildingStorey") {
                                    const elevation = elementProps.Elevation;
                                    curElProp.props.elevation = elevation;
                                }
                            }
                            else {
                                const curElProp = {
                                    id: element_id,
                                    guid: "null",
                                    props: {
                                        name: "null",
                                        typeName: "null",
                                        longName: "null",
                                        type: "null",
                                        elevation: undefined,
                                    },
                                    sets: [curProp],
                                };
                                properties[element_id] = curElProp;
                            }
                        }
                        else {
                            properties[element_id].sets.push(curProp);
                        }
                    }
                }
            }
            for (const id of ids) {
                (_c = this.context.context) === null || _c === void 0 ? void 0 : _c.loadingProgressUtils.updateLoadingState("Parsing properties");
                if (properties[id]) {
                    continue;
                }
                const elementProps = yield this.getItemProperty(modelID, id);
                if (elementProps) {
                    const guid = elementProps.GlobalId;
                    const name = elementProps.Name;
                    const typeName = elementProps.ObjectType;
                    const longName = elementProps.LongName;
                    const type = elementProps.type;
                    const curElProp = {
                        id: id,
                        guid,
                        props: {
                            name,
                            typeName,
                            longName,
                            type,
                            elevation: undefined,
                        },
                        sets: [],
                    };
                    properties[id] = curElProp;
                }
                else {
                    const curElProp = {
                        id: id,
                        guid: "null",
                        props: {
                            name: "null",
                            typeName: "null",
                            longName: "null",
                            type: "null",
                            elevation: undefined,
                        },
                        sets: [],
                    };
                    properties[id] = curElProp;
                }
            }
            (_d = this.context.context) === null || _d === void 0 ? void 0 : _d.loadingProgressUtils.endLoading("Parsing properties");
            return properties;
        });
    }
    getItemProperty(modelID, id, flatten = false) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const props = yield this.context._parser.GetLine(modelID, id, flatten);
                if (!props)
                    return null;
                if (props.type) {
                    props.type = this.context._parser.GetNameFromTypeCode(props.type);
                }
                this.formatItemProperties(props);
                return props;
            }
            catch (e) {
                console.log(`There was a problem getting the properties of the item with ID ${id}, ${e}`);
                return null;
            }
        });
    }
    formatItemProperties(props) {
        if (!props)
            return props;
        Object.keys(props).forEach((key) => {
            const value = props[key];
            if (value && value.value !== undefined)
                props[key] = value.value;
            else if (Array.isArray(value))
                props[key] = value.map((item) => {
                    if (item && item.value)
                        return item.value;
                    return item;
                });
        });
    }
    getAllRelDefinesByProps(modelID) {
        return __awaiter(this, void 0, void 0, function* () {
            const relDefineByProps = yield this.context._parser.GetLineIDsWithType(modelID, web_ifc_api_node_1.IFCRELDEFINESBYPROPERTIES);
            const relDefineByPropsSet = new Set();
            const idsSize = relDefineByProps.size();
            for (let j = 0; j < idsSize; j++) {
                relDefineByPropsSet.add(relDefineByProps.get(j));
            }
            return relDefineByPropsSet;
        });
    }
    getSpatialStructure(modelID, includeProperties = false) {
        return __awaiter(this, void 0, void 0, function* () {
            const chunks = yield this.getSpatialTreeChunks(modelID);
            const allLines = yield this.context._parser.GetLineIDsWithType(modelID, web_ifc_api_node_1.IFCPROJECT);
            const projectID = allLines.get(0);
            const project = this.newIfcProject(projectID);
            yield this.getSpatialNode(modelID, project, chunks, includeProperties);
            return project;
        });
    }
    getRelatedProperties(modelID, elementID, propsName, recursive = false) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = [];
            let rels = null;
            if (elementID !== 0)
                rels = yield this.context._parser.GetLine(modelID, elementID, false, true, propsName.key)[propsName.key];
            else {
                let vec = this.context._parser.GetLineIDsWithType(modelID, propsName.name);
                rels = [];
                for (let i = 0; i < vec.size(); ++i)
                    rels.push({ value: vec.get(i) });
            }
            if (rels == null)
                return result;
            if (!Array.isArray(rels))
                rels = [rels];
            for (let i = 0; i < rels.length; i++) {
                let propSetIds = yield this.context._parser.GetLine(modelID, rels[i].value, false, false)[propsName.relating];
                if (propSetIds == null)
                    continue;
                if (!Array.isArray(propSetIds))
                    propSetIds = [propSetIds];
                for (let x = 0; x < propSetIds.length; x++) {
                    result.push(yield this.context._parser.GetLine(modelID, propSetIds[x].value, recursive));
                }
            }
            return result;
        });
    }
    getChunks(modelID, chunks, propNames) {
        return __awaiter(this, void 0, void 0, function* () {
            const relation = yield this.context._parser.GetLineIDsWithType(modelID, propNames.name, true);
            for (let i = 0; i < relation.size(); i++) {
                const rel = yield this.context._parser.GetLine(modelID, relation.get(i), false);
                this.saveChunk(chunks, propNames, rel);
            }
        });
    }
    newIfcProject(id) {
        return {
            id,
            type: "IFCPROJECT",
            children: [],
        };
    }
    getSpatialNode(modelID, node, treeChunks, includeProperties) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getChildren(modelID, node, treeChunks, this.PropsNames.aggregates, includeProperties);
            yield this.getChildren(modelID, node, treeChunks, this.PropsNames.spatial, includeProperties);
        });
    }
    getChildren(modelID, node, treeChunks, propNames, includeProperties) {
        return __awaiter(this, void 0, void 0, function* () {
            const children = treeChunks[node.id];
            if (children == void 0)
                return;
            const prop = propNames.key;
            const nodes = [];
            for (let i = 0; i < children.length; i++) {
                const child = children[i];
                let node2 = this.newNode(child, this.context._parser.GetLineType(modelID, child));
                if (includeProperties) {
                    const properties = yield this.getItemProperty(modelID, node2.id);
                    node2 = Object.assign(Object.assign({}, properties), node2);
                }
                yield this.getSpatialNode(modelID, node2, treeChunks, includeProperties);
                nodes.push(node2);
            }
            node[prop] = nodes;
        });
    }
    newNode(id, type) {
        return {
            id,
            type: this.context._parser.GetNameFromTypeCode(type),
            children: [],
        };
    }
    getSpatialTreeChunks(modelID) {
        return __awaiter(this, void 0, void 0, function* () {
            const treeChunks = {};
            yield this.getChunks(modelID, treeChunks, this.PropsNames.aggregates);
            yield this.getChunks(modelID, treeChunks, this.PropsNames.spatial);
            return treeChunks;
        });
    }
    saveChunk(chunks, propNames, rel) {
        const relating = rel[propNames.relating].value;
        const related = rel[propNames.related].map((r) => r.value);
        if (chunks[relating] == void 0) {
            chunks[relating] = related;
        }
        else {
            chunks[relating] = chunks[relating].concat(related);
        }
    }
}
exports.PropertySerializer = PropertySerializer;


/***/ }),

/***/ 490:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Loaders = void 0;
const BMTConverter_1 = __webpack_require__(2828);
const BMTLoader_1 = __webpack_require__(8744);
const IFCLoader_1 = __webpack_require__(4686);
const LoadingProgressUtils_1 = __webpack_require__(2386);
class Loaders {
    constructor(context) {
        this.context = context;
        this.bmtLoader = new BMTLoader_1.BMTLoader(this);
        this.ifcLoader = new IFCLoader_1.IFCLoader(this);
        this.bmtConverter = new BMTConverter_1.BMTConverter(this);
        this.loadingProgressUtils = new LoadingProgressUtils_1.LoadingProgressUtils(this);
    }
}
exports.Loaders = Loaders;


/***/ }),

/***/ 2386:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LoadingProgressUtils = void 0;
class LoadingProgressUtils {
    constructor(context) {
        this.context = context;
        this.progressStep = 0.05;
        this.loadingState = {
            total: 0,
            current: 0,
            step: 0.01,
            type: "",
        };
    }
    setContainer(htmlElement) {
        this.htmlElement = htmlElement;
    }
    setOnLoadCallback(onLoadCallback) {
        this.onLoadCallback = onLoadCallback;
    }
    initializeLoadingState(type, total) {
        if (!this.onLoadCallback)
            return;
        this.loadingState = {
            total: total ? total : 0,
            current: 0,
            step: this.progressStep,
            type,
        };
        if (this.htmlElement) {
            this.htmlElement.innerHTML = `${this.loadingState.type} ${(this.loadingState.current * 100) / this.loadingState.total}%`;
            this.htmlElement.style.display = "none";
            this.htmlElement.style.display = "block";
        }
        this.onLoadCallback(Object.assign(Object.assign({}, this.loadingState), { type }));
    }
    updateLoadingState(type) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.onLoadCallback)
                return;
            const realCurrentItem = Math.min(this.loadingState.current++, this.loadingState.total);
            if (realCurrentItem / this.loadingState.total >=
                this.loadingState.step) {
                if (this.htmlElement) {
                    this.htmlElement.innerHTML = `${this.loadingState.type} ${(this.loadingState.current * 100) / this.loadingState.total}%`;
                }
                this.onLoadCallback(Object.assign(Object.assign({}, this.loadingState), { type }));
                this.loadingState.step += this.progressStep;
            }
        });
    }
    endLoading(type) {
        if (!this.onLoadCallback)
            return;
        this.loadingState.current = this.loadingState.total;
        if (this.htmlElement) {
            this.htmlElement.innerHTML = `${this.loadingState.type}`;
        }
        this.onLoadCallback(Object.assign(Object.assign({}, this.loadingState), { type }));
    }
}
exports.LoadingProgressUtils = LoadingProgressUtils;


/***/ }),

/***/ 6118:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Model = void 0;
const Properties_1 = __webpack_require__(3001);
const three_1 = __webpack_require__(5232);
class Model {
    constructor(context, modelID, fitToView = false, threeGeometry, propsData, structure, indMap, idsMap, defIndMap, defIdsMap, start) {
        this.context = context;
        this.modelID = modelID;
        this.threeGeometry = threeGeometry;
        this.activeElements = new Set();
        this.getSelectionGeom(start);
        this.context.context.scene.threeScene.add(this.threeGeometry);
        this.context.models[modelID] = this;
        this.threeGeometry.name = modelID.toString();
        [this.state, this.defaultState] = this.getGeometryState(indMap, idsMap, defIndMap, defIdsMap);
        this.boundingBox = this.getBoundingBox();
        if (this.context.utils.stats && start) {
            console.log("selection:", Date.now() - start, "ms");
        }
        if (this.context.utils.stats && start) {
            console.log("state recording:", Date.now() - start, "ms");
        }
        if (this.context.utils.stats && start) {
            console.log("compute active elements:", Date.now() - start, "ms");
        }
        this.properties = new Properties_1.Properties(this, propsData, structure);
        if (this.context.utils.stats && start) {
            console.log("property init:", Date.now() - start, "ms");
        }
        if (threeGeometry.children.length) {
            this.updateBox();
            this.context.utils.navigationCubeUtil.updateBoundingSphere();
        }
        if (fitToView) {
            this.fitToView();
        }
        if (this.context.utils.clippingUtils.edgesActive) {
            this.context.utils.clippingUtils.edges.forEach((edge) => {
                edge.createByModel(Number(modelID));
            });
        }
        this.context.utils.clippingUtils.updateMaterials(this.modelID);
    }
    getBoundingBox() {
        let points = [];
        for (const ch of this.threeGeometry.children) {
            const mesh = ch;
            points.push(mesh.geometry.boundingBox.max, mesh.geometry.boundingBox.min);
        }
        return new three_1.Box3().setFromPoints(points);
    }
    cloneGeometry(geometry) {
        const preselGeom = new three_1.BufferGeometry();
        preselGeom.setAttribute("position", geometry.attributes.position);
        preselGeom.setAttribute("ids", geometry.attributes.ids);
        preselGeom.setAttribute("normal", geometry.attributes.normal);
        preselGeom.name = geometry.name;
        return preselGeom;
    }
    getSelectionGeom(start) {
        if (!this.context.selector.selectorModels[this.modelID]) {
            this.context.selector.selectorModels[this.modelID] = [];
        }
        const preselectGroup = new three_1.Group();
        const selectGroup = new three_1.Group();
        this.context.selector.preSelection.state[this.modelID] = {};
        this.context.selector.selection.state[this.modelID] = {};
        for (const ch of this.threeGeometry.children) {
            const mesh = ch;
            this.context.bvhManager.applyThreeMeshBVH(mesh.geometry);
            const preselGeom = this.cloneGeometry(mesh.geometry);
            const selGeom = this.cloneGeometry(mesh.geometry);
            preselGeom.setIndex([]);
            selGeom.setIndex([]);
            const preselectMesh = new three_1.Mesh(preselGeom, this.context.selector.preSelMaterial);
            const selectMesh = new three_1.Mesh(selGeom, this.context.selector.selMaterial);
            preselectMesh.renderOrder = 1;
            selectMesh.renderOrder = 2;
            preselectGroup.add(preselectMesh);
            this.context.selector.preSelection.state[this.modelID][Number(mesh.name)] = preselGeom;
            selectGroup.add(selectMesh);
            this.context.selector.selection.state[this.modelID][Number(mesh.name)] = selGeom;
        }
        if (this.threeGeometry.children.length) {
            this.context.selector.selectorModels[this.modelID] =
                this.threeGeometry.children;
            this.context.selector.selection._selectedMesh.add(selectGroup);
            this.context.selector.preSelection._preSelectMesh.add(preselectGroup);
        }
        this.context.selector.selectedElements[this.modelID] = new Set();
    }
    setState(state, defaultState, activeElements) {
        this.state = state;
        this.defaultState = defaultState;
        if (activeElements) {
            this.activeElements = activeElements;
        }
    }
    getGeometryState(indMap, idsMap, defInsMap, defIdsMap) {
        const state = {
            indMap: indMap ? indMap : {},
            idsMap: idsMap ? idsMap : {},
            needsUpdate: new Set(),
        };
        const defaultState = {
            indMap: defInsMap ? defInsMap : {},
            idsMap: defIdsMap ? defIdsMap : {},
        };
        for (const child of this.threeGeometry.children) {
            const mesh = child;
            const matInd = Number(child.name);
            if (!indMap) {
                if (mesh.geometry.index) {
                    state.indMap[matInd] = mesh.geometry.index.array;
                    defaultState.indMap[matInd] = mesh.geometry.index.array;
                }
            }
            if (!idsMap) {
                const idsAttr = mesh.geometry.attributes.ids;
                const indAttr = mesh.geometry.index;
                for (let i = 0; i < (indAttr ? indAttr.count : idsAttr.count); i++) {
                    const index = indAttr ? indAttr.getX(i) : i;
                    const element = idsAttr.getX(index);
                    const elData = state.idsMap[element];
                    this.activeElements.add(element);
                    if (elData) {
                        const elMatData = elData[matInd];
                        if (elMatData) {
                            defaultState.idsMap[element][matInd].push(index);
                            elMatData.push(index);
                        }
                        else {
                            defaultState.idsMap[element][matInd] = [index];
                            elData[matInd] = [index];
                        }
                    }
                    else {
                        defaultState.idsMap[element] = {
                            [matInd]: [index],
                        };
                        state.idsMap[element] = { [matInd]: [index] };
                    }
                }
            }
            else {
                Object.keys(idsMap).forEach((id) => {
                    this.activeElements.add(Number(id));
                });
            }
        }
        return [state, defaultState];
    }
    updateBox() {
        const points = Object.values(this.context.models)
            .map((model) => {
            if (model.threeGeometry.children.length) {
                model.boundingBox = model.getBoundingBox();
                return [model.boundingBox.max, model.boundingBox.min];
            }
            return [];
        })
            .flat();
        const box = new three_1.Box3();
        box.setFromPoints(points);
        this.boundingBox = box;
        this.context.context.environment.lights.updateLightPosition(box);
        const camera = this.context.context.camera.threeCamera;
        camera.far = box.max.distanceTo(box.min) * 3;
        camera.updateProjectionMatrix();
        this.context.context.sizes.modelSize = box;
    }
    fitToView(enableTransition = false) {
        return __awaiter(this, void 0, void 0, function* () {
            const box = this.context.context.sizes.modelSize;
            const sceneSize = new three_1.Vector3();
            box.getSize(sceneSize);
            const sceneCenter = new three_1.Vector3();
            box.getCenter(sceneCenter);
            const nearFactor = 0.5;
            const radius = Math.max(sceneSize.x, sceneSize.y, sceneSize.z) * nearFactor;
            if (radius !== Infinity) {
                const sphere = new three_1.Sphere(sceneCenter, radius);
                yield this.context.context.controls.cameraControl.fitToSphere(sphere, enableTransition);
            }
        });
    }
    addMeshToModel(mesh, selectGroup, preselectGroup, fitToView) {
        this.context.bvhManager.applyThreeMeshBVH(mesh.geometry);
        const preselGeom = this.cloneGeometry(mesh.geometry);
        const selGeom = this.cloneGeometry(mesh.geometry);
        mesh.renderOrder = 0.5;
        preselGeom.setIndex([]);
        selGeom.setIndex([]);
        const preselectMesh = new three_1.Mesh(preselGeom, this.context.selector.preSelMaterial);
        const selectMesh = new three_1.Mesh(selGeom, this.context.selector.selMaterial);
        preselectMesh.renderOrder = 1;
        selectMesh.renderOrder = 2;
        preselectGroup.add(preselectMesh);
        this.context.selector.preSelection.state[this.modelID][Number(mesh.name)] = preselGeom;
        selectGroup.add(selectMesh);
        this.context.selector.selection.state[this.modelID][Number(mesh.name)] =
            selGeom;
        this.threeGeometry.add(mesh);
        this.updateBox();
        this.context.utils.navigationCubeUtil.updateBoundingSphere();
        this.context.utils.clippingUtils.updateMaterials();
        if (fitToView) {
            this.fitToView();
        }
    }
}
exports.Model = Model;


/***/ }),

/***/ 3001:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Properties = void 0;
class Properties {
    constructor(context, data, structure) {
        this.context = context;
        this.data = data;
        this.structure = structure;
        this.hasProperties = Boolean(Object.keys(data).length);
    }
    loadStructure(path) {
        console.log("add load structure func");
    }
    setStructure(structure) {
        this.structure = structure;
    }
    loadProperties(path) {
        console.log("add load props func");
    }
    setProperties(properties) {
        this.data = properties;
    }
}
exports.Properties = Properties;


/***/ }),

/***/ 5222:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PreSelection = void 0;
const three_1 = __webpack_require__(5232);
class PreSelection {
    constructor(context) {
        this.context = context;
        this._active = true;
        this._usePreSelectBind = this.usePreSelect.bind(this);
        this._activeElement = -1;
        this._activeFace = -1;
        this._activePoint = new three_1.Vector3();
        this._activeModelID = 0;
        this._intersectLength = 0;
        this._intersectDistance = 0;
        this._needUpdate = 0;
        this.deep = 0;
        this.state = {};
        this.resetPreselect = () => {
            this._preSelectMesh.children.forEach((ch) => {
                ch.children.forEach((ch2) => {
                    ch2.geometry.setIndex([]);
                });
            });
            this._activeFace = -1;
            this._activeElement = -1;
            this._intersectLength = 0;
            this._intersectDistance = 0;
            this.deep = 0;
        };
        if (this._active) {
            this.context.context.context.renderer.addCallback(this._usePreSelectBind);
        }
        this._preSelectMesh = new three_1.Group();
        this._preSelectMesh.frustumCulled = false;
        this._preSelectMesh.renderOrder = 1;
        this.context.context.context.scene.threeScene.add(this._preSelectMesh);
    }
    get preSelectElement() {
        if (this._activeElement > 0) {
            return {
                mesh: this._preSelectMesh,
                elementID: this._activeElement,
                modelID: this._activeModelID,
                point: this._activePoint,
                distance: this._intersectDistance,
            };
        }
        return null;
    }
    get setDeep() {
        this.deep = (this.deep + 1) % this._intersectLength;
        return this.deep;
    }
    usePreSelect() {
        if (this.context.context.context.controls.moving) {
            this.resetPreselect();
            return;
        }
        const intersects = this.context.context.context.controls.getIntersects();
        let curElementId;
        let curModel;
        let ind;
        let point;
        let distance;
        let curModelMesh;
        let i = 0;
        for (const intersect of intersects) {
            curModelMesh = intersect.object;
            const modelID = Number(curModelMesh.parent.name);
            curModel = this.context.context.models[modelID];
            ind = intersect.faceIndex * 3;
            point = intersect.point;
            distance = intersect.distance;
            const allIds = curModelMesh.geometry.attributes.ids;
            const indexes = curModelMesh.geometry.index;
            const curInd = indexes ? indexes.getX(ind) : ind;
            curElementId = allIds.getX(curInd);
            if (i === this.deep) {
                break;
            }
            i++;
        }
        if (this._activeElement === curElementId || this._activeFace === ind) {
            return;
        }
        this._needUpdate++;
        if (this._needUpdate > this.deep) {
            this.deep = 0;
            this._needUpdate = 0;
        }
        if (!curElementId ||
            !curModel ||
            ind === undefined ||
            !point ||
            !distance ||
            !curModelMesh) {
            return this.resetPreselect();
        }
        const vertIndexes = curModel.defaultState.idsMap[curElementId];
        if (!vertIndexes)
            return;
        Object.keys(this.state).forEach((curModelId) => {
            Object.keys(this.state[Number(curModelId)]).forEach((matId) => {
                const geom = this.state[Number(curModelId)][Number(matId)];
                if (!geom)
                    return;
                if (curModel.modelID === Number(curModelId) &&
                    vertIndexes[Number(matId)]) {
                    geom.setIndex(vertIndexes[Number(matId)]);
                }
                else {
                    geom.setIndex([]);
                }
            });
        });
        this._activeModelID = curModel.modelID;
        this._activeFace = ind;
        this._activeElement = curElementId;
        this._activePoint = point;
        this._intersectDistance = distance;
    }
    get active() {
        return this._active;
    }
    set active(active) {
        if (this._active !== active) {
            this._active = active;
            if (active) {
                this.context.context.context.renderer.addCallback(this._usePreSelectBind);
            }
            else {
                this.context.context.context.renderer.removeCallback(this._usePreSelectBind);
                this.resetPreselect();
            }
        }
    }
}
exports.PreSelection = PreSelection;


/***/ }),

/***/ 1866:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Selection = void 0;
const three_1 = __webpack_require__(5232);
class Selection {
    constructor(context) {
        this.context = context;
        this._active = true;
        this._useSelectBind = this.useSelect.bind(this);
        this._activeFace = -1;
        this._activeElement = -1;
        this._selectionCallback = null;
        this.state = {};
        this.resetModelSelection = (modelID) => {
            this.context.selectedElements[modelID] = new Set();
            for (const matId of Object.keys(this.state[modelID])) {
                this.state[modelID][Number(matId)].setIndex([]);
            }
        };
        this.resetSelect = (full = true) => {
            if (full) {
                for (const modelID of Object.keys(this.state)) {
                    this.resetModelSelection(Number(modelID));
                }
                this.context.isSelected = false;
            }
            this._activeFace = -1;
            this._activeElement = -1;
            this.context.context.utils.propsUtils.getPropertiesById();
            if (this.context.context.utils.propsUtils.propConteiner) {
                this.context.context.utils.propsUtils.propConteiner.replaceChildren();
            }
            if (this._selectionCallback) {
                this._selectionCallback();
            }
        };
        this.selectAll = () => {
            const start = Date.now();
            this.selectByIds(0, Object.keys(this.context.context.models[0].state.idsMap).map((p) => Number(p)));
            console.log("selection time:", Date.now() - start, "ms");
        };
        this.selectByIds = (modelID, ids, removePrevious = true) => {
            this.context.context.context.renderer.needUpdate = false;
            const start = Date.now();
            const curModel = this.context.context.models[modelID];
            const curState = this.state[modelID];
            if (!curState) {
                console.warn("wrong model id");
                return;
            }
            if (removePrevious) {
                this.resetSelect(false);
                this.resetModelSelection(modelID);
                let count = 0;
                Object.values(this.context.selectedElements).forEach((set) => (count += set.size));
                this.context.selectedElements[modelID] = new Set();
                if (count === 1) {
                    this.context.context.utils.propsUtils.getPropertiesById(modelID, ids[0]);
                }
                else {
                    this.context.context.utils.propsUtils.getPropertiesById();
                }
            }
            else {
                this.context.context.utils.propsUtils.getPropertiesById();
            }
            for (const id of ids) {
                if (!curModel.activeElements.has(id)) {
                    continue;
                }
                this.context.selectedElements[modelID].add(id);
                const vertIndexes = curModel.defaultState.idsMap[id];
                if (!vertIndexes)
                    continue;
                for (const matId of Object.keys(vertIndexes)) {
                    const indexes = vertIndexes[Number(matId)];
                    const exArr = curState[Number(matId)].index;
                    const newIndexArr = new three_1.BufferAttribute(new Uint32Array(exArr.count + indexes.length), 1);
                    newIndexArr.set(exArr.array);
                    newIndexArr.set(indexes, exArr.count);
                    curState[Number(matId)].setIndex(newIndexArr);
                }
            }
            this.context.isSelected = true;
            this.context.context.context.renderer.needUpdate = true;
            this.context.context.context.renderer.render();
            if (this._selectionCallback) {
                this._selectionCallback();
            }
            console.log("select by id: ", Date.now() - start, "ms");
        };
        this.removeSelectByIds = (modelID, ids) => {
            const curSelection = this.context.selectedElements[modelID];
            if (!curSelection || !curSelection.size) {
                return;
            }
            for (const id of ids) {
                curSelection.delete(id);
            }
            this.selectByIds(modelID, Array.from(curSelection), true);
            return;
        };
        if (this._active) {
            this.context.context.context.domElement.addEventListener("click", this._useSelectBind);
        }
        this._selectedMesh = new three_1.Group();
        this._selectedMesh.frustumCulled = false;
        this._selectedMesh.renderOrder = 2;
        this.context.context.context.scene.threeScene.add(this._selectedMesh);
    }
    get selectionCallback() {
        return this._selectionCallback;
    }
    set selectionCallback(func) {
        this._selectionCallback = func;
    }
    get selectedMesh() {
        return this._selectedMesh;
    }
    get active() {
        return this._active;
    }
    set active(active) {
        if (this._active !== active) {
            this._active = active;
            if (active) {
                this.context.context.context.domElement.addEventListener("click", this._useSelectBind);
            }
            else {
                this.context.context.context.domElement.removeEventListener("click", this._useSelectBind);
                this.resetSelect();
            }
        }
    }
    useSelect(e) {
        const isRemoveSelect = this.context.context.utils.keysUtils.isRemoveSelectionKey(e);
        const isMultySelect = this.context.context.utils.keysUtils.isMultySelect(e);
        if (this.context.context.context.controls.moving ||
            this.context.selectionBox.dragging) {
            return;
        }
        if (this.context.preSelection.active &&
            this.context.preSelection.preSelectElement &&
            !isMultySelect &&
            !isRemoveSelect) {
            this.resetSelect(true);
            const modelID = structuredClone(this.context.preSelection.preSelectElement.modelID);
            for (const curModelId of Object.keys(this.context.preSelection.state)) {
                for (const matId of Object.keys(this.context.preSelection.state[Number(curModelId)])) {
                    this.state[Number(curModelId)][Number(matId)].setIndex(this.context.preSelection.state[Number(curModelId)][Number(matId)].index);
                    if (modelID === Number(curModelId)) {
                        this.context.selectedElements[modelID] = new Set([
                            this._activeElement,
                        ]);
                    }
                    else {
                        this.context.selectedElements[Number(curModelId)] =
                            new Set([]);
                    }
                }
            }
            this._activeElement =
                this.context.preSelection.preSelectElement.elementID;
            this.context.context.utils.propsUtils.getPropertiesById(modelID, this._activeElement);
            this.context.selectedElements[modelID] = new Set([
                this._activeElement,
            ]);
            this.context.isSelected = true;
        }
        else {
            const intersects = this.context.context.context.controls.getIntersects();
            if (!intersects)
                return;
            let curElementId;
            let modelID;
            let ind;
            for (const intersect of intersects) {
                const curModelMesh = intersect.object;
                modelID = Number(curModelMesh.parent.name);
                ind = intersect.faceIndex * 3;
                if (this._activeFace === ind) {
                    return;
                }
                const allIds = curModelMesh.geometry.attributes.ids;
                const indexes = curModelMesh.geometry.index;
                const curInd = indexes ? indexes.getX(ind) : ind;
                curElementId = allIds.getX(curInd);
                if (this.context.context.models[modelID].activeElements.has(curElementId)) {
                    break;
                }
                curElementId = undefined;
            }
            if (modelID === undefined || ind === undefined || !curElementId) {
                return this.resetSelect();
            }
            const selectedElements = this.context.selectedElements;
            if (selectedElements[modelID].has(curElementId) &&
                !isRemoveSelect) {
                return;
            }
            if (isRemoveSelect) {
                selectedElements[modelID].delete(curElementId);
            }
            else if (isMultySelect) {
                selectedElements[modelID].add(curElementId);
            }
            else {
                this.resetSelect(true);
                for (const keyModelID of Object.keys(this.state)) {
                    if (modelID === Number(keyModelID)) {
                        selectedElements[modelID] = new Set([curElementId]);
                        const inds = this.context.context.models[Number(modelID)]
                            .defaultState.idsMap[curElementId];
                        for (const matId of Object.keys(inds)) {
                            this.state[Number(modelID)][Number(matId)].setIndex(inds[Number(matId)]);
                        }
                    }
                    else {
                        for (const matId of Object.keys(this.state[Number(modelID)])) {
                            this.state[Number(modelID)][Number(matId)].setIndex([]);
                        }
                        selectedElements[Number(keyModelID)] = new Set();
                    }
                }
            }
            this.selectByIds(modelID, Array.from(selectedElements[modelID]), false);
            this._activeFace = ind;
            this.context.isSelected = true;
            this._activeElement = curElementId;
        }
    }
}
exports.Selection = Selection;


/***/ }),

/***/ 3118:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SelectionBox = void 0;
const three_mesh_bvh_1 = __webpack_require__(885);
__webpack_require__(324);
const three_1 = __webpack_require__(5232);
class SelectionBox {
    constructor(context, cssClassName) {
        this.context = context;
        this.params = {
            toolMode: "box",
            selectionMode: "intersection",
            liveUpdate: false,
            resetPrevous: false,
        };
        this.isMouseDown = false;
        this.isAdd = true;
        this.isFullElementInside = true;
        this.selectionPoints = [];
        this.dragging = false;
        this.selectionShapeNeedsUpdate = false;
        this.selectionNeedsUpdate = false;
        this.invWorldMatrix = new three_1.Matrix4();
        this.camLocalPosition = new three_1.Vector3();
        this.tempRay = new three_1.Ray();
        this.centroid = new three_1.Vector3();
        this.screenCentroid = new three_1.Vector3();
        this.faceNormal = new three_1.Vector3();
        this.toScreenSpaceMatrix = new three_1.Matrix4();
        this.boxPoints = new Array(8).fill().map(() => new three_1.Vector3());
        this.boxLines = new Array(12).fill().map(() => new three_1.Line3());
        this.lassoSegments = [];
        this.perBoundsSegments = [];
        this.renderSelectionBind = this.renderSelection.bind(this);
        this.usePreselectionState = this.context.usePreSelection;
        this.selectionShape = new three_1.Line(new three_1.BufferGeometry(), new three_1.LineBasicMaterial({ linewidth: 3 }));
        this.selectionShape.material.color.set(0xff9800).convertSRGBToLinear();
        this.selectionShape.renderOrder = 1;
        this.selectionShape.position.z = -0.2;
        this.selectionShape.scale.setScalar(10);
        this.context.context.context.camera.threeCamera.add(this.selectionShape);
        this.helper = document.createElement("div");
        this.helper.style.pointerEvents = "none";
        if (cssClassName) {
            this.helper.classList.add(cssClassName);
        }
        else {
            this.helper.classList.add("selectionBox_tech");
        }
        this.helper.hidden = true;
        let startX = -Infinity;
        let startY = -Infinity;
        let prevX = -Infinity;
        let prevY = -Infinity;
        let helperStartX = -Infinity;
        let helperStartY = -Infinity;
        const tempVec0 = new three_1.Vector2();
        const tempVec1 = new three_1.Vector2();
        const tempVec2 = new three_1.Vector2();
        const renderer = this.context.context.context.renderer.threeRenderer;
        renderer.domElement.parentElement.appendChild(this.helper);
        this.context.context.context.renderer.addCallback(this.renderSelectionBind);
        window.addEventListener("keydown", (e) => {
            const isRemoveSelect = this.context.context.utils.keysUtils.isRemoveSelectionKey(e);
            const isBoxSelect = this.context.context.utils.keysUtils.isBoxSelect(e);
            if (isBoxSelect) {
                this.isPlus(true);
            }
            else if (isRemoveSelect) {
                this.isPlus(false);
            }
        });
        renderer.domElement.addEventListener("pointerdown", (e) => {
            const isRemoveSelect = this.context.context.utils.keysUtils.isRemoveSelectionKey(e);
            const isBoxSelect = this.context.context.utils.keysUtils.isBoxSelect(e);
            if (!isBoxSelect && !isRemoveSelect)
                return;
            prevX = this.context.context.context.mouse.cords.x;
            prevY = this.context.context.context.mouse.cords.y;
            helperStartX = this.context.context.context.mouse.cords.x;
            helperStartY = this.context.context.context.mouse.cords.y;
            startX = this.context.context.context.mouse.position.x;
            startY = this.context.context.context.mouse.position.y;
            this.selectionPoints.length = 0;
            this.context.context.context.controls.cameraControl.enabled = false;
            this.usePreselectionState = this.context.usePreSelection;
            this.context.usePreSelection = false;
            this.helper.hidden = true;
            this.isMouseDown = true;
            this.helper.style.left = prevX + "px";
            this.helper.style.top = prevY + "px";
            this.helper.style.width = "0px";
            this.helper.style.height = "0px";
        });
        renderer.domElement.addEventListener("pointerup", () => {
            if (!this.isMouseDown)
                return;
            this.selectionShape.visible = false;
            if (this.selectionPoints.length) {
                this.selectionNeedsUpdate = true;
            }
            this.isMouseDown = false;
            this.context.usePreSelection = this.usePreselectionState;
            this.context.context.context.controls.cameraControl.enabled = true;
            setTimeout(() => {
                this.dragging = false;
                this.reset();
            }, 100);
            this.helper.hidden = true;
        });
        renderer.domElement.addEventListener("pointermove", (e) => {
            const isRemoveSelect = this.context.context.utils.keysUtils.isRemoveSelectionKey(e);
            const isBoxSelect = this.context.context.utils.keysUtils.isBoxSelect(e);
            if ((1 & e.buttons) === 0) {
                return;
            }
            if (isBoxSelect) {
                this.isFullElementInside = true;
            }
            else if (isRemoveSelect) {
                this.isFullElementInside = false;
            }
            if (Math.abs(helperStartX - e.clientX) < 5 &&
                Math.abs(helperStartY - e.clientY) < 5) {
                return;
            }
            if (!this.isMouseDown) {
                return;
            }
            this.dragging = true;
            if (this.params.toolMode === "box") {
                const pointBottomRightX = Math.max(helperStartX, e.clientX);
                const pointBottomRightY = Math.max(helperStartY, e.clientY);
                const pointTopLeftX = Math.min(helperStartX, e.clientX);
                const pointTopLeftY = Math.min(helperStartY, e.clientY);
                this.helper.hidden = false;
                this.helper.style.left = pointTopLeftX + "px";
                this.helper.style.top = pointTopLeftY + "px";
                this.helper.style.width =
                    pointBottomRightX - pointTopLeftX + "px";
                this.helper.style.height =
                    pointBottomRightY - pointTopLeftY + "px";
                if (helperStartX >= e.clientX) {
                    this.isFullElementInside = false;
                    this.helper.classList.add("selectBox_green");
                    this.helper.classList.remove("selectBox_blue");
                }
                else {
                    this.isFullElementInside = true;
                    this.helper.classList.remove("selectBox_green");
                    this.helper.classList.add("selectBox_blue");
                }
            }
            const ex = this.context.context.context.mouse.cords.x;
            const ey = this.context.context.context.mouse.cords.y;
            const nx = this.context.context.context.mouse.position.x;
            const ny = this.context.context.context.mouse.position.y;
            if (this.params.toolMode === "box") {
                this.selectionPoints.length = 3 * 5;
                this.selectionPoints[0] = startX;
                this.selectionPoints[1] = startY;
                this.selectionPoints[2] = 0;
                this.selectionPoints[3] = nx;
                this.selectionPoints[4] = startY;
                this.selectionPoints[5] = 0;
                this.selectionPoints[6] = nx;
                this.selectionPoints[7] = ny;
                this.selectionPoints[8] = 0;
                this.selectionPoints[9] = startX;
                this.selectionPoints[10] = ny;
                this.selectionPoints[11] = 0;
                this.selectionPoints[12] = startX;
                this.selectionPoints[13] = startY;
                this.selectionPoints[14] = 0;
                if (ex !== prevX || ey !== prevY) {
                    this.selectionShapeNeedsUpdate = true;
                }
                prevX = ex;
                prevY = ey;
                this.selectionShape.visible = true;
                if (this.params.liveUpdate) {
                    this.selectionNeedsUpdate = true;
                }
            }
            else {
                this.isFullElementInside = true;
                if (Math.abs(ex - prevX) >= 3 || Math.abs(ey - prevY) >= 3) {
                    const i = this.selectionPoints.length / 3 - 1;
                    const i3 = i * 3;
                    let doReplace = false;
                    if (this.selectionPoints.length > 3) {
                        tempVec0.set(this.selectionPoints[i3 - 3], this.selectionPoints[i3 - 3 + 1]);
                        tempVec1.set(this.selectionPoints[i3], this.selectionPoints[i3 + 1]);
                        tempVec1.sub(tempVec0).normalize();
                        tempVec0.set(this.selectionPoints[i3], this.selectionPoints[i3 + 1]);
                        tempVec2.set(nx, ny);
                        tempVec2.sub(tempVec0).normalize();
                        const dot = tempVec1.dot(tempVec2);
                        doReplace = dot > 0.99;
                    }
                    if (doReplace) {
                        this.selectionPoints[i3] = nx;
                        this.selectionPoints[i3 + 1] = ny;
                    }
                    else {
                        this.selectionPoints.push(nx, ny, 0);
                    }
                    this.selectionShapeNeedsUpdate = true;
                    this.selectionShape.visible = true;
                    prevX = ex;
                    prevY = ey;
                    if (this.params.liveUpdate) {
                        this.selectionNeedsUpdate = true;
                    }
                }
            }
        });
    }
    reset() {
        this.invWorldMatrix = new three_1.Matrix4();
        this.camLocalPosition = new three_1.Vector3();
        this.tempRay = new three_1.Ray();
        this.centroid = new three_1.Vector3();
        this.screenCentroid = new three_1.Vector3();
        this.faceNormal = new three_1.Vector3();
        this.toScreenSpaceMatrix = new three_1.Matrix4();
        this.boxPoints = new Array(8).fill().map(() => new three_1.Vector3());
        this.boxLines = new Array(12).fill().map(() => new three_1.Line3());
        this.lassoSegments = [];
        this.perBoundsSegments = [];
    }
    isPlus(isPlus) {
        this.isAdd = isPlus;
        if (isPlus) {
            this.helper.classList.add("selectBox_plus");
            this.helper.classList.remove("selectBox_minus");
        }
        else {
            this.helper.classList.add("selectBox_minus");
            this.helper.classList.remove("selectBox_plus");
        }
    }
    renderSelection() {
        const camera = this.context.context.context.camera.threeCamera;
        if (this.selectionShapeNeedsUpdate) {
            if (this.params.toolMode === "lasso") {
                const ogLength = this.selectionPoints.length;
                this.selectionPoints.push(this.selectionPoints[0], this.selectionPoints[1], this.selectionPoints[2]);
                this.selectionShape.geometry.setAttribute("position", new three_1.Float32BufferAttribute(this.selectionPoints, 3, false));
                this.selectionPoints.length = ogLength;
            }
            else {
                this.selectionShape.geometry.setAttribute("position", new three_1.Float32BufferAttribute([], 3, false));
            }
            this.selectionShape.geometry.attributes.position.needsUpdate = true;
            this.selectionShape.frustumCulled = false;
            this.selectionShapeNeedsUpdate = false;
        }
        if (this.selectionNeedsUpdate) {
            this.selectionNeedsUpdate = false;
            if (this.selectionPoints.length > 0) {
                const selectorModels = this.context.context.selector.selectorModels;
                const models = this.context.context.models;
                for (let modelID = 0; modelID < Object.keys(selectorModels).length; modelID++) {
                    const mesh = selectorModels[modelID];
                    const selectedIds = new Set();
                    mesh.forEach((ch) => {
                        this.updateSelection(ch, models[modelID].state, selectedIds);
                        this.params.resetPrevous = false;
                    });
                    const arr = Array.from(selectedIds);
                    if (this.isAdd) {
                        this.context.selection.selectByIds(modelID, arr, this.params.resetPrevous || this.params.liveUpdate);
                    }
                    else {
                        this.context.selection.removeSelectByIds(modelID, arr);
                    }
                }
            }
        }
        if (camera instanceof three_1.PerspectiveCamera) {
            const yScale = Math.tan((three_1.MathUtils.DEG2RAD * camera.fov) / 2) *
                this.selectionShape.position.z;
            this.selectionShape.scale.set(-yScale * camera.aspect, -yScale, 1);
        }
    }
    updateSelection(mesh, state, set) {
        const startTime = window.performance.now();
        const selectModel = false;
        const camera = this.context.context.context.camera.threeCamera;
        this.toScreenSpaceMatrix
            .copy(mesh.matrixWorld)
            .premultiply(camera.matrixWorldInverse)
            .premultiply(camera.projectionMatrix);
        while (this.lassoSegments.length < this.selectionPoints.length) {
            this.lassoSegments.push(new three_1.Line3());
        }
        this.lassoSegments.length = this.selectionPoints.length;
        for (let s = 0, l = this.selectionPoints.length; s < l; s += 3) {
            const line = this.lassoSegments[s];
            const sNext = (s + 3) % l;
            line.start.x = this.selectionPoints[s];
            line.start.y = this.selectionPoints[s + 1];
            line.end.x = this.selectionPoints[sNext];
            line.end.y = this.selectionPoints[sNext + 1];
        }
        this.invWorldMatrix.copy(mesh.matrixWorld).invert();
        this.camLocalPosition
            .set(0, 0, 0)
            .applyMatrix4(camera.matrixWorld)
            .applyMatrix4(this.invWorldMatrix);
        const indices = new Set();
        const isFull = this.isFullElementInside || this.params.toolMode === "lasso";
        const idsDict = {};
        const indexAttr = mesh.geometry.index;
        const idsAttr = mesh.geometry.attributes.ids;
        mesh.geometry.boundsTree.shapecast({
            intersectsBounds: (box, isLeaf, score, depth) => {
                const { min, max } = box;
                let index = 0;
                let minY = Infinity;
                let maxY = -Infinity;
                let minX = Infinity;
                for (let x = 0; x <= 1; x++) {
                    for (let y = 0; y <= 1; y++) {
                        for (let z = 0; z <= 1; z++) {
                            const v = this.boxPoints[index];
                            v.x = x === 0 ? min.x : max.x;
                            v.y = y === 0 ? min.y : max.y;
                            v.z = z === 0 ? min.z : max.z;
                            v.applyMatrix4(this.toScreenSpaceMatrix);
                            index++;
                            if (v.y < minY)
                                minY = v.y;
                            if (v.y > maxY)
                                maxY = v.y;
                            if (v.x < minX)
                                minX = v.x;
                        }
                    }
                }
                const parentSegments = this.perBoundsSegments[depth - 1] || this.lassoSegments;
                const segmentsToCheck = this.perBoundsSegments[depth] || [];
                segmentsToCheck.length = 0;
                this.perBoundsSegments[depth] = segmentsToCheck;
                for (let i = 0, l = parentSegments.length; i < l; i++) {
                    const line = parentSegments[i];
                    const sx = line.start.x;
                    const sy = line.start.y;
                    const ex = line.end.x;
                    const ey = line.end.y;
                    if (sx < minX && ex < minX)
                        continue;
                    const startAbove = sy > maxY;
                    const endAbove = ey > maxY;
                    if (startAbove && endAbove)
                        continue;
                    const startBelow = sy < minY;
                    const endBelow = ey < minY;
                    if (startBelow && endBelow)
                        continue;
                    segmentsToCheck.push(line);
                }
                if (segmentsToCheck.length === 0) {
                    return three_mesh_bvh_1.NOT_INTERSECTED;
                }
                const hull = this.getConvexHull(this.boxPoints);
                const lines = hull.map((p, i) => {
                    const nextP = hull[(i + 1) % hull.length];
                    const line = this.boxLines[i];
                    line.start.copy(p);
                    line.end.copy(nextP);
                    return line;
                });
                if (this.pointRayCrossesSegments(segmentsToCheck[0].start, lines) %
                    2 ===
                    1) {
                    return three_mesh_bvh_1.INTERSECTED;
                }
                let crossings = 0;
                for (let i = 0, l = hull.length; i < l; i++) {
                    const v = hull[i];
                    const pCrossings = this.pointRayCrossesSegments(v, segmentsToCheck);
                    if (i === 0) {
                        crossings = pCrossings;
                    }
                    if (crossings !== pCrossings) {
                        return three_mesh_bvh_1.INTERSECTED;
                    }
                }
                for (let i = 0, l = lines.length; i < l; i++) {
                    const boxLine = lines[i];
                    for (let s = 0, ls = segmentsToCheck.length; s < ls; s++) {
                        if (this.lineCrossesLine(boxLine, segmentsToCheck[s])) {
                            return three_mesh_bvh_1.INTERSECTED;
                        }
                    }
                }
                return crossings % 2 === 0 ? three_mesh_bvh_1.NOT_INTERSECTED : three_mesh_bvh_1.CONTAINED;
            },
            intersectsTriangle: (tri, index, contained, depth) => {
                const i3 = index * 3;
                const a = i3 + 0;
                const b = i3 + 1;
                const c = i3 + 2;
                const segmentsToCheck = this.perBoundsSegments[depth];
                if (this.params.selectionMode === "centroid" ||
                    this.params.selectionMode === "centroid-visible") {
                    this.centroid
                        .copy(tri.a)
                        .add(tri.b)
                        .add(tri.c)
                        .multiplyScalar(1 / 3);
                    this.screenCentroid
                        .copy(this.centroid)
                        .applyMatrix4(this.toScreenSpaceMatrix);
                    if (contained ||
                        this.pointRayCrossesSegments(this.screenCentroid, segmentsToCheck) %
                            2 ===
                            1) {
                        if (this.params.selectionMode === "centroid-visible") {
                            tri.getNormal(this.faceNormal);
                            this.tempRay.origin
                                .copy(this.centroid)
                                .addScaledVector(this.faceNormal, 1e-6);
                            this.tempRay.direction.subVectors(this.camLocalPosition, this.centroid);
                            const res = mesh.geometry.boundsTree.raycastFirst(this.tempRay, three_1.DoubleSide);
                            if (res) {
                                return false;
                            }
                        }
                        addId(a);
                        return selectModel;
                    }
                }
                else if (this.params.selectionMode === "intersection") {
                    if (contained) {
                        addId(a);
                        return selectModel;
                    }
                    const vertices = [tri.a, tri.b, tri.c];
                    for (let j = 0; j < 3; j++) {
                        const v = vertices[j];
                        v.applyMatrix4(this.toScreenSpaceMatrix);
                        const crossings = this.pointRayCrossesSegments(v, segmentsToCheck);
                        if (crossings % 2 === 1) {
                            addId(a);
                            return selectModel;
                        }
                    }
                    const lines = [
                        this.boxLines[0],
                        this.boxLines[1],
                        this.boxLines[2],
                    ];
                    lines[0].start.copy(tri.a);
                    lines[0].end.copy(tri.b);
                    lines[1].start.copy(tri.b);
                    lines[1].end.copy(tri.c);
                    lines[2].start.copy(tri.c);
                    lines[2].end.copy(tri.a);
                    for (let i = 0; i < 3; i++) {
                        const l = lines[i];
                        for (let s = 0, sl = segmentsToCheck.length; s < sl; s++) {
                            if (this.lineCrossesLine(l, segmentsToCheck[s])) {
                                addId(a);
                                return selectModel;
                            }
                        }
                    }
                }
                return false;
            },
        });
        function addId(i) {
            const i2 = indexAttr.getX(i);
            const id = idsAttr.getX(i2);
            if (!isFull) {
                set.add(id);
            }
            else {
                if (idsDict[id]) {
                    idsDict[id]++;
                }
                else {
                    idsDict[id] = 1;
                }
            }
        }
        if (isFull) {
            for (const id_str of Object.keys(idsDict)) {
                const id = Number(id_str);
                const curIdState = state.idsMap[id];
                let count = 0;
                for (const matId of Object.keys(curIdState)) {
                    const curIdStateVal = curIdState[Number(matId)];
                    count += curIdStateVal.length;
                }
                if (idsDict[id] === count / 3) {
                    set.add(id);
                }
            }
        }
    }
    getConvexHull(points) {
        function orientation(p, q, r) {
            const val = (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
            if (val == 0) {
                return 0;
            }
            return val > 0 ? 1 : 2;
        }
        function distSq(p1, p2) {
            return ((p1.x - p2.x) * (p1.x - p2.x) + (p1.y - p2.y) * (p1.y - p2.y));
        }
        function compare(p1, p2) {
            const o = orientation(p0, p1, p2);
            if (o == 0)
                return distSq(p0, p2) >= distSq(p0, p1) ? -1 : 1;
            return o == 2 ? -1 : 1;
        }
        let lowestY = Infinity;
        let lowestIndex = -1;
        for (let i = 0, l = points.length; i < l; i++) {
            const p = points[i];
            if (p.y < lowestY) {
                lowestIndex = i;
                lowestY = p.y;
            }
        }
        const p0 = points[lowestIndex];
        points[lowestIndex] = points[0];
        points[0] = p0;
        points = points.sort(compare);
        let m = 1;
        const n = points.length;
        for (let i = 1; i < n; i++) {
            while (i < n - 1 &&
                orientation(p0, points[i], points[i + 1]) == 0) {
                i++;
            }
            points[m] = points[i];
            m++;
        }
        const hull = [points[0], points[1], points[2]];
        for (let i = 3; i < m; i++) {
            while (orientation(hull[hull.length - 2], hull[hull.length - 1], points[i]) !== 2) {
                hull.pop();
            }
            hull.push(points[i]);
        }
        return hull;
    }
    pointRayCrossesLine(point, line, prevDirection, thisDirection) {
        const { start, end } = line;
        const px = point.x;
        const py = point.y;
        const sy = start.y;
        const ey = end.y;
        if (sy === ey)
            return false;
        if (py > sy && py > ey)
            return false;
        if (py < sy && py < ey)
            return false;
        const sx = start.x;
        const ex = end.x;
        if (px > sx && px > ex)
            return false;
        if (px < sx && px < ex) {
            if (py === sy && prevDirection !== thisDirection) {
                return false;
            }
            return true;
        }
        const dx = ex - sx;
        const dy = ey - sy;
        const perpx = dy;
        const perpy = -dx;
        const pdx = px - sx;
        const pdy = py - sy;
        const dot = perpx * pdx + perpy * pdy;
        if (Math.sign(dot) !== Math.sign(perpx)) {
            return true;
        }
        return false;
    }
    pointRayCrossesSegments(point, segments) {
        let crossings = 0;
        const firstSeg = segments[segments.length - 1];
        let prevDirection = firstSeg.start.y > firstSeg.end.y;
        for (let s = 0, l = segments.length; s < l; s++) {
            const line = segments[s];
            const thisDirection = line.start.y > line.end.y;
            if (this.pointRayCrossesLine(point, line, prevDirection, thisDirection)) {
                crossings++;
            }
            prevDirection = thisDirection;
        }
        return crossings;
    }
    lineCrossesLine(l1, l2) {
        function ccw(A, B, C) {
            return (C.y - A.y) * (B.x - A.x) > (B.y - A.y) * (C.x - A.x);
        }
        const A = l1.start;
        const B = l1.end;
        const C = l2.start;
        const D = l2.end;
        return ccw(A, C, D) !== ccw(B, C, D) && ccw(A, B, C) !== ccw(A, B, D);
    }
}
exports.SelectionBox = SelectionBox;


/***/ }),

/***/ 2884:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Selector = void 0;
const Selection_1 = __webpack_require__(1866);
const PreSelection_1 = __webpack_require__(5222);
const SelectionBox_1 = __webpack_require__(3118);
const three_1 = __webpack_require__(5232);
class Selector {
    constructor(context) {
        this.context = context;
        this.selMaterial = new three_1.MeshLambertMaterial({
            color: new three_1.Color("rgb(17, 148, 189)"),
            clippingPlanes: [],
            side: three_1.DoubleSide,
        });
        this.preSelMaterial = new three_1.MeshLambertMaterial({
            color: new three_1.Color("rgb(104, 198, 227)"),
            clippingPlanes: [],
            side: three_1.DoubleSide,
        });
        this.selectedElements = {};
        this.isSelected = false;
        this.selectorModels = {};
        this._usePreSelection = true;
        this._selection = new Selection_1.Selection(this);
        this._preSelection = new PreSelection_1.PreSelection(this);
        this.selectionBox = new SelectionBox_1.SelectionBox(this);
    }
    get useDoubleSideMaterial() {
        return this.selMaterial.side === three_1.DoubleSide;
    }
    set useDoubleSideMaterial(bool) {
        this.selMaterial.side = bool ? three_1.DoubleSide : three_1.FrontSide;
        this.preSelMaterial.side = bool ? three_1.DoubleSide : three_1.FrontSide;
    }
    set usePreSelection(usePreSelection) {
        this._preSelection.active = usePreSelection;
    }
    set useSelection(useSelection) {
        this._selection.active = useSelection;
    }
    get usePreSelection() {
        return this._preSelection.active;
    }
    get useSelection() {
        return this._selection.active;
    }
    get preSelection() {
        return this._preSelection;
    }
    get selection() {
        return this._selection;
    }
}
exports.Selector = Selector;


/***/ }),

/***/ 2190:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ClippingEdges = void 0;
const three_1 = __webpack_require__(5232);
class ClippingEdges extends three_1.Object3D {
    constructor(context, plane) {
        super();
        this.context = context;
        this.plane = plane;
        this.tempVector = new three_1.Vector3();
        this.tempVector1 = new three_1.Vector3();
        this.tempVector2 = new three_1.Vector3();
        this.tempVector3 = new three_1.Vector3();
        this.tempLine = new three_1.Line3();
        this.localPlane = new three_1.Plane();
        this.active = this.context.edgesActive;
        const clippingPlanes = [];
        for (const edge of context.edges) {
            if (edge.plane !== plane) {
                if (edge.lines) {
                    for (const modelID of Object.keys(edge.lines)) {
                        for (const matId of Object.keys(edge.lines[Number(modelID)])) {
                            const line = edge.lines[Number(modelID)][Number(matId)];
                            if (line.material.clippingPlanes) {
                                line.material.clippingPlanes.push(plane);
                            }
                            else {
                                line.material.clippingPlanes = [plane];
                            }
                        }
                    }
                }
                clippingPlanes.push(edge.plane);
            }
        }
        this.material = new three_1.LineBasicMaterial({
            clippingPlanes,
            color: "black",
        });
        this.context.edges.push(this);
    }
    dispose() {
        if (!this.lines)
            return;
        for (const modelID of Object.keys(this.lines)) {
            for (const matId of Object.keys(this.lines[Number(modelID)])) {
                const line = this.lines[Number(modelID)][Number(matId)];
                line.removeFromParent();
                line.geometry.dispose();
            }
        }
    }
    toggle() {
        if (this.active) {
            this.removeFromView();
        }
        else {
            this.addToView();
        }
        this.active = !this.active;
    }
    removeFromView() {
        if (!this.lines)
            return;
        for (const modelID of Object.keys(this.lines)) {
            for (const matId of Object.keys(this.lines[Number(modelID)])) {
                const line = this.lines[Number(modelID)][Number(matId)];
                line.visible = false;
            }
        }
    }
    addToView() {
        if (!this.lines)
            return;
        for (const modelID of Object.keys(this.lines)) {
            for (const matId of Object.keys(this.lines[Number(modelID)])) {
                const line = this.lines[Number(modelID)][Number(matId)];
                line.visible = true;
            }
        }
    }
    create() {
        this.tempVector = new three_1.Vector3();
        this.tempVector1 = new three_1.Vector3();
        this.tempVector2 = new three_1.Vector3();
        this.tempVector3 = new three_1.Vector3();
        this.tempLine = new three_1.Line3();
        this.localPlane = new three_1.Plane();
        if (!this.lines) {
            this.lines = {};
        }
        const res = new three_1.Group();
        for (const modelID of Object.keys(this.context.context.context.models)) {
            this.createByModel(Number(modelID), res);
        }
        return res;
    }
    createByModel(modelID, res) {
        if (!this.lines)
            return;
        const model = this.context.context.context.models[modelID];
        let curState = this.lines[modelID];
        if (!curState) {
            curState = {};
        }
        const modelState = {};
        for (const mesh of model.threeGeometry.children) {
            const matId = Number(mesh.name);
            const lineGeometry = new three_1.BufferGeometry();
            const linePosAttr = new three_1.BufferAttribute(new Float32Array(300000), 3, false);
            linePosAttr.setUsage(three_1.DynamicDrawUsage);
            lineGeometry.setAttribute("position", linePosAttr);
            const segment = new three_1.LineSegments(lineGeometry, this.material);
            segment.frustumCulled = false;
            segment.material.color.set("black").convertSRGBToLinear();
            modelState[matId] = segment;
            res === null || res === void 0 ? void 0 : res.add(segment);
        }
        this.lines[modelID] = modelState;
    }
    update() {
        if (!this.lines) {
            this.create();
        }
        if (!this.lines)
            return;
        const clippingPlane = this.plane;
        this.localPlane.copy(clippingPlane);
        for (const modelID of Object.keys(this.lines)) {
            const models = this.context.context.context.models;
            for (const mesh of models[Number(modelID)].threeGeometry.children) {
                const matId = Number(mesh.name);
                const curSegment = this.lines[Number(modelID)][Number(matId)];
                let index = 0;
                const posAttr = curSegment.geometry.attributes.position;
                const curGeom = mesh.geometry;
                const colliderBvh = curGeom.boundsTree;
                if (!colliderBvh) {
                    continue;
                }
                colliderBvh.shapecast({
                    intersectsBounds: (box) => {
                        return this.localPlane.intersectsBox(box);
                    },
                    intersectsTriangle: (tri, triIndex) => {
                        let count = 0;
                        this.tempLine.start.copy(tri.a);
                        this.tempLine.end.copy(tri.b);
                        if (this.localPlane.intersectLine(this.tempLine, this.tempVector)) {
                            posAttr.setXYZ(index, this.tempVector.x, this.tempVector.y, this.tempVector.z);
                            index++;
                            count++;
                        }
                        this.tempLine.start.copy(tri.b);
                        this.tempLine.end.copy(tri.c);
                        if (this.localPlane.intersectLine(this.tempLine, this.tempVector)) {
                            posAttr.setXYZ(index, this.tempVector.x, this.tempVector.y, this.tempVector.z);
                            count++;
                            index++;
                        }
                        this.tempLine.start.copy(tri.c);
                        this.tempLine.end.copy(tri.a);
                        if (this.localPlane.intersectLine(this.tempLine, this.tempVector)) {
                            posAttr.setXYZ(index, this.tempVector.x, this.tempVector.y, this.tempVector.z);
                            count++;
                            index++;
                        }
                        if (count === 3) {
                            this.tempVector1.fromBufferAttribute(posAttr, index - 3);
                            this.tempVector2.fromBufferAttribute(posAttr, index - 2);
                            this.tempVector3.fromBufferAttribute(posAttr, index - 1);
                            if (this.tempVector3.equals(this.tempVector1) ||
                                this.tempVector3.equals(this.tempVector2)) {
                                count--;
                                index--;
                            }
                            else if (this.tempVector1.equals(this.tempVector2)) {
                                posAttr.setXYZ(index - 2, this.tempVector3);
                                count--;
                                index--;
                            }
                        }
                        if (count !== 2) {
                            index -= count;
                        }
                    },
                });
                curSegment.geometry.setDrawRange(0, index);
                curSegment.position
                    .copy(clippingPlane.normal)
                    .multiplyScalar(-0.00001);
                posAttr.needsUpdate = true;
            }
        }
    }
}
exports.ClippingEdges = ClippingEdges;


/***/ }),

/***/ 7388:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ClippingUtils = void 0;
const PlaneHelper_1 = __webpack_require__(8231);
const ClippingEdges_1 = __webpack_require__(2190);
const three_1 = __webpack_require__(5232);
class ClippingUtils {
    constructor(context) {
        this.context = context;
        this.planes = [];
        this.active = false;
        this._edgesActive = true;
        this._helpersActive = true;
        this.edges = [];
        this.heplers = [];
    }
    updateMaterials(modelID) {
        if (modelID !== undefined) {
            this.updateMaterial(this.context.context.models[modelID]);
        }
        else {
            const models = this.context.context.models;
            for (const model of Object.values(models)) {
                this.updateMaterial(model);
            }
        }
        this.context.context.selector.selMaterial.clippingPlanes = this.planes;
        this.context.context.selector.preSelMaterial.clippingPlanes =
            this.planes;
        this.context.context.context.camera.threeCamera.updateMatrixWorld();
    }
    updateMaterial(model) {
        model.threeGeometry.children.forEach((ch) => {
            ch.material.clippingPlanes = this.planes;
        });
    }
    createPlane() {
        if (!this.active) {
            this.toggle();
        }
        const models = this.context.context.models;
        const meshes = Object.values(models)
            .map((m) => m.threeGeometry.children)
            .flat();
        const intersect = this.context.context.context.controls.getIntersects(meshes);
        if (intersect[0]) {
            const plane = new three_1.Plane();
            const point = intersect[0].point.clone();
            const normal = intersect[0].normal;
            point.add(normal.clone().multiplyScalar(0.001));
            plane.setFromNormalAndCoplanarPoint(normal.negate(), point);
            this.createPlaneHelper(plane, point, normal);
            this.planes.push(plane);
            if (this.edgesActive) {
                const clippingEdges = new ClippingEdges_1.ClippingEdges(this, plane);
                const edges = clippingEdges.create();
                this.context.context.context.scene.threeScene.add(edges);
                clippingEdges.update();
            }
            return plane;
        }
    }
    createPlaneHelper(plane, location, normal) {
        const planeHelper = new PlaneHelper_1.PlaneHelper(this, plane, location, normal);
        return planeHelper;
    }
    deleteAllPlanes() {
        this.active = false;
        const models = this.context.context.models;
        for (const helper of this.heplers) {
            helper.dispose();
        }
        for (const edge of this.edges) {
            edge.dispose();
        }
        this.edges = [];
        this.heplers = [];
        this.planes = [];
        for (const model of Object.values(models)) {
            model.threeGeometry.children.forEach((ch) => {
                ch.material.clippingPlanes = this.planes;
            });
        }
        this.context.context.selector.selMaterial.clippingPlanes = this.planes;
        this.context.context.selector.preSelMaterial.clippingPlanes =
            this.planes;
        this.active = false;
        this.context.context.context.renderer.threeRenderer.localClippingEnabled =
            false;
    }
    toggle() {
        const models = this.context.context.models;
        this.context.context.context.renderer.threeRenderer.localClippingEnabled =
            !this.active;
        this.active = !this.active;
        if (this.helpersActive) {
            for (const helper of this.heplers) {
                helper.toggle();
            }
        }
        if (this.edgesActive) {
            for (const edges of this.edges) {
                edges.toggle();
            }
        }
    }
    updateEdges() {
        this.edges.forEach((edge) => {
            edge.update();
        });
    }
    get helpersActive() {
        return this._helpersActive;
    }
    set helpersActive(helpersActive) {
        if (this._helpersActive !== helpersActive) {
            this._helpersActive = helpersActive;
            if (!this.active)
                return;
            for (const helper of this.heplers) {
                helper.toggle();
            }
        }
    }
    get edgesActive() {
        return this._edgesActive;
    }
    set edgesActive(edgesActive) {
        if (this._edgesActive !== edgesActive) {
            this._edgesActive = edgesActive;
            if (!this.active)
                return;
            if (this.edges.length !== this.planes.length) {
                this.edges = [];
                for (const plane of this.planes) {
                    const clippingEdges = new ClippingEdges_1.ClippingEdges(this, plane);
                    const edges = clippingEdges.create();
                    this.context.context.context.scene.threeScene.add(edges);
                    clippingEdges.update();
                }
            }
            for (const edge of this.edges) {
                edge.toggle();
            }
        }
    }
}
exports.ClippingUtils = ClippingUtils;


/***/ }),

/***/ 8231:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PlaneHelper = void 0;
const three_1 = __webpack_require__(5232);
class PlaneHelper extends three_1.Object3D {
    constructor(context, plane, location, normal) {
        super();
        this.context = context;
        this.plane = plane;
        this.location = location;
        this.helper = new three_1.Group();
        this.thickness = 0.08;
        this._deltaVector = null;
        this.material = new three_1.MeshBasicMaterial({
            color: "#858585",
            side: three_1.DoubleSide,
            transparent: true,
            opacity: 0.3,
        });
        this.active = context.helpersActive;
        const planeHelper = this.getHelperGeometry();
        this.helper.add(planeHelper);
        this.plane.coplanarPoint(this.helper.position);
        this.helper.lookAt(normal.x, normal.y, normal.z);
        this.helper.position.set(this.location.x, this.location.y, this.location.z);
        this.context.heplers.push(this);
        this.dragControl =
            this.context.context.context.context.controls.createDragControl([
                planeHelper,
            ]);
        this.dragControl.defaultActive = false;
        if (this.active) {
            this.hoverOn({ object: planeHelper });
            this.addToView();
        }
    }
    addDragControlEvents() {
        this.dragControl.addEventListener("dragstart", this.dragStart.bind(this));
        this.dragControl.addEventListener("drag", this.drag.bind(this));
        this.dragControl.addEventListener("dragend", this.dragEnd.bind(this));
        this.dragControl.addEventListener("hoveron", this.hoverOn.bind(this));
        this.dragControl.addEventListener("hoveroff", this.hoverOff.bind(this));
    }
    removeDragControlEvents() { }
    dragStart(e) {
        this._deltaVector = null;
        this.context.context.context.context.controls.moving = true;
        this.context.context.context.selector.preSelection.resetPreselect();
        this.context.context.context.context.controls.cameraControl.enabled =
            false;
    }
    drag(e) {
        const pointTech = e.point;
        if (!this._deltaVector) {
            if (e.object.position.z === 0) {
                this._deltaVector = new three_1.Vector3(0, 0, 0);
            }
            else {
                const curPos = pointTech
                    .clone()
                    .applyMatrix4(e.object.matrixWorld);
                console.log(curPos);
                console.log(this.helper.position);
                this._deltaVector = new three_1.Vector3(this.helper.position.x - curPos.x, this.helper.position.y - curPos.y, this.helper.position.z - curPos.z);
            }
        }
        const point = new three_1.Vector3(pointTech.x + this._deltaVector.x, pointTech.y + this._deltaVector.y, pointTech.z + this._deltaVector.z);
        const normal = this.plane.normal;
        this.plane.setFromNormalAndCoplanarPoint(normal, point);
        const curPos = this.location.clone();
        const projection1 = point.clone().projectOnVector(normal);
        const projection2 = curPos.clone().projectOnVector(normal);
        let delta;
        const angl = normal.angleTo(point);
        if (angl > Math.PI / 2) {
            delta = projection2.length() - projection1.length();
        }
        else {
            delta = projection1.length() + projection2.length();
        }
        const newNormalVec = normal.clone().multiplyScalar(delta);
        const normalisedPoint = curPos.add(newNormalVec);
        if (this.context.edgesActive) {
            this.context.updateEdges();
        }
        this.helper.position.set(normalisedPoint.x, normalisedPoint.y, normalisedPoint.z);
    }
    dragEnd() {
        setTimeout(() => {
            this.context.context.context.context.controls.moving = false;
        }, 10);
        this.context.context.context.context.controls.cameraControl.enabled =
            true;
    }
    hoverOn(e) {
        if (!this.context.context.context.context.controls.moving) {
            this.context.context.context.context.controls.moving = true;
            this.context.context.context.selector.preSelection.resetPreselect();
        }
        this.material.color = new three_1.Color("#ebeb34");
    }
    hoverOff(e) {
        this.context.context.context.context.controls.moving = false;
        this.material.color = new three_1.Color("#858585");
    }
    dispose() {
        this.removeFromView();
        this.helper.children.forEach((p) => p.geometry.dispose());
        this.dragControl.removeEventListener("dragstart", this.dragStart.bind(this));
        this.dragControl.removeEventListener("drag", this.drag.bind(this));
        this.dragControl.removeEventListener("dragend", this.dragEnd.bind(this));
        this.dragControl.removeEventListener("hoveron", this.hoverOn.bind(this));
        this.dragControl.removeEventListener("hoveroff", this.hoverOff.bind(this));
    }
    toggle() {
        if (this.active) {
            this.removeFromView();
        }
        else {
            this.addToView();
        }
        this.active = !this.active;
    }
    removeFromView() {
        this.removeDragControlEvents();
        this.helper.removeFromParent();
    }
    addToView() {
        this.addDragControlEvents();
        this.context.context.context.context.scene.threeScene.add(this.helper);
    }
    getHelperGeometry() {
        const planeHelper = new three_1.Mesh(new three_1.PlaneGeometry(3, 3), this.material);
        this.customArrow();
        return planeHelper;
    }
    customArrow() {
        const length = 2;
        const ARROW_BODY = new three_1.CylinderGeometry(1, 1, 1, 12)
            .rotateX(Math.PI / 2)
            .translate(0, 0, 0.5);
        const ARROW_HEAD = new three_1.ConeGeometry(1, 1, 12)
            .rotateX(-Math.PI / 2)
            .translate(0, 0, -0.5);
        var body = new three_1.Mesh(ARROW_BODY, this.material);
        body.scale.set(this.thickness / 2, this.thickness / 2, -length);
        var head = new three_1.Mesh(ARROW_HEAD, this.material);
        head.position.set(0, 0, -length);
        head.scale.set(3 * this.thickness, length * this.thickness, 10 * this.thickness);
        this.helper.add(body, head);
    }
}
exports.PlaneHelper = PlaneHelper;


/***/ }),

/***/ 7340:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DimensionLine = void 0;
const three_1 = __webpack_require__(5232);
const CSS2DRenderer_1 = __webpack_require__(1764);
class DimensionLine {
    constructor(context, start, end, lineMaterial, endpointMaterial, endpoint, className, endpointScale) {
        this.context = context;
        this.endpointMeshes = [];
        this.boundingMesh = null;
        this.start = start;
        this.end = end;
        this.lineMaterial = lineMaterial;
        this.endpointMaterial = endpointMaterial;
        this.endpoint = endpoint;
        this.className = className;
        this.root = new three_1.Group();
        this.root.renderOrder = 3;
        this.boundingSize = 0.05;
        this.context = context;
        this.labelClassName = className;
        this.scale = endpointScale;
        this.length = this.getLength();
        this.center = this.getCenter();
        this.axis = new three_1.BufferGeometry().setFromPoints([start, end]);
        this.line = new three_1.Line(this.axis, this.lineMaterial);
        this.root.add(this.line);
        this.addEndpointMeshes();
        this.textLabel = this.newText();
        this.root.renderOrder = 2;
        this.context.context.context.context.scene.threeScene.add(this.root);
        this.context.context.context.context.controls.cameraControl.addEventListener("control", this.rescaleObjectsToCameraPosition.bind(this));
        this.rescaleObjectsToCameraPosition();
    }
    dispose() {
        var _a, _b, _c, _d, _e, _f;
        this.removeFromScene();
        if (this.root)
            this.context.context.disposeMeshRecursively(this.root);
        this.root = null;
        if (this.line)
            this.context.context.disposeMeshRecursively(this.line);
        this.line = null;
        this.endpointMeshes.forEach((mesh) => this.context.context.disposeMeshRecursively(mesh));
        this.endpointMeshes.length = 0;
        (_a = this.axis) === null || _a === void 0 ? void 0 : _a.dispose();
        this.axis = null;
        (_b = this.endpoint) === null || _b === void 0 ? void 0 : _b.dispose();
        this.endpoint = null;
        (_c = this.textLabel) === null || _c === void 0 ? void 0 : _c.removeFromParent();
        (_d = this.textLabel) === null || _d === void 0 ? void 0 : _d.element.remove();
        this.textLabel = null;
        (_e = this.lineMaterial) === null || _e === void 0 ? void 0 : _e.dispose();
        this.lineMaterial = null;
        (_f = this.endpointMaterial) === null || _f === void 0 ? void 0 : _f.dispose();
        this.endpointMaterial = null;
        if (this.boundingMesh) {
            this.context.context.disposeMeshRecursively(this.boundingMesh);
            this.boundingMesh = null;
        }
    }
    get boundingBox() {
        return this.boundingMesh;
    }
    get text() {
        return this.textLabel;
    }
    set dimensionColor(dimensionColor) {
        if (this.endpointMaterial)
            this.endpointMaterial.color = dimensionColor;
        if (this.lineMaterial)
            this.lineMaterial.color = dimensionColor;
    }
    set visibility(visible) {
        if (this.root)
            this.root.visible = visible;
        if (this.textLabel)
            this.textLabel.visible = visible;
    }
    set endpointGeometry(geometry) {
        this.endpointMeshes.forEach((mesh) => { var _a; return (_a = this.root) === null || _a === void 0 ? void 0 : _a.remove(mesh); });
        this.endpointMeshes = [];
        this.endpoint = geometry;
        this.addEndpointMeshes();
    }
    set endpointScale(scale) {
        this.scale = scale;
        this.endpointMeshes.forEach((mesh) => mesh.scale.set(scale.x, scale.y, scale.z));
    }
    set endPoint(point) {
        this.end = point;
        if (!this.axis)
            return;
        const position = this.axis.attributes.position;
        if (!position)
            return;
        position.setXYZ(1, point.x, point.y, point.z);
        position.needsUpdate = true;
        this.endpointMeshes[1].position.set(point.x, point.y, point.z);
        this.endpointMeshes[1].lookAt(this.start);
        this.endpointMeshes[0].lookAt(this.end);
        this.length = this.getLength();
        this.center = this.getCenter();
        if (this.textLabel) {
            this.textLabel.element.textContent = this.getTextContent();
            this.textLabel.position.set(this.center.x, this.center.y, this.center.z);
        }
        if (this.line)
            this.line.computeLineDistances();
    }
    removeFromScene() {
        if (this.root) {
            this.context.context.context.context.scene.threeScene.remove(this.root);
            if (this.textLabel)
                this.root.remove(this.textLabel);
        }
    }
    createBoundingBox() {
        this.boundingMesh = this.newBoundingBox();
        this.setupBoundingBox(this.end);
    }
    rescaleObjectsToCameraPosition() {
        this.endpointMeshes.forEach((mesh) => this.rescaleMesh(mesh, DimensionLine.scaleFactor));
        if (this.boundingMesh) {
            this.rescaleMesh(this.boundingMesh, this.boundingSize, true, true, false);
        }
    }
    rescaleMesh(mesh, scalefactor = 1, x = true, y = true, z = true) {
        const camera = this.context.context.context.context.camera.threeCamera;
        let scale = new three_1.Vector3()
            .subVectors(mesh.position, camera.position)
            .length();
        if (camera instanceof three_1.OrthographicCamera) {
            scale *= 0.1;
        }
        scale *= scalefactor;
        const scaleX = x ? scale : 1;
        const scaleY = y ? scale : 1;
        const scaleZ = z ? scale : 1;
        mesh.scale.set(scaleX, scaleY, scaleZ);
    }
    addEndpointMeshes() {
        this.newEndpointMesh(this.start, this.end);
        this.newEndpointMesh(this.end, this.start);
    }
    newEndpointMesh(position, direction) {
        if (this.endpoint && this.endpointMaterial && this.root) {
            const mesh = new three_1.Mesh(this.endpoint, this.endpointMaterial);
            mesh.position.set(position.x, position.y, position.z);
            mesh.scale.set(this.scale.x, this.scale.y, this.scale.z);
            mesh.lookAt(direction);
            this.endpointMeshes.push(mesh);
            this.root.add(mesh);
        }
    }
    newText() {
        var _a;
        const htmlText = document.createElement("div");
        htmlText.className = this.labelClassName;
        htmlText.textContent = this.getTextContent();
        const label = new CSS2DRenderer_1.CSS2DObject(htmlText);
        label.position.set(this.center.x, this.center.y, this.center.z);
        (_a = this.root) === null || _a === void 0 ? void 0 : _a.add(label);
        return label;
    }
    getTextContent() {
        return `${this.length * DimensionLine.scale} ${DimensionLine.units}`;
    }
    newBoundingBox() {
        const box = new three_1.BoxGeometry(1, 1, this.length);
        return new three_1.Mesh(box);
    }
    setupBoundingBox(end) {
        var _a;
        if (!this.boundingMesh)
            return;
        this.boundingMesh.position.set(this.center.x, this.center.y, this.center.z);
        this.boundingMesh.lookAt(end);
        this.boundingMesh.visible = false;
        (_a = this.root) === null || _a === void 0 ? void 0 : _a.add(this.boundingMesh);
    }
    getLength() {
        return parseFloat(this.start.distanceTo(this.end).toFixed(2));
    }
    getCenter() {
        let dir = this.end.clone().sub(this.start);
        const len = dir.length() * 0.5;
        dir = dir.normalize().multiplyScalar(len);
        return this.start.clone().add(dir);
    }
}
exports.DimensionLine = DimensionLine;
DimensionLine.scaleFactor = 0.1;
DimensionLine.scale = 1;
DimensionLine.units = "m";


/***/ }),

/***/ 5448:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DimensionsUtils = void 0;
const three_1 = __webpack_require__(5232);
const DimentionLine_1 = __webpack_require__(7340);
__webpack_require__(7586);
const CSS2DRenderer_1 = __webpack_require__(1764);
class DimensionsUtils {
    constructor(context) {
        this.context = context;
        this.currentDimension = null;
        this.curAxis = null;
        this.measureInPros = false;
        this.measureStart = false;
        this.dimensions = [];
        this.labelClassName = "dimension-label";
        this.previewClassName = "dimension-preview";
        this.enabled = false;
        this.preview = false;
        this.dragging = false;
        this.snapDistance = 0.25;
        this.baseScale = new three_1.Vector3(1, 1, 1);
        this.lineMaterial = new three_1.LineDashedMaterial({
            color: 0x000000,
            linewidth: 2,
            depthTest: false,
            dashSize: 0.2,
            gapSize: 0.2,
        });
        this.endpointsMaterial = new three_1.MeshBasicMaterial({
            color: 0x000000,
            depthTest: false,
        });
        this.startPoint = new three_1.Vector3();
        this.endPoint = new three_1.Vector3();
        this.endpoint = DimensionsUtils.getDefaultEndpointGeometry();
        const htmlPreview = document.createElement("div");
        htmlPreview.className = this.previewClassName;
        this.previewElement = new CSS2DRenderer_1.CSS2DObject(htmlPreview);
        this.previewElement.visible = true;
        const pivotElement = document.createElement("div");
        pivotElement.className = "camera-pivot-marker";
        this.measureObject = new CSS2DRenderer_1.CSS2DObject(pivotElement);
        this.measureObject.visible = false;
        this.context.context.context.scene.threeScene.add(this.measureObject);
        this._selectionState = {
            selection: context.context.selector.useSelection,
            preselection: context.context.selector.usePreSelection,
        };
        this.drawInProcessEvent_binded = this.drawInProcessEvent.bind(this);
        this.dimensionsClickEventHandle_binded =
            this.dimentionsClickEventHandle.bind(this);
    }
    dispose() {
        var _b, _c, _d;
        this.dimensions.forEach((dim) => dim.dispose());
        this.dimensions = [];
        this.currentDimension = null;
        (_b = this.endpoint) === null || _b === void 0 ? void 0 : _b.dispose();
        this.endpoint = null;
        (_c = this.previewElement) === null || _c === void 0 ? void 0 : _c.removeFromParent();
        (_d = this.previewElement) === null || _d === void 0 ? void 0 : _d.element.remove();
        this.previewElement = null;
    }
    update() {
        if (this.enabled && this.preview && this.previewElement) {
            const models = this.context.context.models;
            const meshes = Object.values(models)
                .map((m) => m.threeGeometry.children)
                .flat();
            const intersects = this.context.context.context.controls.getIntersects(meshes)[0];
            this.previewElement.visible = !!intersects;
            if (!intersects)
                return;
            this.previewElement.visible = true;
            const closest = this.getClosestVertex(intersects);
            this.previewElement.visible = !!closest;
            if (!closest)
                return;
            this.previewElement.position.set(closest.x, closest.y, closest.z);
            if (this.dragging) {
                this.drawInProcess();
            }
        }
    }
    setPreviewElement(element) {
        this.previewElement = new CSS2DRenderer_1.CSS2DObject(element);
    }
    get active() {
        return this.enabled;
    }
    get previewActive() {
        return this.preview;
    }
    get previewObject() {
        return this.previewElement;
    }
    set previewActive(state) {
        this.preview = state;
        if (this.previewElement) {
            const scene = this.context.context.context.scene.threeScene;
            if (this.preview) {
                scene.add(this.previewElement);
            }
            else {
                scene.remove(this.previewElement);
            }
        }
    }
    set active(state) {
        this.enabled = state;
        this.dimensions.forEach((dim) => {
            dim.visibility = state;
        });
    }
    set dimensionsColor(color) {
        this.endpointsMaterial.color = color;
        this.lineMaterial.color = color;
    }
    set dimensionsWidth(width) {
        this.lineMaterial.linewidth = width;
    }
    set endpointGeometry(geometry) {
        this.dimensions.forEach((dim) => {
            dim.endpointGeometry = geometry;
        });
    }
    set endpointScaleFactor(factor) {
        DimentionLine_1.DimensionLine.scaleFactor = factor;
    }
    set endpointScale(scale) {
        this.baseScale = scale;
        this.dimensions.forEach((dim) => {
            dim.endpointScale = scale;
        });
    }
    create() {
        if (!this.enabled)
            return;
        if (!this.dragging) {
            this.drawStart();
            return;
        }
        this.drawEnd();
    }
    createInPlane(plane) {
        if (!this.enabled)
            return;
        if (!this.dragging) {
            this.drawStartInPlane(plane);
            return;
        }
        this.drawEnd();
    }
    delete() {
        if (!this.enabled || this.dimensions.length === 0)
            return;
        const boundingBoxes = this.getBoundingBoxes();
        const intersects = this.context.context.context.controls.getIntersects(boundingBoxes);
        if (intersects.length === 0)
            return;
        const selected = this.dimensions.find((dim) => dim.boundingBox === intersects[0].object);
        if (!selected)
            return;
        const index = this.dimensions.indexOf(selected);
        this.dimensions.splice(index, 1);
        selected.removeFromScene();
    }
    deleteAll() {
        this.dimensions.forEach((dim) => {
            dim.removeFromScene();
        });
        this.dimensions = [];
    }
    cancelDrawing() {
        var _a;
        if (!this.currentDimension)
            return;
        (_a = this.currentDimension) === null || _a === void 0
            ? void 0
            : _a.removeFromScene();
        this.currentDimension = null;
        this.measureInPros = false;
    }
    setDimensionUnit(units) {
        if (!units)
            return;
        if (units === "mm") {
            DimentionLine_1.DimensionLine.units = units;
            DimentionLine_1.DimensionLine.scale = 1000;
        }
        else if (units === "m") {
            DimentionLine_1.DimensionLine.units = units;
            DimentionLine_1.DimensionLine.scale = 1;
        }
    }
    drawStart() {
        this.dragging = true;
        const models = this.context.context.models;
        const meshes = Object.values(models)
            .map((m) => m.threeGeometry.children)
            .flat();
        const intersects = this.context.context.context.controls.getIntersects(meshes);
        if (!intersects)
            return;
        const found = this.getClosestVertex(intersects[0]);
        if (!found)
            return;
        this.startPoint = found;
    }
    drawStartInPlane(plane) {
        this.dragging = true;
        const intersects = this.context.context.context.controls.getIntersects([
            plane,
        ]);
        if (!intersects || intersects.length < 1)
            return;
        this.startPoint = intersects[0].point;
    }
    drawInProcess() {
        const models = this.context.context.models;
        const meshes = Object.values(models)
            .map((m) => m.threeGeometry.children)
            .flat();
        const intersects = this.context.context.context.controls.getIntersects(meshes)[0];
        if (!intersects)
            return;
        const found = this.getClosestVertex(intersects);
        if (!found)
            return;
        this.endPoint = found;
        if (!this.currentDimension)
            this.currentDimension = this.drawDimension();
        this.currentDimension.endPoint = this.endPoint;
    }
    drawEnd() {
        if (!this.currentDimension)
            return;
        this.currentDimension.createBoundingBox();
        this.dimensions.push(this.currentDimension);
        this.currentDimension = null;
        this.dragging = false;
    }
    get getDimensionsLines() {
        return this.dimensions;
    }
    drawDimension() {
        return new DimentionLine_1.DimensionLine(this, this.startPoint, this.endPoint, this.lineMaterial, this.endpointsMaterial, this.endpoint, this.labelClassName, this.baseScale);
    }
    getBoundingBoxes() {
        return this.dimensions
            .map((dim) => dim.boundingBox)
            .filter((box) => box !== undefined && box !== null);
    }
    static getDefaultEndpointGeometry(height = 0.1, radius = 0.03) {
        const coneGeometry = new three_1.ConeGeometry(radius, height);
        coneGeometry.translate(0, -height / 2, 0);
        coneGeometry.rotateX(-Math.PI / 2);
        return coneGeometry;
    }
    getClosestVertex(intersects) {
        let closestVertex = new three_1.Vector3();
        let vertexFound = false;
        let closestDistance = Number.MAX_SAFE_INTEGER;
        const vertices = this.getVertices(intersects);
        vertices === null || vertices === void 0
            ? void 0
            : vertices.forEach((vertex) => {
                if (!vertex)
                    return;
                const distance = intersects.point.distanceTo(vertex);
                if (distance > closestDistance ||
                    distance > this.snapDistance)
                    return;
                vertexFound = true;
                closestVertex = vertex;
                closestDistance = intersects.point.distanceTo(vertex);
            });
        return vertexFound ? closestVertex : intersects.point;
    }
    getVertices(intersects) {
        const mesh = intersects.object;
        if (!intersects.face || !mesh)
            return null;
        const geom = mesh.geometry;
        return [
            this.getVertex(intersects.face.a, geom),
            this.getVertex(intersects.face.b, geom),
            this.getVertex(intersects.face.c, geom),
        ];
    }
    getVertex(index, geom) {
        if (index === undefined)
            return null;
        const vertices = geom.attributes.position;
        return new three_1.Vector3(vertices.getX(index), vertices.getY(index), vertices.getZ(index));
    }
    changeAxes() {
        if (this.measureInPros && this.found) {
            const curFound = new three_1.Vector3();
            switch (this.curAxis) {
                case "x":
                    curFound.x = this.startPoint.x;
                    curFound.y = this.found.y;
                    curFound.z = this.startPoint.z;
                    this.curAxis = "y";
                    break;
                case "y":
                    curFound.x = this.startPoint.x;
                    curFound.y = this.startPoint.y;
                    curFound.z = this.found.z;
                    this.curAxis = "z";
                    break;
                default:
                    curFound.x = this.found.x;
                    curFound.y = this.startPoint.y;
                    curFound.z = this.startPoint.z;
                    this.curAxis = "x";
                    break;
            }
            this.endPoint = curFound;
            if (!this.currentDimension)
                this.currentDimension = this.drawDimension();
            this.currentDimension.endPoint = this.endPoint;
        }
    }
    drawInProcessEvent(e) {
        const models = this.context.context.models;
        const meshes = Object.values(models)
            .map((m) => m.threeGeometry.children)
            .flat();
        const intersects = this.context.context.context.controls.getIntersects(meshes);
        if (!intersects.length)
            return;
        this.found = this.getClosestVertex(intersects[0]);
        if (!this.found) {
            this.setDimentionVisibility(false);
            return;
        }
        this.measureObject.visible = true;
        const curFound = new three_1.Vector3();
        if (e.shiftKey) {
            const xDist = Math.sqrt(Math.pow(this.found.y - this.startPoint.y, 2) +
                Math.pow(this.found.z - this.startPoint.z, 2));
            const yDist = Math.sqrt(Math.pow(this.found.x - this.startPoint.x, 2) +
                Math.pow(this.found.z - this.startPoint.z, 2));
            const zDist = Math.sqrt(Math.pow(this.found.y - this.startPoint.y, 2) +
                Math.pow(this.found.x - this.startPoint.x, 2));
            const minDist = Math.min(xDist, yDist, zDist);
            switch (minDist) {
                case xDist:
                    curFound.x = this.found.x;
                    curFound.y = this.startPoint.y;
                    curFound.z = this.startPoint.z;
                    this.curAxis = "x";
                    break;
                case yDist:
                    curFound.x = this.startPoint.x;
                    curFound.y = this.found.y;
                    curFound.z = this.startPoint.z;
                    this.curAxis = "y";
                    break;
                case zDist:
                    curFound.x = this.startPoint.x;
                    curFound.y = this.startPoint.y;
                    curFound.z = this.found.z;
                    this.curAxis = "z";
                    break;
                default:
                    curFound.x = this.found.x;
                    curFound.y = this.found.y;
                    curFound.z = this.found.z;
                    this.curAxis = null;
                    break;
            }
        }
        else {
            curFound.x = this.found.x;
            curFound.y = this.found.y;
            curFound.z = this.found.z;
            this.curAxis = null;
        }
        if (this.measureInPros) {
            this.measureObject.position.set(curFound.x, curFound.y, curFound.z);
            this.endPoint = curFound;
            if (!this.currentDimension)
                this.currentDimension = this.drawDimension();
            this.currentDimension.endPoint = this.endPoint;
            this.setDimentionVisibility(true);
        }
        else {
            this.measureObject.position.set(this.found.x, this.found.y, this.found.z);
        }
    }
    setDimentionVisibility(bool) {
        if (this.currentDimension && this.currentDimension.line) {
            this.currentDimension.line.visible = bool;
            this.currentDimension.endpointMeshes.map((p) => (p.visible = bool));
            if (this.currentDimension.textLabel) {
                this.currentDimension.textLabel.visible = bool;
            }
        }
        this.measureObject.visible = bool;
    }
    dimentionsClickEventHandle() {
        if (this.measureStart &&
            !this.context.context.context.controls.moving) {
            const models = this.context.context.models;
            const meshes = Object.values(models)
                .map((m) => m.threeGeometry.children)
                .flat();
            const intersects = this.context.context.context.controls.getIntersects(meshes);
            if (!this.measureInPros) {
                if (intersects[0]) {
                    this.drawStart();
                    this.measureInPros = true;
                }
            }
            else {
                this.drawEnd();
                this.measureInPros = false;
            }
        }
    }
    toggleDimentionsActive() {
        this.snapDistance = 1;
        if (!this.measureStart) {
            this.measureStart = true;
            this.active = true;
            this._selectionState = {
                selection: this.context.context.selector.useSelection,
                preselection: this.context.context.selector.usePreSelection,
            };
            if (this._selectionState.preselection) {
                this.context.context.selector.usePreSelection = false;
            }
            if (this._selectionState.selection) {
                this.context.context.selector.useSelection = false;
            }
            this.context.context.container.addEventListener("mousemove", this.drawInProcessEvent_binded);
            this.context.context.container.addEventListener("click", this.dimensionsClickEventHandle_binded);
        }
        else {
            this.measureStart = false;
            this.measureInPros = false;
            this.active = false;
            this.context.context.container.removeEventListener("click", this.dimensionsClickEventHandle_binded);
            this.context.context.container.removeEventListener("mousemove", this.drawInProcessEvent_binded);
            if (this._selectionState.preselection) {
                this.context.context.selector.usePreSelection = true;
            }
            if (this._selectionState.selection) {
                this.context.context.selector.useSelection = true;
            }
            if (this.currentDimension) {
                this.currentDimension.removeFromScene();
                this.currentDimension = null;
                this.dragging = false;
            }
            this.measureObject.visible = false;
        }
    }
}
exports.DimensionsUtils = DimensionsUtils;


/***/ }),

/***/ 6044:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.GeometryUtils = void 0;
const three_1 = __webpack_require__(5232);
class GeometryUtils {
    constructor(context) {
        this.context = context;
        this.hideSelectedElements = () => {
            const selEls = this.context.context.selector.selectedElements;
            for (const modelIDStr of Object.keys(selEls)) {
                const modelID = Number(modelIDStr);
                const set = selEls[modelID];
                if (set.size === 0)
                    continue;
                this.hideElementsByIds(modelID, Array.from(set));
            }
        };
        this.isolateSelectedElements = () => {
            const selEls = this.context.context.selector.selectedElements;
            const models = this.context.context.models;
            for (const modelIDStr of Object.keys(models)) {
                const modelID = Number(modelIDStr);
                let set = selEls[modelID];
                if (set.size === 0) {
                    set = new Set();
                }
                this.isolateElementsByIds(modelID, Array.from(set));
            }
            if (this.context.clippingUtils.active) {
                this.context.clippingUtils.updateEdges();
            }
        };
        this.hideElementsByIds = (modelID, ids) => {
            const start = Date.now();
            this.context.context.context.renderer.needUpdate = false;
            const curModel = this.context.context.models[modelID];
            if (!curModel)
                return;
            const needsUpdate = new Set();
            for (const id of ids) {
                curModel.activeElements.delete(id);
                const curData = curModel.state.idsMap[id];
                if (!curData)
                    continue;
                Object.keys(curData).forEach((k) => {
                    if (k === "-1")
                        return;
                    needsUpdate.add(Number(k));
                    curModel.state.needsUpdate.add(Number(k));
                });
            }
            const map = {};
            for (const id of curModel.activeElements) {
                const curData = curModel.state.idsMap[id];
                if (!curData)
                    continue;
                for (const matId of Object.keys(curData)) {
                    if (matId === "-1" || !needsUpdate.has(Number(matId)))
                        continue;
                    const cur = map[matId];
                    if (cur) {
                        map[matId].push(curData[Number(matId)]);
                    }
                    else {
                        map[matId] = [curData[Number(matId)]];
                    }
                }
            }
            curModel.threeGeometry.children.forEach((child) => {
                const mesh = child;
                if (needsUpdate.has(Number(mesh.name))) {
                    const excludeInd = map[mesh.name];
                    if (!excludeInd) {
                        mesh.geometry.setIndex([]);
                    }
                    else {
                        let l = 0;
                        excludeInd.forEach((arr) => (l += arr.length));
                        const newArr = new three_1.BufferAttribute(new Uint32Array(l), 1);
                        let offset = 0;
                        excludeInd.forEach((arr) => {
                            newArr.set(arr, offset);
                            offset += arr.length;
                        });
                        mesh.geometry.setIndex(newArr);
                    }
                    this.context.context.bvhManager.update(mesh);
                }
            });
            if (this.context.clippingUtils.active) {
                this.context.clippingUtils.updateEdges();
            }
            this.update(modelID, ids, true);
            if (this.context.context.utils.stats) {
                console.log("hidding: ", Date.now() - start);
            }
        };
        this.isolateElementsByIds = (modelID, ids) => {
            const start = Date.now();
            this.context.context.context.renderer.needUpdate = false;
            const curModel = this.context.context.models[modelID];
            if (!curModel)
                return;
            const map = new Map();
            for (const id of ids) {
                const curData = curModel.state.idsMap[id];
                if (!curData)
                    continue;
                for (const matId of Object.keys(curData)) {
                    if (matId === "-1")
                        continue;
                    if (map.has(matId)) {
                        map.get(matId).push(curData[Number(matId)]);
                    }
                    else {
                        map.set(matId, [curData[Number(matId)]]);
                    }
                }
            }
            curModel.threeGeometry.children.forEach((child) => {
                const mesh = child;
                if (map.has(mesh.name)) {
                    const arrs = map.get(mesh.name);
                    let l = 0;
                    arrs.forEach((arr) => (l += arr.length));
                    const indexArr = new three_1.BufferAttribute(new Uint32Array(l), 1);
                    let offset = 0;
                    arrs.forEach((arr) => {
                        indexArr.set(arr, offset);
                        offset += arr.length;
                    });
                    mesh.geometry.setIndex(indexArr);
                }
                else {
                    mesh.geometry.setIndex([]);
                }
                curModel.state.needsUpdate.add(Number(mesh.name));
                this.context.context.bvhManager.update(mesh);
            });
            curModel.activeElements = new Set(ids);
            this.update(modelID, ids);
            if (this.context.context.utils.stats) {
                console.log("isolating: ", Date.now() - start);
            }
        };
        this.showAll = () => {
            const start = Date.now();
            this.context.context.context.renderer.needUpdate = false;
            for (const modelID of Object.keys(this.context.context.models)) {
                const curModel = this.context.context.models[Number(modelID)];
                this.resetModelVisibility(curModel);
                curModel.state.needsUpdate = new Set();
            }
            if (this.context.clippingUtils.active) {
                this.context.clippingUtils.updateEdges();
            }
            this.context.context.context.renderer.needUpdate = true;
            if (this.context.context.utils.stats) {
                console.log("showAll: ", Date.now() - start);
            }
        };
        this.createGeometryChunk = (config) => {
            const ids = config.ids;
            const start = Date.now();
            if (!ids.length) {
                return;
            }
            let material;
            material = config.material;
            if (!material) {
                let color = config.color;
                if (!color) {
                    color = new three_1.Color("#484848");
                }
                if (typeof color === "string") {
                    color = new three_1.Color(color);
                }
                material = new three_1.MeshLambertMaterial({ color });
            }
            const removePrevious = config.removePrevious;
            const modelID = config.modelID;
            const model = this.context.context.models[modelID];
            if (!model) {
                return new Error("unknown modelID");
            }
            const modelData = model.state;
            const chunkID = model.threeGeometry.children.length;
            const modelDataIds = modelData.idsMap;
            const modelDataInd = modelData.indMap;
            const dataToRemove = {};
            for (const id of ids) {
                const idData = modelDataIds[id];
                const newData = {
                    [chunkID]: [],
                };
                for (const matKey of Object.keys(idData)) {
                    const indData = idData[Number(matKey)];
                    if (Number(matKey) === -1) {
                        newData[-1] = indData;
                    }
                    else {
                        let curExData = dataToRemove[Number(matKey)];
                        if (!curExData) {
                            dataToRemove[Number(matKey)] = [indData];
                        }
                        else {
                            dataToRemove[Number(matKey)].push(indData);
                        }
                    }
                }
                modelDataIds[id] = structuredClone(newData);
            }
            const newPosAttr = [];
            const newIdsAttr = [];
            let newIndex = 0;
            let allIndexOfChunk = [];
            for (const matId_str of Object.keys(dataToRemove)) {
                if (matId_str === "-1")
                    continue;
                const matId = Number(matId_str);
                let curMesh;
                for (const child of model.threeGeometry.children) {
                    const mesh = child;
                    if (mesh.name === matId_str) {
                        curMesh = mesh;
                        break;
                    }
                }
                if (!curMesh)
                    return new Error("undefined mesh id");
                const posAttr = curMesh.geometry.attributes.position;
                const idsAttr = curMesh.geometry.attributes.ids;
                const curDataToRemove = [].concat.apply([], dataToRemove[matId]);
                curDataToRemove.forEach((ind) => {
                    allIndexOfChunk.push(newIndex);
                    newPosAttr.push(posAttr.getX(ind), posAttr.getY(ind), posAttr.getZ(ind));
                    const curId = idsAttr.getX(ind);
                    if (modelDataIds[curId][chunkID]) {
                        modelDataIds[curId][chunkID].push(newIndex);
                    }
                    else {
                        modelDataIds[curId][chunkID] = [newIndex];
                    }
                    newIdsAttr.push(curId);
                    newIndex++;
                });
            }
            const removeMatIds = Object.keys(dataToRemove);
            const map = {};
            for (const curData of Object.values(modelDataIds)) {
                for (const matId of Object.keys(curData)) {
                    if (matId === "-1" || !removeMatIds.includes(matId))
                        continue;
                    const cur = map[matId];
                    if (cur) {
                        map[matId].push(curData[Number(matId)]);
                    }
                    else {
                        map[matId] = [structuredClone(curData[Number(matId)])];
                    }
                }
            }
            model.threeGeometry.children.forEach((child) => {
                const mesh = child;
                if (removeMatIds.includes(mesh.name)) {
                    const excludeInd = map[mesh.name];
                    let newIndexes;
                    if (!excludeInd) {
                        newIndexes = new Uint32Array();
                    }
                    else {
                        let l = 0;
                        excludeInd.forEach((arr) => (l += arr.length));
                        newIndexes = new Uint32Array(l);
                        let offset = 0;
                        excludeInd.forEach((arr) => {
                            newIndexes.set(arr, offset);
                            offset += arr.length;
                        });
                    }
                    modelDataInd[Number(mesh.name)] = new Uint32Array(newIndexes);
                    mesh.geometry.setIndex(new three_1.BufferAttribute(newIndexes, 1));
                    this.context.context.bvhManager.update(mesh);
                }
            });
            modelDataInd[chunkID] = new Uint32Array(allIndexOfChunk);
            const geom = new three_1.BufferGeometry();
            geom.setAttribute("position", new three_1.BufferAttribute(new Float32Array(newPosAttr), 3));
            geom.setAttribute("ids", new three_1.BufferAttribute(new Uint32Array(newIdsAttr), 1));
            geom.computeVertexNormals();
            geom.setIndex(allIndexOfChunk);
            this.context.context.bvhManager.applyThreeMeshBVH(geom);
            const mesh = new three_1.Mesh(geom, material);
            model.threeGeometry.add(mesh);
            mesh.name = chunkID.toString();
            if (model.activeElements.size !== Object.keys(modelDataIds).length) {
                this.isolateElementsByIds(modelID, Array.from(model.activeElements));
            }
            if (this.context.context.utils.stats) {
                console.log("create Chunk: ", Date.now() - start);
            }
        };
    }
    update(modelID, ids, remove) {
        if (this.context.context.selector.isSelected && remove) {
            this.context.context.selector.selection.removeSelectByIds(modelID, ids);
        }
        this.context.context.selector.preSelection.resetPreselect();
        this.context.context.context.renderer.needUpdate = true;
    }
    resetModelVisibility(model) {
        for (const child of model.threeGeometry.children) {
            const mesh = child;
            if (!model.state.needsUpdate.has(Number(mesh.name))) {
                continue;
            }
            let indexArr = model.state.indMap[Number(mesh.name)];
            if (!indexArr) {
                indexArr = null;
            }
            mesh.geometry.setIndex(new three_1.BufferAttribute(indexArr, 1));
            this.context.context.bvhManager.update(mesh);
        }
        model.activeElements = new Set(Object.keys(model.state.idsMap).map((e) => Number(e)));
    }
    resetAllModelsChunks() {
        for (const model of Object.values(this.context.context.models)) {
            this.resetModelChunks(model.modelID);
        }
    }
    resetModelChunks(modelID) {
        const start = Date.now();
        this.context.context.context.renderer.needUpdate = false;
        const model = this.context.context.models[modelID];
        const modelState = model.state;
        const modelDefState = model.defaultState;
        modelState.idsMap = structuredClone(modelDefState.idsMap);
        modelState.indMap = structuredClone(modelDefState.indMap);
        modelState.needsUpdate = new Set();
        const toRemove = [];
        for (const child of model.threeGeometry.children) {
            const mesh = child;
            if (!modelDefState.indMap[Number(mesh.name)]) {
                toRemove.push(mesh);
            }
            else {
                modelState.needsUpdate.add(Number(mesh.name));
            }
        }
        toRemove.forEach((m) => m.removeFromParent());
        this.resetModelVisibility(model);
        model.state.needsUpdate = new Set();
        this.context.context.context.renderer.needUpdate = true;
        if (this.context.context.utils.stats) {
            console.log("resetModelChunks: ", Date.now() - start);
        }
    }
}
exports.GeometryUtils = GeometryUtils;


/***/ }),

/***/ 2959:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.KeysUtils = void 0;
class KeysUtils {
    constructor(context) {
        this.context = context;
    }
    isRemoveSelectionKey(e) {
        return e.ctrlKey || (this.context.osUtils.OS === "Mac" && e.altKey);
    }
    isMultySelect(e) {
        return e.shiftKey;
    }
    isBoxSelect(e) {
        return e.shiftKey;
    }
}
exports.KeysUtils = KeysUtils;


/***/ }),

/***/ 798:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ViewCubeContainer = void 0;
const three_1 = __webpack_require__(5232);
__webpack_require__(8309);
class ViewCubeContainer {
    constructor(context) {
        this.context = context;
        this._active = true;
        this.boundingSphere = null;
        if (this._active) {
            this.create();
        }
    }
    get active() {
        return this._active;
    }
    set active(bool) {
        if (!bool) {
            if (this.cubeContainer) {
                this.cubeContainer.remove();
            }
        }
        else {
            if (!this.cubeContainer) {
                this.create();
            }
        }
        this._active = bool;
    }
    epsilon(value) {
        return Math.abs(value) < 1e-10 ? 0 : value;
    }
    getCameraCSSMatrix(matrix) {
        const { elements } = matrix;
        return `matrix3d(
  ${this.epsilon(elements[0])},
  ${this.epsilon(-elements[1])},
  ${this.epsilon(elements[2])},
  ${this.epsilon(elements[3])},
  ${this.epsilon(elements[4])},
  ${this.epsilon(-elements[5])},
  ${this.epsilon(elements[6])},
  ${this.epsilon(elements[7])},
  ${this.epsilon(elements[8])},
  ${this.epsilon(-elements[9])},
  ${this.epsilon(elements[10])},
  ${this.epsilon(elements[11])},
  ${this.epsilon(elements[12])},
  ${this.epsilon(-elements[13])},
  ${this.epsilon(elements[14])},
  ${this.epsilon(elements[15])})`;
    }
    animate() {
        const cube = document.querySelector(".cube");
        if (!cube) {
            return;
        }
        const camera = this.context.context.context.camera.threeCamera;
        const mat = new three_1.Matrix4();
        setInterval(() => {
            if (cube && camera) {
                mat.extractRotation(camera.matrixWorldInverse);
                cube.style.transform = `translateZ(-500px) ${this.getCameraCSSMatrix(mat)}`;
            }
        }, 10);
    }
    switchPick(name) {
        const two = 3;
        const zero = 0;
        var r = 40;
        var c = new three_1.Vector3(zero, zero, zero);
        if (this.boundingSphere) {
            r = this.boundingSphere.radius * two - 40;
            c = this.boundingSphere.center;
        }
        const coords = new three_1.Vector3(zero, zero, zero);
        switch (name) {
            case "left":
                coords.x = -r + c.x;
                coords.y = c.y;
                coords.z = c.z;
                break;
            case "right":
                coords.x = r + c.x;
                coords.y = c.y;
                coords.z = c.z;
                break;
            case "top":
                coords.x = c.x;
                coords.y = r + c.y;
                coords.z = c.z;
                break;
            case "bottom":
                coords.x = c.x;
                coords.y = -r + c.y;
                coords.z = c.z;
                break;
            case "front":
                coords.x = c.x;
                coords.y = c.y;
                coords.z = r + c.z;
                break;
            case "back":
                coords.x = c.x;
                coords.y = c.y;
                coords.z = -r + c.z;
                break;
            case "left_front":
                coords.x = -r + c.x;
                coords.y = c.y;
                coords.z = r + c.z;
                break;
            case "left_back":
                coords.x = r + c.x;
                coords.y = c.y;
                coords.z = -r + c.z;
                break;
            case "right_front":
                coords.x = r + c.x;
                coords.y = c.y;
                coords.z = r + c.z;
                break;
            case "right_back":
                coords.x = -r + c.x;
                coords.y = c.y;
                coords.z = -r + c.z;
                break;
            case "top_left":
                coords.x = -r + c.x;
                coords.y = r + c.y;
                coords.z = c.z;
                break;
            case "top_right":
                coords.x = r + c.x;
                coords.y = r + c.y;
                coords.z = c.z;
                break;
            case "top_front":
                coords.x = c.x;
                coords.y = r + c.y;
                coords.z = r + c.z;
                break;
            case "top_back":
                coords.x = c.x;
                coords.y = r + c.y;
                coords.z = -r + c.z;
                break;
            case "bottom_left":
                coords.x = -r + c.x;
                coords.y = -r + c.y;
                coords.z = c.z;
                break;
            case "bottom_right":
                coords.x = r + c.x;
                coords.y = -r + c.y;
                coords.z = c.z;
                break;
            case "bottom_front":
                coords.x = c.x;
                coords.y = -r + c.y;
                coords.z = r + c.z;
                break;
            case "bottom_back":
                coords.x = c.x;
                coords.y = -r + c.y;
                coords.z = -r + c.z;
                break;
            case "front_left":
                coords.x = r + c.x;
                coords.y = c.y;
                coords.z = r + c.z;
                break;
            case "right_left":
                coords.x = r + c.x;
                coords.y = c.y;
                coords.z = r + c.z;
                break;
            case "left_right":
                coords.x = r + c.x;
                coords.y = c.y;
                coords.z = -r + c.z;
                break;
            case "back_left":
                coords.x = -r + c.x;
                coords.y = c.y;
                coords.z = r + c.z;
                break;
            case "front_right":
                coords.x = r + c.x;
                coords.y = c.y;
                coords.z = -r + c.z;
                break;
            case "back_right":
                coords.x = r + c.x;
                coords.y = c.y;
                coords.z = -r + c.z;
                break;
            case "left_top":
                coords.x = c.x;
                coords.y = r + c.y;
                coords.z = r + c.z;
                break;
            case "right_top":
                coords.x = c.x;
                coords.y = r + c.y;
                coords.z = -r + c.z;
                break;
            case "front_top":
                coords.x = r + c.x;
                coords.y = r + c.y;
                coords.z = c.z;
                break;
            case "back_top":
                coords.x = -r + c.x;
                coords.y = r + c.y;
                coords.z = c.z;
                break;
            case "left_bottom":
                coords.x = c.x;
                coords.y = -r + c.y;
                coords.z = r + c.z;
                break;
            case "right_bottom":
                coords.x = r + c.x;
                coords.y = -r + c.y;
                coords.z = c.z;
                break;
            case "front_bottom":
                coords.x = r + c.x;
                coords.y = -r + c.y;
                coords.z = c.z;
                break;
            case "back_bottom":
                coords.x = -r + c.x;
                coords.y = -r + c.y;
                coords.z = c.z;
                break;
            case "top_left_front":
                coords.x = -r + c.x;
                coords.y = r + c.y;
                coords.z = r + c.z;
                break;
            case "top_left_back":
                coords.x = r + c.x;
                coords.y = r + c.y;
                coords.z = -r + c.z;
                break;
            case "top_right_front":
                coords.x = r + c.x;
                coords.y = r + c.y;
                coords.z = r + c.z;
                break;
            case "top_right_back":
                coords.x = -r + c.x;
                coords.y = r + c.y;
                coords.z = -r + c.z;
                break;
            case "bottom_left_front":
                coords.x = -r + c.x;
                coords.y = -r + c.y;
                coords.z = r + c.z;
                break;
            case "bottom_left_back":
                coords.x = -r + c.x;
                coords.y = -r + c.y;
                coords.z = -r + c.z;
                break;
            case "bottom_right_front":
                coords.x = r + c.x;
                coords.y = -r + c.y;
                coords.z = r + c.z;
                break;
            case "bottom_right_back":
                coords.x = r + c.x;
                coords.y = -r + c.y;
                coords.z = -r + c.z;
                break;
            default:
                break;
        }
        const controls = this.context.context.context.controls.cameraControl;
        controls.setPosition(coords.x, coords.y, coords.z, true);
        controls.setLookAt(coords.x, coords.y, coords.z, c.x, c.y, c.z, true);
    }
    hoverFunc(e) {
        for (let el of e.target.children) {
            el.style.background = "#7d7d7d";
            el.style.color = "#fff";
        }
    }
    unHoverFunc(e) {
        for (let el of e.target.children) {
            el.style.background = "#ddd";
            el.style.color = "#7d7d7d";
        }
    }
    updateBoundingSphere() {
        this.boundingSphere = new three_1.Sphere().setFromPoints([
            this.context.context.context.sizes.modelSize.max,
            this.context.context.context.sizes.modelSize.min,
        ]);
    }
    create(parent) {
        if (!parent) {
            parent = document.body;
        }
        const wrapDiv = document.createElement("div");
        this.cubeContainer = wrapDiv;
        wrapDiv.id = "cube__wrap";
        wrapDiv.classList.add("cube__wrap");
        parent.appendChild(wrapDiv);
        const cube = document.createElement("div");
        cube.id = "cube";
        cube.classList.add("cube");
        wrapDiv.appendChild(cube);
        const cfb = document.createElement("div");
        cfb.classList.add("cube__face");
        cfb.classList.add("cube__face--bottom");
        cfb.addEventListener("click", () => this.switchPick("bottom"));
        cfb.innerHTML = "bot";
        cube.appendChild(cfb);
        const cft = document.createElement("div");
        cft.classList.add("cube__face");
        cft.classList.add("cube__face--top");
        cft.addEventListener("click", () => this.switchPick("top"));
        cft.innerHTML = "top";
        cube.appendChild(cft);
        const cfr = document.createElement("div");
        cfr.classList.add("cube__face");
        cfr.classList.add("cube__face--right");
        cfr.addEventListener("click", () => this.switchPick("right"));
        cfr.innerHTML = "right";
        cube.appendChild(cfr);
        const cfl = document.createElement("div");
        cfl.classList.add("cube__face");
        cfl.classList.add("cube__face--left");
        cfl.addEventListener("click", () => this.switchPick("left"));
        cfl.innerHTML = "left";
        cube.appendChild(cfl);
        const cff = document.createElement("div");
        cff.classList.add("cube__face");
        cff.classList.add("cube__face--front");
        cff.addEventListener("click", () => this.switchPick("front"));
        cff.innerHTML = "front";
        cube.appendChild(cff);
        const cfbk = document.createElement("div");
        cfbk.classList.add("cube__face");
        cfbk.classList.add("cube__face--back");
        cfbk.addEventListener("click", () => this.switchPick("back"));
        cfbk.innerHTML = "back";
        cube.appendChild(cfbk);
        const tl = document.createElement("div");
        tl.classList.add("cube__face__face__edge__wrap");
        tl.addEventListener("click", () => this.switchPick("top_left"));
        tl.addEventListener("mouseenter", this.hoverFunc);
        tl.addEventListener("mouseleave", this.unHoverFunc);
        cube.appendChild(tl);
        const tlc1 = document.createElement("div");
        tlc1.classList.add("cube__face__face__edge");
        tlc1.classList.add("cube__face--top--left");
        tl.appendChild(tlc1);
        const tlc2 = document.createElement("div");
        tlc2.classList.add("cube__face__face__edge");
        tlc2.classList.add("cube__face--left--top");
        tl.appendChild(tlc2);
        const tr = document.createElement("div");
        tr.classList.add("cube__face__face__edge__wrap");
        tr.addEventListener("click", () => this.switchPick("top_right"));
        tr.addEventListener("mouseenter", this.hoverFunc);
        tr.addEventListener("mouseleave", this.unHoverFunc);
        cube.appendChild(tr);
        const trc1 = document.createElement("div");
        trc1.classList.add("cube__face__face__edge");
        trc1.classList.add("cube__face--top--right");
        tr.appendChild(trc1);
        const trc2 = document.createElement("div");
        trc2.classList.add("cube__face__face__edge");
        trc2.classList.add("cube__face--right--top");
        tr.appendChild(trc2);
        const bl = document.createElement("div");
        bl.classList.add("cube__face__face__edge__wrap");
        bl.addEventListener("click", () => this.switchPick("bottom_left"));
        bl.addEventListener("mouseenter", this.hoverFunc);
        bl.addEventListener("mouseleave", this.unHoverFunc);
        cube.appendChild(bl);
        const blc1 = document.createElement("div");
        blc1.classList.add("cube__face__face__edge");
        blc1.classList.add("cube__face--bottom--left");
        bl.appendChild(blc1);
        const blc2 = document.createElement("div");
        blc2.classList.add("cube__face__face__edge");
        blc2.classList.add("cube__face--left--bottom");
        bl.appendChild(blc2);
        const br = document.createElement("div");
        br.classList.add("cube__face__face__edge__wrap");
        br.addEventListener("click", () => this.switchPick("bottom_right"));
        br.addEventListener("mouseenter", this.hoverFunc);
        br.addEventListener("mouseleave", this.unHoverFunc);
        cube.appendChild(br);
        const brc1 = document.createElement("div");
        brc1.classList.add("cube__face__face__edge");
        brc1.classList.add("cube__face--bottom--right");
        br.appendChild(brc1);
        const brc2 = document.createElement("div");
        brc2.classList.add("cube__face__face__edge");
        brc2.classList.add("cube__face--right--bottom");
        br.appendChild(brc2);
        const bf = document.createElement("div");
        bf.classList.add("cube__face__face__edge__wrap");
        bf.addEventListener("click", () => this.switchPick("bottom_front"));
        bf.addEventListener("mouseenter", this.hoverFunc);
        bf.addEventListener("mouseleave", this.unHoverFunc);
        cube.appendChild(bf);
        const bfc1 = document.createElement("div");
        bfc1.classList.add("cube__face__face__edge");
        bfc1.classList.add("cube__face--front--bottom");
        bf.appendChild(bfc1);
        const bfc2 = document.createElement("div");
        bfc2.classList.add("cube__face__face__edge");
        bfc2.classList.add("cube__face--bottom--front");
        bf.appendChild(bfc2);
        const bb = document.createElement("div");
        bb.classList.add("cube__face__face__edge__wrap");
        bb.addEventListener("click", () => this.switchPick("bottom_back"));
        bb.addEventListener("mouseenter", this.hoverFunc);
        bb.addEventListener("mouseleave", this.unHoverFunc);
        cube.appendChild(bb);
        const bbc1 = document.createElement("div");
        bbc1.classList.add("cube__face__face__edge");
        bbc1.classList.add("cube__face--back--bottom");
        bb.appendChild(bbc1);
        const bbc2 = document.createElement("div");
        bbc2.classList.add("cube__face__face__edge");
        bbc2.classList.add("cube__face--bottom--back");
        bb.appendChild(bbc2);
        const tf = document.createElement("div");
        tf.classList.add("cube__face__face__edge__wrap");
        tf.addEventListener("click", () => this.switchPick("top_front"));
        tf.addEventListener("mouseenter", this.hoverFunc);
        tf.addEventListener("mouseleave", this.unHoverFunc);
        cube.appendChild(tf);
        const tfc1 = document.createElement("div");
        tfc1.classList.add("cube__face__face__edge");
        tfc1.classList.add("cube__face--front--top");
        tf.appendChild(tfc1);
        const tfc2 = document.createElement("div");
        tfc2.classList.add("cube__face__face__edge");
        tfc2.classList.add("cube__face--top--front");
        tf.appendChild(tfc2);
        const tb = document.createElement("div");
        tb.classList.add("cube__face__face__edge__wrap");
        tb.addEventListener("click", () => this.switchPick("top_back"));
        tb.addEventListener("mouseenter", this.hoverFunc);
        tb.addEventListener("mouseleave", this.unHoverFunc);
        cube.appendChild(tb);
        const tbc1 = document.createElement("div");
        tbc1.classList.add("cube__face__face__edge");
        tbc1.classList.add("cube__face--back--top");
        tb.appendChild(tbc1);
        const tbc2 = document.createElement("div");
        tbc2.classList.add("cube__face__face__edge");
        tbc2.classList.add("cube__face--top--back");
        tb.appendChild(tbc2);
        const lb = document.createElement("div");
        lb.classList.add("cube__face__face__edge__wrap");
        lb.addEventListener("click", () => this.switchPick("left_back"));
        lb.addEventListener("mouseenter", this.hoverFunc);
        lb.addEventListener("mouseleave", this.unHoverFunc);
        cube.appendChild(lb);
        const lbc1 = document.createElement("div");
        lbc1.classList.add("cube__face__face__edge");
        lbc1.classList.add("cube__face--back--left");
        lb.appendChild(lbc1);
        const lbc2 = document.createElement("div");
        lbc2.classList.add("cube__face__face__edge");
        lbc2.classList.add("cube__face--left--back");
        lb.appendChild(lbc2);
        const rb = document.createElement("div");
        rb.classList.add("cube__face__face__edge__wrap");
        rb.addEventListener("click", () => this.switchPick("right_back"));
        rb.addEventListener("mouseenter", this.hoverFunc);
        rb.addEventListener("mouseleave", this.unHoverFunc);
        cube.appendChild(rb);
        const rbc1 = document.createElement("div");
        rbc1.classList.add("cube__face__face__edge");
        rbc1.classList.add("cube__face--back--right");
        rb.appendChild(rbc1);
        const rbc2 = document.createElement("div");
        rbc2.classList.add("cube__face__face__edge");
        rbc2.classList.add("cube__face--right--back");
        rb.appendChild(rbc2);
        const rf = document.createElement("div");
        rf.classList.add("cube__face__face__edge__wrap");
        rf.addEventListener("click", () => this.switchPick("right_front"));
        rf.addEventListener("mouseenter", this.hoverFunc);
        rf.addEventListener("mouseleave", this.unHoverFunc);
        cube.appendChild(rf);
        const rfc1 = document.createElement("div");
        rfc1.classList.add("cube__face__face__edge");
        rfc1.classList.add("cube__face--front--right");
        rf.appendChild(rfc1);
        const rfc2 = document.createElement("div");
        rfc2.classList.add("cube__face__face__edge");
        rfc2.classList.add("cube__face--right--front");
        rf.appendChild(rfc2);
        const lf = document.createElement("div");
        lf.classList.add("cube__face__face__edge__wrap");
        lf.addEventListener("click", () => this.switchPick("left_front"));
        lf.addEventListener("mouseenter", this.hoverFunc);
        lf.addEventListener("mouseleave", this.unHoverFunc);
        cube.appendChild(lf);
        const lfc1 = document.createElement("div");
        lfc1.classList.add("cube__face__face__edge");
        lfc1.classList.add("cube__face--front--left");
        lf.appendChild(lfc1);
        const lfc2 = document.createElement("div");
        lfc2.classList.add("cube__face__face__edge");
        lfc2.classList.add("cube__face--left--front");
        lf.appendChild(lfc2);
        const tlf = document.createElement("div");
        tlf.classList.add("cube__face__face__edge__wrap");
        tlf.addEventListener("click", () => this.switchPick("top_left_front"));
        tlf.addEventListener("mouseenter", this.hoverFunc);
        tlf.addEventListener("mouseleave", this.unHoverFunc);
        cube.appendChild(tlf);
        const tlfc1 = document.createElement("div");
        tlfc1.classList.add("cube__face__face__edge");
        tlfc1.classList.add("cube__edge--left--front--top");
        tlf.appendChild(tlfc1);
        const tlfc2 = document.createElement("div");
        tlfc2.classList.add("cube__face__face__edge");
        tlfc2.classList.add("cube__edge--front--left--top");
        tlf.appendChild(tlfc2);
        const tlfc3 = document.createElement("div");
        tlfc3.classList.add("cube__face__face__edge");
        tlfc3.classList.add("cube__edge--top--left--front");
        tlf.appendChild(tlfc3);
        const trf = document.createElement("div");
        trf.classList.add("cube__face__face__edge__wrap");
        trf.addEventListener("click", () => this.switchPick("top_right_front"));
        trf.addEventListener("mouseenter", this.hoverFunc);
        trf.addEventListener("mouseleave", this.unHoverFunc);
        cube.appendChild(trf);
        const trfc1 = document.createElement("div");
        trfc1.classList.add("cube__face__face__edge");
        trfc1.classList.add("cube__edge--right--front--top");
        trf.appendChild(trfc1);
        const trfc2 = document.createElement("div");
        trfc2.classList.add("cube__face__face__edge");
        trfc2.classList.add("cube__edge--front--right--top");
        trf.appendChild(trfc2);
        const trfc3 = document.createElement("div");
        trfc3.classList.add("cube__face__face__edge");
        trfc3.classList.add("cube__edge--top--right--front");
        trf.appendChild(trfc3);
        const tlb = document.createElement("div");
        tlb.classList.add("cube__face__face__edge__wrap");
        tlb.addEventListener("click", () => this.switchPick("top_left_back"));
        tlb.addEventListener("mouseenter", this.hoverFunc);
        tlb.addEventListener("mouseleave", this.unHoverFunc);
        cube.appendChild(tlb);
        const tlbc1 = document.createElement("div");
        tlbc1.classList.add("cube__face__face__edge");
        tlbc1.classList.add("cube__edge--back--left--top");
        tlb.appendChild(tlbc1);
        const tlbc2 = document.createElement("div");
        tlbc2.classList.add("cube__face__face__edge");
        tlbc2.classList.add("cube__edge--left--back--top");
        tlb.appendChild(tlbc2);
        const tlbc3 = document.createElement("div");
        tlbc3.classList.add("cube__face__face__edge");
        tlbc3.classList.add("cube__edge--top--left--back");
        tlb.appendChild(tlbc3);
        const trb = document.createElement("div");
        trb.classList.add("cube__face__face__edge__wrap");
        trb.addEventListener("click", () => this.switchPick("top_right_back"));
        trb.addEventListener("mouseenter", this.hoverFunc);
        trb.addEventListener("mouseleave", this.unHoverFunc);
        cube.appendChild(trb);
        const trbc1 = document.createElement("div");
        trbc1.classList.add("cube__face__face__edge");
        trbc1.classList.add("cube__edge--back--right--top");
        trb.appendChild(trbc1);
        const trbc2 = document.createElement("div");
        trbc2.classList.add("cube__face__face__edge");
        trbc2.classList.add("cube__edge--right--back--top");
        trb.appendChild(trbc2);
        const trbc3 = document.createElement("div");
        trbc3.classList.add("cube__face__face__edge");
        trbc3.classList.add("cube__edge--top--right--back");
        trb.appendChild(trbc3);
        const blf = document.createElement("div");
        blf.classList.add("cube__face__face__edge__wrap");
        blf.addEventListener("click", () => this.switchPick("bottom_left_front"));
        blf.addEventListener("mouseenter", this.hoverFunc);
        blf.addEventListener("mouseleave", this.unHoverFunc);
        cube.appendChild(blf);
        const blfc1 = document.createElement("div");
        blfc1.classList.add("cube__face__face__edge");
        blfc1.classList.add("cube__edge--left--front--bottom");
        blf.appendChild(blfc1);
        const blfc2 = document.createElement("div");
        blfc2.classList.add("cube__face__face__edge");
        blfc2.classList.add("cube__edge--front--left--bottom");
        blf.appendChild(blfc2);
        const blfc3 = document.createElement("div");
        blfc3.classList.add("cube__face__face__edge");
        blfc3.classList.add("cube__edge--bottom--left--front");
        blf.appendChild(blfc3);
        const brf = document.createElement("div");
        brf.classList.add("cube__face__face__edge__wrap");
        brf.addEventListener("click", () => this.switchPick("bottom_right_front"));
        brf.addEventListener("mouseenter", this.hoverFunc);
        brf.addEventListener("mouseleave", this.unHoverFunc);
        cube.appendChild(brf);
        const brfc1 = document.createElement("div");
        brfc1.classList.add("cube__face__face__edge");
        brfc1.classList.add("cube__edge--right--front--bottom");
        brf.appendChild(brfc1);
        const brfc2 = document.createElement("div");
        brfc2.classList.add("cube__face__face__edge");
        brfc2.classList.add("cube__edge--front--right--bottom");
        brf.appendChild(brfc2);
        const brfc3 = document.createElement("div");
        brfc3.classList.add("cube__face__face__edge");
        brfc3.classList.add("cube__edge--bottom--right--front");
        brf.appendChild(brfc3);
        const brb = document.createElement("div");
        brb.classList.add("cube__face__face__edge__wrap");
        brb.addEventListener("click", () => this.switchPick("bottom_right_back"));
        brb.addEventListener("mouseenter", this.hoverFunc);
        brb.addEventListener("mouseleave", this.unHoverFunc);
        cube.appendChild(brb);
        const brbc1 = document.createElement("div");
        brbc1.classList.add("cube__face__face__edge");
        brbc1.classList.add("cube__edge--back--left--bottom");
        brb.appendChild(brbc1);
        const brbc2 = document.createElement("div");
        brbc2.classList.add("cube__face__face__edge");
        brbc2.classList.add("cube__edge--left--back--bottom");
        brb.appendChild(brbc2);
        const brbc3 = document.createElement("div");
        brbc3.classList.add("cube__face__face__edge");
        brbc3.classList.add("cube__edge--bottom--left--back");
        brb.appendChild(brbc3);
        const blb = document.createElement("div");
        blb.classList.add("cube__face__face__edge__wrap");
        blb.addEventListener("click", () => this.switchPick("bottom_left_back"));
        blb.addEventListener("mouseenter", this.hoverFunc);
        blb.addEventListener("mouseleave", this.unHoverFunc);
        cube.appendChild(blb);
        const blbc1 = document.createElement("div");
        blbc1.classList.add("cube__face__face__edge");
        blbc1.classList.add("cube__edge--back--right--bottom");
        blb.appendChild(blbc1);
        const blbc2 = document.createElement("div");
        blbc2.classList.add("cube__face__face__edge");
        blbc2.classList.add("cube__edge--right--back--bottom");
        blb.appendChild(blbc2);
        const blbc3 = document.createElement("div");
        blbc3.classList.add("cube__face__face__edge");
        blbc3.classList.add("cube__edge--bottom--right--back");
        blb.appendChild(blbc3);
        this.animate();
    }
}
exports.ViewCubeContainer = ViewCubeContainer;


/***/ }),

/***/ 4004:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.OsUtils = void 0;
class OsUtils {
    constructor(context) {
        this.context = context;
        this.OS = this.getOS();
    }
    getOS() {
        let os = "unknown";
        const userAgent = window.navigator.userAgent;
        const platform = window.navigator.platform;
        const macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"];
        const windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"];
        const iosPlatforms = ["iPhone", "iPad", "iPod"];
        if (macosPlatforms.indexOf(platform) !== -1) {
            os = "Mac";
        }
        else if (iosPlatforms.indexOf(platform) !== -1) {
            this.setMobileSettings();
            os = "IOS";
        }
        else if (windowsPlatforms.indexOf(platform) !== -1) {
            os = "Windows";
        }
        else if (/Android/.test(userAgent)) {
            this.setMobileSettings();
            os = "Android";
        }
        else if (os === "unknown" && /Linux/.test(platform)) {
            os = "Linux";
        }
        return os;
    }
    setMobileSettings() {
        this.context.context.selector.usePreSelection = false;
        this.context.context.context.controls.cameraControl.truckSpeed = 1.6;
        this.context.context.context.controls.cameraControl.dollySpeed = 1;
        this.context.context.context.controls.cameraControl.azimuthRotateSpeed = 1;
        this.context.context.context.renderer.removeCallback(this.context.context.selector.selectionBox.renderSelectionBind);
    }
}
exports.OsUtils = OsUtils;


/***/ }),

/***/ 6378:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PropsUtils = void 0;
class PropsUtils {
    constructor(context) {
        this.context = context;
        this.useDefaultGetPropertiesById = true;
    }
    getPropertiesById(modelID, elementId) {
        if (this._getPropertiesByIdOveride) {
            const result = this._getPropertiesByIdOveride(modelID, elementId);
            if (result) {
                return result;
            }
        }
        if (elementId === undefined || modelID === undefined) {
            return;
        }
        if (this.useDefaultGetPropertiesById) {
            const curProp = this.context.context.models[modelID].properties.data[elementId];
            if (!curProp) {
                return;
            }
            if (this.propConteiner) {
                this.generatePropsThree(curProp);
            }
            return curProp;
        }
    }
    setGetParamsByIdOverride(func, returnExSelection = false) {
        this._getPropertiesByIdOveride = func;
        if (func && returnExSelection) {
            let exSelection;
            for (const modelID of Object.keys(this.context.context.selector.selectedElements)) {
                const elements = this.context.context.selector.selectedElements[Number(modelID)];
                if (elements.size === 1) {
                    if (exSelection) {
                        exSelection = undefined;
                        break;
                    }
                    exSelection = {
                        modelID: Number(modelID),
                        element_id: elements.values().next().value,
                    };
                }
            }
            if (exSelection) {
                func(exSelection.modelID, exSelection.element_id);
            }
        }
    }
    initPropConteiner(conteiner) {
        this.propConteiner = conteiner;
    }
    generatePropsThree(curProp) {
        var _a, _b, _c, _d, _e;
        (_a = this.propConteiner) === null || _a === void 0 ? void 0 : _a.replaceChildren();
        const params = document.createElement("h4");
        params.innerHTML = "Идентификаторы элемента";
        (_b = this.propConteiner) === null || _b === void 0 ? void 0 : _b.appendChild(params);
        const props = curProp.props;
        const typeProps = curProp.tprops;
        const propSets = curProp.sets;
        const row1 = document.createElement("div");
        row1.style.display = "flex";
        row1.style.justifyContent = "center";
        row1.style.flexDirection = "row";
        const paramNameDiv1 = document.createElement("div");
        const paramValueDiv1 = document.createElement("div");
        row1.appendChild(paramNameDiv1);
        row1.appendChild(paramValueDiv1);
        paramNameDiv1.innerHTML = "guid: ";
        paramNameDiv1.style.marginRight = "5px";
        paramValueDiv1.innerHTML = curProp.guid;
        const row2 = document.createElement("div");
        row2.style.display = "flex";
        row2.style.justifyContent = "center";
        row2.style.flexDirection = "row";
        const paramNameDiv2 = document.createElement("div");
        const paramValueDiv2 = document.createElement("div");
        row2.appendChild(paramNameDiv2);
        row2.appendChild(paramValueDiv2);
        paramNameDiv2.innerHTML = "id: ";
        paramNameDiv2.style.marginRight = "5px";
        paramValueDiv2.innerHTML = curProp.id.toString();
        this.propConteiner.appendChild(row1);
        this.propConteiner.appendChild(row2);
        if (props && Object.keys(props).length) {
            const params = document.createElement("h4");
            params.innerHTML = "Параметры экземпляра";
            (_c = this.propConteiner) === null || _c === void 0 ? void 0 : _c.appendChild(params);
            for (const paramName of Object.keys(props)) {
                const paramValue = props[paramName];
                const row = document.createElement("div");
                this.propConteiner.appendChild(row);
                row.style.display = "flex";
                row.style.justifyContent = "center";
                row.style.flexDirection = "row";
                const paramNameDiv = document.createElement("div");
                paramNameDiv.style.marginRight = "5px";
                const paramValueDiv = document.createElement("div");
                row.appendChild(paramNameDiv);
                row.appendChild(paramValueDiv);
                paramNameDiv.innerHTML = paramName + ": ";
                paramValueDiv.innerHTML = paramValue ? paramValue : "";
            }
        }
        if (typeProps && Object.keys(typeProps).length) {
            const params = document.createElement("h4");
            params.innerHTML = "Параметры типа";
            (_d = this.propConteiner) === null || _d === void 0 ? void 0 : _d.appendChild(params);
            for (const paramName of Object.keys(typeProps)) {
                const paramValue = typeProps[paramName];
                const row = document.createElement("div");
                this.propConteiner.appendChild(row);
                row.style.display = "flex";
                row.style.justifyContent = "center";
                row.style.flexDirection = "row";
                const paramNameDiv = document.createElement("div");
                paramNameDiv.style.marginRight = "5px";
                const paramValueDiv = document.createElement("div");
                row.appendChild(paramNameDiv);
                row.appendChild(paramValueDiv);
                paramNameDiv.innerHTML = paramName + ": ";
                paramValueDiv.innerHTML = paramValue ? paramValue : "";
            }
        }
        if (propSets && propSets.length) {
            for (const set of propSets) {
                const params = document.createElement("h4");
                params.innerHTML = set.name;
                (_e = this.propConteiner) === null || _e === void 0 ? void 0 : _e.appendChild(params);
                for (const param of set.props) {
                    const paramName = param.Name;
                    let paramValue;
                    if (param.isQuantities) {
                        if (props.LengthValue) {
                            paramValue =
                                Math.round(props.LengthValue * 100) / 100;
                        }
                        else if (props.WeightValue) {
                            paramValue =
                                Math.round(props.WeightValue * 100) / 100;
                        }
                        else if (props.VolumeValue) {
                            paramValue =
                                Math.round(props.VolumeValue * 100) / 100;
                        }
                        else if (props.AreaValue) {
                            paramValue =
                                Math.round(props.AreaValue * 100) / 100;
                        }
                    }
                    else {
                        paramValue = param.NominalValue;
                    }
                    const row = document.createElement("div");
                    this.propConteiner.appendChild(row);
                    row.style.display = "flex";
                    row.style.justifyContent = "center";
                    row.style.flexDirection = "row";
                    const paramNameDiv = document.createElement("div");
                    paramNameDiv.style.marginRight = "5px";
                    const paramValueDiv = document.createElement("div");
                    row.appendChild(paramNameDiv);
                    row.appendChild(paramValueDiv);
                    paramNameDiv.innerHTML = paramName + ": ";
                    paramValueDiv.innerHTML = paramValue ? paramValue : "";
                }
            }
        }
    }
}
exports.PropsUtils = PropsUtils;


/***/ }),

/***/ 3236:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Utils = void 0;
const GeometryUtils_1 = __webpack_require__(6044);
const PropsUtils_1 = __webpack_require__(6378);
const stats_module_js_1 = __webpack_require__(5079);
const ClippingUtils_1 = __webpack_require__(7388);
const NavigationCube_1 = __webpack_require__(798);
const decoder_1 = __webpack_require__(730);
const DimentionsUtils_1 = __webpack_require__(5448);
const OsUtils_1 = __webpack_require__(4004);
const KeysUtils_1 = __webpack_require__(2959);
const lil_gui_esm_1 = __webpack_require__(1990);
class Utils {
    constructor(context) {
        this.context = context;
        this.propsUtils = new PropsUtils_1.PropsUtils(this);
        this.geometryUtils = new GeometryUtils_1.GeometryUtils(this);
        this.clippingUtils = new ClippingUtils_1.ClippingUtils(this);
        this.dimentionsUtils = new DimentionsUtils_1.DimensionsUtils(this);
        this.navigationCubeUtil = new NavigationCube_1.ViewCubeContainer(this);
        this.osUtils = new OsUtils_1.OsUtils(this);
        this.keysUtils = new KeysUtils_1.KeysUtils(this);
        this.decoder = decoder_1.default;
        this.gui = new lil_gui_esm_1.default();
        this.gui.hide();
    }
    set useStats(useStats) {
        var _a;
        if (useStats) {
            this.stats = new stats_module_js_1.default();
            this.stats.showPanel(1);
            document.body.appendChild(this.stats.dom);
        }
        else {
            (_a = this.stats) === null || _a === void 0 ? void 0 : _a.dom.remove();
            this.stats = undefined;
        }
    }
    disposeMeshRecursively(mesh) {
        mesh.removeFromParent();
        if (mesh.geometry)
            mesh.geometry.dispose();
        if (mesh.material) {
            if (Array.isArray(mesh.material))
                mesh.material.forEach((mat) => mat.dispose());
            else
                mesh.material.dispose();
        }
        if (mesh.children && mesh.children.length) {
            mesh.children.forEach((child) => this.disposeMeshRecursively(child));
        }
        mesh.children.length = 0;
    }
}
exports.Utils = Utils;


/***/ }),

/***/ 692:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BvhManager = void 0;
const three_1 = __webpack_require__(5232);
const three_mesh_bvh_1 = __webpack_require__(885);
class BvhManager {
    constructor(context) {
        this.context = context;
        this._worker = null;
        this.computeBoundsTree = three_mesh_bvh_1.computeBoundsTree;
        this.disposeBoundsTree = three_mesh_bvh_1.disposeBoundsTree;
        this.acceleratedRaycast = three_mesh_bvh_1.acceleratedRaycast;
        this.setupThreeMeshBVH();
    }
    set useWorker(worker) {
        var _a;
        if (!worker) {
            (_a = this._worker) === null || _a === void 0 ? void 0 : _a.terminate();
            this._worker = null;
            return;
        }
        worker.onerror = (e) => {
            if (e.message) {
                throw new Error(`GenerateMeshBVHWorker: Could not create Web Worker with error "${e.message}"`);
            }
            else {
                throw new Error("GenerateMeshBVHWorker: Could not create Web Worker.");
            }
        };
        this._worker = worker;
    }
    get useWorker() {
        return this._worker;
    }
    applyThreeMeshBVH(geometry) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._worker) {
                geometry.boundsTree = yield this.generate(geometry, {
                    maxDepth: this.maxDepth ? this.maxDepth : 100,
                });
            }
            else {
                if (!geometry.computeBoundsTree) {
                    geometry.computeBoundsTree = this.computeBoundsTree;
                }
                geometry.computeBoundsTree({
                    maxDepth: this.maxDepth ? this.maxDepth : 100,
                });
            }
        });
    }
    generate(geometry, options = {}) {
        if (this._worker === null) {
            throw new Error("GenerateMeshBVHWorker: Worker has been disposed.");
        }
        return new Promise((resolve, reject) => {
            this._worker.onerror = (e) => {
                reject(new Error(`GenerateMeshBVHWorker: ${e.message}`));
            };
            this._worker.onmessage = (e) => {
                const { data } = e;
                if (data.error) {
                    reject(new Error(data.error));
                    this._worker.onmessage = null;
                }
                else if (data.serialized) {
                    const { serialized } = data;
                    try {
                        const bvh = three_mesh_bvh_1.MeshBVH.deserialize(serialized, geometry, {
                            setIndex: true,
                        });
                        resolve(bvh);
                    }
                    catch (e) {
                        console.log(e);
                    }
                    this._worker.onmessage = null;
                }
                else if (options.onProgress) {
                    options.onProgress(data.progress);
                }
            };
            const index = geometry.index ? geometry.index.array : null;
            const position = geometry.attributes.position.array;
            this._worker.postMessage({
                index,
                position,
                options: Object.assign({}, options),
            });
        });
    }
    update(mesh) {
        if (mesh) {
            this.updateByMesh(mesh);
        }
        else {
            Object.values(this.context.models).forEach((model) => {
                model.threeGeometry.children.forEach((child) => {
                    const mesh = child;
                    this.updateByMesh(mesh);
                });
            });
        }
    }
    updateByMesh(mesh) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._worker) {
                let geometry = mesh.geometry;
                const bvh = yield this.generate(geometry, {
                    maxDepth: this.maxDepth ? this.maxDepth : 100,
                });
                mesh.geometry.boundsTree = bvh;
            }
            else {
                mesh.geometry.boundsTree.refit();
            }
        });
    }
    dispose() {
        var _a;
        (_a = this._worker) === null || _a === void 0 ? void 0 : _a.terminate();
    }
    setupThreeMeshBVH() {
        if (!this.computeBoundsTree ||
            !this.disposeBoundsTree ||
            !this.acceleratedRaycast) {
            console.log("Error while loading three-mesh-bvh");
            return;
        }
        three_1.BufferGeometry.prototype.computeBoundsTree = this.computeBoundsTree;
        three_1.BufferGeometry.prototype.disposeBoundsTree = this.disposeBoundsTree;
        three_1.Mesh.prototype.raycast = this.acceleratedRaycast;
    }
}
exports.BvhManager = BvhManager;


/***/ }),

/***/ 713:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BimatterConverter = void 0;
const BvhUtils_1 = __webpack_require__(692);
const Context_1 = __webpack_require__(823);
const Loaders_1 = __webpack_require__(490);
const Selector_1 = __webpack_require__(2884);
const Utils_1 = __webpack_require__(3236);
const three_1 = __webpack_require__(5232);
const decoder_1 = __webpack_require__(730);
const Model_1 = __webpack_require__(6118);
class BimatterViewer {
    constructor(settings) {
        this.models = {};
        this.settings = settings || {};
        if (!this.settings.container) {
            const div = document.createElement("div");
            div.style.position = "absolute";
            div.style.top = "0";
            div.style.bottom = "0";
            div.style.left = "0";
            div.style.right = "0";
            div.style.zIndex = "0";
            document.body.appendChild(div);
            this.container = div;
        }
        else {
            this.container = this.settings.container;
        }
        this.loaders = new Loaders_1.Loaders(this);
        this.context = new Context_1.Context(this, this.settings);
        this.selector = new Selector_1.Selector(this);
        this.bvhManager = new BvhUtils_1.BvhManager(this);
        this.utils = new Utils_1.Utils(this);
    }
    addEmptyModel(modelID) {
        return new Model_1.Model(this, modelID, false, new three_1.Group(), {}, { type: "null", id: 1, children: [] }, undefined, undefined, undefined, undefined, Date.now());
    }
    loadModel(arg1, fitToView, onLoadCallback) {
        let path;
        let ext;
        if (!arg1)
            throw new Error("Need to provide file or path!");
        if (arg1 instanceof File) {
            path = URL.createObjectURL(arg1);
            ext = arg1.name.split(".").pop();
        }
        else if (typeof arg1 === "string") {
            path = arg1;
            ext = path.split(".").pop();
        }
        if (!path || !ext)
            throw new Error("Unsupported file!");
        switch (ext.toLowerCase()) {
            case "ifc":
                return this.loaders.ifcLoader.loadModel(path, fitToView, onLoadCallback);
            case "bmt":
                return this.loaders.bmtLoader.loadModel(path, fitToView);
            default:
                throw new Error("Unsupported file!");
        }
    }
    removeModel(modelID) {
        const model = this.models[modelID];
        model.threeGeometry.children.forEach((ch) => {
            ch.geometry.dispose();
        });
        model.state.idsMap = {};
        model.state.indMap = {};
        model.defaultState.idsMap = {};
        model.defaultState.indMap = {};
        model.threeGeometry.removeFromParent();
        model.properties.data = {};
        model.properties.structure = { id: 1, type: "", children: [] };
        delete this.models[modelID];
        delete this.selector.selectedElements[modelID];
        if (this.utils.clippingUtils.active) {
            this.utils.clippingUtils.updateEdges();
        }
    }
    dispose() {
        var _a, _b, _c;
        for (const key of Object.keys(this.models)) {
            this.removeModel(Number(key));
        }
        this.context.camera.threeCamera.removeFromParent();
        this.context.scene.threeScene.removeFromParent();
        this.context.controls.cameraControl.dispose();
        this.context.environment.lights.ambientLight.removeFromParent();
        this.context.environment.lights.directionalLight1.removeFromParent();
        this.context.environment.lights.directionalLight2.removeFromParent();
        (_a = this.context.renderer.tempRenderer) === null || _a === void 0 ? void 0 : _a.dispose();
        this.context.renderer.threeRenderer.dispose();
        this.context.renderer.threeRenderer2D.domElement.remove();
        this.context.renderer.threeRenderer3D.domElement.remove();
        this.container.remove();
        (_b = this.utils.propsUtils.propConteiner) === null || _b === void 0 ? void 0 : _b.remove();
        (_c = this.utils.navigationCubeUtil.cubeContainer) === null || _c === void 0 ? void 0 : _c.remove();
    }
}
exports["default"] = BimatterViewer;
class BimatterConverter {
    constructor() {
        this.loaders = new Loaders_1.Loaders(this);
        this.utils = { decoder: decoder_1.default };
        this.models = {};
    }
}
exports.BimatterConverter = BimatterConverter;


/***/ }),

/***/ 3199:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DragControls: () => (/* binding */ DragControls)
/* harmony export */ });
/* harmony import */ var three__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9477);


const _plane = new three__WEBPACK_IMPORTED_MODULE_0__/* .Plane */ .JOQ();
const _raycaster = new three__WEBPACK_IMPORTED_MODULE_0__/* .Raycaster */ .iMs();

const _pointer = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector2 */ .FM8();
const _offset = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const _intersection = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const _worldPosition = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const _inverseMatrix = new three__WEBPACK_IMPORTED_MODULE_0__/* .Matrix4 */ .yGw();

class DragControls extends three__WEBPACK_IMPORTED_MODULE_0__/* .EventDispatcher */ .pBf {
    defaultActive = true;
    constructor(_objects, _camera, _domElement) {
        super();
        _domElement.style.touchAction = "none"; // disable touch scroll

        let _selected = null,
            _hovered = null;

        const _intersections = [];

        //

        const scope = this;

        function activate() {
            _domElement.addEventListener("pointermove", onPointerMove);
            _domElement.addEventListener("pointerdown", onPointerDown);
            _domElement.addEventListener("pointerup", onPointerCancel);
            _domElement.addEventListener("pointerleave", onPointerCancel);
        }

        function deactivate() {
            _domElement.removeEventListener("pointermove", onPointerMove);
            _domElement.removeEventListener("pointerdown", onPointerDown);
            _domElement.removeEventListener("pointerup", onPointerCancel);
            _domElement.removeEventListener("pointerleave", onPointerCancel);

            _domElement.style.cursor = "";
        }

        function dispose() {
            deactivate();
        }

        function getObjects() {
            return _objects;
        }

        function getRaycaster() {
            return _raycaster;
        }

        function onPointerMove(event) {
            if (scope.enabled === false) return;

            updatePointer(event);

            _raycaster.setFromCamera(_pointer, _camera);

            if (_selected) {
                let _vec;
                if (_raycaster.ray.intersectPlane(_plane, _intersection)) {
                    _vec = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4().copy(_intersection);
                    if (scope.defaultActive) {
                        _selected.position.copy(_vec);
                    }
                }
                scope.dispatchEvent({
                    type: "drag",
                    object: _selected,
                    point: _vec,
                });

                return;
            }

            // hover support

            if (event.pointerType === "mouse" || event.pointerType === "pen") {
                _intersections.length = 0;

                _raycaster.setFromCamera(_pointer, _camera);
                _raycaster.intersectObjects(_objects, true, _intersections);

                if (_intersections.length > 0) {
                    const object = _intersections[0].object;

                    _plane.setFromNormalAndCoplanarPoint(
                        _camera.getWorldDirection(_plane.normal),
                        _worldPosition.setFromMatrixPosition(object.matrixWorld)
                    );

                    if (_hovered !== object && _hovered !== null) {
                        scope.dispatchEvent({
                            type: "hoveroff",
                            object: _hovered,
                        });

                        _domElement.style.cursor = "auto";
                        _hovered = null;
                    }

                    if (_hovered !== object) {
                        scope.dispatchEvent({
                            type: "hoveron",
                            object: object,
                        });

                        _domElement.style.cursor = "pointer";
                        _hovered = object;
                    }
                } else {
                    if (_hovered !== null) {
                        scope.dispatchEvent({
                            type: "hoveroff",
                            object: _hovered,
                        });

                        _domElement.style.cursor = "auto";
                        _hovered = null;
                    }
                }
            }
        }

        function onPointerDown(event) {
            if (scope.enabled === false) return;

            updatePointer(event);

            _intersections.length = 0;

            _raycaster.setFromCamera(_pointer, _camera);
            _raycaster.intersectObjects(_objects, true, _intersections);

            if (_intersections.length > 0) {
                _selected =
                    scope.transformGroup === true
                        ? _objects[0]
                        : _intersections[0].object;

                _plane.setFromNormalAndCoplanarPoint(
                    _camera.getWorldDirection(_plane.normal),
                    _worldPosition.setFromMatrixPosition(_selected.matrixWorld)
                );

                if (_raycaster.ray.intersectPlane(_plane, _intersection)) {
                    //     _inverseMatrix.copy(_selected.parent.matrixWorld).invert();
                    _offset
                        .copy(_intersection)
                        .sub(
                            _worldPosition.setFromMatrixPosition(
                                _selected.matrixWorld
                            )
                        );
                }

                _domElement.style.cursor = "move";

                scope.dispatchEvent({ type: "dragstart", object: _selected });
            }
        }

        function onPointerCancel() {
            if (scope.enabled === false) return;

            if (_selected) {
                scope.dispatchEvent({ type: "dragend", object: _selected });

                _selected = null;
            }

            _domElement.style.cursor = _hovered ? "pointer" : "auto";
        }

        function updatePointer(event) {
            const rect = _domElement.getBoundingClientRect();

            _pointer.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
            _pointer.y = (-(event.clientY - rect.top) / rect.height) * 2 + 1;
        }

        activate();

        // API

        this.enabled = true;
        this.transformGroup = false;

        this.activate = activate;
        this.deactivate = deactivate;
        this.dispose = dispose;
        this.getObjects = getObjects;
        this.getRaycaster = getRaycaster;
    }
}




/***/ }),

/***/ 9618:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AnimationController: () => (/* binding */ AnimationController),
/* harmony export */   CharacterController: () => (/* binding */ CharacterController),
/* harmony export */   KeyInputControl: () => (/* binding */ KeyInputControl),
/* harmony export */   Octree: () => (/* binding */ Octree),
/* harmony export */   TPSCameraControls: () => (/* binding */ TPSCameraControls),
/* harmony export */   World: () => (/* binding */ World)
/* harmony export */ });
/* harmony import */ var three__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9477);
/*!
 * meshwalk
 * https://github.com/[object Object]
 * (c) 2017 @yomotsu
 * Released under the MIT License.
 */


const vec3$1 = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
class ComputedTriangle extends three__WEBPACK_IMPORTED_MODULE_0__/* .Triangle */ .CJI {
    constructor(a, b, c) {
        super(a, b, c);
        this.normal = this.getNormal(new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4());
    }
    computeBoundingSphere() {
        this.boundingSphere = makeTriangleBoundingSphere(this, this.normal);
    }
    // https://math.stackexchange.com/questions/1397456/how-to-scale-a-triangle-such-that-the-distance-between-original-edges-and-new-ed
    // scale( amount: number ) {
    // 	const incenter = getIncenter( this, vec3 );
    // 	this.a.sub( incenter ).multiplyScalar( amount ).add( incenter );
    // 	this.b.sub( incenter ).multiplyScalar( amount ).add( incenter );
    // 	this.c.sub( incenter ).multiplyScalar( amount ).add( incenter );
    // 	拡張したら、過去の boundingSphere はすでに大きさが違うものとなる。破棄する。
    // 	this.boundingSphere = undefined;
    // }
    extend(amount) {
        const incenter = getIncenter(this, vec3$1);
        const a = incenter.distanceTo(this.a);
        const b = incenter.distanceTo(this.b);
        const c = incenter.distanceTo(this.c);
        this.a
            .sub(incenter)
            .normalize()
            .multiplyScalar(a + amount)
            .add(incenter);
        this.b
            .sub(incenter)
            .normalize()
            .multiplyScalar(b + amount)
            .add(incenter);
        this.c
            .sub(incenter)
            .normalize()
            .multiplyScalar(c + amount)
            .add(incenter);
        // 拡張したら、過去の boundingSphere はすでに大きさが違うものとなる。破棄する。
        this.boundingSphere = undefined;
    }
}
// aka Semiperimeter
function getIncenter(triangle, out) {
    // https://byjus.com/maths/incenter-of-a-triangle/
    const a = triangle.a.distanceTo(triangle.b);
    const b = triangle.b.distanceTo(triangle.c);
    const c = triangle.c.distanceTo(triangle.a);
    const p = a + b + c;
    out.set(
        (a * triangle.a.x + b * triangle.b.x + c * triangle.c.x) / p,
        (a * triangle.a.y + b * triangle.b.y + c * triangle.c.y) / p,
        (a * triangle.a.z + b * triangle.b.z + c * triangle.c.z) / p
    );
    return out;
}
// const edge = new Line3();
// function getInradius( triangle: Triangle ) {
// 	const incenter = getIncenter( triangle, vec3 );
// 	const closestPointToEdge = new Vector3();
// 	edge.start = triangle.a;
// 	edge.end = triangle.b;
// 	edge.closestPointToPoint( incenter, true, closestPointToEdge );
// 	return incenter.distanceTo( closestPointToEdge );
// }
// function makeTriangleBoundingBox( triangle: Triangle ) {
// 	const bb = new Box3();
// 	bb.min = bb.min.min( triangle.a );
// 	bb.min = bb.min.min( triangle.b );
// 	bb.min = bb.min.min( triangle.c );
// 	bb.max = bb.max.max( triangle.a );
// 	bb.max = bb.max.max( triangle.b );
// 	bb.max = bb.max.max( triangle.c );
// 	return bb;
// }
const v = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const v0 = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const v1 = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const e0 = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const e1 = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const triangleNormal = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
function makeTriangleBoundingSphere(triangle, normal) {
    const bs = new three__WEBPACK_IMPORTED_MODULE_0__/* .Sphere */ .aLr();
    // obtuse triangle
    v0.subVectors(triangle.b, triangle.a);
    v1.subVectors(triangle.c, triangle.a);
    if (v0.dot(v1) <= 0) {
        bs.center.addVectors(triangle.b, triangle.c).divideScalar(2);
        bs.radius = v.subVectors(triangle.b, triangle.c).length() / 2;
        return bs;
    }
    v0.subVectors(triangle.a, triangle.b);
    v1.subVectors(triangle.c, triangle.b);
    if (v0.dot(v1) <= 0) {
        bs.center.addVectors(triangle.a, triangle.c).divideScalar(2);
        bs.radius = v.subVectors(triangle.a, triangle.c).length() / 2;
        return bs;
    }
    v0.subVectors(triangle.a, triangle.c);
    v1.subVectors(triangle.b, triangle.c);
    if (v0.dot(v1) <= 0) {
        bs.center.addVectors(triangle.a, triangle.b).divideScalar(2);
        bs.radius = v.subVectors(triangle.a, triangle.b).length() / 2;
        return bs;
    }
    // acute‐angled triangle
    if (!normal) {
        normal = triangle.getNormal(triangleNormal);
    }
    v0.crossVectors(v.subVectors(triangle.c, triangle.b), normal);
    v1.crossVectors(v.subVectors(triangle.c, triangle.a), normal);
    e0.addVectors(triangle.c, triangle.b).multiplyScalar(0.5);
    e1.addVectors(triangle.c, triangle.a).multiplyScalar(0.5);
    const a = v0.dot(v1);
    const b = v0.dot(v0);
    const d = v1.dot(v1);
    const c = -v.subVectors(e1, e0).dot(v0);
    const e = -v.subVectors(e1, e0).dot(v1);
    const div = -a * a + b * d;
    // t = ( - a * c + b * e ) / div;
    const s = (-c * d + a * e) / div;
    bs.center = e0.clone().add(v0.clone().multiplyScalar(s));
    bs.radius = v.subVectors(bs.center, triangle.a).length();
    return bs;
}

const vec3 = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const vec3_0 = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const vec3_1 = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
new three__WEBPACK_IMPORTED_MODULE_0__/* .Sphere */ .aLr();
new three__WEBPACK_IMPORTED_MODULE_0__/* .Line3 */ .Zzh();
class Intersection {
    constructor() {
        this.point = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
        this.normal = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
        this.depth = 0;
    }
    set(point, normal, depth) {
        this.point.copy(point);
        this.normal.copy(normal);
        this.depth = depth;
    }
}
// https://3dkingdoms.com/weekly/weekly.php?a=3
function isIntersectionLineBox(line, box, hit) {
    if (line.end.x < box.min.x && line.start.x < box.min.x) return false;
    if (line.end.x > box.max.x && line.start.x > box.max.x) return false;
    if (line.end.y < box.min.y && line.start.y < box.min.y) return false;
    if (line.end.y > box.max.y && line.start.y > box.max.y) return false;
    if (line.end.z < box.min.z && line.start.z < box.min.z) return false;
    if (line.end.z > box.max.z && line.start.z > box.max.z) return false;
    if (
        line.start.x > box.min.x &&
        line.start.x < box.max.x &&
        line.start.y > box.min.y &&
        line.start.y < box.max.y &&
        line.start.z > box.min.z &&
        line.start.z < box.max.z
    ) {
        hit && hit.copy(line.start);
        return true;
    }
    const _hit = vec3;
    if (
        (getIntersection(
            line.start.x - box.min.x,
            line.end.x - box.min.x,
            line.start,
            line.end,
            _hit
        ) &&
            inBox(_hit, box, 1)) ||
        (getIntersection(
            line.start.y - box.min.y,
            line.end.y - box.min.y,
            line.start,
            line.end,
            _hit
        ) &&
            inBox(_hit, box, 2)) ||
        (getIntersection(
            line.start.z - box.min.z,
            line.end.z - box.min.z,
            line.start,
            line.end,
            _hit
        ) &&
            inBox(_hit, box, 3)) ||
        (getIntersection(
            line.start.x - box.max.x,
            line.end.x - box.max.x,
            line.start,
            line.end,
            _hit
        ) &&
            inBox(_hit, box, 1)) ||
        (getIntersection(
            line.start.y - box.max.y,
            line.end.y - box.max.y,
            line.start,
            line.end,
            _hit
        ) &&
            inBox(_hit, box, 2)) ||
        (getIntersection(
            line.start.z - box.max.z,
            line.end.z - box.max.z,
            line.start,
            line.end,
            _hit
        ) &&
            inBox(_hit, box, 3))
    ) {
        hit && hit.copy(_hit);
        return true;
    }
    return false;
}
function getIntersection(dst1, dst2, p1, p2, hit) {
    if (dst1 * dst2 >= 0) return false;
    if (dst1 == dst2) return false;
    if (hit) {
        vec3.subVectors(p2, p1);
        vec3.multiplyScalar(-dst1 / (dst2 - dst1));
        hit.addVectors(p1, vec3);
    }
    return true;
}
function inBox(hit, box, axis) {
    if (
        axis === 1 &&
        hit.z > box.min.z &&
        hit.z < box.max.z &&
        hit.y > box.min.y &&
        hit.y < box.max.y
    )
        return true;
    if (
        axis === 2 &&
        hit.z > box.min.z &&
        hit.z < box.max.z &&
        hit.x > box.min.x &&
        hit.x < box.max.x
    )
        return true;
    if (
        axis === 3 &&
        hit.x > box.min.x &&
        hit.x < box.max.x &&
        hit.y > box.min.y &&
        hit.y < box.max.y
    )
        return true;
    return false;
}
new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
new three__WEBPACK_IMPORTED_MODULE_0__/* .Plane */ .JOQ();
const A = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const B = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const C = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const V = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const AB = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const BC = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const CA = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const Q1 = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const Q2 = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const Q3 = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const QC = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const QA = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const QB = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const negatedNormal = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
// sphere: <THREE.Sphere>
// a: <THREE.Vector3>, // vertex of a triangle
// b: <THREE.Vector3>, // vertex of a triangle
// c: <THREE.Vector3>, // vertex of a triangle
// normal: <THREE.Vector3>, // normal of a triangle
function isIntersectionSphereTriangle(sphere, a, b, c, normal, out) {
    // http://realtimecollisiondetection.net/blog/?p=103
    // vs plain of triangle face
    A.subVectors(a, sphere.center);
    B.subVectors(b, sphere.center);
    C.subVectors(c, sphere.center);
    const rr = sphere.radius * sphere.radius;
    V.crossVectors(vec3_0.subVectors(B, A), vec3_1.subVectors(C, A));
    const d = A.dot(V);
    const e = V.dot(V);
    if (d * d > rr * e) {
        return false;
    }
    // vs triangle vertex
    const aa = A.dot(A);
    const ab = A.dot(B);
    const ac = A.dot(C);
    const bb = B.dot(B);
    const bc = B.dot(C);
    const cc = C.dot(C);
    if (
        (aa > rr && ab > aa && ac > aa) ||
        (bb > rr && ab > bb && bc > bb) ||
        (cc > rr && ac > cc && bc > cc)
    ) {
        return false;
    }
    // vs edge
    AB.subVectors(B, A);
    BC.subVectors(C, B);
    CA.subVectors(A, C);
    const d1 = ab - aa;
    const d2 = bc - bb;
    const d3 = ac - cc;
    const e1 = AB.dot(AB);
    const e2 = BC.dot(BC);
    const e3 = CA.dot(CA);
    Q1.subVectors(A.multiplyScalar(e1), AB.multiplyScalar(d1));
    Q2.subVectors(B.multiplyScalar(e2), BC.multiplyScalar(d2));
    Q3.subVectors(C.multiplyScalar(e3), CA.multiplyScalar(d3));
    QC.subVectors(C.multiplyScalar(e1), Q1);
    QA.subVectors(A.multiplyScalar(e2), Q2);
    QB.subVectors(B.multiplyScalar(e3), Q3);
    if (
        (Q1.dot(Q1) > rr * e1 * e1 && Q1.dot(QC) >= 0) ||
        (Q2.dot(Q2) > rr * e2 * e2 && Q2.dot(QA) >= 0) ||
        (Q3.dot(Q3) > rr * e3 * e3 && Q3.dot(QB) >= 0)
    ) {
        return false;
    }
    const distance = Math.sqrt((d * d) / e) - sphere.radius - 1;
    negatedNormal.set(-normal.x, -normal.y, -normal.z);
    const contactPoint = sphere.center
        .clone()
        .add(negatedNormal.multiplyScalar(distance));
    out.set(contactPoint, normal, distance);
    return true;
}
// // based on Real-Time Collision Detection Section 5.3.4
// // p: <THREE.Vector3>, // line3.start
// // q: <THREE.Vector3>, // line3.end
// // a: <THREE.Vector3>, // triangle.a
// // b: <THREE.Vector3>, // triangle.b
// // c: <THREE.Vector3>, // triangle.c
// const pq = new Vector3();
// const pa = new Vector3();
// const pb = new Vector3();
// const pc = new Vector3();
// const au = new Vector3();
// const bv = new Vector3();
// const cw = new Vector3();
// export function testLineTriangle( p: Vector3, q: Vector3, a: Vector3, b: Vector3, c: Vector3, hit: Vector3 ) {
// 	pq.subVectors( q, p );
// 	pa.subVectors( a, p );
// 	pb.subVectors( b, p );
// 	pc.subVectors( c, p );
// 	let u: number;
// 	let v: number;
// 	let w: number;
// 	u = scalarTriple( pq, pc, pb );
// 	if ( u < 0 ) return false;
// 	v = scalarTriple( pq, pa, pc );
// 	if ( v < 0 ) return false;
// 	w = scalarTriple( pq, pb, pa );
// 	if ( w < 0 ) return false;
// 	const denom = 1 / ( u + v + w );
// 	u *= denom;
// 	v *= denom;
// 	w *= denom;
// 	au.copy( a ).multiplyScalar( u );
// 	bv.copy( b ).multiplyScalar( v );
// 	cw.copy( c ).multiplyScalar( w );
// 	hit.copy( au ).add( bv ).add( cw );
// 	return true;
// }
// function scalarTriple( a: Vector3, b: Vector3, c: Vector3 ) {
// 	var m = b.clone().cross( c );
// 	return a.dot( m );
// }
// var vectorTriple = function ( a, b, c ) {
//   var m = b.clone().cross( c );
//   return a.clone().cross( m );
// }
const ab = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const ac = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const qp = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const n = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const ap = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const e = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const au = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const bv = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const cw = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
function testLineTriangle(p, q, a, b, c, hit) {
    ab.subVectors(b, a);
    ac.subVectors(c, a);
    qp.subVectors(p, q);
    n.copy(ab).cross(ac);
    const d = qp.dot(n);
    if (d <= 0) return false;
    ap.subVectors(p, a);
    let t = ap.dot(n);
    if (t < 0) return false;
    if (t > d) return false;
    e.copy(qp).cross(ap);
    let v = ac.dot(e);
    if (v < 0 || v > d) return false;
    let w = vec3.copy(ab).dot(e) * -1;
    if (w < 0 || v + w > d) return false;
    const ood = 1 / d;
    t *= ood;
    v *= ood;
    w *= ood;
    const u = 1 - v - w;
    au.copy(a).multiplyScalar(u);
    bv.copy(b).multiplyScalar(v);
    cw.copy(c).multiplyScalar(w);
    hit.copy(au).add(bv).add(cw);
    return true;
}
//
// based on https://github.com/mrdoob/three.js/blob/master/examples/jsm/math/Octree.js
// https://wickedengine.net/2020/04/26/capsule-collision-detection/
// we select the closest point on the capsule line to the triangle,
// place a sphere on that point and then perform the sphere – triangle test.
// also
// 5.1.10
new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
new three__WEBPACK_IMPORTED_MODULE_0__/* .Plane */ .JOQ();
new three__WEBPACK_IMPORTED_MODULE_0__/* .Line3 */ .Zzh();
new three__WEBPACK_IMPORTED_MODULE_0__/* .Line3 */ .Zzh();
new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();

const _v1 = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const _v2$1 = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
// const _plane = new Plane();
// const _line1 = new Line3();
// const _line2 = new Line3();
// const _sphere = new Sphere();
// const _capsule = new Capsule();
class Octree {
    constructor(box = new three__WEBPACK_IMPORTED_MODULE_0__/* .Box3 */ .ZzF()) {
        this.bounds = new three__WEBPACK_IMPORTED_MODULE_0__/* .Box3 */ .ZzF();
        this.triangles = [];
        this.subTrees = [];
        this.box = box;
    }
    addTriangle(triangle) {
        this.bounds.min.x = Math.min(
            this.bounds.min.x,
            triangle.a.x,
            triangle.b.x,
            triangle.c.x
        );
        this.bounds.min.y = Math.min(
            this.bounds.min.y,
            triangle.a.y,
            triangle.b.y,
            triangle.c.y
        );
        this.bounds.min.z = Math.min(
            this.bounds.min.z,
            triangle.a.z,
            triangle.b.z,
            triangle.c.z
        );
        this.bounds.max.x = Math.max(
            this.bounds.max.x,
            triangle.a.x,
            triangle.b.x,
            triangle.c.x
        );
        this.bounds.max.y = Math.max(
            this.bounds.max.y,
            triangle.a.y,
            triangle.b.y,
            triangle.c.y
        );
        this.bounds.max.z = Math.max(
            this.bounds.max.z,
            triangle.a.z,
            triangle.b.z,
            triangle.c.z
        );
        this.triangles.push(triangle);
    }
    calcBox() {
        this.box.set(this.bounds.min, this.bounds.max);
        // offset small amount to account for regular grid
        this.box.min.x -= 0.01;
        this.box.min.y -= 0.01;
        this.box.min.z -= 0.01;
        return this;
    }
    split(level) {
        const subTrees = [];
        const halfSize = _v2$1
            .copy(this.box.max)
            .sub(this.box.min)
            .multiplyScalar(0.5);
        for (let x = 0; x < 2; x++) {
            for (let y = 0; y < 2; y++) {
                for (let z = 0; z < 2; z++) {
                    const box = new three__WEBPACK_IMPORTED_MODULE_0__/* .Box3 */ .ZzF();
                    const v = _v1.set(x, y, z);
                    box.min.copy(this.box.min).add(v.multiply(halfSize));
                    box.max.copy(box.min).add(halfSize);
                    subTrees.push(new Octree(box));
                }
            }
        }
        let triangle;
        while ((triangle = this.triangles.pop())) {
            for (let i = 0; i < subTrees.length; i++) {
                if (subTrees[i].box.intersectsTriangle(triangle)) {
                    subTrees[i].triangles.push(triangle);
                }
            }
        }
        for (let i = 0; i < subTrees.length; i++) {
            const len = subTrees[i].triangles.length;
            if (len > 8 && level < 16) {
                subTrees[i].split(level + 1);
            }
            if (len !== 0) {
                this.subTrees.push(subTrees[i]);
            }
        }
    }
    build() {
        this.calcBox();
        this.split(0);
        return this;
    }
    getLineTriangles(line, result) {
        for (let i = 0; i < this.subTrees.length; i++) {
            const subTree = this.subTrees[i];
            if (!isIntersectionLineBox(line, subTree.box)) continue;
            if (subTree.triangles.length > 0) {
                for (let j = 0; j < subTree.triangles.length; j++) {
                    if (result.indexOf(subTree.triangles[j]) === -1)
                        result.push(subTree.triangles[j]);
                }
            } else {
                subTree.getLineTriangles(line, result);
            }
        }
        return result;
    }
    getRayTriangles(ray, result) {
        for (let i = 0; i < this.subTrees.length; i++) {
            const subTree = this.subTrees[i];
            if (!ray.intersectsBox(subTree.box)) continue;
            if (subTree.triangles.length > 0) {
                for (let j = 0; j < subTree.triangles.length; j++) {
                    if (result.indexOf(subTree.triangles[j]) === -1)
                        result.push(subTree.triangles[j]);
                }
            } else {
                subTree.getRayTriangles(ray, result);
            }
        }
        return result;
    }
    getSphereTriangles(sphere, result) {
        for (let i = 0; i < this.subTrees.length; i++) {
            const subTree = this.subTrees[i];
            if (!sphere.intersectsBox(subTree.box)) continue;
            if (subTree.triangles.length > 0) {
                for (let j = 0; j < subTree.triangles.length; j++) {
                    if (result.indexOf(subTree.triangles[j]) === -1)
                        result.push(subTree.triangles[j]);
                }
            } else {
                subTree.getSphereTriangles(sphere, result);
            }
        }
        return result;
    }
    getCapsuleTriangles(capsule, result) {
        for (let i = 0; i < this.subTrees.length; i++) {
            const subTree = this.subTrees[i];
            if (!capsule.intersectsBox(subTree.box)) continue;
            if (subTree.triangles.length > 0) {
                for (let j = 0; j < subTree.triangles.length; j++) {
                    if (result.indexOf(subTree.triangles[j]) === -1)
                        result.push(subTree.triangles[j]);
                }
            } else {
                subTree.getCapsuleTriangles(capsule, result);
            }
        }
    }
    lineIntersect(line) {
        const position = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
        const triangles = [];
        let distanceSquared = Infinity;
        let triangle = null;
        this.getLineTriangles(line, triangles);
        for (let i = 0; i < triangles.length; i++) {
            const result = _v1;
            const isIntersected = testLineTriangle(
                line.start,
                line.end,
                triangles[i].a,
                triangles[i].b,
                triangles[i].c,
                result
            );
            if (isIntersected) {
                const newDistanceSquared = line.start.distanceToSquared(result);
                if (distanceSquared > newDistanceSquared) {
                    position.copy(result);
                    distanceSquared = newDistanceSquared;
                    triangle = triangles[i];
                }
            }
        }
        return triangle
            ? { distance: Math.sqrt(distanceSquared), triangle, position }
            : false;
    }
    rayIntersect(ray) {
        if (ray.direction.lengthSq() === 0) return;
        const triangles = [];
        let triangle,
            position,
            distanceSquared = 1e100;
        this.getRayTriangles(ray, triangles);
        for (let i = 0; i < triangles.length; i++) {
            const result = ray.intersectTriangle(
                triangles[i].a,
                triangles[i].b,
                triangles[i].c,
                true,
                _v1
            );
            if (result) {
                const newDistanceSquared = result.sub(ray.origin).lengthSq();
                if (distanceSquared > newDistanceSquared) {
                    position = result.clone().add(ray.origin);
                    distanceSquared = newDistanceSquared;
                    triangle = triangles[i];
                }
            }
        }
        return distanceSquared < 1e100
            ? { distance: Math.sqrt(distanceSquared), triangle, position }
            : false;
    }
    addGraphNode(object) {
        object.updateWorldMatrix(true, true);
        const mesh = object;
        const geometry = mesh.geometry.clone();
        geometry.applyMatrix4(mesh.matrix);
        geometry.computeVertexNormals();
        if (!!geometry.index) {
            const indices = geometry.index.array;
            const positions = geometry.attributes.position.array;
            const groups =
                geometry.groups.length !== 0
                    ? geometry.groups
                    : [
                          {
                              start: 0,
                              count: indices.length,
                              materialIndex: 0,
                          },
                      ];
            for (let i = 0, l = groups.length; i < l; ++i) {
                const start = groups[i].start;
                const count = groups[i].count;
                for (let ii = start, ll = start + count; ii < ll; ii += 3) {
                    const a = indices[ii];
                    const b = indices[ii + 1];
                    const c = indices[ii + 2];
                    const vA = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4().fromArray(positions, a * 3);
                    const vB = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4().fromArray(positions, b * 3);
                    const vC = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4().fromArray(positions, c * 3);
                    const triangle = new ComputedTriangle(vA, vB, vC);
                    // ポリゴンの継ぎ目の辺で raycast が交差しない可能性があるので、わずかに拡大する
                    triangle.extend(1e-10);
                    triangle.computeBoundingSphere();
                    this.addTriangle(triangle);
                }
            }
        }
        this.build();
    }
}

let EventDispatcher$1 = class EventDispatcher {
    constructor() {
        this._listeners = {};
    }
    /**
     * Adds the specified event listener.
     * @param type event name
     * @param listener handler function
     * @category Methods
     */
    addEventListener(type, listener) {
        const listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        if (listeners[type].indexOf(listener) === -1)
            listeners[type].push(listener);
    }
    /**
     * Presence of the specified event listener.
     * @param type event name
     * @param listener handler function
     * @category Methods
     */
    hasEventListener(type, listener) {
        const listeners = this._listeners;
        return (
            listeners[type] !== undefined &&
            listeners[type].indexOf(listener) !== -1
        );
    }
    /**
     * Removes the specified event listener
     * @param type event name
     * @param listener handler function
     * @category Methods
     */
    removeEventListener(type, listener) {
        const listeners = this._listeners;
        const listenerArray = listeners[type];
        if (listenerArray !== undefined) {
            const index = listenerArray.indexOf(listener);
            if (index !== -1) listenerArray.splice(index, 1);
        }
    }
    /**
     * Fire an event type.
     * @param event DispatcherEvent
     * @category Methods
     */
    dispatchEvent(event) {
        const listeners = this._listeners;
        const listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            const array = listenerArray.slice(0);
            for (let i = 0, l = array.length; i < l; i++) {
                array[i].call(this, event);
            }
        }
    }
};

const FALL_VELOCITY = -20;
const JUMP_DURATION = 1000;
const PI_HALF$1 = Math.PI * 0.5;
const PI_ONE_HALF = Math.PI * 1.5;
const direction2D = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector2 */ .FM8();
const wallNormal2D = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector2 */ .FM8();
const groundingHead = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const groundingTo = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const groundContactPointTmp = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const groundContactPoint = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
// const point1 = new Vector3();
// const point2 = new Vector3();
// const direction = new Vector3();
// const translateScoped = new Vector3();
const translate = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const sphereCenter = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const sphere$1 = new three__WEBPACK_IMPORTED_MODULE_0__/* .Sphere */ .aLr();
const intersection = new Intersection();
class CharacterController extends EventDispatcher$1 {
    constructor(object3d, radius) {
        super();
        this.isCharacterController = true;
        this.position = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
        this.groundCheckDepth = 0.2;
        this.maxSlopeGradient = Math.cos(50 * three__WEBPACK_IMPORTED_MODULE_0__/* .MathUtils */ .M8C.DEG2RAD);
        this.isGrounded = false;
        this.isOnSlope = false;
        this.isIdling = false;
        this.isRunning = false;
        this.isJumping = false;
        this.direction = 0; // 0 to 2PI (= 360deg) in rad
        this.movementSpeed = 10; // Meters Per Second
        this.velocity = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4(0, -9.8, 0);
        this.currentJumpPower = 0;
        this.jumpStartTime = 0;
        this.groundHeight = 0;
        this.groundNormal = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
        this.nearTriangles = [];
        this.contactInfo = [];
        this.object = object3d;
        this.radius = radius;
        this.position.set(0, 0, 0);
        let isFirstUpdate = true;
        let wasGrounded = false;
        let wasOnSlope = false;
        // let wasIdling = false;
        let wasRunning = false;
        let wasJumping = false;
        this._events = () => {
            // 初回のみ、過去状態を作るだけで終わり
            if (isFirstUpdate) {
                isFirstUpdate = false;
                wasGrounded = this.isGrounded;
                wasOnSlope = this.isOnSlope;
                // wasIdling   = this.isIdling;
                wasRunning = this.isRunning;
                wasJumping = this.isJumping;
                return;
            }
            if (
                !wasRunning &&
                !this.isRunning &&
                this.isGrounded &&
                !this.isIdling
            ) {
                this.isIdling = true;
                this.dispatchEvent({ type: "startIdling" });
            } else if (
                (!wasRunning &&
                    this.isRunning &&
                    !this.isJumping &&
                    this.isGrounded) ||
                (!wasGrounded && this.isGrounded && this.isRunning) ||
                (wasOnSlope &&
                    !this.isOnSlope &&
                    this.isRunning &&
                    this.isGrounded)
            ) {
                this.isIdling = false;
                this.dispatchEvent({ type: "startWalking" });
            } else if (!wasJumping && this.isJumping) {
                this.isIdling = false;
                this.dispatchEvent({ type: "startJumping" });
            } else if (!wasOnSlope && this.isOnSlope) {
                this.dispatchEvent({ type: "startSliding" });
            } else if (wasGrounded && !this.isGrounded && !this.isJumping) {
                this.dispatchEvent({ type: "startFalling" });
            }
            if (!wasGrounded && this.isGrounded);
            wasGrounded = this.isGrounded;
            wasOnSlope = this.isOnSlope;
            // wasIdling   = this.isIdling;
            wasRunning = this.isRunning;
            wasJumping = this.isJumping;
        };
    }
    setNearTriangles(nearTriangles) {
        this.nearTriangles = nearTriangles;
    }
    update(deltaTime) {
        // 状態をリセットしておく
        this.isGrounded = false;
        this.isOnSlope = false;
        this.groundHeight = -Infinity;
        this.groundNormal.set(0, 1, 0);
        this._checkGround();
        this._updateJumping();
        this._updatePosition(deltaTime);
        this._collisionDetection();
        this._solvePosition();
        this._updateVelocity();
        this._events();
    }
    _updateVelocity() {
        const frontDirection = -Math.cos(this.direction);
        const rightDirection = -Math.sin(this.direction);
        let isHittingCeiling = false;
        this.velocity.set(
            this.isRunning ? rightDirection * this.movementSpeed : 0,
            FALL_VELOCITY,
            this.isRunning ? frontDirection * this.movementSpeed : 0
        );
        // 急勾配や自由落下など、自動で付与される速度の処理
        if (this.contactInfo.length === 0 && !this.isJumping) {
            // 何とも衝突していないので、自由落下
            return;
        } else if (this.isGrounded && !this.isOnSlope && !this.isJumping) {
            // 通常の地面上にいる場合、ただしジャンプ開始時は除く
            this.velocity.y = 0;
        } else if (this.isOnSlope) {
            // TODO 0.2 はマジックナンバーなので、幾何学的な求め方を考える
            const slidingDownVelocity = FALL_VELOCITY;
            const horizontalSpeed =
                (-slidingDownVelocity / (1 - this.groundNormal.y)) * 0.2;
            this.velocity.x = this.groundNormal.x * horizontalSpeed;
            this.velocity.y = FALL_VELOCITY;
            this.velocity.z = this.groundNormal.z * horizontalSpeed;
        } else if (!this.isGrounded && !this.isOnSlope && this.isJumping) {
            // ジャンプの処理
            this.velocity.y = this.currentJumpPower * -FALL_VELOCITY;
        }
        // 壁に向かった場合、壁方向の速度を0にする処理
        // vs walls and sliding on the wall
        direction2D.set(rightDirection, frontDirection);
        // const frontAngle = Math.atan2( direction2D.y, direction2D.x );
        const negativeFrontAngle = Math.atan2(-direction2D.y, -direction2D.x);
        for (let i = 0, l = this.contactInfo.length; i < l; i++) {
            const normal = this.contactInfo[i].triangle.normal;
            // var distance = this.contactInfo[ i ].distance;
            if (this.maxSlopeGradient < normal.y || this.isOnSlope) {
                // フェイスは地面なので、壁としての衝突の可能性はない。
                // 速度の減衰はしないでいい
                continue;
            }
            if (!isHittingCeiling && normal.y < 0) {
                isHittingCeiling = true;
            }
            wallNormal2D.set(normal.x, normal.z).normalize();
            const wallAngle = Math.atan2(wallNormal2D.y, wallNormal2D.x);
            if (
                Math.abs(negativeFrontAngle - wallAngle) >= PI_HALF$1 && //  90deg
                Math.abs(negativeFrontAngle - wallAngle) <= PI_ONE_HALF // 270deg
            ) {
                // フェイスは進行方向とは逆方向、要は背中側の壁なので
                // 速度の減衰はしないでいい
                continue;
            }
            // 上記までの条件に一致しなければ、フェイスは壁
            // 壁の法線を求めて、その逆方向に向いている速度ベクトルを0にする
            wallNormal2D.set(
                direction2D.dot(wallNormal2D) * wallNormal2D.x,
                direction2D.dot(wallNormal2D) * wallNormal2D.y
            );
            direction2D.sub(wallNormal2D);
            this.velocity.x = this.isRunning
                ? direction2D.x * this.movementSpeed
                : 0;
            this.velocity.z = this.isRunning
                ? direction2D.y * this.movementSpeed
                : 0;
        }
        // ジャンプ中に天井にぶつかったら、ジャンプを中断する
        if (isHittingCeiling) {
            this.velocity.y = Math.min(0, this.velocity.y);
            this.isJumping = false;
        }
    }
    _checkGround() {
        // "頭上からほぼ無限に下方向までの線 (segment)" vs "フェイス (triangle)" の
        // 交差判定を行う
        // もし、フェイスとの交差点が「頭上」から「下 groundCheckDepth」までの間だったら
        // 地面上 (isGrounded) にいることとみなす
        //
        //   ___
        //  / | \
        // |  |  | player sphere
        //  \_|_/
        //    |
        //---[+]---- ground
        //    |
        //    |
        //    | segment (player's head to almost -infinity)
        let groundContact = null;
        const triangles = this.nearTriangles;
        groundingHead.set(
            this.position.x,
            this.position.y + this.radius * 2,
            this.position.z
        );
        groundingTo.set(
            this.position.x,
            this.position.y - 1e1,
            this.position.z
        );
        for (let i = 0, l = triangles.length; i < l; i++) {
            const triangle = triangles[i];
            // 壁・天井は接地処理では無視
            if (triangle.normal.y <= 0) continue;
            const isIntersected = testLineTriangle(
                groundingHead,
                groundingTo,
                triangle.a,
                triangle.b,
                triangle.c,
                groundContactPointTmp
            );
            if (!isIntersected) continue;
            if (!groundContact) {
                groundContactPoint.copy(groundContactPointTmp);
                groundContact = {
                    point: groundContactPoint,
                    ground: triangle,
                };
                continue;
            }
            if (groundContactPointTmp.y <= groundContact.point.y) continue;
            groundContactPoint.copy(groundContactPointTmp);
            groundContact = {
                point: groundContactPoint,
                ground: triangle,
            };
        }
        if (!groundContact) return;
        this.groundHeight = groundContact.point.y;
        this.groundNormal.copy(groundContact.ground.normal);
        // その他、床の属性を追加で取得する場合はここで
        const top = groundingHead.y;
        const bottom = this.position.y - this.groundCheckDepth;
        // ジャンプ中、かつ上方向に移動中だったら、強制接地しない
        if (this.isJumping && 0 < this.currentJumpPower) {
            this.isOnSlope = false;
            this.isGrounded = false;
            return;
        }
        this.isGrounded =
            bottom <= this.groundHeight && this.groundHeight <= top;
        this.isOnSlope = this.groundNormal.y <= this.maxSlopeGradient;
        if (this.isGrounded) {
            this.isJumping = false;
        }
    }
    _updatePosition(deltaTime) {
        // 壁などを無視してひとまず(速度 * 時間)だけ
        // position の座標を進める
        // 壁との衝突判定はこのこの後のステップで行うのでここではやらない
        // もし isGrounded 状態なら、強制的に y の値を地面に合わせる
        this.position.set(
            this.position.x + this.velocity.x * deltaTime,
            this.isGrounded
                ? this.groundHeight
                : this.position.y + this.velocity.y * deltaTime,
            this.position.z + this.velocity.z * deltaTime
        );
    }
    _collisionDetection() {
        sphereCenter.set(0, this.radius, 0).add(this.position);
        sphere$1.set(sphereCenter, this.radius);
        // 交差していそうなフェイス (nearTriangles) のリストから、
        // 実際に交差している壁フェイスを抜き出して
        // this.contactInfo に追加する
        const triangles = this.nearTriangles;
        this.contactInfo.length = 0;
        for (let i = 0, l = triangles.length; i < l; i++) {
            const triangle = triangles[i];
            if (!triangle.boundingSphere) triangle.computeBoundingSphere();
            if (!sphere$1.intersectsSphere(triangle.boundingSphere)) continue;
            const isIntersected = isIntersectionSphereTriangle(
                sphere$1,
                triangle.a,
                triangle.b,
                triangle.c,
                triangle.normal,
                intersection
            );
            if (!isIntersected) continue;
            this.contactInfo.push({
                point: intersection.point.clone(),
                depth: intersection.depth,
                triangle,
            });
        }
    }
    _solvePosition() {
        // updatePosition() で position を動かした後
        // 壁と衝突し食い込んでいる場合、
        // ここで壁の外への押し出しをする
        // let triangle;
        let normal;
        // let distance;
        if (this.contactInfo.length === 0) {
            // 何とも衝突していない
            // position の値をそのままつかって終了
            this.object.position.copy(this.position);
            this.object.rotation.y = this.direction + Math.PI;
            return;
        }
        //
        // vs walls and sliding on the wall
        translate.set(0, 0, 0);
        for (let i = 0, l = this.contactInfo.length; i < l; i++) {
            // triangle = this.contactInfo[ i ].triangle;
            normal = this.contactInfo[i].triangle.normal;
            // distance = this.contactInfo[ i ].distance;
            // if ( 0 <= distance ) {
            //   // 交差点までの距離が 0 以上ならこのフェイスとは衝突していない
            //   // 無視する
            //   continue;
            // }
            if (this.maxSlopeGradient < normal.y) {
                // this triangle is a ground or slope, not a wall or ceil
                // フェイスは急勾配でない坂、つまり地面。
                // 接地の処理は updatePosition() 内で解決しているので無視する
                continue;
            }
            // フェイスは急勾配な坂か否か
            const isSlopeFace =
                this.maxSlopeGradient <= normal.y && normal.y < 1;
            // ジャンプ降下中に、急勾配な坂に衝突したらジャンプ終わり
            if (this.isJumping && 0 >= this.currentJumpPower && isSlopeFace) {
                this.isJumping = false;
                this.isGrounded = true;
                // console.log( 'jump end' );
            }
            // if ( this.isGrounded || this.isOnSlope ) {
            //   // 地面の上にいる場合はy(縦)方向は同一のまま
            //   // x, z (横) 方向だけを変更して押し出す
            //   // http://gamedev.stackexchange.com/questions/80293/how-do-i-resolve-a-sphere-triangle-collision-in-a-given-direction
            // 	sphereCenter.set( 0, this.radius, 0 ).add( this.position );
            // 	point1.copy( normal ).multiplyScalar( - this.radius ).add( sphereCenter );
            // 	direction.set( normal.x, 0, normal.z ).normalize();
            // 	const plainD = triangle.a.dot( normal );
            // 	const t = ( plainD - ( normal.x * point1.x + normal.y * point1.y + normal.z * point1.z ) ) / ( normal.x * direction.x + normal.y * direction.y + normal.z * direction.z );
            // 	point2.copy( direction ).multiplyScalar( t ).add( point1 );
            // 	translateScoped.subVectors( point2, point1 );
            // 	if ( translate.lengthSq() < translateScoped.lengthSq() ) {
            // 		translate.copy( translateScoped );
            // 	}
            // 	// break;
            // 	continue;
            // }
        }
        this.position.add(translate);
        this.object.position.copy(this.position);
        this.object.rotation.y = this.direction + Math.PI;
    }
    setDirection() {}
    jump() {
        if (this.isJumping || !this.isGrounded || this.isOnSlope) return;
        this.jumpStartTime = performance.now();
        this.currentJumpPower = 1;
        this.isJumping = true;
    }
    _updateJumping() {
        if (!this.isJumping) return;
        const elapsed = performance.now() - this.jumpStartTime;
        const progress = elapsed / JUMP_DURATION;
        this.currentJumpPower = Math.cos(Math.min(progress, 1) * Math.PI);
    }
    teleport(x, y, z) {
        this.position.set(x, y, z);
        this.object.position.copy(this.position);
    }
}

const sphere = new three__WEBPACK_IMPORTED_MODULE_0__/* .Sphere */ .aLr();
class World {
    constructor({ fps = 60, stepsPerFrame = 4 } = {}) {
        this.colliderPool = [];
        this.characterPool = [];
        this._fps = fps;
        this._stepsPerFrame = stepsPerFrame;
    }
    add(object) {
        if (object instanceof Octree) {
            this.colliderPool.push(object);
        }
        if (object instanceof CharacterController) {
            this.characterPool.push(object);
        }
    }
    remove(object) {
        if (object instanceof Octree) {
            const index = this.colliderPool.indexOf(object);
            if (index !== -1) this.colliderPool.splice(index, 1);
        }
        if (object instanceof CharacterController) {
            const index = this.characterPool.indexOf(object);
            if (index !== -1) this.characterPool.splice(index, 1);
        }
    }
    fixedUpdate() {
        const deltaTime = 1 / this._fps;
        const stepDeltaTime = deltaTime / this._stepsPerFrame;
        for (let i = 0; i < this._stepsPerFrame; i++) {
            this.step(stepDeltaTime);
        }
    }
    step(stepDeltaTime) {
        for (let i = 0, l = this.characterPool.length; i < l; i++) {
            const character = this.characterPool[i];
            let triangles = [];
            // octree で絞られた node に含まれる face だけを
            // character に渡して判定する
            for (let ii = 0, ll = this.colliderPool.length; ii < ll; ii++) {
                const octree = this.colliderPool[ii];
                sphere.center
                    .set(0, character.radius, 0)
                    .add(character.position);
                sphere.radius = character.radius + character.groundCheckDepth;
                triangles.push(...octree.getSphereTriangles(sphere, []));
            }
            character.setNearTriangles(triangles);
            character.update(stepDeltaTime);
        }
    }
}

const TURN_DURATION = 200;
const TAU = 2 * Math.PI;
const modulo = (n, d) => ((n % d) + d) % d;
const getDeltaTurnAngle = (current, target) => {
    const a = modulo(current - target, TAU);
    const b = modulo(target - current, TAU);
    return a < b ? -a : b;
};
class AnimationController {
    constructor(mesh, animations) {
        this._targetRotY = null;
        this.mesh = mesh;
        this.motion = {};
        this.mixer = new three__WEBPACK_IMPORTED_MODULE_0__/* .AnimationMixer */ .Xcj(mesh);
        this.currentMotionName = "";
        for (let i = 0, l = animations.length; i < l; i++) {
            const anim = animations[i];
            this.motion[anim.name] = this.mixer.clipAction(anim);
            this.motion[anim.name].setEffectiveWeight(1);
        }
    }
    play(name) {
        if (this.currentMotionName === name) return;
        if (this.motion[this.currentMotionName]) {
            const from = this.motion[this.currentMotionName].play();
            const to = this.motion[name].play();
            from.enabled = true;
            to.enabled = true;
            from.crossFadeTo(to, 0.3, false);
        } else {
            this.motion[name].enabled = true;
            this.motion[name].play();
        }
        this.currentMotionName = name;
    }
    turn(rad, immediate) {
        const that = this;
        const prevRotY = this.mesh.rotation.y;
        const targetRotY = rad;
        const deltaY = getDeltaTurnAngle(prevRotY, targetRotY);
        // const duration   = Math.abs( deltaY ) * 100;
        const start = Date.now();
        const end = start + TURN_DURATION;
        let progress = 0;
        if (immediate) {
            this.mesh.rotation.y = targetRotY;
            return;
        }
        if (this._targetRotY === targetRotY) return;
        this._targetRotY = targetRotY;
        {
            let _targetRotY = targetRotY;
            (function interval() {
                const now = Date.now();
                const isAborted = _targetRotY !== that._targetRotY;
                if (isAborted) return;
                if (now >= end) {
                    that.mesh.rotation.y = _targetRotY;
                    that._targetRotY = null;
                    return;
                }
                requestAnimationFrame(interval);
                progress = (now - start) / TURN_DURATION;
                that.mesh.rotation.y = prevRotY + deltaY * progress;
            })();
        }
    }
    update(deltaTime) {
        this.mixer.update(deltaTime);
    }
}

const KEY_W = 87;
const KEY_UP = 38;
const KEY_S = 83;
const KEY_DOWN = 40;
const KEY_A = 65;
const KEY_LEFT = 37;
const KEY_D = 68;
const KEY_RIGHT = 39;
const KEY_SPACE = 32;
const DEG2RAD$1 = Math.PI / 180;
const DEG_0 = 0 * DEG2RAD$1;
const DEG_45 = 45 * DEG2RAD$1;
const DEG_90 = 90 * DEG2RAD$1;
const DEG_135 = 135 * DEG2RAD$1;
const DEG_180 = 180 * DEG2RAD$1;
const DEG_225 = 225 * DEG2RAD$1;
const DEG_270 = 270 * DEG2RAD$1;
const DEG_315 = 315 * DEG2RAD$1;
class KeyInputControl extends EventDispatcher$1 {
    constructor() {
        super();
        this.isDisabled = false;
        this.isUp = false;
        this.isDown = false;
        this.isLeft = false;
        this.isRight = false;
        this.isMoveKeyHolding = false;
        this.frontAngle = 0;
        this._keydownListener = (event) => {
            if (this.isDisabled) return;
            if (isInputEvent(event)) return;
            switch (event.keyCode) {
                case KEY_W:
                case KEY_UP:
                    this.isUp = true;
                    break;
                case KEY_S:
                case KEY_DOWN:
                    this.isDown = true;
                    break;
                case KEY_A:
                case KEY_LEFT:
                    this.isLeft = true;
                    break;
                case KEY_D:
                case KEY_RIGHT:
                    this.isRight = true;
                    break;
                case KEY_SPACE:
                    this.jump();
                    break;
                default:
                    return;
            }
            const prevAngle = this.frontAngle;
            this.updateAngle();
            if (prevAngle !== this.frontAngle) {
                this.dispatchEvent({ type: "movekeychange" });
            }
            if (
                (this.isUp || this.isDown || this.isLeft || this.isRight) &&
                !this.isMoveKeyHolding
            ) {
                this.isMoveKeyHolding = true;
                this.dispatchEvent({ type: "movekeyon" });
            }
        };
        this._keyupListener = (event) => {
            if (this.isDisabled) return;
            switch (event.keyCode) {
                case KEY_W:
                case KEY_UP:
                    this.isUp = false;
                    break;
                case KEY_S:
                case KEY_DOWN:
                    this.isDown = false;
                    break;
                case KEY_A:
                case KEY_LEFT:
                    this.isLeft = false;
                    break;
                case KEY_D:
                case KEY_RIGHT:
                    this.isRight = false;
                    break;
                case KEY_SPACE:
                    break;
                default:
                    return;
            }
            const prevAngle = this.frontAngle;
            this.updateAngle();
            if (prevAngle !== this.frontAngle) {
                this.dispatchEvent({ type: "movekeychange" });
            }
            if (
                !this.isUp &&
                !this.isDown &&
                !this.isLeft &&
                !this.isRight &&
                (event.keyCode === KEY_W ||
                    event.keyCode === KEY_UP ||
                    event.keyCode === KEY_S ||
                    event.keyCode === KEY_DOWN ||
                    event.keyCode === KEY_A ||
                    event.keyCode === KEY_LEFT ||
                    event.keyCode === KEY_D ||
                    event.keyCode === KEY_RIGHT)
            ) {
                this.isMoveKeyHolding = false;
                this.dispatchEvent({ type: "movekeyoff" });
            }
        };
        this._blurListener = () => {
            this.isUp = false;
            this.isDown = false;
            this.isLeft = false;
            this.isRight = false;
            if (this.isMoveKeyHolding) {
                this.isMoveKeyHolding = false;
                this.dispatchEvent({ type: "movekeyoff" });
            }
        };
        function isInputEvent(event) {
            const target = event.target;
            if (!(target instanceof HTMLElement)) return false;
            return (
                target.tagName === "INPUT" ||
                target.tagName === "SELECT" ||
                target.tagName === "TEXTAREA" ||
                target.tagName === "BUTTON" ||
                target.isContentEditable
            );
        }
        window.addEventListener("keydown", this._keydownListener);
        window.addEventListener("keyup", this._keyupListener);
        window.addEventListener("blur", this._blurListener);
        window.addEventListener("contextmenu", this._blurListener);
    }
    jump() {
        this.dispatchEvent({ type: "jumpkeypress" });
    }
    updateAngle() {
        const up = this.isUp;
        const down = this.isDown;
        const left = this.isLeft;
        const right = this.isRight;
        if (up && !left && !down && !right) this.frontAngle = DEG_0;
        else if (up && left && !down && !right) this.frontAngle = DEG_45;
        else if (!up && left && !down && !right) this.frontAngle = DEG_90;
        else if (!up && left && down && !right) this.frontAngle = DEG_135;
        else if (!up && !left && down && !right) this.frontAngle = DEG_180;
        else if (!up && !left && down && right) this.frontAngle = DEG_225;
        else if (!up && !left && !down && right) this.frontAngle = DEG_270;
        else if (up && !left && !down && right) this.frontAngle = DEG_315;
    }
    dispose() {
        window.removeEventListener("keydown", this._keydownListener);
        window.removeEventListener("keyup", this._keyupListener);
        window.removeEventListener("blur", this._blurListener);
        this._blurListener();
    }
}

/*!
 * camera-controls
 * https://github.com/yomotsu/camera-controls
 * (c) 2017 @yomotsu
 * Released under the MIT License.
 */
// see https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/buttons#value
const MOUSE_BUTTON = {
    LEFT: 1,
    RIGHT: 2,
    MIDDLE: 4,
};
const ACTION = Object.freeze({
    NONE: 0,
    ROTATE: 1,
    TRUCK: 2,
    OFFSET: 4,
    DOLLY: 8,
    ZOOM: 16,
    TOUCH_ROTATE: 32,
    TOUCH_TRUCK: 64,
    TOUCH_OFFSET: 128,
    TOUCH_DOLLY: 256,
    TOUCH_ZOOM: 512,
    TOUCH_DOLLY_TRUCK: 1024,
    TOUCH_DOLLY_OFFSET: 2048,
    TOUCH_DOLLY_ROTATE: 4096,
    TOUCH_ZOOM_TRUCK: 8192,
    TOUCH_ZOOM_OFFSET: 16384,
    TOUCH_ZOOM_ROTATE: 32768,
});
function isPerspectiveCamera(camera) {
    return camera.isPerspectiveCamera;
}
function isOrthographicCamera(camera) {
    return camera.isOrthographicCamera;
}

const PI_2 = Math.PI * 2;
const PI_HALF = Math.PI / 2;

const EPSILON = 1e-5;
const DEG2RAD = Math.PI / 180;
function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
function approxZero(number, error = EPSILON) {
    return Math.abs(number) < error;
}
function approxEquals(a, b, error = EPSILON) {
    return approxZero(a - b, error);
}
function roundToStep(value, step) {
    return Math.round(value / step) * step;
}
function infinityToMaxNumber(value) {
    if (isFinite(value)) return value;
    if (value < 0) return -Number.MAX_VALUE;
    return Number.MAX_VALUE;
}
function maxNumberToInfinity(value) {
    if (Math.abs(value) < Number.MAX_VALUE) return value;
    return value * Infinity;
}
// https://docs.unity3d.com/ScriptReference/Mathf.SmoothDamp.html
// https://github.com/Unity-Technologies/UnityCsReference/blob/a2bdfe9b3c4cd4476f44bf52f848063bfaf7b6b9/Runtime/Export/Math/Mathf.cs#L308
function smoothDamp(
    current,
    target,
    currentVelocityRef,
    smoothTime,
    maxSpeed = Infinity,
    deltaTime
) {
    // Based on Game Programming Gems 4 Chapter 1.10
    smoothTime = Math.max(0.0001, smoothTime);
    const omega = 2 / smoothTime;
    const x = omega * deltaTime;
    const exp = 1 / (1 + x + 0.48 * x * x + 0.235 * x * x * x);
    let change = current - target;
    const originalTo = target;
    // Clamp maximum speed
    const maxChange = maxSpeed * smoothTime;
    change = clamp(change, -maxChange, maxChange);
    target = current - change;
    const temp = (currentVelocityRef.value + omega * change) * deltaTime;
    currentVelocityRef.value = (currentVelocityRef.value - omega * temp) * exp;
    let output = target + (change + temp) * exp;
    // Prevent overshooting
    if (originalTo - current > 0.0 === output > originalTo) {
        output = originalTo;
        currentVelocityRef.value = (output - originalTo) / deltaTime;
    }
    return output;
}
// https://docs.unity3d.com/ScriptReference/Vector3.SmoothDamp.html
// https://github.com/Unity-Technologies/UnityCsReference/blob/a2bdfe9b3c4cd4476f44bf52f848063bfaf7b6b9/Runtime/Export/Math/Vector3.cs#L97
function smoothDampVec3(
    current,
    target,
    currentVelocityRef,
    smoothTime,
    maxSpeed = Infinity,
    deltaTime,
    out
) {
    // Based on Game Programming Gems 4 Chapter 1.10
    smoothTime = Math.max(0.0001, smoothTime);
    const omega = 2 / smoothTime;
    const x = omega * deltaTime;
    const exp = 1 / (1 + x + 0.48 * x * x + 0.235 * x * x * x);
    let targetX = target.x;
    let targetY = target.y;
    let targetZ = target.z;
    let changeX = current.x - targetX;
    let changeY = current.y - targetY;
    let changeZ = current.z - targetZ;
    const originalToX = targetX;
    const originalToY = targetY;
    const originalToZ = targetZ;
    // Clamp maximum speed
    const maxChange = maxSpeed * smoothTime;
    const maxChangeSq = maxChange * maxChange;
    const magnitudeSq =
        changeX * changeX + changeY * changeY + changeZ * changeZ;
    if (magnitudeSq > maxChangeSq) {
        const magnitude = Math.sqrt(magnitudeSq);
        changeX = (changeX / magnitude) * maxChange;
        changeY = (changeY / magnitude) * maxChange;
        changeZ = (changeZ / magnitude) * maxChange;
    }
    targetX = current.x - changeX;
    targetY = current.y - changeY;
    targetZ = current.z - changeZ;
    const tempX = (currentVelocityRef.x + omega * changeX) * deltaTime;
    const tempY = (currentVelocityRef.y + omega * changeY) * deltaTime;
    const tempZ = (currentVelocityRef.z + omega * changeZ) * deltaTime;
    currentVelocityRef.x = (currentVelocityRef.x - omega * tempX) * exp;
    currentVelocityRef.y = (currentVelocityRef.y - omega * tempY) * exp;
    currentVelocityRef.z = (currentVelocityRef.z - omega * tempZ) * exp;
    out.x = targetX + (changeX + tempX) * exp;
    out.y = targetY + (changeY + tempY) * exp;
    out.z = targetZ + (changeZ + tempZ) * exp;
    // Prevent overshooting
    const origMinusCurrentX = originalToX - current.x;
    const origMinusCurrentY = originalToY - current.y;
    const origMinusCurrentZ = originalToZ - current.z;
    const outMinusOrigX = out.x - originalToX;
    const outMinusOrigY = out.y - originalToY;
    const outMinusOrigZ = out.z - originalToZ;
    if (
        origMinusCurrentX * outMinusOrigX +
            origMinusCurrentY * outMinusOrigY +
            origMinusCurrentZ * outMinusOrigZ >
        0
    ) {
        out.x = originalToX;
        out.y = originalToY;
        out.z = originalToZ;
        currentVelocityRef.x = (out.x - originalToX) / deltaTime;
        currentVelocityRef.y = (out.y - originalToY) / deltaTime;
        currentVelocityRef.z = (out.z - originalToZ) / deltaTime;
    }
    return out;
}

function extractClientCoordFromEvent(pointers, out) {
    out.set(0, 0);
    pointers.forEach((pointer) => {
        out.x += pointer.clientX;
        out.y += pointer.clientY;
    });
    out.x /= pointers.length;
    out.y /= pointers.length;
}

function notSupportedInOrthographicCamera(camera, message) {
    if (isOrthographicCamera(camera)) {
        console.warn(`${message} is not supported in OrthographicCamera`);
        return true;
    }
    return false;
}

class EventDispatcher {
    constructor() {
        this._listeners = {};
    }
    /**
     * Adds the specified event listener.
     * @param type event name
     * @param listener handler function
     * @category Methods
     */
    addEventListener(type, listener) {
        const listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        if (listeners[type].indexOf(listener) === -1)
            listeners[type].push(listener);
    }
    /**
     * Presence of the specified event listener.
     * @param type event name
     * @param listener handler function
     * @category Methods
     */
    hasEventListener(type, listener) {
        const listeners = this._listeners;
        return (
            listeners[type] !== undefined &&
            listeners[type].indexOf(listener) !== -1
        );
    }
    /**
     * Removes the specified event listener
     * @param type event name
     * @param listener handler function
     * @category Methods
     */
    removeEventListener(type, listener) {
        const listeners = this._listeners;
        const listenerArray = listeners[type];
        if (listenerArray !== undefined) {
            const index = listenerArray.indexOf(listener);
            if (index !== -1) listenerArray.splice(index, 1);
        }
    }
    /**
     * Removes all event listeners
     * @param type event name
     * @category Methods
     */
    removeAllEventListeners(type) {
        if (!type) {
            this._listeners = {};
            return;
        }
        if (Array.isArray(this._listeners[type]))
            this._listeners[type].length = 0;
    }
    /**
     * Fire an event type.
     * @param event DispatcherEvent
     * @category Methods
     */
    dispatchEvent(event) {
        const listeners = this._listeners;
        const listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            const array = listenerArray.slice(0);
            for (let i = 0, l = array.length; i < l; i++) {
                array[i].call(this, event);
            }
        }
    }
}

const VERSION = "2.3.4"; // will be replaced with `version` in package.json during the build process.
const TOUCH_DOLLY_FACTOR = 1 / 8;
const isBrowser = typeof window !== "undefined";
const isMac = isBrowser && /Mac/.test(navigator.platform);
const isPointerEventsNotSupported = !(isBrowser && "PointerEvent" in window); // macOS Safari 12 does not support PointerEvents API
let THREE;
let _ORIGIN$1;
let _AXIS_Y;
let _AXIS_Z;
let _v2;
let _v3A$1;
let _v3B$1;
let _v3C$1;
let _xColumn;
let _yColumn;
let _zColumn;
let _deltaTarget;
let _deltaOffset;
let _sphericalA;
let _sphericalB;
let _box3A;
let _box3B;
let _sphere;
let _quaternionA;
let _quaternionB;
let _rotationMatrix$1;
let _raycaster;
class CameraControls extends EventDispatcher {
    /**
     * Injects THREE as the dependency. You can then proceed to use CameraControls.
     *
     * e.g
     * ```javascript
     * CameraControls.install( { THREE: THREE } );
     * ```
     *
     * Note: If you do not wish to use enter three.js to reduce file size(tree-shaking for example), make a subset to install.
     *
     * ```js
     * import {
     * 	Vector2,
     * 	Vector3,
     * 	Vector4,
     * 	Quaternion,
     * 	Matrix4,
     * 	Spherical,
     * 	Box3,
     * 	Sphere,
     * 	Raycaster,
     * 	MathUtils,
     * } from 'three';
     *
     * const subsetOfTHREE = {
     * 	Vector2   : Vector2,
     * 	Vector3   : Vector3,
     * 	Vector4   : Vector4,
     * 	Quaternion: Quaternion,
     * 	Matrix4   : Matrix4,
     * 	Spherical : Spherical,
     * 	Box3      : Box3,
     * 	Sphere    : Sphere,
     * 	Raycaster : Raycaster,
     * };

     * CameraControls.install( { THREE: subsetOfTHREE } );
     * ```
     * @category Statics
     */
    static install(libs) {
        THREE = libs.THREE;
        _ORIGIN$1 = Object.freeze(new THREE.Vector3(0, 0, 0));
        _AXIS_Y = Object.freeze(new THREE.Vector3(0, 1, 0));
        _AXIS_Z = Object.freeze(new THREE.Vector3(0, 0, 1));
        _v2 = new THREE.Vector2();
        _v3A$1 = new THREE.Vector3();
        _v3B$1 = new THREE.Vector3();
        _v3C$1 = new THREE.Vector3();
        _xColumn = new THREE.Vector3();
        _yColumn = new THREE.Vector3();
        _zColumn = new THREE.Vector3();
        _deltaTarget = new THREE.Vector3();
        _deltaOffset = new THREE.Vector3();
        _sphericalA = new THREE.Spherical();
        _sphericalB = new THREE.Spherical();
        _box3A = new THREE.Box3();
        _box3B = new THREE.Box3();
        _sphere = new THREE.Sphere();
        _quaternionA = new THREE.Quaternion();
        _quaternionB = new THREE.Quaternion();
        _rotationMatrix$1 = new THREE.Matrix4();
        _raycaster = new THREE.Raycaster();
    }
    /**
     * list all ACTIONs
     * @category Statics
     */
    static get ACTION() {
        return ACTION;
    }
    /**
     * Creates a `CameraControls` instance.
     *
     * Note:
     * You **must install** three.js before using camera-controls. see [#install](#install)
     * Not doing so will lead to runtime errors (`undefined` references to THREE).
     *
     * e.g.
     * ```
     * CameraControls.install( { THREE } );
     * const cameraControls = new CameraControls( camera, domElement );
     * ```
     *
     * @param camera A `THREE.PerspectiveCamera` or `THREE.OrthographicCamera` to be controlled.
     * @param domElement A `HTMLElement` for the draggable area, usually `renderer.domElement`.
     * @category Constructor
     */
    constructor(camera, domElement) {
        super();
        /**
         * Minimum vertical angle in radians.
         * The angle has to be between `0` and `.maxPolarAngle` inclusive.
         * The default value is `0`.
         *
         * e.g.
         * ```
         * cameraControls.maxPolarAngle = 0;
         * ```
         * @category Properties
         */
        this.minPolarAngle = 0; // radians
        /**
         * Maximum vertical angle in radians.
         * The angle has to be between `.maxPolarAngle` and `Math.PI` inclusive.
         * The default value is `Math.PI`.
         *
         * e.g.
         * ```
         * cameraControls.maxPolarAngle = Math.PI;
         * ```
         * @category Properties
         */
        this.maxPolarAngle = Math.PI; // radians
        /**
         * Minimum horizontal angle in radians.
         * The angle has to be less than `.maxAzimuthAngle`.
         * The default value is `- Infinity`.
         *
         * e.g.
         * ```
         * cameraControls.minAzimuthAngle = - Infinity;
         * ```
         * @category Properties
         */
        this.minAzimuthAngle = -Infinity; // radians
        /**
         * Maximum horizontal angle in radians.
         * The angle has to be greater than `.minAzimuthAngle`.
         * The default value is `Infinity`.
         *
         * e.g.
         * ```
         * cameraControls.maxAzimuthAngle = Infinity;
         * ```
         * @category Properties
         */
        this.maxAzimuthAngle = Infinity; // radians
        // How far you can dolly in and out ( PerspectiveCamera only )
        /**
         * Minimum distance for dolly. The value must be higher than `0`.
         * PerspectiveCamera only.
         * @category Properties
         */
        this.minDistance = 0;
        /**
         * Maximum distance for dolly. The value must be higher than `minDistance`.
         * PerspectiveCamera only.
         * @category Properties
         */
        this.maxDistance = Infinity;
        /**
         * `true` to enable Infinity Dolly.
         * When the Dolly distance is less than the `minDistance`, radius of the sphere will be set `minDistance` automatically.
         * @category Properties
         */
        this.infinityDolly = false;
        /**
         * Minimum camera zoom.
         * @category Properties
         */
        this.minZoom = 0.01;
        /**
         * Maximum camera zoom.
         * @category Properties
         */
        this.maxZoom = Infinity;
        /**
         * Approximate time in seconds to reach the target. A smaller value will reach the target faster.
         * @category Properties
         */
        this.smoothTime = 0.25;
        /**
         * the smoothTime while dragging
         * @category Properties
         */
        this.draggingSmoothTime = 0.125;
        /**
         * Max transition speed in unit-per-seconds
         * @category Properties
         */
        this.maxSpeed = Infinity;
        /**
         * Speed of azimuth (horizontal) rotation.
         * @category Properties
         */
        this.azimuthRotateSpeed = 1.0;
        /**
         * Speed of polar (vertical) rotation.
         * @category Properties
         */
        this.polarRotateSpeed = 1.0;
        /**
         * Speed of mouse-wheel dollying.
         * @category Properties
         */
        this.dollySpeed = 1.0;
        /**
         * `true` to invert direction when dollying or zooming via drag
         * @category Properties
         */
        this.dollyDragInverted = false;
        /**
         * Speed of drag for truck and pedestal.
         * @category Properties
         */
        this.truckSpeed = 2.0;
        /**
         * `true` to enable Dolly-in to the mouse cursor coords.
         * @category Properties
         */
        this.dollyToCursor = false;
        /**
         * @category Properties
         */
        this.dragToOffset = false;
        /**
         * The same as `.screenSpacePanning` in three.js's OrbitControls.
         * @category Properties
         */
        this.verticalDragToForward = false;
        /**
         * Friction ratio of the boundary.
         * @category Properties
         */
        this.boundaryFriction = 0.0;
        /**
         * Controls how soon the `rest` event fires as the camera slows.
         * @category Properties
         */
        this.restThreshold = 0.01;
        /**
         * An array of Meshes to collide with camera.
         * Be aware colliderMeshes may decrease performance. The collision test uses 4 raycasters from the camera since the near plane has 4 corners.
         * @category Properties
         */
        this.colliderMeshes = [];
        /**
         * Force cancel user dragging.
         * @category Methods
         */
        // cancel will be overwritten in the constructor.
        this.cancel = () => {};
        this._enabled = true;
        this._state = ACTION.NONE;
        this._viewport = null;
        this._dollyControlAmount = 0;
        this._hasRested = true;
        this._boundaryEnclosesCamera = false;
        this._needsUpdate = true;
        this._updatedLastTime = false;
        this._elementRect = new DOMRect();
        this._activePointers = [];
        // Use draggingSmoothTime over smoothTime while true.
        // set automatically true on user-dragging start.
        // set automatically false on programmable methods call.
        this._isUserControllingRotate = false;
        this._isUserControllingDolly = false;
        this._isUserControllingTruck = false;
        this._isUserControllingOffset = false;
        this._isUserControllingZoom = false;
        // velocities for smoothDamp
        this._thetaVelocity = { value: 0 };
        this._phiVelocity = { value: 0 };
        this._radiusVelocity = { value: 0 };
        this._targetVelocity = new THREE.Vector3();
        this._focalOffsetVelocity = new THREE.Vector3();
        this._zoomVelocity = { value: 0 };
        this._truckInternal = (deltaX, deltaY, dragToOffset) => {
            if (isPerspectiveCamera(this._camera)) {
                const offset = _v3A$1
                    .copy(this._camera.position)
                    .sub(this._target);
                // half of the fov is center to top of screen
                const fov = this._camera.getEffectiveFOV() * DEG2RAD;
                const targetDistance = offset.length() * Math.tan(fov * 0.5);
                const truckX =
                    (this.truckSpeed * deltaX * targetDistance) /
                    this._elementRect.height;
                const pedestalY =
                    (this.truckSpeed * deltaY * targetDistance) /
                    this._elementRect.height;
                if (this.verticalDragToForward) {
                    dragToOffset
                        ? this.setFocalOffset(
                              this._focalOffsetEnd.x + truckX,
                              this._focalOffsetEnd.y,
                              this._focalOffsetEnd.z,
                              true
                          )
                        : this.truck(truckX, 0, true);
                    this.forward(-pedestalY, true);
                } else {
                    dragToOffset
                        ? this.setFocalOffset(
                              this._focalOffsetEnd.x + truckX,
                              this._focalOffsetEnd.y + pedestalY,
                              this._focalOffsetEnd.z,
                              true
                          )
                        : this.truck(truckX, pedestalY, true);
                }
            } else if (isOrthographicCamera(this._camera)) {
                // orthographic
                const camera = this._camera;
                const truckX =
                    (deltaX * (camera.right - camera.left)) /
                    camera.zoom /
                    this._elementRect.width;
                const pedestalY =
                    (deltaY * (camera.top - camera.bottom)) /
                    camera.zoom /
                    this._elementRect.height;
                dragToOffset
                    ? this.setFocalOffset(
                          this._focalOffsetEnd.x + truckX,
                          this._focalOffsetEnd.y + pedestalY,
                          this._focalOffsetEnd.z,
                          true
                      )
                    : this.truck(truckX, pedestalY, true);
            }
        };
        this._rotateInternal = (deltaX, deltaY) => {
            const theta =
                (PI_2 * this.azimuthRotateSpeed * deltaX) /
                this._elementRect.height; // divide by *height* to refer the resolution
            const phi =
                (PI_2 * this.polarRotateSpeed * deltaY) /
                this._elementRect.height;
            this.rotate(theta, phi, true);
        };
        this._dollyInternal = (delta, x, y) => {
            const dollyScale = Math.pow(0.95, -delta * this.dollySpeed);
            const distance = this._sphericalEnd.radius * dollyScale;
            const prevRadius = this._sphericalEnd.radius;
            const signedPrevRadius = prevRadius * (delta >= 0 ? -1 : 1);
            this.dollyTo(distance);
            if (
                this.infinityDolly &&
                (distance < this.minDistance ||
                    this.maxDistance === this.minDistance)
            ) {
                this._camera.getWorldDirection(_v3A$1);
                this._targetEnd.add(
                    _v3A$1.normalize().multiplyScalar(signedPrevRadius)
                );
                this._target.add(
                    _v3A$1.normalize().multiplyScalar(signedPrevRadius)
                );
            }
            if (this.dollyToCursor) {
                this._dollyControlAmount +=
                    this._sphericalEnd.radius - prevRadius;
                if (
                    this.infinityDolly &&
                    (distance < this.minDistance ||
                        this.maxDistance === this.minDistance)
                ) {
                    this._dollyControlAmount -= signedPrevRadius;
                }
                this._dollyControlCoord.set(x, y);
            }
        };
        this._zoomInternal = (delta, x, y) => {
            const zoomScale = Math.pow(0.95, delta * this.dollySpeed);
            const prevZoom = this._zoomEnd;
            // for both PerspectiveCamera and OrthographicCamera
            this.zoomTo(this._zoom * zoomScale);
            if (this.dollyToCursor) {
                this._dollyControlAmount += this._zoomEnd - prevZoom;
                this._dollyControlCoord.set(x, y);
            }
        };
        // Check if the user has installed THREE
        if (typeof THREE === "undefined") {
            console.error(
                "camera-controls: `THREE` is undefined. You must first run `CameraControls.install( { THREE: THREE } )`. Check the docs for further information."
            );
        }
        this._camera = camera;
        this._yAxisUpSpace = new THREE.Quaternion().setFromUnitVectors(
            this._camera.up,
            _AXIS_Y
        );
        this._yAxisUpSpaceInverse = this._yAxisUpSpace.clone().invert();
        this._state = ACTION.NONE;
        // the location
        this._target = new THREE.Vector3();
        this._targetEnd = this._target.clone();
        this._focalOffset = new THREE.Vector3();
        this._focalOffsetEnd = this._focalOffset.clone();
        // rotation
        this._spherical = new THREE.Spherical().setFromVector3(
            _v3A$1
                .copy(this._camera.position)
                .applyQuaternion(this._yAxisUpSpace)
        );
        this._sphericalEnd = this._spherical.clone();
        this._zoom = this._camera.zoom;
        this._zoomEnd = this._zoom;
        // collisionTest uses nearPlane.s
        this._nearPlaneCorners = [
            new THREE.Vector3(),
            new THREE.Vector3(),
            new THREE.Vector3(),
            new THREE.Vector3(),
        ];
        this._updateNearPlaneCorners();
        // Target cannot move outside of this box
        this._boundary = new THREE.Box3(
            new THREE.Vector3(-Infinity, -Infinity, -Infinity),
            new THREE.Vector3(Infinity, Infinity, Infinity)
        );
        // reset
        this._cameraUp0 = this._camera.up.clone();
        this._target0 = this._target.clone();
        this._position0 = this._camera.position.clone();
        this._zoom0 = this._zoom;
        this._focalOffset0 = this._focalOffset.clone();
        this._dollyControlAmount = 0;
        this._dollyControlCoord = new THREE.Vector2();
        // configs
        this.mouseButtons = {
            left: ACTION.ROTATE,
            middle: ACTION.DOLLY,
            right: ACTION.TRUCK,
            wheel: isPerspectiveCamera(this._camera)
                ? ACTION.DOLLY
                : isOrthographicCamera(this._camera)
                ? ACTION.ZOOM
                : ACTION.NONE,
        };
        this.touches = {
            one: ACTION.TOUCH_ROTATE,
            two: isPerspectiveCamera(this._camera)
                ? ACTION.TOUCH_DOLLY_TRUCK
                : isOrthographicCamera(this._camera)
                ? ACTION.TOUCH_ZOOM_TRUCK
                : ACTION.NONE,
            three: ACTION.TOUCH_TRUCK,
        };
        const dragStartPosition = new THREE.Vector2();
        const lastDragPosition = new THREE.Vector2();
        const dollyStart = new THREE.Vector2();
        const onPointerDown = (event) => {
            if (!this._enabled || !this._domElement) return;
            // Don't call `event.preventDefault()` on the pointerdown event
            // to keep receiving pointermove evens outside dragging iframe
            // https://taye.me/blog/tips/2015/11/16/mouse-drag-outside-iframe/
            const mouseButton =
                event.pointerType !== "mouse"
                    ? null
                    : (event.buttons & MOUSE_BUTTON.LEFT) === MOUSE_BUTTON.LEFT
                    ? MOUSE_BUTTON.LEFT
                    : (event.buttons & MOUSE_BUTTON.MIDDLE) ===
                      MOUSE_BUTTON.MIDDLE
                    ? MOUSE_BUTTON.MIDDLE
                    : (event.buttons & MOUSE_BUTTON.RIGHT) ===
                      MOUSE_BUTTON.RIGHT
                    ? MOUSE_BUTTON.RIGHT
                    : null;
            if (mouseButton !== null) {
                const zombiePointer =
                    this._findPointerByMouseButton(mouseButton);
                zombiePointer &&
                    this._activePointers.splice(
                        this._activePointers.indexOf(zombiePointer),
                        1
                    );
            }
            const pointer = {
                pointerId: event.pointerId,
                clientX: event.clientX,
                clientY: event.clientY,
                deltaX: 0,
                deltaY: 0,
                mouseButton,
            };
            this._activePointers.push(pointer);
            // eslint-disable-next-line no-undef
            this._domElement.ownerDocument.removeEventListener(
                "pointermove",
                onPointerMove,
                { passive: false }
            );
            this._domElement.ownerDocument.removeEventListener(
                "pointerup",
                onPointerUp
            );
            this._domElement.ownerDocument.addEventListener(
                "pointermove",
                onPointerMove,
                { passive: false }
            );
            this._domElement.ownerDocument.addEventListener(
                "pointerup",
                onPointerUp
            );
            startDragging(event);
        };
        const onMouseDown = (event) => {
            if (!this._enabled || !this._domElement) return;
            const mouseButton =
                (event.buttons & MOUSE_BUTTON.LEFT) === MOUSE_BUTTON.LEFT
                    ? MOUSE_BUTTON.LEFT
                    : (event.buttons & MOUSE_BUTTON.MIDDLE) ===
                      MOUSE_BUTTON.MIDDLE
                    ? MOUSE_BUTTON.MIDDLE
                    : (event.buttons & MOUSE_BUTTON.RIGHT) ===
                      MOUSE_BUTTON.RIGHT
                    ? MOUSE_BUTTON.RIGHT
                    : null;
            if (mouseButton !== null) {
                const zombiePointer =
                    this._findPointerByMouseButton(mouseButton);
                zombiePointer &&
                    this._activePointers.splice(
                        this._activePointers.indexOf(zombiePointer),
                        1
                    );
            }
            const pointer = {
                pointerId: 0,
                clientX: event.clientX,
                clientY: event.clientY,
                deltaX: 0,
                deltaY: 0,
                mouseButton:
                    (event.buttons & MOUSE_BUTTON.LEFT) === MOUSE_BUTTON.LEFT
                        ? MOUSE_BUTTON.LEFT
                        : (event.buttons & MOUSE_BUTTON.MIDDLE) ===
                          MOUSE_BUTTON.LEFT
                        ? MOUSE_BUTTON.MIDDLE
                        : (event.buttons & MOUSE_BUTTON.RIGHT) ===
                          MOUSE_BUTTON.LEFT
                        ? MOUSE_BUTTON.RIGHT
                        : null,
            };
            this._activePointers.push(pointer);
            // see https://github.com/microsoft/TypeScript/issues/32912#issuecomment-522142969
            // eslint-disable-next-line no-undef
            this._domElement.ownerDocument.removeEventListener(
                "mousemove",
                onMouseMove
            );
            this._domElement.ownerDocument.removeEventListener(
                "mouseup",
                onMouseUp
            );
            this._domElement.ownerDocument.addEventListener(
                "mousemove",
                onMouseMove
            );
            this._domElement.ownerDocument.addEventListener(
                "mouseup",
                onMouseUp
            );
            startDragging(event);
        };
        const onPointerMove = (event) => {
            if (event.cancelable) event.preventDefault();
            const pointerId = event.pointerId;
            const pointer = this._findPointerById(pointerId);
            if (!pointer) return;
            pointer.clientX = event.clientX;
            pointer.clientY = event.clientY;
            pointer.deltaX = event.movementX;
            pointer.deltaY = event.movementY;
            if (event.pointerType === "touch") {
                switch (this._activePointers.length) {
                    case 1:
                        this._state = this.touches.one;
                        break;
                    case 2:
                        this._state = this.touches.two;
                        break;
                    case 3:
                        this._state = this.touches.three;
                        break;
                }
            } else {
                this._state = 0;
                if ((event.buttons & MOUSE_BUTTON.LEFT) === MOUSE_BUTTON.LEFT) {
                    this._state = this._state | this.mouseButtons.left;
                }
                if (
                    (event.buttons & MOUSE_BUTTON.MIDDLE) ===
                    MOUSE_BUTTON.MIDDLE
                ) {
                    this._state = this._state | this.mouseButtons.middle;
                }
                if (
                    (event.buttons & MOUSE_BUTTON.RIGHT) ===
                    MOUSE_BUTTON.RIGHT
                ) {
                    this._state = this._state | this.mouseButtons.right;
                }
            }
            dragging();
        };
        const onMouseMove = (event) => {
            const pointer = this._findPointerById(0);
            if (!pointer) return;
            pointer.clientX = event.clientX;
            pointer.clientY = event.clientY;
            pointer.deltaX = event.movementX;
            pointer.deltaY = event.movementY;
            this._state = 0;
            if ((event.buttons & MOUSE_BUTTON.LEFT) === MOUSE_BUTTON.LEFT) {
                this._state = this._state | this.mouseButtons.left;
            }
            if ((event.buttons & MOUSE_BUTTON.MIDDLE) === MOUSE_BUTTON.MIDDLE) {
                this._state = this._state | this.mouseButtons.middle;
            }
            if ((event.buttons & MOUSE_BUTTON.RIGHT) === MOUSE_BUTTON.RIGHT) {
                this._state = this._state | this.mouseButtons.right;
            }
            dragging();
        };
        const onPointerUp = (event) => {
            const pointerId = event.pointerId;
            const pointer = this._findPointerById(pointerId);
            pointer &&
                this._activePointers.splice(
                    this._activePointers.indexOf(pointer),
                    1
                );
            if (event.pointerType === "touch") {
                switch (this._activePointers.length) {
                    case 0:
                        this._state = ACTION.NONE;
                        break;
                    case 1:
                        this._state = this.touches.one;
                        break;
                    case 2:
                        this._state = this.touches.two;
                        break;
                    case 3:
                        this._state = this.touches.three;
                        break;
                }
            } else {
                this._state = ACTION.NONE;
            }
            endDragging();
        };
        const onMouseUp = () => {
            const pointer = this._findPointerById(0);
            pointer &&
                this._activePointers.splice(
                    this._activePointers.indexOf(pointer),
                    1
                );
            this._state = ACTION.NONE;
            endDragging();
        };
        let lastScrollTimeStamp = -1;
        const onMouseWheel = (event) => {
            if (!this._enabled || this.mouseButtons.wheel === ACTION.NONE)
                return;
            event.preventDefault();
            if (
                this.dollyToCursor ||
                this.mouseButtons.wheel === ACTION.ROTATE ||
                this.mouseButtons.wheel === ACTION.TRUCK
            ) {
                const now = performance.now();
                // only need to fire this at scroll start.
                if (lastScrollTimeStamp - now < 1000)
                    this._getClientRect(this._elementRect);
                lastScrollTimeStamp = now;
            }
            // Ref: https://github.com/cedricpinson/osgjs/blob/00e5a7e9d9206c06fdde0436e1d62ab7cb5ce853/sources/osgViewer/input/source/InputSourceMouse.js#L89-L103
            const deltaYFactor = isMac ? -1 : -3;
            const delta =
                event.deltaMode === 1
                    ? event.deltaY / deltaYFactor
                    : event.deltaY / (deltaYFactor * 10);
            const x = this.dollyToCursor
                ? ((event.clientX - this._elementRect.x) /
                      this._elementRect.width) *
                      2 -
                  1
                : 0;
            const y = this.dollyToCursor
                ? ((event.clientY - this._elementRect.y) /
                      this._elementRect.height) *
                      -2 +
                  1
                : 0;
            switch (this.mouseButtons.wheel) {
                case ACTION.ROTATE: {
                    this._rotateInternal(event.deltaX, event.deltaY);
                    this._isUserControllingRotate = true;
                    break;
                }
                case ACTION.TRUCK: {
                    this._truckInternal(event.deltaX, event.deltaY, false);
                    this._isUserControllingTruck = true;
                    break;
                }
                case ACTION.OFFSET: {
                    this._truckInternal(event.deltaX, event.deltaY, true);
                    this._isUserControllingOffset = true;
                    break;
                }
                case ACTION.DOLLY: {
                    this._dollyInternal(-delta, x, y);
                    this._isUserControllingDolly = true;
                    break;
                }
                case ACTION.ZOOM: {
                    this._zoomInternal(-delta, x, y);
                    this._isUserControllingZoom = true;
                    break;
                }
            }
            this.dispatchEvent({ type: "control" });
        };
        const onContextMenu = (event) => {
            if (!this._domElement || !this._enabled) return;
            // contextmenu event is fired right after pointerdown/mousedown.
            // remove attached handlers and active pointer, if interrupted by contextmenu.
            if (this.mouseButtons.right === CameraControls.ACTION.NONE) {
                const pointerId =
                    event instanceof PointerEvent
                        ? event.pointerId
                        : event instanceof MouseEvent
                        ? 0
                        : 0;
                const pointer = this._findPointerById(pointerId);
                pointer &&
                    this._activePointers.splice(
                        this._activePointers.indexOf(pointer),
                        1
                    );
                // eslint-disable-next-line no-undef
                this._domElement.ownerDocument.removeEventListener(
                    "pointermove",
                    onPointerMove,
                    { passive: false }
                );
                this._domElement.ownerDocument.removeEventListener(
                    "pointerup",
                    onPointerUp
                );
                this._domElement.ownerDocument.removeEventListener(
                    "mousemove",
                    onMouseMove
                );
                this._domElement.ownerDocument.removeEventListener(
                    "mouseup",
                    onMouseUp
                );
                return;
            }
            event.preventDefault();
        };
        const startDragging = (event) => {
            if (!this._enabled) return;
            extractClientCoordFromEvent(this._activePointers, _v2);
            this._getClientRect(this._elementRect);
            dragStartPosition.copy(_v2);
            lastDragPosition.copy(_v2);
            const isMultiTouch = this._activePointers.length >= 2;
            if (isMultiTouch) {
                // 2 finger pinch
                const dx = _v2.x - this._activePointers[1].clientX;
                const dy = _v2.y - this._activePointers[1].clientY;
                const distance = Math.sqrt(dx * dx + dy * dy);
                dollyStart.set(0, distance);
                // center coords of 2 finger truck
                const x =
                    (this._activePointers[0].clientX +
                        this._activePointers[1].clientX) *
                    0.5;
                const y =
                    (this._activePointers[0].clientY +
                        this._activePointers[1].clientY) *
                    0.5;
                lastDragPosition.set(x, y);
            }
            if ("pointerType" in event && event.pointerType === "touch") {
                switch (this._activePointers.length) {
                    case 1:
                        this._state = this.touches.one;
                        break;
                    case 2:
                        this._state = this.touches.two;
                        break;
                    case 3:
                        this._state = this.touches.three;
                        break;
                }
            } else {
                this._state = 0;
                if ((event.buttons & MOUSE_BUTTON.LEFT) === MOUSE_BUTTON.LEFT) {
                    this._state = this._state | this.mouseButtons.left;
                }
                if (
                    (event.buttons & MOUSE_BUTTON.MIDDLE) ===
                    MOUSE_BUTTON.MIDDLE
                ) {
                    this._state = this._state | this.mouseButtons.middle;
                }
                if (
                    (event.buttons & MOUSE_BUTTON.RIGHT) ===
                    MOUSE_BUTTON.RIGHT
                ) {
                    this._state = this._state | this.mouseButtons.right;
                }
            }
            // stop current movement on drag start
            if (
                (this._state & ACTION.ROTATE) === ACTION.ROTATE ||
                (this._state & ACTION.TOUCH_ROTATE) === ACTION.TOUCH_ROTATE ||
                (this._state & ACTION.TOUCH_DOLLY_ROTATE) ===
                    ACTION.TOUCH_DOLLY_ROTATE ||
                (this._state & ACTION.TOUCH_ZOOM_ROTATE) ===
                    ACTION.TOUCH_ZOOM_ROTATE
            ) {
                this._sphericalEnd.theta = this._spherical.theta;
                this._sphericalEnd.phi = this._spherical.phi;
                this._thetaVelocity.value = 0;
                this._phiVelocity.value = 0;
            }
            if (
                (this._state & ACTION.TRUCK) === ACTION.TRUCK ||
                (this._state & ACTION.TOUCH_TRUCK) === ACTION.TOUCH_TRUCK ||
                (this._state & ACTION.TOUCH_DOLLY_TRUCK) ===
                    ACTION.TOUCH_DOLLY_TRUCK ||
                (this._state & ACTION.TOUCH_ZOOM_TRUCK) ===
                    ACTION.TOUCH_ZOOM_TRUCK
            ) {
                this._targetEnd.copy(this._target);
                this._targetVelocity.set(0, 0, 0);
            }
            if (
                (this._state & ACTION.DOLLY) === ACTION.DOLLY ||
                (this._state & ACTION.TOUCH_DOLLY) === ACTION.TOUCH_DOLLY ||
                (this._state & ACTION.TOUCH_DOLLY_TRUCK) ===
                    ACTION.TOUCH_DOLLY_TRUCK ||
                (this._state & ACTION.TOUCH_DOLLY_OFFSET) ===
                    ACTION.TOUCH_DOLLY_OFFSET ||
                (this._state & ACTION.TOUCH_DOLLY_ROTATE) ===
                    ACTION.TOUCH_DOLLY_ROTATE
            ) {
                this._sphericalEnd.radius = this._spherical.radius;
                this._radiusVelocity.value = 0;
            }
            if (
                (this._state & ACTION.ZOOM) === ACTION.ZOOM ||
                (this._state & ACTION.TOUCH_ZOOM) === ACTION.TOUCH_ZOOM ||
                (this._state & ACTION.TOUCH_ZOOM_TRUCK) ===
                    ACTION.TOUCH_ZOOM_TRUCK ||
                (this._state & ACTION.TOUCH_ZOOM_OFFSET) ===
                    ACTION.TOUCH_ZOOM_OFFSET ||
                (this._state & ACTION.TOUCH_ZOOM_ROTATE) ===
                    ACTION.TOUCH_ZOOM_ROTATE
            ) {
                this._zoomEnd = this._zoom;
                this._zoomVelocity.value = 0;
            }
            if (
                (this._state & ACTION.OFFSET) === ACTION.OFFSET ||
                (this._state & ACTION.TOUCH_OFFSET) === ACTION.TOUCH_OFFSET ||
                (this._state & ACTION.TOUCH_DOLLY_OFFSET) ===
                    ACTION.TOUCH_DOLLY_OFFSET ||
                (this._state & ACTION.TOUCH_ZOOM_OFFSET) ===
                    ACTION.TOUCH_ZOOM_OFFSET
            ) {
                this._focalOffsetEnd.copy(this._focalOffset);
                this._focalOffsetVelocity.set(0, 0, 0);
            }
            this.dispatchEvent({ type: "controlstart" });
        };
        const dragging = () => {
            if (!this._enabled) return;
            extractClientCoordFromEvent(this._activePointers, _v2);
            // When pointer lock is enabled clientX, clientY, screenX, and screenY remain 0.
            // If pointer lock is enabled, use the Delta directory, and assume active-pointer is not multiple.
            const isPointerLockActive =
                this._domElement &&
                document.pointerLockElement === this._domElement;
            const deltaX = isPointerLockActive
                ? -this._activePointers[0].deltaX
                : lastDragPosition.x - _v2.x;
            const deltaY = isPointerLockActive
                ? -this._activePointers[0].deltaY
                : lastDragPosition.y - _v2.y;
            lastDragPosition.copy(_v2);
            if (
                (this._state & ACTION.ROTATE) === ACTION.ROTATE ||
                (this._state & ACTION.TOUCH_ROTATE) === ACTION.TOUCH_ROTATE ||
                (this._state & ACTION.TOUCH_DOLLY_ROTATE) ===
                    ACTION.TOUCH_DOLLY_ROTATE ||
                (this._state & ACTION.TOUCH_ZOOM_ROTATE) ===
                    ACTION.TOUCH_ZOOM_ROTATE
            ) {
                this._rotateInternal(deltaX, deltaY);
                this._isUserControllingRotate = true;
            }
            if (
                (this._state & ACTION.DOLLY) === ACTION.DOLLY ||
                (this._state & ACTION.ZOOM) === ACTION.ZOOM
            ) {
                const dollyX = this.dollyToCursor
                    ? ((dragStartPosition.x - this._elementRect.x) /
                          this._elementRect.width) *
                          2 -
                      1
                    : 0;
                const dollyY = this.dollyToCursor
                    ? ((dragStartPosition.y - this._elementRect.y) /
                          this._elementRect.height) *
                          -2 +
                      1
                    : 0;
                const dollyDirection = this.dollyDragInverted ? -1 : 1;
                if ((this._state & ACTION.DOLLY) === ACTION.DOLLY) {
                    this._dollyInternal(
                        dollyDirection * deltaY * TOUCH_DOLLY_FACTOR,
                        dollyX,
                        dollyY
                    );
                    this._isUserControllingDolly = true;
                } else {
                    this._zoomInternal(
                        dollyDirection * deltaY * TOUCH_DOLLY_FACTOR,
                        dollyX,
                        dollyY
                    );
                    this._isUserControllingZoom = true;
                }
            }
            if (
                (this._state & ACTION.TOUCH_DOLLY) === ACTION.TOUCH_DOLLY ||
                (this._state & ACTION.TOUCH_ZOOM) === ACTION.TOUCH_ZOOM ||
                (this._state & ACTION.TOUCH_DOLLY_TRUCK) ===
                    ACTION.TOUCH_DOLLY_TRUCK ||
                (this._state & ACTION.TOUCH_ZOOM_TRUCK) ===
                    ACTION.TOUCH_ZOOM_TRUCK ||
                (this._state & ACTION.TOUCH_DOLLY_OFFSET) ===
                    ACTION.TOUCH_DOLLY_OFFSET ||
                (this._state & ACTION.TOUCH_ZOOM_OFFSET) ===
                    ACTION.TOUCH_ZOOM_OFFSET ||
                (this._state & ACTION.TOUCH_DOLLY_ROTATE) ===
                    ACTION.TOUCH_DOLLY_ROTATE ||
                (this._state & ACTION.TOUCH_ZOOM_ROTATE) ===
                    ACTION.TOUCH_ZOOM_ROTATE
            ) {
                const dx = _v2.x - this._activePointers[1].clientX;
                const dy = _v2.y - this._activePointers[1].clientY;
                const distance = Math.sqrt(dx * dx + dy * dy);
                const dollyDelta = dollyStart.y - distance;
                dollyStart.set(0, distance);
                const dollyX = this.dollyToCursor
                    ? ((lastDragPosition.x - this._elementRect.x) /
                          this._elementRect.width) *
                          2 -
                      1
                    : 0;
                const dollyY = this.dollyToCursor
                    ? ((lastDragPosition.y - this._elementRect.y) /
                          this._elementRect.height) *
                          -2 +
                      1
                    : 0;
                if (
                    (this._state & ACTION.TOUCH_DOLLY) === ACTION.TOUCH_DOLLY ||
                    (this._state & ACTION.TOUCH_DOLLY_ROTATE) ===
                        ACTION.TOUCH_DOLLY_ROTATE ||
                    (this._state & ACTION.TOUCH_DOLLY_TRUCK) ===
                        ACTION.TOUCH_DOLLY_TRUCK ||
                    (this._state & ACTION.TOUCH_DOLLY_OFFSET) ===
                        ACTION.TOUCH_DOLLY_OFFSET
                ) {
                    this._dollyInternal(
                        dollyDelta * TOUCH_DOLLY_FACTOR,
                        dollyX,
                        dollyY
                    );
                    this._isUserControllingDolly = true;
                } else {
                    this._zoomInternal(
                        dollyDelta * TOUCH_DOLLY_FACTOR,
                        dollyX,
                        dollyY
                    );
                    this._isUserControllingZoom = true;
                }
            }
            if (
                (this._state & ACTION.TRUCK) === ACTION.TRUCK ||
                (this._state & ACTION.TOUCH_TRUCK) === ACTION.TOUCH_TRUCK ||
                (this._state & ACTION.TOUCH_DOLLY_TRUCK) ===
                    ACTION.TOUCH_DOLLY_TRUCK ||
                (this._state & ACTION.TOUCH_ZOOM_TRUCK) ===
                    ACTION.TOUCH_ZOOM_TRUCK
            ) {
                this._truckInternal(deltaX, deltaY, false);
                this._isUserControllingTruck = true;
            }
            if (
                (this._state & ACTION.OFFSET) === ACTION.OFFSET ||
                (this._state & ACTION.TOUCH_OFFSET) === ACTION.TOUCH_OFFSET ||
                (this._state & ACTION.TOUCH_DOLLY_OFFSET) ===
                    ACTION.TOUCH_DOLLY_OFFSET ||
                (this._state & ACTION.TOUCH_ZOOM_OFFSET) ===
                    ACTION.TOUCH_ZOOM_OFFSET
            ) {
                this._truckInternal(deltaX, deltaY, true);
                this._isUserControllingOffset = true;
            }
            this.dispatchEvent({ type: "control" });
        };
        const endDragging = () => {
            extractClientCoordFromEvent(this._activePointers, _v2);
            lastDragPosition.copy(_v2);
            if (this._activePointers.length === 0 && this._domElement) {
                // eslint-disable-next-line no-undef
                this._domElement.ownerDocument.removeEventListener(
                    "pointermove",
                    onPointerMove,
                    { passive: false }
                );
                this._domElement.ownerDocument.removeEventListener(
                    "mousemove",
                    onMouseMove
                );
                this._domElement.ownerDocument.removeEventListener(
                    "pointerup",
                    onPointerUp
                );
                this._domElement.ownerDocument.removeEventListener(
                    "mouseup",
                    onMouseUp
                );
                this.dispatchEvent({ type: "controlend" });
            }
        };
        this._addAllEventListeners = (domElement) => {
            this._domElement = domElement;
            this._domElement.style.touchAction = "none";
            this._domElement.style.userSelect = "none";
            this._domElement.style.webkitUserSelect = "none";
            this._domElement.addEventListener("pointerdown", onPointerDown);
            isPointerEventsNotSupported &&
                this._domElement.addEventListener("mousedown", onMouseDown);
            this._domElement.addEventListener("pointercancel", onPointerUp);
            this._domElement.addEventListener("wheel", onMouseWheel, {
                passive: false,
            });
            this._domElement.addEventListener("contextmenu", onContextMenu);
        };
        this._removeAllEventListeners = () => {
            if (!this._domElement) return;
            this._domElement.style.touchAction = "";
            this._domElement.style.userSelect = "";
            this._domElement.style.webkitUserSelect = "";
            this._domElement.removeEventListener("pointerdown", onPointerDown);
            this._domElement.removeEventListener("mousedown", onMouseDown);
            this._domElement.removeEventListener("pointercancel", onPointerUp);
            // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener#matching_event_listeners_for_removal
            // > it's probably wise to use the same values used for the call to `addEventListener()` when calling `removeEventListener()`
            // see https://github.com/microsoft/TypeScript/issues/32912#issuecomment-522142969
            // eslint-disable-next-line no-undef
            this._domElement.removeEventListener("wheel", onMouseWheel, {
                passive: false,
            });
            this._domElement.removeEventListener("contextmenu", onContextMenu);
            // eslint-disable-next-line no-undef
            this._domElement.ownerDocument.removeEventListener(
                "pointermove",
                onPointerMove,
                { passive: false }
            );
            this._domElement.ownerDocument.removeEventListener(
                "mousemove",
                onMouseMove
            );
            this._domElement.ownerDocument.removeEventListener(
                "pointerup",
                onPointerUp
            );
            this._domElement.ownerDocument.removeEventListener(
                "mouseup",
                onMouseUp
            );
        };
        this.cancel = () => {
            if (this._state === ACTION.NONE) return;
            this._state = ACTION.NONE;
            this._activePointers.length = 0;
            endDragging();
        };
        if (domElement) this.connect(domElement);
        this.update(0);
    }
    /**
     * The camera to be controlled
     * @category Properties
     */
    get camera() {
        return this._camera;
    }
    set camera(camera) {
        this._camera = camera;
        this.updateCameraUp();
        this._camera.updateProjectionMatrix();
        this._updateNearPlaneCorners();
        this._needsUpdate = true;
    }
    /**
     * Whether or not the controls are enabled.
     * `false` to disable user dragging/touch-move, but all methods works.
     * @category Properties
     */
    get enabled() {
        return this._enabled;
    }
    set enabled(enabled) {
        this._enabled = enabled;
        if (!this._domElement) return;
        if (enabled) {
            this._domElement.style.touchAction = "none";
            this._domElement.style.userSelect = "none";
            this._domElement.style.webkitUserSelect = "none";
        } else {
            this.cancel();
            this._domElement.style.touchAction = "";
            this._domElement.style.userSelect = "";
            this._domElement.style.webkitUserSelect = "";
        }
    }
    /**
     * Returns `true` if the controls are active updating.
     * readonly value.
     * @category Properties
     */
    get active() {
        return !this._hasRested;
    }
    /**
     * Getter for the current `ACTION`.
     * readonly value.
     * @category Properties
     */
    get currentAction() {
        return this._state;
    }
    /**
     * get/set Current distance.
     * @category Properties
     */
    get distance() {
        return this._spherical.radius;
    }
    set distance(distance) {
        if (
            this._spherical.radius === distance &&
            this._sphericalEnd.radius === distance
        )
            return;
        this._spherical.radius = distance;
        this._sphericalEnd.radius = distance;
        this._needsUpdate = true;
    }
    // horizontal angle
    /**
     * get/set the azimuth angle (horizontal) in radians.
     * Every 360 degrees turn is added to `.azimuthAngle` value, which is accumulative.
     * @category Properties
     */
    get azimuthAngle() {
        return this._spherical.theta;
    }
    set azimuthAngle(azimuthAngle) {
        if (
            this._spherical.theta === azimuthAngle &&
            this._sphericalEnd.theta === azimuthAngle
        )
            return;
        this._spherical.theta = azimuthAngle;
        this._sphericalEnd.theta = azimuthAngle;
        this._needsUpdate = true;
    }
    // vertical angle
    /**
     * get/set the polar angle (vertical) in radians.
     * @category Properties
     */
    get polarAngle() {
        return this._spherical.phi;
    }
    set polarAngle(polarAngle) {
        if (
            this._spherical.phi === polarAngle &&
            this._sphericalEnd.phi === polarAngle
        )
            return;
        this._spherical.phi = polarAngle;
        this._sphericalEnd.phi = polarAngle;
        this._needsUpdate = true;
    }
    /**
     * Whether camera position should be enclosed in the boundary or not.
     * @category Properties
     */
    get boundaryEnclosesCamera() {
        return this._boundaryEnclosesCamera;
    }
    set boundaryEnclosesCamera(boundaryEnclosesCamera) {
        this._boundaryEnclosesCamera = boundaryEnclosesCamera;
        this._needsUpdate = true;
    }
    /**
     * Adds the specified event listener.
     * Applicable event types (which is `K`) are:
     * | Event name          | Timing |
     * | ------------------- | ------ |
     * | `'controlstart'`    | When the user starts to control the camera via mouse / touches. ¹ |
     * | `'control'`         | When the user controls the camera (dragging). |
     * | `'controlend'`      | When the user ends to control the camera. ¹ |
     * | `'transitionstart'` | When any kind of transition starts, either user control or using a method with `enableTransition = true` |
     * | `'update'`          | When the camera position is updated. |
     * | `'wake'`            | When the camera starts moving. |
     * | `'rest'`            | When the camera movement is below `.restThreshold` ². |
     * | `'sleep'`           | When the camera end moving. |
     *
     * 1. `mouseButtons.wheel` (Mouse wheel control) does not emit `'controlstart'` and `'controlend'`. `mouseButtons.wheel` uses scroll-event internally, and scroll-event happens intermittently. That means "start" and "end" cannot be detected.
     * 2. Due to damping, `sleep` will usually fire a few seconds after the camera _appears_ to have stopped moving. If you want to do something (e.g. enable UI, perform another transition) at the point when the camera has stopped, you probably want the `rest` event. This can be fine tuned using the `.restThreshold` parameter. See the [Rest and Sleep Example](https://yomotsu.github.io/camera-controls/examples/rest-and-sleep.html).
     *
     * e.g.
     * ```
     * cameraControl.addEventListener( 'controlstart', myCallbackFunction );
     * ```
     * @param type event name
     * @param listener handler function
     * @category Methods
     */
    addEventListener(type, listener) {
        super.addEventListener(type, listener);
    }
    /**
     * Removes the specified event listener
     * e.g.
     * ```
     * cameraControl.addEventListener( 'controlstart', myCallbackFunction );
     * ```
     * @param type event name
     * @param listener handler function
     * @category Methods
     */
    removeEventListener(type, listener) {
        super.removeEventListener(type, listener);
    }
    /**
     * Rotate azimuthal angle(horizontal) and polar angle(vertical).
     * Every value is added to the current value.
     * @param azimuthAngle Azimuth rotate angle. In radian.
     * @param polarAngle Polar rotate angle. In radian.
     * @param enableTransition Whether to move smoothly or immediately
     * @category Methods
     */
    rotate(azimuthAngle, polarAngle, enableTransition = false) {
        return this.rotateTo(
            this._sphericalEnd.theta + azimuthAngle,
            this._sphericalEnd.phi + polarAngle,
            enableTransition
        );
    }
    /**
     * Rotate azimuthal angle(horizontal) to the given angle and keep the same polar angle(vertical) target.
     *
     * e.g.
     * ```
     * cameraControls.rotateAzimuthTo( 30 * THREE.MathUtils.DEG2RAD, true );
     * ```
     * @param azimuthAngle Azimuth rotate angle. In radian.
     * @param enableTransition Whether to move smoothly or immediately
     * @category Methods
     */
    rotateAzimuthTo(azimuthAngle, enableTransition = false) {
        return this.rotateTo(
            azimuthAngle,
            this._sphericalEnd.phi,
            enableTransition
        );
    }
    /**
     * Rotate polar angle(vertical) to the given angle and keep the same azimuthal angle(horizontal) target.
     *
     * e.g.
     * ```
     * cameraControls.rotatePolarTo( 30 * THREE.MathUtils.DEG2RAD, true );
     * ```
     * @param polarAngle Polar rotate angle. In radian.
     * @param enableTransition Whether to move smoothly or immediately
     * @category Methods
     */
    rotatePolarTo(polarAngle, enableTransition = false) {
        return this.rotateTo(
            this._sphericalEnd.theta,
            polarAngle,
            enableTransition
        );
    }
    /**
     * Rotate azimuthal angle(horizontal) and polar angle(vertical) to the given angle.
     * Camera view will rotate over the orbit pivot absolutely:
     *
     * azimuthAngle
     * ```
     *       0º
     *         \
     * 90º -----+----- -90º
     *           \
     *           180º
     * ```
     * | direction | angle                  |
     * | --------- | ---------------------- |
     * | front     | 0º                     |
     * | left      | 90º (`Math.PI / 2`)    |
     * | right     | -90º (`- Math.PI / 2`) |
     * | back      | 180º (`Math.PI`)       |
     *
     * polarAngle
     * ```
     *     180º
     *      |
     *      90º
     *      |
     *      0º
     * ```
     * | direction            | angle                  |
     * | -------------------- | ---------------------- |
     * | top/sky              | 180º (`Math.PI`)       |
     * | horizontal from view | 90º (`Math.PI / 2`)    |
     * | bottom/floor         | 0º                     |
     *
     * @param azimuthAngle Azimuth rotate angle to. In radian.
     * @param polarAngle Polar rotate angle to. In radian.
     * @param enableTransition  Whether to move smoothly or immediately
     * @category Methods
     */
    rotateTo(azimuthAngle, polarAngle, enableTransition = false) {
        this._isUserControllingRotate = false;
        const theta = clamp(
            azimuthAngle,
            this.minAzimuthAngle,
            this.maxAzimuthAngle
        );
        const phi = clamp(polarAngle, this.minPolarAngle, this.maxPolarAngle);
        this._sphericalEnd.theta = theta;
        this._sphericalEnd.phi = phi;
        this._sphericalEnd.makeSafe();
        this._needsUpdate = true;
        if (!enableTransition) {
            this._spherical.theta = this._sphericalEnd.theta;
            this._spherical.phi = this._sphericalEnd.phi;
        }
        const resolveImmediately =
            !enableTransition ||
            (approxEquals(
                this._spherical.theta,
                this._sphericalEnd.theta,
                this.restThreshold
            ) &&
                approxEquals(
                    this._spherical.phi,
                    this._sphericalEnd.phi,
                    this.restThreshold
                ));
        return this._createOnRestPromise(resolveImmediately);
    }
    /**
     * Dolly in/out camera position.
     * @param distance Distance of dollyIn. Negative number for dollyOut.
     * @param enableTransition Whether to move smoothly or immediately.
     * @category Methods
     */
    dolly(distance, enableTransition = false) {
        return this.dollyTo(
            this._sphericalEnd.radius - distance,
            enableTransition
        );
    }
    /**
     * Dolly in/out camera position to given distance.
     * @param distance Distance of dolly.
     * @param enableTransition Whether to move smoothly or immediately.
     * @category Methods
     */
    dollyTo(distance, enableTransition = false) {
        this._isUserControllingDolly = false;
        const lastRadius = this._sphericalEnd.radius;
        const newRadius = clamp(distance, this.minDistance, this.maxDistance);
        const hasCollider = this.colliderMeshes.length >= 1;
        if (hasCollider) {
            const maxDistanceByCollisionTest = this._collisionTest();
            const isCollided = approxEquals(
                maxDistanceByCollisionTest,
                this._spherical.radius
            );
            const isDollyIn = lastRadius > newRadius;
            if (!isDollyIn && isCollided) return Promise.resolve();
            this._sphericalEnd.radius = Math.min(
                newRadius,
                maxDistanceByCollisionTest
            );
        } else {
            this._sphericalEnd.radius = newRadius;
        }
        this._needsUpdate = true;
        if (!enableTransition) {
            this._spherical.radius = this._sphericalEnd.radius;
        }
        const resolveImmediately =
            !enableTransition ||
            approxEquals(
                this._spherical.radius,
                this._sphericalEnd.radius,
                this.restThreshold
            );
        return this._createOnRestPromise(resolveImmediately);
    }
    /**
     * Zoom in/out camera. The value is added to camera zoom.
     * Limits set with `.minZoom` and `.maxZoom`
     * @param zoomStep zoom scale
     * @param enableTransition Whether to move smoothly or immediately
     * @category Methods
     */
    zoom(zoomStep, enableTransition = false) {
        return this.zoomTo(this._zoomEnd + zoomStep, enableTransition);
    }
    /**
     * Zoom in/out camera to given scale. The value overwrites camera zoom.
     * Limits set with .minZoom and .maxZoom
     * @param zoom
     * @param enableTransition
     * @category Methods
     */
    zoomTo(zoom, enableTransition = false) {
        this._isUserControllingZoom = false;
        this._zoomEnd = clamp(zoom, this.minZoom, this.maxZoom);
        this._needsUpdate = true;
        if (!enableTransition) {
            this._zoom = this._zoomEnd;
        }
        const resolveImmediately =
            !enableTransition ||
            approxEquals(this._zoom, this._zoomEnd, this.restThreshold);
        return this._createOnRestPromise(resolveImmediately);
    }
    /**
     * @deprecated `pan()` has been renamed to `truck()`
     * @category Methods
     */
    pan(x, y, enableTransition = false) {
        console.warn("`pan` has been renamed to `truck`");
        return this.truck(x, y, enableTransition);
    }
    /**
     * Truck and pedestal camera using current azimuthal angle
     * @param x Horizontal translate amount
     * @param y Vertical translate amount
     * @param enableTransition Whether to move smoothly or immediately
     * @category Methods
     */
    truck(x, y, enableTransition = false) {
        this._camera.updateMatrix();
        _xColumn.setFromMatrixColumn(this._camera.matrix, 0);
        _yColumn.setFromMatrixColumn(this._camera.matrix, 1);
        _xColumn.multiplyScalar(x);
        _yColumn.multiplyScalar(-y);
        const offset = _v3A$1.copy(_xColumn).add(_yColumn);
        const to = _v3B$1.copy(this._targetEnd).add(offset);
        return this.moveTo(to.x, to.y, to.z, enableTransition);
    }
    /**
     * Move forward / backward.
     * @param distance Amount to move forward / backward. Negative value to move backward
     * @param enableTransition Whether to move smoothly or immediately
     * @category Methods
     */
    forward(distance, enableTransition = false) {
        _v3A$1.setFromMatrixColumn(this._camera.matrix, 0);
        _v3A$1.crossVectors(this._camera.up, _v3A$1);
        _v3A$1.multiplyScalar(distance);
        const to = _v3B$1.copy(this._targetEnd).add(_v3A$1);
        return this.moveTo(to.x, to.y, to.z, enableTransition);
    }
    /**
     * Move up / down.
     * @param height Amount to move up / down. Negative value to move down
     * @param enableTransition Whether to move smoothly or immediately
     * @category Methods
     */
    elevate(height, enableTransition = false) {
        _v3A$1.copy(this._camera.up).multiplyScalar(height);
        return this.moveTo(
            this._targetEnd.x + _v3A$1.x,
            this._targetEnd.y + _v3A$1.y,
            this._targetEnd.z + _v3A$1.z,
            enableTransition
        );
    }
    /**
     * Move target position to given point.
     * @param x x coord to move center position
     * @param y y coord to move center position
     * @param z z coord to move center position
     * @param enableTransition Whether to move smoothly or immediately
     * @category Methods
     */
    moveTo(x, y, z, enableTransition = false) {
        this._isUserControllingTruck = false;
        const offset = _v3A$1.set(x, y, z).sub(this._targetEnd);
        this._encloseToBoundary(this._targetEnd, offset, this.boundaryFriction);
        this._needsUpdate = true;
        if (!enableTransition) {
            this._target.copy(this._targetEnd);
        }
        const resolveImmediately =
            !enableTransition ||
            (approxEquals(
                this._target.x,
                this._targetEnd.x,
                this.restThreshold
            ) &&
                approxEquals(
                    this._target.y,
                    this._targetEnd.y,
                    this.restThreshold
                ) &&
                approxEquals(
                    this._target.z,
                    this._targetEnd.z,
                    this.restThreshold
                ));
        return this._createOnRestPromise(resolveImmediately);
    }
    /**
     * Look in the given point direction.
     * @param x point x.
     * @param y point y.
     * @param z point z.
     * @param enableTransition Whether to move smoothly or immediately.
     * @returns Transition end promise
     * @category Methods
     */
    lookInDirectionOf(x, y, z, enableTransition = false) {
        const point = _v3A$1.set(x, y, z);
        const direction = point.sub(this._targetEnd).normalize();
        const position = direction.multiplyScalar(-this._sphericalEnd.radius);
        return this.setPosition(
            position.x,
            position.y,
            position.z,
            enableTransition
        );
    }
    /**
     * Fit the viewport to the box or the bounding box of the object, using the nearest axis. paddings are in unit.
     * set `cover: true` to fill enter screen.
     * e.g.
     * ```
     * cameraControls.fitToBox( myMesh );
     * ```
     * @param box3OrObject Axis aligned bounding box to fit the view.
     * @param enableTransition Whether to move smoothly or immediately.
     * @param options | `<object>` { cover: boolean, paddingTop: number, paddingLeft: number, paddingBottom: number, paddingRight: number }
     * @returns Transition end promise
     * @category Methods
     */
    fitToBox(
        box3OrObject,
        enableTransition,
        {
            cover = false,
            paddingLeft = 0,
            paddingRight = 0,
            paddingBottom = 0,
            paddingTop = 0,
        } = {}
    ) {
        const promises = [];
        const aabb = box3OrObject.isBox3
            ? _box3A.copy(box3OrObject)
            : _box3A.setFromObject(box3OrObject);
        if (aabb.isEmpty()) {
            console.warn(
                "camera-controls: fitTo() cannot be used with an empty box. Aborting"
            );
            Promise.resolve();
        }
        // round to closest axis ( forward | backward | right | left | top | bottom )
        const theta = roundToStep(this._sphericalEnd.theta, PI_HALF);
        const phi = roundToStep(this._sphericalEnd.phi, PI_HALF);
        promises.push(this.rotateTo(theta, phi, enableTransition));
        const normal = _v3A$1.setFromSpherical(this._sphericalEnd).normalize();
        const rotation = _quaternionA.setFromUnitVectors(normal, _AXIS_Z);
        const viewFromPolar = approxEquals(Math.abs(normal.y), 1);
        if (viewFromPolar) {
            rotation.multiply(_quaternionB.setFromAxisAngle(_AXIS_Y, theta));
        }
        rotation.multiply(this._yAxisUpSpaceInverse);
        // make oriented bounding box
        const bb = _box3B.makeEmpty();
        // left bottom back corner
        _v3B$1.copy(aabb.min).applyQuaternion(rotation);
        bb.expandByPoint(_v3B$1);
        // right bottom back corner
        _v3B$1.copy(aabb.min).setX(aabb.max.x).applyQuaternion(rotation);
        bb.expandByPoint(_v3B$1);
        // left top back corner
        _v3B$1.copy(aabb.min).setY(aabb.max.y).applyQuaternion(rotation);
        bb.expandByPoint(_v3B$1);
        // right top back corner
        _v3B$1.copy(aabb.max).setZ(aabb.min.z).applyQuaternion(rotation);
        bb.expandByPoint(_v3B$1);
        // left bottom front corner
        _v3B$1.copy(aabb.min).setZ(aabb.max.z).applyQuaternion(rotation);
        bb.expandByPoint(_v3B$1);
        // right bottom front corner
        _v3B$1.copy(aabb.max).setY(aabb.min.y).applyQuaternion(rotation);
        bb.expandByPoint(_v3B$1);
        // left top front corner
        _v3B$1.copy(aabb.max).setX(aabb.min.x).applyQuaternion(rotation);
        bb.expandByPoint(_v3B$1);
        // right top front corner
        _v3B$1.copy(aabb.max).applyQuaternion(rotation);
        bb.expandByPoint(_v3B$1);
        // add padding
        bb.min.x -= paddingLeft;
        bb.min.y -= paddingBottom;
        bb.max.x += paddingRight;
        bb.max.y += paddingTop;
        rotation.setFromUnitVectors(_AXIS_Z, normal);
        if (viewFromPolar) {
            rotation.premultiply(_quaternionB.invert());
        }
        rotation.premultiply(this._yAxisUpSpace);
        const bbSize = bb.getSize(_v3A$1);
        const center = bb.getCenter(_v3B$1).applyQuaternion(rotation);
        if (isPerspectiveCamera(this._camera)) {
            const distance = this.getDistanceToFitBox(
                bbSize.x,
                bbSize.y,
                bbSize.z,
                cover
            );
            promises.push(
                this.moveTo(center.x, center.y, center.z, enableTransition)
            );
            promises.push(this.dollyTo(distance, enableTransition));
            promises.push(this.setFocalOffset(0, 0, 0, enableTransition));
        } else if (isOrthographicCamera(this._camera)) {
            const camera = this._camera;
            const width = camera.right - camera.left;
            const height = camera.top - camera.bottom;
            const zoom = cover
                ? Math.max(width / bbSize.x, height / bbSize.y)
                : Math.min(width / bbSize.x, height / bbSize.y);
            promises.push(
                this.moveTo(center.x, center.y, center.z, enableTransition)
            );
            promises.push(this.zoomTo(zoom, enableTransition));
            promises.push(this.setFocalOffset(0, 0, 0, enableTransition));
        }
        return Promise.all(promises);
    }
    /**
     * Fit the viewport to the sphere or the bounding sphere of the object.
     * @param sphereOrMesh
     * @param enableTransition
     * @category Methods
     */
    fitToSphere(sphereOrMesh, enableTransition) {
        const promises = [];
        const isSphere = sphereOrMesh instanceof THREE.Sphere;
        const boundingSphere = isSphere
            ? _sphere.copy(sphereOrMesh)
            : CameraControls.createBoundingSphere(sphereOrMesh, _sphere);
        promises.push(
            this.moveTo(
                boundingSphere.center.x,
                boundingSphere.center.y,
                boundingSphere.center.z,
                enableTransition
            )
        );
        if (isPerspectiveCamera(this._camera)) {
            const distanceToFit = this.getDistanceToFitSphere(
                boundingSphere.radius
            );
            promises.push(this.dollyTo(distanceToFit, enableTransition));
        } else if (isOrthographicCamera(this._camera)) {
            const width = this._camera.right - this._camera.left;
            const height = this._camera.top - this._camera.bottom;
            const diameter = 2 * boundingSphere.radius;
            const zoom = Math.min(width / diameter, height / diameter);
            promises.push(this.zoomTo(zoom, enableTransition));
        }
        promises.push(this.setFocalOffset(0, 0, 0, enableTransition));
        return Promise.all(promises);
    }
    /**
     * Look at the `target` from the `position`.
     * @param positionX
     * @param positionY
     * @param positionZ
     * @param targetX
     * @param targetY
     * @param targetZ
     * @param enableTransition
     * @category Methods
     */
    setLookAt(
        positionX,
        positionY,
        positionZ,
        targetX,
        targetY,
        targetZ,
        enableTransition = false
    ) {
        this._isUserControllingRotate = false;
        this._isUserControllingDolly = false;
        this._isUserControllingTruck = false;
        const target = _v3B$1.set(targetX, targetY, targetZ);
        const position = _v3A$1.set(positionX, positionY, positionZ);
        this._targetEnd.copy(target);
        this._sphericalEnd.setFromVector3(
            position.sub(target).applyQuaternion(this._yAxisUpSpace)
        );
        this.normalizeRotations();
        this._needsUpdate = true;
        if (!enableTransition) {
            this._target.copy(this._targetEnd);
            this._spherical.copy(this._sphericalEnd);
        }
        const resolveImmediately =
            !enableTransition ||
            (approxEquals(
                this._target.x,
                this._targetEnd.x,
                this.restThreshold
            ) &&
                approxEquals(
                    this._target.y,
                    this._targetEnd.y,
                    this.restThreshold
                ) &&
                approxEquals(
                    this._target.z,
                    this._targetEnd.z,
                    this.restThreshold
                ) &&
                approxEquals(
                    this._spherical.theta,
                    this._sphericalEnd.theta,
                    this.restThreshold
                ) &&
                approxEquals(
                    this._spherical.phi,
                    this._sphericalEnd.phi,
                    this.restThreshold
                ) &&
                approxEquals(
                    this._spherical.radius,
                    this._sphericalEnd.radius,
                    this.restThreshold
                ));
        return this._createOnRestPromise(resolveImmediately);
    }
    /**
     * Similar to setLookAt, but it interpolates between two states.
     * @param positionAX
     * @param positionAY
     * @param positionAZ
     * @param targetAX
     * @param targetAY
     * @param targetAZ
     * @param positionBX
     * @param positionBY
     * @param positionBZ
     * @param targetBX
     * @param targetBY
     * @param targetBZ
     * @param t
     * @param enableTransition
     * @category Methods
     */
    lerpLookAt(
        positionAX,
        positionAY,
        positionAZ,
        targetAX,
        targetAY,
        targetAZ,
        positionBX,
        positionBY,
        positionBZ,
        targetBX,
        targetBY,
        targetBZ,
        t,
        enableTransition = false
    ) {
        this._isUserControllingRotate = false;
        this._isUserControllingDolly = false;
        this._isUserControllingTruck = false;
        const targetA = _v3A$1.set(targetAX, targetAY, targetAZ);
        const positionA = _v3B$1.set(positionAX, positionAY, positionAZ);
        _sphericalA.setFromVector3(
            positionA.sub(targetA).applyQuaternion(this._yAxisUpSpace)
        );
        const targetB = _v3C$1.set(targetBX, targetBY, targetBZ);
        const positionB = _v3B$1.set(positionBX, positionBY, positionBZ);
        _sphericalB.setFromVector3(
            positionB.sub(targetB).applyQuaternion(this._yAxisUpSpace)
        );
        this._targetEnd.copy(targetA.lerp(targetB, t)); // tricky
        const deltaTheta = _sphericalB.theta - _sphericalA.theta;
        const deltaPhi = _sphericalB.phi - _sphericalA.phi;
        const deltaRadius = _sphericalB.radius - _sphericalA.radius;
        this._sphericalEnd.set(
            _sphericalA.radius + deltaRadius * t,
            _sphericalA.phi + deltaPhi * t,
            _sphericalA.theta + deltaTheta * t
        );
        this.normalizeRotations();
        this._needsUpdate = true;
        if (!enableTransition) {
            this._target.copy(this._targetEnd);
            this._spherical.copy(this._sphericalEnd);
        }
        const resolveImmediately =
            !enableTransition ||
            (approxEquals(
                this._target.x,
                this._targetEnd.x,
                this.restThreshold
            ) &&
                approxEquals(
                    this._target.y,
                    this._targetEnd.y,
                    this.restThreshold
                ) &&
                approxEquals(
                    this._target.z,
                    this._targetEnd.z,
                    this.restThreshold
                ) &&
                approxEquals(
                    this._spherical.theta,
                    this._sphericalEnd.theta,
                    this.restThreshold
                ) &&
                approxEquals(
                    this._spherical.phi,
                    this._sphericalEnd.phi,
                    this.restThreshold
                ) &&
                approxEquals(
                    this._spherical.radius,
                    this._sphericalEnd.radius,
                    this.restThreshold
                ));
        return this._createOnRestPromise(resolveImmediately);
    }
    /**
     * Set angle and distance by given position.
     * An alias of `setLookAt()`, without target change. Thus keep gazing at the current target
     * @param positionX
     * @param positionY
     * @param positionZ
     * @param enableTransition
     * @category Methods
     */
    setPosition(positionX, positionY, positionZ, enableTransition = false) {
        return this.setLookAt(
            positionX,
            positionY,
            positionZ,
            this._targetEnd.x,
            this._targetEnd.y,
            this._targetEnd.z,
            enableTransition
        );
    }
    /**
     * Set the target position where gaze at.
     * An alias of `setLookAt()`, without position change. Thus keep the same position.
     * @param targetX
     * @param targetY
     * @param targetZ
     * @param enableTransition
     * @category Methods
     */
    setTarget(targetX, targetY, targetZ, enableTransition = false) {
        const pos = this.getPosition(_v3A$1);
        const promise = this.setLookAt(
            pos.x,
            pos.y,
            pos.z,
            targetX,
            targetY,
            targetZ,
            enableTransition
        );
        // see https://github.com/yomotsu/camera-controls/issues/335
        this._sphericalEnd.phi = clamp(
            this.polarAngle,
            this.minPolarAngle,
            this.maxPolarAngle
        );
        return promise;
    }
    /**
     * Set focal offset using the screen parallel coordinates. z doesn't affect in Orthographic as with Dolly.
     * @param x
     * @param y
     * @param z
     * @param enableTransition
     * @category Methods
     */
    setFocalOffset(x, y, z, enableTransition = false) {
        this._isUserControllingOffset = false;
        this._focalOffsetEnd.set(x, y, z);
        this._needsUpdate = true;
        if (!enableTransition) this._focalOffset.copy(this._focalOffsetEnd);
        const resolveImmediately =
            !enableTransition ||
            (approxEquals(
                this._focalOffset.x,
                this._focalOffsetEnd.x,
                this.restThreshold
            ) &&
                approxEquals(
                    this._focalOffset.y,
                    this._focalOffsetEnd.y,
                    this.restThreshold
                ) &&
                approxEquals(
                    this._focalOffset.z,
                    this._focalOffsetEnd.z,
                    this.restThreshold
                ));
        return this._createOnRestPromise(resolveImmediately);
    }
    /**
     * Set orbit point without moving the camera.
     * SHOULD NOT RUN DURING ANIMATIONS. `setOrbitPoint()` will immediately fix the positions.
     * @param targetX
     * @param targetY
     * @param targetZ
     * @category Methods
     */
    setOrbitPoint(targetX, targetY, targetZ) {
        this._camera.updateMatrixWorld();
        _xColumn.setFromMatrixColumn(this._camera.matrixWorldInverse, 0);
        _yColumn.setFromMatrixColumn(this._camera.matrixWorldInverse, 1);
        _zColumn.setFromMatrixColumn(this._camera.matrixWorldInverse, 2);
        const position = _v3A$1.set(targetX, targetY, targetZ);
        const distance = position.distanceTo(this._camera.position);
        const cameraToPoint = position.sub(this._camera.position);
        _xColumn.multiplyScalar(cameraToPoint.x);
        _yColumn.multiplyScalar(cameraToPoint.y);
        _zColumn.multiplyScalar(cameraToPoint.z);
        _v3A$1.copy(_xColumn).add(_yColumn).add(_zColumn);
        _v3A$1.z = _v3A$1.z + distance;
        this.dollyTo(distance, false);
        this.setFocalOffset(-_v3A$1.x, _v3A$1.y, -_v3A$1.z, false);
        this.moveTo(targetX, targetY, targetZ, false);
    }
    /**
     * Set the boundary box that encloses the target of the camera. box3 is in THREE.Box3
     * @param box3
     * @category Methods
     */
    setBoundary(box3) {
        if (!box3) {
            this._boundary.min.set(-Infinity, -Infinity, -Infinity);
            this._boundary.max.set(Infinity, Infinity, Infinity);
            this._needsUpdate = true;
            return;
        }
        this._boundary.copy(box3);
        this._boundary.clampPoint(this._targetEnd, this._targetEnd);
        this._needsUpdate = true;
    }
    /**
     * Set (or unset) the current viewport.
     * Set this when you want to use renderer viewport and .dollyToCursor feature at the same time.
     * @param viewportOrX
     * @param y
     * @param width
     * @param height
     * @category Methods
     */
    setViewport(viewportOrX, y, width, height) {
        if (viewportOrX === null) {
            // null
            this._viewport = null;
            return;
        }
        this._viewport = this._viewport || new THREE.Vector4();
        if (typeof viewportOrX === "number") {
            // number
            this._viewport.set(viewportOrX, y, width, height);
        } else {
            // Vector4
            this._viewport.copy(viewportOrX);
        }
    }
    /**
     * Calculate the distance to fit the box.
     * @param width box width
     * @param height box height
     * @param depth box depth
     * @returns distance
     * @category Methods
     */
    getDistanceToFitBox(width, height, depth, cover = false) {
        if (
            notSupportedInOrthographicCamera(
                this._camera,
                "getDistanceToFitBox"
            )
        )
            return this._spherical.radius;
        const boundingRectAspect = width / height;
        const fov = this._camera.getEffectiveFOV() * DEG2RAD;
        const aspect = this._camera.aspect;
        const heightToFit = (
            cover ? boundingRectAspect > aspect : boundingRectAspect < aspect
        )
            ? height
            : width / aspect;
        return (heightToFit * 0.5) / Math.tan(fov * 0.5) + depth * 0.5;
    }
    /**
     * Calculate the distance to fit the sphere.
     * @param radius sphere radius
     * @returns distance
     * @category Methods
     */
    getDistanceToFitSphere(radius) {
        if (
            notSupportedInOrthographicCamera(
                this._camera,
                "getDistanceToFitSphere"
            )
        )
            return this._spherical.radius;
        // https://stackoverflow.com/a/44849975
        const vFOV = this._camera.getEffectiveFOV() * DEG2RAD;
        const hFOV = Math.atan(Math.tan(vFOV * 0.5) * this._camera.aspect) * 2;
        const fov = 1 < this._camera.aspect ? vFOV : hFOV;
        return radius / Math.sin(fov * 0.5);
    }
    /**
     * Returns its current gazing target, which is the center position of the orbit.
     * @param out current gazing target
     * @category Methods
     */
    getTarget(out) {
        const _out = !!out && out.isVector3 ? out : new THREE.Vector3();
        return _out.copy(this._targetEnd);
    }
    /**
     * Returns its current position.
     * @param out current position
     * @category Methods
     */
    getPosition(out) {
        const _out = !!out && out.isVector3 ? out : new THREE.Vector3();
        return _out
            .setFromSpherical(this._sphericalEnd)
            .applyQuaternion(this._yAxisUpSpaceInverse)
            .add(this._targetEnd);
    }
    /**
     * Returns its current focal offset, which is how much the camera appears to be translated in screen parallel coordinates.
     * @param out current focal offset
     * @category Methods
     */
    getFocalOffset(out) {
        const _out = !!out && out.isVector3 ? out : new THREE.Vector3();
        return _out.copy(this._focalOffsetEnd);
    }
    /**
     * Normalize camera azimuth angle rotation between 0 and 360 degrees.
     * @category Methods
     */
    normalizeRotations() {
        this._sphericalEnd.theta = this._sphericalEnd.theta % PI_2;
        if (this._sphericalEnd.theta < 0) this._sphericalEnd.theta += PI_2;
        this._spherical.theta +=
            PI_2 *
            Math.round(
                (this._sphericalEnd.theta - this._spherical.theta) / PI_2
            );
    }
    /**
     * Reset all rotation and position to defaults.
     * @param enableTransition
     * @category Methods
     */
    reset(enableTransition = false) {
        if (
            !approxEquals(this._camera.up.x, this._cameraUp0.x) ||
            !approxEquals(this._camera.up.y, this._cameraUp0.y) ||
            !approxEquals(this._camera.up.z, this._cameraUp0.z)
        ) {
            this._camera.up.copy(this._cameraUp0);
            const position = this.getPosition(_v3A$1);
            this.updateCameraUp();
            this.setPosition(position.x, position.y, position.z);
        }
        const promises = [
            this.setLookAt(
                this._position0.x,
                this._position0.y,
                this._position0.z,
                this._target0.x,
                this._target0.y,
                this._target0.z,
                enableTransition
            ),
            this.setFocalOffset(
                this._focalOffset0.x,
                this._focalOffset0.y,
                this._focalOffset0.z,
                enableTransition
            ),
            this.zoomTo(this._zoom0, enableTransition),
        ];
        return Promise.all(promises);
    }
    /**
     * Set current camera position as the default position.
     * @category Methods
     */
    saveState() {
        this._cameraUp0.copy(this._camera.up);
        this.getTarget(this._target0);
        this.getPosition(this._position0);
        this._zoom0 = this._zoom;
        this._focalOffset0.copy(this._focalOffset);
    }
    /**
     * Sync camera-up direction.
     * When camera-up vector is changed, `.updateCameraUp()` must be called.
     * @category Methods
     */
    updateCameraUp() {
        this._yAxisUpSpace.setFromUnitVectors(this._camera.up, _AXIS_Y);
        this._yAxisUpSpaceInverse.copy(this._yAxisUpSpace).invert();
    }
    /**
     * Apply current camera-up direction to the camera.
     * The orbit system will be re-initialized with the current position.
     * @category Methods
     */
    applyCameraUp() {
        const cameraDirection = _v3A$1
            .subVectors(this._target, this._camera.position)
            .normalize();
        // So first find the vector off to the side, orthogonal to both this.object.up and
        // the "view" vector.
        const side = _v3B$1
            .crossVectors(cameraDirection, this._camera.up)
            .normalize();
        // Then find the vector orthogonal to both this "side" vector and the "view" vector.
        // This vector will be the new "up" vector.
        this._camera.up.crossVectors(side, cameraDirection).normalize();
        this._camera.updateMatrixWorld();
        const position = this.getPosition(_v3A$1);
        this.updateCameraUp();
        this.setPosition(position.x, position.y, position.z);
    }
    /**
     * Update camera position and directions.
     * This should be called in your tick loop every time, and returns true if re-rendering is needed.
     * @param delta
     * @returns updated
     * @category Methods
     */
    update(delta) {
        const deltaTheta = this._sphericalEnd.theta - this._spherical.theta;
        const deltaPhi = this._sphericalEnd.phi - this._spherical.phi;
        const deltaRadius = this._sphericalEnd.radius - this._spherical.radius;
        const deltaTarget = _deltaTarget.subVectors(
            this._targetEnd,
            this._target
        );
        const deltaOffset = _deltaOffset.subVectors(
            this._focalOffsetEnd,
            this._focalOffset
        );
        const deltaZoom = this._zoomEnd - this._zoom;
        // update theta
        if (approxZero(deltaTheta)) {
            this._thetaVelocity.value = 0;
            this._spherical.theta = this._sphericalEnd.theta;
        } else {
            const smoothTime = this._isUserControllingRotate
                ? this.draggingSmoothTime
                : this.smoothTime;
            this._spherical.theta = smoothDamp(
                this._spherical.theta,
                this._sphericalEnd.theta,
                this._thetaVelocity,
                smoothTime,
                Infinity,
                delta
            );
            this._needsUpdate = true;
        }
        // update phi
        if (approxZero(deltaPhi)) {
            this._phiVelocity.value = 0;
            this._spherical.phi = this._sphericalEnd.phi;
        } else {
            const smoothTime = this._isUserControllingRotate
                ? this.draggingSmoothTime
                : this.smoothTime;
            this._spherical.phi = smoothDamp(
                this._spherical.phi,
                this._sphericalEnd.phi,
                this._phiVelocity,
                smoothTime,
                Infinity,
                delta
            );
            this._needsUpdate = true;
        }
        // update distance
        if (approxZero(deltaRadius)) {
            this._radiusVelocity.value = 0;
            this._spherical.radius = this._sphericalEnd.radius;
        } else {
            const smoothTime = this._isUserControllingDolly
                ? this.draggingSmoothTime
                : this.smoothTime;
            this._spherical.radius = smoothDamp(
                this._spherical.radius,
                this._sphericalEnd.radius,
                this._radiusVelocity,
                smoothTime,
                this.maxSpeed,
                delta
            );
            this._needsUpdate = true;
        }
        // update target position
        if (
            approxZero(deltaTarget.x) &&
            approxZero(deltaTarget.y) &&
            approxZero(deltaTarget.z)
        ) {
            this._targetVelocity.set(0, 0, 0);
            this._target.copy(this._targetEnd);
        } else {
            const smoothTime = this._isUserControllingTruck
                ? this.draggingSmoothTime
                : this.smoothTime;
            smoothDampVec3(
                this._target,
                this._targetEnd,
                this._targetVelocity,
                smoothTime,
                this.maxSpeed,
                delta,
                this._target
            );
            this._needsUpdate = true;
        }
        // update focalOffset
        if (
            approxZero(deltaOffset.x) &&
            approxZero(deltaOffset.y) &&
            approxZero(deltaOffset.z)
        ) {
            this._focalOffsetVelocity.set(0, 0, 0);
            this._focalOffset.copy(this._focalOffsetEnd);
        } else {
            const smoothTime = this._isUserControllingOffset
                ? this.draggingSmoothTime
                : this.smoothTime;
            smoothDampVec3(
                this._focalOffset,
                this._focalOffsetEnd,
                this._focalOffsetVelocity,
                smoothTime,
                this.maxSpeed,
                delta,
                this._focalOffset
            );
            this._needsUpdate = true;
        }
        if (this._dollyControlAmount !== 0) {
            if (isPerspectiveCamera(this._camera)) {
                const camera = this._camera;
                const cameraDirection = _v3A$1
                    .setFromSpherical(this._spherical)
                    .applyQuaternion(this._yAxisUpSpaceInverse)
                    .normalize()
                    .negate();
                const planeX = _v3B$1
                    .copy(cameraDirection)
                    .cross(camera.up)
                    .normalize();
                if (planeX.lengthSq() === 0) planeX.x = 1.0;
                const planeY = _v3C$1.crossVectors(planeX, cameraDirection);
                const worldToScreen =
                    this._sphericalEnd.radius *
                    Math.tan(camera.getEffectiveFOV() * DEG2RAD * 0.5);
                const prevRadius =
                    this._sphericalEnd.radius - this._dollyControlAmount;
                const lerpRatio =
                    (prevRadius - this._sphericalEnd.radius) /
                    this._sphericalEnd.radius;
                const cursor = _v3A$1
                    .copy(this._targetEnd)
                    .add(
                        planeX.multiplyScalar(
                            this._dollyControlCoord.x *
                                worldToScreen *
                                camera.aspect
                        )
                    )
                    .add(
                        planeY.multiplyScalar(
                            this._dollyControlCoord.y * worldToScreen
                        )
                    );
                this._targetEnd.lerp(cursor, lerpRatio);
            } else if (isOrthographicCamera(this._camera)) {
                const camera = this._camera;
                const worldCursorPosition = _v3A$1
                    .set(
                        this._dollyControlCoord.x,
                        this._dollyControlCoord.y,
                        (camera.near + camera.far) / (camera.near - camera.far)
                    )
                    .unproject(camera); //.sub( _v3B.set( this._focalOffset.x, this._focalOffset.y, 0 ) );
                const quaternion = _v3B$1
                    .set(0, 0, -1)
                    .applyQuaternion(camera.quaternion);
                const cursor = _v3C$1
                    .copy(worldCursorPosition)
                    .add(
                        quaternion.multiplyScalar(
                            -worldCursorPosition.dot(camera.up)
                        )
                    );
                const prevZoom = this._zoom - this._dollyControlAmount;
                const lerpRatio = -(prevZoom - this._zoomEnd) / this._zoom;
                // find the "distance" (aka plane constant in three.js) of Plane
                // from a given position (this._targetEnd) and normal vector (cameraDirection)
                // https://www.maplesoft.com/support/help/maple/view.aspx?path=MathApps%2FEquationOfAPlaneNormal#bkmrk0
                const cameraDirection = _v3A$1
                    .setFromSpherical(this._spherical)
                    .applyQuaternion(this._yAxisUpSpaceInverse)
                    .normalize()
                    .negate();
                const prevPlaneConstant = this._targetEnd.dot(cameraDirection);
                this._targetEnd.lerp(cursor, lerpRatio);
                const newPlaneConstant = this._targetEnd.dot(cameraDirection);
                // Pull back the camera depth that has moved, to be the camera stationary as zoom
                const pullBack = cameraDirection.multiplyScalar(
                    newPlaneConstant - prevPlaneConstant
                );
                this._targetEnd.sub(pullBack);
            }
            this._target.copy(this._targetEnd);
            // target position may be moved beyond boundary.
            this._boundary.clampPoint(this._targetEnd, this._targetEnd);
            this._dollyControlAmount = 0;
        }
        // update zoom
        if (approxZero(deltaZoom)) {
            this._zoomVelocity.value = 0;
            this._zoom = this._zoomEnd;
        } else {
            const smoothTime = this._isUserControllingZoom
                ? this.draggingSmoothTime
                : this.smoothTime;
            this._zoom = smoothDamp(
                this._zoom,
                this._zoomEnd,
                this._zoomVelocity,
                smoothTime,
                Infinity,
                delta
            );
        }
        if (this._camera.zoom !== this._zoom) {
            this._camera.zoom = this._zoom;
            this._camera.updateProjectionMatrix();
            this._updateNearPlaneCorners();
            this._needsUpdate = true;
        }
        // collision detection
        const maxDistance = this._collisionTest();
        this._spherical.radius = Math.min(this._spherical.radius, maxDistance);
        // decompose spherical to the camera position
        this._spherical.makeSafe();
        this._camera.position
            .setFromSpherical(this._spherical)
            .applyQuaternion(this._yAxisUpSpaceInverse)
            .add(this._target);
        this._camera.lookAt(this._target);
        // set offset after the orbit movement
        const affectOffset =
            !approxZero(this._focalOffset.x) ||
            !approxZero(this._focalOffset.y) ||
            !approxZero(this._focalOffset.z);
        if (affectOffset) {
            this._camera.updateMatrixWorld();
            _xColumn.setFromMatrixColumn(this._camera.matrix, 0);
            _yColumn.setFromMatrixColumn(this._camera.matrix, 1);
            _zColumn.setFromMatrixColumn(this._camera.matrix, 2);
            _xColumn.multiplyScalar(this._focalOffset.x);
            _yColumn.multiplyScalar(-this._focalOffset.y);
            _zColumn.multiplyScalar(this._focalOffset.z); // notice: z-offset will not affect in Orthographic.
            _v3A$1.copy(_xColumn).add(_yColumn).add(_zColumn);
            this._camera.position.add(_v3A$1);
        }
        if (this._boundaryEnclosesCamera) {
            this._encloseToBoundary(
                this._camera.position.copy(this._target),
                _v3A$1
                    .setFromSpherical(this._spherical)
                    .applyQuaternion(this._yAxisUpSpaceInverse),
                1.0
            );
        }
        const updated = this._needsUpdate;
        if (updated && !this._updatedLastTime) {
            this._hasRested = false;
            this.dispatchEvent({ type: "wake" });
            this.dispatchEvent({ type: "update" });
        } else if (updated) {
            this.dispatchEvent({ type: "update" });
            if (
                approxZero(deltaTheta, this.restThreshold) &&
                approxZero(deltaPhi, this.restThreshold) &&
                approxZero(deltaRadius, this.restThreshold) &&
                approxZero(deltaTarget.x, this.restThreshold) &&
                approxZero(deltaTarget.y, this.restThreshold) &&
                approxZero(deltaTarget.z, this.restThreshold) &&
                approxZero(deltaOffset.x, this.restThreshold) &&
                approxZero(deltaOffset.y, this.restThreshold) &&
                approxZero(deltaOffset.z, this.restThreshold) &&
                approxZero(deltaZoom, this.restThreshold) &&
                !this._hasRested
            ) {
                this._hasRested = true;
                this.dispatchEvent({ type: "rest" });
            }
        } else if (!updated && this._updatedLastTime) {
            this.dispatchEvent({ type: "sleep" });
        }
        this._updatedLastTime = updated;
        this._needsUpdate = false;
        return updated;
    }
    /**
     * Get all state in JSON string
     * @category Methods
     */
    toJSON() {
        return JSON.stringify({
            enabled: this._enabled,
            minDistance: this.minDistance,
            maxDistance: infinityToMaxNumber(this.maxDistance),
            minZoom: this.minZoom,
            maxZoom: infinityToMaxNumber(this.maxZoom),
            minPolarAngle: this.minPolarAngle,
            maxPolarAngle: infinityToMaxNumber(this.maxPolarAngle),
            minAzimuthAngle: infinityToMaxNumber(this.minAzimuthAngle),
            maxAzimuthAngle: infinityToMaxNumber(this.maxAzimuthAngle),
            smoothTime: this.smoothTime,
            draggingSmoothTime: this.draggingSmoothTime,
            dollySpeed: this.dollySpeed,
            truckSpeed: this.truckSpeed,
            dollyToCursor: this.dollyToCursor,
            verticalDragToForward: this.verticalDragToForward,
            target: this._targetEnd.toArray(),
            position: _v3A$1
                .setFromSpherical(this._sphericalEnd)
                .add(this._targetEnd)
                .toArray(),
            zoom: this._zoomEnd,
            focalOffset: this._focalOffsetEnd.toArray(),
            target0: this._target0.toArray(),
            position0: this._position0.toArray(),
            zoom0: this._zoom0,
            focalOffset0: this._focalOffset0.toArray(),
        });
    }
    /**
     * Reproduce the control state with JSON. enableTransition is where anim or not in a boolean.
     * @param json
     * @param enableTransition
     * @category Methods
     */
    fromJSON(json, enableTransition = false) {
        const obj = JSON.parse(json);
        this.enabled = obj.enabled;
        this.minDistance = obj.minDistance;
        this.maxDistance = maxNumberToInfinity(obj.maxDistance);
        this.minZoom = obj.minZoom;
        this.maxZoom = maxNumberToInfinity(obj.maxZoom);
        this.minPolarAngle = obj.minPolarAngle;
        this.maxPolarAngle = maxNumberToInfinity(obj.maxPolarAngle);
        this.minAzimuthAngle = maxNumberToInfinity(obj.minAzimuthAngle);
        this.maxAzimuthAngle = maxNumberToInfinity(obj.maxAzimuthAngle);
        this.smoothTime = obj.smoothTime;
        this.draggingSmoothTime = obj.draggingSmoothTime;
        this.dollySpeed = obj.dollySpeed;
        this.truckSpeed = obj.truckSpeed;
        this.dollyToCursor = obj.dollyToCursor;
        this.verticalDragToForward = obj.verticalDragToForward;
        this._target0.fromArray(obj.target0);
        this._position0.fromArray(obj.position0);
        this._zoom0 = obj.zoom0;
        this._focalOffset0.fromArray(obj.focalOffset0);
        this.moveTo(
            obj.target[0],
            obj.target[1],
            obj.target[2],
            enableTransition
        );
        _sphericalA.setFromVector3(
            _v3A$1
                .fromArray(obj.position)
                .sub(this._targetEnd)
                .applyQuaternion(this._yAxisUpSpace)
        );
        this.rotateTo(_sphericalA.theta, _sphericalA.phi, enableTransition);
        this.dollyTo(_sphericalA.radius, enableTransition);
        this.zoomTo(obj.zoom, enableTransition);
        this.setFocalOffset(
            obj.focalOffset[0],
            obj.focalOffset[1],
            obj.focalOffset[2],
            enableTransition
        );
        this._needsUpdate = true;
    }
    /**
     * Attach all internal event handlers to enable drag control.
     * @category Methods
     */
    connect(domElement) {
        if (this._domElement) {
            console.warn("camera-controls is already connected.");
            return;
        }
        domElement.setAttribute("data-camera-controls-version", VERSION);
        this._addAllEventListeners(domElement);
    }
    /**
     * Detach all internal event handlers to disable drag control.
     */
    disconnect() {
        this.cancel();
        this._removeAllEventListeners();
        if (this._domElement) {
            this._domElement.removeAttribute("data-camera-controls-version");
            this._domElement = undefined;
        }
    }
    /**
     * Dispose the cameraControls instance itself, remove all eventListeners.
     * @category Methods
     */
    dispose() {
        // remove all user event listeners
        this.removeAllEventListeners();
        // remove all internal event listeners
        this.disconnect();
    }
    _findPointerById(pointerId) {
        return this._activePointers.find(
            (activePointer) => activePointer.pointerId === pointerId
        );
    }
    _findPointerByMouseButton(mouseButton) {
        return this._activePointers.find(
            (activePointer) => activePointer.mouseButton === mouseButton
        );
    }
    _encloseToBoundary(position, offset, friction) {
        const offsetLength2 = offset.lengthSq();
        if (offsetLength2 === 0.0) {
            // sanity check
            return position;
        }
        // See: https://twitter.com/FMS_Cat/status/1106508958640988161
        const newTarget = _v3B$1.copy(offset).add(position); // target
        const clampedTarget = this._boundary.clampPoint(newTarget, _v3C$1); // clamped target
        const deltaClampedTarget = clampedTarget.sub(newTarget); // newTarget -> clampedTarget
        const deltaClampedTargetLength2 = deltaClampedTarget.lengthSq(); // squared length of deltaClampedTarget
        if (deltaClampedTargetLength2 === 0.0) {
            // when the position doesn't have to be clamped
            return position.add(offset);
        } else if (deltaClampedTargetLength2 === offsetLength2) {
            // when the position is completely stuck
            return position;
        } else if (friction === 0.0) {
            return position.add(offset).add(deltaClampedTarget);
        } else {
            const offsetFactor =
                1.0 +
                (friction * deltaClampedTargetLength2) /
                    offset.dot(deltaClampedTarget);
            return position
                .add(_v3B$1.copy(offset).multiplyScalar(offsetFactor))
                .add(deltaClampedTarget.multiplyScalar(1.0 - friction));
        }
    }
    _updateNearPlaneCorners() {
        if (isPerspectiveCamera(this._camera)) {
            const camera = this._camera;
            const near = camera.near;
            const fov = camera.getEffectiveFOV() * DEG2RAD;
            const heightHalf = Math.tan(fov * 0.5) * near; // near plain half height
            const widthHalf = heightHalf * camera.aspect; // near plain half width
            this._nearPlaneCorners[0].set(-widthHalf, -heightHalf, 0);
            this._nearPlaneCorners[1].set(widthHalf, -heightHalf, 0);
            this._nearPlaneCorners[2].set(widthHalf, heightHalf, 0);
            this._nearPlaneCorners[3].set(-widthHalf, heightHalf, 0);
        } else if (isOrthographicCamera(this._camera)) {
            const camera = this._camera;
            const zoomInv = 1 / camera.zoom;
            const left = camera.left * zoomInv;
            const right = camera.right * zoomInv;
            const top = camera.top * zoomInv;
            const bottom = camera.bottom * zoomInv;
            this._nearPlaneCorners[0].set(left, top, 0);
            this._nearPlaneCorners[1].set(right, top, 0);
            this._nearPlaneCorners[2].set(right, bottom, 0);
            this._nearPlaneCorners[3].set(left, bottom, 0);
        }
    }
    // lateUpdate
    _collisionTest() {
        let distance = Infinity;
        const hasCollider = this.colliderMeshes.length >= 1;
        if (!hasCollider) return distance;
        if (notSupportedInOrthographicCamera(this._camera, "_collisionTest"))
            return distance;
        // divide by distance to normalize, lighter than `Vector3.prototype.normalize()`
        const direction = _v3A$1
            .setFromSpherical(this._spherical)
            .divideScalar(this._spherical.radius);
        _rotationMatrix$1.lookAt(_ORIGIN$1, direction, this._camera.up);
        for (let i = 0; i < 4; i++) {
            const nearPlaneCorner = _v3B$1.copy(this._nearPlaneCorners[i]);
            nearPlaneCorner.applyMatrix4(_rotationMatrix$1);
            const origin = _v3C$1.addVectors(this._target, nearPlaneCorner);
            _raycaster.set(origin, direction);
            _raycaster.far = this._spherical.radius + 1;
            const intersects = _raycaster.intersectObjects(this.colliderMeshes);
            if (intersects.length !== 0 && intersects[0].distance < distance) {
                distance = intersects[0].distance;
            }
        }
        return distance;
    }
    /**
     * Get its client rect and package into given `DOMRect` .
     */
    _getClientRect(target) {
        if (!this._domElement) return;
        const rect = this._domElement.getBoundingClientRect();
        target.x = rect.left;
        target.y = rect.top;
        if (this._viewport) {
            target.x += this._viewport.x;
            target.y += rect.height - this._viewport.w - this._viewport.y;
            target.width = this._viewport.z;
            target.height = this._viewport.w;
        } else {
            target.width = rect.width;
            target.height = rect.height;
        }
        return target;
    }
    _createOnRestPromise(resolveImmediately) {
        if (resolveImmediately) return Promise.resolve();
        this._hasRested = false;
        this.dispatchEvent({ type: "transitionstart" });
        return new Promise((resolve) => {
            const onResolve = () => {
                this.removeEventListener("rest", onResolve);
                resolve();
            };
            this.addEventListener("rest", onResolve);
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _addAllEventListeners(_domElement) {}
    _removeAllEventListeners() {}
    /**
     * backward compatible
     * @deprecated use smoothTime (in seconds) instead
     * @category Properties
     */
    get dampingFactor() {
        console.warn(
            ".dampingFactor has been deprecated. use smoothTime (in seconds) instead."
        );
        return 0;
    }
    /**
     * backward compatible
     * @deprecated use smoothTime (in seconds) instead
     * @category Properties
     */
    set dampingFactor(_) {
        console.warn(
            ".dampingFactor has been deprecated. use smoothTime (in seconds) instead."
        );
    }
    /**
     * backward compatible
     * @deprecated use draggingSmoothTime (in seconds) instead
     * @category Properties
     */
    get draggingDampingFactor() {
        console.warn(
            ".draggingDampingFactor has been deprecated. use draggingSmoothTime (in seconds) instead."
        );
        return 0;
    }
    /**
     * backward compatible
     * @deprecated use draggingSmoothTime (in seconds) instead
     * @category Properties
     */
    set draggingDampingFactor(_) {
        console.warn(
            ".draggingDampingFactor has been deprecated. use draggingSmoothTime (in seconds) instead."
        );
    }
    static createBoundingSphere(object3d, out = new THREE.Sphere()) {
        const boundingSphere = out;
        const center = boundingSphere.center;
        _box3A.makeEmpty();
        // find the center
        object3d.traverseVisible((object) => {
            if (!object.isMesh) return;
            _box3A.expandByObject(object);
        });
        _box3A.getCenter(center);
        // find the radius
        let maxRadiusSq = 0;
        object3d.traverseVisible((object) => {
            if (!object.isMesh) return;
            const mesh = object;
            const geometry = mesh.geometry.clone();
            geometry.applyMatrix4(mesh.matrixWorld);
            const bufferGeometry = geometry;
            const position = bufferGeometry.attributes.position;
            for (let i = 0, l = position.count; i < l; i++) {
                _v3A$1.fromBufferAttribute(position, i);
                maxRadiusSq = Math.max(
                    maxRadiusSq,
                    center.distanceToSquared(_v3A$1)
                );
            }
        });
        boundingSphere.radius = Math.sqrt(maxRadiusSq);
        return boundingSphere;
    }
}

const subsetOfTHREE = {
    Vector2: three__WEBPACK_IMPORTED_MODULE_0__/* .Vector2 */ .FM8,
    Vector3: three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4,
    Vector4: three__WEBPACK_IMPORTED_MODULE_0__/* .Vector4 */ .Ltg,
    Quaternion: three__WEBPACK_IMPORTED_MODULE_0__/* .Quaternion */ ._fP,
    Matrix4: three__WEBPACK_IMPORTED_MODULE_0__/* .Matrix4 */ .yGw,
    Spherical: three__WEBPACK_IMPORTED_MODULE_0__/* .Spherical */ .$V,
    Box3: three__WEBPACK_IMPORTED_MODULE_0__/* .Box3 */ .ZzF,
    Sphere: three__WEBPACK_IMPORTED_MODULE_0__/* .Sphere */ .aLr,
    Raycaster: three__WEBPACK_IMPORTED_MODULE_0__/* .Raycaster */ .iMs,
};
CameraControls.install({ THREE: subsetOfTHREE });
const _ORIGIN = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4(0, 0, 0);
const _v3A = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const _v3B = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const _v3C = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const _ray = new three__WEBPACK_IMPORTED_MODULE_0__/* .Ray */ .zHn();
const _rotationMatrix = new three__WEBPACK_IMPORTED_MODULE_0__/* .Matrix4 */ .yGw();
class TPSCameraControls extends CameraControls {
    constructor(camera, trackObject, world, domElement) {
        super(camera, domElement);
        this.minDistance = 1;
        this.maxDistance = 30;
        this.azimuthRotateSpeed = 0.3; // negative value to invert rotation direction
        this.polarRotateSpeed = -0.2; // negative value to invert rotation direction
        this.minPolarAngle = 30 * three__WEBPACK_IMPORTED_MODULE_0__/* .MathUtils */ .M8C.DEG2RAD;
        this.maxPolarAngle = 120 * three__WEBPACK_IMPORTED_MODULE_0__/* .MathUtils */ .M8C.DEG2RAD;
        this.draggingSmoothTime = 1e-10;
        this.mouseButtons.right = CameraControls.ACTION.NONE;
        this.mouseButtons.middle = CameraControls.ACTION.NONE;
        this.touches.two = CameraControls.ACTION.TOUCH_DOLLY;
        this.touches.three = CameraControls.ACTION.TOUCH_DOLLY;
        this.world = world;
        this.colliderMeshes = [new three__WEBPACK_IMPORTED_MODULE_0__/* .Object3D */ .Tme()];
        // this._trackObject = trackObject;
        // this.offset = new Vector3( 0, 1, 0 );
        const offset = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4(0, 2, 0);
        this.update = (delta) => {
            const x = trackObject.position.x + offset.x;
            const y = trackObject.position.y + offset.y;
            const z = trackObject.position.z + offset.z;
            this.moveTo(x, y, z, false);
            return super.update(delta);
        };
    }
    get frontAngle() {
        return this.azimuthAngle;
    }
    _collisionTest() {
        let distance = Infinity;
        if (!this.world) return distance;
        for (let i = 0, l = this.world.colliderPool.length; i < l; i++) {
            const octree = this.world.colliderPool[i];
            const direction = _v3A
                .setFromSpherical(this._spherical)
                .divideScalar(this._spherical.radius);
            _rotationMatrix.lookAt(_ORIGIN, direction, this._camera.up);
            for (let i = 0; i < 4; i++) {
                const nearPlaneCorner = _v3B.copy(this._nearPlaneCorners[i]);
                nearPlaneCorner.applyMatrix4(_rotationMatrix);
                const origin = _v3C.addVectors(this._target, nearPlaneCorner);
                _ray.set(origin, direction);
                const intersect = octree.rayIntersect(_ray);
                if (intersect && intersect.distance < distance) {
                    distance = intersect.distance;
                }
            }
        }
        return distance;
    }
}




/***/ }),

/***/ 829:
/***/ ((module, exports, __webpack_require__) => {

"use strict";
var __filename = "/index.js";
var __dirname = "/";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// dist/web-ifc-mt.js
var require_web_ifc_mt = __commonJS({
  "dist/web-ifc-mt.js"(exports2, module2) {
    "use strict";
    var WebIFCWasm2 = (() => {
      var _scriptDir = typeof document !== "undefined" && document.currentScript ? document.currentScript.src : void 0;
      return function(moduleArg = {}) {
        function GROWABLE_HEAP_I8() {
          if (wasmMemory.buffer != HEAP8.buffer) {
            updateMemoryViews();
          }
          return HEAP8;
        }
        function GROWABLE_HEAP_U8() {
          if (wasmMemory.buffer != HEAP8.buffer) {
            updateMemoryViews();
          }
          return HEAPU8;
        }
        function GROWABLE_HEAP_I16() {
          if (wasmMemory.buffer != HEAP8.buffer) {
            updateMemoryViews();
          }
          return HEAP16;
        }
        function GROWABLE_HEAP_U16() {
          if (wasmMemory.buffer != HEAP8.buffer) {
            updateMemoryViews();
          }
          return HEAPU16;
        }
        function GROWABLE_HEAP_I32() {
          if (wasmMemory.buffer != HEAP8.buffer) {
            updateMemoryViews();
          }
          return HEAP32;
        }
        function GROWABLE_HEAP_U32() {
          if (wasmMemory.buffer != HEAP8.buffer) {
            updateMemoryViews();
          }
          return HEAPU32;
        }
        function GROWABLE_HEAP_F32() {
          if (wasmMemory.buffer != HEAP8.buffer) {
            updateMemoryViews();
          }
          return HEAPF32;
        }
        function GROWABLE_HEAP_F64() {
          if (wasmMemory.buffer != HEAP8.buffer) {
            updateMemoryViews();
          }
          return HEAPF64;
        }
        var Module = moduleArg;
        var readyPromiseResolve, readyPromiseReject;
        Module["ready"] = new Promise((resolve, reject) => {
          readyPromiseResolve = resolve;
          readyPromiseReject = reject;
        });
        var moduleOverrides = Object.assign({}, Module);
        var arguments_ = [];
        var thisProgram = "./this.program";
        var quit_ = (status, toThrow) => {
          throw toThrow;
        };
        var ENVIRONMENT_IS_WEB = typeof window == "object";
        var ENVIRONMENT_IS_WORKER = typeof importScripts == "function";
        var ENVIRONMENT_IS_NODE = typeof process == "object" && typeof process.versions == "object" && typeof process.versions.node == "string";
        var ENVIRONMENT_IS_PTHREAD = Module["ENVIRONMENT_IS_PTHREAD"] || false;
        var scriptDirectory = "";
        function locateFile(path) {
          if (Module["locateFile"]) {
            return Module["locateFile"](path, scriptDirectory);
          }
          return scriptDirectory + path;
        }
        var read_, readAsync, readBinary, setWindowTitle;
        if (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) {
          if (ENVIRONMENT_IS_WORKER) {
            scriptDirectory = self.location.href;
          } else if (typeof document != "undefined" && document.currentScript) {
            scriptDirectory = document.currentScript.src;
          }
          if (_scriptDir) {
            scriptDirectory = _scriptDir;
          }
          if (scriptDirectory.indexOf("blob:") !== 0) {
            scriptDirectory = scriptDirectory.substr(0, scriptDirectory.replace(/[?#].*/, "").lastIndexOf("/") + 1);
          } else {
            scriptDirectory = "";
          }
          {
            read_ = (url) => {
              var xhr = new XMLHttpRequest();
              xhr.open("GET", url, false);
              xhr.send(null);
              return xhr.responseText;
            };
            if (ENVIRONMENT_IS_WORKER) {
              readBinary = (url) => {
                var xhr = new XMLHttpRequest();
                xhr.open("GET", url, false);
                xhr.responseType = "arraybuffer";
                xhr.send(null);
                return new Uint8Array(xhr.response);
              };
            }
            readAsync = (url, onload, onerror) => {
              var xhr = new XMLHttpRequest();
              xhr.open("GET", url, true);
              xhr.responseType = "arraybuffer";
              xhr.onload = () => {
                if (xhr.status == 200 || xhr.status == 0 && xhr.response) {
                  onload(xhr.response);
                  return;
                }
                onerror();
              };
              xhr.onerror = onerror;
              xhr.send(null);
            };
          }
          setWindowTitle = (title) => document.title = title;
        } else {
        }
        var out = Module["print"] || console.log.bind(console);
        var err = Module["printErr"] || console.error.bind(console);
        Object.assign(Module, moduleOverrides);
        moduleOverrides = null;
        if (Module["arguments"]) arguments_ = Module["arguments"];
        if (Module["thisProgram"]) thisProgram = Module["thisProgram"];
        if (Module["quit"]) quit_ = Module["quit"];
        var wasmBinary;
        if (Module["wasmBinary"]) wasmBinary = Module["wasmBinary"];
        var noExitRuntime = Module["noExitRuntime"] || true;
        if (typeof WebAssembly != "object") {
          abort("no native wasm support detected");
        }
        var wasmMemory;
        var wasmExports;
        var wasmModule;
        var ABORT = false;
        var EXITSTATUS;
        function assert(condition, text) {
          if (!condition) {
            abort(text);
          }
        }
        var HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32, HEAPF64;
        function updateMemoryViews() {
          var b = wasmMemory.buffer;
          Module["HEAP8"] = HEAP8 = new Int8Array(b);
          Module["HEAP16"] = HEAP16 = new Int16Array(b);
          Module["HEAP32"] = HEAP32 = new Int32Array(b);
          Module["HEAPU8"] = HEAPU8 = new Uint8Array(b);
          Module["HEAPU16"] = HEAPU16 = new Uint16Array(b);
          Module["HEAPU32"] = HEAPU32 = new Uint32Array(b);
          Module["HEAPF32"] = HEAPF32 = new Float32Array(b);
          Module["HEAPF64"] = HEAPF64 = new Float64Array(b);
        }
        var INITIAL_MEMORY = Module["INITIAL_MEMORY"] || 16777216;
        assert(INITIAL_MEMORY >= 5242880, "INITIAL_MEMORY should be larger than STACK_SIZE, was " + INITIAL_MEMORY + "! (STACK_SIZE=5242880)");
        if (ENVIRONMENT_IS_PTHREAD) {
          wasmMemory = Module["wasmMemory"];
        } else {
          if (Module["wasmMemory"]) {
            wasmMemory = Module["wasmMemory"];
          } else {
            wasmMemory = new WebAssembly.Memory({ "initial": INITIAL_MEMORY / 65536, "maximum": 4294967296 / 65536, "shared": true });
            if (!(wasmMemory.buffer instanceof SharedArrayBuffer)) {
              err("requested a shared WebAssembly.Memory but the returned buffer is not a SharedArrayBuffer, indicating that while the browser has SharedArrayBuffer it does not have WebAssembly threads support - you may need to set a flag");
              if (ENVIRONMENT_IS_NODE) {
                err("(on node you may need: --experimental-wasm-threads --experimental-wasm-bulk-memory and/or recent version)");
              }
              throw Error("bad memory");
            }
          }
        }
        updateMemoryViews();
        INITIAL_MEMORY = wasmMemory.buffer.byteLength;
        var wasmTable;
        var __ATPRERUN__ = [];
        var __ATINIT__ = [];
        var __ATPOSTRUN__ = [];
        var runtimeInitialized = false;
        var runtimeKeepaliveCounter = 0;
        function keepRuntimeAlive() {
          return noExitRuntime || runtimeKeepaliveCounter > 0;
        }
        function preRun() {
          if (Module["preRun"]) {
            if (typeof Module["preRun"] == "function") Module["preRun"] = [Module["preRun"]];
            while (Module["preRun"].length) {
              addOnPreRun(Module["preRun"].shift());
            }
          }
          callRuntimeCallbacks(__ATPRERUN__);
        }
        function initRuntime() {
          runtimeInitialized = true;
          if (ENVIRONMENT_IS_PTHREAD) return;
          if (!Module["noFSInit"] && !FS.init.initialized) FS.init();
          FS.ignorePermissions = false;
          TTY.init();
          callRuntimeCallbacks(__ATINIT__);
        }
        function postRun() {
          if (ENVIRONMENT_IS_PTHREAD) return;
          if (Module["postRun"]) {
            if (typeof Module["postRun"] == "function") Module["postRun"] = [Module["postRun"]];
            while (Module["postRun"].length) {
              addOnPostRun(Module["postRun"].shift());
            }
          }
          callRuntimeCallbacks(__ATPOSTRUN__);
        }
        function addOnPreRun(cb) {
          __ATPRERUN__.unshift(cb);
        }
        function addOnInit(cb) {
          __ATINIT__.unshift(cb);
        }
        function addOnPostRun(cb) {
          __ATPOSTRUN__.unshift(cb);
        }
        var runDependencies = 0;
        var runDependencyWatcher = null;
        var dependenciesFulfilled = null;
        function getUniqueRunDependency(id) {
          return id;
        }
        function addRunDependency(id) {
          runDependencies++;
          if (Module["monitorRunDependencies"]) {
            Module["monitorRunDependencies"](runDependencies);
          }
        }
        function removeRunDependency(id) {
          runDependencies--;
          if (Module["monitorRunDependencies"]) {
            Module["monitorRunDependencies"](runDependencies);
          }
          if (runDependencies == 0) {
            if (runDependencyWatcher !== null) {
              clearInterval(runDependencyWatcher);
              runDependencyWatcher = null;
            }
            if (dependenciesFulfilled) {
              var callback = dependenciesFulfilled;
              dependenciesFulfilled = null;
              callback();
            }
          }
        }
        function abort(what) {
          if (Module["onAbort"]) {
            Module["onAbort"](what);
          }
          what = "Aborted(" + what + ")";
          err(what);
          ABORT = true;
          EXITSTATUS = 1;
          what += ". Build with -sASSERTIONS for more info.";
          var e = new WebAssembly.RuntimeError(what);
          readyPromiseReject(e);
          throw e;
        }
        var dataURIPrefix = "data:application/octet-stream;base64,";
        function isDataURI(filename) {
          return filename.startsWith(dataURIPrefix);
        }
        var wasmBinaryFile;
        wasmBinaryFile = "web-ifc-mt.wasm";
        if (!isDataURI(wasmBinaryFile)) {
          wasmBinaryFile = locateFile(wasmBinaryFile);
        }
        function getBinarySync(file) {
          if (file == wasmBinaryFile && wasmBinary) {
            return new Uint8Array(wasmBinary);
          }
          if (readBinary) {
            return readBinary(file);
          }
          throw "both async and sync fetching of the wasm failed";
        }
        function getBinaryPromise(binaryFile) {
          if (!wasmBinary && (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER)) {
            if (typeof fetch == "function") {
              return fetch(binaryFile, { credentials: "same-origin" }).then((response) => {
                if (!response["ok"]) {
                  throw "failed to load wasm binary file at '" + binaryFile + "'";
                }
                return response["arrayBuffer"]();
              }).catch(() => getBinarySync(binaryFile));
            }
          }
          return Promise.resolve().then(() => getBinarySync(binaryFile));
        }
        function instantiateArrayBuffer(binaryFile, imports, receiver) {
          return getBinaryPromise(binaryFile).then((binary) => WebAssembly.instantiate(binary, imports)).then((instance) => instance).then(receiver, (reason) => {
            err("failed to asynchronously prepare wasm: " + reason);
            abort(reason);
          });
        }
        function instantiateAsync(binary, binaryFile, imports, callback) {
          if (!binary && typeof WebAssembly.instantiateStreaming == "function" && !isDataURI(binaryFile) && typeof fetch == "function") {
            return fetch(binaryFile, { credentials: "same-origin" }).then((response) => {
              var result = WebAssembly.instantiateStreaming(response, imports);
              return result.then(callback, function(reason) {
                err("wasm streaming compile failed: " + reason);
                err("falling back to ArrayBuffer instantiation");
                return instantiateArrayBuffer(binaryFile, imports, callback);
              });
            });
          }
          return instantiateArrayBuffer(binaryFile, imports, callback);
        }
        function createWasm() {
          var info = { "a": wasmImports };
          function receiveInstance(instance, module3) {
            var exports3 = instance.exports;
            exports3 = applySignatureConversions(exports3);
            wasmExports = exports3;
            registerTLSInit(wasmExports["ma"]);
            wasmTable = wasmExports["ka"];
            addOnInit(wasmExports["ia"]);
            wasmModule = module3;
            removeRunDependency("wasm-instantiate");
            return exports3;
          }
          addRunDependency("wasm-instantiate");
          function receiveInstantiationResult(result) {
            receiveInstance(result["instance"], result["module"]);
          }
          if (Module["instantiateWasm"]) {
            try {
              return Module["instantiateWasm"](info, receiveInstance);
            } catch (e) {
              err("Module.instantiateWasm callback failed with error: " + e);
              readyPromiseReject(e);
            }
          }
          instantiateAsync(wasmBinary, wasmBinaryFile, info, receiveInstantiationResult).catch(readyPromiseReject);
          return {};
        }
        var tempDouble;
        var tempI64;
        function ExitStatus(status) {
          this.name = "ExitStatus";
          this.message = `Program terminated with exit(${status})`;
          this.status = status;
        }
        var terminateWorker = function(worker) {
          worker.terminate();
          worker.onmessage = (e) => {
          };
        };
        function killThread(pthread_ptr) {
          var worker = PThread.pthreads[pthread_ptr];
          delete PThread.pthreads[pthread_ptr];
          terminateWorker(worker);
          __emscripten_thread_free_data(pthread_ptr);
          PThread.runningWorkers.splice(PThread.runningWorkers.indexOf(worker), 1);
          worker.pthread_ptr = 0;
        }
        function cancelThread(pthread_ptr) {
          var worker = PThread.pthreads[pthread_ptr];
          worker.postMessage({ "cmd": "cancel" });
        }
        function cleanupThread(pthread_ptr) {
          var worker = PThread.pthreads[pthread_ptr];
          assert(worker);
          PThread.returnWorkerToPool(worker);
        }
        function spawnThread(threadParams) {
          var worker = PThread.getNewWorker();
          if (!worker) {
            return 6;
          }
          PThread.runningWorkers.push(worker);
          PThread.pthreads[threadParams.pthread_ptr] = worker;
          worker.pthread_ptr = threadParams.pthread_ptr;
          var msg = { "cmd": "run", "start_routine": threadParams.startRoutine, "arg": threadParams.arg, "pthread_ptr": threadParams.pthread_ptr };
          worker.postMessage(msg, threadParams.transferList);
          return 0;
        }
        var PATH = { isAbs: (path) => path.charAt(0) === "/", splitPath: (filename) => {
          var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
          return splitPathRe.exec(filename).slice(1);
        }, normalizeArray: (parts, allowAboveRoot) => {
          var up = 0;
          for (var i = parts.length - 1; i >= 0; i--) {
            var last = parts[i];
            if (last === ".") {
              parts.splice(i, 1);
            } else if (last === "..") {
              parts.splice(i, 1);
              up++;
            } else if (up) {
              parts.splice(i, 1);
              up--;
            }
          }
          if (allowAboveRoot) {
            for (; up; up--) {
              parts.unshift("..");
            }
          }
          return parts;
        }, normalize: (path) => {
          var isAbsolute = PATH.isAbs(path), trailingSlash = path.substr(-1) === "/";
          path = PATH.normalizeArray(path.split("/").filter((p) => !!p), !isAbsolute).join("/");
          if (!path && !isAbsolute) {
            path = ".";
          }
          if (path && trailingSlash) {
            path += "/";
          }
          return (isAbsolute ? "/" : "") + path;
        }, dirname: (path) => {
          var result = PATH.splitPath(path), root = result[0], dir = result[1];
          if (!root && !dir) {
            return ".";
          }
          if (dir) {
            dir = dir.substr(0, dir.length - 1);
          }
          return root + dir;
        }, basename: (path) => {
          if (path === "/") return "/";
          path = PATH.normalize(path);
          path = path.replace(/\/$/, "");
          var lastSlash = path.lastIndexOf("/");
          if (lastSlash === -1) return path;
          return path.substr(lastSlash + 1);
        }, join: function() {
          var paths = Array.prototype.slice.call(arguments);
          return PATH.normalize(paths.join("/"));
        }, join2: (l, r) => PATH.normalize(l + "/" + r) };
        var initRandomFill = () => {
          if (typeof crypto == "object" && typeof crypto["getRandomValues"] == "function") {
            return (view) => (view.set(crypto.getRandomValues(new Uint8Array(view.byteLength))), view);
          } else abort("initRandomDevice");
        };
        var randomFill = (view) => (randomFill = initRandomFill())(view);
        var PATH_FS = { resolve: function() {
          var resolvedPath = "", resolvedAbsolute = false;
          for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
            var path = i >= 0 ? arguments[i] : FS.cwd();
            if (typeof path != "string") {
              throw new TypeError("Arguments to path.resolve must be strings");
            } else if (!path) {
              return "";
            }
            resolvedPath = path + "/" + resolvedPath;
            resolvedAbsolute = PATH.isAbs(path);
          }
          resolvedPath = PATH.normalizeArray(resolvedPath.split("/").filter((p) => !!p), !resolvedAbsolute).join("/");
          return (resolvedAbsolute ? "/" : "") + resolvedPath || ".";
        }, relative: (from, to) => {
          from = PATH_FS.resolve(from).substr(1);
          to = PATH_FS.resolve(to).substr(1);
          function trim(arr) {
            var start = 0;
            for (; start < arr.length; start++) {
              if (arr[start] !== "") break;
            }
            var end = arr.length - 1;
            for (; end >= 0; end--) {
              if (arr[end] !== "") break;
            }
            if (start > end) return [];
            return arr.slice(start, end - start + 1);
          }
          var fromParts = trim(from.split("/"));
          var toParts = trim(to.split("/"));
          var length = Math.min(fromParts.length, toParts.length);
          var samePartsLength = length;
          for (var i = 0; i < length; i++) {
            if (fromParts[i] !== toParts[i]) {
              samePartsLength = i;
              break;
            }
          }
          var outputParts = [];
          for (var i = samePartsLength; i < fromParts.length; i++) {
            outputParts.push("..");
          }
          outputParts = outputParts.concat(toParts.slice(samePartsLength));
          return outputParts.join("/");
        } };
        var UTF8Decoder = typeof TextDecoder != "undefined" ? new TextDecoder("utf8") : void 0;
        var UTF8ArrayToString = (heapOrArray, idx, maxBytesToRead) => {
          idx >>>= 0;
          var endIdx = idx + maxBytesToRead;
          var endPtr = idx;
          while (heapOrArray[endPtr] && !(endPtr >= endIdx)) ++endPtr;
          if (endPtr - idx > 16 && heapOrArray.buffer && UTF8Decoder) {
            return UTF8Decoder.decode(heapOrArray.buffer instanceof SharedArrayBuffer ? heapOrArray.slice(idx, endPtr) : heapOrArray.subarray(idx, endPtr));
          }
          var str = "";
          while (idx < endPtr) {
            var u0 = heapOrArray[idx++];
            if (!(u0 & 128)) {
              str += String.fromCharCode(u0);
              continue;
            }
            var u1 = heapOrArray[idx++] & 63;
            if ((u0 & 224) == 192) {
              str += String.fromCharCode((u0 & 31) << 6 | u1);
              continue;
            }
            var u2 = heapOrArray[idx++] & 63;
            if ((u0 & 240) == 224) {
              u0 = (u0 & 15) << 12 | u1 << 6 | u2;
            } else {
              u0 = (u0 & 7) << 18 | u1 << 12 | u2 << 6 | heapOrArray[idx++] & 63;
            }
            if (u0 < 65536) {
              str += String.fromCharCode(u0);
            } else {
              var ch = u0 - 65536;
              str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023);
            }
          }
          return str;
        };
        var FS_stdin_getChar_buffer = [];
        var lengthBytesUTF8 = (str) => {
          var len = 0;
          for (var i = 0; i < str.length; ++i) {
            var c = str.charCodeAt(i);
            if (c <= 127) {
              len++;
            } else if (c <= 2047) {
              len += 2;
            } else if (c >= 55296 && c <= 57343) {
              len += 4;
              ++i;
            } else {
              len += 3;
            }
          }
          return len;
        };
        var stringToUTF8Array = (str, heap, outIdx, maxBytesToWrite) => {
          outIdx >>>= 0;
          if (!(maxBytesToWrite > 0)) return 0;
          var startIdx = outIdx;
          var endIdx = outIdx + maxBytesToWrite - 1;
          for (var i = 0; i < str.length; ++i) {
            var u = str.charCodeAt(i);
            if (u >= 55296 && u <= 57343) {
              var u1 = str.charCodeAt(++i);
              u = 65536 + ((u & 1023) << 10) | u1 & 1023;
            }
            if (u <= 127) {
              if (outIdx >= endIdx) break;
              heap[outIdx++ >>> 0] = u;
            } else if (u <= 2047) {
              if (outIdx + 1 >= endIdx) break;
              heap[outIdx++ >>> 0] = 192 | u >> 6;
              heap[outIdx++ >>> 0] = 128 | u & 63;
            } else if (u <= 65535) {
              if (outIdx + 2 >= endIdx) break;
              heap[outIdx++ >>> 0] = 224 | u >> 12;
              heap[outIdx++ >>> 0] = 128 | u >> 6 & 63;
              heap[outIdx++ >>> 0] = 128 | u & 63;
            } else {
              if (outIdx + 3 >= endIdx) break;
              heap[outIdx++ >>> 0] = 240 | u >> 18;
              heap[outIdx++ >>> 0] = 128 | u >> 12 & 63;
              heap[outIdx++ >>> 0] = 128 | u >> 6 & 63;
              heap[outIdx++ >>> 0] = 128 | u & 63;
            }
          }
          heap[outIdx >>> 0] = 0;
          return outIdx - startIdx;
        };
        function intArrayFromString(stringy, dontAddNull, length) {
          var len = length > 0 ? length : lengthBytesUTF8(stringy) + 1;
          var u8array = new Array(len);
          var numBytesWritten = stringToUTF8Array(stringy, u8array, 0, u8array.length);
          if (dontAddNull) u8array.length = numBytesWritten;
          return u8array;
        }
        var FS_stdin_getChar = () => {
          if (!FS_stdin_getChar_buffer.length) {
            var result = null;
            if (typeof window != "undefined" && typeof window.prompt == "function") {
              result = window.prompt("Input: ");
              if (result !== null) {
                result += "\n";
              }
            } else if (typeof readline == "function") {
              result = readline();
              if (result !== null) {
                result += "\n";
              }
            }
            if (!result) {
              return null;
            }
            FS_stdin_getChar_buffer = intArrayFromString(result, true);
          }
          return FS_stdin_getChar_buffer.shift();
        };
        var TTY = { ttys: [], init: function() {
        }, shutdown: function() {
        }, register: function(dev, ops) {
          TTY.ttys[dev] = { input: [], output: [], ops };
          FS.registerDevice(dev, TTY.stream_ops);
        }, stream_ops: { open: function(stream) {
          var tty = TTY.ttys[stream.node.rdev];
          if (!tty) {
            throw new FS.ErrnoError(43);
          }
          stream.tty = tty;
          stream.seekable = false;
        }, close: function(stream) {
          stream.tty.ops.fsync(stream.tty);
        }, fsync: function(stream) {
          stream.tty.ops.fsync(stream.tty);
        }, read: function(stream, buffer, offset, length, pos) {
          if (!stream.tty || !stream.tty.ops.get_char) {
            throw new FS.ErrnoError(60);
          }
          var bytesRead = 0;
          for (var i = 0; i < length; i++) {
            var result;
            try {
              result = stream.tty.ops.get_char(stream.tty);
            } catch (e) {
              throw new FS.ErrnoError(29);
            }
            if (result === void 0 && bytesRead === 0) {
              throw new FS.ErrnoError(6);
            }
            if (result === null || result === void 0) break;
            bytesRead++;
            buffer[offset + i] = result;
          }
          if (bytesRead) {
            stream.node.timestamp = Date.now();
          }
          return bytesRead;
        }, write: function(stream, buffer, offset, length, pos) {
          if (!stream.tty || !stream.tty.ops.put_char) {
            throw new FS.ErrnoError(60);
          }
          try {
            for (var i = 0; i < length; i++) {
              stream.tty.ops.put_char(stream.tty, buffer[offset + i]);
            }
          } catch (e) {
            throw new FS.ErrnoError(29);
          }
          if (length) {
            stream.node.timestamp = Date.now();
          }
          return i;
        } }, default_tty_ops: { get_char: function(tty) {
          return FS_stdin_getChar();
        }, put_char: function(tty, val) {
          if (val === null || val === 10) {
            out(UTF8ArrayToString(tty.output, 0));
            tty.output = [];
          } else {
            if (val != 0) tty.output.push(val);
          }
        }, fsync: function(tty) {
          if (tty.output && tty.output.length > 0) {
            out(UTF8ArrayToString(tty.output, 0));
            tty.output = [];
          }
        }, ioctl_tcgets: function(tty) {
          return { c_iflag: 25856, c_oflag: 5, c_cflag: 191, c_lflag: 35387, c_cc: [3, 28, 127, 21, 4, 0, 1, 0, 17, 19, 26, 0, 18, 15, 23, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] };
        }, ioctl_tcsets: function(tty, optional_actions, data) {
          return 0;
        }, ioctl_tiocgwinsz: function(tty) {
          return [24, 80];
        } }, default_tty1_ops: { put_char: function(tty, val) {
          if (val === null || val === 10) {
            err(UTF8ArrayToString(tty.output, 0));
            tty.output = [];
          } else {
            if (val != 0) tty.output.push(val);
          }
        }, fsync: function(tty) {
          if (tty.output && tty.output.length > 0) {
            err(UTF8ArrayToString(tty.output, 0));
            tty.output = [];
          }
        } } };
        var mmapAlloc = (size) => {
          abort();
        };
        var MEMFS = { ops_table: null, mount(mount) {
          return MEMFS.createNode(null, "/", 16384 | 511, 0);
        }, createNode(parent, name, mode, dev) {
          if (FS.isBlkdev(mode) || FS.isFIFO(mode)) {
            throw new FS.ErrnoError(63);
          }
          if (!MEMFS.ops_table) {
            MEMFS.ops_table = { dir: { node: { getattr: MEMFS.node_ops.getattr, setattr: MEMFS.node_ops.setattr, lookup: MEMFS.node_ops.lookup, mknod: MEMFS.node_ops.mknod, rename: MEMFS.node_ops.rename, unlink: MEMFS.node_ops.unlink, rmdir: MEMFS.node_ops.rmdir, readdir: MEMFS.node_ops.readdir, symlink: MEMFS.node_ops.symlink }, stream: { llseek: MEMFS.stream_ops.llseek } }, file: { node: { getattr: MEMFS.node_ops.getattr, setattr: MEMFS.node_ops.setattr }, stream: { llseek: MEMFS.stream_ops.llseek, read: MEMFS.stream_ops.read, write: MEMFS.stream_ops.write, allocate: MEMFS.stream_ops.allocate, mmap: MEMFS.stream_ops.mmap, msync: MEMFS.stream_ops.msync } }, link: { node: { getattr: MEMFS.node_ops.getattr, setattr: MEMFS.node_ops.setattr, readlink: MEMFS.node_ops.readlink }, stream: {} }, chrdev: { node: { getattr: MEMFS.node_ops.getattr, setattr: MEMFS.node_ops.setattr }, stream: FS.chrdev_stream_ops } };
          }
          var node = FS.createNode(parent, name, mode, dev);
          if (FS.isDir(node.mode)) {
            node.node_ops = MEMFS.ops_table.dir.node;
            node.stream_ops = MEMFS.ops_table.dir.stream;
            node.contents = {};
          } else if (FS.isFile(node.mode)) {
            node.node_ops = MEMFS.ops_table.file.node;
            node.stream_ops = MEMFS.ops_table.file.stream;
            node.usedBytes = 0;
            node.contents = null;
          } else if (FS.isLink(node.mode)) {
            node.node_ops = MEMFS.ops_table.link.node;
            node.stream_ops = MEMFS.ops_table.link.stream;
          } else if (FS.isChrdev(node.mode)) {
            node.node_ops = MEMFS.ops_table.chrdev.node;
            node.stream_ops = MEMFS.ops_table.chrdev.stream;
          }
          node.timestamp = Date.now();
          if (parent) {
            parent.contents[name] = node;
            parent.timestamp = node.timestamp;
          }
          return node;
        }, getFileDataAsTypedArray(node) {
          if (!node.contents) return new Uint8Array(0);
          if (node.contents.subarray) return node.contents.subarray(0, node.usedBytes);
          return new Uint8Array(node.contents);
        }, expandFileStorage(node, newCapacity) {
          var prevCapacity = node.contents ? node.contents.length : 0;
          if (prevCapacity >= newCapacity) return;
          var CAPACITY_DOUBLING_MAX = 1024 * 1024;
          newCapacity = Math.max(newCapacity, prevCapacity * (prevCapacity < CAPACITY_DOUBLING_MAX ? 2 : 1.125) >>> 0);
          if (prevCapacity != 0) newCapacity = Math.max(newCapacity, 256);
          var oldContents = node.contents;
          node.contents = new Uint8Array(newCapacity);
          if (node.usedBytes > 0) node.contents.set(oldContents.subarray(0, node.usedBytes), 0);
        }, resizeFileStorage(node, newSize) {
          if (node.usedBytes == newSize) return;
          if (newSize == 0) {
            node.contents = null;
            node.usedBytes = 0;
          } else {
            var oldContents = node.contents;
            node.contents = new Uint8Array(newSize);
            if (oldContents) {
              node.contents.set(oldContents.subarray(0, Math.min(newSize, node.usedBytes)));
            }
            node.usedBytes = newSize;
          }
        }, node_ops: { getattr(node) {
          var attr = {};
          attr.dev = FS.isChrdev(node.mode) ? node.id : 1;
          attr.ino = node.id;
          attr.mode = node.mode;
          attr.nlink = 1;
          attr.uid = 0;
          attr.gid = 0;
          attr.rdev = node.rdev;
          if (FS.isDir(node.mode)) {
            attr.size = 4096;
          } else if (FS.isFile(node.mode)) {
            attr.size = node.usedBytes;
          } else if (FS.isLink(node.mode)) {
            attr.size = node.link.length;
          } else {
            attr.size = 0;
          }
          attr.atime = new Date(node.timestamp);
          attr.mtime = new Date(node.timestamp);
          attr.ctime = new Date(node.timestamp);
          attr.blksize = 4096;
          attr.blocks = Math.ceil(attr.size / attr.blksize);
          return attr;
        }, setattr(node, attr) {
          if (attr.mode !== void 0) {
            node.mode = attr.mode;
          }
          if (attr.timestamp !== void 0) {
            node.timestamp = attr.timestamp;
          }
          if (attr.size !== void 0) {
            MEMFS.resizeFileStorage(node, attr.size);
          }
        }, lookup(parent, name) {
          throw FS.genericErrors[44];
        }, mknod(parent, name, mode, dev) {
          return MEMFS.createNode(parent, name, mode, dev);
        }, rename(old_node, new_dir, new_name) {
          if (FS.isDir(old_node.mode)) {
            var new_node;
            try {
              new_node = FS.lookupNode(new_dir, new_name);
            } catch (e) {
            }
            if (new_node) {
              for (var i in new_node.contents) {
                throw new FS.ErrnoError(55);
              }
            }
          }
          delete old_node.parent.contents[old_node.name];
          old_node.parent.timestamp = Date.now();
          old_node.name = new_name;
          new_dir.contents[new_name] = old_node;
          new_dir.timestamp = old_node.parent.timestamp;
          old_node.parent = new_dir;
        }, unlink(parent, name) {
          delete parent.contents[name];
          parent.timestamp = Date.now();
        }, rmdir(parent, name) {
          var node = FS.lookupNode(parent, name);
          for (var i in node.contents) {
            throw new FS.ErrnoError(55);
          }
          delete parent.contents[name];
          parent.timestamp = Date.now();
        }, readdir(node) {
          var entries = [".", ".."];
          for (var key in node.contents) {
            if (!node.contents.hasOwnProperty(key)) {
              continue;
            }
            entries.push(key);
          }
          return entries;
        }, symlink(parent, newname, oldpath) {
          var node = MEMFS.createNode(parent, newname, 511 | 40960, 0);
          node.link = oldpath;
          return node;
        }, readlink(node) {
          if (!FS.isLink(node.mode)) {
            throw new FS.ErrnoError(28);
          }
          return node.link;
        } }, stream_ops: { read(stream, buffer, offset, length, position) {
          var contents = stream.node.contents;
          if (position >= stream.node.usedBytes) return 0;
          var size = Math.min(stream.node.usedBytes - position, length);
          if (size > 8 && contents.subarray) {
            buffer.set(contents.subarray(position, position + size), offset);
          } else {
            for (var i = 0; i < size; i++) buffer[offset + i] = contents[position + i];
          }
          return size;
        }, write(stream, buffer, offset, length, position, canOwn) {
          if (buffer.buffer === GROWABLE_HEAP_I8().buffer) {
            canOwn = false;
          }
          if (!length) return 0;
          var node = stream.node;
          node.timestamp = Date.now();
          if (buffer.subarray && (!node.contents || node.contents.subarray)) {
            if (canOwn) {
              node.contents = buffer.subarray(offset, offset + length);
              node.usedBytes = length;
              return length;
            } else if (node.usedBytes === 0 && position === 0) {
              node.contents = buffer.slice(offset, offset + length);
              node.usedBytes = length;
              return length;
            } else if (position + length <= node.usedBytes) {
              node.contents.set(buffer.subarray(offset, offset + length), position);
              return length;
            }
          }
          MEMFS.expandFileStorage(node, position + length);
          if (node.contents.subarray && buffer.subarray) {
            node.contents.set(buffer.subarray(offset, offset + length), position);
          } else {
            for (var i = 0; i < length; i++) {
              node.contents[position + i] = buffer[offset + i];
            }
          }
          node.usedBytes = Math.max(node.usedBytes, position + length);
          return length;
        }, llseek(stream, offset, whence) {
          var position = offset;
          if (whence === 1) {
            position += stream.position;
          } else if (whence === 2) {
            if (FS.isFile(stream.node.mode)) {
              position += stream.node.usedBytes;
            }
          }
          if (position < 0) {
            throw new FS.ErrnoError(28);
          }
          return position;
        }, allocate(stream, offset, length) {
          MEMFS.expandFileStorage(stream.node, offset + length);
          stream.node.usedBytes = Math.max(stream.node.usedBytes, offset + length);
        }, mmap(stream, length, position, prot, flags) {
          if (!FS.isFile(stream.node.mode)) {
            throw new FS.ErrnoError(43);
          }
          var ptr;
          var allocated;
          var contents = stream.node.contents;
          if (!(flags & 2) && contents.buffer === GROWABLE_HEAP_I8().buffer) {
            allocated = false;
            ptr = contents.byteOffset;
          } else {
            if (position > 0 || position + length < contents.length) {
              if (contents.subarray) {
                contents = contents.subarray(position, position + length);
              } else {
                contents = Array.prototype.slice.call(contents, position, position + length);
              }
            }
            allocated = true;
            ptr = mmapAlloc(length);
            if (!ptr) {
              throw new FS.ErrnoError(48);
            }
            GROWABLE_HEAP_I8().set(contents, ptr >>> 0);
          }
          return { ptr, allocated };
        }, msync(stream, buffer, offset, length, mmapFlags) {
          MEMFS.stream_ops.write(stream, buffer, 0, length, offset, false);
          return 0;
        } } };
        var asyncLoad = (url, onload, onerror, noRunDep) => {
          var dep = !noRunDep ? getUniqueRunDependency(`al ${url}`) : "";
          readAsync(url, (arrayBuffer) => {
            assert(arrayBuffer, `Loading data file "${url}" failed (no arrayBuffer).`);
            onload(new Uint8Array(arrayBuffer));
            if (dep) removeRunDependency(dep);
          }, (event) => {
            if (onerror) {
              onerror();
            } else {
              throw `Loading data file "${url}" failed.`;
            }
          });
          if (dep) addRunDependency(dep);
        };
        var preloadPlugins = Module["preloadPlugins"] || [];
        function FS_handledByPreloadPlugin(byteArray, fullname, finish, onerror) {
          if (typeof Browser != "undefined") Browser.init();
          var handled = false;
          preloadPlugins.forEach(function(plugin) {
            if (handled) return;
            if (plugin["canHandle"](fullname)) {
              plugin["handle"](byteArray, fullname, finish, onerror);
              handled = true;
            }
          });
          return handled;
        }
        function FS_createPreloadedFile(parent, name, url, canRead, canWrite, onload, onerror, dontCreateFile, canOwn, preFinish) {
          var fullname = name ? PATH_FS.resolve(PATH.join2(parent, name)) : parent;
          var dep = getUniqueRunDependency(`cp ${fullname}`);
          function processData(byteArray) {
            function finish(byteArray2) {
              if (preFinish) preFinish();
              if (!dontCreateFile) {
                FS.createDataFile(parent, name, byteArray2, canRead, canWrite, canOwn);
              }
              if (onload) onload();
              removeRunDependency(dep);
            }
            if (FS_handledByPreloadPlugin(byteArray, fullname, finish, () => {
              if (onerror) onerror();
              removeRunDependency(dep);
            })) {
              return;
            }
            finish(byteArray);
          }
          addRunDependency(dep);
          if (typeof url == "string") {
            asyncLoad(url, (byteArray) => processData(byteArray), onerror);
          } else {
            processData(url);
          }
        }
        function FS_modeStringToFlags(str) {
          var flagModes = { "r": 0, "r+": 2, "w": 512 | 64 | 1, "w+": 512 | 64 | 2, "a": 1024 | 64 | 1, "a+": 1024 | 64 | 2 };
          var flags = flagModes[str];
          if (typeof flags == "undefined") {
            throw new Error(`Unknown file open mode: ${str}`);
          }
          return flags;
        }
        function FS_getMode(canRead, canWrite) {
          var mode = 0;
          if (canRead) mode |= 292 | 73;
          if (canWrite) mode |= 146;
          return mode;
        }
        var FS = { root: null, mounts: [], devices: {}, streams: [], nextInode: 1, nameTable: null, currentPath: "/", initialized: false, ignorePermissions: true, ErrnoError: null, genericErrors: {}, filesystems: null, syncFSRequests: 0, lookupPath: (path, opts = {}) => {
          path = PATH_FS.resolve(path);
          if (!path) return { path: "", node: null };
          var defaults = { follow_mount: true, recurse_count: 0 };
          opts = Object.assign(defaults, opts);
          if (opts.recurse_count > 8) {
            throw new FS.ErrnoError(32);
          }
          var parts = path.split("/").filter((p) => !!p);
          var current = FS.root;
          var current_path = "/";
          for (var i = 0; i < parts.length; i++) {
            var islast = i === parts.length - 1;
            if (islast && opts.parent) {
              break;
            }
            current = FS.lookupNode(current, parts[i]);
            current_path = PATH.join2(current_path, parts[i]);
            if (FS.isMountpoint(current)) {
              if (!islast || islast && opts.follow_mount) {
                current = current.mounted.root;
              }
            }
            if (!islast || opts.follow) {
              var count = 0;
              while (FS.isLink(current.mode)) {
                var link = FS.readlink(current_path);
                current_path = PATH_FS.resolve(PATH.dirname(current_path), link);
                var lookup = FS.lookupPath(current_path, { recurse_count: opts.recurse_count + 1 });
                current = lookup.node;
                if (count++ > 40) {
                  throw new FS.ErrnoError(32);
                }
              }
            }
          }
          return { path: current_path, node: current };
        }, getPath: (node) => {
          var path;
          while (true) {
            if (FS.isRoot(node)) {
              var mount = node.mount.mountpoint;
              if (!path) return mount;
              return mount[mount.length - 1] !== "/" ? `${mount}/${path}` : mount + path;
            }
            path = path ? `${node.name}/${path}` : node.name;
            node = node.parent;
          }
        }, hashName: (parentid, name) => {
          var hash = 0;
          for (var i = 0; i < name.length; i++) {
            hash = (hash << 5) - hash + name.charCodeAt(i) | 0;
          }
          return (parentid + hash >>> 0) % FS.nameTable.length;
        }, hashAddNode: (node) => {
          var hash = FS.hashName(node.parent.id, node.name);
          node.name_next = FS.nameTable[hash];
          FS.nameTable[hash] = node;
        }, hashRemoveNode: (node) => {
          var hash = FS.hashName(node.parent.id, node.name);
          if (FS.nameTable[hash] === node) {
            FS.nameTable[hash] = node.name_next;
          } else {
            var current = FS.nameTable[hash];
            while (current) {
              if (current.name_next === node) {
                current.name_next = node.name_next;
                break;
              }
              current = current.name_next;
            }
          }
        }, lookupNode: (parent, name) => {
          var errCode = FS.mayLookup(parent);
          if (errCode) {
            throw new FS.ErrnoError(errCode, parent);
          }
          var hash = FS.hashName(parent.id, name);
          for (var node = FS.nameTable[hash]; node; node = node.name_next) {
            var nodeName = node.name;
            if (node.parent.id === parent.id && nodeName === name) {
              return node;
            }
          }
          return FS.lookup(parent, name);
        }, createNode: (parent, name, mode, rdev) => {
          var node = new FS.FSNode(parent, name, mode, rdev);
          FS.hashAddNode(node);
          return node;
        }, destroyNode: (node) => {
          FS.hashRemoveNode(node);
        }, isRoot: (node) => node === node.parent, isMountpoint: (node) => !!node.mounted, isFile: (mode) => (mode & 61440) === 32768, isDir: (mode) => (mode & 61440) === 16384, isLink: (mode) => (mode & 61440) === 40960, isChrdev: (mode) => (mode & 61440) === 8192, isBlkdev: (mode) => (mode & 61440) === 24576, isFIFO: (mode) => (mode & 61440) === 4096, isSocket: (mode) => (mode & 49152) === 49152, flagsToPermissionString: (flag) => {
          var perms = ["r", "w", "rw"][flag & 3];
          if (flag & 512) {
            perms += "w";
          }
          return perms;
        }, nodePermissions: (node, perms) => {
          if (FS.ignorePermissions) {
            return 0;
          }
          if (perms.includes("r") && !(node.mode & 292)) {
            return 2;
          } else if (perms.includes("w") && !(node.mode & 146)) {
            return 2;
          } else if (perms.includes("x") && !(node.mode & 73)) {
            return 2;
          }
          return 0;
        }, mayLookup: (dir) => {
          var errCode = FS.nodePermissions(dir, "x");
          if (errCode) return errCode;
          if (!dir.node_ops.lookup) return 2;
          return 0;
        }, mayCreate: (dir, name) => {
          try {
            var node = FS.lookupNode(dir, name);
            return 20;
          } catch (e) {
          }
          return FS.nodePermissions(dir, "wx");
        }, mayDelete: (dir, name, isdir) => {
          var node;
          try {
            node = FS.lookupNode(dir, name);
          } catch (e) {
            return e.errno;
          }
          var errCode = FS.nodePermissions(dir, "wx");
          if (errCode) {
            return errCode;
          }
          if (isdir) {
            if (!FS.isDir(node.mode)) {
              return 54;
            }
            if (FS.isRoot(node) || FS.getPath(node) === FS.cwd()) {
              return 10;
            }
          } else {
            if (FS.isDir(node.mode)) {
              return 31;
            }
          }
          return 0;
        }, mayOpen: (node, flags) => {
          if (!node) {
            return 44;
          }
          if (FS.isLink(node.mode)) {
            return 32;
          } else if (FS.isDir(node.mode)) {
            if (FS.flagsToPermissionString(flags) !== "r" || flags & 512) {
              return 31;
            }
          }
          return FS.nodePermissions(node, FS.flagsToPermissionString(flags));
        }, MAX_OPEN_FDS: 4096, nextfd: () => {
          for (var fd = 0; fd <= FS.MAX_OPEN_FDS; fd++) {
            if (!FS.streams[fd]) {
              return fd;
            }
          }
          throw new FS.ErrnoError(33);
        }, getStreamChecked: (fd) => {
          var stream = FS.getStream(fd);
          if (!stream) {
            throw new FS.ErrnoError(8);
          }
          return stream;
        }, getStream: (fd) => FS.streams[fd], createStream: (stream, fd = -1) => {
          if (!FS.FSStream) {
            FS.FSStream = function() {
              this.shared = {};
            };
            FS.FSStream.prototype = {};
            Object.defineProperties(FS.FSStream.prototype, { object: { get() {
              return this.node;
            }, set(val) {
              this.node = val;
            } }, isRead: { get() {
              return (this.flags & 2097155) !== 1;
            } }, isWrite: { get() {
              return (this.flags & 2097155) !== 0;
            } }, isAppend: { get() {
              return this.flags & 1024;
            } }, flags: { get() {
              return this.shared.flags;
            }, set(val) {
              this.shared.flags = val;
            } }, position: { get() {
              return this.shared.position;
            }, set(val) {
              this.shared.position = val;
            } } });
          }
          stream = Object.assign(new FS.FSStream(), stream);
          if (fd == -1) {
            fd = FS.nextfd();
          }
          stream.fd = fd;
          FS.streams[fd] = stream;
          return stream;
        }, closeStream: (fd) => {
          FS.streams[fd] = null;
        }, chrdev_stream_ops: { open: (stream) => {
          var device = FS.getDevice(stream.node.rdev);
          stream.stream_ops = device.stream_ops;
          if (stream.stream_ops.open) {
            stream.stream_ops.open(stream);
          }
        }, llseek: () => {
          throw new FS.ErrnoError(70);
        } }, major: (dev) => dev >> 8, minor: (dev) => dev & 255, makedev: (ma, mi) => ma << 8 | mi, registerDevice: (dev, ops) => {
          FS.devices[dev] = { stream_ops: ops };
        }, getDevice: (dev) => FS.devices[dev], getMounts: (mount) => {
          var mounts = [];
          var check = [mount];
          while (check.length) {
            var m = check.pop();
            mounts.push(m);
            check.push.apply(check, m.mounts);
          }
          return mounts;
        }, syncfs: (populate, callback) => {
          if (typeof populate == "function") {
            callback = populate;
            populate = false;
          }
          FS.syncFSRequests++;
          if (FS.syncFSRequests > 1) {
            err(`warning: ${FS.syncFSRequests} FS.syncfs operations in flight at once, probably just doing extra work`);
          }
          var mounts = FS.getMounts(FS.root.mount);
          var completed = 0;
          function doCallback(errCode) {
            FS.syncFSRequests--;
            return callback(errCode);
          }
          function done(errCode) {
            if (errCode) {
              if (!done.errored) {
                done.errored = true;
                return doCallback(errCode);
              }
              return;
            }
            if (++completed >= mounts.length) {
              doCallback(null);
            }
          }
          mounts.forEach((mount) => {
            if (!mount.type.syncfs) {
              return done(null);
            }
            mount.type.syncfs(mount, populate, done);
          });
        }, mount: (type, opts, mountpoint) => {
          var root = mountpoint === "/";
          var pseudo = !mountpoint;
          var node;
          if (root && FS.root) {
            throw new FS.ErrnoError(10);
          } else if (!root && !pseudo) {
            var lookup = FS.lookupPath(mountpoint, { follow_mount: false });
            mountpoint = lookup.path;
            node = lookup.node;
            if (FS.isMountpoint(node)) {
              throw new FS.ErrnoError(10);
            }
            if (!FS.isDir(node.mode)) {
              throw new FS.ErrnoError(54);
            }
          }
          var mount = { type, opts, mountpoint, mounts: [] };
          var mountRoot = type.mount(mount);
          mountRoot.mount = mount;
          mount.root = mountRoot;
          if (root) {
            FS.root = mountRoot;
          } else if (node) {
            node.mounted = mount;
            if (node.mount) {
              node.mount.mounts.push(mount);
            }
          }
          return mountRoot;
        }, unmount: (mountpoint) => {
          var lookup = FS.lookupPath(mountpoint, { follow_mount: false });
          if (!FS.isMountpoint(lookup.node)) {
            throw new FS.ErrnoError(28);
          }
          var node = lookup.node;
          var mount = node.mounted;
          var mounts = FS.getMounts(mount);
          Object.keys(FS.nameTable).forEach((hash) => {
            var current = FS.nameTable[hash];
            while (current) {
              var next = current.name_next;
              if (mounts.includes(current.mount)) {
                FS.destroyNode(current);
              }
              current = next;
            }
          });
          node.mounted = null;
          var idx = node.mount.mounts.indexOf(mount);
          node.mount.mounts.splice(idx, 1);
        }, lookup: (parent, name) => parent.node_ops.lookup(parent, name), mknod: (path, mode, dev) => {
          var lookup = FS.lookupPath(path, { parent: true });
          var parent = lookup.node;
          var name = PATH.basename(path);
          if (!name || name === "." || name === "..") {
            throw new FS.ErrnoError(28);
          }
          var errCode = FS.mayCreate(parent, name);
          if (errCode) {
            throw new FS.ErrnoError(errCode);
          }
          if (!parent.node_ops.mknod) {
            throw new FS.ErrnoError(63);
          }
          return parent.node_ops.mknod(parent, name, mode, dev);
        }, create: (path, mode) => {
          mode = mode !== void 0 ? mode : 438;
          mode &= 4095;
          mode |= 32768;
          return FS.mknod(path, mode, 0);
        }, mkdir: (path, mode) => {
          mode = mode !== void 0 ? mode : 511;
          mode &= 511 | 512;
          mode |= 16384;
          return FS.mknod(path, mode, 0);
        }, mkdirTree: (path, mode) => {
          var dirs = path.split("/");
          var d = "";
          for (var i = 0; i < dirs.length; ++i) {
            if (!dirs[i]) continue;
            d += "/" + dirs[i];
            try {
              FS.mkdir(d, mode);
            } catch (e) {
              if (e.errno != 20) throw e;
            }
          }
        }, mkdev: (path, mode, dev) => {
          if (typeof dev == "undefined") {
            dev = mode;
            mode = 438;
          }
          mode |= 8192;
          return FS.mknod(path, mode, dev);
        }, symlink: (oldpath, newpath) => {
          if (!PATH_FS.resolve(oldpath)) {
            throw new FS.ErrnoError(44);
          }
          var lookup = FS.lookupPath(newpath, { parent: true });
          var parent = lookup.node;
          if (!parent) {
            throw new FS.ErrnoError(44);
          }
          var newname = PATH.basename(newpath);
          var errCode = FS.mayCreate(parent, newname);
          if (errCode) {
            throw new FS.ErrnoError(errCode);
          }
          if (!parent.node_ops.symlink) {
            throw new FS.ErrnoError(63);
          }
          return parent.node_ops.symlink(parent, newname, oldpath);
        }, rename: (old_path, new_path) => {
          var old_dirname = PATH.dirname(old_path);
          var new_dirname = PATH.dirname(new_path);
          var old_name = PATH.basename(old_path);
          var new_name = PATH.basename(new_path);
          var lookup, old_dir, new_dir;
          lookup = FS.lookupPath(old_path, { parent: true });
          old_dir = lookup.node;
          lookup = FS.lookupPath(new_path, { parent: true });
          new_dir = lookup.node;
          if (!old_dir || !new_dir) throw new FS.ErrnoError(44);
          if (old_dir.mount !== new_dir.mount) {
            throw new FS.ErrnoError(75);
          }
          var old_node = FS.lookupNode(old_dir, old_name);
          var relative = PATH_FS.relative(old_path, new_dirname);
          if (relative.charAt(0) !== ".") {
            throw new FS.ErrnoError(28);
          }
          relative = PATH_FS.relative(new_path, old_dirname);
          if (relative.charAt(0) !== ".") {
            throw new FS.ErrnoError(55);
          }
          var new_node;
          try {
            new_node = FS.lookupNode(new_dir, new_name);
          } catch (e) {
          }
          if (old_node === new_node) {
            return;
          }
          var isdir = FS.isDir(old_node.mode);
          var errCode = FS.mayDelete(old_dir, old_name, isdir);
          if (errCode) {
            throw new FS.ErrnoError(errCode);
          }
          errCode = new_node ? FS.mayDelete(new_dir, new_name, isdir) : FS.mayCreate(new_dir, new_name);
          if (errCode) {
            throw new FS.ErrnoError(errCode);
          }
          if (!old_dir.node_ops.rename) {
            throw new FS.ErrnoError(63);
          }
          if (FS.isMountpoint(old_node) || new_node && FS.isMountpoint(new_node)) {
            throw new FS.ErrnoError(10);
          }
          if (new_dir !== old_dir) {
            errCode = FS.nodePermissions(old_dir, "w");
            if (errCode) {
              throw new FS.ErrnoError(errCode);
            }
          }
          FS.hashRemoveNode(old_node);
          try {
            old_dir.node_ops.rename(old_node, new_dir, new_name);
          } catch (e) {
            throw e;
          } finally {
            FS.hashAddNode(old_node);
          }
        }, rmdir: (path) => {
          var lookup = FS.lookupPath(path, { parent: true });
          var parent = lookup.node;
          var name = PATH.basename(path);
          var node = FS.lookupNode(parent, name);
          var errCode = FS.mayDelete(parent, name, true);
          if (errCode) {
            throw new FS.ErrnoError(errCode);
          }
          if (!parent.node_ops.rmdir) {
            throw new FS.ErrnoError(63);
          }
          if (FS.isMountpoint(node)) {
            throw new FS.ErrnoError(10);
          }
          parent.node_ops.rmdir(parent, name);
          FS.destroyNode(node);
        }, readdir: (path) => {
          var lookup = FS.lookupPath(path, { follow: true });
          var node = lookup.node;
          if (!node.node_ops.readdir) {
            throw new FS.ErrnoError(54);
          }
          return node.node_ops.readdir(node);
        }, unlink: (path) => {
          var lookup = FS.lookupPath(path, { parent: true });
          var parent = lookup.node;
          if (!parent) {
            throw new FS.ErrnoError(44);
          }
          var name = PATH.basename(path);
          var node = FS.lookupNode(parent, name);
          var errCode = FS.mayDelete(parent, name, false);
          if (errCode) {
            throw new FS.ErrnoError(errCode);
          }
          if (!parent.node_ops.unlink) {
            throw new FS.ErrnoError(63);
          }
          if (FS.isMountpoint(node)) {
            throw new FS.ErrnoError(10);
          }
          parent.node_ops.unlink(parent, name);
          FS.destroyNode(node);
        }, readlink: (path) => {
          var lookup = FS.lookupPath(path);
          var link = lookup.node;
          if (!link) {
            throw new FS.ErrnoError(44);
          }
          if (!link.node_ops.readlink) {
            throw new FS.ErrnoError(28);
          }
          return PATH_FS.resolve(FS.getPath(link.parent), link.node_ops.readlink(link));
        }, stat: (path, dontFollow) => {
          var lookup = FS.lookupPath(path, { follow: !dontFollow });
          var node = lookup.node;
          if (!node) {
            throw new FS.ErrnoError(44);
          }
          if (!node.node_ops.getattr) {
            throw new FS.ErrnoError(63);
          }
          return node.node_ops.getattr(node);
        }, lstat: (path) => FS.stat(path, true), chmod: (path, mode, dontFollow) => {
          var node;
          if (typeof path == "string") {
            var lookup = FS.lookupPath(path, { follow: !dontFollow });
            node = lookup.node;
          } else {
            node = path;
          }
          if (!node.node_ops.setattr) {
            throw new FS.ErrnoError(63);
          }
          node.node_ops.setattr(node, { mode: mode & 4095 | node.mode & ~4095, timestamp: Date.now() });
        }, lchmod: (path, mode) => {
          FS.chmod(path, mode, true);
        }, fchmod: (fd, mode) => {
          var stream = FS.getStreamChecked(fd);
          FS.chmod(stream.node, mode);
        }, chown: (path, uid, gid, dontFollow) => {
          var node;
          if (typeof path == "string") {
            var lookup = FS.lookupPath(path, { follow: !dontFollow });
            node = lookup.node;
          } else {
            node = path;
          }
          if (!node.node_ops.setattr) {
            throw new FS.ErrnoError(63);
          }
          node.node_ops.setattr(node, { timestamp: Date.now() });
        }, lchown: (path, uid, gid) => {
          FS.chown(path, uid, gid, true);
        }, fchown: (fd, uid, gid) => {
          var stream = FS.getStreamChecked(fd);
          FS.chown(stream.node, uid, gid);
        }, truncate: (path, len) => {
          if (len < 0) {
            throw new FS.ErrnoError(28);
          }
          var node;
          if (typeof path == "string") {
            var lookup = FS.lookupPath(path, { follow: true });
            node = lookup.node;
          } else {
            node = path;
          }
          if (!node.node_ops.setattr) {
            throw new FS.ErrnoError(63);
          }
          if (FS.isDir(node.mode)) {
            throw new FS.ErrnoError(31);
          }
          if (!FS.isFile(node.mode)) {
            throw new FS.ErrnoError(28);
          }
          var errCode = FS.nodePermissions(node, "w");
          if (errCode) {
            throw new FS.ErrnoError(errCode);
          }
          node.node_ops.setattr(node, { size: len, timestamp: Date.now() });
        }, ftruncate: (fd, len) => {
          var stream = FS.getStreamChecked(fd);
          if ((stream.flags & 2097155) === 0) {
            throw new FS.ErrnoError(28);
          }
          FS.truncate(stream.node, len);
        }, utime: (path, atime, mtime) => {
          var lookup = FS.lookupPath(path, { follow: true });
          var node = lookup.node;
          node.node_ops.setattr(node, { timestamp: Math.max(atime, mtime) });
        }, open: (path, flags, mode) => {
          if (path === "") {
            throw new FS.ErrnoError(44);
          }
          flags = typeof flags == "string" ? FS_modeStringToFlags(flags) : flags;
          mode = typeof mode == "undefined" ? 438 : mode;
          if (flags & 64) {
            mode = mode & 4095 | 32768;
          } else {
            mode = 0;
          }
          var node;
          if (typeof path == "object") {
            node = path;
          } else {
            path = PATH.normalize(path);
            try {
              var lookup = FS.lookupPath(path, { follow: !(flags & 131072) });
              node = lookup.node;
            } catch (e) {
            }
          }
          var created = false;
          if (flags & 64) {
            if (node) {
              if (flags & 128) {
                throw new FS.ErrnoError(20);
              }
            } else {
              node = FS.mknod(path, mode, 0);
              created = true;
            }
          }
          if (!node) {
            throw new FS.ErrnoError(44);
          }
          if (FS.isChrdev(node.mode)) {
            flags &= ~512;
          }
          if (flags & 65536 && !FS.isDir(node.mode)) {
            throw new FS.ErrnoError(54);
          }
          if (!created) {
            var errCode = FS.mayOpen(node, flags);
            if (errCode) {
              throw new FS.ErrnoError(errCode);
            }
          }
          if (flags & 512 && !created) {
            FS.truncate(node, 0);
          }
          flags &= ~(128 | 512 | 131072);
          var stream = FS.createStream({ node, path: FS.getPath(node), flags, seekable: true, position: 0, stream_ops: node.stream_ops, ungotten: [], error: false });
          if (stream.stream_ops.open) {
            stream.stream_ops.open(stream);
          }
          if (Module["logReadFiles"] && !(flags & 1)) {
            if (!FS.readFiles) FS.readFiles = {};
            if (!(path in FS.readFiles)) {
              FS.readFiles[path] = 1;
            }
          }
          return stream;
        }, close: (stream) => {
          if (FS.isClosed(stream)) {
            throw new FS.ErrnoError(8);
          }
          if (stream.getdents) stream.getdents = null;
          try {
            if (stream.stream_ops.close) {
              stream.stream_ops.close(stream);
            }
          } catch (e) {
            throw e;
          } finally {
            FS.closeStream(stream.fd);
          }
          stream.fd = null;
        }, isClosed: (stream) => stream.fd === null, llseek: (stream, offset, whence) => {
          if (FS.isClosed(stream)) {
            throw new FS.ErrnoError(8);
          }
          if (!stream.seekable || !stream.stream_ops.llseek) {
            throw new FS.ErrnoError(70);
          }
          if (whence != 0 && whence != 1 && whence != 2) {
            throw new FS.ErrnoError(28);
          }
          stream.position = stream.stream_ops.llseek(stream, offset, whence);
          stream.ungotten = [];
          return stream.position;
        }, read: (stream, buffer, offset, length, position) => {
          if (length < 0 || position < 0) {
            throw new FS.ErrnoError(28);
          }
          if (FS.isClosed(stream)) {
            throw new FS.ErrnoError(8);
          }
          if ((stream.flags & 2097155) === 1) {
            throw new FS.ErrnoError(8);
          }
          if (FS.isDir(stream.node.mode)) {
            throw new FS.ErrnoError(31);
          }
          if (!stream.stream_ops.read) {
            throw new FS.ErrnoError(28);
          }
          var seeking = typeof position != "undefined";
          if (!seeking) {
            position = stream.position;
          } else if (!stream.seekable) {
            throw new FS.ErrnoError(70);
          }
          var bytesRead = stream.stream_ops.read(stream, buffer, offset, length, position);
          if (!seeking) stream.position += bytesRead;
          return bytesRead;
        }, write: (stream, buffer, offset, length, position, canOwn) => {
          if (length < 0 || position < 0) {
            throw new FS.ErrnoError(28);
          }
          if (FS.isClosed(stream)) {
            throw new FS.ErrnoError(8);
          }
          if ((stream.flags & 2097155) === 0) {
            throw new FS.ErrnoError(8);
          }
          if (FS.isDir(stream.node.mode)) {
            throw new FS.ErrnoError(31);
          }
          if (!stream.stream_ops.write) {
            throw new FS.ErrnoError(28);
          }
          if (stream.seekable && stream.flags & 1024) {
            FS.llseek(stream, 0, 2);
          }
          var seeking = typeof position != "undefined";
          if (!seeking) {
            position = stream.position;
          } else if (!stream.seekable) {
            throw new FS.ErrnoError(70);
          }
          var bytesWritten = stream.stream_ops.write(stream, buffer, offset, length, position, canOwn);
          if (!seeking) stream.position += bytesWritten;
          return bytesWritten;
        }, allocate: (stream, offset, length) => {
          if (FS.isClosed(stream)) {
            throw new FS.ErrnoError(8);
          }
          if (offset < 0 || length <= 0) {
            throw new FS.ErrnoError(28);
          }
          if ((stream.flags & 2097155) === 0) {
            throw new FS.ErrnoError(8);
          }
          if (!FS.isFile(stream.node.mode) && !FS.isDir(stream.node.mode)) {
            throw new FS.ErrnoError(43);
          }
          if (!stream.stream_ops.allocate) {
            throw new FS.ErrnoError(138);
          }
          stream.stream_ops.allocate(stream, offset, length);
        }, mmap: (stream, length, position, prot, flags) => {
          if ((prot & 2) !== 0 && (flags & 2) === 0 && (stream.flags & 2097155) !== 2) {
            throw new FS.ErrnoError(2);
          }
          if ((stream.flags & 2097155) === 1) {
            throw new FS.ErrnoError(2);
          }
          if (!stream.stream_ops.mmap) {
            throw new FS.ErrnoError(43);
          }
          return stream.stream_ops.mmap(stream, length, position, prot, flags);
        }, msync: (stream, buffer, offset, length, mmapFlags) => {
          if (!stream.stream_ops.msync) {
            return 0;
          }
          return stream.stream_ops.msync(stream, buffer, offset, length, mmapFlags);
        }, munmap: (stream) => 0, ioctl: (stream, cmd, arg) => {
          if (!stream.stream_ops.ioctl) {
            throw new FS.ErrnoError(59);
          }
          return stream.stream_ops.ioctl(stream, cmd, arg);
        }, readFile: (path, opts = {}) => {
          opts.flags = opts.flags || 0;
          opts.encoding = opts.encoding || "binary";
          if (opts.encoding !== "utf8" && opts.encoding !== "binary") {
            throw new Error(`Invalid encoding type "${opts.encoding}"`);
          }
          var ret;
          var stream = FS.open(path, opts.flags);
          var stat = FS.stat(path);
          var length = stat.size;
          var buf = new Uint8Array(length);
          FS.read(stream, buf, 0, length, 0);
          if (opts.encoding === "utf8") {
            ret = UTF8ArrayToString(buf, 0);
          } else if (opts.encoding === "binary") {
            ret = buf;
          }
          FS.close(stream);
          return ret;
        }, writeFile: (path, data, opts = {}) => {
          opts.flags = opts.flags || 577;
          var stream = FS.open(path, opts.flags, opts.mode);
          if (typeof data == "string") {
            var buf = new Uint8Array(lengthBytesUTF8(data) + 1);
            var actualNumBytes = stringToUTF8Array(data, buf, 0, buf.length);
            FS.write(stream, buf, 0, actualNumBytes, void 0, opts.canOwn);
          } else if (ArrayBuffer.isView(data)) {
            FS.write(stream, data, 0, data.byteLength, void 0, opts.canOwn);
          } else {
            throw new Error("Unsupported data type");
          }
          FS.close(stream);
        }, cwd: () => FS.currentPath, chdir: (path) => {
          var lookup = FS.lookupPath(path, { follow: true });
          if (lookup.node === null) {
            throw new FS.ErrnoError(44);
          }
          if (!FS.isDir(lookup.node.mode)) {
            throw new FS.ErrnoError(54);
          }
          var errCode = FS.nodePermissions(lookup.node, "x");
          if (errCode) {
            throw new FS.ErrnoError(errCode);
          }
          FS.currentPath = lookup.path;
        }, createDefaultDirectories: () => {
          FS.mkdir("/tmp");
          FS.mkdir("/home");
          FS.mkdir("/home/web_user");
        }, createDefaultDevices: () => {
          FS.mkdir("/dev");
          FS.registerDevice(FS.makedev(1, 3), { read: () => 0, write: (stream, buffer, offset, length, pos) => length });
          FS.mkdev("/dev/null", FS.makedev(1, 3));
          TTY.register(FS.makedev(5, 0), TTY.default_tty_ops);
          TTY.register(FS.makedev(6, 0), TTY.default_tty1_ops);
          FS.mkdev("/dev/tty", FS.makedev(5, 0));
          FS.mkdev("/dev/tty1", FS.makedev(6, 0));
          var randomBuffer = new Uint8Array(1024), randomLeft = 0;
          var randomByte = () => {
            if (randomLeft === 0) {
              randomLeft = randomFill(randomBuffer).byteLength;
            }
            return randomBuffer[--randomLeft];
          };
          FS.createDevice("/dev", "random", randomByte);
          FS.createDevice("/dev", "urandom", randomByte);
          FS.mkdir("/dev/shm");
          FS.mkdir("/dev/shm/tmp");
        }, createSpecialDirectories: () => {
          FS.mkdir("/proc");
          var proc_self = FS.mkdir("/proc/self");
          FS.mkdir("/proc/self/fd");
          FS.mount({ mount: () => {
            var node = FS.createNode(proc_self, "fd", 16384 | 511, 73);
            node.node_ops = { lookup: (parent, name) => {
              var fd = +name;
              var stream = FS.getStreamChecked(fd);
              var ret = { parent: null, mount: { mountpoint: "fake" }, node_ops: { readlink: () => stream.path } };
              ret.parent = ret;
              return ret;
            } };
            return node;
          } }, {}, "/proc/self/fd");
        }, createStandardStreams: () => {
          if (Module["stdin"]) {
            FS.createDevice("/dev", "stdin", Module["stdin"]);
          } else {
            FS.symlink("/dev/tty", "/dev/stdin");
          }
          if (Module["stdout"]) {
            FS.createDevice("/dev", "stdout", null, Module["stdout"]);
          } else {
            FS.symlink("/dev/tty", "/dev/stdout");
          }
          if (Module["stderr"]) {
            FS.createDevice("/dev", "stderr", null, Module["stderr"]);
          } else {
            FS.symlink("/dev/tty1", "/dev/stderr");
          }
          var stdin = FS.open("/dev/stdin", 0);
          var stdout = FS.open("/dev/stdout", 1);
          var stderr = FS.open("/dev/stderr", 1);
        }, ensureErrnoError: () => {
          if (FS.ErrnoError) return;
          FS.ErrnoError = function ErrnoError(errno, node) {
            this.name = "ErrnoError";
            this.node = node;
            this.setErrno = function(errno2) {
              this.errno = errno2;
            };
            this.setErrno(errno);
            this.message = "FS error";
          };
          FS.ErrnoError.prototype = new Error();
          FS.ErrnoError.prototype.constructor = FS.ErrnoError;
          [44].forEach((code) => {
            FS.genericErrors[code] = new FS.ErrnoError(code);
            FS.genericErrors[code].stack = "<generic error, no stack>";
          });
        }, staticInit: () => {
          FS.ensureErrnoError();
          FS.nameTable = new Array(4096);
          FS.mount(MEMFS, {}, "/");
          FS.createDefaultDirectories();
          FS.createDefaultDevices();
          FS.createSpecialDirectories();
          FS.filesystems = { "MEMFS": MEMFS };
        }, init: (input, output, error) => {
          FS.init.initialized = true;
          FS.ensureErrnoError();
          Module["stdin"] = input || Module["stdin"];
          Module["stdout"] = output || Module["stdout"];
          Module["stderr"] = error || Module["stderr"];
          FS.createStandardStreams();
        }, quit: () => {
          FS.init.initialized = false;
          for (var i = 0; i < FS.streams.length; i++) {
            var stream = FS.streams[i];
            if (!stream) {
              continue;
            }
            FS.close(stream);
          }
        }, findObject: (path, dontResolveLastLink) => {
          var ret = FS.analyzePath(path, dontResolveLastLink);
          if (!ret.exists) {
            return null;
          }
          return ret.object;
        }, analyzePath: (path, dontResolveLastLink) => {
          try {
            var lookup = FS.lookupPath(path, { follow: !dontResolveLastLink });
            path = lookup.path;
          } catch (e) {
          }
          var ret = { isRoot: false, exists: false, error: 0, name: null, path: null, object: null, parentExists: false, parentPath: null, parentObject: null };
          try {
            var lookup = FS.lookupPath(path, { parent: true });
            ret.parentExists = true;
            ret.parentPath = lookup.path;
            ret.parentObject = lookup.node;
            ret.name = PATH.basename(path);
            lookup = FS.lookupPath(path, { follow: !dontResolveLastLink });
            ret.exists = true;
            ret.path = lookup.path;
            ret.object = lookup.node;
            ret.name = lookup.node.name;
            ret.isRoot = lookup.path === "/";
          } catch (e) {
            ret.error = e.errno;
          }
          return ret;
        }, createPath: (parent, path, canRead, canWrite) => {
          parent = typeof parent == "string" ? parent : FS.getPath(parent);
          var parts = path.split("/").reverse();
          while (parts.length) {
            var part = parts.pop();
            if (!part) continue;
            var current = PATH.join2(parent, part);
            try {
              FS.mkdir(current);
            } catch (e) {
            }
            parent = current;
          }
          return current;
        }, createFile: (parent, name, properties, canRead, canWrite) => {
          var path = PATH.join2(typeof parent == "string" ? parent : FS.getPath(parent), name);
          var mode = FS_getMode(canRead, canWrite);
          return FS.create(path, mode);
        }, createDataFile: (parent, name, data, canRead, canWrite, canOwn) => {
          var path = name;
          if (parent) {
            parent = typeof parent == "string" ? parent : FS.getPath(parent);
            path = name ? PATH.join2(parent, name) : parent;
          }
          var mode = FS_getMode(canRead, canWrite);
          var node = FS.create(path, mode);
          if (data) {
            if (typeof data == "string") {
              var arr = new Array(data.length);
              for (var i = 0, len = data.length; i < len; ++i) arr[i] = data.charCodeAt(i);
              data = arr;
            }
            FS.chmod(node, mode | 146);
            var stream = FS.open(node, 577);
            FS.write(stream, data, 0, data.length, 0, canOwn);
            FS.close(stream);
            FS.chmod(node, mode);
          }
          return node;
        }, createDevice: (parent, name, input, output) => {
          var path = PATH.join2(typeof parent == "string" ? parent : FS.getPath(parent), name);
          var mode = FS_getMode(!!input, !!output);
          if (!FS.createDevice.major) FS.createDevice.major = 64;
          var dev = FS.makedev(FS.createDevice.major++, 0);
          FS.registerDevice(dev, { open: (stream) => {
            stream.seekable = false;
          }, close: (stream) => {
            if (output && output.buffer && output.buffer.length) {
              output(10);
            }
          }, read: (stream, buffer, offset, length, pos) => {
            var bytesRead = 0;
            for (var i = 0; i < length; i++) {
              var result;
              try {
                result = input();
              } catch (e) {
                throw new FS.ErrnoError(29);
              }
              if (result === void 0 && bytesRead === 0) {
                throw new FS.ErrnoError(6);
              }
              if (result === null || result === void 0) break;
              bytesRead++;
              buffer[offset + i] = result;
            }
            if (bytesRead) {
              stream.node.timestamp = Date.now();
            }
            return bytesRead;
          }, write: (stream, buffer, offset, length, pos) => {
            for (var i = 0; i < length; i++) {
              try {
                output(buffer[offset + i]);
              } catch (e) {
                throw new FS.ErrnoError(29);
              }
            }
            if (length) {
              stream.node.timestamp = Date.now();
            }
            return i;
          } });
          return FS.mkdev(path, mode, dev);
        }, forceLoadFile: (obj) => {
          if (obj.isDevice || obj.isFolder || obj.link || obj.contents) return true;
          if (typeof XMLHttpRequest != "undefined") {
            throw new Error("Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.");
          } else if (read_) {
            try {
              obj.contents = intArrayFromString(read_(obj.url), true);
              obj.usedBytes = obj.contents.length;
            } catch (e) {
              throw new FS.ErrnoError(29);
            }
          } else {
            throw new Error("Cannot load without read() or XMLHttpRequest.");
          }
        }, createLazyFile: (parent, name, url, canRead, canWrite) => {
          function LazyUint8Array() {
            this.lengthKnown = false;
            this.chunks = [];
          }
          LazyUint8Array.prototype.get = function LazyUint8Array_get(idx) {
            if (idx > this.length - 1 || idx < 0) {
              return void 0;
            }
            var chunkOffset = idx % this.chunkSize;
            var chunkNum = idx / this.chunkSize | 0;
            return this.getter(chunkNum)[chunkOffset];
          };
          LazyUint8Array.prototype.setDataGetter = function LazyUint8Array_setDataGetter(getter) {
            this.getter = getter;
          };
          LazyUint8Array.prototype.cacheLength = function LazyUint8Array_cacheLength() {
            var xhr = new XMLHttpRequest();
            xhr.open("HEAD", url, false);
            xhr.send(null);
            if (!(xhr.status >= 200 && xhr.status < 300 || xhr.status === 304)) throw new Error("Couldn't load " + url + ". Status: " + xhr.status);
            var datalength = Number(xhr.getResponseHeader("Content-length"));
            var header;
            var hasByteServing = (header = xhr.getResponseHeader("Accept-Ranges")) && header === "bytes";
            var usesGzip = (header = xhr.getResponseHeader("Content-Encoding")) && header === "gzip";
            var chunkSize = 1024 * 1024;
            if (!hasByteServing) chunkSize = datalength;
            var doXHR = (from, to) => {
              if (from > to) throw new Error("invalid range (" + from + ", " + to + ") or no bytes requested!");
              if (to > datalength - 1) throw new Error("only " + datalength + " bytes available! programmer error!");
              var xhr2 = new XMLHttpRequest();
              xhr2.open("GET", url, false);
              if (datalength !== chunkSize) xhr2.setRequestHeader("Range", "bytes=" + from + "-" + to);
              xhr2.responseType = "arraybuffer";
              if (xhr2.overrideMimeType) {
                xhr2.overrideMimeType("text/plain; charset=x-user-defined");
              }
              xhr2.send(null);
              if (!(xhr2.status >= 200 && xhr2.status < 300 || xhr2.status === 304)) throw new Error("Couldn't load " + url + ". Status: " + xhr2.status);
              if (xhr2.response !== void 0) {
                return new Uint8Array(xhr2.response || []);
              }
              return intArrayFromString(xhr2.responseText || "", true);
            };
            var lazyArray2 = this;
            lazyArray2.setDataGetter((chunkNum) => {
              var start = chunkNum * chunkSize;
              var end = (chunkNum + 1) * chunkSize - 1;
              end = Math.min(end, datalength - 1);
              if (typeof lazyArray2.chunks[chunkNum] == "undefined") {
                lazyArray2.chunks[chunkNum] = doXHR(start, end);
              }
              if (typeof lazyArray2.chunks[chunkNum] == "undefined") throw new Error("doXHR failed!");
              return lazyArray2.chunks[chunkNum];
            });
            if (usesGzip || !datalength) {
              chunkSize = datalength = 1;
              datalength = this.getter(0).length;
              chunkSize = datalength;
              out("LazyFiles on gzip forces download of the whole file when length is accessed");
            }
            this._length = datalength;
            this._chunkSize = chunkSize;
            this.lengthKnown = true;
          };
          if (typeof XMLHttpRequest != "undefined") {
            if (!ENVIRONMENT_IS_WORKER) throw "Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc";
            var lazyArray = new LazyUint8Array();
            Object.defineProperties(lazyArray, { length: { get: function() {
              if (!this.lengthKnown) {
                this.cacheLength();
              }
              return this._length;
            } }, chunkSize: { get: function() {
              if (!this.lengthKnown) {
                this.cacheLength();
              }
              return this._chunkSize;
            } } });
            var properties = { isDevice: false, contents: lazyArray };
          } else {
            var properties = { isDevice: false, url };
          }
          var node = FS.createFile(parent, name, properties, canRead, canWrite);
          if (properties.contents) {
            node.contents = properties.contents;
          } else if (properties.url) {
            node.contents = null;
            node.url = properties.url;
          }
          Object.defineProperties(node, { usedBytes: { get: function() {
            return this.contents.length;
          } } });
          var stream_ops = {};
          var keys = Object.keys(node.stream_ops);
          keys.forEach((key) => {
            var fn = node.stream_ops[key];
            stream_ops[key] = function forceLoadLazyFile() {
              FS.forceLoadFile(node);
              return fn.apply(null, arguments);
            };
          });
          function writeChunks(stream, buffer, offset, length, position) {
            var contents = stream.node.contents;
            if (position >= contents.length) return 0;
            var size = Math.min(contents.length - position, length);
            if (contents.slice) {
              for (var i = 0; i < size; i++) {
                buffer[offset + i] = contents[position + i];
              }
            } else {
              for (var i = 0; i < size; i++) {
                buffer[offset + i] = contents.get(position + i);
              }
            }
            return size;
          }
          stream_ops.read = (stream, buffer, offset, length, position) => {
            FS.forceLoadFile(node);
            return writeChunks(stream, buffer, offset, length, position);
          };
          stream_ops.mmap = (stream, length, position, prot, flags) => {
            FS.forceLoadFile(node);
            var ptr = mmapAlloc(length);
            if (!ptr) {
              throw new FS.ErrnoError(48);
            }
            writeChunks(stream, GROWABLE_HEAP_I8(), ptr, length, position);
            return { ptr, allocated: true };
          };
          node.stream_ops = stream_ops;
          return node;
        } };
        var UTF8ToString = (ptr, maxBytesToRead) => {
          ptr >>>= 0;
          return ptr ? UTF8ArrayToString(GROWABLE_HEAP_U8(), ptr, maxBytesToRead) : "";
        };
        var SYSCALLS = { DEFAULT_POLLMASK: 5, calculateAt: function(dirfd, path, allowEmpty) {
          if (PATH.isAbs(path)) {
            return path;
          }
          var dir;
          if (dirfd === -100) {
            dir = FS.cwd();
          } else {
            var dirstream = SYSCALLS.getStreamFromFD(dirfd);
            dir = dirstream.path;
          }
          if (path.length == 0) {
            if (!allowEmpty) {
              throw new FS.ErrnoError(44);
            }
            return dir;
          }
          return PATH.join2(dir, path);
        }, doStat: function(func, path, buf) {
          try {
            var stat = func(path);
          } catch (e) {
            if (e && e.node && PATH.normalize(path) !== PATH.normalize(FS.getPath(e.node))) {
              return -54;
            }
            throw e;
          }
          GROWABLE_HEAP_I32()[buf >>> 2] = stat.dev;
          GROWABLE_HEAP_I32()[buf + 4 >>> 2] = stat.mode;
          GROWABLE_HEAP_U32()[buf + 8 >>> 2] = stat.nlink;
          GROWABLE_HEAP_I32()[buf + 12 >>> 2] = stat.uid;
          GROWABLE_HEAP_I32()[buf + 16 >>> 2] = stat.gid;
          GROWABLE_HEAP_I32()[buf + 20 >>> 2] = stat.rdev;
          tempI64 = [stat.size >>> 0, (tempDouble = stat.size, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], GROWABLE_HEAP_I32()[buf + 24 >>> 2] = tempI64[0], GROWABLE_HEAP_I32()[buf + 28 >>> 2] = tempI64[1];
          GROWABLE_HEAP_I32()[buf + 32 >>> 2] = 4096;
          GROWABLE_HEAP_I32()[buf + 36 >>> 2] = stat.blocks;
          var atime = stat.atime.getTime();
          var mtime = stat.mtime.getTime();
          var ctime = stat.ctime.getTime();
          tempI64 = [Math.floor(atime / 1e3) >>> 0, (tempDouble = Math.floor(atime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], GROWABLE_HEAP_I32()[buf + 40 >>> 2] = tempI64[0], GROWABLE_HEAP_I32()[buf + 44 >>> 2] = tempI64[1];
          GROWABLE_HEAP_U32()[buf + 48 >>> 2] = atime % 1e3 * 1e3;
          tempI64 = [Math.floor(mtime / 1e3) >>> 0, (tempDouble = Math.floor(mtime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], GROWABLE_HEAP_I32()[buf + 56 >>> 2] = tempI64[0], GROWABLE_HEAP_I32()[buf + 60 >>> 2] = tempI64[1];
          GROWABLE_HEAP_U32()[buf + 64 >>> 2] = mtime % 1e3 * 1e3;
          tempI64 = [Math.floor(ctime / 1e3) >>> 0, (tempDouble = Math.floor(ctime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], GROWABLE_HEAP_I32()[buf + 72 >>> 2] = tempI64[0], GROWABLE_HEAP_I32()[buf + 76 >>> 2] = tempI64[1];
          GROWABLE_HEAP_U32()[buf + 80 >>> 2] = ctime % 1e3 * 1e3;
          tempI64 = [stat.ino >>> 0, (tempDouble = stat.ino, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], GROWABLE_HEAP_I32()[buf + 88 >>> 2] = tempI64[0], GROWABLE_HEAP_I32()[buf + 92 >>> 2] = tempI64[1];
          return 0;
        }, doMsync: function(addr, stream, len, flags, offset) {
          if (!FS.isFile(stream.node.mode)) {
            throw new FS.ErrnoError(43);
          }
          if (flags & 2) {
            return 0;
          }
          var buffer = GROWABLE_HEAP_U8().slice(addr, addr + len);
          FS.msync(stream, buffer, offset, len, flags);
        }, varargs: void 0, get() {
          SYSCALLS.varargs += 4;
          var ret = GROWABLE_HEAP_I32()[SYSCALLS.varargs - 4 >>> 2];
          return ret;
        }, getStr(ptr) {
          var ret = UTF8ToString(ptr);
          return ret;
        }, getStreamFromFD: function(fd) {
          var stream = FS.getStreamChecked(fd);
          return stream;
        } };
        function _proc_exit(code) {
          if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(1, 1, code);
          EXITSTATUS = code;
          if (!keepRuntimeAlive()) {
            PThread.terminateAllThreads();
            if (Module["onExit"]) Module["onExit"](code);
            ABORT = true;
          }
          quit_(code, new ExitStatus(code));
        }
        var exitJS = (status, implicit) => {
          EXITSTATUS = status;
          if (ENVIRONMENT_IS_PTHREAD) {
            exitOnMainThread(status);
            throw "unwind";
          }
          _proc_exit(status);
        };
        var _exit = exitJS;
        var handleException = (e) => {
          if (e instanceof ExitStatus || e == "unwind") {
            return EXITSTATUS;
          }
          quit_(1, e);
        };
        var PThread = { unusedWorkers: [], runningWorkers: [], tlsInitFunctions: [], pthreads: {}, init: function() {
          if (ENVIRONMENT_IS_PTHREAD) {
            PThread.initWorker();
          } else {
            PThread.initMainThread();
          }
        }, initMainThread: function() {
          var pthreadPoolSize = navigator.hardwareConcurrency;
          while (pthreadPoolSize--) {
            PThread.allocateUnusedWorker();
          }
          addOnPreRun(() => {
            addRunDependency("loading-workers");
            PThread.loadWasmModuleToAllWorkers(() => removeRunDependency("loading-workers"));
          });
        }, initWorker: function() {
          noExitRuntime = false;
        }, setExitStatus: function(status) {
          EXITSTATUS = status;
        }, terminateAllThreads__deps: ["$terminateWorker"], terminateAllThreads: function() {
          for (var worker of PThread.runningWorkers) {
            terminateWorker(worker);
          }
          for (var worker of PThread.unusedWorkers) {
            terminateWorker(worker);
          }
          PThread.unusedWorkers = [];
          PThread.runningWorkers = [];
          PThread.pthreads = [];
        }, returnWorkerToPool: function(worker) {
          var pthread_ptr = worker.pthread_ptr;
          delete PThread.pthreads[pthread_ptr];
          PThread.unusedWorkers.push(worker);
          PThread.runningWorkers.splice(PThread.runningWorkers.indexOf(worker), 1);
          worker.pthread_ptr = 0;
          __emscripten_thread_free_data(pthread_ptr);
        }, receiveObjectTransfer: function(data) {
        }, threadInitTLS: function() {
          PThread.tlsInitFunctions.forEach((f) => f());
        }, loadWasmModuleToWorker: (worker) => new Promise((onFinishedLoading) => {
          worker.onmessage = (e) => {
            var d = e["data"];
            var cmd = d["cmd"];
            if (d["targetThread"] && d["targetThread"] != _pthread_self()) {
              var targetWorker = PThread.pthreads[d.targetThread];
              if (targetWorker) {
                targetWorker.postMessage(d, d["transferList"]);
              } else {
                err('Internal error! Worker sent a message "' + cmd + '" to target pthread ' + d["targetThread"] + ", but that thread no longer exists!");
              }
              return;
            }
            if (cmd === "checkMailbox") {
              checkMailbox();
            } else if (cmd === "spawnThread") {
              spawnThread(d);
            } else if (cmd === "cleanupThread") {
              cleanupThread(d["thread"]);
            } else if (cmd === "killThread") {
              killThread(d["thread"]);
            } else if (cmd === "cancelThread") {
              cancelThread(d["thread"]);
            } else if (cmd === "loaded") {
              worker.loaded = true;
              onFinishedLoading(worker);
            } else if (cmd === "alert") {
              alert("Thread " + d["threadId"] + ": " + d["text"]);
            } else if (d.target === "setimmediate") {
              worker.postMessage(d);
            } else if (cmd === "callHandler") {
              Module[d["handler"]](...d["args"]);
            } else if (cmd) {
              err("worker sent an unknown command " + cmd);
            }
          };
          worker.onerror = (e) => {
            var message = "worker sent an error!";
            err(message + " " + e.filename + ":" + e.lineno + ": " + e.message);
            throw e;
          };
          var handlers = [];
          var knownHandlers = ["onExit", "onAbort", "print", "printErr"];
          for (var handler of knownHandlers) {
            if (Module.hasOwnProperty(handler)) {
              handlers.push(handler);
            }
          }
          worker.postMessage({ "cmd": "load", "handlers": handlers, "urlOrBlob": Module["mainScriptUrlOrBlob"] || _scriptDir, "wasmMemory": wasmMemory, "wasmModule": wasmModule });
        }), loadWasmModuleToAllWorkers: function(onMaybeReady) {
          if (ENVIRONMENT_IS_PTHREAD) {
            return onMaybeReady();
          }
          let pthreadPoolReady = Promise.all(PThread.unusedWorkers.map(PThread.loadWasmModuleToWorker));
          pthreadPoolReady.then(onMaybeReady);
        }, allocateUnusedWorker: function() {
          var worker;
          var pthreadMainJs = locateFile("web-ifc-mt.worker.js");
          worker = new Worker(pthreadMainJs);
          PThread.unusedWorkers.push(worker);
        }, getNewWorker: function() {
          if (PThread.unusedWorkers.length == 0) {
            PThread.allocateUnusedWorker();
            PThread.loadWasmModuleToWorker(PThread.unusedWorkers[0]);
          }
          return PThread.unusedWorkers.pop();
        } };
        Module["PThread"] = PThread;
        var callRuntimeCallbacks = (callbacks) => {
          while (callbacks.length > 0) {
            callbacks.shift()(Module);
          }
        };
        function establishStackSpace() {
          var pthread_ptr = _pthread_self();
          var stackHigh = GROWABLE_HEAP_I32()[pthread_ptr + 52 >>> 2];
          var stackSize = GROWABLE_HEAP_I32()[pthread_ptr + 56 >>> 2];
          var stackLow = stackHigh - stackSize;
          _emscripten_stack_set_limits(stackHigh, stackLow);
          stackRestore(stackHigh);
        }
        Module["establishStackSpace"] = establishStackSpace;
        function exitOnMainThread(returnCode) {
          if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(2, 0, returnCode);
          _exit(returnCode);
        }
        var wasmTableMirror = [];
        var getWasmTableEntry = (funcPtr) => {
          var func = wasmTableMirror[funcPtr];
          if (!func) {
            if (funcPtr >= wasmTableMirror.length) wasmTableMirror.length = funcPtr + 1;
            wasmTableMirror[funcPtr] = func = wasmTable.get(funcPtr);
          }
          return func;
        };
        function invokeEntryPoint(ptr, arg) {
          var result = getWasmTableEntry(ptr)(arg);
          function finish(result2) {
            if (keepRuntimeAlive()) {
              PThread.setExitStatus(result2);
            } else {
              __emscripten_thread_exit(result2);
            }
          }
          finish(result);
        }
        Module["invokeEntryPoint"] = invokeEntryPoint;
        function registerTLSInit(tlsInitFunc) {
          PThread.tlsInitFunctions.push(tlsInitFunc);
        }
        function ExceptionInfo(excPtr) {
          this.excPtr = excPtr;
          this.ptr = excPtr - 24;
          this.set_type = function(type) {
            GROWABLE_HEAP_U32()[this.ptr + 4 >>> 2] = type;
          };
          this.get_type = function() {
            return GROWABLE_HEAP_U32()[this.ptr + 4 >>> 2];
          };
          this.set_destructor = function(destructor) {
            GROWABLE_HEAP_U32()[this.ptr + 8 >>> 2] = destructor;
          };
          this.get_destructor = function() {
            return GROWABLE_HEAP_U32()[this.ptr + 8 >>> 2];
          };
          this.set_caught = function(caught) {
            caught = caught ? 1 : 0;
            GROWABLE_HEAP_I8()[this.ptr + 12 >>> 0] = caught;
          };
          this.get_caught = function() {
            return GROWABLE_HEAP_I8()[this.ptr + 12 >>> 0] != 0;
          };
          this.set_rethrown = function(rethrown) {
            rethrown = rethrown ? 1 : 0;
            GROWABLE_HEAP_I8()[this.ptr + 13 >>> 0] = rethrown;
          };
          this.get_rethrown = function() {
            return GROWABLE_HEAP_I8()[this.ptr + 13 >>> 0] != 0;
          };
          this.init = function(type, destructor) {
            this.set_adjusted_ptr(0);
            this.set_type(type);
            this.set_destructor(destructor);
          };
          this.set_adjusted_ptr = function(adjustedPtr) {
            GROWABLE_HEAP_U32()[this.ptr + 16 >>> 2] = adjustedPtr;
          };
          this.get_adjusted_ptr = function() {
            return GROWABLE_HEAP_U32()[this.ptr + 16 >>> 2];
          };
          this.get_exception_ptr = function() {
            var isPointer = ___cxa_is_pointer_type(this.get_type());
            if (isPointer) {
              return GROWABLE_HEAP_U32()[this.excPtr >>> 2];
            }
            var adjusted = this.get_adjusted_ptr();
            if (adjusted !== 0) return adjusted;
            return this.excPtr;
          };
        }
        var exceptionLast = 0;
        var uncaughtExceptionCount = 0;
        function convertI32PairToI53Checked(lo, hi) {
          return hi + 2097152 >>> 0 < 4194305 - !!lo ? (lo >>> 0) + hi * 4294967296 : NaN;
        }
        function ___cxa_throw(ptr, type, destructor) {
          ptr >>>= 0;
          type >>>= 0;
          destructor >>>= 0;
          var info = new ExceptionInfo(ptr);
          info.init(type, destructor);
          exceptionLast = ptr;
          uncaughtExceptionCount++;
          throw exceptionLast;
        }
        function ___emscripten_init_main_thread_js(tb) {
          tb >>>= 0;
          __emscripten_thread_init(tb, !ENVIRONMENT_IS_WORKER, 1, !ENVIRONMENT_IS_WEB, 5242880, false);
          PThread.threadInitTLS();
        }
        function ___emscripten_thread_cleanup(thread) {
          thread >>>= 0;
          if (!ENVIRONMENT_IS_PTHREAD) cleanupThread(thread);
          else postMessage({ "cmd": "cleanupThread", "thread": thread });
        }
        var tupleRegistrations = {};
        function runDestructors(destructors) {
          while (destructors.length) {
            var ptr = destructors.pop();
            var del = destructors.pop();
            del(ptr);
          }
        }
        function simpleReadValueFromPointer(pointer) {
          return this["fromWireType"](GROWABLE_HEAP_I32()[pointer >>> 2]);
        }
        var awaitingDependencies = {};
        var registeredTypes = {};
        var typeDependencies = {};
        var InternalError = void 0;
        function throwInternalError(message) {
          throw new InternalError(message);
        }
        function whenDependentTypesAreResolved(myTypes, dependentTypes, getTypeConverters) {
          myTypes.forEach(function(type) {
            typeDependencies[type] = dependentTypes;
          });
          function onComplete(typeConverters2) {
            var myTypeConverters = getTypeConverters(typeConverters2);
            if (myTypeConverters.length !== myTypes.length) {
              throwInternalError("Mismatched type converter count");
            }
            for (var i = 0; i < myTypes.length; ++i) {
              registerType(myTypes[i], myTypeConverters[i]);
            }
          }
          var typeConverters = new Array(dependentTypes.length);
          var unregisteredTypes = [];
          var registered = 0;
          dependentTypes.forEach((dt, i) => {
            if (registeredTypes.hasOwnProperty(dt)) {
              typeConverters[i] = registeredTypes[dt];
            } else {
              unregisteredTypes.push(dt);
              if (!awaitingDependencies.hasOwnProperty(dt)) {
                awaitingDependencies[dt] = [];
              }
              awaitingDependencies[dt].push(() => {
                typeConverters[i] = registeredTypes[dt];
                ++registered;
                if (registered === unregisteredTypes.length) {
                  onComplete(typeConverters);
                }
              });
            }
          });
          if (0 === unregisteredTypes.length) {
            onComplete(typeConverters);
          }
        }
        function __embind_finalize_value_array(rawTupleType) {
          rawTupleType >>>= 0;
          var reg = tupleRegistrations[rawTupleType];
          delete tupleRegistrations[rawTupleType];
          var elements = reg.elements;
          var elementsLength = elements.length;
          var elementTypes = elements.map(function(elt) {
            return elt.getterReturnType;
          }).concat(elements.map(function(elt) {
            return elt.setterArgumentType;
          }));
          var rawConstructor = reg.rawConstructor;
          var rawDestructor = reg.rawDestructor;
          whenDependentTypesAreResolved([rawTupleType], elementTypes, function(elementTypes2) {
            elements.forEach((elt, i) => {
              var getterReturnType = elementTypes2[i];
              var getter = elt.getter;
              var getterContext = elt.getterContext;
              var setterArgumentType = elementTypes2[i + elementsLength];
              var setter = elt.setter;
              var setterContext = elt.setterContext;
              elt.read = (ptr) => getterReturnType["fromWireType"](getter(getterContext, ptr));
              elt.write = (ptr, o) => {
                var destructors = [];
                setter(setterContext, ptr, setterArgumentType["toWireType"](destructors, o));
                runDestructors(destructors);
              };
            });
            return [{ name: reg.name, "fromWireType": function(ptr) {
              var rv = new Array(elementsLength);
              for (var i = 0; i < elementsLength; ++i) {
                rv[i] = elements[i].read(ptr);
              }
              rawDestructor(ptr);
              return rv;
            }, "toWireType": function(destructors, o) {
              if (elementsLength !== o.length) {
                throw new TypeError(`Incorrect number of tuple elements for ${reg.name}: expected=${elementsLength}, actual=${o.length}`);
              }
              var ptr = rawConstructor();
              for (var i = 0; i < elementsLength; ++i) {
                elements[i].write(ptr, o[i]);
              }
              if (destructors !== null) {
                destructors.push(rawDestructor, ptr);
              }
              return ptr;
            }, "argPackAdvance": 8, "readValueFromPointer": simpleReadValueFromPointer, destructorFunction: rawDestructor }];
          });
        }
        var structRegistrations = {};
        var __embind_finalize_value_object = function(structType) {
          structType >>>= 0;
          var reg = structRegistrations[structType];
          delete structRegistrations[structType];
          var rawConstructor = reg.rawConstructor;
          var rawDestructor = reg.rawDestructor;
          var fieldRecords = reg.fields;
          var fieldTypes = fieldRecords.map((field) => field.getterReturnType).concat(fieldRecords.map((field) => field.setterArgumentType));
          whenDependentTypesAreResolved([structType], fieldTypes, (fieldTypes2) => {
            var fields = {};
            fieldRecords.forEach((field, i) => {
              var fieldName = field.fieldName;
              var getterReturnType = fieldTypes2[i];
              var getter = field.getter;
              var getterContext = field.getterContext;
              var setterArgumentType = fieldTypes2[i + fieldRecords.length];
              var setter = field.setter;
              var setterContext = field.setterContext;
              fields[fieldName] = { read: (ptr) => getterReturnType["fromWireType"](getter(getterContext, ptr)), write: (ptr, o) => {
                var destructors = [];
                setter(setterContext, ptr, setterArgumentType["toWireType"](destructors, o));
                runDestructors(destructors);
              } };
            });
            return [{ name: reg.name, "fromWireType": function(ptr) {
              var rv = {};
              for (var i in fields) {
                rv[i] = fields[i].read(ptr);
              }
              rawDestructor(ptr);
              return rv;
            }, "toWireType": function(destructors, o) {
              for (var fieldName in fields) {
                if (!(fieldName in o)) {
                  throw new TypeError(`Missing field: "${fieldName}"`);
                }
              }
              var ptr = rawConstructor();
              for (fieldName in fields) {
                fields[fieldName].write(ptr, o[fieldName]);
              }
              if (destructors !== null) {
                destructors.push(rawDestructor, ptr);
              }
              return ptr;
            }, "argPackAdvance": 8, "readValueFromPointer": simpleReadValueFromPointer, destructorFunction: rawDestructor }];
          });
        };
        function __embind_register_bigint(primitiveType, name, size, minRange, maxRange) {
          primitiveType >>>= 0;
          name >>>= 0;
          size >>>= 0;
        }
        function getShiftFromSize(size) {
          switch (size) {
            case 1:
              return 0;
            case 2:
              return 1;
            case 4:
              return 2;
            case 8:
              return 3;
            default:
              throw new TypeError(`Unknown type size: ${size}`);
          }
        }
        function embind_init_charCodes() {
          var codes = new Array(256);
          for (var i = 0; i < 256; ++i) {
            codes[i] = String.fromCharCode(i);
          }
          embind_charCodes = codes;
        }
        var embind_charCodes = void 0;
        function readLatin1String(ptr) {
          var ret = "";
          var c = ptr;
          while (GROWABLE_HEAP_U8()[c >>> 0]) {
            ret += embind_charCodes[GROWABLE_HEAP_U8()[c++ >>> 0]];
          }
          return ret;
        }
        var BindingError = void 0;
        function throwBindingError(message) {
          throw new BindingError(message);
        }
        function sharedRegisterType(rawType, registeredInstance, options = {}) {
          var name = registeredInstance.name;
          if (!rawType) {
            throwBindingError(`type "${name}" must have a positive integer typeid pointer`);
          }
          if (registeredTypes.hasOwnProperty(rawType)) {
            if (options.ignoreDuplicateRegistrations) {
              return;
            } else {
              throwBindingError(`Cannot register type '${name}' twice`);
            }
          }
          registeredTypes[rawType] = registeredInstance;
          delete typeDependencies[rawType];
          if (awaitingDependencies.hasOwnProperty(rawType)) {
            var callbacks = awaitingDependencies[rawType];
            delete awaitingDependencies[rawType];
            callbacks.forEach((cb) => cb());
          }
        }
        function registerType(rawType, registeredInstance, options = {}) {
          if (!("argPackAdvance" in registeredInstance)) {
            throw new TypeError("registerType registeredInstance requires argPackAdvance");
          }
          return sharedRegisterType(rawType, registeredInstance, options);
        }
        function __embind_register_bool(rawType, name, size, trueValue, falseValue) {
          rawType >>>= 0;
          name >>>= 0;
          size >>>= 0;
          var shift = getShiftFromSize(size);
          name = readLatin1String(name);
          registerType(rawType, { name, "fromWireType": function(wt) {
            return !!wt;
          }, "toWireType": function(destructors, o) {
            return o ? trueValue : falseValue;
          }, "argPackAdvance": 8, "readValueFromPointer": function(pointer) {
            var heap;
            if (size === 1) {
              heap = GROWABLE_HEAP_I8();
            } else if (size === 2) {
              heap = GROWABLE_HEAP_I16();
            } else if (size === 4) {
              heap = GROWABLE_HEAP_I32();
            } else {
              throw new TypeError("Unknown boolean type size: " + name);
            }
            return this["fromWireType"](heap[pointer >>> shift]);
          }, destructorFunction: null });
        }
        function ClassHandle_isAliasOf(other) {
          if (!(this instanceof ClassHandle)) {
            return false;
          }
          if (!(other instanceof ClassHandle)) {
            return false;
          }
          var leftClass = this.$$.ptrType.registeredClass;
          var left = this.$$.ptr;
          var rightClass = other.$$.ptrType.registeredClass;
          var right = other.$$.ptr;
          while (leftClass.baseClass) {
            left = leftClass.upcast(left);
            leftClass = leftClass.baseClass;
          }
          while (rightClass.baseClass) {
            right = rightClass.upcast(right);
            rightClass = rightClass.baseClass;
          }
          return leftClass === rightClass && left === right;
        }
        function shallowCopyInternalPointer(o) {
          return { count: o.count, deleteScheduled: o.deleteScheduled, preservePointerOnDelete: o.preservePointerOnDelete, ptr: o.ptr, ptrType: o.ptrType, smartPtr: o.smartPtr, smartPtrType: o.smartPtrType };
        }
        function throwInstanceAlreadyDeleted(obj) {
          function getInstanceTypeName(handle) {
            return handle.$$.ptrType.registeredClass.name;
          }
          throwBindingError(getInstanceTypeName(obj) + " instance already deleted");
        }
        var finalizationRegistry = false;
        function detachFinalizer(handle) {
        }
        function runDestructor($$) {
          if ($$.smartPtr) {
            $$.smartPtrType.rawDestructor($$.smartPtr);
          } else {
            $$.ptrType.registeredClass.rawDestructor($$.ptr);
          }
        }
        function releaseClassHandle($$) {
          $$.count.value -= 1;
          var toDelete = 0 === $$.count.value;
          if (toDelete) {
            runDestructor($$);
          }
        }
        function downcastPointer(ptr, ptrClass, desiredClass) {
          if (ptrClass === desiredClass) {
            return ptr;
          }
          if (void 0 === desiredClass.baseClass) {
            return null;
          }
          var rv = downcastPointer(ptr, ptrClass, desiredClass.baseClass);
          if (rv === null) {
            return null;
          }
          return desiredClass.downcast(rv);
        }
        var registeredPointers = {};
        function getInheritedInstanceCount() {
          return Object.keys(registeredInstances).length;
        }
        function getLiveInheritedInstances() {
          var rv = [];
          for (var k in registeredInstances) {
            if (registeredInstances.hasOwnProperty(k)) {
              rv.push(registeredInstances[k]);
            }
          }
          return rv;
        }
        var deletionQueue = [];
        function flushPendingDeletes() {
          while (deletionQueue.length) {
            var obj = deletionQueue.pop();
            obj.$$.deleteScheduled = false;
            obj["delete"]();
          }
        }
        var delayFunction = void 0;
        function setDelayFunction(fn) {
          delayFunction = fn;
          if (deletionQueue.length && delayFunction) {
            delayFunction(flushPendingDeletes);
          }
        }
        function init_embind() {
          Module["getInheritedInstanceCount"] = getInheritedInstanceCount;
          Module["getLiveInheritedInstances"] = getLiveInheritedInstances;
          Module["flushPendingDeletes"] = flushPendingDeletes;
          Module["setDelayFunction"] = setDelayFunction;
        }
        var registeredInstances = {};
        function getBasestPointer(class_, ptr) {
          if (ptr === void 0) {
            throwBindingError("ptr should not be undefined");
          }
          while (class_.baseClass) {
            ptr = class_.upcast(ptr);
            class_ = class_.baseClass;
          }
          return ptr;
        }
        function getInheritedInstance(class_, ptr) {
          ptr = getBasestPointer(class_, ptr);
          return registeredInstances[ptr];
        }
        function makeClassHandle(prototype, record) {
          if (!record.ptrType || !record.ptr) {
            throwInternalError("makeClassHandle requires ptr and ptrType");
          }
          var hasSmartPtrType = !!record.smartPtrType;
          var hasSmartPtr = !!record.smartPtr;
          if (hasSmartPtrType !== hasSmartPtr) {
            throwInternalError("Both smartPtrType and smartPtr must be specified");
          }
          record.count = { value: 1 };
          return attachFinalizer(Object.create(prototype, { $$: { value: record } }));
        }
        function RegisteredPointer_fromWireType(ptr) {
          var rawPointer = this.getPointee(ptr);
          if (!rawPointer) {
            this.destructor(ptr);
            return null;
          }
          var registeredInstance = getInheritedInstance(this.registeredClass, rawPointer);
          if (void 0 !== registeredInstance) {
            if (0 === registeredInstance.$$.count.value) {
              registeredInstance.$$.ptr = rawPointer;
              registeredInstance.$$.smartPtr = ptr;
              return registeredInstance["clone"]();
            } else {
              var rv = registeredInstance["clone"]();
              this.destructor(ptr);
              return rv;
            }
          }
          function makeDefaultHandle() {
            if (this.isSmartPointer) {
              return makeClassHandle(this.registeredClass.instancePrototype, { ptrType: this.pointeeType, ptr: rawPointer, smartPtrType: this, smartPtr: ptr });
            } else {
              return makeClassHandle(this.registeredClass.instancePrototype, { ptrType: this, ptr });
            }
          }
          var actualType = this.registeredClass.getActualType(rawPointer);
          var registeredPointerRecord = registeredPointers[actualType];
          if (!registeredPointerRecord) {
            return makeDefaultHandle.call(this);
          }
          var toType;
          if (this.isConst) {
            toType = registeredPointerRecord.constPointerType;
          } else {
            toType = registeredPointerRecord.pointerType;
          }
          var dp = downcastPointer(rawPointer, this.registeredClass, toType.registeredClass);
          if (dp === null) {
            return makeDefaultHandle.call(this);
          }
          if (this.isSmartPointer) {
            return makeClassHandle(toType.registeredClass.instancePrototype, { ptrType: toType, ptr: dp, smartPtrType: this, smartPtr: ptr });
          } else {
            return makeClassHandle(toType.registeredClass.instancePrototype, { ptrType: toType, ptr: dp });
          }
        }
        var attachFinalizer = function(handle) {
          if ("undefined" === typeof FinalizationRegistry) {
            attachFinalizer = (handle2) => handle2;
            return handle;
          }
          finalizationRegistry = new FinalizationRegistry((info) => {
            releaseClassHandle(info.$$);
          });
          attachFinalizer = (handle2) => {
            var $$ = handle2.$$;
            var hasSmartPtr = !!$$.smartPtr;
            if (hasSmartPtr) {
              var info = { $$ };
              finalizationRegistry.register(handle2, info, handle2);
            }
            return handle2;
          };
          detachFinalizer = (handle2) => finalizationRegistry.unregister(handle2);
          return attachFinalizer(handle);
        };
        function ClassHandle_clone() {
          if (!this.$$.ptr) {
            throwInstanceAlreadyDeleted(this);
          }
          if (this.$$.preservePointerOnDelete) {
            this.$$.count.value += 1;
            return this;
          } else {
            var clone = attachFinalizer(Object.create(Object.getPrototypeOf(this), { $$: { value: shallowCopyInternalPointer(this.$$) } }));
            clone.$$.count.value += 1;
            clone.$$.deleteScheduled = false;
            return clone;
          }
        }
        function ClassHandle_delete() {
          if (!this.$$.ptr) {
            throwInstanceAlreadyDeleted(this);
          }
          if (this.$$.deleteScheduled && !this.$$.preservePointerOnDelete) {
            throwBindingError("Object already scheduled for deletion");
          }
          detachFinalizer(this);
          releaseClassHandle(this.$$);
          if (!this.$$.preservePointerOnDelete) {
            this.$$.smartPtr = void 0;
            this.$$.ptr = void 0;
          }
        }
        function ClassHandle_isDeleted() {
          return !this.$$.ptr;
        }
        function ClassHandle_deleteLater() {
          if (!this.$$.ptr) {
            throwInstanceAlreadyDeleted(this);
          }
          if (this.$$.deleteScheduled && !this.$$.preservePointerOnDelete) {
            throwBindingError("Object already scheduled for deletion");
          }
          deletionQueue.push(this);
          if (deletionQueue.length === 1 && delayFunction) {
            delayFunction(flushPendingDeletes);
          }
          this.$$.deleteScheduled = true;
          return this;
        }
        function init_ClassHandle() {
          ClassHandle.prototype["isAliasOf"] = ClassHandle_isAliasOf;
          ClassHandle.prototype["clone"] = ClassHandle_clone;
          ClassHandle.prototype["delete"] = ClassHandle_delete;
          ClassHandle.prototype["isDeleted"] = ClassHandle_isDeleted;
          ClassHandle.prototype["deleteLater"] = ClassHandle_deleteLater;
        }
        function ClassHandle() {
        }
        var char_0 = 48;
        var char_9 = 57;
        function makeLegalFunctionName(name) {
          if (void 0 === name) {
            return "_unknown";
          }
          name = name.replace(/[^a-zA-Z0-9_]/g, "$");
          var f = name.charCodeAt(0);
          if (f >= char_0 && f <= char_9) {
            return `_${name}`;
          }
          return name;
        }
        function createNamedFunction(name, body) {
          name = makeLegalFunctionName(name);
          return { [name]: function() {
            return body.apply(this, arguments);
          } }[name];
        }
        function ensureOverloadTable(proto, methodName, humanName) {
          if (void 0 === proto[methodName].overloadTable) {
            var prevFunc = proto[methodName];
            proto[methodName] = function() {
              if (!proto[methodName].overloadTable.hasOwnProperty(arguments.length)) {
                throwBindingError(`Function '${humanName}' called with an invalid number of arguments (${arguments.length}) - expects one of (${proto[methodName].overloadTable})!`);
              }
              return proto[methodName].overloadTable[arguments.length].apply(this, arguments);
            };
            proto[methodName].overloadTable = [];
            proto[methodName].overloadTable[prevFunc.argCount] = prevFunc;
          }
        }
        function exposePublicSymbol(name, value, numArguments) {
          if (Module.hasOwnProperty(name)) {
            if (void 0 === numArguments || void 0 !== Module[name].overloadTable && void 0 !== Module[name].overloadTable[numArguments]) {
              throwBindingError(`Cannot register public name '${name}' twice`);
            }
            ensureOverloadTable(Module, name, name);
            if (Module.hasOwnProperty(numArguments)) {
              throwBindingError(`Cannot register multiple overloads of a function with the same number of arguments (${numArguments})!`);
            }
            Module[name].overloadTable[numArguments] = value;
          } else {
            Module[name] = value;
            if (void 0 !== numArguments) {
              Module[name].numArguments = numArguments;
            }
          }
        }
        function RegisteredClass(name, constructor, instancePrototype, rawDestructor, baseClass, getActualType, upcast, downcast) {
          this.name = name;
          this.constructor = constructor;
          this.instancePrototype = instancePrototype;
          this.rawDestructor = rawDestructor;
          this.baseClass = baseClass;
          this.getActualType = getActualType;
          this.upcast = upcast;
          this.downcast = downcast;
          this.pureVirtualFunctions = [];
        }
        function upcastPointer(ptr, ptrClass, desiredClass) {
          while (ptrClass !== desiredClass) {
            if (!ptrClass.upcast) {
              throwBindingError(`Expected null or instance of ${desiredClass.name}, got an instance of ${ptrClass.name}`);
            }
            ptr = ptrClass.upcast(ptr);
            ptrClass = ptrClass.baseClass;
          }
          return ptr;
        }
        function constNoSmartPtrRawPointerToWireType(destructors, handle) {
          if (handle === null) {
            if (this.isReference) {
              throwBindingError(`null is not a valid ${this.name}`);
            }
            return 0;
          }
          if (!handle.$$) {
            throwBindingError(`Cannot pass "${embindRepr(handle)}" as a ${this.name}`);
          }
          if (!handle.$$.ptr) {
            throwBindingError(`Cannot pass deleted object as a pointer of type ${this.name}`);
          }
          var handleClass = handle.$$.ptrType.registeredClass;
          var ptr = upcastPointer(handle.$$.ptr, handleClass, this.registeredClass);
          return ptr;
        }
        function genericPointerToWireType(destructors, handle) {
          var ptr;
          if (handle === null) {
            if (this.isReference) {
              throwBindingError(`null is not a valid ${this.name}`);
            }
            if (this.isSmartPointer) {
              ptr = this.rawConstructor();
              if (destructors !== null) {
                destructors.push(this.rawDestructor, ptr);
              }
              return ptr;
            } else {
              return 0;
            }
          }
          if (!handle.$$) {
            throwBindingError(`Cannot pass "${embindRepr(handle)}" as a ${this.name}`);
          }
          if (!handle.$$.ptr) {
            throwBindingError(`Cannot pass deleted object as a pointer of type ${this.name}`);
          }
          if (!this.isConst && handle.$$.ptrType.isConst) {
            throwBindingError(`Cannot convert argument of type ${handle.$$.smartPtrType ? handle.$$.smartPtrType.name : handle.$$.ptrType.name} to parameter type ${this.name}`);
          }
          var handleClass = handle.$$.ptrType.registeredClass;
          ptr = upcastPointer(handle.$$.ptr, handleClass, this.registeredClass);
          if (this.isSmartPointer) {
            if (void 0 === handle.$$.smartPtr) {
              throwBindingError("Passing raw pointer to smart pointer is illegal");
            }
            switch (this.sharingPolicy) {
              case 0:
                if (handle.$$.smartPtrType === this) {
                  ptr = handle.$$.smartPtr;
                } else {
                  throwBindingError(`Cannot convert argument of type ${handle.$$.smartPtrType ? handle.$$.smartPtrType.name : handle.$$.ptrType.name} to parameter type ${this.name}`);
                }
                break;
              case 1:
                ptr = handle.$$.smartPtr;
                break;
              case 2:
                if (handle.$$.smartPtrType === this) {
                  ptr = handle.$$.smartPtr;
                } else {
                  var clonedHandle = handle["clone"]();
                  ptr = this.rawShare(ptr, Emval.toHandle(function() {
                    clonedHandle["delete"]();
                  }));
                  if (destructors !== null) {
                    destructors.push(this.rawDestructor, ptr);
                  }
                }
                break;
              default:
                throwBindingError("Unsupporting sharing policy");
            }
          }
          return ptr;
        }
        function nonConstNoSmartPtrRawPointerToWireType(destructors, handle) {
          if (handle === null) {
            if (this.isReference) {
              throwBindingError(`null is not a valid ${this.name}`);
            }
            return 0;
          }
          if (!handle.$$) {
            throwBindingError(`Cannot pass "${embindRepr(handle)}" as a ${this.name}`);
          }
          if (!handle.$$.ptr) {
            throwBindingError(`Cannot pass deleted object as a pointer of type ${this.name}`);
          }
          if (handle.$$.ptrType.isConst) {
            throwBindingError(`Cannot convert argument of type ${handle.$$.ptrType.name} to parameter type ${this.name}`);
          }
          var handleClass = handle.$$.ptrType.registeredClass;
          var ptr = upcastPointer(handle.$$.ptr, handleClass, this.registeredClass);
          return ptr;
        }
        function RegisteredPointer_getPointee(ptr) {
          if (this.rawGetPointee) {
            ptr = this.rawGetPointee(ptr);
          }
          return ptr;
        }
        function RegisteredPointer_destructor(ptr) {
          if (this.rawDestructor) {
            this.rawDestructor(ptr);
          }
        }
        function RegisteredPointer_deleteObject(handle) {
          if (handle !== null) {
            handle["delete"]();
          }
        }
        function init_RegisteredPointer() {
          RegisteredPointer.prototype.getPointee = RegisteredPointer_getPointee;
          RegisteredPointer.prototype.destructor = RegisteredPointer_destructor;
          RegisteredPointer.prototype["argPackAdvance"] = 8;
          RegisteredPointer.prototype["readValueFromPointer"] = simpleReadValueFromPointer;
          RegisteredPointer.prototype["deleteObject"] = RegisteredPointer_deleteObject;
          RegisteredPointer.prototype["fromWireType"] = RegisteredPointer_fromWireType;
        }
        function RegisteredPointer(name, registeredClass, isReference, isConst, isSmartPointer, pointeeType, sharingPolicy, rawGetPointee, rawConstructor, rawShare, rawDestructor) {
          this.name = name;
          this.registeredClass = registeredClass;
          this.isReference = isReference;
          this.isConst = isConst;
          this.isSmartPointer = isSmartPointer;
          this.pointeeType = pointeeType;
          this.sharingPolicy = sharingPolicy;
          this.rawGetPointee = rawGetPointee;
          this.rawConstructor = rawConstructor;
          this.rawShare = rawShare;
          this.rawDestructor = rawDestructor;
          if (!isSmartPointer && registeredClass.baseClass === void 0) {
            if (isConst) {
              this["toWireType"] = constNoSmartPtrRawPointerToWireType;
              this.destructorFunction = null;
            } else {
              this["toWireType"] = nonConstNoSmartPtrRawPointerToWireType;
              this.destructorFunction = null;
            }
          } else {
            this["toWireType"] = genericPointerToWireType;
          }
        }
        function replacePublicSymbol(name, value, numArguments) {
          if (!Module.hasOwnProperty(name)) {
            throwInternalError("Replacing nonexistant public symbol");
          }
          if (void 0 !== Module[name].overloadTable && void 0 !== numArguments) {
            Module[name].overloadTable[numArguments] = value;
          } else {
            Module[name] = value;
            Module[name].argCount = numArguments;
          }
        }
        var dynCallLegacy = (sig, ptr, args) => {
          var f = Module["dynCall_" + sig];
          return args && args.length ? f.apply(null, [ptr].concat(args)) : f.call(null, ptr);
        };
        var dynCall = (sig, ptr, args) => {
          if (sig.includes("j")) {
            return dynCallLegacy(sig, ptr, args);
          }
          var rtn = getWasmTableEntry(ptr).apply(null, args);
          return rtn;
        };
        var getDynCaller = (sig, ptr) => {
          var argCache = [];
          return function() {
            argCache.length = 0;
            Object.assign(argCache, arguments);
            return dynCall(sig, ptr, argCache);
          };
        };
        function embind__requireFunction(signature, rawFunction) {
          signature = readLatin1String(signature);
          function makeDynCaller() {
            if (signature.includes("j")) {
              return getDynCaller(signature, rawFunction);
            }
            return getWasmTableEntry(rawFunction);
          }
          var fp = makeDynCaller();
          if (typeof fp != "function") {
            throwBindingError(`unknown function pointer with signature ${signature}: ${rawFunction}`);
          }
          return fp;
        }
        function extendError(baseErrorType, errorName) {
          var errorClass = createNamedFunction(errorName, function(message) {
            this.name = errorName;
            this.message = message;
            var stack = new Error(message).stack;
            if (stack !== void 0) {
              this.stack = this.toString() + "\n" + stack.replace(/^Error(:[^\n]*)?\n/, "");
            }
          });
          errorClass.prototype = Object.create(baseErrorType.prototype);
          errorClass.prototype.constructor = errorClass;
          errorClass.prototype.toString = function() {
            if (this.message === void 0) {
              return this.name;
            } else {
              return `${this.name}: ${this.message}`;
            }
          };
          return errorClass;
        }
        var UnboundTypeError = void 0;
        function getTypeName(type) {
          var ptr = ___getTypeName(type);
          var rv = readLatin1String(ptr);
          _free(ptr);
          return rv;
        }
        function throwUnboundTypeError(message, types) {
          var unboundTypes = [];
          var seen = {};
          function visit(type) {
            if (seen[type]) {
              return;
            }
            if (registeredTypes[type]) {
              return;
            }
            if (typeDependencies[type]) {
              typeDependencies[type].forEach(visit);
              return;
            }
            unboundTypes.push(type);
            seen[type] = true;
          }
          types.forEach(visit);
          throw new UnboundTypeError(`${message}: ` + unboundTypes.map(getTypeName).join([", "]));
        }
        function __embind_register_class(rawType, rawPointerType, rawConstPointerType, baseClassRawType, getActualTypeSignature, getActualType, upcastSignature, upcast, downcastSignature, downcast, name, destructorSignature, rawDestructor) {
          rawType >>>= 0;
          rawPointerType >>>= 0;
          rawConstPointerType >>>= 0;
          baseClassRawType >>>= 0;
          getActualTypeSignature >>>= 0;
          getActualType >>>= 0;
          upcastSignature >>>= 0;
          upcast >>>= 0;
          downcastSignature >>>= 0;
          downcast >>>= 0;
          name >>>= 0;
          destructorSignature >>>= 0;
          rawDestructor >>>= 0;
          name = readLatin1String(name);
          getActualType = embind__requireFunction(getActualTypeSignature, getActualType);
          if (upcast) {
            upcast = embind__requireFunction(upcastSignature, upcast);
          }
          if (downcast) {
            downcast = embind__requireFunction(downcastSignature, downcast);
          }
          rawDestructor = embind__requireFunction(destructorSignature, rawDestructor);
          var legalFunctionName = makeLegalFunctionName(name);
          exposePublicSymbol(legalFunctionName, function() {
            throwUnboundTypeError(`Cannot construct ${name} due to unbound types`, [baseClassRawType]);
          });
          whenDependentTypesAreResolved([rawType, rawPointerType, rawConstPointerType], baseClassRawType ? [baseClassRawType] : [], function(base) {
            base = base[0];
            var baseClass;
            var basePrototype;
            if (baseClassRawType) {
              baseClass = base.registeredClass;
              basePrototype = baseClass.instancePrototype;
            } else {
              basePrototype = ClassHandle.prototype;
            }
            var constructor = createNamedFunction(legalFunctionName, function() {
              if (Object.getPrototypeOf(this) !== instancePrototype) {
                throw new BindingError("Use 'new' to construct " + name);
              }
              if (void 0 === registeredClass.constructor_body) {
                throw new BindingError(name + " has no accessible constructor");
              }
              var body = registeredClass.constructor_body[arguments.length];
              if (void 0 === body) {
                throw new BindingError(`Tried to invoke ctor of ${name} with invalid number of parameters (${arguments.length}) - expected (${Object.keys(registeredClass.constructor_body).toString()}) parameters instead!`);
              }
              return body.apply(this, arguments);
            });
            var instancePrototype = Object.create(basePrototype, { constructor: { value: constructor } });
            constructor.prototype = instancePrototype;
            var registeredClass = new RegisteredClass(name, constructor, instancePrototype, rawDestructor, baseClass, getActualType, upcast, downcast);
            if (registeredClass.baseClass) {
              if (registeredClass.baseClass.__derivedClasses === void 0) {
                registeredClass.baseClass.__derivedClasses = [];
              }
              registeredClass.baseClass.__derivedClasses.push(registeredClass);
            }
            var referenceConverter = new RegisteredPointer(name, registeredClass, true, false, false);
            var pointerConverter = new RegisteredPointer(name + "*", registeredClass, false, false, false);
            var constPointerConverter = new RegisteredPointer(name + " const*", registeredClass, false, true, false);
            registeredPointers[rawType] = { pointerType: pointerConverter, constPointerType: constPointerConverter };
            replacePublicSymbol(legalFunctionName, constructor);
            return [referenceConverter, pointerConverter, constPointerConverter];
          });
        }
        function heap32VectorToArray(count, firstElement) {
          var array = [];
          for (var i = 0; i < count; i++) {
            array.push(GROWABLE_HEAP_U32()[firstElement + i * 4 >>> 2]);
          }
          return array;
        }
        function newFunc(constructor, argumentList) {
          if (!(constructor instanceof Function)) {
            throw new TypeError(`new_ called with constructor type ${typeof constructor} which is not a function`);
          }
          var dummy = createNamedFunction(constructor.name || "unknownFunctionName", function() {
          });
          dummy.prototype = constructor.prototype;
          var obj = new dummy();
          var r = constructor.apply(obj, argumentList);
          return r instanceof Object ? r : obj;
        }
        function craftInvokerFunction(humanName, argTypes, classType, cppInvokerFunc, cppTargetFunc, isAsync) {
          var argCount = argTypes.length;
          if (argCount < 2) {
            throwBindingError("argTypes array size mismatch! Must at least get return value and 'this' types!");
          }
          var isClassMethodFunc = argTypes[1] !== null && classType !== null;
          var needsDestructorStack = false;
          for (var i = 1; i < argTypes.length; ++i) {
            if (argTypes[i] !== null && argTypes[i].destructorFunction === void 0) {
              needsDestructorStack = true;
              break;
            }
          }
          var returns = argTypes[0].name !== "void";
          var argsList = "";
          var argsListWired = "";
          for (var i = 0; i < argCount - 2; ++i) {
            argsList += (i !== 0 ? ", " : "") + "arg" + i;
            argsListWired += (i !== 0 ? ", " : "") + "arg" + i + "Wired";
          }
          var invokerFnBody = `
        return function ${makeLegalFunctionName(humanName)}(${argsList}) {
        if (arguments.length !== ${argCount - 2}) {
          throwBindingError('function ${humanName} called with ${arguments.length} arguments, expected ${argCount - 2} args!');
        }`;
          if (needsDestructorStack) {
            invokerFnBody += "var destructors = [];\n";
          }
          var dtorStack = needsDestructorStack ? "destructors" : "null";
          var args1 = ["throwBindingError", "invoker", "fn", "runDestructors", "retType", "classParam"];
          var args2 = [throwBindingError, cppInvokerFunc, cppTargetFunc, runDestructors, argTypes[0], argTypes[1]];
          if (isClassMethodFunc) {
            invokerFnBody += "var thisWired = classParam.toWireType(" + dtorStack + ", this);\n";
          }
          for (var i = 0; i < argCount - 2; ++i) {
            invokerFnBody += "var arg" + i + "Wired = argType" + i + ".toWireType(" + dtorStack + ", arg" + i + "); // " + argTypes[i + 2].name + "\n";
            args1.push("argType" + i);
            args2.push(argTypes[i + 2]);
          }
          if (isClassMethodFunc) {
            argsListWired = "thisWired" + (argsListWired.length > 0 ? ", " : "") + argsListWired;
          }
          invokerFnBody += (returns || isAsync ? "var rv = " : "") + "invoker(fn" + (argsListWired.length > 0 ? ", " : "") + argsListWired + ");\n";
          if (needsDestructorStack) {
            invokerFnBody += "runDestructors(destructors);\n";
          } else {
            for (var i = isClassMethodFunc ? 1 : 2; i < argTypes.length; ++i) {
              var paramName = i === 1 ? "thisWired" : "arg" + (i - 2) + "Wired";
              if (argTypes[i].destructorFunction !== null) {
                invokerFnBody += paramName + "_dtor(" + paramName + "); // " + argTypes[i].name + "\n";
                args1.push(paramName + "_dtor");
                args2.push(argTypes[i].destructorFunction);
              }
            }
          }
          if (returns) {
            invokerFnBody += "var ret = retType.fromWireType(rv);\nreturn ret;\n";
          } else {
          }
          invokerFnBody += "}\n";
          args1.push(invokerFnBody);
          return newFunc(Function, args1).apply(null, args2);
        }
        function __embind_register_class_constructor(rawClassType, argCount, rawArgTypesAddr, invokerSignature, invoker, rawConstructor) {
          rawClassType >>>= 0;
          rawArgTypesAddr >>>= 0;
          invokerSignature >>>= 0;
          invoker >>>= 0;
          rawConstructor >>>= 0;
          var rawArgTypes = heap32VectorToArray(argCount, rawArgTypesAddr);
          invoker = embind__requireFunction(invokerSignature, invoker);
          whenDependentTypesAreResolved([], [rawClassType], function(classType) {
            classType = classType[0];
            var humanName = `constructor ${classType.name}`;
            if (void 0 === classType.registeredClass.constructor_body) {
              classType.registeredClass.constructor_body = [];
            }
            if (void 0 !== classType.registeredClass.constructor_body[argCount - 1]) {
              throw new BindingError(`Cannot register multiple constructors with identical number of parameters (${argCount - 1}) for class '${classType.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`);
            }
            classType.registeredClass.constructor_body[argCount - 1] = () => {
              throwUnboundTypeError(`Cannot construct ${classType.name} due to unbound types`, rawArgTypes);
            };
            whenDependentTypesAreResolved([], rawArgTypes, function(argTypes) {
              argTypes.splice(1, 0, null);
              classType.registeredClass.constructor_body[argCount - 1] = craftInvokerFunction(humanName, argTypes, null, invoker, rawConstructor);
              return [];
            });
            return [];
          });
        }
        function __embind_register_class_function(rawClassType, methodName, argCount, rawArgTypesAddr, invokerSignature, rawInvoker, context, isPureVirtual, isAsync) {
          rawClassType >>>= 0;
          methodName >>>= 0;
          rawArgTypesAddr >>>= 0;
          invokerSignature >>>= 0;
          rawInvoker >>>= 0;
          context >>>= 0;
          var rawArgTypes = heap32VectorToArray(argCount, rawArgTypesAddr);
          methodName = readLatin1String(methodName);
          rawInvoker = embind__requireFunction(invokerSignature, rawInvoker);
          whenDependentTypesAreResolved([], [rawClassType], function(classType) {
            classType = classType[0];
            var humanName = `${classType.name}.${methodName}`;
            if (methodName.startsWith("@@")) {
              methodName = Symbol[methodName.substring(2)];
            }
            if (isPureVirtual) {
              classType.registeredClass.pureVirtualFunctions.push(methodName);
            }
            function unboundTypesHandler() {
              throwUnboundTypeError(`Cannot call ${humanName} due to unbound types`, rawArgTypes);
            }
            var proto = classType.registeredClass.instancePrototype;
            var method = proto[methodName];
            if (void 0 === method || void 0 === method.overloadTable && method.className !== classType.name && method.argCount === argCount - 2) {
              unboundTypesHandler.argCount = argCount - 2;
              unboundTypesHandler.className = classType.name;
              proto[methodName] = unboundTypesHandler;
            } else {
              ensureOverloadTable(proto, methodName, humanName);
              proto[methodName].overloadTable[argCount - 2] = unboundTypesHandler;
            }
            whenDependentTypesAreResolved([], rawArgTypes, function(argTypes) {
              var memberFunction = craftInvokerFunction(humanName, argTypes, classType, rawInvoker, context, isAsync);
              if (void 0 === proto[methodName].overloadTable) {
                memberFunction.argCount = argCount - 2;
                proto[methodName] = memberFunction;
              } else {
                proto[methodName].overloadTable[argCount - 2] = memberFunction;
              }
              return [];
            });
            return [];
          });
        }
        function handleAllocatorInit() {
          Object.assign(HandleAllocator.prototype, { get(id) {
            return this.allocated[id];
          }, has(id) {
            return this.allocated[id] !== void 0;
          }, allocate(handle) {
            var id = this.freelist.pop() || this.allocated.length;
            this.allocated[id] = handle;
            return id;
          }, free(id) {
            this.allocated[id] = void 0;
            this.freelist.push(id);
          } });
        }
        function HandleAllocator() {
          this.allocated = [void 0];
          this.freelist = [];
        }
        var emval_handles = new HandleAllocator();
        function __emval_decref(handle) {
          handle >>>= 0;
          if (handle >= emval_handles.reserved && 0 === --emval_handles.get(handle).refcount) {
            emval_handles.free(handle);
          }
        }
        function count_emval_handles() {
          var count = 0;
          for (var i = emval_handles.reserved; i < emval_handles.allocated.length; ++i) {
            if (emval_handles.allocated[i] !== void 0) {
              ++count;
            }
          }
          return count;
        }
        function init_emval() {
          emval_handles.allocated.push({ value: void 0 }, { value: null }, { value: true }, { value: false });
          emval_handles.reserved = emval_handles.allocated.length;
          Module["count_emval_handles"] = count_emval_handles;
        }
        var Emval = { toValue: (handle) => {
          if (!handle) {
            throwBindingError("Cannot use deleted val. handle = " + handle);
          }
          return emval_handles.get(handle).value;
        }, toHandle: (value) => {
          switch (value) {
            case void 0:
              return 1;
            case null:
              return 2;
            case true:
              return 3;
            case false:
              return 4;
            default: {
              return emval_handles.allocate({ refcount: 1, value });
            }
          }
        } };
        function __embind_register_emval(rawType, name) {
          rawType >>>= 0;
          name >>>= 0;
          name = readLatin1String(name);
          registerType(rawType, { name, "fromWireType": function(handle) {
            var rv = Emval.toValue(handle);
            __emval_decref(handle);
            return rv;
          }, "toWireType": function(destructors, value) {
            return Emval.toHandle(value);
          }, "argPackAdvance": 8, "readValueFromPointer": simpleReadValueFromPointer, destructorFunction: null });
        }
        function embindRepr(v) {
          if (v === null) {
            return "null";
          }
          var t = typeof v;
          if (t === "object" || t === "array" || t === "function") {
            return v.toString();
          } else {
            return "" + v;
          }
        }
        function floatReadValueFromPointer(name, shift) {
          switch (shift) {
            case 2:
              return function(pointer) {
                return this["fromWireType"](GROWABLE_HEAP_F32()[pointer >>> 2]);
              };
            case 3:
              return function(pointer) {
                return this["fromWireType"](GROWABLE_HEAP_F64()[pointer >>> 3]);
              };
            default:
              throw new TypeError("Unknown float type: " + name);
          }
        }
        function __embind_register_float(rawType, name, size) {
          rawType >>>= 0;
          name >>>= 0;
          size >>>= 0;
          var shift = getShiftFromSize(size);
          name = readLatin1String(name);
          registerType(rawType, { name, "fromWireType": function(value) {
            return value;
          }, "toWireType": function(destructors, value) {
            return value;
          }, "argPackAdvance": 8, "readValueFromPointer": floatReadValueFromPointer(name, shift), destructorFunction: null });
        }
        function __embind_register_function(name, argCount, rawArgTypesAddr, signature, rawInvoker, fn, isAsync) {
          name >>>= 0;
          rawArgTypesAddr >>>= 0;
          signature >>>= 0;
          rawInvoker >>>= 0;
          fn >>>= 0;
          var argTypes = heap32VectorToArray(argCount, rawArgTypesAddr);
          name = readLatin1String(name);
          rawInvoker = embind__requireFunction(signature, rawInvoker);
          exposePublicSymbol(name, function() {
            throwUnboundTypeError(`Cannot call ${name} due to unbound types`, argTypes);
          }, argCount - 1);
          whenDependentTypesAreResolved([], argTypes, function(argTypes2) {
            var invokerArgsArray = [argTypes2[0], null].concat(argTypes2.slice(1));
            replacePublicSymbol(name, craftInvokerFunction(name, invokerArgsArray, null, rawInvoker, fn, isAsync), argCount - 1);
            return [];
          });
        }
        function integerReadValueFromPointer(name, shift, signed) {
          switch (shift) {
            case 0:
              return signed ? function readS8FromPointer(pointer) {
                return GROWABLE_HEAP_I8()[pointer >>> 0];
              } : function readU8FromPointer(pointer) {
                return GROWABLE_HEAP_U8()[pointer >>> 0];
              };
            case 1:
              return signed ? function readS16FromPointer(pointer) {
                return GROWABLE_HEAP_I16()[pointer >>> 1];
              } : function readU16FromPointer(pointer) {
                return GROWABLE_HEAP_U16()[pointer >>> 1];
              };
            case 2:
              return signed ? function readS32FromPointer(pointer) {
                return GROWABLE_HEAP_I32()[pointer >>> 2];
              } : function readU32FromPointer(pointer) {
                return GROWABLE_HEAP_U32()[pointer >>> 2];
              };
            default:
              throw new TypeError("Unknown integer type: " + name);
          }
        }
        function __embind_register_integer(primitiveType, name, size, minRange, maxRange) {
          primitiveType >>>= 0;
          name >>>= 0;
          size >>>= 0;
          name = readLatin1String(name);
          if (maxRange === -1) {
            maxRange = 4294967295;
          }
          var shift = getShiftFromSize(size);
          var fromWireType = (value) => value;
          if (minRange === 0) {
            var bitshift = 32 - 8 * size;
            fromWireType = (value) => value << bitshift >>> bitshift;
          }
          var isUnsignedType = name.includes("unsigned");
          var checkAssertions = (value, toTypeName) => {
          };
          var toWireType;
          if (isUnsignedType) {
            toWireType = function(destructors, value) {
              checkAssertions(value, this.name);
              return value >>> 0;
            };
          } else {
            toWireType = function(destructors, value) {
              checkAssertions(value, this.name);
              return value;
            };
          }
          registerType(primitiveType, { name, "fromWireType": fromWireType, "toWireType": toWireType, "argPackAdvance": 8, "readValueFromPointer": integerReadValueFromPointer(name, shift, minRange !== 0), destructorFunction: null });
        }
        function __embind_register_memory_view(rawType, dataTypeIndex, name) {
          rawType >>>= 0;
          name >>>= 0;
          var typeMapping = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array];
          var TA = typeMapping[dataTypeIndex];
          function decodeMemoryView(handle) {
            handle = handle >> 2;
            var heap = GROWABLE_HEAP_U32();
            var size = heap[handle >>> 0];
            var data = heap[handle + 1 >>> 0];
            return new TA(heap.buffer, data, size);
          }
          name = readLatin1String(name);
          registerType(rawType, { name, "fromWireType": decodeMemoryView, "argPackAdvance": 8, "readValueFromPointer": decodeMemoryView }, { ignoreDuplicateRegistrations: true });
        }
        var stringToUTF8 = (str, outPtr, maxBytesToWrite) => stringToUTF8Array(str, GROWABLE_HEAP_U8(), outPtr, maxBytesToWrite);
        function __embind_register_std_string(rawType, name) {
          rawType >>>= 0;
          name >>>= 0;
          name = readLatin1String(name);
          var stdStringIsUTF8 = name === "std::string";
          registerType(rawType, { name, "fromWireType": function(value) {
            var length = GROWABLE_HEAP_U32()[value >>> 2];
            var payload = value + 4;
            var str;
            if (stdStringIsUTF8) {
              var decodeStartPtr = payload;
              for (var i = 0; i <= length; ++i) {
                var currentBytePtr = payload + i;
                if (i == length || GROWABLE_HEAP_U8()[currentBytePtr >>> 0] == 0) {
                  var maxRead = currentBytePtr - decodeStartPtr;
                  var stringSegment = UTF8ToString(decodeStartPtr, maxRead);
                  if (str === void 0) {
                    str = stringSegment;
                  } else {
                    str += String.fromCharCode(0);
                    str += stringSegment;
                  }
                  decodeStartPtr = currentBytePtr + 1;
                }
              }
            } else {
              var a = new Array(length);
              for (var i = 0; i < length; ++i) {
                a[i] = String.fromCharCode(GROWABLE_HEAP_U8()[payload + i >>> 0]);
              }
              str = a.join("");
            }
            _free(value);
            return str;
          }, "toWireType": function(destructors, value) {
            if (value instanceof ArrayBuffer) {
              value = new Uint8Array(value);
            }
            var length;
            var valueIsOfTypeString = typeof value == "string";
            if (!(valueIsOfTypeString || value instanceof Uint8Array || value instanceof Uint8ClampedArray || value instanceof Int8Array)) {
              throwBindingError("Cannot pass non-string to std::string");
            }
            if (stdStringIsUTF8 && valueIsOfTypeString) {
              length = lengthBytesUTF8(value);
            } else {
              length = value.length;
            }
            var base = _malloc(4 + length + 1);
            var ptr = base + 4;
            GROWABLE_HEAP_U32()[base >>> 2] = length;
            if (stdStringIsUTF8 && valueIsOfTypeString) {
              stringToUTF8(value, ptr, length + 1);
            } else {
              if (valueIsOfTypeString) {
                for (var i = 0; i < length; ++i) {
                  var charCode = value.charCodeAt(i);
                  if (charCode > 255) {
                    _free(ptr);
                    throwBindingError("String has UTF-16 code units that do not fit in 8 bits");
                  }
                  GROWABLE_HEAP_U8()[ptr + i >>> 0] = charCode;
                }
              } else {
                for (var i = 0; i < length; ++i) {
                  GROWABLE_HEAP_U8()[ptr + i >>> 0] = value[i];
                }
              }
            }
            if (destructors !== null) {
              destructors.push(_free, base);
            }
            return base;
          }, "argPackAdvance": 8, "readValueFromPointer": simpleReadValueFromPointer, destructorFunction: function(ptr) {
            _free(ptr);
          } });
        }
        var UTF16Decoder = typeof TextDecoder != "undefined" ? new TextDecoder("utf-16le") : void 0;
        var UTF16ToString = (ptr, maxBytesToRead) => {
          var endPtr = ptr;
          var idx = endPtr >> 1;
          var maxIdx = idx + maxBytesToRead / 2;
          while (!(idx >= maxIdx) && GROWABLE_HEAP_U16()[idx >>> 0]) ++idx;
          endPtr = idx << 1;
          if (endPtr - ptr > 32 && UTF16Decoder) return UTF16Decoder.decode(GROWABLE_HEAP_U8().slice(ptr, endPtr));
          var str = "";
          for (var i = 0; !(i >= maxBytesToRead / 2); ++i) {
            var codeUnit = GROWABLE_HEAP_I16()[ptr + i * 2 >>> 1];
            if (codeUnit == 0) break;
            str += String.fromCharCode(codeUnit);
          }
          return str;
        };
        var stringToUTF16 = (str, outPtr, maxBytesToWrite) => {
          if (maxBytesToWrite === void 0) {
            maxBytesToWrite = 2147483647;
          }
          if (maxBytesToWrite < 2) return 0;
          maxBytesToWrite -= 2;
          var startPtr = outPtr;
          var numCharsToWrite = maxBytesToWrite < str.length * 2 ? maxBytesToWrite / 2 : str.length;
          for (var i = 0; i < numCharsToWrite; ++i) {
            var codeUnit = str.charCodeAt(i);
            GROWABLE_HEAP_I16()[outPtr >>> 1] = codeUnit;
            outPtr += 2;
          }
          GROWABLE_HEAP_I16()[outPtr >>> 1] = 0;
          return outPtr - startPtr;
        };
        var lengthBytesUTF16 = (str) => str.length * 2;
        var UTF32ToString = (ptr, maxBytesToRead) => {
          var i = 0;
          var str = "";
          while (!(i >= maxBytesToRead / 4)) {
            var utf32 = GROWABLE_HEAP_I32()[ptr + i * 4 >>> 2];
            if (utf32 == 0) break;
            ++i;
            if (utf32 >= 65536) {
              var ch = utf32 - 65536;
              str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023);
            } else {
              str += String.fromCharCode(utf32);
            }
          }
          return str;
        };
        var stringToUTF32 = (str, outPtr, maxBytesToWrite) => {
          outPtr >>>= 0;
          if (maxBytesToWrite === void 0) {
            maxBytesToWrite = 2147483647;
          }
          if (maxBytesToWrite < 4) return 0;
          var startPtr = outPtr;
          var endPtr = startPtr + maxBytesToWrite - 4;
          for (var i = 0; i < str.length; ++i) {
            var codeUnit = str.charCodeAt(i);
            if (codeUnit >= 55296 && codeUnit <= 57343) {
              var trailSurrogate = str.charCodeAt(++i);
              codeUnit = 65536 + ((codeUnit & 1023) << 10) | trailSurrogate & 1023;
            }
            GROWABLE_HEAP_I32()[outPtr >>> 2] = codeUnit;
            outPtr += 4;
            if (outPtr + 4 > endPtr) break;
          }
          GROWABLE_HEAP_I32()[outPtr >>> 2] = 0;
          return outPtr - startPtr;
        };
        var lengthBytesUTF32 = (str) => {
          var len = 0;
          for (var i = 0; i < str.length; ++i) {
            var codeUnit = str.charCodeAt(i);
            if (codeUnit >= 55296 && codeUnit <= 57343) ++i;
            len += 4;
          }
          return len;
        };
        var __embind_register_std_wstring = function(rawType, charSize, name) {
          rawType >>>= 0;
          charSize >>>= 0;
          name >>>= 0;
          name = readLatin1String(name);
          var decodeString, encodeString, getHeap, lengthBytesUTF, shift;
          if (charSize === 2) {
            decodeString = UTF16ToString;
            encodeString = stringToUTF16;
            lengthBytesUTF = lengthBytesUTF16;
            getHeap = () => GROWABLE_HEAP_U16();
            shift = 1;
          } else if (charSize === 4) {
            decodeString = UTF32ToString;
            encodeString = stringToUTF32;
            lengthBytesUTF = lengthBytesUTF32;
            getHeap = () => GROWABLE_HEAP_U32();
            shift = 2;
          }
          registerType(rawType, { name, "fromWireType": function(value) {
            var length = GROWABLE_HEAP_U32()[value >>> 2];
            var HEAP = getHeap();
            var str;
            var decodeStartPtr = value + 4;
            for (var i = 0; i <= length; ++i) {
              var currentBytePtr = value + 4 + i * charSize;
              if (i == length || HEAP[currentBytePtr >>> shift] == 0) {
                var maxReadBytes = currentBytePtr - decodeStartPtr;
                var stringSegment = decodeString(decodeStartPtr, maxReadBytes);
                if (str === void 0) {
                  str = stringSegment;
                } else {
                  str += String.fromCharCode(0);
                  str += stringSegment;
                }
                decodeStartPtr = currentBytePtr + charSize;
              }
            }
            _free(value);
            return str;
          }, "toWireType": function(destructors, value) {
            if (!(typeof value == "string")) {
              throwBindingError(`Cannot pass non-string to C++ string type ${name}`);
            }
            var length = lengthBytesUTF(value);
            var ptr = _malloc(4 + length + charSize);
            GROWABLE_HEAP_U32()[ptr >>> 2] = length >> shift;
            encodeString(value, ptr + 4, length + charSize);
            if (destructors !== null) {
              destructors.push(_free, ptr);
            }
            return ptr;
          }, "argPackAdvance": 8, "readValueFromPointer": simpleReadValueFromPointer, destructorFunction: function(ptr) {
            _free(ptr);
          } });
        };
        function __embind_register_value_array(rawType, name, constructorSignature, rawConstructor, destructorSignature, rawDestructor) {
          rawType >>>= 0;
          name >>>= 0;
          constructorSignature >>>= 0;
          rawConstructor >>>= 0;
          destructorSignature >>>= 0;
          rawDestructor >>>= 0;
          tupleRegistrations[rawType] = { name: readLatin1String(name), rawConstructor: embind__requireFunction(constructorSignature, rawConstructor), rawDestructor: embind__requireFunction(destructorSignature, rawDestructor), elements: [] };
        }
        function __embind_register_value_array_element(rawTupleType, getterReturnType, getterSignature, getter, getterContext, setterArgumentType, setterSignature, setter, setterContext) {
          rawTupleType >>>= 0;
          getterReturnType >>>= 0;
          getterSignature >>>= 0;
          getter >>>= 0;
          getterContext >>>= 0;
          setterArgumentType >>>= 0;
          setterSignature >>>= 0;
          setter >>>= 0;
          setterContext >>>= 0;
          tupleRegistrations[rawTupleType].elements.push({ getterReturnType, getter: embind__requireFunction(getterSignature, getter), getterContext, setterArgumentType, setter: embind__requireFunction(setterSignature, setter), setterContext });
        }
        function __embind_register_value_object(rawType, name, constructorSignature, rawConstructor, destructorSignature, rawDestructor) {
          rawType >>>= 0;
          name >>>= 0;
          constructorSignature >>>= 0;
          rawConstructor >>>= 0;
          destructorSignature >>>= 0;
          rawDestructor >>>= 0;
          structRegistrations[rawType] = { name: readLatin1String(name), rawConstructor: embind__requireFunction(constructorSignature, rawConstructor), rawDestructor: embind__requireFunction(destructorSignature, rawDestructor), fields: [] };
        }
        function __embind_register_value_object_field(structType, fieldName, getterReturnType, getterSignature, getter, getterContext, setterArgumentType, setterSignature, setter, setterContext) {
          structType >>>= 0;
          fieldName >>>= 0;
          getterReturnType >>>= 0;
          getterSignature >>>= 0;
          getter >>>= 0;
          getterContext >>>= 0;
          setterArgumentType >>>= 0;
          setterSignature >>>= 0;
          setter >>>= 0;
          setterContext >>>= 0;
          structRegistrations[structType].fields.push({ fieldName: readLatin1String(fieldName), getterReturnType, getter: embind__requireFunction(getterSignature, getter), getterContext, setterArgumentType, setter: embind__requireFunction(setterSignature, setter), setterContext });
        }
        function __embind_register_void(rawType, name) {
          rawType >>>= 0;
          name >>>= 0;
          name = readLatin1String(name);
          registerType(rawType, { isVoid: true, name, "argPackAdvance": 0, "fromWireType": function() {
            return void 0;
          }, "toWireType": function(destructors, o) {
            return void 0;
          } });
        }
        var nowIsMonotonic = true;
        var __emscripten_get_now_is_monotonic = () => nowIsMonotonic;
        var maybeExit = () => {
          if (!keepRuntimeAlive()) {
            try {
              if (ENVIRONMENT_IS_PTHREAD) __emscripten_thread_exit(EXITSTATUS);
              else _exit(EXITSTATUS);
            } catch (e) {
              handleException(e);
            }
          }
        };
        var callUserCallback = (func) => {
          if (ABORT) {
            return;
          }
          try {
            func();
            maybeExit();
          } catch (e) {
            handleException(e);
          }
        };
        function __emscripten_thread_mailbox_await(pthread_ptr) {
          pthread_ptr >>>= 0;
          if (typeof Atomics.waitAsync === "function") {
            var wait = Atomics.waitAsync(GROWABLE_HEAP_I32(), pthread_ptr >> 2, pthread_ptr);
            wait.value.then(checkMailbox);
            var waitingAsync = pthread_ptr + 128;
            Atomics.store(GROWABLE_HEAP_I32(), waitingAsync >> 2, 1);
          }
        }
        Module["__emscripten_thread_mailbox_await"] = __emscripten_thread_mailbox_await;
        var checkMailbox = function() {
          var pthread_ptr = _pthread_self();
          if (pthread_ptr) {
            __emscripten_thread_mailbox_await(pthread_ptr);
            callUserCallback(() => __emscripten_check_mailbox());
          }
        };
        Module["checkMailbox"] = checkMailbox;
        var __emscripten_notify_mailbox_postmessage = function(targetThreadId, currThreadId, mainThreadId) {
          targetThreadId >>>= 0;
          currThreadId >>>= 0;
          mainThreadId >>>= 0;
          if (targetThreadId == currThreadId) {
            setTimeout(() => checkMailbox());
          } else if (ENVIRONMENT_IS_PTHREAD) {
            postMessage({ "targetThread": targetThreadId, "cmd": "checkMailbox" });
          } else {
            var worker = PThread.pthreads[targetThreadId];
            if (!worker) {
              return;
            }
            worker.postMessage({ "cmd": "checkMailbox" });
          }
        };
        function __emscripten_set_offscreencanvas_size(target, width, height) {
          target >>>= 0;
          return -1;
        }
        function __emscripten_thread_set_strongref(thread) {
          thread >>>= 0;
        }
        function requireRegisteredType(rawType, humanName) {
          var impl = registeredTypes[rawType];
          if (void 0 === impl) {
            throwBindingError(humanName + " has unknown type " + getTypeName(rawType));
          }
          return impl;
        }
        function __emval_as(handle, returnType, destructorsRef) {
          handle >>>= 0;
          returnType >>>= 0;
          destructorsRef >>>= 0;
          handle = Emval.toValue(handle);
          returnType = requireRegisteredType(returnType, "emval::as");
          var destructors = [];
          var rd = Emval.toHandle(destructors);
          GROWABLE_HEAP_U32()[destructorsRef >>> 2] = rd;
          return returnType["toWireType"](destructors, handle);
        }
        function emval_lookupTypes(argCount, argTypes) {
          var a = new Array(argCount);
          for (var i = 0; i < argCount; ++i) {
            a[i] = requireRegisteredType(GROWABLE_HEAP_U32()[argTypes + i * 4 >>> 2], "parameter " + i);
          }
          return a;
        }
        function __emval_call(handle, argCount, argTypes, argv) {
          handle >>>= 0;
          argTypes >>>= 0;
          argv >>>= 0;
          handle = Emval.toValue(handle);
          var types = emval_lookupTypes(argCount, argTypes);
          var args = new Array(argCount);
          for (var i = 0; i < argCount; ++i) {
            var type = types[i];
            args[i] = type["readValueFromPointer"](argv);
            argv += type["argPackAdvance"];
          }
          var rv = handle.apply(void 0, args);
          return Emval.toHandle(rv);
        }
        var emval_symbols = {};
        function getStringOrSymbol(address) {
          var symbol = emval_symbols[address];
          if (symbol === void 0) {
            return readLatin1String(address);
          }
          return symbol;
        }
        function emval_get_global() {
          if (typeof globalThis == "object") {
            return globalThis;
          }
          return (/* @__PURE__ */ function() {
            return Function;
          }())("return this")();
        }
        function __emval_get_global(name) {
          name >>>= 0;
          if (name === 0) {
            return Emval.toHandle(emval_get_global());
          } else {
            name = getStringOrSymbol(name);
            return Emval.toHandle(emval_get_global()[name]);
          }
        }
        function __emval_get_property(handle, key) {
          handle >>>= 0;
          key >>>= 0;
          handle = Emval.toValue(handle);
          key = Emval.toValue(key);
          return Emval.toHandle(handle[key]);
        }
        function __emval_incref(handle) {
          handle >>>= 0;
          if (handle > 4) {
            emval_handles.get(handle).refcount += 1;
          }
        }
        function __emval_instanceof(object, constructor) {
          object >>>= 0;
          constructor >>>= 0;
          object = Emval.toValue(object);
          constructor = Emval.toValue(constructor);
          return object instanceof constructor;
        }
        function __emval_is_number(handle) {
          handle >>>= 0;
          handle = Emval.toValue(handle);
          return typeof handle == "number";
        }
        function __emval_is_string(handle) {
          handle >>>= 0;
          handle = Emval.toValue(handle);
          return typeof handle == "string";
        }
        function __emval_new_array() {
          return Emval.toHandle([]);
        }
        function __emval_new_cstring(v) {
          v >>>= 0;
          return Emval.toHandle(getStringOrSymbol(v));
        }
        function __emval_new_object() {
          return Emval.toHandle({});
        }
        function __emval_run_destructors(handle) {
          handle >>>= 0;
          var destructors = Emval.toValue(handle);
          runDestructors(destructors);
          __emval_decref(handle);
        }
        function __emval_set_property(handle, key, value) {
          handle >>>= 0;
          key >>>= 0;
          value >>>= 0;
          handle = Emval.toValue(handle);
          key = Emval.toValue(key);
          value = Emval.toValue(value);
          handle[key] = value;
        }
        function __emval_take_value(type, arg) {
          type >>>= 0;
          arg >>>= 0;
          type = requireRegisteredType(type, "_emval_take_value");
          var v = type["readValueFromPointer"](arg);
          return Emval.toHandle(v);
        }
        function __gmtime_js(time_low, time_high, tmPtr) {
          var time = convertI32PairToI53Checked(time_low, time_high);
          tmPtr >>>= 0;
          var date = new Date(time * 1e3);
          GROWABLE_HEAP_I32()[tmPtr >>> 2] = date.getUTCSeconds();
          GROWABLE_HEAP_I32()[tmPtr + 4 >>> 2] = date.getUTCMinutes();
          GROWABLE_HEAP_I32()[tmPtr + 8 >>> 2] = date.getUTCHours();
          GROWABLE_HEAP_I32()[tmPtr + 12 >>> 2] = date.getUTCDate();
          GROWABLE_HEAP_I32()[tmPtr + 16 >>> 2] = date.getUTCMonth();
          GROWABLE_HEAP_I32()[tmPtr + 20 >>> 2] = date.getUTCFullYear() - 1900;
          GROWABLE_HEAP_I32()[tmPtr + 24 >>> 2] = date.getUTCDay();
          var start = Date.UTC(date.getUTCFullYear(), 0, 1, 0, 0, 0, 0);
          var yday = (date.getTime() - start) / (1e3 * 60 * 60 * 24) | 0;
          GROWABLE_HEAP_I32()[tmPtr + 28 >>> 2] = yday;
        }
        var isLeapYear = (year) => year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
        var MONTH_DAYS_LEAP_CUMULATIVE = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
        var MONTH_DAYS_REGULAR_CUMULATIVE = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
        var ydayFromDate = (date) => {
          var leap = isLeapYear(date.getFullYear());
          var monthDaysCumulative = leap ? MONTH_DAYS_LEAP_CUMULATIVE : MONTH_DAYS_REGULAR_CUMULATIVE;
          var yday = monthDaysCumulative[date.getMonth()] + date.getDate() - 1;
          return yday;
        };
        function __localtime_js(time_low, time_high, tmPtr) {
          var time = convertI32PairToI53Checked(time_low, time_high);
          tmPtr >>>= 0;
          var date = new Date(time * 1e3);
          GROWABLE_HEAP_I32()[tmPtr >>> 2] = date.getSeconds();
          GROWABLE_HEAP_I32()[tmPtr + 4 >>> 2] = date.getMinutes();
          GROWABLE_HEAP_I32()[tmPtr + 8 >>> 2] = date.getHours();
          GROWABLE_HEAP_I32()[tmPtr + 12 >>> 2] = date.getDate();
          GROWABLE_HEAP_I32()[tmPtr + 16 >>> 2] = date.getMonth();
          GROWABLE_HEAP_I32()[tmPtr + 20 >>> 2] = date.getFullYear() - 1900;
          GROWABLE_HEAP_I32()[tmPtr + 24 >>> 2] = date.getDay();
          var yday = ydayFromDate(date) | 0;
          GROWABLE_HEAP_I32()[tmPtr + 28 >>> 2] = yday;
          GROWABLE_HEAP_I32()[tmPtr + 36 >>> 2] = -(date.getTimezoneOffset() * 60);
          var start = new Date(date.getFullYear(), 0, 1);
          var summerOffset = new Date(date.getFullYear(), 6, 1).getTimezoneOffset();
          var winterOffset = start.getTimezoneOffset();
          var dst = (summerOffset != winterOffset && date.getTimezoneOffset() == Math.min(winterOffset, summerOffset)) | 0;
          GROWABLE_HEAP_I32()[tmPtr + 32 >>> 2] = dst;
        }
        var stringToNewUTF8 = (str) => {
          var size = lengthBytesUTF8(str) + 1;
          var ret = _malloc(size);
          if (ret) stringToUTF8(str, ret, size);
          return ret;
        };
        function __tzset_js(timezone, daylight, tzname) {
          timezone >>>= 0;
          daylight >>>= 0;
          tzname >>>= 0;
          var currentYear = (/* @__PURE__ */ new Date()).getFullYear();
          var winter = new Date(currentYear, 0, 1);
          var summer = new Date(currentYear, 6, 1);
          var winterOffset = winter.getTimezoneOffset();
          var summerOffset = summer.getTimezoneOffset();
          var stdTimezoneOffset = Math.max(winterOffset, summerOffset);
          GROWABLE_HEAP_U32()[timezone >>> 2] = stdTimezoneOffset * 60;
          GROWABLE_HEAP_I32()[daylight >>> 2] = Number(winterOffset != summerOffset);
          function extractZone(date) {
            var match = date.toTimeString().match(/\(([A-Za-z ]+)\)$/);
            return match ? match[1] : "GMT";
          }
          var winterName = extractZone(winter);
          var summerName = extractZone(summer);
          var winterNamePtr = stringToNewUTF8(winterName);
          var summerNamePtr = stringToNewUTF8(summerName);
          if (summerOffset < winterOffset) {
            GROWABLE_HEAP_U32()[tzname >>> 2] = winterNamePtr;
            GROWABLE_HEAP_U32()[tzname + 4 >>> 2] = summerNamePtr;
          } else {
            GROWABLE_HEAP_U32()[tzname >>> 2] = summerNamePtr;
            GROWABLE_HEAP_U32()[tzname + 4 >>> 2] = winterNamePtr;
          }
        }
        var _abort = () => {
          abort("");
        };
        var warnOnce = (text) => {
          if (!warnOnce.shown) warnOnce.shown = {};
          if (!warnOnce.shown[text]) {
            warnOnce.shown[text] = 1;
            err(text);
          }
        };
        function _emscripten_check_blocking_allowed() {
        }
        function _emscripten_date_now() {
          return Date.now();
        }
        var runtimeKeepalivePush = () => {
          runtimeKeepaliveCounter += 1;
        };
        var _emscripten_exit_with_live_runtime = () => {
          runtimeKeepalivePush();
          throw "unwind";
        };
        var _emscripten_get_now;
        _emscripten_get_now = () => performance.timeOrigin + performance.now();
        var withStackSave = (f) => {
          var stack = stackSave();
          var ret = f();
          stackRestore(stack);
          return ret;
        };
        var proxyToMainThread = function(index, sync) {
          var numCallArgs = arguments.length - 2;
          var outerArgs = arguments;
          return withStackSave(() => {
            var serializedNumCallArgs = numCallArgs;
            var args = stackAlloc(serializedNumCallArgs * 8);
            var b = args >> 3;
            for (var i = 0; i < numCallArgs; i++) {
              var arg = outerArgs[2 + i];
              GROWABLE_HEAP_F64()[b + i >>> 0] = arg;
            }
            return __emscripten_run_in_main_runtime_thread_js(index, serializedNumCallArgs, args, sync);
          });
        };
        var emscripten_receive_on_main_thread_js_callArgs = [];
        function _emscripten_receive_on_main_thread_js(index, callingThread, numCallArgs, args) {
          callingThread >>>= 0;
          args >>>= 0;
          PThread.currentProxiedOperationCallerThread = callingThread;
          emscripten_receive_on_main_thread_js_callArgs.length = numCallArgs;
          var b = args >> 3;
          for (var i = 0; i < numCallArgs; i++) {
            emscripten_receive_on_main_thread_js_callArgs[i] = GROWABLE_HEAP_F64()[b + i >>> 0];
          }
          var func = proxiedFunctionTable[index];
          return func.apply(null, emscripten_receive_on_main_thread_js_callArgs);
        }
        var getHeapMax = () => 4294901760;
        var growMemory = (size) => {
          var b = wasmMemory.buffer;
          var pages = size - b.byteLength + 65535 >>> 16;
          try {
            wasmMemory.grow(pages);
            updateMemoryViews();
            return 1;
          } catch (e) {
          }
        };
        function _emscripten_resize_heap(requestedSize) {
          requestedSize >>>= 0;
          var oldSize = GROWABLE_HEAP_U8().length;
          if (requestedSize <= oldSize) {
            return false;
          }
          var maxHeapSize = getHeapMax();
          if (requestedSize > maxHeapSize) {
            return false;
          }
          var alignUp = (x, multiple) => x + (multiple - x % multiple) % multiple;
          for (var cutDown = 1; cutDown <= 4; cutDown *= 2) {
            var overGrownHeapSize = oldSize * (1 + 0.2 / cutDown);
            overGrownHeapSize = Math.min(overGrownHeapSize, requestedSize + 100663296);
            var newSize = Math.min(maxHeapSize, alignUp(Math.max(requestedSize, overGrownHeapSize), 65536));
            var replacement = growMemory(newSize);
            if (replacement) {
              return true;
            }
          }
          return false;
        }
        var ENV = {};
        var getExecutableName = () => thisProgram || "./this.program";
        var getEnvStrings = () => {
          if (!getEnvStrings.strings) {
            var lang = (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8";
            var env = { "USER": "web_user", "LOGNAME": "web_user", "PATH": "/", "PWD": "/", "HOME": "/home/web_user", "LANG": lang, "_": getExecutableName() };
            for (var x in ENV) {
              if (ENV[x] === void 0) delete env[x];
              else env[x] = ENV[x];
            }
            var strings = [];
            for (var x in env) {
              strings.push(`${x}=${env[x]}`);
            }
            getEnvStrings.strings = strings;
          }
          return getEnvStrings.strings;
        };
        var stringToAscii = (str, buffer) => {
          for (var i = 0; i < str.length; ++i) {
            GROWABLE_HEAP_I8()[buffer++ >>> 0] = str.charCodeAt(i);
          }
          GROWABLE_HEAP_I8()[buffer >>> 0] = 0;
        };
        function _environ_get(__environ, environ_buf) {
          if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(3, 1, __environ, environ_buf);
          __environ >>>= 0;
          environ_buf >>>= 0;
          var bufSize = 0;
          getEnvStrings().forEach(function(string, i) {
            var ptr = environ_buf + bufSize;
            GROWABLE_HEAP_U32()[__environ + i * 4 >>> 2] = ptr;
            stringToAscii(string, ptr);
            bufSize += string.length + 1;
          });
          return 0;
        }
        function _environ_sizes_get(penviron_count, penviron_buf_size) {
          if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(4, 1, penviron_count, penviron_buf_size);
          penviron_count >>>= 0;
          penviron_buf_size >>>= 0;
          var strings = getEnvStrings();
          GROWABLE_HEAP_U32()[penviron_count >>> 2] = strings.length;
          var bufSize = 0;
          strings.forEach(function(string) {
            bufSize += string.length + 1;
          });
          GROWABLE_HEAP_U32()[penviron_buf_size >>> 2] = bufSize;
          return 0;
        }
        function _fd_close(fd) {
          if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(5, 1, fd);
          try {
            var stream = SYSCALLS.getStreamFromFD(fd);
            FS.close(stream);
            return 0;
          } catch (e) {
            if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
            return e.errno;
          }
        }
        function _fd_fdstat_get(fd, pbuf) {
          if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(6, 1, fd, pbuf);
          pbuf >>>= 0;
          try {
            var rightsBase = 0;
            var rightsInheriting = 0;
            var flags = 0;
            {
              var stream = SYSCALLS.getStreamFromFD(fd);
              var type = stream.tty ? 2 : FS.isDir(stream.mode) ? 3 : FS.isLink(stream.mode) ? 7 : 4;
            }
            GROWABLE_HEAP_I8()[pbuf >>> 0] = type;
            GROWABLE_HEAP_I16()[pbuf + 2 >>> 1] = flags;
            tempI64 = [rightsBase >>> 0, (tempDouble = rightsBase, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], GROWABLE_HEAP_I32()[pbuf + 8 >>> 2] = tempI64[0], GROWABLE_HEAP_I32()[pbuf + 12 >>> 2] = tempI64[1];
            tempI64 = [rightsInheriting >>> 0, (tempDouble = rightsInheriting, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], GROWABLE_HEAP_I32()[pbuf + 16 >>> 2] = tempI64[0], GROWABLE_HEAP_I32()[pbuf + 20 >>> 2] = tempI64[1];
            return 0;
          } catch (e) {
            if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
            return e.errno;
          }
        }
        var doReadv = (stream, iov, iovcnt, offset) => {
          var ret = 0;
          for (var i = 0; i < iovcnt; i++) {
            var ptr = GROWABLE_HEAP_U32()[iov >>> 2];
            var len = GROWABLE_HEAP_U32()[iov + 4 >>> 2];
            iov += 8;
            var curr = FS.read(stream, GROWABLE_HEAP_I8(), ptr, len, offset);
            if (curr < 0) return -1;
            ret += curr;
            if (curr < len) break;
            if (typeof offset !== "undefined") {
              offset += curr;
            }
          }
          return ret;
        };
        function _fd_read(fd, iov, iovcnt, pnum) {
          if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(7, 1, fd, iov, iovcnt, pnum);
          iov >>>= 0;
          iovcnt >>>= 0;
          pnum >>>= 0;
          try {
            var stream = SYSCALLS.getStreamFromFD(fd);
            var num = doReadv(stream, iov, iovcnt);
            GROWABLE_HEAP_U32()[pnum >>> 2] = num;
            return 0;
          } catch (e) {
            if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
            return e.errno;
          }
        }
        function _fd_seek(fd, offset_low, offset_high, whence, newOffset) {
          if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(8, 1, fd, offset_low, offset_high, whence, newOffset);
          var offset = convertI32PairToI53Checked(offset_low, offset_high);
          newOffset >>>= 0;
          try {
            if (isNaN(offset)) return 61;
            var stream = SYSCALLS.getStreamFromFD(fd);
            FS.llseek(stream, offset, whence);
            tempI64 = [stream.position >>> 0, (tempDouble = stream.position, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], GROWABLE_HEAP_I32()[newOffset >>> 2] = tempI64[0], GROWABLE_HEAP_I32()[newOffset + 4 >>> 2] = tempI64[1];
            if (stream.getdents && offset === 0 && whence === 0) stream.getdents = null;
            return 0;
          } catch (e) {
            if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
            return e.errno;
          }
        }
        var doWritev = (stream, iov, iovcnt, offset) => {
          var ret = 0;
          for (var i = 0; i < iovcnt; i++) {
            var ptr = GROWABLE_HEAP_U32()[iov >>> 2];
            var len = GROWABLE_HEAP_U32()[iov + 4 >>> 2];
            iov += 8;
            var curr = FS.write(stream, GROWABLE_HEAP_I8(), ptr, len, offset);
            if (curr < 0) return -1;
            ret += curr;
            if (typeof offset !== "undefined") {
              offset += curr;
            }
          }
          return ret;
        };
        function _fd_write(fd, iov, iovcnt, pnum) {
          if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(9, 1, fd, iov, iovcnt, pnum);
          iov >>>= 0;
          iovcnt >>>= 0;
          pnum >>>= 0;
          try {
            var stream = SYSCALLS.getStreamFromFD(fd);
            var num = doWritev(stream, iov, iovcnt);
            GROWABLE_HEAP_U32()[pnum >>> 2] = num;
            return 0;
          } catch (e) {
            if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
            return e.errno;
          }
        }
        var arraySum = (array, index) => {
          var sum = 0;
          for (var i = 0; i <= index; sum += array[i++]) {
          }
          return sum;
        };
        var MONTH_DAYS_LEAP = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        var MONTH_DAYS_REGULAR = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        var addDays = (date, days) => {
          var newDate = new Date(date.getTime());
          while (days > 0) {
            var leap = isLeapYear(newDate.getFullYear());
            var currentMonth = newDate.getMonth();
            var daysInCurrentMonth = (leap ? MONTH_DAYS_LEAP : MONTH_DAYS_REGULAR)[currentMonth];
            if (days > daysInCurrentMonth - newDate.getDate()) {
              days -= daysInCurrentMonth - newDate.getDate() + 1;
              newDate.setDate(1);
              if (currentMonth < 11) {
                newDate.setMonth(currentMonth + 1);
              } else {
                newDate.setMonth(0);
                newDate.setFullYear(newDate.getFullYear() + 1);
              }
            } else {
              newDate.setDate(newDate.getDate() + days);
              return newDate;
            }
          }
          return newDate;
        };
        var writeArrayToMemory = (array, buffer) => {
          GROWABLE_HEAP_I8().set(array, buffer >>> 0);
        };
        function _strftime(s, maxsize, format, tm) {
          s >>>= 0;
          maxsize >>>= 0;
          format >>>= 0;
          tm >>>= 0;
          var tm_zone = GROWABLE_HEAP_I32()[tm + 40 >>> 2];
          var date = { tm_sec: GROWABLE_HEAP_I32()[tm >>> 2], tm_min: GROWABLE_HEAP_I32()[tm + 4 >>> 2], tm_hour: GROWABLE_HEAP_I32()[tm + 8 >>> 2], tm_mday: GROWABLE_HEAP_I32()[tm + 12 >>> 2], tm_mon: GROWABLE_HEAP_I32()[tm + 16 >>> 2], tm_year: GROWABLE_HEAP_I32()[tm + 20 >>> 2], tm_wday: GROWABLE_HEAP_I32()[tm + 24 >>> 2], tm_yday: GROWABLE_HEAP_I32()[tm + 28 >>> 2], tm_isdst: GROWABLE_HEAP_I32()[tm + 32 >>> 2], tm_gmtoff: GROWABLE_HEAP_I32()[tm + 36 >>> 2], tm_zone: tm_zone ? UTF8ToString(tm_zone) : "" };
          var pattern = UTF8ToString(format);
          var EXPANSION_RULES_1 = { "%c": "%a %b %d %H:%M:%S %Y", "%D": "%m/%d/%y", "%F": "%Y-%m-%d", "%h": "%b", "%r": "%I:%M:%S %p", "%R": "%H:%M", "%T": "%H:%M:%S", "%x": "%m/%d/%y", "%X": "%H:%M:%S", "%Ec": "%c", "%EC": "%C", "%Ex": "%m/%d/%y", "%EX": "%H:%M:%S", "%Ey": "%y", "%EY": "%Y", "%Od": "%d", "%Oe": "%e", "%OH": "%H", "%OI": "%I", "%Om": "%m", "%OM": "%M", "%OS": "%S", "%Ou": "%u", "%OU": "%U", "%OV": "%V", "%Ow": "%w", "%OW": "%W", "%Oy": "%y" };
          for (var rule in EXPANSION_RULES_1) {
            pattern = pattern.replace(new RegExp(rule, "g"), EXPANSION_RULES_1[rule]);
          }
          var WEEKDAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
          var MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
          function leadingSomething(value, digits, character) {
            var str = typeof value == "number" ? value.toString() : value || "";
            while (str.length < digits) {
              str = character[0] + str;
            }
            return str;
          }
          function leadingNulls(value, digits) {
            return leadingSomething(value, digits, "0");
          }
          function compareByDay(date1, date2) {
            function sgn(value) {
              return value < 0 ? -1 : value > 0 ? 1 : 0;
            }
            var compare;
            if ((compare = sgn(date1.getFullYear() - date2.getFullYear())) === 0) {
              if ((compare = sgn(date1.getMonth() - date2.getMonth())) === 0) {
                compare = sgn(date1.getDate() - date2.getDate());
              }
            }
            return compare;
          }
          function getFirstWeekStartDate(janFourth) {
            switch (janFourth.getDay()) {
              case 0:
                return new Date(janFourth.getFullYear() - 1, 11, 29);
              case 1:
                return janFourth;
              case 2:
                return new Date(janFourth.getFullYear(), 0, 3);
              case 3:
                return new Date(janFourth.getFullYear(), 0, 2);
              case 4:
                return new Date(janFourth.getFullYear(), 0, 1);
              case 5:
                return new Date(janFourth.getFullYear() - 1, 11, 31);
              case 6:
                return new Date(janFourth.getFullYear() - 1, 11, 30);
            }
          }
          function getWeekBasedYear(date2) {
            var thisDate = addDays(new Date(date2.tm_year + 1900, 0, 1), date2.tm_yday);
            var janFourthThisYear = new Date(thisDate.getFullYear(), 0, 4);
            var janFourthNextYear = new Date(thisDate.getFullYear() + 1, 0, 4);
            var firstWeekStartThisYear = getFirstWeekStartDate(janFourthThisYear);
            var firstWeekStartNextYear = getFirstWeekStartDate(janFourthNextYear);
            if (compareByDay(firstWeekStartThisYear, thisDate) <= 0) {
              if (compareByDay(firstWeekStartNextYear, thisDate) <= 0) {
                return thisDate.getFullYear() + 1;
              }
              return thisDate.getFullYear();
            }
            return thisDate.getFullYear() - 1;
          }
          var EXPANSION_RULES_2 = { "%a": (date2) => WEEKDAYS[date2.tm_wday].substring(0, 3), "%A": (date2) => WEEKDAYS[date2.tm_wday], "%b": (date2) => MONTHS[date2.tm_mon].substring(0, 3), "%B": (date2) => MONTHS[date2.tm_mon], "%C": (date2) => {
            var year = date2.tm_year + 1900;
            return leadingNulls(year / 100 | 0, 2);
          }, "%d": (date2) => leadingNulls(date2.tm_mday, 2), "%e": (date2) => leadingSomething(date2.tm_mday, 2, " "), "%g": (date2) => getWeekBasedYear(date2).toString().substring(2), "%G": (date2) => getWeekBasedYear(date2), "%H": (date2) => leadingNulls(date2.tm_hour, 2), "%I": (date2) => {
            var twelveHour = date2.tm_hour;
            if (twelveHour == 0) twelveHour = 12;
            else if (twelveHour > 12) twelveHour -= 12;
            return leadingNulls(twelveHour, 2);
          }, "%j": (date2) => leadingNulls(date2.tm_mday + arraySum(isLeapYear(date2.tm_year + 1900) ? MONTH_DAYS_LEAP : MONTH_DAYS_REGULAR, date2.tm_mon - 1), 3), "%m": (date2) => leadingNulls(date2.tm_mon + 1, 2), "%M": (date2) => leadingNulls(date2.tm_min, 2), "%n": () => "\n", "%p": (date2) => {
            if (date2.tm_hour >= 0 && date2.tm_hour < 12) {
              return "AM";
            }
            return "PM";
          }, "%S": (date2) => leadingNulls(date2.tm_sec, 2), "%t": () => "	", "%u": (date2) => date2.tm_wday || 7, "%U": (date2) => {
            var days = date2.tm_yday + 7 - date2.tm_wday;
            return leadingNulls(Math.floor(days / 7), 2);
          }, "%V": (date2) => {
            var val = Math.floor((date2.tm_yday + 7 - (date2.tm_wday + 6) % 7) / 7);
            if ((date2.tm_wday + 371 - date2.tm_yday - 2) % 7 <= 2) {
              val++;
            }
            if (!val) {
              val = 52;
              var dec31 = (date2.tm_wday + 7 - date2.tm_yday - 1) % 7;
              if (dec31 == 4 || dec31 == 5 && isLeapYear(date2.tm_year % 400 - 1)) {
                val++;
              }
            } else if (val == 53) {
              var jan1 = (date2.tm_wday + 371 - date2.tm_yday) % 7;
              if (jan1 != 4 && (jan1 != 3 || !isLeapYear(date2.tm_year))) val = 1;
            }
            return leadingNulls(val, 2);
          }, "%w": (date2) => date2.tm_wday, "%W": (date2) => {
            var days = date2.tm_yday + 7 - (date2.tm_wday + 6) % 7;
            return leadingNulls(Math.floor(days / 7), 2);
          }, "%y": (date2) => (date2.tm_year + 1900).toString().substring(2), "%Y": (date2) => date2.tm_year + 1900, "%z": (date2) => {
            var off = date2.tm_gmtoff;
            var ahead = off >= 0;
            off = Math.abs(off) / 60;
            off = off / 60 * 100 + off % 60;
            return (ahead ? "+" : "-") + String("0000" + off).slice(-4);
          }, "%Z": (date2) => date2.tm_zone, "%%": () => "%" };
          pattern = pattern.replace(/%%/g, "\0\0");
          for (var rule in EXPANSION_RULES_2) {
            if (pattern.includes(rule)) {
              pattern = pattern.replace(new RegExp(rule, "g"), EXPANSION_RULES_2[rule](date));
            }
          }
          pattern = pattern.replace(/\0\0/g, "%");
          var bytes = intArrayFromString(pattern, false);
          if (bytes.length > maxsize) {
            return 0;
          }
          writeArrayToMemory(bytes, s);
          return bytes.length - 1;
        }
        function _strftime_l(s, maxsize, format, tm, loc) {
          s >>>= 0;
          maxsize >>>= 0;
          format >>>= 0;
          tm >>>= 0;
          loc >>>= 0;
          return _strftime(s, maxsize, format, tm);
        }
        PThread.init();
        var FSNode = function(parent, name, mode, rdev) {
          if (!parent) {
            parent = this;
          }
          this.parent = parent;
          this.mount = parent.mount;
          this.mounted = null;
          this.id = FS.nextInode++;
          this.name = name;
          this.mode = mode;
          this.node_ops = {};
          this.stream_ops = {};
          this.rdev = rdev;
        };
        var readMode = 292 | 73;
        var writeMode = 146;
        Object.defineProperties(FSNode.prototype, { read: { get: function() {
          return (this.mode & readMode) === readMode;
        }, set: function(val) {
          val ? this.mode |= readMode : this.mode &= ~readMode;
        } }, write: { get: function() {
          return (this.mode & writeMode) === writeMode;
        }, set: function(val) {
          val ? this.mode |= writeMode : this.mode &= ~writeMode;
        } }, isFolder: { get: function() {
          return FS.isDir(this.mode);
        } }, isDevice: { get: function() {
          return FS.isChrdev(this.mode);
        } } });
        FS.FSNode = FSNode;
        FS.createPreloadedFile = FS_createPreloadedFile;
        FS.staticInit();
        InternalError = Module["InternalError"] = class InternalError extends Error {
          constructor(message) {
            super(message);
            this.name = "InternalError";
          }
        };
        embind_init_charCodes();
        BindingError = Module["BindingError"] = class BindingError extends Error {
          constructor(message) {
            super(message);
            this.name = "BindingError";
          }
        };
        init_ClassHandle();
        init_embind();
        init_RegisteredPointer();
        UnboundTypeError = Module["UnboundTypeError"] = extendError(Error, "UnboundTypeError");
        handleAllocatorInit();
        init_emval();
        var proxiedFunctionTable = [null, _proc_exit, exitOnMainThread, _environ_get, _environ_sizes_get, _fd_close, _fd_fdstat_get, _fd_read, _fd_seek, _fd_write];
        var wasmImports = { g: ___cxa_throw, Y: ___emscripten_init_main_thread_js, B: ___emscripten_thread_cleanup, fa: __embind_finalize_value_array, r: __embind_finalize_value_object, K: __embind_register_bigint, da: __embind_register_bool, q: __embind_register_class, p: __embind_register_class_constructor, c: __embind_register_class_function, ca: __embind_register_emval, D: __embind_register_float, d: __embind_register_function, t: __embind_register_integer, l: __embind_register_memory_view, E: __embind_register_std_string, y: __embind_register_std_wstring, ga: __embind_register_value_array, m: __embind_register_value_array_element, s: __embind_register_value_object, f: __embind_register_value_object_field, ea: __embind_register_void, T: __emscripten_get_now_is_monotonic, R: __emscripten_notify_mailbox_postmessage, W: __emscripten_set_offscreencanvas_size, X: __emscripten_thread_mailbox_await, ba: __emscripten_thread_set_strongref, k: __emval_as, x: __emval_call, b: __emval_decref, A: __emval_get_global, i: __emval_get_property, o: __emval_incref, G: __emval_instanceof, z: __emval_is_number, F: __emval_is_string, ha: __emval_new_array, h: __emval_new_cstring, v: __emval_new_object, j: __emval_run_destructors, n: __emval_set_property, e: __emval_take_value, I: __gmtime_js, J: __localtime_js, Q: __tzset_js, w: _abort, C: _emscripten_check_blocking_allowed, U: _emscripten_date_now, aa: _emscripten_exit_with_live_runtime, u: _emscripten_get_now, V: _emscripten_receive_on_main_thread_js, P: _emscripten_resize_heap, _: _environ_get, $: _environ_sizes_get, L: _exit, N: _fd_close, Z: _fd_fdstat_get, O: _fd_read, H: _fd_seek, S: _fd_write, a: wasmMemory || Module["wasmMemory"], M: _strftime_l };
        var asm = createWasm();
        var ___wasm_call_ctors = () => (___wasm_call_ctors = wasmExports["ia"])();
        var _pthread_self = Module["_pthread_self"] = () => (_pthread_self = Module["_pthread_self"] = wasmExports["ja"])();
        var _malloc = (a0) => (_malloc = wasmExports["la"])(a0);
        var __emscripten_tls_init = Module["__emscripten_tls_init"] = () => (__emscripten_tls_init = Module["__emscripten_tls_init"] = wasmExports["ma"])();
        var ___getTypeName = (a0) => (___getTypeName = wasmExports["na"])(a0);
        var __embind_initialize_bindings = Module["__embind_initialize_bindings"] = () => (__embind_initialize_bindings = Module["__embind_initialize_bindings"] = wasmExports["oa"])();
        var ___errno_location = () => (___errno_location = wasmExports["__errno_location"])();
        var __emscripten_thread_init = Module["__emscripten_thread_init"] = (a0, a1, a2, a3, a4, a5) => (__emscripten_thread_init = Module["__emscripten_thread_init"] = wasmExports["pa"])(a0, a1, a2, a3, a4, a5);
        var __emscripten_thread_crashed = Module["__emscripten_thread_crashed"] = () => (__emscripten_thread_crashed = Module["__emscripten_thread_crashed"] = wasmExports["qa"])();
        var _emscripten_main_thread_process_queued_calls = () => (_emscripten_main_thread_process_queued_calls = wasmExports["emscripten_main_thread_process_queued_calls"])();
        var _emscripten_main_runtime_thread_id = () => (_emscripten_main_runtime_thread_id = wasmExports["emscripten_main_runtime_thread_id"])();
        var __emscripten_run_in_main_runtime_thread_js = (a0, a1, a2, a3) => (__emscripten_run_in_main_runtime_thread_js = wasmExports["ra"])(a0, a1, a2, a3);
        var _emscripten_dispatch_to_thread_ = (a0, a1, a2, a3, a4) => (_emscripten_dispatch_to_thread_ = wasmExports["emscripten_dispatch_to_thread_"])(a0, a1, a2, a3, a4);
        var _free = (a0) => (_free = wasmExports["sa"])(a0);
        var __emscripten_thread_free_data = (a0) => (__emscripten_thread_free_data = wasmExports["ta"])(a0);
        var __emscripten_thread_exit = Module["__emscripten_thread_exit"] = (a0) => (__emscripten_thread_exit = Module["__emscripten_thread_exit"] = wasmExports["ua"])(a0);
        var __emscripten_check_mailbox = Module["__emscripten_check_mailbox"] = () => (__emscripten_check_mailbox = Module["__emscripten_check_mailbox"] = wasmExports["va"])();
        var _emscripten_stack_set_limits = (a0, a1) => (_emscripten_stack_set_limits = wasmExports["wa"])(a0, a1);
        var stackSave = () => (stackSave = wasmExports["xa"])();
        var stackRestore = (a0) => (stackRestore = wasmExports["ya"])(a0);
        var stackAlloc = (a0) => (stackAlloc = wasmExports["za"])(a0);
        var ___cxa_increment_exception_refcount = (a0) => (___cxa_increment_exception_refcount = wasmExports["__cxa_increment_exception_refcount"])(a0);
        var ___cxa_is_pointer_type = (a0) => (___cxa_is_pointer_type = wasmExports["Aa"])(a0);
        var dynCall_jiji = Module["dynCall_jiji"] = (a0, a1, a2, a3, a4) => (dynCall_jiji = Module["dynCall_jiji"] = wasmExports["Ba"])(a0, a1, a2, a3, a4);
        var dynCall_viijii = Module["dynCall_viijii"] = (a0, a1, a2, a3, a4, a5, a6) => (dynCall_viijii = Module["dynCall_viijii"] = wasmExports["Ca"])(a0, a1, a2, a3, a4, a5, a6);
        var dynCall_iiiiij = Module["dynCall_iiiiij"] = (a0, a1, a2, a3, a4, a5, a6) => (dynCall_iiiiij = Module["dynCall_iiiiij"] = wasmExports["Da"])(a0, a1, a2, a3, a4, a5, a6);
        var dynCall_iiiiijj = Module["dynCall_iiiiijj"] = (a0, a1, a2, a3, a4, a5, a6, a7, a8) => (dynCall_iiiiijj = Module["dynCall_iiiiijj"] = wasmExports["Ea"])(a0, a1, a2, a3, a4, a5, a6, a7, a8);
        var dynCall_iiiiiijj = Module["dynCall_iiiiiijj"] = (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) => (dynCall_iiiiiijj = Module["dynCall_iiiiiijj"] = wasmExports["Fa"])(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9);
        function applySignatureConversions(exports3) {
          exports3 = Object.assign({}, exports3);
          var makeWrapper_p = (f) => () => f() >>> 0;
          var makeWrapper_pp = (f) => (a0) => f(a0) >>> 0;
          exports3["pthread_self"] = makeWrapper_p(exports3["pthread_self"]);
          exports3["malloc"] = makeWrapper_pp(exports3["malloc"]);
          exports3["__getTypeName"] = makeWrapper_pp(exports3["__getTypeName"]);
          exports3["__errno_location"] = makeWrapper_p(exports3["__errno_location"]);
          exports3["stackSave"] = makeWrapper_p(exports3["stackSave"]);
          exports3["stackAlloc"] = makeWrapper_pp(exports3["stackAlloc"]);
          return exports3;
        }
        Module["keepRuntimeAlive"] = keepRuntimeAlive;
        Module["wasmMemory"] = wasmMemory;
        Module["ExitStatus"] = ExitStatus;
        Module["PThread"] = PThread;
        var calledRun;
        dependenciesFulfilled = function runCaller() {
          if (!calledRun) run();
          if (!calledRun) dependenciesFulfilled = runCaller;
        };
        function run() {
          if (runDependencies > 0) {
            return;
          }
          if (ENVIRONMENT_IS_PTHREAD) {
            readyPromiseResolve(Module);
            initRuntime();
            startWorker(Module);
            return;
          }
          preRun();
          if (runDependencies > 0) {
            return;
          }
          function doRun() {
            if (calledRun) return;
            calledRun = true;
            Module["calledRun"] = true;
            if (ABORT) return;
            initRuntime();
            readyPromiseResolve(Module);
            if (Module["onRuntimeInitialized"]) Module["onRuntimeInitialized"]();
            postRun();
          }
          if (Module["setStatus"]) {
            Module["setStatus"]("Running...");
            setTimeout(function() {
              setTimeout(function() {
                Module["setStatus"]("");
              }, 1);
              doRun();
            }, 1);
          } else {
            doRun();
          }
        }
        if (Module["preInit"]) {
          if (typeof Module["preInit"] == "function") Module["preInit"] = [Module["preInit"]];
          while (Module["preInit"].length > 0) {
            Module["preInit"].pop()();
          }
        }
        run();
        return moduleArg.ready;
      };
    })();
    if (typeof exports2 === "object" && typeof module2 === "object")
      module2.exports = WebIFCWasm2;
    else if (true)
      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (() => WebIFCWasm2).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
});

// dist/web-ifc-node.js
var require_web_ifc_node = __commonJS({
  "dist/web-ifc-node.js"(exports2, module2) {
    "use strict";
    var WebIFCWasm2 = (() => {
      var _scriptDir = typeof document !== "undefined" && document.currentScript ? document.currentScript.src : void 0;
      if (true) _scriptDir = _scriptDir || __filename;
      return function(moduleArg = {}) {
        var Module = moduleArg;
        var readyPromiseResolve, readyPromiseReject;
        Module["ready"] = new Promise((resolve, reject) => {
          readyPromiseResolve = resolve;
          readyPromiseReject = reject;
        });
        var moduleOverrides = Object.assign({}, Module);
        var arguments_ = [];
        var thisProgram = "./this.program";
        var quit_ = (status, toThrow) => {
          throw toThrow;
        };
        var ENVIRONMENT_IS_WEB = typeof window == "object";
        var ENVIRONMENT_IS_WORKER = typeof importScripts == "function";
        var ENVIRONMENT_IS_NODE = typeof process == "object" && typeof process.versions == "object" && typeof process.versions.node == "string";
        var scriptDirectory = "";
        function locateFile(path) {
          if (Module["locateFile"]) {
            return Module["locateFile"](path, scriptDirectory);
          }
          return scriptDirectory + path;
        }
        var read_, readAsync, readBinary, setWindowTitle;
        if (ENVIRONMENT_IS_NODE) {
          var fs = __webpack_require__(6938);
          var nodePath = __webpack_require__(8631);
          if (ENVIRONMENT_IS_WORKER) {
            scriptDirectory = nodePath.dirname(scriptDirectory) + "/";
          } else {
            scriptDirectory = __dirname + "/";
          }
          read_ = (filename, binary) => {
            filename = isFileURI(filename) ? new URL(filename) : nodePath.normalize(filename);
            return fs.readFileSync(filename, binary ? void 0 : "utf8");
          };
          readBinary = (filename) => {
            var ret = read_(filename, true);
            if (!ret.buffer) {
              ret = new Uint8Array(ret);
            }
            return ret;
          };
          readAsync = (filename, onload, onerror, binary = true) => {
            filename = isFileURI(filename) ? new URL(filename) : nodePath.normalize(filename);
            fs.readFile(filename, binary ? void 0 : "utf8", (err2, data) => {
              if (err2) onerror(err2);
              else onload(binary ? data.buffer : data);
            });
          };
          if (!Module["thisProgram"] && process.argv.length > 1) {
            thisProgram = process.argv[1].replace(/\\/g, "/");
          }
          arguments_ = process.argv.slice(2);
          quit_ = (status, toThrow) => {
            process.exitCode = status;
            throw toThrow;
          };
          Module["inspect"] = () => "[Emscripten Module object]";
        } else if (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) {
          if (ENVIRONMENT_IS_WORKER) {
            scriptDirectory = self.location.href;
          } else if (typeof document != "undefined" && document.currentScript) {
            scriptDirectory = document.currentScript.src;
          }
          if (_scriptDir) {
            scriptDirectory = _scriptDir;
          }
          if (scriptDirectory.indexOf("blob:") !== 0) {
            scriptDirectory = scriptDirectory.substr(0, scriptDirectory.replace(/[?#].*/, "").lastIndexOf("/") + 1);
          } else {
            scriptDirectory = "";
          }
          {
            read_ = (url) => {
              var xhr = new XMLHttpRequest();
              xhr.open("GET", url, false);
              xhr.send(null);
              return xhr.responseText;
            };
            if (ENVIRONMENT_IS_WORKER) {
              readBinary = (url) => {
                var xhr = new XMLHttpRequest();
                xhr.open("GET", url, false);
                xhr.responseType = "arraybuffer";
                xhr.send(null);
                return new Uint8Array(xhr.response);
              };
            }
            readAsync = (url, onload, onerror) => {
              var xhr = new XMLHttpRequest();
              xhr.open("GET", url, true);
              xhr.responseType = "arraybuffer";
              xhr.onload = () => {
                if (xhr.status == 200 || xhr.status == 0 && xhr.response) {
                  onload(xhr.response);
                  return;
                }
                onerror();
              };
              xhr.onerror = onerror;
              xhr.send(null);
            };
          }
          setWindowTitle = (title) => document.title = title;
        } else {
        }
        var out = Module["print"] || console.log.bind(console);
        var err = Module["printErr"] || console.error.bind(console);
        Object.assign(Module, moduleOverrides);
        moduleOverrides = null;
        if (Module["arguments"]) arguments_ = Module["arguments"];
        if (Module["thisProgram"]) thisProgram = Module["thisProgram"];
        if (Module["quit"]) quit_ = Module["quit"];
        var wasmBinary;
        if (Module["wasmBinary"]) wasmBinary = Module["wasmBinary"];
        var noExitRuntime = Module["noExitRuntime"] || true;
        if (typeof WebAssembly != "object") {
          abort("no native wasm support detected");
        }
        var wasmMemory;
        var wasmExports;
        var ABORT = false;
        var EXITSTATUS;
        function assert(condition, text) {
          if (!condition) {
            abort(text);
          }
        }
        var HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32, HEAPF64;
        function updateMemoryViews() {
          var b = wasmMemory.buffer;
          Module["HEAP8"] = HEAP8 = new Int8Array(b);
          Module["HEAP16"] = HEAP16 = new Int16Array(b);
          Module["HEAP32"] = HEAP32 = new Int32Array(b);
          Module["HEAPU8"] = HEAPU8 = new Uint8Array(b);
          Module["HEAPU16"] = HEAPU16 = new Uint16Array(b);
          Module["HEAPU32"] = HEAPU32 = new Uint32Array(b);
          Module["HEAPF32"] = HEAPF32 = new Float32Array(b);
          Module["HEAPF64"] = HEAPF64 = new Float64Array(b);
        }
        var wasmTable;
        var __ATPRERUN__ = [];
        var __ATINIT__ = [];
        var __ATPOSTRUN__ = [];
        var runtimeInitialized = false;
        function preRun() {
          if (Module["preRun"]) {
            if (typeof Module["preRun"] == "function") Module["preRun"] = [Module["preRun"]];
            while (Module["preRun"].length) {
              addOnPreRun(Module["preRun"].shift());
            }
          }
          callRuntimeCallbacks(__ATPRERUN__);
        }
        function initRuntime() {
          runtimeInitialized = true;
          if (!Module["noFSInit"] && !FS.init.initialized) FS.init();
          FS.ignorePermissions = false;
          TTY.init();
          callRuntimeCallbacks(__ATINIT__);
        }
        function postRun() {
          if (Module["postRun"]) {
            if (typeof Module["postRun"] == "function") Module["postRun"] = [Module["postRun"]];
            while (Module["postRun"].length) {
              addOnPostRun(Module["postRun"].shift());
            }
          }
          callRuntimeCallbacks(__ATPOSTRUN__);
        }
        function addOnPreRun(cb) {
          __ATPRERUN__.unshift(cb);
        }
        function addOnInit(cb) {
          __ATINIT__.unshift(cb);
        }
        function addOnPostRun(cb) {
          __ATPOSTRUN__.unshift(cb);
        }
        var runDependencies = 0;
        var runDependencyWatcher = null;
        var dependenciesFulfilled = null;
        function getUniqueRunDependency(id) {
          return id;
        }
        function addRunDependency(id) {
          runDependencies++;
          if (Module["monitorRunDependencies"]) {
            Module["monitorRunDependencies"](runDependencies);
          }
        }
        function removeRunDependency(id) {
          runDependencies--;
          if (Module["monitorRunDependencies"]) {
            Module["monitorRunDependencies"](runDependencies);
          }
          if (runDependencies == 0) {
            if (runDependencyWatcher !== null) {
              clearInterval(runDependencyWatcher);
              runDependencyWatcher = null;
            }
            if (dependenciesFulfilled) {
              var callback = dependenciesFulfilled;
              dependenciesFulfilled = null;
              callback();
            }
          }
        }
        function abort(what) {
          if (Module["onAbort"]) {
            Module["onAbort"](what);
          }
          what = "Aborted(" + what + ")";
          err(what);
          ABORT = true;
          EXITSTATUS = 1;
          what += ". Build with -sASSERTIONS for more info.";
          var e = new WebAssembly.RuntimeError(what);
          readyPromiseReject(e);
          throw e;
        }
        var dataURIPrefix = "data:application/octet-stream;base64,";
        function isDataURI(filename) {
          return filename.startsWith(dataURIPrefix);
        }
        function isFileURI(filename) {
          return filename.startsWith("file://");
        }
        var wasmBinaryFile;
        wasmBinaryFile = "web-ifc-node.wasm";
        if (!isDataURI(wasmBinaryFile)) {
          wasmBinaryFile = locateFile(wasmBinaryFile);
        }
        function getBinarySync(file) {
          if (file == wasmBinaryFile && wasmBinary) {
            return new Uint8Array(wasmBinary);
          }
          if (readBinary) {
            return readBinary(file);
          }
          throw "both async and sync fetching of the wasm failed";
        }
        function getBinaryPromise(binaryFile) {
          if (!wasmBinary && (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER)) {
            if (typeof fetch == "function" && !isFileURI(binaryFile)) {
              return fetch(binaryFile, { credentials: "same-origin" }).then((response) => {
                if (!response["ok"]) {
                  throw "failed to load wasm binary file at '" + binaryFile + "'";
                }
                return response["arrayBuffer"]();
              }).catch(() => getBinarySync(binaryFile));
            } else if (readAsync) {
              return new Promise((resolve, reject) => {
                readAsync(binaryFile, (response) => resolve(new Uint8Array(response)), reject);
              });
            }
          }
          return Promise.resolve().then(() => getBinarySync(binaryFile));
        }
        function instantiateArrayBuffer(binaryFile, imports, receiver) {
          return getBinaryPromise(binaryFile).then((binary) => WebAssembly.instantiate(binary, imports)).then((instance) => instance).then(receiver, (reason) => {
            err("failed to asynchronously prepare wasm: " + reason);
            abort(reason);
          });
        }
        function instantiateAsync(binary, binaryFile, imports, callback) {
          if (!binary && typeof WebAssembly.instantiateStreaming == "function" && !isDataURI(binaryFile) && !isFileURI(binaryFile) && !ENVIRONMENT_IS_NODE && typeof fetch == "function") {
            return fetch(binaryFile, { credentials: "same-origin" }).then((response) => {
              var result = WebAssembly.instantiateStreaming(response, imports);
              return result.then(callback, function(reason) {
                err("wasm streaming compile failed: " + reason);
                err("falling back to ArrayBuffer instantiation");
                return instantiateArrayBuffer(binaryFile, imports, callback);
              });
            });
          }
          return instantiateArrayBuffer(binaryFile, imports, callback);
        }
        function createWasm() {
          var info = { "a": wasmImports };
          function receiveInstance(instance, module3) {
            var exports3 = instance.exports;
            exports3 = applySignatureConversions(exports3);
            wasmExports = exports3;
            wasmMemory = wasmExports["Z"];
            updateMemoryViews();
            wasmTable = wasmExports["$"];
            addOnInit(wasmExports["_"]);
            removeRunDependency("wasm-instantiate");
            return exports3;
          }
          addRunDependency("wasm-instantiate");
          function receiveInstantiationResult(result) {
            receiveInstance(result["instance"]);
          }
          if (Module["instantiateWasm"]) {
            try {
              return Module["instantiateWasm"](info, receiveInstance);
            } catch (e) {
              err("Module.instantiateWasm callback failed with error: " + e);
              readyPromiseReject(e);
            }
          }
          instantiateAsync(wasmBinary, wasmBinaryFile, info, receiveInstantiationResult).catch(readyPromiseReject);
          return {};
        }
        var tempDouble;
        var tempI64;
        var callRuntimeCallbacks = (callbacks) => {
          while (callbacks.length > 0) {
            callbacks.shift()(Module);
          }
        };
        function ExceptionInfo(excPtr) {
          this.excPtr = excPtr;
          this.ptr = excPtr - 24;
          this.set_type = function(type) {
            HEAPU32[this.ptr + 4 >>> 2] = type;
          };
          this.get_type = function() {
            return HEAPU32[this.ptr + 4 >>> 2];
          };
          this.set_destructor = function(destructor) {
            HEAPU32[this.ptr + 8 >>> 2] = destructor;
          };
          this.get_destructor = function() {
            return HEAPU32[this.ptr + 8 >>> 2];
          };
          this.set_caught = function(caught) {
            caught = caught ? 1 : 0;
            HEAP8[this.ptr + 12 >>> 0] = caught;
          };
          this.get_caught = function() {
            return HEAP8[this.ptr + 12 >>> 0] != 0;
          };
          this.set_rethrown = function(rethrown) {
            rethrown = rethrown ? 1 : 0;
            HEAP8[this.ptr + 13 >>> 0] = rethrown;
          };
          this.get_rethrown = function() {
            return HEAP8[this.ptr + 13 >>> 0] != 0;
          };
          this.init = function(type, destructor) {
            this.set_adjusted_ptr(0);
            this.set_type(type);
            this.set_destructor(destructor);
          };
          this.set_adjusted_ptr = function(adjustedPtr) {
            HEAPU32[this.ptr + 16 >>> 2] = adjustedPtr;
          };
          this.get_adjusted_ptr = function() {
            return HEAPU32[this.ptr + 16 >>> 2];
          };
          this.get_exception_ptr = function() {
            var isPointer = ___cxa_is_pointer_type(this.get_type());
            if (isPointer) {
              return HEAPU32[this.excPtr >>> 2];
            }
            var adjusted = this.get_adjusted_ptr();
            if (adjusted !== 0) return adjusted;
            return this.excPtr;
          };
        }
        var exceptionLast = 0;
        var uncaughtExceptionCount = 0;
        function convertI32PairToI53Checked(lo, hi) {
          return hi + 2097152 >>> 0 < 4194305 - !!lo ? (lo >>> 0) + hi * 4294967296 : NaN;
        }
        function ___cxa_throw(ptr, type, destructor) {
          ptr >>>= 0;
          type >>>= 0;
          destructor >>>= 0;
          var info = new ExceptionInfo(ptr);
          info.init(type, destructor);
          exceptionLast = ptr;
          uncaughtExceptionCount++;
          throw exceptionLast;
        }
        var tupleRegistrations = {};
        function runDestructors(destructors) {
          while (destructors.length) {
            var ptr = destructors.pop();
            var del = destructors.pop();
            del(ptr);
          }
        }
        function simpleReadValueFromPointer(pointer) {
          return this["fromWireType"](HEAP32[pointer >>> 2]);
        }
        var awaitingDependencies = {};
        var registeredTypes = {};
        var typeDependencies = {};
        var InternalError = void 0;
        function throwInternalError(message) {
          throw new InternalError(message);
        }
        function whenDependentTypesAreResolved(myTypes, dependentTypes, getTypeConverters) {
          myTypes.forEach(function(type) {
            typeDependencies[type] = dependentTypes;
          });
          function onComplete(typeConverters2) {
            var myTypeConverters = getTypeConverters(typeConverters2);
            if (myTypeConverters.length !== myTypes.length) {
              throwInternalError("Mismatched type converter count");
            }
            for (var i = 0; i < myTypes.length; ++i) {
              registerType(myTypes[i], myTypeConverters[i]);
            }
          }
          var typeConverters = new Array(dependentTypes.length);
          var unregisteredTypes = [];
          var registered = 0;
          dependentTypes.forEach((dt, i) => {
            if (registeredTypes.hasOwnProperty(dt)) {
              typeConverters[i] = registeredTypes[dt];
            } else {
              unregisteredTypes.push(dt);
              if (!awaitingDependencies.hasOwnProperty(dt)) {
                awaitingDependencies[dt] = [];
              }
              awaitingDependencies[dt].push(() => {
                typeConverters[i] = registeredTypes[dt];
                ++registered;
                if (registered === unregisteredTypes.length) {
                  onComplete(typeConverters);
                }
              });
            }
          });
          if (0 === unregisteredTypes.length) {
            onComplete(typeConverters);
          }
        }
        function __embind_finalize_value_array(rawTupleType) {
          rawTupleType >>>= 0;
          var reg = tupleRegistrations[rawTupleType];
          delete tupleRegistrations[rawTupleType];
          var elements = reg.elements;
          var elementsLength = elements.length;
          var elementTypes = elements.map(function(elt) {
            return elt.getterReturnType;
          }).concat(elements.map(function(elt) {
            return elt.setterArgumentType;
          }));
          var rawConstructor = reg.rawConstructor;
          var rawDestructor = reg.rawDestructor;
          whenDependentTypesAreResolved([rawTupleType], elementTypes, function(elementTypes2) {
            elements.forEach((elt, i) => {
              var getterReturnType = elementTypes2[i];
              var getter = elt.getter;
              var getterContext = elt.getterContext;
              var setterArgumentType = elementTypes2[i + elementsLength];
              var setter = elt.setter;
              var setterContext = elt.setterContext;
              elt.read = (ptr) => getterReturnType["fromWireType"](getter(getterContext, ptr));
              elt.write = (ptr, o) => {
                var destructors = [];
                setter(setterContext, ptr, setterArgumentType["toWireType"](destructors, o));
                runDestructors(destructors);
              };
            });
            return [{ name: reg.name, "fromWireType": function(ptr) {
              var rv = new Array(elementsLength);
              for (var i = 0; i < elementsLength; ++i) {
                rv[i] = elements[i].read(ptr);
              }
              rawDestructor(ptr);
              return rv;
            }, "toWireType": function(destructors, o) {
              if (elementsLength !== o.length) {
                throw new TypeError(`Incorrect number of tuple elements for ${reg.name}: expected=${elementsLength}, actual=${o.length}`);
              }
              var ptr = rawConstructor();
              for (var i = 0; i < elementsLength; ++i) {
                elements[i].write(ptr, o[i]);
              }
              if (destructors !== null) {
                destructors.push(rawDestructor, ptr);
              }
              return ptr;
            }, "argPackAdvance": 8, "readValueFromPointer": simpleReadValueFromPointer, destructorFunction: rawDestructor }];
          });
        }
        var structRegistrations = {};
        var __embind_finalize_value_object = function(structType) {
          structType >>>= 0;
          var reg = structRegistrations[structType];
          delete structRegistrations[structType];
          var rawConstructor = reg.rawConstructor;
          var rawDestructor = reg.rawDestructor;
          var fieldRecords = reg.fields;
          var fieldTypes = fieldRecords.map((field) => field.getterReturnType).concat(fieldRecords.map((field) => field.setterArgumentType));
          whenDependentTypesAreResolved([structType], fieldTypes, (fieldTypes2) => {
            var fields = {};
            fieldRecords.forEach((field, i) => {
              var fieldName = field.fieldName;
              var getterReturnType = fieldTypes2[i];
              var getter = field.getter;
              var getterContext = field.getterContext;
              var setterArgumentType = fieldTypes2[i + fieldRecords.length];
              var setter = field.setter;
              var setterContext = field.setterContext;
              fields[fieldName] = { read: (ptr) => getterReturnType["fromWireType"](getter(getterContext, ptr)), write: (ptr, o) => {
                var destructors = [];
                setter(setterContext, ptr, setterArgumentType["toWireType"](destructors, o));
                runDestructors(destructors);
              } };
            });
            return [{ name: reg.name, "fromWireType": function(ptr) {
              var rv = {};
              for (var i in fields) {
                rv[i] = fields[i].read(ptr);
              }
              rawDestructor(ptr);
              return rv;
            }, "toWireType": function(destructors, o) {
              for (var fieldName in fields) {
                if (!(fieldName in o)) {
                  throw new TypeError(`Missing field: "${fieldName}"`);
                }
              }
              var ptr = rawConstructor();
              for (fieldName in fields) {
                fields[fieldName].write(ptr, o[fieldName]);
              }
              if (destructors !== null) {
                destructors.push(rawDestructor, ptr);
              }
              return ptr;
            }, "argPackAdvance": 8, "readValueFromPointer": simpleReadValueFromPointer, destructorFunction: rawDestructor }];
          });
        };
        function __embind_register_bigint(primitiveType, name, size, minRange, maxRange) {
          primitiveType >>>= 0;
          name >>>= 0;
          size >>>= 0;
        }
        function getShiftFromSize(size) {
          switch (size) {
            case 1:
              return 0;
            case 2:
              return 1;
            case 4:
              return 2;
            case 8:
              return 3;
            default:
              throw new TypeError(`Unknown type size: ${size}`);
          }
        }
        function embind_init_charCodes() {
          var codes = new Array(256);
          for (var i = 0; i < 256; ++i) {
            codes[i] = String.fromCharCode(i);
          }
          embind_charCodes = codes;
        }
        var embind_charCodes = void 0;
        function readLatin1String(ptr) {
          var ret = "";
          var c = ptr;
          while (HEAPU8[c >>> 0]) {
            ret += embind_charCodes[HEAPU8[c++ >>> 0]];
          }
          return ret;
        }
        var BindingError = void 0;
        function throwBindingError(message) {
          throw new BindingError(message);
        }
        function sharedRegisterType(rawType, registeredInstance, options = {}) {
          var name = registeredInstance.name;
          if (!rawType) {
            throwBindingError(`type "${name}" must have a positive integer typeid pointer`);
          }
          if (registeredTypes.hasOwnProperty(rawType)) {
            if (options.ignoreDuplicateRegistrations) {
              return;
            } else {
              throwBindingError(`Cannot register type '${name}' twice`);
            }
          }
          registeredTypes[rawType] = registeredInstance;
          delete typeDependencies[rawType];
          if (awaitingDependencies.hasOwnProperty(rawType)) {
            var callbacks = awaitingDependencies[rawType];
            delete awaitingDependencies[rawType];
            callbacks.forEach((cb) => cb());
          }
        }
        function registerType(rawType, registeredInstance, options = {}) {
          if (!("argPackAdvance" in registeredInstance)) {
            throw new TypeError("registerType registeredInstance requires argPackAdvance");
          }
          return sharedRegisterType(rawType, registeredInstance, options);
        }
        function __embind_register_bool(rawType, name, size, trueValue, falseValue) {
          rawType >>>= 0;
          name >>>= 0;
          size >>>= 0;
          var shift = getShiftFromSize(size);
          name = readLatin1String(name);
          registerType(rawType, { name, "fromWireType": function(wt) {
            return !!wt;
          }, "toWireType": function(destructors, o) {
            return o ? trueValue : falseValue;
          }, "argPackAdvance": 8, "readValueFromPointer": function(pointer) {
            var heap;
            if (size === 1) {
              heap = HEAP8;
            } else if (size === 2) {
              heap = HEAP16;
            } else if (size === 4) {
              heap = HEAP32;
            } else {
              throw new TypeError("Unknown boolean type size: " + name);
            }
            return this["fromWireType"](heap[pointer >>> shift]);
          }, destructorFunction: null });
        }
        function ClassHandle_isAliasOf(other) {
          if (!(this instanceof ClassHandle)) {
            return false;
          }
          if (!(other instanceof ClassHandle)) {
            return false;
          }
          var leftClass = this.$$.ptrType.registeredClass;
          var left = this.$$.ptr;
          var rightClass = other.$$.ptrType.registeredClass;
          var right = other.$$.ptr;
          while (leftClass.baseClass) {
            left = leftClass.upcast(left);
            leftClass = leftClass.baseClass;
          }
          while (rightClass.baseClass) {
            right = rightClass.upcast(right);
            rightClass = rightClass.baseClass;
          }
          return leftClass === rightClass && left === right;
        }
        function shallowCopyInternalPointer(o) {
          return { count: o.count, deleteScheduled: o.deleteScheduled, preservePointerOnDelete: o.preservePointerOnDelete, ptr: o.ptr, ptrType: o.ptrType, smartPtr: o.smartPtr, smartPtrType: o.smartPtrType };
        }
        function throwInstanceAlreadyDeleted(obj) {
          function getInstanceTypeName(handle) {
            return handle.$$.ptrType.registeredClass.name;
          }
          throwBindingError(getInstanceTypeName(obj) + " instance already deleted");
        }
        var finalizationRegistry = false;
        function detachFinalizer(handle) {
        }
        function runDestructor($$) {
          if ($$.smartPtr) {
            $$.smartPtrType.rawDestructor($$.smartPtr);
          } else {
            $$.ptrType.registeredClass.rawDestructor($$.ptr);
          }
        }
        function releaseClassHandle($$) {
          $$.count.value -= 1;
          var toDelete = 0 === $$.count.value;
          if (toDelete) {
            runDestructor($$);
          }
        }
        function downcastPointer(ptr, ptrClass, desiredClass) {
          if (ptrClass === desiredClass) {
            return ptr;
          }
          if (void 0 === desiredClass.baseClass) {
            return null;
          }
          var rv = downcastPointer(ptr, ptrClass, desiredClass.baseClass);
          if (rv === null) {
            return null;
          }
          return desiredClass.downcast(rv);
        }
        var registeredPointers = {};
        function getInheritedInstanceCount() {
          return Object.keys(registeredInstances).length;
        }
        function getLiveInheritedInstances() {
          var rv = [];
          for (var k in registeredInstances) {
            if (registeredInstances.hasOwnProperty(k)) {
              rv.push(registeredInstances[k]);
            }
          }
          return rv;
        }
        var deletionQueue = [];
        function flushPendingDeletes() {
          while (deletionQueue.length) {
            var obj = deletionQueue.pop();
            obj.$$.deleteScheduled = false;
            obj["delete"]();
          }
        }
        var delayFunction = void 0;
        function setDelayFunction(fn) {
          delayFunction = fn;
          if (deletionQueue.length && delayFunction) {
            delayFunction(flushPendingDeletes);
          }
        }
        function init_embind() {
          Module["getInheritedInstanceCount"] = getInheritedInstanceCount;
          Module["getLiveInheritedInstances"] = getLiveInheritedInstances;
          Module["flushPendingDeletes"] = flushPendingDeletes;
          Module["setDelayFunction"] = setDelayFunction;
        }
        var registeredInstances = {};
        function getBasestPointer(class_, ptr) {
          if (ptr === void 0) {
            throwBindingError("ptr should not be undefined");
          }
          while (class_.baseClass) {
            ptr = class_.upcast(ptr);
            class_ = class_.baseClass;
          }
          return ptr;
        }
        function getInheritedInstance(class_, ptr) {
          ptr = getBasestPointer(class_, ptr);
          return registeredInstances[ptr];
        }
        function makeClassHandle(prototype, record) {
          if (!record.ptrType || !record.ptr) {
            throwInternalError("makeClassHandle requires ptr and ptrType");
          }
          var hasSmartPtrType = !!record.smartPtrType;
          var hasSmartPtr = !!record.smartPtr;
          if (hasSmartPtrType !== hasSmartPtr) {
            throwInternalError("Both smartPtrType and smartPtr must be specified");
          }
          record.count = { value: 1 };
          return attachFinalizer(Object.create(prototype, { $$: { value: record } }));
        }
        function RegisteredPointer_fromWireType(ptr) {
          var rawPointer = this.getPointee(ptr);
          if (!rawPointer) {
            this.destructor(ptr);
            return null;
          }
          var registeredInstance = getInheritedInstance(this.registeredClass, rawPointer);
          if (void 0 !== registeredInstance) {
            if (0 === registeredInstance.$$.count.value) {
              registeredInstance.$$.ptr = rawPointer;
              registeredInstance.$$.smartPtr = ptr;
              return registeredInstance["clone"]();
            } else {
              var rv = registeredInstance["clone"]();
              this.destructor(ptr);
              return rv;
            }
          }
          function makeDefaultHandle() {
            if (this.isSmartPointer) {
              return makeClassHandle(this.registeredClass.instancePrototype, { ptrType: this.pointeeType, ptr: rawPointer, smartPtrType: this, smartPtr: ptr });
            } else {
              return makeClassHandle(this.registeredClass.instancePrototype, { ptrType: this, ptr });
            }
          }
          var actualType = this.registeredClass.getActualType(rawPointer);
          var registeredPointerRecord = registeredPointers[actualType];
          if (!registeredPointerRecord) {
            return makeDefaultHandle.call(this);
          }
          var toType;
          if (this.isConst) {
            toType = registeredPointerRecord.constPointerType;
          } else {
            toType = registeredPointerRecord.pointerType;
          }
          var dp = downcastPointer(rawPointer, this.registeredClass, toType.registeredClass);
          if (dp === null) {
            return makeDefaultHandle.call(this);
          }
          if (this.isSmartPointer) {
            return makeClassHandle(toType.registeredClass.instancePrototype, { ptrType: toType, ptr: dp, smartPtrType: this, smartPtr: ptr });
          } else {
            return makeClassHandle(toType.registeredClass.instancePrototype, { ptrType: toType, ptr: dp });
          }
        }
        var attachFinalizer = function(handle) {
          if ("undefined" === typeof FinalizationRegistry) {
            attachFinalizer = (handle2) => handle2;
            return handle;
          }
          finalizationRegistry = new FinalizationRegistry((info) => {
            releaseClassHandle(info.$$);
          });
          attachFinalizer = (handle2) => {
            var $$ = handle2.$$;
            var hasSmartPtr = !!$$.smartPtr;
            if (hasSmartPtr) {
              var info = { $$ };
              finalizationRegistry.register(handle2, info, handle2);
            }
            return handle2;
          };
          detachFinalizer = (handle2) => finalizationRegistry.unregister(handle2);
          return attachFinalizer(handle);
        };
        function ClassHandle_clone() {
          if (!this.$$.ptr) {
            throwInstanceAlreadyDeleted(this);
          }
          if (this.$$.preservePointerOnDelete) {
            this.$$.count.value += 1;
            return this;
          } else {
            var clone = attachFinalizer(Object.create(Object.getPrototypeOf(this), { $$: { value: shallowCopyInternalPointer(this.$$) } }));
            clone.$$.count.value += 1;
            clone.$$.deleteScheduled = false;
            return clone;
          }
        }
        function ClassHandle_delete() {
          if (!this.$$.ptr) {
            throwInstanceAlreadyDeleted(this);
          }
          if (this.$$.deleteScheduled && !this.$$.preservePointerOnDelete) {
            throwBindingError("Object already scheduled for deletion");
          }
          detachFinalizer(this);
          releaseClassHandle(this.$$);
          if (!this.$$.preservePointerOnDelete) {
            this.$$.smartPtr = void 0;
            this.$$.ptr = void 0;
          }
        }
        function ClassHandle_isDeleted() {
          return !this.$$.ptr;
        }
        function ClassHandle_deleteLater() {
          if (!this.$$.ptr) {
            throwInstanceAlreadyDeleted(this);
          }
          if (this.$$.deleteScheduled && !this.$$.preservePointerOnDelete) {
            throwBindingError("Object already scheduled for deletion");
          }
          deletionQueue.push(this);
          if (deletionQueue.length === 1 && delayFunction) {
            delayFunction(flushPendingDeletes);
          }
          this.$$.deleteScheduled = true;
          return this;
        }
        function init_ClassHandle() {
          ClassHandle.prototype["isAliasOf"] = ClassHandle_isAliasOf;
          ClassHandle.prototype["clone"] = ClassHandle_clone;
          ClassHandle.prototype["delete"] = ClassHandle_delete;
          ClassHandle.prototype["isDeleted"] = ClassHandle_isDeleted;
          ClassHandle.prototype["deleteLater"] = ClassHandle_deleteLater;
        }
        function ClassHandle() {
        }
        var char_0 = 48;
        var char_9 = 57;
        function makeLegalFunctionName(name) {
          if (void 0 === name) {
            return "_unknown";
          }
          name = name.replace(/[^a-zA-Z0-9_]/g, "$");
          var f = name.charCodeAt(0);
          if (f >= char_0 && f <= char_9) {
            return `_${name}`;
          }
          return name;
        }
        function createNamedFunction(name, body) {
          name = makeLegalFunctionName(name);
          return { [name]: function() {
            return body.apply(this, arguments);
          } }[name];
        }
        function ensureOverloadTable(proto, methodName, humanName) {
          if (void 0 === proto[methodName].overloadTable) {
            var prevFunc = proto[methodName];
            proto[methodName] = function() {
              if (!proto[methodName].overloadTable.hasOwnProperty(arguments.length)) {
                throwBindingError(`Function '${humanName}' called with an invalid number of arguments (${arguments.length}) - expects one of (${proto[methodName].overloadTable})!`);
              }
              return proto[methodName].overloadTable[arguments.length].apply(this, arguments);
            };
            proto[methodName].overloadTable = [];
            proto[methodName].overloadTable[prevFunc.argCount] = prevFunc;
          }
        }
        function exposePublicSymbol(name, value, numArguments) {
          if (Module.hasOwnProperty(name)) {
            if (void 0 === numArguments || void 0 !== Module[name].overloadTable && void 0 !== Module[name].overloadTable[numArguments]) {
              throwBindingError(`Cannot register public name '${name}' twice`);
            }
            ensureOverloadTable(Module, name, name);
            if (Module.hasOwnProperty(numArguments)) {
              throwBindingError(`Cannot register multiple overloads of a function with the same number of arguments (${numArguments})!`);
            }
            Module[name].overloadTable[numArguments] = value;
          } else {
            Module[name] = value;
            if (void 0 !== numArguments) {
              Module[name].numArguments = numArguments;
            }
          }
        }
        function RegisteredClass(name, constructor, instancePrototype, rawDestructor, baseClass, getActualType, upcast, downcast) {
          this.name = name;
          this.constructor = constructor;
          this.instancePrototype = instancePrototype;
          this.rawDestructor = rawDestructor;
          this.baseClass = baseClass;
          this.getActualType = getActualType;
          this.upcast = upcast;
          this.downcast = downcast;
          this.pureVirtualFunctions = [];
        }
        function upcastPointer(ptr, ptrClass, desiredClass) {
          while (ptrClass !== desiredClass) {
            if (!ptrClass.upcast) {
              throwBindingError(`Expected null or instance of ${desiredClass.name}, got an instance of ${ptrClass.name}`);
            }
            ptr = ptrClass.upcast(ptr);
            ptrClass = ptrClass.baseClass;
          }
          return ptr;
        }
        function constNoSmartPtrRawPointerToWireType(destructors, handle) {
          if (handle === null) {
            if (this.isReference) {
              throwBindingError(`null is not a valid ${this.name}`);
            }
            return 0;
          }
          if (!handle.$$) {
            throwBindingError(`Cannot pass "${embindRepr(handle)}" as a ${this.name}`);
          }
          if (!handle.$$.ptr) {
            throwBindingError(`Cannot pass deleted object as a pointer of type ${this.name}`);
          }
          var handleClass = handle.$$.ptrType.registeredClass;
          var ptr = upcastPointer(handle.$$.ptr, handleClass, this.registeredClass);
          return ptr;
        }
        function genericPointerToWireType(destructors, handle) {
          var ptr;
          if (handle === null) {
            if (this.isReference) {
              throwBindingError(`null is not a valid ${this.name}`);
            }
            if (this.isSmartPointer) {
              ptr = this.rawConstructor();
              if (destructors !== null) {
                destructors.push(this.rawDestructor, ptr);
              }
              return ptr;
            } else {
              return 0;
            }
          }
          if (!handle.$$) {
            throwBindingError(`Cannot pass "${embindRepr(handle)}" as a ${this.name}`);
          }
          if (!handle.$$.ptr) {
            throwBindingError(`Cannot pass deleted object as a pointer of type ${this.name}`);
          }
          if (!this.isConst && handle.$$.ptrType.isConst) {
            throwBindingError(`Cannot convert argument of type ${handle.$$.smartPtrType ? handle.$$.smartPtrType.name : handle.$$.ptrType.name} to parameter type ${this.name}`);
          }
          var handleClass = handle.$$.ptrType.registeredClass;
          ptr = upcastPointer(handle.$$.ptr, handleClass, this.registeredClass);
          if (this.isSmartPointer) {
            if (void 0 === handle.$$.smartPtr) {
              throwBindingError("Passing raw pointer to smart pointer is illegal");
            }
            switch (this.sharingPolicy) {
              case 0:
                if (handle.$$.smartPtrType === this) {
                  ptr = handle.$$.smartPtr;
                } else {
                  throwBindingError(`Cannot convert argument of type ${handle.$$.smartPtrType ? handle.$$.smartPtrType.name : handle.$$.ptrType.name} to parameter type ${this.name}`);
                }
                break;
              case 1:
                ptr = handle.$$.smartPtr;
                break;
              case 2:
                if (handle.$$.smartPtrType === this) {
                  ptr = handle.$$.smartPtr;
                } else {
                  var clonedHandle = handle["clone"]();
                  ptr = this.rawShare(ptr, Emval.toHandle(function() {
                    clonedHandle["delete"]();
                  }));
                  if (destructors !== null) {
                    destructors.push(this.rawDestructor, ptr);
                  }
                }
                break;
              default:
                throwBindingError("Unsupporting sharing policy");
            }
          }
          return ptr;
        }
        function nonConstNoSmartPtrRawPointerToWireType(destructors, handle) {
          if (handle === null) {
            if (this.isReference) {
              throwBindingError(`null is not a valid ${this.name}`);
            }
            return 0;
          }
          if (!handle.$$) {
            throwBindingError(`Cannot pass "${embindRepr(handle)}" as a ${this.name}`);
          }
          if (!handle.$$.ptr) {
            throwBindingError(`Cannot pass deleted object as a pointer of type ${this.name}`);
          }
          if (handle.$$.ptrType.isConst) {
            throwBindingError(`Cannot convert argument of type ${handle.$$.ptrType.name} to parameter type ${this.name}`);
          }
          var handleClass = handle.$$.ptrType.registeredClass;
          var ptr = upcastPointer(handle.$$.ptr, handleClass, this.registeredClass);
          return ptr;
        }
        function RegisteredPointer_getPointee(ptr) {
          if (this.rawGetPointee) {
            ptr = this.rawGetPointee(ptr);
          }
          return ptr;
        }
        function RegisteredPointer_destructor(ptr) {
          if (this.rawDestructor) {
            this.rawDestructor(ptr);
          }
        }
        function RegisteredPointer_deleteObject(handle) {
          if (handle !== null) {
            handle["delete"]();
          }
        }
        function init_RegisteredPointer() {
          RegisteredPointer.prototype.getPointee = RegisteredPointer_getPointee;
          RegisteredPointer.prototype.destructor = RegisteredPointer_destructor;
          RegisteredPointer.prototype["argPackAdvance"] = 8;
          RegisteredPointer.prototype["readValueFromPointer"] = simpleReadValueFromPointer;
          RegisteredPointer.prototype["deleteObject"] = RegisteredPointer_deleteObject;
          RegisteredPointer.prototype["fromWireType"] = RegisteredPointer_fromWireType;
        }
        function RegisteredPointer(name, registeredClass, isReference, isConst, isSmartPointer, pointeeType, sharingPolicy, rawGetPointee, rawConstructor, rawShare, rawDestructor) {
          this.name = name;
          this.registeredClass = registeredClass;
          this.isReference = isReference;
          this.isConst = isConst;
          this.isSmartPointer = isSmartPointer;
          this.pointeeType = pointeeType;
          this.sharingPolicy = sharingPolicy;
          this.rawGetPointee = rawGetPointee;
          this.rawConstructor = rawConstructor;
          this.rawShare = rawShare;
          this.rawDestructor = rawDestructor;
          if (!isSmartPointer && registeredClass.baseClass === void 0) {
            if (isConst) {
              this["toWireType"] = constNoSmartPtrRawPointerToWireType;
              this.destructorFunction = null;
            } else {
              this["toWireType"] = nonConstNoSmartPtrRawPointerToWireType;
              this.destructorFunction = null;
            }
          } else {
            this["toWireType"] = genericPointerToWireType;
          }
        }
        function replacePublicSymbol(name, value, numArguments) {
          if (!Module.hasOwnProperty(name)) {
            throwInternalError("Replacing nonexistant public symbol");
          }
          if (void 0 !== Module[name].overloadTable && void 0 !== numArguments) {
            Module[name].overloadTable[numArguments] = value;
          } else {
            Module[name] = value;
            Module[name].argCount = numArguments;
          }
        }
        var dynCallLegacy = (sig, ptr, args) => {
          var f = Module["dynCall_" + sig];
          return args && args.length ? f.apply(null, [ptr].concat(args)) : f.call(null, ptr);
        };
        var wasmTableMirror = [];
        var getWasmTableEntry = (funcPtr) => {
          var func = wasmTableMirror[funcPtr];
          if (!func) {
            if (funcPtr >= wasmTableMirror.length) wasmTableMirror.length = funcPtr + 1;
            wasmTableMirror[funcPtr] = func = wasmTable.get(funcPtr);
          }
          return func;
        };
        var dynCall = (sig, ptr, args) => {
          if (sig.includes("j")) {
            return dynCallLegacy(sig, ptr, args);
          }
          var rtn = getWasmTableEntry(ptr).apply(null, args);
          return rtn;
        };
        var getDynCaller = (sig, ptr) => {
          var argCache = [];
          return function() {
            argCache.length = 0;
            Object.assign(argCache, arguments);
            return dynCall(sig, ptr, argCache);
          };
        };
        function embind__requireFunction(signature, rawFunction) {
          signature = readLatin1String(signature);
          function makeDynCaller() {
            if (signature.includes("j")) {
              return getDynCaller(signature, rawFunction);
            }
            return getWasmTableEntry(rawFunction);
          }
          var fp = makeDynCaller();
          if (typeof fp != "function") {
            throwBindingError(`unknown function pointer with signature ${signature}: ${rawFunction}`);
          }
          return fp;
        }
        function extendError(baseErrorType, errorName) {
          var errorClass = createNamedFunction(errorName, function(message) {
            this.name = errorName;
            this.message = message;
            var stack = new Error(message).stack;
            if (stack !== void 0) {
              this.stack = this.toString() + "\n" + stack.replace(/^Error(:[^\n]*)?\n/, "");
            }
          });
          errorClass.prototype = Object.create(baseErrorType.prototype);
          errorClass.prototype.constructor = errorClass;
          errorClass.prototype.toString = function() {
            if (this.message === void 0) {
              return this.name;
            } else {
              return `${this.name}: ${this.message}`;
            }
          };
          return errorClass;
        }
        var UnboundTypeError = void 0;
        function getTypeName(type) {
          var ptr = ___getTypeName(type);
          var rv = readLatin1String(ptr);
          _free(ptr);
          return rv;
        }
        function throwUnboundTypeError(message, types) {
          var unboundTypes = [];
          var seen = {};
          function visit(type) {
            if (seen[type]) {
              return;
            }
            if (registeredTypes[type]) {
              return;
            }
            if (typeDependencies[type]) {
              typeDependencies[type].forEach(visit);
              return;
            }
            unboundTypes.push(type);
            seen[type] = true;
          }
          types.forEach(visit);
          throw new UnboundTypeError(`${message}: ` + unboundTypes.map(getTypeName).join([", "]));
        }
        function __embind_register_class(rawType, rawPointerType, rawConstPointerType, baseClassRawType, getActualTypeSignature, getActualType, upcastSignature, upcast, downcastSignature, downcast, name, destructorSignature, rawDestructor) {
          rawType >>>= 0;
          rawPointerType >>>= 0;
          rawConstPointerType >>>= 0;
          baseClassRawType >>>= 0;
          getActualTypeSignature >>>= 0;
          getActualType >>>= 0;
          upcastSignature >>>= 0;
          upcast >>>= 0;
          downcastSignature >>>= 0;
          downcast >>>= 0;
          name >>>= 0;
          destructorSignature >>>= 0;
          rawDestructor >>>= 0;
          name = readLatin1String(name);
          getActualType = embind__requireFunction(getActualTypeSignature, getActualType);
          if (upcast) {
            upcast = embind__requireFunction(upcastSignature, upcast);
          }
          if (downcast) {
            downcast = embind__requireFunction(downcastSignature, downcast);
          }
          rawDestructor = embind__requireFunction(destructorSignature, rawDestructor);
          var legalFunctionName = makeLegalFunctionName(name);
          exposePublicSymbol(legalFunctionName, function() {
            throwUnboundTypeError(`Cannot construct ${name} due to unbound types`, [baseClassRawType]);
          });
          whenDependentTypesAreResolved([rawType, rawPointerType, rawConstPointerType], baseClassRawType ? [baseClassRawType] : [], function(base) {
            base = base[0];
            var baseClass;
            var basePrototype;
            if (baseClassRawType) {
              baseClass = base.registeredClass;
              basePrototype = baseClass.instancePrototype;
            } else {
              basePrototype = ClassHandle.prototype;
            }
            var constructor = createNamedFunction(legalFunctionName, function() {
              if (Object.getPrototypeOf(this) !== instancePrototype) {
                throw new BindingError("Use 'new' to construct " + name);
              }
              if (void 0 === registeredClass.constructor_body) {
                throw new BindingError(name + " has no accessible constructor");
              }
              var body = registeredClass.constructor_body[arguments.length];
              if (void 0 === body) {
                throw new BindingError(`Tried to invoke ctor of ${name} with invalid number of parameters (${arguments.length}) - expected (${Object.keys(registeredClass.constructor_body).toString()}) parameters instead!`);
              }
              return body.apply(this, arguments);
            });
            var instancePrototype = Object.create(basePrototype, { constructor: { value: constructor } });
            constructor.prototype = instancePrototype;
            var registeredClass = new RegisteredClass(name, constructor, instancePrototype, rawDestructor, baseClass, getActualType, upcast, downcast);
            if (registeredClass.baseClass) {
              if (registeredClass.baseClass.__derivedClasses === void 0) {
                registeredClass.baseClass.__derivedClasses = [];
              }
              registeredClass.baseClass.__derivedClasses.push(registeredClass);
            }
            var referenceConverter = new RegisteredPointer(name, registeredClass, true, false, false);
            var pointerConverter = new RegisteredPointer(name + "*", registeredClass, false, false, false);
            var constPointerConverter = new RegisteredPointer(name + " const*", registeredClass, false, true, false);
            registeredPointers[rawType] = { pointerType: pointerConverter, constPointerType: constPointerConverter };
            replacePublicSymbol(legalFunctionName, constructor);
            return [referenceConverter, pointerConverter, constPointerConverter];
          });
        }
        function heap32VectorToArray(count, firstElement) {
          var array = [];
          for (var i = 0; i < count; i++) {
            array.push(HEAPU32[firstElement + i * 4 >>> 2]);
          }
          return array;
        }
        function newFunc(constructor, argumentList) {
          if (!(constructor instanceof Function)) {
            throw new TypeError(`new_ called with constructor type ${typeof constructor} which is not a function`);
          }
          var dummy = createNamedFunction(constructor.name || "unknownFunctionName", function() {
          });
          dummy.prototype = constructor.prototype;
          var obj = new dummy();
          var r = constructor.apply(obj, argumentList);
          return r instanceof Object ? r : obj;
        }
        function craftInvokerFunction(humanName, argTypes, classType, cppInvokerFunc, cppTargetFunc, isAsync) {
          var argCount = argTypes.length;
          if (argCount < 2) {
            throwBindingError("argTypes array size mismatch! Must at least get return value and 'this' types!");
          }
          var isClassMethodFunc = argTypes[1] !== null && classType !== null;
          var needsDestructorStack = false;
          for (var i = 1; i < argTypes.length; ++i) {
            if (argTypes[i] !== null && argTypes[i].destructorFunction === void 0) {
              needsDestructorStack = true;
              break;
            }
          }
          var returns = argTypes[0].name !== "void";
          var argsList = "";
          var argsListWired = "";
          for (var i = 0; i < argCount - 2; ++i) {
            argsList += (i !== 0 ? ", " : "") + "arg" + i;
            argsListWired += (i !== 0 ? ", " : "") + "arg" + i + "Wired";
          }
          var invokerFnBody = `
        return function ${makeLegalFunctionName(humanName)}(${argsList}) {
        if (arguments.length !== ${argCount - 2}) {
          throwBindingError('function ${humanName} called with ${arguments.length} arguments, expected ${argCount - 2} args!');
        }`;
          if (needsDestructorStack) {
            invokerFnBody += "var destructors = [];\n";
          }
          var dtorStack = needsDestructorStack ? "destructors" : "null";
          var args1 = ["throwBindingError", "invoker", "fn", "runDestructors", "retType", "classParam"];
          var args2 = [throwBindingError, cppInvokerFunc, cppTargetFunc, runDestructors, argTypes[0], argTypes[1]];
          if (isClassMethodFunc) {
            invokerFnBody += "var thisWired = classParam.toWireType(" + dtorStack + ", this);\n";
          }
          for (var i = 0; i < argCount - 2; ++i) {
            invokerFnBody += "var arg" + i + "Wired = argType" + i + ".toWireType(" + dtorStack + ", arg" + i + "); // " + argTypes[i + 2].name + "\n";
            args1.push("argType" + i);
            args2.push(argTypes[i + 2]);
          }
          if (isClassMethodFunc) {
            argsListWired = "thisWired" + (argsListWired.length > 0 ? ", " : "") + argsListWired;
          }
          invokerFnBody += (returns || isAsync ? "var rv = " : "") + "invoker(fn" + (argsListWired.length > 0 ? ", " : "") + argsListWired + ");\n";
          if (needsDestructorStack) {
            invokerFnBody += "runDestructors(destructors);\n";
          } else {
            for (var i = isClassMethodFunc ? 1 : 2; i < argTypes.length; ++i) {
              var paramName = i === 1 ? "thisWired" : "arg" + (i - 2) + "Wired";
              if (argTypes[i].destructorFunction !== null) {
                invokerFnBody += paramName + "_dtor(" + paramName + "); // " + argTypes[i].name + "\n";
                args1.push(paramName + "_dtor");
                args2.push(argTypes[i].destructorFunction);
              }
            }
          }
          if (returns) {
            invokerFnBody += "var ret = retType.fromWireType(rv);\nreturn ret;\n";
          } else {
          }
          invokerFnBody += "}\n";
          args1.push(invokerFnBody);
          return newFunc(Function, args1).apply(null, args2);
        }
        function __embind_register_class_constructor(rawClassType, argCount, rawArgTypesAddr, invokerSignature, invoker, rawConstructor) {
          rawClassType >>>= 0;
          rawArgTypesAddr >>>= 0;
          invokerSignature >>>= 0;
          invoker >>>= 0;
          rawConstructor >>>= 0;
          var rawArgTypes = heap32VectorToArray(argCount, rawArgTypesAddr);
          invoker = embind__requireFunction(invokerSignature, invoker);
          whenDependentTypesAreResolved([], [rawClassType], function(classType) {
            classType = classType[0];
            var humanName = `constructor ${classType.name}`;
            if (void 0 === classType.registeredClass.constructor_body) {
              classType.registeredClass.constructor_body = [];
            }
            if (void 0 !== classType.registeredClass.constructor_body[argCount - 1]) {
              throw new BindingError(`Cannot register multiple constructors with identical number of parameters (${argCount - 1}) for class '${classType.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`);
            }
            classType.registeredClass.constructor_body[argCount - 1] = () => {
              throwUnboundTypeError(`Cannot construct ${classType.name} due to unbound types`, rawArgTypes);
            };
            whenDependentTypesAreResolved([], rawArgTypes, function(argTypes) {
              argTypes.splice(1, 0, null);
              classType.registeredClass.constructor_body[argCount - 1] = craftInvokerFunction(humanName, argTypes, null, invoker, rawConstructor);
              return [];
            });
            return [];
          });
        }
        function __embind_register_class_function(rawClassType, methodName, argCount, rawArgTypesAddr, invokerSignature, rawInvoker, context, isPureVirtual, isAsync) {
          rawClassType >>>= 0;
          methodName >>>= 0;
          rawArgTypesAddr >>>= 0;
          invokerSignature >>>= 0;
          rawInvoker >>>= 0;
          context >>>= 0;
          var rawArgTypes = heap32VectorToArray(argCount, rawArgTypesAddr);
          methodName = readLatin1String(methodName);
          rawInvoker = embind__requireFunction(invokerSignature, rawInvoker);
          whenDependentTypesAreResolved([], [rawClassType], function(classType) {
            classType = classType[0];
            var humanName = `${classType.name}.${methodName}`;
            if (methodName.startsWith("@@")) {
              methodName = Symbol[methodName.substring(2)];
            }
            if (isPureVirtual) {
              classType.registeredClass.pureVirtualFunctions.push(methodName);
            }
            function unboundTypesHandler() {
              throwUnboundTypeError(`Cannot call ${humanName} due to unbound types`, rawArgTypes);
            }
            var proto = classType.registeredClass.instancePrototype;
            var method = proto[methodName];
            if (void 0 === method || void 0 === method.overloadTable && method.className !== classType.name && method.argCount === argCount - 2) {
              unboundTypesHandler.argCount = argCount - 2;
              unboundTypesHandler.className = classType.name;
              proto[methodName] = unboundTypesHandler;
            } else {
              ensureOverloadTable(proto, methodName, humanName);
              proto[methodName].overloadTable[argCount - 2] = unboundTypesHandler;
            }
            whenDependentTypesAreResolved([], rawArgTypes, function(argTypes) {
              var memberFunction = craftInvokerFunction(humanName, argTypes, classType, rawInvoker, context, isAsync);
              if (void 0 === proto[methodName].overloadTable) {
                memberFunction.argCount = argCount - 2;
                proto[methodName] = memberFunction;
              } else {
                proto[methodName].overloadTable[argCount - 2] = memberFunction;
              }
              return [];
            });
            return [];
          });
        }
        function handleAllocatorInit() {
          Object.assign(HandleAllocator.prototype, { get(id) {
            return this.allocated[id];
          }, has(id) {
            return this.allocated[id] !== void 0;
          }, allocate(handle) {
            var id = this.freelist.pop() || this.allocated.length;
            this.allocated[id] = handle;
            return id;
          }, free(id) {
            this.allocated[id] = void 0;
            this.freelist.push(id);
          } });
        }
        function HandleAllocator() {
          this.allocated = [void 0];
          this.freelist = [];
        }
        var emval_handles = new HandleAllocator();
        function __emval_decref(handle) {
          handle >>>= 0;
          if (handle >= emval_handles.reserved && 0 === --emval_handles.get(handle).refcount) {
            emval_handles.free(handle);
          }
        }
        function count_emval_handles() {
          var count = 0;
          for (var i = emval_handles.reserved; i < emval_handles.allocated.length; ++i) {
            if (emval_handles.allocated[i] !== void 0) {
              ++count;
            }
          }
          return count;
        }
        function init_emval() {
          emval_handles.allocated.push({ value: void 0 }, { value: null }, { value: true }, { value: false });
          emval_handles.reserved = emval_handles.allocated.length;
          Module["count_emval_handles"] = count_emval_handles;
        }
        var Emval = { toValue: (handle) => {
          if (!handle) {
            throwBindingError("Cannot use deleted val. handle = " + handle);
          }
          return emval_handles.get(handle).value;
        }, toHandle: (value) => {
          switch (value) {
            case void 0:
              return 1;
            case null:
              return 2;
            case true:
              return 3;
            case false:
              return 4;
            default: {
              return emval_handles.allocate({ refcount: 1, value });
            }
          }
        } };
        function __embind_register_emval(rawType, name) {
          rawType >>>= 0;
          name >>>= 0;
          name = readLatin1String(name);
          registerType(rawType, { name, "fromWireType": function(handle) {
            var rv = Emval.toValue(handle);
            __emval_decref(handle);
            return rv;
          }, "toWireType": function(destructors, value) {
            return Emval.toHandle(value);
          }, "argPackAdvance": 8, "readValueFromPointer": simpleReadValueFromPointer, destructorFunction: null });
        }
        function embindRepr(v) {
          if (v === null) {
            return "null";
          }
          var t = typeof v;
          if (t === "object" || t === "array" || t === "function") {
            return v.toString();
          } else {
            return "" + v;
          }
        }
        function floatReadValueFromPointer(name, shift) {
          switch (shift) {
            case 2:
              return function(pointer) {
                return this["fromWireType"](HEAPF32[pointer >>> 2]);
              };
            case 3:
              return function(pointer) {
                return this["fromWireType"](HEAPF64[pointer >>> 3]);
              };
            default:
              throw new TypeError("Unknown float type: " + name);
          }
        }
        function __embind_register_float(rawType, name, size) {
          rawType >>>= 0;
          name >>>= 0;
          size >>>= 0;
          var shift = getShiftFromSize(size);
          name = readLatin1String(name);
          registerType(rawType, { name, "fromWireType": function(value) {
            return value;
          }, "toWireType": function(destructors, value) {
            return value;
          }, "argPackAdvance": 8, "readValueFromPointer": floatReadValueFromPointer(name, shift), destructorFunction: null });
        }
        function __embind_register_function(name, argCount, rawArgTypesAddr, signature, rawInvoker, fn, isAsync) {
          name >>>= 0;
          rawArgTypesAddr >>>= 0;
          signature >>>= 0;
          rawInvoker >>>= 0;
          fn >>>= 0;
          var argTypes = heap32VectorToArray(argCount, rawArgTypesAddr);
          name = readLatin1String(name);
          rawInvoker = embind__requireFunction(signature, rawInvoker);
          exposePublicSymbol(name, function() {
            throwUnboundTypeError(`Cannot call ${name} due to unbound types`, argTypes);
          }, argCount - 1);
          whenDependentTypesAreResolved([], argTypes, function(argTypes2) {
            var invokerArgsArray = [argTypes2[0], null].concat(argTypes2.slice(1));
            replacePublicSymbol(name, craftInvokerFunction(name, invokerArgsArray, null, rawInvoker, fn, isAsync), argCount - 1);
            return [];
          });
        }
        function integerReadValueFromPointer(name, shift, signed) {
          switch (shift) {
            case 0:
              return signed ? function readS8FromPointer(pointer) {
                return HEAP8[pointer >>> 0];
              } : function readU8FromPointer(pointer) {
                return HEAPU8[pointer >>> 0];
              };
            case 1:
              return signed ? function readS16FromPointer(pointer) {
                return HEAP16[pointer >>> 1];
              } : function readU16FromPointer(pointer) {
                return HEAPU16[pointer >>> 1];
              };
            case 2:
              return signed ? function readS32FromPointer(pointer) {
                return HEAP32[pointer >>> 2];
              } : function readU32FromPointer(pointer) {
                return HEAPU32[pointer >>> 2];
              };
            default:
              throw new TypeError("Unknown integer type: " + name);
          }
        }
        function __embind_register_integer(primitiveType, name, size, minRange, maxRange) {
          primitiveType >>>= 0;
          name >>>= 0;
          size >>>= 0;
          name = readLatin1String(name);
          if (maxRange === -1) {
            maxRange = 4294967295;
          }
          var shift = getShiftFromSize(size);
          var fromWireType = (value) => value;
          if (minRange === 0) {
            var bitshift = 32 - 8 * size;
            fromWireType = (value) => value << bitshift >>> bitshift;
          }
          var isUnsignedType = name.includes("unsigned");
          var checkAssertions = (value, toTypeName) => {
          };
          var toWireType;
          if (isUnsignedType) {
            toWireType = function(destructors, value) {
              checkAssertions(value, this.name);
              return value >>> 0;
            };
          } else {
            toWireType = function(destructors, value) {
              checkAssertions(value, this.name);
              return value;
            };
          }
          registerType(primitiveType, { name, "fromWireType": fromWireType, "toWireType": toWireType, "argPackAdvance": 8, "readValueFromPointer": integerReadValueFromPointer(name, shift, minRange !== 0), destructorFunction: null });
        }
        function __embind_register_memory_view(rawType, dataTypeIndex, name) {
          rawType >>>= 0;
          name >>>= 0;
          var typeMapping = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array];
          var TA = typeMapping[dataTypeIndex];
          function decodeMemoryView(handle) {
            handle = handle >> 2;
            var heap = HEAPU32;
            var size = heap[handle >>> 0];
            var data = heap[handle + 1 >>> 0];
            return new TA(heap.buffer, data, size);
          }
          name = readLatin1String(name);
          registerType(rawType, { name, "fromWireType": decodeMemoryView, "argPackAdvance": 8, "readValueFromPointer": decodeMemoryView }, { ignoreDuplicateRegistrations: true });
        }
        var stringToUTF8Array = (str, heap, outIdx, maxBytesToWrite) => {
          outIdx >>>= 0;
          if (!(maxBytesToWrite > 0)) return 0;
          var startIdx = outIdx;
          var endIdx = outIdx + maxBytesToWrite - 1;
          for (var i = 0; i < str.length; ++i) {
            var u = str.charCodeAt(i);
            if (u >= 55296 && u <= 57343) {
              var u1 = str.charCodeAt(++i);
              u = 65536 + ((u & 1023) << 10) | u1 & 1023;
            }
            if (u <= 127) {
              if (outIdx >= endIdx) break;
              heap[outIdx++ >>> 0] = u;
            } else if (u <= 2047) {
              if (outIdx + 1 >= endIdx) break;
              heap[outIdx++ >>> 0] = 192 | u >> 6;
              heap[outIdx++ >>> 0] = 128 | u & 63;
            } else if (u <= 65535) {
              if (outIdx + 2 >= endIdx) break;
              heap[outIdx++ >>> 0] = 224 | u >> 12;
              heap[outIdx++ >>> 0] = 128 | u >> 6 & 63;
              heap[outIdx++ >>> 0] = 128 | u & 63;
            } else {
              if (outIdx + 3 >= endIdx) break;
              heap[outIdx++ >>> 0] = 240 | u >> 18;
              heap[outIdx++ >>> 0] = 128 | u >> 12 & 63;
              heap[outIdx++ >>> 0] = 128 | u >> 6 & 63;
              heap[outIdx++ >>> 0] = 128 | u & 63;
            }
          }
          heap[outIdx >>> 0] = 0;
          return outIdx - startIdx;
        };
        var stringToUTF8 = (str, outPtr, maxBytesToWrite) => stringToUTF8Array(str, HEAPU8, outPtr, maxBytesToWrite);
        var lengthBytesUTF8 = (str) => {
          var len = 0;
          for (var i = 0; i < str.length; ++i) {
            var c = str.charCodeAt(i);
            if (c <= 127) {
              len++;
            } else if (c <= 2047) {
              len += 2;
            } else if (c >= 55296 && c <= 57343) {
              len += 4;
              ++i;
            } else {
              len += 3;
            }
          }
          return len;
        };
        var UTF8Decoder = typeof TextDecoder != "undefined" ? new TextDecoder("utf8") : void 0;
        var UTF8ArrayToString = (heapOrArray, idx, maxBytesToRead) => {
          idx >>>= 0;
          var endIdx = idx + maxBytesToRead;
          var endPtr = idx;
          while (heapOrArray[endPtr] && !(endPtr >= endIdx)) ++endPtr;
          if (endPtr - idx > 16 && heapOrArray.buffer && UTF8Decoder) {
            return UTF8Decoder.decode(heapOrArray.subarray(idx, endPtr));
          }
          var str = "";
          while (idx < endPtr) {
            var u0 = heapOrArray[idx++];
            if (!(u0 & 128)) {
              str += String.fromCharCode(u0);
              continue;
            }
            var u1 = heapOrArray[idx++] & 63;
            if ((u0 & 224) == 192) {
              str += String.fromCharCode((u0 & 31) << 6 | u1);
              continue;
            }
            var u2 = heapOrArray[idx++] & 63;
            if ((u0 & 240) == 224) {
              u0 = (u0 & 15) << 12 | u1 << 6 | u2;
            } else {
              u0 = (u0 & 7) << 18 | u1 << 12 | u2 << 6 | heapOrArray[idx++] & 63;
            }
            if (u0 < 65536) {
              str += String.fromCharCode(u0);
            } else {
              var ch = u0 - 65536;
              str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023);
            }
          }
          return str;
        };
        var UTF8ToString = (ptr, maxBytesToRead) => {
          ptr >>>= 0;
          return ptr ? UTF8ArrayToString(HEAPU8, ptr, maxBytesToRead) : "";
        };
        function __embind_register_std_string(rawType, name) {
          rawType >>>= 0;
          name >>>= 0;
          name = readLatin1String(name);
          var stdStringIsUTF8 = name === "std::string";
          registerType(rawType, { name, "fromWireType": function(value) {
            var length = HEAPU32[value >>> 2];
            var payload = value + 4;
            var str;
            if (stdStringIsUTF8) {
              var decodeStartPtr = payload;
              for (var i = 0; i <= length; ++i) {
                var currentBytePtr = payload + i;
                if (i == length || HEAPU8[currentBytePtr >>> 0] == 0) {
                  var maxRead = currentBytePtr - decodeStartPtr;
                  var stringSegment = UTF8ToString(decodeStartPtr, maxRead);
                  if (str === void 0) {
                    str = stringSegment;
                  } else {
                    str += String.fromCharCode(0);
                    str += stringSegment;
                  }
                  decodeStartPtr = currentBytePtr + 1;
                }
              }
            } else {
              var a = new Array(length);
              for (var i = 0; i < length; ++i) {
                a[i] = String.fromCharCode(HEAPU8[payload + i >>> 0]);
              }
              str = a.join("");
            }
            _free(value);
            return str;
          }, "toWireType": function(destructors, value) {
            if (value instanceof ArrayBuffer) {
              value = new Uint8Array(value);
            }
            var length;
            var valueIsOfTypeString = typeof value == "string";
            if (!(valueIsOfTypeString || value instanceof Uint8Array || value instanceof Uint8ClampedArray || value instanceof Int8Array)) {
              throwBindingError("Cannot pass non-string to std::string");
            }
            if (stdStringIsUTF8 && valueIsOfTypeString) {
              length = lengthBytesUTF8(value);
            } else {
              length = value.length;
            }
            var base = _malloc(4 + length + 1);
            var ptr = base + 4;
            HEAPU32[base >>> 2] = length;
            if (stdStringIsUTF8 && valueIsOfTypeString) {
              stringToUTF8(value, ptr, length + 1);
            } else {
              if (valueIsOfTypeString) {
                for (var i = 0; i < length; ++i) {
                  var charCode = value.charCodeAt(i);
                  if (charCode > 255) {
                    _free(ptr);
                    throwBindingError("String has UTF-16 code units that do not fit in 8 bits");
                  }
                  HEAPU8[ptr + i >>> 0] = charCode;
                }
              } else {
                for (var i = 0; i < length; ++i) {
                  HEAPU8[ptr + i >>> 0] = value[i];
                }
              }
            }
            if (destructors !== null) {
              destructors.push(_free, base);
            }
            return base;
          }, "argPackAdvance": 8, "readValueFromPointer": simpleReadValueFromPointer, destructorFunction: function(ptr) {
            _free(ptr);
          } });
        }
        var UTF16Decoder = typeof TextDecoder != "undefined" ? new TextDecoder("utf-16le") : void 0;
        var UTF16ToString = (ptr, maxBytesToRead) => {
          var endPtr = ptr;
          var idx = endPtr >> 1;
          var maxIdx = idx + maxBytesToRead / 2;
          while (!(idx >= maxIdx) && HEAPU16[idx >>> 0]) ++idx;
          endPtr = idx << 1;
          if (endPtr - ptr > 32 && UTF16Decoder) return UTF16Decoder.decode(HEAPU8.subarray(ptr >>> 0, endPtr >>> 0));
          var str = "";
          for (var i = 0; !(i >= maxBytesToRead / 2); ++i) {
            var codeUnit = HEAP16[ptr + i * 2 >>> 1];
            if (codeUnit == 0) break;
            str += String.fromCharCode(codeUnit);
          }
          return str;
        };
        var stringToUTF16 = (str, outPtr, maxBytesToWrite) => {
          if (maxBytesToWrite === void 0) {
            maxBytesToWrite = 2147483647;
          }
          if (maxBytesToWrite < 2) return 0;
          maxBytesToWrite -= 2;
          var startPtr = outPtr;
          var numCharsToWrite = maxBytesToWrite < str.length * 2 ? maxBytesToWrite / 2 : str.length;
          for (var i = 0; i < numCharsToWrite; ++i) {
            var codeUnit = str.charCodeAt(i);
            HEAP16[outPtr >>> 1] = codeUnit;
            outPtr += 2;
          }
          HEAP16[outPtr >>> 1] = 0;
          return outPtr - startPtr;
        };
        var lengthBytesUTF16 = (str) => str.length * 2;
        var UTF32ToString = (ptr, maxBytesToRead) => {
          var i = 0;
          var str = "";
          while (!(i >= maxBytesToRead / 4)) {
            var utf32 = HEAP32[ptr + i * 4 >>> 2];
            if (utf32 == 0) break;
            ++i;
            if (utf32 >= 65536) {
              var ch = utf32 - 65536;
              str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023);
            } else {
              str += String.fromCharCode(utf32);
            }
          }
          return str;
        };
        var stringToUTF32 = (str, outPtr, maxBytesToWrite) => {
          outPtr >>>= 0;
          if (maxBytesToWrite === void 0) {
            maxBytesToWrite = 2147483647;
          }
          if (maxBytesToWrite < 4) return 0;
          var startPtr = outPtr;
          var endPtr = startPtr + maxBytesToWrite - 4;
          for (var i = 0; i < str.length; ++i) {
            var codeUnit = str.charCodeAt(i);
            if (codeUnit >= 55296 && codeUnit <= 57343) {
              var trailSurrogate = str.charCodeAt(++i);
              codeUnit = 65536 + ((codeUnit & 1023) << 10) | trailSurrogate & 1023;
            }
            HEAP32[outPtr >>> 2] = codeUnit;
            outPtr += 4;
            if (outPtr + 4 > endPtr) break;
          }
          HEAP32[outPtr >>> 2] = 0;
          return outPtr - startPtr;
        };
        var lengthBytesUTF32 = (str) => {
          var len = 0;
          for (var i = 0; i < str.length; ++i) {
            var codeUnit = str.charCodeAt(i);
            if (codeUnit >= 55296 && codeUnit <= 57343) ++i;
            len += 4;
          }
          return len;
        };
        var __embind_register_std_wstring = function(rawType, charSize, name) {
          rawType >>>= 0;
          charSize >>>= 0;
          name >>>= 0;
          name = readLatin1String(name);
          var decodeString, encodeString, getHeap, lengthBytesUTF, shift;
          if (charSize === 2) {
            decodeString = UTF16ToString;
            encodeString = stringToUTF16;
            lengthBytesUTF = lengthBytesUTF16;
            getHeap = () => HEAPU16;
            shift = 1;
          } else if (charSize === 4) {
            decodeString = UTF32ToString;
            encodeString = stringToUTF32;
            lengthBytesUTF = lengthBytesUTF32;
            getHeap = () => HEAPU32;
            shift = 2;
          }
          registerType(rawType, { name, "fromWireType": function(value) {
            var length = HEAPU32[value >>> 2];
            var HEAP = getHeap();
            var str;
            var decodeStartPtr = value + 4;
            for (var i = 0; i <= length; ++i) {
              var currentBytePtr = value + 4 + i * charSize;
              if (i == length || HEAP[currentBytePtr >>> shift] == 0) {
                var maxReadBytes = currentBytePtr - decodeStartPtr;
                var stringSegment = decodeString(decodeStartPtr, maxReadBytes);
                if (str === void 0) {
                  str = stringSegment;
                } else {
                  str += String.fromCharCode(0);
                  str += stringSegment;
                }
                decodeStartPtr = currentBytePtr + charSize;
              }
            }
            _free(value);
            return str;
          }, "toWireType": function(destructors, value) {
            if (!(typeof value == "string")) {
              throwBindingError(`Cannot pass non-string to C++ string type ${name}`);
            }
            var length = lengthBytesUTF(value);
            var ptr = _malloc(4 + length + charSize);
            HEAPU32[ptr >>> 2] = length >> shift;
            encodeString(value, ptr + 4, length + charSize);
            if (destructors !== null) {
              destructors.push(_free, ptr);
            }
            return ptr;
          }, "argPackAdvance": 8, "readValueFromPointer": simpleReadValueFromPointer, destructorFunction: function(ptr) {
            _free(ptr);
          } });
        };
        function __embind_register_value_array(rawType, name, constructorSignature, rawConstructor, destructorSignature, rawDestructor) {
          rawType >>>= 0;
          name >>>= 0;
          constructorSignature >>>= 0;
          rawConstructor >>>= 0;
          destructorSignature >>>= 0;
          rawDestructor >>>= 0;
          tupleRegistrations[rawType] = { name: readLatin1String(name), rawConstructor: embind__requireFunction(constructorSignature, rawConstructor), rawDestructor: embind__requireFunction(destructorSignature, rawDestructor), elements: [] };
        }
        function __embind_register_value_array_element(rawTupleType, getterReturnType, getterSignature, getter, getterContext, setterArgumentType, setterSignature, setter, setterContext) {
          rawTupleType >>>= 0;
          getterReturnType >>>= 0;
          getterSignature >>>= 0;
          getter >>>= 0;
          getterContext >>>= 0;
          setterArgumentType >>>= 0;
          setterSignature >>>= 0;
          setter >>>= 0;
          setterContext >>>= 0;
          tupleRegistrations[rawTupleType].elements.push({ getterReturnType, getter: embind__requireFunction(getterSignature, getter), getterContext, setterArgumentType, setter: embind__requireFunction(setterSignature, setter), setterContext });
        }
        function __embind_register_value_object(rawType, name, constructorSignature, rawConstructor, destructorSignature, rawDestructor) {
          rawType >>>= 0;
          name >>>= 0;
          constructorSignature >>>= 0;
          rawConstructor >>>= 0;
          destructorSignature >>>= 0;
          rawDestructor >>>= 0;
          structRegistrations[rawType] = { name: readLatin1String(name), rawConstructor: embind__requireFunction(constructorSignature, rawConstructor), rawDestructor: embind__requireFunction(destructorSignature, rawDestructor), fields: [] };
        }
        function __embind_register_value_object_field(structType, fieldName, getterReturnType, getterSignature, getter, getterContext, setterArgumentType, setterSignature, setter, setterContext) {
          structType >>>= 0;
          fieldName >>>= 0;
          getterReturnType >>>= 0;
          getterSignature >>>= 0;
          getter >>>= 0;
          getterContext >>>= 0;
          setterArgumentType >>>= 0;
          setterSignature >>>= 0;
          setter >>>= 0;
          setterContext >>>= 0;
          structRegistrations[structType].fields.push({ fieldName: readLatin1String(fieldName), getterReturnType, getter: embind__requireFunction(getterSignature, getter), getterContext, setterArgumentType, setter: embind__requireFunction(setterSignature, setter), setterContext });
        }
        function __embind_register_void(rawType, name) {
          rawType >>>= 0;
          name >>>= 0;
          name = readLatin1String(name);
          registerType(rawType, { isVoid: true, name, "argPackAdvance": 0, "fromWireType": function() {
            return void 0;
          }, "toWireType": function(destructors, o) {
            return void 0;
          } });
        }
        var nowIsMonotonic = true;
        var __emscripten_get_now_is_monotonic = () => nowIsMonotonic;
        function requireRegisteredType(rawType, humanName) {
          var impl = registeredTypes[rawType];
          if (void 0 === impl) {
            throwBindingError(humanName + " has unknown type " + getTypeName(rawType));
          }
          return impl;
        }
        function __emval_as(handle, returnType, destructorsRef) {
          handle >>>= 0;
          returnType >>>= 0;
          destructorsRef >>>= 0;
          handle = Emval.toValue(handle);
          returnType = requireRegisteredType(returnType, "emval::as");
          var destructors = [];
          var rd = Emval.toHandle(destructors);
          HEAPU32[destructorsRef >>> 2] = rd;
          return returnType["toWireType"](destructors, handle);
        }
        function emval_lookupTypes(argCount, argTypes) {
          var a = new Array(argCount);
          for (var i = 0; i < argCount; ++i) {
            a[i] = requireRegisteredType(HEAPU32[argTypes + i * 4 >>> 2], "parameter " + i);
          }
          return a;
        }
        function __emval_call(handle, argCount, argTypes, argv) {
          handle >>>= 0;
          argTypes >>>= 0;
          argv >>>= 0;
          handle = Emval.toValue(handle);
          var types = emval_lookupTypes(argCount, argTypes);
          var args = new Array(argCount);
          for (var i = 0; i < argCount; ++i) {
            var type = types[i];
            args[i] = type["readValueFromPointer"](argv);
            argv += type["argPackAdvance"];
          }
          var rv = handle.apply(void 0, args);
          return Emval.toHandle(rv);
        }
        var emval_symbols = {};
        function getStringOrSymbol(address) {
          var symbol = emval_symbols[address];
          if (symbol === void 0) {
            return readLatin1String(address);
          }
          return symbol;
        }
        function emval_get_global() {
          if (typeof globalThis == "object") {
            return globalThis;
          }
          return (/* @__PURE__ */ function() {
            return Function;
          }())("return this")();
        }
        function __emval_get_global(name) {
          name >>>= 0;
          if (name === 0) {
            return Emval.toHandle(emval_get_global());
          } else {
            name = getStringOrSymbol(name);
            return Emval.toHandle(emval_get_global()[name]);
          }
        }
        function __emval_get_property(handle, key) {
          handle >>>= 0;
          key >>>= 0;
          handle = Emval.toValue(handle);
          key = Emval.toValue(key);
          return Emval.toHandle(handle[key]);
        }
        function __emval_incref(handle) {
          handle >>>= 0;
          if (handle > 4) {
            emval_handles.get(handle).refcount += 1;
          }
        }
        function __emval_instanceof(object, constructor) {
          object >>>= 0;
          constructor >>>= 0;
          object = Emval.toValue(object);
          constructor = Emval.toValue(constructor);
          return object instanceof constructor;
        }
        function __emval_is_number(handle) {
          handle >>>= 0;
          handle = Emval.toValue(handle);
          return typeof handle == "number";
        }
        function __emval_is_string(handle) {
          handle >>>= 0;
          handle = Emval.toValue(handle);
          return typeof handle == "string";
        }
        function __emval_new_array() {
          return Emval.toHandle([]);
        }
        function __emval_new_cstring(v) {
          v >>>= 0;
          return Emval.toHandle(getStringOrSymbol(v));
        }
        function __emval_new_object() {
          return Emval.toHandle({});
        }
        function __emval_run_destructors(handle) {
          handle >>>= 0;
          var destructors = Emval.toValue(handle);
          runDestructors(destructors);
          __emval_decref(handle);
        }
        function __emval_set_property(handle, key, value) {
          handle >>>= 0;
          key >>>= 0;
          value >>>= 0;
          handle = Emval.toValue(handle);
          key = Emval.toValue(key);
          value = Emval.toValue(value);
          handle[key] = value;
        }
        function __emval_take_value(type, arg) {
          type >>>= 0;
          arg >>>= 0;
          type = requireRegisteredType(type, "_emval_take_value");
          var v = type["readValueFromPointer"](arg);
          return Emval.toHandle(v);
        }
        function __gmtime_js(time_low, time_high, tmPtr) {
          var time = convertI32PairToI53Checked(time_low, time_high);
          tmPtr >>>= 0;
          var date = new Date(time * 1e3);
          HEAP32[tmPtr >>> 2] = date.getUTCSeconds();
          HEAP32[tmPtr + 4 >>> 2] = date.getUTCMinutes();
          HEAP32[tmPtr + 8 >>> 2] = date.getUTCHours();
          HEAP32[tmPtr + 12 >>> 2] = date.getUTCDate();
          HEAP32[tmPtr + 16 >>> 2] = date.getUTCMonth();
          HEAP32[tmPtr + 20 >>> 2] = date.getUTCFullYear() - 1900;
          HEAP32[tmPtr + 24 >>> 2] = date.getUTCDay();
          var start = Date.UTC(date.getUTCFullYear(), 0, 1, 0, 0, 0, 0);
          var yday = (date.getTime() - start) / (1e3 * 60 * 60 * 24) | 0;
          HEAP32[tmPtr + 28 >>> 2] = yday;
        }
        var isLeapYear = (year) => year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
        var MONTH_DAYS_LEAP_CUMULATIVE = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
        var MONTH_DAYS_REGULAR_CUMULATIVE = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
        var ydayFromDate = (date) => {
          var leap = isLeapYear(date.getFullYear());
          var monthDaysCumulative = leap ? MONTH_DAYS_LEAP_CUMULATIVE : MONTH_DAYS_REGULAR_CUMULATIVE;
          var yday = monthDaysCumulative[date.getMonth()] + date.getDate() - 1;
          return yday;
        };
        function __localtime_js(time_low, time_high, tmPtr) {
          var time = convertI32PairToI53Checked(time_low, time_high);
          tmPtr >>>= 0;
          var date = new Date(time * 1e3);
          HEAP32[tmPtr >>> 2] = date.getSeconds();
          HEAP32[tmPtr + 4 >>> 2] = date.getMinutes();
          HEAP32[tmPtr + 8 >>> 2] = date.getHours();
          HEAP32[tmPtr + 12 >>> 2] = date.getDate();
          HEAP32[tmPtr + 16 >>> 2] = date.getMonth();
          HEAP32[tmPtr + 20 >>> 2] = date.getFullYear() - 1900;
          HEAP32[tmPtr + 24 >>> 2] = date.getDay();
          var yday = ydayFromDate(date) | 0;
          HEAP32[tmPtr + 28 >>> 2] = yday;
          HEAP32[tmPtr + 36 >>> 2] = -(date.getTimezoneOffset() * 60);
          var start = new Date(date.getFullYear(), 0, 1);
          var summerOffset = new Date(date.getFullYear(), 6, 1).getTimezoneOffset();
          var winterOffset = start.getTimezoneOffset();
          var dst = (summerOffset != winterOffset && date.getTimezoneOffset() == Math.min(winterOffset, summerOffset)) | 0;
          HEAP32[tmPtr + 32 >>> 2] = dst;
        }
        var stringToNewUTF8 = (str) => {
          var size = lengthBytesUTF8(str) + 1;
          var ret = _malloc(size);
          if (ret) stringToUTF8(str, ret, size);
          return ret;
        };
        function __tzset_js(timezone, daylight, tzname) {
          timezone >>>= 0;
          daylight >>>= 0;
          tzname >>>= 0;
          var currentYear = (/* @__PURE__ */ new Date()).getFullYear();
          var winter = new Date(currentYear, 0, 1);
          var summer = new Date(currentYear, 6, 1);
          var winterOffset = winter.getTimezoneOffset();
          var summerOffset = summer.getTimezoneOffset();
          var stdTimezoneOffset = Math.max(winterOffset, summerOffset);
          HEAPU32[timezone >>> 2] = stdTimezoneOffset * 60;
          HEAP32[daylight >>> 2] = Number(winterOffset != summerOffset);
          function extractZone(date) {
            var match = date.toTimeString().match(/\(([A-Za-z ]+)\)$/);
            return match ? match[1] : "GMT";
          }
          var winterName = extractZone(winter);
          var summerName = extractZone(summer);
          var winterNamePtr = stringToNewUTF8(winterName);
          var summerNamePtr = stringToNewUTF8(summerName);
          if (summerOffset < winterOffset) {
            HEAPU32[tzname >>> 2] = winterNamePtr;
            HEAPU32[tzname + 4 >>> 2] = summerNamePtr;
          } else {
            HEAPU32[tzname >>> 2] = summerNamePtr;
            HEAPU32[tzname + 4 >>> 2] = winterNamePtr;
          }
        }
        var _abort = () => {
          abort("");
        };
        function _emscripten_date_now() {
          return Date.now();
        }
        var _emscripten_get_now;
        _emscripten_get_now = () => performance.now();
        function _emscripten_memcpy_big(dest, src, num) {
          dest >>>= 0;
          src >>>= 0;
          num >>>= 0;
          return HEAPU8.copyWithin(dest >>> 0, src >>> 0, src + num >>> 0);
        }
        var getHeapMax = () => 4294901760;
        var growMemory = (size) => {
          var b = wasmMemory.buffer;
          var pages = size - b.byteLength + 65535 >>> 16;
          try {
            wasmMemory.grow(pages);
            updateMemoryViews();
            return 1;
          } catch (e) {
          }
        };
        function _emscripten_resize_heap(requestedSize) {
          requestedSize >>>= 0;
          var oldSize = HEAPU8.length;
          var maxHeapSize = getHeapMax();
          if (requestedSize > maxHeapSize) {
            return false;
          }
          var alignUp = (x, multiple) => x + (multiple - x % multiple) % multiple;
          for (var cutDown = 1; cutDown <= 4; cutDown *= 2) {
            var overGrownHeapSize = oldSize * (1 + 0.2 / cutDown);
            overGrownHeapSize = Math.min(overGrownHeapSize, requestedSize + 100663296);
            var newSize = Math.min(maxHeapSize, alignUp(Math.max(requestedSize, overGrownHeapSize), 65536));
            var replacement = growMemory(newSize);
            if (replacement) {
              return true;
            }
          }
          return false;
        }
        var ENV = {};
        var getExecutableName = () => thisProgram || "./this.program";
        var getEnvStrings = () => {
          if (!getEnvStrings.strings) {
            var lang = (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8";
            var env = { "USER": "web_user", "LOGNAME": "web_user", "PATH": "/", "PWD": "/", "HOME": "/home/web_user", "LANG": lang, "_": getExecutableName() };
            for (var x in ENV) {
              if (ENV[x] === void 0) delete env[x];
              else env[x] = ENV[x];
            }
            var strings = [];
            for (var x in env) {
              strings.push(`${x}=${env[x]}`);
            }
            getEnvStrings.strings = strings;
          }
          return getEnvStrings.strings;
        };
        var stringToAscii = (str, buffer) => {
          for (var i = 0; i < str.length; ++i) {
            HEAP8[buffer++ >>> 0] = str.charCodeAt(i);
          }
          HEAP8[buffer >>> 0] = 0;
        };
        var PATH = { isAbs: (path) => path.charAt(0) === "/", splitPath: (filename) => {
          var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
          return splitPathRe.exec(filename).slice(1);
        }, normalizeArray: (parts, allowAboveRoot) => {
          var up = 0;
          for (var i = parts.length - 1; i >= 0; i--) {
            var last = parts[i];
            if (last === ".") {
              parts.splice(i, 1);
            } else if (last === "..") {
              parts.splice(i, 1);
              up++;
            } else if (up) {
              parts.splice(i, 1);
              up--;
            }
          }
          if (allowAboveRoot) {
            for (; up; up--) {
              parts.unshift("..");
            }
          }
          return parts;
        }, normalize: (path) => {
          var isAbsolute = PATH.isAbs(path), trailingSlash = path.substr(-1) === "/";
          path = PATH.normalizeArray(path.split("/").filter((p) => !!p), !isAbsolute).join("/");
          if (!path && !isAbsolute) {
            path = ".";
          }
          if (path && trailingSlash) {
            path += "/";
          }
          return (isAbsolute ? "/" : "") + path;
        }, dirname: (path) => {
          var result = PATH.splitPath(path), root = result[0], dir = result[1];
          if (!root && !dir) {
            return ".";
          }
          if (dir) {
            dir = dir.substr(0, dir.length - 1);
          }
          return root + dir;
        }, basename: (path) => {
          if (path === "/") return "/";
          path = PATH.normalize(path);
          path = path.replace(/\/$/, "");
          var lastSlash = path.lastIndexOf("/");
          if (lastSlash === -1) return path;
          return path.substr(lastSlash + 1);
        }, join: function() {
          var paths = Array.prototype.slice.call(arguments);
          return PATH.normalize(paths.join("/"));
        }, join2: (l, r) => PATH.normalize(l + "/" + r) };
        var initRandomFill = () => {
          if (typeof crypto == "object" && typeof crypto["getRandomValues"] == "function") {
            return (view) => crypto.getRandomValues(view);
          } else if (ENVIRONMENT_IS_NODE) {
            try {
              var crypto_module = __webpack_require__(2925);
              var randomFillSync = crypto_module["randomFillSync"];
              if (randomFillSync) {
                return (view) => crypto_module["randomFillSync"](view);
              }
              var randomBytes = crypto_module["randomBytes"];
              return (view) => (view.set(randomBytes(view.byteLength)), view);
            } catch (e) {
            }
          }
          abort("initRandomDevice");
        };
        var randomFill = (view) => (randomFill = initRandomFill())(view);
        var PATH_FS = { resolve: function() {
          var resolvedPath = "", resolvedAbsolute = false;
          for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
            var path = i >= 0 ? arguments[i] : FS.cwd();
            if (typeof path != "string") {
              throw new TypeError("Arguments to path.resolve must be strings");
            } else if (!path) {
              return "";
            }
            resolvedPath = path + "/" + resolvedPath;
            resolvedAbsolute = PATH.isAbs(path);
          }
          resolvedPath = PATH.normalizeArray(resolvedPath.split("/").filter((p) => !!p), !resolvedAbsolute).join("/");
          return (resolvedAbsolute ? "/" : "") + resolvedPath || ".";
        }, relative: (from, to) => {
          from = PATH_FS.resolve(from).substr(1);
          to = PATH_FS.resolve(to).substr(1);
          function trim(arr) {
            var start = 0;
            for (; start < arr.length; start++) {
              if (arr[start] !== "") break;
            }
            var end = arr.length - 1;
            for (; end >= 0; end--) {
              if (arr[end] !== "") break;
            }
            if (start > end) return [];
            return arr.slice(start, end - start + 1);
          }
          var fromParts = trim(from.split("/"));
          var toParts = trim(to.split("/"));
          var length = Math.min(fromParts.length, toParts.length);
          var samePartsLength = length;
          for (var i = 0; i < length; i++) {
            if (fromParts[i] !== toParts[i]) {
              samePartsLength = i;
              break;
            }
          }
          var outputParts = [];
          for (var i = samePartsLength; i < fromParts.length; i++) {
            outputParts.push("..");
          }
          outputParts = outputParts.concat(toParts.slice(samePartsLength));
          return outputParts.join("/");
        } };
        var FS_stdin_getChar_buffer = [];
        function intArrayFromString(stringy, dontAddNull, length) {
          var len = length > 0 ? length : lengthBytesUTF8(stringy) + 1;
          var u8array = new Array(len);
          var numBytesWritten = stringToUTF8Array(stringy, u8array, 0, u8array.length);
          if (dontAddNull) u8array.length = numBytesWritten;
          return u8array;
        }
        var FS_stdin_getChar = () => {
          if (!FS_stdin_getChar_buffer.length) {
            var result = null;
            if (ENVIRONMENT_IS_NODE) {
              var BUFSIZE = 256;
              var buf = Buffer.alloc(BUFSIZE);
              var bytesRead = 0;
              var fd = process.stdin.fd;
              try {
                bytesRead = fs.readSync(fd, buf, 0, BUFSIZE, -1);
              } catch (e) {
                if (e.toString().includes("EOF")) bytesRead = 0;
                else throw e;
              }
              if (bytesRead > 0) {
                result = buf.slice(0, bytesRead).toString("utf-8");
              } else {
                result = null;
              }
            } else if (typeof window != "undefined" && typeof window.prompt == "function") {
              result = window.prompt("Input: ");
              if (result !== null) {
                result += "\n";
              }
            } else if (typeof readline == "function") {
              result = readline();
              if (result !== null) {
                result += "\n";
              }
            }
            if (!result) {
              return null;
            }
            FS_stdin_getChar_buffer = intArrayFromString(result, true);
          }
          return FS_stdin_getChar_buffer.shift();
        };
        var TTY = { ttys: [], init: function() {
        }, shutdown: function() {
        }, register: function(dev, ops) {
          TTY.ttys[dev] = { input: [], output: [], ops };
          FS.registerDevice(dev, TTY.stream_ops);
        }, stream_ops: { open: function(stream) {
          var tty = TTY.ttys[stream.node.rdev];
          if (!tty) {
            throw new FS.ErrnoError(43);
          }
          stream.tty = tty;
          stream.seekable = false;
        }, close: function(stream) {
          stream.tty.ops.fsync(stream.tty);
        }, fsync: function(stream) {
          stream.tty.ops.fsync(stream.tty);
        }, read: function(stream, buffer, offset, length, pos) {
          if (!stream.tty || !stream.tty.ops.get_char) {
            throw new FS.ErrnoError(60);
          }
          var bytesRead = 0;
          for (var i = 0; i < length; i++) {
            var result;
            try {
              result = stream.tty.ops.get_char(stream.tty);
            } catch (e) {
              throw new FS.ErrnoError(29);
            }
            if (result === void 0 && bytesRead === 0) {
              throw new FS.ErrnoError(6);
            }
            if (result === null || result === void 0) break;
            bytesRead++;
            buffer[offset + i] = result;
          }
          if (bytesRead) {
            stream.node.timestamp = Date.now();
          }
          return bytesRead;
        }, write: function(stream, buffer, offset, length, pos) {
          if (!stream.tty || !stream.tty.ops.put_char) {
            throw new FS.ErrnoError(60);
          }
          try {
            for (var i = 0; i < length; i++) {
              stream.tty.ops.put_char(stream.tty, buffer[offset + i]);
            }
          } catch (e) {
            throw new FS.ErrnoError(29);
          }
          if (length) {
            stream.node.timestamp = Date.now();
          }
          return i;
        } }, default_tty_ops: { get_char: function(tty) {
          return FS_stdin_getChar();
        }, put_char: function(tty, val) {
          if (val === null || val === 10) {
            out(UTF8ArrayToString(tty.output, 0));
            tty.output = [];
          } else {
            if (val != 0) tty.output.push(val);
          }
        }, fsync: function(tty) {
          if (tty.output && tty.output.length > 0) {
            out(UTF8ArrayToString(tty.output, 0));
            tty.output = [];
          }
        }, ioctl_tcgets: function(tty) {
          return { c_iflag: 25856, c_oflag: 5, c_cflag: 191, c_lflag: 35387, c_cc: [3, 28, 127, 21, 4, 0, 1, 0, 17, 19, 26, 0, 18, 15, 23, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] };
        }, ioctl_tcsets: function(tty, optional_actions, data) {
          return 0;
        }, ioctl_tiocgwinsz: function(tty) {
          return [24, 80];
        } }, default_tty1_ops: { put_char: function(tty, val) {
          if (val === null || val === 10) {
            err(UTF8ArrayToString(tty.output, 0));
            tty.output = [];
          } else {
            if (val != 0) tty.output.push(val);
          }
        }, fsync: function(tty) {
          if (tty.output && tty.output.length > 0) {
            err(UTF8ArrayToString(tty.output, 0));
            tty.output = [];
          }
        } } };
        var mmapAlloc = (size) => {
          abort();
        };
        var MEMFS = { ops_table: null, mount(mount) {
          return MEMFS.createNode(null, "/", 16384 | 511, 0);
        }, createNode(parent, name, mode, dev) {
          if (FS.isBlkdev(mode) || FS.isFIFO(mode)) {
            throw new FS.ErrnoError(63);
          }
          if (!MEMFS.ops_table) {
            MEMFS.ops_table = { dir: { node: { getattr: MEMFS.node_ops.getattr, setattr: MEMFS.node_ops.setattr, lookup: MEMFS.node_ops.lookup, mknod: MEMFS.node_ops.mknod, rename: MEMFS.node_ops.rename, unlink: MEMFS.node_ops.unlink, rmdir: MEMFS.node_ops.rmdir, readdir: MEMFS.node_ops.readdir, symlink: MEMFS.node_ops.symlink }, stream: { llseek: MEMFS.stream_ops.llseek } }, file: { node: { getattr: MEMFS.node_ops.getattr, setattr: MEMFS.node_ops.setattr }, stream: { llseek: MEMFS.stream_ops.llseek, read: MEMFS.stream_ops.read, write: MEMFS.stream_ops.write, allocate: MEMFS.stream_ops.allocate, mmap: MEMFS.stream_ops.mmap, msync: MEMFS.stream_ops.msync } }, link: { node: { getattr: MEMFS.node_ops.getattr, setattr: MEMFS.node_ops.setattr, readlink: MEMFS.node_ops.readlink }, stream: {} }, chrdev: { node: { getattr: MEMFS.node_ops.getattr, setattr: MEMFS.node_ops.setattr }, stream: FS.chrdev_stream_ops } };
          }
          var node = FS.createNode(parent, name, mode, dev);
          if (FS.isDir(node.mode)) {
            node.node_ops = MEMFS.ops_table.dir.node;
            node.stream_ops = MEMFS.ops_table.dir.stream;
            node.contents = {};
          } else if (FS.isFile(node.mode)) {
            node.node_ops = MEMFS.ops_table.file.node;
            node.stream_ops = MEMFS.ops_table.file.stream;
            node.usedBytes = 0;
            node.contents = null;
          } else if (FS.isLink(node.mode)) {
            node.node_ops = MEMFS.ops_table.link.node;
            node.stream_ops = MEMFS.ops_table.link.stream;
          } else if (FS.isChrdev(node.mode)) {
            node.node_ops = MEMFS.ops_table.chrdev.node;
            node.stream_ops = MEMFS.ops_table.chrdev.stream;
          }
          node.timestamp = Date.now();
          if (parent) {
            parent.contents[name] = node;
            parent.timestamp = node.timestamp;
          }
          return node;
        }, getFileDataAsTypedArray(node) {
          if (!node.contents) return new Uint8Array(0);
          if (node.contents.subarray) return node.contents.subarray(0, node.usedBytes);
          return new Uint8Array(node.contents);
        }, expandFileStorage(node, newCapacity) {
          var prevCapacity = node.contents ? node.contents.length : 0;
          if (prevCapacity >= newCapacity) return;
          var CAPACITY_DOUBLING_MAX = 1024 * 1024;
          newCapacity = Math.max(newCapacity, prevCapacity * (prevCapacity < CAPACITY_DOUBLING_MAX ? 2 : 1.125) >>> 0);
          if (prevCapacity != 0) newCapacity = Math.max(newCapacity, 256);
          var oldContents = node.contents;
          node.contents = new Uint8Array(newCapacity);
          if (node.usedBytes > 0) node.contents.set(oldContents.subarray(0, node.usedBytes), 0);
        }, resizeFileStorage(node, newSize) {
          if (node.usedBytes == newSize) return;
          if (newSize == 0) {
            node.contents = null;
            node.usedBytes = 0;
          } else {
            var oldContents = node.contents;
            node.contents = new Uint8Array(newSize);
            if (oldContents) {
              node.contents.set(oldContents.subarray(0, Math.min(newSize, node.usedBytes)));
            }
            node.usedBytes = newSize;
          }
        }, node_ops: { getattr(node) {
          var attr = {};
          attr.dev = FS.isChrdev(node.mode) ? node.id : 1;
          attr.ino = node.id;
          attr.mode = node.mode;
          attr.nlink = 1;
          attr.uid = 0;
          attr.gid = 0;
          attr.rdev = node.rdev;
          if (FS.isDir(node.mode)) {
            attr.size = 4096;
          } else if (FS.isFile(node.mode)) {
            attr.size = node.usedBytes;
          } else if (FS.isLink(node.mode)) {
            attr.size = node.link.length;
          } else {
            attr.size = 0;
          }
          attr.atime = new Date(node.timestamp);
          attr.mtime = new Date(node.timestamp);
          attr.ctime = new Date(node.timestamp);
          attr.blksize = 4096;
          attr.blocks = Math.ceil(attr.size / attr.blksize);
          return attr;
        }, setattr(node, attr) {
          if (attr.mode !== void 0) {
            node.mode = attr.mode;
          }
          if (attr.timestamp !== void 0) {
            node.timestamp = attr.timestamp;
          }
          if (attr.size !== void 0) {
            MEMFS.resizeFileStorage(node, attr.size);
          }
        }, lookup(parent, name) {
          throw FS.genericErrors[44];
        }, mknod(parent, name, mode, dev) {
          return MEMFS.createNode(parent, name, mode, dev);
        }, rename(old_node, new_dir, new_name) {
          if (FS.isDir(old_node.mode)) {
            var new_node;
            try {
              new_node = FS.lookupNode(new_dir, new_name);
            } catch (e) {
            }
            if (new_node) {
              for (var i in new_node.contents) {
                throw new FS.ErrnoError(55);
              }
            }
          }
          delete old_node.parent.contents[old_node.name];
          old_node.parent.timestamp = Date.now();
          old_node.name = new_name;
          new_dir.contents[new_name] = old_node;
          new_dir.timestamp = old_node.parent.timestamp;
          old_node.parent = new_dir;
        }, unlink(parent, name) {
          delete parent.contents[name];
          parent.timestamp = Date.now();
        }, rmdir(parent, name) {
          var node = FS.lookupNode(parent, name);
          for (var i in node.contents) {
            throw new FS.ErrnoError(55);
          }
          delete parent.contents[name];
          parent.timestamp = Date.now();
        }, readdir(node) {
          var entries = [".", ".."];
          for (var key in node.contents) {
            if (!node.contents.hasOwnProperty(key)) {
              continue;
            }
            entries.push(key);
          }
          return entries;
        }, symlink(parent, newname, oldpath) {
          var node = MEMFS.createNode(parent, newname, 511 | 40960, 0);
          node.link = oldpath;
          return node;
        }, readlink(node) {
          if (!FS.isLink(node.mode)) {
            throw new FS.ErrnoError(28);
          }
          return node.link;
        } }, stream_ops: { read(stream, buffer, offset, length, position) {
          var contents = stream.node.contents;
          if (position >= stream.node.usedBytes) return 0;
          var size = Math.min(stream.node.usedBytes - position, length);
          if (size > 8 && contents.subarray) {
            buffer.set(contents.subarray(position, position + size), offset);
          } else {
            for (var i = 0; i < size; i++) buffer[offset + i] = contents[position + i];
          }
          return size;
        }, write(stream, buffer, offset, length, position, canOwn) {
          if (buffer.buffer === HEAP8.buffer) {
            canOwn = false;
          }
          if (!length) return 0;
          var node = stream.node;
          node.timestamp = Date.now();
          if (buffer.subarray && (!node.contents || node.contents.subarray)) {
            if (canOwn) {
              node.contents = buffer.subarray(offset, offset + length);
              node.usedBytes = length;
              return length;
            } else if (node.usedBytes === 0 && position === 0) {
              node.contents = buffer.slice(offset, offset + length);
              node.usedBytes = length;
              return length;
            } else if (position + length <= node.usedBytes) {
              node.contents.set(buffer.subarray(offset, offset + length), position);
              return length;
            }
          }
          MEMFS.expandFileStorage(node, position + length);
          if (node.contents.subarray && buffer.subarray) {
            node.contents.set(buffer.subarray(offset, offset + length), position);
          } else {
            for (var i = 0; i < length; i++) {
              node.contents[position + i] = buffer[offset + i];
            }
          }
          node.usedBytes = Math.max(node.usedBytes, position + length);
          return length;
        }, llseek(stream, offset, whence) {
          var position = offset;
          if (whence === 1) {
            position += stream.position;
          } else if (whence === 2) {
            if (FS.isFile(stream.node.mode)) {
              position += stream.node.usedBytes;
            }
          }
          if (position < 0) {
            throw new FS.ErrnoError(28);
          }
          return position;
        }, allocate(stream, offset, length) {
          MEMFS.expandFileStorage(stream.node, offset + length);
          stream.node.usedBytes = Math.max(stream.node.usedBytes, offset + length);
        }, mmap(stream, length, position, prot, flags) {
          if (!FS.isFile(stream.node.mode)) {
            throw new FS.ErrnoError(43);
          }
          var ptr;
          var allocated;
          var contents = stream.node.contents;
          if (!(flags & 2) && contents.buffer === HEAP8.buffer) {
            allocated = false;
            ptr = contents.byteOffset;
          } else {
            if (position > 0 || position + length < contents.length) {
              if (contents.subarray) {
                contents = contents.subarray(position, position + length);
              } else {
                contents = Array.prototype.slice.call(contents, position, position + length);
              }
            }
            allocated = true;
            ptr = mmapAlloc(length);
            if (!ptr) {
              throw new FS.ErrnoError(48);
            }
            HEAP8.set(contents, ptr >>> 0);
          }
          return { ptr, allocated };
        }, msync(stream, buffer, offset, length, mmapFlags) {
          MEMFS.stream_ops.write(stream, buffer, 0, length, offset, false);
          return 0;
        } } };
        var asyncLoad = (url, onload, onerror, noRunDep) => {
          var dep = !noRunDep ? getUniqueRunDependency(`al ${url}`) : "";
          readAsync(url, (arrayBuffer) => {
            assert(arrayBuffer, `Loading data file "${url}" failed (no arrayBuffer).`);
            onload(new Uint8Array(arrayBuffer));
            if (dep) removeRunDependency(dep);
          }, (event) => {
            if (onerror) {
              onerror();
            } else {
              throw `Loading data file "${url}" failed.`;
            }
          });
          if (dep) addRunDependency(dep);
        };
        var preloadPlugins = Module["preloadPlugins"] || [];
        function FS_handledByPreloadPlugin(byteArray, fullname, finish, onerror) {
          if (typeof Browser != "undefined") Browser.init();
          var handled = false;
          preloadPlugins.forEach(function(plugin) {
            if (handled) return;
            if (plugin["canHandle"](fullname)) {
              plugin["handle"](byteArray, fullname, finish, onerror);
              handled = true;
            }
          });
          return handled;
        }
        function FS_createPreloadedFile(parent, name, url, canRead, canWrite, onload, onerror, dontCreateFile, canOwn, preFinish) {
          var fullname = name ? PATH_FS.resolve(PATH.join2(parent, name)) : parent;
          var dep = getUniqueRunDependency(`cp ${fullname}`);
          function processData(byteArray) {
            function finish(byteArray2) {
              if (preFinish) preFinish();
              if (!dontCreateFile) {
                FS.createDataFile(parent, name, byteArray2, canRead, canWrite, canOwn);
              }
              if (onload) onload();
              removeRunDependency(dep);
            }
            if (FS_handledByPreloadPlugin(byteArray, fullname, finish, () => {
              if (onerror) onerror();
              removeRunDependency(dep);
            })) {
              return;
            }
            finish(byteArray);
          }
          addRunDependency(dep);
          if (typeof url == "string") {
            asyncLoad(url, (byteArray) => processData(byteArray), onerror);
          } else {
            processData(url);
          }
        }
        function FS_modeStringToFlags(str) {
          var flagModes = { "r": 0, "r+": 2, "w": 512 | 64 | 1, "w+": 512 | 64 | 2, "a": 1024 | 64 | 1, "a+": 1024 | 64 | 2 };
          var flags = flagModes[str];
          if (typeof flags == "undefined") {
            throw new Error(`Unknown file open mode: ${str}`);
          }
          return flags;
        }
        function FS_getMode(canRead, canWrite) {
          var mode = 0;
          if (canRead) mode |= 292 | 73;
          if (canWrite) mode |= 146;
          return mode;
        }
        var FS = { root: null, mounts: [], devices: {}, streams: [], nextInode: 1, nameTable: null, currentPath: "/", initialized: false, ignorePermissions: true, ErrnoError: null, genericErrors: {}, filesystems: null, syncFSRequests: 0, lookupPath: (path, opts = {}) => {
          path = PATH_FS.resolve(path);
          if (!path) return { path: "", node: null };
          var defaults = { follow_mount: true, recurse_count: 0 };
          opts = Object.assign(defaults, opts);
          if (opts.recurse_count > 8) {
            throw new FS.ErrnoError(32);
          }
          var parts = path.split("/").filter((p) => !!p);
          var current = FS.root;
          var current_path = "/";
          for (var i = 0; i < parts.length; i++) {
            var islast = i === parts.length - 1;
            if (islast && opts.parent) {
              break;
            }
            current = FS.lookupNode(current, parts[i]);
            current_path = PATH.join2(current_path, parts[i]);
            if (FS.isMountpoint(current)) {
              if (!islast || islast && opts.follow_mount) {
                current = current.mounted.root;
              }
            }
            if (!islast || opts.follow) {
              var count = 0;
              while (FS.isLink(current.mode)) {
                var link = FS.readlink(current_path);
                current_path = PATH_FS.resolve(PATH.dirname(current_path), link);
                var lookup = FS.lookupPath(current_path, { recurse_count: opts.recurse_count + 1 });
                current = lookup.node;
                if (count++ > 40) {
                  throw new FS.ErrnoError(32);
                }
              }
            }
          }
          return { path: current_path, node: current };
        }, getPath: (node) => {
          var path;
          while (true) {
            if (FS.isRoot(node)) {
              var mount = node.mount.mountpoint;
              if (!path) return mount;
              return mount[mount.length - 1] !== "/" ? `${mount}/${path}` : mount + path;
            }
            path = path ? `${node.name}/${path}` : node.name;
            node = node.parent;
          }
        }, hashName: (parentid, name) => {
          var hash = 0;
          for (var i = 0; i < name.length; i++) {
            hash = (hash << 5) - hash + name.charCodeAt(i) | 0;
          }
          return (parentid + hash >>> 0) % FS.nameTable.length;
        }, hashAddNode: (node) => {
          var hash = FS.hashName(node.parent.id, node.name);
          node.name_next = FS.nameTable[hash];
          FS.nameTable[hash] = node;
        }, hashRemoveNode: (node) => {
          var hash = FS.hashName(node.parent.id, node.name);
          if (FS.nameTable[hash] === node) {
            FS.nameTable[hash] = node.name_next;
          } else {
            var current = FS.nameTable[hash];
            while (current) {
              if (current.name_next === node) {
                current.name_next = node.name_next;
                break;
              }
              current = current.name_next;
            }
          }
        }, lookupNode: (parent, name) => {
          var errCode = FS.mayLookup(parent);
          if (errCode) {
            throw new FS.ErrnoError(errCode, parent);
          }
          var hash = FS.hashName(parent.id, name);
          for (var node = FS.nameTable[hash]; node; node = node.name_next) {
            var nodeName = node.name;
            if (node.parent.id === parent.id && nodeName === name) {
              return node;
            }
          }
          return FS.lookup(parent, name);
        }, createNode: (parent, name, mode, rdev) => {
          var node = new FS.FSNode(parent, name, mode, rdev);
          FS.hashAddNode(node);
          return node;
        }, destroyNode: (node) => {
          FS.hashRemoveNode(node);
        }, isRoot: (node) => node === node.parent, isMountpoint: (node) => !!node.mounted, isFile: (mode) => (mode & 61440) === 32768, isDir: (mode) => (mode & 61440) === 16384, isLink: (mode) => (mode & 61440) === 40960, isChrdev: (mode) => (mode & 61440) === 8192, isBlkdev: (mode) => (mode & 61440) === 24576, isFIFO: (mode) => (mode & 61440) === 4096, isSocket: (mode) => (mode & 49152) === 49152, flagsToPermissionString: (flag) => {
          var perms = ["r", "w", "rw"][flag & 3];
          if (flag & 512) {
            perms += "w";
          }
          return perms;
        }, nodePermissions: (node, perms) => {
          if (FS.ignorePermissions) {
            return 0;
          }
          if (perms.includes("r") && !(node.mode & 292)) {
            return 2;
          } else if (perms.includes("w") && !(node.mode & 146)) {
            return 2;
          } else if (perms.includes("x") && !(node.mode & 73)) {
            return 2;
          }
          return 0;
        }, mayLookup: (dir) => {
          var errCode = FS.nodePermissions(dir, "x");
          if (errCode) return errCode;
          if (!dir.node_ops.lookup) return 2;
          return 0;
        }, mayCreate: (dir, name) => {
          try {
            var node = FS.lookupNode(dir, name);
            return 20;
          } catch (e) {
          }
          return FS.nodePermissions(dir, "wx");
        }, mayDelete: (dir, name, isdir) => {
          var node;
          try {
            node = FS.lookupNode(dir, name);
          } catch (e) {
            return e.errno;
          }
          var errCode = FS.nodePermissions(dir, "wx");
          if (errCode) {
            return errCode;
          }
          if (isdir) {
            if (!FS.isDir(node.mode)) {
              return 54;
            }
            if (FS.isRoot(node) || FS.getPath(node) === FS.cwd()) {
              return 10;
            }
          } else {
            if (FS.isDir(node.mode)) {
              return 31;
            }
          }
          return 0;
        }, mayOpen: (node, flags) => {
          if (!node) {
            return 44;
          }
          if (FS.isLink(node.mode)) {
            return 32;
          } else if (FS.isDir(node.mode)) {
            if (FS.flagsToPermissionString(flags) !== "r" || flags & 512) {
              return 31;
            }
          }
          return FS.nodePermissions(node, FS.flagsToPermissionString(flags));
        }, MAX_OPEN_FDS: 4096, nextfd: () => {
          for (var fd = 0; fd <= FS.MAX_OPEN_FDS; fd++) {
            if (!FS.streams[fd]) {
              return fd;
            }
          }
          throw new FS.ErrnoError(33);
        }, getStreamChecked: (fd) => {
          var stream = FS.getStream(fd);
          if (!stream) {
            throw new FS.ErrnoError(8);
          }
          return stream;
        }, getStream: (fd) => FS.streams[fd], createStream: (stream, fd = -1) => {
          if (!FS.FSStream) {
            FS.FSStream = function() {
              this.shared = {};
            };
            FS.FSStream.prototype = {};
            Object.defineProperties(FS.FSStream.prototype, { object: { get() {
              return this.node;
            }, set(val) {
              this.node = val;
            } }, isRead: { get() {
              return (this.flags & 2097155) !== 1;
            } }, isWrite: { get() {
              return (this.flags & 2097155) !== 0;
            } }, isAppend: { get() {
              return this.flags & 1024;
            } }, flags: { get() {
              return this.shared.flags;
            }, set(val) {
              this.shared.flags = val;
            } }, position: { get() {
              return this.shared.position;
            }, set(val) {
              this.shared.position = val;
            } } });
          }
          stream = Object.assign(new FS.FSStream(), stream);
          if (fd == -1) {
            fd = FS.nextfd();
          }
          stream.fd = fd;
          FS.streams[fd] = stream;
          return stream;
        }, closeStream: (fd) => {
          FS.streams[fd] = null;
        }, chrdev_stream_ops: { open: (stream) => {
          var device = FS.getDevice(stream.node.rdev);
          stream.stream_ops = device.stream_ops;
          if (stream.stream_ops.open) {
            stream.stream_ops.open(stream);
          }
        }, llseek: () => {
          throw new FS.ErrnoError(70);
        } }, major: (dev) => dev >> 8, minor: (dev) => dev & 255, makedev: (ma, mi) => ma << 8 | mi, registerDevice: (dev, ops) => {
          FS.devices[dev] = { stream_ops: ops };
        }, getDevice: (dev) => FS.devices[dev], getMounts: (mount) => {
          var mounts = [];
          var check = [mount];
          while (check.length) {
            var m = check.pop();
            mounts.push(m);
            check.push.apply(check, m.mounts);
          }
          return mounts;
        }, syncfs: (populate, callback) => {
          if (typeof populate == "function") {
            callback = populate;
            populate = false;
          }
          FS.syncFSRequests++;
          if (FS.syncFSRequests > 1) {
            err(`warning: ${FS.syncFSRequests} FS.syncfs operations in flight at once, probably just doing extra work`);
          }
          var mounts = FS.getMounts(FS.root.mount);
          var completed = 0;
          function doCallback(errCode) {
            FS.syncFSRequests--;
            return callback(errCode);
          }
          function done(errCode) {
            if (errCode) {
              if (!done.errored) {
                done.errored = true;
                return doCallback(errCode);
              }
              return;
            }
            if (++completed >= mounts.length) {
              doCallback(null);
            }
          }
          mounts.forEach((mount) => {
            if (!mount.type.syncfs) {
              return done(null);
            }
            mount.type.syncfs(mount, populate, done);
          });
        }, mount: (type, opts, mountpoint) => {
          var root = mountpoint === "/";
          var pseudo = !mountpoint;
          var node;
          if (root && FS.root) {
            throw new FS.ErrnoError(10);
          } else if (!root && !pseudo) {
            var lookup = FS.lookupPath(mountpoint, { follow_mount: false });
            mountpoint = lookup.path;
            node = lookup.node;
            if (FS.isMountpoint(node)) {
              throw new FS.ErrnoError(10);
            }
            if (!FS.isDir(node.mode)) {
              throw new FS.ErrnoError(54);
            }
          }
          var mount = { type, opts, mountpoint, mounts: [] };
          var mountRoot = type.mount(mount);
          mountRoot.mount = mount;
          mount.root = mountRoot;
          if (root) {
            FS.root = mountRoot;
          } else if (node) {
            node.mounted = mount;
            if (node.mount) {
              node.mount.mounts.push(mount);
            }
          }
          return mountRoot;
        }, unmount: (mountpoint) => {
          var lookup = FS.lookupPath(mountpoint, { follow_mount: false });
          if (!FS.isMountpoint(lookup.node)) {
            throw new FS.ErrnoError(28);
          }
          var node = lookup.node;
          var mount = node.mounted;
          var mounts = FS.getMounts(mount);
          Object.keys(FS.nameTable).forEach((hash) => {
            var current = FS.nameTable[hash];
            while (current) {
              var next = current.name_next;
              if (mounts.includes(current.mount)) {
                FS.destroyNode(current);
              }
              current = next;
            }
          });
          node.mounted = null;
          var idx = node.mount.mounts.indexOf(mount);
          node.mount.mounts.splice(idx, 1);
        }, lookup: (parent, name) => parent.node_ops.lookup(parent, name), mknod: (path, mode, dev) => {
          var lookup = FS.lookupPath(path, { parent: true });
          var parent = lookup.node;
          var name = PATH.basename(path);
          if (!name || name === "." || name === "..") {
            throw new FS.ErrnoError(28);
          }
          var errCode = FS.mayCreate(parent, name);
          if (errCode) {
            throw new FS.ErrnoError(errCode);
          }
          if (!parent.node_ops.mknod) {
            throw new FS.ErrnoError(63);
          }
          return parent.node_ops.mknod(parent, name, mode, dev);
        }, create: (path, mode) => {
          mode = mode !== void 0 ? mode : 438;
          mode &= 4095;
          mode |= 32768;
          return FS.mknod(path, mode, 0);
        }, mkdir: (path, mode) => {
          mode = mode !== void 0 ? mode : 511;
          mode &= 511 | 512;
          mode |= 16384;
          return FS.mknod(path, mode, 0);
        }, mkdirTree: (path, mode) => {
          var dirs = path.split("/");
          var d = "";
          for (var i = 0; i < dirs.length; ++i) {
            if (!dirs[i]) continue;
            d += "/" + dirs[i];
            try {
              FS.mkdir(d, mode);
            } catch (e) {
              if (e.errno != 20) throw e;
            }
          }
        }, mkdev: (path, mode, dev) => {
          if (typeof dev == "undefined") {
            dev = mode;
            mode = 438;
          }
          mode |= 8192;
          return FS.mknod(path, mode, dev);
        }, symlink: (oldpath, newpath) => {
          if (!PATH_FS.resolve(oldpath)) {
            throw new FS.ErrnoError(44);
          }
          var lookup = FS.lookupPath(newpath, { parent: true });
          var parent = lookup.node;
          if (!parent) {
            throw new FS.ErrnoError(44);
          }
          var newname = PATH.basename(newpath);
          var errCode = FS.mayCreate(parent, newname);
          if (errCode) {
            throw new FS.ErrnoError(errCode);
          }
          if (!parent.node_ops.symlink) {
            throw new FS.ErrnoError(63);
          }
          return parent.node_ops.symlink(parent, newname, oldpath);
        }, rename: (old_path, new_path) => {
          var old_dirname = PATH.dirname(old_path);
          var new_dirname = PATH.dirname(new_path);
          var old_name = PATH.basename(old_path);
          var new_name = PATH.basename(new_path);
          var lookup, old_dir, new_dir;
          lookup = FS.lookupPath(old_path, { parent: true });
          old_dir = lookup.node;
          lookup = FS.lookupPath(new_path, { parent: true });
          new_dir = lookup.node;
          if (!old_dir || !new_dir) throw new FS.ErrnoError(44);
          if (old_dir.mount !== new_dir.mount) {
            throw new FS.ErrnoError(75);
          }
          var old_node = FS.lookupNode(old_dir, old_name);
          var relative = PATH_FS.relative(old_path, new_dirname);
          if (relative.charAt(0) !== ".") {
            throw new FS.ErrnoError(28);
          }
          relative = PATH_FS.relative(new_path, old_dirname);
          if (relative.charAt(0) !== ".") {
            throw new FS.ErrnoError(55);
          }
          var new_node;
          try {
            new_node = FS.lookupNode(new_dir, new_name);
          } catch (e) {
          }
          if (old_node === new_node) {
            return;
          }
          var isdir = FS.isDir(old_node.mode);
          var errCode = FS.mayDelete(old_dir, old_name, isdir);
          if (errCode) {
            throw new FS.ErrnoError(errCode);
          }
          errCode = new_node ? FS.mayDelete(new_dir, new_name, isdir) : FS.mayCreate(new_dir, new_name);
          if (errCode) {
            throw new FS.ErrnoError(errCode);
          }
          if (!old_dir.node_ops.rename) {
            throw new FS.ErrnoError(63);
          }
          if (FS.isMountpoint(old_node) || new_node && FS.isMountpoint(new_node)) {
            throw new FS.ErrnoError(10);
          }
          if (new_dir !== old_dir) {
            errCode = FS.nodePermissions(old_dir, "w");
            if (errCode) {
              throw new FS.ErrnoError(errCode);
            }
          }
          FS.hashRemoveNode(old_node);
          try {
            old_dir.node_ops.rename(old_node, new_dir, new_name);
          } catch (e) {
            throw e;
          } finally {
            FS.hashAddNode(old_node);
          }
        }, rmdir: (path) => {
          var lookup = FS.lookupPath(path, { parent: true });
          var parent = lookup.node;
          var name = PATH.basename(path);
          var node = FS.lookupNode(parent, name);
          var errCode = FS.mayDelete(parent, name, true);
          if (errCode) {
            throw new FS.ErrnoError(errCode);
          }
          if (!parent.node_ops.rmdir) {
            throw new FS.ErrnoError(63);
          }
          if (FS.isMountpoint(node)) {
            throw new FS.ErrnoError(10);
          }
          parent.node_ops.rmdir(parent, name);
          FS.destroyNode(node);
        }, readdir: (path) => {
          var lookup = FS.lookupPath(path, { follow: true });
          var node = lookup.node;
          if (!node.node_ops.readdir) {
            throw new FS.ErrnoError(54);
          }
          return node.node_ops.readdir(node);
        }, unlink: (path) => {
          var lookup = FS.lookupPath(path, { parent: true });
          var parent = lookup.node;
          if (!parent) {
            throw new FS.ErrnoError(44);
          }
          var name = PATH.basename(path);
          var node = FS.lookupNode(parent, name);
          var errCode = FS.mayDelete(parent, name, false);
          if (errCode) {
            throw new FS.ErrnoError(errCode);
          }
          if (!parent.node_ops.unlink) {
            throw new FS.ErrnoError(63);
          }
          if (FS.isMountpoint(node)) {
            throw new FS.ErrnoError(10);
          }
          parent.node_ops.unlink(parent, name);
          FS.destroyNode(node);
        }, readlink: (path) => {
          var lookup = FS.lookupPath(path);
          var link = lookup.node;
          if (!link) {
            throw new FS.ErrnoError(44);
          }
          if (!link.node_ops.readlink) {
            throw new FS.ErrnoError(28);
          }
          return PATH_FS.resolve(FS.getPath(link.parent), link.node_ops.readlink(link));
        }, stat: (path, dontFollow) => {
          var lookup = FS.lookupPath(path, { follow: !dontFollow });
          var node = lookup.node;
          if (!node) {
            throw new FS.ErrnoError(44);
          }
          if (!node.node_ops.getattr) {
            throw new FS.ErrnoError(63);
          }
          return node.node_ops.getattr(node);
        }, lstat: (path) => FS.stat(path, true), chmod: (path, mode, dontFollow) => {
          var node;
          if (typeof path == "string") {
            var lookup = FS.lookupPath(path, { follow: !dontFollow });
            node = lookup.node;
          } else {
            node = path;
          }
          if (!node.node_ops.setattr) {
            throw new FS.ErrnoError(63);
          }
          node.node_ops.setattr(node, { mode: mode & 4095 | node.mode & ~4095, timestamp: Date.now() });
        }, lchmod: (path, mode) => {
          FS.chmod(path, mode, true);
        }, fchmod: (fd, mode) => {
          var stream = FS.getStreamChecked(fd);
          FS.chmod(stream.node, mode);
        }, chown: (path, uid, gid, dontFollow) => {
          var node;
          if (typeof path == "string") {
            var lookup = FS.lookupPath(path, { follow: !dontFollow });
            node = lookup.node;
          } else {
            node = path;
          }
          if (!node.node_ops.setattr) {
            throw new FS.ErrnoError(63);
          }
          node.node_ops.setattr(node, { timestamp: Date.now() });
        }, lchown: (path, uid, gid) => {
          FS.chown(path, uid, gid, true);
        }, fchown: (fd, uid, gid) => {
          var stream = FS.getStreamChecked(fd);
          FS.chown(stream.node, uid, gid);
        }, truncate: (path, len) => {
          if (len < 0) {
            throw new FS.ErrnoError(28);
          }
          var node;
          if (typeof path == "string") {
            var lookup = FS.lookupPath(path, { follow: true });
            node = lookup.node;
          } else {
            node = path;
          }
          if (!node.node_ops.setattr) {
            throw new FS.ErrnoError(63);
          }
          if (FS.isDir(node.mode)) {
            throw new FS.ErrnoError(31);
          }
          if (!FS.isFile(node.mode)) {
            throw new FS.ErrnoError(28);
          }
          var errCode = FS.nodePermissions(node, "w");
          if (errCode) {
            throw new FS.ErrnoError(errCode);
          }
          node.node_ops.setattr(node, { size: len, timestamp: Date.now() });
        }, ftruncate: (fd, len) => {
          var stream = FS.getStreamChecked(fd);
          if ((stream.flags & 2097155) === 0) {
            throw new FS.ErrnoError(28);
          }
          FS.truncate(stream.node, len);
        }, utime: (path, atime, mtime) => {
          var lookup = FS.lookupPath(path, { follow: true });
          var node = lookup.node;
          node.node_ops.setattr(node, { timestamp: Math.max(atime, mtime) });
        }, open: (path, flags, mode) => {
          if (path === "") {
            throw new FS.ErrnoError(44);
          }
          flags = typeof flags == "string" ? FS_modeStringToFlags(flags) : flags;
          mode = typeof mode == "undefined" ? 438 : mode;
          if (flags & 64) {
            mode = mode & 4095 | 32768;
          } else {
            mode = 0;
          }
          var node;
          if (typeof path == "object") {
            node = path;
          } else {
            path = PATH.normalize(path);
            try {
              var lookup = FS.lookupPath(path, { follow: !(flags & 131072) });
              node = lookup.node;
            } catch (e) {
            }
          }
          var created = false;
          if (flags & 64) {
            if (node) {
              if (flags & 128) {
                throw new FS.ErrnoError(20);
              }
            } else {
              node = FS.mknod(path, mode, 0);
              created = true;
            }
          }
          if (!node) {
            throw new FS.ErrnoError(44);
          }
          if (FS.isChrdev(node.mode)) {
            flags &= ~512;
          }
          if (flags & 65536 && !FS.isDir(node.mode)) {
            throw new FS.ErrnoError(54);
          }
          if (!created) {
            var errCode = FS.mayOpen(node, flags);
            if (errCode) {
              throw new FS.ErrnoError(errCode);
            }
          }
          if (flags & 512 && !created) {
            FS.truncate(node, 0);
          }
          flags &= ~(128 | 512 | 131072);
          var stream = FS.createStream({ node, path: FS.getPath(node), flags, seekable: true, position: 0, stream_ops: node.stream_ops, ungotten: [], error: false });
          if (stream.stream_ops.open) {
            stream.stream_ops.open(stream);
          }
          if (Module["logReadFiles"] && !(flags & 1)) {
            if (!FS.readFiles) FS.readFiles = {};
            if (!(path in FS.readFiles)) {
              FS.readFiles[path] = 1;
            }
          }
          return stream;
        }, close: (stream) => {
          if (FS.isClosed(stream)) {
            throw new FS.ErrnoError(8);
          }
          if (stream.getdents) stream.getdents = null;
          try {
            if (stream.stream_ops.close) {
              stream.stream_ops.close(stream);
            }
          } catch (e) {
            throw e;
          } finally {
            FS.closeStream(stream.fd);
          }
          stream.fd = null;
        }, isClosed: (stream) => stream.fd === null, llseek: (stream, offset, whence) => {
          if (FS.isClosed(stream)) {
            throw new FS.ErrnoError(8);
          }
          if (!stream.seekable || !stream.stream_ops.llseek) {
            throw new FS.ErrnoError(70);
          }
          if (whence != 0 && whence != 1 && whence != 2) {
            throw new FS.ErrnoError(28);
          }
          stream.position = stream.stream_ops.llseek(stream, offset, whence);
          stream.ungotten = [];
          return stream.position;
        }, read: (stream, buffer, offset, length, position) => {
          if (length < 0 || position < 0) {
            throw new FS.ErrnoError(28);
          }
          if (FS.isClosed(stream)) {
            throw new FS.ErrnoError(8);
          }
          if ((stream.flags & 2097155) === 1) {
            throw new FS.ErrnoError(8);
          }
          if (FS.isDir(stream.node.mode)) {
            throw new FS.ErrnoError(31);
          }
          if (!stream.stream_ops.read) {
            throw new FS.ErrnoError(28);
          }
          var seeking = typeof position != "undefined";
          if (!seeking) {
            position = stream.position;
          } else if (!stream.seekable) {
            throw new FS.ErrnoError(70);
          }
          var bytesRead = stream.stream_ops.read(stream, buffer, offset, length, position);
          if (!seeking) stream.position += bytesRead;
          return bytesRead;
        }, write: (stream, buffer, offset, length, position, canOwn) => {
          if (length < 0 || position < 0) {
            throw new FS.ErrnoError(28);
          }
          if (FS.isClosed(stream)) {
            throw new FS.ErrnoError(8);
          }
          if ((stream.flags & 2097155) === 0) {
            throw new FS.ErrnoError(8);
          }
          if (FS.isDir(stream.node.mode)) {
            throw new FS.ErrnoError(31);
          }
          if (!stream.stream_ops.write) {
            throw new FS.ErrnoError(28);
          }
          if (stream.seekable && stream.flags & 1024) {
            FS.llseek(stream, 0, 2);
          }
          var seeking = typeof position != "undefined";
          if (!seeking) {
            position = stream.position;
          } else if (!stream.seekable) {
            throw new FS.ErrnoError(70);
          }
          var bytesWritten = stream.stream_ops.write(stream, buffer, offset, length, position, canOwn);
          if (!seeking) stream.position += bytesWritten;
          return bytesWritten;
        }, allocate: (stream, offset, length) => {
          if (FS.isClosed(stream)) {
            throw new FS.ErrnoError(8);
          }
          if (offset < 0 || length <= 0) {
            throw new FS.ErrnoError(28);
          }
          if ((stream.flags & 2097155) === 0) {
            throw new FS.ErrnoError(8);
          }
          if (!FS.isFile(stream.node.mode) && !FS.isDir(stream.node.mode)) {
            throw new FS.ErrnoError(43);
          }
          if (!stream.stream_ops.allocate) {
            throw new FS.ErrnoError(138);
          }
          stream.stream_ops.allocate(stream, offset, length);
        }, mmap: (stream, length, position, prot, flags) => {
          if ((prot & 2) !== 0 && (flags & 2) === 0 && (stream.flags & 2097155) !== 2) {
            throw new FS.ErrnoError(2);
          }
          if ((stream.flags & 2097155) === 1) {
            throw new FS.ErrnoError(2);
          }
          if (!stream.stream_ops.mmap) {
            throw new FS.ErrnoError(43);
          }
          return stream.stream_ops.mmap(stream, length, position, prot, flags);
        }, msync: (stream, buffer, offset, length, mmapFlags) => {
          if (!stream.stream_ops.msync) {
            return 0;
          }
          return stream.stream_ops.msync(stream, buffer, offset, length, mmapFlags);
        }, munmap: (stream) => 0, ioctl: (stream, cmd, arg) => {
          if (!stream.stream_ops.ioctl) {
            throw new FS.ErrnoError(59);
          }
          return stream.stream_ops.ioctl(stream, cmd, arg);
        }, readFile: (path, opts = {}) => {
          opts.flags = opts.flags || 0;
          opts.encoding = opts.encoding || "binary";
          if (opts.encoding !== "utf8" && opts.encoding !== "binary") {
            throw new Error(`Invalid encoding type "${opts.encoding}"`);
          }
          var ret;
          var stream = FS.open(path, opts.flags);
          var stat = FS.stat(path);
          var length = stat.size;
          var buf = new Uint8Array(length);
          FS.read(stream, buf, 0, length, 0);
          if (opts.encoding === "utf8") {
            ret = UTF8ArrayToString(buf, 0);
          } else if (opts.encoding === "binary") {
            ret = buf;
          }
          FS.close(stream);
          return ret;
        }, writeFile: (path, data, opts = {}) => {
          opts.flags = opts.flags || 577;
          var stream = FS.open(path, opts.flags, opts.mode);
          if (typeof data == "string") {
            var buf = new Uint8Array(lengthBytesUTF8(data) + 1);
            var actualNumBytes = stringToUTF8Array(data, buf, 0, buf.length);
            FS.write(stream, buf, 0, actualNumBytes, void 0, opts.canOwn);
          } else if (ArrayBuffer.isView(data)) {
            FS.write(stream, data, 0, data.byteLength, void 0, opts.canOwn);
          } else {
            throw new Error("Unsupported data type");
          }
          FS.close(stream);
        }, cwd: () => FS.currentPath, chdir: (path) => {
          var lookup = FS.lookupPath(path, { follow: true });
          if (lookup.node === null) {
            throw new FS.ErrnoError(44);
          }
          if (!FS.isDir(lookup.node.mode)) {
            throw new FS.ErrnoError(54);
          }
          var errCode = FS.nodePermissions(lookup.node, "x");
          if (errCode) {
            throw new FS.ErrnoError(errCode);
          }
          FS.currentPath = lookup.path;
        }, createDefaultDirectories: () => {
          FS.mkdir("/tmp");
          FS.mkdir("/home");
          FS.mkdir("/home/web_user");
        }, createDefaultDevices: () => {
          FS.mkdir("/dev");
          FS.registerDevice(FS.makedev(1, 3), { read: () => 0, write: (stream, buffer, offset, length, pos) => length });
          FS.mkdev("/dev/null", FS.makedev(1, 3));
          TTY.register(FS.makedev(5, 0), TTY.default_tty_ops);
          TTY.register(FS.makedev(6, 0), TTY.default_tty1_ops);
          FS.mkdev("/dev/tty", FS.makedev(5, 0));
          FS.mkdev("/dev/tty1", FS.makedev(6, 0));
          var randomBuffer = new Uint8Array(1024), randomLeft = 0;
          var randomByte = () => {
            if (randomLeft === 0) {
              randomLeft = randomFill(randomBuffer).byteLength;
            }
            return randomBuffer[--randomLeft];
          };
          FS.createDevice("/dev", "random", randomByte);
          FS.createDevice("/dev", "urandom", randomByte);
          FS.mkdir("/dev/shm");
          FS.mkdir("/dev/shm/tmp");
        }, createSpecialDirectories: () => {
          FS.mkdir("/proc");
          var proc_self = FS.mkdir("/proc/self");
          FS.mkdir("/proc/self/fd");
          FS.mount({ mount: () => {
            var node = FS.createNode(proc_self, "fd", 16384 | 511, 73);
            node.node_ops = { lookup: (parent, name) => {
              var fd = +name;
              var stream = FS.getStreamChecked(fd);
              var ret = { parent: null, mount: { mountpoint: "fake" }, node_ops: { readlink: () => stream.path } };
              ret.parent = ret;
              return ret;
            } };
            return node;
          } }, {}, "/proc/self/fd");
        }, createStandardStreams: () => {
          if (Module["stdin"]) {
            FS.createDevice("/dev", "stdin", Module["stdin"]);
          } else {
            FS.symlink("/dev/tty", "/dev/stdin");
          }
          if (Module["stdout"]) {
            FS.createDevice("/dev", "stdout", null, Module["stdout"]);
          } else {
            FS.symlink("/dev/tty", "/dev/stdout");
          }
          if (Module["stderr"]) {
            FS.createDevice("/dev", "stderr", null, Module["stderr"]);
          } else {
            FS.symlink("/dev/tty1", "/dev/stderr");
          }
          var stdin = FS.open("/dev/stdin", 0);
          var stdout = FS.open("/dev/stdout", 1);
          var stderr = FS.open("/dev/stderr", 1);
        }, ensureErrnoError: () => {
          if (FS.ErrnoError) return;
          FS.ErrnoError = function ErrnoError(errno, node) {
            this.name = "ErrnoError";
            this.node = node;
            this.setErrno = function(errno2) {
              this.errno = errno2;
            };
            this.setErrno(errno);
            this.message = "FS error";
          };
          FS.ErrnoError.prototype = new Error();
          FS.ErrnoError.prototype.constructor = FS.ErrnoError;
          [44].forEach((code) => {
            FS.genericErrors[code] = new FS.ErrnoError(code);
            FS.genericErrors[code].stack = "<generic error, no stack>";
          });
        }, staticInit: () => {
          FS.ensureErrnoError();
          FS.nameTable = new Array(4096);
          FS.mount(MEMFS, {}, "/");
          FS.createDefaultDirectories();
          FS.createDefaultDevices();
          FS.createSpecialDirectories();
          FS.filesystems = { "MEMFS": MEMFS };
        }, init: (input, output, error) => {
          FS.init.initialized = true;
          FS.ensureErrnoError();
          Module["stdin"] = input || Module["stdin"];
          Module["stdout"] = output || Module["stdout"];
          Module["stderr"] = error || Module["stderr"];
          FS.createStandardStreams();
        }, quit: () => {
          FS.init.initialized = false;
          for (var i = 0; i < FS.streams.length; i++) {
            var stream = FS.streams[i];
            if (!stream) {
              continue;
            }
            FS.close(stream);
          }
        }, findObject: (path, dontResolveLastLink) => {
          var ret = FS.analyzePath(path, dontResolveLastLink);
          if (!ret.exists) {
            return null;
          }
          return ret.object;
        }, analyzePath: (path, dontResolveLastLink) => {
          try {
            var lookup = FS.lookupPath(path, { follow: !dontResolveLastLink });
            path = lookup.path;
          } catch (e) {
          }
          var ret = { isRoot: false, exists: false, error: 0, name: null, path: null, object: null, parentExists: false, parentPath: null, parentObject: null };
          try {
            var lookup = FS.lookupPath(path, { parent: true });
            ret.parentExists = true;
            ret.parentPath = lookup.path;
            ret.parentObject = lookup.node;
            ret.name = PATH.basename(path);
            lookup = FS.lookupPath(path, { follow: !dontResolveLastLink });
            ret.exists = true;
            ret.path = lookup.path;
            ret.object = lookup.node;
            ret.name = lookup.node.name;
            ret.isRoot = lookup.path === "/";
          } catch (e) {
            ret.error = e.errno;
          }
          return ret;
        }, createPath: (parent, path, canRead, canWrite) => {
          parent = typeof parent == "string" ? parent : FS.getPath(parent);
          var parts = path.split("/").reverse();
          while (parts.length) {
            var part = parts.pop();
            if (!part) continue;
            var current = PATH.join2(parent, part);
            try {
              FS.mkdir(current);
            } catch (e) {
            }
            parent = current;
          }
          return current;
        }, createFile: (parent, name, properties, canRead, canWrite) => {
          var path = PATH.join2(typeof parent == "string" ? parent : FS.getPath(parent), name);
          var mode = FS_getMode(canRead, canWrite);
          return FS.create(path, mode);
        }, createDataFile: (parent, name, data, canRead, canWrite, canOwn) => {
          var path = name;
          if (parent) {
            parent = typeof parent == "string" ? parent : FS.getPath(parent);
            path = name ? PATH.join2(parent, name) : parent;
          }
          var mode = FS_getMode(canRead, canWrite);
          var node = FS.create(path, mode);
          if (data) {
            if (typeof data == "string") {
              var arr = new Array(data.length);
              for (var i = 0, len = data.length; i < len; ++i) arr[i] = data.charCodeAt(i);
              data = arr;
            }
            FS.chmod(node, mode | 146);
            var stream = FS.open(node, 577);
            FS.write(stream, data, 0, data.length, 0, canOwn);
            FS.close(stream);
            FS.chmod(node, mode);
          }
          return node;
        }, createDevice: (parent, name, input, output) => {
          var path = PATH.join2(typeof parent == "string" ? parent : FS.getPath(parent), name);
          var mode = FS_getMode(!!input, !!output);
          if (!FS.createDevice.major) FS.createDevice.major = 64;
          var dev = FS.makedev(FS.createDevice.major++, 0);
          FS.registerDevice(dev, { open: (stream) => {
            stream.seekable = false;
          }, close: (stream) => {
            if (output && output.buffer && output.buffer.length) {
              output(10);
            }
          }, read: (stream, buffer, offset, length, pos) => {
            var bytesRead = 0;
            for (var i = 0; i < length; i++) {
              var result;
              try {
                result = input();
              } catch (e) {
                throw new FS.ErrnoError(29);
              }
              if (result === void 0 && bytesRead === 0) {
                throw new FS.ErrnoError(6);
              }
              if (result === null || result === void 0) break;
              bytesRead++;
              buffer[offset + i] = result;
            }
            if (bytesRead) {
              stream.node.timestamp = Date.now();
            }
            return bytesRead;
          }, write: (stream, buffer, offset, length, pos) => {
            for (var i = 0; i < length; i++) {
              try {
                output(buffer[offset + i]);
              } catch (e) {
                throw new FS.ErrnoError(29);
              }
            }
            if (length) {
              stream.node.timestamp = Date.now();
            }
            return i;
          } });
          return FS.mkdev(path, mode, dev);
        }, forceLoadFile: (obj) => {
          if (obj.isDevice || obj.isFolder || obj.link || obj.contents) return true;
          if (typeof XMLHttpRequest != "undefined") {
            throw new Error("Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.");
          } else if (read_) {
            try {
              obj.contents = intArrayFromString(read_(obj.url), true);
              obj.usedBytes = obj.contents.length;
            } catch (e) {
              throw new FS.ErrnoError(29);
            }
          } else {
            throw new Error("Cannot load without read() or XMLHttpRequest.");
          }
        }, createLazyFile: (parent, name, url, canRead, canWrite) => {
          function LazyUint8Array() {
            this.lengthKnown = false;
            this.chunks = [];
          }
          LazyUint8Array.prototype.get = function LazyUint8Array_get(idx) {
            if (idx > this.length - 1 || idx < 0) {
              return void 0;
            }
            var chunkOffset = idx % this.chunkSize;
            var chunkNum = idx / this.chunkSize | 0;
            return this.getter(chunkNum)[chunkOffset];
          };
          LazyUint8Array.prototype.setDataGetter = function LazyUint8Array_setDataGetter(getter) {
            this.getter = getter;
          };
          LazyUint8Array.prototype.cacheLength = function LazyUint8Array_cacheLength() {
            var xhr = new XMLHttpRequest();
            xhr.open("HEAD", url, false);
            xhr.send(null);
            if (!(xhr.status >= 200 && xhr.status < 300 || xhr.status === 304)) throw new Error("Couldn't load " + url + ". Status: " + xhr.status);
            var datalength = Number(xhr.getResponseHeader("Content-length"));
            var header;
            var hasByteServing = (header = xhr.getResponseHeader("Accept-Ranges")) && header === "bytes";
            var usesGzip = (header = xhr.getResponseHeader("Content-Encoding")) && header === "gzip";
            var chunkSize = 1024 * 1024;
            if (!hasByteServing) chunkSize = datalength;
            var doXHR = (from, to) => {
              if (from > to) throw new Error("invalid range (" + from + ", " + to + ") or no bytes requested!");
              if (to > datalength - 1) throw new Error("only " + datalength + " bytes available! programmer error!");
              var xhr2 = new XMLHttpRequest();
              xhr2.open("GET", url, false);
              if (datalength !== chunkSize) xhr2.setRequestHeader("Range", "bytes=" + from + "-" + to);
              xhr2.responseType = "arraybuffer";
              if (xhr2.overrideMimeType) {
                xhr2.overrideMimeType("text/plain; charset=x-user-defined");
              }
              xhr2.send(null);
              if (!(xhr2.status >= 200 && xhr2.status < 300 || xhr2.status === 304)) throw new Error("Couldn't load " + url + ". Status: " + xhr2.status);
              if (xhr2.response !== void 0) {
                return new Uint8Array(xhr2.response || []);
              }
              return intArrayFromString(xhr2.responseText || "", true);
            };
            var lazyArray2 = this;
            lazyArray2.setDataGetter((chunkNum) => {
              var start = chunkNum * chunkSize;
              var end = (chunkNum + 1) * chunkSize - 1;
              end = Math.min(end, datalength - 1);
              if (typeof lazyArray2.chunks[chunkNum] == "undefined") {
                lazyArray2.chunks[chunkNum] = doXHR(start, end);
              }
              if (typeof lazyArray2.chunks[chunkNum] == "undefined") throw new Error("doXHR failed!");
              return lazyArray2.chunks[chunkNum];
            });
            if (usesGzip || !datalength) {
              chunkSize = datalength = 1;
              datalength = this.getter(0).length;
              chunkSize = datalength;
              out("LazyFiles on gzip forces download of the whole file when length is accessed");
            }
            this._length = datalength;
            this._chunkSize = chunkSize;
            this.lengthKnown = true;
          };
          if (typeof XMLHttpRequest != "undefined") {
            if (!ENVIRONMENT_IS_WORKER) throw "Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc";
            var lazyArray = new LazyUint8Array();
            Object.defineProperties(lazyArray, { length: { get: function() {
              if (!this.lengthKnown) {
                this.cacheLength();
              }
              return this._length;
            } }, chunkSize: { get: function() {
              if (!this.lengthKnown) {
                this.cacheLength();
              }
              return this._chunkSize;
            } } });
            var properties = { isDevice: false, contents: lazyArray };
          } else {
            var properties = { isDevice: false, url };
          }
          var node = FS.createFile(parent, name, properties, canRead, canWrite);
          if (properties.contents) {
            node.contents = properties.contents;
          } else if (properties.url) {
            node.contents = null;
            node.url = properties.url;
          }
          Object.defineProperties(node, { usedBytes: { get: function() {
            return this.contents.length;
          } } });
          var stream_ops = {};
          var keys = Object.keys(node.stream_ops);
          keys.forEach((key) => {
            var fn = node.stream_ops[key];
            stream_ops[key] = function forceLoadLazyFile() {
              FS.forceLoadFile(node);
              return fn.apply(null, arguments);
            };
          });
          function writeChunks(stream, buffer, offset, length, position) {
            var contents = stream.node.contents;
            if (position >= contents.length) return 0;
            var size = Math.min(contents.length - position, length);
            if (contents.slice) {
              for (var i = 0; i < size; i++) {
                buffer[offset + i] = contents[position + i];
              }
            } else {
              for (var i = 0; i < size; i++) {
                buffer[offset + i] = contents.get(position + i);
              }
            }
            return size;
          }
          stream_ops.read = (stream, buffer, offset, length, position) => {
            FS.forceLoadFile(node);
            return writeChunks(stream, buffer, offset, length, position);
          };
          stream_ops.mmap = (stream, length, position, prot, flags) => {
            FS.forceLoadFile(node);
            var ptr = mmapAlloc(length);
            if (!ptr) {
              throw new FS.ErrnoError(48);
            }
            writeChunks(stream, HEAP8, ptr, length, position);
            return { ptr, allocated: true };
          };
          node.stream_ops = stream_ops;
          return node;
        } };
        var SYSCALLS = { DEFAULT_POLLMASK: 5, calculateAt: function(dirfd, path, allowEmpty) {
          if (PATH.isAbs(path)) {
            return path;
          }
          var dir;
          if (dirfd === -100) {
            dir = FS.cwd();
          } else {
            var dirstream = SYSCALLS.getStreamFromFD(dirfd);
            dir = dirstream.path;
          }
          if (path.length == 0) {
            if (!allowEmpty) {
              throw new FS.ErrnoError(44);
            }
            return dir;
          }
          return PATH.join2(dir, path);
        }, doStat: function(func, path, buf) {
          try {
            var stat = func(path);
          } catch (e) {
            if (e && e.node && PATH.normalize(path) !== PATH.normalize(FS.getPath(e.node))) {
              return -54;
            }
            throw e;
          }
          HEAP32[buf >>> 2] = stat.dev;
          HEAP32[buf + 4 >>> 2] = stat.mode;
          HEAPU32[buf + 8 >>> 2] = stat.nlink;
          HEAP32[buf + 12 >>> 2] = stat.uid;
          HEAP32[buf + 16 >>> 2] = stat.gid;
          HEAP32[buf + 20 >>> 2] = stat.rdev;
          tempI64 = [stat.size >>> 0, (tempDouble = stat.size, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], HEAP32[buf + 24 >>> 2] = tempI64[0], HEAP32[buf + 28 >>> 2] = tempI64[1];
          HEAP32[buf + 32 >>> 2] = 4096;
          HEAP32[buf + 36 >>> 2] = stat.blocks;
          var atime = stat.atime.getTime();
          var mtime = stat.mtime.getTime();
          var ctime = stat.ctime.getTime();
          tempI64 = [Math.floor(atime / 1e3) >>> 0, (tempDouble = Math.floor(atime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], HEAP32[buf + 40 >>> 2] = tempI64[0], HEAP32[buf + 44 >>> 2] = tempI64[1];
          HEAPU32[buf + 48 >>> 2] = atime % 1e3 * 1e3;
          tempI64 = [Math.floor(mtime / 1e3) >>> 0, (tempDouble = Math.floor(mtime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], HEAP32[buf + 56 >>> 2] = tempI64[0], HEAP32[buf + 60 >>> 2] = tempI64[1];
          HEAPU32[buf + 64 >>> 2] = mtime % 1e3 * 1e3;
          tempI64 = [Math.floor(ctime / 1e3) >>> 0, (tempDouble = Math.floor(ctime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], HEAP32[buf + 72 >>> 2] = tempI64[0], HEAP32[buf + 76 >>> 2] = tempI64[1];
          HEAPU32[buf + 80 >>> 2] = ctime % 1e3 * 1e3;
          tempI64 = [stat.ino >>> 0, (tempDouble = stat.ino, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], HEAP32[buf + 88 >>> 2] = tempI64[0], HEAP32[buf + 92 >>> 2] = tempI64[1];
          return 0;
        }, doMsync: function(addr, stream, len, flags, offset) {
          if (!FS.isFile(stream.node.mode)) {
            throw new FS.ErrnoError(43);
          }
          if (flags & 2) {
            return 0;
          }
          var buffer = HEAPU8.slice(addr, addr + len);
          FS.msync(stream, buffer, offset, len, flags);
        }, varargs: void 0, get() {
          SYSCALLS.varargs += 4;
          var ret = HEAP32[SYSCALLS.varargs - 4 >>> 2];
          return ret;
        }, getStr(ptr) {
          var ret = UTF8ToString(ptr);
          return ret;
        }, getStreamFromFD: function(fd) {
          var stream = FS.getStreamChecked(fd);
          return stream;
        } };
        function _environ_get(__environ, environ_buf) {
          __environ >>>= 0;
          environ_buf >>>= 0;
          var bufSize = 0;
          getEnvStrings().forEach(function(string, i) {
            var ptr = environ_buf + bufSize;
            HEAPU32[__environ + i * 4 >>> 2] = ptr;
            stringToAscii(string, ptr);
            bufSize += string.length + 1;
          });
          return 0;
        }
        function _environ_sizes_get(penviron_count, penviron_buf_size) {
          penviron_count >>>= 0;
          penviron_buf_size >>>= 0;
          var strings = getEnvStrings();
          HEAPU32[penviron_count >>> 2] = strings.length;
          var bufSize = 0;
          strings.forEach(function(string) {
            bufSize += string.length + 1;
          });
          HEAPU32[penviron_buf_size >>> 2] = bufSize;
          return 0;
        }
        function _fd_close(fd) {
          try {
            var stream = SYSCALLS.getStreamFromFD(fd);
            FS.close(stream);
            return 0;
          } catch (e) {
            if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
            return e.errno;
          }
        }
        function _fd_fdstat_get(fd, pbuf) {
          pbuf >>>= 0;
          try {
            var rightsBase = 0;
            var rightsInheriting = 0;
            var flags = 0;
            {
              var stream = SYSCALLS.getStreamFromFD(fd);
              var type = stream.tty ? 2 : FS.isDir(stream.mode) ? 3 : FS.isLink(stream.mode) ? 7 : 4;
            }
            HEAP8[pbuf >>> 0] = type;
            HEAP16[pbuf + 2 >>> 1] = flags;
            tempI64 = [rightsBase >>> 0, (tempDouble = rightsBase, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], HEAP32[pbuf + 8 >>> 2] = tempI64[0], HEAP32[pbuf + 12 >>> 2] = tempI64[1];
            tempI64 = [rightsInheriting >>> 0, (tempDouble = rightsInheriting, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], HEAP32[pbuf + 16 >>> 2] = tempI64[0], HEAP32[pbuf + 20 >>> 2] = tempI64[1];
            return 0;
          } catch (e) {
            if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
            return e.errno;
          }
        }
        var doReadv = (stream, iov, iovcnt, offset) => {
          var ret = 0;
          for (var i = 0; i < iovcnt; i++) {
            var ptr = HEAPU32[iov >>> 2];
            var len = HEAPU32[iov + 4 >>> 2];
            iov += 8;
            var curr = FS.read(stream, HEAP8, ptr, len, offset);
            if (curr < 0) return -1;
            ret += curr;
            if (curr < len) break;
            if (typeof offset !== "undefined") {
              offset += curr;
            }
          }
          return ret;
        };
        function _fd_read(fd, iov, iovcnt, pnum) {
          iov >>>= 0;
          iovcnt >>>= 0;
          pnum >>>= 0;
          try {
            var stream = SYSCALLS.getStreamFromFD(fd);
            var num = doReadv(stream, iov, iovcnt);
            HEAPU32[pnum >>> 2] = num;
            return 0;
          } catch (e) {
            if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
            return e.errno;
          }
        }
        function _fd_seek(fd, offset_low, offset_high, whence, newOffset) {
          var offset = convertI32PairToI53Checked(offset_low, offset_high);
          newOffset >>>= 0;
          try {
            if (isNaN(offset)) return 61;
            var stream = SYSCALLS.getStreamFromFD(fd);
            FS.llseek(stream, offset, whence);
            tempI64 = [stream.position >>> 0, (tempDouble = stream.position, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], HEAP32[newOffset >>> 2] = tempI64[0], HEAP32[newOffset + 4 >>> 2] = tempI64[1];
            if (stream.getdents && offset === 0 && whence === 0) stream.getdents = null;
            return 0;
          } catch (e) {
            if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
            return e.errno;
          }
        }
        var doWritev = (stream, iov, iovcnt, offset) => {
          var ret = 0;
          for (var i = 0; i < iovcnt; i++) {
            var ptr = HEAPU32[iov >>> 2];
            var len = HEAPU32[iov + 4 >>> 2];
            iov += 8;
            var curr = FS.write(stream, HEAP8, ptr, len, offset);
            if (curr < 0) return -1;
            ret += curr;
            if (typeof offset !== "undefined") {
              offset += curr;
            }
          }
          return ret;
        };
        function _fd_write(fd, iov, iovcnt, pnum) {
          iov >>>= 0;
          iovcnt >>>= 0;
          pnum >>>= 0;
          try {
            var stream = SYSCALLS.getStreamFromFD(fd);
            var num = doWritev(stream, iov, iovcnt);
            HEAPU32[pnum >>> 2] = num;
            return 0;
          } catch (e) {
            if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
            return e.errno;
          }
        }
        var arraySum = (array, index) => {
          var sum = 0;
          for (var i = 0; i <= index; sum += array[i++]) {
          }
          return sum;
        };
        var MONTH_DAYS_LEAP = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        var MONTH_DAYS_REGULAR = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        var addDays = (date, days) => {
          var newDate = new Date(date.getTime());
          while (days > 0) {
            var leap = isLeapYear(newDate.getFullYear());
            var currentMonth = newDate.getMonth();
            var daysInCurrentMonth = (leap ? MONTH_DAYS_LEAP : MONTH_DAYS_REGULAR)[currentMonth];
            if (days > daysInCurrentMonth - newDate.getDate()) {
              days -= daysInCurrentMonth - newDate.getDate() + 1;
              newDate.setDate(1);
              if (currentMonth < 11) {
                newDate.setMonth(currentMonth + 1);
              } else {
                newDate.setMonth(0);
                newDate.setFullYear(newDate.getFullYear() + 1);
              }
            } else {
              newDate.setDate(newDate.getDate() + days);
              return newDate;
            }
          }
          return newDate;
        };
        var writeArrayToMemory = (array, buffer) => {
          HEAP8.set(array, buffer >>> 0);
        };
        function _strftime(s, maxsize, format, tm) {
          s >>>= 0;
          maxsize >>>= 0;
          format >>>= 0;
          tm >>>= 0;
          var tm_zone = HEAP32[tm + 40 >>> 2];
          var date = { tm_sec: HEAP32[tm >>> 2], tm_min: HEAP32[tm + 4 >>> 2], tm_hour: HEAP32[tm + 8 >>> 2], tm_mday: HEAP32[tm + 12 >>> 2], tm_mon: HEAP32[tm + 16 >>> 2], tm_year: HEAP32[tm + 20 >>> 2], tm_wday: HEAP32[tm + 24 >>> 2], tm_yday: HEAP32[tm + 28 >>> 2], tm_isdst: HEAP32[tm + 32 >>> 2], tm_gmtoff: HEAP32[tm + 36 >>> 2], tm_zone: tm_zone ? UTF8ToString(tm_zone) : "" };
          var pattern = UTF8ToString(format);
          var EXPANSION_RULES_1 = { "%c": "%a %b %d %H:%M:%S %Y", "%D": "%m/%d/%y", "%F": "%Y-%m-%d", "%h": "%b", "%r": "%I:%M:%S %p", "%R": "%H:%M", "%T": "%H:%M:%S", "%x": "%m/%d/%y", "%X": "%H:%M:%S", "%Ec": "%c", "%EC": "%C", "%Ex": "%m/%d/%y", "%EX": "%H:%M:%S", "%Ey": "%y", "%EY": "%Y", "%Od": "%d", "%Oe": "%e", "%OH": "%H", "%OI": "%I", "%Om": "%m", "%OM": "%M", "%OS": "%S", "%Ou": "%u", "%OU": "%U", "%OV": "%V", "%Ow": "%w", "%OW": "%W", "%Oy": "%y" };
          for (var rule in EXPANSION_RULES_1) {
            pattern = pattern.replace(new RegExp(rule, "g"), EXPANSION_RULES_1[rule]);
          }
          var WEEKDAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
          var MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
          function leadingSomething(value, digits, character) {
            var str = typeof value == "number" ? value.toString() : value || "";
            while (str.length < digits) {
              str = character[0] + str;
            }
            return str;
          }
          function leadingNulls(value, digits) {
            return leadingSomething(value, digits, "0");
          }
          function compareByDay(date1, date2) {
            function sgn(value) {
              return value < 0 ? -1 : value > 0 ? 1 : 0;
            }
            var compare;
            if ((compare = sgn(date1.getFullYear() - date2.getFullYear())) === 0) {
              if ((compare = sgn(date1.getMonth() - date2.getMonth())) === 0) {
                compare = sgn(date1.getDate() - date2.getDate());
              }
            }
            return compare;
          }
          function getFirstWeekStartDate(janFourth) {
            switch (janFourth.getDay()) {
              case 0:
                return new Date(janFourth.getFullYear() - 1, 11, 29);
              case 1:
                return janFourth;
              case 2:
                return new Date(janFourth.getFullYear(), 0, 3);
              case 3:
                return new Date(janFourth.getFullYear(), 0, 2);
              case 4:
                return new Date(janFourth.getFullYear(), 0, 1);
              case 5:
                return new Date(janFourth.getFullYear() - 1, 11, 31);
              case 6:
                return new Date(janFourth.getFullYear() - 1, 11, 30);
            }
          }
          function getWeekBasedYear(date2) {
            var thisDate = addDays(new Date(date2.tm_year + 1900, 0, 1), date2.tm_yday);
            var janFourthThisYear = new Date(thisDate.getFullYear(), 0, 4);
            var janFourthNextYear = new Date(thisDate.getFullYear() + 1, 0, 4);
            var firstWeekStartThisYear = getFirstWeekStartDate(janFourthThisYear);
            var firstWeekStartNextYear = getFirstWeekStartDate(janFourthNextYear);
            if (compareByDay(firstWeekStartThisYear, thisDate) <= 0) {
              if (compareByDay(firstWeekStartNextYear, thisDate) <= 0) {
                return thisDate.getFullYear() + 1;
              }
              return thisDate.getFullYear();
            }
            return thisDate.getFullYear() - 1;
          }
          var EXPANSION_RULES_2 = { "%a": (date2) => WEEKDAYS[date2.tm_wday].substring(0, 3), "%A": (date2) => WEEKDAYS[date2.tm_wday], "%b": (date2) => MONTHS[date2.tm_mon].substring(0, 3), "%B": (date2) => MONTHS[date2.tm_mon], "%C": (date2) => {
            var year = date2.tm_year + 1900;
            return leadingNulls(year / 100 | 0, 2);
          }, "%d": (date2) => leadingNulls(date2.tm_mday, 2), "%e": (date2) => leadingSomething(date2.tm_mday, 2, " "), "%g": (date2) => getWeekBasedYear(date2).toString().substring(2), "%G": (date2) => getWeekBasedYear(date2), "%H": (date2) => leadingNulls(date2.tm_hour, 2), "%I": (date2) => {
            var twelveHour = date2.tm_hour;
            if (twelveHour == 0) twelveHour = 12;
            else if (twelveHour > 12) twelveHour -= 12;
            return leadingNulls(twelveHour, 2);
          }, "%j": (date2) => leadingNulls(date2.tm_mday + arraySum(isLeapYear(date2.tm_year + 1900) ? MONTH_DAYS_LEAP : MONTH_DAYS_REGULAR, date2.tm_mon - 1), 3), "%m": (date2) => leadingNulls(date2.tm_mon + 1, 2), "%M": (date2) => leadingNulls(date2.tm_min, 2), "%n": () => "\n", "%p": (date2) => {
            if (date2.tm_hour >= 0 && date2.tm_hour < 12) {
              return "AM";
            }
            return "PM";
          }, "%S": (date2) => leadingNulls(date2.tm_sec, 2), "%t": () => "	", "%u": (date2) => date2.tm_wday || 7, "%U": (date2) => {
            var days = date2.tm_yday + 7 - date2.tm_wday;
            return leadingNulls(Math.floor(days / 7), 2);
          }, "%V": (date2) => {
            var val = Math.floor((date2.tm_yday + 7 - (date2.tm_wday + 6) % 7) / 7);
            if ((date2.tm_wday + 371 - date2.tm_yday - 2) % 7 <= 2) {
              val++;
            }
            if (!val) {
              val = 52;
              var dec31 = (date2.tm_wday + 7 - date2.tm_yday - 1) % 7;
              if (dec31 == 4 || dec31 == 5 && isLeapYear(date2.tm_year % 400 - 1)) {
                val++;
              }
            } else if (val == 53) {
              var jan1 = (date2.tm_wday + 371 - date2.tm_yday) % 7;
              if (jan1 != 4 && (jan1 != 3 || !isLeapYear(date2.tm_year))) val = 1;
            }
            return leadingNulls(val, 2);
          }, "%w": (date2) => date2.tm_wday, "%W": (date2) => {
            var days = date2.tm_yday + 7 - (date2.tm_wday + 6) % 7;
            return leadingNulls(Math.floor(days / 7), 2);
          }, "%y": (date2) => (date2.tm_year + 1900).toString().substring(2), "%Y": (date2) => date2.tm_year + 1900, "%z": (date2) => {
            var off = date2.tm_gmtoff;
            var ahead = off >= 0;
            off = Math.abs(off) / 60;
            off = off / 60 * 100 + off % 60;
            return (ahead ? "+" : "-") + String("0000" + off).slice(-4);
          }, "%Z": (date2) => date2.tm_zone, "%%": () => "%" };
          pattern = pattern.replace(/%%/g, "\0\0");
          for (var rule in EXPANSION_RULES_2) {
            if (pattern.includes(rule)) {
              pattern = pattern.replace(new RegExp(rule, "g"), EXPANSION_RULES_2[rule](date));
            }
          }
          pattern = pattern.replace(/\0\0/g, "%");
          var bytes = intArrayFromString(pattern, false);
          if (bytes.length > maxsize) {
            return 0;
          }
          writeArrayToMemory(bytes, s);
          return bytes.length - 1;
        }
        function _strftime_l(s, maxsize, format, tm, loc) {
          s >>>= 0;
          maxsize >>>= 0;
          format >>>= 0;
          tm >>>= 0;
          loc >>>= 0;
          return _strftime(s, maxsize, format, tm);
        }
        InternalError = Module["InternalError"] = class InternalError extends Error {
          constructor(message) {
            super(message);
            this.name = "InternalError";
          }
        };
        embind_init_charCodes();
        BindingError = Module["BindingError"] = class BindingError extends Error {
          constructor(message) {
            super(message);
            this.name = "BindingError";
          }
        };
        init_ClassHandle();
        init_embind();
        init_RegisteredPointer();
        UnboundTypeError = Module["UnboundTypeError"] = extendError(Error, "UnboundTypeError");
        handleAllocatorInit();
        init_emval();
        var FSNode = function(parent, name, mode, rdev) {
          if (!parent) {
            parent = this;
          }
          this.parent = parent;
          this.mount = parent.mount;
          this.mounted = null;
          this.id = FS.nextInode++;
          this.name = name;
          this.mode = mode;
          this.node_ops = {};
          this.stream_ops = {};
          this.rdev = rdev;
        };
        var readMode = 292 | 73;
        var writeMode = 146;
        Object.defineProperties(FSNode.prototype, { read: { get: function() {
          return (this.mode & readMode) === readMode;
        }, set: function(val) {
          val ? this.mode |= readMode : this.mode &= ~readMode;
        } }, write: { get: function() {
          return (this.mode & writeMode) === writeMode;
        }, set: function(val) {
          val ? this.mode |= writeMode : this.mode &= ~writeMode;
        } }, isFolder: { get: function() {
          return FS.isDir(this.mode);
        } }, isDevice: { get: function() {
          return FS.isChrdev(this.mode);
        } } });
        FS.FSNode = FSNode;
        FS.createPreloadedFile = FS_createPreloadedFile;
        FS.staticInit();
        var wasmImports = { f: ___cxa_throw, W: __embind_finalize_value_array, q: __embind_finalize_value_object, G: __embind_register_bigint, U: __embind_register_bool, p: __embind_register_class, o: __embind_register_class_constructor, b: __embind_register_class_function, T: __embind_register_emval, z: __embind_register_float, c: __embind_register_function, s: __embind_register_integer, k: __embind_register_memory_view, A: __embind_register_std_string, w: __embind_register_std_wstring, X: __embind_register_value_array, l: __embind_register_value_array_element, r: __embind_register_value_object, e: __embind_register_value_object_field, V: __embind_register_void, N: __emscripten_get_now_is_monotonic, j: __emval_as, v: __emval_call, a: __emval_decref, y: __emval_get_global, h: __emval_get_property, n: __emval_incref, C: __emval_instanceof, x: __emval_is_number, B: __emval_is_string, Y: __emval_new_array, g: __emval_new_cstring, t: __emval_new_object, i: __emval_run_destructors, m: __emval_set_property, d: __emval_take_value, E: __gmtime_js, F: __localtime_js, L: __tzset_js, u: _abort, O: _emscripten_date_now, S: _emscripten_memcpy_big, K: _emscripten_resize_heap, Q: _environ_get, R: _environ_sizes_get, I: _fd_close, P: _fd_fdstat_get, J: _fd_read, D: _fd_seek, M: _fd_write, H: _strftime_l };
        var asm = createWasm();
        var ___wasm_call_ctors = () => (___wasm_call_ctors = wasmExports["_"])();
        var _malloc = (a0) => (_malloc = wasmExports["aa"])(a0);
        var ___getTypeName = (a0) => (___getTypeName = wasmExports["ba"])(a0);
        var __embind_initialize_bindings = Module["__embind_initialize_bindings"] = () => (__embind_initialize_bindings = Module["__embind_initialize_bindings"] = wasmExports["ca"])();
        var ___errno_location = () => (___errno_location = wasmExports["__errno_location"])();
        var _free = (a0) => (_free = wasmExports["da"])(a0);
        var ___cxa_increment_exception_refcount = (a0) => (___cxa_increment_exception_refcount = wasmExports["__cxa_increment_exception_refcount"])(a0);
        var ___cxa_is_pointer_type = (a0) => (___cxa_is_pointer_type = wasmExports["ea"])(a0);
        var dynCall_jiji = Module["dynCall_jiji"] = (a0, a1, a2, a3, a4) => (dynCall_jiji = Module["dynCall_jiji"] = wasmExports["fa"])(a0, a1, a2, a3, a4);
        var dynCall_viijii = Module["dynCall_viijii"] = (a0, a1, a2, a3, a4, a5, a6) => (dynCall_viijii = Module["dynCall_viijii"] = wasmExports["ga"])(a0, a1, a2, a3, a4, a5, a6);
        var dynCall_iiiiij = Module["dynCall_iiiiij"] = (a0, a1, a2, a3, a4, a5, a6) => (dynCall_iiiiij = Module["dynCall_iiiiij"] = wasmExports["ha"])(a0, a1, a2, a3, a4, a5, a6);
        var dynCall_iiiiijj = Module["dynCall_iiiiijj"] = (a0, a1, a2, a3, a4, a5, a6, a7, a8) => (dynCall_iiiiijj = Module["dynCall_iiiiijj"] = wasmExports["ia"])(a0, a1, a2, a3, a4, a5, a6, a7, a8);
        var dynCall_iiiiiijj = Module["dynCall_iiiiiijj"] = (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) => (dynCall_iiiiiijj = Module["dynCall_iiiiiijj"] = wasmExports["ja"])(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9);
        function applySignatureConversions(exports3) {
          exports3 = Object.assign({}, exports3);
          var makeWrapper_pp = (f) => (a0) => f(a0) >>> 0;
          var makeWrapper_p = (f) => () => f() >>> 0;
          exports3["malloc"] = makeWrapper_pp(exports3["malloc"]);
          exports3["__getTypeName"] = makeWrapper_pp(exports3["__getTypeName"]);
          exports3["__errno_location"] = makeWrapper_p(exports3["__errno_location"]);
          exports3["stackSave"] = makeWrapper_p(exports3["stackSave"]);
          exports3["stackAlloc"] = makeWrapper_pp(exports3["stackAlloc"]);
          return exports3;
        }
        var calledRun;
        dependenciesFulfilled = function runCaller() {
          if (!calledRun) run();
          if (!calledRun) dependenciesFulfilled = runCaller;
        };
        function run() {
          if (runDependencies > 0) {
            return;
          }
          preRun();
          if (runDependencies > 0) {
            return;
          }
          function doRun() {
            if (calledRun) return;
            calledRun = true;
            Module["calledRun"] = true;
            if (ABORT) return;
            initRuntime();
            readyPromiseResolve(Module);
            if (Module["onRuntimeInitialized"]) Module["onRuntimeInitialized"]();
            postRun();
          }
          if (Module["setStatus"]) {
            Module["setStatus"]("Running...");
            setTimeout(function() {
              setTimeout(function() {
                Module["setStatus"]("");
              }, 1);
              doRun();
            }, 1);
          } else {
            doRun();
          }
        }
        if (Module["preInit"]) {
          if (typeof Module["preInit"] == "function") Module["preInit"] = [Module["preInit"]];
          while (Module["preInit"].length > 0) {
            Module["preInit"].pop()();
          }
        }
        run();
        return moduleArg.ready;
      };
    })();
    if (typeof exports2 === "object" && typeof module2 === "object")
      module2.exports = WebIFCWasm2;
    else if (true)
      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (() => WebIFCWasm2).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
});

// dist/web-ifc-api.ts
var web_ifc_api_exports = {};
__export(web_ifc_api_exports, {
  Constructors: () => Constructors,
  EMPTY: () => EMPTY,
  ENUM: () => ENUM,
  FILE_DESCRIPTION: () => FILE_DESCRIPTION,
  FILE_NAME: () => FILE_NAME,
  FILE_SCHEMA: () => FILE_SCHEMA,
  FromRawLineData: () => FromRawLineData,
  Handle: () => Handle,
  IFC2DCOMPOSITECURVE: () => IFC2DCOMPOSITECURVE,
  IFC2X3: () => IFC2X3,
  IFC4: () => IFC4,
  IFC4X3: () => IFC4X3,
  IFCABSORBEDDOSEMEASURE: () => IFCABSORBEDDOSEMEASURE,
  IFCACCELERATIONMEASURE: () => IFCACCELERATIONMEASURE,
  IFCACTIONREQUEST: () => IFCACTIONREQUEST,
  IFCACTOR: () => IFCACTOR,
  IFCACTORROLE: () => IFCACTORROLE,
  IFCACTUATOR: () => IFCACTUATOR,
  IFCACTUATORTYPE: () => IFCACTUATORTYPE,
  IFCADDRESS: () => IFCADDRESS,
  IFCADVANCEDBREP: () => IFCADVANCEDBREP,
  IFCADVANCEDBREPWITHVOIDS: () => IFCADVANCEDBREPWITHVOIDS,
  IFCADVANCEDFACE: () => IFCADVANCEDFACE,
  IFCAIRTERMINAL: () => IFCAIRTERMINAL,
  IFCAIRTERMINALBOX: () => IFCAIRTERMINALBOX,
  IFCAIRTERMINALBOXTYPE: () => IFCAIRTERMINALBOXTYPE,
  IFCAIRTERMINALTYPE: () => IFCAIRTERMINALTYPE,
  IFCAIRTOAIRHEATRECOVERY: () => IFCAIRTOAIRHEATRECOVERY,
  IFCAIRTOAIRHEATRECOVERYTYPE: () => IFCAIRTOAIRHEATRECOVERYTYPE,
  IFCALARM: () => IFCALARM,
  IFCALARMTYPE: () => IFCALARMTYPE,
  IFCALIGNMENT: () => IFCALIGNMENT,
  IFCALIGNMENTCANT: () => IFCALIGNMENTCANT,
  IFCALIGNMENTCANTSEGMENT: () => IFCALIGNMENTCANTSEGMENT,
  IFCALIGNMENTHORIZONTAL: () => IFCALIGNMENTHORIZONTAL,
  IFCALIGNMENTHORIZONTALSEGMENT: () => IFCALIGNMENTHORIZONTALSEGMENT,
  IFCALIGNMENTPARAMETERSEGMENT: () => IFCALIGNMENTPARAMETERSEGMENT,
  IFCALIGNMENTSEGMENT: () => IFCALIGNMENTSEGMENT,
  IFCALIGNMENTVERTICAL: () => IFCALIGNMENTVERTICAL,
  IFCALIGNMENTVERTICALSEGMENT: () => IFCALIGNMENTVERTICALSEGMENT,
  IFCAMOUNTOFSUBSTANCEMEASURE: () => IFCAMOUNTOFSUBSTANCEMEASURE,
  IFCANGULARDIMENSION: () => IFCANGULARDIMENSION,
  IFCANGULARVELOCITYMEASURE: () => IFCANGULARVELOCITYMEASURE,
  IFCANNOTATION: () => IFCANNOTATION,
  IFCANNOTATIONCURVEOCCURRENCE: () => IFCANNOTATIONCURVEOCCURRENCE,
  IFCANNOTATIONFILLAREA: () => IFCANNOTATIONFILLAREA,
  IFCANNOTATIONFILLAREAOCCURRENCE: () => IFCANNOTATIONFILLAREAOCCURRENCE,
  IFCANNOTATIONOCCURRENCE: () => IFCANNOTATIONOCCURRENCE,
  IFCANNOTATIONSURFACE: () => IFCANNOTATIONSURFACE,
  IFCANNOTATIONSURFACEOCCURRENCE: () => IFCANNOTATIONSURFACEOCCURRENCE,
  IFCANNOTATIONSYMBOLOCCURRENCE: () => IFCANNOTATIONSYMBOLOCCURRENCE,
  IFCANNOTATIONTEXTOCCURRENCE: () => IFCANNOTATIONTEXTOCCURRENCE,
  IFCAPPLICATION: () => IFCAPPLICATION,
  IFCAPPLIEDVALUE: () => IFCAPPLIEDVALUE,
  IFCAPPLIEDVALUERELATIONSHIP: () => IFCAPPLIEDVALUERELATIONSHIP,
  IFCAPPROVAL: () => IFCAPPROVAL,
  IFCAPPROVALACTORRELATIONSHIP: () => IFCAPPROVALACTORRELATIONSHIP,
  IFCAPPROVALPROPERTYRELATIONSHIP: () => IFCAPPROVALPROPERTYRELATIONSHIP,
  IFCAPPROVALRELATIONSHIP: () => IFCAPPROVALRELATIONSHIP,
  IFCARBITRARYCLOSEDPROFILEDEF: () => IFCARBITRARYCLOSEDPROFILEDEF,
  IFCARBITRARYOPENPROFILEDEF: () => IFCARBITRARYOPENPROFILEDEF,
  IFCARBITRARYPROFILEDEFWITHVOIDS: () => IFCARBITRARYPROFILEDEFWITHVOIDS,
  IFCARCINDEX: () => IFCARCINDEX,
  IFCAREADENSITYMEASURE: () => IFCAREADENSITYMEASURE,
  IFCAREAMEASURE: () => IFCAREAMEASURE,
  IFCASSET: () => IFCASSET,
  IFCASYMMETRICISHAPEPROFILEDEF: () => IFCASYMMETRICISHAPEPROFILEDEF,
  IFCAUDIOVISUALAPPLIANCE: () => IFCAUDIOVISUALAPPLIANCE,
  IFCAUDIOVISUALAPPLIANCETYPE: () => IFCAUDIOVISUALAPPLIANCETYPE,
  IFCAXIS1PLACEMENT: () => IFCAXIS1PLACEMENT,
  IFCAXIS2PLACEMENT2D: () => IFCAXIS2PLACEMENT2D,
  IFCAXIS2PLACEMENT3D: () => IFCAXIS2PLACEMENT3D,
  IFCAXIS2PLACEMENTLINEAR: () => IFCAXIS2PLACEMENTLINEAR,
  IFCBEAM: () => IFCBEAM,
  IFCBEAMSTANDARDCASE: () => IFCBEAMSTANDARDCASE,
  IFCBEAMTYPE: () => IFCBEAMTYPE,
  IFCBEARING: () => IFCBEARING,
  IFCBEARINGTYPE: () => IFCBEARINGTYPE,
  IFCBEZIERCURVE: () => IFCBEZIERCURVE,
  IFCBINARY: () => IFCBINARY,
  IFCBLOBTEXTURE: () => IFCBLOBTEXTURE,
  IFCBLOCK: () => IFCBLOCK,
  IFCBOILER: () => IFCBOILER,
  IFCBOILERTYPE: () => IFCBOILERTYPE,
  IFCBOOLEAN: () => IFCBOOLEAN,
  IFCBOOLEANCLIPPINGRESULT: () => IFCBOOLEANCLIPPINGRESULT,
  IFCBOOLEANRESULT: () => IFCBOOLEANRESULT,
  IFCBOREHOLE: () => IFCBOREHOLE,
  IFCBOUNDARYCONDITION: () => IFCBOUNDARYCONDITION,
  IFCBOUNDARYCURVE: () => IFCBOUNDARYCURVE,
  IFCBOUNDARYEDGECONDITION: () => IFCBOUNDARYEDGECONDITION,
  IFCBOUNDARYFACECONDITION: () => IFCBOUNDARYFACECONDITION,
  IFCBOUNDARYNODECONDITION: () => IFCBOUNDARYNODECONDITION,
  IFCBOUNDARYNODECONDITIONWARPING: () => IFCBOUNDARYNODECONDITIONWARPING,
  IFCBOUNDEDCURVE: () => IFCBOUNDEDCURVE,
  IFCBOUNDEDSURFACE: () => IFCBOUNDEDSURFACE,
  IFCBOUNDINGBOX: () => IFCBOUNDINGBOX,
  IFCBOXALIGNMENT: () => IFCBOXALIGNMENT,
  IFCBOXEDHALFSPACE: () => IFCBOXEDHALFSPACE,
  IFCBRIDGE: () => IFCBRIDGE,
  IFCBRIDGEPART: () => IFCBRIDGEPART,
  IFCBSPLINECURVE: () => IFCBSPLINECURVE,
  IFCBSPLINECURVEWITHKNOTS: () => IFCBSPLINECURVEWITHKNOTS,
  IFCBSPLINESURFACE: () => IFCBSPLINESURFACE,
  IFCBSPLINESURFACEWITHKNOTS: () => IFCBSPLINESURFACEWITHKNOTS,
  IFCBUILDING: () => IFCBUILDING,
  IFCBUILDINGELEMENT: () => IFCBUILDINGELEMENT,
  IFCBUILDINGELEMENTCOMPONENT: () => IFCBUILDINGELEMENTCOMPONENT,
  IFCBUILDINGELEMENTPART: () => IFCBUILDINGELEMENTPART,
  IFCBUILDINGELEMENTPARTTYPE: () => IFCBUILDINGELEMENTPARTTYPE,
  IFCBUILDINGELEMENTPROXY: () => IFCBUILDINGELEMENTPROXY,
  IFCBUILDINGELEMENTPROXYTYPE: () => IFCBUILDINGELEMENTPROXYTYPE,
  IFCBUILDINGELEMENTTYPE: () => IFCBUILDINGELEMENTTYPE,
  IFCBUILDINGSTOREY: () => IFCBUILDINGSTOREY,
  IFCBUILDINGSYSTEM: () => IFCBUILDINGSYSTEM,
  IFCBUILTELEMENT: () => IFCBUILTELEMENT,
  IFCBUILTELEMENTTYPE: () => IFCBUILTELEMENTTYPE,
  IFCBUILTSYSTEM: () => IFCBUILTSYSTEM,
  IFCBURNER: () => IFCBURNER,
  IFCBURNERTYPE: () => IFCBURNERTYPE,
  IFCCABLECARRIERFITTING: () => IFCCABLECARRIERFITTING,
  IFCCABLECARRIERFITTINGTYPE: () => IFCCABLECARRIERFITTINGTYPE,
  IFCCABLECARRIERSEGMENT: () => IFCCABLECARRIERSEGMENT,
  IFCCABLECARRIERSEGMENTTYPE: () => IFCCABLECARRIERSEGMENTTYPE,
  IFCCABLEFITTING: () => IFCCABLEFITTING,
  IFCCABLEFITTINGTYPE: () => IFCCABLEFITTINGTYPE,
  IFCCABLESEGMENT: () => IFCCABLESEGMENT,
  IFCCABLESEGMENTTYPE: () => IFCCABLESEGMENTTYPE,
  IFCCAISSONFOUNDATION: () => IFCCAISSONFOUNDATION,
  IFCCAISSONFOUNDATIONTYPE: () => IFCCAISSONFOUNDATIONTYPE,
  IFCCALENDARDATE: () => IFCCALENDARDATE,
  IFCCARDINALPOINTREFERENCE: () => IFCCARDINALPOINTREFERENCE,
  IFCCARTESIANPOINT: () => IFCCARTESIANPOINT,
  IFCCARTESIANPOINTLIST: () => IFCCARTESIANPOINTLIST,
  IFCCARTESIANPOINTLIST2D: () => IFCCARTESIANPOINTLIST2D,
  IFCCARTESIANPOINTLIST3D: () => IFCCARTESIANPOINTLIST3D,
  IFCCARTESIANTRANSFORMATIONOPERATOR: () => IFCCARTESIANTRANSFORMATIONOPERATOR,
  IFCCARTESIANTRANSFORMATIONOPERATOR2D: () => IFCCARTESIANTRANSFORMATIONOPERATOR2D,
  IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM: () => IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM,
  IFCCARTESIANTRANSFORMATIONOPERATOR3D: () => IFCCARTESIANTRANSFORMATIONOPERATOR3D,
  IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM: () => IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM,
  IFCCENTERLINEPROFILEDEF: () => IFCCENTERLINEPROFILEDEF,
  IFCCHAMFEREDGEFEATURE: () => IFCCHAMFEREDGEFEATURE,
  IFCCHILLER: () => IFCCHILLER,
  IFCCHILLERTYPE: () => IFCCHILLERTYPE,
  IFCCHIMNEY: () => IFCCHIMNEY,
  IFCCHIMNEYTYPE: () => IFCCHIMNEYTYPE,
  IFCCIRCLE: () => IFCCIRCLE,
  IFCCIRCLEHOLLOWPROFILEDEF: () => IFCCIRCLEHOLLOWPROFILEDEF,
  IFCCIRCLEPROFILEDEF: () => IFCCIRCLEPROFILEDEF,
  IFCCIVILELEMENT: () => IFCCIVILELEMENT,
  IFCCIVILELEMENTTYPE: () => IFCCIVILELEMENTTYPE,
  IFCCLASSIFICATION: () => IFCCLASSIFICATION,
  IFCCLASSIFICATIONITEM: () => IFCCLASSIFICATIONITEM,
  IFCCLASSIFICATIONITEMRELATIONSHIP: () => IFCCLASSIFICATIONITEMRELATIONSHIP,
  IFCCLASSIFICATIONNOTATION: () => IFCCLASSIFICATIONNOTATION,
  IFCCLASSIFICATIONNOTATIONFACET: () => IFCCLASSIFICATIONNOTATIONFACET,
  IFCCLASSIFICATIONREFERENCE: () => IFCCLASSIFICATIONREFERENCE,
  IFCCLOSEDSHELL: () => IFCCLOSEDSHELL,
  IFCCLOTHOID: () => IFCCLOTHOID,
  IFCCOIL: () => IFCCOIL,
  IFCCOILTYPE: () => IFCCOILTYPE,
  IFCCOLOURRGB: () => IFCCOLOURRGB,
  IFCCOLOURRGBLIST: () => IFCCOLOURRGBLIST,
  IFCCOLOURSPECIFICATION: () => IFCCOLOURSPECIFICATION,
  IFCCOLUMN: () => IFCCOLUMN,
  IFCCOLUMNSTANDARDCASE: () => IFCCOLUMNSTANDARDCASE,
  IFCCOLUMNTYPE: () => IFCCOLUMNTYPE,
  IFCCOMMUNICATIONSAPPLIANCE: () => IFCCOMMUNICATIONSAPPLIANCE,
  IFCCOMMUNICATIONSAPPLIANCETYPE: () => IFCCOMMUNICATIONSAPPLIANCETYPE,
  IFCCOMPLEXNUMBER: () => IFCCOMPLEXNUMBER,
  IFCCOMPLEXPROPERTY: () => IFCCOMPLEXPROPERTY,
  IFCCOMPLEXPROPERTYTEMPLATE: () => IFCCOMPLEXPROPERTYTEMPLATE,
  IFCCOMPOSITECURVE: () => IFCCOMPOSITECURVE,
  IFCCOMPOSITECURVEONSURFACE: () => IFCCOMPOSITECURVEONSURFACE,
  IFCCOMPOSITECURVESEGMENT: () => IFCCOMPOSITECURVESEGMENT,
  IFCCOMPOSITEPROFILEDEF: () => IFCCOMPOSITEPROFILEDEF,
  IFCCOMPOUNDPLANEANGLEMEASURE: () => IFCCOMPOUNDPLANEANGLEMEASURE,
  IFCCOMPRESSOR: () => IFCCOMPRESSOR,
  IFCCOMPRESSORTYPE: () => IFCCOMPRESSORTYPE,
  IFCCONDENSER: () => IFCCONDENSER,
  IFCCONDENSERTYPE: () => IFCCONDENSERTYPE,
  IFCCONDITION: () => IFCCONDITION,
  IFCCONDITIONCRITERION: () => IFCCONDITIONCRITERION,
  IFCCONIC: () => IFCCONIC,
  IFCCONNECTEDFACESET: () => IFCCONNECTEDFACESET,
  IFCCONNECTIONCURVEGEOMETRY: () => IFCCONNECTIONCURVEGEOMETRY,
  IFCCONNECTIONGEOMETRY: () => IFCCONNECTIONGEOMETRY,
  IFCCONNECTIONPOINTECCENTRICITY: () => IFCCONNECTIONPOINTECCENTRICITY,
  IFCCONNECTIONPOINTGEOMETRY: () => IFCCONNECTIONPOINTGEOMETRY,
  IFCCONNECTIONPORTGEOMETRY: () => IFCCONNECTIONPORTGEOMETRY,
  IFCCONNECTIONSURFACEGEOMETRY: () => IFCCONNECTIONSURFACEGEOMETRY,
  IFCCONNECTIONVOLUMEGEOMETRY: () => IFCCONNECTIONVOLUMEGEOMETRY,
  IFCCONSTRAINT: () => IFCCONSTRAINT,
  IFCCONSTRAINTAGGREGATIONRELATIONSHIP: () => IFCCONSTRAINTAGGREGATIONRELATIONSHIP,
  IFCCONSTRAINTCLASSIFICATIONRELATIONSHIP: () => IFCCONSTRAINTCLASSIFICATIONRELATIONSHIP,
  IFCCONSTRAINTRELATIONSHIP: () => IFCCONSTRAINTRELATIONSHIP,
  IFCCONSTRUCTIONEQUIPMENTRESOURCE: () => IFCCONSTRUCTIONEQUIPMENTRESOURCE,
  IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE: () => IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE,
  IFCCONSTRUCTIONMATERIALRESOURCE: () => IFCCONSTRUCTIONMATERIALRESOURCE,
  IFCCONSTRUCTIONMATERIALRESOURCETYPE: () => IFCCONSTRUCTIONMATERIALRESOURCETYPE,
  IFCCONSTRUCTIONPRODUCTRESOURCE: () => IFCCONSTRUCTIONPRODUCTRESOURCE,
  IFCCONSTRUCTIONPRODUCTRESOURCETYPE: () => IFCCONSTRUCTIONPRODUCTRESOURCETYPE,
  IFCCONSTRUCTIONRESOURCE: () => IFCCONSTRUCTIONRESOURCE,
  IFCCONSTRUCTIONRESOURCETYPE: () => IFCCONSTRUCTIONRESOURCETYPE,
  IFCCONTEXT: () => IFCCONTEXT,
  IFCCONTEXTDEPENDENTMEASURE: () => IFCCONTEXTDEPENDENTMEASURE,
  IFCCONTEXTDEPENDENTUNIT: () => IFCCONTEXTDEPENDENTUNIT,
  IFCCONTROL: () => IFCCONTROL,
  IFCCONTROLLER: () => IFCCONTROLLER,
  IFCCONTROLLERTYPE: () => IFCCONTROLLERTYPE,
  IFCCONVERSIONBASEDUNIT: () => IFCCONVERSIONBASEDUNIT,
  IFCCONVERSIONBASEDUNITWITHOFFSET: () => IFCCONVERSIONBASEDUNITWITHOFFSET,
  IFCCONVEYORSEGMENT: () => IFCCONVEYORSEGMENT,
  IFCCONVEYORSEGMENTTYPE: () => IFCCONVEYORSEGMENTTYPE,
  IFCCOOLEDBEAM: () => IFCCOOLEDBEAM,
  IFCCOOLEDBEAMTYPE: () => IFCCOOLEDBEAMTYPE,
  IFCCOOLINGTOWER: () => IFCCOOLINGTOWER,
  IFCCOOLINGTOWERTYPE: () => IFCCOOLINGTOWERTYPE,
  IFCCOORDINATEDUNIVERSALTIMEOFFSET: () => IFCCOORDINATEDUNIVERSALTIMEOFFSET,
  IFCCOORDINATEOPERATION: () => IFCCOORDINATEOPERATION,
  IFCCOORDINATEREFERENCESYSTEM: () => IFCCOORDINATEREFERENCESYSTEM,
  IFCCOSINESPIRAL: () => IFCCOSINESPIRAL,
  IFCCOSTITEM: () => IFCCOSTITEM,
  IFCCOSTSCHEDULE: () => IFCCOSTSCHEDULE,
  IFCCOSTVALUE: () => IFCCOSTVALUE,
  IFCCOUNTMEASURE: () => IFCCOUNTMEASURE,
  IFCCOURSE: () => IFCCOURSE,
  IFCCOURSETYPE: () => IFCCOURSETYPE,
  IFCCOVERING: () => IFCCOVERING,
  IFCCOVERINGTYPE: () => IFCCOVERINGTYPE,
  IFCCRANERAILASHAPEPROFILEDEF: () => IFCCRANERAILASHAPEPROFILEDEF,
  IFCCRANERAILFSHAPEPROFILEDEF: () => IFCCRANERAILFSHAPEPROFILEDEF,
  IFCCREWRESOURCE: () => IFCCREWRESOURCE,
  IFCCREWRESOURCETYPE: () => IFCCREWRESOURCETYPE,
  IFCCSGPRIMITIVE3D: () => IFCCSGPRIMITIVE3D,
  IFCCSGSOLID: () => IFCCSGSOLID,
  IFCCSHAPEPROFILEDEF: () => IFCCSHAPEPROFILEDEF,
  IFCCURRENCYRELATIONSHIP: () => IFCCURRENCYRELATIONSHIP,
  IFCCURTAINWALL: () => IFCCURTAINWALL,
  IFCCURTAINWALLTYPE: () => IFCCURTAINWALLTYPE,
  IFCCURVATUREMEASURE: () => IFCCURVATUREMEASURE,
  IFCCURVE: () => IFCCURVE,
  IFCCURVEBOUNDEDPLANE: () => IFCCURVEBOUNDEDPLANE,
  IFCCURVEBOUNDEDSURFACE: () => IFCCURVEBOUNDEDSURFACE,
  IFCCURVESEGMENT: () => IFCCURVESEGMENT,
  IFCCURVESTYLE: () => IFCCURVESTYLE,
  IFCCURVESTYLEFONT: () => IFCCURVESTYLEFONT,
  IFCCURVESTYLEFONTANDSCALING: () => IFCCURVESTYLEFONTANDSCALING,
  IFCCURVESTYLEFONTPATTERN: () => IFCCURVESTYLEFONTPATTERN,
  IFCCYLINDRICALSURFACE: () => IFCCYLINDRICALSURFACE,
  IFCDAMPER: () => IFCDAMPER,
  IFCDAMPERTYPE: () => IFCDAMPERTYPE,
  IFCDATE: () => IFCDATE,
  IFCDATEANDTIME: () => IFCDATEANDTIME,
  IFCDATETIME: () => IFCDATETIME,
  IFCDAYINMONTHNUMBER: () => IFCDAYINMONTHNUMBER,
  IFCDAYINWEEKNUMBER: () => IFCDAYINWEEKNUMBER,
  IFCDAYLIGHTSAVINGHOUR: () => IFCDAYLIGHTSAVINGHOUR,
  IFCDEEPFOUNDATION: () => IFCDEEPFOUNDATION,
  IFCDEEPFOUNDATIONTYPE: () => IFCDEEPFOUNDATIONTYPE,
  IFCDEFINEDSYMBOL: () => IFCDEFINEDSYMBOL,
  IFCDERIVEDPROFILEDEF: () => IFCDERIVEDPROFILEDEF,
  IFCDERIVEDUNIT: () => IFCDERIVEDUNIT,
  IFCDERIVEDUNITELEMENT: () => IFCDERIVEDUNITELEMENT,
  IFCDESCRIPTIVEMEASURE: () => IFCDESCRIPTIVEMEASURE,
  IFCDIAMETERDIMENSION: () => IFCDIAMETERDIMENSION,
  IFCDIMENSIONALEXPONENTS: () => IFCDIMENSIONALEXPONENTS,
  IFCDIMENSIONCALLOUTRELATIONSHIP: () => IFCDIMENSIONCALLOUTRELATIONSHIP,
  IFCDIMENSIONCOUNT: () => IFCDIMENSIONCOUNT,
  IFCDIMENSIONCURVE: () => IFCDIMENSIONCURVE,
  IFCDIMENSIONCURVEDIRECTEDCALLOUT: () => IFCDIMENSIONCURVEDIRECTEDCALLOUT,
  IFCDIMENSIONCURVETERMINATOR: () => IFCDIMENSIONCURVETERMINATOR,
  IFCDIMENSIONPAIR: () => IFCDIMENSIONPAIR,
  IFCDIRECTION: () => IFCDIRECTION,
  IFCDIRECTRIXCURVESWEPTAREASOLID: () => IFCDIRECTRIXCURVESWEPTAREASOLID,
  IFCDIRECTRIXDERIVEDREFERENCESWEPTAREASOLID: () => IFCDIRECTRIXDERIVEDREFERENCESWEPTAREASOLID,
  IFCDISCRETEACCESSORY: () => IFCDISCRETEACCESSORY,
  IFCDISCRETEACCESSORYTYPE: () => IFCDISCRETEACCESSORYTYPE,
  IFCDISTRIBUTIONBOARD: () => IFCDISTRIBUTIONBOARD,
  IFCDISTRIBUTIONBOARDTYPE: () => IFCDISTRIBUTIONBOARDTYPE,
  IFCDISTRIBUTIONCHAMBERELEMENT: () => IFCDISTRIBUTIONCHAMBERELEMENT,
  IFCDISTRIBUTIONCHAMBERELEMENTTYPE: () => IFCDISTRIBUTIONCHAMBERELEMENTTYPE,
  IFCDISTRIBUTIONCIRCUIT: () => IFCDISTRIBUTIONCIRCUIT,
  IFCDISTRIBUTIONCONTROLELEMENT: () => IFCDISTRIBUTIONCONTROLELEMENT,
  IFCDISTRIBUTIONCONTROLELEMENTTYPE: () => IFCDISTRIBUTIONCONTROLELEMENTTYPE,
  IFCDISTRIBUTIONELEMENT: () => IFCDISTRIBUTIONELEMENT,
  IFCDISTRIBUTIONELEMENTTYPE: () => IFCDISTRIBUTIONELEMENTTYPE,
  IFCDISTRIBUTIONFLOWELEMENT: () => IFCDISTRIBUTIONFLOWELEMENT,
  IFCDISTRIBUTIONFLOWELEMENTTYPE: () => IFCDISTRIBUTIONFLOWELEMENTTYPE,
  IFCDISTRIBUTIONPORT: () => IFCDISTRIBUTIONPORT,
  IFCDISTRIBUTIONSYSTEM: () => IFCDISTRIBUTIONSYSTEM,
  IFCDOCUMENTELECTRONICFORMAT: () => IFCDOCUMENTELECTRONICFORMAT,
  IFCDOCUMENTINFORMATION: () => IFCDOCUMENTINFORMATION,
  IFCDOCUMENTINFORMATIONRELATIONSHIP: () => IFCDOCUMENTINFORMATIONRELATIONSHIP,
  IFCDOCUMENTREFERENCE: () => IFCDOCUMENTREFERENCE,
  IFCDOOR: () => IFCDOOR,
  IFCDOORLININGPROPERTIES: () => IFCDOORLININGPROPERTIES,
  IFCDOORPANELPROPERTIES: () => IFCDOORPANELPROPERTIES,
  IFCDOORSTANDARDCASE: () => IFCDOORSTANDARDCASE,
  IFCDOORSTYLE: () => IFCDOORSTYLE,
  IFCDOORTYPE: () => IFCDOORTYPE,
  IFCDOSEEQUIVALENTMEASURE: () => IFCDOSEEQUIVALENTMEASURE,
  IFCDRAUGHTINGCALLOUT: () => IFCDRAUGHTINGCALLOUT,
  IFCDRAUGHTINGCALLOUTRELATIONSHIP: () => IFCDRAUGHTINGCALLOUTRELATIONSHIP,
  IFCDRAUGHTINGPREDEFINEDCOLOUR: () => IFCDRAUGHTINGPREDEFINEDCOLOUR,
  IFCDRAUGHTINGPREDEFINEDCURVEFONT: () => IFCDRAUGHTINGPREDEFINEDCURVEFONT,
  IFCDRAUGHTINGPREDEFINEDTEXTFONT: () => IFCDRAUGHTINGPREDEFINEDTEXTFONT,
  IFCDUCTFITTING: () => IFCDUCTFITTING,
  IFCDUCTFITTINGTYPE: () => IFCDUCTFITTINGTYPE,
  IFCDUCTSEGMENT: () => IFCDUCTSEGMENT,
  IFCDUCTSEGMENTTYPE: () => IFCDUCTSEGMENTTYPE,
  IFCDUCTSILENCER: () => IFCDUCTSILENCER,
  IFCDUCTSILENCERTYPE: () => IFCDUCTSILENCERTYPE,
  IFCDURATION: () => IFCDURATION,
  IFCDYNAMICVISCOSITYMEASURE: () => IFCDYNAMICVISCOSITYMEASURE,
  IFCEARTHWORKSCUT: () => IFCEARTHWORKSCUT,
  IFCEARTHWORKSELEMENT: () => IFCEARTHWORKSELEMENT,
  IFCEARTHWORKSFILL: () => IFCEARTHWORKSFILL,
  IFCEDGE: () => IFCEDGE,
  IFCEDGECURVE: () => IFCEDGECURVE,
  IFCEDGEFEATURE: () => IFCEDGEFEATURE,
  IFCEDGELOOP: () => IFCEDGELOOP,
  IFCELECTRICALBASEPROPERTIES: () => IFCELECTRICALBASEPROPERTIES,
  IFCELECTRICALCIRCUIT: () => IFCELECTRICALCIRCUIT,
  IFCELECTRICALELEMENT: () => IFCELECTRICALELEMENT,
  IFCELECTRICAPPLIANCE: () => IFCELECTRICAPPLIANCE,
  IFCELECTRICAPPLIANCETYPE: () => IFCELECTRICAPPLIANCETYPE,
  IFCELECTRICCAPACITANCEMEASURE: () => IFCELECTRICCAPACITANCEMEASURE,
  IFCELECTRICCHARGEMEASURE: () => IFCELECTRICCHARGEMEASURE,
  IFCELECTRICCONDUCTANCEMEASURE: () => IFCELECTRICCONDUCTANCEMEASURE,
  IFCELECTRICCURRENTMEASURE: () => IFCELECTRICCURRENTMEASURE,
  IFCELECTRICDISTRIBUTIONBOARD: () => IFCELECTRICDISTRIBUTIONBOARD,
  IFCELECTRICDISTRIBUTIONBOARDTYPE: () => IFCELECTRICDISTRIBUTIONBOARDTYPE,
  IFCELECTRICDISTRIBUTIONPOINT: () => IFCELECTRICDISTRIBUTIONPOINT,
  IFCELECTRICFLOWSTORAGEDEVICE: () => IFCELECTRICFLOWSTORAGEDEVICE,
  IFCELECTRICFLOWSTORAGEDEVICETYPE: () => IFCELECTRICFLOWSTORAGEDEVICETYPE,
  IFCELECTRICFLOWTREATMENTDEVICE: () => IFCELECTRICFLOWTREATMENTDEVICE,
  IFCELECTRICFLOWTREATMENTDEVICETYPE: () => IFCELECTRICFLOWTREATMENTDEVICETYPE,
  IFCELECTRICGENERATOR: () => IFCELECTRICGENERATOR,
  IFCELECTRICGENERATORTYPE: () => IFCELECTRICGENERATORTYPE,
  IFCELECTRICHEATERTYPE: () => IFCELECTRICHEATERTYPE,
  IFCELECTRICMOTOR: () => IFCELECTRICMOTOR,
  IFCELECTRICMOTORTYPE: () => IFCELECTRICMOTORTYPE,
  IFCELECTRICRESISTANCEMEASURE: () => IFCELECTRICRESISTANCEMEASURE,
  IFCELECTRICTIMECONTROL: () => IFCELECTRICTIMECONTROL,
  IFCELECTRICTIMECONTROLTYPE: () => IFCELECTRICTIMECONTROLTYPE,
  IFCELECTRICVOLTAGEMEASURE: () => IFCELECTRICVOLTAGEMEASURE,
  IFCELEMENT: () => IFCELEMENT,
  IFCELEMENTARYSURFACE: () => IFCELEMENTARYSURFACE,
  IFCELEMENTASSEMBLY: () => IFCELEMENTASSEMBLY,
  IFCELEMENTASSEMBLYTYPE: () => IFCELEMENTASSEMBLYTYPE,
  IFCELEMENTCOMPONENT: () => IFCELEMENTCOMPONENT,
  IFCELEMENTCOMPONENTTYPE: () => IFCELEMENTCOMPONENTTYPE,
  IFCELEMENTQUANTITY: () => IFCELEMENTQUANTITY,
  IFCELEMENTTYPE: () => IFCELEMENTTYPE,
  IFCELLIPSE: () => IFCELLIPSE,
  IFCELLIPSEPROFILEDEF: () => IFCELLIPSEPROFILEDEF,
  IFCENERGYCONVERSIONDEVICE: () => IFCENERGYCONVERSIONDEVICE,
  IFCENERGYCONVERSIONDEVICETYPE: () => IFCENERGYCONVERSIONDEVICETYPE,
  IFCENERGYMEASURE: () => IFCENERGYMEASURE,
  IFCENERGYPROPERTIES: () => IFCENERGYPROPERTIES,
  IFCENGINE: () => IFCENGINE,
  IFCENGINETYPE: () => IFCENGINETYPE,
  IFCENVIRONMENTALIMPACTVALUE: () => IFCENVIRONMENTALIMPACTVALUE,
  IFCEQUIPMENTELEMENT: () => IFCEQUIPMENTELEMENT,
  IFCEQUIPMENTSTANDARD: () => IFCEQUIPMENTSTANDARD,
  IFCEVAPORATIVECOOLER: () => IFCEVAPORATIVECOOLER,
  IFCEVAPORATIVECOOLERTYPE: () => IFCEVAPORATIVECOOLERTYPE,
  IFCEVAPORATOR: () => IFCEVAPORATOR,
  IFCEVAPORATORTYPE: () => IFCEVAPORATORTYPE,
  IFCEVENT: () => IFCEVENT,
  IFCEVENTTIME: () => IFCEVENTTIME,
  IFCEVENTTYPE: () => IFCEVENTTYPE,
  IFCEXTENDEDMATERIALPROPERTIES: () => IFCEXTENDEDMATERIALPROPERTIES,
  IFCEXTENDEDPROPERTIES: () => IFCEXTENDEDPROPERTIES,
  IFCEXTERNALINFORMATION: () => IFCEXTERNALINFORMATION,
  IFCEXTERNALLYDEFINEDHATCHSTYLE: () => IFCEXTERNALLYDEFINEDHATCHSTYLE,
  IFCEXTERNALLYDEFINEDSURFACESTYLE: () => IFCEXTERNALLYDEFINEDSURFACESTYLE,
  IFCEXTERNALLYDEFINEDSYMBOL: () => IFCEXTERNALLYDEFINEDSYMBOL,
  IFCEXTERNALLYDEFINEDTEXTFONT: () => IFCEXTERNALLYDEFINEDTEXTFONT,
  IFCEXTERNALREFERENCE: () => IFCEXTERNALREFERENCE,
  IFCEXTERNALREFERENCERELATIONSHIP: () => IFCEXTERNALREFERENCERELATIONSHIP,
  IFCEXTERNALSPATIALELEMENT: () => IFCEXTERNALSPATIALELEMENT,
  IFCEXTERNALSPATIALSTRUCTUREELEMENT: () => IFCEXTERNALSPATIALSTRUCTUREELEMENT,
  IFCEXTRUDEDAREASOLID: () => IFCEXTRUDEDAREASOLID,
  IFCEXTRUDEDAREASOLIDTAPERED: () => IFCEXTRUDEDAREASOLIDTAPERED,
  IFCFACE: () => IFCFACE,
  IFCFACEBASEDSURFACEMODEL: () => IFCFACEBASEDSURFACEMODEL,
  IFCFACEBOUND: () => IFCFACEBOUND,
  IFCFACEOUTERBOUND: () => IFCFACEOUTERBOUND,
  IFCFACESURFACE: () => IFCFACESURFACE,
  IFCFACETEDBREP: () => IFCFACETEDBREP,
  IFCFACETEDBREPWITHVOIDS: () => IFCFACETEDBREPWITHVOIDS,
  IFCFACILITY: () => IFCFACILITY,
  IFCFACILITYPART: () => IFCFACILITYPART,
  IFCFACILITYPARTCOMMON: () => IFCFACILITYPARTCOMMON,
  IFCFAILURECONNECTIONCONDITION: () => IFCFAILURECONNECTIONCONDITION,
  IFCFAN: () => IFCFAN,
  IFCFANTYPE: () => IFCFANTYPE,
  IFCFASTENER: () => IFCFASTENER,
  IFCFASTENERTYPE: () => IFCFASTENERTYPE,
  IFCFEATUREELEMENT: () => IFCFEATUREELEMENT,
  IFCFEATUREELEMENTADDITION: () => IFCFEATUREELEMENTADDITION,
  IFCFEATUREELEMENTSUBTRACTION: () => IFCFEATUREELEMENTSUBTRACTION,
  IFCFILLAREASTYLE: () => IFCFILLAREASTYLE,
  IFCFILLAREASTYLEHATCHING: () => IFCFILLAREASTYLEHATCHING,
  IFCFILLAREASTYLETILES: () => IFCFILLAREASTYLETILES,
  IFCFILLAREASTYLETILESYMBOLWITHSTYLE: () => IFCFILLAREASTYLETILESYMBOLWITHSTYLE,
  IFCFILTER: () => IFCFILTER,
  IFCFILTERTYPE: () => IFCFILTERTYPE,
  IFCFIRESUPPRESSIONTERMINAL: () => IFCFIRESUPPRESSIONTERMINAL,
  IFCFIRESUPPRESSIONTERMINALTYPE: () => IFCFIRESUPPRESSIONTERMINALTYPE,
  IFCFIXEDREFERENCESWEPTAREASOLID: () => IFCFIXEDREFERENCESWEPTAREASOLID,
  IFCFLOWCONTROLLER: () => IFCFLOWCONTROLLER,
  IFCFLOWCONTROLLERTYPE: () => IFCFLOWCONTROLLERTYPE,
  IFCFLOWFITTING: () => IFCFLOWFITTING,
  IFCFLOWFITTINGTYPE: () => IFCFLOWFITTINGTYPE,
  IFCFLOWINSTRUMENT: () => IFCFLOWINSTRUMENT,
  IFCFLOWINSTRUMENTTYPE: () => IFCFLOWINSTRUMENTTYPE,
  IFCFLOWMETER: () => IFCFLOWMETER,
  IFCFLOWMETERTYPE: () => IFCFLOWMETERTYPE,
  IFCFLOWMOVINGDEVICE: () => IFCFLOWMOVINGDEVICE,
  IFCFLOWMOVINGDEVICETYPE: () => IFCFLOWMOVINGDEVICETYPE,
  IFCFLOWSEGMENT: () => IFCFLOWSEGMENT,
  IFCFLOWSEGMENTTYPE: () => IFCFLOWSEGMENTTYPE,
  IFCFLOWSTORAGEDEVICE: () => IFCFLOWSTORAGEDEVICE,
  IFCFLOWSTORAGEDEVICETYPE: () => IFCFLOWSTORAGEDEVICETYPE,
  IFCFLOWTERMINAL: () => IFCFLOWTERMINAL,
  IFCFLOWTERMINALTYPE: () => IFCFLOWTERMINALTYPE,
  IFCFLOWTREATMENTDEVICE: () => IFCFLOWTREATMENTDEVICE,
  IFCFLOWTREATMENTDEVICETYPE: () => IFCFLOWTREATMENTDEVICETYPE,
  IFCFLUIDFLOWPROPERTIES: () => IFCFLUIDFLOWPROPERTIES,
  IFCFONTSTYLE: () => IFCFONTSTYLE,
  IFCFONTVARIANT: () => IFCFONTVARIANT,
  IFCFONTWEIGHT: () => IFCFONTWEIGHT,
  IFCFOOTING: () => IFCFOOTING,
  IFCFOOTINGTYPE: () => IFCFOOTINGTYPE,
  IFCFORCEMEASURE: () => IFCFORCEMEASURE,
  IFCFREQUENCYMEASURE: () => IFCFREQUENCYMEASURE,
  IFCFUELPROPERTIES: () => IFCFUELPROPERTIES,
  IFCFURNISHINGELEMENT: () => IFCFURNISHINGELEMENT,
  IFCFURNISHINGELEMENTTYPE: () => IFCFURNISHINGELEMENTTYPE,
  IFCFURNITURE: () => IFCFURNITURE,
  IFCFURNITURESTANDARD: () => IFCFURNITURESTANDARD,
  IFCFURNITURETYPE: () => IFCFURNITURETYPE,
  IFCGASTERMINALTYPE: () => IFCGASTERMINALTYPE,
  IFCGENERALMATERIALPROPERTIES: () => IFCGENERALMATERIALPROPERTIES,
  IFCGENERALPROFILEPROPERTIES: () => IFCGENERALPROFILEPROPERTIES,
  IFCGEOGRAPHICELEMENT: () => IFCGEOGRAPHICELEMENT,
  IFCGEOGRAPHICELEMENTTYPE: () => IFCGEOGRAPHICELEMENTTYPE,
  IFCGEOMETRICCURVESET: () => IFCGEOMETRICCURVESET,
  IFCGEOMETRICREPRESENTATIONCONTEXT: () => IFCGEOMETRICREPRESENTATIONCONTEXT,
  IFCGEOMETRICREPRESENTATIONITEM: () => IFCGEOMETRICREPRESENTATIONITEM,
  IFCGEOMETRICREPRESENTATIONSUBCONTEXT: () => IFCGEOMETRICREPRESENTATIONSUBCONTEXT,
  IFCGEOMETRICSET: () => IFCGEOMETRICSET,
  IFCGEOMODEL: () => IFCGEOMODEL,
  IFCGEOSLICE: () => IFCGEOSLICE,
  IFCGEOTECHNICALASSEMBLY: () => IFCGEOTECHNICALASSEMBLY,
  IFCGEOTECHNICALELEMENT: () => IFCGEOTECHNICALELEMENT,
  IFCGEOTECHNICALSTRATUM: () => IFCGEOTECHNICALSTRATUM,
  IFCGLOBALLYUNIQUEID: () => IFCGLOBALLYUNIQUEID,
  IFCGRADIENTCURVE: () => IFCGRADIENTCURVE,
  IFCGRID: () => IFCGRID,
  IFCGRIDAXIS: () => IFCGRIDAXIS,
  IFCGRIDPLACEMENT: () => IFCGRIDPLACEMENT,
  IFCGROUP: () => IFCGROUP,
  IFCHALFSPACESOLID: () => IFCHALFSPACESOLID,
  IFCHEATEXCHANGER: () => IFCHEATEXCHANGER,
  IFCHEATEXCHANGERTYPE: () => IFCHEATEXCHANGERTYPE,
  IFCHEATFLUXDENSITYMEASURE: () => IFCHEATFLUXDENSITYMEASURE,
  IFCHEATINGVALUEMEASURE: () => IFCHEATINGVALUEMEASURE,
  IFCHOURINDAY: () => IFCHOURINDAY,
  IFCHUMIDIFIER: () => IFCHUMIDIFIER,
  IFCHUMIDIFIERTYPE: () => IFCHUMIDIFIERTYPE,
  IFCHYGROSCOPICMATERIALPROPERTIES: () => IFCHYGROSCOPICMATERIALPROPERTIES,
  IFCIDENTIFIER: () => IFCIDENTIFIER,
  IFCILLUMINANCEMEASURE: () => IFCILLUMINANCEMEASURE,
  IFCIMAGETEXTURE: () => IFCIMAGETEXTURE,
  IFCIMPACTPROTECTIONDEVICE: () => IFCIMPACTPROTECTIONDEVICE,
  IFCIMPACTPROTECTIONDEVICETYPE: () => IFCIMPACTPROTECTIONDEVICETYPE,
  IFCINDEXEDCOLOURMAP: () => IFCINDEXEDCOLOURMAP,
  IFCINDEXEDPOLYCURVE: () => IFCINDEXEDPOLYCURVE,
  IFCINDEXEDPOLYGONALFACE: () => IFCINDEXEDPOLYGONALFACE,
  IFCINDEXEDPOLYGONALFACEWITHVOIDS: () => IFCINDEXEDPOLYGONALFACEWITHVOIDS,
  IFCINDEXEDPOLYGONALTEXTUREMAP: () => IFCINDEXEDPOLYGONALTEXTUREMAP,
  IFCINDEXEDTEXTUREMAP: () => IFCINDEXEDTEXTUREMAP,
  IFCINDEXEDTRIANGLETEXTUREMAP: () => IFCINDEXEDTRIANGLETEXTUREMAP,
  IFCINDUCTANCEMEASURE: () => IFCINDUCTANCEMEASURE,
  IFCINTEGER: () => IFCINTEGER,
  IFCINTEGERCOUNTRATEMEASURE: () => IFCINTEGERCOUNTRATEMEASURE,
  IFCINTERCEPTOR: () => IFCINTERCEPTOR,
  IFCINTERCEPTORTYPE: () => IFCINTERCEPTORTYPE,
  IFCINTERSECTIONCURVE: () => IFCINTERSECTIONCURVE,
  IFCINVENTORY: () => IFCINVENTORY,
  IFCIONCONCENTRATIONMEASURE: () => IFCIONCONCENTRATIONMEASURE,
  IFCIRREGULARTIMESERIES: () => IFCIRREGULARTIMESERIES,
  IFCIRREGULARTIMESERIESVALUE: () => IFCIRREGULARTIMESERIESVALUE,
  IFCISHAPEPROFILEDEF: () => IFCISHAPEPROFILEDEF,
  IFCISOTHERMALMOISTURECAPACITYMEASURE: () => IFCISOTHERMALMOISTURECAPACITYMEASURE,
  IFCJUNCTIONBOX: () => IFCJUNCTIONBOX,
  IFCJUNCTIONBOXTYPE: () => IFCJUNCTIONBOXTYPE,
  IFCKERB: () => IFCKERB,
  IFCKERBTYPE: () => IFCKERBTYPE,
  IFCKINEMATICVISCOSITYMEASURE: () => IFCKINEMATICVISCOSITYMEASURE,
  IFCLABEL: () => IFCLABEL,
  IFCLABORRESOURCE: () => IFCLABORRESOURCE,
  IFCLABORRESOURCETYPE: () => IFCLABORRESOURCETYPE,
  IFCLAGTIME: () => IFCLAGTIME,
  IFCLAMP: () => IFCLAMP,
  IFCLAMPTYPE: () => IFCLAMPTYPE,
  IFCLANGUAGEID: () => IFCLANGUAGEID,
  IFCLENGTHMEASURE: () => IFCLENGTHMEASURE,
  IFCLIBRARYINFORMATION: () => IFCLIBRARYINFORMATION,
  IFCLIBRARYREFERENCE: () => IFCLIBRARYREFERENCE,
  IFCLIGHTDISTRIBUTIONDATA: () => IFCLIGHTDISTRIBUTIONDATA,
  IFCLIGHTFIXTURE: () => IFCLIGHTFIXTURE,
  IFCLIGHTFIXTURETYPE: () => IFCLIGHTFIXTURETYPE,
  IFCLIGHTINTENSITYDISTRIBUTION: () => IFCLIGHTINTENSITYDISTRIBUTION,
  IFCLIGHTSOURCE: () => IFCLIGHTSOURCE,
  IFCLIGHTSOURCEAMBIENT: () => IFCLIGHTSOURCEAMBIENT,
  IFCLIGHTSOURCEDIRECTIONAL: () => IFCLIGHTSOURCEDIRECTIONAL,
  IFCLIGHTSOURCEGONIOMETRIC: () => IFCLIGHTSOURCEGONIOMETRIC,
  IFCLIGHTSOURCEPOSITIONAL: () => IFCLIGHTSOURCEPOSITIONAL,
  IFCLIGHTSOURCESPOT: () => IFCLIGHTSOURCESPOT,
  IFCLINE: () => IFCLINE,
  IFCLINEARDIMENSION: () => IFCLINEARDIMENSION,
  IFCLINEARELEMENT: () => IFCLINEARELEMENT,
  IFCLINEARFORCEMEASURE: () => IFCLINEARFORCEMEASURE,
  IFCLINEARMOMENTMEASURE: () => IFCLINEARMOMENTMEASURE,
  IFCLINEARPLACEMENT: () => IFCLINEARPLACEMENT,
  IFCLINEARPOSITIONINGELEMENT: () => IFCLINEARPOSITIONINGELEMENT,
  IFCLINEARSTIFFNESSMEASURE: () => IFCLINEARSTIFFNESSMEASURE,
  IFCLINEARVELOCITYMEASURE: () => IFCLINEARVELOCITYMEASURE,
  IFCLINEINDEX: () => IFCLINEINDEX,
  IFCLIQUIDTERMINAL: () => IFCLIQUIDTERMINAL,
  IFCLIQUIDTERMINALTYPE: () => IFCLIQUIDTERMINALTYPE,
  IFCLOCALPLACEMENT: () => IFCLOCALPLACEMENT,
  IFCLOCALTIME: () => IFCLOCALTIME,
  IFCLOGICAL: () => IFCLOGICAL,
  IFCLOOP: () => IFCLOOP,
  IFCLSHAPEPROFILEDEF: () => IFCLSHAPEPROFILEDEF,
  IFCLUMINOUSFLUXMEASURE: () => IFCLUMINOUSFLUXMEASURE,
  IFCLUMINOUSINTENSITYDISTRIBUTIONMEASURE: () => IFCLUMINOUSINTENSITYDISTRIBUTIONMEASURE,
  IFCLUMINOUSINTENSITYMEASURE: () => IFCLUMINOUSINTENSITYMEASURE,
  IFCMAGNETICFLUXDENSITYMEASURE: () => IFCMAGNETICFLUXDENSITYMEASURE,
  IFCMAGNETICFLUXMEASURE: () => IFCMAGNETICFLUXMEASURE,
  IFCMANIFOLDSOLIDBREP: () => IFCMANIFOLDSOLIDBREP,
  IFCMAPCONVERSION: () => IFCMAPCONVERSION,
  IFCMAPPEDITEM: () => IFCMAPPEDITEM,
  IFCMARINEFACILITY: () => IFCMARINEFACILITY,
  IFCMARINEPART: () => IFCMARINEPART,
  IFCMASSDENSITYMEASURE: () => IFCMASSDENSITYMEASURE,
  IFCMASSFLOWRATEMEASURE: () => IFCMASSFLOWRATEMEASURE,
  IFCMASSMEASURE: () => IFCMASSMEASURE,
  IFCMASSPERLENGTHMEASURE: () => IFCMASSPERLENGTHMEASURE,
  IFCMATERIAL: () => IFCMATERIAL,
  IFCMATERIALCLASSIFICATIONRELATIONSHIP: () => IFCMATERIALCLASSIFICATIONRELATIONSHIP,
  IFCMATERIALCONSTITUENT: () => IFCMATERIALCONSTITUENT,
  IFCMATERIALCONSTITUENTSET: () => IFCMATERIALCONSTITUENTSET,
  IFCMATERIALDEFINITION: () => IFCMATERIALDEFINITION,
  IFCMATERIALDEFINITIONREPRESENTATION: () => IFCMATERIALDEFINITIONREPRESENTATION,
  IFCMATERIALLAYER: () => IFCMATERIALLAYER,
  IFCMATERIALLAYERSET: () => IFCMATERIALLAYERSET,
  IFCMATERIALLAYERSETUSAGE: () => IFCMATERIALLAYERSETUSAGE,
  IFCMATERIALLAYERWITHOFFSETS: () => IFCMATERIALLAYERWITHOFFSETS,
  IFCMATERIALLIST: () => IFCMATERIALLIST,
  IFCMATERIALPROFILE: () => IFCMATERIALPROFILE,
  IFCMATERIALPROFILESET: () => IFCMATERIALPROFILESET,
  IFCMATERIALPROFILESETUSAGE: () => IFCMATERIALPROFILESETUSAGE,
  IFCMATERIALPROFILESETUSAGETAPERING: () => IFCMATERIALPROFILESETUSAGETAPERING,
  IFCMATERIALPROFILEWITHOFFSETS: () => IFCMATERIALPROFILEWITHOFFSETS,
  IFCMATERIALPROPERTIES: () => IFCMATERIALPROPERTIES,
  IFCMATERIALRELATIONSHIP: () => IFCMATERIALRELATIONSHIP,
  IFCMATERIALUSAGEDEFINITION: () => IFCMATERIALUSAGEDEFINITION,
  IFCMEASUREWITHUNIT: () => IFCMEASUREWITHUNIT,
  IFCMECHANICALCONCRETEMATERIALPROPERTIES: () => IFCMECHANICALCONCRETEMATERIALPROPERTIES,
  IFCMECHANICALFASTENER: () => IFCMECHANICALFASTENER,
  IFCMECHANICALFASTENERTYPE: () => IFCMECHANICALFASTENERTYPE,
  IFCMECHANICALMATERIALPROPERTIES: () => IFCMECHANICALMATERIALPROPERTIES,
  IFCMECHANICALSTEELMATERIALPROPERTIES: () => IFCMECHANICALSTEELMATERIALPROPERTIES,
  IFCMEDICALDEVICE: () => IFCMEDICALDEVICE,
  IFCMEDICALDEVICETYPE: () => IFCMEDICALDEVICETYPE,
  IFCMEMBER: () => IFCMEMBER,
  IFCMEMBERSTANDARDCASE: () => IFCMEMBERSTANDARDCASE,
  IFCMEMBERTYPE: () => IFCMEMBERTYPE,
  IFCMETRIC: () => IFCMETRIC,
  IFCMINUTEINHOUR: () => IFCMINUTEINHOUR,
  IFCMIRROREDPROFILEDEF: () => IFCMIRROREDPROFILEDEF,
  IFCMOBILETELECOMMUNICATIONSAPPLIANCE: () => IFCMOBILETELECOMMUNICATIONSAPPLIANCE,
  IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE: () => IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE,
  IFCMODULUSOFELASTICITYMEASURE: () => IFCMODULUSOFELASTICITYMEASURE,
  IFCMODULUSOFLINEARSUBGRADEREACTIONMEASURE: () => IFCMODULUSOFLINEARSUBGRADEREACTIONMEASURE,
  IFCMODULUSOFROTATIONALSUBGRADEREACTIONMEASURE: () => IFCMODULUSOFROTATIONALSUBGRADEREACTIONMEASURE,
  IFCMODULUSOFSUBGRADEREACTIONMEASURE: () => IFCMODULUSOFSUBGRADEREACTIONMEASURE,
  IFCMOISTUREDIFFUSIVITYMEASURE: () => IFCMOISTUREDIFFUSIVITYMEASURE,
  IFCMOLECULARWEIGHTMEASURE: () => IFCMOLECULARWEIGHTMEASURE,
  IFCMOMENTOFINERTIAMEASURE: () => IFCMOMENTOFINERTIAMEASURE,
  IFCMONETARYMEASURE: () => IFCMONETARYMEASURE,
  IFCMONETARYUNIT: () => IFCMONETARYUNIT,
  IFCMONTHINYEARNUMBER: () => IFCMONTHINYEARNUMBER,
  IFCMOORINGDEVICE: () => IFCMOORINGDEVICE,
  IFCMOORINGDEVICETYPE: () => IFCMOORINGDEVICETYPE,
  IFCMOTORCONNECTION: () => IFCMOTORCONNECTION,
  IFCMOTORCONNECTIONTYPE: () => IFCMOTORCONNECTIONTYPE,
  IFCMOVE: () => IFCMOVE,
  IFCNAMEDUNIT: () => IFCNAMEDUNIT,
  IFCNAVIGATIONELEMENT: () => IFCNAVIGATIONELEMENT,
  IFCNAVIGATIONELEMENTTYPE: () => IFCNAVIGATIONELEMENTTYPE,
  IFCNONNEGATIVELENGTHMEASURE: () => IFCNONNEGATIVELENGTHMEASURE,
  IFCNORMALISEDRATIOMEASURE: () => IFCNORMALISEDRATIOMEASURE,
  IFCNUMERICMEASURE: () => IFCNUMERICMEASURE,
  IFCOBJECT: () => IFCOBJECT,
  IFCOBJECTDEFINITION: () => IFCOBJECTDEFINITION,
  IFCOBJECTIVE: () => IFCOBJECTIVE,
  IFCOBJECTPLACEMENT: () => IFCOBJECTPLACEMENT,
  IFCOCCUPANT: () => IFCOCCUPANT,
  IFCOFFSETCURVE: () => IFCOFFSETCURVE,
  IFCOFFSETCURVE2D: () => IFCOFFSETCURVE2D,
  IFCOFFSETCURVE3D: () => IFCOFFSETCURVE3D,
  IFCOFFSETCURVEBYDISTANCES: () => IFCOFFSETCURVEBYDISTANCES,
  IFCONEDIRECTIONREPEATFACTOR: () => IFCONEDIRECTIONREPEATFACTOR,
  IFCOPENCROSSPROFILEDEF: () => IFCOPENCROSSPROFILEDEF,
  IFCOPENINGELEMENT: () => IFCOPENINGELEMENT,
  IFCOPENINGSTANDARDCASE: () => IFCOPENINGSTANDARDCASE,
  IFCOPENSHELL: () => IFCOPENSHELL,
  IFCOPTICALMATERIALPROPERTIES: () => IFCOPTICALMATERIALPROPERTIES,
  IFCORDERACTION: () => IFCORDERACTION,
  IFCORGANIZATION: () => IFCORGANIZATION,
  IFCORGANIZATIONRELATIONSHIP: () => IFCORGANIZATIONRELATIONSHIP,
  IFCORIENTEDEDGE: () => IFCORIENTEDEDGE,
  IFCOUTERBOUNDARYCURVE: () => IFCOUTERBOUNDARYCURVE,
  IFCOUTLET: () => IFCOUTLET,
  IFCOUTLETTYPE: () => IFCOUTLETTYPE,
  IFCOWNERHISTORY: () => IFCOWNERHISTORY,
  IFCPARAMETERIZEDPROFILEDEF: () => IFCPARAMETERIZEDPROFILEDEF,
  IFCPARAMETERVALUE: () => IFCPARAMETERVALUE,
  IFCPATH: () => IFCPATH,
  IFCPAVEMENT: () => IFCPAVEMENT,
  IFCPAVEMENTTYPE: () => IFCPAVEMENTTYPE,
  IFCPCURVE: () => IFCPCURVE,
  IFCPERFORMANCEHISTORY: () => IFCPERFORMANCEHISTORY,
  IFCPERMEABLECOVERINGPROPERTIES: () => IFCPERMEABLECOVERINGPROPERTIES,
  IFCPERMIT: () => IFCPERMIT,
  IFCPERSON: () => IFCPERSON,
  IFCPERSONANDORGANIZATION: () => IFCPERSONANDORGANIZATION,
  IFCPHMEASURE: () => IFCPHMEASURE,
  IFCPHYSICALCOMPLEXQUANTITY: () => IFCPHYSICALCOMPLEXQUANTITY,
  IFCPHYSICALQUANTITY: () => IFCPHYSICALQUANTITY,
  IFCPHYSICALSIMPLEQUANTITY: () => IFCPHYSICALSIMPLEQUANTITY,
  IFCPILE: () => IFCPILE,
  IFCPILETYPE: () => IFCPILETYPE,
  IFCPIPEFITTING: () => IFCPIPEFITTING,
  IFCPIPEFITTINGTYPE: () => IFCPIPEFITTINGTYPE,
  IFCPIPESEGMENT: () => IFCPIPESEGMENT,
  IFCPIPESEGMENTTYPE: () => IFCPIPESEGMENTTYPE,
  IFCPIXELTEXTURE: () => IFCPIXELTEXTURE,
  IFCPLACEMENT: () => IFCPLACEMENT,
  IFCPLANARBOX: () => IFCPLANARBOX,
  IFCPLANAREXTENT: () => IFCPLANAREXTENT,
  IFCPLANARFORCEMEASURE: () => IFCPLANARFORCEMEASURE,
  IFCPLANE: () => IFCPLANE,
  IFCPLANEANGLEMEASURE: () => IFCPLANEANGLEMEASURE,
  IFCPLATE: () => IFCPLATE,
  IFCPLATESTANDARDCASE: () => IFCPLATESTANDARDCASE,
  IFCPLATETYPE: () => IFCPLATETYPE,
  IFCPOINT: () => IFCPOINT,
  IFCPOINTBYDISTANCEEXPRESSION: () => IFCPOINTBYDISTANCEEXPRESSION,
  IFCPOINTONCURVE: () => IFCPOINTONCURVE,
  IFCPOINTONSURFACE: () => IFCPOINTONSURFACE,
  IFCPOLYGONALBOUNDEDHALFSPACE: () => IFCPOLYGONALBOUNDEDHALFSPACE,
  IFCPOLYGONALFACESET: () => IFCPOLYGONALFACESET,
  IFCPOLYLINE: () => IFCPOLYLINE,
  IFCPOLYLOOP: () => IFCPOLYLOOP,
  IFCPOLYNOMIALCURVE: () => IFCPOLYNOMIALCURVE,
  IFCPORT: () => IFCPORT,
  IFCPOSITIONINGELEMENT: () => IFCPOSITIONINGELEMENT,
  IFCPOSITIVEINTEGER: () => IFCPOSITIVEINTEGER,
  IFCPOSITIVELENGTHMEASURE: () => IFCPOSITIVELENGTHMEASURE,
  IFCPOSITIVEPLANEANGLEMEASURE: () => IFCPOSITIVEPLANEANGLEMEASURE,
  IFCPOSITIVERATIOMEASURE: () => IFCPOSITIVERATIOMEASURE,
  IFCPOSTALADDRESS: () => IFCPOSTALADDRESS,
  IFCPOWERMEASURE: () => IFCPOWERMEASURE,
  IFCPREDEFINEDCOLOUR: () => IFCPREDEFINEDCOLOUR,
  IFCPREDEFINEDCURVEFONT: () => IFCPREDEFINEDCURVEFONT,
  IFCPREDEFINEDDIMENSIONSYMBOL: () => IFCPREDEFINEDDIMENSIONSYMBOL,
  IFCPREDEFINEDITEM: () => IFCPREDEFINEDITEM,
  IFCPREDEFINEDPOINTMARKERSYMBOL: () => IFCPREDEFINEDPOINTMARKERSYMBOL,
  IFCPREDEFINEDPROPERTIES: () => IFCPREDEFINEDPROPERTIES,
  IFCPREDEFINEDPROPERTYSET: () => IFCPREDEFINEDPROPERTYSET,
  IFCPREDEFINEDSYMBOL: () => IFCPREDEFINEDSYMBOL,
  IFCPREDEFINEDTERMINATORSYMBOL: () => IFCPREDEFINEDTERMINATORSYMBOL,
  IFCPREDEFINEDTEXTFONT: () => IFCPREDEFINEDTEXTFONT,
  IFCPRESENTABLETEXT: () => IFCPRESENTABLETEXT,
  IFCPRESENTATIONITEM: () => IFCPRESENTATIONITEM,
  IFCPRESENTATIONLAYERASSIGNMENT: () => IFCPRESENTATIONLAYERASSIGNMENT,
  IFCPRESENTATIONLAYERWITHSTYLE: () => IFCPRESENTATIONLAYERWITHSTYLE,
  IFCPRESENTATIONSTYLE: () => IFCPRESENTATIONSTYLE,
  IFCPRESENTATIONSTYLEASSIGNMENT: () => IFCPRESENTATIONSTYLEASSIGNMENT,
  IFCPRESSUREMEASURE: () => IFCPRESSUREMEASURE,
  IFCPROCEDURE: () => IFCPROCEDURE,
  IFCPROCEDURETYPE: () => IFCPROCEDURETYPE,
  IFCPROCESS: () => IFCPROCESS,
  IFCPRODUCT: () => IFCPRODUCT,
  IFCPRODUCTDEFINITIONSHAPE: () => IFCPRODUCTDEFINITIONSHAPE,
  IFCPRODUCTREPRESENTATION: () => IFCPRODUCTREPRESENTATION,
  IFCPRODUCTSOFCOMBUSTIONPROPERTIES: () => IFCPRODUCTSOFCOMBUSTIONPROPERTIES,
  IFCPROFILEDEF: () => IFCPROFILEDEF,
  IFCPROFILEPROPERTIES: () => IFCPROFILEPROPERTIES,
  IFCPROJECT: () => IFCPROJECT,
  IFCPROJECTEDCRS: () => IFCPROJECTEDCRS,
  IFCPROJECTIONCURVE: () => IFCPROJECTIONCURVE,
  IFCPROJECTIONELEMENT: () => IFCPROJECTIONELEMENT,
  IFCPROJECTLIBRARY: () => IFCPROJECTLIBRARY,
  IFCPROJECTORDER: () => IFCPROJECTORDER,
  IFCPROJECTORDERRECORD: () => IFCPROJECTORDERRECORD,
  IFCPROPERTY: () => IFCPROPERTY,
  IFCPROPERTYABSTRACTION: () => IFCPROPERTYABSTRACTION,
  IFCPROPERTYBOUNDEDVALUE: () => IFCPROPERTYBOUNDEDVALUE,
  IFCPROPERTYCONSTRAINTRELATIONSHIP: () => IFCPROPERTYCONSTRAINTRELATIONSHIP,
  IFCPROPERTYDEFINITION: () => IFCPROPERTYDEFINITION,
  IFCPROPERTYDEPENDENCYRELATIONSHIP: () => IFCPROPERTYDEPENDENCYRELATIONSHIP,
  IFCPROPERTYENUMERATEDVALUE: () => IFCPROPERTYENUMERATEDVALUE,
  IFCPROPERTYENUMERATION: () => IFCPROPERTYENUMERATION,
  IFCPROPERTYLISTVALUE: () => IFCPROPERTYLISTVALUE,
  IFCPROPERTYREFERENCEVALUE: () => IFCPROPERTYREFERENCEVALUE,
  IFCPROPERTYSET: () => IFCPROPERTYSET,
  IFCPROPERTYSETDEFINITION: () => IFCPROPERTYSETDEFINITION,
  IFCPROPERTYSETDEFINITIONSET: () => IFCPROPERTYSETDEFINITIONSET,
  IFCPROPERTYSETTEMPLATE: () => IFCPROPERTYSETTEMPLATE,
  IFCPROPERTYSINGLEVALUE: () => IFCPROPERTYSINGLEVALUE,
  IFCPROPERTYTABLEVALUE: () => IFCPROPERTYTABLEVALUE,
  IFCPROPERTYTEMPLATE: () => IFCPROPERTYTEMPLATE,
  IFCPROPERTYTEMPLATEDEFINITION: () => IFCPROPERTYTEMPLATEDEFINITION,
  IFCPROTECTIVEDEVICE: () => IFCPROTECTIVEDEVICE,
  IFCPROTECTIVEDEVICETRIPPINGUNIT: () => IFCPROTECTIVEDEVICETRIPPINGUNIT,
  IFCPROTECTIVEDEVICETRIPPINGUNITTYPE: () => IFCPROTECTIVEDEVICETRIPPINGUNITTYPE,
  IFCPROTECTIVEDEVICETYPE: () => IFCPROTECTIVEDEVICETYPE,
  IFCPROXY: () => IFCPROXY,
  IFCPUMP: () => IFCPUMP,
  IFCPUMPTYPE: () => IFCPUMPTYPE,
  IFCQUANTITYAREA: () => IFCQUANTITYAREA,
  IFCQUANTITYCOUNT: () => IFCQUANTITYCOUNT,
  IFCQUANTITYLENGTH: () => IFCQUANTITYLENGTH,
  IFCQUANTITYNUMBER: () => IFCQUANTITYNUMBER,
  IFCQUANTITYSET: () => IFCQUANTITYSET,
  IFCQUANTITYTIME: () => IFCQUANTITYTIME,
  IFCQUANTITYVOLUME: () => IFCQUANTITYVOLUME,
  IFCQUANTITYWEIGHT: () => IFCQUANTITYWEIGHT,
  IFCRADIOACTIVITYMEASURE: () => IFCRADIOACTIVITYMEASURE,
  IFCRADIUSDIMENSION: () => IFCRADIUSDIMENSION,
  IFCRAIL: () => IFCRAIL,
  IFCRAILING: () => IFCRAILING,
  IFCRAILINGTYPE: () => IFCRAILINGTYPE,
  IFCRAILTYPE: () => IFCRAILTYPE,
  IFCRAILWAY: () => IFCRAILWAY,
  IFCRAILWAYPART: () => IFCRAILWAYPART,
  IFCRAMP: () => IFCRAMP,
  IFCRAMPFLIGHT: () => IFCRAMPFLIGHT,
  IFCRAMPFLIGHTTYPE: () => IFCRAMPFLIGHTTYPE,
  IFCRAMPTYPE: () => IFCRAMPTYPE,
  IFCRATIOMEASURE: () => IFCRATIOMEASURE,
  IFCRATIONALBEZIERCURVE: () => IFCRATIONALBEZIERCURVE,
  IFCRATIONALBSPLINECURVEWITHKNOTS: () => IFCRATIONALBSPLINECURVEWITHKNOTS,
  IFCRATIONALBSPLINESURFACEWITHKNOTS: () => IFCRATIONALBSPLINESURFACEWITHKNOTS,
  IFCREAL: () => IFCREAL,
  IFCRECTANGLEHOLLOWPROFILEDEF: () => IFCRECTANGLEHOLLOWPROFILEDEF,
  IFCRECTANGLEPROFILEDEF: () => IFCRECTANGLEPROFILEDEF,
  IFCRECTANGULARPYRAMID: () => IFCRECTANGULARPYRAMID,
  IFCRECTANGULARTRIMMEDSURFACE: () => IFCRECTANGULARTRIMMEDSURFACE,
  IFCRECURRENCEPATTERN: () => IFCRECURRENCEPATTERN,
  IFCREFERENCE: () => IFCREFERENCE,
  IFCREFERENCESVALUEDOCUMENT: () => IFCREFERENCESVALUEDOCUMENT,
  IFCREFERENT: () => IFCREFERENT,
  IFCREGULARTIMESERIES: () => IFCREGULARTIMESERIES,
  IFCREINFORCEDSOIL: () => IFCREINFORCEDSOIL,
  IFCREINFORCEMENTBARPROPERTIES: () => IFCREINFORCEMENTBARPROPERTIES,
  IFCREINFORCEMENTDEFINITIONPROPERTIES: () => IFCREINFORCEMENTDEFINITIONPROPERTIES,
  IFCREINFORCINGBAR: () => IFCREINFORCINGBAR,
  IFCREINFORCINGBARTYPE: () => IFCREINFORCINGBARTYPE,
  IFCREINFORCINGELEMENT: () => IFCREINFORCINGELEMENT,
  IFCREINFORCINGELEMENTTYPE: () => IFCREINFORCINGELEMENTTYPE,
  IFCREINFORCINGMESH: () => IFCREINFORCINGMESH,
  IFCREINFORCINGMESHTYPE: () => IFCREINFORCINGMESHTYPE,
  IFCRELADHERESTOELEMENT: () => IFCRELADHERESTOELEMENT,
  IFCRELAGGREGATES: () => IFCRELAGGREGATES,
  IFCRELASSIGNS: () => IFCRELASSIGNS,
  IFCRELASSIGNSTASKS: () => IFCRELASSIGNSTASKS,
  IFCRELASSIGNSTOACTOR: () => IFCRELASSIGNSTOACTOR,
  IFCRELASSIGNSTOCONTROL: () => IFCRELASSIGNSTOCONTROL,
  IFCRELASSIGNSTOGROUP: () => IFCRELASSIGNSTOGROUP,
  IFCRELASSIGNSTOGROUPBYFACTOR: () => IFCRELASSIGNSTOGROUPBYFACTOR,
  IFCRELASSIGNSTOPROCESS: () => IFCRELASSIGNSTOPROCESS,
  IFCRELASSIGNSTOPRODUCT: () => IFCRELASSIGNSTOPRODUCT,
  IFCRELASSIGNSTOPROJECTORDER: () => IFCRELASSIGNSTOPROJECTORDER,
  IFCRELASSIGNSTORESOURCE: () => IFCRELASSIGNSTORESOURCE,
  IFCRELASSOCIATES: () => IFCRELASSOCIATES,
  IFCRELASSOCIATESAPPLIEDVALUE: () => IFCRELASSOCIATESAPPLIEDVALUE,
  IFCRELASSOCIATESAPPROVAL: () => IFCRELASSOCIATESAPPROVAL,
  IFCRELASSOCIATESCLASSIFICATION: () => IFCRELASSOCIATESCLASSIFICATION,
  IFCRELASSOCIATESCONSTRAINT: () => IFCRELASSOCIATESCONSTRAINT,
  IFCRELASSOCIATESDOCUMENT: () => IFCRELASSOCIATESDOCUMENT,
  IFCRELASSOCIATESLIBRARY: () => IFCRELASSOCIATESLIBRARY,
  IFCRELASSOCIATESMATERIAL: () => IFCRELASSOCIATESMATERIAL,
  IFCRELASSOCIATESPROFILEDEF: () => IFCRELASSOCIATESPROFILEDEF,
  IFCRELASSOCIATESPROFILEPROPERTIES: () => IFCRELASSOCIATESPROFILEPROPERTIES,
  IFCRELATIONSHIP: () => IFCRELATIONSHIP,
  IFCRELAXATION: () => IFCRELAXATION,
  IFCRELCONNECTS: () => IFCRELCONNECTS,
  IFCRELCONNECTSELEMENTS: () => IFCRELCONNECTSELEMENTS,
  IFCRELCONNECTSPATHELEMENTS: () => IFCRELCONNECTSPATHELEMENTS,
  IFCRELCONNECTSPORTS: () => IFCRELCONNECTSPORTS,
  IFCRELCONNECTSPORTTOELEMENT: () => IFCRELCONNECTSPORTTOELEMENT,
  IFCRELCONNECTSSTRUCTURALACTIVITY: () => IFCRELCONNECTSSTRUCTURALACTIVITY,
  IFCRELCONNECTSSTRUCTURALELEMENT: () => IFCRELCONNECTSSTRUCTURALELEMENT,
  IFCRELCONNECTSSTRUCTURALMEMBER: () => IFCRELCONNECTSSTRUCTURALMEMBER,
  IFCRELCONNECTSWITHECCENTRICITY: () => IFCRELCONNECTSWITHECCENTRICITY,
  IFCRELCONNECTSWITHREALIZINGELEMENTS: () => IFCRELCONNECTSWITHREALIZINGELEMENTS,
  IFCRELCONTAINEDINSPATIALSTRUCTURE: () => IFCRELCONTAINEDINSPATIALSTRUCTURE,
  IFCRELCOVERSBLDGELEMENTS: () => IFCRELCOVERSBLDGELEMENTS,
  IFCRELCOVERSSPACES: () => IFCRELCOVERSSPACES,
  IFCRELDECLARES: () => IFCRELDECLARES,
  IFCRELDECOMPOSES: () => IFCRELDECOMPOSES,
  IFCRELDEFINES: () => IFCRELDEFINES,
  IFCRELDEFINESBYOBJECT: () => IFCRELDEFINESBYOBJECT,
  IFCRELDEFINESBYPROPERTIES: () => IFCRELDEFINESBYPROPERTIES,
  IFCRELDEFINESBYTEMPLATE: () => IFCRELDEFINESBYTEMPLATE,
  IFCRELDEFINESBYTYPE: () => IFCRELDEFINESBYTYPE,
  IFCRELFILLSELEMENT: () => IFCRELFILLSELEMENT,
  IFCRELFLOWCONTROLELEMENTS: () => IFCRELFLOWCONTROLELEMENTS,
  IFCRELINTERACTIONREQUIREMENTS: () => IFCRELINTERACTIONREQUIREMENTS,
  IFCRELINTERFERESELEMENTS: () => IFCRELINTERFERESELEMENTS,
  IFCRELNESTS: () => IFCRELNESTS,
  IFCRELOCCUPIESSPACES: () => IFCRELOCCUPIESSPACES,
  IFCRELOVERRIDESPROPERTIES: () => IFCRELOVERRIDESPROPERTIES,
  IFCRELPOSITIONS: () => IFCRELPOSITIONS,
  IFCRELPROJECTSELEMENT: () => IFCRELPROJECTSELEMENT,
  IFCRELREFERENCEDINSPATIALSTRUCTURE: () => IFCRELREFERENCEDINSPATIALSTRUCTURE,
  IFCRELSCHEDULESCOSTITEMS: () => IFCRELSCHEDULESCOSTITEMS,
  IFCRELSEQUENCE: () => IFCRELSEQUENCE,
  IFCRELSERVICESBUILDINGS: () => IFCRELSERVICESBUILDINGS,
  IFCRELSPACEBOUNDARY: () => IFCRELSPACEBOUNDARY,
  IFCRELSPACEBOUNDARY1STLEVEL: () => IFCRELSPACEBOUNDARY1STLEVEL,
  IFCRELSPACEBOUNDARY2NDLEVEL: () => IFCRELSPACEBOUNDARY2NDLEVEL,
  IFCRELVOIDSELEMENT: () => IFCRELVOIDSELEMENT,
  IFCREPARAMETRISEDCOMPOSITECURVESEGMENT: () => IFCREPARAMETRISEDCOMPOSITECURVESEGMENT,
  IFCREPRESENTATION: () => IFCREPRESENTATION,
  IFCREPRESENTATIONCONTEXT: () => IFCREPRESENTATIONCONTEXT,
  IFCREPRESENTATIONITEM: () => IFCREPRESENTATIONITEM,
  IFCREPRESENTATIONMAP: () => IFCREPRESENTATIONMAP,
  IFCRESOURCE: () => IFCRESOURCE,
  IFCRESOURCEAPPROVALRELATIONSHIP: () => IFCRESOURCEAPPROVALRELATIONSHIP,
  IFCRESOURCECONSTRAINTRELATIONSHIP: () => IFCRESOURCECONSTRAINTRELATIONSHIP,
  IFCRESOURCELEVELRELATIONSHIP: () => IFCRESOURCELEVELRELATIONSHIP,
  IFCRESOURCETIME: () => IFCRESOURCETIME,
  IFCREVOLVEDAREASOLID: () => IFCREVOLVEDAREASOLID,
  IFCREVOLVEDAREASOLIDTAPERED: () => IFCREVOLVEDAREASOLIDTAPERED,
  IFCRIBPLATEPROFILEPROPERTIES: () => IFCRIBPLATEPROFILEPROPERTIES,
  IFCRIGHTCIRCULARCONE: () => IFCRIGHTCIRCULARCONE,
  IFCRIGHTCIRCULARCYLINDER: () => IFCRIGHTCIRCULARCYLINDER,
  IFCROAD: () => IFCROAD,
  IFCROADPART: () => IFCROADPART,
  IFCROOF: () => IFCROOF,
  IFCROOFTYPE: () => IFCROOFTYPE,
  IFCROOT: () => IFCROOT,
  IFCROTATIONALFREQUENCYMEASURE: () => IFCROTATIONALFREQUENCYMEASURE,
  IFCROTATIONALMASSMEASURE: () => IFCROTATIONALMASSMEASURE,
  IFCROTATIONALSTIFFNESSMEASURE: () => IFCROTATIONALSTIFFNESSMEASURE,
  IFCROUNDEDEDGEFEATURE: () => IFCROUNDEDEDGEFEATURE,
  IFCROUNDEDRECTANGLEPROFILEDEF: () => IFCROUNDEDRECTANGLEPROFILEDEF,
  IFCSANITARYTERMINAL: () => IFCSANITARYTERMINAL,
  IFCSANITARYTERMINALTYPE: () => IFCSANITARYTERMINALTYPE,
  IFCSCHEDULETIMECONTROL: () => IFCSCHEDULETIMECONTROL,
  IFCSCHEDULINGTIME: () => IFCSCHEDULINGTIME,
  IFCSEAMCURVE: () => IFCSEAMCURVE,
  IFCSECONDINMINUTE: () => IFCSECONDINMINUTE,
  IFCSECONDORDERPOLYNOMIALSPIRAL: () => IFCSECONDORDERPOLYNOMIALSPIRAL,
  IFCSECTIONALAREAINTEGRALMEASURE: () => IFCSECTIONALAREAINTEGRALMEASURE,
  IFCSECTIONEDSOLID: () => IFCSECTIONEDSOLID,
  IFCSECTIONEDSOLIDHORIZONTAL: () => IFCSECTIONEDSOLIDHORIZONTAL,
  IFCSECTIONEDSPINE: () => IFCSECTIONEDSPINE,
  IFCSECTIONEDSURFACE: () => IFCSECTIONEDSURFACE,
  IFCSECTIONMODULUSMEASURE: () => IFCSECTIONMODULUSMEASURE,
  IFCSECTIONPROPERTIES: () => IFCSECTIONPROPERTIES,
  IFCSECTIONREINFORCEMENTPROPERTIES: () => IFCSECTIONREINFORCEMENTPROPERTIES,
  IFCSEGMENT: () => IFCSEGMENT,
  IFCSEGMENTEDREFERENCECURVE: () => IFCSEGMENTEDREFERENCECURVE,
  IFCSENSOR: () => IFCSENSOR,
  IFCSENSORTYPE: () => IFCSENSORTYPE,
  IFCSERVICELIFE: () => IFCSERVICELIFE,
  IFCSERVICELIFEFACTOR: () => IFCSERVICELIFEFACTOR,
  IFCSEVENTHORDERPOLYNOMIALSPIRAL: () => IFCSEVENTHORDERPOLYNOMIALSPIRAL,
  IFCSHADINGDEVICE: () => IFCSHADINGDEVICE,
  IFCSHADINGDEVICETYPE: () => IFCSHADINGDEVICETYPE,
  IFCSHAPEASPECT: () => IFCSHAPEASPECT,
  IFCSHAPEMODEL: () => IFCSHAPEMODEL,
  IFCSHAPEREPRESENTATION: () => IFCSHAPEREPRESENTATION,
  IFCSHEARMODULUSMEASURE: () => IFCSHEARMODULUSMEASURE,
  IFCSHELLBASEDSURFACEMODEL: () => IFCSHELLBASEDSURFACEMODEL,
  IFCSIGN: () => IFCSIGN,
  IFCSIGNAL: () => IFCSIGNAL,
  IFCSIGNALTYPE: () => IFCSIGNALTYPE,
  IFCSIGNTYPE: () => IFCSIGNTYPE,
  IFCSIMPLEPROPERTY: () => IFCSIMPLEPROPERTY,
  IFCSIMPLEPROPERTYTEMPLATE: () => IFCSIMPLEPROPERTYTEMPLATE,
  IFCSINESPIRAL: () => IFCSINESPIRAL,
  IFCSITE: () => IFCSITE,
  IFCSIUNIT: () => IFCSIUNIT,
  IFCSLAB: () => IFCSLAB,
  IFCSLABELEMENTEDCASE: () => IFCSLABELEMENTEDCASE,
  IFCSLABSTANDARDCASE: () => IFCSLABSTANDARDCASE,
  IFCSLABTYPE: () => IFCSLABTYPE,
  IFCSLIPPAGECONNECTIONCONDITION: () => IFCSLIPPAGECONNECTIONCONDITION,
  IFCSOLARDEVICE: () => IFCSOLARDEVICE,
  IFCSOLARDEVICETYPE: () => IFCSOLARDEVICETYPE,
  IFCSOLIDANGLEMEASURE: () => IFCSOLIDANGLEMEASURE,
  IFCSOLIDMODEL: () => IFCSOLIDMODEL,
  IFCSOUNDPOWERLEVELMEASURE: () => IFCSOUNDPOWERLEVELMEASURE,
  IFCSOUNDPOWERMEASURE: () => IFCSOUNDPOWERMEASURE,
  IFCSOUNDPRESSURELEVELMEASURE: () => IFCSOUNDPRESSURELEVELMEASURE,
  IFCSOUNDPRESSUREMEASURE: () => IFCSOUNDPRESSUREMEASURE,
  IFCSOUNDPROPERTIES: () => IFCSOUNDPROPERTIES,
  IFCSOUNDVALUE: () => IFCSOUNDVALUE,
  IFCSPACE: () => IFCSPACE,
  IFCSPACEHEATER: () => IFCSPACEHEATER,
  IFCSPACEHEATERTYPE: () => IFCSPACEHEATERTYPE,
  IFCSPACEPROGRAM: () => IFCSPACEPROGRAM,
  IFCSPACETHERMALLOADPROPERTIES: () => IFCSPACETHERMALLOADPROPERTIES,
  IFCSPACETYPE: () => IFCSPACETYPE,
  IFCSPATIALELEMENT: () => IFCSPATIALELEMENT,
  IFCSPATIALELEMENTTYPE: () => IFCSPATIALELEMENTTYPE,
  IFCSPATIALSTRUCTUREELEMENT: () => IFCSPATIALSTRUCTUREELEMENT,
  IFCSPATIALSTRUCTUREELEMENTTYPE: () => IFCSPATIALSTRUCTUREELEMENTTYPE,
  IFCSPATIALZONE: () => IFCSPATIALZONE,
  IFCSPATIALZONETYPE: () => IFCSPATIALZONETYPE,
  IFCSPECIFICHEATCAPACITYMEASURE: () => IFCSPECIFICHEATCAPACITYMEASURE,
  IFCSPECULAREXPONENT: () => IFCSPECULAREXPONENT,
  IFCSPECULARROUGHNESS: () => IFCSPECULARROUGHNESS,
  IFCSPHERE: () => IFCSPHERE,
  IFCSPHERICALSURFACE: () => IFCSPHERICALSURFACE,
  IFCSPIRAL: () => IFCSPIRAL,
  IFCSTACKTERMINAL: () => IFCSTACKTERMINAL,
  IFCSTACKTERMINALTYPE: () => IFCSTACKTERMINALTYPE,
  IFCSTAIR: () => IFCSTAIR,
  IFCSTAIRFLIGHT: () => IFCSTAIRFLIGHT,
  IFCSTAIRFLIGHTTYPE: () => IFCSTAIRFLIGHTTYPE,
  IFCSTAIRTYPE: () => IFCSTAIRTYPE,
  IFCSTRUCTURALACTION: () => IFCSTRUCTURALACTION,
  IFCSTRUCTURALACTIVITY: () => IFCSTRUCTURALACTIVITY,
  IFCSTRUCTURALANALYSISMODEL: () => IFCSTRUCTURALANALYSISMODEL,
  IFCSTRUCTURALCONNECTION: () => IFCSTRUCTURALCONNECTION,
  IFCSTRUCTURALCONNECTIONCONDITION: () => IFCSTRUCTURALCONNECTIONCONDITION,
  IFCSTRUCTURALCURVEACTION: () => IFCSTRUCTURALCURVEACTION,
  IFCSTRUCTURALCURVECONNECTION: () => IFCSTRUCTURALCURVECONNECTION,
  IFCSTRUCTURALCURVEMEMBER: () => IFCSTRUCTURALCURVEMEMBER,
  IFCSTRUCTURALCURVEMEMBERVARYING: () => IFCSTRUCTURALCURVEMEMBERVARYING,
  IFCSTRUCTURALCURVEREACTION: () => IFCSTRUCTURALCURVEREACTION,
  IFCSTRUCTURALITEM: () => IFCSTRUCTURALITEM,
  IFCSTRUCTURALLINEARACTION: () => IFCSTRUCTURALLINEARACTION,
  IFCSTRUCTURALLINEARACTIONVARYING: () => IFCSTRUCTURALLINEARACTIONVARYING,
  IFCSTRUCTURALLOAD: () => IFCSTRUCTURALLOAD,
  IFCSTRUCTURALLOADCASE: () => IFCSTRUCTURALLOADCASE,
  IFCSTRUCTURALLOADCONFIGURATION: () => IFCSTRUCTURALLOADCONFIGURATION,
  IFCSTRUCTURALLOADGROUP: () => IFCSTRUCTURALLOADGROUP,
  IFCSTRUCTURALLOADLINEARFORCE: () => IFCSTRUCTURALLOADLINEARFORCE,
  IFCSTRUCTURALLOADORRESULT: () => IFCSTRUCTURALLOADORRESULT,
  IFCSTRUCTURALLOADPLANARFORCE: () => IFCSTRUCTURALLOADPLANARFORCE,
  IFCSTRUCTURALLOADSINGLEDISPLACEMENT: () => IFCSTRUCTURALLOADSINGLEDISPLACEMENT,
  IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION: () => IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION,
  IFCSTRUCTURALLOADSINGLEFORCE: () => IFCSTRUCTURALLOADSINGLEFORCE,
  IFCSTRUCTURALLOADSINGLEFORCEWARPING: () => IFCSTRUCTURALLOADSINGLEFORCEWARPING,
  IFCSTRUCTURALLOADSTATIC: () => IFCSTRUCTURALLOADSTATIC,
  IFCSTRUCTURALLOADTEMPERATURE: () => IFCSTRUCTURALLOADTEMPERATURE,
  IFCSTRUCTURALMEMBER: () => IFCSTRUCTURALMEMBER,
  IFCSTRUCTURALPLANARACTION: () => IFCSTRUCTURALPLANARACTION,
  IFCSTRUCTURALPLANARACTIONVARYING: () => IFCSTRUCTURALPLANARACTIONVARYING,
  IFCSTRUCTURALPOINTACTION: () => IFCSTRUCTURALPOINTACTION,
  IFCSTRUCTURALPOINTCONNECTION: () => IFCSTRUCTURALPOINTCONNECTION,
  IFCSTRUCTURALPOINTREACTION: () => IFCSTRUCTURALPOINTREACTION,
  IFCSTRUCTURALPROFILEPROPERTIES: () => IFCSTRUCTURALPROFILEPROPERTIES,
  IFCSTRUCTURALREACTION: () => IFCSTRUCTURALREACTION,
  IFCSTRUCTURALRESULTGROUP: () => IFCSTRUCTURALRESULTGROUP,
  IFCSTRUCTURALSTEELPROFILEPROPERTIES: () => IFCSTRUCTURALSTEELPROFILEPROPERTIES,
  IFCSTRUCTURALSURFACEACTION: () => IFCSTRUCTURALSURFACEACTION,
  IFCSTRUCTURALSURFACECONNECTION: () => IFCSTRUCTURALSURFACECONNECTION,
  IFCSTRUCTURALSURFACEMEMBER: () => IFCSTRUCTURALSURFACEMEMBER,
  IFCSTRUCTURALSURFACEMEMBERVARYING: () => IFCSTRUCTURALSURFACEMEMBERVARYING,
  IFCSTRUCTURALSURFACEREACTION: () => IFCSTRUCTURALSURFACEREACTION,
  IFCSTRUCTUREDDIMENSIONCALLOUT: () => IFCSTRUCTUREDDIMENSIONCALLOUT,
  IFCSTYLEDITEM: () => IFCSTYLEDITEM,
  IFCSTYLEDREPRESENTATION: () => IFCSTYLEDREPRESENTATION,
  IFCSTYLEMODEL: () => IFCSTYLEMODEL,
  IFCSUBCONTRACTRESOURCE: () => IFCSUBCONTRACTRESOURCE,
  IFCSUBCONTRACTRESOURCETYPE: () => IFCSUBCONTRACTRESOURCETYPE,
  IFCSUBEDGE: () => IFCSUBEDGE,
  IFCSURFACE: () => IFCSURFACE,
  IFCSURFACECURVE: () => IFCSURFACECURVE,
  IFCSURFACECURVESWEPTAREASOLID: () => IFCSURFACECURVESWEPTAREASOLID,
  IFCSURFACEFEATURE: () => IFCSURFACEFEATURE,
  IFCSURFACEOFLINEAREXTRUSION: () => IFCSURFACEOFLINEAREXTRUSION,
  IFCSURFACEOFREVOLUTION: () => IFCSURFACEOFREVOLUTION,
  IFCSURFACEREINFORCEMENTAREA: () => IFCSURFACEREINFORCEMENTAREA,
  IFCSURFACESTYLE: () => IFCSURFACESTYLE,
  IFCSURFACESTYLELIGHTING: () => IFCSURFACESTYLELIGHTING,
  IFCSURFACESTYLEREFRACTION: () => IFCSURFACESTYLEREFRACTION,
  IFCSURFACESTYLERENDERING: () => IFCSURFACESTYLERENDERING,
  IFCSURFACESTYLESHADING: () => IFCSURFACESTYLESHADING,
  IFCSURFACESTYLEWITHTEXTURES: () => IFCSURFACESTYLEWITHTEXTURES,
  IFCSURFACETEXTURE: () => IFCSURFACETEXTURE,
  IFCSWEPTAREASOLID: () => IFCSWEPTAREASOLID,
  IFCSWEPTDISKSOLID: () => IFCSWEPTDISKSOLID,
  IFCSWEPTDISKSOLIDPOLYGONAL: () => IFCSWEPTDISKSOLIDPOLYGONAL,
  IFCSWEPTSURFACE: () => IFCSWEPTSURFACE,
  IFCSWITCHINGDEVICE: () => IFCSWITCHINGDEVICE,
  IFCSWITCHINGDEVICETYPE: () => IFCSWITCHINGDEVICETYPE,
  IFCSYMBOLSTYLE: () => IFCSYMBOLSTYLE,
  IFCSYSTEM: () => IFCSYSTEM,
  IFCSYSTEMFURNITUREELEMENT: () => IFCSYSTEMFURNITUREELEMENT,
  IFCSYSTEMFURNITUREELEMENTTYPE: () => IFCSYSTEMFURNITUREELEMENTTYPE,
  IFCTABLE: () => IFCTABLE,
  IFCTABLECOLUMN: () => IFCTABLECOLUMN,
  IFCTABLEROW: () => IFCTABLEROW,
  IFCTANK: () => IFCTANK,
  IFCTANKTYPE: () => IFCTANKTYPE,
  IFCTASK: () => IFCTASK,
  IFCTASKTIME: () => IFCTASKTIME,
  IFCTASKTIMERECURRING: () => IFCTASKTIMERECURRING,
  IFCTASKTYPE: () => IFCTASKTYPE,
  IFCTELECOMADDRESS: () => IFCTELECOMADDRESS,
  IFCTEMPERATUREGRADIENTMEASURE: () => IFCTEMPERATUREGRADIENTMEASURE,
  IFCTEMPERATURERATEOFCHANGEMEASURE: () => IFCTEMPERATURERATEOFCHANGEMEASURE,
  IFCTENDON: () => IFCTENDON,
  IFCTENDONANCHOR: () => IFCTENDONANCHOR,
  IFCTENDONANCHORTYPE: () => IFCTENDONANCHORTYPE,
  IFCTENDONCONDUIT: () => IFCTENDONCONDUIT,
  IFCTENDONCONDUITTYPE: () => IFCTENDONCONDUITTYPE,
  IFCTENDONTYPE: () => IFCTENDONTYPE,
  IFCTERMINATORSYMBOL: () => IFCTERMINATORSYMBOL,
  IFCTESSELLATEDFACESET: () => IFCTESSELLATEDFACESET,
  IFCTESSELLATEDITEM: () => IFCTESSELLATEDITEM,
  IFCTEXT: () => IFCTEXT,
  IFCTEXTALIGNMENT: () => IFCTEXTALIGNMENT,
  IFCTEXTDECORATION: () => IFCTEXTDECORATION,
  IFCTEXTFONTNAME: () => IFCTEXTFONTNAME,
  IFCTEXTLITERAL: () => IFCTEXTLITERAL,
  IFCTEXTLITERALWITHEXTENT: () => IFCTEXTLITERALWITHEXTENT,
  IFCTEXTSTYLE: () => IFCTEXTSTYLE,
  IFCTEXTSTYLEFONTMODEL: () => IFCTEXTSTYLEFONTMODEL,
  IFCTEXTSTYLEFORDEFINEDFONT: () => IFCTEXTSTYLEFORDEFINEDFONT,
  IFCTEXTSTYLETEXTMODEL: () => IFCTEXTSTYLETEXTMODEL,
  IFCTEXTSTYLEWITHBOXCHARACTERISTICS: () => IFCTEXTSTYLEWITHBOXCHARACTERISTICS,
  IFCTEXTTRANSFORMATION: () => IFCTEXTTRANSFORMATION,
  IFCTEXTURECOORDINATE: () => IFCTEXTURECOORDINATE,
  IFCTEXTURECOORDINATEGENERATOR: () => IFCTEXTURECOORDINATEGENERATOR,
  IFCTEXTURECOORDINATEINDICES: () => IFCTEXTURECOORDINATEINDICES,
  IFCTEXTURECOORDINATEINDICESWITHVOIDS: () => IFCTEXTURECOORDINATEINDICESWITHVOIDS,
  IFCTEXTUREMAP: () => IFCTEXTUREMAP,
  IFCTEXTUREVERTEX: () => IFCTEXTUREVERTEX,
  IFCTEXTUREVERTEXLIST: () => IFCTEXTUREVERTEXLIST,
  IFCTHERMALADMITTANCEMEASURE: () => IFCTHERMALADMITTANCEMEASURE,
  IFCTHERMALCONDUCTIVITYMEASURE: () => IFCTHERMALCONDUCTIVITYMEASURE,
  IFCTHERMALEXPANSIONCOEFFICIENTMEASURE: () => IFCTHERMALEXPANSIONCOEFFICIENTMEASURE,
  IFCTHERMALMATERIALPROPERTIES: () => IFCTHERMALMATERIALPROPERTIES,
  IFCTHERMALRESISTANCEMEASURE: () => IFCTHERMALRESISTANCEMEASURE,
  IFCTHERMALTRANSMITTANCEMEASURE: () => IFCTHERMALTRANSMITTANCEMEASURE,
  IFCTHERMODYNAMICTEMPERATUREMEASURE: () => IFCTHERMODYNAMICTEMPERATUREMEASURE,
  IFCTHIRDORDERPOLYNOMIALSPIRAL: () => IFCTHIRDORDERPOLYNOMIALSPIRAL,
  IFCTIME: () => IFCTIME,
  IFCTIMEMEASURE: () => IFCTIMEMEASURE,
  IFCTIMEPERIOD: () => IFCTIMEPERIOD,
  IFCTIMESERIES: () => IFCTIMESERIES,
  IFCTIMESERIESREFERENCERELATIONSHIP: () => IFCTIMESERIESREFERENCERELATIONSHIP,
  IFCTIMESERIESSCHEDULE: () => IFCTIMESERIESSCHEDULE,
  IFCTIMESERIESVALUE: () => IFCTIMESERIESVALUE,
  IFCTIMESTAMP: () => IFCTIMESTAMP,
  IFCTOPOLOGICALREPRESENTATIONITEM: () => IFCTOPOLOGICALREPRESENTATIONITEM,
  IFCTOPOLOGYREPRESENTATION: () => IFCTOPOLOGYREPRESENTATION,
  IFCTOROIDALSURFACE: () => IFCTOROIDALSURFACE,
  IFCTORQUEMEASURE: () => IFCTORQUEMEASURE,
  IFCTRACKELEMENT: () => IFCTRACKELEMENT,
  IFCTRACKELEMENTTYPE: () => IFCTRACKELEMENTTYPE,
  IFCTRANSFORMER: () => IFCTRANSFORMER,
  IFCTRANSFORMERTYPE: () => IFCTRANSFORMERTYPE,
  IFCTRANSPORTATIONDEVICE: () => IFCTRANSPORTATIONDEVICE,
  IFCTRANSPORTATIONDEVICETYPE: () => IFCTRANSPORTATIONDEVICETYPE,
  IFCTRANSPORTELEMENT: () => IFCTRANSPORTELEMENT,
  IFCTRANSPORTELEMENTTYPE: () => IFCTRANSPORTELEMENTTYPE,
  IFCTRAPEZIUMPROFILEDEF: () => IFCTRAPEZIUMPROFILEDEF,
  IFCTRIANGULATEDFACESET: () => IFCTRIANGULATEDFACESET,
  IFCTRIANGULATEDIRREGULARNETWORK: () => IFCTRIANGULATEDIRREGULARNETWORK,
  IFCTRIMMEDCURVE: () => IFCTRIMMEDCURVE,
  IFCTSHAPEPROFILEDEF: () => IFCTSHAPEPROFILEDEF,
  IFCTUBEBUNDLE: () => IFCTUBEBUNDLE,
  IFCTUBEBUNDLETYPE: () => IFCTUBEBUNDLETYPE,
  IFCTWODIRECTIONREPEATFACTOR: () => IFCTWODIRECTIONREPEATFACTOR,
  IFCTYPEOBJECT: () => IFCTYPEOBJECT,
  IFCTYPEPROCESS: () => IFCTYPEPROCESS,
  IFCTYPEPRODUCT: () => IFCTYPEPRODUCT,
  IFCTYPERESOURCE: () => IFCTYPERESOURCE,
  IFCUNITARYCONTROLELEMENT: () => IFCUNITARYCONTROLELEMENT,
  IFCUNITARYCONTROLELEMENTTYPE: () => IFCUNITARYCONTROLELEMENTTYPE,
  IFCUNITARYEQUIPMENT: () => IFCUNITARYEQUIPMENT,
  IFCUNITARYEQUIPMENTTYPE: () => IFCUNITARYEQUIPMENTTYPE,
  IFCUNITASSIGNMENT: () => IFCUNITASSIGNMENT,
  IFCURIREFERENCE: () => IFCURIREFERENCE,
  IFCUSHAPEPROFILEDEF: () => IFCUSHAPEPROFILEDEF,
  IFCVALVE: () => IFCVALVE,
  IFCVALVETYPE: () => IFCVALVETYPE,
  IFCVAPORPERMEABILITYMEASURE: () => IFCVAPORPERMEABILITYMEASURE,
  IFCVECTOR: () => IFCVECTOR,
  IFCVEHICLE: () => IFCVEHICLE,
  IFCVEHICLETYPE: () => IFCVEHICLETYPE,
  IFCVERTEX: () => IFCVERTEX,
  IFCVERTEXBASEDTEXTUREMAP: () => IFCVERTEXBASEDTEXTUREMAP,
  IFCVERTEXLOOP: () => IFCVERTEXLOOP,
  IFCVERTEXPOINT: () => IFCVERTEXPOINT,
  IFCVIBRATIONDAMPER: () => IFCVIBRATIONDAMPER,
  IFCVIBRATIONDAMPERTYPE: () => IFCVIBRATIONDAMPERTYPE,
  IFCVIBRATIONISOLATOR: () => IFCVIBRATIONISOLATOR,
  IFCVIBRATIONISOLATORTYPE: () => IFCVIBRATIONISOLATORTYPE,
  IFCVIRTUALELEMENT: () => IFCVIRTUALELEMENT,
  IFCVIRTUALGRIDINTERSECTION: () => IFCVIRTUALGRIDINTERSECTION,
  IFCVOIDINGFEATURE: () => IFCVOIDINGFEATURE,
  IFCVOLUMEMEASURE: () => IFCVOLUMEMEASURE,
  IFCVOLUMETRICFLOWRATEMEASURE: () => IFCVOLUMETRICFLOWRATEMEASURE,
  IFCWALL: () => IFCWALL,
  IFCWALLELEMENTEDCASE: () => IFCWALLELEMENTEDCASE,
  IFCWALLSTANDARDCASE: () => IFCWALLSTANDARDCASE,
  IFCWALLTYPE: () => IFCWALLTYPE,
  IFCWARPINGCONSTANTMEASURE: () => IFCWARPINGCONSTANTMEASURE,
  IFCWARPINGMOMENTMEASURE: () => IFCWARPINGMOMENTMEASURE,
  IFCWASTETERMINAL: () => IFCWASTETERMINAL,
  IFCWASTETERMINALTYPE: () => IFCWASTETERMINALTYPE,
  IFCWATERPROPERTIES: () => IFCWATERPROPERTIES,
  IFCWINDOW: () => IFCWINDOW,
  IFCWINDOWLININGPROPERTIES: () => IFCWINDOWLININGPROPERTIES,
  IFCWINDOWPANELPROPERTIES: () => IFCWINDOWPANELPROPERTIES,
  IFCWINDOWSTANDARDCASE: () => IFCWINDOWSTANDARDCASE,
  IFCWINDOWSTYLE: () => IFCWINDOWSTYLE,
  IFCWINDOWTYPE: () => IFCWINDOWTYPE,
  IFCWORKCALENDAR: () => IFCWORKCALENDAR,
  IFCWORKCONTROL: () => IFCWORKCONTROL,
  IFCWORKPLAN: () => IFCWORKPLAN,
  IFCWORKSCHEDULE: () => IFCWORKSCHEDULE,
  IFCWORKTIME: () => IFCWORKTIME,
  IFCYEARNUMBER: () => IFCYEARNUMBER,
  IFCZONE: () => IFCZONE,
  IFCZSHAPEPROFILEDEF: () => IFCZSHAPEPROFILEDEF,
  INTEGER: () => INTEGER,
  IfcAPI: () => IfcAPI2,
  IfcLineObject: () => IfcLineObject,
  InheritanceDef: () => InheritanceDef,
  InversePropertyDef: () => InversePropertyDef,
  LABEL: () => LABEL,
  LINE_END: () => LINE_END,
  LogLevel: () => LogLevel,
  Properties: () => Properties,
  REAL: () => REAL,
  REF: () => REF,
  SET_BEGIN: () => SET_BEGIN,
  SET_END: () => SET_END,
  STRING: () => STRING,
  SchemaNames: () => SchemaNames,
  Schemas: () => Schemas,
  ToRawLineData: () => ToRawLineData,
  TypeInitialisers: () => TypeInitialisers,
  UNKNOWN: () => UNKNOWN,
  logical: () => logical,
  ms: () => ms
});
module.exports = __toCommonJS(web_ifc_api_exports);

// dist/ifc-schema.ts
var IFCURIREFERENCE = 950732822;
var IFCTIME = 4075327185;
var IFCTEMPERATURERATEOFCHANGEMEASURE = 1209108979;
var IFCSOUNDPRESSURELEVELMEASURE = 3457685358;
var IFCSOUNDPOWERLEVELMEASURE = 4157543285;
var IFCPROPERTYSETDEFINITIONSET = 2798247006;
var IFCPOSITIVEINTEGER = 1790229001;
var IFCNONNEGATIVELENGTHMEASURE = 525895558;
var IFCLINEINDEX = 1774176899;
var IFCLANGUAGEID = 1275358634;
var IFCDURATION = 2541165894;
var IFCDAYINWEEKNUMBER = 3701338814;
var IFCDATETIME = 2195413836;
var IFCDATE = 937566702;
var IFCCARDINALPOINTREFERENCE = 1683019596;
var IFCBINARY = 2314439260;
var IFCAREADENSITYMEASURE = 1500781891;
var IFCARCINDEX = 3683503648;
var IFCYEARNUMBER = 4065007721;
var IFCWARPINGMOMENTMEASURE = 1718600412;
var IFCWARPINGCONSTANTMEASURE = 51269191;
var IFCVOLUMETRICFLOWRATEMEASURE = 2593997549;
var IFCVOLUMEMEASURE = 3458127941;
var IFCVAPORPERMEABILITYMEASURE = 3345633955;
var IFCTORQUEMEASURE = 1278329552;
var IFCTIMESTAMP = 2591213694;
var IFCTIMEMEASURE = 2726807636;
var IFCTHERMODYNAMICTEMPERATUREMEASURE = 743184107;
var IFCTHERMALTRANSMITTANCEMEASURE = 2016195849;
var IFCTHERMALRESISTANCEMEASURE = 857959152;
var IFCTHERMALEXPANSIONCOEFFICIENTMEASURE = 2281867870;
var IFCTHERMALCONDUCTIVITYMEASURE = 2645777649;
var IFCTHERMALADMITTANCEMEASURE = 232962298;
var IFCTEXTTRANSFORMATION = 296282323;
var IFCTEXTFONTNAME = 603696268;
var IFCTEXTDECORATION = 3490877962;
var IFCTEXTALIGNMENT = 1460886941;
var IFCTEXT = 2801250643;
var IFCTEMPERATUREGRADIENTMEASURE = 58845555;
var IFCSPECULARROUGHNESS = 361837227;
var IFCSPECULAREXPONENT = 2757832317;
var IFCSPECIFICHEATCAPACITYMEASURE = 3477203348;
var IFCSOUNDPRESSUREMEASURE = 993287707;
var IFCSOUNDPOWERMEASURE = 846465480;
var IFCSOLIDANGLEMEASURE = 3471399674;
var IFCSHEARMODULUSMEASURE = 408310005;
var IFCSECTIONALAREAINTEGRALMEASURE = 2190458107;
var IFCSECTIONMODULUSMEASURE = 3467162246;
var IFCSECONDINMINUTE = 2766185779;
var IFCROTATIONALSTIFFNESSMEASURE = 3211557302;
var IFCROTATIONALMASSMEASURE = 1755127002;
var IFCROTATIONALFREQUENCYMEASURE = 2133746277;
var IFCREAL = 200335297;
var IFCRATIOMEASURE = 96294661;
var IFCRADIOACTIVITYMEASURE = 3972513137;
var IFCPRESSUREMEASURE = 3665567075;
var IFCPRESENTABLETEXT = 2169031380;
var IFCPOWERMEASURE = 1364037233;
var IFCPOSITIVERATIOMEASURE = 1245737093;
var IFCPOSITIVEPLANEANGLEMEASURE = 3054510233;
var IFCPOSITIVELENGTHMEASURE = 2815919920;
var IFCPLANEANGLEMEASURE = 4042175685;
var IFCPLANARFORCEMEASURE = 2642773653;
var IFCPARAMETERVALUE = 2260317790;
var IFCPHMEASURE = 929793134;
var IFCNUMERICMEASURE = 2395907400;
var IFCNORMALISEDRATIOMEASURE = 2095195183;
var IFCMONTHINYEARNUMBER = 765770214;
var IFCMONETARYMEASURE = 2615040989;
var IFCMOMENTOFINERTIAMEASURE = 3114022597;
var IFCMOLECULARWEIGHTMEASURE = 1648970520;
var IFCMOISTUREDIFFUSIVITYMEASURE = 3177669450;
var IFCMODULUSOFSUBGRADEREACTIONMEASURE = 1753493141;
var IFCMODULUSOFROTATIONALSUBGRADEREACTIONMEASURE = 1052454078;
var IFCMODULUSOFLINEARSUBGRADEREACTIONMEASURE = 2173214787;
var IFCMODULUSOFELASTICITYMEASURE = 3341486342;
var IFCMINUTEINHOUR = 102610177;
var IFCMASSPERLENGTHMEASURE = 3531705166;
var IFCMASSMEASURE = 3124614049;
var IFCMASSFLOWRATEMEASURE = 4017473158;
var IFCMASSDENSITYMEASURE = 1477762836;
var IFCMAGNETICFLUXMEASURE = 2486716878;
var IFCMAGNETICFLUXDENSITYMEASURE = 286949696;
var IFCLUMINOUSINTENSITYMEASURE = 151039812;
var IFCLUMINOUSINTENSITYDISTRIBUTIONMEASURE = 2755797622;
var IFCLUMINOUSFLUXMEASURE = 2095003142;
var IFCLOGICAL = 503418787;
var IFCLINEARVELOCITYMEASURE = 3086160713;
var IFCLINEARSTIFFNESSMEASURE = 1307019551;
var IFCLINEARMOMENTMEASURE = 2128979029;
var IFCLINEARFORCEMEASURE = 191860431;
var IFCLENGTHMEASURE = 1243674935;
var IFCLABEL = 3258342251;
var IFCKINEMATICVISCOSITYMEASURE = 2054016361;
var IFCISOTHERMALMOISTURECAPACITYMEASURE = 3192672207;
var IFCIONCONCENTRATIONMEASURE = 3686016028;
var IFCINTEGERCOUNTRATEMEASURE = 3809634241;
var IFCINTEGER = 1939436016;
var IFCINDUCTANCEMEASURE = 2679005408;
var IFCILLUMINANCEMEASURE = 3358199106;
var IFCIDENTIFIER = 983778844;
var IFCHOURINDAY = 2589826445;
var IFCHEATINGVALUEMEASURE = 1158859006;
var IFCHEATFLUXDENSITYMEASURE = 3113092358;
var IFCGLOBALLYUNIQUEID = 3064340077;
var IFCFREQUENCYMEASURE = 3044325142;
var IFCFORCEMEASURE = 1361398929;
var IFCFONTWEIGHT = 2590844177;
var IFCFONTVARIANT = 2715512545;
var IFCFONTSTYLE = 1102727119;
var IFCENERGYMEASURE = 2078135608;
var IFCELECTRICVOLTAGEMEASURE = 2506197118;
var IFCELECTRICRESISTANCEMEASURE = 2951915441;
var IFCELECTRICCURRENTMEASURE = 3790457270;
var IFCELECTRICCONDUCTANCEMEASURE = 2093906313;
var IFCELECTRICCHARGEMEASURE = 3818826038;
var IFCELECTRICCAPACITANCEMEASURE = 1827137117;
var IFCDYNAMICVISCOSITYMEASURE = 69416015;
var IFCDOSEEQUIVALENTMEASURE = 524656162;
var IFCDIMENSIONCOUNT = 4134073009;
var IFCDESCRIPTIVEMEASURE = 1514641115;
var IFCDAYLIGHTSAVINGHOUR = 300323983;
var IFCDAYINMONTHNUMBER = 86635668;
var IFCCURVATUREMEASURE = 94842927;
var IFCCOUNTMEASURE = 1778710042;
var IFCCONTEXTDEPENDENTMEASURE = 3238673880;
var IFCCOMPOUNDPLANEANGLEMEASURE = 3812528620;
var IFCCOMPLEXNUMBER = 2991860651;
var IFCBOXALIGNMENT = 1867003952;
var IFCBOOLEAN = 2735952531;
var IFCAREAMEASURE = 2650437152;
var IFCANGULARVELOCITYMEASURE = 632304761;
var IFCAMOUNTOFSUBSTANCEMEASURE = 360377573;
var IFCACCELERATIONMEASURE = 4182062534;
var IFCABSORBEDDOSEMEASURE = 3699917729;
var IFCGEOSLICE = 1971632696;
var IFCGEOMODEL = 2680139844;
var IFCELECTRICFLOWTREATMENTDEVICE = 24726584;
var IFCDISTRIBUTIONBOARD = 3693000487;
var IFCCONVEYORSEGMENT = 3460952963;
var IFCCAISSONFOUNDATION = 3999819293;
var IFCBOREHOLE = 3314249567;
var IFCBEARING = 4196446775;
var IFCALIGNMENT = 325726236;
var IFCTRACKELEMENT = 3425753595;
var IFCSIGNAL = 991950508;
var IFCREINFORCEDSOIL = 3798194928;
var IFCRAIL = 3290496277;
var IFCPAVEMENT = 1383356374;
var IFCNAVIGATIONELEMENT = 2182337498;
var IFCMOORINGDEVICE = 234836483;
var IFCMOBILETELECOMMUNICATIONSAPPLIANCE = 2078563270;
var IFCLIQUIDTERMINAL = 1638804497;
var IFCLINEARPOSITIONINGELEMENT = 1154579445;
var IFCKERB = 2696325953;
var IFCGEOTECHNICALASSEMBLY = 2713699986;
var IFCELECTRICFLOWTREATMENTDEVICETYPE = 2142170206;
var IFCEARTHWORKSFILL = 3376911765;
var IFCEARTHWORKSELEMENT = 1077100507;
var IFCEARTHWORKSCUT = 3071239417;
var IFCDISTRIBUTIONBOARDTYPE = 479945903;
var IFCDEEPFOUNDATION = 3426335179;
var IFCCOURSE = 1502416096;
var IFCCONVEYORSEGMENTTYPE = 2940368186;
var IFCCAISSONFOUNDATIONTYPE = 3203706013;
var IFCBUILTSYSTEM = 3862327254;
var IFCBUILTELEMENT = 1876633798;
var IFCBRIDGEPART = 963979645;
var IFCBRIDGE = 644574406;
var IFCBEARINGTYPE = 3649138523;
var IFCALIGNMENTVERTICAL = 1662888072;
var IFCALIGNMENTSEGMENT = 317615605;
var IFCALIGNMENTHORIZONTAL = 1545765605;
var IFCALIGNMENTCANT = 4266260250;
var IFCVIBRATIONDAMPERTYPE = 3956297820;
var IFCVIBRATIONDAMPER = 1530820697;
var IFCVEHICLE = 840318589;
var IFCTRANSPORTATIONDEVICE = 1953115116;
var IFCTRACKELEMENTTYPE = 618700268;
var IFCTENDONCONDUITTYPE = 2281632017;
var IFCTENDONCONDUIT = 3663046924;
var IFCSINESPIRAL = 42703149;
var IFCSIGNALTYPE = 1894708472;
var IFCSIGNTYPE = 3599934289;
var IFCSIGN = 33720170;
var IFCSEVENTHORDERPOLYNOMIALSPIRAL = 1027922057;
var IFCSEGMENTEDREFERENCECURVE = 544395925;
var IFCSECONDORDERPOLYNOMIALSPIRAL = 3649235739;
var IFCROADPART = 550521510;
var IFCROAD = 146592293;
var IFCRELADHERESTOELEMENT = 3818125796;
var IFCREFERENT = 4021432810;
var IFCRAILWAYPART = 1891881377;
var IFCRAILWAY = 3992365140;
var IFCRAILTYPE = 1763565496;
var IFCPOSITIONINGELEMENT = 1946335990;
var IFCPAVEMENTTYPE = 514975943;
var IFCNAVIGATIONELEMENTTYPE = 506776471;
var IFCMOORINGDEVICETYPE = 710110818;
var IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE = 1950438474;
var IFCMARINEPART = 976884017;
var IFCMARINEFACILITY = 525669439;
var IFCLIQUIDTERMINALTYPE = 1770583370;
var IFCLINEARELEMENT = 2176059722;
var IFCKERBTYPE = 679976338;
var IFCIMPACTPROTECTIONDEVICETYPE = 3948183225;
var IFCIMPACTPROTECTIONDEVICE = 2568555532;
var IFCGRADIENTCURVE = 2898700619;
var IFCGEOTECHNICALSTRATUM = 1594536857;
var IFCGEOTECHNICALELEMENT = 4230923436;
var IFCFACILITYPARTCOMMON = 4228831410;
var IFCFACILITYPART = 1310830890;
var IFCFACILITY = 24185140;
var IFCDIRECTRIXDERIVEDREFERENCESWEPTAREASOLID = 4234616927;
var IFCDEEPFOUNDATIONTYPE = 1306400036;
var IFCCOURSETYPE = 4189326743;
var IFCCOSINESPIRAL = 2000195564;
var IFCCLOTHOID = 3497074424;
var IFCBUILTELEMENTTYPE = 1626504194;
var IFCVEHICLETYPE = 3651464721;
var IFCTRIANGULATEDIRREGULARNETWORK = 1229763772;
var IFCTRANSPORTATIONDEVICETYPE = 3665877780;
var IFCTHIRDORDERPOLYNOMIALSPIRAL = 782932809;
var IFCSPIRAL = 2735484536;
var IFCSECTIONEDSURFACE = 1356537516;
var IFCSECTIONEDSOLIDHORIZONTAL = 1290935644;
var IFCSECTIONEDSOLID = 1862484736;
var IFCRELPOSITIONS = 1441486842;
var IFCRELASSOCIATESPROFILEDEF = 1033248425;
var IFCPOLYNOMIALCURVE = 3381221214;
var IFCOFFSETCURVEBYDISTANCES = 2485787929;
var IFCOFFSETCURVE = 590820931;
var IFCINDEXEDPOLYGONALTEXTUREMAP = 3465909080;
var IFCDIRECTRIXCURVESWEPTAREASOLID = 593015953;
var IFCCURVESEGMENT = 4212018352;
var IFCAXIS2PLACEMENTLINEAR = 3425423356;
var IFCSEGMENT = 823603102;
var IFCPOINTBYDISTANCEEXPRESSION = 2165702409;
var IFCOPENCROSSPROFILEDEF = 182550632;
var IFCLINEARPLACEMENT = 388784114;
var IFCALIGNMENTHORIZONTALSEGMENT = 536804194;
var IFCALIGNMENTCANTSEGMENT = 3752311538;
var IFCTEXTURECOORDINATEINDICESWITHVOIDS = 1010789467;
var IFCTEXTURECOORDINATEINDICES = 222769930;
var IFCQUANTITYNUMBER = 2691318326;
var IFCALIGNMENTVERTICALSEGMENT = 3633395639;
var IFCALIGNMENTPARAMETERSEGMENT = 2879124712;
var IFCCONTROLLER = 25142252;
var IFCALARM = 3087945054;
var IFCACTUATOR = 4288193352;
var IFCUNITARYCONTROLELEMENT = 630975310;
var IFCSENSOR = 4086658281;
var IFCPROTECTIVEDEVICETRIPPINGUNIT = 2295281155;
var IFCFLOWINSTRUMENT = 182646315;
var IFCFIRESUPPRESSIONTERMINAL = 1426591983;
var IFCFILTER = 819412036;
var IFCFAN = 3415622556;
var IFCELECTRICTIMECONTROL = 1003880860;
var IFCELECTRICMOTOR = 402227799;
var IFCELECTRICGENERATOR = 264262732;
var IFCELECTRICFLOWSTORAGEDEVICE = 3310460725;
var IFCELECTRICDISTRIBUTIONBOARD = 862014818;
var IFCELECTRICAPPLIANCE = 1904799276;
var IFCDUCTSILENCER = 1360408905;
var IFCDUCTSEGMENT = 3518393246;
var IFCDUCTFITTING = 342316401;
var IFCDISTRIBUTIONCIRCUIT = 562808652;
var IFCDAMPER = 4074379575;
var IFCCOOLINGTOWER = 3640358203;
var IFCCOOLEDBEAM = 4136498852;
var IFCCONDENSER = 2272882330;
var IFCCOMPRESSOR = 3571504051;
var IFCCOMMUNICATIONSAPPLIANCE = 3221913625;
var IFCCOIL = 639361253;
var IFCCHILLER = 3902619387;
var IFCCABLESEGMENT = 4217484030;
var IFCCABLEFITTING = 1051757585;
var IFCCABLECARRIERSEGMENT = 3758799889;
var IFCCABLECARRIERFITTING = 635142910;
var IFCBURNER = 2938176219;
var IFCBOILER = 32344328;
var IFCBEAMSTANDARDCASE = 2906023776;
var IFCAUDIOVISUALAPPLIANCE = 277319702;
var IFCAIRTOAIRHEATRECOVERY = 2056796094;
var IFCAIRTERMINALBOX = 177149247;
var IFCAIRTERMINAL = 1634111441;
var IFCWINDOWSTANDARDCASE = 486154966;
var IFCWASTETERMINAL = 4237592921;
var IFCWALLELEMENTEDCASE = 4156078855;
var IFCVALVE = 4207607924;
var IFCUNITARYEQUIPMENT = 4292641817;
var IFCUNITARYCONTROLELEMENTTYPE = 3179687236;
var IFCTUBEBUNDLE = 3026737570;
var IFCTRANSFORMER = 3825984169;
var IFCTANK = 812556717;
var IFCSWITCHINGDEVICE = 1162798199;
var IFCSTRUCTURALLOADCASE = 385403989;
var IFCSTACKTERMINAL = 1404847402;
var IFCSPACEHEATER = 1999602285;
var IFCSOLARDEVICE = 3420628829;
var IFCSLABSTANDARDCASE = 3027962421;
var IFCSLABELEMENTEDCASE = 3127900445;
var IFCSHADINGDEVICE = 1329646415;
var IFCSANITARYTERMINAL = 3053780830;
var IFCREINFORCINGBARTYPE = 2572171363;
var IFCRATIONALBSPLINECURVEWITHKNOTS = 1232101972;
var IFCPUMP = 90941305;
var IFCPROTECTIVEDEVICETRIPPINGUNITTYPE = 655969474;
var IFCPROTECTIVEDEVICE = 738039164;
var IFCPLATESTANDARDCASE = 1156407060;
var IFCPIPESEGMENT = 3612865200;
var IFCPIPEFITTING = 310824031;
var IFCOUTLET = 3694346114;
var IFCOUTERBOUNDARYCURVE = 144952367;
var IFCMOTORCONNECTION = 2474470126;
var IFCMEMBERSTANDARDCASE = 1911478936;
var IFCMEDICALDEVICE = 1437502449;
var IFCLIGHTFIXTURE = 629592764;
var IFCLAMP = 76236018;
var IFCJUNCTIONBOX = 2176052936;
var IFCINTERCEPTOR = 4175244083;
var IFCHUMIDIFIER = 2068733104;
var IFCHEATEXCHANGER = 3319311131;
var IFCFLOWMETER = 2188021234;
var IFCEXTERNALSPATIALELEMENT = 1209101575;
var IFCEVAPORATOR = 484807127;
var IFCEVAPORATIVECOOLER = 3747195512;
var IFCENGINE = 2814081492;
var IFCELECTRICDISTRIBUTIONBOARDTYPE = 2417008758;
var IFCDOORSTANDARDCASE = 3242481149;
var IFCDISTRIBUTIONSYSTEM = 3205830791;
var IFCCOMMUNICATIONSAPPLIANCETYPE = 400855858;
var IFCCOLUMNSTANDARDCASE = 905975707;
var IFCCIVILELEMENT = 1677625105;
var IFCCHIMNEY = 3296154744;
var IFCCABLEFITTINGTYPE = 2674252688;
var IFCBURNERTYPE = 2188180465;
var IFCBUILDINGSYSTEM = 1177604601;
var IFCBUILDINGELEMENTPARTTYPE = 39481116;
var IFCBOUNDARYCURVE = 1136057603;
var IFCBSPLINECURVEWITHKNOTS = 2461110595;
var IFCAUDIOVISUALAPPLIANCETYPE = 1532957894;
var IFCWORKCALENDAR = 4088093105;
var IFCWINDOWTYPE = 4009809668;
var IFCVOIDINGFEATURE = 926996030;
var IFCVIBRATIONISOLATOR = 2391383451;
var IFCTENDONTYPE = 2415094496;
var IFCTENDONANCHORTYPE = 3081323446;
var IFCSYSTEMFURNITUREELEMENT = 413509423;
var IFCSURFACEFEATURE = 3101698114;
var IFCSTRUCTURALSURFACEACTION = 3657597509;
var IFCSTRUCTURALCURVEREACTION = 2757150158;
var IFCSTRUCTURALCURVEACTION = 1004757350;
var IFCSTAIRTYPE = 338393293;
var IFCSOLARDEVICETYPE = 1072016465;
var IFCSHADINGDEVICETYPE = 4074543187;
var IFCSEAMCURVE = 2157484638;
var IFCROOFTYPE = 2781568857;
var IFCREINFORCINGMESHTYPE = 2310774935;
var IFCREINFORCINGELEMENTTYPE = 964333572;
var IFCRATIONALBSPLINESURFACEWITHKNOTS = 683857671;
var IFCRAMPTYPE = 1469900589;
var IFCPOLYGONALFACESET = 2839578677;
var IFCPILETYPE = 1158309216;
var IFCOPENINGSTANDARDCASE = 3079942009;
var IFCMEDICALDEVICETYPE = 1114901282;
var IFCINTERSECTIONCURVE = 3113134337;
var IFCINTERCEPTORTYPE = 3946677679;
var IFCINDEXEDPOLYCURVE = 2571569899;
var IFCGEOGRAPHICELEMENT = 3493046030;
var IFCFURNITURE = 1509553395;
var IFCFOOTINGTYPE = 1893162501;
var IFCEXTERNALSPATIALSTRUCTUREELEMENT = 2853485674;
var IFCEVENT = 4148101412;
var IFCENGINETYPE = 132023988;
var IFCELEMENTASSEMBLYTYPE = 2397081782;
var IFCDOORTYPE = 2323601079;
var IFCCYLINDRICALSURFACE = 1213902940;
var IFCCONSTRUCTIONPRODUCTRESOURCETYPE = 1525564444;
var IFCCONSTRUCTIONMATERIALRESOURCETYPE = 4105962743;
var IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE = 2185764099;
var IFCCOMPOSITECURVEONSURFACE = 15328376;
var IFCCOMPLEXPROPERTYTEMPLATE = 3875453745;
var IFCCIVILELEMENTTYPE = 3893394355;
var IFCCHIMNEYTYPE = 2197970202;
var IFCBSPLINESURFACEWITHKNOTS = 167062518;
var IFCBSPLINESURFACE = 2887950389;
var IFCADVANCEDBREPWITHVOIDS = 2603310189;
var IFCADVANCEDBREP = 1635779807;
var IFCTRIANGULATEDFACESET = 2916149573;
var IFCTOROIDALSURFACE = 1935646853;
var IFCTESSELLATEDFACESET = 2387106220;
var IFCTASKTYPE = 3206491090;
var IFCSURFACECURVE = 699246055;
var IFCSUBCONTRACTRESOURCETYPE = 4095615324;
var IFCSTRUCTURALSURFACEREACTION = 603775116;
var IFCSPHERICALSURFACE = 4015995234;
var IFCSPATIALZONETYPE = 2481509218;
var IFCSPATIALZONE = 463610769;
var IFCSPATIALELEMENTTYPE = 710998568;
var IFCSPATIALELEMENT = 1412071761;
var IFCSIMPLEPROPERTYTEMPLATE = 3663146110;
var IFCREVOLVEDAREASOLIDTAPERED = 3243963512;
var IFCREPARAMETRISEDCOMPOSITECURVESEGMENT = 816062949;
var IFCRELSPACEBOUNDARY2NDLEVEL = 1521410863;
var IFCRELSPACEBOUNDARY1STLEVEL = 3523091289;
var IFCRELINTERFERESELEMENTS = 427948657;
var IFCRELDEFINESBYTEMPLATE = 307848117;
var IFCRELDEFINESBYOBJECT = 1462361463;
var IFCRELDECLARES = 2565941209;
var IFCRELASSIGNSTOGROUPBYFACTOR = 1027710054;
var IFCPROPERTYTEMPLATE = 3521284610;
var IFCPROPERTYSETTEMPLATE = 492091185;
var IFCPROJECTLIBRARY = 653396225;
var IFCPROCEDURETYPE = 569719735;
var IFCPREDEFINEDPROPERTYSET = 3967405729;
var IFCPCURVE = 1682466193;
var IFCLABORRESOURCETYPE = 428585644;
var IFCINDEXEDPOLYGONALFACEWITHVOIDS = 2294589976;
var IFCINDEXEDPOLYGONALFACE = 178912537;
var IFCGEOGRAPHICELEMENTTYPE = 4095422895;
var IFCFIXEDREFERENCESWEPTAREASOLID = 2652556860;
var IFCEXTRUDEDAREASOLIDTAPERED = 2804161546;
var IFCEVENTTYPE = 4024345920;
var IFCCURVEBOUNDEDSURFACE = 2629017746;
var IFCCREWRESOURCETYPE = 1815067380;
var IFCCONTEXT = 3419103109;
var IFCCONSTRUCTIONRESOURCETYPE = 2574617495;
var IFCCARTESIANPOINTLIST3D = 2059837836;
var IFCCARTESIANPOINTLIST2D = 1675464909;
var IFCCARTESIANPOINTLIST = 574549367;
var IFCADVANCEDFACE = 3406155212;
var IFCTYPERESOURCE = 3698973494;
var IFCTYPEPROCESS = 3736923433;
var IFCTESSELLATEDITEM = 901063453;
var IFCSWEPTDISKSOLIDPOLYGONAL = 1096409881;
var IFCRESOURCETIME = 1042787934;
var IFCRESOURCECONSTRAINTRELATIONSHIP = 1608871552;
var IFCRESOURCEAPPROVALRELATIONSHIP = 2943643501;
var IFCQUANTITYSET = 2090586900;
var IFCPROPERTYTEMPLATEDEFINITION = 1482703590;
var IFCPREDEFINEDPROPERTIES = 3778827333;
var IFCMIRROREDPROFILEDEF = 2998442950;
var IFCMATERIALRELATIONSHIP = 853536259;
var IFCMATERIALPROFILESETUSAGETAPERING = 3404854881;
var IFCMATERIALPROFILESETUSAGE = 3079605661;
var IFCMATERIALCONSTITUENTSET = 2852063980;
var IFCMATERIALCONSTITUENT = 3708119e3;
var IFCLAGTIME = 1585845231;
var IFCINDEXEDTRIANGLETEXTUREMAP = 2133299955;
var IFCINDEXEDTEXTUREMAP = 1437953363;
var IFCINDEXEDCOLOURMAP = 3570813810;
var IFCEXTERNALREFERENCERELATIONSHIP = 1437805879;
var IFCEXTENDEDPROPERTIES = 297599258;
var IFCEVENTTIME = 211053100;
var IFCCONVERSIONBASEDUNITWITHOFFSET = 2713554722;
var IFCCOLOURRGBLIST = 3285139300;
var IFCWORKTIME = 1236880293;
var IFCTIMEPERIOD = 1199560280;
var IFCTEXTUREVERTEXLIST = 3611470254;
var IFCTASKTIMERECURRING = 2771591690;
var IFCTASKTIME = 1549132990;
var IFCTABLECOLUMN = 2043862942;
var IFCSURFACEREINFORCEMENTAREA = 2934153892;
var IFCSTRUCTURALLOADORRESULT = 609421318;
var IFCSTRUCTURALLOADCONFIGURATION = 3478079324;
var IFCSCHEDULINGTIME = 1054537805;
var IFCRESOURCELEVELRELATIONSHIP = 2439245199;
var IFCREFERENCE = 2433181523;
var IFCRECURRENCEPATTERN = 3915482550;
var IFCPROPERTYABSTRACTION = 986844984;
var IFCPROJECTEDCRS = 3843373140;
var IFCPRESENTATIONITEM = 677532197;
var IFCMATERIALUSAGEDEFINITION = 1507914824;
var IFCMATERIALPROFILEWITHOFFSETS = 552965576;
var IFCMATERIALPROFILESET = 164193824;
var IFCMATERIALPROFILE = 2235152071;
var IFCMATERIALLAYERWITHOFFSETS = 1847252529;
var IFCMATERIALDEFINITION = 760658860;
var IFCMAPCONVERSION = 3057273783;
var IFCEXTERNALINFORMATION = 4294318154;
var IFCCOORDINATEREFERENCESYSTEM = 1466758467;
var IFCCOORDINATEOPERATION = 1785450214;
var IFCCONNECTIONVOLUMEGEOMETRY = 775493141;
var IFCREINFORCINGBAR = 979691226;
var IFCELECTRICDISTRIBUTIONPOINT = 3700593921;
var IFCDISTRIBUTIONCONTROLELEMENT = 1062813311;
var IFCDISTRIBUTIONCHAMBERELEMENT = 1052013943;
var IFCCONTROLLERTYPE = 578613899;
var IFCCHAMFEREDGEFEATURE = 2454782716;
var IFCBEAM = 753842376;
var IFCALARMTYPE = 3001207471;
var IFCACTUATORTYPE = 2874132201;
var IFCWINDOW = 3304561284;
var IFCWALLSTANDARDCASE = 3512223829;
var IFCWALL = 2391406946;
var IFCVIBRATIONISOLATORTYPE = 3313531582;
var IFCTENDONANCHOR = 2347447852;
var IFCTENDON = 3824725483;
var IFCSTRUCTURALANALYSISMODEL = 2515109513;
var IFCSTAIRFLIGHT = 4252922144;
var IFCSTAIR = 331165859;
var IFCSLAB = 1529196076;
var IFCSENSORTYPE = 1783015770;
var IFCROUNDEDEDGEFEATURE = 1376911519;
var IFCROOF = 2016517767;
var IFCREINFORCINGMESH = 2320036040;
var IFCREINFORCINGELEMENT = 3027567501;
var IFCRATIONALBEZIERCURVE = 3055160366;
var IFCRAMPFLIGHT = 3283111854;
var IFCRAMP = 3024970846;
var IFCRAILING = 2262370178;
var IFCPLATE = 3171933400;
var IFCPILE = 1687234759;
var IFCMEMBER = 1073191201;
var IFCFOOTING = 900683007;
var IFCFLOWTREATMENTDEVICE = 3508470533;
var IFCFLOWTERMINAL = 2223149337;
var IFCFLOWSTORAGEDEVICE = 707683696;
var IFCFLOWSEGMENT = 987401354;
var IFCFLOWMOVINGDEVICE = 3132237377;
var IFCFLOWINSTRUMENTTYPE = 4037862832;
var IFCFLOWFITTING = 4278956645;
var IFCFLOWCONTROLLER = 2058353004;
var IFCFIRESUPPRESSIONTERMINALTYPE = 4222183408;
var IFCFILTERTYPE = 1810631287;
var IFCFANTYPE = 346874300;
var IFCENERGYCONVERSIONDEVICE = 1658829314;
var IFCELECTRICALELEMENT = 857184966;
var IFCELECTRICALCIRCUIT = 1634875225;
var IFCELECTRICTIMECONTROLTYPE = 712377611;
var IFCELECTRICMOTORTYPE = 1217240411;
var IFCELECTRICHEATERTYPE = 1365060375;
var IFCELECTRICGENERATORTYPE = 1534661035;
var IFCELECTRICFLOWSTORAGEDEVICETYPE = 3277789161;
var IFCELECTRICAPPLIANCETYPE = 663422040;
var IFCEDGEFEATURE = 855621170;
var IFCDUCTSILENCERTYPE = 2030761528;
var IFCDUCTSEGMENTTYPE = 3760055223;
var IFCDUCTFITTINGTYPE = 869906466;
var IFCDOOR = 395920057;
var IFCDISTRIBUTIONPORT = 3041715199;
var IFCDISTRIBUTIONFLOWELEMENT = 3040386961;
var IFCDISTRIBUTIONELEMENT = 1945004755;
var IFCDISTRIBUTIONCONTROLELEMENTTYPE = 2063403501;
var IFCDISTRIBUTIONCHAMBERELEMENTTYPE = 1599208980;
var IFCDISCRETEACCESSORYTYPE = 2635815018;
var IFCDISCRETEACCESSORY = 1335981549;
var IFCDIAMETERDIMENSION = 4147604152;
var IFCDAMPERTYPE = 3961806047;
var IFCCURTAINWALL = 3495092785;
var IFCCOVERING = 1973544240;
var IFCCOOLINGTOWERTYPE = 2954562838;
var IFCCOOLEDBEAMTYPE = 335055490;
var IFCCONSTRUCTIONPRODUCTRESOURCE = 488727124;
var IFCCONSTRUCTIONMATERIALRESOURCE = 1060000209;
var IFCCONSTRUCTIONEQUIPMENTRESOURCE = 3898045240;
var IFCCONDITIONCRITERION = 1163958913;
var IFCCONDITION = 2188551683;
var IFCCONDENSERTYPE = 2816379211;
var IFCCOMPRESSORTYPE = 3850581409;
var IFCCOLUMN = 843113511;
var IFCCOILTYPE = 2301859152;
var IFCCIRCLE = 2611217952;
var IFCCHILLERTYPE = 2951183804;
var IFCCABLESEGMENTTYPE = 1285652485;
var IFCCABLECARRIERSEGMENTTYPE = 3293546465;
var IFCCABLECARRIERFITTINGTYPE = 395041908;
var IFCBUILDINGELEMENTPROXYTYPE = 1909888760;
var IFCBUILDINGELEMENTPROXY = 1095909175;
var IFCBUILDINGELEMENTPART = 2979338954;
var IFCBUILDINGELEMENTCOMPONENT = 52481810;
var IFCBUILDINGELEMENT = 3299480353;
var IFCBOILERTYPE = 231477066;
var IFCBEZIERCURVE = 1916977116;
var IFCBEAMTYPE = 819618141;
var IFCBSPLINECURVE = 1967976161;
var IFCASSET = 3460190687;
var IFCANGULARDIMENSION = 2470393545;
var IFCAIRTOAIRHEATRECOVERYTYPE = 1871374353;
var IFCAIRTERMINALTYPE = 3352864051;
var IFCAIRTERMINALBOXTYPE = 1411407467;
var IFCACTIONREQUEST = 3821786052;
var IFC2DCOMPOSITECURVE = 1213861670;
var IFCZONE = 1033361043;
var IFCWORKSCHEDULE = 3342526732;
var IFCWORKPLAN = 4218914973;
var IFCWORKCONTROL = 1028945134;
var IFCWASTETERMINALTYPE = 1133259667;
var IFCWALLTYPE = 1898987631;
var IFCVIRTUALELEMENT = 2769231204;
var IFCVALVETYPE = 728799441;
var IFCUNITARYEQUIPMENTTYPE = 1911125066;
var IFCTUBEBUNDLETYPE = 1600972822;
var IFCTRIMMEDCURVE = 3593883385;
var IFCTRANSPORTELEMENT = 1620046519;
var IFCTRANSFORMERTYPE = 1692211062;
var IFCTIMESERIESSCHEDULE = 1637806684;
var IFCTANKTYPE = 5716631;
var IFCSYSTEM = 2254336722;
var IFCSWITCHINGDEVICETYPE = 2315554128;
var IFCSUBCONTRACTRESOURCE = 148013059;
var IFCSTRUCTURALSURFACECONNECTION = 1975003073;
var IFCSTRUCTURALRESULTGROUP = 2986769608;
var IFCSTRUCTURALPOINTREACTION = 1235345126;
var IFCSTRUCTURALPOINTCONNECTION = 734778138;
var IFCSTRUCTURALPOINTACTION = 2082059205;
var IFCSTRUCTURALPLANARACTIONVARYING = 3987759626;
var IFCSTRUCTURALPLANARACTION = 1621171031;
var IFCSTRUCTURALLOADGROUP = 1252848954;
var IFCSTRUCTURALLINEARACTIONVARYING = 1721250024;
var IFCSTRUCTURALLINEARACTION = 1807405624;
var IFCSTRUCTURALCURVEMEMBERVARYING = 2445595289;
var IFCSTRUCTURALCURVEMEMBER = 214636428;
var IFCSTRUCTURALCURVECONNECTION = 4243806635;
var IFCSTRUCTURALCONNECTION = 1179482911;
var IFCSTRUCTURALACTION = 682877961;
var IFCSTAIRFLIGHTTYPE = 1039846685;
var IFCSTACKTERMINALTYPE = 3112655638;
var IFCSPACETYPE = 3812236995;
var IFCSPACEPROGRAM = 652456506;
var IFCSPACEHEATERTYPE = 1305183839;
var IFCSPACE = 3856911033;
var IFCSLABTYPE = 2533589738;
var IFCSITE = 4097777520;
var IFCSERVICELIFE = 4105383287;
var IFCSCHEDULETIMECONTROL = 3517283431;
var IFCSANITARYTERMINALTYPE = 1768891740;
var IFCRELASSIGNSTASKS = 2863920197;
var IFCRELAGGREGATES = 160246688;
var IFCRAMPFLIGHTTYPE = 2324767716;
var IFCRAILINGTYPE = 2893384427;
var IFCRADIUSDIMENSION = 3248260540;
var IFCPUMPTYPE = 2250791053;
var IFCPROTECTIVEDEVICETYPE = 1842657554;
var IFCPROJECTIONELEMENT = 3651124850;
var IFCPROJECTORDERRECORD = 3642467123;
var IFCPROJECTORDER = 2904328755;
var IFCPROCEDURE = 2744685151;
var IFCPORT = 3740093272;
var IFCPOLYLINE = 3724593414;
var IFCPLATETYPE = 4017108033;
var IFCPIPESEGMENTTYPE = 4231323485;
var IFCPIPEFITTINGTYPE = 804291784;
var IFCPERMIT = 3327091369;
var IFCPERFORMANCEHISTORY = 2382730787;
var IFCOUTLETTYPE = 2837617999;
var IFCORDERACTION = 3425660407;
var IFCOPENINGELEMENT = 3588315303;
var IFCOCCUPANT = 4143007308;
var IFCMOVE = 1916936684;
var IFCMOTORCONNECTIONTYPE = 977012517;
var IFCMEMBERTYPE = 3181161470;
var IFCMECHANICALFASTENERTYPE = 2108223431;
var IFCMECHANICALFASTENER = 377706215;
var IFCLINEARDIMENSION = 2506943328;
var IFCLIGHTFIXTURETYPE = 1161773419;
var IFCLAMPTYPE = 1051575348;
var IFCLABORRESOURCE = 3827777499;
var IFCJUNCTIONBOXTYPE = 4288270099;
var IFCINVENTORY = 2391368822;
var IFCHUMIDIFIERTYPE = 1806887404;
var IFCHEATEXCHANGERTYPE = 1251058090;
var IFCGROUP = 2706460486;
var IFCGRID = 3009204131;
var IFCGASTERMINALTYPE = 200128114;
var IFCFURNITURESTANDARD = 814719939;
var IFCFURNISHINGELEMENT = 263784265;
var IFCFLOWTREATMENTDEVICETYPE = 3009222698;
var IFCFLOWTERMINALTYPE = 2297155007;
var IFCFLOWSTORAGEDEVICETYPE = 1339347760;
var IFCFLOWSEGMENTTYPE = 1834744321;
var IFCFLOWMOVINGDEVICETYPE = 1482959167;
var IFCFLOWMETERTYPE = 3815607619;
var IFCFLOWFITTINGTYPE = 3198132628;
var IFCFLOWCONTROLLERTYPE = 3907093117;
var IFCFEATUREELEMENTSUBTRACTION = 1287392070;
var IFCFEATUREELEMENTADDITION = 2143335405;
var IFCFEATUREELEMENT = 2827207264;
var IFCFASTENERTYPE = 2489546625;
var IFCFASTENER = 647756555;
var IFCFACETEDBREPWITHVOIDS = 3737207727;
var IFCFACETEDBREP = 807026263;
var IFCEVAPORATORTYPE = 3390157468;
var IFCEVAPORATIVECOOLERTYPE = 3174744832;
var IFCEQUIPMENTSTANDARD = 3272907226;
var IFCEQUIPMENTELEMENT = 1962604670;
var IFCENERGYCONVERSIONDEVICETYPE = 2107101300;
var IFCELLIPSE = 1704287377;
var IFCELEMENTCOMPONENTTYPE = 2590856083;
var IFCELEMENTCOMPONENT = 1623761950;
var IFCELEMENTASSEMBLY = 4123344466;
var IFCELEMENT = 1758889154;
var IFCELECTRICALBASEPROPERTIES = 360485395;
var IFCDISTRIBUTIONFLOWELEMENTTYPE = 3849074793;
var IFCDISTRIBUTIONELEMENTTYPE = 3256556792;
var IFCDIMENSIONCURVEDIRECTEDCALLOUT = 681481545;
var IFCCURTAINWALLTYPE = 1457835157;
var IFCCREWRESOURCE = 3295246426;
var IFCCOVERINGTYPE = 1916426348;
var IFCCOSTSCHEDULE = 1419761937;
var IFCCOSTITEM = 3895139033;
var IFCCONTROL = 3293443760;
var IFCCONSTRUCTIONRESOURCE = 2559216714;
var IFCCONIC = 2510884976;
var IFCCOMPOSITECURVE = 3732776249;
var IFCCOLUMNTYPE = 300633059;
var IFCCIRCLEHOLLOWPROFILEDEF = 2937912522;
var IFCBUILDINGSTOREY = 3124254112;
var IFCBUILDINGELEMENTTYPE = 1950629157;
var IFCBUILDING = 4031249490;
var IFCBOUNDEDCURVE = 1260505505;
var IFCBOOLEANCLIPPINGRESULT = 3649129432;
var IFCBLOCK = 1334484129;
var IFCASYMMETRICISHAPEPROFILEDEF = 3207858831;
var IFCANNOTATION = 1674181508;
var IFCACTOR = 2296667514;
var IFCTRANSPORTELEMENTTYPE = 2097647324;
var IFCTASK = 3473067441;
var IFCSYSTEMFURNITUREELEMENTTYPE = 1580310250;
var IFCSURFACEOFREVOLUTION = 4124788165;
var IFCSURFACEOFLINEAREXTRUSION = 2809605785;
var IFCSURFACECURVESWEPTAREASOLID = 2028607225;
var IFCSTRUCTUREDDIMENSIONCALLOUT = 4070609034;
var IFCSTRUCTURALSURFACEMEMBERVARYING = 2218152070;
var IFCSTRUCTURALSURFACEMEMBER = 3979015343;
var IFCSTRUCTURALREACTION = 3689010777;
var IFCSTRUCTURALMEMBER = 530289379;
var IFCSTRUCTURALITEM = 3136571912;
var IFCSTRUCTURALACTIVITY = 3544373492;
var IFCSPHERE = 451544542;
var IFCSPATIALSTRUCTUREELEMENTTYPE = 3893378262;
var IFCSPATIALSTRUCTUREELEMENT = 2706606064;
var IFCRIGHTCIRCULARCYLINDER = 3626867408;
var IFCRIGHTCIRCULARCONE = 4158566097;
var IFCREVOLVEDAREASOLID = 1856042241;
var IFCRESOURCE = 2914609552;
var IFCRELVOIDSELEMENT = 1401173127;
var IFCRELSPACEBOUNDARY = 3451746338;
var IFCRELSERVICESBUILDINGS = 366585022;
var IFCRELSEQUENCE = 4122056220;
var IFCRELSCHEDULESCOSTITEMS = 1058617721;
var IFCRELREFERENCEDINSPATIALSTRUCTURE = 1245217292;
var IFCRELPROJECTSELEMENT = 750771296;
var IFCRELOVERRIDESPROPERTIES = 202636808;
var IFCRELOCCUPIESSPACES = 2051452291;
var IFCRELNESTS = 3268803585;
var IFCRELINTERACTIONREQUIREMENTS = 4189434867;
var IFCRELFLOWCONTROLELEMENTS = 279856033;
var IFCRELFILLSELEMENT = 3940055652;
var IFCRELDEFINESBYTYPE = 781010003;
var IFCRELDEFINESBYPROPERTIES = 4186316022;
var IFCRELDEFINES = 693640335;
var IFCRELDECOMPOSES = 2551354335;
var IFCRELCOVERSSPACES = 2802773753;
var IFCRELCOVERSBLDGELEMENTS = 886880790;
var IFCRELCONTAINEDINSPATIALSTRUCTURE = 3242617779;
var IFCRELCONNECTSWITHREALIZINGELEMENTS = 3678494232;
var IFCRELCONNECTSWITHECCENTRICITY = 504942748;
var IFCRELCONNECTSSTRUCTURALMEMBER = 1638771189;
var IFCRELCONNECTSSTRUCTURALELEMENT = 3912681535;
var IFCRELCONNECTSSTRUCTURALACTIVITY = 2127690289;
var IFCRELCONNECTSPORTS = 3190031847;
var IFCRELCONNECTSPORTTOELEMENT = 4201705270;
var IFCRELCONNECTSPATHELEMENTS = 3945020480;
var IFCRELCONNECTSELEMENTS = 1204542856;
var IFCRELCONNECTS = 826625072;
var IFCRELASSOCIATESPROFILEPROPERTIES = 2851387026;
var IFCRELASSOCIATESMATERIAL = 2655215786;
var IFCRELASSOCIATESLIBRARY = 3840914261;
var IFCRELASSOCIATESDOCUMENT = 982818633;
var IFCRELASSOCIATESCONSTRAINT = 2728634034;
var IFCRELASSOCIATESCLASSIFICATION = 919958153;
var IFCRELASSOCIATESAPPROVAL = 4095574036;
var IFCRELASSOCIATESAPPLIEDVALUE = 1327628568;
var IFCRELASSOCIATES = 1865459582;
var IFCRELASSIGNSTORESOURCE = 205026976;
var IFCRELASSIGNSTOPROJECTORDER = 3372526763;
var IFCRELASSIGNSTOPRODUCT = 2857406711;
var IFCRELASSIGNSTOPROCESS = 4278684876;
var IFCRELASSIGNSTOGROUP = 1307041759;
var IFCRELASSIGNSTOCONTROL = 2495723537;
var IFCRELASSIGNSTOACTOR = 1683148259;
var IFCRELASSIGNS = 3939117080;
var IFCRECTANGULARTRIMMEDSURFACE = 3454111270;
var IFCRECTANGULARPYRAMID = 2798486643;
var IFCRECTANGLEHOLLOWPROFILEDEF = 2770003689;
var IFCPROXY = 3219374653;
var IFCPROPERTYSET = 1451395588;
var IFCPROJECTIONCURVE = 4194566429;
var IFCPROJECT = 103090709;
var IFCPRODUCT = 4208778838;
var IFCPROCESS = 2945172077;
var IFCPLANE = 220341763;
var IFCPLANARBOX = 603570806;
var IFCPERMEABLECOVERINGPROPERTIES = 3566463478;
var IFCOFFSETCURVE3D = 3505215534;
var IFCOFFSETCURVE2D = 3388369263;
var IFCOBJECT = 3888040117;
var IFCMANIFOLDSOLIDBREP = 1425443689;
var IFCLINE = 1281925730;
var IFCLSHAPEPROFILEDEF = 572779678;
var IFCISHAPEPROFILEDEF = 1484403080;
var IFCGEOMETRICCURVESET = 987898635;
var IFCFURNITURETYPE = 1268542332;
var IFCFURNISHINGELEMENTTYPE = 4238390223;
var IFCFLUIDFLOWPROPERTIES = 3455213021;
var IFCFILLAREASTYLETILES = 315944413;
var IFCFILLAREASTYLETILESYMBOLWITHSTYLE = 4203026998;
var IFCFILLAREASTYLEHATCHING = 374418227;
var IFCFACEBASEDSURFACEMODEL = 2047409740;
var IFCEXTRUDEDAREASOLID = 477187591;
var IFCENERGYPROPERTIES = 80994333;
var IFCELLIPSEPROFILEDEF = 2835456948;
var IFCELEMENTARYSURFACE = 2777663545;
var IFCELEMENTTYPE = 339256511;
var IFCELEMENTQUANTITY = 1883228015;
var IFCEDGELOOP = 1472233963;
var IFCDRAUGHTINGPREDEFINEDCURVEFONT = 4006246654;
var IFCDRAUGHTINGPREDEFINEDCOLOUR = 445594917;
var IFCDRAUGHTINGCALLOUT = 3073041342;
var IFCDOORSTYLE = 526551008;
var IFCDOORPANELPROPERTIES = 1714330368;
var IFCDOORLININGPROPERTIES = 2963535650;
var IFCDIRECTION = 32440307;
var IFCDIMENSIONCURVETERMINATOR = 4054601972;
var IFCDIMENSIONCURVE = 606661476;
var IFCDEFINEDSYMBOL = 693772133;
var IFCCURVEBOUNDEDPLANE = 2827736869;
var IFCCURVE = 2601014836;
var IFCCSGSOLID = 2147822146;
var IFCCSGPRIMITIVE3D = 2506170314;
var IFCCRANERAILFSHAPEPROFILEDEF = 194851669;
var IFCCRANERAILASHAPEPROFILEDEF = 4133800736;
var IFCCOMPOSITECURVESEGMENT = 2485617015;
var IFCCLOSEDSHELL = 2205249479;
var IFCCIRCLEPROFILEDEF = 1383045692;
var IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM = 1416205885;
var IFCCARTESIANTRANSFORMATIONOPERATOR3D = 3331915920;
var IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM = 3486308946;
var IFCCARTESIANTRANSFORMATIONOPERATOR2D = 3749851601;
var IFCCARTESIANTRANSFORMATIONOPERATOR = 59481748;
var IFCCARTESIANPOINT = 1123145078;
var IFCCSHAPEPROFILEDEF = 2898889636;
var IFCBOXEDHALFSPACE = 2713105998;
var IFCBOUNDINGBOX = 2581212453;
var IFCBOUNDEDSURFACE = 4182860854;
var IFCBOOLEANRESULT = 2736907675;
var IFCAXIS2PLACEMENT3D = 2740243338;
var IFCAXIS2PLACEMENT2D = 3125803723;
var IFCAXIS1PLACEMENT = 4261334040;
var IFCANNOTATIONSURFACE = 1302238472;
var IFCANNOTATIONFILLAREAOCCURRENCE = 2265737646;
var IFCANNOTATIONFILLAREA = 669184980;
var IFCANNOTATIONCURVEOCCURRENCE = 3288037868;
var IFCZSHAPEPROFILEDEF = 2543172580;
var IFCWINDOWSTYLE = 1299126871;
var IFCWINDOWPANELPROPERTIES = 512836454;
var IFCWINDOWLININGPROPERTIES = 336235671;
var IFCVERTEXLOOP = 2759199220;
var IFCVECTOR = 1417489154;
var IFCUSHAPEPROFILEDEF = 427810014;
var IFCTYPEPRODUCT = 2347495698;
var IFCTYPEOBJECT = 1628702193;
var IFCTWODIRECTIONREPEATFACTOR = 1345879162;
var IFCTRAPEZIUMPROFILEDEF = 2715220739;
var IFCTEXTLITERALWITHEXTENT = 3124975700;
var IFCTEXTLITERAL = 4282788508;
var IFCTERMINATORSYMBOL = 3028897424;
var IFCTSHAPEPROFILEDEF = 3071757647;
var IFCSWEPTSURFACE = 230924584;
var IFCSWEPTDISKSOLID = 1260650574;
var IFCSWEPTAREASOLID = 2247615214;
var IFCSURFACESTYLERENDERING = 1878645084;
var IFCSURFACE = 2513912981;
var IFCSUBEDGE = 2233826070;
var IFCSTRUCTURALSTEELPROFILEPROPERTIES = 3653947884;
var IFCSTRUCTURALPROFILEPROPERTIES = 3843319758;
var IFCSTRUCTURALLOADSINGLEFORCEWARPING = 1190533807;
var IFCSTRUCTURALLOADSINGLEFORCE = 1597423693;
var IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION = 1973038258;
var IFCSTRUCTURALLOADSINGLEDISPLACEMENT = 2473145415;
var IFCSTRUCTURALLOADPLANARFORCE = 2668620305;
var IFCSTRUCTURALLOADLINEARFORCE = 1595516126;
var IFCSPACETHERMALLOADPROPERTIES = 390701378;
var IFCSOUNDVALUE = 1202362311;
var IFCSOUNDPROPERTIES = 2485662743;
var IFCSOLIDMODEL = 723233188;
var IFCSLIPPAGECONNECTIONCONDITION = 2609359061;
var IFCSHELLBASEDSURFACEMODEL = 4124623270;
var IFCSERVICELIFEFACTOR = 2411513650;
var IFCSECTIONEDSPINE = 1509187699;
var IFCROUNDEDRECTANGLEPROFILEDEF = 2778083089;
var IFCRELATIONSHIP = 478536968;
var IFCREINFORCEMENTDEFINITIONPROPERTIES = 3765753017;
var IFCREGULARTIMESERIES = 3413951693;
var IFCRECTANGLEPROFILEDEF = 3615266464;
var IFCPROPERTYTABLEVALUE = 110355661;
var IFCPROPERTYSINGLEVALUE = 3650150729;
var IFCPROPERTYSETDEFINITION = 3357820518;
var IFCPROPERTYREFERENCEVALUE = 941946838;
var IFCPROPERTYLISTVALUE = 2752243245;
var IFCPROPERTYENUMERATEDVALUE = 4166981789;
var IFCPROPERTYDEFINITION = 1680319473;
var IFCPROPERTYBOUNDEDVALUE = 871118103;
var IFCPRODUCTDEFINITIONSHAPE = 673634403;
var IFCPREDEFINEDPOINTMARKERSYMBOL = 179317114;
var IFCPREDEFINEDDIMENSIONSYMBOL = 433424934;
var IFCPREDEFINEDCURVEFONT = 2559016684;
var IFCPREDEFINEDCOLOUR = 759155922;
var IFCPOLYGONALBOUNDEDHALFSPACE = 2775532180;
var IFCPOLYLOOP = 2924175390;
var IFCPOINTONSURFACE = 1423911732;
var IFCPOINTONCURVE = 4022376103;
var IFCPOINT = 2067069095;
var IFCPLANAREXTENT = 1663979128;
var IFCPLACEMENT = 2004835150;
var IFCPIXELTEXTURE = 597895409;
var IFCPHYSICALCOMPLEXQUANTITY = 3021840470;
var IFCPATH = 2519244187;
var IFCPARAMETERIZEDPROFILEDEF = 2529465313;
var IFCORIENTEDEDGE = 1029017970;
var IFCOPENSHELL = 2665983363;
var IFCONEDIRECTIONREPEATFACTOR = 2833995503;
var IFCOBJECTDEFINITION = 219451334;
var IFCMECHANICALCONCRETEMATERIALPROPERTIES = 1430189142;
var IFCMATERIALDEFINITIONREPRESENTATION = 2022407955;
var IFCMAPPEDITEM = 2347385850;
var IFCLOOP = 1008929658;
var IFCLOCALPLACEMENT = 2624227202;
var IFCLIGHTSOURCESPOT = 3422422726;
var IFCLIGHTSOURCEPOSITIONAL = 1520743889;
var IFCLIGHTSOURCEGONIOMETRIC = 4266656042;
var IFCLIGHTSOURCEDIRECTIONAL = 2604431987;
var IFCLIGHTSOURCEAMBIENT = 125510826;
var IFCLIGHTSOURCE = 1402838566;
var IFCIRREGULARTIMESERIES = 3741457305;
var IFCIMAGETEXTURE = 3905492369;
var IFCHYGROSCOPICMATERIALPROPERTIES = 2445078500;
var IFCHALFSPACESOLID = 812098782;
var IFCGRIDPLACEMENT = 178086475;
var IFCGEOMETRICSET = 3590301190;
var IFCGEOMETRICREPRESENTATIONSUBCONTEXT = 4142052618;
var IFCGEOMETRICREPRESENTATIONITEM = 2453401579;
var IFCGEOMETRICREPRESENTATIONCONTEXT = 3448662350;
var IFCGENERALPROFILEPROPERTIES = 1446786286;
var IFCGENERALMATERIALPROPERTIES = 803998398;
var IFCFUELPROPERTIES = 3857492461;
var IFCFILLAREASTYLE = 738692330;
var IFCFAILURECONNECTIONCONDITION = 4219587988;
var IFCFACESURFACE = 3008276851;
var IFCFACEOUTERBOUND = 803316827;
var IFCFACEBOUND = 1809719519;
var IFCFACE = 2556980723;
var IFCEXTENDEDMATERIALPROPERTIES = 1860660968;
var IFCEDGECURVE = 476780140;
var IFCEDGE = 3900360178;
var IFCDRAUGHTINGPREDEFINEDTEXTFONT = 4170525392;
var IFCDOCUMENTREFERENCE = 3732053477;
var IFCDIMENSIONPAIR = 1694125774;
var IFCDIMENSIONCALLOUTRELATIONSHIP = 2273265877;
var IFCDERIVEDPROFILEDEF = 3632507154;
var IFCCURVESTYLE = 3800577675;
var IFCCONVERSIONBASEDUNIT = 2889183280;
var IFCCONTEXTDEPENDENTUNIT = 3050246964;
var IFCCONNECTIONPOINTECCENTRICITY = 45288368;
var IFCCONNECTIONCURVEGEOMETRY = 1981873012;
var IFCCONNECTEDFACESET = 370225590;
var IFCCOMPOSITEPROFILEDEF = 1485152156;
var IFCCOMPLEXPROPERTY = 2542286263;
var IFCCOLOURRGB = 776857604;
var IFCCLASSIFICATIONREFERENCE = 647927063;
var IFCCENTERLINEPROFILEDEF = 3150382593;
var IFCBLOBTEXTURE = 616511568;
var IFCARBITRARYPROFILEDEFWITHVOIDS = 2705031697;
var IFCARBITRARYOPENPROFILEDEF = 1310608509;
var IFCARBITRARYCLOSEDPROFILEDEF = 3798115385;
var IFCANNOTATIONTEXTOCCURRENCE = 2297822566;
var IFCANNOTATIONSYMBOLOCCURRENCE = 3612888222;
var IFCANNOTATIONSURFACEOCCURRENCE = 962685235;
var IFCANNOTATIONOCCURRENCE = 2442683028;
var IFCWATERPROPERTIES = 1065908215;
var IFCVIRTUALGRIDINTERSECTION = 891718957;
var IFCVERTEXPOINT = 1907098498;
var IFCVERTEXBASEDTEXTUREMAP = 3304826586;
var IFCVERTEX = 2799835756;
var IFCUNITASSIGNMENT = 180925521;
var IFCTOPOLOGYREPRESENTATION = 1735638870;
var IFCTOPOLOGICALREPRESENTATIONITEM = 1377556343;
var IFCTIMESERIESVALUE = 581633288;
var IFCTIMESERIESREFERENCERELATIONSHIP = 1718945513;
var IFCTIMESERIES = 3101149627;
var IFCTHERMALMATERIALPROPERTIES = 3317419933;
var IFCTEXTUREVERTEX = 1210645708;
var IFCTEXTUREMAP = 2552916305;
var IFCTEXTURECOORDINATEGENERATOR = 1742049831;
var IFCTEXTURECOORDINATE = 280115917;
var IFCTEXTSTYLEWITHBOXCHARACTERISTICS = 1484833681;
var IFCTEXTSTYLETEXTMODEL = 1640371178;
var IFCTEXTSTYLEFORDEFINEDFONT = 2636378356;
var IFCTEXTSTYLEFONTMODEL = 1983826977;
var IFCTEXTSTYLE = 1447204868;
var IFCTELECOMADDRESS = 912023232;
var IFCTABLEROW = 531007025;
var IFCTABLE = 985171141;
var IFCSYMBOLSTYLE = 1290481447;
var IFCSURFACETEXTURE = 626085974;
var IFCSURFACESTYLEWITHTEXTURES = 1351298697;
var IFCSURFACESTYLESHADING = 846575682;
var IFCSURFACESTYLEREFRACTION = 1607154358;
var IFCSURFACESTYLELIGHTING = 3303107099;
var IFCSURFACESTYLE = 1300840506;
var IFCSTYLEDREPRESENTATION = 3049322572;
var IFCSTYLEDITEM = 3958052878;
var IFCSTYLEMODEL = 2830218821;
var IFCSTRUCTURALLOADTEMPERATURE = 3408363356;
var IFCSTRUCTURALLOADSTATIC = 2525727697;
var IFCSTRUCTURALLOAD = 2162789131;
var IFCSTRUCTURALCONNECTIONCONDITION = 2273995522;
var IFCSIMPLEPROPERTY = 3692461612;
var IFCSHAPEREPRESENTATION = 4240577450;
var IFCSHAPEMODEL = 3982875396;
var IFCSHAPEASPECT = 867548509;
var IFCSECTIONREINFORCEMENTPROPERTIES = 4165799628;
var IFCSECTIONPROPERTIES = 2042790032;
var IFCSIUNIT = 448429030;
var IFCROOT = 2341007311;
var IFCRIBPLATEPROFILEPROPERTIES = 3679540991;
var IFCREPRESENTATIONMAP = 1660063152;
var IFCREPRESENTATIONITEM = 3008791417;
var IFCREPRESENTATIONCONTEXT = 3377609919;
var IFCREPRESENTATION = 1076942058;
var IFCRELAXATION = 1222501353;
var IFCREINFORCEMENTBARPROPERTIES = 1580146022;
var IFCREFERENCESVALUEDOCUMENT = 2692823254;
var IFCQUANTITYWEIGHT = 825690147;
var IFCQUANTITYVOLUME = 2405470396;
var IFCQUANTITYTIME = 3252649465;
var IFCQUANTITYLENGTH = 931644368;
var IFCQUANTITYCOUNT = 2093928680;
var IFCQUANTITYAREA = 2044713172;
var IFCPROPERTYENUMERATION = 3710013099;
var IFCPROPERTYDEPENDENCYRELATIONSHIP = 148025276;
var IFCPROPERTYCONSTRAINTRELATIONSHIP = 3896028662;
var IFCPROPERTY = 2598011224;
var IFCPROFILEPROPERTIES = 2802850158;
var IFCPROFILEDEF = 3958567839;
var IFCPRODUCTSOFCOMBUSTIONPROPERTIES = 2267347899;
var IFCPRODUCTREPRESENTATION = 2095639259;
var IFCPRESENTATIONSTYLEASSIGNMENT = 2417041796;
var IFCPRESENTATIONSTYLE = 3119450353;
var IFCPRESENTATIONLAYERWITHSTYLE = 1304840413;
var IFCPRESENTATIONLAYERASSIGNMENT = 2022622350;
var IFCPREDEFINEDTEXTFONT = 1775413392;
var IFCPREDEFINEDTERMINATORSYMBOL = 3213052703;
var IFCPREDEFINEDSYMBOL = 990879717;
var IFCPREDEFINEDITEM = 3727388367;
var IFCPOSTALADDRESS = 3355820592;
var IFCPHYSICALSIMPLEQUANTITY = 2226359599;
var IFCPHYSICALQUANTITY = 2483315170;
var IFCPERSONANDORGANIZATION = 101040310;
var IFCPERSON = 2077209135;
var IFCOWNERHISTORY = 1207048766;
var IFCORGANIZATIONRELATIONSHIP = 1411181986;
var IFCORGANIZATION = 4251960020;
var IFCOPTICALMATERIALPROPERTIES = 1227763645;
var IFCOBJECTIVE = 2251480897;
var IFCOBJECTPLACEMENT = 3701648758;
var IFCNAMEDUNIT = 1918398963;
var IFCMONETARYUNIT = 2706619895;
var IFCMETRIC = 3368373690;
var IFCMECHANICALSTEELMATERIALPROPERTIES = 677618848;
var IFCMECHANICALMATERIALPROPERTIES = 4256014907;
var IFCMEASUREWITHUNIT = 2597039031;
var IFCMATERIALPROPERTIES = 3265635763;
var IFCMATERIALLIST = 2199411900;
var IFCMATERIALLAYERSETUSAGE = 1303795690;
var IFCMATERIALLAYERSET = 3303938423;
var IFCMATERIALLAYER = 248100487;
var IFCMATERIALCLASSIFICATIONRELATIONSHIP = 1847130766;
var IFCMATERIAL = 1838606355;
var IFCLOCALTIME = 30780891;
var IFCLIGHTINTENSITYDISTRIBUTION = 1566485204;
var IFCLIGHTDISTRIBUTIONDATA = 4162380809;
var IFCLIBRARYREFERENCE = 3452421091;
var IFCLIBRARYINFORMATION = 2655187982;
var IFCIRREGULARTIMESERIESVALUE = 3020489413;
var IFCGRIDAXIS = 852622518;
var IFCEXTERNALLYDEFINEDTEXTFONT = 3548104201;
var IFCEXTERNALLYDEFINEDSYMBOL = 3207319532;
var IFCEXTERNALLYDEFINEDSURFACESTYLE = 1040185647;
var IFCEXTERNALLYDEFINEDHATCHSTYLE = 2242383968;
var IFCEXTERNALREFERENCE = 3200245327;
var IFCENVIRONMENTALIMPACTVALUE = 1648886627;
var IFCDRAUGHTINGCALLOUTRELATIONSHIP = 3796139169;
var IFCDOCUMENTINFORMATIONRELATIONSHIP = 770865208;
var IFCDOCUMENTINFORMATION = 1154170062;
var IFCDOCUMENTELECTRONICFORMAT = 1376555844;
var IFCDIMENSIONALEXPONENTS = 2949456006;
var IFCDERIVEDUNITELEMENT = 1045800335;
var IFCDERIVEDUNIT = 1765591967;
var IFCDATEANDTIME = 1072939445;
var IFCCURVESTYLEFONTPATTERN = 3510044353;
var IFCCURVESTYLEFONTANDSCALING = 2367409068;
var IFCCURVESTYLEFONT = 1105321065;
var IFCCURRENCYRELATIONSHIP = 539742890;
var IFCCOSTVALUE = 602808272;
var IFCCOORDINATEDUNIVERSALTIMEOFFSET = 1065062679;
var IFCCONSTRAINTRELATIONSHIP = 347226245;
var IFCCONSTRAINTCLASSIFICATIONRELATIONSHIP = 613356794;
var IFCCONSTRAINTAGGREGATIONRELATIONSHIP = 1658513725;
var IFCCONSTRAINT = 1959218052;
var IFCCONNECTIONSURFACEGEOMETRY = 2732653382;
var IFCCONNECTIONPORTGEOMETRY = 4257277454;
var IFCCONNECTIONPOINTGEOMETRY = 2614616156;
var IFCCONNECTIONGEOMETRY = 2859738748;
var IFCCOLOURSPECIFICATION = 3264961684;
var IFCCLASSIFICATIONNOTATIONFACET = 3639012971;
var IFCCLASSIFICATIONNOTATION = 938368621;
var IFCCLASSIFICATIONITEMRELATIONSHIP = 1098599126;
var IFCCLASSIFICATIONITEM = 1767535486;
var IFCCLASSIFICATION = 747523909;
var IFCCALENDARDATE = 622194075;
var IFCBOUNDARYNODECONDITIONWARPING = 2069777674;
var IFCBOUNDARYNODECONDITION = 1387855156;
var IFCBOUNDARYFACECONDITION = 3367102660;
var IFCBOUNDARYEDGECONDITION = 1560379544;
var IFCBOUNDARYCONDITION = 4037036970;
var IFCAPPROVALRELATIONSHIP = 3869604511;
var IFCAPPROVALPROPERTYRELATIONSHIP = 390851274;
var IFCAPPROVALACTORRELATIONSHIP = 2080292479;
var IFCAPPROVAL = 130549933;
var IFCAPPLIEDVALUERELATIONSHIP = 1110488051;
var IFCAPPLIEDVALUE = 411424972;
var IFCAPPLICATION = 639542469;
var IFCADDRESS = 618182010;
var IFCACTORROLE = 3630933823;
var FILE_DESCRIPTION = 599546466;
var FILE_NAME = 1390159747;
var FILE_SCHEMA = 1109904537;
var Handle = class {
  constructor(value) {
    this.value = value;
    this.type = 5;
  }
};
var logical = /* @__PURE__ */ ((logical2) => {
  logical2[logical2["FALSE"] = 0] = "FALSE";
  logical2[logical2["TRUE"] = 1] = "TRUE";
  logical2[logical2["UNKNOWN"] = 2] = "UNKNOWN";
  return logical2;
})(logical || {});
var IfcLineObject = class {
  constructor(expressID = -1) {
    this.expressID = expressID;
    this.type = 0;
  }
};
var FromRawLineData = [];
var InversePropertyDef = {};
var InheritanceDef = {};
var Constructors = {};
var ToRawLineData = {};
var TypeInitialisers = {};
var SchemaNames = [];
function TypeInitialiser(schema, tapeItem) {
  if (Array.isArray(tapeItem)) tapeItem.map((p) => TypeInitialiser(schema, p));
  if (tapeItem.typecode) return TypeInitialisers[schema][tapeItem.typecode](tapeItem.value);
  else return tapeItem.value;
}
function Labelise(tapeItem) {
  if (tapeItem.label) return tapeItem;
  else return { value: tapeItem.value.toString(), valueType: tapeItem.type, type: 2, label: tapeItem.name };
}
function BooleanConvert(item) {
  switch (item.toString()) {
    case "true":
      return "T";
    case "false":
      return "F";
    case "0":
      return "F";
    case "1":
      return "T";
    case "2":
      return "U";
  }
}
var Schemas = /* @__PURE__ */ ((Schemas2) => {
  Schemas2["IFC2X3"] = "IFC2X3";
  Schemas2["IFC4"] = "IFC4";
  Schemas2["IFC4X3"] = "IFC4X3";
  return Schemas2;
})(Schemas || {});
SchemaNames[1] = ["IFC2X3", "IFC2X_FINAL"];
FromRawLineData[1] = {
  3630933823: (v) => new IFC2X3.IfcActorRole(v[0], !v[1] && v[1] != "" ? null : new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcText(!v[2] && v[2] != "" ? null : v[2].value)),
  618182010: (v) => new IFC2X3.IfcAddress(v[0], !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  639542469: (v) => new IFC2X3.IfcApplication(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), new IFC2X3.IfcIdentifier(!v[3] && v[3] != "" ? null : v[3].value)),
  411424972: (v) => new IFC2X3.IfcAppliedValue(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  1110488051: (v) => new IFC2X3.IfcAppliedValueRelationship(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[2], !v[3] && v[3] != "" ? null : new IFC2X3.IfcLabel(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcText(!v[4] && v[4] != "" ? null : v[4].value)),
  130549933: (v) => new IFC2X3.IfcApproval(!v[0] && v[0] != "" ? null : new IFC2X3.IfcText(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcLabel(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcText(!v[4] && v[4] != "" ? null : v[4].value), new IFC2X3.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value), new IFC2X3.IfcIdentifier(!v[6] && v[6] != "" ? null : v[6].value)),
  2080292479: (v) => new IFC2X3.IfcApprovalActorRelationship(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  390851274: (v) => new IFC2X3.IfcApprovalPropertyRelationship(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  3869604511: (v) => new IFC2X3.IfcApprovalRelationship(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcText(!v[2] && v[2] != "" ? null : v[2].value), new IFC2X3.IfcLabel(!v[3] && v[3] != "" ? null : v[3].value)),
  4037036970: (v) => new IFC2X3.IfcBoundaryCondition(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  1560379544: (v) => new IFC2X3.IfcBoundaryEdgeCondition(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcModulusOfLinearSubgradeReactionMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcModulusOfLinearSubgradeReactionMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcModulusOfLinearSubgradeReactionMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcModulusOfRotationalSubgradeReactionMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC2X3.IfcModulusOfRotationalSubgradeReactionMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC2X3.IfcModulusOfRotationalSubgradeReactionMeasure(!v[6] && v[6] != "" ? null : v[6].value)),
  3367102660: (v) => new IFC2X3.IfcBoundaryFaceCondition(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcModulusOfSubgradeReactionMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcModulusOfSubgradeReactionMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcModulusOfSubgradeReactionMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  1387855156: (v) => new IFC2X3.IfcBoundaryNodeCondition(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcLinearStiffnessMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLinearStiffnessMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcLinearStiffnessMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcRotationalStiffnessMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC2X3.IfcRotationalStiffnessMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC2X3.IfcRotationalStiffnessMeasure(!v[6] && v[6] != "" ? null : v[6].value)),
  2069777674: (v) => new IFC2X3.IfcBoundaryNodeConditionWarping(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcLinearStiffnessMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLinearStiffnessMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcLinearStiffnessMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcRotationalStiffnessMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC2X3.IfcRotationalStiffnessMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC2X3.IfcRotationalStiffnessMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcWarpingMomentMeasure(!v[7] && v[7] != "" ? null : v[7].value)),
  622194075: (v) => new IFC2X3.IfcCalendarDate(new IFC2X3.IfcDayInMonthNumber(!v[0] && v[0] != "" ? null : v[0].value), new IFC2X3.IfcMonthInYearNumber(!v[1] && v[1] != "" ? null : v[1].value), new IFC2X3.IfcYearNumber(!v[2] && v[2] != "" ? null : v[2].value)),
  747523909: (v) => new IFC2X3.IfcClassification(new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC2X3.IfcLabel(!v[3] && v[3] != "" ? null : v[3].value)),
  1767535486: (v) => new IFC2X3.IfcClassificationItem(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  1098599126: (v) => new IFC2X3.IfcClassificationItemRelationship(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  938368621: (v) => new IFC2X3.IfcClassificationNotation(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3639012971: (v) => new IFC2X3.IfcClassificationNotationFacet(new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  3264961684: (v) => new IFC2X3.IfcColourSpecification(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  2859738748: (_) => new IFC2X3.IfcConnectionGeometry(),
  2614616156: (v) => new IFC2X3.IfcConnectionPointGeometry(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  4257277454: (v) => new IFC2X3.IfcConnectionPortGeometry(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  2732653382: (v) => new IFC2X3.IfcConnectionSurfaceGeometry(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  1959218052: (v) => new IFC2X3.IfcConstraint(new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2], !v[3] && v[3] != "" ? null : new IFC2X3.IfcLabel(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC2X3.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value)),
  1658513725: (v) => new IFC2X3.IfcConstraintAggregationRelationship(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[4]),
  613356794: (v) => new IFC2X3.IfcConstraintClassificationRelationship(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  347226245: (v) => new IFC2X3.IfcConstraintRelationship(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1065062679: (v) => new IFC2X3.IfcCoordinatedUniversalTimeOffset(new IFC2X3.IfcHourInDay(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcMinuteInHour(!v[1] && v[1] != "" ? null : v[1].value), v[2]),
  602808272: (v) => new IFC2X3.IfcCostValue(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), new IFC2X3.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcText(!v[7] && v[7] != "" ? null : v[7].value)),
  539742890: (v) => new IFC2X3.IfcCurrencyRelationship(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), new IFC2X3.IfcPositiveRatioMeasure(!v[2] && v[2] != "" ? null : v[2].value), new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value)),
  1105321065: (v) => new IFC2X3.IfcCurveStyleFont(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2367409068: (v) => new IFC2X3.IfcCurveStyleFontAndScaling(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), new IFC2X3.IfcPositiveRatioMeasure(!v[2] && v[2] != "" ? null : v[2].value)),
  3510044353: (v) => new IFC2X3.IfcCurveStyleFontPattern(new IFC2X3.IfcLengthMeasure(!v[0] && v[0] != "" ? null : v[0].value), new IFC2X3.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value)),
  1072939445: (v) => new IFC2X3.IfcDateAndTime(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  1765591967: (v) => new IFC2X3.IfcDerivedUnit(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[1], !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  1045800335: (v) => new IFC2X3.IfcDerivedUnitElement(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : v[1].value),
  2949456006: (v) => new IFC2X3.IfcDimensionalExponents(!v[0] && v[0] != "" ? null : v[0].value, !v[1] && v[1] != "" ? null : v[1].value, !v[2] && v[2] != "" ? null : v[2].value, !v[3] && v[3] != "" ? null : v[3].value, !v[4] && v[4] != "" ? null : v[4].value, !v[5] && v[5] != "" ? null : v[5].value, !v[6] && v[6] != "" ? null : v[6].value),
  1376555844: (v) => new IFC2X3.IfcDocumentElectronicFormat(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  1154170062: (v) => new IFC2X3.IfcDocumentInformation(new IFC2X3.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcText(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[4] && v[4] != "" ? null : new IFC2X3.IfcText(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC2X3.IfcText(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC2X3.IfcText(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new Handle(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : v[9]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[10] && v[10] != "" ? null : new Handle(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new Handle(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new Handle(!v[12] && v[12] != "" ? null : v[12].value), !v[13] && v[13] != "" ? null : new Handle(!v[13] && v[13] != "" ? null : v[13].value), !v[14] && v[14] != "" ? null : new Handle(!v[14] && v[14] != "" ? null : v[14].value), v[15], v[16]),
  770865208: (v) => new IFC2X3.IfcDocumentInformationRelationship(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  3796139169: (v) => new IFC2X3.IfcDraughtingCalloutRelationship(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  1648886627: (v) => new IFC2X3.IfcEnvironmentalImpactValue(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), new IFC2X3.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), v[7], !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  3200245327: (v) => new IFC2X3.IfcExternalReference(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcIdentifier(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  2242383968: (v) => new IFC2X3.IfcExternallyDefinedHatchStyle(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcIdentifier(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  1040185647: (v) => new IFC2X3.IfcExternallyDefinedSurfaceStyle(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcIdentifier(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  3207319532: (v) => new IFC2X3.IfcExternallyDefinedSymbol(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcIdentifier(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  3548104201: (v) => new IFC2X3.IfcExternallyDefinedTextFont(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcIdentifier(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  852622518: (v) => new IFC2X3.IfcGridAxis(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), new IFC2X3.IfcBoolean(!v[2] && v[2] != "" ? null : v[2].value)),
  3020489413: (v) => new IFC2X3.IfcIrregularTimeSeriesValue(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? TypeInitialiser(1, p) : null) || []),
  2655187982: (v) => new IFC2X3.IfcLibraryInformation(new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3452421091: (v) => new IFC2X3.IfcLibraryReference(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcIdentifier(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  4162380809: (v) => new IFC2X3.IfcLightDistributionData(new IFC2X3.IfcPlaneAngleMeasure(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new IFC2X3.IfcPlaneAngleMeasure(p.value) : null) || [], v[2]?.map((p) => p?.value && p?.value != "" ? new IFC2X3.IfcLuminousIntensityDistributionMeasure(p.value) : null) || []),
  1566485204: (v) => new IFC2X3.IfcLightIntensityDistribution(v[0], v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  30780891: (v) => new IFC2X3.IfcLocalTime(new IFC2X3.IfcHourInDay(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcMinuteInHour(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcSecondInMinute(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcDaylightSavingHour(!v[4] && v[4] != "" ? null : v[4].value)),
  1838606355: (v) => new IFC2X3.IfcMaterial(new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  1847130766: (v) => new IFC2X3.IfcMaterialClassificationRelationship(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  248100487: (v) => new IFC2X3.IfcMaterialLayer(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC2X3.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLogical(!v[2] && v[2] != "" ? null : v[2].value)),
  3303938423: (v) => new IFC2X3.IfcMaterialLayerSet(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[1] && v[1] != "" ? null : new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value)),
  1303795690: (v) => new IFC2X3.IfcMaterialLayerSetUsage(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1], v[2], new IFC2X3.IfcLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  2199411900: (v) => new IFC2X3.IfcMaterialList(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3265635763: (v) => new IFC2X3.IfcMaterialProperties(new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  2597039031: (v) => new IFC2X3.IfcMeasureWithUnit(TypeInitialiser(1, v[0]), new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  4256014907: (v) => new IFC2X3.IfcMechanicalMaterialProperties(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcDynamicViscosityMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcModulusOfElasticityMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcModulusOfElasticityMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcPositiveRatioMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC2X3.IfcThermalExpansionCoefficientMeasure(!v[5] && v[5] != "" ? null : v[5].value)),
  677618848: (v) => new IFC2X3.IfcMechanicalSteelMaterialProperties(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcDynamicViscosityMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcModulusOfElasticityMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcModulusOfElasticityMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcPositiveRatioMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC2X3.IfcThermalExpansionCoefficientMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC2X3.IfcPressureMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcPressureMeasure(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcPositiveRatioMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC2X3.IfcModulusOfElasticityMeasure(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC2X3.IfcPressureMeasure(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC2X3.IfcPositiveRatioMeasure(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : v[12]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3368373690: (v) => new IFC2X3.IfcMetric(new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2], !v[3] && v[3] != "" ? null : new IFC2X3.IfcLabel(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC2X3.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), v[7], !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), new Handle(!v[9] && v[9] != "" ? null : v[9].value)),
  2706619895: (v) => new IFC2X3.IfcMonetaryUnit(v[0]),
  1918398963: (v) => new IFC2X3.IfcNamedUnit(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]),
  3701648758: (_) => new IFC2X3.IfcObjectPlacement(),
  2251480897: (v) => new IFC2X3.IfcObjective(new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2], !v[3] && v[3] != "" ? null : new IFC2X3.IfcLabel(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC2X3.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new Handle(!v[8] && v[8] != "" ? null : v[8].value), v[9], !v[10] && v[10] != "" ? null : new IFC2X3.IfcLabel(!v[10] && v[10] != "" ? null : v[10].value)),
  1227763645: (v) => new IFC2X3.IfcOpticalMaterialProperties(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcPositiveRatioMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcPositiveRatioMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcPositiveRatioMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcPositiveRatioMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC2X3.IfcPositiveRatioMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC2X3.IfcPositiveRatioMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcPositiveRatioMeasure(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcPositiveRatioMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC2X3.IfcPositiveRatioMeasure(!v[9] && v[9] != "" ? null : v[9].value)),
  4251960020: (v) => new IFC2X3.IfcOrganization(!v[0] && v[0] != "" ? null : new IFC2X3.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcText(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[4] && v[4] != "" ? null : v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1411181986: (v) => new IFC2X3.IfcOrganizationRelationship(new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1207048766: (v) => new IFC2X3.IfcOwnerHistory(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), v[2], v[3], !v[4] && v[4] != "" ? null : new IFC2X3.IfcTimeStamp(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), new IFC2X3.IfcTimeStamp(!v[7] && v[7] != "" ? null : v[7].value)),
  2077209135: (v) => new IFC2X3.IfcPerson(!v[0] && v[0] != "" ? null : new IFC2X3.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : v[3]?.map((p) => p?.value && p?.value != "" ? new IFC2X3.IfcLabel(p.value) : null) || [], !v[4] && v[4] != "" ? null : v[4]?.map((p) => p?.value && p?.value != "" ? new IFC2X3.IfcLabel(p.value) : null) || [], !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new IFC2X3.IfcLabel(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  101040310: (v) => new IFC2X3.IfcPersonAndOrganization(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2483315170: (v) => new IFC2X3.IfcPhysicalQuantity(new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value)),
  2226359599: (v) => new IFC2X3.IfcPhysicalSimpleQuantity(new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  3355820592: (v) => new IFC2X3.IfcPostalAddress(v[0], !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcLabel(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : v[4]?.map((p) => p?.value && p?.value != "" ? new IFC2X3.IfcLabel(p.value) : null) || [], !v[5] && v[5] != "" ? null : new IFC2X3.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC2X3.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC2X3.IfcLabel(!v[9] && v[9] != "" ? null : v[9].value)),
  3727388367: (v) => new IFC2X3.IfcPreDefinedItem(new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  990879717: (v) => new IFC2X3.IfcPreDefinedSymbol(new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  3213052703: (v) => new IFC2X3.IfcPreDefinedTerminatorSymbol(new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  1775413392: (v) => new IFC2X3.IfcPreDefinedTextFont(new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  2022622350: (v) => new IFC2X3.IfcPresentationLayerAssignment(new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[3] && v[3] != "" ? null : new IFC2X3.IfcIdentifier(!v[3] && v[3] != "" ? null : v[3].value)),
  1304840413: (v) => new IFC2X3.IfcPresentationLayerWithStyle(new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[3] && v[3] != "" ? null : new IFC2X3.IfcIdentifier(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : v[4].value, !v[5] && v[5] != "" ? null : v[5].value, !v[6] && v[6] != "" ? null : v[6].value, !v[7] && v[7] != "" ? null : v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3119450353: (v) => new IFC2X3.IfcPresentationStyle(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  2417041796: (v) => new IFC2X3.IfcPresentationStyleAssignment(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2095639259: (v) => new IFC2X3.IfcProductRepresentation(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2267347899: (v) => new IFC2X3.IfcProductsOfCombustionProperties(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcSpecificHeatCapacityMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcPositiveRatioMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcPositiveRatioMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcPositiveRatioMeasure(!v[4] && v[4] != "" ? null : v[4].value)),
  3958567839: (v) => new IFC2X3.IfcProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value)),
  2802850158: (v) => new IFC2X3.IfcProfileProperties(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  2598011224: (v) => new IFC2X3.IfcProperty(new IFC2X3.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value)),
  3896028662: (v) => new IFC2X3.IfcPropertyConstraintRelationship(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value)),
  148025276: (v) => new IFC2X3.IfcPropertyDependencyRelationship(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcText(!v[4] && v[4] != "" ? null : v[4].value)),
  3710013099: (v) => new IFC2X3.IfcPropertyEnumeration(new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? TypeInitialiser(1, p) : null) || [], !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  2044713172: (v) => new IFC2X3.IfcQuantityArea(new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC2X3.IfcAreaMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  2093928680: (v) => new IFC2X3.IfcQuantityCount(new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC2X3.IfcCountMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  931644368: (v) => new IFC2X3.IfcQuantityLength(new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC2X3.IfcLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  3252649465: (v) => new IFC2X3.IfcQuantityTime(new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC2X3.IfcTimeMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  2405470396: (v) => new IFC2X3.IfcQuantityVolume(new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC2X3.IfcVolumeMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  825690147: (v) => new IFC2X3.IfcQuantityWeight(new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC2X3.IfcMassMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  2692823254: (v) => new IFC2X3.IfcReferencesValueDocument(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value)),
  1580146022: (v) => new IFC2X3.IfcReinforcementBarProperties(new IFC2X3.IfcAreaMeasure(!v[0] && v[0] != "" ? null : v[0].value), new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), v[2], !v[3] && v[3] != "" ? null : new IFC2X3.IfcLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC2X3.IfcCountMeasure(!v[5] && v[5] != "" ? null : v[5].value)),
  1222501353: (v) => new IFC2X3.IfcRelaxation(new IFC2X3.IfcNormalisedRatioMeasure(!v[0] && v[0] != "" ? null : v[0].value), new IFC2X3.IfcNormalisedRatioMeasure(!v[1] && v[1] != "" ? null : v[1].value)),
  1076942058: (v) => new IFC2X3.IfcRepresentation(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3377609919: (v) => new IFC2X3.IfcRepresentationContext(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value)),
  3008791417: (_) => new IFC2X3.IfcRepresentationItem(),
  1660063152: (v) => new IFC2X3.IfcRepresentationMap(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  3679540991: (v) => new IFC2X3.IfcRibPlateProfileProperties(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), v[6]),
  2341007311: (v) => new IFC2X3.IfcRoot(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value)),
  448429030: (v) => new IFC2X3.IfcSIUnit(v[0], v[1], v[2]),
  2042790032: (v) => new IFC2X3.IfcSectionProperties(v[0], new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  4165799628: (v) => new IFC2X3.IfcSectionReinforcementProperties(new IFC2X3.IfcLengthMeasure(!v[0] && v[0] != "" ? null : v[0].value), new IFC2X3.IfcLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), v[3], new Handle(!v[4] && v[4] != "" ? null : v[4].value), v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  867548509: (v) => new IFC2X3.IfcShapeAspect(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[1] && v[1] != "" ? null : new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcText(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : v[3].value, new Handle(!v[4] && v[4] != "" ? null : v[4].value)),
  3982875396: (v) => new IFC2X3.IfcShapeModel(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  4240577450: (v) => new IFC2X3.IfcShapeRepresentation(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3692461612: (v) => new IFC2X3.IfcSimpleProperty(new IFC2X3.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value)),
  2273995522: (v) => new IFC2X3.IfcStructuralConnectionCondition(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  2162789131: (v) => new IFC2X3.IfcStructuralLoad(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  2525727697: (v) => new IFC2X3.IfcStructuralLoadStatic(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  3408363356: (v) => new IFC2X3.IfcStructuralLoadTemperature(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcThermodynamicTemperatureMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcThermodynamicTemperatureMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcThermodynamicTemperatureMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  2830218821: (v) => new IFC2X3.IfcStyleModel(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3958052878: (v) => new IFC2X3.IfcStyledItem(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  3049322572: (v) => new IFC2X3.IfcStyledRepresentation(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1300840506: (v) => new IFC2X3.IfcSurfaceStyle(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), v[1], v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3303107099: (v) => new IFC2X3.IfcSurfaceStyleLighting(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  1607154358: (v) => new IFC2X3.IfcSurfaceStyleRefraction(!v[0] && v[0] != "" ? null : new IFC2X3.IfcReal(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcReal(!v[1] && v[1] != "" ? null : v[1].value)),
  846575682: (v) => new IFC2X3.IfcSurfaceStyleShading(new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  1351298697: (v) => new IFC2X3.IfcSurfaceStyleWithTextures(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  626085974: (v) => new IFC2X3.IfcSurfaceTexture(!v[0] && v[0] != "" ? null : v[0].value, !v[1] && v[1] != "" ? null : v[1].value, v[2], !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  1290481447: (v) => new IFC2X3.IfcSymbolStyle(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), TypeInitialiser(1, v[1])),
  985171141: (v) => new IFC2X3.IfcTable(!v[0] && v[0] != "" ? null : v[0].value, v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  531007025: (v) => new IFC2X3.IfcTableRow(v[0]?.map((p) => p?.value && p?.value != "" ? TypeInitialiser(1, p) : null) || [], !v[1] && v[1] != "" ? null : v[1].value),
  912023232: (v) => new IFC2X3.IfcTelecomAddress(v[0], !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : v[3]?.map((p) => p?.value && p?.value != "" ? new IFC2X3.IfcLabel(p.value) : null) || [], !v[4] && v[4] != "" ? null : v[4]?.map((p) => p?.value && p?.value != "" ? new IFC2X3.IfcLabel(p.value) : null) || [], !v[5] && v[5] != "" ? null : new IFC2X3.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new IFC2X3.IfcLabel(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value)),
  1447204868: (v) => new IFC2X3.IfcTextStyle(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  1983826977: (v) => new IFC2X3.IfcTextStyleFontModel(new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : v[1]?.map((p) => p?.value && p?.value != "" ? new IFC2X3.IfcTextFontName(p.value) : null) || [], !v[2] && v[2] != "" ? null : new IFC2X3.IfcFontStyle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcFontVariant(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcFontWeight(!v[4] && v[4] != "" ? null : v[4].value), TypeInitialiser(1, v[5])),
  2636378356: (v) => new IFC2X3.IfcTextStyleForDefinedFont(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  1640371178: (v) => new IFC2X3.IfcTextStyleTextModel(!v[0] && v[0] != "" ? null : TypeInitialiser(1, v[0]), !v[1] && v[1] != "" ? null : new IFC2X3.IfcTextAlignment(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcTextDecoration(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : TypeInitialiser(1, v[3]), !v[4] && v[4] != "" ? null : TypeInitialiser(1, v[4]), !v[5] && v[5] != "" ? null : new IFC2X3.IfcTextTransformation(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : TypeInitialiser(1, v[6])),
  1484833681: (v) => new IFC2X3.IfcTextStyleWithBoxCharacteristics(!v[0] && v[0] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcPlaneAngleMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcPlaneAngleMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : TypeInitialiser(1, v[4])),
  280115917: (_) => new IFC2X3.IfcTextureCoordinate(),
  1742049831: (v) => new IFC2X3.IfcTextureCoordinateGenerator(new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? TypeInitialiser(1, p) : null) || []),
  2552916305: (v) => new IFC2X3.IfcTextureMap(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1210645708: (v) => new IFC2X3.IfcTextureVertex(v[0]?.map((p) => p?.value && p?.value != "" ? new IFC2X3.IfcParameterValue(p.value) : null) || []),
  3317419933: (v) => new IFC2X3.IfcThermalMaterialProperties(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcSpecificHeatCapacityMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcThermodynamicTemperatureMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcThermodynamicTemperatureMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcThermalConductivityMeasure(!v[4] && v[4] != "" ? null : v[4].value)),
  3101149627: (v) => new IFC2X3.IfcTimeSeries(new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new Handle(!v[3] && v[3] != "" ? null : v[3].value), v[4], v[5], !v[6] && v[6] != "" ? null : new IFC2X3.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value)),
  1718945513: (v) => new IFC2X3.IfcTimeSeriesReferenceRelationship(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  581633288: (v) => new IFC2X3.IfcTimeSeriesValue(v[0]?.map((p) => p?.value && p?.value != "" ? TypeInitialiser(1, p) : null) || []),
  1377556343: (_) => new IFC2X3.IfcTopologicalRepresentationItem(),
  1735638870: (v) => new IFC2X3.IfcTopologyRepresentation(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  180925521: (v) => new IFC2X3.IfcUnitAssignment(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2799835756: (_) => new IFC2X3.IfcVertex(),
  3304826586: (v) => new IFC2X3.IfcVertexBasedTextureMap(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1907098498: (v) => new IFC2X3.IfcVertexPoint(new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  891718957: (v) => new IFC2X3.IfcVirtualGridIntersection(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[1]?.map((p) => p?.value && p?.value != "" ? new IFC2X3.IfcLengthMeasure(p.value) : null) || []),
  1065908215: (v) => new IFC2X3.IfcWaterProperties(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : !v[1] && v[1] != "" ? null : v[1].value, !v[2] && v[2] != "" ? null : new IFC2X3.IfcIonConcentrationMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcIonConcentrationMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcIonConcentrationMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC2X3.IfcNormalisedRatioMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC2X3.IfcPHMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcNormalisedRatioMeasure(!v[7] && v[7] != "" ? null : v[7].value)),
  2442683028: (v) => new IFC2X3.IfcAnnotationOccurrence(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  962685235: (v) => new IFC2X3.IfcAnnotationSurfaceOccurrence(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  3612888222: (v) => new IFC2X3.IfcAnnotationSymbolOccurrence(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  2297822566: (v) => new IFC2X3.IfcAnnotationTextOccurrence(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  3798115385: (v) => new IFC2X3.IfcArbitraryClosedProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  1310608509: (v) => new IFC2X3.IfcArbitraryOpenProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  2705031697: (v) => new IFC2X3.IfcArbitraryProfileDefWithVoids(v[0], !v[1] && v[1] != "" ? null : new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  616511568: (v) => new IFC2X3.IfcBlobTexture(!v[0] && v[0] != "" ? null : v[0].value, !v[1] && v[1] != "" ? null : v[1].value, v[2], !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value), new IFC2X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5].value),
  3150382593: (v) => new IFC2X3.IfcCenterLineProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC2X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  647927063: (v) => new IFC2X3.IfcClassificationReference(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcIdentifier(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  776857604: (v) => new IFC2X3.IfcColourRgb(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), new IFC2X3.IfcNormalisedRatioMeasure(!v[1] && v[1] != "" ? null : v[1].value), new IFC2X3.IfcNormalisedRatioMeasure(!v[2] && v[2] != "" ? null : v[2].value), new IFC2X3.IfcNormalisedRatioMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  2542286263: (v) => new IFC2X3.IfcComplexProperty(new IFC2X3.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), new IFC2X3.IfcIdentifier(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1485152156: (v) => new IFC2X3.IfcCompositeProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[3] && v[3] != "" ? null : new IFC2X3.IfcLabel(!v[3] && v[3] != "" ? null : v[3].value)),
  370225590: (v) => new IFC2X3.IfcConnectedFaceSet(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1981873012: (v) => new IFC2X3.IfcConnectionCurveGeometry(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  45288368: (v) => new IFC2X3.IfcConnectionPointEccentricity(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value)),
  3050246964: (v) => new IFC2X3.IfcContextDependentUnit(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1], new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  2889183280: (v) => new IFC2X3.IfcConversionBasedUnit(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1], new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  3800577675: (v) => new IFC2X3.IfcCurveStyle(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : TypeInitialiser(1, v[2]), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  3632507154: (v) => new IFC2X3.IfcDerivedProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  2273265877: (v) => new IFC2X3.IfcDimensionCalloutRelationship(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  1694125774: (v) => new IFC2X3.IfcDimensionPair(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  3732053477: (v) => new IFC2X3.IfcDocumentReference(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcIdentifier(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  4170525392: (v) => new IFC2X3.IfcDraughtingPreDefinedTextFont(new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  3900360178: (v) => new IFC2X3.IfcEdge(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  476780140: (v) => new IFC2X3.IfcEdgeCurve(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : v[3].value),
  1860660968: (v) => new IFC2X3.IfcExtendedMaterialProperties(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[2] && v[2] != "" ? null : new IFC2X3.IfcText(!v[2] && v[2] != "" ? null : v[2].value), new IFC2X3.IfcLabel(!v[3] && v[3] != "" ? null : v[3].value)),
  2556980723: (v) => new IFC2X3.IfcFace(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1809719519: (v) => new IFC2X3.IfcFaceBound(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : v[1].value),
  803316827: (v) => new IFC2X3.IfcFaceOuterBound(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : v[1].value),
  3008276851: (v) => new IFC2X3.IfcFaceSurface(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : v[2].value),
  4219587988: (v) => new IFC2X3.IfcFailureConnectionCondition(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcForceMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcForceMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcForceMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcForceMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC2X3.IfcForceMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC2X3.IfcForceMeasure(!v[6] && v[6] != "" ? null : v[6].value)),
  738692330: (v) => new IFC2X3.IfcFillAreaStyle(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3857492461: (v) => new IFC2X3.IfcFuelProperties(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcThermodynamicTemperatureMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcPositiveRatioMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcHeatingValueMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcHeatingValueMeasure(!v[4] && v[4] != "" ? null : v[4].value)),
  803998398: (v) => new IFC2X3.IfcGeneralMaterialProperties(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcMolecularWeightMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcNormalisedRatioMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcMassDensityMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  1446786286: (v) => new IFC2X3.IfcGeneralProfileProperties(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcMassPerLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC2X3.IfcAreaMeasure(!v[6] && v[6] != "" ? null : v[6].value)),
  3448662350: (v) => new IFC2X3.IfcGeometricRepresentationContext(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new IFC2X3.IfcDimensionCount(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : !v[3] && v[3] != "" ? null : v[3].value, new Handle(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  2453401579: (_) => new IFC2X3.IfcGeometricRepresentationItem(),
  4142052618: (v) => new IFC2X3.IfcGeometricRepresentationSubContext(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcPositiveRatioMeasure(!v[3] && v[3] != "" ? null : v[3].value), v[4], !v[5] && v[5] != "" ? null : new IFC2X3.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value)),
  3590301190: (v) => new IFC2X3.IfcGeometricSet(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  178086475: (v) => new IFC2X3.IfcGridPlacement(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  812098782: (v) => new IFC2X3.IfcHalfSpaceSolid(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : v[1].value),
  2445078500: (v) => new IFC2X3.IfcHygroscopicMaterialProperties(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcPositiveRatioMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcPositiveRatioMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcIsothermalMoistureCapacityMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcVaporPermeabilityMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC2X3.IfcMoistureDiffusivityMeasure(!v[5] && v[5] != "" ? null : v[5].value)),
  3905492369: (v) => new IFC2X3.IfcImageTexture(!v[0] && v[0] != "" ? null : v[0].value, !v[1] && v[1] != "" ? null : v[1].value, v[2], !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value), new IFC2X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value)),
  3741457305: (v) => new IFC2X3.IfcIrregularTimeSeries(new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new Handle(!v[3] && v[3] != "" ? null : v[3].value), v[4], v[5], !v[6] && v[6] != "" ? null : new IFC2X3.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), v[8]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1402838566: (v) => new IFC2X3.IfcLightSource(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcNormalisedRatioMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcNormalisedRatioMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  125510826: (v) => new IFC2X3.IfcLightSourceAmbient(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcNormalisedRatioMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcNormalisedRatioMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  2604431987: (v) => new IFC2X3.IfcLightSourceDirectional(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcNormalisedRatioMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcNormalisedRatioMeasure(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value)),
  4266656042: (v) => new IFC2X3.IfcLightSourceGoniometric(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcNormalisedRatioMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcNormalisedRatioMeasure(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), new IFC2X3.IfcThermodynamicTemperatureMeasure(!v[6] && v[6] != "" ? null : v[6].value), new IFC2X3.IfcLuminousFluxMeasure(!v[7] && v[7] != "" ? null : v[7].value), v[8], new Handle(!v[9] && v[9] != "" ? null : v[9].value)),
  1520743889: (v) => new IFC2X3.IfcLightSourcePositional(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcNormalisedRatioMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcNormalisedRatioMeasure(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new IFC2X3.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), new IFC2X3.IfcReal(!v[6] && v[6] != "" ? null : v[6].value), new IFC2X3.IfcReal(!v[7] && v[7] != "" ? null : v[7].value), new IFC2X3.IfcReal(!v[8] && v[8] != "" ? null : v[8].value)),
  3422422726: (v) => new IFC2X3.IfcLightSourceSpot(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcNormalisedRatioMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcNormalisedRatioMeasure(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new IFC2X3.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), new IFC2X3.IfcReal(!v[6] && v[6] != "" ? null : v[6].value), new IFC2X3.IfcReal(!v[7] && v[7] != "" ? null : v[7].value), new IFC2X3.IfcReal(!v[8] && v[8] != "" ? null : v[8].value), new Handle(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC2X3.IfcReal(!v[10] && v[10] != "" ? null : v[10].value), new IFC2X3.IfcPositivePlaneAngleMeasure(!v[11] && v[11] != "" ? null : v[11].value), new IFC2X3.IfcPositivePlaneAngleMeasure(!v[12] && v[12] != "" ? null : v[12].value)),
  2624227202: (v) => new IFC2X3.IfcLocalPlacement(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  1008929658: (_) => new IFC2X3.IfcLoop(),
  2347385850: (v) => new IFC2X3.IfcMappedItem(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  2022407955: (v) => new IFC2X3.IfcMaterialDefinitionRepresentation(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  1430189142: (v) => new IFC2X3.IfcMechanicalConcreteMaterialProperties(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcDynamicViscosityMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcModulusOfElasticityMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcModulusOfElasticityMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcPositiveRatioMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC2X3.IfcThermalExpansionCoefficientMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC2X3.IfcPressureMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcText(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC2X3.IfcText(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC2X3.IfcNormalisedRatioMeasure(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC2X3.IfcText(!v[11] && v[11] != "" ? null : v[11].value)),
  219451334: (v) => new IFC2X3.IfcObjectDefinition(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value)),
  2833995503: (v) => new IFC2X3.IfcOneDirectionRepeatFactor(new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  2665983363: (v) => new IFC2X3.IfcOpenShell(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1029017970: (v) => new IFC2X3.IfcOrientedEdge(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : v[1].value),
  2529465313: (v) => new IFC2X3.IfcParameterizedProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  2519244187: (v) => new IFC2X3.IfcPath(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3021840470: (v) => new IFC2X3.IfcPhysicalComplexQuantity(new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new IFC2X3.IfcLabel(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC2X3.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value)),
  597895409: (v) => new IFC2X3.IfcPixelTexture(!v[0] && v[0] != "" ? null : v[0].value, !v[1] && v[1] != "" ? null : v[1].value, v[2], !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value), new IFC2X3.IfcInteger(!v[4] && v[4] != "" ? null : v[4].value), new IFC2X3.IfcInteger(!v[5] && v[5] != "" ? null : v[5].value), new IFC2X3.IfcInteger(!v[6] && v[6] != "" ? null : v[6].value), v[7]?.map((p) => p?.value && p?.value != "" ? Number(p.value) : null) || []),
  2004835150: (v) => new IFC2X3.IfcPlacement(new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  1663979128: (v) => new IFC2X3.IfcPlanarExtent(new IFC2X3.IfcLengthMeasure(!v[0] && v[0] != "" ? null : v[0].value), new IFC2X3.IfcLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value)),
  2067069095: (_) => new IFC2X3.IfcPoint(),
  4022376103: (v) => new IFC2X3.IfcPointOnCurve(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC2X3.IfcParameterValue(!v[1] && v[1] != "" ? null : v[1].value)),
  1423911732: (v) => new IFC2X3.IfcPointOnSurface(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC2X3.IfcParameterValue(!v[1] && v[1] != "" ? null : v[1].value), new IFC2X3.IfcParameterValue(!v[2] && v[2] != "" ? null : v[2].value)),
  2924175390: (v) => new IFC2X3.IfcPolyLoop(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2775532180: (v) => new IFC2X3.IfcPolygonalBoundedHalfSpace(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : v[1].value, new Handle(!v[2] && v[2] != "" ? null : v[2].value), new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  759155922: (v) => new IFC2X3.IfcPreDefinedColour(new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  2559016684: (v) => new IFC2X3.IfcPreDefinedCurveFont(new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  433424934: (v) => new IFC2X3.IfcPreDefinedDimensionSymbol(new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  179317114: (v) => new IFC2X3.IfcPreDefinedPointMarkerSymbol(new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  673634403: (v) => new IFC2X3.IfcProductDefinitionShape(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  871118103: (v) => new IFC2X3.IfcPropertyBoundedValue(new IFC2X3.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : TypeInitialiser(1, v[2]), !v[3] && v[3] != "" ? null : TypeInitialiser(1, v[3]), !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value)),
  1680319473: (v) => new IFC2X3.IfcPropertyDefinition(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value)),
  4166981789: (v) => new IFC2X3.IfcPropertyEnumeratedValue(new IFC2X3.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.value && p?.value != "" ? TypeInitialiser(1, p) : null) || [], !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  2752243245: (v) => new IFC2X3.IfcPropertyListValue(new IFC2X3.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.value && p?.value != "" ? TypeInitialiser(1, p) : null) || [], !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  941946838: (v) => new IFC2X3.IfcPropertyReferenceValue(new IFC2X3.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  3357820518: (v) => new IFC2X3.IfcPropertySetDefinition(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value)),
  3650150729: (v) => new IFC2X3.IfcPropertySingleValue(new IFC2X3.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : TypeInitialiser(1, v[2]), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  110355661: (v) => new IFC2X3.IfcPropertyTableValue(new IFC2X3.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.value && p?.value != "" ? TypeInitialiser(1, p) : null) || [], v[3]?.map((p) => p?.value && p?.value != "" ? TypeInitialiser(1, p) : null) || [], !v[4] && v[4] != "" ? null : new IFC2X3.IfcText(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  3615266464: (v) => new IFC2X3.IfcRectangleProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC2X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC2X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value)),
  3413951693: (v) => new IFC2X3.IfcRegularTimeSeries(new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new Handle(!v[3] && v[3] != "" ? null : v[3].value), v[4], v[5], !v[6] && v[6] != "" ? null : new IFC2X3.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), new IFC2X3.IfcTimeMeasure(!v[8] && v[8] != "" ? null : v[8].value), v[9]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3765753017: (v) => new IFC2X3.IfcReinforcementDefinitionProperties(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  478536968: (v) => new IFC2X3.IfcRelationship(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value)),
  2778083089: (v) => new IFC2X3.IfcRoundedRectangleProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC2X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC2X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), new IFC2X3.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value)),
  1509187699: (v) => new IFC2X3.IfcSectionedSpine(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2411513650: (v) => new IFC2X3.IfcServiceLifeFactor(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4], !v[5] && v[5] != "" ? null : TypeInitialiser(1, v[5]), TypeInitialiser(1, v[6]), !v[7] && v[7] != "" ? null : TypeInitialiser(1, v[7])),
  4124623270: (v) => new IFC2X3.IfcShellBasedSurfaceModel(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2609359061: (v) => new IFC2X3.IfcSlippageConnectionCondition(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  723233188: (_) => new IFC2X3.IfcSolidModel(),
  2485662743: (v) => new IFC2X3.IfcSoundProperties(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new IFC2X3.IfcBoolean(!v[4] && v[4] != "" ? null : v[4].value), v[5], v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1202362311: (v) => new IFC2X3.IfcSoundValue(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value), new IFC2X3.IfcFrequencyMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : TypeInitialiser(1, v[6])),
  390701378: (v) => new IFC2X3.IfcSpaceThermalLoadProperties(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcPositiveRatioMeasure(!v[4] && v[4] != "" ? null : v[4].value), v[5], v[6], !v[7] && v[7] != "" ? null : new IFC2X3.IfcText(!v[7] && v[7] != "" ? null : v[7].value), new IFC2X3.IfcPowerMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC2X3.IfcPowerMeasure(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new Handle(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC2X3.IfcLabel(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC2X3.IfcLabel(!v[12] && v[12] != "" ? null : v[12].value), v[13]),
  1595516126: (v) => new IFC2X3.IfcStructuralLoadLinearForce(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcLinearForceMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLinearForceMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcLinearForceMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLinearMomentMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC2X3.IfcLinearMomentMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC2X3.IfcLinearMomentMeasure(!v[6] && v[6] != "" ? null : v[6].value)),
  2668620305: (v) => new IFC2X3.IfcStructuralLoadPlanarForce(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcPlanarForceMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcPlanarForceMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcPlanarForceMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  2473145415: (v) => new IFC2X3.IfcStructuralLoadSingleDisplacement(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcPlaneAngleMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC2X3.IfcPlaneAngleMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC2X3.IfcPlaneAngleMeasure(!v[6] && v[6] != "" ? null : v[6].value)),
  1973038258: (v) => new IFC2X3.IfcStructuralLoadSingleDisplacementDistortion(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcPlaneAngleMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC2X3.IfcPlaneAngleMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC2X3.IfcPlaneAngleMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcCurvatureMeasure(!v[7] && v[7] != "" ? null : v[7].value)),
  1597423693: (v) => new IFC2X3.IfcStructuralLoadSingleForce(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcForceMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcForceMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcForceMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcTorqueMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC2X3.IfcTorqueMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC2X3.IfcTorqueMeasure(!v[6] && v[6] != "" ? null : v[6].value)),
  1190533807: (v) => new IFC2X3.IfcStructuralLoadSingleForceWarping(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcForceMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcForceMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcForceMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcTorqueMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC2X3.IfcTorqueMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC2X3.IfcTorqueMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcWarpingMomentMeasure(!v[7] && v[7] != "" ? null : v[7].value)),
  3843319758: (v) => new IFC2X3.IfcStructuralProfileProperties(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcMassPerLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC2X3.IfcAreaMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcMomentOfInertiaMeasure(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcMomentOfInertiaMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC2X3.IfcMomentOfInertiaMeasure(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC2X3.IfcMomentOfInertiaMeasure(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC2X3.IfcWarpingConstantMeasure(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC2X3.IfcLengthMeasure(!v[12] && v[12] != "" ? null : v[12].value), !v[13] && v[13] != "" ? null : new IFC2X3.IfcLengthMeasure(!v[13] && v[13] != "" ? null : v[13].value), !v[14] && v[14] != "" ? null : new IFC2X3.IfcAreaMeasure(!v[14] && v[14] != "" ? null : v[14].value), !v[15] && v[15] != "" ? null : new IFC2X3.IfcAreaMeasure(!v[15] && v[15] != "" ? null : v[15].value), !v[16] && v[16] != "" ? null : new IFC2X3.IfcSectionModulusMeasure(!v[16] && v[16] != "" ? null : v[16].value), !v[17] && v[17] != "" ? null : new IFC2X3.IfcSectionModulusMeasure(!v[17] && v[17] != "" ? null : v[17].value), !v[18] && v[18] != "" ? null : new IFC2X3.IfcSectionModulusMeasure(!v[18] && v[18] != "" ? null : v[18].value), !v[19] && v[19] != "" ? null : new IFC2X3.IfcSectionModulusMeasure(!v[19] && v[19] != "" ? null : v[19].value), !v[20] && v[20] != "" ? null : new IFC2X3.IfcSectionModulusMeasure(!v[20] && v[20] != "" ? null : v[20].value), !v[21] && v[21] != "" ? null : new IFC2X3.IfcLengthMeasure(!v[21] && v[21] != "" ? null : v[21].value), !v[22] && v[22] != "" ? null : new IFC2X3.IfcLengthMeasure(!v[22] && v[22] != "" ? null : v[22].value)),
  3653947884: (v) => new IFC2X3.IfcStructuralSteelProfileProperties(!v[0] && v[0] != "" ? null : new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcMassPerLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC2X3.IfcAreaMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcMomentOfInertiaMeasure(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcMomentOfInertiaMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC2X3.IfcMomentOfInertiaMeasure(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC2X3.IfcMomentOfInertiaMeasure(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC2X3.IfcWarpingConstantMeasure(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC2X3.IfcLengthMeasure(!v[12] && v[12] != "" ? null : v[12].value), !v[13] && v[13] != "" ? null : new IFC2X3.IfcLengthMeasure(!v[13] && v[13] != "" ? null : v[13].value), !v[14] && v[14] != "" ? null : new IFC2X3.IfcAreaMeasure(!v[14] && v[14] != "" ? null : v[14].value), !v[15] && v[15] != "" ? null : new IFC2X3.IfcAreaMeasure(!v[15] && v[15] != "" ? null : v[15].value), !v[16] && v[16] != "" ? null : new IFC2X3.IfcSectionModulusMeasure(!v[16] && v[16] != "" ? null : v[16].value), !v[17] && v[17] != "" ? null : new IFC2X3.IfcSectionModulusMeasure(!v[17] && v[17] != "" ? null : v[17].value), !v[18] && v[18] != "" ? null : new IFC2X3.IfcSectionModulusMeasure(!v[18] && v[18] != "" ? null : v[18].value), !v[19] && v[19] != "" ? null : new IFC2X3.IfcSectionModulusMeasure(!v[19] && v[19] != "" ? null : v[19].value), !v[20] && v[20] != "" ? null : new IFC2X3.IfcSectionModulusMeasure(!v[20] && v[20] != "" ? null : v[20].value), !v[21] && v[21] != "" ? null : new IFC2X3.IfcLengthMeasure(!v[21] && v[21] != "" ? null : v[21].value), !v[22] && v[22] != "" ? null : new IFC2X3.IfcLengthMeasure(!v[22] && v[22] != "" ? null : v[22].value), !v[23] && v[23] != "" ? null : new IFC2X3.IfcAreaMeasure(!v[23] && v[23] != "" ? null : v[23].value), !v[24] && v[24] != "" ? null : new IFC2X3.IfcAreaMeasure(!v[24] && v[24] != "" ? null : v[24].value), !v[25] && v[25] != "" ? null : new IFC2X3.IfcPositiveRatioMeasure(!v[25] && v[25] != "" ? null : v[25].value), !v[26] && v[26] != "" ? null : new IFC2X3.IfcPositiveRatioMeasure(!v[26] && v[26] != "" ? null : v[26].value)),
  2233826070: (v) => new IFC2X3.IfcSubedge(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  2513912981: (_) => new IFC2X3.IfcSurface(),
  1878645084: (v) => new IFC2X3.IfcSurfaceStyleRendering(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC2X3.IfcNormalisedRatioMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : TypeInitialiser(1, v[7]), v[8]),
  2247615214: (v) => new IFC2X3.IfcSweptAreaSolid(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  1260650574: (v) => new IFC2X3.IfcSweptDiskSolid(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC2X3.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), new IFC2X3.IfcParameterValue(!v[3] && v[3] != "" ? null : v[3].value), new IFC2X3.IfcParameterValue(!v[4] && v[4] != "" ? null : v[4].value)),
  230924584: (v) => new IFC2X3.IfcSweptSurface(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  3071757647: (v) => new IFC2X3.IfcTShapeProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC2X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC2X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), new IFC2X3.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), new IFC2X3.IfcPositiveLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC2X3.IfcPlaneAngleMeasure(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC2X3.IfcPlaneAngleMeasure(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[12] && v[12] != "" ? null : v[12].value)),
  3028897424: (v) => new IFC2X3.IfcTerminatorSymbol(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  4282788508: (v) => new IFC2X3.IfcTextLiteral(new IFC2X3.IfcPresentableText(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), v[2]),
  3124975700: (v) => new IFC2X3.IfcTextLiteralWithExtent(new IFC2X3.IfcPresentableText(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), v[2], new Handle(!v[3] && v[3] != "" ? null : v[3].value), new IFC2X3.IfcBoxAlignment(!v[4] && v[4] != "" ? null : v[4].value)),
  2715220739: (v) => new IFC2X3.IfcTrapeziumProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC2X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC2X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), new IFC2X3.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), new IFC2X3.IfcLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value)),
  1345879162: (v) => new IFC2X3.IfcTwoDirectionRepeatFactor(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  1628702193: (v) => new IFC2X3.IfcTypeObject(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2347495698: (v) => new IFC2X3.IfcTypeProduct(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value)),
  427810014: (v) => new IFC2X3.IfcUShapeProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC2X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC2X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), new IFC2X3.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), new IFC2X3.IfcPositiveLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC2X3.IfcPlaneAngleMeasure(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[10] && v[10] != "" ? null : v[10].value)),
  1417489154: (v) => new IFC2X3.IfcVector(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC2X3.IfcLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value)),
  2759199220: (v) => new IFC2X3.IfcVertexLoop(new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  336235671: (v) => new IFC2X3.IfcWindowLiningProperties(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcNormalisedRatioMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC2X3.IfcNormalisedRatioMeasure(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC2X3.IfcNormalisedRatioMeasure(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC2X3.IfcNormalisedRatioMeasure(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new Handle(!v[12] && v[12] != "" ? null : v[12].value)),
  512836454: (v) => new IFC2X3.IfcWindowPanelProperties(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4], v[5], !v[6] && v[6] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new Handle(!v[8] && v[8] != "" ? null : v[8].value)),
  1299126871: (v) => new IFC2X3.IfcWindowStyle(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), v[8], v[9], !v[10] && v[10] != "" ? null : v[10].value, !v[11] && v[11] != "" ? null : v[11].value),
  2543172580: (v) => new IFC2X3.IfcZShapeProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC2X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC2X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), new IFC2X3.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), new IFC2X3.IfcPositiveLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value)),
  3288037868: (v) => new IFC2X3.IfcAnnotationCurveOccurrence(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  669184980: (v) => new IFC2X3.IfcAnnotationFillArea(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2265737646: (v) => new IFC2X3.IfcAnnotationFillAreaOccurrence(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value), v[4]),
  1302238472: (v) => new IFC2X3.IfcAnnotationSurface(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  4261334040: (v) => new IFC2X3.IfcAxis1Placement(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  3125803723: (v) => new IFC2X3.IfcAxis2Placement2D(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  2740243338: (v) => new IFC2X3.IfcAxis2Placement3D(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  2736907675: (v) => new IFC2X3.IfcBooleanResult(v[0], new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  4182860854: (_) => new IFC2X3.IfcBoundedSurface(),
  2581212453: (v) => new IFC2X3.IfcBoundingBox(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC2X3.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), new IFC2X3.IfcPositiveLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), new IFC2X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  2713105998: (v) => new IFC2X3.IfcBoxedHalfSpace(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : v[1].value, new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  2898889636: (v) => new IFC2X3.IfcCShapeProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC2X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC2X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), new IFC2X3.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), new IFC2X3.IfcPositiveLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value)),
  1123145078: (v) => new IFC2X3.IfcCartesianPoint(v[0]?.map((p) => p?.value && p?.value != "" ? new IFC2X3.IfcLengthMeasure(p.value) : null) || []),
  59481748: (v) => new IFC2X3.IfcCartesianTransformationOperator(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : !v[3] && v[3] != "" ? null : v[3].value),
  3749851601: (v) => new IFC2X3.IfcCartesianTransformationOperator2D(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : !v[3] && v[3] != "" ? null : v[3].value),
  3486308946: (v) => new IFC2X3.IfcCartesianTransformationOperator2DnonUniform(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : !v[3] && v[3] != "" ? null : v[3].value, !v[4] && v[4] != "" ? null : !v[4] && v[4] != "" ? null : v[4].value),
  3331915920: (v) => new IFC2X3.IfcCartesianTransformationOperator3D(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : !v[3] && v[3] != "" ? null : v[3].value, !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value)),
  1416205885: (v) => new IFC2X3.IfcCartesianTransformationOperator3DnonUniform(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : !v[3] && v[3] != "" ? null : v[3].value, !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : !v[5] && v[5] != "" ? null : v[5].value, !v[6] && v[6] != "" ? null : !v[6] && v[6] != "" ? null : v[6].value),
  1383045692: (v) => new IFC2X3.IfcCircleProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC2X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  2205249479: (v) => new IFC2X3.IfcClosedShell(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2485617015: (v) => new IFC2X3.IfcCompositeCurveSegment(v[0], !v[1] && v[1] != "" ? null : v[1].value, new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  4133800736: (v) => new IFC2X3.IfcCraneRailAShapeProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC2X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC2X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), new IFC2X3.IfcPositiveLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), new IFC2X3.IfcPositiveLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value), new IFC2X3.IfcPositiveLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value), new IFC2X3.IfcPositiveLengthMeasure(!v[9] && v[9] != "" ? null : v[9].value), new IFC2X3.IfcPositiveLengthMeasure(!v[10] && v[10] != "" ? null : v[10].value), new IFC2X3.IfcPositiveLengthMeasure(!v[11] && v[11] != "" ? null : v[11].value), new IFC2X3.IfcPositiveLengthMeasure(!v[12] && v[12] != "" ? null : v[12].value), new IFC2X3.IfcPositiveLengthMeasure(!v[13] && v[13] != "" ? null : v[13].value), !v[14] && v[14] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[14] && v[14] != "" ? null : v[14].value)),
  194851669: (v) => new IFC2X3.IfcCraneRailFShapeProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC2X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC2X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), new IFC2X3.IfcPositiveLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), new IFC2X3.IfcPositiveLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value), new IFC2X3.IfcPositiveLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value), new IFC2X3.IfcPositiveLengthMeasure(!v[9] && v[9] != "" ? null : v[9].value), new IFC2X3.IfcPositiveLengthMeasure(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[11] && v[11] != "" ? null : v[11].value)),
  2506170314: (v) => new IFC2X3.IfcCsgPrimitive3D(new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  2147822146: (v) => new IFC2X3.IfcCsgSolid(new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  2601014836: (_) => new IFC2X3.IfcCurve(),
  2827736869: (v) => new IFC2X3.IfcCurveBoundedPlane(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  693772133: (v) => new IFC2X3.IfcDefinedSymbol(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  606661476: (v) => new IFC2X3.IfcDimensionCurve(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  4054601972: (v) => new IFC2X3.IfcDimensionCurveTerminator(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), new Handle(!v[3] && v[3] != "" ? null : v[3].value), v[4]),
  32440307: (v) => new IFC2X3.IfcDirection(v[0]?.map((p) => p?.value && p?.value != "" ? Number(p.value) : null) || []),
  2963535650: (v) => new IFC2X3.IfcDoorLiningProperties(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC2X3.IfcLengthMeasure(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC2X3.IfcLengthMeasure(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC2X3.IfcLengthMeasure(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[12] && v[12] != "" ? null : v[12].value), !v[13] && v[13] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[13] && v[13] != "" ? null : v[13].value), !v[14] && v[14] != "" ? null : new Handle(!v[14] && v[14] != "" ? null : v[14].value)),
  1714330368: (v) => new IFC2X3.IfcDoorPanelProperties(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), v[5], !v[6] && v[6] != "" ? null : new IFC2X3.IfcNormalisedRatioMeasure(!v[6] && v[6] != "" ? null : v[6].value), v[7], !v[8] && v[8] != "" ? null : new Handle(!v[8] && v[8] != "" ? null : v[8].value)),
  526551008: (v) => new IFC2X3.IfcDoorStyle(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), v[8], v[9], !v[10] && v[10] != "" ? null : v[10].value, !v[11] && v[11] != "" ? null : v[11].value),
  3073041342: (v) => new IFC2X3.IfcDraughtingCallout(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  445594917: (v) => new IFC2X3.IfcDraughtingPreDefinedColour(new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  4006246654: (v) => new IFC2X3.IfcDraughtingPreDefinedCurveFont(new IFC2X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  1472233963: (v) => new IFC2X3.IfcEdgeLoop(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1883228015: (v) => new IFC2X3.IfcElementQuantity(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  339256511: (v) => new IFC2X3.IfcElementType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  2777663545: (v) => new IFC2X3.IfcElementarySurface(new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  2835456948: (v) => new IFC2X3.IfcEllipseProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC2X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC2X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value)),
  80994333: (v) => new IFC2X3.IfcEnergyProperties(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4], !v[5] && v[5] != "" ? null : new IFC2X3.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value)),
  477187591: (v) => new IFC2X3.IfcExtrudedAreaSolid(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC2X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  2047409740: (v) => new IFC2X3.IfcFaceBasedSurfaceModel(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  374418227: (v) => new IFC2X3.IfcFillAreaStyleHatching(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value), new IFC2X3.IfcPlaneAngleMeasure(!v[4] && v[4] != "" ? null : v[4].value)),
  4203026998: (v) => new IFC2X3.IfcFillAreaStyleTileSymbolWithStyle(new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  315944413: (v) => new IFC2X3.IfcFillAreaStyleTiles(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new IFC2X3.IfcPositiveRatioMeasure(!v[2] && v[2] != "" ? null : v[2].value)),
  3455213021: (v) => new IFC2X3.IfcFluidFlowProperties(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4], !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), new Handle(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new Handle(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC2X3.IfcLabel(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC2X3.IfcThermodynamicTemperatureMeasure(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC2X3.IfcThermodynamicTemperatureMeasure(!v[12] && v[12] != "" ? null : v[12].value), !v[13] && v[13] != "" ? null : new Handle(!v[13] && v[13] != "" ? null : v[13].value), !v[14] && v[14] != "" ? null : new Handle(!v[14] && v[14] != "" ? null : v[14].value), !v[15] && v[15] != "" ? null : TypeInitialiser(1, v[15]), !v[16] && v[16] != "" ? null : new IFC2X3.IfcPositiveRatioMeasure(!v[16] && v[16] != "" ? null : v[16].value), !v[17] && v[17] != "" ? null : new IFC2X3.IfcLinearVelocityMeasure(!v[17] && v[17] != "" ? null : v[17].value), !v[18] && v[18] != "" ? null : new IFC2X3.IfcPressureMeasure(!v[18] && v[18] != "" ? null : v[18].value)),
  4238390223: (v) => new IFC2X3.IfcFurnishingElementType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  1268542332: (v) => new IFC2X3.IfcFurnitureType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  987898635: (v) => new IFC2X3.IfcGeometricCurveSet(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1484403080: (v) => new IFC2X3.IfcIShapeProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC2X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC2X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), new IFC2X3.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), new IFC2X3.IfcPositiveLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value)),
  572779678: (v) => new IFC2X3.IfcLShapeProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC2X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), new IFC2X3.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcPlaneAngleMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[10] && v[10] != "" ? null : v[10].value)),
  1281925730: (v) => new IFC2X3.IfcLine(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  1425443689: (v) => new IFC2X3.IfcManifoldSolidBrep(new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  3888040117: (v) => new IFC2X3.IfcObject(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  3388369263: (v) => new IFC2X3.IfcOffsetCurve2D(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC2X3.IfcLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : v[2].value),
  3505215534: (v) => new IFC2X3.IfcOffsetCurve3D(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC2X3.IfcLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : v[2].value, new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  3566463478: (v) => new IFC2X3.IfcPermeableCoveringProperties(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4], v[5], !v[6] && v[6] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new Handle(!v[8] && v[8] != "" ? null : v[8].value)),
  603570806: (v) => new IFC2X3.IfcPlanarBox(new IFC2X3.IfcLengthMeasure(!v[0] && v[0] != "" ? null : v[0].value), new IFC2X3.IfcLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  220341763: (v) => new IFC2X3.IfcPlane(new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  2945172077: (v) => new IFC2X3.IfcProcess(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  4208778838: (v) => new IFC2X3.IfcProduct(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  103090709: (v) => new IFC2X3.IfcProject(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC2X3.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC2X3.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[8] && v[8] != "" ? null : v[8].value)),
  4194566429: (v) => new IFC2X3.IfcProjectionCurve(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  1451395588: (v) => new IFC2X3.IfcPropertySet(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3219374653: (v) => new IFC2X3.IfcProxy(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), v[7], !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  2770003689: (v) => new IFC2X3.IfcRectangleHollowProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC2X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC2X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), new IFC2X3.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value)),
  2798486643: (v) => new IFC2X3.IfcRectangularPyramid(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC2X3.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), new IFC2X3.IfcPositiveLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), new IFC2X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  3454111270: (v) => new IFC2X3.IfcRectangularTrimmedSurface(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC2X3.IfcParameterValue(!v[1] && v[1] != "" ? null : v[1].value), new IFC2X3.IfcParameterValue(!v[2] && v[2] != "" ? null : v[2].value), new IFC2X3.IfcParameterValue(!v[3] && v[3] != "" ? null : v[3].value), new IFC2X3.IfcParameterValue(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5].value, !v[6] && v[6] != "" ? null : v[6].value),
  3939117080: (v) => new IFC2X3.IfcRelAssigns(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[5]),
  1683148259: (v) => new IFC2X3.IfcRelAssignsToActor(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[5], new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value)),
  2495723537: (v) => new IFC2X3.IfcRelAssignsToControl(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[5], new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  1307041759: (v) => new IFC2X3.IfcRelAssignsToGroup(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[5], new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  4278684876: (v) => new IFC2X3.IfcRelAssignsToProcess(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[5], new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value)),
  2857406711: (v) => new IFC2X3.IfcRelAssignsToProduct(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[5], new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  3372526763: (v) => new IFC2X3.IfcRelAssignsToProjectOrder(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[5], new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  205026976: (v) => new IFC2X3.IfcRelAssignsToResource(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[5], new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  1865459582: (v) => new IFC2X3.IfcRelAssociates(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1327628568: (v) => new IFC2X3.IfcRelAssociatesAppliedValue(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  4095574036: (v) => new IFC2X3.IfcRelAssociatesApproval(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  919958153: (v) => new IFC2X3.IfcRelAssociatesClassification(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  2728634034: (v) => new IFC2X3.IfcRelAssociatesConstraint(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new IFC2X3.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value), new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  982818633: (v) => new IFC2X3.IfcRelAssociatesDocument(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  3840914261: (v) => new IFC2X3.IfcRelAssociatesLibrary(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  2655215786: (v) => new IFC2X3.IfcRelAssociatesMaterial(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  2851387026: (v) => new IFC2X3.IfcRelAssociatesProfileProperties(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value)),
  826625072: (v) => new IFC2X3.IfcRelConnects(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value)),
  1204542856: (v) => new IFC2X3.IfcRelConnectsElements(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value), new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  3945020480: (v) => new IFC2X3.IfcRelConnectsPathElements(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value), new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : v[7]?.map((p) => p?.value && p?.value != "" ? Number(p.value) : null) || [], !v[8] && v[8] != "" ? null : v[8]?.map((p) => p?.value && p?.value != "" ? Number(p.value) : null) || [], v[9], v[10]),
  4201705270: (v) => new IFC2X3.IfcRelConnectsPortToElement(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  3190031847: (v) => new IFC2X3.IfcRelConnectsPorts(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  2127690289: (v) => new IFC2X3.IfcRelConnectsStructuralActivity(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  3912681535: (v) => new IFC2X3.IfcRelConnectsStructuralElement(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  1638771189: (v) => new IFC2X3.IfcRelConnectsStructuralMember(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new Handle(!v[9] && v[9] != "" ? null : v[9].value)),
  504942748: (v) => new IFC2X3.IfcRelConnectsWithEccentricity(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new Handle(!v[9] && v[9] != "" ? null : v[9].value), new Handle(!v[10] && v[10] != "" ? null : v[10].value)),
  3678494232: (v) => new IFC2X3.IfcRelConnectsWithRealizingElements(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value), new Handle(!v[6] && v[6] != "" ? null : v[6].value), v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  3242617779: (v) => new IFC2X3.IfcRelContainedInSpatialStructure(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  886880790: (v) => new IFC2X3.IfcRelCoversBldgElements(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2802773753: (v) => new IFC2X3.IfcRelCoversSpaces(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2551354335: (v) => new IFC2X3.IfcRelDecomposes(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  693640335: (v) => new IFC2X3.IfcRelDefines(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  4186316022: (v) => new IFC2X3.IfcRelDefinesByProperties(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  781010003: (v) => new IFC2X3.IfcRelDefinesByType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  3940055652: (v) => new IFC2X3.IfcRelFillsElement(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  279856033: (v) => new IFC2X3.IfcRelFlowControlElements(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  4189434867: (v) => new IFC2X3.IfcRelInteractionRequirements(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcCountMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC2X3.IfcNormalisedRatioMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), new Handle(!v[7] && v[7] != "" ? null : v[7].value), new Handle(!v[8] && v[8] != "" ? null : v[8].value)),
  3268803585: (v) => new IFC2X3.IfcRelNests(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2051452291: (v) => new IFC2X3.IfcRelOccupiesSpaces(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[5], new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value)),
  202636808: (v) => new IFC2X3.IfcRelOverridesProperties(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[5] && v[5] != "" ? null : v[5].value), v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  750771296: (v) => new IFC2X3.IfcRelProjectsElement(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  1245217292: (v) => new IFC2X3.IfcRelReferencedInSpatialStructure(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  1058617721: (v) => new IFC2X3.IfcRelSchedulesCostItems(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[5], new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  4122056220: (v) => new IFC2X3.IfcRelSequence(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value), new IFC2X3.IfcTimeMeasure(!v[6] && v[6] != "" ? null : v[6].value), v[7]),
  366585022: (v) => new IFC2X3.IfcRelServicesBuildings(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3451746338: (v) => new IFC2X3.IfcRelSpaceBoundary(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), v[7], v[8]),
  1401173127: (v) => new IFC2X3.IfcRelVoidsElement(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  2914609552: (v) => new IFC2X3.IfcResource(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  1856042241: (v) => new IFC2X3.IfcRevolvedAreaSolid(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC2X3.IfcPlaneAngleMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  4158566097: (v) => new IFC2X3.IfcRightCircularCone(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC2X3.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), new IFC2X3.IfcPositiveLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value)),
  3626867408: (v) => new IFC2X3.IfcRightCircularCylinder(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC2X3.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), new IFC2X3.IfcPositiveLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value)),
  2706606064: (v) => new IFC2X3.IfcSpatialStructureElement(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3893378262: (v) => new IFC2X3.IfcSpatialStructureElementType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  451544542: (v) => new IFC2X3.IfcSphere(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC2X3.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value)),
  3544373492: (v) => new IFC2X3.IfcStructuralActivity(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), new Handle(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3136571912: (v) => new IFC2X3.IfcStructuralItem(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  530289379: (v) => new IFC2X3.IfcStructuralMember(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  3689010777: (v) => new IFC2X3.IfcStructuralReaction(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), new Handle(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3979015343: (v) => new IFC2X3.IfcStructuralSurfaceMember(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), v[7], !v[8] && v[8] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value)),
  2218152070: (v) => new IFC2X3.IfcStructuralSurfaceMemberVarying(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), v[7], !v[8] && v[8] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value), v[9]?.map((p) => p?.value && p?.value != "" ? new IFC2X3.IfcPositiveLengthMeasure(p.value) : null) || [], new Handle(!v[10] && v[10] != "" ? null : v[10].value)),
  4070609034: (v) => new IFC2X3.IfcStructuredDimensionCallout(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2028607225: (v) => new IFC2X3.IfcSurfaceCurveSweptAreaSolid(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC2X3.IfcParameterValue(!v[3] && v[3] != "" ? null : v[3].value), new IFC2X3.IfcParameterValue(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  2809605785: (v) => new IFC2X3.IfcSurfaceOfLinearExtrusion(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC2X3.IfcLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  4124788165: (v) => new IFC2X3.IfcSurfaceOfRevolution(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  1580310250: (v) => new IFC2X3.IfcSystemFurnitureElementType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  3473067441: (v) => new IFC2X3.IfcTask(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), new IFC2X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC2X3.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : v[8].value, !v[9] && v[9] != "" ? null : !v[9] && v[9] != "" ? null : v[9].value),
  2097647324: (v) => new IFC2X3.IfcTransportElementType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2296667514: (v) => new IFC2X3.IfcActor(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  1674181508: (v) => new IFC2X3.IfcAnnotation(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  3207858831: (v) => new IFC2X3.IfcAsymmetricIShapeProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC2X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC2X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), new IFC2X3.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), new IFC2X3.IfcPositiveLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value), new IFC2X3.IfcPositiveLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[11] && v[11] != "" ? null : v[11].value)),
  1334484129: (v) => new IFC2X3.IfcBlock(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC2X3.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), new IFC2X3.IfcPositiveLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), new IFC2X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  3649129432: (v) => new IFC2X3.IfcBooleanClippingResult(v[0], new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  1260505505: (_) => new IFC2X3.IfcBoundedCurve(),
  4031249490: (v) => new IFC2X3.IfcBuilding(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), v[8], !v[9] && v[9] != "" ? null : new IFC2X3.IfcLengthMeasure(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC2X3.IfcLengthMeasure(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new Handle(!v[11] && v[11] != "" ? null : v[11].value)),
  1950629157: (v) => new IFC2X3.IfcBuildingElementType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  3124254112: (v) => new IFC2X3.IfcBuildingStorey(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), v[8], !v[9] && v[9] != "" ? null : new IFC2X3.IfcLengthMeasure(!v[9] && v[9] != "" ? null : v[9].value)),
  2937912522: (v) => new IFC2X3.IfcCircleHollowProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC2X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC2X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC2X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value)),
  300633059: (v) => new IFC2X3.IfcColumnType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3732776249: (v) => new IFC2X3.IfcCompositeCurve(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[1] && v[1] != "" ? null : v[1].value),
  2510884976: (v) => new IFC2X3.IfcConic(new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  2559216714: (v) => new IFC2X3.IfcConstructionResource(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC2X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC2X3.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), v[7], !v[8] && v[8] != "" ? null : new Handle(!v[8] && v[8] != "" ? null : v[8].value)),
  3293443760: (v) => new IFC2X3.IfcControl(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  3895139033: (v) => new IFC2X3.IfcCostItem(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  1419761937: (v) => new IFC2X3.IfcCostSchedule(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : v[9]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[10] && v[10] != "" ? null : new Handle(!v[10] && v[10] != "" ? null : v[10].value), new IFC2X3.IfcIdentifier(!v[11] && v[11] != "" ? null : v[11].value), v[12]),
  1916426348: (v) => new IFC2X3.IfcCoveringType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3295246426: (v) => new IFC2X3.IfcCrewResource(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC2X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC2X3.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), v[7], !v[8] && v[8] != "" ? null : new Handle(!v[8] && v[8] != "" ? null : v[8].value)),
  1457835157: (v) => new IFC2X3.IfcCurtainWallType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  681481545: (v) => new IFC2X3.IfcDimensionCurveDirectedCallout(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3256556792: (v) => new IFC2X3.IfcDistributionElementType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  3849074793: (v) => new IFC2X3.IfcDistributionFlowElementType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  360485395: (v) => new IFC2X3.IfcElectricalBaseProperties(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4], !v[5] && v[5] != "" ? null : new IFC2X3.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value), v[6], new IFC2X3.IfcElectricVoltageMeasure(!v[7] && v[7] != "" ? null : v[7].value), new IFC2X3.IfcFrequencyMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC2X3.IfcElectricCurrentMeasure(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC2X3.IfcElectricCurrentMeasure(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC2X3.IfcPowerMeasure(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC2X3.IfcPowerMeasure(!v[12] && v[12] != "" ? null : v[12].value), !v[13] && v[13] != "" ? null : v[13].value),
  1758889154: (v) => new IFC2X3.IfcElement(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  4123344466: (v) => new IFC2X3.IfcElementAssembly(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8], v[9]),
  1623761950: (v) => new IFC2X3.IfcElementComponent(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  2590856083: (v) => new IFC2X3.IfcElementComponentType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  1704287377: (v) => new IFC2X3.IfcEllipse(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC2X3.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), new IFC2X3.IfcPositiveLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value)),
  2107101300: (v) => new IFC2X3.IfcEnergyConversionDeviceType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  1962604670: (v) => new IFC2X3.IfcEquipmentElement(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  3272907226: (v) => new IFC2X3.IfcEquipmentStandard(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  3174744832: (v) => new IFC2X3.IfcEvaporativeCoolerType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3390157468: (v) => new IFC2X3.IfcEvaporatorType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  807026263: (v) => new IFC2X3.IfcFacetedBrep(new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  3737207727: (v) => new IFC2X3.IfcFacetedBrepWithVoids(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  647756555: (v) => new IFC2X3.IfcFastener(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  2489546625: (v) => new IFC2X3.IfcFastenerType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  2827207264: (v) => new IFC2X3.IfcFeatureElement(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  2143335405: (v) => new IFC2X3.IfcFeatureElementAddition(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  1287392070: (v) => new IFC2X3.IfcFeatureElementSubtraction(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  3907093117: (v) => new IFC2X3.IfcFlowControllerType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  3198132628: (v) => new IFC2X3.IfcFlowFittingType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  3815607619: (v) => new IFC2X3.IfcFlowMeterType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1482959167: (v) => new IFC2X3.IfcFlowMovingDeviceType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  1834744321: (v) => new IFC2X3.IfcFlowSegmentType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  1339347760: (v) => new IFC2X3.IfcFlowStorageDeviceType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  2297155007: (v) => new IFC2X3.IfcFlowTerminalType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  3009222698: (v) => new IFC2X3.IfcFlowTreatmentDeviceType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  263784265: (v) => new IFC2X3.IfcFurnishingElement(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  814719939: (v) => new IFC2X3.IfcFurnitureStandard(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  200128114: (v) => new IFC2X3.IfcGasTerminalType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3009204131: (v) => new IFC2X3.IfcGrid(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[8]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[9] && v[9] != "" ? null : v[9]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2706460486: (v) => new IFC2X3.IfcGroup(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  1251058090: (v) => new IFC2X3.IfcHeatExchangerType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1806887404: (v) => new IFC2X3.IfcHumidifierType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2391368822: (v) => new IFC2X3.IfcInventory(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), v[5], new Handle(!v[6] && v[6] != "" ? null : v[6].value), v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new Handle(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new Handle(!v[10] && v[10] != "" ? null : v[10].value)),
  4288270099: (v) => new IFC2X3.IfcJunctionBoxType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3827777499: (v) => new IFC2X3.IfcLaborResource(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC2X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC2X3.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), v[7], !v[8] && v[8] != "" ? null : new Handle(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC2X3.IfcText(!v[9] && v[9] != "" ? null : v[9].value)),
  1051575348: (v) => new IFC2X3.IfcLampType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1161773419: (v) => new IFC2X3.IfcLightFixtureType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2506943328: (v) => new IFC2X3.IfcLinearDimension(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  377706215: (v) => new IFC2X3.IfcMechanicalFastener(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[9] && v[9] != "" ? null : v[9].value)),
  2108223431: (v) => new IFC2X3.IfcMechanicalFastenerType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  3181161470: (v) => new IFC2X3.IfcMemberType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  977012517: (v) => new IFC2X3.IfcMotorConnectionType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1916936684: (v) => new IFC2X3.IfcMove(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), new IFC2X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC2X3.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : v[8].value, !v[9] && v[9] != "" ? null : !v[9] && v[9] != "" ? null : v[9].value, new Handle(!v[10] && v[10] != "" ? null : v[10].value), new Handle(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : v[12]?.map((p) => p?.value && p?.value != "" ? new IFC2X3.IfcText(p.value) : null) || []),
  4143007308: (v) => new IFC2X3.IfcOccupant(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value), v[6]),
  3588315303: (v) => new IFC2X3.IfcOpeningElement(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  3425660407: (v) => new IFC2X3.IfcOrderAction(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), new IFC2X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC2X3.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : v[8].value, !v[9] && v[9] != "" ? null : !v[9] && v[9] != "" ? null : v[9].value, new IFC2X3.IfcIdentifier(!v[10] && v[10] != "" ? null : v[10].value)),
  2837617999: (v) => new IFC2X3.IfcOutletType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2382730787: (v) => new IFC2X3.IfcPerformanceHistory(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), new IFC2X3.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value)),
  3327091369: (v) => new IFC2X3.IfcPermit(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), new IFC2X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value)),
  804291784: (v) => new IFC2X3.IfcPipeFittingType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  4231323485: (v) => new IFC2X3.IfcPipeSegmentType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  4017108033: (v) => new IFC2X3.IfcPlateType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3724593414: (v) => new IFC2X3.IfcPolyline(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3740093272: (v) => new IFC2X3.IfcPort(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  2744685151: (v) => new IFC2X3.IfcProcedure(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), new IFC2X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), v[6], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value)),
  2904328755: (v) => new IFC2X3.IfcProjectOrder(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), new IFC2X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), v[6], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value)),
  3642467123: (v) => new IFC2X3.IfcProjectOrderRecord(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[6]),
  3651124850: (v) => new IFC2X3.IfcProjectionElement(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  1842657554: (v) => new IFC2X3.IfcProtectiveDeviceType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2250791053: (v) => new IFC2X3.IfcPumpType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3248260540: (v) => new IFC2X3.IfcRadiusDimension(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2893384427: (v) => new IFC2X3.IfcRailingType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2324767716: (v) => new IFC2X3.IfcRampFlightType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  160246688: (v) => new IFC2X3.IfcRelAggregates(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2863920197: (v) => new IFC2X3.IfcRelAssignsTasks(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[5], new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value)),
  1768891740: (v) => new IFC2X3.IfcSanitaryTerminalType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3517283431: (v) => new IFC2X3.IfcScheduleTimeControl(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new Handle(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new Handle(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new Handle(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new Handle(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new Handle(!v[12] && v[12] != "" ? null : v[12].value), !v[13] && v[13] != "" ? null : new IFC2X3.IfcTimeMeasure(!v[13] && v[13] != "" ? null : v[13].value), !v[14] && v[14] != "" ? null : new IFC2X3.IfcTimeMeasure(!v[14] && v[14] != "" ? null : v[14].value), !v[15] && v[15] != "" ? null : new IFC2X3.IfcTimeMeasure(!v[15] && v[15] != "" ? null : v[15].value), !v[16] && v[16] != "" ? null : new IFC2X3.IfcTimeMeasure(!v[16] && v[16] != "" ? null : v[16].value), !v[17] && v[17] != "" ? null : new IFC2X3.IfcTimeMeasure(!v[17] && v[17] != "" ? null : v[17].value), !v[18] && v[18] != "" ? null : !v[18] && v[18] != "" ? null : v[18].value, !v[19] && v[19] != "" ? null : new Handle(!v[19] && v[19] != "" ? null : v[19].value), !v[20] && v[20] != "" ? null : new IFC2X3.IfcTimeMeasure(!v[20] && v[20] != "" ? null : v[20].value), !v[21] && v[21] != "" ? null : new IFC2X3.IfcTimeMeasure(!v[21] && v[21] != "" ? null : v[21].value), !v[22] && v[22] != "" ? null : new IFC2X3.IfcPositiveRatioMeasure(!v[22] && v[22] != "" ? null : v[22].value)),
  4105383287: (v) => new IFC2X3.IfcServiceLife(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), v[5], new IFC2X3.IfcTimeMeasure(!v[6] && v[6] != "" ? null : v[6].value)),
  4097777520: (v) => new IFC2X3.IfcSite(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), v[8], !v[9] && v[9] != "" ? null : new IFC2X3.IfcCompoundPlaneAngleMeasure(v[9].map((x) => x.value)), !v[10] && v[10] != "" ? null : new IFC2X3.IfcCompoundPlaneAngleMeasure(v[10].map((x) => x.value)), !v[11] && v[11] != "" ? null : new IFC2X3.IfcLengthMeasure(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC2X3.IfcLabel(!v[12] && v[12] != "" ? null : v[12].value), !v[13] && v[13] != "" ? null : new Handle(!v[13] && v[13] != "" ? null : v[13].value)),
  2533589738: (v) => new IFC2X3.IfcSlabType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3856911033: (v) => new IFC2X3.IfcSpace(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), v[8], v[9], !v[10] && v[10] != "" ? null : new IFC2X3.IfcLengthMeasure(!v[10] && v[10] != "" ? null : v[10].value)),
  1305183839: (v) => new IFC2X3.IfcSpaceHeaterType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  652456506: (v) => new IFC2X3.IfcSpaceProgram(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), new IFC2X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC2X3.IfcAreaMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcAreaMeasure(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new Handle(!v[8] && v[8] != "" ? null : v[8].value), new IFC2X3.IfcAreaMeasure(!v[9] && v[9] != "" ? null : v[9].value)),
  3812236995: (v) => new IFC2X3.IfcSpaceType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3112655638: (v) => new IFC2X3.IfcStackTerminalType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1039846685: (v) => new IFC2X3.IfcStairFlightType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  682877961: (v) => new IFC2X3.IfcStructuralAction(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), new Handle(!v[7] && v[7] != "" ? null : v[7].value), v[8], !v[9] && v[9] != "" ? null : v[9].value, !v[10] && v[10] != "" ? null : new Handle(!v[10] && v[10] != "" ? null : v[10].value)),
  1179482911: (v) => new IFC2X3.IfcStructuralConnection(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value)),
  4243806635: (v) => new IFC2X3.IfcStructuralCurveConnection(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value)),
  214636428: (v) => new IFC2X3.IfcStructuralCurveMember(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), v[7]),
  2445595289: (v) => new IFC2X3.IfcStructuralCurveMemberVarying(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), v[7]),
  1807405624: (v) => new IFC2X3.IfcStructuralLinearAction(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), new Handle(!v[7] && v[7] != "" ? null : v[7].value), v[8], !v[9] && v[9] != "" ? null : v[9].value, !v[10] && v[10] != "" ? null : new Handle(!v[10] && v[10] != "" ? null : v[10].value), v[11]),
  1721250024: (v) => new IFC2X3.IfcStructuralLinearActionVarying(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), new Handle(!v[7] && v[7] != "" ? null : v[7].value), v[8], !v[9] && v[9] != "" ? null : v[9].value, !v[10] && v[10] != "" ? null : new Handle(!v[10] && v[10] != "" ? null : v[10].value), v[11], new Handle(!v[12] && v[12] != "" ? null : v[12].value), v[13]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1252848954: (v) => new IFC2X3.IfcStructuralLoadGroup(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), v[5], v[6], v[7], !v[8] && v[8] != "" ? null : new IFC2X3.IfcRatioMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC2X3.IfcLabel(!v[9] && v[9] != "" ? null : v[9].value)),
  1621171031: (v) => new IFC2X3.IfcStructuralPlanarAction(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), new Handle(!v[7] && v[7] != "" ? null : v[7].value), v[8], !v[9] && v[9] != "" ? null : v[9].value, !v[10] && v[10] != "" ? null : new Handle(!v[10] && v[10] != "" ? null : v[10].value), v[11]),
  3987759626: (v) => new IFC2X3.IfcStructuralPlanarActionVarying(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), new Handle(!v[7] && v[7] != "" ? null : v[7].value), v[8], !v[9] && v[9] != "" ? null : v[9].value, !v[10] && v[10] != "" ? null : new Handle(!v[10] && v[10] != "" ? null : v[10].value), v[11], new Handle(!v[12] && v[12] != "" ? null : v[12].value), v[13]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2082059205: (v) => new IFC2X3.IfcStructuralPointAction(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), new Handle(!v[7] && v[7] != "" ? null : v[7].value), v[8], !v[9] && v[9] != "" ? null : v[9].value, !v[10] && v[10] != "" ? null : new Handle(!v[10] && v[10] != "" ? null : v[10].value)),
  734778138: (v) => new IFC2X3.IfcStructuralPointConnection(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value)),
  1235345126: (v) => new IFC2X3.IfcStructuralPointReaction(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), new Handle(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  2986769608: (v) => new IFC2X3.IfcStructuralResultGroup(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), v[5], !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : v[7].value),
  1975003073: (v) => new IFC2X3.IfcStructuralSurfaceConnection(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value)),
  148013059: (v) => new IFC2X3.IfcSubContractResource(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC2X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC2X3.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), v[7], !v[8] && v[8] != "" ? null : new Handle(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new Handle(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC2X3.IfcText(!v[10] && v[10] != "" ? null : v[10].value)),
  2315554128: (v) => new IFC2X3.IfcSwitchingDeviceType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2254336722: (v) => new IFC2X3.IfcSystem(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  5716631: (v) => new IFC2X3.IfcTankType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1637806684: (v) => new IFC2X3.IfcTimeSeriesSchedule(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[6], new Handle(!v[7] && v[7] != "" ? null : v[7].value)),
  1692211062: (v) => new IFC2X3.IfcTransformerType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1620046519: (v) => new IFC2X3.IfcTransportElement(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8], !v[9] && v[9] != "" ? null : new IFC2X3.IfcMassMeasure(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC2X3.IfcCountMeasure(!v[10] && v[10] != "" ? null : v[10].value)),
  3593883385: (v) => new IFC2X3.IfcTrimmedCurve(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[3] && v[3] != "" ? null : v[3].value, v[4]),
  1600972822: (v) => new IFC2X3.IfcTubeBundleType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1911125066: (v) => new IFC2X3.IfcUnitaryEquipmentType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  728799441: (v) => new IFC2X3.IfcValveType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2769231204: (v) => new IFC2X3.IfcVirtualElement(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  1898987631: (v) => new IFC2X3.IfcWallType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1133259667: (v) => new IFC2X3.IfcWasteTerminalType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1028945134: (v) => new IFC2X3.IfcWorkControl(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), new IFC2X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC2X3.IfcTimeMeasure(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC2X3.IfcTimeMeasure(!v[10] && v[10] != "" ? null : v[10].value), new Handle(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new Handle(!v[12] && v[12] != "" ? null : v[12].value), v[13], !v[14] && v[14] != "" ? null : new IFC2X3.IfcLabel(!v[14] && v[14] != "" ? null : v[14].value)),
  4218914973: (v) => new IFC2X3.IfcWorkPlan(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), new IFC2X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC2X3.IfcTimeMeasure(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC2X3.IfcTimeMeasure(!v[10] && v[10] != "" ? null : v[10].value), new Handle(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new Handle(!v[12] && v[12] != "" ? null : v[12].value), v[13], !v[14] && v[14] != "" ? null : new IFC2X3.IfcLabel(!v[14] && v[14] != "" ? null : v[14].value)),
  3342526732: (v) => new IFC2X3.IfcWorkSchedule(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), new IFC2X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC2X3.IfcTimeMeasure(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC2X3.IfcTimeMeasure(!v[10] && v[10] != "" ? null : v[10].value), new Handle(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new Handle(!v[12] && v[12] != "" ? null : v[12].value), v[13], !v[14] && v[14] != "" ? null : new IFC2X3.IfcLabel(!v[14] && v[14] != "" ? null : v[14].value)),
  1033361043: (v) => new IFC2X3.IfcZone(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  1213861670: (v) => new IFC2X3.Ifc2DCompositeCurve(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[1] && v[1] != "" ? null : v[1].value),
  3821786052: (v) => new IFC2X3.IfcActionRequest(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), new IFC2X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value)),
  1411407467: (v) => new IFC2X3.IfcAirTerminalBoxType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3352864051: (v) => new IFC2X3.IfcAirTerminalType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1871374353: (v) => new IFC2X3.IfcAirToAirHeatRecoveryType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2470393545: (v) => new IFC2X3.IfcAngularDimension(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3460190687: (v) => new IFC2X3.IfcAsset(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), new IFC2X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), new Handle(!v[6] && v[6] != "" ? null : v[6].value), new Handle(!v[7] && v[7] != "" ? null : v[7].value), new Handle(!v[8] && v[8] != "" ? null : v[8].value), new Handle(!v[9] && v[9] != "" ? null : v[9].value), new Handle(!v[10] && v[10] != "" ? null : v[10].value), new Handle(!v[11] && v[11] != "" ? null : v[11].value), new Handle(!v[12] && v[12] != "" ? null : v[12].value), new Handle(!v[13] && v[13] != "" ? null : v[13].value)),
  1967976161: (v) => new IFC2X3.IfcBSplineCurve(!v[0] && v[0] != "" ? null : v[0].value, v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[2], !v[3] && v[3] != "" ? null : v[3].value, !v[4] && v[4] != "" ? null : v[4].value),
  819618141: (v) => new IFC2X3.IfcBeamType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1916977116: (v) => new IFC2X3.IfcBezierCurve(!v[0] && v[0] != "" ? null : v[0].value, v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[2], !v[3] && v[3] != "" ? null : v[3].value, !v[4] && v[4] != "" ? null : v[4].value),
  231477066: (v) => new IFC2X3.IfcBoilerType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3299480353: (v) => new IFC2X3.IfcBuildingElement(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  52481810: (v) => new IFC2X3.IfcBuildingElementComponent(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  2979338954: (v) => new IFC2X3.IfcBuildingElementPart(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  1095909175: (v) => new IFC2X3.IfcBuildingElementProxy(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1909888760: (v) => new IFC2X3.IfcBuildingElementProxyType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  395041908: (v) => new IFC2X3.IfcCableCarrierFittingType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3293546465: (v) => new IFC2X3.IfcCableCarrierSegmentType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1285652485: (v) => new IFC2X3.IfcCableSegmentType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2951183804: (v) => new IFC2X3.IfcChillerType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2611217952: (v) => new IFC2X3.IfcCircle(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC2X3.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value)),
  2301859152: (v) => new IFC2X3.IfcCoilType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  843113511: (v) => new IFC2X3.IfcColumn(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  3850581409: (v) => new IFC2X3.IfcCompressorType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2816379211: (v) => new IFC2X3.IfcCondenserType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2188551683: (v) => new IFC2X3.IfcCondition(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  1163958913: (v) => new IFC2X3.IfcConditionCriterion(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value), new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  3898045240: (v) => new IFC2X3.IfcConstructionEquipmentResource(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC2X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC2X3.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), v[7], !v[8] && v[8] != "" ? null : new Handle(!v[8] && v[8] != "" ? null : v[8].value)),
  1060000209: (v) => new IFC2X3.IfcConstructionMaterialResource(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC2X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC2X3.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), v[7], !v[8] && v[8] != "" ? null : new Handle(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : v[9]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[10] && v[10] != "" ? null : new IFC2X3.IfcRatioMeasure(!v[10] && v[10] != "" ? null : v[10].value)),
  488727124: (v) => new IFC2X3.IfcConstructionProductResource(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC2X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC2X3.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), v[7], !v[8] && v[8] != "" ? null : new Handle(!v[8] && v[8] != "" ? null : v[8].value)),
  335055490: (v) => new IFC2X3.IfcCooledBeamType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2954562838: (v) => new IFC2X3.IfcCoolingTowerType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1973544240: (v) => new IFC2X3.IfcCovering(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3495092785: (v) => new IFC2X3.IfcCurtainWall(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  3961806047: (v) => new IFC2X3.IfcDamperType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  4147604152: (v) => new IFC2X3.IfcDiameterDimension(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1335981549: (v) => new IFC2X3.IfcDiscreteAccessory(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  2635815018: (v) => new IFC2X3.IfcDiscreteAccessoryType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  1599208980: (v) => new IFC2X3.IfcDistributionChamberElementType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2063403501: (v) => new IFC2X3.IfcDistributionControlElementType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  1945004755: (v) => new IFC2X3.IfcDistributionElement(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  3040386961: (v) => new IFC2X3.IfcDistributionFlowElement(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  3041715199: (v) => new IFC2X3.IfcDistributionPort(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), v[7]),
  395920057: (v) => new IFC2X3.IfcDoor(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[9] && v[9] != "" ? null : v[9].value)),
  869906466: (v) => new IFC2X3.IfcDuctFittingType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3760055223: (v) => new IFC2X3.IfcDuctSegmentType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2030761528: (v) => new IFC2X3.IfcDuctSilencerType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  855621170: (v) => new IFC2X3.IfcEdgeFeature(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value)),
  663422040: (v) => new IFC2X3.IfcElectricApplianceType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3277789161: (v) => new IFC2X3.IfcElectricFlowStorageDeviceType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1534661035: (v) => new IFC2X3.IfcElectricGeneratorType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1365060375: (v) => new IFC2X3.IfcElectricHeaterType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1217240411: (v) => new IFC2X3.IfcElectricMotorType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  712377611: (v) => new IFC2X3.IfcElectricTimeControlType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1634875225: (v) => new IFC2X3.IfcElectricalCircuit(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  857184966: (v) => new IFC2X3.IfcElectricalElement(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  1658829314: (v) => new IFC2X3.IfcEnergyConversionDevice(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  346874300: (v) => new IFC2X3.IfcFanType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1810631287: (v) => new IFC2X3.IfcFilterType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  4222183408: (v) => new IFC2X3.IfcFireSuppressionTerminalType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2058353004: (v) => new IFC2X3.IfcFlowController(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  4278956645: (v) => new IFC2X3.IfcFlowFitting(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  4037862832: (v) => new IFC2X3.IfcFlowInstrumentType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3132237377: (v) => new IFC2X3.IfcFlowMovingDevice(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  987401354: (v) => new IFC2X3.IfcFlowSegment(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  707683696: (v) => new IFC2X3.IfcFlowStorageDevice(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  2223149337: (v) => new IFC2X3.IfcFlowTerminal(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  3508470533: (v) => new IFC2X3.IfcFlowTreatmentDevice(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  900683007: (v) => new IFC2X3.IfcFooting(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1073191201: (v) => new IFC2X3.IfcMember(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  1687234759: (v) => new IFC2X3.IfcPile(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8], v[9]),
  3171933400: (v) => new IFC2X3.IfcPlate(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  2262370178: (v) => new IFC2X3.IfcRailing(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3024970846: (v) => new IFC2X3.IfcRamp(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3283111854: (v) => new IFC2X3.IfcRampFlight(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  3055160366: (v) => new IFC2X3.IfcRationalBezierCurve(!v[0] && v[0] != "" ? null : v[0].value, v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[2], !v[3] && v[3] != "" ? null : v[3].value, !v[4] && v[4] != "" ? null : v[4].value, v[5]?.map((p) => p?.value && p?.value != "" ? Number(p.value) : null) || []),
  3027567501: (v) => new IFC2X3.IfcReinforcingElement(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  2320036040: (v) => new IFC2X3.IfcReinforcingMesh(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[10] && v[10] != "" ? null : v[10].value), new IFC2X3.IfcPositiveLengthMeasure(!v[11] && v[11] != "" ? null : v[11].value), new IFC2X3.IfcPositiveLengthMeasure(!v[12] && v[12] != "" ? null : v[12].value), new IFC2X3.IfcAreaMeasure(!v[13] && v[13] != "" ? null : v[13].value), new IFC2X3.IfcAreaMeasure(!v[14] && v[14] != "" ? null : v[14].value), new IFC2X3.IfcPositiveLengthMeasure(!v[15] && v[15] != "" ? null : v[15].value), new IFC2X3.IfcPositiveLengthMeasure(!v[16] && v[16] != "" ? null : v[16].value)),
  2016517767: (v) => new IFC2X3.IfcRoof(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1376911519: (v) => new IFC2X3.IfcRoundedEdgeFeature(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[9] && v[9] != "" ? null : v[9].value)),
  1783015770: (v) => new IFC2X3.IfcSensorType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1529196076: (v) => new IFC2X3.IfcSlab(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  331165859: (v) => new IFC2X3.IfcStair(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  4252922144: (v) => new IFC2X3.IfcStairFlight(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : !v[8] && v[8] != "" ? null : v[8].value, !v[9] && v[9] != "" ? null : !v[9] && v[9] != "" ? null : v[9].value, !v[10] && v[10] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[11] && v[11] != "" ? null : v[11].value)),
  2515109513: (v) => new IFC2X3.IfcStructuralAnalysisModel(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), v[5], !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[8] && v[8] != "" ? null : v[8]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3824725483: (v) => new IFC2X3.IfcTendon(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9], new IFC2X3.IfcPositiveLengthMeasure(!v[10] && v[10] != "" ? null : v[10].value), new IFC2X3.IfcAreaMeasure(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC2X3.IfcForceMeasure(!v[12] && v[12] != "" ? null : v[12].value), !v[13] && v[13] != "" ? null : new IFC2X3.IfcPressureMeasure(!v[13] && v[13] != "" ? null : v[13].value), !v[14] && v[14] != "" ? null : new IFC2X3.IfcNormalisedRatioMeasure(!v[14] && v[14] != "" ? null : v[14].value), !v[15] && v[15] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[15] && v[15] != "" ? null : v[15].value), !v[16] && v[16] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[16] && v[16] != "" ? null : v[16].value)),
  2347447852: (v) => new IFC2X3.IfcTendonAnchor(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  3313531582: (v) => new IFC2X3.IfcVibrationIsolatorType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2391406946: (v) => new IFC2X3.IfcWall(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  3512223829: (v) => new IFC2X3.IfcWallStandardCase(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  3304561284: (v) => new IFC2X3.IfcWindow(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[9] && v[9] != "" ? null : v[9].value)),
  2874132201: (v) => new IFC2X3.IfcActuatorType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3001207471: (v) => new IFC2X3.IfcAlarmType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  753842376: (v) => new IFC2X3.IfcBeam(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  2454782716: (v) => new IFC2X3.IfcChamferEdgeFeature(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[10] && v[10] != "" ? null : v[10].value)),
  578613899: (v) => new IFC2X3.IfcControllerType(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC2X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1052013943: (v) => new IFC2X3.IfcDistributionChamberElement(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  1062813311: (v) => new IFC2X3.IfcDistributionControlElement(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcIdentifier(!v[8] && v[8] != "" ? null : v[8].value)),
  3700593921: (v) => new IFC2X3.IfcElectricDistributionPoint(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8], !v[9] && v[9] != "" ? null : new IFC2X3.IfcLabel(!v[9] && v[9] != "" ? null : v[9].value)),
  979691226: (v) => new IFC2X3.IfcReinforcingBar(new IFC2X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC2X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC2X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC2X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC2X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC2X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), new IFC2X3.IfcPositiveLengthMeasure(!v[9] && v[9] != "" ? null : v[9].value), new IFC2X3.IfcAreaMeasure(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC2X3.IfcPositiveLengthMeasure(!v[11] && v[11] != "" ? null : v[11].value), v[12], v[13])
};
InheritanceDef[1] = {
  618182010: [IFCTELECOMADDRESS, IFCPOSTALADDRESS],
  411424972: [IFCENVIRONMENTALIMPACTVALUE, IFCCOSTVALUE],
  4037036970: [IFCBOUNDARYNODECONDITIONWARPING, IFCBOUNDARYNODECONDITION, IFCBOUNDARYFACECONDITION, IFCBOUNDARYEDGECONDITION],
  1387855156: [IFCBOUNDARYNODECONDITIONWARPING],
  3264961684: [IFCCOLOURRGB],
  2859738748: [IFCCONNECTIONCURVEGEOMETRY, IFCCONNECTIONSURFACEGEOMETRY, IFCCONNECTIONPORTGEOMETRY, IFCCONNECTIONPOINTECCENTRICITY, IFCCONNECTIONPOINTGEOMETRY],
  2614616156: [IFCCONNECTIONPOINTECCENTRICITY],
  1959218052: [IFCOBJECTIVE, IFCMETRIC],
  3796139169: [IFCDIMENSIONPAIR, IFCDIMENSIONCALLOUTRELATIONSHIP],
  3200245327: [IFCDOCUMENTREFERENCE, IFCCLASSIFICATIONREFERENCE, IFCLIBRARYREFERENCE, IFCEXTERNALLYDEFINEDTEXTFONT, IFCEXTERNALLYDEFINEDSYMBOL, IFCEXTERNALLYDEFINEDSURFACESTYLE, IFCEXTERNALLYDEFINEDHATCHSTYLE],
  3265635763: [IFCHYGROSCOPICMATERIALPROPERTIES, IFCGENERALMATERIALPROPERTIES, IFCFUELPROPERTIES, IFCEXTENDEDMATERIALPROPERTIES, IFCWATERPROPERTIES, IFCTHERMALMATERIALPROPERTIES, IFCPRODUCTSOFCOMBUSTIONPROPERTIES, IFCOPTICALMATERIALPROPERTIES, IFCMECHANICALCONCRETEMATERIALPROPERTIES, IFCMECHANICALSTEELMATERIALPROPERTIES, IFCMECHANICALMATERIALPROPERTIES],
  4256014907: [IFCMECHANICALCONCRETEMATERIALPROPERTIES, IFCMECHANICALSTEELMATERIALPROPERTIES],
  1918398963: [IFCCONVERSIONBASEDUNIT, IFCCONTEXTDEPENDENTUNIT, IFCSIUNIT],
  3701648758: [IFCLOCALPLACEMENT, IFCGRIDPLACEMENT],
  2483315170: [IFCPHYSICALCOMPLEXQUANTITY, IFCQUANTITYWEIGHT, IFCQUANTITYVOLUME, IFCQUANTITYTIME, IFCQUANTITYLENGTH, IFCQUANTITYCOUNT, IFCQUANTITYAREA, IFCPHYSICALSIMPLEQUANTITY],
  2226359599: [IFCQUANTITYWEIGHT, IFCQUANTITYVOLUME, IFCQUANTITYTIME, IFCQUANTITYLENGTH, IFCQUANTITYCOUNT, IFCQUANTITYAREA],
  3727388367: [IFCDRAUGHTINGPREDEFINEDCURVEFONT, IFCPREDEFINEDCURVEFONT, IFCDRAUGHTINGPREDEFINEDCOLOUR, IFCPREDEFINEDCOLOUR, IFCDRAUGHTINGPREDEFINEDTEXTFONT, IFCTEXTSTYLEFONTMODEL, IFCPREDEFINEDTEXTFONT, IFCPREDEFINEDPOINTMARKERSYMBOL, IFCPREDEFINEDDIMENSIONSYMBOL, IFCPREDEFINEDTERMINATORSYMBOL, IFCPREDEFINEDSYMBOL],
  990879717: [IFCPREDEFINEDPOINTMARKERSYMBOL, IFCPREDEFINEDDIMENSIONSYMBOL, IFCPREDEFINEDTERMINATORSYMBOL],
  1775413392: [IFCDRAUGHTINGPREDEFINEDTEXTFONT, IFCTEXTSTYLEFONTMODEL],
  2022622350: [IFCPRESENTATIONLAYERWITHSTYLE],
  3119450353: [IFCFILLAREASTYLE, IFCCURVESTYLE, IFCTEXTSTYLE, IFCSYMBOLSTYLE, IFCSURFACESTYLE],
  2095639259: [IFCPRODUCTDEFINITIONSHAPE, IFCMATERIALDEFINITIONREPRESENTATION],
  3958567839: [IFCLSHAPEPROFILEDEF, IFCASYMMETRICISHAPEPROFILEDEF, IFCISHAPEPROFILEDEF, IFCELLIPSEPROFILEDEF, IFCCRANERAILFSHAPEPROFILEDEF, IFCCRANERAILASHAPEPROFILEDEF, IFCCIRCLEHOLLOWPROFILEDEF, IFCCIRCLEPROFILEDEF, IFCCSHAPEPROFILEDEF, IFCZSHAPEPROFILEDEF, IFCUSHAPEPROFILEDEF, IFCTRAPEZIUMPROFILEDEF, IFCTSHAPEPROFILEDEF, IFCRECTANGLEHOLLOWPROFILEDEF, IFCROUNDEDRECTANGLEPROFILEDEF, IFCRECTANGLEPROFILEDEF, IFCPARAMETERIZEDPROFILEDEF, IFCDERIVEDPROFILEDEF, IFCCOMPOSITEPROFILEDEF, IFCCENTERLINEPROFILEDEF, IFCARBITRARYOPENPROFILEDEF, IFCARBITRARYPROFILEDEFWITHVOIDS, IFCARBITRARYCLOSEDPROFILEDEF],
  2802850158: [IFCSTRUCTURALSTEELPROFILEPROPERTIES, IFCSTRUCTURALPROFILEPROPERTIES, IFCGENERALPROFILEPROPERTIES, IFCRIBPLATEPROFILEPROPERTIES],
  2598011224: [IFCCOMPLEXPROPERTY, IFCPROPERTYTABLEVALUE, IFCPROPERTYSINGLEVALUE, IFCPROPERTYREFERENCEVALUE, IFCPROPERTYLISTVALUE, IFCPROPERTYENUMERATEDVALUE, IFCPROPERTYBOUNDEDVALUE, IFCSIMPLEPROPERTY],
  1076942058: [IFCSTYLEDREPRESENTATION, IFCSTYLEMODEL, IFCTOPOLOGYREPRESENTATION, IFCSHAPEREPRESENTATION, IFCSHAPEMODEL],
  3377609919: [IFCGEOMETRICREPRESENTATIONSUBCONTEXT, IFCGEOMETRICREPRESENTATIONCONTEXT],
  3008791417: [IFCMAPPEDITEM, IFCFILLAREASTYLETILES, IFCFILLAREASTYLETILESYMBOLWITHSTYLE, IFCFILLAREASTYLEHATCHING, IFCFACEBASEDSURFACEMODEL, IFCDIAMETERDIMENSION, IFCANGULARDIMENSION, IFCRADIUSDIMENSION, IFCLINEARDIMENSION, IFCDIMENSIONCURVEDIRECTEDCALLOUT, IFCSTRUCTUREDDIMENSIONCALLOUT, IFCDRAUGHTINGCALLOUT, IFCDIRECTION, IFCDEFINEDSYMBOL, IFCCIRCLE, IFCELLIPSE, IFCCONIC, IFCRATIONALBEZIERCURVE, IFCBEZIERCURVE, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFC2DCOMPOSITECURVE, IFCCOMPOSITECURVE, IFCBOUNDEDCURVE, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D, IFCLINE, IFCCURVE, IFCBLOCK, IFCSPHERE, IFCRIGHTCIRCULARCYLINDER, IFCRIGHTCIRCULARCONE, IFCRECTANGULARPYRAMID, IFCCSGPRIMITIVE3D, IFCCOMPOSITECURVESEGMENT, IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR3D, IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR2D, IFCCARTESIANTRANSFORMATIONOPERATOR, IFCBOUNDINGBOX, IFCBOOLEANCLIPPINGRESULT, IFCBOOLEANRESULT, IFCANNOTATIONSURFACE, IFCANNOTATIONFILLAREA, IFCVECTOR, IFCTEXTLITERALWITHEXTENT, IFCTEXTLITERAL, IFCPLANE, IFCELEMENTARYSURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDPLANE, IFCBOUNDEDSURFACE, IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION, IFCSWEPTSURFACE, IFCSURFACE, IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCMANIFOLDSOLIDBREP, IFCCSGSOLID, IFCSWEPTDISKSOLID, IFCSURFACECURVESWEPTAREASOLID, IFCREVOLVEDAREASOLID, IFCEXTRUDEDAREASOLID, IFCSWEPTAREASOLID, IFCSOLIDMODEL, IFCSHELLBASEDSURFACEMODEL, IFCSECTIONEDSPINE, IFCCARTESIANPOINT, IFCPOINTONSURFACE, IFCPOINTONCURVE, IFCPOINT, IFCPLANARBOX, IFCPLANAREXTENT, IFCAXIS2PLACEMENT3D, IFCAXIS2PLACEMENT2D, IFCAXIS1PLACEMENT, IFCPLACEMENT, IFCTWODIRECTIONREPEATFACTOR, IFCONEDIRECTIONREPEATFACTOR, IFCLIGHTSOURCESPOT, IFCLIGHTSOURCEPOSITIONAL, IFCLIGHTSOURCEGONIOMETRIC, IFCLIGHTSOURCEDIRECTIONAL, IFCLIGHTSOURCEAMBIENT, IFCLIGHTSOURCE, IFCBOXEDHALFSPACE, IFCPOLYGONALBOUNDEDHALFSPACE, IFCHALFSPACESOLID, IFCGEOMETRICCURVESET, IFCGEOMETRICSET, IFCGEOMETRICREPRESENTATIONITEM, IFCPATH, IFCEDGELOOP, IFCVERTEXLOOP, IFCPOLYLOOP, IFCLOOP, IFCFACEOUTERBOUND, IFCFACEBOUND, IFCFACESURFACE, IFCFACE, IFCSUBEDGE, IFCORIENTEDEDGE, IFCEDGECURVE, IFCEDGE, IFCCLOSEDSHELL, IFCOPENSHELL, IFCCONNECTEDFACESET, IFCVERTEXPOINT, IFCVERTEX, IFCTOPOLOGICALREPRESENTATIONITEM, IFCANNOTATIONFILLAREAOCCURRENCE, IFCPROJECTIONCURVE, IFCDIMENSIONCURVE, IFCANNOTATIONCURVEOCCURRENCE, IFCANNOTATIONTEXTOCCURRENCE, IFCDIMENSIONCURVETERMINATOR, IFCTERMINATORSYMBOL, IFCANNOTATIONSYMBOLOCCURRENCE, IFCANNOTATIONSURFACEOCCURRENCE, IFCANNOTATIONOCCURRENCE, IFCSTYLEDITEM],
  2341007311: [IFCRELDEFINESBYTYPE, IFCRELOVERRIDESPROPERTIES, IFCRELDEFINESBYPROPERTIES, IFCRELDEFINES, IFCRELAGGREGATES, IFCRELNESTS, IFCRELDECOMPOSES, IFCRELVOIDSELEMENT, IFCRELSPACEBOUNDARY, IFCRELSERVICESBUILDINGS, IFCRELSEQUENCE, IFCRELREFERENCEDINSPATIALSTRUCTURE, IFCRELPROJECTSELEMENT, IFCRELINTERACTIONREQUIREMENTS, IFCRELFLOWCONTROLELEMENTS, IFCRELFILLSELEMENT, IFCRELCOVERSSPACES, IFCRELCOVERSBLDGELEMENTS, IFCRELCONTAINEDINSPATIALSTRUCTURE, IFCRELCONNECTSWITHECCENTRICITY, IFCRELCONNECTSSTRUCTURALMEMBER, IFCRELCONNECTSSTRUCTURALELEMENT, IFCRELCONNECTSSTRUCTURALACTIVITY, IFCRELCONNECTSPORTS, IFCRELCONNECTSPORTTOELEMENT, IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS, IFCRELCONNECTSELEMENTS, IFCRELCONNECTS, IFCRELASSOCIATESPROFILEPROPERTIES, IFCRELASSOCIATESMATERIAL, IFCRELASSOCIATESLIBRARY, IFCRELASSOCIATESDOCUMENT, IFCRELASSOCIATESCONSTRAINT, IFCRELASSOCIATESCLASSIFICATION, IFCRELASSOCIATESAPPROVAL, IFCRELASSOCIATESAPPLIEDVALUE, IFCRELASSOCIATES, IFCRELASSIGNSTORESOURCE, IFCRELASSIGNSTOPRODUCT, IFCRELASSIGNSTOPROCESS, IFCRELASSIGNSTOGROUP, IFCRELASSIGNSTASKS, IFCRELSCHEDULESCOSTITEMS, IFCRELASSIGNSTOPROJECTORDER, IFCRELASSIGNSTOCONTROL, IFCRELOCCUPIESSPACES, IFCRELASSIGNSTOACTOR, IFCRELASSIGNS, IFCRELATIONSHIP, IFCPROPERTYSET, IFCPERMEABLECOVERINGPROPERTIES, IFCFLUIDFLOWPROPERTIES, IFCELECTRICALBASEPROPERTIES, IFCENERGYPROPERTIES, IFCELEMENTQUANTITY, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCSPACETHERMALLOADPROPERTIES, IFCSOUNDVALUE, IFCSOUNDPROPERTIES, IFCSERVICELIFEFACTOR, IFCREINFORCEMENTDEFINITIONPROPERTIES, IFCPROPERTYSETDEFINITION, IFCPROPERTYDEFINITION, IFCCONDITION, IFCASSET, IFCZONE, IFCSTRUCTURALANALYSISMODEL, IFCELECTRICALCIRCUIT, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADGROUP, IFCINVENTORY, IFCGROUP, IFCCONDITIONCRITERION, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCTIMESERIESSCHEDULE, IFCSPACEPROGRAM, IFCSERVICELIFE, IFCSCHEDULETIMECONTROL, IFCPROJECTORDERRECORD, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCFURNITURESTANDARD, IFCEQUIPMENTSTANDARD, IFCCOSTSCHEDULE, IFCCOSTITEM, IFCCONTROL, IFCOCCUPANT, IFCACTOR, IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE, IFCRESOURCE, IFCPROJECT, IFCDISTRIBUTIONPORT, IFCPORT, IFCGRID, IFCELECTRICALELEMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFLOWTREATMENTDEVICE, IFCFLOWTERMINAL, IFCFLOWSTORAGEDEVICE, IFCFLOWSEGMENT, IFCFLOWMOVINGDEVICE, IFCFLOWFITTING, IFCELECTRICDISTRIBUTIONPOINT, IFCFLOWCONTROLLER, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATE, IFCPILE, IFCMEMBER, IFCFOOTING, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMN, IFCBUILDINGELEMENTPROXY, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCBUILDINGELEMENTPART, IFCBUILDINGELEMENTCOMPONENT, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCFURNISHINGELEMENT, IFCCHAMFEREDGEFEATURE, IFCROUNDEDEDGEFEATURE, IFCEDGEFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCEQUIPMENTELEMENT, IFCDISCRETEACCESSORY, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALPLANARACTIONVARYING, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALLINEARACTIONVARYING, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING, IFCSPATIALSTRUCTUREELEMENT, IFCPROXY, IFCPRODUCT, IFCPROCEDURE, IFCORDERACTION, IFCMOVE, IFCTASK, IFCPROCESS, IFCOBJECT, IFCVIBRATIONISOLATORTYPE, IFCDISCRETEACCESSORYTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCSENSORTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICHEATERTYPE, IFCELECTRICAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCGASTERMINALTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSPACEHEATERTYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWALLTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCMEMBERTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCDOORSTYLE, IFCWINDOWSTYLE, IFCTYPEPRODUCT, IFCTYPEOBJECT, IFCOBJECTDEFINITION],
  3982875396: [IFCTOPOLOGYREPRESENTATION, IFCSHAPEREPRESENTATION],
  3692461612: [IFCPROPERTYTABLEVALUE, IFCPROPERTYSINGLEVALUE, IFCPROPERTYREFERENCEVALUE, IFCPROPERTYLISTVALUE, IFCPROPERTYENUMERATEDVALUE, IFCPROPERTYBOUNDEDVALUE],
  2273995522: [IFCSLIPPAGECONNECTIONCONDITION, IFCFAILURECONNECTIONCONDITION],
  2162789131: [IFCSTRUCTURALLOADSINGLEFORCEWARPING, IFCSTRUCTURALLOADSINGLEFORCE, IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION, IFCSTRUCTURALLOADSINGLEDISPLACEMENT, IFCSTRUCTURALLOADPLANARFORCE, IFCSTRUCTURALLOADLINEARFORCE, IFCSTRUCTURALLOADTEMPERATURE, IFCSTRUCTURALLOADSTATIC],
  2525727697: [IFCSTRUCTURALLOADSINGLEFORCEWARPING, IFCSTRUCTURALLOADSINGLEFORCE, IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION, IFCSTRUCTURALLOADSINGLEDISPLACEMENT, IFCSTRUCTURALLOADPLANARFORCE, IFCSTRUCTURALLOADLINEARFORCE, IFCSTRUCTURALLOADTEMPERATURE],
  2830218821: [IFCSTYLEDREPRESENTATION],
  3958052878: [IFCANNOTATIONFILLAREAOCCURRENCE, IFCPROJECTIONCURVE, IFCDIMENSIONCURVE, IFCANNOTATIONCURVEOCCURRENCE, IFCANNOTATIONTEXTOCCURRENCE, IFCDIMENSIONCURVETERMINATOR, IFCTERMINATORSYMBOL, IFCANNOTATIONSYMBOLOCCURRENCE, IFCANNOTATIONSURFACEOCCURRENCE, IFCANNOTATIONOCCURRENCE],
  846575682: [IFCSURFACESTYLERENDERING],
  626085974: [IFCPIXELTEXTURE, IFCIMAGETEXTURE, IFCBLOBTEXTURE],
  280115917: [IFCTEXTUREMAP, IFCTEXTURECOORDINATEGENERATOR],
  3101149627: [IFCREGULARTIMESERIES, IFCIRREGULARTIMESERIES],
  1377556343: [IFCPATH, IFCEDGELOOP, IFCVERTEXLOOP, IFCPOLYLOOP, IFCLOOP, IFCFACEOUTERBOUND, IFCFACEBOUND, IFCFACESURFACE, IFCFACE, IFCSUBEDGE, IFCORIENTEDEDGE, IFCEDGECURVE, IFCEDGE, IFCCLOSEDSHELL, IFCOPENSHELL, IFCCONNECTEDFACESET, IFCVERTEXPOINT, IFCVERTEX],
  2799835756: [IFCVERTEXPOINT],
  2442683028: [IFCANNOTATIONFILLAREAOCCURRENCE, IFCPROJECTIONCURVE, IFCDIMENSIONCURVE, IFCANNOTATIONCURVEOCCURRENCE, IFCANNOTATIONTEXTOCCURRENCE, IFCDIMENSIONCURVETERMINATOR, IFCTERMINATORSYMBOL, IFCANNOTATIONSYMBOLOCCURRENCE, IFCANNOTATIONSURFACEOCCURRENCE],
  3612888222: [IFCDIMENSIONCURVETERMINATOR, IFCTERMINATORSYMBOL],
  3798115385: [IFCARBITRARYPROFILEDEFWITHVOIDS],
  1310608509: [IFCCENTERLINEPROFILEDEF],
  370225590: [IFCCLOSEDSHELL, IFCOPENSHELL],
  3900360178: [IFCSUBEDGE, IFCORIENTEDEDGE, IFCEDGECURVE],
  2556980723: [IFCFACESURFACE],
  1809719519: [IFCFACEOUTERBOUND],
  1446786286: [IFCSTRUCTURALSTEELPROFILEPROPERTIES, IFCSTRUCTURALPROFILEPROPERTIES],
  3448662350: [IFCGEOMETRICREPRESENTATIONSUBCONTEXT],
  2453401579: [IFCFILLAREASTYLETILES, IFCFILLAREASTYLETILESYMBOLWITHSTYLE, IFCFILLAREASTYLEHATCHING, IFCFACEBASEDSURFACEMODEL, IFCDIAMETERDIMENSION, IFCANGULARDIMENSION, IFCRADIUSDIMENSION, IFCLINEARDIMENSION, IFCDIMENSIONCURVEDIRECTEDCALLOUT, IFCSTRUCTUREDDIMENSIONCALLOUT, IFCDRAUGHTINGCALLOUT, IFCDIRECTION, IFCDEFINEDSYMBOL, IFCCIRCLE, IFCELLIPSE, IFCCONIC, IFCRATIONALBEZIERCURVE, IFCBEZIERCURVE, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFC2DCOMPOSITECURVE, IFCCOMPOSITECURVE, IFCBOUNDEDCURVE, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D, IFCLINE, IFCCURVE, IFCBLOCK, IFCSPHERE, IFCRIGHTCIRCULARCYLINDER, IFCRIGHTCIRCULARCONE, IFCRECTANGULARPYRAMID, IFCCSGPRIMITIVE3D, IFCCOMPOSITECURVESEGMENT, IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR3D, IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR2D, IFCCARTESIANTRANSFORMATIONOPERATOR, IFCBOUNDINGBOX, IFCBOOLEANCLIPPINGRESULT, IFCBOOLEANRESULT, IFCANNOTATIONSURFACE, IFCANNOTATIONFILLAREA, IFCVECTOR, IFCTEXTLITERALWITHEXTENT, IFCTEXTLITERAL, IFCPLANE, IFCELEMENTARYSURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDPLANE, IFCBOUNDEDSURFACE, IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION, IFCSWEPTSURFACE, IFCSURFACE, IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCMANIFOLDSOLIDBREP, IFCCSGSOLID, IFCSWEPTDISKSOLID, IFCSURFACECURVESWEPTAREASOLID, IFCREVOLVEDAREASOLID, IFCEXTRUDEDAREASOLID, IFCSWEPTAREASOLID, IFCSOLIDMODEL, IFCSHELLBASEDSURFACEMODEL, IFCSECTIONEDSPINE, IFCCARTESIANPOINT, IFCPOINTONSURFACE, IFCPOINTONCURVE, IFCPOINT, IFCPLANARBOX, IFCPLANAREXTENT, IFCAXIS2PLACEMENT3D, IFCAXIS2PLACEMENT2D, IFCAXIS1PLACEMENT, IFCPLACEMENT, IFCTWODIRECTIONREPEATFACTOR, IFCONEDIRECTIONREPEATFACTOR, IFCLIGHTSOURCESPOT, IFCLIGHTSOURCEPOSITIONAL, IFCLIGHTSOURCEGONIOMETRIC, IFCLIGHTSOURCEDIRECTIONAL, IFCLIGHTSOURCEAMBIENT, IFCLIGHTSOURCE, IFCBOXEDHALFSPACE, IFCPOLYGONALBOUNDEDHALFSPACE, IFCHALFSPACESOLID, IFCGEOMETRICCURVESET, IFCGEOMETRICSET],
  3590301190: [IFCGEOMETRICCURVESET],
  812098782: [IFCBOXEDHALFSPACE, IFCPOLYGONALBOUNDEDHALFSPACE],
  1402838566: [IFCLIGHTSOURCESPOT, IFCLIGHTSOURCEPOSITIONAL, IFCLIGHTSOURCEGONIOMETRIC, IFCLIGHTSOURCEDIRECTIONAL, IFCLIGHTSOURCEAMBIENT],
  1520743889: [IFCLIGHTSOURCESPOT],
  1008929658: [IFCEDGELOOP, IFCVERTEXLOOP, IFCPOLYLOOP],
  219451334: [IFCCONDITION, IFCASSET, IFCZONE, IFCSTRUCTURALANALYSISMODEL, IFCELECTRICALCIRCUIT, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADGROUP, IFCINVENTORY, IFCGROUP, IFCCONDITIONCRITERION, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCTIMESERIESSCHEDULE, IFCSPACEPROGRAM, IFCSERVICELIFE, IFCSCHEDULETIMECONTROL, IFCPROJECTORDERRECORD, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCFURNITURESTANDARD, IFCEQUIPMENTSTANDARD, IFCCOSTSCHEDULE, IFCCOSTITEM, IFCCONTROL, IFCOCCUPANT, IFCACTOR, IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE, IFCRESOURCE, IFCPROJECT, IFCDISTRIBUTIONPORT, IFCPORT, IFCGRID, IFCELECTRICALELEMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFLOWTREATMENTDEVICE, IFCFLOWTERMINAL, IFCFLOWSTORAGEDEVICE, IFCFLOWSEGMENT, IFCFLOWMOVINGDEVICE, IFCFLOWFITTING, IFCELECTRICDISTRIBUTIONPOINT, IFCFLOWCONTROLLER, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATE, IFCPILE, IFCMEMBER, IFCFOOTING, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMN, IFCBUILDINGELEMENTPROXY, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCBUILDINGELEMENTPART, IFCBUILDINGELEMENTCOMPONENT, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCFURNISHINGELEMENT, IFCCHAMFEREDGEFEATURE, IFCROUNDEDEDGEFEATURE, IFCEDGEFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCEQUIPMENTELEMENT, IFCDISCRETEACCESSORY, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALPLANARACTIONVARYING, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALLINEARACTIONVARYING, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING, IFCSPATIALSTRUCTUREELEMENT, IFCPROXY, IFCPRODUCT, IFCPROCEDURE, IFCORDERACTION, IFCMOVE, IFCTASK, IFCPROCESS, IFCOBJECT, IFCVIBRATIONISOLATORTYPE, IFCDISCRETEACCESSORYTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCSENSORTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICHEATERTYPE, IFCELECTRICAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCGASTERMINALTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSPACEHEATERTYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWALLTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCMEMBERTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCDOORSTYLE, IFCWINDOWSTYLE, IFCTYPEPRODUCT, IFCTYPEOBJECT],
  2833995503: [IFCTWODIRECTIONREPEATFACTOR],
  2529465313: [IFCLSHAPEPROFILEDEF, IFCASYMMETRICISHAPEPROFILEDEF, IFCISHAPEPROFILEDEF, IFCELLIPSEPROFILEDEF, IFCCRANERAILFSHAPEPROFILEDEF, IFCCRANERAILASHAPEPROFILEDEF, IFCCIRCLEHOLLOWPROFILEDEF, IFCCIRCLEPROFILEDEF, IFCCSHAPEPROFILEDEF, IFCZSHAPEPROFILEDEF, IFCUSHAPEPROFILEDEF, IFCTRAPEZIUMPROFILEDEF, IFCTSHAPEPROFILEDEF, IFCRECTANGLEHOLLOWPROFILEDEF, IFCROUNDEDRECTANGLEPROFILEDEF, IFCRECTANGLEPROFILEDEF],
  2004835150: [IFCAXIS2PLACEMENT3D, IFCAXIS2PLACEMENT2D, IFCAXIS1PLACEMENT],
  1663979128: [IFCPLANARBOX],
  2067069095: [IFCCARTESIANPOINT, IFCPOINTONSURFACE, IFCPOINTONCURVE],
  759155922: [IFCDRAUGHTINGPREDEFINEDCOLOUR],
  2559016684: [IFCDRAUGHTINGPREDEFINEDCURVEFONT],
  1680319473: [IFCPROPERTYSET, IFCPERMEABLECOVERINGPROPERTIES, IFCFLUIDFLOWPROPERTIES, IFCELECTRICALBASEPROPERTIES, IFCENERGYPROPERTIES, IFCELEMENTQUANTITY, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCSPACETHERMALLOADPROPERTIES, IFCSOUNDVALUE, IFCSOUNDPROPERTIES, IFCSERVICELIFEFACTOR, IFCREINFORCEMENTDEFINITIONPROPERTIES, IFCPROPERTYSETDEFINITION],
  3357820518: [IFCPROPERTYSET, IFCPERMEABLECOVERINGPROPERTIES, IFCFLUIDFLOWPROPERTIES, IFCELECTRICALBASEPROPERTIES, IFCENERGYPROPERTIES, IFCELEMENTQUANTITY, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCSPACETHERMALLOADPROPERTIES, IFCSOUNDVALUE, IFCSOUNDPROPERTIES, IFCSERVICELIFEFACTOR, IFCREINFORCEMENTDEFINITIONPROPERTIES],
  3615266464: [IFCRECTANGLEHOLLOWPROFILEDEF, IFCROUNDEDRECTANGLEPROFILEDEF],
  478536968: [IFCRELDEFINESBYTYPE, IFCRELOVERRIDESPROPERTIES, IFCRELDEFINESBYPROPERTIES, IFCRELDEFINES, IFCRELAGGREGATES, IFCRELNESTS, IFCRELDECOMPOSES, IFCRELVOIDSELEMENT, IFCRELSPACEBOUNDARY, IFCRELSERVICESBUILDINGS, IFCRELSEQUENCE, IFCRELREFERENCEDINSPATIALSTRUCTURE, IFCRELPROJECTSELEMENT, IFCRELINTERACTIONREQUIREMENTS, IFCRELFLOWCONTROLELEMENTS, IFCRELFILLSELEMENT, IFCRELCOVERSSPACES, IFCRELCOVERSBLDGELEMENTS, IFCRELCONTAINEDINSPATIALSTRUCTURE, IFCRELCONNECTSWITHECCENTRICITY, IFCRELCONNECTSSTRUCTURALMEMBER, IFCRELCONNECTSSTRUCTURALELEMENT, IFCRELCONNECTSSTRUCTURALACTIVITY, IFCRELCONNECTSPORTS, IFCRELCONNECTSPORTTOELEMENT, IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS, IFCRELCONNECTSELEMENTS, IFCRELCONNECTS, IFCRELASSOCIATESPROFILEPROPERTIES, IFCRELASSOCIATESMATERIAL, IFCRELASSOCIATESLIBRARY, IFCRELASSOCIATESDOCUMENT, IFCRELASSOCIATESCONSTRAINT, IFCRELASSOCIATESCLASSIFICATION, IFCRELASSOCIATESAPPROVAL, IFCRELASSOCIATESAPPLIEDVALUE, IFCRELASSOCIATES, IFCRELASSIGNSTORESOURCE, IFCRELASSIGNSTOPRODUCT, IFCRELASSIGNSTOPROCESS, IFCRELASSIGNSTOGROUP, IFCRELASSIGNSTASKS, IFCRELSCHEDULESCOSTITEMS, IFCRELASSIGNSTOPROJECTORDER, IFCRELASSIGNSTOCONTROL, IFCRELOCCUPIESSPACES, IFCRELASSIGNSTOACTOR, IFCRELASSIGNS],
  723233188: [IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCMANIFOLDSOLIDBREP, IFCCSGSOLID, IFCSWEPTDISKSOLID, IFCSURFACECURVESWEPTAREASOLID, IFCREVOLVEDAREASOLID, IFCEXTRUDEDAREASOLID, IFCSWEPTAREASOLID],
  2473145415: [IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION],
  1597423693: [IFCSTRUCTURALLOADSINGLEFORCEWARPING],
  3843319758: [IFCSTRUCTURALSTEELPROFILEPROPERTIES],
  2513912981: [IFCPLANE, IFCELEMENTARYSURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDPLANE, IFCBOUNDEDSURFACE, IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION, IFCSWEPTSURFACE],
  2247615214: [IFCSURFACECURVESWEPTAREASOLID, IFCREVOLVEDAREASOLID, IFCEXTRUDEDAREASOLID],
  230924584: [IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION],
  3028897424: [IFCDIMENSIONCURVETERMINATOR],
  4282788508: [IFCTEXTLITERALWITHEXTENT],
  1628702193: [IFCVIBRATIONISOLATORTYPE, IFCDISCRETEACCESSORYTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCSENSORTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICHEATERTYPE, IFCELECTRICAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCGASTERMINALTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSPACEHEATERTYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWALLTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCMEMBERTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCDOORSTYLE, IFCWINDOWSTYLE, IFCTYPEPRODUCT],
  2347495698: [IFCVIBRATIONISOLATORTYPE, IFCDISCRETEACCESSORYTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCSENSORTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICHEATERTYPE, IFCELECTRICAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCGASTERMINALTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSPACEHEATERTYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWALLTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCMEMBERTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCDOORSTYLE, IFCWINDOWSTYLE],
  3288037868: [IFCPROJECTIONCURVE, IFCDIMENSIONCURVE],
  2736907675: [IFCBOOLEANCLIPPINGRESULT],
  4182860854: [IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDPLANE],
  59481748: [IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR3D, IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR2D],
  3749851601: [IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM],
  3331915920: [IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM],
  1383045692: [IFCCIRCLEHOLLOWPROFILEDEF],
  2506170314: [IFCBLOCK, IFCSPHERE, IFCRIGHTCIRCULARCYLINDER, IFCRIGHTCIRCULARCONE, IFCRECTANGULARPYRAMID],
  2601014836: [IFCCIRCLE, IFCELLIPSE, IFCCONIC, IFCRATIONALBEZIERCURVE, IFCBEZIERCURVE, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFC2DCOMPOSITECURVE, IFCCOMPOSITECURVE, IFCBOUNDEDCURVE, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D, IFCLINE],
  3073041342: [IFCDIAMETERDIMENSION, IFCANGULARDIMENSION, IFCRADIUSDIMENSION, IFCLINEARDIMENSION, IFCDIMENSIONCURVEDIRECTEDCALLOUT, IFCSTRUCTUREDDIMENSIONCALLOUT],
  339256511: [IFCVIBRATIONISOLATORTYPE, IFCDISCRETEACCESSORYTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCSENSORTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICHEATERTYPE, IFCELECTRICAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCGASTERMINALTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSPACEHEATERTYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWALLTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCMEMBERTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE],
  2777663545: [IFCPLANE],
  80994333: [IFCELECTRICALBASEPROPERTIES],
  4238390223: [IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE],
  1484403080: [IFCASYMMETRICISHAPEPROFILEDEF],
  1425443689: [IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP],
  3888040117: [IFCCONDITION, IFCASSET, IFCZONE, IFCSTRUCTURALANALYSISMODEL, IFCELECTRICALCIRCUIT, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADGROUP, IFCINVENTORY, IFCGROUP, IFCCONDITIONCRITERION, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCTIMESERIESSCHEDULE, IFCSPACEPROGRAM, IFCSERVICELIFE, IFCSCHEDULETIMECONTROL, IFCPROJECTORDERRECORD, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCFURNITURESTANDARD, IFCEQUIPMENTSTANDARD, IFCCOSTSCHEDULE, IFCCOSTITEM, IFCCONTROL, IFCOCCUPANT, IFCACTOR, IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE, IFCRESOURCE, IFCPROJECT, IFCDISTRIBUTIONPORT, IFCPORT, IFCGRID, IFCELECTRICALELEMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFLOWTREATMENTDEVICE, IFCFLOWTERMINAL, IFCFLOWSTORAGEDEVICE, IFCFLOWSEGMENT, IFCFLOWMOVINGDEVICE, IFCFLOWFITTING, IFCELECTRICDISTRIBUTIONPOINT, IFCFLOWCONTROLLER, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATE, IFCPILE, IFCMEMBER, IFCFOOTING, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMN, IFCBUILDINGELEMENTPROXY, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCBUILDINGELEMENTPART, IFCBUILDINGELEMENTCOMPONENT, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCFURNISHINGELEMENT, IFCCHAMFEREDGEFEATURE, IFCROUNDEDEDGEFEATURE, IFCEDGEFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCEQUIPMENTELEMENT, IFCDISCRETEACCESSORY, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALPLANARACTIONVARYING, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALLINEARACTIONVARYING, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING, IFCSPATIALSTRUCTUREELEMENT, IFCPROXY, IFCPRODUCT, IFCPROCEDURE, IFCORDERACTION, IFCMOVE, IFCTASK, IFCPROCESS],
  2945172077: [IFCPROCEDURE, IFCORDERACTION, IFCMOVE, IFCTASK],
  4208778838: [IFCDISTRIBUTIONPORT, IFCPORT, IFCGRID, IFCELECTRICALELEMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFLOWTREATMENTDEVICE, IFCFLOWTERMINAL, IFCFLOWSTORAGEDEVICE, IFCFLOWSEGMENT, IFCFLOWMOVINGDEVICE, IFCFLOWFITTING, IFCELECTRICDISTRIBUTIONPOINT, IFCFLOWCONTROLLER, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATE, IFCPILE, IFCMEMBER, IFCFOOTING, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMN, IFCBUILDINGELEMENTPROXY, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCBUILDINGELEMENTPART, IFCBUILDINGELEMENTCOMPONENT, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCFURNISHINGELEMENT, IFCCHAMFEREDGEFEATURE, IFCROUNDEDEDGEFEATURE, IFCEDGEFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCEQUIPMENTELEMENT, IFCDISCRETEACCESSORY, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALPLANARACTIONVARYING, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALLINEARACTIONVARYING, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING, IFCSPATIALSTRUCTUREELEMENT, IFCPROXY],
  3939117080: [IFCRELASSIGNSTORESOURCE, IFCRELASSIGNSTOPRODUCT, IFCRELASSIGNSTOPROCESS, IFCRELASSIGNSTOGROUP, IFCRELASSIGNSTASKS, IFCRELSCHEDULESCOSTITEMS, IFCRELASSIGNSTOPROJECTORDER, IFCRELASSIGNSTOCONTROL, IFCRELOCCUPIESSPACES, IFCRELASSIGNSTOACTOR],
  1683148259: [IFCRELOCCUPIESSPACES],
  2495723537: [IFCRELASSIGNSTASKS, IFCRELSCHEDULESCOSTITEMS, IFCRELASSIGNSTOPROJECTORDER],
  1865459582: [IFCRELASSOCIATESPROFILEPROPERTIES, IFCRELASSOCIATESMATERIAL, IFCRELASSOCIATESLIBRARY, IFCRELASSOCIATESDOCUMENT, IFCRELASSOCIATESCONSTRAINT, IFCRELASSOCIATESCLASSIFICATION, IFCRELASSOCIATESAPPROVAL, IFCRELASSOCIATESAPPLIEDVALUE],
  826625072: [IFCRELVOIDSELEMENT, IFCRELSPACEBOUNDARY, IFCRELSERVICESBUILDINGS, IFCRELSEQUENCE, IFCRELREFERENCEDINSPATIALSTRUCTURE, IFCRELPROJECTSELEMENT, IFCRELINTERACTIONREQUIREMENTS, IFCRELFLOWCONTROLELEMENTS, IFCRELFILLSELEMENT, IFCRELCOVERSSPACES, IFCRELCOVERSBLDGELEMENTS, IFCRELCONTAINEDINSPATIALSTRUCTURE, IFCRELCONNECTSWITHECCENTRICITY, IFCRELCONNECTSSTRUCTURALMEMBER, IFCRELCONNECTSSTRUCTURALELEMENT, IFCRELCONNECTSSTRUCTURALACTIVITY, IFCRELCONNECTSPORTS, IFCRELCONNECTSPORTTOELEMENT, IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS, IFCRELCONNECTSELEMENTS],
  1204542856: [IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS],
  1638771189: [IFCRELCONNECTSWITHECCENTRICITY],
  2551354335: [IFCRELAGGREGATES, IFCRELNESTS],
  693640335: [IFCRELDEFINESBYTYPE, IFCRELOVERRIDESPROPERTIES, IFCRELDEFINESBYPROPERTIES],
  4186316022: [IFCRELOVERRIDESPROPERTIES],
  2914609552: [IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE],
  2706606064: [IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING],
  3893378262: [IFCSPACETYPE],
  3544373492: [IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALPLANARACTIONVARYING, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALLINEARACTIONVARYING, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALREACTION],
  3136571912: [IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER],
  530289379: [IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER],
  3689010777: [IFCSTRUCTURALPOINTREACTION],
  3979015343: [IFCSTRUCTURALSURFACEMEMBERVARYING],
  3473067441: [IFCORDERACTION, IFCMOVE],
  2296667514: [IFCOCCUPANT],
  1260505505: [IFCRATIONALBEZIERCURVE, IFCBEZIERCURVE, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFC2DCOMPOSITECURVE, IFCCOMPOSITECURVE],
  1950629157: [IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWALLTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCMEMBERTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE],
  3732776249: [IFC2DCOMPOSITECURVE],
  2510884976: [IFCCIRCLE, IFCELLIPSE],
  2559216714: [IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE],
  3293443760: [IFCCONDITIONCRITERION, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCTIMESERIESSCHEDULE, IFCSPACEPROGRAM, IFCSERVICELIFE, IFCSCHEDULETIMECONTROL, IFCPROJECTORDERRECORD, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCFURNITURESTANDARD, IFCEQUIPMENTSTANDARD, IFCCOSTSCHEDULE, IFCCOSTITEM],
  681481545: [IFCDIAMETERDIMENSION, IFCANGULARDIMENSION, IFCRADIUSDIMENSION, IFCLINEARDIMENSION],
  3256556792: [IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCSENSORTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICHEATERTYPE, IFCELECTRICAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCGASTERMINALTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSPACEHEATERTYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE],
  3849074793: [IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICHEATERTYPE, IFCELECTRICAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCGASTERMINALTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSPACEHEATERTYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENERGYCONVERSIONDEVICETYPE],
  1758889154: [IFCELECTRICALELEMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFLOWTREATMENTDEVICE, IFCFLOWTERMINAL, IFCFLOWSTORAGEDEVICE, IFCFLOWSEGMENT, IFCFLOWMOVINGDEVICE, IFCFLOWFITTING, IFCELECTRICDISTRIBUTIONPOINT, IFCFLOWCONTROLLER, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATE, IFCPILE, IFCMEMBER, IFCFOOTING, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMN, IFCBUILDINGELEMENTPROXY, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCBUILDINGELEMENTPART, IFCBUILDINGELEMENTCOMPONENT, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCFURNISHINGELEMENT, IFCCHAMFEREDGEFEATURE, IFCROUNDEDEDGEFEATURE, IFCEDGEFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCEQUIPMENTELEMENT, IFCDISCRETEACCESSORY, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY],
  1623761950: [IFCDISCRETEACCESSORY, IFCMECHANICALFASTENER, IFCFASTENER],
  2590856083: [IFCVIBRATIONISOLATORTYPE, IFCDISCRETEACCESSORYTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE],
  2107101300: [IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSPACEHEATERTYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE],
  647756555: [IFCMECHANICALFASTENER],
  2489546625: [IFCMECHANICALFASTENERTYPE],
  2827207264: [IFCCHAMFEREDGEFEATURE, IFCROUNDEDEDGEFEATURE, IFCEDGEFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION],
  2143335405: [IFCPROJECTIONELEMENT],
  1287392070: [IFCCHAMFEREDGEFEATURE, IFCROUNDEDEDGEFEATURE, IFCEDGEFEATURE, IFCOPENINGELEMENT],
  3907093117: [IFCELECTRICTIMECONTROLTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE],
  3198132628: [IFCDUCTFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE],
  1482959167: [IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE],
  1834744321: [IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE],
  1339347760: [IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE],
  2297155007: [IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICHEATERTYPE, IFCELECTRICAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCGASTERMINALTYPE],
  3009222698: [IFCFILTERTYPE, IFCDUCTSILENCERTYPE],
  2706460486: [IFCCONDITION, IFCASSET, IFCZONE, IFCSTRUCTURALANALYSISMODEL, IFCELECTRICALCIRCUIT, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADGROUP, IFCINVENTORY],
  3740093272: [IFCDISTRIBUTIONPORT],
  682877961: [IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALPLANARACTIONVARYING, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALLINEARACTIONVARYING, IFCSTRUCTURALLINEARACTION],
  1179482911: [IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION],
  214636428: [IFCSTRUCTURALCURVEMEMBERVARYING],
  1807405624: [IFCSTRUCTURALLINEARACTIONVARYING],
  1621171031: [IFCSTRUCTURALPLANARACTIONVARYING],
  2254336722: [IFCSTRUCTURALANALYSISMODEL, IFCELECTRICALCIRCUIT],
  1028945134: [IFCWORKSCHEDULE, IFCWORKPLAN],
  1967976161: [IFCRATIONALBEZIERCURVE, IFCBEZIERCURVE],
  1916977116: [IFCRATIONALBEZIERCURVE],
  3299480353: [IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATE, IFCPILE, IFCMEMBER, IFCFOOTING, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMN, IFCBUILDINGELEMENTPROXY, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCBUILDINGELEMENTPART, IFCBUILDINGELEMENTCOMPONENT],
  52481810: [IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCBUILDINGELEMENTPART],
  2635815018: [IFCVIBRATIONISOLATORTYPE],
  2063403501: [IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCSENSORTYPE, IFCFLOWINSTRUMENTTYPE],
  1945004755: [IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFLOWTREATMENTDEVICE, IFCFLOWTERMINAL, IFCFLOWSTORAGEDEVICE, IFCFLOWSEGMENT, IFCFLOWMOVINGDEVICE, IFCFLOWFITTING, IFCELECTRICDISTRIBUTIONPOINT, IFCFLOWCONTROLLER, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT],
  3040386961: [IFCDISTRIBUTIONCHAMBERELEMENT, IFCFLOWTREATMENTDEVICE, IFCFLOWTERMINAL, IFCFLOWSTORAGEDEVICE, IFCFLOWSEGMENT, IFCFLOWMOVINGDEVICE, IFCFLOWFITTING, IFCELECTRICDISTRIBUTIONPOINT, IFCFLOWCONTROLLER, IFCENERGYCONVERSIONDEVICE],
  855621170: [IFCCHAMFEREDGEFEATURE, IFCROUNDEDEDGEFEATURE],
  2058353004: [IFCELECTRICDISTRIBUTIONPOINT],
  3027567501: [IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH],
  2391406946: [IFCWALLSTANDARDCASE]
};
InversePropertyDef[1] = {
  618182010: [["OfPerson", IFCPERSON, 7, true], ["OfOrganization", IFCORGANIZATION, 4, true]],
  411424972: [["ValuesReferenced", IFCREFERENCESVALUEDOCUMENT, 1, true], ["ValueOfComponents", IFCAPPLIEDVALUERELATIONSHIP, 0, true], ["IsComponentIn", IFCAPPLIEDVALUERELATIONSHIP, 1, true]],
  130549933: [["Actors", IFCAPPROVALACTORRELATIONSHIP, 1, true], ["IsRelatedWith", IFCAPPROVALRELATIONSHIP, 0, true], ["Relates", IFCAPPROVALRELATIONSHIP, 1, true]],
  747523909: [["Contains", IFCCLASSIFICATIONITEM, 1, true]],
  1767535486: [["IsClassifiedItemIn", IFCCLASSIFICATIONITEMRELATIONSHIP, 1, true], ["IsClassifyingItemIn", IFCCLASSIFICATIONITEMRELATIONSHIP, 0, true]],
  1959218052: [["ClassifiedAs", IFCCONSTRAINTCLASSIFICATIONRELATIONSHIP, 0, true], ["RelatesConstraints", IFCCONSTRAINTRELATIONSHIP, 2, true], ["IsRelatedWith", IFCCONSTRAINTRELATIONSHIP, 3, true], ["PropertiesForConstraint", IFCPROPERTYCONSTRAINTRELATIONSHIP, 0, true], ["Aggregates", IFCCONSTRAINTAGGREGATIONRELATIONSHIP, 2, true], ["IsAggregatedIn", IFCCONSTRAINTAGGREGATIONRELATIONSHIP, 3, true]],
  602808272: [["ValuesReferenced", IFCREFERENCESVALUEDOCUMENT, 1, true], ["ValueOfComponents", IFCAPPLIEDVALUERELATIONSHIP, 0, true], ["IsComponentIn", IFCAPPLIEDVALUERELATIONSHIP, 1, true]],
  1154170062: [["IsPointedTo", IFCDOCUMENTINFORMATIONRELATIONSHIP, 1, true], ["IsPointer", IFCDOCUMENTINFORMATIONRELATIONSHIP, 0, true]],
  1648886627: [["ValuesReferenced", IFCREFERENCESVALUEDOCUMENT, 1, true], ["ValueOfComponents", IFCAPPLIEDVALUERELATIONSHIP, 0, true], ["IsComponentIn", IFCAPPLIEDVALUERELATIONSHIP, 1, true]],
  852622518: [["PartOfW", IFCGRID, 9, true], ["PartOfV", IFCGRID, 8, true], ["PartOfU", IFCGRID, 7, true], ["HasIntersections", IFCVIRTUALGRIDINTERSECTION, 0, true]],
  3452421091: [["ReferenceIntoLibrary", IFCLIBRARYINFORMATION, 4, true]],
  1838606355: [["HasRepresentation", IFCMATERIALDEFINITIONREPRESENTATION, 3, true], ["ClassifiedAs", IFCMATERIALCLASSIFICATIONRELATIONSHIP, 1, true]],
  248100487: [["ToMaterialLayerSet", IFCMATERIALLAYERSET, 0, false]],
  3368373690: [["ClassifiedAs", IFCCONSTRAINTCLASSIFICATIONRELATIONSHIP, 0, true], ["RelatesConstraints", IFCCONSTRAINTRELATIONSHIP, 2, true], ["IsRelatedWith", IFCCONSTRAINTRELATIONSHIP, 3, true], ["PropertiesForConstraint", IFCPROPERTYCONSTRAINTRELATIONSHIP, 0, true], ["Aggregates", IFCCONSTRAINTAGGREGATIONRELATIONSHIP, 2, true], ["IsAggregatedIn", IFCCONSTRAINTAGGREGATIONRELATIONSHIP, 3, true]],
  3701648758: [["PlacesObject", IFCPRODUCT, 5, true], ["ReferencedByPlacements", IFCLOCALPLACEMENT, 0, true]],
  2251480897: [["ClassifiedAs", IFCCONSTRAINTCLASSIFICATIONRELATIONSHIP, 0, true], ["RelatesConstraints", IFCCONSTRAINTRELATIONSHIP, 2, true], ["IsRelatedWith", IFCCONSTRAINTRELATIONSHIP, 3, true], ["PropertiesForConstraint", IFCPROPERTYCONSTRAINTRELATIONSHIP, 0, true], ["Aggregates", IFCCONSTRAINTAGGREGATIONRELATIONSHIP, 2, true], ["IsAggregatedIn", IFCCONSTRAINTAGGREGATIONRELATIONSHIP, 3, true]],
  4251960020: [["IsRelatedBy", IFCORGANIZATIONRELATIONSHIP, 3, true], ["Relates", IFCORGANIZATIONRELATIONSHIP, 2, true], ["Engages", IFCPERSONANDORGANIZATION, 1, true]],
  2077209135: [["EngagedIn", IFCPERSONANDORGANIZATION, 0, true]],
  2483315170: [["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  2226359599: [["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  3355820592: [["OfPerson", IFCPERSON, 7, true], ["OfOrganization", IFCORGANIZATION, 4, true]],
  2598011224: [["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 0, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 1, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true]],
  2044713172: [["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  2093928680: [["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  931644368: [["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  3252649465: [["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  2405470396: [["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  825690147: [["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  1076942058: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true]],
  3377609919: [["RepresentationsInContext", IFCREPRESENTATION, 0, true]],
  3008791417: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1660063152: [["MapUsage", IFCMAPPEDITEM, 0, true]],
  3982875396: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true], ["OfShapeAspect", IFCSHAPEASPECT, 0, true]],
  4240577450: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true], ["OfShapeAspect", IFCSHAPEASPECT, 0, true]],
  3692461612: [["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 0, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 1, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true]],
  2830218821: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true]],
  3958052878: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3049322572: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true]],
  531007025: [["OfTable", IFCTABLE, 1, false]],
  912023232: [["OfPerson", IFCPERSON, 7, true], ["OfOrganization", IFCORGANIZATION, 4, true]],
  280115917: [["AnnotatedSurface", IFCANNOTATIONSURFACE, 1, true]],
  1742049831: [["AnnotatedSurface", IFCANNOTATIONSURFACE, 1, true]],
  2552916305: [["AnnotatedSurface", IFCANNOTATIONSURFACE, 1, true]],
  3101149627: [["DocumentedBy", IFCTIMESERIESREFERENCERELATIONSHIP, 0, true]],
  1377556343: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1735638870: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true], ["OfShapeAspect", IFCSHAPEASPECT, 0, true]],
  2799835756: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1907098498: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2442683028: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  962685235: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3612888222: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2297822566: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2542286263: [["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 0, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 1, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true]],
  370225590: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3732053477: [["ReferenceToDocument", IFCDOCUMENTINFORMATION, 3, true]],
  3900360178: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  476780140: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2556980723: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1809719519: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  803316827: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3008276851: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3448662350: [["RepresentationsInContext", IFCREPRESENTATION, 0, true], ["HasSubContexts", IFCGEOMETRICREPRESENTATIONSUBCONTEXT, 6, true]],
  2453401579: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4142052618: [["RepresentationsInContext", IFCREPRESENTATION, 0, true], ["HasSubContexts", IFCGEOMETRICREPRESENTATIONSUBCONTEXT, 6, true]],
  3590301190: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  178086475: [["PlacesObject", IFCPRODUCT, 5, true], ["ReferencedByPlacements", IFCLOCALPLACEMENT, 0, true]],
  812098782: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3741457305: [["DocumentedBy", IFCTIMESERIESREFERENCERELATIONSHIP, 0, true]],
  1402838566: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  125510826: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2604431987: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4266656042: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1520743889: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3422422726: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2624227202: [["PlacesObject", IFCPRODUCT, 5, true], ["ReferencedByPlacements", IFCLOCALPLACEMENT, 0, true]],
  1008929658: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2347385850: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  219451334: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true]],
  2833995503: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2665983363: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1029017970: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2519244187: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3021840470: [["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  2004835150: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1663979128: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2067069095: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4022376103: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1423911732: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2924175390: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2775532180: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  673634403: [["ShapeOfProduct", IFCPRODUCT, 6, true], ["HasShapeAspects", IFCSHAPEASPECT, 4, true]],
  871118103: [["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 0, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 1, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true]],
  1680319473: [["HasAssociations", IFCRELASSOCIATES, 4, true]],
  4166981789: [["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 0, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 1, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true]],
  2752243245: [["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 0, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 1, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true]],
  941946838: [["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 0, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 1, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true]],
  3357820518: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  3650150729: [["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 0, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 1, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true]],
  110355661: [["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 0, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 1, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true]],
  3413951693: [["DocumentedBy", IFCTIMESERIESREFERENCERELATIONSHIP, 0, true]],
  3765753017: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  1509187699: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2411513650: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  4124623270: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  723233188: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2485662743: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  1202362311: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  390701378: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  2233826070: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2513912981: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2247615214: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1260650574: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  230924584: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3028897424: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4282788508: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3124975700: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1345879162: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1628702193: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2347495698: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1417489154: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2759199220: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  336235671: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  512836454: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  1299126871: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3288037868: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  669184980: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2265737646: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1302238472: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4261334040: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3125803723: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2740243338: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2736907675: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4182860854: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2581212453: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2713105998: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1123145078: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  59481748: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3749851601: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3486308946: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3331915920: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1416205885: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2205249479: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2485617015: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["UsingCurves", IFCCOMPOSITECURVE, 0, true]],
  2506170314: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2147822146: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2601014836: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2827736869: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  693772133: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  606661476: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["AnnotatedBySymbols", IFCTERMINATORSYMBOL, 3, true]],
  4054601972: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  32440307: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2963535650: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  1714330368: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  526551008: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3073041342: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["IsRelatedFromCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 3, true], ["IsRelatedToCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 2, true]],
  1472233963: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1883228015: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  339256511: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2777663545: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  80994333: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  477187591: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2047409740: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  374418227: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4203026998: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  315944413: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3455213021: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  4238390223: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1268542332: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  987898635: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1281925730: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1425443689: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3888040117: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true]],
  3388369263: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3505215534: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3566463478: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  603570806: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  220341763: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2945172077: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, true], ["IsPredecessorTo", IFCRELSEQUENCE, 4, true]],
  4208778838: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  103090709: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true]],
  4194566429: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1451395588: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  3219374653: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2798486643: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3454111270: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2914609552: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1856042241: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4158566097: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3626867408: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2706606064: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true]],
  3893378262: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  451544542: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3544373492: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, false]],
  3136571912: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true]],
  530289379: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ReferencesElement", IFCRELCONNECTSSTRUCTURALELEMENT, 5, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  3689010777: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, false], ["Causes", IFCSTRUCTURALACTION, 10, true]],
  3979015343: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ReferencesElement", IFCRELCONNECTSSTRUCTURALELEMENT, 5, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  2218152070: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ReferencesElement", IFCRELCONNECTSSTRUCTURALELEMENT, 5, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  4070609034: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["IsRelatedFromCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 3, true], ["IsRelatedToCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 2, true]],
  2028607225: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2809605785: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4124788165: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1580310250: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3473067441: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, true], ["IsPredecessorTo", IFCRELSEQUENCE, 4, true]],
  2097647324: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2296667514: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["IsActingUpon", IFCRELASSIGNSTOACTOR, 6, true]],
  1674181508: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  1334484129: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3649129432: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1260505505: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4031249490: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true]],
  1950629157: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3124254112: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true]],
  300633059: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3732776249: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2510884976: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2559216714: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  3293443760: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3895139033: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1419761937: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1916426348: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3295246426: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1457835157: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  681481545: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["IsRelatedFromCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 3, true], ["IsRelatedToCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 2, true]],
  3256556792: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3849074793: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  360485395: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  1758889154: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  4123344466: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  1623761950: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2590856083: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1704287377: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2107101300: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1962604670: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  3272907226: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3174744832: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3390157468: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  807026263: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3737207727: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  647756555: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2489546625: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2827207264: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2143335405: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["ProjectsElements", IFCRELPROJECTSELEMENT, 5, false]],
  1287392070: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["VoidsElements", IFCRELVOIDSELEMENT, 5, false]],
  3907093117: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3198132628: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3815607619: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1482959167: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1834744321: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1339347760: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2297155007: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3009222698: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  263784265: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  814719939: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  200128114: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3009204131: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2706460486: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, false]],
  1251058090: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1806887404: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2391368822: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, false]],
  4288270099: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3827777499: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1051575348: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1161773419: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2506943328: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["IsRelatedFromCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 3, true], ["IsRelatedToCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 2, true]],
  377706215: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2108223431: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3181161470: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  977012517: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1916936684: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, true], ["IsPredecessorTo", IFCRELSEQUENCE, 4, true]],
  4143007308: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["IsActingUpon", IFCRELASSIGNSTOACTOR, 6, true]],
  3588315303: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["VoidsElements", IFCRELVOIDSELEMENT, 5, false], ["HasFillings", IFCRELFILLSELEMENT, 4, true]],
  3425660407: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, true], ["IsPredecessorTo", IFCRELSEQUENCE, 4, true]],
  2837617999: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2382730787: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3327091369: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  804291784: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  4231323485: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  4017108033: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3724593414: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3740093272: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainedIn", IFCRELCONNECTSPORTTOELEMENT, 4, false], ["ConnectedFrom", IFCRELCONNECTSPORTS, 5, true], ["ConnectedTo", IFCRELCONNECTSPORTS, 4, true]],
  2744685151: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, true], ["IsPredecessorTo", IFCRELSEQUENCE, 4, true]],
  2904328755: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3642467123: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3651124850: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["ProjectsElements", IFCRELPROJECTSELEMENT, 5, false]],
  1842657554: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2250791053: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3248260540: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["IsRelatedFromCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 3, true], ["IsRelatedToCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 2, true]],
  2893384427: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2324767716: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1768891740: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3517283431: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true], ["ScheduleTimeControlAssigned", IFCRELASSIGNSTASKS, 7, false]],
  4105383287: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  4097777520: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true]],
  2533589738: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3856911033: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["HasCoverings", IFCRELCOVERSSPACES, 4, true], ["BoundedBy", IFCRELSPACEBOUNDARY, 4, true]],
  1305183839: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  652456506: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true], ["HasInteractionReqsFrom", IFCRELINTERACTIONREQUIREMENTS, 7, true], ["HasInteractionReqsTo", IFCRELINTERACTIONREQUIREMENTS, 8, true]],
  3812236995: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3112655638: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1039846685: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  682877961: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, false]],
  1179482911: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, true]],
  4243806635: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, true]],
  214636428: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ReferencesElement", IFCRELCONNECTSSTRUCTURALELEMENT, 5, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  2445595289: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ReferencesElement", IFCRELCONNECTSSTRUCTURALELEMENT, 5, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  1807405624: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, false]],
  1721250024: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, false]],
  1252848954: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, false], ["SourceOfResultGroup", IFCSTRUCTURALRESULTGROUP, 6, true], ["LoadGroupFor", IFCSTRUCTURALANALYSISMODEL, 7, true]],
  1621171031: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, false]],
  3987759626: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, false]],
  2082059205: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, false]],
  734778138: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, true]],
  1235345126: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, false], ["Causes", IFCSTRUCTURALACTION, 10, true]],
  2986769608: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, false], ["ResultGroupFor", IFCSTRUCTURALANALYSISMODEL, 8, true]],
  1975003073: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, true]],
  148013059: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  2315554128: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2254336722: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, false], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true]],
  5716631: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1637806684: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1692211062: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1620046519: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  3593883385: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1600972822: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1911125066: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  728799441: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2769231204: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  1898987631: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1133259667: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1028945134: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  4218914973: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3342526732: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1033361043: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, false]],
  1213861670: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3821786052: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1411407467: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3352864051: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1871374353: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2470393545: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["IsRelatedFromCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 3, true], ["IsRelatedToCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 2, true]],
  3460190687: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, false]],
  1967976161: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  819618141: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1916977116: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  231477066: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3299480353: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  52481810: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2979338954: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  1095909175: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  1909888760: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  395041908: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3293546465: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1285652485: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2951183804: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2611217952: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2301859152: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  843113511: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  3850581409: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2816379211: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2188551683: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, false]],
  1163958913: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3898045240: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1060000209: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  488727124: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  335055490: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2954562838: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1973544240: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["CoversSpaces", IFCRELCOVERSSPACES, 5, true], ["Covers", IFCRELCOVERSBLDGELEMENTS, 5, true]],
  3495092785: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  3961806047: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  4147604152: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["IsRelatedFromCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 3, true], ["IsRelatedToCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 2, true]],
  1335981549: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2635815018: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1599208980: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2063403501: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1945004755: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  3040386961: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3041715199: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainedIn", IFCRELCONNECTSPORTTOELEMENT, 4, false], ["ConnectedFrom", IFCRELCONNECTSPORTS, 5, true], ["ConnectedTo", IFCRELCONNECTSPORTS, 4, true]],
  395920057: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  869906466: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3760055223: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2030761528: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  855621170: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["VoidsElements", IFCRELVOIDSELEMENT, 5, false]],
  663422040: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3277789161: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1534661035: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1365060375: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1217240411: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  712377611: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1634875225: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, false], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true]],
  857184966: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  1658829314: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  346874300: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1810631287: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  4222183408: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2058353004: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4278956645: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4037862832: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3132237377: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  987401354: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  707683696: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2223149337: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3508470533: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  900683007: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  1073191201: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  1687234759: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  3171933400: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2262370178: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  3024970846: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  3283111854: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  3055160366: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3027567501: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2320036040: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2016517767: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  1376911519: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["VoidsElements", IFCRELVOIDSELEMENT, 5, false]],
  1783015770: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1529196076: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  331165859: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  4252922144: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2515109513: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, false], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true]],
  3824725483: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2347447852: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  3313531582: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2391406946: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  3512223829: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  3304561284: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2874132201: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3001207471: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  753842376: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2454782716: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["VoidsElements", IFCRELVOIDSELEMENT, 5, false]],
  578613899: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1052013943: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1062813311: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  3700593921: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  979691226: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]]
};
Constructors[1] = {
  3630933823: (a) => new IFC2X3.IfcActorRole(a[0], a[1], a[2]),
  618182010: (a) => new IFC2X3.IfcAddress(a[0], a[1], a[2]),
  639542469: (a) => new IFC2X3.IfcApplication(a[0], a[1], a[2], a[3]),
  411424972: (a) => new IFC2X3.IfcAppliedValue(a[0], a[1], a[2], a[3], a[4], a[5]),
  1110488051: (a) => new IFC2X3.IfcAppliedValueRelationship(a[0], a[1], a[2], a[3], a[4]),
  130549933: (a) => new IFC2X3.IfcApproval(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  2080292479: (a) => new IFC2X3.IfcApprovalActorRelationship(a[0], a[1], a[2]),
  390851274: (a) => new IFC2X3.IfcApprovalPropertyRelationship(a[0], a[1]),
  3869604511: (a) => new IFC2X3.IfcApprovalRelationship(a[0], a[1], a[2], a[3]),
  4037036970: (a) => new IFC2X3.IfcBoundaryCondition(a[0]),
  1560379544: (a) => new IFC2X3.IfcBoundaryEdgeCondition(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3367102660: (a) => new IFC2X3.IfcBoundaryFaceCondition(a[0], a[1], a[2], a[3]),
  1387855156: (a) => new IFC2X3.IfcBoundaryNodeCondition(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  2069777674: (a) => new IFC2X3.IfcBoundaryNodeConditionWarping(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  622194075: (a) => new IFC2X3.IfcCalendarDate(a[0], a[1], a[2]),
  747523909: (a) => new IFC2X3.IfcClassification(a[0], a[1], a[2], a[3]),
  1767535486: (a) => new IFC2X3.IfcClassificationItem(a[0], a[1], a[2]),
  1098599126: (a) => new IFC2X3.IfcClassificationItemRelationship(a[0], a[1]),
  938368621: (a) => new IFC2X3.IfcClassificationNotation(a[0]),
  3639012971: (a) => new IFC2X3.IfcClassificationNotationFacet(a[0]),
  3264961684: (a) => new IFC2X3.IfcColourSpecification(a[0]),
  2859738748: (_) => new IFC2X3.IfcConnectionGeometry(),
  2614616156: (a) => new IFC2X3.IfcConnectionPointGeometry(a[0], a[1]),
  4257277454: (a) => new IFC2X3.IfcConnectionPortGeometry(a[0], a[1], a[2]),
  2732653382: (a) => new IFC2X3.IfcConnectionSurfaceGeometry(a[0], a[1]),
  1959218052: (a) => new IFC2X3.IfcConstraint(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1658513725: (a) => new IFC2X3.IfcConstraintAggregationRelationship(a[0], a[1], a[2], a[3], a[4]),
  613356794: (a) => new IFC2X3.IfcConstraintClassificationRelationship(a[0], a[1]),
  347226245: (a) => new IFC2X3.IfcConstraintRelationship(a[0], a[1], a[2], a[3]),
  1065062679: (a) => new IFC2X3.IfcCoordinatedUniversalTimeOffset(a[0], a[1], a[2]),
  602808272: (a) => new IFC2X3.IfcCostValue(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  539742890: (a) => new IFC2X3.IfcCurrencyRelationship(a[0], a[1], a[2], a[3], a[4]),
  1105321065: (a) => new IFC2X3.IfcCurveStyleFont(a[0], a[1]),
  2367409068: (a) => new IFC2X3.IfcCurveStyleFontAndScaling(a[0], a[1], a[2]),
  3510044353: (a) => new IFC2X3.IfcCurveStyleFontPattern(a[0], a[1]),
  1072939445: (a) => new IFC2X3.IfcDateAndTime(a[0], a[1]),
  1765591967: (a) => new IFC2X3.IfcDerivedUnit(a[0], a[1], a[2]),
  1045800335: (a) => new IFC2X3.IfcDerivedUnitElement(a[0], a[1]),
  2949456006: (a) => new IFC2X3.IfcDimensionalExponents(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1376555844: (a) => new IFC2X3.IfcDocumentElectronicFormat(a[0], a[1], a[2]),
  1154170062: (a) => new IFC2X3.IfcDocumentInformation(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16]),
  770865208: (a) => new IFC2X3.IfcDocumentInformationRelationship(a[0], a[1], a[2]),
  3796139169: (a) => new IFC2X3.IfcDraughtingCalloutRelationship(a[0], a[1], a[2], a[3]),
  1648886627: (a) => new IFC2X3.IfcEnvironmentalImpactValue(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3200245327: (a) => new IFC2X3.IfcExternalReference(a[0], a[1], a[2]),
  2242383968: (a) => new IFC2X3.IfcExternallyDefinedHatchStyle(a[0], a[1], a[2]),
  1040185647: (a) => new IFC2X3.IfcExternallyDefinedSurfaceStyle(a[0], a[1], a[2]),
  3207319532: (a) => new IFC2X3.IfcExternallyDefinedSymbol(a[0], a[1], a[2]),
  3548104201: (a) => new IFC2X3.IfcExternallyDefinedTextFont(a[0], a[1], a[2]),
  852622518: (a) => new IFC2X3.IfcGridAxis(a[0], a[1], a[2]),
  3020489413: (a) => new IFC2X3.IfcIrregularTimeSeriesValue(a[0], a[1]),
  2655187982: (a) => new IFC2X3.IfcLibraryInformation(a[0], a[1], a[2], a[3], a[4]),
  3452421091: (a) => new IFC2X3.IfcLibraryReference(a[0], a[1], a[2]),
  4162380809: (a) => new IFC2X3.IfcLightDistributionData(a[0], a[1], a[2]),
  1566485204: (a) => new IFC2X3.IfcLightIntensityDistribution(a[0], a[1]),
  30780891: (a) => new IFC2X3.IfcLocalTime(a[0], a[1], a[2], a[3], a[4]),
  1838606355: (a) => new IFC2X3.IfcMaterial(a[0]),
  1847130766: (a) => new IFC2X3.IfcMaterialClassificationRelationship(a[0], a[1]),
  248100487: (a) => new IFC2X3.IfcMaterialLayer(a[0], a[1], a[2]),
  3303938423: (a) => new IFC2X3.IfcMaterialLayerSet(a[0], a[1]),
  1303795690: (a) => new IFC2X3.IfcMaterialLayerSetUsage(a[0], a[1], a[2], a[3]),
  2199411900: (a) => new IFC2X3.IfcMaterialList(a[0]),
  3265635763: (a) => new IFC2X3.IfcMaterialProperties(a[0]),
  2597039031: (a) => new IFC2X3.IfcMeasureWithUnit(a[0], a[1]),
  4256014907: (a) => new IFC2X3.IfcMechanicalMaterialProperties(a[0], a[1], a[2], a[3], a[4], a[5]),
  677618848: (a) => new IFC2X3.IfcMechanicalSteelMaterialProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  3368373690: (a) => new IFC2X3.IfcMetric(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2706619895: (a) => new IFC2X3.IfcMonetaryUnit(a[0]),
  1918398963: (a) => new IFC2X3.IfcNamedUnit(a[0], a[1]),
  3701648758: (_) => new IFC2X3.IfcObjectPlacement(),
  2251480897: (a) => new IFC2X3.IfcObjective(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  1227763645: (a) => new IFC2X3.IfcOpticalMaterialProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4251960020: (a) => new IFC2X3.IfcOrganization(a[0], a[1], a[2], a[3], a[4]),
  1411181986: (a) => new IFC2X3.IfcOrganizationRelationship(a[0], a[1], a[2], a[3]),
  1207048766: (a) => new IFC2X3.IfcOwnerHistory(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2077209135: (a) => new IFC2X3.IfcPerson(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  101040310: (a) => new IFC2X3.IfcPersonAndOrganization(a[0], a[1], a[2]),
  2483315170: (a) => new IFC2X3.IfcPhysicalQuantity(a[0], a[1]),
  2226359599: (a) => new IFC2X3.IfcPhysicalSimpleQuantity(a[0], a[1], a[2]),
  3355820592: (a) => new IFC2X3.IfcPostalAddress(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3727388367: (a) => new IFC2X3.IfcPreDefinedItem(a[0]),
  990879717: (a) => new IFC2X3.IfcPreDefinedSymbol(a[0]),
  3213052703: (a) => new IFC2X3.IfcPreDefinedTerminatorSymbol(a[0]),
  1775413392: (a) => new IFC2X3.IfcPreDefinedTextFont(a[0]),
  2022622350: (a) => new IFC2X3.IfcPresentationLayerAssignment(a[0], a[1], a[2], a[3]),
  1304840413: (a) => new IFC2X3.IfcPresentationLayerWithStyle(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3119450353: (a) => new IFC2X3.IfcPresentationStyle(a[0]),
  2417041796: (a) => new IFC2X3.IfcPresentationStyleAssignment(a[0]),
  2095639259: (a) => new IFC2X3.IfcProductRepresentation(a[0], a[1], a[2]),
  2267347899: (a) => new IFC2X3.IfcProductsOfCombustionProperties(a[0], a[1], a[2], a[3], a[4]),
  3958567839: (a) => new IFC2X3.IfcProfileDef(a[0], a[1]),
  2802850158: (a) => new IFC2X3.IfcProfileProperties(a[0], a[1]),
  2598011224: (a) => new IFC2X3.IfcProperty(a[0], a[1]),
  3896028662: (a) => new IFC2X3.IfcPropertyConstraintRelationship(a[0], a[1], a[2], a[3]),
  148025276: (a) => new IFC2X3.IfcPropertyDependencyRelationship(a[0], a[1], a[2], a[3], a[4]),
  3710013099: (a) => new IFC2X3.IfcPropertyEnumeration(a[0], a[1], a[2]),
  2044713172: (a) => new IFC2X3.IfcQuantityArea(a[0], a[1], a[2], a[3]),
  2093928680: (a) => new IFC2X3.IfcQuantityCount(a[0], a[1], a[2], a[3]),
  931644368: (a) => new IFC2X3.IfcQuantityLength(a[0], a[1], a[2], a[3]),
  3252649465: (a) => new IFC2X3.IfcQuantityTime(a[0], a[1], a[2], a[3]),
  2405470396: (a) => new IFC2X3.IfcQuantityVolume(a[0], a[1], a[2], a[3]),
  825690147: (a) => new IFC2X3.IfcQuantityWeight(a[0], a[1], a[2], a[3]),
  2692823254: (a) => new IFC2X3.IfcReferencesValueDocument(a[0], a[1], a[2], a[3]),
  1580146022: (a) => new IFC2X3.IfcReinforcementBarProperties(a[0], a[1], a[2], a[3], a[4], a[5]),
  1222501353: (a) => new IFC2X3.IfcRelaxation(a[0], a[1]),
  1076942058: (a) => new IFC2X3.IfcRepresentation(a[0], a[1], a[2], a[3]),
  3377609919: (a) => new IFC2X3.IfcRepresentationContext(a[0], a[1]),
  3008791417: (_) => new IFC2X3.IfcRepresentationItem(),
  1660063152: (a) => new IFC2X3.IfcRepresentationMap(a[0], a[1]),
  3679540991: (a) => new IFC2X3.IfcRibPlateProfileProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  2341007311: (a) => new IFC2X3.IfcRoot(a[0], a[1], a[2], a[3]),
  448429030: (a) => new IFC2X3.IfcSIUnit(a[0], a[1], a[2]),
  2042790032: (a) => new IFC2X3.IfcSectionProperties(a[0], a[1], a[2]),
  4165799628: (a) => new IFC2X3.IfcSectionReinforcementProperties(a[0], a[1], a[2], a[3], a[4], a[5]),
  867548509: (a) => new IFC2X3.IfcShapeAspect(a[0], a[1], a[2], a[3], a[4]),
  3982875396: (a) => new IFC2X3.IfcShapeModel(a[0], a[1], a[2], a[3]),
  4240577450: (a) => new IFC2X3.IfcShapeRepresentation(a[0], a[1], a[2], a[3]),
  3692461612: (a) => new IFC2X3.IfcSimpleProperty(a[0], a[1]),
  2273995522: (a) => new IFC2X3.IfcStructuralConnectionCondition(a[0]),
  2162789131: (a) => new IFC2X3.IfcStructuralLoad(a[0]),
  2525727697: (a) => new IFC2X3.IfcStructuralLoadStatic(a[0]),
  3408363356: (a) => new IFC2X3.IfcStructuralLoadTemperature(a[0], a[1], a[2], a[3]),
  2830218821: (a) => new IFC2X3.IfcStyleModel(a[0], a[1], a[2], a[3]),
  3958052878: (a) => new IFC2X3.IfcStyledItem(a[0], a[1], a[2]),
  3049322572: (a) => new IFC2X3.IfcStyledRepresentation(a[0], a[1], a[2], a[3]),
  1300840506: (a) => new IFC2X3.IfcSurfaceStyle(a[0], a[1], a[2]),
  3303107099: (a) => new IFC2X3.IfcSurfaceStyleLighting(a[0], a[1], a[2], a[3]),
  1607154358: (a) => new IFC2X3.IfcSurfaceStyleRefraction(a[0], a[1]),
  846575682: (a) => new IFC2X3.IfcSurfaceStyleShading(a[0]),
  1351298697: (a) => new IFC2X3.IfcSurfaceStyleWithTextures(a[0]),
  626085974: (a) => new IFC2X3.IfcSurfaceTexture(a[0], a[1], a[2], a[3]),
  1290481447: (a) => new IFC2X3.IfcSymbolStyle(a[0], a[1]),
  985171141: (a) => new IFC2X3.IfcTable(a[0], a[1]),
  531007025: (a) => new IFC2X3.IfcTableRow(a[0], a[1]),
  912023232: (a) => new IFC2X3.IfcTelecomAddress(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1447204868: (a) => new IFC2X3.IfcTextStyle(a[0], a[1], a[2], a[3]),
  1983826977: (a) => new IFC2X3.IfcTextStyleFontModel(a[0], a[1], a[2], a[3], a[4], a[5]),
  2636378356: (a) => new IFC2X3.IfcTextStyleForDefinedFont(a[0], a[1]),
  1640371178: (a) => new IFC2X3.IfcTextStyleTextModel(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1484833681: (a) => new IFC2X3.IfcTextStyleWithBoxCharacteristics(a[0], a[1], a[2], a[3], a[4]),
  280115917: (_) => new IFC2X3.IfcTextureCoordinate(),
  1742049831: (a) => new IFC2X3.IfcTextureCoordinateGenerator(a[0], a[1]),
  2552916305: (a) => new IFC2X3.IfcTextureMap(a[0]),
  1210645708: (a) => new IFC2X3.IfcTextureVertex(a[0]),
  3317419933: (a) => new IFC2X3.IfcThermalMaterialProperties(a[0], a[1], a[2], a[3], a[4]),
  3101149627: (a) => new IFC2X3.IfcTimeSeries(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1718945513: (a) => new IFC2X3.IfcTimeSeriesReferenceRelationship(a[0], a[1]),
  581633288: (a) => new IFC2X3.IfcTimeSeriesValue(a[0]),
  1377556343: (_) => new IFC2X3.IfcTopologicalRepresentationItem(),
  1735638870: (a) => new IFC2X3.IfcTopologyRepresentation(a[0], a[1], a[2], a[3]),
  180925521: (a) => new IFC2X3.IfcUnitAssignment(a[0]),
  2799835756: (_) => new IFC2X3.IfcVertex(),
  3304826586: (a) => new IFC2X3.IfcVertexBasedTextureMap(a[0], a[1]),
  1907098498: (a) => new IFC2X3.IfcVertexPoint(a[0]),
  891718957: (a) => new IFC2X3.IfcVirtualGridIntersection(a[0], a[1]),
  1065908215: (a) => new IFC2X3.IfcWaterProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2442683028: (a) => new IFC2X3.IfcAnnotationOccurrence(a[0], a[1], a[2]),
  962685235: (a) => new IFC2X3.IfcAnnotationSurfaceOccurrence(a[0], a[1], a[2]),
  3612888222: (a) => new IFC2X3.IfcAnnotationSymbolOccurrence(a[0], a[1], a[2]),
  2297822566: (a) => new IFC2X3.IfcAnnotationTextOccurrence(a[0], a[1], a[2]),
  3798115385: (a) => new IFC2X3.IfcArbitraryClosedProfileDef(a[0], a[1], a[2]),
  1310608509: (a) => new IFC2X3.IfcArbitraryOpenProfileDef(a[0], a[1], a[2]),
  2705031697: (a) => new IFC2X3.IfcArbitraryProfileDefWithVoids(a[0], a[1], a[2], a[3]),
  616511568: (a) => new IFC2X3.IfcBlobTexture(a[0], a[1], a[2], a[3], a[4], a[5]),
  3150382593: (a) => new IFC2X3.IfcCenterLineProfileDef(a[0], a[1], a[2], a[3]),
  647927063: (a) => new IFC2X3.IfcClassificationReference(a[0], a[1], a[2], a[3]),
  776857604: (a) => new IFC2X3.IfcColourRgb(a[0], a[1], a[2], a[3]),
  2542286263: (a) => new IFC2X3.IfcComplexProperty(a[0], a[1], a[2], a[3]),
  1485152156: (a) => new IFC2X3.IfcCompositeProfileDef(a[0], a[1], a[2], a[3]),
  370225590: (a) => new IFC2X3.IfcConnectedFaceSet(a[0]),
  1981873012: (a) => new IFC2X3.IfcConnectionCurveGeometry(a[0], a[1]),
  45288368: (a) => new IFC2X3.IfcConnectionPointEccentricity(a[0], a[1], a[2], a[3], a[4]),
  3050246964: (a) => new IFC2X3.IfcContextDependentUnit(a[0], a[1], a[2]),
  2889183280: (a) => new IFC2X3.IfcConversionBasedUnit(a[0], a[1], a[2], a[3]),
  3800577675: (a) => new IFC2X3.IfcCurveStyle(a[0], a[1], a[2], a[3]),
  3632507154: (a) => new IFC2X3.IfcDerivedProfileDef(a[0], a[1], a[2], a[3], a[4]),
  2273265877: (a) => new IFC2X3.IfcDimensionCalloutRelationship(a[0], a[1], a[2], a[3]),
  1694125774: (a) => new IFC2X3.IfcDimensionPair(a[0], a[1], a[2], a[3]),
  3732053477: (a) => new IFC2X3.IfcDocumentReference(a[0], a[1], a[2]),
  4170525392: (a) => new IFC2X3.IfcDraughtingPreDefinedTextFont(a[0]),
  3900360178: (a) => new IFC2X3.IfcEdge(a[0], a[1]),
  476780140: (a) => new IFC2X3.IfcEdgeCurve(a[0], a[1], a[2], a[3]),
  1860660968: (a) => new IFC2X3.IfcExtendedMaterialProperties(a[0], a[1], a[2], a[3]),
  2556980723: (a) => new IFC2X3.IfcFace(a[0]),
  1809719519: (a) => new IFC2X3.IfcFaceBound(a[0], a[1]),
  803316827: (a) => new IFC2X3.IfcFaceOuterBound(a[0], a[1]),
  3008276851: (a) => new IFC2X3.IfcFaceSurface(a[0], a[1], a[2]),
  4219587988: (a) => new IFC2X3.IfcFailureConnectionCondition(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  738692330: (a) => new IFC2X3.IfcFillAreaStyle(a[0], a[1]),
  3857492461: (a) => new IFC2X3.IfcFuelProperties(a[0], a[1], a[2], a[3], a[4]),
  803998398: (a) => new IFC2X3.IfcGeneralMaterialProperties(a[0], a[1], a[2], a[3]),
  1446786286: (a) => new IFC2X3.IfcGeneralProfileProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3448662350: (a) => new IFC2X3.IfcGeometricRepresentationContext(a[0], a[1], a[2], a[3], a[4], a[5]),
  2453401579: (_) => new IFC2X3.IfcGeometricRepresentationItem(),
  4142052618: (a) => new IFC2X3.IfcGeometricRepresentationSubContext(a[0], a[1], a[2], a[3], a[4], a[5]),
  3590301190: (a) => new IFC2X3.IfcGeometricSet(a[0]),
  178086475: (a) => new IFC2X3.IfcGridPlacement(a[0], a[1]),
  812098782: (a) => new IFC2X3.IfcHalfSpaceSolid(a[0], a[1]),
  2445078500: (a) => new IFC2X3.IfcHygroscopicMaterialProperties(a[0], a[1], a[2], a[3], a[4], a[5]),
  3905492369: (a) => new IFC2X3.IfcImageTexture(a[0], a[1], a[2], a[3], a[4]),
  3741457305: (a) => new IFC2X3.IfcIrregularTimeSeries(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1402838566: (a) => new IFC2X3.IfcLightSource(a[0], a[1], a[2], a[3]),
  125510826: (a) => new IFC2X3.IfcLightSourceAmbient(a[0], a[1], a[2], a[3]),
  2604431987: (a) => new IFC2X3.IfcLightSourceDirectional(a[0], a[1], a[2], a[3], a[4]),
  4266656042: (a) => new IFC2X3.IfcLightSourceGoniometric(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1520743889: (a) => new IFC2X3.IfcLightSourcePositional(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3422422726: (a) => new IFC2X3.IfcLightSourceSpot(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  2624227202: (a) => new IFC2X3.IfcLocalPlacement(a[0], a[1]),
  1008929658: (_) => new IFC2X3.IfcLoop(),
  2347385850: (a) => new IFC2X3.IfcMappedItem(a[0], a[1]),
  2022407955: (a) => new IFC2X3.IfcMaterialDefinitionRepresentation(a[0], a[1], a[2], a[3]),
  1430189142: (a) => new IFC2X3.IfcMechanicalConcreteMaterialProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  219451334: (a) => new IFC2X3.IfcObjectDefinition(a[0], a[1], a[2], a[3]),
  2833995503: (a) => new IFC2X3.IfcOneDirectionRepeatFactor(a[0]),
  2665983363: (a) => new IFC2X3.IfcOpenShell(a[0]),
  1029017970: (a) => new IFC2X3.IfcOrientedEdge(a[0], a[1]),
  2529465313: (a) => new IFC2X3.IfcParameterizedProfileDef(a[0], a[1], a[2]),
  2519244187: (a) => new IFC2X3.IfcPath(a[0]),
  3021840470: (a) => new IFC2X3.IfcPhysicalComplexQuantity(a[0], a[1], a[2], a[3], a[4], a[5]),
  597895409: (a) => new IFC2X3.IfcPixelTexture(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2004835150: (a) => new IFC2X3.IfcPlacement(a[0]),
  1663979128: (a) => new IFC2X3.IfcPlanarExtent(a[0], a[1]),
  2067069095: (_) => new IFC2X3.IfcPoint(),
  4022376103: (a) => new IFC2X3.IfcPointOnCurve(a[0], a[1]),
  1423911732: (a) => new IFC2X3.IfcPointOnSurface(a[0], a[1], a[2]),
  2924175390: (a) => new IFC2X3.IfcPolyLoop(a[0]),
  2775532180: (a) => new IFC2X3.IfcPolygonalBoundedHalfSpace(a[0], a[1], a[2], a[3]),
  759155922: (a) => new IFC2X3.IfcPreDefinedColour(a[0]),
  2559016684: (a) => new IFC2X3.IfcPreDefinedCurveFont(a[0]),
  433424934: (a) => new IFC2X3.IfcPreDefinedDimensionSymbol(a[0]),
  179317114: (a) => new IFC2X3.IfcPreDefinedPointMarkerSymbol(a[0]),
  673634403: (a) => new IFC2X3.IfcProductDefinitionShape(a[0], a[1], a[2]),
  871118103: (a) => new IFC2X3.IfcPropertyBoundedValue(a[0], a[1], a[2], a[3], a[4]),
  1680319473: (a) => new IFC2X3.IfcPropertyDefinition(a[0], a[1], a[2], a[3]),
  4166981789: (a) => new IFC2X3.IfcPropertyEnumeratedValue(a[0], a[1], a[2], a[3]),
  2752243245: (a) => new IFC2X3.IfcPropertyListValue(a[0], a[1], a[2], a[3]),
  941946838: (a) => new IFC2X3.IfcPropertyReferenceValue(a[0], a[1], a[2], a[3]),
  3357820518: (a) => new IFC2X3.IfcPropertySetDefinition(a[0], a[1], a[2], a[3]),
  3650150729: (a) => new IFC2X3.IfcPropertySingleValue(a[0], a[1], a[2], a[3]),
  110355661: (a) => new IFC2X3.IfcPropertyTableValue(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3615266464: (a) => new IFC2X3.IfcRectangleProfileDef(a[0], a[1], a[2], a[3], a[4]),
  3413951693: (a) => new IFC2X3.IfcRegularTimeSeries(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3765753017: (a) => new IFC2X3.IfcReinforcementDefinitionProperties(a[0], a[1], a[2], a[3], a[4], a[5]),
  478536968: (a) => new IFC2X3.IfcRelationship(a[0], a[1], a[2], a[3]),
  2778083089: (a) => new IFC2X3.IfcRoundedRectangleProfileDef(a[0], a[1], a[2], a[3], a[4], a[5]),
  1509187699: (a) => new IFC2X3.IfcSectionedSpine(a[0], a[1], a[2]),
  2411513650: (a) => new IFC2X3.IfcServiceLifeFactor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  4124623270: (a) => new IFC2X3.IfcShellBasedSurfaceModel(a[0]),
  2609359061: (a) => new IFC2X3.IfcSlippageConnectionCondition(a[0], a[1], a[2], a[3]),
  723233188: (_) => new IFC2X3.IfcSolidModel(),
  2485662743: (a) => new IFC2X3.IfcSoundProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1202362311: (a) => new IFC2X3.IfcSoundValue(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  390701378: (a) => new IFC2X3.IfcSpaceThermalLoadProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
  1595516126: (a) => new IFC2X3.IfcStructuralLoadLinearForce(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  2668620305: (a) => new IFC2X3.IfcStructuralLoadPlanarForce(a[0], a[1], a[2], a[3]),
  2473145415: (a) => new IFC2X3.IfcStructuralLoadSingleDisplacement(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1973038258: (a) => new IFC2X3.IfcStructuralLoadSingleDisplacementDistortion(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1597423693: (a) => new IFC2X3.IfcStructuralLoadSingleForce(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1190533807: (a) => new IFC2X3.IfcStructuralLoadSingleForceWarping(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3843319758: (a) => new IFC2X3.IfcStructuralProfileProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18], a[19], a[20], a[21], a[22]),
  3653947884: (a) => new IFC2X3.IfcStructuralSteelProfileProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18], a[19], a[20], a[21], a[22], a[23], a[24], a[25], a[26]),
  2233826070: (a) => new IFC2X3.IfcSubedge(a[0], a[1], a[2]),
  2513912981: (_) => new IFC2X3.IfcSurface(),
  1878645084: (a) => new IFC2X3.IfcSurfaceStyleRendering(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2247615214: (a) => new IFC2X3.IfcSweptAreaSolid(a[0], a[1]),
  1260650574: (a) => new IFC2X3.IfcSweptDiskSolid(a[0], a[1], a[2], a[3], a[4]),
  230924584: (a) => new IFC2X3.IfcSweptSurface(a[0], a[1]),
  3071757647: (a) => new IFC2X3.IfcTShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  3028897424: (a) => new IFC2X3.IfcTerminatorSymbol(a[0], a[1], a[2], a[3]),
  4282788508: (a) => new IFC2X3.IfcTextLiteral(a[0], a[1], a[2]),
  3124975700: (a) => new IFC2X3.IfcTextLiteralWithExtent(a[0], a[1], a[2], a[3], a[4]),
  2715220739: (a) => new IFC2X3.IfcTrapeziumProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1345879162: (a) => new IFC2X3.IfcTwoDirectionRepeatFactor(a[0], a[1]),
  1628702193: (a) => new IFC2X3.IfcTypeObject(a[0], a[1], a[2], a[3], a[4], a[5]),
  2347495698: (a) => new IFC2X3.IfcTypeProduct(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  427810014: (a) => new IFC2X3.IfcUShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  1417489154: (a) => new IFC2X3.IfcVector(a[0], a[1]),
  2759199220: (a) => new IFC2X3.IfcVertexLoop(a[0]),
  336235671: (a) => new IFC2X3.IfcWindowLiningProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  512836454: (a) => new IFC2X3.IfcWindowPanelProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1299126871: (a) => new IFC2X3.IfcWindowStyle(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  2543172580: (a) => new IFC2X3.IfcZShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3288037868: (a) => new IFC2X3.IfcAnnotationCurveOccurrence(a[0], a[1], a[2]),
  669184980: (a) => new IFC2X3.IfcAnnotationFillArea(a[0], a[1]),
  2265737646: (a) => new IFC2X3.IfcAnnotationFillAreaOccurrence(a[0], a[1], a[2], a[3], a[4]),
  1302238472: (a) => new IFC2X3.IfcAnnotationSurface(a[0], a[1]),
  4261334040: (a) => new IFC2X3.IfcAxis1Placement(a[0], a[1]),
  3125803723: (a) => new IFC2X3.IfcAxis2Placement2D(a[0], a[1]),
  2740243338: (a) => new IFC2X3.IfcAxis2Placement3D(a[0], a[1], a[2]),
  2736907675: (a) => new IFC2X3.IfcBooleanResult(a[0], a[1], a[2]),
  4182860854: (_) => new IFC2X3.IfcBoundedSurface(),
  2581212453: (a) => new IFC2X3.IfcBoundingBox(a[0], a[1], a[2], a[3]),
  2713105998: (a) => new IFC2X3.IfcBoxedHalfSpace(a[0], a[1], a[2]),
  2898889636: (a) => new IFC2X3.IfcCShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1123145078: (a) => new IFC2X3.IfcCartesianPoint(a[0]),
  59481748: (a) => new IFC2X3.IfcCartesianTransformationOperator(a[0], a[1], a[2], a[3]),
  3749851601: (a) => new IFC2X3.IfcCartesianTransformationOperator2D(a[0], a[1], a[2], a[3]),
  3486308946: (a) => new IFC2X3.IfcCartesianTransformationOperator2DnonUniform(a[0], a[1], a[2], a[3], a[4]),
  3331915920: (a) => new IFC2X3.IfcCartesianTransformationOperator3D(a[0], a[1], a[2], a[3], a[4]),
  1416205885: (a) => new IFC2X3.IfcCartesianTransformationOperator3DnonUniform(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1383045692: (a) => new IFC2X3.IfcCircleProfileDef(a[0], a[1], a[2], a[3]),
  2205249479: (a) => new IFC2X3.IfcClosedShell(a[0]),
  2485617015: (a) => new IFC2X3.IfcCompositeCurveSegment(a[0], a[1], a[2]),
  4133800736: (a) => new IFC2X3.IfcCraneRailAShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14]),
  194851669: (a) => new IFC2X3.IfcCraneRailFShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  2506170314: (a) => new IFC2X3.IfcCsgPrimitive3D(a[0]),
  2147822146: (a) => new IFC2X3.IfcCsgSolid(a[0]),
  2601014836: (_) => new IFC2X3.IfcCurve(),
  2827736869: (a) => new IFC2X3.IfcCurveBoundedPlane(a[0], a[1], a[2]),
  693772133: (a) => new IFC2X3.IfcDefinedSymbol(a[0], a[1]),
  606661476: (a) => new IFC2X3.IfcDimensionCurve(a[0], a[1], a[2]),
  4054601972: (a) => new IFC2X3.IfcDimensionCurveTerminator(a[0], a[1], a[2], a[3], a[4]),
  32440307: (a) => new IFC2X3.IfcDirection(a[0]),
  2963535650: (a) => new IFC2X3.IfcDoorLiningProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14]),
  1714330368: (a) => new IFC2X3.IfcDoorPanelProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  526551008: (a) => new IFC2X3.IfcDoorStyle(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  3073041342: (a) => new IFC2X3.IfcDraughtingCallout(a[0]),
  445594917: (a) => new IFC2X3.IfcDraughtingPreDefinedColour(a[0]),
  4006246654: (a) => new IFC2X3.IfcDraughtingPreDefinedCurveFont(a[0]),
  1472233963: (a) => new IFC2X3.IfcEdgeLoop(a[0]),
  1883228015: (a) => new IFC2X3.IfcElementQuantity(a[0], a[1], a[2], a[3], a[4], a[5]),
  339256511: (a) => new IFC2X3.IfcElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2777663545: (a) => new IFC2X3.IfcElementarySurface(a[0]),
  2835456948: (a) => new IFC2X3.IfcEllipseProfileDef(a[0], a[1], a[2], a[3], a[4]),
  80994333: (a) => new IFC2X3.IfcEnergyProperties(a[0], a[1], a[2], a[3], a[4], a[5]),
  477187591: (a) => new IFC2X3.IfcExtrudedAreaSolid(a[0], a[1], a[2], a[3]),
  2047409740: (a) => new IFC2X3.IfcFaceBasedSurfaceModel(a[0]),
  374418227: (a) => new IFC2X3.IfcFillAreaStyleHatching(a[0], a[1], a[2], a[3], a[4]),
  4203026998: (a) => new IFC2X3.IfcFillAreaStyleTileSymbolWithStyle(a[0]),
  315944413: (a) => new IFC2X3.IfcFillAreaStyleTiles(a[0], a[1], a[2]),
  3455213021: (a) => new IFC2X3.IfcFluidFlowProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18]),
  4238390223: (a) => new IFC2X3.IfcFurnishingElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1268542332: (a) => new IFC2X3.IfcFurnitureType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  987898635: (a) => new IFC2X3.IfcGeometricCurveSet(a[0]),
  1484403080: (a) => new IFC2X3.IfcIShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  572779678: (a) => new IFC2X3.IfcLShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  1281925730: (a) => new IFC2X3.IfcLine(a[0], a[1]),
  1425443689: (a) => new IFC2X3.IfcManifoldSolidBrep(a[0]),
  3888040117: (a) => new IFC2X3.IfcObject(a[0], a[1], a[2], a[3], a[4]),
  3388369263: (a) => new IFC2X3.IfcOffsetCurve2D(a[0], a[1], a[2]),
  3505215534: (a) => new IFC2X3.IfcOffsetCurve3D(a[0], a[1], a[2], a[3]),
  3566463478: (a) => new IFC2X3.IfcPermeableCoveringProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  603570806: (a) => new IFC2X3.IfcPlanarBox(a[0], a[1], a[2]),
  220341763: (a) => new IFC2X3.IfcPlane(a[0]),
  2945172077: (a) => new IFC2X3.IfcProcess(a[0], a[1], a[2], a[3], a[4]),
  4208778838: (a) => new IFC2X3.IfcProduct(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  103090709: (a) => new IFC2X3.IfcProject(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4194566429: (a) => new IFC2X3.IfcProjectionCurve(a[0], a[1], a[2]),
  1451395588: (a) => new IFC2X3.IfcPropertySet(a[0], a[1], a[2], a[3], a[4]),
  3219374653: (a) => new IFC2X3.IfcProxy(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2770003689: (a) => new IFC2X3.IfcRectangleHollowProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2798486643: (a) => new IFC2X3.IfcRectangularPyramid(a[0], a[1], a[2], a[3]),
  3454111270: (a) => new IFC2X3.IfcRectangularTrimmedSurface(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3939117080: (a) => new IFC2X3.IfcRelAssigns(a[0], a[1], a[2], a[3], a[4], a[5]),
  1683148259: (a) => new IFC2X3.IfcRelAssignsToActor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2495723537: (a) => new IFC2X3.IfcRelAssignsToControl(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1307041759: (a) => new IFC2X3.IfcRelAssignsToGroup(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  4278684876: (a) => new IFC2X3.IfcRelAssignsToProcess(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2857406711: (a) => new IFC2X3.IfcRelAssignsToProduct(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3372526763: (a) => new IFC2X3.IfcRelAssignsToProjectOrder(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  205026976: (a) => new IFC2X3.IfcRelAssignsToResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1865459582: (a) => new IFC2X3.IfcRelAssociates(a[0], a[1], a[2], a[3], a[4]),
  1327628568: (a) => new IFC2X3.IfcRelAssociatesAppliedValue(a[0], a[1], a[2], a[3], a[4], a[5]),
  4095574036: (a) => new IFC2X3.IfcRelAssociatesApproval(a[0], a[1], a[2], a[3], a[4], a[5]),
  919958153: (a) => new IFC2X3.IfcRelAssociatesClassification(a[0], a[1], a[2], a[3], a[4], a[5]),
  2728634034: (a) => new IFC2X3.IfcRelAssociatesConstraint(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  982818633: (a) => new IFC2X3.IfcRelAssociatesDocument(a[0], a[1], a[2], a[3], a[4], a[5]),
  3840914261: (a) => new IFC2X3.IfcRelAssociatesLibrary(a[0], a[1], a[2], a[3], a[4], a[5]),
  2655215786: (a) => new IFC2X3.IfcRelAssociatesMaterial(a[0], a[1], a[2], a[3], a[4], a[5]),
  2851387026: (a) => new IFC2X3.IfcRelAssociatesProfileProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  826625072: (a) => new IFC2X3.IfcRelConnects(a[0], a[1], a[2], a[3]),
  1204542856: (a) => new IFC2X3.IfcRelConnectsElements(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3945020480: (a) => new IFC2X3.IfcRelConnectsPathElements(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  4201705270: (a) => new IFC2X3.IfcRelConnectsPortToElement(a[0], a[1], a[2], a[3], a[4], a[5]),
  3190031847: (a) => new IFC2X3.IfcRelConnectsPorts(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  2127690289: (a) => new IFC2X3.IfcRelConnectsStructuralActivity(a[0], a[1], a[2], a[3], a[4], a[5]),
  3912681535: (a) => new IFC2X3.IfcRelConnectsStructuralElement(a[0], a[1], a[2], a[3], a[4], a[5]),
  1638771189: (a) => new IFC2X3.IfcRelConnectsStructuralMember(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  504942748: (a) => new IFC2X3.IfcRelConnectsWithEccentricity(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  3678494232: (a) => new IFC2X3.IfcRelConnectsWithRealizingElements(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3242617779: (a) => new IFC2X3.IfcRelContainedInSpatialStructure(a[0], a[1], a[2], a[3], a[4], a[5]),
  886880790: (a) => new IFC2X3.IfcRelCoversBldgElements(a[0], a[1], a[2], a[3], a[4], a[5]),
  2802773753: (a) => new IFC2X3.IfcRelCoversSpaces(a[0], a[1], a[2], a[3], a[4], a[5]),
  2551354335: (a) => new IFC2X3.IfcRelDecomposes(a[0], a[1], a[2], a[3], a[4], a[5]),
  693640335: (a) => new IFC2X3.IfcRelDefines(a[0], a[1], a[2], a[3], a[4]),
  4186316022: (a) => new IFC2X3.IfcRelDefinesByProperties(a[0], a[1], a[2], a[3], a[4], a[5]),
  781010003: (a) => new IFC2X3.IfcRelDefinesByType(a[0], a[1], a[2], a[3], a[4], a[5]),
  3940055652: (a) => new IFC2X3.IfcRelFillsElement(a[0], a[1], a[2], a[3], a[4], a[5]),
  279856033: (a) => new IFC2X3.IfcRelFlowControlElements(a[0], a[1], a[2], a[3], a[4], a[5]),
  4189434867: (a) => new IFC2X3.IfcRelInteractionRequirements(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3268803585: (a) => new IFC2X3.IfcRelNests(a[0], a[1], a[2], a[3], a[4], a[5]),
  2051452291: (a) => new IFC2X3.IfcRelOccupiesSpaces(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  202636808: (a) => new IFC2X3.IfcRelOverridesProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  750771296: (a) => new IFC2X3.IfcRelProjectsElement(a[0], a[1], a[2], a[3], a[4], a[5]),
  1245217292: (a) => new IFC2X3.IfcRelReferencedInSpatialStructure(a[0], a[1], a[2], a[3], a[4], a[5]),
  1058617721: (a) => new IFC2X3.IfcRelSchedulesCostItems(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  4122056220: (a) => new IFC2X3.IfcRelSequence(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  366585022: (a) => new IFC2X3.IfcRelServicesBuildings(a[0], a[1], a[2], a[3], a[4], a[5]),
  3451746338: (a) => new IFC2X3.IfcRelSpaceBoundary(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1401173127: (a) => new IFC2X3.IfcRelVoidsElement(a[0], a[1], a[2], a[3], a[4], a[5]),
  2914609552: (a) => new IFC2X3.IfcResource(a[0], a[1], a[2], a[3], a[4]),
  1856042241: (a) => new IFC2X3.IfcRevolvedAreaSolid(a[0], a[1], a[2], a[3]),
  4158566097: (a) => new IFC2X3.IfcRightCircularCone(a[0], a[1], a[2]),
  3626867408: (a) => new IFC2X3.IfcRightCircularCylinder(a[0], a[1], a[2]),
  2706606064: (a) => new IFC2X3.IfcSpatialStructureElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3893378262: (a) => new IFC2X3.IfcSpatialStructureElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  451544542: (a) => new IFC2X3.IfcSphere(a[0], a[1]),
  3544373492: (a) => new IFC2X3.IfcStructuralActivity(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3136571912: (a) => new IFC2X3.IfcStructuralItem(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  530289379: (a) => new IFC2X3.IfcStructuralMember(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3689010777: (a) => new IFC2X3.IfcStructuralReaction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3979015343: (a) => new IFC2X3.IfcStructuralSurfaceMember(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2218152070: (a) => new IFC2X3.IfcStructuralSurfaceMemberVarying(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  4070609034: (a) => new IFC2X3.IfcStructuredDimensionCallout(a[0]),
  2028607225: (a) => new IFC2X3.IfcSurfaceCurveSweptAreaSolid(a[0], a[1], a[2], a[3], a[4], a[5]),
  2809605785: (a) => new IFC2X3.IfcSurfaceOfLinearExtrusion(a[0], a[1], a[2], a[3]),
  4124788165: (a) => new IFC2X3.IfcSurfaceOfRevolution(a[0], a[1], a[2]),
  1580310250: (a) => new IFC2X3.IfcSystemFurnitureElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3473067441: (a) => new IFC2X3.IfcTask(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2097647324: (a) => new IFC2X3.IfcTransportElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2296667514: (a) => new IFC2X3.IfcActor(a[0], a[1], a[2], a[3], a[4], a[5]),
  1674181508: (a) => new IFC2X3.IfcAnnotation(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3207858831: (a) => new IFC2X3.IfcAsymmetricIShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1334484129: (a) => new IFC2X3.IfcBlock(a[0], a[1], a[2], a[3]),
  3649129432: (a) => new IFC2X3.IfcBooleanClippingResult(a[0], a[1], a[2]),
  1260505505: (_) => new IFC2X3.IfcBoundedCurve(),
  4031249490: (a) => new IFC2X3.IfcBuilding(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1950629157: (a) => new IFC2X3.IfcBuildingElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3124254112: (a) => new IFC2X3.IfcBuildingStorey(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2937912522: (a) => new IFC2X3.IfcCircleHollowProfileDef(a[0], a[1], a[2], a[3], a[4]),
  300633059: (a) => new IFC2X3.IfcColumnType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3732776249: (a) => new IFC2X3.IfcCompositeCurve(a[0], a[1]),
  2510884976: (a) => new IFC2X3.IfcConic(a[0]),
  2559216714: (a) => new IFC2X3.IfcConstructionResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3293443760: (a) => new IFC2X3.IfcControl(a[0], a[1], a[2], a[3], a[4]),
  3895139033: (a) => new IFC2X3.IfcCostItem(a[0], a[1], a[2], a[3], a[4]),
  1419761937: (a) => new IFC2X3.IfcCostSchedule(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  1916426348: (a) => new IFC2X3.IfcCoveringType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3295246426: (a) => new IFC2X3.IfcCrewResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1457835157: (a) => new IFC2X3.IfcCurtainWallType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  681481545: (a) => new IFC2X3.IfcDimensionCurveDirectedCallout(a[0]),
  3256556792: (a) => new IFC2X3.IfcDistributionElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3849074793: (a) => new IFC2X3.IfcDistributionFlowElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  360485395: (a) => new IFC2X3.IfcElectricalBaseProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
  1758889154: (a) => new IFC2X3.IfcElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  4123344466: (a) => new IFC2X3.IfcElementAssembly(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1623761950: (a) => new IFC2X3.IfcElementComponent(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2590856083: (a) => new IFC2X3.IfcElementComponentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1704287377: (a) => new IFC2X3.IfcEllipse(a[0], a[1], a[2]),
  2107101300: (a) => new IFC2X3.IfcEnergyConversionDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1962604670: (a) => new IFC2X3.IfcEquipmentElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3272907226: (a) => new IFC2X3.IfcEquipmentStandard(a[0], a[1], a[2], a[3], a[4]),
  3174744832: (a) => new IFC2X3.IfcEvaporativeCoolerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3390157468: (a) => new IFC2X3.IfcEvaporatorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  807026263: (a) => new IFC2X3.IfcFacetedBrep(a[0]),
  3737207727: (a) => new IFC2X3.IfcFacetedBrepWithVoids(a[0], a[1]),
  647756555: (a) => new IFC2X3.IfcFastener(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2489546625: (a) => new IFC2X3.IfcFastenerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2827207264: (a) => new IFC2X3.IfcFeatureElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2143335405: (a) => new IFC2X3.IfcFeatureElementAddition(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1287392070: (a) => new IFC2X3.IfcFeatureElementSubtraction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3907093117: (a) => new IFC2X3.IfcFlowControllerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3198132628: (a) => new IFC2X3.IfcFlowFittingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3815607619: (a) => new IFC2X3.IfcFlowMeterType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1482959167: (a) => new IFC2X3.IfcFlowMovingDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1834744321: (a) => new IFC2X3.IfcFlowSegmentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1339347760: (a) => new IFC2X3.IfcFlowStorageDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2297155007: (a) => new IFC2X3.IfcFlowTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3009222698: (a) => new IFC2X3.IfcFlowTreatmentDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  263784265: (a) => new IFC2X3.IfcFurnishingElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  814719939: (a) => new IFC2X3.IfcFurnitureStandard(a[0], a[1], a[2], a[3], a[4]),
  200128114: (a) => new IFC2X3.IfcGasTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3009204131: (a) => new IFC2X3.IfcGrid(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2706460486: (a) => new IFC2X3.IfcGroup(a[0], a[1], a[2], a[3], a[4]),
  1251058090: (a) => new IFC2X3.IfcHeatExchangerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1806887404: (a) => new IFC2X3.IfcHumidifierType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2391368822: (a) => new IFC2X3.IfcInventory(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  4288270099: (a) => new IFC2X3.IfcJunctionBoxType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3827777499: (a) => new IFC2X3.IfcLaborResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1051575348: (a) => new IFC2X3.IfcLampType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1161773419: (a) => new IFC2X3.IfcLightFixtureType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2506943328: (a) => new IFC2X3.IfcLinearDimension(a[0]),
  377706215: (a) => new IFC2X3.IfcMechanicalFastener(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2108223431: (a) => new IFC2X3.IfcMechanicalFastenerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3181161470: (a) => new IFC2X3.IfcMemberType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  977012517: (a) => new IFC2X3.IfcMotorConnectionType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1916936684: (a) => new IFC2X3.IfcMove(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  4143007308: (a) => new IFC2X3.IfcOccupant(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3588315303: (a) => new IFC2X3.IfcOpeningElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3425660407: (a) => new IFC2X3.IfcOrderAction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  2837617999: (a) => new IFC2X3.IfcOutletType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2382730787: (a) => new IFC2X3.IfcPerformanceHistory(a[0], a[1], a[2], a[3], a[4], a[5]),
  3327091369: (a) => new IFC2X3.IfcPermit(a[0], a[1], a[2], a[3], a[4], a[5]),
  804291784: (a) => new IFC2X3.IfcPipeFittingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4231323485: (a) => new IFC2X3.IfcPipeSegmentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4017108033: (a) => new IFC2X3.IfcPlateType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3724593414: (a) => new IFC2X3.IfcPolyline(a[0]),
  3740093272: (a) => new IFC2X3.IfcPort(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  2744685151: (a) => new IFC2X3.IfcProcedure(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2904328755: (a) => new IFC2X3.IfcProjectOrder(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3642467123: (a) => new IFC2X3.IfcProjectOrderRecord(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3651124850: (a) => new IFC2X3.IfcProjectionElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1842657554: (a) => new IFC2X3.IfcProtectiveDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2250791053: (a) => new IFC2X3.IfcPumpType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3248260540: (a) => new IFC2X3.IfcRadiusDimension(a[0]),
  2893384427: (a) => new IFC2X3.IfcRailingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2324767716: (a) => new IFC2X3.IfcRampFlightType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  160246688: (a) => new IFC2X3.IfcRelAggregates(a[0], a[1], a[2], a[3], a[4], a[5]),
  2863920197: (a) => new IFC2X3.IfcRelAssignsTasks(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1768891740: (a) => new IFC2X3.IfcSanitaryTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3517283431: (a) => new IFC2X3.IfcScheduleTimeControl(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18], a[19], a[20], a[21], a[22]),
  4105383287: (a) => new IFC2X3.IfcServiceLife(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  4097777520: (a) => new IFC2X3.IfcSite(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
  2533589738: (a) => new IFC2X3.IfcSlabType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3856911033: (a) => new IFC2X3.IfcSpace(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  1305183839: (a) => new IFC2X3.IfcSpaceHeaterType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  652456506: (a) => new IFC2X3.IfcSpaceProgram(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3812236995: (a) => new IFC2X3.IfcSpaceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3112655638: (a) => new IFC2X3.IfcStackTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1039846685: (a) => new IFC2X3.IfcStairFlightType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  682877961: (a) => new IFC2X3.IfcStructuralAction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  1179482911: (a) => new IFC2X3.IfcStructuralConnection(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  4243806635: (a) => new IFC2X3.IfcStructuralCurveConnection(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  214636428: (a) => new IFC2X3.IfcStructuralCurveMember(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2445595289: (a) => new IFC2X3.IfcStructuralCurveMemberVarying(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1807405624: (a) => new IFC2X3.IfcStructuralLinearAction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1721250024: (a) => new IFC2X3.IfcStructuralLinearActionVarying(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
  1252848954: (a) => new IFC2X3.IfcStructuralLoadGroup(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1621171031: (a) => new IFC2X3.IfcStructuralPlanarAction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  3987759626: (a) => new IFC2X3.IfcStructuralPlanarActionVarying(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
  2082059205: (a) => new IFC2X3.IfcStructuralPointAction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  734778138: (a) => new IFC2X3.IfcStructuralPointConnection(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1235345126: (a) => new IFC2X3.IfcStructuralPointReaction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2986769608: (a) => new IFC2X3.IfcStructuralResultGroup(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1975003073: (a) => new IFC2X3.IfcStructuralSurfaceConnection(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  148013059: (a) => new IFC2X3.IfcSubContractResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  2315554128: (a) => new IFC2X3.IfcSwitchingDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2254336722: (a) => new IFC2X3.IfcSystem(a[0], a[1], a[2], a[3], a[4]),
  5716631: (a) => new IFC2X3.IfcTankType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1637806684: (a) => new IFC2X3.IfcTimeSeriesSchedule(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1692211062: (a) => new IFC2X3.IfcTransformerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1620046519: (a) => new IFC2X3.IfcTransportElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  3593883385: (a) => new IFC2X3.IfcTrimmedCurve(a[0], a[1], a[2], a[3], a[4]),
  1600972822: (a) => new IFC2X3.IfcTubeBundleType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1911125066: (a) => new IFC2X3.IfcUnitaryEquipmentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  728799441: (a) => new IFC2X3.IfcValveType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2769231204: (a) => new IFC2X3.IfcVirtualElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1898987631: (a) => new IFC2X3.IfcWallType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1133259667: (a) => new IFC2X3.IfcWasteTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1028945134: (a) => new IFC2X3.IfcWorkControl(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14]),
  4218914973: (a) => new IFC2X3.IfcWorkPlan(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14]),
  3342526732: (a) => new IFC2X3.IfcWorkSchedule(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14]),
  1033361043: (a) => new IFC2X3.IfcZone(a[0], a[1], a[2], a[3], a[4]),
  1213861670: (a) => new IFC2X3.Ifc2DCompositeCurve(a[0], a[1]),
  3821786052: (a) => new IFC2X3.IfcActionRequest(a[0], a[1], a[2], a[3], a[4], a[5]),
  1411407467: (a) => new IFC2X3.IfcAirTerminalBoxType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3352864051: (a) => new IFC2X3.IfcAirTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1871374353: (a) => new IFC2X3.IfcAirToAirHeatRecoveryType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2470393545: (a) => new IFC2X3.IfcAngularDimension(a[0]),
  3460190687: (a) => new IFC2X3.IfcAsset(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
  1967976161: (a) => new IFC2X3.IfcBSplineCurve(a[0], a[1], a[2], a[3], a[4]),
  819618141: (a) => new IFC2X3.IfcBeamType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1916977116: (a) => new IFC2X3.IfcBezierCurve(a[0], a[1], a[2], a[3], a[4]),
  231477066: (a) => new IFC2X3.IfcBoilerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3299480353: (a) => new IFC2X3.IfcBuildingElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  52481810: (a) => new IFC2X3.IfcBuildingElementComponent(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2979338954: (a) => new IFC2X3.IfcBuildingElementPart(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1095909175: (a) => new IFC2X3.IfcBuildingElementProxy(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1909888760: (a) => new IFC2X3.IfcBuildingElementProxyType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  395041908: (a) => new IFC2X3.IfcCableCarrierFittingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3293546465: (a) => new IFC2X3.IfcCableCarrierSegmentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1285652485: (a) => new IFC2X3.IfcCableSegmentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2951183804: (a) => new IFC2X3.IfcChillerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2611217952: (a) => new IFC2X3.IfcCircle(a[0], a[1]),
  2301859152: (a) => new IFC2X3.IfcCoilType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  843113511: (a) => new IFC2X3.IfcColumn(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3850581409: (a) => new IFC2X3.IfcCompressorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2816379211: (a) => new IFC2X3.IfcCondenserType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2188551683: (a) => new IFC2X3.IfcCondition(a[0], a[1], a[2], a[3], a[4]),
  1163958913: (a) => new IFC2X3.IfcConditionCriterion(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3898045240: (a) => new IFC2X3.IfcConstructionEquipmentResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1060000209: (a) => new IFC2X3.IfcConstructionMaterialResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  488727124: (a) => new IFC2X3.IfcConstructionProductResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  335055490: (a) => new IFC2X3.IfcCooledBeamType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2954562838: (a) => new IFC2X3.IfcCoolingTowerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1973544240: (a) => new IFC2X3.IfcCovering(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3495092785: (a) => new IFC2X3.IfcCurtainWall(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3961806047: (a) => new IFC2X3.IfcDamperType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4147604152: (a) => new IFC2X3.IfcDiameterDimension(a[0]),
  1335981549: (a) => new IFC2X3.IfcDiscreteAccessory(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2635815018: (a) => new IFC2X3.IfcDiscreteAccessoryType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1599208980: (a) => new IFC2X3.IfcDistributionChamberElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2063403501: (a) => new IFC2X3.IfcDistributionControlElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1945004755: (a) => new IFC2X3.IfcDistributionElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3040386961: (a) => new IFC2X3.IfcDistributionFlowElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3041715199: (a) => new IFC2X3.IfcDistributionPort(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  395920057: (a) => new IFC2X3.IfcDoor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  869906466: (a) => new IFC2X3.IfcDuctFittingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3760055223: (a) => new IFC2X3.IfcDuctSegmentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2030761528: (a) => new IFC2X3.IfcDuctSilencerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  855621170: (a) => new IFC2X3.IfcEdgeFeature(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  663422040: (a) => new IFC2X3.IfcElectricApplianceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3277789161: (a) => new IFC2X3.IfcElectricFlowStorageDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1534661035: (a) => new IFC2X3.IfcElectricGeneratorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1365060375: (a) => new IFC2X3.IfcElectricHeaterType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1217240411: (a) => new IFC2X3.IfcElectricMotorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  712377611: (a) => new IFC2X3.IfcElectricTimeControlType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1634875225: (a) => new IFC2X3.IfcElectricalCircuit(a[0], a[1], a[2], a[3], a[4]),
  857184966: (a) => new IFC2X3.IfcElectricalElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1658829314: (a) => new IFC2X3.IfcEnergyConversionDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  346874300: (a) => new IFC2X3.IfcFanType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1810631287: (a) => new IFC2X3.IfcFilterType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4222183408: (a) => new IFC2X3.IfcFireSuppressionTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2058353004: (a) => new IFC2X3.IfcFlowController(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  4278956645: (a) => new IFC2X3.IfcFlowFitting(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  4037862832: (a) => new IFC2X3.IfcFlowInstrumentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3132237377: (a) => new IFC2X3.IfcFlowMovingDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  987401354: (a) => new IFC2X3.IfcFlowSegment(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  707683696: (a) => new IFC2X3.IfcFlowStorageDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2223149337: (a) => new IFC2X3.IfcFlowTerminal(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3508470533: (a) => new IFC2X3.IfcFlowTreatmentDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  900683007: (a) => new IFC2X3.IfcFooting(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1073191201: (a) => new IFC2X3.IfcMember(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1687234759: (a) => new IFC2X3.IfcPile(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3171933400: (a) => new IFC2X3.IfcPlate(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2262370178: (a) => new IFC2X3.IfcRailing(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3024970846: (a) => new IFC2X3.IfcRamp(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3283111854: (a) => new IFC2X3.IfcRampFlight(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3055160366: (a) => new IFC2X3.IfcRationalBezierCurve(a[0], a[1], a[2], a[3], a[4], a[5]),
  3027567501: (a) => new IFC2X3.IfcReinforcingElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2320036040: (a) => new IFC2X3.IfcReinforcingMesh(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16]),
  2016517767: (a) => new IFC2X3.IfcRoof(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1376911519: (a) => new IFC2X3.IfcRoundedEdgeFeature(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1783015770: (a) => new IFC2X3.IfcSensorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1529196076: (a) => new IFC2X3.IfcSlab(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  331165859: (a) => new IFC2X3.IfcStair(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4252922144: (a) => new IFC2X3.IfcStairFlight(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  2515109513: (a) => new IFC2X3.IfcStructuralAnalysisModel(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3824725483: (a) => new IFC2X3.IfcTendon(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16]),
  2347447852: (a) => new IFC2X3.IfcTendonAnchor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3313531582: (a) => new IFC2X3.IfcVibrationIsolatorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2391406946: (a) => new IFC2X3.IfcWall(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3512223829: (a) => new IFC2X3.IfcWallStandardCase(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3304561284: (a) => new IFC2X3.IfcWindow(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2874132201: (a) => new IFC2X3.IfcActuatorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3001207471: (a) => new IFC2X3.IfcAlarmType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  753842376: (a) => new IFC2X3.IfcBeam(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2454782716: (a) => new IFC2X3.IfcChamferEdgeFeature(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  578613899: (a) => new IFC2X3.IfcControllerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1052013943: (a) => new IFC2X3.IfcDistributionChamberElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1062813311: (a) => new IFC2X3.IfcDistributionControlElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3700593921: (a) => new IFC2X3.IfcElectricDistributionPoint(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  979691226: (a) => new IFC2X3.IfcReinforcingBar(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13])
};
ToRawLineData[1] = {
  3630933823: (i) => [i.Role, i.UserDefinedRole, i.Description],
  618182010: (i) => [i.Purpose, i.Description, i.UserDefinedPurpose],
  639542469: (i) => [i.ApplicationDeveloper, i.Version, i.ApplicationFullName, i.ApplicationIdentifier],
  411424972: (i) => [i.Name, i.Description, i.AppliedValue, i.UnitBasis, i.ApplicableDate, i.FixedUntilDate],
  1110488051: (i) => [i.ComponentOfTotal, i.Components, i.ArithmeticOperator, i.Name, i.Description],
  130549933: (i) => [i.Description, i.ApprovalDateTime, i.ApprovalStatus, i.ApprovalLevel, i.ApprovalQualifier, i.Name, i.Identifier],
  2080292479: (i) => [i.Actor, i.Approval, i.Role],
  390851274: (i) => [i.ApprovedProperties, i.Approval],
  3869604511: (i) => [i.RelatedApproval, i.RelatingApproval, i.Description, i.Name],
  4037036970: (i) => [i.Name],
  1560379544: (i) => [i.Name, i.LinearStiffnessByLengthX, i.LinearStiffnessByLengthY, i.LinearStiffnessByLengthZ, i.RotationalStiffnessByLengthX, i.RotationalStiffnessByLengthY, i.RotationalStiffnessByLengthZ],
  3367102660: (i) => [i.Name, i.LinearStiffnessByAreaX, i.LinearStiffnessByAreaY, i.LinearStiffnessByAreaZ],
  1387855156: (i) => [i.Name, i.LinearStiffnessX, i.LinearStiffnessY, i.LinearStiffnessZ, i.RotationalStiffnessX, i.RotationalStiffnessY, i.RotationalStiffnessZ],
  2069777674: (i) => [i.Name, i.LinearStiffnessX, i.LinearStiffnessY, i.LinearStiffnessZ, i.RotationalStiffnessX, i.RotationalStiffnessY, i.RotationalStiffnessZ, i.WarpingStiffness],
  622194075: (i) => [i.DayComponent, i.MonthComponent, i.YearComponent],
  747523909: (i) => [i.Source, i.Edition, i.EditionDate, i.Name],
  1767535486: (i) => [i.Notation, i.ItemOf, i.Title],
  1098599126: (i) => [i.RelatingItem, i.RelatedItems],
  938368621: (i) => [i.NotationFacets],
  3639012971: (i) => [i.NotationValue],
  3264961684: (i) => [i.Name],
  2859738748: (_) => [],
  2614616156: (i) => [i.PointOnRelatingElement, i.PointOnRelatedElement],
  4257277454: (i) => [i.LocationAtRelatingElement, i.LocationAtRelatedElement, i.ProfileOfPort],
  2732653382: (i) => [i.SurfaceOnRelatingElement, i.SurfaceOnRelatedElement],
  1959218052: (i) => [i.Name, i.Description, i.ConstraintGrade, i.ConstraintSource, i.CreatingActor, i.CreationTime, i.UserDefinedGrade],
  1658513725: (i) => [i.Name, i.Description, i.RelatingConstraint, i.RelatedConstraints, i.LogicalAggregator],
  613356794: (i) => [i.ClassifiedConstraint, i.RelatedClassifications],
  347226245: (i) => [i.Name, i.Description, i.RelatingConstraint, i.RelatedConstraints],
  1065062679: (i) => [i.HourOffset, i.MinuteOffset, i.Sense],
  602808272: (i) => [i.Name, i.Description, i.AppliedValue, i.UnitBasis, i.ApplicableDate, i.FixedUntilDate, i.CostType, i.Condition],
  539742890: (i) => [i.RelatingMonetaryUnit, i.RelatedMonetaryUnit, i.ExchangeRate, i.RateDateTime, i.RateSource],
  1105321065: (i) => [i.Name, i.PatternList],
  2367409068: (i) => [i.Name, i.CurveFont, i.CurveFontScaling],
  3510044353: (i) => [i.VisibleSegmentLength, i.InvisibleSegmentLength],
  1072939445: (i) => [i.DateComponent, i.TimeComponent],
  1765591967: (i) => [i.Elements, i.UnitType, i.UserDefinedType],
  1045800335: (i) => [i.Unit, i.Exponent],
  2949456006: (i) => [i.LengthExponent, i.MassExponent, i.TimeExponent, i.ElectricCurrentExponent, i.ThermodynamicTemperatureExponent, i.AmountOfSubstanceExponent, i.LuminousIntensityExponent],
  1376555844: (i) => [i.FileExtension, i.MimeContentType, i.MimeSubtype],
  1154170062: (i) => [i.DocumentId, i.Name, i.Description, i.DocumentReferences, i.Purpose, i.IntendedUse, i.Scope, i.Revision, i.DocumentOwner, i.Editors, i.CreationTime, i.LastRevisionTime, i.ElectronicFormat, i.ValidFrom, i.ValidUntil, i.Confidentiality, i.Status],
  770865208: (i) => [i.RelatingDocument, i.RelatedDocuments, i.RelationshipType],
  3796139169: (i) => [i.Name, i.Description, i.RelatingDraughtingCallout, i.RelatedDraughtingCallout],
  1648886627: (i) => [i.Name, i.Description, i.AppliedValue, i.UnitBasis, i.ApplicableDate, i.FixedUntilDate, i.ImpactType, i.Category, i.UserDefinedCategory],
  3200245327: (i) => [i.Location, i.ItemReference, i.Name],
  2242383968: (i) => [i.Location, i.ItemReference, i.Name],
  1040185647: (i) => [i.Location, i.ItemReference, i.Name],
  3207319532: (i) => [i.Location, i.ItemReference, i.Name],
  3548104201: (i) => [i.Location, i.ItemReference, i.Name],
  852622518: (i) => [i.AxisTag, i.AxisCurve, { type: 3, value: BooleanConvert(i.SameSense.value) }],
  3020489413: (i) => [i.TimeStamp, i.ListValues.map((p) => Labelise(p))],
  2655187982: (i) => [i.Name, i.Version, i.Publisher, i.VersionDate, i.LibraryReference],
  3452421091: (i) => [i.Location, i.ItemReference, i.Name],
  4162380809: (i) => [i.MainPlaneAngle, i.SecondaryPlaneAngle, i.LuminousIntensity],
  1566485204: (i) => [i.LightDistributionCurve, i.DistributionData],
  30780891: (i) => [i.HourComponent, i.MinuteComponent, i.SecondComponent, i.Zone, i.DaylightSavingOffset],
  1838606355: (i) => [i.Name],
  1847130766: (i) => [i.MaterialClassifications, i.ClassifiedMaterial],
  248100487: (i) => [i.Material, i.LayerThickness, i.IsVentilated == null ? null : { type: 3, value: BooleanConvert(i.IsVentilated.value) }],
  3303938423: (i) => [i.MaterialLayers, i.LayerSetName],
  1303795690: (i) => [i.ForLayerSet, i.LayerSetDirection, i.DirectionSense, i.OffsetFromReferenceLine],
  2199411900: (i) => [i.Materials],
  3265635763: (i) => [i.Material],
  2597039031: (i) => [Labelise(i.ValueComponent), i.UnitComponent],
  4256014907: (i) => [i.Material, i.DynamicViscosity, i.YoungModulus, i.ShearModulus, i.PoissonRatio, i.ThermalExpansionCoefficient],
  677618848: (i) => [i.Material, i.DynamicViscosity, i.YoungModulus, i.ShearModulus, i.PoissonRatio, i.ThermalExpansionCoefficient, i.YieldStress, i.UltimateStress, i.UltimateStrain, i.HardeningModule, i.ProportionalStress, i.PlasticStrain, i.Relaxations],
  3368373690: (i) => [i.Name, i.Description, i.ConstraintGrade, i.ConstraintSource, i.CreatingActor, i.CreationTime, i.UserDefinedGrade, i.Benchmark, i.ValueSource, i.DataValue],
  2706619895: (i) => [i.Currency],
  1918398963: (i) => [i.Dimensions, i.UnitType],
  3701648758: (_) => [],
  2251480897: (i) => [i.Name, i.Description, i.ConstraintGrade, i.ConstraintSource, i.CreatingActor, i.CreationTime, i.UserDefinedGrade, i.BenchmarkValues, i.ResultValues, i.ObjectiveQualifier, i.UserDefinedQualifier],
  1227763645: (i) => [i.Material, i.VisibleTransmittance, i.SolarTransmittance, i.ThermalIrTransmittance, i.ThermalIrEmissivityBack, i.ThermalIrEmissivityFront, i.VisibleReflectanceBack, i.VisibleReflectanceFront, i.SolarReflectanceFront, i.SolarReflectanceBack],
  4251960020: (i) => [i.Id, i.Name, i.Description, i.Roles, i.Addresses],
  1411181986: (i) => [i.Name, i.Description, i.RelatingOrganization, i.RelatedOrganizations],
  1207048766: (i) => [i.OwningUser, i.OwningApplication, i.State, i.ChangeAction, i.LastModifiedDate, i.LastModifyingUser, i.LastModifyingApplication, i.CreationDate],
  2077209135: (i) => [i.Id, i.FamilyName, i.GivenName, i.MiddleNames, i.PrefixTitles, i.SuffixTitles, i.Roles, i.Addresses],
  101040310: (i) => [i.ThePerson, i.TheOrganization, i.Roles],
  2483315170: (i) => [i.Name, i.Description],
  2226359599: (i) => [i.Name, i.Description, i.Unit],
  3355820592: (i) => [i.Purpose, i.Description, i.UserDefinedPurpose, i.InternalLocation, i.AddressLines, i.PostalBox, i.Town, i.Region, i.PostalCode, i.Country],
  3727388367: (i) => [i.Name],
  990879717: (i) => [i.Name],
  3213052703: (i) => [i.Name],
  1775413392: (i) => [i.Name],
  2022622350: (i) => [i.Name, i.Description, i.AssignedItems, i.Identifier],
  1304840413: (i) => [i.Name, i.Description, i.AssignedItems, i.Identifier, i.LayerOn, i.LayerFrozen, i.LayerBlocked, i.LayerStyles],
  3119450353: (i) => [i.Name],
  2417041796: (i) => [i.Styles],
  2095639259: (i) => [i.Name, i.Description, i.Representations],
  2267347899: (i) => [i.Material, i.SpecificHeatCapacity, i.N20Content, i.COContent, i.CO2Content],
  3958567839: (i) => [i.ProfileType, i.ProfileName],
  2802850158: (i) => [i.ProfileName, i.ProfileDefinition],
  2598011224: (i) => [i.Name, i.Description],
  3896028662: (i) => [i.RelatingConstraint, i.RelatedProperties, i.Name, i.Description],
  148025276: (i) => [i.DependingProperty, i.DependantProperty, i.Name, i.Description, i.Expression],
  3710013099: (i) => [i.Name, i.EnumerationValues.map((p) => Labelise(p)), i.Unit],
  2044713172: (i) => [i.Name, i.Description, i.Unit, i.AreaValue],
  2093928680: (i) => [i.Name, i.Description, i.Unit, i.CountValue],
  931644368: (i) => [i.Name, i.Description, i.Unit, i.LengthValue],
  3252649465: (i) => [i.Name, i.Description, i.Unit, i.TimeValue],
  2405470396: (i) => [i.Name, i.Description, i.Unit, i.VolumeValue],
  825690147: (i) => [i.Name, i.Description, i.Unit, i.WeightValue],
  2692823254: (i) => [i.ReferencedDocument, i.ReferencingValues, i.Name, i.Description],
  1580146022: (i) => [i.TotalCrossSectionArea, i.SteelGrade, i.BarSurface, i.EffectiveDepth, i.NominalBarDiameter, i.BarCount],
  1222501353: (i) => [i.RelaxationValue, i.InitialStress],
  1076942058: (i) => [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items],
  3377609919: (i) => [i.ContextIdentifier, i.ContextType],
  3008791417: (_) => [],
  1660063152: (i) => [i.MappingOrigin, i.MappedRepresentation],
  3679540991: (i) => [i.ProfileName, i.ProfileDefinition, i.Thickness, i.RibHeight, i.RibWidth, i.RibSpacing, i.Direction],
  2341007311: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  448429030: (i) => [i.Dimensions, i.UnitType, i.Prefix, i.Name],
  2042790032: (i) => [i.SectionType, i.StartProfile, i.EndProfile],
  4165799628: (i) => [i.LongitudinalStartPosition, i.LongitudinalEndPosition, i.TransversePosition, i.ReinforcementRole, i.SectionDefinition, i.CrossSectionReinforcementDefinitions],
  867548509: (i) => [i.ShapeRepresentations, i.Name, i.Description, i.ProductDefinitional, i.PartOfProductDefinitionShape],
  3982875396: (i) => [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items],
  4240577450: (i) => [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items],
  3692461612: (i) => [i.Name, i.Description],
  2273995522: (i) => [i.Name],
  2162789131: (i) => [i.Name],
  2525727697: (i) => [i.Name],
  3408363356: (i) => [i.Name, i.DeltaT_Constant, i.DeltaT_Y, i.DeltaT_Z],
  2830218821: (i) => [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items],
  3958052878: (i) => [i.Item, i.Styles, i.Name],
  3049322572: (i) => [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items],
  1300840506: (i) => [i.Name, i.Side, i.Styles],
  3303107099: (i) => [i.DiffuseTransmissionColour, i.DiffuseReflectionColour, i.TransmissionColour, i.ReflectanceColour],
  1607154358: (i) => [i.RefractionIndex, i.DispersionFactor],
  846575682: (i) => [i.SurfaceColour],
  1351298697: (i) => [i.Textures],
  626085974: (i) => [i.RepeatS, i.RepeatT, i.TextureType, i.TextureTransform],
  1290481447: (i) => [i.Name, Labelise(i.StyleOfSymbol)],
  985171141: (i) => [i.Name, i.Rows],
  531007025: (i) => [i.RowCells.map((p) => Labelise(p)), i.IsHeading],
  912023232: (i) => [i.Purpose, i.Description, i.UserDefinedPurpose, i.TelephoneNumbers, i.FacsimileNumbers, i.PagerNumber, i.ElectronicMailAddresses, i.WWWHomePageURL],
  1447204868: (i) => [i.Name, i.TextCharacterAppearance, i.TextStyle, i.TextFontStyle],
  1983826977: (i) => [i.Name, i.FontFamily, i.FontStyle, i.FontVariant, i.FontWeight, Labelise(i.FontSize)],
  2636378356: (i) => [i.Colour, i.BackgroundColour],
  1640371178: (i) => [!i.TextIndent ? null : Labelise(i.TextIndent), i.TextAlign, i.TextDecoration, !i.LetterSpacing ? null : Labelise(i.LetterSpacing), !i.WordSpacing ? null : Labelise(i.WordSpacing), i.TextTransform, !i.LineHeight ? null : Labelise(i.LineHeight)],
  1484833681: (i) => [i.BoxHeight, i.BoxWidth, i.BoxSlantAngle, i.BoxRotateAngle, !i.CharacterSpacing ? null : Labelise(i.CharacterSpacing)],
  280115917: (_) => [],
  1742049831: (i) => [i.Mode, i.Parameter.map((p) => Labelise(p))],
  2552916305: (i) => [i.TextureMaps],
  1210645708: (i) => [i.Coordinates],
  3317419933: (i) => [i.Material, i.SpecificHeatCapacity, i.BoilingPoint, i.FreezingPoint, i.ThermalConductivity],
  3101149627: (i) => [i.Name, i.Description, i.StartTime, i.EndTime, i.TimeSeriesDataType, i.DataOrigin, i.UserDefinedDataOrigin, i.Unit],
  1718945513: (i) => [i.ReferencedTimeSeries, i.TimeSeriesReferences],
  581633288: (i) => [i.ListValues.map((p) => Labelise(p))],
  1377556343: (_) => [],
  1735638870: (i) => [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items],
  180925521: (i) => [i.Units],
  2799835756: (_) => [],
  3304826586: (i) => [i.TextureVertices, i.TexturePoints],
  1907098498: (i) => [i.VertexGeometry],
  891718957: (i) => [i.IntersectingAxes, i.OffsetDistances],
  1065908215: (i) => [i.Material, i.IsPotable, i.Hardness, i.AlkalinityConcentration, i.AcidityConcentration, i.ImpuritiesContent, i.PHLevel, i.DissolvedSolidsContent],
  2442683028: (i) => [i.Item, i.Styles, i.Name],
  962685235: (i) => [i.Item, i.Styles, i.Name],
  3612888222: (i) => [i.Item, i.Styles, i.Name],
  2297822566: (i) => [i.Item, i.Styles, i.Name],
  3798115385: (i) => [i.ProfileType, i.ProfileName, i.OuterCurve],
  1310608509: (i) => [i.ProfileType, i.ProfileName, i.Curve],
  2705031697: (i) => [i.ProfileType, i.ProfileName, i.OuterCurve, i.InnerCurves],
  616511568: (i) => [i.RepeatS, i.RepeatT, i.TextureType, i.TextureTransform, i.RasterFormat, i.RasterCode],
  3150382593: (i) => [i.ProfileType, i.ProfileName, i.Curve, i.Thickness],
  647927063: (i) => [i.Location, i.ItemReference, i.Name, i.ReferencedSource],
  776857604: (i) => [i.Name, i.Red, i.Green, i.Blue],
  2542286263: (i) => [i.Name, i.Description, i.UsageName, i.HasProperties],
  1485152156: (i) => [i.ProfileType, i.ProfileName, i.Profiles, i.Label],
  370225590: (i) => [i.CfsFaces],
  1981873012: (i) => [i.CurveOnRelatingElement, i.CurveOnRelatedElement],
  45288368: (i) => [i.PointOnRelatingElement, i.PointOnRelatedElement, i.EccentricityInX, i.EccentricityInY, i.EccentricityInZ],
  3050246964: (i) => [i.Dimensions, i.UnitType, i.Name],
  2889183280: (i) => [i.Dimensions, i.UnitType, i.Name, i.ConversionFactor],
  3800577675: (i) => [i.Name, i.CurveFont, !i.CurveWidth ? null : Labelise(i.CurveWidth), i.CurveColour],
  3632507154: (i) => [i.ProfileType, i.ProfileName, i.ParentProfile, i.Operator, i.Label],
  2273265877: (i) => [i.Name, i.Description, i.RelatingDraughtingCallout, i.RelatedDraughtingCallout],
  1694125774: (i) => [i.Name, i.Description, i.RelatingDraughtingCallout, i.RelatedDraughtingCallout],
  3732053477: (i) => [i.Location, i.ItemReference, i.Name],
  4170525392: (i) => [i.Name],
  3900360178: (i) => [i.EdgeStart, i.EdgeEnd],
  476780140: (i) => [i.EdgeStart, i.EdgeEnd, i.EdgeGeometry, i.SameSense],
  1860660968: (i) => [i.Material, i.ExtendedProperties, i.Description, i.Name],
  2556980723: (i) => [i.Bounds],
  1809719519: (i) => [i.Bound, i.Orientation],
  803316827: (i) => [i.Bound, i.Orientation],
  3008276851: (i) => [i.Bounds, i.FaceSurface, i.SameSense],
  4219587988: (i) => [i.Name, i.TensionFailureX, i.TensionFailureY, i.TensionFailureZ, i.CompressionFailureX, i.CompressionFailureY, i.CompressionFailureZ],
  738692330: (i) => [i.Name, i.FillStyles],
  3857492461: (i) => [i.Material, i.CombustionTemperature, i.CarbonContent, i.LowerHeatingValue, i.HigherHeatingValue],
  803998398: (i) => [i.Material, i.MolecularWeight, i.Porosity, i.MassDensity],
  1446786286: (i) => [i.ProfileName, i.ProfileDefinition, i.PhysicalWeight, i.Perimeter, i.MinimumPlateThickness, i.MaximumPlateThickness, i.CrossSectionArea],
  3448662350: (i) => [i.ContextIdentifier, i.ContextType, i.CoordinateSpaceDimension, i.Precision, i.WorldCoordinateSystem, i.TrueNorth],
  2453401579: (_) => [],
  4142052618: (i) => [i.ContextIdentifier, i.ContextType, i.CoordinateSpaceDimension, i.Precision, i.WorldCoordinateSystem, i.TrueNorth, i.ParentContext, i.TargetScale, i.TargetView, i.UserDefinedTargetView],
  3590301190: (i) => [i.Elements],
  178086475: (i) => [i.PlacementLocation, i.PlacementRefDirection],
  812098782: (i) => [i.BaseSurface, i.AgreementFlag],
  2445078500: (i) => [i.Material, i.UpperVaporResistanceFactor, i.LowerVaporResistanceFactor, i.IsothermalMoistureCapacity, i.VaporPermeability, i.MoistureDiffusivity],
  3905492369: (i) => [i.RepeatS, i.RepeatT, i.TextureType, i.TextureTransform, i.UrlReference],
  3741457305: (i) => [i.Name, i.Description, i.StartTime, i.EndTime, i.TimeSeriesDataType, i.DataOrigin, i.UserDefinedDataOrigin, i.Unit, i.Values],
  1402838566: (i) => [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity],
  125510826: (i) => [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity],
  2604431987: (i) => [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity, i.Orientation],
  4266656042: (i) => [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity, i.Position, i.ColourAppearance, i.ColourTemperature, i.LuminousFlux, i.LightEmissionSource, i.LightDistributionDataSource],
  1520743889: (i) => [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity, i.Position, i.Radius, i.ConstantAttenuation, i.DistanceAttenuation, i.QuadricAttenuation],
  3422422726: (i) => [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity, i.Position, i.Radius, i.ConstantAttenuation, i.DistanceAttenuation, i.QuadricAttenuation, i.Orientation, i.ConcentrationExponent, i.SpreadAngle, i.BeamWidthAngle],
  2624227202: (i) => [i.PlacementRelTo, i.RelativePlacement],
  1008929658: (_) => [],
  2347385850: (i) => [i.MappingSource, i.MappingTarget],
  2022407955: (i) => [i.Name, i.Description, i.Representations, i.RepresentedMaterial],
  1430189142: (i) => [i.Material, i.DynamicViscosity, i.YoungModulus, i.ShearModulus, i.PoissonRatio, i.ThermalExpansionCoefficient, i.CompressiveStrength, i.MaxAggregateSize, i.AdmixturesDescription, i.Workability, i.ProtectivePoreRatio, i.WaterImpermeability],
  219451334: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  2833995503: (i) => [i.RepeatFactor],
  2665983363: (i) => [i.CfsFaces],
  1029017970: (i) => [i.EdgeStart, i.EdgeEnd, i.EdgeElement, i.Orientation],
  2529465313: (i) => [i.ProfileType, i.ProfileName, i.Position],
  2519244187: (i) => [i.EdgeList],
  3021840470: (i) => [i.Name, i.Description, i.HasQuantities, i.Discrimination, i.Quality, i.Usage],
  597895409: (i) => [i.RepeatS, i.RepeatT, i.TextureType, i.TextureTransform, i.Width, i.Height, i.ColourComponents, i.Pixel],
  2004835150: (i) => [i.Location],
  1663979128: (i) => [i.SizeInX, i.SizeInY],
  2067069095: (_) => [],
  4022376103: (i) => [i.BasisCurve, i.PointParameter],
  1423911732: (i) => [i.BasisSurface, i.PointParameterU, i.PointParameterV],
  2924175390: (i) => [i.Polygon],
  2775532180: (i) => [i.BaseSurface, i.AgreementFlag, i.Position, i.PolygonalBoundary],
  759155922: (i) => [i.Name],
  2559016684: (i) => [i.Name],
  433424934: (i) => [i.Name],
  179317114: (i) => [i.Name],
  673634403: (i) => [i.Name, i.Description, i.Representations],
  871118103: (i) => [i.Name, i.Description, !i.UpperBoundValue ? null : Labelise(i.UpperBoundValue), !i.LowerBoundValue ? null : Labelise(i.LowerBoundValue), i.Unit],
  1680319473: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  4166981789: (i) => [i.Name, i.Description, i.EnumerationValues.map((p) => Labelise(p)), i.EnumerationReference],
  2752243245: (i) => [i.Name, i.Description, i.ListValues.map((p) => Labelise(p)), i.Unit],
  941946838: (i) => [i.Name, i.Description, i.UsageName, i.PropertyReference],
  3357820518: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  3650150729: (i) => [i.Name, i.Description, !i.NominalValue ? null : Labelise(i.NominalValue), i.Unit],
  110355661: (i) => [i.Name, i.Description, i.DefiningValues.map((p) => Labelise(p)), i.DefinedValues.map((p) => Labelise(p)), i.Expression, i.DefiningUnit, i.DefinedUnit],
  3615266464: (i) => [i.ProfileType, i.ProfileName, i.Position, i.XDim, i.YDim],
  3413951693: (i) => [i.Name, i.Description, i.StartTime, i.EndTime, i.TimeSeriesDataType, i.DataOrigin, i.UserDefinedDataOrigin, i.Unit, i.TimeStep, i.Values],
  3765753017: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.DefinitionType, i.ReinforcementSectionDefinitions],
  478536968: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  2778083089: (i) => [i.ProfileType, i.ProfileName, i.Position, i.XDim, i.YDim, i.RoundingRadius],
  1509187699: (i) => [i.SpineCurve, i.CrossSections, i.CrossSectionPositions],
  2411513650: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.PredefinedType, !i.UpperValue ? null : Labelise(i.UpperValue), Labelise(i.MostUsedValue), !i.LowerValue ? null : Labelise(i.LowerValue)],
  4124623270: (i) => [i.SbsmBoundary],
  2609359061: (i) => [i.Name, i.SlippageX, i.SlippageY, i.SlippageZ],
  723233188: (_) => [],
  2485662743: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, { type: 3, value: BooleanConvert(i.IsAttenuating.value) }, i.SoundScale, i.SoundValues],
  1202362311: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.SoundLevelTimeSeries, i.Frequency, !i.SoundLevelSingleValue ? null : Labelise(i.SoundLevelSingleValue)],
  390701378: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableValueRatio, i.ThermalLoadSource, i.PropertySource, i.SourceDescription, i.MaximumValue, i.MinimumValue, i.ThermalLoadTimeSeriesValues, i.UserDefinedThermalLoadSource, i.UserDefinedPropertySource, i.ThermalLoadType],
  1595516126: (i) => [i.Name, i.LinearForceX, i.LinearForceY, i.LinearForceZ, i.LinearMomentX, i.LinearMomentY, i.LinearMomentZ],
  2668620305: (i) => [i.Name, i.PlanarForceX, i.PlanarForceY, i.PlanarForceZ],
  2473145415: (i) => [i.Name, i.DisplacementX, i.DisplacementY, i.DisplacementZ, i.RotationalDisplacementRX, i.RotationalDisplacementRY, i.RotationalDisplacementRZ],
  1973038258: (i) => [i.Name, i.DisplacementX, i.DisplacementY, i.DisplacementZ, i.RotationalDisplacementRX, i.RotationalDisplacementRY, i.RotationalDisplacementRZ, i.Distortion],
  1597423693: (i) => [i.Name, i.ForceX, i.ForceY, i.ForceZ, i.MomentX, i.MomentY, i.MomentZ],
  1190533807: (i) => [i.Name, i.ForceX, i.ForceY, i.ForceZ, i.MomentX, i.MomentY, i.MomentZ, i.WarpingMoment],
  3843319758: (i) => [i.ProfileName, i.ProfileDefinition, i.PhysicalWeight, i.Perimeter, i.MinimumPlateThickness, i.MaximumPlateThickness, i.CrossSectionArea, i.TorsionalConstantX, i.MomentOfInertiaYZ, i.MomentOfInertiaY, i.MomentOfInertiaZ, i.WarpingConstant, i.ShearCentreZ, i.ShearCentreY, i.ShearDeformationAreaZ, i.ShearDeformationAreaY, i.MaximumSectionModulusY, i.MinimumSectionModulusY, i.MaximumSectionModulusZ, i.MinimumSectionModulusZ, i.TorsionalSectionModulus, i.CentreOfGravityInX, i.CentreOfGravityInY],
  3653947884: (i) => [i.ProfileName, i.ProfileDefinition, i.PhysicalWeight, i.Perimeter, i.MinimumPlateThickness, i.MaximumPlateThickness, i.CrossSectionArea, i.TorsionalConstantX, i.MomentOfInertiaYZ, i.MomentOfInertiaY, i.MomentOfInertiaZ, i.WarpingConstant, i.ShearCentreZ, i.ShearCentreY, i.ShearDeformationAreaZ, i.ShearDeformationAreaY, i.MaximumSectionModulusY, i.MinimumSectionModulusY, i.MaximumSectionModulusZ, i.MinimumSectionModulusZ, i.TorsionalSectionModulus, i.CentreOfGravityInX, i.CentreOfGravityInY, i.ShearAreaZ, i.ShearAreaY, i.PlasticShapeFactorY, i.PlasticShapeFactorZ],
  2233826070: (i) => [i.EdgeStart, i.EdgeEnd, i.ParentEdge],
  2513912981: (_) => [],
  1878645084: (i) => [i.SurfaceColour, i.Transparency, i.DiffuseColour, i.TransmissionColour, i.DiffuseTransmissionColour, i.ReflectionColour, i.SpecularColour, !i.SpecularHighlight ? null : Labelise(i.SpecularHighlight), i.ReflectanceMethod],
  2247615214: (i) => [i.SweptArea, i.Position],
  1260650574: (i) => [i.Directrix, i.Radius, i.InnerRadius, i.StartParam, i.EndParam],
  230924584: (i) => [i.SweptCurve, i.Position],
  3071757647: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.FlangeWidth, i.WebThickness, i.FlangeThickness, i.FilletRadius, i.FlangeEdgeRadius, i.WebEdgeRadius, i.WebSlope, i.FlangeSlope, i.CentreOfGravityInY],
  3028897424: (i) => [i.Item, i.Styles, i.Name, i.AnnotatedCurve],
  4282788508: (i) => [i.Literal, i.Placement, i.Path],
  3124975700: (i) => [i.Literal, i.Placement, i.Path, i.Extent, i.BoxAlignment],
  2715220739: (i) => [i.ProfileType, i.ProfileName, i.Position, i.BottomXDim, i.TopXDim, i.YDim, i.TopXOffset],
  1345879162: (i) => [i.RepeatFactor, i.SecondRepeatFactor],
  1628702193: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets],
  2347495698: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag],
  427810014: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.FlangeWidth, i.WebThickness, i.FlangeThickness, i.FilletRadius, i.EdgeRadius, i.FlangeSlope, i.CentreOfGravityInX],
  1417489154: (i) => [i.Orientation, i.Magnitude],
  2759199220: (i) => [i.LoopVertex],
  336235671: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.LiningDepth, i.LiningThickness, i.TransomThickness, i.MullionThickness, i.FirstTransomOffset, i.SecondTransomOffset, i.FirstMullionOffset, i.SecondMullionOffset, i.ShapeAspectStyle],
  512836454: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.OperationType, i.PanelPosition, i.FrameDepth, i.FrameThickness, i.ShapeAspectStyle],
  1299126871: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ConstructionType, i.OperationType, i.ParameterTakesPrecedence, i.Sizeable],
  2543172580: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.FlangeWidth, i.WebThickness, i.FlangeThickness, i.FilletRadius, i.EdgeRadius],
  3288037868: (i) => [i.Item, i.Styles, i.Name],
  669184980: (i) => [i.OuterBoundary, i.InnerBoundaries],
  2265737646: (i) => [i.Item, i.Styles, i.Name, i.FillStyleTarget, i.GlobalOrLocal],
  1302238472: (i) => [i.Item, i.TextureCoordinates],
  4261334040: (i) => [i.Location, i.Axis],
  3125803723: (i) => [i.Location, i.RefDirection],
  2740243338: (i) => [i.Location, i.Axis, i.RefDirection],
  2736907675: (i) => [i.Operator, i.FirstOperand, i.SecondOperand],
  4182860854: (_) => [],
  2581212453: (i) => [i.Corner, i.XDim, i.YDim, i.ZDim],
  2713105998: (i) => [i.BaseSurface, i.AgreementFlag, i.Enclosure],
  2898889636: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.Width, i.WallThickness, i.Girth, i.InternalFilletRadius, i.CentreOfGravityInX],
  1123145078: (i) => [i.Coordinates],
  59481748: (i) => [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale],
  3749851601: (i) => [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale],
  3486308946: (i) => [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale, i.Scale2],
  3331915920: (i) => [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale, i.Axis3],
  1416205885: (i) => [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale, i.Axis3, i.Scale2, i.Scale3],
  1383045692: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Radius],
  2205249479: (i) => [i.CfsFaces],
  2485617015: (i) => [i.Transition, i.SameSense, i.ParentCurve],
  4133800736: (i) => [i.ProfileType, i.ProfileName, i.Position, i.OverallHeight, i.BaseWidth2, i.Radius, i.HeadWidth, i.HeadDepth2, i.HeadDepth3, i.WebThickness, i.BaseWidth4, i.BaseDepth1, i.BaseDepth2, i.BaseDepth3, i.CentreOfGravityInY],
  194851669: (i) => [i.ProfileType, i.ProfileName, i.Position, i.OverallHeight, i.HeadWidth, i.Radius, i.HeadDepth2, i.HeadDepth3, i.WebThickness, i.BaseDepth1, i.BaseDepth2, i.CentreOfGravityInY],
  2506170314: (i) => [i.Position],
  2147822146: (i) => [i.TreeRootExpression],
  2601014836: (_) => [],
  2827736869: (i) => [i.BasisSurface, i.OuterBoundary, i.InnerBoundaries],
  693772133: (i) => [i.Definition, i.Target],
  606661476: (i) => [i.Item, i.Styles, i.Name],
  4054601972: (i) => [i.Item, i.Styles, i.Name, i.AnnotatedCurve, i.Role],
  32440307: (i) => [i.DirectionRatios],
  2963535650: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.LiningDepth, i.LiningThickness, i.ThresholdDepth, i.ThresholdThickness, i.TransomThickness, i.TransomOffset, i.LiningOffset, i.ThresholdOffset, i.CasingThickness, i.CasingDepth, i.ShapeAspectStyle],
  1714330368: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.PanelDepth, i.PanelOperation, i.PanelWidth, i.PanelPosition, i.ShapeAspectStyle],
  526551008: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.OperationType, i.ConstructionType, i.ParameterTakesPrecedence, i.Sizeable],
  3073041342: (i) => [i.Contents],
  445594917: (i) => [i.Name],
  4006246654: (i) => [i.Name],
  1472233963: (i) => [i.EdgeList],
  1883228015: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.MethodOfMeasurement, i.Quantities],
  339256511: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  2777663545: (i) => [i.Position],
  2835456948: (i) => [i.ProfileType, i.ProfileName, i.Position, i.SemiAxis1, i.SemiAxis2],
  80994333: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.EnergySequence, i.UserDefinedEnergySequence],
  477187591: (i) => [i.SweptArea, i.Position, i.ExtrudedDirection, i.Depth],
  2047409740: (i) => [i.FbsmFaces],
  374418227: (i) => [i.HatchLineAppearance, i.StartOfNextHatchLine, i.PointOfReferenceHatchLine, i.PatternStart, i.HatchLineAngle],
  4203026998: (i) => [i.Symbol],
  315944413: (i) => [i.TilingPattern, i.Tiles, i.TilingScale],
  3455213021: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.PropertySource, i.FlowConditionTimeSeries, i.VelocityTimeSeries, i.FlowrateTimeSeries, i.Fluid, i.PressureTimeSeries, i.UserDefinedPropertySource, i.TemperatureSingleValue, i.WetBulbTemperatureSingleValue, i.WetBulbTemperatureTimeSeries, i.TemperatureTimeSeries, !i.FlowrateSingleValue ? null : Labelise(i.FlowrateSingleValue), i.FlowConditionSingleValue, i.VelocitySingleValue, i.PressureSingleValue],
  4238390223: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  1268542332: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.AssemblyPlace],
  987898635: (i) => [i.Elements],
  1484403080: (i) => [i.ProfileType, i.ProfileName, i.Position, i.OverallWidth, i.OverallDepth, i.WebThickness, i.FlangeThickness, i.FilletRadius],
  572779678: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.Width, i.Thickness, i.FilletRadius, i.EdgeRadius, i.LegSlope, i.CentreOfGravityInX, i.CentreOfGravityInY],
  1281925730: (i) => [i.Pnt, i.Dir],
  1425443689: (i) => [i.Outer],
  3888040117: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType],
  3388369263: (i) => [i.BasisCurve, i.Distance, i.SelfIntersect],
  3505215534: (i) => [i.BasisCurve, i.Distance, i.SelfIntersect, i.RefDirection],
  3566463478: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.OperationType, i.PanelPosition, i.FrameDepth, i.FrameThickness, i.ShapeAspectStyle],
  603570806: (i) => [i.SizeInX, i.SizeInY, i.Placement],
  220341763: (i) => [i.Position],
  2945172077: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType],
  4208778838: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation],
  103090709: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LongName, i.Phase, i.RepresentationContexts, i.UnitsInContext],
  4194566429: (i) => [i.Item, i.Styles, i.Name],
  1451395588: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.HasProperties],
  3219374653: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.ProxyType, i.Tag],
  2770003689: (i) => [i.ProfileType, i.ProfileName, i.Position, i.XDim, i.YDim, i.WallThickness, i.InnerFilletRadius, i.OuterFilletRadius],
  2798486643: (i) => [i.Position, i.XLength, i.YLength, i.Height],
  3454111270: (i) => [i.BasisSurface, i.U1, i.V1, i.U2, i.V2, i.Usense, i.Vsense],
  3939117080: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType],
  1683148259: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingActor, i.ActingRole],
  2495723537: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingControl],
  1307041759: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingGroup],
  4278684876: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingProcess, i.QuantityInProcess],
  2857406711: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingProduct],
  3372526763: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingControl],
  205026976: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingResource],
  1865459582: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects],
  1327628568: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingAppliedValue],
  4095574036: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingApproval],
  919958153: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingClassification],
  2728634034: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.Intent, i.RelatingConstraint],
  982818633: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingDocument],
  3840914261: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingLibrary],
  2655215786: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingMaterial],
  2851387026: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingProfileProperties, i.ProfileSectionLocation, i.ProfileOrientation],
  826625072: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  1204542856: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ConnectionGeometry, i.RelatingElement, i.RelatedElement],
  3945020480: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ConnectionGeometry, i.RelatingElement, i.RelatedElement, i.RelatingPriorities, i.RelatedPriorities, i.RelatedConnectionType, i.RelatingConnectionType],
  4201705270: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingPort, i.RelatedElement],
  3190031847: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingPort, i.RelatedPort, i.RealizingElement],
  2127690289: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingElement, i.RelatedStructuralActivity],
  3912681535: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingElement, i.RelatedStructuralMember],
  1638771189: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingStructuralMember, i.RelatedStructuralConnection, i.AppliedCondition, i.AdditionalConditions, i.SupportedLength, i.ConditionCoordinateSystem],
  504942748: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingStructuralMember, i.RelatedStructuralConnection, i.AppliedCondition, i.AdditionalConditions, i.SupportedLength, i.ConditionCoordinateSystem, i.ConnectionConstraint],
  3678494232: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ConnectionGeometry, i.RelatingElement, i.RelatedElement, i.RealizingElements, i.ConnectionType],
  3242617779: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedElements, i.RelatingStructure],
  886880790: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingBuildingElement, i.RelatedCoverings],
  2802773753: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedSpace, i.RelatedCoverings],
  2551354335: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingObject, i.RelatedObjects],
  693640335: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects],
  4186316022: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingPropertyDefinition],
  781010003: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingType],
  3940055652: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingOpeningElement, i.RelatedBuildingElement],
  279856033: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedControlElements, i.RelatingFlowElement],
  4189434867: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.DailyInteraction, i.ImportanceRating, i.LocationOfInteraction, i.RelatedSpaceProgram, i.RelatingSpaceProgram],
  3268803585: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingObject, i.RelatedObjects],
  2051452291: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingActor, i.ActingRole],
  202636808: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingPropertyDefinition, i.OverridingProperties],
  750771296: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingElement, i.RelatedFeatureElement],
  1245217292: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedElements, i.RelatingStructure],
  1058617721: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingControl],
  4122056220: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingProcess, i.RelatedProcess, i.TimeLag, i.SequenceType],
  366585022: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingSystem, i.RelatedBuildings],
  3451746338: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingSpace, i.RelatedBuildingElement, i.ConnectionGeometry, i.PhysicalOrVirtualBoundary, i.InternalOrExternalBoundary],
  1401173127: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingBuildingElement, i.RelatedOpeningElement],
  2914609552: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType],
  1856042241: (i) => [i.SweptArea, i.Position, i.Axis, i.Angle],
  4158566097: (i) => [i.Position, i.Height, i.BottomRadius],
  3626867408: (i) => [i.Position, i.Height, i.Radius],
  2706606064: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType],
  3893378262: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  451544542: (i) => [i.Position, i.Radius],
  3544373492: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal],
  3136571912: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation],
  530289379: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation],
  3689010777: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal],
  3979015343: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType, i.Thickness],
  2218152070: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType, i.Thickness, i.SubsequentThickness, i.VaryingThicknessLocation],
  4070609034: (i) => [i.Contents],
  2028607225: (i) => [i.SweptArea, i.Position, i.Directrix, i.StartParam, i.EndParam, i.ReferenceSurface],
  2809605785: (i) => [i.SweptCurve, i.Position, i.ExtrudedDirection, i.Depth],
  4124788165: (i) => [i.SweptCurve, i.Position, i.AxisPosition],
  1580310250: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  3473067441: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.TaskId, i.Status, i.WorkMethod, i.IsMilestone, i.Priority],
  2097647324: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2296667514: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.TheActor],
  1674181508: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation],
  3207858831: (i) => [i.ProfileType, i.ProfileName, i.Position, i.OverallWidth, i.OverallDepth, i.WebThickness, i.FlangeThickness, i.FilletRadius, i.TopFlangeWidth, i.TopFlangeThickness, i.TopFlangeFilletRadius, i.CentreOfGravityInY],
  1334484129: (i) => [i.Position, i.XLength, i.YLength, i.ZLength],
  3649129432: (i) => [i.Operator, i.FirstOperand, i.SecondOperand],
  1260505505: (_) => [],
  4031249490: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.ElevationOfRefHeight, i.ElevationOfTerrain, i.BuildingAddress],
  1950629157: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  3124254112: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.Elevation],
  2937912522: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Radius, i.WallThickness],
  300633059: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3732776249: (i) => [i.Segments, i.SelfIntersect],
  2510884976: (i) => [i.Position],
  2559216714: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ResourceIdentifier, i.ResourceGroup, i.ResourceConsumption, i.BaseQuantity],
  3293443760: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType],
  3895139033: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType],
  1419761937: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.SubmittedBy, i.PreparedBy, i.SubmittedOn, i.Status, i.TargetUsers, i.UpdateDate, i.ID, i.PredefinedType],
  1916426348: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3295246426: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ResourceIdentifier, i.ResourceGroup, i.ResourceConsumption, i.BaseQuantity],
  1457835157: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  681481545: (i) => [i.Contents],
  3256556792: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  3849074793: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  360485395: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.EnergySequence, i.UserDefinedEnergySequence, i.ElectricCurrentType, i.InputVoltage, i.InputFrequency, i.FullLoadCurrent, i.MinimumCircuitCurrent, i.MaximumPowerInput, i.RatedPowerInput, i.InputPhase],
  1758889154: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  4123344466: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.AssemblyPlace, i.PredefinedType],
  1623761950: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2590856083: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  1704287377: (i) => [i.Position, i.SemiAxis1, i.SemiAxis2],
  2107101300: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  1962604670: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3272907226: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType],
  3174744832: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3390157468: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  807026263: (i) => [i.Outer],
  3737207727: (i) => [i.Outer, i.Voids],
  647756555: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2489546625: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  2827207264: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2143335405: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  1287392070: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3907093117: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  3198132628: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  3815607619: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1482959167: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  1834744321: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  1339347760: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  2297155007: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  3009222698: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  263784265: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  814719939: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType],
  200128114: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3009204131: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.UAxes, i.VAxes, i.WAxes],
  2706460486: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType],
  1251058090: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1806887404: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2391368822: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.InventoryType, i.Jurisdiction, i.ResponsiblePersons, i.LastUpdateDate, i.CurrentValue, i.OriginalValue],
  4288270099: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3827777499: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ResourceIdentifier, i.ResourceGroup, i.ResourceConsumption, i.BaseQuantity, i.SkillSet],
  1051575348: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1161773419: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2506943328: (i) => [i.Contents],
  377706215: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.NominalDiameter, i.NominalLength],
  2108223431: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  3181161470: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  977012517: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1916936684: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.TaskId, i.Status, i.WorkMethod, i.IsMilestone, i.Priority, i.MoveFrom, i.MoveTo, i.PunchList],
  4143007308: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.TheActor, i.PredefinedType],
  3588315303: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3425660407: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.TaskId, i.Status, i.WorkMethod, i.IsMilestone, i.Priority, i.ActionID],
  2837617999: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2382730787: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LifeCyclePhase],
  3327091369: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PermitID],
  804291784: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4231323485: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4017108033: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3724593414: (i) => [i.Points],
  3740093272: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation],
  2744685151: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ProcedureID, i.ProcedureType, i.UserDefinedProcedureType],
  2904328755: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ID, i.PredefinedType, i.Status],
  3642467123: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Records, i.PredefinedType],
  3651124850: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  1842657554: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2250791053: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3248260540: (i) => [i.Contents],
  2893384427: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2324767716: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  160246688: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingObject, i.RelatedObjects],
  2863920197: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingControl, i.TimeForTask],
  1768891740: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3517283431: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ActualStart, i.EarlyStart, i.LateStart, i.ScheduleStart, i.ActualFinish, i.EarlyFinish, i.LateFinish, i.ScheduleFinish, i.ScheduleDuration, i.ActualDuration, i.RemainingTime, i.FreeFloat, i.TotalFloat, i.IsCritical, i.StatusTime, i.StartFloat, i.FinishFloat, i.Completion],
  4105383287: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ServiceLifeType, i.ServiceLifeDuration],
  4097777520: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.RefLatitude, i.RefLongitude, i.RefElevation, i.LandTitleNumber, i.SiteAddress],
  2533589738: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3856911033: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.InteriorOrExteriorSpace, i.ElevationWithFlooring],
  1305183839: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  652456506: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.SpaceProgramIdentifier, i.MaxRequiredArea, i.MinRequiredArea, i.RequestedLocation, i.StandardRequiredArea],
  3812236995: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3112655638: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1039846685: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  682877961: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad, i.CausedBy],
  1179482911: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedCondition],
  4243806635: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedCondition],
  214636428: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType],
  2445595289: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType],
  1807405624: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad, i.CausedBy, i.ProjectedOrTrue],
  1721250024: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad, i.CausedBy, i.ProjectedOrTrue, i.VaryingAppliedLoadLocation, i.SubsequentAppliedLoads],
  1252848954: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PredefinedType, i.ActionType, i.ActionSource, i.Coefficient, i.Purpose],
  1621171031: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad, i.CausedBy, i.ProjectedOrTrue],
  3987759626: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad, i.CausedBy, i.ProjectedOrTrue, i.VaryingAppliedLoadLocation, i.SubsequentAppliedLoads],
  2082059205: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad, i.CausedBy],
  734778138: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedCondition],
  1235345126: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal],
  2986769608: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.TheoryType, i.ResultForLoadGroup, i.IsLinear],
  1975003073: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedCondition],
  148013059: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ResourceIdentifier, i.ResourceGroup, i.ResourceConsumption, i.BaseQuantity, i.SubContractor, i.JobDescription],
  2315554128: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2254336722: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType],
  5716631: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1637806684: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ApplicableDates, i.TimeSeriesScheduleType, i.TimeSeries],
  1692211062: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1620046519: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.OperationType, i.CapacityByWeight, i.CapacityByNumber],
  3593883385: (i) => [i.BasisCurve, i.Trim1, i.Trim2, i.SenseAgreement, i.MasterRepresentation],
  1600972822: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1911125066: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  728799441: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2769231204: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  1898987631: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1133259667: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1028945134: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identifier, i.CreationDate, i.Creators, i.Purpose, i.Duration, i.TotalFloat, i.StartTime, i.FinishTime, i.WorkControlType, i.UserDefinedControlType],
  4218914973: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identifier, i.CreationDate, i.Creators, i.Purpose, i.Duration, i.TotalFloat, i.StartTime, i.FinishTime, i.WorkControlType, i.UserDefinedControlType],
  3342526732: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identifier, i.CreationDate, i.Creators, i.Purpose, i.Duration, i.TotalFloat, i.StartTime, i.FinishTime, i.WorkControlType, i.UserDefinedControlType],
  1033361043: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType],
  1213861670: (i) => [i.Segments, i.SelfIntersect],
  3821786052: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.RequestID],
  1411407467: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3352864051: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1871374353: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2470393545: (i) => [i.Contents],
  3460190687: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.AssetID, i.OriginalValue, i.CurrentValue, i.TotalReplacementCost, i.Owner, i.User, i.ResponsiblePerson, i.IncorporationDate, i.DepreciatedValue],
  1967976161: (i) => [i.Degree, i.ControlPointsList, i.CurveForm, i.ClosedCurve, i.SelfIntersect],
  819618141: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1916977116: (i) => [i.Degree, i.ControlPointsList, i.CurveForm, i.ClosedCurve, i.SelfIntersect],
  231477066: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3299480353: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  52481810: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2979338954: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  1095909175: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.CompositionType],
  1909888760: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  395041908: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3293546465: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1285652485: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2951183804: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2611217952: (i) => [i.Position, i.Radius],
  2301859152: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  843113511: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3850581409: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2816379211: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2188551683: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType],
  1163958913: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Criterion, i.CriterionDateTime],
  3898045240: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ResourceIdentifier, i.ResourceGroup, i.ResourceConsumption, i.BaseQuantity],
  1060000209: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ResourceIdentifier, i.ResourceGroup, i.ResourceConsumption, i.BaseQuantity, i.Suppliers, i.UsageRatio],
  488727124: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ResourceIdentifier, i.ResourceGroup, i.ResourceConsumption, i.BaseQuantity],
  335055490: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2954562838: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1973544240: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3495092785: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3961806047: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4147604152: (i) => [i.Contents],
  1335981549: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2635815018: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  1599208980: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2063403501: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  1945004755: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3040386961: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3041715199: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.FlowDirection],
  395920057: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.OverallHeight, i.OverallWidth],
  869906466: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3760055223: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2030761528: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  855621170: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.FeatureLength],
  663422040: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3277789161: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1534661035: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1365060375: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1217240411: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  712377611: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1634875225: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType],
  857184966: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  1658829314: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  346874300: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1810631287: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4222183408: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2058353004: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  4278956645: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  4037862832: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3132237377: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  987401354: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  707683696: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2223149337: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3508470533: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  900683007: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1073191201: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  1687234759: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType, i.ConstructionType],
  3171933400: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2262370178: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3024970846: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.ShapeType],
  3283111854: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3055160366: (i) => [i.Degree, i.ControlPointsList, i.CurveForm, i.ClosedCurve, i.SelfIntersect, i.WeightsData],
  3027567501: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade],
  2320036040: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade, i.MeshLength, i.MeshWidth, i.LongitudinalBarNominalDiameter, i.TransverseBarNominalDiameter, i.LongitudinalBarCrossSectionArea, i.TransverseBarCrossSectionArea, i.LongitudinalBarSpacing, i.TransverseBarSpacing],
  2016517767: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.ShapeType],
  1376911519: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.FeatureLength, i.Radius],
  1783015770: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1529196076: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  331165859: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.ShapeType],
  4252922144: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.NumberOfRiser, i.NumberOfTreads, i.RiserHeight, i.TreadLength],
  2515109513: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PredefinedType, i.OrientationOf2DPlane, i.LoadedBy, i.HasResults],
  3824725483: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade, i.PredefinedType, i.NominalDiameter, i.CrossSectionArea, i.TensionForce, i.PreStress, i.FrictionCoefficient, i.AnchorageSlip, i.MinCurvatureRadius],
  2347447852: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade],
  3313531582: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2391406946: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3512223829: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3304561284: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.OverallHeight, i.OverallWidth],
  2874132201: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3001207471: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  753842376: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2454782716: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.FeatureLength, i.Width, i.Height],
  578613899: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1052013943: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  1062813311: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.ControlElementId],
  3700593921: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.DistributionPointFunction, i.UserDefinedFunction],
  979691226: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade, i.NominalDiameter, i.CrossSectionArea, i.BarLength, i.BarRole, i.BarSurface]
};
TypeInitialisers[1] = {
  3699917729: (v) => new IFC2X3.IfcAbsorbedDoseMeasure(v),
  4182062534: (v) => new IFC2X3.IfcAccelerationMeasure(v),
  360377573: (v) => new IFC2X3.IfcAmountOfSubstanceMeasure(v),
  632304761: (v) => new IFC2X3.IfcAngularVelocityMeasure(v),
  2650437152: (v) => new IFC2X3.IfcAreaMeasure(v),
  2735952531: (v) => new IFC2X3.IfcBoolean(v),
  1867003952: (v) => new IFC2X3.IfcBoxAlignment(v),
  2991860651: (v) => new IFC2X3.IfcComplexNumber(v.map((x) => x.value)),
  3812528620: (v) => new IFC2X3.IfcCompoundPlaneAngleMeasure(v.map((x) => x.value)),
  3238673880: (v) => new IFC2X3.IfcContextDependentMeasure(v),
  1778710042: (v) => new IFC2X3.IfcCountMeasure(v),
  94842927: (v) => new IFC2X3.IfcCurvatureMeasure(v),
  86635668: (v) => new IFC2X3.IfcDayInMonthNumber(v),
  300323983: (v) => new IFC2X3.IfcDaylightSavingHour(v),
  1514641115: (v) => new IFC2X3.IfcDescriptiveMeasure(v),
  4134073009: (v) => new IFC2X3.IfcDimensionCount(v),
  524656162: (v) => new IFC2X3.IfcDoseEquivalentMeasure(v),
  69416015: (v) => new IFC2X3.IfcDynamicViscosityMeasure(v),
  1827137117: (v) => new IFC2X3.IfcElectricCapacitanceMeasure(v),
  3818826038: (v) => new IFC2X3.IfcElectricChargeMeasure(v),
  2093906313: (v) => new IFC2X3.IfcElectricConductanceMeasure(v),
  3790457270: (v) => new IFC2X3.IfcElectricCurrentMeasure(v),
  2951915441: (v) => new IFC2X3.IfcElectricResistanceMeasure(v),
  2506197118: (v) => new IFC2X3.IfcElectricVoltageMeasure(v),
  2078135608: (v) => new IFC2X3.IfcEnergyMeasure(v),
  1102727119: (v) => new IFC2X3.IfcFontStyle(v),
  2715512545: (v) => new IFC2X3.IfcFontVariant(v),
  2590844177: (v) => new IFC2X3.IfcFontWeight(v),
  1361398929: (v) => new IFC2X3.IfcForceMeasure(v),
  3044325142: (v) => new IFC2X3.IfcFrequencyMeasure(v),
  3064340077: (v) => new IFC2X3.IfcGloballyUniqueId(v),
  3113092358: (v) => new IFC2X3.IfcHeatFluxDensityMeasure(v),
  1158859006: (v) => new IFC2X3.IfcHeatingValueMeasure(v),
  2589826445: (v) => new IFC2X3.IfcHourInDay(v),
  983778844: (v) => new IFC2X3.IfcIdentifier(v),
  3358199106: (v) => new IFC2X3.IfcIlluminanceMeasure(v),
  2679005408: (v) => new IFC2X3.IfcInductanceMeasure(v),
  1939436016: (v) => new IFC2X3.IfcInteger(v),
  3809634241: (v) => new IFC2X3.IfcIntegerCountRateMeasure(v),
  3686016028: (v) => new IFC2X3.IfcIonConcentrationMeasure(v),
  3192672207: (v) => new IFC2X3.IfcIsothermalMoistureCapacityMeasure(v),
  2054016361: (v) => new IFC2X3.IfcKinematicViscosityMeasure(v),
  3258342251: (v) => new IFC2X3.IfcLabel(v),
  1243674935: (v) => new IFC2X3.IfcLengthMeasure(v),
  191860431: (v) => new IFC2X3.IfcLinearForceMeasure(v),
  2128979029: (v) => new IFC2X3.IfcLinearMomentMeasure(v),
  1307019551: (v) => new IFC2X3.IfcLinearStiffnessMeasure(v),
  3086160713: (v) => new IFC2X3.IfcLinearVelocityMeasure(v),
  503418787: (v) => new IFC2X3.IfcLogical(v),
  2095003142: (v) => new IFC2X3.IfcLuminousFluxMeasure(v),
  2755797622: (v) => new IFC2X3.IfcLuminousIntensityDistributionMeasure(v),
  151039812: (v) => new IFC2X3.IfcLuminousIntensityMeasure(v),
  286949696: (v) => new IFC2X3.IfcMagneticFluxDensityMeasure(v),
  2486716878: (v) => new IFC2X3.IfcMagneticFluxMeasure(v),
  1477762836: (v) => new IFC2X3.IfcMassDensityMeasure(v),
  4017473158: (v) => new IFC2X3.IfcMassFlowRateMeasure(v),
  3124614049: (v) => new IFC2X3.IfcMassMeasure(v),
  3531705166: (v) => new IFC2X3.IfcMassPerLengthMeasure(v),
  102610177: (v) => new IFC2X3.IfcMinuteInHour(v),
  3341486342: (v) => new IFC2X3.IfcModulusOfElasticityMeasure(v),
  2173214787: (v) => new IFC2X3.IfcModulusOfLinearSubgradeReactionMeasure(v),
  1052454078: (v) => new IFC2X3.IfcModulusOfRotationalSubgradeReactionMeasure(v),
  1753493141: (v) => new IFC2X3.IfcModulusOfSubgradeReactionMeasure(v),
  3177669450: (v) => new IFC2X3.IfcMoistureDiffusivityMeasure(v),
  1648970520: (v) => new IFC2X3.IfcMolecularWeightMeasure(v),
  3114022597: (v) => new IFC2X3.IfcMomentOfInertiaMeasure(v),
  2615040989: (v) => new IFC2X3.IfcMonetaryMeasure(v),
  765770214: (v) => new IFC2X3.IfcMonthInYearNumber(v),
  2095195183: (v) => new IFC2X3.IfcNormalisedRatioMeasure(v),
  2395907400: (v) => new IFC2X3.IfcNumericMeasure(v),
  929793134: (v) => new IFC2X3.IfcPHMeasure(v),
  2260317790: (v) => new IFC2X3.IfcParameterValue(v),
  2642773653: (v) => new IFC2X3.IfcPlanarForceMeasure(v),
  4042175685: (v) => new IFC2X3.IfcPlaneAngleMeasure(v),
  2815919920: (v) => new IFC2X3.IfcPositiveLengthMeasure(v),
  3054510233: (v) => new IFC2X3.IfcPositivePlaneAngleMeasure(v),
  1245737093: (v) => new IFC2X3.IfcPositiveRatioMeasure(v),
  1364037233: (v) => new IFC2X3.IfcPowerMeasure(v),
  2169031380: (v) => new IFC2X3.IfcPresentableText(v),
  3665567075: (v) => new IFC2X3.IfcPressureMeasure(v),
  3972513137: (v) => new IFC2X3.IfcRadioActivityMeasure(v),
  96294661: (v) => new IFC2X3.IfcRatioMeasure(v),
  200335297: (v) => new IFC2X3.IfcReal(v),
  2133746277: (v) => new IFC2X3.IfcRotationalFrequencyMeasure(v),
  1755127002: (v) => new IFC2X3.IfcRotationalMassMeasure(v),
  3211557302: (v) => new IFC2X3.IfcRotationalStiffnessMeasure(v),
  2766185779: (v) => new IFC2X3.IfcSecondInMinute(v),
  3467162246: (v) => new IFC2X3.IfcSectionModulusMeasure(v),
  2190458107: (v) => new IFC2X3.IfcSectionalAreaIntegralMeasure(v),
  408310005: (v) => new IFC2X3.IfcShearModulusMeasure(v),
  3471399674: (v) => new IFC2X3.IfcSolidAngleMeasure(v),
  846465480: (v) => new IFC2X3.IfcSoundPowerMeasure(v),
  993287707: (v) => new IFC2X3.IfcSoundPressureMeasure(v),
  3477203348: (v) => new IFC2X3.IfcSpecificHeatCapacityMeasure(v),
  2757832317: (v) => new IFC2X3.IfcSpecularExponent(v),
  361837227: (v) => new IFC2X3.IfcSpecularRoughness(v),
  58845555: (v) => new IFC2X3.IfcTemperatureGradientMeasure(v),
  2801250643: (v) => new IFC2X3.IfcText(v),
  1460886941: (v) => new IFC2X3.IfcTextAlignment(v),
  3490877962: (v) => new IFC2X3.IfcTextDecoration(v),
  603696268: (v) => new IFC2X3.IfcTextFontName(v),
  296282323: (v) => new IFC2X3.IfcTextTransformation(v),
  232962298: (v) => new IFC2X3.IfcThermalAdmittanceMeasure(v),
  2645777649: (v) => new IFC2X3.IfcThermalConductivityMeasure(v),
  2281867870: (v) => new IFC2X3.IfcThermalExpansionCoefficientMeasure(v),
  857959152: (v) => new IFC2X3.IfcThermalResistanceMeasure(v),
  2016195849: (v) => new IFC2X3.IfcThermalTransmittanceMeasure(v),
  743184107: (v) => new IFC2X3.IfcThermodynamicTemperatureMeasure(v),
  2726807636: (v) => new IFC2X3.IfcTimeMeasure(v),
  2591213694: (v) => new IFC2X3.IfcTimeStamp(v),
  1278329552: (v) => new IFC2X3.IfcTorqueMeasure(v),
  3345633955: (v) => new IFC2X3.IfcVaporPermeabilityMeasure(v),
  3458127941: (v) => new IFC2X3.IfcVolumeMeasure(v),
  2593997549: (v) => new IFC2X3.IfcVolumetricFlowRateMeasure(v),
  51269191: (v) => new IFC2X3.IfcWarpingConstantMeasure(v),
  1718600412: (v) => new IFC2X3.IfcWarpingMomentMeasure(v),
  4065007721: (v) => new IFC2X3.IfcYearNumber(v)
};
var IFC2X3;
((IFC2X32) => {
  class IfcAbsorbedDoseMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCABSORBEDDOSEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcAbsorbedDoseMeasure = IfcAbsorbedDoseMeasure;
  class IfcAccelerationMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCACCELERATIONMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcAccelerationMeasure = IfcAccelerationMeasure;
  class IfcAmountOfSubstanceMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCAMOUNTOFSUBSTANCEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcAmountOfSubstanceMeasure = IfcAmountOfSubstanceMeasure;
  class IfcAngularVelocityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCANGULARVELOCITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcAngularVelocityMeasure = IfcAngularVelocityMeasure;
  class IfcAreaMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCAREAMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcAreaMeasure = IfcAreaMeasure;
  class IfcBoolean {
    constructor(v) {
      this.type = 3;
      this.name = "IFCBOOLEAN";
      this.value = v === null ? v : v == "T" ? true : false;
    }
  }
  IFC2X32.IfcBoolean = IfcBoolean;
  class IfcBoxAlignment {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCBOXALIGNMENT";
    }
  }
  IFC2X32.IfcBoxAlignment = IfcBoxAlignment;
  class IfcComplexNumber {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcComplexNumber = IfcComplexNumber;
  ;
  class IfcCompoundPlaneAngleMeasure {
    constructor(value) {
      this.value = value;
      this.type = 10;
    }
  }
  IFC2X32.IfcCompoundPlaneAngleMeasure = IfcCompoundPlaneAngleMeasure;
  ;
  class IfcContextDependentMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCCONTEXTDEPENDENTMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcContextDependentMeasure = IfcContextDependentMeasure;
  class IfcCountMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCCOUNTMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcCountMeasure = IfcCountMeasure;
  class IfcCurvatureMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCCURVATUREMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcCurvatureMeasure = IfcCurvatureMeasure;
  class IfcDayInMonthNumber {
    constructor(v) {
      this.type = 10;
      this.name = "IFCDAYINMONTHNUMBER";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcDayInMonthNumber = IfcDayInMonthNumber;
  class IfcDaylightSavingHour {
    constructor(v) {
      this.type = 10;
      this.name = "IFCDAYLIGHTSAVINGHOUR";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcDaylightSavingHour = IfcDaylightSavingHour;
  class IfcDescriptiveMeasure {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCDESCRIPTIVEMEASURE";
    }
  }
  IFC2X32.IfcDescriptiveMeasure = IfcDescriptiveMeasure;
  class IfcDimensionCount {
    constructor(v) {
      this.type = 10;
      this.name = "IFCDIMENSIONCOUNT";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcDimensionCount = IfcDimensionCount;
  class IfcDoseEquivalentMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCDOSEEQUIVALENTMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcDoseEquivalentMeasure = IfcDoseEquivalentMeasure;
  class IfcDynamicViscosityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCDYNAMICVISCOSITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcDynamicViscosityMeasure = IfcDynamicViscosityMeasure;
  class IfcElectricCapacitanceMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCELECTRICCAPACITANCEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcElectricCapacitanceMeasure = IfcElectricCapacitanceMeasure;
  class IfcElectricChargeMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCELECTRICCHARGEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcElectricChargeMeasure = IfcElectricChargeMeasure;
  class IfcElectricConductanceMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCELECTRICCONDUCTANCEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcElectricConductanceMeasure = IfcElectricConductanceMeasure;
  class IfcElectricCurrentMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCELECTRICCURRENTMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcElectricCurrentMeasure = IfcElectricCurrentMeasure;
  class IfcElectricResistanceMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCELECTRICRESISTANCEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcElectricResistanceMeasure = IfcElectricResistanceMeasure;
  class IfcElectricVoltageMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCELECTRICVOLTAGEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcElectricVoltageMeasure = IfcElectricVoltageMeasure;
  class IfcEnergyMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCENERGYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcEnergyMeasure = IfcEnergyMeasure;
  class IfcFontStyle {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCFONTSTYLE";
    }
  }
  IFC2X32.IfcFontStyle = IfcFontStyle;
  class IfcFontVariant {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCFONTVARIANT";
    }
  }
  IFC2X32.IfcFontVariant = IfcFontVariant;
  class IfcFontWeight {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCFONTWEIGHT";
    }
  }
  IFC2X32.IfcFontWeight = IfcFontWeight;
  class IfcForceMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCFORCEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcForceMeasure = IfcForceMeasure;
  class IfcFrequencyMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCFREQUENCYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcFrequencyMeasure = IfcFrequencyMeasure;
  class IfcGloballyUniqueId {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCGLOBALLYUNIQUEID";
    }
  }
  IFC2X32.IfcGloballyUniqueId = IfcGloballyUniqueId;
  class IfcHeatFluxDensityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCHEATFLUXDENSITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcHeatFluxDensityMeasure = IfcHeatFluxDensityMeasure;
  class IfcHeatingValueMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCHEATINGVALUEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcHeatingValueMeasure = IfcHeatingValueMeasure;
  class IfcHourInDay {
    constructor(v) {
      this.type = 10;
      this.name = "IFCHOURINDAY";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcHourInDay = IfcHourInDay;
  class IfcIdentifier {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCIDENTIFIER";
    }
  }
  IFC2X32.IfcIdentifier = IfcIdentifier;
  class IfcIlluminanceMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCILLUMINANCEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcIlluminanceMeasure = IfcIlluminanceMeasure;
  class IfcInductanceMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCINDUCTANCEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcInductanceMeasure = IfcInductanceMeasure;
  class IfcInteger {
    constructor(v) {
      this.type = 10;
      this.name = "IFCINTEGER";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcInteger = IfcInteger;
  class IfcIntegerCountRateMeasure {
    constructor(v) {
      this.type = 10;
      this.name = "IFCINTEGERCOUNTRATEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcIntegerCountRateMeasure = IfcIntegerCountRateMeasure;
  class IfcIonConcentrationMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCIONCONCENTRATIONMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcIonConcentrationMeasure = IfcIonConcentrationMeasure;
  class IfcIsothermalMoistureCapacityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCISOTHERMALMOISTURECAPACITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcIsothermalMoistureCapacityMeasure = IfcIsothermalMoistureCapacityMeasure;
  class IfcKinematicViscosityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCKINEMATICVISCOSITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcKinematicViscosityMeasure = IfcKinematicViscosityMeasure;
  class IfcLabel {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCLABEL";
    }
  }
  IFC2X32.IfcLabel = IfcLabel;
  class IfcLengthMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCLENGTHMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcLengthMeasure = IfcLengthMeasure;
  class IfcLinearForceMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCLINEARFORCEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcLinearForceMeasure = IfcLinearForceMeasure;
  class IfcLinearMomentMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCLINEARMOMENTMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcLinearMomentMeasure = IfcLinearMomentMeasure;
  class IfcLinearStiffnessMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCLINEARSTIFFNESSMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcLinearStiffnessMeasure = IfcLinearStiffnessMeasure;
  class IfcLinearVelocityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCLINEARVELOCITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcLinearVelocityMeasure = IfcLinearVelocityMeasure;
  class IfcLogical {
    constructor(v) {
      this.type = 3;
      this.name = "IFCLOGICAL";
      this.value = v === null ? v : v == "T" ? 1 /* TRUE */ : v == "F" ? 0 /* FALSE */ : 2 /* UNKNOWN */;
    }
  }
  IFC2X32.IfcLogical = IfcLogical;
  class IfcLuminousFluxMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCLUMINOUSFLUXMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcLuminousFluxMeasure = IfcLuminousFluxMeasure;
  class IfcLuminousIntensityDistributionMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCLUMINOUSINTENSITYDISTRIBUTIONMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcLuminousIntensityDistributionMeasure = IfcLuminousIntensityDistributionMeasure;
  class IfcLuminousIntensityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCLUMINOUSINTENSITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcLuminousIntensityMeasure = IfcLuminousIntensityMeasure;
  class IfcMagneticFluxDensityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMAGNETICFLUXDENSITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcMagneticFluxDensityMeasure = IfcMagneticFluxDensityMeasure;
  class IfcMagneticFluxMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMAGNETICFLUXMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcMagneticFluxMeasure = IfcMagneticFluxMeasure;
  class IfcMassDensityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMASSDENSITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcMassDensityMeasure = IfcMassDensityMeasure;
  class IfcMassFlowRateMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMASSFLOWRATEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcMassFlowRateMeasure = IfcMassFlowRateMeasure;
  class IfcMassMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMASSMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcMassMeasure = IfcMassMeasure;
  class IfcMassPerLengthMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMASSPERLENGTHMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcMassPerLengthMeasure = IfcMassPerLengthMeasure;
  class IfcMinuteInHour {
    constructor(v) {
      this.type = 10;
      this.name = "IFCMINUTEINHOUR";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcMinuteInHour = IfcMinuteInHour;
  class IfcModulusOfElasticityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMODULUSOFELASTICITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcModulusOfElasticityMeasure = IfcModulusOfElasticityMeasure;
  class IfcModulusOfLinearSubgradeReactionMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMODULUSOFLINEARSUBGRADEREACTIONMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcModulusOfLinearSubgradeReactionMeasure = IfcModulusOfLinearSubgradeReactionMeasure;
  class IfcModulusOfRotationalSubgradeReactionMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMODULUSOFROTATIONALSUBGRADEREACTIONMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcModulusOfRotationalSubgradeReactionMeasure = IfcModulusOfRotationalSubgradeReactionMeasure;
  class IfcModulusOfSubgradeReactionMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMODULUSOFSUBGRADEREACTIONMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcModulusOfSubgradeReactionMeasure = IfcModulusOfSubgradeReactionMeasure;
  class IfcMoistureDiffusivityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMOISTUREDIFFUSIVITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcMoistureDiffusivityMeasure = IfcMoistureDiffusivityMeasure;
  class IfcMolecularWeightMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMOLECULARWEIGHTMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcMolecularWeightMeasure = IfcMolecularWeightMeasure;
  class IfcMomentOfInertiaMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMOMENTOFINERTIAMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcMomentOfInertiaMeasure = IfcMomentOfInertiaMeasure;
  class IfcMonetaryMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMONETARYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcMonetaryMeasure = IfcMonetaryMeasure;
  class IfcMonthInYearNumber {
    constructor(v) {
      this.type = 10;
      this.name = "IFCMONTHINYEARNUMBER";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcMonthInYearNumber = IfcMonthInYearNumber;
  class IfcNormalisedRatioMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCNORMALISEDRATIOMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcNormalisedRatioMeasure = IfcNormalisedRatioMeasure;
  class IfcNumericMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCNUMERICMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcNumericMeasure = IfcNumericMeasure;
  class IfcPHMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCPHMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcPHMeasure = IfcPHMeasure;
  class IfcParameterValue {
    constructor(v) {
      this.type = 4;
      this.name = "IFCPARAMETERVALUE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcParameterValue = IfcParameterValue;
  class IfcPlanarForceMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCPLANARFORCEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcPlanarForceMeasure = IfcPlanarForceMeasure;
  class IfcPlaneAngleMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCPLANEANGLEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcPlaneAngleMeasure = IfcPlaneAngleMeasure;
  class IfcPositiveLengthMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCPOSITIVELENGTHMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcPositiveLengthMeasure = IfcPositiveLengthMeasure;
  class IfcPositivePlaneAngleMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCPOSITIVEPLANEANGLEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcPositivePlaneAngleMeasure = IfcPositivePlaneAngleMeasure;
  class IfcPositiveRatioMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCPOSITIVERATIOMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcPositiveRatioMeasure = IfcPositiveRatioMeasure;
  class IfcPowerMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCPOWERMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcPowerMeasure = IfcPowerMeasure;
  class IfcPresentableText {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCPRESENTABLETEXT";
    }
  }
  IFC2X32.IfcPresentableText = IfcPresentableText;
  class IfcPressureMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCPRESSUREMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcPressureMeasure = IfcPressureMeasure;
  class IfcRadioActivityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCRADIOACTIVITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcRadioActivityMeasure = IfcRadioActivityMeasure;
  class IfcRatioMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCRATIOMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcRatioMeasure = IfcRatioMeasure;
  class IfcReal {
    constructor(v) {
      this.type = 4;
      this.name = "IFCREAL";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcReal = IfcReal;
  class IfcRotationalFrequencyMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCROTATIONALFREQUENCYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcRotationalFrequencyMeasure = IfcRotationalFrequencyMeasure;
  class IfcRotationalMassMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCROTATIONALMASSMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcRotationalMassMeasure = IfcRotationalMassMeasure;
  class IfcRotationalStiffnessMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCROTATIONALSTIFFNESSMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcRotationalStiffnessMeasure = IfcRotationalStiffnessMeasure;
  class IfcSecondInMinute {
    constructor(v) {
      this.type = 4;
      this.name = "IFCSECONDINMINUTE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcSecondInMinute = IfcSecondInMinute;
  class IfcSectionModulusMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCSECTIONMODULUSMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcSectionModulusMeasure = IfcSectionModulusMeasure;
  class IfcSectionalAreaIntegralMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCSECTIONALAREAINTEGRALMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcSectionalAreaIntegralMeasure = IfcSectionalAreaIntegralMeasure;
  class IfcShearModulusMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCSHEARMODULUSMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcShearModulusMeasure = IfcShearModulusMeasure;
  class IfcSolidAngleMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCSOLIDANGLEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcSolidAngleMeasure = IfcSolidAngleMeasure;
  class IfcSoundPowerMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCSOUNDPOWERMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcSoundPowerMeasure = IfcSoundPowerMeasure;
  class IfcSoundPressureMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCSOUNDPRESSUREMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcSoundPressureMeasure = IfcSoundPressureMeasure;
  class IfcSpecificHeatCapacityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCSPECIFICHEATCAPACITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcSpecificHeatCapacityMeasure = IfcSpecificHeatCapacityMeasure;
  class IfcSpecularExponent {
    constructor(v) {
      this.type = 4;
      this.name = "IFCSPECULAREXPONENT";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcSpecularExponent = IfcSpecularExponent;
  class IfcSpecularRoughness {
    constructor(v) {
      this.type = 4;
      this.name = "IFCSPECULARROUGHNESS";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcSpecularRoughness = IfcSpecularRoughness;
  class IfcTemperatureGradientMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCTEMPERATUREGRADIENTMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcTemperatureGradientMeasure = IfcTemperatureGradientMeasure;
  class IfcText {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCTEXT";
    }
  }
  IFC2X32.IfcText = IfcText;
  class IfcTextAlignment {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCTEXTALIGNMENT";
    }
  }
  IFC2X32.IfcTextAlignment = IfcTextAlignment;
  class IfcTextDecoration {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCTEXTDECORATION";
    }
  }
  IFC2X32.IfcTextDecoration = IfcTextDecoration;
  class IfcTextFontName {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCTEXTFONTNAME";
    }
  }
  IFC2X32.IfcTextFontName = IfcTextFontName;
  class IfcTextTransformation {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCTEXTTRANSFORMATION";
    }
  }
  IFC2X32.IfcTextTransformation = IfcTextTransformation;
  class IfcThermalAdmittanceMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCTHERMALADMITTANCEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcThermalAdmittanceMeasure = IfcThermalAdmittanceMeasure;
  class IfcThermalConductivityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCTHERMALCONDUCTIVITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcThermalConductivityMeasure = IfcThermalConductivityMeasure;
  class IfcThermalExpansionCoefficientMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCTHERMALEXPANSIONCOEFFICIENTMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcThermalExpansionCoefficientMeasure = IfcThermalExpansionCoefficientMeasure;
  class IfcThermalResistanceMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCTHERMALRESISTANCEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcThermalResistanceMeasure = IfcThermalResistanceMeasure;
  class IfcThermalTransmittanceMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCTHERMALTRANSMITTANCEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcThermalTransmittanceMeasure = IfcThermalTransmittanceMeasure;
  class IfcThermodynamicTemperatureMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCTHERMODYNAMICTEMPERATUREMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcThermodynamicTemperatureMeasure = IfcThermodynamicTemperatureMeasure;
  class IfcTimeMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCTIMEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcTimeMeasure = IfcTimeMeasure;
  class IfcTimeStamp {
    constructor(v) {
      this.type = 10;
      this.name = "IFCTIMESTAMP";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcTimeStamp = IfcTimeStamp;
  class IfcTorqueMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCTORQUEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcTorqueMeasure = IfcTorqueMeasure;
  class IfcVaporPermeabilityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCVAPORPERMEABILITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcVaporPermeabilityMeasure = IfcVaporPermeabilityMeasure;
  class IfcVolumeMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCVOLUMEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcVolumeMeasure = IfcVolumeMeasure;
  class IfcVolumetricFlowRateMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCVOLUMETRICFLOWRATEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcVolumetricFlowRateMeasure = IfcVolumetricFlowRateMeasure;
  class IfcWarpingConstantMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCWARPINGCONSTANTMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcWarpingConstantMeasure = IfcWarpingConstantMeasure;
  class IfcWarpingMomentMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCWARPINGMOMENTMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcWarpingMomentMeasure = IfcWarpingMomentMeasure;
  class IfcYearNumber {
    constructor(v) {
      this.type = 10;
      this.name = "IFCYEARNUMBER";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC2X32.IfcYearNumber = IfcYearNumber;
  class IfcActionSourceTypeEnum {
    static {
      this.DEAD_LOAD_G = { type: 3, value: "DEAD_LOAD_G" };
    }
    static {
      this.COMPLETION_G1 = { type: 3, value: "COMPLETION_G1" };
    }
    static {
      this.LIVE_LOAD_Q = { type: 3, value: "LIVE_LOAD_Q" };
    }
    static {
      this.SNOW_S = { type: 3, value: "SNOW_S" };
    }
    static {
      this.WIND_W = { type: 3, value: "WIND_W" };
    }
    static {
      this.PRESTRESSING_P = { type: 3, value: "PRESTRESSING_P" };
    }
    static {
      this.SETTLEMENT_U = { type: 3, value: "SETTLEMENT_U" };
    }
    static {
      this.TEMPERATURE_T = { type: 3, value: "TEMPERATURE_T" };
    }
    static {
      this.EARTHQUAKE_E = { type: 3, value: "EARTHQUAKE_E" };
    }
    static {
      this.FIRE = { type: 3, value: "FIRE" };
    }
    static {
      this.IMPULSE = { type: 3, value: "IMPULSE" };
    }
    static {
      this.IMPACT = { type: 3, value: "IMPACT" };
    }
    static {
      this.TRANSPORT = { type: 3, value: "TRANSPORT" };
    }
    static {
      this.ERECTION = { type: 3, value: "ERECTION" };
    }
    static {
      this.PROPPING = { type: 3, value: "PROPPING" };
    }
    static {
      this.SYSTEM_IMPERFECTION = { type: 3, value: "SYSTEM_IMPERFECTION" };
    }
    static {
      this.SHRINKAGE = { type: 3, value: "SHRINKAGE" };
    }
    static {
      this.CREEP = { type: 3, value: "CREEP" };
    }
    static {
      this.LACK_OF_FIT = { type: 3, value: "LACK_OF_FIT" };
    }
    static {
      this.BUOYANCY = { type: 3, value: "BUOYANCY" };
    }
    static {
      this.ICE = { type: 3, value: "ICE" };
    }
    static {
      this.CURRENT = { type: 3, value: "CURRENT" };
    }
    static {
      this.WAVE = { type: 3, value: "WAVE" };
    }
    static {
      this.RAIN = { type: 3, value: "RAIN" };
    }
    static {
      this.BRAKES = { type: 3, value: "BRAKES" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcActionSourceTypeEnum = IfcActionSourceTypeEnum;
  class IfcActionTypeEnum {
    static {
      this.PERMANENT_G = { type: 3, value: "PERMANENT_G" };
    }
    static {
      this.VARIABLE_Q = { type: 3, value: "VARIABLE_Q" };
    }
    static {
      this.EXTRAORDINARY_A = { type: 3, value: "EXTRAORDINARY_A" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcActionTypeEnum = IfcActionTypeEnum;
  class IfcActuatorTypeEnum {
    static {
      this.ELECTRICACTUATOR = { type: 3, value: "ELECTRICACTUATOR" };
    }
    static {
      this.HANDOPERATEDACTUATOR = { type: 3, value: "HANDOPERATEDACTUATOR" };
    }
    static {
      this.HYDRAULICACTUATOR = { type: 3, value: "HYDRAULICACTUATOR" };
    }
    static {
      this.PNEUMATICACTUATOR = { type: 3, value: "PNEUMATICACTUATOR" };
    }
    static {
      this.THERMOSTATICACTUATOR = { type: 3, value: "THERMOSTATICACTUATOR" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcActuatorTypeEnum = IfcActuatorTypeEnum;
  class IfcAddressTypeEnum {
    static {
      this.OFFICE = { type: 3, value: "OFFICE" };
    }
    static {
      this.SITE = { type: 3, value: "SITE" };
    }
    static {
      this.HOME = { type: 3, value: "HOME" };
    }
    static {
      this.DISTRIBUTIONPOINT = { type: 3, value: "DISTRIBUTIONPOINT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
  }
  IFC2X32.IfcAddressTypeEnum = IfcAddressTypeEnum;
  class IfcAheadOrBehind {
    static {
      this.AHEAD = { type: 3, value: "AHEAD" };
    }
    static {
      this.BEHIND = { type: 3, value: "BEHIND" };
    }
  }
  IFC2X32.IfcAheadOrBehind = IfcAheadOrBehind;
  class IfcAirTerminalBoxTypeEnum {
    static {
      this.CONSTANTFLOW = { type: 3, value: "CONSTANTFLOW" };
    }
    static {
      this.VARIABLEFLOWPRESSUREDEPENDANT = { type: 3, value: "VARIABLEFLOWPRESSUREDEPENDANT" };
    }
    static {
      this.VARIABLEFLOWPRESSUREINDEPENDANT = { type: 3, value: "VARIABLEFLOWPRESSUREINDEPENDANT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcAirTerminalBoxTypeEnum = IfcAirTerminalBoxTypeEnum;
  class IfcAirTerminalTypeEnum {
    static {
      this.GRILLE = { type: 3, value: "GRILLE" };
    }
    static {
      this.REGISTER = { type: 3, value: "REGISTER" };
    }
    static {
      this.DIFFUSER = { type: 3, value: "DIFFUSER" };
    }
    static {
      this.EYEBALL = { type: 3, value: "EYEBALL" };
    }
    static {
      this.IRIS = { type: 3, value: "IRIS" };
    }
    static {
      this.LINEARGRILLE = { type: 3, value: "LINEARGRILLE" };
    }
    static {
      this.LINEARDIFFUSER = { type: 3, value: "LINEARDIFFUSER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcAirTerminalTypeEnum = IfcAirTerminalTypeEnum;
  class IfcAirToAirHeatRecoveryTypeEnum {
    static {
      this.FIXEDPLATECOUNTERFLOWEXCHANGER = { type: 3, value: "FIXEDPLATECOUNTERFLOWEXCHANGER" };
    }
    static {
      this.FIXEDPLATECROSSFLOWEXCHANGER = { type: 3, value: "FIXEDPLATECROSSFLOWEXCHANGER" };
    }
    static {
      this.FIXEDPLATEPARALLELFLOWEXCHANGER = { type: 3, value: "FIXEDPLATEPARALLELFLOWEXCHANGER" };
    }
    static {
      this.ROTARYWHEEL = { type: 3, value: "ROTARYWHEEL" };
    }
    static {
      this.RUNAROUNDCOILLOOP = { type: 3, value: "RUNAROUNDCOILLOOP" };
    }
    static {
      this.HEATPIPE = { type: 3, value: "HEATPIPE" };
    }
    static {
      this.TWINTOWERENTHALPYRECOVERYLOOPS = { type: 3, value: "TWINTOWERENTHALPYRECOVERYLOOPS" };
    }
    static {
      this.THERMOSIPHONSEALEDTUBEHEATEXCHANGERS = { type: 3, value: "THERMOSIPHONSEALEDTUBEHEATEXCHANGERS" };
    }
    static {
      this.THERMOSIPHONCOILTYPEHEATEXCHANGERS = { type: 3, value: "THERMOSIPHONCOILTYPEHEATEXCHANGERS" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcAirToAirHeatRecoveryTypeEnum = IfcAirToAirHeatRecoveryTypeEnum;
  class IfcAlarmTypeEnum {
    static {
      this.BELL = { type: 3, value: "BELL" };
    }
    static {
      this.BREAKGLASSBUTTON = { type: 3, value: "BREAKGLASSBUTTON" };
    }
    static {
      this.LIGHT = { type: 3, value: "LIGHT" };
    }
    static {
      this.MANUALPULLBOX = { type: 3, value: "MANUALPULLBOX" };
    }
    static {
      this.SIREN = { type: 3, value: "SIREN" };
    }
    static {
      this.WHISTLE = { type: 3, value: "WHISTLE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcAlarmTypeEnum = IfcAlarmTypeEnum;
  class IfcAnalysisModelTypeEnum {
    static {
      this.IN_PLANE_LOADING_2D = { type: 3, value: "IN_PLANE_LOADING_2D" };
    }
    static {
      this.OUT_PLANE_LOADING_2D = { type: 3, value: "OUT_PLANE_LOADING_2D" };
    }
    static {
      this.LOADING_3D = { type: 3, value: "LOADING_3D" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcAnalysisModelTypeEnum = IfcAnalysisModelTypeEnum;
  class IfcAnalysisTheoryTypeEnum {
    static {
      this.FIRST_ORDER_THEORY = { type: 3, value: "FIRST_ORDER_THEORY" };
    }
    static {
      this.SECOND_ORDER_THEORY = { type: 3, value: "SECOND_ORDER_THEORY" };
    }
    static {
      this.THIRD_ORDER_THEORY = { type: 3, value: "THIRD_ORDER_THEORY" };
    }
    static {
      this.FULL_NONLINEAR_THEORY = { type: 3, value: "FULL_NONLINEAR_THEORY" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcAnalysisTheoryTypeEnum = IfcAnalysisTheoryTypeEnum;
  class IfcArithmeticOperatorEnum {
    static {
      this.ADD = { type: 3, value: "ADD" };
    }
    static {
      this.DIVIDE = { type: 3, value: "DIVIDE" };
    }
    static {
      this.MULTIPLY = { type: 3, value: "MULTIPLY" };
    }
    static {
      this.SUBTRACT = { type: 3, value: "SUBTRACT" };
    }
  }
  IFC2X32.IfcArithmeticOperatorEnum = IfcArithmeticOperatorEnum;
  class IfcAssemblyPlaceEnum {
    static {
      this.SITE = { type: 3, value: "SITE" };
    }
    static {
      this.FACTORY = { type: 3, value: "FACTORY" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcAssemblyPlaceEnum = IfcAssemblyPlaceEnum;
  class IfcBSplineCurveForm {
    static {
      this.POLYLINE_FORM = { type: 3, value: "POLYLINE_FORM" };
    }
    static {
      this.CIRCULAR_ARC = { type: 3, value: "CIRCULAR_ARC" };
    }
    static {
      this.ELLIPTIC_ARC = { type: 3, value: "ELLIPTIC_ARC" };
    }
    static {
      this.PARABOLIC_ARC = { type: 3, value: "PARABOLIC_ARC" };
    }
    static {
      this.HYPERBOLIC_ARC = { type: 3, value: "HYPERBOLIC_ARC" };
    }
    static {
      this.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" };
    }
  }
  IFC2X32.IfcBSplineCurveForm = IfcBSplineCurveForm;
  class IfcBeamTypeEnum {
    static {
      this.BEAM = { type: 3, value: "BEAM" };
    }
    static {
      this.JOIST = { type: 3, value: "JOIST" };
    }
    static {
      this.LINTEL = { type: 3, value: "LINTEL" };
    }
    static {
      this.T_BEAM = { type: 3, value: "T_BEAM" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcBeamTypeEnum = IfcBeamTypeEnum;
  class IfcBenchmarkEnum {
    static {
      this.GREATERTHAN = { type: 3, value: "GREATERTHAN" };
    }
    static {
      this.GREATERTHANOREQUALTO = { type: 3, value: "GREATERTHANOREQUALTO" };
    }
    static {
      this.LESSTHAN = { type: 3, value: "LESSTHAN" };
    }
    static {
      this.LESSTHANOREQUALTO = { type: 3, value: "LESSTHANOREQUALTO" };
    }
    static {
      this.EQUALTO = { type: 3, value: "EQUALTO" };
    }
    static {
      this.NOTEQUALTO = { type: 3, value: "NOTEQUALTO" };
    }
  }
  IFC2X32.IfcBenchmarkEnum = IfcBenchmarkEnum;
  class IfcBoilerTypeEnum {
    static {
      this.WATER = { type: 3, value: "WATER" };
    }
    static {
      this.STEAM = { type: 3, value: "STEAM" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcBoilerTypeEnum = IfcBoilerTypeEnum;
  class IfcBooleanOperator {
    static {
      this.UNION = { type: 3, value: "UNION" };
    }
    static {
      this.INTERSECTION = { type: 3, value: "INTERSECTION" };
    }
    static {
      this.DIFFERENCE = { type: 3, value: "DIFFERENCE" };
    }
  }
  IFC2X32.IfcBooleanOperator = IfcBooleanOperator;
  class IfcBuildingElementProxyTypeEnum {
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcBuildingElementProxyTypeEnum = IfcBuildingElementProxyTypeEnum;
  class IfcCableCarrierFittingTypeEnum {
    static {
      this.BEND = { type: 3, value: "BEND" };
    }
    static {
      this.CROSS = { type: 3, value: "CROSS" };
    }
    static {
      this.REDUCER = { type: 3, value: "REDUCER" };
    }
    static {
      this.TEE = { type: 3, value: "TEE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcCableCarrierFittingTypeEnum = IfcCableCarrierFittingTypeEnum;
  class IfcCableCarrierSegmentTypeEnum {
    static {
      this.CABLELADDERSEGMENT = { type: 3, value: "CABLELADDERSEGMENT" };
    }
    static {
      this.CABLETRAYSEGMENT = { type: 3, value: "CABLETRAYSEGMENT" };
    }
    static {
      this.CABLETRUNKINGSEGMENT = { type: 3, value: "CABLETRUNKINGSEGMENT" };
    }
    static {
      this.CONDUITSEGMENT = { type: 3, value: "CONDUITSEGMENT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcCableCarrierSegmentTypeEnum = IfcCableCarrierSegmentTypeEnum;
  class IfcCableSegmentTypeEnum {
    static {
      this.CABLESEGMENT = { type: 3, value: "CABLESEGMENT" };
    }
    static {
      this.CONDUCTORSEGMENT = { type: 3, value: "CONDUCTORSEGMENT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcCableSegmentTypeEnum = IfcCableSegmentTypeEnum;
  class IfcChangeActionEnum {
    static {
      this.NOCHANGE = { type: 3, value: "NOCHANGE" };
    }
    static {
      this.MODIFIED = { type: 3, value: "MODIFIED" };
    }
    static {
      this.ADDED = { type: 3, value: "ADDED" };
    }
    static {
      this.DELETED = { type: 3, value: "DELETED" };
    }
    static {
      this.MODIFIEDADDED = { type: 3, value: "MODIFIEDADDED" };
    }
    static {
      this.MODIFIEDDELETED = { type: 3, value: "MODIFIEDDELETED" };
    }
  }
  IFC2X32.IfcChangeActionEnum = IfcChangeActionEnum;
  class IfcChillerTypeEnum {
    static {
      this.AIRCOOLED = { type: 3, value: "AIRCOOLED" };
    }
    static {
      this.WATERCOOLED = { type: 3, value: "WATERCOOLED" };
    }
    static {
      this.HEATRECOVERY = { type: 3, value: "HEATRECOVERY" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcChillerTypeEnum = IfcChillerTypeEnum;
  class IfcCoilTypeEnum {
    static {
      this.DXCOOLINGCOIL = { type: 3, value: "DXCOOLINGCOIL" };
    }
    static {
      this.WATERCOOLINGCOIL = { type: 3, value: "WATERCOOLINGCOIL" };
    }
    static {
      this.STEAMHEATINGCOIL = { type: 3, value: "STEAMHEATINGCOIL" };
    }
    static {
      this.WATERHEATINGCOIL = { type: 3, value: "WATERHEATINGCOIL" };
    }
    static {
      this.ELECTRICHEATINGCOIL = { type: 3, value: "ELECTRICHEATINGCOIL" };
    }
    static {
      this.GASHEATINGCOIL = { type: 3, value: "GASHEATINGCOIL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcCoilTypeEnum = IfcCoilTypeEnum;
  class IfcColumnTypeEnum {
    static {
      this.COLUMN = { type: 3, value: "COLUMN" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcColumnTypeEnum = IfcColumnTypeEnum;
  class IfcCompressorTypeEnum {
    static {
      this.DYNAMIC = { type: 3, value: "DYNAMIC" };
    }
    static {
      this.RECIPROCATING = { type: 3, value: "RECIPROCATING" };
    }
    static {
      this.ROTARY = { type: 3, value: "ROTARY" };
    }
    static {
      this.SCROLL = { type: 3, value: "SCROLL" };
    }
    static {
      this.TROCHOIDAL = { type: 3, value: "TROCHOIDAL" };
    }
    static {
      this.SINGLESTAGE = { type: 3, value: "SINGLESTAGE" };
    }
    static {
      this.BOOSTER = { type: 3, value: "BOOSTER" };
    }
    static {
      this.OPENTYPE = { type: 3, value: "OPENTYPE" };
    }
    static {
      this.HERMETIC = { type: 3, value: "HERMETIC" };
    }
    static {
      this.SEMIHERMETIC = { type: 3, value: "SEMIHERMETIC" };
    }
    static {
      this.WELDEDSHELLHERMETIC = { type: 3, value: "WELDEDSHELLHERMETIC" };
    }
    static {
      this.ROLLINGPISTON = { type: 3, value: "ROLLINGPISTON" };
    }
    static {
      this.ROTARYVANE = { type: 3, value: "ROTARYVANE" };
    }
    static {
      this.SINGLESCREW = { type: 3, value: "SINGLESCREW" };
    }
    static {
      this.TWINSCREW = { type: 3, value: "TWINSCREW" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcCompressorTypeEnum = IfcCompressorTypeEnum;
  class IfcCondenserTypeEnum {
    static {
      this.WATERCOOLEDSHELLTUBE = { type: 3, value: "WATERCOOLEDSHELLTUBE" };
    }
    static {
      this.WATERCOOLEDSHELLCOIL = { type: 3, value: "WATERCOOLEDSHELLCOIL" };
    }
    static {
      this.WATERCOOLEDTUBEINTUBE = { type: 3, value: "WATERCOOLEDTUBEINTUBE" };
    }
    static {
      this.WATERCOOLEDBRAZEDPLATE = { type: 3, value: "WATERCOOLEDBRAZEDPLATE" };
    }
    static {
      this.AIRCOOLED = { type: 3, value: "AIRCOOLED" };
    }
    static {
      this.EVAPORATIVECOOLED = { type: 3, value: "EVAPORATIVECOOLED" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcCondenserTypeEnum = IfcCondenserTypeEnum;
  class IfcConnectionTypeEnum {
    static {
      this.ATPATH = { type: 3, value: "ATPATH" };
    }
    static {
      this.ATSTART = { type: 3, value: "ATSTART" };
    }
    static {
      this.ATEND = { type: 3, value: "ATEND" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcConnectionTypeEnum = IfcConnectionTypeEnum;
  class IfcConstraintEnum {
    static {
      this.HARD = { type: 3, value: "HARD" };
    }
    static {
      this.SOFT = { type: 3, value: "SOFT" };
    }
    static {
      this.ADVISORY = { type: 3, value: "ADVISORY" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcConstraintEnum = IfcConstraintEnum;
  class IfcControllerTypeEnum {
    static {
      this.FLOATING = { type: 3, value: "FLOATING" };
    }
    static {
      this.PROPORTIONAL = { type: 3, value: "PROPORTIONAL" };
    }
    static {
      this.PROPORTIONALINTEGRAL = { type: 3, value: "PROPORTIONALINTEGRAL" };
    }
    static {
      this.PROPORTIONALINTEGRALDERIVATIVE = { type: 3, value: "PROPORTIONALINTEGRALDERIVATIVE" };
    }
    static {
      this.TIMEDTWOPOSITION = { type: 3, value: "TIMEDTWOPOSITION" };
    }
    static {
      this.TWOPOSITION = { type: 3, value: "TWOPOSITION" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcControllerTypeEnum = IfcControllerTypeEnum;
  class IfcCooledBeamTypeEnum {
    static {
      this.ACTIVE = { type: 3, value: "ACTIVE" };
    }
    static {
      this.PASSIVE = { type: 3, value: "PASSIVE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcCooledBeamTypeEnum = IfcCooledBeamTypeEnum;
  class IfcCoolingTowerTypeEnum {
    static {
      this.NATURALDRAFT = { type: 3, value: "NATURALDRAFT" };
    }
    static {
      this.MECHANICALINDUCEDDRAFT = { type: 3, value: "MECHANICALINDUCEDDRAFT" };
    }
    static {
      this.MECHANICALFORCEDDRAFT = { type: 3, value: "MECHANICALFORCEDDRAFT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcCoolingTowerTypeEnum = IfcCoolingTowerTypeEnum;
  class IfcCostScheduleTypeEnum {
    static {
      this.BUDGET = { type: 3, value: "BUDGET" };
    }
    static {
      this.COSTPLAN = { type: 3, value: "COSTPLAN" };
    }
    static {
      this.ESTIMATE = { type: 3, value: "ESTIMATE" };
    }
    static {
      this.TENDER = { type: 3, value: "TENDER" };
    }
    static {
      this.PRICEDBILLOFQUANTITIES = { type: 3, value: "PRICEDBILLOFQUANTITIES" };
    }
    static {
      this.UNPRICEDBILLOFQUANTITIES = { type: 3, value: "UNPRICEDBILLOFQUANTITIES" };
    }
    static {
      this.SCHEDULEOFRATES = { type: 3, value: "SCHEDULEOFRATES" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcCostScheduleTypeEnum = IfcCostScheduleTypeEnum;
  class IfcCoveringTypeEnum {
    static {
      this.CEILING = { type: 3, value: "CEILING" };
    }
    static {
      this.FLOORING = { type: 3, value: "FLOORING" };
    }
    static {
      this.CLADDING = { type: 3, value: "CLADDING" };
    }
    static {
      this.ROOFING = { type: 3, value: "ROOFING" };
    }
    static {
      this.INSULATION = { type: 3, value: "INSULATION" };
    }
    static {
      this.MEMBRANE = { type: 3, value: "MEMBRANE" };
    }
    static {
      this.SLEEVING = { type: 3, value: "SLEEVING" };
    }
    static {
      this.WRAPPING = { type: 3, value: "WRAPPING" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcCoveringTypeEnum = IfcCoveringTypeEnum;
  class IfcCurrencyEnum {
    static {
      this.AED = { type: 3, value: "AED" };
    }
    static {
      this.AES = { type: 3, value: "AES" };
    }
    static {
      this.ATS = { type: 3, value: "ATS" };
    }
    static {
      this.AUD = { type: 3, value: "AUD" };
    }
    static {
      this.BBD = { type: 3, value: "BBD" };
    }
    static {
      this.BEG = { type: 3, value: "BEG" };
    }
    static {
      this.BGL = { type: 3, value: "BGL" };
    }
    static {
      this.BHD = { type: 3, value: "BHD" };
    }
    static {
      this.BMD = { type: 3, value: "BMD" };
    }
    static {
      this.BND = { type: 3, value: "BND" };
    }
    static {
      this.BRL = { type: 3, value: "BRL" };
    }
    static {
      this.BSD = { type: 3, value: "BSD" };
    }
    static {
      this.BWP = { type: 3, value: "BWP" };
    }
    static {
      this.BZD = { type: 3, value: "BZD" };
    }
    static {
      this.CAD = { type: 3, value: "CAD" };
    }
    static {
      this.CBD = { type: 3, value: "CBD" };
    }
    static {
      this.CHF = { type: 3, value: "CHF" };
    }
    static {
      this.CLP = { type: 3, value: "CLP" };
    }
    static {
      this.CNY = { type: 3, value: "CNY" };
    }
    static {
      this.CYS = { type: 3, value: "CYS" };
    }
    static {
      this.CZK = { type: 3, value: "CZK" };
    }
    static {
      this.DDP = { type: 3, value: "DDP" };
    }
    static {
      this.DEM = { type: 3, value: "DEM" };
    }
    static {
      this.DKK = { type: 3, value: "DKK" };
    }
    static {
      this.EGL = { type: 3, value: "EGL" };
    }
    static {
      this.EST = { type: 3, value: "EST" };
    }
    static {
      this.EUR = { type: 3, value: "EUR" };
    }
    static {
      this.FAK = { type: 3, value: "FAK" };
    }
    static {
      this.FIM = { type: 3, value: "FIM" };
    }
    static {
      this.FJD = { type: 3, value: "FJD" };
    }
    static {
      this.FKP = { type: 3, value: "FKP" };
    }
    static {
      this.FRF = { type: 3, value: "FRF" };
    }
    static {
      this.GBP = { type: 3, value: "GBP" };
    }
    static {
      this.GIP = { type: 3, value: "GIP" };
    }
    static {
      this.GMD = { type: 3, value: "GMD" };
    }
    static {
      this.GRX = { type: 3, value: "GRX" };
    }
    static {
      this.HKD = { type: 3, value: "HKD" };
    }
    static {
      this.HUF = { type: 3, value: "HUF" };
    }
    static {
      this.ICK = { type: 3, value: "ICK" };
    }
    static {
      this.IDR = { type: 3, value: "IDR" };
    }
    static {
      this.ILS = { type: 3, value: "ILS" };
    }
    static {
      this.INR = { type: 3, value: "INR" };
    }
    static {
      this.IRP = { type: 3, value: "IRP" };
    }
    static {
      this.ITL = { type: 3, value: "ITL" };
    }
    static {
      this.JMD = { type: 3, value: "JMD" };
    }
    static {
      this.JOD = { type: 3, value: "JOD" };
    }
    static {
      this.JPY = { type: 3, value: "JPY" };
    }
    static {
      this.KES = { type: 3, value: "KES" };
    }
    static {
      this.KRW = { type: 3, value: "KRW" };
    }
    static {
      this.KWD = { type: 3, value: "KWD" };
    }
    static {
      this.KYD = { type: 3, value: "KYD" };
    }
    static {
      this.LKR = { type: 3, value: "LKR" };
    }
    static {
      this.LUF = { type: 3, value: "LUF" };
    }
    static {
      this.MTL = { type: 3, value: "MTL" };
    }
    static {
      this.MUR = { type: 3, value: "MUR" };
    }
    static {
      this.MXN = { type: 3, value: "MXN" };
    }
    static {
      this.MYR = { type: 3, value: "MYR" };
    }
    static {
      this.NLG = { type: 3, value: "NLG" };
    }
    static {
      this.NZD = { type: 3, value: "NZD" };
    }
    static {
      this.OMR = { type: 3, value: "OMR" };
    }
    static {
      this.PGK = { type: 3, value: "PGK" };
    }
    static {
      this.PHP = { type: 3, value: "PHP" };
    }
    static {
      this.PKR = { type: 3, value: "PKR" };
    }
    static {
      this.PLN = { type: 3, value: "PLN" };
    }
    static {
      this.PTN = { type: 3, value: "PTN" };
    }
    static {
      this.QAR = { type: 3, value: "QAR" };
    }
    static {
      this.RUR = { type: 3, value: "RUR" };
    }
    static {
      this.SAR = { type: 3, value: "SAR" };
    }
    static {
      this.SCR = { type: 3, value: "SCR" };
    }
    static {
      this.SEK = { type: 3, value: "SEK" };
    }
    static {
      this.SGD = { type: 3, value: "SGD" };
    }
    static {
      this.SKP = { type: 3, value: "SKP" };
    }
    static {
      this.THB = { type: 3, value: "THB" };
    }
    static {
      this.TRL = { type: 3, value: "TRL" };
    }
    static {
      this.TTD = { type: 3, value: "TTD" };
    }
    static {
      this.TWD = { type: 3, value: "TWD" };
    }
    static {
      this.USD = { type: 3, value: "USD" };
    }
    static {
      this.VEB = { type: 3, value: "VEB" };
    }
    static {
      this.VND = { type: 3, value: "VND" };
    }
    static {
      this.XEU = { type: 3, value: "XEU" };
    }
    static {
      this.ZAR = { type: 3, value: "ZAR" };
    }
    static {
      this.ZWD = { type: 3, value: "ZWD" };
    }
    static {
      this.NOK = { type: 3, value: "NOK" };
    }
  }
  IFC2X32.IfcCurrencyEnum = IfcCurrencyEnum;
  class IfcCurtainWallTypeEnum {
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcCurtainWallTypeEnum = IfcCurtainWallTypeEnum;
  class IfcDamperTypeEnum {
    static {
      this.CONTROLDAMPER = { type: 3, value: "CONTROLDAMPER" };
    }
    static {
      this.FIREDAMPER = { type: 3, value: "FIREDAMPER" };
    }
    static {
      this.SMOKEDAMPER = { type: 3, value: "SMOKEDAMPER" };
    }
    static {
      this.FIRESMOKEDAMPER = { type: 3, value: "FIRESMOKEDAMPER" };
    }
    static {
      this.BACKDRAFTDAMPER = { type: 3, value: "BACKDRAFTDAMPER" };
    }
    static {
      this.RELIEFDAMPER = { type: 3, value: "RELIEFDAMPER" };
    }
    static {
      this.BLASTDAMPER = { type: 3, value: "BLASTDAMPER" };
    }
    static {
      this.GRAVITYDAMPER = { type: 3, value: "GRAVITYDAMPER" };
    }
    static {
      this.GRAVITYRELIEFDAMPER = { type: 3, value: "GRAVITYRELIEFDAMPER" };
    }
    static {
      this.BALANCINGDAMPER = { type: 3, value: "BALANCINGDAMPER" };
    }
    static {
      this.FUMEHOODEXHAUST = { type: 3, value: "FUMEHOODEXHAUST" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcDamperTypeEnum = IfcDamperTypeEnum;
  class IfcDataOriginEnum {
    static {
      this.MEASURED = { type: 3, value: "MEASURED" };
    }
    static {
      this.PREDICTED = { type: 3, value: "PREDICTED" };
    }
    static {
      this.SIMULATED = { type: 3, value: "SIMULATED" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcDataOriginEnum = IfcDataOriginEnum;
  class IfcDerivedUnitEnum {
    static {
      this.ANGULARVELOCITYUNIT = { type: 3, value: "ANGULARVELOCITYUNIT" };
    }
    static {
      this.COMPOUNDPLANEANGLEUNIT = { type: 3, value: "COMPOUNDPLANEANGLEUNIT" };
    }
    static {
      this.DYNAMICVISCOSITYUNIT = { type: 3, value: "DYNAMICVISCOSITYUNIT" };
    }
    static {
      this.HEATFLUXDENSITYUNIT = { type: 3, value: "HEATFLUXDENSITYUNIT" };
    }
    static {
      this.INTEGERCOUNTRATEUNIT = { type: 3, value: "INTEGERCOUNTRATEUNIT" };
    }
    static {
      this.ISOTHERMALMOISTURECAPACITYUNIT = { type: 3, value: "ISOTHERMALMOISTURECAPACITYUNIT" };
    }
    static {
      this.KINEMATICVISCOSITYUNIT = { type: 3, value: "KINEMATICVISCOSITYUNIT" };
    }
    static {
      this.LINEARVELOCITYUNIT = { type: 3, value: "LINEARVELOCITYUNIT" };
    }
    static {
      this.MASSDENSITYUNIT = { type: 3, value: "MASSDENSITYUNIT" };
    }
    static {
      this.MASSFLOWRATEUNIT = { type: 3, value: "MASSFLOWRATEUNIT" };
    }
    static {
      this.MOISTUREDIFFUSIVITYUNIT = { type: 3, value: "MOISTUREDIFFUSIVITYUNIT" };
    }
    static {
      this.MOLECULARWEIGHTUNIT = { type: 3, value: "MOLECULARWEIGHTUNIT" };
    }
    static {
      this.SPECIFICHEATCAPACITYUNIT = { type: 3, value: "SPECIFICHEATCAPACITYUNIT" };
    }
    static {
      this.THERMALADMITTANCEUNIT = { type: 3, value: "THERMALADMITTANCEUNIT" };
    }
    static {
      this.THERMALCONDUCTANCEUNIT = { type: 3, value: "THERMALCONDUCTANCEUNIT" };
    }
    static {
      this.THERMALRESISTANCEUNIT = { type: 3, value: "THERMALRESISTANCEUNIT" };
    }
    static {
      this.THERMALTRANSMITTANCEUNIT = { type: 3, value: "THERMALTRANSMITTANCEUNIT" };
    }
    static {
      this.VAPORPERMEABILITYUNIT = { type: 3, value: "VAPORPERMEABILITYUNIT" };
    }
    static {
      this.VOLUMETRICFLOWRATEUNIT = { type: 3, value: "VOLUMETRICFLOWRATEUNIT" };
    }
    static {
      this.ROTATIONALFREQUENCYUNIT = { type: 3, value: "ROTATIONALFREQUENCYUNIT" };
    }
    static {
      this.TORQUEUNIT = { type: 3, value: "TORQUEUNIT" };
    }
    static {
      this.MOMENTOFINERTIAUNIT = { type: 3, value: "MOMENTOFINERTIAUNIT" };
    }
    static {
      this.LINEARMOMENTUNIT = { type: 3, value: "LINEARMOMENTUNIT" };
    }
    static {
      this.LINEARFORCEUNIT = { type: 3, value: "LINEARFORCEUNIT" };
    }
    static {
      this.PLANARFORCEUNIT = { type: 3, value: "PLANARFORCEUNIT" };
    }
    static {
      this.MODULUSOFELASTICITYUNIT = { type: 3, value: "MODULUSOFELASTICITYUNIT" };
    }
    static {
      this.SHEARMODULUSUNIT = { type: 3, value: "SHEARMODULUSUNIT" };
    }
    static {
      this.LINEARSTIFFNESSUNIT = { type: 3, value: "LINEARSTIFFNESSUNIT" };
    }
    static {
      this.ROTATIONALSTIFFNESSUNIT = { type: 3, value: "ROTATIONALSTIFFNESSUNIT" };
    }
    static {
      this.MODULUSOFSUBGRADEREACTIONUNIT = { type: 3, value: "MODULUSOFSUBGRADEREACTIONUNIT" };
    }
    static {
      this.ACCELERATIONUNIT = { type: 3, value: "ACCELERATIONUNIT" };
    }
    static {
      this.CURVATUREUNIT = { type: 3, value: "CURVATUREUNIT" };
    }
    static {
      this.HEATINGVALUEUNIT = { type: 3, value: "HEATINGVALUEUNIT" };
    }
    static {
      this.IONCONCENTRATIONUNIT = { type: 3, value: "IONCONCENTRATIONUNIT" };
    }
    static {
      this.LUMINOUSINTENSITYDISTRIBUTIONUNIT = { type: 3, value: "LUMINOUSINTENSITYDISTRIBUTIONUNIT" };
    }
    static {
      this.MASSPERLENGTHUNIT = { type: 3, value: "MASSPERLENGTHUNIT" };
    }
    static {
      this.MODULUSOFLINEARSUBGRADEREACTIONUNIT = { type: 3, value: "MODULUSOFLINEARSUBGRADEREACTIONUNIT" };
    }
    static {
      this.MODULUSOFROTATIONALSUBGRADEREACTIONUNIT = { type: 3, value: "MODULUSOFROTATIONALSUBGRADEREACTIONUNIT" };
    }
    static {
      this.PHUNIT = { type: 3, value: "PHUNIT" };
    }
    static {
      this.ROTATIONALMASSUNIT = { type: 3, value: "ROTATIONALMASSUNIT" };
    }
    static {
      this.SECTIONAREAINTEGRALUNIT = { type: 3, value: "SECTIONAREAINTEGRALUNIT" };
    }
    static {
      this.SECTIONMODULUSUNIT = { type: 3, value: "SECTIONMODULUSUNIT" };
    }
    static {
      this.SOUNDPOWERUNIT = { type: 3, value: "SOUNDPOWERUNIT" };
    }
    static {
      this.SOUNDPRESSUREUNIT = { type: 3, value: "SOUNDPRESSUREUNIT" };
    }
    static {
      this.TEMPERATUREGRADIENTUNIT = { type: 3, value: "TEMPERATUREGRADIENTUNIT" };
    }
    static {
      this.THERMALEXPANSIONCOEFFICIENTUNIT = { type: 3, value: "THERMALEXPANSIONCOEFFICIENTUNIT" };
    }
    static {
      this.WARPINGCONSTANTUNIT = { type: 3, value: "WARPINGCONSTANTUNIT" };
    }
    static {
      this.WARPINGMOMENTUNIT = { type: 3, value: "WARPINGMOMENTUNIT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
  }
  IFC2X32.IfcDerivedUnitEnum = IfcDerivedUnitEnum;
  class IfcDimensionExtentUsage {
    static {
      this.ORIGIN = { type: 3, value: "ORIGIN" };
    }
    static {
      this.TARGET = { type: 3, value: "TARGET" };
    }
  }
  IFC2X32.IfcDimensionExtentUsage = IfcDimensionExtentUsage;
  class IfcDirectionSenseEnum {
    static {
      this.POSITIVE = { type: 3, value: "POSITIVE" };
    }
    static {
      this.NEGATIVE = { type: 3, value: "NEGATIVE" };
    }
  }
  IFC2X32.IfcDirectionSenseEnum = IfcDirectionSenseEnum;
  class IfcDistributionChamberElementTypeEnum {
    static {
      this.FORMEDDUCT = { type: 3, value: "FORMEDDUCT" };
    }
    static {
      this.INSPECTIONCHAMBER = { type: 3, value: "INSPECTIONCHAMBER" };
    }
    static {
      this.INSPECTIONPIT = { type: 3, value: "INSPECTIONPIT" };
    }
    static {
      this.MANHOLE = { type: 3, value: "MANHOLE" };
    }
    static {
      this.METERCHAMBER = { type: 3, value: "METERCHAMBER" };
    }
    static {
      this.SUMP = { type: 3, value: "SUMP" };
    }
    static {
      this.TRENCH = { type: 3, value: "TRENCH" };
    }
    static {
      this.VALVECHAMBER = { type: 3, value: "VALVECHAMBER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcDistributionChamberElementTypeEnum = IfcDistributionChamberElementTypeEnum;
  class IfcDocumentConfidentialityEnum {
    static {
      this.PUBLIC = { type: 3, value: "PUBLIC" };
    }
    static {
      this.RESTRICTED = { type: 3, value: "RESTRICTED" };
    }
    static {
      this.CONFIDENTIAL = { type: 3, value: "CONFIDENTIAL" };
    }
    static {
      this.PERSONAL = { type: 3, value: "PERSONAL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcDocumentConfidentialityEnum = IfcDocumentConfidentialityEnum;
  class IfcDocumentStatusEnum {
    static {
      this.DRAFT = { type: 3, value: "DRAFT" };
    }
    static {
      this.FINALDRAFT = { type: 3, value: "FINALDRAFT" };
    }
    static {
      this.FINAL = { type: 3, value: "FINAL" };
    }
    static {
      this.REVISION = { type: 3, value: "REVISION" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcDocumentStatusEnum = IfcDocumentStatusEnum;
  class IfcDoorPanelOperationEnum {
    static {
      this.SWINGING = { type: 3, value: "SWINGING" };
    }
    static {
      this.DOUBLE_ACTING = { type: 3, value: "DOUBLE_ACTING" };
    }
    static {
      this.SLIDING = { type: 3, value: "SLIDING" };
    }
    static {
      this.FOLDING = { type: 3, value: "FOLDING" };
    }
    static {
      this.REVOLVING = { type: 3, value: "REVOLVING" };
    }
    static {
      this.ROLLINGUP = { type: 3, value: "ROLLINGUP" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcDoorPanelOperationEnum = IfcDoorPanelOperationEnum;
  class IfcDoorPanelPositionEnum {
    static {
      this.LEFT = { type: 3, value: "LEFT" };
    }
    static {
      this.MIDDLE = { type: 3, value: "MIDDLE" };
    }
    static {
      this.RIGHT = { type: 3, value: "RIGHT" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcDoorPanelPositionEnum = IfcDoorPanelPositionEnum;
  class IfcDoorStyleConstructionEnum {
    static {
      this.ALUMINIUM = { type: 3, value: "ALUMINIUM" };
    }
    static {
      this.HIGH_GRADE_STEEL = { type: 3, value: "HIGH_GRADE_STEEL" };
    }
    static {
      this.STEEL = { type: 3, value: "STEEL" };
    }
    static {
      this.WOOD = { type: 3, value: "WOOD" };
    }
    static {
      this.ALUMINIUM_WOOD = { type: 3, value: "ALUMINIUM_WOOD" };
    }
    static {
      this.ALUMINIUM_PLASTIC = { type: 3, value: "ALUMINIUM_PLASTIC" };
    }
    static {
      this.PLASTIC = { type: 3, value: "PLASTIC" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcDoorStyleConstructionEnum = IfcDoorStyleConstructionEnum;
  class IfcDoorStyleOperationEnum {
    static {
      this.SINGLE_SWING_LEFT = { type: 3, value: "SINGLE_SWING_LEFT" };
    }
    static {
      this.SINGLE_SWING_RIGHT = { type: 3, value: "SINGLE_SWING_RIGHT" };
    }
    static {
      this.DOUBLE_DOOR_SINGLE_SWING = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING" };
    }
    static {
      this.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT" };
    }
    static {
      this.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT" };
    }
    static {
      this.DOUBLE_SWING_LEFT = { type: 3, value: "DOUBLE_SWING_LEFT" };
    }
    static {
      this.DOUBLE_SWING_RIGHT = { type: 3, value: "DOUBLE_SWING_RIGHT" };
    }
    static {
      this.DOUBLE_DOOR_DOUBLE_SWING = { type: 3, value: "DOUBLE_DOOR_DOUBLE_SWING" };
    }
    static {
      this.SLIDING_TO_LEFT = { type: 3, value: "SLIDING_TO_LEFT" };
    }
    static {
      this.SLIDING_TO_RIGHT = { type: 3, value: "SLIDING_TO_RIGHT" };
    }
    static {
      this.DOUBLE_DOOR_SLIDING = { type: 3, value: "DOUBLE_DOOR_SLIDING" };
    }
    static {
      this.FOLDING_TO_LEFT = { type: 3, value: "FOLDING_TO_LEFT" };
    }
    static {
      this.FOLDING_TO_RIGHT = { type: 3, value: "FOLDING_TO_RIGHT" };
    }
    static {
      this.DOUBLE_DOOR_FOLDING = { type: 3, value: "DOUBLE_DOOR_FOLDING" };
    }
    static {
      this.REVOLVING = { type: 3, value: "REVOLVING" };
    }
    static {
      this.ROLLINGUP = { type: 3, value: "ROLLINGUP" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcDoorStyleOperationEnum = IfcDoorStyleOperationEnum;
  class IfcDuctFittingTypeEnum {
    static {
      this.BEND = { type: 3, value: "BEND" };
    }
    static {
      this.CONNECTOR = { type: 3, value: "CONNECTOR" };
    }
    static {
      this.ENTRY = { type: 3, value: "ENTRY" };
    }
    static {
      this.EXIT = { type: 3, value: "EXIT" };
    }
    static {
      this.JUNCTION = { type: 3, value: "JUNCTION" };
    }
    static {
      this.OBSTRUCTION = { type: 3, value: "OBSTRUCTION" };
    }
    static {
      this.TRANSITION = { type: 3, value: "TRANSITION" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcDuctFittingTypeEnum = IfcDuctFittingTypeEnum;
  class IfcDuctSegmentTypeEnum {
    static {
      this.RIGIDSEGMENT = { type: 3, value: "RIGIDSEGMENT" };
    }
    static {
      this.FLEXIBLESEGMENT = { type: 3, value: "FLEXIBLESEGMENT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcDuctSegmentTypeEnum = IfcDuctSegmentTypeEnum;
  class IfcDuctSilencerTypeEnum {
    static {
      this.FLATOVAL = { type: 3, value: "FLATOVAL" };
    }
    static {
      this.RECTANGULAR = { type: 3, value: "RECTANGULAR" };
    }
    static {
      this.ROUND = { type: 3, value: "ROUND" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcDuctSilencerTypeEnum = IfcDuctSilencerTypeEnum;
  class IfcElectricApplianceTypeEnum {
    static {
      this.COMPUTER = { type: 3, value: "COMPUTER" };
    }
    static {
      this.DIRECTWATERHEATER = { type: 3, value: "DIRECTWATERHEATER" };
    }
    static {
      this.DISHWASHER = { type: 3, value: "DISHWASHER" };
    }
    static {
      this.ELECTRICCOOKER = { type: 3, value: "ELECTRICCOOKER" };
    }
    static {
      this.ELECTRICHEATER = { type: 3, value: "ELECTRICHEATER" };
    }
    static {
      this.FACSIMILE = { type: 3, value: "FACSIMILE" };
    }
    static {
      this.FREESTANDINGFAN = { type: 3, value: "FREESTANDINGFAN" };
    }
    static {
      this.FREEZER = { type: 3, value: "FREEZER" };
    }
    static {
      this.FRIDGE_FREEZER = { type: 3, value: "FRIDGE_FREEZER" };
    }
    static {
      this.HANDDRYER = { type: 3, value: "HANDDRYER" };
    }
    static {
      this.INDIRECTWATERHEATER = { type: 3, value: "INDIRECTWATERHEATER" };
    }
    static {
      this.MICROWAVE = { type: 3, value: "MICROWAVE" };
    }
    static {
      this.PHOTOCOPIER = { type: 3, value: "PHOTOCOPIER" };
    }
    static {
      this.PRINTER = { type: 3, value: "PRINTER" };
    }
    static {
      this.REFRIGERATOR = { type: 3, value: "REFRIGERATOR" };
    }
    static {
      this.RADIANTHEATER = { type: 3, value: "RADIANTHEATER" };
    }
    static {
      this.SCANNER = { type: 3, value: "SCANNER" };
    }
    static {
      this.TELEPHONE = { type: 3, value: "TELEPHONE" };
    }
    static {
      this.TUMBLEDRYER = { type: 3, value: "TUMBLEDRYER" };
    }
    static {
      this.TV = { type: 3, value: "TV" };
    }
    static {
      this.VENDINGMACHINE = { type: 3, value: "VENDINGMACHINE" };
    }
    static {
      this.WASHINGMACHINE = { type: 3, value: "WASHINGMACHINE" };
    }
    static {
      this.WATERHEATER = { type: 3, value: "WATERHEATER" };
    }
    static {
      this.WATERCOOLER = { type: 3, value: "WATERCOOLER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcElectricApplianceTypeEnum = IfcElectricApplianceTypeEnum;
  class IfcElectricCurrentEnum {
    static {
      this.ALTERNATING = { type: 3, value: "ALTERNATING" };
    }
    static {
      this.DIRECT = { type: 3, value: "DIRECT" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcElectricCurrentEnum = IfcElectricCurrentEnum;
  class IfcElectricDistributionPointFunctionEnum {
    static {
      this.ALARMPANEL = { type: 3, value: "ALARMPANEL" };
    }
    static {
      this.CONSUMERUNIT = { type: 3, value: "CONSUMERUNIT" };
    }
    static {
      this.CONTROLPANEL = { type: 3, value: "CONTROLPANEL" };
    }
    static {
      this.DISTRIBUTIONBOARD = { type: 3, value: "DISTRIBUTIONBOARD" };
    }
    static {
      this.GASDETECTORPANEL = { type: 3, value: "GASDETECTORPANEL" };
    }
    static {
      this.INDICATORPANEL = { type: 3, value: "INDICATORPANEL" };
    }
    static {
      this.MIMICPANEL = { type: 3, value: "MIMICPANEL" };
    }
    static {
      this.MOTORCONTROLCENTRE = { type: 3, value: "MOTORCONTROLCENTRE" };
    }
    static {
      this.SWITCHBOARD = { type: 3, value: "SWITCHBOARD" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcElectricDistributionPointFunctionEnum = IfcElectricDistributionPointFunctionEnum;
  class IfcElectricFlowStorageDeviceTypeEnum {
    static {
      this.BATTERY = { type: 3, value: "BATTERY" };
    }
    static {
      this.CAPACITORBANK = { type: 3, value: "CAPACITORBANK" };
    }
    static {
      this.HARMONICFILTER = { type: 3, value: "HARMONICFILTER" };
    }
    static {
      this.INDUCTORBANK = { type: 3, value: "INDUCTORBANK" };
    }
    static {
      this.UPS = { type: 3, value: "UPS" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcElectricFlowStorageDeviceTypeEnum = IfcElectricFlowStorageDeviceTypeEnum;
  class IfcElectricGeneratorTypeEnum {
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcElectricGeneratorTypeEnum = IfcElectricGeneratorTypeEnum;
  class IfcElectricHeaterTypeEnum {
    static {
      this.ELECTRICPOINTHEATER = { type: 3, value: "ELECTRICPOINTHEATER" };
    }
    static {
      this.ELECTRICCABLEHEATER = { type: 3, value: "ELECTRICCABLEHEATER" };
    }
    static {
      this.ELECTRICMATHEATER = { type: 3, value: "ELECTRICMATHEATER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcElectricHeaterTypeEnum = IfcElectricHeaterTypeEnum;
  class IfcElectricMotorTypeEnum {
    static {
      this.DC = { type: 3, value: "DC" };
    }
    static {
      this.INDUCTION = { type: 3, value: "INDUCTION" };
    }
    static {
      this.POLYPHASE = { type: 3, value: "POLYPHASE" };
    }
    static {
      this.RELUCTANCESYNCHRONOUS = { type: 3, value: "RELUCTANCESYNCHRONOUS" };
    }
    static {
      this.SYNCHRONOUS = { type: 3, value: "SYNCHRONOUS" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcElectricMotorTypeEnum = IfcElectricMotorTypeEnum;
  class IfcElectricTimeControlTypeEnum {
    static {
      this.TIMECLOCK = { type: 3, value: "TIMECLOCK" };
    }
    static {
      this.TIMEDELAY = { type: 3, value: "TIMEDELAY" };
    }
    static {
      this.RELAY = { type: 3, value: "RELAY" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcElectricTimeControlTypeEnum = IfcElectricTimeControlTypeEnum;
  class IfcElementAssemblyTypeEnum {
    static {
      this.ACCESSORY_ASSEMBLY = { type: 3, value: "ACCESSORY_ASSEMBLY" };
    }
    static {
      this.ARCH = { type: 3, value: "ARCH" };
    }
    static {
      this.BEAM_GRID = { type: 3, value: "BEAM_GRID" };
    }
    static {
      this.BRACED_FRAME = { type: 3, value: "BRACED_FRAME" };
    }
    static {
      this.GIRDER = { type: 3, value: "GIRDER" };
    }
    static {
      this.REINFORCEMENT_UNIT = { type: 3, value: "REINFORCEMENT_UNIT" };
    }
    static {
      this.RIGID_FRAME = { type: 3, value: "RIGID_FRAME" };
    }
    static {
      this.SLAB_FIELD = { type: 3, value: "SLAB_FIELD" };
    }
    static {
      this.TRUSS = { type: 3, value: "TRUSS" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcElementAssemblyTypeEnum = IfcElementAssemblyTypeEnum;
  class IfcElementCompositionEnum {
    static {
      this.COMPLEX = { type: 3, value: "COMPLEX" };
    }
    static {
      this.ELEMENT = { type: 3, value: "ELEMENT" };
    }
    static {
      this.PARTIAL = { type: 3, value: "PARTIAL" };
    }
  }
  IFC2X32.IfcElementCompositionEnum = IfcElementCompositionEnum;
  class IfcEnergySequenceEnum {
    static {
      this.PRIMARY = { type: 3, value: "PRIMARY" };
    }
    static {
      this.SECONDARY = { type: 3, value: "SECONDARY" };
    }
    static {
      this.TERTIARY = { type: 3, value: "TERTIARY" };
    }
    static {
      this.AUXILIARY = { type: 3, value: "AUXILIARY" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcEnergySequenceEnum = IfcEnergySequenceEnum;
  class IfcEnvironmentalImpactCategoryEnum {
    static {
      this.COMBINEDVALUE = { type: 3, value: "COMBINEDVALUE" };
    }
    static {
      this.DISPOSAL = { type: 3, value: "DISPOSAL" };
    }
    static {
      this.EXTRACTION = { type: 3, value: "EXTRACTION" };
    }
    static {
      this.INSTALLATION = { type: 3, value: "INSTALLATION" };
    }
    static {
      this.MANUFACTURE = { type: 3, value: "MANUFACTURE" };
    }
    static {
      this.TRANSPORTATION = { type: 3, value: "TRANSPORTATION" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcEnvironmentalImpactCategoryEnum = IfcEnvironmentalImpactCategoryEnum;
  class IfcEvaporativeCoolerTypeEnum {
    static {
      this.DIRECTEVAPORATIVERANDOMMEDIAAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVERANDOMMEDIAAIRCOOLER" };
    }
    static {
      this.DIRECTEVAPORATIVERIGIDMEDIAAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVERIGIDMEDIAAIRCOOLER" };
    }
    static {
      this.DIRECTEVAPORATIVESLINGERSPACKAGEDAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVESLINGERSPACKAGEDAIRCOOLER" };
    }
    static {
      this.DIRECTEVAPORATIVEPACKAGEDROTARYAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVEPACKAGEDROTARYAIRCOOLER" };
    }
    static {
      this.DIRECTEVAPORATIVEAIRWASHER = { type: 3, value: "DIRECTEVAPORATIVEAIRWASHER" };
    }
    static {
      this.INDIRECTEVAPORATIVEPACKAGEAIRCOOLER = { type: 3, value: "INDIRECTEVAPORATIVEPACKAGEAIRCOOLER" };
    }
    static {
      this.INDIRECTEVAPORATIVEWETCOIL = { type: 3, value: "INDIRECTEVAPORATIVEWETCOIL" };
    }
    static {
      this.INDIRECTEVAPORATIVECOOLINGTOWERORCOILCOOLER = { type: 3, value: "INDIRECTEVAPORATIVECOOLINGTOWERORCOILCOOLER" };
    }
    static {
      this.INDIRECTDIRECTCOMBINATION = { type: 3, value: "INDIRECTDIRECTCOMBINATION" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcEvaporativeCoolerTypeEnum = IfcEvaporativeCoolerTypeEnum;
  class IfcEvaporatorTypeEnum {
    static {
      this.DIRECTEXPANSIONSHELLANDTUBE = { type: 3, value: "DIRECTEXPANSIONSHELLANDTUBE" };
    }
    static {
      this.DIRECTEXPANSIONTUBEINTUBE = { type: 3, value: "DIRECTEXPANSIONTUBEINTUBE" };
    }
    static {
      this.DIRECTEXPANSIONBRAZEDPLATE = { type: 3, value: "DIRECTEXPANSIONBRAZEDPLATE" };
    }
    static {
      this.FLOODEDSHELLANDTUBE = { type: 3, value: "FLOODEDSHELLANDTUBE" };
    }
    static {
      this.SHELLANDCOIL = { type: 3, value: "SHELLANDCOIL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcEvaporatorTypeEnum = IfcEvaporatorTypeEnum;
  class IfcFanTypeEnum {
    static {
      this.CENTRIFUGALFORWARDCURVED = { type: 3, value: "CENTRIFUGALFORWARDCURVED" };
    }
    static {
      this.CENTRIFUGALRADIAL = { type: 3, value: "CENTRIFUGALRADIAL" };
    }
    static {
      this.CENTRIFUGALBACKWARDINCLINEDCURVED = { type: 3, value: "CENTRIFUGALBACKWARDINCLINEDCURVED" };
    }
    static {
      this.CENTRIFUGALAIRFOIL = { type: 3, value: "CENTRIFUGALAIRFOIL" };
    }
    static {
      this.TUBEAXIAL = { type: 3, value: "TUBEAXIAL" };
    }
    static {
      this.VANEAXIAL = { type: 3, value: "VANEAXIAL" };
    }
    static {
      this.PROPELLORAXIAL = { type: 3, value: "PROPELLORAXIAL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcFanTypeEnum = IfcFanTypeEnum;
  class IfcFilterTypeEnum {
    static {
      this.AIRPARTICLEFILTER = { type: 3, value: "AIRPARTICLEFILTER" };
    }
    static {
      this.ODORFILTER = { type: 3, value: "ODORFILTER" };
    }
    static {
      this.OILFILTER = { type: 3, value: "OILFILTER" };
    }
    static {
      this.STRAINER = { type: 3, value: "STRAINER" };
    }
    static {
      this.WATERFILTER = { type: 3, value: "WATERFILTER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcFilterTypeEnum = IfcFilterTypeEnum;
  class IfcFireSuppressionTerminalTypeEnum {
    static {
      this.BREECHINGINLET = { type: 3, value: "BREECHINGINLET" };
    }
    static {
      this.FIREHYDRANT = { type: 3, value: "FIREHYDRANT" };
    }
    static {
      this.HOSEREEL = { type: 3, value: "HOSEREEL" };
    }
    static {
      this.SPRINKLER = { type: 3, value: "SPRINKLER" };
    }
    static {
      this.SPRINKLERDEFLECTOR = { type: 3, value: "SPRINKLERDEFLECTOR" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcFireSuppressionTerminalTypeEnum = IfcFireSuppressionTerminalTypeEnum;
  class IfcFlowDirectionEnum {
    static {
      this.SOURCE = { type: 3, value: "SOURCE" };
    }
    static {
      this.SINK = { type: 3, value: "SINK" };
    }
    static {
      this.SOURCEANDSINK = { type: 3, value: "SOURCEANDSINK" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcFlowDirectionEnum = IfcFlowDirectionEnum;
  class IfcFlowInstrumentTypeEnum {
    static {
      this.PRESSUREGAUGE = { type: 3, value: "PRESSUREGAUGE" };
    }
    static {
      this.THERMOMETER = { type: 3, value: "THERMOMETER" };
    }
    static {
      this.AMMETER = { type: 3, value: "AMMETER" };
    }
    static {
      this.FREQUENCYMETER = { type: 3, value: "FREQUENCYMETER" };
    }
    static {
      this.POWERFACTORMETER = { type: 3, value: "POWERFACTORMETER" };
    }
    static {
      this.PHASEANGLEMETER = { type: 3, value: "PHASEANGLEMETER" };
    }
    static {
      this.VOLTMETER_PEAK = { type: 3, value: "VOLTMETER_PEAK" };
    }
    static {
      this.VOLTMETER_RMS = { type: 3, value: "VOLTMETER_RMS" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcFlowInstrumentTypeEnum = IfcFlowInstrumentTypeEnum;
  class IfcFlowMeterTypeEnum {
    static {
      this.ELECTRICMETER = { type: 3, value: "ELECTRICMETER" };
    }
    static {
      this.ENERGYMETER = { type: 3, value: "ENERGYMETER" };
    }
    static {
      this.FLOWMETER = { type: 3, value: "FLOWMETER" };
    }
    static {
      this.GASMETER = { type: 3, value: "GASMETER" };
    }
    static {
      this.OILMETER = { type: 3, value: "OILMETER" };
    }
    static {
      this.WATERMETER = { type: 3, value: "WATERMETER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcFlowMeterTypeEnum = IfcFlowMeterTypeEnum;
  class IfcFootingTypeEnum {
    static {
      this.FOOTING_BEAM = { type: 3, value: "FOOTING_BEAM" };
    }
    static {
      this.PAD_FOOTING = { type: 3, value: "PAD_FOOTING" };
    }
    static {
      this.PILE_CAP = { type: 3, value: "PILE_CAP" };
    }
    static {
      this.STRIP_FOOTING = { type: 3, value: "STRIP_FOOTING" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcFootingTypeEnum = IfcFootingTypeEnum;
  class IfcGasTerminalTypeEnum {
    static {
      this.GASAPPLIANCE = { type: 3, value: "GASAPPLIANCE" };
    }
    static {
      this.GASBOOSTER = { type: 3, value: "GASBOOSTER" };
    }
    static {
      this.GASBURNER = { type: 3, value: "GASBURNER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcGasTerminalTypeEnum = IfcGasTerminalTypeEnum;
  class IfcGeometricProjectionEnum {
    static {
      this.GRAPH_VIEW = { type: 3, value: "GRAPH_VIEW" };
    }
    static {
      this.SKETCH_VIEW = { type: 3, value: "SKETCH_VIEW" };
    }
    static {
      this.MODEL_VIEW = { type: 3, value: "MODEL_VIEW" };
    }
    static {
      this.PLAN_VIEW = { type: 3, value: "PLAN_VIEW" };
    }
    static {
      this.REFLECTED_PLAN_VIEW = { type: 3, value: "REFLECTED_PLAN_VIEW" };
    }
    static {
      this.SECTION_VIEW = { type: 3, value: "SECTION_VIEW" };
    }
    static {
      this.ELEVATION_VIEW = { type: 3, value: "ELEVATION_VIEW" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcGeometricProjectionEnum = IfcGeometricProjectionEnum;
  class IfcGlobalOrLocalEnum {
    static {
      this.GLOBAL_COORDS = { type: 3, value: "GLOBAL_COORDS" };
    }
    static {
      this.LOCAL_COORDS = { type: 3, value: "LOCAL_COORDS" };
    }
  }
  IFC2X32.IfcGlobalOrLocalEnum = IfcGlobalOrLocalEnum;
  class IfcHeatExchangerTypeEnum {
    static {
      this.PLATE = { type: 3, value: "PLATE" };
    }
    static {
      this.SHELLANDTUBE = { type: 3, value: "SHELLANDTUBE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcHeatExchangerTypeEnum = IfcHeatExchangerTypeEnum;
  class IfcHumidifierTypeEnum {
    static {
      this.STEAMINJECTION = { type: 3, value: "STEAMINJECTION" };
    }
    static {
      this.ADIABATICAIRWASHER = { type: 3, value: "ADIABATICAIRWASHER" };
    }
    static {
      this.ADIABATICPAN = { type: 3, value: "ADIABATICPAN" };
    }
    static {
      this.ADIABATICWETTEDELEMENT = { type: 3, value: "ADIABATICWETTEDELEMENT" };
    }
    static {
      this.ADIABATICATOMIZING = { type: 3, value: "ADIABATICATOMIZING" };
    }
    static {
      this.ADIABATICULTRASONIC = { type: 3, value: "ADIABATICULTRASONIC" };
    }
    static {
      this.ADIABATICRIGIDMEDIA = { type: 3, value: "ADIABATICRIGIDMEDIA" };
    }
    static {
      this.ADIABATICCOMPRESSEDAIRNOZZLE = { type: 3, value: "ADIABATICCOMPRESSEDAIRNOZZLE" };
    }
    static {
      this.ASSISTEDELECTRIC = { type: 3, value: "ASSISTEDELECTRIC" };
    }
    static {
      this.ASSISTEDNATURALGAS = { type: 3, value: "ASSISTEDNATURALGAS" };
    }
    static {
      this.ASSISTEDPROPANE = { type: 3, value: "ASSISTEDPROPANE" };
    }
    static {
      this.ASSISTEDBUTANE = { type: 3, value: "ASSISTEDBUTANE" };
    }
    static {
      this.ASSISTEDSTEAM = { type: 3, value: "ASSISTEDSTEAM" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcHumidifierTypeEnum = IfcHumidifierTypeEnum;
  class IfcInternalOrExternalEnum {
    static {
      this.INTERNAL = { type: 3, value: "INTERNAL" };
    }
    static {
      this.EXTERNAL = { type: 3, value: "EXTERNAL" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcInternalOrExternalEnum = IfcInternalOrExternalEnum;
  class IfcInventoryTypeEnum {
    static {
      this.ASSETINVENTORY = { type: 3, value: "ASSETINVENTORY" };
    }
    static {
      this.SPACEINVENTORY = { type: 3, value: "SPACEINVENTORY" };
    }
    static {
      this.FURNITUREINVENTORY = { type: 3, value: "FURNITUREINVENTORY" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcInventoryTypeEnum = IfcInventoryTypeEnum;
  class IfcJunctionBoxTypeEnum {
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcJunctionBoxTypeEnum = IfcJunctionBoxTypeEnum;
  class IfcLampTypeEnum {
    static {
      this.COMPACTFLUORESCENT = { type: 3, value: "COMPACTFLUORESCENT" };
    }
    static {
      this.FLUORESCENT = { type: 3, value: "FLUORESCENT" };
    }
    static {
      this.HIGHPRESSUREMERCURY = { type: 3, value: "HIGHPRESSUREMERCURY" };
    }
    static {
      this.HIGHPRESSURESODIUM = { type: 3, value: "HIGHPRESSURESODIUM" };
    }
    static {
      this.METALHALIDE = { type: 3, value: "METALHALIDE" };
    }
    static {
      this.TUNGSTENFILAMENT = { type: 3, value: "TUNGSTENFILAMENT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcLampTypeEnum = IfcLampTypeEnum;
  class IfcLayerSetDirectionEnum {
    static {
      this.AXIS1 = { type: 3, value: "AXIS1" };
    }
    static {
      this.AXIS2 = { type: 3, value: "AXIS2" };
    }
    static {
      this.AXIS3 = { type: 3, value: "AXIS3" };
    }
  }
  IFC2X32.IfcLayerSetDirectionEnum = IfcLayerSetDirectionEnum;
  class IfcLightDistributionCurveEnum {
    static {
      this.TYPE_A = { type: 3, value: "TYPE_A" };
    }
    static {
      this.TYPE_B = { type: 3, value: "TYPE_B" };
    }
    static {
      this.TYPE_C = { type: 3, value: "TYPE_C" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcLightDistributionCurveEnum = IfcLightDistributionCurveEnum;
  class IfcLightEmissionSourceEnum {
    static {
      this.COMPACTFLUORESCENT = { type: 3, value: "COMPACTFLUORESCENT" };
    }
    static {
      this.FLUORESCENT = { type: 3, value: "FLUORESCENT" };
    }
    static {
      this.HIGHPRESSUREMERCURY = { type: 3, value: "HIGHPRESSUREMERCURY" };
    }
    static {
      this.HIGHPRESSURESODIUM = { type: 3, value: "HIGHPRESSURESODIUM" };
    }
    static {
      this.LIGHTEMITTINGDIODE = { type: 3, value: "LIGHTEMITTINGDIODE" };
    }
    static {
      this.LOWPRESSURESODIUM = { type: 3, value: "LOWPRESSURESODIUM" };
    }
    static {
      this.LOWVOLTAGEHALOGEN = { type: 3, value: "LOWVOLTAGEHALOGEN" };
    }
    static {
      this.MAINVOLTAGEHALOGEN = { type: 3, value: "MAINVOLTAGEHALOGEN" };
    }
    static {
      this.METALHALIDE = { type: 3, value: "METALHALIDE" };
    }
    static {
      this.TUNGSTENFILAMENT = { type: 3, value: "TUNGSTENFILAMENT" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcLightEmissionSourceEnum = IfcLightEmissionSourceEnum;
  class IfcLightFixtureTypeEnum {
    static {
      this.POINTSOURCE = { type: 3, value: "POINTSOURCE" };
    }
    static {
      this.DIRECTIONSOURCE = { type: 3, value: "DIRECTIONSOURCE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcLightFixtureTypeEnum = IfcLightFixtureTypeEnum;
  class IfcLoadGroupTypeEnum {
    static {
      this.LOAD_GROUP = { type: 3, value: "LOAD_GROUP" };
    }
    static {
      this.LOAD_CASE = { type: 3, value: "LOAD_CASE" };
    }
    static {
      this.LOAD_COMBINATION_GROUP = { type: 3, value: "LOAD_COMBINATION_GROUP" };
    }
    static {
      this.LOAD_COMBINATION = { type: 3, value: "LOAD_COMBINATION" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcLoadGroupTypeEnum = IfcLoadGroupTypeEnum;
  class IfcLogicalOperatorEnum {
    static {
      this.LOGICALAND = { type: 3, value: "LOGICALAND" };
    }
    static {
      this.LOGICALOR = { type: 3, value: "LOGICALOR" };
    }
  }
  IFC2X32.IfcLogicalOperatorEnum = IfcLogicalOperatorEnum;
  class IfcMemberTypeEnum {
    static {
      this.BRACE = { type: 3, value: "BRACE" };
    }
    static {
      this.CHORD = { type: 3, value: "CHORD" };
    }
    static {
      this.COLLAR = { type: 3, value: "COLLAR" };
    }
    static {
      this.MEMBER = { type: 3, value: "MEMBER" };
    }
    static {
      this.MULLION = { type: 3, value: "MULLION" };
    }
    static {
      this.PLATE = { type: 3, value: "PLATE" };
    }
    static {
      this.POST = { type: 3, value: "POST" };
    }
    static {
      this.PURLIN = { type: 3, value: "PURLIN" };
    }
    static {
      this.RAFTER = { type: 3, value: "RAFTER" };
    }
    static {
      this.STRINGER = { type: 3, value: "STRINGER" };
    }
    static {
      this.STRUT = { type: 3, value: "STRUT" };
    }
    static {
      this.STUD = { type: 3, value: "STUD" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcMemberTypeEnum = IfcMemberTypeEnum;
  class IfcMotorConnectionTypeEnum {
    static {
      this.BELTDRIVE = { type: 3, value: "BELTDRIVE" };
    }
    static {
      this.COUPLING = { type: 3, value: "COUPLING" };
    }
    static {
      this.DIRECTDRIVE = { type: 3, value: "DIRECTDRIVE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcMotorConnectionTypeEnum = IfcMotorConnectionTypeEnum;
  class IfcNullStyle {
    static {
      this.NULL = { type: 3, value: "NULL" };
    }
  }
  IFC2X32.IfcNullStyle = IfcNullStyle;
  class IfcObjectTypeEnum {
    static {
      this.PRODUCT = { type: 3, value: "PRODUCT" };
    }
    static {
      this.PROCESS = { type: 3, value: "PROCESS" };
    }
    static {
      this.CONTROL = { type: 3, value: "CONTROL" };
    }
    static {
      this.RESOURCE = { type: 3, value: "RESOURCE" };
    }
    static {
      this.ACTOR = { type: 3, value: "ACTOR" };
    }
    static {
      this.GROUP = { type: 3, value: "GROUP" };
    }
    static {
      this.PROJECT = { type: 3, value: "PROJECT" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcObjectTypeEnum = IfcObjectTypeEnum;
  class IfcObjectiveEnum {
    static {
      this.CODECOMPLIANCE = { type: 3, value: "CODECOMPLIANCE" };
    }
    static {
      this.DESIGNINTENT = { type: 3, value: "DESIGNINTENT" };
    }
    static {
      this.HEALTHANDSAFETY = { type: 3, value: "HEALTHANDSAFETY" };
    }
    static {
      this.REQUIREMENT = { type: 3, value: "REQUIREMENT" };
    }
    static {
      this.SPECIFICATION = { type: 3, value: "SPECIFICATION" };
    }
    static {
      this.TRIGGERCONDITION = { type: 3, value: "TRIGGERCONDITION" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcObjectiveEnum = IfcObjectiveEnum;
  class IfcOccupantTypeEnum {
    static {
      this.ASSIGNEE = { type: 3, value: "ASSIGNEE" };
    }
    static {
      this.ASSIGNOR = { type: 3, value: "ASSIGNOR" };
    }
    static {
      this.LESSEE = { type: 3, value: "LESSEE" };
    }
    static {
      this.LESSOR = { type: 3, value: "LESSOR" };
    }
    static {
      this.LETTINGAGENT = { type: 3, value: "LETTINGAGENT" };
    }
    static {
      this.OWNER = { type: 3, value: "OWNER" };
    }
    static {
      this.TENANT = { type: 3, value: "TENANT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcOccupantTypeEnum = IfcOccupantTypeEnum;
  class IfcOutletTypeEnum {
    static {
      this.AUDIOVISUALOUTLET = { type: 3, value: "AUDIOVISUALOUTLET" };
    }
    static {
      this.COMMUNICATIONSOUTLET = { type: 3, value: "COMMUNICATIONSOUTLET" };
    }
    static {
      this.POWEROUTLET = { type: 3, value: "POWEROUTLET" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcOutletTypeEnum = IfcOutletTypeEnum;
  class IfcPermeableCoveringOperationEnum {
    static {
      this.GRILL = { type: 3, value: "GRILL" };
    }
    static {
      this.LOUVER = { type: 3, value: "LOUVER" };
    }
    static {
      this.SCREEN = { type: 3, value: "SCREEN" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcPermeableCoveringOperationEnum = IfcPermeableCoveringOperationEnum;
  class IfcPhysicalOrVirtualEnum {
    static {
      this.PHYSICAL = { type: 3, value: "PHYSICAL" };
    }
    static {
      this.VIRTUAL = { type: 3, value: "VIRTUAL" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcPhysicalOrVirtualEnum = IfcPhysicalOrVirtualEnum;
  class IfcPileConstructionEnum {
    static {
      this.CAST_IN_PLACE = { type: 3, value: "CAST_IN_PLACE" };
    }
    static {
      this.COMPOSITE = { type: 3, value: "COMPOSITE" };
    }
    static {
      this.PRECAST_CONCRETE = { type: 3, value: "PRECAST_CONCRETE" };
    }
    static {
      this.PREFAB_STEEL = { type: 3, value: "PREFAB_STEEL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcPileConstructionEnum = IfcPileConstructionEnum;
  class IfcPileTypeEnum {
    static {
      this.COHESION = { type: 3, value: "COHESION" };
    }
    static {
      this.FRICTION = { type: 3, value: "FRICTION" };
    }
    static {
      this.SUPPORT = { type: 3, value: "SUPPORT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcPileTypeEnum = IfcPileTypeEnum;
  class IfcPipeFittingTypeEnum {
    static {
      this.BEND = { type: 3, value: "BEND" };
    }
    static {
      this.CONNECTOR = { type: 3, value: "CONNECTOR" };
    }
    static {
      this.ENTRY = { type: 3, value: "ENTRY" };
    }
    static {
      this.EXIT = { type: 3, value: "EXIT" };
    }
    static {
      this.JUNCTION = { type: 3, value: "JUNCTION" };
    }
    static {
      this.OBSTRUCTION = { type: 3, value: "OBSTRUCTION" };
    }
    static {
      this.TRANSITION = { type: 3, value: "TRANSITION" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcPipeFittingTypeEnum = IfcPipeFittingTypeEnum;
  class IfcPipeSegmentTypeEnum {
    static {
      this.FLEXIBLESEGMENT = { type: 3, value: "FLEXIBLESEGMENT" };
    }
    static {
      this.RIGIDSEGMENT = { type: 3, value: "RIGIDSEGMENT" };
    }
    static {
      this.GUTTER = { type: 3, value: "GUTTER" };
    }
    static {
      this.SPOOL = { type: 3, value: "SPOOL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcPipeSegmentTypeEnum = IfcPipeSegmentTypeEnum;
  class IfcPlateTypeEnum {
    static {
      this.CURTAIN_PANEL = { type: 3, value: "CURTAIN_PANEL" };
    }
    static {
      this.SHEET = { type: 3, value: "SHEET" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcPlateTypeEnum = IfcPlateTypeEnum;
  class IfcProcedureTypeEnum {
    static {
      this.ADVICE_CAUTION = { type: 3, value: "ADVICE_CAUTION" };
    }
    static {
      this.ADVICE_NOTE = { type: 3, value: "ADVICE_NOTE" };
    }
    static {
      this.ADVICE_WARNING = { type: 3, value: "ADVICE_WARNING" };
    }
    static {
      this.CALIBRATION = { type: 3, value: "CALIBRATION" };
    }
    static {
      this.DIAGNOSTIC = { type: 3, value: "DIAGNOSTIC" };
    }
    static {
      this.SHUTDOWN = { type: 3, value: "SHUTDOWN" };
    }
    static {
      this.STARTUP = { type: 3, value: "STARTUP" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcProcedureTypeEnum = IfcProcedureTypeEnum;
  class IfcProfileTypeEnum {
    static {
      this.CURVE = { type: 3, value: "CURVE" };
    }
    static {
      this.AREA = { type: 3, value: "AREA" };
    }
  }
  IFC2X32.IfcProfileTypeEnum = IfcProfileTypeEnum;
  class IfcProjectOrderRecordTypeEnum {
    static {
      this.CHANGE = { type: 3, value: "CHANGE" };
    }
    static {
      this.MAINTENANCE = { type: 3, value: "MAINTENANCE" };
    }
    static {
      this.MOVE = { type: 3, value: "MOVE" };
    }
    static {
      this.PURCHASE = { type: 3, value: "PURCHASE" };
    }
    static {
      this.WORK = { type: 3, value: "WORK" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcProjectOrderRecordTypeEnum = IfcProjectOrderRecordTypeEnum;
  class IfcProjectOrderTypeEnum {
    static {
      this.CHANGEORDER = { type: 3, value: "CHANGEORDER" };
    }
    static {
      this.MAINTENANCEWORKORDER = { type: 3, value: "MAINTENANCEWORKORDER" };
    }
    static {
      this.MOVEORDER = { type: 3, value: "MOVEORDER" };
    }
    static {
      this.PURCHASEORDER = { type: 3, value: "PURCHASEORDER" };
    }
    static {
      this.WORKORDER = { type: 3, value: "WORKORDER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcProjectOrderTypeEnum = IfcProjectOrderTypeEnum;
  class IfcProjectedOrTrueLengthEnum {
    static {
      this.PROJECTED_LENGTH = { type: 3, value: "PROJECTED_LENGTH" };
    }
    static {
      this.TRUE_LENGTH = { type: 3, value: "TRUE_LENGTH" };
    }
  }
  IFC2X32.IfcProjectedOrTrueLengthEnum = IfcProjectedOrTrueLengthEnum;
  class IfcPropertySourceEnum {
    static {
      this.DESIGN = { type: 3, value: "DESIGN" };
    }
    static {
      this.DESIGNMAXIMUM = { type: 3, value: "DESIGNMAXIMUM" };
    }
    static {
      this.DESIGNMINIMUM = { type: 3, value: "DESIGNMINIMUM" };
    }
    static {
      this.SIMULATED = { type: 3, value: "SIMULATED" };
    }
    static {
      this.ASBUILT = { type: 3, value: "ASBUILT" };
    }
    static {
      this.COMMISSIONING = { type: 3, value: "COMMISSIONING" };
    }
    static {
      this.MEASURED = { type: 3, value: "MEASURED" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTKNOWN = { type: 3, value: "NOTKNOWN" };
    }
  }
  IFC2X32.IfcPropertySourceEnum = IfcPropertySourceEnum;
  class IfcProtectiveDeviceTypeEnum {
    static {
      this.FUSEDISCONNECTOR = { type: 3, value: "FUSEDISCONNECTOR" };
    }
    static {
      this.CIRCUITBREAKER = { type: 3, value: "CIRCUITBREAKER" };
    }
    static {
      this.EARTHFAILUREDEVICE = { type: 3, value: "EARTHFAILUREDEVICE" };
    }
    static {
      this.RESIDUALCURRENTCIRCUITBREAKER = { type: 3, value: "RESIDUALCURRENTCIRCUITBREAKER" };
    }
    static {
      this.RESIDUALCURRENTSWITCH = { type: 3, value: "RESIDUALCURRENTSWITCH" };
    }
    static {
      this.VARISTOR = { type: 3, value: "VARISTOR" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcProtectiveDeviceTypeEnum = IfcProtectiveDeviceTypeEnum;
  class IfcPumpTypeEnum {
    static {
      this.CIRCULATOR = { type: 3, value: "CIRCULATOR" };
    }
    static {
      this.ENDSUCTION = { type: 3, value: "ENDSUCTION" };
    }
    static {
      this.SPLITCASE = { type: 3, value: "SPLITCASE" };
    }
    static {
      this.VERTICALINLINE = { type: 3, value: "VERTICALINLINE" };
    }
    static {
      this.VERTICALTURBINE = { type: 3, value: "VERTICALTURBINE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcPumpTypeEnum = IfcPumpTypeEnum;
  class IfcRailingTypeEnum {
    static {
      this.HANDRAIL = { type: 3, value: "HANDRAIL" };
    }
    static {
      this.GUARDRAIL = { type: 3, value: "GUARDRAIL" };
    }
    static {
      this.BALUSTRADE = { type: 3, value: "BALUSTRADE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcRailingTypeEnum = IfcRailingTypeEnum;
  class IfcRampFlightTypeEnum {
    static {
      this.STRAIGHT = { type: 3, value: "STRAIGHT" };
    }
    static {
      this.SPIRAL = { type: 3, value: "SPIRAL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcRampFlightTypeEnum = IfcRampFlightTypeEnum;
  class IfcRampTypeEnum {
    static {
      this.STRAIGHT_RUN_RAMP = { type: 3, value: "STRAIGHT_RUN_RAMP" };
    }
    static {
      this.TWO_STRAIGHT_RUN_RAMP = { type: 3, value: "TWO_STRAIGHT_RUN_RAMP" };
    }
    static {
      this.QUARTER_TURN_RAMP = { type: 3, value: "QUARTER_TURN_RAMP" };
    }
    static {
      this.TWO_QUARTER_TURN_RAMP = { type: 3, value: "TWO_QUARTER_TURN_RAMP" };
    }
    static {
      this.HALF_TURN_RAMP = { type: 3, value: "HALF_TURN_RAMP" };
    }
    static {
      this.SPIRAL_RAMP = { type: 3, value: "SPIRAL_RAMP" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcRampTypeEnum = IfcRampTypeEnum;
  class IfcReflectanceMethodEnum {
    static {
      this.BLINN = { type: 3, value: "BLINN" };
    }
    static {
      this.FLAT = { type: 3, value: "FLAT" };
    }
    static {
      this.GLASS = { type: 3, value: "GLASS" };
    }
    static {
      this.MATT = { type: 3, value: "MATT" };
    }
    static {
      this.METAL = { type: 3, value: "METAL" };
    }
    static {
      this.MIRROR = { type: 3, value: "MIRROR" };
    }
    static {
      this.PHONG = { type: 3, value: "PHONG" };
    }
    static {
      this.PLASTIC = { type: 3, value: "PLASTIC" };
    }
    static {
      this.STRAUSS = { type: 3, value: "STRAUSS" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcReflectanceMethodEnum = IfcReflectanceMethodEnum;
  class IfcReinforcingBarRoleEnum {
    static {
      this.MAIN = { type: 3, value: "MAIN" };
    }
    static {
      this.SHEAR = { type: 3, value: "SHEAR" };
    }
    static {
      this.LIGATURE = { type: 3, value: "LIGATURE" };
    }
    static {
      this.STUD = { type: 3, value: "STUD" };
    }
    static {
      this.PUNCHING = { type: 3, value: "PUNCHING" };
    }
    static {
      this.EDGE = { type: 3, value: "EDGE" };
    }
    static {
      this.RING = { type: 3, value: "RING" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcReinforcingBarRoleEnum = IfcReinforcingBarRoleEnum;
  class IfcReinforcingBarSurfaceEnum {
    static {
      this.PLAIN = { type: 3, value: "PLAIN" };
    }
    static {
      this.TEXTURED = { type: 3, value: "TEXTURED" };
    }
  }
  IFC2X32.IfcReinforcingBarSurfaceEnum = IfcReinforcingBarSurfaceEnum;
  class IfcResourceConsumptionEnum {
    static {
      this.CONSUMED = { type: 3, value: "CONSUMED" };
    }
    static {
      this.PARTIALLYCONSUMED = { type: 3, value: "PARTIALLYCONSUMED" };
    }
    static {
      this.NOTCONSUMED = { type: 3, value: "NOTCONSUMED" };
    }
    static {
      this.OCCUPIED = { type: 3, value: "OCCUPIED" };
    }
    static {
      this.PARTIALLYOCCUPIED = { type: 3, value: "PARTIALLYOCCUPIED" };
    }
    static {
      this.NOTOCCUPIED = { type: 3, value: "NOTOCCUPIED" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcResourceConsumptionEnum = IfcResourceConsumptionEnum;
  class IfcRibPlateDirectionEnum {
    static {
      this.DIRECTION_X = { type: 3, value: "DIRECTION_X" };
    }
    static {
      this.DIRECTION_Y = { type: 3, value: "DIRECTION_Y" };
    }
  }
  IFC2X32.IfcRibPlateDirectionEnum = IfcRibPlateDirectionEnum;
  class IfcRoleEnum {
    static {
      this.SUPPLIER = { type: 3, value: "SUPPLIER" };
    }
    static {
      this.MANUFACTURER = { type: 3, value: "MANUFACTURER" };
    }
    static {
      this.CONTRACTOR = { type: 3, value: "CONTRACTOR" };
    }
    static {
      this.SUBCONTRACTOR = { type: 3, value: "SUBCONTRACTOR" };
    }
    static {
      this.ARCHITECT = { type: 3, value: "ARCHITECT" };
    }
    static {
      this.STRUCTURALENGINEER = { type: 3, value: "STRUCTURALENGINEER" };
    }
    static {
      this.COSTENGINEER = { type: 3, value: "COSTENGINEER" };
    }
    static {
      this.CLIENT = { type: 3, value: "CLIENT" };
    }
    static {
      this.BUILDINGOWNER = { type: 3, value: "BUILDINGOWNER" };
    }
    static {
      this.BUILDINGOPERATOR = { type: 3, value: "BUILDINGOPERATOR" };
    }
    static {
      this.MECHANICALENGINEER = { type: 3, value: "MECHANICALENGINEER" };
    }
    static {
      this.ELECTRICALENGINEER = { type: 3, value: "ELECTRICALENGINEER" };
    }
    static {
      this.PROJECTMANAGER = { type: 3, value: "PROJECTMANAGER" };
    }
    static {
      this.FACILITIESMANAGER = { type: 3, value: "FACILITIESMANAGER" };
    }
    static {
      this.CIVILENGINEER = { type: 3, value: "CIVILENGINEER" };
    }
    static {
      this.COMISSIONINGENGINEER = { type: 3, value: "COMISSIONINGENGINEER" };
    }
    static {
      this.ENGINEER = { type: 3, value: "ENGINEER" };
    }
    static {
      this.OWNER = { type: 3, value: "OWNER" };
    }
    static {
      this.CONSULTANT = { type: 3, value: "CONSULTANT" };
    }
    static {
      this.CONSTRUCTIONMANAGER = { type: 3, value: "CONSTRUCTIONMANAGER" };
    }
    static {
      this.FIELDCONSTRUCTIONMANAGER = { type: 3, value: "FIELDCONSTRUCTIONMANAGER" };
    }
    static {
      this.RESELLER = { type: 3, value: "RESELLER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
  }
  IFC2X32.IfcRoleEnum = IfcRoleEnum;
  class IfcRoofTypeEnum {
    static {
      this.FLAT_ROOF = { type: 3, value: "FLAT_ROOF" };
    }
    static {
      this.SHED_ROOF = { type: 3, value: "SHED_ROOF" };
    }
    static {
      this.GABLE_ROOF = { type: 3, value: "GABLE_ROOF" };
    }
    static {
      this.HIP_ROOF = { type: 3, value: "HIP_ROOF" };
    }
    static {
      this.HIPPED_GABLE_ROOF = { type: 3, value: "HIPPED_GABLE_ROOF" };
    }
    static {
      this.GAMBREL_ROOF = { type: 3, value: "GAMBREL_ROOF" };
    }
    static {
      this.MANSARD_ROOF = { type: 3, value: "MANSARD_ROOF" };
    }
    static {
      this.BARREL_ROOF = { type: 3, value: "BARREL_ROOF" };
    }
    static {
      this.RAINBOW_ROOF = { type: 3, value: "RAINBOW_ROOF" };
    }
    static {
      this.BUTTERFLY_ROOF = { type: 3, value: "BUTTERFLY_ROOF" };
    }
    static {
      this.PAVILION_ROOF = { type: 3, value: "PAVILION_ROOF" };
    }
    static {
      this.DOME_ROOF = { type: 3, value: "DOME_ROOF" };
    }
    static {
      this.FREEFORM = { type: 3, value: "FREEFORM" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcRoofTypeEnum = IfcRoofTypeEnum;
  class IfcSIPrefix {
    static {
      this.EXA = { type: 3, value: "EXA" };
    }
    static {
      this.PETA = { type: 3, value: "PETA" };
    }
    static {
      this.TERA = { type: 3, value: "TERA" };
    }
    static {
      this.GIGA = { type: 3, value: "GIGA" };
    }
    static {
      this.MEGA = { type: 3, value: "MEGA" };
    }
    static {
      this.KILO = { type: 3, value: "KILO" };
    }
    static {
      this.HECTO = { type: 3, value: "HECTO" };
    }
    static {
      this.DECA = { type: 3, value: "DECA" };
    }
    static {
      this.DECI = { type: 3, value: "DECI" };
    }
    static {
      this.CENTI = { type: 3, value: "CENTI" };
    }
    static {
      this.MILLI = { type: 3, value: "MILLI" };
    }
    static {
      this.MICRO = { type: 3, value: "MICRO" };
    }
    static {
      this.NANO = { type: 3, value: "NANO" };
    }
    static {
      this.PICO = { type: 3, value: "PICO" };
    }
    static {
      this.FEMTO = { type: 3, value: "FEMTO" };
    }
    static {
      this.ATTO = { type: 3, value: "ATTO" };
    }
  }
  IFC2X32.IfcSIPrefix = IfcSIPrefix;
  class IfcSIUnitName {
    static {
      this.AMPERE = { type: 3, value: "AMPERE" };
    }
    static {
      this.BECQUEREL = { type: 3, value: "BECQUEREL" };
    }
    static {
      this.CANDELA = { type: 3, value: "CANDELA" };
    }
    static {
      this.COULOMB = { type: 3, value: "COULOMB" };
    }
    static {
      this.CUBIC_METRE = { type: 3, value: "CUBIC_METRE" };
    }
    static {
      this.DEGREE_CELSIUS = { type: 3, value: "DEGREE_CELSIUS" };
    }
    static {
      this.FARAD = { type: 3, value: "FARAD" };
    }
    static {
      this.GRAM = { type: 3, value: "GRAM" };
    }
    static {
      this.GRAY = { type: 3, value: "GRAY" };
    }
    static {
      this.HENRY = { type: 3, value: "HENRY" };
    }
    static {
      this.HERTZ = { type: 3, value: "HERTZ" };
    }
    static {
      this.JOULE = { type: 3, value: "JOULE" };
    }
    static {
      this.KELVIN = { type: 3, value: "KELVIN" };
    }
    static {
      this.LUMEN = { type: 3, value: "LUMEN" };
    }
    static {
      this.LUX = { type: 3, value: "LUX" };
    }
    static {
      this.METRE = { type: 3, value: "METRE" };
    }
    static {
      this.MOLE = { type: 3, value: "MOLE" };
    }
    static {
      this.NEWTON = { type: 3, value: "NEWTON" };
    }
    static {
      this.OHM = { type: 3, value: "OHM" };
    }
    static {
      this.PASCAL = { type: 3, value: "PASCAL" };
    }
    static {
      this.RADIAN = { type: 3, value: "RADIAN" };
    }
    static {
      this.SECOND = { type: 3, value: "SECOND" };
    }
    static {
      this.SIEMENS = { type: 3, value: "SIEMENS" };
    }
    static {
      this.SIEVERT = { type: 3, value: "SIEVERT" };
    }
    static {
      this.SQUARE_METRE = { type: 3, value: "SQUARE_METRE" };
    }
    static {
      this.STERADIAN = { type: 3, value: "STERADIAN" };
    }
    static {
      this.TESLA = { type: 3, value: "TESLA" };
    }
    static {
      this.VOLT = { type: 3, value: "VOLT" };
    }
    static {
      this.WATT = { type: 3, value: "WATT" };
    }
    static {
      this.WEBER = { type: 3, value: "WEBER" };
    }
  }
  IFC2X32.IfcSIUnitName = IfcSIUnitName;
  class IfcSanitaryTerminalTypeEnum {
    static {
      this.BATH = { type: 3, value: "BATH" };
    }
    static {
      this.BIDET = { type: 3, value: "BIDET" };
    }
    static {
      this.CISTERN = { type: 3, value: "CISTERN" };
    }
    static {
      this.SHOWER = { type: 3, value: "SHOWER" };
    }
    static {
      this.SINK = { type: 3, value: "SINK" };
    }
    static {
      this.SANITARYFOUNTAIN = { type: 3, value: "SANITARYFOUNTAIN" };
    }
    static {
      this.TOILETPAN = { type: 3, value: "TOILETPAN" };
    }
    static {
      this.URINAL = { type: 3, value: "URINAL" };
    }
    static {
      this.WASHHANDBASIN = { type: 3, value: "WASHHANDBASIN" };
    }
    static {
      this.WCSEAT = { type: 3, value: "WCSEAT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcSanitaryTerminalTypeEnum = IfcSanitaryTerminalTypeEnum;
  class IfcSectionTypeEnum {
    static {
      this.UNIFORM = { type: 3, value: "UNIFORM" };
    }
    static {
      this.TAPERED = { type: 3, value: "TAPERED" };
    }
  }
  IFC2X32.IfcSectionTypeEnum = IfcSectionTypeEnum;
  class IfcSensorTypeEnum {
    static {
      this.CO2SENSOR = { type: 3, value: "CO2SENSOR" };
    }
    static {
      this.FIRESENSOR = { type: 3, value: "FIRESENSOR" };
    }
    static {
      this.FLOWSENSOR = { type: 3, value: "FLOWSENSOR" };
    }
    static {
      this.GASSENSOR = { type: 3, value: "GASSENSOR" };
    }
    static {
      this.HEATSENSOR = { type: 3, value: "HEATSENSOR" };
    }
    static {
      this.HUMIDITYSENSOR = { type: 3, value: "HUMIDITYSENSOR" };
    }
    static {
      this.LIGHTSENSOR = { type: 3, value: "LIGHTSENSOR" };
    }
    static {
      this.MOISTURESENSOR = { type: 3, value: "MOISTURESENSOR" };
    }
    static {
      this.MOVEMENTSENSOR = { type: 3, value: "MOVEMENTSENSOR" };
    }
    static {
      this.PRESSURESENSOR = { type: 3, value: "PRESSURESENSOR" };
    }
    static {
      this.SMOKESENSOR = { type: 3, value: "SMOKESENSOR" };
    }
    static {
      this.SOUNDSENSOR = { type: 3, value: "SOUNDSENSOR" };
    }
    static {
      this.TEMPERATURESENSOR = { type: 3, value: "TEMPERATURESENSOR" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcSensorTypeEnum = IfcSensorTypeEnum;
  class IfcSequenceEnum {
    static {
      this.START_START = { type: 3, value: "START_START" };
    }
    static {
      this.START_FINISH = { type: 3, value: "START_FINISH" };
    }
    static {
      this.FINISH_START = { type: 3, value: "FINISH_START" };
    }
    static {
      this.FINISH_FINISH = { type: 3, value: "FINISH_FINISH" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcSequenceEnum = IfcSequenceEnum;
  class IfcServiceLifeFactorTypeEnum {
    static {
      this.A_QUALITYOFCOMPONENTS = { type: 3, value: "A_QUALITYOFCOMPONENTS" };
    }
    static {
      this.B_DESIGNLEVEL = { type: 3, value: "B_DESIGNLEVEL" };
    }
    static {
      this.C_WORKEXECUTIONLEVEL = { type: 3, value: "C_WORKEXECUTIONLEVEL" };
    }
    static {
      this.D_INDOORENVIRONMENT = { type: 3, value: "D_INDOORENVIRONMENT" };
    }
    static {
      this.E_OUTDOORENVIRONMENT = { type: 3, value: "E_OUTDOORENVIRONMENT" };
    }
    static {
      this.F_INUSECONDITIONS = { type: 3, value: "F_INUSECONDITIONS" };
    }
    static {
      this.G_MAINTENANCELEVEL = { type: 3, value: "G_MAINTENANCELEVEL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcServiceLifeFactorTypeEnum = IfcServiceLifeFactorTypeEnum;
  class IfcServiceLifeTypeEnum {
    static {
      this.ACTUALSERVICELIFE = { type: 3, value: "ACTUALSERVICELIFE" };
    }
    static {
      this.EXPECTEDSERVICELIFE = { type: 3, value: "EXPECTEDSERVICELIFE" };
    }
    static {
      this.OPTIMISTICREFERENCESERVICELIFE = { type: 3, value: "OPTIMISTICREFERENCESERVICELIFE" };
    }
    static {
      this.PESSIMISTICREFERENCESERVICELIFE = { type: 3, value: "PESSIMISTICREFERENCESERVICELIFE" };
    }
    static {
      this.REFERENCESERVICELIFE = { type: 3, value: "REFERENCESERVICELIFE" };
    }
  }
  IFC2X32.IfcServiceLifeTypeEnum = IfcServiceLifeTypeEnum;
  class IfcSlabTypeEnum {
    static {
      this.FLOOR = { type: 3, value: "FLOOR" };
    }
    static {
      this.ROOF = { type: 3, value: "ROOF" };
    }
    static {
      this.LANDING = { type: 3, value: "LANDING" };
    }
    static {
      this.BASESLAB = { type: 3, value: "BASESLAB" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcSlabTypeEnum = IfcSlabTypeEnum;
  class IfcSoundScaleEnum {
    static {
      this.DBA = { type: 3, value: "DBA" };
    }
    static {
      this.DBB = { type: 3, value: "DBB" };
    }
    static {
      this.DBC = { type: 3, value: "DBC" };
    }
    static {
      this.NC = { type: 3, value: "NC" };
    }
    static {
      this.NR = { type: 3, value: "NR" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcSoundScaleEnum = IfcSoundScaleEnum;
  class IfcSpaceHeaterTypeEnum {
    static {
      this.SECTIONALRADIATOR = { type: 3, value: "SECTIONALRADIATOR" };
    }
    static {
      this.PANELRADIATOR = { type: 3, value: "PANELRADIATOR" };
    }
    static {
      this.TUBULARRADIATOR = { type: 3, value: "TUBULARRADIATOR" };
    }
    static {
      this.CONVECTOR = { type: 3, value: "CONVECTOR" };
    }
    static {
      this.BASEBOARDHEATER = { type: 3, value: "BASEBOARDHEATER" };
    }
    static {
      this.FINNEDTUBEUNIT = { type: 3, value: "FINNEDTUBEUNIT" };
    }
    static {
      this.UNITHEATER = { type: 3, value: "UNITHEATER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcSpaceHeaterTypeEnum = IfcSpaceHeaterTypeEnum;
  class IfcSpaceTypeEnum {
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcSpaceTypeEnum = IfcSpaceTypeEnum;
  class IfcStackTerminalTypeEnum {
    static {
      this.BIRDCAGE = { type: 3, value: "BIRDCAGE" };
    }
    static {
      this.COWL = { type: 3, value: "COWL" };
    }
    static {
      this.RAINWATERHOPPER = { type: 3, value: "RAINWATERHOPPER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcStackTerminalTypeEnum = IfcStackTerminalTypeEnum;
  class IfcStairFlightTypeEnum {
    static {
      this.STRAIGHT = { type: 3, value: "STRAIGHT" };
    }
    static {
      this.WINDER = { type: 3, value: "WINDER" };
    }
    static {
      this.SPIRAL = { type: 3, value: "SPIRAL" };
    }
    static {
      this.CURVED = { type: 3, value: "CURVED" };
    }
    static {
      this.FREEFORM = { type: 3, value: "FREEFORM" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcStairFlightTypeEnum = IfcStairFlightTypeEnum;
  class IfcStairTypeEnum {
    static {
      this.STRAIGHT_RUN_STAIR = { type: 3, value: "STRAIGHT_RUN_STAIR" };
    }
    static {
      this.TWO_STRAIGHT_RUN_STAIR = { type: 3, value: "TWO_STRAIGHT_RUN_STAIR" };
    }
    static {
      this.QUARTER_WINDING_STAIR = { type: 3, value: "QUARTER_WINDING_STAIR" };
    }
    static {
      this.QUARTER_TURN_STAIR = { type: 3, value: "QUARTER_TURN_STAIR" };
    }
    static {
      this.HALF_WINDING_STAIR = { type: 3, value: "HALF_WINDING_STAIR" };
    }
    static {
      this.HALF_TURN_STAIR = { type: 3, value: "HALF_TURN_STAIR" };
    }
    static {
      this.TWO_QUARTER_WINDING_STAIR = { type: 3, value: "TWO_QUARTER_WINDING_STAIR" };
    }
    static {
      this.TWO_QUARTER_TURN_STAIR = { type: 3, value: "TWO_QUARTER_TURN_STAIR" };
    }
    static {
      this.THREE_QUARTER_WINDING_STAIR = { type: 3, value: "THREE_QUARTER_WINDING_STAIR" };
    }
    static {
      this.THREE_QUARTER_TURN_STAIR = { type: 3, value: "THREE_QUARTER_TURN_STAIR" };
    }
    static {
      this.SPIRAL_STAIR = { type: 3, value: "SPIRAL_STAIR" };
    }
    static {
      this.DOUBLE_RETURN_STAIR = { type: 3, value: "DOUBLE_RETURN_STAIR" };
    }
    static {
      this.CURVED_RUN_STAIR = { type: 3, value: "CURVED_RUN_STAIR" };
    }
    static {
      this.TWO_CURVED_RUN_STAIR = { type: 3, value: "TWO_CURVED_RUN_STAIR" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcStairTypeEnum = IfcStairTypeEnum;
  class IfcStateEnum {
    static {
      this.READWRITE = { type: 3, value: "READWRITE" };
    }
    static {
      this.READONLY = { type: 3, value: "READONLY" };
    }
    static {
      this.LOCKED = { type: 3, value: "LOCKED" };
    }
    static {
      this.READWRITELOCKED = { type: 3, value: "READWRITELOCKED" };
    }
    static {
      this.READONLYLOCKED = { type: 3, value: "READONLYLOCKED" };
    }
  }
  IFC2X32.IfcStateEnum = IfcStateEnum;
  class IfcStructuralCurveTypeEnum {
    static {
      this.RIGID_JOINED_MEMBER = { type: 3, value: "RIGID_JOINED_MEMBER" };
    }
    static {
      this.PIN_JOINED_MEMBER = { type: 3, value: "PIN_JOINED_MEMBER" };
    }
    static {
      this.CABLE = { type: 3, value: "CABLE" };
    }
    static {
      this.TENSION_MEMBER = { type: 3, value: "TENSION_MEMBER" };
    }
    static {
      this.COMPRESSION_MEMBER = { type: 3, value: "COMPRESSION_MEMBER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcStructuralCurveTypeEnum = IfcStructuralCurveTypeEnum;
  class IfcStructuralSurfaceTypeEnum {
    static {
      this.BENDING_ELEMENT = { type: 3, value: "BENDING_ELEMENT" };
    }
    static {
      this.MEMBRANE_ELEMENT = { type: 3, value: "MEMBRANE_ELEMENT" };
    }
    static {
      this.SHELL = { type: 3, value: "SHELL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcStructuralSurfaceTypeEnum = IfcStructuralSurfaceTypeEnum;
  class IfcSurfaceSide {
    static {
      this.POSITIVE = { type: 3, value: "POSITIVE" };
    }
    static {
      this.NEGATIVE = { type: 3, value: "NEGATIVE" };
    }
    static {
      this.BOTH = { type: 3, value: "BOTH" };
    }
  }
  IFC2X32.IfcSurfaceSide = IfcSurfaceSide;
  class IfcSurfaceTextureEnum {
    static {
      this.BUMP = { type: 3, value: "BUMP" };
    }
    static {
      this.OPACITY = { type: 3, value: "OPACITY" };
    }
    static {
      this.REFLECTION = { type: 3, value: "REFLECTION" };
    }
    static {
      this.SELFILLUMINATION = { type: 3, value: "SELFILLUMINATION" };
    }
    static {
      this.SHININESS = { type: 3, value: "SHININESS" };
    }
    static {
      this.SPECULAR = { type: 3, value: "SPECULAR" };
    }
    static {
      this.TEXTURE = { type: 3, value: "TEXTURE" };
    }
    static {
      this.TRANSPARENCYMAP = { type: 3, value: "TRANSPARENCYMAP" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcSurfaceTextureEnum = IfcSurfaceTextureEnum;
  class IfcSwitchingDeviceTypeEnum {
    static {
      this.CONTACTOR = { type: 3, value: "CONTACTOR" };
    }
    static {
      this.EMERGENCYSTOP = { type: 3, value: "EMERGENCYSTOP" };
    }
    static {
      this.STARTER = { type: 3, value: "STARTER" };
    }
    static {
      this.SWITCHDISCONNECTOR = { type: 3, value: "SWITCHDISCONNECTOR" };
    }
    static {
      this.TOGGLESWITCH = { type: 3, value: "TOGGLESWITCH" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcSwitchingDeviceTypeEnum = IfcSwitchingDeviceTypeEnum;
  class IfcTankTypeEnum {
    static {
      this.PREFORMED = { type: 3, value: "PREFORMED" };
    }
    static {
      this.SECTIONAL = { type: 3, value: "SECTIONAL" };
    }
    static {
      this.EXPANSION = { type: 3, value: "EXPANSION" };
    }
    static {
      this.PRESSUREVESSEL = { type: 3, value: "PRESSUREVESSEL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcTankTypeEnum = IfcTankTypeEnum;
  class IfcTendonTypeEnum {
    static {
      this.STRAND = { type: 3, value: "STRAND" };
    }
    static {
      this.WIRE = { type: 3, value: "WIRE" };
    }
    static {
      this.BAR = { type: 3, value: "BAR" };
    }
    static {
      this.COATED = { type: 3, value: "COATED" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcTendonTypeEnum = IfcTendonTypeEnum;
  class IfcTextPath {
    static {
      this.LEFT = { type: 3, value: "LEFT" };
    }
    static {
      this.RIGHT = { type: 3, value: "RIGHT" };
    }
    static {
      this.UP = { type: 3, value: "UP" };
    }
    static {
      this.DOWN = { type: 3, value: "DOWN" };
    }
  }
  IFC2X32.IfcTextPath = IfcTextPath;
  class IfcThermalLoadSourceEnum {
    static {
      this.PEOPLE = { type: 3, value: "PEOPLE" };
    }
    static {
      this.LIGHTING = { type: 3, value: "LIGHTING" };
    }
    static {
      this.EQUIPMENT = { type: 3, value: "EQUIPMENT" };
    }
    static {
      this.VENTILATIONINDOORAIR = { type: 3, value: "VENTILATIONINDOORAIR" };
    }
    static {
      this.VENTILATIONOUTSIDEAIR = { type: 3, value: "VENTILATIONOUTSIDEAIR" };
    }
    static {
      this.RECIRCULATEDAIR = { type: 3, value: "RECIRCULATEDAIR" };
    }
    static {
      this.EXHAUSTAIR = { type: 3, value: "EXHAUSTAIR" };
    }
    static {
      this.AIREXCHANGERATE = { type: 3, value: "AIREXCHANGERATE" };
    }
    static {
      this.DRYBULBTEMPERATURE = { type: 3, value: "DRYBULBTEMPERATURE" };
    }
    static {
      this.RELATIVEHUMIDITY = { type: 3, value: "RELATIVEHUMIDITY" };
    }
    static {
      this.INFILTRATION = { type: 3, value: "INFILTRATION" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcThermalLoadSourceEnum = IfcThermalLoadSourceEnum;
  class IfcThermalLoadTypeEnum {
    static {
      this.SENSIBLE = { type: 3, value: "SENSIBLE" };
    }
    static {
      this.LATENT = { type: 3, value: "LATENT" };
    }
    static {
      this.RADIANT = { type: 3, value: "RADIANT" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcThermalLoadTypeEnum = IfcThermalLoadTypeEnum;
  class IfcTimeSeriesDataTypeEnum {
    static {
      this.CONTINUOUS = { type: 3, value: "CONTINUOUS" };
    }
    static {
      this.DISCRETE = { type: 3, value: "DISCRETE" };
    }
    static {
      this.DISCRETEBINARY = { type: 3, value: "DISCRETEBINARY" };
    }
    static {
      this.PIECEWISEBINARY = { type: 3, value: "PIECEWISEBINARY" };
    }
    static {
      this.PIECEWISECONSTANT = { type: 3, value: "PIECEWISECONSTANT" };
    }
    static {
      this.PIECEWISECONTINUOUS = { type: 3, value: "PIECEWISECONTINUOUS" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcTimeSeriesDataTypeEnum = IfcTimeSeriesDataTypeEnum;
  class IfcTimeSeriesScheduleTypeEnum {
    static {
      this.ANNUAL = { type: 3, value: "ANNUAL" };
    }
    static {
      this.MONTHLY = { type: 3, value: "MONTHLY" };
    }
    static {
      this.WEEKLY = { type: 3, value: "WEEKLY" };
    }
    static {
      this.DAILY = { type: 3, value: "DAILY" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcTimeSeriesScheduleTypeEnum = IfcTimeSeriesScheduleTypeEnum;
  class IfcTransformerTypeEnum {
    static {
      this.CURRENT = { type: 3, value: "CURRENT" };
    }
    static {
      this.FREQUENCY = { type: 3, value: "FREQUENCY" };
    }
    static {
      this.VOLTAGE = { type: 3, value: "VOLTAGE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcTransformerTypeEnum = IfcTransformerTypeEnum;
  class IfcTransitionCode {
    static {
      this.DISCONTINUOUS = { type: 3, value: "DISCONTINUOUS" };
    }
    static {
      this.CONTINUOUS = { type: 3, value: "CONTINUOUS" };
    }
    static {
      this.CONTSAMEGRADIENT = { type: 3, value: "CONTSAMEGRADIENT" };
    }
    static {
      this.CONTSAMEGRADIENTSAMECURVATURE = { type: 3, value: "CONTSAMEGRADIENTSAMECURVATURE" };
    }
  }
  IFC2X32.IfcTransitionCode = IfcTransitionCode;
  class IfcTransportElementTypeEnum {
    static {
      this.ELEVATOR = { type: 3, value: "ELEVATOR" };
    }
    static {
      this.ESCALATOR = { type: 3, value: "ESCALATOR" };
    }
    static {
      this.MOVINGWALKWAY = { type: 3, value: "MOVINGWALKWAY" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcTransportElementTypeEnum = IfcTransportElementTypeEnum;
  class IfcTrimmingPreference {
    static {
      this.CARTESIAN = { type: 3, value: "CARTESIAN" };
    }
    static {
      this.PARAMETER = { type: 3, value: "PARAMETER" };
    }
    static {
      this.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" };
    }
  }
  IFC2X32.IfcTrimmingPreference = IfcTrimmingPreference;
  class IfcTubeBundleTypeEnum {
    static {
      this.FINNED = { type: 3, value: "FINNED" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcTubeBundleTypeEnum = IfcTubeBundleTypeEnum;
  class IfcUnitEnum {
    static {
      this.ABSORBEDDOSEUNIT = { type: 3, value: "ABSORBEDDOSEUNIT" };
    }
    static {
      this.AMOUNTOFSUBSTANCEUNIT = { type: 3, value: "AMOUNTOFSUBSTANCEUNIT" };
    }
    static {
      this.AREAUNIT = { type: 3, value: "AREAUNIT" };
    }
    static {
      this.DOSEEQUIVALENTUNIT = { type: 3, value: "DOSEEQUIVALENTUNIT" };
    }
    static {
      this.ELECTRICCAPACITANCEUNIT = { type: 3, value: "ELECTRICCAPACITANCEUNIT" };
    }
    static {
      this.ELECTRICCHARGEUNIT = { type: 3, value: "ELECTRICCHARGEUNIT" };
    }
    static {
      this.ELECTRICCONDUCTANCEUNIT = { type: 3, value: "ELECTRICCONDUCTANCEUNIT" };
    }
    static {
      this.ELECTRICCURRENTUNIT = { type: 3, value: "ELECTRICCURRENTUNIT" };
    }
    static {
      this.ELECTRICRESISTANCEUNIT = { type: 3, value: "ELECTRICRESISTANCEUNIT" };
    }
    static {
      this.ELECTRICVOLTAGEUNIT = { type: 3, value: "ELECTRICVOLTAGEUNIT" };
    }
    static {
      this.ENERGYUNIT = { type: 3, value: "ENERGYUNIT" };
    }
    static {
      this.FORCEUNIT = { type: 3, value: "FORCEUNIT" };
    }
    static {
      this.FREQUENCYUNIT = { type: 3, value: "FREQUENCYUNIT" };
    }
    static {
      this.ILLUMINANCEUNIT = { type: 3, value: "ILLUMINANCEUNIT" };
    }
    static {
      this.INDUCTANCEUNIT = { type: 3, value: "INDUCTANCEUNIT" };
    }
    static {
      this.LENGTHUNIT = { type: 3, value: "LENGTHUNIT" };
    }
    static {
      this.LUMINOUSFLUXUNIT = { type: 3, value: "LUMINOUSFLUXUNIT" };
    }
    static {
      this.LUMINOUSINTENSITYUNIT = { type: 3, value: "LUMINOUSINTENSITYUNIT" };
    }
    static {
      this.MAGNETICFLUXDENSITYUNIT = { type: 3, value: "MAGNETICFLUXDENSITYUNIT" };
    }
    static {
      this.MAGNETICFLUXUNIT = { type: 3, value: "MAGNETICFLUXUNIT" };
    }
    static {
      this.MASSUNIT = { type: 3, value: "MASSUNIT" };
    }
    static {
      this.PLANEANGLEUNIT = { type: 3, value: "PLANEANGLEUNIT" };
    }
    static {
      this.POWERUNIT = { type: 3, value: "POWERUNIT" };
    }
    static {
      this.PRESSUREUNIT = { type: 3, value: "PRESSUREUNIT" };
    }
    static {
      this.RADIOACTIVITYUNIT = { type: 3, value: "RADIOACTIVITYUNIT" };
    }
    static {
      this.SOLIDANGLEUNIT = { type: 3, value: "SOLIDANGLEUNIT" };
    }
    static {
      this.THERMODYNAMICTEMPERATUREUNIT = { type: 3, value: "THERMODYNAMICTEMPERATUREUNIT" };
    }
    static {
      this.TIMEUNIT = { type: 3, value: "TIMEUNIT" };
    }
    static {
      this.VOLUMEUNIT = { type: 3, value: "VOLUMEUNIT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
  }
  IFC2X32.IfcUnitEnum = IfcUnitEnum;
  class IfcUnitaryEquipmentTypeEnum {
    static {
      this.AIRHANDLER = { type: 3, value: "AIRHANDLER" };
    }
    static {
      this.AIRCONDITIONINGUNIT = { type: 3, value: "AIRCONDITIONINGUNIT" };
    }
    static {
      this.SPLITSYSTEM = { type: 3, value: "SPLITSYSTEM" };
    }
    static {
      this.ROOFTOPUNIT = { type: 3, value: "ROOFTOPUNIT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcUnitaryEquipmentTypeEnum = IfcUnitaryEquipmentTypeEnum;
  class IfcValveTypeEnum {
    static {
      this.AIRRELEASE = { type: 3, value: "AIRRELEASE" };
    }
    static {
      this.ANTIVACUUM = { type: 3, value: "ANTIVACUUM" };
    }
    static {
      this.CHANGEOVER = { type: 3, value: "CHANGEOVER" };
    }
    static {
      this.CHECK = { type: 3, value: "CHECK" };
    }
    static {
      this.COMMISSIONING = { type: 3, value: "COMMISSIONING" };
    }
    static {
      this.DIVERTING = { type: 3, value: "DIVERTING" };
    }
    static {
      this.DRAWOFFCOCK = { type: 3, value: "DRAWOFFCOCK" };
    }
    static {
      this.DOUBLECHECK = { type: 3, value: "DOUBLECHECK" };
    }
    static {
      this.DOUBLEREGULATING = { type: 3, value: "DOUBLEREGULATING" };
    }
    static {
      this.FAUCET = { type: 3, value: "FAUCET" };
    }
    static {
      this.FLUSHING = { type: 3, value: "FLUSHING" };
    }
    static {
      this.GASCOCK = { type: 3, value: "GASCOCK" };
    }
    static {
      this.GASTAP = { type: 3, value: "GASTAP" };
    }
    static {
      this.ISOLATING = { type: 3, value: "ISOLATING" };
    }
    static {
      this.MIXING = { type: 3, value: "MIXING" };
    }
    static {
      this.PRESSUREREDUCING = { type: 3, value: "PRESSUREREDUCING" };
    }
    static {
      this.PRESSURERELIEF = { type: 3, value: "PRESSURERELIEF" };
    }
    static {
      this.REGULATING = { type: 3, value: "REGULATING" };
    }
    static {
      this.SAFETYCUTOFF = { type: 3, value: "SAFETYCUTOFF" };
    }
    static {
      this.STEAMTRAP = { type: 3, value: "STEAMTRAP" };
    }
    static {
      this.STOPCOCK = { type: 3, value: "STOPCOCK" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcValveTypeEnum = IfcValveTypeEnum;
  class IfcVibrationIsolatorTypeEnum {
    static {
      this.COMPRESSION = { type: 3, value: "COMPRESSION" };
    }
    static {
      this.SPRING = { type: 3, value: "SPRING" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcVibrationIsolatorTypeEnum = IfcVibrationIsolatorTypeEnum;
  class IfcWallTypeEnum {
    static {
      this.STANDARD = { type: 3, value: "STANDARD" };
    }
    static {
      this.POLYGONAL = { type: 3, value: "POLYGONAL" };
    }
    static {
      this.SHEAR = { type: 3, value: "SHEAR" };
    }
    static {
      this.ELEMENTEDWALL = { type: 3, value: "ELEMENTEDWALL" };
    }
    static {
      this.PLUMBINGWALL = { type: 3, value: "PLUMBINGWALL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcWallTypeEnum = IfcWallTypeEnum;
  class IfcWasteTerminalTypeEnum {
    static {
      this.FLOORTRAP = { type: 3, value: "FLOORTRAP" };
    }
    static {
      this.FLOORWASTE = { type: 3, value: "FLOORWASTE" };
    }
    static {
      this.GULLYSUMP = { type: 3, value: "GULLYSUMP" };
    }
    static {
      this.GULLYTRAP = { type: 3, value: "GULLYTRAP" };
    }
    static {
      this.GREASEINTERCEPTOR = { type: 3, value: "GREASEINTERCEPTOR" };
    }
    static {
      this.OILINTERCEPTOR = { type: 3, value: "OILINTERCEPTOR" };
    }
    static {
      this.PETROLINTERCEPTOR = { type: 3, value: "PETROLINTERCEPTOR" };
    }
    static {
      this.ROOFDRAIN = { type: 3, value: "ROOFDRAIN" };
    }
    static {
      this.WASTEDISPOSALUNIT = { type: 3, value: "WASTEDISPOSALUNIT" };
    }
    static {
      this.WASTETRAP = { type: 3, value: "WASTETRAP" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcWasteTerminalTypeEnum = IfcWasteTerminalTypeEnum;
  class IfcWindowPanelOperationEnum {
    static {
      this.SIDEHUNGRIGHTHAND = { type: 3, value: "SIDEHUNGRIGHTHAND" };
    }
    static {
      this.SIDEHUNGLEFTHAND = { type: 3, value: "SIDEHUNGLEFTHAND" };
    }
    static {
      this.TILTANDTURNRIGHTHAND = { type: 3, value: "TILTANDTURNRIGHTHAND" };
    }
    static {
      this.TILTANDTURNLEFTHAND = { type: 3, value: "TILTANDTURNLEFTHAND" };
    }
    static {
      this.TOPHUNG = { type: 3, value: "TOPHUNG" };
    }
    static {
      this.BOTTOMHUNG = { type: 3, value: "BOTTOMHUNG" };
    }
    static {
      this.PIVOTHORIZONTAL = { type: 3, value: "PIVOTHORIZONTAL" };
    }
    static {
      this.PIVOTVERTICAL = { type: 3, value: "PIVOTVERTICAL" };
    }
    static {
      this.SLIDINGHORIZONTAL = { type: 3, value: "SLIDINGHORIZONTAL" };
    }
    static {
      this.SLIDINGVERTICAL = { type: 3, value: "SLIDINGVERTICAL" };
    }
    static {
      this.REMOVABLECASEMENT = { type: 3, value: "REMOVABLECASEMENT" };
    }
    static {
      this.FIXEDCASEMENT = { type: 3, value: "FIXEDCASEMENT" };
    }
    static {
      this.OTHEROPERATION = { type: 3, value: "OTHEROPERATION" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcWindowPanelOperationEnum = IfcWindowPanelOperationEnum;
  class IfcWindowPanelPositionEnum {
    static {
      this.LEFT = { type: 3, value: "LEFT" };
    }
    static {
      this.MIDDLE = { type: 3, value: "MIDDLE" };
    }
    static {
      this.RIGHT = { type: 3, value: "RIGHT" };
    }
    static {
      this.BOTTOM = { type: 3, value: "BOTTOM" };
    }
    static {
      this.TOP = { type: 3, value: "TOP" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcWindowPanelPositionEnum = IfcWindowPanelPositionEnum;
  class IfcWindowStyleConstructionEnum {
    static {
      this.ALUMINIUM = { type: 3, value: "ALUMINIUM" };
    }
    static {
      this.HIGH_GRADE_STEEL = { type: 3, value: "HIGH_GRADE_STEEL" };
    }
    static {
      this.STEEL = { type: 3, value: "STEEL" };
    }
    static {
      this.WOOD = { type: 3, value: "WOOD" };
    }
    static {
      this.ALUMINIUM_WOOD = { type: 3, value: "ALUMINIUM_WOOD" };
    }
    static {
      this.PLASTIC = { type: 3, value: "PLASTIC" };
    }
    static {
      this.OTHER_CONSTRUCTION = { type: 3, value: "OTHER_CONSTRUCTION" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcWindowStyleConstructionEnum = IfcWindowStyleConstructionEnum;
  class IfcWindowStyleOperationEnum {
    static {
      this.SINGLE_PANEL = { type: 3, value: "SINGLE_PANEL" };
    }
    static {
      this.DOUBLE_PANEL_VERTICAL = { type: 3, value: "DOUBLE_PANEL_VERTICAL" };
    }
    static {
      this.DOUBLE_PANEL_HORIZONTAL = { type: 3, value: "DOUBLE_PANEL_HORIZONTAL" };
    }
    static {
      this.TRIPLE_PANEL_VERTICAL = { type: 3, value: "TRIPLE_PANEL_VERTICAL" };
    }
    static {
      this.TRIPLE_PANEL_BOTTOM = { type: 3, value: "TRIPLE_PANEL_BOTTOM" };
    }
    static {
      this.TRIPLE_PANEL_TOP = { type: 3, value: "TRIPLE_PANEL_TOP" };
    }
    static {
      this.TRIPLE_PANEL_LEFT = { type: 3, value: "TRIPLE_PANEL_LEFT" };
    }
    static {
      this.TRIPLE_PANEL_RIGHT = { type: 3, value: "TRIPLE_PANEL_RIGHT" };
    }
    static {
      this.TRIPLE_PANEL_HORIZONTAL = { type: 3, value: "TRIPLE_PANEL_HORIZONTAL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcWindowStyleOperationEnum = IfcWindowStyleOperationEnum;
  class IfcWorkControlTypeEnum {
    static {
      this.ACTUAL = { type: 3, value: "ACTUAL" };
    }
    static {
      this.BASELINE = { type: 3, value: "BASELINE" };
    }
    static {
      this.PLANNED = { type: 3, value: "PLANNED" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC2X32.IfcWorkControlTypeEnum = IfcWorkControlTypeEnum;
  class IfcActorRole extends IfcLineObject {
    constructor(Role, UserDefinedRole, Description) {
      super();
      this.Role = Role;
      this.UserDefinedRole = UserDefinedRole;
      this.Description = Description;
      this.type = 3630933823;
    }
  }
  IFC2X32.IfcActorRole = IfcActorRole;
  class IfcAddress extends IfcLineObject {
    constructor(Purpose, Description, UserDefinedPurpose) {
      super();
      this.Purpose = Purpose;
      this.Description = Description;
      this.UserDefinedPurpose = UserDefinedPurpose;
      this.type = 618182010;
    }
  }
  IFC2X32.IfcAddress = IfcAddress;
  class IfcApplication extends IfcLineObject {
    constructor(ApplicationDeveloper, Version, ApplicationFullName, ApplicationIdentifier) {
      super();
      this.ApplicationDeveloper = ApplicationDeveloper;
      this.Version = Version;
      this.ApplicationFullName = ApplicationFullName;
      this.ApplicationIdentifier = ApplicationIdentifier;
      this.type = 639542469;
    }
  }
  IFC2X32.IfcApplication = IfcApplication;
  class IfcAppliedValue extends IfcLineObject {
    constructor(Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.AppliedValue = AppliedValue;
      this.UnitBasis = UnitBasis;
      this.ApplicableDate = ApplicableDate;
      this.FixedUntilDate = FixedUntilDate;
      this.type = 411424972;
    }
  }
  IFC2X32.IfcAppliedValue = IfcAppliedValue;
  class IfcAppliedValueRelationship extends IfcLineObject {
    constructor(ComponentOfTotal, Components, ArithmeticOperator, Name, Description) {
      super();
      this.ComponentOfTotal = ComponentOfTotal;
      this.Components = Components;
      this.ArithmeticOperator = ArithmeticOperator;
      this.Name = Name;
      this.Description = Description;
      this.type = 1110488051;
    }
  }
  IFC2X32.IfcAppliedValueRelationship = IfcAppliedValueRelationship;
  class IfcApproval extends IfcLineObject {
    constructor(Description, ApprovalDateTime, ApprovalStatus, ApprovalLevel, ApprovalQualifier, Name, Identifier) {
      super();
      this.Description = Description;
      this.ApprovalDateTime = ApprovalDateTime;
      this.ApprovalStatus = ApprovalStatus;
      this.ApprovalLevel = ApprovalLevel;
      this.ApprovalQualifier = ApprovalQualifier;
      this.Name = Name;
      this.Identifier = Identifier;
      this.type = 130549933;
    }
  }
  IFC2X32.IfcApproval = IfcApproval;
  class IfcApprovalActorRelationship extends IfcLineObject {
    constructor(Actor, Approval, Role) {
      super();
      this.Actor = Actor;
      this.Approval = Approval;
      this.Role = Role;
      this.type = 2080292479;
    }
  }
  IFC2X32.IfcApprovalActorRelationship = IfcApprovalActorRelationship;
  class IfcApprovalPropertyRelationship extends IfcLineObject {
    constructor(ApprovedProperties, Approval) {
      super();
      this.ApprovedProperties = ApprovedProperties;
      this.Approval = Approval;
      this.type = 390851274;
    }
  }
  IFC2X32.IfcApprovalPropertyRelationship = IfcApprovalPropertyRelationship;
  class IfcApprovalRelationship extends IfcLineObject {
    constructor(RelatedApproval, RelatingApproval, Description, Name) {
      super();
      this.RelatedApproval = RelatedApproval;
      this.RelatingApproval = RelatingApproval;
      this.Description = Description;
      this.Name = Name;
      this.type = 3869604511;
    }
  }
  IFC2X32.IfcApprovalRelationship = IfcApprovalRelationship;
  class IfcBoundaryCondition extends IfcLineObject {
    constructor(Name) {
      super();
      this.Name = Name;
      this.type = 4037036970;
    }
  }
  IFC2X32.IfcBoundaryCondition = IfcBoundaryCondition;
  class IfcBoundaryEdgeCondition extends IfcBoundaryCondition {
    constructor(Name, LinearStiffnessByLengthX, LinearStiffnessByLengthY, LinearStiffnessByLengthZ, RotationalStiffnessByLengthX, RotationalStiffnessByLengthY, RotationalStiffnessByLengthZ) {
      super(Name);
      this.Name = Name;
      this.LinearStiffnessByLengthX = LinearStiffnessByLengthX;
      this.LinearStiffnessByLengthY = LinearStiffnessByLengthY;
      this.LinearStiffnessByLengthZ = LinearStiffnessByLengthZ;
      this.RotationalStiffnessByLengthX = RotationalStiffnessByLengthX;
      this.RotationalStiffnessByLengthY = RotationalStiffnessByLengthY;
      this.RotationalStiffnessByLengthZ = RotationalStiffnessByLengthZ;
      this.type = 1560379544;
    }
  }
  IFC2X32.IfcBoundaryEdgeCondition = IfcBoundaryEdgeCondition;
  class IfcBoundaryFaceCondition extends IfcBoundaryCondition {
    constructor(Name, LinearStiffnessByAreaX, LinearStiffnessByAreaY, LinearStiffnessByAreaZ) {
      super(Name);
      this.Name = Name;
      this.LinearStiffnessByAreaX = LinearStiffnessByAreaX;
      this.LinearStiffnessByAreaY = LinearStiffnessByAreaY;
      this.LinearStiffnessByAreaZ = LinearStiffnessByAreaZ;
      this.type = 3367102660;
    }
  }
  IFC2X32.IfcBoundaryFaceCondition = IfcBoundaryFaceCondition;
  class IfcBoundaryNodeCondition extends IfcBoundaryCondition {
    constructor(Name, LinearStiffnessX, LinearStiffnessY, LinearStiffnessZ, RotationalStiffnessX, RotationalStiffnessY, RotationalStiffnessZ) {
      super(Name);
      this.Name = Name;
      this.LinearStiffnessX = LinearStiffnessX;
      this.LinearStiffnessY = LinearStiffnessY;
      this.LinearStiffnessZ = LinearStiffnessZ;
      this.RotationalStiffnessX = RotationalStiffnessX;
      this.RotationalStiffnessY = RotationalStiffnessY;
      this.RotationalStiffnessZ = RotationalStiffnessZ;
      this.type = 1387855156;
    }
  }
  IFC2X32.IfcBoundaryNodeCondition = IfcBoundaryNodeCondition;
  class IfcBoundaryNodeConditionWarping extends IfcBoundaryNodeCondition {
    constructor(Name, LinearStiffnessX, LinearStiffnessY, LinearStiffnessZ, RotationalStiffnessX, RotationalStiffnessY, RotationalStiffnessZ, WarpingStiffness) {
      super(Name, LinearStiffnessX, LinearStiffnessY, LinearStiffnessZ, RotationalStiffnessX, RotationalStiffnessY, RotationalStiffnessZ);
      this.Name = Name;
      this.LinearStiffnessX = LinearStiffnessX;
      this.LinearStiffnessY = LinearStiffnessY;
      this.LinearStiffnessZ = LinearStiffnessZ;
      this.RotationalStiffnessX = RotationalStiffnessX;
      this.RotationalStiffnessY = RotationalStiffnessY;
      this.RotationalStiffnessZ = RotationalStiffnessZ;
      this.WarpingStiffness = WarpingStiffness;
      this.type = 2069777674;
    }
  }
  IFC2X32.IfcBoundaryNodeConditionWarping = IfcBoundaryNodeConditionWarping;
  class IfcCalendarDate extends IfcLineObject {
    constructor(DayComponent, MonthComponent, YearComponent) {
      super();
      this.DayComponent = DayComponent;
      this.MonthComponent = MonthComponent;
      this.YearComponent = YearComponent;
      this.type = 622194075;
    }
  }
  IFC2X32.IfcCalendarDate = IfcCalendarDate;
  class IfcClassification extends IfcLineObject {
    constructor(Source, Edition, EditionDate, Name) {
      super();
      this.Source = Source;
      this.Edition = Edition;
      this.EditionDate = EditionDate;
      this.Name = Name;
      this.type = 747523909;
    }
  }
  IFC2X32.IfcClassification = IfcClassification;
  class IfcClassificationItem extends IfcLineObject {
    constructor(Notation, ItemOf, Title) {
      super();
      this.Notation = Notation;
      this.ItemOf = ItemOf;
      this.Title = Title;
      this.type = 1767535486;
    }
  }
  IFC2X32.IfcClassificationItem = IfcClassificationItem;
  class IfcClassificationItemRelationship extends IfcLineObject {
    constructor(RelatingItem, RelatedItems) {
      super();
      this.RelatingItem = RelatingItem;
      this.RelatedItems = RelatedItems;
      this.type = 1098599126;
    }
  }
  IFC2X32.IfcClassificationItemRelationship = IfcClassificationItemRelationship;
  class IfcClassificationNotation extends IfcLineObject {
    constructor(NotationFacets) {
      super();
      this.NotationFacets = NotationFacets;
      this.type = 938368621;
    }
  }
  IFC2X32.IfcClassificationNotation = IfcClassificationNotation;
  class IfcClassificationNotationFacet extends IfcLineObject {
    constructor(NotationValue) {
      super();
      this.NotationValue = NotationValue;
      this.type = 3639012971;
    }
  }
  IFC2X32.IfcClassificationNotationFacet = IfcClassificationNotationFacet;
  class IfcColourSpecification extends IfcLineObject {
    constructor(Name) {
      super();
      this.Name = Name;
      this.type = 3264961684;
    }
  }
  IFC2X32.IfcColourSpecification = IfcColourSpecification;
  class IfcConnectionGeometry extends IfcLineObject {
    constructor() {
      super();
      this.type = 2859738748;
    }
  }
  IFC2X32.IfcConnectionGeometry = IfcConnectionGeometry;
  class IfcConnectionPointGeometry extends IfcConnectionGeometry {
    constructor(PointOnRelatingElement, PointOnRelatedElement) {
      super();
      this.PointOnRelatingElement = PointOnRelatingElement;
      this.PointOnRelatedElement = PointOnRelatedElement;
      this.type = 2614616156;
    }
  }
  IFC2X32.IfcConnectionPointGeometry = IfcConnectionPointGeometry;
  class IfcConnectionPortGeometry extends IfcConnectionGeometry {
    constructor(LocationAtRelatingElement, LocationAtRelatedElement, ProfileOfPort) {
      super();
      this.LocationAtRelatingElement = LocationAtRelatingElement;
      this.LocationAtRelatedElement = LocationAtRelatedElement;
      this.ProfileOfPort = ProfileOfPort;
      this.type = 4257277454;
    }
  }
  IFC2X32.IfcConnectionPortGeometry = IfcConnectionPortGeometry;
  class IfcConnectionSurfaceGeometry extends IfcConnectionGeometry {
    constructor(SurfaceOnRelatingElement, SurfaceOnRelatedElement) {
      super();
      this.SurfaceOnRelatingElement = SurfaceOnRelatingElement;
      this.SurfaceOnRelatedElement = SurfaceOnRelatedElement;
      this.type = 2732653382;
    }
  }
  IFC2X32.IfcConnectionSurfaceGeometry = IfcConnectionSurfaceGeometry;
  class IfcConstraint extends IfcLineObject {
    constructor(Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.ConstraintGrade = ConstraintGrade;
      this.ConstraintSource = ConstraintSource;
      this.CreatingActor = CreatingActor;
      this.CreationTime = CreationTime;
      this.UserDefinedGrade = UserDefinedGrade;
      this.type = 1959218052;
    }
  }
  IFC2X32.IfcConstraint = IfcConstraint;
  class IfcConstraintAggregationRelationship extends IfcLineObject {
    constructor(Name, Description, RelatingConstraint, RelatedConstraints, LogicalAggregator) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.RelatingConstraint = RelatingConstraint;
      this.RelatedConstraints = RelatedConstraints;
      this.LogicalAggregator = LogicalAggregator;
      this.type = 1658513725;
    }
  }
  IFC2X32.IfcConstraintAggregationRelationship = IfcConstraintAggregationRelationship;
  class IfcConstraintClassificationRelationship extends IfcLineObject {
    constructor(ClassifiedConstraint, RelatedClassifications) {
      super();
      this.ClassifiedConstraint = ClassifiedConstraint;
      this.RelatedClassifications = RelatedClassifications;
      this.type = 613356794;
    }
  }
  IFC2X32.IfcConstraintClassificationRelationship = IfcConstraintClassificationRelationship;
  class IfcConstraintRelationship extends IfcLineObject {
    constructor(Name, Description, RelatingConstraint, RelatedConstraints) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.RelatingConstraint = RelatingConstraint;
      this.RelatedConstraints = RelatedConstraints;
      this.type = 347226245;
    }
  }
  IFC2X32.IfcConstraintRelationship = IfcConstraintRelationship;
  class IfcCoordinatedUniversalTimeOffset extends IfcLineObject {
    constructor(HourOffset, MinuteOffset, Sense) {
      super();
      this.HourOffset = HourOffset;
      this.MinuteOffset = MinuteOffset;
      this.Sense = Sense;
      this.type = 1065062679;
    }
  }
  IFC2X32.IfcCoordinatedUniversalTimeOffset = IfcCoordinatedUniversalTimeOffset;
  class IfcCostValue extends IfcAppliedValue {
    constructor(Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate, CostType, Condition) {
      super(Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate);
      this.Name = Name;
      this.Description = Description;
      this.AppliedValue = AppliedValue;
      this.UnitBasis = UnitBasis;
      this.ApplicableDate = ApplicableDate;
      this.FixedUntilDate = FixedUntilDate;
      this.CostType = CostType;
      this.Condition = Condition;
      this.type = 602808272;
    }
  }
  IFC2X32.IfcCostValue = IfcCostValue;
  class IfcCurrencyRelationship extends IfcLineObject {
    constructor(RelatingMonetaryUnit, RelatedMonetaryUnit, ExchangeRate, RateDateTime, RateSource) {
      super();
      this.RelatingMonetaryUnit = RelatingMonetaryUnit;
      this.RelatedMonetaryUnit = RelatedMonetaryUnit;
      this.ExchangeRate = ExchangeRate;
      this.RateDateTime = RateDateTime;
      this.RateSource = RateSource;
      this.type = 539742890;
    }
  }
  IFC2X32.IfcCurrencyRelationship = IfcCurrencyRelationship;
  class IfcCurveStyleFont extends IfcLineObject {
    constructor(Name, PatternList) {
      super();
      this.Name = Name;
      this.PatternList = PatternList;
      this.type = 1105321065;
    }
  }
  IFC2X32.IfcCurveStyleFont = IfcCurveStyleFont;
  class IfcCurveStyleFontAndScaling extends IfcLineObject {
    constructor(Name, CurveFont, CurveFontScaling) {
      super();
      this.Name = Name;
      this.CurveFont = CurveFont;
      this.CurveFontScaling = CurveFontScaling;
      this.type = 2367409068;
    }
  }
  IFC2X32.IfcCurveStyleFontAndScaling = IfcCurveStyleFontAndScaling;
  class IfcCurveStyleFontPattern extends IfcLineObject {
    constructor(VisibleSegmentLength, InvisibleSegmentLength) {
      super();
      this.VisibleSegmentLength = VisibleSegmentLength;
      this.InvisibleSegmentLength = InvisibleSegmentLength;
      this.type = 3510044353;
    }
  }
  IFC2X32.IfcCurveStyleFontPattern = IfcCurveStyleFontPattern;
  class IfcDateAndTime extends IfcLineObject {
    constructor(DateComponent, TimeComponent) {
      super();
      this.DateComponent = DateComponent;
      this.TimeComponent = TimeComponent;
      this.type = 1072939445;
    }
  }
  IFC2X32.IfcDateAndTime = IfcDateAndTime;
  class IfcDerivedUnit extends IfcLineObject {
    constructor(Elements, UnitType, UserDefinedType) {
      super();
      this.Elements = Elements;
      this.UnitType = UnitType;
      this.UserDefinedType = UserDefinedType;
      this.type = 1765591967;
    }
  }
  IFC2X32.IfcDerivedUnit = IfcDerivedUnit;
  class IfcDerivedUnitElement extends IfcLineObject {
    constructor(Unit, Exponent) {
      super();
      this.Unit = Unit;
      this.Exponent = Exponent;
      this.type = 1045800335;
    }
  }
  IFC2X32.IfcDerivedUnitElement = IfcDerivedUnitElement;
  class IfcDimensionalExponents extends IfcLineObject {
    constructor(LengthExponent, MassExponent, TimeExponent, ElectricCurrentExponent, ThermodynamicTemperatureExponent, AmountOfSubstanceExponent, LuminousIntensityExponent) {
      super();
      this.LengthExponent = LengthExponent;
      this.MassExponent = MassExponent;
      this.TimeExponent = TimeExponent;
      this.ElectricCurrentExponent = ElectricCurrentExponent;
      this.ThermodynamicTemperatureExponent = ThermodynamicTemperatureExponent;
      this.AmountOfSubstanceExponent = AmountOfSubstanceExponent;
      this.LuminousIntensityExponent = LuminousIntensityExponent;
      this.type = 2949456006;
    }
  }
  IFC2X32.IfcDimensionalExponents = IfcDimensionalExponents;
  class IfcDocumentElectronicFormat extends IfcLineObject {
    constructor(FileExtension, MimeContentType, MimeSubtype) {
      super();
      this.FileExtension = FileExtension;
      this.MimeContentType = MimeContentType;
      this.MimeSubtype = MimeSubtype;
      this.type = 1376555844;
    }
  }
  IFC2X32.IfcDocumentElectronicFormat = IfcDocumentElectronicFormat;
  class IfcDocumentInformation extends IfcLineObject {
    constructor(DocumentId, Name, Description, DocumentReferences, Purpose, IntendedUse, Scope, Revision, DocumentOwner, Editors, CreationTime, LastRevisionTime, ElectronicFormat, ValidFrom, ValidUntil, Confidentiality, Status) {
      super();
      this.DocumentId = DocumentId;
      this.Name = Name;
      this.Description = Description;
      this.DocumentReferences = DocumentReferences;
      this.Purpose = Purpose;
      this.IntendedUse = IntendedUse;
      this.Scope = Scope;
      this.Revision = Revision;
      this.DocumentOwner = DocumentOwner;
      this.Editors = Editors;
      this.CreationTime = CreationTime;
      this.LastRevisionTime = LastRevisionTime;
      this.ElectronicFormat = ElectronicFormat;
      this.ValidFrom = ValidFrom;
      this.ValidUntil = ValidUntil;
      this.Confidentiality = Confidentiality;
      this.Status = Status;
      this.type = 1154170062;
    }
  }
  IFC2X32.IfcDocumentInformation = IfcDocumentInformation;
  class IfcDocumentInformationRelationship extends IfcLineObject {
    constructor(RelatingDocument, RelatedDocuments, RelationshipType) {
      super();
      this.RelatingDocument = RelatingDocument;
      this.RelatedDocuments = RelatedDocuments;
      this.RelationshipType = RelationshipType;
      this.type = 770865208;
    }
  }
  IFC2X32.IfcDocumentInformationRelationship = IfcDocumentInformationRelationship;
  class IfcDraughtingCalloutRelationship extends IfcLineObject {
    constructor(Name, Description, RelatingDraughtingCallout, RelatedDraughtingCallout) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.RelatingDraughtingCallout = RelatingDraughtingCallout;
      this.RelatedDraughtingCallout = RelatedDraughtingCallout;
      this.type = 3796139169;
    }
  }
  IFC2X32.IfcDraughtingCalloutRelationship = IfcDraughtingCalloutRelationship;
  class IfcEnvironmentalImpactValue extends IfcAppliedValue {
    constructor(Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate, ImpactType, Category, UserDefinedCategory) {
      super(Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate);
      this.Name = Name;
      this.Description = Description;
      this.AppliedValue = AppliedValue;
      this.UnitBasis = UnitBasis;
      this.ApplicableDate = ApplicableDate;
      this.FixedUntilDate = FixedUntilDate;
      this.ImpactType = ImpactType;
      this.Category = Category;
      this.UserDefinedCategory = UserDefinedCategory;
      this.type = 1648886627;
    }
  }
  IFC2X32.IfcEnvironmentalImpactValue = IfcEnvironmentalImpactValue;
  class IfcExternalReference extends IfcLineObject {
    constructor(Location, ItemReference, Name) {
      super();
      this.Location = Location;
      this.ItemReference = ItemReference;
      this.Name = Name;
      this.type = 3200245327;
    }
  }
  IFC2X32.IfcExternalReference = IfcExternalReference;
  class IfcExternallyDefinedHatchStyle extends IfcExternalReference {
    constructor(Location, ItemReference, Name) {
      super(Location, ItemReference, Name);
      this.Location = Location;
      this.ItemReference = ItemReference;
      this.Name = Name;
      this.type = 2242383968;
    }
  }
  IFC2X32.IfcExternallyDefinedHatchStyle = IfcExternallyDefinedHatchStyle;
  class IfcExternallyDefinedSurfaceStyle extends IfcExternalReference {
    constructor(Location, ItemReference, Name) {
      super(Location, ItemReference, Name);
      this.Location = Location;
      this.ItemReference = ItemReference;
      this.Name = Name;
      this.type = 1040185647;
    }
  }
  IFC2X32.IfcExternallyDefinedSurfaceStyle = IfcExternallyDefinedSurfaceStyle;
  class IfcExternallyDefinedSymbol extends IfcExternalReference {
    constructor(Location, ItemReference, Name) {
      super(Location, ItemReference, Name);
      this.Location = Location;
      this.ItemReference = ItemReference;
      this.Name = Name;
      this.type = 3207319532;
    }
  }
  IFC2X32.IfcExternallyDefinedSymbol = IfcExternallyDefinedSymbol;
  class IfcExternallyDefinedTextFont extends IfcExternalReference {
    constructor(Location, ItemReference, Name) {
      super(Location, ItemReference, Name);
      this.Location = Location;
      this.ItemReference = ItemReference;
      this.Name = Name;
      this.type = 3548104201;
    }
  }
  IFC2X32.IfcExternallyDefinedTextFont = IfcExternallyDefinedTextFont;
  class IfcGridAxis extends IfcLineObject {
    constructor(AxisTag, AxisCurve, SameSense) {
      super();
      this.AxisTag = AxisTag;
      this.AxisCurve = AxisCurve;
      this.SameSense = SameSense;
      this.type = 852622518;
    }
  }
  IFC2X32.IfcGridAxis = IfcGridAxis;
  class IfcIrregularTimeSeriesValue extends IfcLineObject {
    constructor(TimeStamp, ListValues) {
      super();
      this.TimeStamp = TimeStamp;
      this.ListValues = ListValues;
      this.type = 3020489413;
    }
  }
  IFC2X32.IfcIrregularTimeSeriesValue = IfcIrregularTimeSeriesValue;
  class IfcLibraryInformation extends IfcLineObject {
    constructor(Name, Version, Publisher, VersionDate, LibraryReference) {
      super();
      this.Name = Name;
      this.Version = Version;
      this.Publisher = Publisher;
      this.VersionDate = VersionDate;
      this.LibraryReference = LibraryReference;
      this.type = 2655187982;
    }
  }
  IFC2X32.IfcLibraryInformation = IfcLibraryInformation;
  class IfcLibraryReference extends IfcExternalReference {
    constructor(Location, ItemReference, Name) {
      super(Location, ItemReference, Name);
      this.Location = Location;
      this.ItemReference = ItemReference;
      this.Name = Name;
      this.type = 3452421091;
    }
  }
  IFC2X32.IfcLibraryReference = IfcLibraryReference;
  class IfcLightDistributionData extends IfcLineObject {
    constructor(MainPlaneAngle, SecondaryPlaneAngle, LuminousIntensity) {
      super();
      this.MainPlaneAngle = MainPlaneAngle;
      this.SecondaryPlaneAngle = SecondaryPlaneAngle;
      this.LuminousIntensity = LuminousIntensity;
      this.type = 4162380809;
    }
  }
  IFC2X32.IfcLightDistributionData = IfcLightDistributionData;
  class IfcLightIntensityDistribution extends IfcLineObject {
    constructor(LightDistributionCurve, DistributionData) {
      super();
      this.LightDistributionCurve = LightDistributionCurve;
      this.DistributionData = DistributionData;
      this.type = 1566485204;
    }
  }
  IFC2X32.IfcLightIntensityDistribution = IfcLightIntensityDistribution;
  class IfcLocalTime extends IfcLineObject {
    constructor(HourComponent, MinuteComponent, SecondComponent, Zone, DaylightSavingOffset) {
      super();
      this.HourComponent = HourComponent;
      this.MinuteComponent = MinuteComponent;
      this.SecondComponent = SecondComponent;
      this.Zone = Zone;
      this.DaylightSavingOffset = DaylightSavingOffset;
      this.type = 30780891;
    }
  }
  IFC2X32.IfcLocalTime = IfcLocalTime;
  class IfcMaterial extends IfcLineObject {
    constructor(Name) {
      super();
      this.Name = Name;
      this.type = 1838606355;
    }
  }
  IFC2X32.IfcMaterial = IfcMaterial;
  class IfcMaterialClassificationRelationship extends IfcLineObject {
    constructor(MaterialClassifications, ClassifiedMaterial) {
      super();
      this.MaterialClassifications = MaterialClassifications;
      this.ClassifiedMaterial = ClassifiedMaterial;
      this.type = 1847130766;
    }
  }
  IFC2X32.IfcMaterialClassificationRelationship = IfcMaterialClassificationRelationship;
  class IfcMaterialLayer extends IfcLineObject {
    constructor(Material, LayerThickness, IsVentilated) {
      super();
      this.Material = Material;
      this.LayerThickness = LayerThickness;
      this.IsVentilated = IsVentilated;
      this.type = 248100487;
    }
  }
  IFC2X32.IfcMaterialLayer = IfcMaterialLayer;
  class IfcMaterialLayerSet extends IfcLineObject {
    constructor(MaterialLayers, LayerSetName) {
      super();
      this.MaterialLayers = MaterialLayers;
      this.LayerSetName = LayerSetName;
      this.type = 3303938423;
    }
  }
  IFC2X32.IfcMaterialLayerSet = IfcMaterialLayerSet;
  class IfcMaterialLayerSetUsage extends IfcLineObject {
    constructor(ForLayerSet, LayerSetDirection, DirectionSense, OffsetFromReferenceLine) {
      super();
      this.ForLayerSet = ForLayerSet;
      this.LayerSetDirection = LayerSetDirection;
      this.DirectionSense = DirectionSense;
      this.OffsetFromReferenceLine = OffsetFromReferenceLine;
      this.type = 1303795690;
    }
  }
  IFC2X32.IfcMaterialLayerSetUsage = IfcMaterialLayerSetUsage;
  class IfcMaterialList extends IfcLineObject {
    constructor(Materials) {
      super();
      this.Materials = Materials;
      this.type = 2199411900;
    }
  }
  IFC2X32.IfcMaterialList = IfcMaterialList;
  class IfcMaterialProperties extends IfcLineObject {
    constructor(Material) {
      super();
      this.Material = Material;
      this.type = 3265635763;
    }
  }
  IFC2X32.IfcMaterialProperties = IfcMaterialProperties;
  class IfcMeasureWithUnit extends IfcLineObject {
    constructor(ValueComponent, UnitComponent) {
      super();
      this.ValueComponent = ValueComponent;
      this.UnitComponent = UnitComponent;
      this.type = 2597039031;
    }
  }
  IFC2X32.IfcMeasureWithUnit = IfcMeasureWithUnit;
  class IfcMechanicalMaterialProperties extends IfcMaterialProperties {
    constructor(Material, DynamicViscosity, YoungModulus, ShearModulus, PoissonRatio, ThermalExpansionCoefficient) {
      super(Material);
      this.Material = Material;
      this.DynamicViscosity = DynamicViscosity;
      this.YoungModulus = YoungModulus;
      this.ShearModulus = ShearModulus;
      this.PoissonRatio = PoissonRatio;
      this.ThermalExpansionCoefficient = ThermalExpansionCoefficient;
      this.type = 4256014907;
    }
  }
  IFC2X32.IfcMechanicalMaterialProperties = IfcMechanicalMaterialProperties;
  class IfcMechanicalSteelMaterialProperties extends IfcMechanicalMaterialProperties {
    constructor(Material, DynamicViscosity, YoungModulus, ShearModulus, PoissonRatio, ThermalExpansionCoefficient, YieldStress, UltimateStress, UltimateStrain, HardeningModule, ProportionalStress, PlasticStrain, Relaxations) {
      super(Material, DynamicViscosity, YoungModulus, ShearModulus, PoissonRatio, ThermalExpansionCoefficient);
      this.Material = Material;
      this.DynamicViscosity = DynamicViscosity;
      this.YoungModulus = YoungModulus;
      this.ShearModulus = ShearModulus;
      this.PoissonRatio = PoissonRatio;
      this.ThermalExpansionCoefficient = ThermalExpansionCoefficient;
      this.YieldStress = YieldStress;
      this.UltimateStress = UltimateStress;
      this.UltimateStrain = UltimateStrain;
      this.HardeningModule = HardeningModule;
      this.ProportionalStress = ProportionalStress;
      this.PlasticStrain = PlasticStrain;
      this.Relaxations = Relaxations;
      this.type = 677618848;
    }
  }
  IFC2X32.IfcMechanicalSteelMaterialProperties = IfcMechanicalSteelMaterialProperties;
  class IfcMetric extends IfcConstraint {
    constructor(Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade, Benchmark, ValueSource, DataValue) {
      super(Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade);
      this.Name = Name;
      this.Description = Description;
      this.ConstraintGrade = ConstraintGrade;
      this.ConstraintSource = ConstraintSource;
      this.CreatingActor = CreatingActor;
      this.CreationTime = CreationTime;
      this.UserDefinedGrade = UserDefinedGrade;
      this.Benchmark = Benchmark;
      this.ValueSource = ValueSource;
      this.DataValue = DataValue;
      this.type = 3368373690;
    }
  }
  IFC2X32.IfcMetric = IfcMetric;
  class IfcMonetaryUnit extends IfcLineObject {
    constructor(Currency) {
      super();
      this.Currency = Currency;
      this.type = 2706619895;
    }
  }
  IFC2X32.IfcMonetaryUnit = IfcMonetaryUnit;
  class IfcNamedUnit extends IfcLineObject {
    constructor(Dimensions, UnitType) {
      super();
      this.Dimensions = Dimensions;
      this.UnitType = UnitType;
      this.type = 1918398963;
    }
  }
  IFC2X32.IfcNamedUnit = IfcNamedUnit;
  class IfcObjectPlacement extends IfcLineObject {
    constructor() {
      super();
      this.type = 3701648758;
    }
  }
  IFC2X32.IfcObjectPlacement = IfcObjectPlacement;
  class IfcObjective extends IfcConstraint {
    constructor(Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade, BenchmarkValues, ResultValues, ObjectiveQualifier, UserDefinedQualifier) {
      super(Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade);
      this.Name = Name;
      this.Description = Description;
      this.ConstraintGrade = ConstraintGrade;
      this.ConstraintSource = ConstraintSource;
      this.CreatingActor = CreatingActor;
      this.CreationTime = CreationTime;
      this.UserDefinedGrade = UserDefinedGrade;
      this.BenchmarkValues = BenchmarkValues;
      this.ResultValues = ResultValues;
      this.ObjectiveQualifier = ObjectiveQualifier;
      this.UserDefinedQualifier = UserDefinedQualifier;
      this.type = 2251480897;
    }
  }
  IFC2X32.IfcObjective = IfcObjective;
  class IfcOpticalMaterialProperties extends IfcMaterialProperties {
    constructor(Material, VisibleTransmittance, SolarTransmittance, ThermalIrTransmittance, ThermalIrEmissivityBack, ThermalIrEmissivityFront, VisibleReflectanceBack, VisibleReflectanceFront, SolarReflectanceFront, SolarReflectanceBack) {
      super(Material);
      this.Material = Material;
      this.VisibleTransmittance = VisibleTransmittance;
      this.SolarTransmittance = SolarTransmittance;
      this.ThermalIrTransmittance = ThermalIrTransmittance;
      this.ThermalIrEmissivityBack = ThermalIrEmissivityBack;
      this.ThermalIrEmissivityFront = ThermalIrEmissivityFront;
      this.VisibleReflectanceBack = VisibleReflectanceBack;
      this.VisibleReflectanceFront = VisibleReflectanceFront;
      this.SolarReflectanceFront = SolarReflectanceFront;
      this.SolarReflectanceBack = SolarReflectanceBack;
      this.type = 1227763645;
    }
  }
  IFC2X32.IfcOpticalMaterialProperties = IfcOpticalMaterialProperties;
  class IfcOrganization extends IfcLineObject {
    constructor(Id, Name, Description, Roles, Addresses) {
      super();
      this.Id = Id;
      this.Name = Name;
      this.Description = Description;
      this.Roles = Roles;
      this.Addresses = Addresses;
      this.type = 4251960020;
    }
  }
  IFC2X32.IfcOrganization = IfcOrganization;
  class IfcOrganizationRelationship extends IfcLineObject {
    constructor(Name, Description, RelatingOrganization, RelatedOrganizations) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.RelatingOrganization = RelatingOrganization;
      this.RelatedOrganizations = RelatedOrganizations;
      this.type = 1411181986;
    }
  }
  IFC2X32.IfcOrganizationRelationship = IfcOrganizationRelationship;
  class IfcOwnerHistory extends IfcLineObject {
    constructor(OwningUser, OwningApplication, State, ChangeAction, LastModifiedDate, LastModifyingUser, LastModifyingApplication, CreationDate) {
      super();
      this.OwningUser = OwningUser;
      this.OwningApplication = OwningApplication;
      this.State = State;
      this.ChangeAction = ChangeAction;
      this.LastModifiedDate = LastModifiedDate;
      this.LastModifyingUser = LastModifyingUser;
      this.LastModifyingApplication = LastModifyingApplication;
      this.CreationDate = CreationDate;
      this.type = 1207048766;
    }
  }
  IFC2X32.IfcOwnerHistory = IfcOwnerHistory;
  class IfcPerson extends IfcLineObject {
    constructor(Id, FamilyName, GivenName, MiddleNames, PrefixTitles, SuffixTitles, Roles, Addresses) {
      super();
      this.Id = Id;
      this.FamilyName = FamilyName;
      this.GivenName = GivenName;
      this.MiddleNames = MiddleNames;
      this.PrefixTitles = PrefixTitles;
      this.SuffixTitles = SuffixTitles;
      this.Roles = Roles;
      this.Addresses = Addresses;
      this.type = 2077209135;
    }
  }
  IFC2X32.IfcPerson = IfcPerson;
  class IfcPersonAndOrganization extends IfcLineObject {
    constructor(ThePerson, TheOrganization, Roles) {
      super();
      this.ThePerson = ThePerson;
      this.TheOrganization = TheOrganization;
      this.Roles = Roles;
      this.type = 101040310;
    }
  }
  IFC2X32.IfcPersonAndOrganization = IfcPersonAndOrganization;
  class IfcPhysicalQuantity extends IfcLineObject {
    constructor(Name, Description) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.type = 2483315170;
    }
  }
  IFC2X32.IfcPhysicalQuantity = IfcPhysicalQuantity;
  class IfcPhysicalSimpleQuantity extends IfcPhysicalQuantity {
    constructor(Name, Description, Unit) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.type = 2226359599;
    }
  }
  IFC2X32.IfcPhysicalSimpleQuantity = IfcPhysicalSimpleQuantity;
  class IfcPostalAddress extends IfcAddress {
    constructor(Purpose, Description, UserDefinedPurpose, InternalLocation, AddressLines, PostalBox, Town, Region, PostalCode, Country) {
      super(Purpose, Description, UserDefinedPurpose);
      this.Purpose = Purpose;
      this.Description = Description;
      this.UserDefinedPurpose = UserDefinedPurpose;
      this.InternalLocation = InternalLocation;
      this.AddressLines = AddressLines;
      this.PostalBox = PostalBox;
      this.Town = Town;
      this.Region = Region;
      this.PostalCode = PostalCode;
      this.Country = Country;
      this.type = 3355820592;
    }
  }
  IFC2X32.IfcPostalAddress = IfcPostalAddress;
  class IfcPreDefinedItem extends IfcLineObject {
    constructor(Name) {
      super();
      this.Name = Name;
      this.type = 3727388367;
    }
  }
  IFC2X32.IfcPreDefinedItem = IfcPreDefinedItem;
  class IfcPreDefinedSymbol extends IfcPreDefinedItem {
    constructor(Name) {
      super(Name);
      this.Name = Name;
      this.type = 990879717;
    }
  }
  IFC2X32.IfcPreDefinedSymbol = IfcPreDefinedSymbol;
  class IfcPreDefinedTerminatorSymbol extends IfcPreDefinedSymbol {
    constructor(Name) {
      super(Name);
      this.Name = Name;
      this.type = 3213052703;
    }
  }
  IFC2X32.IfcPreDefinedTerminatorSymbol = IfcPreDefinedTerminatorSymbol;
  class IfcPreDefinedTextFont extends IfcPreDefinedItem {
    constructor(Name) {
      super(Name);
      this.Name = Name;
      this.type = 1775413392;
    }
  }
  IFC2X32.IfcPreDefinedTextFont = IfcPreDefinedTextFont;
  class IfcPresentationLayerAssignment extends IfcLineObject {
    constructor(Name, Description, AssignedItems, Identifier) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.AssignedItems = AssignedItems;
      this.Identifier = Identifier;
      this.type = 2022622350;
    }
  }
  IFC2X32.IfcPresentationLayerAssignment = IfcPresentationLayerAssignment;
  class IfcPresentationLayerWithStyle extends IfcPresentationLayerAssignment {
    constructor(Name, Description, AssignedItems, Identifier, LayerOn, LayerFrozen, LayerBlocked, LayerStyles) {
      super(Name, Description, AssignedItems, Identifier);
      this.Name = Name;
      this.Description = Description;
      this.AssignedItems = AssignedItems;
      this.Identifier = Identifier;
      this.LayerOn = LayerOn;
      this.LayerFrozen = LayerFrozen;
      this.LayerBlocked = LayerBlocked;
      this.LayerStyles = LayerStyles;
      this.type = 1304840413;
    }
  }
  IFC2X32.IfcPresentationLayerWithStyle = IfcPresentationLayerWithStyle;
  class IfcPresentationStyle extends IfcLineObject {
    constructor(Name) {
      super();
      this.Name = Name;
      this.type = 3119450353;
    }
  }
  IFC2X32.IfcPresentationStyle = IfcPresentationStyle;
  class IfcPresentationStyleAssignment extends IfcLineObject {
    constructor(Styles) {
      super();
      this.Styles = Styles;
      this.type = 2417041796;
    }
  }
  IFC2X32.IfcPresentationStyleAssignment = IfcPresentationStyleAssignment;
  class IfcProductRepresentation extends IfcLineObject {
    constructor(Name, Description, Representations) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.Representations = Representations;
      this.type = 2095639259;
    }
  }
  IFC2X32.IfcProductRepresentation = IfcProductRepresentation;
  class IfcProductsOfCombustionProperties extends IfcMaterialProperties {
    constructor(Material, SpecificHeatCapacity, N20Content, COContent, CO2Content) {
      super(Material);
      this.Material = Material;
      this.SpecificHeatCapacity = SpecificHeatCapacity;
      this.N20Content = N20Content;
      this.COContent = COContent;
      this.CO2Content = CO2Content;
      this.type = 2267347899;
    }
  }
  IFC2X32.IfcProductsOfCombustionProperties = IfcProductsOfCombustionProperties;
  class IfcProfileDef extends IfcLineObject {
    constructor(ProfileType, ProfileName) {
      super();
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.type = 3958567839;
    }
  }
  IFC2X32.IfcProfileDef = IfcProfileDef;
  class IfcProfileProperties extends IfcLineObject {
    constructor(ProfileName, ProfileDefinition) {
      super();
      this.ProfileName = ProfileName;
      this.ProfileDefinition = ProfileDefinition;
      this.type = 2802850158;
    }
  }
  IFC2X32.IfcProfileProperties = IfcProfileProperties;
  class IfcProperty extends IfcLineObject {
    constructor(Name, Description) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.type = 2598011224;
    }
  }
  IFC2X32.IfcProperty = IfcProperty;
  class IfcPropertyConstraintRelationship extends IfcLineObject {
    constructor(RelatingConstraint, RelatedProperties, Name, Description) {
      super();
      this.RelatingConstraint = RelatingConstraint;
      this.RelatedProperties = RelatedProperties;
      this.Name = Name;
      this.Description = Description;
      this.type = 3896028662;
    }
  }
  IFC2X32.IfcPropertyConstraintRelationship = IfcPropertyConstraintRelationship;
  class IfcPropertyDependencyRelationship extends IfcLineObject {
    constructor(DependingProperty, DependantProperty, Name, Description, Expression) {
      super();
      this.DependingProperty = DependingProperty;
      this.DependantProperty = DependantProperty;
      this.Name = Name;
      this.Description = Description;
      this.Expression = Expression;
      this.type = 148025276;
    }
  }
  IFC2X32.IfcPropertyDependencyRelationship = IfcPropertyDependencyRelationship;
  class IfcPropertyEnumeration extends IfcLineObject {
    constructor(Name, EnumerationValues, Unit) {
      super();
      this.Name = Name;
      this.EnumerationValues = EnumerationValues;
      this.Unit = Unit;
      this.type = 3710013099;
    }
  }
  IFC2X32.IfcPropertyEnumeration = IfcPropertyEnumeration;
  class IfcQuantityArea extends IfcPhysicalSimpleQuantity {
    constructor(Name, Description, Unit, AreaValue) {
      super(Name, Description, Unit);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.AreaValue = AreaValue;
      this.type = 2044713172;
    }
  }
  IFC2X32.IfcQuantityArea = IfcQuantityArea;
  class IfcQuantityCount extends IfcPhysicalSimpleQuantity {
    constructor(Name, Description, Unit, CountValue) {
      super(Name, Description, Unit);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.CountValue = CountValue;
      this.type = 2093928680;
    }
  }
  IFC2X32.IfcQuantityCount = IfcQuantityCount;
  class IfcQuantityLength extends IfcPhysicalSimpleQuantity {
    constructor(Name, Description, Unit, LengthValue) {
      super(Name, Description, Unit);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.LengthValue = LengthValue;
      this.type = 931644368;
    }
  }
  IFC2X32.IfcQuantityLength = IfcQuantityLength;
  class IfcQuantityTime extends IfcPhysicalSimpleQuantity {
    constructor(Name, Description, Unit, TimeValue) {
      super(Name, Description, Unit);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.TimeValue = TimeValue;
      this.type = 3252649465;
    }
  }
  IFC2X32.IfcQuantityTime = IfcQuantityTime;
  class IfcQuantityVolume extends IfcPhysicalSimpleQuantity {
    constructor(Name, Description, Unit, VolumeValue) {
      super(Name, Description, Unit);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.VolumeValue = VolumeValue;
      this.type = 2405470396;
    }
  }
  IFC2X32.IfcQuantityVolume = IfcQuantityVolume;
  class IfcQuantityWeight extends IfcPhysicalSimpleQuantity {
    constructor(Name, Description, Unit, WeightValue) {
      super(Name, Description, Unit);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.WeightValue = WeightValue;
      this.type = 825690147;
    }
  }
  IFC2X32.IfcQuantityWeight = IfcQuantityWeight;
  class IfcReferencesValueDocument extends IfcLineObject {
    constructor(ReferencedDocument, ReferencingValues, Name, Description) {
      super();
      this.ReferencedDocument = ReferencedDocument;
      this.ReferencingValues = ReferencingValues;
      this.Name = Name;
      this.Description = Description;
      this.type = 2692823254;
    }
  }
  IFC2X32.IfcReferencesValueDocument = IfcReferencesValueDocument;
  class IfcReinforcementBarProperties extends IfcLineObject {
    constructor(TotalCrossSectionArea, SteelGrade, BarSurface, EffectiveDepth, NominalBarDiameter, BarCount) {
      super();
      this.TotalCrossSectionArea = TotalCrossSectionArea;
      this.SteelGrade = SteelGrade;
      this.BarSurface = BarSurface;
      this.EffectiveDepth = EffectiveDepth;
      this.NominalBarDiameter = NominalBarDiameter;
      this.BarCount = BarCount;
      this.type = 1580146022;
    }
  }
  IFC2X32.IfcReinforcementBarProperties = IfcReinforcementBarProperties;
  class IfcRelaxation extends IfcLineObject {
    constructor(RelaxationValue, InitialStress) {
      super();
      this.RelaxationValue = RelaxationValue;
      this.InitialStress = InitialStress;
      this.type = 1222501353;
    }
  }
  IFC2X32.IfcRelaxation = IfcRelaxation;
  class IfcRepresentation extends IfcLineObject {
    constructor(ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      super();
      this.ContextOfItems = ContextOfItems;
      this.RepresentationIdentifier = RepresentationIdentifier;
      this.RepresentationType = RepresentationType;
      this.Items = Items;
      this.type = 1076942058;
    }
  }
  IFC2X32.IfcRepresentation = IfcRepresentation;
  class IfcRepresentationContext extends IfcLineObject {
    constructor(ContextIdentifier, ContextType) {
      super();
      this.ContextIdentifier = ContextIdentifier;
      this.ContextType = ContextType;
      this.type = 3377609919;
    }
  }
  IFC2X32.IfcRepresentationContext = IfcRepresentationContext;
  class IfcRepresentationItem extends IfcLineObject {
    constructor() {
      super();
      this.type = 3008791417;
    }
  }
  IFC2X32.IfcRepresentationItem = IfcRepresentationItem;
  class IfcRepresentationMap extends IfcLineObject {
    constructor(MappingOrigin, MappedRepresentation) {
      super();
      this.MappingOrigin = MappingOrigin;
      this.MappedRepresentation = MappedRepresentation;
      this.type = 1660063152;
    }
  }
  IFC2X32.IfcRepresentationMap = IfcRepresentationMap;
  class IfcRibPlateProfileProperties extends IfcProfileProperties {
    constructor(ProfileName, ProfileDefinition, Thickness, RibHeight, RibWidth, RibSpacing, Direction) {
      super(ProfileName, ProfileDefinition);
      this.ProfileName = ProfileName;
      this.ProfileDefinition = ProfileDefinition;
      this.Thickness = Thickness;
      this.RibHeight = RibHeight;
      this.RibWidth = RibWidth;
      this.RibSpacing = RibSpacing;
      this.Direction = Direction;
      this.type = 3679540991;
    }
  }
  IFC2X32.IfcRibPlateProfileProperties = IfcRibPlateProfileProperties;
  class IfcRoot extends IfcLineObject {
    constructor(GlobalId, OwnerHistory, Name, Description) {
      super();
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 2341007311;
    }
  }
  IFC2X32.IfcRoot = IfcRoot;
  class IfcSIUnit extends IfcNamedUnit {
    constructor(UnitType, Prefix, Name) {
      super(new Handle(0), UnitType);
      this.UnitType = UnitType;
      this.Prefix = Prefix;
      this.Name = Name;
      this.type = 448429030;
    }
  }
  IFC2X32.IfcSIUnit = IfcSIUnit;
  class IfcSectionProperties extends IfcLineObject {
    constructor(SectionType, StartProfile, EndProfile) {
      super();
      this.SectionType = SectionType;
      this.StartProfile = StartProfile;
      this.EndProfile = EndProfile;
      this.type = 2042790032;
    }
  }
  IFC2X32.IfcSectionProperties = IfcSectionProperties;
  class IfcSectionReinforcementProperties extends IfcLineObject {
    constructor(LongitudinalStartPosition, LongitudinalEndPosition, TransversePosition, ReinforcementRole, SectionDefinition, CrossSectionReinforcementDefinitions) {
      super();
      this.LongitudinalStartPosition = LongitudinalStartPosition;
      this.LongitudinalEndPosition = LongitudinalEndPosition;
      this.TransversePosition = TransversePosition;
      this.ReinforcementRole = ReinforcementRole;
      this.SectionDefinition = SectionDefinition;
      this.CrossSectionReinforcementDefinitions = CrossSectionReinforcementDefinitions;
      this.type = 4165799628;
    }
  }
  IFC2X32.IfcSectionReinforcementProperties = IfcSectionReinforcementProperties;
  class IfcShapeAspect extends IfcLineObject {
    constructor(ShapeRepresentations, Name, Description, ProductDefinitional, PartOfProductDefinitionShape) {
      super();
      this.ShapeRepresentations = ShapeRepresentations;
      this.Name = Name;
      this.Description = Description;
      this.ProductDefinitional = ProductDefinitional;
      this.PartOfProductDefinitionShape = PartOfProductDefinitionShape;
      this.type = 867548509;
    }
  }
  IFC2X32.IfcShapeAspect = IfcShapeAspect;
  class IfcShapeModel extends IfcRepresentation {
    constructor(ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      super(ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      this.ContextOfItems = ContextOfItems;
      this.RepresentationIdentifier = RepresentationIdentifier;
      this.RepresentationType = RepresentationType;
      this.Items = Items;
      this.type = 3982875396;
    }
  }
  IFC2X32.IfcShapeModel = IfcShapeModel;
  class IfcShapeRepresentation extends IfcShapeModel {
    constructor(ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      super(ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      this.ContextOfItems = ContextOfItems;
      this.RepresentationIdentifier = RepresentationIdentifier;
      this.RepresentationType = RepresentationType;
      this.Items = Items;
      this.type = 4240577450;
    }
  }
  IFC2X32.IfcShapeRepresentation = IfcShapeRepresentation;
  class IfcSimpleProperty extends IfcProperty {
    constructor(Name, Description) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.type = 3692461612;
    }
  }
  IFC2X32.IfcSimpleProperty = IfcSimpleProperty;
  class IfcStructuralConnectionCondition extends IfcLineObject {
    constructor(Name) {
      super();
      this.Name = Name;
      this.type = 2273995522;
    }
  }
  IFC2X32.IfcStructuralConnectionCondition = IfcStructuralConnectionCondition;
  class IfcStructuralLoad extends IfcLineObject {
    constructor(Name) {
      super();
      this.Name = Name;
      this.type = 2162789131;
    }
  }
  IFC2X32.IfcStructuralLoad = IfcStructuralLoad;
  class IfcStructuralLoadStatic extends IfcStructuralLoad {
    constructor(Name) {
      super(Name);
      this.Name = Name;
      this.type = 2525727697;
    }
  }
  IFC2X32.IfcStructuralLoadStatic = IfcStructuralLoadStatic;
  class IfcStructuralLoadTemperature extends IfcStructuralLoadStatic {
    constructor(Name, DeltaT_Constant, DeltaT_Y, DeltaT_Z) {
      super(Name);
      this.Name = Name;
      this.DeltaT_Constant = DeltaT_Constant;
      this.DeltaT_Y = DeltaT_Y;
      this.DeltaT_Z = DeltaT_Z;
      this.type = 3408363356;
    }
  }
  IFC2X32.IfcStructuralLoadTemperature = IfcStructuralLoadTemperature;
  class IfcStyleModel extends IfcRepresentation {
    constructor(ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      super(ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      this.ContextOfItems = ContextOfItems;
      this.RepresentationIdentifier = RepresentationIdentifier;
      this.RepresentationType = RepresentationType;
      this.Items = Items;
      this.type = 2830218821;
    }
  }
  IFC2X32.IfcStyleModel = IfcStyleModel;
  class IfcStyledItem extends IfcRepresentationItem {
    constructor(Item, Styles, Name) {
      super();
      this.Item = Item;
      this.Styles = Styles;
      this.Name = Name;
      this.type = 3958052878;
    }
  }
  IFC2X32.IfcStyledItem = IfcStyledItem;
  class IfcStyledRepresentation extends IfcStyleModel {
    constructor(ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      super(ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      this.ContextOfItems = ContextOfItems;
      this.RepresentationIdentifier = RepresentationIdentifier;
      this.RepresentationType = RepresentationType;
      this.Items = Items;
      this.type = 3049322572;
    }
  }
  IFC2X32.IfcStyledRepresentation = IfcStyledRepresentation;
  class IfcSurfaceStyle extends IfcPresentationStyle {
    constructor(Name, Side, Styles) {
      super(Name);
      this.Name = Name;
      this.Side = Side;
      this.Styles = Styles;
      this.type = 1300840506;
    }
  }
  IFC2X32.IfcSurfaceStyle = IfcSurfaceStyle;
  class IfcSurfaceStyleLighting extends IfcLineObject {
    constructor(DiffuseTransmissionColour, DiffuseReflectionColour, TransmissionColour, ReflectanceColour) {
      super();
      this.DiffuseTransmissionColour = DiffuseTransmissionColour;
      this.DiffuseReflectionColour = DiffuseReflectionColour;
      this.TransmissionColour = TransmissionColour;
      this.ReflectanceColour = ReflectanceColour;
      this.type = 3303107099;
    }
  }
  IFC2X32.IfcSurfaceStyleLighting = IfcSurfaceStyleLighting;
  class IfcSurfaceStyleRefraction extends IfcLineObject {
    constructor(RefractionIndex, DispersionFactor) {
      super();
      this.RefractionIndex = RefractionIndex;
      this.DispersionFactor = DispersionFactor;
      this.type = 1607154358;
    }
  }
  IFC2X32.IfcSurfaceStyleRefraction = IfcSurfaceStyleRefraction;
  class IfcSurfaceStyleShading extends IfcLineObject {
    constructor(SurfaceColour) {
      super();
      this.SurfaceColour = SurfaceColour;
      this.type = 846575682;
    }
  }
  IFC2X32.IfcSurfaceStyleShading = IfcSurfaceStyleShading;
  class IfcSurfaceStyleWithTextures extends IfcLineObject {
    constructor(Textures) {
      super();
      this.Textures = Textures;
      this.type = 1351298697;
    }
  }
  IFC2X32.IfcSurfaceStyleWithTextures = IfcSurfaceStyleWithTextures;
  class IfcSurfaceTexture extends IfcLineObject {
    constructor(RepeatS, RepeatT, TextureType, TextureTransform) {
      super();
      this.RepeatS = RepeatS;
      this.RepeatT = RepeatT;
      this.TextureType = TextureType;
      this.TextureTransform = TextureTransform;
      this.type = 626085974;
    }
  }
  IFC2X32.IfcSurfaceTexture = IfcSurfaceTexture;
  class IfcSymbolStyle extends IfcPresentationStyle {
    constructor(Name, StyleOfSymbol) {
      super(Name);
      this.Name = Name;
      this.StyleOfSymbol = StyleOfSymbol;
      this.type = 1290481447;
    }
  }
  IFC2X32.IfcSymbolStyle = IfcSymbolStyle;
  class IfcTable extends IfcLineObject {
    constructor(Name, Rows) {
      super();
      this.Name = Name;
      this.Rows = Rows;
      this.type = 985171141;
    }
  }
  IFC2X32.IfcTable = IfcTable;
  class IfcTableRow extends IfcLineObject {
    constructor(RowCells, IsHeading) {
      super();
      this.RowCells = RowCells;
      this.IsHeading = IsHeading;
      this.type = 531007025;
    }
  }
  IFC2X32.IfcTableRow = IfcTableRow;
  class IfcTelecomAddress extends IfcAddress {
    constructor(Purpose, Description, UserDefinedPurpose, TelephoneNumbers, FacsimileNumbers, PagerNumber, ElectronicMailAddresses, WWWHomePageURL) {
      super(Purpose, Description, UserDefinedPurpose);
      this.Purpose = Purpose;
      this.Description = Description;
      this.UserDefinedPurpose = UserDefinedPurpose;
      this.TelephoneNumbers = TelephoneNumbers;
      this.FacsimileNumbers = FacsimileNumbers;
      this.PagerNumber = PagerNumber;
      this.ElectronicMailAddresses = ElectronicMailAddresses;
      this.WWWHomePageURL = WWWHomePageURL;
      this.type = 912023232;
    }
  }
  IFC2X32.IfcTelecomAddress = IfcTelecomAddress;
  class IfcTextStyle extends IfcPresentationStyle {
    constructor(Name, TextCharacterAppearance, TextStyle, TextFontStyle) {
      super(Name);
      this.Name = Name;
      this.TextCharacterAppearance = TextCharacterAppearance;
      this.TextStyle = TextStyle;
      this.TextFontStyle = TextFontStyle;
      this.type = 1447204868;
    }
  }
  IFC2X32.IfcTextStyle = IfcTextStyle;
  class IfcTextStyleFontModel extends IfcPreDefinedTextFont {
    constructor(Name, FontFamily, FontStyle, FontVariant, FontWeight, FontSize) {
      super(Name);
      this.Name = Name;
      this.FontFamily = FontFamily;
      this.FontStyle = FontStyle;
      this.FontVariant = FontVariant;
      this.FontWeight = FontWeight;
      this.FontSize = FontSize;
      this.type = 1983826977;
    }
  }
  IFC2X32.IfcTextStyleFontModel = IfcTextStyleFontModel;
  class IfcTextStyleForDefinedFont extends IfcLineObject {
    constructor(Colour, BackgroundColour) {
      super();
      this.Colour = Colour;
      this.BackgroundColour = BackgroundColour;
      this.type = 2636378356;
    }
  }
  IFC2X32.IfcTextStyleForDefinedFont = IfcTextStyleForDefinedFont;
  class IfcTextStyleTextModel extends IfcLineObject {
    constructor(TextIndent, TextAlign, TextDecoration, LetterSpacing, WordSpacing, TextTransform, LineHeight) {
      super();
      this.TextIndent = TextIndent;
      this.TextAlign = TextAlign;
      this.TextDecoration = TextDecoration;
      this.LetterSpacing = LetterSpacing;
      this.WordSpacing = WordSpacing;
      this.TextTransform = TextTransform;
      this.LineHeight = LineHeight;
      this.type = 1640371178;
    }
  }
  IFC2X32.IfcTextStyleTextModel = IfcTextStyleTextModel;
  class IfcTextStyleWithBoxCharacteristics extends IfcLineObject {
    constructor(BoxHeight, BoxWidth, BoxSlantAngle, BoxRotateAngle, CharacterSpacing) {
      super();
      this.BoxHeight = BoxHeight;
      this.BoxWidth = BoxWidth;
      this.BoxSlantAngle = BoxSlantAngle;
      this.BoxRotateAngle = BoxRotateAngle;
      this.CharacterSpacing = CharacterSpacing;
      this.type = 1484833681;
    }
  }
  IFC2X32.IfcTextStyleWithBoxCharacteristics = IfcTextStyleWithBoxCharacteristics;
  class IfcTextureCoordinate extends IfcLineObject {
    constructor() {
      super();
      this.type = 280115917;
    }
  }
  IFC2X32.IfcTextureCoordinate = IfcTextureCoordinate;
  class IfcTextureCoordinateGenerator extends IfcTextureCoordinate {
    constructor(Mode, Parameter) {
      super();
      this.Mode = Mode;
      this.Parameter = Parameter;
      this.type = 1742049831;
    }
  }
  IFC2X32.IfcTextureCoordinateGenerator = IfcTextureCoordinateGenerator;
  class IfcTextureMap extends IfcTextureCoordinate {
    constructor(TextureMaps) {
      super();
      this.TextureMaps = TextureMaps;
      this.type = 2552916305;
    }
  }
  IFC2X32.IfcTextureMap = IfcTextureMap;
  class IfcTextureVertex extends IfcLineObject {
    constructor(Coordinates) {
      super();
      this.Coordinates = Coordinates;
      this.type = 1210645708;
    }
  }
  IFC2X32.IfcTextureVertex = IfcTextureVertex;
  class IfcThermalMaterialProperties extends IfcMaterialProperties {
    constructor(Material, SpecificHeatCapacity, BoilingPoint, FreezingPoint, ThermalConductivity) {
      super(Material);
      this.Material = Material;
      this.SpecificHeatCapacity = SpecificHeatCapacity;
      this.BoilingPoint = BoilingPoint;
      this.FreezingPoint = FreezingPoint;
      this.ThermalConductivity = ThermalConductivity;
      this.type = 3317419933;
    }
  }
  IFC2X32.IfcThermalMaterialProperties = IfcThermalMaterialProperties;
  class IfcTimeSeries extends IfcLineObject {
    constructor(Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.StartTime = StartTime;
      this.EndTime = EndTime;
      this.TimeSeriesDataType = TimeSeriesDataType;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.Unit = Unit;
      this.type = 3101149627;
    }
  }
  IFC2X32.IfcTimeSeries = IfcTimeSeries;
  class IfcTimeSeriesReferenceRelationship extends IfcLineObject {
    constructor(ReferencedTimeSeries, TimeSeriesReferences) {
      super();
      this.ReferencedTimeSeries = ReferencedTimeSeries;
      this.TimeSeriesReferences = TimeSeriesReferences;
      this.type = 1718945513;
    }
  }
  IFC2X32.IfcTimeSeriesReferenceRelationship = IfcTimeSeriesReferenceRelationship;
  class IfcTimeSeriesValue extends IfcLineObject {
    constructor(ListValues) {
      super();
      this.ListValues = ListValues;
      this.type = 581633288;
    }
  }
  IFC2X32.IfcTimeSeriesValue = IfcTimeSeriesValue;
  class IfcTopologicalRepresentationItem extends IfcRepresentationItem {
    constructor() {
      super();
      this.type = 1377556343;
    }
  }
  IFC2X32.IfcTopologicalRepresentationItem = IfcTopologicalRepresentationItem;
  class IfcTopologyRepresentation extends IfcShapeModel {
    constructor(ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      super(ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      this.ContextOfItems = ContextOfItems;
      this.RepresentationIdentifier = RepresentationIdentifier;
      this.RepresentationType = RepresentationType;
      this.Items = Items;
      this.type = 1735638870;
    }
  }
  IFC2X32.IfcTopologyRepresentation = IfcTopologyRepresentation;
  class IfcUnitAssignment extends IfcLineObject {
    constructor(Units) {
      super();
      this.Units = Units;
      this.type = 180925521;
    }
  }
  IFC2X32.IfcUnitAssignment = IfcUnitAssignment;
  class IfcVertex extends IfcTopologicalRepresentationItem {
    constructor() {
      super();
      this.type = 2799835756;
    }
  }
  IFC2X32.IfcVertex = IfcVertex;
  class IfcVertexBasedTextureMap extends IfcLineObject {
    constructor(TextureVertices, TexturePoints) {
      super();
      this.TextureVertices = TextureVertices;
      this.TexturePoints = TexturePoints;
      this.type = 3304826586;
    }
  }
  IFC2X32.IfcVertexBasedTextureMap = IfcVertexBasedTextureMap;
  class IfcVertexPoint extends IfcVertex {
    constructor(VertexGeometry) {
      super();
      this.VertexGeometry = VertexGeometry;
      this.type = 1907098498;
    }
  }
  IFC2X32.IfcVertexPoint = IfcVertexPoint;
  class IfcVirtualGridIntersection extends IfcLineObject {
    constructor(IntersectingAxes, OffsetDistances) {
      super();
      this.IntersectingAxes = IntersectingAxes;
      this.OffsetDistances = OffsetDistances;
      this.type = 891718957;
    }
  }
  IFC2X32.IfcVirtualGridIntersection = IfcVirtualGridIntersection;
  class IfcWaterProperties extends IfcMaterialProperties {
    constructor(Material, IsPotable, Hardness, AlkalinityConcentration, AcidityConcentration, ImpuritiesContent, PHLevel, DissolvedSolidsContent) {
      super(Material);
      this.Material = Material;
      this.IsPotable = IsPotable;
      this.Hardness = Hardness;
      this.AlkalinityConcentration = AlkalinityConcentration;
      this.AcidityConcentration = AcidityConcentration;
      this.ImpuritiesContent = ImpuritiesContent;
      this.PHLevel = PHLevel;
      this.DissolvedSolidsContent = DissolvedSolidsContent;
      this.type = 1065908215;
    }
  }
  IFC2X32.IfcWaterProperties = IfcWaterProperties;
  class IfcAnnotationOccurrence extends IfcStyledItem {
    constructor(Item, Styles, Name) {
      super(Item, Styles, Name);
      this.Item = Item;
      this.Styles = Styles;
      this.Name = Name;
      this.type = 2442683028;
    }
  }
  IFC2X32.IfcAnnotationOccurrence = IfcAnnotationOccurrence;
  class IfcAnnotationSurfaceOccurrence extends IfcAnnotationOccurrence {
    constructor(Item, Styles, Name) {
      super(Item, Styles, Name);
      this.Item = Item;
      this.Styles = Styles;
      this.Name = Name;
      this.type = 962685235;
    }
  }
  IFC2X32.IfcAnnotationSurfaceOccurrence = IfcAnnotationSurfaceOccurrence;
  class IfcAnnotationSymbolOccurrence extends IfcAnnotationOccurrence {
    constructor(Item, Styles, Name) {
      super(Item, Styles, Name);
      this.Item = Item;
      this.Styles = Styles;
      this.Name = Name;
      this.type = 3612888222;
    }
  }
  IFC2X32.IfcAnnotationSymbolOccurrence = IfcAnnotationSymbolOccurrence;
  class IfcAnnotationTextOccurrence extends IfcAnnotationOccurrence {
    constructor(Item, Styles, Name) {
      super(Item, Styles, Name);
      this.Item = Item;
      this.Styles = Styles;
      this.Name = Name;
      this.type = 2297822566;
    }
  }
  IFC2X32.IfcAnnotationTextOccurrence = IfcAnnotationTextOccurrence;
  class IfcArbitraryClosedProfileDef extends IfcProfileDef {
    constructor(ProfileType, ProfileName, OuterCurve) {
      super(ProfileType, ProfileName);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.OuterCurve = OuterCurve;
      this.type = 3798115385;
    }
  }
  IFC2X32.IfcArbitraryClosedProfileDef = IfcArbitraryClosedProfileDef;
  class IfcArbitraryOpenProfileDef extends IfcProfileDef {
    constructor(ProfileType, ProfileName, Curve) {
      super(ProfileType, ProfileName);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Curve = Curve;
      this.type = 1310608509;
    }
  }
  IFC2X32.IfcArbitraryOpenProfileDef = IfcArbitraryOpenProfileDef;
  class IfcArbitraryProfileDefWithVoids extends IfcArbitraryClosedProfileDef {
    constructor(ProfileType, ProfileName, OuterCurve, InnerCurves) {
      super(ProfileType, ProfileName, OuterCurve);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.OuterCurve = OuterCurve;
      this.InnerCurves = InnerCurves;
      this.type = 2705031697;
    }
  }
  IFC2X32.IfcArbitraryProfileDefWithVoids = IfcArbitraryProfileDefWithVoids;
  class IfcBlobTexture extends IfcSurfaceTexture {
    constructor(RepeatS, RepeatT, TextureType, TextureTransform, RasterFormat, RasterCode) {
      super(RepeatS, RepeatT, TextureType, TextureTransform);
      this.RepeatS = RepeatS;
      this.RepeatT = RepeatT;
      this.TextureType = TextureType;
      this.TextureTransform = TextureTransform;
      this.RasterFormat = RasterFormat;
      this.RasterCode = RasterCode;
      this.type = 616511568;
    }
  }
  IFC2X32.IfcBlobTexture = IfcBlobTexture;
  class IfcCenterLineProfileDef extends IfcArbitraryOpenProfileDef {
    constructor(ProfileType, ProfileName, Curve, Thickness) {
      super(ProfileType, ProfileName, Curve);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Curve = Curve;
      this.Thickness = Thickness;
      this.type = 3150382593;
    }
  }
  IFC2X32.IfcCenterLineProfileDef = IfcCenterLineProfileDef;
  class IfcClassificationReference extends IfcExternalReference {
    constructor(Location, ItemReference, Name, ReferencedSource) {
      super(Location, ItemReference, Name);
      this.Location = Location;
      this.ItemReference = ItemReference;
      this.Name = Name;
      this.ReferencedSource = ReferencedSource;
      this.type = 647927063;
    }
  }
  IFC2X32.IfcClassificationReference = IfcClassificationReference;
  class IfcColourRgb extends IfcColourSpecification {
    constructor(Name, Red, Green, Blue) {
      super(Name);
      this.Name = Name;
      this.Red = Red;
      this.Green = Green;
      this.Blue = Blue;
      this.type = 776857604;
    }
  }
  IFC2X32.IfcColourRgb = IfcColourRgb;
  class IfcComplexProperty extends IfcProperty {
    constructor(Name, Description, UsageName, HasProperties) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.UsageName = UsageName;
      this.HasProperties = HasProperties;
      this.type = 2542286263;
    }
  }
  IFC2X32.IfcComplexProperty = IfcComplexProperty;
  class IfcCompositeProfileDef extends IfcProfileDef {
    constructor(ProfileType, ProfileName, Profiles, Label) {
      super(ProfileType, ProfileName);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Profiles = Profiles;
      this.Label = Label;
      this.type = 1485152156;
    }
  }
  IFC2X32.IfcCompositeProfileDef = IfcCompositeProfileDef;
  class IfcConnectedFaceSet extends IfcTopologicalRepresentationItem {
    constructor(CfsFaces) {
      super();
      this.CfsFaces = CfsFaces;
      this.type = 370225590;
    }
  }
  IFC2X32.IfcConnectedFaceSet = IfcConnectedFaceSet;
  class IfcConnectionCurveGeometry extends IfcConnectionGeometry {
    constructor(CurveOnRelatingElement, CurveOnRelatedElement) {
      super();
      this.CurveOnRelatingElement = CurveOnRelatingElement;
      this.CurveOnRelatedElement = CurveOnRelatedElement;
      this.type = 1981873012;
    }
  }
  IFC2X32.IfcConnectionCurveGeometry = IfcConnectionCurveGeometry;
  class IfcConnectionPointEccentricity extends IfcConnectionPointGeometry {
    constructor(PointOnRelatingElement, PointOnRelatedElement, EccentricityInX, EccentricityInY, EccentricityInZ) {
      super(PointOnRelatingElement, PointOnRelatedElement);
      this.PointOnRelatingElement = PointOnRelatingElement;
      this.PointOnRelatedElement = PointOnRelatedElement;
      this.EccentricityInX = EccentricityInX;
      this.EccentricityInY = EccentricityInY;
      this.EccentricityInZ = EccentricityInZ;
      this.type = 45288368;
    }
  }
  IFC2X32.IfcConnectionPointEccentricity = IfcConnectionPointEccentricity;
  class IfcContextDependentUnit extends IfcNamedUnit {
    constructor(Dimensions, UnitType, Name) {
      super(Dimensions, UnitType);
      this.Dimensions = Dimensions;
      this.UnitType = UnitType;
      this.Name = Name;
      this.type = 3050246964;
    }
  }
  IFC2X32.IfcContextDependentUnit = IfcContextDependentUnit;
  class IfcConversionBasedUnit extends IfcNamedUnit {
    constructor(Dimensions, UnitType, Name, ConversionFactor) {
      super(Dimensions, UnitType);
      this.Dimensions = Dimensions;
      this.UnitType = UnitType;
      this.Name = Name;
      this.ConversionFactor = ConversionFactor;
      this.type = 2889183280;
    }
  }
  IFC2X32.IfcConversionBasedUnit = IfcConversionBasedUnit;
  class IfcCurveStyle extends IfcPresentationStyle {
    constructor(Name, CurveFont, CurveWidth, CurveColour) {
      super(Name);
      this.Name = Name;
      this.CurveFont = CurveFont;
      this.CurveWidth = CurveWidth;
      this.CurveColour = CurveColour;
      this.type = 3800577675;
    }
  }
  IFC2X32.IfcCurveStyle = IfcCurveStyle;
  class IfcDerivedProfileDef extends IfcProfileDef {
    constructor(ProfileType, ProfileName, ParentProfile, Operator, Label) {
      super(ProfileType, ProfileName);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.ParentProfile = ParentProfile;
      this.Operator = Operator;
      this.Label = Label;
      this.type = 3632507154;
    }
  }
  IFC2X32.IfcDerivedProfileDef = IfcDerivedProfileDef;
  class IfcDimensionCalloutRelationship extends IfcDraughtingCalloutRelationship {
    constructor(Name, Description, RelatingDraughtingCallout, RelatedDraughtingCallout) {
      super(Name, Description, RelatingDraughtingCallout, RelatedDraughtingCallout);
      this.Name = Name;
      this.Description = Description;
      this.RelatingDraughtingCallout = RelatingDraughtingCallout;
      this.RelatedDraughtingCallout = RelatedDraughtingCallout;
      this.type = 2273265877;
    }
  }
  IFC2X32.IfcDimensionCalloutRelationship = IfcDimensionCalloutRelationship;
  class IfcDimensionPair extends IfcDraughtingCalloutRelationship {
    constructor(Name, Description, RelatingDraughtingCallout, RelatedDraughtingCallout) {
      super(Name, Description, RelatingDraughtingCallout, RelatedDraughtingCallout);
      this.Name = Name;
      this.Description = Description;
      this.RelatingDraughtingCallout = RelatingDraughtingCallout;
      this.RelatedDraughtingCallout = RelatedDraughtingCallout;
      this.type = 1694125774;
    }
  }
  IFC2X32.IfcDimensionPair = IfcDimensionPair;
  class IfcDocumentReference extends IfcExternalReference {
    constructor(Location, ItemReference, Name) {
      super(Location, ItemReference, Name);
      this.Location = Location;
      this.ItemReference = ItemReference;
      this.Name = Name;
      this.type = 3732053477;
    }
  }
  IFC2X32.IfcDocumentReference = IfcDocumentReference;
  class IfcDraughtingPreDefinedTextFont extends IfcPreDefinedTextFont {
    constructor(Name) {
      super(Name);
      this.Name = Name;
      this.type = 4170525392;
    }
  }
  IFC2X32.IfcDraughtingPreDefinedTextFont = IfcDraughtingPreDefinedTextFont;
  class IfcEdge extends IfcTopologicalRepresentationItem {
    constructor(EdgeStart, EdgeEnd) {
      super();
      this.EdgeStart = EdgeStart;
      this.EdgeEnd = EdgeEnd;
      this.type = 3900360178;
    }
  }
  IFC2X32.IfcEdge = IfcEdge;
  class IfcEdgeCurve extends IfcEdge {
    constructor(EdgeStart, EdgeEnd, EdgeGeometry, SameSense) {
      super(EdgeStart, EdgeEnd);
      this.EdgeStart = EdgeStart;
      this.EdgeEnd = EdgeEnd;
      this.EdgeGeometry = EdgeGeometry;
      this.SameSense = SameSense;
      this.type = 476780140;
    }
  }
  IFC2X32.IfcEdgeCurve = IfcEdgeCurve;
  class IfcExtendedMaterialProperties extends IfcMaterialProperties {
    constructor(Material, ExtendedProperties, Description, Name) {
      super(Material);
      this.Material = Material;
      this.ExtendedProperties = ExtendedProperties;
      this.Description = Description;
      this.Name = Name;
      this.type = 1860660968;
    }
  }
  IFC2X32.IfcExtendedMaterialProperties = IfcExtendedMaterialProperties;
  class IfcFace extends IfcTopologicalRepresentationItem {
    constructor(Bounds) {
      super();
      this.Bounds = Bounds;
      this.type = 2556980723;
    }
  }
  IFC2X32.IfcFace = IfcFace;
  class IfcFaceBound extends IfcTopologicalRepresentationItem {
    constructor(Bound, Orientation) {
      super();
      this.Bound = Bound;
      this.Orientation = Orientation;
      this.type = 1809719519;
    }
  }
  IFC2X32.IfcFaceBound = IfcFaceBound;
  class IfcFaceOuterBound extends IfcFaceBound {
    constructor(Bound, Orientation) {
      super(Bound, Orientation);
      this.Bound = Bound;
      this.Orientation = Orientation;
      this.type = 803316827;
    }
  }
  IFC2X32.IfcFaceOuterBound = IfcFaceOuterBound;
  class IfcFaceSurface extends IfcFace {
    constructor(Bounds, FaceSurface, SameSense) {
      super(Bounds);
      this.Bounds = Bounds;
      this.FaceSurface = FaceSurface;
      this.SameSense = SameSense;
      this.type = 3008276851;
    }
  }
  IFC2X32.IfcFaceSurface = IfcFaceSurface;
  class IfcFailureConnectionCondition extends IfcStructuralConnectionCondition {
    constructor(Name, TensionFailureX, TensionFailureY, TensionFailureZ, CompressionFailureX, CompressionFailureY, CompressionFailureZ) {
      super(Name);
      this.Name = Name;
      this.TensionFailureX = TensionFailureX;
      this.TensionFailureY = TensionFailureY;
      this.TensionFailureZ = TensionFailureZ;
      this.CompressionFailureX = CompressionFailureX;
      this.CompressionFailureY = CompressionFailureY;
      this.CompressionFailureZ = CompressionFailureZ;
      this.type = 4219587988;
    }
  }
  IFC2X32.IfcFailureConnectionCondition = IfcFailureConnectionCondition;
  class IfcFillAreaStyle extends IfcPresentationStyle {
    constructor(Name, FillStyles) {
      super(Name);
      this.Name = Name;
      this.FillStyles = FillStyles;
      this.type = 738692330;
    }
  }
  IFC2X32.IfcFillAreaStyle = IfcFillAreaStyle;
  class IfcFuelProperties extends IfcMaterialProperties {
    constructor(Material, CombustionTemperature, CarbonContent, LowerHeatingValue, HigherHeatingValue) {
      super(Material);
      this.Material = Material;
      this.CombustionTemperature = CombustionTemperature;
      this.CarbonContent = CarbonContent;
      this.LowerHeatingValue = LowerHeatingValue;
      this.HigherHeatingValue = HigherHeatingValue;
      this.type = 3857492461;
    }
  }
  IFC2X32.IfcFuelProperties = IfcFuelProperties;
  class IfcGeneralMaterialProperties extends IfcMaterialProperties {
    constructor(Material, MolecularWeight, Porosity, MassDensity) {
      super(Material);
      this.Material = Material;
      this.MolecularWeight = MolecularWeight;
      this.Porosity = Porosity;
      this.MassDensity = MassDensity;
      this.type = 803998398;
    }
  }
  IFC2X32.IfcGeneralMaterialProperties = IfcGeneralMaterialProperties;
  class IfcGeneralProfileProperties extends IfcProfileProperties {
    constructor(ProfileName, ProfileDefinition, PhysicalWeight, Perimeter, MinimumPlateThickness, MaximumPlateThickness, CrossSectionArea) {
      super(ProfileName, ProfileDefinition);
      this.ProfileName = ProfileName;
      this.ProfileDefinition = ProfileDefinition;
      this.PhysicalWeight = PhysicalWeight;
      this.Perimeter = Perimeter;
      this.MinimumPlateThickness = MinimumPlateThickness;
      this.MaximumPlateThickness = MaximumPlateThickness;
      this.CrossSectionArea = CrossSectionArea;
      this.type = 1446786286;
    }
  }
  IFC2X32.IfcGeneralProfileProperties = IfcGeneralProfileProperties;
  class IfcGeometricRepresentationContext extends IfcRepresentationContext {
    constructor(ContextIdentifier, ContextType, CoordinateSpaceDimension, Precision, WorldCoordinateSystem, TrueNorth) {
      super(ContextIdentifier, ContextType);
      this.ContextIdentifier = ContextIdentifier;
      this.ContextType = ContextType;
      this.CoordinateSpaceDimension = CoordinateSpaceDimension;
      this.Precision = Precision;
      this.WorldCoordinateSystem = WorldCoordinateSystem;
      this.TrueNorth = TrueNorth;
      this.type = 3448662350;
    }
  }
  IFC2X32.IfcGeometricRepresentationContext = IfcGeometricRepresentationContext;
  class IfcGeometricRepresentationItem extends IfcRepresentationItem {
    constructor() {
      super();
      this.type = 2453401579;
    }
  }
  IFC2X32.IfcGeometricRepresentationItem = IfcGeometricRepresentationItem;
  class IfcGeometricRepresentationSubContext extends IfcGeometricRepresentationContext {
    constructor(ContextIdentifier, ContextType, ParentContext, TargetScale, TargetView, UserDefinedTargetView) {
      super(ContextIdentifier, ContextType, new IfcDimensionCount(0), null, new Handle(0), null);
      this.ContextIdentifier = ContextIdentifier;
      this.ContextType = ContextType;
      this.ParentContext = ParentContext;
      this.TargetScale = TargetScale;
      this.TargetView = TargetView;
      this.UserDefinedTargetView = UserDefinedTargetView;
      this.type = 4142052618;
    }
  }
  IFC2X32.IfcGeometricRepresentationSubContext = IfcGeometricRepresentationSubContext;
  class IfcGeometricSet extends IfcGeometricRepresentationItem {
    constructor(Elements) {
      super();
      this.Elements = Elements;
      this.type = 3590301190;
    }
  }
  IFC2X32.IfcGeometricSet = IfcGeometricSet;
  class IfcGridPlacement extends IfcObjectPlacement {
    constructor(PlacementLocation, PlacementRefDirection) {
      super();
      this.PlacementLocation = PlacementLocation;
      this.PlacementRefDirection = PlacementRefDirection;
      this.type = 178086475;
    }
  }
  IFC2X32.IfcGridPlacement = IfcGridPlacement;
  class IfcHalfSpaceSolid extends IfcGeometricRepresentationItem {
    constructor(BaseSurface, AgreementFlag) {
      super();
      this.BaseSurface = BaseSurface;
      this.AgreementFlag = AgreementFlag;
      this.type = 812098782;
    }
  }
  IFC2X32.IfcHalfSpaceSolid = IfcHalfSpaceSolid;
  class IfcHygroscopicMaterialProperties extends IfcMaterialProperties {
    constructor(Material, UpperVaporResistanceFactor, LowerVaporResistanceFactor, IsothermalMoistureCapacity, VaporPermeability, MoistureDiffusivity) {
      super(Material);
      this.Material = Material;
      this.UpperVaporResistanceFactor = UpperVaporResistanceFactor;
      this.LowerVaporResistanceFactor = LowerVaporResistanceFactor;
      this.IsothermalMoistureCapacity = IsothermalMoistureCapacity;
      this.VaporPermeability = VaporPermeability;
      this.MoistureDiffusivity = MoistureDiffusivity;
      this.type = 2445078500;
    }
  }
  IFC2X32.IfcHygroscopicMaterialProperties = IfcHygroscopicMaterialProperties;
  class IfcImageTexture extends IfcSurfaceTexture {
    constructor(RepeatS, RepeatT, TextureType, TextureTransform, UrlReference) {
      super(RepeatS, RepeatT, TextureType, TextureTransform);
      this.RepeatS = RepeatS;
      this.RepeatT = RepeatT;
      this.TextureType = TextureType;
      this.TextureTransform = TextureTransform;
      this.UrlReference = UrlReference;
      this.type = 3905492369;
    }
  }
  IFC2X32.IfcImageTexture = IfcImageTexture;
  class IfcIrregularTimeSeries extends IfcTimeSeries {
    constructor(Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit, Values) {
      super(Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit);
      this.Name = Name;
      this.Description = Description;
      this.StartTime = StartTime;
      this.EndTime = EndTime;
      this.TimeSeriesDataType = TimeSeriesDataType;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.Unit = Unit;
      this.Values = Values;
      this.type = 3741457305;
    }
  }
  IFC2X32.IfcIrregularTimeSeries = IfcIrregularTimeSeries;
  class IfcLightSource extends IfcGeometricRepresentationItem {
    constructor(Name, LightColour, AmbientIntensity, Intensity) {
      super();
      this.Name = Name;
      this.LightColour = LightColour;
      this.AmbientIntensity = AmbientIntensity;
      this.Intensity = Intensity;
      this.type = 1402838566;
    }
  }
  IFC2X32.IfcLightSource = IfcLightSource;
  class IfcLightSourceAmbient extends IfcLightSource {
    constructor(Name, LightColour, AmbientIntensity, Intensity) {
      super(Name, LightColour, AmbientIntensity, Intensity);
      this.Name = Name;
      this.LightColour = LightColour;
      this.AmbientIntensity = AmbientIntensity;
      this.Intensity = Intensity;
      this.type = 125510826;
    }
  }
  IFC2X32.IfcLightSourceAmbient = IfcLightSourceAmbient;
  class IfcLightSourceDirectional extends IfcLightSource {
    constructor(Name, LightColour, AmbientIntensity, Intensity, Orientation) {
      super(Name, LightColour, AmbientIntensity, Intensity);
      this.Name = Name;
      this.LightColour = LightColour;
      this.AmbientIntensity = AmbientIntensity;
      this.Intensity = Intensity;
      this.Orientation = Orientation;
      this.type = 2604431987;
    }
  }
  IFC2X32.IfcLightSourceDirectional = IfcLightSourceDirectional;
  class IfcLightSourceGoniometric extends IfcLightSource {
    constructor(Name, LightColour, AmbientIntensity, Intensity, Position, ColourAppearance, ColourTemperature, LuminousFlux, LightEmissionSource, LightDistributionDataSource) {
      super(Name, LightColour, AmbientIntensity, Intensity);
      this.Name = Name;
      this.LightColour = LightColour;
      this.AmbientIntensity = AmbientIntensity;
      this.Intensity = Intensity;
      this.Position = Position;
      this.ColourAppearance = ColourAppearance;
      this.ColourTemperature = ColourTemperature;
      this.LuminousFlux = LuminousFlux;
      this.LightEmissionSource = LightEmissionSource;
      this.LightDistributionDataSource = LightDistributionDataSource;
      this.type = 4266656042;
    }
  }
  IFC2X32.IfcLightSourceGoniometric = IfcLightSourceGoniometric;
  class IfcLightSourcePositional extends IfcLightSource {
    constructor(Name, LightColour, AmbientIntensity, Intensity, Position, Radius, ConstantAttenuation, DistanceAttenuation, QuadricAttenuation) {
      super(Name, LightColour, AmbientIntensity, Intensity);
      this.Name = Name;
      this.LightColour = LightColour;
      this.AmbientIntensity = AmbientIntensity;
      this.Intensity = Intensity;
      this.Position = Position;
      this.Radius = Radius;
      this.ConstantAttenuation = ConstantAttenuation;
      this.DistanceAttenuation = DistanceAttenuation;
      this.QuadricAttenuation = QuadricAttenuation;
      this.type = 1520743889;
    }
  }
  IFC2X32.IfcLightSourcePositional = IfcLightSourcePositional;
  class IfcLightSourceSpot extends IfcLightSourcePositional {
    constructor(Name, LightColour, AmbientIntensity, Intensity, Position, Radius, ConstantAttenuation, DistanceAttenuation, QuadricAttenuation, Orientation, ConcentrationExponent, SpreadAngle, BeamWidthAngle) {
      super(Name, LightColour, AmbientIntensity, Intensity, Position, Radius, ConstantAttenuation, DistanceAttenuation, QuadricAttenuation);
      this.Name = Name;
      this.LightColour = LightColour;
      this.AmbientIntensity = AmbientIntensity;
      this.Intensity = Intensity;
      this.Position = Position;
      this.Radius = Radius;
      this.ConstantAttenuation = ConstantAttenuation;
      this.DistanceAttenuation = DistanceAttenuation;
      this.QuadricAttenuation = QuadricAttenuation;
      this.Orientation = Orientation;
      this.ConcentrationExponent = ConcentrationExponent;
      this.SpreadAngle = SpreadAngle;
      this.BeamWidthAngle = BeamWidthAngle;
      this.type = 3422422726;
    }
  }
  IFC2X32.IfcLightSourceSpot = IfcLightSourceSpot;
  class IfcLocalPlacement extends IfcObjectPlacement {
    constructor(PlacementRelTo, RelativePlacement) {
      super();
      this.PlacementRelTo = PlacementRelTo;
      this.RelativePlacement = RelativePlacement;
      this.type = 2624227202;
    }
  }
  IFC2X32.IfcLocalPlacement = IfcLocalPlacement;
  class IfcLoop extends IfcTopologicalRepresentationItem {
    constructor() {
      super();
      this.type = 1008929658;
    }
  }
  IFC2X32.IfcLoop = IfcLoop;
  class IfcMappedItem extends IfcRepresentationItem {
    constructor(MappingSource, MappingTarget) {
      super();
      this.MappingSource = MappingSource;
      this.MappingTarget = MappingTarget;
      this.type = 2347385850;
    }
  }
  IFC2X32.IfcMappedItem = IfcMappedItem;
  class IfcMaterialDefinitionRepresentation extends IfcProductRepresentation {
    constructor(Name, Description, Representations, RepresentedMaterial) {
      super(Name, Description, Representations);
      this.Name = Name;
      this.Description = Description;
      this.Representations = Representations;
      this.RepresentedMaterial = RepresentedMaterial;
      this.type = 2022407955;
    }
  }
  IFC2X32.IfcMaterialDefinitionRepresentation = IfcMaterialDefinitionRepresentation;
  class IfcMechanicalConcreteMaterialProperties extends IfcMechanicalMaterialProperties {
    constructor(Material, DynamicViscosity, YoungModulus, ShearModulus, PoissonRatio, ThermalExpansionCoefficient, CompressiveStrength, MaxAggregateSize, AdmixturesDescription, Workability, ProtectivePoreRatio, WaterImpermeability) {
      super(Material, DynamicViscosity, YoungModulus, ShearModulus, PoissonRatio, ThermalExpansionCoefficient);
      this.Material = Material;
      this.DynamicViscosity = DynamicViscosity;
      this.YoungModulus = YoungModulus;
      this.ShearModulus = ShearModulus;
      this.PoissonRatio = PoissonRatio;
      this.ThermalExpansionCoefficient = ThermalExpansionCoefficient;
      this.CompressiveStrength = CompressiveStrength;
      this.MaxAggregateSize = MaxAggregateSize;
      this.AdmixturesDescription = AdmixturesDescription;
      this.Workability = Workability;
      this.ProtectivePoreRatio = ProtectivePoreRatio;
      this.WaterImpermeability = WaterImpermeability;
      this.type = 1430189142;
    }
  }
  IFC2X32.IfcMechanicalConcreteMaterialProperties = IfcMechanicalConcreteMaterialProperties;
  class IfcObjectDefinition extends IfcRoot {
    constructor(GlobalId, OwnerHistory, Name, Description) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 219451334;
    }
  }
  IFC2X32.IfcObjectDefinition = IfcObjectDefinition;
  class IfcOneDirectionRepeatFactor extends IfcGeometricRepresentationItem {
    constructor(RepeatFactor) {
      super();
      this.RepeatFactor = RepeatFactor;
      this.type = 2833995503;
    }
  }
  IFC2X32.IfcOneDirectionRepeatFactor = IfcOneDirectionRepeatFactor;
  class IfcOpenShell extends IfcConnectedFaceSet {
    constructor(CfsFaces) {
      super(CfsFaces);
      this.CfsFaces = CfsFaces;
      this.type = 2665983363;
    }
  }
  IFC2X32.IfcOpenShell = IfcOpenShell;
  class IfcOrientedEdge extends IfcEdge {
    constructor(EdgeElement, Orientation) {
      super(new Handle(0), new Handle(0));
      this.EdgeElement = EdgeElement;
      this.Orientation = Orientation;
      this.type = 1029017970;
    }
  }
  IFC2X32.IfcOrientedEdge = IfcOrientedEdge;
  class IfcParameterizedProfileDef extends IfcProfileDef {
    constructor(ProfileType, ProfileName, Position) {
      super(ProfileType, ProfileName);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.type = 2529465313;
    }
  }
  IFC2X32.IfcParameterizedProfileDef = IfcParameterizedProfileDef;
  class IfcPath extends IfcTopologicalRepresentationItem {
    constructor(EdgeList) {
      super();
      this.EdgeList = EdgeList;
      this.type = 2519244187;
    }
  }
  IFC2X32.IfcPath = IfcPath;
  class IfcPhysicalComplexQuantity extends IfcPhysicalQuantity {
    constructor(Name, Description, HasQuantities, Discrimination, Quality, Usage) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.HasQuantities = HasQuantities;
      this.Discrimination = Discrimination;
      this.Quality = Quality;
      this.Usage = Usage;
      this.type = 3021840470;
    }
  }
  IFC2X32.IfcPhysicalComplexQuantity = IfcPhysicalComplexQuantity;
  class IfcPixelTexture extends IfcSurfaceTexture {
    constructor(RepeatS, RepeatT, TextureType, TextureTransform, Width, Height, ColourComponents, Pixel) {
      super(RepeatS, RepeatT, TextureType, TextureTransform);
      this.RepeatS = RepeatS;
      this.RepeatT = RepeatT;
      this.TextureType = TextureType;
      this.TextureTransform = TextureTransform;
      this.Width = Width;
      this.Height = Height;
      this.ColourComponents = ColourComponents;
      this.Pixel = Pixel;
      this.type = 597895409;
    }
  }
  IFC2X32.IfcPixelTexture = IfcPixelTexture;
  class IfcPlacement extends IfcGeometricRepresentationItem {
    constructor(Location) {
      super();
      this.Location = Location;
      this.type = 2004835150;
    }
  }
  IFC2X32.IfcPlacement = IfcPlacement;
  class IfcPlanarExtent extends IfcGeometricRepresentationItem {
    constructor(SizeInX, SizeInY) {
      super();
      this.SizeInX = SizeInX;
      this.SizeInY = SizeInY;
      this.type = 1663979128;
    }
  }
  IFC2X32.IfcPlanarExtent = IfcPlanarExtent;
  class IfcPoint extends IfcGeometricRepresentationItem {
    constructor() {
      super();
      this.type = 2067069095;
    }
  }
  IFC2X32.IfcPoint = IfcPoint;
  class IfcPointOnCurve extends IfcPoint {
    constructor(BasisCurve, PointParameter) {
      super();
      this.BasisCurve = BasisCurve;
      this.PointParameter = PointParameter;
      this.type = 4022376103;
    }
  }
  IFC2X32.IfcPointOnCurve = IfcPointOnCurve;
  class IfcPointOnSurface extends IfcPoint {
    constructor(BasisSurface, PointParameterU, PointParameterV) {
      super();
      this.BasisSurface = BasisSurface;
      this.PointParameterU = PointParameterU;
      this.PointParameterV = PointParameterV;
      this.type = 1423911732;
    }
  }
  IFC2X32.IfcPointOnSurface = IfcPointOnSurface;
  class IfcPolyLoop extends IfcLoop {
    constructor(Polygon) {
      super();
      this.Polygon = Polygon;
      this.type = 2924175390;
    }
  }
  IFC2X32.IfcPolyLoop = IfcPolyLoop;
  class IfcPolygonalBoundedHalfSpace extends IfcHalfSpaceSolid {
    constructor(BaseSurface, AgreementFlag, Position, PolygonalBoundary) {
      super(BaseSurface, AgreementFlag);
      this.BaseSurface = BaseSurface;
      this.AgreementFlag = AgreementFlag;
      this.Position = Position;
      this.PolygonalBoundary = PolygonalBoundary;
      this.type = 2775532180;
    }
  }
  IFC2X32.IfcPolygonalBoundedHalfSpace = IfcPolygonalBoundedHalfSpace;
  class IfcPreDefinedColour extends IfcPreDefinedItem {
    constructor(Name) {
      super(Name);
      this.Name = Name;
      this.type = 759155922;
    }
  }
  IFC2X32.IfcPreDefinedColour = IfcPreDefinedColour;
  class IfcPreDefinedCurveFont extends IfcPreDefinedItem {
    constructor(Name) {
      super(Name);
      this.Name = Name;
      this.type = 2559016684;
    }
  }
  IFC2X32.IfcPreDefinedCurveFont = IfcPreDefinedCurveFont;
  class IfcPreDefinedDimensionSymbol extends IfcPreDefinedSymbol {
    constructor(Name) {
      super(Name);
      this.Name = Name;
      this.type = 433424934;
    }
  }
  IFC2X32.IfcPreDefinedDimensionSymbol = IfcPreDefinedDimensionSymbol;
  class IfcPreDefinedPointMarkerSymbol extends IfcPreDefinedSymbol {
    constructor(Name) {
      super(Name);
      this.Name = Name;
      this.type = 179317114;
    }
  }
  IFC2X32.IfcPreDefinedPointMarkerSymbol = IfcPreDefinedPointMarkerSymbol;
  class IfcProductDefinitionShape extends IfcProductRepresentation {
    constructor(Name, Description, Representations) {
      super(Name, Description, Representations);
      this.Name = Name;
      this.Description = Description;
      this.Representations = Representations;
      this.type = 673634403;
    }
  }
  IFC2X32.IfcProductDefinitionShape = IfcProductDefinitionShape;
  class IfcPropertyBoundedValue extends IfcSimpleProperty {
    constructor(Name, Description, UpperBoundValue, LowerBoundValue, Unit) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.UpperBoundValue = UpperBoundValue;
      this.LowerBoundValue = LowerBoundValue;
      this.Unit = Unit;
      this.type = 871118103;
    }
  }
  IFC2X32.IfcPropertyBoundedValue = IfcPropertyBoundedValue;
  class IfcPropertyDefinition extends IfcRoot {
    constructor(GlobalId, OwnerHistory, Name, Description) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 1680319473;
    }
  }
  IFC2X32.IfcPropertyDefinition = IfcPropertyDefinition;
  class IfcPropertyEnumeratedValue extends IfcSimpleProperty {
    constructor(Name, Description, EnumerationValues, EnumerationReference) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.EnumerationValues = EnumerationValues;
      this.EnumerationReference = EnumerationReference;
      this.type = 4166981789;
    }
  }
  IFC2X32.IfcPropertyEnumeratedValue = IfcPropertyEnumeratedValue;
  class IfcPropertyListValue extends IfcSimpleProperty {
    constructor(Name, Description, ListValues, Unit) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.ListValues = ListValues;
      this.Unit = Unit;
      this.type = 2752243245;
    }
  }
  IFC2X32.IfcPropertyListValue = IfcPropertyListValue;
  class IfcPropertyReferenceValue extends IfcSimpleProperty {
    constructor(Name, Description, UsageName, PropertyReference) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.UsageName = UsageName;
      this.PropertyReference = PropertyReference;
      this.type = 941946838;
    }
  }
  IFC2X32.IfcPropertyReferenceValue = IfcPropertyReferenceValue;
  class IfcPropertySetDefinition extends IfcPropertyDefinition {
    constructor(GlobalId, OwnerHistory, Name, Description) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 3357820518;
    }
  }
  IFC2X32.IfcPropertySetDefinition = IfcPropertySetDefinition;
  class IfcPropertySingleValue extends IfcSimpleProperty {
    constructor(Name, Description, NominalValue, Unit) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.NominalValue = NominalValue;
      this.Unit = Unit;
      this.type = 3650150729;
    }
  }
  IFC2X32.IfcPropertySingleValue = IfcPropertySingleValue;
  class IfcPropertyTableValue extends IfcSimpleProperty {
    constructor(Name, Description, DefiningValues, DefinedValues, Expression, DefiningUnit, DefinedUnit) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.DefiningValues = DefiningValues;
      this.DefinedValues = DefinedValues;
      this.Expression = Expression;
      this.DefiningUnit = DefiningUnit;
      this.DefinedUnit = DefinedUnit;
      this.type = 110355661;
    }
  }
  IFC2X32.IfcPropertyTableValue = IfcPropertyTableValue;
  class IfcRectangleProfileDef extends IfcParameterizedProfileDef {
    constructor(ProfileType, ProfileName, Position, XDim, YDim) {
      super(ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.XDim = XDim;
      this.YDim = YDim;
      this.type = 3615266464;
    }
  }
  IFC2X32.IfcRectangleProfileDef = IfcRectangleProfileDef;
  class IfcRegularTimeSeries extends IfcTimeSeries {
    constructor(Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit, TimeStep, Values) {
      super(Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit);
      this.Name = Name;
      this.Description = Description;
      this.StartTime = StartTime;
      this.EndTime = EndTime;
      this.TimeSeriesDataType = TimeSeriesDataType;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.Unit = Unit;
      this.TimeStep = TimeStep;
      this.Values = Values;
      this.type = 3413951693;
    }
  }
  IFC2X32.IfcRegularTimeSeries = IfcRegularTimeSeries;
  class IfcReinforcementDefinitionProperties extends IfcPropertySetDefinition {
    constructor(GlobalId, OwnerHistory, Name, Description, DefinitionType, ReinforcementSectionDefinitions) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.DefinitionType = DefinitionType;
      this.ReinforcementSectionDefinitions = ReinforcementSectionDefinitions;
      this.type = 3765753017;
    }
  }
  IFC2X32.IfcReinforcementDefinitionProperties = IfcReinforcementDefinitionProperties;
  class IfcRelationship extends IfcRoot {
    constructor(GlobalId, OwnerHistory, Name, Description) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 478536968;
    }
  }
  IFC2X32.IfcRelationship = IfcRelationship;
  class IfcRoundedRectangleProfileDef extends IfcRectangleProfileDef {
    constructor(ProfileType, ProfileName, Position, XDim, YDim, RoundingRadius) {
      super(ProfileType, ProfileName, Position, XDim, YDim);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.XDim = XDim;
      this.YDim = YDim;
      this.RoundingRadius = RoundingRadius;
      this.type = 2778083089;
    }
  }
  IFC2X32.IfcRoundedRectangleProfileDef = IfcRoundedRectangleProfileDef;
  class IfcSectionedSpine extends IfcGeometricRepresentationItem {
    constructor(SpineCurve, CrossSections, CrossSectionPositions) {
      super();
      this.SpineCurve = SpineCurve;
      this.CrossSections = CrossSections;
      this.CrossSectionPositions = CrossSectionPositions;
      this.type = 1509187699;
    }
  }
  IFC2X32.IfcSectionedSpine = IfcSectionedSpine;
  class IfcServiceLifeFactor extends IfcPropertySetDefinition {
    constructor(GlobalId, OwnerHistory, Name, Description, PredefinedType, UpperValue, MostUsedValue, LowerValue) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.PredefinedType = PredefinedType;
      this.UpperValue = UpperValue;
      this.MostUsedValue = MostUsedValue;
      this.LowerValue = LowerValue;
      this.type = 2411513650;
    }
  }
  IFC2X32.IfcServiceLifeFactor = IfcServiceLifeFactor;
  class IfcShellBasedSurfaceModel extends IfcGeometricRepresentationItem {
    constructor(SbsmBoundary) {
      super();
      this.SbsmBoundary = SbsmBoundary;
      this.type = 4124623270;
    }
  }
  IFC2X32.IfcShellBasedSurfaceModel = IfcShellBasedSurfaceModel;
  class IfcSlippageConnectionCondition extends IfcStructuralConnectionCondition {
    constructor(Name, SlippageX, SlippageY, SlippageZ) {
      super(Name);
      this.Name = Name;
      this.SlippageX = SlippageX;
      this.SlippageY = SlippageY;
      this.SlippageZ = SlippageZ;
      this.type = 2609359061;
    }
  }
  IFC2X32.IfcSlippageConnectionCondition = IfcSlippageConnectionCondition;
  class IfcSolidModel extends IfcGeometricRepresentationItem {
    constructor() {
      super();
      this.type = 723233188;
    }
  }
  IFC2X32.IfcSolidModel = IfcSolidModel;
  class IfcSoundProperties extends IfcPropertySetDefinition {
    constructor(GlobalId, OwnerHistory, Name, Description, IsAttenuating, SoundScale, SoundValues) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.IsAttenuating = IsAttenuating;
      this.SoundScale = SoundScale;
      this.SoundValues = SoundValues;
      this.type = 2485662743;
    }
  }
  IFC2X32.IfcSoundProperties = IfcSoundProperties;
  class IfcSoundValue extends IfcPropertySetDefinition {
    constructor(GlobalId, OwnerHistory, Name, Description, SoundLevelTimeSeries, Frequency, SoundLevelSingleValue) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.SoundLevelTimeSeries = SoundLevelTimeSeries;
      this.Frequency = Frequency;
      this.SoundLevelSingleValue = SoundLevelSingleValue;
      this.type = 1202362311;
    }
  }
  IFC2X32.IfcSoundValue = IfcSoundValue;
  class IfcSpaceThermalLoadProperties extends IfcPropertySetDefinition {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableValueRatio, ThermalLoadSource, PropertySource, SourceDescription, MaximumValue, MinimumValue, ThermalLoadTimeSeriesValues, UserDefinedThermalLoadSource, UserDefinedPropertySource, ThermalLoadType) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableValueRatio = ApplicableValueRatio;
      this.ThermalLoadSource = ThermalLoadSource;
      this.PropertySource = PropertySource;
      this.SourceDescription = SourceDescription;
      this.MaximumValue = MaximumValue;
      this.MinimumValue = MinimumValue;
      this.ThermalLoadTimeSeriesValues = ThermalLoadTimeSeriesValues;
      this.UserDefinedThermalLoadSource = UserDefinedThermalLoadSource;
      this.UserDefinedPropertySource = UserDefinedPropertySource;
      this.ThermalLoadType = ThermalLoadType;
      this.type = 390701378;
    }
  }
  IFC2X32.IfcSpaceThermalLoadProperties = IfcSpaceThermalLoadProperties;
  class IfcStructuralLoadLinearForce extends IfcStructuralLoadStatic {
    constructor(Name, LinearForceX, LinearForceY, LinearForceZ, LinearMomentX, LinearMomentY, LinearMomentZ) {
      super(Name);
      this.Name = Name;
      this.LinearForceX = LinearForceX;
      this.LinearForceY = LinearForceY;
      this.LinearForceZ = LinearForceZ;
      this.LinearMomentX = LinearMomentX;
      this.LinearMomentY = LinearMomentY;
      this.LinearMomentZ = LinearMomentZ;
      this.type = 1595516126;
    }
  }
  IFC2X32.IfcStructuralLoadLinearForce = IfcStructuralLoadLinearForce;
  class IfcStructuralLoadPlanarForce extends IfcStructuralLoadStatic {
    constructor(Name, PlanarForceX, PlanarForceY, PlanarForceZ) {
      super(Name);
      this.Name = Name;
      this.PlanarForceX = PlanarForceX;
      this.PlanarForceY = PlanarForceY;
      this.PlanarForceZ = PlanarForceZ;
      this.type = 2668620305;
    }
  }
  IFC2X32.IfcStructuralLoadPlanarForce = IfcStructuralLoadPlanarForce;
  class IfcStructuralLoadSingleDisplacement extends IfcStructuralLoadStatic {
    constructor(Name, DisplacementX, DisplacementY, DisplacementZ, RotationalDisplacementRX, RotationalDisplacementRY, RotationalDisplacementRZ) {
      super(Name);
      this.Name = Name;
      this.DisplacementX = DisplacementX;
      this.DisplacementY = DisplacementY;
      this.DisplacementZ = DisplacementZ;
      this.RotationalDisplacementRX = RotationalDisplacementRX;
      this.RotationalDisplacementRY = RotationalDisplacementRY;
      this.RotationalDisplacementRZ = RotationalDisplacementRZ;
      this.type = 2473145415;
    }
  }
  IFC2X32.IfcStructuralLoadSingleDisplacement = IfcStructuralLoadSingleDisplacement;
  class IfcStructuralLoadSingleDisplacementDistortion extends IfcStructuralLoadSingleDisplacement {
    constructor(Name, DisplacementX, DisplacementY, DisplacementZ, RotationalDisplacementRX, RotationalDisplacementRY, RotationalDisplacementRZ, Distortion) {
      super(Name, DisplacementX, DisplacementY, DisplacementZ, RotationalDisplacementRX, RotationalDisplacementRY, RotationalDisplacementRZ);
      this.Name = Name;
      this.DisplacementX = DisplacementX;
      this.DisplacementY = DisplacementY;
      this.DisplacementZ = DisplacementZ;
      this.RotationalDisplacementRX = RotationalDisplacementRX;
      this.RotationalDisplacementRY = RotationalDisplacementRY;
      this.RotationalDisplacementRZ = RotationalDisplacementRZ;
      this.Distortion = Distortion;
      this.type = 1973038258;
    }
  }
  IFC2X32.IfcStructuralLoadSingleDisplacementDistortion = IfcStructuralLoadSingleDisplacementDistortion;
  class IfcStructuralLoadSingleForce extends IfcStructuralLoadStatic {
    constructor(Name, ForceX, ForceY, ForceZ, MomentX, MomentY, MomentZ) {
      super(Name);
      this.Name = Name;
      this.ForceX = ForceX;
      this.ForceY = ForceY;
      this.ForceZ = ForceZ;
      this.MomentX = MomentX;
      this.MomentY = MomentY;
      this.MomentZ = MomentZ;
      this.type = 1597423693;
    }
  }
  IFC2X32.IfcStructuralLoadSingleForce = IfcStructuralLoadSingleForce;
  class IfcStructuralLoadSingleForceWarping extends IfcStructuralLoadSingleForce {
    constructor(Name, ForceX, ForceY, ForceZ, MomentX, MomentY, MomentZ, WarpingMoment) {
      super(Name, ForceX, ForceY, ForceZ, MomentX, MomentY, MomentZ);
      this.Name = Name;
      this.ForceX = ForceX;
      this.ForceY = ForceY;
      this.ForceZ = ForceZ;
      this.MomentX = MomentX;
      this.MomentY = MomentY;
      this.MomentZ = MomentZ;
      this.WarpingMoment = WarpingMoment;
      this.type = 1190533807;
    }
  }
  IFC2X32.IfcStructuralLoadSingleForceWarping = IfcStructuralLoadSingleForceWarping;
  class IfcStructuralProfileProperties extends IfcGeneralProfileProperties {
    constructor(ProfileName, ProfileDefinition, PhysicalWeight, Perimeter, MinimumPlateThickness, MaximumPlateThickness, CrossSectionArea, TorsionalConstantX, MomentOfInertiaYZ, MomentOfInertiaY, MomentOfInertiaZ, WarpingConstant, ShearCentreZ, ShearCentreY, ShearDeformationAreaZ, ShearDeformationAreaY, MaximumSectionModulusY, MinimumSectionModulusY, MaximumSectionModulusZ, MinimumSectionModulusZ, TorsionalSectionModulus, CentreOfGravityInX, CentreOfGravityInY) {
      super(ProfileName, ProfileDefinition, PhysicalWeight, Perimeter, MinimumPlateThickness, MaximumPlateThickness, CrossSectionArea);
      this.ProfileName = ProfileName;
      this.ProfileDefinition = ProfileDefinition;
      this.PhysicalWeight = PhysicalWeight;
      this.Perimeter = Perimeter;
      this.MinimumPlateThickness = MinimumPlateThickness;
      this.MaximumPlateThickness = MaximumPlateThickness;
      this.CrossSectionArea = CrossSectionArea;
      this.TorsionalConstantX = TorsionalConstantX;
      this.MomentOfInertiaYZ = MomentOfInertiaYZ;
      this.MomentOfInertiaY = MomentOfInertiaY;
      this.MomentOfInertiaZ = MomentOfInertiaZ;
      this.WarpingConstant = WarpingConstant;
      this.ShearCentreZ = ShearCentreZ;
      this.ShearCentreY = ShearCentreY;
      this.ShearDeformationAreaZ = ShearDeformationAreaZ;
      this.ShearDeformationAreaY = ShearDeformationAreaY;
      this.MaximumSectionModulusY = MaximumSectionModulusY;
      this.MinimumSectionModulusY = MinimumSectionModulusY;
      this.MaximumSectionModulusZ = MaximumSectionModulusZ;
      this.MinimumSectionModulusZ = MinimumSectionModulusZ;
      this.TorsionalSectionModulus = TorsionalSectionModulus;
      this.CentreOfGravityInX = CentreOfGravityInX;
      this.CentreOfGravityInY = CentreOfGravityInY;
      this.type = 3843319758;
    }
  }
  IFC2X32.IfcStructuralProfileProperties = IfcStructuralProfileProperties;
  class IfcStructuralSteelProfileProperties extends IfcStructuralProfileProperties {
    constructor(ProfileName, ProfileDefinition, PhysicalWeight, Perimeter, MinimumPlateThickness, MaximumPlateThickness, CrossSectionArea, TorsionalConstantX, MomentOfInertiaYZ, MomentOfInertiaY, MomentOfInertiaZ, WarpingConstant, ShearCentreZ, ShearCentreY, ShearDeformationAreaZ, ShearDeformationAreaY, MaximumSectionModulusY, MinimumSectionModulusY, MaximumSectionModulusZ, MinimumSectionModulusZ, TorsionalSectionModulus, CentreOfGravityInX, CentreOfGravityInY, ShearAreaZ, ShearAreaY, PlasticShapeFactorY, PlasticShapeFactorZ) {
      super(ProfileName, ProfileDefinition, PhysicalWeight, Perimeter, MinimumPlateThickness, MaximumPlateThickness, CrossSectionArea, TorsionalConstantX, MomentOfInertiaYZ, MomentOfInertiaY, MomentOfInertiaZ, WarpingConstant, ShearCentreZ, ShearCentreY, ShearDeformationAreaZ, ShearDeformationAreaY, MaximumSectionModulusY, MinimumSectionModulusY, MaximumSectionModulusZ, MinimumSectionModulusZ, TorsionalSectionModulus, CentreOfGravityInX, CentreOfGravityInY);
      this.ProfileName = ProfileName;
      this.ProfileDefinition = ProfileDefinition;
      this.PhysicalWeight = PhysicalWeight;
      this.Perimeter = Perimeter;
      this.MinimumPlateThickness = MinimumPlateThickness;
      this.MaximumPlateThickness = MaximumPlateThickness;
      this.CrossSectionArea = CrossSectionArea;
      this.TorsionalConstantX = TorsionalConstantX;
      this.MomentOfInertiaYZ = MomentOfInertiaYZ;
      this.MomentOfInertiaY = MomentOfInertiaY;
      this.MomentOfInertiaZ = MomentOfInertiaZ;
      this.WarpingConstant = WarpingConstant;
      this.ShearCentreZ = ShearCentreZ;
      this.ShearCentreY = ShearCentreY;
      this.ShearDeformationAreaZ = ShearDeformationAreaZ;
      this.ShearDeformationAreaY = ShearDeformationAreaY;
      this.MaximumSectionModulusY = MaximumSectionModulusY;
      this.MinimumSectionModulusY = MinimumSectionModulusY;
      this.MaximumSectionModulusZ = MaximumSectionModulusZ;
      this.MinimumSectionModulusZ = MinimumSectionModulusZ;
      this.TorsionalSectionModulus = TorsionalSectionModulus;
      this.CentreOfGravityInX = CentreOfGravityInX;
      this.CentreOfGravityInY = CentreOfGravityInY;
      this.ShearAreaZ = ShearAreaZ;
      this.ShearAreaY = ShearAreaY;
      this.PlasticShapeFactorY = PlasticShapeFactorY;
      this.PlasticShapeFactorZ = PlasticShapeFactorZ;
      this.type = 3653947884;
    }
  }
  IFC2X32.IfcStructuralSteelProfileProperties = IfcStructuralSteelProfileProperties;
  class IfcSubedge extends IfcEdge {
    constructor(EdgeStart, EdgeEnd, ParentEdge) {
      super(EdgeStart, EdgeEnd);
      this.EdgeStart = EdgeStart;
      this.EdgeEnd = EdgeEnd;
      this.ParentEdge = ParentEdge;
      this.type = 2233826070;
    }
  }
  IFC2X32.IfcSubedge = IfcSubedge;
  class IfcSurface extends IfcGeometricRepresentationItem {
    constructor() {
      super();
      this.type = 2513912981;
    }
  }
  IFC2X32.IfcSurface = IfcSurface;
  class IfcSurfaceStyleRendering extends IfcSurfaceStyleShading {
    constructor(SurfaceColour, Transparency, DiffuseColour, TransmissionColour, DiffuseTransmissionColour, ReflectionColour, SpecularColour, SpecularHighlight, ReflectanceMethod) {
      super(SurfaceColour);
      this.SurfaceColour = SurfaceColour;
      this.Transparency = Transparency;
      this.DiffuseColour = DiffuseColour;
      this.TransmissionColour = TransmissionColour;
      this.DiffuseTransmissionColour = DiffuseTransmissionColour;
      this.ReflectionColour = ReflectionColour;
      this.SpecularColour = SpecularColour;
      this.SpecularHighlight = SpecularHighlight;
      this.ReflectanceMethod = ReflectanceMethod;
      this.type = 1878645084;
    }
  }
  IFC2X32.IfcSurfaceStyleRendering = IfcSurfaceStyleRendering;
  class IfcSweptAreaSolid extends IfcSolidModel {
    constructor(SweptArea, Position) {
      super();
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.type = 2247615214;
    }
  }
  IFC2X32.IfcSweptAreaSolid = IfcSweptAreaSolid;
  class IfcSweptDiskSolid extends IfcSolidModel {
    constructor(Directrix, Radius, InnerRadius, StartParam, EndParam) {
      super();
      this.Directrix = Directrix;
      this.Radius = Radius;
      this.InnerRadius = InnerRadius;
      this.StartParam = StartParam;
      this.EndParam = EndParam;
      this.type = 1260650574;
    }
  }
  IFC2X32.IfcSweptDiskSolid = IfcSweptDiskSolid;
  class IfcSweptSurface extends IfcSurface {
    constructor(SweptCurve, Position) {
      super();
      this.SweptCurve = SweptCurve;
      this.Position = Position;
      this.type = 230924584;
    }
  }
  IFC2X32.IfcSweptSurface = IfcSweptSurface;
  class IfcTShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(ProfileType, ProfileName, Position, Depth, FlangeWidth, WebThickness, FlangeThickness, FilletRadius, FlangeEdgeRadius, WebEdgeRadius, WebSlope, FlangeSlope, CentreOfGravityInY) {
      super(ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Depth = Depth;
      this.FlangeWidth = FlangeWidth;
      this.WebThickness = WebThickness;
      this.FlangeThickness = FlangeThickness;
      this.FilletRadius = FilletRadius;
      this.FlangeEdgeRadius = FlangeEdgeRadius;
      this.WebEdgeRadius = WebEdgeRadius;
      this.WebSlope = WebSlope;
      this.FlangeSlope = FlangeSlope;
      this.CentreOfGravityInY = CentreOfGravityInY;
      this.type = 3071757647;
    }
  }
  IFC2X32.IfcTShapeProfileDef = IfcTShapeProfileDef;
  class IfcTerminatorSymbol extends IfcAnnotationSymbolOccurrence {
    constructor(Item, Styles, Name, AnnotatedCurve) {
      super(Item, Styles, Name);
      this.Item = Item;
      this.Styles = Styles;
      this.Name = Name;
      this.AnnotatedCurve = AnnotatedCurve;
      this.type = 3028897424;
    }
  }
  IFC2X32.IfcTerminatorSymbol = IfcTerminatorSymbol;
  class IfcTextLiteral extends IfcGeometricRepresentationItem {
    constructor(Literal, Placement, Path) {
      super();
      this.Literal = Literal;
      this.Placement = Placement;
      this.Path = Path;
      this.type = 4282788508;
    }
  }
  IFC2X32.IfcTextLiteral = IfcTextLiteral;
  class IfcTextLiteralWithExtent extends IfcTextLiteral {
    constructor(Literal, Placement, Path, Extent, BoxAlignment) {
      super(Literal, Placement, Path);
      this.Literal = Literal;
      this.Placement = Placement;
      this.Path = Path;
      this.Extent = Extent;
      this.BoxAlignment = BoxAlignment;
      this.type = 3124975700;
    }
  }
  IFC2X32.IfcTextLiteralWithExtent = IfcTextLiteralWithExtent;
  class IfcTrapeziumProfileDef extends IfcParameterizedProfileDef {
    constructor(ProfileType, ProfileName, Position, BottomXDim, TopXDim, YDim, TopXOffset) {
      super(ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.BottomXDim = BottomXDim;
      this.TopXDim = TopXDim;
      this.YDim = YDim;
      this.TopXOffset = TopXOffset;
      this.type = 2715220739;
    }
  }
  IFC2X32.IfcTrapeziumProfileDef = IfcTrapeziumProfileDef;
  class IfcTwoDirectionRepeatFactor extends IfcOneDirectionRepeatFactor {
    constructor(RepeatFactor, SecondRepeatFactor) {
      super(RepeatFactor);
      this.RepeatFactor = RepeatFactor;
      this.SecondRepeatFactor = SecondRepeatFactor;
      this.type = 1345879162;
    }
  }
  IFC2X32.IfcTwoDirectionRepeatFactor = IfcTwoDirectionRepeatFactor;
  class IfcTypeObject extends IfcObjectDefinition {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.type = 1628702193;
    }
  }
  IFC2X32.IfcTypeObject = IfcTypeObject;
  class IfcTypeProduct extends IfcTypeObject {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.type = 2347495698;
    }
  }
  IFC2X32.IfcTypeProduct = IfcTypeProduct;
  class IfcUShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(ProfileType, ProfileName, Position, Depth, FlangeWidth, WebThickness, FlangeThickness, FilletRadius, EdgeRadius, FlangeSlope, CentreOfGravityInX) {
      super(ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Depth = Depth;
      this.FlangeWidth = FlangeWidth;
      this.WebThickness = WebThickness;
      this.FlangeThickness = FlangeThickness;
      this.FilletRadius = FilletRadius;
      this.EdgeRadius = EdgeRadius;
      this.FlangeSlope = FlangeSlope;
      this.CentreOfGravityInX = CentreOfGravityInX;
      this.type = 427810014;
    }
  }
  IFC2X32.IfcUShapeProfileDef = IfcUShapeProfileDef;
  class IfcVector extends IfcGeometricRepresentationItem {
    constructor(Orientation, Magnitude) {
      super();
      this.Orientation = Orientation;
      this.Magnitude = Magnitude;
      this.type = 1417489154;
    }
  }
  IFC2X32.IfcVector = IfcVector;
  class IfcVertexLoop extends IfcLoop {
    constructor(LoopVertex) {
      super();
      this.LoopVertex = LoopVertex;
      this.type = 2759199220;
    }
  }
  IFC2X32.IfcVertexLoop = IfcVertexLoop;
  class IfcWindowLiningProperties extends IfcPropertySetDefinition {
    constructor(GlobalId, OwnerHistory, Name, Description, LiningDepth, LiningThickness, TransomThickness, MullionThickness, FirstTransomOffset, SecondTransomOffset, FirstMullionOffset, SecondMullionOffset, ShapeAspectStyle) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.LiningDepth = LiningDepth;
      this.LiningThickness = LiningThickness;
      this.TransomThickness = TransomThickness;
      this.MullionThickness = MullionThickness;
      this.FirstTransomOffset = FirstTransomOffset;
      this.SecondTransomOffset = SecondTransomOffset;
      this.FirstMullionOffset = FirstMullionOffset;
      this.SecondMullionOffset = SecondMullionOffset;
      this.ShapeAspectStyle = ShapeAspectStyle;
      this.type = 336235671;
    }
  }
  IFC2X32.IfcWindowLiningProperties = IfcWindowLiningProperties;
  class IfcWindowPanelProperties extends IfcPropertySetDefinition {
    constructor(GlobalId, OwnerHistory, Name, Description, OperationType, PanelPosition, FrameDepth, FrameThickness, ShapeAspectStyle) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.OperationType = OperationType;
      this.PanelPosition = PanelPosition;
      this.FrameDepth = FrameDepth;
      this.FrameThickness = FrameThickness;
      this.ShapeAspectStyle = ShapeAspectStyle;
      this.type = 512836454;
    }
  }
  IFC2X32.IfcWindowPanelProperties = IfcWindowPanelProperties;
  class IfcWindowStyle extends IfcTypeProduct {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ConstructionType, OperationType, ParameterTakesPrecedence, Sizeable) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ConstructionType = ConstructionType;
      this.OperationType = OperationType;
      this.ParameterTakesPrecedence = ParameterTakesPrecedence;
      this.Sizeable = Sizeable;
      this.type = 1299126871;
    }
  }
  IFC2X32.IfcWindowStyle = IfcWindowStyle;
  class IfcZShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(ProfileType, ProfileName, Position, Depth, FlangeWidth, WebThickness, FlangeThickness, FilletRadius, EdgeRadius) {
      super(ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Depth = Depth;
      this.FlangeWidth = FlangeWidth;
      this.WebThickness = WebThickness;
      this.FlangeThickness = FlangeThickness;
      this.FilletRadius = FilletRadius;
      this.EdgeRadius = EdgeRadius;
      this.type = 2543172580;
    }
  }
  IFC2X32.IfcZShapeProfileDef = IfcZShapeProfileDef;
  class IfcAnnotationCurveOccurrence extends IfcAnnotationOccurrence {
    constructor(Item, Styles, Name) {
      super(Item, Styles, Name);
      this.Item = Item;
      this.Styles = Styles;
      this.Name = Name;
      this.type = 3288037868;
    }
  }
  IFC2X32.IfcAnnotationCurveOccurrence = IfcAnnotationCurveOccurrence;
  class IfcAnnotationFillArea extends IfcGeometricRepresentationItem {
    constructor(OuterBoundary, InnerBoundaries) {
      super();
      this.OuterBoundary = OuterBoundary;
      this.InnerBoundaries = InnerBoundaries;
      this.type = 669184980;
    }
  }
  IFC2X32.IfcAnnotationFillArea = IfcAnnotationFillArea;
  class IfcAnnotationFillAreaOccurrence extends IfcAnnotationOccurrence {
    constructor(Item, Styles, Name, FillStyleTarget, GlobalOrLocal) {
      super(Item, Styles, Name);
      this.Item = Item;
      this.Styles = Styles;
      this.Name = Name;
      this.FillStyleTarget = FillStyleTarget;
      this.GlobalOrLocal = GlobalOrLocal;
      this.type = 2265737646;
    }
  }
  IFC2X32.IfcAnnotationFillAreaOccurrence = IfcAnnotationFillAreaOccurrence;
  class IfcAnnotationSurface extends IfcGeometricRepresentationItem {
    constructor(Item, TextureCoordinates) {
      super();
      this.Item = Item;
      this.TextureCoordinates = TextureCoordinates;
      this.type = 1302238472;
    }
  }
  IFC2X32.IfcAnnotationSurface = IfcAnnotationSurface;
  class IfcAxis1Placement extends IfcPlacement {
    constructor(Location, Axis) {
      super(Location);
      this.Location = Location;
      this.Axis = Axis;
      this.type = 4261334040;
    }
  }
  IFC2X32.IfcAxis1Placement = IfcAxis1Placement;
  class IfcAxis2Placement2D extends IfcPlacement {
    constructor(Location, RefDirection) {
      super(Location);
      this.Location = Location;
      this.RefDirection = RefDirection;
      this.type = 3125803723;
    }
  }
  IFC2X32.IfcAxis2Placement2D = IfcAxis2Placement2D;
  class IfcAxis2Placement3D extends IfcPlacement {
    constructor(Location, Axis, RefDirection) {
      super(Location);
      this.Location = Location;
      this.Axis = Axis;
      this.RefDirection = RefDirection;
      this.type = 2740243338;
    }
  }
  IFC2X32.IfcAxis2Placement3D = IfcAxis2Placement3D;
  class IfcBooleanResult extends IfcGeometricRepresentationItem {
    constructor(Operator, FirstOperand, SecondOperand) {
      super();
      this.Operator = Operator;
      this.FirstOperand = FirstOperand;
      this.SecondOperand = SecondOperand;
      this.type = 2736907675;
    }
  }
  IFC2X32.IfcBooleanResult = IfcBooleanResult;
  class IfcBoundedSurface extends IfcSurface {
    constructor() {
      super();
      this.type = 4182860854;
    }
  }
  IFC2X32.IfcBoundedSurface = IfcBoundedSurface;
  class IfcBoundingBox extends IfcGeometricRepresentationItem {
    constructor(Corner, XDim, YDim, ZDim) {
      super();
      this.Corner = Corner;
      this.XDim = XDim;
      this.YDim = YDim;
      this.ZDim = ZDim;
      this.type = 2581212453;
    }
  }
  IFC2X32.IfcBoundingBox = IfcBoundingBox;
  class IfcBoxedHalfSpace extends IfcHalfSpaceSolid {
    constructor(BaseSurface, AgreementFlag, Enclosure) {
      super(BaseSurface, AgreementFlag);
      this.BaseSurface = BaseSurface;
      this.AgreementFlag = AgreementFlag;
      this.Enclosure = Enclosure;
      this.type = 2713105998;
    }
  }
  IFC2X32.IfcBoxedHalfSpace = IfcBoxedHalfSpace;
  class IfcCShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(ProfileType, ProfileName, Position, Depth, Width, WallThickness, Girth, InternalFilletRadius, CentreOfGravityInX) {
      super(ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Depth = Depth;
      this.Width = Width;
      this.WallThickness = WallThickness;
      this.Girth = Girth;
      this.InternalFilletRadius = InternalFilletRadius;
      this.CentreOfGravityInX = CentreOfGravityInX;
      this.type = 2898889636;
    }
  }
  IFC2X32.IfcCShapeProfileDef = IfcCShapeProfileDef;
  class IfcCartesianPoint extends IfcPoint {
    constructor(Coordinates) {
      super();
      this.Coordinates = Coordinates;
      this.type = 1123145078;
    }
  }
  IFC2X32.IfcCartesianPoint = IfcCartesianPoint;
  class IfcCartesianTransformationOperator extends IfcGeometricRepresentationItem {
    constructor(Axis1, Axis2, LocalOrigin, Scale) {
      super();
      this.Axis1 = Axis1;
      this.Axis2 = Axis2;
      this.LocalOrigin = LocalOrigin;
      this.Scale = Scale;
      this.type = 59481748;
    }
  }
  IFC2X32.IfcCartesianTransformationOperator = IfcCartesianTransformationOperator;
  class IfcCartesianTransformationOperator2D extends IfcCartesianTransformationOperator {
    constructor(Axis1, Axis2, LocalOrigin, Scale) {
      super(Axis1, Axis2, LocalOrigin, Scale);
      this.Axis1 = Axis1;
      this.Axis2 = Axis2;
      this.LocalOrigin = LocalOrigin;
      this.Scale = Scale;
      this.type = 3749851601;
    }
  }
  IFC2X32.IfcCartesianTransformationOperator2D = IfcCartesianTransformationOperator2D;
  class IfcCartesianTransformationOperator2DnonUniform extends IfcCartesianTransformationOperator2D {
    constructor(Axis1, Axis2, LocalOrigin, Scale, Scale2) {
      super(Axis1, Axis2, LocalOrigin, Scale);
      this.Axis1 = Axis1;
      this.Axis2 = Axis2;
      this.LocalOrigin = LocalOrigin;
      this.Scale = Scale;
      this.Scale2 = Scale2;
      this.type = 3486308946;
    }
  }
  IFC2X32.IfcCartesianTransformationOperator2DnonUniform = IfcCartesianTransformationOperator2DnonUniform;
  class IfcCartesianTransformationOperator3D extends IfcCartesianTransformationOperator {
    constructor(Axis1, Axis2, LocalOrigin, Scale, Axis3) {
      super(Axis1, Axis2, LocalOrigin, Scale);
      this.Axis1 = Axis1;
      this.Axis2 = Axis2;
      this.LocalOrigin = LocalOrigin;
      this.Scale = Scale;
      this.Axis3 = Axis3;
      this.type = 3331915920;
    }
  }
  IFC2X32.IfcCartesianTransformationOperator3D = IfcCartesianTransformationOperator3D;
  class IfcCartesianTransformationOperator3DnonUniform extends IfcCartesianTransformationOperator3D {
    constructor(Axis1, Axis2, LocalOrigin, Scale, Axis3, Scale2, Scale3) {
      super(Axis1, Axis2, LocalOrigin, Scale, Axis3);
      this.Axis1 = Axis1;
      this.Axis2 = Axis2;
      this.LocalOrigin = LocalOrigin;
      this.Scale = Scale;
      this.Axis3 = Axis3;
      this.Scale2 = Scale2;
      this.Scale3 = Scale3;
      this.type = 1416205885;
    }
  }
  IFC2X32.IfcCartesianTransformationOperator3DnonUniform = IfcCartesianTransformationOperator3DnonUniform;
  class IfcCircleProfileDef extends IfcParameterizedProfileDef {
    constructor(ProfileType, ProfileName, Position, Radius) {
      super(ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Radius = Radius;
      this.type = 1383045692;
    }
  }
  IFC2X32.IfcCircleProfileDef = IfcCircleProfileDef;
  class IfcClosedShell extends IfcConnectedFaceSet {
    constructor(CfsFaces) {
      super(CfsFaces);
      this.CfsFaces = CfsFaces;
      this.type = 2205249479;
    }
  }
  IFC2X32.IfcClosedShell = IfcClosedShell;
  class IfcCompositeCurveSegment extends IfcGeometricRepresentationItem {
    constructor(Transition, SameSense, ParentCurve) {
      super();
      this.Transition = Transition;
      this.SameSense = SameSense;
      this.ParentCurve = ParentCurve;
      this.type = 2485617015;
    }
  }
  IFC2X32.IfcCompositeCurveSegment = IfcCompositeCurveSegment;
  class IfcCraneRailAShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(ProfileType, ProfileName, Position, OverallHeight, BaseWidth2, Radius, HeadWidth, HeadDepth2, HeadDepth3, WebThickness, BaseWidth4, BaseDepth1, BaseDepth2, BaseDepth3, CentreOfGravityInY) {
      super(ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.OverallHeight = OverallHeight;
      this.BaseWidth2 = BaseWidth2;
      this.Radius = Radius;
      this.HeadWidth = HeadWidth;
      this.HeadDepth2 = HeadDepth2;
      this.HeadDepth3 = HeadDepth3;
      this.WebThickness = WebThickness;
      this.BaseWidth4 = BaseWidth4;
      this.BaseDepth1 = BaseDepth1;
      this.BaseDepth2 = BaseDepth2;
      this.BaseDepth3 = BaseDepth3;
      this.CentreOfGravityInY = CentreOfGravityInY;
      this.type = 4133800736;
    }
  }
  IFC2X32.IfcCraneRailAShapeProfileDef = IfcCraneRailAShapeProfileDef;
  class IfcCraneRailFShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(ProfileType, ProfileName, Position, OverallHeight, HeadWidth, Radius, HeadDepth2, HeadDepth3, WebThickness, BaseDepth1, BaseDepth2, CentreOfGravityInY) {
      super(ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.OverallHeight = OverallHeight;
      this.HeadWidth = HeadWidth;
      this.Radius = Radius;
      this.HeadDepth2 = HeadDepth2;
      this.HeadDepth3 = HeadDepth3;
      this.WebThickness = WebThickness;
      this.BaseDepth1 = BaseDepth1;
      this.BaseDepth2 = BaseDepth2;
      this.CentreOfGravityInY = CentreOfGravityInY;
      this.type = 194851669;
    }
  }
  IFC2X32.IfcCraneRailFShapeProfileDef = IfcCraneRailFShapeProfileDef;
  class IfcCsgPrimitive3D extends IfcGeometricRepresentationItem {
    constructor(Position) {
      super();
      this.Position = Position;
      this.type = 2506170314;
    }
  }
  IFC2X32.IfcCsgPrimitive3D = IfcCsgPrimitive3D;
  class IfcCsgSolid extends IfcSolidModel {
    constructor(TreeRootExpression) {
      super();
      this.TreeRootExpression = TreeRootExpression;
      this.type = 2147822146;
    }
  }
  IFC2X32.IfcCsgSolid = IfcCsgSolid;
  class IfcCurve extends IfcGeometricRepresentationItem {
    constructor() {
      super();
      this.type = 2601014836;
    }
  }
  IFC2X32.IfcCurve = IfcCurve;
  class IfcCurveBoundedPlane extends IfcBoundedSurface {
    constructor(BasisSurface, OuterBoundary, InnerBoundaries) {
      super();
      this.BasisSurface = BasisSurface;
      this.OuterBoundary = OuterBoundary;
      this.InnerBoundaries = InnerBoundaries;
      this.type = 2827736869;
    }
  }
  IFC2X32.IfcCurveBoundedPlane = IfcCurveBoundedPlane;
  class IfcDefinedSymbol extends IfcGeometricRepresentationItem {
    constructor(Definition, Target) {
      super();
      this.Definition = Definition;
      this.Target = Target;
      this.type = 693772133;
    }
  }
  IFC2X32.IfcDefinedSymbol = IfcDefinedSymbol;
  class IfcDimensionCurve extends IfcAnnotationCurveOccurrence {
    constructor(Item, Styles, Name) {
      super(Item, Styles, Name);
      this.Item = Item;
      this.Styles = Styles;
      this.Name = Name;
      this.type = 606661476;
    }
  }
  IFC2X32.IfcDimensionCurve = IfcDimensionCurve;
  class IfcDimensionCurveTerminator extends IfcTerminatorSymbol {
    constructor(Item, Styles, Name, AnnotatedCurve, Role) {
      super(Item, Styles, Name, AnnotatedCurve);
      this.Item = Item;
      this.Styles = Styles;
      this.Name = Name;
      this.AnnotatedCurve = AnnotatedCurve;
      this.Role = Role;
      this.type = 4054601972;
    }
  }
  IFC2X32.IfcDimensionCurveTerminator = IfcDimensionCurveTerminator;
  class IfcDirection extends IfcGeometricRepresentationItem {
    constructor(DirectionRatios) {
      super();
      this.DirectionRatios = DirectionRatios;
      this.type = 32440307;
    }
  }
  IFC2X32.IfcDirection = IfcDirection;
  class IfcDoorLiningProperties extends IfcPropertySetDefinition {
    constructor(GlobalId, OwnerHistory, Name, Description, LiningDepth, LiningThickness, ThresholdDepth, ThresholdThickness, TransomThickness, TransomOffset, LiningOffset, ThresholdOffset, CasingThickness, CasingDepth, ShapeAspectStyle) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.LiningDepth = LiningDepth;
      this.LiningThickness = LiningThickness;
      this.ThresholdDepth = ThresholdDepth;
      this.ThresholdThickness = ThresholdThickness;
      this.TransomThickness = TransomThickness;
      this.TransomOffset = TransomOffset;
      this.LiningOffset = LiningOffset;
      this.ThresholdOffset = ThresholdOffset;
      this.CasingThickness = CasingThickness;
      this.CasingDepth = CasingDepth;
      this.ShapeAspectStyle = ShapeAspectStyle;
      this.type = 2963535650;
    }
  }
  IFC2X32.IfcDoorLiningProperties = IfcDoorLiningProperties;
  class IfcDoorPanelProperties extends IfcPropertySetDefinition {
    constructor(GlobalId, OwnerHistory, Name, Description, PanelDepth, PanelOperation, PanelWidth, PanelPosition, ShapeAspectStyle) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.PanelDepth = PanelDepth;
      this.PanelOperation = PanelOperation;
      this.PanelWidth = PanelWidth;
      this.PanelPosition = PanelPosition;
      this.ShapeAspectStyle = ShapeAspectStyle;
      this.type = 1714330368;
    }
  }
  IFC2X32.IfcDoorPanelProperties = IfcDoorPanelProperties;
  class IfcDoorStyle extends IfcTypeProduct {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, OperationType, ConstructionType, ParameterTakesPrecedence, Sizeable) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.OperationType = OperationType;
      this.ConstructionType = ConstructionType;
      this.ParameterTakesPrecedence = ParameterTakesPrecedence;
      this.Sizeable = Sizeable;
      this.type = 526551008;
    }
  }
  IFC2X32.IfcDoorStyle = IfcDoorStyle;
  class IfcDraughtingCallout extends IfcGeometricRepresentationItem {
    constructor(Contents) {
      super();
      this.Contents = Contents;
      this.type = 3073041342;
    }
  }
  IFC2X32.IfcDraughtingCallout = IfcDraughtingCallout;
  class IfcDraughtingPreDefinedColour extends IfcPreDefinedColour {
    constructor(Name) {
      super(Name);
      this.Name = Name;
      this.type = 445594917;
    }
  }
  IFC2X32.IfcDraughtingPreDefinedColour = IfcDraughtingPreDefinedColour;
  class IfcDraughtingPreDefinedCurveFont extends IfcPreDefinedCurveFont {
    constructor(Name) {
      super(Name);
      this.Name = Name;
      this.type = 4006246654;
    }
  }
  IFC2X32.IfcDraughtingPreDefinedCurveFont = IfcDraughtingPreDefinedCurveFont;
  class IfcEdgeLoop extends IfcLoop {
    constructor(EdgeList) {
      super();
      this.EdgeList = EdgeList;
      this.type = 1472233963;
    }
  }
  IFC2X32.IfcEdgeLoop = IfcEdgeLoop;
  class IfcElementQuantity extends IfcPropertySetDefinition {
    constructor(GlobalId, OwnerHistory, Name, Description, MethodOfMeasurement, Quantities) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.MethodOfMeasurement = MethodOfMeasurement;
      this.Quantities = Quantities;
      this.type = 1883228015;
    }
  }
  IFC2X32.IfcElementQuantity = IfcElementQuantity;
  class IfcElementType extends IfcTypeProduct {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 339256511;
    }
  }
  IFC2X32.IfcElementType = IfcElementType;
  class IfcElementarySurface extends IfcSurface {
    constructor(Position) {
      super();
      this.Position = Position;
      this.type = 2777663545;
    }
  }
  IFC2X32.IfcElementarySurface = IfcElementarySurface;
  class IfcEllipseProfileDef extends IfcParameterizedProfileDef {
    constructor(ProfileType, ProfileName, Position, SemiAxis1, SemiAxis2) {
      super(ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.SemiAxis1 = SemiAxis1;
      this.SemiAxis2 = SemiAxis2;
      this.type = 2835456948;
    }
  }
  IFC2X32.IfcEllipseProfileDef = IfcEllipseProfileDef;
  class IfcEnergyProperties extends IfcPropertySetDefinition {
    constructor(GlobalId, OwnerHistory, Name, Description, EnergySequence, UserDefinedEnergySequence) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.EnergySequence = EnergySequence;
      this.UserDefinedEnergySequence = UserDefinedEnergySequence;
      this.type = 80994333;
    }
  }
  IFC2X32.IfcEnergyProperties = IfcEnergyProperties;
  class IfcExtrudedAreaSolid extends IfcSweptAreaSolid {
    constructor(SweptArea, Position, ExtrudedDirection, Depth) {
      super(SweptArea, Position);
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.ExtrudedDirection = ExtrudedDirection;
      this.Depth = Depth;
      this.type = 477187591;
    }
  }
  IFC2X32.IfcExtrudedAreaSolid = IfcExtrudedAreaSolid;
  class IfcFaceBasedSurfaceModel extends IfcGeometricRepresentationItem {
    constructor(FbsmFaces) {
      super();
      this.FbsmFaces = FbsmFaces;
      this.type = 2047409740;
    }
  }
  IFC2X32.IfcFaceBasedSurfaceModel = IfcFaceBasedSurfaceModel;
  class IfcFillAreaStyleHatching extends IfcGeometricRepresentationItem {
    constructor(HatchLineAppearance, StartOfNextHatchLine, PointOfReferenceHatchLine, PatternStart, HatchLineAngle) {
      super();
      this.HatchLineAppearance = HatchLineAppearance;
      this.StartOfNextHatchLine = StartOfNextHatchLine;
      this.PointOfReferenceHatchLine = PointOfReferenceHatchLine;
      this.PatternStart = PatternStart;
      this.HatchLineAngle = HatchLineAngle;
      this.type = 374418227;
    }
  }
  IFC2X32.IfcFillAreaStyleHatching = IfcFillAreaStyleHatching;
  class IfcFillAreaStyleTileSymbolWithStyle extends IfcGeometricRepresentationItem {
    constructor(Symbol2) {
      super();
      this.Symbol = Symbol2;
      this.type = 4203026998;
    }
  }
  IFC2X32.IfcFillAreaStyleTileSymbolWithStyle = IfcFillAreaStyleTileSymbolWithStyle;
  class IfcFillAreaStyleTiles extends IfcGeometricRepresentationItem {
    constructor(TilingPattern, Tiles, TilingScale) {
      super();
      this.TilingPattern = TilingPattern;
      this.Tiles = Tiles;
      this.TilingScale = TilingScale;
      this.type = 315944413;
    }
  }
  IFC2X32.IfcFillAreaStyleTiles = IfcFillAreaStyleTiles;
  class IfcFluidFlowProperties extends IfcPropertySetDefinition {
    constructor(GlobalId, OwnerHistory, Name, Description, PropertySource, FlowConditionTimeSeries, VelocityTimeSeries, FlowrateTimeSeries, Fluid, PressureTimeSeries, UserDefinedPropertySource, TemperatureSingleValue, WetBulbTemperatureSingleValue, WetBulbTemperatureTimeSeries, TemperatureTimeSeries, FlowrateSingleValue, FlowConditionSingleValue, VelocitySingleValue, PressureSingleValue) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.PropertySource = PropertySource;
      this.FlowConditionTimeSeries = FlowConditionTimeSeries;
      this.VelocityTimeSeries = VelocityTimeSeries;
      this.FlowrateTimeSeries = FlowrateTimeSeries;
      this.Fluid = Fluid;
      this.PressureTimeSeries = PressureTimeSeries;
      this.UserDefinedPropertySource = UserDefinedPropertySource;
      this.TemperatureSingleValue = TemperatureSingleValue;
      this.WetBulbTemperatureSingleValue = WetBulbTemperatureSingleValue;
      this.WetBulbTemperatureTimeSeries = WetBulbTemperatureTimeSeries;
      this.TemperatureTimeSeries = TemperatureTimeSeries;
      this.FlowrateSingleValue = FlowrateSingleValue;
      this.FlowConditionSingleValue = FlowConditionSingleValue;
      this.VelocitySingleValue = VelocitySingleValue;
      this.PressureSingleValue = PressureSingleValue;
      this.type = 3455213021;
    }
  }
  IFC2X32.IfcFluidFlowProperties = IfcFluidFlowProperties;
  class IfcFurnishingElementType extends IfcElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 4238390223;
    }
  }
  IFC2X32.IfcFurnishingElementType = IfcFurnishingElementType;
  class IfcFurnitureType extends IfcFurnishingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, AssemblyPlace) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.AssemblyPlace = AssemblyPlace;
      this.type = 1268542332;
    }
  }
  IFC2X32.IfcFurnitureType = IfcFurnitureType;
  class IfcGeometricCurveSet extends IfcGeometricSet {
    constructor(Elements) {
      super(Elements);
      this.Elements = Elements;
      this.type = 987898635;
    }
  }
  IFC2X32.IfcGeometricCurveSet = IfcGeometricCurveSet;
  class IfcIShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(ProfileType, ProfileName, Position, OverallWidth, OverallDepth, WebThickness, FlangeThickness, FilletRadius) {
      super(ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.OverallWidth = OverallWidth;
      this.OverallDepth = OverallDepth;
      this.WebThickness = WebThickness;
      this.FlangeThickness = FlangeThickness;
      this.FilletRadius = FilletRadius;
      this.type = 1484403080;
    }
  }
  IFC2X32.IfcIShapeProfileDef = IfcIShapeProfileDef;
  class IfcLShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(ProfileType, ProfileName, Position, Depth, Width, Thickness, FilletRadius, EdgeRadius, LegSlope, CentreOfGravityInX, CentreOfGravityInY) {
      super(ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Depth = Depth;
      this.Width = Width;
      this.Thickness = Thickness;
      this.FilletRadius = FilletRadius;
      this.EdgeRadius = EdgeRadius;
      this.LegSlope = LegSlope;
      this.CentreOfGravityInX = CentreOfGravityInX;
      this.CentreOfGravityInY = CentreOfGravityInY;
      this.type = 572779678;
    }
  }
  IFC2X32.IfcLShapeProfileDef = IfcLShapeProfileDef;
  class IfcLine extends IfcCurve {
    constructor(Pnt, Dir) {
      super();
      this.Pnt = Pnt;
      this.Dir = Dir;
      this.type = 1281925730;
    }
  }
  IFC2X32.IfcLine = IfcLine;
  class IfcManifoldSolidBrep extends IfcSolidModel {
    constructor(Outer) {
      super();
      this.Outer = Outer;
      this.type = 1425443689;
    }
  }
  IFC2X32.IfcManifoldSolidBrep = IfcManifoldSolidBrep;
  class IfcObject extends IfcObjectDefinition {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.type = 3888040117;
    }
  }
  IFC2X32.IfcObject = IfcObject;
  class IfcOffsetCurve2D extends IfcCurve {
    constructor(BasisCurve, Distance, SelfIntersect) {
      super();
      this.BasisCurve = BasisCurve;
      this.Distance = Distance;
      this.SelfIntersect = SelfIntersect;
      this.type = 3388369263;
    }
  }
  IFC2X32.IfcOffsetCurve2D = IfcOffsetCurve2D;
  class IfcOffsetCurve3D extends IfcCurve {
    constructor(BasisCurve, Distance, SelfIntersect, RefDirection) {
      super();
      this.BasisCurve = BasisCurve;
      this.Distance = Distance;
      this.SelfIntersect = SelfIntersect;
      this.RefDirection = RefDirection;
      this.type = 3505215534;
    }
  }
  IFC2X32.IfcOffsetCurve3D = IfcOffsetCurve3D;
  class IfcPermeableCoveringProperties extends IfcPropertySetDefinition {
    constructor(GlobalId, OwnerHistory, Name, Description, OperationType, PanelPosition, FrameDepth, FrameThickness, ShapeAspectStyle) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.OperationType = OperationType;
      this.PanelPosition = PanelPosition;
      this.FrameDepth = FrameDepth;
      this.FrameThickness = FrameThickness;
      this.ShapeAspectStyle = ShapeAspectStyle;
      this.type = 3566463478;
    }
  }
  IFC2X32.IfcPermeableCoveringProperties = IfcPermeableCoveringProperties;
  class IfcPlanarBox extends IfcPlanarExtent {
    constructor(SizeInX, SizeInY, Placement) {
      super(SizeInX, SizeInY);
      this.SizeInX = SizeInX;
      this.SizeInY = SizeInY;
      this.Placement = Placement;
      this.type = 603570806;
    }
  }
  IFC2X32.IfcPlanarBox = IfcPlanarBox;
  class IfcPlane extends IfcElementarySurface {
    constructor(Position) {
      super(Position);
      this.Position = Position;
      this.type = 220341763;
    }
  }
  IFC2X32.IfcPlane = IfcPlane;
  class IfcProcess extends IfcObject {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.type = 2945172077;
    }
  }
  IFC2X32.IfcProcess = IfcProcess;
  class IfcProduct extends IfcObject {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.type = 4208778838;
    }
  }
  IFC2X32.IfcProduct = IfcProduct;
  class IfcProject extends IfcObject {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.LongName = LongName;
      this.Phase = Phase;
      this.RepresentationContexts = RepresentationContexts;
      this.UnitsInContext = UnitsInContext;
      this.type = 103090709;
    }
  }
  IFC2X32.IfcProject = IfcProject;
  class IfcProjectionCurve extends IfcAnnotationCurveOccurrence {
    constructor(Item, Styles, Name) {
      super(Item, Styles, Name);
      this.Item = Item;
      this.Styles = Styles;
      this.Name = Name;
      this.type = 4194566429;
    }
  }
  IFC2X32.IfcProjectionCurve = IfcProjectionCurve;
  class IfcPropertySet extends IfcPropertySetDefinition {
    constructor(GlobalId, OwnerHistory, Name, Description, HasProperties) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.HasProperties = HasProperties;
      this.type = 1451395588;
    }
  }
  IFC2X32.IfcPropertySet = IfcPropertySet;
  class IfcProxy extends IfcProduct {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, ProxyType, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.ProxyType = ProxyType;
      this.Tag = Tag;
      this.type = 3219374653;
    }
  }
  IFC2X32.IfcProxy = IfcProxy;
  class IfcRectangleHollowProfileDef extends IfcRectangleProfileDef {
    constructor(ProfileType, ProfileName, Position, XDim, YDim, WallThickness, InnerFilletRadius, OuterFilletRadius) {
      super(ProfileType, ProfileName, Position, XDim, YDim);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.XDim = XDim;
      this.YDim = YDim;
      this.WallThickness = WallThickness;
      this.InnerFilletRadius = InnerFilletRadius;
      this.OuterFilletRadius = OuterFilletRadius;
      this.type = 2770003689;
    }
  }
  IFC2X32.IfcRectangleHollowProfileDef = IfcRectangleHollowProfileDef;
  class IfcRectangularPyramid extends IfcCsgPrimitive3D {
    constructor(Position, XLength, YLength, Height) {
      super(Position);
      this.Position = Position;
      this.XLength = XLength;
      this.YLength = YLength;
      this.Height = Height;
      this.type = 2798486643;
    }
  }
  IFC2X32.IfcRectangularPyramid = IfcRectangularPyramid;
  class IfcRectangularTrimmedSurface extends IfcBoundedSurface {
    constructor(BasisSurface, U1, V1, U2, V2, Usense, Vsense) {
      super();
      this.BasisSurface = BasisSurface;
      this.U1 = U1;
      this.V1 = V1;
      this.U2 = U2;
      this.V2 = V2;
      this.Usense = Usense;
      this.Vsense = Vsense;
      this.type = 3454111270;
    }
  }
  IFC2X32.IfcRectangularTrimmedSurface = IfcRectangularTrimmedSurface;
  class IfcRelAssigns extends IfcRelationship {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.type = 3939117080;
    }
  }
  IFC2X32.IfcRelAssigns = IfcRelAssigns;
  class IfcRelAssignsToActor extends IfcRelAssigns {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingActor, ActingRole) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingActor = RelatingActor;
      this.ActingRole = ActingRole;
      this.type = 1683148259;
    }
  }
  IFC2X32.IfcRelAssignsToActor = IfcRelAssignsToActor;
  class IfcRelAssignsToControl extends IfcRelAssigns {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingControl) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingControl = RelatingControl;
      this.type = 2495723537;
    }
  }
  IFC2X32.IfcRelAssignsToControl = IfcRelAssignsToControl;
  class IfcRelAssignsToGroup extends IfcRelAssigns {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingGroup) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingGroup = RelatingGroup;
      this.type = 1307041759;
    }
  }
  IFC2X32.IfcRelAssignsToGroup = IfcRelAssignsToGroup;
  class IfcRelAssignsToProcess extends IfcRelAssigns {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingProcess, QuantityInProcess) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingProcess = RelatingProcess;
      this.QuantityInProcess = QuantityInProcess;
      this.type = 4278684876;
    }
  }
  IFC2X32.IfcRelAssignsToProcess = IfcRelAssignsToProcess;
  class IfcRelAssignsToProduct extends IfcRelAssigns {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingProduct) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingProduct = RelatingProduct;
      this.type = 2857406711;
    }
  }
  IFC2X32.IfcRelAssignsToProduct = IfcRelAssignsToProduct;
  class IfcRelAssignsToProjectOrder extends IfcRelAssignsToControl {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingControl) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingControl);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingControl = RelatingControl;
      this.type = 3372526763;
    }
  }
  IFC2X32.IfcRelAssignsToProjectOrder = IfcRelAssignsToProjectOrder;
  class IfcRelAssignsToResource extends IfcRelAssigns {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingResource) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingResource = RelatingResource;
      this.type = 205026976;
    }
  }
  IFC2X32.IfcRelAssignsToResource = IfcRelAssignsToResource;
  class IfcRelAssociates extends IfcRelationship {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.type = 1865459582;
    }
  }
  IFC2X32.IfcRelAssociates = IfcRelAssociates;
  class IfcRelAssociatesAppliedValue extends IfcRelAssociates {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingAppliedValue) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingAppliedValue = RelatingAppliedValue;
      this.type = 1327628568;
    }
  }
  IFC2X32.IfcRelAssociatesAppliedValue = IfcRelAssociatesAppliedValue;
  class IfcRelAssociatesApproval extends IfcRelAssociates {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingApproval) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingApproval = RelatingApproval;
      this.type = 4095574036;
    }
  }
  IFC2X32.IfcRelAssociatesApproval = IfcRelAssociatesApproval;
  class IfcRelAssociatesClassification extends IfcRelAssociates {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingClassification) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingClassification = RelatingClassification;
      this.type = 919958153;
    }
  }
  IFC2X32.IfcRelAssociatesClassification = IfcRelAssociatesClassification;
  class IfcRelAssociatesConstraint extends IfcRelAssociates {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, Intent, RelatingConstraint) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.Intent = Intent;
      this.RelatingConstraint = RelatingConstraint;
      this.type = 2728634034;
    }
  }
  IFC2X32.IfcRelAssociatesConstraint = IfcRelAssociatesConstraint;
  class IfcRelAssociatesDocument extends IfcRelAssociates {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingDocument) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingDocument = RelatingDocument;
      this.type = 982818633;
    }
  }
  IFC2X32.IfcRelAssociatesDocument = IfcRelAssociatesDocument;
  class IfcRelAssociatesLibrary extends IfcRelAssociates {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingLibrary) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingLibrary = RelatingLibrary;
      this.type = 3840914261;
    }
  }
  IFC2X32.IfcRelAssociatesLibrary = IfcRelAssociatesLibrary;
  class IfcRelAssociatesMaterial extends IfcRelAssociates {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingMaterial) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingMaterial = RelatingMaterial;
      this.type = 2655215786;
    }
  }
  IFC2X32.IfcRelAssociatesMaterial = IfcRelAssociatesMaterial;
  class IfcRelAssociatesProfileProperties extends IfcRelAssociates {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingProfileProperties, ProfileSectionLocation, ProfileOrientation) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingProfileProperties = RelatingProfileProperties;
      this.ProfileSectionLocation = ProfileSectionLocation;
      this.ProfileOrientation = ProfileOrientation;
      this.type = 2851387026;
    }
  }
  IFC2X32.IfcRelAssociatesProfileProperties = IfcRelAssociatesProfileProperties;
  class IfcRelConnects extends IfcRelationship {
    constructor(GlobalId, OwnerHistory, Name, Description) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 826625072;
    }
  }
  IFC2X32.IfcRelConnects = IfcRelConnects;
  class IfcRelConnectsElements extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ConnectionGeometry = ConnectionGeometry;
      this.RelatingElement = RelatingElement;
      this.RelatedElement = RelatedElement;
      this.type = 1204542856;
    }
  }
  IFC2X32.IfcRelConnectsElements = IfcRelConnectsElements;
  class IfcRelConnectsPathElements extends IfcRelConnectsElements {
    constructor(GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement, RelatingPriorities, RelatedPriorities, RelatedConnectionType, RelatingConnectionType) {
      super(GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ConnectionGeometry = ConnectionGeometry;
      this.RelatingElement = RelatingElement;
      this.RelatedElement = RelatedElement;
      this.RelatingPriorities = RelatingPriorities;
      this.RelatedPriorities = RelatedPriorities;
      this.RelatedConnectionType = RelatedConnectionType;
      this.RelatingConnectionType = RelatingConnectionType;
      this.type = 3945020480;
    }
  }
  IFC2X32.IfcRelConnectsPathElements = IfcRelConnectsPathElements;
  class IfcRelConnectsPortToElement extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingPort, RelatedElement) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingPort = RelatingPort;
      this.RelatedElement = RelatedElement;
      this.type = 4201705270;
    }
  }
  IFC2X32.IfcRelConnectsPortToElement = IfcRelConnectsPortToElement;
  class IfcRelConnectsPorts extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingPort, RelatedPort, RealizingElement) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingPort = RelatingPort;
      this.RelatedPort = RelatedPort;
      this.RealizingElement = RealizingElement;
      this.type = 3190031847;
    }
  }
  IFC2X32.IfcRelConnectsPorts = IfcRelConnectsPorts;
  class IfcRelConnectsStructuralActivity extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedStructuralActivity) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingElement = RelatingElement;
      this.RelatedStructuralActivity = RelatedStructuralActivity;
      this.type = 2127690289;
    }
  }
  IFC2X32.IfcRelConnectsStructuralActivity = IfcRelConnectsStructuralActivity;
  class IfcRelConnectsStructuralElement extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedStructuralMember) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingElement = RelatingElement;
      this.RelatedStructuralMember = RelatedStructuralMember;
      this.type = 3912681535;
    }
  }
  IFC2X32.IfcRelConnectsStructuralElement = IfcRelConnectsStructuralElement;
  class IfcRelConnectsStructuralMember extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingStructuralMember, RelatedStructuralConnection, AppliedCondition, AdditionalConditions, SupportedLength, ConditionCoordinateSystem) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingStructuralMember = RelatingStructuralMember;
      this.RelatedStructuralConnection = RelatedStructuralConnection;
      this.AppliedCondition = AppliedCondition;
      this.AdditionalConditions = AdditionalConditions;
      this.SupportedLength = SupportedLength;
      this.ConditionCoordinateSystem = ConditionCoordinateSystem;
      this.type = 1638771189;
    }
  }
  IFC2X32.IfcRelConnectsStructuralMember = IfcRelConnectsStructuralMember;
  class IfcRelConnectsWithEccentricity extends IfcRelConnectsStructuralMember {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingStructuralMember, RelatedStructuralConnection, AppliedCondition, AdditionalConditions, SupportedLength, ConditionCoordinateSystem, ConnectionConstraint) {
      super(GlobalId, OwnerHistory, Name, Description, RelatingStructuralMember, RelatedStructuralConnection, AppliedCondition, AdditionalConditions, SupportedLength, ConditionCoordinateSystem);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingStructuralMember = RelatingStructuralMember;
      this.RelatedStructuralConnection = RelatedStructuralConnection;
      this.AppliedCondition = AppliedCondition;
      this.AdditionalConditions = AdditionalConditions;
      this.SupportedLength = SupportedLength;
      this.ConditionCoordinateSystem = ConditionCoordinateSystem;
      this.ConnectionConstraint = ConnectionConstraint;
      this.type = 504942748;
    }
  }
  IFC2X32.IfcRelConnectsWithEccentricity = IfcRelConnectsWithEccentricity;
  class IfcRelConnectsWithRealizingElements extends IfcRelConnectsElements {
    constructor(GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement, RealizingElements, ConnectionType) {
      super(GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ConnectionGeometry = ConnectionGeometry;
      this.RelatingElement = RelatingElement;
      this.RelatedElement = RelatedElement;
      this.RealizingElements = RealizingElements;
      this.ConnectionType = ConnectionType;
      this.type = 3678494232;
    }
  }
  IFC2X32.IfcRelConnectsWithRealizingElements = IfcRelConnectsWithRealizingElements;
  class IfcRelContainedInSpatialStructure extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedElements, RelatingStructure) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedElements = RelatedElements;
      this.RelatingStructure = RelatingStructure;
      this.type = 3242617779;
    }
  }
  IFC2X32.IfcRelContainedInSpatialStructure = IfcRelContainedInSpatialStructure;
  class IfcRelCoversBldgElements extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingBuildingElement, RelatedCoverings) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingBuildingElement = RelatingBuildingElement;
      this.RelatedCoverings = RelatedCoverings;
      this.type = 886880790;
    }
  }
  IFC2X32.IfcRelCoversBldgElements = IfcRelCoversBldgElements;
  class IfcRelCoversSpaces extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedSpace, RelatedCoverings) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedSpace = RelatedSpace;
      this.RelatedCoverings = RelatedCoverings;
      this.type = 2802773753;
    }
  }
  IFC2X32.IfcRelCoversSpaces = IfcRelCoversSpaces;
  class IfcRelDecomposes extends IfcRelationship {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingObject, RelatedObjects) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingObject = RelatingObject;
      this.RelatedObjects = RelatedObjects;
      this.type = 2551354335;
    }
  }
  IFC2X32.IfcRelDecomposes = IfcRelDecomposes;
  class IfcRelDefines extends IfcRelationship {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.type = 693640335;
    }
  }
  IFC2X32.IfcRelDefines = IfcRelDefines;
  class IfcRelDefinesByProperties extends IfcRelDefines {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingPropertyDefinition) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingPropertyDefinition = RelatingPropertyDefinition;
      this.type = 4186316022;
    }
  }
  IFC2X32.IfcRelDefinesByProperties = IfcRelDefinesByProperties;
  class IfcRelDefinesByType extends IfcRelDefines {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingType) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingType = RelatingType;
      this.type = 781010003;
    }
  }
  IFC2X32.IfcRelDefinesByType = IfcRelDefinesByType;
  class IfcRelFillsElement extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingOpeningElement, RelatedBuildingElement) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingOpeningElement = RelatingOpeningElement;
      this.RelatedBuildingElement = RelatedBuildingElement;
      this.type = 3940055652;
    }
  }
  IFC2X32.IfcRelFillsElement = IfcRelFillsElement;
  class IfcRelFlowControlElements extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedControlElements, RelatingFlowElement) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedControlElements = RelatedControlElements;
      this.RelatingFlowElement = RelatingFlowElement;
      this.type = 279856033;
    }
  }
  IFC2X32.IfcRelFlowControlElements = IfcRelFlowControlElements;
  class IfcRelInteractionRequirements extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, DailyInteraction, ImportanceRating, LocationOfInteraction, RelatedSpaceProgram, RelatingSpaceProgram) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.DailyInteraction = DailyInteraction;
      this.ImportanceRating = ImportanceRating;
      this.LocationOfInteraction = LocationOfInteraction;
      this.RelatedSpaceProgram = RelatedSpaceProgram;
      this.RelatingSpaceProgram = RelatingSpaceProgram;
      this.type = 4189434867;
    }
  }
  IFC2X32.IfcRelInteractionRequirements = IfcRelInteractionRequirements;
  class IfcRelNests extends IfcRelDecomposes {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingObject, RelatedObjects) {
      super(GlobalId, OwnerHistory, Name, Description, RelatingObject, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingObject = RelatingObject;
      this.RelatedObjects = RelatedObjects;
      this.type = 3268803585;
    }
  }
  IFC2X32.IfcRelNests = IfcRelNests;
  class IfcRelOccupiesSpaces extends IfcRelAssignsToActor {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingActor, ActingRole) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingActor, ActingRole);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingActor = RelatingActor;
      this.ActingRole = ActingRole;
      this.type = 2051452291;
    }
  }
  IFC2X32.IfcRelOccupiesSpaces = IfcRelOccupiesSpaces;
  class IfcRelOverridesProperties extends IfcRelDefinesByProperties {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingPropertyDefinition, OverridingProperties) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingPropertyDefinition);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingPropertyDefinition = RelatingPropertyDefinition;
      this.OverridingProperties = OverridingProperties;
      this.type = 202636808;
    }
  }
  IFC2X32.IfcRelOverridesProperties = IfcRelOverridesProperties;
  class IfcRelProjectsElement extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedFeatureElement) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingElement = RelatingElement;
      this.RelatedFeatureElement = RelatedFeatureElement;
      this.type = 750771296;
    }
  }
  IFC2X32.IfcRelProjectsElement = IfcRelProjectsElement;
  class IfcRelReferencedInSpatialStructure extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedElements, RelatingStructure) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedElements = RelatedElements;
      this.RelatingStructure = RelatingStructure;
      this.type = 1245217292;
    }
  }
  IFC2X32.IfcRelReferencedInSpatialStructure = IfcRelReferencedInSpatialStructure;
  class IfcRelSchedulesCostItems extends IfcRelAssignsToControl {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingControl) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingControl);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingControl = RelatingControl;
      this.type = 1058617721;
    }
  }
  IFC2X32.IfcRelSchedulesCostItems = IfcRelSchedulesCostItems;
  class IfcRelSequence extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingProcess, RelatedProcess, TimeLag, SequenceType) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingProcess = RelatingProcess;
      this.RelatedProcess = RelatedProcess;
      this.TimeLag = TimeLag;
      this.SequenceType = SequenceType;
      this.type = 4122056220;
    }
  }
  IFC2X32.IfcRelSequence = IfcRelSequence;
  class IfcRelServicesBuildings extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingSystem, RelatedBuildings) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingSystem = RelatingSystem;
      this.RelatedBuildings = RelatedBuildings;
      this.type = 366585022;
    }
  }
  IFC2X32.IfcRelServicesBuildings = IfcRelServicesBuildings;
  class IfcRelSpaceBoundary extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingSpace = RelatingSpace;
      this.RelatedBuildingElement = RelatedBuildingElement;
      this.ConnectionGeometry = ConnectionGeometry;
      this.PhysicalOrVirtualBoundary = PhysicalOrVirtualBoundary;
      this.InternalOrExternalBoundary = InternalOrExternalBoundary;
      this.type = 3451746338;
    }
  }
  IFC2X32.IfcRelSpaceBoundary = IfcRelSpaceBoundary;
  class IfcRelVoidsElement extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingBuildingElement, RelatedOpeningElement) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingBuildingElement = RelatingBuildingElement;
      this.RelatedOpeningElement = RelatedOpeningElement;
      this.type = 1401173127;
    }
  }
  IFC2X32.IfcRelVoidsElement = IfcRelVoidsElement;
  class IfcResource extends IfcObject {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.type = 2914609552;
    }
  }
  IFC2X32.IfcResource = IfcResource;
  class IfcRevolvedAreaSolid extends IfcSweptAreaSolid {
    constructor(SweptArea, Position, Axis, Angle) {
      super(SweptArea, Position);
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.Axis = Axis;
      this.Angle = Angle;
      this.type = 1856042241;
    }
  }
  IFC2X32.IfcRevolvedAreaSolid = IfcRevolvedAreaSolid;
  class IfcRightCircularCone extends IfcCsgPrimitive3D {
    constructor(Position, Height, BottomRadius) {
      super(Position);
      this.Position = Position;
      this.Height = Height;
      this.BottomRadius = BottomRadius;
      this.type = 4158566097;
    }
  }
  IFC2X32.IfcRightCircularCone = IfcRightCircularCone;
  class IfcRightCircularCylinder extends IfcCsgPrimitive3D {
    constructor(Position, Height, Radius) {
      super(Position);
      this.Position = Position;
      this.Height = Height;
      this.Radius = Radius;
      this.type = 3626867408;
    }
  }
  IFC2X32.IfcRightCircularCylinder = IfcRightCircularCylinder;
  class IfcSpatialStructureElement extends IfcProduct {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.type = 2706606064;
    }
  }
  IFC2X32.IfcSpatialStructureElement = IfcSpatialStructureElement;
  class IfcSpatialStructureElementType extends IfcElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3893378262;
    }
  }
  IFC2X32.IfcSpatialStructureElementType = IfcSpatialStructureElementType;
  class IfcSphere extends IfcCsgPrimitive3D {
    constructor(Position, Radius) {
      super(Position);
      this.Position = Position;
      this.Radius = Radius;
      this.type = 451544542;
    }
  }
  IFC2X32.IfcSphere = IfcSphere;
  class IfcStructuralActivity extends IfcProduct {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.type = 3544373492;
    }
  }
  IFC2X32.IfcStructuralActivity = IfcStructuralActivity;
  class IfcStructuralItem extends IfcProduct {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.type = 3136571912;
    }
  }
  IFC2X32.IfcStructuralItem = IfcStructuralItem;
  class IfcStructuralMember extends IfcStructuralItem {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.type = 530289379;
    }
  }
  IFC2X32.IfcStructuralMember = IfcStructuralMember;
  class IfcStructuralReaction extends IfcStructuralActivity {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.type = 3689010777;
    }
  }
  IFC2X32.IfcStructuralReaction = IfcStructuralReaction;
  class IfcStructuralSurfaceMember extends IfcStructuralMember {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Thickness) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.PredefinedType = PredefinedType;
      this.Thickness = Thickness;
      this.type = 3979015343;
    }
  }
  IFC2X32.IfcStructuralSurfaceMember = IfcStructuralSurfaceMember;
  class IfcStructuralSurfaceMemberVarying extends IfcStructuralSurfaceMember {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Thickness, SubsequentThickness, VaryingThicknessLocation) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Thickness);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.PredefinedType = PredefinedType;
      this.Thickness = Thickness;
      this.SubsequentThickness = SubsequentThickness;
      this.VaryingThicknessLocation = VaryingThicknessLocation;
      this.type = 2218152070;
    }
  }
  IFC2X32.IfcStructuralSurfaceMemberVarying = IfcStructuralSurfaceMemberVarying;
  class IfcStructuredDimensionCallout extends IfcDraughtingCallout {
    constructor(Contents) {
      super(Contents);
      this.Contents = Contents;
      this.type = 4070609034;
    }
  }
  IFC2X32.IfcStructuredDimensionCallout = IfcStructuredDimensionCallout;
  class IfcSurfaceCurveSweptAreaSolid extends IfcSweptAreaSolid {
    constructor(SweptArea, Position, Directrix, StartParam, EndParam, ReferenceSurface) {
      super(SweptArea, Position);
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.Directrix = Directrix;
      this.StartParam = StartParam;
      this.EndParam = EndParam;
      this.ReferenceSurface = ReferenceSurface;
      this.type = 2028607225;
    }
  }
  IFC2X32.IfcSurfaceCurveSweptAreaSolid = IfcSurfaceCurveSweptAreaSolid;
  class IfcSurfaceOfLinearExtrusion extends IfcSweptSurface {
    constructor(SweptCurve, Position, ExtrudedDirection, Depth) {
      super(SweptCurve, Position);
      this.SweptCurve = SweptCurve;
      this.Position = Position;
      this.ExtrudedDirection = ExtrudedDirection;
      this.Depth = Depth;
      this.type = 2809605785;
    }
  }
  IFC2X32.IfcSurfaceOfLinearExtrusion = IfcSurfaceOfLinearExtrusion;
  class IfcSurfaceOfRevolution extends IfcSweptSurface {
    constructor(SweptCurve, Position, AxisPosition) {
      super(SweptCurve, Position);
      this.SweptCurve = SweptCurve;
      this.Position = Position;
      this.AxisPosition = AxisPosition;
      this.type = 4124788165;
    }
  }
  IFC2X32.IfcSurfaceOfRevolution = IfcSurfaceOfRevolution;
  class IfcSystemFurnitureElementType extends IfcFurnishingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 1580310250;
    }
  }
  IFC2X32.IfcSystemFurnitureElementType = IfcSystemFurnitureElementType;
  class IfcTask extends IfcProcess {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, TaskId, Status, WorkMethod, IsMilestone, Priority) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.TaskId = TaskId;
      this.Status = Status;
      this.WorkMethod = WorkMethod;
      this.IsMilestone = IsMilestone;
      this.Priority = Priority;
      this.type = 3473067441;
    }
  }
  IFC2X32.IfcTask = IfcTask;
  class IfcTransportElementType extends IfcElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2097647324;
    }
  }
  IFC2X32.IfcTransportElementType = IfcTransportElementType;
  class IfcActor extends IfcObject {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, TheActor) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.TheActor = TheActor;
      this.type = 2296667514;
    }
  }
  IFC2X32.IfcActor = IfcActor;
  class IfcAnnotation extends IfcProduct {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.type = 1674181508;
    }
  }
  IFC2X32.IfcAnnotation = IfcAnnotation;
  class IfcAsymmetricIShapeProfileDef extends IfcIShapeProfileDef {
    constructor(ProfileType, ProfileName, Position, OverallWidth, OverallDepth, WebThickness, FlangeThickness, FilletRadius, TopFlangeWidth, TopFlangeThickness, TopFlangeFilletRadius, CentreOfGravityInY) {
      super(ProfileType, ProfileName, Position, OverallWidth, OverallDepth, WebThickness, FlangeThickness, FilletRadius);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.OverallWidth = OverallWidth;
      this.OverallDepth = OverallDepth;
      this.WebThickness = WebThickness;
      this.FlangeThickness = FlangeThickness;
      this.FilletRadius = FilletRadius;
      this.TopFlangeWidth = TopFlangeWidth;
      this.TopFlangeThickness = TopFlangeThickness;
      this.TopFlangeFilletRadius = TopFlangeFilletRadius;
      this.CentreOfGravityInY = CentreOfGravityInY;
      this.type = 3207858831;
    }
  }
  IFC2X32.IfcAsymmetricIShapeProfileDef = IfcAsymmetricIShapeProfileDef;
  class IfcBlock extends IfcCsgPrimitive3D {
    constructor(Position, XLength, YLength, ZLength) {
      super(Position);
      this.Position = Position;
      this.XLength = XLength;
      this.YLength = YLength;
      this.ZLength = ZLength;
      this.type = 1334484129;
    }
  }
  IFC2X32.IfcBlock = IfcBlock;
  class IfcBooleanClippingResult extends IfcBooleanResult {
    constructor(Operator, FirstOperand, SecondOperand) {
      super(Operator, FirstOperand, SecondOperand);
      this.Operator = Operator;
      this.FirstOperand = FirstOperand;
      this.SecondOperand = SecondOperand;
      this.type = 3649129432;
    }
  }
  IFC2X32.IfcBooleanClippingResult = IfcBooleanClippingResult;
  class IfcBoundedCurve extends IfcCurve {
    constructor() {
      super();
      this.type = 1260505505;
    }
  }
  IFC2X32.IfcBoundedCurve = IfcBoundedCurve;
  class IfcBuilding extends IfcSpatialStructureElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, ElevationOfRefHeight, ElevationOfTerrain, BuildingAddress) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.ElevationOfRefHeight = ElevationOfRefHeight;
      this.ElevationOfTerrain = ElevationOfTerrain;
      this.BuildingAddress = BuildingAddress;
      this.type = 4031249490;
    }
  }
  IFC2X32.IfcBuilding = IfcBuilding;
  class IfcBuildingElementType extends IfcElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 1950629157;
    }
  }
  IFC2X32.IfcBuildingElementType = IfcBuildingElementType;
  class IfcBuildingStorey extends IfcSpatialStructureElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, Elevation) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.Elevation = Elevation;
      this.type = 3124254112;
    }
  }
  IFC2X32.IfcBuildingStorey = IfcBuildingStorey;
  class IfcCircleHollowProfileDef extends IfcCircleProfileDef {
    constructor(ProfileType, ProfileName, Position, Radius, WallThickness) {
      super(ProfileType, ProfileName, Position, Radius);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Radius = Radius;
      this.WallThickness = WallThickness;
      this.type = 2937912522;
    }
  }
  IFC2X32.IfcCircleHollowProfileDef = IfcCircleHollowProfileDef;
  class IfcColumnType extends IfcBuildingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 300633059;
    }
  }
  IFC2X32.IfcColumnType = IfcColumnType;
  class IfcCompositeCurve extends IfcBoundedCurve {
    constructor(Segments, SelfIntersect) {
      super();
      this.Segments = Segments;
      this.SelfIntersect = SelfIntersect;
      this.type = 3732776249;
    }
  }
  IFC2X32.IfcCompositeCurve = IfcCompositeCurve;
  class IfcConic extends IfcCurve {
    constructor(Position) {
      super();
      this.Position = Position;
      this.type = 2510884976;
    }
  }
  IFC2X32.IfcConic = IfcConic;
  class IfcConstructionResource extends IfcResource {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ResourceIdentifier = ResourceIdentifier;
      this.ResourceGroup = ResourceGroup;
      this.ResourceConsumption = ResourceConsumption;
      this.BaseQuantity = BaseQuantity;
      this.type = 2559216714;
    }
  }
  IFC2X32.IfcConstructionResource = IfcConstructionResource;
  class IfcControl extends IfcObject {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.type = 3293443760;
    }
  }
  IFC2X32.IfcControl = IfcControl;
  class IfcCostItem extends IfcControl {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.type = 3895139033;
    }
  }
  IFC2X32.IfcCostItem = IfcCostItem;
  class IfcCostSchedule extends IfcControl {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, SubmittedBy, PreparedBy, SubmittedOn, Status, TargetUsers, UpdateDate, ID, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.SubmittedBy = SubmittedBy;
      this.PreparedBy = PreparedBy;
      this.SubmittedOn = SubmittedOn;
      this.Status = Status;
      this.TargetUsers = TargetUsers;
      this.UpdateDate = UpdateDate;
      this.ID = ID;
      this.PredefinedType = PredefinedType;
      this.type = 1419761937;
    }
  }
  IFC2X32.IfcCostSchedule = IfcCostSchedule;
  class IfcCoveringType extends IfcBuildingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1916426348;
    }
  }
  IFC2X32.IfcCoveringType = IfcCoveringType;
  class IfcCrewResource extends IfcConstructionResource {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ResourceIdentifier = ResourceIdentifier;
      this.ResourceGroup = ResourceGroup;
      this.ResourceConsumption = ResourceConsumption;
      this.BaseQuantity = BaseQuantity;
      this.type = 3295246426;
    }
  }
  IFC2X32.IfcCrewResource = IfcCrewResource;
  class IfcCurtainWallType extends IfcBuildingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1457835157;
    }
  }
  IFC2X32.IfcCurtainWallType = IfcCurtainWallType;
  class IfcDimensionCurveDirectedCallout extends IfcDraughtingCallout {
    constructor(Contents) {
      super(Contents);
      this.Contents = Contents;
      this.type = 681481545;
    }
  }
  IFC2X32.IfcDimensionCurveDirectedCallout = IfcDimensionCurveDirectedCallout;
  class IfcDistributionElementType extends IfcElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3256556792;
    }
  }
  IFC2X32.IfcDistributionElementType = IfcDistributionElementType;
  class IfcDistributionFlowElementType extends IfcDistributionElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3849074793;
    }
  }
  IFC2X32.IfcDistributionFlowElementType = IfcDistributionFlowElementType;
  class IfcElectricalBaseProperties extends IfcEnergyProperties {
    constructor(GlobalId, OwnerHistory, Name, Description, EnergySequence, UserDefinedEnergySequence, ElectricCurrentType, InputVoltage, InputFrequency, FullLoadCurrent, MinimumCircuitCurrent, MaximumPowerInput, RatedPowerInput, InputPhase) {
      super(GlobalId, OwnerHistory, Name, Description, EnergySequence, UserDefinedEnergySequence);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.EnergySequence = EnergySequence;
      this.UserDefinedEnergySequence = UserDefinedEnergySequence;
      this.ElectricCurrentType = ElectricCurrentType;
      this.InputVoltage = InputVoltage;
      this.InputFrequency = InputFrequency;
      this.FullLoadCurrent = FullLoadCurrent;
      this.MinimumCircuitCurrent = MinimumCircuitCurrent;
      this.MaximumPowerInput = MaximumPowerInput;
      this.RatedPowerInput = RatedPowerInput;
      this.InputPhase = InputPhase;
      this.type = 360485395;
    }
  }
  IFC2X32.IfcElectricalBaseProperties = IfcElectricalBaseProperties;
  class IfcElement extends IfcProduct {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1758889154;
    }
  }
  IFC2X32.IfcElement = IfcElement;
  class IfcElementAssembly extends IfcElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, AssemblyPlace, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.AssemblyPlace = AssemblyPlace;
      this.PredefinedType = PredefinedType;
      this.type = 4123344466;
    }
  }
  IFC2X32.IfcElementAssembly = IfcElementAssembly;
  class IfcElementComponent extends IfcElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1623761950;
    }
  }
  IFC2X32.IfcElementComponent = IfcElementComponent;
  class IfcElementComponentType extends IfcElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 2590856083;
    }
  }
  IFC2X32.IfcElementComponentType = IfcElementComponentType;
  class IfcEllipse extends IfcConic {
    constructor(Position, SemiAxis1, SemiAxis2) {
      super(Position);
      this.Position = Position;
      this.SemiAxis1 = SemiAxis1;
      this.SemiAxis2 = SemiAxis2;
      this.type = 1704287377;
    }
  }
  IFC2X32.IfcEllipse = IfcEllipse;
  class IfcEnergyConversionDeviceType extends IfcDistributionFlowElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 2107101300;
    }
  }
  IFC2X32.IfcEnergyConversionDeviceType = IfcEnergyConversionDeviceType;
  class IfcEquipmentElement extends IfcElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1962604670;
    }
  }
  IFC2X32.IfcEquipmentElement = IfcEquipmentElement;
  class IfcEquipmentStandard extends IfcControl {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.type = 3272907226;
    }
  }
  IFC2X32.IfcEquipmentStandard = IfcEquipmentStandard;
  class IfcEvaporativeCoolerType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3174744832;
    }
  }
  IFC2X32.IfcEvaporativeCoolerType = IfcEvaporativeCoolerType;
  class IfcEvaporatorType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3390157468;
    }
  }
  IFC2X32.IfcEvaporatorType = IfcEvaporatorType;
  class IfcFacetedBrep extends IfcManifoldSolidBrep {
    constructor(Outer) {
      super(Outer);
      this.Outer = Outer;
      this.type = 807026263;
    }
  }
  IFC2X32.IfcFacetedBrep = IfcFacetedBrep;
  class IfcFacetedBrepWithVoids extends IfcManifoldSolidBrep {
    constructor(Outer, Voids) {
      super(Outer);
      this.Outer = Outer;
      this.Voids = Voids;
      this.type = 3737207727;
    }
  }
  IFC2X32.IfcFacetedBrepWithVoids = IfcFacetedBrepWithVoids;
  class IfcFastener extends IfcElementComponent {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 647756555;
    }
  }
  IFC2X32.IfcFastener = IfcFastener;
  class IfcFastenerType extends IfcElementComponentType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 2489546625;
    }
  }
  IFC2X32.IfcFastenerType = IfcFastenerType;
  class IfcFeatureElement extends IfcElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 2827207264;
    }
  }
  IFC2X32.IfcFeatureElement = IfcFeatureElement;
  class IfcFeatureElementAddition extends IfcFeatureElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 2143335405;
    }
  }
  IFC2X32.IfcFeatureElementAddition = IfcFeatureElementAddition;
  class IfcFeatureElementSubtraction extends IfcFeatureElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1287392070;
    }
  }
  IFC2X32.IfcFeatureElementSubtraction = IfcFeatureElementSubtraction;
  class IfcFlowControllerType extends IfcDistributionFlowElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3907093117;
    }
  }
  IFC2X32.IfcFlowControllerType = IfcFlowControllerType;
  class IfcFlowFittingType extends IfcDistributionFlowElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3198132628;
    }
  }
  IFC2X32.IfcFlowFittingType = IfcFlowFittingType;
  class IfcFlowMeterType extends IfcFlowControllerType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3815607619;
    }
  }
  IFC2X32.IfcFlowMeterType = IfcFlowMeterType;
  class IfcFlowMovingDeviceType extends IfcDistributionFlowElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 1482959167;
    }
  }
  IFC2X32.IfcFlowMovingDeviceType = IfcFlowMovingDeviceType;
  class IfcFlowSegmentType extends IfcDistributionFlowElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 1834744321;
    }
  }
  IFC2X32.IfcFlowSegmentType = IfcFlowSegmentType;
  class IfcFlowStorageDeviceType extends IfcDistributionFlowElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 1339347760;
    }
  }
  IFC2X32.IfcFlowStorageDeviceType = IfcFlowStorageDeviceType;
  class IfcFlowTerminalType extends IfcDistributionFlowElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 2297155007;
    }
  }
  IFC2X32.IfcFlowTerminalType = IfcFlowTerminalType;
  class IfcFlowTreatmentDeviceType extends IfcDistributionFlowElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3009222698;
    }
  }
  IFC2X32.IfcFlowTreatmentDeviceType = IfcFlowTreatmentDeviceType;
  class IfcFurnishingElement extends IfcElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 263784265;
    }
  }
  IFC2X32.IfcFurnishingElement = IfcFurnishingElement;
  class IfcFurnitureStandard extends IfcControl {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.type = 814719939;
    }
  }
  IFC2X32.IfcFurnitureStandard = IfcFurnitureStandard;
  class IfcGasTerminalType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 200128114;
    }
  }
  IFC2X32.IfcGasTerminalType = IfcGasTerminalType;
  class IfcGrid extends IfcProduct {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, UAxes, VAxes, WAxes) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.UAxes = UAxes;
      this.VAxes = VAxes;
      this.WAxes = WAxes;
      this.type = 3009204131;
    }
  }
  IFC2X32.IfcGrid = IfcGrid;
  class IfcGroup extends IfcObject {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.type = 2706460486;
    }
  }
  IFC2X32.IfcGroup = IfcGroup;
  class IfcHeatExchangerType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1251058090;
    }
  }
  IFC2X32.IfcHeatExchangerType = IfcHeatExchangerType;
  class IfcHumidifierType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1806887404;
    }
  }
  IFC2X32.IfcHumidifierType = IfcHumidifierType;
  class IfcInventory extends IfcGroup {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, InventoryType, Jurisdiction, ResponsiblePersons, LastUpdateDate, CurrentValue, OriginalValue) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.InventoryType = InventoryType;
      this.Jurisdiction = Jurisdiction;
      this.ResponsiblePersons = ResponsiblePersons;
      this.LastUpdateDate = LastUpdateDate;
      this.CurrentValue = CurrentValue;
      this.OriginalValue = OriginalValue;
      this.type = 2391368822;
    }
  }
  IFC2X32.IfcInventory = IfcInventory;
  class IfcJunctionBoxType extends IfcFlowFittingType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4288270099;
    }
  }
  IFC2X32.IfcJunctionBoxType = IfcJunctionBoxType;
  class IfcLaborResource extends IfcConstructionResource {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity, SkillSet) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ResourceIdentifier = ResourceIdentifier;
      this.ResourceGroup = ResourceGroup;
      this.ResourceConsumption = ResourceConsumption;
      this.BaseQuantity = BaseQuantity;
      this.SkillSet = SkillSet;
      this.type = 3827777499;
    }
  }
  IFC2X32.IfcLaborResource = IfcLaborResource;
  class IfcLampType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1051575348;
    }
  }
  IFC2X32.IfcLampType = IfcLampType;
  class IfcLightFixtureType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1161773419;
    }
  }
  IFC2X32.IfcLightFixtureType = IfcLightFixtureType;
  class IfcLinearDimension extends IfcDimensionCurveDirectedCallout {
    constructor(Contents) {
      super(Contents);
      this.Contents = Contents;
      this.type = 2506943328;
    }
  }
  IFC2X32.IfcLinearDimension = IfcLinearDimension;
  class IfcMechanicalFastener extends IfcFastener {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, NominalDiameter, NominalLength) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.NominalDiameter = NominalDiameter;
      this.NominalLength = NominalLength;
      this.type = 377706215;
    }
  }
  IFC2X32.IfcMechanicalFastener = IfcMechanicalFastener;
  class IfcMechanicalFastenerType extends IfcFastenerType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 2108223431;
    }
  }
  IFC2X32.IfcMechanicalFastenerType = IfcMechanicalFastenerType;
  class IfcMemberType extends IfcBuildingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3181161470;
    }
  }
  IFC2X32.IfcMemberType = IfcMemberType;
  class IfcMotorConnectionType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 977012517;
    }
  }
  IFC2X32.IfcMotorConnectionType = IfcMotorConnectionType;
  class IfcMove extends IfcTask {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, TaskId, Status, WorkMethod, IsMilestone, Priority, MoveFrom, MoveTo, PunchList) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, TaskId, Status, WorkMethod, IsMilestone, Priority);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.TaskId = TaskId;
      this.Status = Status;
      this.WorkMethod = WorkMethod;
      this.IsMilestone = IsMilestone;
      this.Priority = Priority;
      this.MoveFrom = MoveFrom;
      this.MoveTo = MoveTo;
      this.PunchList = PunchList;
      this.type = 1916936684;
    }
  }
  IFC2X32.IfcMove = IfcMove;
  class IfcOccupant extends IfcActor {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, TheActor, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, TheActor);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.TheActor = TheActor;
      this.PredefinedType = PredefinedType;
      this.type = 4143007308;
    }
  }
  IFC2X32.IfcOccupant = IfcOccupant;
  class IfcOpeningElement extends IfcFeatureElementSubtraction {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 3588315303;
    }
  }
  IFC2X32.IfcOpeningElement = IfcOpeningElement;
  class IfcOrderAction extends IfcTask {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, TaskId, Status, WorkMethod, IsMilestone, Priority, ActionID) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, TaskId, Status, WorkMethod, IsMilestone, Priority);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.TaskId = TaskId;
      this.Status = Status;
      this.WorkMethod = WorkMethod;
      this.IsMilestone = IsMilestone;
      this.Priority = Priority;
      this.ActionID = ActionID;
      this.type = 3425660407;
    }
  }
  IFC2X32.IfcOrderAction = IfcOrderAction;
  class IfcOutletType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2837617999;
    }
  }
  IFC2X32.IfcOutletType = IfcOutletType;
  class IfcPerformanceHistory extends IfcControl {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, LifeCyclePhase) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.LifeCyclePhase = LifeCyclePhase;
      this.type = 2382730787;
    }
  }
  IFC2X32.IfcPerformanceHistory = IfcPerformanceHistory;
  class IfcPermit extends IfcControl {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, PermitID) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.PermitID = PermitID;
      this.type = 3327091369;
    }
  }
  IFC2X32.IfcPermit = IfcPermit;
  class IfcPipeFittingType extends IfcFlowFittingType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 804291784;
    }
  }
  IFC2X32.IfcPipeFittingType = IfcPipeFittingType;
  class IfcPipeSegmentType extends IfcFlowSegmentType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4231323485;
    }
  }
  IFC2X32.IfcPipeSegmentType = IfcPipeSegmentType;
  class IfcPlateType extends IfcBuildingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4017108033;
    }
  }
  IFC2X32.IfcPlateType = IfcPlateType;
  class IfcPolyline extends IfcBoundedCurve {
    constructor(Points) {
      super();
      this.Points = Points;
      this.type = 3724593414;
    }
  }
  IFC2X32.IfcPolyline = IfcPolyline;
  class IfcPort extends IfcProduct {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.type = 3740093272;
    }
  }
  IFC2X32.IfcPort = IfcPort;
  class IfcProcedure extends IfcProcess {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ProcedureID, ProcedureType, UserDefinedProcedureType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ProcedureID = ProcedureID;
      this.ProcedureType = ProcedureType;
      this.UserDefinedProcedureType = UserDefinedProcedureType;
      this.type = 2744685151;
    }
  }
  IFC2X32.IfcProcedure = IfcProcedure;
  class IfcProjectOrder extends IfcControl {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ID, PredefinedType, Status) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ID = ID;
      this.PredefinedType = PredefinedType;
      this.Status = Status;
      this.type = 2904328755;
    }
  }
  IFC2X32.IfcProjectOrder = IfcProjectOrder;
  class IfcProjectOrderRecord extends IfcControl {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Records, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Records = Records;
      this.PredefinedType = PredefinedType;
      this.type = 3642467123;
    }
  }
  IFC2X32.IfcProjectOrderRecord = IfcProjectOrderRecord;
  class IfcProjectionElement extends IfcFeatureElementAddition {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 3651124850;
    }
  }
  IFC2X32.IfcProjectionElement = IfcProjectionElement;
  class IfcProtectiveDeviceType extends IfcFlowControllerType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1842657554;
    }
  }
  IFC2X32.IfcProtectiveDeviceType = IfcProtectiveDeviceType;
  class IfcPumpType extends IfcFlowMovingDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2250791053;
    }
  }
  IFC2X32.IfcPumpType = IfcPumpType;
  class IfcRadiusDimension extends IfcDimensionCurveDirectedCallout {
    constructor(Contents) {
      super(Contents);
      this.Contents = Contents;
      this.type = 3248260540;
    }
  }
  IFC2X32.IfcRadiusDimension = IfcRadiusDimension;
  class IfcRailingType extends IfcBuildingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2893384427;
    }
  }
  IFC2X32.IfcRailingType = IfcRailingType;
  class IfcRampFlightType extends IfcBuildingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2324767716;
    }
  }
  IFC2X32.IfcRampFlightType = IfcRampFlightType;
  class IfcRelAggregates extends IfcRelDecomposes {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingObject, RelatedObjects) {
      super(GlobalId, OwnerHistory, Name, Description, RelatingObject, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingObject = RelatingObject;
      this.RelatedObjects = RelatedObjects;
      this.type = 160246688;
    }
  }
  IFC2X32.IfcRelAggregates = IfcRelAggregates;
  class IfcRelAssignsTasks extends IfcRelAssignsToControl {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingControl, TimeForTask) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingControl);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingControl = RelatingControl;
      this.TimeForTask = TimeForTask;
      this.type = 2863920197;
    }
  }
  IFC2X32.IfcRelAssignsTasks = IfcRelAssignsTasks;
  class IfcSanitaryTerminalType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1768891740;
    }
  }
  IFC2X32.IfcSanitaryTerminalType = IfcSanitaryTerminalType;
  class IfcScheduleTimeControl extends IfcControl {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ActualStart, EarlyStart, LateStart, ScheduleStart, ActualFinish, EarlyFinish, LateFinish, ScheduleFinish, ScheduleDuration, ActualDuration, RemainingTime, FreeFloat, TotalFloat, IsCritical, StatusTime, StartFloat, FinishFloat, Completion) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ActualStart = ActualStart;
      this.EarlyStart = EarlyStart;
      this.LateStart = LateStart;
      this.ScheduleStart = ScheduleStart;
      this.ActualFinish = ActualFinish;
      this.EarlyFinish = EarlyFinish;
      this.LateFinish = LateFinish;
      this.ScheduleFinish = ScheduleFinish;
      this.ScheduleDuration = ScheduleDuration;
      this.ActualDuration = ActualDuration;
      this.RemainingTime = RemainingTime;
      this.FreeFloat = FreeFloat;
      this.TotalFloat = TotalFloat;
      this.IsCritical = IsCritical;
      this.StatusTime = StatusTime;
      this.StartFloat = StartFloat;
      this.FinishFloat = FinishFloat;
      this.Completion = Completion;
      this.type = 3517283431;
    }
  }
  IFC2X32.IfcScheduleTimeControl = IfcScheduleTimeControl;
  class IfcServiceLife extends IfcControl {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ServiceLifeType, ServiceLifeDuration) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ServiceLifeType = ServiceLifeType;
      this.ServiceLifeDuration = ServiceLifeDuration;
      this.type = 4105383287;
    }
  }
  IFC2X32.IfcServiceLife = IfcServiceLife;
  class IfcSite extends IfcSpatialStructureElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, RefLatitude, RefLongitude, RefElevation, LandTitleNumber, SiteAddress) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.RefLatitude = RefLatitude;
      this.RefLongitude = RefLongitude;
      this.RefElevation = RefElevation;
      this.LandTitleNumber = LandTitleNumber;
      this.SiteAddress = SiteAddress;
      this.type = 4097777520;
    }
  }
  IFC2X32.IfcSite = IfcSite;
  class IfcSlabType extends IfcBuildingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2533589738;
    }
  }
  IFC2X32.IfcSlabType = IfcSlabType;
  class IfcSpace extends IfcSpatialStructureElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, InteriorOrExteriorSpace, ElevationWithFlooring) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.InteriorOrExteriorSpace = InteriorOrExteriorSpace;
      this.ElevationWithFlooring = ElevationWithFlooring;
      this.type = 3856911033;
    }
  }
  IFC2X32.IfcSpace = IfcSpace;
  class IfcSpaceHeaterType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1305183839;
    }
  }
  IFC2X32.IfcSpaceHeaterType = IfcSpaceHeaterType;
  class IfcSpaceProgram extends IfcControl {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, SpaceProgramIdentifier, MaxRequiredArea, MinRequiredArea, RequestedLocation, StandardRequiredArea) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.SpaceProgramIdentifier = SpaceProgramIdentifier;
      this.MaxRequiredArea = MaxRequiredArea;
      this.MinRequiredArea = MinRequiredArea;
      this.RequestedLocation = RequestedLocation;
      this.StandardRequiredArea = StandardRequiredArea;
      this.type = 652456506;
    }
  }
  IFC2X32.IfcSpaceProgram = IfcSpaceProgram;
  class IfcSpaceType extends IfcSpatialStructureElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3812236995;
    }
  }
  IFC2X32.IfcSpaceType = IfcSpaceType;
  class IfcStackTerminalType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3112655638;
    }
  }
  IFC2X32.IfcStackTerminalType = IfcStackTerminalType;
  class IfcStairFlightType extends IfcBuildingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1039846685;
    }
  }
  IFC2X32.IfcStairFlightType = IfcStairFlightType;
  class IfcStructuralAction extends IfcStructuralActivity {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.DestabilizingLoad = DestabilizingLoad;
      this.CausedBy = CausedBy;
      this.type = 682877961;
    }
  }
  IFC2X32.IfcStructuralAction = IfcStructuralAction;
  class IfcStructuralConnection extends IfcStructuralItem {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedCondition = AppliedCondition;
      this.type = 1179482911;
    }
  }
  IFC2X32.IfcStructuralConnection = IfcStructuralConnection;
  class IfcStructuralCurveConnection extends IfcStructuralConnection {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedCondition = AppliedCondition;
      this.type = 4243806635;
    }
  }
  IFC2X32.IfcStructuralCurveConnection = IfcStructuralCurveConnection;
  class IfcStructuralCurveMember extends IfcStructuralMember {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.PredefinedType = PredefinedType;
      this.type = 214636428;
    }
  }
  IFC2X32.IfcStructuralCurveMember = IfcStructuralCurveMember;
  class IfcStructuralCurveMemberVarying extends IfcStructuralCurveMember {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.PredefinedType = PredefinedType;
      this.type = 2445595289;
    }
  }
  IFC2X32.IfcStructuralCurveMemberVarying = IfcStructuralCurveMemberVarying;
  class IfcStructuralLinearAction extends IfcStructuralAction {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy, ProjectedOrTrue) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.DestabilizingLoad = DestabilizingLoad;
      this.CausedBy = CausedBy;
      this.ProjectedOrTrue = ProjectedOrTrue;
      this.type = 1807405624;
    }
  }
  IFC2X32.IfcStructuralLinearAction = IfcStructuralLinearAction;
  class IfcStructuralLinearActionVarying extends IfcStructuralLinearAction {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy, ProjectedOrTrue, VaryingAppliedLoadLocation, SubsequentAppliedLoads) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy, ProjectedOrTrue);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.DestabilizingLoad = DestabilizingLoad;
      this.CausedBy = CausedBy;
      this.ProjectedOrTrue = ProjectedOrTrue;
      this.VaryingAppliedLoadLocation = VaryingAppliedLoadLocation;
      this.SubsequentAppliedLoads = SubsequentAppliedLoads;
      this.type = 1721250024;
    }
  }
  IFC2X32.IfcStructuralLinearActionVarying = IfcStructuralLinearActionVarying;
  class IfcStructuralLoadGroup extends IfcGroup {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, ActionType, ActionSource, Coefficient, Purpose) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.PredefinedType = PredefinedType;
      this.ActionType = ActionType;
      this.ActionSource = ActionSource;
      this.Coefficient = Coefficient;
      this.Purpose = Purpose;
      this.type = 1252848954;
    }
  }
  IFC2X32.IfcStructuralLoadGroup = IfcStructuralLoadGroup;
  class IfcStructuralPlanarAction extends IfcStructuralAction {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy, ProjectedOrTrue) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.DestabilizingLoad = DestabilizingLoad;
      this.CausedBy = CausedBy;
      this.ProjectedOrTrue = ProjectedOrTrue;
      this.type = 1621171031;
    }
  }
  IFC2X32.IfcStructuralPlanarAction = IfcStructuralPlanarAction;
  class IfcStructuralPlanarActionVarying extends IfcStructuralPlanarAction {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy, ProjectedOrTrue, VaryingAppliedLoadLocation, SubsequentAppliedLoads) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy, ProjectedOrTrue);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.DestabilizingLoad = DestabilizingLoad;
      this.CausedBy = CausedBy;
      this.ProjectedOrTrue = ProjectedOrTrue;
      this.VaryingAppliedLoadLocation = VaryingAppliedLoadLocation;
      this.SubsequentAppliedLoads = SubsequentAppliedLoads;
      this.type = 3987759626;
    }
  }
  IFC2X32.IfcStructuralPlanarActionVarying = IfcStructuralPlanarActionVarying;
  class IfcStructuralPointAction extends IfcStructuralAction {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.DestabilizingLoad = DestabilizingLoad;
      this.CausedBy = CausedBy;
      this.type = 2082059205;
    }
  }
  IFC2X32.IfcStructuralPointAction = IfcStructuralPointAction;
  class IfcStructuralPointConnection extends IfcStructuralConnection {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedCondition = AppliedCondition;
      this.type = 734778138;
    }
  }
  IFC2X32.IfcStructuralPointConnection = IfcStructuralPointConnection;
  class IfcStructuralPointReaction extends IfcStructuralReaction {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.type = 1235345126;
    }
  }
  IFC2X32.IfcStructuralPointReaction = IfcStructuralPointReaction;
  class IfcStructuralResultGroup extends IfcGroup {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, TheoryType, ResultForLoadGroup, IsLinear) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.TheoryType = TheoryType;
      this.ResultForLoadGroup = ResultForLoadGroup;
      this.IsLinear = IsLinear;
      this.type = 2986769608;
    }
  }
  IFC2X32.IfcStructuralResultGroup = IfcStructuralResultGroup;
  class IfcStructuralSurfaceConnection extends IfcStructuralConnection {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedCondition = AppliedCondition;
      this.type = 1975003073;
    }
  }
  IFC2X32.IfcStructuralSurfaceConnection = IfcStructuralSurfaceConnection;
  class IfcSubContractResource extends IfcConstructionResource {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity, SubContractor, JobDescription) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ResourceIdentifier = ResourceIdentifier;
      this.ResourceGroup = ResourceGroup;
      this.ResourceConsumption = ResourceConsumption;
      this.BaseQuantity = BaseQuantity;
      this.SubContractor = SubContractor;
      this.JobDescription = JobDescription;
      this.type = 148013059;
    }
  }
  IFC2X32.IfcSubContractResource = IfcSubContractResource;
  class IfcSwitchingDeviceType extends IfcFlowControllerType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2315554128;
    }
  }
  IFC2X32.IfcSwitchingDeviceType = IfcSwitchingDeviceType;
  class IfcSystem extends IfcGroup {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.type = 2254336722;
    }
  }
  IFC2X32.IfcSystem = IfcSystem;
  class IfcTankType extends IfcFlowStorageDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 5716631;
    }
  }
  IFC2X32.IfcTankType = IfcTankType;
  class IfcTimeSeriesSchedule extends IfcControl {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ApplicableDates, TimeSeriesScheduleType, TimeSeries) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ApplicableDates = ApplicableDates;
      this.TimeSeriesScheduleType = TimeSeriesScheduleType;
      this.TimeSeries = TimeSeries;
      this.type = 1637806684;
    }
  }
  IFC2X32.IfcTimeSeriesSchedule = IfcTimeSeriesSchedule;
  class IfcTransformerType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1692211062;
    }
  }
  IFC2X32.IfcTransformerType = IfcTransformerType;
  class IfcTransportElement extends IfcElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OperationType, CapacityByWeight, CapacityByNumber) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.OperationType = OperationType;
      this.CapacityByWeight = CapacityByWeight;
      this.CapacityByNumber = CapacityByNumber;
      this.type = 1620046519;
    }
  }
  IFC2X32.IfcTransportElement = IfcTransportElement;
  class IfcTrimmedCurve extends IfcBoundedCurve {
    constructor(BasisCurve, Trim1, Trim2, SenseAgreement, MasterRepresentation) {
      super();
      this.BasisCurve = BasisCurve;
      this.Trim1 = Trim1;
      this.Trim2 = Trim2;
      this.SenseAgreement = SenseAgreement;
      this.MasterRepresentation = MasterRepresentation;
      this.type = 3593883385;
    }
  }
  IFC2X32.IfcTrimmedCurve = IfcTrimmedCurve;
  class IfcTubeBundleType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1600972822;
    }
  }
  IFC2X32.IfcTubeBundleType = IfcTubeBundleType;
  class IfcUnitaryEquipmentType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1911125066;
    }
  }
  IFC2X32.IfcUnitaryEquipmentType = IfcUnitaryEquipmentType;
  class IfcValveType extends IfcFlowControllerType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 728799441;
    }
  }
  IFC2X32.IfcValveType = IfcValveType;
  class IfcVirtualElement extends IfcElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 2769231204;
    }
  }
  IFC2X32.IfcVirtualElement = IfcVirtualElement;
  class IfcWallType extends IfcBuildingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1898987631;
    }
  }
  IFC2X32.IfcWallType = IfcWallType;
  class IfcWasteTerminalType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1133259667;
    }
  }
  IFC2X32.IfcWasteTerminalType = IfcWasteTerminalType;
  class IfcWorkControl extends IfcControl {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identifier, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime, WorkControlType, UserDefinedControlType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identifier = Identifier;
      this.CreationDate = CreationDate;
      this.Creators = Creators;
      this.Purpose = Purpose;
      this.Duration = Duration;
      this.TotalFloat = TotalFloat;
      this.StartTime = StartTime;
      this.FinishTime = FinishTime;
      this.WorkControlType = WorkControlType;
      this.UserDefinedControlType = UserDefinedControlType;
      this.type = 1028945134;
    }
  }
  IFC2X32.IfcWorkControl = IfcWorkControl;
  class IfcWorkPlan extends IfcWorkControl {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identifier, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime, WorkControlType, UserDefinedControlType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identifier, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime, WorkControlType, UserDefinedControlType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identifier = Identifier;
      this.CreationDate = CreationDate;
      this.Creators = Creators;
      this.Purpose = Purpose;
      this.Duration = Duration;
      this.TotalFloat = TotalFloat;
      this.StartTime = StartTime;
      this.FinishTime = FinishTime;
      this.WorkControlType = WorkControlType;
      this.UserDefinedControlType = UserDefinedControlType;
      this.type = 4218914973;
    }
  }
  IFC2X32.IfcWorkPlan = IfcWorkPlan;
  class IfcWorkSchedule extends IfcWorkControl {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identifier, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime, WorkControlType, UserDefinedControlType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identifier, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime, WorkControlType, UserDefinedControlType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identifier = Identifier;
      this.CreationDate = CreationDate;
      this.Creators = Creators;
      this.Purpose = Purpose;
      this.Duration = Duration;
      this.TotalFloat = TotalFloat;
      this.StartTime = StartTime;
      this.FinishTime = FinishTime;
      this.WorkControlType = WorkControlType;
      this.UserDefinedControlType = UserDefinedControlType;
      this.type = 3342526732;
    }
  }
  IFC2X32.IfcWorkSchedule = IfcWorkSchedule;
  class IfcZone extends IfcGroup {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.type = 1033361043;
    }
  }
  IFC2X32.IfcZone = IfcZone;
  class Ifc2DCompositeCurve extends IfcCompositeCurve {
    constructor(Segments, SelfIntersect) {
      super(Segments, SelfIntersect);
      this.Segments = Segments;
      this.SelfIntersect = SelfIntersect;
      this.type = 1213861670;
    }
  }
  IFC2X32.Ifc2DCompositeCurve = Ifc2DCompositeCurve;
  class IfcActionRequest extends IfcControl {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, RequestID) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.RequestID = RequestID;
      this.type = 3821786052;
    }
  }
  IFC2X32.IfcActionRequest = IfcActionRequest;
  class IfcAirTerminalBoxType extends IfcFlowControllerType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1411407467;
    }
  }
  IFC2X32.IfcAirTerminalBoxType = IfcAirTerminalBoxType;
  class IfcAirTerminalType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3352864051;
    }
  }
  IFC2X32.IfcAirTerminalType = IfcAirTerminalType;
  class IfcAirToAirHeatRecoveryType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1871374353;
    }
  }
  IFC2X32.IfcAirToAirHeatRecoveryType = IfcAirToAirHeatRecoveryType;
  class IfcAngularDimension extends IfcDimensionCurveDirectedCallout {
    constructor(Contents) {
      super(Contents);
      this.Contents = Contents;
      this.type = 2470393545;
    }
  }
  IFC2X32.IfcAngularDimension = IfcAngularDimension;
  class IfcAsset extends IfcGroup {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, AssetID, OriginalValue, CurrentValue, TotalReplacementCost, Owner, User, ResponsiblePerson, IncorporationDate, DepreciatedValue) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.AssetID = AssetID;
      this.OriginalValue = OriginalValue;
      this.CurrentValue = CurrentValue;
      this.TotalReplacementCost = TotalReplacementCost;
      this.Owner = Owner;
      this.User = User;
      this.ResponsiblePerson = ResponsiblePerson;
      this.IncorporationDate = IncorporationDate;
      this.DepreciatedValue = DepreciatedValue;
      this.type = 3460190687;
    }
  }
  IFC2X32.IfcAsset = IfcAsset;
  class IfcBSplineCurve extends IfcBoundedCurve {
    constructor(Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect) {
      super();
      this.Degree = Degree;
      this.ControlPointsList = ControlPointsList;
      this.CurveForm = CurveForm;
      this.ClosedCurve = ClosedCurve;
      this.SelfIntersect = SelfIntersect;
      this.type = 1967976161;
    }
  }
  IFC2X32.IfcBSplineCurve = IfcBSplineCurve;
  class IfcBeamType extends IfcBuildingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 819618141;
    }
  }
  IFC2X32.IfcBeamType = IfcBeamType;
  class IfcBezierCurve extends IfcBSplineCurve {
    constructor(Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect) {
      super(Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect);
      this.Degree = Degree;
      this.ControlPointsList = ControlPointsList;
      this.CurveForm = CurveForm;
      this.ClosedCurve = ClosedCurve;
      this.SelfIntersect = SelfIntersect;
      this.type = 1916977116;
    }
  }
  IFC2X32.IfcBezierCurve = IfcBezierCurve;
  class IfcBoilerType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 231477066;
    }
  }
  IFC2X32.IfcBoilerType = IfcBoilerType;
  class IfcBuildingElement extends IfcElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 3299480353;
    }
  }
  IFC2X32.IfcBuildingElement = IfcBuildingElement;
  class IfcBuildingElementComponent extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 52481810;
    }
  }
  IFC2X32.IfcBuildingElementComponent = IfcBuildingElementComponent;
  class IfcBuildingElementPart extends IfcBuildingElementComponent {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 2979338954;
    }
  }
  IFC2X32.IfcBuildingElementPart = IfcBuildingElementPart;
  class IfcBuildingElementProxy extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, CompositionType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.CompositionType = CompositionType;
      this.type = 1095909175;
    }
  }
  IFC2X32.IfcBuildingElementProxy = IfcBuildingElementProxy;
  class IfcBuildingElementProxyType extends IfcBuildingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1909888760;
    }
  }
  IFC2X32.IfcBuildingElementProxyType = IfcBuildingElementProxyType;
  class IfcCableCarrierFittingType extends IfcFlowFittingType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 395041908;
    }
  }
  IFC2X32.IfcCableCarrierFittingType = IfcCableCarrierFittingType;
  class IfcCableCarrierSegmentType extends IfcFlowSegmentType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3293546465;
    }
  }
  IFC2X32.IfcCableCarrierSegmentType = IfcCableCarrierSegmentType;
  class IfcCableSegmentType extends IfcFlowSegmentType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1285652485;
    }
  }
  IFC2X32.IfcCableSegmentType = IfcCableSegmentType;
  class IfcChillerType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2951183804;
    }
  }
  IFC2X32.IfcChillerType = IfcChillerType;
  class IfcCircle extends IfcConic {
    constructor(Position, Radius) {
      super(Position);
      this.Position = Position;
      this.Radius = Radius;
      this.type = 2611217952;
    }
  }
  IFC2X32.IfcCircle = IfcCircle;
  class IfcCoilType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2301859152;
    }
  }
  IFC2X32.IfcCoilType = IfcCoilType;
  class IfcColumn extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 843113511;
    }
  }
  IFC2X32.IfcColumn = IfcColumn;
  class IfcCompressorType extends IfcFlowMovingDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3850581409;
    }
  }
  IFC2X32.IfcCompressorType = IfcCompressorType;
  class IfcCondenserType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2816379211;
    }
  }
  IFC2X32.IfcCondenserType = IfcCondenserType;
  class IfcCondition extends IfcGroup {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.type = 2188551683;
    }
  }
  IFC2X32.IfcCondition = IfcCondition;
  class IfcConditionCriterion extends IfcControl {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Criterion, CriterionDateTime) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Criterion = Criterion;
      this.CriterionDateTime = CriterionDateTime;
      this.type = 1163958913;
    }
  }
  IFC2X32.IfcConditionCriterion = IfcConditionCriterion;
  class IfcConstructionEquipmentResource extends IfcConstructionResource {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ResourceIdentifier = ResourceIdentifier;
      this.ResourceGroup = ResourceGroup;
      this.ResourceConsumption = ResourceConsumption;
      this.BaseQuantity = BaseQuantity;
      this.type = 3898045240;
    }
  }
  IFC2X32.IfcConstructionEquipmentResource = IfcConstructionEquipmentResource;
  class IfcConstructionMaterialResource extends IfcConstructionResource {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity, Suppliers, UsageRatio) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ResourceIdentifier = ResourceIdentifier;
      this.ResourceGroup = ResourceGroup;
      this.ResourceConsumption = ResourceConsumption;
      this.BaseQuantity = BaseQuantity;
      this.Suppliers = Suppliers;
      this.UsageRatio = UsageRatio;
      this.type = 1060000209;
    }
  }
  IFC2X32.IfcConstructionMaterialResource = IfcConstructionMaterialResource;
  class IfcConstructionProductResource extends IfcConstructionResource {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ResourceIdentifier = ResourceIdentifier;
      this.ResourceGroup = ResourceGroup;
      this.ResourceConsumption = ResourceConsumption;
      this.BaseQuantity = BaseQuantity;
      this.type = 488727124;
    }
  }
  IFC2X32.IfcConstructionProductResource = IfcConstructionProductResource;
  class IfcCooledBeamType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 335055490;
    }
  }
  IFC2X32.IfcCooledBeamType = IfcCooledBeamType;
  class IfcCoolingTowerType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2954562838;
    }
  }
  IFC2X32.IfcCoolingTowerType = IfcCoolingTowerType;
  class IfcCovering extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1973544240;
    }
  }
  IFC2X32.IfcCovering = IfcCovering;
  class IfcCurtainWall extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 3495092785;
    }
  }
  IFC2X32.IfcCurtainWall = IfcCurtainWall;
  class IfcDamperType extends IfcFlowControllerType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3961806047;
    }
  }
  IFC2X32.IfcDamperType = IfcDamperType;
  class IfcDiameterDimension extends IfcDimensionCurveDirectedCallout {
    constructor(Contents) {
      super(Contents);
      this.Contents = Contents;
      this.type = 4147604152;
    }
  }
  IFC2X32.IfcDiameterDimension = IfcDiameterDimension;
  class IfcDiscreteAccessory extends IfcElementComponent {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1335981549;
    }
  }
  IFC2X32.IfcDiscreteAccessory = IfcDiscreteAccessory;
  class IfcDiscreteAccessoryType extends IfcElementComponentType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 2635815018;
    }
  }
  IFC2X32.IfcDiscreteAccessoryType = IfcDiscreteAccessoryType;
  class IfcDistributionChamberElementType extends IfcDistributionFlowElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1599208980;
    }
  }
  IFC2X32.IfcDistributionChamberElementType = IfcDistributionChamberElementType;
  class IfcDistributionControlElementType extends IfcDistributionElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 2063403501;
    }
  }
  IFC2X32.IfcDistributionControlElementType = IfcDistributionControlElementType;
  class IfcDistributionElement extends IfcElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1945004755;
    }
  }
  IFC2X32.IfcDistributionElement = IfcDistributionElement;
  class IfcDistributionFlowElement extends IfcDistributionElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 3040386961;
    }
  }
  IFC2X32.IfcDistributionFlowElement = IfcDistributionFlowElement;
  class IfcDistributionPort extends IfcPort {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, FlowDirection) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.FlowDirection = FlowDirection;
      this.type = 3041715199;
    }
  }
  IFC2X32.IfcDistributionPort = IfcDistributionPort;
  class IfcDoor extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.OverallHeight = OverallHeight;
      this.OverallWidth = OverallWidth;
      this.type = 395920057;
    }
  }
  IFC2X32.IfcDoor = IfcDoor;
  class IfcDuctFittingType extends IfcFlowFittingType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 869906466;
    }
  }
  IFC2X32.IfcDuctFittingType = IfcDuctFittingType;
  class IfcDuctSegmentType extends IfcFlowSegmentType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3760055223;
    }
  }
  IFC2X32.IfcDuctSegmentType = IfcDuctSegmentType;
  class IfcDuctSilencerType extends IfcFlowTreatmentDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2030761528;
    }
  }
  IFC2X32.IfcDuctSilencerType = IfcDuctSilencerType;
  class IfcEdgeFeature extends IfcFeatureElementSubtraction {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, FeatureLength) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.FeatureLength = FeatureLength;
      this.type = 855621170;
    }
  }
  IFC2X32.IfcEdgeFeature = IfcEdgeFeature;
  class IfcElectricApplianceType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 663422040;
    }
  }
  IFC2X32.IfcElectricApplianceType = IfcElectricApplianceType;
  class IfcElectricFlowStorageDeviceType extends IfcFlowStorageDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3277789161;
    }
  }
  IFC2X32.IfcElectricFlowStorageDeviceType = IfcElectricFlowStorageDeviceType;
  class IfcElectricGeneratorType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1534661035;
    }
  }
  IFC2X32.IfcElectricGeneratorType = IfcElectricGeneratorType;
  class IfcElectricHeaterType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1365060375;
    }
  }
  IFC2X32.IfcElectricHeaterType = IfcElectricHeaterType;
  class IfcElectricMotorType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1217240411;
    }
  }
  IFC2X32.IfcElectricMotorType = IfcElectricMotorType;
  class IfcElectricTimeControlType extends IfcFlowControllerType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 712377611;
    }
  }
  IFC2X32.IfcElectricTimeControlType = IfcElectricTimeControlType;
  class IfcElectricalCircuit extends IfcSystem {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.type = 1634875225;
    }
  }
  IFC2X32.IfcElectricalCircuit = IfcElectricalCircuit;
  class IfcElectricalElement extends IfcElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 857184966;
    }
  }
  IFC2X32.IfcElectricalElement = IfcElectricalElement;
  class IfcEnergyConversionDevice extends IfcDistributionFlowElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1658829314;
    }
  }
  IFC2X32.IfcEnergyConversionDevice = IfcEnergyConversionDevice;
  class IfcFanType extends IfcFlowMovingDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 346874300;
    }
  }
  IFC2X32.IfcFanType = IfcFanType;
  class IfcFilterType extends IfcFlowTreatmentDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1810631287;
    }
  }
  IFC2X32.IfcFilterType = IfcFilterType;
  class IfcFireSuppressionTerminalType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4222183408;
    }
  }
  IFC2X32.IfcFireSuppressionTerminalType = IfcFireSuppressionTerminalType;
  class IfcFlowController extends IfcDistributionFlowElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 2058353004;
    }
  }
  IFC2X32.IfcFlowController = IfcFlowController;
  class IfcFlowFitting extends IfcDistributionFlowElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 4278956645;
    }
  }
  IFC2X32.IfcFlowFitting = IfcFlowFitting;
  class IfcFlowInstrumentType extends IfcDistributionControlElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4037862832;
    }
  }
  IFC2X32.IfcFlowInstrumentType = IfcFlowInstrumentType;
  class IfcFlowMovingDevice extends IfcDistributionFlowElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 3132237377;
    }
  }
  IFC2X32.IfcFlowMovingDevice = IfcFlowMovingDevice;
  class IfcFlowSegment extends IfcDistributionFlowElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 987401354;
    }
  }
  IFC2X32.IfcFlowSegment = IfcFlowSegment;
  class IfcFlowStorageDevice extends IfcDistributionFlowElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 707683696;
    }
  }
  IFC2X32.IfcFlowStorageDevice = IfcFlowStorageDevice;
  class IfcFlowTerminal extends IfcDistributionFlowElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 2223149337;
    }
  }
  IFC2X32.IfcFlowTerminal = IfcFlowTerminal;
  class IfcFlowTreatmentDevice extends IfcDistributionFlowElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 3508470533;
    }
  }
  IFC2X32.IfcFlowTreatmentDevice = IfcFlowTreatmentDevice;
  class IfcFooting extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 900683007;
    }
  }
  IFC2X32.IfcFooting = IfcFooting;
  class IfcMember extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1073191201;
    }
  }
  IFC2X32.IfcMember = IfcMember;
  class IfcPile extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType, ConstructionType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.ConstructionType = ConstructionType;
      this.type = 1687234759;
    }
  }
  IFC2X32.IfcPile = IfcPile;
  class IfcPlate extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 3171933400;
    }
  }
  IFC2X32.IfcPlate = IfcPlate;
  class IfcRailing extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2262370178;
    }
  }
  IFC2X32.IfcRailing = IfcRailing;
  class IfcRamp extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, ShapeType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.ShapeType = ShapeType;
      this.type = 3024970846;
    }
  }
  IFC2X32.IfcRamp = IfcRamp;
  class IfcRampFlight extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 3283111854;
    }
  }
  IFC2X32.IfcRampFlight = IfcRampFlight;
  class IfcRationalBezierCurve extends IfcBezierCurve {
    constructor(Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect, WeightsData) {
      super(Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect);
      this.Degree = Degree;
      this.ControlPointsList = ControlPointsList;
      this.CurveForm = CurveForm;
      this.ClosedCurve = ClosedCurve;
      this.SelfIntersect = SelfIntersect;
      this.WeightsData = WeightsData;
      this.type = 3055160366;
    }
  }
  IFC2X32.IfcRationalBezierCurve = IfcRationalBezierCurve;
  class IfcReinforcingElement extends IfcBuildingElementComponent {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.SteelGrade = SteelGrade;
      this.type = 3027567501;
    }
  }
  IFC2X32.IfcReinforcingElement = IfcReinforcingElement;
  class IfcReinforcingMesh extends IfcReinforcingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, MeshLength, MeshWidth, LongitudinalBarNominalDiameter, TransverseBarNominalDiameter, LongitudinalBarCrossSectionArea, TransverseBarCrossSectionArea, LongitudinalBarSpacing, TransverseBarSpacing) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.SteelGrade = SteelGrade;
      this.MeshLength = MeshLength;
      this.MeshWidth = MeshWidth;
      this.LongitudinalBarNominalDiameter = LongitudinalBarNominalDiameter;
      this.TransverseBarNominalDiameter = TransverseBarNominalDiameter;
      this.LongitudinalBarCrossSectionArea = LongitudinalBarCrossSectionArea;
      this.TransverseBarCrossSectionArea = TransverseBarCrossSectionArea;
      this.LongitudinalBarSpacing = LongitudinalBarSpacing;
      this.TransverseBarSpacing = TransverseBarSpacing;
      this.type = 2320036040;
    }
  }
  IFC2X32.IfcReinforcingMesh = IfcReinforcingMesh;
  class IfcRoof extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, ShapeType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.ShapeType = ShapeType;
      this.type = 2016517767;
    }
  }
  IFC2X32.IfcRoof = IfcRoof;
  class IfcRoundedEdgeFeature extends IfcEdgeFeature {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, FeatureLength, Radius) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, FeatureLength);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.FeatureLength = FeatureLength;
      this.Radius = Radius;
      this.type = 1376911519;
    }
  }
  IFC2X32.IfcRoundedEdgeFeature = IfcRoundedEdgeFeature;
  class IfcSensorType extends IfcDistributionControlElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1783015770;
    }
  }
  IFC2X32.IfcSensorType = IfcSensorType;
  class IfcSlab extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1529196076;
    }
  }
  IFC2X32.IfcSlab = IfcSlab;
  class IfcStair extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, ShapeType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.ShapeType = ShapeType;
      this.type = 331165859;
    }
  }
  IFC2X32.IfcStair = IfcStair;
  class IfcStairFlight extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, NumberOfRiser, NumberOfTreads, RiserHeight, TreadLength) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.NumberOfRiser = NumberOfRiser;
      this.NumberOfTreads = NumberOfTreads;
      this.RiserHeight = RiserHeight;
      this.TreadLength = TreadLength;
      this.type = 4252922144;
    }
  }
  IFC2X32.IfcStairFlight = IfcStairFlight;
  class IfcStructuralAnalysisModel extends IfcSystem {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, OrientationOf2DPlane, LoadedBy, HasResults) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.PredefinedType = PredefinedType;
      this.OrientationOf2DPlane = OrientationOf2DPlane;
      this.LoadedBy = LoadedBy;
      this.HasResults = HasResults;
      this.type = 2515109513;
    }
  }
  IFC2X32.IfcStructuralAnalysisModel = IfcStructuralAnalysisModel;
  class IfcTendon extends IfcReinforcingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, PredefinedType, NominalDiameter, CrossSectionArea, TensionForce, PreStress, FrictionCoefficient, AnchorageSlip, MinCurvatureRadius) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.SteelGrade = SteelGrade;
      this.PredefinedType = PredefinedType;
      this.NominalDiameter = NominalDiameter;
      this.CrossSectionArea = CrossSectionArea;
      this.TensionForce = TensionForce;
      this.PreStress = PreStress;
      this.FrictionCoefficient = FrictionCoefficient;
      this.AnchorageSlip = AnchorageSlip;
      this.MinCurvatureRadius = MinCurvatureRadius;
      this.type = 3824725483;
    }
  }
  IFC2X32.IfcTendon = IfcTendon;
  class IfcTendonAnchor extends IfcReinforcingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.SteelGrade = SteelGrade;
      this.type = 2347447852;
    }
  }
  IFC2X32.IfcTendonAnchor = IfcTendonAnchor;
  class IfcVibrationIsolatorType extends IfcDiscreteAccessoryType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3313531582;
    }
  }
  IFC2X32.IfcVibrationIsolatorType = IfcVibrationIsolatorType;
  class IfcWall extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 2391406946;
    }
  }
  IFC2X32.IfcWall = IfcWall;
  class IfcWallStandardCase extends IfcWall {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 3512223829;
    }
  }
  IFC2X32.IfcWallStandardCase = IfcWallStandardCase;
  class IfcWindow extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.OverallHeight = OverallHeight;
      this.OverallWidth = OverallWidth;
      this.type = 3304561284;
    }
  }
  IFC2X32.IfcWindow = IfcWindow;
  class IfcActuatorType extends IfcDistributionControlElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2874132201;
    }
  }
  IFC2X32.IfcActuatorType = IfcActuatorType;
  class IfcAlarmType extends IfcDistributionControlElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3001207471;
    }
  }
  IFC2X32.IfcAlarmType = IfcAlarmType;
  class IfcBeam extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 753842376;
    }
  }
  IFC2X32.IfcBeam = IfcBeam;
  class IfcChamferEdgeFeature extends IfcEdgeFeature {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, FeatureLength, Width, Height) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, FeatureLength);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.FeatureLength = FeatureLength;
      this.Width = Width;
      this.Height = Height;
      this.type = 2454782716;
    }
  }
  IFC2X32.IfcChamferEdgeFeature = IfcChamferEdgeFeature;
  class IfcControllerType extends IfcDistributionControlElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 578613899;
    }
  }
  IFC2X32.IfcControllerType = IfcControllerType;
  class IfcDistributionChamberElement extends IfcDistributionFlowElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1052013943;
    }
  }
  IFC2X32.IfcDistributionChamberElement = IfcDistributionChamberElement;
  class IfcDistributionControlElement extends IfcDistributionElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, ControlElementId) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.ControlElementId = ControlElementId;
      this.type = 1062813311;
    }
  }
  IFC2X32.IfcDistributionControlElement = IfcDistributionControlElement;
  class IfcElectricDistributionPoint extends IfcFlowController {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, DistributionPointFunction, UserDefinedFunction) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.DistributionPointFunction = DistributionPointFunction;
      this.UserDefinedFunction = UserDefinedFunction;
      this.type = 3700593921;
    }
  }
  IFC2X32.IfcElectricDistributionPoint = IfcElectricDistributionPoint;
  class IfcReinforcingBar extends IfcReinforcingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, NominalDiameter, CrossSectionArea, BarLength, BarRole, BarSurface) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.SteelGrade = SteelGrade;
      this.NominalDiameter = NominalDiameter;
      this.CrossSectionArea = CrossSectionArea;
      this.BarLength = BarLength;
      this.BarRole = BarRole;
      this.BarSurface = BarSurface;
      this.type = 979691226;
    }
  }
  IFC2X32.IfcReinforcingBar = IfcReinforcingBar;
})(IFC2X3 || (IFC2X3 = {}));
SchemaNames[2] = ["IFC4"];
FromRawLineData[2] = {
  3630933823: (v) => new IFC4.IfcActorRole(v[0], !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcText(!v[2] && v[2] != "" ? null : v[2].value)),
  618182010: (v) => new IFC4.IfcAddress(v[0], !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  639542469: (v) => new IFC4.IfcApplication(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcIdentifier(!v[3] && v[3] != "" ? null : v[3].value)),
  411424972: (v) => new IFC4.IfcAppliedValue(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcDate(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcDate(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), v[8], !v[9] && v[9] != "" ? null : v[9]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  130549933: (v) => new IFC4.IfcApproval(!v[0] && v[0] != "" ? null : new IFC4.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcText(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcDateTime(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcText(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new Handle(!v[8] && v[8] != "" ? null : v[8].value)),
  4037036970: (v) => new IFC4.IfcBoundaryCondition(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  1560379544: (v) => new IFC4.IfcBoundaryEdgeCondition(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : TypeInitialiser(2, v[1]), !v[2] && v[2] != "" ? null : TypeInitialiser(2, v[2]), !v[3] && v[3] != "" ? null : TypeInitialiser(2, v[3]), !v[4] && v[4] != "" ? null : TypeInitialiser(2, v[4]), !v[5] && v[5] != "" ? null : TypeInitialiser(2, v[5]), !v[6] && v[6] != "" ? null : TypeInitialiser(2, v[6])),
  3367102660: (v) => new IFC4.IfcBoundaryFaceCondition(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : TypeInitialiser(2, v[1]), !v[2] && v[2] != "" ? null : TypeInitialiser(2, v[2]), !v[3] && v[3] != "" ? null : TypeInitialiser(2, v[3])),
  1387855156: (v) => new IFC4.IfcBoundaryNodeCondition(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : TypeInitialiser(2, v[1]), !v[2] && v[2] != "" ? null : TypeInitialiser(2, v[2]), !v[3] && v[3] != "" ? null : TypeInitialiser(2, v[3]), !v[4] && v[4] != "" ? null : TypeInitialiser(2, v[4]), !v[5] && v[5] != "" ? null : TypeInitialiser(2, v[5]), !v[6] && v[6] != "" ? null : TypeInitialiser(2, v[6])),
  2069777674: (v) => new IFC4.IfcBoundaryNodeConditionWarping(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : TypeInitialiser(2, v[1]), !v[2] && v[2] != "" ? null : TypeInitialiser(2, v[2]), !v[3] && v[3] != "" ? null : TypeInitialiser(2, v[3]), !v[4] && v[4] != "" ? null : TypeInitialiser(2, v[4]), !v[5] && v[5] != "" ? null : TypeInitialiser(2, v[5]), !v[6] && v[6] != "" ? null : TypeInitialiser(2, v[6]), !v[7] && v[7] != "" ? null : TypeInitialiser(2, v[7])),
  2859738748: (_) => new IFC4.IfcConnectionGeometry(),
  2614616156: (v) => new IFC4.IfcConnectionPointGeometry(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  2732653382: (v) => new IFC4.IfcConnectionSurfaceGeometry(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  775493141: (v) => new IFC4.IfcConnectionVolumeGeometry(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  1959218052: (v) => new IFC4.IfcConstraint(new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2], !v[3] && v[3] != "" ? null : new IFC4.IfcLabel(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcDateTime(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value)),
  1785450214: (v) => new IFC4.IfcCoordinateOperation(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  1466758467: (v) => new IFC4.IfcCoordinateReferenceSystem(new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcIdentifier(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcIdentifier(!v[3] && v[3] != "" ? null : v[3].value)),
  602808272: (v) => new IFC4.IfcCostValue(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcDate(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcDate(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), v[8], !v[9] && v[9] != "" ? null : v[9]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1765591967: (v) => new IFC4.IfcDerivedUnit(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[1], !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  1045800335: (v) => new IFC4.IfcDerivedUnitElement(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : v[1].value),
  2949456006: (v) => new IFC4.IfcDimensionalExponents(!v[0] && v[0] != "" ? null : v[0].value, !v[1] && v[1] != "" ? null : v[1].value, !v[2] && v[2] != "" ? null : v[2].value, !v[3] && v[3] != "" ? null : v[3].value, !v[4] && v[4] != "" ? null : v[4].value, !v[5] && v[5] != "" ? null : v[5].value, !v[6] && v[6] != "" ? null : v[6].value),
  4294318154: (_) => new IFC4.IfcExternalInformation(),
  3200245327: (v) => new IFC4.IfcExternalReference(!v[0] && v[0] != "" ? null : new IFC4.IfcURIReference(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcIdentifier(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  2242383968: (v) => new IFC4.IfcExternallyDefinedHatchStyle(!v[0] && v[0] != "" ? null : new IFC4.IfcURIReference(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcIdentifier(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  1040185647: (v) => new IFC4.IfcExternallyDefinedSurfaceStyle(!v[0] && v[0] != "" ? null : new IFC4.IfcURIReference(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcIdentifier(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  3548104201: (v) => new IFC4.IfcExternallyDefinedTextFont(!v[0] && v[0] != "" ? null : new IFC4.IfcURIReference(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcIdentifier(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  852622518: (v) => new IFC4.IfcGridAxis(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), new IFC4.IfcBoolean(!v[2] && v[2] != "" ? null : v[2].value)),
  3020489413: (v) => new IFC4.IfcIrregularTimeSeriesValue(new IFC4.IfcDateTime(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? TypeInitialiser(2, p) : null) || []),
  2655187982: (v) => new IFC4.IfcLibraryInformation(new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcDateTime(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcURIReference(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcText(!v[5] && v[5] != "" ? null : v[5].value)),
  3452421091: (v) => new IFC4.IfcLibraryReference(!v[0] && v[0] != "" ? null : new IFC4.IfcURIReference(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcIdentifier(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLanguageId(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  4162380809: (v) => new IFC4.IfcLightDistributionData(new IFC4.IfcPlaneAngleMeasure(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcPlaneAngleMeasure(p.value) : null) || [], v[2]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcLuminousIntensityDistributionMeasure(p.value) : null) || []),
  1566485204: (v) => new IFC4.IfcLightIntensityDistribution(v[0], v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3057273783: (v) => new IFC4.IfcMapConversion(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), new IFC4.IfcLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC4.IfcLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcReal(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcReal(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcReal(!v[7] && v[7] != "" ? null : v[7].value)),
  1847130766: (v) => new IFC4.IfcMaterialClassificationRelationship(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  760658860: (_) => new IFC4.IfcMaterialDefinition(),
  248100487: (v) => new IFC4.IfcMaterialLayer(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcNonNegativeLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLogical(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcLabel(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcText(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcInteger(!v[6] && v[6] != "" ? null : v[6].value)),
  3303938423: (v) => new IFC4.IfcMaterialLayerSet(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcText(!v[2] && v[2] != "" ? null : v[2].value)),
  1847252529: (v) => new IFC4.IfcMaterialLayerWithOffsets(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcNonNegativeLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLogical(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcLabel(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcText(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcInteger(!v[6] && v[6] != "" ? null : v[6].value), v[7], new IFC4.IfcLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value)),
  2199411900: (v) => new IFC4.IfcMaterialList(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2235152071: (v) => new IFC4.IfcMaterialProfile(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcInteger(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value)),
  164193824: (v) => new IFC4.IfcMaterialProfileSet(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  552965576: (v) => new IFC4.IfcMaterialProfileWithOffsets(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcInteger(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value), new IFC4.IfcLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value)),
  1507914824: (_) => new IFC4.IfcMaterialUsageDefinition(),
  2597039031: (v) => new IFC4.IfcMeasureWithUnit(TypeInitialiser(2, v[0]), new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  3368373690: (v) => new IFC4.IfcMetric(new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2], !v[3] && v[3] != "" ? null : new IFC4.IfcLabel(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcDateTime(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), v[7], !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new Handle(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new Handle(!v[10] && v[10] != "" ? null : v[10].value)),
  2706619895: (v) => new IFC4.IfcMonetaryUnit(new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  1918398963: (v) => new IFC4.IfcNamedUnit(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]),
  3701648758: (_) => new IFC4.IfcObjectPlacement(),
  2251480897: (v) => new IFC4.IfcObjective(new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2], !v[3] && v[3] != "" ? null : new IFC4.IfcLabel(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcDateTime(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[8], v[9], !v[10] && v[10] != "" ? null : new IFC4.IfcLabel(!v[10] && v[10] != "" ? null : v[10].value)),
  4251960020: (v) => new IFC4.IfcOrganization(!v[0] && v[0] != "" ? null : new IFC4.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcText(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[4] && v[4] != "" ? null : v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1207048766: (v) => new IFC4.IfcOwnerHistory(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), v[2], v[3], !v[4] && v[4] != "" ? null : new IFC4.IfcTimeStamp(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), new IFC4.IfcTimeStamp(!v[7] && v[7] != "" ? null : v[7].value)),
  2077209135: (v) => new IFC4.IfcPerson(!v[0] && v[0] != "" ? null : new IFC4.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : v[3]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcLabel(p.value) : null) || [], !v[4] && v[4] != "" ? null : v[4]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcLabel(p.value) : null) || [], !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcLabel(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  101040310: (v) => new IFC4.IfcPersonAndOrganization(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2483315170: (v) => new IFC4.IfcPhysicalQuantity(new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value)),
  2226359599: (v) => new IFC4.IfcPhysicalSimpleQuantity(new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  3355820592: (v) => new IFC4.IfcPostalAddress(v[0], !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcLabel(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : v[4]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcLabel(p.value) : null) || [], !v[5] && v[5] != "" ? null : new IFC4.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4.IfcLabel(!v[9] && v[9] != "" ? null : v[9].value)),
  677532197: (_) => new IFC4.IfcPresentationItem(),
  2022622350: (v) => new IFC4.IfcPresentationLayerAssignment(new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[3] && v[3] != "" ? null : new IFC4.IfcIdentifier(!v[3] && v[3] != "" ? null : v[3].value)),
  1304840413: (v) => new IFC4.IfcPresentationLayerWithStyle(new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[3] && v[3] != "" ? null : new IFC4.IfcIdentifier(!v[3] && v[3] != "" ? null : v[3].value), new IFC4.IfcLogical(!v[4] && v[4] != "" ? null : v[4].value), new IFC4.IfcLogical(!v[5] && v[5] != "" ? null : v[5].value), new IFC4.IfcLogical(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3119450353: (v) => new IFC4.IfcPresentationStyle(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  2417041796: (v) => new IFC4.IfcPresentationStyleAssignment(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2095639259: (v) => new IFC4.IfcProductRepresentation(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3958567839: (v) => new IFC4.IfcProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value)),
  3843373140: (v) => new IFC4.IfcProjectedCRS(new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcIdentifier(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcIdentifier(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  986844984: (_) => new IFC4.IfcPropertyAbstraction(),
  3710013099: (v) => new IFC4.IfcPropertyEnumeration(new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? TypeInitialiser(2, p) : null) || [], !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  2044713172: (v) => new IFC4.IfcQuantityArea(new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcAreaMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  2093928680: (v) => new IFC4.IfcQuantityCount(new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcCountMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  931644368: (v) => new IFC4.IfcQuantityLength(new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  3252649465: (v) => new IFC4.IfcQuantityTime(new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcTimeMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  2405470396: (v) => new IFC4.IfcQuantityVolume(new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcVolumeMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  825690147: (v) => new IFC4.IfcQuantityWeight(new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcMassMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  3915482550: (v) => new IFC4.IfcRecurrencePattern(v[0], !v[1] && v[1] != "" ? null : v[1]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcDayInMonthNumber(p.value) : null) || [], !v[2] && v[2] != "" ? null : v[2]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcDayInWeekNumber(p.value) : null) || [], !v[3] && v[3] != "" ? null : v[3]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcMonthInYearNumber(p.value) : null) || [], !v[4] && v[4] != "" ? null : new IFC4.IfcInteger(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcInteger(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcInteger(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2433181523: (v) => new IFC4.IfcReference(!v[0] && v[0] != "" ? null : new IFC4.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcIdentifier(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : v[3]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcInteger(p.value) : null) || [], !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value)),
  1076942058: (v) => new IFC4.IfcRepresentation(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3377609919: (v) => new IFC4.IfcRepresentationContext(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value)),
  3008791417: (_) => new IFC4.IfcRepresentationItem(),
  1660063152: (v) => new IFC4.IfcRepresentationMap(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  2439245199: (v) => new IFC4.IfcResourceLevelRelationship(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value)),
  2341007311: (v) => new IFC4.IfcRoot(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value)),
  448429030: (v) => new IFC4.IfcSIUnit(v[0], v[1], v[2]),
  1054537805: (v) => new IFC4.IfcSchedulingTime(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), v[1], !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  867548509: (v) => new IFC4.IfcShapeAspect(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcText(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcLogical(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value)),
  3982875396: (v) => new IFC4.IfcShapeModel(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  4240577450: (v) => new IFC4.IfcShapeRepresentation(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2273995522: (v) => new IFC4.IfcStructuralConnectionCondition(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  2162789131: (v) => new IFC4.IfcStructuralLoad(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  3478079324: (v) => new IFC4.IfcStructuralLoadConfiguration(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[2] && v[2] != "" ? null : v[2]?.map((p) => p?.map((p2) => p2?.value && p2?.value != "" ? new IFC4.IfcLengthMeasure(p2.value) : null) || [])),
  609421318: (v) => new IFC4.IfcStructuralLoadOrResult(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  2525727697: (v) => new IFC4.IfcStructuralLoadStatic(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  3408363356: (v) => new IFC4.IfcStructuralLoadTemperature(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcThermodynamicTemperatureMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcThermodynamicTemperatureMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcThermodynamicTemperatureMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  2830218821: (v) => new IFC4.IfcStyleModel(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3958052878: (v) => new IFC4.IfcStyledItem(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  3049322572: (v) => new IFC4.IfcStyledRepresentation(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2934153892: (v) => new IFC4.IfcSurfaceReinforcementArea(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : v[1]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcLengthMeasure(p.value) : null) || [], !v[2] && v[2] != "" ? null : v[2]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcLengthMeasure(p.value) : null) || [], !v[3] && v[3] != "" ? null : new IFC4.IfcRatioMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  1300840506: (v) => new IFC4.IfcSurfaceStyle(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), v[1], v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3303107099: (v) => new IFC4.IfcSurfaceStyleLighting(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  1607154358: (v) => new IFC4.IfcSurfaceStyleRefraction(!v[0] && v[0] != "" ? null : new IFC4.IfcReal(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcReal(!v[1] && v[1] != "" ? null : v[1].value)),
  846575682: (v) => new IFC4.IfcSurfaceStyleShading(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcNormalisedRatioMeasure(!v[1] && v[1] != "" ? null : v[1].value)),
  1351298697: (v) => new IFC4.IfcSurfaceStyleWithTextures(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  626085974: (v) => new IFC4.IfcSurfaceTexture(new IFC4.IfcBoolean(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcBoolean(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcIdentifier(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : v[4]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcIdentifier(p.value) : null) || []),
  985171141: (v) => new IFC4.IfcTable(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[2] && v[2] != "" ? null : v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2043862942: (v) => new IFC4.IfcTableColumn(!v[0] && v[0] != "" ? null : new IFC4.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcText(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value)),
  531007025: (v) => new IFC4.IfcTableRow(!v[0] && v[0] != "" ? null : v[0]?.map((p) => p?.value && p?.value != "" ? TypeInitialiser(2, p) : null) || [], !v[1] && v[1] != "" ? null : new IFC4.IfcBoolean(!v[1] && v[1] != "" ? null : v[1].value)),
  1549132990: (v) => new IFC4.IfcTaskTime(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), v[1], !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), v[3], !v[4] && v[4] != "" ? null : new IFC4.IfcDuration(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcDateTime(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcDateTime(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcDateTime(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcDateTime(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4.IfcDateTime(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC4.IfcDateTime(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC4.IfcDuration(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC4.IfcDuration(!v[12] && v[12] != "" ? null : v[12].value), !v[13] && v[13] != "" ? null : new IFC4.IfcBoolean(!v[13] && v[13] != "" ? null : v[13].value), !v[14] && v[14] != "" ? null : new IFC4.IfcDateTime(!v[14] && v[14] != "" ? null : v[14].value), !v[15] && v[15] != "" ? null : new IFC4.IfcDuration(!v[15] && v[15] != "" ? null : v[15].value), !v[16] && v[16] != "" ? null : new IFC4.IfcDateTime(!v[16] && v[16] != "" ? null : v[16].value), !v[17] && v[17] != "" ? null : new IFC4.IfcDateTime(!v[17] && v[17] != "" ? null : v[17].value), !v[18] && v[18] != "" ? null : new IFC4.IfcDuration(!v[18] && v[18] != "" ? null : v[18].value), !v[19] && v[19] != "" ? null : new IFC4.IfcPositiveRatioMeasure(!v[19] && v[19] != "" ? null : v[19].value)),
  2771591690: (v) => new IFC4.IfcTaskTimeRecurring(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), v[1], !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), v[3], !v[4] && v[4] != "" ? null : new IFC4.IfcDuration(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcDateTime(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcDateTime(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcDateTime(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcDateTime(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4.IfcDateTime(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC4.IfcDateTime(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC4.IfcDuration(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC4.IfcDuration(!v[12] && v[12] != "" ? null : v[12].value), !v[13] && v[13] != "" ? null : new IFC4.IfcBoolean(!v[13] && v[13] != "" ? null : v[13].value), !v[14] && v[14] != "" ? null : new IFC4.IfcDateTime(!v[14] && v[14] != "" ? null : v[14].value), !v[15] && v[15] != "" ? null : new IFC4.IfcDuration(!v[15] && v[15] != "" ? null : v[15].value), !v[16] && v[16] != "" ? null : new IFC4.IfcDateTime(!v[16] && v[16] != "" ? null : v[16].value), !v[17] && v[17] != "" ? null : new IFC4.IfcDateTime(!v[17] && v[17] != "" ? null : v[17].value), !v[18] && v[18] != "" ? null : new IFC4.IfcDuration(!v[18] && v[18] != "" ? null : v[18].value), !v[19] && v[19] != "" ? null : new IFC4.IfcPositiveRatioMeasure(!v[19] && v[19] != "" ? null : v[19].value), new Handle(!v[20] && v[20] != "" ? null : v[20].value)),
  912023232: (v) => new IFC4.IfcTelecomAddress(v[0], !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : v[3]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcLabel(p.value) : null) || [], !v[4] && v[4] != "" ? null : v[4]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcLabel(p.value) : null) || [], !v[5] && v[5] != "" ? null : new IFC4.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcLabel(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcURIReference(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : v[8]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcURIReference(p.value) : null) || []),
  1447204868: (v) => new IFC4.IfcTextStyle(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcBoolean(!v[4] && v[4] != "" ? null : v[4].value)),
  2636378356: (v) => new IFC4.IfcTextStyleForDefinedFont(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  1640371178: (v) => new IFC4.IfcTextStyleTextModel(!v[0] && v[0] != "" ? null : TypeInitialiser(2, v[0]), !v[1] && v[1] != "" ? null : new IFC4.IfcTextAlignment(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcTextDecoration(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : TypeInitialiser(2, v[3]), !v[4] && v[4] != "" ? null : TypeInitialiser(2, v[4]), !v[5] && v[5] != "" ? null : new IFC4.IfcTextTransformation(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : TypeInitialiser(2, v[6])),
  280115917: (v) => new IFC4.IfcTextureCoordinate(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1742049831: (v) => new IFC4.IfcTextureCoordinateGenerator(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : v[2]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcReal(p.value) : null) || []),
  2552916305: (v) => new IFC4.IfcTextureMap(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  1210645708: (v) => new IFC4.IfcTextureVertex(v[0]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcParameterValue(p.value) : null) || []),
  3611470254: (v) => new IFC4.IfcTextureVertexList(v[0]?.map((p) => p?.map((p2) => p2?.value && p2?.value != "" ? new IFC4.IfcParameterValue(p2.value) : null) || [])),
  1199560280: (v) => new IFC4.IfcTimePeriod(new IFC4.IfcTime(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcTime(!v[1] && v[1] != "" ? null : v[1].value)),
  3101149627: (v) => new IFC4.IfcTimeSeries(new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), new IFC4.IfcDateTime(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcDateTime(!v[3] && v[3] != "" ? null : v[3].value), v[4], v[5], !v[6] && v[6] != "" ? null : new IFC4.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value)),
  581633288: (v) => new IFC4.IfcTimeSeriesValue(v[0]?.map((p) => p?.value && p?.value != "" ? TypeInitialiser(2, p) : null) || []),
  1377556343: (_) => new IFC4.IfcTopologicalRepresentationItem(),
  1735638870: (v) => new IFC4.IfcTopologyRepresentation(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  180925521: (v) => new IFC4.IfcUnitAssignment(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2799835756: (_) => new IFC4.IfcVertex(),
  1907098498: (v) => new IFC4.IfcVertexPoint(new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  891718957: (v) => new IFC4.IfcVirtualGridIntersection(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[1]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcLengthMeasure(p.value) : null) || []),
  1236880293: (v) => new IFC4.IfcWorkTime(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), v[1], !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcDate(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcDate(!v[5] && v[5] != "" ? null : v[5].value)),
  3869604511: (v) => new IFC4.IfcApprovalRelationship(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3798115385: (v) => new IFC4.IfcArbitraryClosedProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  1310608509: (v) => new IFC4.IfcArbitraryOpenProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  2705031697: (v) => new IFC4.IfcArbitraryProfileDefWithVoids(v[0], !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  616511568: (v) => new IFC4.IfcBlobTexture(new IFC4.IfcBoolean(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcBoolean(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcIdentifier(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : v[4]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcIdentifier(p.value) : null) || [], new IFC4.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), new IFC4.IfcBinary(!v[6] && v[6] != "" ? null : v[6].value)),
  3150382593: (v) => new IFC4.IfcCenterLineProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  747523909: (v) => new IFC4.IfcClassification(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcDate(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcLabel(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcText(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcURIReference(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcIdentifier(p.value) : null) || []),
  647927063: (v) => new IFC4.IfcClassificationReference(!v[0] && v[0] != "" ? null : new IFC4.IfcURIReference(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcIdentifier(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcText(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value)),
  3285139300: (v) => new IFC4.IfcColourRgbList(v[0]?.map((p) => p?.map((p2) => p2?.value && p2?.value != "" ? new IFC4.IfcNormalisedRatioMeasure(p2.value) : null) || [])),
  3264961684: (v) => new IFC4.IfcColourSpecification(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  1485152156: (v) => new IFC4.IfcCompositeProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[3] && v[3] != "" ? null : new IFC4.IfcLabel(!v[3] && v[3] != "" ? null : v[3].value)),
  370225590: (v) => new IFC4.IfcConnectedFaceSet(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1981873012: (v) => new IFC4.IfcConnectionCurveGeometry(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  45288368: (v) => new IFC4.IfcConnectionPointEccentricity(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value)),
  3050246964: (v) => new IFC4.IfcContextDependentUnit(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1], new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  2889183280: (v) => new IFC4.IfcConversionBasedUnit(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1], new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  2713554722: (v) => new IFC4.IfcConversionBasedUnitWithOffset(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1], new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), new Handle(!v[3] && v[3] != "" ? null : v[3].value), new IFC4.IfcReal(!v[4] && v[4] != "" ? null : v[4].value)),
  539742890: (v) => new IFC4.IfcCurrencyRelationship(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new Handle(!v[3] && v[3] != "" ? null : v[3].value), new IFC4.IfcPositiveRatioMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcDateTime(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  3800577675: (v) => new IFC4.IfcCurveStyle(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : TypeInitialiser(2, v[2]), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcBoolean(!v[4] && v[4] != "" ? null : v[4].value)),
  1105321065: (v) => new IFC4.IfcCurveStyleFont(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2367409068: (v) => new IFC4.IfcCurveStyleFontAndScaling(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), new IFC4.IfcPositiveRatioMeasure(!v[2] && v[2] != "" ? null : v[2].value)),
  3510044353: (v) => new IFC4.IfcCurveStyleFontPattern(new IFC4.IfcLengthMeasure(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value)),
  3632507154: (v) => new IFC4.IfcDerivedProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  1154170062: (v) => new IFC4.IfcDocumentInformation(new IFC4.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcText(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcURIReference(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcText(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcText(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcText(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new Handle(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : v[9]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[10] && v[10] != "" ? null : new IFC4.IfcDateTime(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC4.IfcDateTime(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC4.IfcIdentifier(!v[12] && v[12] != "" ? null : v[12].value), !v[13] && v[13] != "" ? null : new IFC4.IfcDate(!v[13] && v[13] != "" ? null : v[13].value), !v[14] && v[14] != "" ? null : new IFC4.IfcDate(!v[14] && v[14] != "" ? null : v[14].value), v[15], v[16]),
  770865208: (v) => new IFC4.IfcDocumentInformationRelationship(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  3732053477: (v) => new IFC4.IfcDocumentReference(!v[0] && v[0] != "" ? null : new IFC4.IfcURIReference(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcIdentifier(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value)),
  3900360178: (v) => new IFC4.IfcEdge(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  476780140: (v) => new IFC4.IfcEdgeCurve(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcBoolean(!v[3] && v[3] != "" ? null : v[3].value)),
  211053100: (v) => new IFC4.IfcEventTime(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), v[1], !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcDateTime(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcDateTime(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcDateTime(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcDateTime(!v[6] && v[6] != "" ? null : v[6].value)),
  297599258: (v) => new IFC4.IfcExtendedProperties(!v[0] && v[0] != "" ? null : new IFC4.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1437805879: (v) => new IFC4.IfcExternalReferenceRelationship(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2556980723: (v) => new IFC4.IfcFace(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1809719519: (v) => new IFC4.IfcFaceBound(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcBoolean(!v[1] && v[1] != "" ? null : v[1].value)),
  803316827: (v) => new IFC4.IfcFaceOuterBound(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcBoolean(!v[1] && v[1] != "" ? null : v[1].value)),
  3008276851: (v) => new IFC4.IfcFaceSurface(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[1] && v[1] != "" ? null : v[1].value), new IFC4.IfcBoolean(!v[2] && v[2] != "" ? null : v[2].value)),
  4219587988: (v) => new IFC4.IfcFailureConnectionCondition(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcForceMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcForceMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcForceMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcForceMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcForceMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcForceMeasure(!v[6] && v[6] != "" ? null : v[6].value)),
  738692330: (v) => new IFC4.IfcFillAreaStyle(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[2] && v[2] != "" ? null : new IFC4.IfcBoolean(!v[2] && v[2] != "" ? null : v[2].value)),
  3448662350: (v) => new IFC4.IfcGeometricRepresentationContext(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new IFC4.IfcDimensionCount(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcReal(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  2453401579: (_) => new IFC4.IfcGeometricRepresentationItem(),
  4142052618: (v) => new IFC4.IfcGeometricRepresentationSubContext(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcPositiveRatioMeasure(!v[3] && v[3] != "" ? null : v[3].value), v[4], !v[5] && v[5] != "" ? null : new IFC4.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value)),
  3590301190: (v) => new IFC4.IfcGeometricSet(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  178086475: (v) => new IFC4.IfcGridPlacement(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  812098782: (v) => new IFC4.IfcHalfSpaceSolid(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcBoolean(!v[1] && v[1] != "" ? null : v[1].value)),
  3905492369: (v) => new IFC4.IfcImageTexture(new IFC4.IfcBoolean(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcBoolean(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcIdentifier(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : v[4]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcIdentifier(p.value) : null) || [], new IFC4.IfcURIReference(!v[5] && v[5] != "" ? null : v[5].value)),
  3570813810: (v) => new IFC4.IfcIndexedColourMap(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcNormalisedRatioMeasure(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcPositiveInteger(p.value) : null) || []),
  1437953363: (v) => new IFC4.IfcIndexedTextureMap(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  2133299955: (v) => new IFC4.IfcIndexedTriangleTextureMap(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : v[3]?.map((p) => p?.map((p2) => p2?.value && p2?.value != "" ? new IFC4.IfcPositiveInteger(p2.value) : null) || [])),
  3741457305: (v) => new IFC4.IfcIrregularTimeSeries(new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), new IFC4.IfcDateTime(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcDateTime(!v[3] && v[3] != "" ? null : v[3].value), v[4], v[5], !v[6] && v[6] != "" ? null : new IFC4.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), v[8]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1585845231: (v) => new IFC4.IfcLagTime(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), v[1], !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), TypeInitialiser(2, v[3]), v[4]),
  1402838566: (v) => new IFC4.IfcLightSource(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcNormalisedRatioMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcNormalisedRatioMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  125510826: (v) => new IFC4.IfcLightSourceAmbient(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcNormalisedRatioMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcNormalisedRatioMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  2604431987: (v) => new IFC4.IfcLightSourceDirectional(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcNormalisedRatioMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcNormalisedRatioMeasure(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value)),
  4266656042: (v) => new IFC4.IfcLightSourceGoniometric(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcNormalisedRatioMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcNormalisedRatioMeasure(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), new IFC4.IfcThermodynamicTemperatureMeasure(!v[6] && v[6] != "" ? null : v[6].value), new IFC4.IfcLuminousFluxMeasure(!v[7] && v[7] != "" ? null : v[7].value), v[8], new Handle(!v[9] && v[9] != "" ? null : v[9].value)),
  1520743889: (v) => new IFC4.IfcLightSourcePositional(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcNormalisedRatioMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcNormalisedRatioMeasure(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new IFC4.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), new IFC4.IfcReal(!v[6] && v[6] != "" ? null : v[6].value), new IFC4.IfcReal(!v[7] && v[7] != "" ? null : v[7].value), new IFC4.IfcReal(!v[8] && v[8] != "" ? null : v[8].value)),
  3422422726: (v) => new IFC4.IfcLightSourceSpot(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcNormalisedRatioMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcNormalisedRatioMeasure(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new IFC4.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), new IFC4.IfcReal(!v[6] && v[6] != "" ? null : v[6].value), new IFC4.IfcReal(!v[7] && v[7] != "" ? null : v[7].value), new IFC4.IfcReal(!v[8] && v[8] != "" ? null : v[8].value), new Handle(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC4.IfcReal(!v[10] && v[10] != "" ? null : v[10].value), new IFC4.IfcPositivePlaneAngleMeasure(!v[11] && v[11] != "" ? null : v[11].value), new IFC4.IfcPositivePlaneAngleMeasure(!v[12] && v[12] != "" ? null : v[12].value)),
  2624227202: (v) => new IFC4.IfcLocalPlacement(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  1008929658: (_) => new IFC4.IfcLoop(),
  2347385850: (v) => new IFC4.IfcMappedItem(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  1838606355: (v) => new IFC4.IfcMaterial(new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  3708119e3: (v) => new IFC4.IfcMaterialConstituent(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcNormalisedRatioMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  2852063980: (v) => new IFC4.IfcMaterialConstituentSet(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2022407955: (v) => new IFC4.IfcMaterialDefinitionRepresentation(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  1303795690: (v) => new IFC4.IfcMaterialLayerSetUsage(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1], v[2], new IFC4.IfcLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value)),
  3079605661: (v) => new IFC4.IfcMaterialProfileSetUsage(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcCardinalPointReference(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value)),
  3404854881: (v) => new IFC4.IfcMaterialProfileSetUsageTapering(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcCardinalPointReference(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcCardinalPointReference(!v[4] && v[4] != "" ? null : v[4].value)),
  3265635763: (v) => new IFC4.IfcMaterialProperties(!v[0] && v[0] != "" ? null : new IFC4.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  853536259: (v) => new IFC4.IfcMaterialRelationship(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  2998442950: (v) => new IFC4.IfcMirroredProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcLabel(!v[3] && v[3] != "" ? null : v[3].value)),
  219451334: (v) => new IFC4.IfcObjectDefinition(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value)),
  2665983363: (v) => new IFC4.IfcOpenShell(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1411181986: (v) => new IFC4.IfcOrganizationRelationship(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1029017970: (v) => new IFC4.IfcOrientedEdge(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcBoolean(!v[1] && v[1] != "" ? null : v[1].value)),
  2529465313: (v) => new IFC4.IfcParameterizedProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  2519244187: (v) => new IFC4.IfcPath(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3021840470: (v) => new IFC4.IfcPhysicalComplexQuantity(new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new IFC4.IfcLabel(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value)),
  597895409: (v) => new IFC4.IfcPixelTexture(new IFC4.IfcBoolean(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcBoolean(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcIdentifier(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : v[4]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcIdentifier(p.value) : null) || [], new IFC4.IfcInteger(!v[5] && v[5] != "" ? null : v[5].value), new IFC4.IfcInteger(!v[6] && v[6] != "" ? null : v[6].value), new IFC4.IfcInteger(!v[7] && v[7] != "" ? null : v[7].value), v[8]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcBinary(p.value) : null) || []),
  2004835150: (v) => new IFC4.IfcPlacement(new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  1663979128: (v) => new IFC4.IfcPlanarExtent(new IFC4.IfcLengthMeasure(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value)),
  2067069095: (_) => new IFC4.IfcPoint(),
  4022376103: (v) => new IFC4.IfcPointOnCurve(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcParameterValue(!v[1] && v[1] != "" ? null : v[1].value)),
  1423911732: (v) => new IFC4.IfcPointOnSurface(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcParameterValue(!v[1] && v[1] != "" ? null : v[1].value), new IFC4.IfcParameterValue(!v[2] && v[2] != "" ? null : v[2].value)),
  2924175390: (v) => new IFC4.IfcPolyLoop(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2775532180: (v) => new IFC4.IfcPolygonalBoundedHalfSpace(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcBoolean(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  3727388367: (v) => new IFC4.IfcPreDefinedItem(new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  3778827333: (_) => new IFC4.IfcPreDefinedProperties(),
  1775413392: (v) => new IFC4.IfcPreDefinedTextFont(new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  673634403: (v) => new IFC4.IfcProductDefinitionShape(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2802850158: (v) => new IFC4.IfcProfileProperties(!v[0] && v[0] != "" ? null : new IFC4.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  2598011224: (v) => new IFC4.IfcProperty(new IFC4.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value)),
  1680319473: (v) => new IFC4.IfcPropertyDefinition(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value)),
  148025276: (v) => new IFC4.IfcPropertyDependencyRelationship(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcText(!v[4] && v[4] != "" ? null : v[4].value)),
  3357820518: (v) => new IFC4.IfcPropertySetDefinition(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value)),
  1482703590: (v) => new IFC4.IfcPropertyTemplateDefinition(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value)),
  2090586900: (v) => new IFC4.IfcQuantitySet(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value)),
  3615266464: (v) => new IFC4.IfcRectangleProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC4.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value)),
  3413951693: (v) => new IFC4.IfcRegularTimeSeries(new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), new IFC4.IfcDateTime(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcDateTime(!v[3] && v[3] != "" ? null : v[3].value), v[4], v[5], !v[6] && v[6] != "" ? null : new IFC4.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), new IFC4.IfcTimeMeasure(!v[8] && v[8] != "" ? null : v[8].value), v[9]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1580146022: (v) => new IFC4.IfcReinforcementBarProperties(new IFC4.IfcAreaMeasure(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), v[2], !v[3] && v[3] != "" ? null : new IFC4.IfcLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcCountMeasure(!v[5] && v[5] != "" ? null : v[5].value)),
  478536968: (v) => new IFC4.IfcRelationship(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value)),
  2943643501: (v) => new IFC4.IfcResourceApprovalRelationship(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  1608871552: (v) => new IFC4.IfcResourceConstraintRelationship(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1042787934: (v) => new IFC4.IfcResourceTime(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), v[1], !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcDuration(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcPositiveRatioMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcDateTime(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcDateTime(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcDuration(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4.IfcBoolean(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC4.IfcDateTime(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC4.IfcDuration(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC4.IfcPositiveRatioMeasure(!v[12] && v[12] != "" ? null : v[12].value), !v[13] && v[13] != "" ? null : new IFC4.IfcDateTime(!v[13] && v[13] != "" ? null : v[13].value), !v[14] && v[14] != "" ? null : new IFC4.IfcDateTime(!v[14] && v[14] != "" ? null : v[14].value), !v[15] && v[15] != "" ? null : new IFC4.IfcDuration(!v[15] && v[15] != "" ? null : v[15].value), !v[16] && v[16] != "" ? null : new IFC4.IfcPositiveRatioMeasure(!v[16] && v[16] != "" ? null : v[16].value), !v[17] && v[17] != "" ? null : new IFC4.IfcPositiveRatioMeasure(!v[17] && v[17] != "" ? null : v[17].value)),
  2778083089: (v) => new IFC4.IfcRoundedRectangleProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC4.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), new IFC4.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value)),
  2042790032: (v) => new IFC4.IfcSectionProperties(v[0], new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  4165799628: (v) => new IFC4.IfcSectionReinforcementProperties(new IFC4.IfcLengthMeasure(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), v[3], new Handle(!v[4] && v[4] != "" ? null : v[4].value), v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1509187699: (v) => new IFC4.IfcSectionedSpine(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  4124623270: (v) => new IFC4.IfcShellBasedSurfaceModel(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3692461612: (v) => new IFC4.IfcSimpleProperty(new IFC4.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value)),
  2609359061: (v) => new IFC4.IfcSlippageConnectionCondition(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  723233188: (_) => new IFC4.IfcSolidModel(),
  1595516126: (v) => new IFC4.IfcStructuralLoadLinearForce(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcLinearForceMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLinearForceMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcLinearForceMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLinearMomentMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcLinearMomentMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcLinearMomentMeasure(!v[6] && v[6] != "" ? null : v[6].value)),
  2668620305: (v) => new IFC4.IfcStructuralLoadPlanarForce(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcPlanarForceMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcPlanarForceMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcPlanarForceMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  2473145415: (v) => new IFC4.IfcStructuralLoadSingleDisplacement(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcPlaneAngleMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcPlaneAngleMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcPlaneAngleMeasure(!v[6] && v[6] != "" ? null : v[6].value)),
  1973038258: (v) => new IFC4.IfcStructuralLoadSingleDisplacementDistortion(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcPlaneAngleMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcPlaneAngleMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcPlaneAngleMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcCurvatureMeasure(!v[7] && v[7] != "" ? null : v[7].value)),
  1597423693: (v) => new IFC4.IfcStructuralLoadSingleForce(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcForceMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcForceMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcForceMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcTorqueMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcTorqueMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcTorqueMeasure(!v[6] && v[6] != "" ? null : v[6].value)),
  1190533807: (v) => new IFC4.IfcStructuralLoadSingleForceWarping(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcForceMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcForceMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcForceMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcTorqueMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcTorqueMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcTorqueMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcWarpingMomentMeasure(!v[7] && v[7] != "" ? null : v[7].value)),
  2233826070: (v) => new IFC4.IfcSubedge(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  2513912981: (_) => new IFC4.IfcSurface(),
  1878645084: (v) => new IFC4.IfcSurfaceStyleRendering(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcNormalisedRatioMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : TypeInitialiser(2, v[7]), v[8]),
  2247615214: (v) => new IFC4.IfcSweptAreaSolid(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  1260650574: (v) => new IFC4.IfcSweptDiskSolid(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcParameterValue(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcParameterValue(!v[4] && v[4] != "" ? null : v[4].value)),
  1096409881: (v) => new IFC4.IfcSweptDiskSolidPolygonal(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcParameterValue(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcParameterValue(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value)),
  230924584: (v) => new IFC4.IfcSweptSurface(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  3071757647: (v) => new IFC4.IfcTShapeProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC4.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), new IFC4.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), new IFC4.IfcPositiveLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcNonNegativeLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcNonNegativeLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4.IfcNonNegativeLengthMeasure(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC4.IfcPlaneAngleMeasure(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC4.IfcPlaneAngleMeasure(!v[11] && v[11] != "" ? null : v[11].value)),
  901063453: (_) => new IFC4.IfcTessellatedItem(),
  4282788508: (v) => new IFC4.IfcTextLiteral(new IFC4.IfcPresentableText(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), v[2]),
  3124975700: (v) => new IFC4.IfcTextLiteralWithExtent(new IFC4.IfcPresentableText(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), v[2], new Handle(!v[3] && v[3] != "" ? null : v[3].value), new IFC4.IfcBoxAlignment(!v[4] && v[4] != "" ? null : v[4].value)),
  1983826977: (v) => new IFC4.IfcTextStyleFontModel(new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcTextFontName(p.value) : null) || [], !v[2] && v[2] != "" ? null : new IFC4.IfcFontStyle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcFontVariant(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcFontWeight(!v[4] && v[4] != "" ? null : v[4].value), TypeInitialiser(2, v[5])),
  2715220739: (v) => new IFC4.IfcTrapeziumProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC4.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), new IFC4.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), new IFC4.IfcLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value)),
  1628702193: (v) => new IFC4.IfcTypeObject(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3736923433: (v) => new IFC4.IfcTypeProcess(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : new IFC4.IfcIdentifier(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcText(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  2347495698: (v) => new IFC4.IfcTypeProduct(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value)),
  3698973494: (v) => new IFC4.IfcTypeResource(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : new IFC4.IfcIdentifier(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcText(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  427810014: (v) => new IFC4.IfcUShapeProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC4.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), new IFC4.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), new IFC4.IfcPositiveLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcNonNegativeLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcNonNegativeLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4.IfcPlaneAngleMeasure(!v[9] && v[9] != "" ? null : v[9].value)),
  1417489154: (v) => new IFC4.IfcVector(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value)),
  2759199220: (v) => new IFC4.IfcVertexLoop(new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  1299126871: (v) => new IFC4.IfcWindowStyle(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), v[8], v[9], new IFC4.IfcBoolean(!v[10] && v[10] != "" ? null : v[10].value), new IFC4.IfcBoolean(!v[11] && v[11] != "" ? null : v[11].value)),
  2543172580: (v) => new IFC4.IfcZShapeProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC4.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), new IFC4.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), new IFC4.IfcPositiveLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcNonNegativeLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcNonNegativeLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value)),
  3406155212: (v) => new IFC4.IfcAdvancedFace(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[1] && v[1] != "" ? null : v[1].value), new IFC4.IfcBoolean(!v[2] && v[2] != "" ? null : v[2].value)),
  669184980: (v) => new IFC4.IfcAnnotationFillArea(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3207858831: (v) => new IFC4.IfcAsymmetricIShapeProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC4.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), new IFC4.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), new IFC4.IfcPositiveLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcNonNegativeLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value), new IFC4.IfcPositiveLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC4.IfcNonNegativeLengthMeasure(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC4.IfcNonNegativeLengthMeasure(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC4.IfcPlaneAngleMeasure(!v[12] && v[12] != "" ? null : v[12].value), !v[13] && v[13] != "" ? null : new IFC4.IfcNonNegativeLengthMeasure(!v[13] && v[13] != "" ? null : v[13].value), !v[14] && v[14] != "" ? null : new IFC4.IfcPlaneAngleMeasure(!v[14] && v[14] != "" ? null : v[14].value)),
  4261334040: (v) => new IFC4.IfcAxis1Placement(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  3125803723: (v) => new IFC4.IfcAxis2Placement2D(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  2740243338: (v) => new IFC4.IfcAxis2Placement3D(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  2736907675: (v) => new IFC4.IfcBooleanResult(v[0], new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  4182860854: (_) => new IFC4.IfcBoundedSurface(),
  2581212453: (v) => new IFC4.IfcBoundingBox(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), new IFC4.IfcPositiveLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  2713105998: (v) => new IFC4.IfcBoxedHalfSpace(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcBoolean(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  2898889636: (v) => new IFC4.IfcCShapeProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC4.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), new IFC4.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), new IFC4.IfcPositiveLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcNonNegativeLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value)),
  1123145078: (v) => new IFC4.IfcCartesianPoint(v[0]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcLengthMeasure(p.value) : null) || []),
  574549367: (_) => new IFC4.IfcCartesianPointList(),
  1675464909: (v) => new IFC4.IfcCartesianPointList2D(v[0]?.map((p) => p?.map((p2) => p2?.value && p2?.value != "" ? new IFC4.IfcLengthMeasure(p2.value) : null) || [])),
  2059837836: (v) => new IFC4.IfcCartesianPointList3D(v[0]?.map((p) => p?.map((p2) => p2?.value && p2?.value != "" ? new IFC4.IfcLengthMeasure(p2.value) : null) || [])),
  59481748: (v) => new IFC4.IfcCartesianTransformationOperator(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcReal(!v[3] && v[3] != "" ? null : v[3].value)),
  3749851601: (v) => new IFC4.IfcCartesianTransformationOperator2D(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcReal(!v[3] && v[3] != "" ? null : v[3].value)),
  3486308946: (v) => new IFC4.IfcCartesianTransformationOperator2DnonUniform(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcReal(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcReal(!v[4] && v[4] != "" ? null : v[4].value)),
  3331915920: (v) => new IFC4.IfcCartesianTransformationOperator3D(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcReal(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value)),
  1416205885: (v) => new IFC4.IfcCartesianTransformationOperator3DnonUniform(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcReal(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcReal(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcReal(!v[6] && v[6] != "" ? null : v[6].value)),
  1383045692: (v) => new IFC4.IfcCircleProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  2205249479: (v) => new IFC4.IfcClosedShell(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  776857604: (v) => new IFC4.IfcColourRgb(!v[0] && v[0] != "" ? null : new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcNormalisedRatioMeasure(!v[1] && v[1] != "" ? null : v[1].value), new IFC4.IfcNormalisedRatioMeasure(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcNormalisedRatioMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  2542286263: (v) => new IFC4.IfcComplexProperty(new IFC4.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), new IFC4.IfcIdentifier(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2485617015: (v) => new IFC4.IfcCompositeCurveSegment(v[0], new IFC4.IfcBoolean(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  2574617495: (v) => new IFC4.IfcConstructionResourceType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : new IFC4.IfcIdentifier(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcText(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : v[9]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[10] && v[10] != "" ? null : new Handle(!v[10] && v[10] != "" ? null : v[10].value)),
  3419103109: (v) => new IFC4.IfcContext(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[8] && v[8] != "" ? null : new Handle(!v[8] && v[8] != "" ? null : v[8].value)),
  1815067380: (v) => new IFC4.IfcCrewResourceType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : new IFC4.IfcIdentifier(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcText(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : v[9]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[10] && v[10] != "" ? null : new Handle(!v[10] && v[10] != "" ? null : v[10].value), v[11]),
  2506170314: (v) => new IFC4.IfcCsgPrimitive3D(new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  2147822146: (v) => new IFC4.IfcCsgSolid(new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  2601014836: (_) => new IFC4.IfcCurve(),
  2827736869: (v) => new IFC4.IfcCurveBoundedPlane(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2629017746: (v) => new IFC4.IfcCurveBoundedSurface(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new IFC4.IfcBoolean(!v[2] && v[2] != "" ? null : v[2].value)),
  32440307: (v) => new IFC4.IfcDirection(v[0]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcReal(p.value) : null) || []),
  526551008: (v) => new IFC4.IfcDoorStyle(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), v[8], v[9], new IFC4.IfcBoolean(!v[10] && v[10] != "" ? null : v[10].value), new IFC4.IfcBoolean(!v[11] && v[11] != "" ? null : v[11].value)),
  1472233963: (v) => new IFC4.IfcEdgeLoop(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1883228015: (v) => new IFC4.IfcElementQuantity(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  339256511: (v) => new IFC4.IfcElementType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  2777663545: (v) => new IFC4.IfcElementarySurface(new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  2835456948: (v) => new IFC4.IfcEllipseProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC4.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value)),
  4024345920: (v) => new IFC4.IfcEventType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : new IFC4.IfcIdentifier(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcText(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9], v[10], !v[11] && v[11] != "" ? null : new IFC4.IfcLabel(!v[11] && v[11] != "" ? null : v[11].value)),
  477187591: (v) => new IFC4.IfcExtrudedAreaSolid(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  2804161546: (v) => new IFC4.IfcExtrudedAreaSolidTapered(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value)),
  2047409740: (v) => new IFC4.IfcFaceBasedSurfaceModel(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  374418227: (v) => new IFC4.IfcFillAreaStyleHatching(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value), new IFC4.IfcPlaneAngleMeasure(!v[4] && v[4] != "" ? null : v[4].value)),
  315944413: (v) => new IFC4.IfcFillAreaStyleTiles(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new IFC4.IfcPositiveRatioMeasure(!v[2] && v[2] != "" ? null : v[2].value)),
  2652556860: (v) => new IFC4.IfcFixedReferenceSweptAreaSolid(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcParameterValue(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcParameterValue(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  4238390223: (v) => new IFC4.IfcFurnishingElementType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  1268542332: (v) => new IFC4.IfcFurnitureType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9], v[10]),
  4095422895: (v) => new IFC4.IfcGeographicElementType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  987898635: (v) => new IFC4.IfcGeometricCurveSet(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1484403080: (v) => new IFC4.IfcIShapeProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC4.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), new IFC4.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), new IFC4.IfcPositiveLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcNonNegativeLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcNonNegativeLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4.IfcPlaneAngleMeasure(!v[9] && v[9] != "" ? null : v[9].value)),
  178912537: (v) => new IFC4.IfcIndexedPolygonalFace(v[0]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcPositiveInteger(p.value) : null) || []),
  2294589976: (v) => new IFC4.IfcIndexedPolygonalFaceWithVoids(v[0]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcPositiveInteger(p.value) : null) || [], v[1]?.map((p) => p?.map((p2) => p2?.value && p2?.value != "" ? new IFC4.IfcPositiveInteger(p2.value) : null) || [])),
  572779678: (v) => new IFC4.IfcLShapeProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), new IFC4.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcNonNegativeLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcNonNegativeLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcPlaneAngleMeasure(!v[8] && v[8] != "" ? null : v[8].value)),
  428585644: (v) => new IFC4.IfcLaborResourceType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : new IFC4.IfcIdentifier(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcText(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : v[9]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[10] && v[10] != "" ? null : new Handle(!v[10] && v[10] != "" ? null : v[10].value), v[11]),
  1281925730: (v) => new IFC4.IfcLine(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  1425443689: (v) => new IFC4.IfcManifoldSolidBrep(new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  3888040117: (v) => new IFC4.IfcObject(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  3388369263: (v) => new IFC4.IfcOffsetCurve2D(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), new IFC4.IfcLogical(!v[2] && v[2] != "" ? null : v[2].value)),
  3505215534: (v) => new IFC4.IfcOffsetCurve3D(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), new IFC4.IfcLogical(!v[2] && v[2] != "" ? null : v[2].value), new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  1682466193: (v) => new IFC4.IfcPcurve(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  603570806: (v) => new IFC4.IfcPlanarBox(new IFC4.IfcLengthMeasure(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  220341763: (v) => new IFC4.IfcPlane(new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  759155922: (v) => new IFC4.IfcPreDefinedColour(new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  2559016684: (v) => new IFC4.IfcPreDefinedCurveFont(new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  3967405729: (v) => new IFC4.IfcPreDefinedPropertySet(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value)),
  569719735: (v) => new IFC4.IfcProcedureType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : new IFC4.IfcIdentifier(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcText(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2945172077: (v) => new IFC4.IfcProcess(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcText(!v[6] && v[6] != "" ? null : v[6].value)),
  4208778838: (v) => new IFC4.IfcProduct(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  103090709: (v) => new IFC4.IfcProject(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[8] && v[8] != "" ? null : new Handle(!v[8] && v[8] != "" ? null : v[8].value)),
  653396225: (v) => new IFC4.IfcProjectLibrary(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[8] && v[8] != "" ? null : new Handle(!v[8] && v[8] != "" ? null : v[8].value)),
  871118103: (v) => new IFC4.IfcPropertyBoundedValue(new IFC4.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : TypeInitialiser(2, v[2]), !v[3] && v[3] != "" ? null : TypeInitialiser(2, v[3]), !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : TypeInitialiser(2, v[5])),
  4166981789: (v) => new IFC4.IfcPropertyEnumeratedValue(new IFC4.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : v[2]?.map((p) => p?.value && p?.value != "" ? TypeInitialiser(2, p) : null) || [], !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  2752243245: (v) => new IFC4.IfcPropertyListValue(new IFC4.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : v[2]?.map((p) => p?.value && p?.value != "" ? TypeInitialiser(2, p) : null) || [], !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  941946838: (v) => new IFC4.IfcPropertyReferenceValue(new IFC4.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcText(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  1451395588: (v) => new IFC4.IfcPropertySet(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  492091185: (v) => new IFC4.IfcPropertySetTemplate(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4], !v[5] && v[5] != "" ? null : new IFC4.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3650150729: (v) => new IFC4.IfcPropertySingleValue(new IFC4.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : TypeInitialiser(2, v[2]), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  110355661: (v) => new IFC4.IfcPropertyTableValue(new IFC4.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : v[2]?.map((p) => p?.value && p?.value != "" ? TypeInitialiser(2, p) : null) || [], !v[3] && v[3] != "" ? null : v[3]?.map((p) => p?.value && p?.value != "" ? TypeInitialiser(2, p) : null) || [], !v[4] && v[4] != "" ? null : new IFC4.IfcText(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), v[7]),
  3521284610: (v) => new IFC4.IfcPropertyTemplate(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value)),
  3219374653: (v) => new IFC4.IfcProxy(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), v[7], !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  2770003689: (v) => new IFC4.IfcRectangleHollowProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC4.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), new IFC4.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcNonNegativeLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcNonNegativeLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value)),
  2798486643: (v) => new IFC4.IfcRectangularPyramid(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), new IFC4.IfcPositiveLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  3454111270: (v) => new IFC4.IfcRectangularTrimmedSurface(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcParameterValue(!v[1] && v[1] != "" ? null : v[1].value), new IFC4.IfcParameterValue(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcParameterValue(!v[3] && v[3] != "" ? null : v[3].value), new IFC4.IfcParameterValue(!v[4] && v[4] != "" ? null : v[4].value), new IFC4.IfcBoolean(!v[5] && v[5] != "" ? null : v[5].value), new IFC4.IfcBoolean(!v[6] && v[6] != "" ? null : v[6].value)),
  3765753017: (v) => new IFC4.IfcReinforcementDefinitionProperties(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3939117080: (v) => new IFC4.IfcRelAssigns(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[5]),
  1683148259: (v) => new IFC4.IfcRelAssignsToActor(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[5], new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value)),
  2495723537: (v) => new IFC4.IfcRelAssignsToControl(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[5], new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  1307041759: (v) => new IFC4.IfcRelAssignsToGroup(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[5], new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  1027710054: (v) => new IFC4.IfcRelAssignsToGroupByFactor(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[5], new Handle(!v[6] && v[6] != "" ? null : v[6].value), new IFC4.IfcRatioMeasure(!v[7] && v[7] != "" ? null : v[7].value)),
  4278684876: (v) => new IFC4.IfcRelAssignsToProcess(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[5], new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value)),
  2857406711: (v) => new IFC4.IfcRelAssignsToProduct(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[5], new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  205026976: (v) => new IFC4.IfcRelAssignsToResource(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[5], new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  1865459582: (v) => new IFC4.IfcRelAssociates(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  4095574036: (v) => new IFC4.IfcRelAssociatesApproval(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  919958153: (v) => new IFC4.IfcRelAssociatesClassification(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  2728634034: (v) => new IFC4.IfcRelAssociatesConstraint(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[5] && v[5] != "" ? null : new IFC4.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value), new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  982818633: (v) => new IFC4.IfcRelAssociatesDocument(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  3840914261: (v) => new IFC4.IfcRelAssociatesLibrary(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  2655215786: (v) => new IFC4.IfcRelAssociatesMaterial(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  826625072: (v) => new IFC4.IfcRelConnects(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value)),
  1204542856: (v) => new IFC4.IfcRelConnectsElements(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value), new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  3945020480: (v) => new IFC4.IfcRelConnectsPathElements(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value), new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : v[7]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcInteger(p.value) : null) || [], !v[8] && v[8] != "" ? null : v[8]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcInteger(p.value) : null) || [], v[9], v[10]),
  4201705270: (v) => new IFC4.IfcRelConnectsPortToElement(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  3190031847: (v) => new IFC4.IfcRelConnectsPorts(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  2127690289: (v) => new IFC4.IfcRelConnectsStructuralActivity(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  1638771189: (v) => new IFC4.IfcRelConnectsStructuralMember(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new Handle(!v[9] && v[9] != "" ? null : v[9].value)),
  504942748: (v) => new IFC4.IfcRelConnectsWithEccentricity(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new Handle(!v[9] && v[9] != "" ? null : v[9].value), new Handle(!v[10] && v[10] != "" ? null : v[10].value)),
  3678494232: (v) => new IFC4.IfcRelConnectsWithRealizingElements(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value), new Handle(!v[6] && v[6] != "" ? null : v[6].value), v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  3242617779: (v) => new IFC4.IfcRelContainedInSpatialStructure(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  886880790: (v) => new IFC4.IfcRelCoversBldgElements(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2802773753: (v) => new IFC4.IfcRelCoversSpaces(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2565941209: (v) => new IFC4.IfcRelDeclares(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2551354335: (v) => new IFC4.IfcRelDecomposes(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value)),
  693640335: (v) => new IFC4.IfcRelDefines(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value)),
  1462361463: (v) => new IFC4.IfcRelDefinesByObject(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  4186316022: (v) => new IFC4.IfcRelDefinesByProperties(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  307848117: (v) => new IFC4.IfcRelDefinesByTemplate(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  781010003: (v) => new IFC4.IfcRelDefinesByType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  3940055652: (v) => new IFC4.IfcRelFillsElement(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  279856033: (v) => new IFC4.IfcRelFlowControlElements(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  427948657: (v) => new IFC4.IfcRelInterferesElements(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : v[8].value),
  3268803585: (v) => new IFC4.IfcRelNests(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  750771296: (v) => new IFC4.IfcRelProjectsElement(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  1245217292: (v) => new IFC4.IfcRelReferencedInSpatialStructure(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  4122056220: (v) => new IFC4.IfcRelSequence(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), v[7], !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  366585022: (v) => new IFC4.IfcRelServicesBuildings(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3451746338: (v) => new IFC4.IfcRelSpaceBoundary(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), v[7], v[8]),
  3523091289: (v) => new IFC4.IfcRelSpaceBoundary1stLevel(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), v[7], v[8], !v[9] && v[9] != "" ? null : new Handle(!v[9] && v[9] != "" ? null : v[9].value)),
  1521410863: (v) => new IFC4.IfcRelSpaceBoundary2ndLevel(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), v[7], v[8], !v[9] && v[9] != "" ? null : new Handle(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new Handle(!v[10] && v[10] != "" ? null : v[10].value)),
  1401173127: (v) => new IFC4.IfcRelVoidsElement(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  816062949: (v) => new IFC4.IfcReparametrisedCompositeCurveSegment(v[0], new IFC4.IfcBoolean(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcParameterValue(!v[3] && v[3] != "" ? null : v[3].value)),
  2914609552: (v) => new IFC4.IfcResource(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcText(!v[6] && v[6] != "" ? null : v[6].value)),
  1856042241: (v) => new IFC4.IfcRevolvedAreaSolid(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcPlaneAngleMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  3243963512: (v) => new IFC4.IfcRevolvedAreaSolidTapered(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcPlaneAngleMeasure(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value)),
  4158566097: (v) => new IFC4.IfcRightCircularCone(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), new IFC4.IfcPositiveLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value)),
  3626867408: (v) => new IFC4.IfcRightCircularCylinder(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), new IFC4.IfcPositiveLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value)),
  3663146110: (v) => new IFC4.IfcSimplePropertyTemplate(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4], !v[5] && v[5] != "" ? null : new IFC4.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new Handle(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new Handle(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC4.IfcLabel(!v[10] && v[10] != "" ? null : v[10].value), v[11]),
  1412071761: (v) => new IFC4.IfcSpatialElement(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value)),
  710998568: (v) => new IFC4.IfcSpatialElementType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  2706606064: (v) => new IFC4.IfcSpatialStructureElement(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3893378262: (v) => new IFC4.IfcSpatialStructureElementType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  463610769: (v) => new IFC4.IfcSpatialZone(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  2481509218: (v) => new IFC4.IfcSpatialZoneType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9], !v[10] && v[10] != "" ? null : new IFC4.IfcLabel(!v[10] && v[10] != "" ? null : v[10].value)),
  451544542: (v) => new IFC4.IfcSphere(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value)),
  4015995234: (v) => new IFC4.IfcSphericalSurface(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value)),
  3544373492: (v) => new IFC4.IfcStructuralActivity(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), new Handle(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3136571912: (v) => new IFC4.IfcStructuralItem(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  530289379: (v) => new IFC4.IfcStructuralMember(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  3689010777: (v) => new IFC4.IfcStructuralReaction(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), new Handle(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3979015343: (v) => new IFC4.IfcStructuralSurfaceMember(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), v[7], !v[8] && v[8] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value)),
  2218152070: (v) => new IFC4.IfcStructuralSurfaceMemberVarying(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), v[7], !v[8] && v[8] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value)),
  603775116: (v) => new IFC4.IfcStructuralSurfaceReaction(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), new Handle(!v[7] && v[7] != "" ? null : v[7].value), v[8], v[9]),
  4095615324: (v) => new IFC4.IfcSubContractResourceType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : new IFC4.IfcIdentifier(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcText(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : v[9]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[10] && v[10] != "" ? null : new Handle(!v[10] && v[10] != "" ? null : v[10].value), v[11]),
  699246055: (v) => new IFC4.IfcSurfaceCurve(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[2]),
  2028607225: (v) => new IFC4.IfcSurfaceCurveSweptAreaSolid(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcParameterValue(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcParameterValue(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  2809605785: (v) => new IFC4.IfcSurfaceOfLinearExtrusion(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  4124788165: (v) => new IFC4.IfcSurfaceOfRevolution(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  1580310250: (v) => new IFC4.IfcSystemFurnitureElementType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3473067441: (v) => new IFC4.IfcTask(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcText(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), new IFC4.IfcBoolean(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC4.IfcInteger(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new Handle(!v[11] && v[11] != "" ? null : v[11].value), v[12]),
  3206491090: (v) => new IFC4.IfcTaskType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : new IFC4.IfcIdentifier(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcText(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9], !v[10] && v[10] != "" ? null : new IFC4.IfcLabel(!v[10] && v[10] != "" ? null : v[10].value)),
  2387106220: (v) => new IFC4.IfcTessellatedFaceSet(new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  1935646853: (v) => new IFC4.IfcToroidalSurface(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), new IFC4.IfcPositiveLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value)),
  2097647324: (v) => new IFC4.IfcTransportElementType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2916149573: (v) => new IFC4.IfcTriangulatedFaceSet(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : v[1]?.map((p) => p?.map((p2) => p2?.value && p2?.value != "" ? new IFC4.IfcParameterValue(p2.value) : null) || []), !v[2] && v[2] != "" ? null : new IFC4.IfcBoolean(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.map((p2) => p2?.value && p2?.value != "" ? new IFC4.IfcPositiveInteger(p2.value) : null) || []), !v[4] && v[4] != "" ? null : v[4]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcPositiveInteger(p.value) : null) || []),
  336235671: (v) => new IFC4.IfcWindowLiningProperties(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcNonNegativeLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcNonNegativeLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcNonNegativeLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcNormalisedRatioMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4.IfcNormalisedRatioMeasure(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC4.IfcNormalisedRatioMeasure(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC4.IfcNormalisedRatioMeasure(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new Handle(!v[12] && v[12] != "" ? null : v[12].value), !v[13] && v[13] != "" ? null : new IFC4.IfcLengthMeasure(!v[13] && v[13] != "" ? null : v[13].value), !v[14] && v[14] != "" ? null : new IFC4.IfcLengthMeasure(!v[14] && v[14] != "" ? null : v[14].value), !v[15] && v[15] != "" ? null : new IFC4.IfcLengthMeasure(!v[15] && v[15] != "" ? null : v[15].value)),
  512836454: (v) => new IFC4.IfcWindowPanelProperties(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4], v[5], !v[6] && v[6] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new Handle(!v[8] && v[8] != "" ? null : v[8].value)),
  2296667514: (v) => new IFC4.IfcActor(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  1635779807: (v) => new IFC4.IfcAdvancedBrep(new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  2603310189: (v) => new IFC4.IfcAdvancedBrepWithVoids(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1674181508: (v) => new IFC4.IfcAnnotation(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  2887950389: (v) => new IFC4.IfcBSplineSurface(new IFC4.IfcInteger(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcInteger(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.map((p2) => p2?.value && p2?.value != "" ? new Handle(p2.value) : null) || []), v[3], new IFC4.IfcLogical(!v[4] && v[4] != "" ? null : v[4].value), new IFC4.IfcLogical(!v[5] && v[5] != "" ? null : v[5].value), new IFC4.IfcLogical(!v[6] && v[6] != "" ? null : v[6].value)),
  167062518: (v) => new IFC4.IfcBSplineSurfaceWithKnots(new IFC4.IfcInteger(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcInteger(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.map((p2) => p2?.value && p2?.value != "" ? new Handle(p2.value) : null) || []), v[3], new IFC4.IfcLogical(!v[4] && v[4] != "" ? null : v[4].value), new IFC4.IfcLogical(!v[5] && v[5] != "" ? null : v[5].value), new IFC4.IfcLogical(!v[6] && v[6] != "" ? null : v[6].value), v[7]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcInteger(p.value) : null) || [], v[8]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcInteger(p.value) : null) || [], v[9]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcParameterValue(p.value) : null) || [], v[10]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcParameterValue(p.value) : null) || [], v[11]),
  1334484129: (v) => new IFC4.IfcBlock(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), new IFC4.IfcPositiveLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  3649129432: (v) => new IFC4.IfcBooleanClippingResult(v[0], new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  1260505505: (_) => new IFC4.IfcBoundedCurve(),
  4031249490: (v) => new IFC4.IfcBuilding(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), v[8], !v[9] && v[9] != "" ? null : new IFC4.IfcLengthMeasure(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC4.IfcLengthMeasure(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new Handle(!v[11] && v[11] != "" ? null : v[11].value)),
  1950629157: (v) => new IFC4.IfcBuildingElementType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  3124254112: (v) => new IFC4.IfcBuildingStorey(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), v[8], !v[9] && v[9] != "" ? null : new IFC4.IfcLengthMeasure(!v[9] && v[9] != "" ? null : v[9].value)),
  2197970202: (v) => new IFC4.IfcChimneyType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2937912522: (v) => new IFC4.IfcCircleHollowProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC4.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value)),
  3893394355: (v) => new IFC4.IfcCivilElementType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  300633059: (v) => new IFC4.IfcColumnType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3875453745: (v) => new IFC4.IfcComplexPropertyTemplate(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), v[5], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3732776249: (v) => new IFC4.IfcCompositeCurve(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new IFC4.IfcLogical(!v[1] && v[1] != "" ? null : v[1].value)),
  15328376: (v) => new IFC4.IfcCompositeCurveOnSurface(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new IFC4.IfcLogical(!v[1] && v[1] != "" ? null : v[1].value)),
  2510884976: (v) => new IFC4.IfcConic(new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  2185764099: (v) => new IFC4.IfcConstructionEquipmentResourceType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : new IFC4.IfcIdentifier(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcText(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : v[9]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[10] && v[10] != "" ? null : new Handle(!v[10] && v[10] != "" ? null : v[10].value), v[11]),
  4105962743: (v) => new IFC4.IfcConstructionMaterialResourceType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : new IFC4.IfcIdentifier(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcText(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : v[9]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[10] && v[10] != "" ? null : new Handle(!v[10] && v[10] != "" ? null : v[10].value), v[11]),
  1525564444: (v) => new IFC4.IfcConstructionProductResourceType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : new IFC4.IfcIdentifier(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcText(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : v[9]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[10] && v[10] != "" ? null : new Handle(!v[10] && v[10] != "" ? null : v[10].value), v[11]),
  2559216714: (v) => new IFC4.IfcConstructionResource(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcText(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : v[8]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[9] && v[9] != "" ? null : new Handle(!v[9] && v[9] != "" ? null : v[9].value)),
  3293443760: (v) => new IFC4.IfcControl(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value)),
  3895139033: (v) => new IFC4.IfcCostItem(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), v[6], !v[7] && v[7] != "" ? null : v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[8] && v[8] != "" ? null : v[8]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1419761937: (v) => new IFC4.IfcCostSchedule(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), v[6], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcDateTime(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4.IfcDateTime(!v[9] && v[9] != "" ? null : v[9].value)),
  1916426348: (v) => new IFC4.IfcCoveringType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3295246426: (v) => new IFC4.IfcCrewResource(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcText(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : v[8]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[9] && v[9] != "" ? null : new Handle(!v[9] && v[9] != "" ? null : v[9].value), v[10]),
  1457835157: (v) => new IFC4.IfcCurtainWallType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1213902940: (v) => new IFC4.IfcCylindricalSurface(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value)),
  3256556792: (v) => new IFC4.IfcDistributionElementType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  3849074793: (v) => new IFC4.IfcDistributionFlowElementType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  2963535650: (v) => new IFC4.IfcDoorLiningProperties(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcNonNegativeLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcNonNegativeLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcNonNegativeLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4.IfcLengthMeasure(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC4.IfcLengthMeasure(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC4.IfcLengthMeasure(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[12] && v[12] != "" ? null : v[12].value), !v[13] && v[13] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[13] && v[13] != "" ? null : v[13].value), !v[14] && v[14] != "" ? null : new Handle(!v[14] && v[14] != "" ? null : v[14].value), !v[15] && v[15] != "" ? null : new IFC4.IfcLengthMeasure(!v[15] && v[15] != "" ? null : v[15].value), !v[16] && v[16] != "" ? null : new IFC4.IfcLengthMeasure(!v[16] && v[16] != "" ? null : v[16].value)),
  1714330368: (v) => new IFC4.IfcDoorPanelProperties(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), v[5], !v[6] && v[6] != "" ? null : new IFC4.IfcNormalisedRatioMeasure(!v[6] && v[6] != "" ? null : v[6].value), v[7], !v[8] && v[8] != "" ? null : new Handle(!v[8] && v[8] != "" ? null : v[8].value)),
  2323601079: (v) => new IFC4.IfcDoorType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9], v[10], !v[11] && v[11] != "" ? null : new IFC4.IfcBoolean(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC4.IfcLabel(!v[12] && v[12] != "" ? null : v[12].value)),
  445594917: (v) => new IFC4.IfcDraughtingPreDefinedColour(new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  4006246654: (v) => new IFC4.IfcDraughtingPreDefinedCurveFont(new IFC4.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  1758889154: (v) => new IFC4.IfcElement(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  4123344466: (v) => new IFC4.IfcElementAssembly(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8], v[9]),
  2397081782: (v) => new IFC4.IfcElementAssemblyType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1623761950: (v) => new IFC4.IfcElementComponent(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  2590856083: (v) => new IFC4.IfcElementComponentType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  1704287377: (v) => new IFC4.IfcEllipse(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), new IFC4.IfcPositiveLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value)),
  2107101300: (v) => new IFC4.IfcEnergyConversionDeviceType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  132023988: (v) => new IFC4.IfcEngineType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3174744832: (v) => new IFC4.IfcEvaporativeCoolerType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3390157468: (v) => new IFC4.IfcEvaporatorType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  4148101412: (v) => new IFC4.IfcEvent(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcText(!v[6] && v[6] != "" ? null : v[6].value), v[7], v[8], !v[9] && v[9] != "" ? null : new IFC4.IfcLabel(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new Handle(!v[10] && v[10] != "" ? null : v[10].value)),
  2853485674: (v) => new IFC4.IfcExternalSpatialStructureElement(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value)),
  807026263: (v) => new IFC4.IfcFacetedBrep(new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  3737207727: (v) => new IFC4.IfcFacetedBrepWithVoids(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  647756555: (v) => new IFC4.IfcFastener(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  2489546625: (v) => new IFC4.IfcFastenerType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2827207264: (v) => new IFC4.IfcFeatureElement(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  2143335405: (v) => new IFC4.IfcFeatureElementAddition(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  1287392070: (v) => new IFC4.IfcFeatureElementSubtraction(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  3907093117: (v) => new IFC4.IfcFlowControllerType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  3198132628: (v) => new IFC4.IfcFlowFittingType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  3815607619: (v) => new IFC4.IfcFlowMeterType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1482959167: (v) => new IFC4.IfcFlowMovingDeviceType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  1834744321: (v) => new IFC4.IfcFlowSegmentType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  1339347760: (v) => new IFC4.IfcFlowStorageDeviceType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  2297155007: (v) => new IFC4.IfcFlowTerminalType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  3009222698: (v) => new IFC4.IfcFlowTreatmentDeviceType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  1893162501: (v) => new IFC4.IfcFootingType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  263784265: (v) => new IFC4.IfcFurnishingElement(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  1509553395: (v) => new IFC4.IfcFurniture(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3493046030: (v) => new IFC4.IfcGeographicElement(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3009204131: (v) => new IFC4.IfcGrid(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[8]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[9] && v[9] != "" ? null : v[9]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[10]),
  2706460486: (v) => new IFC4.IfcGroup(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  1251058090: (v) => new IFC4.IfcHeatExchangerType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1806887404: (v) => new IFC4.IfcHumidifierType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2571569899: (v) => new IFC4.IfcIndexedPolyCurve(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : v[1]?.map((p) => p?.value && p?.value != "" ? TypeInitialiser(2, p) : null) || [], !v[2] && v[2] != "" ? null : new IFC4.IfcBoolean(!v[2] && v[2] != "" ? null : v[2].value)),
  3946677679: (v) => new IFC4.IfcInterceptorType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3113134337: (v) => new IFC4.IfcIntersectionCurve(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[2]),
  2391368822: (v) => new IFC4.IfcInventory(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), v[5], !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[8] && v[8] != "" ? null : new IFC4.IfcDate(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new Handle(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new Handle(!v[10] && v[10] != "" ? null : v[10].value)),
  4288270099: (v) => new IFC4.IfcJunctionBoxType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3827777499: (v) => new IFC4.IfcLaborResource(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcText(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : v[8]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[9] && v[9] != "" ? null : new Handle(!v[9] && v[9] != "" ? null : v[9].value), v[10]),
  1051575348: (v) => new IFC4.IfcLampType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1161773419: (v) => new IFC4.IfcLightFixtureType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  377706215: (v) => new IFC4.IfcMechanicalFastener(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[9] && v[9] != "" ? null : v[9].value), v[10]),
  2108223431: (v) => new IFC4.IfcMechanicalFastenerType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9], !v[10] && v[10] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[11] && v[11] != "" ? null : v[11].value)),
  1114901282: (v) => new IFC4.IfcMedicalDeviceType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3181161470: (v) => new IFC4.IfcMemberType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  977012517: (v) => new IFC4.IfcMotorConnectionType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  4143007308: (v) => new IFC4.IfcOccupant(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value), v[6]),
  3588315303: (v) => new IFC4.IfcOpeningElement(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3079942009: (v) => new IFC4.IfcOpeningStandardCase(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  2837617999: (v) => new IFC4.IfcOutletType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2382730787: (v) => new IFC4.IfcPerformanceHistory(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), new IFC4.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), v[7]),
  3566463478: (v) => new IFC4.IfcPermeableCoveringProperties(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4], v[5], !v[6] && v[6] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new Handle(!v[8] && v[8] != "" ? null : v[8].value)),
  3327091369: (v) => new IFC4.IfcPermit(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), v[6], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcText(!v[8] && v[8] != "" ? null : v[8].value)),
  1158309216: (v) => new IFC4.IfcPileType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  804291784: (v) => new IFC4.IfcPipeFittingType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  4231323485: (v) => new IFC4.IfcPipeSegmentType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  4017108033: (v) => new IFC4.IfcPlateType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2839578677: (v) => new IFC4.IfcPolygonalFaceSet(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4.IfcBoolean(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[3] && v[3] != "" ? null : v[3]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcPositiveInteger(p.value) : null) || []),
  3724593414: (v) => new IFC4.IfcPolyline(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3740093272: (v) => new IFC4.IfcPort(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  2744685151: (v) => new IFC4.IfcProcedure(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcText(!v[6] && v[6] != "" ? null : v[6].value), v[7]),
  2904328755: (v) => new IFC4.IfcProjectOrder(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), v[6], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcText(!v[8] && v[8] != "" ? null : v[8].value)),
  3651124850: (v) => new IFC4.IfcProjectionElement(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1842657554: (v) => new IFC4.IfcProtectiveDeviceType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2250791053: (v) => new IFC4.IfcPumpType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2893384427: (v) => new IFC4.IfcRailingType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2324767716: (v) => new IFC4.IfcRampFlightType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1469900589: (v) => new IFC4.IfcRampType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  683857671: (v) => new IFC4.IfcRationalBSplineSurfaceWithKnots(new IFC4.IfcInteger(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcInteger(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.map((p2) => p2?.value && p2?.value != "" ? new Handle(p2.value) : null) || []), v[3], new IFC4.IfcLogical(!v[4] && v[4] != "" ? null : v[4].value), new IFC4.IfcLogical(!v[5] && v[5] != "" ? null : v[5].value), new IFC4.IfcLogical(!v[6] && v[6] != "" ? null : v[6].value), v[7]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcInteger(p.value) : null) || [], v[8]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcInteger(p.value) : null) || [], v[9]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcParameterValue(p.value) : null) || [], v[10]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcParameterValue(p.value) : null) || [], v[11], v[12]?.map((p) => p?.map((p2) => p2?.value && p2?.value != "" ? new IFC4.IfcReal(p2.value) : null) || [])),
  3027567501: (v) => new IFC4.IfcReinforcingElement(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  964333572: (v) => new IFC4.IfcReinforcingElementType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  2320036040: (v) => new IFC4.IfcReinforcingMesh(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[12] && v[12] != "" ? null : v[12].value), !v[13] && v[13] != "" ? null : new IFC4.IfcAreaMeasure(!v[13] && v[13] != "" ? null : v[13].value), !v[14] && v[14] != "" ? null : new IFC4.IfcAreaMeasure(!v[14] && v[14] != "" ? null : v[14].value), !v[15] && v[15] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[15] && v[15] != "" ? null : v[15].value), !v[16] && v[16] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[16] && v[16] != "" ? null : v[16].value), v[17]),
  2310774935: (v) => new IFC4.IfcReinforcingMeshType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9], !v[10] && v[10] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[12] && v[12] != "" ? null : v[12].value), !v[13] && v[13] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[13] && v[13] != "" ? null : v[13].value), !v[14] && v[14] != "" ? null : new IFC4.IfcAreaMeasure(!v[14] && v[14] != "" ? null : v[14].value), !v[15] && v[15] != "" ? null : new IFC4.IfcAreaMeasure(!v[15] && v[15] != "" ? null : v[15].value), !v[16] && v[16] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[16] && v[16] != "" ? null : v[16].value), !v[17] && v[17] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[17] && v[17] != "" ? null : v[17].value), !v[18] && v[18] != "" ? null : new IFC4.IfcLabel(!v[18] && v[18] != "" ? null : v[18].value), !v[19] && v[19] != "" ? null : v[19]?.map((p) => p?.value && p?.value != "" ? TypeInitialiser(2, p) : null) || []),
  160246688: (v) => new IFC4.IfcRelAggregates(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2781568857: (v) => new IFC4.IfcRoofType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1768891740: (v) => new IFC4.IfcSanitaryTerminalType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2157484638: (v) => new IFC4.IfcSeamCurve(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[2]),
  4074543187: (v) => new IFC4.IfcShadingDeviceType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  4097777520: (v) => new IFC4.IfcSite(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), v[8], !v[9] && v[9] != "" ? null : new IFC4.IfcCompoundPlaneAngleMeasure(v[9].map((x) => x.value)), !v[10] && v[10] != "" ? null : new IFC4.IfcCompoundPlaneAngleMeasure(v[10].map((x) => x.value)), !v[11] && v[11] != "" ? null : new IFC4.IfcLengthMeasure(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC4.IfcLabel(!v[12] && v[12] != "" ? null : v[12].value), !v[13] && v[13] != "" ? null : new Handle(!v[13] && v[13] != "" ? null : v[13].value)),
  2533589738: (v) => new IFC4.IfcSlabType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1072016465: (v) => new IFC4.IfcSolarDeviceType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3856911033: (v) => new IFC4.IfcSpace(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), v[8], v[9], !v[10] && v[10] != "" ? null : new IFC4.IfcLengthMeasure(!v[10] && v[10] != "" ? null : v[10].value)),
  1305183839: (v) => new IFC4.IfcSpaceHeaterType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3812236995: (v) => new IFC4.IfcSpaceType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9], !v[10] && v[10] != "" ? null : new IFC4.IfcLabel(!v[10] && v[10] != "" ? null : v[10].value)),
  3112655638: (v) => new IFC4.IfcStackTerminalType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1039846685: (v) => new IFC4.IfcStairFlightType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  338393293: (v) => new IFC4.IfcStairType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  682877961: (v) => new IFC4.IfcStructuralAction(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), new Handle(!v[7] && v[7] != "" ? null : v[7].value), v[8], !v[9] && v[9] != "" ? null : new IFC4.IfcBoolean(!v[9] && v[9] != "" ? null : v[9].value)),
  1179482911: (v) => new IFC4.IfcStructuralConnection(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value)),
  1004757350: (v) => new IFC4.IfcStructuralCurveAction(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), new Handle(!v[7] && v[7] != "" ? null : v[7].value), v[8], !v[9] && v[9] != "" ? null : new IFC4.IfcBoolean(!v[9] && v[9] != "" ? null : v[9].value), v[10], v[11]),
  4243806635: (v) => new IFC4.IfcStructuralCurveConnection(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), new Handle(!v[8] && v[8] != "" ? null : v[8].value)),
  214636428: (v) => new IFC4.IfcStructuralCurveMember(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), v[7], new Handle(!v[8] && v[8] != "" ? null : v[8].value)),
  2445595289: (v) => new IFC4.IfcStructuralCurveMemberVarying(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), v[7], new Handle(!v[8] && v[8] != "" ? null : v[8].value)),
  2757150158: (v) => new IFC4.IfcStructuralCurveReaction(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), new Handle(!v[7] && v[7] != "" ? null : v[7].value), v[8], v[9]),
  1807405624: (v) => new IFC4.IfcStructuralLinearAction(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), new Handle(!v[7] && v[7] != "" ? null : v[7].value), v[8], !v[9] && v[9] != "" ? null : new IFC4.IfcBoolean(!v[9] && v[9] != "" ? null : v[9].value), v[10], v[11]),
  1252848954: (v) => new IFC4.IfcStructuralLoadGroup(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), v[5], v[6], v[7], !v[8] && v[8] != "" ? null : new IFC4.IfcRatioMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4.IfcLabel(!v[9] && v[9] != "" ? null : v[9].value)),
  2082059205: (v) => new IFC4.IfcStructuralPointAction(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), new Handle(!v[7] && v[7] != "" ? null : v[7].value), v[8], !v[9] && v[9] != "" ? null : new IFC4.IfcBoolean(!v[9] && v[9] != "" ? null : v[9].value)),
  734778138: (v) => new IFC4.IfcStructuralPointConnection(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new Handle(!v[8] && v[8] != "" ? null : v[8].value)),
  1235345126: (v) => new IFC4.IfcStructuralPointReaction(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), new Handle(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  2986769608: (v) => new IFC4.IfcStructuralResultGroup(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), v[5], !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), new IFC4.IfcBoolean(!v[7] && v[7] != "" ? null : v[7].value)),
  3657597509: (v) => new IFC4.IfcStructuralSurfaceAction(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), new Handle(!v[7] && v[7] != "" ? null : v[7].value), v[8], !v[9] && v[9] != "" ? null : new IFC4.IfcBoolean(!v[9] && v[9] != "" ? null : v[9].value), v[10], v[11]),
  1975003073: (v) => new IFC4.IfcStructuralSurfaceConnection(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value)),
  148013059: (v) => new IFC4.IfcSubContractResource(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcText(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : v[8]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[9] && v[9] != "" ? null : new Handle(!v[9] && v[9] != "" ? null : v[9].value), v[10]),
  3101698114: (v) => new IFC4.IfcSurfaceFeature(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  2315554128: (v) => new IFC4.IfcSwitchingDeviceType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2254336722: (v) => new IFC4.IfcSystem(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  413509423: (v) => new IFC4.IfcSystemFurnitureElement(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  5716631: (v) => new IFC4.IfcTankType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3824725483: (v) => new IFC4.IfcTendon(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9], !v[10] && v[10] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC4.IfcAreaMeasure(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC4.IfcForceMeasure(!v[12] && v[12] != "" ? null : v[12].value), !v[13] && v[13] != "" ? null : new IFC4.IfcPressureMeasure(!v[13] && v[13] != "" ? null : v[13].value), !v[14] && v[14] != "" ? null : new IFC4.IfcNormalisedRatioMeasure(!v[14] && v[14] != "" ? null : v[14].value), !v[15] && v[15] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[15] && v[15] != "" ? null : v[15].value), !v[16] && v[16] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[16] && v[16] != "" ? null : v[16].value)),
  2347447852: (v) => new IFC4.IfcTendonAnchor(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3081323446: (v) => new IFC4.IfcTendonAnchorType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2415094496: (v) => new IFC4.IfcTendonType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9], !v[10] && v[10] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC4.IfcAreaMeasure(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[12] && v[12] != "" ? null : v[12].value)),
  1692211062: (v) => new IFC4.IfcTransformerType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1620046519: (v) => new IFC4.IfcTransportElement(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3593883385: (v) => new IFC4.IfcTrimmedCurve(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new IFC4.IfcBoolean(!v[3] && v[3] != "" ? null : v[3].value), v[4]),
  1600972822: (v) => new IFC4.IfcTubeBundleType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1911125066: (v) => new IFC4.IfcUnitaryEquipmentType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  728799441: (v) => new IFC4.IfcValveType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2391383451: (v) => new IFC4.IfcVibrationIsolator(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3313531582: (v) => new IFC4.IfcVibrationIsolatorType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2769231204: (v) => new IFC4.IfcVirtualElement(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  926996030: (v) => new IFC4.IfcVoidingFeature(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1898987631: (v) => new IFC4.IfcWallType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1133259667: (v) => new IFC4.IfcWasteTerminalType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  4009809668: (v) => new IFC4.IfcWindowType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9], v[10], !v[11] && v[11] != "" ? null : new IFC4.IfcBoolean(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC4.IfcLabel(!v[12] && v[12] != "" ? null : v[12].value)),
  4088093105: (v) => new IFC4.IfcWorkCalendar(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[8]),
  1028945134: (v) => new IFC4.IfcWorkControl(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), new IFC4.IfcDateTime(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4.IfcDuration(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC4.IfcDuration(!v[10] && v[10] != "" ? null : v[10].value), new IFC4.IfcDateTime(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC4.IfcDateTime(!v[12] && v[12] != "" ? null : v[12].value)),
  4218914973: (v) => new IFC4.IfcWorkPlan(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), new IFC4.IfcDateTime(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4.IfcDuration(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC4.IfcDuration(!v[10] && v[10] != "" ? null : v[10].value), new IFC4.IfcDateTime(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC4.IfcDateTime(!v[12] && v[12] != "" ? null : v[12].value), v[13]),
  3342526732: (v) => new IFC4.IfcWorkSchedule(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), new IFC4.IfcDateTime(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4.IfcDuration(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC4.IfcDuration(!v[10] && v[10] != "" ? null : v[10].value), new IFC4.IfcDateTime(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC4.IfcDateTime(!v[12] && v[12] != "" ? null : v[12].value), v[13]),
  1033361043: (v) => new IFC4.IfcZone(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value)),
  3821786052: (v) => new IFC4.IfcActionRequest(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), v[6], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcText(!v[8] && v[8] != "" ? null : v[8].value)),
  1411407467: (v) => new IFC4.IfcAirTerminalBoxType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3352864051: (v) => new IFC4.IfcAirTerminalType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1871374353: (v) => new IFC4.IfcAirToAirHeatRecoveryType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3460190687: (v) => new IFC4.IfcAsset(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new Handle(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new Handle(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new Handle(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new Handle(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC4.IfcDate(!v[12] && v[12] != "" ? null : v[12].value), !v[13] && v[13] != "" ? null : new Handle(!v[13] && v[13] != "" ? null : v[13].value)),
  1532957894: (v) => new IFC4.IfcAudioVisualApplianceType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1967976161: (v) => new IFC4.IfcBSplineCurve(new IFC4.IfcInteger(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[2], new IFC4.IfcLogical(!v[3] && v[3] != "" ? null : v[3].value), new IFC4.IfcLogical(!v[4] && v[4] != "" ? null : v[4].value)),
  2461110595: (v) => new IFC4.IfcBSplineCurveWithKnots(new IFC4.IfcInteger(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[2], new IFC4.IfcLogical(!v[3] && v[3] != "" ? null : v[3].value), new IFC4.IfcLogical(!v[4] && v[4] != "" ? null : v[4].value), v[5]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcInteger(p.value) : null) || [], v[6]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcParameterValue(p.value) : null) || [], v[7]),
  819618141: (v) => new IFC4.IfcBeamType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  231477066: (v) => new IFC4.IfcBoilerType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1136057603: (v) => new IFC4.IfcBoundaryCurve(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new IFC4.IfcLogical(!v[1] && v[1] != "" ? null : v[1].value)),
  3299480353: (v) => new IFC4.IfcBuildingElement(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  2979338954: (v) => new IFC4.IfcBuildingElementPart(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  39481116: (v) => new IFC4.IfcBuildingElementPartType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1095909175: (v) => new IFC4.IfcBuildingElementProxy(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1909888760: (v) => new IFC4.IfcBuildingElementProxyType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1177604601: (v) => new IFC4.IfcBuildingSystem(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), v[5], !v[6] && v[6] != "" ? null : new IFC4.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value)),
  2188180465: (v) => new IFC4.IfcBurnerType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  395041908: (v) => new IFC4.IfcCableCarrierFittingType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3293546465: (v) => new IFC4.IfcCableCarrierSegmentType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2674252688: (v) => new IFC4.IfcCableFittingType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1285652485: (v) => new IFC4.IfcCableSegmentType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2951183804: (v) => new IFC4.IfcChillerType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3296154744: (v) => new IFC4.IfcChimney(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  2611217952: (v) => new IFC4.IfcCircle(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value)),
  1677625105: (v) => new IFC4.IfcCivilElement(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  2301859152: (v) => new IFC4.IfcCoilType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  843113511: (v) => new IFC4.IfcColumn(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  905975707: (v) => new IFC4.IfcColumnStandardCase(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  400855858: (v) => new IFC4.IfcCommunicationsApplianceType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3850581409: (v) => new IFC4.IfcCompressorType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2816379211: (v) => new IFC4.IfcCondenserType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3898045240: (v) => new IFC4.IfcConstructionEquipmentResource(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcText(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : v[8]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[9] && v[9] != "" ? null : new Handle(!v[9] && v[9] != "" ? null : v[9].value), v[10]),
  1060000209: (v) => new IFC4.IfcConstructionMaterialResource(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcText(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : v[8]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[9] && v[9] != "" ? null : new Handle(!v[9] && v[9] != "" ? null : v[9].value), v[10]),
  488727124: (v) => new IFC4.IfcConstructionProductResource(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4.IfcText(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : v[8]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[9] && v[9] != "" ? null : new Handle(!v[9] && v[9] != "" ? null : v[9].value), v[10]),
  335055490: (v) => new IFC4.IfcCooledBeamType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2954562838: (v) => new IFC4.IfcCoolingTowerType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1973544240: (v) => new IFC4.IfcCovering(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3495092785: (v) => new IFC4.IfcCurtainWall(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3961806047: (v) => new IFC4.IfcDamperType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1335981549: (v) => new IFC4.IfcDiscreteAccessory(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  2635815018: (v) => new IFC4.IfcDiscreteAccessoryType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1599208980: (v) => new IFC4.IfcDistributionChamberElementType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2063403501: (v) => new IFC4.IfcDistributionControlElementType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  1945004755: (v) => new IFC4.IfcDistributionElement(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  3040386961: (v) => new IFC4.IfcDistributionFlowElement(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  3041715199: (v) => new IFC4.IfcDistributionPort(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), v[7], v[8], v[9]),
  3205830791: (v) => new IFC4.IfcDistributionSystem(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value), v[6]),
  395920057: (v) => new IFC4.IfcDoor(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[9] && v[9] != "" ? null : v[9].value), v[10], v[11], !v[12] && v[12] != "" ? null : new IFC4.IfcLabel(!v[12] && v[12] != "" ? null : v[12].value)),
  3242481149: (v) => new IFC4.IfcDoorStandardCase(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[9] && v[9] != "" ? null : v[9].value), v[10], v[11], !v[12] && v[12] != "" ? null : new IFC4.IfcLabel(!v[12] && v[12] != "" ? null : v[12].value)),
  869906466: (v) => new IFC4.IfcDuctFittingType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3760055223: (v) => new IFC4.IfcDuctSegmentType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2030761528: (v) => new IFC4.IfcDuctSilencerType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  663422040: (v) => new IFC4.IfcElectricApplianceType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2417008758: (v) => new IFC4.IfcElectricDistributionBoardType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3277789161: (v) => new IFC4.IfcElectricFlowStorageDeviceType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1534661035: (v) => new IFC4.IfcElectricGeneratorType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1217240411: (v) => new IFC4.IfcElectricMotorType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  712377611: (v) => new IFC4.IfcElectricTimeControlType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1658829314: (v) => new IFC4.IfcEnergyConversionDevice(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  2814081492: (v) => new IFC4.IfcEngine(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3747195512: (v) => new IFC4.IfcEvaporativeCooler(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  484807127: (v) => new IFC4.IfcEvaporator(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1209101575: (v) => new IFC4.IfcExternalSpatialElement(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  346874300: (v) => new IFC4.IfcFanType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1810631287: (v) => new IFC4.IfcFilterType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  4222183408: (v) => new IFC4.IfcFireSuppressionTerminalType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2058353004: (v) => new IFC4.IfcFlowController(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  4278956645: (v) => new IFC4.IfcFlowFitting(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  4037862832: (v) => new IFC4.IfcFlowInstrumentType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2188021234: (v) => new IFC4.IfcFlowMeter(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3132237377: (v) => new IFC4.IfcFlowMovingDevice(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  987401354: (v) => new IFC4.IfcFlowSegment(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  707683696: (v) => new IFC4.IfcFlowStorageDevice(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  2223149337: (v) => new IFC4.IfcFlowTerminal(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  3508470533: (v) => new IFC4.IfcFlowTreatmentDevice(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  900683007: (v) => new IFC4.IfcFooting(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3319311131: (v) => new IFC4.IfcHeatExchanger(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  2068733104: (v) => new IFC4.IfcHumidifier(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  4175244083: (v) => new IFC4.IfcInterceptor(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  2176052936: (v) => new IFC4.IfcJunctionBox(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  76236018: (v) => new IFC4.IfcLamp(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  629592764: (v) => new IFC4.IfcLightFixture(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1437502449: (v) => new IFC4.IfcMedicalDevice(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1073191201: (v) => new IFC4.IfcMember(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1911478936: (v) => new IFC4.IfcMemberStandardCase(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  2474470126: (v) => new IFC4.IfcMotorConnection(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  144952367: (v) => new IFC4.IfcOuterBoundaryCurve(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new IFC4.IfcLogical(!v[1] && v[1] != "" ? null : v[1].value)),
  3694346114: (v) => new IFC4.IfcOutlet(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1687234759: (v) => new IFC4.IfcPile(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8], v[9]),
  310824031: (v) => new IFC4.IfcPipeFitting(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3612865200: (v) => new IFC4.IfcPipeSegment(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3171933400: (v) => new IFC4.IfcPlate(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1156407060: (v) => new IFC4.IfcPlateStandardCase(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  738039164: (v) => new IFC4.IfcProtectiveDevice(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  655969474: (v) => new IFC4.IfcProtectiveDeviceTrippingUnitType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  90941305: (v) => new IFC4.IfcPump(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  2262370178: (v) => new IFC4.IfcRailing(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3024970846: (v) => new IFC4.IfcRamp(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3283111854: (v) => new IFC4.IfcRampFlight(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1232101972: (v) => new IFC4.IfcRationalBSplineCurveWithKnots(new IFC4.IfcInteger(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[2], new IFC4.IfcLogical(!v[3] && v[3] != "" ? null : v[3].value), new IFC4.IfcLogical(!v[4] && v[4] != "" ? null : v[4].value), v[5]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcInteger(p.value) : null) || [], v[6]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcParameterValue(p.value) : null) || [], v[7], v[8]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcReal(p.value) : null) || []),
  979691226: (v) => new IFC4.IfcReinforcingBar(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC4.IfcAreaMeasure(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[11] && v[11] != "" ? null : v[11].value), v[12], v[13]),
  2572171363: (v) => new IFC4.IfcReinforcingBarType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9], !v[10] && v[10] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC4.IfcAreaMeasure(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[12] && v[12] != "" ? null : v[12].value), v[13], !v[14] && v[14] != "" ? null : new IFC4.IfcLabel(!v[14] && v[14] != "" ? null : v[14].value), !v[15] && v[15] != "" ? null : v[15]?.map((p) => p?.value && p?.value != "" ? TypeInitialiser(2, p) : null) || []),
  2016517767: (v) => new IFC4.IfcRoof(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3053780830: (v) => new IFC4.IfcSanitaryTerminal(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1783015770: (v) => new IFC4.IfcSensorType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1329646415: (v) => new IFC4.IfcShadingDevice(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1529196076: (v) => new IFC4.IfcSlab(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3127900445: (v) => new IFC4.IfcSlabElementedCase(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3027962421: (v) => new IFC4.IfcSlabStandardCase(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3420628829: (v) => new IFC4.IfcSolarDevice(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1999602285: (v) => new IFC4.IfcSpaceHeater(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1404847402: (v) => new IFC4.IfcStackTerminal(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  331165859: (v) => new IFC4.IfcStair(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  4252922144: (v) => new IFC4.IfcStairFlight(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcInteger(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4.IfcInteger(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[11] && v[11] != "" ? null : v[11].value), v[12]),
  2515109513: (v) => new IFC4.IfcStructuralAnalysisModel(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), v[5], !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[8] && v[8] != "" ? null : v[8]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[9] && v[9] != "" ? null : new Handle(!v[9] && v[9] != "" ? null : v[9].value)),
  385403989: (v) => new IFC4.IfcStructuralLoadCase(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), v[5], v[6], v[7], !v[8] && v[8] != "" ? null : new IFC4.IfcRatioMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4.IfcLabel(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : v[10]?.map((p) => p?.value && p?.value != "" ? new IFC4.IfcRatioMeasure(p.value) : null) || []),
  1621171031: (v) => new IFC4.IfcStructuralPlanarAction(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), new Handle(!v[7] && v[7] != "" ? null : v[7].value), v[8], !v[9] && v[9] != "" ? null : new IFC4.IfcBoolean(!v[9] && v[9] != "" ? null : v[9].value), v[10], v[11]),
  1162798199: (v) => new IFC4.IfcSwitchingDevice(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  812556717: (v) => new IFC4.IfcTank(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3825984169: (v) => new IFC4.IfcTransformer(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3026737570: (v) => new IFC4.IfcTubeBundle(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3179687236: (v) => new IFC4.IfcUnitaryControlElementType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  4292641817: (v) => new IFC4.IfcUnitaryEquipment(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  4207607924: (v) => new IFC4.IfcValve(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  2391406946: (v) => new IFC4.IfcWall(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  4156078855: (v) => new IFC4.IfcWallElementedCase(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3512223829: (v) => new IFC4.IfcWallStandardCase(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  4237592921: (v) => new IFC4.IfcWasteTerminal(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3304561284: (v) => new IFC4.IfcWindow(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[9] && v[9] != "" ? null : v[9].value), v[10], v[11], !v[12] && v[12] != "" ? null : new IFC4.IfcLabel(!v[12] && v[12] != "" ? null : v[12].value)),
  486154966: (v) => new IFC4.IfcWindowStandardCase(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4.IfcPositiveLengthMeasure(!v[9] && v[9] != "" ? null : v[9].value), v[10], v[11], !v[12] && v[12] != "" ? null : new IFC4.IfcLabel(!v[12] && v[12] != "" ? null : v[12].value)),
  2874132201: (v) => new IFC4.IfcActuatorType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1634111441: (v) => new IFC4.IfcAirTerminal(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  177149247: (v) => new IFC4.IfcAirTerminalBox(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  2056796094: (v) => new IFC4.IfcAirToAirHeatRecovery(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3001207471: (v) => new IFC4.IfcAlarmType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  277319702: (v) => new IFC4.IfcAudioVisualAppliance(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  753842376: (v) => new IFC4.IfcBeam(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  2906023776: (v) => new IFC4.IfcBeamStandardCase(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  32344328: (v) => new IFC4.IfcBoiler(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  2938176219: (v) => new IFC4.IfcBurner(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  635142910: (v) => new IFC4.IfcCableCarrierFitting(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3758799889: (v) => new IFC4.IfcCableCarrierSegment(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1051757585: (v) => new IFC4.IfcCableFitting(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  4217484030: (v) => new IFC4.IfcCableSegment(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3902619387: (v) => new IFC4.IfcChiller(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  639361253: (v) => new IFC4.IfcCoil(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3221913625: (v) => new IFC4.IfcCommunicationsAppliance(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3571504051: (v) => new IFC4.IfcCompressor(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  2272882330: (v) => new IFC4.IfcCondenser(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  578613899: (v) => new IFC4.IfcControllerType(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  4136498852: (v) => new IFC4.IfcCooledBeam(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3640358203: (v) => new IFC4.IfcCoolingTower(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  4074379575: (v) => new IFC4.IfcDamper(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1052013943: (v) => new IFC4.IfcDistributionChamberElement(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  562808652: (v) => new IFC4.IfcDistributionCircuit(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value), v[6]),
  1062813311: (v) => new IFC4.IfcDistributionControlElement(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  342316401: (v) => new IFC4.IfcDuctFitting(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3518393246: (v) => new IFC4.IfcDuctSegment(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1360408905: (v) => new IFC4.IfcDuctSilencer(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1904799276: (v) => new IFC4.IfcElectricAppliance(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  862014818: (v) => new IFC4.IfcElectricDistributionBoard(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3310460725: (v) => new IFC4.IfcElectricFlowStorageDevice(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  264262732: (v) => new IFC4.IfcElectricGenerator(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  402227799: (v) => new IFC4.IfcElectricMotor(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1003880860: (v) => new IFC4.IfcElectricTimeControl(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3415622556: (v) => new IFC4.IfcFan(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  819412036: (v) => new IFC4.IfcFilter(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1426591983: (v) => new IFC4.IfcFireSuppressionTerminal(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  182646315: (v) => new IFC4.IfcFlowInstrument(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  2295281155: (v) => new IFC4.IfcProtectiveDeviceTrippingUnit(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  4086658281: (v) => new IFC4.IfcSensor(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  630975310: (v) => new IFC4.IfcUnitaryControlElement(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  4288193352: (v) => new IFC4.IfcActuator(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3087945054: (v) => new IFC4.IfcAlarm(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  25142252: (v) => new IFC4.IfcController(new IFC4.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8])
};
InheritanceDef[2] = {
  618182010: [IFCTELECOMADDRESS, IFCPOSTALADDRESS],
  411424972: [IFCCOSTVALUE],
  4037036970: [IFCBOUNDARYNODECONDITIONWARPING, IFCBOUNDARYNODECONDITION, IFCBOUNDARYFACECONDITION, IFCBOUNDARYEDGECONDITION],
  1387855156: [IFCBOUNDARYNODECONDITIONWARPING],
  2859738748: [IFCCONNECTIONCURVEGEOMETRY, IFCCONNECTIONVOLUMEGEOMETRY, IFCCONNECTIONSURFACEGEOMETRY, IFCCONNECTIONPOINTECCENTRICITY, IFCCONNECTIONPOINTGEOMETRY],
  2614616156: [IFCCONNECTIONPOINTECCENTRICITY],
  1959218052: [IFCOBJECTIVE, IFCMETRIC],
  1785450214: [IFCMAPCONVERSION],
  1466758467: [IFCPROJECTEDCRS],
  4294318154: [IFCDOCUMENTINFORMATION, IFCCLASSIFICATION, IFCLIBRARYINFORMATION],
  3200245327: [IFCDOCUMENTREFERENCE, IFCCLASSIFICATIONREFERENCE, IFCLIBRARYREFERENCE, IFCEXTERNALLYDEFINEDTEXTFONT, IFCEXTERNALLYDEFINEDSURFACESTYLE, IFCEXTERNALLYDEFINEDHATCHSTYLE],
  760658860: [IFCMATERIALCONSTITUENTSET, IFCMATERIALCONSTITUENT, IFCMATERIAL, IFCMATERIALPROFILESET, IFCMATERIALPROFILEWITHOFFSETS, IFCMATERIALPROFILE, IFCMATERIALLAYERSET, IFCMATERIALLAYERWITHOFFSETS, IFCMATERIALLAYER],
  248100487: [IFCMATERIALLAYERWITHOFFSETS],
  2235152071: [IFCMATERIALPROFILEWITHOFFSETS],
  1507914824: [IFCMATERIALPROFILESETUSAGETAPERING, IFCMATERIALPROFILESETUSAGE, IFCMATERIALLAYERSETUSAGE],
  1918398963: [IFCCONVERSIONBASEDUNITWITHOFFSET, IFCCONVERSIONBASEDUNIT, IFCCONTEXTDEPENDENTUNIT, IFCSIUNIT],
  3701648758: [IFCLOCALPLACEMENT, IFCGRIDPLACEMENT],
  2483315170: [IFCPHYSICALCOMPLEXQUANTITY, IFCQUANTITYWEIGHT, IFCQUANTITYVOLUME, IFCQUANTITYTIME, IFCQUANTITYLENGTH, IFCQUANTITYCOUNT, IFCQUANTITYAREA, IFCPHYSICALSIMPLEQUANTITY],
  2226359599: [IFCQUANTITYWEIGHT, IFCQUANTITYVOLUME, IFCQUANTITYTIME, IFCQUANTITYLENGTH, IFCQUANTITYCOUNT, IFCQUANTITYAREA],
  677532197: [IFCDRAUGHTINGPREDEFINEDCURVEFONT, IFCPREDEFINEDCURVEFONT, IFCDRAUGHTINGPREDEFINEDCOLOUR, IFCPREDEFINEDCOLOUR, IFCTEXTSTYLEFONTMODEL, IFCPREDEFINEDTEXTFONT, IFCPREDEFINEDITEM, IFCINDEXEDCOLOURMAP, IFCCURVESTYLEFONTPATTERN, IFCCURVESTYLEFONTANDSCALING, IFCCURVESTYLEFONT, IFCCOLOURRGB, IFCCOLOURSPECIFICATION, IFCCOLOURRGBLIST, IFCTEXTUREVERTEXLIST, IFCTEXTUREVERTEX, IFCINDEXEDTRIANGLETEXTUREMAP, IFCINDEXEDTEXTUREMAP, IFCTEXTUREMAP, IFCTEXTURECOORDINATEGENERATOR, IFCTEXTURECOORDINATE, IFCTEXTSTYLETEXTMODEL, IFCTEXTSTYLEFORDEFINEDFONT, IFCPIXELTEXTURE, IFCIMAGETEXTURE, IFCBLOBTEXTURE, IFCSURFACETEXTURE, IFCSURFACESTYLEWITHTEXTURES, IFCSURFACESTYLERENDERING, IFCSURFACESTYLESHADING, IFCSURFACESTYLEREFRACTION, IFCSURFACESTYLELIGHTING],
  2022622350: [IFCPRESENTATIONLAYERWITHSTYLE],
  3119450353: [IFCFILLAREASTYLE, IFCCURVESTYLE, IFCTEXTSTYLE, IFCSURFACESTYLE],
  2095639259: [IFCPRODUCTDEFINITIONSHAPE, IFCMATERIALDEFINITIONREPRESENTATION],
  3958567839: [IFCLSHAPEPROFILEDEF, IFCISHAPEPROFILEDEF, IFCELLIPSEPROFILEDEF, IFCCIRCLEHOLLOWPROFILEDEF, IFCCIRCLEPROFILEDEF, IFCCSHAPEPROFILEDEF, IFCASYMMETRICISHAPEPROFILEDEF, IFCZSHAPEPROFILEDEF, IFCUSHAPEPROFILEDEF, IFCTRAPEZIUMPROFILEDEF, IFCTSHAPEPROFILEDEF, IFCRECTANGLEHOLLOWPROFILEDEF, IFCROUNDEDRECTANGLEPROFILEDEF, IFCRECTANGLEPROFILEDEF, IFCPARAMETERIZEDPROFILEDEF, IFCMIRROREDPROFILEDEF, IFCDERIVEDPROFILEDEF, IFCCOMPOSITEPROFILEDEF, IFCCENTERLINEPROFILEDEF, IFCARBITRARYOPENPROFILEDEF, IFCARBITRARYPROFILEDEFWITHVOIDS, IFCARBITRARYCLOSEDPROFILEDEF],
  986844984: [IFCCOMPLEXPROPERTY, IFCPROPERTYTABLEVALUE, IFCPROPERTYSINGLEVALUE, IFCPROPERTYREFERENCEVALUE, IFCPROPERTYLISTVALUE, IFCPROPERTYENUMERATEDVALUE, IFCPROPERTYBOUNDEDVALUE, IFCSIMPLEPROPERTY, IFCPROPERTY, IFCSECTIONREINFORCEMENTPROPERTIES, IFCSECTIONPROPERTIES, IFCREINFORCEMENTBARPROPERTIES, IFCPREDEFINEDPROPERTIES, IFCPROFILEPROPERTIES, IFCMATERIALPROPERTIES, IFCEXTENDEDPROPERTIES, IFCPROPERTYENUMERATION],
  1076942058: [IFCSTYLEDREPRESENTATION, IFCSTYLEMODEL, IFCTOPOLOGYREPRESENTATION, IFCSHAPEREPRESENTATION, IFCSHAPEMODEL],
  3377609919: [IFCGEOMETRICREPRESENTATIONSUBCONTEXT, IFCGEOMETRICREPRESENTATIONCONTEXT],
  3008791417: [IFCMAPPEDITEM, IFCFILLAREASTYLETILES, IFCFILLAREASTYLEHATCHING, IFCFACEBASEDSURFACEMODEL, IFCDIRECTION, IFCCIRCLE, IFCELLIPSE, IFCCONIC, IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFCINDEXEDPOLYCURVE, IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE, IFCCOMPOSITECURVE, IFCBOUNDEDCURVE, IFCSEAMCURVE, IFCINTERSECTIONCURVE, IFCSURFACECURVE, IFCPCURVE, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D, IFCLINE, IFCCURVE, IFCBLOCK, IFCSPHERE, IFCRIGHTCIRCULARCYLINDER, IFCRIGHTCIRCULARCONE, IFCRECTANGULARPYRAMID, IFCCSGPRIMITIVE3D, IFCREPARAMETRISEDCOMPOSITECURVESEGMENT, IFCCOMPOSITECURVESEGMENT, IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR3D, IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR2D, IFCCARTESIANTRANSFORMATIONOPERATOR, IFCCARTESIANPOINTLIST3D, IFCCARTESIANPOINTLIST2D, IFCCARTESIANPOINTLIST, IFCBOUNDINGBOX, IFCBOOLEANCLIPPINGRESULT, IFCBOOLEANRESULT, IFCANNOTATIONFILLAREA, IFCVECTOR, IFCTEXTLITERALWITHEXTENT, IFCTEXTLITERAL, IFCPOLYGONALFACESET, IFCTRIANGULATEDFACESET, IFCTESSELLATEDFACESET, IFCINDEXEDPOLYGONALFACEWITHVOIDS, IFCINDEXEDPOLYGONALFACE, IFCTESSELLATEDITEM, IFCCYLINDRICALSURFACE, IFCTOROIDALSURFACE, IFCSPHERICALSURFACE, IFCPLANE, IFCELEMENTARYSURFACE, IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDSURFACE, IFCCURVEBOUNDEDPLANE, IFCBOUNDEDSURFACE, IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION, IFCSWEPTSURFACE, IFCSURFACE, IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCADVANCEDBREPWITHVOIDS, IFCADVANCEDBREP, IFCMANIFOLDSOLIDBREP, IFCCSGSOLID, IFCSWEPTDISKSOLIDPOLYGONAL, IFCSWEPTDISKSOLID, IFCSURFACECURVESWEPTAREASOLID, IFCREVOLVEDAREASOLIDTAPERED, IFCREVOLVEDAREASOLID, IFCFIXEDREFERENCESWEPTAREASOLID, IFCEXTRUDEDAREASOLIDTAPERED, IFCEXTRUDEDAREASOLID, IFCSWEPTAREASOLID, IFCSOLIDMODEL, IFCSHELLBASEDSURFACEMODEL, IFCSECTIONEDSPINE, IFCCARTESIANPOINT, IFCPOINTONSURFACE, IFCPOINTONCURVE, IFCPOINT, IFCPLANARBOX, IFCPLANAREXTENT, IFCAXIS2PLACEMENT3D, IFCAXIS2PLACEMENT2D, IFCAXIS1PLACEMENT, IFCPLACEMENT, IFCLIGHTSOURCESPOT, IFCLIGHTSOURCEPOSITIONAL, IFCLIGHTSOURCEGONIOMETRIC, IFCLIGHTSOURCEDIRECTIONAL, IFCLIGHTSOURCEAMBIENT, IFCLIGHTSOURCE, IFCBOXEDHALFSPACE, IFCPOLYGONALBOUNDEDHALFSPACE, IFCHALFSPACESOLID, IFCGEOMETRICCURVESET, IFCGEOMETRICSET, IFCGEOMETRICREPRESENTATIONITEM, IFCPATH, IFCEDGELOOP, IFCVERTEXLOOP, IFCPOLYLOOP, IFCLOOP, IFCFACEOUTERBOUND, IFCFACEBOUND, IFCADVANCEDFACE, IFCFACESURFACE, IFCFACE, IFCSUBEDGE, IFCORIENTEDEDGE, IFCEDGECURVE, IFCEDGE, IFCCLOSEDSHELL, IFCOPENSHELL, IFCCONNECTEDFACESET, IFCVERTEXPOINT, IFCVERTEX, IFCTOPOLOGICALREPRESENTATIONITEM, IFCSTYLEDITEM],
  2439245199: [IFCRESOURCECONSTRAINTRELATIONSHIP, IFCRESOURCEAPPROVALRELATIONSHIP, IFCPROPERTYDEPENDENCYRELATIONSHIP, IFCORGANIZATIONRELATIONSHIP, IFCMATERIALRELATIONSHIP, IFCEXTERNALREFERENCERELATIONSHIP, IFCDOCUMENTINFORMATIONRELATIONSHIP, IFCCURRENCYRELATIONSHIP, IFCAPPROVALRELATIONSHIP],
  2341007311: [IFCRELDEFINESBYTYPE, IFCRELDEFINESBYTEMPLATE, IFCRELDEFINESBYPROPERTIES, IFCRELDEFINESBYOBJECT, IFCRELDEFINES, IFCRELAGGREGATES, IFCRELVOIDSELEMENT, IFCRELPROJECTSELEMENT, IFCRELNESTS, IFCRELDECOMPOSES, IFCRELDECLARES, IFCRELSPACEBOUNDARY2NDLEVEL, IFCRELSPACEBOUNDARY1STLEVEL, IFCRELSPACEBOUNDARY, IFCRELSERVICESBUILDINGS, IFCRELSEQUENCE, IFCRELREFERENCEDINSPATIALSTRUCTURE, IFCRELINTERFERESELEMENTS, IFCRELFLOWCONTROLELEMENTS, IFCRELFILLSELEMENT, IFCRELCOVERSSPACES, IFCRELCOVERSBLDGELEMENTS, IFCRELCONTAINEDINSPATIALSTRUCTURE, IFCRELCONNECTSWITHECCENTRICITY, IFCRELCONNECTSSTRUCTURALMEMBER, IFCRELCONNECTSSTRUCTURALACTIVITY, IFCRELCONNECTSPORTS, IFCRELCONNECTSPORTTOELEMENT, IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS, IFCRELCONNECTSELEMENTS, IFCRELCONNECTS, IFCRELASSOCIATESMATERIAL, IFCRELASSOCIATESLIBRARY, IFCRELASSOCIATESDOCUMENT, IFCRELASSOCIATESCONSTRAINT, IFCRELASSOCIATESCLASSIFICATION, IFCRELASSOCIATESAPPROVAL, IFCRELASSOCIATES, IFCRELASSIGNSTORESOURCE, IFCRELASSIGNSTOPRODUCT, IFCRELASSIGNSTOPROCESS, IFCRELASSIGNSTOGROUPBYFACTOR, IFCRELASSIGNSTOGROUP, IFCRELASSIGNSTOCONTROL, IFCRELASSIGNSTOACTOR, IFCRELASSIGNS, IFCRELATIONSHIP, IFCCOMPLEXPROPERTYTEMPLATE, IFCSIMPLEPROPERTYTEMPLATE, IFCPROPERTYTEMPLATE, IFCPROPERTYSETTEMPLATE, IFCPROPERTYTEMPLATEDEFINITION, IFCPROPERTYSET, IFCPERMEABLECOVERINGPROPERTIES, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCREINFORCEMENTDEFINITIONPROPERTIES, IFCPREDEFINEDPROPERTYSET, IFCELEMENTQUANTITY, IFCQUANTITYSET, IFCPROPERTYSETDEFINITION, IFCPROPERTYDEFINITION, IFCASSET, IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILDINGSYSTEM, IFCZONE, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADCASE, IFCSTRUCTURALLOADGROUP, IFCINVENTORY, IFCGROUP, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCWORKCALENDAR, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCCOSTSCHEDULE, IFCCOSTITEM, IFCCONTROL, IFCOCCUPANT, IFCACTOR, IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE, IFCRESOURCE, IFCDISTRIBUTIONPORT, IFCPORT, IFCGRID, IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSANITARYTERMINAL, IFCOUTLET, IFCMEDICALDEVICE, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBEAMSTANDARDCASE, IFCBEAM, IFCWINDOWSTANDARDCASE, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALLELEMENTEDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLABSTANDARDCASE, IFCSLABELEMENTEDCASE, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATESTANDARDCASE, IFCPLATE, IFCPILE, IFCMEMBERSTANDARDCASE, IFCMEMBER, IFCFOOTING, IFCDOORSTANDARDCASE, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMNSTANDARDCASE, IFCCOLUMN, IFCCHIMNEY, IFCBUILDINGELEMENTPROXY, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCVOIDINGFEATURE, IFCOPENINGSTANDARDCASE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING, IFCSPATIALSTRUCTUREELEMENT, IFCSPATIALELEMENT, IFCPROXY, IFCPRODUCT, IFCPROCEDURE, IFCEVENT, IFCTASK, IFCPROCESS, IFCOBJECT, IFCPROJECTLIBRARY, IFCPROJECT, IFCCONTEXT, IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE, IFCCONSTRUCTIONRESOURCETYPE, IFCTYPERESOURCE, IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSPATIALELEMENTTYPE, IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMEDICALDEVICETYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCPILETYPE, IFCMEMBERTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCDOORSTYLE, IFCWINDOWSTYLE, IFCTYPEPRODUCT, IFCTASKTYPE, IFCPROCEDURETYPE, IFCEVENTTYPE, IFCTYPEPROCESS, IFCTYPEOBJECT, IFCOBJECTDEFINITION],
  1054537805: [IFCRESOURCETIME, IFCLAGTIME, IFCEVENTTIME, IFCWORKTIME, IFCTASKTIMERECURRING, IFCTASKTIME],
  3982875396: [IFCTOPOLOGYREPRESENTATION, IFCSHAPEREPRESENTATION],
  2273995522: [IFCSLIPPAGECONNECTIONCONDITION, IFCFAILURECONNECTIONCONDITION],
  2162789131: [IFCSURFACEREINFORCEMENTAREA, IFCSTRUCTURALLOADSINGLEFORCEWARPING, IFCSTRUCTURALLOADSINGLEFORCE, IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION, IFCSTRUCTURALLOADSINGLEDISPLACEMENT, IFCSTRUCTURALLOADPLANARFORCE, IFCSTRUCTURALLOADLINEARFORCE, IFCSTRUCTURALLOADTEMPERATURE, IFCSTRUCTURALLOADSTATIC, IFCSTRUCTURALLOADORRESULT, IFCSTRUCTURALLOADCONFIGURATION],
  609421318: [IFCSURFACEREINFORCEMENTAREA, IFCSTRUCTURALLOADSINGLEFORCEWARPING, IFCSTRUCTURALLOADSINGLEFORCE, IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION, IFCSTRUCTURALLOADSINGLEDISPLACEMENT, IFCSTRUCTURALLOADPLANARFORCE, IFCSTRUCTURALLOADLINEARFORCE, IFCSTRUCTURALLOADTEMPERATURE, IFCSTRUCTURALLOADSTATIC],
  2525727697: [IFCSTRUCTURALLOADSINGLEFORCEWARPING, IFCSTRUCTURALLOADSINGLEFORCE, IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION, IFCSTRUCTURALLOADSINGLEDISPLACEMENT, IFCSTRUCTURALLOADPLANARFORCE, IFCSTRUCTURALLOADLINEARFORCE, IFCSTRUCTURALLOADTEMPERATURE],
  2830218821: [IFCSTYLEDREPRESENTATION],
  846575682: [IFCSURFACESTYLERENDERING],
  626085974: [IFCPIXELTEXTURE, IFCIMAGETEXTURE, IFCBLOBTEXTURE],
  1549132990: [IFCTASKTIMERECURRING],
  280115917: [IFCINDEXEDTRIANGLETEXTUREMAP, IFCINDEXEDTEXTUREMAP, IFCTEXTUREMAP, IFCTEXTURECOORDINATEGENERATOR],
  3101149627: [IFCREGULARTIMESERIES, IFCIRREGULARTIMESERIES],
  1377556343: [IFCPATH, IFCEDGELOOP, IFCVERTEXLOOP, IFCPOLYLOOP, IFCLOOP, IFCFACEOUTERBOUND, IFCFACEBOUND, IFCADVANCEDFACE, IFCFACESURFACE, IFCFACE, IFCSUBEDGE, IFCORIENTEDEDGE, IFCEDGECURVE, IFCEDGE, IFCCLOSEDSHELL, IFCOPENSHELL, IFCCONNECTEDFACESET, IFCVERTEXPOINT, IFCVERTEX],
  2799835756: [IFCVERTEXPOINT],
  3798115385: [IFCARBITRARYPROFILEDEFWITHVOIDS],
  1310608509: [IFCCENTERLINEPROFILEDEF],
  3264961684: [IFCCOLOURRGB],
  370225590: [IFCCLOSEDSHELL, IFCOPENSHELL],
  2889183280: [IFCCONVERSIONBASEDUNITWITHOFFSET],
  3632507154: [IFCMIRROREDPROFILEDEF],
  3900360178: [IFCSUBEDGE, IFCORIENTEDEDGE, IFCEDGECURVE],
  297599258: [IFCPROFILEPROPERTIES, IFCMATERIALPROPERTIES],
  2556980723: [IFCADVANCEDFACE, IFCFACESURFACE],
  1809719519: [IFCFACEOUTERBOUND],
  3008276851: [IFCADVANCEDFACE],
  3448662350: [IFCGEOMETRICREPRESENTATIONSUBCONTEXT],
  2453401579: [IFCFILLAREASTYLETILES, IFCFILLAREASTYLEHATCHING, IFCFACEBASEDSURFACEMODEL, IFCDIRECTION, IFCCIRCLE, IFCELLIPSE, IFCCONIC, IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFCINDEXEDPOLYCURVE, IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE, IFCCOMPOSITECURVE, IFCBOUNDEDCURVE, IFCSEAMCURVE, IFCINTERSECTIONCURVE, IFCSURFACECURVE, IFCPCURVE, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D, IFCLINE, IFCCURVE, IFCBLOCK, IFCSPHERE, IFCRIGHTCIRCULARCYLINDER, IFCRIGHTCIRCULARCONE, IFCRECTANGULARPYRAMID, IFCCSGPRIMITIVE3D, IFCREPARAMETRISEDCOMPOSITECURVESEGMENT, IFCCOMPOSITECURVESEGMENT, IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR3D, IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR2D, IFCCARTESIANTRANSFORMATIONOPERATOR, IFCCARTESIANPOINTLIST3D, IFCCARTESIANPOINTLIST2D, IFCCARTESIANPOINTLIST, IFCBOUNDINGBOX, IFCBOOLEANCLIPPINGRESULT, IFCBOOLEANRESULT, IFCANNOTATIONFILLAREA, IFCVECTOR, IFCTEXTLITERALWITHEXTENT, IFCTEXTLITERAL, IFCPOLYGONALFACESET, IFCTRIANGULATEDFACESET, IFCTESSELLATEDFACESET, IFCINDEXEDPOLYGONALFACEWITHVOIDS, IFCINDEXEDPOLYGONALFACE, IFCTESSELLATEDITEM, IFCCYLINDRICALSURFACE, IFCTOROIDALSURFACE, IFCSPHERICALSURFACE, IFCPLANE, IFCELEMENTARYSURFACE, IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDSURFACE, IFCCURVEBOUNDEDPLANE, IFCBOUNDEDSURFACE, IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION, IFCSWEPTSURFACE, IFCSURFACE, IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCADVANCEDBREPWITHVOIDS, IFCADVANCEDBREP, IFCMANIFOLDSOLIDBREP, IFCCSGSOLID, IFCSWEPTDISKSOLIDPOLYGONAL, IFCSWEPTDISKSOLID, IFCSURFACECURVESWEPTAREASOLID, IFCREVOLVEDAREASOLIDTAPERED, IFCREVOLVEDAREASOLID, IFCFIXEDREFERENCESWEPTAREASOLID, IFCEXTRUDEDAREASOLIDTAPERED, IFCEXTRUDEDAREASOLID, IFCSWEPTAREASOLID, IFCSOLIDMODEL, IFCSHELLBASEDSURFACEMODEL, IFCSECTIONEDSPINE, IFCCARTESIANPOINT, IFCPOINTONSURFACE, IFCPOINTONCURVE, IFCPOINT, IFCPLANARBOX, IFCPLANAREXTENT, IFCAXIS2PLACEMENT3D, IFCAXIS2PLACEMENT2D, IFCAXIS1PLACEMENT, IFCPLACEMENT, IFCLIGHTSOURCESPOT, IFCLIGHTSOURCEPOSITIONAL, IFCLIGHTSOURCEGONIOMETRIC, IFCLIGHTSOURCEDIRECTIONAL, IFCLIGHTSOURCEAMBIENT, IFCLIGHTSOURCE, IFCBOXEDHALFSPACE, IFCPOLYGONALBOUNDEDHALFSPACE, IFCHALFSPACESOLID, IFCGEOMETRICCURVESET, IFCGEOMETRICSET],
  3590301190: [IFCGEOMETRICCURVESET],
  812098782: [IFCBOXEDHALFSPACE, IFCPOLYGONALBOUNDEDHALFSPACE],
  1437953363: [IFCINDEXEDTRIANGLETEXTUREMAP],
  1402838566: [IFCLIGHTSOURCESPOT, IFCLIGHTSOURCEPOSITIONAL, IFCLIGHTSOURCEGONIOMETRIC, IFCLIGHTSOURCEDIRECTIONAL, IFCLIGHTSOURCEAMBIENT],
  1520743889: [IFCLIGHTSOURCESPOT],
  1008929658: [IFCEDGELOOP, IFCVERTEXLOOP, IFCPOLYLOOP],
  3079605661: [IFCMATERIALPROFILESETUSAGETAPERING],
  219451334: [IFCASSET, IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILDINGSYSTEM, IFCZONE, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADCASE, IFCSTRUCTURALLOADGROUP, IFCINVENTORY, IFCGROUP, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCWORKCALENDAR, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCCOSTSCHEDULE, IFCCOSTITEM, IFCCONTROL, IFCOCCUPANT, IFCACTOR, IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE, IFCRESOURCE, IFCDISTRIBUTIONPORT, IFCPORT, IFCGRID, IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSANITARYTERMINAL, IFCOUTLET, IFCMEDICALDEVICE, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBEAMSTANDARDCASE, IFCBEAM, IFCWINDOWSTANDARDCASE, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALLELEMENTEDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLABSTANDARDCASE, IFCSLABELEMENTEDCASE, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATESTANDARDCASE, IFCPLATE, IFCPILE, IFCMEMBERSTANDARDCASE, IFCMEMBER, IFCFOOTING, IFCDOORSTANDARDCASE, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMNSTANDARDCASE, IFCCOLUMN, IFCCHIMNEY, IFCBUILDINGELEMENTPROXY, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCVOIDINGFEATURE, IFCOPENINGSTANDARDCASE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING, IFCSPATIALSTRUCTUREELEMENT, IFCSPATIALELEMENT, IFCPROXY, IFCPRODUCT, IFCPROCEDURE, IFCEVENT, IFCTASK, IFCPROCESS, IFCOBJECT, IFCPROJECTLIBRARY, IFCPROJECT, IFCCONTEXT, IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE, IFCCONSTRUCTIONRESOURCETYPE, IFCTYPERESOURCE, IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSPATIALELEMENTTYPE, IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMEDICALDEVICETYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCPILETYPE, IFCMEMBERTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCDOORSTYLE, IFCWINDOWSTYLE, IFCTYPEPRODUCT, IFCTASKTYPE, IFCPROCEDURETYPE, IFCEVENTTYPE, IFCTYPEPROCESS, IFCTYPEOBJECT],
  2529465313: [IFCLSHAPEPROFILEDEF, IFCISHAPEPROFILEDEF, IFCELLIPSEPROFILEDEF, IFCCIRCLEHOLLOWPROFILEDEF, IFCCIRCLEPROFILEDEF, IFCCSHAPEPROFILEDEF, IFCASYMMETRICISHAPEPROFILEDEF, IFCZSHAPEPROFILEDEF, IFCUSHAPEPROFILEDEF, IFCTRAPEZIUMPROFILEDEF, IFCTSHAPEPROFILEDEF, IFCRECTANGLEHOLLOWPROFILEDEF, IFCROUNDEDRECTANGLEPROFILEDEF, IFCRECTANGLEPROFILEDEF],
  2004835150: [IFCAXIS2PLACEMENT3D, IFCAXIS2PLACEMENT2D, IFCAXIS1PLACEMENT],
  1663979128: [IFCPLANARBOX],
  2067069095: [IFCCARTESIANPOINT, IFCPOINTONSURFACE, IFCPOINTONCURVE],
  3727388367: [IFCDRAUGHTINGPREDEFINEDCURVEFONT, IFCPREDEFINEDCURVEFONT, IFCDRAUGHTINGPREDEFINEDCOLOUR, IFCPREDEFINEDCOLOUR, IFCTEXTSTYLEFONTMODEL, IFCPREDEFINEDTEXTFONT],
  3778827333: [IFCSECTIONREINFORCEMENTPROPERTIES, IFCSECTIONPROPERTIES, IFCREINFORCEMENTBARPROPERTIES],
  1775413392: [IFCTEXTSTYLEFONTMODEL],
  2598011224: [IFCCOMPLEXPROPERTY, IFCPROPERTYTABLEVALUE, IFCPROPERTYSINGLEVALUE, IFCPROPERTYREFERENCEVALUE, IFCPROPERTYLISTVALUE, IFCPROPERTYENUMERATEDVALUE, IFCPROPERTYBOUNDEDVALUE, IFCSIMPLEPROPERTY],
  1680319473: [IFCCOMPLEXPROPERTYTEMPLATE, IFCSIMPLEPROPERTYTEMPLATE, IFCPROPERTYTEMPLATE, IFCPROPERTYSETTEMPLATE, IFCPROPERTYTEMPLATEDEFINITION, IFCPROPERTYSET, IFCPERMEABLECOVERINGPROPERTIES, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCREINFORCEMENTDEFINITIONPROPERTIES, IFCPREDEFINEDPROPERTYSET, IFCELEMENTQUANTITY, IFCQUANTITYSET, IFCPROPERTYSETDEFINITION],
  3357820518: [IFCPROPERTYSET, IFCPERMEABLECOVERINGPROPERTIES, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCREINFORCEMENTDEFINITIONPROPERTIES, IFCPREDEFINEDPROPERTYSET, IFCELEMENTQUANTITY, IFCQUANTITYSET],
  1482703590: [IFCCOMPLEXPROPERTYTEMPLATE, IFCSIMPLEPROPERTYTEMPLATE, IFCPROPERTYTEMPLATE, IFCPROPERTYSETTEMPLATE],
  2090586900: [IFCELEMENTQUANTITY],
  3615266464: [IFCRECTANGLEHOLLOWPROFILEDEF, IFCROUNDEDRECTANGLEPROFILEDEF],
  478536968: [IFCRELDEFINESBYTYPE, IFCRELDEFINESBYTEMPLATE, IFCRELDEFINESBYPROPERTIES, IFCRELDEFINESBYOBJECT, IFCRELDEFINES, IFCRELAGGREGATES, IFCRELVOIDSELEMENT, IFCRELPROJECTSELEMENT, IFCRELNESTS, IFCRELDECOMPOSES, IFCRELDECLARES, IFCRELSPACEBOUNDARY2NDLEVEL, IFCRELSPACEBOUNDARY1STLEVEL, IFCRELSPACEBOUNDARY, IFCRELSERVICESBUILDINGS, IFCRELSEQUENCE, IFCRELREFERENCEDINSPATIALSTRUCTURE, IFCRELINTERFERESELEMENTS, IFCRELFLOWCONTROLELEMENTS, IFCRELFILLSELEMENT, IFCRELCOVERSSPACES, IFCRELCOVERSBLDGELEMENTS, IFCRELCONTAINEDINSPATIALSTRUCTURE, IFCRELCONNECTSWITHECCENTRICITY, IFCRELCONNECTSSTRUCTURALMEMBER, IFCRELCONNECTSSTRUCTURALACTIVITY, IFCRELCONNECTSPORTS, IFCRELCONNECTSPORTTOELEMENT, IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS, IFCRELCONNECTSELEMENTS, IFCRELCONNECTS, IFCRELASSOCIATESMATERIAL, IFCRELASSOCIATESLIBRARY, IFCRELASSOCIATESDOCUMENT, IFCRELASSOCIATESCONSTRAINT, IFCRELASSOCIATESCLASSIFICATION, IFCRELASSOCIATESAPPROVAL, IFCRELASSOCIATES, IFCRELASSIGNSTORESOURCE, IFCRELASSIGNSTOPRODUCT, IFCRELASSIGNSTOPROCESS, IFCRELASSIGNSTOGROUPBYFACTOR, IFCRELASSIGNSTOGROUP, IFCRELASSIGNSTOCONTROL, IFCRELASSIGNSTOACTOR, IFCRELASSIGNS],
  3692461612: [IFCPROPERTYTABLEVALUE, IFCPROPERTYSINGLEVALUE, IFCPROPERTYREFERENCEVALUE, IFCPROPERTYLISTVALUE, IFCPROPERTYENUMERATEDVALUE, IFCPROPERTYBOUNDEDVALUE],
  723233188: [IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCADVANCEDBREPWITHVOIDS, IFCADVANCEDBREP, IFCMANIFOLDSOLIDBREP, IFCCSGSOLID, IFCSWEPTDISKSOLIDPOLYGONAL, IFCSWEPTDISKSOLID, IFCSURFACECURVESWEPTAREASOLID, IFCREVOLVEDAREASOLIDTAPERED, IFCREVOLVEDAREASOLID, IFCFIXEDREFERENCESWEPTAREASOLID, IFCEXTRUDEDAREASOLIDTAPERED, IFCEXTRUDEDAREASOLID, IFCSWEPTAREASOLID],
  2473145415: [IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION],
  1597423693: [IFCSTRUCTURALLOADSINGLEFORCEWARPING],
  2513912981: [IFCCYLINDRICALSURFACE, IFCTOROIDALSURFACE, IFCSPHERICALSURFACE, IFCPLANE, IFCELEMENTARYSURFACE, IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDSURFACE, IFCCURVEBOUNDEDPLANE, IFCBOUNDEDSURFACE, IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION, IFCSWEPTSURFACE],
  2247615214: [IFCSURFACECURVESWEPTAREASOLID, IFCREVOLVEDAREASOLIDTAPERED, IFCREVOLVEDAREASOLID, IFCFIXEDREFERENCESWEPTAREASOLID, IFCEXTRUDEDAREASOLIDTAPERED, IFCEXTRUDEDAREASOLID],
  1260650574: [IFCSWEPTDISKSOLIDPOLYGONAL],
  230924584: [IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION],
  901063453: [IFCPOLYGONALFACESET, IFCTRIANGULATEDFACESET, IFCTESSELLATEDFACESET, IFCINDEXEDPOLYGONALFACEWITHVOIDS, IFCINDEXEDPOLYGONALFACE],
  4282788508: [IFCTEXTLITERALWITHEXTENT],
  1628702193: [IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE, IFCCONSTRUCTIONRESOURCETYPE, IFCTYPERESOURCE, IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSPATIALELEMENTTYPE, IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMEDICALDEVICETYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCPILETYPE, IFCMEMBERTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCDOORSTYLE, IFCWINDOWSTYLE, IFCTYPEPRODUCT, IFCTASKTYPE, IFCPROCEDURETYPE, IFCEVENTTYPE, IFCTYPEPROCESS],
  3736923433: [IFCTASKTYPE, IFCPROCEDURETYPE, IFCEVENTTYPE],
  2347495698: [IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSPATIALELEMENTTYPE, IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMEDICALDEVICETYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCPILETYPE, IFCMEMBERTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCDOORSTYLE, IFCWINDOWSTYLE],
  3698973494: [IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE, IFCCONSTRUCTIONRESOURCETYPE],
  2736907675: [IFCBOOLEANCLIPPINGRESULT],
  4182860854: [IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDSURFACE, IFCCURVEBOUNDEDPLANE],
  574549367: [IFCCARTESIANPOINTLIST3D, IFCCARTESIANPOINTLIST2D],
  59481748: [IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR3D, IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR2D],
  3749851601: [IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM],
  3331915920: [IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM],
  1383045692: [IFCCIRCLEHOLLOWPROFILEDEF],
  2485617015: [IFCREPARAMETRISEDCOMPOSITECURVESEGMENT],
  2574617495: [IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE],
  3419103109: [IFCPROJECTLIBRARY, IFCPROJECT],
  2506170314: [IFCBLOCK, IFCSPHERE, IFCRIGHTCIRCULARCYLINDER, IFCRIGHTCIRCULARCONE, IFCRECTANGULARPYRAMID],
  2601014836: [IFCCIRCLE, IFCELLIPSE, IFCCONIC, IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFCINDEXEDPOLYCURVE, IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE, IFCCOMPOSITECURVE, IFCBOUNDEDCURVE, IFCSEAMCURVE, IFCINTERSECTIONCURVE, IFCSURFACECURVE, IFCPCURVE, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D, IFCLINE],
  339256511: [IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMEDICALDEVICETYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCPILETYPE, IFCMEMBERTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE],
  2777663545: [IFCCYLINDRICALSURFACE, IFCTOROIDALSURFACE, IFCSPHERICALSURFACE, IFCPLANE],
  477187591: [IFCEXTRUDEDAREASOLIDTAPERED],
  4238390223: [IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE],
  178912537: [IFCINDEXEDPOLYGONALFACEWITHVOIDS],
  1425443689: [IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCADVANCEDBREPWITHVOIDS, IFCADVANCEDBREP],
  3888040117: [IFCASSET, IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILDINGSYSTEM, IFCZONE, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADCASE, IFCSTRUCTURALLOADGROUP, IFCINVENTORY, IFCGROUP, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCWORKCALENDAR, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCCOSTSCHEDULE, IFCCOSTITEM, IFCCONTROL, IFCOCCUPANT, IFCACTOR, IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE, IFCRESOURCE, IFCDISTRIBUTIONPORT, IFCPORT, IFCGRID, IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSANITARYTERMINAL, IFCOUTLET, IFCMEDICALDEVICE, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBEAMSTANDARDCASE, IFCBEAM, IFCWINDOWSTANDARDCASE, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALLELEMENTEDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLABSTANDARDCASE, IFCSLABELEMENTEDCASE, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATESTANDARDCASE, IFCPLATE, IFCPILE, IFCMEMBERSTANDARDCASE, IFCMEMBER, IFCFOOTING, IFCDOORSTANDARDCASE, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMNSTANDARDCASE, IFCCOLUMN, IFCCHIMNEY, IFCBUILDINGELEMENTPROXY, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCVOIDINGFEATURE, IFCOPENINGSTANDARDCASE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING, IFCSPATIALSTRUCTUREELEMENT, IFCSPATIALELEMENT, IFCPROXY, IFCPRODUCT, IFCPROCEDURE, IFCEVENT, IFCTASK, IFCPROCESS],
  759155922: [IFCDRAUGHTINGPREDEFINEDCOLOUR],
  2559016684: [IFCDRAUGHTINGPREDEFINEDCURVEFONT],
  3967405729: [IFCPERMEABLECOVERINGPROPERTIES, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCREINFORCEMENTDEFINITIONPROPERTIES],
  2945172077: [IFCPROCEDURE, IFCEVENT, IFCTASK],
  4208778838: [IFCDISTRIBUTIONPORT, IFCPORT, IFCGRID, IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSANITARYTERMINAL, IFCOUTLET, IFCMEDICALDEVICE, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBEAMSTANDARDCASE, IFCBEAM, IFCWINDOWSTANDARDCASE, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALLELEMENTEDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLABSTANDARDCASE, IFCSLABELEMENTEDCASE, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATESTANDARDCASE, IFCPLATE, IFCPILE, IFCMEMBERSTANDARDCASE, IFCMEMBER, IFCFOOTING, IFCDOORSTANDARDCASE, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMNSTANDARDCASE, IFCCOLUMN, IFCCHIMNEY, IFCBUILDINGELEMENTPROXY, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCVOIDINGFEATURE, IFCOPENINGSTANDARDCASE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING, IFCSPATIALSTRUCTUREELEMENT, IFCSPATIALELEMENT, IFCPROXY],
  3521284610: [IFCCOMPLEXPROPERTYTEMPLATE, IFCSIMPLEPROPERTYTEMPLATE],
  3939117080: [IFCRELASSIGNSTORESOURCE, IFCRELASSIGNSTOPRODUCT, IFCRELASSIGNSTOPROCESS, IFCRELASSIGNSTOGROUPBYFACTOR, IFCRELASSIGNSTOGROUP, IFCRELASSIGNSTOCONTROL, IFCRELASSIGNSTOACTOR],
  1307041759: [IFCRELASSIGNSTOGROUPBYFACTOR],
  1865459582: [IFCRELASSOCIATESMATERIAL, IFCRELASSOCIATESLIBRARY, IFCRELASSOCIATESDOCUMENT, IFCRELASSOCIATESCONSTRAINT, IFCRELASSOCIATESCLASSIFICATION, IFCRELASSOCIATESAPPROVAL],
  826625072: [IFCRELSPACEBOUNDARY2NDLEVEL, IFCRELSPACEBOUNDARY1STLEVEL, IFCRELSPACEBOUNDARY, IFCRELSERVICESBUILDINGS, IFCRELSEQUENCE, IFCRELREFERENCEDINSPATIALSTRUCTURE, IFCRELINTERFERESELEMENTS, IFCRELFLOWCONTROLELEMENTS, IFCRELFILLSELEMENT, IFCRELCOVERSSPACES, IFCRELCOVERSBLDGELEMENTS, IFCRELCONTAINEDINSPATIALSTRUCTURE, IFCRELCONNECTSWITHECCENTRICITY, IFCRELCONNECTSSTRUCTURALMEMBER, IFCRELCONNECTSSTRUCTURALACTIVITY, IFCRELCONNECTSPORTS, IFCRELCONNECTSPORTTOELEMENT, IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS, IFCRELCONNECTSELEMENTS],
  1204542856: [IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS],
  1638771189: [IFCRELCONNECTSWITHECCENTRICITY],
  2551354335: [IFCRELAGGREGATES, IFCRELVOIDSELEMENT, IFCRELPROJECTSELEMENT, IFCRELNESTS],
  693640335: [IFCRELDEFINESBYTYPE, IFCRELDEFINESBYTEMPLATE, IFCRELDEFINESBYPROPERTIES, IFCRELDEFINESBYOBJECT],
  3451746338: [IFCRELSPACEBOUNDARY2NDLEVEL, IFCRELSPACEBOUNDARY1STLEVEL],
  3523091289: [IFCRELSPACEBOUNDARY2NDLEVEL],
  2914609552: [IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE],
  1856042241: [IFCREVOLVEDAREASOLIDTAPERED],
  1412071761: [IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING, IFCSPATIALSTRUCTUREELEMENT],
  710998568: [IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE],
  2706606064: [IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING],
  3893378262: [IFCSPACETYPE],
  3544373492: [IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION],
  3136571912: [IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER],
  530289379: [IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER],
  3689010777: [IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION],
  3979015343: [IFCSTRUCTURALSURFACEMEMBERVARYING],
  699246055: [IFCSEAMCURVE, IFCINTERSECTIONCURVE],
  2387106220: [IFCPOLYGONALFACESET, IFCTRIANGULATEDFACESET],
  2296667514: [IFCOCCUPANT],
  1635779807: [IFCADVANCEDBREPWITHVOIDS],
  2887950389: [IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS],
  167062518: [IFCRATIONALBSPLINESURFACEWITHKNOTS],
  1260505505: [IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFCINDEXEDPOLYCURVE, IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE, IFCCOMPOSITECURVE],
  1950629157: [IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCPILETYPE, IFCMEMBERTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE],
  3732776249: [IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE],
  15328376: [IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE],
  2510884976: [IFCCIRCLE, IFCELLIPSE],
  2559216714: [IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE],
  3293443760: [IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCWORKCALENDAR, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCCOSTSCHEDULE, IFCCOSTITEM],
  3256556792: [IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMEDICALDEVICETYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE],
  3849074793: [IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMEDICALDEVICETYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE],
  1758889154: [IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSANITARYTERMINAL, IFCOUTLET, IFCMEDICALDEVICE, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBEAMSTANDARDCASE, IFCBEAM, IFCWINDOWSTANDARDCASE, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALLELEMENTEDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLABSTANDARDCASE, IFCSLABELEMENTEDCASE, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATESTANDARDCASE, IFCPLATE, IFCPILE, IFCMEMBERSTANDARDCASE, IFCMEMBER, IFCFOOTING, IFCDOORSTANDARDCASE, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMNSTANDARDCASE, IFCCOLUMN, IFCCHIMNEY, IFCBUILDINGELEMENTPROXY, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCVOIDINGFEATURE, IFCOPENINGSTANDARDCASE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY],
  1623761950: [IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCFASTENER],
  2590856083: [IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE],
  2107101300: [IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE],
  2853485674: [IFCEXTERNALSPATIALELEMENT],
  807026263: [IFCFACETEDBREPWITHVOIDS],
  2827207264: [IFCSURFACEFEATURE, IFCVOIDINGFEATURE, IFCOPENINGSTANDARDCASE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION],
  2143335405: [IFCPROJECTIONELEMENT],
  1287392070: [IFCVOIDINGFEATURE, IFCOPENINGSTANDARDCASE, IFCOPENINGELEMENT],
  3907093117: [IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE],
  3198132628: [IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE],
  1482959167: [IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE],
  1834744321: [IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE],
  1339347760: [IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE],
  2297155007: [IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMEDICALDEVICETYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE],
  3009222698: [IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE],
  263784265: [IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE],
  2706460486: [IFCASSET, IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILDINGSYSTEM, IFCZONE, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADCASE, IFCSTRUCTURALLOADGROUP, IFCINVENTORY],
  3588315303: [IFCOPENINGSTANDARDCASE],
  3740093272: [IFCDISTRIBUTIONPORT],
  3027567501: [IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH],
  964333572: [IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE],
  682877961: [IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION],
  1179482911: [IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION],
  1004757350: [IFCSTRUCTURALLINEARACTION],
  214636428: [IFCSTRUCTURALCURVEMEMBERVARYING],
  1252848954: [IFCSTRUCTURALLOADCASE],
  3657597509: [IFCSTRUCTURALPLANARACTION],
  2254336722: [IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILDINGSYSTEM, IFCZONE],
  1028945134: [IFCWORKSCHEDULE, IFCWORKPLAN],
  1967976161: [IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS],
  2461110595: [IFCRATIONALBSPLINECURVEWITHKNOTS],
  1136057603: [IFCOUTERBOUNDARYCURVE],
  3299480353: [IFCBEAMSTANDARDCASE, IFCBEAM, IFCWINDOWSTANDARDCASE, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALLELEMENTEDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLABSTANDARDCASE, IFCSLABELEMENTEDCASE, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATESTANDARDCASE, IFCPLATE, IFCPILE, IFCMEMBERSTANDARDCASE, IFCMEMBER, IFCFOOTING, IFCDOORSTANDARDCASE, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMNSTANDARDCASE, IFCCOLUMN, IFCCHIMNEY, IFCBUILDINGELEMENTPROXY],
  843113511: [IFCCOLUMNSTANDARDCASE],
  2063403501: [IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE],
  1945004755: [IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSANITARYTERMINAL, IFCOUTLET, IFCMEDICALDEVICE, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT],
  3040386961: [IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSANITARYTERMINAL, IFCOUTLET, IFCMEDICALDEVICE, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE],
  3205830791: [IFCDISTRIBUTIONCIRCUIT],
  395920057: [IFCDOORSTANDARDCASE],
  1658829314: [IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE],
  2058353004: [IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER],
  4278956645: [IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX],
  3132237377: [IFCFAN, IFCCOMPRESSOR, IFCPUMP],
  987401354: [IFCDUCTSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT],
  707683696: [IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK],
  2223149337: [IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSANITARYTERMINAL, IFCOUTLET, IFCMEDICALDEVICE, IFCLIGHTFIXTURE, IFCLAMP],
  3508470533: [IFCFILTER, IFCDUCTSILENCER, IFCINTERCEPTOR],
  1073191201: [IFCMEMBERSTANDARDCASE],
  3171933400: [IFCPLATESTANDARDCASE],
  1529196076: [IFCSLABSTANDARDCASE, IFCSLABELEMENTEDCASE],
  2391406946: [IFCWALLSTANDARDCASE, IFCWALLELEMENTEDCASE],
  3304561284: [IFCWINDOWSTANDARDCASE],
  753842376: [IFCBEAMSTANDARDCASE],
  1062813311: [IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT]
};
InversePropertyDef[2] = {
  3630933823: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  618182010: [["OfPerson", IFCPERSON, 7, true], ["OfOrganization", IFCORGANIZATION, 4, true]],
  411424972: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  130549933: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["ApprovedObjects", IFCRELASSOCIATESAPPROVAL, 5, true], ["ApprovedResources", IFCRESOURCEAPPROVALRELATIONSHIP, 3, true], ["IsRelatedWith", IFCAPPROVALRELATIONSHIP, 3, true], ["Relates", IFCAPPROVALRELATIONSHIP, 2, true]],
  1959218052: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PropertiesForConstraint", IFCRESOURCECONSTRAINTRELATIONSHIP, 2, true]],
  1466758467: [["HasCoordinateOperation", IFCCOORDINATEOPERATION, 0, true]],
  602808272: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  3200245327: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true]],
  2242383968: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true]],
  1040185647: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true]],
  3548104201: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true]],
  852622518: [["PartOfW", IFCGRID, 9, true], ["PartOfV", IFCGRID, 8, true], ["PartOfU", IFCGRID, 7, true], ["HasIntersections", IFCVIRTUALGRIDINTERSECTION, 0, true]],
  2655187982: [["LibraryInfoForObjects", IFCRELASSOCIATESLIBRARY, 5, true], ["HasLibraryReferences", IFCLIBRARYREFERENCE, 5, true]],
  3452421091: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true], ["LibraryRefForObjects", IFCRELASSOCIATESLIBRARY, 5, true]],
  760658860: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true]],
  248100487: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true], ["ToMaterialLayerSet", IFCMATERIALLAYERSET, 0, false]],
  3303938423: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true]],
  1847252529: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true], ["ToMaterialLayerSet", IFCMATERIALLAYERSET, 0, false]],
  2235152071: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true], ["ToMaterialProfileSet", IFCMATERIALPROFILESET, 2, false]],
  164193824: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true]],
  552965576: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true], ["ToMaterialProfileSet", IFCMATERIALPROFILESET, 2, false]],
  1507914824: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true]],
  3368373690: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PropertiesForConstraint", IFCRESOURCECONSTRAINTRELATIONSHIP, 2, true]],
  3701648758: [["PlacesObject", IFCPRODUCT, 5, true], ["ReferencedByPlacements", IFCLOCALPLACEMENT, 0, true]],
  2251480897: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PropertiesForConstraint", IFCRESOURCECONSTRAINTRELATIONSHIP, 2, true]],
  4251960020: [["IsRelatedBy", IFCORGANIZATIONRELATIONSHIP, 3, true], ["Relates", IFCORGANIZATIONRELATIONSHIP, 2, true], ["Engages", IFCPERSONANDORGANIZATION, 1, true]],
  2077209135: [["EngagedIn", IFCPERSONANDORGANIZATION, 0, true]],
  2483315170: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  2226359599: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  3355820592: [["OfPerson", IFCPERSON, 7, true], ["OfOrganization", IFCORGANIZATION, 4, true]],
  3958567839: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  3843373140: [["HasCoordinateOperation", IFCCOORDINATEOPERATION, 0, true]],
  986844984: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  3710013099: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2044713172: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  2093928680: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  931644368: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  3252649465: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  2405470396: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  825690147: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  1076942058: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true]],
  3377609919: [["RepresentationsInContext", IFCREPRESENTATION, 0, true]],
  3008791417: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1660063152: [["HasShapeAspects", IFCSHAPEASPECT, 4, true], ["MapUsage", IFCMAPPEDITEM, 0, true]],
  3982875396: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true], ["OfShapeAspect", IFCSHAPEASPECT, 0, true]],
  4240577450: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true], ["OfShapeAspect", IFCSHAPEASPECT, 0, true]],
  2830218821: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true]],
  3958052878: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3049322572: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true]],
  626085974: [["IsMappedBy", IFCTEXTURECOORDINATE, 0, true], ["UsedInStyles", IFCSURFACESTYLEWITHTEXTURES, 0, true]],
  912023232: [["OfPerson", IFCPERSON, 7, true], ["OfOrganization", IFCORGANIZATION, 4, true]],
  3101149627: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  1377556343: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1735638870: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true], ["OfShapeAspect", IFCSHAPEASPECT, 0, true]],
  2799835756: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1907098498: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3798115385: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  1310608509: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  2705031697: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  616511568: [["IsMappedBy", IFCTEXTURECOORDINATE, 0, true], ["UsedInStyles", IFCSURFACESTYLEWITHTEXTURES, 0, true]],
  3150382593: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  747523909: [["ClassificationForObjects", IFCRELASSOCIATESCLASSIFICATION, 5, true], ["HasReferences", IFCCLASSIFICATIONREFERENCE, 3, true]],
  647927063: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true], ["ClassificationRefForObjects", IFCRELASSOCIATESCLASSIFICATION, 5, true], ["HasReferences", IFCCLASSIFICATIONREFERENCE, 3, true]],
  1485152156: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  370225590: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3050246964: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2889183280: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2713554722: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  3632507154: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  1154170062: [["DocumentInfoForObjects", IFCRELASSOCIATESDOCUMENT, 5, true], ["HasDocumentReferences", IFCDOCUMENTREFERENCE, 4, true], ["IsPointedTo", IFCDOCUMENTINFORMATIONRELATIONSHIP, 3, true], ["IsPointer", IFCDOCUMENTINFORMATIONRELATIONSHIP, 2, true]],
  3732053477: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true], ["DocumentRefForObjects", IFCRELASSOCIATESDOCUMENT, 5, true]],
  3900360178: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  476780140: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  297599258: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2556980723: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["HasTextureMaps", IFCTEXTUREMAP, 2, true]],
  1809719519: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  803316827: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3008276851: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["HasTextureMaps", IFCTEXTUREMAP, 2, true]],
  3448662350: [["RepresentationsInContext", IFCREPRESENTATION, 0, true], ["HasSubContexts", IFCGEOMETRICREPRESENTATIONSUBCONTEXT, 6, true], ["HasCoordinateOperation", IFCCOORDINATEOPERATION, 0, true]],
  2453401579: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4142052618: [["RepresentationsInContext", IFCREPRESENTATION, 0, true], ["HasSubContexts", IFCGEOMETRICREPRESENTATIONSUBCONTEXT, 6, true], ["HasCoordinateOperation", IFCCOORDINATEOPERATION, 0, true]],
  3590301190: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  178086475: [["PlacesObject", IFCPRODUCT, 5, true], ["ReferencedByPlacements", IFCLOCALPLACEMENT, 0, true]],
  812098782: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3905492369: [["IsMappedBy", IFCTEXTURECOORDINATE, 0, true], ["UsedInStyles", IFCSURFACESTYLEWITHTEXTURES, 0, true]],
  3741457305: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  1402838566: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  125510826: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2604431987: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4266656042: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1520743889: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3422422726: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2624227202: [["PlacesObject", IFCPRODUCT, 5, true], ["ReferencedByPlacements", IFCLOCALPLACEMENT, 0, true]],
  1008929658: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2347385850: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1838606355: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true], ["HasRepresentation", IFCMATERIALDEFINITIONREPRESENTATION, 3, true], ["IsRelatedWith", IFCMATERIALRELATIONSHIP, 3, true], ["RelatesTo", IFCMATERIALRELATIONSHIP, 2, true]],
  3708119e3: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true], ["ToMaterialConstituentSet", IFCMATERIALCONSTITUENTSET, 2, false]],
  2852063980: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true]],
  1303795690: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true]],
  3079605661: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true]],
  3404854881: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true]],
  3265635763: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2998442950: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  219451334: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true]],
  2665983363: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1029017970: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2529465313: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  2519244187: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3021840470: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  597895409: [["IsMappedBy", IFCTEXTURECOORDINATE, 0, true], ["UsedInStyles", IFCSURFACESTYLEWITHTEXTURES, 0, true]],
  2004835150: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1663979128: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2067069095: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4022376103: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1423911732: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2924175390: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2775532180: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3778827333: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  673634403: [["ShapeOfProduct", IFCPRODUCT, 6, true], ["HasShapeAspects", IFCSHAPEASPECT, 4, true]],
  2802850158: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2598011224: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  1680319473: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true]],
  3357820518: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  1482703590: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true]],
  2090586900: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  3615266464: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  3413951693: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  1580146022: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2778083089: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  2042790032: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  4165799628: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  1509187699: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4124623270: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3692461612: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  723233188: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2233826070: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2513912981: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2247615214: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1260650574: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1096409881: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  230924584: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3071757647: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  901063453: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4282788508: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3124975700: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2715220739: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  1628702193: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true]],
  3736923433: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  2347495698: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3698973494: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  427810014: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  1417489154: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2759199220: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1299126871: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2543172580: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  3406155212: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["HasTextureMaps", IFCTEXTUREMAP, 2, true]],
  669184980: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3207858831: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  4261334040: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3125803723: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2740243338: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2736907675: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4182860854: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2581212453: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2713105998: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2898889636: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  1123145078: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  574549367: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1675464909: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2059837836: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  59481748: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3749851601: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3486308946: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3331915920: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1416205885: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1383045692: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  2205249479: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2542286263: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  2485617015: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["UsingCurves", IFCCOMPOSITECURVE, 0, true]],
  2574617495: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  3419103109: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Declares", IFCRELDECLARES, 4, true]],
  1815067380: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  2506170314: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2147822146: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2601014836: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2827736869: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2629017746: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  32440307: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  526551008: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1472233963: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1883228015: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  339256511: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2777663545: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2835456948: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  4024345920: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  477187591: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2804161546: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2047409740: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  374418227: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  315944413: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2652556860: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4238390223: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1268542332: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4095422895: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  987898635: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1484403080: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  178912537: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["ToFaceSet", IFCPOLYGONALFACESET, 2, true]],
  2294589976: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["ToFaceSet", IFCPOLYGONALFACESET, 2, true]],
  572779678: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  428585644: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1281925730: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1425443689: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3888040117: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true]],
  3388369263: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3505215534: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1682466193: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  603570806: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  220341763: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3967405729: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  569719735: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  2945172077: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsPredecessorTo", IFCRELSEQUENCE, 4, true], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  4208778838: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  103090709: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Declares", IFCRELDECLARES, 4, true]],
  653396225: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Declares", IFCRELDECLARES, 4, true]],
  871118103: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  4166981789: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  2752243245: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  941946838: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  1451395588: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  492091185: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Defines", IFCRELDEFINESBYTEMPLATE, 5, true]],
  3650150729: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  110355661: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  3521284610: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["PartOfComplexTemplate", IFCCOMPLEXPROPERTYTEMPLATE, 6, true], ["PartOfPsetTemplate", IFCPROPERTYSETTEMPLATE, 6, true]],
  3219374653: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2770003689: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  2798486643: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3454111270: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3765753017: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  3523091289: [["InnerBoundaries", IFCRELSPACEBOUNDARY1STLEVEL, 9, true]],
  1521410863: [["InnerBoundaries", IFCRELSPACEBOUNDARY1STLEVEL, 9, true], ["Corresponds", IFCRELSPACEBOUNDARY2NDLEVEL, 10, true]],
  816062949: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["UsingCurves", IFCCOMPOSITECURVE, 0, true]],
  2914609552: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1856042241: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3243963512: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4158566097: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3626867408: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3663146110: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["PartOfComplexTemplate", IFCCOMPLEXPROPERTYTEMPLATE, 6, true], ["PartOfPsetTemplate", IFCPROPERTYSETTEMPLATE, 6, true]],
  1412071761: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true]],
  710998568: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2706606064: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true]],
  3893378262: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  463610769: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true]],
  2481509218: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  451544542: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4015995234: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3544373492: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  3136571912: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true]],
  530289379: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  3689010777: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  3979015343: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  2218152070: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  603775116: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  4095615324: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  699246055: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2028607225: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2809605785: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4124788165: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1580310250: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3473067441: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsPredecessorTo", IFCRELSEQUENCE, 4, true], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  3206491090: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  2387106220: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["HasColours", IFCINDEXEDCOLOURMAP, 0, true], ["HasTextures", IFCINDEXEDTEXTUREMAP, 1, true]],
  1935646853: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2097647324: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2916149573: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["HasColours", IFCINDEXEDCOLOURMAP, 0, true], ["HasTextures", IFCINDEXEDTEXTUREMAP, 1, true]],
  336235671: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  512836454: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  2296667514: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsActingUpon", IFCRELASSIGNSTOACTOR, 6, true]],
  1635779807: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2603310189: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1674181508: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2887950389: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  167062518: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1334484129: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3649129432: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1260505505: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4031249490: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true]],
  1950629157: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3124254112: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true]],
  2197970202: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2937912522: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  3893394355: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  300633059: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3875453745: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["PartOfComplexTemplate", IFCCOMPLEXPROPERTYTEMPLATE, 6, true], ["PartOfPsetTemplate", IFCPROPERTYSETTEMPLATE, 6, true]],
  3732776249: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  15328376: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2510884976: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2185764099: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  4105962743: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1525564444: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  2559216714: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  3293443760: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3895139033: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1419761937: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1916426348: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3295246426: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1457835157: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1213902940: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3256556792: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3849074793: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2963535650: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  1714330368: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  2323601079: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1758889154: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  4123344466: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2397081782: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1623761950: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2590856083: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1704287377: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2107101300: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  132023988: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3174744832: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3390157468: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4148101412: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsPredecessorTo", IFCRELSEQUENCE, 4, true], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  2853485674: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true]],
  807026263: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3737207727: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  647756555: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2489546625: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2827207264: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2143335405: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["ProjectsElements", IFCRELPROJECTSELEMENT, 5, false]],
  1287392070: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["VoidsElements", IFCRELVOIDSELEMENT, 5, false]],
  3907093117: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3198132628: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3815607619: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1482959167: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1834744321: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1339347760: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2297155007: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3009222698: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1893162501: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  263784265: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  1509553395: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3493046030: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3009204131: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2706460486: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true]],
  1251058090: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1806887404: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2571569899: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3946677679: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3113134337: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2391368822: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true]],
  4288270099: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3827777499: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1051575348: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1161773419: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  377706215: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2108223431: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1114901282: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3181161470: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  977012517: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4143007308: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsActingUpon", IFCRELASSIGNSTOACTOR, 6, true]],
  3588315303: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["VoidsElements", IFCRELVOIDSELEMENT, 5, false], ["HasFillings", IFCRELFILLSELEMENT, 4, true]],
  3079942009: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["VoidsElements", IFCRELVOIDSELEMENT, 5, false], ["HasFillings", IFCRELFILLSELEMENT, 4, true]],
  2837617999: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2382730787: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3566463478: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  3327091369: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1158309216: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  804291784: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4231323485: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4017108033: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2839578677: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["HasColours", IFCINDEXEDCOLOURMAP, 0, true], ["HasTextures", IFCINDEXEDTEXTUREMAP, 1, true]],
  3724593414: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3740093272: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainedIn", IFCRELCONNECTSPORTTOELEMENT, 4, true], ["ConnectedFrom", IFCRELCONNECTSPORTS, 5, true], ["ConnectedTo", IFCRELCONNECTSPORTS, 4, true]],
  2744685151: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsPredecessorTo", IFCRELSEQUENCE, 4, true], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  2904328755: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3651124850: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["ProjectsElements", IFCRELPROJECTSELEMENT, 5, false]],
  1842657554: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2250791053: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2893384427: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2324767716: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1469900589: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  683857671: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3027567501: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  964333572: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2320036040: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2310774935: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2781568857: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1768891740: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2157484638: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4074543187: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4097777520: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true]],
  2533589738: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1072016465: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3856911033: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["HasCoverings", IFCRELCOVERSSPACES, 4, true], ["BoundedBy", IFCRELSPACEBOUNDARY, 4, true]],
  1305183839: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3812236995: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3112655638: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1039846685: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  338393293: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  682877961: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  1179482911: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, true]],
  1004757350: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  4243806635: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, true]],
  214636428: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  2445595289: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  2757150158: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  1807405624: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  1252848954: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["SourceOfResultGroup", IFCSTRUCTURALRESULTGROUP, 6, true], ["LoadGroupFor", IFCSTRUCTURALANALYSISMODEL, 7, true]],
  2082059205: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  734778138: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, true]],
  1235345126: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  2986769608: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ResultGroupFor", IFCSTRUCTURALANALYSISMODEL, 8, true]],
  3657597509: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  1975003073: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, true]],
  148013059: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  3101698114: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2315554128: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2254336722: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true]],
  413509423: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  5716631: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3824725483: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2347447852: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3081323446: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2415094496: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1692211062: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1620046519: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3593883385: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1600972822: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1911125066: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  728799441: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2391383451: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3313531582: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2769231204: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  926996030: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["VoidsElements", IFCRELVOIDSELEMENT, 5, false]],
  1898987631: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1133259667: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4009809668: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4088093105: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1028945134: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  4218914973: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3342526732: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1033361043: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true]],
  3821786052: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1411407467: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3352864051: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1871374353: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3460190687: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true]],
  1532957894: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1967976161: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2461110595: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  819618141: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  231477066: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1136057603: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3299480353: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2979338954: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  39481116: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1095909175: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  1909888760: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1177604601: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true]],
  2188180465: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  395041908: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3293546465: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2674252688: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1285652485: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2951183804: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3296154744: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2611217952: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1677625105: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2301859152: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  843113511: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  905975707: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  400855858: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3850581409: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2816379211: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3898045240: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1060000209: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  488727124: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  335055490: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2954562838: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1973544240: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["CoversSpaces", IFCRELCOVERSSPACES, 5, true], ["CoversElements", IFCRELCOVERSBLDGELEMENTS, 5, true]],
  3495092785: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3961806047: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1335981549: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2635815018: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1599208980: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2063403501: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1945004755: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true]],
  3040386961: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3041715199: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainedIn", IFCRELCONNECTSPORTTOELEMENT, 4, true], ["ConnectedFrom", IFCRELCONNECTSPORTS, 5, true], ["ConnectedTo", IFCRELCONNECTSPORTS, 4, true]],
  3205830791: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true]],
  395920057: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3242481149: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  869906466: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3760055223: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2030761528: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  663422040: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2417008758: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3277789161: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1534661035: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1217240411: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  712377611: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1658829314: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2814081492: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3747195512: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  484807127: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1209101575: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["BoundedBy", IFCRELSPACEBOUNDARY, 4, true]],
  346874300: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1810631287: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4222183408: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2058353004: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4278956645: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4037862832: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2188021234: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3132237377: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  987401354: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  707683696: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2223149337: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3508470533: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  900683007: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3319311131: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2068733104: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4175244083: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2176052936: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  76236018: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  629592764: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1437502449: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1073191201: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  1911478936: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2474470126: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  144952367: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3694346114: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1687234759: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  310824031: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3612865200: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3171933400: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  1156407060: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  738039164: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  655969474: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  90941305: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2262370178: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3024970846: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3283111854: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  1232101972: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  979691226: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2572171363: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2016517767: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3053780830: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1783015770: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1329646415: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  1529196076: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3127900445: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3027962421: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3420628829: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1999602285: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1404847402: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  331165859: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  4252922144: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2515109513: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true]],
  385403989: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["SourceOfResultGroup", IFCSTRUCTURALRESULTGROUP, 6, true], ["LoadGroupFor", IFCSTRUCTURALANALYSISMODEL, 7, true]],
  1621171031: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  1162798199: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  812556717: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3825984169: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3026737570: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3179687236: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4292641817: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4207607924: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2391406946: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  4156078855: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3512223829: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  4237592921: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3304561284: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  486154966: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2874132201: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1634111441: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  177149247: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2056796094: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3001207471: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  277319702: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  753842376: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2906023776: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  32344328: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2938176219: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  635142910: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3758799889: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1051757585: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4217484030: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3902619387: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  639361253: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3221913625: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3571504051: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2272882330: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  578613899: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4136498852: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3640358203: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4074379575: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1052013943: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  562808652: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true]],
  1062813311: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  342316401: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3518393246: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1360408905: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1904799276: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  862014818: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3310460725: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  264262732: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  402227799: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1003880860: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3415622556: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  819412036: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1426591983: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  182646315: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  2295281155: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  4086658281: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  630975310: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  4288193352: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  3087945054: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  25142252: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]]
};
Constructors[2] = {
  3630933823: (a) => new IFC4.IfcActorRole(a[0], a[1], a[2]),
  618182010: (a) => new IFC4.IfcAddress(a[0], a[1], a[2]),
  639542469: (a) => new IFC4.IfcApplication(a[0], a[1], a[2], a[3]),
  411424972: (a) => new IFC4.IfcAppliedValue(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  130549933: (a) => new IFC4.IfcApproval(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4037036970: (a) => new IFC4.IfcBoundaryCondition(a[0]),
  1560379544: (a) => new IFC4.IfcBoundaryEdgeCondition(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3367102660: (a) => new IFC4.IfcBoundaryFaceCondition(a[0], a[1], a[2], a[3]),
  1387855156: (a) => new IFC4.IfcBoundaryNodeCondition(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  2069777674: (a) => new IFC4.IfcBoundaryNodeConditionWarping(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2859738748: (_) => new IFC4.IfcConnectionGeometry(),
  2614616156: (a) => new IFC4.IfcConnectionPointGeometry(a[0], a[1]),
  2732653382: (a) => new IFC4.IfcConnectionSurfaceGeometry(a[0], a[1]),
  775493141: (a) => new IFC4.IfcConnectionVolumeGeometry(a[0], a[1]),
  1959218052: (a) => new IFC4.IfcConstraint(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1785450214: (a) => new IFC4.IfcCoordinateOperation(a[0], a[1]),
  1466758467: (a) => new IFC4.IfcCoordinateReferenceSystem(a[0], a[1], a[2], a[3]),
  602808272: (a) => new IFC4.IfcCostValue(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1765591967: (a) => new IFC4.IfcDerivedUnit(a[0], a[1], a[2]),
  1045800335: (a) => new IFC4.IfcDerivedUnitElement(a[0], a[1]),
  2949456006: (a) => new IFC4.IfcDimensionalExponents(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  4294318154: (_) => new IFC4.IfcExternalInformation(),
  3200245327: (a) => new IFC4.IfcExternalReference(a[0], a[1], a[2]),
  2242383968: (a) => new IFC4.IfcExternallyDefinedHatchStyle(a[0], a[1], a[2]),
  1040185647: (a) => new IFC4.IfcExternallyDefinedSurfaceStyle(a[0], a[1], a[2]),
  3548104201: (a) => new IFC4.IfcExternallyDefinedTextFont(a[0], a[1], a[2]),
  852622518: (a) => new IFC4.IfcGridAxis(a[0], a[1], a[2]),
  3020489413: (a) => new IFC4.IfcIrregularTimeSeriesValue(a[0], a[1]),
  2655187982: (a) => new IFC4.IfcLibraryInformation(a[0], a[1], a[2], a[3], a[4], a[5]),
  3452421091: (a) => new IFC4.IfcLibraryReference(a[0], a[1], a[2], a[3], a[4], a[5]),
  4162380809: (a) => new IFC4.IfcLightDistributionData(a[0], a[1], a[2]),
  1566485204: (a) => new IFC4.IfcLightIntensityDistribution(a[0], a[1]),
  3057273783: (a) => new IFC4.IfcMapConversion(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1847130766: (a) => new IFC4.IfcMaterialClassificationRelationship(a[0], a[1]),
  760658860: (_) => new IFC4.IfcMaterialDefinition(),
  248100487: (a) => new IFC4.IfcMaterialLayer(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3303938423: (a) => new IFC4.IfcMaterialLayerSet(a[0], a[1], a[2]),
  1847252529: (a) => new IFC4.IfcMaterialLayerWithOffsets(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2199411900: (a) => new IFC4.IfcMaterialList(a[0]),
  2235152071: (a) => new IFC4.IfcMaterialProfile(a[0], a[1], a[2], a[3], a[4], a[5]),
  164193824: (a) => new IFC4.IfcMaterialProfileSet(a[0], a[1], a[2], a[3]),
  552965576: (a) => new IFC4.IfcMaterialProfileWithOffsets(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1507914824: (_) => new IFC4.IfcMaterialUsageDefinition(),
  2597039031: (a) => new IFC4.IfcMeasureWithUnit(a[0], a[1]),
  3368373690: (a) => new IFC4.IfcMetric(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  2706619895: (a) => new IFC4.IfcMonetaryUnit(a[0]),
  1918398963: (a) => new IFC4.IfcNamedUnit(a[0], a[1]),
  3701648758: (_) => new IFC4.IfcObjectPlacement(),
  2251480897: (a) => new IFC4.IfcObjective(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  4251960020: (a) => new IFC4.IfcOrganization(a[0], a[1], a[2], a[3], a[4]),
  1207048766: (a) => new IFC4.IfcOwnerHistory(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2077209135: (a) => new IFC4.IfcPerson(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  101040310: (a) => new IFC4.IfcPersonAndOrganization(a[0], a[1], a[2]),
  2483315170: (a) => new IFC4.IfcPhysicalQuantity(a[0], a[1]),
  2226359599: (a) => new IFC4.IfcPhysicalSimpleQuantity(a[0], a[1], a[2]),
  3355820592: (a) => new IFC4.IfcPostalAddress(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  677532197: (_) => new IFC4.IfcPresentationItem(),
  2022622350: (a) => new IFC4.IfcPresentationLayerAssignment(a[0], a[1], a[2], a[3]),
  1304840413: (a) => new IFC4.IfcPresentationLayerWithStyle(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3119450353: (a) => new IFC4.IfcPresentationStyle(a[0]),
  2417041796: (a) => new IFC4.IfcPresentationStyleAssignment(a[0]),
  2095639259: (a) => new IFC4.IfcProductRepresentation(a[0], a[1], a[2]),
  3958567839: (a) => new IFC4.IfcProfileDef(a[0], a[1]),
  3843373140: (a) => new IFC4.IfcProjectedCRS(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  986844984: (_) => new IFC4.IfcPropertyAbstraction(),
  3710013099: (a) => new IFC4.IfcPropertyEnumeration(a[0], a[1], a[2]),
  2044713172: (a) => new IFC4.IfcQuantityArea(a[0], a[1], a[2], a[3], a[4]),
  2093928680: (a) => new IFC4.IfcQuantityCount(a[0], a[1], a[2], a[3], a[4]),
  931644368: (a) => new IFC4.IfcQuantityLength(a[0], a[1], a[2], a[3], a[4]),
  3252649465: (a) => new IFC4.IfcQuantityTime(a[0], a[1], a[2], a[3], a[4]),
  2405470396: (a) => new IFC4.IfcQuantityVolume(a[0], a[1], a[2], a[3], a[4]),
  825690147: (a) => new IFC4.IfcQuantityWeight(a[0], a[1], a[2], a[3], a[4]),
  3915482550: (a) => new IFC4.IfcRecurrencePattern(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2433181523: (a) => new IFC4.IfcReference(a[0], a[1], a[2], a[3], a[4]),
  1076942058: (a) => new IFC4.IfcRepresentation(a[0], a[1], a[2], a[3]),
  3377609919: (a) => new IFC4.IfcRepresentationContext(a[0], a[1]),
  3008791417: (_) => new IFC4.IfcRepresentationItem(),
  1660063152: (a) => new IFC4.IfcRepresentationMap(a[0], a[1]),
  2439245199: (a) => new IFC4.IfcResourceLevelRelationship(a[0], a[1]),
  2341007311: (a) => new IFC4.IfcRoot(a[0], a[1], a[2], a[3]),
  448429030: (a) => new IFC4.IfcSIUnit(a[0], a[1], a[2]),
  1054537805: (a) => new IFC4.IfcSchedulingTime(a[0], a[1], a[2]),
  867548509: (a) => new IFC4.IfcShapeAspect(a[0], a[1], a[2], a[3], a[4]),
  3982875396: (a) => new IFC4.IfcShapeModel(a[0], a[1], a[2], a[3]),
  4240577450: (a) => new IFC4.IfcShapeRepresentation(a[0], a[1], a[2], a[3]),
  2273995522: (a) => new IFC4.IfcStructuralConnectionCondition(a[0]),
  2162789131: (a) => new IFC4.IfcStructuralLoad(a[0]),
  3478079324: (a) => new IFC4.IfcStructuralLoadConfiguration(a[0], a[1], a[2]),
  609421318: (a) => new IFC4.IfcStructuralLoadOrResult(a[0]),
  2525727697: (a) => new IFC4.IfcStructuralLoadStatic(a[0]),
  3408363356: (a) => new IFC4.IfcStructuralLoadTemperature(a[0], a[1], a[2], a[3]),
  2830218821: (a) => new IFC4.IfcStyleModel(a[0], a[1], a[2], a[3]),
  3958052878: (a) => new IFC4.IfcStyledItem(a[0], a[1], a[2]),
  3049322572: (a) => new IFC4.IfcStyledRepresentation(a[0], a[1], a[2], a[3]),
  2934153892: (a) => new IFC4.IfcSurfaceReinforcementArea(a[0], a[1], a[2], a[3]),
  1300840506: (a) => new IFC4.IfcSurfaceStyle(a[0], a[1], a[2]),
  3303107099: (a) => new IFC4.IfcSurfaceStyleLighting(a[0], a[1], a[2], a[3]),
  1607154358: (a) => new IFC4.IfcSurfaceStyleRefraction(a[0], a[1]),
  846575682: (a) => new IFC4.IfcSurfaceStyleShading(a[0], a[1]),
  1351298697: (a) => new IFC4.IfcSurfaceStyleWithTextures(a[0]),
  626085974: (a) => new IFC4.IfcSurfaceTexture(a[0], a[1], a[2], a[3], a[4]),
  985171141: (a) => new IFC4.IfcTable(a[0], a[1], a[2]),
  2043862942: (a) => new IFC4.IfcTableColumn(a[0], a[1], a[2], a[3], a[4]),
  531007025: (a) => new IFC4.IfcTableRow(a[0], a[1]),
  1549132990: (a) => new IFC4.IfcTaskTime(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18], a[19]),
  2771591690: (a) => new IFC4.IfcTaskTimeRecurring(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18], a[19], a[20]),
  912023232: (a) => new IFC4.IfcTelecomAddress(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1447204868: (a) => new IFC4.IfcTextStyle(a[0], a[1], a[2], a[3], a[4]),
  2636378356: (a) => new IFC4.IfcTextStyleForDefinedFont(a[0], a[1]),
  1640371178: (a) => new IFC4.IfcTextStyleTextModel(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  280115917: (a) => new IFC4.IfcTextureCoordinate(a[0]),
  1742049831: (a) => new IFC4.IfcTextureCoordinateGenerator(a[0], a[1], a[2]),
  2552916305: (a) => new IFC4.IfcTextureMap(a[0], a[1], a[2]),
  1210645708: (a) => new IFC4.IfcTextureVertex(a[0]),
  3611470254: (a) => new IFC4.IfcTextureVertexList(a[0]),
  1199560280: (a) => new IFC4.IfcTimePeriod(a[0], a[1]),
  3101149627: (a) => new IFC4.IfcTimeSeries(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  581633288: (a) => new IFC4.IfcTimeSeriesValue(a[0]),
  1377556343: (_) => new IFC4.IfcTopologicalRepresentationItem(),
  1735638870: (a) => new IFC4.IfcTopologyRepresentation(a[0], a[1], a[2], a[3]),
  180925521: (a) => new IFC4.IfcUnitAssignment(a[0]),
  2799835756: (_) => new IFC4.IfcVertex(),
  1907098498: (a) => new IFC4.IfcVertexPoint(a[0]),
  891718957: (a) => new IFC4.IfcVirtualGridIntersection(a[0], a[1]),
  1236880293: (a) => new IFC4.IfcWorkTime(a[0], a[1], a[2], a[3], a[4], a[5]),
  3869604511: (a) => new IFC4.IfcApprovalRelationship(a[0], a[1], a[2], a[3]),
  3798115385: (a) => new IFC4.IfcArbitraryClosedProfileDef(a[0], a[1], a[2]),
  1310608509: (a) => new IFC4.IfcArbitraryOpenProfileDef(a[0], a[1], a[2]),
  2705031697: (a) => new IFC4.IfcArbitraryProfileDefWithVoids(a[0], a[1], a[2], a[3]),
  616511568: (a) => new IFC4.IfcBlobTexture(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3150382593: (a) => new IFC4.IfcCenterLineProfileDef(a[0], a[1], a[2], a[3]),
  747523909: (a) => new IFC4.IfcClassification(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  647927063: (a) => new IFC4.IfcClassificationReference(a[0], a[1], a[2], a[3], a[4], a[5]),
  3285139300: (a) => new IFC4.IfcColourRgbList(a[0]),
  3264961684: (a) => new IFC4.IfcColourSpecification(a[0]),
  1485152156: (a) => new IFC4.IfcCompositeProfileDef(a[0], a[1], a[2], a[3]),
  370225590: (a) => new IFC4.IfcConnectedFaceSet(a[0]),
  1981873012: (a) => new IFC4.IfcConnectionCurveGeometry(a[0], a[1]),
  45288368: (a) => new IFC4.IfcConnectionPointEccentricity(a[0], a[1], a[2], a[3], a[4]),
  3050246964: (a) => new IFC4.IfcContextDependentUnit(a[0], a[1], a[2]),
  2889183280: (a) => new IFC4.IfcConversionBasedUnit(a[0], a[1], a[2], a[3]),
  2713554722: (a) => new IFC4.IfcConversionBasedUnitWithOffset(a[0], a[1], a[2], a[3], a[4]),
  539742890: (a) => new IFC4.IfcCurrencyRelationship(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3800577675: (a) => new IFC4.IfcCurveStyle(a[0], a[1], a[2], a[3], a[4]),
  1105321065: (a) => new IFC4.IfcCurveStyleFont(a[0], a[1]),
  2367409068: (a) => new IFC4.IfcCurveStyleFontAndScaling(a[0], a[1], a[2]),
  3510044353: (a) => new IFC4.IfcCurveStyleFontPattern(a[0], a[1]),
  3632507154: (a) => new IFC4.IfcDerivedProfileDef(a[0], a[1], a[2], a[3], a[4]),
  1154170062: (a) => new IFC4.IfcDocumentInformation(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16]),
  770865208: (a) => new IFC4.IfcDocumentInformationRelationship(a[0], a[1], a[2], a[3], a[4]),
  3732053477: (a) => new IFC4.IfcDocumentReference(a[0], a[1], a[2], a[3], a[4]),
  3900360178: (a) => new IFC4.IfcEdge(a[0], a[1]),
  476780140: (a) => new IFC4.IfcEdgeCurve(a[0], a[1], a[2], a[3]),
  211053100: (a) => new IFC4.IfcEventTime(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  297599258: (a) => new IFC4.IfcExtendedProperties(a[0], a[1], a[2]),
  1437805879: (a) => new IFC4.IfcExternalReferenceRelationship(a[0], a[1], a[2], a[3]),
  2556980723: (a) => new IFC4.IfcFace(a[0]),
  1809719519: (a) => new IFC4.IfcFaceBound(a[0], a[1]),
  803316827: (a) => new IFC4.IfcFaceOuterBound(a[0], a[1]),
  3008276851: (a) => new IFC4.IfcFaceSurface(a[0], a[1], a[2]),
  4219587988: (a) => new IFC4.IfcFailureConnectionCondition(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  738692330: (a) => new IFC4.IfcFillAreaStyle(a[0], a[1], a[2]),
  3448662350: (a) => new IFC4.IfcGeometricRepresentationContext(a[0], a[1], a[2], a[3], a[4], a[5]),
  2453401579: (_) => new IFC4.IfcGeometricRepresentationItem(),
  4142052618: (a) => new IFC4.IfcGeometricRepresentationSubContext(a[0], a[1], a[2], a[3], a[4], a[5]),
  3590301190: (a) => new IFC4.IfcGeometricSet(a[0]),
  178086475: (a) => new IFC4.IfcGridPlacement(a[0], a[1]),
  812098782: (a) => new IFC4.IfcHalfSpaceSolid(a[0], a[1]),
  3905492369: (a) => new IFC4.IfcImageTexture(a[0], a[1], a[2], a[3], a[4], a[5]),
  3570813810: (a) => new IFC4.IfcIndexedColourMap(a[0], a[1], a[2], a[3]),
  1437953363: (a) => new IFC4.IfcIndexedTextureMap(a[0], a[1], a[2]),
  2133299955: (a) => new IFC4.IfcIndexedTriangleTextureMap(a[0], a[1], a[2], a[3]),
  3741457305: (a) => new IFC4.IfcIrregularTimeSeries(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1585845231: (a) => new IFC4.IfcLagTime(a[0], a[1], a[2], a[3], a[4]),
  1402838566: (a) => new IFC4.IfcLightSource(a[0], a[1], a[2], a[3]),
  125510826: (a) => new IFC4.IfcLightSourceAmbient(a[0], a[1], a[2], a[3]),
  2604431987: (a) => new IFC4.IfcLightSourceDirectional(a[0], a[1], a[2], a[3], a[4]),
  4266656042: (a) => new IFC4.IfcLightSourceGoniometric(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1520743889: (a) => new IFC4.IfcLightSourcePositional(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3422422726: (a) => new IFC4.IfcLightSourceSpot(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  2624227202: (a) => new IFC4.IfcLocalPlacement(a[0], a[1]),
  1008929658: (_) => new IFC4.IfcLoop(),
  2347385850: (a) => new IFC4.IfcMappedItem(a[0], a[1]),
  1838606355: (a) => new IFC4.IfcMaterial(a[0], a[1], a[2]),
  3708119e3: (a) => new IFC4.IfcMaterialConstituent(a[0], a[1], a[2], a[3], a[4]),
  2852063980: (a) => new IFC4.IfcMaterialConstituentSet(a[0], a[1], a[2]),
  2022407955: (a) => new IFC4.IfcMaterialDefinitionRepresentation(a[0], a[1], a[2], a[3]),
  1303795690: (a) => new IFC4.IfcMaterialLayerSetUsage(a[0], a[1], a[2], a[3], a[4]),
  3079605661: (a) => new IFC4.IfcMaterialProfileSetUsage(a[0], a[1], a[2]),
  3404854881: (a) => new IFC4.IfcMaterialProfileSetUsageTapering(a[0], a[1], a[2], a[3], a[4]),
  3265635763: (a) => new IFC4.IfcMaterialProperties(a[0], a[1], a[2], a[3]),
  853536259: (a) => new IFC4.IfcMaterialRelationship(a[0], a[1], a[2], a[3], a[4]),
  2998442950: (a) => new IFC4.IfcMirroredProfileDef(a[0], a[1], a[2], a[3]),
  219451334: (a) => new IFC4.IfcObjectDefinition(a[0], a[1], a[2], a[3]),
  2665983363: (a) => new IFC4.IfcOpenShell(a[0]),
  1411181986: (a) => new IFC4.IfcOrganizationRelationship(a[0], a[1], a[2], a[3]),
  1029017970: (a) => new IFC4.IfcOrientedEdge(a[0], a[1]),
  2529465313: (a) => new IFC4.IfcParameterizedProfileDef(a[0], a[1], a[2]),
  2519244187: (a) => new IFC4.IfcPath(a[0]),
  3021840470: (a) => new IFC4.IfcPhysicalComplexQuantity(a[0], a[1], a[2], a[3], a[4], a[5]),
  597895409: (a) => new IFC4.IfcPixelTexture(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2004835150: (a) => new IFC4.IfcPlacement(a[0]),
  1663979128: (a) => new IFC4.IfcPlanarExtent(a[0], a[1]),
  2067069095: (_) => new IFC4.IfcPoint(),
  4022376103: (a) => new IFC4.IfcPointOnCurve(a[0], a[1]),
  1423911732: (a) => new IFC4.IfcPointOnSurface(a[0], a[1], a[2]),
  2924175390: (a) => new IFC4.IfcPolyLoop(a[0]),
  2775532180: (a) => new IFC4.IfcPolygonalBoundedHalfSpace(a[0], a[1], a[2], a[3]),
  3727388367: (a) => new IFC4.IfcPreDefinedItem(a[0]),
  3778827333: (_) => new IFC4.IfcPreDefinedProperties(),
  1775413392: (a) => new IFC4.IfcPreDefinedTextFont(a[0]),
  673634403: (a) => new IFC4.IfcProductDefinitionShape(a[0], a[1], a[2]),
  2802850158: (a) => new IFC4.IfcProfileProperties(a[0], a[1], a[2], a[3]),
  2598011224: (a) => new IFC4.IfcProperty(a[0], a[1]),
  1680319473: (a) => new IFC4.IfcPropertyDefinition(a[0], a[1], a[2], a[3]),
  148025276: (a) => new IFC4.IfcPropertyDependencyRelationship(a[0], a[1], a[2], a[3], a[4]),
  3357820518: (a) => new IFC4.IfcPropertySetDefinition(a[0], a[1], a[2], a[3]),
  1482703590: (a) => new IFC4.IfcPropertyTemplateDefinition(a[0], a[1], a[2], a[3]),
  2090586900: (a) => new IFC4.IfcQuantitySet(a[0], a[1], a[2], a[3]),
  3615266464: (a) => new IFC4.IfcRectangleProfileDef(a[0], a[1], a[2], a[3], a[4]),
  3413951693: (a) => new IFC4.IfcRegularTimeSeries(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1580146022: (a) => new IFC4.IfcReinforcementBarProperties(a[0], a[1], a[2], a[3], a[4], a[5]),
  478536968: (a) => new IFC4.IfcRelationship(a[0], a[1], a[2], a[3]),
  2943643501: (a) => new IFC4.IfcResourceApprovalRelationship(a[0], a[1], a[2], a[3]),
  1608871552: (a) => new IFC4.IfcResourceConstraintRelationship(a[0], a[1], a[2], a[3]),
  1042787934: (a) => new IFC4.IfcResourceTime(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17]),
  2778083089: (a) => new IFC4.IfcRoundedRectangleProfileDef(a[0], a[1], a[2], a[3], a[4], a[5]),
  2042790032: (a) => new IFC4.IfcSectionProperties(a[0], a[1], a[2]),
  4165799628: (a) => new IFC4.IfcSectionReinforcementProperties(a[0], a[1], a[2], a[3], a[4], a[5]),
  1509187699: (a) => new IFC4.IfcSectionedSpine(a[0], a[1], a[2]),
  4124623270: (a) => new IFC4.IfcShellBasedSurfaceModel(a[0]),
  3692461612: (a) => new IFC4.IfcSimpleProperty(a[0], a[1]),
  2609359061: (a) => new IFC4.IfcSlippageConnectionCondition(a[0], a[1], a[2], a[3]),
  723233188: (_) => new IFC4.IfcSolidModel(),
  1595516126: (a) => new IFC4.IfcStructuralLoadLinearForce(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  2668620305: (a) => new IFC4.IfcStructuralLoadPlanarForce(a[0], a[1], a[2], a[3]),
  2473145415: (a) => new IFC4.IfcStructuralLoadSingleDisplacement(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1973038258: (a) => new IFC4.IfcStructuralLoadSingleDisplacementDistortion(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1597423693: (a) => new IFC4.IfcStructuralLoadSingleForce(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1190533807: (a) => new IFC4.IfcStructuralLoadSingleForceWarping(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2233826070: (a) => new IFC4.IfcSubedge(a[0], a[1], a[2]),
  2513912981: (_) => new IFC4.IfcSurface(),
  1878645084: (a) => new IFC4.IfcSurfaceStyleRendering(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2247615214: (a) => new IFC4.IfcSweptAreaSolid(a[0], a[1]),
  1260650574: (a) => new IFC4.IfcSweptDiskSolid(a[0], a[1], a[2], a[3], a[4]),
  1096409881: (a) => new IFC4.IfcSweptDiskSolidPolygonal(a[0], a[1], a[2], a[3], a[4], a[5]),
  230924584: (a) => new IFC4.IfcSweptSurface(a[0], a[1]),
  3071757647: (a) => new IFC4.IfcTShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  901063453: (_) => new IFC4.IfcTessellatedItem(),
  4282788508: (a) => new IFC4.IfcTextLiteral(a[0], a[1], a[2]),
  3124975700: (a) => new IFC4.IfcTextLiteralWithExtent(a[0], a[1], a[2], a[3], a[4]),
  1983826977: (a) => new IFC4.IfcTextStyleFontModel(a[0], a[1], a[2], a[3], a[4], a[5]),
  2715220739: (a) => new IFC4.IfcTrapeziumProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1628702193: (a) => new IFC4.IfcTypeObject(a[0], a[1], a[2], a[3], a[4], a[5]),
  3736923433: (a) => new IFC4.IfcTypeProcess(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2347495698: (a) => new IFC4.IfcTypeProduct(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3698973494: (a) => new IFC4.IfcTypeResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  427810014: (a) => new IFC4.IfcUShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1417489154: (a) => new IFC4.IfcVector(a[0], a[1]),
  2759199220: (a) => new IFC4.IfcVertexLoop(a[0]),
  1299126871: (a) => new IFC4.IfcWindowStyle(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  2543172580: (a) => new IFC4.IfcZShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3406155212: (a) => new IFC4.IfcAdvancedFace(a[0], a[1], a[2]),
  669184980: (a) => new IFC4.IfcAnnotationFillArea(a[0], a[1]),
  3207858831: (a) => new IFC4.IfcAsymmetricIShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14]),
  4261334040: (a) => new IFC4.IfcAxis1Placement(a[0], a[1]),
  3125803723: (a) => new IFC4.IfcAxis2Placement2D(a[0], a[1]),
  2740243338: (a) => new IFC4.IfcAxis2Placement3D(a[0], a[1], a[2]),
  2736907675: (a) => new IFC4.IfcBooleanResult(a[0], a[1], a[2]),
  4182860854: (_) => new IFC4.IfcBoundedSurface(),
  2581212453: (a) => new IFC4.IfcBoundingBox(a[0], a[1], a[2], a[3]),
  2713105998: (a) => new IFC4.IfcBoxedHalfSpace(a[0], a[1], a[2]),
  2898889636: (a) => new IFC4.IfcCShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1123145078: (a) => new IFC4.IfcCartesianPoint(a[0]),
  574549367: (_) => new IFC4.IfcCartesianPointList(),
  1675464909: (a) => new IFC4.IfcCartesianPointList2D(a[0]),
  2059837836: (a) => new IFC4.IfcCartesianPointList3D(a[0]),
  59481748: (a) => new IFC4.IfcCartesianTransformationOperator(a[0], a[1], a[2], a[3]),
  3749851601: (a) => new IFC4.IfcCartesianTransformationOperator2D(a[0], a[1], a[2], a[3]),
  3486308946: (a) => new IFC4.IfcCartesianTransformationOperator2DnonUniform(a[0], a[1], a[2], a[3], a[4]),
  3331915920: (a) => new IFC4.IfcCartesianTransformationOperator3D(a[0], a[1], a[2], a[3], a[4]),
  1416205885: (a) => new IFC4.IfcCartesianTransformationOperator3DnonUniform(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1383045692: (a) => new IFC4.IfcCircleProfileDef(a[0], a[1], a[2], a[3]),
  2205249479: (a) => new IFC4.IfcClosedShell(a[0]),
  776857604: (a) => new IFC4.IfcColourRgb(a[0], a[1], a[2], a[3]),
  2542286263: (a) => new IFC4.IfcComplexProperty(a[0], a[1], a[2], a[3]),
  2485617015: (a) => new IFC4.IfcCompositeCurveSegment(a[0], a[1], a[2]),
  2574617495: (a) => new IFC4.IfcConstructionResourceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  3419103109: (a) => new IFC4.IfcContext(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1815067380: (a) => new IFC4.IfcCrewResourceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  2506170314: (a) => new IFC4.IfcCsgPrimitive3D(a[0]),
  2147822146: (a) => new IFC4.IfcCsgSolid(a[0]),
  2601014836: (_) => new IFC4.IfcCurve(),
  2827736869: (a) => new IFC4.IfcCurveBoundedPlane(a[0], a[1], a[2]),
  2629017746: (a) => new IFC4.IfcCurveBoundedSurface(a[0], a[1], a[2]),
  32440307: (a) => new IFC4.IfcDirection(a[0]),
  526551008: (a) => new IFC4.IfcDoorStyle(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1472233963: (a) => new IFC4.IfcEdgeLoop(a[0]),
  1883228015: (a) => new IFC4.IfcElementQuantity(a[0], a[1], a[2], a[3], a[4], a[5]),
  339256511: (a) => new IFC4.IfcElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2777663545: (a) => new IFC4.IfcElementarySurface(a[0]),
  2835456948: (a) => new IFC4.IfcEllipseProfileDef(a[0], a[1], a[2], a[3], a[4]),
  4024345920: (a) => new IFC4.IfcEventType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  477187591: (a) => new IFC4.IfcExtrudedAreaSolid(a[0], a[1], a[2], a[3]),
  2804161546: (a) => new IFC4.IfcExtrudedAreaSolidTapered(a[0], a[1], a[2], a[3], a[4]),
  2047409740: (a) => new IFC4.IfcFaceBasedSurfaceModel(a[0]),
  374418227: (a) => new IFC4.IfcFillAreaStyleHatching(a[0], a[1], a[2], a[3], a[4]),
  315944413: (a) => new IFC4.IfcFillAreaStyleTiles(a[0], a[1], a[2]),
  2652556860: (a) => new IFC4.IfcFixedReferenceSweptAreaSolid(a[0], a[1], a[2], a[3], a[4], a[5]),
  4238390223: (a) => new IFC4.IfcFurnishingElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1268542332: (a) => new IFC4.IfcFurnitureType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  4095422895: (a) => new IFC4.IfcGeographicElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  987898635: (a) => new IFC4.IfcGeometricCurveSet(a[0]),
  1484403080: (a) => new IFC4.IfcIShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  178912537: (a) => new IFC4.IfcIndexedPolygonalFace(a[0]),
  2294589976: (a) => new IFC4.IfcIndexedPolygonalFaceWithVoids(a[0], a[1]),
  572779678: (a) => new IFC4.IfcLShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  428585644: (a) => new IFC4.IfcLaborResourceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1281925730: (a) => new IFC4.IfcLine(a[0], a[1]),
  1425443689: (a) => new IFC4.IfcManifoldSolidBrep(a[0]),
  3888040117: (a) => new IFC4.IfcObject(a[0], a[1], a[2], a[3], a[4]),
  3388369263: (a) => new IFC4.IfcOffsetCurve2D(a[0], a[1], a[2]),
  3505215534: (a) => new IFC4.IfcOffsetCurve3D(a[0], a[1], a[2], a[3]),
  1682466193: (a) => new IFC4.IfcPcurve(a[0], a[1]),
  603570806: (a) => new IFC4.IfcPlanarBox(a[0], a[1], a[2]),
  220341763: (a) => new IFC4.IfcPlane(a[0]),
  759155922: (a) => new IFC4.IfcPreDefinedColour(a[0]),
  2559016684: (a) => new IFC4.IfcPreDefinedCurveFont(a[0]),
  3967405729: (a) => new IFC4.IfcPreDefinedPropertySet(a[0], a[1], a[2], a[3]),
  569719735: (a) => new IFC4.IfcProcedureType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2945172077: (a) => new IFC4.IfcProcess(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  4208778838: (a) => new IFC4.IfcProduct(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  103090709: (a) => new IFC4.IfcProject(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  653396225: (a) => new IFC4.IfcProjectLibrary(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  871118103: (a) => new IFC4.IfcPropertyBoundedValue(a[0], a[1], a[2], a[3], a[4], a[5]),
  4166981789: (a) => new IFC4.IfcPropertyEnumeratedValue(a[0], a[1], a[2], a[3]),
  2752243245: (a) => new IFC4.IfcPropertyListValue(a[0], a[1], a[2], a[3]),
  941946838: (a) => new IFC4.IfcPropertyReferenceValue(a[0], a[1], a[2], a[3]),
  1451395588: (a) => new IFC4.IfcPropertySet(a[0], a[1], a[2], a[3], a[4]),
  492091185: (a) => new IFC4.IfcPropertySetTemplate(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3650150729: (a) => new IFC4.IfcPropertySingleValue(a[0], a[1], a[2], a[3]),
  110355661: (a) => new IFC4.IfcPropertyTableValue(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3521284610: (a) => new IFC4.IfcPropertyTemplate(a[0], a[1], a[2], a[3]),
  3219374653: (a) => new IFC4.IfcProxy(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2770003689: (a) => new IFC4.IfcRectangleHollowProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2798486643: (a) => new IFC4.IfcRectangularPyramid(a[0], a[1], a[2], a[3]),
  3454111270: (a) => new IFC4.IfcRectangularTrimmedSurface(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3765753017: (a) => new IFC4.IfcReinforcementDefinitionProperties(a[0], a[1], a[2], a[3], a[4], a[5]),
  3939117080: (a) => new IFC4.IfcRelAssigns(a[0], a[1], a[2], a[3], a[4], a[5]),
  1683148259: (a) => new IFC4.IfcRelAssignsToActor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2495723537: (a) => new IFC4.IfcRelAssignsToControl(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1307041759: (a) => new IFC4.IfcRelAssignsToGroup(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1027710054: (a) => new IFC4.IfcRelAssignsToGroupByFactor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  4278684876: (a) => new IFC4.IfcRelAssignsToProcess(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2857406711: (a) => new IFC4.IfcRelAssignsToProduct(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  205026976: (a) => new IFC4.IfcRelAssignsToResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1865459582: (a) => new IFC4.IfcRelAssociates(a[0], a[1], a[2], a[3], a[4]),
  4095574036: (a) => new IFC4.IfcRelAssociatesApproval(a[0], a[1], a[2], a[3], a[4], a[5]),
  919958153: (a) => new IFC4.IfcRelAssociatesClassification(a[0], a[1], a[2], a[3], a[4], a[5]),
  2728634034: (a) => new IFC4.IfcRelAssociatesConstraint(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  982818633: (a) => new IFC4.IfcRelAssociatesDocument(a[0], a[1], a[2], a[3], a[4], a[5]),
  3840914261: (a) => new IFC4.IfcRelAssociatesLibrary(a[0], a[1], a[2], a[3], a[4], a[5]),
  2655215786: (a) => new IFC4.IfcRelAssociatesMaterial(a[0], a[1], a[2], a[3], a[4], a[5]),
  826625072: (a) => new IFC4.IfcRelConnects(a[0], a[1], a[2], a[3]),
  1204542856: (a) => new IFC4.IfcRelConnectsElements(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3945020480: (a) => new IFC4.IfcRelConnectsPathElements(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  4201705270: (a) => new IFC4.IfcRelConnectsPortToElement(a[0], a[1], a[2], a[3], a[4], a[5]),
  3190031847: (a) => new IFC4.IfcRelConnectsPorts(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  2127690289: (a) => new IFC4.IfcRelConnectsStructuralActivity(a[0], a[1], a[2], a[3], a[4], a[5]),
  1638771189: (a) => new IFC4.IfcRelConnectsStructuralMember(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  504942748: (a) => new IFC4.IfcRelConnectsWithEccentricity(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  3678494232: (a) => new IFC4.IfcRelConnectsWithRealizingElements(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3242617779: (a) => new IFC4.IfcRelContainedInSpatialStructure(a[0], a[1], a[2], a[3], a[4], a[5]),
  886880790: (a) => new IFC4.IfcRelCoversBldgElements(a[0], a[1], a[2], a[3], a[4], a[5]),
  2802773753: (a) => new IFC4.IfcRelCoversSpaces(a[0], a[1], a[2], a[3], a[4], a[5]),
  2565941209: (a) => new IFC4.IfcRelDeclares(a[0], a[1], a[2], a[3], a[4], a[5]),
  2551354335: (a) => new IFC4.IfcRelDecomposes(a[0], a[1], a[2], a[3]),
  693640335: (a) => new IFC4.IfcRelDefines(a[0], a[1], a[2], a[3]),
  1462361463: (a) => new IFC4.IfcRelDefinesByObject(a[0], a[1], a[2], a[3], a[4], a[5]),
  4186316022: (a) => new IFC4.IfcRelDefinesByProperties(a[0], a[1], a[2], a[3], a[4], a[5]),
  307848117: (a) => new IFC4.IfcRelDefinesByTemplate(a[0], a[1], a[2], a[3], a[4], a[5]),
  781010003: (a) => new IFC4.IfcRelDefinesByType(a[0], a[1], a[2], a[3], a[4], a[5]),
  3940055652: (a) => new IFC4.IfcRelFillsElement(a[0], a[1], a[2], a[3], a[4], a[5]),
  279856033: (a) => new IFC4.IfcRelFlowControlElements(a[0], a[1], a[2], a[3], a[4], a[5]),
  427948657: (a) => new IFC4.IfcRelInterferesElements(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3268803585: (a) => new IFC4.IfcRelNests(a[0], a[1], a[2], a[3], a[4], a[5]),
  750771296: (a) => new IFC4.IfcRelProjectsElement(a[0], a[1], a[2], a[3], a[4], a[5]),
  1245217292: (a) => new IFC4.IfcRelReferencedInSpatialStructure(a[0], a[1], a[2], a[3], a[4], a[5]),
  4122056220: (a) => new IFC4.IfcRelSequence(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  366585022: (a) => new IFC4.IfcRelServicesBuildings(a[0], a[1], a[2], a[3], a[4], a[5]),
  3451746338: (a) => new IFC4.IfcRelSpaceBoundary(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3523091289: (a) => new IFC4.IfcRelSpaceBoundary1stLevel(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1521410863: (a) => new IFC4.IfcRelSpaceBoundary2ndLevel(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  1401173127: (a) => new IFC4.IfcRelVoidsElement(a[0], a[1], a[2], a[3], a[4], a[5]),
  816062949: (a) => new IFC4.IfcReparametrisedCompositeCurveSegment(a[0], a[1], a[2], a[3]),
  2914609552: (a) => new IFC4.IfcResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1856042241: (a) => new IFC4.IfcRevolvedAreaSolid(a[0], a[1], a[2], a[3]),
  3243963512: (a) => new IFC4.IfcRevolvedAreaSolidTapered(a[0], a[1], a[2], a[3], a[4]),
  4158566097: (a) => new IFC4.IfcRightCircularCone(a[0], a[1], a[2]),
  3626867408: (a) => new IFC4.IfcRightCircularCylinder(a[0], a[1], a[2]),
  3663146110: (a) => new IFC4.IfcSimplePropertyTemplate(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1412071761: (a) => new IFC4.IfcSpatialElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  710998568: (a) => new IFC4.IfcSpatialElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2706606064: (a) => new IFC4.IfcSpatialStructureElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3893378262: (a) => new IFC4.IfcSpatialStructureElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  463610769: (a) => new IFC4.IfcSpatialZone(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2481509218: (a) => new IFC4.IfcSpatialZoneType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  451544542: (a) => new IFC4.IfcSphere(a[0], a[1]),
  4015995234: (a) => new IFC4.IfcSphericalSurface(a[0], a[1]),
  3544373492: (a) => new IFC4.IfcStructuralActivity(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3136571912: (a) => new IFC4.IfcStructuralItem(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  530289379: (a) => new IFC4.IfcStructuralMember(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3689010777: (a) => new IFC4.IfcStructuralReaction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3979015343: (a) => new IFC4.IfcStructuralSurfaceMember(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2218152070: (a) => new IFC4.IfcStructuralSurfaceMemberVarying(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  603775116: (a) => new IFC4.IfcStructuralSurfaceReaction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4095615324: (a) => new IFC4.IfcSubContractResourceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  699246055: (a) => new IFC4.IfcSurfaceCurve(a[0], a[1], a[2]),
  2028607225: (a) => new IFC4.IfcSurfaceCurveSweptAreaSolid(a[0], a[1], a[2], a[3], a[4], a[5]),
  2809605785: (a) => new IFC4.IfcSurfaceOfLinearExtrusion(a[0], a[1], a[2], a[3]),
  4124788165: (a) => new IFC4.IfcSurfaceOfRevolution(a[0], a[1], a[2]),
  1580310250: (a) => new IFC4.IfcSystemFurnitureElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3473067441: (a) => new IFC4.IfcTask(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  3206491090: (a) => new IFC4.IfcTaskType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  2387106220: (a) => new IFC4.IfcTessellatedFaceSet(a[0]),
  1935646853: (a) => new IFC4.IfcToroidalSurface(a[0], a[1], a[2]),
  2097647324: (a) => new IFC4.IfcTransportElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2916149573: (a) => new IFC4.IfcTriangulatedFaceSet(a[0], a[1], a[2], a[3], a[4]),
  336235671: (a) => new IFC4.IfcWindowLiningProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]),
  512836454: (a) => new IFC4.IfcWindowPanelProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2296667514: (a) => new IFC4.IfcActor(a[0], a[1], a[2], a[3], a[4], a[5]),
  1635779807: (a) => new IFC4.IfcAdvancedBrep(a[0]),
  2603310189: (a) => new IFC4.IfcAdvancedBrepWithVoids(a[0], a[1]),
  1674181508: (a) => new IFC4.IfcAnnotation(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  2887950389: (a) => new IFC4.IfcBSplineSurface(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  167062518: (a) => new IFC4.IfcBSplineSurfaceWithKnots(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1334484129: (a) => new IFC4.IfcBlock(a[0], a[1], a[2], a[3]),
  3649129432: (a) => new IFC4.IfcBooleanClippingResult(a[0], a[1], a[2]),
  1260505505: (_) => new IFC4.IfcBoundedCurve(),
  4031249490: (a) => new IFC4.IfcBuilding(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1950629157: (a) => new IFC4.IfcBuildingElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3124254112: (a) => new IFC4.IfcBuildingStorey(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2197970202: (a) => new IFC4.IfcChimneyType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2937912522: (a) => new IFC4.IfcCircleHollowProfileDef(a[0], a[1], a[2], a[3], a[4]),
  3893394355: (a) => new IFC4.IfcCivilElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  300633059: (a) => new IFC4.IfcColumnType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3875453745: (a) => new IFC4.IfcComplexPropertyTemplate(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3732776249: (a) => new IFC4.IfcCompositeCurve(a[0], a[1]),
  15328376: (a) => new IFC4.IfcCompositeCurveOnSurface(a[0], a[1]),
  2510884976: (a) => new IFC4.IfcConic(a[0]),
  2185764099: (a) => new IFC4.IfcConstructionEquipmentResourceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  4105962743: (a) => new IFC4.IfcConstructionMaterialResourceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1525564444: (a) => new IFC4.IfcConstructionProductResourceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  2559216714: (a) => new IFC4.IfcConstructionResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3293443760: (a) => new IFC4.IfcControl(a[0], a[1], a[2], a[3], a[4], a[5]),
  3895139033: (a) => new IFC4.IfcCostItem(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1419761937: (a) => new IFC4.IfcCostSchedule(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1916426348: (a) => new IFC4.IfcCoveringType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3295246426: (a) => new IFC4.IfcCrewResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  1457835157: (a) => new IFC4.IfcCurtainWallType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1213902940: (a) => new IFC4.IfcCylindricalSurface(a[0], a[1]),
  3256556792: (a) => new IFC4.IfcDistributionElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3849074793: (a) => new IFC4.IfcDistributionFlowElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2963535650: (a) => new IFC4.IfcDoorLiningProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16]),
  1714330368: (a) => new IFC4.IfcDoorPanelProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2323601079: (a) => new IFC4.IfcDoorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  445594917: (a) => new IFC4.IfcDraughtingPreDefinedColour(a[0]),
  4006246654: (a) => new IFC4.IfcDraughtingPreDefinedCurveFont(a[0]),
  1758889154: (a) => new IFC4.IfcElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  4123344466: (a) => new IFC4.IfcElementAssembly(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2397081782: (a) => new IFC4.IfcElementAssemblyType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1623761950: (a) => new IFC4.IfcElementComponent(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2590856083: (a) => new IFC4.IfcElementComponentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1704287377: (a) => new IFC4.IfcEllipse(a[0], a[1], a[2]),
  2107101300: (a) => new IFC4.IfcEnergyConversionDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  132023988: (a) => new IFC4.IfcEngineType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3174744832: (a) => new IFC4.IfcEvaporativeCoolerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3390157468: (a) => new IFC4.IfcEvaporatorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4148101412: (a) => new IFC4.IfcEvent(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  2853485674: (a) => new IFC4.IfcExternalSpatialStructureElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  807026263: (a) => new IFC4.IfcFacetedBrep(a[0]),
  3737207727: (a) => new IFC4.IfcFacetedBrepWithVoids(a[0], a[1]),
  647756555: (a) => new IFC4.IfcFastener(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2489546625: (a) => new IFC4.IfcFastenerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2827207264: (a) => new IFC4.IfcFeatureElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2143335405: (a) => new IFC4.IfcFeatureElementAddition(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1287392070: (a) => new IFC4.IfcFeatureElementSubtraction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3907093117: (a) => new IFC4.IfcFlowControllerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3198132628: (a) => new IFC4.IfcFlowFittingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3815607619: (a) => new IFC4.IfcFlowMeterType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1482959167: (a) => new IFC4.IfcFlowMovingDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1834744321: (a) => new IFC4.IfcFlowSegmentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1339347760: (a) => new IFC4.IfcFlowStorageDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2297155007: (a) => new IFC4.IfcFlowTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3009222698: (a) => new IFC4.IfcFlowTreatmentDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1893162501: (a) => new IFC4.IfcFootingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  263784265: (a) => new IFC4.IfcFurnishingElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1509553395: (a) => new IFC4.IfcFurniture(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3493046030: (a) => new IFC4.IfcGeographicElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3009204131: (a) => new IFC4.IfcGrid(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  2706460486: (a) => new IFC4.IfcGroup(a[0], a[1], a[2], a[3], a[4]),
  1251058090: (a) => new IFC4.IfcHeatExchangerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1806887404: (a) => new IFC4.IfcHumidifierType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2571569899: (a) => new IFC4.IfcIndexedPolyCurve(a[0], a[1], a[2]),
  3946677679: (a) => new IFC4.IfcInterceptorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3113134337: (a) => new IFC4.IfcIntersectionCurve(a[0], a[1], a[2]),
  2391368822: (a) => new IFC4.IfcInventory(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  4288270099: (a) => new IFC4.IfcJunctionBoxType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3827777499: (a) => new IFC4.IfcLaborResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  1051575348: (a) => new IFC4.IfcLampType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1161773419: (a) => new IFC4.IfcLightFixtureType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  377706215: (a) => new IFC4.IfcMechanicalFastener(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  2108223431: (a) => new IFC4.IfcMechanicalFastenerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1114901282: (a) => new IFC4.IfcMedicalDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3181161470: (a) => new IFC4.IfcMemberType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  977012517: (a) => new IFC4.IfcMotorConnectionType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4143007308: (a) => new IFC4.IfcOccupant(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3588315303: (a) => new IFC4.IfcOpeningElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3079942009: (a) => new IFC4.IfcOpeningStandardCase(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2837617999: (a) => new IFC4.IfcOutletType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2382730787: (a) => new IFC4.IfcPerformanceHistory(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3566463478: (a) => new IFC4.IfcPermeableCoveringProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3327091369: (a) => new IFC4.IfcPermit(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1158309216: (a) => new IFC4.IfcPileType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  804291784: (a) => new IFC4.IfcPipeFittingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4231323485: (a) => new IFC4.IfcPipeSegmentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4017108033: (a) => new IFC4.IfcPlateType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2839578677: (a) => new IFC4.IfcPolygonalFaceSet(a[0], a[1], a[2], a[3]),
  3724593414: (a) => new IFC4.IfcPolyline(a[0]),
  3740093272: (a) => new IFC4.IfcPort(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  2744685151: (a) => new IFC4.IfcProcedure(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2904328755: (a) => new IFC4.IfcProjectOrder(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3651124850: (a) => new IFC4.IfcProjectionElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1842657554: (a) => new IFC4.IfcProtectiveDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2250791053: (a) => new IFC4.IfcPumpType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2893384427: (a) => new IFC4.IfcRailingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2324767716: (a) => new IFC4.IfcRampFlightType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1469900589: (a) => new IFC4.IfcRampType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  683857671: (a) => new IFC4.IfcRationalBSplineSurfaceWithKnots(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  3027567501: (a) => new IFC4.IfcReinforcingElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  964333572: (a) => new IFC4.IfcReinforcingElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2320036040: (a) => new IFC4.IfcReinforcingMesh(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17]),
  2310774935: (a) => new IFC4.IfcReinforcingMeshType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18], a[19]),
  160246688: (a) => new IFC4.IfcRelAggregates(a[0], a[1], a[2], a[3], a[4], a[5]),
  2781568857: (a) => new IFC4.IfcRoofType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1768891740: (a) => new IFC4.IfcSanitaryTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2157484638: (a) => new IFC4.IfcSeamCurve(a[0], a[1], a[2]),
  4074543187: (a) => new IFC4.IfcShadingDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4097777520: (a) => new IFC4.IfcSite(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
  2533589738: (a) => new IFC4.IfcSlabType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1072016465: (a) => new IFC4.IfcSolarDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3856911033: (a) => new IFC4.IfcSpace(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  1305183839: (a) => new IFC4.IfcSpaceHeaterType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3812236995: (a) => new IFC4.IfcSpaceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  3112655638: (a) => new IFC4.IfcStackTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1039846685: (a) => new IFC4.IfcStairFlightType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  338393293: (a) => new IFC4.IfcStairType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  682877961: (a) => new IFC4.IfcStructuralAction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1179482911: (a) => new IFC4.IfcStructuralConnection(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1004757350: (a) => new IFC4.IfcStructuralCurveAction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  4243806635: (a) => new IFC4.IfcStructuralCurveConnection(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  214636428: (a) => new IFC4.IfcStructuralCurveMember(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2445595289: (a) => new IFC4.IfcStructuralCurveMemberVarying(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2757150158: (a) => new IFC4.IfcStructuralCurveReaction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1807405624: (a) => new IFC4.IfcStructuralLinearAction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1252848954: (a) => new IFC4.IfcStructuralLoadGroup(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2082059205: (a) => new IFC4.IfcStructuralPointAction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  734778138: (a) => new IFC4.IfcStructuralPointConnection(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1235345126: (a) => new IFC4.IfcStructuralPointReaction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2986769608: (a) => new IFC4.IfcStructuralResultGroup(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3657597509: (a) => new IFC4.IfcStructuralSurfaceAction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1975003073: (a) => new IFC4.IfcStructuralSurfaceConnection(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  148013059: (a) => new IFC4.IfcSubContractResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  3101698114: (a) => new IFC4.IfcSurfaceFeature(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2315554128: (a) => new IFC4.IfcSwitchingDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2254336722: (a) => new IFC4.IfcSystem(a[0], a[1], a[2], a[3], a[4]),
  413509423: (a) => new IFC4.IfcSystemFurnitureElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  5716631: (a) => new IFC4.IfcTankType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3824725483: (a) => new IFC4.IfcTendon(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16]),
  2347447852: (a) => new IFC4.IfcTendonAnchor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3081323446: (a) => new IFC4.IfcTendonAnchorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2415094496: (a) => new IFC4.IfcTendonType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  1692211062: (a) => new IFC4.IfcTransformerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1620046519: (a) => new IFC4.IfcTransportElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3593883385: (a) => new IFC4.IfcTrimmedCurve(a[0], a[1], a[2], a[3], a[4]),
  1600972822: (a) => new IFC4.IfcTubeBundleType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1911125066: (a) => new IFC4.IfcUnitaryEquipmentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  728799441: (a) => new IFC4.IfcValveType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2391383451: (a) => new IFC4.IfcVibrationIsolator(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3313531582: (a) => new IFC4.IfcVibrationIsolatorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2769231204: (a) => new IFC4.IfcVirtualElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  926996030: (a) => new IFC4.IfcVoidingFeature(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1898987631: (a) => new IFC4.IfcWallType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1133259667: (a) => new IFC4.IfcWasteTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4009809668: (a) => new IFC4.IfcWindowType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  4088093105: (a) => new IFC4.IfcWorkCalendar(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1028945134: (a) => new IFC4.IfcWorkControl(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  4218914973: (a) => new IFC4.IfcWorkPlan(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
  3342526732: (a) => new IFC4.IfcWorkSchedule(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
  1033361043: (a) => new IFC4.IfcZone(a[0], a[1], a[2], a[3], a[4], a[5]),
  3821786052: (a) => new IFC4.IfcActionRequest(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1411407467: (a) => new IFC4.IfcAirTerminalBoxType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3352864051: (a) => new IFC4.IfcAirTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1871374353: (a) => new IFC4.IfcAirToAirHeatRecoveryType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3460190687: (a) => new IFC4.IfcAsset(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
  1532957894: (a) => new IFC4.IfcAudioVisualApplianceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1967976161: (a) => new IFC4.IfcBSplineCurve(a[0], a[1], a[2], a[3], a[4]),
  2461110595: (a) => new IFC4.IfcBSplineCurveWithKnots(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  819618141: (a) => new IFC4.IfcBeamType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  231477066: (a) => new IFC4.IfcBoilerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1136057603: (a) => new IFC4.IfcBoundaryCurve(a[0], a[1]),
  3299480353: (a) => new IFC4.IfcBuildingElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2979338954: (a) => new IFC4.IfcBuildingElementPart(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  39481116: (a) => new IFC4.IfcBuildingElementPartType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1095909175: (a) => new IFC4.IfcBuildingElementProxy(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1909888760: (a) => new IFC4.IfcBuildingElementProxyType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1177604601: (a) => new IFC4.IfcBuildingSystem(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  2188180465: (a) => new IFC4.IfcBurnerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  395041908: (a) => new IFC4.IfcCableCarrierFittingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3293546465: (a) => new IFC4.IfcCableCarrierSegmentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2674252688: (a) => new IFC4.IfcCableFittingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1285652485: (a) => new IFC4.IfcCableSegmentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2951183804: (a) => new IFC4.IfcChillerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3296154744: (a) => new IFC4.IfcChimney(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2611217952: (a) => new IFC4.IfcCircle(a[0], a[1]),
  1677625105: (a) => new IFC4.IfcCivilElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2301859152: (a) => new IFC4.IfcCoilType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  843113511: (a) => new IFC4.IfcColumn(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  905975707: (a) => new IFC4.IfcColumnStandardCase(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  400855858: (a) => new IFC4.IfcCommunicationsApplianceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3850581409: (a) => new IFC4.IfcCompressorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2816379211: (a) => new IFC4.IfcCondenserType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3898045240: (a) => new IFC4.IfcConstructionEquipmentResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  1060000209: (a) => new IFC4.IfcConstructionMaterialResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  488727124: (a) => new IFC4.IfcConstructionProductResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  335055490: (a) => new IFC4.IfcCooledBeamType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2954562838: (a) => new IFC4.IfcCoolingTowerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1973544240: (a) => new IFC4.IfcCovering(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3495092785: (a) => new IFC4.IfcCurtainWall(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3961806047: (a) => new IFC4.IfcDamperType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1335981549: (a) => new IFC4.IfcDiscreteAccessory(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2635815018: (a) => new IFC4.IfcDiscreteAccessoryType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1599208980: (a) => new IFC4.IfcDistributionChamberElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2063403501: (a) => new IFC4.IfcDistributionControlElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1945004755: (a) => new IFC4.IfcDistributionElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3040386961: (a) => new IFC4.IfcDistributionFlowElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3041715199: (a) => new IFC4.IfcDistributionPort(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3205830791: (a) => new IFC4.IfcDistributionSystem(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  395920057: (a) => new IFC4.IfcDoor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  3242481149: (a) => new IFC4.IfcDoorStandardCase(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  869906466: (a) => new IFC4.IfcDuctFittingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3760055223: (a) => new IFC4.IfcDuctSegmentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2030761528: (a) => new IFC4.IfcDuctSilencerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  663422040: (a) => new IFC4.IfcElectricApplianceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2417008758: (a) => new IFC4.IfcElectricDistributionBoardType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3277789161: (a) => new IFC4.IfcElectricFlowStorageDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1534661035: (a) => new IFC4.IfcElectricGeneratorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1217240411: (a) => new IFC4.IfcElectricMotorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  712377611: (a) => new IFC4.IfcElectricTimeControlType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1658829314: (a) => new IFC4.IfcEnergyConversionDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2814081492: (a) => new IFC4.IfcEngine(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3747195512: (a) => new IFC4.IfcEvaporativeCooler(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  484807127: (a) => new IFC4.IfcEvaporator(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1209101575: (a) => new IFC4.IfcExternalSpatialElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  346874300: (a) => new IFC4.IfcFanType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1810631287: (a) => new IFC4.IfcFilterType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4222183408: (a) => new IFC4.IfcFireSuppressionTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2058353004: (a) => new IFC4.IfcFlowController(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  4278956645: (a) => new IFC4.IfcFlowFitting(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  4037862832: (a) => new IFC4.IfcFlowInstrumentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2188021234: (a) => new IFC4.IfcFlowMeter(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3132237377: (a) => new IFC4.IfcFlowMovingDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  987401354: (a) => new IFC4.IfcFlowSegment(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  707683696: (a) => new IFC4.IfcFlowStorageDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2223149337: (a) => new IFC4.IfcFlowTerminal(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3508470533: (a) => new IFC4.IfcFlowTreatmentDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  900683007: (a) => new IFC4.IfcFooting(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3319311131: (a) => new IFC4.IfcHeatExchanger(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2068733104: (a) => new IFC4.IfcHumidifier(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4175244083: (a) => new IFC4.IfcInterceptor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2176052936: (a) => new IFC4.IfcJunctionBox(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  76236018: (a) => new IFC4.IfcLamp(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  629592764: (a) => new IFC4.IfcLightFixture(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1437502449: (a) => new IFC4.IfcMedicalDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1073191201: (a) => new IFC4.IfcMember(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1911478936: (a) => new IFC4.IfcMemberStandardCase(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2474470126: (a) => new IFC4.IfcMotorConnection(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  144952367: (a) => new IFC4.IfcOuterBoundaryCurve(a[0], a[1]),
  3694346114: (a) => new IFC4.IfcOutlet(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1687234759: (a) => new IFC4.IfcPile(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  310824031: (a) => new IFC4.IfcPipeFitting(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3612865200: (a) => new IFC4.IfcPipeSegment(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3171933400: (a) => new IFC4.IfcPlate(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1156407060: (a) => new IFC4.IfcPlateStandardCase(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  738039164: (a) => new IFC4.IfcProtectiveDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  655969474: (a) => new IFC4.IfcProtectiveDeviceTrippingUnitType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  90941305: (a) => new IFC4.IfcPump(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2262370178: (a) => new IFC4.IfcRailing(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3024970846: (a) => new IFC4.IfcRamp(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3283111854: (a) => new IFC4.IfcRampFlight(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1232101972: (a) => new IFC4.IfcRationalBSplineCurveWithKnots(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  979691226: (a) => new IFC4.IfcReinforcingBar(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
  2572171363: (a) => new IFC4.IfcReinforcingBarType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]),
  2016517767: (a) => new IFC4.IfcRoof(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3053780830: (a) => new IFC4.IfcSanitaryTerminal(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1783015770: (a) => new IFC4.IfcSensorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1329646415: (a) => new IFC4.IfcShadingDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1529196076: (a) => new IFC4.IfcSlab(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3127900445: (a) => new IFC4.IfcSlabElementedCase(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3027962421: (a) => new IFC4.IfcSlabStandardCase(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3420628829: (a) => new IFC4.IfcSolarDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1999602285: (a) => new IFC4.IfcSpaceHeater(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1404847402: (a) => new IFC4.IfcStackTerminal(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  331165859: (a) => new IFC4.IfcStair(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4252922144: (a) => new IFC4.IfcStairFlight(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  2515109513: (a) => new IFC4.IfcStructuralAnalysisModel(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  385403989: (a) => new IFC4.IfcStructuralLoadCase(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  1621171031: (a) => new IFC4.IfcStructuralPlanarAction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1162798199: (a) => new IFC4.IfcSwitchingDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  812556717: (a) => new IFC4.IfcTank(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3825984169: (a) => new IFC4.IfcTransformer(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3026737570: (a) => new IFC4.IfcTubeBundle(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3179687236: (a) => new IFC4.IfcUnitaryControlElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4292641817: (a) => new IFC4.IfcUnitaryEquipment(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4207607924: (a) => new IFC4.IfcValve(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2391406946: (a) => new IFC4.IfcWall(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4156078855: (a) => new IFC4.IfcWallElementedCase(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3512223829: (a) => new IFC4.IfcWallStandardCase(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4237592921: (a) => new IFC4.IfcWasteTerminal(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3304561284: (a) => new IFC4.IfcWindow(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  486154966: (a) => new IFC4.IfcWindowStandardCase(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  2874132201: (a) => new IFC4.IfcActuatorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1634111441: (a) => new IFC4.IfcAirTerminal(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  177149247: (a) => new IFC4.IfcAirTerminalBox(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2056796094: (a) => new IFC4.IfcAirToAirHeatRecovery(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3001207471: (a) => new IFC4.IfcAlarmType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  277319702: (a) => new IFC4.IfcAudioVisualAppliance(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  753842376: (a) => new IFC4.IfcBeam(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2906023776: (a) => new IFC4.IfcBeamStandardCase(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  32344328: (a) => new IFC4.IfcBoiler(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2938176219: (a) => new IFC4.IfcBurner(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  635142910: (a) => new IFC4.IfcCableCarrierFitting(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3758799889: (a) => new IFC4.IfcCableCarrierSegment(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1051757585: (a) => new IFC4.IfcCableFitting(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4217484030: (a) => new IFC4.IfcCableSegment(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3902619387: (a) => new IFC4.IfcChiller(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  639361253: (a) => new IFC4.IfcCoil(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3221913625: (a) => new IFC4.IfcCommunicationsAppliance(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3571504051: (a) => new IFC4.IfcCompressor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2272882330: (a) => new IFC4.IfcCondenser(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  578613899: (a) => new IFC4.IfcControllerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4136498852: (a) => new IFC4.IfcCooledBeam(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3640358203: (a) => new IFC4.IfcCoolingTower(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4074379575: (a) => new IFC4.IfcDamper(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1052013943: (a) => new IFC4.IfcDistributionChamberElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  562808652: (a) => new IFC4.IfcDistributionCircuit(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1062813311: (a) => new IFC4.IfcDistributionControlElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  342316401: (a) => new IFC4.IfcDuctFitting(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3518393246: (a) => new IFC4.IfcDuctSegment(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1360408905: (a) => new IFC4.IfcDuctSilencer(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1904799276: (a) => new IFC4.IfcElectricAppliance(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  862014818: (a) => new IFC4.IfcElectricDistributionBoard(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3310460725: (a) => new IFC4.IfcElectricFlowStorageDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  264262732: (a) => new IFC4.IfcElectricGenerator(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  402227799: (a) => new IFC4.IfcElectricMotor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1003880860: (a) => new IFC4.IfcElectricTimeControl(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3415622556: (a) => new IFC4.IfcFan(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  819412036: (a) => new IFC4.IfcFilter(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1426591983: (a) => new IFC4.IfcFireSuppressionTerminal(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  182646315: (a) => new IFC4.IfcFlowInstrument(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2295281155: (a) => new IFC4.IfcProtectiveDeviceTrippingUnit(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4086658281: (a) => new IFC4.IfcSensor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  630975310: (a) => new IFC4.IfcUnitaryControlElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4288193352: (a) => new IFC4.IfcActuator(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3087945054: (a) => new IFC4.IfcAlarm(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  25142252: (a) => new IFC4.IfcController(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8])
};
ToRawLineData[2] = {
  3630933823: (i) => [i.Role, i.UserDefinedRole, i.Description],
  618182010: (i) => [i.Purpose, i.Description, i.UserDefinedPurpose],
  639542469: (i) => [i.ApplicationDeveloper, i.Version, i.ApplicationFullName, i.ApplicationIdentifier],
  411424972: (i) => [i.Name, i.Description, i.AppliedValue, i.UnitBasis, i.ApplicableDate, i.FixedUntilDate, i.Category, i.Condition, i.ArithmeticOperator, i.Components],
  130549933: (i) => [i.Identifier, i.Name, i.Description, i.TimeOfApproval, i.Status, i.Level, i.Qualifier, i.RequestingApproval, i.GivingApproval],
  4037036970: (i) => [i.Name],
  1560379544: (i) => [i.Name, !i.TranslationalStiffnessByLengthX ? null : Labelise(i.TranslationalStiffnessByLengthX), !i.TranslationalStiffnessByLengthY ? null : Labelise(i.TranslationalStiffnessByLengthY), !i.TranslationalStiffnessByLengthZ ? null : Labelise(i.TranslationalStiffnessByLengthZ), !i.RotationalStiffnessByLengthX ? null : Labelise(i.RotationalStiffnessByLengthX), !i.RotationalStiffnessByLengthY ? null : Labelise(i.RotationalStiffnessByLengthY), !i.RotationalStiffnessByLengthZ ? null : Labelise(i.RotationalStiffnessByLengthZ)],
  3367102660: (i) => [i.Name, !i.TranslationalStiffnessByAreaX ? null : Labelise(i.TranslationalStiffnessByAreaX), !i.TranslationalStiffnessByAreaY ? null : Labelise(i.TranslationalStiffnessByAreaY), !i.TranslationalStiffnessByAreaZ ? null : Labelise(i.TranslationalStiffnessByAreaZ)],
  1387855156: (i) => [i.Name, !i.TranslationalStiffnessX ? null : Labelise(i.TranslationalStiffnessX), !i.TranslationalStiffnessY ? null : Labelise(i.TranslationalStiffnessY), !i.TranslationalStiffnessZ ? null : Labelise(i.TranslationalStiffnessZ), !i.RotationalStiffnessX ? null : Labelise(i.RotationalStiffnessX), !i.RotationalStiffnessY ? null : Labelise(i.RotationalStiffnessY), !i.RotationalStiffnessZ ? null : Labelise(i.RotationalStiffnessZ)],
  2069777674: (i) => [i.Name, !i.TranslationalStiffnessX ? null : Labelise(i.TranslationalStiffnessX), !i.TranslationalStiffnessY ? null : Labelise(i.TranslationalStiffnessY), !i.TranslationalStiffnessZ ? null : Labelise(i.TranslationalStiffnessZ), !i.RotationalStiffnessX ? null : Labelise(i.RotationalStiffnessX), !i.RotationalStiffnessY ? null : Labelise(i.RotationalStiffnessY), !i.RotationalStiffnessZ ? null : Labelise(i.RotationalStiffnessZ), !i.WarpingStiffness ? null : Labelise(i.WarpingStiffness)],
  2859738748: (_) => [],
  2614616156: (i) => [i.PointOnRelatingElement, i.PointOnRelatedElement],
  2732653382: (i) => [i.SurfaceOnRelatingElement, i.SurfaceOnRelatedElement],
  775493141: (i) => [i.VolumeOnRelatingElement, i.VolumeOnRelatedElement],
  1959218052: (i) => [i.Name, i.Description, i.ConstraintGrade, i.ConstraintSource, i.CreatingActor, i.CreationTime, i.UserDefinedGrade],
  1785450214: (i) => [i.SourceCRS, i.TargetCRS],
  1466758467: (i) => [i.Name, i.Description, i.GeodeticDatum, i.VerticalDatum],
  602808272: (i) => [i.Name, i.Description, i.AppliedValue, i.UnitBasis, i.ApplicableDate, i.FixedUntilDate, i.Category, i.Condition, i.ArithmeticOperator, i.Components],
  1765591967: (i) => [i.Elements, i.UnitType, i.UserDefinedType],
  1045800335: (i) => [i.Unit, i.Exponent],
  2949456006: (i) => [i.LengthExponent, i.MassExponent, i.TimeExponent, i.ElectricCurrentExponent, i.ThermodynamicTemperatureExponent, i.AmountOfSubstanceExponent, i.LuminousIntensityExponent],
  4294318154: (_) => [],
  3200245327: (i) => [i.Location, i.Identification, i.Name],
  2242383968: (i) => [i.Location, i.Identification, i.Name],
  1040185647: (i) => [i.Location, i.Identification, i.Name],
  3548104201: (i) => [i.Location, i.Identification, i.Name],
  852622518: (i) => [i.AxisTag, i.AxisCurve, { type: 3, value: BooleanConvert(i.SameSense.value) }],
  3020489413: (i) => [i.TimeStamp, i.ListValues.map((p) => Labelise(p))],
  2655187982: (i) => [i.Name, i.Version, i.Publisher, i.VersionDate, i.Location, i.Description],
  3452421091: (i) => [i.Location, i.Identification, i.Name, i.Description, i.Language, i.ReferencedLibrary],
  4162380809: (i) => [i.MainPlaneAngle, i.SecondaryPlaneAngle, i.LuminousIntensity],
  1566485204: (i) => [i.LightDistributionCurve, i.DistributionData],
  3057273783: (i) => [i.SourceCRS, i.TargetCRS, i.Eastings, i.Northings, i.OrthogonalHeight, i.XAxisAbscissa, i.XAxisOrdinate, i.Scale],
  1847130766: (i) => [i.MaterialClassifications, i.ClassifiedMaterial],
  760658860: (_) => [],
  248100487: (i) => [i.Material, i.LayerThickness, i.IsVentilated == null ? null : { type: 3, value: BooleanConvert(i.IsVentilated.value) }, i.Name, i.Description, i.Category, i.Priority],
  3303938423: (i) => [i.MaterialLayers, i.LayerSetName, i.Description],
  1847252529: (i) => [i.Material, i.LayerThickness, i.IsVentilated == null ? null : { type: 3, value: BooleanConvert(i.IsVentilated.value) }, i.Name, i.Description, i.Category, i.Priority, i.OffsetDirection, i.OffsetValues],
  2199411900: (i) => [i.Materials],
  2235152071: (i) => [i.Name, i.Description, i.Material, i.Profile, i.Priority, i.Category],
  164193824: (i) => [i.Name, i.Description, i.MaterialProfiles, i.CompositeProfile],
  552965576: (i) => [i.Name, i.Description, i.Material, i.Profile, i.Priority, i.Category, i.OffsetValues],
  1507914824: (_) => [],
  2597039031: (i) => [Labelise(i.ValueComponent), i.UnitComponent],
  3368373690: (i) => [i.Name, i.Description, i.ConstraintGrade, i.ConstraintSource, i.CreatingActor, i.CreationTime, i.UserDefinedGrade, i.Benchmark, i.ValueSource, i.DataValue, i.ReferencePath],
  2706619895: (i) => [i.Currency],
  1918398963: (i) => [i.Dimensions, i.UnitType],
  3701648758: (_) => [],
  2251480897: (i) => [i.Name, i.Description, i.ConstraintGrade, i.ConstraintSource, i.CreatingActor, i.CreationTime, i.UserDefinedGrade, i.BenchmarkValues, i.LogicalAggregator, i.ObjectiveQualifier, i.UserDefinedQualifier],
  4251960020: (i) => [i.Identification, i.Name, i.Description, i.Roles, i.Addresses],
  1207048766: (i) => [i.OwningUser, i.OwningApplication, i.State, i.ChangeAction, i.LastModifiedDate, i.LastModifyingUser, i.LastModifyingApplication, i.CreationDate],
  2077209135: (i) => [i.Identification, i.FamilyName, i.GivenName, i.MiddleNames, i.PrefixTitles, i.SuffixTitles, i.Roles, i.Addresses],
  101040310: (i) => [i.ThePerson, i.TheOrganization, i.Roles],
  2483315170: (i) => [i.Name, i.Description],
  2226359599: (i) => [i.Name, i.Description, i.Unit],
  3355820592: (i) => [i.Purpose, i.Description, i.UserDefinedPurpose, i.InternalLocation, i.AddressLines, i.PostalBox, i.Town, i.Region, i.PostalCode, i.Country],
  677532197: (_) => [],
  2022622350: (i) => [i.Name, i.Description, i.AssignedItems, i.Identifier],
  1304840413: (i) => [i.Name, i.Description, i.AssignedItems, i.Identifier, { type: 3, value: BooleanConvert(i.LayerOn.value) }, { type: 3, value: BooleanConvert(i.LayerFrozen.value) }, { type: 3, value: BooleanConvert(i.LayerBlocked.value) }, i.LayerStyles],
  3119450353: (i) => [i.Name],
  2417041796: (i) => [i.Styles],
  2095639259: (i) => [i.Name, i.Description, i.Representations],
  3958567839: (i) => [i.ProfileType, i.ProfileName],
  3843373140: (i) => [i.Name, i.Description, i.GeodeticDatum, i.VerticalDatum, i.MapProjection, i.MapZone, i.MapUnit],
  986844984: (_) => [],
  3710013099: (i) => [i.Name, i.EnumerationValues.map((p) => Labelise(p)), i.Unit],
  2044713172: (i) => [i.Name, i.Description, i.Unit, i.AreaValue, i.Formula],
  2093928680: (i) => [i.Name, i.Description, i.Unit, i.CountValue, i.Formula],
  931644368: (i) => [i.Name, i.Description, i.Unit, i.LengthValue, i.Formula],
  3252649465: (i) => [i.Name, i.Description, i.Unit, i.TimeValue, i.Formula],
  2405470396: (i) => [i.Name, i.Description, i.Unit, i.VolumeValue, i.Formula],
  825690147: (i) => [i.Name, i.Description, i.Unit, i.WeightValue, i.Formula],
  3915482550: (i) => [i.RecurrenceType, i.DayComponent, i.WeekdayComponent, i.MonthComponent, i.Position, i.Interval, i.Occurrences, i.TimePeriods],
  2433181523: (i) => [i.TypeIdentifier, i.AttributeIdentifier, i.InstanceName, i.ListPositions, i.InnerReference],
  1076942058: (i) => [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items],
  3377609919: (i) => [i.ContextIdentifier, i.ContextType],
  3008791417: (_) => [],
  1660063152: (i) => [i.MappingOrigin, i.MappedRepresentation],
  2439245199: (i) => [i.Name, i.Description],
  2341007311: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  448429030: (i) => [i.Dimensions, i.UnitType, i.Prefix, i.Name],
  1054537805: (i) => [i.Name, i.DataOrigin, i.UserDefinedDataOrigin],
  867548509: (i) => [i.ShapeRepresentations, i.Name, i.Description, { type: 3, value: BooleanConvert(i.ProductDefinitional.value) }, i.PartOfProductDefinitionShape],
  3982875396: (i) => [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items],
  4240577450: (i) => [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items],
  2273995522: (i) => [i.Name],
  2162789131: (i) => [i.Name],
  3478079324: (i) => [i.Name, i.Values, i.Locations],
  609421318: (i) => [i.Name],
  2525727697: (i) => [i.Name],
  3408363356: (i) => [i.Name, i.DeltaTConstant, i.DeltaTY, i.DeltaTZ],
  2830218821: (i) => [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items],
  3958052878: (i) => [i.Item, i.Styles, i.Name],
  3049322572: (i) => [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items],
  2934153892: (i) => [i.Name, i.SurfaceReinforcement1, i.SurfaceReinforcement2, i.ShearReinforcement],
  1300840506: (i) => [i.Name, i.Side, i.Styles],
  3303107099: (i) => [i.DiffuseTransmissionColour, i.DiffuseReflectionColour, i.TransmissionColour, i.ReflectanceColour],
  1607154358: (i) => [i.RefractionIndex, i.DispersionFactor],
  846575682: (i) => [i.SurfaceColour, i.Transparency],
  1351298697: (i) => [i.Textures],
  626085974: (i) => [{ type: 3, value: BooleanConvert(i.RepeatS.value) }, { type: 3, value: BooleanConvert(i.RepeatT.value) }, i.Mode, i.TextureTransform, i.Parameter],
  985171141: (i) => [i.Name, i.Rows, i.Columns],
  2043862942: (i) => [i.Identifier, i.Name, i.Description, i.Unit, i.ReferencePath],
  531007025: (i) => [!i.RowCells ? null : i.RowCells.map((p) => Labelise(p)), i.IsHeading == null ? null : { type: 3, value: BooleanConvert(i.IsHeading.value) }],
  1549132990: (i) => [i.Name, i.DataOrigin, i.UserDefinedDataOrigin, i.DurationType, i.ScheduleDuration, i.ScheduleStart, i.ScheduleFinish, i.EarlyStart, i.EarlyFinish, i.LateStart, i.LateFinish, i.FreeFloat, i.TotalFloat, i.IsCritical == null ? null : { type: 3, value: BooleanConvert(i.IsCritical.value) }, i.StatusTime, i.ActualDuration, i.ActualStart, i.ActualFinish, i.RemainingTime, i.Completion],
  2771591690: (i) => [i.Name, i.DataOrigin, i.UserDefinedDataOrigin, i.DurationType, i.ScheduleDuration, i.ScheduleStart, i.ScheduleFinish, i.EarlyStart, i.EarlyFinish, i.LateStart, i.LateFinish, i.FreeFloat, i.TotalFloat, i.IsCritical == null ? null : { type: 3, value: BooleanConvert(i.IsCritical.value) }, i.StatusTime, i.ActualDuration, i.ActualStart, i.ActualFinish, i.RemainingTime, i.Completion, i.Recurrence],
  912023232: (i) => [i.Purpose, i.Description, i.UserDefinedPurpose, i.TelephoneNumbers, i.FacsimileNumbers, i.PagerNumber, i.ElectronicMailAddresses, i.WWWHomePageURL, i.MessagingIDs],
  1447204868: (i) => [i.Name, i.TextCharacterAppearance, i.TextStyle, i.TextFontStyle, i.ModelOrDraughting == null ? null : { type: 3, value: BooleanConvert(i.ModelOrDraughting.value) }],
  2636378356: (i) => [i.Colour, i.BackgroundColour],
  1640371178: (i) => [!i.TextIndent ? null : Labelise(i.TextIndent), i.TextAlign, i.TextDecoration, !i.LetterSpacing ? null : Labelise(i.LetterSpacing), !i.WordSpacing ? null : Labelise(i.WordSpacing), i.TextTransform, !i.LineHeight ? null : Labelise(i.LineHeight)],
  280115917: (i) => [i.Maps],
  1742049831: (i) => [i.Maps, i.Mode, i.Parameter],
  2552916305: (i) => [i.Maps, i.Vertices, i.MappedTo],
  1210645708: (i) => [i.Coordinates],
  3611470254: (i) => [i.TexCoordsList],
  1199560280: (i) => [i.StartTime, i.EndTime],
  3101149627: (i) => [i.Name, i.Description, i.StartTime, i.EndTime, i.TimeSeriesDataType, i.DataOrigin, i.UserDefinedDataOrigin, i.Unit],
  581633288: (i) => [i.ListValues.map((p) => Labelise(p))],
  1377556343: (_) => [],
  1735638870: (i) => [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items],
  180925521: (i) => [i.Units],
  2799835756: (_) => [],
  1907098498: (i) => [i.VertexGeometry],
  891718957: (i) => [i.IntersectingAxes, i.OffsetDistances],
  1236880293: (i) => [i.Name, i.DataOrigin, i.UserDefinedDataOrigin, i.RecurrencePattern, i.Start, i.Finish],
  3869604511: (i) => [i.Name, i.Description, i.RelatingApproval, i.RelatedApprovals],
  3798115385: (i) => [i.ProfileType, i.ProfileName, i.OuterCurve],
  1310608509: (i) => [i.ProfileType, i.ProfileName, i.Curve],
  2705031697: (i) => [i.ProfileType, i.ProfileName, i.OuterCurve, i.InnerCurves],
  616511568: (i) => [{ type: 3, value: BooleanConvert(i.RepeatS.value) }, { type: 3, value: BooleanConvert(i.RepeatT.value) }, i.Mode, i.TextureTransform, i.Parameter, i.RasterFormat, i.RasterCode],
  3150382593: (i) => [i.ProfileType, i.ProfileName, i.Curve, i.Thickness],
  747523909: (i) => [i.Source, i.Edition, i.EditionDate, i.Name, i.Description, i.Location, i.ReferenceTokens],
  647927063: (i) => [i.Location, i.Identification, i.Name, i.ReferencedSource, i.Description, i.Sort],
  3285139300: (i) => [i.ColourList],
  3264961684: (i) => [i.Name],
  1485152156: (i) => [i.ProfileType, i.ProfileName, i.Profiles, i.Label],
  370225590: (i) => [i.CfsFaces],
  1981873012: (i) => [i.CurveOnRelatingElement, i.CurveOnRelatedElement],
  45288368: (i) => [i.PointOnRelatingElement, i.PointOnRelatedElement, i.EccentricityInX, i.EccentricityInY, i.EccentricityInZ],
  3050246964: (i) => [i.Dimensions, i.UnitType, i.Name],
  2889183280: (i) => [i.Dimensions, i.UnitType, i.Name, i.ConversionFactor],
  2713554722: (i) => [i.Dimensions, i.UnitType, i.Name, i.ConversionFactor, i.ConversionOffset],
  539742890: (i) => [i.Name, i.Description, i.RelatingMonetaryUnit, i.RelatedMonetaryUnit, i.ExchangeRate, i.RateDateTime, i.RateSource],
  3800577675: (i) => [i.Name, i.CurveFont, !i.CurveWidth ? null : Labelise(i.CurveWidth), i.CurveColour, i.ModelOrDraughting == null ? null : { type: 3, value: BooleanConvert(i.ModelOrDraughting.value) }],
  1105321065: (i) => [i.Name, i.PatternList],
  2367409068: (i) => [i.Name, i.CurveFont, i.CurveFontScaling],
  3510044353: (i) => [i.VisibleSegmentLength, i.InvisibleSegmentLength],
  3632507154: (i) => [i.ProfileType, i.ProfileName, i.ParentProfile, i.Operator, i.Label],
  1154170062: (i) => [i.Identification, i.Name, i.Description, i.Location, i.Purpose, i.IntendedUse, i.Scope, i.Revision, i.DocumentOwner, i.Editors, i.CreationTime, i.LastRevisionTime, i.ElectronicFormat, i.ValidFrom, i.ValidUntil, i.Confidentiality, i.Status],
  770865208: (i) => [i.Name, i.Description, i.RelatingDocument, i.RelatedDocuments, i.RelationshipType],
  3732053477: (i) => [i.Location, i.Identification, i.Name, i.Description, i.ReferencedDocument],
  3900360178: (i) => [i.EdgeStart, i.EdgeEnd],
  476780140: (i) => [i.EdgeStart, i.EdgeEnd, i.EdgeGeometry, { type: 3, value: BooleanConvert(i.SameSense.value) }],
  211053100: (i) => [i.Name, i.DataOrigin, i.UserDefinedDataOrigin, i.ActualDate, i.EarlyDate, i.LateDate, i.ScheduleDate],
  297599258: (i) => [i.Name, i.Description, i.Properties],
  1437805879: (i) => [i.Name, i.Description, i.RelatingReference, i.RelatedResourceObjects],
  2556980723: (i) => [i.Bounds],
  1809719519: (i) => [i.Bound, { type: 3, value: BooleanConvert(i.Orientation.value) }],
  803316827: (i) => [i.Bound, { type: 3, value: BooleanConvert(i.Orientation.value) }],
  3008276851: (i) => [i.Bounds, i.FaceSurface, { type: 3, value: BooleanConvert(i.SameSense.value) }],
  4219587988: (i) => [i.Name, i.TensionFailureX, i.TensionFailureY, i.TensionFailureZ, i.CompressionFailureX, i.CompressionFailureY, i.CompressionFailureZ],
  738692330: (i) => [i.Name, i.FillStyles, i.ModelorDraughting == null ? null : { type: 3, value: BooleanConvert(i.ModelorDraughting.value) }],
  3448662350: (i) => [i.ContextIdentifier, i.ContextType, i.CoordinateSpaceDimension, i.Precision, i.WorldCoordinateSystem, i.TrueNorth],
  2453401579: (_) => [],
  4142052618: (i) => [i.ContextIdentifier, i.ContextType, i.CoordinateSpaceDimension, i.Precision, i.WorldCoordinateSystem, i.TrueNorth, i.ParentContext, i.TargetScale, i.TargetView, i.UserDefinedTargetView],
  3590301190: (i) => [i.Elements],
  178086475: (i) => [i.PlacementLocation, i.PlacementRefDirection],
  812098782: (i) => [i.BaseSurface, { type: 3, value: BooleanConvert(i.AgreementFlag.value) }],
  3905492369: (i) => [{ type: 3, value: BooleanConvert(i.RepeatS.value) }, { type: 3, value: BooleanConvert(i.RepeatT.value) }, i.Mode, i.TextureTransform, i.Parameter, i.URLReference],
  3570813810: (i) => [i.MappedTo, i.Opacity, i.Colours, i.ColourIndex],
  1437953363: (i) => [i.Maps, i.MappedTo, i.TexCoords],
  2133299955: (i) => [i.Maps, i.MappedTo, i.TexCoords, i.TexCoordIndex],
  3741457305: (i) => [i.Name, i.Description, i.StartTime, i.EndTime, i.TimeSeriesDataType, i.DataOrigin, i.UserDefinedDataOrigin, i.Unit, i.Values],
  1585845231: (i) => [i.Name, i.DataOrigin, i.UserDefinedDataOrigin, Labelise(i.LagValue), i.DurationType],
  1402838566: (i) => [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity],
  125510826: (i) => [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity],
  2604431987: (i) => [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity, i.Orientation],
  4266656042: (i) => [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity, i.Position, i.ColourAppearance, i.ColourTemperature, i.LuminousFlux, i.LightEmissionSource, i.LightDistributionDataSource],
  1520743889: (i) => [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity, i.Position, i.Radius, i.ConstantAttenuation, i.DistanceAttenuation, i.QuadricAttenuation],
  3422422726: (i) => [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity, i.Position, i.Radius, i.ConstantAttenuation, i.DistanceAttenuation, i.QuadricAttenuation, i.Orientation, i.ConcentrationExponent, i.SpreadAngle, i.BeamWidthAngle],
  2624227202: (i) => [i.PlacementRelTo, i.RelativePlacement],
  1008929658: (_) => [],
  2347385850: (i) => [i.MappingSource, i.MappingTarget],
  1838606355: (i) => [i.Name, i.Description, i.Category],
  3708119e3: (i) => [i.Name, i.Description, i.Material, i.Fraction, i.Category],
  2852063980: (i) => [i.Name, i.Description, i.MaterialConstituents],
  2022407955: (i) => [i.Name, i.Description, i.Representations, i.RepresentedMaterial],
  1303795690: (i) => [i.ForLayerSet, i.LayerSetDirection, i.DirectionSense, i.OffsetFromReferenceLine, i.ReferenceExtent],
  3079605661: (i) => [i.ForProfileSet, i.CardinalPoint, i.ReferenceExtent],
  3404854881: (i) => [i.ForProfileSet, i.CardinalPoint, i.ReferenceExtent, i.ForProfileEndSet, i.CardinalEndPoint],
  3265635763: (i) => [i.Name, i.Description, i.Properties, i.Material],
  853536259: (i) => [i.Name, i.Description, i.RelatingMaterial, i.RelatedMaterials, i.Expression],
  2998442950: (i) => [i.ProfileType, i.ProfileName, i.ParentProfile, i.Operator, i.Label],
  219451334: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  2665983363: (i) => [i.CfsFaces],
  1411181986: (i) => [i.Name, i.Description, i.RelatingOrganization, i.RelatedOrganizations],
  1029017970: (i) => [i.EdgeStart, i.EdgeEnd, i.EdgeElement, { type: 3, value: BooleanConvert(i.Orientation.value) }],
  2529465313: (i) => [i.ProfileType, i.ProfileName, i.Position],
  2519244187: (i) => [i.EdgeList],
  3021840470: (i) => [i.Name, i.Description, i.HasQuantities, i.Discrimination, i.Quality, i.Usage],
  597895409: (i) => [{ type: 3, value: BooleanConvert(i.RepeatS.value) }, { type: 3, value: BooleanConvert(i.RepeatT.value) }, i.Mode, i.TextureTransform, i.Parameter, i.Width, i.Height, i.ColourComponents, i.Pixel],
  2004835150: (i) => [i.Location],
  1663979128: (i) => [i.SizeInX, i.SizeInY],
  2067069095: (_) => [],
  4022376103: (i) => [i.BasisCurve, i.PointParameter],
  1423911732: (i) => [i.BasisSurface, i.PointParameterU, i.PointParameterV],
  2924175390: (i) => [i.Polygon],
  2775532180: (i) => [i.BaseSurface, { type: 3, value: BooleanConvert(i.AgreementFlag.value) }, i.Position, i.PolygonalBoundary],
  3727388367: (i) => [i.Name],
  3778827333: (_) => [],
  1775413392: (i) => [i.Name],
  673634403: (i) => [i.Name, i.Description, i.Representations],
  2802850158: (i) => [i.Name, i.Description, i.Properties, i.ProfileDefinition],
  2598011224: (i) => [i.Name, i.Description],
  1680319473: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  148025276: (i) => [i.Name, i.Description, i.DependingProperty, i.DependantProperty, i.Expression],
  3357820518: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  1482703590: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  2090586900: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  3615266464: (i) => [i.ProfileType, i.ProfileName, i.Position, i.XDim, i.YDim],
  3413951693: (i) => [i.Name, i.Description, i.StartTime, i.EndTime, i.TimeSeriesDataType, i.DataOrigin, i.UserDefinedDataOrigin, i.Unit, i.TimeStep, i.Values],
  1580146022: (i) => [i.TotalCrossSectionArea, i.SteelGrade, i.BarSurface, i.EffectiveDepth, i.NominalBarDiameter, i.BarCount],
  478536968: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  2943643501: (i) => [i.Name, i.Description, i.RelatedResourceObjects, i.RelatingApproval],
  1608871552: (i) => [i.Name, i.Description, i.RelatingConstraint, i.RelatedResourceObjects],
  1042787934: (i) => [i.Name, i.DataOrigin, i.UserDefinedDataOrigin, i.ScheduleWork, i.ScheduleUsage, i.ScheduleStart, i.ScheduleFinish, i.ScheduleContour, i.LevelingDelay, i.IsOverAllocated == null ? null : { type: 3, value: BooleanConvert(i.IsOverAllocated.value) }, i.StatusTime, i.ActualWork, i.ActualUsage, i.ActualStart, i.ActualFinish, i.RemainingWork, i.RemainingUsage, i.Completion],
  2778083089: (i) => [i.ProfileType, i.ProfileName, i.Position, i.XDim, i.YDim, i.RoundingRadius],
  2042790032: (i) => [i.SectionType, i.StartProfile, i.EndProfile],
  4165799628: (i) => [i.LongitudinalStartPosition, i.LongitudinalEndPosition, i.TransversePosition, i.ReinforcementRole, i.SectionDefinition, i.CrossSectionReinforcementDefinitions],
  1509187699: (i) => [i.SpineCurve, i.CrossSections, i.CrossSectionPositions],
  4124623270: (i) => [i.SbsmBoundary],
  3692461612: (i) => [i.Name, i.Description],
  2609359061: (i) => [i.Name, i.SlippageX, i.SlippageY, i.SlippageZ],
  723233188: (_) => [],
  1595516126: (i) => [i.Name, i.LinearForceX, i.LinearForceY, i.LinearForceZ, i.LinearMomentX, i.LinearMomentY, i.LinearMomentZ],
  2668620305: (i) => [i.Name, i.PlanarForceX, i.PlanarForceY, i.PlanarForceZ],
  2473145415: (i) => [i.Name, i.DisplacementX, i.DisplacementY, i.DisplacementZ, i.RotationalDisplacementRX, i.RotationalDisplacementRY, i.RotationalDisplacementRZ],
  1973038258: (i) => [i.Name, i.DisplacementX, i.DisplacementY, i.DisplacementZ, i.RotationalDisplacementRX, i.RotationalDisplacementRY, i.RotationalDisplacementRZ, i.Distortion],
  1597423693: (i) => [i.Name, i.ForceX, i.ForceY, i.ForceZ, i.MomentX, i.MomentY, i.MomentZ],
  1190533807: (i) => [i.Name, i.ForceX, i.ForceY, i.ForceZ, i.MomentX, i.MomentY, i.MomentZ, i.WarpingMoment],
  2233826070: (i) => [i.EdgeStart, i.EdgeEnd, i.ParentEdge],
  2513912981: (_) => [],
  1878645084: (i) => [i.SurfaceColour, i.Transparency, i.DiffuseColour, i.TransmissionColour, i.DiffuseTransmissionColour, i.ReflectionColour, i.SpecularColour, !i.SpecularHighlight ? null : Labelise(i.SpecularHighlight), i.ReflectanceMethod],
  2247615214: (i) => [i.SweptArea, i.Position],
  1260650574: (i) => [i.Directrix, i.Radius, i.InnerRadius, i.StartParam, i.EndParam],
  1096409881: (i) => [i.Directrix, i.Radius, i.InnerRadius, i.StartParam, i.EndParam, i.FilletRadius],
  230924584: (i) => [i.SweptCurve, i.Position],
  3071757647: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.FlangeWidth, i.WebThickness, i.FlangeThickness, i.FilletRadius, i.FlangeEdgeRadius, i.WebEdgeRadius, i.WebSlope, i.FlangeSlope],
  901063453: (_) => [],
  4282788508: (i) => [i.Literal, i.Placement, i.Path],
  3124975700: (i) => [i.Literal, i.Placement, i.Path, i.Extent, i.BoxAlignment],
  1983826977: (i) => [i.Name, i.FontFamily, i.FontStyle, i.FontVariant, i.FontWeight, Labelise(i.FontSize)],
  2715220739: (i) => [i.ProfileType, i.ProfileName, i.Position, i.BottomXDim, i.TopXDim, i.YDim, i.TopXOffset],
  1628702193: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets],
  3736923433: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ProcessType],
  2347495698: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag],
  3698973494: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType],
  427810014: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.FlangeWidth, i.WebThickness, i.FlangeThickness, i.FilletRadius, i.EdgeRadius, i.FlangeSlope],
  1417489154: (i) => [i.Orientation, i.Magnitude],
  2759199220: (i) => [i.LoopVertex],
  1299126871: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ConstructionType, i.OperationType, { type: 3, value: BooleanConvert(i.ParameterTakesPrecedence.value) }, { type: 3, value: BooleanConvert(i.Sizeable.value) }],
  2543172580: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.FlangeWidth, i.WebThickness, i.FlangeThickness, i.FilletRadius, i.EdgeRadius],
  3406155212: (i) => [i.Bounds, i.FaceSurface, { type: 3, value: BooleanConvert(i.SameSense.value) }],
  669184980: (i) => [i.OuterBoundary, i.InnerBoundaries],
  3207858831: (i) => [i.ProfileType, i.ProfileName, i.Position, i.BottomFlangeWidth, i.OverallDepth, i.WebThickness, i.BottomFlangeThickness, i.BottomFlangeFilletRadius, i.TopFlangeWidth, i.TopFlangeThickness, i.TopFlangeFilletRadius, i.BottomFlangeEdgeRadius, i.BottomFlangeSlope, i.TopFlangeEdgeRadius, i.TopFlangeSlope],
  4261334040: (i) => [i.Location, i.Axis],
  3125803723: (i) => [i.Location, i.RefDirection],
  2740243338: (i) => [i.Location, i.Axis, i.RefDirection],
  2736907675: (i) => [i.Operator, i.FirstOperand, i.SecondOperand],
  4182860854: (_) => [],
  2581212453: (i) => [i.Corner, i.XDim, i.YDim, i.ZDim],
  2713105998: (i) => [i.BaseSurface, { type: 3, value: BooleanConvert(i.AgreementFlag.value) }, i.Enclosure],
  2898889636: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.Width, i.WallThickness, i.Girth, i.InternalFilletRadius],
  1123145078: (i) => [i.Coordinates],
  574549367: (_) => [],
  1675464909: (i) => [i.CoordList],
  2059837836: (i) => [i.CoordList],
  59481748: (i) => [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale],
  3749851601: (i) => [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale],
  3486308946: (i) => [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale, i.Scale2],
  3331915920: (i) => [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale, i.Axis3],
  1416205885: (i) => [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale, i.Axis3, i.Scale2, i.Scale3],
  1383045692: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Radius],
  2205249479: (i) => [i.CfsFaces],
  776857604: (i) => [i.Name, i.Red, i.Green, i.Blue],
  2542286263: (i) => [i.Name, i.Description, i.UsageName, i.HasProperties],
  2485617015: (i) => [i.Transition, { type: 3, value: BooleanConvert(i.SameSense.value) }, i.ParentCurve],
  2574617495: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity],
  3419103109: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LongName, i.Phase, i.RepresentationContexts, i.UnitsInContext],
  1815067380: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  2506170314: (i) => [i.Position],
  2147822146: (i) => [i.TreeRootExpression],
  2601014836: (_) => [],
  2827736869: (i) => [i.BasisSurface, i.OuterBoundary, i.InnerBoundaries],
  2629017746: (i) => [i.BasisSurface, i.Boundaries, { type: 3, value: BooleanConvert(i.ImplicitOuter.value) }],
  32440307: (i) => [i.DirectionRatios],
  526551008: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.OperationType, i.ConstructionType, { type: 3, value: BooleanConvert(i.ParameterTakesPrecedence.value) }, { type: 3, value: BooleanConvert(i.Sizeable.value) }],
  1472233963: (i) => [i.EdgeList],
  1883228015: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.MethodOfMeasurement, i.Quantities],
  339256511: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  2777663545: (i) => [i.Position],
  2835456948: (i) => [i.ProfileType, i.ProfileName, i.Position, i.SemiAxis1, i.SemiAxis2],
  4024345920: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ProcessType, i.PredefinedType, i.EventTriggerType, i.UserDefinedEventTriggerType],
  477187591: (i) => [i.SweptArea, i.Position, i.ExtrudedDirection, i.Depth],
  2804161546: (i) => [i.SweptArea, i.Position, i.ExtrudedDirection, i.Depth, i.EndSweptArea],
  2047409740: (i) => [i.FbsmFaces],
  374418227: (i) => [i.HatchLineAppearance, i.StartOfNextHatchLine, i.PointOfReferenceHatchLine, i.PatternStart, i.HatchLineAngle],
  315944413: (i) => [i.TilingPattern, i.Tiles, i.TilingScale],
  2652556860: (i) => [i.SweptArea, i.Position, i.Directrix, i.StartParam, i.EndParam, i.FixedReference],
  4238390223: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  1268542332: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.AssemblyPlace, i.PredefinedType],
  4095422895: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  987898635: (i) => [i.Elements],
  1484403080: (i) => [i.ProfileType, i.ProfileName, i.Position, i.OverallWidth, i.OverallDepth, i.WebThickness, i.FlangeThickness, i.FilletRadius, i.FlangeEdgeRadius, i.FlangeSlope],
  178912537: (i) => [i.CoordIndex],
  2294589976: (i) => [i.CoordIndex, i.InnerCoordIndices],
  572779678: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.Width, i.Thickness, i.FilletRadius, i.EdgeRadius, i.LegSlope],
  428585644: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  1281925730: (i) => [i.Pnt, i.Dir],
  1425443689: (i) => [i.Outer],
  3888040117: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType],
  3388369263: (i) => [i.BasisCurve, i.Distance, { type: 3, value: BooleanConvert(i.SelfIntersect.value) }],
  3505215534: (i) => [i.BasisCurve, i.Distance, { type: 3, value: BooleanConvert(i.SelfIntersect.value) }, i.RefDirection],
  1682466193: (i) => [i.BasisSurface, i.ReferenceCurve],
  603570806: (i) => [i.SizeInX, i.SizeInY, i.Placement],
  220341763: (i) => [i.Position],
  759155922: (i) => [i.Name],
  2559016684: (i) => [i.Name],
  3967405729: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  569719735: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ProcessType, i.PredefinedType],
  2945172077: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription],
  4208778838: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation],
  103090709: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LongName, i.Phase, i.RepresentationContexts, i.UnitsInContext],
  653396225: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LongName, i.Phase, i.RepresentationContexts, i.UnitsInContext],
  871118103: (i) => [i.Name, i.Description, !i.UpperBoundValue ? null : Labelise(i.UpperBoundValue), !i.LowerBoundValue ? null : Labelise(i.LowerBoundValue), i.Unit, !i.SetPointValue ? null : Labelise(i.SetPointValue)],
  4166981789: (i) => [i.Name, i.Description, !i.EnumerationValues ? null : i.EnumerationValues.map((p) => Labelise(p)), i.EnumerationReference],
  2752243245: (i) => [i.Name, i.Description, !i.ListValues ? null : i.ListValues.map((p) => Labelise(p)), i.Unit],
  941946838: (i) => [i.Name, i.Description, i.UsageName, i.PropertyReference],
  1451395588: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.HasProperties],
  492091185: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.TemplateType, i.ApplicableEntity, i.HasPropertyTemplates],
  3650150729: (i) => [i.Name, i.Description, !i.NominalValue ? null : Labelise(i.NominalValue), i.Unit],
  110355661: (i) => [i.Name, i.Description, !i.DefiningValues ? null : i.DefiningValues.map((p) => Labelise(p)), !i.DefinedValues ? null : i.DefinedValues.map((p) => Labelise(p)), i.Expression, i.DefiningUnit, i.DefinedUnit, i.CurveInterpolation],
  3521284610: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  3219374653: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.ProxyType, i.Tag],
  2770003689: (i) => [i.ProfileType, i.ProfileName, i.Position, i.XDim, i.YDim, i.WallThickness, i.InnerFilletRadius, i.OuterFilletRadius],
  2798486643: (i) => [i.Position, i.XLength, i.YLength, i.Height],
  3454111270: (i) => [i.BasisSurface, i.U1, i.V1, i.U2, i.V2, { type: 3, value: BooleanConvert(i.Usense.value) }, { type: 3, value: BooleanConvert(i.Vsense.value) }],
  3765753017: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.DefinitionType, i.ReinforcementSectionDefinitions],
  3939117080: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType],
  1683148259: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingActor, i.ActingRole],
  2495723537: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingControl],
  1307041759: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingGroup],
  1027710054: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingGroup, i.Factor],
  4278684876: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingProcess, i.QuantityInProcess],
  2857406711: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingProduct],
  205026976: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingResource],
  1865459582: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects],
  4095574036: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingApproval],
  919958153: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingClassification],
  2728634034: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.Intent, i.RelatingConstraint],
  982818633: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingDocument],
  3840914261: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingLibrary],
  2655215786: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingMaterial],
  826625072: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  1204542856: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ConnectionGeometry, i.RelatingElement, i.RelatedElement],
  3945020480: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ConnectionGeometry, i.RelatingElement, i.RelatedElement, i.RelatingPriorities, i.RelatedPriorities, i.RelatedConnectionType, i.RelatingConnectionType],
  4201705270: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingPort, i.RelatedElement],
  3190031847: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingPort, i.RelatedPort, i.RealizingElement],
  2127690289: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingElement, i.RelatedStructuralActivity],
  1638771189: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingStructuralMember, i.RelatedStructuralConnection, i.AppliedCondition, i.AdditionalConditions, i.SupportedLength, i.ConditionCoordinateSystem],
  504942748: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingStructuralMember, i.RelatedStructuralConnection, i.AppliedCondition, i.AdditionalConditions, i.SupportedLength, i.ConditionCoordinateSystem, i.ConnectionConstraint],
  3678494232: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ConnectionGeometry, i.RelatingElement, i.RelatedElement, i.RealizingElements, i.ConnectionType],
  3242617779: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedElements, i.RelatingStructure],
  886880790: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingBuildingElement, i.RelatedCoverings],
  2802773753: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingSpace, i.RelatedCoverings],
  2565941209: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingContext, i.RelatedDefinitions],
  2551354335: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  693640335: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  1462361463: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingObject],
  4186316022: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingPropertyDefinition],
  307848117: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedPropertySets, i.RelatingTemplate],
  781010003: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingType],
  3940055652: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingOpeningElement, i.RelatedBuildingElement],
  279856033: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedControlElements, i.RelatingFlowElement],
  427948657: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingElement, i.RelatedElement, i.InterferenceGeometry, i.InterferenceType, i.ImpliedOrder],
  3268803585: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingObject, i.RelatedObjects],
  750771296: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingElement, i.RelatedFeatureElement],
  1245217292: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedElements, i.RelatingStructure],
  4122056220: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingProcess, i.RelatedProcess, i.TimeLag, i.SequenceType, i.UserDefinedSequenceType],
  366585022: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingSystem, i.RelatedBuildings],
  3451746338: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingSpace, i.RelatedBuildingElement, i.ConnectionGeometry, i.PhysicalOrVirtualBoundary, i.InternalOrExternalBoundary],
  3523091289: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingSpace, i.RelatedBuildingElement, i.ConnectionGeometry, i.PhysicalOrVirtualBoundary, i.InternalOrExternalBoundary, i.ParentBoundary],
  1521410863: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingSpace, i.RelatedBuildingElement, i.ConnectionGeometry, i.PhysicalOrVirtualBoundary, i.InternalOrExternalBoundary, i.ParentBoundary, i.CorrespondingBoundary],
  1401173127: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingBuildingElement, i.RelatedOpeningElement],
  816062949: (i) => [i.Transition, { type: 3, value: BooleanConvert(i.SameSense.value) }, i.ParentCurve, i.ParamLength],
  2914609552: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription],
  1856042241: (i) => [i.SweptArea, i.Position, i.Axis, i.Angle],
  3243963512: (i) => [i.SweptArea, i.Position, i.Axis, i.Angle, i.EndSweptArea],
  4158566097: (i) => [i.Position, i.Height, i.BottomRadius],
  3626867408: (i) => [i.Position, i.Height, i.Radius],
  3663146110: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.TemplateType, i.PrimaryMeasureType, i.SecondaryMeasureType, i.Enumerators, i.PrimaryUnit, i.SecondaryUnit, i.Expression, i.AccessState],
  1412071761: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName],
  710998568: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  2706606064: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType],
  3893378262: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  463610769: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.PredefinedType],
  2481509218: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.LongName],
  451544542: (i) => [i.Position, i.Radius],
  4015995234: (i) => [i.Position, i.Radius],
  3544373492: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal],
  3136571912: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation],
  530289379: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation],
  3689010777: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal],
  3979015343: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType, i.Thickness],
  2218152070: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType, i.Thickness],
  603775116: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.PredefinedType],
  4095615324: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  699246055: (i) => [i.Curve3D, i.AssociatedGeometry, i.MasterRepresentation],
  2028607225: (i) => [i.SweptArea, i.Position, i.Directrix, i.StartParam, i.EndParam, i.ReferenceSurface],
  2809605785: (i) => [i.SweptCurve, i.Position, i.ExtrudedDirection, i.Depth],
  4124788165: (i) => [i.SweptCurve, i.Position, i.AxisPosition],
  1580310250: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3473067441: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Status, i.WorkMethod, { type: 3, value: BooleanConvert(i.IsMilestone.value) }, i.Priority, i.TaskTime, i.PredefinedType],
  3206491090: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ProcessType, i.PredefinedType, i.WorkMethod],
  2387106220: (i) => [i.Coordinates],
  1935646853: (i) => [i.Position, i.MajorRadius, i.MinorRadius],
  2097647324: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2916149573: (i) => [i.Coordinates, i.Normals, i.Closed == null ? null : { type: 3, value: BooleanConvert(i.Closed.value) }, i.CoordIndex, i.PnIndex],
  336235671: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.LiningDepth, i.LiningThickness, i.TransomThickness, i.MullionThickness, i.FirstTransomOffset, i.SecondTransomOffset, i.FirstMullionOffset, i.SecondMullionOffset, i.ShapeAspectStyle, i.LiningOffset, i.LiningToPanelOffsetX, i.LiningToPanelOffsetY],
  512836454: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.OperationType, i.PanelPosition, i.FrameDepth, i.FrameThickness, i.ShapeAspectStyle],
  2296667514: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.TheActor],
  1635779807: (i) => [i.Outer],
  2603310189: (i) => [i.Outer, i.Voids],
  1674181508: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation],
  2887950389: (i) => [i.UDegree, i.VDegree, i.ControlPointsList, i.SurfaceForm, { type: 3, value: BooleanConvert(i.UClosed.value) }, { type: 3, value: BooleanConvert(i.VClosed.value) }, { type: 3, value: BooleanConvert(i.SelfIntersect.value) }],
  167062518: (i) => [i.UDegree, i.VDegree, i.ControlPointsList, i.SurfaceForm, { type: 3, value: BooleanConvert(i.UClosed.value) }, { type: 3, value: BooleanConvert(i.VClosed.value) }, { type: 3, value: BooleanConvert(i.SelfIntersect.value) }, i.UMultiplicities, i.VMultiplicities, i.UKnots, i.VKnots, i.KnotSpec],
  1334484129: (i) => [i.Position, i.XLength, i.YLength, i.ZLength],
  3649129432: (i) => [i.Operator, i.FirstOperand, i.SecondOperand],
  1260505505: (_) => [],
  4031249490: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.ElevationOfRefHeight, i.ElevationOfTerrain, i.BuildingAddress],
  1950629157: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  3124254112: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.Elevation],
  2197970202: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2937912522: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Radius, i.WallThickness],
  3893394355: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  300633059: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3875453745: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.UsageName, i.TemplateType, i.HasPropertyTemplates],
  3732776249: (i) => [i.Segments, { type: 3, value: BooleanConvert(i.SelfIntersect.value) }],
  15328376: (i) => [i.Segments, { type: 3, value: BooleanConvert(i.SelfIntersect.value) }],
  2510884976: (i) => [i.Position],
  2185764099: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  4105962743: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  1525564444: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  2559216714: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity],
  3293443760: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification],
  3895139033: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.PredefinedType, i.CostValues, i.CostQuantities],
  1419761937: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.PredefinedType, i.Status, i.SubmittedOn, i.UpdateDate],
  1916426348: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3295246426: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  1457835157: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1213902940: (i) => [i.Position, i.Radius],
  3256556792: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  3849074793: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  2963535650: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.LiningDepth, i.LiningThickness, i.ThresholdDepth, i.ThresholdThickness, i.TransomThickness, i.TransomOffset, i.LiningOffset, i.ThresholdOffset, i.CasingThickness, i.CasingDepth, i.ShapeAspectStyle, i.LiningToPanelOffsetX, i.LiningToPanelOffsetY],
  1714330368: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.PanelDepth, i.PanelOperation, i.PanelWidth, i.PanelPosition, i.ShapeAspectStyle],
  2323601079: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.OperationType, i.ParameterTakesPrecedence == null ? null : { type: 3, value: BooleanConvert(i.ParameterTakesPrecedence.value) }, i.UserDefinedOperationType],
  445594917: (i) => [i.Name],
  4006246654: (i) => [i.Name],
  1758889154: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  4123344466: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.AssemblyPlace, i.PredefinedType],
  2397081782: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1623761950: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2590856083: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  1704287377: (i) => [i.Position, i.SemiAxis1, i.SemiAxis2],
  2107101300: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  132023988: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3174744832: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3390157468: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4148101412: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.PredefinedType, i.EventTriggerType, i.UserDefinedEventTriggerType, i.EventOccurenceTime],
  2853485674: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName],
  807026263: (i) => [i.Outer],
  3737207727: (i) => [i.Outer, i.Voids],
  647756555: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2489546625: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2827207264: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2143335405: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  1287392070: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3907093117: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  3198132628: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  3815607619: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1482959167: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  1834744321: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  1339347760: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  2297155007: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  3009222698: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  1893162501: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  263784265: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  1509553395: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3493046030: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3009204131: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.UAxes, i.VAxes, i.WAxes, i.PredefinedType],
  2706460486: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType],
  1251058090: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1806887404: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2571569899: (i) => [i.Points, !i.Segments ? null : i.Segments.map((p) => Labelise(p)), i.SelfIntersect == null ? null : { type: 3, value: BooleanConvert(i.SelfIntersect.value) }],
  3946677679: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3113134337: (i) => [i.Curve3D, i.AssociatedGeometry, i.MasterRepresentation],
  2391368822: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PredefinedType, i.Jurisdiction, i.ResponsiblePersons, i.LastUpdateDate, i.CurrentValue, i.OriginalValue],
  4288270099: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3827777499: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  1051575348: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1161773419: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  377706215: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.NominalDiameter, i.NominalLength, i.PredefinedType],
  2108223431: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.NominalDiameter, i.NominalLength],
  1114901282: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3181161470: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  977012517: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4143007308: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.TheActor, i.PredefinedType],
  3588315303: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3079942009: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2837617999: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2382730787: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LifeCyclePhase, i.PredefinedType],
  3566463478: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.OperationType, i.PanelPosition, i.FrameDepth, i.FrameThickness, i.ShapeAspectStyle],
  3327091369: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.PredefinedType, i.Status, i.LongDescription],
  1158309216: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  804291784: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4231323485: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4017108033: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2839578677: (i) => [i.Coordinates, i.Closed == null ? null : { type: 3, value: BooleanConvert(i.Closed.value) }, i.Faces, i.PnIndex],
  3724593414: (i) => [i.Points],
  3740093272: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation],
  2744685151: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.PredefinedType],
  2904328755: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.PredefinedType, i.Status, i.LongDescription],
  3651124850: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1842657554: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2250791053: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2893384427: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2324767716: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1469900589: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  683857671: (i) => [i.UDegree, i.VDegree, i.ControlPointsList, i.SurfaceForm, { type: 3, value: BooleanConvert(i.UClosed.value) }, { type: 3, value: BooleanConvert(i.VClosed.value) }, { type: 3, value: BooleanConvert(i.SelfIntersect.value) }, i.UMultiplicities, i.VMultiplicities, i.UKnots, i.VKnots, i.KnotSpec, i.WeightsData],
  3027567501: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade],
  964333572: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  2320036040: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade, i.MeshLength, i.MeshWidth, i.LongitudinalBarNominalDiameter, i.TransverseBarNominalDiameter, i.LongitudinalBarCrossSectionArea, i.TransverseBarCrossSectionArea, i.LongitudinalBarSpacing, i.TransverseBarSpacing, i.PredefinedType],
  2310774935: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.MeshLength, i.MeshWidth, i.LongitudinalBarNominalDiameter, i.TransverseBarNominalDiameter, i.LongitudinalBarCrossSectionArea, i.TransverseBarCrossSectionArea, i.LongitudinalBarSpacing, i.TransverseBarSpacing, i.BendingShapeCode, !i.BendingParameters ? null : i.BendingParameters.map((p) => Labelise(p))],
  160246688: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingObject, i.RelatedObjects],
  2781568857: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1768891740: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2157484638: (i) => [i.Curve3D, i.AssociatedGeometry, i.MasterRepresentation],
  4074543187: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4097777520: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.RefLatitude, i.RefLongitude, i.RefElevation, i.LandTitleNumber, i.SiteAddress],
  2533589738: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1072016465: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3856911033: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.PredefinedType, i.ElevationWithFlooring],
  1305183839: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3812236995: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.LongName],
  3112655638: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1039846685: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  338393293: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  682877961: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad == null ? null : { type: 3, value: BooleanConvert(i.DestabilizingLoad.value) }],
  1179482911: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedCondition],
  1004757350: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad == null ? null : { type: 3, value: BooleanConvert(i.DestabilizingLoad.value) }, i.ProjectedOrTrue, i.PredefinedType],
  4243806635: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedCondition, i.Axis],
  214636428: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType, i.Axis],
  2445595289: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType, i.Axis],
  2757150158: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.PredefinedType],
  1807405624: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad == null ? null : { type: 3, value: BooleanConvert(i.DestabilizingLoad.value) }, i.ProjectedOrTrue, i.PredefinedType],
  1252848954: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PredefinedType, i.ActionType, i.ActionSource, i.Coefficient, i.Purpose],
  2082059205: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad == null ? null : { type: 3, value: BooleanConvert(i.DestabilizingLoad.value) }],
  734778138: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedCondition, i.ConditionCoordinateSystem],
  1235345126: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal],
  2986769608: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.TheoryType, i.ResultForLoadGroup, { type: 3, value: BooleanConvert(i.IsLinear.value) }],
  3657597509: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad == null ? null : { type: 3, value: BooleanConvert(i.DestabilizingLoad.value) }, i.ProjectedOrTrue, i.PredefinedType],
  1975003073: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedCondition],
  148013059: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  3101698114: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2315554128: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2254336722: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType],
  413509423: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  5716631: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3824725483: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade, i.PredefinedType, i.NominalDiameter, i.CrossSectionArea, i.TensionForce, i.PreStress, i.FrictionCoefficient, i.AnchorageSlip, i.MinCurvatureRadius],
  2347447852: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade, i.PredefinedType],
  3081323446: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2415094496: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.NominalDiameter, i.CrossSectionArea, i.SheathDiameter],
  1692211062: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1620046519: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3593883385: (i) => [i.BasisCurve, i.Trim1, i.Trim2, { type: 3, value: BooleanConvert(i.SenseAgreement.value) }, i.MasterRepresentation],
  1600972822: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1911125066: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  728799441: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2391383451: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3313531582: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2769231204: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  926996030: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1898987631: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1133259667: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4009809668: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.PartitioningType, i.ParameterTakesPrecedence == null ? null : { type: 3, value: BooleanConvert(i.ParameterTakesPrecedence.value) }, i.UserDefinedPartitioningType],
  4088093105: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.WorkingTimes, i.ExceptionTimes, i.PredefinedType],
  1028945134: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.CreationDate, i.Creators, i.Purpose, i.Duration, i.TotalFloat, i.StartTime, i.FinishTime],
  4218914973: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.CreationDate, i.Creators, i.Purpose, i.Duration, i.TotalFloat, i.StartTime, i.FinishTime, i.PredefinedType],
  3342526732: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.CreationDate, i.Creators, i.Purpose, i.Duration, i.TotalFloat, i.StartTime, i.FinishTime, i.PredefinedType],
  1033361043: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LongName],
  3821786052: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.PredefinedType, i.Status, i.LongDescription],
  1411407467: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3352864051: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1871374353: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3460190687: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.OriginalValue, i.CurrentValue, i.TotalReplacementCost, i.Owner, i.User, i.ResponsiblePerson, i.IncorporationDate, i.DepreciatedValue],
  1532957894: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1967976161: (i) => [i.Degree, i.ControlPointsList, i.CurveForm, { type: 3, value: BooleanConvert(i.ClosedCurve.value) }, { type: 3, value: BooleanConvert(i.SelfIntersect.value) }],
  2461110595: (i) => [i.Degree, i.ControlPointsList, i.CurveForm, { type: 3, value: BooleanConvert(i.ClosedCurve.value) }, { type: 3, value: BooleanConvert(i.SelfIntersect.value) }, i.KnotMultiplicities, i.Knots, i.KnotSpec],
  819618141: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  231477066: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1136057603: (i) => [i.Segments, { type: 3, value: BooleanConvert(i.SelfIntersect.value) }],
  3299480353: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2979338954: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  39481116: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1095909175: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1909888760: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1177604601: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PredefinedType, i.LongName],
  2188180465: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  395041908: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3293546465: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2674252688: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1285652485: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2951183804: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3296154744: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2611217952: (i) => [i.Position, i.Radius],
  1677625105: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2301859152: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  843113511: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  905975707: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  400855858: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3850581409: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2816379211: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3898045240: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  1060000209: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  488727124: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  335055490: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2954562838: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1973544240: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3495092785: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3961806047: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1335981549: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2635815018: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1599208980: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2063403501: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  1945004755: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3040386961: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3041715199: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.FlowDirection, i.PredefinedType, i.SystemType],
  3205830791: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LongName, i.PredefinedType],
  395920057: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.OverallHeight, i.OverallWidth, i.PredefinedType, i.OperationType, i.UserDefinedOperationType],
  3242481149: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.OverallHeight, i.OverallWidth, i.PredefinedType, i.OperationType, i.UserDefinedOperationType],
  869906466: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3760055223: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2030761528: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  663422040: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2417008758: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3277789161: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1534661035: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1217240411: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  712377611: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1658829314: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2814081492: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3747195512: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  484807127: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1209101575: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.PredefinedType],
  346874300: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1810631287: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4222183408: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2058353004: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  4278956645: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  4037862832: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2188021234: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3132237377: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  987401354: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  707683696: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2223149337: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3508470533: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  900683007: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3319311131: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2068733104: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4175244083: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2176052936: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  76236018: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  629592764: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1437502449: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1073191201: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1911478936: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2474470126: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  144952367: (i) => [i.Segments, { type: 3, value: BooleanConvert(i.SelfIntersect.value) }],
  3694346114: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1687234759: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType, i.ConstructionType],
  310824031: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3612865200: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3171933400: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1156407060: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  738039164: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  655969474: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  90941305: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2262370178: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3024970846: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3283111854: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1232101972: (i) => [i.Degree, i.ControlPointsList, i.CurveForm, { type: 3, value: BooleanConvert(i.ClosedCurve.value) }, { type: 3, value: BooleanConvert(i.SelfIntersect.value) }, i.KnotMultiplicities, i.Knots, i.KnotSpec, i.WeightsData],
  979691226: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade, i.NominalDiameter, i.CrossSectionArea, i.BarLength, i.PredefinedType, i.BarSurface],
  2572171363: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.NominalDiameter, i.CrossSectionArea, i.BarLength, i.BarSurface, i.BendingShapeCode, !i.BendingParameters ? null : i.BendingParameters.map((p) => Labelise(p))],
  2016517767: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3053780830: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1783015770: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1329646415: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1529196076: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3127900445: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3027962421: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3420628829: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1999602285: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1404847402: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  331165859: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4252922144: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.NumberOfRisers, i.NumberOfTreads, i.RiserHeight, i.TreadLength, i.PredefinedType],
  2515109513: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PredefinedType, i.OrientationOf2DPlane, i.LoadedBy, i.HasResults, i.SharedPlacement],
  385403989: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PredefinedType, i.ActionType, i.ActionSource, i.Coefficient, i.Purpose, i.SelfWeightCoefficients],
  1621171031: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad == null ? null : { type: 3, value: BooleanConvert(i.DestabilizingLoad.value) }, i.ProjectedOrTrue, i.PredefinedType],
  1162798199: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  812556717: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3825984169: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3026737570: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3179687236: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4292641817: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4207607924: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2391406946: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4156078855: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3512223829: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4237592921: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3304561284: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.OverallHeight, i.OverallWidth, i.PredefinedType, i.PartitioningType, i.UserDefinedPartitioningType],
  486154966: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.OverallHeight, i.OverallWidth, i.PredefinedType, i.PartitioningType, i.UserDefinedPartitioningType],
  2874132201: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1634111441: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  177149247: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2056796094: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3001207471: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  277319702: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  753842376: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2906023776: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  32344328: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2938176219: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  635142910: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3758799889: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1051757585: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4217484030: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3902619387: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  639361253: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3221913625: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3571504051: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2272882330: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  578613899: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4136498852: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3640358203: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4074379575: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1052013943: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  562808652: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LongName, i.PredefinedType],
  1062813311: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  342316401: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3518393246: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1360408905: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1904799276: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  862014818: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3310460725: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  264262732: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  402227799: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1003880860: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3415622556: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  819412036: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1426591983: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  182646315: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2295281155: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4086658281: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  630975310: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4288193352: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3087945054: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  25142252: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType]
};
TypeInitialisers[2] = {
  3699917729: (v) => new IFC4.IfcAbsorbedDoseMeasure(v),
  4182062534: (v) => new IFC4.IfcAccelerationMeasure(v),
  360377573: (v) => new IFC4.IfcAmountOfSubstanceMeasure(v),
  632304761: (v) => new IFC4.IfcAngularVelocityMeasure(v),
  3683503648: (v) => new IFC4.IfcArcIndex(v.map((x) => x.value)),
  1500781891: (v) => new IFC4.IfcAreaDensityMeasure(v),
  2650437152: (v) => new IFC4.IfcAreaMeasure(v),
  2314439260: (v) => new IFC4.IfcBinary(v),
  2735952531: (v) => new IFC4.IfcBoolean(v),
  1867003952: (v) => new IFC4.IfcBoxAlignment(v),
  1683019596: (v) => new IFC4.IfcCardinalPointReference(v),
  2991860651: (v) => new IFC4.IfcComplexNumber(v.map((x) => x.value)),
  3812528620: (v) => new IFC4.IfcCompoundPlaneAngleMeasure(v.map((x) => x.value)),
  3238673880: (v) => new IFC4.IfcContextDependentMeasure(v),
  1778710042: (v) => new IFC4.IfcCountMeasure(v),
  94842927: (v) => new IFC4.IfcCurvatureMeasure(v),
  937566702: (v) => new IFC4.IfcDate(v),
  2195413836: (v) => new IFC4.IfcDateTime(v),
  86635668: (v) => new IFC4.IfcDayInMonthNumber(v),
  3701338814: (v) => new IFC4.IfcDayInWeekNumber(v),
  1514641115: (v) => new IFC4.IfcDescriptiveMeasure(v),
  4134073009: (v) => new IFC4.IfcDimensionCount(v),
  524656162: (v) => new IFC4.IfcDoseEquivalentMeasure(v),
  2541165894: (v) => new IFC4.IfcDuration(v),
  69416015: (v) => new IFC4.IfcDynamicViscosityMeasure(v),
  1827137117: (v) => new IFC4.IfcElectricCapacitanceMeasure(v),
  3818826038: (v) => new IFC4.IfcElectricChargeMeasure(v),
  2093906313: (v) => new IFC4.IfcElectricConductanceMeasure(v),
  3790457270: (v) => new IFC4.IfcElectricCurrentMeasure(v),
  2951915441: (v) => new IFC4.IfcElectricResistanceMeasure(v),
  2506197118: (v) => new IFC4.IfcElectricVoltageMeasure(v),
  2078135608: (v) => new IFC4.IfcEnergyMeasure(v),
  1102727119: (v) => new IFC4.IfcFontStyle(v),
  2715512545: (v) => new IFC4.IfcFontVariant(v),
  2590844177: (v) => new IFC4.IfcFontWeight(v),
  1361398929: (v) => new IFC4.IfcForceMeasure(v),
  3044325142: (v) => new IFC4.IfcFrequencyMeasure(v),
  3064340077: (v) => new IFC4.IfcGloballyUniqueId(v),
  3113092358: (v) => new IFC4.IfcHeatFluxDensityMeasure(v),
  1158859006: (v) => new IFC4.IfcHeatingValueMeasure(v),
  983778844: (v) => new IFC4.IfcIdentifier(v),
  3358199106: (v) => new IFC4.IfcIlluminanceMeasure(v),
  2679005408: (v) => new IFC4.IfcInductanceMeasure(v),
  1939436016: (v) => new IFC4.IfcInteger(v),
  3809634241: (v) => new IFC4.IfcIntegerCountRateMeasure(v),
  3686016028: (v) => new IFC4.IfcIonConcentrationMeasure(v),
  3192672207: (v) => new IFC4.IfcIsothermalMoistureCapacityMeasure(v),
  2054016361: (v) => new IFC4.IfcKinematicViscosityMeasure(v),
  3258342251: (v) => new IFC4.IfcLabel(v),
  1275358634: (v) => new IFC4.IfcLanguageId(v),
  1243674935: (v) => new IFC4.IfcLengthMeasure(v),
  1774176899: (v) => new IFC4.IfcLineIndex(v.map((x) => x.value)),
  191860431: (v) => new IFC4.IfcLinearForceMeasure(v),
  2128979029: (v) => new IFC4.IfcLinearMomentMeasure(v),
  1307019551: (v) => new IFC4.IfcLinearStiffnessMeasure(v),
  3086160713: (v) => new IFC4.IfcLinearVelocityMeasure(v),
  503418787: (v) => new IFC4.IfcLogical(v),
  2095003142: (v) => new IFC4.IfcLuminousFluxMeasure(v),
  2755797622: (v) => new IFC4.IfcLuminousIntensityDistributionMeasure(v),
  151039812: (v) => new IFC4.IfcLuminousIntensityMeasure(v),
  286949696: (v) => new IFC4.IfcMagneticFluxDensityMeasure(v),
  2486716878: (v) => new IFC4.IfcMagneticFluxMeasure(v),
  1477762836: (v) => new IFC4.IfcMassDensityMeasure(v),
  4017473158: (v) => new IFC4.IfcMassFlowRateMeasure(v),
  3124614049: (v) => new IFC4.IfcMassMeasure(v),
  3531705166: (v) => new IFC4.IfcMassPerLengthMeasure(v),
  3341486342: (v) => new IFC4.IfcModulusOfElasticityMeasure(v),
  2173214787: (v) => new IFC4.IfcModulusOfLinearSubgradeReactionMeasure(v),
  1052454078: (v) => new IFC4.IfcModulusOfRotationalSubgradeReactionMeasure(v),
  1753493141: (v) => new IFC4.IfcModulusOfSubgradeReactionMeasure(v),
  3177669450: (v) => new IFC4.IfcMoistureDiffusivityMeasure(v),
  1648970520: (v) => new IFC4.IfcMolecularWeightMeasure(v),
  3114022597: (v) => new IFC4.IfcMomentOfInertiaMeasure(v),
  2615040989: (v) => new IFC4.IfcMonetaryMeasure(v),
  765770214: (v) => new IFC4.IfcMonthInYearNumber(v),
  525895558: (v) => new IFC4.IfcNonNegativeLengthMeasure(v),
  2095195183: (v) => new IFC4.IfcNormalisedRatioMeasure(v),
  2395907400: (v) => new IFC4.IfcNumericMeasure(v),
  929793134: (v) => new IFC4.IfcPHMeasure(v),
  2260317790: (v) => new IFC4.IfcParameterValue(v),
  2642773653: (v) => new IFC4.IfcPlanarForceMeasure(v),
  4042175685: (v) => new IFC4.IfcPlaneAngleMeasure(v),
  1790229001: (v) => new IFC4.IfcPositiveInteger(v),
  2815919920: (v) => new IFC4.IfcPositiveLengthMeasure(v),
  3054510233: (v) => new IFC4.IfcPositivePlaneAngleMeasure(v),
  1245737093: (v) => new IFC4.IfcPositiveRatioMeasure(v),
  1364037233: (v) => new IFC4.IfcPowerMeasure(v),
  2169031380: (v) => new IFC4.IfcPresentableText(v),
  3665567075: (v) => new IFC4.IfcPressureMeasure(v),
  2798247006: (v) => new IFC4.IfcPropertySetDefinitionSet(v.map((x) => x.value)),
  3972513137: (v) => new IFC4.IfcRadioActivityMeasure(v),
  96294661: (v) => new IFC4.IfcRatioMeasure(v),
  200335297: (v) => new IFC4.IfcReal(v),
  2133746277: (v) => new IFC4.IfcRotationalFrequencyMeasure(v),
  1755127002: (v) => new IFC4.IfcRotationalMassMeasure(v),
  3211557302: (v) => new IFC4.IfcRotationalStiffnessMeasure(v),
  3467162246: (v) => new IFC4.IfcSectionModulusMeasure(v),
  2190458107: (v) => new IFC4.IfcSectionalAreaIntegralMeasure(v),
  408310005: (v) => new IFC4.IfcShearModulusMeasure(v),
  3471399674: (v) => new IFC4.IfcSolidAngleMeasure(v),
  4157543285: (v) => new IFC4.IfcSoundPowerLevelMeasure(v),
  846465480: (v) => new IFC4.IfcSoundPowerMeasure(v),
  3457685358: (v) => new IFC4.IfcSoundPressureLevelMeasure(v),
  993287707: (v) => new IFC4.IfcSoundPressureMeasure(v),
  3477203348: (v) => new IFC4.IfcSpecificHeatCapacityMeasure(v),
  2757832317: (v) => new IFC4.IfcSpecularExponent(v),
  361837227: (v) => new IFC4.IfcSpecularRoughness(v),
  58845555: (v) => new IFC4.IfcTemperatureGradientMeasure(v),
  1209108979: (v) => new IFC4.IfcTemperatureRateOfChangeMeasure(v),
  2801250643: (v) => new IFC4.IfcText(v),
  1460886941: (v) => new IFC4.IfcTextAlignment(v),
  3490877962: (v) => new IFC4.IfcTextDecoration(v),
  603696268: (v) => new IFC4.IfcTextFontName(v),
  296282323: (v) => new IFC4.IfcTextTransformation(v),
  232962298: (v) => new IFC4.IfcThermalAdmittanceMeasure(v),
  2645777649: (v) => new IFC4.IfcThermalConductivityMeasure(v),
  2281867870: (v) => new IFC4.IfcThermalExpansionCoefficientMeasure(v),
  857959152: (v) => new IFC4.IfcThermalResistanceMeasure(v),
  2016195849: (v) => new IFC4.IfcThermalTransmittanceMeasure(v),
  743184107: (v) => new IFC4.IfcThermodynamicTemperatureMeasure(v),
  4075327185: (v) => new IFC4.IfcTime(v),
  2726807636: (v) => new IFC4.IfcTimeMeasure(v),
  2591213694: (v) => new IFC4.IfcTimeStamp(v),
  1278329552: (v) => new IFC4.IfcTorqueMeasure(v),
  950732822: (v) => new IFC4.IfcURIReference(v),
  3345633955: (v) => new IFC4.IfcVaporPermeabilityMeasure(v),
  3458127941: (v) => new IFC4.IfcVolumeMeasure(v),
  2593997549: (v) => new IFC4.IfcVolumetricFlowRateMeasure(v),
  51269191: (v) => new IFC4.IfcWarpingConstantMeasure(v),
  1718600412: (v) => new IFC4.IfcWarpingMomentMeasure(v)
};
var IFC4;
((IFC42) => {
  class IfcAbsorbedDoseMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCABSORBEDDOSEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcAbsorbedDoseMeasure = IfcAbsorbedDoseMeasure;
  class IfcAccelerationMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCACCELERATIONMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcAccelerationMeasure = IfcAccelerationMeasure;
  class IfcAmountOfSubstanceMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCAMOUNTOFSUBSTANCEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcAmountOfSubstanceMeasure = IfcAmountOfSubstanceMeasure;
  class IfcAngularVelocityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCANGULARVELOCITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcAngularVelocityMeasure = IfcAngularVelocityMeasure;
  class IfcArcIndex {
    constructor(value) {
      this.value = value;
      this.type = 5;
    }
  }
  IFC42.IfcArcIndex = IfcArcIndex;
  ;
  class IfcAreaDensityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCAREADENSITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcAreaDensityMeasure = IfcAreaDensityMeasure;
  class IfcAreaMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCAREAMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcAreaMeasure = IfcAreaMeasure;
  class IfcBinary {
    constructor(v) {
      this.type = 4;
      this.name = "IFCBINARY";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcBinary = IfcBinary;
  class IfcBoolean {
    constructor(v) {
      this.type = 3;
      this.name = "IFCBOOLEAN";
      this.value = v === null ? v : v == "T" ? true : false;
    }
  }
  IFC42.IfcBoolean = IfcBoolean;
  class IfcBoxAlignment {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCBOXALIGNMENT";
    }
  }
  IFC42.IfcBoxAlignment = IfcBoxAlignment;
  class IfcCardinalPointReference {
    constructor(v) {
      this.type = 10;
      this.name = "IFCCARDINALPOINTREFERENCE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcCardinalPointReference = IfcCardinalPointReference;
  class IfcComplexNumber {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcComplexNumber = IfcComplexNumber;
  ;
  class IfcCompoundPlaneAngleMeasure {
    constructor(value) {
      this.value = value;
      this.type = 10;
    }
  }
  IFC42.IfcCompoundPlaneAngleMeasure = IfcCompoundPlaneAngleMeasure;
  ;
  class IfcContextDependentMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCCONTEXTDEPENDENTMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcContextDependentMeasure = IfcContextDependentMeasure;
  class IfcCountMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCCOUNTMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcCountMeasure = IfcCountMeasure;
  class IfcCurvatureMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCCURVATUREMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcCurvatureMeasure = IfcCurvatureMeasure;
  class IfcDate {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCDATE";
    }
  }
  IFC42.IfcDate = IfcDate;
  class IfcDateTime {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCDATETIME";
    }
  }
  IFC42.IfcDateTime = IfcDateTime;
  class IfcDayInMonthNumber {
    constructor(v) {
      this.type = 10;
      this.name = "IFCDAYINMONTHNUMBER";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcDayInMonthNumber = IfcDayInMonthNumber;
  class IfcDayInWeekNumber {
    constructor(v) {
      this.type = 10;
      this.name = "IFCDAYINWEEKNUMBER";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcDayInWeekNumber = IfcDayInWeekNumber;
  class IfcDescriptiveMeasure {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCDESCRIPTIVEMEASURE";
    }
  }
  IFC42.IfcDescriptiveMeasure = IfcDescriptiveMeasure;
  class IfcDimensionCount {
    constructor(v) {
      this.type = 10;
      this.name = "IFCDIMENSIONCOUNT";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcDimensionCount = IfcDimensionCount;
  class IfcDoseEquivalentMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCDOSEEQUIVALENTMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcDoseEquivalentMeasure = IfcDoseEquivalentMeasure;
  class IfcDuration {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCDURATION";
    }
  }
  IFC42.IfcDuration = IfcDuration;
  class IfcDynamicViscosityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCDYNAMICVISCOSITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcDynamicViscosityMeasure = IfcDynamicViscosityMeasure;
  class IfcElectricCapacitanceMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCELECTRICCAPACITANCEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcElectricCapacitanceMeasure = IfcElectricCapacitanceMeasure;
  class IfcElectricChargeMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCELECTRICCHARGEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcElectricChargeMeasure = IfcElectricChargeMeasure;
  class IfcElectricConductanceMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCELECTRICCONDUCTANCEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcElectricConductanceMeasure = IfcElectricConductanceMeasure;
  class IfcElectricCurrentMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCELECTRICCURRENTMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcElectricCurrentMeasure = IfcElectricCurrentMeasure;
  class IfcElectricResistanceMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCELECTRICRESISTANCEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcElectricResistanceMeasure = IfcElectricResistanceMeasure;
  class IfcElectricVoltageMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCELECTRICVOLTAGEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcElectricVoltageMeasure = IfcElectricVoltageMeasure;
  class IfcEnergyMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCENERGYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcEnergyMeasure = IfcEnergyMeasure;
  class IfcFontStyle {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCFONTSTYLE";
    }
  }
  IFC42.IfcFontStyle = IfcFontStyle;
  class IfcFontVariant {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCFONTVARIANT";
    }
  }
  IFC42.IfcFontVariant = IfcFontVariant;
  class IfcFontWeight {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCFONTWEIGHT";
    }
  }
  IFC42.IfcFontWeight = IfcFontWeight;
  class IfcForceMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCFORCEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcForceMeasure = IfcForceMeasure;
  class IfcFrequencyMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCFREQUENCYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcFrequencyMeasure = IfcFrequencyMeasure;
  class IfcGloballyUniqueId {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCGLOBALLYUNIQUEID";
    }
  }
  IFC42.IfcGloballyUniqueId = IfcGloballyUniqueId;
  class IfcHeatFluxDensityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCHEATFLUXDENSITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcHeatFluxDensityMeasure = IfcHeatFluxDensityMeasure;
  class IfcHeatingValueMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCHEATINGVALUEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcHeatingValueMeasure = IfcHeatingValueMeasure;
  class IfcIdentifier {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCIDENTIFIER";
    }
  }
  IFC42.IfcIdentifier = IfcIdentifier;
  class IfcIlluminanceMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCILLUMINANCEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcIlluminanceMeasure = IfcIlluminanceMeasure;
  class IfcInductanceMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCINDUCTANCEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcInductanceMeasure = IfcInductanceMeasure;
  class IfcInteger {
    constructor(v) {
      this.type = 10;
      this.name = "IFCINTEGER";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcInteger = IfcInteger;
  class IfcIntegerCountRateMeasure {
    constructor(v) {
      this.type = 10;
      this.name = "IFCINTEGERCOUNTRATEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcIntegerCountRateMeasure = IfcIntegerCountRateMeasure;
  class IfcIonConcentrationMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCIONCONCENTRATIONMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcIonConcentrationMeasure = IfcIonConcentrationMeasure;
  class IfcIsothermalMoistureCapacityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCISOTHERMALMOISTURECAPACITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcIsothermalMoistureCapacityMeasure = IfcIsothermalMoistureCapacityMeasure;
  class IfcKinematicViscosityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCKINEMATICVISCOSITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcKinematicViscosityMeasure = IfcKinematicViscosityMeasure;
  class IfcLabel {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCLABEL";
    }
  }
  IFC42.IfcLabel = IfcLabel;
  class IfcLanguageId {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCLANGUAGEID";
    }
  }
  IFC42.IfcLanguageId = IfcLanguageId;
  class IfcLengthMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCLENGTHMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcLengthMeasure = IfcLengthMeasure;
  class IfcLineIndex {
    constructor(value) {
      this.value = value;
      this.type = 5;
    }
  }
  IFC42.IfcLineIndex = IfcLineIndex;
  ;
  class IfcLinearForceMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCLINEARFORCEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcLinearForceMeasure = IfcLinearForceMeasure;
  class IfcLinearMomentMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCLINEARMOMENTMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcLinearMomentMeasure = IfcLinearMomentMeasure;
  class IfcLinearStiffnessMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCLINEARSTIFFNESSMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcLinearStiffnessMeasure = IfcLinearStiffnessMeasure;
  class IfcLinearVelocityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCLINEARVELOCITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcLinearVelocityMeasure = IfcLinearVelocityMeasure;
  class IfcLogical {
    constructor(v) {
      this.type = 3;
      this.name = "IFCLOGICAL";
      this.value = v === null ? v : v == "T" ? 1 /* TRUE */ : v == "F" ? 0 /* FALSE */ : 2 /* UNKNOWN */;
    }
  }
  IFC42.IfcLogical = IfcLogical;
  class IfcLuminousFluxMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCLUMINOUSFLUXMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcLuminousFluxMeasure = IfcLuminousFluxMeasure;
  class IfcLuminousIntensityDistributionMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCLUMINOUSINTENSITYDISTRIBUTIONMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcLuminousIntensityDistributionMeasure = IfcLuminousIntensityDistributionMeasure;
  class IfcLuminousIntensityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCLUMINOUSINTENSITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcLuminousIntensityMeasure = IfcLuminousIntensityMeasure;
  class IfcMagneticFluxDensityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMAGNETICFLUXDENSITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcMagneticFluxDensityMeasure = IfcMagneticFluxDensityMeasure;
  class IfcMagneticFluxMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMAGNETICFLUXMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcMagneticFluxMeasure = IfcMagneticFluxMeasure;
  class IfcMassDensityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMASSDENSITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcMassDensityMeasure = IfcMassDensityMeasure;
  class IfcMassFlowRateMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMASSFLOWRATEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcMassFlowRateMeasure = IfcMassFlowRateMeasure;
  class IfcMassMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMASSMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcMassMeasure = IfcMassMeasure;
  class IfcMassPerLengthMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMASSPERLENGTHMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcMassPerLengthMeasure = IfcMassPerLengthMeasure;
  class IfcModulusOfElasticityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMODULUSOFELASTICITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcModulusOfElasticityMeasure = IfcModulusOfElasticityMeasure;
  class IfcModulusOfLinearSubgradeReactionMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMODULUSOFLINEARSUBGRADEREACTIONMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcModulusOfLinearSubgradeReactionMeasure = IfcModulusOfLinearSubgradeReactionMeasure;
  class IfcModulusOfRotationalSubgradeReactionMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMODULUSOFROTATIONALSUBGRADEREACTIONMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcModulusOfRotationalSubgradeReactionMeasure = IfcModulusOfRotationalSubgradeReactionMeasure;
  class IfcModulusOfSubgradeReactionMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMODULUSOFSUBGRADEREACTIONMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcModulusOfSubgradeReactionMeasure = IfcModulusOfSubgradeReactionMeasure;
  class IfcMoistureDiffusivityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMOISTUREDIFFUSIVITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcMoistureDiffusivityMeasure = IfcMoistureDiffusivityMeasure;
  class IfcMolecularWeightMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMOLECULARWEIGHTMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcMolecularWeightMeasure = IfcMolecularWeightMeasure;
  class IfcMomentOfInertiaMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMOMENTOFINERTIAMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcMomentOfInertiaMeasure = IfcMomentOfInertiaMeasure;
  class IfcMonetaryMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMONETARYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcMonetaryMeasure = IfcMonetaryMeasure;
  class IfcMonthInYearNumber {
    constructor(v) {
      this.type = 10;
      this.name = "IFCMONTHINYEARNUMBER";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcMonthInYearNumber = IfcMonthInYearNumber;
  class IfcNonNegativeLengthMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCNONNEGATIVELENGTHMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcNonNegativeLengthMeasure = IfcNonNegativeLengthMeasure;
  class IfcNormalisedRatioMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCNORMALISEDRATIOMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcNormalisedRatioMeasure = IfcNormalisedRatioMeasure;
  class IfcNumericMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCNUMERICMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcNumericMeasure = IfcNumericMeasure;
  class IfcPHMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCPHMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcPHMeasure = IfcPHMeasure;
  class IfcParameterValue {
    constructor(v) {
      this.type = 4;
      this.name = "IFCPARAMETERVALUE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcParameterValue = IfcParameterValue;
  class IfcPlanarForceMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCPLANARFORCEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcPlanarForceMeasure = IfcPlanarForceMeasure;
  class IfcPlaneAngleMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCPLANEANGLEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcPlaneAngleMeasure = IfcPlaneAngleMeasure;
  class IfcPositiveInteger {
    constructor(v) {
      this.type = 10;
      this.name = "IFCPOSITIVEINTEGER";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcPositiveInteger = IfcPositiveInteger;
  class IfcPositiveLengthMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCPOSITIVELENGTHMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcPositiveLengthMeasure = IfcPositiveLengthMeasure;
  class IfcPositivePlaneAngleMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCPOSITIVEPLANEANGLEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcPositivePlaneAngleMeasure = IfcPositivePlaneAngleMeasure;
  class IfcPositiveRatioMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCPOSITIVERATIOMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcPositiveRatioMeasure = IfcPositiveRatioMeasure;
  class IfcPowerMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCPOWERMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcPowerMeasure = IfcPowerMeasure;
  class IfcPresentableText {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCPRESENTABLETEXT";
    }
  }
  IFC42.IfcPresentableText = IfcPresentableText;
  class IfcPressureMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCPRESSUREMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcPressureMeasure = IfcPressureMeasure;
  class IfcPropertySetDefinitionSet {
    constructor(value) {
      this.value = value;
      this.type = 5;
    }
  }
  IFC42.IfcPropertySetDefinitionSet = IfcPropertySetDefinitionSet;
  ;
  class IfcRadioActivityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCRADIOACTIVITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcRadioActivityMeasure = IfcRadioActivityMeasure;
  class IfcRatioMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCRATIOMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcRatioMeasure = IfcRatioMeasure;
  class IfcReal {
    constructor(v) {
      this.type = 4;
      this.name = "IFCREAL";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcReal = IfcReal;
  class IfcRotationalFrequencyMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCROTATIONALFREQUENCYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcRotationalFrequencyMeasure = IfcRotationalFrequencyMeasure;
  class IfcRotationalMassMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCROTATIONALMASSMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcRotationalMassMeasure = IfcRotationalMassMeasure;
  class IfcRotationalStiffnessMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCROTATIONALSTIFFNESSMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcRotationalStiffnessMeasure = IfcRotationalStiffnessMeasure;
  class IfcSectionModulusMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCSECTIONMODULUSMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcSectionModulusMeasure = IfcSectionModulusMeasure;
  class IfcSectionalAreaIntegralMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCSECTIONALAREAINTEGRALMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcSectionalAreaIntegralMeasure = IfcSectionalAreaIntegralMeasure;
  class IfcShearModulusMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCSHEARMODULUSMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcShearModulusMeasure = IfcShearModulusMeasure;
  class IfcSolidAngleMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCSOLIDANGLEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcSolidAngleMeasure = IfcSolidAngleMeasure;
  class IfcSoundPowerLevelMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCSOUNDPOWERLEVELMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcSoundPowerLevelMeasure = IfcSoundPowerLevelMeasure;
  class IfcSoundPowerMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCSOUNDPOWERMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcSoundPowerMeasure = IfcSoundPowerMeasure;
  class IfcSoundPressureLevelMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCSOUNDPRESSURELEVELMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcSoundPressureLevelMeasure = IfcSoundPressureLevelMeasure;
  class IfcSoundPressureMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCSOUNDPRESSUREMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcSoundPressureMeasure = IfcSoundPressureMeasure;
  class IfcSpecificHeatCapacityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCSPECIFICHEATCAPACITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcSpecificHeatCapacityMeasure = IfcSpecificHeatCapacityMeasure;
  class IfcSpecularExponent {
    constructor(v) {
      this.type = 4;
      this.name = "IFCSPECULAREXPONENT";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcSpecularExponent = IfcSpecularExponent;
  class IfcSpecularRoughness {
    constructor(v) {
      this.type = 4;
      this.name = "IFCSPECULARROUGHNESS";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcSpecularRoughness = IfcSpecularRoughness;
  class IfcTemperatureGradientMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCTEMPERATUREGRADIENTMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcTemperatureGradientMeasure = IfcTemperatureGradientMeasure;
  class IfcTemperatureRateOfChangeMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCTEMPERATURERATEOFCHANGEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcTemperatureRateOfChangeMeasure = IfcTemperatureRateOfChangeMeasure;
  class IfcText {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCTEXT";
    }
  }
  IFC42.IfcText = IfcText;
  class IfcTextAlignment {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCTEXTALIGNMENT";
    }
  }
  IFC42.IfcTextAlignment = IfcTextAlignment;
  class IfcTextDecoration {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCTEXTDECORATION";
    }
  }
  IFC42.IfcTextDecoration = IfcTextDecoration;
  class IfcTextFontName {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCTEXTFONTNAME";
    }
  }
  IFC42.IfcTextFontName = IfcTextFontName;
  class IfcTextTransformation {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCTEXTTRANSFORMATION";
    }
  }
  IFC42.IfcTextTransformation = IfcTextTransformation;
  class IfcThermalAdmittanceMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCTHERMALADMITTANCEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcThermalAdmittanceMeasure = IfcThermalAdmittanceMeasure;
  class IfcThermalConductivityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCTHERMALCONDUCTIVITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcThermalConductivityMeasure = IfcThermalConductivityMeasure;
  class IfcThermalExpansionCoefficientMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCTHERMALEXPANSIONCOEFFICIENTMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcThermalExpansionCoefficientMeasure = IfcThermalExpansionCoefficientMeasure;
  class IfcThermalResistanceMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCTHERMALRESISTANCEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcThermalResistanceMeasure = IfcThermalResistanceMeasure;
  class IfcThermalTransmittanceMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCTHERMALTRANSMITTANCEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcThermalTransmittanceMeasure = IfcThermalTransmittanceMeasure;
  class IfcThermodynamicTemperatureMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCTHERMODYNAMICTEMPERATUREMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcThermodynamicTemperatureMeasure = IfcThermodynamicTemperatureMeasure;
  class IfcTime {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCTIME";
    }
  }
  IFC42.IfcTime = IfcTime;
  class IfcTimeMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCTIMEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcTimeMeasure = IfcTimeMeasure;
  class IfcTimeStamp {
    constructor(v) {
      this.type = 10;
      this.name = "IFCTIMESTAMP";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcTimeStamp = IfcTimeStamp;
  class IfcTorqueMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCTORQUEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcTorqueMeasure = IfcTorqueMeasure;
  class IfcURIReference {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCURIREFERENCE";
    }
  }
  IFC42.IfcURIReference = IfcURIReference;
  class IfcVaporPermeabilityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCVAPORPERMEABILITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcVaporPermeabilityMeasure = IfcVaporPermeabilityMeasure;
  class IfcVolumeMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCVOLUMEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcVolumeMeasure = IfcVolumeMeasure;
  class IfcVolumetricFlowRateMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCVOLUMETRICFLOWRATEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcVolumetricFlowRateMeasure = IfcVolumetricFlowRateMeasure;
  class IfcWarpingConstantMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCWARPINGCONSTANTMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcWarpingConstantMeasure = IfcWarpingConstantMeasure;
  class IfcWarpingMomentMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCWARPINGMOMENTMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC42.IfcWarpingMomentMeasure = IfcWarpingMomentMeasure;
  class IfcActionRequestTypeEnum {
    static {
      this.EMAIL = { type: 3, value: "EMAIL" };
    }
    static {
      this.FAX = { type: 3, value: "FAX" };
    }
    static {
      this.PHONE = { type: 3, value: "PHONE" };
    }
    static {
      this.POST = { type: 3, value: "POST" };
    }
    static {
      this.VERBAL = { type: 3, value: "VERBAL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcActionRequestTypeEnum = IfcActionRequestTypeEnum;
  class IfcActionSourceTypeEnum {
    static {
      this.DEAD_LOAD_G = { type: 3, value: "DEAD_LOAD_G" };
    }
    static {
      this.COMPLETION_G1 = { type: 3, value: "COMPLETION_G1" };
    }
    static {
      this.LIVE_LOAD_Q = { type: 3, value: "LIVE_LOAD_Q" };
    }
    static {
      this.SNOW_S = { type: 3, value: "SNOW_S" };
    }
    static {
      this.WIND_W = { type: 3, value: "WIND_W" };
    }
    static {
      this.PRESTRESSING_P = { type: 3, value: "PRESTRESSING_P" };
    }
    static {
      this.SETTLEMENT_U = { type: 3, value: "SETTLEMENT_U" };
    }
    static {
      this.TEMPERATURE_T = { type: 3, value: "TEMPERATURE_T" };
    }
    static {
      this.EARTHQUAKE_E = { type: 3, value: "EARTHQUAKE_E" };
    }
    static {
      this.FIRE = { type: 3, value: "FIRE" };
    }
    static {
      this.IMPULSE = { type: 3, value: "IMPULSE" };
    }
    static {
      this.IMPACT = { type: 3, value: "IMPACT" };
    }
    static {
      this.TRANSPORT = { type: 3, value: "TRANSPORT" };
    }
    static {
      this.ERECTION = { type: 3, value: "ERECTION" };
    }
    static {
      this.PROPPING = { type: 3, value: "PROPPING" };
    }
    static {
      this.SYSTEM_IMPERFECTION = { type: 3, value: "SYSTEM_IMPERFECTION" };
    }
    static {
      this.SHRINKAGE = { type: 3, value: "SHRINKAGE" };
    }
    static {
      this.CREEP = { type: 3, value: "CREEP" };
    }
    static {
      this.LACK_OF_FIT = { type: 3, value: "LACK_OF_FIT" };
    }
    static {
      this.BUOYANCY = { type: 3, value: "BUOYANCY" };
    }
    static {
      this.ICE = { type: 3, value: "ICE" };
    }
    static {
      this.CURRENT = { type: 3, value: "CURRENT" };
    }
    static {
      this.WAVE = { type: 3, value: "WAVE" };
    }
    static {
      this.RAIN = { type: 3, value: "RAIN" };
    }
    static {
      this.BRAKES = { type: 3, value: "BRAKES" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcActionSourceTypeEnum = IfcActionSourceTypeEnum;
  class IfcActionTypeEnum {
    static {
      this.PERMANENT_G = { type: 3, value: "PERMANENT_G" };
    }
    static {
      this.VARIABLE_Q = { type: 3, value: "VARIABLE_Q" };
    }
    static {
      this.EXTRAORDINARY_A = { type: 3, value: "EXTRAORDINARY_A" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcActionTypeEnum = IfcActionTypeEnum;
  class IfcActuatorTypeEnum {
    static {
      this.ELECTRICACTUATOR = { type: 3, value: "ELECTRICACTUATOR" };
    }
    static {
      this.HANDOPERATEDACTUATOR = { type: 3, value: "HANDOPERATEDACTUATOR" };
    }
    static {
      this.HYDRAULICACTUATOR = { type: 3, value: "HYDRAULICACTUATOR" };
    }
    static {
      this.PNEUMATICACTUATOR = { type: 3, value: "PNEUMATICACTUATOR" };
    }
    static {
      this.THERMOSTATICACTUATOR = { type: 3, value: "THERMOSTATICACTUATOR" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcActuatorTypeEnum = IfcActuatorTypeEnum;
  class IfcAddressTypeEnum {
    static {
      this.OFFICE = { type: 3, value: "OFFICE" };
    }
    static {
      this.SITE = { type: 3, value: "SITE" };
    }
    static {
      this.HOME = { type: 3, value: "HOME" };
    }
    static {
      this.DISTRIBUTIONPOINT = { type: 3, value: "DISTRIBUTIONPOINT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
  }
  IFC42.IfcAddressTypeEnum = IfcAddressTypeEnum;
  class IfcAirTerminalBoxTypeEnum {
    static {
      this.CONSTANTFLOW = { type: 3, value: "CONSTANTFLOW" };
    }
    static {
      this.VARIABLEFLOWPRESSUREDEPENDANT = { type: 3, value: "VARIABLEFLOWPRESSUREDEPENDANT" };
    }
    static {
      this.VARIABLEFLOWPRESSUREINDEPENDANT = { type: 3, value: "VARIABLEFLOWPRESSUREINDEPENDANT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcAirTerminalBoxTypeEnum = IfcAirTerminalBoxTypeEnum;
  class IfcAirTerminalTypeEnum {
    static {
      this.DIFFUSER = { type: 3, value: "DIFFUSER" };
    }
    static {
      this.GRILLE = { type: 3, value: "GRILLE" };
    }
    static {
      this.LOUVRE = { type: 3, value: "LOUVRE" };
    }
    static {
      this.REGISTER = { type: 3, value: "REGISTER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcAirTerminalTypeEnum = IfcAirTerminalTypeEnum;
  class IfcAirToAirHeatRecoveryTypeEnum {
    static {
      this.FIXEDPLATECOUNTERFLOWEXCHANGER = { type: 3, value: "FIXEDPLATECOUNTERFLOWEXCHANGER" };
    }
    static {
      this.FIXEDPLATECROSSFLOWEXCHANGER = { type: 3, value: "FIXEDPLATECROSSFLOWEXCHANGER" };
    }
    static {
      this.FIXEDPLATEPARALLELFLOWEXCHANGER = { type: 3, value: "FIXEDPLATEPARALLELFLOWEXCHANGER" };
    }
    static {
      this.ROTARYWHEEL = { type: 3, value: "ROTARYWHEEL" };
    }
    static {
      this.RUNAROUNDCOILLOOP = { type: 3, value: "RUNAROUNDCOILLOOP" };
    }
    static {
      this.HEATPIPE = { type: 3, value: "HEATPIPE" };
    }
    static {
      this.TWINTOWERENTHALPYRECOVERYLOOPS = { type: 3, value: "TWINTOWERENTHALPYRECOVERYLOOPS" };
    }
    static {
      this.THERMOSIPHONSEALEDTUBEHEATEXCHANGERS = { type: 3, value: "THERMOSIPHONSEALEDTUBEHEATEXCHANGERS" };
    }
    static {
      this.THERMOSIPHONCOILTYPEHEATEXCHANGERS = { type: 3, value: "THERMOSIPHONCOILTYPEHEATEXCHANGERS" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcAirToAirHeatRecoveryTypeEnum = IfcAirToAirHeatRecoveryTypeEnum;
  class IfcAlarmTypeEnum {
    static {
      this.BELL = { type: 3, value: "BELL" };
    }
    static {
      this.BREAKGLASSBUTTON = { type: 3, value: "BREAKGLASSBUTTON" };
    }
    static {
      this.LIGHT = { type: 3, value: "LIGHT" };
    }
    static {
      this.MANUALPULLBOX = { type: 3, value: "MANUALPULLBOX" };
    }
    static {
      this.SIREN = { type: 3, value: "SIREN" };
    }
    static {
      this.WHISTLE = { type: 3, value: "WHISTLE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcAlarmTypeEnum = IfcAlarmTypeEnum;
  class IfcAnalysisModelTypeEnum {
    static {
      this.IN_PLANE_LOADING_2D = { type: 3, value: "IN_PLANE_LOADING_2D" };
    }
    static {
      this.OUT_PLANE_LOADING_2D = { type: 3, value: "OUT_PLANE_LOADING_2D" };
    }
    static {
      this.LOADING_3D = { type: 3, value: "LOADING_3D" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcAnalysisModelTypeEnum = IfcAnalysisModelTypeEnum;
  class IfcAnalysisTheoryTypeEnum {
    static {
      this.FIRST_ORDER_THEORY = { type: 3, value: "FIRST_ORDER_THEORY" };
    }
    static {
      this.SECOND_ORDER_THEORY = { type: 3, value: "SECOND_ORDER_THEORY" };
    }
    static {
      this.THIRD_ORDER_THEORY = { type: 3, value: "THIRD_ORDER_THEORY" };
    }
    static {
      this.FULL_NONLINEAR_THEORY = { type: 3, value: "FULL_NONLINEAR_THEORY" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcAnalysisTheoryTypeEnum = IfcAnalysisTheoryTypeEnum;
  class IfcArithmeticOperatorEnum {
    static {
      this.ADD = { type: 3, value: "ADD" };
    }
    static {
      this.DIVIDE = { type: 3, value: "DIVIDE" };
    }
    static {
      this.MULTIPLY = { type: 3, value: "MULTIPLY" };
    }
    static {
      this.SUBTRACT = { type: 3, value: "SUBTRACT" };
    }
  }
  IFC42.IfcArithmeticOperatorEnum = IfcArithmeticOperatorEnum;
  class IfcAssemblyPlaceEnum {
    static {
      this.SITE = { type: 3, value: "SITE" };
    }
    static {
      this.FACTORY = { type: 3, value: "FACTORY" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcAssemblyPlaceEnum = IfcAssemblyPlaceEnum;
  class IfcAudioVisualApplianceTypeEnum {
    static {
      this.AMPLIFIER = { type: 3, value: "AMPLIFIER" };
    }
    static {
      this.CAMERA = { type: 3, value: "CAMERA" };
    }
    static {
      this.DISPLAY = { type: 3, value: "DISPLAY" };
    }
    static {
      this.MICROPHONE = { type: 3, value: "MICROPHONE" };
    }
    static {
      this.PLAYER = { type: 3, value: "PLAYER" };
    }
    static {
      this.PROJECTOR = { type: 3, value: "PROJECTOR" };
    }
    static {
      this.RECEIVER = { type: 3, value: "RECEIVER" };
    }
    static {
      this.SPEAKER = { type: 3, value: "SPEAKER" };
    }
    static {
      this.SWITCHER = { type: 3, value: "SWITCHER" };
    }
    static {
      this.TELEPHONE = { type: 3, value: "TELEPHONE" };
    }
    static {
      this.TUNER = { type: 3, value: "TUNER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcAudioVisualApplianceTypeEnum = IfcAudioVisualApplianceTypeEnum;
  class IfcBSplineCurveForm {
    static {
      this.POLYLINE_FORM = { type: 3, value: "POLYLINE_FORM" };
    }
    static {
      this.CIRCULAR_ARC = { type: 3, value: "CIRCULAR_ARC" };
    }
    static {
      this.ELLIPTIC_ARC = { type: 3, value: "ELLIPTIC_ARC" };
    }
    static {
      this.PARABOLIC_ARC = { type: 3, value: "PARABOLIC_ARC" };
    }
    static {
      this.HYPERBOLIC_ARC = { type: 3, value: "HYPERBOLIC_ARC" };
    }
    static {
      this.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" };
    }
  }
  IFC42.IfcBSplineCurveForm = IfcBSplineCurveForm;
  class IfcBSplineSurfaceForm {
    static {
      this.PLANE_SURF = { type: 3, value: "PLANE_SURF" };
    }
    static {
      this.CYLINDRICAL_SURF = { type: 3, value: "CYLINDRICAL_SURF" };
    }
    static {
      this.CONICAL_SURF = { type: 3, value: "CONICAL_SURF" };
    }
    static {
      this.SPHERICAL_SURF = { type: 3, value: "SPHERICAL_SURF" };
    }
    static {
      this.TOROIDAL_SURF = { type: 3, value: "TOROIDAL_SURF" };
    }
    static {
      this.SURF_OF_REVOLUTION = { type: 3, value: "SURF_OF_REVOLUTION" };
    }
    static {
      this.RULED_SURF = { type: 3, value: "RULED_SURF" };
    }
    static {
      this.GENERALISED_CONE = { type: 3, value: "GENERALISED_CONE" };
    }
    static {
      this.QUADRIC_SURF = { type: 3, value: "QUADRIC_SURF" };
    }
    static {
      this.SURF_OF_LINEAR_EXTRUSION = { type: 3, value: "SURF_OF_LINEAR_EXTRUSION" };
    }
    static {
      this.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" };
    }
  }
  IFC42.IfcBSplineSurfaceForm = IfcBSplineSurfaceForm;
  class IfcBeamTypeEnum {
    static {
      this.BEAM = { type: 3, value: "BEAM" };
    }
    static {
      this.JOIST = { type: 3, value: "JOIST" };
    }
    static {
      this.HOLLOWCORE = { type: 3, value: "HOLLOWCORE" };
    }
    static {
      this.LINTEL = { type: 3, value: "LINTEL" };
    }
    static {
      this.SPANDREL = { type: 3, value: "SPANDREL" };
    }
    static {
      this.T_BEAM = { type: 3, value: "T_BEAM" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcBeamTypeEnum = IfcBeamTypeEnum;
  class IfcBenchmarkEnum {
    static {
      this.GREATERTHAN = { type: 3, value: "GREATERTHAN" };
    }
    static {
      this.GREATERTHANOREQUALTO = { type: 3, value: "GREATERTHANOREQUALTO" };
    }
    static {
      this.LESSTHAN = { type: 3, value: "LESSTHAN" };
    }
    static {
      this.LESSTHANOREQUALTO = { type: 3, value: "LESSTHANOREQUALTO" };
    }
    static {
      this.EQUALTO = { type: 3, value: "EQUALTO" };
    }
    static {
      this.NOTEQUALTO = { type: 3, value: "NOTEQUALTO" };
    }
    static {
      this.INCLUDES = { type: 3, value: "INCLUDES" };
    }
    static {
      this.NOTINCLUDES = { type: 3, value: "NOTINCLUDES" };
    }
    static {
      this.INCLUDEDIN = { type: 3, value: "INCLUDEDIN" };
    }
    static {
      this.NOTINCLUDEDIN = { type: 3, value: "NOTINCLUDEDIN" };
    }
  }
  IFC42.IfcBenchmarkEnum = IfcBenchmarkEnum;
  class IfcBoilerTypeEnum {
    static {
      this.WATER = { type: 3, value: "WATER" };
    }
    static {
      this.STEAM = { type: 3, value: "STEAM" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcBoilerTypeEnum = IfcBoilerTypeEnum;
  class IfcBooleanOperator {
    static {
      this.UNION = { type: 3, value: "UNION" };
    }
    static {
      this.INTERSECTION = { type: 3, value: "INTERSECTION" };
    }
    static {
      this.DIFFERENCE = { type: 3, value: "DIFFERENCE" };
    }
  }
  IFC42.IfcBooleanOperator = IfcBooleanOperator;
  class IfcBuildingElementPartTypeEnum {
    static {
      this.INSULATION = { type: 3, value: "INSULATION" };
    }
    static {
      this.PRECASTPANEL = { type: 3, value: "PRECASTPANEL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcBuildingElementPartTypeEnum = IfcBuildingElementPartTypeEnum;
  class IfcBuildingElementProxyTypeEnum {
    static {
      this.COMPLEX = { type: 3, value: "COMPLEX" };
    }
    static {
      this.ELEMENT = { type: 3, value: "ELEMENT" };
    }
    static {
      this.PARTIAL = { type: 3, value: "PARTIAL" };
    }
    static {
      this.PROVISIONFORVOID = { type: 3, value: "PROVISIONFORVOID" };
    }
    static {
      this.PROVISIONFORSPACE = { type: 3, value: "PROVISIONFORSPACE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcBuildingElementProxyTypeEnum = IfcBuildingElementProxyTypeEnum;
  class IfcBuildingSystemTypeEnum {
    static {
      this.FENESTRATION = { type: 3, value: "FENESTRATION" };
    }
    static {
      this.FOUNDATION = { type: 3, value: "FOUNDATION" };
    }
    static {
      this.LOADBEARING = { type: 3, value: "LOADBEARING" };
    }
    static {
      this.OUTERSHELL = { type: 3, value: "OUTERSHELL" };
    }
    static {
      this.SHADING = { type: 3, value: "SHADING" };
    }
    static {
      this.TRANSPORT = { type: 3, value: "TRANSPORT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcBuildingSystemTypeEnum = IfcBuildingSystemTypeEnum;
  class IfcBurnerTypeEnum {
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcBurnerTypeEnum = IfcBurnerTypeEnum;
  class IfcCableCarrierFittingTypeEnum {
    static {
      this.BEND = { type: 3, value: "BEND" };
    }
    static {
      this.CROSS = { type: 3, value: "CROSS" };
    }
    static {
      this.REDUCER = { type: 3, value: "REDUCER" };
    }
    static {
      this.TEE = { type: 3, value: "TEE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcCableCarrierFittingTypeEnum = IfcCableCarrierFittingTypeEnum;
  class IfcCableCarrierSegmentTypeEnum {
    static {
      this.CABLELADDERSEGMENT = { type: 3, value: "CABLELADDERSEGMENT" };
    }
    static {
      this.CABLETRAYSEGMENT = { type: 3, value: "CABLETRAYSEGMENT" };
    }
    static {
      this.CABLETRUNKINGSEGMENT = { type: 3, value: "CABLETRUNKINGSEGMENT" };
    }
    static {
      this.CONDUITSEGMENT = { type: 3, value: "CONDUITSEGMENT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcCableCarrierSegmentTypeEnum = IfcCableCarrierSegmentTypeEnum;
  class IfcCableFittingTypeEnum {
    static {
      this.CONNECTOR = { type: 3, value: "CONNECTOR" };
    }
    static {
      this.ENTRY = { type: 3, value: "ENTRY" };
    }
    static {
      this.EXIT = { type: 3, value: "EXIT" };
    }
    static {
      this.JUNCTION = { type: 3, value: "JUNCTION" };
    }
    static {
      this.TRANSITION = { type: 3, value: "TRANSITION" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcCableFittingTypeEnum = IfcCableFittingTypeEnum;
  class IfcCableSegmentTypeEnum {
    static {
      this.BUSBARSEGMENT = { type: 3, value: "BUSBARSEGMENT" };
    }
    static {
      this.CABLESEGMENT = { type: 3, value: "CABLESEGMENT" };
    }
    static {
      this.CONDUCTORSEGMENT = { type: 3, value: "CONDUCTORSEGMENT" };
    }
    static {
      this.CORESEGMENT = { type: 3, value: "CORESEGMENT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcCableSegmentTypeEnum = IfcCableSegmentTypeEnum;
  class IfcChangeActionEnum {
    static {
      this.NOCHANGE = { type: 3, value: "NOCHANGE" };
    }
    static {
      this.MODIFIED = { type: 3, value: "MODIFIED" };
    }
    static {
      this.ADDED = { type: 3, value: "ADDED" };
    }
    static {
      this.DELETED = { type: 3, value: "DELETED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcChangeActionEnum = IfcChangeActionEnum;
  class IfcChillerTypeEnum {
    static {
      this.AIRCOOLED = { type: 3, value: "AIRCOOLED" };
    }
    static {
      this.WATERCOOLED = { type: 3, value: "WATERCOOLED" };
    }
    static {
      this.HEATRECOVERY = { type: 3, value: "HEATRECOVERY" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcChillerTypeEnum = IfcChillerTypeEnum;
  class IfcChimneyTypeEnum {
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcChimneyTypeEnum = IfcChimneyTypeEnum;
  class IfcCoilTypeEnum {
    static {
      this.DXCOOLINGCOIL = { type: 3, value: "DXCOOLINGCOIL" };
    }
    static {
      this.ELECTRICHEATINGCOIL = { type: 3, value: "ELECTRICHEATINGCOIL" };
    }
    static {
      this.GASHEATINGCOIL = { type: 3, value: "GASHEATINGCOIL" };
    }
    static {
      this.HYDRONICCOIL = { type: 3, value: "HYDRONICCOIL" };
    }
    static {
      this.STEAMHEATINGCOIL = { type: 3, value: "STEAMHEATINGCOIL" };
    }
    static {
      this.WATERCOOLINGCOIL = { type: 3, value: "WATERCOOLINGCOIL" };
    }
    static {
      this.WATERHEATINGCOIL = { type: 3, value: "WATERHEATINGCOIL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcCoilTypeEnum = IfcCoilTypeEnum;
  class IfcColumnTypeEnum {
    static {
      this.COLUMN = { type: 3, value: "COLUMN" };
    }
    static {
      this.PILASTER = { type: 3, value: "PILASTER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcColumnTypeEnum = IfcColumnTypeEnum;
  class IfcCommunicationsApplianceTypeEnum {
    static {
      this.ANTENNA = { type: 3, value: "ANTENNA" };
    }
    static {
      this.COMPUTER = { type: 3, value: "COMPUTER" };
    }
    static {
      this.FAX = { type: 3, value: "FAX" };
    }
    static {
      this.GATEWAY = { type: 3, value: "GATEWAY" };
    }
    static {
      this.MODEM = { type: 3, value: "MODEM" };
    }
    static {
      this.NETWORKAPPLIANCE = { type: 3, value: "NETWORKAPPLIANCE" };
    }
    static {
      this.NETWORKBRIDGE = { type: 3, value: "NETWORKBRIDGE" };
    }
    static {
      this.NETWORKHUB = { type: 3, value: "NETWORKHUB" };
    }
    static {
      this.PRINTER = { type: 3, value: "PRINTER" };
    }
    static {
      this.REPEATER = { type: 3, value: "REPEATER" };
    }
    static {
      this.ROUTER = { type: 3, value: "ROUTER" };
    }
    static {
      this.SCANNER = { type: 3, value: "SCANNER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcCommunicationsApplianceTypeEnum = IfcCommunicationsApplianceTypeEnum;
  class IfcComplexPropertyTemplateTypeEnum {
    static {
      this.P_COMPLEX = { type: 3, value: "P_COMPLEX" };
    }
    static {
      this.Q_COMPLEX = { type: 3, value: "Q_COMPLEX" };
    }
  }
  IFC42.IfcComplexPropertyTemplateTypeEnum = IfcComplexPropertyTemplateTypeEnum;
  class IfcCompressorTypeEnum {
    static {
      this.DYNAMIC = { type: 3, value: "DYNAMIC" };
    }
    static {
      this.RECIPROCATING = { type: 3, value: "RECIPROCATING" };
    }
    static {
      this.ROTARY = { type: 3, value: "ROTARY" };
    }
    static {
      this.SCROLL = { type: 3, value: "SCROLL" };
    }
    static {
      this.TROCHOIDAL = { type: 3, value: "TROCHOIDAL" };
    }
    static {
      this.SINGLESTAGE = { type: 3, value: "SINGLESTAGE" };
    }
    static {
      this.BOOSTER = { type: 3, value: "BOOSTER" };
    }
    static {
      this.OPENTYPE = { type: 3, value: "OPENTYPE" };
    }
    static {
      this.HERMETIC = { type: 3, value: "HERMETIC" };
    }
    static {
      this.SEMIHERMETIC = { type: 3, value: "SEMIHERMETIC" };
    }
    static {
      this.WELDEDSHELLHERMETIC = { type: 3, value: "WELDEDSHELLHERMETIC" };
    }
    static {
      this.ROLLINGPISTON = { type: 3, value: "ROLLINGPISTON" };
    }
    static {
      this.ROTARYVANE = { type: 3, value: "ROTARYVANE" };
    }
    static {
      this.SINGLESCREW = { type: 3, value: "SINGLESCREW" };
    }
    static {
      this.TWINSCREW = { type: 3, value: "TWINSCREW" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcCompressorTypeEnum = IfcCompressorTypeEnum;
  class IfcCondenserTypeEnum {
    static {
      this.AIRCOOLED = { type: 3, value: "AIRCOOLED" };
    }
    static {
      this.EVAPORATIVECOOLED = { type: 3, value: "EVAPORATIVECOOLED" };
    }
    static {
      this.WATERCOOLED = { type: 3, value: "WATERCOOLED" };
    }
    static {
      this.WATERCOOLEDBRAZEDPLATE = { type: 3, value: "WATERCOOLEDBRAZEDPLATE" };
    }
    static {
      this.WATERCOOLEDSHELLCOIL = { type: 3, value: "WATERCOOLEDSHELLCOIL" };
    }
    static {
      this.WATERCOOLEDSHELLTUBE = { type: 3, value: "WATERCOOLEDSHELLTUBE" };
    }
    static {
      this.WATERCOOLEDTUBEINTUBE = { type: 3, value: "WATERCOOLEDTUBEINTUBE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcCondenserTypeEnum = IfcCondenserTypeEnum;
  class IfcConnectionTypeEnum {
    static {
      this.ATPATH = { type: 3, value: "ATPATH" };
    }
    static {
      this.ATSTART = { type: 3, value: "ATSTART" };
    }
    static {
      this.ATEND = { type: 3, value: "ATEND" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcConnectionTypeEnum = IfcConnectionTypeEnum;
  class IfcConstraintEnum {
    static {
      this.HARD = { type: 3, value: "HARD" };
    }
    static {
      this.SOFT = { type: 3, value: "SOFT" };
    }
    static {
      this.ADVISORY = { type: 3, value: "ADVISORY" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcConstraintEnum = IfcConstraintEnum;
  class IfcConstructionEquipmentResourceTypeEnum {
    static {
      this.DEMOLISHING = { type: 3, value: "DEMOLISHING" };
    }
    static {
      this.EARTHMOVING = { type: 3, value: "EARTHMOVING" };
    }
    static {
      this.ERECTING = { type: 3, value: "ERECTING" };
    }
    static {
      this.HEATING = { type: 3, value: "HEATING" };
    }
    static {
      this.LIGHTING = { type: 3, value: "LIGHTING" };
    }
    static {
      this.PAVING = { type: 3, value: "PAVING" };
    }
    static {
      this.PUMPING = { type: 3, value: "PUMPING" };
    }
    static {
      this.TRANSPORTING = { type: 3, value: "TRANSPORTING" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcConstructionEquipmentResourceTypeEnum = IfcConstructionEquipmentResourceTypeEnum;
  class IfcConstructionMaterialResourceTypeEnum {
    static {
      this.AGGREGATES = { type: 3, value: "AGGREGATES" };
    }
    static {
      this.CONCRETE = { type: 3, value: "CONCRETE" };
    }
    static {
      this.DRYWALL = { type: 3, value: "DRYWALL" };
    }
    static {
      this.FUEL = { type: 3, value: "FUEL" };
    }
    static {
      this.GYPSUM = { type: 3, value: "GYPSUM" };
    }
    static {
      this.MASONRY = { type: 3, value: "MASONRY" };
    }
    static {
      this.METAL = { type: 3, value: "METAL" };
    }
    static {
      this.PLASTIC = { type: 3, value: "PLASTIC" };
    }
    static {
      this.WOOD = { type: 3, value: "WOOD" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
  }
  IFC42.IfcConstructionMaterialResourceTypeEnum = IfcConstructionMaterialResourceTypeEnum;
  class IfcConstructionProductResourceTypeEnum {
    static {
      this.ASSEMBLY = { type: 3, value: "ASSEMBLY" };
    }
    static {
      this.FORMWORK = { type: 3, value: "FORMWORK" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcConstructionProductResourceTypeEnum = IfcConstructionProductResourceTypeEnum;
  class IfcControllerTypeEnum {
    static {
      this.FLOATING = { type: 3, value: "FLOATING" };
    }
    static {
      this.PROGRAMMABLE = { type: 3, value: "PROGRAMMABLE" };
    }
    static {
      this.PROPORTIONAL = { type: 3, value: "PROPORTIONAL" };
    }
    static {
      this.MULTIPOSITION = { type: 3, value: "MULTIPOSITION" };
    }
    static {
      this.TWOPOSITION = { type: 3, value: "TWOPOSITION" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcControllerTypeEnum = IfcControllerTypeEnum;
  class IfcCooledBeamTypeEnum {
    static {
      this.ACTIVE = { type: 3, value: "ACTIVE" };
    }
    static {
      this.PASSIVE = { type: 3, value: "PASSIVE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcCooledBeamTypeEnum = IfcCooledBeamTypeEnum;
  class IfcCoolingTowerTypeEnum {
    static {
      this.NATURALDRAFT = { type: 3, value: "NATURALDRAFT" };
    }
    static {
      this.MECHANICALINDUCEDDRAFT = { type: 3, value: "MECHANICALINDUCEDDRAFT" };
    }
    static {
      this.MECHANICALFORCEDDRAFT = { type: 3, value: "MECHANICALFORCEDDRAFT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcCoolingTowerTypeEnum = IfcCoolingTowerTypeEnum;
  class IfcCostItemTypeEnum {
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcCostItemTypeEnum = IfcCostItemTypeEnum;
  class IfcCostScheduleTypeEnum {
    static {
      this.BUDGET = { type: 3, value: "BUDGET" };
    }
    static {
      this.COSTPLAN = { type: 3, value: "COSTPLAN" };
    }
    static {
      this.ESTIMATE = { type: 3, value: "ESTIMATE" };
    }
    static {
      this.TENDER = { type: 3, value: "TENDER" };
    }
    static {
      this.PRICEDBILLOFQUANTITIES = { type: 3, value: "PRICEDBILLOFQUANTITIES" };
    }
    static {
      this.UNPRICEDBILLOFQUANTITIES = { type: 3, value: "UNPRICEDBILLOFQUANTITIES" };
    }
    static {
      this.SCHEDULEOFRATES = { type: 3, value: "SCHEDULEOFRATES" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcCostScheduleTypeEnum = IfcCostScheduleTypeEnum;
  class IfcCoveringTypeEnum {
    static {
      this.CEILING = { type: 3, value: "CEILING" };
    }
    static {
      this.FLOORING = { type: 3, value: "FLOORING" };
    }
    static {
      this.CLADDING = { type: 3, value: "CLADDING" };
    }
    static {
      this.ROOFING = { type: 3, value: "ROOFING" };
    }
    static {
      this.MOLDING = { type: 3, value: "MOLDING" };
    }
    static {
      this.SKIRTINGBOARD = { type: 3, value: "SKIRTINGBOARD" };
    }
    static {
      this.INSULATION = { type: 3, value: "INSULATION" };
    }
    static {
      this.MEMBRANE = { type: 3, value: "MEMBRANE" };
    }
    static {
      this.SLEEVING = { type: 3, value: "SLEEVING" };
    }
    static {
      this.WRAPPING = { type: 3, value: "WRAPPING" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcCoveringTypeEnum = IfcCoveringTypeEnum;
  class IfcCrewResourceTypeEnum {
    static {
      this.OFFICE = { type: 3, value: "OFFICE" };
    }
    static {
      this.SITE = { type: 3, value: "SITE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcCrewResourceTypeEnum = IfcCrewResourceTypeEnum;
  class IfcCurtainWallTypeEnum {
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcCurtainWallTypeEnum = IfcCurtainWallTypeEnum;
  class IfcCurveInterpolationEnum {
    static {
      this.LINEAR = { type: 3, value: "LINEAR" };
    }
    static {
      this.LOG_LINEAR = { type: 3, value: "LOG_LINEAR" };
    }
    static {
      this.LOG_LOG = { type: 3, value: "LOG_LOG" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcCurveInterpolationEnum = IfcCurveInterpolationEnum;
  class IfcDamperTypeEnum {
    static {
      this.BACKDRAFTDAMPER = { type: 3, value: "BACKDRAFTDAMPER" };
    }
    static {
      this.BALANCINGDAMPER = { type: 3, value: "BALANCINGDAMPER" };
    }
    static {
      this.BLASTDAMPER = { type: 3, value: "BLASTDAMPER" };
    }
    static {
      this.CONTROLDAMPER = { type: 3, value: "CONTROLDAMPER" };
    }
    static {
      this.FIREDAMPER = { type: 3, value: "FIREDAMPER" };
    }
    static {
      this.FIRESMOKEDAMPER = { type: 3, value: "FIRESMOKEDAMPER" };
    }
    static {
      this.FUMEHOODEXHAUST = { type: 3, value: "FUMEHOODEXHAUST" };
    }
    static {
      this.GRAVITYDAMPER = { type: 3, value: "GRAVITYDAMPER" };
    }
    static {
      this.GRAVITYRELIEFDAMPER = { type: 3, value: "GRAVITYRELIEFDAMPER" };
    }
    static {
      this.RELIEFDAMPER = { type: 3, value: "RELIEFDAMPER" };
    }
    static {
      this.SMOKEDAMPER = { type: 3, value: "SMOKEDAMPER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcDamperTypeEnum = IfcDamperTypeEnum;
  class IfcDataOriginEnum {
    static {
      this.MEASURED = { type: 3, value: "MEASURED" };
    }
    static {
      this.PREDICTED = { type: 3, value: "PREDICTED" };
    }
    static {
      this.SIMULATED = { type: 3, value: "SIMULATED" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcDataOriginEnum = IfcDataOriginEnum;
  class IfcDerivedUnitEnum {
    static {
      this.ANGULARVELOCITYUNIT = { type: 3, value: "ANGULARVELOCITYUNIT" };
    }
    static {
      this.AREADENSITYUNIT = { type: 3, value: "AREADENSITYUNIT" };
    }
    static {
      this.COMPOUNDPLANEANGLEUNIT = { type: 3, value: "COMPOUNDPLANEANGLEUNIT" };
    }
    static {
      this.DYNAMICVISCOSITYUNIT = { type: 3, value: "DYNAMICVISCOSITYUNIT" };
    }
    static {
      this.HEATFLUXDENSITYUNIT = { type: 3, value: "HEATFLUXDENSITYUNIT" };
    }
    static {
      this.INTEGERCOUNTRATEUNIT = { type: 3, value: "INTEGERCOUNTRATEUNIT" };
    }
    static {
      this.ISOTHERMALMOISTURECAPACITYUNIT = { type: 3, value: "ISOTHERMALMOISTURECAPACITYUNIT" };
    }
    static {
      this.KINEMATICVISCOSITYUNIT = { type: 3, value: "KINEMATICVISCOSITYUNIT" };
    }
    static {
      this.LINEARVELOCITYUNIT = { type: 3, value: "LINEARVELOCITYUNIT" };
    }
    static {
      this.MASSDENSITYUNIT = { type: 3, value: "MASSDENSITYUNIT" };
    }
    static {
      this.MASSFLOWRATEUNIT = { type: 3, value: "MASSFLOWRATEUNIT" };
    }
    static {
      this.MOISTUREDIFFUSIVITYUNIT = { type: 3, value: "MOISTUREDIFFUSIVITYUNIT" };
    }
    static {
      this.MOLECULARWEIGHTUNIT = { type: 3, value: "MOLECULARWEIGHTUNIT" };
    }
    static {
      this.SPECIFICHEATCAPACITYUNIT = { type: 3, value: "SPECIFICHEATCAPACITYUNIT" };
    }
    static {
      this.THERMALADMITTANCEUNIT = { type: 3, value: "THERMALADMITTANCEUNIT" };
    }
    static {
      this.THERMALCONDUCTANCEUNIT = { type: 3, value: "THERMALCONDUCTANCEUNIT" };
    }
    static {
      this.THERMALRESISTANCEUNIT = { type: 3, value: "THERMALRESISTANCEUNIT" };
    }
    static {
      this.THERMALTRANSMITTANCEUNIT = { type: 3, value: "THERMALTRANSMITTANCEUNIT" };
    }
    static {
      this.VAPORPERMEABILITYUNIT = { type: 3, value: "VAPORPERMEABILITYUNIT" };
    }
    static {
      this.VOLUMETRICFLOWRATEUNIT = { type: 3, value: "VOLUMETRICFLOWRATEUNIT" };
    }
    static {
      this.ROTATIONALFREQUENCYUNIT = { type: 3, value: "ROTATIONALFREQUENCYUNIT" };
    }
    static {
      this.TORQUEUNIT = { type: 3, value: "TORQUEUNIT" };
    }
    static {
      this.MOMENTOFINERTIAUNIT = { type: 3, value: "MOMENTOFINERTIAUNIT" };
    }
    static {
      this.LINEARMOMENTUNIT = { type: 3, value: "LINEARMOMENTUNIT" };
    }
    static {
      this.LINEARFORCEUNIT = { type: 3, value: "LINEARFORCEUNIT" };
    }
    static {
      this.PLANARFORCEUNIT = { type: 3, value: "PLANARFORCEUNIT" };
    }
    static {
      this.MODULUSOFELASTICITYUNIT = { type: 3, value: "MODULUSOFELASTICITYUNIT" };
    }
    static {
      this.SHEARMODULUSUNIT = { type: 3, value: "SHEARMODULUSUNIT" };
    }
    static {
      this.LINEARSTIFFNESSUNIT = { type: 3, value: "LINEARSTIFFNESSUNIT" };
    }
    static {
      this.ROTATIONALSTIFFNESSUNIT = { type: 3, value: "ROTATIONALSTIFFNESSUNIT" };
    }
    static {
      this.MODULUSOFSUBGRADEREACTIONUNIT = { type: 3, value: "MODULUSOFSUBGRADEREACTIONUNIT" };
    }
    static {
      this.ACCELERATIONUNIT = { type: 3, value: "ACCELERATIONUNIT" };
    }
    static {
      this.CURVATUREUNIT = { type: 3, value: "CURVATUREUNIT" };
    }
    static {
      this.HEATINGVALUEUNIT = { type: 3, value: "HEATINGVALUEUNIT" };
    }
    static {
      this.IONCONCENTRATIONUNIT = { type: 3, value: "IONCONCENTRATIONUNIT" };
    }
    static {
      this.LUMINOUSINTENSITYDISTRIBUTIONUNIT = { type: 3, value: "LUMINOUSINTENSITYDISTRIBUTIONUNIT" };
    }
    static {
      this.MASSPERLENGTHUNIT = { type: 3, value: "MASSPERLENGTHUNIT" };
    }
    static {
      this.MODULUSOFLINEARSUBGRADEREACTIONUNIT = { type: 3, value: "MODULUSOFLINEARSUBGRADEREACTIONUNIT" };
    }
    static {
      this.MODULUSOFROTATIONALSUBGRADEREACTIONUNIT = { type: 3, value: "MODULUSOFROTATIONALSUBGRADEREACTIONUNIT" };
    }
    static {
      this.PHUNIT = { type: 3, value: "PHUNIT" };
    }
    static {
      this.ROTATIONALMASSUNIT = { type: 3, value: "ROTATIONALMASSUNIT" };
    }
    static {
      this.SECTIONAREAINTEGRALUNIT = { type: 3, value: "SECTIONAREAINTEGRALUNIT" };
    }
    static {
      this.SECTIONMODULUSUNIT = { type: 3, value: "SECTIONMODULUSUNIT" };
    }
    static {
      this.SOUNDPOWERLEVELUNIT = { type: 3, value: "SOUNDPOWERLEVELUNIT" };
    }
    static {
      this.SOUNDPOWERUNIT = { type: 3, value: "SOUNDPOWERUNIT" };
    }
    static {
      this.SOUNDPRESSURELEVELUNIT = { type: 3, value: "SOUNDPRESSURELEVELUNIT" };
    }
    static {
      this.SOUNDPRESSUREUNIT = { type: 3, value: "SOUNDPRESSUREUNIT" };
    }
    static {
      this.TEMPERATUREGRADIENTUNIT = { type: 3, value: "TEMPERATUREGRADIENTUNIT" };
    }
    static {
      this.TEMPERATURERATEOFCHANGEUNIT = { type: 3, value: "TEMPERATURERATEOFCHANGEUNIT" };
    }
    static {
      this.THERMALEXPANSIONCOEFFICIENTUNIT = { type: 3, value: "THERMALEXPANSIONCOEFFICIENTUNIT" };
    }
    static {
      this.WARPINGCONSTANTUNIT = { type: 3, value: "WARPINGCONSTANTUNIT" };
    }
    static {
      this.WARPINGMOMENTUNIT = { type: 3, value: "WARPINGMOMENTUNIT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
  }
  IFC42.IfcDerivedUnitEnum = IfcDerivedUnitEnum;
  class IfcDirectionSenseEnum {
    static {
      this.POSITIVE = { type: 3, value: "POSITIVE" };
    }
    static {
      this.NEGATIVE = { type: 3, value: "NEGATIVE" };
    }
  }
  IFC42.IfcDirectionSenseEnum = IfcDirectionSenseEnum;
  class IfcDiscreteAccessoryTypeEnum {
    static {
      this.ANCHORPLATE = { type: 3, value: "ANCHORPLATE" };
    }
    static {
      this.BRACKET = { type: 3, value: "BRACKET" };
    }
    static {
      this.SHOE = { type: 3, value: "SHOE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcDiscreteAccessoryTypeEnum = IfcDiscreteAccessoryTypeEnum;
  class IfcDistributionChamberElementTypeEnum {
    static {
      this.FORMEDDUCT = { type: 3, value: "FORMEDDUCT" };
    }
    static {
      this.INSPECTIONCHAMBER = { type: 3, value: "INSPECTIONCHAMBER" };
    }
    static {
      this.INSPECTIONPIT = { type: 3, value: "INSPECTIONPIT" };
    }
    static {
      this.MANHOLE = { type: 3, value: "MANHOLE" };
    }
    static {
      this.METERCHAMBER = { type: 3, value: "METERCHAMBER" };
    }
    static {
      this.SUMP = { type: 3, value: "SUMP" };
    }
    static {
      this.TRENCH = { type: 3, value: "TRENCH" };
    }
    static {
      this.VALVECHAMBER = { type: 3, value: "VALVECHAMBER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcDistributionChamberElementTypeEnum = IfcDistributionChamberElementTypeEnum;
  class IfcDistributionPortTypeEnum {
    static {
      this.CABLE = { type: 3, value: "CABLE" };
    }
    static {
      this.CABLECARRIER = { type: 3, value: "CABLECARRIER" };
    }
    static {
      this.DUCT = { type: 3, value: "DUCT" };
    }
    static {
      this.PIPE = { type: 3, value: "PIPE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcDistributionPortTypeEnum = IfcDistributionPortTypeEnum;
  class IfcDistributionSystemEnum {
    static {
      this.AIRCONDITIONING = { type: 3, value: "AIRCONDITIONING" };
    }
    static {
      this.AUDIOVISUAL = { type: 3, value: "AUDIOVISUAL" };
    }
    static {
      this.CHEMICAL = { type: 3, value: "CHEMICAL" };
    }
    static {
      this.CHILLEDWATER = { type: 3, value: "CHILLEDWATER" };
    }
    static {
      this.COMMUNICATION = { type: 3, value: "COMMUNICATION" };
    }
    static {
      this.COMPRESSEDAIR = { type: 3, value: "COMPRESSEDAIR" };
    }
    static {
      this.CONDENSERWATER = { type: 3, value: "CONDENSERWATER" };
    }
    static {
      this.CONTROL = { type: 3, value: "CONTROL" };
    }
    static {
      this.CONVEYING = { type: 3, value: "CONVEYING" };
    }
    static {
      this.DATA = { type: 3, value: "DATA" };
    }
    static {
      this.DISPOSAL = { type: 3, value: "DISPOSAL" };
    }
    static {
      this.DOMESTICCOLDWATER = { type: 3, value: "DOMESTICCOLDWATER" };
    }
    static {
      this.DOMESTICHOTWATER = { type: 3, value: "DOMESTICHOTWATER" };
    }
    static {
      this.DRAINAGE = { type: 3, value: "DRAINAGE" };
    }
    static {
      this.EARTHING = { type: 3, value: "EARTHING" };
    }
    static {
      this.ELECTRICAL = { type: 3, value: "ELECTRICAL" };
    }
    static {
      this.ELECTROACOUSTIC = { type: 3, value: "ELECTROACOUSTIC" };
    }
    static {
      this.EXHAUST = { type: 3, value: "EXHAUST" };
    }
    static {
      this.FIREPROTECTION = { type: 3, value: "FIREPROTECTION" };
    }
    static {
      this.FUEL = { type: 3, value: "FUEL" };
    }
    static {
      this.GAS = { type: 3, value: "GAS" };
    }
    static {
      this.HAZARDOUS = { type: 3, value: "HAZARDOUS" };
    }
    static {
      this.HEATING = { type: 3, value: "HEATING" };
    }
    static {
      this.LIGHTING = { type: 3, value: "LIGHTING" };
    }
    static {
      this.LIGHTNINGPROTECTION = { type: 3, value: "LIGHTNINGPROTECTION" };
    }
    static {
      this.MUNICIPALSOLIDWASTE = { type: 3, value: "MUNICIPALSOLIDWASTE" };
    }
    static {
      this.OIL = { type: 3, value: "OIL" };
    }
    static {
      this.OPERATIONAL = { type: 3, value: "OPERATIONAL" };
    }
    static {
      this.POWERGENERATION = { type: 3, value: "POWERGENERATION" };
    }
    static {
      this.RAINWATER = { type: 3, value: "RAINWATER" };
    }
    static {
      this.REFRIGERATION = { type: 3, value: "REFRIGERATION" };
    }
    static {
      this.SECURITY = { type: 3, value: "SECURITY" };
    }
    static {
      this.SEWAGE = { type: 3, value: "SEWAGE" };
    }
    static {
      this.SIGNAL = { type: 3, value: "SIGNAL" };
    }
    static {
      this.STORMWATER = { type: 3, value: "STORMWATER" };
    }
    static {
      this.TELEPHONE = { type: 3, value: "TELEPHONE" };
    }
    static {
      this.TV = { type: 3, value: "TV" };
    }
    static {
      this.VACUUM = { type: 3, value: "VACUUM" };
    }
    static {
      this.VENT = { type: 3, value: "VENT" };
    }
    static {
      this.VENTILATION = { type: 3, value: "VENTILATION" };
    }
    static {
      this.WASTEWATER = { type: 3, value: "WASTEWATER" };
    }
    static {
      this.WATERSUPPLY = { type: 3, value: "WATERSUPPLY" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcDistributionSystemEnum = IfcDistributionSystemEnum;
  class IfcDocumentConfidentialityEnum {
    static {
      this.PUBLIC = { type: 3, value: "PUBLIC" };
    }
    static {
      this.RESTRICTED = { type: 3, value: "RESTRICTED" };
    }
    static {
      this.CONFIDENTIAL = { type: 3, value: "CONFIDENTIAL" };
    }
    static {
      this.PERSONAL = { type: 3, value: "PERSONAL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcDocumentConfidentialityEnum = IfcDocumentConfidentialityEnum;
  class IfcDocumentStatusEnum {
    static {
      this.DRAFT = { type: 3, value: "DRAFT" };
    }
    static {
      this.FINALDRAFT = { type: 3, value: "FINALDRAFT" };
    }
    static {
      this.FINAL = { type: 3, value: "FINAL" };
    }
    static {
      this.REVISION = { type: 3, value: "REVISION" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcDocumentStatusEnum = IfcDocumentStatusEnum;
  class IfcDoorPanelOperationEnum {
    static {
      this.SWINGING = { type: 3, value: "SWINGING" };
    }
    static {
      this.DOUBLE_ACTING = { type: 3, value: "DOUBLE_ACTING" };
    }
    static {
      this.SLIDING = { type: 3, value: "SLIDING" };
    }
    static {
      this.FOLDING = { type: 3, value: "FOLDING" };
    }
    static {
      this.REVOLVING = { type: 3, value: "REVOLVING" };
    }
    static {
      this.ROLLINGUP = { type: 3, value: "ROLLINGUP" };
    }
    static {
      this.FIXEDPANEL = { type: 3, value: "FIXEDPANEL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcDoorPanelOperationEnum = IfcDoorPanelOperationEnum;
  class IfcDoorPanelPositionEnum {
    static {
      this.LEFT = { type: 3, value: "LEFT" };
    }
    static {
      this.MIDDLE = { type: 3, value: "MIDDLE" };
    }
    static {
      this.RIGHT = { type: 3, value: "RIGHT" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcDoorPanelPositionEnum = IfcDoorPanelPositionEnum;
  class IfcDoorStyleConstructionEnum {
    static {
      this.ALUMINIUM = { type: 3, value: "ALUMINIUM" };
    }
    static {
      this.HIGH_GRADE_STEEL = { type: 3, value: "HIGH_GRADE_STEEL" };
    }
    static {
      this.STEEL = { type: 3, value: "STEEL" };
    }
    static {
      this.WOOD = { type: 3, value: "WOOD" };
    }
    static {
      this.ALUMINIUM_WOOD = { type: 3, value: "ALUMINIUM_WOOD" };
    }
    static {
      this.ALUMINIUM_PLASTIC = { type: 3, value: "ALUMINIUM_PLASTIC" };
    }
    static {
      this.PLASTIC = { type: 3, value: "PLASTIC" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcDoorStyleConstructionEnum = IfcDoorStyleConstructionEnum;
  class IfcDoorStyleOperationEnum {
    static {
      this.SINGLE_SWING_LEFT = { type: 3, value: "SINGLE_SWING_LEFT" };
    }
    static {
      this.SINGLE_SWING_RIGHT = { type: 3, value: "SINGLE_SWING_RIGHT" };
    }
    static {
      this.DOUBLE_DOOR_SINGLE_SWING = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING" };
    }
    static {
      this.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT" };
    }
    static {
      this.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT" };
    }
    static {
      this.DOUBLE_SWING_LEFT = { type: 3, value: "DOUBLE_SWING_LEFT" };
    }
    static {
      this.DOUBLE_SWING_RIGHT = { type: 3, value: "DOUBLE_SWING_RIGHT" };
    }
    static {
      this.DOUBLE_DOOR_DOUBLE_SWING = { type: 3, value: "DOUBLE_DOOR_DOUBLE_SWING" };
    }
    static {
      this.SLIDING_TO_LEFT = { type: 3, value: "SLIDING_TO_LEFT" };
    }
    static {
      this.SLIDING_TO_RIGHT = { type: 3, value: "SLIDING_TO_RIGHT" };
    }
    static {
      this.DOUBLE_DOOR_SLIDING = { type: 3, value: "DOUBLE_DOOR_SLIDING" };
    }
    static {
      this.FOLDING_TO_LEFT = { type: 3, value: "FOLDING_TO_LEFT" };
    }
    static {
      this.FOLDING_TO_RIGHT = { type: 3, value: "FOLDING_TO_RIGHT" };
    }
    static {
      this.DOUBLE_DOOR_FOLDING = { type: 3, value: "DOUBLE_DOOR_FOLDING" };
    }
    static {
      this.REVOLVING = { type: 3, value: "REVOLVING" };
    }
    static {
      this.ROLLINGUP = { type: 3, value: "ROLLINGUP" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcDoorStyleOperationEnum = IfcDoorStyleOperationEnum;
  class IfcDoorTypeEnum {
    static {
      this.DOOR = { type: 3, value: "DOOR" };
    }
    static {
      this.GATE = { type: 3, value: "GATE" };
    }
    static {
      this.TRAPDOOR = { type: 3, value: "TRAPDOOR" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcDoorTypeEnum = IfcDoorTypeEnum;
  class IfcDoorTypeOperationEnum {
    static {
      this.SINGLE_SWING_LEFT = { type: 3, value: "SINGLE_SWING_LEFT" };
    }
    static {
      this.SINGLE_SWING_RIGHT = { type: 3, value: "SINGLE_SWING_RIGHT" };
    }
    static {
      this.DOUBLE_DOOR_SINGLE_SWING = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING" };
    }
    static {
      this.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT" };
    }
    static {
      this.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT" };
    }
    static {
      this.DOUBLE_SWING_LEFT = { type: 3, value: "DOUBLE_SWING_LEFT" };
    }
    static {
      this.DOUBLE_SWING_RIGHT = { type: 3, value: "DOUBLE_SWING_RIGHT" };
    }
    static {
      this.DOUBLE_DOOR_DOUBLE_SWING = { type: 3, value: "DOUBLE_DOOR_DOUBLE_SWING" };
    }
    static {
      this.SLIDING_TO_LEFT = { type: 3, value: "SLIDING_TO_LEFT" };
    }
    static {
      this.SLIDING_TO_RIGHT = { type: 3, value: "SLIDING_TO_RIGHT" };
    }
    static {
      this.DOUBLE_DOOR_SLIDING = { type: 3, value: "DOUBLE_DOOR_SLIDING" };
    }
    static {
      this.FOLDING_TO_LEFT = { type: 3, value: "FOLDING_TO_LEFT" };
    }
    static {
      this.FOLDING_TO_RIGHT = { type: 3, value: "FOLDING_TO_RIGHT" };
    }
    static {
      this.DOUBLE_DOOR_FOLDING = { type: 3, value: "DOUBLE_DOOR_FOLDING" };
    }
    static {
      this.REVOLVING = { type: 3, value: "REVOLVING" };
    }
    static {
      this.ROLLINGUP = { type: 3, value: "ROLLINGUP" };
    }
    static {
      this.SWING_FIXED_LEFT = { type: 3, value: "SWING_FIXED_LEFT" };
    }
    static {
      this.SWING_FIXED_RIGHT = { type: 3, value: "SWING_FIXED_RIGHT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcDoorTypeOperationEnum = IfcDoorTypeOperationEnum;
  class IfcDuctFittingTypeEnum {
    static {
      this.BEND = { type: 3, value: "BEND" };
    }
    static {
      this.CONNECTOR = { type: 3, value: "CONNECTOR" };
    }
    static {
      this.ENTRY = { type: 3, value: "ENTRY" };
    }
    static {
      this.EXIT = { type: 3, value: "EXIT" };
    }
    static {
      this.JUNCTION = { type: 3, value: "JUNCTION" };
    }
    static {
      this.OBSTRUCTION = { type: 3, value: "OBSTRUCTION" };
    }
    static {
      this.TRANSITION = { type: 3, value: "TRANSITION" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcDuctFittingTypeEnum = IfcDuctFittingTypeEnum;
  class IfcDuctSegmentTypeEnum {
    static {
      this.RIGIDSEGMENT = { type: 3, value: "RIGIDSEGMENT" };
    }
    static {
      this.FLEXIBLESEGMENT = { type: 3, value: "FLEXIBLESEGMENT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcDuctSegmentTypeEnum = IfcDuctSegmentTypeEnum;
  class IfcDuctSilencerTypeEnum {
    static {
      this.FLATOVAL = { type: 3, value: "FLATOVAL" };
    }
    static {
      this.RECTANGULAR = { type: 3, value: "RECTANGULAR" };
    }
    static {
      this.ROUND = { type: 3, value: "ROUND" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcDuctSilencerTypeEnum = IfcDuctSilencerTypeEnum;
  class IfcElectricApplianceTypeEnum {
    static {
      this.DISHWASHER = { type: 3, value: "DISHWASHER" };
    }
    static {
      this.ELECTRICCOOKER = { type: 3, value: "ELECTRICCOOKER" };
    }
    static {
      this.FREESTANDINGELECTRICHEATER = { type: 3, value: "FREESTANDINGELECTRICHEATER" };
    }
    static {
      this.FREESTANDINGFAN = { type: 3, value: "FREESTANDINGFAN" };
    }
    static {
      this.FREESTANDINGWATERHEATER = { type: 3, value: "FREESTANDINGWATERHEATER" };
    }
    static {
      this.FREESTANDINGWATERCOOLER = { type: 3, value: "FREESTANDINGWATERCOOLER" };
    }
    static {
      this.FREEZER = { type: 3, value: "FREEZER" };
    }
    static {
      this.FRIDGE_FREEZER = { type: 3, value: "FRIDGE_FREEZER" };
    }
    static {
      this.HANDDRYER = { type: 3, value: "HANDDRYER" };
    }
    static {
      this.KITCHENMACHINE = { type: 3, value: "KITCHENMACHINE" };
    }
    static {
      this.MICROWAVE = { type: 3, value: "MICROWAVE" };
    }
    static {
      this.PHOTOCOPIER = { type: 3, value: "PHOTOCOPIER" };
    }
    static {
      this.REFRIGERATOR = { type: 3, value: "REFRIGERATOR" };
    }
    static {
      this.TUMBLEDRYER = { type: 3, value: "TUMBLEDRYER" };
    }
    static {
      this.VENDINGMACHINE = { type: 3, value: "VENDINGMACHINE" };
    }
    static {
      this.WASHINGMACHINE = { type: 3, value: "WASHINGMACHINE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcElectricApplianceTypeEnum = IfcElectricApplianceTypeEnum;
  class IfcElectricDistributionBoardTypeEnum {
    static {
      this.CONSUMERUNIT = { type: 3, value: "CONSUMERUNIT" };
    }
    static {
      this.DISTRIBUTIONBOARD = { type: 3, value: "DISTRIBUTIONBOARD" };
    }
    static {
      this.MOTORCONTROLCENTRE = { type: 3, value: "MOTORCONTROLCENTRE" };
    }
    static {
      this.SWITCHBOARD = { type: 3, value: "SWITCHBOARD" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcElectricDistributionBoardTypeEnum = IfcElectricDistributionBoardTypeEnum;
  class IfcElectricFlowStorageDeviceTypeEnum {
    static {
      this.BATTERY = { type: 3, value: "BATTERY" };
    }
    static {
      this.CAPACITORBANK = { type: 3, value: "CAPACITORBANK" };
    }
    static {
      this.HARMONICFILTER = { type: 3, value: "HARMONICFILTER" };
    }
    static {
      this.INDUCTORBANK = { type: 3, value: "INDUCTORBANK" };
    }
    static {
      this.UPS = { type: 3, value: "UPS" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcElectricFlowStorageDeviceTypeEnum = IfcElectricFlowStorageDeviceTypeEnum;
  class IfcElectricGeneratorTypeEnum {
    static {
      this.CHP = { type: 3, value: "CHP" };
    }
    static {
      this.ENGINEGENERATOR = { type: 3, value: "ENGINEGENERATOR" };
    }
    static {
      this.STANDALONE = { type: 3, value: "STANDALONE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcElectricGeneratorTypeEnum = IfcElectricGeneratorTypeEnum;
  class IfcElectricMotorTypeEnum {
    static {
      this.DC = { type: 3, value: "DC" };
    }
    static {
      this.INDUCTION = { type: 3, value: "INDUCTION" };
    }
    static {
      this.POLYPHASE = { type: 3, value: "POLYPHASE" };
    }
    static {
      this.RELUCTANCESYNCHRONOUS = { type: 3, value: "RELUCTANCESYNCHRONOUS" };
    }
    static {
      this.SYNCHRONOUS = { type: 3, value: "SYNCHRONOUS" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcElectricMotorTypeEnum = IfcElectricMotorTypeEnum;
  class IfcElectricTimeControlTypeEnum {
    static {
      this.TIMECLOCK = { type: 3, value: "TIMECLOCK" };
    }
    static {
      this.TIMEDELAY = { type: 3, value: "TIMEDELAY" };
    }
    static {
      this.RELAY = { type: 3, value: "RELAY" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcElectricTimeControlTypeEnum = IfcElectricTimeControlTypeEnum;
  class IfcElementAssemblyTypeEnum {
    static {
      this.ACCESSORY_ASSEMBLY = { type: 3, value: "ACCESSORY_ASSEMBLY" };
    }
    static {
      this.ARCH = { type: 3, value: "ARCH" };
    }
    static {
      this.BEAM_GRID = { type: 3, value: "BEAM_GRID" };
    }
    static {
      this.BRACED_FRAME = { type: 3, value: "BRACED_FRAME" };
    }
    static {
      this.GIRDER = { type: 3, value: "GIRDER" };
    }
    static {
      this.REINFORCEMENT_UNIT = { type: 3, value: "REINFORCEMENT_UNIT" };
    }
    static {
      this.RIGID_FRAME = { type: 3, value: "RIGID_FRAME" };
    }
    static {
      this.SLAB_FIELD = { type: 3, value: "SLAB_FIELD" };
    }
    static {
      this.TRUSS = { type: 3, value: "TRUSS" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcElementAssemblyTypeEnum = IfcElementAssemblyTypeEnum;
  class IfcElementCompositionEnum {
    static {
      this.COMPLEX = { type: 3, value: "COMPLEX" };
    }
    static {
      this.ELEMENT = { type: 3, value: "ELEMENT" };
    }
    static {
      this.PARTIAL = { type: 3, value: "PARTIAL" };
    }
  }
  IFC42.IfcElementCompositionEnum = IfcElementCompositionEnum;
  class IfcEngineTypeEnum {
    static {
      this.EXTERNALCOMBUSTION = { type: 3, value: "EXTERNALCOMBUSTION" };
    }
    static {
      this.INTERNALCOMBUSTION = { type: 3, value: "INTERNALCOMBUSTION" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcEngineTypeEnum = IfcEngineTypeEnum;
  class IfcEvaporativeCoolerTypeEnum {
    static {
      this.DIRECTEVAPORATIVERANDOMMEDIAAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVERANDOMMEDIAAIRCOOLER" };
    }
    static {
      this.DIRECTEVAPORATIVERIGIDMEDIAAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVERIGIDMEDIAAIRCOOLER" };
    }
    static {
      this.DIRECTEVAPORATIVESLINGERSPACKAGEDAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVESLINGERSPACKAGEDAIRCOOLER" };
    }
    static {
      this.DIRECTEVAPORATIVEPACKAGEDROTARYAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVEPACKAGEDROTARYAIRCOOLER" };
    }
    static {
      this.DIRECTEVAPORATIVEAIRWASHER = { type: 3, value: "DIRECTEVAPORATIVEAIRWASHER" };
    }
    static {
      this.INDIRECTEVAPORATIVEPACKAGEAIRCOOLER = { type: 3, value: "INDIRECTEVAPORATIVEPACKAGEAIRCOOLER" };
    }
    static {
      this.INDIRECTEVAPORATIVEWETCOIL = { type: 3, value: "INDIRECTEVAPORATIVEWETCOIL" };
    }
    static {
      this.INDIRECTEVAPORATIVECOOLINGTOWERORCOILCOOLER = { type: 3, value: "INDIRECTEVAPORATIVECOOLINGTOWERORCOILCOOLER" };
    }
    static {
      this.INDIRECTDIRECTCOMBINATION = { type: 3, value: "INDIRECTDIRECTCOMBINATION" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcEvaporativeCoolerTypeEnum = IfcEvaporativeCoolerTypeEnum;
  class IfcEvaporatorTypeEnum {
    static {
      this.DIRECTEXPANSION = { type: 3, value: "DIRECTEXPANSION" };
    }
    static {
      this.DIRECTEXPANSIONSHELLANDTUBE = { type: 3, value: "DIRECTEXPANSIONSHELLANDTUBE" };
    }
    static {
      this.DIRECTEXPANSIONTUBEINTUBE = { type: 3, value: "DIRECTEXPANSIONTUBEINTUBE" };
    }
    static {
      this.DIRECTEXPANSIONBRAZEDPLATE = { type: 3, value: "DIRECTEXPANSIONBRAZEDPLATE" };
    }
    static {
      this.FLOODEDSHELLANDTUBE = { type: 3, value: "FLOODEDSHELLANDTUBE" };
    }
    static {
      this.SHELLANDCOIL = { type: 3, value: "SHELLANDCOIL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcEvaporatorTypeEnum = IfcEvaporatorTypeEnum;
  class IfcEventTriggerTypeEnum {
    static {
      this.EVENTRULE = { type: 3, value: "EVENTRULE" };
    }
    static {
      this.EVENTMESSAGE = { type: 3, value: "EVENTMESSAGE" };
    }
    static {
      this.EVENTTIME = { type: 3, value: "EVENTTIME" };
    }
    static {
      this.EVENTCOMPLEX = { type: 3, value: "EVENTCOMPLEX" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcEventTriggerTypeEnum = IfcEventTriggerTypeEnum;
  class IfcEventTypeEnum {
    static {
      this.STARTEVENT = { type: 3, value: "STARTEVENT" };
    }
    static {
      this.ENDEVENT = { type: 3, value: "ENDEVENT" };
    }
    static {
      this.INTERMEDIATEEVENT = { type: 3, value: "INTERMEDIATEEVENT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcEventTypeEnum = IfcEventTypeEnum;
  class IfcExternalSpatialElementTypeEnum {
    static {
      this.EXTERNAL = { type: 3, value: "EXTERNAL" };
    }
    static {
      this.EXTERNAL_EARTH = { type: 3, value: "EXTERNAL_EARTH" };
    }
    static {
      this.EXTERNAL_WATER = { type: 3, value: "EXTERNAL_WATER" };
    }
    static {
      this.EXTERNAL_FIRE = { type: 3, value: "EXTERNAL_FIRE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcExternalSpatialElementTypeEnum = IfcExternalSpatialElementTypeEnum;
  class IfcFanTypeEnum {
    static {
      this.CENTRIFUGALFORWARDCURVED = { type: 3, value: "CENTRIFUGALFORWARDCURVED" };
    }
    static {
      this.CENTRIFUGALRADIAL = { type: 3, value: "CENTRIFUGALRADIAL" };
    }
    static {
      this.CENTRIFUGALBACKWARDINCLINEDCURVED = { type: 3, value: "CENTRIFUGALBACKWARDINCLINEDCURVED" };
    }
    static {
      this.CENTRIFUGALAIRFOIL = { type: 3, value: "CENTRIFUGALAIRFOIL" };
    }
    static {
      this.TUBEAXIAL = { type: 3, value: "TUBEAXIAL" };
    }
    static {
      this.VANEAXIAL = { type: 3, value: "VANEAXIAL" };
    }
    static {
      this.PROPELLORAXIAL = { type: 3, value: "PROPELLORAXIAL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcFanTypeEnum = IfcFanTypeEnum;
  class IfcFastenerTypeEnum {
    static {
      this.GLUE = { type: 3, value: "GLUE" };
    }
    static {
      this.MORTAR = { type: 3, value: "MORTAR" };
    }
    static {
      this.WELD = { type: 3, value: "WELD" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcFastenerTypeEnum = IfcFastenerTypeEnum;
  class IfcFilterTypeEnum {
    static {
      this.AIRPARTICLEFILTER = { type: 3, value: "AIRPARTICLEFILTER" };
    }
    static {
      this.COMPRESSEDAIRFILTER = { type: 3, value: "COMPRESSEDAIRFILTER" };
    }
    static {
      this.ODORFILTER = { type: 3, value: "ODORFILTER" };
    }
    static {
      this.OILFILTER = { type: 3, value: "OILFILTER" };
    }
    static {
      this.STRAINER = { type: 3, value: "STRAINER" };
    }
    static {
      this.WATERFILTER = { type: 3, value: "WATERFILTER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcFilterTypeEnum = IfcFilterTypeEnum;
  class IfcFireSuppressionTerminalTypeEnum {
    static {
      this.BREECHINGINLET = { type: 3, value: "BREECHINGINLET" };
    }
    static {
      this.FIREHYDRANT = { type: 3, value: "FIREHYDRANT" };
    }
    static {
      this.HOSEREEL = { type: 3, value: "HOSEREEL" };
    }
    static {
      this.SPRINKLER = { type: 3, value: "SPRINKLER" };
    }
    static {
      this.SPRINKLERDEFLECTOR = { type: 3, value: "SPRINKLERDEFLECTOR" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcFireSuppressionTerminalTypeEnum = IfcFireSuppressionTerminalTypeEnum;
  class IfcFlowDirectionEnum {
    static {
      this.SOURCE = { type: 3, value: "SOURCE" };
    }
    static {
      this.SINK = { type: 3, value: "SINK" };
    }
    static {
      this.SOURCEANDSINK = { type: 3, value: "SOURCEANDSINK" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcFlowDirectionEnum = IfcFlowDirectionEnum;
  class IfcFlowInstrumentTypeEnum {
    static {
      this.PRESSUREGAUGE = { type: 3, value: "PRESSUREGAUGE" };
    }
    static {
      this.THERMOMETER = { type: 3, value: "THERMOMETER" };
    }
    static {
      this.AMMETER = { type: 3, value: "AMMETER" };
    }
    static {
      this.FREQUENCYMETER = { type: 3, value: "FREQUENCYMETER" };
    }
    static {
      this.POWERFACTORMETER = { type: 3, value: "POWERFACTORMETER" };
    }
    static {
      this.PHASEANGLEMETER = { type: 3, value: "PHASEANGLEMETER" };
    }
    static {
      this.VOLTMETER_PEAK = { type: 3, value: "VOLTMETER_PEAK" };
    }
    static {
      this.VOLTMETER_RMS = { type: 3, value: "VOLTMETER_RMS" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcFlowInstrumentTypeEnum = IfcFlowInstrumentTypeEnum;
  class IfcFlowMeterTypeEnum {
    static {
      this.ENERGYMETER = { type: 3, value: "ENERGYMETER" };
    }
    static {
      this.GASMETER = { type: 3, value: "GASMETER" };
    }
    static {
      this.OILMETER = { type: 3, value: "OILMETER" };
    }
    static {
      this.WATERMETER = { type: 3, value: "WATERMETER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcFlowMeterTypeEnum = IfcFlowMeterTypeEnum;
  class IfcFootingTypeEnum {
    static {
      this.CAISSON_FOUNDATION = { type: 3, value: "CAISSON_FOUNDATION" };
    }
    static {
      this.FOOTING_BEAM = { type: 3, value: "FOOTING_BEAM" };
    }
    static {
      this.PAD_FOOTING = { type: 3, value: "PAD_FOOTING" };
    }
    static {
      this.PILE_CAP = { type: 3, value: "PILE_CAP" };
    }
    static {
      this.STRIP_FOOTING = { type: 3, value: "STRIP_FOOTING" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcFootingTypeEnum = IfcFootingTypeEnum;
  class IfcFurnitureTypeEnum {
    static {
      this.CHAIR = { type: 3, value: "CHAIR" };
    }
    static {
      this.TABLE = { type: 3, value: "TABLE" };
    }
    static {
      this.DESK = { type: 3, value: "DESK" };
    }
    static {
      this.BED = { type: 3, value: "BED" };
    }
    static {
      this.FILECABINET = { type: 3, value: "FILECABINET" };
    }
    static {
      this.SHELF = { type: 3, value: "SHELF" };
    }
    static {
      this.SOFA = { type: 3, value: "SOFA" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcFurnitureTypeEnum = IfcFurnitureTypeEnum;
  class IfcGeographicElementTypeEnum {
    static {
      this.TERRAIN = { type: 3, value: "TERRAIN" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcGeographicElementTypeEnum = IfcGeographicElementTypeEnum;
  class IfcGeometricProjectionEnum {
    static {
      this.GRAPH_VIEW = { type: 3, value: "GRAPH_VIEW" };
    }
    static {
      this.SKETCH_VIEW = { type: 3, value: "SKETCH_VIEW" };
    }
    static {
      this.MODEL_VIEW = { type: 3, value: "MODEL_VIEW" };
    }
    static {
      this.PLAN_VIEW = { type: 3, value: "PLAN_VIEW" };
    }
    static {
      this.REFLECTED_PLAN_VIEW = { type: 3, value: "REFLECTED_PLAN_VIEW" };
    }
    static {
      this.SECTION_VIEW = { type: 3, value: "SECTION_VIEW" };
    }
    static {
      this.ELEVATION_VIEW = { type: 3, value: "ELEVATION_VIEW" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcGeometricProjectionEnum = IfcGeometricProjectionEnum;
  class IfcGlobalOrLocalEnum {
    static {
      this.GLOBAL_COORDS = { type: 3, value: "GLOBAL_COORDS" };
    }
    static {
      this.LOCAL_COORDS = { type: 3, value: "LOCAL_COORDS" };
    }
  }
  IFC42.IfcGlobalOrLocalEnum = IfcGlobalOrLocalEnum;
  class IfcGridTypeEnum {
    static {
      this.RECTANGULAR = { type: 3, value: "RECTANGULAR" };
    }
    static {
      this.RADIAL = { type: 3, value: "RADIAL" };
    }
    static {
      this.TRIANGULAR = { type: 3, value: "TRIANGULAR" };
    }
    static {
      this.IRREGULAR = { type: 3, value: "IRREGULAR" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcGridTypeEnum = IfcGridTypeEnum;
  class IfcHeatExchangerTypeEnum {
    static {
      this.PLATE = { type: 3, value: "PLATE" };
    }
    static {
      this.SHELLANDTUBE = { type: 3, value: "SHELLANDTUBE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcHeatExchangerTypeEnum = IfcHeatExchangerTypeEnum;
  class IfcHumidifierTypeEnum {
    static {
      this.STEAMINJECTION = { type: 3, value: "STEAMINJECTION" };
    }
    static {
      this.ADIABATICAIRWASHER = { type: 3, value: "ADIABATICAIRWASHER" };
    }
    static {
      this.ADIABATICPAN = { type: 3, value: "ADIABATICPAN" };
    }
    static {
      this.ADIABATICWETTEDELEMENT = { type: 3, value: "ADIABATICWETTEDELEMENT" };
    }
    static {
      this.ADIABATICATOMIZING = { type: 3, value: "ADIABATICATOMIZING" };
    }
    static {
      this.ADIABATICULTRASONIC = { type: 3, value: "ADIABATICULTRASONIC" };
    }
    static {
      this.ADIABATICRIGIDMEDIA = { type: 3, value: "ADIABATICRIGIDMEDIA" };
    }
    static {
      this.ADIABATICCOMPRESSEDAIRNOZZLE = { type: 3, value: "ADIABATICCOMPRESSEDAIRNOZZLE" };
    }
    static {
      this.ASSISTEDELECTRIC = { type: 3, value: "ASSISTEDELECTRIC" };
    }
    static {
      this.ASSISTEDNATURALGAS = { type: 3, value: "ASSISTEDNATURALGAS" };
    }
    static {
      this.ASSISTEDPROPANE = { type: 3, value: "ASSISTEDPROPANE" };
    }
    static {
      this.ASSISTEDBUTANE = { type: 3, value: "ASSISTEDBUTANE" };
    }
    static {
      this.ASSISTEDSTEAM = { type: 3, value: "ASSISTEDSTEAM" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcHumidifierTypeEnum = IfcHumidifierTypeEnum;
  class IfcInterceptorTypeEnum {
    static {
      this.CYCLONIC = { type: 3, value: "CYCLONIC" };
    }
    static {
      this.GREASE = { type: 3, value: "GREASE" };
    }
    static {
      this.OIL = { type: 3, value: "OIL" };
    }
    static {
      this.PETROL = { type: 3, value: "PETROL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcInterceptorTypeEnum = IfcInterceptorTypeEnum;
  class IfcInternalOrExternalEnum {
    static {
      this.INTERNAL = { type: 3, value: "INTERNAL" };
    }
    static {
      this.EXTERNAL = { type: 3, value: "EXTERNAL" };
    }
    static {
      this.EXTERNAL_EARTH = { type: 3, value: "EXTERNAL_EARTH" };
    }
    static {
      this.EXTERNAL_WATER = { type: 3, value: "EXTERNAL_WATER" };
    }
    static {
      this.EXTERNAL_FIRE = { type: 3, value: "EXTERNAL_FIRE" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcInternalOrExternalEnum = IfcInternalOrExternalEnum;
  class IfcInventoryTypeEnum {
    static {
      this.ASSETINVENTORY = { type: 3, value: "ASSETINVENTORY" };
    }
    static {
      this.SPACEINVENTORY = { type: 3, value: "SPACEINVENTORY" };
    }
    static {
      this.FURNITUREINVENTORY = { type: 3, value: "FURNITUREINVENTORY" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcInventoryTypeEnum = IfcInventoryTypeEnum;
  class IfcJunctionBoxTypeEnum {
    static {
      this.DATA = { type: 3, value: "DATA" };
    }
    static {
      this.POWER = { type: 3, value: "POWER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcJunctionBoxTypeEnum = IfcJunctionBoxTypeEnum;
  class IfcKnotType {
    static {
      this.UNIFORM_KNOTS = { type: 3, value: "UNIFORM_KNOTS" };
    }
    static {
      this.QUASI_UNIFORM_KNOTS = { type: 3, value: "QUASI_UNIFORM_KNOTS" };
    }
    static {
      this.PIECEWISE_BEZIER_KNOTS = { type: 3, value: "PIECEWISE_BEZIER_KNOTS" };
    }
    static {
      this.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" };
    }
  }
  IFC42.IfcKnotType = IfcKnotType;
  class IfcLaborResourceTypeEnum {
    static {
      this.ADMINISTRATION = { type: 3, value: "ADMINISTRATION" };
    }
    static {
      this.CARPENTRY = { type: 3, value: "CARPENTRY" };
    }
    static {
      this.CLEANING = { type: 3, value: "CLEANING" };
    }
    static {
      this.CONCRETE = { type: 3, value: "CONCRETE" };
    }
    static {
      this.DRYWALL = { type: 3, value: "DRYWALL" };
    }
    static {
      this.ELECTRIC = { type: 3, value: "ELECTRIC" };
    }
    static {
      this.FINISHING = { type: 3, value: "FINISHING" };
    }
    static {
      this.FLOORING = { type: 3, value: "FLOORING" };
    }
    static {
      this.GENERAL = { type: 3, value: "GENERAL" };
    }
    static {
      this.HVAC = { type: 3, value: "HVAC" };
    }
    static {
      this.LANDSCAPING = { type: 3, value: "LANDSCAPING" };
    }
    static {
      this.MASONRY = { type: 3, value: "MASONRY" };
    }
    static {
      this.PAINTING = { type: 3, value: "PAINTING" };
    }
    static {
      this.PAVING = { type: 3, value: "PAVING" };
    }
    static {
      this.PLUMBING = { type: 3, value: "PLUMBING" };
    }
    static {
      this.ROOFING = { type: 3, value: "ROOFING" };
    }
    static {
      this.SITEGRADING = { type: 3, value: "SITEGRADING" };
    }
    static {
      this.STEELWORK = { type: 3, value: "STEELWORK" };
    }
    static {
      this.SURVEYING = { type: 3, value: "SURVEYING" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcLaborResourceTypeEnum = IfcLaborResourceTypeEnum;
  class IfcLampTypeEnum {
    static {
      this.COMPACTFLUORESCENT = { type: 3, value: "COMPACTFLUORESCENT" };
    }
    static {
      this.FLUORESCENT = { type: 3, value: "FLUORESCENT" };
    }
    static {
      this.HALOGEN = { type: 3, value: "HALOGEN" };
    }
    static {
      this.HIGHPRESSUREMERCURY = { type: 3, value: "HIGHPRESSUREMERCURY" };
    }
    static {
      this.HIGHPRESSURESODIUM = { type: 3, value: "HIGHPRESSURESODIUM" };
    }
    static {
      this.LED = { type: 3, value: "LED" };
    }
    static {
      this.METALHALIDE = { type: 3, value: "METALHALIDE" };
    }
    static {
      this.OLED = { type: 3, value: "OLED" };
    }
    static {
      this.TUNGSTENFILAMENT = { type: 3, value: "TUNGSTENFILAMENT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcLampTypeEnum = IfcLampTypeEnum;
  class IfcLayerSetDirectionEnum {
    static {
      this.AXIS1 = { type: 3, value: "AXIS1" };
    }
    static {
      this.AXIS2 = { type: 3, value: "AXIS2" };
    }
    static {
      this.AXIS3 = { type: 3, value: "AXIS3" };
    }
  }
  IFC42.IfcLayerSetDirectionEnum = IfcLayerSetDirectionEnum;
  class IfcLightDistributionCurveEnum {
    static {
      this.TYPE_A = { type: 3, value: "TYPE_A" };
    }
    static {
      this.TYPE_B = { type: 3, value: "TYPE_B" };
    }
    static {
      this.TYPE_C = { type: 3, value: "TYPE_C" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcLightDistributionCurveEnum = IfcLightDistributionCurveEnum;
  class IfcLightEmissionSourceEnum {
    static {
      this.COMPACTFLUORESCENT = { type: 3, value: "COMPACTFLUORESCENT" };
    }
    static {
      this.FLUORESCENT = { type: 3, value: "FLUORESCENT" };
    }
    static {
      this.HIGHPRESSUREMERCURY = { type: 3, value: "HIGHPRESSUREMERCURY" };
    }
    static {
      this.HIGHPRESSURESODIUM = { type: 3, value: "HIGHPRESSURESODIUM" };
    }
    static {
      this.LIGHTEMITTINGDIODE = { type: 3, value: "LIGHTEMITTINGDIODE" };
    }
    static {
      this.LOWPRESSURESODIUM = { type: 3, value: "LOWPRESSURESODIUM" };
    }
    static {
      this.LOWVOLTAGEHALOGEN = { type: 3, value: "LOWVOLTAGEHALOGEN" };
    }
    static {
      this.MAINVOLTAGEHALOGEN = { type: 3, value: "MAINVOLTAGEHALOGEN" };
    }
    static {
      this.METALHALIDE = { type: 3, value: "METALHALIDE" };
    }
    static {
      this.TUNGSTENFILAMENT = { type: 3, value: "TUNGSTENFILAMENT" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcLightEmissionSourceEnum = IfcLightEmissionSourceEnum;
  class IfcLightFixtureTypeEnum {
    static {
      this.POINTSOURCE = { type: 3, value: "POINTSOURCE" };
    }
    static {
      this.DIRECTIONSOURCE = { type: 3, value: "DIRECTIONSOURCE" };
    }
    static {
      this.SECURITYLIGHTING = { type: 3, value: "SECURITYLIGHTING" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcLightFixtureTypeEnum = IfcLightFixtureTypeEnum;
  class IfcLoadGroupTypeEnum {
    static {
      this.LOAD_GROUP = { type: 3, value: "LOAD_GROUP" };
    }
    static {
      this.LOAD_CASE = { type: 3, value: "LOAD_CASE" };
    }
    static {
      this.LOAD_COMBINATION = { type: 3, value: "LOAD_COMBINATION" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcLoadGroupTypeEnum = IfcLoadGroupTypeEnum;
  class IfcLogicalOperatorEnum {
    static {
      this.LOGICALAND = { type: 3, value: "LOGICALAND" };
    }
    static {
      this.LOGICALOR = { type: 3, value: "LOGICALOR" };
    }
    static {
      this.LOGICALXOR = { type: 3, value: "LOGICALXOR" };
    }
    static {
      this.LOGICALNOTAND = { type: 3, value: "LOGICALNOTAND" };
    }
    static {
      this.LOGICALNOTOR = { type: 3, value: "LOGICALNOTOR" };
    }
  }
  IFC42.IfcLogicalOperatorEnum = IfcLogicalOperatorEnum;
  class IfcMechanicalFastenerTypeEnum {
    static {
      this.ANCHORBOLT = { type: 3, value: "ANCHORBOLT" };
    }
    static {
      this.BOLT = { type: 3, value: "BOLT" };
    }
    static {
      this.DOWEL = { type: 3, value: "DOWEL" };
    }
    static {
      this.NAIL = { type: 3, value: "NAIL" };
    }
    static {
      this.NAILPLATE = { type: 3, value: "NAILPLATE" };
    }
    static {
      this.RIVET = { type: 3, value: "RIVET" };
    }
    static {
      this.SCREW = { type: 3, value: "SCREW" };
    }
    static {
      this.SHEARCONNECTOR = { type: 3, value: "SHEARCONNECTOR" };
    }
    static {
      this.STAPLE = { type: 3, value: "STAPLE" };
    }
    static {
      this.STUDSHEARCONNECTOR = { type: 3, value: "STUDSHEARCONNECTOR" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcMechanicalFastenerTypeEnum = IfcMechanicalFastenerTypeEnum;
  class IfcMedicalDeviceTypeEnum {
    static {
      this.AIRSTATION = { type: 3, value: "AIRSTATION" };
    }
    static {
      this.FEEDAIRUNIT = { type: 3, value: "FEEDAIRUNIT" };
    }
    static {
      this.OXYGENGENERATOR = { type: 3, value: "OXYGENGENERATOR" };
    }
    static {
      this.OXYGENPLANT = { type: 3, value: "OXYGENPLANT" };
    }
    static {
      this.VACUUMSTATION = { type: 3, value: "VACUUMSTATION" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcMedicalDeviceTypeEnum = IfcMedicalDeviceTypeEnum;
  class IfcMemberTypeEnum {
    static {
      this.BRACE = { type: 3, value: "BRACE" };
    }
    static {
      this.CHORD = { type: 3, value: "CHORD" };
    }
    static {
      this.COLLAR = { type: 3, value: "COLLAR" };
    }
    static {
      this.MEMBER = { type: 3, value: "MEMBER" };
    }
    static {
      this.MULLION = { type: 3, value: "MULLION" };
    }
    static {
      this.PLATE = { type: 3, value: "PLATE" };
    }
    static {
      this.POST = { type: 3, value: "POST" };
    }
    static {
      this.PURLIN = { type: 3, value: "PURLIN" };
    }
    static {
      this.RAFTER = { type: 3, value: "RAFTER" };
    }
    static {
      this.STRINGER = { type: 3, value: "STRINGER" };
    }
    static {
      this.STRUT = { type: 3, value: "STRUT" };
    }
    static {
      this.STUD = { type: 3, value: "STUD" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcMemberTypeEnum = IfcMemberTypeEnum;
  class IfcMotorConnectionTypeEnum {
    static {
      this.BELTDRIVE = { type: 3, value: "BELTDRIVE" };
    }
    static {
      this.COUPLING = { type: 3, value: "COUPLING" };
    }
    static {
      this.DIRECTDRIVE = { type: 3, value: "DIRECTDRIVE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcMotorConnectionTypeEnum = IfcMotorConnectionTypeEnum;
  class IfcNullStyle {
    static {
      this.NULL = { type: 3, value: "NULL" };
    }
  }
  IFC42.IfcNullStyle = IfcNullStyle;
  class IfcObjectTypeEnum {
    static {
      this.PRODUCT = { type: 3, value: "PRODUCT" };
    }
    static {
      this.PROCESS = { type: 3, value: "PROCESS" };
    }
    static {
      this.CONTROL = { type: 3, value: "CONTROL" };
    }
    static {
      this.RESOURCE = { type: 3, value: "RESOURCE" };
    }
    static {
      this.ACTOR = { type: 3, value: "ACTOR" };
    }
    static {
      this.GROUP = { type: 3, value: "GROUP" };
    }
    static {
      this.PROJECT = { type: 3, value: "PROJECT" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcObjectTypeEnum = IfcObjectTypeEnum;
  class IfcObjectiveEnum {
    static {
      this.CODECOMPLIANCE = { type: 3, value: "CODECOMPLIANCE" };
    }
    static {
      this.CODEWAIVER = { type: 3, value: "CODEWAIVER" };
    }
    static {
      this.DESIGNINTENT = { type: 3, value: "DESIGNINTENT" };
    }
    static {
      this.EXTERNAL = { type: 3, value: "EXTERNAL" };
    }
    static {
      this.HEALTHANDSAFETY = { type: 3, value: "HEALTHANDSAFETY" };
    }
    static {
      this.MERGECONFLICT = { type: 3, value: "MERGECONFLICT" };
    }
    static {
      this.MODELVIEW = { type: 3, value: "MODELVIEW" };
    }
    static {
      this.PARAMETER = { type: 3, value: "PARAMETER" };
    }
    static {
      this.REQUIREMENT = { type: 3, value: "REQUIREMENT" };
    }
    static {
      this.SPECIFICATION = { type: 3, value: "SPECIFICATION" };
    }
    static {
      this.TRIGGERCONDITION = { type: 3, value: "TRIGGERCONDITION" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcObjectiveEnum = IfcObjectiveEnum;
  class IfcOccupantTypeEnum {
    static {
      this.ASSIGNEE = { type: 3, value: "ASSIGNEE" };
    }
    static {
      this.ASSIGNOR = { type: 3, value: "ASSIGNOR" };
    }
    static {
      this.LESSEE = { type: 3, value: "LESSEE" };
    }
    static {
      this.LESSOR = { type: 3, value: "LESSOR" };
    }
    static {
      this.LETTINGAGENT = { type: 3, value: "LETTINGAGENT" };
    }
    static {
      this.OWNER = { type: 3, value: "OWNER" };
    }
    static {
      this.TENANT = { type: 3, value: "TENANT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcOccupantTypeEnum = IfcOccupantTypeEnum;
  class IfcOpeningElementTypeEnum {
    static {
      this.OPENING = { type: 3, value: "OPENING" };
    }
    static {
      this.RECESS = { type: 3, value: "RECESS" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcOpeningElementTypeEnum = IfcOpeningElementTypeEnum;
  class IfcOutletTypeEnum {
    static {
      this.AUDIOVISUALOUTLET = { type: 3, value: "AUDIOVISUALOUTLET" };
    }
    static {
      this.COMMUNICATIONSOUTLET = { type: 3, value: "COMMUNICATIONSOUTLET" };
    }
    static {
      this.POWEROUTLET = { type: 3, value: "POWEROUTLET" };
    }
    static {
      this.DATAOUTLET = { type: 3, value: "DATAOUTLET" };
    }
    static {
      this.TELEPHONEOUTLET = { type: 3, value: "TELEPHONEOUTLET" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcOutletTypeEnum = IfcOutletTypeEnum;
  class IfcPerformanceHistoryTypeEnum {
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcPerformanceHistoryTypeEnum = IfcPerformanceHistoryTypeEnum;
  class IfcPermeableCoveringOperationEnum {
    static {
      this.GRILL = { type: 3, value: "GRILL" };
    }
    static {
      this.LOUVER = { type: 3, value: "LOUVER" };
    }
    static {
      this.SCREEN = { type: 3, value: "SCREEN" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcPermeableCoveringOperationEnum = IfcPermeableCoveringOperationEnum;
  class IfcPermitTypeEnum {
    static {
      this.ACCESS = { type: 3, value: "ACCESS" };
    }
    static {
      this.BUILDING = { type: 3, value: "BUILDING" };
    }
    static {
      this.WORK = { type: 3, value: "WORK" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcPermitTypeEnum = IfcPermitTypeEnum;
  class IfcPhysicalOrVirtualEnum {
    static {
      this.PHYSICAL = { type: 3, value: "PHYSICAL" };
    }
    static {
      this.VIRTUAL = { type: 3, value: "VIRTUAL" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcPhysicalOrVirtualEnum = IfcPhysicalOrVirtualEnum;
  class IfcPileConstructionEnum {
    static {
      this.CAST_IN_PLACE = { type: 3, value: "CAST_IN_PLACE" };
    }
    static {
      this.COMPOSITE = { type: 3, value: "COMPOSITE" };
    }
    static {
      this.PRECAST_CONCRETE = { type: 3, value: "PRECAST_CONCRETE" };
    }
    static {
      this.PREFAB_STEEL = { type: 3, value: "PREFAB_STEEL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcPileConstructionEnum = IfcPileConstructionEnum;
  class IfcPileTypeEnum {
    static {
      this.BORED = { type: 3, value: "BORED" };
    }
    static {
      this.DRIVEN = { type: 3, value: "DRIVEN" };
    }
    static {
      this.JETGROUTING = { type: 3, value: "JETGROUTING" };
    }
    static {
      this.COHESION = { type: 3, value: "COHESION" };
    }
    static {
      this.FRICTION = { type: 3, value: "FRICTION" };
    }
    static {
      this.SUPPORT = { type: 3, value: "SUPPORT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcPileTypeEnum = IfcPileTypeEnum;
  class IfcPipeFittingTypeEnum {
    static {
      this.BEND = { type: 3, value: "BEND" };
    }
    static {
      this.CONNECTOR = { type: 3, value: "CONNECTOR" };
    }
    static {
      this.ENTRY = { type: 3, value: "ENTRY" };
    }
    static {
      this.EXIT = { type: 3, value: "EXIT" };
    }
    static {
      this.JUNCTION = { type: 3, value: "JUNCTION" };
    }
    static {
      this.OBSTRUCTION = { type: 3, value: "OBSTRUCTION" };
    }
    static {
      this.TRANSITION = { type: 3, value: "TRANSITION" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcPipeFittingTypeEnum = IfcPipeFittingTypeEnum;
  class IfcPipeSegmentTypeEnum {
    static {
      this.CULVERT = { type: 3, value: "CULVERT" };
    }
    static {
      this.FLEXIBLESEGMENT = { type: 3, value: "FLEXIBLESEGMENT" };
    }
    static {
      this.RIGIDSEGMENT = { type: 3, value: "RIGIDSEGMENT" };
    }
    static {
      this.GUTTER = { type: 3, value: "GUTTER" };
    }
    static {
      this.SPOOL = { type: 3, value: "SPOOL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcPipeSegmentTypeEnum = IfcPipeSegmentTypeEnum;
  class IfcPlateTypeEnum {
    static {
      this.CURTAIN_PANEL = { type: 3, value: "CURTAIN_PANEL" };
    }
    static {
      this.SHEET = { type: 3, value: "SHEET" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcPlateTypeEnum = IfcPlateTypeEnum;
  class IfcPreferredSurfaceCurveRepresentation {
    static {
      this.CURVE3D = { type: 3, value: "CURVE3D" };
    }
    static {
      this.PCURVE_S1 = { type: 3, value: "PCURVE_S1" };
    }
    static {
      this.PCURVE_S2 = { type: 3, value: "PCURVE_S2" };
    }
  }
  IFC42.IfcPreferredSurfaceCurveRepresentation = IfcPreferredSurfaceCurveRepresentation;
  class IfcProcedureTypeEnum {
    static {
      this.ADVICE_CAUTION = { type: 3, value: "ADVICE_CAUTION" };
    }
    static {
      this.ADVICE_NOTE = { type: 3, value: "ADVICE_NOTE" };
    }
    static {
      this.ADVICE_WARNING = { type: 3, value: "ADVICE_WARNING" };
    }
    static {
      this.CALIBRATION = { type: 3, value: "CALIBRATION" };
    }
    static {
      this.DIAGNOSTIC = { type: 3, value: "DIAGNOSTIC" };
    }
    static {
      this.SHUTDOWN = { type: 3, value: "SHUTDOWN" };
    }
    static {
      this.STARTUP = { type: 3, value: "STARTUP" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcProcedureTypeEnum = IfcProcedureTypeEnum;
  class IfcProfileTypeEnum {
    static {
      this.CURVE = { type: 3, value: "CURVE" };
    }
    static {
      this.AREA = { type: 3, value: "AREA" };
    }
  }
  IFC42.IfcProfileTypeEnum = IfcProfileTypeEnum;
  class IfcProjectOrderTypeEnum {
    static {
      this.CHANGEORDER = { type: 3, value: "CHANGEORDER" };
    }
    static {
      this.MAINTENANCEWORKORDER = { type: 3, value: "MAINTENANCEWORKORDER" };
    }
    static {
      this.MOVEORDER = { type: 3, value: "MOVEORDER" };
    }
    static {
      this.PURCHASEORDER = { type: 3, value: "PURCHASEORDER" };
    }
    static {
      this.WORKORDER = { type: 3, value: "WORKORDER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcProjectOrderTypeEnum = IfcProjectOrderTypeEnum;
  class IfcProjectedOrTrueLengthEnum {
    static {
      this.PROJECTED_LENGTH = { type: 3, value: "PROJECTED_LENGTH" };
    }
    static {
      this.TRUE_LENGTH = { type: 3, value: "TRUE_LENGTH" };
    }
  }
  IFC42.IfcProjectedOrTrueLengthEnum = IfcProjectedOrTrueLengthEnum;
  class IfcProjectionElementTypeEnum {
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcProjectionElementTypeEnum = IfcProjectionElementTypeEnum;
  class IfcPropertySetTemplateTypeEnum {
    static {
      this.PSET_TYPEDRIVENONLY = { type: 3, value: "PSET_TYPEDRIVENONLY" };
    }
    static {
      this.PSET_TYPEDRIVENOVERRIDE = { type: 3, value: "PSET_TYPEDRIVENOVERRIDE" };
    }
    static {
      this.PSET_OCCURRENCEDRIVEN = { type: 3, value: "PSET_OCCURRENCEDRIVEN" };
    }
    static {
      this.PSET_PERFORMANCEDRIVEN = { type: 3, value: "PSET_PERFORMANCEDRIVEN" };
    }
    static {
      this.QTO_TYPEDRIVENONLY = { type: 3, value: "QTO_TYPEDRIVENONLY" };
    }
    static {
      this.QTO_TYPEDRIVENOVERRIDE = { type: 3, value: "QTO_TYPEDRIVENOVERRIDE" };
    }
    static {
      this.QTO_OCCURRENCEDRIVEN = { type: 3, value: "QTO_OCCURRENCEDRIVEN" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcPropertySetTemplateTypeEnum = IfcPropertySetTemplateTypeEnum;
  class IfcProtectiveDeviceTrippingUnitTypeEnum {
    static {
      this.ELECTRONIC = { type: 3, value: "ELECTRONIC" };
    }
    static {
      this.ELECTROMAGNETIC = { type: 3, value: "ELECTROMAGNETIC" };
    }
    static {
      this.RESIDUALCURRENT = { type: 3, value: "RESIDUALCURRENT" };
    }
    static {
      this.THERMAL = { type: 3, value: "THERMAL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcProtectiveDeviceTrippingUnitTypeEnum = IfcProtectiveDeviceTrippingUnitTypeEnum;
  class IfcProtectiveDeviceTypeEnum {
    static {
      this.CIRCUITBREAKER = { type: 3, value: "CIRCUITBREAKER" };
    }
    static {
      this.EARTHLEAKAGECIRCUITBREAKER = { type: 3, value: "EARTHLEAKAGECIRCUITBREAKER" };
    }
    static {
      this.EARTHINGSWITCH = { type: 3, value: "EARTHINGSWITCH" };
    }
    static {
      this.FUSEDISCONNECTOR = { type: 3, value: "FUSEDISCONNECTOR" };
    }
    static {
      this.RESIDUALCURRENTCIRCUITBREAKER = { type: 3, value: "RESIDUALCURRENTCIRCUITBREAKER" };
    }
    static {
      this.RESIDUALCURRENTSWITCH = { type: 3, value: "RESIDUALCURRENTSWITCH" };
    }
    static {
      this.VARISTOR = { type: 3, value: "VARISTOR" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcProtectiveDeviceTypeEnum = IfcProtectiveDeviceTypeEnum;
  class IfcPumpTypeEnum {
    static {
      this.CIRCULATOR = { type: 3, value: "CIRCULATOR" };
    }
    static {
      this.ENDSUCTION = { type: 3, value: "ENDSUCTION" };
    }
    static {
      this.SPLITCASE = { type: 3, value: "SPLITCASE" };
    }
    static {
      this.SUBMERSIBLEPUMP = { type: 3, value: "SUBMERSIBLEPUMP" };
    }
    static {
      this.SUMPPUMP = { type: 3, value: "SUMPPUMP" };
    }
    static {
      this.VERTICALINLINE = { type: 3, value: "VERTICALINLINE" };
    }
    static {
      this.VERTICALTURBINE = { type: 3, value: "VERTICALTURBINE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcPumpTypeEnum = IfcPumpTypeEnum;
  class IfcRailingTypeEnum {
    static {
      this.HANDRAIL = { type: 3, value: "HANDRAIL" };
    }
    static {
      this.GUARDRAIL = { type: 3, value: "GUARDRAIL" };
    }
    static {
      this.BALUSTRADE = { type: 3, value: "BALUSTRADE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcRailingTypeEnum = IfcRailingTypeEnum;
  class IfcRampFlightTypeEnum {
    static {
      this.STRAIGHT = { type: 3, value: "STRAIGHT" };
    }
    static {
      this.SPIRAL = { type: 3, value: "SPIRAL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcRampFlightTypeEnum = IfcRampFlightTypeEnum;
  class IfcRampTypeEnum {
    static {
      this.STRAIGHT_RUN_RAMP = { type: 3, value: "STRAIGHT_RUN_RAMP" };
    }
    static {
      this.TWO_STRAIGHT_RUN_RAMP = { type: 3, value: "TWO_STRAIGHT_RUN_RAMP" };
    }
    static {
      this.QUARTER_TURN_RAMP = { type: 3, value: "QUARTER_TURN_RAMP" };
    }
    static {
      this.TWO_QUARTER_TURN_RAMP = { type: 3, value: "TWO_QUARTER_TURN_RAMP" };
    }
    static {
      this.HALF_TURN_RAMP = { type: 3, value: "HALF_TURN_RAMP" };
    }
    static {
      this.SPIRAL_RAMP = { type: 3, value: "SPIRAL_RAMP" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcRampTypeEnum = IfcRampTypeEnum;
  class IfcRecurrenceTypeEnum {
    static {
      this.DAILY = { type: 3, value: "DAILY" };
    }
    static {
      this.WEEKLY = { type: 3, value: "WEEKLY" };
    }
    static {
      this.MONTHLY_BY_DAY_OF_MONTH = { type: 3, value: "MONTHLY_BY_DAY_OF_MONTH" };
    }
    static {
      this.MONTHLY_BY_POSITION = { type: 3, value: "MONTHLY_BY_POSITION" };
    }
    static {
      this.BY_DAY_COUNT = { type: 3, value: "BY_DAY_COUNT" };
    }
    static {
      this.BY_WEEKDAY_COUNT = { type: 3, value: "BY_WEEKDAY_COUNT" };
    }
    static {
      this.YEARLY_BY_DAY_OF_MONTH = { type: 3, value: "YEARLY_BY_DAY_OF_MONTH" };
    }
    static {
      this.YEARLY_BY_POSITION = { type: 3, value: "YEARLY_BY_POSITION" };
    }
  }
  IFC42.IfcRecurrenceTypeEnum = IfcRecurrenceTypeEnum;
  class IfcReflectanceMethodEnum {
    static {
      this.BLINN = { type: 3, value: "BLINN" };
    }
    static {
      this.FLAT = { type: 3, value: "FLAT" };
    }
    static {
      this.GLASS = { type: 3, value: "GLASS" };
    }
    static {
      this.MATT = { type: 3, value: "MATT" };
    }
    static {
      this.METAL = { type: 3, value: "METAL" };
    }
    static {
      this.MIRROR = { type: 3, value: "MIRROR" };
    }
    static {
      this.PHONG = { type: 3, value: "PHONG" };
    }
    static {
      this.PLASTIC = { type: 3, value: "PLASTIC" };
    }
    static {
      this.STRAUSS = { type: 3, value: "STRAUSS" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcReflectanceMethodEnum = IfcReflectanceMethodEnum;
  class IfcReinforcingBarRoleEnum {
    static {
      this.MAIN = { type: 3, value: "MAIN" };
    }
    static {
      this.SHEAR = { type: 3, value: "SHEAR" };
    }
    static {
      this.LIGATURE = { type: 3, value: "LIGATURE" };
    }
    static {
      this.STUD = { type: 3, value: "STUD" };
    }
    static {
      this.PUNCHING = { type: 3, value: "PUNCHING" };
    }
    static {
      this.EDGE = { type: 3, value: "EDGE" };
    }
    static {
      this.RING = { type: 3, value: "RING" };
    }
    static {
      this.ANCHORING = { type: 3, value: "ANCHORING" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcReinforcingBarRoleEnum = IfcReinforcingBarRoleEnum;
  class IfcReinforcingBarSurfaceEnum {
    static {
      this.PLAIN = { type: 3, value: "PLAIN" };
    }
    static {
      this.TEXTURED = { type: 3, value: "TEXTURED" };
    }
  }
  IFC42.IfcReinforcingBarSurfaceEnum = IfcReinforcingBarSurfaceEnum;
  class IfcReinforcingBarTypeEnum {
    static {
      this.ANCHORING = { type: 3, value: "ANCHORING" };
    }
    static {
      this.EDGE = { type: 3, value: "EDGE" };
    }
    static {
      this.LIGATURE = { type: 3, value: "LIGATURE" };
    }
    static {
      this.MAIN = { type: 3, value: "MAIN" };
    }
    static {
      this.PUNCHING = { type: 3, value: "PUNCHING" };
    }
    static {
      this.RING = { type: 3, value: "RING" };
    }
    static {
      this.SHEAR = { type: 3, value: "SHEAR" };
    }
    static {
      this.STUD = { type: 3, value: "STUD" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcReinforcingBarTypeEnum = IfcReinforcingBarTypeEnum;
  class IfcReinforcingMeshTypeEnum {
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcReinforcingMeshTypeEnum = IfcReinforcingMeshTypeEnum;
  class IfcRoleEnum {
    static {
      this.SUPPLIER = { type: 3, value: "SUPPLIER" };
    }
    static {
      this.MANUFACTURER = { type: 3, value: "MANUFACTURER" };
    }
    static {
      this.CONTRACTOR = { type: 3, value: "CONTRACTOR" };
    }
    static {
      this.SUBCONTRACTOR = { type: 3, value: "SUBCONTRACTOR" };
    }
    static {
      this.ARCHITECT = { type: 3, value: "ARCHITECT" };
    }
    static {
      this.STRUCTURALENGINEER = { type: 3, value: "STRUCTURALENGINEER" };
    }
    static {
      this.COSTENGINEER = { type: 3, value: "COSTENGINEER" };
    }
    static {
      this.CLIENT = { type: 3, value: "CLIENT" };
    }
    static {
      this.BUILDINGOWNER = { type: 3, value: "BUILDINGOWNER" };
    }
    static {
      this.BUILDINGOPERATOR = { type: 3, value: "BUILDINGOPERATOR" };
    }
    static {
      this.MECHANICALENGINEER = { type: 3, value: "MECHANICALENGINEER" };
    }
    static {
      this.ELECTRICALENGINEER = { type: 3, value: "ELECTRICALENGINEER" };
    }
    static {
      this.PROJECTMANAGER = { type: 3, value: "PROJECTMANAGER" };
    }
    static {
      this.FACILITIESMANAGER = { type: 3, value: "FACILITIESMANAGER" };
    }
    static {
      this.CIVILENGINEER = { type: 3, value: "CIVILENGINEER" };
    }
    static {
      this.COMMISSIONINGENGINEER = { type: 3, value: "COMMISSIONINGENGINEER" };
    }
    static {
      this.ENGINEER = { type: 3, value: "ENGINEER" };
    }
    static {
      this.OWNER = { type: 3, value: "OWNER" };
    }
    static {
      this.CONSULTANT = { type: 3, value: "CONSULTANT" };
    }
    static {
      this.CONSTRUCTIONMANAGER = { type: 3, value: "CONSTRUCTIONMANAGER" };
    }
    static {
      this.FIELDCONSTRUCTIONMANAGER = { type: 3, value: "FIELDCONSTRUCTIONMANAGER" };
    }
    static {
      this.RESELLER = { type: 3, value: "RESELLER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
  }
  IFC42.IfcRoleEnum = IfcRoleEnum;
  class IfcRoofTypeEnum {
    static {
      this.FLAT_ROOF = { type: 3, value: "FLAT_ROOF" };
    }
    static {
      this.SHED_ROOF = { type: 3, value: "SHED_ROOF" };
    }
    static {
      this.GABLE_ROOF = { type: 3, value: "GABLE_ROOF" };
    }
    static {
      this.HIP_ROOF = { type: 3, value: "HIP_ROOF" };
    }
    static {
      this.HIPPED_GABLE_ROOF = { type: 3, value: "HIPPED_GABLE_ROOF" };
    }
    static {
      this.GAMBREL_ROOF = { type: 3, value: "GAMBREL_ROOF" };
    }
    static {
      this.MANSARD_ROOF = { type: 3, value: "MANSARD_ROOF" };
    }
    static {
      this.BARREL_ROOF = { type: 3, value: "BARREL_ROOF" };
    }
    static {
      this.RAINBOW_ROOF = { type: 3, value: "RAINBOW_ROOF" };
    }
    static {
      this.BUTTERFLY_ROOF = { type: 3, value: "BUTTERFLY_ROOF" };
    }
    static {
      this.PAVILION_ROOF = { type: 3, value: "PAVILION_ROOF" };
    }
    static {
      this.DOME_ROOF = { type: 3, value: "DOME_ROOF" };
    }
    static {
      this.FREEFORM = { type: 3, value: "FREEFORM" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcRoofTypeEnum = IfcRoofTypeEnum;
  class IfcSIPrefix {
    static {
      this.EXA = { type: 3, value: "EXA" };
    }
    static {
      this.PETA = { type: 3, value: "PETA" };
    }
    static {
      this.TERA = { type: 3, value: "TERA" };
    }
    static {
      this.GIGA = { type: 3, value: "GIGA" };
    }
    static {
      this.MEGA = { type: 3, value: "MEGA" };
    }
    static {
      this.KILO = { type: 3, value: "KILO" };
    }
    static {
      this.HECTO = { type: 3, value: "HECTO" };
    }
    static {
      this.DECA = { type: 3, value: "DECA" };
    }
    static {
      this.DECI = { type: 3, value: "DECI" };
    }
    static {
      this.CENTI = { type: 3, value: "CENTI" };
    }
    static {
      this.MILLI = { type: 3, value: "MILLI" };
    }
    static {
      this.MICRO = { type: 3, value: "MICRO" };
    }
    static {
      this.NANO = { type: 3, value: "NANO" };
    }
    static {
      this.PICO = { type: 3, value: "PICO" };
    }
    static {
      this.FEMTO = { type: 3, value: "FEMTO" };
    }
    static {
      this.ATTO = { type: 3, value: "ATTO" };
    }
  }
  IFC42.IfcSIPrefix = IfcSIPrefix;
  class IfcSIUnitName {
    static {
      this.AMPERE = { type: 3, value: "AMPERE" };
    }
    static {
      this.BECQUEREL = { type: 3, value: "BECQUEREL" };
    }
    static {
      this.CANDELA = { type: 3, value: "CANDELA" };
    }
    static {
      this.COULOMB = { type: 3, value: "COULOMB" };
    }
    static {
      this.CUBIC_METRE = { type: 3, value: "CUBIC_METRE" };
    }
    static {
      this.DEGREE_CELSIUS = { type: 3, value: "DEGREE_CELSIUS" };
    }
    static {
      this.FARAD = { type: 3, value: "FARAD" };
    }
    static {
      this.GRAM = { type: 3, value: "GRAM" };
    }
    static {
      this.GRAY = { type: 3, value: "GRAY" };
    }
    static {
      this.HENRY = { type: 3, value: "HENRY" };
    }
    static {
      this.HERTZ = { type: 3, value: "HERTZ" };
    }
    static {
      this.JOULE = { type: 3, value: "JOULE" };
    }
    static {
      this.KELVIN = { type: 3, value: "KELVIN" };
    }
    static {
      this.LUMEN = { type: 3, value: "LUMEN" };
    }
    static {
      this.LUX = { type: 3, value: "LUX" };
    }
    static {
      this.METRE = { type: 3, value: "METRE" };
    }
    static {
      this.MOLE = { type: 3, value: "MOLE" };
    }
    static {
      this.NEWTON = { type: 3, value: "NEWTON" };
    }
    static {
      this.OHM = { type: 3, value: "OHM" };
    }
    static {
      this.PASCAL = { type: 3, value: "PASCAL" };
    }
    static {
      this.RADIAN = { type: 3, value: "RADIAN" };
    }
    static {
      this.SECOND = { type: 3, value: "SECOND" };
    }
    static {
      this.SIEMENS = { type: 3, value: "SIEMENS" };
    }
    static {
      this.SIEVERT = { type: 3, value: "SIEVERT" };
    }
    static {
      this.SQUARE_METRE = { type: 3, value: "SQUARE_METRE" };
    }
    static {
      this.STERADIAN = { type: 3, value: "STERADIAN" };
    }
    static {
      this.TESLA = { type: 3, value: "TESLA" };
    }
    static {
      this.VOLT = { type: 3, value: "VOLT" };
    }
    static {
      this.WATT = { type: 3, value: "WATT" };
    }
    static {
      this.WEBER = { type: 3, value: "WEBER" };
    }
  }
  IFC42.IfcSIUnitName = IfcSIUnitName;
  class IfcSanitaryTerminalTypeEnum {
    static {
      this.BATH = { type: 3, value: "BATH" };
    }
    static {
      this.BIDET = { type: 3, value: "BIDET" };
    }
    static {
      this.CISTERN = { type: 3, value: "CISTERN" };
    }
    static {
      this.SHOWER = { type: 3, value: "SHOWER" };
    }
    static {
      this.SINK = { type: 3, value: "SINK" };
    }
    static {
      this.SANITARYFOUNTAIN = { type: 3, value: "SANITARYFOUNTAIN" };
    }
    static {
      this.TOILETPAN = { type: 3, value: "TOILETPAN" };
    }
    static {
      this.URINAL = { type: 3, value: "URINAL" };
    }
    static {
      this.WASHHANDBASIN = { type: 3, value: "WASHHANDBASIN" };
    }
    static {
      this.WCSEAT = { type: 3, value: "WCSEAT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcSanitaryTerminalTypeEnum = IfcSanitaryTerminalTypeEnum;
  class IfcSectionTypeEnum {
    static {
      this.UNIFORM = { type: 3, value: "UNIFORM" };
    }
    static {
      this.TAPERED = { type: 3, value: "TAPERED" };
    }
  }
  IFC42.IfcSectionTypeEnum = IfcSectionTypeEnum;
  class IfcSensorTypeEnum {
    static {
      this.COSENSOR = { type: 3, value: "COSENSOR" };
    }
    static {
      this.CO2SENSOR = { type: 3, value: "CO2SENSOR" };
    }
    static {
      this.CONDUCTANCESENSOR = { type: 3, value: "CONDUCTANCESENSOR" };
    }
    static {
      this.CONTACTSENSOR = { type: 3, value: "CONTACTSENSOR" };
    }
    static {
      this.FIRESENSOR = { type: 3, value: "FIRESENSOR" };
    }
    static {
      this.FLOWSENSOR = { type: 3, value: "FLOWSENSOR" };
    }
    static {
      this.FROSTSENSOR = { type: 3, value: "FROSTSENSOR" };
    }
    static {
      this.GASSENSOR = { type: 3, value: "GASSENSOR" };
    }
    static {
      this.HEATSENSOR = { type: 3, value: "HEATSENSOR" };
    }
    static {
      this.HUMIDITYSENSOR = { type: 3, value: "HUMIDITYSENSOR" };
    }
    static {
      this.IDENTIFIERSENSOR = { type: 3, value: "IDENTIFIERSENSOR" };
    }
    static {
      this.IONCONCENTRATIONSENSOR = { type: 3, value: "IONCONCENTRATIONSENSOR" };
    }
    static {
      this.LEVELSENSOR = { type: 3, value: "LEVELSENSOR" };
    }
    static {
      this.LIGHTSENSOR = { type: 3, value: "LIGHTSENSOR" };
    }
    static {
      this.MOISTURESENSOR = { type: 3, value: "MOISTURESENSOR" };
    }
    static {
      this.MOVEMENTSENSOR = { type: 3, value: "MOVEMENTSENSOR" };
    }
    static {
      this.PHSENSOR = { type: 3, value: "PHSENSOR" };
    }
    static {
      this.PRESSURESENSOR = { type: 3, value: "PRESSURESENSOR" };
    }
    static {
      this.RADIATIONSENSOR = { type: 3, value: "RADIATIONSENSOR" };
    }
    static {
      this.RADIOACTIVITYSENSOR = { type: 3, value: "RADIOACTIVITYSENSOR" };
    }
    static {
      this.SMOKESENSOR = { type: 3, value: "SMOKESENSOR" };
    }
    static {
      this.SOUNDSENSOR = { type: 3, value: "SOUNDSENSOR" };
    }
    static {
      this.TEMPERATURESENSOR = { type: 3, value: "TEMPERATURESENSOR" };
    }
    static {
      this.WINDSENSOR = { type: 3, value: "WINDSENSOR" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcSensorTypeEnum = IfcSensorTypeEnum;
  class IfcSequenceEnum {
    static {
      this.START_START = { type: 3, value: "START_START" };
    }
    static {
      this.START_FINISH = { type: 3, value: "START_FINISH" };
    }
    static {
      this.FINISH_START = { type: 3, value: "FINISH_START" };
    }
    static {
      this.FINISH_FINISH = { type: 3, value: "FINISH_FINISH" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcSequenceEnum = IfcSequenceEnum;
  class IfcShadingDeviceTypeEnum {
    static {
      this.JALOUSIE = { type: 3, value: "JALOUSIE" };
    }
    static {
      this.SHUTTER = { type: 3, value: "SHUTTER" };
    }
    static {
      this.AWNING = { type: 3, value: "AWNING" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcShadingDeviceTypeEnum = IfcShadingDeviceTypeEnum;
  class IfcSimplePropertyTemplateTypeEnum {
    static {
      this.P_SINGLEVALUE = { type: 3, value: "P_SINGLEVALUE" };
    }
    static {
      this.P_ENUMERATEDVALUE = { type: 3, value: "P_ENUMERATEDVALUE" };
    }
    static {
      this.P_BOUNDEDVALUE = { type: 3, value: "P_BOUNDEDVALUE" };
    }
    static {
      this.P_LISTVALUE = { type: 3, value: "P_LISTVALUE" };
    }
    static {
      this.P_TABLEVALUE = { type: 3, value: "P_TABLEVALUE" };
    }
    static {
      this.P_REFERENCEVALUE = { type: 3, value: "P_REFERENCEVALUE" };
    }
    static {
      this.Q_LENGTH = { type: 3, value: "Q_LENGTH" };
    }
    static {
      this.Q_AREA = { type: 3, value: "Q_AREA" };
    }
    static {
      this.Q_VOLUME = { type: 3, value: "Q_VOLUME" };
    }
    static {
      this.Q_COUNT = { type: 3, value: "Q_COUNT" };
    }
    static {
      this.Q_WEIGHT = { type: 3, value: "Q_WEIGHT" };
    }
    static {
      this.Q_TIME = { type: 3, value: "Q_TIME" };
    }
  }
  IFC42.IfcSimplePropertyTemplateTypeEnum = IfcSimplePropertyTemplateTypeEnum;
  class IfcSlabTypeEnum {
    static {
      this.FLOOR = { type: 3, value: "FLOOR" };
    }
    static {
      this.ROOF = { type: 3, value: "ROOF" };
    }
    static {
      this.LANDING = { type: 3, value: "LANDING" };
    }
    static {
      this.BASESLAB = { type: 3, value: "BASESLAB" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcSlabTypeEnum = IfcSlabTypeEnum;
  class IfcSolarDeviceTypeEnum {
    static {
      this.SOLARCOLLECTOR = { type: 3, value: "SOLARCOLLECTOR" };
    }
    static {
      this.SOLARPANEL = { type: 3, value: "SOLARPANEL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcSolarDeviceTypeEnum = IfcSolarDeviceTypeEnum;
  class IfcSpaceHeaterTypeEnum {
    static {
      this.CONVECTOR = { type: 3, value: "CONVECTOR" };
    }
    static {
      this.RADIATOR = { type: 3, value: "RADIATOR" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcSpaceHeaterTypeEnum = IfcSpaceHeaterTypeEnum;
  class IfcSpaceTypeEnum {
    static {
      this.SPACE = { type: 3, value: "SPACE" };
    }
    static {
      this.PARKING = { type: 3, value: "PARKING" };
    }
    static {
      this.GFA = { type: 3, value: "GFA" };
    }
    static {
      this.INTERNAL = { type: 3, value: "INTERNAL" };
    }
    static {
      this.EXTERNAL = { type: 3, value: "EXTERNAL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcSpaceTypeEnum = IfcSpaceTypeEnum;
  class IfcSpatialZoneTypeEnum {
    static {
      this.CONSTRUCTION = { type: 3, value: "CONSTRUCTION" };
    }
    static {
      this.FIRESAFETY = { type: 3, value: "FIRESAFETY" };
    }
    static {
      this.LIGHTING = { type: 3, value: "LIGHTING" };
    }
    static {
      this.OCCUPANCY = { type: 3, value: "OCCUPANCY" };
    }
    static {
      this.SECURITY = { type: 3, value: "SECURITY" };
    }
    static {
      this.THERMAL = { type: 3, value: "THERMAL" };
    }
    static {
      this.TRANSPORT = { type: 3, value: "TRANSPORT" };
    }
    static {
      this.VENTILATION = { type: 3, value: "VENTILATION" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcSpatialZoneTypeEnum = IfcSpatialZoneTypeEnum;
  class IfcStackTerminalTypeEnum {
    static {
      this.BIRDCAGE = { type: 3, value: "BIRDCAGE" };
    }
    static {
      this.COWL = { type: 3, value: "COWL" };
    }
    static {
      this.RAINWATERHOPPER = { type: 3, value: "RAINWATERHOPPER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcStackTerminalTypeEnum = IfcStackTerminalTypeEnum;
  class IfcStairFlightTypeEnum {
    static {
      this.STRAIGHT = { type: 3, value: "STRAIGHT" };
    }
    static {
      this.WINDER = { type: 3, value: "WINDER" };
    }
    static {
      this.SPIRAL = { type: 3, value: "SPIRAL" };
    }
    static {
      this.CURVED = { type: 3, value: "CURVED" };
    }
    static {
      this.FREEFORM = { type: 3, value: "FREEFORM" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcStairFlightTypeEnum = IfcStairFlightTypeEnum;
  class IfcStairTypeEnum {
    static {
      this.STRAIGHT_RUN_STAIR = { type: 3, value: "STRAIGHT_RUN_STAIR" };
    }
    static {
      this.TWO_STRAIGHT_RUN_STAIR = { type: 3, value: "TWO_STRAIGHT_RUN_STAIR" };
    }
    static {
      this.QUARTER_WINDING_STAIR = { type: 3, value: "QUARTER_WINDING_STAIR" };
    }
    static {
      this.QUARTER_TURN_STAIR = { type: 3, value: "QUARTER_TURN_STAIR" };
    }
    static {
      this.HALF_WINDING_STAIR = { type: 3, value: "HALF_WINDING_STAIR" };
    }
    static {
      this.HALF_TURN_STAIR = { type: 3, value: "HALF_TURN_STAIR" };
    }
    static {
      this.TWO_QUARTER_WINDING_STAIR = { type: 3, value: "TWO_QUARTER_WINDING_STAIR" };
    }
    static {
      this.TWO_QUARTER_TURN_STAIR = { type: 3, value: "TWO_QUARTER_TURN_STAIR" };
    }
    static {
      this.THREE_QUARTER_WINDING_STAIR = { type: 3, value: "THREE_QUARTER_WINDING_STAIR" };
    }
    static {
      this.THREE_QUARTER_TURN_STAIR = { type: 3, value: "THREE_QUARTER_TURN_STAIR" };
    }
    static {
      this.SPIRAL_STAIR = { type: 3, value: "SPIRAL_STAIR" };
    }
    static {
      this.DOUBLE_RETURN_STAIR = { type: 3, value: "DOUBLE_RETURN_STAIR" };
    }
    static {
      this.CURVED_RUN_STAIR = { type: 3, value: "CURVED_RUN_STAIR" };
    }
    static {
      this.TWO_CURVED_RUN_STAIR = { type: 3, value: "TWO_CURVED_RUN_STAIR" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcStairTypeEnum = IfcStairTypeEnum;
  class IfcStateEnum {
    static {
      this.READWRITE = { type: 3, value: "READWRITE" };
    }
    static {
      this.READONLY = { type: 3, value: "READONLY" };
    }
    static {
      this.LOCKED = { type: 3, value: "LOCKED" };
    }
    static {
      this.READWRITELOCKED = { type: 3, value: "READWRITELOCKED" };
    }
    static {
      this.READONLYLOCKED = { type: 3, value: "READONLYLOCKED" };
    }
  }
  IFC42.IfcStateEnum = IfcStateEnum;
  class IfcStructuralCurveActivityTypeEnum {
    static {
      this.CONST = { type: 3, value: "CONST" };
    }
    static {
      this.LINEAR = { type: 3, value: "LINEAR" };
    }
    static {
      this.POLYGONAL = { type: 3, value: "POLYGONAL" };
    }
    static {
      this.EQUIDISTANT = { type: 3, value: "EQUIDISTANT" };
    }
    static {
      this.SINUS = { type: 3, value: "SINUS" };
    }
    static {
      this.PARABOLA = { type: 3, value: "PARABOLA" };
    }
    static {
      this.DISCRETE = { type: 3, value: "DISCRETE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcStructuralCurveActivityTypeEnum = IfcStructuralCurveActivityTypeEnum;
  class IfcStructuralCurveMemberTypeEnum {
    static {
      this.RIGID_JOINED_MEMBER = { type: 3, value: "RIGID_JOINED_MEMBER" };
    }
    static {
      this.PIN_JOINED_MEMBER = { type: 3, value: "PIN_JOINED_MEMBER" };
    }
    static {
      this.CABLE = { type: 3, value: "CABLE" };
    }
    static {
      this.TENSION_MEMBER = { type: 3, value: "TENSION_MEMBER" };
    }
    static {
      this.COMPRESSION_MEMBER = { type: 3, value: "COMPRESSION_MEMBER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcStructuralCurveMemberTypeEnum = IfcStructuralCurveMemberTypeEnum;
  class IfcStructuralSurfaceActivityTypeEnum {
    static {
      this.CONST = { type: 3, value: "CONST" };
    }
    static {
      this.BILINEAR = { type: 3, value: "BILINEAR" };
    }
    static {
      this.DISCRETE = { type: 3, value: "DISCRETE" };
    }
    static {
      this.ISOCONTOUR = { type: 3, value: "ISOCONTOUR" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcStructuralSurfaceActivityTypeEnum = IfcStructuralSurfaceActivityTypeEnum;
  class IfcStructuralSurfaceMemberTypeEnum {
    static {
      this.BENDING_ELEMENT = { type: 3, value: "BENDING_ELEMENT" };
    }
    static {
      this.MEMBRANE_ELEMENT = { type: 3, value: "MEMBRANE_ELEMENT" };
    }
    static {
      this.SHELL = { type: 3, value: "SHELL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcStructuralSurfaceMemberTypeEnum = IfcStructuralSurfaceMemberTypeEnum;
  class IfcSubContractResourceTypeEnum {
    static {
      this.PURCHASE = { type: 3, value: "PURCHASE" };
    }
    static {
      this.WORK = { type: 3, value: "WORK" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcSubContractResourceTypeEnum = IfcSubContractResourceTypeEnum;
  class IfcSurfaceFeatureTypeEnum {
    static {
      this.MARK = { type: 3, value: "MARK" };
    }
    static {
      this.TAG = { type: 3, value: "TAG" };
    }
    static {
      this.TREATMENT = { type: 3, value: "TREATMENT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcSurfaceFeatureTypeEnum = IfcSurfaceFeatureTypeEnum;
  class IfcSurfaceSide {
    static {
      this.POSITIVE = { type: 3, value: "POSITIVE" };
    }
    static {
      this.NEGATIVE = { type: 3, value: "NEGATIVE" };
    }
    static {
      this.BOTH = { type: 3, value: "BOTH" };
    }
  }
  IFC42.IfcSurfaceSide = IfcSurfaceSide;
  class IfcSwitchingDeviceTypeEnum {
    static {
      this.CONTACTOR = { type: 3, value: "CONTACTOR" };
    }
    static {
      this.DIMMERSWITCH = { type: 3, value: "DIMMERSWITCH" };
    }
    static {
      this.EMERGENCYSTOP = { type: 3, value: "EMERGENCYSTOP" };
    }
    static {
      this.KEYPAD = { type: 3, value: "KEYPAD" };
    }
    static {
      this.MOMENTARYSWITCH = { type: 3, value: "MOMENTARYSWITCH" };
    }
    static {
      this.SELECTORSWITCH = { type: 3, value: "SELECTORSWITCH" };
    }
    static {
      this.STARTER = { type: 3, value: "STARTER" };
    }
    static {
      this.SWITCHDISCONNECTOR = { type: 3, value: "SWITCHDISCONNECTOR" };
    }
    static {
      this.TOGGLESWITCH = { type: 3, value: "TOGGLESWITCH" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcSwitchingDeviceTypeEnum = IfcSwitchingDeviceTypeEnum;
  class IfcSystemFurnitureElementTypeEnum {
    static {
      this.PANEL = { type: 3, value: "PANEL" };
    }
    static {
      this.WORKSURFACE = { type: 3, value: "WORKSURFACE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcSystemFurnitureElementTypeEnum = IfcSystemFurnitureElementTypeEnum;
  class IfcTankTypeEnum {
    static {
      this.BASIN = { type: 3, value: "BASIN" };
    }
    static {
      this.BREAKPRESSURE = { type: 3, value: "BREAKPRESSURE" };
    }
    static {
      this.EXPANSION = { type: 3, value: "EXPANSION" };
    }
    static {
      this.FEEDANDEXPANSION = { type: 3, value: "FEEDANDEXPANSION" };
    }
    static {
      this.PRESSUREVESSEL = { type: 3, value: "PRESSUREVESSEL" };
    }
    static {
      this.STORAGE = { type: 3, value: "STORAGE" };
    }
    static {
      this.VESSEL = { type: 3, value: "VESSEL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcTankTypeEnum = IfcTankTypeEnum;
  class IfcTaskDurationEnum {
    static {
      this.ELAPSEDTIME = { type: 3, value: "ELAPSEDTIME" };
    }
    static {
      this.WORKTIME = { type: 3, value: "WORKTIME" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcTaskDurationEnum = IfcTaskDurationEnum;
  class IfcTaskTypeEnum {
    static {
      this.ATTENDANCE = { type: 3, value: "ATTENDANCE" };
    }
    static {
      this.CONSTRUCTION = { type: 3, value: "CONSTRUCTION" };
    }
    static {
      this.DEMOLITION = { type: 3, value: "DEMOLITION" };
    }
    static {
      this.DISMANTLE = { type: 3, value: "DISMANTLE" };
    }
    static {
      this.DISPOSAL = { type: 3, value: "DISPOSAL" };
    }
    static {
      this.INSTALLATION = { type: 3, value: "INSTALLATION" };
    }
    static {
      this.LOGISTIC = { type: 3, value: "LOGISTIC" };
    }
    static {
      this.MAINTENANCE = { type: 3, value: "MAINTENANCE" };
    }
    static {
      this.MOVE = { type: 3, value: "MOVE" };
    }
    static {
      this.OPERATION = { type: 3, value: "OPERATION" };
    }
    static {
      this.REMOVAL = { type: 3, value: "REMOVAL" };
    }
    static {
      this.RENOVATION = { type: 3, value: "RENOVATION" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcTaskTypeEnum = IfcTaskTypeEnum;
  class IfcTendonAnchorTypeEnum {
    static {
      this.COUPLER = { type: 3, value: "COUPLER" };
    }
    static {
      this.FIXED_END = { type: 3, value: "FIXED_END" };
    }
    static {
      this.TENSIONING_END = { type: 3, value: "TENSIONING_END" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcTendonAnchorTypeEnum = IfcTendonAnchorTypeEnum;
  class IfcTendonTypeEnum {
    static {
      this.BAR = { type: 3, value: "BAR" };
    }
    static {
      this.COATED = { type: 3, value: "COATED" };
    }
    static {
      this.STRAND = { type: 3, value: "STRAND" };
    }
    static {
      this.WIRE = { type: 3, value: "WIRE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcTendonTypeEnum = IfcTendonTypeEnum;
  class IfcTextPath {
    static {
      this.LEFT = { type: 3, value: "LEFT" };
    }
    static {
      this.RIGHT = { type: 3, value: "RIGHT" };
    }
    static {
      this.UP = { type: 3, value: "UP" };
    }
    static {
      this.DOWN = { type: 3, value: "DOWN" };
    }
  }
  IFC42.IfcTextPath = IfcTextPath;
  class IfcTimeSeriesDataTypeEnum {
    static {
      this.CONTINUOUS = { type: 3, value: "CONTINUOUS" };
    }
    static {
      this.DISCRETE = { type: 3, value: "DISCRETE" };
    }
    static {
      this.DISCRETEBINARY = { type: 3, value: "DISCRETEBINARY" };
    }
    static {
      this.PIECEWISEBINARY = { type: 3, value: "PIECEWISEBINARY" };
    }
    static {
      this.PIECEWISECONSTANT = { type: 3, value: "PIECEWISECONSTANT" };
    }
    static {
      this.PIECEWISECONTINUOUS = { type: 3, value: "PIECEWISECONTINUOUS" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcTimeSeriesDataTypeEnum = IfcTimeSeriesDataTypeEnum;
  class IfcTransformerTypeEnum {
    static {
      this.CURRENT = { type: 3, value: "CURRENT" };
    }
    static {
      this.FREQUENCY = { type: 3, value: "FREQUENCY" };
    }
    static {
      this.INVERTER = { type: 3, value: "INVERTER" };
    }
    static {
      this.RECTIFIER = { type: 3, value: "RECTIFIER" };
    }
    static {
      this.VOLTAGE = { type: 3, value: "VOLTAGE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcTransformerTypeEnum = IfcTransformerTypeEnum;
  class IfcTransitionCode {
    static {
      this.DISCONTINUOUS = { type: 3, value: "DISCONTINUOUS" };
    }
    static {
      this.CONTINUOUS = { type: 3, value: "CONTINUOUS" };
    }
    static {
      this.CONTSAMEGRADIENT = { type: 3, value: "CONTSAMEGRADIENT" };
    }
    static {
      this.CONTSAMEGRADIENTSAMECURVATURE = { type: 3, value: "CONTSAMEGRADIENTSAMECURVATURE" };
    }
  }
  IFC42.IfcTransitionCode = IfcTransitionCode;
  class IfcTransportElementTypeEnum {
    static {
      this.ELEVATOR = { type: 3, value: "ELEVATOR" };
    }
    static {
      this.ESCALATOR = { type: 3, value: "ESCALATOR" };
    }
    static {
      this.MOVINGWALKWAY = { type: 3, value: "MOVINGWALKWAY" };
    }
    static {
      this.CRANEWAY = { type: 3, value: "CRANEWAY" };
    }
    static {
      this.LIFTINGGEAR = { type: 3, value: "LIFTINGGEAR" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcTransportElementTypeEnum = IfcTransportElementTypeEnum;
  class IfcTrimmingPreference {
    static {
      this.CARTESIAN = { type: 3, value: "CARTESIAN" };
    }
    static {
      this.PARAMETER = { type: 3, value: "PARAMETER" };
    }
    static {
      this.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" };
    }
  }
  IFC42.IfcTrimmingPreference = IfcTrimmingPreference;
  class IfcTubeBundleTypeEnum {
    static {
      this.FINNED = { type: 3, value: "FINNED" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcTubeBundleTypeEnum = IfcTubeBundleTypeEnum;
  class IfcUnitEnum {
    static {
      this.ABSORBEDDOSEUNIT = { type: 3, value: "ABSORBEDDOSEUNIT" };
    }
    static {
      this.AMOUNTOFSUBSTANCEUNIT = { type: 3, value: "AMOUNTOFSUBSTANCEUNIT" };
    }
    static {
      this.AREAUNIT = { type: 3, value: "AREAUNIT" };
    }
    static {
      this.DOSEEQUIVALENTUNIT = { type: 3, value: "DOSEEQUIVALENTUNIT" };
    }
    static {
      this.ELECTRICCAPACITANCEUNIT = { type: 3, value: "ELECTRICCAPACITANCEUNIT" };
    }
    static {
      this.ELECTRICCHARGEUNIT = { type: 3, value: "ELECTRICCHARGEUNIT" };
    }
    static {
      this.ELECTRICCONDUCTANCEUNIT = { type: 3, value: "ELECTRICCONDUCTANCEUNIT" };
    }
    static {
      this.ELECTRICCURRENTUNIT = { type: 3, value: "ELECTRICCURRENTUNIT" };
    }
    static {
      this.ELECTRICRESISTANCEUNIT = { type: 3, value: "ELECTRICRESISTANCEUNIT" };
    }
    static {
      this.ELECTRICVOLTAGEUNIT = { type: 3, value: "ELECTRICVOLTAGEUNIT" };
    }
    static {
      this.ENERGYUNIT = { type: 3, value: "ENERGYUNIT" };
    }
    static {
      this.FORCEUNIT = { type: 3, value: "FORCEUNIT" };
    }
    static {
      this.FREQUENCYUNIT = { type: 3, value: "FREQUENCYUNIT" };
    }
    static {
      this.ILLUMINANCEUNIT = { type: 3, value: "ILLUMINANCEUNIT" };
    }
    static {
      this.INDUCTANCEUNIT = { type: 3, value: "INDUCTANCEUNIT" };
    }
    static {
      this.LENGTHUNIT = { type: 3, value: "LENGTHUNIT" };
    }
    static {
      this.LUMINOUSFLUXUNIT = { type: 3, value: "LUMINOUSFLUXUNIT" };
    }
    static {
      this.LUMINOUSINTENSITYUNIT = { type: 3, value: "LUMINOUSINTENSITYUNIT" };
    }
    static {
      this.MAGNETICFLUXDENSITYUNIT = { type: 3, value: "MAGNETICFLUXDENSITYUNIT" };
    }
    static {
      this.MAGNETICFLUXUNIT = { type: 3, value: "MAGNETICFLUXUNIT" };
    }
    static {
      this.MASSUNIT = { type: 3, value: "MASSUNIT" };
    }
    static {
      this.PLANEANGLEUNIT = { type: 3, value: "PLANEANGLEUNIT" };
    }
    static {
      this.POWERUNIT = { type: 3, value: "POWERUNIT" };
    }
    static {
      this.PRESSUREUNIT = { type: 3, value: "PRESSUREUNIT" };
    }
    static {
      this.RADIOACTIVITYUNIT = { type: 3, value: "RADIOACTIVITYUNIT" };
    }
    static {
      this.SOLIDANGLEUNIT = { type: 3, value: "SOLIDANGLEUNIT" };
    }
    static {
      this.THERMODYNAMICTEMPERATUREUNIT = { type: 3, value: "THERMODYNAMICTEMPERATUREUNIT" };
    }
    static {
      this.TIMEUNIT = { type: 3, value: "TIMEUNIT" };
    }
    static {
      this.VOLUMEUNIT = { type: 3, value: "VOLUMEUNIT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
  }
  IFC42.IfcUnitEnum = IfcUnitEnum;
  class IfcUnitaryControlElementTypeEnum {
    static {
      this.ALARMPANEL = { type: 3, value: "ALARMPANEL" };
    }
    static {
      this.CONTROLPANEL = { type: 3, value: "CONTROLPANEL" };
    }
    static {
      this.GASDETECTIONPANEL = { type: 3, value: "GASDETECTIONPANEL" };
    }
    static {
      this.INDICATORPANEL = { type: 3, value: "INDICATORPANEL" };
    }
    static {
      this.MIMICPANEL = { type: 3, value: "MIMICPANEL" };
    }
    static {
      this.HUMIDISTAT = { type: 3, value: "HUMIDISTAT" };
    }
    static {
      this.THERMOSTAT = { type: 3, value: "THERMOSTAT" };
    }
    static {
      this.WEATHERSTATION = { type: 3, value: "WEATHERSTATION" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcUnitaryControlElementTypeEnum = IfcUnitaryControlElementTypeEnum;
  class IfcUnitaryEquipmentTypeEnum {
    static {
      this.AIRHANDLER = { type: 3, value: "AIRHANDLER" };
    }
    static {
      this.AIRCONDITIONINGUNIT = { type: 3, value: "AIRCONDITIONINGUNIT" };
    }
    static {
      this.DEHUMIDIFIER = { type: 3, value: "DEHUMIDIFIER" };
    }
    static {
      this.SPLITSYSTEM = { type: 3, value: "SPLITSYSTEM" };
    }
    static {
      this.ROOFTOPUNIT = { type: 3, value: "ROOFTOPUNIT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcUnitaryEquipmentTypeEnum = IfcUnitaryEquipmentTypeEnum;
  class IfcValveTypeEnum {
    static {
      this.AIRRELEASE = { type: 3, value: "AIRRELEASE" };
    }
    static {
      this.ANTIVACUUM = { type: 3, value: "ANTIVACUUM" };
    }
    static {
      this.CHANGEOVER = { type: 3, value: "CHANGEOVER" };
    }
    static {
      this.CHECK = { type: 3, value: "CHECK" };
    }
    static {
      this.COMMISSIONING = { type: 3, value: "COMMISSIONING" };
    }
    static {
      this.DIVERTING = { type: 3, value: "DIVERTING" };
    }
    static {
      this.DRAWOFFCOCK = { type: 3, value: "DRAWOFFCOCK" };
    }
    static {
      this.DOUBLECHECK = { type: 3, value: "DOUBLECHECK" };
    }
    static {
      this.DOUBLEREGULATING = { type: 3, value: "DOUBLEREGULATING" };
    }
    static {
      this.FAUCET = { type: 3, value: "FAUCET" };
    }
    static {
      this.FLUSHING = { type: 3, value: "FLUSHING" };
    }
    static {
      this.GASCOCK = { type: 3, value: "GASCOCK" };
    }
    static {
      this.GASTAP = { type: 3, value: "GASTAP" };
    }
    static {
      this.ISOLATING = { type: 3, value: "ISOLATING" };
    }
    static {
      this.MIXING = { type: 3, value: "MIXING" };
    }
    static {
      this.PRESSUREREDUCING = { type: 3, value: "PRESSUREREDUCING" };
    }
    static {
      this.PRESSURERELIEF = { type: 3, value: "PRESSURERELIEF" };
    }
    static {
      this.REGULATING = { type: 3, value: "REGULATING" };
    }
    static {
      this.SAFETYCUTOFF = { type: 3, value: "SAFETYCUTOFF" };
    }
    static {
      this.STEAMTRAP = { type: 3, value: "STEAMTRAP" };
    }
    static {
      this.STOPCOCK = { type: 3, value: "STOPCOCK" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcValveTypeEnum = IfcValveTypeEnum;
  class IfcVibrationIsolatorTypeEnum {
    static {
      this.COMPRESSION = { type: 3, value: "COMPRESSION" };
    }
    static {
      this.SPRING = { type: 3, value: "SPRING" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcVibrationIsolatorTypeEnum = IfcVibrationIsolatorTypeEnum;
  class IfcVoidingFeatureTypeEnum {
    static {
      this.CUTOUT = { type: 3, value: "CUTOUT" };
    }
    static {
      this.NOTCH = { type: 3, value: "NOTCH" };
    }
    static {
      this.HOLE = { type: 3, value: "HOLE" };
    }
    static {
      this.MITER = { type: 3, value: "MITER" };
    }
    static {
      this.CHAMFER = { type: 3, value: "CHAMFER" };
    }
    static {
      this.EDGE = { type: 3, value: "EDGE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcVoidingFeatureTypeEnum = IfcVoidingFeatureTypeEnum;
  class IfcWallTypeEnum {
    static {
      this.MOVABLE = { type: 3, value: "MOVABLE" };
    }
    static {
      this.PARAPET = { type: 3, value: "PARAPET" };
    }
    static {
      this.PARTITIONING = { type: 3, value: "PARTITIONING" };
    }
    static {
      this.PLUMBINGWALL = { type: 3, value: "PLUMBINGWALL" };
    }
    static {
      this.SHEAR = { type: 3, value: "SHEAR" };
    }
    static {
      this.SOLIDWALL = { type: 3, value: "SOLIDWALL" };
    }
    static {
      this.STANDARD = { type: 3, value: "STANDARD" };
    }
    static {
      this.POLYGONAL = { type: 3, value: "POLYGONAL" };
    }
    static {
      this.ELEMENTEDWALL = { type: 3, value: "ELEMENTEDWALL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcWallTypeEnum = IfcWallTypeEnum;
  class IfcWasteTerminalTypeEnum {
    static {
      this.FLOORTRAP = { type: 3, value: "FLOORTRAP" };
    }
    static {
      this.FLOORWASTE = { type: 3, value: "FLOORWASTE" };
    }
    static {
      this.GULLYSUMP = { type: 3, value: "GULLYSUMP" };
    }
    static {
      this.GULLYTRAP = { type: 3, value: "GULLYTRAP" };
    }
    static {
      this.ROOFDRAIN = { type: 3, value: "ROOFDRAIN" };
    }
    static {
      this.WASTEDISPOSALUNIT = { type: 3, value: "WASTEDISPOSALUNIT" };
    }
    static {
      this.WASTETRAP = { type: 3, value: "WASTETRAP" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcWasteTerminalTypeEnum = IfcWasteTerminalTypeEnum;
  class IfcWindowPanelOperationEnum {
    static {
      this.SIDEHUNGRIGHTHAND = { type: 3, value: "SIDEHUNGRIGHTHAND" };
    }
    static {
      this.SIDEHUNGLEFTHAND = { type: 3, value: "SIDEHUNGLEFTHAND" };
    }
    static {
      this.TILTANDTURNRIGHTHAND = { type: 3, value: "TILTANDTURNRIGHTHAND" };
    }
    static {
      this.TILTANDTURNLEFTHAND = { type: 3, value: "TILTANDTURNLEFTHAND" };
    }
    static {
      this.TOPHUNG = { type: 3, value: "TOPHUNG" };
    }
    static {
      this.BOTTOMHUNG = { type: 3, value: "BOTTOMHUNG" };
    }
    static {
      this.PIVOTHORIZONTAL = { type: 3, value: "PIVOTHORIZONTAL" };
    }
    static {
      this.PIVOTVERTICAL = { type: 3, value: "PIVOTVERTICAL" };
    }
    static {
      this.SLIDINGHORIZONTAL = { type: 3, value: "SLIDINGHORIZONTAL" };
    }
    static {
      this.SLIDINGVERTICAL = { type: 3, value: "SLIDINGVERTICAL" };
    }
    static {
      this.REMOVABLECASEMENT = { type: 3, value: "REMOVABLECASEMENT" };
    }
    static {
      this.FIXEDCASEMENT = { type: 3, value: "FIXEDCASEMENT" };
    }
    static {
      this.OTHEROPERATION = { type: 3, value: "OTHEROPERATION" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcWindowPanelOperationEnum = IfcWindowPanelOperationEnum;
  class IfcWindowPanelPositionEnum {
    static {
      this.LEFT = { type: 3, value: "LEFT" };
    }
    static {
      this.MIDDLE = { type: 3, value: "MIDDLE" };
    }
    static {
      this.RIGHT = { type: 3, value: "RIGHT" };
    }
    static {
      this.BOTTOM = { type: 3, value: "BOTTOM" };
    }
    static {
      this.TOP = { type: 3, value: "TOP" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcWindowPanelPositionEnum = IfcWindowPanelPositionEnum;
  class IfcWindowStyleConstructionEnum {
    static {
      this.ALUMINIUM = { type: 3, value: "ALUMINIUM" };
    }
    static {
      this.HIGH_GRADE_STEEL = { type: 3, value: "HIGH_GRADE_STEEL" };
    }
    static {
      this.STEEL = { type: 3, value: "STEEL" };
    }
    static {
      this.WOOD = { type: 3, value: "WOOD" };
    }
    static {
      this.ALUMINIUM_WOOD = { type: 3, value: "ALUMINIUM_WOOD" };
    }
    static {
      this.PLASTIC = { type: 3, value: "PLASTIC" };
    }
    static {
      this.OTHER_CONSTRUCTION = { type: 3, value: "OTHER_CONSTRUCTION" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcWindowStyleConstructionEnum = IfcWindowStyleConstructionEnum;
  class IfcWindowStyleOperationEnum {
    static {
      this.SINGLE_PANEL = { type: 3, value: "SINGLE_PANEL" };
    }
    static {
      this.DOUBLE_PANEL_VERTICAL = { type: 3, value: "DOUBLE_PANEL_VERTICAL" };
    }
    static {
      this.DOUBLE_PANEL_HORIZONTAL = { type: 3, value: "DOUBLE_PANEL_HORIZONTAL" };
    }
    static {
      this.TRIPLE_PANEL_VERTICAL = { type: 3, value: "TRIPLE_PANEL_VERTICAL" };
    }
    static {
      this.TRIPLE_PANEL_BOTTOM = { type: 3, value: "TRIPLE_PANEL_BOTTOM" };
    }
    static {
      this.TRIPLE_PANEL_TOP = { type: 3, value: "TRIPLE_PANEL_TOP" };
    }
    static {
      this.TRIPLE_PANEL_LEFT = { type: 3, value: "TRIPLE_PANEL_LEFT" };
    }
    static {
      this.TRIPLE_PANEL_RIGHT = { type: 3, value: "TRIPLE_PANEL_RIGHT" };
    }
    static {
      this.TRIPLE_PANEL_HORIZONTAL = { type: 3, value: "TRIPLE_PANEL_HORIZONTAL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcWindowStyleOperationEnum = IfcWindowStyleOperationEnum;
  class IfcWindowTypeEnum {
    static {
      this.WINDOW = { type: 3, value: "WINDOW" };
    }
    static {
      this.SKYLIGHT = { type: 3, value: "SKYLIGHT" };
    }
    static {
      this.LIGHTDOME = { type: 3, value: "LIGHTDOME" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcWindowTypeEnum = IfcWindowTypeEnum;
  class IfcWindowTypePartitioningEnum {
    static {
      this.SINGLE_PANEL = { type: 3, value: "SINGLE_PANEL" };
    }
    static {
      this.DOUBLE_PANEL_VERTICAL = { type: 3, value: "DOUBLE_PANEL_VERTICAL" };
    }
    static {
      this.DOUBLE_PANEL_HORIZONTAL = { type: 3, value: "DOUBLE_PANEL_HORIZONTAL" };
    }
    static {
      this.TRIPLE_PANEL_VERTICAL = { type: 3, value: "TRIPLE_PANEL_VERTICAL" };
    }
    static {
      this.TRIPLE_PANEL_BOTTOM = { type: 3, value: "TRIPLE_PANEL_BOTTOM" };
    }
    static {
      this.TRIPLE_PANEL_TOP = { type: 3, value: "TRIPLE_PANEL_TOP" };
    }
    static {
      this.TRIPLE_PANEL_LEFT = { type: 3, value: "TRIPLE_PANEL_LEFT" };
    }
    static {
      this.TRIPLE_PANEL_RIGHT = { type: 3, value: "TRIPLE_PANEL_RIGHT" };
    }
    static {
      this.TRIPLE_PANEL_HORIZONTAL = { type: 3, value: "TRIPLE_PANEL_HORIZONTAL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcWindowTypePartitioningEnum = IfcWindowTypePartitioningEnum;
  class IfcWorkCalendarTypeEnum {
    static {
      this.FIRSTSHIFT = { type: 3, value: "FIRSTSHIFT" };
    }
    static {
      this.SECONDSHIFT = { type: 3, value: "SECONDSHIFT" };
    }
    static {
      this.THIRDSHIFT = { type: 3, value: "THIRDSHIFT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcWorkCalendarTypeEnum = IfcWorkCalendarTypeEnum;
  class IfcWorkPlanTypeEnum {
    static {
      this.ACTUAL = { type: 3, value: "ACTUAL" };
    }
    static {
      this.BASELINE = { type: 3, value: "BASELINE" };
    }
    static {
      this.PLANNED = { type: 3, value: "PLANNED" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcWorkPlanTypeEnum = IfcWorkPlanTypeEnum;
  class IfcWorkScheduleTypeEnum {
    static {
      this.ACTUAL = { type: 3, value: "ACTUAL" };
    }
    static {
      this.BASELINE = { type: 3, value: "BASELINE" };
    }
    static {
      this.PLANNED = { type: 3, value: "PLANNED" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC42.IfcWorkScheduleTypeEnum = IfcWorkScheduleTypeEnum;
  class IfcActorRole extends IfcLineObject {
    constructor(Role, UserDefinedRole, Description) {
      super();
      this.Role = Role;
      this.UserDefinedRole = UserDefinedRole;
      this.Description = Description;
      this.type = 3630933823;
    }
  }
  IFC42.IfcActorRole = IfcActorRole;
  class IfcAddress extends IfcLineObject {
    constructor(Purpose, Description, UserDefinedPurpose) {
      super();
      this.Purpose = Purpose;
      this.Description = Description;
      this.UserDefinedPurpose = UserDefinedPurpose;
      this.type = 618182010;
    }
  }
  IFC42.IfcAddress = IfcAddress;
  class IfcApplication extends IfcLineObject {
    constructor(ApplicationDeveloper, Version, ApplicationFullName, ApplicationIdentifier) {
      super();
      this.ApplicationDeveloper = ApplicationDeveloper;
      this.Version = Version;
      this.ApplicationFullName = ApplicationFullName;
      this.ApplicationIdentifier = ApplicationIdentifier;
      this.type = 639542469;
    }
  }
  IFC42.IfcApplication = IfcApplication;
  class IfcAppliedValue extends IfcLineObject {
    constructor(Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate, Category, Condition, ArithmeticOperator, Components) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.AppliedValue = AppliedValue;
      this.UnitBasis = UnitBasis;
      this.ApplicableDate = ApplicableDate;
      this.FixedUntilDate = FixedUntilDate;
      this.Category = Category;
      this.Condition = Condition;
      this.ArithmeticOperator = ArithmeticOperator;
      this.Components = Components;
      this.type = 411424972;
    }
  }
  IFC42.IfcAppliedValue = IfcAppliedValue;
  class IfcApproval extends IfcLineObject {
    constructor(Identifier, Name, Description, TimeOfApproval, Status, Level, Qualifier, RequestingApproval, GivingApproval) {
      super();
      this.Identifier = Identifier;
      this.Name = Name;
      this.Description = Description;
      this.TimeOfApproval = TimeOfApproval;
      this.Status = Status;
      this.Level = Level;
      this.Qualifier = Qualifier;
      this.RequestingApproval = RequestingApproval;
      this.GivingApproval = GivingApproval;
      this.type = 130549933;
    }
  }
  IFC42.IfcApproval = IfcApproval;
  class IfcBoundaryCondition extends IfcLineObject {
    constructor(Name) {
      super();
      this.Name = Name;
      this.type = 4037036970;
    }
  }
  IFC42.IfcBoundaryCondition = IfcBoundaryCondition;
  class IfcBoundaryEdgeCondition extends IfcBoundaryCondition {
    constructor(Name, TranslationalStiffnessByLengthX, TranslationalStiffnessByLengthY, TranslationalStiffnessByLengthZ, RotationalStiffnessByLengthX, RotationalStiffnessByLengthY, RotationalStiffnessByLengthZ) {
      super(Name);
      this.Name = Name;
      this.TranslationalStiffnessByLengthX = TranslationalStiffnessByLengthX;
      this.TranslationalStiffnessByLengthY = TranslationalStiffnessByLengthY;
      this.TranslationalStiffnessByLengthZ = TranslationalStiffnessByLengthZ;
      this.RotationalStiffnessByLengthX = RotationalStiffnessByLengthX;
      this.RotationalStiffnessByLengthY = RotationalStiffnessByLengthY;
      this.RotationalStiffnessByLengthZ = RotationalStiffnessByLengthZ;
      this.type = 1560379544;
    }
  }
  IFC42.IfcBoundaryEdgeCondition = IfcBoundaryEdgeCondition;
  class IfcBoundaryFaceCondition extends IfcBoundaryCondition {
    constructor(Name, TranslationalStiffnessByAreaX, TranslationalStiffnessByAreaY, TranslationalStiffnessByAreaZ) {
      super(Name);
      this.Name = Name;
      this.TranslationalStiffnessByAreaX = TranslationalStiffnessByAreaX;
      this.TranslationalStiffnessByAreaY = TranslationalStiffnessByAreaY;
      this.TranslationalStiffnessByAreaZ = TranslationalStiffnessByAreaZ;
      this.type = 3367102660;
    }
  }
  IFC42.IfcBoundaryFaceCondition = IfcBoundaryFaceCondition;
  class IfcBoundaryNodeCondition extends IfcBoundaryCondition {
    constructor(Name, TranslationalStiffnessX, TranslationalStiffnessY, TranslationalStiffnessZ, RotationalStiffnessX, RotationalStiffnessY, RotationalStiffnessZ) {
      super(Name);
      this.Name = Name;
      this.TranslationalStiffnessX = TranslationalStiffnessX;
      this.TranslationalStiffnessY = TranslationalStiffnessY;
      this.TranslationalStiffnessZ = TranslationalStiffnessZ;
      this.RotationalStiffnessX = RotationalStiffnessX;
      this.RotationalStiffnessY = RotationalStiffnessY;
      this.RotationalStiffnessZ = RotationalStiffnessZ;
      this.type = 1387855156;
    }
  }
  IFC42.IfcBoundaryNodeCondition = IfcBoundaryNodeCondition;
  class IfcBoundaryNodeConditionWarping extends IfcBoundaryNodeCondition {
    constructor(Name, TranslationalStiffnessX, TranslationalStiffnessY, TranslationalStiffnessZ, RotationalStiffnessX, RotationalStiffnessY, RotationalStiffnessZ, WarpingStiffness) {
      super(Name, TranslationalStiffnessX, TranslationalStiffnessY, TranslationalStiffnessZ, RotationalStiffnessX, RotationalStiffnessY, RotationalStiffnessZ);
      this.Name = Name;
      this.TranslationalStiffnessX = TranslationalStiffnessX;
      this.TranslationalStiffnessY = TranslationalStiffnessY;
      this.TranslationalStiffnessZ = TranslationalStiffnessZ;
      this.RotationalStiffnessX = RotationalStiffnessX;
      this.RotationalStiffnessY = RotationalStiffnessY;
      this.RotationalStiffnessZ = RotationalStiffnessZ;
      this.WarpingStiffness = WarpingStiffness;
      this.type = 2069777674;
    }
  }
  IFC42.IfcBoundaryNodeConditionWarping = IfcBoundaryNodeConditionWarping;
  class IfcConnectionGeometry extends IfcLineObject {
    constructor() {
      super();
      this.type = 2859738748;
    }
  }
  IFC42.IfcConnectionGeometry = IfcConnectionGeometry;
  class IfcConnectionPointGeometry extends IfcConnectionGeometry {
    constructor(PointOnRelatingElement, PointOnRelatedElement) {
      super();
      this.PointOnRelatingElement = PointOnRelatingElement;
      this.PointOnRelatedElement = PointOnRelatedElement;
      this.type = 2614616156;
    }
  }
  IFC42.IfcConnectionPointGeometry = IfcConnectionPointGeometry;
  class IfcConnectionSurfaceGeometry extends IfcConnectionGeometry {
    constructor(SurfaceOnRelatingElement, SurfaceOnRelatedElement) {
      super();
      this.SurfaceOnRelatingElement = SurfaceOnRelatingElement;
      this.SurfaceOnRelatedElement = SurfaceOnRelatedElement;
      this.type = 2732653382;
    }
  }
  IFC42.IfcConnectionSurfaceGeometry = IfcConnectionSurfaceGeometry;
  class IfcConnectionVolumeGeometry extends IfcConnectionGeometry {
    constructor(VolumeOnRelatingElement, VolumeOnRelatedElement) {
      super();
      this.VolumeOnRelatingElement = VolumeOnRelatingElement;
      this.VolumeOnRelatedElement = VolumeOnRelatedElement;
      this.type = 775493141;
    }
  }
  IFC42.IfcConnectionVolumeGeometry = IfcConnectionVolumeGeometry;
  class IfcConstraint extends IfcLineObject {
    constructor(Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.ConstraintGrade = ConstraintGrade;
      this.ConstraintSource = ConstraintSource;
      this.CreatingActor = CreatingActor;
      this.CreationTime = CreationTime;
      this.UserDefinedGrade = UserDefinedGrade;
      this.type = 1959218052;
    }
  }
  IFC42.IfcConstraint = IfcConstraint;
  class IfcCoordinateOperation extends IfcLineObject {
    constructor(SourceCRS, TargetCRS) {
      super();
      this.SourceCRS = SourceCRS;
      this.TargetCRS = TargetCRS;
      this.type = 1785450214;
    }
  }
  IFC42.IfcCoordinateOperation = IfcCoordinateOperation;
  class IfcCoordinateReferenceSystem extends IfcLineObject {
    constructor(Name, Description, GeodeticDatum, VerticalDatum) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.GeodeticDatum = GeodeticDatum;
      this.VerticalDatum = VerticalDatum;
      this.type = 1466758467;
    }
  }
  IFC42.IfcCoordinateReferenceSystem = IfcCoordinateReferenceSystem;
  class IfcCostValue extends IfcAppliedValue {
    constructor(Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate, Category, Condition, ArithmeticOperator, Components) {
      super(Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate, Category, Condition, ArithmeticOperator, Components);
      this.Name = Name;
      this.Description = Description;
      this.AppliedValue = AppliedValue;
      this.UnitBasis = UnitBasis;
      this.ApplicableDate = ApplicableDate;
      this.FixedUntilDate = FixedUntilDate;
      this.Category = Category;
      this.Condition = Condition;
      this.ArithmeticOperator = ArithmeticOperator;
      this.Components = Components;
      this.type = 602808272;
    }
  }
  IFC42.IfcCostValue = IfcCostValue;
  class IfcDerivedUnit extends IfcLineObject {
    constructor(Elements, UnitType, UserDefinedType) {
      super();
      this.Elements = Elements;
      this.UnitType = UnitType;
      this.UserDefinedType = UserDefinedType;
      this.type = 1765591967;
    }
  }
  IFC42.IfcDerivedUnit = IfcDerivedUnit;
  class IfcDerivedUnitElement extends IfcLineObject {
    constructor(Unit, Exponent) {
      super();
      this.Unit = Unit;
      this.Exponent = Exponent;
      this.type = 1045800335;
    }
  }
  IFC42.IfcDerivedUnitElement = IfcDerivedUnitElement;
  class IfcDimensionalExponents extends IfcLineObject {
    constructor(LengthExponent, MassExponent, TimeExponent, ElectricCurrentExponent, ThermodynamicTemperatureExponent, AmountOfSubstanceExponent, LuminousIntensityExponent) {
      super();
      this.LengthExponent = LengthExponent;
      this.MassExponent = MassExponent;
      this.TimeExponent = TimeExponent;
      this.ElectricCurrentExponent = ElectricCurrentExponent;
      this.ThermodynamicTemperatureExponent = ThermodynamicTemperatureExponent;
      this.AmountOfSubstanceExponent = AmountOfSubstanceExponent;
      this.LuminousIntensityExponent = LuminousIntensityExponent;
      this.type = 2949456006;
    }
  }
  IFC42.IfcDimensionalExponents = IfcDimensionalExponents;
  class IfcExternalInformation extends IfcLineObject {
    constructor() {
      super();
      this.type = 4294318154;
    }
  }
  IFC42.IfcExternalInformation = IfcExternalInformation;
  class IfcExternalReference extends IfcLineObject {
    constructor(Location, Identification, Name) {
      super();
      this.Location = Location;
      this.Identification = Identification;
      this.Name = Name;
      this.type = 3200245327;
    }
  }
  IFC42.IfcExternalReference = IfcExternalReference;
  class IfcExternallyDefinedHatchStyle extends IfcExternalReference {
    constructor(Location, Identification, Name) {
      super(Location, Identification, Name);
      this.Location = Location;
      this.Identification = Identification;
      this.Name = Name;
      this.type = 2242383968;
    }
  }
  IFC42.IfcExternallyDefinedHatchStyle = IfcExternallyDefinedHatchStyle;
  class IfcExternallyDefinedSurfaceStyle extends IfcExternalReference {
    constructor(Location, Identification, Name) {
      super(Location, Identification, Name);
      this.Location = Location;
      this.Identification = Identification;
      this.Name = Name;
      this.type = 1040185647;
    }
  }
  IFC42.IfcExternallyDefinedSurfaceStyle = IfcExternallyDefinedSurfaceStyle;
  class IfcExternallyDefinedTextFont extends IfcExternalReference {
    constructor(Location, Identification, Name) {
      super(Location, Identification, Name);
      this.Location = Location;
      this.Identification = Identification;
      this.Name = Name;
      this.type = 3548104201;
    }
  }
  IFC42.IfcExternallyDefinedTextFont = IfcExternallyDefinedTextFont;
  class IfcGridAxis extends IfcLineObject {
    constructor(AxisTag, AxisCurve, SameSense) {
      super();
      this.AxisTag = AxisTag;
      this.AxisCurve = AxisCurve;
      this.SameSense = SameSense;
      this.type = 852622518;
    }
  }
  IFC42.IfcGridAxis = IfcGridAxis;
  class IfcIrregularTimeSeriesValue extends IfcLineObject {
    constructor(TimeStamp, ListValues) {
      super();
      this.TimeStamp = TimeStamp;
      this.ListValues = ListValues;
      this.type = 3020489413;
    }
  }
  IFC42.IfcIrregularTimeSeriesValue = IfcIrregularTimeSeriesValue;
  class IfcLibraryInformation extends IfcExternalInformation {
    constructor(Name, Version, Publisher, VersionDate, Location, Description) {
      super();
      this.Name = Name;
      this.Version = Version;
      this.Publisher = Publisher;
      this.VersionDate = VersionDate;
      this.Location = Location;
      this.Description = Description;
      this.type = 2655187982;
    }
  }
  IFC42.IfcLibraryInformation = IfcLibraryInformation;
  class IfcLibraryReference extends IfcExternalReference {
    constructor(Location, Identification, Name, Description, Language, ReferencedLibrary) {
      super(Location, Identification, Name);
      this.Location = Location;
      this.Identification = Identification;
      this.Name = Name;
      this.Description = Description;
      this.Language = Language;
      this.ReferencedLibrary = ReferencedLibrary;
      this.type = 3452421091;
    }
  }
  IFC42.IfcLibraryReference = IfcLibraryReference;
  class IfcLightDistributionData extends IfcLineObject {
    constructor(MainPlaneAngle, SecondaryPlaneAngle, LuminousIntensity) {
      super();
      this.MainPlaneAngle = MainPlaneAngle;
      this.SecondaryPlaneAngle = SecondaryPlaneAngle;
      this.LuminousIntensity = LuminousIntensity;
      this.type = 4162380809;
    }
  }
  IFC42.IfcLightDistributionData = IfcLightDistributionData;
  class IfcLightIntensityDistribution extends IfcLineObject {
    constructor(LightDistributionCurve, DistributionData) {
      super();
      this.LightDistributionCurve = LightDistributionCurve;
      this.DistributionData = DistributionData;
      this.type = 1566485204;
    }
  }
  IFC42.IfcLightIntensityDistribution = IfcLightIntensityDistribution;
  class IfcMapConversion extends IfcCoordinateOperation {
    constructor(SourceCRS, TargetCRS, Eastings, Northings, OrthogonalHeight, XAxisAbscissa, XAxisOrdinate, Scale) {
      super(SourceCRS, TargetCRS);
      this.SourceCRS = SourceCRS;
      this.TargetCRS = TargetCRS;
      this.Eastings = Eastings;
      this.Northings = Northings;
      this.OrthogonalHeight = OrthogonalHeight;
      this.XAxisAbscissa = XAxisAbscissa;
      this.XAxisOrdinate = XAxisOrdinate;
      this.Scale = Scale;
      this.type = 3057273783;
    }
  }
  IFC42.IfcMapConversion = IfcMapConversion;
  class IfcMaterialClassificationRelationship extends IfcLineObject {
    constructor(MaterialClassifications, ClassifiedMaterial) {
      super();
      this.MaterialClassifications = MaterialClassifications;
      this.ClassifiedMaterial = ClassifiedMaterial;
      this.type = 1847130766;
    }
  }
  IFC42.IfcMaterialClassificationRelationship = IfcMaterialClassificationRelationship;
  class IfcMaterialDefinition extends IfcLineObject {
    constructor() {
      super();
      this.type = 760658860;
    }
  }
  IFC42.IfcMaterialDefinition = IfcMaterialDefinition;
  class IfcMaterialLayer extends IfcMaterialDefinition {
    constructor(Material, LayerThickness, IsVentilated, Name, Description, Category, Priority) {
      super();
      this.Material = Material;
      this.LayerThickness = LayerThickness;
      this.IsVentilated = IsVentilated;
      this.Name = Name;
      this.Description = Description;
      this.Category = Category;
      this.Priority = Priority;
      this.type = 248100487;
    }
  }
  IFC42.IfcMaterialLayer = IfcMaterialLayer;
  class IfcMaterialLayerSet extends IfcMaterialDefinition {
    constructor(MaterialLayers, LayerSetName, Description) {
      super();
      this.MaterialLayers = MaterialLayers;
      this.LayerSetName = LayerSetName;
      this.Description = Description;
      this.type = 3303938423;
    }
  }
  IFC42.IfcMaterialLayerSet = IfcMaterialLayerSet;
  class IfcMaterialLayerWithOffsets extends IfcMaterialLayer {
    constructor(Material, LayerThickness, IsVentilated, Name, Description, Category, Priority, OffsetDirection, OffsetValues) {
      super(Material, LayerThickness, IsVentilated, Name, Description, Category, Priority);
      this.Material = Material;
      this.LayerThickness = LayerThickness;
      this.IsVentilated = IsVentilated;
      this.Name = Name;
      this.Description = Description;
      this.Category = Category;
      this.Priority = Priority;
      this.OffsetDirection = OffsetDirection;
      this.OffsetValues = OffsetValues;
      this.type = 1847252529;
    }
  }
  IFC42.IfcMaterialLayerWithOffsets = IfcMaterialLayerWithOffsets;
  class IfcMaterialList extends IfcLineObject {
    constructor(Materials) {
      super();
      this.Materials = Materials;
      this.type = 2199411900;
    }
  }
  IFC42.IfcMaterialList = IfcMaterialList;
  class IfcMaterialProfile extends IfcMaterialDefinition {
    constructor(Name, Description, Material, Profile, Priority, Category) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.Material = Material;
      this.Profile = Profile;
      this.Priority = Priority;
      this.Category = Category;
      this.type = 2235152071;
    }
  }
  IFC42.IfcMaterialProfile = IfcMaterialProfile;
  class IfcMaterialProfileSet extends IfcMaterialDefinition {
    constructor(Name, Description, MaterialProfiles, CompositeProfile) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.MaterialProfiles = MaterialProfiles;
      this.CompositeProfile = CompositeProfile;
      this.type = 164193824;
    }
  }
  IFC42.IfcMaterialProfileSet = IfcMaterialProfileSet;
  class IfcMaterialProfileWithOffsets extends IfcMaterialProfile {
    constructor(Name, Description, Material, Profile, Priority, Category, OffsetValues) {
      super(Name, Description, Material, Profile, Priority, Category);
      this.Name = Name;
      this.Description = Description;
      this.Material = Material;
      this.Profile = Profile;
      this.Priority = Priority;
      this.Category = Category;
      this.OffsetValues = OffsetValues;
      this.type = 552965576;
    }
  }
  IFC42.IfcMaterialProfileWithOffsets = IfcMaterialProfileWithOffsets;
  class IfcMaterialUsageDefinition extends IfcLineObject {
    constructor() {
      super();
      this.type = 1507914824;
    }
  }
  IFC42.IfcMaterialUsageDefinition = IfcMaterialUsageDefinition;
  class IfcMeasureWithUnit extends IfcLineObject {
    constructor(ValueComponent, UnitComponent) {
      super();
      this.ValueComponent = ValueComponent;
      this.UnitComponent = UnitComponent;
      this.type = 2597039031;
    }
  }
  IFC42.IfcMeasureWithUnit = IfcMeasureWithUnit;
  class IfcMetric extends IfcConstraint {
    constructor(Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade, Benchmark, ValueSource, DataValue, ReferencePath) {
      super(Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade);
      this.Name = Name;
      this.Description = Description;
      this.ConstraintGrade = ConstraintGrade;
      this.ConstraintSource = ConstraintSource;
      this.CreatingActor = CreatingActor;
      this.CreationTime = CreationTime;
      this.UserDefinedGrade = UserDefinedGrade;
      this.Benchmark = Benchmark;
      this.ValueSource = ValueSource;
      this.DataValue = DataValue;
      this.ReferencePath = ReferencePath;
      this.type = 3368373690;
    }
  }
  IFC42.IfcMetric = IfcMetric;
  class IfcMonetaryUnit extends IfcLineObject {
    constructor(Currency) {
      super();
      this.Currency = Currency;
      this.type = 2706619895;
    }
  }
  IFC42.IfcMonetaryUnit = IfcMonetaryUnit;
  class IfcNamedUnit extends IfcLineObject {
    constructor(Dimensions, UnitType) {
      super();
      this.Dimensions = Dimensions;
      this.UnitType = UnitType;
      this.type = 1918398963;
    }
  }
  IFC42.IfcNamedUnit = IfcNamedUnit;
  class IfcObjectPlacement extends IfcLineObject {
    constructor() {
      super();
      this.type = 3701648758;
    }
  }
  IFC42.IfcObjectPlacement = IfcObjectPlacement;
  class IfcObjective extends IfcConstraint {
    constructor(Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade, BenchmarkValues, LogicalAggregator, ObjectiveQualifier, UserDefinedQualifier) {
      super(Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade);
      this.Name = Name;
      this.Description = Description;
      this.ConstraintGrade = ConstraintGrade;
      this.ConstraintSource = ConstraintSource;
      this.CreatingActor = CreatingActor;
      this.CreationTime = CreationTime;
      this.UserDefinedGrade = UserDefinedGrade;
      this.BenchmarkValues = BenchmarkValues;
      this.LogicalAggregator = LogicalAggregator;
      this.ObjectiveQualifier = ObjectiveQualifier;
      this.UserDefinedQualifier = UserDefinedQualifier;
      this.type = 2251480897;
    }
  }
  IFC42.IfcObjective = IfcObjective;
  class IfcOrganization extends IfcLineObject {
    constructor(Identification, Name, Description, Roles, Addresses) {
      super();
      this.Identification = Identification;
      this.Name = Name;
      this.Description = Description;
      this.Roles = Roles;
      this.Addresses = Addresses;
      this.type = 4251960020;
    }
  }
  IFC42.IfcOrganization = IfcOrganization;
  class IfcOwnerHistory extends IfcLineObject {
    constructor(OwningUser, OwningApplication, State, ChangeAction, LastModifiedDate, LastModifyingUser, LastModifyingApplication, CreationDate) {
      super();
      this.OwningUser = OwningUser;
      this.OwningApplication = OwningApplication;
      this.State = State;
      this.ChangeAction = ChangeAction;
      this.LastModifiedDate = LastModifiedDate;
      this.LastModifyingUser = LastModifyingUser;
      this.LastModifyingApplication = LastModifyingApplication;
      this.CreationDate = CreationDate;
      this.type = 1207048766;
    }
  }
  IFC42.IfcOwnerHistory = IfcOwnerHistory;
  class IfcPerson extends IfcLineObject {
    constructor(Identification, FamilyName, GivenName, MiddleNames, PrefixTitles, SuffixTitles, Roles, Addresses) {
      super();
      this.Identification = Identification;
      this.FamilyName = FamilyName;
      this.GivenName = GivenName;
      this.MiddleNames = MiddleNames;
      this.PrefixTitles = PrefixTitles;
      this.SuffixTitles = SuffixTitles;
      this.Roles = Roles;
      this.Addresses = Addresses;
      this.type = 2077209135;
    }
  }
  IFC42.IfcPerson = IfcPerson;
  class IfcPersonAndOrganization extends IfcLineObject {
    constructor(ThePerson, TheOrganization, Roles) {
      super();
      this.ThePerson = ThePerson;
      this.TheOrganization = TheOrganization;
      this.Roles = Roles;
      this.type = 101040310;
    }
  }
  IFC42.IfcPersonAndOrganization = IfcPersonAndOrganization;
  class IfcPhysicalQuantity extends IfcLineObject {
    constructor(Name, Description) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.type = 2483315170;
    }
  }
  IFC42.IfcPhysicalQuantity = IfcPhysicalQuantity;
  class IfcPhysicalSimpleQuantity extends IfcPhysicalQuantity {
    constructor(Name, Description, Unit) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.type = 2226359599;
    }
  }
  IFC42.IfcPhysicalSimpleQuantity = IfcPhysicalSimpleQuantity;
  class IfcPostalAddress extends IfcAddress {
    constructor(Purpose, Description, UserDefinedPurpose, InternalLocation, AddressLines, PostalBox, Town, Region, PostalCode, Country) {
      super(Purpose, Description, UserDefinedPurpose);
      this.Purpose = Purpose;
      this.Description = Description;
      this.UserDefinedPurpose = UserDefinedPurpose;
      this.InternalLocation = InternalLocation;
      this.AddressLines = AddressLines;
      this.PostalBox = PostalBox;
      this.Town = Town;
      this.Region = Region;
      this.PostalCode = PostalCode;
      this.Country = Country;
      this.type = 3355820592;
    }
  }
  IFC42.IfcPostalAddress = IfcPostalAddress;
  class IfcPresentationItem extends IfcLineObject {
    constructor() {
      super();
      this.type = 677532197;
    }
  }
  IFC42.IfcPresentationItem = IfcPresentationItem;
  class IfcPresentationLayerAssignment extends IfcLineObject {
    constructor(Name, Description, AssignedItems, Identifier) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.AssignedItems = AssignedItems;
      this.Identifier = Identifier;
      this.type = 2022622350;
    }
  }
  IFC42.IfcPresentationLayerAssignment = IfcPresentationLayerAssignment;
  class IfcPresentationLayerWithStyle extends IfcPresentationLayerAssignment {
    constructor(Name, Description, AssignedItems, Identifier, LayerOn, LayerFrozen, LayerBlocked, LayerStyles) {
      super(Name, Description, AssignedItems, Identifier);
      this.Name = Name;
      this.Description = Description;
      this.AssignedItems = AssignedItems;
      this.Identifier = Identifier;
      this.LayerOn = LayerOn;
      this.LayerFrozen = LayerFrozen;
      this.LayerBlocked = LayerBlocked;
      this.LayerStyles = LayerStyles;
      this.type = 1304840413;
    }
  }
  IFC42.IfcPresentationLayerWithStyle = IfcPresentationLayerWithStyle;
  class IfcPresentationStyle extends IfcLineObject {
    constructor(Name) {
      super();
      this.Name = Name;
      this.type = 3119450353;
    }
  }
  IFC42.IfcPresentationStyle = IfcPresentationStyle;
  class IfcPresentationStyleAssignment extends IfcLineObject {
    constructor(Styles) {
      super();
      this.Styles = Styles;
      this.type = 2417041796;
    }
  }
  IFC42.IfcPresentationStyleAssignment = IfcPresentationStyleAssignment;
  class IfcProductRepresentation extends IfcLineObject {
    constructor(Name, Description, Representations) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.Representations = Representations;
      this.type = 2095639259;
    }
  }
  IFC42.IfcProductRepresentation = IfcProductRepresentation;
  class IfcProfileDef extends IfcLineObject {
    constructor(ProfileType, ProfileName) {
      super();
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.type = 3958567839;
    }
  }
  IFC42.IfcProfileDef = IfcProfileDef;
  class IfcProjectedCRS extends IfcCoordinateReferenceSystem {
    constructor(Name, Description, GeodeticDatum, VerticalDatum, MapProjection, MapZone, MapUnit) {
      super(Name, Description, GeodeticDatum, VerticalDatum);
      this.Name = Name;
      this.Description = Description;
      this.GeodeticDatum = GeodeticDatum;
      this.VerticalDatum = VerticalDatum;
      this.MapProjection = MapProjection;
      this.MapZone = MapZone;
      this.MapUnit = MapUnit;
      this.type = 3843373140;
    }
  }
  IFC42.IfcProjectedCRS = IfcProjectedCRS;
  class IfcPropertyAbstraction extends IfcLineObject {
    constructor() {
      super();
      this.type = 986844984;
    }
  }
  IFC42.IfcPropertyAbstraction = IfcPropertyAbstraction;
  class IfcPropertyEnumeration extends IfcPropertyAbstraction {
    constructor(Name, EnumerationValues, Unit) {
      super();
      this.Name = Name;
      this.EnumerationValues = EnumerationValues;
      this.Unit = Unit;
      this.type = 3710013099;
    }
  }
  IFC42.IfcPropertyEnumeration = IfcPropertyEnumeration;
  class IfcQuantityArea extends IfcPhysicalSimpleQuantity {
    constructor(Name, Description, Unit, AreaValue, Formula) {
      super(Name, Description, Unit);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.AreaValue = AreaValue;
      this.Formula = Formula;
      this.type = 2044713172;
    }
  }
  IFC42.IfcQuantityArea = IfcQuantityArea;
  class IfcQuantityCount extends IfcPhysicalSimpleQuantity {
    constructor(Name, Description, Unit, CountValue, Formula) {
      super(Name, Description, Unit);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.CountValue = CountValue;
      this.Formula = Formula;
      this.type = 2093928680;
    }
  }
  IFC42.IfcQuantityCount = IfcQuantityCount;
  class IfcQuantityLength extends IfcPhysicalSimpleQuantity {
    constructor(Name, Description, Unit, LengthValue, Formula) {
      super(Name, Description, Unit);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.LengthValue = LengthValue;
      this.Formula = Formula;
      this.type = 931644368;
    }
  }
  IFC42.IfcQuantityLength = IfcQuantityLength;
  class IfcQuantityTime extends IfcPhysicalSimpleQuantity {
    constructor(Name, Description, Unit, TimeValue, Formula) {
      super(Name, Description, Unit);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.TimeValue = TimeValue;
      this.Formula = Formula;
      this.type = 3252649465;
    }
  }
  IFC42.IfcQuantityTime = IfcQuantityTime;
  class IfcQuantityVolume extends IfcPhysicalSimpleQuantity {
    constructor(Name, Description, Unit, VolumeValue, Formula) {
      super(Name, Description, Unit);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.VolumeValue = VolumeValue;
      this.Formula = Formula;
      this.type = 2405470396;
    }
  }
  IFC42.IfcQuantityVolume = IfcQuantityVolume;
  class IfcQuantityWeight extends IfcPhysicalSimpleQuantity {
    constructor(Name, Description, Unit, WeightValue, Formula) {
      super(Name, Description, Unit);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.WeightValue = WeightValue;
      this.Formula = Formula;
      this.type = 825690147;
    }
  }
  IFC42.IfcQuantityWeight = IfcQuantityWeight;
  class IfcRecurrencePattern extends IfcLineObject {
    constructor(RecurrenceType, DayComponent, WeekdayComponent, MonthComponent, Position, Interval, Occurrences, TimePeriods) {
      super();
      this.RecurrenceType = RecurrenceType;
      this.DayComponent = DayComponent;
      this.WeekdayComponent = WeekdayComponent;
      this.MonthComponent = MonthComponent;
      this.Position = Position;
      this.Interval = Interval;
      this.Occurrences = Occurrences;
      this.TimePeriods = TimePeriods;
      this.type = 3915482550;
    }
  }
  IFC42.IfcRecurrencePattern = IfcRecurrencePattern;
  class IfcReference extends IfcLineObject {
    constructor(TypeIdentifier, AttributeIdentifier, InstanceName, ListPositions, InnerReference) {
      super();
      this.TypeIdentifier = TypeIdentifier;
      this.AttributeIdentifier = AttributeIdentifier;
      this.InstanceName = InstanceName;
      this.ListPositions = ListPositions;
      this.InnerReference = InnerReference;
      this.type = 2433181523;
    }
  }
  IFC42.IfcReference = IfcReference;
  class IfcRepresentation extends IfcLineObject {
    constructor(ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      super();
      this.ContextOfItems = ContextOfItems;
      this.RepresentationIdentifier = RepresentationIdentifier;
      this.RepresentationType = RepresentationType;
      this.Items = Items;
      this.type = 1076942058;
    }
  }
  IFC42.IfcRepresentation = IfcRepresentation;
  class IfcRepresentationContext extends IfcLineObject {
    constructor(ContextIdentifier, ContextType) {
      super();
      this.ContextIdentifier = ContextIdentifier;
      this.ContextType = ContextType;
      this.type = 3377609919;
    }
  }
  IFC42.IfcRepresentationContext = IfcRepresentationContext;
  class IfcRepresentationItem extends IfcLineObject {
    constructor() {
      super();
      this.type = 3008791417;
    }
  }
  IFC42.IfcRepresentationItem = IfcRepresentationItem;
  class IfcRepresentationMap extends IfcLineObject {
    constructor(MappingOrigin, MappedRepresentation) {
      super();
      this.MappingOrigin = MappingOrigin;
      this.MappedRepresentation = MappedRepresentation;
      this.type = 1660063152;
    }
  }
  IFC42.IfcRepresentationMap = IfcRepresentationMap;
  class IfcResourceLevelRelationship extends IfcLineObject {
    constructor(Name, Description) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.type = 2439245199;
    }
  }
  IFC42.IfcResourceLevelRelationship = IfcResourceLevelRelationship;
  class IfcRoot extends IfcLineObject {
    constructor(GlobalId, OwnerHistory, Name, Description) {
      super();
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 2341007311;
    }
  }
  IFC42.IfcRoot = IfcRoot;
  class IfcSIUnit extends IfcNamedUnit {
    constructor(UnitType, Prefix, Name) {
      super(new Handle(0), UnitType);
      this.UnitType = UnitType;
      this.Prefix = Prefix;
      this.Name = Name;
      this.type = 448429030;
    }
  }
  IFC42.IfcSIUnit = IfcSIUnit;
  class IfcSchedulingTime extends IfcLineObject {
    constructor(Name, DataOrigin, UserDefinedDataOrigin) {
      super();
      this.Name = Name;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.type = 1054537805;
    }
  }
  IFC42.IfcSchedulingTime = IfcSchedulingTime;
  class IfcShapeAspect extends IfcLineObject {
    constructor(ShapeRepresentations, Name, Description, ProductDefinitional, PartOfProductDefinitionShape) {
      super();
      this.ShapeRepresentations = ShapeRepresentations;
      this.Name = Name;
      this.Description = Description;
      this.ProductDefinitional = ProductDefinitional;
      this.PartOfProductDefinitionShape = PartOfProductDefinitionShape;
      this.type = 867548509;
    }
  }
  IFC42.IfcShapeAspect = IfcShapeAspect;
  class IfcShapeModel extends IfcRepresentation {
    constructor(ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      super(ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      this.ContextOfItems = ContextOfItems;
      this.RepresentationIdentifier = RepresentationIdentifier;
      this.RepresentationType = RepresentationType;
      this.Items = Items;
      this.type = 3982875396;
    }
  }
  IFC42.IfcShapeModel = IfcShapeModel;
  class IfcShapeRepresentation extends IfcShapeModel {
    constructor(ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      super(ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      this.ContextOfItems = ContextOfItems;
      this.RepresentationIdentifier = RepresentationIdentifier;
      this.RepresentationType = RepresentationType;
      this.Items = Items;
      this.type = 4240577450;
    }
  }
  IFC42.IfcShapeRepresentation = IfcShapeRepresentation;
  class IfcStructuralConnectionCondition extends IfcLineObject {
    constructor(Name) {
      super();
      this.Name = Name;
      this.type = 2273995522;
    }
  }
  IFC42.IfcStructuralConnectionCondition = IfcStructuralConnectionCondition;
  class IfcStructuralLoad extends IfcLineObject {
    constructor(Name) {
      super();
      this.Name = Name;
      this.type = 2162789131;
    }
  }
  IFC42.IfcStructuralLoad = IfcStructuralLoad;
  class IfcStructuralLoadConfiguration extends IfcStructuralLoad {
    constructor(Name, Values, Locations) {
      super(Name);
      this.Name = Name;
      this.Values = Values;
      this.Locations = Locations;
      this.type = 3478079324;
    }
  }
  IFC42.IfcStructuralLoadConfiguration = IfcStructuralLoadConfiguration;
  class IfcStructuralLoadOrResult extends IfcStructuralLoad {
    constructor(Name) {
      super(Name);
      this.Name = Name;
      this.type = 609421318;
    }
  }
  IFC42.IfcStructuralLoadOrResult = IfcStructuralLoadOrResult;
  class IfcStructuralLoadStatic extends IfcStructuralLoadOrResult {
    constructor(Name) {
      super(Name);
      this.Name = Name;
      this.type = 2525727697;
    }
  }
  IFC42.IfcStructuralLoadStatic = IfcStructuralLoadStatic;
  class IfcStructuralLoadTemperature extends IfcStructuralLoadStatic {
    constructor(Name, DeltaTConstant, DeltaTY, DeltaTZ) {
      super(Name);
      this.Name = Name;
      this.DeltaTConstant = DeltaTConstant;
      this.DeltaTY = DeltaTY;
      this.DeltaTZ = DeltaTZ;
      this.type = 3408363356;
    }
  }
  IFC42.IfcStructuralLoadTemperature = IfcStructuralLoadTemperature;
  class IfcStyleModel extends IfcRepresentation {
    constructor(ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      super(ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      this.ContextOfItems = ContextOfItems;
      this.RepresentationIdentifier = RepresentationIdentifier;
      this.RepresentationType = RepresentationType;
      this.Items = Items;
      this.type = 2830218821;
    }
  }
  IFC42.IfcStyleModel = IfcStyleModel;
  class IfcStyledItem extends IfcRepresentationItem {
    constructor(Item, Styles, Name) {
      super();
      this.Item = Item;
      this.Styles = Styles;
      this.Name = Name;
      this.type = 3958052878;
    }
  }
  IFC42.IfcStyledItem = IfcStyledItem;
  class IfcStyledRepresentation extends IfcStyleModel {
    constructor(ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      super(ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      this.ContextOfItems = ContextOfItems;
      this.RepresentationIdentifier = RepresentationIdentifier;
      this.RepresentationType = RepresentationType;
      this.Items = Items;
      this.type = 3049322572;
    }
  }
  IFC42.IfcStyledRepresentation = IfcStyledRepresentation;
  class IfcSurfaceReinforcementArea extends IfcStructuralLoadOrResult {
    constructor(Name, SurfaceReinforcement1, SurfaceReinforcement2, ShearReinforcement) {
      super(Name);
      this.Name = Name;
      this.SurfaceReinforcement1 = SurfaceReinforcement1;
      this.SurfaceReinforcement2 = SurfaceReinforcement2;
      this.ShearReinforcement = ShearReinforcement;
      this.type = 2934153892;
    }
  }
  IFC42.IfcSurfaceReinforcementArea = IfcSurfaceReinforcementArea;
  class IfcSurfaceStyle extends IfcPresentationStyle {
    constructor(Name, Side, Styles) {
      super(Name);
      this.Name = Name;
      this.Side = Side;
      this.Styles = Styles;
      this.type = 1300840506;
    }
  }
  IFC42.IfcSurfaceStyle = IfcSurfaceStyle;
  class IfcSurfaceStyleLighting extends IfcPresentationItem {
    constructor(DiffuseTransmissionColour, DiffuseReflectionColour, TransmissionColour, ReflectanceColour) {
      super();
      this.DiffuseTransmissionColour = DiffuseTransmissionColour;
      this.DiffuseReflectionColour = DiffuseReflectionColour;
      this.TransmissionColour = TransmissionColour;
      this.ReflectanceColour = ReflectanceColour;
      this.type = 3303107099;
    }
  }
  IFC42.IfcSurfaceStyleLighting = IfcSurfaceStyleLighting;
  class IfcSurfaceStyleRefraction extends IfcPresentationItem {
    constructor(RefractionIndex, DispersionFactor) {
      super();
      this.RefractionIndex = RefractionIndex;
      this.DispersionFactor = DispersionFactor;
      this.type = 1607154358;
    }
  }
  IFC42.IfcSurfaceStyleRefraction = IfcSurfaceStyleRefraction;
  class IfcSurfaceStyleShading extends IfcPresentationItem {
    constructor(SurfaceColour, Transparency) {
      super();
      this.SurfaceColour = SurfaceColour;
      this.Transparency = Transparency;
      this.type = 846575682;
    }
  }
  IFC42.IfcSurfaceStyleShading = IfcSurfaceStyleShading;
  class IfcSurfaceStyleWithTextures extends IfcPresentationItem {
    constructor(Textures) {
      super();
      this.Textures = Textures;
      this.type = 1351298697;
    }
  }
  IFC42.IfcSurfaceStyleWithTextures = IfcSurfaceStyleWithTextures;
  class IfcSurfaceTexture extends IfcPresentationItem {
    constructor(RepeatS, RepeatT, Mode, TextureTransform, Parameter) {
      super();
      this.RepeatS = RepeatS;
      this.RepeatT = RepeatT;
      this.Mode = Mode;
      this.TextureTransform = TextureTransform;
      this.Parameter = Parameter;
      this.type = 626085974;
    }
  }
  IFC42.IfcSurfaceTexture = IfcSurfaceTexture;
  class IfcTable extends IfcLineObject {
    constructor(Name, Rows, Columns) {
      super();
      this.Name = Name;
      this.Rows = Rows;
      this.Columns = Columns;
      this.type = 985171141;
    }
  }
  IFC42.IfcTable = IfcTable;
  class IfcTableColumn extends IfcLineObject {
    constructor(Identifier, Name, Description, Unit, ReferencePath) {
      super();
      this.Identifier = Identifier;
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.ReferencePath = ReferencePath;
      this.type = 2043862942;
    }
  }
  IFC42.IfcTableColumn = IfcTableColumn;
  class IfcTableRow extends IfcLineObject {
    constructor(RowCells, IsHeading) {
      super();
      this.RowCells = RowCells;
      this.IsHeading = IsHeading;
      this.type = 531007025;
    }
  }
  IFC42.IfcTableRow = IfcTableRow;
  class IfcTaskTime extends IfcSchedulingTime {
    constructor(Name, DataOrigin, UserDefinedDataOrigin, DurationType, ScheduleDuration, ScheduleStart, ScheduleFinish, EarlyStart, EarlyFinish, LateStart, LateFinish, FreeFloat, TotalFloat, IsCritical, StatusTime, ActualDuration, ActualStart, ActualFinish, RemainingTime, Completion) {
      super(Name, DataOrigin, UserDefinedDataOrigin);
      this.Name = Name;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.DurationType = DurationType;
      this.ScheduleDuration = ScheduleDuration;
      this.ScheduleStart = ScheduleStart;
      this.ScheduleFinish = ScheduleFinish;
      this.EarlyStart = EarlyStart;
      this.EarlyFinish = EarlyFinish;
      this.LateStart = LateStart;
      this.LateFinish = LateFinish;
      this.FreeFloat = FreeFloat;
      this.TotalFloat = TotalFloat;
      this.IsCritical = IsCritical;
      this.StatusTime = StatusTime;
      this.ActualDuration = ActualDuration;
      this.ActualStart = ActualStart;
      this.ActualFinish = ActualFinish;
      this.RemainingTime = RemainingTime;
      this.Completion = Completion;
      this.type = 1549132990;
    }
  }
  IFC42.IfcTaskTime = IfcTaskTime;
  class IfcTaskTimeRecurring extends IfcTaskTime {
    constructor(Name, DataOrigin, UserDefinedDataOrigin, DurationType, ScheduleDuration, ScheduleStart, ScheduleFinish, EarlyStart, EarlyFinish, LateStart, LateFinish, FreeFloat, TotalFloat, IsCritical, StatusTime, ActualDuration, ActualStart, ActualFinish, RemainingTime, Completion, Recurrence) {
      super(Name, DataOrigin, UserDefinedDataOrigin, DurationType, ScheduleDuration, ScheduleStart, ScheduleFinish, EarlyStart, EarlyFinish, LateStart, LateFinish, FreeFloat, TotalFloat, IsCritical, StatusTime, ActualDuration, ActualStart, ActualFinish, RemainingTime, Completion);
      this.Name = Name;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.DurationType = DurationType;
      this.ScheduleDuration = ScheduleDuration;
      this.ScheduleStart = ScheduleStart;
      this.ScheduleFinish = ScheduleFinish;
      this.EarlyStart = EarlyStart;
      this.EarlyFinish = EarlyFinish;
      this.LateStart = LateStart;
      this.LateFinish = LateFinish;
      this.FreeFloat = FreeFloat;
      this.TotalFloat = TotalFloat;
      this.IsCritical = IsCritical;
      this.StatusTime = StatusTime;
      this.ActualDuration = ActualDuration;
      this.ActualStart = ActualStart;
      this.ActualFinish = ActualFinish;
      this.RemainingTime = RemainingTime;
      this.Completion = Completion;
      this.Recurrence = Recurrence;
      this.type = 2771591690;
    }
  }
  IFC42.IfcTaskTimeRecurring = IfcTaskTimeRecurring;
  class IfcTelecomAddress extends IfcAddress {
    constructor(Purpose, Description, UserDefinedPurpose, TelephoneNumbers, FacsimileNumbers, PagerNumber, ElectronicMailAddresses, WWWHomePageURL, MessagingIDs) {
      super(Purpose, Description, UserDefinedPurpose);
      this.Purpose = Purpose;
      this.Description = Description;
      this.UserDefinedPurpose = UserDefinedPurpose;
      this.TelephoneNumbers = TelephoneNumbers;
      this.FacsimileNumbers = FacsimileNumbers;
      this.PagerNumber = PagerNumber;
      this.ElectronicMailAddresses = ElectronicMailAddresses;
      this.WWWHomePageURL = WWWHomePageURL;
      this.MessagingIDs = MessagingIDs;
      this.type = 912023232;
    }
  }
  IFC42.IfcTelecomAddress = IfcTelecomAddress;
  class IfcTextStyle extends IfcPresentationStyle {
    constructor(Name, TextCharacterAppearance, TextStyle, TextFontStyle, ModelOrDraughting) {
      super(Name);
      this.Name = Name;
      this.TextCharacterAppearance = TextCharacterAppearance;
      this.TextStyle = TextStyle;
      this.TextFontStyle = TextFontStyle;
      this.ModelOrDraughting = ModelOrDraughting;
      this.type = 1447204868;
    }
  }
  IFC42.IfcTextStyle = IfcTextStyle;
  class IfcTextStyleForDefinedFont extends IfcPresentationItem {
    constructor(Colour, BackgroundColour) {
      super();
      this.Colour = Colour;
      this.BackgroundColour = BackgroundColour;
      this.type = 2636378356;
    }
  }
  IFC42.IfcTextStyleForDefinedFont = IfcTextStyleForDefinedFont;
  class IfcTextStyleTextModel extends IfcPresentationItem {
    constructor(TextIndent, TextAlign, TextDecoration, LetterSpacing, WordSpacing, TextTransform, LineHeight) {
      super();
      this.TextIndent = TextIndent;
      this.TextAlign = TextAlign;
      this.TextDecoration = TextDecoration;
      this.LetterSpacing = LetterSpacing;
      this.WordSpacing = WordSpacing;
      this.TextTransform = TextTransform;
      this.LineHeight = LineHeight;
      this.type = 1640371178;
    }
  }
  IFC42.IfcTextStyleTextModel = IfcTextStyleTextModel;
  class IfcTextureCoordinate extends IfcPresentationItem {
    constructor(Maps) {
      super();
      this.Maps = Maps;
      this.type = 280115917;
    }
  }
  IFC42.IfcTextureCoordinate = IfcTextureCoordinate;
  class IfcTextureCoordinateGenerator extends IfcTextureCoordinate {
    constructor(Maps, Mode, Parameter) {
      super(Maps);
      this.Maps = Maps;
      this.Mode = Mode;
      this.Parameter = Parameter;
      this.type = 1742049831;
    }
  }
  IFC42.IfcTextureCoordinateGenerator = IfcTextureCoordinateGenerator;
  class IfcTextureMap extends IfcTextureCoordinate {
    constructor(Maps, Vertices, MappedTo) {
      super(Maps);
      this.Maps = Maps;
      this.Vertices = Vertices;
      this.MappedTo = MappedTo;
      this.type = 2552916305;
    }
  }
  IFC42.IfcTextureMap = IfcTextureMap;
  class IfcTextureVertex extends IfcPresentationItem {
    constructor(Coordinates) {
      super();
      this.Coordinates = Coordinates;
      this.type = 1210645708;
    }
  }
  IFC42.IfcTextureVertex = IfcTextureVertex;
  class IfcTextureVertexList extends IfcPresentationItem {
    constructor(TexCoordsList) {
      super();
      this.TexCoordsList = TexCoordsList;
      this.type = 3611470254;
    }
  }
  IFC42.IfcTextureVertexList = IfcTextureVertexList;
  class IfcTimePeriod extends IfcLineObject {
    constructor(StartTime, EndTime) {
      super();
      this.StartTime = StartTime;
      this.EndTime = EndTime;
      this.type = 1199560280;
    }
  }
  IFC42.IfcTimePeriod = IfcTimePeriod;
  class IfcTimeSeries extends IfcLineObject {
    constructor(Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.StartTime = StartTime;
      this.EndTime = EndTime;
      this.TimeSeriesDataType = TimeSeriesDataType;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.Unit = Unit;
      this.type = 3101149627;
    }
  }
  IFC42.IfcTimeSeries = IfcTimeSeries;
  class IfcTimeSeriesValue extends IfcLineObject {
    constructor(ListValues) {
      super();
      this.ListValues = ListValues;
      this.type = 581633288;
    }
  }
  IFC42.IfcTimeSeriesValue = IfcTimeSeriesValue;
  class IfcTopologicalRepresentationItem extends IfcRepresentationItem {
    constructor() {
      super();
      this.type = 1377556343;
    }
  }
  IFC42.IfcTopologicalRepresentationItem = IfcTopologicalRepresentationItem;
  class IfcTopologyRepresentation extends IfcShapeModel {
    constructor(ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      super(ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      this.ContextOfItems = ContextOfItems;
      this.RepresentationIdentifier = RepresentationIdentifier;
      this.RepresentationType = RepresentationType;
      this.Items = Items;
      this.type = 1735638870;
    }
  }
  IFC42.IfcTopologyRepresentation = IfcTopologyRepresentation;
  class IfcUnitAssignment extends IfcLineObject {
    constructor(Units) {
      super();
      this.Units = Units;
      this.type = 180925521;
    }
  }
  IFC42.IfcUnitAssignment = IfcUnitAssignment;
  class IfcVertex extends IfcTopologicalRepresentationItem {
    constructor() {
      super();
      this.type = 2799835756;
    }
  }
  IFC42.IfcVertex = IfcVertex;
  class IfcVertexPoint extends IfcVertex {
    constructor(VertexGeometry) {
      super();
      this.VertexGeometry = VertexGeometry;
      this.type = 1907098498;
    }
  }
  IFC42.IfcVertexPoint = IfcVertexPoint;
  class IfcVirtualGridIntersection extends IfcLineObject {
    constructor(IntersectingAxes, OffsetDistances) {
      super();
      this.IntersectingAxes = IntersectingAxes;
      this.OffsetDistances = OffsetDistances;
      this.type = 891718957;
    }
  }
  IFC42.IfcVirtualGridIntersection = IfcVirtualGridIntersection;
  class IfcWorkTime extends IfcSchedulingTime {
    constructor(Name, DataOrigin, UserDefinedDataOrigin, RecurrencePattern, Start, Finish) {
      super(Name, DataOrigin, UserDefinedDataOrigin);
      this.Name = Name;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.RecurrencePattern = RecurrencePattern;
      this.Start = Start;
      this.Finish = Finish;
      this.type = 1236880293;
    }
  }
  IFC42.IfcWorkTime = IfcWorkTime;
  class IfcApprovalRelationship extends IfcResourceLevelRelationship {
    constructor(Name, Description, RelatingApproval, RelatedApprovals) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.RelatingApproval = RelatingApproval;
      this.RelatedApprovals = RelatedApprovals;
      this.type = 3869604511;
    }
  }
  IFC42.IfcApprovalRelationship = IfcApprovalRelationship;
  class IfcArbitraryClosedProfileDef extends IfcProfileDef {
    constructor(ProfileType, ProfileName, OuterCurve) {
      super(ProfileType, ProfileName);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.OuterCurve = OuterCurve;
      this.type = 3798115385;
    }
  }
  IFC42.IfcArbitraryClosedProfileDef = IfcArbitraryClosedProfileDef;
  class IfcArbitraryOpenProfileDef extends IfcProfileDef {
    constructor(ProfileType, ProfileName, Curve) {
      super(ProfileType, ProfileName);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Curve = Curve;
      this.type = 1310608509;
    }
  }
  IFC42.IfcArbitraryOpenProfileDef = IfcArbitraryOpenProfileDef;
  class IfcArbitraryProfileDefWithVoids extends IfcArbitraryClosedProfileDef {
    constructor(ProfileType, ProfileName, OuterCurve, InnerCurves) {
      super(ProfileType, ProfileName, OuterCurve);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.OuterCurve = OuterCurve;
      this.InnerCurves = InnerCurves;
      this.type = 2705031697;
    }
  }
  IFC42.IfcArbitraryProfileDefWithVoids = IfcArbitraryProfileDefWithVoids;
  class IfcBlobTexture extends IfcSurfaceTexture {
    constructor(RepeatS, RepeatT, Mode, TextureTransform, Parameter, RasterFormat, RasterCode) {
      super(RepeatS, RepeatT, Mode, TextureTransform, Parameter);
      this.RepeatS = RepeatS;
      this.RepeatT = RepeatT;
      this.Mode = Mode;
      this.TextureTransform = TextureTransform;
      this.Parameter = Parameter;
      this.RasterFormat = RasterFormat;
      this.RasterCode = RasterCode;
      this.type = 616511568;
    }
  }
  IFC42.IfcBlobTexture = IfcBlobTexture;
  class IfcCenterLineProfileDef extends IfcArbitraryOpenProfileDef {
    constructor(ProfileType, ProfileName, Curve, Thickness) {
      super(ProfileType, ProfileName, Curve);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Curve = Curve;
      this.Thickness = Thickness;
      this.type = 3150382593;
    }
  }
  IFC42.IfcCenterLineProfileDef = IfcCenterLineProfileDef;
  class IfcClassification extends IfcExternalInformation {
    constructor(Source, Edition, EditionDate, Name, Description, Location, ReferenceTokens) {
      super();
      this.Source = Source;
      this.Edition = Edition;
      this.EditionDate = EditionDate;
      this.Name = Name;
      this.Description = Description;
      this.Location = Location;
      this.ReferenceTokens = ReferenceTokens;
      this.type = 747523909;
    }
  }
  IFC42.IfcClassification = IfcClassification;
  class IfcClassificationReference extends IfcExternalReference {
    constructor(Location, Identification, Name, ReferencedSource, Description, Sort) {
      super(Location, Identification, Name);
      this.Location = Location;
      this.Identification = Identification;
      this.Name = Name;
      this.ReferencedSource = ReferencedSource;
      this.Description = Description;
      this.Sort = Sort;
      this.type = 647927063;
    }
  }
  IFC42.IfcClassificationReference = IfcClassificationReference;
  class IfcColourRgbList extends IfcPresentationItem {
    constructor(ColourList) {
      super();
      this.ColourList = ColourList;
      this.type = 3285139300;
    }
  }
  IFC42.IfcColourRgbList = IfcColourRgbList;
  class IfcColourSpecification extends IfcPresentationItem {
    constructor(Name) {
      super();
      this.Name = Name;
      this.type = 3264961684;
    }
  }
  IFC42.IfcColourSpecification = IfcColourSpecification;
  class IfcCompositeProfileDef extends IfcProfileDef {
    constructor(ProfileType, ProfileName, Profiles, Label) {
      super(ProfileType, ProfileName);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Profiles = Profiles;
      this.Label = Label;
      this.type = 1485152156;
    }
  }
  IFC42.IfcCompositeProfileDef = IfcCompositeProfileDef;
  class IfcConnectedFaceSet extends IfcTopologicalRepresentationItem {
    constructor(CfsFaces) {
      super();
      this.CfsFaces = CfsFaces;
      this.type = 370225590;
    }
  }
  IFC42.IfcConnectedFaceSet = IfcConnectedFaceSet;
  class IfcConnectionCurveGeometry extends IfcConnectionGeometry {
    constructor(CurveOnRelatingElement, CurveOnRelatedElement) {
      super();
      this.CurveOnRelatingElement = CurveOnRelatingElement;
      this.CurveOnRelatedElement = CurveOnRelatedElement;
      this.type = 1981873012;
    }
  }
  IFC42.IfcConnectionCurveGeometry = IfcConnectionCurveGeometry;
  class IfcConnectionPointEccentricity extends IfcConnectionPointGeometry {
    constructor(PointOnRelatingElement, PointOnRelatedElement, EccentricityInX, EccentricityInY, EccentricityInZ) {
      super(PointOnRelatingElement, PointOnRelatedElement);
      this.PointOnRelatingElement = PointOnRelatingElement;
      this.PointOnRelatedElement = PointOnRelatedElement;
      this.EccentricityInX = EccentricityInX;
      this.EccentricityInY = EccentricityInY;
      this.EccentricityInZ = EccentricityInZ;
      this.type = 45288368;
    }
  }
  IFC42.IfcConnectionPointEccentricity = IfcConnectionPointEccentricity;
  class IfcContextDependentUnit extends IfcNamedUnit {
    constructor(Dimensions, UnitType, Name) {
      super(Dimensions, UnitType);
      this.Dimensions = Dimensions;
      this.UnitType = UnitType;
      this.Name = Name;
      this.type = 3050246964;
    }
  }
  IFC42.IfcContextDependentUnit = IfcContextDependentUnit;
  class IfcConversionBasedUnit extends IfcNamedUnit {
    constructor(Dimensions, UnitType, Name, ConversionFactor) {
      super(Dimensions, UnitType);
      this.Dimensions = Dimensions;
      this.UnitType = UnitType;
      this.Name = Name;
      this.ConversionFactor = ConversionFactor;
      this.type = 2889183280;
    }
  }
  IFC42.IfcConversionBasedUnit = IfcConversionBasedUnit;
  class IfcConversionBasedUnitWithOffset extends IfcConversionBasedUnit {
    constructor(Dimensions, UnitType, Name, ConversionFactor, ConversionOffset) {
      super(Dimensions, UnitType, Name, ConversionFactor);
      this.Dimensions = Dimensions;
      this.UnitType = UnitType;
      this.Name = Name;
      this.ConversionFactor = ConversionFactor;
      this.ConversionOffset = ConversionOffset;
      this.type = 2713554722;
    }
  }
  IFC42.IfcConversionBasedUnitWithOffset = IfcConversionBasedUnitWithOffset;
  class IfcCurrencyRelationship extends IfcResourceLevelRelationship {
    constructor(Name, Description, RelatingMonetaryUnit, RelatedMonetaryUnit, ExchangeRate, RateDateTime, RateSource) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.RelatingMonetaryUnit = RelatingMonetaryUnit;
      this.RelatedMonetaryUnit = RelatedMonetaryUnit;
      this.ExchangeRate = ExchangeRate;
      this.RateDateTime = RateDateTime;
      this.RateSource = RateSource;
      this.type = 539742890;
    }
  }
  IFC42.IfcCurrencyRelationship = IfcCurrencyRelationship;
  class IfcCurveStyle extends IfcPresentationStyle {
    constructor(Name, CurveFont, CurveWidth, CurveColour, ModelOrDraughting) {
      super(Name);
      this.Name = Name;
      this.CurveFont = CurveFont;
      this.CurveWidth = CurveWidth;
      this.CurveColour = CurveColour;
      this.ModelOrDraughting = ModelOrDraughting;
      this.type = 3800577675;
    }
  }
  IFC42.IfcCurveStyle = IfcCurveStyle;
  class IfcCurveStyleFont extends IfcPresentationItem {
    constructor(Name, PatternList) {
      super();
      this.Name = Name;
      this.PatternList = PatternList;
      this.type = 1105321065;
    }
  }
  IFC42.IfcCurveStyleFont = IfcCurveStyleFont;
  class IfcCurveStyleFontAndScaling extends IfcPresentationItem {
    constructor(Name, CurveFont, CurveFontScaling) {
      super();
      this.Name = Name;
      this.CurveFont = CurveFont;
      this.CurveFontScaling = CurveFontScaling;
      this.type = 2367409068;
    }
  }
  IFC42.IfcCurveStyleFontAndScaling = IfcCurveStyleFontAndScaling;
  class IfcCurveStyleFontPattern extends IfcPresentationItem {
    constructor(VisibleSegmentLength, InvisibleSegmentLength) {
      super();
      this.VisibleSegmentLength = VisibleSegmentLength;
      this.InvisibleSegmentLength = InvisibleSegmentLength;
      this.type = 3510044353;
    }
  }
  IFC42.IfcCurveStyleFontPattern = IfcCurveStyleFontPattern;
  class IfcDerivedProfileDef extends IfcProfileDef {
    constructor(ProfileType, ProfileName, ParentProfile, Operator, Label) {
      super(ProfileType, ProfileName);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.ParentProfile = ParentProfile;
      this.Operator = Operator;
      this.Label = Label;
      this.type = 3632507154;
    }
  }
  IFC42.IfcDerivedProfileDef = IfcDerivedProfileDef;
  class IfcDocumentInformation extends IfcExternalInformation {
    constructor(Identification, Name, Description, Location, Purpose, IntendedUse, Scope, Revision, DocumentOwner, Editors, CreationTime, LastRevisionTime, ElectronicFormat, ValidFrom, ValidUntil, Confidentiality, Status) {
      super();
      this.Identification = Identification;
      this.Name = Name;
      this.Description = Description;
      this.Location = Location;
      this.Purpose = Purpose;
      this.IntendedUse = IntendedUse;
      this.Scope = Scope;
      this.Revision = Revision;
      this.DocumentOwner = DocumentOwner;
      this.Editors = Editors;
      this.CreationTime = CreationTime;
      this.LastRevisionTime = LastRevisionTime;
      this.ElectronicFormat = ElectronicFormat;
      this.ValidFrom = ValidFrom;
      this.ValidUntil = ValidUntil;
      this.Confidentiality = Confidentiality;
      this.Status = Status;
      this.type = 1154170062;
    }
  }
  IFC42.IfcDocumentInformation = IfcDocumentInformation;
  class IfcDocumentInformationRelationship extends IfcResourceLevelRelationship {
    constructor(Name, Description, RelatingDocument, RelatedDocuments, RelationshipType) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.RelatingDocument = RelatingDocument;
      this.RelatedDocuments = RelatedDocuments;
      this.RelationshipType = RelationshipType;
      this.type = 770865208;
    }
  }
  IFC42.IfcDocumentInformationRelationship = IfcDocumentInformationRelationship;
  class IfcDocumentReference extends IfcExternalReference {
    constructor(Location, Identification, Name, Description, ReferencedDocument) {
      super(Location, Identification, Name);
      this.Location = Location;
      this.Identification = Identification;
      this.Name = Name;
      this.Description = Description;
      this.ReferencedDocument = ReferencedDocument;
      this.type = 3732053477;
    }
  }
  IFC42.IfcDocumentReference = IfcDocumentReference;
  class IfcEdge extends IfcTopologicalRepresentationItem {
    constructor(EdgeStart, EdgeEnd) {
      super();
      this.EdgeStart = EdgeStart;
      this.EdgeEnd = EdgeEnd;
      this.type = 3900360178;
    }
  }
  IFC42.IfcEdge = IfcEdge;
  class IfcEdgeCurve extends IfcEdge {
    constructor(EdgeStart, EdgeEnd, EdgeGeometry, SameSense) {
      super(EdgeStart, EdgeEnd);
      this.EdgeStart = EdgeStart;
      this.EdgeEnd = EdgeEnd;
      this.EdgeGeometry = EdgeGeometry;
      this.SameSense = SameSense;
      this.type = 476780140;
    }
  }
  IFC42.IfcEdgeCurve = IfcEdgeCurve;
  class IfcEventTime extends IfcSchedulingTime {
    constructor(Name, DataOrigin, UserDefinedDataOrigin, ActualDate, EarlyDate, LateDate, ScheduleDate) {
      super(Name, DataOrigin, UserDefinedDataOrigin);
      this.Name = Name;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.ActualDate = ActualDate;
      this.EarlyDate = EarlyDate;
      this.LateDate = LateDate;
      this.ScheduleDate = ScheduleDate;
      this.type = 211053100;
    }
  }
  IFC42.IfcEventTime = IfcEventTime;
  class IfcExtendedProperties extends IfcPropertyAbstraction {
    constructor(Name, Description, Properties2) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.Properties = Properties2;
      this.type = 297599258;
    }
  }
  IFC42.IfcExtendedProperties = IfcExtendedProperties;
  class IfcExternalReferenceRelationship extends IfcResourceLevelRelationship {
    constructor(Name, Description, RelatingReference, RelatedResourceObjects) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.RelatingReference = RelatingReference;
      this.RelatedResourceObjects = RelatedResourceObjects;
      this.type = 1437805879;
    }
  }
  IFC42.IfcExternalReferenceRelationship = IfcExternalReferenceRelationship;
  class IfcFace extends IfcTopologicalRepresentationItem {
    constructor(Bounds) {
      super();
      this.Bounds = Bounds;
      this.type = 2556980723;
    }
  }
  IFC42.IfcFace = IfcFace;
  class IfcFaceBound extends IfcTopologicalRepresentationItem {
    constructor(Bound, Orientation) {
      super();
      this.Bound = Bound;
      this.Orientation = Orientation;
      this.type = 1809719519;
    }
  }
  IFC42.IfcFaceBound = IfcFaceBound;
  class IfcFaceOuterBound extends IfcFaceBound {
    constructor(Bound, Orientation) {
      super(Bound, Orientation);
      this.Bound = Bound;
      this.Orientation = Orientation;
      this.type = 803316827;
    }
  }
  IFC42.IfcFaceOuterBound = IfcFaceOuterBound;
  class IfcFaceSurface extends IfcFace {
    constructor(Bounds, FaceSurface, SameSense) {
      super(Bounds);
      this.Bounds = Bounds;
      this.FaceSurface = FaceSurface;
      this.SameSense = SameSense;
      this.type = 3008276851;
    }
  }
  IFC42.IfcFaceSurface = IfcFaceSurface;
  class IfcFailureConnectionCondition extends IfcStructuralConnectionCondition {
    constructor(Name, TensionFailureX, TensionFailureY, TensionFailureZ, CompressionFailureX, CompressionFailureY, CompressionFailureZ) {
      super(Name);
      this.Name = Name;
      this.TensionFailureX = TensionFailureX;
      this.TensionFailureY = TensionFailureY;
      this.TensionFailureZ = TensionFailureZ;
      this.CompressionFailureX = CompressionFailureX;
      this.CompressionFailureY = CompressionFailureY;
      this.CompressionFailureZ = CompressionFailureZ;
      this.type = 4219587988;
    }
  }
  IFC42.IfcFailureConnectionCondition = IfcFailureConnectionCondition;
  class IfcFillAreaStyle extends IfcPresentationStyle {
    constructor(Name, FillStyles, ModelorDraughting) {
      super(Name);
      this.Name = Name;
      this.FillStyles = FillStyles;
      this.ModelorDraughting = ModelorDraughting;
      this.type = 738692330;
    }
  }
  IFC42.IfcFillAreaStyle = IfcFillAreaStyle;
  class IfcGeometricRepresentationContext extends IfcRepresentationContext {
    constructor(ContextIdentifier, ContextType, CoordinateSpaceDimension, Precision, WorldCoordinateSystem, TrueNorth) {
      super(ContextIdentifier, ContextType);
      this.ContextIdentifier = ContextIdentifier;
      this.ContextType = ContextType;
      this.CoordinateSpaceDimension = CoordinateSpaceDimension;
      this.Precision = Precision;
      this.WorldCoordinateSystem = WorldCoordinateSystem;
      this.TrueNorth = TrueNorth;
      this.type = 3448662350;
    }
  }
  IFC42.IfcGeometricRepresentationContext = IfcGeometricRepresentationContext;
  class IfcGeometricRepresentationItem extends IfcRepresentationItem {
    constructor() {
      super();
      this.type = 2453401579;
    }
  }
  IFC42.IfcGeometricRepresentationItem = IfcGeometricRepresentationItem;
  class IfcGeometricRepresentationSubContext extends IfcGeometricRepresentationContext {
    constructor(ContextIdentifier, ContextType, ParentContext, TargetScale, TargetView, UserDefinedTargetView) {
      super(ContextIdentifier, ContextType, new IfcDimensionCount(0), null, new Handle(0), null);
      this.ContextIdentifier = ContextIdentifier;
      this.ContextType = ContextType;
      this.ParentContext = ParentContext;
      this.TargetScale = TargetScale;
      this.TargetView = TargetView;
      this.UserDefinedTargetView = UserDefinedTargetView;
      this.type = 4142052618;
    }
  }
  IFC42.IfcGeometricRepresentationSubContext = IfcGeometricRepresentationSubContext;
  class IfcGeometricSet extends IfcGeometricRepresentationItem {
    constructor(Elements) {
      super();
      this.Elements = Elements;
      this.type = 3590301190;
    }
  }
  IFC42.IfcGeometricSet = IfcGeometricSet;
  class IfcGridPlacement extends IfcObjectPlacement {
    constructor(PlacementLocation, PlacementRefDirection) {
      super();
      this.PlacementLocation = PlacementLocation;
      this.PlacementRefDirection = PlacementRefDirection;
      this.type = 178086475;
    }
  }
  IFC42.IfcGridPlacement = IfcGridPlacement;
  class IfcHalfSpaceSolid extends IfcGeometricRepresentationItem {
    constructor(BaseSurface, AgreementFlag) {
      super();
      this.BaseSurface = BaseSurface;
      this.AgreementFlag = AgreementFlag;
      this.type = 812098782;
    }
  }
  IFC42.IfcHalfSpaceSolid = IfcHalfSpaceSolid;
  class IfcImageTexture extends IfcSurfaceTexture {
    constructor(RepeatS, RepeatT, Mode, TextureTransform, Parameter, URLReference) {
      super(RepeatS, RepeatT, Mode, TextureTransform, Parameter);
      this.RepeatS = RepeatS;
      this.RepeatT = RepeatT;
      this.Mode = Mode;
      this.TextureTransform = TextureTransform;
      this.Parameter = Parameter;
      this.URLReference = URLReference;
      this.type = 3905492369;
    }
  }
  IFC42.IfcImageTexture = IfcImageTexture;
  class IfcIndexedColourMap extends IfcPresentationItem {
    constructor(MappedTo, Opacity, Colours, ColourIndex) {
      super();
      this.MappedTo = MappedTo;
      this.Opacity = Opacity;
      this.Colours = Colours;
      this.ColourIndex = ColourIndex;
      this.type = 3570813810;
    }
  }
  IFC42.IfcIndexedColourMap = IfcIndexedColourMap;
  class IfcIndexedTextureMap extends IfcTextureCoordinate {
    constructor(Maps, MappedTo, TexCoords) {
      super(Maps);
      this.Maps = Maps;
      this.MappedTo = MappedTo;
      this.TexCoords = TexCoords;
      this.type = 1437953363;
    }
  }
  IFC42.IfcIndexedTextureMap = IfcIndexedTextureMap;
  class IfcIndexedTriangleTextureMap extends IfcIndexedTextureMap {
    constructor(Maps, MappedTo, TexCoords, TexCoordIndex) {
      super(Maps, MappedTo, TexCoords);
      this.Maps = Maps;
      this.MappedTo = MappedTo;
      this.TexCoords = TexCoords;
      this.TexCoordIndex = TexCoordIndex;
      this.type = 2133299955;
    }
  }
  IFC42.IfcIndexedTriangleTextureMap = IfcIndexedTriangleTextureMap;
  class IfcIrregularTimeSeries extends IfcTimeSeries {
    constructor(Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit, Values) {
      super(Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit);
      this.Name = Name;
      this.Description = Description;
      this.StartTime = StartTime;
      this.EndTime = EndTime;
      this.TimeSeriesDataType = TimeSeriesDataType;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.Unit = Unit;
      this.Values = Values;
      this.type = 3741457305;
    }
  }
  IFC42.IfcIrregularTimeSeries = IfcIrregularTimeSeries;
  class IfcLagTime extends IfcSchedulingTime {
    constructor(Name, DataOrigin, UserDefinedDataOrigin, LagValue, DurationType) {
      super(Name, DataOrigin, UserDefinedDataOrigin);
      this.Name = Name;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.LagValue = LagValue;
      this.DurationType = DurationType;
      this.type = 1585845231;
    }
  }
  IFC42.IfcLagTime = IfcLagTime;
  class IfcLightSource extends IfcGeometricRepresentationItem {
    constructor(Name, LightColour, AmbientIntensity, Intensity) {
      super();
      this.Name = Name;
      this.LightColour = LightColour;
      this.AmbientIntensity = AmbientIntensity;
      this.Intensity = Intensity;
      this.type = 1402838566;
    }
  }
  IFC42.IfcLightSource = IfcLightSource;
  class IfcLightSourceAmbient extends IfcLightSource {
    constructor(Name, LightColour, AmbientIntensity, Intensity) {
      super(Name, LightColour, AmbientIntensity, Intensity);
      this.Name = Name;
      this.LightColour = LightColour;
      this.AmbientIntensity = AmbientIntensity;
      this.Intensity = Intensity;
      this.type = 125510826;
    }
  }
  IFC42.IfcLightSourceAmbient = IfcLightSourceAmbient;
  class IfcLightSourceDirectional extends IfcLightSource {
    constructor(Name, LightColour, AmbientIntensity, Intensity, Orientation) {
      super(Name, LightColour, AmbientIntensity, Intensity);
      this.Name = Name;
      this.LightColour = LightColour;
      this.AmbientIntensity = AmbientIntensity;
      this.Intensity = Intensity;
      this.Orientation = Orientation;
      this.type = 2604431987;
    }
  }
  IFC42.IfcLightSourceDirectional = IfcLightSourceDirectional;
  class IfcLightSourceGoniometric extends IfcLightSource {
    constructor(Name, LightColour, AmbientIntensity, Intensity, Position, ColourAppearance, ColourTemperature, LuminousFlux, LightEmissionSource, LightDistributionDataSource) {
      super(Name, LightColour, AmbientIntensity, Intensity);
      this.Name = Name;
      this.LightColour = LightColour;
      this.AmbientIntensity = AmbientIntensity;
      this.Intensity = Intensity;
      this.Position = Position;
      this.ColourAppearance = ColourAppearance;
      this.ColourTemperature = ColourTemperature;
      this.LuminousFlux = LuminousFlux;
      this.LightEmissionSource = LightEmissionSource;
      this.LightDistributionDataSource = LightDistributionDataSource;
      this.type = 4266656042;
    }
  }
  IFC42.IfcLightSourceGoniometric = IfcLightSourceGoniometric;
  class IfcLightSourcePositional extends IfcLightSource {
    constructor(Name, LightColour, AmbientIntensity, Intensity, Position, Radius, ConstantAttenuation, DistanceAttenuation, QuadricAttenuation) {
      super(Name, LightColour, AmbientIntensity, Intensity);
      this.Name = Name;
      this.LightColour = LightColour;
      this.AmbientIntensity = AmbientIntensity;
      this.Intensity = Intensity;
      this.Position = Position;
      this.Radius = Radius;
      this.ConstantAttenuation = ConstantAttenuation;
      this.DistanceAttenuation = DistanceAttenuation;
      this.QuadricAttenuation = QuadricAttenuation;
      this.type = 1520743889;
    }
  }
  IFC42.IfcLightSourcePositional = IfcLightSourcePositional;
  class IfcLightSourceSpot extends IfcLightSourcePositional {
    constructor(Name, LightColour, AmbientIntensity, Intensity, Position, Radius, ConstantAttenuation, DistanceAttenuation, QuadricAttenuation, Orientation, ConcentrationExponent, SpreadAngle, BeamWidthAngle) {
      super(Name, LightColour, AmbientIntensity, Intensity, Position, Radius, ConstantAttenuation, DistanceAttenuation, QuadricAttenuation);
      this.Name = Name;
      this.LightColour = LightColour;
      this.AmbientIntensity = AmbientIntensity;
      this.Intensity = Intensity;
      this.Position = Position;
      this.Radius = Radius;
      this.ConstantAttenuation = ConstantAttenuation;
      this.DistanceAttenuation = DistanceAttenuation;
      this.QuadricAttenuation = QuadricAttenuation;
      this.Orientation = Orientation;
      this.ConcentrationExponent = ConcentrationExponent;
      this.SpreadAngle = SpreadAngle;
      this.BeamWidthAngle = BeamWidthAngle;
      this.type = 3422422726;
    }
  }
  IFC42.IfcLightSourceSpot = IfcLightSourceSpot;
  class IfcLocalPlacement extends IfcObjectPlacement {
    constructor(PlacementRelTo, RelativePlacement) {
      super();
      this.PlacementRelTo = PlacementRelTo;
      this.RelativePlacement = RelativePlacement;
      this.type = 2624227202;
    }
  }
  IFC42.IfcLocalPlacement = IfcLocalPlacement;
  class IfcLoop extends IfcTopologicalRepresentationItem {
    constructor() {
      super();
      this.type = 1008929658;
    }
  }
  IFC42.IfcLoop = IfcLoop;
  class IfcMappedItem extends IfcRepresentationItem {
    constructor(MappingSource, MappingTarget) {
      super();
      this.MappingSource = MappingSource;
      this.MappingTarget = MappingTarget;
      this.type = 2347385850;
    }
  }
  IFC42.IfcMappedItem = IfcMappedItem;
  class IfcMaterial extends IfcMaterialDefinition {
    constructor(Name, Description, Category) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.Category = Category;
      this.type = 1838606355;
    }
  }
  IFC42.IfcMaterial = IfcMaterial;
  class IfcMaterialConstituent extends IfcMaterialDefinition {
    constructor(Name, Description, Material, Fraction, Category) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.Material = Material;
      this.Fraction = Fraction;
      this.Category = Category;
      this.type = 3708119e3;
    }
  }
  IFC42.IfcMaterialConstituent = IfcMaterialConstituent;
  class IfcMaterialConstituentSet extends IfcMaterialDefinition {
    constructor(Name, Description, MaterialConstituents) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.MaterialConstituents = MaterialConstituents;
      this.type = 2852063980;
    }
  }
  IFC42.IfcMaterialConstituentSet = IfcMaterialConstituentSet;
  class IfcMaterialDefinitionRepresentation extends IfcProductRepresentation {
    constructor(Name, Description, Representations, RepresentedMaterial) {
      super(Name, Description, Representations);
      this.Name = Name;
      this.Description = Description;
      this.Representations = Representations;
      this.RepresentedMaterial = RepresentedMaterial;
      this.type = 2022407955;
    }
  }
  IFC42.IfcMaterialDefinitionRepresentation = IfcMaterialDefinitionRepresentation;
  class IfcMaterialLayerSetUsage extends IfcMaterialUsageDefinition {
    constructor(ForLayerSet, LayerSetDirection, DirectionSense, OffsetFromReferenceLine, ReferenceExtent) {
      super();
      this.ForLayerSet = ForLayerSet;
      this.LayerSetDirection = LayerSetDirection;
      this.DirectionSense = DirectionSense;
      this.OffsetFromReferenceLine = OffsetFromReferenceLine;
      this.ReferenceExtent = ReferenceExtent;
      this.type = 1303795690;
    }
  }
  IFC42.IfcMaterialLayerSetUsage = IfcMaterialLayerSetUsage;
  class IfcMaterialProfileSetUsage extends IfcMaterialUsageDefinition {
    constructor(ForProfileSet, CardinalPoint, ReferenceExtent) {
      super();
      this.ForProfileSet = ForProfileSet;
      this.CardinalPoint = CardinalPoint;
      this.ReferenceExtent = ReferenceExtent;
      this.type = 3079605661;
    }
  }
  IFC42.IfcMaterialProfileSetUsage = IfcMaterialProfileSetUsage;
  class IfcMaterialProfileSetUsageTapering extends IfcMaterialProfileSetUsage {
    constructor(ForProfileSet, CardinalPoint, ReferenceExtent, ForProfileEndSet, CardinalEndPoint) {
      super(ForProfileSet, CardinalPoint, ReferenceExtent);
      this.ForProfileSet = ForProfileSet;
      this.CardinalPoint = CardinalPoint;
      this.ReferenceExtent = ReferenceExtent;
      this.ForProfileEndSet = ForProfileEndSet;
      this.CardinalEndPoint = CardinalEndPoint;
      this.type = 3404854881;
    }
  }
  IFC42.IfcMaterialProfileSetUsageTapering = IfcMaterialProfileSetUsageTapering;
  class IfcMaterialProperties extends IfcExtendedProperties {
    constructor(Name, Description, Properties2, Material) {
      super(Name, Description, Properties2);
      this.Name = Name;
      this.Description = Description;
      this.Properties = Properties2;
      this.Material = Material;
      this.type = 3265635763;
    }
  }
  IFC42.IfcMaterialProperties = IfcMaterialProperties;
  class IfcMaterialRelationship extends IfcResourceLevelRelationship {
    constructor(Name, Description, RelatingMaterial, RelatedMaterials, Expression) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.RelatingMaterial = RelatingMaterial;
      this.RelatedMaterials = RelatedMaterials;
      this.Expression = Expression;
      this.type = 853536259;
    }
  }
  IFC42.IfcMaterialRelationship = IfcMaterialRelationship;
  class IfcMirroredProfileDef extends IfcDerivedProfileDef {
    constructor(ProfileType, ProfileName, ParentProfile, Label) {
      super(ProfileType, ProfileName, ParentProfile, new Handle(0), Label);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.ParentProfile = ParentProfile;
      this.Label = Label;
      this.type = 2998442950;
    }
  }
  IFC42.IfcMirroredProfileDef = IfcMirroredProfileDef;
  class IfcObjectDefinition extends IfcRoot {
    constructor(GlobalId, OwnerHistory, Name, Description) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 219451334;
    }
  }
  IFC42.IfcObjectDefinition = IfcObjectDefinition;
  class IfcOpenShell extends IfcConnectedFaceSet {
    constructor(CfsFaces) {
      super(CfsFaces);
      this.CfsFaces = CfsFaces;
      this.type = 2665983363;
    }
  }
  IFC42.IfcOpenShell = IfcOpenShell;
  class IfcOrganizationRelationship extends IfcResourceLevelRelationship {
    constructor(Name, Description, RelatingOrganization, RelatedOrganizations) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.RelatingOrganization = RelatingOrganization;
      this.RelatedOrganizations = RelatedOrganizations;
      this.type = 1411181986;
    }
  }
  IFC42.IfcOrganizationRelationship = IfcOrganizationRelationship;
  class IfcOrientedEdge extends IfcEdge {
    constructor(EdgeElement, Orientation) {
      super(new Handle(0), new Handle(0));
      this.EdgeElement = EdgeElement;
      this.Orientation = Orientation;
      this.type = 1029017970;
    }
  }
  IFC42.IfcOrientedEdge = IfcOrientedEdge;
  class IfcParameterizedProfileDef extends IfcProfileDef {
    constructor(ProfileType, ProfileName, Position) {
      super(ProfileType, ProfileName);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.type = 2529465313;
    }
  }
  IFC42.IfcParameterizedProfileDef = IfcParameterizedProfileDef;
  class IfcPath extends IfcTopologicalRepresentationItem {
    constructor(EdgeList) {
      super();
      this.EdgeList = EdgeList;
      this.type = 2519244187;
    }
  }
  IFC42.IfcPath = IfcPath;
  class IfcPhysicalComplexQuantity extends IfcPhysicalQuantity {
    constructor(Name, Description, HasQuantities, Discrimination, Quality, Usage) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.HasQuantities = HasQuantities;
      this.Discrimination = Discrimination;
      this.Quality = Quality;
      this.Usage = Usage;
      this.type = 3021840470;
    }
  }
  IFC42.IfcPhysicalComplexQuantity = IfcPhysicalComplexQuantity;
  class IfcPixelTexture extends IfcSurfaceTexture {
    constructor(RepeatS, RepeatT, Mode, TextureTransform, Parameter, Width, Height, ColourComponents, Pixel) {
      super(RepeatS, RepeatT, Mode, TextureTransform, Parameter);
      this.RepeatS = RepeatS;
      this.RepeatT = RepeatT;
      this.Mode = Mode;
      this.TextureTransform = TextureTransform;
      this.Parameter = Parameter;
      this.Width = Width;
      this.Height = Height;
      this.ColourComponents = ColourComponents;
      this.Pixel = Pixel;
      this.type = 597895409;
    }
  }
  IFC42.IfcPixelTexture = IfcPixelTexture;
  class IfcPlacement extends IfcGeometricRepresentationItem {
    constructor(Location) {
      super();
      this.Location = Location;
      this.type = 2004835150;
    }
  }
  IFC42.IfcPlacement = IfcPlacement;
  class IfcPlanarExtent extends IfcGeometricRepresentationItem {
    constructor(SizeInX, SizeInY) {
      super();
      this.SizeInX = SizeInX;
      this.SizeInY = SizeInY;
      this.type = 1663979128;
    }
  }
  IFC42.IfcPlanarExtent = IfcPlanarExtent;
  class IfcPoint extends IfcGeometricRepresentationItem {
    constructor() {
      super();
      this.type = 2067069095;
    }
  }
  IFC42.IfcPoint = IfcPoint;
  class IfcPointOnCurve extends IfcPoint {
    constructor(BasisCurve, PointParameter) {
      super();
      this.BasisCurve = BasisCurve;
      this.PointParameter = PointParameter;
      this.type = 4022376103;
    }
  }
  IFC42.IfcPointOnCurve = IfcPointOnCurve;
  class IfcPointOnSurface extends IfcPoint {
    constructor(BasisSurface, PointParameterU, PointParameterV) {
      super();
      this.BasisSurface = BasisSurface;
      this.PointParameterU = PointParameterU;
      this.PointParameterV = PointParameterV;
      this.type = 1423911732;
    }
  }
  IFC42.IfcPointOnSurface = IfcPointOnSurface;
  class IfcPolyLoop extends IfcLoop {
    constructor(Polygon) {
      super();
      this.Polygon = Polygon;
      this.type = 2924175390;
    }
  }
  IFC42.IfcPolyLoop = IfcPolyLoop;
  class IfcPolygonalBoundedHalfSpace extends IfcHalfSpaceSolid {
    constructor(BaseSurface, AgreementFlag, Position, PolygonalBoundary) {
      super(BaseSurface, AgreementFlag);
      this.BaseSurface = BaseSurface;
      this.AgreementFlag = AgreementFlag;
      this.Position = Position;
      this.PolygonalBoundary = PolygonalBoundary;
      this.type = 2775532180;
    }
  }
  IFC42.IfcPolygonalBoundedHalfSpace = IfcPolygonalBoundedHalfSpace;
  class IfcPreDefinedItem extends IfcPresentationItem {
    constructor(Name) {
      super();
      this.Name = Name;
      this.type = 3727388367;
    }
  }
  IFC42.IfcPreDefinedItem = IfcPreDefinedItem;
  class IfcPreDefinedProperties extends IfcPropertyAbstraction {
    constructor() {
      super();
      this.type = 3778827333;
    }
  }
  IFC42.IfcPreDefinedProperties = IfcPreDefinedProperties;
  class IfcPreDefinedTextFont extends IfcPreDefinedItem {
    constructor(Name) {
      super(Name);
      this.Name = Name;
      this.type = 1775413392;
    }
  }
  IFC42.IfcPreDefinedTextFont = IfcPreDefinedTextFont;
  class IfcProductDefinitionShape extends IfcProductRepresentation {
    constructor(Name, Description, Representations) {
      super(Name, Description, Representations);
      this.Name = Name;
      this.Description = Description;
      this.Representations = Representations;
      this.type = 673634403;
    }
  }
  IFC42.IfcProductDefinitionShape = IfcProductDefinitionShape;
  class IfcProfileProperties extends IfcExtendedProperties {
    constructor(Name, Description, Properties2, ProfileDefinition) {
      super(Name, Description, Properties2);
      this.Name = Name;
      this.Description = Description;
      this.Properties = Properties2;
      this.ProfileDefinition = ProfileDefinition;
      this.type = 2802850158;
    }
  }
  IFC42.IfcProfileProperties = IfcProfileProperties;
  class IfcProperty extends IfcPropertyAbstraction {
    constructor(Name, Description) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.type = 2598011224;
    }
  }
  IFC42.IfcProperty = IfcProperty;
  class IfcPropertyDefinition extends IfcRoot {
    constructor(GlobalId, OwnerHistory, Name, Description) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 1680319473;
    }
  }
  IFC42.IfcPropertyDefinition = IfcPropertyDefinition;
  class IfcPropertyDependencyRelationship extends IfcResourceLevelRelationship {
    constructor(Name, Description, DependingProperty, DependantProperty, Expression) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.DependingProperty = DependingProperty;
      this.DependantProperty = DependantProperty;
      this.Expression = Expression;
      this.type = 148025276;
    }
  }
  IFC42.IfcPropertyDependencyRelationship = IfcPropertyDependencyRelationship;
  class IfcPropertySetDefinition extends IfcPropertyDefinition {
    constructor(GlobalId, OwnerHistory, Name, Description) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 3357820518;
    }
  }
  IFC42.IfcPropertySetDefinition = IfcPropertySetDefinition;
  class IfcPropertyTemplateDefinition extends IfcPropertyDefinition {
    constructor(GlobalId, OwnerHistory, Name, Description) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 1482703590;
    }
  }
  IFC42.IfcPropertyTemplateDefinition = IfcPropertyTemplateDefinition;
  class IfcQuantitySet extends IfcPropertySetDefinition {
    constructor(GlobalId, OwnerHistory, Name, Description) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 2090586900;
    }
  }
  IFC42.IfcQuantitySet = IfcQuantitySet;
  class IfcRectangleProfileDef extends IfcParameterizedProfileDef {
    constructor(ProfileType, ProfileName, Position, XDim, YDim) {
      super(ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.XDim = XDim;
      this.YDim = YDim;
      this.type = 3615266464;
    }
  }
  IFC42.IfcRectangleProfileDef = IfcRectangleProfileDef;
  class IfcRegularTimeSeries extends IfcTimeSeries {
    constructor(Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit, TimeStep, Values) {
      super(Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit);
      this.Name = Name;
      this.Description = Description;
      this.StartTime = StartTime;
      this.EndTime = EndTime;
      this.TimeSeriesDataType = TimeSeriesDataType;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.Unit = Unit;
      this.TimeStep = TimeStep;
      this.Values = Values;
      this.type = 3413951693;
    }
  }
  IFC42.IfcRegularTimeSeries = IfcRegularTimeSeries;
  class IfcReinforcementBarProperties extends IfcPreDefinedProperties {
    constructor(TotalCrossSectionArea, SteelGrade, BarSurface, EffectiveDepth, NominalBarDiameter, BarCount) {
      super();
      this.TotalCrossSectionArea = TotalCrossSectionArea;
      this.SteelGrade = SteelGrade;
      this.BarSurface = BarSurface;
      this.EffectiveDepth = EffectiveDepth;
      this.NominalBarDiameter = NominalBarDiameter;
      this.BarCount = BarCount;
      this.type = 1580146022;
    }
  }
  IFC42.IfcReinforcementBarProperties = IfcReinforcementBarProperties;
  class IfcRelationship extends IfcRoot {
    constructor(GlobalId, OwnerHistory, Name, Description) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 478536968;
    }
  }
  IFC42.IfcRelationship = IfcRelationship;
  class IfcResourceApprovalRelationship extends IfcResourceLevelRelationship {
    constructor(Name, Description, RelatedResourceObjects, RelatingApproval) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.RelatedResourceObjects = RelatedResourceObjects;
      this.RelatingApproval = RelatingApproval;
      this.type = 2943643501;
    }
  }
  IFC42.IfcResourceApprovalRelationship = IfcResourceApprovalRelationship;
  class IfcResourceConstraintRelationship extends IfcResourceLevelRelationship {
    constructor(Name, Description, RelatingConstraint, RelatedResourceObjects) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.RelatingConstraint = RelatingConstraint;
      this.RelatedResourceObjects = RelatedResourceObjects;
      this.type = 1608871552;
    }
  }
  IFC42.IfcResourceConstraintRelationship = IfcResourceConstraintRelationship;
  class IfcResourceTime extends IfcSchedulingTime {
    constructor(Name, DataOrigin, UserDefinedDataOrigin, ScheduleWork, ScheduleUsage, ScheduleStart, ScheduleFinish, ScheduleContour, LevelingDelay, IsOverAllocated, StatusTime, ActualWork, ActualUsage, ActualStart, ActualFinish, RemainingWork, RemainingUsage, Completion) {
      super(Name, DataOrigin, UserDefinedDataOrigin);
      this.Name = Name;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.ScheduleWork = ScheduleWork;
      this.ScheduleUsage = ScheduleUsage;
      this.ScheduleStart = ScheduleStart;
      this.ScheduleFinish = ScheduleFinish;
      this.ScheduleContour = ScheduleContour;
      this.LevelingDelay = LevelingDelay;
      this.IsOverAllocated = IsOverAllocated;
      this.StatusTime = StatusTime;
      this.ActualWork = ActualWork;
      this.ActualUsage = ActualUsage;
      this.ActualStart = ActualStart;
      this.ActualFinish = ActualFinish;
      this.RemainingWork = RemainingWork;
      this.RemainingUsage = RemainingUsage;
      this.Completion = Completion;
      this.type = 1042787934;
    }
  }
  IFC42.IfcResourceTime = IfcResourceTime;
  class IfcRoundedRectangleProfileDef extends IfcRectangleProfileDef {
    constructor(ProfileType, ProfileName, Position, XDim, YDim, RoundingRadius) {
      super(ProfileType, ProfileName, Position, XDim, YDim);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.XDim = XDim;
      this.YDim = YDim;
      this.RoundingRadius = RoundingRadius;
      this.type = 2778083089;
    }
  }
  IFC42.IfcRoundedRectangleProfileDef = IfcRoundedRectangleProfileDef;
  class IfcSectionProperties extends IfcPreDefinedProperties {
    constructor(SectionType, StartProfile, EndProfile) {
      super();
      this.SectionType = SectionType;
      this.StartProfile = StartProfile;
      this.EndProfile = EndProfile;
      this.type = 2042790032;
    }
  }
  IFC42.IfcSectionProperties = IfcSectionProperties;
  class IfcSectionReinforcementProperties extends IfcPreDefinedProperties {
    constructor(LongitudinalStartPosition, LongitudinalEndPosition, TransversePosition, ReinforcementRole, SectionDefinition, CrossSectionReinforcementDefinitions) {
      super();
      this.LongitudinalStartPosition = LongitudinalStartPosition;
      this.LongitudinalEndPosition = LongitudinalEndPosition;
      this.TransversePosition = TransversePosition;
      this.ReinforcementRole = ReinforcementRole;
      this.SectionDefinition = SectionDefinition;
      this.CrossSectionReinforcementDefinitions = CrossSectionReinforcementDefinitions;
      this.type = 4165799628;
    }
  }
  IFC42.IfcSectionReinforcementProperties = IfcSectionReinforcementProperties;
  class IfcSectionedSpine extends IfcGeometricRepresentationItem {
    constructor(SpineCurve, CrossSections, CrossSectionPositions) {
      super();
      this.SpineCurve = SpineCurve;
      this.CrossSections = CrossSections;
      this.CrossSectionPositions = CrossSectionPositions;
      this.type = 1509187699;
    }
  }
  IFC42.IfcSectionedSpine = IfcSectionedSpine;
  class IfcShellBasedSurfaceModel extends IfcGeometricRepresentationItem {
    constructor(SbsmBoundary) {
      super();
      this.SbsmBoundary = SbsmBoundary;
      this.type = 4124623270;
    }
  }
  IFC42.IfcShellBasedSurfaceModel = IfcShellBasedSurfaceModel;
  class IfcSimpleProperty extends IfcProperty {
    constructor(Name, Description) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.type = 3692461612;
    }
  }
  IFC42.IfcSimpleProperty = IfcSimpleProperty;
  class IfcSlippageConnectionCondition extends IfcStructuralConnectionCondition {
    constructor(Name, SlippageX, SlippageY, SlippageZ) {
      super(Name);
      this.Name = Name;
      this.SlippageX = SlippageX;
      this.SlippageY = SlippageY;
      this.SlippageZ = SlippageZ;
      this.type = 2609359061;
    }
  }
  IFC42.IfcSlippageConnectionCondition = IfcSlippageConnectionCondition;
  class IfcSolidModel extends IfcGeometricRepresentationItem {
    constructor() {
      super();
      this.type = 723233188;
    }
  }
  IFC42.IfcSolidModel = IfcSolidModel;
  class IfcStructuralLoadLinearForce extends IfcStructuralLoadStatic {
    constructor(Name, LinearForceX, LinearForceY, LinearForceZ, LinearMomentX, LinearMomentY, LinearMomentZ) {
      super(Name);
      this.Name = Name;
      this.LinearForceX = LinearForceX;
      this.LinearForceY = LinearForceY;
      this.LinearForceZ = LinearForceZ;
      this.LinearMomentX = LinearMomentX;
      this.LinearMomentY = LinearMomentY;
      this.LinearMomentZ = LinearMomentZ;
      this.type = 1595516126;
    }
  }
  IFC42.IfcStructuralLoadLinearForce = IfcStructuralLoadLinearForce;
  class IfcStructuralLoadPlanarForce extends IfcStructuralLoadStatic {
    constructor(Name, PlanarForceX, PlanarForceY, PlanarForceZ) {
      super(Name);
      this.Name = Name;
      this.PlanarForceX = PlanarForceX;
      this.PlanarForceY = PlanarForceY;
      this.PlanarForceZ = PlanarForceZ;
      this.type = 2668620305;
    }
  }
  IFC42.IfcStructuralLoadPlanarForce = IfcStructuralLoadPlanarForce;
  class IfcStructuralLoadSingleDisplacement extends IfcStructuralLoadStatic {
    constructor(Name, DisplacementX, DisplacementY, DisplacementZ, RotationalDisplacementRX, RotationalDisplacementRY, RotationalDisplacementRZ) {
      super(Name);
      this.Name = Name;
      this.DisplacementX = DisplacementX;
      this.DisplacementY = DisplacementY;
      this.DisplacementZ = DisplacementZ;
      this.RotationalDisplacementRX = RotationalDisplacementRX;
      this.RotationalDisplacementRY = RotationalDisplacementRY;
      this.RotationalDisplacementRZ = RotationalDisplacementRZ;
      this.type = 2473145415;
    }
  }
  IFC42.IfcStructuralLoadSingleDisplacement = IfcStructuralLoadSingleDisplacement;
  class IfcStructuralLoadSingleDisplacementDistortion extends IfcStructuralLoadSingleDisplacement {
    constructor(Name, DisplacementX, DisplacementY, DisplacementZ, RotationalDisplacementRX, RotationalDisplacementRY, RotationalDisplacementRZ, Distortion) {
      super(Name, DisplacementX, DisplacementY, DisplacementZ, RotationalDisplacementRX, RotationalDisplacementRY, RotationalDisplacementRZ);
      this.Name = Name;
      this.DisplacementX = DisplacementX;
      this.DisplacementY = DisplacementY;
      this.DisplacementZ = DisplacementZ;
      this.RotationalDisplacementRX = RotationalDisplacementRX;
      this.RotationalDisplacementRY = RotationalDisplacementRY;
      this.RotationalDisplacementRZ = RotationalDisplacementRZ;
      this.Distortion = Distortion;
      this.type = 1973038258;
    }
  }
  IFC42.IfcStructuralLoadSingleDisplacementDistortion = IfcStructuralLoadSingleDisplacementDistortion;
  class IfcStructuralLoadSingleForce extends IfcStructuralLoadStatic {
    constructor(Name, ForceX, ForceY, ForceZ, MomentX, MomentY, MomentZ) {
      super(Name);
      this.Name = Name;
      this.ForceX = ForceX;
      this.ForceY = ForceY;
      this.ForceZ = ForceZ;
      this.MomentX = MomentX;
      this.MomentY = MomentY;
      this.MomentZ = MomentZ;
      this.type = 1597423693;
    }
  }
  IFC42.IfcStructuralLoadSingleForce = IfcStructuralLoadSingleForce;
  class IfcStructuralLoadSingleForceWarping extends IfcStructuralLoadSingleForce {
    constructor(Name, ForceX, ForceY, ForceZ, MomentX, MomentY, MomentZ, WarpingMoment) {
      super(Name, ForceX, ForceY, ForceZ, MomentX, MomentY, MomentZ);
      this.Name = Name;
      this.ForceX = ForceX;
      this.ForceY = ForceY;
      this.ForceZ = ForceZ;
      this.MomentX = MomentX;
      this.MomentY = MomentY;
      this.MomentZ = MomentZ;
      this.WarpingMoment = WarpingMoment;
      this.type = 1190533807;
    }
  }
  IFC42.IfcStructuralLoadSingleForceWarping = IfcStructuralLoadSingleForceWarping;
  class IfcSubedge extends IfcEdge {
    constructor(EdgeStart, EdgeEnd, ParentEdge) {
      super(EdgeStart, EdgeEnd);
      this.EdgeStart = EdgeStart;
      this.EdgeEnd = EdgeEnd;
      this.ParentEdge = ParentEdge;
      this.type = 2233826070;
    }
  }
  IFC42.IfcSubedge = IfcSubedge;
  class IfcSurface extends IfcGeometricRepresentationItem {
    constructor() {
      super();
      this.type = 2513912981;
    }
  }
  IFC42.IfcSurface = IfcSurface;
  class IfcSurfaceStyleRendering extends IfcSurfaceStyleShading {
    constructor(SurfaceColour, Transparency, DiffuseColour, TransmissionColour, DiffuseTransmissionColour, ReflectionColour, SpecularColour, SpecularHighlight, ReflectanceMethod) {
      super(SurfaceColour, Transparency);
      this.SurfaceColour = SurfaceColour;
      this.Transparency = Transparency;
      this.DiffuseColour = DiffuseColour;
      this.TransmissionColour = TransmissionColour;
      this.DiffuseTransmissionColour = DiffuseTransmissionColour;
      this.ReflectionColour = ReflectionColour;
      this.SpecularColour = SpecularColour;
      this.SpecularHighlight = SpecularHighlight;
      this.ReflectanceMethod = ReflectanceMethod;
      this.type = 1878645084;
    }
  }
  IFC42.IfcSurfaceStyleRendering = IfcSurfaceStyleRendering;
  class IfcSweptAreaSolid extends IfcSolidModel {
    constructor(SweptArea, Position) {
      super();
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.type = 2247615214;
    }
  }
  IFC42.IfcSweptAreaSolid = IfcSweptAreaSolid;
  class IfcSweptDiskSolid extends IfcSolidModel {
    constructor(Directrix, Radius, InnerRadius, StartParam, EndParam) {
      super();
      this.Directrix = Directrix;
      this.Radius = Radius;
      this.InnerRadius = InnerRadius;
      this.StartParam = StartParam;
      this.EndParam = EndParam;
      this.type = 1260650574;
    }
  }
  IFC42.IfcSweptDiskSolid = IfcSweptDiskSolid;
  class IfcSweptDiskSolidPolygonal extends IfcSweptDiskSolid {
    constructor(Directrix, Radius, InnerRadius, StartParam, EndParam, FilletRadius) {
      super(Directrix, Radius, InnerRadius, StartParam, EndParam);
      this.Directrix = Directrix;
      this.Radius = Radius;
      this.InnerRadius = InnerRadius;
      this.StartParam = StartParam;
      this.EndParam = EndParam;
      this.FilletRadius = FilletRadius;
      this.type = 1096409881;
    }
  }
  IFC42.IfcSweptDiskSolidPolygonal = IfcSweptDiskSolidPolygonal;
  class IfcSweptSurface extends IfcSurface {
    constructor(SweptCurve, Position) {
      super();
      this.SweptCurve = SweptCurve;
      this.Position = Position;
      this.type = 230924584;
    }
  }
  IFC42.IfcSweptSurface = IfcSweptSurface;
  class IfcTShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(ProfileType, ProfileName, Position, Depth, FlangeWidth, WebThickness, FlangeThickness, FilletRadius, FlangeEdgeRadius, WebEdgeRadius, WebSlope, FlangeSlope) {
      super(ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Depth = Depth;
      this.FlangeWidth = FlangeWidth;
      this.WebThickness = WebThickness;
      this.FlangeThickness = FlangeThickness;
      this.FilletRadius = FilletRadius;
      this.FlangeEdgeRadius = FlangeEdgeRadius;
      this.WebEdgeRadius = WebEdgeRadius;
      this.WebSlope = WebSlope;
      this.FlangeSlope = FlangeSlope;
      this.type = 3071757647;
    }
  }
  IFC42.IfcTShapeProfileDef = IfcTShapeProfileDef;
  class IfcTessellatedItem extends IfcGeometricRepresentationItem {
    constructor() {
      super();
      this.type = 901063453;
    }
  }
  IFC42.IfcTessellatedItem = IfcTessellatedItem;
  class IfcTextLiteral extends IfcGeometricRepresentationItem {
    constructor(Literal, Placement, Path) {
      super();
      this.Literal = Literal;
      this.Placement = Placement;
      this.Path = Path;
      this.type = 4282788508;
    }
  }
  IFC42.IfcTextLiteral = IfcTextLiteral;
  class IfcTextLiteralWithExtent extends IfcTextLiteral {
    constructor(Literal, Placement, Path, Extent, BoxAlignment) {
      super(Literal, Placement, Path);
      this.Literal = Literal;
      this.Placement = Placement;
      this.Path = Path;
      this.Extent = Extent;
      this.BoxAlignment = BoxAlignment;
      this.type = 3124975700;
    }
  }
  IFC42.IfcTextLiteralWithExtent = IfcTextLiteralWithExtent;
  class IfcTextStyleFontModel extends IfcPreDefinedTextFont {
    constructor(Name, FontFamily, FontStyle, FontVariant, FontWeight, FontSize) {
      super(Name);
      this.Name = Name;
      this.FontFamily = FontFamily;
      this.FontStyle = FontStyle;
      this.FontVariant = FontVariant;
      this.FontWeight = FontWeight;
      this.FontSize = FontSize;
      this.type = 1983826977;
    }
  }
  IFC42.IfcTextStyleFontModel = IfcTextStyleFontModel;
  class IfcTrapeziumProfileDef extends IfcParameterizedProfileDef {
    constructor(ProfileType, ProfileName, Position, BottomXDim, TopXDim, YDim, TopXOffset) {
      super(ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.BottomXDim = BottomXDim;
      this.TopXDim = TopXDim;
      this.YDim = YDim;
      this.TopXOffset = TopXOffset;
      this.type = 2715220739;
    }
  }
  IFC42.IfcTrapeziumProfileDef = IfcTrapeziumProfileDef;
  class IfcTypeObject extends IfcObjectDefinition {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.type = 1628702193;
    }
  }
  IFC42.IfcTypeObject = IfcTypeObject;
  class IfcTypeProcess extends IfcTypeObject {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ProcessType = ProcessType;
      this.type = 3736923433;
    }
  }
  IFC42.IfcTypeProcess = IfcTypeProcess;
  class IfcTypeProduct extends IfcTypeObject {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.type = 2347495698;
    }
  }
  IFC42.IfcTypeProduct = IfcTypeProduct;
  class IfcTypeResource extends IfcTypeObject {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ResourceType = ResourceType;
      this.type = 3698973494;
    }
  }
  IFC42.IfcTypeResource = IfcTypeResource;
  class IfcUShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(ProfileType, ProfileName, Position, Depth, FlangeWidth, WebThickness, FlangeThickness, FilletRadius, EdgeRadius, FlangeSlope) {
      super(ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Depth = Depth;
      this.FlangeWidth = FlangeWidth;
      this.WebThickness = WebThickness;
      this.FlangeThickness = FlangeThickness;
      this.FilletRadius = FilletRadius;
      this.EdgeRadius = EdgeRadius;
      this.FlangeSlope = FlangeSlope;
      this.type = 427810014;
    }
  }
  IFC42.IfcUShapeProfileDef = IfcUShapeProfileDef;
  class IfcVector extends IfcGeometricRepresentationItem {
    constructor(Orientation, Magnitude) {
      super();
      this.Orientation = Orientation;
      this.Magnitude = Magnitude;
      this.type = 1417489154;
    }
  }
  IFC42.IfcVector = IfcVector;
  class IfcVertexLoop extends IfcLoop {
    constructor(LoopVertex) {
      super();
      this.LoopVertex = LoopVertex;
      this.type = 2759199220;
    }
  }
  IFC42.IfcVertexLoop = IfcVertexLoop;
  class IfcWindowStyle extends IfcTypeProduct {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ConstructionType, OperationType, ParameterTakesPrecedence, Sizeable) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ConstructionType = ConstructionType;
      this.OperationType = OperationType;
      this.ParameterTakesPrecedence = ParameterTakesPrecedence;
      this.Sizeable = Sizeable;
      this.type = 1299126871;
    }
  }
  IFC42.IfcWindowStyle = IfcWindowStyle;
  class IfcZShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(ProfileType, ProfileName, Position, Depth, FlangeWidth, WebThickness, FlangeThickness, FilletRadius, EdgeRadius) {
      super(ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Depth = Depth;
      this.FlangeWidth = FlangeWidth;
      this.WebThickness = WebThickness;
      this.FlangeThickness = FlangeThickness;
      this.FilletRadius = FilletRadius;
      this.EdgeRadius = EdgeRadius;
      this.type = 2543172580;
    }
  }
  IFC42.IfcZShapeProfileDef = IfcZShapeProfileDef;
  class IfcAdvancedFace extends IfcFaceSurface {
    constructor(Bounds, FaceSurface, SameSense) {
      super(Bounds, FaceSurface, SameSense);
      this.Bounds = Bounds;
      this.FaceSurface = FaceSurface;
      this.SameSense = SameSense;
      this.type = 3406155212;
    }
  }
  IFC42.IfcAdvancedFace = IfcAdvancedFace;
  class IfcAnnotationFillArea extends IfcGeometricRepresentationItem {
    constructor(OuterBoundary, InnerBoundaries) {
      super();
      this.OuterBoundary = OuterBoundary;
      this.InnerBoundaries = InnerBoundaries;
      this.type = 669184980;
    }
  }
  IFC42.IfcAnnotationFillArea = IfcAnnotationFillArea;
  class IfcAsymmetricIShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(ProfileType, ProfileName, Position, BottomFlangeWidth, OverallDepth, WebThickness, BottomFlangeThickness, BottomFlangeFilletRadius, TopFlangeWidth, TopFlangeThickness, TopFlangeFilletRadius, BottomFlangeEdgeRadius, BottomFlangeSlope, TopFlangeEdgeRadius, TopFlangeSlope) {
      super(ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.BottomFlangeWidth = BottomFlangeWidth;
      this.OverallDepth = OverallDepth;
      this.WebThickness = WebThickness;
      this.BottomFlangeThickness = BottomFlangeThickness;
      this.BottomFlangeFilletRadius = BottomFlangeFilletRadius;
      this.TopFlangeWidth = TopFlangeWidth;
      this.TopFlangeThickness = TopFlangeThickness;
      this.TopFlangeFilletRadius = TopFlangeFilletRadius;
      this.BottomFlangeEdgeRadius = BottomFlangeEdgeRadius;
      this.BottomFlangeSlope = BottomFlangeSlope;
      this.TopFlangeEdgeRadius = TopFlangeEdgeRadius;
      this.TopFlangeSlope = TopFlangeSlope;
      this.type = 3207858831;
    }
  }
  IFC42.IfcAsymmetricIShapeProfileDef = IfcAsymmetricIShapeProfileDef;
  class IfcAxis1Placement extends IfcPlacement {
    constructor(Location, Axis) {
      super(Location);
      this.Location = Location;
      this.Axis = Axis;
      this.type = 4261334040;
    }
  }
  IFC42.IfcAxis1Placement = IfcAxis1Placement;
  class IfcAxis2Placement2D extends IfcPlacement {
    constructor(Location, RefDirection) {
      super(Location);
      this.Location = Location;
      this.RefDirection = RefDirection;
      this.type = 3125803723;
    }
  }
  IFC42.IfcAxis2Placement2D = IfcAxis2Placement2D;
  class IfcAxis2Placement3D extends IfcPlacement {
    constructor(Location, Axis, RefDirection) {
      super(Location);
      this.Location = Location;
      this.Axis = Axis;
      this.RefDirection = RefDirection;
      this.type = 2740243338;
    }
  }
  IFC42.IfcAxis2Placement3D = IfcAxis2Placement3D;
  class IfcBooleanResult extends IfcGeometricRepresentationItem {
    constructor(Operator, FirstOperand, SecondOperand) {
      super();
      this.Operator = Operator;
      this.FirstOperand = FirstOperand;
      this.SecondOperand = SecondOperand;
      this.type = 2736907675;
    }
  }
  IFC42.IfcBooleanResult = IfcBooleanResult;
  class IfcBoundedSurface extends IfcSurface {
    constructor() {
      super();
      this.type = 4182860854;
    }
  }
  IFC42.IfcBoundedSurface = IfcBoundedSurface;
  class IfcBoundingBox extends IfcGeometricRepresentationItem {
    constructor(Corner, XDim, YDim, ZDim) {
      super();
      this.Corner = Corner;
      this.XDim = XDim;
      this.YDim = YDim;
      this.ZDim = ZDim;
      this.type = 2581212453;
    }
  }
  IFC42.IfcBoundingBox = IfcBoundingBox;
  class IfcBoxedHalfSpace extends IfcHalfSpaceSolid {
    constructor(BaseSurface, AgreementFlag, Enclosure) {
      super(BaseSurface, AgreementFlag);
      this.BaseSurface = BaseSurface;
      this.AgreementFlag = AgreementFlag;
      this.Enclosure = Enclosure;
      this.type = 2713105998;
    }
  }
  IFC42.IfcBoxedHalfSpace = IfcBoxedHalfSpace;
  class IfcCShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(ProfileType, ProfileName, Position, Depth, Width, WallThickness, Girth, InternalFilletRadius) {
      super(ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Depth = Depth;
      this.Width = Width;
      this.WallThickness = WallThickness;
      this.Girth = Girth;
      this.InternalFilletRadius = InternalFilletRadius;
      this.type = 2898889636;
    }
  }
  IFC42.IfcCShapeProfileDef = IfcCShapeProfileDef;
  class IfcCartesianPoint extends IfcPoint {
    constructor(Coordinates) {
      super();
      this.Coordinates = Coordinates;
      this.type = 1123145078;
    }
  }
  IFC42.IfcCartesianPoint = IfcCartesianPoint;
  class IfcCartesianPointList extends IfcGeometricRepresentationItem {
    constructor() {
      super();
      this.type = 574549367;
    }
  }
  IFC42.IfcCartesianPointList = IfcCartesianPointList;
  class IfcCartesianPointList2D extends IfcCartesianPointList {
    constructor(CoordList) {
      super();
      this.CoordList = CoordList;
      this.type = 1675464909;
    }
  }
  IFC42.IfcCartesianPointList2D = IfcCartesianPointList2D;
  class IfcCartesianPointList3D extends IfcCartesianPointList {
    constructor(CoordList) {
      super();
      this.CoordList = CoordList;
      this.type = 2059837836;
    }
  }
  IFC42.IfcCartesianPointList3D = IfcCartesianPointList3D;
  class IfcCartesianTransformationOperator extends IfcGeometricRepresentationItem {
    constructor(Axis1, Axis2, LocalOrigin, Scale) {
      super();
      this.Axis1 = Axis1;
      this.Axis2 = Axis2;
      this.LocalOrigin = LocalOrigin;
      this.Scale = Scale;
      this.type = 59481748;
    }
  }
  IFC42.IfcCartesianTransformationOperator = IfcCartesianTransformationOperator;
  class IfcCartesianTransformationOperator2D extends IfcCartesianTransformationOperator {
    constructor(Axis1, Axis2, LocalOrigin, Scale) {
      super(Axis1, Axis2, LocalOrigin, Scale);
      this.Axis1 = Axis1;
      this.Axis2 = Axis2;
      this.LocalOrigin = LocalOrigin;
      this.Scale = Scale;
      this.type = 3749851601;
    }
  }
  IFC42.IfcCartesianTransformationOperator2D = IfcCartesianTransformationOperator2D;
  class IfcCartesianTransformationOperator2DnonUniform extends IfcCartesianTransformationOperator2D {
    constructor(Axis1, Axis2, LocalOrigin, Scale, Scale2) {
      super(Axis1, Axis2, LocalOrigin, Scale);
      this.Axis1 = Axis1;
      this.Axis2 = Axis2;
      this.LocalOrigin = LocalOrigin;
      this.Scale = Scale;
      this.Scale2 = Scale2;
      this.type = 3486308946;
    }
  }
  IFC42.IfcCartesianTransformationOperator2DnonUniform = IfcCartesianTransformationOperator2DnonUniform;
  class IfcCartesianTransformationOperator3D extends IfcCartesianTransformationOperator {
    constructor(Axis1, Axis2, LocalOrigin, Scale, Axis3) {
      super(Axis1, Axis2, LocalOrigin, Scale);
      this.Axis1 = Axis1;
      this.Axis2 = Axis2;
      this.LocalOrigin = LocalOrigin;
      this.Scale = Scale;
      this.Axis3 = Axis3;
      this.type = 3331915920;
    }
  }
  IFC42.IfcCartesianTransformationOperator3D = IfcCartesianTransformationOperator3D;
  class IfcCartesianTransformationOperator3DnonUniform extends IfcCartesianTransformationOperator3D {
    constructor(Axis1, Axis2, LocalOrigin, Scale, Axis3, Scale2, Scale3) {
      super(Axis1, Axis2, LocalOrigin, Scale, Axis3);
      this.Axis1 = Axis1;
      this.Axis2 = Axis2;
      this.LocalOrigin = LocalOrigin;
      this.Scale = Scale;
      this.Axis3 = Axis3;
      this.Scale2 = Scale2;
      this.Scale3 = Scale3;
      this.type = 1416205885;
    }
  }
  IFC42.IfcCartesianTransformationOperator3DnonUniform = IfcCartesianTransformationOperator3DnonUniform;
  class IfcCircleProfileDef extends IfcParameterizedProfileDef {
    constructor(ProfileType, ProfileName, Position, Radius) {
      super(ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Radius = Radius;
      this.type = 1383045692;
    }
  }
  IFC42.IfcCircleProfileDef = IfcCircleProfileDef;
  class IfcClosedShell extends IfcConnectedFaceSet {
    constructor(CfsFaces) {
      super(CfsFaces);
      this.CfsFaces = CfsFaces;
      this.type = 2205249479;
    }
  }
  IFC42.IfcClosedShell = IfcClosedShell;
  class IfcColourRgb extends IfcColourSpecification {
    constructor(Name, Red, Green, Blue) {
      super(Name);
      this.Name = Name;
      this.Red = Red;
      this.Green = Green;
      this.Blue = Blue;
      this.type = 776857604;
    }
  }
  IFC42.IfcColourRgb = IfcColourRgb;
  class IfcComplexProperty extends IfcProperty {
    constructor(Name, Description, UsageName, HasProperties) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.UsageName = UsageName;
      this.HasProperties = HasProperties;
      this.type = 2542286263;
    }
  }
  IFC42.IfcComplexProperty = IfcComplexProperty;
  class IfcCompositeCurveSegment extends IfcGeometricRepresentationItem {
    constructor(Transition, SameSense, ParentCurve) {
      super();
      this.Transition = Transition;
      this.SameSense = SameSense;
      this.ParentCurve = ParentCurve;
      this.type = 2485617015;
    }
  }
  IFC42.IfcCompositeCurveSegment = IfcCompositeCurveSegment;
  class IfcConstructionResourceType extends IfcTypeResource {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ResourceType = ResourceType;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.type = 2574617495;
    }
  }
  IFC42.IfcConstructionResourceType = IfcConstructionResourceType;
  class IfcContext extends IfcObjectDefinition {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.LongName = LongName;
      this.Phase = Phase;
      this.RepresentationContexts = RepresentationContexts;
      this.UnitsInContext = UnitsInContext;
      this.type = 3419103109;
    }
  }
  IFC42.IfcContext = IfcContext;
  class IfcCrewResourceType extends IfcConstructionResourceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ResourceType = ResourceType;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 1815067380;
    }
  }
  IFC42.IfcCrewResourceType = IfcCrewResourceType;
  class IfcCsgPrimitive3D extends IfcGeometricRepresentationItem {
    constructor(Position) {
      super();
      this.Position = Position;
      this.type = 2506170314;
    }
  }
  IFC42.IfcCsgPrimitive3D = IfcCsgPrimitive3D;
  class IfcCsgSolid extends IfcSolidModel {
    constructor(TreeRootExpression) {
      super();
      this.TreeRootExpression = TreeRootExpression;
      this.type = 2147822146;
    }
  }
  IFC42.IfcCsgSolid = IfcCsgSolid;
  class IfcCurve extends IfcGeometricRepresentationItem {
    constructor() {
      super();
      this.type = 2601014836;
    }
  }
  IFC42.IfcCurve = IfcCurve;
  class IfcCurveBoundedPlane extends IfcBoundedSurface {
    constructor(BasisSurface, OuterBoundary, InnerBoundaries) {
      super();
      this.BasisSurface = BasisSurface;
      this.OuterBoundary = OuterBoundary;
      this.InnerBoundaries = InnerBoundaries;
      this.type = 2827736869;
    }
  }
  IFC42.IfcCurveBoundedPlane = IfcCurveBoundedPlane;
  class IfcCurveBoundedSurface extends IfcBoundedSurface {
    constructor(BasisSurface, Boundaries, ImplicitOuter) {
      super();
      this.BasisSurface = BasisSurface;
      this.Boundaries = Boundaries;
      this.ImplicitOuter = ImplicitOuter;
      this.type = 2629017746;
    }
  }
  IFC42.IfcCurveBoundedSurface = IfcCurveBoundedSurface;
  class IfcDirection extends IfcGeometricRepresentationItem {
    constructor(DirectionRatios) {
      super();
      this.DirectionRatios = DirectionRatios;
      this.type = 32440307;
    }
  }
  IFC42.IfcDirection = IfcDirection;
  class IfcDoorStyle extends IfcTypeProduct {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, OperationType, ConstructionType, ParameterTakesPrecedence, Sizeable) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.OperationType = OperationType;
      this.ConstructionType = ConstructionType;
      this.ParameterTakesPrecedence = ParameterTakesPrecedence;
      this.Sizeable = Sizeable;
      this.type = 526551008;
    }
  }
  IFC42.IfcDoorStyle = IfcDoorStyle;
  class IfcEdgeLoop extends IfcLoop {
    constructor(EdgeList) {
      super();
      this.EdgeList = EdgeList;
      this.type = 1472233963;
    }
  }
  IFC42.IfcEdgeLoop = IfcEdgeLoop;
  class IfcElementQuantity extends IfcQuantitySet {
    constructor(GlobalId, OwnerHistory, Name, Description, MethodOfMeasurement, Quantities) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.MethodOfMeasurement = MethodOfMeasurement;
      this.Quantities = Quantities;
      this.type = 1883228015;
    }
  }
  IFC42.IfcElementQuantity = IfcElementQuantity;
  class IfcElementType extends IfcTypeProduct {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 339256511;
    }
  }
  IFC42.IfcElementType = IfcElementType;
  class IfcElementarySurface extends IfcSurface {
    constructor(Position) {
      super();
      this.Position = Position;
      this.type = 2777663545;
    }
  }
  IFC42.IfcElementarySurface = IfcElementarySurface;
  class IfcEllipseProfileDef extends IfcParameterizedProfileDef {
    constructor(ProfileType, ProfileName, Position, SemiAxis1, SemiAxis2) {
      super(ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.SemiAxis1 = SemiAxis1;
      this.SemiAxis2 = SemiAxis2;
      this.type = 2835456948;
    }
  }
  IFC42.IfcEllipseProfileDef = IfcEllipseProfileDef;
  class IfcEventType extends IfcTypeProcess {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType, PredefinedType, EventTriggerType, UserDefinedEventTriggerType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ProcessType = ProcessType;
      this.PredefinedType = PredefinedType;
      this.EventTriggerType = EventTriggerType;
      this.UserDefinedEventTriggerType = UserDefinedEventTriggerType;
      this.type = 4024345920;
    }
  }
  IFC42.IfcEventType = IfcEventType;
  class IfcExtrudedAreaSolid extends IfcSweptAreaSolid {
    constructor(SweptArea, Position, ExtrudedDirection, Depth) {
      super(SweptArea, Position);
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.ExtrudedDirection = ExtrudedDirection;
      this.Depth = Depth;
      this.type = 477187591;
    }
  }
  IFC42.IfcExtrudedAreaSolid = IfcExtrudedAreaSolid;
  class IfcExtrudedAreaSolidTapered extends IfcExtrudedAreaSolid {
    constructor(SweptArea, Position, ExtrudedDirection, Depth, EndSweptArea) {
      super(SweptArea, Position, ExtrudedDirection, Depth);
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.ExtrudedDirection = ExtrudedDirection;
      this.Depth = Depth;
      this.EndSweptArea = EndSweptArea;
      this.type = 2804161546;
    }
  }
  IFC42.IfcExtrudedAreaSolidTapered = IfcExtrudedAreaSolidTapered;
  class IfcFaceBasedSurfaceModel extends IfcGeometricRepresentationItem {
    constructor(FbsmFaces) {
      super();
      this.FbsmFaces = FbsmFaces;
      this.type = 2047409740;
    }
  }
  IFC42.IfcFaceBasedSurfaceModel = IfcFaceBasedSurfaceModel;
  class IfcFillAreaStyleHatching extends IfcGeometricRepresentationItem {
    constructor(HatchLineAppearance, StartOfNextHatchLine, PointOfReferenceHatchLine, PatternStart, HatchLineAngle) {
      super();
      this.HatchLineAppearance = HatchLineAppearance;
      this.StartOfNextHatchLine = StartOfNextHatchLine;
      this.PointOfReferenceHatchLine = PointOfReferenceHatchLine;
      this.PatternStart = PatternStart;
      this.HatchLineAngle = HatchLineAngle;
      this.type = 374418227;
    }
  }
  IFC42.IfcFillAreaStyleHatching = IfcFillAreaStyleHatching;
  class IfcFillAreaStyleTiles extends IfcGeometricRepresentationItem {
    constructor(TilingPattern, Tiles, TilingScale) {
      super();
      this.TilingPattern = TilingPattern;
      this.Tiles = Tiles;
      this.TilingScale = TilingScale;
      this.type = 315944413;
    }
  }
  IFC42.IfcFillAreaStyleTiles = IfcFillAreaStyleTiles;
  class IfcFixedReferenceSweptAreaSolid extends IfcSweptAreaSolid {
    constructor(SweptArea, Position, Directrix, StartParam, EndParam, FixedReference) {
      super(SweptArea, Position);
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.Directrix = Directrix;
      this.StartParam = StartParam;
      this.EndParam = EndParam;
      this.FixedReference = FixedReference;
      this.type = 2652556860;
    }
  }
  IFC42.IfcFixedReferenceSweptAreaSolid = IfcFixedReferenceSweptAreaSolid;
  class IfcFurnishingElementType extends IfcElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 4238390223;
    }
  }
  IFC42.IfcFurnishingElementType = IfcFurnishingElementType;
  class IfcFurnitureType extends IfcFurnishingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, AssemblyPlace, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.AssemblyPlace = AssemblyPlace;
      this.PredefinedType = PredefinedType;
      this.type = 1268542332;
    }
  }
  IFC42.IfcFurnitureType = IfcFurnitureType;
  class IfcGeographicElementType extends IfcElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4095422895;
    }
  }
  IFC42.IfcGeographicElementType = IfcGeographicElementType;
  class IfcGeometricCurveSet extends IfcGeometricSet {
    constructor(Elements) {
      super(Elements);
      this.Elements = Elements;
      this.type = 987898635;
    }
  }
  IFC42.IfcGeometricCurveSet = IfcGeometricCurveSet;
  class IfcIShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(ProfileType, ProfileName, Position, OverallWidth, OverallDepth, WebThickness, FlangeThickness, FilletRadius, FlangeEdgeRadius, FlangeSlope) {
      super(ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.OverallWidth = OverallWidth;
      this.OverallDepth = OverallDepth;
      this.WebThickness = WebThickness;
      this.FlangeThickness = FlangeThickness;
      this.FilletRadius = FilletRadius;
      this.FlangeEdgeRadius = FlangeEdgeRadius;
      this.FlangeSlope = FlangeSlope;
      this.type = 1484403080;
    }
  }
  IFC42.IfcIShapeProfileDef = IfcIShapeProfileDef;
  class IfcIndexedPolygonalFace extends IfcTessellatedItem {
    constructor(CoordIndex) {
      super();
      this.CoordIndex = CoordIndex;
      this.type = 178912537;
    }
  }
  IFC42.IfcIndexedPolygonalFace = IfcIndexedPolygonalFace;
  class IfcIndexedPolygonalFaceWithVoids extends IfcIndexedPolygonalFace {
    constructor(CoordIndex, InnerCoordIndices) {
      super(CoordIndex);
      this.CoordIndex = CoordIndex;
      this.InnerCoordIndices = InnerCoordIndices;
      this.type = 2294589976;
    }
  }
  IFC42.IfcIndexedPolygonalFaceWithVoids = IfcIndexedPolygonalFaceWithVoids;
  class IfcLShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(ProfileType, ProfileName, Position, Depth, Width, Thickness, FilletRadius, EdgeRadius, LegSlope) {
      super(ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Depth = Depth;
      this.Width = Width;
      this.Thickness = Thickness;
      this.FilletRadius = FilletRadius;
      this.EdgeRadius = EdgeRadius;
      this.LegSlope = LegSlope;
      this.type = 572779678;
    }
  }
  IFC42.IfcLShapeProfileDef = IfcLShapeProfileDef;
  class IfcLaborResourceType extends IfcConstructionResourceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ResourceType = ResourceType;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 428585644;
    }
  }
  IFC42.IfcLaborResourceType = IfcLaborResourceType;
  class IfcLine extends IfcCurve {
    constructor(Pnt, Dir) {
      super();
      this.Pnt = Pnt;
      this.Dir = Dir;
      this.type = 1281925730;
    }
  }
  IFC42.IfcLine = IfcLine;
  class IfcManifoldSolidBrep extends IfcSolidModel {
    constructor(Outer) {
      super();
      this.Outer = Outer;
      this.type = 1425443689;
    }
  }
  IFC42.IfcManifoldSolidBrep = IfcManifoldSolidBrep;
  class IfcObject extends IfcObjectDefinition {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.type = 3888040117;
    }
  }
  IFC42.IfcObject = IfcObject;
  class IfcOffsetCurve2D extends IfcCurve {
    constructor(BasisCurve, Distance, SelfIntersect) {
      super();
      this.BasisCurve = BasisCurve;
      this.Distance = Distance;
      this.SelfIntersect = SelfIntersect;
      this.type = 3388369263;
    }
  }
  IFC42.IfcOffsetCurve2D = IfcOffsetCurve2D;
  class IfcOffsetCurve3D extends IfcCurve {
    constructor(BasisCurve, Distance, SelfIntersect, RefDirection) {
      super();
      this.BasisCurve = BasisCurve;
      this.Distance = Distance;
      this.SelfIntersect = SelfIntersect;
      this.RefDirection = RefDirection;
      this.type = 3505215534;
    }
  }
  IFC42.IfcOffsetCurve3D = IfcOffsetCurve3D;
  class IfcPcurve extends IfcCurve {
    constructor(BasisSurface, ReferenceCurve) {
      super();
      this.BasisSurface = BasisSurface;
      this.ReferenceCurve = ReferenceCurve;
      this.type = 1682466193;
    }
  }
  IFC42.IfcPcurve = IfcPcurve;
  class IfcPlanarBox extends IfcPlanarExtent {
    constructor(SizeInX, SizeInY, Placement) {
      super(SizeInX, SizeInY);
      this.SizeInX = SizeInX;
      this.SizeInY = SizeInY;
      this.Placement = Placement;
      this.type = 603570806;
    }
  }
  IFC42.IfcPlanarBox = IfcPlanarBox;
  class IfcPlane extends IfcElementarySurface {
    constructor(Position) {
      super(Position);
      this.Position = Position;
      this.type = 220341763;
    }
  }
  IFC42.IfcPlane = IfcPlane;
  class IfcPreDefinedColour extends IfcPreDefinedItem {
    constructor(Name) {
      super(Name);
      this.Name = Name;
      this.type = 759155922;
    }
  }
  IFC42.IfcPreDefinedColour = IfcPreDefinedColour;
  class IfcPreDefinedCurveFont extends IfcPreDefinedItem {
    constructor(Name) {
      super(Name);
      this.Name = Name;
      this.type = 2559016684;
    }
  }
  IFC42.IfcPreDefinedCurveFont = IfcPreDefinedCurveFont;
  class IfcPreDefinedPropertySet extends IfcPropertySetDefinition {
    constructor(GlobalId, OwnerHistory, Name, Description) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 3967405729;
    }
  }
  IFC42.IfcPreDefinedPropertySet = IfcPreDefinedPropertySet;
  class IfcProcedureType extends IfcTypeProcess {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ProcessType = ProcessType;
      this.PredefinedType = PredefinedType;
      this.type = 569719735;
    }
  }
  IFC42.IfcProcedureType = IfcProcedureType;
  class IfcProcess extends IfcObject {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.type = 2945172077;
    }
  }
  IFC42.IfcProcess = IfcProcess;
  class IfcProduct extends IfcObject {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.type = 4208778838;
    }
  }
  IFC42.IfcProduct = IfcProduct;
  class IfcProject extends IfcContext {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.LongName = LongName;
      this.Phase = Phase;
      this.RepresentationContexts = RepresentationContexts;
      this.UnitsInContext = UnitsInContext;
      this.type = 103090709;
    }
  }
  IFC42.IfcProject = IfcProject;
  class IfcProjectLibrary extends IfcContext {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.LongName = LongName;
      this.Phase = Phase;
      this.RepresentationContexts = RepresentationContexts;
      this.UnitsInContext = UnitsInContext;
      this.type = 653396225;
    }
  }
  IFC42.IfcProjectLibrary = IfcProjectLibrary;
  class IfcPropertyBoundedValue extends IfcSimpleProperty {
    constructor(Name, Description, UpperBoundValue, LowerBoundValue, Unit, SetPointValue) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.UpperBoundValue = UpperBoundValue;
      this.LowerBoundValue = LowerBoundValue;
      this.Unit = Unit;
      this.SetPointValue = SetPointValue;
      this.type = 871118103;
    }
  }
  IFC42.IfcPropertyBoundedValue = IfcPropertyBoundedValue;
  class IfcPropertyEnumeratedValue extends IfcSimpleProperty {
    constructor(Name, Description, EnumerationValues, EnumerationReference) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.EnumerationValues = EnumerationValues;
      this.EnumerationReference = EnumerationReference;
      this.type = 4166981789;
    }
  }
  IFC42.IfcPropertyEnumeratedValue = IfcPropertyEnumeratedValue;
  class IfcPropertyListValue extends IfcSimpleProperty {
    constructor(Name, Description, ListValues, Unit) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.ListValues = ListValues;
      this.Unit = Unit;
      this.type = 2752243245;
    }
  }
  IFC42.IfcPropertyListValue = IfcPropertyListValue;
  class IfcPropertyReferenceValue extends IfcSimpleProperty {
    constructor(Name, Description, UsageName, PropertyReference) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.UsageName = UsageName;
      this.PropertyReference = PropertyReference;
      this.type = 941946838;
    }
  }
  IFC42.IfcPropertyReferenceValue = IfcPropertyReferenceValue;
  class IfcPropertySet extends IfcPropertySetDefinition {
    constructor(GlobalId, OwnerHistory, Name, Description, HasProperties) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.HasProperties = HasProperties;
      this.type = 1451395588;
    }
  }
  IFC42.IfcPropertySet = IfcPropertySet;
  class IfcPropertySetTemplate extends IfcPropertyTemplateDefinition {
    constructor(GlobalId, OwnerHistory, Name, Description, TemplateType, ApplicableEntity, HasPropertyTemplates) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.TemplateType = TemplateType;
      this.ApplicableEntity = ApplicableEntity;
      this.HasPropertyTemplates = HasPropertyTemplates;
      this.type = 492091185;
    }
  }
  IFC42.IfcPropertySetTemplate = IfcPropertySetTemplate;
  class IfcPropertySingleValue extends IfcSimpleProperty {
    constructor(Name, Description, NominalValue, Unit) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.NominalValue = NominalValue;
      this.Unit = Unit;
      this.type = 3650150729;
    }
  }
  IFC42.IfcPropertySingleValue = IfcPropertySingleValue;
  class IfcPropertyTableValue extends IfcSimpleProperty {
    constructor(Name, Description, DefiningValues, DefinedValues, Expression, DefiningUnit, DefinedUnit, CurveInterpolation) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.DefiningValues = DefiningValues;
      this.DefinedValues = DefinedValues;
      this.Expression = Expression;
      this.DefiningUnit = DefiningUnit;
      this.DefinedUnit = DefinedUnit;
      this.CurveInterpolation = CurveInterpolation;
      this.type = 110355661;
    }
  }
  IFC42.IfcPropertyTableValue = IfcPropertyTableValue;
  class IfcPropertyTemplate extends IfcPropertyTemplateDefinition {
    constructor(GlobalId, OwnerHistory, Name, Description) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 3521284610;
    }
  }
  IFC42.IfcPropertyTemplate = IfcPropertyTemplate;
  class IfcProxy extends IfcProduct {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, ProxyType, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.ProxyType = ProxyType;
      this.Tag = Tag;
      this.type = 3219374653;
    }
  }
  IFC42.IfcProxy = IfcProxy;
  class IfcRectangleHollowProfileDef extends IfcRectangleProfileDef {
    constructor(ProfileType, ProfileName, Position, XDim, YDim, WallThickness, InnerFilletRadius, OuterFilletRadius) {
      super(ProfileType, ProfileName, Position, XDim, YDim);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.XDim = XDim;
      this.YDim = YDim;
      this.WallThickness = WallThickness;
      this.InnerFilletRadius = InnerFilletRadius;
      this.OuterFilletRadius = OuterFilletRadius;
      this.type = 2770003689;
    }
  }
  IFC42.IfcRectangleHollowProfileDef = IfcRectangleHollowProfileDef;
  class IfcRectangularPyramid extends IfcCsgPrimitive3D {
    constructor(Position, XLength, YLength, Height) {
      super(Position);
      this.Position = Position;
      this.XLength = XLength;
      this.YLength = YLength;
      this.Height = Height;
      this.type = 2798486643;
    }
  }
  IFC42.IfcRectangularPyramid = IfcRectangularPyramid;
  class IfcRectangularTrimmedSurface extends IfcBoundedSurface {
    constructor(BasisSurface, U1, V1, U2, V2, Usense, Vsense) {
      super();
      this.BasisSurface = BasisSurface;
      this.U1 = U1;
      this.V1 = V1;
      this.U2 = U2;
      this.V2 = V2;
      this.Usense = Usense;
      this.Vsense = Vsense;
      this.type = 3454111270;
    }
  }
  IFC42.IfcRectangularTrimmedSurface = IfcRectangularTrimmedSurface;
  class IfcReinforcementDefinitionProperties extends IfcPreDefinedPropertySet {
    constructor(GlobalId, OwnerHistory, Name, Description, DefinitionType, ReinforcementSectionDefinitions) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.DefinitionType = DefinitionType;
      this.ReinforcementSectionDefinitions = ReinforcementSectionDefinitions;
      this.type = 3765753017;
    }
  }
  IFC42.IfcReinforcementDefinitionProperties = IfcReinforcementDefinitionProperties;
  class IfcRelAssigns extends IfcRelationship {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.type = 3939117080;
    }
  }
  IFC42.IfcRelAssigns = IfcRelAssigns;
  class IfcRelAssignsToActor extends IfcRelAssigns {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingActor, ActingRole) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingActor = RelatingActor;
      this.ActingRole = ActingRole;
      this.type = 1683148259;
    }
  }
  IFC42.IfcRelAssignsToActor = IfcRelAssignsToActor;
  class IfcRelAssignsToControl extends IfcRelAssigns {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingControl) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingControl = RelatingControl;
      this.type = 2495723537;
    }
  }
  IFC42.IfcRelAssignsToControl = IfcRelAssignsToControl;
  class IfcRelAssignsToGroup extends IfcRelAssigns {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingGroup) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingGroup = RelatingGroup;
      this.type = 1307041759;
    }
  }
  IFC42.IfcRelAssignsToGroup = IfcRelAssignsToGroup;
  class IfcRelAssignsToGroupByFactor extends IfcRelAssignsToGroup {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingGroup, Factor) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingGroup);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingGroup = RelatingGroup;
      this.Factor = Factor;
      this.type = 1027710054;
    }
  }
  IFC42.IfcRelAssignsToGroupByFactor = IfcRelAssignsToGroupByFactor;
  class IfcRelAssignsToProcess extends IfcRelAssigns {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingProcess, QuantityInProcess) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingProcess = RelatingProcess;
      this.QuantityInProcess = QuantityInProcess;
      this.type = 4278684876;
    }
  }
  IFC42.IfcRelAssignsToProcess = IfcRelAssignsToProcess;
  class IfcRelAssignsToProduct extends IfcRelAssigns {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingProduct) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingProduct = RelatingProduct;
      this.type = 2857406711;
    }
  }
  IFC42.IfcRelAssignsToProduct = IfcRelAssignsToProduct;
  class IfcRelAssignsToResource extends IfcRelAssigns {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingResource) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingResource = RelatingResource;
      this.type = 205026976;
    }
  }
  IFC42.IfcRelAssignsToResource = IfcRelAssignsToResource;
  class IfcRelAssociates extends IfcRelationship {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.type = 1865459582;
    }
  }
  IFC42.IfcRelAssociates = IfcRelAssociates;
  class IfcRelAssociatesApproval extends IfcRelAssociates {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingApproval) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingApproval = RelatingApproval;
      this.type = 4095574036;
    }
  }
  IFC42.IfcRelAssociatesApproval = IfcRelAssociatesApproval;
  class IfcRelAssociatesClassification extends IfcRelAssociates {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingClassification) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingClassification = RelatingClassification;
      this.type = 919958153;
    }
  }
  IFC42.IfcRelAssociatesClassification = IfcRelAssociatesClassification;
  class IfcRelAssociatesConstraint extends IfcRelAssociates {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, Intent, RelatingConstraint) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.Intent = Intent;
      this.RelatingConstraint = RelatingConstraint;
      this.type = 2728634034;
    }
  }
  IFC42.IfcRelAssociatesConstraint = IfcRelAssociatesConstraint;
  class IfcRelAssociatesDocument extends IfcRelAssociates {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingDocument) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingDocument = RelatingDocument;
      this.type = 982818633;
    }
  }
  IFC42.IfcRelAssociatesDocument = IfcRelAssociatesDocument;
  class IfcRelAssociatesLibrary extends IfcRelAssociates {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingLibrary) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingLibrary = RelatingLibrary;
      this.type = 3840914261;
    }
  }
  IFC42.IfcRelAssociatesLibrary = IfcRelAssociatesLibrary;
  class IfcRelAssociatesMaterial extends IfcRelAssociates {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingMaterial) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingMaterial = RelatingMaterial;
      this.type = 2655215786;
    }
  }
  IFC42.IfcRelAssociatesMaterial = IfcRelAssociatesMaterial;
  class IfcRelConnects extends IfcRelationship {
    constructor(GlobalId, OwnerHistory, Name, Description) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 826625072;
    }
  }
  IFC42.IfcRelConnects = IfcRelConnects;
  class IfcRelConnectsElements extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ConnectionGeometry = ConnectionGeometry;
      this.RelatingElement = RelatingElement;
      this.RelatedElement = RelatedElement;
      this.type = 1204542856;
    }
  }
  IFC42.IfcRelConnectsElements = IfcRelConnectsElements;
  class IfcRelConnectsPathElements extends IfcRelConnectsElements {
    constructor(GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement, RelatingPriorities, RelatedPriorities, RelatedConnectionType, RelatingConnectionType) {
      super(GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ConnectionGeometry = ConnectionGeometry;
      this.RelatingElement = RelatingElement;
      this.RelatedElement = RelatedElement;
      this.RelatingPriorities = RelatingPriorities;
      this.RelatedPriorities = RelatedPriorities;
      this.RelatedConnectionType = RelatedConnectionType;
      this.RelatingConnectionType = RelatingConnectionType;
      this.type = 3945020480;
    }
  }
  IFC42.IfcRelConnectsPathElements = IfcRelConnectsPathElements;
  class IfcRelConnectsPortToElement extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingPort, RelatedElement) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingPort = RelatingPort;
      this.RelatedElement = RelatedElement;
      this.type = 4201705270;
    }
  }
  IFC42.IfcRelConnectsPortToElement = IfcRelConnectsPortToElement;
  class IfcRelConnectsPorts extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingPort, RelatedPort, RealizingElement) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingPort = RelatingPort;
      this.RelatedPort = RelatedPort;
      this.RealizingElement = RealizingElement;
      this.type = 3190031847;
    }
  }
  IFC42.IfcRelConnectsPorts = IfcRelConnectsPorts;
  class IfcRelConnectsStructuralActivity extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedStructuralActivity) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingElement = RelatingElement;
      this.RelatedStructuralActivity = RelatedStructuralActivity;
      this.type = 2127690289;
    }
  }
  IFC42.IfcRelConnectsStructuralActivity = IfcRelConnectsStructuralActivity;
  class IfcRelConnectsStructuralMember extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingStructuralMember, RelatedStructuralConnection, AppliedCondition, AdditionalConditions, SupportedLength, ConditionCoordinateSystem) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingStructuralMember = RelatingStructuralMember;
      this.RelatedStructuralConnection = RelatedStructuralConnection;
      this.AppliedCondition = AppliedCondition;
      this.AdditionalConditions = AdditionalConditions;
      this.SupportedLength = SupportedLength;
      this.ConditionCoordinateSystem = ConditionCoordinateSystem;
      this.type = 1638771189;
    }
  }
  IFC42.IfcRelConnectsStructuralMember = IfcRelConnectsStructuralMember;
  class IfcRelConnectsWithEccentricity extends IfcRelConnectsStructuralMember {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingStructuralMember, RelatedStructuralConnection, AppliedCondition, AdditionalConditions, SupportedLength, ConditionCoordinateSystem, ConnectionConstraint) {
      super(GlobalId, OwnerHistory, Name, Description, RelatingStructuralMember, RelatedStructuralConnection, AppliedCondition, AdditionalConditions, SupportedLength, ConditionCoordinateSystem);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingStructuralMember = RelatingStructuralMember;
      this.RelatedStructuralConnection = RelatedStructuralConnection;
      this.AppliedCondition = AppliedCondition;
      this.AdditionalConditions = AdditionalConditions;
      this.SupportedLength = SupportedLength;
      this.ConditionCoordinateSystem = ConditionCoordinateSystem;
      this.ConnectionConstraint = ConnectionConstraint;
      this.type = 504942748;
    }
  }
  IFC42.IfcRelConnectsWithEccentricity = IfcRelConnectsWithEccentricity;
  class IfcRelConnectsWithRealizingElements extends IfcRelConnectsElements {
    constructor(GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement, RealizingElements, ConnectionType) {
      super(GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ConnectionGeometry = ConnectionGeometry;
      this.RelatingElement = RelatingElement;
      this.RelatedElement = RelatedElement;
      this.RealizingElements = RealizingElements;
      this.ConnectionType = ConnectionType;
      this.type = 3678494232;
    }
  }
  IFC42.IfcRelConnectsWithRealizingElements = IfcRelConnectsWithRealizingElements;
  class IfcRelContainedInSpatialStructure extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedElements, RelatingStructure) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedElements = RelatedElements;
      this.RelatingStructure = RelatingStructure;
      this.type = 3242617779;
    }
  }
  IFC42.IfcRelContainedInSpatialStructure = IfcRelContainedInSpatialStructure;
  class IfcRelCoversBldgElements extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingBuildingElement, RelatedCoverings) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingBuildingElement = RelatingBuildingElement;
      this.RelatedCoverings = RelatedCoverings;
      this.type = 886880790;
    }
  }
  IFC42.IfcRelCoversBldgElements = IfcRelCoversBldgElements;
  class IfcRelCoversSpaces extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedCoverings) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingSpace = RelatingSpace;
      this.RelatedCoverings = RelatedCoverings;
      this.type = 2802773753;
    }
  }
  IFC42.IfcRelCoversSpaces = IfcRelCoversSpaces;
  class IfcRelDeclares extends IfcRelationship {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingContext, RelatedDefinitions) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingContext = RelatingContext;
      this.RelatedDefinitions = RelatedDefinitions;
      this.type = 2565941209;
    }
  }
  IFC42.IfcRelDeclares = IfcRelDeclares;
  class IfcRelDecomposes extends IfcRelationship {
    constructor(GlobalId, OwnerHistory, Name, Description) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 2551354335;
    }
  }
  IFC42.IfcRelDecomposes = IfcRelDecomposes;
  class IfcRelDefines extends IfcRelationship {
    constructor(GlobalId, OwnerHistory, Name, Description) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 693640335;
    }
  }
  IFC42.IfcRelDefines = IfcRelDefines;
  class IfcRelDefinesByObject extends IfcRelDefines {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingObject) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingObject = RelatingObject;
      this.type = 1462361463;
    }
  }
  IFC42.IfcRelDefinesByObject = IfcRelDefinesByObject;
  class IfcRelDefinesByProperties extends IfcRelDefines {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingPropertyDefinition) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingPropertyDefinition = RelatingPropertyDefinition;
      this.type = 4186316022;
    }
  }
  IFC42.IfcRelDefinesByProperties = IfcRelDefinesByProperties;
  class IfcRelDefinesByTemplate extends IfcRelDefines {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedPropertySets, RelatingTemplate) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedPropertySets = RelatedPropertySets;
      this.RelatingTemplate = RelatingTemplate;
      this.type = 307848117;
    }
  }
  IFC42.IfcRelDefinesByTemplate = IfcRelDefinesByTemplate;
  class IfcRelDefinesByType extends IfcRelDefines {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingType) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingType = RelatingType;
      this.type = 781010003;
    }
  }
  IFC42.IfcRelDefinesByType = IfcRelDefinesByType;
  class IfcRelFillsElement extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingOpeningElement, RelatedBuildingElement) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingOpeningElement = RelatingOpeningElement;
      this.RelatedBuildingElement = RelatedBuildingElement;
      this.type = 3940055652;
    }
  }
  IFC42.IfcRelFillsElement = IfcRelFillsElement;
  class IfcRelFlowControlElements extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedControlElements, RelatingFlowElement) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedControlElements = RelatedControlElements;
      this.RelatingFlowElement = RelatingFlowElement;
      this.type = 279856033;
    }
  }
  IFC42.IfcRelFlowControlElements = IfcRelFlowControlElements;
  class IfcRelInterferesElements extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedElement, InterferenceGeometry, InterferenceType, ImpliedOrder) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingElement = RelatingElement;
      this.RelatedElement = RelatedElement;
      this.InterferenceGeometry = InterferenceGeometry;
      this.InterferenceType = InterferenceType;
      this.ImpliedOrder = ImpliedOrder;
      this.type = 427948657;
    }
  }
  IFC42.IfcRelInterferesElements = IfcRelInterferesElements;
  class IfcRelNests extends IfcRelDecomposes {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingObject, RelatedObjects) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingObject = RelatingObject;
      this.RelatedObjects = RelatedObjects;
      this.type = 3268803585;
    }
  }
  IFC42.IfcRelNests = IfcRelNests;
  class IfcRelProjectsElement extends IfcRelDecomposes {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedFeatureElement) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingElement = RelatingElement;
      this.RelatedFeatureElement = RelatedFeatureElement;
      this.type = 750771296;
    }
  }
  IFC42.IfcRelProjectsElement = IfcRelProjectsElement;
  class IfcRelReferencedInSpatialStructure extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedElements, RelatingStructure) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedElements = RelatedElements;
      this.RelatingStructure = RelatingStructure;
      this.type = 1245217292;
    }
  }
  IFC42.IfcRelReferencedInSpatialStructure = IfcRelReferencedInSpatialStructure;
  class IfcRelSequence extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingProcess, RelatedProcess, TimeLag, SequenceType, UserDefinedSequenceType) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingProcess = RelatingProcess;
      this.RelatedProcess = RelatedProcess;
      this.TimeLag = TimeLag;
      this.SequenceType = SequenceType;
      this.UserDefinedSequenceType = UserDefinedSequenceType;
      this.type = 4122056220;
    }
  }
  IFC42.IfcRelSequence = IfcRelSequence;
  class IfcRelServicesBuildings extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingSystem, RelatedBuildings) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingSystem = RelatingSystem;
      this.RelatedBuildings = RelatedBuildings;
      this.type = 366585022;
    }
  }
  IFC42.IfcRelServicesBuildings = IfcRelServicesBuildings;
  class IfcRelSpaceBoundary extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingSpace = RelatingSpace;
      this.RelatedBuildingElement = RelatedBuildingElement;
      this.ConnectionGeometry = ConnectionGeometry;
      this.PhysicalOrVirtualBoundary = PhysicalOrVirtualBoundary;
      this.InternalOrExternalBoundary = InternalOrExternalBoundary;
      this.type = 3451746338;
    }
  }
  IFC42.IfcRelSpaceBoundary = IfcRelSpaceBoundary;
  class IfcRelSpaceBoundary1stLevel extends IfcRelSpaceBoundary {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary, ParentBoundary) {
      super(GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingSpace = RelatingSpace;
      this.RelatedBuildingElement = RelatedBuildingElement;
      this.ConnectionGeometry = ConnectionGeometry;
      this.PhysicalOrVirtualBoundary = PhysicalOrVirtualBoundary;
      this.InternalOrExternalBoundary = InternalOrExternalBoundary;
      this.ParentBoundary = ParentBoundary;
      this.type = 3523091289;
    }
  }
  IFC42.IfcRelSpaceBoundary1stLevel = IfcRelSpaceBoundary1stLevel;
  class IfcRelSpaceBoundary2ndLevel extends IfcRelSpaceBoundary1stLevel {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary, ParentBoundary, CorrespondingBoundary) {
      super(GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary, ParentBoundary);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingSpace = RelatingSpace;
      this.RelatedBuildingElement = RelatedBuildingElement;
      this.ConnectionGeometry = ConnectionGeometry;
      this.PhysicalOrVirtualBoundary = PhysicalOrVirtualBoundary;
      this.InternalOrExternalBoundary = InternalOrExternalBoundary;
      this.ParentBoundary = ParentBoundary;
      this.CorrespondingBoundary = CorrespondingBoundary;
      this.type = 1521410863;
    }
  }
  IFC42.IfcRelSpaceBoundary2ndLevel = IfcRelSpaceBoundary2ndLevel;
  class IfcRelVoidsElement extends IfcRelDecomposes {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingBuildingElement, RelatedOpeningElement) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingBuildingElement = RelatingBuildingElement;
      this.RelatedOpeningElement = RelatedOpeningElement;
      this.type = 1401173127;
    }
  }
  IFC42.IfcRelVoidsElement = IfcRelVoidsElement;
  class IfcReparametrisedCompositeCurveSegment extends IfcCompositeCurveSegment {
    constructor(Transition, SameSense, ParentCurve, ParamLength) {
      super(Transition, SameSense, ParentCurve);
      this.Transition = Transition;
      this.SameSense = SameSense;
      this.ParentCurve = ParentCurve;
      this.ParamLength = ParamLength;
      this.type = 816062949;
    }
  }
  IFC42.IfcReparametrisedCompositeCurveSegment = IfcReparametrisedCompositeCurveSegment;
  class IfcResource extends IfcObject {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.type = 2914609552;
    }
  }
  IFC42.IfcResource = IfcResource;
  class IfcRevolvedAreaSolid extends IfcSweptAreaSolid {
    constructor(SweptArea, Position, Axis, Angle) {
      super(SweptArea, Position);
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.Axis = Axis;
      this.Angle = Angle;
      this.type = 1856042241;
    }
  }
  IFC42.IfcRevolvedAreaSolid = IfcRevolvedAreaSolid;
  class IfcRevolvedAreaSolidTapered extends IfcRevolvedAreaSolid {
    constructor(SweptArea, Position, Axis, Angle, EndSweptArea) {
      super(SweptArea, Position, Axis, Angle);
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.Axis = Axis;
      this.Angle = Angle;
      this.EndSweptArea = EndSweptArea;
      this.type = 3243963512;
    }
  }
  IFC42.IfcRevolvedAreaSolidTapered = IfcRevolvedAreaSolidTapered;
  class IfcRightCircularCone extends IfcCsgPrimitive3D {
    constructor(Position, Height, BottomRadius) {
      super(Position);
      this.Position = Position;
      this.Height = Height;
      this.BottomRadius = BottomRadius;
      this.type = 4158566097;
    }
  }
  IFC42.IfcRightCircularCone = IfcRightCircularCone;
  class IfcRightCircularCylinder extends IfcCsgPrimitive3D {
    constructor(Position, Height, Radius) {
      super(Position);
      this.Position = Position;
      this.Height = Height;
      this.Radius = Radius;
      this.type = 3626867408;
    }
  }
  IFC42.IfcRightCircularCylinder = IfcRightCircularCylinder;
  class IfcSimplePropertyTemplate extends IfcPropertyTemplate {
    constructor(GlobalId, OwnerHistory, Name, Description, TemplateType, PrimaryMeasureType, SecondaryMeasureType, Enumerators, PrimaryUnit, SecondaryUnit, Expression, AccessState) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.TemplateType = TemplateType;
      this.PrimaryMeasureType = PrimaryMeasureType;
      this.SecondaryMeasureType = SecondaryMeasureType;
      this.Enumerators = Enumerators;
      this.PrimaryUnit = PrimaryUnit;
      this.SecondaryUnit = SecondaryUnit;
      this.Expression = Expression;
      this.AccessState = AccessState;
      this.type = 3663146110;
    }
  }
  IFC42.IfcSimplePropertyTemplate = IfcSimplePropertyTemplate;
  class IfcSpatialElement extends IfcProduct {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.type = 1412071761;
    }
  }
  IFC42.IfcSpatialElement = IfcSpatialElement;
  class IfcSpatialElementType extends IfcTypeProduct {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 710998568;
    }
  }
  IFC42.IfcSpatialElementType = IfcSpatialElementType;
  class IfcSpatialStructureElement extends IfcSpatialElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.type = 2706606064;
    }
  }
  IFC42.IfcSpatialStructureElement = IfcSpatialStructureElement;
  class IfcSpatialStructureElementType extends IfcSpatialElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3893378262;
    }
  }
  IFC42.IfcSpatialStructureElementType = IfcSpatialStructureElementType;
  class IfcSpatialZone extends IfcSpatialElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.PredefinedType = PredefinedType;
      this.type = 463610769;
    }
  }
  IFC42.IfcSpatialZone = IfcSpatialZone;
  class IfcSpatialZoneType extends IfcSpatialElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, LongName) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.LongName = LongName;
      this.type = 2481509218;
    }
  }
  IFC42.IfcSpatialZoneType = IfcSpatialZoneType;
  class IfcSphere extends IfcCsgPrimitive3D {
    constructor(Position, Radius) {
      super(Position);
      this.Position = Position;
      this.Radius = Radius;
      this.type = 451544542;
    }
  }
  IFC42.IfcSphere = IfcSphere;
  class IfcSphericalSurface extends IfcElementarySurface {
    constructor(Position, Radius) {
      super(Position);
      this.Position = Position;
      this.Radius = Radius;
      this.type = 4015995234;
    }
  }
  IFC42.IfcSphericalSurface = IfcSphericalSurface;
  class IfcStructuralActivity extends IfcProduct {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.type = 3544373492;
    }
  }
  IFC42.IfcStructuralActivity = IfcStructuralActivity;
  class IfcStructuralItem extends IfcProduct {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.type = 3136571912;
    }
  }
  IFC42.IfcStructuralItem = IfcStructuralItem;
  class IfcStructuralMember extends IfcStructuralItem {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.type = 530289379;
    }
  }
  IFC42.IfcStructuralMember = IfcStructuralMember;
  class IfcStructuralReaction extends IfcStructuralActivity {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.type = 3689010777;
    }
  }
  IFC42.IfcStructuralReaction = IfcStructuralReaction;
  class IfcStructuralSurfaceMember extends IfcStructuralMember {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Thickness) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.PredefinedType = PredefinedType;
      this.Thickness = Thickness;
      this.type = 3979015343;
    }
  }
  IFC42.IfcStructuralSurfaceMember = IfcStructuralSurfaceMember;
  class IfcStructuralSurfaceMemberVarying extends IfcStructuralSurfaceMember {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Thickness) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Thickness);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.PredefinedType = PredefinedType;
      this.Thickness = Thickness;
      this.type = 2218152070;
    }
  }
  IFC42.IfcStructuralSurfaceMemberVarying = IfcStructuralSurfaceMemberVarying;
  class IfcStructuralSurfaceReaction extends IfcStructuralReaction {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.PredefinedType = PredefinedType;
      this.type = 603775116;
    }
  }
  IFC42.IfcStructuralSurfaceReaction = IfcStructuralSurfaceReaction;
  class IfcSubContractResourceType extends IfcConstructionResourceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ResourceType = ResourceType;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 4095615324;
    }
  }
  IFC42.IfcSubContractResourceType = IfcSubContractResourceType;
  class IfcSurfaceCurve extends IfcCurve {
    constructor(Curve3D, AssociatedGeometry, MasterRepresentation) {
      super();
      this.Curve3D = Curve3D;
      this.AssociatedGeometry = AssociatedGeometry;
      this.MasterRepresentation = MasterRepresentation;
      this.type = 699246055;
    }
  }
  IFC42.IfcSurfaceCurve = IfcSurfaceCurve;
  class IfcSurfaceCurveSweptAreaSolid extends IfcSweptAreaSolid {
    constructor(SweptArea, Position, Directrix, StartParam, EndParam, ReferenceSurface) {
      super(SweptArea, Position);
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.Directrix = Directrix;
      this.StartParam = StartParam;
      this.EndParam = EndParam;
      this.ReferenceSurface = ReferenceSurface;
      this.type = 2028607225;
    }
  }
  IFC42.IfcSurfaceCurveSweptAreaSolid = IfcSurfaceCurveSweptAreaSolid;
  class IfcSurfaceOfLinearExtrusion extends IfcSweptSurface {
    constructor(SweptCurve, Position, ExtrudedDirection, Depth) {
      super(SweptCurve, Position);
      this.SweptCurve = SweptCurve;
      this.Position = Position;
      this.ExtrudedDirection = ExtrudedDirection;
      this.Depth = Depth;
      this.type = 2809605785;
    }
  }
  IFC42.IfcSurfaceOfLinearExtrusion = IfcSurfaceOfLinearExtrusion;
  class IfcSurfaceOfRevolution extends IfcSweptSurface {
    constructor(SweptCurve, Position, AxisPosition) {
      super(SweptCurve, Position);
      this.SweptCurve = SweptCurve;
      this.Position = Position;
      this.AxisPosition = AxisPosition;
      this.type = 4124788165;
    }
  }
  IFC42.IfcSurfaceOfRevolution = IfcSurfaceOfRevolution;
  class IfcSystemFurnitureElementType extends IfcFurnishingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1580310250;
    }
  }
  IFC42.IfcSystemFurnitureElementType = IfcSystemFurnitureElementType;
  class IfcTask extends IfcProcess {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Status, WorkMethod, IsMilestone, Priority, TaskTime, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.Status = Status;
      this.WorkMethod = WorkMethod;
      this.IsMilestone = IsMilestone;
      this.Priority = Priority;
      this.TaskTime = TaskTime;
      this.PredefinedType = PredefinedType;
      this.type = 3473067441;
    }
  }
  IFC42.IfcTask = IfcTask;
  class IfcTaskType extends IfcTypeProcess {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType, PredefinedType, WorkMethod) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ProcessType = ProcessType;
      this.PredefinedType = PredefinedType;
      this.WorkMethod = WorkMethod;
      this.type = 3206491090;
    }
  }
  IFC42.IfcTaskType = IfcTaskType;
  class IfcTessellatedFaceSet extends IfcTessellatedItem {
    constructor(Coordinates) {
      super();
      this.Coordinates = Coordinates;
      this.type = 2387106220;
    }
  }
  IFC42.IfcTessellatedFaceSet = IfcTessellatedFaceSet;
  class IfcToroidalSurface extends IfcElementarySurface {
    constructor(Position, MajorRadius, MinorRadius) {
      super(Position);
      this.Position = Position;
      this.MajorRadius = MajorRadius;
      this.MinorRadius = MinorRadius;
      this.type = 1935646853;
    }
  }
  IFC42.IfcToroidalSurface = IfcToroidalSurface;
  class IfcTransportElementType extends IfcElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2097647324;
    }
  }
  IFC42.IfcTransportElementType = IfcTransportElementType;
  class IfcTriangulatedFaceSet extends IfcTessellatedFaceSet {
    constructor(Coordinates, Normals, Closed, CoordIndex, PnIndex) {
      super(Coordinates);
      this.Coordinates = Coordinates;
      this.Normals = Normals;
      this.Closed = Closed;
      this.CoordIndex = CoordIndex;
      this.PnIndex = PnIndex;
      this.type = 2916149573;
    }
  }
  IFC42.IfcTriangulatedFaceSet = IfcTriangulatedFaceSet;
  class IfcWindowLiningProperties extends IfcPreDefinedPropertySet {
    constructor(GlobalId, OwnerHistory, Name, Description, LiningDepth, LiningThickness, TransomThickness, MullionThickness, FirstTransomOffset, SecondTransomOffset, FirstMullionOffset, SecondMullionOffset, ShapeAspectStyle, LiningOffset, LiningToPanelOffsetX, LiningToPanelOffsetY) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.LiningDepth = LiningDepth;
      this.LiningThickness = LiningThickness;
      this.TransomThickness = TransomThickness;
      this.MullionThickness = MullionThickness;
      this.FirstTransomOffset = FirstTransomOffset;
      this.SecondTransomOffset = SecondTransomOffset;
      this.FirstMullionOffset = FirstMullionOffset;
      this.SecondMullionOffset = SecondMullionOffset;
      this.ShapeAspectStyle = ShapeAspectStyle;
      this.LiningOffset = LiningOffset;
      this.LiningToPanelOffsetX = LiningToPanelOffsetX;
      this.LiningToPanelOffsetY = LiningToPanelOffsetY;
      this.type = 336235671;
    }
  }
  IFC42.IfcWindowLiningProperties = IfcWindowLiningProperties;
  class IfcWindowPanelProperties extends IfcPreDefinedPropertySet {
    constructor(GlobalId, OwnerHistory, Name, Description, OperationType, PanelPosition, FrameDepth, FrameThickness, ShapeAspectStyle) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.OperationType = OperationType;
      this.PanelPosition = PanelPosition;
      this.FrameDepth = FrameDepth;
      this.FrameThickness = FrameThickness;
      this.ShapeAspectStyle = ShapeAspectStyle;
      this.type = 512836454;
    }
  }
  IFC42.IfcWindowPanelProperties = IfcWindowPanelProperties;
  class IfcActor extends IfcObject {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, TheActor) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.TheActor = TheActor;
      this.type = 2296667514;
    }
  }
  IFC42.IfcActor = IfcActor;
  class IfcAdvancedBrep extends IfcManifoldSolidBrep {
    constructor(Outer) {
      super(Outer);
      this.Outer = Outer;
      this.type = 1635779807;
    }
  }
  IFC42.IfcAdvancedBrep = IfcAdvancedBrep;
  class IfcAdvancedBrepWithVoids extends IfcAdvancedBrep {
    constructor(Outer, Voids) {
      super(Outer);
      this.Outer = Outer;
      this.Voids = Voids;
      this.type = 2603310189;
    }
  }
  IFC42.IfcAdvancedBrepWithVoids = IfcAdvancedBrepWithVoids;
  class IfcAnnotation extends IfcProduct {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.type = 1674181508;
    }
  }
  IFC42.IfcAnnotation = IfcAnnotation;
  class IfcBSplineSurface extends IfcBoundedSurface {
    constructor(UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect) {
      super();
      this.UDegree = UDegree;
      this.VDegree = VDegree;
      this.ControlPointsList = ControlPointsList;
      this.SurfaceForm = SurfaceForm;
      this.UClosed = UClosed;
      this.VClosed = VClosed;
      this.SelfIntersect = SelfIntersect;
      this.type = 2887950389;
    }
  }
  IFC42.IfcBSplineSurface = IfcBSplineSurface;
  class IfcBSplineSurfaceWithKnots extends IfcBSplineSurface {
    constructor(UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect, UMultiplicities, VMultiplicities, UKnots, VKnots, KnotSpec) {
      super(UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect);
      this.UDegree = UDegree;
      this.VDegree = VDegree;
      this.ControlPointsList = ControlPointsList;
      this.SurfaceForm = SurfaceForm;
      this.UClosed = UClosed;
      this.VClosed = VClosed;
      this.SelfIntersect = SelfIntersect;
      this.UMultiplicities = UMultiplicities;
      this.VMultiplicities = VMultiplicities;
      this.UKnots = UKnots;
      this.VKnots = VKnots;
      this.KnotSpec = KnotSpec;
      this.type = 167062518;
    }
  }
  IFC42.IfcBSplineSurfaceWithKnots = IfcBSplineSurfaceWithKnots;
  class IfcBlock extends IfcCsgPrimitive3D {
    constructor(Position, XLength, YLength, ZLength) {
      super(Position);
      this.Position = Position;
      this.XLength = XLength;
      this.YLength = YLength;
      this.ZLength = ZLength;
      this.type = 1334484129;
    }
  }
  IFC42.IfcBlock = IfcBlock;
  class IfcBooleanClippingResult extends IfcBooleanResult {
    constructor(Operator, FirstOperand, SecondOperand) {
      super(Operator, FirstOperand, SecondOperand);
      this.Operator = Operator;
      this.FirstOperand = FirstOperand;
      this.SecondOperand = SecondOperand;
      this.type = 3649129432;
    }
  }
  IFC42.IfcBooleanClippingResult = IfcBooleanClippingResult;
  class IfcBoundedCurve extends IfcCurve {
    constructor() {
      super();
      this.type = 1260505505;
    }
  }
  IFC42.IfcBoundedCurve = IfcBoundedCurve;
  class IfcBuilding extends IfcSpatialStructureElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, ElevationOfRefHeight, ElevationOfTerrain, BuildingAddress) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.ElevationOfRefHeight = ElevationOfRefHeight;
      this.ElevationOfTerrain = ElevationOfTerrain;
      this.BuildingAddress = BuildingAddress;
      this.type = 4031249490;
    }
  }
  IFC42.IfcBuilding = IfcBuilding;
  class IfcBuildingElementType extends IfcElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 1950629157;
    }
  }
  IFC42.IfcBuildingElementType = IfcBuildingElementType;
  class IfcBuildingStorey extends IfcSpatialStructureElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, Elevation) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.Elevation = Elevation;
      this.type = 3124254112;
    }
  }
  IFC42.IfcBuildingStorey = IfcBuildingStorey;
  class IfcChimneyType extends IfcBuildingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2197970202;
    }
  }
  IFC42.IfcChimneyType = IfcChimneyType;
  class IfcCircleHollowProfileDef extends IfcCircleProfileDef {
    constructor(ProfileType, ProfileName, Position, Radius, WallThickness) {
      super(ProfileType, ProfileName, Position, Radius);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Radius = Radius;
      this.WallThickness = WallThickness;
      this.type = 2937912522;
    }
  }
  IFC42.IfcCircleHollowProfileDef = IfcCircleHollowProfileDef;
  class IfcCivilElementType extends IfcElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3893394355;
    }
  }
  IFC42.IfcCivilElementType = IfcCivilElementType;
  class IfcColumnType extends IfcBuildingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 300633059;
    }
  }
  IFC42.IfcColumnType = IfcColumnType;
  class IfcComplexPropertyTemplate extends IfcPropertyTemplate {
    constructor(GlobalId, OwnerHistory, Name, Description, UsageName, TemplateType, HasPropertyTemplates) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.UsageName = UsageName;
      this.TemplateType = TemplateType;
      this.HasPropertyTemplates = HasPropertyTemplates;
      this.type = 3875453745;
    }
  }
  IFC42.IfcComplexPropertyTemplate = IfcComplexPropertyTemplate;
  class IfcCompositeCurve extends IfcBoundedCurve {
    constructor(Segments, SelfIntersect) {
      super();
      this.Segments = Segments;
      this.SelfIntersect = SelfIntersect;
      this.type = 3732776249;
    }
  }
  IFC42.IfcCompositeCurve = IfcCompositeCurve;
  class IfcCompositeCurveOnSurface extends IfcCompositeCurve {
    constructor(Segments, SelfIntersect) {
      super(Segments, SelfIntersect);
      this.Segments = Segments;
      this.SelfIntersect = SelfIntersect;
      this.type = 15328376;
    }
  }
  IFC42.IfcCompositeCurveOnSurface = IfcCompositeCurveOnSurface;
  class IfcConic extends IfcCurve {
    constructor(Position) {
      super();
      this.Position = Position;
      this.type = 2510884976;
    }
  }
  IFC42.IfcConic = IfcConic;
  class IfcConstructionEquipmentResourceType extends IfcConstructionResourceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ResourceType = ResourceType;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 2185764099;
    }
  }
  IFC42.IfcConstructionEquipmentResourceType = IfcConstructionEquipmentResourceType;
  class IfcConstructionMaterialResourceType extends IfcConstructionResourceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ResourceType = ResourceType;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 4105962743;
    }
  }
  IFC42.IfcConstructionMaterialResourceType = IfcConstructionMaterialResourceType;
  class IfcConstructionProductResourceType extends IfcConstructionResourceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ResourceType = ResourceType;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 1525564444;
    }
  }
  IFC42.IfcConstructionProductResourceType = IfcConstructionProductResourceType;
  class IfcConstructionResource extends IfcResource {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.Usage = Usage;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.type = 2559216714;
    }
  }
  IFC42.IfcConstructionResource = IfcConstructionResource;
  class IfcControl extends IfcObject {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.type = 3293443760;
    }
  }
  IFC42.IfcControl = IfcControl;
  class IfcCostItem extends IfcControl {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, CostValues, CostQuantities) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.PredefinedType = PredefinedType;
      this.CostValues = CostValues;
      this.CostQuantities = CostQuantities;
      this.type = 3895139033;
    }
  }
  IFC42.IfcCostItem = IfcCostItem;
  class IfcCostSchedule extends IfcControl {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, Status, SubmittedOn, UpdateDate) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.PredefinedType = PredefinedType;
      this.Status = Status;
      this.SubmittedOn = SubmittedOn;
      this.UpdateDate = UpdateDate;
      this.type = 1419761937;
    }
  }
  IFC42.IfcCostSchedule = IfcCostSchedule;
  class IfcCoveringType extends IfcBuildingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1916426348;
    }
  }
  IFC42.IfcCoveringType = IfcCoveringType;
  class IfcCrewResource extends IfcConstructionResource {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.Usage = Usage;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 3295246426;
    }
  }
  IFC42.IfcCrewResource = IfcCrewResource;
  class IfcCurtainWallType extends IfcBuildingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1457835157;
    }
  }
  IFC42.IfcCurtainWallType = IfcCurtainWallType;
  class IfcCylindricalSurface extends IfcElementarySurface {
    constructor(Position, Radius) {
      super(Position);
      this.Position = Position;
      this.Radius = Radius;
      this.type = 1213902940;
    }
  }
  IFC42.IfcCylindricalSurface = IfcCylindricalSurface;
  class IfcDistributionElementType extends IfcElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3256556792;
    }
  }
  IFC42.IfcDistributionElementType = IfcDistributionElementType;
  class IfcDistributionFlowElementType extends IfcDistributionElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3849074793;
    }
  }
  IFC42.IfcDistributionFlowElementType = IfcDistributionFlowElementType;
  class IfcDoorLiningProperties extends IfcPreDefinedPropertySet {
    constructor(GlobalId, OwnerHistory, Name, Description, LiningDepth, LiningThickness, ThresholdDepth, ThresholdThickness, TransomThickness, TransomOffset, LiningOffset, ThresholdOffset, CasingThickness, CasingDepth, ShapeAspectStyle, LiningToPanelOffsetX, LiningToPanelOffsetY) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.LiningDepth = LiningDepth;
      this.LiningThickness = LiningThickness;
      this.ThresholdDepth = ThresholdDepth;
      this.ThresholdThickness = ThresholdThickness;
      this.TransomThickness = TransomThickness;
      this.TransomOffset = TransomOffset;
      this.LiningOffset = LiningOffset;
      this.ThresholdOffset = ThresholdOffset;
      this.CasingThickness = CasingThickness;
      this.CasingDepth = CasingDepth;
      this.ShapeAspectStyle = ShapeAspectStyle;
      this.LiningToPanelOffsetX = LiningToPanelOffsetX;
      this.LiningToPanelOffsetY = LiningToPanelOffsetY;
      this.type = 2963535650;
    }
  }
  IFC42.IfcDoorLiningProperties = IfcDoorLiningProperties;
  class IfcDoorPanelProperties extends IfcPreDefinedPropertySet {
    constructor(GlobalId, OwnerHistory, Name, Description, PanelDepth, PanelOperation, PanelWidth, PanelPosition, ShapeAspectStyle) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.PanelDepth = PanelDepth;
      this.PanelOperation = PanelOperation;
      this.PanelWidth = PanelWidth;
      this.PanelPosition = PanelPosition;
      this.ShapeAspectStyle = ShapeAspectStyle;
      this.type = 1714330368;
    }
  }
  IFC42.IfcDoorPanelProperties = IfcDoorPanelProperties;
  class IfcDoorType extends IfcBuildingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, OperationType, ParameterTakesPrecedence, UserDefinedOperationType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.OperationType = OperationType;
      this.ParameterTakesPrecedence = ParameterTakesPrecedence;
      this.UserDefinedOperationType = UserDefinedOperationType;
      this.type = 2323601079;
    }
  }
  IFC42.IfcDoorType = IfcDoorType;
  class IfcDraughtingPreDefinedColour extends IfcPreDefinedColour {
    constructor(Name) {
      super(Name);
      this.Name = Name;
      this.type = 445594917;
    }
  }
  IFC42.IfcDraughtingPreDefinedColour = IfcDraughtingPreDefinedColour;
  class IfcDraughtingPreDefinedCurveFont extends IfcPreDefinedCurveFont {
    constructor(Name) {
      super(Name);
      this.Name = Name;
      this.type = 4006246654;
    }
  }
  IFC42.IfcDraughtingPreDefinedCurveFont = IfcDraughtingPreDefinedCurveFont;
  class IfcElement extends IfcProduct {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1758889154;
    }
  }
  IFC42.IfcElement = IfcElement;
  class IfcElementAssembly extends IfcElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, AssemblyPlace, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.AssemblyPlace = AssemblyPlace;
      this.PredefinedType = PredefinedType;
      this.type = 4123344466;
    }
  }
  IFC42.IfcElementAssembly = IfcElementAssembly;
  class IfcElementAssemblyType extends IfcElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2397081782;
    }
  }
  IFC42.IfcElementAssemblyType = IfcElementAssemblyType;
  class IfcElementComponent extends IfcElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1623761950;
    }
  }
  IFC42.IfcElementComponent = IfcElementComponent;
  class IfcElementComponentType extends IfcElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 2590856083;
    }
  }
  IFC42.IfcElementComponentType = IfcElementComponentType;
  class IfcEllipse extends IfcConic {
    constructor(Position, SemiAxis1, SemiAxis2) {
      super(Position);
      this.Position = Position;
      this.SemiAxis1 = SemiAxis1;
      this.SemiAxis2 = SemiAxis2;
      this.type = 1704287377;
    }
  }
  IFC42.IfcEllipse = IfcEllipse;
  class IfcEnergyConversionDeviceType extends IfcDistributionFlowElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 2107101300;
    }
  }
  IFC42.IfcEnergyConversionDeviceType = IfcEnergyConversionDeviceType;
  class IfcEngineType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 132023988;
    }
  }
  IFC42.IfcEngineType = IfcEngineType;
  class IfcEvaporativeCoolerType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3174744832;
    }
  }
  IFC42.IfcEvaporativeCoolerType = IfcEvaporativeCoolerType;
  class IfcEvaporatorType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3390157468;
    }
  }
  IFC42.IfcEvaporatorType = IfcEvaporatorType;
  class IfcEvent extends IfcProcess {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, PredefinedType, EventTriggerType, UserDefinedEventTriggerType, EventOccurenceTime) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.PredefinedType = PredefinedType;
      this.EventTriggerType = EventTriggerType;
      this.UserDefinedEventTriggerType = UserDefinedEventTriggerType;
      this.EventOccurenceTime = EventOccurenceTime;
      this.type = 4148101412;
    }
  }
  IFC42.IfcEvent = IfcEvent;
  class IfcExternalSpatialStructureElement extends IfcSpatialElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.type = 2853485674;
    }
  }
  IFC42.IfcExternalSpatialStructureElement = IfcExternalSpatialStructureElement;
  class IfcFacetedBrep extends IfcManifoldSolidBrep {
    constructor(Outer) {
      super(Outer);
      this.Outer = Outer;
      this.type = 807026263;
    }
  }
  IFC42.IfcFacetedBrep = IfcFacetedBrep;
  class IfcFacetedBrepWithVoids extends IfcFacetedBrep {
    constructor(Outer, Voids) {
      super(Outer);
      this.Outer = Outer;
      this.Voids = Voids;
      this.type = 3737207727;
    }
  }
  IFC42.IfcFacetedBrepWithVoids = IfcFacetedBrepWithVoids;
  class IfcFastener extends IfcElementComponent {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 647756555;
    }
  }
  IFC42.IfcFastener = IfcFastener;
  class IfcFastenerType extends IfcElementComponentType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2489546625;
    }
  }
  IFC42.IfcFastenerType = IfcFastenerType;
  class IfcFeatureElement extends IfcElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 2827207264;
    }
  }
  IFC42.IfcFeatureElement = IfcFeatureElement;
  class IfcFeatureElementAddition extends IfcFeatureElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 2143335405;
    }
  }
  IFC42.IfcFeatureElementAddition = IfcFeatureElementAddition;
  class IfcFeatureElementSubtraction extends IfcFeatureElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1287392070;
    }
  }
  IFC42.IfcFeatureElementSubtraction = IfcFeatureElementSubtraction;
  class IfcFlowControllerType extends IfcDistributionFlowElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3907093117;
    }
  }
  IFC42.IfcFlowControllerType = IfcFlowControllerType;
  class IfcFlowFittingType extends IfcDistributionFlowElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3198132628;
    }
  }
  IFC42.IfcFlowFittingType = IfcFlowFittingType;
  class IfcFlowMeterType extends IfcFlowControllerType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3815607619;
    }
  }
  IFC42.IfcFlowMeterType = IfcFlowMeterType;
  class IfcFlowMovingDeviceType extends IfcDistributionFlowElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 1482959167;
    }
  }
  IFC42.IfcFlowMovingDeviceType = IfcFlowMovingDeviceType;
  class IfcFlowSegmentType extends IfcDistributionFlowElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 1834744321;
    }
  }
  IFC42.IfcFlowSegmentType = IfcFlowSegmentType;
  class IfcFlowStorageDeviceType extends IfcDistributionFlowElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 1339347760;
    }
  }
  IFC42.IfcFlowStorageDeviceType = IfcFlowStorageDeviceType;
  class IfcFlowTerminalType extends IfcDistributionFlowElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 2297155007;
    }
  }
  IFC42.IfcFlowTerminalType = IfcFlowTerminalType;
  class IfcFlowTreatmentDeviceType extends IfcDistributionFlowElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3009222698;
    }
  }
  IFC42.IfcFlowTreatmentDeviceType = IfcFlowTreatmentDeviceType;
  class IfcFootingType extends IfcBuildingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1893162501;
    }
  }
  IFC42.IfcFootingType = IfcFootingType;
  class IfcFurnishingElement extends IfcElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 263784265;
    }
  }
  IFC42.IfcFurnishingElement = IfcFurnishingElement;
  class IfcFurniture extends IfcFurnishingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1509553395;
    }
  }
  IFC42.IfcFurniture = IfcFurniture;
  class IfcGeographicElement extends IfcElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3493046030;
    }
  }
  IFC42.IfcGeographicElement = IfcGeographicElement;
  class IfcGrid extends IfcProduct {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, UAxes, VAxes, WAxes, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.UAxes = UAxes;
      this.VAxes = VAxes;
      this.WAxes = WAxes;
      this.PredefinedType = PredefinedType;
      this.type = 3009204131;
    }
  }
  IFC42.IfcGrid = IfcGrid;
  class IfcGroup extends IfcObject {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.type = 2706460486;
    }
  }
  IFC42.IfcGroup = IfcGroup;
  class IfcHeatExchangerType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1251058090;
    }
  }
  IFC42.IfcHeatExchangerType = IfcHeatExchangerType;
  class IfcHumidifierType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1806887404;
    }
  }
  IFC42.IfcHumidifierType = IfcHumidifierType;
  class IfcIndexedPolyCurve extends IfcBoundedCurve {
    constructor(Points, Segments, SelfIntersect) {
      super();
      this.Points = Points;
      this.Segments = Segments;
      this.SelfIntersect = SelfIntersect;
      this.type = 2571569899;
    }
  }
  IFC42.IfcIndexedPolyCurve = IfcIndexedPolyCurve;
  class IfcInterceptorType extends IfcFlowTreatmentDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3946677679;
    }
  }
  IFC42.IfcInterceptorType = IfcInterceptorType;
  class IfcIntersectionCurve extends IfcSurfaceCurve {
    constructor(Curve3D, AssociatedGeometry, MasterRepresentation) {
      super(Curve3D, AssociatedGeometry, MasterRepresentation);
      this.Curve3D = Curve3D;
      this.AssociatedGeometry = AssociatedGeometry;
      this.MasterRepresentation = MasterRepresentation;
      this.type = 3113134337;
    }
  }
  IFC42.IfcIntersectionCurve = IfcIntersectionCurve;
  class IfcInventory extends IfcGroup {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, Jurisdiction, ResponsiblePersons, LastUpdateDate, CurrentValue, OriginalValue) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.PredefinedType = PredefinedType;
      this.Jurisdiction = Jurisdiction;
      this.ResponsiblePersons = ResponsiblePersons;
      this.LastUpdateDate = LastUpdateDate;
      this.CurrentValue = CurrentValue;
      this.OriginalValue = OriginalValue;
      this.type = 2391368822;
    }
  }
  IFC42.IfcInventory = IfcInventory;
  class IfcJunctionBoxType extends IfcFlowFittingType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4288270099;
    }
  }
  IFC42.IfcJunctionBoxType = IfcJunctionBoxType;
  class IfcLaborResource extends IfcConstructionResource {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.Usage = Usage;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 3827777499;
    }
  }
  IFC42.IfcLaborResource = IfcLaborResource;
  class IfcLampType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1051575348;
    }
  }
  IFC42.IfcLampType = IfcLampType;
  class IfcLightFixtureType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1161773419;
    }
  }
  IFC42.IfcLightFixtureType = IfcLightFixtureType;
  class IfcMechanicalFastener extends IfcElementComponent {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, NominalDiameter, NominalLength, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.NominalDiameter = NominalDiameter;
      this.NominalLength = NominalLength;
      this.PredefinedType = PredefinedType;
      this.type = 377706215;
    }
  }
  IFC42.IfcMechanicalFastener = IfcMechanicalFastener;
  class IfcMechanicalFastenerType extends IfcElementComponentType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, NominalDiameter, NominalLength) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.NominalDiameter = NominalDiameter;
      this.NominalLength = NominalLength;
      this.type = 2108223431;
    }
  }
  IFC42.IfcMechanicalFastenerType = IfcMechanicalFastenerType;
  class IfcMedicalDeviceType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1114901282;
    }
  }
  IFC42.IfcMedicalDeviceType = IfcMedicalDeviceType;
  class IfcMemberType extends IfcBuildingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3181161470;
    }
  }
  IFC42.IfcMemberType = IfcMemberType;
  class IfcMotorConnectionType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 977012517;
    }
  }
  IFC42.IfcMotorConnectionType = IfcMotorConnectionType;
  class IfcOccupant extends IfcActor {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, TheActor, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, TheActor);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.TheActor = TheActor;
      this.PredefinedType = PredefinedType;
      this.type = 4143007308;
    }
  }
  IFC42.IfcOccupant = IfcOccupant;
  class IfcOpeningElement extends IfcFeatureElementSubtraction {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3588315303;
    }
  }
  IFC42.IfcOpeningElement = IfcOpeningElement;
  class IfcOpeningStandardCase extends IfcOpeningElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3079942009;
    }
  }
  IFC42.IfcOpeningStandardCase = IfcOpeningStandardCase;
  class IfcOutletType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2837617999;
    }
  }
  IFC42.IfcOutletType = IfcOutletType;
  class IfcPerformanceHistory extends IfcControl {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LifeCyclePhase, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LifeCyclePhase = LifeCyclePhase;
      this.PredefinedType = PredefinedType;
      this.type = 2382730787;
    }
  }
  IFC42.IfcPerformanceHistory = IfcPerformanceHistory;
  class IfcPermeableCoveringProperties extends IfcPreDefinedPropertySet {
    constructor(GlobalId, OwnerHistory, Name, Description, OperationType, PanelPosition, FrameDepth, FrameThickness, ShapeAspectStyle) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.OperationType = OperationType;
      this.PanelPosition = PanelPosition;
      this.FrameDepth = FrameDepth;
      this.FrameThickness = FrameThickness;
      this.ShapeAspectStyle = ShapeAspectStyle;
      this.type = 3566463478;
    }
  }
  IFC42.IfcPermeableCoveringProperties = IfcPermeableCoveringProperties;
  class IfcPermit extends IfcControl {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, Status, LongDescription) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.PredefinedType = PredefinedType;
      this.Status = Status;
      this.LongDescription = LongDescription;
      this.type = 3327091369;
    }
  }
  IFC42.IfcPermit = IfcPermit;
  class IfcPileType extends IfcBuildingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1158309216;
    }
  }
  IFC42.IfcPileType = IfcPileType;
  class IfcPipeFittingType extends IfcFlowFittingType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 804291784;
    }
  }
  IFC42.IfcPipeFittingType = IfcPipeFittingType;
  class IfcPipeSegmentType extends IfcFlowSegmentType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4231323485;
    }
  }
  IFC42.IfcPipeSegmentType = IfcPipeSegmentType;
  class IfcPlateType extends IfcBuildingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4017108033;
    }
  }
  IFC42.IfcPlateType = IfcPlateType;
  class IfcPolygonalFaceSet extends IfcTessellatedFaceSet {
    constructor(Coordinates, Closed, Faces, PnIndex) {
      super(Coordinates);
      this.Coordinates = Coordinates;
      this.Closed = Closed;
      this.Faces = Faces;
      this.PnIndex = PnIndex;
      this.type = 2839578677;
    }
  }
  IFC42.IfcPolygonalFaceSet = IfcPolygonalFaceSet;
  class IfcPolyline extends IfcBoundedCurve {
    constructor(Points) {
      super();
      this.Points = Points;
      this.type = 3724593414;
    }
  }
  IFC42.IfcPolyline = IfcPolyline;
  class IfcPort extends IfcProduct {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.type = 3740093272;
    }
  }
  IFC42.IfcPort = IfcPort;
  class IfcProcedure extends IfcProcess {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.PredefinedType = PredefinedType;
      this.type = 2744685151;
    }
  }
  IFC42.IfcProcedure = IfcProcedure;
  class IfcProjectOrder extends IfcControl {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, Status, LongDescription) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.PredefinedType = PredefinedType;
      this.Status = Status;
      this.LongDescription = LongDescription;
      this.type = 2904328755;
    }
  }
  IFC42.IfcProjectOrder = IfcProjectOrder;
  class IfcProjectionElement extends IfcFeatureElementAddition {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3651124850;
    }
  }
  IFC42.IfcProjectionElement = IfcProjectionElement;
  class IfcProtectiveDeviceType extends IfcFlowControllerType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1842657554;
    }
  }
  IFC42.IfcProtectiveDeviceType = IfcProtectiveDeviceType;
  class IfcPumpType extends IfcFlowMovingDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2250791053;
    }
  }
  IFC42.IfcPumpType = IfcPumpType;
  class IfcRailingType extends IfcBuildingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2893384427;
    }
  }
  IFC42.IfcRailingType = IfcRailingType;
  class IfcRampFlightType extends IfcBuildingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2324767716;
    }
  }
  IFC42.IfcRampFlightType = IfcRampFlightType;
  class IfcRampType extends IfcBuildingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1469900589;
    }
  }
  IFC42.IfcRampType = IfcRampType;
  class IfcRationalBSplineSurfaceWithKnots extends IfcBSplineSurfaceWithKnots {
    constructor(UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect, UMultiplicities, VMultiplicities, UKnots, VKnots, KnotSpec, WeightsData) {
      super(UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect, UMultiplicities, VMultiplicities, UKnots, VKnots, KnotSpec);
      this.UDegree = UDegree;
      this.VDegree = VDegree;
      this.ControlPointsList = ControlPointsList;
      this.SurfaceForm = SurfaceForm;
      this.UClosed = UClosed;
      this.VClosed = VClosed;
      this.SelfIntersect = SelfIntersect;
      this.UMultiplicities = UMultiplicities;
      this.VMultiplicities = VMultiplicities;
      this.UKnots = UKnots;
      this.VKnots = VKnots;
      this.KnotSpec = KnotSpec;
      this.WeightsData = WeightsData;
      this.type = 683857671;
    }
  }
  IFC42.IfcRationalBSplineSurfaceWithKnots = IfcRationalBSplineSurfaceWithKnots;
  class IfcReinforcingElement extends IfcElementComponent {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.SteelGrade = SteelGrade;
      this.type = 3027567501;
    }
  }
  IFC42.IfcReinforcingElement = IfcReinforcingElement;
  class IfcReinforcingElementType extends IfcElementComponentType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 964333572;
    }
  }
  IFC42.IfcReinforcingElementType = IfcReinforcingElementType;
  class IfcReinforcingMesh extends IfcReinforcingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, MeshLength, MeshWidth, LongitudinalBarNominalDiameter, TransverseBarNominalDiameter, LongitudinalBarCrossSectionArea, TransverseBarCrossSectionArea, LongitudinalBarSpacing, TransverseBarSpacing, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.SteelGrade = SteelGrade;
      this.MeshLength = MeshLength;
      this.MeshWidth = MeshWidth;
      this.LongitudinalBarNominalDiameter = LongitudinalBarNominalDiameter;
      this.TransverseBarNominalDiameter = TransverseBarNominalDiameter;
      this.LongitudinalBarCrossSectionArea = LongitudinalBarCrossSectionArea;
      this.TransverseBarCrossSectionArea = TransverseBarCrossSectionArea;
      this.LongitudinalBarSpacing = LongitudinalBarSpacing;
      this.TransverseBarSpacing = TransverseBarSpacing;
      this.PredefinedType = PredefinedType;
      this.type = 2320036040;
    }
  }
  IFC42.IfcReinforcingMesh = IfcReinforcingMesh;
  class IfcReinforcingMeshType extends IfcReinforcingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, MeshLength, MeshWidth, LongitudinalBarNominalDiameter, TransverseBarNominalDiameter, LongitudinalBarCrossSectionArea, TransverseBarCrossSectionArea, LongitudinalBarSpacing, TransverseBarSpacing, BendingShapeCode, BendingParameters) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.MeshLength = MeshLength;
      this.MeshWidth = MeshWidth;
      this.LongitudinalBarNominalDiameter = LongitudinalBarNominalDiameter;
      this.TransverseBarNominalDiameter = TransverseBarNominalDiameter;
      this.LongitudinalBarCrossSectionArea = LongitudinalBarCrossSectionArea;
      this.TransverseBarCrossSectionArea = TransverseBarCrossSectionArea;
      this.LongitudinalBarSpacing = LongitudinalBarSpacing;
      this.TransverseBarSpacing = TransverseBarSpacing;
      this.BendingShapeCode = BendingShapeCode;
      this.BendingParameters = BendingParameters;
      this.type = 2310774935;
    }
  }
  IFC42.IfcReinforcingMeshType = IfcReinforcingMeshType;
  class IfcRelAggregates extends IfcRelDecomposes {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingObject, RelatedObjects) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingObject = RelatingObject;
      this.RelatedObjects = RelatedObjects;
      this.type = 160246688;
    }
  }
  IFC42.IfcRelAggregates = IfcRelAggregates;
  class IfcRoofType extends IfcBuildingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2781568857;
    }
  }
  IFC42.IfcRoofType = IfcRoofType;
  class IfcSanitaryTerminalType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1768891740;
    }
  }
  IFC42.IfcSanitaryTerminalType = IfcSanitaryTerminalType;
  class IfcSeamCurve extends IfcSurfaceCurve {
    constructor(Curve3D, AssociatedGeometry, MasterRepresentation) {
      super(Curve3D, AssociatedGeometry, MasterRepresentation);
      this.Curve3D = Curve3D;
      this.AssociatedGeometry = AssociatedGeometry;
      this.MasterRepresentation = MasterRepresentation;
      this.type = 2157484638;
    }
  }
  IFC42.IfcSeamCurve = IfcSeamCurve;
  class IfcShadingDeviceType extends IfcBuildingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4074543187;
    }
  }
  IFC42.IfcShadingDeviceType = IfcShadingDeviceType;
  class IfcSite extends IfcSpatialStructureElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, RefLatitude, RefLongitude, RefElevation, LandTitleNumber, SiteAddress) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.RefLatitude = RefLatitude;
      this.RefLongitude = RefLongitude;
      this.RefElevation = RefElevation;
      this.LandTitleNumber = LandTitleNumber;
      this.SiteAddress = SiteAddress;
      this.type = 4097777520;
    }
  }
  IFC42.IfcSite = IfcSite;
  class IfcSlabType extends IfcBuildingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2533589738;
    }
  }
  IFC42.IfcSlabType = IfcSlabType;
  class IfcSolarDeviceType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1072016465;
    }
  }
  IFC42.IfcSolarDeviceType = IfcSolarDeviceType;
  class IfcSpace extends IfcSpatialStructureElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, PredefinedType, ElevationWithFlooring) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.PredefinedType = PredefinedType;
      this.ElevationWithFlooring = ElevationWithFlooring;
      this.type = 3856911033;
    }
  }
  IFC42.IfcSpace = IfcSpace;
  class IfcSpaceHeaterType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1305183839;
    }
  }
  IFC42.IfcSpaceHeaterType = IfcSpaceHeaterType;
  class IfcSpaceType extends IfcSpatialStructureElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, LongName) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.LongName = LongName;
      this.type = 3812236995;
    }
  }
  IFC42.IfcSpaceType = IfcSpaceType;
  class IfcStackTerminalType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3112655638;
    }
  }
  IFC42.IfcStackTerminalType = IfcStackTerminalType;
  class IfcStairFlightType extends IfcBuildingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1039846685;
    }
  }
  IFC42.IfcStairFlightType = IfcStairFlightType;
  class IfcStairType extends IfcBuildingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 338393293;
    }
  }
  IFC42.IfcStairType = IfcStairType;
  class IfcStructuralAction extends IfcStructuralActivity {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.DestabilizingLoad = DestabilizingLoad;
      this.type = 682877961;
    }
  }
  IFC42.IfcStructuralAction = IfcStructuralAction;
  class IfcStructuralConnection extends IfcStructuralItem {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedCondition = AppliedCondition;
      this.type = 1179482911;
    }
  }
  IFC42.IfcStructuralConnection = IfcStructuralConnection;
  class IfcStructuralCurveAction extends IfcStructuralAction {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.DestabilizingLoad = DestabilizingLoad;
      this.ProjectedOrTrue = ProjectedOrTrue;
      this.PredefinedType = PredefinedType;
      this.type = 1004757350;
    }
  }
  IFC42.IfcStructuralCurveAction = IfcStructuralCurveAction;
  class IfcStructuralCurveConnection extends IfcStructuralConnection {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition, Axis) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedCondition = AppliedCondition;
      this.Axis = Axis;
      this.type = 4243806635;
    }
  }
  IFC42.IfcStructuralCurveConnection = IfcStructuralCurveConnection;
  class IfcStructuralCurveMember extends IfcStructuralMember {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Axis) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.PredefinedType = PredefinedType;
      this.Axis = Axis;
      this.type = 214636428;
    }
  }
  IFC42.IfcStructuralCurveMember = IfcStructuralCurveMember;
  class IfcStructuralCurveMemberVarying extends IfcStructuralCurveMember {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Axis) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Axis);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.PredefinedType = PredefinedType;
      this.Axis = Axis;
      this.type = 2445595289;
    }
  }
  IFC42.IfcStructuralCurveMemberVarying = IfcStructuralCurveMemberVarying;
  class IfcStructuralCurveReaction extends IfcStructuralReaction {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.PredefinedType = PredefinedType;
      this.type = 2757150158;
    }
  }
  IFC42.IfcStructuralCurveReaction = IfcStructuralCurveReaction;
  class IfcStructuralLinearAction extends IfcStructuralCurveAction {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.DestabilizingLoad = DestabilizingLoad;
      this.ProjectedOrTrue = ProjectedOrTrue;
      this.PredefinedType = PredefinedType;
      this.type = 1807405624;
    }
  }
  IFC42.IfcStructuralLinearAction = IfcStructuralLinearAction;
  class IfcStructuralLoadGroup extends IfcGroup {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, ActionType, ActionSource, Coefficient, Purpose) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.PredefinedType = PredefinedType;
      this.ActionType = ActionType;
      this.ActionSource = ActionSource;
      this.Coefficient = Coefficient;
      this.Purpose = Purpose;
      this.type = 1252848954;
    }
  }
  IFC42.IfcStructuralLoadGroup = IfcStructuralLoadGroup;
  class IfcStructuralPointAction extends IfcStructuralAction {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.DestabilizingLoad = DestabilizingLoad;
      this.type = 2082059205;
    }
  }
  IFC42.IfcStructuralPointAction = IfcStructuralPointAction;
  class IfcStructuralPointConnection extends IfcStructuralConnection {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition, ConditionCoordinateSystem) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedCondition = AppliedCondition;
      this.ConditionCoordinateSystem = ConditionCoordinateSystem;
      this.type = 734778138;
    }
  }
  IFC42.IfcStructuralPointConnection = IfcStructuralPointConnection;
  class IfcStructuralPointReaction extends IfcStructuralReaction {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.type = 1235345126;
    }
  }
  IFC42.IfcStructuralPointReaction = IfcStructuralPointReaction;
  class IfcStructuralResultGroup extends IfcGroup {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, TheoryType, ResultForLoadGroup, IsLinear) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.TheoryType = TheoryType;
      this.ResultForLoadGroup = ResultForLoadGroup;
      this.IsLinear = IsLinear;
      this.type = 2986769608;
    }
  }
  IFC42.IfcStructuralResultGroup = IfcStructuralResultGroup;
  class IfcStructuralSurfaceAction extends IfcStructuralAction {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.DestabilizingLoad = DestabilizingLoad;
      this.ProjectedOrTrue = ProjectedOrTrue;
      this.PredefinedType = PredefinedType;
      this.type = 3657597509;
    }
  }
  IFC42.IfcStructuralSurfaceAction = IfcStructuralSurfaceAction;
  class IfcStructuralSurfaceConnection extends IfcStructuralConnection {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedCondition = AppliedCondition;
      this.type = 1975003073;
    }
  }
  IFC42.IfcStructuralSurfaceConnection = IfcStructuralSurfaceConnection;
  class IfcSubContractResource extends IfcConstructionResource {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.Usage = Usage;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 148013059;
    }
  }
  IFC42.IfcSubContractResource = IfcSubContractResource;
  class IfcSurfaceFeature extends IfcFeatureElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3101698114;
    }
  }
  IFC42.IfcSurfaceFeature = IfcSurfaceFeature;
  class IfcSwitchingDeviceType extends IfcFlowControllerType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2315554128;
    }
  }
  IFC42.IfcSwitchingDeviceType = IfcSwitchingDeviceType;
  class IfcSystem extends IfcGroup {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.type = 2254336722;
    }
  }
  IFC42.IfcSystem = IfcSystem;
  class IfcSystemFurnitureElement extends IfcFurnishingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 413509423;
    }
  }
  IFC42.IfcSystemFurnitureElement = IfcSystemFurnitureElement;
  class IfcTankType extends IfcFlowStorageDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 5716631;
    }
  }
  IFC42.IfcTankType = IfcTankType;
  class IfcTendon extends IfcReinforcingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, PredefinedType, NominalDiameter, CrossSectionArea, TensionForce, PreStress, FrictionCoefficient, AnchorageSlip, MinCurvatureRadius) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.SteelGrade = SteelGrade;
      this.PredefinedType = PredefinedType;
      this.NominalDiameter = NominalDiameter;
      this.CrossSectionArea = CrossSectionArea;
      this.TensionForce = TensionForce;
      this.PreStress = PreStress;
      this.FrictionCoefficient = FrictionCoefficient;
      this.AnchorageSlip = AnchorageSlip;
      this.MinCurvatureRadius = MinCurvatureRadius;
      this.type = 3824725483;
    }
  }
  IFC42.IfcTendon = IfcTendon;
  class IfcTendonAnchor extends IfcReinforcingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.SteelGrade = SteelGrade;
      this.PredefinedType = PredefinedType;
      this.type = 2347447852;
    }
  }
  IFC42.IfcTendonAnchor = IfcTendonAnchor;
  class IfcTendonAnchorType extends IfcReinforcingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3081323446;
    }
  }
  IFC42.IfcTendonAnchorType = IfcTendonAnchorType;
  class IfcTendonType extends IfcReinforcingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, NominalDiameter, CrossSectionArea, SheathDiameter) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.NominalDiameter = NominalDiameter;
      this.CrossSectionArea = CrossSectionArea;
      this.SheathDiameter = SheathDiameter;
      this.type = 2415094496;
    }
  }
  IFC42.IfcTendonType = IfcTendonType;
  class IfcTransformerType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1692211062;
    }
  }
  IFC42.IfcTransformerType = IfcTransformerType;
  class IfcTransportElement extends IfcElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1620046519;
    }
  }
  IFC42.IfcTransportElement = IfcTransportElement;
  class IfcTrimmedCurve extends IfcBoundedCurve {
    constructor(BasisCurve, Trim1, Trim2, SenseAgreement, MasterRepresentation) {
      super();
      this.BasisCurve = BasisCurve;
      this.Trim1 = Trim1;
      this.Trim2 = Trim2;
      this.SenseAgreement = SenseAgreement;
      this.MasterRepresentation = MasterRepresentation;
      this.type = 3593883385;
    }
  }
  IFC42.IfcTrimmedCurve = IfcTrimmedCurve;
  class IfcTubeBundleType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1600972822;
    }
  }
  IFC42.IfcTubeBundleType = IfcTubeBundleType;
  class IfcUnitaryEquipmentType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1911125066;
    }
  }
  IFC42.IfcUnitaryEquipmentType = IfcUnitaryEquipmentType;
  class IfcValveType extends IfcFlowControllerType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 728799441;
    }
  }
  IFC42.IfcValveType = IfcValveType;
  class IfcVibrationIsolator extends IfcElementComponent {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2391383451;
    }
  }
  IFC42.IfcVibrationIsolator = IfcVibrationIsolator;
  class IfcVibrationIsolatorType extends IfcElementComponentType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3313531582;
    }
  }
  IFC42.IfcVibrationIsolatorType = IfcVibrationIsolatorType;
  class IfcVirtualElement extends IfcElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 2769231204;
    }
  }
  IFC42.IfcVirtualElement = IfcVirtualElement;
  class IfcVoidingFeature extends IfcFeatureElementSubtraction {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 926996030;
    }
  }
  IFC42.IfcVoidingFeature = IfcVoidingFeature;
  class IfcWallType extends IfcBuildingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1898987631;
    }
  }
  IFC42.IfcWallType = IfcWallType;
  class IfcWasteTerminalType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1133259667;
    }
  }
  IFC42.IfcWasteTerminalType = IfcWasteTerminalType;
  class IfcWindowType extends IfcBuildingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, PartitioningType, ParameterTakesPrecedence, UserDefinedPartitioningType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.PartitioningType = PartitioningType;
      this.ParameterTakesPrecedence = ParameterTakesPrecedence;
      this.UserDefinedPartitioningType = UserDefinedPartitioningType;
      this.type = 4009809668;
    }
  }
  IFC42.IfcWindowType = IfcWindowType;
  class IfcWorkCalendar extends IfcControl {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, WorkingTimes, ExceptionTimes, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.WorkingTimes = WorkingTimes;
      this.ExceptionTimes = ExceptionTimes;
      this.PredefinedType = PredefinedType;
      this.type = 4088093105;
    }
  }
  IFC42.IfcWorkCalendar = IfcWorkCalendar;
  class IfcWorkControl extends IfcControl {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.CreationDate = CreationDate;
      this.Creators = Creators;
      this.Purpose = Purpose;
      this.Duration = Duration;
      this.TotalFloat = TotalFloat;
      this.StartTime = StartTime;
      this.FinishTime = FinishTime;
      this.type = 1028945134;
    }
  }
  IFC42.IfcWorkControl = IfcWorkControl;
  class IfcWorkPlan extends IfcWorkControl {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.CreationDate = CreationDate;
      this.Creators = Creators;
      this.Purpose = Purpose;
      this.Duration = Duration;
      this.TotalFloat = TotalFloat;
      this.StartTime = StartTime;
      this.FinishTime = FinishTime;
      this.PredefinedType = PredefinedType;
      this.type = 4218914973;
    }
  }
  IFC42.IfcWorkPlan = IfcWorkPlan;
  class IfcWorkSchedule extends IfcWorkControl {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.CreationDate = CreationDate;
      this.Creators = Creators;
      this.Purpose = Purpose;
      this.Duration = Duration;
      this.TotalFloat = TotalFloat;
      this.StartTime = StartTime;
      this.FinishTime = FinishTime;
      this.PredefinedType = PredefinedType;
      this.type = 3342526732;
    }
  }
  IFC42.IfcWorkSchedule = IfcWorkSchedule;
  class IfcZone extends IfcSystem {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, LongName) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.LongName = LongName;
      this.type = 1033361043;
    }
  }
  IFC42.IfcZone = IfcZone;
  class IfcActionRequest extends IfcControl {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, Status, LongDescription) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.PredefinedType = PredefinedType;
      this.Status = Status;
      this.LongDescription = LongDescription;
      this.type = 3821786052;
    }
  }
  IFC42.IfcActionRequest = IfcActionRequest;
  class IfcAirTerminalBoxType extends IfcFlowControllerType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1411407467;
    }
  }
  IFC42.IfcAirTerminalBoxType = IfcAirTerminalBoxType;
  class IfcAirTerminalType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3352864051;
    }
  }
  IFC42.IfcAirTerminalType = IfcAirTerminalType;
  class IfcAirToAirHeatRecoveryType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1871374353;
    }
  }
  IFC42.IfcAirToAirHeatRecoveryType = IfcAirToAirHeatRecoveryType;
  class IfcAsset extends IfcGroup {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, OriginalValue, CurrentValue, TotalReplacementCost, Owner, User, ResponsiblePerson, IncorporationDate, DepreciatedValue) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.OriginalValue = OriginalValue;
      this.CurrentValue = CurrentValue;
      this.TotalReplacementCost = TotalReplacementCost;
      this.Owner = Owner;
      this.User = User;
      this.ResponsiblePerson = ResponsiblePerson;
      this.IncorporationDate = IncorporationDate;
      this.DepreciatedValue = DepreciatedValue;
      this.type = 3460190687;
    }
  }
  IFC42.IfcAsset = IfcAsset;
  class IfcAudioVisualApplianceType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1532957894;
    }
  }
  IFC42.IfcAudioVisualApplianceType = IfcAudioVisualApplianceType;
  class IfcBSplineCurve extends IfcBoundedCurve {
    constructor(Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect) {
      super();
      this.Degree = Degree;
      this.ControlPointsList = ControlPointsList;
      this.CurveForm = CurveForm;
      this.ClosedCurve = ClosedCurve;
      this.SelfIntersect = SelfIntersect;
      this.type = 1967976161;
    }
  }
  IFC42.IfcBSplineCurve = IfcBSplineCurve;
  class IfcBSplineCurveWithKnots extends IfcBSplineCurve {
    constructor(Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect, KnotMultiplicities, Knots, KnotSpec) {
      super(Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect);
      this.Degree = Degree;
      this.ControlPointsList = ControlPointsList;
      this.CurveForm = CurveForm;
      this.ClosedCurve = ClosedCurve;
      this.SelfIntersect = SelfIntersect;
      this.KnotMultiplicities = KnotMultiplicities;
      this.Knots = Knots;
      this.KnotSpec = KnotSpec;
      this.type = 2461110595;
    }
  }
  IFC42.IfcBSplineCurveWithKnots = IfcBSplineCurveWithKnots;
  class IfcBeamType extends IfcBuildingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 819618141;
    }
  }
  IFC42.IfcBeamType = IfcBeamType;
  class IfcBoilerType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 231477066;
    }
  }
  IFC42.IfcBoilerType = IfcBoilerType;
  class IfcBoundaryCurve extends IfcCompositeCurveOnSurface {
    constructor(Segments, SelfIntersect) {
      super(Segments, SelfIntersect);
      this.Segments = Segments;
      this.SelfIntersect = SelfIntersect;
      this.type = 1136057603;
    }
  }
  IFC42.IfcBoundaryCurve = IfcBoundaryCurve;
  class IfcBuildingElement extends IfcElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 3299480353;
    }
  }
  IFC42.IfcBuildingElement = IfcBuildingElement;
  class IfcBuildingElementPart extends IfcElementComponent {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2979338954;
    }
  }
  IFC42.IfcBuildingElementPart = IfcBuildingElementPart;
  class IfcBuildingElementPartType extends IfcElementComponentType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 39481116;
    }
  }
  IFC42.IfcBuildingElementPartType = IfcBuildingElementPartType;
  class IfcBuildingElementProxy extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1095909175;
    }
  }
  IFC42.IfcBuildingElementProxy = IfcBuildingElementProxy;
  class IfcBuildingElementProxyType extends IfcBuildingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1909888760;
    }
  }
  IFC42.IfcBuildingElementProxyType = IfcBuildingElementProxyType;
  class IfcBuildingSystem extends IfcSystem {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, LongName) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.PredefinedType = PredefinedType;
      this.LongName = LongName;
      this.type = 1177604601;
    }
  }
  IFC42.IfcBuildingSystem = IfcBuildingSystem;
  class IfcBurnerType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2188180465;
    }
  }
  IFC42.IfcBurnerType = IfcBurnerType;
  class IfcCableCarrierFittingType extends IfcFlowFittingType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 395041908;
    }
  }
  IFC42.IfcCableCarrierFittingType = IfcCableCarrierFittingType;
  class IfcCableCarrierSegmentType extends IfcFlowSegmentType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3293546465;
    }
  }
  IFC42.IfcCableCarrierSegmentType = IfcCableCarrierSegmentType;
  class IfcCableFittingType extends IfcFlowFittingType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2674252688;
    }
  }
  IFC42.IfcCableFittingType = IfcCableFittingType;
  class IfcCableSegmentType extends IfcFlowSegmentType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1285652485;
    }
  }
  IFC42.IfcCableSegmentType = IfcCableSegmentType;
  class IfcChillerType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2951183804;
    }
  }
  IFC42.IfcChillerType = IfcChillerType;
  class IfcChimney extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3296154744;
    }
  }
  IFC42.IfcChimney = IfcChimney;
  class IfcCircle extends IfcConic {
    constructor(Position, Radius) {
      super(Position);
      this.Position = Position;
      this.Radius = Radius;
      this.type = 2611217952;
    }
  }
  IFC42.IfcCircle = IfcCircle;
  class IfcCivilElement extends IfcElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1677625105;
    }
  }
  IFC42.IfcCivilElement = IfcCivilElement;
  class IfcCoilType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2301859152;
    }
  }
  IFC42.IfcCoilType = IfcCoilType;
  class IfcColumn extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 843113511;
    }
  }
  IFC42.IfcColumn = IfcColumn;
  class IfcColumnStandardCase extends IfcColumn {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 905975707;
    }
  }
  IFC42.IfcColumnStandardCase = IfcColumnStandardCase;
  class IfcCommunicationsApplianceType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 400855858;
    }
  }
  IFC42.IfcCommunicationsApplianceType = IfcCommunicationsApplianceType;
  class IfcCompressorType extends IfcFlowMovingDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3850581409;
    }
  }
  IFC42.IfcCompressorType = IfcCompressorType;
  class IfcCondenserType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2816379211;
    }
  }
  IFC42.IfcCondenserType = IfcCondenserType;
  class IfcConstructionEquipmentResource extends IfcConstructionResource {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.Usage = Usage;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 3898045240;
    }
  }
  IFC42.IfcConstructionEquipmentResource = IfcConstructionEquipmentResource;
  class IfcConstructionMaterialResource extends IfcConstructionResource {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.Usage = Usage;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 1060000209;
    }
  }
  IFC42.IfcConstructionMaterialResource = IfcConstructionMaterialResource;
  class IfcConstructionProductResource extends IfcConstructionResource {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.Usage = Usage;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 488727124;
    }
  }
  IFC42.IfcConstructionProductResource = IfcConstructionProductResource;
  class IfcCooledBeamType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 335055490;
    }
  }
  IFC42.IfcCooledBeamType = IfcCooledBeamType;
  class IfcCoolingTowerType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2954562838;
    }
  }
  IFC42.IfcCoolingTowerType = IfcCoolingTowerType;
  class IfcCovering extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1973544240;
    }
  }
  IFC42.IfcCovering = IfcCovering;
  class IfcCurtainWall extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3495092785;
    }
  }
  IFC42.IfcCurtainWall = IfcCurtainWall;
  class IfcDamperType extends IfcFlowControllerType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3961806047;
    }
  }
  IFC42.IfcDamperType = IfcDamperType;
  class IfcDiscreteAccessory extends IfcElementComponent {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1335981549;
    }
  }
  IFC42.IfcDiscreteAccessory = IfcDiscreteAccessory;
  class IfcDiscreteAccessoryType extends IfcElementComponentType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2635815018;
    }
  }
  IFC42.IfcDiscreteAccessoryType = IfcDiscreteAccessoryType;
  class IfcDistributionChamberElementType extends IfcDistributionFlowElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1599208980;
    }
  }
  IFC42.IfcDistributionChamberElementType = IfcDistributionChamberElementType;
  class IfcDistributionControlElementType extends IfcDistributionElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 2063403501;
    }
  }
  IFC42.IfcDistributionControlElementType = IfcDistributionControlElementType;
  class IfcDistributionElement extends IfcElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1945004755;
    }
  }
  IFC42.IfcDistributionElement = IfcDistributionElement;
  class IfcDistributionFlowElement extends IfcDistributionElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 3040386961;
    }
  }
  IFC42.IfcDistributionFlowElement = IfcDistributionFlowElement;
  class IfcDistributionPort extends IfcPort {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, FlowDirection, PredefinedType, SystemType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.FlowDirection = FlowDirection;
      this.PredefinedType = PredefinedType;
      this.SystemType = SystemType;
      this.type = 3041715199;
    }
  }
  IFC42.IfcDistributionPort = IfcDistributionPort;
  class IfcDistributionSystem extends IfcSystem {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.LongName = LongName;
      this.PredefinedType = PredefinedType;
      this.type = 3205830791;
    }
  }
  IFC42.IfcDistributionSystem = IfcDistributionSystem;
  class IfcDoor extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth, PredefinedType, OperationType, UserDefinedOperationType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.OverallHeight = OverallHeight;
      this.OverallWidth = OverallWidth;
      this.PredefinedType = PredefinedType;
      this.OperationType = OperationType;
      this.UserDefinedOperationType = UserDefinedOperationType;
      this.type = 395920057;
    }
  }
  IFC42.IfcDoor = IfcDoor;
  class IfcDoorStandardCase extends IfcDoor {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth, PredefinedType, OperationType, UserDefinedOperationType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth, PredefinedType, OperationType, UserDefinedOperationType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.OverallHeight = OverallHeight;
      this.OverallWidth = OverallWidth;
      this.PredefinedType = PredefinedType;
      this.OperationType = OperationType;
      this.UserDefinedOperationType = UserDefinedOperationType;
      this.type = 3242481149;
    }
  }
  IFC42.IfcDoorStandardCase = IfcDoorStandardCase;
  class IfcDuctFittingType extends IfcFlowFittingType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 869906466;
    }
  }
  IFC42.IfcDuctFittingType = IfcDuctFittingType;
  class IfcDuctSegmentType extends IfcFlowSegmentType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3760055223;
    }
  }
  IFC42.IfcDuctSegmentType = IfcDuctSegmentType;
  class IfcDuctSilencerType extends IfcFlowTreatmentDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2030761528;
    }
  }
  IFC42.IfcDuctSilencerType = IfcDuctSilencerType;
  class IfcElectricApplianceType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 663422040;
    }
  }
  IFC42.IfcElectricApplianceType = IfcElectricApplianceType;
  class IfcElectricDistributionBoardType extends IfcFlowControllerType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2417008758;
    }
  }
  IFC42.IfcElectricDistributionBoardType = IfcElectricDistributionBoardType;
  class IfcElectricFlowStorageDeviceType extends IfcFlowStorageDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3277789161;
    }
  }
  IFC42.IfcElectricFlowStorageDeviceType = IfcElectricFlowStorageDeviceType;
  class IfcElectricGeneratorType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1534661035;
    }
  }
  IFC42.IfcElectricGeneratorType = IfcElectricGeneratorType;
  class IfcElectricMotorType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1217240411;
    }
  }
  IFC42.IfcElectricMotorType = IfcElectricMotorType;
  class IfcElectricTimeControlType extends IfcFlowControllerType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 712377611;
    }
  }
  IFC42.IfcElectricTimeControlType = IfcElectricTimeControlType;
  class IfcEnergyConversionDevice extends IfcDistributionFlowElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1658829314;
    }
  }
  IFC42.IfcEnergyConversionDevice = IfcEnergyConversionDevice;
  class IfcEngine extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2814081492;
    }
  }
  IFC42.IfcEngine = IfcEngine;
  class IfcEvaporativeCooler extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3747195512;
    }
  }
  IFC42.IfcEvaporativeCooler = IfcEvaporativeCooler;
  class IfcEvaporator extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 484807127;
    }
  }
  IFC42.IfcEvaporator = IfcEvaporator;
  class IfcExternalSpatialElement extends IfcExternalSpatialStructureElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.PredefinedType = PredefinedType;
      this.type = 1209101575;
    }
  }
  IFC42.IfcExternalSpatialElement = IfcExternalSpatialElement;
  class IfcFanType extends IfcFlowMovingDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 346874300;
    }
  }
  IFC42.IfcFanType = IfcFanType;
  class IfcFilterType extends IfcFlowTreatmentDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1810631287;
    }
  }
  IFC42.IfcFilterType = IfcFilterType;
  class IfcFireSuppressionTerminalType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4222183408;
    }
  }
  IFC42.IfcFireSuppressionTerminalType = IfcFireSuppressionTerminalType;
  class IfcFlowController extends IfcDistributionFlowElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 2058353004;
    }
  }
  IFC42.IfcFlowController = IfcFlowController;
  class IfcFlowFitting extends IfcDistributionFlowElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 4278956645;
    }
  }
  IFC42.IfcFlowFitting = IfcFlowFitting;
  class IfcFlowInstrumentType extends IfcDistributionControlElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4037862832;
    }
  }
  IFC42.IfcFlowInstrumentType = IfcFlowInstrumentType;
  class IfcFlowMeter extends IfcFlowController {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2188021234;
    }
  }
  IFC42.IfcFlowMeter = IfcFlowMeter;
  class IfcFlowMovingDevice extends IfcDistributionFlowElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 3132237377;
    }
  }
  IFC42.IfcFlowMovingDevice = IfcFlowMovingDevice;
  class IfcFlowSegment extends IfcDistributionFlowElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 987401354;
    }
  }
  IFC42.IfcFlowSegment = IfcFlowSegment;
  class IfcFlowStorageDevice extends IfcDistributionFlowElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 707683696;
    }
  }
  IFC42.IfcFlowStorageDevice = IfcFlowStorageDevice;
  class IfcFlowTerminal extends IfcDistributionFlowElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 2223149337;
    }
  }
  IFC42.IfcFlowTerminal = IfcFlowTerminal;
  class IfcFlowTreatmentDevice extends IfcDistributionFlowElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 3508470533;
    }
  }
  IFC42.IfcFlowTreatmentDevice = IfcFlowTreatmentDevice;
  class IfcFooting extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 900683007;
    }
  }
  IFC42.IfcFooting = IfcFooting;
  class IfcHeatExchanger extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3319311131;
    }
  }
  IFC42.IfcHeatExchanger = IfcHeatExchanger;
  class IfcHumidifier extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2068733104;
    }
  }
  IFC42.IfcHumidifier = IfcHumidifier;
  class IfcInterceptor extends IfcFlowTreatmentDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4175244083;
    }
  }
  IFC42.IfcInterceptor = IfcInterceptor;
  class IfcJunctionBox extends IfcFlowFitting {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2176052936;
    }
  }
  IFC42.IfcJunctionBox = IfcJunctionBox;
  class IfcLamp extends IfcFlowTerminal {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 76236018;
    }
  }
  IFC42.IfcLamp = IfcLamp;
  class IfcLightFixture extends IfcFlowTerminal {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 629592764;
    }
  }
  IFC42.IfcLightFixture = IfcLightFixture;
  class IfcMedicalDevice extends IfcFlowTerminal {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1437502449;
    }
  }
  IFC42.IfcMedicalDevice = IfcMedicalDevice;
  class IfcMember extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1073191201;
    }
  }
  IFC42.IfcMember = IfcMember;
  class IfcMemberStandardCase extends IfcMember {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1911478936;
    }
  }
  IFC42.IfcMemberStandardCase = IfcMemberStandardCase;
  class IfcMotorConnection extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2474470126;
    }
  }
  IFC42.IfcMotorConnection = IfcMotorConnection;
  class IfcOuterBoundaryCurve extends IfcBoundaryCurve {
    constructor(Segments, SelfIntersect) {
      super(Segments, SelfIntersect);
      this.Segments = Segments;
      this.SelfIntersect = SelfIntersect;
      this.type = 144952367;
    }
  }
  IFC42.IfcOuterBoundaryCurve = IfcOuterBoundaryCurve;
  class IfcOutlet extends IfcFlowTerminal {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3694346114;
    }
  }
  IFC42.IfcOutlet = IfcOutlet;
  class IfcPile extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType, ConstructionType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.ConstructionType = ConstructionType;
      this.type = 1687234759;
    }
  }
  IFC42.IfcPile = IfcPile;
  class IfcPipeFitting extends IfcFlowFitting {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 310824031;
    }
  }
  IFC42.IfcPipeFitting = IfcPipeFitting;
  class IfcPipeSegment extends IfcFlowSegment {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3612865200;
    }
  }
  IFC42.IfcPipeSegment = IfcPipeSegment;
  class IfcPlate extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3171933400;
    }
  }
  IFC42.IfcPlate = IfcPlate;
  class IfcPlateStandardCase extends IfcPlate {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1156407060;
    }
  }
  IFC42.IfcPlateStandardCase = IfcPlateStandardCase;
  class IfcProtectiveDevice extends IfcFlowController {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 738039164;
    }
  }
  IFC42.IfcProtectiveDevice = IfcProtectiveDevice;
  class IfcProtectiveDeviceTrippingUnitType extends IfcDistributionControlElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 655969474;
    }
  }
  IFC42.IfcProtectiveDeviceTrippingUnitType = IfcProtectiveDeviceTrippingUnitType;
  class IfcPump extends IfcFlowMovingDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 90941305;
    }
  }
  IFC42.IfcPump = IfcPump;
  class IfcRailing extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2262370178;
    }
  }
  IFC42.IfcRailing = IfcRailing;
  class IfcRamp extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3024970846;
    }
  }
  IFC42.IfcRamp = IfcRamp;
  class IfcRampFlight extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3283111854;
    }
  }
  IFC42.IfcRampFlight = IfcRampFlight;
  class IfcRationalBSplineCurveWithKnots extends IfcBSplineCurveWithKnots {
    constructor(Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect, KnotMultiplicities, Knots, KnotSpec, WeightsData) {
      super(Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect, KnotMultiplicities, Knots, KnotSpec);
      this.Degree = Degree;
      this.ControlPointsList = ControlPointsList;
      this.CurveForm = CurveForm;
      this.ClosedCurve = ClosedCurve;
      this.SelfIntersect = SelfIntersect;
      this.KnotMultiplicities = KnotMultiplicities;
      this.Knots = Knots;
      this.KnotSpec = KnotSpec;
      this.WeightsData = WeightsData;
      this.type = 1232101972;
    }
  }
  IFC42.IfcRationalBSplineCurveWithKnots = IfcRationalBSplineCurveWithKnots;
  class IfcReinforcingBar extends IfcReinforcingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, NominalDiameter, CrossSectionArea, BarLength, PredefinedType, BarSurface) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.SteelGrade = SteelGrade;
      this.NominalDiameter = NominalDiameter;
      this.CrossSectionArea = CrossSectionArea;
      this.BarLength = BarLength;
      this.PredefinedType = PredefinedType;
      this.BarSurface = BarSurface;
      this.type = 979691226;
    }
  }
  IFC42.IfcReinforcingBar = IfcReinforcingBar;
  class IfcReinforcingBarType extends IfcReinforcingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, NominalDiameter, CrossSectionArea, BarLength, BarSurface, BendingShapeCode, BendingParameters) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.NominalDiameter = NominalDiameter;
      this.CrossSectionArea = CrossSectionArea;
      this.BarLength = BarLength;
      this.BarSurface = BarSurface;
      this.BendingShapeCode = BendingShapeCode;
      this.BendingParameters = BendingParameters;
      this.type = 2572171363;
    }
  }
  IFC42.IfcReinforcingBarType = IfcReinforcingBarType;
  class IfcRoof extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2016517767;
    }
  }
  IFC42.IfcRoof = IfcRoof;
  class IfcSanitaryTerminal extends IfcFlowTerminal {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3053780830;
    }
  }
  IFC42.IfcSanitaryTerminal = IfcSanitaryTerminal;
  class IfcSensorType extends IfcDistributionControlElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1783015770;
    }
  }
  IFC42.IfcSensorType = IfcSensorType;
  class IfcShadingDevice extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1329646415;
    }
  }
  IFC42.IfcShadingDevice = IfcShadingDevice;
  class IfcSlab extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1529196076;
    }
  }
  IFC42.IfcSlab = IfcSlab;
  class IfcSlabElementedCase extends IfcSlab {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3127900445;
    }
  }
  IFC42.IfcSlabElementedCase = IfcSlabElementedCase;
  class IfcSlabStandardCase extends IfcSlab {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3027962421;
    }
  }
  IFC42.IfcSlabStandardCase = IfcSlabStandardCase;
  class IfcSolarDevice extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3420628829;
    }
  }
  IFC42.IfcSolarDevice = IfcSolarDevice;
  class IfcSpaceHeater extends IfcFlowTerminal {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1999602285;
    }
  }
  IFC42.IfcSpaceHeater = IfcSpaceHeater;
  class IfcStackTerminal extends IfcFlowTerminal {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1404847402;
    }
  }
  IFC42.IfcStackTerminal = IfcStackTerminal;
  class IfcStair extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 331165859;
    }
  }
  IFC42.IfcStair = IfcStair;
  class IfcStairFlight extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, NumberOfRisers, NumberOfTreads, RiserHeight, TreadLength, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.NumberOfRisers = NumberOfRisers;
      this.NumberOfTreads = NumberOfTreads;
      this.RiserHeight = RiserHeight;
      this.TreadLength = TreadLength;
      this.PredefinedType = PredefinedType;
      this.type = 4252922144;
    }
  }
  IFC42.IfcStairFlight = IfcStairFlight;
  class IfcStructuralAnalysisModel extends IfcSystem {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, OrientationOf2DPlane, LoadedBy, HasResults, SharedPlacement) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.PredefinedType = PredefinedType;
      this.OrientationOf2DPlane = OrientationOf2DPlane;
      this.LoadedBy = LoadedBy;
      this.HasResults = HasResults;
      this.SharedPlacement = SharedPlacement;
      this.type = 2515109513;
    }
  }
  IFC42.IfcStructuralAnalysisModel = IfcStructuralAnalysisModel;
  class IfcStructuralLoadCase extends IfcStructuralLoadGroup {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, ActionType, ActionSource, Coefficient, Purpose, SelfWeightCoefficients) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, ActionType, ActionSource, Coefficient, Purpose);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.PredefinedType = PredefinedType;
      this.ActionType = ActionType;
      this.ActionSource = ActionSource;
      this.Coefficient = Coefficient;
      this.Purpose = Purpose;
      this.SelfWeightCoefficients = SelfWeightCoefficients;
      this.type = 385403989;
    }
  }
  IFC42.IfcStructuralLoadCase = IfcStructuralLoadCase;
  class IfcStructuralPlanarAction extends IfcStructuralSurfaceAction {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.DestabilizingLoad = DestabilizingLoad;
      this.ProjectedOrTrue = ProjectedOrTrue;
      this.PredefinedType = PredefinedType;
      this.type = 1621171031;
    }
  }
  IFC42.IfcStructuralPlanarAction = IfcStructuralPlanarAction;
  class IfcSwitchingDevice extends IfcFlowController {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1162798199;
    }
  }
  IFC42.IfcSwitchingDevice = IfcSwitchingDevice;
  class IfcTank extends IfcFlowStorageDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 812556717;
    }
  }
  IFC42.IfcTank = IfcTank;
  class IfcTransformer extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3825984169;
    }
  }
  IFC42.IfcTransformer = IfcTransformer;
  class IfcTubeBundle extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3026737570;
    }
  }
  IFC42.IfcTubeBundle = IfcTubeBundle;
  class IfcUnitaryControlElementType extends IfcDistributionControlElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3179687236;
    }
  }
  IFC42.IfcUnitaryControlElementType = IfcUnitaryControlElementType;
  class IfcUnitaryEquipment extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4292641817;
    }
  }
  IFC42.IfcUnitaryEquipment = IfcUnitaryEquipment;
  class IfcValve extends IfcFlowController {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4207607924;
    }
  }
  IFC42.IfcValve = IfcValve;
  class IfcWall extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2391406946;
    }
  }
  IFC42.IfcWall = IfcWall;
  class IfcWallElementedCase extends IfcWall {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4156078855;
    }
  }
  IFC42.IfcWallElementedCase = IfcWallElementedCase;
  class IfcWallStandardCase extends IfcWall {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3512223829;
    }
  }
  IFC42.IfcWallStandardCase = IfcWallStandardCase;
  class IfcWasteTerminal extends IfcFlowTerminal {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4237592921;
    }
  }
  IFC42.IfcWasteTerminal = IfcWasteTerminal;
  class IfcWindow extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth, PredefinedType, PartitioningType, UserDefinedPartitioningType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.OverallHeight = OverallHeight;
      this.OverallWidth = OverallWidth;
      this.PredefinedType = PredefinedType;
      this.PartitioningType = PartitioningType;
      this.UserDefinedPartitioningType = UserDefinedPartitioningType;
      this.type = 3304561284;
    }
  }
  IFC42.IfcWindow = IfcWindow;
  class IfcWindowStandardCase extends IfcWindow {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth, PredefinedType, PartitioningType, UserDefinedPartitioningType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth, PredefinedType, PartitioningType, UserDefinedPartitioningType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.OverallHeight = OverallHeight;
      this.OverallWidth = OverallWidth;
      this.PredefinedType = PredefinedType;
      this.PartitioningType = PartitioningType;
      this.UserDefinedPartitioningType = UserDefinedPartitioningType;
      this.type = 486154966;
    }
  }
  IFC42.IfcWindowStandardCase = IfcWindowStandardCase;
  class IfcActuatorType extends IfcDistributionControlElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2874132201;
    }
  }
  IFC42.IfcActuatorType = IfcActuatorType;
  class IfcAirTerminal extends IfcFlowTerminal {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1634111441;
    }
  }
  IFC42.IfcAirTerminal = IfcAirTerminal;
  class IfcAirTerminalBox extends IfcFlowController {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 177149247;
    }
  }
  IFC42.IfcAirTerminalBox = IfcAirTerminalBox;
  class IfcAirToAirHeatRecovery extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2056796094;
    }
  }
  IFC42.IfcAirToAirHeatRecovery = IfcAirToAirHeatRecovery;
  class IfcAlarmType extends IfcDistributionControlElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3001207471;
    }
  }
  IFC42.IfcAlarmType = IfcAlarmType;
  class IfcAudioVisualAppliance extends IfcFlowTerminal {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 277319702;
    }
  }
  IFC42.IfcAudioVisualAppliance = IfcAudioVisualAppliance;
  class IfcBeam extends IfcBuildingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 753842376;
    }
  }
  IFC42.IfcBeam = IfcBeam;
  class IfcBeamStandardCase extends IfcBeam {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2906023776;
    }
  }
  IFC42.IfcBeamStandardCase = IfcBeamStandardCase;
  class IfcBoiler extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 32344328;
    }
  }
  IFC42.IfcBoiler = IfcBoiler;
  class IfcBurner extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2938176219;
    }
  }
  IFC42.IfcBurner = IfcBurner;
  class IfcCableCarrierFitting extends IfcFlowFitting {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 635142910;
    }
  }
  IFC42.IfcCableCarrierFitting = IfcCableCarrierFitting;
  class IfcCableCarrierSegment extends IfcFlowSegment {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3758799889;
    }
  }
  IFC42.IfcCableCarrierSegment = IfcCableCarrierSegment;
  class IfcCableFitting extends IfcFlowFitting {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1051757585;
    }
  }
  IFC42.IfcCableFitting = IfcCableFitting;
  class IfcCableSegment extends IfcFlowSegment {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4217484030;
    }
  }
  IFC42.IfcCableSegment = IfcCableSegment;
  class IfcChiller extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3902619387;
    }
  }
  IFC42.IfcChiller = IfcChiller;
  class IfcCoil extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 639361253;
    }
  }
  IFC42.IfcCoil = IfcCoil;
  class IfcCommunicationsAppliance extends IfcFlowTerminal {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3221913625;
    }
  }
  IFC42.IfcCommunicationsAppliance = IfcCommunicationsAppliance;
  class IfcCompressor extends IfcFlowMovingDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3571504051;
    }
  }
  IFC42.IfcCompressor = IfcCompressor;
  class IfcCondenser extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2272882330;
    }
  }
  IFC42.IfcCondenser = IfcCondenser;
  class IfcControllerType extends IfcDistributionControlElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 578613899;
    }
  }
  IFC42.IfcControllerType = IfcControllerType;
  class IfcCooledBeam extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4136498852;
    }
  }
  IFC42.IfcCooledBeam = IfcCooledBeam;
  class IfcCoolingTower extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3640358203;
    }
  }
  IFC42.IfcCoolingTower = IfcCoolingTower;
  class IfcDamper extends IfcFlowController {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4074379575;
    }
  }
  IFC42.IfcDamper = IfcDamper;
  class IfcDistributionChamberElement extends IfcDistributionFlowElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1052013943;
    }
  }
  IFC42.IfcDistributionChamberElement = IfcDistributionChamberElement;
  class IfcDistributionCircuit extends IfcDistributionSystem {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, PredefinedType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.LongName = LongName;
      this.PredefinedType = PredefinedType;
      this.type = 562808652;
    }
  }
  IFC42.IfcDistributionCircuit = IfcDistributionCircuit;
  class IfcDistributionControlElement extends IfcDistributionElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1062813311;
    }
  }
  IFC42.IfcDistributionControlElement = IfcDistributionControlElement;
  class IfcDuctFitting extends IfcFlowFitting {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 342316401;
    }
  }
  IFC42.IfcDuctFitting = IfcDuctFitting;
  class IfcDuctSegment extends IfcFlowSegment {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3518393246;
    }
  }
  IFC42.IfcDuctSegment = IfcDuctSegment;
  class IfcDuctSilencer extends IfcFlowTreatmentDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1360408905;
    }
  }
  IFC42.IfcDuctSilencer = IfcDuctSilencer;
  class IfcElectricAppliance extends IfcFlowTerminal {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1904799276;
    }
  }
  IFC42.IfcElectricAppliance = IfcElectricAppliance;
  class IfcElectricDistributionBoard extends IfcFlowController {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 862014818;
    }
  }
  IFC42.IfcElectricDistributionBoard = IfcElectricDistributionBoard;
  class IfcElectricFlowStorageDevice extends IfcFlowStorageDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3310460725;
    }
  }
  IFC42.IfcElectricFlowStorageDevice = IfcElectricFlowStorageDevice;
  class IfcElectricGenerator extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 264262732;
    }
  }
  IFC42.IfcElectricGenerator = IfcElectricGenerator;
  class IfcElectricMotor extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 402227799;
    }
  }
  IFC42.IfcElectricMotor = IfcElectricMotor;
  class IfcElectricTimeControl extends IfcFlowController {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1003880860;
    }
  }
  IFC42.IfcElectricTimeControl = IfcElectricTimeControl;
  class IfcFan extends IfcFlowMovingDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3415622556;
    }
  }
  IFC42.IfcFan = IfcFan;
  class IfcFilter extends IfcFlowTreatmentDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 819412036;
    }
  }
  IFC42.IfcFilter = IfcFilter;
  class IfcFireSuppressionTerminal extends IfcFlowTerminal {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1426591983;
    }
  }
  IFC42.IfcFireSuppressionTerminal = IfcFireSuppressionTerminal;
  class IfcFlowInstrument extends IfcDistributionControlElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 182646315;
    }
  }
  IFC42.IfcFlowInstrument = IfcFlowInstrument;
  class IfcProtectiveDeviceTrippingUnit extends IfcDistributionControlElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2295281155;
    }
  }
  IFC42.IfcProtectiveDeviceTrippingUnit = IfcProtectiveDeviceTrippingUnit;
  class IfcSensor extends IfcDistributionControlElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4086658281;
    }
  }
  IFC42.IfcSensor = IfcSensor;
  class IfcUnitaryControlElement extends IfcDistributionControlElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 630975310;
    }
  }
  IFC42.IfcUnitaryControlElement = IfcUnitaryControlElement;
  class IfcActuator extends IfcDistributionControlElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4288193352;
    }
  }
  IFC42.IfcActuator = IfcActuator;
  class IfcAlarm extends IfcDistributionControlElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3087945054;
    }
  }
  IFC42.IfcAlarm = IfcAlarm;
  class IfcController extends IfcDistributionControlElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 25142252;
    }
  }
  IFC42.IfcController = IfcController;
})(IFC4 || (IFC4 = {}));
SchemaNames[3] = ["IFC4X3", "IFC4X1", "IFC4X2", "IFC4X3_RC3", "IFC4X3_RC4", "IFC4X3_RC1", "IFC4X3_RC2", "IFC4X3_ADD2", "IFC4X3_ADD1"];
FromRawLineData[3] = {
  3630933823: (v) => new IFC4X3.IfcActorRole(v[0], !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcText(!v[2] && v[2] != "" ? null : v[2].value)),
  618182010: (v) => new IFC4X3.IfcAddress(v[0], !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  2879124712: (v) => new IFC4X3.IfcAlignmentParameterSegment(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value)),
  3633395639: (v) => new IFC4X3.IfcAlignmentVerticalSegment(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new IFC4X3.IfcLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcNonNegativeLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC4X3.IfcLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), new IFC4X3.IfcRatioMeasure(!v[5] && v[5] != "" ? null : v[5].value), new IFC4X3.IfcRatioMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  639542469: (v) => new IFC4X3.IfcApplication(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcIdentifier(!v[3] && v[3] != "" ? null : v[3].value)),
  411424972: (v) => new IFC4X3.IfcAppliedValue(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcDate(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcDate(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), v[8], !v[9] && v[9] != "" ? null : v[9]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  130549933: (v) => new IFC4X3.IfcApproval(!v[0] && v[0] != "" ? null : new IFC4X3.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcText(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcDateTime(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcText(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new Handle(!v[8] && v[8] != "" ? null : v[8].value)),
  4037036970: (v) => new IFC4X3.IfcBoundaryCondition(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  1560379544: (v) => new IFC4X3.IfcBoundaryEdgeCondition(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : TypeInitialiser(3, v[1]), !v[2] && v[2] != "" ? null : TypeInitialiser(3, v[2]), !v[3] && v[3] != "" ? null : TypeInitialiser(3, v[3]), !v[4] && v[4] != "" ? null : TypeInitialiser(3, v[4]), !v[5] && v[5] != "" ? null : TypeInitialiser(3, v[5]), !v[6] && v[6] != "" ? null : TypeInitialiser(3, v[6])),
  3367102660: (v) => new IFC4X3.IfcBoundaryFaceCondition(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : TypeInitialiser(3, v[1]), !v[2] && v[2] != "" ? null : TypeInitialiser(3, v[2]), !v[3] && v[3] != "" ? null : TypeInitialiser(3, v[3])),
  1387855156: (v) => new IFC4X3.IfcBoundaryNodeCondition(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : TypeInitialiser(3, v[1]), !v[2] && v[2] != "" ? null : TypeInitialiser(3, v[2]), !v[3] && v[3] != "" ? null : TypeInitialiser(3, v[3]), !v[4] && v[4] != "" ? null : TypeInitialiser(3, v[4]), !v[5] && v[5] != "" ? null : TypeInitialiser(3, v[5]), !v[6] && v[6] != "" ? null : TypeInitialiser(3, v[6])),
  2069777674: (v) => new IFC4X3.IfcBoundaryNodeConditionWarping(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : TypeInitialiser(3, v[1]), !v[2] && v[2] != "" ? null : TypeInitialiser(3, v[2]), !v[3] && v[3] != "" ? null : TypeInitialiser(3, v[3]), !v[4] && v[4] != "" ? null : TypeInitialiser(3, v[4]), !v[5] && v[5] != "" ? null : TypeInitialiser(3, v[5]), !v[6] && v[6] != "" ? null : TypeInitialiser(3, v[6]), !v[7] && v[7] != "" ? null : TypeInitialiser(3, v[7])),
  2859738748: (_) => new IFC4X3.IfcConnectionGeometry(),
  2614616156: (v) => new IFC4X3.IfcConnectionPointGeometry(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  2732653382: (v) => new IFC4X3.IfcConnectionSurfaceGeometry(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  775493141: (v) => new IFC4X3.IfcConnectionVolumeGeometry(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  1959218052: (v) => new IFC4X3.IfcConstraint(new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2], !v[3] && v[3] != "" ? null : new IFC4X3.IfcLabel(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcDateTime(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value)),
  1785450214: (v) => new IFC4X3.IfcCoordinateOperation(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  1466758467: (v) => new IFC4X3.IfcCoordinateReferenceSystem(new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcIdentifier(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcIdentifier(!v[3] && v[3] != "" ? null : v[3].value)),
  602808272: (v) => new IFC4X3.IfcCostValue(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcDate(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcDate(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), v[8], !v[9] && v[9] != "" ? null : v[9]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1765591967: (v) => new IFC4X3.IfcDerivedUnit(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[1], !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcLabel(!v[3] && v[3] != "" ? null : v[3].value)),
  1045800335: (v) => new IFC4X3.IfcDerivedUnitElement(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : v[1].value),
  2949456006: (v) => new IFC4X3.IfcDimensionalExponents(!v[0] && v[0] != "" ? null : v[0].value, !v[1] && v[1] != "" ? null : v[1].value, !v[2] && v[2] != "" ? null : v[2].value, !v[3] && v[3] != "" ? null : v[3].value, !v[4] && v[4] != "" ? null : v[4].value, !v[5] && v[5] != "" ? null : v[5].value, !v[6] && v[6] != "" ? null : v[6].value),
  4294318154: (_) => new IFC4X3.IfcExternalInformation(),
  3200245327: (v) => new IFC4X3.IfcExternalReference(!v[0] && v[0] != "" ? null : new IFC4X3.IfcURIReference(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcIdentifier(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  2242383968: (v) => new IFC4X3.IfcExternallyDefinedHatchStyle(!v[0] && v[0] != "" ? null : new IFC4X3.IfcURIReference(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcIdentifier(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  1040185647: (v) => new IFC4X3.IfcExternallyDefinedSurfaceStyle(!v[0] && v[0] != "" ? null : new IFC4X3.IfcURIReference(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcIdentifier(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  3548104201: (v) => new IFC4X3.IfcExternallyDefinedTextFont(!v[0] && v[0] != "" ? null : new IFC4X3.IfcURIReference(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcIdentifier(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  852622518: (v) => new IFC4X3.IfcGridAxis(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), new IFC4X3.IfcBoolean(!v[2] && v[2] != "" ? null : v[2].value)),
  3020489413: (v) => new IFC4X3.IfcIrregularTimeSeriesValue(new IFC4X3.IfcDateTime(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? TypeInitialiser(3, p) : null) || []),
  2655187982: (v) => new IFC4X3.IfcLibraryInformation(new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcDateTime(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcURIReference(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcText(!v[5] && v[5] != "" ? null : v[5].value)),
  3452421091: (v) => new IFC4X3.IfcLibraryReference(!v[0] && v[0] != "" ? null : new IFC4X3.IfcURIReference(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcIdentifier(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLanguageId(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  4162380809: (v) => new IFC4X3.IfcLightDistributionData(new IFC4X3.IfcPlaneAngleMeasure(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcPlaneAngleMeasure(p.value) : null) || [], v[2]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcLuminousIntensityDistributionMeasure(p.value) : null) || []),
  1566485204: (v) => new IFC4X3.IfcLightIntensityDistribution(v[0], v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3057273783: (v) => new IFC4X3.IfcMapConversion(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), new IFC4X3.IfcLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC4X3.IfcLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcReal(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcReal(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcReal(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcReal(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4X3.IfcReal(!v[9] && v[9] != "" ? null : v[9].value)),
  1847130766: (v) => new IFC4X3.IfcMaterialClassificationRelationship(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  760658860: (_) => new IFC4X3.IfcMaterialDefinition(),
  248100487: (v) => new IFC4X3.IfcMaterialLayer(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcNonNegativeLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLogical(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcLabel(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcText(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcInteger(!v[6] && v[6] != "" ? null : v[6].value)),
  3303938423: (v) => new IFC4X3.IfcMaterialLayerSet(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcText(!v[2] && v[2] != "" ? null : v[2].value)),
  1847252529: (v) => new IFC4X3.IfcMaterialLayerWithOffsets(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcNonNegativeLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLogical(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcLabel(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcText(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcInteger(!v[6] && v[6] != "" ? null : v[6].value), v[7], new IFC4X3.IfcLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value)),
  2199411900: (v) => new IFC4X3.IfcMaterialList(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2235152071: (v) => new IFC4X3.IfcMaterialProfile(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcInteger(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value)),
  164193824: (v) => new IFC4X3.IfcMaterialProfileSet(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  552965576: (v) => new IFC4X3.IfcMaterialProfileWithOffsets(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcInteger(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value), new IFC4X3.IfcLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value)),
  1507914824: (_) => new IFC4X3.IfcMaterialUsageDefinition(),
  2597039031: (v) => new IFC4X3.IfcMeasureWithUnit(TypeInitialiser(3, v[0]), new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  3368373690: (v) => new IFC4X3.IfcMetric(new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2], !v[3] && v[3] != "" ? null : new IFC4X3.IfcLabel(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcDateTime(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), v[7], !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new Handle(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new Handle(!v[10] && v[10] != "" ? null : v[10].value)),
  2706619895: (v) => new IFC4X3.IfcMonetaryUnit(new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  1918398963: (v) => new IFC4X3.IfcNamedUnit(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]),
  3701648758: (v) => new IFC4X3.IfcObjectPlacement(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  2251480897: (v) => new IFC4X3.IfcObjective(new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2], !v[3] && v[3] != "" ? null : new IFC4X3.IfcLabel(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcDateTime(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[8], v[9], !v[10] && v[10] != "" ? null : new IFC4X3.IfcLabel(!v[10] && v[10] != "" ? null : v[10].value)),
  4251960020: (v) => new IFC4X3.IfcOrganization(!v[0] && v[0] != "" ? null : new IFC4X3.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcText(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[4] && v[4] != "" ? null : v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1207048766: (v) => new IFC4X3.IfcOwnerHistory(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), v[2], v[3], !v[4] && v[4] != "" ? null : new IFC4X3.IfcTimeStamp(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), new IFC4X3.IfcTimeStamp(!v[7] && v[7] != "" ? null : v[7].value)),
  2077209135: (v) => new IFC4X3.IfcPerson(!v[0] && v[0] != "" ? null : new IFC4X3.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : v[3]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcLabel(p.value) : null) || [], !v[4] && v[4] != "" ? null : v[4]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcLabel(p.value) : null) || [], !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcLabel(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  101040310: (v) => new IFC4X3.IfcPersonAndOrganization(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2483315170: (v) => new IFC4X3.IfcPhysicalQuantity(new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value)),
  2226359599: (v) => new IFC4X3.IfcPhysicalSimpleQuantity(new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  3355820592: (v) => new IFC4X3.IfcPostalAddress(v[0], !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcLabel(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : v[4]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcLabel(p.value) : null) || [], !v[5] && v[5] != "" ? null : new IFC4X3.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4X3.IfcLabel(!v[9] && v[9] != "" ? null : v[9].value)),
  677532197: (_) => new IFC4X3.IfcPresentationItem(),
  2022622350: (v) => new IFC4X3.IfcPresentationLayerAssignment(new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[3] && v[3] != "" ? null : new IFC4X3.IfcIdentifier(!v[3] && v[3] != "" ? null : v[3].value)),
  1304840413: (v) => new IFC4X3.IfcPresentationLayerWithStyle(new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[3] && v[3] != "" ? null : new IFC4X3.IfcIdentifier(!v[3] && v[3] != "" ? null : v[3].value), new IFC4X3.IfcLogical(!v[4] && v[4] != "" ? null : v[4].value), new IFC4X3.IfcLogical(!v[5] && v[5] != "" ? null : v[5].value), new IFC4X3.IfcLogical(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3119450353: (v) => new IFC4X3.IfcPresentationStyle(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  2095639259: (v) => new IFC4X3.IfcProductRepresentation(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3958567839: (v) => new IFC4X3.IfcProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value)),
  3843373140: (v) => new IFC4X3.IfcProjectedCRS(new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcIdentifier(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcIdentifier(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  986844984: (_) => new IFC4X3.IfcPropertyAbstraction(),
  3710013099: (v) => new IFC4X3.IfcPropertyEnumeration(new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? TypeInitialiser(3, p) : null) || [], !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  2044713172: (v) => new IFC4X3.IfcQuantityArea(new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcAreaMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  2093928680: (v) => new IFC4X3.IfcQuantityCount(new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcCountMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  931644368: (v) => new IFC4X3.IfcQuantityLength(new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  2691318326: (v) => new IFC4X3.IfcQuantityNumber(new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcNumericMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  3252649465: (v) => new IFC4X3.IfcQuantityTime(new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcTimeMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  2405470396: (v) => new IFC4X3.IfcQuantityVolume(new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcVolumeMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  825690147: (v) => new IFC4X3.IfcQuantityWeight(new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcMassMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  3915482550: (v) => new IFC4X3.IfcRecurrencePattern(v[0], !v[1] && v[1] != "" ? null : v[1]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcDayInMonthNumber(p.value) : null) || [], !v[2] && v[2] != "" ? null : v[2]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcDayInWeekNumber(p.value) : null) || [], !v[3] && v[3] != "" ? null : v[3]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcMonthInYearNumber(p.value) : null) || [], !v[4] && v[4] != "" ? null : new IFC4X3.IfcInteger(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcInteger(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcInteger(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2433181523: (v) => new IFC4X3.IfcReference(!v[0] && v[0] != "" ? null : new IFC4X3.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcIdentifier(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : v[3]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcInteger(p.value) : null) || [], !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value)),
  1076942058: (v) => new IFC4X3.IfcRepresentation(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3377609919: (v) => new IFC4X3.IfcRepresentationContext(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value)),
  3008791417: (_) => new IFC4X3.IfcRepresentationItem(),
  1660063152: (v) => new IFC4X3.IfcRepresentationMap(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  2439245199: (v) => new IFC4X3.IfcResourceLevelRelationship(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value)),
  2341007311: (v) => new IFC4X3.IfcRoot(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value)),
  448429030: (v) => new IFC4X3.IfcSIUnit(v[0], v[1], v[2]),
  1054537805: (v) => new IFC4X3.IfcSchedulingTime(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), v[1], !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  867548509: (v) => new IFC4X3.IfcShapeAspect(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcText(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcLogical(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value)),
  3982875396: (v) => new IFC4X3.IfcShapeModel(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  4240577450: (v) => new IFC4X3.IfcShapeRepresentation(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2273995522: (v) => new IFC4X3.IfcStructuralConnectionCondition(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  2162789131: (v) => new IFC4X3.IfcStructuralLoad(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  3478079324: (v) => new IFC4X3.IfcStructuralLoadConfiguration(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[2] && v[2] != "" ? null : v[2]?.map((p) => p?.map((p2) => p2?.value && p2?.value != "" ? new IFC4X3.IfcLengthMeasure(p2.value) : null) || [])),
  609421318: (v) => new IFC4X3.IfcStructuralLoadOrResult(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  2525727697: (v) => new IFC4X3.IfcStructuralLoadStatic(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  3408363356: (v) => new IFC4X3.IfcStructuralLoadTemperature(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcThermodynamicTemperatureMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcThermodynamicTemperatureMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcThermodynamicTemperatureMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  2830218821: (v) => new IFC4X3.IfcStyleModel(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3958052878: (v) => new IFC4X3.IfcStyledItem(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  3049322572: (v) => new IFC4X3.IfcStyledRepresentation(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2934153892: (v) => new IFC4X3.IfcSurfaceReinforcementArea(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : v[1]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcLengthMeasure(p.value) : null) || [], !v[2] && v[2] != "" ? null : v[2]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcLengthMeasure(p.value) : null) || [], !v[3] && v[3] != "" ? null : new IFC4X3.IfcRatioMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  1300840506: (v) => new IFC4X3.IfcSurfaceStyle(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), v[1], v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3303107099: (v) => new IFC4X3.IfcSurfaceStyleLighting(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  1607154358: (v) => new IFC4X3.IfcSurfaceStyleRefraction(!v[0] && v[0] != "" ? null : new IFC4X3.IfcReal(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcReal(!v[1] && v[1] != "" ? null : v[1].value)),
  846575682: (v) => new IFC4X3.IfcSurfaceStyleShading(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcNormalisedRatioMeasure(!v[1] && v[1] != "" ? null : v[1].value)),
  1351298697: (v) => new IFC4X3.IfcSurfaceStyleWithTextures(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  626085974: (v) => new IFC4X3.IfcSurfaceTexture(new IFC4X3.IfcBoolean(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcBoolean(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcIdentifier(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : v[4]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcIdentifier(p.value) : null) || []),
  985171141: (v) => new IFC4X3.IfcTable(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[2] && v[2] != "" ? null : v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2043862942: (v) => new IFC4X3.IfcTableColumn(!v[0] && v[0] != "" ? null : new IFC4X3.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcText(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value)),
  531007025: (v) => new IFC4X3.IfcTableRow(!v[0] && v[0] != "" ? null : v[0]?.map((p) => p?.value && p?.value != "" ? TypeInitialiser(3, p) : null) || [], !v[1] && v[1] != "" ? null : new IFC4X3.IfcBoolean(!v[1] && v[1] != "" ? null : v[1].value)),
  1549132990: (v) => new IFC4X3.IfcTaskTime(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), v[1], !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), v[3], !v[4] && v[4] != "" ? null : new IFC4X3.IfcDuration(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcDateTime(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcDateTime(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcDateTime(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcDateTime(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4X3.IfcDateTime(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC4X3.IfcDateTime(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC4X3.IfcDuration(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC4X3.IfcDuration(!v[12] && v[12] != "" ? null : v[12].value), !v[13] && v[13] != "" ? null : new IFC4X3.IfcBoolean(!v[13] && v[13] != "" ? null : v[13].value), !v[14] && v[14] != "" ? null : new IFC4X3.IfcDateTime(!v[14] && v[14] != "" ? null : v[14].value), !v[15] && v[15] != "" ? null : new IFC4X3.IfcDuration(!v[15] && v[15] != "" ? null : v[15].value), !v[16] && v[16] != "" ? null : new IFC4X3.IfcDateTime(!v[16] && v[16] != "" ? null : v[16].value), !v[17] && v[17] != "" ? null : new IFC4X3.IfcDateTime(!v[17] && v[17] != "" ? null : v[17].value), !v[18] && v[18] != "" ? null : new IFC4X3.IfcDuration(!v[18] && v[18] != "" ? null : v[18].value), !v[19] && v[19] != "" ? null : new IFC4X3.IfcPositiveRatioMeasure(!v[19] && v[19] != "" ? null : v[19].value)),
  2771591690: (v) => new IFC4X3.IfcTaskTimeRecurring(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), v[1], !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), v[3], !v[4] && v[4] != "" ? null : new IFC4X3.IfcDuration(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcDateTime(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcDateTime(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcDateTime(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcDateTime(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4X3.IfcDateTime(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC4X3.IfcDateTime(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC4X3.IfcDuration(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC4X3.IfcDuration(!v[12] && v[12] != "" ? null : v[12].value), !v[13] && v[13] != "" ? null : new IFC4X3.IfcBoolean(!v[13] && v[13] != "" ? null : v[13].value), !v[14] && v[14] != "" ? null : new IFC4X3.IfcDateTime(!v[14] && v[14] != "" ? null : v[14].value), !v[15] && v[15] != "" ? null : new IFC4X3.IfcDuration(!v[15] && v[15] != "" ? null : v[15].value), !v[16] && v[16] != "" ? null : new IFC4X3.IfcDateTime(!v[16] && v[16] != "" ? null : v[16].value), !v[17] && v[17] != "" ? null : new IFC4X3.IfcDateTime(!v[17] && v[17] != "" ? null : v[17].value), !v[18] && v[18] != "" ? null : new IFC4X3.IfcDuration(!v[18] && v[18] != "" ? null : v[18].value), !v[19] && v[19] != "" ? null : new IFC4X3.IfcPositiveRatioMeasure(!v[19] && v[19] != "" ? null : v[19].value), new Handle(!v[20] && v[20] != "" ? null : v[20].value)),
  912023232: (v) => new IFC4X3.IfcTelecomAddress(v[0], !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : v[3]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcLabel(p.value) : null) || [], !v[4] && v[4] != "" ? null : v[4]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcLabel(p.value) : null) || [], !v[5] && v[5] != "" ? null : new IFC4X3.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcLabel(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcURIReference(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : v[8]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcURIReference(p.value) : null) || []),
  1447204868: (v) => new IFC4X3.IfcTextStyle(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcBoolean(!v[4] && v[4] != "" ? null : v[4].value)),
  2636378356: (v) => new IFC4X3.IfcTextStyleForDefinedFont(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  1640371178: (v) => new IFC4X3.IfcTextStyleTextModel(!v[0] && v[0] != "" ? null : TypeInitialiser(3, v[0]), !v[1] && v[1] != "" ? null : new IFC4X3.IfcTextAlignment(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcTextDecoration(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : TypeInitialiser(3, v[3]), !v[4] && v[4] != "" ? null : TypeInitialiser(3, v[4]), !v[5] && v[5] != "" ? null : new IFC4X3.IfcTextTransformation(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : TypeInitialiser(3, v[6])),
  280115917: (v) => new IFC4X3.IfcTextureCoordinate(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1742049831: (v) => new IFC4X3.IfcTextureCoordinateGenerator(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : v[2]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcReal(p.value) : null) || []),
  222769930: (v) => new IFC4X3.IfcTextureCoordinateIndices(v[0]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcPositiveInteger(p.value) : null) || [], new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  1010789467: (v) => new IFC4X3.IfcTextureCoordinateIndicesWithVoids(v[0]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcPositiveInteger(p.value) : null) || [], new Handle(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.map((p2) => p2?.value && p2?.value != "" ? new IFC4X3.IfcPositiveInteger(p2.value) : null) || [])),
  2552916305: (v) => new IFC4X3.IfcTextureMap(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  1210645708: (v) => new IFC4X3.IfcTextureVertex(v[0]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcParameterValue(p.value) : null) || []),
  3611470254: (v) => new IFC4X3.IfcTextureVertexList(v[0]?.map((p) => p?.map((p2) => p2?.value && p2?.value != "" ? new IFC4X3.IfcParameterValue(p2.value) : null) || [])),
  1199560280: (v) => new IFC4X3.IfcTimePeriod(new IFC4X3.IfcTime(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcTime(!v[1] && v[1] != "" ? null : v[1].value)),
  3101149627: (v) => new IFC4X3.IfcTimeSeries(new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), new IFC4X3.IfcDateTime(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcDateTime(!v[3] && v[3] != "" ? null : v[3].value), v[4], v[5], !v[6] && v[6] != "" ? null : new IFC4X3.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value)),
  581633288: (v) => new IFC4X3.IfcTimeSeriesValue(v[0]?.map((p) => p?.value && p?.value != "" ? TypeInitialiser(3, p) : null) || []),
  1377556343: (_) => new IFC4X3.IfcTopologicalRepresentationItem(),
  1735638870: (v) => new IFC4X3.IfcTopologyRepresentation(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  180925521: (v) => new IFC4X3.IfcUnitAssignment(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2799835756: (_) => new IFC4X3.IfcVertex(),
  1907098498: (v) => new IFC4X3.IfcVertexPoint(new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  891718957: (v) => new IFC4X3.IfcVirtualGridIntersection(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[1]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcLengthMeasure(p.value) : null) || []),
  1236880293: (v) => new IFC4X3.IfcWorkTime(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), v[1], !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcDate(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcDate(!v[5] && v[5] != "" ? null : v[5].value)),
  3752311538: (v) => new IFC4X3.IfcAlignmentCantSegment(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new IFC4X3.IfcLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcNonNegativeLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC4X3.IfcLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), new IFC4X3.IfcLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  536804194: (v) => new IFC4X3.IfcAlignmentHorizontalSegment(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcPlaneAngleMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC4X3.IfcLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), new IFC4X3.IfcLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), new IFC4X3.IfcNonNegativeLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3869604511: (v) => new IFC4X3.IfcApprovalRelationship(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3798115385: (v) => new IFC4X3.IfcArbitraryClosedProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  1310608509: (v) => new IFC4X3.IfcArbitraryOpenProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  2705031697: (v) => new IFC4X3.IfcArbitraryProfileDefWithVoids(v[0], !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  616511568: (v) => new IFC4X3.IfcBlobTexture(new IFC4X3.IfcBoolean(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcBoolean(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcIdentifier(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : v[4]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcIdentifier(p.value) : null) || [], new IFC4X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), new IFC4X3.IfcBinary(!v[6] && v[6] != "" ? null : v[6].value)),
  3150382593: (v) => new IFC4X3.IfcCenterLineProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  747523909: (v) => new IFC4X3.IfcClassification(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcDate(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcLabel(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcText(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcURIReference(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcIdentifier(p.value) : null) || []),
  647927063: (v) => new IFC4X3.IfcClassificationReference(!v[0] && v[0] != "" ? null : new IFC4X3.IfcURIReference(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcIdentifier(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcText(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value)),
  3285139300: (v) => new IFC4X3.IfcColourRgbList(v[0]?.map((p) => p?.map((p2) => p2?.value && p2?.value != "" ? new IFC4X3.IfcNormalisedRatioMeasure(p2.value) : null) || [])),
  3264961684: (v) => new IFC4X3.IfcColourSpecification(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  1485152156: (v) => new IFC4X3.IfcCompositeProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[3] && v[3] != "" ? null : new IFC4X3.IfcLabel(!v[3] && v[3] != "" ? null : v[3].value)),
  370225590: (v) => new IFC4X3.IfcConnectedFaceSet(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1981873012: (v) => new IFC4X3.IfcConnectionCurveGeometry(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  45288368: (v) => new IFC4X3.IfcConnectionPointEccentricity(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value)),
  3050246964: (v) => new IFC4X3.IfcContextDependentUnit(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1], new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  2889183280: (v) => new IFC4X3.IfcConversionBasedUnit(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1], new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  2713554722: (v) => new IFC4X3.IfcConversionBasedUnitWithOffset(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1], new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), new Handle(!v[3] && v[3] != "" ? null : v[3].value), new IFC4X3.IfcReal(!v[4] && v[4] != "" ? null : v[4].value)),
  539742890: (v) => new IFC4X3.IfcCurrencyRelationship(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new Handle(!v[3] && v[3] != "" ? null : v[3].value), new IFC4X3.IfcPositiveRatioMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcDateTime(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  3800577675: (v) => new IFC4X3.IfcCurveStyle(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : TypeInitialiser(3, v[2]), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcBoolean(!v[4] && v[4] != "" ? null : v[4].value)),
  1105321065: (v) => new IFC4X3.IfcCurveStyleFont(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2367409068: (v) => new IFC4X3.IfcCurveStyleFontAndScaling(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), new IFC4X3.IfcPositiveRatioMeasure(!v[2] && v[2] != "" ? null : v[2].value)),
  3510044353: (v) => new IFC4X3.IfcCurveStyleFontPattern(new IFC4X3.IfcLengthMeasure(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value)),
  3632507154: (v) => new IFC4X3.IfcDerivedProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  1154170062: (v) => new IFC4X3.IfcDocumentInformation(new IFC4X3.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcText(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcURIReference(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcText(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcText(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcText(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new Handle(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : v[9]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[10] && v[10] != "" ? null : new IFC4X3.IfcDateTime(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC4X3.IfcDateTime(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC4X3.IfcIdentifier(!v[12] && v[12] != "" ? null : v[12].value), !v[13] && v[13] != "" ? null : new IFC4X3.IfcDate(!v[13] && v[13] != "" ? null : v[13].value), !v[14] && v[14] != "" ? null : new IFC4X3.IfcDate(!v[14] && v[14] != "" ? null : v[14].value), v[15], v[16]),
  770865208: (v) => new IFC4X3.IfcDocumentInformationRelationship(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  3732053477: (v) => new IFC4X3.IfcDocumentReference(!v[0] && v[0] != "" ? null : new IFC4X3.IfcURIReference(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcIdentifier(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value)),
  3900360178: (v) => new IFC4X3.IfcEdge(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  476780140: (v) => new IFC4X3.IfcEdgeCurve(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcBoolean(!v[3] && v[3] != "" ? null : v[3].value)),
  211053100: (v) => new IFC4X3.IfcEventTime(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), v[1], !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcDateTime(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcDateTime(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcDateTime(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcDateTime(!v[6] && v[6] != "" ? null : v[6].value)),
  297599258: (v) => new IFC4X3.IfcExtendedProperties(!v[0] && v[0] != "" ? null : new IFC4X3.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1437805879: (v) => new IFC4X3.IfcExternalReferenceRelationship(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2556980723: (v) => new IFC4X3.IfcFace(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1809719519: (v) => new IFC4X3.IfcFaceBound(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcBoolean(!v[1] && v[1] != "" ? null : v[1].value)),
  803316827: (v) => new IFC4X3.IfcFaceOuterBound(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcBoolean(!v[1] && v[1] != "" ? null : v[1].value)),
  3008276851: (v) => new IFC4X3.IfcFaceSurface(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[1] && v[1] != "" ? null : v[1].value), new IFC4X3.IfcBoolean(!v[2] && v[2] != "" ? null : v[2].value)),
  4219587988: (v) => new IFC4X3.IfcFailureConnectionCondition(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcForceMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcForceMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcForceMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcForceMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcForceMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcForceMeasure(!v[6] && v[6] != "" ? null : v[6].value)),
  738692330: (v) => new IFC4X3.IfcFillAreaStyle(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[2] && v[2] != "" ? null : new IFC4X3.IfcBoolean(!v[2] && v[2] != "" ? null : v[2].value)),
  3448662350: (v) => new IFC4X3.IfcGeometricRepresentationContext(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new IFC4X3.IfcDimensionCount(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcReal(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  2453401579: (_) => new IFC4X3.IfcGeometricRepresentationItem(),
  4142052618: (v) => new IFC4X3.IfcGeometricRepresentationSubContext(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcPositiveRatioMeasure(!v[3] && v[3] != "" ? null : v[3].value), v[4], !v[5] && v[5] != "" ? null : new IFC4X3.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value)),
  3590301190: (v) => new IFC4X3.IfcGeometricSet(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  178086475: (v) => new IFC4X3.IfcGridPlacement(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  812098782: (v) => new IFC4X3.IfcHalfSpaceSolid(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcBoolean(!v[1] && v[1] != "" ? null : v[1].value)),
  3905492369: (v) => new IFC4X3.IfcImageTexture(new IFC4X3.IfcBoolean(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcBoolean(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcIdentifier(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : v[4]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcIdentifier(p.value) : null) || [], new IFC4X3.IfcURIReference(!v[5] && v[5] != "" ? null : v[5].value)),
  3570813810: (v) => new IFC4X3.IfcIndexedColourMap(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcNormalisedRatioMeasure(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcPositiveInteger(p.value) : null) || []),
  1437953363: (v) => new IFC4X3.IfcIndexedTextureMap(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  2133299955: (v) => new IFC4X3.IfcIndexedTriangleTextureMap(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : v[3]?.map((p) => p?.map((p2) => p2?.value && p2?.value != "" ? new IFC4X3.IfcPositiveInteger(p2.value) : null) || [])),
  3741457305: (v) => new IFC4X3.IfcIrregularTimeSeries(new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), new IFC4X3.IfcDateTime(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcDateTime(!v[3] && v[3] != "" ? null : v[3].value), v[4], v[5], !v[6] && v[6] != "" ? null : new IFC4X3.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), v[8]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1585845231: (v) => new IFC4X3.IfcLagTime(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), v[1], !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), TypeInitialiser(3, v[3]), v[4]),
  1402838566: (v) => new IFC4X3.IfcLightSource(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcNormalisedRatioMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcNormalisedRatioMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  125510826: (v) => new IFC4X3.IfcLightSourceAmbient(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcNormalisedRatioMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcNormalisedRatioMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  2604431987: (v) => new IFC4X3.IfcLightSourceDirectional(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcNormalisedRatioMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcNormalisedRatioMeasure(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value)),
  4266656042: (v) => new IFC4X3.IfcLightSourceGoniometric(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcNormalisedRatioMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcNormalisedRatioMeasure(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), new IFC4X3.IfcThermodynamicTemperatureMeasure(!v[6] && v[6] != "" ? null : v[6].value), new IFC4X3.IfcLuminousFluxMeasure(!v[7] && v[7] != "" ? null : v[7].value), v[8], new Handle(!v[9] && v[9] != "" ? null : v[9].value)),
  1520743889: (v) => new IFC4X3.IfcLightSourcePositional(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcNormalisedRatioMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcNormalisedRatioMeasure(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new IFC4X3.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), new IFC4X3.IfcReal(!v[6] && v[6] != "" ? null : v[6].value), new IFC4X3.IfcReal(!v[7] && v[7] != "" ? null : v[7].value), new IFC4X3.IfcReal(!v[8] && v[8] != "" ? null : v[8].value)),
  3422422726: (v) => new IFC4X3.IfcLightSourceSpot(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcNormalisedRatioMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcNormalisedRatioMeasure(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new IFC4X3.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), new IFC4X3.IfcReal(!v[6] && v[6] != "" ? null : v[6].value), new IFC4X3.IfcReal(!v[7] && v[7] != "" ? null : v[7].value), new IFC4X3.IfcReal(!v[8] && v[8] != "" ? null : v[8].value), new Handle(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC4X3.IfcReal(!v[10] && v[10] != "" ? null : v[10].value), new IFC4X3.IfcPositivePlaneAngleMeasure(!v[11] && v[11] != "" ? null : v[11].value), new IFC4X3.IfcPositivePlaneAngleMeasure(!v[12] && v[12] != "" ? null : v[12].value)),
  388784114: (v) => new IFC4X3.IfcLinearPlacement(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  2624227202: (v) => new IFC4X3.IfcLocalPlacement(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  1008929658: (_) => new IFC4X3.IfcLoop(),
  2347385850: (v) => new IFC4X3.IfcMappedItem(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  1838606355: (v) => new IFC4X3.IfcMaterial(new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  3708119e3: (v) => new IFC4X3.IfcMaterialConstituent(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcNormalisedRatioMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  2852063980: (v) => new IFC4X3.IfcMaterialConstituentSet(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2022407955: (v) => new IFC4X3.IfcMaterialDefinitionRepresentation(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  1303795690: (v) => new IFC4X3.IfcMaterialLayerSetUsage(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1], v[2], new IFC4X3.IfcLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value)),
  3079605661: (v) => new IFC4X3.IfcMaterialProfileSetUsage(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcCardinalPointReference(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value)),
  3404854881: (v) => new IFC4X3.IfcMaterialProfileSetUsageTapering(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcCardinalPointReference(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcCardinalPointReference(!v[4] && v[4] != "" ? null : v[4].value)),
  3265635763: (v) => new IFC4X3.IfcMaterialProperties(!v[0] && v[0] != "" ? null : new IFC4X3.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  853536259: (v) => new IFC4X3.IfcMaterialRelationship(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  2998442950: (v) => new IFC4X3.IfcMirroredProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcLabel(!v[3] && v[3] != "" ? null : v[3].value)),
  219451334: (v) => new IFC4X3.IfcObjectDefinition(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value)),
  182550632: (v) => new IFC4X3.IfcOpenCrossProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), new IFC4X3.IfcBoolean(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcNonNegativeLengthMeasure(p.value) : null) || [], v[4]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcPlaneAngleMeasure(p.value) : null) || [], !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcLabel(p.value) : null) || [], !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  2665983363: (v) => new IFC4X3.IfcOpenShell(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1411181986: (v) => new IFC4X3.IfcOrganizationRelationship(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1029017970: (v) => new IFC4X3.IfcOrientedEdge(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcBoolean(!v[1] && v[1] != "" ? null : v[1].value)),
  2529465313: (v) => new IFC4X3.IfcParameterizedProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  2519244187: (v) => new IFC4X3.IfcPath(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3021840470: (v) => new IFC4X3.IfcPhysicalComplexQuantity(new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new IFC4X3.IfcLabel(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value)),
  597895409: (v) => new IFC4X3.IfcPixelTexture(new IFC4X3.IfcBoolean(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcBoolean(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcIdentifier(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : v[4]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcIdentifier(p.value) : null) || [], new IFC4X3.IfcInteger(!v[5] && v[5] != "" ? null : v[5].value), new IFC4X3.IfcInteger(!v[6] && v[6] != "" ? null : v[6].value), new IFC4X3.IfcInteger(!v[7] && v[7] != "" ? null : v[7].value), v[8]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcBinary(p.value) : null) || []),
  2004835150: (v) => new IFC4X3.IfcPlacement(new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  1663979128: (v) => new IFC4X3.IfcPlanarExtent(new IFC4X3.IfcLengthMeasure(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value)),
  2067069095: (_) => new IFC4X3.IfcPoint(),
  2165702409: (v) => new IFC4X3.IfcPointByDistanceExpression(TypeInitialiser(3, v[0]), !v[1] && v[1] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value)),
  4022376103: (v) => new IFC4X3.IfcPointOnCurve(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcParameterValue(!v[1] && v[1] != "" ? null : v[1].value)),
  1423911732: (v) => new IFC4X3.IfcPointOnSurface(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcParameterValue(!v[1] && v[1] != "" ? null : v[1].value), new IFC4X3.IfcParameterValue(!v[2] && v[2] != "" ? null : v[2].value)),
  2924175390: (v) => new IFC4X3.IfcPolyLoop(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2775532180: (v) => new IFC4X3.IfcPolygonalBoundedHalfSpace(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcBoolean(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  3727388367: (v) => new IFC4X3.IfcPreDefinedItem(new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  3778827333: (_) => new IFC4X3.IfcPreDefinedProperties(),
  1775413392: (v) => new IFC4X3.IfcPreDefinedTextFont(new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  673634403: (v) => new IFC4X3.IfcProductDefinitionShape(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2802850158: (v) => new IFC4X3.IfcProfileProperties(!v[0] && v[0] != "" ? null : new IFC4X3.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  2598011224: (v) => new IFC4X3.IfcProperty(new IFC4X3.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value)),
  1680319473: (v) => new IFC4X3.IfcPropertyDefinition(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value)),
  148025276: (v) => new IFC4X3.IfcPropertyDependencyRelationship(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcText(!v[4] && v[4] != "" ? null : v[4].value)),
  3357820518: (v) => new IFC4X3.IfcPropertySetDefinition(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value)),
  1482703590: (v) => new IFC4X3.IfcPropertyTemplateDefinition(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value)),
  2090586900: (v) => new IFC4X3.IfcQuantitySet(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value)),
  3615266464: (v) => new IFC4X3.IfcRectangleProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC4X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value)),
  3413951693: (v) => new IFC4X3.IfcRegularTimeSeries(new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), new IFC4X3.IfcDateTime(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcDateTime(!v[3] && v[3] != "" ? null : v[3].value), v[4], v[5], !v[6] && v[6] != "" ? null : new IFC4X3.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), new IFC4X3.IfcTimeMeasure(!v[8] && v[8] != "" ? null : v[8].value), v[9]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1580146022: (v) => new IFC4X3.IfcReinforcementBarProperties(new IFC4X3.IfcAreaMeasure(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), v[2], !v[3] && v[3] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcCountMeasure(!v[5] && v[5] != "" ? null : v[5].value)),
  478536968: (v) => new IFC4X3.IfcRelationship(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value)),
  2943643501: (v) => new IFC4X3.IfcResourceApprovalRelationship(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  1608871552: (v) => new IFC4X3.IfcResourceConstraintRelationship(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1042787934: (v) => new IFC4X3.IfcResourceTime(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), v[1], !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcDuration(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcPositiveRatioMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcDateTime(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcDateTime(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcDuration(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4X3.IfcBoolean(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC4X3.IfcDateTime(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC4X3.IfcDuration(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC4X3.IfcPositiveRatioMeasure(!v[12] && v[12] != "" ? null : v[12].value), !v[13] && v[13] != "" ? null : new IFC4X3.IfcDateTime(!v[13] && v[13] != "" ? null : v[13].value), !v[14] && v[14] != "" ? null : new IFC4X3.IfcDateTime(!v[14] && v[14] != "" ? null : v[14].value), !v[15] && v[15] != "" ? null : new IFC4X3.IfcDuration(!v[15] && v[15] != "" ? null : v[15].value), !v[16] && v[16] != "" ? null : new IFC4X3.IfcPositiveRatioMeasure(!v[16] && v[16] != "" ? null : v[16].value), !v[17] && v[17] != "" ? null : new IFC4X3.IfcPositiveRatioMeasure(!v[17] && v[17] != "" ? null : v[17].value)),
  2778083089: (v) => new IFC4X3.IfcRoundedRectangleProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC4X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), new IFC4X3.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value)),
  2042790032: (v) => new IFC4X3.IfcSectionProperties(v[0], new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  4165799628: (v) => new IFC4X3.IfcSectionReinforcementProperties(new IFC4X3.IfcLengthMeasure(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), v[3], new Handle(!v[4] && v[4] != "" ? null : v[4].value), v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1509187699: (v) => new IFC4X3.IfcSectionedSpine(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  823603102: (v) => new IFC4X3.IfcSegment(v[0]),
  4124623270: (v) => new IFC4X3.IfcShellBasedSurfaceModel(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3692461612: (v) => new IFC4X3.IfcSimpleProperty(new IFC4X3.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value)),
  2609359061: (v) => new IFC4X3.IfcSlippageConnectionCondition(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  723233188: (_) => new IFC4X3.IfcSolidModel(),
  1595516126: (v) => new IFC4X3.IfcStructuralLoadLinearForce(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcLinearForceMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLinearForceMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcLinearForceMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLinearMomentMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcLinearMomentMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcLinearMomentMeasure(!v[6] && v[6] != "" ? null : v[6].value)),
  2668620305: (v) => new IFC4X3.IfcStructuralLoadPlanarForce(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcPlanarForceMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcPlanarForceMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcPlanarForceMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  2473145415: (v) => new IFC4X3.IfcStructuralLoadSingleDisplacement(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcPlaneAngleMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcPlaneAngleMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcPlaneAngleMeasure(!v[6] && v[6] != "" ? null : v[6].value)),
  1973038258: (v) => new IFC4X3.IfcStructuralLoadSingleDisplacementDistortion(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcPlaneAngleMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcPlaneAngleMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcPlaneAngleMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcCurvatureMeasure(!v[7] && v[7] != "" ? null : v[7].value)),
  1597423693: (v) => new IFC4X3.IfcStructuralLoadSingleForce(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcForceMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcForceMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcForceMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcTorqueMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcTorqueMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcTorqueMeasure(!v[6] && v[6] != "" ? null : v[6].value)),
  1190533807: (v) => new IFC4X3.IfcStructuralLoadSingleForceWarping(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcForceMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcForceMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcForceMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcTorqueMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcTorqueMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcTorqueMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcWarpingMomentMeasure(!v[7] && v[7] != "" ? null : v[7].value)),
  2233826070: (v) => new IFC4X3.IfcSubedge(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  2513912981: (_) => new IFC4X3.IfcSurface(),
  1878645084: (v) => new IFC4X3.IfcSurfaceStyleRendering(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcNormalisedRatioMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : TypeInitialiser(3, v[7]), v[8]),
  2247615214: (v) => new IFC4X3.IfcSweptAreaSolid(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  1260650574: (v) => new IFC4X3.IfcSweptDiskSolid(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcParameterValue(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcParameterValue(!v[4] && v[4] != "" ? null : v[4].value)),
  1096409881: (v) => new IFC4X3.IfcSweptDiskSolidPolygonal(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcParameterValue(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcParameterValue(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcNonNegativeLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value)),
  230924584: (v) => new IFC4X3.IfcSweptSurface(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  3071757647: (v) => new IFC4X3.IfcTShapeProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC4X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), new IFC4X3.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), new IFC4X3.IfcPositiveLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcNonNegativeLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcNonNegativeLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4X3.IfcNonNegativeLengthMeasure(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC4X3.IfcPlaneAngleMeasure(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC4X3.IfcPlaneAngleMeasure(!v[11] && v[11] != "" ? null : v[11].value)),
  901063453: (_) => new IFC4X3.IfcTessellatedItem(),
  4282788508: (v) => new IFC4X3.IfcTextLiteral(new IFC4X3.IfcPresentableText(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), v[2]),
  3124975700: (v) => new IFC4X3.IfcTextLiteralWithExtent(new IFC4X3.IfcPresentableText(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), v[2], new Handle(!v[3] && v[3] != "" ? null : v[3].value), new IFC4X3.IfcBoxAlignment(!v[4] && v[4] != "" ? null : v[4].value)),
  1983826977: (v) => new IFC4X3.IfcTextStyleFontModel(new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcTextFontName(p.value) : null) || [], !v[2] && v[2] != "" ? null : new IFC4X3.IfcFontStyle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcFontVariant(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcFontWeight(!v[4] && v[4] != "" ? null : v[4].value), TypeInitialiser(3, v[5])),
  2715220739: (v) => new IFC4X3.IfcTrapeziumProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC4X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), new IFC4X3.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), new IFC4X3.IfcLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value)),
  1628702193: (v) => new IFC4X3.IfcTypeObject(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3736923433: (v) => new IFC4X3.IfcTypeProcess(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : new IFC4X3.IfcIdentifier(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcText(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  2347495698: (v) => new IFC4X3.IfcTypeProduct(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value)),
  3698973494: (v) => new IFC4X3.IfcTypeResource(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : new IFC4X3.IfcIdentifier(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcText(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  427810014: (v) => new IFC4X3.IfcUShapeProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC4X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), new IFC4X3.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), new IFC4X3.IfcPositiveLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcNonNegativeLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcNonNegativeLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4X3.IfcPlaneAngleMeasure(!v[9] && v[9] != "" ? null : v[9].value)),
  1417489154: (v) => new IFC4X3.IfcVector(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value)),
  2759199220: (v) => new IFC4X3.IfcVertexLoop(new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  2543172580: (v) => new IFC4X3.IfcZShapeProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC4X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), new IFC4X3.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), new IFC4X3.IfcPositiveLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcNonNegativeLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcNonNegativeLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value)),
  3406155212: (v) => new IFC4X3.IfcAdvancedFace(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[1] && v[1] != "" ? null : v[1].value), new IFC4X3.IfcBoolean(!v[2] && v[2] != "" ? null : v[2].value)),
  669184980: (v) => new IFC4X3.IfcAnnotationFillArea(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3207858831: (v) => new IFC4X3.IfcAsymmetricIShapeProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC4X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), new IFC4X3.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), new IFC4X3.IfcPositiveLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcNonNegativeLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value), new IFC4X3.IfcPositiveLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC4X3.IfcNonNegativeLengthMeasure(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC4X3.IfcNonNegativeLengthMeasure(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC4X3.IfcPlaneAngleMeasure(!v[12] && v[12] != "" ? null : v[12].value), !v[13] && v[13] != "" ? null : new IFC4X3.IfcNonNegativeLengthMeasure(!v[13] && v[13] != "" ? null : v[13].value), !v[14] && v[14] != "" ? null : new IFC4X3.IfcPlaneAngleMeasure(!v[14] && v[14] != "" ? null : v[14].value)),
  4261334040: (v) => new IFC4X3.IfcAxis1Placement(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  3125803723: (v) => new IFC4X3.IfcAxis2Placement2D(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  2740243338: (v) => new IFC4X3.IfcAxis2Placement3D(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  3425423356: (v) => new IFC4X3.IfcAxis2PlacementLinear(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  2736907675: (v) => new IFC4X3.IfcBooleanResult(v[0], new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  4182860854: (_) => new IFC4X3.IfcBoundedSurface(),
  2581212453: (v) => new IFC4X3.IfcBoundingBox(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), new IFC4X3.IfcPositiveLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  2713105998: (v) => new IFC4X3.IfcBoxedHalfSpace(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcBoolean(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  2898889636: (v) => new IFC4X3.IfcCShapeProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC4X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), new IFC4X3.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), new IFC4X3.IfcPositiveLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcNonNegativeLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value)),
  1123145078: (v) => new IFC4X3.IfcCartesianPoint(v[0]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcLengthMeasure(p.value) : null) || []),
  574549367: (_) => new IFC4X3.IfcCartesianPointList(),
  1675464909: (v) => new IFC4X3.IfcCartesianPointList2D(v[0]?.map((p) => p?.map((p2) => p2?.value && p2?.value != "" ? new IFC4X3.IfcLengthMeasure(p2.value) : null) || []), !v[1] && v[1] != "" ? null : v[1]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcLabel(p.value) : null) || []),
  2059837836: (v) => new IFC4X3.IfcCartesianPointList3D(v[0]?.map((p) => p?.map((p2) => p2?.value && p2?.value != "" ? new IFC4X3.IfcLengthMeasure(p2.value) : null) || []), !v[1] && v[1] != "" ? null : v[1]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcLabel(p.value) : null) || []),
  59481748: (v) => new IFC4X3.IfcCartesianTransformationOperator(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcReal(!v[3] && v[3] != "" ? null : v[3].value)),
  3749851601: (v) => new IFC4X3.IfcCartesianTransformationOperator2D(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcReal(!v[3] && v[3] != "" ? null : v[3].value)),
  3486308946: (v) => new IFC4X3.IfcCartesianTransformationOperator2DnonUniform(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcReal(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcReal(!v[4] && v[4] != "" ? null : v[4].value)),
  3331915920: (v) => new IFC4X3.IfcCartesianTransformationOperator3D(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcReal(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value)),
  1416205885: (v) => new IFC4X3.IfcCartesianTransformationOperator3DnonUniform(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcReal(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcReal(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcReal(!v[6] && v[6] != "" ? null : v[6].value)),
  1383045692: (v) => new IFC4X3.IfcCircleProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  2205249479: (v) => new IFC4X3.IfcClosedShell(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  776857604: (v) => new IFC4X3.IfcColourRgb(!v[0] && v[0] != "" ? null : new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcNormalisedRatioMeasure(!v[1] && v[1] != "" ? null : v[1].value), new IFC4X3.IfcNormalisedRatioMeasure(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcNormalisedRatioMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  2542286263: (v) => new IFC4X3.IfcComplexProperty(new IFC4X3.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), new IFC4X3.IfcIdentifier(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2485617015: (v) => new IFC4X3.IfcCompositeCurveSegment(v[0], new IFC4X3.IfcBoolean(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  2574617495: (v) => new IFC4X3.IfcConstructionResourceType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : new IFC4X3.IfcIdentifier(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcText(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : v[9]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[10] && v[10] != "" ? null : new Handle(!v[10] && v[10] != "" ? null : v[10].value)),
  3419103109: (v) => new IFC4X3.IfcContext(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[8] && v[8] != "" ? null : new Handle(!v[8] && v[8] != "" ? null : v[8].value)),
  1815067380: (v) => new IFC4X3.IfcCrewResourceType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : new IFC4X3.IfcIdentifier(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcText(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : v[9]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[10] && v[10] != "" ? null : new Handle(!v[10] && v[10] != "" ? null : v[10].value), v[11]),
  2506170314: (v) => new IFC4X3.IfcCsgPrimitive3D(new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  2147822146: (v) => new IFC4X3.IfcCsgSolid(new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  2601014836: (_) => new IFC4X3.IfcCurve(),
  2827736869: (v) => new IFC4X3.IfcCurveBoundedPlane(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2629017746: (v) => new IFC4X3.IfcCurveBoundedSurface(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new IFC4X3.IfcBoolean(!v[2] && v[2] != "" ? null : v[2].value)),
  4212018352: (v) => new IFC4X3.IfcCurveSegment(v[0], new Handle(!v[1] && v[1] != "" ? null : v[1].value), TypeInitialiser(3, v[2]), TypeInitialiser(3, v[3]), new Handle(!v[4] && v[4] != "" ? null : v[4].value)),
  32440307: (v) => new IFC4X3.IfcDirection(v[0]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcReal(p.value) : null) || []),
  593015953: (v) => new IFC4X3.IfcDirectrixCurveSweptAreaSolid(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : TypeInitialiser(3, v[3]), !v[4] && v[4] != "" ? null : TypeInitialiser(3, v[4])),
  1472233963: (v) => new IFC4X3.IfcEdgeLoop(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1883228015: (v) => new IFC4X3.IfcElementQuantity(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  339256511: (v) => new IFC4X3.IfcElementType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  2777663545: (v) => new IFC4X3.IfcElementarySurface(new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  2835456948: (v) => new IFC4X3.IfcEllipseProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC4X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value)),
  4024345920: (v) => new IFC4X3.IfcEventType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : new IFC4X3.IfcIdentifier(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcText(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9], v[10], !v[11] && v[11] != "" ? null : new IFC4X3.IfcLabel(!v[11] && v[11] != "" ? null : v[11].value)),
  477187591: (v) => new IFC4X3.IfcExtrudedAreaSolid(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  2804161546: (v) => new IFC4X3.IfcExtrudedAreaSolidTapered(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value)),
  2047409740: (v) => new IFC4X3.IfcFaceBasedSurfaceModel(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  374418227: (v) => new IFC4X3.IfcFillAreaStyleHatching(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value), new IFC4X3.IfcPlaneAngleMeasure(!v[4] && v[4] != "" ? null : v[4].value)),
  315944413: (v) => new IFC4X3.IfcFillAreaStyleTiles(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new IFC4X3.IfcPositiveRatioMeasure(!v[2] && v[2] != "" ? null : v[2].value)),
  2652556860: (v) => new IFC4X3.IfcFixedReferenceSweptAreaSolid(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : TypeInitialiser(3, v[3]), !v[4] && v[4] != "" ? null : TypeInitialiser(3, v[4]), new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  4238390223: (v) => new IFC4X3.IfcFurnishingElementType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  1268542332: (v) => new IFC4X3.IfcFurnitureType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9], v[10]),
  4095422895: (v) => new IFC4X3.IfcGeographicElementType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  987898635: (v) => new IFC4X3.IfcGeometricCurveSet(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1484403080: (v) => new IFC4X3.IfcIShapeProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC4X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), new IFC4X3.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), new IFC4X3.IfcPositiveLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcNonNegativeLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcNonNegativeLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4X3.IfcPlaneAngleMeasure(!v[9] && v[9] != "" ? null : v[9].value)),
  178912537: (v) => new IFC4X3.IfcIndexedPolygonalFace(v[0]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcPositiveInteger(p.value) : null) || []),
  2294589976: (v) => new IFC4X3.IfcIndexedPolygonalFaceWithVoids(v[0]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcPositiveInteger(p.value) : null) || [], v[1]?.map((p) => p?.map((p2) => p2?.value && p2?.value != "" ? new IFC4X3.IfcPositiveInteger(p2.value) : null) || [])),
  3465909080: (v) => new IFC4X3.IfcIndexedPolygonalTextureMap(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), v[3]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  572779678: (v) => new IFC4X3.IfcLShapeProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), new IFC4X3.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcNonNegativeLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcNonNegativeLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcPlaneAngleMeasure(!v[8] && v[8] != "" ? null : v[8].value)),
  428585644: (v) => new IFC4X3.IfcLaborResourceType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : new IFC4X3.IfcIdentifier(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcText(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : v[9]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[10] && v[10] != "" ? null : new Handle(!v[10] && v[10] != "" ? null : v[10].value), v[11]),
  1281925730: (v) => new IFC4X3.IfcLine(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  1425443689: (v) => new IFC4X3.IfcManifoldSolidBrep(new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  3888040117: (v) => new IFC4X3.IfcObject(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  590820931: (v) => new IFC4X3.IfcOffsetCurve(new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  3388369263: (v) => new IFC4X3.IfcOffsetCurve2D(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), new IFC4X3.IfcLogical(!v[2] && v[2] != "" ? null : v[2].value)),
  3505215534: (v) => new IFC4X3.IfcOffsetCurve3D(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), new IFC4X3.IfcLogical(!v[2] && v[2] != "" ? null : v[2].value), new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  2485787929: (v) => new IFC4X3.IfcOffsetCurveByDistances(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value)),
  1682466193: (v) => new IFC4X3.IfcPcurve(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new Handle(!v[1] && v[1] != "" ? null : v[1].value)),
  603570806: (v) => new IFC4X3.IfcPlanarBox(new IFC4X3.IfcLengthMeasure(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  220341763: (v) => new IFC4X3.IfcPlane(new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  3381221214: (v) => new IFC4X3.IfcPolynomialCurve(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : v[1]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcReal(p.value) : null) || [], !v[2] && v[2] != "" ? null : v[2]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcReal(p.value) : null) || [], !v[3] && v[3] != "" ? null : v[3]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcReal(p.value) : null) || []),
  759155922: (v) => new IFC4X3.IfcPreDefinedColour(new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  2559016684: (v) => new IFC4X3.IfcPreDefinedCurveFont(new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  3967405729: (v) => new IFC4X3.IfcPreDefinedPropertySet(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value)),
  569719735: (v) => new IFC4X3.IfcProcedureType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : new IFC4X3.IfcIdentifier(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcText(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2945172077: (v) => new IFC4X3.IfcProcess(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcText(!v[6] && v[6] != "" ? null : v[6].value)),
  4208778838: (v) => new IFC4X3.IfcProduct(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  103090709: (v) => new IFC4X3.IfcProject(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[8] && v[8] != "" ? null : new Handle(!v[8] && v[8] != "" ? null : v[8].value)),
  653396225: (v) => new IFC4X3.IfcProjectLibrary(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[8] && v[8] != "" ? null : new Handle(!v[8] && v[8] != "" ? null : v[8].value)),
  871118103: (v) => new IFC4X3.IfcPropertyBoundedValue(new IFC4X3.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : TypeInitialiser(3, v[2]), !v[3] && v[3] != "" ? null : TypeInitialiser(3, v[3]), !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : TypeInitialiser(3, v[5])),
  4166981789: (v) => new IFC4X3.IfcPropertyEnumeratedValue(new IFC4X3.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : v[2]?.map((p) => p?.value && p?.value != "" ? TypeInitialiser(3, p) : null) || [], !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  2752243245: (v) => new IFC4X3.IfcPropertyListValue(new IFC4X3.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : v[2]?.map((p) => p?.value && p?.value != "" ? TypeInitialiser(3, p) : null) || [], !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  941946838: (v) => new IFC4X3.IfcPropertyReferenceValue(new IFC4X3.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcText(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  1451395588: (v) => new IFC4X3.IfcPropertySet(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  492091185: (v) => new IFC4X3.IfcPropertySetTemplate(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4], !v[5] && v[5] != "" ? null : new IFC4X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3650150729: (v) => new IFC4X3.IfcPropertySingleValue(new IFC4X3.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : TypeInitialiser(3, v[2]), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  110355661: (v) => new IFC4X3.IfcPropertyTableValue(new IFC4X3.IfcIdentifier(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcText(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : v[2]?.map((p) => p?.value && p?.value != "" ? TypeInitialiser(3, p) : null) || [], !v[3] && v[3] != "" ? null : v[3]?.map((p) => p?.value && p?.value != "" ? TypeInitialiser(3, p) : null) || [], !v[4] && v[4] != "" ? null : new IFC4X3.IfcText(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), v[7]),
  3521284610: (v) => new IFC4X3.IfcPropertyTemplate(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value)),
  2770003689: (v) => new IFC4X3.IfcRectangleHollowProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC4X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), new IFC4X3.IfcPositiveLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcNonNegativeLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcNonNegativeLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value)),
  2798486643: (v) => new IFC4X3.IfcRectangularPyramid(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), new IFC4X3.IfcPositiveLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  3454111270: (v) => new IFC4X3.IfcRectangularTrimmedSurface(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcParameterValue(!v[1] && v[1] != "" ? null : v[1].value), new IFC4X3.IfcParameterValue(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcParameterValue(!v[3] && v[3] != "" ? null : v[3].value), new IFC4X3.IfcParameterValue(!v[4] && v[4] != "" ? null : v[4].value), new IFC4X3.IfcBoolean(!v[5] && v[5] != "" ? null : v[5].value), new IFC4X3.IfcBoolean(!v[6] && v[6] != "" ? null : v[6].value)),
  3765753017: (v) => new IFC4X3.IfcReinforcementDefinitionProperties(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3939117080: (v) => new IFC4X3.IfcRelAssigns(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[5]),
  1683148259: (v) => new IFC4X3.IfcRelAssignsToActor(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[5], new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value)),
  2495723537: (v) => new IFC4X3.IfcRelAssignsToControl(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[5], new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  1307041759: (v) => new IFC4X3.IfcRelAssignsToGroup(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[5], new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  1027710054: (v) => new IFC4X3.IfcRelAssignsToGroupByFactor(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[5], new Handle(!v[6] && v[6] != "" ? null : v[6].value), new IFC4X3.IfcRatioMeasure(!v[7] && v[7] != "" ? null : v[7].value)),
  4278684876: (v) => new IFC4X3.IfcRelAssignsToProcess(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[5], new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value)),
  2857406711: (v) => new IFC4X3.IfcRelAssignsToProduct(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[5], new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  205026976: (v) => new IFC4X3.IfcRelAssignsToResource(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[5], new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  1865459582: (v) => new IFC4X3.IfcRelAssociates(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  4095574036: (v) => new IFC4X3.IfcRelAssociatesApproval(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  919958153: (v) => new IFC4X3.IfcRelAssociatesClassification(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  2728634034: (v) => new IFC4X3.IfcRelAssociatesConstraint(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[5] && v[5] != "" ? null : new IFC4X3.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value), new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  982818633: (v) => new IFC4X3.IfcRelAssociatesDocument(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  3840914261: (v) => new IFC4X3.IfcRelAssociatesLibrary(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  2655215786: (v) => new IFC4X3.IfcRelAssociatesMaterial(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  1033248425: (v) => new IFC4X3.IfcRelAssociatesProfileDef(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  826625072: (v) => new IFC4X3.IfcRelConnects(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value)),
  1204542856: (v) => new IFC4X3.IfcRelConnectsElements(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value), new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  3945020480: (v) => new IFC4X3.IfcRelConnectsPathElements(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value), new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : v[7]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcInteger(p.value) : null) || [], !v[8] && v[8] != "" ? null : v[8]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcInteger(p.value) : null) || [], v[9], v[10]),
  4201705270: (v) => new IFC4X3.IfcRelConnectsPortToElement(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  3190031847: (v) => new IFC4X3.IfcRelConnectsPorts(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  2127690289: (v) => new IFC4X3.IfcRelConnectsStructuralActivity(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  1638771189: (v) => new IFC4X3.IfcRelConnectsStructuralMember(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new Handle(!v[9] && v[9] != "" ? null : v[9].value)),
  504942748: (v) => new IFC4X3.IfcRelConnectsWithEccentricity(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new Handle(!v[9] && v[9] != "" ? null : v[9].value), new Handle(!v[10] && v[10] != "" ? null : v[10].value)),
  3678494232: (v) => new IFC4X3.IfcRelConnectsWithRealizingElements(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value), new Handle(!v[6] && v[6] != "" ? null : v[6].value), v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  3242617779: (v) => new IFC4X3.IfcRelContainedInSpatialStructure(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  886880790: (v) => new IFC4X3.IfcRelCoversBldgElements(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2802773753: (v) => new IFC4X3.IfcRelCoversSpaces(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2565941209: (v) => new IFC4X3.IfcRelDeclares(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  2551354335: (v) => new IFC4X3.IfcRelDecomposes(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value)),
  693640335: (v) => new IFC4X3.IfcRelDefines(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value)),
  1462361463: (v) => new IFC4X3.IfcRelDefinesByObject(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  4186316022: (v) => new IFC4X3.IfcRelDefinesByProperties(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  307848117: (v) => new IFC4X3.IfcRelDefinesByTemplate(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  781010003: (v) => new IFC4X3.IfcRelDefinesByType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  3940055652: (v) => new IFC4X3.IfcRelFillsElement(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  279856033: (v) => new IFC4X3.IfcRelFlowControlElements(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  427948657: (v) => new IFC4X3.IfcRelInterferesElements(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcIdentifier(!v[8] && v[8] != "" ? null : v[8].value), new IFC4X3.IfcLogical(!v[9] && v[9] != "" ? null : v[9].value)),
  3268803585: (v) => new IFC4X3.IfcRelNests(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1441486842: (v) => new IFC4X3.IfcRelPositions(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  750771296: (v) => new IFC4X3.IfcRelProjectsElement(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  1245217292: (v) => new IFC4X3.IfcRelReferencedInSpatialStructure(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  4122056220: (v) => new IFC4X3.IfcRelSequence(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), v[7], !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  366585022: (v) => new IFC4X3.IfcRelServicesBuildings(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3451746338: (v) => new IFC4X3.IfcRelSpaceBoundary(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), v[7], v[8]),
  3523091289: (v) => new IFC4X3.IfcRelSpaceBoundary1stLevel(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), v[7], v[8], !v[9] && v[9] != "" ? null : new Handle(!v[9] && v[9] != "" ? null : v[9].value)),
  1521410863: (v) => new IFC4X3.IfcRelSpaceBoundary2ndLevel(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), v[7], v[8], !v[9] && v[9] != "" ? null : new Handle(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new Handle(!v[10] && v[10] != "" ? null : v[10].value)),
  1401173127: (v) => new IFC4X3.IfcRelVoidsElement(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  816062949: (v) => new IFC4X3.IfcReparametrisedCompositeCurveSegment(v[0], new IFC4X3.IfcBoolean(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcParameterValue(!v[3] && v[3] != "" ? null : v[3].value)),
  2914609552: (v) => new IFC4X3.IfcResource(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcText(!v[6] && v[6] != "" ? null : v[6].value)),
  1856042241: (v) => new IFC4X3.IfcRevolvedAreaSolid(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcPlaneAngleMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  3243963512: (v) => new IFC4X3.IfcRevolvedAreaSolidTapered(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcPlaneAngleMeasure(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value)),
  4158566097: (v) => new IFC4X3.IfcRightCircularCone(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), new IFC4X3.IfcPositiveLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value)),
  3626867408: (v) => new IFC4X3.IfcRightCircularCylinder(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), new IFC4X3.IfcPositiveLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value)),
  1862484736: (v) => new IFC4X3.IfcSectionedSolid(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1290935644: (v) => new IFC4X3.IfcSectionedSolidHorizontal(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1356537516: (v) => new IFC4X3.IfcSectionedSurface(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3663146110: (v) => new IFC4X3.IfcSimplePropertyTemplate(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4], !v[5] && v[5] != "" ? null : new IFC4X3.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new Handle(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new Handle(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC4X3.IfcLabel(!v[10] && v[10] != "" ? null : v[10].value), v[11]),
  1412071761: (v) => new IFC4X3.IfcSpatialElement(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value)),
  710998568: (v) => new IFC4X3.IfcSpatialElementType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  2706606064: (v) => new IFC4X3.IfcSpatialStructureElement(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3893378262: (v) => new IFC4X3.IfcSpatialStructureElementType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  463610769: (v) => new IFC4X3.IfcSpatialZone(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  2481509218: (v) => new IFC4X3.IfcSpatialZoneType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9], !v[10] && v[10] != "" ? null : new IFC4X3.IfcLabel(!v[10] && v[10] != "" ? null : v[10].value)),
  451544542: (v) => new IFC4X3.IfcSphere(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value)),
  4015995234: (v) => new IFC4X3.IfcSphericalSurface(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value)),
  2735484536: (v) => new IFC4X3.IfcSpiral(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  3544373492: (v) => new IFC4X3.IfcStructuralActivity(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), new Handle(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3136571912: (v) => new IFC4X3.IfcStructuralItem(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  530289379: (v) => new IFC4X3.IfcStructuralMember(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  3689010777: (v) => new IFC4X3.IfcStructuralReaction(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), new Handle(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3979015343: (v) => new IFC4X3.IfcStructuralSurfaceMember(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), v[7], !v[8] && v[8] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value)),
  2218152070: (v) => new IFC4X3.IfcStructuralSurfaceMemberVarying(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), v[7], !v[8] && v[8] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value)),
  603775116: (v) => new IFC4X3.IfcStructuralSurfaceReaction(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), new Handle(!v[7] && v[7] != "" ? null : v[7].value), v[8], v[9]),
  4095615324: (v) => new IFC4X3.IfcSubContractResourceType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : new IFC4X3.IfcIdentifier(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcText(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : v[9]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[10] && v[10] != "" ? null : new Handle(!v[10] && v[10] != "" ? null : v[10].value), v[11]),
  699246055: (v) => new IFC4X3.IfcSurfaceCurve(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[2]),
  2028607225: (v) => new IFC4X3.IfcSurfaceCurveSweptAreaSolid(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : TypeInitialiser(3, v[3]), !v[4] && v[4] != "" ? null : TypeInitialiser(3, v[4]), new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  2809605785: (v) => new IFC4X3.IfcSurfaceOfLinearExtrusion(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  4124788165: (v) => new IFC4X3.IfcSurfaceOfRevolution(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  1580310250: (v) => new IFC4X3.IfcSystemFurnitureElementType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3473067441: (v) => new IFC4X3.IfcTask(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcText(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), new IFC4X3.IfcBoolean(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC4X3.IfcInteger(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new Handle(!v[11] && v[11] != "" ? null : v[11].value), v[12]),
  3206491090: (v) => new IFC4X3.IfcTaskType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : new IFC4X3.IfcIdentifier(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcText(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9], !v[10] && v[10] != "" ? null : new IFC4X3.IfcLabel(!v[10] && v[10] != "" ? null : v[10].value)),
  2387106220: (v) => new IFC4X3.IfcTessellatedFaceSet(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcBoolean(!v[1] && v[1] != "" ? null : v[1].value)),
  782932809: (v) => new IFC4X3.IfcThirdOrderPolynomialSpiral(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value)),
  1935646853: (v) => new IFC4X3.IfcToroidalSurface(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), new IFC4X3.IfcPositiveLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value)),
  3665877780: (v) => new IFC4X3.IfcTransportationDeviceType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  2916149573: (v) => new IFC4X3.IfcTriangulatedFaceSet(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcBoolean(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : v[2]?.map((p) => p?.map((p2) => p2?.value && p2?.value != "" ? new IFC4X3.IfcParameterValue(p2.value) : null) || []), v[3]?.map((p) => p?.map((p2) => p2?.value && p2?.value != "" ? new IFC4X3.IfcPositiveInteger(p2.value) : null) || []), !v[4] && v[4] != "" ? null : v[4]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcPositiveInteger(p.value) : null) || []),
  1229763772: (v) => new IFC4X3.IfcTriangulatedIrregularNetwork(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcBoolean(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : v[2]?.map((p) => p?.map((p2) => p2?.value && p2?.value != "" ? new IFC4X3.IfcParameterValue(p2.value) : null) || []), v[3]?.map((p) => p?.map((p2) => p2?.value && p2?.value != "" ? new IFC4X3.IfcPositiveInteger(p2.value) : null) || []), !v[4] && v[4] != "" ? null : v[4]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcPositiveInteger(p.value) : null) || [], v[5]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcInteger(p.value) : null) || []),
  3651464721: (v) => new IFC4X3.IfcVehicleType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  336235671: (v) => new IFC4X3.IfcWindowLiningProperties(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcNonNegativeLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcNonNegativeLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcNonNegativeLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcNormalisedRatioMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4X3.IfcNormalisedRatioMeasure(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC4X3.IfcNormalisedRatioMeasure(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC4X3.IfcNormalisedRatioMeasure(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new Handle(!v[12] && v[12] != "" ? null : v[12].value), !v[13] && v[13] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[13] && v[13] != "" ? null : v[13].value), !v[14] && v[14] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[14] && v[14] != "" ? null : v[14].value), !v[15] && v[15] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[15] && v[15] != "" ? null : v[15].value)),
  512836454: (v) => new IFC4X3.IfcWindowPanelProperties(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4], v[5], !v[6] && v[6] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new Handle(!v[8] && v[8] != "" ? null : v[8].value)),
  2296667514: (v) => new IFC4X3.IfcActor(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  1635779807: (v) => new IFC4X3.IfcAdvancedBrep(new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  2603310189: (v) => new IFC4X3.IfcAdvancedBrepWithVoids(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1674181508: (v) => new IFC4X3.IfcAnnotation(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), v[7]),
  2887950389: (v) => new IFC4X3.IfcBSplineSurface(new IFC4X3.IfcInteger(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcInteger(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.map((p2) => p2?.value && p2?.value != "" ? new Handle(p2.value) : null) || []), v[3], new IFC4X3.IfcLogical(!v[4] && v[4] != "" ? null : v[4].value), new IFC4X3.IfcLogical(!v[5] && v[5] != "" ? null : v[5].value), new IFC4X3.IfcLogical(!v[6] && v[6] != "" ? null : v[6].value)),
  167062518: (v) => new IFC4X3.IfcBSplineSurfaceWithKnots(new IFC4X3.IfcInteger(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcInteger(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.map((p2) => p2?.value && p2?.value != "" ? new Handle(p2.value) : null) || []), v[3], new IFC4X3.IfcLogical(!v[4] && v[4] != "" ? null : v[4].value), new IFC4X3.IfcLogical(!v[5] && v[5] != "" ? null : v[5].value), new IFC4X3.IfcLogical(!v[6] && v[6] != "" ? null : v[6].value), v[7]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcInteger(p.value) : null) || [], v[8]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcInteger(p.value) : null) || [], v[9]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcParameterValue(p.value) : null) || [], v[10]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcParameterValue(p.value) : null) || [], v[11]),
  1334484129: (v) => new IFC4X3.IfcBlock(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), new IFC4X3.IfcPositiveLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  3649129432: (v) => new IFC4X3.IfcBooleanClippingResult(v[0], new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value)),
  1260505505: (_) => new IFC4X3.IfcBoundedCurve(),
  3124254112: (v) => new IFC4X3.IfcBuildingStorey(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), v[8], !v[9] && v[9] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[9] && v[9] != "" ? null : v[9].value)),
  1626504194: (v) => new IFC4X3.IfcBuiltElementType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  2197970202: (v) => new IFC4X3.IfcChimneyType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2937912522: (v) => new IFC4X3.IfcCircleHollowProfileDef(v[0], !v[1] && v[1] != "" ? null : new IFC4X3.IfcLabel(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new Handle(!v[2] && v[2] != "" ? null : v[2].value), new IFC4X3.IfcPositiveLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), new IFC4X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value)),
  3893394355: (v) => new IFC4X3.IfcCivilElementType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  3497074424: (v) => new IFC4X3.IfcClothoid(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value)),
  300633059: (v) => new IFC4X3.IfcColumnType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3875453745: (v) => new IFC4X3.IfcComplexPropertyTemplate(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), v[5], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3732776249: (v) => new IFC4X3.IfcCompositeCurve(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new IFC4X3.IfcLogical(!v[1] && v[1] != "" ? null : v[1].value)),
  15328376: (v) => new IFC4X3.IfcCompositeCurveOnSurface(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new IFC4X3.IfcLogical(!v[1] && v[1] != "" ? null : v[1].value)),
  2510884976: (v) => new IFC4X3.IfcConic(new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  2185764099: (v) => new IFC4X3.IfcConstructionEquipmentResourceType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : new IFC4X3.IfcIdentifier(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcText(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : v[9]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[10] && v[10] != "" ? null : new Handle(!v[10] && v[10] != "" ? null : v[10].value), v[11]),
  4105962743: (v) => new IFC4X3.IfcConstructionMaterialResourceType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : new IFC4X3.IfcIdentifier(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcText(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : v[9]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[10] && v[10] != "" ? null : new Handle(!v[10] && v[10] != "" ? null : v[10].value), v[11]),
  1525564444: (v) => new IFC4X3.IfcConstructionProductResourceType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : new IFC4X3.IfcIdentifier(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcText(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : v[9]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[10] && v[10] != "" ? null : new Handle(!v[10] && v[10] != "" ? null : v[10].value), v[11]),
  2559216714: (v) => new IFC4X3.IfcConstructionResource(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcText(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : v[8]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[9] && v[9] != "" ? null : new Handle(!v[9] && v[9] != "" ? null : v[9].value)),
  3293443760: (v) => new IFC4X3.IfcControl(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value)),
  2000195564: (v) => new IFC4X3.IfcCosineSpiral(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value)),
  3895139033: (v) => new IFC4X3.IfcCostItem(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), v[6], !v[7] && v[7] != "" ? null : v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[8] && v[8] != "" ? null : v[8]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  1419761937: (v) => new IFC4X3.IfcCostSchedule(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), v[6], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcDateTime(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4X3.IfcDateTime(!v[9] && v[9] != "" ? null : v[9].value)),
  4189326743: (v) => new IFC4X3.IfcCourseType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1916426348: (v) => new IFC4X3.IfcCoveringType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3295246426: (v) => new IFC4X3.IfcCrewResource(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcText(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : v[8]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[9] && v[9] != "" ? null : new Handle(!v[9] && v[9] != "" ? null : v[9].value), v[10]),
  1457835157: (v) => new IFC4X3.IfcCurtainWallType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1213902940: (v) => new IFC4X3.IfcCylindricalSurface(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value)),
  1306400036: (v) => new IFC4X3.IfcDeepFoundationType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  4234616927: (v) => new IFC4X3.IfcDirectrixDerivedReferenceSweptAreaSolid(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : TypeInitialiser(3, v[3]), !v[4] && v[4] != "" ? null : TypeInitialiser(3, v[4]), new Handle(!v[5] && v[5] != "" ? null : v[5].value)),
  3256556792: (v) => new IFC4X3.IfcDistributionElementType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  3849074793: (v) => new IFC4X3.IfcDistributionFlowElementType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  2963535650: (v) => new IFC4X3.IfcDoorLiningProperties(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcNonNegativeLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcNonNegativeLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcNonNegativeLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[12] && v[12] != "" ? null : v[12].value), !v[13] && v[13] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[13] && v[13] != "" ? null : v[13].value), !v[14] && v[14] != "" ? null : new Handle(!v[14] && v[14] != "" ? null : v[14].value), !v[15] && v[15] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[15] && v[15] != "" ? null : v[15].value), !v[16] && v[16] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[16] && v[16] != "" ? null : v[16].value)),
  1714330368: (v) => new IFC4X3.IfcDoorPanelProperties(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), v[5], !v[6] && v[6] != "" ? null : new IFC4X3.IfcNormalisedRatioMeasure(!v[6] && v[6] != "" ? null : v[6].value), v[7], !v[8] && v[8] != "" ? null : new Handle(!v[8] && v[8] != "" ? null : v[8].value)),
  2323601079: (v) => new IFC4X3.IfcDoorType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9], v[10], !v[11] && v[11] != "" ? null : new IFC4X3.IfcBoolean(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC4X3.IfcLabel(!v[12] && v[12] != "" ? null : v[12].value)),
  445594917: (v) => new IFC4X3.IfcDraughtingPreDefinedColour(new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  4006246654: (v) => new IFC4X3.IfcDraughtingPreDefinedCurveFont(new IFC4X3.IfcLabel(!v[0] && v[0] != "" ? null : v[0].value)),
  1758889154: (v) => new IFC4X3.IfcElement(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  4123344466: (v) => new IFC4X3.IfcElementAssembly(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8], v[9]),
  2397081782: (v) => new IFC4X3.IfcElementAssemblyType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1623761950: (v) => new IFC4X3.IfcElementComponent(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  2590856083: (v) => new IFC4X3.IfcElementComponentType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  1704287377: (v) => new IFC4X3.IfcEllipse(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), new IFC4X3.IfcPositiveLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value)),
  2107101300: (v) => new IFC4X3.IfcEnergyConversionDeviceType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  132023988: (v) => new IFC4X3.IfcEngineType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3174744832: (v) => new IFC4X3.IfcEvaporativeCoolerType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3390157468: (v) => new IFC4X3.IfcEvaporatorType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  4148101412: (v) => new IFC4X3.IfcEvent(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcText(!v[6] && v[6] != "" ? null : v[6].value), v[7], v[8], !v[9] && v[9] != "" ? null : new IFC4X3.IfcLabel(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new Handle(!v[10] && v[10] != "" ? null : v[10].value)),
  2853485674: (v) => new IFC4X3.IfcExternalSpatialStructureElement(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value)),
  807026263: (v) => new IFC4X3.IfcFacetedBrep(new Handle(!v[0] && v[0] != "" ? null : v[0].value)),
  3737207727: (v) => new IFC4X3.IfcFacetedBrepWithVoids(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  24185140: (v) => new IFC4X3.IfcFacility(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1310830890: (v) => new IFC4X3.IfcFacilityPart(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), v[8], v[9]),
  4228831410: (v) => new IFC4X3.IfcFacilityPartCommon(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), v[8], v[9], v[10]),
  647756555: (v) => new IFC4X3.IfcFastener(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  2489546625: (v) => new IFC4X3.IfcFastenerType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2827207264: (v) => new IFC4X3.IfcFeatureElement(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  2143335405: (v) => new IFC4X3.IfcFeatureElementAddition(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  1287392070: (v) => new IFC4X3.IfcFeatureElementSubtraction(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  3907093117: (v) => new IFC4X3.IfcFlowControllerType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  3198132628: (v) => new IFC4X3.IfcFlowFittingType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  3815607619: (v) => new IFC4X3.IfcFlowMeterType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1482959167: (v) => new IFC4X3.IfcFlowMovingDeviceType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  1834744321: (v) => new IFC4X3.IfcFlowSegmentType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  1339347760: (v) => new IFC4X3.IfcFlowStorageDeviceType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  2297155007: (v) => new IFC4X3.IfcFlowTerminalType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  3009222698: (v) => new IFC4X3.IfcFlowTreatmentDeviceType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  1893162501: (v) => new IFC4X3.IfcFootingType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  263784265: (v) => new IFC4X3.IfcFurnishingElement(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  1509553395: (v) => new IFC4X3.IfcFurniture(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3493046030: (v) => new IFC4X3.IfcGeographicElement(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  4230923436: (v) => new IFC4X3.IfcGeotechnicalElement(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  1594536857: (v) => new IFC4X3.IfcGeotechnicalStratum(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  2898700619: (v) => new IFC4X3.IfcGradientCurve(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new IFC4X3.IfcLogical(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  2706460486: (v) => new IFC4X3.IfcGroup(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  1251058090: (v) => new IFC4X3.IfcHeatExchangerType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1806887404: (v) => new IFC4X3.IfcHumidifierType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2568555532: (v) => new IFC4X3.IfcImpactProtectionDevice(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3948183225: (v) => new IFC4X3.IfcImpactProtectionDeviceType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2571569899: (v) => new IFC4X3.IfcIndexedPolyCurve(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : v[1]?.map((p) => p?.value && p?.value != "" ? TypeInitialiser(3, p) : null) || [], new IFC4X3.IfcLogical(!v[2] && v[2] != "" ? null : v[2].value)),
  3946677679: (v) => new IFC4X3.IfcInterceptorType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3113134337: (v) => new IFC4X3.IfcIntersectionCurve(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[2]),
  2391368822: (v) => new IFC4X3.IfcInventory(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), v[5], !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[8] && v[8] != "" ? null : new IFC4X3.IfcDate(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new Handle(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new Handle(!v[10] && v[10] != "" ? null : v[10].value)),
  4288270099: (v) => new IFC4X3.IfcJunctionBoxType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  679976338: (v) => new IFC4X3.IfcKerbType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), new IFC4X3.IfcBoolean(!v[9] && v[9] != "" ? null : v[9].value)),
  3827777499: (v) => new IFC4X3.IfcLaborResource(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcText(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : v[8]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[9] && v[9] != "" ? null : new Handle(!v[9] && v[9] != "" ? null : v[9].value), v[10]),
  1051575348: (v) => new IFC4X3.IfcLampType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1161773419: (v) => new IFC4X3.IfcLightFixtureType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2176059722: (v) => new IFC4X3.IfcLinearElement(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  1770583370: (v) => new IFC4X3.IfcLiquidTerminalType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  525669439: (v) => new IFC4X3.IfcMarineFacility(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), v[8], v[9]),
  976884017: (v) => new IFC4X3.IfcMarinePart(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), v[8], v[9], v[10]),
  377706215: (v) => new IFC4X3.IfcMechanicalFastener(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[9] && v[9] != "" ? null : v[9].value), v[10]),
  2108223431: (v) => new IFC4X3.IfcMechanicalFastenerType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9], !v[10] && v[10] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[11] && v[11] != "" ? null : v[11].value)),
  1114901282: (v) => new IFC4X3.IfcMedicalDeviceType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3181161470: (v) => new IFC4X3.IfcMemberType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1950438474: (v) => new IFC4X3.IfcMobileTelecommunicationsApplianceType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  710110818: (v) => new IFC4X3.IfcMooringDeviceType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  977012517: (v) => new IFC4X3.IfcMotorConnectionType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  506776471: (v) => new IFC4X3.IfcNavigationElementType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  4143007308: (v) => new IFC4X3.IfcOccupant(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), new Handle(!v[5] && v[5] != "" ? null : v[5].value), v[6]),
  3588315303: (v) => new IFC4X3.IfcOpeningElement(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  2837617999: (v) => new IFC4X3.IfcOutletType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  514975943: (v) => new IFC4X3.IfcPavementType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2382730787: (v) => new IFC4X3.IfcPerformanceHistory(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), new IFC4X3.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value), v[7]),
  3566463478: (v) => new IFC4X3.IfcPermeableCoveringProperties(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), v[4], v[5], !v[6] && v[6] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new Handle(!v[8] && v[8] != "" ? null : v[8].value)),
  3327091369: (v) => new IFC4X3.IfcPermit(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), v[6], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcText(!v[8] && v[8] != "" ? null : v[8].value)),
  1158309216: (v) => new IFC4X3.IfcPileType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  804291784: (v) => new IFC4X3.IfcPipeFittingType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  4231323485: (v) => new IFC4X3.IfcPipeSegmentType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  4017108033: (v) => new IFC4X3.IfcPlateType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2839578677: (v) => new IFC4X3.IfcPolygonalFaceSet(new Handle(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new IFC4X3.IfcBoolean(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[3] && v[3] != "" ? null : v[3]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcPositiveInteger(p.value) : null) || []),
  3724593414: (v) => new IFC4X3.IfcPolyline(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  3740093272: (v) => new IFC4X3.IfcPort(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  1946335990: (v) => new IFC4X3.IfcPositioningElement(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  2744685151: (v) => new IFC4X3.IfcProcedure(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcText(!v[6] && v[6] != "" ? null : v[6].value), v[7]),
  2904328755: (v) => new IFC4X3.IfcProjectOrder(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), v[6], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcText(!v[8] && v[8] != "" ? null : v[8].value)),
  3651124850: (v) => new IFC4X3.IfcProjectionElement(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1842657554: (v) => new IFC4X3.IfcProtectiveDeviceType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2250791053: (v) => new IFC4X3.IfcPumpType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1763565496: (v) => new IFC4X3.IfcRailType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2893384427: (v) => new IFC4X3.IfcRailingType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3992365140: (v) => new IFC4X3.IfcRailway(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), v[8], v[9]),
  1891881377: (v) => new IFC4X3.IfcRailwayPart(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), v[8], v[9], v[10]),
  2324767716: (v) => new IFC4X3.IfcRampFlightType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1469900589: (v) => new IFC4X3.IfcRampType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  683857671: (v) => new IFC4X3.IfcRationalBSplineSurfaceWithKnots(new IFC4X3.IfcInteger(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcInteger(!v[1] && v[1] != "" ? null : v[1].value), v[2]?.map((p) => p?.map((p2) => p2?.value && p2?.value != "" ? new Handle(p2.value) : null) || []), v[3], new IFC4X3.IfcLogical(!v[4] && v[4] != "" ? null : v[4].value), new IFC4X3.IfcLogical(!v[5] && v[5] != "" ? null : v[5].value), new IFC4X3.IfcLogical(!v[6] && v[6] != "" ? null : v[6].value), v[7]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcInteger(p.value) : null) || [], v[8]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcInteger(p.value) : null) || [], v[9]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcParameterValue(p.value) : null) || [], v[10]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcParameterValue(p.value) : null) || [], v[11], v[12]?.map((p) => p?.map((p2) => p2?.value && p2?.value != "" ? new IFC4X3.IfcReal(p2.value) : null) || [])),
  4021432810: (v) => new IFC4X3.IfcReferent(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), v[7]),
  3027567501: (v) => new IFC4X3.IfcReinforcingElement(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  964333572: (v) => new IFC4X3.IfcReinforcingElementType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  2320036040: (v) => new IFC4X3.IfcReinforcingMesh(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[12] && v[12] != "" ? null : v[12].value), !v[13] && v[13] != "" ? null : new IFC4X3.IfcAreaMeasure(!v[13] && v[13] != "" ? null : v[13].value), !v[14] && v[14] != "" ? null : new IFC4X3.IfcAreaMeasure(!v[14] && v[14] != "" ? null : v[14].value), !v[15] && v[15] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[15] && v[15] != "" ? null : v[15].value), !v[16] && v[16] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[16] && v[16] != "" ? null : v[16].value), v[17]),
  2310774935: (v) => new IFC4X3.IfcReinforcingMeshType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9], !v[10] && v[10] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[12] && v[12] != "" ? null : v[12].value), !v[13] && v[13] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[13] && v[13] != "" ? null : v[13].value), !v[14] && v[14] != "" ? null : new IFC4X3.IfcAreaMeasure(!v[14] && v[14] != "" ? null : v[14].value), !v[15] && v[15] != "" ? null : new IFC4X3.IfcAreaMeasure(!v[15] && v[15] != "" ? null : v[15].value), !v[16] && v[16] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[16] && v[16] != "" ? null : v[16].value), !v[17] && v[17] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[17] && v[17] != "" ? null : v[17].value), !v[18] && v[18] != "" ? null : new IFC4X3.IfcLabel(!v[18] && v[18] != "" ? null : v[18].value), !v[19] && v[19] != "" ? null : v[19]?.map((p) => p?.value && p?.value != "" ? TypeInitialiser(3, p) : null) || []),
  3818125796: (v) => new IFC4X3.IfcRelAdheresToElement(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  160246688: (v) => new IFC4X3.IfcRelAggregates(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), new Handle(!v[4] && v[4] != "" ? null : v[4].value), v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || []),
  146592293: (v) => new IFC4X3.IfcRoad(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), v[8], v[9]),
  550521510: (v) => new IFC4X3.IfcRoadPart(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), v[8], v[9], v[10]),
  2781568857: (v) => new IFC4X3.IfcRoofType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1768891740: (v) => new IFC4X3.IfcSanitaryTerminalType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2157484638: (v) => new IFC4X3.IfcSeamCurve(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[2]),
  3649235739: (v) => new IFC4X3.IfcSecondOrderPolynomialSpiral(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  544395925: (v) => new IFC4X3.IfcSegmentedReferenceCurve(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new IFC4X3.IfcLogical(!v[1] && v[1] != "" ? null : v[1].value), new Handle(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new Handle(!v[3] && v[3] != "" ? null : v[3].value)),
  1027922057: (v) => new IFC4X3.IfcSeventhOrderPolynomialSpiral(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value)),
  4074543187: (v) => new IFC4X3.IfcShadingDeviceType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  33720170: (v) => new IFC4X3.IfcSign(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3599934289: (v) => new IFC4X3.IfcSignType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1894708472: (v) => new IFC4X3.IfcSignalType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  42703149: (v) => new IFC4X3.IfcSineSpiral(!v[0] && v[0] != "" ? null : new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[3] && v[3] != "" ? null : v[3].value)),
  4097777520: (v) => new IFC4X3.IfcSite(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), v[8], !v[9] && v[9] != "" ? null : new IFC4X3.IfcCompoundPlaneAngleMeasure(v[9].map((x) => x.value)), !v[10] && v[10] != "" ? null : new IFC4X3.IfcCompoundPlaneAngleMeasure(v[10].map((x) => x.value)), !v[11] && v[11] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC4X3.IfcLabel(!v[12] && v[12] != "" ? null : v[12].value), !v[13] && v[13] != "" ? null : new Handle(!v[13] && v[13] != "" ? null : v[13].value)),
  2533589738: (v) => new IFC4X3.IfcSlabType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1072016465: (v) => new IFC4X3.IfcSolarDeviceType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3856911033: (v) => new IFC4X3.IfcSpace(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), v[8], v[9], !v[10] && v[10] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[10] && v[10] != "" ? null : v[10].value)),
  1305183839: (v) => new IFC4X3.IfcSpaceHeaterType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3812236995: (v) => new IFC4X3.IfcSpaceType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9], !v[10] && v[10] != "" ? null : new IFC4X3.IfcLabel(!v[10] && v[10] != "" ? null : v[10].value)),
  3112655638: (v) => new IFC4X3.IfcStackTerminalType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1039846685: (v) => new IFC4X3.IfcStairFlightType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  338393293: (v) => new IFC4X3.IfcStairType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  682877961: (v) => new IFC4X3.IfcStructuralAction(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), new Handle(!v[7] && v[7] != "" ? null : v[7].value), v[8], !v[9] && v[9] != "" ? null : new IFC4X3.IfcBoolean(!v[9] && v[9] != "" ? null : v[9].value)),
  1179482911: (v) => new IFC4X3.IfcStructuralConnection(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value)),
  1004757350: (v) => new IFC4X3.IfcStructuralCurveAction(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), new Handle(!v[7] && v[7] != "" ? null : v[7].value), v[8], !v[9] && v[9] != "" ? null : new IFC4X3.IfcBoolean(!v[9] && v[9] != "" ? null : v[9].value), v[10], v[11]),
  4243806635: (v) => new IFC4X3.IfcStructuralCurveConnection(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), new Handle(!v[8] && v[8] != "" ? null : v[8].value)),
  214636428: (v) => new IFC4X3.IfcStructuralCurveMember(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), v[7], new Handle(!v[8] && v[8] != "" ? null : v[8].value)),
  2445595289: (v) => new IFC4X3.IfcStructuralCurveMemberVarying(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), v[7], new Handle(!v[8] && v[8] != "" ? null : v[8].value)),
  2757150158: (v) => new IFC4X3.IfcStructuralCurveReaction(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), new Handle(!v[7] && v[7] != "" ? null : v[7].value), v[8], v[9]),
  1807405624: (v) => new IFC4X3.IfcStructuralLinearAction(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), new Handle(!v[7] && v[7] != "" ? null : v[7].value), v[8], !v[9] && v[9] != "" ? null : new IFC4X3.IfcBoolean(!v[9] && v[9] != "" ? null : v[9].value), v[10], v[11]),
  1252848954: (v) => new IFC4X3.IfcStructuralLoadGroup(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), v[5], v[6], v[7], !v[8] && v[8] != "" ? null : new IFC4X3.IfcRatioMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4X3.IfcLabel(!v[9] && v[9] != "" ? null : v[9].value)),
  2082059205: (v) => new IFC4X3.IfcStructuralPointAction(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), new Handle(!v[7] && v[7] != "" ? null : v[7].value), v[8], !v[9] && v[9] != "" ? null : new IFC4X3.IfcBoolean(!v[9] && v[9] != "" ? null : v[9].value)),
  734778138: (v) => new IFC4X3.IfcStructuralPointConnection(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new Handle(!v[8] && v[8] != "" ? null : v[8].value)),
  1235345126: (v) => new IFC4X3.IfcStructuralPointReaction(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), new Handle(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  2986769608: (v) => new IFC4X3.IfcStructuralResultGroup(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), v[5], !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), new IFC4X3.IfcBoolean(!v[7] && v[7] != "" ? null : v[7].value)),
  3657597509: (v) => new IFC4X3.IfcStructuralSurfaceAction(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), new Handle(!v[7] && v[7] != "" ? null : v[7].value), v[8], !v[9] && v[9] != "" ? null : new IFC4X3.IfcBoolean(!v[9] && v[9] != "" ? null : v[9].value), v[10], v[11]),
  1975003073: (v) => new IFC4X3.IfcStructuralSurfaceConnection(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value)),
  148013059: (v) => new IFC4X3.IfcSubContractResource(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcText(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : v[8]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[9] && v[9] != "" ? null : new Handle(!v[9] && v[9] != "" ? null : v[9].value), v[10]),
  3101698114: (v) => new IFC4X3.IfcSurfaceFeature(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  2315554128: (v) => new IFC4X3.IfcSwitchingDeviceType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2254336722: (v) => new IFC4X3.IfcSystem(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value)),
  413509423: (v) => new IFC4X3.IfcSystemFurnitureElement(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  5716631: (v) => new IFC4X3.IfcTankType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3824725483: (v) => new IFC4X3.IfcTendon(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9], !v[10] && v[10] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC4X3.IfcAreaMeasure(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC4X3.IfcForceMeasure(!v[12] && v[12] != "" ? null : v[12].value), !v[13] && v[13] != "" ? null : new IFC4X3.IfcPressureMeasure(!v[13] && v[13] != "" ? null : v[13].value), !v[14] && v[14] != "" ? null : new IFC4X3.IfcNormalisedRatioMeasure(!v[14] && v[14] != "" ? null : v[14].value), !v[15] && v[15] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[15] && v[15] != "" ? null : v[15].value), !v[16] && v[16] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[16] && v[16] != "" ? null : v[16].value)),
  2347447852: (v) => new IFC4X3.IfcTendonAnchor(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3081323446: (v) => new IFC4X3.IfcTendonAnchorType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3663046924: (v) => new IFC4X3.IfcTendonConduit(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2281632017: (v) => new IFC4X3.IfcTendonConduitType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2415094496: (v) => new IFC4X3.IfcTendonType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9], !v[10] && v[10] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC4X3.IfcAreaMeasure(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[12] && v[12] != "" ? null : v[12].value)),
  618700268: (v) => new IFC4X3.IfcTrackElementType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1692211062: (v) => new IFC4X3.IfcTransformerType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2097647324: (v) => new IFC4X3.IfcTransportElementType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1953115116: (v) => new IFC4X3.IfcTransportationDevice(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  3593883385: (v) => new IFC4X3.IfcTrimmedCurve(new Handle(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[2]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new IFC4X3.IfcBoolean(!v[3] && v[3] != "" ? null : v[3].value), v[4]),
  1600972822: (v) => new IFC4X3.IfcTubeBundleType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1911125066: (v) => new IFC4X3.IfcUnitaryEquipmentType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  728799441: (v) => new IFC4X3.IfcValveType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  840318589: (v) => new IFC4X3.IfcVehicle(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1530820697: (v) => new IFC4X3.IfcVibrationDamper(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3956297820: (v) => new IFC4X3.IfcVibrationDamperType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2391383451: (v) => new IFC4X3.IfcVibrationIsolator(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3313531582: (v) => new IFC4X3.IfcVibrationIsolatorType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2769231204: (v) => new IFC4X3.IfcVirtualElement(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  926996030: (v) => new IFC4X3.IfcVoidingFeature(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1898987631: (v) => new IFC4X3.IfcWallType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1133259667: (v) => new IFC4X3.IfcWasteTerminalType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  4009809668: (v) => new IFC4X3.IfcWindowType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9], v[10], !v[11] && v[11] != "" ? null : new IFC4X3.IfcBoolean(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC4X3.IfcLabel(!v[12] && v[12] != "" ? null : v[12].value)),
  4088093105: (v) => new IFC4X3.IfcWorkCalendar(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[8]),
  1028945134: (v) => new IFC4X3.IfcWorkControl(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), new IFC4X3.IfcDateTime(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4X3.IfcDuration(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC4X3.IfcDuration(!v[10] && v[10] != "" ? null : v[10].value), new IFC4X3.IfcDateTime(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC4X3.IfcDateTime(!v[12] && v[12] != "" ? null : v[12].value)),
  4218914973: (v) => new IFC4X3.IfcWorkPlan(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), new IFC4X3.IfcDateTime(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4X3.IfcDuration(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC4X3.IfcDuration(!v[10] && v[10] != "" ? null : v[10].value), new IFC4X3.IfcDateTime(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC4X3.IfcDateTime(!v[12] && v[12] != "" ? null : v[12].value), v[13]),
  3342526732: (v) => new IFC4X3.IfcWorkSchedule(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), new IFC4X3.IfcDateTime(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4X3.IfcDuration(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC4X3.IfcDuration(!v[10] && v[10] != "" ? null : v[10].value), new IFC4X3.IfcDateTime(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC4X3.IfcDateTime(!v[12] && v[12] != "" ? null : v[12].value), v[13]),
  1033361043: (v) => new IFC4X3.IfcZone(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value)),
  3821786052: (v) => new IFC4X3.IfcActionRequest(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), v[6], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcText(!v[8] && v[8] != "" ? null : v[8].value)),
  1411407467: (v) => new IFC4X3.IfcAirTerminalBoxType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3352864051: (v) => new IFC4X3.IfcAirTerminalType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1871374353: (v) => new IFC4X3.IfcAirToAirHeatRecoveryType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  4266260250: (v) => new IFC4X3.IfcAlignmentCant(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), new IFC4X3.IfcPositiveLengthMeasure(!v[7] && v[7] != "" ? null : v[7].value)),
  1545765605: (v) => new IFC4X3.IfcAlignmentHorizontal(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  317615605: (v) => new IFC4X3.IfcAlignmentSegment(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), new Handle(!v[7] && v[7] != "" ? null : v[7].value)),
  1662888072: (v) => new IFC4X3.IfcAlignmentVertical(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  3460190687: (v) => new IFC4X3.IfcAsset(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new Handle(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new Handle(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new Handle(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new Handle(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC4X3.IfcDate(!v[12] && v[12] != "" ? null : v[12].value), !v[13] && v[13] != "" ? null : new Handle(!v[13] && v[13] != "" ? null : v[13].value)),
  1532957894: (v) => new IFC4X3.IfcAudioVisualApplianceType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1967976161: (v) => new IFC4X3.IfcBSplineCurve(new IFC4X3.IfcInteger(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[2], new IFC4X3.IfcLogical(!v[3] && v[3] != "" ? null : v[3].value), new IFC4X3.IfcLogical(!v[4] && v[4] != "" ? null : v[4].value)),
  2461110595: (v) => new IFC4X3.IfcBSplineCurveWithKnots(new IFC4X3.IfcInteger(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[2], new IFC4X3.IfcLogical(!v[3] && v[3] != "" ? null : v[3].value), new IFC4X3.IfcLogical(!v[4] && v[4] != "" ? null : v[4].value), v[5]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcInteger(p.value) : null) || [], v[6]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcParameterValue(p.value) : null) || [], v[7]),
  819618141: (v) => new IFC4X3.IfcBeamType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3649138523: (v) => new IFC4X3.IfcBearingType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  231477066: (v) => new IFC4X3.IfcBoilerType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1136057603: (v) => new IFC4X3.IfcBoundaryCurve(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new IFC4X3.IfcLogical(!v[1] && v[1] != "" ? null : v[1].value)),
  644574406: (v) => new IFC4X3.IfcBridge(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), v[8], v[9]),
  963979645: (v) => new IFC4X3.IfcBridgePart(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), v[8], v[9], v[10]),
  4031249490: (v) => new IFC4X3.IfcBuilding(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), v[8], !v[9] && v[9] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC4X3.IfcLengthMeasure(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new Handle(!v[11] && v[11] != "" ? null : v[11].value)),
  2979338954: (v) => new IFC4X3.IfcBuildingElementPart(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  39481116: (v) => new IFC4X3.IfcBuildingElementPartType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1909888760: (v) => new IFC4X3.IfcBuildingElementProxyType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1177604601: (v) => new IFC4X3.IfcBuildingSystem(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), v[5], !v[6] && v[6] != "" ? null : new IFC4X3.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value)),
  1876633798: (v) => new IFC4X3.IfcBuiltElement(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  3862327254: (v) => new IFC4X3.IfcBuiltSystem(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), v[5], !v[6] && v[6] != "" ? null : new IFC4X3.IfcLabel(!v[6] && v[6] != "" ? null : v[6].value)),
  2188180465: (v) => new IFC4X3.IfcBurnerType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  395041908: (v) => new IFC4X3.IfcCableCarrierFittingType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3293546465: (v) => new IFC4X3.IfcCableCarrierSegmentType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2674252688: (v) => new IFC4X3.IfcCableFittingType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1285652485: (v) => new IFC4X3.IfcCableSegmentType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3203706013: (v) => new IFC4X3.IfcCaissonFoundationType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2951183804: (v) => new IFC4X3.IfcChillerType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3296154744: (v) => new IFC4X3.IfcChimney(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  2611217952: (v) => new IFC4X3.IfcCircle(new Handle(!v[0] && v[0] != "" ? null : v[0].value), new IFC4X3.IfcPositiveLengthMeasure(!v[1] && v[1] != "" ? null : v[1].value)),
  1677625105: (v) => new IFC4X3.IfcCivilElement(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  2301859152: (v) => new IFC4X3.IfcCoilType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  843113511: (v) => new IFC4X3.IfcColumn(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  400855858: (v) => new IFC4X3.IfcCommunicationsApplianceType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3850581409: (v) => new IFC4X3.IfcCompressorType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2816379211: (v) => new IFC4X3.IfcCondenserType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3898045240: (v) => new IFC4X3.IfcConstructionEquipmentResource(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcText(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : v[8]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[9] && v[9] != "" ? null : new Handle(!v[9] && v[9] != "" ? null : v[9].value), v[10]),
  1060000209: (v) => new IFC4X3.IfcConstructionMaterialResource(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcText(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : v[8]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[9] && v[9] != "" ? null : new Handle(!v[9] && v[9] != "" ? null : v[9].value), v[10]),
  488727124: (v) => new IFC4X3.IfcConstructionProductResource(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcIdentifier(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new IFC4X3.IfcText(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new Handle(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : v[8]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[9] && v[9] != "" ? null : new Handle(!v[9] && v[9] != "" ? null : v[9].value), v[10]),
  2940368186: (v) => new IFC4X3.IfcConveyorSegmentType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  335055490: (v) => new IFC4X3.IfcCooledBeamType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2954562838: (v) => new IFC4X3.IfcCoolingTowerType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1502416096: (v) => new IFC4X3.IfcCourse(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1973544240: (v) => new IFC4X3.IfcCovering(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3495092785: (v) => new IFC4X3.IfcCurtainWall(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3961806047: (v) => new IFC4X3.IfcDamperType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3426335179: (v) => new IFC4X3.IfcDeepFoundation(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  1335981549: (v) => new IFC4X3.IfcDiscreteAccessory(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  2635815018: (v) => new IFC4X3.IfcDiscreteAccessoryType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  479945903: (v) => new IFC4X3.IfcDistributionBoardType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1599208980: (v) => new IFC4X3.IfcDistributionChamberElementType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2063403501: (v) => new IFC4X3.IfcDistributionControlElementType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value)),
  1945004755: (v) => new IFC4X3.IfcDistributionElement(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  3040386961: (v) => new IFC4X3.IfcDistributionFlowElement(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  3041715199: (v) => new IFC4X3.IfcDistributionPort(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), v[7], v[8], v[9]),
  3205830791: (v) => new IFC4X3.IfcDistributionSystem(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value), v[6]),
  395920057: (v) => new IFC4X3.IfcDoor(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[9] && v[9] != "" ? null : v[9].value), v[10], v[11], !v[12] && v[12] != "" ? null : new IFC4X3.IfcLabel(!v[12] && v[12] != "" ? null : v[12].value)),
  869906466: (v) => new IFC4X3.IfcDuctFittingType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3760055223: (v) => new IFC4X3.IfcDuctSegmentType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2030761528: (v) => new IFC4X3.IfcDuctSilencerType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3071239417: (v) => new IFC4X3.IfcEarthworksCut(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1077100507: (v) => new IFC4X3.IfcEarthworksElement(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  3376911765: (v) => new IFC4X3.IfcEarthworksFill(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  663422040: (v) => new IFC4X3.IfcElectricApplianceType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2417008758: (v) => new IFC4X3.IfcElectricDistributionBoardType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3277789161: (v) => new IFC4X3.IfcElectricFlowStorageDeviceType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2142170206: (v) => new IFC4X3.IfcElectricFlowTreatmentDeviceType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1534661035: (v) => new IFC4X3.IfcElectricGeneratorType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1217240411: (v) => new IFC4X3.IfcElectricMotorType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  712377611: (v) => new IFC4X3.IfcElectricTimeControlType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1658829314: (v) => new IFC4X3.IfcEnergyConversionDevice(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  2814081492: (v) => new IFC4X3.IfcEngine(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3747195512: (v) => new IFC4X3.IfcEvaporativeCooler(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  484807127: (v) => new IFC4X3.IfcEvaporator(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1209101575: (v) => new IFC4X3.IfcExternalSpatialElement(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  346874300: (v) => new IFC4X3.IfcFanType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1810631287: (v) => new IFC4X3.IfcFilterType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  4222183408: (v) => new IFC4X3.IfcFireSuppressionTerminalType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2058353004: (v) => new IFC4X3.IfcFlowController(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  4278956645: (v) => new IFC4X3.IfcFlowFitting(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  4037862832: (v) => new IFC4X3.IfcFlowInstrumentType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  2188021234: (v) => new IFC4X3.IfcFlowMeter(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3132237377: (v) => new IFC4X3.IfcFlowMovingDevice(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  987401354: (v) => new IFC4X3.IfcFlowSegment(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  707683696: (v) => new IFC4X3.IfcFlowStorageDevice(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  2223149337: (v) => new IFC4X3.IfcFlowTerminal(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  3508470533: (v) => new IFC4X3.IfcFlowTreatmentDevice(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  900683007: (v) => new IFC4X3.IfcFooting(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  2713699986: (v) => new IFC4X3.IfcGeotechnicalAssembly(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  3009204131: (v) => new IFC4X3.IfcGrid(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[8]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[9] && v[9] != "" ? null : v[9]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[10]),
  3319311131: (v) => new IFC4X3.IfcHeatExchanger(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  2068733104: (v) => new IFC4X3.IfcHumidifier(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  4175244083: (v) => new IFC4X3.IfcInterceptor(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  2176052936: (v) => new IFC4X3.IfcJunctionBox(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  2696325953: (v) => new IFC4X3.IfcKerb(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), new IFC4X3.IfcBoolean(!v[8] && v[8] != "" ? null : v[8].value)),
  76236018: (v) => new IFC4X3.IfcLamp(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  629592764: (v) => new IFC4X3.IfcLightFixture(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1154579445: (v) => new IFC4X3.IfcLinearPositioningElement(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value)),
  1638804497: (v) => new IFC4X3.IfcLiquidTerminal(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1437502449: (v) => new IFC4X3.IfcMedicalDevice(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1073191201: (v) => new IFC4X3.IfcMember(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  2078563270: (v) => new IFC4X3.IfcMobileTelecommunicationsAppliance(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  234836483: (v) => new IFC4X3.IfcMooringDevice(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  2474470126: (v) => new IFC4X3.IfcMotorConnection(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  2182337498: (v) => new IFC4X3.IfcNavigationElement(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  144952367: (v) => new IFC4X3.IfcOuterBoundaryCurve(v[0]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], new IFC4X3.IfcLogical(!v[1] && v[1] != "" ? null : v[1].value)),
  3694346114: (v) => new IFC4X3.IfcOutlet(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1383356374: (v) => new IFC4X3.IfcPavement(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1687234759: (v) => new IFC4X3.IfcPile(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8], v[9]),
  310824031: (v) => new IFC4X3.IfcPipeFitting(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3612865200: (v) => new IFC4X3.IfcPipeSegment(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3171933400: (v) => new IFC4X3.IfcPlate(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  738039164: (v) => new IFC4X3.IfcProtectiveDevice(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  655969474: (v) => new IFC4X3.IfcProtectiveDeviceTrippingUnitType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  90941305: (v) => new IFC4X3.IfcPump(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3290496277: (v) => new IFC4X3.IfcRail(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  2262370178: (v) => new IFC4X3.IfcRailing(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3024970846: (v) => new IFC4X3.IfcRamp(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3283111854: (v) => new IFC4X3.IfcRampFlight(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1232101972: (v) => new IFC4X3.IfcRationalBSplineCurveWithKnots(new IFC4X3.IfcInteger(!v[0] && v[0] != "" ? null : v[0].value), v[1]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], v[2], new IFC4X3.IfcLogical(!v[3] && v[3] != "" ? null : v[3].value), new IFC4X3.IfcLogical(!v[4] && v[4] != "" ? null : v[4].value), v[5]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcInteger(p.value) : null) || [], v[6]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcParameterValue(p.value) : null) || [], v[7], v[8]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcReal(p.value) : null) || []),
  3798194928: (v) => new IFC4X3.IfcReinforcedSoil(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  979691226: (v) => new IFC4X3.IfcReinforcingBar(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC4X3.IfcAreaMeasure(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[11] && v[11] != "" ? null : v[11].value), v[12], v[13]),
  2572171363: (v) => new IFC4X3.IfcReinforcingBarType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9], !v[10] && v[10] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC4X3.IfcAreaMeasure(!v[11] && v[11] != "" ? null : v[11].value), !v[12] && v[12] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[12] && v[12] != "" ? null : v[12].value), v[13], !v[14] && v[14] != "" ? null : new IFC4X3.IfcLabel(!v[14] && v[14] != "" ? null : v[14].value), !v[15] && v[15] != "" ? null : v[15]?.map((p) => p?.value && p?.value != "" ? TypeInitialiser(3, p) : null) || []),
  2016517767: (v) => new IFC4X3.IfcRoof(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3053780830: (v) => new IFC4X3.IfcSanitaryTerminal(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1783015770: (v) => new IFC4X3.IfcSensorType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1329646415: (v) => new IFC4X3.IfcShadingDevice(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  991950508: (v) => new IFC4X3.IfcSignal(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1529196076: (v) => new IFC4X3.IfcSlab(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3420628829: (v) => new IFC4X3.IfcSolarDevice(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1999602285: (v) => new IFC4X3.IfcSpaceHeater(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1404847402: (v) => new IFC4X3.IfcStackTerminal(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  331165859: (v) => new IFC4X3.IfcStair(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  4252922144: (v) => new IFC4X3.IfcStairFlight(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcInteger(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4X3.IfcInteger(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[10] && v[10] != "" ? null : v[10].value), !v[11] && v[11] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[11] && v[11] != "" ? null : v[11].value), v[12]),
  2515109513: (v) => new IFC4X3.IfcStructuralAnalysisModel(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), v[5], !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : v[7]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[8] && v[8] != "" ? null : v[8]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[9] && v[9] != "" ? null : new Handle(!v[9] && v[9] != "" ? null : v[9].value)),
  385403989: (v) => new IFC4X3.IfcStructuralLoadCase(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), v[5], v[6], v[7], !v[8] && v[8] != "" ? null : new IFC4X3.IfcRatioMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4X3.IfcLabel(!v[9] && v[9] != "" ? null : v[9].value), !v[10] && v[10] != "" ? null : v[10]?.map((p) => p?.value && p?.value != "" ? new IFC4X3.IfcRatioMeasure(p.value) : null) || []),
  1621171031: (v) => new IFC4X3.IfcStructuralPlanarAction(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), new Handle(!v[7] && v[7] != "" ? null : v[7].value), v[8], !v[9] && v[9] != "" ? null : new IFC4X3.IfcBoolean(!v[9] && v[9] != "" ? null : v[9].value), v[10], v[11]),
  1162798199: (v) => new IFC4X3.IfcSwitchingDevice(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  812556717: (v) => new IFC4X3.IfcTank(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3425753595: (v) => new IFC4X3.IfcTrackElement(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3825984169: (v) => new IFC4X3.IfcTransformer(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1620046519: (v) => new IFC4X3.IfcTransportElement(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3026737570: (v) => new IFC4X3.IfcTubeBundle(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3179687236: (v) => new IFC4X3.IfcUnitaryControlElementType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  4292641817: (v) => new IFC4X3.IfcUnitaryEquipment(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  4207607924: (v) => new IFC4X3.IfcValve(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  2391406946: (v) => new IFC4X3.IfcWall(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3512223829: (v) => new IFC4X3.IfcWallStandardCase(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  4237592921: (v) => new IFC4X3.IfcWasteTerminal(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3304561284: (v) => new IFC4X3.IfcWindow(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[8] && v[8] != "" ? null : v[8].value), !v[9] && v[9] != "" ? null : new IFC4X3.IfcPositiveLengthMeasure(!v[9] && v[9] != "" ? null : v[9].value), v[10], v[11], !v[12] && v[12] != "" ? null : new IFC4X3.IfcLabel(!v[12] && v[12] != "" ? null : v[12].value)),
  2874132201: (v) => new IFC4X3.IfcActuatorType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  1634111441: (v) => new IFC4X3.IfcAirTerminal(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  177149247: (v) => new IFC4X3.IfcAirTerminalBox(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  2056796094: (v) => new IFC4X3.IfcAirToAirHeatRecovery(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3001207471: (v) => new IFC4X3.IfcAlarmType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  325726236: (v) => new IFC4X3.IfcAlignment(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), v[7]),
  277319702: (v) => new IFC4X3.IfcAudioVisualAppliance(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  753842376: (v) => new IFC4X3.IfcBeam(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  4196446775: (v) => new IFC4X3.IfcBearing(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  32344328: (v) => new IFC4X3.IfcBoiler(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3314249567: (v) => new IFC4X3.IfcBorehole(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  1095909175: (v) => new IFC4X3.IfcBuildingElementProxy(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  2938176219: (v) => new IFC4X3.IfcBurner(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  635142910: (v) => new IFC4X3.IfcCableCarrierFitting(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3758799889: (v) => new IFC4X3.IfcCableCarrierSegment(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1051757585: (v) => new IFC4X3.IfcCableFitting(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  4217484030: (v) => new IFC4X3.IfcCableSegment(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3999819293: (v) => new IFC4X3.IfcCaissonFoundation(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3902619387: (v) => new IFC4X3.IfcChiller(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  639361253: (v) => new IFC4X3.IfcCoil(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3221913625: (v) => new IFC4X3.IfcCommunicationsAppliance(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3571504051: (v) => new IFC4X3.IfcCompressor(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  2272882330: (v) => new IFC4X3.IfcCondenser(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  578613899: (v) => new IFC4X3.IfcControllerType(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcIdentifier(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : v[5]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[6] && v[6] != "" ? null : v[6]?.map((p) => p?.value && p?.value != "" ? new Handle(p.value) : null) || [], !v[7] && v[7] != "" ? null : new IFC4X3.IfcLabel(!v[7] && v[7] != "" ? null : v[7].value), !v[8] && v[8] != "" ? null : new IFC4X3.IfcLabel(!v[8] && v[8] != "" ? null : v[8].value), v[9]),
  3460952963: (v) => new IFC4X3.IfcConveyorSegment(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  4136498852: (v) => new IFC4X3.IfcCooledBeam(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3640358203: (v) => new IFC4X3.IfcCoolingTower(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  4074379575: (v) => new IFC4X3.IfcDamper(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3693000487: (v) => new IFC4X3.IfcDistributionBoard(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1052013943: (v) => new IFC4X3.IfcDistributionChamberElement(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  562808652: (v) => new IFC4X3.IfcDistributionCircuit(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new IFC4X3.IfcLabel(!v[5] && v[5] != "" ? null : v[5].value), v[6]),
  1062813311: (v) => new IFC4X3.IfcDistributionControlElement(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  342316401: (v) => new IFC4X3.IfcDuctFitting(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3518393246: (v) => new IFC4X3.IfcDuctSegment(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1360408905: (v) => new IFC4X3.IfcDuctSilencer(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1904799276: (v) => new IFC4X3.IfcElectricAppliance(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  862014818: (v) => new IFC4X3.IfcElectricDistributionBoard(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3310460725: (v) => new IFC4X3.IfcElectricFlowStorageDevice(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  24726584: (v) => new IFC4X3.IfcElectricFlowTreatmentDevice(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  264262732: (v) => new IFC4X3.IfcElectricGenerator(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  402227799: (v) => new IFC4X3.IfcElectricMotor(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1003880860: (v) => new IFC4X3.IfcElectricTimeControl(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3415622556: (v) => new IFC4X3.IfcFan(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  819412036: (v) => new IFC4X3.IfcFilter(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  1426591983: (v) => new IFC4X3.IfcFireSuppressionTerminal(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  182646315: (v) => new IFC4X3.IfcFlowInstrument(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  2680139844: (v) => new IFC4X3.IfcGeomodel(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  1971632696: (v) => new IFC4X3.IfcGeoslice(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value)),
  2295281155: (v) => new IFC4X3.IfcProtectiveDeviceTrippingUnit(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  4086658281: (v) => new IFC4X3.IfcSensor(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  630975310: (v) => new IFC4X3.IfcUnitaryControlElement(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  4288193352: (v) => new IFC4X3.IfcActuator(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  3087945054: (v) => new IFC4X3.IfcAlarm(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8]),
  25142252: (v) => new IFC4X3.IfcController(new IFC4X3.IfcGloballyUniqueId(!v[0] && v[0] != "" ? null : v[0].value), !v[1] && v[1] != "" ? null : new Handle(!v[1] && v[1] != "" ? null : v[1].value), !v[2] && v[2] != "" ? null : new IFC4X3.IfcLabel(!v[2] && v[2] != "" ? null : v[2].value), !v[3] && v[3] != "" ? null : new IFC4X3.IfcText(!v[3] && v[3] != "" ? null : v[3].value), !v[4] && v[4] != "" ? null : new IFC4X3.IfcLabel(!v[4] && v[4] != "" ? null : v[4].value), !v[5] && v[5] != "" ? null : new Handle(!v[5] && v[5] != "" ? null : v[5].value), !v[6] && v[6] != "" ? null : new Handle(!v[6] && v[6] != "" ? null : v[6].value), !v[7] && v[7] != "" ? null : new IFC4X3.IfcIdentifier(!v[7] && v[7] != "" ? null : v[7].value), v[8])
};
InheritanceDef[3] = {
  618182010: [IFCTELECOMADDRESS, IFCPOSTALADDRESS],
  2879124712: [IFCALIGNMENTHORIZONTALSEGMENT, IFCALIGNMENTCANTSEGMENT, IFCALIGNMENTVERTICALSEGMENT],
  411424972: [IFCCOSTVALUE],
  4037036970: [IFCBOUNDARYNODECONDITIONWARPING, IFCBOUNDARYNODECONDITION, IFCBOUNDARYFACECONDITION, IFCBOUNDARYEDGECONDITION],
  1387855156: [IFCBOUNDARYNODECONDITIONWARPING],
  2859738748: [IFCCONNECTIONCURVEGEOMETRY, IFCCONNECTIONVOLUMEGEOMETRY, IFCCONNECTIONSURFACEGEOMETRY, IFCCONNECTIONPOINTECCENTRICITY, IFCCONNECTIONPOINTGEOMETRY],
  2614616156: [IFCCONNECTIONPOINTECCENTRICITY],
  1959218052: [IFCOBJECTIVE, IFCMETRIC],
  1785450214: [IFCMAPCONVERSION],
  1466758467: [IFCPROJECTEDCRS],
  4294318154: [IFCDOCUMENTINFORMATION, IFCCLASSIFICATION, IFCLIBRARYINFORMATION],
  3200245327: [IFCDOCUMENTREFERENCE, IFCCLASSIFICATIONREFERENCE, IFCLIBRARYREFERENCE, IFCEXTERNALLYDEFINEDTEXTFONT, IFCEXTERNALLYDEFINEDSURFACESTYLE, IFCEXTERNALLYDEFINEDHATCHSTYLE],
  760658860: [IFCMATERIALCONSTITUENTSET, IFCMATERIALCONSTITUENT, IFCMATERIAL, IFCMATERIALPROFILESET, IFCMATERIALPROFILEWITHOFFSETS, IFCMATERIALPROFILE, IFCMATERIALLAYERSET, IFCMATERIALLAYERWITHOFFSETS, IFCMATERIALLAYER],
  248100487: [IFCMATERIALLAYERWITHOFFSETS],
  2235152071: [IFCMATERIALPROFILEWITHOFFSETS],
  1507914824: [IFCMATERIALPROFILESETUSAGETAPERING, IFCMATERIALPROFILESETUSAGE, IFCMATERIALLAYERSETUSAGE],
  1918398963: [IFCCONVERSIONBASEDUNITWITHOFFSET, IFCCONVERSIONBASEDUNIT, IFCCONTEXTDEPENDENTUNIT, IFCSIUNIT],
  3701648758: [IFCLOCALPLACEMENT, IFCLINEARPLACEMENT, IFCGRIDPLACEMENT],
  2483315170: [IFCPHYSICALCOMPLEXQUANTITY, IFCQUANTITYWEIGHT, IFCQUANTITYVOLUME, IFCQUANTITYTIME, IFCQUANTITYNUMBER, IFCQUANTITYLENGTH, IFCQUANTITYCOUNT, IFCQUANTITYAREA, IFCPHYSICALSIMPLEQUANTITY],
  2226359599: [IFCQUANTITYWEIGHT, IFCQUANTITYVOLUME, IFCQUANTITYTIME, IFCQUANTITYNUMBER, IFCQUANTITYLENGTH, IFCQUANTITYCOUNT, IFCQUANTITYAREA],
  677532197: [IFCDRAUGHTINGPREDEFINEDCURVEFONT, IFCPREDEFINEDCURVEFONT, IFCDRAUGHTINGPREDEFINEDCOLOUR, IFCPREDEFINEDCOLOUR, IFCTEXTSTYLEFONTMODEL, IFCPREDEFINEDTEXTFONT, IFCPREDEFINEDITEM, IFCINDEXEDCOLOURMAP, IFCCURVESTYLEFONTPATTERN, IFCCURVESTYLEFONTANDSCALING, IFCCURVESTYLEFONT, IFCCOLOURRGB, IFCCOLOURSPECIFICATION, IFCCOLOURRGBLIST, IFCTEXTUREVERTEXLIST, IFCTEXTUREVERTEX, IFCINDEXEDPOLYGONALTEXTUREMAP, IFCINDEXEDTRIANGLETEXTUREMAP, IFCINDEXEDTEXTUREMAP, IFCTEXTUREMAP, IFCTEXTURECOORDINATEGENERATOR, IFCTEXTURECOORDINATE, IFCTEXTSTYLETEXTMODEL, IFCTEXTSTYLEFORDEFINEDFONT, IFCPIXELTEXTURE, IFCIMAGETEXTURE, IFCBLOBTEXTURE, IFCSURFACETEXTURE, IFCSURFACESTYLEWITHTEXTURES, IFCSURFACESTYLERENDERING, IFCSURFACESTYLESHADING, IFCSURFACESTYLEREFRACTION, IFCSURFACESTYLELIGHTING],
  2022622350: [IFCPRESENTATIONLAYERWITHSTYLE],
  3119450353: [IFCFILLAREASTYLE, IFCCURVESTYLE, IFCTEXTSTYLE, IFCSURFACESTYLE],
  2095639259: [IFCPRODUCTDEFINITIONSHAPE, IFCMATERIALDEFINITIONREPRESENTATION],
  3958567839: [IFCLSHAPEPROFILEDEF, IFCISHAPEPROFILEDEF, IFCELLIPSEPROFILEDEF, IFCCIRCLEHOLLOWPROFILEDEF, IFCCIRCLEPROFILEDEF, IFCCSHAPEPROFILEDEF, IFCASYMMETRICISHAPEPROFILEDEF, IFCZSHAPEPROFILEDEF, IFCUSHAPEPROFILEDEF, IFCTRAPEZIUMPROFILEDEF, IFCTSHAPEPROFILEDEF, IFCRECTANGLEHOLLOWPROFILEDEF, IFCROUNDEDRECTANGLEPROFILEDEF, IFCRECTANGLEPROFILEDEF, IFCPARAMETERIZEDPROFILEDEF, IFCOPENCROSSPROFILEDEF, IFCMIRROREDPROFILEDEF, IFCDERIVEDPROFILEDEF, IFCCOMPOSITEPROFILEDEF, IFCCENTERLINEPROFILEDEF, IFCARBITRARYOPENPROFILEDEF, IFCARBITRARYPROFILEDEFWITHVOIDS, IFCARBITRARYCLOSEDPROFILEDEF],
  986844984: [IFCCOMPLEXPROPERTY, IFCPROPERTYTABLEVALUE, IFCPROPERTYSINGLEVALUE, IFCPROPERTYREFERENCEVALUE, IFCPROPERTYLISTVALUE, IFCPROPERTYENUMERATEDVALUE, IFCPROPERTYBOUNDEDVALUE, IFCSIMPLEPROPERTY, IFCPROPERTY, IFCSECTIONREINFORCEMENTPROPERTIES, IFCSECTIONPROPERTIES, IFCREINFORCEMENTBARPROPERTIES, IFCPREDEFINEDPROPERTIES, IFCPROFILEPROPERTIES, IFCMATERIALPROPERTIES, IFCEXTENDEDPROPERTIES, IFCPROPERTYENUMERATION],
  1076942058: [IFCSTYLEDREPRESENTATION, IFCSTYLEMODEL, IFCTOPOLOGYREPRESENTATION, IFCSHAPEREPRESENTATION, IFCSHAPEMODEL],
  3377609919: [IFCGEOMETRICREPRESENTATIONSUBCONTEXT, IFCGEOMETRICREPRESENTATIONCONTEXT],
  3008791417: [IFCMAPPEDITEM, IFCFILLAREASTYLETILES, IFCFILLAREASTYLEHATCHING, IFCFACEBASEDSURFACEMODEL, IFCDIRECTION, IFCCIRCLE, IFCELLIPSE, IFCCONIC, IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFCINDEXEDPOLYCURVE, IFCSEGMENTEDREFERENCECURVE, IFCGRADIENTCURVE, IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE, IFCCOMPOSITECURVE, IFCBOUNDEDCURVE, IFCSEAMCURVE, IFCINTERSECTIONCURVE, IFCSURFACECURVE, IFCSINESPIRAL, IFCSEVENTHORDERPOLYNOMIALSPIRAL, IFCSECONDORDERPOLYNOMIALSPIRAL, IFCCOSINESPIRAL, IFCCLOTHOID, IFCTHIRDORDERPOLYNOMIALSPIRAL, IFCSPIRAL, IFCPOLYNOMIALCURVE, IFCPCURVE, IFCOFFSETCURVEBYDISTANCES, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D, IFCOFFSETCURVE, IFCLINE, IFCCURVE, IFCBLOCK, IFCSPHERE, IFCRIGHTCIRCULARCYLINDER, IFCRIGHTCIRCULARCONE, IFCRECTANGULARPYRAMID, IFCCSGPRIMITIVE3D, IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR3D, IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR2D, IFCCARTESIANTRANSFORMATIONOPERATOR, IFCCARTESIANPOINTLIST3D, IFCCARTESIANPOINTLIST2D, IFCCARTESIANPOINTLIST, IFCBOUNDINGBOX, IFCBOOLEANCLIPPINGRESULT, IFCBOOLEANRESULT, IFCANNOTATIONFILLAREA, IFCVECTOR, IFCTEXTLITERALWITHEXTENT, IFCTEXTLITERAL, IFCPOLYGONALFACESET, IFCTRIANGULATEDIRREGULARNETWORK, IFCTRIANGULATEDFACESET, IFCTESSELLATEDFACESET, IFCINDEXEDPOLYGONALFACEWITHVOIDS, IFCINDEXEDPOLYGONALFACE, IFCTESSELLATEDITEM, IFCSECTIONEDSURFACE, IFCCYLINDRICALSURFACE, IFCTOROIDALSURFACE, IFCSPHERICALSURFACE, IFCPLANE, IFCELEMENTARYSURFACE, IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDSURFACE, IFCCURVEBOUNDEDPLANE, IFCBOUNDEDSURFACE, IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION, IFCSWEPTSURFACE, IFCSURFACE, IFCSECTIONEDSOLIDHORIZONTAL, IFCSECTIONEDSOLID, IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCADVANCEDBREPWITHVOIDS, IFCADVANCEDBREP, IFCMANIFOLDSOLIDBREP, IFCCSGSOLID, IFCSWEPTDISKSOLIDPOLYGONAL, IFCSWEPTDISKSOLID, IFCREVOLVEDAREASOLIDTAPERED, IFCREVOLVEDAREASOLID, IFCEXTRUDEDAREASOLIDTAPERED, IFCEXTRUDEDAREASOLID, IFCSURFACECURVESWEPTAREASOLID, IFCDIRECTRIXDERIVEDREFERENCESWEPTAREASOLID, IFCFIXEDREFERENCESWEPTAREASOLID, IFCDIRECTRIXCURVESWEPTAREASOLID, IFCSWEPTAREASOLID, IFCSOLIDMODEL, IFCSHELLBASEDSURFACEMODEL, IFCCURVESEGMENT, IFCREPARAMETRISEDCOMPOSITECURVESEGMENT, IFCCOMPOSITECURVESEGMENT, IFCSEGMENT, IFCSECTIONEDSPINE, IFCCARTESIANPOINT, IFCPOINTONSURFACE, IFCPOINTONCURVE, IFCPOINTBYDISTANCEEXPRESSION, IFCPOINT, IFCPLANARBOX, IFCPLANAREXTENT, IFCAXIS2PLACEMENTLINEAR, IFCAXIS2PLACEMENT3D, IFCAXIS2PLACEMENT2D, IFCAXIS1PLACEMENT, IFCPLACEMENT, IFCLIGHTSOURCESPOT, IFCLIGHTSOURCEPOSITIONAL, IFCLIGHTSOURCEGONIOMETRIC, IFCLIGHTSOURCEDIRECTIONAL, IFCLIGHTSOURCEAMBIENT, IFCLIGHTSOURCE, IFCBOXEDHALFSPACE, IFCPOLYGONALBOUNDEDHALFSPACE, IFCHALFSPACESOLID, IFCGEOMETRICCURVESET, IFCGEOMETRICSET, IFCGEOMETRICREPRESENTATIONITEM, IFCPATH, IFCEDGELOOP, IFCVERTEXLOOP, IFCPOLYLOOP, IFCLOOP, IFCFACEOUTERBOUND, IFCFACEBOUND, IFCADVANCEDFACE, IFCFACESURFACE, IFCFACE, IFCSUBEDGE, IFCORIENTEDEDGE, IFCEDGECURVE, IFCEDGE, IFCCLOSEDSHELL, IFCOPENSHELL, IFCCONNECTEDFACESET, IFCVERTEXPOINT, IFCVERTEX, IFCTOPOLOGICALREPRESENTATIONITEM, IFCSTYLEDITEM],
  2439245199: [IFCRESOURCECONSTRAINTRELATIONSHIP, IFCRESOURCEAPPROVALRELATIONSHIP, IFCPROPERTYDEPENDENCYRELATIONSHIP, IFCORGANIZATIONRELATIONSHIP, IFCMATERIALRELATIONSHIP, IFCEXTERNALREFERENCERELATIONSHIP, IFCDOCUMENTINFORMATIONRELATIONSHIP, IFCCURRENCYRELATIONSHIP, IFCAPPROVALRELATIONSHIP],
  2341007311: [IFCRELDEFINESBYTYPE, IFCRELDEFINESBYTEMPLATE, IFCRELDEFINESBYPROPERTIES, IFCRELDEFINESBYOBJECT, IFCRELDEFINES, IFCRELAGGREGATES, IFCRELADHERESTOELEMENT, IFCRELVOIDSELEMENT, IFCRELPROJECTSELEMENT, IFCRELNESTS, IFCRELDECOMPOSES, IFCRELDECLARES, IFCRELSPACEBOUNDARY2NDLEVEL, IFCRELSPACEBOUNDARY1STLEVEL, IFCRELSPACEBOUNDARY, IFCRELSERVICESBUILDINGS, IFCRELSEQUENCE, IFCRELREFERENCEDINSPATIALSTRUCTURE, IFCRELPOSITIONS, IFCRELINTERFERESELEMENTS, IFCRELFLOWCONTROLELEMENTS, IFCRELFILLSELEMENT, IFCRELCOVERSSPACES, IFCRELCOVERSBLDGELEMENTS, IFCRELCONTAINEDINSPATIALSTRUCTURE, IFCRELCONNECTSWITHECCENTRICITY, IFCRELCONNECTSSTRUCTURALMEMBER, IFCRELCONNECTSSTRUCTURALACTIVITY, IFCRELCONNECTSPORTS, IFCRELCONNECTSPORTTOELEMENT, IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS, IFCRELCONNECTSELEMENTS, IFCRELCONNECTS, IFCRELASSOCIATESPROFILEDEF, IFCRELASSOCIATESMATERIAL, IFCRELASSOCIATESLIBRARY, IFCRELASSOCIATESDOCUMENT, IFCRELASSOCIATESCONSTRAINT, IFCRELASSOCIATESCLASSIFICATION, IFCRELASSOCIATESAPPROVAL, IFCRELASSOCIATES, IFCRELASSIGNSTORESOURCE, IFCRELASSIGNSTOPRODUCT, IFCRELASSIGNSTOPROCESS, IFCRELASSIGNSTOGROUPBYFACTOR, IFCRELASSIGNSTOGROUP, IFCRELASSIGNSTOCONTROL, IFCRELASSIGNSTOACTOR, IFCRELASSIGNS, IFCRELATIONSHIP, IFCCOMPLEXPROPERTYTEMPLATE, IFCSIMPLEPROPERTYTEMPLATE, IFCPROPERTYTEMPLATE, IFCPROPERTYSETTEMPLATE, IFCPROPERTYTEMPLATEDEFINITION, IFCPROPERTYSET, IFCPERMEABLECOVERINGPROPERTIES, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCREINFORCEMENTDEFINITIONPROPERTIES, IFCPREDEFINEDPROPERTYSET, IFCELEMENTQUANTITY, IFCQUANTITYSET, IFCPROPERTYSETDEFINITION, IFCPROPERTYDEFINITION, IFCASSET, IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILTSYSTEM, IFCBUILDINGSYSTEM, IFCZONE, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADCASE, IFCSTRUCTURALLOADGROUP, IFCINVENTORY, IFCGROUP, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCWORKCALENDAR, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCCOSTSCHEDULE, IFCCOSTITEM, IFCCONTROL, IFCOCCUPANT, IFCACTOR, IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE, IFCRESOURCE, IFCALIGNMENT, IFCLINEARPOSITIONINGELEMENT, IFCGRID, IFCREFERENT, IFCPOSITIONINGELEMENT, IFCDISTRIBUTIONPORT, IFCPORT, IFCALIGNMENTVERTICAL, IFCALIGNMENTSEGMENT, IFCALIGNMENTHORIZONTAL, IFCALIGNMENTCANT, IFCLINEARELEMENT, IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCELECTRICFLOWTREATMENTDEVICE, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSIGNAL, IFCSANITARYTERMINAL, IFCOUTLET, IFCMOBILETELECOMMUNICATIONSAPPLIANCE, IFCMEDICALDEVICE, IFCLIQUIDTERMINAL, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCONVEYORSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBUILDINGELEMENTPROXY, IFCBEARING, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCTRACKELEMENT, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCRAIL, IFCPLATE, IFCPAVEMENT, IFCNAVIGATIONELEMENT, IFCMOORINGDEVICE, IFCMEMBER, IFCKERB, IFCFOOTING, IFCREINFORCEDSOIL, IFCEARTHWORKSFILL, IFCEARTHWORKSELEMENT, IFCDOOR, IFCCAISSONFOUNDATION, IFCPILE, IFCDEEPFOUNDATION, IFCCURTAINWALL, IFCCOVERING, IFCCOURSE, IFCCOLUMN, IFCCHIMNEY, IFCBUILTELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCVEHICLE, IFCTRANSPORTATIONDEVICE, IFCGEOSLICE, IFCGEOMODEL, IFCBOREHOLE, IFCGEOTECHNICALASSEMBLY, IFCGEOTECHNICALSTRATUM, IFCGEOTECHNICALELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCEARTHWORKSCUT, IFCVOIDINGFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCVIBRATIONDAMPER, IFCSIGN, IFCREINFORCINGBAR, IFCTENDONCONDUIT, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCIMPACTPROTECTIONDEVICE, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBRIDGEPART, IFCROADPART, IFCRAILWAYPART, IFCMARINEPART, IFCFACILITYPARTCOMMON, IFCFACILITYPART, IFCBUILDING, IFCBRIDGE, IFCROAD, IFCRAILWAY, IFCMARINEFACILITY, IFCFACILITY, IFCBUILDINGSTOREY, IFCSPATIALSTRUCTUREELEMENT, IFCSPATIALELEMENT, IFCPRODUCT, IFCPROCEDURE, IFCEVENT, IFCTASK, IFCPROCESS, IFCOBJECT, IFCPROJECTLIBRARY, IFCPROJECT, IFCCONTEXT, IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE, IFCCONSTRUCTIONRESOURCETYPE, IFCTYPERESOURCE, IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSPATIALELEMENTTYPE, IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCVIBRATIONDAMPERTYPE, IFCSIGNTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONCONDUITTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCIMPACTPROTECTIONDEVICETYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCELECTRICFLOWTREATMENTDEVICETYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSIGNALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE, IFCMEDICALDEVICETYPE, IFCLIQUIDTERMINALTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCONVEYORSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEARINGTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCTRACKELEMENTTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCRAILTYPE, IFCPLATETYPE, IFCPAVEMENTTYPE, IFCNAVIGATIONELEMENTTYPE, IFCMOORINGDEVICETYPE, IFCMEMBERTYPE, IFCKERBTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCAISSONFOUNDATIONTYPE, IFCPILETYPE, IFCDEEPFOUNDATIONTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOURSETYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILTELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCVEHICLETYPE, IFCTRANSPORTATIONDEVICETYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCTYPEPRODUCT, IFCTASKTYPE, IFCPROCEDURETYPE, IFCEVENTTYPE, IFCTYPEPROCESS, IFCTYPEOBJECT, IFCOBJECTDEFINITION],
  1054537805: [IFCRESOURCETIME, IFCLAGTIME, IFCEVENTTIME, IFCWORKTIME, IFCTASKTIMERECURRING, IFCTASKTIME],
  3982875396: [IFCTOPOLOGYREPRESENTATION, IFCSHAPEREPRESENTATION],
  2273995522: [IFCSLIPPAGECONNECTIONCONDITION, IFCFAILURECONNECTIONCONDITION],
  2162789131: [IFCSURFACEREINFORCEMENTAREA, IFCSTRUCTURALLOADSINGLEFORCEWARPING, IFCSTRUCTURALLOADSINGLEFORCE, IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION, IFCSTRUCTURALLOADSINGLEDISPLACEMENT, IFCSTRUCTURALLOADPLANARFORCE, IFCSTRUCTURALLOADLINEARFORCE, IFCSTRUCTURALLOADTEMPERATURE, IFCSTRUCTURALLOADSTATIC, IFCSTRUCTURALLOADORRESULT, IFCSTRUCTURALLOADCONFIGURATION],
  609421318: [IFCSURFACEREINFORCEMENTAREA, IFCSTRUCTURALLOADSINGLEFORCEWARPING, IFCSTRUCTURALLOADSINGLEFORCE, IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION, IFCSTRUCTURALLOADSINGLEDISPLACEMENT, IFCSTRUCTURALLOADPLANARFORCE, IFCSTRUCTURALLOADLINEARFORCE, IFCSTRUCTURALLOADTEMPERATURE, IFCSTRUCTURALLOADSTATIC],
  2525727697: [IFCSTRUCTURALLOADSINGLEFORCEWARPING, IFCSTRUCTURALLOADSINGLEFORCE, IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION, IFCSTRUCTURALLOADSINGLEDISPLACEMENT, IFCSTRUCTURALLOADPLANARFORCE, IFCSTRUCTURALLOADLINEARFORCE, IFCSTRUCTURALLOADTEMPERATURE],
  2830218821: [IFCSTYLEDREPRESENTATION],
  846575682: [IFCSURFACESTYLERENDERING],
  626085974: [IFCPIXELTEXTURE, IFCIMAGETEXTURE, IFCBLOBTEXTURE],
  1549132990: [IFCTASKTIMERECURRING],
  280115917: [IFCINDEXEDPOLYGONALTEXTUREMAP, IFCINDEXEDTRIANGLETEXTUREMAP, IFCINDEXEDTEXTUREMAP, IFCTEXTUREMAP, IFCTEXTURECOORDINATEGENERATOR],
  222769930: [IFCTEXTURECOORDINATEINDICESWITHVOIDS],
  3101149627: [IFCREGULARTIMESERIES, IFCIRREGULARTIMESERIES],
  1377556343: [IFCPATH, IFCEDGELOOP, IFCVERTEXLOOP, IFCPOLYLOOP, IFCLOOP, IFCFACEOUTERBOUND, IFCFACEBOUND, IFCADVANCEDFACE, IFCFACESURFACE, IFCFACE, IFCSUBEDGE, IFCORIENTEDEDGE, IFCEDGECURVE, IFCEDGE, IFCCLOSEDSHELL, IFCOPENSHELL, IFCCONNECTEDFACESET, IFCVERTEXPOINT, IFCVERTEX],
  2799835756: [IFCVERTEXPOINT],
  3798115385: [IFCARBITRARYPROFILEDEFWITHVOIDS],
  1310608509: [IFCCENTERLINEPROFILEDEF],
  3264961684: [IFCCOLOURRGB],
  370225590: [IFCCLOSEDSHELL, IFCOPENSHELL],
  2889183280: [IFCCONVERSIONBASEDUNITWITHOFFSET],
  3632507154: [IFCMIRROREDPROFILEDEF],
  3900360178: [IFCSUBEDGE, IFCORIENTEDEDGE, IFCEDGECURVE],
  297599258: [IFCPROFILEPROPERTIES, IFCMATERIALPROPERTIES],
  2556980723: [IFCADVANCEDFACE, IFCFACESURFACE],
  1809719519: [IFCFACEOUTERBOUND],
  3008276851: [IFCADVANCEDFACE],
  3448662350: [IFCGEOMETRICREPRESENTATIONSUBCONTEXT],
  2453401579: [IFCFILLAREASTYLETILES, IFCFILLAREASTYLEHATCHING, IFCFACEBASEDSURFACEMODEL, IFCDIRECTION, IFCCIRCLE, IFCELLIPSE, IFCCONIC, IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFCINDEXEDPOLYCURVE, IFCSEGMENTEDREFERENCECURVE, IFCGRADIENTCURVE, IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE, IFCCOMPOSITECURVE, IFCBOUNDEDCURVE, IFCSEAMCURVE, IFCINTERSECTIONCURVE, IFCSURFACECURVE, IFCSINESPIRAL, IFCSEVENTHORDERPOLYNOMIALSPIRAL, IFCSECONDORDERPOLYNOMIALSPIRAL, IFCCOSINESPIRAL, IFCCLOTHOID, IFCTHIRDORDERPOLYNOMIALSPIRAL, IFCSPIRAL, IFCPOLYNOMIALCURVE, IFCPCURVE, IFCOFFSETCURVEBYDISTANCES, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D, IFCOFFSETCURVE, IFCLINE, IFCCURVE, IFCBLOCK, IFCSPHERE, IFCRIGHTCIRCULARCYLINDER, IFCRIGHTCIRCULARCONE, IFCRECTANGULARPYRAMID, IFCCSGPRIMITIVE3D, IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR3D, IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR2D, IFCCARTESIANTRANSFORMATIONOPERATOR, IFCCARTESIANPOINTLIST3D, IFCCARTESIANPOINTLIST2D, IFCCARTESIANPOINTLIST, IFCBOUNDINGBOX, IFCBOOLEANCLIPPINGRESULT, IFCBOOLEANRESULT, IFCANNOTATIONFILLAREA, IFCVECTOR, IFCTEXTLITERALWITHEXTENT, IFCTEXTLITERAL, IFCPOLYGONALFACESET, IFCTRIANGULATEDIRREGULARNETWORK, IFCTRIANGULATEDFACESET, IFCTESSELLATEDFACESET, IFCINDEXEDPOLYGONALFACEWITHVOIDS, IFCINDEXEDPOLYGONALFACE, IFCTESSELLATEDITEM, IFCSECTIONEDSURFACE, IFCCYLINDRICALSURFACE, IFCTOROIDALSURFACE, IFCSPHERICALSURFACE, IFCPLANE, IFCELEMENTARYSURFACE, IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDSURFACE, IFCCURVEBOUNDEDPLANE, IFCBOUNDEDSURFACE, IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION, IFCSWEPTSURFACE, IFCSURFACE, IFCSECTIONEDSOLIDHORIZONTAL, IFCSECTIONEDSOLID, IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCADVANCEDBREPWITHVOIDS, IFCADVANCEDBREP, IFCMANIFOLDSOLIDBREP, IFCCSGSOLID, IFCSWEPTDISKSOLIDPOLYGONAL, IFCSWEPTDISKSOLID, IFCREVOLVEDAREASOLIDTAPERED, IFCREVOLVEDAREASOLID, IFCEXTRUDEDAREASOLIDTAPERED, IFCEXTRUDEDAREASOLID, IFCSURFACECURVESWEPTAREASOLID, IFCDIRECTRIXDERIVEDREFERENCESWEPTAREASOLID, IFCFIXEDREFERENCESWEPTAREASOLID, IFCDIRECTRIXCURVESWEPTAREASOLID, IFCSWEPTAREASOLID, IFCSOLIDMODEL, IFCSHELLBASEDSURFACEMODEL, IFCCURVESEGMENT, IFCREPARAMETRISEDCOMPOSITECURVESEGMENT, IFCCOMPOSITECURVESEGMENT, IFCSEGMENT, IFCSECTIONEDSPINE, IFCCARTESIANPOINT, IFCPOINTONSURFACE, IFCPOINTONCURVE, IFCPOINTBYDISTANCEEXPRESSION, IFCPOINT, IFCPLANARBOX, IFCPLANAREXTENT, IFCAXIS2PLACEMENTLINEAR, IFCAXIS2PLACEMENT3D, IFCAXIS2PLACEMENT2D, IFCAXIS1PLACEMENT, IFCPLACEMENT, IFCLIGHTSOURCESPOT, IFCLIGHTSOURCEPOSITIONAL, IFCLIGHTSOURCEGONIOMETRIC, IFCLIGHTSOURCEDIRECTIONAL, IFCLIGHTSOURCEAMBIENT, IFCLIGHTSOURCE, IFCBOXEDHALFSPACE, IFCPOLYGONALBOUNDEDHALFSPACE, IFCHALFSPACESOLID, IFCGEOMETRICCURVESET, IFCGEOMETRICSET],
  3590301190: [IFCGEOMETRICCURVESET],
  812098782: [IFCBOXEDHALFSPACE, IFCPOLYGONALBOUNDEDHALFSPACE],
  1437953363: [IFCINDEXEDPOLYGONALTEXTUREMAP, IFCINDEXEDTRIANGLETEXTUREMAP],
  1402838566: [IFCLIGHTSOURCESPOT, IFCLIGHTSOURCEPOSITIONAL, IFCLIGHTSOURCEGONIOMETRIC, IFCLIGHTSOURCEDIRECTIONAL, IFCLIGHTSOURCEAMBIENT],
  1520743889: [IFCLIGHTSOURCESPOT],
  1008929658: [IFCEDGELOOP, IFCVERTEXLOOP, IFCPOLYLOOP],
  3079605661: [IFCMATERIALPROFILESETUSAGETAPERING],
  219451334: [IFCASSET, IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILTSYSTEM, IFCBUILDINGSYSTEM, IFCZONE, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADCASE, IFCSTRUCTURALLOADGROUP, IFCINVENTORY, IFCGROUP, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCWORKCALENDAR, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCCOSTSCHEDULE, IFCCOSTITEM, IFCCONTROL, IFCOCCUPANT, IFCACTOR, IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE, IFCRESOURCE, IFCALIGNMENT, IFCLINEARPOSITIONINGELEMENT, IFCGRID, IFCREFERENT, IFCPOSITIONINGELEMENT, IFCDISTRIBUTIONPORT, IFCPORT, IFCALIGNMENTVERTICAL, IFCALIGNMENTSEGMENT, IFCALIGNMENTHORIZONTAL, IFCALIGNMENTCANT, IFCLINEARELEMENT, IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCELECTRICFLOWTREATMENTDEVICE, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSIGNAL, IFCSANITARYTERMINAL, IFCOUTLET, IFCMOBILETELECOMMUNICATIONSAPPLIANCE, IFCMEDICALDEVICE, IFCLIQUIDTERMINAL, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCONVEYORSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBUILDINGELEMENTPROXY, IFCBEARING, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCTRACKELEMENT, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCRAIL, IFCPLATE, IFCPAVEMENT, IFCNAVIGATIONELEMENT, IFCMOORINGDEVICE, IFCMEMBER, IFCKERB, IFCFOOTING, IFCREINFORCEDSOIL, IFCEARTHWORKSFILL, IFCEARTHWORKSELEMENT, IFCDOOR, IFCCAISSONFOUNDATION, IFCPILE, IFCDEEPFOUNDATION, IFCCURTAINWALL, IFCCOVERING, IFCCOURSE, IFCCOLUMN, IFCCHIMNEY, IFCBUILTELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCVEHICLE, IFCTRANSPORTATIONDEVICE, IFCGEOSLICE, IFCGEOMODEL, IFCBOREHOLE, IFCGEOTECHNICALASSEMBLY, IFCGEOTECHNICALSTRATUM, IFCGEOTECHNICALELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCEARTHWORKSCUT, IFCVOIDINGFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCVIBRATIONDAMPER, IFCSIGN, IFCREINFORCINGBAR, IFCTENDONCONDUIT, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCIMPACTPROTECTIONDEVICE, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBRIDGEPART, IFCROADPART, IFCRAILWAYPART, IFCMARINEPART, IFCFACILITYPARTCOMMON, IFCFACILITYPART, IFCBUILDING, IFCBRIDGE, IFCROAD, IFCRAILWAY, IFCMARINEFACILITY, IFCFACILITY, IFCBUILDINGSTOREY, IFCSPATIALSTRUCTUREELEMENT, IFCSPATIALELEMENT, IFCPRODUCT, IFCPROCEDURE, IFCEVENT, IFCTASK, IFCPROCESS, IFCOBJECT, IFCPROJECTLIBRARY, IFCPROJECT, IFCCONTEXT, IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE, IFCCONSTRUCTIONRESOURCETYPE, IFCTYPERESOURCE, IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSPATIALELEMENTTYPE, IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCVIBRATIONDAMPERTYPE, IFCSIGNTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONCONDUITTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCIMPACTPROTECTIONDEVICETYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCELECTRICFLOWTREATMENTDEVICETYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSIGNALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE, IFCMEDICALDEVICETYPE, IFCLIQUIDTERMINALTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCONVEYORSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEARINGTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCTRACKELEMENTTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCRAILTYPE, IFCPLATETYPE, IFCPAVEMENTTYPE, IFCNAVIGATIONELEMENTTYPE, IFCMOORINGDEVICETYPE, IFCMEMBERTYPE, IFCKERBTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCAISSONFOUNDATIONTYPE, IFCPILETYPE, IFCDEEPFOUNDATIONTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOURSETYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILTELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCVEHICLETYPE, IFCTRANSPORTATIONDEVICETYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCTYPEPRODUCT, IFCTASKTYPE, IFCPROCEDURETYPE, IFCEVENTTYPE, IFCTYPEPROCESS, IFCTYPEOBJECT],
  2529465313: [IFCLSHAPEPROFILEDEF, IFCISHAPEPROFILEDEF, IFCELLIPSEPROFILEDEF, IFCCIRCLEHOLLOWPROFILEDEF, IFCCIRCLEPROFILEDEF, IFCCSHAPEPROFILEDEF, IFCASYMMETRICISHAPEPROFILEDEF, IFCZSHAPEPROFILEDEF, IFCUSHAPEPROFILEDEF, IFCTRAPEZIUMPROFILEDEF, IFCTSHAPEPROFILEDEF, IFCRECTANGLEHOLLOWPROFILEDEF, IFCROUNDEDRECTANGLEPROFILEDEF, IFCRECTANGLEPROFILEDEF],
  2004835150: [IFCAXIS2PLACEMENTLINEAR, IFCAXIS2PLACEMENT3D, IFCAXIS2PLACEMENT2D, IFCAXIS1PLACEMENT],
  1663979128: [IFCPLANARBOX],
  2067069095: [IFCCARTESIANPOINT, IFCPOINTONSURFACE, IFCPOINTONCURVE, IFCPOINTBYDISTANCEEXPRESSION],
  3727388367: [IFCDRAUGHTINGPREDEFINEDCURVEFONT, IFCPREDEFINEDCURVEFONT, IFCDRAUGHTINGPREDEFINEDCOLOUR, IFCPREDEFINEDCOLOUR, IFCTEXTSTYLEFONTMODEL, IFCPREDEFINEDTEXTFONT],
  3778827333: [IFCSECTIONREINFORCEMENTPROPERTIES, IFCSECTIONPROPERTIES, IFCREINFORCEMENTBARPROPERTIES],
  1775413392: [IFCTEXTSTYLEFONTMODEL],
  2598011224: [IFCCOMPLEXPROPERTY, IFCPROPERTYTABLEVALUE, IFCPROPERTYSINGLEVALUE, IFCPROPERTYREFERENCEVALUE, IFCPROPERTYLISTVALUE, IFCPROPERTYENUMERATEDVALUE, IFCPROPERTYBOUNDEDVALUE, IFCSIMPLEPROPERTY],
  1680319473: [IFCCOMPLEXPROPERTYTEMPLATE, IFCSIMPLEPROPERTYTEMPLATE, IFCPROPERTYTEMPLATE, IFCPROPERTYSETTEMPLATE, IFCPROPERTYTEMPLATEDEFINITION, IFCPROPERTYSET, IFCPERMEABLECOVERINGPROPERTIES, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCREINFORCEMENTDEFINITIONPROPERTIES, IFCPREDEFINEDPROPERTYSET, IFCELEMENTQUANTITY, IFCQUANTITYSET, IFCPROPERTYSETDEFINITION],
  3357820518: [IFCPROPERTYSET, IFCPERMEABLECOVERINGPROPERTIES, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCREINFORCEMENTDEFINITIONPROPERTIES, IFCPREDEFINEDPROPERTYSET, IFCELEMENTQUANTITY, IFCQUANTITYSET],
  1482703590: [IFCCOMPLEXPROPERTYTEMPLATE, IFCSIMPLEPROPERTYTEMPLATE, IFCPROPERTYTEMPLATE, IFCPROPERTYSETTEMPLATE],
  2090586900: [IFCELEMENTQUANTITY],
  3615266464: [IFCRECTANGLEHOLLOWPROFILEDEF, IFCROUNDEDRECTANGLEPROFILEDEF],
  478536968: [IFCRELDEFINESBYTYPE, IFCRELDEFINESBYTEMPLATE, IFCRELDEFINESBYPROPERTIES, IFCRELDEFINESBYOBJECT, IFCRELDEFINES, IFCRELAGGREGATES, IFCRELADHERESTOELEMENT, IFCRELVOIDSELEMENT, IFCRELPROJECTSELEMENT, IFCRELNESTS, IFCRELDECOMPOSES, IFCRELDECLARES, IFCRELSPACEBOUNDARY2NDLEVEL, IFCRELSPACEBOUNDARY1STLEVEL, IFCRELSPACEBOUNDARY, IFCRELSERVICESBUILDINGS, IFCRELSEQUENCE, IFCRELREFERENCEDINSPATIALSTRUCTURE, IFCRELPOSITIONS, IFCRELINTERFERESELEMENTS, IFCRELFLOWCONTROLELEMENTS, IFCRELFILLSELEMENT, IFCRELCOVERSSPACES, IFCRELCOVERSBLDGELEMENTS, IFCRELCONTAINEDINSPATIALSTRUCTURE, IFCRELCONNECTSWITHECCENTRICITY, IFCRELCONNECTSSTRUCTURALMEMBER, IFCRELCONNECTSSTRUCTURALACTIVITY, IFCRELCONNECTSPORTS, IFCRELCONNECTSPORTTOELEMENT, IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS, IFCRELCONNECTSELEMENTS, IFCRELCONNECTS, IFCRELASSOCIATESPROFILEDEF, IFCRELASSOCIATESMATERIAL, IFCRELASSOCIATESLIBRARY, IFCRELASSOCIATESDOCUMENT, IFCRELASSOCIATESCONSTRAINT, IFCRELASSOCIATESCLASSIFICATION, IFCRELASSOCIATESAPPROVAL, IFCRELASSOCIATES, IFCRELASSIGNSTORESOURCE, IFCRELASSIGNSTOPRODUCT, IFCRELASSIGNSTOPROCESS, IFCRELASSIGNSTOGROUPBYFACTOR, IFCRELASSIGNSTOGROUP, IFCRELASSIGNSTOCONTROL, IFCRELASSIGNSTOACTOR, IFCRELASSIGNS],
  823603102: [IFCCURVESEGMENT, IFCREPARAMETRISEDCOMPOSITECURVESEGMENT, IFCCOMPOSITECURVESEGMENT],
  3692461612: [IFCPROPERTYTABLEVALUE, IFCPROPERTYSINGLEVALUE, IFCPROPERTYREFERENCEVALUE, IFCPROPERTYLISTVALUE, IFCPROPERTYENUMERATEDVALUE, IFCPROPERTYBOUNDEDVALUE],
  723233188: [IFCSECTIONEDSOLIDHORIZONTAL, IFCSECTIONEDSOLID, IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCADVANCEDBREPWITHVOIDS, IFCADVANCEDBREP, IFCMANIFOLDSOLIDBREP, IFCCSGSOLID, IFCSWEPTDISKSOLIDPOLYGONAL, IFCSWEPTDISKSOLID, IFCREVOLVEDAREASOLIDTAPERED, IFCREVOLVEDAREASOLID, IFCEXTRUDEDAREASOLIDTAPERED, IFCEXTRUDEDAREASOLID, IFCSURFACECURVESWEPTAREASOLID, IFCDIRECTRIXDERIVEDREFERENCESWEPTAREASOLID, IFCFIXEDREFERENCESWEPTAREASOLID, IFCDIRECTRIXCURVESWEPTAREASOLID, IFCSWEPTAREASOLID],
  2473145415: [IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION],
  1597423693: [IFCSTRUCTURALLOADSINGLEFORCEWARPING],
  2513912981: [IFCSECTIONEDSURFACE, IFCCYLINDRICALSURFACE, IFCTOROIDALSURFACE, IFCSPHERICALSURFACE, IFCPLANE, IFCELEMENTARYSURFACE, IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDSURFACE, IFCCURVEBOUNDEDPLANE, IFCBOUNDEDSURFACE, IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION, IFCSWEPTSURFACE],
  2247615214: [IFCREVOLVEDAREASOLIDTAPERED, IFCREVOLVEDAREASOLID, IFCEXTRUDEDAREASOLIDTAPERED, IFCEXTRUDEDAREASOLID, IFCSURFACECURVESWEPTAREASOLID, IFCDIRECTRIXDERIVEDREFERENCESWEPTAREASOLID, IFCFIXEDREFERENCESWEPTAREASOLID, IFCDIRECTRIXCURVESWEPTAREASOLID],
  1260650574: [IFCSWEPTDISKSOLIDPOLYGONAL],
  230924584: [IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION],
  901063453: [IFCPOLYGONALFACESET, IFCTRIANGULATEDIRREGULARNETWORK, IFCTRIANGULATEDFACESET, IFCTESSELLATEDFACESET, IFCINDEXEDPOLYGONALFACEWITHVOIDS, IFCINDEXEDPOLYGONALFACE],
  4282788508: [IFCTEXTLITERALWITHEXTENT],
  1628702193: [IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE, IFCCONSTRUCTIONRESOURCETYPE, IFCTYPERESOURCE, IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSPATIALELEMENTTYPE, IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCVIBRATIONDAMPERTYPE, IFCSIGNTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONCONDUITTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCIMPACTPROTECTIONDEVICETYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCELECTRICFLOWTREATMENTDEVICETYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSIGNALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE, IFCMEDICALDEVICETYPE, IFCLIQUIDTERMINALTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCONVEYORSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEARINGTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCTRACKELEMENTTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCRAILTYPE, IFCPLATETYPE, IFCPAVEMENTTYPE, IFCNAVIGATIONELEMENTTYPE, IFCMOORINGDEVICETYPE, IFCMEMBERTYPE, IFCKERBTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCAISSONFOUNDATIONTYPE, IFCPILETYPE, IFCDEEPFOUNDATIONTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOURSETYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILTELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCVEHICLETYPE, IFCTRANSPORTATIONDEVICETYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCTYPEPRODUCT, IFCTASKTYPE, IFCPROCEDURETYPE, IFCEVENTTYPE, IFCTYPEPROCESS],
  3736923433: [IFCTASKTYPE, IFCPROCEDURETYPE, IFCEVENTTYPE],
  2347495698: [IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSPATIALELEMENTTYPE, IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCVIBRATIONDAMPERTYPE, IFCSIGNTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONCONDUITTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCIMPACTPROTECTIONDEVICETYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCELECTRICFLOWTREATMENTDEVICETYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSIGNALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE, IFCMEDICALDEVICETYPE, IFCLIQUIDTERMINALTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCONVEYORSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEARINGTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCTRACKELEMENTTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCRAILTYPE, IFCPLATETYPE, IFCPAVEMENTTYPE, IFCNAVIGATIONELEMENTTYPE, IFCMOORINGDEVICETYPE, IFCMEMBERTYPE, IFCKERBTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCAISSONFOUNDATIONTYPE, IFCPILETYPE, IFCDEEPFOUNDATIONTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOURSETYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILTELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCVEHICLETYPE, IFCTRANSPORTATIONDEVICETYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE],
  3698973494: [IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE, IFCCONSTRUCTIONRESOURCETYPE],
  2736907675: [IFCBOOLEANCLIPPINGRESULT],
  4182860854: [IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDSURFACE, IFCCURVEBOUNDEDPLANE],
  574549367: [IFCCARTESIANPOINTLIST3D, IFCCARTESIANPOINTLIST2D],
  59481748: [IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR3D, IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR2D],
  3749851601: [IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM],
  3331915920: [IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM],
  1383045692: [IFCCIRCLEHOLLOWPROFILEDEF],
  2485617015: [IFCREPARAMETRISEDCOMPOSITECURVESEGMENT],
  2574617495: [IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE],
  3419103109: [IFCPROJECTLIBRARY, IFCPROJECT],
  2506170314: [IFCBLOCK, IFCSPHERE, IFCRIGHTCIRCULARCYLINDER, IFCRIGHTCIRCULARCONE, IFCRECTANGULARPYRAMID],
  2601014836: [IFCCIRCLE, IFCELLIPSE, IFCCONIC, IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFCINDEXEDPOLYCURVE, IFCSEGMENTEDREFERENCECURVE, IFCGRADIENTCURVE, IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE, IFCCOMPOSITECURVE, IFCBOUNDEDCURVE, IFCSEAMCURVE, IFCINTERSECTIONCURVE, IFCSURFACECURVE, IFCSINESPIRAL, IFCSEVENTHORDERPOLYNOMIALSPIRAL, IFCSECONDORDERPOLYNOMIALSPIRAL, IFCCOSINESPIRAL, IFCCLOTHOID, IFCTHIRDORDERPOLYNOMIALSPIRAL, IFCSPIRAL, IFCPOLYNOMIALCURVE, IFCPCURVE, IFCOFFSETCURVEBYDISTANCES, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D, IFCOFFSETCURVE, IFCLINE],
  593015953: [IFCSURFACECURVESWEPTAREASOLID, IFCDIRECTRIXDERIVEDREFERENCESWEPTAREASOLID, IFCFIXEDREFERENCESWEPTAREASOLID],
  339256511: [IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCVIBRATIONDAMPERTYPE, IFCSIGNTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONCONDUITTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCIMPACTPROTECTIONDEVICETYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCELECTRICFLOWTREATMENTDEVICETYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSIGNALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE, IFCMEDICALDEVICETYPE, IFCLIQUIDTERMINALTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCONVEYORSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEARINGTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCTRACKELEMENTTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCRAILTYPE, IFCPLATETYPE, IFCPAVEMENTTYPE, IFCNAVIGATIONELEMENTTYPE, IFCMOORINGDEVICETYPE, IFCMEMBERTYPE, IFCKERBTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCAISSONFOUNDATIONTYPE, IFCPILETYPE, IFCDEEPFOUNDATIONTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOURSETYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILTELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCVEHICLETYPE, IFCTRANSPORTATIONDEVICETYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE],
  2777663545: [IFCCYLINDRICALSURFACE, IFCTOROIDALSURFACE, IFCSPHERICALSURFACE, IFCPLANE],
  477187591: [IFCEXTRUDEDAREASOLIDTAPERED],
  2652556860: [IFCDIRECTRIXDERIVEDREFERENCESWEPTAREASOLID],
  4238390223: [IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE],
  178912537: [IFCINDEXEDPOLYGONALFACEWITHVOIDS],
  1425443689: [IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCADVANCEDBREPWITHVOIDS, IFCADVANCEDBREP],
  3888040117: [IFCASSET, IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILTSYSTEM, IFCBUILDINGSYSTEM, IFCZONE, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADCASE, IFCSTRUCTURALLOADGROUP, IFCINVENTORY, IFCGROUP, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCWORKCALENDAR, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCCOSTSCHEDULE, IFCCOSTITEM, IFCCONTROL, IFCOCCUPANT, IFCACTOR, IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE, IFCRESOURCE, IFCALIGNMENT, IFCLINEARPOSITIONINGELEMENT, IFCGRID, IFCREFERENT, IFCPOSITIONINGELEMENT, IFCDISTRIBUTIONPORT, IFCPORT, IFCALIGNMENTVERTICAL, IFCALIGNMENTSEGMENT, IFCALIGNMENTHORIZONTAL, IFCALIGNMENTCANT, IFCLINEARELEMENT, IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCELECTRICFLOWTREATMENTDEVICE, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSIGNAL, IFCSANITARYTERMINAL, IFCOUTLET, IFCMOBILETELECOMMUNICATIONSAPPLIANCE, IFCMEDICALDEVICE, IFCLIQUIDTERMINAL, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCONVEYORSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBUILDINGELEMENTPROXY, IFCBEARING, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCTRACKELEMENT, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCRAIL, IFCPLATE, IFCPAVEMENT, IFCNAVIGATIONELEMENT, IFCMOORINGDEVICE, IFCMEMBER, IFCKERB, IFCFOOTING, IFCREINFORCEDSOIL, IFCEARTHWORKSFILL, IFCEARTHWORKSELEMENT, IFCDOOR, IFCCAISSONFOUNDATION, IFCPILE, IFCDEEPFOUNDATION, IFCCURTAINWALL, IFCCOVERING, IFCCOURSE, IFCCOLUMN, IFCCHIMNEY, IFCBUILTELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCVEHICLE, IFCTRANSPORTATIONDEVICE, IFCGEOSLICE, IFCGEOMODEL, IFCBOREHOLE, IFCGEOTECHNICALASSEMBLY, IFCGEOTECHNICALSTRATUM, IFCGEOTECHNICALELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCEARTHWORKSCUT, IFCVOIDINGFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCVIBRATIONDAMPER, IFCSIGN, IFCREINFORCINGBAR, IFCTENDONCONDUIT, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCIMPACTPROTECTIONDEVICE, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBRIDGEPART, IFCROADPART, IFCRAILWAYPART, IFCMARINEPART, IFCFACILITYPARTCOMMON, IFCFACILITYPART, IFCBUILDING, IFCBRIDGE, IFCROAD, IFCRAILWAY, IFCMARINEFACILITY, IFCFACILITY, IFCBUILDINGSTOREY, IFCSPATIALSTRUCTUREELEMENT, IFCSPATIALELEMENT, IFCPRODUCT, IFCPROCEDURE, IFCEVENT, IFCTASK, IFCPROCESS],
  590820931: [IFCOFFSETCURVEBYDISTANCES, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D],
  759155922: [IFCDRAUGHTINGPREDEFINEDCOLOUR],
  2559016684: [IFCDRAUGHTINGPREDEFINEDCURVEFONT],
  3967405729: [IFCPERMEABLECOVERINGPROPERTIES, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCREINFORCEMENTDEFINITIONPROPERTIES],
  2945172077: [IFCPROCEDURE, IFCEVENT, IFCTASK],
  4208778838: [IFCALIGNMENT, IFCLINEARPOSITIONINGELEMENT, IFCGRID, IFCREFERENT, IFCPOSITIONINGELEMENT, IFCDISTRIBUTIONPORT, IFCPORT, IFCALIGNMENTVERTICAL, IFCALIGNMENTSEGMENT, IFCALIGNMENTHORIZONTAL, IFCALIGNMENTCANT, IFCLINEARELEMENT, IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCELECTRICFLOWTREATMENTDEVICE, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSIGNAL, IFCSANITARYTERMINAL, IFCOUTLET, IFCMOBILETELECOMMUNICATIONSAPPLIANCE, IFCMEDICALDEVICE, IFCLIQUIDTERMINAL, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCONVEYORSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBUILDINGELEMENTPROXY, IFCBEARING, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCTRACKELEMENT, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCRAIL, IFCPLATE, IFCPAVEMENT, IFCNAVIGATIONELEMENT, IFCMOORINGDEVICE, IFCMEMBER, IFCKERB, IFCFOOTING, IFCREINFORCEDSOIL, IFCEARTHWORKSFILL, IFCEARTHWORKSELEMENT, IFCDOOR, IFCCAISSONFOUNDATION, IFCPILE, IFCDEEPFOUNDATION, IFCCURTAINWALL, IFCCOVERING, IFCCOURSE, IFCCOLUMN, IFCCHIMNEY, IFCBUILTELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCVEHICLE, IFCTRANSPORTATIONDEVICE, IFCGEOSLICE, IFCGEOMODEL, IFCBOREHOLE, IFCGEOTECHNICALASSEMBLY, IFCGEOTECHNICALSTRATUM, IFCGEOTECHNICALELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCEARTHWORKSCUT, IFCVOIDINGFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCVIBRATIONDAMPER, IFCSIGN, IFCREINFORCINGBAR, IFCTENDONCONDUIT, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCIMPACTPROTECTIONDEVICE, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBRIDGEPART, IFCROADPART, IFCRAILWAYPART, IFCMARINEPART, IFCFACILITYPARTCOMMON, IFCFACILITYPART, IFCBUILDING, IFCBRIDGE, IFCROAD, IFCRAILWAY, IFCMARINEFACILITY, IFCFACILITY, IFCBUILDINGSTOREY, IFCSPATIALSTRUCTUREELEMENT, IFCSPATIALELEMENT],
  3521284610: [IFCCOMPLEXPROPERTYTEMPLATE, IFCSIMPLEPROPERTYTEMPLATE],
  3939117080: [IFCRELASSIGNSTORESOURCE, IFCRELASSIGNSTOPRODUCT, IFCRELASSIGNSTOPROCESS, IFCRELASSIGNSTOGROUPBYFACTOR, IFCRELASSIGNSTOGROUP, IFCRELASSIGNSTOCONTROL, IFCRELASSIGNSTOACTOR],
  1307041759: [IFCRELASSIGNSTOGROUPBYFACTOR],
  1865459582: [IFCRELASSOCIATESPROFILEDEF, IFCRELASSOCIATESMATERIAL, IFCRELASSOCIATESLIBRARY, IFCRELASSOCIATESDOCUMENT, IFCRELASSOCIATESCONSTRAINT, IFCRELASSOCIATESCLASSIFICATION, IFCRELASSOCIATESAPPROVAL],
  826625072: [IFCRELSPACEBOUNDARY2NDLEVEL, IFCRELSPACEBOUNDARY1STLEVEL, IFCRELSPACEBOUNDARY, IFCRELSERVICESBUILDINGS, IFCRELSEQUENCE, IFCRELREFERENCEDINSPATIALSTRUCTURE, IFCRELPOSITIONS, IFCRELINTERFERESELEMENTS, IFCRELFLOWCONTROLELEMENTS, IFCRELFILLSELEMENT, IFCRELCOVERSSPACES, IFCRELCOVERSBLDGELEMENTS, IFCRELCONTAINEDINSPATIALSTRUCTURE, IFCRELCONNECTSWITHECCENTRICITY, IFCRELCONNECTSSTRUCTURALMEMBER, IFCRELCONNECTSSTRUCTURALACTIVITY, IFCRELCONNECTSPORTS, IFCRELCONNECTSPORTTOELEMENT, IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS, IFCRELCONNECTSELEMENTS],
  1204542856: [IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS],
  1638771189: [IFCRELCONNECTSWITHECCENTRICITY],
  2551354335: [IFCRELAGGREGATES, IFCRELADHERESTOELEMENT, IFCRELVOIDSELEMENT, IFCRELPROJECTSELEMENT, IFCRELNESTS],
  693640335: [IFCRELDEFINESBYTYPE, IFCRELDEFINESBYTEMPLATE, IFCRELDEFINESBYPROPERTIES, IFCRELDEFINESBYOBJECT],
  3451746338: [IFCRELSPACEBOUNDARY2NDLEVEL, IFCRELSPACEBOUNDARY1STLEVEL],
  3523091289: [IFCRELSPACEBOUNDARY2NDLEVEL],
  2914609552: [IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE],
  1856042241: [IFCREVOLVEDAREASOLIDTAPERED],
  1862484736: [IFCSECTIONEDSOLIDHORIZONTAL],
  1412071761: [IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBRIDGEPART, IFCROADPART, IFCRAILWAYPART, IFCMARINEPART, IFCFACILITYPARTCOMMON, IFCFACILITYPART, IFCBUILDING, IFCBRIDGE, IFCROAD, IFCRAILWAY, IFCMARINEFACILITY, IFCFACILITY, IFCBUILDINGSTOREY, IFCSPATIALSTRUCTUREELEMENT],
  710998568: [IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE],
  2706606064: [IFCSPACE, IFCSITE, IFCBRIDGEPART, IFCROADPART, IFCRAILWAYPART, IFCMARINEPART, IFCFACILITYPARTCOMMON, IFCFACILITYPART, IFCBUILDING, IFCBRIDGE, IFCROAD, IFCRAILWAY, IFCMARINEFACILITY, IFCFACILITY, IFCBUILDINGSTOREY],
  3893378262: [IFCSPACETYPE],
  2735484536: [IFCSINESPIRAL, IFCSEVENTHORDERPOLYNOMIALSPIRAL, IFCSECONDORDERPOLYNOMIALSPIRAL, IFCCOSINESPIRAL, IFCCLOTHOID, IFCTHIRDORDERPOLYNOMIALSPIRAL],
  3544373492: [IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION],
  3136571912: [IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER],
  530289379: [IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER],
  3689010777: [IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION],
  3979015343: [IFCSTRUCTURALSURFACEMEMBERVARYING],
  699246055: [IFCSEAMCURVE, IFCINTERSECTIONCURVE],
  2387106220: [IFCPOLYGONALFACESET, IFCTRIANGULATEDIRREGULARNETWORK, IFCTRIANGULATEDFACESET],
  3665877780: [IFCTRANSPORTELEMENTTYPE, IFCVEHICLETYPE],
  2916149573: [IFCTRIANGULATEDIRREGULARNETWORK],
  2296667514: [IFCOCCUPANT],
  1635779807: [IFCADVANCEDBREPWITHVOIDS],
  2887950389: [IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS],
  167062518: [IFCRATIONALBSPLINESURFACEWITHKNOTS],
  1260505505: [IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFCINDEXEDPOLYCURVE, IFCSEGMENTEDREFERENCECURVE, IFCGRADIENTCURVE, IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE, IFCCOMPOSITECURVE],
  1626504194: [IFCBUILDINGELEMENTPROXYTYPE, IFCBEARINGTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCTRACKELEMENTTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCRAILTYPE, IFCPLATETYPE, IFCPAVEMENTTYPE, IFCNAVIGATIONELEMENTTYPE, IFCMOORINGDEVICETYPE, IFCMEMBERTYPE, IFCKERBTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCAISSONFOUNDATIONTYPE, IFCPILETYPE, IFCDEEPFOUNDATIONTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOURSETYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE],
  3732776249: [IFCSEGMENTEDREFERENCECURVE, IFCGRADIENTCURVE, IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE],
  15328376: [IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE],
  2510884976: [IFCCIRCLE, IFCELLIPSE],
  2559216714: [IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE],
  3293443760: [IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCWORKCALENDAR, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCCOSTSCHEDULE, IFCCOSTITEM],
  1306400036: [IFCCAISSONFOUNDATIONTYPE, IFCPILETYPE],
  3256556792: [IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCELECTRICFLOWTREATMENTDEVICETYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSIGNALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE, IFCMEDICALDEVICETYPE, IFCLIQUIDTERMINALTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCONVEYORSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE],
  3849074793: [IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCELECTRICFLOWTREATMENTDEVICETYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSIGNALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE, IFCMEDICALDEVICETYPE, IFCLIQUIDTERMINALTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCONVEYORSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE],
  1758889154: [IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCELECTRICFLOWTREATMENTDEVICE, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSIGNAL, IFCSANITARYTERMINAL, IFCOUTLET, IFCMOBILETELECOMMUNICATIONSAPPLIANCE, IFCMEDICALDEVICE, IFCLIQUIDTERMINAL, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCONVEYORSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBUILDINGELEMENTPROXY, IFCBEARING, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCTRACKELEMENT, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCRAIL, IFCPLATE, IFCPAVEMENT, IFCNAVIGATIONELEMENT, IFCMOORINGDEVICE, IFCMEMBER, IFCKERB, IFCFOOTING, IFCREINFORCEDSOIL, IFCEARTHWORKSFILL, IFCEARTHWORKSELEMENT, IFCDOOR, IFCCAISSONFOUNDATION, IFCPILE, IFCDEEPFOUNDATION, IFCCURTAINWALL, IFCCOVERING, IFCCOURSE, IFCCOLUMN, IFCCHIMNEY, IFCBUILTELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCVEHICLE, IFCTRANSPORTATIONDEVICE, IFCGEOSLICE, IFCGEOMODEL, IFCBOREHOLE, IFCGEOTECHNICALASSEMBLY, IFCGEOTECHNICALSTRATUM, IFCGEOTECHNICALELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCEARTHWORKSCUT, IFCVOIDINGFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCVIBRATIONDAMPER, IFCSIGN, IFCREINFORCINGBAR, IFCTENDONCONDUIT, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCIMPACTPROTECTIONDEVICE, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY],
  1623761950: [IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCVIBRATIONDAMPER, IFCSIGN, IFCREINFORCINGBAR, IFCTENDONCONDUIT, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCIMPACTPROTECTIONDEVICE, IFCFASTENER],
  2590856083: [IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCVIBRATIONDAMPERTYPE, IFCSIGNTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONCONDUITTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCIMPACTPROTECTIONDEVICETYPE, IFCFASTENERTYPE],
  2107101300: [IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE],
  2853485674: [IFCEXTERNALSPATIALELEMENT],
  807026263: [IFCFACETEDBREPWITHVOIDS],
  24185140: [IFCBUILDING, IFCBRIDGE, IFCROAD, IFCRAILWAY, IFCMARINEFACILITY],
  1310830890: [IFCBRIDGEPART, IFCROADPART, IFCRAILWAYPART, IFCMARINEPART, IFCFACILITYPARTCOMMON],
  2827207264: [IFCSURFACEFEATURE, IFCEARTHWORKSCUT, IFCVOIDINGFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION],
  2143335405: [IFCPROJECTIONELEMENT],
  1287392070: [IFCEARTHWORKSCUT, IFCVOIDINGFEATURE, IFCOPENINGELEMENT],
  3907093117: [IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE],
  3198132628: [IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE],
  1482959167: [IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE],
  1834744321: [IFCDUCTSEGMENTTYPE, IFCCONVEYORSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE],
  1339347760: [IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE],
  2297155007: [IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSIGNALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE, IFCMEDICALDEVICETYPE, IFCLIQUIDTERMINALTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE],
  3009222698: [IFCFILTERTYPE, IFCELECTRICFLOWTREATMENTDEVICETYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE],
  263784265: [IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE],
  4230923436: [IFCGEOSLICE, IFCGEOMODEL, IFCBOREHOLE, IFCGEOTECHNICALASSEMBLY, IFCGEOTECHNICALSTRATUM],
  2706460486: [IFCASSET, IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILTSYSTEM, IFCBUILDINGSYSTEM, IFCZONE, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADCASE, IFCSTRUCTURALLOADGROUP, IFCINVENTORY],
  2176059722: [IFCALIGNMENTVERTICAL, IFCALIGNMENTSEGMENT, IFCALIGNMENTHORIZONTAL, IFCALIGNMENTCANT],
  3740093272: [IFCDISTRIBUTIONPORT],
  1946335990: [IFCALIGNMENT, IFCLINEARPOSITIONINGELEMENT, IFCGRID, IFCREFERENT],
  3027567501: [IFCREINFORCINGBAR, IFCTENDONCONDUIT, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH],
  964333572: [IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONCONDUITTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE],
  682877961: [IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION],
  1179482911: [IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION],
  1004757350: [IFCSTRUCTURALLINEARACTION],
  214636428: [IFCSTRUCTURALCURVEMEMBERVARYING],
  1252848954: [IFCSTRUCTURALLOADCASE],
  3657597509: [IFCSTRUCTURALPLANARACTION],
  2254336722: [IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILTSYSTEM, IFCBUILDINGSYSTEM, IFCZONE],
  1953115116: [IFCTRANSPORTELEMENT, IFCVEHICLE],
  1028945134: [IFCWORKSCHEDULE, IFCWORKPLAN],
  1967976161: [IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS],
  2461110595: [IFCRATIONALBSPLINECURVEWITHKNOTS],
  1136057603: [IFCOUTERBOUNDARYCURVE],
  1876633798: [IFCBUILDINGELEMENTPROXY, IFCBEARING, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCTRACKELEMENT, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCRAIL, IFCPLATE, IFCPAVEMENT, IFCNAVIGATIONELEMENT, IFCMOORINGDEVICE, IFCMEMBER, IFCKERB, IFCFOOTING, IFCREINFORCEDSOIL, IFCEARTHWORKSFILL, IFCEARTHWORKSELEMENT, IFCDOOR, IFCCAISSONFOUNDATION, IFCPILE, IFCDEEPFOUNDATION, IFCCURTAINWALL, IFCCOVERING, IFCCOURSE, IFCCOLUMN, IFCCHIMNEY],
  3426335179: [IFCCAISSONFOUNDATION, IFCPILE],
  2063403501: [IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE],
  1945004755: [IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCELECTRICFLOWTREATMENTDEVICE, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSIGNAL, IFCSANITARYTERMINAL, IFCOUTLET, IFCMOBILETELECOMMUNICATIONSAPPLIANCE, IFCMEDICALDEVICE, IFCLIQUIDTERMINAL, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCONVEYORSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT],
  3040386961: [IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCELECTRICFLOWTREATMENTDEVICE, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSIGNAL, IFCSANITARYTERMINAL, IFCOUTLET, IFCMOBILETELECOMMUNICATIONSAPPLIANCE, IFCMEDICALDEVICE, IFCLIQUIDTERMINAL, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCONVEYORSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE],
  3205830791: [IFCDISTRIBUTIONCIRCUIT],
  1077100507: [IFCREINFORCEDSOIL, IFCEARTHWORKSFILL],
  1658829314: [IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE],
  2058353004: [IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER],
  4278956645: [IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX],
  3132237377: [IFCFAN, IFCCOMPRESSOR, IFCPUMP],
  987401354: [IFCDUCTSEGMENT, IFCCONVEYORSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT],
  707683696: [IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK],
  2223149337: [IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSIGNAL, IFCSANITARYTERMINAL, IFCOUTLET, IFCMOBILETELECOMMUNICATIONSAPPLIANCE, IFCMEDICALDEVICE, IFCLIQUIDTERMINAL, IFCLIGHTFIXTURE, IFCLAMP],
  3508470533: [IFCFILTER, IFCELECTRICFLOWTREATMENTDEVICE, IFCDUCTSILENCER, IFCINTERCEPTOR],
  2713699986: [IFCGEOSLICE, IFCGEOMODEL, IFCBOREHOLE],
  1154579445: [IFCALIGNMENT],
  2391406946: [IFCWALLSTANDARDCASE],
  1062813311: [IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT]
};
InversePropertyDef[3] = {
  3630933823: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  618182010: [["OfPerson", IFCPERSON, 7, true], ["OfOrganization", IFCORGANIZATION, 4, true]],
  411424972: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  130549933: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["ApprovedObjects", IFCRELASSOCIATESAPPROVAL, 5, true], ["ApprovedResources", IFCRESOURCEAPPROVALRELATIONSHIP, 3, true], ["IsRelatedWith", IFCAPPROVALRELATIONSHIP, 3, true], ["Relates", IFCAPPROVALRELATIONSHIP, 2, true]],
  1959218052: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PropertiesForConstraint", IFCRESOURCECONSTRAINTRELATIONSHIP, 2, true]],
  1466758467: [["HasCoordinateOperation", IFCCOORDINATEOPERATION, 0, true]],
  602808272: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  3200245327: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true]],
  2242383968: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true]],
  1040185647: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true]],
  3548104201: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true]],
  852622518: [["PartOfW", IFCGRID, 9, true], ["PartOfV", IFCGRID, 8, true], ["PartOfU", IFCGRID, 7, true], ["HasIntersections", IFCVIRTUALGRIDINTERSECTION, 0, true]],
  2655187982: [["LibraryInfoForObjects", IFCRELASSOCIATESLIBRARY, 5, true], ["HasLibraryReferences", IFCLIBRARYREFERENCE, 5, true]],
  3452421091: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true], ["LibraryRefForObjects", IFCRELASSOCIATESLIBRARY, 5, true]],
  760658860: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true]],
  248100487: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true], ["ToMaterialLayerSet", IFCMATERIALLAYERSET, 0, false]],
  3303938423: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true]],
  1847252529: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true], ["ToMaterialLayerSet", IFCMATERIALLAYERSET, 0, false]],
  2235152071: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true], ["ToMaterialProfileSet", IFCMATERIALPROFILESET, 2, false]],
  164193824: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true]],
  552965576: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true], ["ToMaterialProfileSet", IFCMATERIALPROFILESET, 2, false]],
  1507914824: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true]],
  3368373690: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PropertiesForConstraint", IFCRESOURCECONSTRAINTRELATIONSHIP, 2, true]],
  3701648758: [["PlacesObject", IFCPRODUCT, 5, true], ["ReferencedByPlacements", IFCOBJECTPLACEMENT, 0, true]],
  2251480897: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PropertiesForConstraint", IFCRESOURCECONSTRAINTRELATIONSHIP, 2, true]],
  4251960020: [["IsRelatedBy", IFCORGANIZATIONRELATIONSHIP, 3, true], ["Relates", IFCORGANIZATIONRELATIONSHIP, 2, true], ["Engages", IFCPERSONANDORGANIZATION, 1, true]],
  2077209135: [["EngagedIn", IFCPERSONANDORGANIZATION, 0, true]],
  2483315170: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  2226359599: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  3355820592: [["OfPerson", IFCPERSON, 7, true], ["OfOrganization", IFCORGANIZATION, 4, true]],
  3958567839: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  3843373140: [["HasCoordinateOperation", IFCCOORDINATEOPERATION, 0, true]],
  986844984: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  3710013099: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2044713172: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  2093928680: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  931644368: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  2691318326: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  3252649465: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  2405470396: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  825690147: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  1076942058: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true]],
  3377609919: [["RepresentationsInContext", IFCREPRESENTATION, 0, true]],
  3008791417: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1660063152: [["HasShapeAspects", IFCSHAPEASPECT, 4, true], ["MapUsage", IFCMAPPEDITEM, 0, true]],
  867548509: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  3982875396: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true], ["OfShapeAspect", IFCSHAPEASPECT, 0, true]],
  4240577450: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true], ["OfShapeAspect", IFCSHAPEASPECT, 0, true]],
  2830218821: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true]],
  3958052878: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3049322572: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true]],
  626085974: [["IsMappedBy", IFCTEXTURECOORDINATE, 0, true], ["UsedInStyles", IFCSURFACESTYLEWITHTEXTURES, 0, true]],
  912023232: [["OfPerson", IFCPERSON, 7, true], ["OfOrganization", IFCORGANIZATION, 4, true]],
  222769930: [["ToTexMap", IFCINDEXEDPOLYGONALTEXTUREMAP, 3, false]],
  1010789467: [["ToTexMap", IFCINDEXEDPOLYGONALTEXTUREMAP, 3, false]],
  3101149627: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  1377556343: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1735638870: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true], ["OfShapeAspect", IFCSHAPEASPECT, 0, true]],
  2799835756: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1907098498: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3798115385: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  1310608509: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  2705031697: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  616511568: [["IsMappedBy", IFCTEXTURECOORDINATE, 0, true], ["UsedInStyles", IFCSURFACESTYLEWITHTEXTURES, 0, true]],
  3150382593: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  747523909: [["ClassificationForObjects", IFCRELASSOCIATESCLASSIFICATION, 5, true], ["HasReferences", IFCCLASSIFICATIONREFERENCE, 3, true]],
  647927063: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true], ["ClassificationRefForObjects", IFCRELASSOCIATESCLASSIFICATION, 5, true], ["HasReferences", IFCCLASSIFICATIONREFERENCE, 3, true]],
  1485152156: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  370225590: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3050246964: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2889183280: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2713554722: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  3632507154: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  1154170062: [["DocumentInfoForObjects", IFCRELASSOCIATESDOCUMENT, 5, true], ["HasDocumentReferences", IFCDOCUMENTREFERENCE, 4, true], ["IsPointedTo", IFCDOCUMENTINFORMATIONRELATIONSHIP, 3, true], ["IsPointer", IFCDOCUMENTINFORMATIONRELATIONSHIP, 2, true]],
  3732053477: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true], ["DocumentRefForObjects", IFCRELASSOCIATESDOCUMENT, 5, true]],
  3900360178: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  476780140: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  297599258: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2556980723: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["HasTextureMaps", IFCTEXTUREMAP, 2, true]],
  1809719519: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  803316827: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3008276851: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["HasTextureMaps", IFCTEXTUREMAP, 2, true]],
  3448662350: [["RepresentationsInContext", IFCREPRESENTATION, 0, true], ["HasSubContexts", IFCGEOMETRICREPRESENTATIONSUBCONTEXT, 6, true], ["HasCoordinateOperation", IFCCOORDINATEOPERATION, 0, true]],
  2453401579: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4142052618: [["RepresentationsInContext", IFCREPRESENTATION, 0, true], ["HasSubContexts", IFCGEOMETRICREPRESENTATIONSUBCONTEXT, 6, true], ["HasCoordinateOperation", IFCCOORDINATEOPERATION, 0, true]],
  3590301190: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  178086475: [["PlacesObject", IFCPRODUCT, 5, true], ["ReferencedByPlacements", IFCOBJECTPLACEMENT, 0, true]],
  812098782: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3905492369: [["IsMappedBy", IFCTEXTURECOORDINATE, 0, true], ["UsedInStyles", IFCSURFACESTYLEWITHTEXTURES, 0, true]],
  3741457305: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  1402838566: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  125510826: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2604431987: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4266656042: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1520743889: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3422422726: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  388784114: [["PlacesObject", IFCPRODUCT, 5, true], ["ReferencedByPlacements", IFCOBJECTPLACEMENT, 0, true]],
  2624227202: [["PlacesObject", IFCPRODUCT, 5, true], ["ReferencedByPlacements", IFCOBJECTPLACEMENT, 0, true]],
  1008929658: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2347385850: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1838606355: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true], ["HasRepresentation", IFCMATERIALDEFINITIONREPRESENTATION, 3, true], ["IsRelatedWith", IFCMATERIALRELATIONSHIP, 3, true], ["RelatesTo", IFCMATERIALRELATIONSHIP, 2, true]],
  3708119e3: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true], ["ToMaterialConstituentSet", IFCMATERIALCONSTITUENTSET, 2, false]],
  2852063980: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true]],
  1303795690: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true]],
  3079605661: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true]],
  3404854881: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true]],
  3265635763: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2998442950: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  219451334: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true]],
  182550632: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  2665983363: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1029017970: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2529465313: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  2519244187: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3021840470: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  597895409: [["IsMappedBy", IFCTEXTURECOORDINATE, 0, true], ["UsedInStyles", IFCSURFACESTYLEWITHTEXTURES, 0, true]],
  2004835150: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1663979128: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2067069095: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2165702409: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4022376103: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1423911732: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2924175390: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2775532180: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3778827333: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  673634403: [["ShapeOfProduct", IFCPRODUCT, 6, true], ["HasShapeAspects", IFCSHAPEASPECT, 4, true]],
  2802850158: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2598011224: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  1680319473: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true]],
  3357820518: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  1482703590: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true]],
  2090586900: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  3615266464: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  3413951693: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  1580146022: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2778083089: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  2042790032: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  4165799628: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  1509187699: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  823603102: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["UsingCurves", IFCCOMPOSITECURVE, 0, true]],
  4124623270: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3692461612: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  723233188: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2233826070: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2513912981: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2247615214: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1260650574: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1096409881: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  230924584: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3071757647: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  901063453: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4282788508: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3124975700: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2715220739: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  1628702193: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true]],
  3736923433: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  2347495698: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3698973494: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  427810014: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  1417489154: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2759199220: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2543172580: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  3406155212: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["HasTextureMaps", IFCTEXTUREMAP, 2, true]],
  669184980: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3207858831: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  4261334040: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3125803723: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2740243338: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3425423356: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2736907675: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4182860854: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2581212453: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2713105998: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2898889636: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  1123145078: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  574549367: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1675464909: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2059837836: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  59481748: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3749851601: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3486308946: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3331915920: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1416205885: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1383045692: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  2205249479: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2542286263: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  2485617015: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["UsingCurves", IFCCOMPOSITECURVE, 0, true]],
  2574617495: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  3419103109: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Declares", IFCRELDECLARES, 4, true]],
  1815067380: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  2506170314: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2147822146: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2601014836: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2827736869: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2629017746: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4212018352: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["UsingCurves", IFCCOMPOSITECURVE, 0, true]],
  32440307: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  593015953: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1472233963: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1883228015: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  339256511: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2777663545: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2835456948: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  4024345920: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  477187591: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2804161546: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2047409740: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  374418227: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  315944413: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2652556860: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4238390223: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1268542332: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4095422895: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  987898635: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1484403080: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  178912537: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["ToFaceSet", IFCPOLYGONALFACESET, 2, true], ["HasTexCoords", IFCTEXTURECOORDINATEINDICES, 1, true]],
  2294589976: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["ToFaceSet", IFCPOLYGONALFACESET, 2, true], ["HasTexCoords", IFCTEXTURECOORDINATEINDICES, 1, true]],
  572779678: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  428585644: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1281925730: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1425443689: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3888040117: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true]],
  590820931: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3388369263: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3505215534: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2485787929: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1682466193: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  603570806: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  220341763: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3381221214: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3967405729: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  569719735: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  2945172077: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsPredecessorTo", IFCRELSEQUENCE, 4, true], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  4208778838: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  103090709: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Declares", IFCRELDECLARES, 4, true]],
  653396225: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Declares", IFCRELDECLARES, 4, true]],
  871118103: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  4166981789: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  2752243245: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  941946838: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  1451395588: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  492091185: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Defines", IFCRELDEFINESBYTEMPLATE, 5, true]],
  3650150729: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  110355661: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  3521284610: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["PartOfComplexTemplate", IFCCOMPLEXPROPERTYTEMPLATE, 6, true], ["PartOfPsetTemplate", IFCPROPERTYSETTEMPLATE, 6, true]],
  2770003689: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  2798486643: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3454111270: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3765753017: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  3523091289: [["InnerBoundaries", IFCRELSPACEBOUNDARY1STLEVEL, 9, true]],
  1521410863: [["InnerBoundaries", IFCRELSPACEBOUNDARY1STLEVEL, 9, true], ["Corresponds", IFCRELSPACEBOUNDARY2NDLEVEL, 10, true]],
  816062949: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["UsingCurves", IFCCOMPOSITECURVE, 0, true]],
  2914609552: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1856042241: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3243963512: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4158566097: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3626867408: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1862484736: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1290935644: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1356537516: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3663146110: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["PartOfComplexTemplate", IFCCOMPLEXPROPERTYTEMPLATE, 6, true], ["PartOfPsetTemplate", IFCPROPERTYSETTEMPLATE, 6, true]],
  1412071761: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  710998568: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2706606064: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  3893378262: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  463610769: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  2481509218: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  451544542: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4015995234: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2735484536: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3544373492: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  3136571912: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true]],
  530289379: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  3689010777: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  3979015343: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  2218152070: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  603775116: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  4095615324: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  699246055: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2028607225: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2809605785: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4124788165: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1580310250: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3473067441: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsPredecessorTo", IFCRELSEQUENCE, 4, true], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  3206491090: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  2387106220: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["HasColours", IFCINDEXEDCOLOURMAP, 0, true], ["HasTextures", IFCINDEXEDTEXTUREMAP, 1, true]],
  782932809: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1935646853: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3665877780: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2916149573: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["HasColours", IFCINDEXEDCOLOURMAP, 0, true], ["HasTextures", IFCINDEXEDTEXTUREMAP, 1, true]],
  1229763772: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["HasColours", IFCINDEXEDCOLOURMAP, 0, true], ["HasTextures", IFCINDEXEDTEXTUREMAP, 1, true]],
  3651464721: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  336235671: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  512836454: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  2296667514: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsActingUpon", IFCRELASSIGNSTOACTOR, 6, true]],
  1635779807: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2603310189: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1674181508: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2887950389: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  167062518: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1334484129: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3649129432: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1260505505: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3124254112: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  1626504194: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2197970202: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2937912522: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  3893394355: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3497074424: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  300633059: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3875453745: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["PartOfComplexTemplate", IFCCOMPLEXPROPERTYTEMPLATE, 6, true], ["PartOfPsetTemplate", IFCPROPERTYSETTEMPLATE, 6, true]],
  3732776249: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  15328376: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2510884976: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2185764099: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  4105962743: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1525564444: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  2559216714: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  3293443760: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  2000195564: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3895139033: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1419761937: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  4189326743: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1916426348: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3295246426: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1457835157: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1213902940: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1306400036: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4234616927: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3256556792: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3849074793: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2963535650: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  1714330368: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  2323601079: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1758889154: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  4123344466: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2397081782: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1623761950: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2590856083: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1704287377: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2107101300: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  132023988: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3174744832: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3390157468: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4148101412: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsPredecessorTo", IFCRELSEQUENCE, 4, true], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  2853485674: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  807026263: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3737207727: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  24185140: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  1310830890: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  4228831410: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  647756555: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2489546625: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2827207264: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2143335405: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["ProjectsElements", IFCRELPROJECTSELEMENT, 5, false]],
  1287392070: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["VoidsElements", IFCRELVOIDSELEMENT, 5, false]],
  3907093117: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3198132628: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3815607619: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1482959167: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1834744321: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1339347760: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2297155007: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3009222698: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1893162501: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  263784265: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  1509553395: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3493046030: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  4230923436: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  1594536857: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2898700619: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2706460486: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  1251058090: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1806887404: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2568555532: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3948183225: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2571569899: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3946677679: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3113134337: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2391368822: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  4288270099: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  679976338: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3827777499: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1051575348: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1161773419: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2176059722: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  1770583370: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  525669439: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  976884017: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  377706215: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2108223431: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1114901282: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3181161470: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1950438474: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  710110818: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  977012517: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  506776471: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4143007308: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsActingUpon", IFCRELASSIGNSTOACTOR, 6, true]],
  3588315303: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["VoidsElements", IFCRELVOIDSELEMENT, 5, false], ["HasFillings", IFCRELFILLSELEMENT, 4, true]],
  2837617999: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  514975943: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2382730787: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3566463478: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  3327091369: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1158309216: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  804291784: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4231323485: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4017108033: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2839578677: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["HasColours", IFCINDEXEDCOLOURMAP, 0, true], ["HasTextures", IFCINDEXEDTEXTUREMAP, 1, true]],
  3724593414: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3740093272: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainedIn", IFCRELCONNECTSPORTTOELEMENT, 4, true], ["ConnectedFrom", IFCRELCONNECTSPORTS, 5, true], ["ConnectedTo", IFCRELCONNECTSPORTS, 4, true]],
  1946335990: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["Positions", IFCRELPOSITIONS, 4, true]],
  2744685151: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsPredecessorTo", IFCRELSEQUENCE, 4, true], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  2904328755: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3651124850: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["ProjectsElements", IFCRELPROJECTSELEMENT, 5, false]],
  1842657554: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2250791053: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1763565496: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2893384427: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3992365140: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  1891881377: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  2324767716: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1469900589: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  683857671: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4021432810: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["Positions", IFCRELPOSITIONS, 4, true]],
  3027567501: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  964333572: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2320036040: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2310774935: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  146592293: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  550521510: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  2781568857: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1768891740: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2157484638: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3649235739: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  544395925: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1027922057: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4074543187: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  33720170: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3599934289: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1894708472: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  42703149: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4097777520: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  2533589738: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1072016465: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3856911033: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasCoverings", IFCRELCOVERSSPACES, 4, true], ["BoundedBy", IFCRELSPACEBOUNDARY, 4, true]],
  1305183839: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3812236995: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3112655638: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1039846685: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  338393293: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  682877961: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  1179482911: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, true]],
  1004757350: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  4243806635: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, true]],
  214636428: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  2445595289: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  2757150158: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  1807405624: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  1252848954: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["SourceOfResultGroup", IFCSTRUCTURALRESULTGROUP, 6, true], ["LoadGroupFor", IFCSTRUCTURALANALYSISMODEL, 7, true]],
  2082059205: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  734778138: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, true]],
  1235345126: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  2986769608: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ResultGroupFor", IFCSTRUCTURALANALYSISMODEL, 8, true]],
  3657597509: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  1975003073: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, true]],
  148013059: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  3101698114: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["AdheresToElement", IFCRELADHERESTOELEMENT, 5, false]],
  2315554128: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2254336722: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true], ["ServicesFacilities", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  413509423: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  5716631: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3824725483: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2347447852: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3081323446: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3663046924: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2281632017: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2415094496: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  618700268: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1692211062: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2097647324: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1953115116: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3593883385: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1600972822: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1911125066: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  728799441: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  840318589: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  1530820697: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3956297820: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2391383451: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3313531582: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2769231204: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  926996030: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["VoidsElements", IFCRELVOIDSELEMENT, 5, false]],
  1898987631: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1133259667: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4009809668: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4088093105: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1028945134: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  4218914973: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3342526732: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1033361043: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true], ["ServicesFacilities", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  3821786052: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1411407467: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3352864051: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1871374353: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4266260250: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  1545765605: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  317615605: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  1662888072: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  3460190687: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  1532957894: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1967976161: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2461110595: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  819618141: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3649138523: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  231477066: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1136057603: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  644574406: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  963979645: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  4031249490: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  2979338954: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  39481116: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1909888760: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1177604601: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true], ["ServicesFacilities", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  1876633798: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3862327254: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true], ["ServicesFacilities", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  2188180465: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  395041908: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3293546465: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2674252688: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1285652485: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3203706013: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2951183804: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3296154744: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2611217952: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1677625105: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2301859152: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  843113511: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  400855858: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3850581409: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2816379211: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3898045240: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1060000209: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  488727124: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  2940368186: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  335055490: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2954562838: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1502416096: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  1973544240: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["CoversSpaces", IFCRELCOVERSSPACES, 5, true], ["CoversElements", IFCRELCOVERSBLDGELEMENTS, 5, true]],
  3495092785: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3961806047: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3426335179: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  1335981549: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2635815018: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  479945903: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1599208980: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2063403501: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1945004755: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true]],
  3040386961: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3041715199: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainedIn", IFCRELCONNECTSPORTTOELEMENT, 4, true], ["ConnectedFrom", IFCRELCONNECTSPORTS, 5, true], ["ConnectedTo", IFCRELCONNECTSPORTS, 4, true]],
  3205830791: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true], ["ServicesFacilities", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  395920057: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  869906466: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3760055223: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2030761528: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3071239417: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["VoidsElements", IFCRELVOIDSELEMENT, 5, false]],
  1077100507: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3376911765: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  663422040: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2417008758: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3277789161: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2142170206: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1534661035: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1217240411: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  712377611: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1658829314: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2814081492: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3747195512: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  484807127: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1209101575: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["BoundedBy", IFCRELSPACEBOUNDARY, 4, true]],
  346874300: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1810631287: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4222183408: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2058353004: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4278956645: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4037862832: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2188021234: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3132237377: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  987401354: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  707683696: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2223149337: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3508470533: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  900683007: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2713699986: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3009204131: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["Positions", IFCRELPOSITIONS, 4, true]],
  3319311131: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2068733104: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4175244083: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2176052936: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2696325953: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  76236018: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  629592764: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1154579445: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["Positions", IFCRELPOSITIONS, 4, true]],
  1638804497: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1437502449: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1073191201: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2078563270: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  234836483: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2474470126: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2182337498: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  144952367: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3694346114: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1383356374: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  1687234759: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  310824031: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3612865200: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3171933400: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  738039164: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  655969474: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  90941305: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3290496277: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2262370178: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3024970846: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3283111854: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  1232101972: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3798194928: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  979691226: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2572171363: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2016517767: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3053780830: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1783015770: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1329646415: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  991950508: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1529196076: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3420628829: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1999602285: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1404847402: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  331165859: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  4252922144: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2515109513: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true], ["ServicesFacilities", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  385403989: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["SourceOfResultGroup", IFCSTRUCTURALRESULTGROUP, 6, true], ["LoadGroupFor", IFCSTRUCTURALANALYSISMODEL, 7, true]],
  1621171031: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  1162798199: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  812556717: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3425753595: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3825984169: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1620046519: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3026737570: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3179687236: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4292641817: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4207607924: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2391406946: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3512223829: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  4237592921: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3304561284: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2874132201: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1634111441: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  177149247: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2056796094: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3001207471: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  325726236: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["Positions", IFCRELPOSITIONS, 4, true]],
  277319702: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  753842376: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  4196446775: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  32344328: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3314249567: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  1095909175: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2938176219: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  635142910: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3758799889: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1051757585: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4217484030: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3999819293: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3902619387: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  639361253: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3221913625: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3571504051: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2272882330: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  578613899: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3460952963: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4136498852: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3640358203: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4074379575: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3693000487: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1052013943: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  562808652: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true], ["ServicesFacilities", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  1062813311: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  342316401: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3518393246: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1360408905: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1904799276: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  862014818: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3310460725: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  24726584: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  264262732: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  402227799: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1003880860: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3415622556: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  819412036: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1426591983: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  182646315: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  2680139844: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  1971632696: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2295281155: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  4086658281: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  630975310: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  4288193352: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  3087945054: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  25142252: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]]
};
Constructors[3] = {
  3630933823: (a) => new IFC4X3.IfcActorRole(a[0], a[1], a[2]),
  618182010: (a) => new IFC4X3.IfcAddress(a[0], a[1], a[2]),
  2879124712: (a) => new IFC4X3.IfcAlignmentParameterSegment(a[0], a[1]),
  3633395639: (a) => new IFC4X3.IfcAlignmentVerticalSegment(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  639542469: (a) => new IFC4X3.IfcApplication(a[0], a[1], a[2], a[3]),
  411424972: (a) => new IFC4X3.IfcAppliedValue(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  130549933: (a) => new IFC4X3.IfcApproval(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4037036970: (a) => new IFC4X3.IfcBoundaryCondition(a[0]),
  1560379544: (a) => new IFC4X3.IfcBoundaryEdgeCondition(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3367102660: (a) => new IFC4X3.IfcBoundaryFaceCondition(a[0], a[1], a[2], a[3]),
  1387855156: (a) => new IFC4X3.IfcBoundaryNodeCondition(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  2069777674: (a) => new IFC4X3.IfcBoundaryNodeConditionWarping(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2859738748: (_) => new IFC4X3.IfcConnectionGeometry(),
  2614616156: (a) => new IFC4X3.IfcConnectionPointGeometry(a[0], a[1]),
  2732653382: (a) => new IFC4X3.IfcConnectionSurfaceGeometry(a[0], a[1]),
  775493141: (a) => new IFC4X3.IfcConnectionVolumeGeometry(a[0], a[1]),
  1959218052: (a) => new IFC4X3.IfcConstraint(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1785450214: (a) => new IFC4X3.IfcCoordinateOperation(a[0], a[1]),
  1466758467: (a) => new IFC4X3.IfcCoordinateReferenceSystem(a[0], a[1], a[2], a[3]),
  602808272: (a) => new IFC4X3.IfcCostValue(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1765591967: (a) => new IFC4X3.IfcDerivedUnit(a[0], a[1], a[2], a[3]),
  1045800335: (a) => new IFC4X3.IfcDerivedUnitElement(a[0], a[1]),
  2949456006: (a) => new IFC4X3.IfcDimensionalExponents(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  4294318154: (_) => new IFC4X3.IfcExternalInformation(),
  3200245327: (a) => new IFC4X3.IfcExternalReference(a[0], a[1], a[2]),
  2242383968: (a) => new IFC4X3.IfcExternallyDefinedHatchStyle(a[0], a[1], a[2]),
  1040185647: (a) => new IFC4X3.IfcExternallyDefinedSurfaceStyle(a[0], a[1], a[2]),
  3548104201: (a) => new IFC4X3.IfcExternallyDefinedTextFont(a[0], a[1], a[2]),
  852622518: (a) => new IFC4X3.IfcGridAxis(a[0], a[1], a[2]),
  3020489413: (a) => new IFC4X3.IfcIrregularTimeSeriesValue(a[0], a[1]),
  2655187982: (a) => new IFC4X3.IfcLibraryInformation(a[0], a[1], a[2], a[3], a[4], a[5]),
  3452421091: (a) => new IFC4X3.IfcLibraryReference(a[0], a[1], a[2], a[3], a[4], a[5]),
  4162380809: (a) => new IFC4X3.IfcLightDistributionData(a[0], a[1], a[2]),
  1566485204: (a) => new IFC4X3.IfcLightIntensityDistribution(a[0], a[1]),
  3057273783: (a) => new IFC4X3.IfcMapConversion(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1847130766: (a) => new IFC4X3.IfcMaterialClassificationRelationship(a[0], a[1]),
  760658860: (_) => new IFC4X3.IfcMaterialDefinition(),
  248100487: (a) => new IFC4X3.IfcMaterialLayer(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3303938423: (a) => new IFC4X3.IfcMaterialLayerSet(a[0], a[1], a[2]),
  1847252529: (a) => new IFC4X3.IfcMaterialLayerWithOffsets(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2199411900: (a) => new IFC4X3.IfcMaterialList(a[0]),
  2235152071: (a) => new IFC4X3.IfcMaterialProfile(a[0], a[1], a[2], a[3], a[4], a[5]),
  164193824: (a) => new IFC4X3.IfcMaterialProfileSet(a[0], a[1], a[2], a[3]),
  552965576: (a) => new IFC4X3.IfcMaterialProfileWithOffsets(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1507914824: (_) => new IFC4X3.IfcMaterialUsageDefinition(),
  2597039031: (a) => new IFC4X3.IfcMeasureWithUnit(a[0], a[1]),
  3368373690: (a) => new IFC4X3.IfcMetric(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  2706619895: (a) => new IFC4X3.IfcMonetaryUnit(a[0]),
  1918398963: (a) => new IFC4X3.IfcNamedUnit(a[0], a[1]),
  3701648758: (a) => new IFC4X3.IfcObjectPlacement(a[0]),
  2251480897: (a) => new IFC4X3.IfcObjective(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  4251960020: (a) => new IFC4X3.IfcOrganization(a[0], a[1], a[2], a[3], a[4]),
  1207048766: (a) => new IFC4X3.IfcOwnerHistory(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2077209135: (a) => new IFC4X3.IfcPerson(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  101040310: (a) => new IFC4X3.IfcPersonAndOrganization(a[0], a[1], a[2]),
  2483315170: (a) => new IFC4X3.IfcPhysicalQuantity(a[0], a[1]),
  2226359599: (a) => new IFC4X3.IfcPhysicalSimpleQuantity(a[0], a[1], a[2]),
  3355820592: (a) => new IFC4X3.IfcPostalAddress(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  677532197: (_) => new IFC4X3.IfcPresentationItem(),
  2022622350: (a) => new IFC4X3.IfcPresentationLayerAssignment(a[0], a[1], a[2], a[3]),
  1304840413: (a) => new IFC4X3.IfcPresentationLayerWithStyle(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3119450353: (a) => new IFC4X3.IfcPresentationStyle(a[0]),
  2095639259: (a) => new IFC4X3.IfcProductRepresentation(a[0], a[1], a[2]),
  3958567839: (a) => new IFC4X3.IfcProfileDef(a[0], a[1]),
  3843373140: (a) => new IFC4X3.IfcProjectedCRS(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  986844984: (_) => new IFC4X3.IfcPropertyAbstraction(),
  3710013099: (a) => new IFC4X3.IfcPropertyEnumeration(a[0], a[1], a[2]),
  2044713172: (a) => new IFC4X3.IfcQuantityArea(a[0], a[1], a[2], a[3], a[4]),
  2093928680: (a) => new IFC4X3.IfcQuantityCount(a[0], a[1], a[2], a[3], a[4]),
  931644368: (a) => new IFC4X3.IfcQuantityLength(a[0], a[1], a[2], a[3], a[4]),
  2691318326: (a) => new IFC4X3.IfcQuantityNumber(a[0], a[1], a[2], a[3], a[4]),
  3252649465: (a) => new IFC4X3.IfcQuantityTime(a[0], a[1], a[2], a[3], a[4]),
  2405470396: (a) => new IFC4X3.IfcQuantityVolume(a[0], a[1], a[2], a[3], a[4]),
  825690147: (a) => new IFC4X3.IfcQuantityWeight(a[0], a[1], a[2], a[3], a[4]),
  3915482550: (a) => new IFC4X3.IfcRecurrencePattern(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2433181523: (a) => new IFC4X3.IfcReference(a[0], a[1], a[2], a[3], a[4]),
  1076942058: (a) => new IFC4X3.IfcRepresentation(a[0], a[1], a[2], a[3]),
  3377609919: (a) => new IFC4X3.IfcRepresentationContext(a[0], a[1]),
  3008791417: (_) => new IFC4X3.IfcRepresentationItem(),
  1660063152: (a) => new IFC4X3.IfcRepresentationMap(a[0], a[1]),
  2439245199: (a) => new IFC4X3.IfcResourceLevelRelationship(a[0], a[1]),
  2341007311: (a) => new IFC4X3.IfcRoot(a[0], a[1], a[2], a[3]),
  448429030: (a) => new IFC4X3.IfcSIUnit(a[0], a[1], a[2]),
  1054537805: (a) => new IFC4X3.IfcSchedulingTime(a[0], a[1], a[2]),
  867548509: (a) => new IFC4X3.IfcShapeAspect(a[0], a[1], a[2], a[3], a[4]),
  3982875396: (a) => new IFC4X3.IfcShapeModel(a[0], a[1], a[2], a[3]),
  4240577450: (a) => new IFC4X3.IfcShapeRepresentation(a[0], a[1], a[2], a[3]),
  2273995522: (a) => new IFC4X3.IfcStructuralConnectionCondition(a[0]),
  2162789131: (a) => new IFC4X3.IfcStructuralLoad(a[0]),
  3478079324: (a) => new IFC4X3.IfcStructuralLoadConfiguration(a[0], a[1], a[2]),
  609421318: (a) => new IFC4X3.IfcStructuralLoadOrResult(a[0]),
  2525727697: (a) => new IFC4X3.IfcStructuralLoadStatic(a[0]),
  3408363356: (a) => new IFC4X3.IfcStructuralLoadTemperature(a[0], a[1], a[2], a[3]),
  2830218821: (a) => new IFC4X3.IfcStyleModel(a[0], a[1], a[2], a[3]),
  3958052878: (a) => new IFC4X3.IfcStyledItem(a[0], a[1], a[2]),
  3049322572: (a) => new IFC4X3.IfcStyledRepresentation(a[0], a[1], a[2], a[3]),
  2934153892: (a) => new IFC4X3.IfcSurfaceReinforcementArea(a[0], a[1], a[2], a[3]),
  1300840506: (a) => new IFC4X3.IfcSurfaceStyle(a[0], a[1], a[2]),
  3303107099: (a) => new IFC4X3.IfcSurfaceStyleLighting(a[0], a[1], a[2], a[3]),
  1607154358: (a) => new IFC4X3.IfcSurfaceStyleRefraction(a[0], a[1]),
  846575682: (a) => new IFC4X3.IfcSurfaceStyleShading(a[0], a[1]),
  1351298697: (a) => new IFC4X3.IfcSurfaceStyleWithTextures(a[0]),
  626085974: (a) => new IFC4X3.IfcSurfaceTexture(a[0], a[1], a[2], a[3], a[4]),
  985171141: (a) => new IFC4X3.IfcTable(a[0], a[1], a[2]),
  2043862942: (a) => new IFC4X3.IfcTableColumn(a[0], a[1], a[2], a[3], a[4]),
  531007025: (a) => new IFC4X3.IfcTableRow(a[0], a[1]),
  1549132990: (a) => new IFC4X3.IfcTaskTime(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18], a[19]),
  2771591690: (a) => new IFC4X3.IfcTaskTimeRecurring(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18], a[19], a[20]),
  912023232: (a) => new IFC4X3.IfcTelecomAddress(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1447204868: (a) => new IFC4X3.IfcTextStyle(a[0], a[1], a[2], a[3], a[4]),
  2636378356: (a) => new IFC4X3.IfcTextStyleForDefinedFont(a[0], a[1]),
  1640371178: (a) => new IFC4X3.IfcTextStyleTextModel(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  280115917: (a) => new IFC4X3.IfcTextureCoordinate(a[0]),
  1742049831: (a) => new IFC4X3.IfcTextureCoordinateGenerator(a[0], a[1], a[2]),
  222769930: (a) => new IFC4X3.IfcTextureCoordinateIndices(a[0], a[1]),
  1010789467: (a) => new IFC4X3.IfcTextureCoordinateIndicesWithVoids(a[0], a[1], a[2]),
  2552916305: (a) => new IFC4X3.IfcTextureMap(a[0], a[1], a[2]),
  1210645708: (a) => new IFC4X3.IfcTextureVertex(a[0]),
  3611470254: (a) => new IFC4X3.IfcTextureVertexList(a[0]),
  1199560280: (a) => new IFC4X3.IfcTimePeriod(a[0], a[1]),
  3101149627: (a) => new IFC4X3.IfcTimeSeries(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  581633288: (a) => new IFC4X3.IfcTimeSeriesValue(a[0]),
  1377556343: (_) => new IFC4X3.IfcTopologicalRepresentationItem(),
  1735638870: (a) => new IFC4X3.IfcTopologyRepresentation(a[0], a[1], a[2], a[3]),
  180925521: (a) => new IFC4X3.IfcUnitAssignment(a[0]),
  2799835756: (_) => new IFC4X3.IfcVertex(),
  1907098498: (a) => new IFC4X3.IfcVertexPoint(a[0]),
  891718957: (a) => new IFC4X3.IfcVirtualGridIntersection(a[0], a[1]),
  1236880293: (a) => new IFC4X3.IfcWorkTime(a[0], a[1], a[2], a[3], a[4], a[5]),
  3752311538: (a) => new IFC4X3.IfcAlignmentCantSegment(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  536804194: (a) => new IFC4X3.IfcAlignmentHorizontalSegment(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3869604511: (a) => new IFC4X3.IfcApprovalRelationship(a[0], a[1], a[2], a[3]),
  3798115385: (a) => new IFC4X3.IfcArbitraryClosedProfileDef(a[0], a[1], a[2]),
  1310608509: (a) => new IFC4X3.IfcArbitraryOpenProfileDef(a[0], a[1], a[2]),
  2705031697: (a) => new IFC4X3.IfcArbitraryProfileDefWithVoids(a[0], a[1], a[2], a[3]),
  616511568: (a) => new IFC4X3.IfcBlobTexture(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3150382593: (a) => new IFC4X3.IfcCenterLineProfileDef(a[0], a[1], a[2], a[3]),
  747523909: (a) => new IFC4X3.IfcClassification(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  647927063: (a) => new IFC4X3.IfcClassificationReference(a[0], a[1], a[2], a[3], a[4], a[5]),
  3285139300: (a) => new IFC4X3.IfcColourRgbList(a[0]),
  3264961684: (a) => new IFC4X3.IfcColourSpecification(a[0]),
  1485152156: (a) => new IFC4X3.IfcCompositeProfileDef(a[0], a[1], a[2], a[3]),
  370225590: (a) => new IFC4X3.IfcConnectedFaceSet(a[0]),
  1981873012: (a) => new IFC4X3.IfcConnectionCurveGeometry(a[0], a[1]),
  45288368: (a) => new IFC4X3.IfcConnectionPointEccentricity(a[0], a[1], a[2], a[3], a[4]),
  3050246964: (a) => new IFC4X3.IfcContextDependentUnit(a[0], a[1], a[2]),
  2889183280: (a) => new IFC4X3.IfcConversionBasedUnit(a[0], a[1], a[2], a[3]),
  2713554722: (a) => new IFC4X3.IfcConversionBasedUnitWithOffset(a[0], a[1], a[2], a[3], a[4]),
  539742890: (a) => new IFC4X3.IfcCurrencyRelationship(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3800577675: (a) => new IFC4X3.IfcCurveStyle(a[0], a[1], a[2], a[3], a[4]),
  1105321065: (a) => new IFC4X3.IfcCurveStyleFont(a[0], a[1]),
  2367409068: (a) => new IFC4X3.IfcCurveStyleFontAndScaling(a[0], a[1], a[2]),
  3510044353: (a) => new IFC4X3.IfcCurveStyleFontPattern(a[0], a[1]),
  3632507154: (a) => new IFC4X3.IfcDerivedProfileDef(a[0], a[1], a[2], a[3], a[4]),
  1154170062: (a) => new IFC4X3.IfcDocumentInformation(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16]),
  770865208: (a) => new IFC4X3.IfcDocumentInformationRelationship(a[0], a[1], a[2], a[3], a[4]),
  3732053477: (a) => new IFC4X3.IfcDocumentReference(a[0], a[1], a[2], a[3], a[4]),
  3900360178: (a) => new IFC4X3.IfcEdge(a[0], a[1]),
  476780140: (a) => new IFC4X3.IfcEdgeCurve(a[0], a[1], a[2], a[3]),
  211053100: (a) => new IFC4X3.IfcEventTime(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  297599258: (a) => new IFC4X3.IfcExtendedProperties(a[0], a[1], a[2]),
  1437805879: (a) => new IFC4X3.IfcExternalReferenceRelationship(a[0], a[1], a[2], a[3]),
  2556980723: (a) => new IFC4X3.IfcFace(a[0]),
  1809719519: (a) => new IFC4X3.IfcFaceBound(a[0], a[1]),
  803316827: (a) => new IFC4X3.IfcFaceOuterBound(a[0], a[1]),
  3008276851: (a) => new IFC4X3.IfcFaceSurface(a[0], a[1], a[2]),
  4219587988: (a) => new IFC4X3.IfcFailureConnectionCondition(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  738692330: (a) => new IFC4X3.IfcFillAreaStyle(a[0], a[1], a[2]),
  3448662350: (a) => new IFC4X3.IfcGeometricRepresentationContext(a[0], a[1], a[2], a[3], a[4], a[5]),
  2453401579: (_) => new IFC4X3.IfcGeometricRepresentationItem(),
  4142052618: (a) => new IFC4X3.IfcGeometricRepresentationSubContext(a[0], a[1], a[2], a[3], a[4], a[5]),
  3590301190: (a) => new IFC4X3.IfcGeometricSet(a[0]),
  178086475: (a) => new IFC4X3.IfcGridPlacement(a[0], a[1], a[2]),
  812098782: (a) => new IFC4X3.IfcHalfSpaceSolid(a[0], a[1]),
  3905492369: (a) => new IFC4X3.IfcImageTexture(a[0], a[1], a[2], a[3], a[4], a[5]),
  3570813810: (a) => new IFC4X3.IfcIndexedColourMap(a[0], a[1], a[2], a[3]),
  1437953363: (a) => new IFC4X3.IfcIndexedTextureMap(a[0], a[1], a[2]),
  2133299955: (a) => new IFC4X3.IfcIndexedTriangleTextureMap(a[0], a[1], a[2], a[3]),
  3741457305: (a) => new IFC4X3.IfcIrregularTimeSeries(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1585845231: (a) => new IFC4X3.IfcLagTime(a[0], a[1], a[2], a[3], a[4]),
  1402838566: (a) => new IFC4X3.IfcLightSource(a[0], a[1], a[2], a[3]),
  125510826: (a) => new IFC4X3.IfcLightSourceAmbient(a[0], a[1], a[2], a[3]),
  2604431987: (a) => new IFC4X3.IfcLightSourceDirectional(a[0], a[1], a[2], a[3], a[4]),
  4266656042: (a) => new IFC4X3.IfcLightSourceGoniometric(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1520743889: (a) => new IFC4X3.IfcLightSourcePositional(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3422422726: (a) => new IFC4X3.IfcLightSourceSpot(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  388784114: (a) => new IFC4X3.IfcLinearPlacement(a[0], a[1], a[2]),
  2624227202: (a) => new IFC4X3.IfcLocalPlacement(a[0], a[1]),
  1008929658: (_) => new IFC4X3.IfcLoop(),
  2347385850: (a) => new IFC4X3.IfcMappedItem(a[0], a[1]),
  1838606355: (a) => new IFC4X3.IfcMaterial(a[0], a[1], a[2]),
  3708119e3: (a) => new IFC4X3.IfcMaterialConstituent(a[0], a[1], a[2], a[3], a[4]),
  2852063980: (a) => new IFC4X3.IfcMaterialConstituentSet(a[0], a[1], a[2]),
  2022407955: (a) => new IFC4X3.IfcMaterialDefinitionRepresentation(a[0], a[1], a[2], a[3]),
  1303795690: (a) => new IFC4X3.IfcMaterialLayerSetUsage(a[0], a[1], a[2], a[3], a[4]),
  3079605661: (a) => new IFC4X3.IfcMaterialProfileSetUsage(a[0], a[1], a[2]),
  3404854881: (a) => new IFC4X3.IfcMaterialProfileSetUsageTapering(a[0], a[1], a[2], a[3], a[4]),
  3265635763: (a) => new IFC4X3.IfcMaterialProperties(a[0], a[1], a[2], a[3]),
  853536259: (a) => new IFC4X3.IfcMaterialRelationship(a[0], a[1], a[2], a[3], a[4]),
  2998442950: (a) => new IFC4X3.IfcMirroredProfileDef(a[0], a[1], a[2], a[3]),
  219451334: (a) => new IFC4X3.IfcObjectDefinition(a[0], a[1], a[2], a[3]),
  182550632: (a) => new IFC4X3.IfcOpenCrossProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  2665983363: (a) => new IFC4X3.IfcOpenShell(a[0]),
  1411181986: (a) => new IFC4X3.IfcOrganizationRelationship(a[0], a[1], a[2], a[3]),
  1029017970: (a) => new IFC4X3.IfcOrientedEdge(a[0], a[1]),
  2529465313: (a) => new IFC4X3.IfcParameterizedProfileDef(a[0], a[1], a[2]),
  2519244187: (a) => new IFC4X3.IfcPath(a[0]),
  3021840470: (a) => new IFC4X3.IfcPhysicalComplexQuantity(a[0], a[1], a[2], a[3], a[4], a[5]),
  597895409: (a) => new IFC4X3.IfcPixelTexture(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2004835150: (a) => new IFC4X3.IfcPlacement(a[0]),
  1663979128: (a) => new IFC4X3.IfcPlanarExtent(a[0], a[1]),
  2067069095: (_) => new IFC4X3.IfcPoint(),
  2165702409: (a) => new IFC4X3.IfcPointByDistanceExpression(a[0], a[1], a[2], a[3], a[4]),
  4022376103: (a) => new IFC4X3.IfcPointOnCurve(a[0], a[1]),
  1423911732: (a) => new IFC4X3.IfcPointOnSurface(a[0], a[1], a[2]),
  2924175390: (a) => new IFC4X3.IfcPolyLoop(a[0]),
  2775532180: (a) => new IFC4X3.IfcPolygonalBoundedHalfSpace(a[0], a[1], a[2], a[3]),
  3727388367: (a) => new IFC4X3.IfcPreDefinedItem(a[0]),
  3778827333: (_) => new IFC4X3.IfcPreDefinedProperties(),
  1775413392: (a) => new IFC4X3.IfcPreDefinedTextFont(a[0]),
  673634403: (a) => new IFC4X3.IfcProductDefinitionShape(a[0], a[1], a[2]),
  2802850158: (a) => new IFC4X3.IfcProfileProperties(a[0], a[1], a[2], a[3]),
  2598011224: (a) => new IFC4X3.IfcProperty(a[0], a[1]),
  1680319473: (a) => new IFC4X3.IfcPropertyDefinition(a[0], a[1], a[2], a[3]),
  148025276: (a) => new IFC4X3.IfcPropertyDependencyRelationship(a[0], a[1], a[2], a[3], a[4]),
  3357820518: (a) => new IFC4X3.IfcPropertySetDefinition(a[0], a[1], a[2], a[3]),
  1482703590: (a) => new IFC4X3.IfcPropertyTemplateDefinition(a[0], a[1], a[2], a[3]),
  2090586900: (a) => new IFC4X3.IfcQuantitySet(a[0], a[1], a[2], a[3]),
  3615266464: (a) => new IFC4X3.IfcRectangleProfileDef(a[0], a[1], a[2], a[3], a[4]),
  3413951693: (a) => new IFC4X3.IfcRegularTimeSeries(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1580146022: (a) => new IFC4X3.IfcReinforcementBarProperties(a[0], a[1], a[2], a[3], a[4], a[5]),
  478536968: (a) => new IFC4X3.IfcRelationship(a[0], a[1], a[2], a[3]),
  2943643501: (a) => new IFC4X3.IfcResourceApprovalRelationship(a[0], a[1], a[2], a[3]),
  1608871552: (a) => new IFC4X3.IfcResourceConstraintRelationship(a[0], a[1], a[2], a[3]),
  1042787934: (a) => new IFC4X3.IfcResourceTime(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17]),
  2778083089: (a) => new IFC4X3.IfcRoundedRectangleProfileDef(a[0], a[1], a[2], a[3], a[4], a[5]),
  2042790032: (a) => new IFC4X3.IfcSectionProperties(a[0], a[1], a[2]),
  4165799628: (a) => new IFC4X3.IfcSectionReinforcementProperties(a[0], a[1], a[2], a[3], a[4], a[5]),
  1509187699: (a) => new IFC4X3.IfcSectionedSpine(a[0], a[1], a[2]),
  823603102: (a) => new IFC4X3.IfcSegment(a[0]),
  4124623270: (a) => new IFC4X3.IfcShellBasedSurfaceModel(a[0]),
  3692461612: (a) => new IFC4X3.IfcSimpleProperty(a[0], a[1]),
  2609359061: (a) => new IFC4X3.IfcSlippageConnectionCondition(a[0], a[1], a[2], a[3]),
  723233188: (_) => new IFC4X3.IfcSolidModel(),
  1595516126: (a) => new IFC4X3.IfcStructuralLoadLinearForce(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  2668620305: (a) => new IFC4X3.IfcStructuralLoadPlanarForce(a[0], a[1], a[2], a[3]),
  2473145415: (a) => new IFC4X3.IfcStructuralLoadSingleDisplacement(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1973038258: (a) => new IFC4X3.IfcStructuralLoadSingleDisplacementDistortion(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1597423693: (a) => new IFC4X3.IfcStructuralLoadSingleForce(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1190533807: (a) => new IFC4X3.IfcStructuralLoadSingleForceWarping(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2233826070: (a) => new IFC4X3.IfcSubedge(a[0], a[1], a[2]),
  2513912981: (_) => new IFC4X3.IfcSurface(),
  1878645084: (a) => new IFC4X3.IfcSurfaceStyleRendering(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2247615214: (a) => new IFC4X3.IfcSweptAreaSolid(a[0], a[1]),
  1260650574: (a) => new IFC4X3.IfcSweptDiskSolid(a[0], a[1], a[2], a[3], a[4]),
  1096409881: (a) => new IFC4X3.IfcSweptDiskSolidPolygonal(a[0], a[1], a[2], a[3], a[4], a[5]),
  230924584: (a) => new IFC4X3.IfcSweptSurface(a[0], a[1]),
  3071757647: (a) => new IFC4X3.IfcTShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  901063453: (_) => new IFC4X3.IfcTessellatedItem(),
  4282788508: (a) => new IFC4X3.IfcTextLiteral(a[0], a[1], a[2]),
  3124975700: (a) => new IFC4X3.IfcTextLiteralWithExtent(a[0], a[1], a[2], a[3], a[4]),
  1983826977: (a) => new IFC4X3.IfcTextStyleFontModel(a[0], a[1], a[2], a[3], a[4], a[5]),
  2715220739: (a) => new IFC4X3.IfcTrapeziumProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1628702193: (a) => new IFC4X3.IfcTypeObject(a[0], a[1], a[2], a[3], a[4], a[5]),
  3736923433: (a) => new IFC4X3.IfcTypeProcess(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2347495698: (a) => new IFC4X3.IfcTypeProduct(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3698973494: (a) => new IFC4X3.IfcTypeResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  427810014: (a) => new IFC4X3.IfcUShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1417489154: (a) => new IFC4X3.IfcVector(a[0], a[1]),
  2759199220: (a) => new IFC4X3.IfcVertexLoop(a[0]),
  2543172580: (a) => new IFC4X3.IfcZShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3406155212: (a) => new IFC4X3.IfcAdvancedFace(a[0], a[1], a[2]),
  669184980: (a) => new IFC4X3.IfcAnnotationFillArea(a[0], a[1]),
  3207858831: (a) => new IFC4X3.IfcAsymmetricIShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14]),
  4261334040: (a) => new IFC4X3.IfcAxis1Placement(a[0], a[1]),
  3125803723: (a) => new IFC4X3.IfcAxis2Placement2D(a[0], a[1]),
  2740243338: (a) => new IFC4X3.IfcAxis2Placement3D(a[0], a[1], a[2]),
  3425423356: (a) => new IFC4X3.IfcAxis2PlacementLinear(a[0], a[1], a[2]),
  2736907675: (a) => new IFC4X3.IfcBooleanResult(a[0], a[1], a[2]),
  4182860854: (_) => new IFC4X3.IfcBoundedSurface(),
  2581212453: (a) => new IFC4X3.IfcBoundingBox(a[0], a[1], a[2], a[3]),
  2713105998: (a) => new IFC4X3.IfcBoxedHalfSpace(a[0], a[1], a[2]),
  2898889636: (a) => new IFC4X3.IfcCShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1123145078: (a) => new IFC4X3.IfcCartesianPoint(a[0]),
  574549367: (_) => new IFC4X3.IfcCartesianPointList(),
  1675464909: (a) => new IFC4X3.IfcCartesianPointList2D(a[0], a[1]),
  2059837836: (a) => new IFC4X3.IfcCartesianPointList3D(a[0], a[1]),
  59481748: (a) => new IFC4X3.IfcCartesianTransformationOperator(a[0], a[1], a[2], a[3]),
  3749851601: (a) => new IFC4X3.IfcCartesianTransformationOperator2D(a[0], a[1], a[2], a[3]),
  3486308946: (a) => new IFC4X3.IfcCartesianTransformationOperator2DnonUniform(a[0], a[1], a[2], a[3], a[4]),
  3331915920: (a) => new IFC4X3.IfcCartesianTransformationOperator3D(a[0], a[1], a[2], a[3], a[4]),
  1416205885: (a) => new IFC4X3.IfcCartesianTransformationOperator3DnonUniform(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1383045692: (a) => new IFC4X3.IfcCircleProfileDef(a[0], a[1], a[2], a[3]),
  2205249479: (a) => new IFC4X3.IfcClosedShell(a[0]),
  776857604: (a) => new IFC4X3.IfcColourRgb(a[0], a[1], a[2], a[3]),
  2542286263: (a) => new IFC4X3.IfcComplexProperty(a[0], a[1], a[2], a[3]),
  2485617015: (a) => new IFC4X3.IfcCompositeCurveSegment(a[0], a[1], a[2]),
  2574617495: (a) => new IFC4X3.IfcConstructionResourceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  3419103109: (a) => new IFC4X3.IfcContext(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1815067380: (a) => new IFC4X3.IfcCrewResourceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  2506170314: (a) => new IFC4X3.IfcCsgPrimitive3D(a[0]),
  2147822146: (a) => new IFC4X3.IfcCsgSolid(a[0]),
  2601014836: (_) => new IFC4X3.IfcCurve(),
  2827736869: (a) => new IFC4X3.IfcCurveBoundedPlane(a[0], a[1], a[2]),
  2629017746: (a) => new IFC4X3.IfcCurveBoundedSurface(a[0], a[1], a[2]),
  4212018352: (a) => new IFC4X3.IfcCurveSegment(a[0], a[1], a[2], a[3], a[4]),
  32440307: (a) => new IFC4X3.IfcDirection(a[0]),
  593015953: (a) => new IFC4X3.IfcDirectrixCurveSweptAreaSolid(a[0], a[1], a[2], a[3], a[4]),
  1472233963: (a) => new IFC4X3.IfcEdgeLoop(a[0]),
  1883228015: (a) => new IFC4X3.IfcElementQuantity(a[0], a[1], a[2], a[3], a[4], a[5]),
  339256511: (a) => new IFC4X3.IfcElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2777663545: (a) => new IFC4X3.IfcElementarySurface(a[0]),
  2835456948: (a) => new IFC4X3.IfcEllipseProfileDef(a[0], a[1], a[2], a[3], a[4]),
  4024345920: (a) => new IFC4X3.IfcEventType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  477187591: (a) => new IFC4X3.IfcExtrudedAreaSolid(a[0], a[1], a[2], a[3]),
  2804161546: (a) => new IFC4X3.IfcExtrudedAreaSolidTapered(a[0], a[1], a[2], a[3], a[4]),
  2047409740: (a) => new IFC4X3.IfcFaceBasedSurfaceModel(a[0]),
  374418227: (a) => new IFC4X3.IfcFillAreaStyleHatching(a[0], a[1], a[2], a[3], a[4]),
  315944413: (a) => new IFC4X3.IfcFillAreaStyleTiles(a[0], a[1], a[2]),
  2652556860: (a) => new IFC4X3.IfcFixedReferenceSweptAreaSolid(a[0], a[1], a[2], a[3], a[4], a[5]),
  4238390223: (a) => new IFC4X3.IfcFurnishingElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1268542332: (a) => new IFC4X3.IfcFurnitureType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  4095422895: (a) => new IFC4X3.IfcGeographicElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  987898635: (a) => new IFC4X3.IfcGeometricCurveSet(a[0]),
  1484403080: (a) => new IFC4X3.IfcIShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  178912537: (a) => new IFC4X3.IfcIndexedPolygonalFace(a[0]),
  2294589976: (a) => new IFC4X3.IfcIndexedPolygonalFaceWithVoids(a[0], a[1]),
  3465909080: (a) => new IFC4X3.IfcIndexedPolygonalTextureMap(a[0], a[1], a[2], a[3]),
  572779678: (a) => new IFC4X3.IfcLShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  428585644: (a) => new IFC4X3.IfcLaborResourceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1281925730: (a) => new IFC4X3.IfcLine(a[0], a[1]),
  1425443689: (a) => new IFC4X3.IfcManifoldSolidBrep(a[0]),
  3888040117: (a) => new IFC4X3.IfcObject(a[0], a[1], a[2], a[3], a[4]),
  590820931: (a) => new IFC4X3.IfcOffsetCurve(a[0]),
  3388369263: (a) => new IFC4X3.IfcOffsetCurve2D(a[0], a[1], a[2]),
  3505215534: (a) => new IFC4X3.IfcOffsetCurve3D(a[0], a[1], a[2], a[3]),
  2485787929: (a) => new IFC4X3.IfcOffsetCurveByDistances(a[0], a[1], a[2]),
  1682466193: (a) => new IFC4X3.IfcPcurve(a[0], a[1]),
  603570806: (a) => new IFC4X3.IfcPlanarBox(a[0], a[1], a[2]),
  220341763: (a) => new IFC4X3.IfcPlane(a[0]),
  3381221214: (a) => new IFC4X3.IfcPolynomialCurve(a[0], a[1], a[2], a[3]),
  759155922: (a) => new IFC4X3.IfcPreDefinedColour(a[0]),
  2559016684: (a) => new IFC4X3.IfcPreDefinedCurveFont(a[0]),
  3967405729: (a) => new IFC4X3.IfcPreDefinedPropertySet(a[0], a[1], a[2], a[3]),
  569719735: (a) => new IFC4X3.IfcProcedureType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2945172077: (a) => new IFC4X3.IfcProcess(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  4208778838: (a) => new IFC4X3.IfcProduct(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  103090709: (a) => new IFC4X3.IfcProject(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  653396225: (a) => new IFC4X3.IfcProjectLibrary(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  871118103: (a) => new IFC4X3.IfcPropertyBoundedValue(a[0], a[1], a[2], a[3], a[4], a[5]),
  4166981789: (a) => new IFC4X3.IfcPropertyEnumeratedValue(a[0], a[1], a[2], a[3]),
  2752243245: (a) => new IFC4X3.IfcPropertyListValue(a[0], a[1], a[2], a[3]),
  941946838: (a) => new IFC4X3.IfcPropertyReferenceValue(a[0], a[1], a[2], a[3]),
  1451395588: (a) => new IFC4X3.IfcPropertySet(a[0], a[1], a[2], a[3], a[4]),
  492091185: (a) => new IFC4X3.IfcPropertySetTemplate(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3650150729: (a) => new IFC4X3.IfcPropertySingleValue(a[0], a[1], a[2], a[3]),
  110355661: (a) => new IFC4X3.IfcPropertyTableValue(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3521284610: (a) => new IFC4X3.IfcPropertyTemplate(a[0], a[1], a[2], a[3]),
  2770003689: (a) => new IFC4X3.IfcRectangleHollowProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2798486643: (a) => new IFC4X3.IfcRectangularPyramid(a[0], a[1], a[2], a[3]),
  3454111270: (a) => new IFC4X3.IfcRectangularTrimmedSurface(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3765753017: (a) => new IFC4X3.IfcReinforcementDefinitionProperties(a[0], a[1], a[2], a[3], a[4], a[5]),
  3939117080: (a) => new IFC4X3.IfcRelAssigns(a[0], a[1], a[2], a[3], a[4], a[5]),
  1683148259: (a) => new IFC4X3.IfcRelAssignsToActor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2495723537: (a) => new IFC4X3.IfcRelAssignsToControl(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1307041759: (a) => new IFC4X3.IfcRelAssignsToGroup(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1027710054: (a) => new IFC4X3.IfcRelAssignsToGroupByFactor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  4278684876: (a) => new IFC4X3.IfcRelAssignsToProcess(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2857406711: (a) => new IFC4X3.IfcRelAssignsToProduct(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  205026976: (a) => new IFC4X3.IfcRelAssignsToResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1865459582: (a) => new IFC4X3.IfcRelAssociates(a[0], a[1], a[2], a[3], a[4]),
  4095574036: (a) => new IFC4X3.IfcRelAssociatesApproval(a[0], a[1], a[2], a[3], a[4], a[5]),
  919958153: (a) => new IFC4X3.IfcRelAssociatesClassification(a[0], a[1], a[2], a[3], a[4], a[5]),
  2728634034: (a) => new IFC4X3.IfcRelAssociatesConstraint(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  982818633: (a) => new IFC4X3.IfcRelAssociatesDocument(a[0], a[1], a[2], a[3], a[4], a[5]),
  3840914261: (a) => new IFC4X3.IfcRelAssociatesLibrary(a[0], a[1], a[2], a[3], a[4], a[5]),
  2655215786: (a) => new IFC4X3.IfcRelAssociatesMaterial(a[0], a[1], a[2], a[3], a[4], a[5]),
  1033248425: (a) => new IFC4X3.IfcRelAssociatesProfileDef(a[0], a[1], a[2], a[3], a[4], a[5]),
  826625072: (a) => new IFC4X3.IfcRelConnects(a[0], a[1], a[2], a[3]),
  1204542856: (a) => new IFC4X3.IfcRelConnectsElements(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3945020480: (a) => new IFC4X3.IfcRelConnectsPathElements(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  4201705270: (a) => new IFC4X3.IfcRelConnectsPortToElement(a[0], a[1], a[2], a[3], a[4], a[5]),
  3190031847: (a) => new IFC4X3.IfcRelConnectsPorts(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  2127690289: (a) => new IFC4X3.IfcRelConnectsStructuralActivity(a[0], a[1], a[2], a[3], a[4], a[5]),
  1638771189: (a) => new IFC4X3.IfcRelConnectsStructuralMember(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  504942748: (a) => new IFC4X3.IfcRelConnectsWithEccentricity(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  3678494232: (a) => new IFC4X3.IfcRelConnectsWithRealizingElements(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3242617779: (a) => new IFC4X3.IfcRelContainedInSpatialStructure(a[0], a[1], a[2], a[3], a[4], a[5]),
  886880790: (a) => new IFC4X3.IfcRelCoversBldgElements(a[0], a[1], a[2], a[3], a[4], a[5]),
  2802773753: (a) => new IFC4X3.IfcRelCoversSpaces(a[0], a[1], a[2], a[3], a[4], a[5]),
  2565941209: (a) => new IFC4X3.IfcRelDeclares(a[0], a[1], a[2], a[3], a[4], a[5]),
  2551354335: (a) => new IFC4X3.IfcRelDecomposes(a[0], a[1], a[2], a[3]),
  693640335: (a) => new IFC4X3.IfcRelDefines(a[0], a[1], a[2], a[3]),
  1462361463: (a) => new IFC4X3.IfcRelDefinesByObject(a[0], a[1], a[2], a[3], a[4], a[5]),
  4186316022: (a) => new IFC4X3.IfcRelDefinesByProperties(a[0], a[1], a[2], a[3], a[4], a[5]),
  307848117: (a) => new IFC4X3.IfcRelDefinesByTemplate(a[0], a[1], a[2], a[3], a[4], a[5]),
  781010003: (a) => new IFC4X3.IfcRelDefinesByType(a[0], a[1], a[2], a[3], a[4], a[5]),
  3940055652: (a) => new IFC4X3.IfcRelFillsElement(a[0], a[1], a[2], a[3], a[4], a[5]),
  279856033: (a) => new IFC4X3.IfcRelFlowControlElements(a[0], a[1], a[2], a[3], a[4], a[5]),
  427948657: (a) => new IFC4X3.IfcRelInterferesElements(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3268803585: (a) => new IFC4X3.IfcRelNests(a[0], a[1], a[2], a[3], a[4], a[5]),
  1441486842: (a) => new IFC4X3.IfcRelPositions(a[0], a[1], a[2], a[3], a[4], a[5]),
  750771296: (a) => new IFC4X3.IfcRelProjectsElement(a[0], a[1], a[2], a[3], a[4], a[5]),
  1245217292: (a) => new IFC4X3.IfcRelReferencedInSpatialStructure(a[0], a[1], a[2], a[3], a[4], a[5]),
  4122056220: (a) => new IFC4X3.IfcRelSequence(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  366585022: (a) => new IFC4X3.IfcRelServicesBuildings(a[0], a[1], a[2], a[3], a[4], a[5]),
  3451746338: (a) => new IFC4X3.IfcRelSpaceBoundary(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3523091289: (a) => new IFC4X3.IfcRelSpaceBoundary1stLevel(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1521410863: (a) => new IFC4X3.IfcRelSpaceBoundary2ndLevel(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  1401173127: (a) => new IFC4X3.IfcRelVoidsElement(a[0], a[1], a[2], a[3], a[4], a[5]),
  816062949: (a) => new IFC4X3.IfcReparametrisedCompositeCurveSegment(a[0], a[1], a[2], a[3]),
  2914609552: (a) => new IFC4X3.IfcResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1856042241: (a) => new IFC4X3.IfcRevolvedAreaSolid(a[0], a[1], a[2], a[3]),
  3243963512: (a) => new IFC4X3.IfcRevolvedAreaSolidTapered(a[0], a[1], a[2], a[3], a[4]),
  4158566097: (a) => new IFC4X3.IfcRightCircularCone(a[0], a[1], a[2]),
  3626867408: (a) => new IFC4X3.IfcRightCircularCylinder(a[0], a[1], a[2]),
  1862484736: (a) => new IFC4X3.IfcSectionedSolid(a[0], a[1]),
  1290935644: (a) => new IFC4X3.IfcSectionedSolidHorizontal(a[0], a[1], a[2]),
  1356537516: (a) => new IFC4X3.IfcSectionedSurface(a[0], a[1], a[2]),
  3663146110: (a) => new IFC4X3.IfcSimplePropertyTemplate(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1412071761: (a) => new IFC4X3.IfcSpatialElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  710998568: (a) => new IFC4X3.IfcSpatialElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2706606064: (a) => new IFC4X3.IfcSpatialStructureElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3893378262: (a) => new IFC4X3.IfcSpatialStructureElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  463610769: (a) => new IFC4X3.IfcSpatialZone(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2481509218: (a) => new IFC4X3.IfcSpatialZoneType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  451544542: (a) => new IFC4X3.IfcSphere(a[0], a[1]),
  4015995234: (a) => new IFC4X3.IfcSphericalSurface(a[0], a[1]),
  2735484536: (a) => new IFC4X3.IfcSpiral(a[0]),
  3544373492: (a) => new IFC4X3.IfcStructuralActivity(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3136571912: (a) => new IFC4X3.IfcStructuralItem(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  530289379: (a) => new IFC4X3.IfcStructuralMember(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3689010777: (a) => new IFC4X3.IfcStructuralReaction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3979015343: (a) => new IFC4X3.IfcStructuralSurfaceMember(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2218152070: (a) => new IFC4X3.IfcStructuralSurfaceMemberVarying(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  603775116: (a) => new IFC4X3.IfcStructuralSurfaceReaction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4095615324: (a) => new IFC4X3.IfcSubContractResourceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  699246055: (a) => new IFC4X3.IfcSurfaceCurve(a[0], a[1], a[2]),
  2028607225: (a) => new IFC4X3.IfcSurfaceCurveSweptAreaSolid(a[0], a[1], a[2], a[3], a[4], a[5]),
  2809605785: (a) => new IFC4X3.IfcSurfaceOfLinearExtrusion(a[0], a[1], a[2], a[3]),
  4124788165: (a) => new IFC4X3.IfcSurfaceOfRevolution(a[0], a[1], a[2]),
  1580310250: (a) => new IFC4X3.IfcSystemFurnitureElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3473067441: (a) => new IFC4X3.IfcTask(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  3206491090: (a) => new IFC4X3.IfcTaskType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  2387106220: (a) => new IFC4X3.IfcTessellatedFaceSet(a[0], a[1]),
  782932809: (a) => new IFC4X3.IfcThirdOrderPolynomialSpiral(a[0], a[1], a[2], a[3], a[4]),
  1935646853: (a) => new IFC4X3.IfcToroidalSurface(a[0], a[1], a[2]),
  3665877780: (a) => new IFC4X3.IfcTransportationDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2916149573: (a) => new IFC4X3.IfcTriangulatedFaceSet(a[0], a[1], a[2], a[3], a[4]),
  1229763772: (a) => new IFC4X3.IfcTriangulatedIrregularNetwork(a[0], a[1], a[2], a[3], a[4], a[5]),
  3651464721: (a) => new IFC4X3.IfcVehicleType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  336235671: (a) => new IFC4X3.IfcWindowLiningProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]),
  512836454: (a) => new IFC4X3.IfcWindowPanelProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2296667514: (a) => new IFC4X3.IfcActor(a[0], a[1], a[2], a[3], a[4], a[5]),
  1635779807: (a) => new IFC4X3.IfcAdvancedBrep(a[0]),
  2603310189: (a) => new IFC4X3.IfcAdvancedBrepWithVoids(a[0], a[1]),
  1674181508: (a) => new IFC4X3.IfcAnnotation(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2887950389: (a) => new IFC4X3.IfcBSplineSurface(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  167062518: (a) => new IFC4X3.IfcBSplineSurfaceWithKnots(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1334484129: (a) => new IFC4X3.IfcBlock(a[0], a[1], a[2], a[3]),
  3649129432: (a) => new IFC4X3.IfcBooleanClippingResult(a[0], a[1], a[2]),
  1260505505: (_) => new IFC4X3.IfcBoundedCurve(),
  3124254112: (a) => new IFC4X3.IfcBuildingStorey(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1626504194: (a) => new IFC4X3.IfcBuiltElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2197970202: (a) => new IFC4X3.IfcChimneyType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2937912522: (a) => new IFC4X3.IfcCircleHollowProfileDef(a[0], a[1], a[2], a[3], a[4]),
  3893394355: (a) => new IFC4X3.IfcCivilElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3497074424: (a) => new IFC4X3.IfcClothoid(a[0], a[1]),
  300633059: (a) => new IFC4X3.IfcColumnType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3875453745: (a) => new IFC4X3.IfcComplexPropertyTemplate(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3732776249: (a) => new IFC4X3.IfcCompositeCurve(a[0], a[1]),
  15328376: (a) => new IFC4X3.IfcCompositeCurveOnSurface(a[0], a[1]),
  2510884976: (a) => new IFC4X3.IfcConic(a[0]),
  2185764099: (a) => new IFC4X3.IfcConstructionEquipmentResourceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  4105962743: (a) => new IFC4X3.IfcConstructionMaterialResourceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1525564444: (a) => new IFC4X3.IfcConstructionProductResourceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  2559216714: (a) => new IFC4X3.IfcConstructionResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3293443760: (a) => new IFC4X3.IfcControl(a[0], a[1], a[2], a[3], a[4], a[5]),
  2000195564: (a) => new IFC4X3.IfcCosineSpiral(a[0], a[1], a[2]),
  3895139033: (a) => new IFC4X3.IfcCostItem(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1419761937: (a) => new IFC4X3.IfcCostSchedule(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4189326743: (a) => new IFC4X3.IfcCourseType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1916426348: (a) => new IFC4X3.IfcCoveringType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3295246426: (a) => new IFC4X3.IfcCrewResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  1457835157: (a) => new IFC4X3.IfcCurtainWallType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1213902940: (a) => new IFC4X3.IfcCylindricalSurface(a[0], a[1]),
  1306400036: (a) => new IFC4X3.IfcDeepFoundationType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4234616927: (a) => new IFC4X3.IfcDirectrixDerivedReferenceSweptAreaSolid(a[0], a[1], a[2], a[3], a[4], a[5]),
  3256556792: (a) => new IFC4X3.IfcDistributionElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3849074793: (a) => new IFC4X3.IfcDistributionFlowElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2963535650: (a) => new IFC4X3.IfcDoorLiningProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16]),
  1714330368: (a) => new IFC4X3.IfcDoorPanelProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2323601079: (a) => new IFC4X3.IfcDoorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  445594917: (a) => new IFC4X3.IfcDraughtingPreDefinedColour(a[0]),
  4006246654: (a) => new IFC4X3.IfcDraughtingPreDefinedCurveFont(a[0]),
  1758889154: (a) => new IFC4X3.IfcElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  4123344466: (a) => new IFC4X3.IfcElementAssembly(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2397081782: (a) => new IFC4X3.IfcElementAssemblyType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1623761950: (a) => new IFC4X3.IfcElementComponent(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2590856083: (a) => new IFC4X3.IfcElementComponentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1704287377: (a) => new IFC4X3.IfcEllipse(a[0], a[1], a[2]),
  2107101300: (a) => new IFC4X3.IfcEnergyConversionDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  132023988: (a) => new IFC4X3.IfcEngineType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3174744832: (a) => new IFC4X3.IfcEvaporativeCoolerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3390157468: (a) => new IFC4X3.IfcEvaporatorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4148101412: (a) => new IFC4X3.IfcEvent(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  2853485674: (a) => new IFC4X3.IfcExternalSpatialStructureElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  807026263: (a) => new IFC4X3.IfcFacetedBrep(a[0]),
  3737207727: (a) => new IFC4X3.IfcFacetedBrepWithVoids(a[0], a[1]),
  24185140: (a) => new IFC4X3.IfcFacility(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1310830890: (a) => new IFC4X3.IfcFacilityPart(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4228831410: (a) => new IFC4X3.IfcFacilityPartCommon(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  647756555: (a) => new IFC4X3.IfcFastener(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2489546625: (a) => new IFC4X3.IfcFastenerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2827207264: (a) => new IFC4X3.IfcFeatureElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2143335405: (a) => new IFC4X3.IfcFeatureElementAddition(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1287392070: (a) => new IFC4X3.IfcFeatureElementSubtraction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3907093117: (a) => new IFC4X3.IfcFlowControllerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3198132628: (a) => new IFC4X3.IfcFlowFittingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3815607619: (a) => new IFC4X3.IfcFlowMeterType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1482959167: (a) => new IFC4X3.IfcFlowMovingDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1834744321: (a) => new IFC4X3.IfcFlowSegmentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1339347760: (a) => new IFC4X3.IfcFlowStorageDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2297155007: (a) => new IFC4X3.IfcFlowTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3009222698: (a) => new IFC4X3.IfcFlowTreatmentDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1893162501: (a) => new IFC4X3.IfcFootingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  263784265: (a) => new IFC4X3.IfcFurnishingElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1509553395: (a) => new IFC4X3.IfcFurniture(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3493046030: (a) => new IFC4X3.IfcGeographicElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4230923436: (a) => new IFC4X3.IfcGeotechnicalElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1594536857: (a) => new IFC4X3.IfcGeotechnicalStratum(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2898700619: (a) => new IFC4X3.IfcGradientCurve(a[0], a[1], a[2], a[3]),
  2706460486: (a) => new IFC4X3.IfcGroup(a[0], a[1], a[2], a[3], a[4]),
  1251058090: (a) => new IFC4X3.IfcHeatExchangerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1806887404: (a) => new IFC4X3.IfcHumidifierType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2568555532: (a) => new IFC4X3.IfcImpactProtectionDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3948183225: (a) => new IFC4X3.IfcImpactProtectionDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2571569899: (a) => new IFC4X3.IfcIndexedPolyCurve(a[0], a[1], a[2]),
  3946677679: (a) => new IFC4X3.IfcInterceptorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3113134337: (a) => new IFC4X3.IfcIntersectionCurve(a[0], a[1], a[2]),
  2391368822: (a) => new IFC4X3.IfcInventory(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  4288270099: (a) => new IFC4X3.IfcJunctionBoxType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  679976338: (a) => new IFC4X3.IfcKerbType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3827777499: (a) => new IFC4X3.IfcLaborResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  1051575348: (a) => new IFC4X3.IfcLampType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1161773419: (a) => new IFC4X3.IfcLightFixtureType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2176059722: (a) => new IFC4X3.IfcLinearElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1770583370: (a) => new IFC4X3.IfcLiquidTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  525669439: (a) => new IFC4X3.IfcMarineFacility(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  976884017: (a) => new IFC4X3.IfcMarinePart(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  377706215: (a) => new IFC4X3.IfcMechanicalFastener(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  2108223431: (a) => new IFC4X3.IfcMechanicalFastenerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1114901282: (a) => new IFC4X3.IfcMedicalDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3181161470: (a) => new IFC4X3.IfcMemberType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1950438474: (a) => new IFC4X3.IfcMobileTelecommunicationsApplianceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  710110818: (a) => new IFC4X3.IfcMooringDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  977012517: (a) => new IFC4X3.IfcMotorConnectionType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  506776471: (a) => new IFC4X3.IfcNavigationElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4143007308: (a) => new IFC4X3.IfcOccupant(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3588315303: (a) => new IFC4X3.IfcOpeningElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2837617999: (a) => new IFC4X3.IfcOutletType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  514975943: (a) => new IFC4X3.IfcPavementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2382730787: (a) => new IFC4X3.IfcPerformanceHistory(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3566463478: (a) => new IFC4X3.IfcPermeableCoveringProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3327091369: (a) => new IFC4X3.IfcPermit(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1158309216: (a) => new IFC4X3.IfcPileType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  804291784: (a) => new IFC4X3.IfcPipeFittingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4231323485: (a) => new IFC4X3.IfcPipeSegmentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4017108033: (a) => new IFC4X3.IfcPlateType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2839578677: (a) => new IFC4X3.IfcPolygonalFaceSet(a[0], a[1], a[2], a[3]),
  3724593414: (a) => new IFC4X3.IfcPolyline(a[0]),
  3740093272: (a) => new IFC4X3.IfcPort(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1946335990: (a) => new IFC4X3.IfcPositioningElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  2744685151: (a) => new IFC4X3.IfcProcedure(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2904328755: (a) => new IFC4X3.IfcProjectOrder(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3651124850: (a) => new IFC4X3.IfcProjectionElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1842657554: (a) => new IFC4X3.IfcProtectiveDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2250791053: (a) => new IFC4X3.IfcPumpType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1763565496: (a) => new IFC4X3.IfcRailType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2893384427: (a) => new IFC4X3.IfcRailingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3992365140: (a) => new IFC4X3.IfcRailway(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1891881377: (a) => new IFC4X3.IfcRailwayPart(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  2324767716: (a) => new IFC4X3.IfcRampFlightType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1469900589: (a) => new IFC4X3.IfcRampType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  683857671: (a) => new IFC4X3.IfcRationalBSplineSurfaceWithKnots(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  4021432810: (a) => new IFC4X3.IfcReferent(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3027567501: (a) => new IFC4X3.IfcReinforcingElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  964333572: (a) => new IFC4X3.IfcReinforcingElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2320036040: (a) => new IFC4X3.IfcReinforcingMesh(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17]),
  2310774935: (a) => new IFC4X3.IfcReinforcingMeshType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18], a[19]),
  3818125796: (a) => new IFC4X3.IfcRelAdheresToElement(a[0], a[1], a[2], a[3], a[4], a[5]),
  160246688: (a) => new IFC4X3.IfcRelAggregates(a[0], a[1], a[2], a[3], a[4], a[5]),
  146592293: (a) => new IFC4X3.IfcRoad(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  550521510: (a) => new IFC4X3.IfcRoadPart(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  2781568857: (a) => new IFC4X3.IfcRoofType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1768891740: (a) => new IFC4X3.IfcSanitaryTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2157484638: (a) => new IFC4X3.IfcSeamCurve(a[0], a[1], a[2]),
  3649235739: (a) => new IFC4X3.IfcSecondOrderPolynomialSpiral(a[0], a[1], a[2], a[3]),
  544395925: (a) => new IFC4X3.IfcSegmentedReferenceCurve(a[0], a[1], a[2], a[3]),
  1027922057: (a) => new IFC4X3.IfcSeventhOrderPolynomialSpiral(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4074543187: (a) => new IFC4X3.IfcShadingDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  33720170: (a) => new IFC4X3.IfcSign(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3599934289: (a) => new IFC4X3.IfcSignType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1894708472: (a) => new IFC4X3.IfcSignalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  42703149: (a) => new IFC4X3.IfcSineSpiral(a[0], a[1], a[2], a[3]),
  4097777520: (a) => new IFC4X3.IfcSite(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
  2533589738: (a) => new IFC4X3.IfcSlabType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1072016465: (a) => new IFC4X3.IfcSolarDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3856911033: (a) => new IFC4X3.IfcSpace(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  1305183839: (a) => new IFC4X3.IfcSpaceHeaterType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3812236995: (a) => new IFC4X3.IfcSpaceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  3112655638: (a) => new IFC4X3.IfcStackTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1039846685: (a) => new IFC4X3.IfcStairFlightType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  338393293: (a) => new IFC4X3.IfcStairType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  682877961: (a) => new IFC4X3.IfcStructuralAction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1179482911: (a) => new IFC4X3.IfcStructuralConnection(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1004757350: (a) => new IFC4X3.IfcStructuralCurveAction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  4243806635: (a) => new IFC4X3.IfcStructuralCurveConnection(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  214636428: (a) => new IFC4X3.IfcStructuralCurveMember(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2445595289: (a) => new IFC4X3.IfcStructuralCurveMemberVarying(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2757150158: (a) => new IFC4X3.IfcStructuralCurveReaction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1807405624: (a) => new IFC4X3.IfcStructuralLinearAction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1252848954: (a) => new IFC4X3.IfcStructuralLoadGroup(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2082059205: (a) => new IFC4X3.IfcStructuralPointAction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  734778138: (a) => new IFC4X3.IfcStructuralPointConnection(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1235345126: (a) => new IFC4X3.IfcStructuralPointReaction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2986769608: (a) => new IFC4X3.IfcStructuralResultGroup(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3657597509: (a) => new IFC4X3.IfcStructuralSurfaceAction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1975003073: (a) => new IFC4X3.IfcStructuralSurfaceConnection(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  148013059: (a) => new IFC4X3.IfcSubContractResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  3101698114: (a) => new IFC4X3.IfcSurfaceFeature(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2315554128: (a) => new IFC4X3.IfcSwitchingDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2254336722: (a) => new IFC4X3.IfcSystem(a[0], a[1], a[2], a[3], a[4]),
  413509423: (a) => new IFC4X3.IfcSystemFurnitureElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  5716631: (a) => new IFC4X3.IfcTankType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3824725483: (a) => new IFC4X3.IfcTendon(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16]),
  2347447852: (a) => new IFC4X3.IfcTendonAnchor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3081323446: (a) => new IFC4X3.IfcTendonAnchorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3663046924: (a) => new IFC4X3.IfcTendonConduit(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2281632017: (a) => new IFC4X3.IfcTendonConduitType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2415094496: (a) => new IFC4X3.IfcTendonType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  618700268: (a) => new IFC4X3.IfcTrackElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1692211062: (a) => new IFC4X3.IfcTransformerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2097647324: (a) => new IFC4X3.IfcTransportElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1953115116: (a) => new IFC4X3.IfcTransportationDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3593883385: (a) => new IFC4X3.IfcTrimmedCurve(a[0], a[1], a[2], a[3], a[4]),
  1600972822: (a) => new IFC4X3.IfcTubeBundleType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1911125066: (a) => new IFC4X3.IfcUnitaryEquipmentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  728799441: (a) => new IFC4X3.IfcValveType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  840318589: (a) => new IFC4X3.IfcVehicle(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1530820697: (a) => new IFC4X3.IfcVibrationDamper(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3956297820: (a) => new IFC4X3.IfcVibrationDamperType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2391383451: (a) => new IFC4X3.IfcVibrationIsolator(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3313531582: (a) => new IFC4X3.IfcVibrationIsolatorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2769231204: (a) => new IFC4X3.IfcVirtualElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  926996030: (a) => new IFC4X3.IfcVoidingFeature(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1898987631: (a) => new IFC4X3.IfcWallType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1133259667: (a) => new IFC4X3.IfcWasteTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4009809668: (a) => new IFC4X3.IfcWindowType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  4088093105: (a) => new IFC4X3.IfcWorkCalendar(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1028945134: (a) => new IFC4X3.IfcWorkControl(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  4218914973: (a) => new IFC4X3.IfcWorkPlan(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
  3342526732: (a) => new IFC4X3.IfcWorkSchedule(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
  1033361043: (a) => new IFC4X3.IfcZone(a[0], a[1], a[2], a[3], a[4], a[5]),
  3821786052: (a) => new IFC4X3.IfcActionRequest(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1411407467: (a) => new IFC4X3.IfcAirTerminalBoxType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3352864051: (a) => new IFC4X3.IfcAirTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1871374353: (a) => new IFC4X3.IfcAirToAirHeatRecoveryType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4266260250: (a) => new IFC4X3.IfcAlignmentCant(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1545765605: (a) => new IFC4X3.IfcAlignmentHorizontal(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  317615605: (a) => new IFC4X3.IfcAlignmentSegment(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1662888072: (a) => new IFC4X3.IfcAlignmentVertical(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3460190687: (a) => new IFC4X3.IfcAsset(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
  1532957894: (a) => new IFC4X3.IfcAudioVisualApplianceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1967976161: (a) => new IFC4X3.IfcBSplineCurve(a[0], a[1], a[2], a[3], a[4]),
  2461110595: (a) => new IFC4X3.IfcBSplineCurveWithKnots(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  819618141: (a) => new IFC4X3.IfcBeamType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3649138523: (a) => new IFC4X3.IfcBearingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  231477066: (a) => new IFC4X3.IfcBoilerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1136057603: (a) => new IFC4X3.IfcBoundaryCurve(a[0], a[1]),
  644574406: (a) => new IFC4X3.IfcBridge(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  963979645: (a) => new IFC4X3.IfcBridgePart(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  4031249490: (a) => new IFC4X3.IfcBuilding(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  2979338954: (a) => new IFC4X3.IfcBuildingElementPart(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  39481116: (a) => new IFC4X3.IfcBuildingElementPartType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1909888760: (a) => new IFC4X3.IfcBuildingElementProxyType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1177604601: (a) => new IFC4X3.IfcBuildingSystem(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1876633798: (a) => new IFC4X3.IfcBuiltElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3862327254: (a) => new IFC4X3.IfcBuiltSystem(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  2188180465: (a) => new IFC4X3.IfcBurnerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  395041908: (a) => new IFC4X3.IfcCableCarrierFittingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3293546465: (a) => new IFC4X3.IfcCableCarrierSegmentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2674252688: (a) => new IFC4X3.IfcCableFittingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1285652485: (a) => new IFC4X3.IfcCableSegmentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3203706013: (a) => new IFC4X3.IfcCaissonFoundationType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2951183804: (a) => new IFC4X3.IfcChillerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3296154744: (a) => new IFC4X3.IfcChimney(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2611217952: (a) => new IFC4X3.IfcCircle(a[0], a[1]),
  1677625105: (a) => new IFC4X3.IfcCivilElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2301859152: (a) => new IFC4X3.IfcCoilType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  843113511: (a) => new IFC4X3.IfcColumn(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  400855858: (a) => new IFC4X3.IfcCommunicationsApplianceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3850581409: (a) => new IFC4X3.IfcCompressorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2816379211: (a) => new IFC4X3.IfcCondenserType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3898045240: (a) => new IFC4X3.IfcConstructionEquipmentResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  1060000209: (a) => new IFC4X3.IfcConstructionMaterialResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  488727124: (a) => new IFC4X3.IfcConstructionProductResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  2940368186: (a) => new IFC4X3.IfcConveyorSegmentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  335055490: (a) => new IFC4X3.IfcCooledBeamType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2954562838: (a) => new IFC4X3.IfcCoolingTowerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1502416096: (a) => new IFC4X3.IfcCourse(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1973544240: (a) => new IFC4X3.IfcCovering(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3495092785: (a) => new IFC4X3.IfcCurtainWall(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3961806047: (a) => new IFC4X3.IfcDamperType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3426335179: (a) => new IFC4X3.IfcDeepFoundation(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1335981549: (a) => new IFC4X3.IfcDiscreteAccessory(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2635815018: (a) => new IFC4X3.IfcDiscreteAccessoryType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  479945903: (a) => new IFC4X3.IfcDistributionBoardType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1599208980: (a) => new IFC4X3.IfcDistributionChamberElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2063403501: (a) => new IFC4X3.IfcDistributionControlElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1945004755: (a) => new IFC4X3.IfcDistributionElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3040386961: (a) => new IFC4X3.IfcDistributionFlowElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3041715199: (a) => new IFC4X3.IfcDistributionPort(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3205830791: (a) => new IFC4X3.IfcDistributionSystem(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  395920057: (a) => new IFC4X3.IfcDoor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  869906466: (a) => new IFC4X3.IfcDuctFittingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3760055223: (a) => new IFC4X3.IfcDuctSegmentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2030761528: (a) => new IFC4X3.IfcDuctSilencerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3071239417: (a) => new IFC4X3.IfcEarthworksCut(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1077100507: (a) => new IFC4X3.IfcEarthworksElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3376911765: (a) => new IFC4X3.IfcEarthworksFill(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  663422040: (a) => new IFC4X3.IfcElectricApplianceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2417008758: (a) => new IFC4X3.IfcElectricDistributionBoardType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3277789161: (a) => new IFC4X3.IfcElectricFlowStorageDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2142170206: (a) => new IFC4X3.IfcElectricFlowTreatmentDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1534661035: (a) => new IFC4X3.IfcElectricGeneratorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1217240411: (a) => new IFC4X3.IfcElectricMotorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  712377611: (a) => new IFC4X3.IfcElectricTimeControlType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1658829314: (a) => new IFC4X3.IfcEnergyConversionDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2814081492: (a) => new IFC4X3.IfcEngine(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3747195512: (a) => new IFC4X3.IfcEvaporativeCooler(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  484807127: (a) => new IFC4X3.IfcEvaporator(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1209101575: (a) => new IFC4X3.IfcExternalSpatialElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  346874300: (a) => new IFC4X3.IfcFanType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1810631287: (a) => new IFC4X3.IfcFilterType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4222183408: (a) => new IFC4X3.IfcFireSuppressionTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2058353004: (a) => new IFC4X3.IfcFlowController(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  4278956645: (a) => new IFC4X3.IfcFlowFitting(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  4037862832: (a) => new IFC4X3.IfcFlowInstrumentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2188021234: (a) => new IFC4X3.IfcFlowMeter(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3132237377: (a) => new IFC4X3.IfcFlowMovingDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  987401354: (a) => new IFC4X3.IfcFlowSegment(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  707683696: (a) => new IFC4X3.IfcFlowStorageDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2223149337: (a) => new IFC4X3.IfcFlowTerminal(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3508470533: (a) => new IFC4X3.IfcFlowTreatmentDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  900683007: (a) => new IFC4X3.IfcFooting(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2713699986: (a) => new IFC4X3.IfcGeotechnicalAssembly(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3009204131: (a) => new IFC4X3.IfcGrid(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  3319311131: (a) => new IFC4X3.IfcHeatExchanger(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2068733104: (a) => new IFC4X3.IfcHumidifier(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4175244083: (a) => new IFC4X3.IfcInterceptor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2176052936: (a) => new IFC4X3.IfcJunctionBox(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2696325953: (a) => new IFC4X3.IfcKerb(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  76236018: (a) => new IFC4X3.IfcLamp(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  629592764: (a) => new IFC4X3.IfcLightFixture(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1154579445: (a) => new IFC4X3.IfcLinearPositioningElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1638804497: (a) => new IFC4X3.IfcLiquidTerminal(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1437502449: (a) => new IFC4X3.IfcMedicalDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1073191201: (a) => new IFC4X3.IfcMember(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2078563270: (a) => new IFC4X3.IfcMobileTelecommunicationsAppliance(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  234836483: (a) => new IFC4X3.IfcMooringDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2474470126: (a) => new IFC4X3.IfcMotorConnection(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2182337498: (a) => new IFC4X3.IfcNavigationElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  144952367: (a) => new IFC4X3.IfcOuterBoundaryCurve(a[0], a[1]),
  3694346114: (a) => new IFC4X3.IfcOutlet(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1383356374: (a) => new IFC4X3.IfcPavement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1687234759: (a) => new IFC4X3.IfcPile(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  310824031: (a) => new IFC4X3.IfcPipeFitting(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3612865200: (a) => new IFC4X3.IfcPipeSegment(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3171933400: (a) => new IFC4X3.IfcPlate(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  738039164: (a) => new IFC4X3.IfcProtectiveDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  655969474: (a) => new IFC4X3.IfcProtectiveDeviceTrippingUnitType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  90941305: (a) => new IFC4X3.IfcPump(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3290496277: (a) => new IFC4X3.IfcRail(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2262370178: (a) => new IFC4X3.IfcRailing(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3024970846: (a) => new IFC4X3.IfcRamp(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3283111854: (a) => new IFC4X3.IfcRampFlight(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1232101972: (a) => new IFC4X3.IfcRationalBSplineCurveWithKnots(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3798194928: (a) => new IFC4X3.IfcReinforcedSoil(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  979691226: (a) => new IFC4X3.IfcReinforcingBar(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
  2572171363: (a) => new IFC4X3.IfcReinforcingBarType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]),
  2016517767: (a) => new IFC4X3.IfcRoof(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3053780830: (a) => new IFC4X3.IfcSanitaryTerminal(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1783015770: (a) => new IFC4X3.IfcSensorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1329646415: (a) => new IFC4X3.IfcShadingDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  991950508: (a) => new IFC4X3.IfcSignal(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1529196076: (a) => new IFC4X3.IfcSlab(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3420628829: (a) => new IFC4X3.IfcSolarDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1999602285: (a) => new IFC4X3.IfcSpaceHeater(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1404847402: (a) => new IFC4X3.IfcStackTerminal(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  331165859: (a) => new IFC4X3.IfcStair(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4252922144: (a) => new IFC4X3.IfcStairFlight(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  2515109513: (a) => new IFC4X3.IfcStructuralAnalysisModel(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  385403989: (a) => new IFC4X3.IfcStructuralLoadCase(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  1621171031: (a) => new IFC4X3.IfcStructuralPlanarAction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1162798199: (a) => new IFC4X3.IfcSwitchingDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  812556717: (a) => new IFC4X3.IfcTank(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3425753595: (a) => new IFC4X3.IfcTrackElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3825984169: (a) => new IFC4X3.IfcTransformer(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1620046519: (a) => new IFC4X3.IfcTransportElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3026737570: (a) => new IFC4X3.IfcTubeBundle(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3179687236: (a) => new IFC4X3.IfcUnitaryControlElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4292641817: (a) => new IFC4X3.IfcUnitaryEquipment(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4207607924: (a) => new IFC4X3.IfcValve(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2391406946: (a) => new IFC4X3.IfcWall(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3512223829: (a) => new IFC4X3.IfcWallStandardCase(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4237592921: (a) => new IFC4X3.IfcWasteTerminal(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3304561284: (a) => new IFC4X3.IfcWindow(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  2874132201: (a) => new IFC4X3.IfcActuatorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1634111441: (a) => new IFC4X3.IfcAirTerminal(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  177149247: (a) => new IFC4X3.IfcAirTerminalBox(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2056796094: (a) => new IFC4X3.IfcAirToAirHeatRecovery(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3001207471: (a) => new IFC4X3.IfcAlarmType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  325726236: (a) => new IFC4X3.IfcAlignment(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  277319702: (a) => new IFC4X3.IfcAudioVisualAppliance(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  753842376: (a) => new IFC4X3.IfcBeam(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4196446775: (a) => new IFC4X3.IfcBearing(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  32344328: (a) => new IFC4X3.IfcBoiler(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3314249567: (a) => new IFC4X3.IfcBorehole(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1095909175: (a) => new IFC4X3.IfcBuildingElementProxy(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2938176219: (a) => new IFC4X3.IfcBurner(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  635142910: (a) => new IFC4X3.IfcCableCarrierFitting(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3758799889: (a) => new IFC4X3.IfcCableCarrierSegment(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1051757585: (a) => new IFC4X3.IfcCableFitting(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4217484030: (a) => new IFC4X3.IfcCableSegment(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3999819293: (a) => new IFC4X3.IfcCaissonFoundation(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3902619387: (a) => new IFC4X3.IfcChiller(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  639361253: (a) => new IFC4X3.IfcCoil(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3221913625: (a) => new IFC4X3.IfcCommunicationsAppliance(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3571504051: (a) => new IFC4X3.IfcCompressor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2272882330: (a) => new IFC4X3.IfcCondenser(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  578613899: (a) => new IFC4X3.IfcControllerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3460952963: (a) => new IFC4X3.IfcConveyorSegment(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4136498852: (a) => new IFC4X3.IfcCooledBeam(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3640358203: (a) => new IFC4X3.IfcCoolingTower(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4074379575: (a) => new IFC4X3.IfcDamper(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3693000487: (a) => new IFC4X3.IfcDistributionBoard(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1052013943: (a) => new IFC4X3.IfcDistributionChamberElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  562808652: (a) => new IFC4X3.IfcDistributionCircuit(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1062813311: (a) => new IFC4X3.IfcDistributionControlElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  342316401: (a) => new IFC4X3.IfcDuctFitting(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3518393246: (a) => new IFC4X3.IfcDuctSegment(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1360408905: (a) => new IFC4X3.IfcDuctSilencer(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1904799276: (a) => new IFC4X3.IfcElectricAppliance(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  862014818: (a) => new IFC4X3.IfcElectricDistributionBoard(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3310460725: (a) => new IFC4X3.IfcElectricFlowStorageDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  24726584: (a) => new IFC4X3.IfcElectricFlowTreatmentDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  264262732: (a) => new IFC4X3.IfcElectricGenerator(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  402227799: (a) => new IFC4X3.IfcElectricMotor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1003880860: (a) => new IFC4X3.IfcElectricTimeControl(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3415622556: (a) => new IFC4X3.IfcFan(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  819412036: (a) => new IFC4X3.IfcFilter(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1426591983: (a) => new IFC4X3.IfcFireSuppressionTerminal(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  182646315: (a) => new IFC4X3.IfcFlowInstrument(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2680139844: (a) => new IFC4X3.IfcGeomodel(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1971632696: (a) => new IFC4X3.IfcGeoslice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2295281155: (a) => new IFC4X3.IfcProtectiveDeviceTrippingUnit(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4086658281: (a) => new IFC4X3.IfcSensor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  630975310: (a) => new IFC4X3.IfcUnitaryControlElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4288193352: (a) => new IFC4X3.IfcActuator(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3087945054: (a) => new IFC4X3.IfcAlarm(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  25142252: (a) => new IFC4X3.IfcController(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8])
};
ToRawLineData[3] = {
  3630933823: (i) => [i.Role, i.UserDefinedRole, i.Description],
  618182010: (i) => [i.Purpose, i.Description, i.UserDefinedPurpose],
  2879124712: (i) => [i.StartTag, i.EndTag],
  3633395639: (i) => [i.StartTag, i.EndTag, i.StartDistAlong, i.HorizontalLength, i.StartHeight, i.StartGradient, i.EndGradient, i.RadiusOfCurvature, i.PredefinedType],
  639542469: (i) => [i.ApplicationDeveloper, i.Version, i.ApplicationFullName, i.ApplicationIdentifier],
  411424972: (i) => [i.Name, i.Description, i.AppliedValue, i.UnitBasis, i.ApplicableDate, i.FixedUntilDate, i.Category, i.Condition, i.ArithmeticOperator, i.Components],
  130549933: (i) => [i.Identifier, i.Name, i.Description, i.TimeOfApproval, i.Status, i.Level, i.Qualifier, i.RequestingApproval, i.GivingApproval],
  4037036970: (i) => [i.Name],
  1560379544: (i) => [i.Name, !i.TranslationalStiffnessByLengthX ? null : Labelise(i.TranslationalStiffnessByLengthX), !i.TranslationalStiffnessByLengthY ? null : Labelise(i.TranslationalStiffnessByLengthY), !i.TranslationalStiffnessByLengthZ ? null : Labelise(i.TranslationalStiffnessByLengthZ), !i.RotationalStiffnessByLengthX ? null : Labelise(i.RotationalStiffnessByLengthX), !i.RotationalStiffnessByLengthY ? null : Labelise(i.RotationalStiffnessByLengthY), !i.RotationalStiffnessByLengthZ ? null : Labelise(i.RotationalStiffnessByLengthZ)],
  3367102660: (i) => [i.Name, !i.TranslationalStiffnessByAreaX ? null : Labelise(i.TranslationalStiffnessByAreaX), !i.TranslationalStiffnessByAreaY ? null : Labelise(i.TranslationalStiffnessByAreaY), !i.TranslationalStiffnessByAreaZ ? null : Labelise(i.TranslationalStiffnessByAreaZ)],
  1387855156: (i) => [i.Name, !i.TranslationalStiffnessX ? null : Labelise(i.TranslationalStiffnessX), !i.TranslationalStiffnessY ? null : Labelise(i.TranslationalStiffnessY), !i.TranslationalStiffnessZ ? null : Labelise(i.TranslationalStiffnessZ), !i.RotationalStiffnessX ? null : Labelise(i.RotationalStiffnessX), !i.RotationalStiffnessY ? null : Labelise(i.RotationalStiffnessY), !i.RotationalStiffnessZ ? null : Labelise(i.RotationalStiffnessZ)],
  2069777674: (i) => [i.Name, !i.TranslationalStiffnessX ? null : Labelise(i.TranslationalStiffnessX), !i.TranslationalStiffnessY ? null : Labelise(i.TranslationalStiffnessY), !i.TranslationalStiffnessZ ? null : Labelise(i.TranslationalStiffnessZ), !i.RotationalStiffnessX ? null : Labelise(i.RotationalStiffnessX), !i.RotationalStiffnessY ? null : Labelise(i.RotationalStiffnessY), !i.RotationalStiffnessZ ? null : Labelise(i.RotationalStiffnessZ), !i.WarpingStiffness ? null : Labelise(i.WarpingStiffness)],
  2859738748: (_) => [],
  2614616156: (i) => [i.PointOnRelatingElement, i.PointOnRelatedElement],
  2732653382: (i) => [i.SurfaceOnRelatingElement, i.SurfaceOnRelatedElement],
  775493141: (i) => [i.VolumeOnRelatingElement, i.VolumeOnRelatedElement],
  1959218052: (i) => [i.Name, i.Description, i.ConstraintGrade, i.ConstraintSource, i.CreatingActor, i.CreationTime, i.UserDefinedGrade],
  1785450214: (i) => [i.SourceCRS, i.TargetCRS],
  1466758467: (i) => [i.Name, i.Description, i.GeodeticDatum, i.VerticalDatum],
  602808272: (i) => [i.Name, i.Description, i.AppliedValue, i.UnitBasis, i.ApplicableDate, i.FixedUntilDate, i.Category, i.Condition, i.ArithmeticOperator, i.Components],
  1765591967: (i) => [i.Elements, i.UnitType, i.UserDefinedType, i.Name],
  1045800335: (i) => [i.Unit, i.Exponent],
  2949456006: (i) => [i.LengthExponent, i.MassExponent, i.TimeExponent, i.ElectricCurrentExponent, i.ThermodynamicTemperatureExponent, i.AmountOfSubstanceExponent, i.LuminousIntensityExponent],
  4294318154: (_) => [],
  3200245327: (i) => [i.Location, i.Identification, i.Name],
  2242383968: (i) => [i.Location, i.Identification, i.Name],
  1040185647: (i) => [i.Location, i.Identification, i.Name],
  3548104201: (i) => [i.Location, i.Identification, i.Name],
  852622518: (i) => [i.AxisTag, i.AxisCurve, { type: 3, value: BooleanConvert(i.SameSense.value) }],
  3020489413: (i) => [i.TimeStamp, i.ListValues.map((p) => Labelise(p))],
  2655187982: (i) => [i.Name, i.Version, i.Publisher, i.VersionDate, i.Location, i.Description],
  3452421091: (i) => [i.Location, i.Identification, i.Name, i.Description, i.Language, i.ReferencedLibrary],
  4162380809: (i) => [i.MainPlaneAngle, i.SecondaryPlaneAngle, i.LuminousIntensity],
  1566485204: (i) => [i.LightDistributionCurve, i.DistributionData],
  3057273783: (i) => [i.SourceCRS, i.TargetCRS, i.Eastings, i.Northings, i.OrthogonalHeight, i.XAxisAbscissa, i.XAxisOrdinate, i.Scale, i.ScaleY, i.ScaleZ],
  1847130766: (i) => [i.MaterialClassifications, i.ClassifiedMaterial],
  760658860: (_) => [],
  248100487: (i) => [i.Material, i.LayerThickness, i.IsVentilated == null ? null : { type: 3, value: BooleanConvert(i.IsVentilated.value) }, i.Name, i.Description, i.Category, i.Priority],
  3303938423: (i) => [i.MaterialLayers, i.LayerSetName, i.Description],
  1847252529: (i) => [i.Material, i.LayerThickness, i.IsVentilated == null ? null : { type: 3, value: BooleanConvert(i.IsVentilated.value) }, i.Name, i.Description, i.Category, i.Priority, i.OffsetDirection, i.OffsetValues],
  2199411900: (i) => [i.Materials],
  2235152071: (i) => [i.Name, i.Description, i.Material, i.Profile, i.Priority, i.Category],
  164193824: (i) => [i.Name, i.Description, i.MaterialProfiles, i.CompositeProfile],
  552965576: (i) => [i.Name, i.Description, i.Material, i.Profile, i.Priority, i.Category, i.OffsetValues],
  1507914824: (_) => [],
  2597039031: (i) => [Labelise(i.ValueComponent), i.UnitComponent],
  3368373690: (i) => [i.Name, i.Description, i.ConstraintGrade, i.ConstraintSource, i.CreatingActor, i.CreationTime, i.UserDefinedGrade, i.Benchmark, i.ValueSource, i.DataValue, i.ReferencePath],
  2706619895: (i) => [i.Currency],
  1918398963: (i) => [i.Dimensions, i.UnitType],
  3701648758: (i) => [i.PlacementRelTo],
  2251480897: (i) => [i.Name, i.Description, i.ConstraintGrade, i.ConstraintSource, i.CreatingActor, i.CreationTime, i.UserDefinedGrade, i.BenchmarkValues, i.LogicalAggregator, i.ObjectiveQualifier, i.UserDefinedQualifier],
  4251960020: (i) => [i.Identification, i.Name, i.Description, i.Roles, i.Addresses],
  1207048766: (i) => [i.OwningUser, i.OwningApplication, i.State, i.ChangeAction, i.LastModifiedDate, i.LastModifyingUser, i.LastModifyingApplication, i.CreationDate],
  2077209135: (i) => [i.Identification, i.FamilyName, i.GivenName, i.MiddleNames, i.PrefixTitles, i.SuffixTitles, i.Roles, i.Addresses],
  101040310: (i) => [i.ThePerson, i.TheOrganization, i.Roles],
  2483315170: (i) => [i.Name, i.Description],
  2226359599: (i) => [i.Name, i.Description, i.Unit],
  3355820592: (i) => [i.Purpose, i.Description, i.UserDefinedPurpose, i.InternalLocation, i.AddressLines, i.PostalBox, i.Town, i.Region, i.PostalCode, i.Country],
  677532197: (_) => [],
  2022622350: (i) => [i.Name, i.Description, i.AssignedItems, i.Identifier],
  1304840413: (i) => [i.Name, i.Description, i.AssignedItems, i.Identifier, { type: 3, value: BooleanConvert(i.LayerOn.value) }, { type: 3, value: BooleanConvert(i.LayerFrozen.value) }, { type: 3, value: BooleanConvert(i.LayerBlocked.value) }, i.LayerStyles],
  3119450353: (i) => [i.Name],
  2095639259: (i) => [i.Name, i.Description, i.Representations],
  3958567839: (i) => [i.ProfileType, i.ProfileName],
  3843373140: (i) => [i.Name, i.Description, i.GeodeticDatum, i.VerticalDatum, i.MapProjection, i.MapZone, i.MapUnit],
  986844984: (_) => [],
  3710013099: (i) => [i.Name, i.EnumerationValues.map((p) => Labelise(p)), i.Unit],
  2044713172: (i) => [i.Name, i.Description, i.Unit, i.AreaValue, i.Formula],
  2093928680: (i) => [i.Name, i.Description, i.Unit, i.CountValue, i.Formula],
  931644368: (i) => [i.Name, i.Description, i.Unit, i.LengthValue, i.Formula],
  2691318326: (i) => [i.Name, i.Description, i.Unit, i.NumberValue, i.Formula],
  3252649465: (i) => [i.Name, i.Description, i.Unit, i.TimeValue, i.Formula],
  2405470396: (i) => [i.Name, i.Description, i.Unit, i.VolumeValue, i.Formula],
  825690147: (i) => [i.Name, i.Description, i.Unit, i.WeightValue, i.Formula],
  3915482550: (i) => [i.RecurrenceType, i.DayComponent, i.WeekdayComponent, i.MonthComponent, i.Position, i.Interval, i.Occurrences, i.TimePeriods],
  2433181523: (i) => [i.TypeIdentifier, i.AttributeIdentifier, i.InstanceName, i.ListPositions, i.InnerReference],
  1076942058: (i) => [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items],
  3377609919: (i) => [i.ContextIdentifier, i.ContextType],
  3008791417: (_) => [],
  1660063152: (i) => [i.MappingOrigin, i.MappedRepresentation],
  2439245199: (i) => [i.Name, i.Description],
  2341007311: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  448429030: (i) => [i.Dimensions, i.UnitType, i.Prefix, i.Name],
  1054537805: (i) => [i.Name, i.DataOrigin, i.UserDefinedDataOrigin],
  867548509: (i) => [i.ShapeRepresentations, i.Name, i.Description, { type: 3, value: BooleanConvert(i.ProductDefinitional.value) }, i.PartOfProductDefinitionShape],
  3982875396: (i) => [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items],
  4240577450: (i) => [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items],
  2273995522: (i) => [i.Name],
  2162789131: (i) => [i.Name],
  3478079324: (i) => [i.Name, i.Values, i.Locations],
  609421318: (i) => [i.Name],
  2525727697: (i) => [i.Name],
  3408363356: (i) => [i.Name, i.DeltaTConstant, i.DeltaTY, i.DeltaTZ],
  2830218821: (i) => [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items],
  3958052878: (i) => [i.Item, i.Styles, i.Name],
  3049322572: (i) => [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items],
  2934153892: (i) => [i.Name, i.SurfaceReinforcement1, i.SurfaceReinforcement2, i.ShearReinforcement],
  1300840506: (i) => [i.Name, i.Side, i.Styles],
  3303107099: (i) => [i.DiffuseTransmissionColour, i.DiffuseReflectionColour, i.TransmissionColour, i.ReflectanceColour],
  1607154358: (i) => [i.RefractionIndex, i.DispersionFactor],
  846575682: (i) => [i.SurfaceColour, i.Transparency],
  1351298697: (i) => [i.Textures],
  626085974: (i) => [{ type: 3, value: BooleanConvert(i.RepeatS.value) }, { type: 3, value: BooleanConvert(i.RepeatT.value) }, i.Mode, i.TextureTransform, i.Parameter],
  985171141: (i) => [i.Name, i.Rows, i.Columns],
  2043862942: (i) => [i.Identifier, i.Name, i.Description, i.Unit, i.ReferencePath],
  531007025: (i) => [!i.RowCells ? null : i.RowCells.map((p) => Labelise(p)), i.IsHeading == null ? null : { type: 3, value: BooleanConvert(i.IsHeading.value) }],
  1549132990: (i) => [i.Name, i.DataOrigin, i.UserDefinedDataOrigin, i.DurationType, i.ScheduleDuration, i.ScheduleStart, i.ScheduleFinish, i.EarlyStart, i.EarlyFinish, i.LateStart, i.LateFinish, i.FreeFloat, i.TotalFloat, i.IsCritical == null ? null : { type: 3, value: BooleanConvert(i.IsCritical.value) }, i.StatusTime, i.ActualDuration, i.ActualStart, i.ActualFinish, i.RemainingTime, i.Completion],
  2771591690: (i) => [i.Name, i.DataOrigin, i.UserDefinedDataOrigin, i.DurationType, i.ScheduleDuration, i.ScheduleStart, i.ScheduleFinish, i.EarlyStart, i.EarlyFinish, i.LateStart, i.LateFinish, i.FreeFloat, i.TotalFloat, i.IsCritical == null ? null : { type: 3, value: BooleanConvert(i.IsCritical.value) }, i.StatusTime, i.ActualDuration, i.ActualStart, i.ActualFinish, i.RemainingTime, i.Completion, i.Recurrence],
  912023232: (i) => [i.Purpose, i.Description, i.UserDefinedPurpose, i.TelephoneNumbers, i.FacsimileNumbers, i.PagerNumber, i.ElectronicMailAddresses, i.WWWHomePageURL, i.MessagingIDs],
  1447204868: (i) => [i.Name, i.TextCharacterAppearance, i.TextStyle, i.TextFontStyle, i.ModelOrDraughting == null ? null : { type: 3, value: BooleanConvert(i.ModelOrDraughting.value) }],
  2636378356: (i) => [i.Colour, i.BackgroundColour],
  1640371178: (i) => [!i.TextIndent ? null : Labelise(i.TextIndent), i.TextAlign, i.TextDecoration, !i.LetterSpacing ? null : Labelise(i.LetterSpacing), !i.WordSpacing ? null : Labelise(i.WordSpacing), i.TextTransform, !i.LineHeight ? null : Labelise(i.LineHeight)],
  280115917: (i) => [i.Maps],
  1742049831: (i) => [i.Maps, i.Mode, i.Parameter],
  222769930: (i) => [i.TexCoordIndex, i.TexCoordsOf],
  1010789467: (i) => [i.TexCoordIndex, i.TexCoordsOf, i.InnerTexCoordIndices],
  2552916305: (i) => [i.Maps, i.Vertices, i.MappedTo],
  1210645708: (i) => [i.Coordinates],
  3611470254: (i) => [i.TexCoordsList],
  1199560280: (i) => [i.StartTime, i.EndTime],
  3101149627: (i) => [i.Name, i.Description, i.StartTime, i.EndTime, i.TimeSeriesDataType, i.DataOrigin, i.UserDefinedDataOrigin, i.Unit],
  581633288: (i) => [i.ListValues.map((p) => Labelise(p))],
  1377556343: (_) => [],
  1735638870: (i) => [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items],
  180925521: (i) => [i.Units],
  2799835756: (_) => [],
  1907098498: (i) => [i.VertexGeometry],
  891718957: (i) => [i.IntersectingAxes, i.OffsetDistances],
  1236880293: (i) => [i.Name, i.DataOrigin, i.UserDefinedDataOrigin, i.RecurrencePattern, i.StartDate, i.FinishDate],
  3752311538: (i) => [i.StartTag, i.EndTag, i.StartDistAlong, i.HorizontalLength, i.StartCantLeft, i.EndCantLeft, i.StartCantRight, i.EndCantRight, i.PredefinedType],
  536804194: (i) => [i.StartTag, i.EndTag, i.StartPoint, i.StartDirection, i.StartRadiusOfCurvature, i.EndRadiusOfCurvature, i.SegmentLength, i.GravityCenterLineHeight, i.PredefinedType],
  3869604511: (i) => [i.Name, i.Description, i.RelatingApproval, i.RelatedApprovals],
  3798115385: (i) => [i.ProfileType, i.ProfileName, i.OuterCurve],
  1310608509: (i) => [i.ProfileType, i.ProfileName, i.Curve],
  2705031697: (i) => [i.ProfileType, i.ProfileName, i.OuterCurve, i.InnerCurves],
  616511568: (i) => [{ type: 3, value: BooleanConvert(i.RepeatS.value) }, { type: 3, value: BooleanConvert(i.RepeatT.value) }, i.Mode, i.TextureTransform, i.Parameter, i.RasterFormat, i.RasterCode],
  3150382593: (i) => [i.ProfileType, i.ProfileName, i.Curve, i.Thickness],
  747523909: (i) => [i.Source, i.Edition, i.EditionDate, i.Name, i.Description, i.Specification, i.ReferenceTokens],
  647927063: (i) => [i.Location, i.Identification, i.Name, i.ReferencedSource, i.Description, i.Sort],
  3285139300: (i) => [i.ColourList],
  3264961684: (i) => [i.Name],
  1485152156: (i) => [i.ProfileType, i.ProfileName, i.Profiles, i.Label],
  370225590: (i) => [i.CfsFaces],
  1981873012: (i) => [i.CurveOnRelatingElement, i.CurveOnRelatedElement],
  45288368: (i) => [i.PointOnRelatingElement, i.PointOnRelatedElement, i.EccentricityInX, i.EccentricityInY, i.EccentricityInZ],
  3050246964: (i) => [i.Dimensions, i.UnitType, i.Name],
  2889183280: (i) => [i.Dimensions, i.UnitType, i.Name, i.ConversionFactor],
  2713554722: (i) => [i.Dimensions, i.UnitType, i.Name, i.ConversionFactor, i.ConversionOffset],
  539742890: (i) => [i.Name, i.Description, i.RelatingMonetaryUnit, i.RelatedMonetaryUnit, i.ExchangeRate, i.RateDateTime, i.RateSource],
  3800577675: (i) => [i.Name, i.CurveFont, !i.CurveWidth ? null : Labelise(i.CurveWidth), i.CurveColour, i.ModelOrDraughting == null ? null : { type: 3, value: BooleanConvert(i.ModelOrDraughting.value) }],
  1105321065: (i) => [i.Name, i.PatternList],
  2367409068: (i) => [i.Name, i.CurveStyleFont, i.CurveFontScaling],
  3510044353: (i) => [i.VisibleSegmentLength, i.InvisibleSegmentLength],
  3632507154: (i) => [i.ProfileType, i.ProfileName, i.ParentProfile, i.Operator, i.Label],
  1154170062: (i) => [i.Identification, i.Name, i.Description, i.Location, i.Purpose, i.IntendedUse, i.Scope, i.Revision, i.DocumentOwner, i.Editors, i.CreationTime, i.LastRevisionTime, i.ElectronicFormat, i.ValidFrom, i.ValidUntil, i.Confidentiality, i.Status],
  770865208: (i) => [i.Name, i.Description, i.RelatingDocument, i.RelatedDocuments, i.RelationshipType],
  3732053477: (i) => [i.Location, i.Identification, i.Name, i.Description, i.ReferencedDocument],
  3900360178: (i) => [i.EdgeStart, i.EdgeEnd],
  476780140: (i) => [i.EdgeStart, i.EdgeEnd, i.EdgeGeometry, { type: 3, value: BooleanConvert(i.SameSense.value) }],
  211053100: (i) => [i.Name, i.DataOrigin, i.UserDefinedDataOrigin, i.ActualDate, i.EarlyDate, i.LateDate, i.ScheduleDate],
  297599258: (i) => [i.Name, i.Description, i.Properties],
  1437805879: (i) => [i.Name, i.Description, i.RelatingReference, i.RelatedResourceObjects],
  2556980723: (i) => [i.Bounds],
  1809719519: (i) => [i.Bound, { type: 3, value: BooleanConvert(i.Orientation.value) }],
  803316827: (i) => [i.Bound, { type: 3, value: BooleanConvert(i.Orientation.value) }],
  3008276851: (i) => [i.Bounds, i.FaceSurface, { type: 3, value: BooleanConvert(i.SameSense.value) }],
  4219587988: (i) => [i.Name, i.TensionFailureX, i.TensionFailureY, i.TensionFailureZ, i.CompressionFailureX, i.CompressionFailureY, i.CompressionFailureZ],
  738692330: (i) => [i.Name, i.FillStyles, i.ModelOrDraughting == null ? null : { type: 3, value: BooleanConvert(i.ModelOrDraughting.value) }],
  3448662350: (i) => [i.ContextIdentifier, i.ContextType, i.CoordinateSpaceDimension, i.Precision, i.WorldCoordinateSystem, i.TrueNorth],
  2453401579: (_) => [],
  4142052618: (i) => [i.ContextIdentifier, i.ContextType, i.CoordinateSpaceDimension, i.Precision, i.WorldCoordinateSystem, i.TrueNorth, i.ParentContext, i.TargetScale, i.TargetView, i.UserDefinedTargetView],
  3590301190: (i) => [i.Elements],
  178086475: (i) => [i.PlacementRelTo, i.PlacementLocation, i.PlacementRefDirection],
  812098782: (i) => [i.BaseSurface, { type: 3, value: BooleanConvert(i.AgreementFlag.value) }],
  3905492369: (i) => [{ type: 3, value: BooleanConvert(i.RepeatS.value) }, { type: 3, value: BooleanConvert(i.RepeatT.value) }, i.Mode, i.TextureTransform, i.Parameter, i.URLReference],
  3570813810: (i) => [i.MappedTo, i.Opacity, i.Colours, i.ColourIndex],
  1437953363: (i) => [i.Maps, i.MappedTo, i.TexCoords],
  2133299955: (i) => [i.Maps, i.MappedTo, i.TexCoords, i.TexCoordIndex],
  3741457305: (i) => [i.Name, i.Description, i.StartTime, i.EndTime, i.TimeSeriesDataType, i.DataOrigin, i.UserDefinedDataOrigin, i.Unit, i.Values],
  1585845231: (i) => [i.Name, i.DataOrigin, i.UserDefinedDataOrigin, Labelise(i.LagValue), i.DurationType],
  1402838566: (i) => [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity],
  125510826: (i) => [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity],
  2604431987: (i) => [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity, i.Orientation],
  4266656042: (i) => [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity, i.Position, i.ColourAppearance, i.ColourTemperature, i.LuminousFlux, i.LightEmissionSource, i.LightDistributionDataSource],
  1520743889: (i) => [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity, i.Position, i.Radius, i.ConstantAttenuation, i.DistanceAttenuation, i.QuadricAttenuation],
  3422422726: (i) => [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity, i.Position, i.Radius, i.ConstantAttenuation, i.DistanceAttenuation, i.QuadricAttenuation, i.Orientation, i.ConcentrationExponent, i.SpreadAngle, i.BeamWidthAngle],
  388784114: (i) => [i.PlacementRelTo, i.RelativePlacement, i.CartesianPosition],
  2624227202: (i) => [i.PlacementRelTo, i.RelativePlacement],
  1008929658: (_) => [],
  2347385850: (i) => [i.MappingSource, i.MappingTarget],
  1838606355: (i) => [i.Name, i.Description, i.Category],
  3708119e3: (i) => [i.Name, i.Description, i.Material, i.Fraction, i.Category],
  2852063980: (i) => [i.Name, i.Description, i.MaterialConstituents],
  2022407955: (i) => [i.Name, i.Description, i.Representations, i.RepresentedMaterial],
  1303795690: (i) => [i.ForLayerSet, i.LayerSetDirection, i.DirectionSense, i.OffsetFromReferenceLine, i.ReferenceExtent],
  3079605661: (i) => [i.ForProfileSet, i.CardinalPoint, i.ReferenceExtent],
  3404854881: (i) => [i.ForProfileSet, i.CardinalPoint, i.ReferenceExtent, i.ForProfileEndSet, i.CardinalEndPoint],
  3265635763: (i) => [i.Name, i.Description, i.Properties, i.Material],
  853536259: (i) => [i.Name, i.Description, i.RelatingMaterial, i.RelatedMaterials, i.MaterialExpression],
  2998442950: (i) => [i.ProfileType, i.ProfileName, i.ParentProfile, i.Operator, i.Label],
  219451334: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  182550632: (i) => [i.ProfileType, i.ProfileName, { type: 3, value: BooleanConvert(i.HorizontalWidths.value) }, i.Widths, i.Slopes, i.Tags, i.OffsetPoint],
  2665983363: (i) => [i.CfsFaces],
  1411181986: (i) => [i.Name, i.Description, i.RelatingOrganization, i.RelatedOrganizations],
  1029017970: (i) => [i.EdgeStart, i.EdgeEnd, i.EdgeElement, { type: 3, value: BooleanConvert(i.Orientation.value) }],
  2529465313: (i) => [i.ProfileType, i.ProfileName, i.Position],
  2519244187: (i) => [i.EdgeList],
  3021840470: (i) => [i.Name, i.Description, i.HasQuantities, i.Discrimination, i.Quality, i.Usage],
  597895409: (i) => [{ type: 3, value: BooleanConvert(i.RepeatS.value) }, { type: 3, value: BooleanConvert(i.RepeatT.value) }, i.Mode, i.TextureTransform, i.Parameter, i.Width, i.Height, i.ColourComponents, i.Pixel],
  2004835150: (i) => [i.Location],
  1663979128: (i) => [i.SizeInX, i.SizeInY],
  2067069095: (_) => [],
  2165702409: (i) => [Labelise(i.DistanceAlong), i.OffsetLateral, i.OffsetVertical, i.OffsetLongitudinal, i.BasisCurve],
  4022376103: (i) => [i.BasisCurve, i.PointParameter],
  1423911732: (i) => [i.BasisSurface, i.PointParameterU, i.PointParameterV],
  2924175390: (i) => [i.Polygon],
  2775532180: (i) => [i.BaseSurface, { type: 3, value: BooleanConvert(i.AgreementFlag.value) }, i.Position, i.PolygonalBoundary],
  3727388367: (i) => [i.Name],
  3778827333: (_) => [],
  1775413392: (i) => [i.Name],
  673634403: (i) => [i.Name, i.Description, i.Representations],
  2802850158: (i) => [i.Name, i.Description, i.Properties, i.ProfileDefinition],
  2598011224: (i) => [i.Name, i.Specification],
  1680319473: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  148025276: (i) => [i.Name, i.Description, i.DependingProperty, i.DependantProperty, i.Expression],
  3357820518: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  1482703590: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  2090586900: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  3615266464: (i) => [i.ProfileType, i.ProfileName, i.Position, i.XDim, i.YDim],
  3413951693: (i) => [i.Name, i.Description, i.StartTime, i.EndTime, i.TimeSeriesDataType, i.DataOrigin, i.UserDefinedDataOrigin, i.Unit, i.TimeStep, i.Values],
  1580146022: (i) => [i.TotalCrossSectionArea, i.SteelGrade, i.BarSurface, i.EffectiveDepth, i.NominalBarDiameter, i.BarCount],
  478536968: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  2943643501: (i) => [i.Name, i.Description, i.RelatedResourceObjects, i.RelatingApproval],
  1608871552: (i) => [i.Name, i.Description, i.RelatingConstraint, i.RelatedResourceObjects],
  1042787934: (i) => [i.Name, i.DataOrigin, i.UserDefinedDataOrigin, i.ScheduleWork, i.ScheduleUsage, i.ScheduleStart, i.ScheduleFinish, i.ScheduleContour, i.LevelingDelay, i.IsOverAllocated == null ? null : { type: 3, value: BooleanConvert(i.IsOverAllocated.value) }, i.StatusTime, i.ActualWork, i.ActualUsage, i.ActualStart, i.ActualFinish, i.RemainingWork, i.RemainingUsage, i.Completion],
  2778083089: (i) => [i.ProfileType, i.ProfileName, i.Position, i.XDim, i.YDim, i.RoundingRadius],
  2042790032: (i) => [i.SectionType, i.StartProfile, i.EndProfile],
  4165799628: (i) => [i.LongitudinalStartPosition, i.LongitudinalEndPosition, i.TransversePosition, i.ReinforcementRole, i.SectionDefinition, i.CrossSectionReinforcementDefinitions],
  1509187699: (i) => [i.SpineCurve, i.CrossSections, i.CrossSectionPositions],
  823603102: (i) => [i.Transition],
  4124623270: (i) => [i.SbsmBoundary],
  3692461612: (i) => [i.Name, i.Specification],
  2609359061: (i) => [i.Name, i.SlippageX, i.SlippageY, i.SlippageZ],
  723233188: (_) => [],
  1595516126: (i) => [i.Name, i.LinearForceX, i.LinearForceY, i.LinearForceZ, i.LinearMomentX, i.LinearMomentY, i.LinearMomentZ],
  2668620305: (i) => [i.Name, i.PlanarForceX, i.PlanarForceY, i.PlanarForceZ],
  2473145415: (i) => [i.Name, i.DisplacementX, i.DisplacementY, i.DisplacementZ, i.RotationalDisplacementRX, i.RotationalDisplacementRY, i.RotationalDisplacementRZ],
  1973038258: (i) => [i.Name, i.DisplacementX, i.DisplacementY, i.DisplacementZ, i.RotationalDisplacementRX, i.RotationalDisplacementRY, i.RotationalDisplacementRZ, i.Distortion],
  1597423693: (i) => [i.Name, i.ForceX, i.ForceY, i.ForceZ, i.MomentX, i.MomentY, i.MomentZ],
  1190533807: (i) => [i.Name, i.ForceX, i.ForceY, i.ForceZ, i.MomentX, i.MomentY, i.MomentZ, i.WarpingMoment],
  2233826070: (i) => [i.EdgeStart, i.EdgeEnd, i.ParentEdge],
  2513912981: (_) => [],
  1878645084: (i) => [i.SurfaceColour, i.Transparency, i.DiffuseColour, i.TransmissionColour, i.DiffuseTransmissionColour, i.ReflectionColour, i.SpecularColour, !i.SpecularHighlight ? null : Labelise(i.SpecularHighlight), i.ReflectanceMethod],
  2247615214: (i) => [i.SweptArea, i.Position],
  1260650574: (i) => [i.Directrix, i.Radius, i.InnerRadius, i.StartParam, i.EndParam],
  1096409881: (i) => [i.Directrix, i.Radius, i.InnerRadius, i.StartParam, i.EndParam, i.FilletRadius],
  230924584: (i) => [i.SweptCurve, i.Position],
  3071757647: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.FlangeWidth, i.WebThickness, i.FlangeThickness, i.FilletRadius, i.FlangeEdgeRadius, i.WebEdgeRadius, i.WebSlope, i.FlangeSlope],
  901063453: (_) => [],
  4282788508: (i) => [i.Literal, i.Placement, i.Path],
  3124975700: (i) => [i.Literal, i.Placement, i.Path, i.Extent, i.BoxAlignment],
  1983826977: (i) => [i.Name, i.FontFamily, i.FontStyle, i.FontVariant, i.FontWeight, Labelise(i.FontSize)],
  2715220739: (i) => [i.ProfileType, i.ProfileName, i.Position, i.BottomXDim, i.TopXDim, i.YDim, i.TopXOffset],
  1628702193: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets],
  3736923433: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ProcessType],
  2347495698: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag],
  3698973494: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType],
  427810014: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.FlangeWidth, i.WebThickness, i.FlangeThickness, i.FilletRadius, i.EdgeRadius, i.FlangeSlope],
  1417489154: (i) => [i.Orientation, i.Magnitude],
  2759199220: (i) => [i.LoopVertex],
  2543172580: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.FlangeWidth, i.WebThickness, i.FlangeThickness, i.FilletRadius, i.EdgeRadius],
  3406155212: (i) => [i.Bounds, i.FaceSurface, { type: 3, value: BooleanConvert(i.SameSense.value) }],
  669184980: (i) => [i.OuterBoundary, i.InnerBoundaries],
  3207858831: (i) => [i.ProfileType, i.ProfileName, i.Position, i.BottomFlangeWidth, i.OverallDepth, i.WebThickness, i.BottomFlangeThickness, i.BottomFlangeFilletRadius, i.TopFlangeWidth, i.TopFlangeThickness, i.TopFlangeFilletRadius, i.BottomFlangeEdgeRadius, i.BottomFlangeSlope, i.TopFlangeEdgeRadius, i.TopFlangeSlope],
  4261334040: (i) => [i.Location, i.Axis],
  3125803723: (i) => [i.Location, i.RefDirection],
  2740243338: (i) => [i.Location, i.Axis, i.RefDirection],
  3425423356: (i) => [i.Location, i.Axis, i.RefDirection],
  2736907675: (i) => [i.Operator, i.FirstOperand, i.SecondOperand],
  4182860854: (_) => [],
  2581212453: (i) => [i.Corner, i.XDim, i.YDim, i.ZDim],
  2713105998: (i) => [i.BaseSurface, { type: 3, value: BooleanConvert(i.AgreementFlag.value) }, i.Enclosure],
  2898889636: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.Width, i.WallThickness, i.Girth, i.InternalFilletRadius],
  1123145078: (i) => [i.Coordinates],
  574549367: (_) => [],
  1675464909: (i) => [i.CoordList, i.TagList],
  2059837836: (i) => [i.CoordList, i.TagList],
  59481748: (i) => [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale],
  3749851601: (i) => [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale],
  3486308946: (i) => [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale, i.Scale2],
  3331915920: (i) => [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale, i.Axis3],
  1416205885: (i) => [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale, i.Axis3, i.Scale2, i.Scale3],
  1383045692: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Radius],
  2205249479: (i) => [i.CfsFaces],
  776857604: (i) => [i.Name, i.Red, i.Green, i.Blue],
  2542286263: (i) => [i.Name, i.Specification, i.UsageName, i.HasProperties],
  2485617015: (i) => [i.Transition, { type: 3, value: BooleanConvert(i.SameSense.value) }, i.ParentCurve],
  2574617495: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity],
  3419103109: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LongName, i.Phase, i.RepresentationContexts, i.UnitsInContext],
  1815067380: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  2506170314: (i) => [i.Position],
  2147822146: (i) => [i.TreeRootExpression],
  2601014836: (_) => [],
  2827736869: (i) => [i.BasisSurface, i.OuterBoundary, i.InnerBoundaries],
  2629017746: (i) => [i.BasisSurface, i.Boundaries, { type: 3, value: BooleanConvert(i.ImplicitOuter.value) }],
  4212018352: (i) => [i.Transition, i.Placement, Labelise(i.SegmentStart), Labelise(i.SegmentLength), i.ParentCurve],
  32440307: (i) => [i.DirectionRatios],
  593015953: (i) => [i.SweptArea, i.Position, i.Directrix, !i.StartParam ? null : Labelise(i.StartParam), !i.EndParam ? null : Labelise(i.EndParam)],
  1472233963: (i) => [i.EdgeList],
  1883228015: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.MethodOfMeasurement, i.Quantities],
  339256511: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  2777663545: (i) => [i.Position],
  2835456948: (i) => [i.ProfileType, i.ProfileName, i.Position, i.SemiAxis1, i.SemiAxis2],
  4024345920: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ProcessType, i.PredefinedType, i.EventTriggerType, i.UserDefinedEventTriggerType],
  477187591: (i) => [i.SweptArea, i.Position, i.ExtrudedDirection, i.Depth],
  2804161546: (i) => [i.SweptArea, i.Position, i.ExtrudedDirection, i.Depth, i.EndSweptArea],
  2047409740: (i) => [i.FbsmFaces],
  374418227: (i) => [i.HatchLineAppearance, i.StartOfNextHatchLine, i.PointOfReferenceHatchLine, i.PatternStart, i.HatchLineAngle],
  315944413: (i) => [i.TilingPattern, i.Tiles, i.TilingScale],
  2652556860: (i) => [i.SweptArea, i.Position, i.Directrix, !i.StartParam ? null : Labelise(i.StartParam), !i.EndParam ? null : Labelise(i.EndParam), i.FixedReference],
  4238390223: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  1268542332: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.AssemblyPlace, i.PredefinedType],
  4095422895: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  987898635: (i) => [i.Elements],
  1484403080: (i) => [i.ProfileType, i.ProfileName, i.Position, i.OverallWidth, i.OverallDepth, i.WebThickness, i.FlangeThickness, i.FilletRadius, i.FlangeEdgeRadius, i.FlangeSlope],
  178912537: (i) => [i.CoordIndex],
  2294589976: (i) => [i.CoordIndex, i.InnerCoordIndices],
  3465909080: (i) => [i.Maps, i.MappedTo, i.TexCoords, i.TexCoordIndices],
  572779678: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.Width, i.Thickness, i.FilletRadius, i.EdgeRadius, i.LegSlope],
  428585644: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  1281925730: (i) => [i.Pnt, i.Dir],
  1425443689: (i) => [i.Outer],
  3888040117: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType],
  590820931: (i) => [i.BasisCurve],
  3388369263: (i) => [i.BasisCurve, i.Distance, { type: 3, value: BooleanConvert(i.SelfIntersect.value) }],
  3505215534: (i) => [i.BasisCurve, i.Distance, { type: 3, value: BooleanConvert(i.SelfIntersect.value) }, i.RefDirection],
  2485787929: (i) => [i.BasisCurve, i.OffsetValues, i.Tag],
  1682466193: (i) => [i.BasisSurface, i.ReferenceCurve],
  603570806: (i) => [i.SizeInX, i.SizeInY, i.Placement],
  220341763: (i) => [i.Position],
  3381221214: (i) => [i.Position, i.CoefficientsX, i.CoefficientsY, i.CoefficientsZ],
  759155922: (i) => [i.Name],
  2559016684: (i) => [i.Name],
  3967405729: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  569719735: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ProcessType, i.PredefinedType],
  2945172077: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription],
  4208778838: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation],
  103090709: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LongName, i.Phase, i.RepresentationContexts, i.UnitsInContext],
  653396225: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LongName, i.Phase, i.RepresentationContexts, i.UnitsInContext],
  871118103: (i) => [i.Name, i.Specification, !i.UpperBoundValue ? null : Labelise(i.UpperBoundValue), !i.LowerBoundValue ? null : Labelise(i.LowerBoundValue), i.Unit, !i.SetPointValue ? null : Labelise(i.SetPointValue)],
  4166981789: (i) => [i.Name, i.Specification, !i.EnumerationValues ? null : i.EnumerationValues.map((p) => Labelise(p)), i.EnumerationReference],
  2752243245: (i) => [i.Name, i.Specification, !i.ListValues ? null : i.ListValues.map((p) => Labelise(p)), i.Unit],
  941946838: (i) => [i.Name, i.Specification, i.UsageName, i.PropertyReference],
  1451395588: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.HasProperties],
  492091185: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.TemplateType, i.ApplicableEntity, i.HasPropertyTemplates],
  3650150729: (i) => [i.Name, i.Specification, !i.NominalValue ? null : Labelise(i.NominalValue), i.Unit],
  110355661: (i) => [i.Name, i.Specification, !i.DefiningValues ? null : i.DefiningValues.map((p) => Labelise(p)), !i.DefinedValues ? null : i.DefinedValues.map((p) => Labelise(p)), i.Expression, i.DefiningUnit, i.DefinedUnit, i.CurveInterpolation],
  3521284610: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  2770003689: (i) => [i.ProfileType, i.ProfileName, i.Position, i.XDim, i.YDim, i.WallThickness, i.InnerFilletRadius, i.OuterFilletRadius],
  2798486643: (i) => [i.Position, i.XLength, i.YLength, i.Height],
  3454111270: (i) => [i.BasisSurface, i.U1, i.V1, i.U2, i.V2, { type: 3, value: BooleanConvert(i.Usense.value) }, { type: 3, value: BooleanConvert(i.Vsense.value) }],
  3765753017: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.DefinitionType, i.ReinforcementSectionDefinitions],
  3939117080: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType],
  1683148259: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingActor, i.ActingRole],
  2495723537: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingControl],
  1307041759: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingGroup],
  1027710054: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingGroup, i.Factor],
  4278684876: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingProcess, i.QuantityInProcess],
  2857406711: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingProduct],
  205026976: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingResource],
  1865459582: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects],
  4095574036: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingApproval],
  919958153: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingClassification],
  2728634034: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.Intent, i.RelatingConstraint],
  982818633: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingDocument],
  3840914261: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingLibrary],
  2655215786: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingMaterial],
  1033248425: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingProfileDef],
  826625072: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  1204542856: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ConnectionGeometry, i.RelatingElement, i.RelatedElement],
  3945020480: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ConnectionGeometry, i.RelatingElement, i.RelatedElement, i.RelatingPriorities, i.RelatedPriorities, i.RelatedConnectionType, i.RelatingConnectionType],
  4201705270: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingPort, i.RelatedElement],
  3190031847: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingPort, i.RelatedPort, i.RealizingElement],
  2127690289: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingElement, i.RelatedStructuralActivity],
  1638771189: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingStructuralMember, i.RelatedStructuralConnection, i.AppliedCondition, i.AdditionalConditions, i.SupportedLength, i.ConditionCoordinateSystem],
  504942748: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingStructuralMember, i.RelatedStructuralConnection, i.AppliedCondition, i.AdditionalConditions, i.SupportedLength, i.ConditionCoordinateSystem, i.ConnectionConstraint],
  3678494232: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ConnectionGeometry, i.RelatingElement, i.RelatedElement, i.RealizingElements, i.ConnectionType],
  3242617779: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedElements, i.RelatingStructure],
  886880790: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingBuildingElement, i.RelatedCoverings],
  2802773753: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingSpace, i.RelatedCoverings],
  2565941209: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingContext, i.RelatedDefinitions],
  2551354335: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  693640335: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  1462361463: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingObject],
  4186316022: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingPropertyDefinition],
  307848117: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedPropertySets, i.RelatingTemplate],
  781010003: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingType],
  3940055652: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingOpeningElement, i.RelatedBuildingElement],
  279856033: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedControlElements, i.RelatingFlowElement],
  427948657: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingElement, i.RelatedElement, i.InterferenceGeometry, i.InterferenceSpace, i.InterferenceType, { type: 3, value: BooleanConvert(i.ImpliedOrder.value) }],
  3268803585: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingObject, i.RelatedObjects],
  1441486842: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingPositioningElement, i.RelatedProducts],
  750771296: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingElement, i.RelatedFeatureElement],
  1245217292: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedElements, i.RelatingStructure],
  4122056220: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingProcess, i.RelatedProcess, i.TimeLag, i.SequenceType, i.UserDefinedSequenceType],
  366585022: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingSystem, i.RelatedBuildings],
  3451746338: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingSpace, i.RelatedBuildingElement, i.ConnectionGeometry, i.PhysicalOrVirtualBoundary, i.InternalOrExternalBoundary],
  3523091289: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingSpace, i.RelatedBuildingElement, i.ConnectionGeometry, i.PhysicalOrVirtualBoundary, i.InternalOrExternalBoundary, i.ParentBoundary],
  1521410863: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingSpace, i.RelatedBuildingElement, i.ConnectionGeometry, i.PhysicalOrVirtualBoundary, i.InternalOrExternalBoundary, i.ParentBoundary, i.CorrespondingBoundary],
  1401173127: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingBuildingElement, i.RelatedOpeningElement],
  816062949: (i) => [i.Transition, { type: 3, value: BooleanConvert(i.SameSense.value) }, i.ParentCurve, i.ParamLength],
  2914609552: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription],
  1856042241: (i) => [i.SweptArea, i.Position, i.Axis, i.Angle],
  3243963512: (i) => [i.SweptArea, i.Position, i.Axis, i.Angle, i.EndSweptArea],
  4158566097: (i) => [i.Position, i.Height, i.BottomRadius],
  3626867408: (i) => [i.Position, i.Height, i.Radius],
  1862484736: (i) => [i.Directrix, i.CrossSections],
  1290935644: (i) => [i.Directrix, i.CrossSections, i.CrossSectionPositions],
  1356537516: (i) => [i.Directrix, i.CrossSectionPositions, i.CrossSections],
  3663146110: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.TemplateType, i.PrimaryMeasureType, i.SecondaryMeasureType, i.Enumerators, i.PrimaryUnit, i.SecondaryUnit, i.Expression, i.AccessState],
  1412071761: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName],
  710998568: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  2706606064: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType],
  3893378262: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  463610769: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.PredefinedType],
  2481509218: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.LongName],
  451544542: (i) => [i.Position, i.Radius],
  4015995234: (i) => [i.Position, i.Radius],
  2735484536: (i) => [i.Position],
  3544373492: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal],
  3136571912: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation],
  530289379: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation],
  3689010777: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal],
  3979015343: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType, i.Thickness],
  2218152070: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType, i.Thickness],
  603775116: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.PredefinedType],
  4095615324: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  699246055: (i) => [i.Curve3D, i.AssociatedGeometry, i.MasterRepresentation],
  2028607225: (i) => [i.SweptArea, i.Position, i.Directrix, !i.StartParam ? null : Labelise(i.StartParam), !i.EndParam ? null : Labelise(i.EndParam), i.ReferenceSurface],
  2809605785: (i) => [i.SweptCurve, i.Position, i.ExtrudedDirection, i.Depth],
  4124788165: (i) => [i.SweptCurve, i.Position, i.AxisPosition],
  1580310250: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3473067441: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Status, i.WorkMethod, { type: 3, value: BooleanConvert(i.IsMilestone.value) }, i.Priority, i.TaskTime, i.PredefinedType],
  3206491090: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ProcessType, i.PredefinedType, i.WorkMethod],
  2387106220: (i) => [i.Coordinates, i.Closed == null ? null : { type: 3, value: BooleanConvert(i.Closed.value) }],
  782932809: (i) => [i.Position, i.CubicTerm, i.QuadraticTerm, i.LinearTerm, i.ConstantTerm],
  1935646853: (i) => [i.Position, i.MajorRadius, i.MinorRadius],
  3665877780: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  2916149573: (i) => [i.Coordinates, i.Closed == null ? null : { type: 3, value: BooleanConvert(i.Closed.value) }, i.Normals, i.CoordIndex, i.PnIndex],
  1229763772: (i) => [i.Coordinates, i.Closed == null ? null : { type: 3, value: BooleanConvert(i.Closed.value) }, i.Normals, i.CoordIndex, i.PnIndex, i.Flags],
  3651464721: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  336235671: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.LiningDepth, i.LiningThickness, i.TransomThickness, i.MullionThickness, i.FirstTransomOffset, i.SecondTransomOffset, i.FirstMullionOffset, i.SecondMullionOffset, i.ShapeAspectStyle, i.LiningOffset, i.LiningToPanelOffsetX, i.LiningToPanelOffsetY],
  512836454: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.OperationType, i.PanelPosition, i.FrameDepth, i.FrameThickness, i.ShapeAspectStyle],
  2296667514: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.TheActor],
  1635779807: (i) => [i.Outer],
  2603310189: (i) => [i.Outer, i.Voids],
  1674181508: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType],
  2887950389: (i) => [i.UDegree, i.VDegree, i.ControlPointsList, i.SurfaceForm, { type: 3, value: BooleanConvert(i.UClosed.value) }, { type: 3, value: BooleanConvert(i.VClosed.value) }, { type: 3, value: BooleanConvert(i.SelfIntersect.value) }],
  167062518: (i) => [i.UDegree, i.VDegree, i.ControlPointsList, i.SurfaceForm, { type: 3, value: BooleanConvert(i.UClosed.value) }, { type: 3, value: BooleanConvert(i.VClosed.value) }, { type: 3, value: BooleanConvert(i.SelfIntersect.value) }, i.UMultiplicities, i.VMultiplicities, i.UKnots, i.VKnots, i.KnotSpec],
  1334484129: (i) => [i.Position, i.XLength, i.YLength, i.ZLength],
  3649129432: (i) => [i.Operator, i.FirstOperand, i.SecondOperand],
  1260505505: (_) => [],
  3124254112: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.Elevation],
  1626504194: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  2197970202: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2937912522: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Radius, i.WallThickness],
  3893394355: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  3497074424: (i) => [i.Position, i.ClothoidConstant],
  300633059: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3875453745: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.UsageName, i.TemplateType, i.HasPropertyTemplates],
  3732776249: (i) => [i.Segments, { type: 3, value: BooleanConvert(i.SelfIntersect.value) }],
  15328376: (i) => [i.Segments, { type: 3, value: BooleanConvert(i.SelfIntersect.value) }],
  2510884976: (i) => [i.Position],
  2185764099: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  4105962743: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  1525564444: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  2559216714: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity],
  3293443760: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification],
  2000195564: (i) => [i.Position, i.CosineTerm, i.ConstantTerm],
  3895139033: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.PredefinedType, i.CostValues, i.CostQuantities],
  1419761937: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.PredefinedType, i.Status, i.SubmittedOn, i.UpdateDate],
  4189326743: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1916426348: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3295246426: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  1457835157: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1213902940: (i) => [i.Position, i.Radius],
  1306400036: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  4234616927: (i) => [i.SweptArea, i.Position, i.Directrix, !i.StartParam ? null : Labelise(i.StartParam), !i.EndParam ? null : Labelise(i.EndParam), i.FixedReference],
  3256556792: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  3849074793: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  2963535650: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.LiningDepth, i.LiningThickness, i.ThresholdDepth, i.ThresholdThickness, i.TransomThickness, i.TransomOffset, i.LiningOffset, i.ThresholdOffset, i.CasingThickness, i.CasingDepth, i.ShapeAspectStyle, i.LiningToPanelOffsetX, i.LiningToPanelOffsetY],
  1714330368: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.PanelDepth, i.PanelOperation, i.PanelWidth, i.PanelPosition, i.ShapeAspectStyle],
  2323601079: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.OperationType, i.ParameterTakesPrecedence == null ? null : { type: 3, value: BooleanConvert(i.ParameterTakesPrecedence.value) }, i.UserDefinedOperationType],
  445594917: (i) => [i.Name],
  4006246654: (i) => [i.Name],
  1758889154: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  4123344466: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.AssemblyPlace, i.PredefinedType],
  2397081782: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1623761950: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2590856083: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  1704287377: (i) => [i.Position, i.SemiAxis1, i.SemiAxis2],
  2107101300: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  132023988: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3174744832: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3390157468: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4148101412: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.PredefinedType, i.EventTriggerType, i.UserDefinedEventTriggerType, i.EventOccurenceTime],
  2853485674: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName],
  807026263: (i) => [i.Outer],
  3737207727: (i) => [i.Outer, i.Voids],
  24185140: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType],
  1310830890: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.UsageType],
  4228831410: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.UsageType, i.PredefinedType],
  647756555: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2489546625: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2827207264: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2143335405: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  1287392070: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3907093117: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  3198132628: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  3815607619: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1482959167: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  1834744321: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  1339347760: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  2297155007: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  3009222698: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  1893162501: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  263784265: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  1509553395: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3493046030: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4230923436: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  1594536857: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2898700619: (i) => [i.Segments, { type: 3, value: BooleanConvert(i.SelfIntersect.value) }, i.BaseCurve, i.EndPoint],
  2706460486: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType],
  1251058090: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1806887404: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2568555532: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3948183225: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2571569899: (i) => [i.Points, !i.Segments ? null : i.Segments.map((p) => Labelise(p)), { type: 3, value: BooleanConvert(i.SelfIntersect.value) }],
  3946677679: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3113134337: (i) => [i.Curve3D, i.AssociatedGeometry, i.MasterRepresentation],
  2391368822: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PredefinedType, i.Jurisdiction, i.ResponsiblePersons, i.LastUpdateDate, i.CurrentValue, i.OriginalValue],
  4288270099: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  679976338: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, { type: 3, value: BooleanConvert(i.Mountable.value) }],
  3827777499: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  1051575348: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1161773419: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2176059722: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation],
  1770583370: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  525669439: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.PredefinedType],
  976884017: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.UsageType, i.PredefinedType],
  377706215: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.NominalDiameter, i.NominalLength, i.PredefinedType],
  2108223431: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.NominalDiameter, i.NominalLength],
  1114901282: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3181161470: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1950438474: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  710110818: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  977012517: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  506776471: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4143007308: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.TheActor, i.PredefinedType],
  3588315303: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2837617999: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  514975943: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2382730787: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LifeCyclePhase, i.PredefinedType],
  3566463478: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.OperationType, i.PanelPosition, i.FrameDepth, i.FrameThickness, i.ShapeAspectStyle],
  3327091369: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.PredefinedType, i.Status, i.LongDescription],
  1158309216: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  804291784: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4231323485: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4017108033: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2839578677: (i) => [i.Coordinates, i.Closed == null ? null : { type: 3, value: BooleanConvert(i.Closed.value) }, i.Faces, i.PnIndex],
  3724593414: (i) => [i.Points],
  3740093272: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation],
  1946335990: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation],
  2744685151: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.PredefinedType],
  2904328755: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.PredefinedType, i.Status, i.LongDescription],
  3651124850: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1842657554: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2250791053: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1763565496: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2893384427: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3992365140: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.PredefinedType],
  1891881377: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.UsageType, i.PredefinedType],
  2324767716: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1469900589: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  683857671: (i) => [i.UDegree, i.VDegree, i.ControlPointsList, i.SurfaceForm, { type: 3, value: BooleanConvert(i.UClosed.value) }, { type: 3, value: BooleanConvert(i.VClosed.value) }, { type: 3, value: BooleanConvert(i.SelfIntersect.value) }, i.UMultiplicities, i.VMultiplicities, i.UKnots, i.VKnots, i.KnotSpec, i.WeightsData],
  4021432810: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType],
  3027567501: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade],
  964333572: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  2320036040: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade, i.MeshLength, i.MeshWidth, i.LongitudinalBarNominalDiameter, i.TransverseBarNominalDiameter, i.LongitudinalBarCrossSectionArea, i.TransverseBarCrossSectionArea, i.LongitudinalBarSpacing, i.TransverseBarSpacing, i.PredefinedType],
  2310774935: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.MeshLength, i.MeshWidth, i.LongitudinalBarNominalDiameter, i.TransverseBarNominalDiameter, i.LongitudinalBarCrossSectionArea, i.TransverseBarCrossSectionArea, i.LongitudinalBarSpacing, i.TransverseBarSpacing, i.BendingShapeCode, !i.BendingParameters ? null : i.BendingParameters.map((p) => Labelise(p))],
  3818125796: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingElement, i.RelatedSurfaceFeatures],
  160246688: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingObject, i.RelatedObjects],
  146592293: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.PredefinedType],
  550521510: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.UsageType, i.PredefinedType],
  2781568857: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1768891740: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2157484638: (i) => [i.Curve3D, i.AssociatedGeometry, i.MasterRepresentation],
  3649235739: (i) => [i.Position, i.QuadraticTerm, i.LinearTerm, i.ConstantTerm],
  544395925: (i) => [i.Segments, { type: 3, value: BooleanConvert(i.SelfIntersect.value) }, i.BaseCurve, i.EndPoint],
  1027922057: (i) => [i.Position, i.SepticTerm, i.SexticTerm, i.QuinticTerm, i.QuarticTerm, i.CubicTerm, i.QuadraticTerm, i.LinearTerm, i.ConstantTerm],
  4074543187: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  33720170: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3599934289: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1894708472: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  42703149: (i) => [i.Position, i.SineTerm, i.LinearTerm, i.ConstantTerm],
  4097777520: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.RefLatitude, i.RefLongitude, i.RefElevation, i.LandTitleNumber, i.SiteAddress],
  2533589738: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1072016465: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3856911033: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.PredefinedType, i.ElevationWithFlooring],
  1305183839: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3812236995: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.LongName],
  3112655638: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1039846685: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  338393293: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  682877961: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad == null ? null : { type: 3, value: BooleanConvert(i.DestabilizingLoad.value) }],
  1179482911: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedCondition],
  1004757350: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad == null ? null : { type: 3, value: BooleanConvert(i.DestabilizingLoad.value) }, i.ProjectedOrTrue, i.PredefinedType],
  4243806635: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedCondition, i.AxisDirection],
  214636428: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType, i.Axis],
  2445595289: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType, i.Axis],
  2757150158: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.PredefinedType],
  1807405624: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad == null ? null : { type: 3, value: BooleanConvert(i.DestabilizingLoad.value) }, i.ProjectedOrTrue, i.PredefinedType],
  1252848954: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PredefinedType, i.ActionType, i.ActionSource, i.Coefficient, i.Purpose],
  2082059205: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad == null ? null : { type: 3, value: BooleanConvert(i.DestabilizingLoad.value) }],
  734778138: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedCondition, i.ConditionCoordinateSystem],
  1235345126: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal],
  2986769608: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.TheoryType, i.ResultForLoadGroup, { type: 3, value: BooleanConvert(i.IsLinear.value) }],
  3657597509: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad == null ? null : { type: 3, value: BooleanConvert(i.DestabilizingLoad.value) }, i.ProjectedOrTrue, i.PredefinedType],
  1975003073: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedCondition],
  148013059: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  3101698114: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2315554128: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2254336722: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType],
  413509423: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  5716631: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3824725483: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade, i.PredefinedType, i.NominalDiameter, i.CrossSectionArea, i.TensionForce, i.PreStress, i.FrictionCoefficient, i.AnchorageSlip, i.MinCurvatureRadius],
  2347447852: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade, i.PredefinedType],
  3081323446: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3663046924: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade, i.PredefinedType],
  2281632017: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2415094496: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.NominalDiameter, i.CrossSectionArea, i.SheathDiameter],
  618700268: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1692211062: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2097647324: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1953115116: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3593883385: (i) => [i.BasisCurve, i.Trim1, i.Trim2, { type: 3, value: BooleanConvert(i.SenseAgreement.value) }, i.MasterRepresentation],
  1600972822: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1911125066: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  728799441: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  840318589: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1530820697: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3956297820: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2391383451: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3313531582: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2769231204: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  926996030: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1898987631: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1133259667: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4009809668: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.PartitioningType, i.ParameterTakesPrecedence == null ? null : { type: 3, value: BooleanConvert(i.ParameterTakesPrecedence.value) }, i.UserDefinedPartitioningType],
  4088093105: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.WorkingTimes, i.ExceptionTimes, i.PredefinedType],
  1028945134: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.CreationDate, i.Creators, i.Purpose, i.Duration, i.TotalFloat, i.StartTime, i.FinishTime],
  4218914973: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.CreationDate, i.Creators, i.Purpose, i.Duration, i.TotalFloat, i.StartTime, i.FinishTime, i.PredefinedType],
  3342526732: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.CreationDate, i.Creators, i.Purpose, i.Duration, i.TotalFloat, i.StartTime, i.FinishTime, i.PredefinedType],
  1033361043: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LongName],
  3821786052: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.PredefinedType, i.Status, i.LongDescription],
  1411407467: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3352864051: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1871374353: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4266260250: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.RailHeadDistance],
  1545765605: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation],
  317615605: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.DesignParameters],
  1662888072: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation],
  3460190687: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.OriginalValue, i.CurrentValue, i.TotalReplacementCost, i.Owner, i.User, i.ResponsiblePerson, i.IncorporationDate, i.DepreciatedValue],
  1532957894: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1967976161: (i) => [i.Degree, i.ControlPointsList, i.CurveForm, { type: 3, value: BooleanConvert(i.ClosedCurve.value) }, { type: 3, value: BooleanConvert(i.SelfIntersect.value) }],
  2461110595: (i) => [i.Degree, i.ControlPointsList, i.CurveForm, { type: 3, value: BooleanConvert(i.ClosedCurve.value) }, { type: 3, value: BooleanConvert(i.SelfIntersect.value) }, i.KnotMultiplicities, i.Knots, i.KnotSpec],
  819618141: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3649138523: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  231477066: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1136057603: (i) => [i.Segments, { type: 3, value: BooleanConvert(i.SelfIntersect.value) }],
  644574406: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.PredefinedType],
  963979645: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.UsageType, i.PredefinedType],
  4031249490: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.ElevationOfRefHeight, i.ElevationOfTerrain, i.BuildingAddress],
  2979338954: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  39481116: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1909888760: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1177604601: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PredefinedType, i.LongName],
  1876633798: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3862327254: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PredefinedType, i.LongName],
  2188180465: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  395041908: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3293546465: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2674252688: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1285652485: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3203706013: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2951183804: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3296154744: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2611217952: (i) => [i.Position, i.Radius],
  1677625105: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2301859152: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  843113511: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  400855858: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3850581409: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2816379211: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3898045240: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  1060000209: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  488727124: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  2940368186: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  335055490: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2954562838: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1502416096: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1973544240: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3495092785: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3961806047: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3426335179: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  1335981549: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2635815018: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  479945903: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1599208980: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2063403501: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  1945004755: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3040386961: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3041715199: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.FlowDirection, i.PredefinedType, i.SystemType],
  3205830791: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LongName, i.PredefinedType],
  395920057: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.OverallHeight, i.OverallWidth, i.PredefinedType, i.OperationType, i.UserDefinedOperationType],
  869906466: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3760055223: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2030761528: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3071239417: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1077100507: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3376911765: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  663422040: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2417008758: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3277789161: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2142170206: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1534661035: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1217240411: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  712377611: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1658829314: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2814081492: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3747195512: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  484807127: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1209101575: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.PredefinedType],
  346874300: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1810631287: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4222183408: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2058353004: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  4278956645: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  4037862832: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2188021234: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3132237377: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  987401354: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  707683696: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2223149337: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3508470533: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  900683007: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2713699986: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3009204131: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.UAxes, i.VAxes, i.WAxes, i.PredefinedType],
  3319311131: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2068733104: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4175244083: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2176052936: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2696325953: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, { type: 3, value: BooleanConvert(i.Mountable.value) }],
  76236018: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  629592764: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1154579445: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation],
  1638804497: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1437502449: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1073191201: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2078563270: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  234836483: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2474470126: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2182337498: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  144952367: (i) => [i.Segments, { type: 3, value: BooleanConvert(i.SelfIntersect.value) }],
  3694346114: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1383356374: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1687234759: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType, i.ConstructionType],
  310824031: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3612865200: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3171933400: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  738039164: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  655969474: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  90941305: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3290496277: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2262370178: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3024970846: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3283111854: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1232101972: (i) => [i.Degree, i.ControlPointsList, i.CurveForm, { type: 3, value: BooleanConvert(i.ClosedCurve.value) }, { type: 3, value: BooleanConvert(i.SelfIntersect.value) }, i.KnotMultiplicities, i.Knots, i.KnotSpec, i.WeightsData],
  3798194928: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  979691226: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade, i.NominalDiameter, i.CrossSectionArea, i.BarLength, i.PredefinedType, i.BarSurface],
  2572171363: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.NominalDiameter, i.CrossSectionArea, i.BarLength, i.BarSurface, i.BendingShapeCode, !i.BendingParameters ? null : i.BendingParameters.map((p) => Labelise(p))],
  2016517767: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3053780830: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1783015770: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1329646415: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  991950508: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1529196076: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3420628829: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1999602285: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1404847402: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  331165859: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4252922144: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.NumberOfRisers, i.NumberOfTreads, i.RiserHeight, i.TreadLength, i.PredefinedType],
  2515109513: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PredefinedType, i.OrientationOf2DPlane, i.LoadedBy, i.HasResults, i.SharedPlacement],
  385403989: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PredefinedType, i.ActionType, i.ActionSource, i.Coefficient, i.Purpose, i.SelfWeightCoefficients],
  1621171031: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad == null ? null : { type: 3, value: BooleanConvert(i.DestabilizingLoad.value) }, i.ProjectedOrTrue, i.PredefinedType],
  1162798199: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  812556717: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3425753595: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3825984169: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1620046519: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3026737570: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3179687236: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4292641817: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4207607924: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2391406946: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3512223829: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4237592921: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3304561284: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.OverallHeight, i.OverallWidth, i.PredefinedType, i.PartitioningType, i.UserDefinedPartitioningType],
  2874132201: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1634111441: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  177149247: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2056796094: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3001207471: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  325726236: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType],
  277319702: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  753842376: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4196446775: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  32344328: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3314249567: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  1095909175: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2938176219: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  635142910: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3758799889: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1051757585: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4217484030: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3999819293: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3902619387: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  639361253: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3221913625: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3571504051: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2272882330: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  578613899: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3460952963: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4136498852: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3640358203: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4074379575: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3693000487: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1052013943: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  562808652: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LongName, i.PredefinedType],
  1062813311: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  342316401: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3518393246: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1360408905: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1904799276: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  862014818: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3310460725: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  24726584: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  264262732: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  402227799: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1003880860: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3415622556: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  819412036: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1426591983: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  182646315: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2680139844: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  1971632696: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2295281155: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4086658281: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  630975310: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4288193352: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3087945054: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  25142252: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType]
};
TypeInitialisers[3] = {
  3699917729: (v) => new IFC4X3.IfcAbsorbedDoseMeasure(v),
  4182062534: (v) => new IFC4X3.IfcAccelerationMeasure(v),
  360377573: (v) => new IFC4X3.IfcAmountOfSubstanceMeasure(v),
  632304761: (v) => new IFC4X3.IfcAngularVelocityMeasure(v),
  3683503648: (v) => new IFC4X3.IfcArcIndex(v.map((x) => x.value)),
  1500781891: (v) => new IFC4X3.IfcAreaDensityMeasure(v),
  2650437152: (v) => new IFC4X3.IfcAreaMeasure(v),
  2314439260: (v) => new IFC4X3.IfcBinary(v),
  2735952531: (v) => new IFC4X3.IfcBoolean(v),
  1867003952: (v) => new IFC4X3.IfcBoxAlignment(v),
  1683019596: (v) => new IFC4X3.IfcCardinalPointReference(v),
  2991860651: (v) => new IFC4X3.IfcComplexNumber(v.map((x) => x.value)),
  3812528620: (v) => new IFC4X3.IfcCompoundPlaneAngleMeasure(v.map((x) => x.value)),
  3238673880: (v) => new IFC4X3.IfcContextDependentMeasure(v),
  1778710042: (v) => new IFC4X3.IfcCountMeasure(v),
  94842927: (v) => new IFC4X3.IfcCurvatureMeasure(v),
  937566702: (v) => new IFC4X3.IfcDate(v),
  2195413836: (v) => new IFC4X3.IfcDateTime(v),
  86635668: (v) => new IFC4X3.IfcDayInMonthNumber(v),
  3701338814: (v) => new IFC4X3.IfcDayInWeekNumber(v),
  1514641115: (v) => new IFC4X3.IfcDescriptiveMeasure(v),
  4134073009: (v) => new IFC4X3.IfcDimensionCount(v),
  524656162: (v) => new IFC4X3.IfcDoseEquivalentMeasure(v),
  2541165894: (v) => new IFC4X3.IfcDuration(v),
  69416015: (v) => new IFC4X3.IfcDynamicViscosityMeasure(v),
  1827137117: (v) => new IFC4X3.IfcElectricCapacitanceMeasure(v),
  3818826038: (v) => new IFC4X3.IfcElectricChargeMeasure(v),
  2093906313: (v) => new IFC4X3.IfcElectricConductanceMeasure(v),
  3790457270: (v) => new IFC4X3.IfcElectricCurrentMeasure(v),
  2951915441: (v) => new IFC4X3.IfcElectricResistanceMeasure(v),
  2506197118: (v) => new IFC4X3.IfcElectricVoltageMeasure(v),
  2078135608: (v) => new IFC4X3.IfcEnergyMeasure(v),
  1102727119: (v) => new IFC4X3.IfcFontStyle(v),
  2715512545: (v) => new IFC4X3.IfcFontVariant(v),
  2590844177: (v) => new IFC4X3.IfcFontWeight(v),
  1361398929: (v) => new IFC4X3.IfcForceMeasure(v),
  3044325142: (v) => new IFC4X3.IfcFrequencyMeasure(v),
  3064340077: (v) => new IFC4X3.IfcGloballyUniqueId(v),
  3113092358: (v) => new IFC4X3.IfcHeatFluxDensityMeasure(v),
  1158859006: (v) => new IFC4X3.IfcHeatingValueMeasure(v),
  983778844: (v) => new IFC4X3.IfcIdentifier(v),
  3358199106: (v) => new IFC4X3.IfcIlluminanceMeasure(v),
  2679005408: (v) => new IFC4X3.IfcInductanceMeasure(v),
  1939436016: (v) => new IFC4X3.IfcInteger(v),
  3809634241: (v) => new IFC4X3.IfcIntegerCountRateMeasure(v),
  3686016028: (v) => new IFC4X3.IfcIonConcentrationMeasure(v),
  3192672207: (v) => new IFC4X3.IfcIsothermalMoistureCapacityMeasure(v),
  2054016361: (v) => new IFC4X3.IfcKinematicViscosityMeasure(v),
  3258342251: (v) => new IFC4X3.IfcLabel(v),
  1275358634: (v) => new IFC4X3.IfcLanguageId(v),
  1243674935: (v) => new IFC4X3.IfcLengthMeasure(v),
  1774176899: (v) => new IFC4X3.IfcLineIndex(v.map((x) => x.value)),
  191860431: (v) => new IFC4X3.IfcLinearForceMeasure(v),
  2128979029: (v) => new IFC4X3.IfcLinearMomentMeasure(v),
  1307019551: (v) => new IFC4X3.IfcLinearStiffnessMeasure(v),
  3086160713: (v) => new IFC4X3.IfcLinearVelocityMeasure(v),
  503418787: (v) => new IFC4X3.IfcLogical(v),
  2095003142: (v) => new IFC4X3.IfcLuminousFluxMeasure(v),
  2755797622: (v) => new IFC4X3.IfcLuminousIntensityDistributionMeasure(v),
  151039812: (v) => new IFC4X3.IfcLuminousIntensityMeasure(v),
  286949696: (v) => new IFC4X3.IfcMagneticFluxDensityMeasure(v),
  2486716878: (v) => new IFC4X3.IfcMagneticFluxMeasure(v),
  1477762836: (v) => new IFC4X3.IfcMassDensityMeasure(v),
  4017473158: (v) => new IFC4X3.IfcMassFlowRateMeasure(v),
  3124614049: (v) => new IFC4X3.IfcMassMeasure(v),
  3531705166: (v) => new IFC4X3.IfcMassPerLengthMeasure(v),
  3341486342: (v) => new IFC4X3.IfcModulusOfElasticityMeasure(v),
  2173214787: (v) => new IFC4X3.IfcModulusOfLinearSubgradeReactionMeasure(v),
  1052454078: (v) => new IFC4X3.IfcModulusOfRotationalSubgradeReactionMeasure(v),
  1753493141: (v) => new IFC4X3.IfcModulusOfSubgradeReactionMeasure(v),
  3177669450: (v) => new IFC4X3.IfcMoistureDiffusivityMeasure(v),
  1648970520: (v) => new IFC4X3.IfcMolecularWeightMeasure(v),
  3114022597: (v) => new IFC4X3.IfcMomentOfInertiaMeasure(v),
  2615040989: (v) => new IFC4X3.IfcMonetaryMeasure(v),
  765770214: (v) => new IFC4X3.IfcMonthInYearNumber(v),
  525895558: (v) => new IFC4X3.IfcNonNegativeLengthMeasure(v),
  2095195183: (v) => new IFC4X3.IfcNormalisedRatioMeasure(v),
  2395907400: (v) => new IFC4X3.IfcNumericMeasure(v),
  929793134: (v) => new IFC4X3.IfcPHMeasure(v),
  2260317790: (v) => new IFC4X3.IfcParameterValue(v),
  2642773653: (v) => new IFC4X3.IfcPlanarForceMeasure(v),
  4042175685: (v) => new IFC4X3.IfcPlaneAngleMeasure(v),
  1790229001: (v) => new IFC4X3.IfcPositiveInteger(v),
  2815919920: (v) => new IFC4X3.IfcPositiveLengthMeasure(v),
  3054510233: (v) => new IFC4X3.IfcPositivePlaneAngleMeasure(v),
  1245737093: (v) => new IFC4X3.IfcPositiveRatioMeasure(v),
  1364037233: (v) => new IFC4X3.IfcPowerMeasure(v),
  2169031380: (v) => new IFC4X3.IfcPresentableText(v),
  3665567075: (v) => new IFC4X3.IfcPressureMeasure(v),
  2798247006: (v) => new IFC4X3.IfcPropertySetDefinitionSet(v.map((x) => x.value)),
  3972513137: (v) => new IFC4X3.IfcRadioActivityMeasure(v),
  96294661: (v) => new IFC4X3.IfcRatioMeasure(v),
  200335297: (v) => new IFC4X3.IfcReal(v),
  2133746277: (v) => new IFC4X3.IfcRotationalFrequencyMeasure(v),
  1755127002: (v) => new IFC4X3.IfcRotationalMassMeasure(v),
  3211557302: (v) => new IFC4X3.IfcRotationalStiffnessMeasure(v),
  3467162246: (v) => new IFC4X3.IfcSectionModulusMeasure(v),
  2190458107: (v) => new IFC4X3.IfcSectionalAreaIntegralMeasure(v),
  408310005: (v) => new IFC4X3.IfcShearModulusMeasure(v),
  3471399674: (v) => new IFC4X3.IfcSolidAngleMeasure(v),
  4157543285: (v) => new IFC4X3.IfcSoundPowerLevelMeasure(v),
  846465480: (v) => new IFC4X3.IfcSoundPowerMeasure(v),
  3457685358: (v) => new IFC4X3.IfcSoundPressureLevelMeasure(v),
  993287707: (v) => new IFC4X3.IfcSoundPressureMeasure(v),
  3477203348: (v) => new IFC4X3.IfcSpecificHeatCapacityMeasure(v),
  2757832317: (v) => new IFC4X3.IfcSpecularExponent(v),
  361837227: (v) => new IFC4X3.IfcSpecularRoughness(v),
  58845555: (v) => new IFC4X3.IfcTemperatureGradientMeasure(v),
  1209108979: (v) => new IFC4X3.IfcTemperatureRateOfChangeMeasure(v),
  2801250643: (v) => new IFC4X3.IfcText(v),
  1460886941: (v) => new IFC4X3.IfcTextAlignment(v),
  3490877962: (v) => new IFC4X3.IfcTextDecoration(v),
  603696268: (v) => new IFC4X3.IfcTextFontName(v),
  296282323: (v) => new IFC4X3.IfcTextTransformation(v),
  232962298: (v) => new IFC4X3.IfcThermalAdmittanceMeasure(v),
  2645777649: (v) => new IFC4X3.IfcThermalConductivityMeasure(v),
  2281867870: (v) => new IFC4X3.IfcThermalExpansionCoefficientMeasure(v),
  857959152: (v) => new IFC4X3.IfcThermalResistanceMeasure(v),
  2016195849: (v) => new IFC4X3.IfcThermalTransmittanceMeasure(v),
  743184107: (v) => new IFC4X3.IfcThermodynamicTemperatureMeasure(v),
  4075327185: (v) => new IFC4X3.IfcTime(v),
  2726807636: (v) => new IFC4X3.IfcTimeMeasure(v),
  2591213694: (v) => new IFC4X3.IfcTimeStamp(v),
  1278329552: (v) => new IFC4X3.IfcTorqueMeasure(v),
  950732822: (v) => new IFC4X3.IfcURIReference(v),
  3345633955: (v) => new IFC4X3.IfcVaporPermeabilityMeasure(v),
  3458127941: (v) => new IFC4X3.IfcVolumeMeasure(v),
  2593997549: (v) => new IFC4X3.IfcVolumetricFlowRateMeasure(v),
  51269191: (v) => new IFC4X3.IfcWarpingConstantMeasure(v),
  1718600412: (v) => new IFC4X3.IfcWarpingMomentMeasure(v)
};
var IFC4X3;
((IFC4X32) => {
  class IfcAbsorbedDoseMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCABSORBEDDOSEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcAbsorbedDoseMeasure = IfcAbsorbedDoseMeasure;
  class IfcAccelerationMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCACCELERATIONMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcAccelerationMeasure = IfcAccelerationMeasure;
  class IfcAmountOfSubstanceMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCAMOUNTOFSUBSTANCEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcAmountOfSubstanceMeasure = IfcAmountOfSubstanceMeasure;
  class IfcAngularVelocityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCANGULARVELOCITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcAngularVelocityMeasure = IfcAngularVelocityMeasure;
  class IfcArcIndex {
    constructor(value) {
      this.value = value;
      this.type = 5;
    }
  }
  IFC4X32.IfcArcIndex = IfcArcIndex;
  ;
  class IfcAreaDensityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCAREADENSITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcAreaDensityMeasure = IfcAreaDensityMeasure;
  class IfcAreaMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCAREAMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcAreaMeasure = IfcAreaMeasure;
  class IfcBinary {
    constructor(v) {
      this.type = 4;
      this.name = "IFCBINARY";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcBinary = IfcBinary;
  class IfcBoolean {
    constructor(v) {
      this.type = 3;
      this.name = "IFCBOOLEAN";
      this.value = v === null ? v : v == "T" ? true : false;
    }
  }
  IFC4X32.IfcBoolean = IfcBoolean;
  class IfcBoxAlignment {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCBOXALIGNMENT";
    }
  }
  IFC4X32.IfcBoxAlignment = IfcBoxAlignment;
  class IfcCardinalPointReference {
    constructor(v) {
      this.type = 10;
      this.name = "IFCCARDINALPOINTREFERENCE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcCardinalPointReference = IfcCardinalPointReference;
  class IfcComplexNumber {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4X32.IfcComplexNumber = IfcComplexNumber;
  ;
  class IfcCompoundPlaneAngleMeasure {
    constructor(value) {
      this.value = value;
      this.type = 10;
    }
  }
  IFC4X32.IfcCompoundPlaneAngleMeasure = IfcCompoundPlaneAngleMeasure;
  ;
  class IfcContextDependentMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCCONTEXTDEPENDENTMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcContextDependentMeasure = IfcContextDependentMeasure;
  class IfcCountMeasure {
    constructor(v) {
      this.type = 10;
      this.name = "IFCCOUNTMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcCountMeasure = IfcCountMeasure;
  class IfcCurvatureMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCCURVATUREMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcCurvatureMeasure = IfcCurvatureMeasure;
  class IfcDate {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCDATE";
    }
  }
  IFC4X32.IfcDate = IfcDate;
  class IfcDateTime {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCDATETIME";
    }
  }
  IFC4X32.IfcDateTime = IfcDateTime;
  class IfcDayInMonthNumber {
    constructor(v) {
      this.type = 10;
      this.name = "IFCDAYINMONTHNUMBER";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcDayInMonthNumber = IfcDayInMonthNumber;
  class IfcDayInWeekNumber {
    constructor(v) {
      this.type = 10;
      this.name = "IFCDAYINWEEKNUMBER";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcDayInWeekNumber = IfcDayInWeekNumber;
  class IfcDescriptiveMeasure {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCDESCRIPTIVEMEASURE";
    }
  }
  IFC4X32.IfcDescriptiveMeasure = IfcDescriptiveMeasure;
  class IfcDimensionCount {
    constructor(v) {
      this.type = 10;
      this.name = "IFCDIMENSIONCOUNT";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcDimensionCount = IfcDimensionCount;
  class IfcDoseEquivalentMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCDOSEEQUIVALENTMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcDoseEquivalentMeasure = IfcDoseEquivalentMeasure;
  class IfcDuration {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCDURATION";
    }
  }
  IFC4X32.IfcDuration = IfcDuration;
  class IfcDynamicViscosityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCDYNAMICVISCOSITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcDynamicViscosityMeasure = IfcDynamicViscosityMeasure;
  class IfcElectricCapacitanceMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCELECTRICCAPACITANCEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcElectricCapacitanceMeasure = IfcElectricCapacitanceMeasure;
  class IfcElectricChargeMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCELECTRICCHARGEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcElectricChargeMeasure = IfcElectricChargeMeasure;
  class IfcElectricConductanceMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCELECTRICCONDUCTANCEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcElectricConductanceMeasure = IfcElectricConductanceMeasure;
  class IfcElectricCurrentMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCELECTRICCURRENTMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcElectricCurrentMeasure = IfcElectricCurrentMeasure;
  class IfcElectricResistanceMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCELECTRICRESISTANCEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcElectricResistanceMeasure = IfcElectricResistanceMeasure;
  class IfcElectricVoltageMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCELECTRICVOLTAGEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcElectricVoltageMeasure = IfcElectricVoltageMeasure;
  class IfcEnergyMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCENERGYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcEnergyMeasure = IfcEnergyMeasure;
  class IfcFontStyle {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCFONTSTYLE";
    }
  }
  IFC4X32.IfcFontStyle = IfcFontStyle;
  class IfcFontVariant {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCFONTVARIANT";
    }
  }
  IFC4X32.IfcFontVariant = IfcFontVariant;
  class IfcFontWeight {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCFONTWEIGHT";
    }
  }
  IFC4X32.IfcFontWeight = IfcFontWeight;
  class IfcForceMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCFORCEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcForceMeasure = IfcForceMeasure;
  class IfcFrequencyMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCFREQUENCYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcFrequencyMeasure = IfcFrequencyMeasure;
  class IfcGloballyUniqueId {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCGLOBALLYUNIQUEID";
    }
  }
  IFC4X32.IfcGloballyUniqueId = IfcGloballyUniqueId;
  class IfcHeatFluxDensityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCHEATFLUXDENSITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcHeatFluxDensityMeasure = IfcHeatFluxDensityMeasure;
  class IfcHeatingValueMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCHEATINGVALUEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcHeatingValueMeasure = IfcHeatingValueMeasure;
  class IfcIdentifier {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCIDENTIFIER";
    }
  }
  IFC4X32.IfcIdentifier = IfcIdentifier;
  class IfcIlluminanceMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCILLUMINANCEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcIlluminanceMeasure = IfcIlluminanceMeasure;
  class IfcInductanceMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCINDUCTANCEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcInductanceMeasure = IfcInductanceMeasure;
  class IfcInteger {
    constructor(v) {
      this.type = 10;
      this.name = "IFCINTEGER";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcInteger = IfcInteger;
  class IfcIntegerCountRateMeasure {
    constructor(v) {
      this.type = 10;
      this.name = "IFCINTEGERCOUNTRATEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcIntegerCountRateMeasure = IfcIntegerCountRateMeasure;
  class IfcIonConcentrationMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCIONCONCENTRATIONMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcIonConcentrationMeasure = IfcIonConcentrationMeasure;
  class IfcIsothermalMoistureCapacityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCISOTHERMALMOISTURECAPACITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcIsothermalMoistureCapacityMeasure = IfcIsothermalMoistureCapacityMeasure;
  class IfcKinematicViscosityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCKINEMATICVISCOSITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcKinematicViscosityMeasure = IfcKinematicViscosityMeasure;
  class IfcLabel {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCLABEL";
    }
  }
  IFC4X32.IfcLabel = IfcLabel;
  class IfcLanguageId {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCLANGUAGEID";
    }
  }
  IFC4X32.IfcLanguageId = IfcLanguageId;
  class IfcLengthMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCLENGTHMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcLengthMeasure = IfcLengthMeasure;
  class IfcLineIndex {
    constructor(value) {
      this.value = value;
      this.type = 5;
    }
  }
  IFC4X32.IfcLineIndex = IfcLineIndex;
  ;
  class IfcLinearForceMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCLINEARFORCEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcLinearForceMeasure = IfcLinearForceMeasure;
  class IfcLinearMomentMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCLINEARMOMENTMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcLinearMomentMeasure = IfcLinearMomentMeasure;
  class IfcLinearStiffnessMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCLINEARSTIFFNESSMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcLinearStiffnessMeasure = IfcLinearStiffnessMeasure;
  class IfcLinearVelocityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCLINEARVELOCITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcLinearVelocityMeasure = IfcLinearVelocityMeasure;
  class IfcLogical {
    constructor(v) {
      this.type = 3;
      this.name = "IFCLOGICAL";
      this.value = v === null ? v : v == "T" ? 1 /* TRUE */ : v == "F" ? 0 /* FALSE */ : 2 /* UNKNOWN */;
    }
  }
  IFC4X32.IfcLogical = IfcLogical;
  class IfcLuminousFluxMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCLUMINOUSFLUXMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcLuminousFluxMeasure = IfcLuminousFluxMeasure;
  class IfcLuminousIntensityDistributionMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCLUMINOUSINTENSITYDISTRIBUTIONMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcLuminousIntensityDistributionMeasure = IfcLuminousIntensityDistributionMeasure;
  class IfcLuminousIntensityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCLUMINOUSINTENSITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcLuminousIntensityMeasure = IfcLuminousIntensityMeasure;
  class IfcMagneticFluxDensityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMAGNETICFLUXDENSITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcMagneticFluxDensityMeasure = IfcMagneticFluxDensityMeasure;
  class IfcMagneticFluxMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMAGNETICFLUXMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcMagneticFluxMeasure = IfcMagneticFluxMeasure;
  class IfcMassDensityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMASSDENSITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcMassDensityMeasure = IfcMassDensityMeasure;
  class IfcMassFlowRateMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMASSFLOWRATEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcMassFlowRateMeasure = IfcMassFlowRateMeasure;
  class IfcMassMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMASSMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcMassMeasure = IfcMassMeasure;
  class IfcMassPerLengthMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMASSPERLENGTHMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcMassPerLengthMeasure = IfcMassPerLengthMeasure;
  class IfcModulusOfElasticityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMODULUSOFELASTICITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcModulusOfElasticityMeasure = IfcModulusOfElasticityMeasure;
  class IfcModulusOfLinearSubgradeReactionMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMODULUSOFLINEARSUBGRADEREACTIONMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcModulusOfLinearSubgradeReactionMeasure = IfcModulusOfLinearSubgradeReactionMeasure;
  class IfcModulusOfRotationalSubgradeReactionMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMODULUSOFROTATIONALSUBGRADEREACTIONMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcModulusOfRotationalSubgradeReactionMeasure = IfcModulusOfRotationalSubgradeReactionMeasure;
  class IfcModulusOfSubgradeReactionMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMODULUSOFSUBGRADEREACTIONMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcModulusOfSubgradeReactionMeasure = IfcModulusOfSubgradeReactionMeasure;
  class IfcMoistureDiffusivityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMOISTUREDIFFUSIVITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcMoistureDiffusivityMeasure = IfcMoistureDiffusivityMeasure;
  class IfcMolecularWeightMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMOLECULARWEIGHTMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcMolecularWeightMeasure = IfcMolecularWeightMeasure;
  class IfcMomentOfInertiaMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMOMENTOFINERTIAMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcMomentOfInertiaMeasure = IfcMomentOfInertiaMeasure;
  class IfcMonetaryMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCMONETARYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcMonetaryMeasure = IfcMonetaryMeasure;
  class IfcMonthInYearNumber {
    constructor(v) {
      this.type = 10;
      this.name = "IFCMONTHINYEARNUMBER";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcMonthInYearNumber = IfcMonthInYearNumber;
  class IfcNonNegativeLengthMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCNONNEGATIVELENGTHMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcNonNegativeLengthMeasure = IfcNonNegativeLengthMeasure;
  class IfcNormalisedRatioMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCNORMALISEDRATIOMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcNormalisedRatioMeasure = IfcNormalisedRatioMeasure;
  class IfcNumericMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCNUMERICMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcNumericMeasure = IfcNumericMeasure;
  class IfcPHMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCPHMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcPHMeasure = IfcPHMeasure;
  class IfcParameterValue {
    constructor(v) {
      this.type = 4;
      this.name = "IFCPARAMETERVALUE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcParameterValue = IfcParameterValue;
  class IfcPlanarForceMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCPLANARFORCEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcPlanarForceMeasure = IfcPlanarForceMeasure;
  class IfcPlaneAngleMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCPLANEANGLEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcPlaneAngleMeasure = IfcPlaneAngleMeasure;
  class IfcPositiveInteger {
    constructor(v) {
      this.type = 10;
      this.name = "IFCPOSITIVEINTEGER";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcPositiveInteger = IfcPositiveInteger;
  class IfcPositiveLengthMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCPOSITIVELENGTHMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcPositiveLengthMeasure = IfcPositiveLengthMeasure;
  class IfcPositivePlaneAngleMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCPOSITIVEPLANEANGLEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcPositivePlaneAngleMeasure = IfcPositivePlaneAngleMeasure;
  class IfcPositiveRatioMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCPOSITIVERATIOMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcPositiveRatioMeasure = IfcPositiveRatioMeasure;
  class IfcPowerMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCPOWERMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcPowerMeasure = IfcPowerMeasure;
  class IfcPresentableText {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCPRESENTABLETEXT";
    }
  }
  IFC4X32.IfcPresentableText = IfcPresentableText;
  class IfcPressureMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCPRESSUREMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcPressureMeasure = IfcPressureMeasure;
  class IfcPropertySetDefinitionSet {
    constructor(value) {
      this.value = value;
      this.type = 5;
    }
  }
  IFC4X32.IfcPropertySetDefinitionSet = IfcPropertySetDefinitionSet;
  ;
  class IfcRadioActivityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCRADIOACTIVITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcRadioActivityMeasure = IfcRadioActivityMeasure;
  class IfcRatioMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCRATIOMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcRatioMeasure = IfcRatioMeasure;
  class IfcReal {
    constructor(v) {
      this.type = 4;
      this.name = "IFCREAL";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcReal = IfcReal;
  class IfcRotationalFrequencyMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCROTATIONALFREQUENCYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcRotationalFrequencyMeasure = IfcRotationalFrequencyMeasure;
  class IfcRotationalMassMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCROTATIONALMASSMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcRotationalMassMeasure = IfcRotationalMassMeasure;
  class IfcRotationalStiffnessMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCROTATIONALSTIFFNESSMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcRotationalStiffnessMeasure = IfcRotationalStiffnessMeasure;
  class IfcSectionModulusMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCSECTIONMODULUSMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcSectionModulusMeasure = IfcSectionModulusMeasure;
  class IfcSectionalAreaIntegralMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCSECTIONALAREAINTEGRALMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcSectionalAreaIntegralMeasure = IfcSectionalAreaIntegralMeasure;
  class IfcShearModulusMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCSHEARMODULUSMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcShearModulusMeasure = IfcShearModulusMeasure;
  class IfcSolidAngleMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCSOLIDANGLEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcSolidAngleMeasure = IfcSolidAngleMeasure;
  class IfcSoundPowerLevelMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCSOUNDPOWERLEVELMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcSoundPowerLevelMeasure = IfcSoundPowerLevelMeasure;
  class IfcSoundPowerMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCSOUNDPOWERMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcSoundPowerMeasure = IfcSoundPowerMeasure;
  class IfcSoundPressureLevelMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCSOUNDPRESSURELEVELMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcSoundPressureLevelMeasure = IfcSoundPressureLevelMeasure;
  class IfcSoundPressureMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCSOUNDPRESSUREMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcSoundPressureMeasure = IfcSoundPressureMeasure;
  class IfcSpecificHeatCapacityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCSPECIFICHEATCAPACITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcSpecificHeatCapacityMeasure = IfcSpecificHeatCapacityMeasure;
  class IfcSpecularExponent {
    constructor(v) {
      this.type = 4;
      this.name = "IFCSPECULAREXPONENT";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcSpecularExponent = IfcSpecularExponent;
  class IfcSpecularRoughness {
    constructor(v) {
      this.type = 4;
      this.name = "IFCSPECULARROUGHNESS";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcSpecularRoughness = IfcSpecularRoughness;
  class IfcTemperatureGradientMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCTEMPERATUREGRADIENTMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcTemperatureGradientMeasure = IfcTemperatureGradientMeasure;
  class IfcTemperatureRateOfChangeMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCTEMPERATURERATEOFCHANGEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcTemperatureRateOfChangeMeasure = IfcTemperatureRateOfChangeMeasure;
  class IfcText {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCTEXT";
    }
  }
  IFC4X32.IfcText = IfcText;
  class IfcTextAlignment {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCTEXTALIGNMENT";
    }
  }
  IFC4X32.IfcTextAlignment = IfcTextAlignment;
  class IfcTextDecoration {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCTEXTDECORATION";
    }
  }
  IFC4X32.IfcTextDecoration = IfcTextDecoration;
  class IfcTextFontName {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCTEXTFONTNAME";
    }
  }
  IFC4X32.IfcTextFontName = IfcTextFontName;
  class IfcTextTransformation {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCTEXTTRANSFORMATION";
    }
  }
  IFC4X32.IfcTextTransformation = IfcTextTransformation;
  class IfcThermalAdmittanceMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCTHERMALADMITTANCEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcThermalAdmittanceMeasure = IfcThermalAdmittanceMeasure;
  class IfcThermalConductivityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCTHERMALCONDUCTIVITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcThermalConductivityMeasure = IfcThermalConductivityMeasure;
  class IfcThermalExpansionCoefficientMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCTHERMALEXPANSIONCOEFFICIENTMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcThermalExpansionCoefficientMeasure = IfcThermalExpansionCoefficientMeasure;
  class IfcThermalResistanceMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCTHERMALRESISTANCEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcThermalResistanceMeasure = IfcThermalResistanceMeasure;
  class IfcThermalTransmittanceMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCTHERMALTRANSMITTANCEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcThermalTransmittanceMeasure = IfcThermalTransmittanceMeasure;
  class IfcThermodynamicTemperatureMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCTHERMODYNAMICTEMPERATUREMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcThermodynamicTemperatureMeasure = IfcThermodynamicTemperatureMeasure;
  class IfcTime {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCTIME";
    }
  }
  IFC4X32.IfcTime = IfcTime;
  class IfcTimeMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCTIMEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcTimeMeasure = IfcTimeMeasure;
  class IfcTimeStamp {
    constructor(v) {
      this.type = 10;
      this.name = "IFCTIMESTAMP";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcTimeStamp = IfcTimeStamp;
  class IfcTorqueMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCTORQUEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcTorqueMeasure = IfcTorqueMeasure;
  class IfcURIReference {
    constructor(value) {
      this.value = value;
      this.type = 1;
      this.name = "IFCURIREFERENCE";
    }
  }
  IFC4X32.IfcURIReference = IfcURIReference;
  class IfcVaporPermeabilityMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCVAPORPERMEABILITYMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcVaporPermeabilityMeasure = IfcVaporPermeabilityMeasure;
  class IfcVolumeMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCVOLUMEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcVolumeMeasure = IfcVolumeMeasure;
  class IfcVolumetricFlowRateMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCVOLUMETRICFLOWRATEMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcVolumetricFlowRateMeasure = IfcVolumetricFlowRateMeasure;
  class IfcWarpingConstantMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCWARPINGCONSTANTMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcWarpingConstantMeasure = IfcWarpingConstantMeasure;
  class IfcWarpingMomentMeasure {
    constructor(v) {
      this.type = 4;
      this.name = "IFCWARPINGMOMENTMEASURE";
      this.value = v === null ? v : parseFloat(v);
    }
  }
  IFC4X32.IfcWarpingMomentMeasure = IfcWarpingMomentMeasure;
  class IfcActionRequestTypeEnum {
    static {
      this.EMAIL = { type: 3, value: "EMAIL" };
    }
    static {
      this.FAX = { type: 3, value: "FAX" };
    }
    static {
      this.PHONE = { type: 3, value: "PHONE" };
    }
    static {
      this.POST = { type: 3, value: "POST" };
    }
    static {
      this.VERBAL = { type: 3, value: "VERBAL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcActionRequestTypeEnum = IfcActionRequestTypeEnum;
  class IfcActionSourceTypeEnum {
    static {
      this.BRAKES = { type: 3, value: "BRAKES" };
    }
    static {
      this.BUOYANCY = { type: 3, value: "BUOYANCY" };
    }
    static {
      this.COMPLETION_G1 = { type: 3, value: "COMPLETION_G1" };
    }
    static {
      this.CREEP = { type: 3, value: "CREEP" };
    }
    static {
      this.CURRENT = { type: 3, value: "CURRENT" };
    }
    static {
      this.DEAD_LOAD_G = { type: 3, value: "DEAD_LOAD_G" };
    }
    static {
      this.EARTHQUAKE_E = { type: 3, value: "EARTHQUAKE_E" };
    }
    static {
      this.ERECTION = { type: 3, value: "ERECTION" };
    }
    static {
      this.FIRE = { type: 3, value: "FIRE" };
    }
    static {
      this.ICE = { type: 3, value: "ICE" };
    }
    static {
      this.IMPACT = { type: 3, value: "IMPACT" };
    }
    static {
      this.IMPULSE = { type: 3, value: "IMPULSE" };
    }
    static {
      this.LACK_OF_FIT = { type: 3, value: "LACK_OF_FIT" };
    }
    static {
      this.LIVE_LOAD_Q = { type: 3, value: "LIVE_LOAD_Q" };
    }
    static {
      this.PRESTRESSING_P = { type: 3, value: "PRESTRESSING_P" };
    }
    static {
      this.PROPPING = { type: 3, value: "PROPPING" };
    }
    static {
      this.RAIN = { type: 3, value: "RAIN" };
    }
    static {
      this.SETTLEMENT_U = { type: 3, value: "SETTLEMENT_U" };
    }
    static {
      this.SHRINKAGE = { type: 3, value: "SHRINKAGE" };
    }
    static {
      this.SNOW_S = { type: 3, value: "SNOW_S" };
    }
    static {
      this.SYSTEM_IMPERFECTION = { type: 3, value: "SYSTEM_IMPERFECTION" };
    }
    static {
      this.TEMPERATURE_T = { type: 3, value: "TEMPERATURE_T" };
    }
    static {
      this.TRANSPORT = { type: 3, value: "TRANSPORT" };
    }
    static {
      this.WAVE = { type: 3, value: "WAVE" };
    }
    static {
      this.WIND_W = { type: 3, value: "WIND_W" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcActionSourceTypeEnum = IfcActionSourceTypeEnum;
  class IfcActionTypeEnum {
    static {
      this.EXTRAORDINARY_A = { type: 3, value: "EXTRAORDINARY_A" };
    }
    static {
      this.PERMANENT_G = { type: 3, value: "PERMANENT_G" };
    }
    static {
      this.VARIABLE_Q = { type: 3, value: "VARIABLE_Q" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcActionTypeEnum = IfcActionTypeEnum;
  class IfcActuatorTypeEnum {
    static {
      this.ELECTRICACTUATOR = { type: 3, value: "ELECTRICACTUATOR" };
    }
    static {
      this.HANDOPERATEDACTUATOR = { type: 3, value: "HANDOPERATEDACTUATOR" };
    }
    static {
      this.HYDRAULICACTUATOR = { type: 3, value: "HYDRAULICACTUATOR" };
    }
    static {
      this.PNEUMATICACTUATOR = { type: 3, value: "PNEUMATICACTUATOR" };
    }
    static {
      this.THERMOSTATICACTUATOR = { type: 3, value: "THERMOSTATICACTUATOR" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcActuatorTypeEnum = IfcActuatorTypeEnum;
  class IfcAddressTypeEnum {
    static {
      this.DISTRIBUTIONPOINT = { type: 3, value: "DISTRIBUTIONPOINT" };
    }
    static {
      this.HOME = { type: 3, value: "HOME" };
    }
    static {
      this.OFFICE = { type: 3, value: "OFFICE" };
    }
    static {
      this.SITE = { type: 3, value: "SITE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
  }
  IFC4X32.IfcAddressTypeEnum = IfcAddressTypeEnum;
  class IfcAirTerminalBoxTypeEnum {
    static {
      this.CONSTANTFLOW = { type: 3, value: "CONSTANTFLOW" };
    }
    static {
      this.VARIABLEFLOWPRESSUREDEPENDANT = { type: 3, value: "VARIABLEFLOWPRESSUREDEPENDANT" };
    }
    static {
      this.VARIABLEFLOWPRESSUREINDEPENDANT = { type: 3, value: "VARIABLEFLOWPRESSUREINDEPENDANT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcAirTerminalBoxTypeEnum = IfcAirTerminalBoxTypeEnum;
  class IfcAirTerminalTypeEnum {
    static {
      this.DIFFUSER = { type: 3, value: "DIFFUSER" };
    }
    static {
      this.GRILLE = { type: 3, value: "GRILLE" };
    }
    static {
      this.LOUVRE = { type: 3, value: "LOUVRE" };
    }
    static {
      this.REGISTER = { type: 3, value: "REGISTER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcAirTerminalTypeEnum = IfcAirTerminalTypeEnum;
  class IfcAirToAirHeatRecoveryTypeEnum {
    static {
      this.FIXEDPLATECOUNTERFLOWEXCHANGER = { type: 3, value: "FIXEDPLATECOUNTERFLOWEXCHANGER" };
    }
    static {
      this.FIXEDPLATECROSSFLOWEXCHANGER = { type: 3, value: "FIXEDPLATECROSSFLOWEXCHANGER" };
    }
    static {
      this.FIXEDPLATEPARALLELFLOWEXCHANGER = { type: 3, value: "FIXEDPLATEPARALLELFLOWEXCHANGER" };
    }
    static {
      this.HEATPIPE = { type: 3, value: "HEATPIPE" };
    }
    static {
      this.ROTARYWHEEL = { type: 3, value: "ROTARYWHEEL" };
    }
    static {
      this.RUNAROUNDCOILLOOP = { type: 3, value: "RUNAROUNDCOILLOOP" };
    }
    static {
      this.THERMOSIPHONCOILTYPEHEATEXCHANGERS = { type: 3, value: "THERMOSIPHONCOILTYPEHEATEXCHANGERS" };
    }
    static {
      this.THERMOSIPHONSEALEDTUBEHEATEXCHANGERS = { type: 3, value: "THERMOSIPHONSEALEDTUBEHEATEXCHANGERS" };
    }
    static {
      this.TWINTOWERENTHALPYRECOVERYLOOPS = { type: 3, value: "TWINTOWERENTHALPYRECOVERYLOOPS" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcAirToAirHeatRecoveryTypeEnum = IfcAirToAirHeatRecoveryTypeEnum;
  class IfcAlarmTypeEnum {
    static {
      this.BELL = { type: 3, value: "BELL" };
    }
    static {
      this.BREAKGLASSBUTTON = { type: 3, value: "BREAKGLASSBUTTON" };
    }
    static {
      this.LIGHT = { type: 3, value: "LIGHT" };
    }
    static {
      this.MANUALPULLBOX = { type: 3, value: "MANUALPULLBOX" };
    }
    static {
      this.RAILWAYCROCODILE = { type: 3, value: "RAILWAYCROCODILE" };
    }
    static {
      this.RAILWAYDETONATOR = { type: 3, value: "RAILWAYDETONATOR" };
    }
    static {
      this.SIREN = { type: 3, value: "SIREN" };
    }
    static {
      this.WHISTLE = { type: 3, value: "WHISTLE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcAlarmTypeEnum = IfcAlarmTypeEnum;
  class IfcAlignmentCantSegmentTypeEnum {
    static {
      this.BLOSSCURVE = { type: 3, value: "BLOSSCURVE" };
    }
    static {
      this.CONSTANTCANT = { type: 3, value: "CONSTANTCANT" };
    }
    static {
      this.COSINECURVE = { type: 3, value: "COSINECURVE" };
    }
    static {
      this.HELMERTCURVE = { type: 3, value: "HELMERTCURVE" };
    }
    static {
      this.LINEARTRANSITION = { type: 3, value: "LINEARTRANSITION" };
    }
    static {
      this.SINECURVE = { type: 3, value: "SINECURVE" };
    }
    static {
      this.VIENNESEBEND = { type: 3, value: "VIENNESEBEND" };
    }
  }
  IFC4X32.IfcAlignmentCantSegmentTypeEnum = IfcAlignmentCantSegmentTypeEnum;
  class IfcAlignmentHorizontalSegmentTypeEnum {
    static {
      this.BLOSSCURVE = { type: 3, value: "BLOSSCURVE" };
    }
    static {
      this.CIRCULARARC = { type: 3, value: "CIRCULARARC" };
    }
    static {
      this.CLOTHOID = { type: 3, value: "CLOTHOID" };
    }
    static {
      this.COSINECURVE = { type: 3, value: "COSINECURVE" };
    }
    static {
      this.CUBIC = { type: 3, value: "CUBIC" };
    }
    static {
      this.HELMERTCURVE = { type: 3, value: "HELMERTCURVE" };
    }
    static {
      this.LINE = { type: 3, value: "LINE" };
    }
    static {
      this.SINECURVE = { type: 3, value: "SINECURVE" };
    }
    static {
      this.VIENNESEBEND = { type: 3, value: "VIENNESEBEND" };
    }
  }
  IFC4X32.IfcAlignmentHorizontalSegmentTypeEnum = IfcAlignmentHorizontalSegmentTypeEnum;
  class IfcAlignmentTypeEnum {
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcAlignmentTypeEnum = IfcAlignmentTypeEnum;
  class IfcAlignmentVerticalSegmentTypeEnum {
    static {
      this.CIRCULARARC = { type: 3, value: "CIRCULARARC" };
    }
    static {
      this.CLOTHOID = { type: 3, value: "CLOTHOID" };
    }
    static {
      this.CONSTANTGRADIENT = { type: 3, value: "CONSTANTGRADIENT" };
    }
    static {
      this.PARABOLICARC = { type: 3, value: "PARABOLICARC" };
    }
  }
  IFC4X32.IfcAlignmentVerticalSegmentTypeEnum = IfcAlignmentVerticalSegmentTypeEnum;
  class IfcAnalysisModelTypeEnum {
    static {
      this.IN_PLANE_LOADING_2D = { type: 3, value: "IN_PLANE_LOADING_2D" };
    }
    static {
      this.LOADING_3D = { type: 3, value: "LOADING_3D" };
    }
    static {
      this.OUT_PLANE_LOADING_2D = { type: 3, value: "OUT_PLANE_LOADING_2D" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcAnalysisModelTypeEnum = IfcAnalysisModelTypeEnum;
  class IfcAnalysisTheoryTypeEnum {
    static {
      this.FIRST_ORDER_THEORY = { type: 3, value: "FIRST_ORDER_THEORY" };
    }
    static {
      this.FULL_NONLINEAR_THEORY = { type: 3, value: "FULL_NONLINEAR_THEORY" };
    }
    static {
      this.SECOND_ORDER_THEORY = { type: 3, value: "SECOND_ORDER_THEORY" };
    }
    static {
      this.THIRD_ORDER_THEORY = { type: 3, value: "THIRD_ORDER_THEORY" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcAnalysisTheoryTypeEnum = IfcAnalysisTheoryTypeEnum;
  class IfcAnnotationTypeEnum {
    static {
      this.ASBUILTAREA = { type: 3, value: "ASBUILTAREA" };
    }
    static {
      this.ASBUILTLINE = { type: 3, value: "ASBUILTLINE" };
    }
    static {
      this.ASBUILTPOINT = { type: 3, value: "ASBUILTPOINT" };
    }
    static {
      this.ASSUMEDAREA = { type: 3, value: "ASSUMEDAREA" };
    }
    static {
      this.ASSUMEDLINE = { type: 3, value: "ASSUMEDLINE" };
    }
    static {
      this.ASSUMEDPOINT = { type: 3, value: "ASSUMEDPOINT" };
    }
    static {
      this.NON_PHYSICAL_SIGNAL = { type: 3, value: "NON_PHYSICAL_SIGNAL" };
    }
    static {
      this.SUPERELEVATIONEVENT = { type: 3, value: "SUPERELEVATIONEVENT" };
    }
    static {
      this.WIDTHEVENT = { type: 3, value: "WIDTHEVENT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcAnnotationTypeEnum = IfcAnnotationTypeEnum;
  class IfcArithmeticOperatorEnum {
    static {
      this.ADD = { type: 3, value: "ADD" };
    }
    static {
      this.DIVIDE = { type: 3, value: "DIVIDE" };
    }
    static {
      this.MULTIPLY = { type: 3, value: "MULTIPLY" };
    }
    static {
      this.SUBTRACT = { type: 3, value: "SUBTRACT" };
    }
  }
  IFC4X32.IfcArithmeticOperatorEnum = IfcArithmeticOperatorEnum;
  class IfcAssemblyPlaceEnum {
    static {
      this.FACTORY = { type: 3, value: "FACTORY" };
    }
    static {
      this.SITE = { type: 3, value: "SITE" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcAssemblyPlaceEnum = IfcAssemblyPlaceEnum;
  class IfcAudioVisualApplianceTypeEnum {
    static {
      this.AMPLIFIER = { type: 3, value: "AMPLIFIER" };
    }
    static {
      this.CAMERA = { type: 3, value: "CAMERA" };
    }
    static {
      this.COMMUNICATIONTERMINAL = { type: 3, value: "COMMUNICATIONTERMINAL" };
    }
    static {
      this.DISPLAY = { type: 3, value: "DISPLAY" };
    }
    static {
      this.MICROPHONE = { type: 3, value: "MICROPHONE" };
    }
    static {
      this.PLAYER = { type: 3, value: "PLAYER" };
    }
    static {
      this.PROJECTOR = { type: 3, value: "PROJECTOR" };
    }
    static {
      this.RECEIVER = { type: 3, value: "RECEIVER" };
    }
    static {
      this.RECORDINGEQUIPMENT = { type: 3, value: "RECORDINGEQUIPMENT" };
    }
    static {
      this.SPEAKER = { type: 3, value: "SPEAKER" };
    }
    static {
      this.SWITCHER = { type: 3, value: "SWITCHER" };
    }
    static {
      this.TELEPHONE = { type: 3, value: "TELEPHONE" };
    }
    static {
      this.TUNER = { type: 3, value: "TUNER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcAudioVisualApplianceTypeEnum = IfcAudioVisualApplianceTypeEnum;
  class IfcBSplineCurveForm {
    static {
      this.CIRCULAR_ARC = { type: 3, value: "CIRCULAR_ARC" };
    }
    static {
      this.ELLIPTIC_ARC = { type: 3, value: "ELLIPTIC_ARC" };
    }
    static {
      this.HYPERBOLIC_ARC = { type: 3, value: "HYPERBOLIC_ARC" };
    }
    static {
      this.PARABOLIC_ARC = { type: 3, value: "PARABOLIC_ARC" };
    }
    static {
      this.POLYLINE_FORM = { type: 3, value: "POLYLINE_FORM" };
    }
    static {
      this.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" };
    }
  }
  IFC4X32.IfcBSplineCurveForm = IfcBSplineCurveForm;
  class IfcBSplineSurfaceForm {
    static {
      this.CONICAL_SURF = { type: 3, value: "CONICAL_SURF" };
    }
    static {
      this.CYLINDRICAL_SURF = { type: 3, value: "CYLINDRICAL_SURF" };
    }
    static {
      this.GENERALISED_CONE = { type: 3, value: "GENERALISED_CONE" };
    }
    static {
      this.PLANE_SURF = { type: 3, value: "PLANE_SURF" };
    }
    static {
      this.QUADRIC_SURF = { type: 3, value: "QUADRIC_SURF" };
    }
    static {
      this.RULED_SURF = { type: 3, value: "RULED_SURF" };
    }
    static {
      this.SPHERICAL_SURF = { type: 3, value: "SPHERICAL_SURF" };
    }
    static {
      this.SURF_OF_LINEAR_EXTRUSION = { type: 3, value: "SURF_OF_LINEAR_EXTRUSION" };
    }
    static {
      this.SURF_OF_REVOLUTION = { type: 3, value: "SURF_OF_REVOLUTION" };
    }
    static {
      this.TOROIDAL_SURF = { type: 3, value: "TOROIDAL_SURF" };
    }
    static {
      this.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" };
    }
  }
  IFC4X32.IfcBSplineSurfaceForm = IfcBSplineSurfaceForm;
  class IfcBeamTypeEnum {
    static {
      this.BEAM = { type: 3, value: "BEAM" };
    }
    static {
      this.CORNICE = { type: 3, value: "CORNICE" };
    }
    static {
      this.DIAPHRAGM = { type: 3, value: "DIAPHRAGM" };
    }
    static {
      this.EDGEBEAM = { type: 3, value: "EDGEBEAM" };
    }
    static {
      this.GIRDER_SEGMENT = { type: 3, value: "GIRDER_SEGMENT" };
    }
    static {
      this.HATSTONE = { type: 3, value: "HATSTONE" };
    }
    static {
      this.HOLLOWCORE = { type: 3, value: "HOLLOWCORE" };
    }
    static {
      this.JOIST = { type: 3, value: "JOIST" };
    }
    static {
      this.LINTEL = { type: 3, value: "LINTEL" };
    }
    static {
      this.PIERCAP = { type: 3, value: "PIERCAP" };
    }
    static {
      this.SPANDREL = { type: 3, value: "SPANDREL" };
    }
    static {
      this.T_BEAM = { type: 3, value: "T_BEAM" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcBeamTypeEnum = IfcBeamTypeEnum;
  class IfcBearingTypeDisplacementEnum {
    static {
      this.FIXED_MOVEMENT = { type: 3, value: "FIXED_MOVEMENT" };
    }
    static {
      this.FREE_MOVEMENT = { type: 3, value: "FREE_MOVEMENT" };
    }
    static {
      this.GUIDED_LONGITUDINAL = { type: 3, value: "GUIDED_LONGITUDINAL" };
    }
    static {
      this.GUIDED_TRANSVERSAL = { type: 3, value: "GUIDED_TRANSVERSAL" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcBearingTypeDisplacementEnum = IfcBearingTypeDisplacementEnum;
  class IfcBearingTypeEnum {
    static {
      this.CYLINDRICAL = { type: 3, value: "CYLINDRICAL" };
    }
    static {
      this.DISK = { type: 3, value: "DISK" };
    }
    static {
      this.ELASTOMERIC = { type: 3, value: "ELASTOMERIC" };
    }
    static {
      this.GUIDE = { type: 3, value: "GUIDE" };
    }
    static {
      this.POT = { type: 3, value: "POT" };
    }
    static {
      this.ROCKER = { type: 3, value: "ROCKER" };
    }
    static {
      this.ROLLER = { type: 3, value: "ROLLER" };
    }
    static {
      this.SPHERICAL = { type: 3, value: "SPHERICAL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcBearingTypeEnum = IfcBearingTypeEnum;
  class IfcBenchmarkEnum {
    static {
      this.EQUALTO = { type: 3, value: "EQUALTO" };
    }
    static {
      this.GREATERTHAN = { type: 3, value: "GREATERTHAN" };
    }
    static {
      this.GREATERTHANOREQUALTO = { type: 3, value: "GREATERTHANOREQUALTO" };
    }
    static {
      this.INCLUDEDIN = { type: 3, value: "INCLUDEDIN" };
    }
    static {
      this.INCLUDES = { type: 3, value: "INCLUDES" };
    }
    static {
      this.LESSTHAN = { type: 3, value: "LESSTHAN" };
    }
    static {
      this.LESSTHANOREQUALTO = { type: 3, value: "LESSTHANOREQUALTO" };
    }
    static {
      this.NOTEQUALTO = { type: 3, value: "NOTEQUALTO" };
    }
    static {
      this.NOTINCLUDEDIN = { type: 3, value: "NOTINCLUDEDIN" };
    }
    static {
      this.NOTINCLUDES = { type: 3, value: "NOTINCLUDES" };
    }
  }
  IFC4X32.IfcBenchmarkEnum = IfcBenchmarkEnum;
  class IfcBoilerTypeEnum {
    static {
      this.STEAM = { type: 3, value: "STEAM" };
    }
    static {
      this.WATER = { type: 3, value: "WATER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcBoilerTypeEnum = IfcBoilerTypeEnum;
  class IfcBooleanOperator {
    static {
      this.DIFFERENCE = { type: 3, value: "DIFFERENCE" };
    }
    static {
      this.INTERSECTION = { type: 3, value: "INTERSECTION" };
    }
    static {
      this.UNION = { type: 3, value: "UNION" };
    }
  }
  IFC4X32.IfcBooleanOperator = IfcBooleanOperator;
  class IfcBridgePartTypeEnum {
    static {
      this.ABUTMENT = { type: 3, value: "ABUTMENT" };
    }
    static {
      this.DECK = { type: 3, value: "DECK" };
    }
    static {
      this.DECK_SEGMENT = { type: 3, value: "DECK_SEGMENT" };
    }
    static {
      this.FOUNDATION = { type: 3, value: "FOUNDATION" };
    }
    static {
      this.PIER = { type: 3, value: "PIER" };
    }
    static {
      this.PIER_SEGMENT = { type: 3, value: "PIER_SEGMENT" };
    }
    static {
      this.PYLON = { type: 3, value: "PYLON" };
    }
    static {
      this.SUBSTRUCTURE = { type: 3, value: "SUBSTRUCTURE" };
    }
    static {
      this.SUPERSTRUCTURE = { type: 3, value: "SUPERSTRUCTURE" };
    }
    static {
      this.SURFACESTRUCTURE = { type: 3, value: "SURFACESTRUCTURE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcBridgePartTypeEnum = IfcBridgePartTypeEnum;
  class IfcBridgeTypeEnum {
    static {
      this.ARCHED = { type: 3, value: "ARCHED" };
    }
    static {
      this.CABLE_STAYED = { type: 3, value: "CABLE_STAYED" };
    }
    static {
      this.CANTILEVER = { type: 3, value: "CANTILEVER" };
    }
    static {
      this.CULVERT = { type: 3, value: "CULVERT" };
    }
    static {
      this.FRAMEWORK = { type: 3, value: "FRAMEWORK" };
    }
    static {
      this.GIRDER = { type: 3, value: "GIRDER" };
    }
    static {
      this.SUSPENSION = { type: 3, value: "SUSPENSION" };
    }
    static {
      this.TRUSS = { type: 3, value: "TRUSS" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcBridgeTypeEnum = IfcBridgeTypeEnum;
  class IfcBuildingElementPartTypeEnum {
    static {
      this.APRON = { type: 3, value: "APRON" };
    }
    static {
      this.ARMOURUNIT = { type: 3, value: "ARMOURUNIT" };
    }
    static {
      this.INSULATION = { type: 3, value: "INSULATION" };
    }
    static {
      this.PRECASTPANEL = { type: 3, value: "PRECASTPANEL" };
    }
    static {
      this.SAFETYCAGE = { type: 3, value: "SAFETYCAGE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcBuildingElementPartTypeEnum = IfcBuildingElementPartTypeEnum;
  class IfcBuildingElementProxyTypeEnum {
    static {
      this.COMPLEX = { type: 3, value: "COMPLEX" };
    }
    static {
      this.ELEMENT = { type: 3, value: "ELEMENT" };
    }
    static {
      this.PARTIAL = { type: 3, value: "PARTIAL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcBuildingElementProxyTypeEnum = IfcBuildingElementProxyTypeEnum;
  class IfcBuildingSystemTypeEnum {
    static {
      this.EROSIONPREVENTION = { type: 3, value: "EROSIONPREVENTION" };
    }
    static {
      this.FENESTRATION = { type: 3, value: "FENESTRATION" };
    }
    static {
      this.FOUNDATION = { type: 3, value: "FOUNDATION" };
    }
    static {
      this.LOADBEARING = { type: 3, value: "LOADBEARING" };
    }
    static {
      this.OUTERSHELL = { type: 3, value: "OUTERSHELL" };
    }
    static {
      this.PRESTRESSING = { type: 3, value: "PRESTRESSING" };
    }
    static {
      this.REINFORCING = { type: 3, value: "REINFORCING" };
    }
    static {
      this.SHADING = { type: 3, value: "SHADING" };
    }
    static {
      this.TRANSPORT = { type: 3, value: "TRANSPORT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcBuildingSystemTypeEnum = IfcBuildingSystemTypeEnum;
  class IfcBuiltSystemTypeEnum {
    static {
      this.EROSIONPREVENTION = { type: 3, value: "EROSIONPREVENTION" };
    }
    static {
      this.FENESTRATION = { type: 3, value: "FENESTRATION" };
    }
    static {
      this.FOUNDATION = { type: 3, value: "FOUNDATION" };
    }
    static {
      this.LOADBEARING = { type: 3, value: "LOADBEARING" };
    }
    static {
      this.MOORING = { type: 3, value: "MOORING" };
    }
    static {
      this.OUTERSHELL = { type: 3, value: "OUTERSHELL" };
    }
    static {
      this.PRESTRESSING = { type: 3, value: "PRESTRESSING" };
    }
    static {
      this.RAILWAYLINE = { type: 3, value: "RAILWAYLINE" };
    }
    static {
      this.RAILWAYTRACK = { type: 3, value: "RAILWAYTRACK" };
    }
    static {
      this.REINFORCING = { type: 3, value: "REINFORCING" };
    }
    static {
      this.SHADING = { type: 3, value: "SHADING" };
    }
    static {
      this.TRACKCIRCUIT = { type: 3, value: "TRACKCIRCUIT" };
    }
    static {
      this.TRANSPORT = { type: 3, value: "TRANSPORT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcBuiltSystemTypeEnum = IfcBuiltSystemTypeEnum;
  class IfcBurnerTypeEnum {
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcBurnerTypeEnum = IfcBurnerTypeEnum;
  class IfcCableCarrierFittingTypeEnum {
    static {
      this.BEND = { type: 3, value: "BEND" };
    }
    static {
      this.CONNECTOR = { type: 3, value: "CONNECTOR" };
    }
    static {
      this.CROSS = { type: 3, value: "CROSS" };
    }
    static {
      this.JUNCTION = { type: 3, value: "JUNCTION" };
    }
    static {
      this.TEE = { type: 3, value: "TEE" };
    }
    static {
      this.TRANSITION = { type: 3, value: "TRANSITION" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcCableCarrierFittingTypeEnum = IfcCableCarrierFittingTypeEnum;
  class IfcCableCarrierSegmentTypeEnum {
    static {
      this.CABLEBRACKET = { type: 3, value: "CABLEBRACKET" };
    }
    static {
      this.CABLELADDERSEGMENT = { type: 3, value: "CABLELADDERSEGMENT" };
    }
    static {
      this.CABLETRAYSEGMENT = { type: 3, value: "CABLETRAYSEGMENT" };
    }
    static {
      this.CABLETRUNKINGSEGMENT = { type: 3, value: "CABLETRUNKINGSEGMENT" };
    }
    static {
      this.CATENARYWIRE = { type: 3, value: "CATENARYWIRE" };
    }
    static {
      this.CONDUITSEGMENT = { type: 3, value: "CONDUITSEGMENT" };
    }
    static {
      this.DROPPER = { type: 3, value: "DROPPER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcCableCarrierSegmentTypeEnum = IfcCableCarrierSegmentTypeEnum;
  class IfcCableFittingTypeEnum {
    static {
      this.CONNECTOR = { type: 3, value: "CONNECTOR" };
    }
    static {
      this.ENTRY = { type: 3, value: "ENTRY" };
    }
    static {
      this.EXIT = { type: 3, value: "EXIT" };
    }
    static {
      this.FANOUT = { type: 3, value: "FANOUT" };
    }
    static {
      this.JUNCTION = { type: 3, value: "JUNCTION" };
    }
    static {
      this.TRANSITION = { type: 3, value: "TRANSITION" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcCableFittingTypeEnum = IfcCableFittingTypeEnum;
  class IfcCableSegmentTypeEnum {
    static {
      this.BUSBARSEGMENT = { type: 3, value: "BUSBARSEGMENT" };
    }
    static {
      this.CABLESEGMENT = { type: 3, value: "CABLESEGMENT" };
    }
    static {
      this.CONDUCTORSEGMENT = { type: 3, value: "CONDUCTORSEGMENT" };
    }
    static {
      this.CONTACTWIRESEGMENT = { type: 3, value: "CONTACTWIRESEGMENT" };
    }
    static {
      this.CORESEGMENT = { type: 3, value: "CORESEGMENT" };
    }
    static {
      this.FIBERSEGMENT = { type: 3, value: "FIBERSEGMENT" };
    }
    static {
      this.FIBERTUBE = { type: 3, value: "FIBERTUBE" };
    }
    static {
      this.OPTICALCABLESEGMENT = { type: 3, value: "OPTICALCABLESEGMENT" };
    }
    static {
      this.STITCHWIRE = { type: 3, value: "STITCHWIRE" };
    }
    static {
      this.WIREPAIRSEGMENT = { type: 3, value: "WIREPAIRSEGMENT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcCableSegmentTypeEnum = IfcCableSegmentTypeEnum;
  class IfcCaissonFoundationTypeEnum {
    static {
      this.CAISSON = { type: 3, value: "CAISSON" };
    }
    static {
      this.WELL = { type: 3, value: "WELL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcCaissonFoundationTypeEnum = IfcCaissonFoundationTypeEnum;
  class IfcChangeActionEnum {
    static {
      this.ADDED = { type: 3, value: "ADDED" };
    }
    static {
      this.DELETED = { type: 3, value: "DELETED" };
    }
    static {
      this.MODIFIED = { type: 3, value: "MODIFIED" };
    }
    static {
      this.NOCHANGE = { type: 3, value: "NOCHANGE" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcChangeActionEnum = IfcChangeActionEnum;
  class IfcChillerTypeEnum {
    static {
      this.AIRCOOLED = { type: 3, value: "AIRCOOLED" };
    }
    static {
      this.HEATRECOVERY = { type: 3, value: "HEATRECOVERY" };
    }
    static {
      this.WATERCOOLED = { type: 3, value: "WATERCOOLED" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcChillerTypeEnum = IfcChillerTypeEnum;
  class IfcChimneyTypeEnum {
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcChimneyTypeEnum = IfcChimneyTypeEnum;
  class IfcCoilTypeEnum {
    static {
      this.DXCOOLINGCOIL = { type: 3, value: "DXCOOLINGCOIL" };
    }
    static {
      this.ELECTRICHEATINGCOIL = { type: 3, value: "ELECTRICHEATINGCOIL" };
    }
    static {
      this.GASHEATINGCOIL = { type: 3, value: "GASHEATINGCOIL" };
    }
    static {
      this.HYDRONICCOIL = { type: 3, value: "HYDRONICCOIL" };
    }
    static {
      this.STEAMHEATINGCOIL = { type: 3, value: "STEAMHEATINGCOIL" };
    }
    static {
      this.WATERCOOLINGCOIL = { type: 3, value: "WATERCOOLINGCOIL" };
    }
    static {
      this.WATERHEATINGCOIL = { type: 3, value: "WATERHEATINGCOIL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcCoilTypeEnum = IfcCoilTypeEnum;
  class IfcColumnTypeEnum {
    static {
      this.COLUMN = { type: 3, value: "COLUMN" };
    }
    static {
      this.PIERSTEM = { type: 3, value: "PIERSTEM" };
    }
    static {
      this.PIERSTEM_SEGMENT = { type: 3, value: "PIERSTEM_SEGMENT" };
    }
    static {
      this.PILASTER = { type: 3, value: "PILASTER" };
    }
    static {
      this.STANDCOLUMN = { type: 3, value: "STANDCOLUMN" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcColumnTypeEnum = IfcColumnTypeEnum;
  class IfcCommunicationsApplianceTypeEnum {
    static {
      this.ANTENNA = { type: 3, value: "ANTENNA" };
    }
    static {
      this.AUTOMATON = { type: 3, value: "AUTOMATON" };
    }
    static {
      this.COMPUTER = { type: 3, value: "COMPUTER" };
    }
    static {
      this.FAX = { type: 3, value: "FAX" };
    }
    static {
      this.GATEWAY = { type: 3, value: "GATEWAY" };
    }
    static {
      this.INTELLIGENTPERIPHERAL = { type: 3, value: "INTELLIGENTPERIPHERAL" };
    }
    static {
      this.IPNETWORKEQUIPMENT = { type: 3, value: "IPNETWORKEQUIPMENT" };
    }
    static {
      this.LINESIDEELECTRONICUNIT = { type: 3, value: "LINESIDEELECTRONICUNIT" };
    }
    static {
      this.MODEM = { type: 3, value: "MODEM" };
    }
    static {
      this.NETWORKAPPLIANCE = { type: 3, value: "NETWORKAPPLIANCE" };
    }
    static {
      this.NETWORKBRIDGE = { type: 3, value: "NETWORKBRIDGE" };
    }
    static {
      this.NETWORKHUB = { type: 3, value: "NETWORKHUB" };
    }
    static {
      this.OPTICALLINETERMINAL = { type: 3, value: "OPTICALLINETERMINAL" };
    }
    static {
      this.OPTICALNETWORKUNIT = { type: 3, value: "OPTICALNETWORKUNIT" };
    }
    static {
      this.PRINTER = { type: 3, value: "PRINTER" };
    }
    static {
      this.RADIOBLOCKCENTER = { type: 3, value: "RADIOBLOCKCENTER" };
    }
    static {
      this.REPEATER = { type: 3, value: "REPEATER" };
    }
    static {
      this.ROUTER = { type: 3, value: "ROUTER" };
    }
    static {
      this.SCANNER = { type: 3, value: "SCANNER" };
    }
    static {
      this.TELECOMMAND = { type: 3, value: "TELECOMMAND" };
    }
    static {
      this.TELEPHONYEXCHANGE = { type: 3, value: "TELEPHONYEXCHANGE" };
    }
    static {
      this.TRANSITIONCOMPONENT = { type: 3, value: "TRANSITIONCOMPONENT" };
    }
    static {
      this.TRANSPONDER = { type: 3, value: "TRANSPONDER" };
    }
    static {
      this.TRANSPORTEQUIPMENT = { type: 3, value: "TRANSPORTEQUIPMENT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcCommunicationsApplianceTypeEnum = IfcCommunicationsApplianceTypeEnum;
  class IfcComplexPropertyTemplateTypeEnum {
    static {
      this.P_COMPLEX = { type: 3, value: "P_COMPLEX" };
    }
    static {
      this.Q_COMPLEX = { type: 3, value: "Q_COMPLEX" };
    }
  }
  IFC4X32.IfcComplexPropertyTemplateTypeEnum = IfcComplexPropertyTemplateTypeEnum;
  class IfcCompressorTypeEnum {
    static {
      this.BOOSTER = { type: 3, value: "BOOSTER" };
    }
    static {
      this.DYNAMIC = { type: 3, value: "DYNAMIC" };
    }
    static {
      this.HERMETIC = { type: 3, value: "HERMETIC" };
    }
    static {
      this.OPENTYPE = { type: 3, value: "OPENTYPE" };
    }
    static {
      this.RECIPROCATING = { type: 3, value: "RECIPROCATING" };
    }
    static {
      this.ROLLINGPISTON = { type: 3, value: "ROLLINGPISTON" };
    }
    static {
      this.ROTARY = { type: 3, value: "ROTARY" };
    }
    static {
      this.ROTARYVANE = { type: 3, value: "ROTARYVANE" };
    }
    static {
      this.SCROLL = { type: 3, value: "SCROLL" };
    }
    static {
      this.SEMIHERMETIC = { type: 3, value: "SEMIHERMETIC" };
    }
    static {
      this.SINGLESCREW = { type: 3, value: "SINGLESCREW" };
    }
    static {
      this.SINGLESTAGE = { type: 3, value: "SINGLESTAGE" };
    }
    static {
      this.TROCHOIDAL = { type: 3, value: "TROCHOIDAL" };
    }
    static {
      this.TWINSCREW = { type: 3, value: "TWINSCREW" };
    }
    static {
      this.WELDEDSHELLHERMETIC = { type: 3, value: "WELDEDSHELLHERMETIC" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcCompressorTypeEnum = IfcCompressorTypeEnum;
  class IfcCondenserTypeEnum {
    static {
      this.AIRCOOLED = { type: 3, value: "AIRCOOLED" };
    }
    static {
      this.EVAPORATIVECOOLED = { type: 3, value: "EVAPORATIVECOOLED" };
    }
    static {
      this.WATERCOOLED = { type: 3, value: "WATERCOOLED" };
    }
    static {
      this.WATERCOOLEDBRAZEDPLATE = { type: 3, value: "WATERCOOLEDBRAZEDPLATE" };
    }
    static {
      this.WATERCOOLEDSHELLCOIL = { type: 3, value: "WATERCOOLEDSHELLCOIL" };
    }
    static {
      this.WATERCOOLEDSHELLTUBE = { type: 3, value: "WATERCOOLEDSHELLTUBE" };
    }
    static {
      this.WATERCOOLEDTUBEINTUBE = { type: 3, value: "WATERCOOLEDTUBEINTUBE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcCondenserTypeEnum = IfcCondenserTypeEnum;
  class IfcConnectionTypeEnum {
    static {
      this.ATEND = { type: 3, value: "ATEND" };
    }
    static {
      this.ATPATH = { type: 3, value: "ATPATH" };
    }
    static {
      this.ATSTART = { type: 3, value: "ATSTART" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcConnectionTypeEnum = IfcConnectionTypeEnum;
  class IfcConstraintEnum {
    static {
      this.ADVISORY = { type: 3, value: "ADVISORY" };
    }
    static {
      this.HARD = { type: 3, value: "HARD" };
    }
    static {
      this.SOFT = { type: 3, value: "SOFT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcConstraintEnum = IfcConstraintEnum;
  class IfcConstructionEquipmentResourceTypeEnum {
    static {
      this.DEMOLISHING = { type: 3, value: "DEMOLISHING" };
    }
    static {
      this.EARTHMOVING = { type: 3, value: "EARTHMOVING" };
    }
    static {
      this.ERECTING = { type: 3, value: "ERECTING" };
    }
    static {
      this.HEATING = { type: 3, value: "HEATING" };
    }
    static {
      this.LIGHTING = { type: 3, value: "LIGHTING" };
    }
    static {
      this.PAVING = { type: 3, value: "PAVING" };
    }
    static {
      this.PUMPING = { type: 3, value: "PUMPING" };
    }
    static {
      this.TRANSPORTING = { type: 3, value: "TRANSPORTING" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcConstructionEquipmentResourceTypeEnum = IfcConstructionEquipmentResourceTypeEnum;
  class IfcConstructionMaterialResourceTypeEnum {
    static {
      this.AGGREGATES = { type: 3, value: "AGGREGATES" };
    }
    static {
      this.CONCRETE = { type: 3, value: "CONCRETE" };
    }
    static {
      this.DRYWALL = { type: 3, value: "DRYWALL" };
    }
    static {
      this.FUEL = { type: 3, value: "FUEL" };
    }
    static {
      this.GYPSUM = { type: 3, value: "GYPSUM" };
    }
    static {
      this.MASONRY = { type: 3, value: "MASONRY" };
    }
    static {
      this.METAL = { type: 3, value: "METAL" };
    }
    static {
      this.PLASTIC = { type: 3, value: "PLASTIC" };
    }
    static {
      this.WOOD = { type: 3, value: "WOOD" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcConstructionMaterialResourceTypeEnum = IfcConstructionMaterialResourceTypeEnum;
  class IfcConstructionProductResourceTypeEnum {
    static {
      this.ASSEMBLY = { type: 3, value: "ASSEMBLY" };
    }
    static {
      this.FORMWORK = { type: 3, value: "FORMWORK" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcConstructionProductResourceTypeEnum = IfcConstructionProductResourceTypeEnum;
  class IfcControllerTypeEnum {
    static {
      this.FLOATING = { type: 3, value: "FLOATING" };
    }
    static {
      this.MULTIPOSITION = { type: 3, value: "MULTIPOSITION" };
    }
    static {
      this.PROGRAMMABLE = { type: 3, value: "PROGRAMMABLE" };
    }
    static {
      this.PROPORTIONAL = { type: 3, value: "PROPORTIONAL" };
    }
    static {
      this.TWOPOSITION = { type: 3, value: "TWOPOSITION" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcControllerTypeEnum = IfcControllerTypeEnum;
  class IfcConveyorSegmentTypeEnum {
    static {
      this.BELTCONVEYOR = { type: 3, value: "BELTCONVEYOR" };
    }
    static {
      this.BUCKETCONVEYOR = { type: 3, value: "BUCKETCONVEYOR" };
    }
    static {
      this.CHUTECONVEYOR = { type: 3, value: "CHUTECONVEYOR" };
    }
    static {
      this.SCREWCONVEYOR = { type: 3, value: "SCREWCONVEYOR" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcConveyorSegmentTypeEnum = IfcConveyorSegmentTypeEnum;
  class IfcCooledBeamTypeEnum {
    static {
      this.ACTIVE = { type: 3, value: "ACTIVE" };
    }
    static {
      this.PASSIVE = { type: 3, value: "PASSIVE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcCooledBeamTypeEnum = IfcCooledBeamTypeEnum;
  class IfcCoolingTowerTypeEnum {
    static {
      this.MECHANICALFORCEDDRAFT = { type: 3, value: "MECHANICALFORCEDDRAFT" };
    }
    static {
      this.MECHANICALINDUCEDDRAFT = { type: 3, value: "MECHANICALINDUCEDDRAFT" };
    }
    static {
      this.NATURALDRAFT = { type: 3, value: "NATURALDRAFT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcCoolingTowerTypeEnum = IfcCoolingTowerTypeEnum;
  class IfcCostItemTypeEnum {
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcCostItemTypeEnum = IfcCostItemTypeEnum;
  class IfcCostScheduleTypeEnum {
    static {
      this.BUDGET = { type: 3, value: "BUDGET" };
    }
    static {
      this.COSTPLAN = { type: 3, value: "COSTPLAN" };
    }
    static {
      this.ESTIMATE = { type: 3, value: "ESTIMATE" };
    }
    static {
      this.PRICEDBILLOFQUANTITIES = { type: 3, value: "PRICEDBILLOFQUANTITIES" };
    }
    static {
      this.SCHEDULEOFRATES = { type: 3, value: "SCHEDULEOFRATES" };
    }
    static {
      this.TENDER = { type: 3, value: "TENDER" };
    }
    static {
      this.UNPRICEDBILLOFQUANTITIES = { type: 3, value: "UNPRICEDBILLOFQUANTITIES" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcCostScheduleTypeEnum = IfcCostScheduleTypeEnum;
  class IfcCourseTypeEnum {
    static {
      this.ARMOUR = { type: 3, value: "ARMOUR" };
    }
    static {
      this.BALLASTBED = { type: 3, value: "BALLASTBED" };
    }
    static {
      this.CORE = { type: 3, value: "CORE" };
    }
    static {
      this.FILTER = { type: 3, value: "FILTER" };
    }
    static {
      this.PAVEMENT = { type: 3, value: "PAVEMENT" };
    }
    static {
      this.PROTECTION = { type: 3, value: "PROTECTION" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcCourseTypeEnum = IfcCourseTypeEnum;
  class IfcCoveringTypeEnum {
    static {
      this.CEILING = { type: 3, value: "CEILING" };
    }
    static {
      this.CLADDING = { type: 3, value: "CLADDING" };
    }
    static {
      this.COPING = { type: 3, value: "COPING" };
    }
    static {
      this.FLOORING = { type: 3, value: "FLOORING" };
    }
    static {
      this.INSULATION = { type: 3, value: "INSULATION" };
    }
    static {
      this.MEMBRANE = { type: 3, value: "MEMBRANE" };
    }
    static {
      this.MOLDING = { type: 3, value: "MOLDING" };
    }
    static {
      this.ROOFING = { type: 3, value: "ROOFING" };
    }
    static {
      this.SKIRTINGBOARD = { type: 3, value: "SKIRTINGBOARD" };
    }
    static {
      this.SLEEVING = { type: 3, value: "SLEEVING" };
    }
    static {
      this.TOPPING = { type: 3, value: "TOPPING" };
    }
    static {
      this.WRAPPING = { type: 3, value: "WRAPPING" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcCoveringTypeEnum = IfcCoveringTypeEnum;
  class IfcCrewResourceTypeEnum {
    static {
      this.OFFICE = { type: 3, value: "OFFICE" };
    }
    static {
      this.SITE = { type: 3, value: "SITE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcCrewResourceTypeEnum = IfcCrewResourceTypeEnum;
  class IfcCurtainWallTypeEnum {
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcCurtainWallTypeEnum = IfcCurtainWallTypeEnum;
  class IfcCurveInterpolationEnum {
    static {
      this.LINEAR = { type: 3, value: "LINEAR" };
    }
    static {
      this.LOG_LINEAR = { type: 3, value: "LOG_LINEAR" };
    }
    static {
      this.LOG_LOG = { type: 3, value: "LOG_LOG" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcCurveInterpolationEnum = IfcCurveInterpolationEnum;
  class IfcDamperTypeEnum {
    static {
      this.BACKDRAFTDAMPER = { type: 3, value: "BACKDRAFTDAMPER" };
    }
    static {
      this.BALANCINGDAMPER = { type: 3, value: "BALANCINGDAMPER" };
    }
    static {
      this.BLASTDAMPER = { type: 3, value: "BLASTDAMPER" };
    }
    static {
      this.CONTROLDAMPER = { type: 3, value: "CONTROLDAMPER" };
    }
    static {
      this.FIREDAMPER = { type: 3, value: "FIREDAMPER" };
    }
    static {
      this.FIRESMOKEDAMPER = { type: 3, value: "FIRESMOKEDAMPER" };
    }
    static {
      this.FUMEHOODEXHAUST = { type: 3, value: "FUMEHOODEXHAUST" };
    }
    static {
      this.GRAVITYDAMPER = { type: 3, value: "GRAVITYDAMPER" };
    }
    static {
      this.GRAVITYRELIEFDAMPER = { type: 3, value: "GRAVITYRELIEFDAMPER" };
    }
    static {
      this.RELIEFDAMPER = { type: 3, value: "RELIEFDAMPER" };
    }
    static {
      this.SMOKEDAMPER = { type: 3, value: "SMOKEDAMPER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcDamperTypeEnum = IfcDamperTypeEnum;
  class IfcDataOriginEnum {
    static {
      this.MEASURED = { type: 3, value: "MEASURED" };
    }
    static {
      this.PREDICTED = { type: 3, value: "PREDICTED" };
    }
    static {
      this.SIMULATED = { type: 3, value: "SIMULATED" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcDataOriginEnum = IfcDataOriginEnum;
  class IfcDerivedUnitEnum {
    static {
      this.ACCELERATIONUNIT = { type: 3, value: "ACCELERATIONUNIT" };
    }
    static {
      this.ANGULARVELOCITYUNIT = { type: 3, value: "ANGULARVELOCITYUNIT" };
    }
    static {
      this.AREADENSITYUNIT = { type: 3, value: "AREADENSITYUNIT" };
    }
    static {
      this.COMPOUNDPLANEANGLEUNIT = { type: 3, value: "COMPOUNDPLANEANGLEUNIT" };
    }
    static {
      this.CURVATUREUNIT = { type: 3, value: "CURVATUREUNIT" };
    }
    static {
      this.DYNAMICVISCOSITYUNIT = { type: 3, value: "DYNAMICVISCOSITYUNIT" };
    }
    static {
      this.HEATFLUXDENSITYUNIT = { type: 3, value: "HEATFLUXDENSITYUNIT" };
    }
    static {
      this.HEATINGVALUEUNIT = { type: 3, value: "HEATINGVALUEUNIT" };
    }
    static {
      this.INTEGERCOUNTRATEUNIT = { type: 3, value: "INTEGERCOUNTRATEUNIT" };
    }
    static {
      this.IONCONCENTRATIONUNIT = { type: 3, value: "IONCONCENTRATIONUNIT" };
    }
    static {
      this.ISOTHERMALMOISTURECAPACITYUNIT = { type: 3, value: "ISOTHERMALMOISTURECAPACITYUNIT" };
    }
    static {
      this.KINEMATICVISCOSITYUNIT = { type: 3, value: "KINEMATICVISCOSITYUNIT" };
    }
    static {
      this.LINEARFORCEUNIT = { type: 3, value: "LINEARFORCEUNIT" };
    }
    static {
      this.LINEARMOMENTUNIT = { type: 3, value: "LINEARMOMENTUNIT" };
    }
    static {
      this.LINEARSTIFFNESSUNIT = { type: 3, value: "LINEARSTIFFNESSUNIT" };
    }
    static {
      this.LINEARVELOCITYUNIT = { type: 3, value: "LINEARVELOCITYUNIT" };
    }
    static {
      this.LUMINOUSINTENSITYDISTRIBUTIONUNIT = { type: 3, value: "LUMINOUSINTENSITYDISTRIBUTIONUNIT" };
    }
    static {
      this.MASSDENSITYUNIT = { type: 3, value: "MASSDENSITYUNIT" };
    }
    static {
      this.MASSFLOWRATEUNIT = { type: 3, value: "MASSFLOWRATEUNIT" };
    }
    static {
      this.MASSPERLENGTHUNIT = { type: 3, value: "MASSPERLENGTHUNIT" };
    }
    static {
      this.MODULUSOFELASTICITYUNIT = { type: 3, value: "MODULUSOFELASTICITYUNIT" };
    }
    static {
      this.MODULUSOFLINEARSUBGRADEREACTIONUNIT = { type: 3, value: "MODULUSOFLINEARSUBGRADEREACTIONUNIT" };
    }
    static {
      this.MODULUSOFROTATIONALSUBGRADEREACTIONUNIT = { type: 3, value: "MODULUSOFROTATIONALSUBGRADEREACTIONUNIT" };
    }
    static {
      this.MODULUSOFSUBGRADEREACTIONUNIT = { type: 3, value: "MODULUSOFSUBGRADEREACTIONUNIT" };
    }
    static {
      this.MOISTUREDIFFUSIVITYUNIT = { type: 3, value: "MOISTUREDIFFUSIVITYUNIT" };
    }
    static {
      this.MOLECULARWEIGHTUNIT = { type: 3, value: "MOLECULARWEIGHTUNIT" };
    }
    static {
      this.MOMENTOFINERTIAUNIT = { type: 3, value: "MOMENTOFINERTIAUNIT" };
    }
    static {
      this.PHUNIT = { type: 3, value: "PHUNIT" };
    }
    static {
      this.PLANARFORCEUNIT = { type: 3, value: "PLANARFORCEUNIT" };
    }
    static {
      this.ROTATIONALFREQUENCYUNIT = { type: 3, value: "ROTATIONALFREQUENCYUNIT" };
    }
    static {
      this.ROTATIONALMASSUNIT = { type: 3, value: "ROTATIONALMASSUNIT" };
    }
    static {
      this.ROTATIONALSTIFFNESSUNIT = { type: 3, value: "ROTATIONALSTIFFNESSUNIT" };
    }
    static {
      this.SECTIONAREAINTEGRALUNIT = { type: 3, value: "SECTIONAREAINTEGRALUNIT" };
    }
    static {
      this.SECTIONMODULUSUNIT = { type: 3, value: "SECTIONMODULUSUNIT" };
    }
    static {
      this.SHEARMODULUSUNIT = { type: 3, value: "SHEARMODULUSUNIT" };
    }
    static {
      this.SOUNDPOWERLEVELUNIT = { type: 3, value: "SOUNDPOWERLEVELUNIT" };
    }
    static {
      this.SOUNDPOWERUNIT = { type: 3, value: "SOUNDPOWERUNIT" };
    }
    static {
      this.SOUNDPRESSURELEVELUNIT = { type: 3, value: "SOUNDPRESSURELEVELUNIT" };
    }
    static {
      this.SOUNDPRESSUREUNIT = { type: 3, value: "SOUNDPRESSUREUNIT" };
    }
    static {
      this.SPECIFICHEATCAPACITYUNIT = { type: 3, value: "SPECIFICHEATCAPACITYUNIT" };
    }
    static {
      this.TEMPERATUREGRADIENTUNIT = { type: 3, value: "TEMPERATUREGRADIENTUNIT" };
    }
    static {
      this.TEMPERATURERATEOFCHANGEUNIT = { type: 3, value: "TEMPERATURERATEOFCHANGEUNIT" };
    }
    static {
      this.THERMALADMITTANCEUNIT = { type: 3, value: "THERMALADMITTANCEUNIT" };
    }
    static {
      this.THERMALCONDUCTANCEUNIT = { type: 3, value: "THERMALCONDUCTANCEUNIT" };
    }
    static {
      this.THERMALEXPANSIONCOEFFICIENTUNIT = { type: 3, value: "THERMALEXPANSIONCOEFFICIENTUNIT" };
    }
    static {
      this.THERMALRESISTANCEUNIT = { type: 3, value: "THERMALRESISTANCEUNIT" };
    }
    static {
      this.THERMALTRANSMITTANCEUNIT = { type: 3, value: "THERMALTRANSMITTANCEUNIT" };
    }
    static {
      this.TORQUEUNIT = { type: 3, value: "TORQUEUNIT" };
    }
    static {
      this.VAPORPERMEABILITYUNIT = { type: 3, value: "VAPORPERMEABILITYUNIT" };
    }
    static {
      this.VOLUMETRICFLOWRATEUNIT = { type: 3, value: "VOLUMETRICFLOWRATEUNIT" };
    }
    static {
      this.WARPINGCONSTANTUNIT = { type: 3, value: "WARPINGCONSTANTUNIT" };
    }
    static {
      this.WARPINGMOMENTUNIT = { type: 3, value: "WARPINGMOMENTUNIT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
  }
  IFC4X32.IfcDerivedUnitEnum = IfcDerivedUnitEnum;
  class IfcDirectionSenseEnum {
    static {
      this.NEGATIVE = { type: 3, value: "NEGATIVE" };
    }
    static {
      this.POSITIVE = { type: 3, value: "POSITIVE" };
    }
  }
  IFC4X32.IfcDirectionSenseEnum = IfcDirectionSenseEnum;
  class IfcDiscreteAccessoryTypeEnum {
    static {
      this.ANCHORPLATE = { type: 3, value: "ANCHORPLATE" };
    }
    static {
      this.BIRDPROTECTION = { type: 3, value: "BIRDPROTECTION" };
    }
    static {
      this.BRACKET = { type: 3, value: "BRACKET" };
    }
    static {
      this.CABLEARRANGER = { type: 3, value: "CABLEARRANGER" };
    }
    static {
      this.ELASTIC_CUSHION = { type: 3, value: "ELASTIC_CUSHION" };
    }
    static {
      this.EXPANSION_JOINT_DEVICE = { type: 3, value: "EXPANSION_JOINT_DEVICE" };
    }
    static {
      this.FILLER = { type: 3, value: "FILLER" };
    }
    static {
      this.FLASHING = { type: 3, value: "FLASHING" };
    }
    static {
      this.INSULATOR = { type: 3, value: "INSULATOR" };
    }
    static {
      this.LOCK = { type: 3, value: "LOCK" };
    }
    static {
      this.PANEL_STRENGTHENING = { type: 3, value: "PANEL_STRENGTHENING" };
    }
    static {
      this.POINTMACHINEMOUNTINGDEVICE = { type: 3, value: "POINTMACHINEMOUNTINGDEVICE" };
    }
    static {
      this.POINT_MACHINE_LOCKING_DEVICE = { type: 3, value: "POINT_MACHINE_LOCKING_DEVICE" };
    }
    static {
      this.RAILBRACE = { type: 3, value: "RAILBRACE" };
    }
    static {
      this.RAILPAD = { type: 3, value: "RAILPAD" };
    }
    static {
      this.RAIL_LUBRICATION = { type: 3, value: "RAIL_LUBRICATION" };
    }
    static {
      this.RAIL_MECHANICAL_EQUIPMENT = { type: 3, value: "RAIL_MECHANICAL_EQUIPMENT" };
    }
    static {
      this.SHOE = { type: 3, value: "SHOE" };
    }
    static {
      this.SLIDINGCHAIR = { type: 3, value: "SLIDINGCHAIR" };
    }
    static {
      this.SOUNDABSORPTION = { type: 3, value: "SOUNDABSORPTION" };
    }
    static {
      this.TENSIONINGEQUIPMENT = { type: 3, value: "TENSIONINGEQUIPMENT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcDiscreteAccessoryTypeEnum = IfcDiscreteAccessoryTypeEnum;
  class IfcDistributionBoardTypeEnum {
    static {
      this.CONSUMERUNIT = { type: 3, value: "CONSUMERUNIT" };
    }
    static {
      this.DISPATCHINGBOARD = { type: 3, value: "DISPATCHINGBOARD" };
    }
    static {
      this.DISTRIBUTIONBOARD = { type: 3, value: "DISTRIBUTIONBOARD" };
    }
    static {
      this.DISTRIBUTIONFRAME = { type: 3, value: "DISTRIBUTIONFRAME" };
    }
    static {
      this.MOTORCONTROLCENTRE = { type: 3, value: "MOTORCONTROLCENTRE" };
    }
    static {
      this.SWITCHBOARD = { type: 3, value: "SWITCHBOARD" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcDistributionBoardTypeEnum = IfcDistributionBoardTypeEnum;
  class IfcDistributionChamberElementTypeEnum {
    static {
      this.FORMEDDUCT = { type: 3, value: "FORMEDDUCT" };
    }
    static {
      this.INSPECTIONCHAMBER = { type: 3, value: "INSPECTIONCHAMBER" };
    }
    static {
      this.INSPECTIONPIT = { type: 3, value: "INSPECTIONPIT" };
    }
    static {
      this.MANHOLE = { type: 3, value: "MANHOLE" };
    }
    static {
      this.METERCHAMBER = { type: 3, value: "METERCHAMBER" };
    }
    static {
      this.SUMP = { type: 3, value: "SUMP" };
    }
    static {
      this.TRENCH = { type: 3, value: "TRENCH" };
    }
    static {
      this.VALVECHAMBER = { type: 3, value: "VALVECHAMBER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcDistributionChamberElementTypeEnum = IfcDistributionChamberElementTypeEnum;
  class IfcDistributionPortTypeEnum {
    static {
      this.CABLE = { type: 3, value: "CABLE" };
    }
    static {
      this.CABLECARRIER = { type: 3, value: "CABLECARRIER" };
    }
    static {
      this.DUCT = { type: 3, value: "DUCT" };
    }
    static {
      this.PIPE = { type: 3, value: "PIPE" };
    }
    static {
      this.WIRELESS = { type: 3, value: "WIRELESS" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcDistributionPortTypeEnum = IfcDistributionPortTypeEnum;
  class IfcDistributionSystemEnum {
    static {
      this.AIRCONDITIONING = { type: 3, value: "AIRCONDITIONING" };
    }
    static {
      this.AUDIOVISUAL = { type: 3, value: "AUDIOVISUAL" };
    }
    static {
      this.CATENARY_SYSTEM = { type: 3, value: "CATENARY_SYSTEM" };
    }
    static {
      this.CHEMICAL = { type: 3, value: "CHEMICAL" };
    }
    static {
      this.CHILLEDWATER = { type: 3, value: "CHILLEDWATER" };
    }
    static {
      this.COMMUNICATION = { type: 3, value: "COMMUNICATION" };
    }
    static {
      this.COMPRESSEDAIR = { type: 3, value: "COMPRESSEDAIR" };
    }
    static {
      this.CONDENSERWATER = { type: 3, value: "CONDENSERWATER" };
    }
    static {
      this.CONTROL = { type: 3, value: "CONTROL" };
    }
    static {
      this.CONVEYING = { type: 3, value: "CONVEYING" };
    }
    static {
      this.DATA = { type: 3, value: "DATA" };
    }
    static {
      this.DISPOSAL = { type: 3, value: "DISPOSAL" };
    }
    static {
      this.DOMESTICCOLDWATER = { type: 3, value: "DOMESTICCOLDWATER" };
    }
    static {
      this.DOMESTICHOTWATER = { type: 3, value: "DOMESTICHOTWATER" };
    }
    static {
      this.DRAINAGE = { type: 3, value: "DRAINAGE" };
    }
    static {
      this.EARTHING = { type: 3, value: "EARTHING" };
    }
    static {
      this.ELECTRICAL = { type: 3, value: "ELECTRICAL" };
    }
    static {
      this.ELECTROACOUSTIC = { type: 3, value: "ELECTROACOUSTIC" };
    }
    static {
      this.EXHAUST = { type: 3, value: "EXHAUST" };
    }
    static {
      this.FIREPROTECTION = { type: 3, value: "FIREPROTECTION" };
    }
    static {
      this.FIXEDTRANSMISSIONNETWORK = { type: 3, value: "FIXEDTRANSMISSIONNETWORK" };
    }
    static {
      this.FUEL = { type: 3, value: "FUEL" };
    }
    static {
      this.GAS = { type: 3, value: "GAS" };
    }
    static {
      this.HAZARDOUS = { type: 3, value: "HAZARDOUS" };
    }
    static {
      this.HEATING = { type: 3, value: "HEATING" };
    }
    static {
      this.LIGHTING = { type: 3, value: "LIGHTING" };
    }
    static {
      this.LIGHTNINGPROTECTION = { type: 3, value: "LIGHTNINGPROTECTION" };
    }
    static {
      this.MOBILENETWORK = { type: 3, value: "MOBILENETWORK" };
    }
    static {
      this.MONITORINGSYSTEM = { type: 3, value: "MONITORINGSYSTEM" };
    }
    static {
      this.MUNICIPALSOLIDWASTE = { type: 3, value: "MUNICIPALSOLIDWASTE" };
    }
    static {
      this.OIL = { type: 3, value: "OIL" };
    }
    static {
      this.OPERATIONAL = { type: 3, value: "OPERATIONAL" };
    }
    static {
      this.OPERATIONALTELEPHONYSYSTEM = { type: 3, value: "OPERATIONALTELEPHONYSYSTEM" };
    }
    static {
      this.OVERHEAD_CONTACTLINE_SYSTEM = { type: 3, value: "OVERHEAD_CONTACTLINE_SYSTEM" };
    }
    static {
      this.POWERGENERATION = { type: 3, value: "POWERGENERATION" };
    }
    static {
      this.RAINWATER = { type: 3, value: "RAINWATER" };
    }
    static {
      this.REFRIGERATION = { type: 3, value: "REFRIGERATION" };
    }
    static {
      this.RETURN_CIRCUIT = { type: 3, value: "RETURN_CIRCUIT" };
    }
    static {
      this.SECURITY = { type: 3, value: "SECURITY" };
    }
    static {
      this.SEWAGE = { type: 3, value: "SEWAGE" };
    }
    static {
      this.SIGNAL = { type: 3, value: "SIGNAL" };
    }
    static {
      this.STORMWATER = { type: 3, value: "STORMWATER" };
    }
    static {
      this.TELEPHONE = { type: 3, value: "TELEPHONE" };
    }
    static {
      this.TV = { type: 3, value: "TV" };
    }
    static {
      this.VACUUM = { type: 3, value: "VACUUM" };
    }
    static {
      this.VENT = { type: 3, value: "VENT" };
    }
    static {
      this.VENTILATION = { type: 3, value: "VENTILATION" };
    }
    static {
      this.WASTEWATER = { type: 3, value: "WASTEWATER" };
    }
    static {
      this.WATERSUPPLY = { type: 3, value: "WATERSUPPLY" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcDistributionSystemEnum = IfcDistributionSystemEnum;
  class IfcDocumentConfidentialityEnum {
    static {
      this.CONFIDENTIAL = { type: 3, value: "CONFIDENTIAL" };
    }
    static {
      this.PERSONAL = { type: 3, value: "PERSONAL" };
    }
    static {
      this.PUBLIC = { type: 3, value: "PUBLIC" };
    }
    static {
      this.RESTRICTED = { type: 3, value: "RESTRICTED" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcDocumentConfidentialityEnum = IfcDocumentConfidentialityEnum;
  class IfcDocumentStatusEnum {
    static {
      this.DRAFT = { type: 3, value: "DRAFT" };
    }
    static {
      this.FINAL = { type: 3, value: "FINAL" };
    }
    static {
      this.FINALDRAFT = { type: 3, value: "FINALDRAFT" };
    }
    static {
      this.REVISION = { type: 3, value: "REVISION" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcDocumentStatusEnum = IfcDocumentStatusEnum;
  class IfcDoorPanelOperationEnum {
    static {
      this.DOUBLE_ACTING = { type: 3, value: "DOUBLE_ACTING" };
    }
    static {
      this.FIXEDPANEL = { type: 3, value: "FIXEDPANEL" };
    }
    static {
      this.FOLDING = { type: 3, value: "FOLDING" };
    }
    static {
      this.REVOLVING = { type: 3, value: "REVOLVING" };
    }
    static {
      this.ROLLINGUP = { type: 3, value: "ROLLINGUP" };
    }
    static {
      this.SLIDING = { type: 3, value: "SLIDING" };
    }
    static {
      this.SWINGING = { type: 3, value: "SWINGING" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcDoorPanelOperationEnum = IfcDoorPanelOperationEnum;
  class IfcDoorPanelPositionEnum {
    static {
      this.LEFT = { type: 3, value: "LEFT" };
    }
    static {
      this.MIDDLE = { type: 3, value: "MIDDLE" };
    }
    static {
      this.RIGHT = { type: 3, value: "RIGHT" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcDoorPanelPositionEnum = IfcDoorPanelPositionEnum;
  class IfcDoorStyleConstructionEnum {
    static {
      this.ALUMINIUM = { type: 3, value: "ALUMINIUM" };
    }
    static {
      this.ALUMINIUM_PLASTIC = { type: 3, value: "ALUMINIUM_PLASTIC" };
    }
    static {
      this.ALUMINIUM_WOOD = { type: 3, value: "ALUMINIUM_WOOD" };
    }
    static {
      this.HIGH_GRADE_STEEL = { type: 3, value: "HIGH_GRADE_STEEL" };
    }
    static {
      this.PLASTIC = { type: 3, value: "PLASTIC" };
    }
    static {
      this.STEEL = { type: 3, value: "STEEL" };
    }
    static {
      this.WOOD = { type: 3, value: "WOOD" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcDoorStyleConstructionEnum = IfcDoorStyleConstructionEnum;
  class IfcDoorStyleOperationEnum {
    static {
      this.DOUBLE_DOOR_DOUBLE_SWING = { type: 3, value: "DOUBLE_DOOR_DOUBLE_SWING" };
    }
    static {
      this.DOUBLE_DOOR_FOLDING = { type: 3, value: "DOUBLE_DOOR_FOLDING" };
    }
    static {
      this.DOUBLE_DOOR_SINGLE_SWING = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING" };
    }
    static {
      this.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT" };
    }
    static {
      this.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT" };
    }
    static {
      this.DOUBLE_DOOR_SLIDING = { type: 3, value: "DOUBLE_DOOR_SLIDING" };
    }
    static {
      this.DOUBLE_SWING_LEFT = { type: 3, value: "DOUBLE_SWING_LEFT" };
    }
    static {
      this.DOUBLE_SWING_RIGHT = { type: 3, value: "DOUBLE_SWING_RIGHT" };
    }
    static {
      this.FOLDING_TO_LEFT = { type: 3, value: "FOLDING_TO_LEFT" };
    }
    static {
      this.FOLDING_TO_RIGHT = { type: 3, value: "FOLDING_TO_RIGHT" };
    }
    static {
      this.REVOLVING = { type: 3, value: "REVOLVING" };
    }
    static {
      this.ROLLINGUP = { type: 3, value: "ROLLINGUP" };
    }
    static {
      this.SINGLE_SWING_LEFT = { type: 3, value: "SINGLE_SWING_LEFT" };
    }
    static {
      this.SINGLE_SWING_RIGHT = { type: 3, value: "SINGLE_SWING_RIGHT" };
    }
    static {
      this.SLIDING_TO_LEFT = { type: 3, value: "SLIDING_TO_LEFT" };
    }
    static {
      this.SLIDING_TO_RIGHT = { type: 3, value: "SLIDING_TO_RIGHT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcDoorStyleOperationEnum = IfcDoorStyleOperationEnum;
  class IfcDoorTypeEnum {
    static {
      this.BOOM_BARRIER = { type: 3, value: "BOOM_BARRIER" };
    }
    static {
      this.DOOR = { type: 3, value: "DOOR" };
    }
    static {
      this.GATE = { type: 3, value: "GATE" };
    }
    static {
      this.TRAPDOOR = { type: 3, value: "TRAPDOOR" };
    }
    static {
      this.TURNSTILE = { type: 3, value: "TURNSTILE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcDoorTypeEnum = IfcDoorTypeEnum;
  class IfcDoorTypeOperationEnum {
    static {
      this.DOUBLE_PANEL_DOUBLE_SWING = { type: 3, value: "DOUBLE_PANEL_DOUBLE_SWING" };
    }
    static {
      this.DOUBLE_PANEL_FOLDING = { type: 3, value: "DOUBLE_PANEL_FOLDING" };
    }
    static {
      this.DOUBLE_PANEL_LIFTING_VERTICAL = { type: 3, value: "DOUBLE_PANEL_LIFTING_VERTICAL" };
    }
    static {
      this.DOUBLE_PANEL_SINGLE_SWING = { type: 3, value: "DOUBLE_PANEL_SINGLE_SWING" };
    }
    static {
      this.DOUBLE_PANEL_SINGLE_SWING_OPPOSITE_LEFT = { type: 3, value: "DOUBLE_PANEL_SINGLE_SWING_OPPOSITE_LEFT" };
    }
    static {
      this.DOUBLE_PANEL_SINGLE_SWING_OPPOSITE_RIGHT = { type: 3, value: "DOUBLE_PANEL_SINGLE_SWING_OPPOSITE_RIGHT" };
    }
    static {
      this.DOUBLE_PANEL_SLIDING = { type: 3, value: "DOUBLE_PANEL_SLIDING" };
    }
    static {
      this.DOUBLE_SWING_LEFT = { type: 3, value: "DOUBLE_SWING_LEFT" };
    }
    static {
      this.DOUBLE_SWING_RIGHT = { type: 3, value: "DOUBLE_SWING_RIGHT" };
    }
    static {
      this.FOLDING_TO_LEFT = { type: 3, value: "FOLDING_TO_LEFT" };
    }
    static {
      this.FOLDING_TO_RIGHT = { type: 3, value: "FOLDING_TO_RIGHT" };
    }
    static {
      this.LIFTING_HORIZONTAL = { type: 3, value: "LIFTING_HORIZONTAL" };
    }
    static {
      this.LIFTING_VERTICAL_LEFT = { type: 3, value: "LIFTING_VERTICAL_LEFT" };
    }
    static {
      this.LIFTING_VERTICAL_RIGHT = { type: 3, value: "LIFTING_VERTICAL_RIGHT" };
    }
    static {
      this.REVOLVING_HORIZONTAL = { type: 3, value: "REVOLVING_HORIZONTAL" };
    }
    static {
      this.REVOLVING_VERTICAL = { type: 3, value: "REVOLVING_VERTICAL" };
    }
    static {
      this.ROLLINGUP = { type: 3, value: "ROLLINGUP" };
    }
    static {
      this.SINGLE_SWING_LEFT = { type: 3, value: "SINGLE_SWING_LEFT" };
    }
    static {
      this.SINGLE_SWING_RIGHT = { type: 3, value: "SINGLE_SWING_RIGHT" };
    }
    static {
      this.SLIDING_TO_LEFT = { type: 3, value: "SLIDING_TO_LEFT" };
    }
    static {
      this.SLIDING_TO_RIGHT = { type: 3, value: "SLIDING_TO_RIGHT" };
    }
    static {
      this.SWING_FIXED_LEFT = { type: 3, value: "SWING_FIXED_LEFT" };
    }
    static {
      this.SWING_FIXED_RIGHT = { type: 3, value: "SWING_FIXED_RIGHT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcDoorTypeOperationEnum = IfcDoorTypeOperationEnum;
  class IfcDuctFittingTypeEnum {
    static {
      this.BEND = { type: 3, value: "BEND" };
    }
    static {
      this.CONNECTOR = { type: 3, value: "CONNECTOR" };
    }
    static {
      this.ENTRY = { type: 3, value: "ENTRY" };
    }
    static {
      this.EXIT = { type: 3, value: "EXIT" };
    }
    static {
      this.JUNCTION = { type: 3, value: "JUNCTION" };
    }
    static {
      this.OBSTRUCTION = { type: 3, value: "OBSTRUCTION" };
    }
    static {
      this.TRANSITION = { type: 3, value: "TRANSITION" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcDuctFittingTypeEnum = IfcDuctFittingTypeEnum;
  class IfcDuctSegmentTypeEnum {
    static {
      this.FLEXIBLESEGMENT = { type: 3, value: "FLEXIBLESEGMENT" };
    }
    static {
      this.RIGIDSEGMENT = { type: 3, value: "RIGIDSEGMENT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcDuctSegmentTypeEnum = IfcDuctSegmentTypeEnum;
  class IfcDuctSilencerTypeEnum {
    static {
      this.FLATOVAL = { type: 3, value: "FLATOVAL" };
    }
    static {
      this.RECTANGULAR = { type: 3, value: "RECTANGULAR" };
    }
    static {
      this.ROUND = { type: 3, value: "ROUND" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcDuctSilencerTypeEnum = IfcDuctSilencerTypeEnum;
  class IfcEarthworksCutTypeEnum {
    static {
      this.BASE_EXCAVATION = { type: 3, value: "BASE_EXCAVATION" };
    }
    static {
      this.CUT = { type: 3, value: "CUT" };
    }
    static {
      this.DREDGING = { type: 3, value: "DREDGING" };
    }
    static {
      this.EXCAVATION = { type: 3, value: "EXCAVATION" };
    }
    static {
      this.OVEREXCAVATION = { type: 3, value: "OVEREXCAVATION" };
    }
    static {
      this.PAVEMENTMILLING = { type: 3, value: "PAVEMENTMILLING" };
    }
    static {
      this.STEPEXCAVATION = { type: 3, value: "STEPEXCAVATION" };
    }
    static {
      this.TOPSOILREMOVAL = { type: 3, value: "TOPSOILREMOVAL" };
    }
    static {
      this.TRENCH = { type: 3, value: "TRENCH" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcEarthworksCutTypeEnum = IfcEarthworksCutTypeEnum;
  class IfcEarthworksFillTypeEnum {
    static {
      this.BACKFILL = { type: 3, value: "BACKFILL" };
    }
    static {
      this.COUNTERWEIGHT = { type: 3, value: "COUNTERWEIGHT" };
    }
    static {
      this.EMBANKMENT = { type: 3, value: "EMBANKMENT" };
    }
    static {
      this.SLOPEFILL = { type: 3, value: "SLOPEFILL" };
    }
    static {
      this.SUBGRADE = { type: 3, value: "SUBGRADE" };
    }
    static {
      this.SUBGRADEBED = { type: 3, value: "SUBGRADEBED" };
    }
    static {
      this.TRANSITIONSECTION = { type: 3, value: "TRANSITIONSECTION" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcEarthworksFillTypeEnum = IfcEarthworksFillTypeEnum;
  class IfcElectricApplianceTypeEnum {
    static {
      this.DISHWASHER = { type: 3, value: "DISHWASHER" };
    }
    static {
      this.ELECTRICCOOKER = { type: 3, value: "ELECTRICCOOKER" };
    }
    static {
      this.FREESTANDINGELECTRICHEATER = { type: 3, value: "FREESTANDINGELECTRICHEATER" };
    }
    static {
      this.FREESTANDINGFAN = { type: 3, value: "FREESTANDINGFAN" };
    }
    static {
      this.FREESTANDINGWATERCOOLER = { type: 3, value: "FREESTANDINGWATERCOOLER" };
    }
    static {
      this.FREESTANDINGWATERHEATER = { type: 3, value: "FREESTANDINGWATERHEATER" };
    }
    static {
      this.FREEZER = { type: 3, value: "FREEZER" };
    }
    static {
      this.FRIDGE_FREEZER = { type: 3, value: "FRIDGE_FREEZER" };
    }
    static {
      this.HANDDRYER = { type: 3, value: "HANDDRYER" };
    }
    static {
      this.KITCHENMACHINE = { type: 3, value: "KITCHENMACHINE" };
    }
    static {
      this.MICROWAVE = { type: 3, value: "MICROWAVE" };
    }
    static {
      this.PHOTOCOPIER = { type: 3, value: "PHOTOCOPIER" };
    }
    static {
      this.REFRIGERATOR = { type: 3, value: "REFRIGERATOR" };
    }
    static {
      this.TUMBLEDRYER = { type: 3, value: "TUMBLEDRYER" };
    }
    static {
      this.VENDINGMACHINE = { type: 3, value: "VENDINGMACHINE" };
    }
    static {
      this.WASHINGMACHINE = { type: 3, value: "WASHINGMACHINE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcElectricApplianceTypeEnum = IfcElectricApplianceTypeEnum;
  class IfcElectricDistributionBoardTypeEnum {
    static {
      this.CONSUMERUNIT = { type: 3, value: "CONSUMERUNIT" };
    }
    static {
      this.DISTRIBUTIONBOARD = { type: 3, value: "DISTRIBUTIONBOARD" };
    }
    static {
      this.MOTORCONTROLCENTRE = { type: 3, value: "MOTORCONTROLCENTRE" };
    }
    static {
      this.SWITCHBOARD = { type: 3, value: "SWITCHBOARD" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcElectricDistributionBoardTypeEnum = IfcElectricDistributionBoardTypeEnum;
  class IfcElectricFlowStorageDeviceTypeEnum {
    static {
      this.BATTERY = { type: 3, value: "BATTERY" };
    }
    static {
      this.CAPACITOR = { type: 3, value: "CAPACITOR" };
    }
    static {
      this.CAPACITORBANK = { type: 3, value: "CAPACITORBANK" };
    }
    static {
      this.COMPENSATOR = { type: 3, value: "COMPENSATOR" };
    }
    static {
      this.HARMONICFILTER = { type: 3, value: "HARMONICFILTER" };
    }
    static {
      this.INDUCTOR = { type: 3, value: "INDUCTOR" };
    }
    static {
      this.INDUCTORBANK = { type: 3, value: "INDUCTORBANK" };
    }
    static {
      this.RECHARGER = { type: 3, value: "RECHARGER" };
    }
    static {
      this.UPS = { type: 3, value: "UPS" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcElectricFlowStorageDeviceTypeEnum = IfcElectricFlowStorageDeviceTypeEnum;
  class IfcElectricFlowTreatmentDeviceTypeEnum {
    static {
      this.ELECTRONICFILTER = { type: 3, value: "ELECTRONICFILTER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcElectricFlowTreatmentDeviceTypeEnum = IfcElectricFlowTreatmentDeviceTypeEnum;
  class IfcElectricGeneratorTypeEnum {
    static {
      this.CHP = { type: 3, value: "CHP" };
    }
    static {
      this.ENGINEGENERATOR = { type: 3, value: "ENGINEGENERATOR" };
    }
    static {
      this.STANDALONE = { type: 3, value: "STANDALONE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcElectricGeneratorTypeEnum = IfcElectricGeneratorTypeEnum;
  class IfcElectricMotorTypeEnum {
    static {
      this.DC = { type: 3, value: "DC" };
    }
    static {
      this.INDUCTION = { type: 3, value: "INDUCTION" };
    }
    static {
      this.POLYPHASE = { type: 3, value: "POLYPHASE" };
    }
    static {
      this.RELUCTANCESYNCHRONOUS = { type: 3, value: "RELUCTANCESYNCHRONOUS" };
    }
    static {
      this.SYNCHRONOUS = { type: 3, value: "SYNCHRONOUS" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcElectricMotorTypeEnum = IfcElectricMotorTypeEnum;
  class IfcElectricTimeControlTypeEnum {
    static {
      this.RELAY = { type: 3, value: "RELAY" };
    }
    static {
      this.TIMECLOCK = { type: 3, value: "TIMECLOCK" };
    }
    static {
      this.TIMEDELAY = { type: 3, value: "TIMEDELAY" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcElectricTimeControlTypeEnum = IfcElectricTimeControlTypeEnum;
  class IfcElementAssemblyTypeEnum {
    static {
      this.ABUTMENT = { type: 3, value: "ABUTMENT" };
    }
    static {
      this.ACCESSORY_ASSEMBLY = { type: 3, value: "ACCESSORY_ASSEMBLY" };
    }
    static {
      this.ARCH = { type: 3, value: "ARCH" };
    }
    static {
      this.BEAM_GRID = { type: 3, value: "BEAM_GRID" };
    }
    static {
      this.BRACED_FRAME = { type: 3, value: "BRACED_FRAME" };
    }
    static {
      this.CROSS_BRACING = { type: 3, value: "CROSS_BRACING" };
    }
    static {
      this.DECK = { type: 3, value: "DECK" };
    }
    static {
      this.DILATATIONPANEL = { type: 3, value: "DILATATIONPANEL" };
    }
    static {
      this.ENTRANCEWORKS = { type: 3, value: "ENTRANCEWORKS" };
    }
    static {
      this.GIRDER = { type: 3, value: "GIRDER" };
    }
    static {
      this.GRID = { type: 3, value: "GRID" };
    }
    static {
      this.MAST = { type: 3, value: "MAST" };
    }
    static {
      this.PIER = { type: 3, value: "PIER" };
    }
    static {
      this.PYLON = { type: 3, value: "PYLON" };
    }
    static {
      this.RAIL_MECHANICAL_EQUIPMENT_ASSEMBLY = { type: 3, value: "RAIL_MECHANICAL_EQUIPMENT_ASSEMBLY" };
    }
    static {
      this.REINFORCEMENT_UNIT = { type: 3, value: "REINFORCEMENT_UNIT" };
    }
    static {
      this.RIGID_FRAME = { type: 3, value: "RIGID_FRAME" };
    }
    static {
      this.SHELTER = { type: 3, value: "SHELTER" };
    }
    static {
      this.SIGNALASSEMBLY = { type: 3, value: "SIGNALASSEMBLY" };
    }
    static {
      this.SLAB_FIELD = { type: 3, value: "SLAB_FIELD" };
    }
    static {
      this.SUMPBUSTER = { type: 3, value: "SUMPBUSTER" };
    }
    static {
      this.SUPPORTINGASSEMBLY = { type: 3, value: "SUPPORTINGASSEMBLY" };
    }
    static {
      this.SUSPENSIONASSEMBLY = { type: 3, value: "SUSPENSIONASSEMBLY" };
    }
    static {
      this.TRACKPANEL = { type: 3, value: "TRACKPANEL" };
    }
    static {
      this.TRACTION_SWITCHING_ASSEMBLY = { type: 3, value: "TRACTION_SWITCHING_ASSEMBLY" };
    }
    static {
      this.TRAFFIC_CALMING_DEVICE = { type: 3, value: "TRAFFIC_CALMING_DEVICE" };
    }
    static {
      this.TRUSS = { type: 3, value: "TRUSS" };
    }
    static {
      this.TURNOUTPANEL = { type: 3, value: "TURNOUTPANEL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcElementAssemblyTypeEnum = IfcElementAssemblyTypeEnum;
  class IfcElementCompositionEnum {
    static {
      this.COMPLEX = { type: 3, value: "COMPLEX" };
    }
    static {
      this.ELEMENT = { type: 3, value: "ELEMENT" };
    }
    static {
      this.PARTIAL = { type: 3, value: "PARTIAL" };
    }
  }
  IFC4X32.IfcElementCompositionEnum = IfcElementCompositionEnum;
  class IfcEngineTypeEnum {
    static {
      this.EXTERNALCOMBUSTION = { type: 3, value: "EXTERNALCOMBUSTION" };
    }
    static {
      this.INTERNALCOMBUSTION = { type: 3, value: "INTERNALCOMBUSTION" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcEngineTypeEnum = IfcEngineTypeEnum;
  class IfcEvaporativeCoolerTypeEnum {
    static {
      this.DIRECTEVAPORATIVEAIRWASHER = { type: 3, value: "DIRECTEVAPORATIVEAIRWASHER" };
    }
    static {
      this.DIRECTEVAPORATIVEPACKAGEDROTARYAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVEPACKAGEDROTARYAIRCOOLER" };
    }
    static {
      this.DIRECTEVAPORATIVERANDOMMEDIAAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVERANDOMMEDIAAIRCOOLER" };
    }
    static {
      this.DIRECTEVAPORATIVERIGIDMEDIAAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVERIGIDMEDIAAIRCOOLER" };
    }
    static {
      this.DIRECTEVAPORATIVESLINGERSPACKAGEDAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVESLINGERSPACKAGEDAIRCOOLER" };
    }
    static {
      this.INDIRECTDIRECTCOMBINATION = { type: 3, value: "INDIRECTDIRECTCOMBINATION" };
    }
    static {
      this.INDIRECTEVAPORATIVECOOLINGTOWERORCOILCOOLER = { type: 3, value: "INDIRECTEVAPORATIVECOOLINGTOWERORCOILCOOLER" };
    }
    static {
      this.INDIRECTEVAPORATIVEPACKAGEAIRCOOLER = { type: 3, value: "INDIRECTEVAPORATIVEPACKAGEAIRCOOLER" };
    }
    static {
      this.INDIRECTEVAPORATIVEWETCOIL = { type: 3, value: "INDIRECTEVAPORATIVEWETCOIL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcEvaporativeCoolerTypeEnum = IfcEvaporativeCoolerTypeEnum;
  class IfcEvaporatorTypeEnum {
    static {
      this.DIRECTEXPANSION = { type: 3, value: "DIRECTEXPANSION" };
    }
    static {
      this.DIRECTEXPANSIONBRAZEDPLATE = { type: 3, value: "DIRECTEXPANSIONBRAZEDPLATE" };
    }
    static {
      this.DIRECTEXPANSIONSHELLANDTUBE = { type: 3, value: "DIRECTEXPANSIONSHELLANDTUBE" };
    }
    static {
      this.DIRECTEXPANSIONTUBEINTUBE = { type: 3, value: "DIRECTEXPANSIONTUBEINTUBE" };
    }
    static {
      this.FLOODEDSHELLANDTUBE = { type: 3, value: "FLOODEDSHELLANDTUBE" };
    }
    static {
      this.SHELLANDCOIL = { type: 3, value: "SHELLANDCOIL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcEvaporatorTypeEnum = IfcEvaporatorTypeEnum;
  class IfcEventTriggerTypeEnum {
    static {
      this.EVENTCOMPLEX = { type: 3, value: "EVENTCOMPLEX" };
    }
    static {
      this.EVENTMESSAGE = { type: 3, value: "EVENTMESSAGE" };
    }
    static {
      this.EVENTRULE = { type: 3, value: "EVENTRULE" };
    }
    static {
      this.EVENTTIME = { type: 3, value: "EVENTTIME" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcEventTriggerTypeEnum = IfcEventTriggerTypeEnum;
  class IfcEventTypeEnum {
    static {
      this.ENDEVENT = { type: 3, value: "ENDEVENT" };
    }
    static {
      this.INTERMEDIATEEVENT = { type: 3, value: "INTERMEDIATEEVENT" };
    }
    static {
      this.STARTEVENT = { type: 3, value: "STARTEVENT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcEventTypeEnum = IfcEventTypeEnum;
  class IfcExternalSpatialElementTypeEnum {
    static {
      this.EXTERNAL = { type: 3, value: "EXTERNAL" };
    }
    static {
      this.EXTERNAL_EARTH = { type: 3, value: "EXTERNAL_EARTH" };
    }
    static {
      this.EXTERNAL_FIRE = { type: 3, value: "EXTERNAL_FIRE" };
    }
    static {
      this.EXTERNAL_WATER = { type: 3, value: "EXTERNAL_WATER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcExternalSpatialElementTypeEnum = IfcExternalSpatialElementTypeEnum;
  class IfcFacilityPartCommonTypeEnum {
    static {
      this.ABOVEGROUND = { type: 3, value: "ABOVEGROUND" };
    }
    static {
      this.BELOWGROUND = { type: 3, value: "BELOWGROUND" };
    }
    static {
      this.JUNCTION = { type: 3, value: "JUNCTION" };
    }
    static {
      this.LEVELCROSSING = { type: 3, value: "LEVELCROSSING" };
    }
    static {
      this.SEGMENT = { type: 3, value: "SEGMENT" };
    }
    static {
      this.SUBSTRUCTURE = { type: 3, value: "SUBSTRUCTURE" };
    }
    static {
      this.SUPERSTRUCTURE = { type: 3, value: "SUPERSTRUCTURE" };
    }
    static {
      this.TERMINAL = { type: 3, value: "TERMINAL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcFacilityPartCommonTypeEnum = IfcFacilityPartCommonTypeEnum;
  class IfcFacilityUsageEnum {
    static {
      this.LATERAL = { type: 3, value: "LATERAL" };
    }
    static {
      this.LONGITUDINAL = { type: 3, value: "LONGITUDINAL" };
    }
    static {
      this.REGION = { type: 3, value: "REGION" };
    }
    static {
      this.VERTICAL = { type: 3, value: "VERTICAL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcFacilityUsageEnum = IfcFacilityUsageEnum;
  class IfcFanTypeEnum {
    static {
      this.CENTRIFUGALAIRFOIL = { type: 3, value: "CENTRIFUGALAIRFOIL" };
    }
    static {
      this.CENTRIFUGALBACKWARDINCLINEDCURVED = { type: 3, value: "CENTRIFUGALBACKWARDINCLINEDCURVED" };
    }
    static {
      this.CENTRIFUGALFORWARDCURVED = { type: 3, value: "CENTRIFUGALFORWARDCURVED" };
    }
    static {
      this.CENTRIFUGALRADIAL = { type: 3, value: "CENTRIFUGALRADIAL" };
    }
    static {
      this.PROPELLORAXIAL = { type: 3, value: "PROPELLORAXIAL" };
    }
    static {
      this.TUBEAXIAL = { type: 3, value: "TUBEAXIAL" };
    }
    static {
      this.VANEAXIAL = { type: 3, value: "VANEAXIAL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcFanTypeEnum = IfcFanTypeEnum;
  class IfcFastenerTypeEnum {
    static {
      this.GLUE = { type: 3, value: "GLUE" };
    }
    static {
      this.MORTAR = { type: 3, value: "MORTAR" };
    }
    static {
      this.WELD = { type: 3, value: "WELD" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcFastenerTypeEnum = IfcFastenerTypeEnum;
  class IfcFilterTypeEnum {
    static {
      this.AIRPARTICLEFILTER = { type: 3, value: "AIRPARTICLEFILTER" };
    }
    static {
      this.COMPRESSEDAIRFILTER = { type: 3, value: "COMPRESSEDAIRFILTER" };
    }
    static {
      this.ODORFILTER = { type: 3, value: "ODORFILTER" };
    }
    static {
      this.OILFILTER = { type: 3, value: "OILFILTER" };
    }
    static {
      this.STRAINER = { type: 3, value: "STRAINER" };
    }
    static {
      this.WATERFILTER = { type: 3, value: "WATERFILTER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcFilterTypeEnum = IfcFilterTypeEnum;
  class IfcFireSuppressionTerminalTypeEnum {
    static {
      this.BREECHINGINLET = { type: 3, value: "BREECHINGINLET" };
    }
    static {
      this.FIREHYDRANT = { type: 3, value: "FIREHYDRANT" };
    }
    static {
      this.FIREMONITOR = { type: 3, value: "FIREMONITOR" };
    }
    static {
      this.HOSEREEL = { type: 3, value: "HOSEREEL" };
    }
    static {
      this.SPRINKLER = { type: 3, value: "SPRINKLER" };
    }
    static {
      this.SPRINKLERDEFLECTOR = { type: 3, value: "SPRINKLERDEFLECTOR" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcFireSuppressionTerminalTypeEnum = IfcFireSuppressionTerminalTypeEnum;
  class IfcFlowDirectionEnum {
    static {
      this.SINK = { type: 3, value: "SINK" };
    }
    static {
      this.SOURCE = { type: 3, value: "SOURCE" };
    }
    static {
      this.SOURCEANDSINK = { type: 3, value: "SOURCEANDSINK" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcFlowDirectionEnum = IfcFlowDirectionEnum;
  class IfcFlowInstrumentTypeEnum {
    static {
      this.AMMETER = { type: 3, value: "AMMETER" };
    }
    static {
      this.COMBINED = { type: 3, value: "COMBINED" };
    }
    static {
      this.FREQUENCYMETER = { type: 3, value: "FREQUENCYMETER" };
    }
    static {
      this.PHASEANGLEMETER = { type: 3, value: "PHASEANGLEMETER" };
    }
    static {
      this.POWERFACTORMETER = { type: 3, value: "POWERFACTORMETER" };
    }
    static {
      this.PRESSUREGAUGE = { type: 3, value: "PRESSUREGAUGE" };
    }
    static {
      this.THERMOMETER = { type: 3, value: "THERMOMETER" };
    }
    static {
      this.VOLTMETER = { type: 3, value: "VOLTMETER" };
    }
    static {
      this.VOLTMETER_PEAK = { type: 3, value: "VOLTMETER_PEAK" };
    }
    static {
      this.VOLTMETER_RMS = { type: 3, value: "VOLTMETER_RMS" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcFlowInstrumentTypeEnum = IfcFlowInstrumentTypeEnum;
  class IfcFlowMeterTypeEnum {
    static {
      this.ENERGYMETER = { type: 3, value: "ENERGYMETER" };
    }
    static {
      this.GASMETER = { type: 3, value: "GASMETER" };
    }
    static {
      this.OILMETER = { type: 3, value: "OILMETER" };
    }
    static {
      this.WATERMETER = { type: 3, value: "WATERMETER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcFlowMeterTypeEnum = IfcFlowMeterTypeEnum;
  class IfcFootingTypeEnum {
    static {
      this.CAISSON_FOUNDATION = { type: 3, value: "CAISSON_FOUNDATION" };
    }
    static {
      this.FOOTING_BEAM = { type: 3, value: "FOOTING_BEAM" };
    }
    static {
      this.PAD_FOOTING = { type: 3, value: "PAD_FOOTING" };
    }
    static {
      this.PILE_CAP = { type: 3, value: "PILE_CAP" };
    }
    static {
      this.STRIP_FOOTING = { type: 3, value: "STRIP_FOOTING" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcFootingTypeEnum = IfcFootingTypeEnum;
  class IfcFurnitureTypeEnum {
    static {
      this.BED = { type: 3, value: "BED" };
    }
    static {
      this.CHAIR = { type: 3, value: "CHAIR" };
    }
    static {
      this.DESK = { type: 3, value: "DESK" };
    }
    static {
      this.FILECABINET = { type: 3, value: "FILECABINET" };
    }
    static {
      this.SHELF = { type: 3, value: "SHELF" };
    }
    static {
      this.SOFA = { type: 3, value: "SOFA" };
    }
    static {
      this.TABLE = { type: 3, value: "TABLE" };
    }
    static {
      this.TECHNICALCABINET = { type: 3, value: "TECHNICALCABINET" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcFurnitureTypeEnum = IfcFurnitureTypeEnum;
  class IfcGeographicElementTypeEnum {
    static {
      this.SOIL_BORING_POINT = { type: 3, value: "SOIL_BORING_POINT" };
    }
    static {
      this.TERRAIN = { type: 3, value: "TERRAIN" };
    }
    static {
      this.VEGETATION = { type: 3, value: "VEGETATION" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcGeographicElementTypeEnum = IfcGeographicElementTypeEnum;
  class IfcGeometricProjectionEnum {
    static {
      this.ELEVATION_VIEW = { type: 3, value: "ELEVATION_VIEW" };
    }
    static {
      this.GRAPH_VIEW = { type: 3, value: "GRAPH_VIEW" };
    }
    static {
      this.MODEL_VIEW = { type: 3, value: "MODEL_VIEW" };
    }
    static {
      this.PLAN_VIEW = { type: 3, value: "PLAN_VIEW" };
    }
    static {
      this.REFLECTED_PLAN_VIEW = { type: 3, value: "REFLECTED_PLAN_VIEW" };
    }
    static {
      this.SECTION_VIEW = { type: 3, value: "SECTION_VIEW" };
    }
    static {
      this.SKETCH_VIEW = { type: 3, value: "SKETCH_VIEW" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcGeometricProjectionEnum = IfcGeometricProjectionEnum;
  class IfcGeotechnicalStratumTypeEnum {
    static {
      this.SOLID = { type: 3, value: "SOLID" };
    }
    static {
      this.VOID = { type: 3, value: "VOID" };
    }
    static {
      this.WATER = { type: 3, value: "WATER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcGeotechnicalStratumTypeEnum = IfcGeotechnicalStratumTypeEnum;
  class IfcGlobalOrLocalEnum {
    static {
      this.GLOBAL_COORDS = { type: 3, value: "GLOBAL_COORDS" };
    }
    static {
      this.LOCAL_COORDS = { type: 3, value: "LOCAL_COORDS" };
    }
  }
  IFC4X32.IfcGlobalOrLocalEnum = IfcGlobalOrLocalEnum;
  class IfcGridTypeEnum {
    static {
      this.IRREGULAR = { type: 3, value: "IRREGULAR" };
    }
    static {
      this.RADIAL = { type: 3, value: "RADIAL" };
    }
    static {
      this.RECTANGULAR = { type: 3, value: "RECTANGULAR" };
    }
    static {
      this.TRIANGULAR = { type: 3, value: "TRIANGULAR" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcGridTypeEnum = IfcGridTypeEnum;
  class IfcHeatExchangerTypeEnum {
    static {
      this.PLATE = { type: 3, value: "PLATE" };
    }
    static {
      this.SHELLANDTUBE = { type: 3, value: "SHELLANDTUBE" };
    }
    static {
      this.TURNOUTHEATING = { type: 3, value: "TURNOUTHEATING" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcHeatExchangerTypeEnum = IfcHeatExchangerTypeEnum;
  class IfcHumidifierTypeEnum {
    static {
      this.ADIABATICAIRWASHER = { type: 3, value: "ADIABATICAIRWASHER" };
    }
    static {
      this.ADIABATICATOMIZING = { type: 3, value: "ADIABATICATOMIZING" };
    }
    static {
      this.ADIABATICCOMPRESSEDAIRNOZZLE = { type: 3, value: "ADIABATICCOMPRESSEDAIRNOZZLE" };
    }
    static {
      this.ADIABATICPAN = { type: 3, value: "ADIABATICPAN" };
    }
    static {
      this.ADIABATICRIGIDMEDIA = { type: 3, value: "ADIABATICRIGIDMEDIA" };
    }
    static {
      this.ADIABATICULTRASONIC = { type: 3, value: "ADIABATICULTRASONIC" };
    }
    static {
      this.ADIABATICWETTEDELEMENT = { type: 3, value: "ADIABATICWETTEDELEMENT" };
    }
    static {
      this.ASSISTEDBUTANE = { type: 3, value: "ASSISTEDBUTANE" };
    }
    static {
      this.ASSISTEDELECTRIC = { type: 3, value: "ASSISTEDELECTRIC" };
    }
    static {
      this.ASSISTEDNATURALGAS = { type: 3, value: "ASSISTEDNATURALGAS" };
    }
    static {
      this.ASSISTEDPROPANE = { type: 3, value: "ASSISTEDPROPANE" };
    }
    static {
      this.ASSISTEDSTEAM = { type: 3, value: "ASSISTEDSTEAM" };
    }
    static {
      this.STEAMINJECTION = { type: 3, value: "STEAMINJECTION" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcHumidifierTypeEnum = IfcHumidifierTypeEnum;
  class IfcImpactProtectionDeviceTypeEnum {
    static {
      this.BUMPER = { type: 3, value: "BUMPER" };
    }
    static {
      this.CRASHCUSHION = { type: 3, value: "CRASHCUSHION" };
    }
    static {
      this.DAMPINGSYSTEM = { type: 3, value: "DAMPINGSYSTEM" };
    }
    static {
      this.FENDER = { type: 3, value: "FENDER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcImpactProtectionDeviceTypeEnum = IfcImpactProtectionDeviceTypeEnum;
  class IfcInterceptorTypeEnum {
    static {
      this.CYCLONIC = { type: 3, value: "CYCLONIC" };
    }
    static {
      this.GREASE = { type: 3, value: "GREASE" };
    }
    static {
      this.OIL = { type: 3, value: "OIL" };
    }
    static {
      this.PETROL = { type: 3, value: "PETROL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcInterceptorTypeEnum = IfcInterceptorTypeEnum;
  class IfcInternalOrExternalEnum {
    static {
      this.EXTERNAL = { type: 3, value: "EXTERNAL" };
    }
    static {
      this.EXTERNAL_EARTH = { type: 3, value: "EXTERNAL_EARTH" };
    }
    static {
      this.EXTERNAL_FIRE = { type: 3, value: "EXTERNAL_FIRE" };
    }
    static {
      this.EXTERNAL_WATER = { type: 3, value: "EXTERNAL_WATER" };
    }
    static {
      this.INTERNAL = { type: 3, value: "INTERNAL" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcInternalOrExternalEnum = IfcInternalOrExternalEnum;
  class IfcInventoryTypeEnum {
    static {
      this.ASSETINVENTORY = { type: 3, value: "ASSETINVENTORY" };
    }
    static {
      this.FURNITUREINVENTORY = { type: 3, value: "FURNITUREINVENTORY" };
    }
    static {
      this.SPACEINVENTORY = { type: 3, value: "SPACEINVENTORY" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcInventoryTypeEnum = IfcInventoryTypeEnum;
  class IfcJunctionBoxTypeEnum {
    static {
      this.DATA = { type: 3, value: "DATA" };
    }
    static {
      this.POWER = { type: 3, value: "POWER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcJunctionBoxTypeEnum = IfcJunctionBoxTypeEnum;
  class IfcKnotType {
    static {
      this.PIECEWISE_BEZIER_KNOTS = { type: 3, value: "PIECEWISE_BEZIER_KNOTS" };
    }
    static {
      this.QUASI_UNIFORM_KNOTS = { type: 3, value: "QUASI_UNIFORM_KNOTS" };
    }
    static {
      this.UNIFORM_KNOTS = { type: 3, value: "UNIFORM_KNOTS" };
    }
    static {
      this.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" };
    }
  }
  IFC4X32.IfcKnotType = IfcKnotType;
  class IfcLaborResourceTypeEnum {
    static {
      this.ADMINISTRATION = { type: 3, value: "ADMINISTRATION" };
    }
    static {
      this.CARPENTRY = { type: 3, value: "CARPENTRY" };
    }
    static {
      this.CLEANING = { type: 3, value: "CLEANING" };
    }
    static {
      this.CONCRETE = { type: 3, value: "CONCRETE" };
    }
    static {
      this.DRYWALL = { type: 3, value: "DRYWALL" };
    }
    static {
      this.ELECTRIC = { type: 3, value: "ELECTRIC" };
    }
    static {
      this.FINISHING = { type: 3, value: "FINISHING" };
    }
    static {
      this.FLOORING = { type: 3, value: "FLOORING" };
    }
    static {
      this.GENERAL = { type: 3, value: "GENERAL" };
    }
    static {
      this.HVAC = { type: 3, value: "HVAC" };
    }
    static {
      this.LANDSCAPING = { type: 3, value: "LANDSCAPING" };
    }
    static {
      this.MASONRY = { type: 3, value: "MASONRY" };
    }
    static {
      this.PAINTING = { type: 3, value: "PAINTING" };
    }
    static {
      this.PAVING = { type: 3, value: "PAVING" };
    }
    static {
      this.PLUMBING = { type: 3, value: "PLUMBING" };
    }
    static {
      this.ROOFING = { type: 3, value: "ROOFING" };
    }
    static {
      this.SITEGRADING = { type: 3, value: "SITEGRADING" };
    }
    static {
      this.STEELWORK = { type: 3, value: "STEELWORK" };
    }
    static {
      this.SURVEYING = { type: 3, value: "SURVEYING" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcLaborResourceTypeEnum = IfcLaborResourceTypeEnum;
  class IfcLampTypeEnum {
    static {
      this.COMPACTFLUORESCENT = { type: 3, value: "COMPACTFLUORESCENT" };
    }
    static {
      this.FLUORESCENT = { type: 3, value: "FLUORESCENT" };
    }
    static {
      this.HALOGEN = { type: 3, value: "HALOGEN" };
    }
    static {
      this.HIGHPRESSUREMERCURY = { type: 3, value: "HIGHPRESSUREMERCURY" };
    }
    static {
      this.HIGHPRESSURESODIUM = { type: 3, value: "HIGHPRESSURESODIUM" };
    }
    static {
      this.LED = { type: 3, value: "LED" };
    }
    static {
      this.METALHALIDE = { type: 3, value: "METALHALIDE" };
    }
    static {
      this.OLED = { type: 3, value: "OLED" };
    }
    static {
      this.TUNGSTENFILAMENT = { type: 3, value: "TUNGSTENFILAMENT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcLampTypeEnum = IfcLampTypeEnum;
  class IfcLayerSetDirectionEnum {
    static {
      this.AXIS1 = { type: 3, value: "AXIS1" };
    }
    static {
      this.AXIS2 = { type: 3, value: "AXIS2" };
    }
    static {
      this.AXIS3 = { type: 3, value: "AXIS3" };
    }
  }
  IFC4X32.IfcLayerSetDirectionEnum = IfcLayerSetDirectionEnum;
  class IfcLightDistributionCurveEnum {
    static {
      this.TYPE_A = { type: 3, value: "TYPE_A" };
    }
    static {
      this.TYPE_B = { type: 3, value: "TYPE_B" };
    }
    static {
      this.TYPE_C = { type: 3, value: "TYPE_C" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcLightDistributionCurveEnum = IfcLightDistributionCurveEnum;
  class IfcLightEmissionSourceEnum {
    static {
      this.COMPACTFLUORESCENT = { type: 3, value: "COMPACTFLUORESCENT" };
    }
    static {
      this.FLUORESCENT = { type: 3, value: "FLUORESCENT" };
    }
    static {
      this.HIGHPRESSUREMERCURY = { type: 3, value: "HIGHPRESSUREMERCURY" };
    }
    static {
      this.HIGHPRESSURESODIUM = { type: 3, value: "HIGHPRESSURESODIUM" };
    }
    static {
      this.LIGHTEMITTINGDIODE = { type: 3, value: "LIGHTEMITTINGDIODE" };
    }
    static {
      this.LOWPRESSURESODIUM = { type: 3, value: "LOWPRESSURESODIUM" };
    }
    static {
      this.LOWVOLTAGEHALOGEN = { type: 3, value: "LOWVOLTAGEHALOGEN" };
    }
    static {
      this.MAINVOLTAGEHALOGEN = { type: 3, value: "MAINVOLTAGEHALOGEN" };
    }
    static {
      this.METALHALIDE = { type: 3, value: "METALHALIDE" };
    }
    static {
      this.TUNGSTENFILAMENT = { type: 3, value: "TUNGSTENFILAMENT" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcLightEmissionSourceEnum = IfcLightEmissionSourceEnum;
  class IfcLightFixtureTypeEnum {
    static {
      this.DIRECTIONSOURCE = { type: 3, value: "DIRECTIONSOURCE" };
    }
    static {
      this.POINTSOURCE = { type: 3, value: "POINTSOURCE" };
    }
    static {
      this.SECURITYLIGHTING = { type: 3, value: "SECURITYLIGHTING" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcLightFixtureTypeEnum = IfcLightFixtureTypeEnum;
  class IfcLiquidTerminalTypeEnum {
    static {
      this.HOSEREEL = { type: 3, value: "HOSEREEL" };
    }
    static {
      this.LOADINGARM = { type: 3, value: "LOADINGARM" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcLiquidTerminalTypeEnum = IfcLiquidTerminalTypeEnum;
  class IfcLoadGroupTypeEnum {
    static {
      this.LOAD_CASE = { type: 3, value: "LOAD_CASE" };
    }
    static {
      this.LOAD_COMBINATION = { type: 3, value: "LOAD_COMBINATION" };
    }
    static {
      this.LOAD_GROUP = { type: 3, value: "LOAD_GROUP" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcLoadGroupTypeEnum = IfcLoadGroupTypeEnum;
  class IfcLogicalOperatorEnum {
    static {
      this.LOGICALAND = { type: 3, value: "LOGICALAND" };
    }
    static {
      this.LOGICALNOTAND = { type: 3, value: "LOGICALNOTAND" };
    }
    static {
      this.LOGICALNOTOR = { type: 3, value: "LOGICALNOTOR" };
    }
    static {
      this.LOGICALOR = { type: 3, value: "LOGICALOR" };
    }
    static {
      this.LOGICALXOR = { type: 3, value: "LOGICALXOR" };
    }
  }
  IFC4X32.IfcLogicalOperatorEnum = IfcLogicalOperatorEnum;
  class IfcMarineFacilityTypeEnum {
    static {
      this.BARRIERBEACH = { type: 3, value: "BARRIERBEACH" };
    }
    static {
      this.BREAKWATER = { type: 3, value: "BREAKWATER" };
    }
    static {
      this.CANAL = { type: 3, value: "CANAL" };
    }
    static {
      this.DRYDOCK = { type: 3, value: "DRYDOCK" };
    }
    static {
      this.FLOATINGDOCK = { type: 3, value: "FLOATINGDOCK" };
    }
    static {
      this.HYDROLIFT = { type: 3, value: "HYDROLIFT" };
    }
    static {
      this.JETTY = { type: 3, value: "JETTY" };
    }
    static {
      this.LAUNCHRECOVERY = { type: 3, value: "LAUNCHRECOVERY" };
    }
    static {
      this.MARINEDEFENCE = { type: 3, value: "MARINEDEFENCE" };
    }
    static {
      this.NAVIGATIONALCHANNEL = { type: 3, value: "NAVIGATIONALCHANNEL" };
    }
    static {
      this.PORT = { type: 3, value: "PORT" };
    }
    static {
      this.QUAY = { type: 3, value: "QUAY" };
    }
    static {
      this.REVETMENT = { type: 3, value: "REVETMENT" };
    }
    static {
      this.SHIPLIFT = { type: 3, value: "SHIPLIFT" };
    }
    static {
      this.SHIPLOCK = { type: 3, value: "SHIPLOCK" };
    }
    static {
      this.SHIPYARD = { type: 3, value: "SHIPYARD" };
    }
    static {
      this.SLIPWAY = { type: 3, value: "SLIPWAY" };
    }
    static {
      this.WATERWAY = { type: 3, value: "WATERWAY" };
    }
    static {
      this.WATERWAYSHIPLIFT = { type: 3, value: "WATERWAYSHIPLIFT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcMarineFacilityTypeEnum = IfcMarineFacilityTypeEnum;
  class IfcMarinePartTypeEnum {
    static {
      this.ABOVEWATERLINE = { type: 3, value: "ABOVEWATERLINE" };
    }
    static {
      this.ANCHORAGE = { type: 3, value: "ANCHORAGE" };
    }
    static {
      this.APPROACHCHANNEL = { type: 3, value: "APPROACHCHANNEL" };
    }
    static {
      this.BELOWWATERLINE = { type: 3, value: "BELOWWATERLINE" };
    }
    static {
      this.BERTHINGSTRUCTURE = { type: 3, value: "BERTHINGSTRUCTURE" };
    }
    static {
      this.CHAMBER = { type: 3, value: "CHAMBER" };
    }
    static {
      this.CILL_LEVEL = { type: 3, value: "CILL_LEVEL" };
    }
    static {
      this.COPELEVEL = { type: 3, value: "COPELEVEL" };
    }
    static {
      this.CORE = { type: 3, value: "CORE" };
    }
    static {
      this.CREST = { type: 3, value: "CREST" };
    }
    static {
      this.GATEHEAD = { type: 3, value: "GATEHEAD" };
    }
    static {
      this.GUDINGSTRUCTURE = { type: 3, value: "GUDINGSTRUCTURE" };
    }
    static {
      this.HIGHWATERLINE = { type: 3, value: "HIGHWATERLINE" };
    }
    static {
      this.LANDFIELD = { type: 3, value: "LANDFIELD" };
    }
    static {
      this.LEEWARDSIDE = { type: 3, value: "LEEWARDSIDE" };
    }
    static {
      this.LOWWATERLINE = { type: 3, value: "LOWWATERLINE" };
    }
    static {
      this.MANUFACTURING = { type: 3, value: "MANUFACTURING" };
    }
    static {
      this.NAVIGATIONALAREA = { type: 3, value: "NAVIGATIONALAREA" };
    }
    static {
      this.PROTECTION = { type: 3, value: "PROTECTION" };
    }
    static {
      this.SHIPTRANSFER = { type: 3, value: "SHIPTRANSFER" };
    }
    static {
      this.STORAGEAREA = { type: 3, value: "STORAGEAREA" };
    }
    static {
      this.VEHICLESERVICING = { type: 3, value: "VEHICLESERVICING" };
    }
    static {
      this.WATERFIELD = { type: 3, value: "WATERFIELD" };
    }
    static {
      this.WEATHERSIDE = { type: 3, value: "WEATHERSIDE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcMarinePartTypeEnum = IfcMarinePartTypeEnum;
  class IfcMechanicalFastenerTypeEnum {
    static {
      this.ANCHORBOLT = { type: 3, value: "ANCHORBOLT" };
    }
    static {
      this.BOLT = { type: 3, value: "BOLT" };
    }
    static {
      this.CHAIN = { type: 3, value: "CHAIN" };
    }
    static {
      this.COUPLER = { type: 3, value: "COUPLER" };
    }
    static {
      this.DOWEL = { type: 3, value: "DOWEL" };
    }
    static {
      this.NAIL = { type: 3, value: "NAIL" };
    }
    static {
      this.NAILPLATE = { type: 3, value: "NAILPLATE" };
    }
    static {
      this.RAILFASTENING = { type: 3, value: "RAILFASTENING" };
    }
    static {
      this.RAILJOINT = { type: 3, value: "RAILJOINT" };
    }
    static {
      this.RIVET = { type: 3, value: "RIVET" };
    }
    static {
      this.ROPE = { type: 3, value: "ROPE" };
    }
    static {
      this.SCREW = { type: 3, value: "SCREW" };
    }
    static {
      this.SHEARCONNECTOR = { type: 3, value: "SHEARCONNECTOR" };
    }
    static {
      this.STAPLE = { type: 3, value: "STAPLE" };
    }
    static {
      this.STUDSHEARCONNECTOR = { type: 3, value: "STUDSHEARCONNECTOR" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcMechanicalFastenerTypeEnum = IfcMechanicalFastenerTypeEnum;
  class IfcMedicalDeviceTypeEnum {
    static {
      this.AIRSTATION = { type: 3, value: "AIRSTATION" };
    }
    static {
      this.FEEDAIRUNIT = { type: 3, value: "FEEDAIRUNIT" };
    }
    static {
      this.OXYGENGENERATOR = { type: 3, value: "OXYGENGENERATOR" };
    }
    static {
      this.OXYGENPLANT = { type: 3, value: "OXYGENPLANT" };
    }
    static {
      this.VACUUMSTATION = { type: 3, value: "VACUUMSTATION" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcMedicalDeviceTypeEnum = IfcMedicalDeviceTypeEnum;
  class IfcMemberTypeEnum {
    static {
      this.ARCH_SEGMENT = { type: 3, value: "ARCH_SEGMENT" };
    }
    static {
      this.BRACE = { type: 3, value: "BRACE" };
    }
    static {
      this.CHORD = { type: 3, value: "CHORD" };
    }
    static {
      this.COLLAR = { type: 3, value: "COLLAR" };
    }
    static {
      this.MEMBER = { type: 3, value: "MEMBER" };
    }
    static {
      this.MULLION = { type: 3, value: "MULLION" };
    }
    static {
      this.PLATE = { type: 3, value: "PLATE" };
    }
    static {
      this.POST = { type: 3, value: "POST" };
    }
    static {
      this.PURLIN = { type: 3, value: "PURLIN" };
    }
    static {
      this.RAFTER = { type: 3, value: "RAFTER" };
    }
    static {
      this.STAY_CABLE = { type: 3, value: "STAY_CABLE" };
    }
    static {
      this.STIFFENING_RIB = { type: 3, value: "STIFFENING_RIB" };
    }
    static {
      this.STRINGER = { type: 3, value: "STRINGER" };
    }
    static {
      this.STRUCTURALCABLE = { type: 3, value: "STRUCTURALCABLE" };
    }
    static {
      this.STRUT = { type: 3, value: "STRUT" };
    }
    static {
      this.STUD = { type: 3, value: "STUD" };
    }
    static {
      this.SUSPENDER = { type: 3, value: "SUSPENDER" };
    }
    static {
      this.SUSPENSION_CABLE = { type: 3, value: "SUSPENSION_CABLE" };
    }
    static {
      this.TIEBAR = { type: 3, value: "TIEBAR" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcMemberTypeEnum = IfcMemberTypeEnum;
  class IfcMobileTelecommunicationsApplianceTypeEnum {
    static {
      this.ACCESSPOINT = { type: 3, value: "ACCESSPOINT" };
    }
    static {
      this.BASEBANDUNIT = { type: 3, value: "BASEBANDUNIT" };
    }
    static {
      this.BASETRANSCEIVERSTATION = { type: 3, value: "BASETRANSCEIVERSTATION" };
    }
    static {
      this.E_UTRAN_NODE_B = { type: 3, value: "E_UTRAN_NODE_B" };
    }
    static {
      this.GATEWAY_GPRS_SUPPORT_NODE = { type: 3, value: "GATEWAY_GPRS_SUPPORT_NODE" };
    }
    static {
      this.MASTERUNIT = { type: 3, value: "MASTERUNIT" };
    }
    static {
      this.MOBILESWITCHINGCENTER = { type: 3, value: "MOBILESWITCHINGCENTER" };
    }
    static {
      this.MSCSERVER = { type: 3, value: "MSCSERVER" };
    }
    static {
      this.PACKETCONTROLUNIT = { type: 3, value: "PACKETCONTROLUNIT" };
    }
    static {
      this.REMOTERADIOUNIT = { type: 3, value: "REMOTERADIOUNIT" };
    }
    static {
      this.REMOTEUNIT = { type: 3, value: "REMOTEUNIT" };
    }
    static {
      this.SERVICE_GPRS_SUPPORT_NODE = { type: 3, value: "SERVICE_GPRS_SUPPORT_NODE" };
    }
    static {
      this.SUBSCRIBERSERVER = { type: 3, value: "SUBSCRIBERSERVER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcMobileTelecommunicationsApplianceTypeEnum = IfcMobileTelecommunicationsApplianceTypeEnum;
  class IfcMooringDeviceTypeEnum {
    static {
      this.BOLLARD = { type: 3, value: "BOLLARD" };
    }
    static {
      this.LINETENSIONER = { type: 3, value: "LINETENSIONER" };
    }
    static {
      this.MAGNETICDEVICE = { type: 3, value: "MAGNETICDEVICE" };
    }
    static {
      this.MOORINGHOOKS = { type: 3, value: "MOORINGHOOKS" };
    }
    static {
      this.VACUUMDEVICE = { type: 3, value: "VACUUMDEVICE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcMooringDeviceTypeEnum = IfcMooringDeviceTypeEnum;
  class IfcMotorConnectionTypeEnum {
    static {
      this.BELTDRIVE = { type: 3, value: "BELTDRIVE" };
    }
    static {
      this.COUPLING = { type: 3, value: "COUPLING" };
    }
    static {
      this.DIRECTDRIVE = { type: 3, value: "DIRECTDRIVE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcMotorConnectionTypeEnum = IfcMotorConnectionTypeEnum;
  class IfcNavigationElementTypeEnum {
    static {
      this.BEACON = { type: 3, value: "BEACON" };
    }
    static {
      this.BUOY = { type: 3, value: "BUOY" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcNavigationElementTypeEnum = IfcNavigationElementTypeEnum;
  class IfcObjectTypeEnum {
    static {
      this.ACTOR = { type: 3, value: "ACTOR" };
    }
    static {
      this.CONTROL = { type: 3, value: "CONTROL" };
    }
    static {
      this.GROUP = { type: 3, value: "GROUP" };
    }
    static {
      this.PROCESS = { type: 3, value: "PROCESS" };
    }
    static {
      this.PRODUCT = { type: 3, value: "PRODUCT" };
    }
    static {
      this.PROJECT = { type: 3, value: "PROJECT" };
    }
    static {
      this.RESOURCE = { type: 3, value: "RESOURCE" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcObjectTypeEnum = IfcObjectTypeEnum;
  class IfcObjectiveEnum {
    static {
      this.CODECOMPLIANCE = { type: 3, value: "CODECOMPLIANCE" };
    }
    static {
      this.CODEWAIVER = { type: 3, value: "CODEWAIVER" };
    }
    static {
      this.DESIGNINTENT = { type: 3, value: "DESIGNINTENT" };
    }
    static {
      this.EXTERNAL = { type: 3, value: "EXTERNAL" };
    }
    static {
      this.HEALTHANDSAFETY = { type: 3, value: "HEALTHANDSAFETY" };
    }
    static {
      this.MERGECONFLICT = { type: 3, value: "MERGECONFLICT" };
    }
    static {
      this.MODELVIEW = { type: 3, value: "MODELVIEW" };
    }
    static {
      this.PARAMETER = { type: 3, value: "PARAMETER" };
    }
    static {
      this.REQUIREMENT = { type: 3, value: "REQUIREMENT" };
    }
    static {
      this.SPECIFICATION = { type: 3, value: "SPECIFICATION" };
    }
    static {
      this.TRIGGERCONDITION = { type: 3, value: "TRIGGERCONDITION" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcObjectiveEnum = IfcObjectiveEnum;
  class IfcOccupantTypeEnum {
    static {
      this.ASSIGNEE = { type: 3, value: "ASSIGNEE" };
    }
    static {
      this.ASSIGNOR = { type: 3, value: "ASSIGNOR" };
    }
    static {
      this.LESSEE = { type: 3, value: "LESSEE" };
    }
    static {
      this.LESSOR = { type: 3, value: "LESSOR" };
    }
    static {
      this.LETTINGAGENT = { type: 3, value: "LETTINGAGENT" };
    }
    static {
      this.OWNER = { type: 3, value: "OWNER" };
    }
    static {
      this.TENANT = { type: 3, value: "TENANT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcOccupantTypeEnum = IfcOccupantTypeEnum;
  class IfcOpeningElementTypeEnum {
    static {
      this.OPENING = { type: 3, value: "OPENING" };
    }
    static {
      this.RECESS = { type: 3, value: "RECESS" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcOpeningElementTypeEnum = IfcOpeningElementTypeEnum;
  class IfcOutletTypeEnum {
    static {
      this.AUDIOVISUALOUTLET = { type: 3, value: "AUDIOVISUALOUTLET" };
    }
    static {
      this.COMMUNICATIONSOUTLET = { type: 3, value: "COMMUNICATIONSOUTLET" };
    }
    static {
      this.DATAOUTLET = { type: 3, value: "DATAOUTLET" };
    }
    static {
      this.POWEROUTLET = { type: 3, value: "POWEROUTLET" };
    }
    static {
      this.TELEPHONEOUTLET = { type: 3, value: "TELEPHONEOUTLET" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcOutletTypeEnum = IfcOutletTypeEnum;
  class IfcPavementTypeEnum {
    static {
      this.FLEXIBLE = { type: 3, value: "FLEXIBLE" };
    }
    static {
      this.RIGID = { type: 3, value: "RIGID" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcPavementTypeEnum = IfcPavementTypeEnum;
  class IfcPerformanceHistoryTypeEnum {
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcPerformanceHistoryTypeEnum = IfcPerformanceHistoryTypeEnum;
  class IfcPermeableCoveringOperationEnum {
    static {
      this.GRILL = { type: 3, value: "GRILL" };
    }
    static {
      this.LOUVER = { type: 3, value: "LOUVER" };
    }
    static {
      this.SCREEN = { type: 3, value: "SCREEN" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcPermeableCoveringOperationEnum = IfcPermeableCoveringOperationEnum;
  class IfcPermitTypeEnum {
    static {
      this.ACCESS = { type: 3, value: "ACCESS" };
    }
    static {
      this.BUILDING = { type: 3, value: "BUILDING" };
    }
    static {
      this.WORK = { type: 3, value: "WORK" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcPermitTypeEnum = IfcPermitTypeEnum;
  class IfcPhysicalOrVirtualEnum {
    static {
      this.PHYSICAL = { type: 3, value: "PHYSICAL" };
    }
    static {
      this.VIRTUAL = { type: 3, value: "VIRTUAL" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcPhysicalOrVirtualEnum = IfcPhysicalOrVirtualEnum;
  class IfcPileConstructionEnum {
    static {
      this.CAST_IN_PLACE = { type: 3, value: "CAST_IN_PLACE" };
    }
    static {
      this.COMPOSITE = { type: 3, value: "COMPOSITE" };
    }
    static {
      this.PRECAST_CONCRETE = { type: 3, value: "PRECAST_CONCRETE" };
    }
    static {
      this.PREFAB_STEEL = { type: 3, value: "PREFAB_STEEL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcPileConstructionEnum = IfcPileConstructionEnum;
  class IfcPileTypeEnum {
    static {
      this.BORED = { type: 3, value: "BORED" };
    }
    static {
      this.COHESION = { type: 3, value: "COHESION" };
    }
    static {
      this.DRIVEN = { type: 3, value: "DRIVEN" };
    }
    static {
      this.FRICTION = { type: 3, value: "FRICTION" };
    }
    static {
      this.JETGROUTING = { type: 3, value: "JETGROUTING" };
    }
    static {
      this.SUPPORT = { type: 3, value: "SUPPORT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcPileTypeEnum = IfcPileTypeEnum;
  class IfcPipeFittingTypeEnum {
    static {
      this.BEND = { type: 3, value: "BEND" };
    }
    static {
      this.CONNECTOR = { type: 3, value: "CONNECTOR" };
    }
    static {
      this.ENTRY = { type: 3, value: "ENTRY" };
    }
    static {
      this.EXIT = { type: 3, value: "EXIT" };
    }
    static {
      this.JUNCTION = { type: 3, value: "JUNCTION" };
    }
    static {
      this.OBSTRUCTION = { type: 3, value: "OBSTRUCTION" };
    }
    static {
      this.TRANSITION = { type: 3, value: "TRANSITION" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcPipeFittingTypeEnum = IfcPipeFittingTypeEnum;
  class IfcPipeSegmentTypeEnum {
    static {
      this.CULVERT = { type: 3, value: "CULVERT" };
    }
    static {
      this.FLEXIBLESEGMENT = { type: 3, value: "FLEXIBLESEGMENT" };
    }
    static {
      this.GUTTER = { type: 3, value: "GUTTER" };
    }
    static {
      this.RIGIDSEGMENT = { type: 3, value: "RIGIDSEGMENT" };
    }
    static {
      this.SPOOL = { type: 3, value: "SPOOL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcPipeSegmentTypeEnum = IfcPipeSegmentTypeEnum;
  class IfcPlateTypeEnum {
    static {
      this.BASE_PLATE = { type: 3, value: "BASE_PLATE" };
    }
    static {
      this.COVER_PLATE = { type: 3, value: "COVER_PLATE" };
    }
    static {
      this.CURTAIN_PANEL = { type: 3, value: "CURTAIN_PANEL" };
    }
    static {
      this.FLANGE_PLATE = { type: 3, value: "FLANGE_PLATE" };
    }
    static {
      this.GUSSET_PLATE = { type: 3, value: "GUSSET_PLATE" };
    }
    static {
      this.SHEET = { type: 3, value: "SHEET" };
    }
    static {
      this.SPLICE_PLATE = { type: 3, value: "SPLICE_PLATE" };
    }
    static {
      this.STIFFENER_PLATE = { type: 3, value: "STIFFENER_PLATE" };
    }
    static {
      this.WEB_PLATE = { type: 3, value: "WEB_PLATE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcPlateTypeEnum = IfcPlateTypeEnum;
  class IfcPreferredSurfaceCurveRepresentation {
    static {
      this.CURVE3D = { type: 3, value: "CURVE3D" };
    }
    static {
      this.PCURVE_S1 = { type: 3, value: "PCURVE_S1" };
    }
    static {
      this.PCURVE_S2 = { type: 3, value: "PCURVE_S2" };
    }
  }
  IFC4X32.IfcPreferredSurfaceCurveRepresentation = IfcPreferredSurfaceCurveRepresentation;
  class IfcProcedureTypeEnum {
    static {
      this.ADVICE_CAUTION = { type: 3, value: "ADVICE_CAUTION" };
    }
    static {
      this.ADVICE_NOTE = { type: 3, value: "ADVICE_NOTE" };
    }
    static {
      this.ADVICE_WARNING = { type: 3, value: "ADVICE_WARNING" };
    }
    static {
      this.CALIBRATION = { type: 3, value: "CALIBRATION" };
    }
    static {
      this.DIAGNOSTIC = { type: 3, value: "DIAGNOSTIC" };
    }
    static {
      this.SHUTDOWN = { type: 3, value: "SHUTDOWN" };
    }
    static {
      this.STARTUP = { type: 3, value: "STARTUP" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcProcedureTypeEnum = IfcProcedureTypeEnum;
  class IfcProfileTypeEnum {
    static {
      this.AREA = { type: 3, value: "AREA" };
    }
    static {
      this.CURVE = { type: 3, value: "CURVE" };
    }
  }
  IFC4X32.IfcProfileTypeEnum = IfcProfileTypeEnum;
  class IfcProjectOrderTypeEnum {
    static {
      this.CHANGEORDER = { type: 3, value: "CHANGEORDER" };
    }
    static {
      this.MAINTENANCEWORKORDER = { type: 3, value: "MAINTENANCEWORKORDER" };
    }
    static {
      this.MOVEORDER = { type: 3, value: "MOVEORDER" };
    }
    static {
      this.PURCHASEORDER = { type: 3, value: "PURCHASEORDER" };
    }
    static {
      this.WORKORDER = { type: 3, value: "WORKORDER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcProjectOrderTypeEnum = IfcProjectOrderTypeEnum;
  class IfcProjectedOrTrueLengthEnum {
    static {
      this.PROJECTED_LENGTH = { type: 3, value: "PROJECTED_LENGTH" };
    }
    static {
      this.TRUE_LENGTH = { type: 3, value: "TRUE_LENGTH" };
    }
  }
  IFC4X32.IfcProjectedOrTrueLengthEnum = IfcProjectedOrTrueLengthEnum;
  class IfcProjectionElementTypeEnum {
    static {
      this.BLISTER = { type: 3, value: "BLISTER" };
    }
    static {
      this.DEVIATOR = { type: 3, value: "DEVIATOR" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcProjectionElementTypeEnum = IfcProjectionElementTypeEnum;
  class IfcPropertySetTemplateTypeEnum {
    static {
      this.PSET_MATERIALDRIVEN = { type: 3, value: "PSET_MATERIALDRIVEN" };
    }
    static {
      this.PSET_OCCURRENCEDRIVEN = { type: 3, value: "PSET_OCCURRENCEDRIVEN" };
    }
    static {
      this.PSET_PERFORMANCEDRIVEN = { type: 3, value: "PSET_PERFORMANCEDRIVEN" };
    }
    static {
      this.PSET_PROFILEDRIVEN = { type: 3, value: "PSET_PROFILEDRIVEN" };
    }
    static {
      this.PSET_TYPEDRIVENONLY = { type: 3, value: "PSET_TYPEDRIVENONLY" };
    }
    static {
      this.PSET_TYPEDRIVENOVERRIDE = { type: 3, value: "PSET_TYPEDRIVENOVERRIDE" };
    }
    static {
      this.QTO_OCCURRENCEDRIVEN = { type: 3, value: "QTO_OCCURRENCEDRIVEN" };
    }
    static {
      this.QTO_TYPEDRIVENONLY = { type: 3, value: "QTO_TYPEDRIVENONLY" };
    }
    static {
      this.QTO_TYPEDRIVENOVERRIDE = { type: 3, value: "QTO_TYPEDRIVENOVERRIDE" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcPropertySetTemplateTypeEnum = IfcPropertySetTemplateTypeEnum;
  class IfcProtectiveDeviceTrippingUnitTypeEnum {
    static {
      this.ELECTROMAGNETIC = { type: 3, value: "ELECTROMAGNETIC" };
    }
    static {
      this.ELECTRONIC = { type: 3, value: "ELECTRONIC" };
    }
    static {
      this.RESIDUALCURRENT = { type: 3, value: "RESIDUALCURRENT" };
    }
    static {
      this.THERMAL = { type: 3, value: "THERMAL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcProtectiveDeviceTrippingUnitTypeEnum = IfcProtectiveDeviceTrippingUnitTypeEnum;
  class IfcProtectiveDeviceTypeEnum {
    static {
      this.ANTI_ARCING_DEVICE = { type: 3, value: "ANTI_ARCING_DEVICE" };
    }
    static {
      this.CIRCUITBREAKER = { type: 3, value: "CIRCUITBREAKER" };
    }
    static {
      this.EARTHINGSWITCH = { type: 3, value: "EARTHINGSWITCH" };
    }
    static {
      this.EARTHLEAKAGECIRCUITBREAKER = { type: 3, value: "EARTHLEAKAGECIRCUITBREAKER" };
    }
    static {
      this.FUSEDISCONNECTOR = { type: 3, value: "FUSEDISCONNECTOR" };
    }
    static {
      this.RESIDUALCURRENTCIRCUITBREAKER = { type: 3, value: "RESIDUALCURRENTCIRCUITBREAKER" };
    }
    static {
      this.RESIDUALCURRENTSWITCH = { type: 3, value: "RESIDUALCURRENTSWITCH" };
    }
    static {
      this.SPARKGAP = { type: 3, value: "SPARKGAP" };
    }
    static {
      this.VARISTOR = { type: 3, value: "VARISTOR" };
    }
    static {
      this.VOLTAGELIMITER = { type: 3, value: "VOLTAGELIMITER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcProtectiveDeviceTypeEnum = IfcProtectiveDeviceTypeEnum;
  class IfcPumpTypeEnum {
    static {
      this.CIRCULATOR = { type: 3, value: "CIRCULATOR" };
    }
    static {
      this.ENDSUCTION = { type: 3, value: "ENDSUCTION" };
    }
    static {
      this.SPLITCASE = { type: 3, value: "SPLITCASE" };
    }
    static {
      this.SUBMERSIBLEPUMP = { type: 3, value: "SUBMERSIBLEPUMP" };
    }
    static {
      this.SUMPPUMP = { type: 3, value: "SUMPPUMP" };
    }
    static {
      this.VERTICALINLINE = { type: 3, value: "VERTICALINLINE" };
    }
    static {
      this.VERTICALTURBINE = { type: 3, value: "VERTICALTURBINE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcPumpTypeEnum = IfcPumpTypeEnum;
  class IfcRailTypeEnum {
    static {
      this.BLADE = { type: 3, value: "BLADE" };
    }
    static {
      this.CHECKRAIL = { type: 3, value: "CHECKRAIL" };
    }
    static {
      this.GUARDRAIL = { type: 3, value: "GUARDRAIL" };
    }
    static {
      this.RACKRAIL = { type: 3, value: "RACKRAIL" };
    }
    static {
      this.RAIL = { type: 3, value: "RAIL" };
    }
    static {
      this.STOCKRAIL = { type: 3, value: "STOCKRAIL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcRailTypeEnum = IfcRailTypeEnum;
  class IfcRailingTypeEnum {
    static {
      this.BALUSTRADE = { type: 3, value: "BALUSTRADE" };
    }
    static {
      this.FENCE = { type: 3, value: "FENCE" };
    }
    static {
      this.GUARDRAIL = { type: 3, value: "GUARDRAIL" };
    }
    static {
      this.HANDRAIL = { type: 3, value: "HANDRAIL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcRailingTypeEnum = IfcRailingTypeEnum;
  class IfcRailwayPartTypeEnum {
    static {
      this.DILATATIONSUPERSTRUCTURE = { type: 3, value: "DILATATIONSUPERSTRUCTURE" };
    }
    static {
      this.LINESIDESTRUCTURE = { type: 3, value: "LINESIDESTRUCTURE" };
    }
    static {
      this.LINESIDESTRUCTUREPART = { type: 3, value: "LINESIDESTRUCTUREPART" };
    }
    static {
      this.PLAINTRACKSUPERSTRUCTURE = { type: 3, value: "PLAINTRACKSUPERSTRUCTURE" };
    }
    static {
      this.SUPERSTRUCTURE = { type: 3, value: "SUPERSTRUCTURE" };
    }
    static {
      this.TRACKSTRUCTURE = { type: 3, value: "TRACKSTRUCTURE" };
    }
    static {
      this.TRACKSTRUCTUREPART = { type: 3, value: "TRACKSTRUCTUREPART" };
    }
    static {
      this.TURNOUTSUPERSTRUCTURE = { type: 3, value: "TURNOUTSUPERSTRUCTURE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcRailwayPartTypeEnum = IfcRailwayPartTypeEnum;
  class IfcRailwayTypeEnum {
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcRailwayTypeEnum = IfcRailwayTypeEnum;
  class IfcRampFlightTypeEnum {
    static {
      this.SPIRAL = { type: 3, value: "SPIRAL" };
    }
    static {
      this.STRAIGHT = { type: 3, value: "STRAIGHT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcRampFlightTypeEnum = IfcRampFlightTypeEnum;
  class IfcRampTypeEnum {
    static {
      this.HALF_TURN_RAMP = { type: 3, value: "HALF_TURN_RAMP" };
    }
    static {
      this.QUARTER_TURN_RAMP = { type: 3, value: "QUARTER_TURN_RAMP" };
    }
    static {
      this.SPIRAL_RAMP = { type: 3, value: "SPIRAL_RAMP" };
    }
    static {
      this.STRAIGHT_RUN_RAMP = { type: 3, value: "STRAIGHT_RUN_RAMP" };
    }
    static {
      this.TWO_QUARTER_TURN_RAMP = { type: 3, value: "TWO_QUARTER_TURN_RAMP" };
    }
    static {
      this.TWO_STRAIGHT_RUN_RAMP = { type: 3, value: "TWO_STRAIGHT_RUN_RAMP" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcRampTypeEnum = IfcRampTypeEnum;
  class IfcRecurrenceTypeEnum {
    static {
      this.BY_DAY_COUNT = { type: 3, value: "BY_DAY_COUNT" };
    }
    static {
      this.BY_WEEKDAY_COUNT = { type: 3, value: "BY_WEEKDAY_COUNT" };
    }
    static {
      this.DAILY = { type: 3, value: "DAILY" };
    }
    static {
      this.MONTHLY_BY_DAY_OF_MONTH = { type: 3, value: "MONTHLY_BY_DAY_OF_MONTH" };
    }
    static {
      this.MONTHLY_BY_POSITION = { type: 3, value: "MONTHLY_BY_POSITION" };
    }
    static {
      this.WEEKLY = { type: 3, value: "WEEKLY" };
    }
    static {
      this.YEARLY_BY_DAY_OF_MONTH = { type: 3, value: "YEARLY_BY_DAY_OF_MONTH" };
    }
    static {
      this.YEARLY_BY_POSITION = { type: 3, value: "YEARLY_BY_POSITION" };
    }
  }
  IFC4X32.IfcRecurrenceTypeEnum = IfcRecurrenceTypeEnum;
  class IfcReferentTypeEnum {
    static {
      this.BOUNDARY = { type: 3, value: "BOUNDARY" };
    }
    static {
      this.INTERSECTION = { type: 3, value: "INTERSECTION" };
    }
    static {
      this.KILOPOINT = { type: 3, value: "KILOPOINT" };
    }
    static {
      this.LANDMARK = { type: 3, value: "LANDMARK" };
    }
    static {
      this.MILEPOINT = { type: 3, value: "MILEPOINT" };
    }
    static {
      this.POSITION = { type: 3, value: "POSITION" };
    }
    static {
      this.REFERENCEMARKER = { type: 3, value: "REFERENCEMARKER" };
    }
    static {
      this.STATION = { type: 3, value: "STATION" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcReferentTypeEnum = IfcReferentTypeEnum;
  class IfcReflectanceMethodEnum {
    static {
      this.BLINN = { type: 3, value: "BLINN" };
    }
    static {
      this.FLAT = { type: 3, value: "FLAT" };
    }
    static {
      this.GLASS = { type: 3, value: "GLASS" };
    }
    static {
      this.MATT = { type: 3, value: "MATT" };
    }
    static {
      this.METAL = { type: 3, value: "METAL" };
    }
    static {
      this.MIRROR = { type: 3, value: "MIRROR" };
    }
    static {
      this.PHONG = { type: 3, value: "PHONG" };
    }
    static {
      this.PHYSICAL = { type: 3, value: "PHYSICAL" };
    }
    static {
      this.PLASTIC = { type: 3, value: "PLASTIC" };
    }
    static {
      this.STRAUSS = { type: 3, value: "STRAUSS" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcReflectanceMethodEnum = IfcReflectanceMethodEnum;
  class IfcReinforcedSoilTypeEnum {
    static {
      this.DYNAMICALLYCOMPACTED = { type: 3, value: "DYNAMICALLYCOMPACTED" };
    }
    static {
      this.GROUTED = { type: 3, value: "GROUTED" };
    }
    static {
      this.REPLACED = { type: 3, value: "REPLACED" };
    }
    static {
      this.ROLLERCOMPACTED = { type: 3, value: "ROLLERCOMPACTED" };
    }
    static {
      this.SURCHARGEPRELOADED = { type: 3, value: "SURCHARGEPRELOADED" };
    }
    static {
      this.VERTICALLYDRAINED = { type: 3, value: "VERTICALLYDRAINED" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcReinforcedSoilTypeEnum = IfcReinforcedSoilTypeEnum;
  class IfcReinforcingBarRoleEnum {
    static {
      this.ANCHORING = { type: 3, value: "ANCHORING" };
    }
    static {
      this.EDGE = { type: 3, value: "EDGE" };
    }
    static {
      this.LIGATURE = { type: 3, value: "LIGATURE" };
    }
    static {
      this.MAIN = { type: 3, value: "MAIN" };
    }
    static {
      this.PUNCHING = { type: 3, value: "PUNCHING" };
    }
    static {
      this.RING = { type: 3, value: "RING" };
    }
    static {
      this.SHEAR = { type: 3, value: "SHEAR" };
    }
    static {
      this.STUD = { type: 3, value: "STUD" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcReinforcingBarRoleEnum = IfcReinforcingBarRoleEnum;
  class IfcReinforcingBarSurfaceEnum {
    static {
      this.PLAIN = { type: 3, value: "PLAIN" };
    }
    static {
      this.TEXTURED = { type: 3, value: "TEXTURED" };
    }
  }
  IFC4X32.IfcReinforcingBarSurfaceEnum = IfcReinforcingBarSurfaceEnum;
  class IfcReinforcingBarTypeEnum {
    static {
      this.ANCHORING = { type: 3, value: "ANCHORING" };
    }
    static {
      this.EDGE = { type: 3, value: "EDGE" };
    }
    static {
      this.LIGATURE = { type: 3, value: "LIGATURE" };
    }
    static {
      this.MAIN = { type: 3, value: "MAIN" };
    }
    static {
      this.PUNCHING = { type: 3, value: "PUNCHING" };
    }
    static {
      this.RING = { type: 3, value: "RING" };
    }
    static {
      this.SHEAR = { type: 3, value: "SHEAR" };
    }
    static {
      this.SPACEBAR = { type: 3, value: "SPACEBAR" };
    }
    static {
      this.STUD = { type: 3, value: "STUD" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcReinforcingBarTypeEnum = IfcReinforcingBarTypeEnum;
  class IfcReinforcingMeshTypeEnum {
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcReinforcingMeshTypeEnum = IfcReinforcingMeshTypeEnum;
  class IfcRoadPartTypeEnum {
    static {
      this.BICYCLECROSSING = { type: 3, value: "BICYCLECROSSING" };
    }
    static {
      this.BUS_STOP = { type: 3, value: "BUS_STOP" };
    }
    static {
      this.CARRIAGEWAY = { type: 3, value: "CARRIAGEWAY" };
    }
    static {
      this.CENTRALISLAND = { type: 3, value: "CENTRALISLAND" };
    }
    static {
      this.CENTRALRESERVE = { type: 3, value: "CENTRALRESERVE" };
    }
    static {
      this.HARDSHOULDER = { type: 3, value: "HARDSHOULDER" };
    }
    static {
      this.INTERSECTION = { type: 3, value: "INTERSECTION" };
    }
    static {
      this.LAYBY = { type: 3, value: "LAYBY" };
    }
    static {
      this.PARKINGBAY = { type: 3, value: "PARKINGBAY" };
    }
    static {
      this.PASSINGBAY = { type: 3, value: "PASSINGBAY" };
    }
    static {
      this.PEDESTRIAN_CROSSING = { type: 3, value: "PEDESTRIAN_CROSSING" };
    }
    static {
      this.RAILWAYCROSSING = { type: 3, value: "RAILWAYCROSSING" };
    }
    static {
      this.REFUGEISLAND = { type: 3, value: "REFUGEISLAND" };
    }
    static {
      this.ROADSEGMENT = { type: 3, value: "ROADSEGMENT" };
    }
    static {
      this.ROADSIDE = { type: 3, value: "ROADSIDE" };
    }
    static {
      this.ROADSIDEPART = { type: 3, value: "ROADSIDEPART" };
    }
    static {
      this.ROADWAYPLATEAU = { type: 3, value: "ROADWAYPLATEAU" };
    }
    static {
      this.ROUNDABOUT = { type: 3, value: "ROUNDABOUT" };
    }
    static {
      this.SHOULDER = { type: 3, value: "SHOULDER" };
    }
    static {
      this.SIDEWALK = { type: 3, value: "SIDEWALK" };
    }
    static {
      this.SOFTSHOULDER = { type: 3, value: "SOFTSHOULDER" };
    }
    static {
      this.TOLLPLAZA = { type: 3, value: "TOLLPLAZA" };
    }
    static {
      this.TRAFFICISLAND = { type: 3, value: "TRAFFICISLAND" };
    }
    static {
      this.TRAFFICLANE = { type: 3, value: "TRAFFICLANE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcRoadPartTypeEnum = IfcRoadPartTypeEnum;
  class IfcRoadTypeEnum {
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcRoadTypeEnum = IfcRoadTypeEnum;
  class IfcRoleEnum {
    static {
      this.ARCHITECT = { type: 3, value: "ARCHITECT" };
    }
    static {
      this.BUILDINGOPERATOR = { type: 3, value: "BUILDINGOPERATOR" };
    }
    static {
      this.BUILDINGOWNER = { type: 3, value: "BUILDINGOWNER" };
    }
    static {
      this.CIVILENGINEER = { type: 3, value: "CIVILENGINEER" };
    }
    static {
      this.CLIENT = { type: 3, value: "CLIENT" };
    }
    static {
      this.COMMISSIONINGENGINEER = { type: 3, value: "COMMISSIONINGENGINEER" };
    }
    static {
      this.CONSTRUCTIONMANAGER = { type: 3, value: "CONSTRUCTIONMANAGER" };
    }
    static {
      this.CONSULTANT = { type: 3, value: "CONSULTANT" };
    }
    static {
      this.CONTRACTOR = { type: 3, value: "CONTRACTOR" };
    }
    static {
      this.COSTENGINEER = { type: 3, value: "COSTENGINEER" };
    }
    static {
      this.ELECTRICALENGINEER = { type: 3, value: "ELECTRICALENGINEER" };
    }
    static {
      this.ENGINEER = { type: 3, value: "ENGINEER" };
    }
    static {
      this.FACILITIESMANAGER = { type: 3, value: "FACILITIESMANAGER" };
    }
    static {
      this.FIELDCONSTRUCTIONMANAGER = { type: 3, value: "FIELDCONSTRUCTIONMANAGER" };
    }
    static {
      this.MANUFACTURER = { type: 3, value: "MANUFACTURER" };
    }
    static {
      this.MECHANICALENGINEER = { type: 3, value: "MECHANICALENGINEER" };
    }
    static {
      this.OWNER = { type: 3, value: "OWNER" };
    }
    static {
      this.PROJECTMANAGER = { type: 3, value: "PROJECTMANAGER" };
    }
    static {
      this.RESELLER = { type: 3, value: "RESELLER" };
    }
    static {
      this.STRUCTURALENGINEER = { type: 3, value: "STRUCTURALENGINEER" };
    }
    static {
      this.SUBCONTRACTOR = { type: 3, value: "SUBCONTRACTOR" };
    }
    static {
      this.SUPPLIER = { type: 3, value: "SUPPLIER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
  }
  IFC4X32.IfcRoleEnum = IfcRoleEnum;
  class IfcRoofTypeEnum {
    static {
      this.BARREL_ROOF = { type: 3, value: "BARREL_ROOF" };
    }
    static {
      this.BUTTERFLY_ROOF = { type: 3, value: "BUTTERFLY_ROOF" };
    }
    static {
      this.DOME_ROOF = { type: 3, value: "DOME_ROOF" };
    }
    static {
      this.FLAT_ROOF = { type: 3, value: "FLAT_ROOF" };
    }
    static {
      this.FREEFORM = { type: 3, value: "FREEFORM" };
    }
    static {
      this.GABLE_ROOF = { type: 3, value: "GABLE_ROOF" };
    }
    static {
      this.GAMBREL_ROOF = { type: 3, value: "GAMBREL_ROOF" };
    }
    static {
      this.HIPPED_GABLE_ROOF = { type: 3, value: "HIPPED_GABLE_ROOF" };
    }
    static {
      this.HIP_ROOF = { type: 3, value: "HIP_ROOF" };
    }
    static {
      this.MANSARD_ROOF = { type: 3, value: "MANSARD_ROOF" };
    }
    static {
      this.PAVILION_ROOF = { type: 3, value: "PAVILION_ROOF" };
    }
    static {
      this.RAINBOW_ROOF = { type: 3, value: "RAINBOW_ROOF" };
    }
    static {
      this.SHED_ROOF = { type: 3, value: "SHED_ROOF" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcRoofTypeEnum = IfcRoofTypeEnum;
  class IfcSIPrefix {
    static {
      this.ATTO = { type: 3, value: "ATTO" };
    }
    static {
      this.CENTI = { type: 3, value: "CENTI" };
    }
    static {
      this.DECA = { type: 3, value: "DECA" };
    }
    static {
      this.DECI = { type: 3, value: "DECI" };
    }
    static {
      this.EXA = { type: 3, value: "EXA" };
    }
    static {
      this.FEMTO = { type: 3, value: "FEMTO" };
    }
    static {
      this.GIGA = { type: 3, value: "GIGA" };
    }
    static {
      this.HECTO = { type: 3, value: "HECTO" };
    }
    static {
      this.KILO = { type: 3, value: "KILO" };
    }
    static {
      this.MEGA = { type: 3, value: "MEGA" };
    }
    static {
      this.MICRO = { type: 3, value: "MICRO" };
    }
    static {
      this.MILLI = { type: 3, value: "MILLI" };
    }
    static {
      this.NANO = { type: 3, value: "NANO" };
    }
    static {
      this.PETA = { type: 3, value: "PETA" };
    }
    static {
      this.PICO = { type: 3, value: "PICO" };
    }
    static {
      this.TERA = { type: 3, value: "TERA" };
    }
  }
  IFC4X32.IfcSIPrefix = IfcSIPrefix;
  class IfcSIUnitName {
    static {
      this.AMPERE = { type: 3, value: "AMPERE" };
    }
    static {
      this.BECQUEREL = { type: 3, value: "BECQUEREL" };
    }
    static {
      this.CANDELA = { type: 3, value: "CANDELA" };
    }
    static {
      this.COULOMB = { type: 3, value: "COULOMB" };
    }
    static {
      this.CUBIC_METRE = { type: 3, value: "CUBIC_METRE" };
    }
    static {
      this.DEGREE_CELSIUS = { type: 3, value: "DEGREE_CELSIUS" };
    }
    static {
      this.FARAD = { type: 3, value: "FARAD" };
    }
    static {
      this.GRAM = { type: 3, value: "GRAM" };
    }
    static {
      this.GRAY = { type: 3, value: "GRAY" };
    }
    static {
      this.HENRY = { type: 3, value: "HENRY" };
    }
    static {
      this.HERTZ = { type: 3, value: "HERTZ" };
    }
    static {
      this.JOULE = { type: 3, value: "JOULE" };
    }
    static {
      this.KELVIN = { type: 3, value: "KELVIN" };
    }
    static {
      this.LUMEN = { type: 3, value: "LUMEN" };
    }
    static {
      this.LUX = { type: 3, value: "LUX" };
    }
    static {
      this.METRE = { type: 3, value: "METRE" };
    }
    static {
      this.MOLE = { type: 3, value: "MOLE" };
    }
    static {
      this.NEWTON = { type: 3, value: "NEWTON" };
    }
    static {
      this.OHM = { type: 3, value: "OHM" };
    }
    static {
      this.PASCAL = { type: 3, value: "PASCAL" };
    }
    static {
      this.RADIAN = { type: 3, value: "RADIAN" };
    }
    static {
      this.SECOND = { type: 3, value: "SECOND" };
    }
    static {
      this.SIEMENS = { type: 3, value: "SIEMENS" };
    }
    static {
      this.SIEVERT = { type: 3, value: "SIEVERT" };
    }
    static {
      this.SQUARE_METRE = { type: 3, value: "SQUARE_METRE" };
    }
    static {
      this.STERADIAN = { type: 3, value: "STERADIAN" };
    }
    static {
      this.TESLA = { type: 3, value: "TESLA" };
    }
    static {
      this.VOLT = { type: 3, value: "VOLT" };
    }
    static {
      this.WATT = { type: 3, value: "WATT" };
    }
    static {
      this.WEBER = { type: 3, value: "WEBER" };
    }
  }
  IFC4X32.IfcSIUnitName = IfcSIUnitName;
  class IfcSanitaryTerminalTypeEnum {
    static {
      this.BATH = { type: 3, value: "BATH" };
    }
    static {
      this.BIDET = { type: 3, value: "BIDET" };
    }
    static {
      this.CISTERN = { type: 3, value: "CISTERN" };
    }
    static {
      this.SANITARYFOUNTAIN = { type: 3, value: "SANITARYFOUNTAIN" };
    }
    static {
      this.SHOWER = { type: 3, value: "SHOWER" };
    }
    static {
      this.SINK = { type: 3, value: "SINK" };
    }
    static {
      this.TOILETPAN = { type: 3, value: "TOILETPAN" };
    }
    static {
      this.URINAL = { type: 3, value: "URINAL" };
    }
    static {
      this.WASHHANDBASIN = { type: 3, value: "WASHHANDBASIN" };
    }
    static {
      this.WCSEAT = { type: 3, value: "WCSEAT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcSanitaryTerminalTypeEnum = IfcSanitaryTerminalTypeEnum;
  class IfcSectionTypeEnum {
    static {
      this.TAPERED = { type: 3, value: "TAPERED" };
    }
    static {
      this.UNIFORM = { type: 3, value: "UNIFORM" };
    }
  }
  IFC4X32.IfcSectionTypeEnum = IfcSectionTypeEnum;
  class IfcSensorTypeEnum {
    static {
      this.CO2SENSOR = { type: 3, value: "CO2SENSOR" };
    }
    static {
      this.CONDUCTANCESENSOR = { type: 3, value: "CONDUCTANCESENSOR" };
    }
    static {
      this.CONTACTSENSOR = { type: 3, value: "CONTACTSENSOR" };
    }
    static {
      this.COSENSOR = { type: 3, value: "COSENSOR" };
    }
    static {
      this.EARTHQUAKESENSOR = { type: 3, value: "EARTHQUAKESENSOR" };
    }
    static {
      this.FIRESENSOR = { type: 3, value: "FIRESENSOR" };
    }
    static {
      this.FLOWSENSOR = { type: 3, value: "FLOWSENSOR" };
    }
    static {
      this.FOREIGNOBJECTDETECTIONSENSOR = { type: 3, value: "FOREIGNOBJECTDETECTIONSENSOR" };
    }
    static {
      this.FROSTSENSOR = { type: 3, value: "FROSTSENSOR" };
    }
    static {
      this.GASSENSOR = { type: 3, value: "GASSENSOR" };
    }
    static {
      this.HEATSENSOR = { type: 3, value: "HEATSENSOR" };
    }
    static {
      this.HUMIDITYSENSOR = { type: 3, value: "HUMIDITYSENSOR" };
    }
    static {
      this.IDENTIFIERSENSOR = { type: 3, value: "IDENTIFIERSENSOR" };
    }
    static {
      this.IONCONCENTRATIONSENSOR = { type: 3, value: "IONCONCENTRATIONSENSOR" };
    }
    static {
      this.LEVELSENSOR = { type: 3, value: "LEVELSENSOR" };
    }
    static {
      this.LIGHTSENSOR = { type: 3, value: "LIGHTSENSOR" };
    }
    static {
      this.MOISTURESENSOR = { type: 3, value: "MOISTURESENSOR" };
    }
    static {
      this.MOVEMENTSENSOR = { type: 3, value: "MOVEMENTSENSOR" };
    }
    static {
      this.OBSTACLESENSOR = { type: 3, value: "OBSTACLESENSOR" };
    }
    static {
      this.PHSENSOR = { type: 3, value: "PHSENSOR" };
    }
    static {
      this.PRESSURESENSOR = { type: 3, value: "PRESSURESENSOR" };
    }
    static {
      this.RADIATIONSENSOR = { type: 3, value: "RADIATIONSENSOR" };
    }
    static {
      this.RADIOACTIVITYSENSOR = { type: 3, value: "RADIOACTIVITYSENSOR" };
    }
    static {
      this.RAINSENSOR = { type: 3, value: "RAINSENSOR" };
    }
    static {
      this.SMOKESENSOR = { type: 3, value: "SMOKESENSOR" };
    }
    static {
      this.SNOWDEPTHSENSOR = { type: 3, value: "SNOWDEPTHSENSOR" };
    }
    static {
      this.SOUNDSENSOR = { type: 3, value: "SOUNDSENSOR" };
    }
    static {
      this.TEMPERATURESENSOR = { type: 3, value: "TEMPERATURESENSOR" };
    }
    static {
      this.TRAINSENSOR = { type: 3, value: "TRAINSENSOR" };
    }
    static {
      this.TURNOUTCLOSURESENSOR = { type: 3, value: "TURNOUTCLOSURESENSOR" };
    }
    static {
      this.WHEELSENSOR = { type: 3, value: "WHEELSENSOR" };
    }
    static {
      this.WINDSENSOR = { type: 3, value: "WINDSENSOR" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcSensorTypeEnum = IfcSensorTypeEnum;
  class IfcSequenceEnum {
    static {
      this.FINISH_FINISH = { type: 3, value: "FINISH_FINISH" };
    }
    static {
      this.FINISH_START = { type: 3, value: "FINISH_START" };
    }
    static {
      this.START_FINISH = { type: 3, value: "START_FINISH" };
    }
    static {
      this.START_START = { type: 3, value: "START_START" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcSequenceEnum = IfcSequenceEnum;
  class IfcShadingDeviceTypeEnum {
    static {
      this.AWNING = { type: 3, value: "AWNING" };
    }
    static {
      this.JALOUSIE = { type: 3, value: "JALOUSIE" };
    }
    static {
      this.SHUTTER = { type: 3, value: "SHUTTER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcShadingDeviceTypeEnum = IfcShadingDeviceTypeEnum;
  class IfcSignTypeEnum {
    static {
      this.MARKER = { type: 3, value: "MARKER" };
    }
    static {
      this.MIRROR = { type: 3, value: "MIRROR" };
    }
    static {
      this.PICTORAL = { type: 3, value: "PICTORAL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcSignTypeEnum = IfcSignTypeEnum;
  class IfcSignalTypeEnum {
    static {
      this.AUDIO = { type: 3, value: "AUDIO" };
    }
    static {
      this.MIXED = { type: 3, value: "MIXED" };
    }
    static {
      this.VISUAL = { type: 3, value: "VISUAL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcSignalTypeEnum = IfcSignalTypeEnum;
  class IfcSimplePropertyTemplateTypeEnum {
    static {
      this.P_BOUNDEDVALUE = { type: 3, value: "P_BOUNDEDVALUE" };
    }
    static {
      this.P_ENUMERATEDVALUE = { type: 3, value: "P_ENUMERATEDVALUE" };
    }
    static {
      this.P_LISTVALUE = { type: 3, value: "P_LISTVALUE" };
    }
    static {
      this.P_REFERENCEVALUE = { type: 3, value: "P_REFERENCEVALUE" };
    }
    static {
      this.P_SINGLEVALUE = { type: 3, value: "P_SINGLEVALUE" };
    }
    static {
      this.P_TABLEVALUE = { type: 3, value: "P_TABLEVALUE" };
    }
    static {
      this.Q_AREA = { type: 3, value: "Q_AREA" };
    }
    static {
      this.Q_COUNT = { type: 3, value: "Q_COUNT" };
    }
    static {
      this.Q_LENGTH = { type: 3, value: "Q_LENGTH" };
    }
    static {
      this.Q_NUMBER = { type: 3, value: "Q_NUMBER" };
    }
    static {
      this.Q_TIME = { type: 3, value: "Q_TIME" };
    }
    static {
      this.Q_VOLUME = { type: 3, value: "Q_VOLUME" };
    }
    static {
      this.Q_WEIGHT = { type: 3, value: "Q_WEIGHT" };
    }
  }
  IFC4X32.IfcSimplePropertyTemplateTypeEnum = IfcSimplePropertyTemplateTypeEnum;
  class IfcSlabTypeEnum {
    static {
      this.APPROACH_SLAB = { type: 3, value: "APPROACH_SLAB" };
    }
    static {
      this.BASESLAB = { type: 3, value: "BASESLAB" };
    }
    static {
      this.FLOOR = { type: 3, value: "FLOOR" };
    }
    static {
      this.LANDING = { type: 3, value: "LANDING" };
    }
    static {
      this.PAVING = { type: 3, value: "PAVING" };
    }
    static {
      this.ROOF = { type: 3, value: "ROOF" };
    }
    static {
      this.SIDEWALK = { type: 3, value: "SIDEWALK" };
    }
    static {
      this.TRACKSLAB = { type: 3, value: "TRACKSLAB" };
    }
    static {
      this.WEARING = { type: 3, value: "WEARING" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcSlabTypeEnum = IfcSlabTypeEnum;
  class IfcSolarDeviceTypeEnum {
    static {
      this.SOLARCOLLECTOR = { type: 3, value: "SOLARCOLLECTOR" };
    }
    static {
      this.SOLARPANEL = { type: 3, value: "SOLARPANEL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcSolarDeviceTypeEnum = IfcSolarDeviceTypeEnum;
  class IfcSpaceHeaterTypeEnum {
    static {
      this.CONVECTOR = { type: 3, value: "CONVECTOR" };
    }
    static {
      this.RADIATOR = { type: 3, value: "RADIATOR" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcSpaceHeaterTypeEnum = IfcSpaceHeaterTypeEnum;
  class IfcSpaceTypeEnum {
    static {
      this.BERTH = { type: 3, value: "BERTH" };
    }
    static {
      this.EXTERNAL = { type: 3, value: "EXTERNAL" };
    }
    static {
      this.GFA = { type: 3, value: "GFA" };
    }
    static {
      this.INTERNAL = { type: 3, value: "INTERNAL" };
    }
    static {
      this.PARKING = { type: 3, value: "PARKING" };
    }
    static {
      this.SPACE = { type: 3, value: "SPACE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcSpaceTypeEnum = IfcSpaceTypeEnum;
  class IfcSpatialZoneTypeEnum {
    static {
      this.CONSTRUCTION = { type: 3, value: "CONSTRUCTION" };
    }
    static {
      this.FIRESAFETY = { type: 3, value: "FIRESAFETY" };
    }
    static {
      this.INTERFERENCE = { type: 3, value: "INTERFERENCE" };
    }
    static {
      this.LIGHTING = { type: 3, value: "LIGHTING" };
    }
    static {
      this.OCCUPANCY = { type: 3, value: "OCCUPANCY" };
    }
    static {
      this.RESERVATION = { type: 3, value: "RESERVATION" };
    }
    static {
      this.SECURITY = { type: 3, value: "SECURITY" };
    }
    static {
      this.THERMAL = { type: 3, value: "THERMAL" };
    }
    static {
      this.TRANSPORT = { type: 3, value: "TRANSPORT" };
    }
    static {
      this.VENTILATION = { type: 3, value: "VENTILATION" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcSpatialZoneTypeEnum = IfcSpatialZoneTypeEnum;
  class IfcStackTerminalTypeEnum {
    static {
      this.BIRDCAGE = { type: 3, value: "BIRDCAGE" };
    }
    static {
      this.COWL = { type: 3, value: "COWL" };
    }
    static {
      this.RAINWATERHOPPER = { type: 3, value: "RAINWATERHOPPER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcStackTerminalTypeEnum = IfcStackTerminalTypeEnum;
  class IfcStairFlightTypeEnum {
    static {
      this.CURVED = { type: 3, value: "CURVED" };
    }
    static {
      this.FREEFORM = { type: 3, value: "FREEFORM" };
    }
    static {
      this.SPIRAL = { type: 3, value: "SPIRAL" };
    }
    static {
      this.STRAIGHT = { type: 3, value: "STRAIGHT" };
    }
    static {
      this.WINDER = { type: 3, value: "WINDER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcStairFlightTypeEnum = IfcStairFlightTypeEnum;
  class IfcStairTypeEnum {
    static {
      this.CURVED_RUN_STAIR = { type: 3, value: "CURVED_RUN_STAIR" };
    }
    static {
      this.DOUBLE_RETURN_STAIR = { type: 3, value: "DOUBLE_RETURN_STAIR" };
    }
    static {
      this.HALF_TURN_STAIR = { type: 3, value: "HALF_TURN_STAIR" };
    }
    static {
      this.HALF_WINDING_STAIR = { type: 3, value: "HALF_WINDING_STAIR" };
    }
    static {
      this.LADDER = { type: 3, value: "LADDER" };
    }
    static {
      this.QUARTER_TURN_STAIR = { type: 3, value: "QUARTER_TURN_STAIR" };
    }
    static {
      this.QUARTER_WINDING_STAIR = { type: 3, value: "QUARTER_WINDING_STAIR" };
    }
    static {
      this.SPIRAL_STAIR = { type: 3, value: "SPIRAL_STAIR" };
    }
    static {
      this.STRAIGHT_RUN_STAIR = { type: 3, value: "STRAIGHT_RUN_STAIR" };
    }
    static {
      this.THREE_QUARTER_TURN_STAIR = { type: 3, value: "THREE_QUARTER_TURN_STAIR" };
    }
    static {
      this.THREE_QUARTER_WINDING_STAIR = { type: 3, value: "THREE_QUARTER_WINDING_STAIR" };
    }
    static {
      this.TWO_CURVED_RUN_STAIR = { type: 3, value: "TWO_CURVED_RUN_STAIR" };
    }
    static {
      this.TWO_QUARTER_TURN_STAIR = { type: 3, value: "TWO_QUARTER_TURN_STAIR" };
    }
    static {
      this.TWO_QUARTER_WINDING_STAIR = { type: 3, value: "TWO_QUARTER_WINDING_STAIR" };
    }
    static {
      this.TWO_STRAIGHT_RUN_STAIR = { type: 3, value: "TWO_STRAIGHT_RUN_STAIR" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcStairTypeEnum = IfcStairTypeEnum;
  class IfcStateEnum {
    static {
      this.LOCKED = { type: 3, value: "LOCKED" };
    }
    static {
      this.READONLY = { type: 3, value: "READONLY" };
    }
    static {
      this.READONLYLOCKED = { type: 3, value: "READONLYLOCKED" };
    }
    static {
      this.READWRITE = { type: 3, value: "READWRITE" };
    }
    static {
      this.READWRITELOCKED = { type: 3, value: "READWRITELOCKED" };
    }
  }
  IFC4X32.IfcStateEnum = IfcStateEnum;
  class IfcStructuralCurveActivityTypeEnum {
    static {
      this.CONST = { type: 3, value: "CONST" };
    }
    static {
      this.DISCRETE = { type: 3, value: "DISCRETE" };
    }
    static {
      this.EQUIDISTANT = { type: 3, value: "EQUIDISTANT" };
    }
    static {
      this.LINEAR = { type: 3, value: "LINEAR" };
    }
    static {
      this.PARABOLA = { type: 3, value: "PARABOLA" };
    }
    static {
      this.POLYGONAL = { type: 3, value: "POLYGONAL" };
    }
    static {
      this.SINUS = { type: 3, value: "SINUS" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcStructuralCurveActivityTypeEnum = IfcStructuralCurveActivityTypeEnum;
  class IfcStructuralCurveMemberTypeEnum {
    static {
      this.CABLE = { type: 3, value: "CABLE" };
    }
    static {
      this.COMPRESSION_MEMBER = { type: 3, value: "COMPRESSION_MEMBER" };
    }
    static {
      this.PIN_JOINED_MEMBER = { type: 3, value: "PIN_JOINED_MEMBER" };
    }
    static {
      this.RIGID_JOINED_MEMBER = { type: 3, value: "RIGID_JOINED_MEMBER" };
    }
    static {
      this.TENSION_MEMBER = { type: 3, value: "TENSION_MEMBER" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcStructuralCurveMemberTypeEnum = IfcStructuralCurveMemberTypeEnum;
  class IfcStructuralSurfaceActivityTypeEnum {
    static {
      this.BILINEAR = { type: 3, value: "BILINEAR" };
    }
    static {
      this.CONST = { type: 3, value: "CONST" };
    }
    static {
      this.DISCRETE = { type: 3, value: "DISCRETE" };
    }
    static {
      this.ISOCONTOUR = { type: 3, value: "ISOCONTOUR" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcStructuralSurfaceActivityTypeEnum = IfcStructuralSurfaceActivityTypeEnum;
  class IfcStructuralSurfaceMemberTypeEnum {
    static {
      this.BENDING_ELEMENT = { type: 3, value: "BENDING_ELEMENT" };
    }
    static {
      this.MEMBRANE_ELEMENT = { type: 3, value: "MEMBRANE_ELEMENT" };
    }
    static {
      this.SHELL = { type: 3, value: "SHELL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcStructuralSurfaceMemberTypeEnum = IfcStructuralSurfaceMemberTypeEnum;
  class IfcSubContractResourceTypeEnum {
    static {
      this.PURCHASE = { type: 3, value: "PURCHASE" };
    }
    static {
      this.WORK = { type: 3, value: "WORK" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcSubContractResourceTypeEnum = IfcSubContractResourceTypeEnum;
  class IfcSurfaceFeatureTypeEnum {
    static {
      this.DEFECT = { type: 3, value: "DEFECT" };
    }
    static {
      this.HATCHMARKING = { type: 3, value: "HATCHMARKING" };
    }
    static {
      this.LINEMARKING = { type: 3, value: "LINEMARKING" };
    }
    static {
      this.MARK = { type: 3, value: "MARK" };
    }
    static {
      this.NONSKIDSURFACING = { type: 3, value: "NONSKIDSURFACING" };
    }
    static {
      this.PAVEMENTSURFACEMARKING = { type: 3, value: "PAVEMENTSURFACEMARKING" };
    }
    static {
      this.RUMBLESTRIP = { type: 3, value: "RUMBLESTRIP" };
    }
    static {
      this.SYMBOLMARKING = { type: 3, value: "SYMBOLMARKING" };
    }
    static {
      this.TAG = { type: 3, value: "TAG" };
    }
    static {
      this.TRANSVERSERUMBLESTRIP = { type: 3, value: "TRANSVERSERUMBLESTRIP" };
    }
    static {
      this.TREATMENT = { type: 3, value: "TREATMENT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcSurfaceFeatureTypeEnum = IfcSurfaceFeatureTypeEnum;
  class IfcSurfaceSide {
    static {
      this.BOTH = { type: 3, value: "BOTH" };
    }
    static {
      this.NEGATIVE = { type: 3, value: "NEGATIVE" };
    }
    static {
      this.POSITIVE = { type: 3, value: "POSITIVE" };
    }
  }
  IFC4X32.IfcSurfaceSide = IfcSurfaceSide;
  class IfcSwitchingDeviceTypeEnum {
    static {
      this.CONTACTOR = { type: 3, value: "CONTACTOR" };
    }
    static {
      this.DIMMERSWITCH = { type: 3, value: "DIMMERSWITCH" };
    }
    static {
      this.EMERGENCYSTOP = { type: 3, value: "EMERGENCYSTOP" };
    }
    static {
      this.KEYPAD = { type: 3, value: "KEYPAD" };
    }
    static {
      this.MOMENTARYSWITCH = { type: 3, value: "MOMENTARYSWITCH" };
    }
    static {
      this.RELAY = { type: 3, value: "RELAY" };
    }
    static {
      this.SELECTORSWITCH = { type: 3, value: "SELECTORSWITCH" };
    }
    static {
      this.STARTER = { type: 3, value: "STARTER" };
    }
    static {
      this.START_AND_STOP_EQUIPMENT = { type: 3, value: "START_AND_STOP_EQUIPMENT" };
    }
    static {
      this.SWITCHDISCONNECTOR = { type: 3, value: "SWITCHDISCONNECTOR" };
    }
    static {
      this.TOGGLESWITCH = { type: 3, value: "TOGGLESWITCH" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcSwitchingDeviceTypeEnum = IfcSwitchingDeviceTypeEnum;
  class IfcSystemFurnitureElementTypeEnum {
    static {
      this.PANEL = { type: 3, value: "PANEL" };
    }
    static {
      this.SUBRACK = { type: 3, value: "SUBRACK" };
    }
    static {
      this.WORKSURFACE = { type: 3, value: "WORKSURFACE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcSystemFurnitureElementTypeEnum = IfcSystemFurnitureElementTypeEnum;
  class IfcTankTypeEnum {
    static {
      this.BASIN = { type: 3, value: "BASIN" };
    }
    static {
      this.BREAKPRESSURE = { type: 3, value: "BREAKPRESSURE" };
    }
    static {
      this.EXPANSION = { type: 3, value: "EXPANSION" };
    }
    static {
      this.FEEDANDEXPANSION = { type: 3, value: "FEEDANDEXPANSION" };
    }
    static {
      this.OILRETENTIONTRAY = { type: 3, value: "OILRETENTIONTRAY" };
    }
    static {
      this.PRESSUREVESSEL = { type: 3, value: "PRESSUREVESSEL" };
    }
    static {
      this.STORAGE = { type: 3, value: "STORAGE" };
    }
    static {
      this.VESSEL = { type: 3, value: "VESSEL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcTankTypeEnum = IfcTankTypeEnum;
  class IfcTaskDurationEnum {
    static {
      this.ELAPSEDTIME = { type: 3, value: "ELAPSEDTIME" };
    }
    static {
      this.WORKTIME = { type: 3, value: "WORKTIME" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcTaskDurationEnum = IfcTaskDurationEnum;
  class IfcTaskTypeEnum {
    static {
      this.ADJUSTMENT = { type: 3, value: "ADJUSTMENT" };
    }
    static {
      this.ATTENDANCE = { type: 3, value: "ATTENDANCE" };
    }
    static {
      this.CALIBRATION = { type: 3, value: "CALIBRATION" };
    }
    static {
      this.CONSTRUCTION = { type: 3, value: "CONSTRUCTION" };
    }
    static {
      this.DEMOLITION = { type: 3, value: "DEMOLITION" };
    }
    static {
      this.DISMANTLE = { type: 3, value: "DISMANTLE" };
    }
    static {
      this.DISPOSAL = { type: 3, value: "DISPOSAL" };
    }
    static {
      this.EMERGENCY = { type: 3, value: "EMERGENCY" };
    }
    static {
      this.INSPECTION = { type: 3, value: "INSPECTION" };
    }
    static {
      this.INSTALLATION = { type: 3, value: "INSTALLATION" };
    }
    static {
      this.LOGISTIC = { type: 3, value: "LOGISTIC" };
    }
    static {
      this.MAINTENANCE = { type: 3, value: "MAINTENANCE" };
    }
    static {
      this.MOVE = { type: 3, value: "MOVE" };
    }
    static {
      this.OPERATION = { type: 3, value: "OPERATION" };
    }
    static {
      this.REMOVAL = { type: 3, value: "REMOVAL" };
    }
    static {
      this.RENOVATION = { type: 3, value: "RENOVATION" };
    }
    static {
      this.SAFETY = { type: 3, value: "SAFETY" };
    }
    static {
      this.SHUTDOWN = { type: 3, value: "SHUTDOWN" };
    }
    static {
      this.STARTUP = { type: 3, value: "STARTUP" };
    }
    static {
      this.TESTING = { type: 3, value: "TESTING" };
    }
    static {
      this.TROUBLESHOOTING = { type: 3, value: "TROUBLESHOOTING" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcTaskTypeEnum = IfcTaskTypeEnum;
  class IfcTendonAnchorTypeEnum {
    static {
      this.COUPLER = { type: 3, value: "COUPLER" };
    }
    static {
      this.FIXED_END = { type: 3, value: "FIXED_END" };
    }
    static {
      this.TENSIONING_END = { type: 3, value: "TENSIONING_END" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcTendonAnchorTypeEnum = IfcTendonAnchorTypeEnum;
  class IfcTendonConduitTypeEnum {
    static {
      this.COUPLER = { type: 3, value: "COUPLER" };
    }
    static {
      this.DIABOLO = { type: 3, value: "DIABOLO" };
    }
    static {
      this.DUCT = { type: 3, value: "DUCT" };
    }
    static {
      this.GROUTING_DUCT = { type: 3, value: "GROUTING_DUCT" };
    }
    static {
      this.TRUMPET = { type: 3, value: "TRUMPET" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcTendonConduitTypeEnum = IfcTendonConduitTypeEnum;
  class IfcTendonTypeEnum {
    static {
      this.BAR = { type: 3, value: "BAR" };
    }
    static {
      this.COATED = { type: 3, value: "COATED" };
    }
    static {
      this.STRAND = { type: 3, value: "STRAND" };
    }
    static {
      this.WIRE = { type: 3, value: "WIRE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcTendonTypeEnum = IfcTendonTypeEnum;
  class IfcTextPath {
    static {
      this.DOWN = { type: 3, value: "DOWN" };
    }
    static {
      this.LEFT = { type: 3, value: "LEFT" };
    }
    static {
      this.RIGHT = { type: 3, value: "RIGHT" };
    }
    static {
      this.UP = { type: 3, value: "UP" };
    }
  }
  IFC4X32.IfcTextPath = IfcTextPath;
  class IfcTimeSeriesDataTypeEnum {
    static {
      this.CONTINUOUS = { type: 3, value: "CONTINUOUS" };
    }
    static {
      this.DISCRETE = { type: 3, value: "DISCRETE" };
    }
    static {
      this.DISCRETEBINARY = { type: 3, value: "DISCRETEBINARY" };
    }
    static {
      this.PIECEWISEBINARY = { type: 3, value: "PIECEWISEBINARY" };
    }
    static {
      this.PIECEWISECONSTANT = { type: 3, value: "PIECEWISECONSTANT" };
    }
    static {
      this.PIECEWISECONTINUOUS = { type: 3, value: "PIECEWISECONTINUOUS" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcTimeSeriesDataTypeEnum = IfcTimeSeriesDataTypeEnum;
  class IfcTrackElementTypeEnum {
    static {
      this.BLOCKINGDEVICE = { type: 3, value: "BLOCKINGDEVICE" };
    }
    static {
      this.DERAILER = { type: 3, value: "DERAILER" };
    }
    static {
      this.FROG = { type: 3, value: "FROG" };
    }
    static {
      this.HALF_SET_OF_BLADES = { type: 3, value: "HALF_SET_OF_BLADES" };
    }
    static {
      this.SLEEPER = { type: 3, value: "SLEEPER" };
    }
    static {
      this.SPEEDREGULATOR = { type: 3, value: "SPEEDREGULATOR" };
    }
    static {
      this.TRACKENDOFALIGNMENT = { type: 3, value: "TRACKENDOFALIGNMENT" };
    }
    static {
      this.VEHICLESTOP = { type: 3, value: "VEHICLESTOP" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcTrackElementTypeEnum = IfcTrackElementTypeEnum;
  class IfcTransformerTypeEnum {
    static {
      this.CHOPPER = { type: 3, value: "CHOPPER" };
    }
    static {
      this.COMBINED = { type: 3, value: "COMBINED" };
    }
    static {
      this.CURRENT = { type: 3, value: "CURRENT" };
    }
    static {
      this.FREQUENCY = { type: 3, value: "FREQUENCY" };
    }
    static {
      this.INVERTER = { type: 3, value: "INVERTER" };
    }
    static {
      this.RECTIFIER = { type: 3, value: "RECTIFIER" };
    }
    static {
      this.VOLTAGE = { type: 3, value: "VOLTAGE" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcTransformerTypeEnum = IfcTransformerTypeEnum;
  class IfcTransitionCode {
    static {
      this.CONTINUOUS = { type: 3, value: "CONTINUOUS" };
    }
    static {
      this.CONTSAMEGRADIENT = { type: 3, value: "CONTSAMEGRADIENT" };
    }
    static {
      this.CONTSAMEGRADIENTSAMECURVATURE = { type: 3, value: "CONTSAMEGRADIENTSAMECURVATURE" };
    }
    static {
      this.DISCONTINUOUS = { type: 3, value: "DISCONTINUOUS" };
    }
  }
  IFC4X32.IfcTransitionCode = IfcTransitionCode;
  class IfcTransportElementTypeEnum {
    static {
      this.CRANEWAY = { type: 3, value: "CRANEWAY" };
    }
    static {
      this.ELEVATOR = { type: 3, value: "ELEVATOR" };
    }
    static {
      this.ESCALATOR = { type: 3, value: "ESCALATOR" };
    }
    static {
      this.HAULINGGEAR = { type: 3, value: "HAULINGGEAR" };
    }
    static {
      this.LIFTINGGEAR = { type: 3, value: "LIFTINGGEAR" };
    }
    static {
      this.MOVINGWALKWAY = { type: 3, value: "MOVINGWALKWAY" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcTransportElementTypeEnum = IfcTransportElementTypeEnum;
  class IfcTrimmingPreference {
    static {
      this.CARTESIAN = { type: 3, value: "CARTESIAN" };
    }
    static {
      this.PARAMETER = { type: 3, value: "PARAMETER" };
    }
    static {
      this.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" };
    }
  }
  IFC4X32.IfcTrimmingPreference = IfcTrimmingPreference;
  class IfcTubeBundleTypeEnum {
    static {
      this.FINNED = { type: 3, value: "FINNED" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcTubeBundleTypeEnum = IfcTubeBundleTypeEnum;
  class IfcUnitEnum {
    static {
      this.ABSORBEDDOSEUNIT = { type: 3, value: "ABSORBEDDOSEUNIT" };
    }
    static {
      this.AMOUNTOFSUBSTANCEUNIT = { type: 3, value: "AMOUNTOFSUBSTANCEUNIT" };
    }
    static {
      this.AREAUNIT = { type: 3, value: "AREAUNIT" };
    }
    static {
      this.DOSEEQUIVALENTUNIT = { type: 3, value: "DOSEEQUIVALENTUNIT" };
    }
    static {
      this.ELECTRICCAPACITANCEUNIT = { type: 3, value: "ELECTRICCAPACITANCEUNIT" };
    }
    static {
      this.ELECTRICCHARGEUNIT = { type: 3, value: "ELECTRICCHARGEUNIT" };
    }
    static {
      this.ELECTRICCONDUCTANCEUNIT = { type: 3, value: "ELECTRICCONDUCTANCEUNIT" };
    }
    static {
      this.ELECTRICCURRENTUNIT = { type: 3, value: "ELECTRICCURRENTUNIT" };
    }
    static {
      this.ELECTRICRESISTANCEUNIT = { type: 3, value: "ELECTRICRESISTANCEUNIT" };
    }
    static {
      this.ELECTRICVOLTAGEUNIT = { type: 3, value: "ELECTRICVOLTAGEUNIT" };
    }
    static {
      this.ENERGYUNIT = { type: 3, value: "ENERGYUNIT" };
    }
    static {
      this.FORCEUNIT = { type: 3, value: "FORCEUNIT" };
    }
    static {
      this.FREQUENCYUNIT = { type: 3, value: "FREQUENCYUNIT" };
    }
    static {
      this.ILLUMINANCEUNIT = { type: 3, value: "ILLUMINANCEUNIT" };
    }
    static {
      this.INDUCTANCEUNIT = { type: 3, value: "INDUCTANCEUNIT" };
    }
    static {
      this.LENGTHUNIT = { type: 3, value: "LENGTHUNIT" };
    }
    static {
      this.LUMINOUSFLUXUNIT = { type: 3, value: "LUMINOUSFLUXUNIT" };
    }
    static {
      this.LUMINOUSINTENSITYUNIT = { type: 3, value: "LUMINOUSINTENSITYUNIT" };
    }
    static {
      this.MAGNETICFLUXDENSITYUNIT = { type: 3, value: "MAGNETICFLUXDENSITYUNIT" };
    }
    static {
      this.MAGNETICFLUXUNIT = { type: 3, value: "MAGNETICFLUXUNIT" };
    }
    static {
      this.MASSUNIT = { type: 3, value: "MASSUNIT" };
    }
    static {
      this.PLANEANGLEUNIT = { type: 3, value: "PLANEANGLEUNIT" };
    }
    static {
      this.POWERUNIT = { type: 3, value: "POWERUNIT" };
    }
    static {
      this.PRESSUREUNIT = { type: 3, value: "PRESSUREUNIT" };
    }
    static {
      this.RADIOACTIVITYUNIT = { type: 3, value: "RADIOACTIVITYUNIT" };
    }
    static {
      this.SOLIDANGLEUNIT = { type: 3, value: "SOLIDANGLEUNIT" };
    }
    static {
      this.THERMODYNAMICTEMPERATUREUNIT = { type: 3, value: "THERMODYNAMICTEMPERATUREUNIT" };
    }
    static {
      this.TIMEUNIT = { type: 3, value: "TIMEUNIT" };
    }
    static {
      this.VOLUMEUNIT = { type: 3, value: "VOLUMEUNIT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
  }
  IFC4X32.IfcUnitEnum = IfcUnitEnum;
  class IfcUnitaryControlElementTypeEnum {
    static {
      this.ALARMPANEL = { type: 3, value: "ALARMPANEL" };
    }
    static {
      this.BASESTATIONCONTROLLER = { type: 3, value: "BASESTATIONCONTROLLER" };
    }
    static {
      this.COMBINED = { type: 3, value: "COMBINED" };
    }
    static {
      this.CONTROLPANEL = { type: 3, value: "CONTROLPANEL" };
    }
    static {
      this.GASDETECTIONPANEL = { type: 3, value: "GASDETECTIONPANEL" };
    }
    static {
      this.HUMIDISTAT = { type: 3, value: "HUMIDISTAT" };
    }
    static {
      this.INDICATORPANEL = { type: 3, value: "INDICATORPANEL" };
    }
    static {
      this.MIMICPANEL = { type: 3, value: "MIMICPANEL" };
    }
    static {
      this.THERMOSTAT = { type: 3, value: "THERMOSTAT" };
    }
    static {
      this.WEATHERSTATION = { type: 3, value: "WEATHERSTATION" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcUnitaryControlElementTypeEnum = IfcUnitaryControlElementTypeEnum;
  class IfcUnitaryEquipmentTypeEnum {
    static {
      this.AIRCONDITIONINGUNIT = { type: 3, value: "AIRCONDITIONINGUNIT" };
    }
    static {
      this.AIRHANDLER = { type: 3, value: "AIRHANDLER" };
    }
    static {
      this.DEHUMIDIFIER = { type: 3, value: "DEHUMIDIFIER" };
    }
    static {
      this.ROOFTOPUNIT = { type: 3, value: "ROOFTOPUNIT" };
    }
    static {
      this.SPLITSYSTEM = { type: 3, value: "SPLITSYSTEM" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcUnitaryEquipmentTypeEnum = IfcUnitaryEquipmentTypeEnum;
  class IfcValveTypeEnum {
    static {
      this.AIRRELEASE = { type: 3, value: "AIRRELEASE" };
    }
    static {
      this.ANTIVACUUM = { type: 3, value: "ANTIVACUUM" };
    }
    static {
      this.CHANGEOVER = { type: 3, value: "CHANGEOVER" };
    }
    static {
      this.CHECK = { type: 3, value: "CHECK" };
    }
    static {
      this.COMMISSIONING = { type: 3, value: "COMMISSIONING" };
    }
    static {
      this.DIVERTING = { type: 3, value: "DIVERTING" };
    }
    static {
      this.DOUBLECHECK = { type: 3, value: "DOUBLECHECK" };
    }
    static {
      this.DOUBLEREGULATING = { type: 3, value: "DOUBLEREGULATING" };
    }
    static {
      this.DRAWOFFCOCK = { type: 3, value: "DRAWOFFCOCK" };
    }
    static {
      this.FAUCET = { type: 3, value: "FAUCET" };
    }
    static {
      this.FLUSHING = { type: 3, value: "FLUSHING" };
    }
    static {
      this.GASCOCK = { type: 3, value: "GASCOCK" };
    }
    static {
      this.GASTAP = { type: 3, value: "GASTAP" };
    }
    static {
      this.ISOLATING = { type: 3, value: "ISOLATING" };
    }
    static {
      this.MIXING = { type: 3, value: "MIXING" };
    }
    static {
      this.PRESSUREREDUCING = { type: 3, value: "PRESSUREREDUCING" };
    }
    static {
      this.PRESSURERELIEF = { type: 3, value: "PRESSURERELIEF" };
    }
    static {
      this.REGULATING = { type: 3, value: "REGULATING" };
    }
    static {
      this.SAFETYCUTOFF = { type: 3, value: "SAFETYCUTOFF" };
    }
    static {
      this.STEAMTRAP = { type: 3, value: "STEAMTRAP" };
    }
    static {
      this.STOPCOCK = { type: 3, value: "STOPCOCK" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcValveTypeEnum = IfcValveTypeEnum;
  class IfcVehicleTypeEnum {
    static {
      this.CARGO = { type: 3, value: "CARGO" };
    }
    static {
      this.ROLLINGSTOCK = { type: 3, value: "ROLLINGSTOCK" };
    }
    static {
      this.VEHICLE = { type: 3, value: "VEHICLE" };
    }
    static {
      this.VEHICLEAIR = { type: 3, value: "VEHICLEAIR" };
    }
    static {
      this.VEHICLEMARINE = { type: 3, value: "VEHICLEMARINE" };
    }
    static {
      this.VEHICLETRACKED = { type: 3, value: "VEHICLETRACKED" };
    }
    static {
      this.VEHICLEWHEELED = { type: 3, value: "VEHICLEWHEELED" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcVehicleTypeEnum = IfcVehicleTypeEnum;
  class IfcVibrationDamperTypeEnum {
    static {
      this.AXIAL_YIELD = { type: 3, value: "AXIAL_YIELD" };
    }
    static {
      this.BENDING_YIELD = { type: 3, value: "BENDING_YIELD" };
    }
    static {
      this.FRICTION = { type: 3, value: "FRICTION" };
    }
    static {
      this.RUBBER = { type: 3, value: "RUBBER" };
    }
    static {
      this.SHEAR_YIELD = { type: 3, value: "SHEAR_YIELD" };
    }
    static {
      this.VISCOUS = { type: 3, value: "VISCOUS" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcVibrationDamperTypeEnum = IfcVibrationDamperTypeEnum;
  class IfcVibrationIsolatorTypeEnum {
    static {
      this.BASE = { type: 3, value: "BASE" };
    }
    static {
      this.COMPRESSION = { type: 3, value: "COMPRESSION" };
    }
    static {
      this.SPRING = { type: 3, value: "SPRING" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcVibrationIsolatorTypeEnum = IfcVibrationIsolatorTypeEnum;
  class IfcVirtualElementTypeEnum {
    static {
      this.BOUNDARY = { type: 3, value: "BOUNDARY" };
    }
    static {
      this.CLEARANCE = { type: 3, value: "CLEARANCE" };
    }
    static {
      this.PROVISIONFORVOID = { type: 3, value: "PROVISIONFORVOID" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcVirtualElementTypeEnum = IfcVirtualElementTypeEnum;
  class IfcVoidingFeatureTypeEnum {
    static {
      this.CHAMFER = { type: 3, value: "CHAMFER" };
    }
    static {
      this.CUTOUT = { type: 3, value: "CUTOUT" };
    }
    static {
      this.EDGE = { type: 3, value: "EDGE" };
    }
    static {
      this.HOLE = { type: 3, value: "HOLE" };
    }
    static {
      this.MITER = { type: 3, value: "MITER" };
    }
    static {
      this.NOTCH = { type: 3, value: "NOTCH" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcVoidingFeatureTypeEnum = IfcVoidingFeatureTypeEnum;
  class IfcWallTypeEnum {
    static {
      this.ELEMENTEDWALL = { type: 3, value: "ELEMENTEDWALL" };
    }
    static {
      this.MOVABLE = { type: 3, value: "MOVABLE" };
    }
    static {
      this.PARAPET = { type: 3, value: "PARAPET" };
    }
    static {
      this.PARTITIONING = { type: 3, value: "PARTITIONING" };
    }
    static {
      this.PLUMBINGWALL = { type: 3, value: "PLUMBINGWALL" };
    }
    static {
      this.POLYGONAL = { type: 3, value: "POLYGONAL" };
    }
    static {
      this.RETAININGWALL = { type: 3, value: "RETAININGWALL" };
    }
    static {
      this.SHEAR = { type: 3, value: "SHEAR" };
    }
    static {
      this.SOLIDWALL = { type: 3, value: "SOLIDWALL" };
    }
    static {
      this.STANDARD = { type: 3, value: "STANDARD" };
    }
    static {
      this.WAVEWALL = { type: 3, value: "WAVEWALL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcWallTypeEnum = IfcWallTypeEnum;
  class IfcWasteTerminalTypeEnum {
    static {
      this.FLOORTRAP = { type: 3, value: "FLOORTRAP" };
    }
    static {
      this.FLOORWASTE = { type: 3, value: "FLOORWASTE" };
    }
    static {
      this.GULLYSUMP = { type: 3, value: "GULLYSUMP" };
    }
    static {
      this.GULLYTRAP = { type: 3, value: "GULLYTRAP" };
    }
    static {
      this.ROOFDRAIN = { type: 3, value: "ROOFDRAIN" };
    }
    static {
      this.WASTEDISPOSALUNIT = { type: 3, value: "WASTEDISPOSALUNIT" };
    }
    static {
      this.WASTETRAP = { type: 3, value: "WASTETRAP" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcWasteTerminalTypeEnum = IfcWasteTerminalTypeEnum;
  class IfcWindowPanelOperationEnum {
    static {
      this.BOTTOMHUNG = { type: 3, value: "BOTTOMHUNG" };
    }
    static {
      this.FIXEDCASEMENT = { type: 3, value: "FIXEDCASEMENT" };
    }
    static {
      this.OTHEROPERATION = { type: 3, value: "OTHEROPERATION" };
    }
    static {
      this.PIVOTHORIZONTAL = { type: 3, value: "PIVOTHORIZONTAL" };
    }
    static {
      this.PIVOTVERTICAL = { type: 3, value: "PIVOTVERTICAL" };
    }
    static {
      this.REMOVABLECASEMENT = { type: 3, value: "REMOVABLECASEMENT" };
    }
    static {
      this.SIDEHUNGLEFTHAND = { type: 3, value: "SIDEHUNGLEFTHAND" };
    }
    static {
      this.SIDEHUNGRIGHTHAND = { type: 3, value: "SIDEHUNGRIGHTHAND" };
    }
    static {
      this.SLIDINGHORIZONTAL = { type: 3, value: "SLIDINGHORIZONTAL" };
    }
    static {
      this.SLIDINGVERTICAL = { type: 3, value: "SLIDINGVERTICAL" };
    }
    static {
      this.TILTANDTURNLEFTHAND = { type: 3, value: "TILTANDTURNLEFTHAND" };
    }
    static {
      this.TILTANDTURNRIGHTHAND = { type: 3, value: "TILTANDTURNRIGHTHAND" };
    }
    static {
      this.TOPHUNG = { type: 3, value: "TOPHUNG" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcWindowPanelOperationEnum = IfcWindowPanelOperationEnum;
  class IfcWindowPanelPositionEnum {
    static {
      this.BOTTOM = { type: 3, value: "BOTTOM" };
    }
    static {
      this.LEFT = { type: 3, value: "LEFT" };
    }
    static {
      this.MIDDLE = { type: 3, value: "MIDDLE" };
    }
    static {
      this.RIGHT = { type: 3, value: "RIGHT" };
    }
    static {
      this.TOP = { type: 3, value: "TOP" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcWindowPanelPositionEnum = IfcWindowPanelPositionEnum;
  class IfcWindowStyleConstructionEnum {
    static {
      this.ALUMINIUM = { type: 3, value: "ALUMINIUM" };
    }
    static {
      this.ALUMINIUM_WOOD = { type: 3, value: "ALUMINIUM_WOOD" };
    }
    static {
      this.HIGH_GRADE_STEEL = { type: 3, value: "HIGH_GRADE_STEEL" };
    }
    static {
      this.OTHER_CONSTRUCTION = { type: 3, value: "OTHER_CONSTRUCTION" };
    }
    static {
      this.PLASTIC = { type: 3, value: "PLASTIC" };
    }
    static {
      this.STEEL = { type: 3, value: "STEEL" };
    }
    static {
      this.WOOD = { type: 3, value: "WOOD" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcWindowStyleConstructionEnum = IfcWindowStyleConstructionEnum;
  class IfcWindowStyleOperationEnum {
    static {
      this.DOUBLE_PANEL_HORIZONTAL = { type: 3, value: "DOUBLE_PANEL_HORIZONTAL" };
    }
    static {
      this.DOUBLE_PANEL_VERTICAL = { type: 3, value: "DOUBLE_PANEL_VERTICAL" };
    }
    static {
      this.SINGLE_PANEL = { type: 3, value: "SINGLE_PANEL" };
    }
    static {
      this.TRIPLE_PANEL_BOTTOM = { type: 3, value: "TRIPLE_PANEL_BOTTOM" };
    }
    static {
      this.TRIPLE_PANEL_HORIZONTAL = { type: 3, value: "TRIPLE_PANEL_HORIZONTAL" };
    }
    static {
      this.TRIPLE_PANEL_LEFT = { type: 3, value: "TRIPLE_PANEL_LEFT" };
    }
    static {
      this.TRIPLE_PANEL_RIGHT = { type: 3, value: "TRIPLE_PANEL_RIGHT" };
    }
    static {
      this.TRIPLE_PANEL_TOP = { type: 3, value: "TRIPLE_PANEL_TOP" };
    }
    static {
      this.TRIPLE_PANEL_VERTICAL = { type: 3, value: "TRIPLE_PANEL_VERTICAL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcWindowStyleOperationEnum = IfcWindowStyleOperationEnum;
  class IfcWindowTypeEnum {
    static {
      this.LIGHTDOME = { type: 3, value: "LIGHTDOME" };
    }
    static {
      this.SKYLIGHT = { type: 3, value: "SKYLIGHT" };
    }
    static {
      this.WINDOW = { type: 3, value: "WINDOW" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcWindowTypeEnum = IfcWindowTypeEnum;
  class IfcWindowTypePartitioningEnum {
    static {
      this.DOUBLE_PANEL_HORIZONTAL = { type: 3, value: "DOUBLE_PANEL_HORIZONTAL" };
    }
    static {
      this.DOUBLE_PANEL_VERTICAL = { type: 3, value: "DOUBLE_PANEL_VERTICAL" };
    }
    static {
      this.SINGLE_PANEL = { type: 3, value: "SINGLE_PANEL" };
    }
    static {
      this.TRIPLE_PANEL_BOTTOM = { type: 3, value: "TRIPLE_PANEL_BOTTOM" };
    }
    static {
      this.TRIPLE_PANEL_HORIZONTAL = { type: 3, value: "TRIPLE_PANEL_HORIZONTAL" };
    }
    static {
      this.TRIPLE_PANEL_LEFT = { type: 3, value: "TRIPLE_PANEL_LEFT" };
    }
    static {
      this.TRIPLE_PANEL_RIGHT = { type: 3, value: "TRIPLE_PANEL_RIGHT" };
    }
    static {
      this.TRIPLE_PANEL_TOP = { type: 3, value: "TRIPLE_PANEL_TOP" };
    }
    static {
      this.TRIPLE_PANEL_VERTICAL = { type: 3, value: "TRIPLE_PANEL_VERTICAL" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcWindowTypePartitioningEnum = IfcWindowTypePartitioningEnum;
  class IfcWorkCalendarTypeEnum {
    static {
      this.FIRSTSHIFT = { type: 3, value: "FIRSTSHIFT" };
    }
    static {
      this.SECONDSHIFT = { type: 3, value: "SECONDSHIFT" };
    }
    static {
      this.THIRDSHIFT = { type: 3, value: "THIRDSHIFT" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcWorkCalendarTypeEnum = IfcWorkCalendarTypeEnum;
  class IfcWorkPlanTypeEnum {
    static {
      this.ACTUAL = { type: 3, value: "ACTUAL" };
    }
    static {
      this.BASELINE = { type: 3, value: "BASELINE" };
    }
    static {
      this.PLANNED = { type: 3, value: "PLANNED" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcWorkPlanTypeEnum = IfcWorkPlanTypeEnum;
  class IfcWorkScheduleTypeEnum {
    static {
      this.ACTUAL = { type: 3, value: "ACTUAL" };
    }
    static {
      this.BASELINE = { type: 3, value: "BASELINE" };
    }
    static {
      this.PLANNED = { type: 3, value: "PLANNED" };
    }
    static {
      this.USERDEFINED = { type: 3, value: "USERDEFINED" };
    }
    static {
      this.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
    }
  }
  IFC4X32.IfcWorkScheduleTypeEnum = IfcWorkScheduleTypeEnum;
  class IfcActorRole extends IfcLineObject {
    constructor(Role, UserDefinedRole, Description) {
      super();
      this.Role = Role;
      this.UserDefinedRole = UserDefinedRole;
      this.Description = Description;
      this.type = 3630933823;
    }
  }
  IFC4X32.IfcActorRole = IfcActorRole;
  class IfcAddress extends IfcLineObject {
    constructor(Purpose, Description, UserDefinedPurpose) {
      super();
      this.Purpose = Purpose;
      this.Description = Description;
      this.UserDefinedPurpose = UserDefinedPurpose;
      this.type = 618182010;
    }
  }
  IFC4X32.IfcAddress = IfcAddress;
  class IfcAlignmentParameterSegment extends IfcLineObject {
    constructor(StartTag, EndTag) {
      super();
      this.StartTag = StartTag;
      this.EndTag = EndTag;
      this.type = 2879124712;
    }
  }
  IFC4X32.IfcAlignmentParameterSegment = IfcAlignmentParameterSegment;
  class IfcAlignmentVerticalSegment extends IfcAlignmentParameterSegment {
    constructor(StartTag, EndTag, StartDistAlong, HorizontalLength, StartHeight, StartGradient, EndGradient, RadiusOfCurvature, PredefinedType) {
      super(StartTag, EndTag);
      this.StartTag = StartTag;
      this.EndTag = EndTag;
      this.StartDistAlong = StartDistAlong;
      this.HorizontalLength = HorizontalLength;
      this.StartHeight = StartHeight;
      this.StartGradient = StartGradient;
      this.EndGradient = EndGradient;
      this.RadiusOfCurvature = RadiusOfCurvature;
      this.PredefinedType = PredefinedType;
      this.type = 3633395639;
    }
  }
  IFC4X32.IfcAlignmentVerticalSegment = IfcAlignmentVerticalSegment;
  class IfcApplication extends IfcLineObject {
    constructor(ApplicationDeveloper, Version, ApplicationFullName, ApplicationIdentifier) {
      super();
      this.ApplicationDeveloper = ApplicationDeveloper;
      this.Version = Version;
      this.ApplicationFullName = ApplicationFullName;
      this.ApplicationIdentifier = ApplicationIdentifier;
      this.type = 639542469;
    }
  }
  IFC4X32.IfcApplication = IfcApplication;
  class IfcAppliedValue extends IfcLineObject {
    constructor(Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate, Category, Condition, ArithmeticOperator, Components) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.AppliedValue = AppliedValue;
      this.UnitBasis = UnitBasis;
      this.ApplicableDate = ApplicableDate;
      this.FixedUntilDate = FixedUntilDate;
      this.Category = Category;
      this.Condition = Condition;
      this.ArithmeticOperator = ArithmeticOperator;
      this.Components = Components;
      this.type = 411424972;
    }
  }
  IFC4X32.IfcAppliedValue = IfcAppliedValue;
  class IfcApproval extends IfcLineObject {
    constructor(Identifier, Name, Description, TimeOfApproval, Status, Level, Qualifier, RequestingApproval, GivingApproval) {
      super();
      this.Identifier = Identifier;
      this.Name = Name;
      this.Description = Description;
      this.TimeOfApproval = TimeOfApproval;
      this.Status = Status;
      this.Level = Level;
      this.Qualifier = Qualifier;
      this.RequestingApproval = RequestingApproval;
      this.GivingApproval = GivingApproval;
      this.type = 130549933;
    }
  }
  IFC4X32.IfcApproval = IfcApproval;
  class IfcBoundaryCondition extends IfcLineObject {
    constructor(Name) {
      super();
      this.Name = Name;
      this.type = 4037036970;
    }
  }
  IFC4X32.IfcBoundaryCondition = IfcBoundaryCondition;
  class IfcBoundaryEdgeCondition extends IfcBoundaryCondition {
    constructor(Name, TranslationalStiffnessByLengthX, TranslationalStiffnessByLengthY, TranslationalStiffnessByLengthZ, RotationalStiffnessByLengthX, RotationalStiffnessByLengthY, RotationalStiffnessByLengthZ) {
      super(Name);
      this.Name = Name;
      this.TranslationalStiffnessByLengthX = TranslationalStiffnessByLengthX;
      this.TranslationalStiffnessByLengthY = TranslationalStiffnessByLengthY;
      this.TranslationalStiffnessByLengthZ = TranslationalStiffnessByLengthZ;
      this.RotationalStiffnessByLengthX = RotationalStiffnessByLengthX;
      this.RotationalStiffnessByLengthY = RotationalStiffnessByLengthY;
      this.RotationalStiffnessByLengthZ = RotationalStiffnessByLengthZ;
      this.type = 1560379544;
    }
  }
  IFC4X32.IfcBoundaryEdgeCondition = IfcBoundaryEdgeCondition;
  class IfcBoundaryFaceCondition extends IfcBoundaryCondition {
    constructor(Name, TranslationalStiffnessByAreaX, TranslationalStiffnessByAreaY, TranslationalStiffnessByAreaZ) {
      super(Name);
      this.Name = Name;
      this.TranslationalStiffnessByAreaX = TranslationalStiffnessByAreaX;
      this.TranslationalStiffnessByAreaY = TranslationalStiffnessByAreaY;
      this.TranslationalStiffnessByAreaZ = TranslationalStiffnessByAreaZ;
      this.type = 3367102660;
    }
  }
  IFC4X32.IfcBoundaryFaceCondition = IfcBoundaryFaceCondition;
  class IfcBoundaryNodeCondition extends IfcBoundaryCondition {
    constructor(Name, TranslationalStiffnessX, TranslationalStiffnessY, TranslationalStiffnessZ, RotationalStiffnessX, RotationalStiffnessY, RotationalStiffnessZ) {
      super(Name);
      this.Name = Name;
      this.TranslationalStiffnessX = TranslationalStiffnessX;
      this.TranslationalStiffnessY = TranslationalStiffnessY;
      this.TranslationalStiffnessZ = TranslationalStiffnessZ;
      this.RotationalStiffnessX = RotationalStiffnessX;
      this.RotationalStiffnessY = RotationalStiffnessY;
      this.RotationalStiffnessZ = RotationalStiffnessZ;
      this.type = 1387855156;
    }
  }
  IFC4X32.IfcBoundaryNodeCondition = IfcBoundaryNodeCondition;
  class IfcBoundaryNodeConditionWarping extends IfcBoundaryNodeCondition {
    constructor(Name, TranslationalStiffnessX, TranslationalStiffnessY, TranslationalStiffnessZ, RotationalStiffnessX, RotationalStiffnessY, RotationalStiffnessZ, WarpingStiffness) {
      super(Name, TranslationalStiffnessX, TranslationalStiffnessY, TranslationalStiffnessZ, RotationalStiffnessX, RotationalStiffnessY, RotationalStiffnessZ);
      this.Name = Name;
      this.TranslationalStiffnessX = TranslationalStiffnessX;
      this.TranslationalStiffnessY = TranslationalStiffnessY;
      this.TranslationalStiffnessZ = TranslationalStiffnessZ;
      this.RotationalStiffnessX = RotationalStiffnessX;
      this.RotationalStiffnessY = RotationalStiffnessY;
      this.RotationalStiffnessZ = RotationalStiffnessZ;
      this.WarpingStiffness = WarpingStiffness;
      this.type = 2069777674;
    }
  }
  IFC4X32.IfcBoundaryNodeConditionWarping = IfcBoundaryNodeConditionWarping;
  class IfcConnectionGeometry extends IfcLineObject {
    constructor() {
      super();
      this.type = 2859738748;
    }
  }
  IFC4X32.IfcConnectionGeometry = IfcConnectionGeometry;
  class IfcConnectionPointGeometry extends IfcConnectionGeometry {
    constructor(PointOnRelatingElement, PointOnRelatedElement) {
      super();
      this.PointOnRelatingElement = PointOnRelatingElement;
      this.PointOnRelatedElement = PointOnRelatedElement;
      this.type = 2614616156;
    }
  }
  IFC4X32.IfcConnectionPointGeometry = IfcConnectionPointGeometry;
  class IfcConnectionSurfaceGeometry extends IfcConnectionGeometry {
    constructor(SurfaceOnRelatingElement, SurfaceOnRelatedElement) {
      super();
      this.SurfaceOnRelatingElement = SurfaceOnRelatingElement;
      this.SurfaceOnRelatedElement = SurfaceOnRelatedElement;
      this.type = 2732653382;
    }
  }
  IFC4X32.IfcConnectionSurfaceGeometry = IfcConnectionSurfaceGeometry;
  class IfcConnectionVolumeGeometry extends IfcConnectionGeometry {
    constructor(VolumeOnRelatingElement, VolumeOnRelatedElement) {
      super();
      this.VolumeOnRelatingElement = VolumeOnRelatingElement;
      this.VolumeOnRelatedElement = VolumeOnRelatedElement;
      this.type = 775493141;
    }
  }
  IFC4X32.IfcConnectionVolumeGeometry = IfcConnectionVolumeGeometry;
  class IfcConstraint extends IfcLineObject {
    constructor(Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.ConstraintGrade = ConstraintGrade;
      this.ConstraintSource = ConstraintSource;
      this.CreatingActor = CreatingActor;
      this.CreationTime = CreationTime;
      this.UserDefinedGrade = UserDefinedGrade;
      this.type = 1959218052;
    }
  }
  IFC4X32.IfcConstraint = IfcConstraint;
  class IfcCoordinateOperation extends IfcLineObject {
    constructor(SourceCRS, TargetCRS) {
      super();
      this.SourceCRS = SourceCRS;
      this.TargetCRS = TargetCRS;
      this.type = 1785450214;
    }
  }
  IFC4X32.IfcCoordinateOperation = IfcCoordinateOperation;
  class IfcCoordinateReferenceSystem extends IfcLineObject {
    constructor(Name, Description, GeodeticDatum, VerticalDatum) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.GeodeticDatum = GeodeticDatum;
      this.VerticalDatum = VerticalDatum;
      this.type = 1466758467;
    }
  }
  IFC4X32.IfcCoordinateReferenceSystem = IfcCoordinateReferenceSystem;
  class IfcCostValue extends IfcAppliedValue {
    constructor(Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate, Category, Condition, ArithmeticOperator, Components) {
      super(Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate, Category, Condition, ArithmeticOperator, Components);
      this.Name = Name;
      this.Description = Description;
      this.AppliedValue = AppliedValue;
      this.UnitBasis = UnitBasis;
      this.ApplicableDate = ApplicableDate;
      this.FixedUntilDate = FixedUntilDate;
      this.Category = Category;
      this.Condition = Condition;
      this.ArithmeticOperator = ArithmeticOperator;
      this.Components = Components;
      this.type = 602808272;
    }
  }
  IFC4X32.IfcCostValue = IfcCostValue;
  class IfcDerivedUnit extends IfcLineObject {
    constructor(Elements, UnitType, UserDefinedType, Name) {
      super();
      this.Elements = Elements;
      this.UnitType = UnitType;
      this.UserDefinedType = UserDefinedType;
      this.Name = Name;
      this.type = 1765591967;
    }
  }
  IFC4X32.IfcDerivedUnit = IfcDerivedUnit;
  class IfcDerivedUnitElement extends IfcLineObject {
    constructor(Unit, Exponent) {
      super();
      this.Unit = Unit;
      this.Exponent = Exponent;
      this.type = 1045800335;
    }
  }
  IFC4X32.IfcDerivedUnitElement = IfcDerivedUnitElement;
  class IfcDimensionalExponents extends IfcLineObject {
    constructor(LengthExponent, MassExponent, TimeExponent, ElectricCurrentExponent, ThermodynamicTemperatureExponent, AmountOfSubstanceExponent, LuminousIntensityExponent) {
      super();
      this.LengthExponent = LengthExponent;
      this.MassExponent = MassExponent;
      this.TimeExponent = TimeExponent;
      this.ElectricCurrentExponent = ElectricCurrentExponent;
      this.ThermodynamicTemperatureExponent = ThermodynamicTemperatureExponent;
      this.AmountOfSubstanceExponent = AmountOfSubstanceExponent;
      this.LuminousIntensityExponent = LuminousIntensityExponent;
      this.type = 2949456006;
    }
  }
  IFC4X32.IfcDimensionalExponents = IfcDimensionalExponents;
  class IfcExternalInformation extends IfcLineObject {
    constructor() {
      super();
      this.type = 4294318154;
    }
  }
  IFC4X32.IfcExternalInformation = IfcExternalInformation;
  class IfcExternalReference extends IfcLineObject {
    constructor(Location, Identification, Name) {
      super();
      this.Location = Location;
      this.Identification = Identification;
      this.Name = Name;
      this.type = 3200245327;
    }
  }
  IFC4X32.IfcExternalReference = IfcExternalReference;
  class IfcExternallyDefinedHatchStyle extends IfcExternalReference {
    constructor(Location, Identification, Name) {
      super(Location, Identification, Name);
      this.Location = Location;
      this.Identification = Identification;
      this.Name = Name;
      this.type = 2242383968;
    }
  }
  IFC4X32.IfcExternallyDefinedHatchStyle = IfcExternallyDefinedHatchStyle;
  class IfcExternallyDefinedSurfaceStyle extends IfcExternalReference {
    constructor(Location, Identification, Name) {
      super(Location, Identification, Name);
      this.Location = Location;
      this.Identification = Identification;
      this.Name = Name;
      this.type = 1040185647;
    }
  }
  IFC4X32.IfcExternallyDefinedSurfaceStyle = IfcExternallyDefinedSurfaceStyle;
  class IfcExternallyDefinedTextFont extends IfcExternalReference {
    constructor(Location, Identification, Name) {
      super(Location, Identification, Name);
      this.Location = Location;
      this.Identification = Identification;
      this.Name = Name;
      this.type = 3548104201;
    }
  }
  IFC4X32.IfcExternallyDefinedTextFont = IfcExternallyDefinedTextFont;
  class IfcGridAxis extends IfcLineObject {
    constructor(AxisTag, AxisCurve, SameSense) {
      super();
      this.AxisTag = AxisTag;
      this.AxisCurve = AxisCurve;
      this.SameSense = SameSense;
      this.type = 852622518;
    }
  }
  IFC4X32.IfcGridAxis = IfcGridAxis;
  class IfcIrregularTimeSeriesValue extends IfcLineObject {
    constructor(TimeStamp, ListValues) {
      super();
      this.TimeStamp = TimeStamp;
      this.ListValues = ListValues;
      this.type = 3020489413;
    }
  }
  IFC4X32.IfcIrregularTimeSeriesValue = IfcIrregularTimeSeriesValue;
  class IfcLibraryInformation extends IfcExternalInformation {
    constructor(Name, Version, Publisher, VersionDate, Location, Description) {
      super();
      this.Name = Name;
      this.Version = Version;
      this.Publisher = Publisher;
      this.VersionDate = VersionDate;
      this.Location = Location;
      this.Description = Description;
      this.type = 2655187982;
    }
  }
  IFC4X32.IfcLibraryInformation = IfcLibraryInformation;
  class IfcLibraryReference extends IfcExternalReference {
    constructor(Location, Identification, Name, Description, Language, ReferencedLibrary) {
      super(Location, Identification, Name);
      this.Location = Location;
      this.Identification = Identification;
      this.Name = Name;
      this.Description = Description;
      this.Language = Language;
      this.ReferencedLibrary = ReferencedLibrary;
      this.type = 3452421091;
    }
  }
  IFC4X32.IfcLibraryReference = IfcLibraryReference;
  class IfcLightDistributionData extends IfcLineObject {
    constructor(MainPlaneAngle, SecondaryPlaneAngle, LuminousIntensity) {
      super();
      this.MainPlaneAngle = MainPlaneAngle;
      this.SecondaryPlaneAngle = SecondaryPlaneAngle;
      this.LuminousIntensity = LuminousIntensity;
      this.type = 4162380809;
    }
  }
  IFC4X32.IfcLightDistributionData = IfcLightDistributionData;
  class IfcLightIntensityDistribution extends IfcLineObject {
    constructor(LightDistributionCurve, DistributionData) {
      super();
      this.LightDistributionCurve = LightDistributionCurve;
      this.DistributionData = DistributionData;
      this.type = 1566485204;
    }
  }
  IFC4X32.IfcLightIntensityDistribution = IfcLightIntensityDistribution;
  class IfcMapConversion extends IfcCoordinateOperation {
    constructor(SourceCRS, TargetCRS, Eastings, Northings, OrthogonalHeight, XAxisAbscissa, XAxisOrdinate, Scale, ScaleY, ScaleZ) {
      super(SourceCRS, TargetCRS);
      this.SourceCRS = SourceCRS;
      this.TargetCRS = TargetCRS;
      this.Eastings = Eastings;
      this.Northings = Northings;
      this.OrthogonalHeight = OrthogonalHeight;
      this.XAxisAbscissa = XAxisAbscissa;
      this.XAxisOrdinate = XAxisOrdinate;
      this.Scale = Scale;
      this.ScaleY = ScaleY;
      this.ScaleZ = ScaleZ;
      this.type = 3057273783;
    }
  }
  IFC4X32.IfcMapConversion = IfcMapConversion;
  class IfcMaterialClassificationRelationship extends IfcLineObject {
    constructor(MaterialClassifications, ClassifiedMaterial) {
      super();
      this.MaterialClassifications = MaterialClassifications;
      this.ClassifiedMaterial = ClassifiedMaterial;
      this.type = 1847130766;
    }
  }
  IFC4X32.IfcMaterialClassificationRelationship = IfcMaterialClassificationRelationship;
  class IfcMaterialDefinition extends IfcLineObject {
    constructor() {
      super();
      this.type = 760658860;
    }
  }
  IFC4X32.IfcMaterialDefinition = IfcMaterialDefinition;
  class IfcMaterialLayer extends IfcMaterialDefinition {
    constructor(Material, LayerThickness, IsVentilated, Name, Description, Category, Priority) {
      super();
      this.Material = Material;
      this.LayerThickness = LayerThickness;
      this.IsVentilated = IsVentilated;
      this.Name = Name;
      this.Description = Description;
      this.Category = Category;
      this.Priority = Priority;
      this.type = 248100487;
    }
  }
  IFC4X32.IfcMaterialLayer = IfcMaterialLayer;
  class IfcMaterialLayerSet extends IfcMaterialDefinition {
    constructor(MaterialLayers, LayerSetName, Description) {
      super();
      this.MaterialLayers = MaterialLayers;
      this.LayerSetName = LayerSetName;
      this.Description = Description;
      this.type = 3303938423;
    }
  }
  IFC4X32.IfcMaterialLayerSet = IfcMaterialLayerSet;
  class IfcMaterialLayerWithOffsets extends IfcMaterialLayer {
    constructor(Material, LayerThickness, IsVentilated, Name, Description, Category, Priority, OffsetDirection, OffsetValues) {
      super(Material, LayerThickness, IsVentilated, Name, Description, Category, Priority);
      this.Material = Material;
      this.LayerThickness = LayerThickness;
      this.IsVentilated = IsVentilated;
      this.Name = Name;
      this.Description = Description;
      this.Category = Category;
      this.Priority = Priority;
      this.OffsetDirection = OffsetDirection;
      this.OffsetValues = OffsetValues;
      this.type = 1847252529;
    }
  }
  IFC4X32.IfcMaterialLayerWithOffsets = IfcMaterialLayerWithOffsets;
  class IfcMaterialList extends IfcLineObject {
    constructor(Materials) {
      super();
      this.Materials = Materials;
      this.type = 2199411900;
    }
  }
  IFC4X32.IfcMaterialList = IfcMaterialList;
  class IfcMaterialProfile extends IfcMaterialDefinition {
    constructor(Name, Description, Material, Profile, Priority, Category) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.Material = Material;
      this.Profile = Profile;
      this.Priority = Priority;
      this.Category = Category;
      this.type = 2235152071;
    }
  }
  IFC4X32.IfcMaterialProfile = IfcMaterialProfile;
  class IfcMaterialProfileSet extends IfcMaterialDefinition {
    constructor(Name, Description, MaterialProfiles, CompositeProfile) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.MaterialProfiles = MaterialProfiles;
      this.CompositeProfile = CompositeProfile;
      this.type = 164193824;
    }
  }
  IFC4X32.IfcMaterialProfileSet = IfcMaterialProfileSet;
  class IfcMaterialProfileWithOffsets extends IfcMaterialProfile {
    constructor(Name, Description, Material, Profile, Priority, Category, OffsetValues) {
      super(Name, Description, Material, Profile, Priority, Category);
      this.Name = Name;
      this.Description = Description;
      this.Material = Material;
      this.Profile = Profile;
      this.Priority = Priority;
      this.Category = Category;
      this.OffsetValues = OffsetValues;
      this.type = 552965576;
    }
  }
  IFC4X32.IfcMaterialProfileWithOffsets = IfcMaterialProfileWithOffsets;
  class IfcMaterialUsageDefinition extends IfcLineObject {
    constructor() {
      super();
      this.type = 1507914824;
    }
  }
  IFC4X32.IfcMaterialUsageDefinition = IfcMaterialUsageDefinition;
  class IfcMeasureWithUnit extends IfcLineObject {
    constructor(ValueComponent, UnitComponent) {
      super();
      this.ValueComponent = ValueComponent;
      this.UnitComponent = UnitComponent;
      this.type = 2597039031;
    }
  }
  IFC4X32.IfcMeasureWithUnit = IfcMeasureWithUnit;
  class IfcMetric extends IfcConstraint {
    constructor(Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade, Benchmark, ValueSource, DataValue, ReferencePath) {
      super(Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade);
      this.Name = Name;
      this.Description = Description;
      this.ConstraintGrade = ConstraintGrade;
      this.ConstraintSource = ConstraintSource;
      this.CreatingActor = CreatingActor;
      this.CreationTime = CreationTime;
      this.UserDefinedGrade = UserDefinedGrade;
      this.Benchmark = Benchmark;
      this.ValueSource = ValueSource;
      this.DataValue = DataValue;
      this.ReferencePath = ReferencePath;
      this.type = 3368373690;
    }
  }
  IFC4X32.IfcMetric = IfcMetric;
  class IfcMonetaryUnit extends IfcLineObject {
    constructor(Currency) {
      super();
      this.Currency = Currency;
      this.type = 2706619895;
    }
  }
  IFC4X32.IfcMonetaryUnit = IfcMonetaryUnit;
  class IfcNamedUnit extends IfcLineObject {
    constructor(Dimensions, UnitType) {
      super();
      this.Dimensions = Dimensions;
      this.UnitType = UnitType;
      this.type = 1918398963;
    }
  }
  IFC4X32.IfcNamedUnit = IfcNamedUnit;
  class IfcObjectPlacement extends IfcLineObject {
    constructor(PlacementRelTo) {
      super();
      this.PlacementRelTo = PlacementRelTo;
      this.type = 3701648758;
    }
  }
  IFC4X32.IfcObjectPlacement = IfcObjectPlacement;
  class IfcObjective extends IfcConstraint {
    constructor(Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade, BenchmarkValues, LogicalAggregator, ObjectiveQualifier, UserDefinedQualifier) {
      super(Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade);
      this.Name = Name;
      this.Description = Description;
      this.ConstraintGrade = ConstraintGrade;
      this.ConstraintSource = ConstraintSource;
      this.CreatingActor = CreatingActor;
      this.CreationTime = CreationTime;
      this.UserDefinedGrade = UserDefinedGrade;
      this.BenchmarkValues = BenchmarkValues;
      this.LogicalAggregator = LogicalAggregator;
      this.ObjectiveQualifier = ObjectiveQualifier;
      this.UserDefinedQualifier = UserDefinedQualifier;
      this.type = 2251480897;
    }
  }
  IFC4X32.IfcObjective = IfcObjective;
  class IfcOrganization extends IfcLineObject {
    constructor(Identification, Name, Description, Roles, Addresses) {
      super();
      this.Identification = Identification;
      this.Name = Name;
      this.Description = Description;
      this.Roles = Roles;
      this.Addresses = Addresses;
      this.type = 4251960020;
    }
  }
  IFC4X32.IfcOrganization = IfcOrganization;
  class IfcOwnerHistory extends IfcLineObject {
    constructor(OwningUser, OwningApplication, State, ChangeAction, LastModifiedDate, LastModifyingUser, LastModifyingApplication, CreationDate) {
      super();
      this.OwningUser = OwningUser;
      this.OwningApplication = OwningApplication;
      this.State = State;
      this.ChangeAction = ChangeAction;
      this.LastModifiedDate = LastModifiedDate;
      this.LastModifyingUser = LastModifyingUser;
      this.LastModifyingApplication = LastModifyingApplication;
      this.CreationDate = CreationDate;
      this.type = 1207048766;
    }
  }
  IFC4X32.IfcOwnerHistory = IfcOwnerHistory;
  class IfcPerson extends IfcLineObject {
    constructor(Identification, FamilyName, GivenName, MiddleNames, PrefixTitles, SuffixTitles, Roles, Addresses) {
      super();
      this.Identification = Identification;
      this.FamilyName = FamilyName;
      this.GivenName = GivenName;
      this.MiddleNames = MiddleNames;
      this.PrefixTitles = PrefixTitles;
      this.SuffixTitles = SuffixTitles;
      this.Roles = Roles;
      this.Addresses = Addresses;
      this.type = 2077209135;
    }
  }
  IFC4X32.IfcPerson = IfcPerson;
  class IfcPersonAndOrganization extends IfcLineObject {
    constructor(ThePerson, TheOrganization, Roles) {
      super();
      this.ThePerson = ThePerson;
      this.TheOrganization = TheOrganization;
      this.Roles = Roles;
      this.type = 101040310;
    }
  }
  IFC4X32.IfcPersonAndOrganization = IfcPersonAndOrganization;
  class IfcPhysicalQuantity extends IfcLineObject {
    constructor(Name, Description) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.type = 2483315170;
    }
  }
  IFC4X32.IfcPhysicalQuantity = IfcPhysicalQuantity;
  class IfcPhysicalSimpleQuantity extends IfcPhysicalQuantity {
    constructor(Name, Description, Unit) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.type = 2226359599;
    }
  }
  IFC4X32.IfcPhysicalSimpleQuantity = IfcPhysicalSimpleQuantity;
  class IfcPostalAddress extends IfcAddress {
    constructor(Purpose, Description, UserDefinedPurpose, InternalLocation, AddressLines, PostalBox, Town, Region, PostalCode, Country) {
      super(Purpose, Description, UserDefinedPurpose);
      this.Purpose = Purpose;
      this.Description = Description;
      this.UserDefinedPurpose = UserDefinedPurpose;
      this.InternalLocation = InternalLocation;
      this.AddressLines = AddressLines;
      this.PostalBox = PostalBox;
      this.Town = Town;
      this.Region = Region;
      this.PostalCode = PostalCode;
      this.Country = Country;
      this.type = 3355820592;
    }
  }
  IFC4X32.IfcPostalAddress = IfcPostalAddress;
  class IfcPresentationItem extends IfcLineObject {
    constructor() {
      super();
      this.type = 677532197;
    }
  }
  IFC4X32.IfcPresentationItem = IfcPresentationItem;
  class IfcPresentationLayerAssignment extends IfcLineObject {
    constructor(Name, Description, AssignedItems, Identifier) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.AssignedItems = AssignedItems;
      this.Identifier = Identifier;
      this.type = 2022622350;
    }
  }
  IFC4X32.IfcPresentationLayerAssignment = IfcPresentationLayerAssignment;
  class IfcPresentationLayerWithStyle extends IfcPresentationLayerAssignment {
    constructor(Name, Description, AssignedItems, Identifier, LayerOn, LayerFrozen, LayerBlocked, LayerStyles) {
      super(Name, Description, AssignedItems, Identifier);
      this.Name = Name;
      this.Description = Description;
      this.AssignedItems = AssignedItems;
      this.Identifier = Identifier;
      this.LayerOn = LayerOn;
      this.LayerFrozen = LayerFrozen;
      this.LayerBlocked = LayerBlocked;
      this.LayerStyles = LayerStyles;
      this.type = 1304840413;
    }
  }
  IFC4X32.IfcPresentationLayerWithStyle = IfcPresentationLayerWithStyle;
  class IfcPresentationStyle extends IfcLineObject {
    constructor(Name) {
      super();
      this.Name = Name;
      this.type = 3119450353;
    }
  }
  IFC4X32.IfcPresentationStyle = IfcPresentationStyle;
  class IfcProductRepresentation extends IfcLineObject {
    constructor(Name, Description, Representations) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.Representations = Representations;
      this.type = 2095639259;
    }
  }
  IFC4X32.IfcProductRepresentation = IfcProductRepresentation;
  class IfcProfileDef extends IfcLineObject {
    constructor(ProfileType, ProfileName) {
      super();
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.type = 3958567839;
    }
  }
  IFC4X32.IfcProfileDef = IfcProfileDef;
  class IfcProjectedCRS extends IfcCoordinateReferenceSystem {
    constructor(Name, Description, GeodeticDatum, VerticalDatum, MapProjection, MapZone, MapUnit) {
      super(Name, Description, GeodeticDatum, VerticalDatum);
      this.Name = Name;
      this.Description = Description;
      this.GeodeticDatum = GeodeticDatum;
      this.VerticalDatum = VerticalDatum;
      this.MapProjection = MapProjection;
      this.MapZone = MapZone;
      this.MapUnit = MapUnit;
      this.type = 3843373140;
    }
  }
  IFC4X32.IfcProjectedCRS = IfcProjectedCRS;
  class IfcPropertyAbstraction extends IfcLineObject {
    constructor() {
      super();
      this.type = 986844984;
    }
  }
  IFC4X32.IfcPropertyAbstraction = IfcPropertyAbstraction;
  class IfcPropertyEnumeration extends IfcPropertyAbstraction {
    constructor(Name, EnumerationValues, Unit) {
      super();
      this.Name = Name;
      this.EnumerationValues = EnumerationValues;
      this.Unit = Unit;
      this.type = 3710013099;
    }
  }
  IFC4X32.IfcPropertyEnumeration = IfcPropertyEnumeration;
  class IfcQuantityArea extends IfcPhysicalSimpleQuantity {
    constructor(Name, Description, Unit, AreaValue, Formula) {
      super(Name, Description, Unit);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.AreaValue = AreaValue;
      this.Formula = Formula;
      this.type = 2044713172;
    }
  }
  IFC4X32.IfcQuantityArea = IfcQuantityArea;
  class IfcQuantityCount extends IfcPhysicalSimpleQuantity {
    constructor(Name, Description, Unit, CountValue, Formula) {
      super(Name, Description, Unit);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.CountValue = CountValue;
      this.Formula = Formula;
      this.type = 2093928680;
    }
  }
  IFC4X32.IfcQuantityCount = IfcQuantityCount;
  class IfcQuantityLength extends IfcPhysicalSimpleQuantity {
    constructor(Name, Description, Unit, LengthValue, Formula) {
      super(Name, Description, Unit);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.LengthValue = LengthValue;
      this.Formula = Formula;
      this.type = 931644368;
    }
  }
  IFC4X32.IfcQuantityLength = IfcQuantityLength;
  class IfcQuantityNumber extends IfcPhysicalSimpleQuantity {
    constructor(Name, Description, Unit, NumberValue, Formula) {
      super(Name, Description, Unit);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.NumberValue = NumberValue;
      this.Formula = Formula;
      this.type = 2691318326;
    }
  }
  IFC4X32.IfcQuantityNumber = IfcQuantityNumber;
  class IfcQuantityTime extends IfcPhysicalSimpleQuantity {
    constructor(Name, Description, Unit, TimeValue, Formula) {
      super(Name, Description, Unit);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.TimeValue = TimeValue;
      this.Formula = Formula;
      this.type = 3252649465;
    }
  }
  IFC4X32.IfcQuantityTime = IfcQuantityTime;
  class IfcQuantityVolume extends IfcPhysicalSimpleQuantity {
    constructor(Name, Description, Unit, VolumeValue, Formula) {
      super(Name, Description, Unit);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.VolumeValue = VolumeValue;
      this.Formula = Formula;
      this.type = 2405470396;
    }
  }
  IFC4X32.IfcQuantityVolume = IfcQuantityVolume;
  class IfcQuantityWeight extends IfcPhysicalSimpleQuantity {
    constructor(Name, Description, Unit, WeightValue, Formula) {
      super(Name, Description, Unit);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.WeightValue = WeightValue;
      this.Formula = Formula;
      this.type = 825690147;
    }
  }
  IFC4X32.IfcQuantityWeight = IfcQuantityWeight;
  class IfcRecurrencePattern extends IfcLineObject {
    constructor(RecurrenceType, DayComponent, WeekdayComponent, MonthComponent, Position, Interval, Occurrences, TimePeriods) {
      super();
      this.RecurrenceType = RecurrenceType;
      this.DayComponent = DayComponent;
      this.WeekdayComponent = WeekdayComponent;
      this.MonthComponent = MonthComponent;
      this.Position = Position;
      this.Interval = Interval;
      this.Occurrences = Occurrences;
      this.TimePeriods = TimePeriods;
      this.type = 3915482550;
    }
  }
  IFC4X32.IfcRecurrencePattern = IfcRecurrencePattern;
  class IfcReference extends IfcLineObject {
    constructor(TypeIdentifier, AttributeIdentifier, InstanceName, ListPositions, InnerReference) {
      super();
      this.TypeIdentifier = TypeIdentifier;
      this.AttributeIdentifier = AttributeIdentifier;
      this.InstanceName = InstanceName;
      this.ListPositions = ListPositions;
      this.InnerReference = InnerReference;
      this.type = 2433181523;
    }
  }
  IFC4X32.IfcReference = IfcReference;
  class IfcRepresentation extends IfcLineObject {
    constructor(ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      super();
      this.ContextOfItems = ContextOfItems;
      this.RepresentationIdentifier = RepresentationIdentifier;
      this.RepresentationType = RepresentationType;
      this.Items = Items;
      this.type = 1076942058;
    }
  }
  IFC4X32.IfcRepresentation = IfcRepresentation;
  class IfcRepresentationContext extends IfcLineObject {
    constructor(ContextIdentifier, ContextType) {
      super();
      this.ContextIdentifier = ContextIdentifier;
      this.ContextType = ContextType;
      this.type = 3377609919;
    }
  }
  IFC4X32.IfcRepresentationContext = IfcRepresentationContext;
  class IfcRepresentationItem extends IfcLineObject {
    constructor() {
      super();
      this.type = 3008791417;
    }
  }
  IFC4X32.IfcRepresentationItem = IfcRepresentationItem;
  class IfcRepresentationMap extends IfcLineObject {
    constructor(MappingOrigin, MappedRepresentation) {
      super();
      this.MappingOrigin = MappingOrigin;
      this.MappedRepresentation = MappedRepresentation;
      this.type = 1660063152;
    }
  }
  IFC4X32.IfcRepresentationMap = IfcRepresentationMap;
  class IfcResourceLevelRelationship extends IfcLineObject {
    constructor(Name, Description) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.type = 2439245199;
    }
  }
  IFC4X32.IfcResourceLevelRelationship = IfcResourceLevelRelationship;
  class IfcRoot extends IfcLineObject {
    constructor(GlobalId, OwnerHistory, Name, Description) {
      super();
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 2341007311;
    }
  }
  IFC4X32.IfcRoot = IfcRoot;
  class IfcSIUnit extends IfcNamedUnit {
    constructor(UnitType, Prefix, Name) {
      super(new Handle(0), UnitType);
      this.UnitType = UnitType;
      this.Prefix = Prefix;
      this.Name = Name;
      this.type = 448429030;
    }
  }
  IFC4X32.IfcSIUnit = IfcSIUnit;
  class IfcSchedulingTime extends IfcLineObject {
    constructor(Name, DataOrigin, UserDefinedDataOrigin) {
      super();
      this.Name = Name;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.type = 1054537805;
    }
  }
  IFC4X32.IfcSchedulingTime = IfcSchedulingTime;
  class IfcShapeAspect extends IfcLineObject {
    constructor(ShapeRepresentations, Name, Description, ProductDefinitional, PartOfProductDefinitionShape) {
      super();
      this.ShapeRepresentations = ShapeRepresentations;
      this.Name = Name;
      this.Description = Description;
      this.ProductDefinitional = ProductDefinitional;
      this.PartOfProductDefinitionShape = PartOfProductDefinitionShape;
      this.type = 867548509;
    }
  }
  IFC4X32.IfcShapeAspect = IfcShapeAspect;
  class IfcShapeModel extends IfcRepresentation {
    constructor(ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      super(ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      this.ContextOfItems = ContextOfItems;
      this.RepresentationIdentifier = RepresentationIdentifier;
      this.RepresentationType = RepresentationType;
      this.Items = Items;
      this.type = 3982875396;
    }
  }
  IFC4X32.IfcShapeModel = IfcShapeModel;
  class IfcShapeRepresentation extends IfcShapeModel {
    constructor(ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      super(ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      this.ContextOfItems = ContextOfItems;
      this.RepresentationIdentifier = RepresentationIdentifier;
      this.RepresentationType = RepresentationType;
      this.Items = Items;
      this.type = 4240577450;
    }
  }
  IFC4X32.IfcShapeRepresentation = IfcShapeRepresentation;
  class IfcStructuralConnectionCondition extends IfcLineObject {
    constructor(Name) {
      super();
      this.Name = Name;
      this.type = 2273995522;
    }
  }
  IFC4X32.IfcStructuralConnectionCondition = IfcStructuralConnectionCondition;
  class IfcStructuralLoad extends IfcLineObject {
    constructor(Name) {
      super();
      this.Name = Name;
      this.type = 2162789131;
    }
  }
  IFC4X32.IfcStructuralLoad = IfcStructuralLoad;
  class IfcStructuralLoadConfiguration extends IfcStructuralLoad {
    constructor(Name, Values, Locations) {
      super(Name);
      this.Name = Name;
      this.Values = Values;
      this.Locations = Locations;
      this.type = 3478079324;
    }
  }
  IFC4X32.IfcStructuralLoadConfiguration = IfcStructuralLoadConfiguration;
  class IfcStructuralLoadOrResult extends IfcStructuralLoad {
    constructor(Name) {
      super(Name);
      this.Name = Name;
      this.type = 609421318;
    }
  }
  IFC4X32.IfcStructuralLoadOrResult = IfcStructuralLoadOrResult;
  class IfcStructuralLoadStatic extends IfcStructuralLoadOrResult {
    constructor(Name) {
      super(Name);
      this.Name = Name;
      this.type = 2525727697;
    }
  }
  IFC4X32.IfcStructuralLoadStatic = IfcStructuralLoadStatic;
  class IfcStructuralLoadTemperature extends IfcStructuralLoadStatic {
    constructor(Name, DeltaTConstant, DeltaTY, DeltaTZ) {
      super(Name);
      this.Name = Name;
      this.DeltaTConstant = DeltaTConstant;
      this.DeltaTY = DeltaTY;
      this.DeltaTZ = DeltaTZ;
      this.type = 3408363356;
    }
  }
  IFC4X32.IfcStructuralLoadTemperature = IfcStructuralLoadTemperature;
  class IfcStyleModel extends IfcRepresentation {
    constructor(ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      super(ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      this.ContextOfItems = ContextOfItems;
      this.RepresentationIdentifier = RepresentationIdentifier;
      this.RepresentationType = RepresentationType;
      this.Items = Items;
      this.type = 2830218821;
    }
  }
  IFC4X32.IfcStyleModel = IfcStyleModel;
  class IfcStyledItem extends IfcRepresentationItem {
    constructor(Item, Styles, Name) {
      super();
      this.Item = Item;
      this.Styles = Styles;
      this.Name = Name;
      this.type = 3958052878;
    }
  }
  IFC4X32.IfcStyledItem = IfcStyledItem;
  class IfcStyledRepresentation extends IfcStyleModel {
    constructor(ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      super(ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      this.ContextOfItems = ContextOfItems;
      this.RepresentationIdentifier = RepresentationIdentifier;
      this.RepresentationType = RepresentationType;
      this.Items = Items;
      this.type = 3049322572;
    }
  }
  IFC4X32.IfcStyledRepresentation = IfcStyledRepresentation;
  class IfcSurfaceReinforcementArea extends IfcStructuralLoadOrResult {
    constructor(Name, SurfaceReinforcement1, SurfaceReinforcement2, ShearReinforcement) {
      super(Name);
      this.Name = Name;
      this.SurfaceReinforcement1 = SurfaceReinforcement1;
      this.SurfaceReinforcement2 = SurfaceReinforcement2;
      this.ShearReinforcement = ShearReinforcement;
      this.type = 2934153892;
    }
  }
  IFC4X32.IfcSurfaceReinforcementArea = IfcSurfaceReinforcementArea;
  class IfcSurfaceStyle extends IfcPresentationStyle {
    constructor(Name, Side, Styles) {
      super(Name);
      this.Name = Name;
      this.Side = Side;
      this.Styles = Styles;
      this.type = 1300840506;
    }
  }
  IFC4X32.IfcSurfaceStyle = IfcSurfaceStyle;
  class IfcSurfaceStyleLighting extends IfcPresentationItem {
    constructor(DiffuseTransmissionColour, DiffuseReflectionColour, TransmissionColour, ReflectanceColour) {
      super();
      this.DiffuseTransmissionColour = DiffuseTransmissionColour;
      this.DiffuseReflectionColour = DiffuseReflectionColour;
      this.TransmissionColour = TransmissionColour;
      this.ReflectanceColour = ReflectanceColour;
      this.type = 3303107099;
    }
  }
  IFC4X32.IfcSurfaceStyleLighting = IfcSurfaceStyleLighting;
  class IfcSurfaceStyleRefraction extends IfcPresentationItem {
    constructor(RefractionIndex, DispersionFactor) {
      super();
      this.RefractionIndex = RefractionIndex;
      this.DispersionFactor = DispersionFactor;
      this.type = 1607154358;
    }
  }
  IFC4X32.IfcSurfaceStyleRefraction = IfcSurfaceStyleRefraction;
  class IfcSurfaceStyleShading extends IfcPresentationItem {
    constructor(SurfaceColour, Transparency) {
      super();
      this.SurfaceColour = SurfaceColour;
      this.Transparency = Transparency;
      this.type = 846575682;
    }
  }
  IFC4X32.IfcSurfaceStyleShading = IfcSurfaceStyleShading;
  class IfcSurfaceStyleWithTextures extends IfcPresentationItem {
    constructor(Textures) {
      super();
      this.Textures = Textures;
      this.type = 1351298697;
    }
  }
  IFC4X32.IfcSurfaceStyleWithTextures = IfcSurfaceStyleWithTextures;
  class IfcSurfaceTexture extends IfcPresentationItem {
    constructor(RepeatS, RepeatT, Mode, TextureTransform, Parameter) {
      super();
      this.RepeatS = RepeatS;
      this.RepeatT = RepeatT;
      this.Mode = Mode;
      this.TextureTransform = TextureTransform;
      this.Parameter = Parameter;
      this.type = 626085974;
    }
  }
  IFC4X32.IfcSurfaceTexture = IfcSurfaceTexture;
  class IfcTable extends IfcLineObject {
    constructor(Name, Rows, Columns) {
      super();
      this.Name = Name;
      this.Rows = Rows;
      this.Columns = Columns;
      this.type = 985171141;
    }
  }
  IFC4X32.IfcTable = IfcTable;
  class IfcTableColumn extends IfcLineObject {
    constructor(Identifier, Name, Description, Unit, ReferencePath) {
      super();
      this.Identifier = Identifier;
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.ReferencePath = ReferencePath;
      this.type = 2043862942;
    }
  }
  IFC4X32.IfcTableColumn = IfcTableColumn;
  class IfcTableRow extends IfcLineObject {
    constructor(RowCells, IsHeading) {
      super();
      this.RowCells = RowCells;
      this.IsHeading = IsHeading;
      this.type = 531007025;
    }
  }
  IFC4X32.IfcTableRow = IfcTableRow;
  class IfcTaskTime extends IfcSchedulingTime {
    constructor(Name, DataOrigin, UserDefinedDataOrigin, DurationType, ScheduleDuration, ScheduleStart, ScheduleFinish, EarlyStart, EarlyFinish, LateStart, LateFinish, FreeFloat, TotalFloat, IsCritical, StatusTime, ActualDuration, ActualStart, ActualFinish, RemainingTime, Completion) {
      super(Name, DataOrigin, UserDefinedDataOrigin);
      this.Name = Name;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.DurationType = DurationType;
      this.ScheduleDuration = ScheduleDuration;
      this.ScheduleStart = ScheduleStart;
      this.ScheduleFinish = ScheduleFinish;
      this.EarlyStart = EarlyStart;
      this.EarlyFinish = EarlyFinish;
      this.LateStart = LateStart;
      this.LateFinish = LateFinish;
      this.FreeFloat = FreeFloat;
      this.TotalFloat = TotalFloat;
      this.IsCritical = IsCritical;
      this.StatusTime = StatusTime;
      this.ActualDuration = ActualDuration;
      this.ActualStart = ActualStart;
      this.ActualFinish = ActualFinish;
      this.RemainingTime = RemainingTime;
      this.Completion = Completion;
      this.type = 1549132990;
    }
  }
  IFC4X32.IfcTaskTime = IfcTaskTime;
  class IfcTaskTimeRecurring extends IfcTaskTime {
    constructor(Name, DataOrigin, UserDefinedDataOrigin, DurationType, ScheduleDuration, ScheduleStart, ScheduleFinish, EarlyStart, EarlyFinish, LateStart, LateFinish, FreeFloat, TotalFloat, IsCritical, StatusTime, ActualDuration, ActualStart, ActualFinish, RemainingTime, Completion, Recurrence) {
      super(Name, DataOrigin, UserDefinedDataOrigin, DurationType, ScheduleDuration, ScheduleStart, ScheduleFinish, EarlyStart, EarlyFinish, LateStart, LateFinish, FreeFloat, TotalFloat, IsCritical, StatusTime, ActualDuration, ActualStart, ActualFinish, RemainingTime, Completion);
      this.Name = Name;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.DurationType = DurationType;
      this.ScheduleDuration = ScheduleDuration;
      this.ScheduleStart = ScheduleStart;
      this.ScheduleFinish = ScheduleFinish;
      this.EarlyStart = EarlyStart;
      this.EarlyFinish = EarlyFinish;
      this.LateStart = LateStart;
      this.LateFinish = LateFinish;
      this.FreeFloat = FreeFloat;
      this.TotalFloat = TotalFloat;
      this.IsCritical = IsCritical;
      this.StatusTime = StatusTime;
      this.ActualDuration = ActualDuration;
      this.ActualStart = ActualStart;
      this.ActualFinish = ActualFinish;
      this.RemainingTime = RemainingTime;
      this.Completion = Completion;
      this.Recurrence = Recurrence;
      this.type = 2771591690;
    }
  }
  IFC4X32.IfcTaskTimeRecurring = IfcTaskTimeRecurring;
  class IfcTelecomAddress extends IfcAddress {
    constructor(Purpose, Description, UserDefinedPurpose, TelephoneNumbers, FacsimileNumbers, PagerNumber, ElectronicMailAddresses, WWWHomePageURL, MessagingIDs) {
      super(Purpose, Description, UserDefinedPurpose);
      this.Purpose = Purpose;
      this.Description = Description;
      this.UserDefinedPurpose = UserDefinedPurpose;
      this.TelephoneNumbers = TelephoneNumbers;
      this.FacsimileNumbers = FacsimileNumbers;
      this.PagerNumber = PagerNumber;
      this.ElectronicMailAddresses = ElectronicMailAddresses;
      this.WWWHomePageURL = WWWHomePageURL;
      this.MessagingIDs = MessagingIDs;
      this.type = 912023232;
    }
  }
  IFC4X32.IfcTelecomAddress = IfcTelecomAddress;
  class IfcTextStyle extends IfcPresentationStyle {
    constructor(Name, TextCharacterAppearance, TextStyle, TextFontStyle, ModelOrDraughting) {
      super(Name);
      this.Name = Name;
      this.TextCharacterAppearance = TextCharacterAppearance;
      this.TextStyle = TextStyle;
      this.TextFontStyle = TextFontStyle;
      this.ModelOrDraughting = ModelOrDraughting;
      this.type = 1447204868;
    }
  }
  IFC4X32.IfcTextStyle = IfcTextStyle;
  class IfcTextStyleForDefinedFont extends IfcPresentationItem {
    constructor(Colour, BackgroundColour) {
      super();
      this.Colour = Colour;
      this.BackgroundColour = BackgroundColour;
      this.type = 2636378356;
    }
  }
  IFC4X32.IfcTextStyleForDefinedFont = IfcTextStyleForDefinedFont;
  class IfcTextStyleTextModel extends IfcPresentationItem {
    constructor(TextIndent, TextAlign, TextDecoration, LetterSpacing, WordSpacing, TextTransform, LineHeight) {
      super();
      this.TextIndent = TextIndent;
      this.TextAlign = TextAlign;
      this.TextDecoration = TextDecoration;
      this.LetterSpacing = LetterSpacing;
      this.WordSpacing = WordSpacing;
      this.TextTransform = TextTransform;
      this.LineHeight = LineHeight;
      this.type = 1640371178;
    }
  }
  IFC4X32.IfcTextStyleTextModel = IfcTextStyleTextModel;
  class IfcTextureCoordinate extends IfcPresentationItem {
    constructor(Maps) {
      super();
      this.Maps = Maps;
      this.type = 280115917;
    }
  }
  IFC4X32.IfcTextureCoordinate = IfcTextureCoordinate;
  class IfcTextureCoordinateGenerator extends IfcTextureCoordinate {
    constructor(Maps, Mode, Parameter) {
      super(Maps);
      this.Maps = Maps;
      this.Mode = Mode;
      this.Parameter = Parameter;
      this.type = 1742049831;
    }
  }
  IFC4X32.IfcTextureCoordinateGenerator = IfcTextureCoordinateGenerator;
  class IfcTextureCoordinateIndices extends IfcLineObject {
    constructor(TexCoordIndex, TexCoordsOf) {
      super();
      this.TexCoordIndex = TexCoordIndex;
      this.TexCoordsOf = TexCoordsOf;
      this.type = 222769930;
    }
  }
  IFC4X32.IfcTextureCoordinateIndices = IfcTextureCoordinateIndices;
  class IfcTextureCoordinateIndicesWithVoids extends IfcTextureCoordinateIndices {
    constructor(TexCoordIndex, TexCoordsOf, InnerTexCoordIndices) {
      super(TexCoordIndex, TexCoordsOf);
      this.TexCoordIndex = TexCoordIndex;
      this.TexCoordsOf = TexCoordsOf;
      this.InnerTexCoordIndices = InnerTexCoordIndices;
      this.type = 1010789467;
    }
  }
  IFC4X32.IfcTextureCoordinateIndicesWithVoids = IfcTextureCoordinateIndicesWithVoids;
  class IfcTextureMap extends IfcTextureCoordinate {
    constructor(Maps, Vertices, MappedTo) {
      super(Maps);
      this.Maps = Maps;
      this.Vertices = Vertices;
      this.MappedTo = MappedTo;
      this.type = 2552916305;
    }
  }
  IFC4X32.IfcTextureMap = IfcTextureMap;
  class IfcTextureVertex extends IfcPresentationItem {
    constructor(Coordinates) {
      super();
      this.Coordinates = Coordinates;
      this.type = 1210645708;
    }
  }
  IFC4X32.IfcTextureVertex = IfcTextureVertex;
  class IfcTextureVertexList extends IfcPresentationItem {
    constructor(TexCoordsList) {
      super();
      this.TexCoordsList = TexCoordsList;
      this.type = 3611470254;
    }
  }
  IFC4X32.IfcTextureVertexList = IfcTextureVertexList;
  class IfcTimePeriod extends IfcLineObject {
    constructor(StartTime, EndTime) {
      super();
      this.StartTime = StartTime;
      this.EndTime = EndTime;
      this.type = 1199560280;
    }
  }
  IFC4X32.IfcTimePeriod = IfcTimePeriod;
  class IfcTimeSeries extends IfcLineObject {
    constructor(Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.StartTime = StartTime;
      this.EndTime = EndTime;
      this.TimeSeriesDataType = TimeSeriesDataType;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.Unit = Unit;
      this.type = 3101149627;
    }
  }
  IFC4X32.IfcTimeSeries = IfcTimeSeries;
  class IfcTimeSeriesValue extends IfcLineObject {
    constructor(ListValues) {
      super();
      this.ListValues = ListValues;
      this.type = 581633288;
    }
  }
  IFC4X32.IfcTimeSeriesValue = IfcTimeSeriesValue;
  class IfcTopologicalRepresentationItem extends IfcRepresentationItem {
    constructor() {
      super();
      this.type = 1377556343;
    }
  }
  IFC4X32.IfcTopologicalRepresentationItem = IfcTopologicalRepresentationItem;
  class IfcTopologyRepresentation extends IfcShapeModel {
    constructor(ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      super(ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      this.ContextOfItems = ContextOfItems;
      this.RepresentationIdentifier = RepresentationIdentifier;
      this.RepresentationType = RepresentationType;
      this.Items = Items;
      this.type = 1735638870;
    }
  }
  IFC4X32.IfcTopologyRepresentation = IfcTopologyRepresentation;
  class IfcUnitAssignment extends IfcLineObject {
    constructor(Units) {
      super();
      this.Units = Units;
      this.type = 180925521;
    }
  }
  IFC4X32.IfcUnitAssignment = IfcUnitAssignment;
  class IfcVertex extends IfcTopologicalRepresentationItem {
    constructor() {
      super();
      this.type = 2799835756;
    }
  }
  IFC4X32.IfcVertex = IfcVertex;
  class IfcVertexPoint extends IfcVertex {
    constructor(VertexGeometry) {
      super();
      this.VertexGeometry = VertexGeometry;
      this.type = 1907098498;
    }
  }
  IFC4X32.IfcVertexPoint = IfcVertexPoint;
  class IfcVirtualGridIntersection extends IfcLineObject {
    constructor(IntersectingAxes, OffsetDistances) {
      super();
      this.IntersectingAxes = IntersectingAxes;
      this.OffsetDistances = OffsetDistances;
      this.type = 891718957;
    }
  }
  IFC4X32.IfcVirtualGridIntersection = IfcVirtualGridIntersection;
  class IfcWorkTime extends IfcSchedulingTime {
    constructor(Name, DataOrigin, UserDefinedDataOrigin, RecurrencePattern, StartDate, FinishDate) {
      super(Name, DataOrigin, UserDefinedDataOrigin);
      this.Name = Name;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.RecurrencePattern = RecurrencePattern;
      this.StartDate = StartDate;
      this.FinishDate = FinishDate;
      this.type = 1236880293;
    }
  }
  IFC4X32.IfcWorkTime = IfcWorkTime;
  class IfcAlignmentCantSegment extends IfcAlignmentParameterSegment {
    constructor(StartTag, EndTag, StartDistAlong, HorizontalLength, StartCantLeft, EndCantLeft, StartCantRight, EndCantRight, PredefinedType) {
      super(StartTag, EndTag);
      this.StartTag = StartTag;
      this.EndTag = EndTag;
      this.StartDistAlong = StartDistAlong;
      this.HorizontalLength = HorizontalLength;
      this.StartCantLeft = StartCantLeft;
      this.EndCantLeft = EndCantLeft;
      this.StartCantRight = StartCantRight;
      this.EndCantRight = EndCantRight;
      this.PredefinedType = PredefinedType;
      this.type = 3752311538;
    }
  }
  IFC4X32.IfcAlignmentCantSegment = IfcAlignmentCantSegment;
  class IfcAlignmentHorizontalSegment extends IfcAlignmentParameterSegment {
    constructor(StartTag, EndTag, StartPoint, StartDirection, StartRadiusOfCurvature, EndRadiusOfCurvature, SegmentLength, GravityCenterLineHeight, PredefinedType) {
      super(StartTag, EndTag);
      this.StartTag = StartTag;
      this.EndTag = EndTag;
      this.StartPoint = StartPoint;
      this.StartDirection = StartDirection;
      this.StartRadiusOfCurvature = StartRadiusOfCurvature;
      this.EndRadiusOfCurvature = EndRadiusOfCurvature;
      this.SegmentLength = SegmentLength;
      this.GravityCenterLineHeight = GravityCenterLineHeight;
      this.PredefinedType = PredefinedType;
      this.type = 536804194;
    }
  }
  IFC4X32.IfcAlignmentHorizontalSegment = IfcAlignmentHorizontalSegment;
  class IfcApprovalRelationship extends IfcResourceLevelRelationship {
    constructor(Name, Description, RelatingApproval, RelatedApprovals) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.RelatingApproval = RelatingApproval;
      this.RelatedApprovals = RelatedApprovals;
      this.type = 3869604511;
    }
  }
  IFC4X32.IfcApprovalRelationship = IfcApprovalRelationship;
  class IfcArbitraryClosedProfileDef extends IfcProfileDef {
    constructor(ProfileType, ProfileName, OuterCurve) {
      super(ProfileType, ProfileName);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.OuterCurve = OuterCurve;
      this.type = 3798115385;
    }
  }
  IFC4X32.IfcArbitraryClosedProfileDef = IfcArbitraryClosedProfileDef;
  class IfcArbitraryOpenProfileDef extends IfcProfileDef {
    constructor(ProfileType, ProfileName, Curve) {
      super(ProfileType, ProfileName);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Curve = Curve;
      this.type = 1310608509;
    }
  }
  IFC4X32.IfcArbitraryOpenProfileDef = IfcArbitraryOpenProfileDef;
  class IfcArbitraryProfileDefWithVoids extends IfcArbitraryClosedProfileDef {
    constructor(ProfileType, ProfileName, OuterCurve, InnerCurves) {
      super(ProfileType, ProfileName, OuterCurve);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.OuterCurve = OuterCurve;
      this.InnerCurves = InnerCurves;
      this.type = 2705031697;
    }
  }
  IFC4X32.IfcArbitraryProfileDefWithVoids = IfcArbitraryProfileDefWithVoids;
  class IfcBlobTexture extends IfcSurfaceTexture {
    constructor(RepeatS, RepeatT, Mode, TextureTransform, Parameter, RasterFormat, RasterCode) {
      super(RepeatS, RepeatT, Mode, TextureTransform, Parameter);
      this.RepeatS = RepeatS;
      this.RepeatT = RepeatT;
      this.Mode = Mode;
      this.TextureTransform = TextureTransform;
      this.Parameter = Parameter;
      this.RasterFormat = RasterFormat;
      this.RasterCode = RasterCode;
      this.type = 616511568;
    }
  }
  IFC4X32.IfcBlobTexture = IfcBlobTexture;
  class IfcCenterLineProfileDef extends IfcArbitraryOpenProfileDef {
    constructor(ProfileType, ProfileName, Curve, Thickness) {
      super(ProfileType, ProfileName, Curve);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Curve = Curve;
      this.Thickness = Thickness;
      this.type = 3150382593;
    }
  }
  IFC4X32.IfcCenterLineProfileDef = IfcCenterLineProfileDef;
  class IfcClassification extends IfcExternalInformation {
    constructor(Source, Edition, EditionDate, Name, Description, Specification, ReferenceTokens) {
      super();
      this.Source = Source;
      this.Edition = Edition;
      this.EditionDate = EditionDate;
      this.Name = Name;
      this.Description = Description;
      this.Specification = Specification;
      this.ReferenceTokens = ReferenceTokens;
      this.type = 747523909;
    }
  }
  IFC4X32.IfcClassification = IfcClassification;
  class IfcClassificationReference extends IfcExternalReference {
    constructor(Location, Identification, Name, ReferencedSource, Description, Sort) {
      super(Location, Identification, Name);
      this.Location = Location;
      this.Identification = Identification;
      this.Name = Name;
      this.ReferencedSource = ReferencedSource;
      this.Description = Description;
      this.Sort = Sort;
      this.type = 647927063;
    }
  }
  IFC4X32.IfcClassificationReference = IfcClassificationReference;
  class IfcColourRgbList extends IfcPresentationItem {
    constructor(ColourList) {
      super();
      this.ColourList = ColourList;
      this.type = 3285139300;
    }
  }
  IFC4X32.IfcColourRgbList = IfcColourRgbList;
  class IfcColourSpecification extends IfcPresentationItem {
    constructor(Name) {
      super();
      this.Name = Name;
      this.type = 3264961684;
    }
  }
  IFC4X32.IfcColourSpecification = IfcColourSpecification;
  class IfcCompositeProfileDef extends IfcProfileDef {
    constructor(ProfileType, ProfileName, Profiles, Label) {
      super(ProfileType, ProfileName);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Profiles = Profiles;
      this.Label = Label;
      this.type = 1485152156;
    }
  }
  IFC4X32.IfcCompositeProfileDef = IfcCompositeProfileDef;
  class IfcConnectedFaceSet extends IfcTopologicalRepresentationItem {
    constructor(CfsFaces) {
      super();
      this.CfsFaces = CfsFaces;
      this.type = 370225590;
    }
  }
  IFC4X32.IfcConnectedFaceSet = IfcConnectedFaceSet;
  class IfcConnectionCurveGeometry extends IfcConnectionGeometry {
    constructor(CurveOnRelatingElement, CurveOnRelatedElement) {
      super();
      this.CurveOnRelatingElement = CurveOnRelatingElement;
      this.CurveOnRelatedElement = CurveOnRelatedElement;
      this.type = 1981873012;
    }
  }
  IFC4X32.IfcConnectionCurveGeometry = IfcConnectionCurveGeometry;
  class IfcConnectionPointEccentricity extends IfcConnectionPointGeometry {
    constructor(PointOnRelatingElement, PointOnRelatedElement, EccentricityInX, EccentricityInY, EccentricityInZ) {
      super(PointOnRelatingElement, PointOnRelatedElement);
      this.PointOnRelatingElement = PointOnRelatingElement;
      this.PointOnRelatedElement = PointOnRelatedElement;
      this.EccentricityInX = EccentricityInX;
      this.EccentricityInY = EccentricityInY;
      this.EccentricityInZ = EccentricityInZ;
      this.type = 45288368;
    }
  }
  IFC4X32.IfcConnectionPointEccentricity = IfcConnectionPointEccentricity;
  class IfcContextDependentUnit extends IfcNamedUnit {
    constructor(Dimensions, UnitType, Name) {
      super(Dimensions, UnitType);
      this.Dimensions = Dimensions;
      this.UnitType = UnitType;
      this.Name = Name;
      this.type = 3050246964;
    }
  }
  IFC4X32.IfcContextDependentUnit = IfcContextDependentUnit;
  class IfcConversionBasedUnit extends IfcNamedUnit {
    constructor(Dimensions, UnitType, Name, ConversionFactor) {
      super(Dimensions, UnitType);
      this.Dimensions = Dimensions;
      this.UnitType = UnitType;
      this.Name = Name;
      this.ConversionFactor = ConversionFactor;
      this.type = 2889183280;
    }
  }
  IFC4X32.IfcConversionBasedUnit = IfcConversionBasedUnit;
  class IfcConversionBasedUnitWithOffset extends IfcConversionBasedUnit {
    constructor(Dimensions, UnitType, Name, ConversionFactor, ConversionOffset) {
      super(Dimensions, UnitType, Name, ConversionFactor);
      this.Dimensions = Dimensions;
      this.UnitType = UnitType;
      this.Name = Name;
      this.ConversionFactor = ConversionFactor;
      this.ConversionOffset = ConversionOffset;
      this.type = 2713554722;
    }
  }
  IFC4X32.IfcConversionBasedUnitWithOffset = IfcConversionBasedUnitWithOffset;
  class IfcCurrencyRelationship extends IfcResourceLevelRelationship {
    constructor(Name, Description, RelatingMonetaryUnit, RelatedMonetaryUnit, ExchangeRate, RateDateTime, RateSource) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.RelatingMonetaryUnit = RelatingMonetaryUnit;
      this.RelatedMonetaryUnit = RelatedMonetaryUnit;
      this.ExchangeRate = ExchangeRate;
      this.RateDateTime = RateDateTime;
      this.RateSource = RateSource;
      this.type = 539742890;
    }
  }
  IFC4X32.IfcCurrencyRelationship = IfcCurrencyRelationship;
  class IfcCurveStyle extends IfcPresentationStyle {
    constructor(Name, CurveFont, CurveWidth, CurveColour, ModelOrDraughting) {
      super(Name);
      this.Name = Name;
      this.CurveFont = CurveFont;
      this.CurveWidth = CurveWidth;
      this.CurveColour = CurveColour;
      this.ModelOrDraughting = ModelOrDraughting;
      this.type = 3800577675;
    }
  }
  IFC4X32.IfcCurveStyle = IfcCurveStyle;
  class IfcCurveStyleFont extends IfcPresentationItem {
    constructor(Name, PatternList) {
      super();
      this.Name = Name;
      this.PatternList = PatternList;
      this.type = 1105321065;
    }
  }
  IFC4X32.IfcCurveStyleFont = IfcCurveStyleFont;
  class IfcCurveStyleFontAndScaling extends IfcPresentationItem {
    constructor(Name, CurveStyleFont, CurveFontScaling) {
      super();
      this.Name = Name;
      this.CurveStyleFont = CurveStyleFont;
      this.CurveFontScaling = CurveFontScaling;
      this.type = 2367409068;
    }
  }
  IFC4X32.IfcCurveStyleFontAndScaling = IfcCurveStyleFontAndScaling;
  class IfcCurveStyleFontPattern extends IfcPresentationItem {
    constructor(VisibleSegmentLength, InvisibleSegmentLength) {
      super();
      this.VisibleSegmentLength = VisibleSegmentLength;
      this.InvisibleSegmentLength = InvisibleSegmentLength;
      this.type = 3510044353;
    }
  }
  IFC4X32.IfcCurveStyleFontPattern = IfcCurveStyleFontPattern;
  class IfcDerivedProfileDef extends IfcProfileDef {
    constructor(ProfileType, ProfileName, ParentProfile, Operator, Label) {
      super(ProfileType, ProfileName);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.ParentProfile = ParentProfile;
      this.Operator = Operator;
      this.Label = Label;
      this.type = 3632507154;
    }
  }
  IFC4X32.IfcDerivedProfileDef = IfcDerivedProfileDef;
  class IfcDocumentInformation extends IfcExternalInformation {
    constructor(Identification, Name, Description, Location, Purpose, IntendedUse, Scope, Revision, DocumentOwner, Editors, CreationTime, LastRevisionTime, ElectronicFormat, ValidFrom, ValidUntil, Confidentiality, Status) {
      super();
      this.Identification = Identification;
      this.Name = Name;
      this.Description = Description;
      this.Location = Location;
      this.Purpose = Purpose;
      this.IntendedUse = IntendedUse;
      this.Scope = Scope;
      this.Revision = Revision;
      this.DocumentOwner = DocumentOwner;
      this.Editors = Editors;
      this.CreationTime = CreationTime;
      this.LastRevisionTime = LastRevisionTime;
      this.ElectronicFormat = ElectronicFormat;
      this.ValidFrom = ValidFrom;
      this.ValidUntil = ValidUntil;
      this.Confidentiality = Confidentiality;
      this.Status = Status;
      this.type = 1154170062;
    }
  }
  IFC4X32.IfcDocumentInformation = IfcDocumentInformation;
  class IfcDocumentInformationRelationship extends IfcResourceLevelRelationship {
    constructor(Name, Description, RelatingDocument, RelatedDocuments, RelationshipType) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.RelatingDocument = RelatingDocument;
      this.RelatedDocuments = RelatedDocuments;
      this.RelationshipType = RelationshipType;
      this.type = 770865208;
    }
  }
  IFC4X32.IfcDocumentInformationRelationship = IfcDocumentInformationRelationship;
  class IfcDocumentReference extends IfcExternalReference {
    constructor(Location, Identification, Name, Description, ReferencedDocument) {
      super(Location, Identification, Name);
      this.Location = Location;
      this.Identification = Identification;
      this.Name = Name;
      this.Description = Description;
      this.ReferencedDocument = ReferencedDocument;
      this.type = 3732053477;
    }
  }
  IFC4X32.IfcDocumentReference = IfcDocumentReference;
  class IfcEdge extends IfcTopologicalRepresentationItem {
    constructor(EdgeStart, EdgeEnd) {
      super();
      this.EdgeStart = EdgeStart;
      this.EdgeEnd = EdgeEnd;
      this.type = 3900360178;
    }
  }
  IFC4X32.IfcEdge = IfcEdge;
  class IfcEdgeCurve extends IfcEdge {
    constructor(EdgeStart, EdgeEnd, EdgeGeometry, SameSense) {
      super(EdgeStart, EdgeEnd);
      this.EdgeStart = EdgeStart;
      this.EdgeEnd = EdgeEnd;
      this.EdgeGeometry = EdgeGeometry;
      this.SameSense = SameSense;
      this.type = 476780140;
    }
  }
  IFC4X32.IfcEdgeCurve = IfcEdgeCurve;
  class IfcEventTime extends IfcSchedulingTime {
    constructor(Name, DataOrigin, UserDefinedDataOrigin, ActualDate, EarlyDate, LateDate, ScheduleDate) {
      super(Name, DataOrigin, UserDefinedDataOrigin);
      this.Name = Name;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.ActualDate = ActualDate;
      this.EarlyDate = EarlyDate;
      this.LateDate = LateDate;
      this.ScheduleDate = ScheduleDate;
      this.type = 211053100;
    }
  }
  IFC4X32.IfcEventTime = IfcEventTime;
  class IfcExtendedProperties extends IfcPropertyAbstraction {
    constructor(Name, Description, Properties2) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.Properties = Properties2;
      this.type = 297599258;
    }
  }
  IFC4X32.IfcExtendedProperties = IfcExtendedProperties;
  class IfcExternalReferenceRelationship extends IfcResourceLevelRelationship {
    constructor(Name, Description, RelatingReference, RelatedResourceObjects) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.RelatingReference = RelatingReference;
      this.RelatedResourceObjects = RelatedResourceObjects;
      this.type = 1437805879;
    }
  }
  IFC4X32.IfcExternalReferenceRelationship = IfcExternalReferenceRelationship;
  class IfcFace extends IfcTopologicalRepresentationItem {
    constructor(Bounds) {
      super();
      this.Bounds = Bounds;
      this.type = 2556980723;
    }
  }
  IFC4X32.IfcFace = IfcFace;
  class IfcFaceBound extends IfcTopologicalRepresentationItem {
    constructor(Bound, Orientation) {
      super();
      this.Bound = Bound;
      this.Orientation = Orientation;
      this.type = 1809719519;
    }
  }
  IFC4X32.IfcFaceBound = IfcFaceBound;
  class IfcFaceOuterBound extends IfcFaceBound {
    constructor(Bound, Orientation) {
      super(Bound, Orientation);
      this.Bound = Bound;
      this.Orientation = Orientation;
      this.type = 803316827;
    }
  }
  IFC4X32.IfcFaceOuterBound = IfcFaceOuterBound;
  class IfcFaceSurface extends IfcFace {
    constructor(Bounds, FaceSurface, SameSense) {
      super(Bounds);
      this.Bounds = Bounds;
      this.FaceSurface = FaceSurface;
      this.SameSense = SameSense;
      this.type = 3008276851;
    }
  }
  IFC4X32.IfcFaceSurface = IfcFaceSurface;
  class IfcFailureConnectionCondition extends IfcStructuralConnectionCondition {
    constructor(Name, TensionFailureX, TensionFailureY, TensionFailureZ, CompressionFailureX, CompressionFailureY, CompressionFailureZ) {
      super(Name);
      this.Name = Name;
      this.TensionFailureX = TensionFailureX;
      this.TensionFailureY = TensionFailureY;
      this.TensionFailureZ = TensionFailureZ;
      this.CompressionFailureX = CompressionFailureX;
      this.CompressionFailureY = CompressionFailureY;
      this.CompressionFailureZ = CompressionFailureZ;
      this.type = 4219587988;
    }
  }
  IFC4X32.IfcFailureConnectionCondition = IfcFailureConnectionCondition;
  class IfcFillAreaStyle extends IfcPresentationStyle {
    constructor(Name, FillStyles, ModelOrDraughting) {
      super(Name);
      this.Name = Name;
      this.FillStyles = FillStyles;
      this.ModelOrDraughting = ModelOrDraughting;
      this.type = 738692330;
    }
  }
  IFC4X32.IfcFillAreaStyle = IfcFillAreaStyle;
  class IfcGeometricRepresentationContext extends IfcRepresentationContext {
    constructor(ContextIdentifier, ContextType, CoordinateSpaceDimension, Precision, WorldCoordinateSystem, TrueNorth) {
      super(ContextIdentifier, ContextType);
      this.ContextIdentifier = ContextIdentifier;
      this.ContextType = ContextType;
      this.CoordinateSpaceDimension = CoordinateSpaceDimension;
      this.Precision = Precision;
      this.WorldCoordinateSystem = WorldCoordinateSystem;
      this.TrueNorth = TrueNorth;
      this.type = 3448662350;
    }
  }
  IFC4X32.IfcGeometricRepresentationContext = IfcGeometricRepresentationContext;
  class IfcGeometricRepresentationItem extends IfcRepresentationItem {
    constructor() {
      super();
      this.type = 2453401579;
    }
  }
  IFC4X32.IfcGeometricRepresentationItem = IfcGeometricRepresentationItem;
  class IfcGeometricRepresentationSubContext extends IfcGeometricRepresentationContext {
    constructor(ContextIdentifier, ContextType, ParentContext, TargetScale, TargetView, UserDefinedTargetView) {
      super(ContextIdentifier, ContextType, new IfcDimensionCount(0), null, new Handle(0), null);
      this.ContextIdentifier = ContextIdentifier;
      this.ContextType = ContextType;
      this.ParentContext = ParentContext;
      this.TargetScale = TargetScale;
      this.TargetView = TargetView;
      this.UserDefinedTargetView = UserDefinedTargetView;
      this.type = 4142052618;
    }
  }
  IFC4X32.IfcGeometricRepresentationSubContext = IfcGeometricRepresentationSubContext;
  class IfcGeometricSet extends IfcGeometricRepresentationItem {
    constructor(Elements) {
      super();
      this.Elements = Elements;
      this.type = 3590301190;
    }
  }
  IFC4X32.IfcGeometricSet = IfcGeometricSet;
  class IfcGridPlacement extends IfcObjectPlacement {
    constructor(PlacementRelTo, PlacementLocation, PlacementRefDirection) {
      super(PlacementRelTo);
      this.PlacementRelTo = PlacementRelTo;
      this.PlacementLocation = PlacementLocation;
      this.PlacementRefDirection = PlacementRefDirection;
      this.type = 178086475;
    }
  }
  IFC4X32.IfcGridPlacement = IfcGridPlacement;
  class IfcHalfSpaceSolid extends IfcGeometricRepresentationItem {
    constructor(BaseSurface, AgreementFlag) {
      super();
      this.BaseSurface = BaseSurface;
      this.AgreementFlag = AgreementFlag;
      this.type = 812098782;
    }
  }
  IFC4X32.IfcHalfSpaceSolid = IfcHalfSpaceSolid;
  class IfcImageTexture extends IfcSurfaceTexture {
    constructor(RepeatS, RepeatT, Mode, TextureTransform, Parameter, URLReference) {
      super(RepeatS, RepeatT, Mode, TextureTransform, Parameter);
      this.RepeatS = RepeatS;
      this.RepeatT = RepeatT;
      this.Mode = Mode;
      this.TextureTransform = TextureTransform;
      this.Parameter = Parameter;
      this.URLReference = URLReference;
      this.type = 3905492369;
    }
  }
  IFC4X32.IfcImageTexture = IfcImageTexture;
  class IfcIndexedColourMap extends IfcPresentationItem {
    constructor(MappedTo, Opacity, Colours, ColourIndex) {
      super();
      this.MappedTo = MappedTo;
      this.Opacity = Opacity;
      this.Colours = Colours;
      this.ColourIndex = ColourIndex;
      this.type = 3570813810;
    }
  }
  IFC4X32.IfcIndexedColourMap = IfcIndexedColourMap;
  class IfcIndexedTextureMap extends IfcTextureCoordinate {
    constructor(Maps, MappedTo, TexCoords) {
      super(Maps);
      this.Maps = Maps;
      this.MappedTo = MappedTo;
      this.TexCoords = TexCoords;
      this.type = 1437953363;
    }
  }
  IFC4X32.IfcIndexedTextureMap = IfcIndexedTextureMap;
  class IfcIndexedTriangleTextureMap extends IfcIndexedTextureMap {
    constructor(Maps, MappedTo, TexCoords, TexCoordIndex) {
      super(Maps, MappedTo, TexCoords);
      this.Maps = Maps;
      this.MappedTo = MappedTo;
      this.TexCoords = TexCoords;
      this.TexCoordIndex = TexCoordIndex;
      this.type = 2133299955;
    }
  }
  IFC4X32.IfcIndexedTriangleTextureMap = IfcIndexedTriangleTextureMap;
  class IfcIrregularTimeSeries extends IfcTimeSeries {
    constructor(Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit, Values) {
      super(Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit);
      this.Name = Name;
      this.Description = Description;
      this.StartTime = StartTime;
      this.EndTime = EndTime;
      this.TimeSeriesDataType = TimeSeriesDataType;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.Unit = Unit;
      this.Values = Values;
      this.type = 3741457305;
    }
  }
  IFC4X32.IfcIrregularTimeSeries = IfcIrregularTimeSeries;
  class IfcLagTime extends IfcSchedulingTime {
    constructor(Name, DataOrigin, UserDefinedDataOrigin, LagValue, DurationType) {
      super(Name, DataOrigin, UserDefinedDataOrigin);
      this.Name = Name;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.LagValue = LagValue;
      this.DurationType = DurationType;
      this.type = 1585845231;
    }
  }
  IFC4X32.IfcLagTime = IfcLagTime;
  class IfcLightSource extends IfcGeometricRepresentationItem {
    constructor(Name, LightColour, AmbientIntensity, Intensity) {
      super();
      this.Name = Name;
      this.LightColour = LightColour;
      this.AmbientIntensity = AmbientIntensity;
      this.Intensity = Intensity;
      this.type = 1402838566;
    }
  }
  IFC4X32.IfcLightSource = IfcLightSource;
  class IfcLightSourceAmbient extends IfcLightSource {
    constructor(Name, LightColour, AmbientIntensity, Intensity) {
      super(Name, LightColour, AmbientIntensity, Intensity);
      this.Name = Name;
      this.LightColour = LightColour;
      this.AmbientIntensity = AmbientIntensity;
      this.Intensity = Intensity;
      this.type = 125510826;
    }
  }
  IFC4X32.IfcLightSourceAmbient = IfcLightSourceAmbient;
  class IfcLightSourceDirectional extends IfcLightSource {
    constructor(Name, LightColour, AmbientIntensity, Intensity, Orientation) {
      super(Name, LightColour, AmbientIntensity, Intensity);
      this.Name = Name;
      this.LightColour = LightColour;
      this.AmbientIntensity = AmbientIntensity;
      this.Intensity = Intensity;
      this.Orientation = Orientation;
      this.type = 2604431987;
    }
  }
  IFC4X32.IfcLightSourceDirectional = IfcLightSourceDirectional;
  class IfcLightSourceGoniometric extends IfcLightSource {
    constructor(Name, LightColour, AmbientIntensity, Intensity, Position, ColourAppearance, ColourTemperature, LuminousFlux, LightEmissionSource, LightDistributionDataSource) {
      super(Name, LightColour, AmbientIntensity, Intensity);
      this.Name = Name;
      this.LightColour = LightColour;
      this.AmbientIntensity = AmbientIntensity;
      this.Intensity = Intensity;
      this.Position = Position;
      this.ColourAppearance = ColourAppearance;
      this.ColourTemperature = ColourTemperature;
      this.LuminousFlux = LuminousFlux;
      this.LightEmissionSource = LightEmissionSource;
      this.LightDistributionDataSource = LightDistributionDataSource;
      this.type = 4266656042;
    }
  }
  IFC4X32.IfcLightSourceGoniometric = IfcLightSourceGoniometric;
  class IfcLightSourcePositional extends IfcLightSource {
    constructor(Name, LightColour, AmbientIntensity, Intensity, Position, Radius, ConstantAttenuation, DistanceAttenuation, QuadricAttenuation) {
      super(Name, LightColour, AmbientIntensity, Intensity);
      this.Name = Name;
      this.LightColour = LightColour;
      this.AmbientIntensity = AmbientIntensity;
      this.Intensity = Intensity;
      this.Position = Position;
      this.Radius = Radius;
      this.ConstantAttenuation = ConstantAttenuation;
      this.DistanceAttenuation = DistanceAttenuation;
      this.QuadricAttenuation = QuadricAttenuation;
      this.type = 1520743889;
    }
  }
  IFC4X32.IfcLightSourcePositional = IfcLightSourcePositional;
  class IfcLightSourceSpot extends IfcLightSourcePositional {
    constructor(Name, LightColour, AmbientIntensity, Intensity, Position, Radius, ConstantAttenuation, DistanceAttenuation, QuadricAttenuation, Orientation, ConcentrationExponent, SpreadAngle, BeamWidthAngle) {
      super(Name, LightColour, AmbientIntensity, Intensity, Position, Radius, ConstantAttenuation, DistanceAttenuation, QuadricAttenuation);
      this.Name = Name;
      this.LightColour = LightColour;
      this.AmbientIntensity = AmbientIntensity;
      this.Intensity = Intensity;
      this.Position = Position;
      this.Radius = Radius;
      this.ConstantAttenuation = ConstantAttenuation;
      this.DistanceAttenuation = DistanceAttenuation;
      this.QuadricAttenuation = QuadricAttenuation;
      this.Orientation = Orientation;
      this.ConcentrationExponent = ConcentrationExponent;
      this.SpreadAngle = SpreadAngle;
      this.BeamWidthAngle = BeamWidthAngle;
      this.type = 3422422726;
    }
  }
  IFC4X32.IfcLightSourceSpot = IfcLightSourceSpot;
  class IfcLinearPlacement extends IfcObjectPlacement {
    constructor(PlacementRelTo, RelativePlacement, CartesianPosition) {
      super(PlacementRelTo);
      this.PlacementRelTo = PlacementRelTo;
      this.RelativePlacement = RelativePlacement;
      this.CartesianPosition = CartesianPosition;
      this.type = 388784114;
    }
  }
  IFC4X32.IfcLinearPlacement = IfcLinearPlacement;
  class IfcLocalPlacement extends IfcObjectPlacement {
    constructor(PlacementRelTo, RelativePlacement) {
      super(PlacementRelTo);
      this.PlacementRelTo = PlacementRelTo;
      this.RelativePlacement = RelativePlacement;
      this.type = 2624227202;
    }
  }
  IFC4X32.IfcLocalPlacement = IfcLocalPlacement;
  class IfcLoop extends IfcTopologicalRepresentationItem {
    constructor() {
      super();
      this.type = 1008929658;
    }
  }
  IFC4X32.IfcLoop = IfcLoop;
  class IfcMappedItem extends IfcRepresentationItem {
    constructor(MappingSource, MappingTarget) {
      super();
      this.MappingSource = MappingSource;
      this.MappingTarget = MappingTarget;
      this.type = 2347385850;
    }
  }
  IFC4X32.IfcMappedItem = IfcMappedItem;
  class IfcMaterial extends IfcMaterialDefinition {
    constructor(Name, Description, Category) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.Category = Category;
      this.type = 1838606355;
    }
  }
  IFC4X32.IfcMaterial = IfcMaterial;
  class IfcMaterialConstituent extends IfcMaterialDefinition {
    constructor(Name, Description, Material, Fraction, Category) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.Material = Material;
      this.Fraction = Fraction;
      this.Category = Category;
      this.type = 3708119e3;
    }
  }
  IFC4X32.IfcMaterialConstituent = IfcMaterialConstituent;
  class IfcMaterialConstituentSet extends IfcMaterialDefinition {
    constructor(Name, Description, MaterialConstituents) {
      super();
      this.Name = Name;
      this.Description = Description;
      this.MaterialConstituents = MaterialConstituents;
      this.type = 2852063980;
    }
  }
  IFC4X32.IfcMaterialConstituentSet = IfcMaterialConstituentSet;
  class IfcMaterialDefinitionRepresentation extends IfcProductRepresentation {
    constructor(Name, Description, Representations, RepresentedMaterial) {
      super(Name, Description, Representations);
      this.Name = Name;
      this.Description = Description;
      this.Representations = Representations;
      this.RepresentedMaterial = RepresentedMaterial;
      this.type = 2022407955;
    }
  }
  IFC4X32.IfcMaterialDefinitionRepresentation = IfcMaterialDefinitionRepresentation;
  class IfcMaterialLayerSetUsage extends IfcMaterialUsageDefinition {
    constructor(ForLayerSet, LayerSetDirection, DirectionSense, OffsetFromReferenceLine, ReferenceExtent) {
      super();
      this.ForLayerSet = ForLayerSet;
      this.LayerSetDirection = LayerSetDirection;
      this.DirectionSense = DirectionSense;
      this.OffsetFromReferenceLine = OffsetFromReferenceLine;
      this.ReferenceExtent = ReferenceExtent;
      this.type = 1303795690;
    }
  }
  IFC4X32.IfcMaterialLayerSetUsage = IfcMaterialLayerSetUsage;
  class IfcMaterialProfileSetUsage extends IfcMaterialUsageDefinition {
    constructor(ForProfileSet, CardinalPoint, ReferenceExtent) {
      super();
      this.ForProfileSet = ForProfileSet;
      this.CardinalPoint = CardinalPoint;
      this.ReferenceExtent = ReferenceExtent;
      this.type = 3079605661;
    }
  }
  IFC4X32.IfcMaterialProfileSetUsage = IfcMaterialProfileSetUsage;
  class IfcMaterialProfileSetUsageTapering extends IfcMaterialProfileSetUsage {
    constructor(ForProfileSet, CardinalPoint, ReferenceExtent, ForProfileEndSet, CardinalEndPoint) {
      super(ForProfileSet, CardinalPoint, ReferenceExtent);
      this.ForProfileSet = ForProfileSet;
      this.CardinalPoint = CardinalPoint;
      this.ReferenceExtent = ReferenceExtent;
      this.ForProfileEndSet = ForProfileEndSet;
      this.CardinalEndPoint = CardinalEndPoint;
      this.type = 3404854881;
    }
  }
  IFC4X32.IfcMaterialProfileSetUsageTapering = IfcMaterialProfileSetUsageTapering;
  class IfcMaterialProperties extends IfcExtendedProperties {
    constructor(Name, Description, Properties2, Material) {
      super(Name, Description, Properties2);
      this.Name = Name;
      this.Description = Description;
      this.Properties = Properties2;
      this.Material = Material;
      this.type = 3265635763;
    }
  }
  IFC4X32.IfcMaterialProperties = IfcMaterialProperties;
  class IfcMaterialRelationship extends IfcResourceLevelRelationship {
    constructor(Name, Description, RelatingMaterial, RelatedMaterials, MaterialExpression) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.RelatingMaterial = RelatingMaterial;
      this.RelatedMaterials = RelatedMaterials;
      this.MaterialExpression = MaterialExpression;
      this.type = 853536259;
    }
  }
  IFC4X32.IfcMaterialRelationship = IfcMaterialRelationship;
  class IfcMirroredProfileDef extends IfcDerivedProfileDef {
    constructor(ProfileType, ProfileName, ParentProfile, Label) {
      super(ProfileType, ProfileName, ParentProfile, new Handle(0), Label);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.ParentProfile = ParentProfile;
      this.Label = Label;
      this.type = 2998442950;
    }
  }
  IFC4X32.IfcMirroredProfileDef = IfcMirroredProfileDef;
  class IfcObjectDefinition extends IfcRoot {
    constructor(GlobalId, OwnerHistory, Name, Description) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 219451334;
    }
  }
  IFC4X32.IfcObjectDefinition = IfcObjectDefinition;
  class IfcOpenCrossProfileDef extends IfcProfileDef {
    constructor(ProfileType, ProfileName, HorizontalWidths, Widths, Slopes, Tags, OffsetPoint) {
      super(ProfileType, ProfileName);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.HorizontalWidths = HorizontalWidths;
      this.Widths = Widths;
      this.Slopes = Slopes;
      this.Tags = Tags;
      this.OffsetPoint = OffsetPoint;
      this.type = 182550632;
    }
  }
  IFC4X32.IfcOpenCrossProfileDef = IfcOpenCrossProfileDef;
  class IfcOpenShell extends IfcConnectedFaceSet {
    constructor(CfsFaces) {
      super(CfsFaces);
      this.CfsFaces = CfsFaces;
      this.type = 2665983363;
    }
  }
  IFC4X32.IfcOpenShell = IfcOpenShell;
  class IfcOrganizationRelationship extends IfcResourceLevelRelationship {
    constructor(Name, Description, RelatingOrganization, RelatedOrganizations) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.RelatingOrganization = RelatingOrganization;
      this.RelatedOrganizations = RelatedOrganizations;
      this.type = 1411181986;
    }
  }
  IFC4X32.IfcOrganizationRelationship = IfcOrganizationRelationship;
  class IfcOrientedEdge extends IfcEdge {
    constructor(EdgeElement, Orientation) {
      super(new Handle(0), new Handle(0));
      this.EdgeElement = EdgeElement;
      this.Orientation = Orientation;
      this.type = 1029017970;
    }
  }
  IFC4X32.IfcOrientedEdge = IfcOrientedEdge;
  class IfcParameterizedProfileDef extends IfcProfileDef {
    constructor(ProfileType, ProfileName, Position) {
      super(ProfileType, ProfileName);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.type = 2529465313;
    }
  }
  IFC4X32.IfcParameterizedProfileDef = IfcParameterizedProfileDef;
  class IfcPath extends IfcTopologicalRepresentationItem {
    constructor(EdgeList) {
      super();
      this.EdgeList = EdgeList;
      this.type = 2519244187;
    }
  }
  IFC4X32.IfcPath = IfcPath;
  class IfcPhysicalComplexQuantity extends IfcPhysicalQuantity {
    constructor(Name, Description, HasQuantities, Discrimination, Quality, Usage) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.HasQuantities = HasQuantities;
      this.Discrimination = Discrimination;
      this.Quality = Quality;
      this.Usage = Usage;
      this.type = 3021840470;
    }
  }
  IFC4X32.IfcPhysicalComplexQuantity = IfcPhysicalComplexQuantity;
  class IfcPixelTexture extends IfcSurfaceTexture {
    constructor(RepeatS, RepeatT, Mode, TextureTransform, Parameter, Width, Height, ColourComponents, Pixel) {
      super(RepeatS, RepeatT, Mode, TextureTransform, Parameter);
      this.RepeatS = RepeatS;
      this.RepeatT = RepeatT;
      this.Mode = Mode;
      this.TextureTransform = TextureTransform;
      this.Parameter = Parameter;
      this.Width = Width;
      this.Height = Height;
      this.ColourComponents = ColourComponents;
      this.Pixel = Pixel;
      this.type = 597895409;
    }
  }
  IFC4X32.IfcPixelTexture = IfcPixelTexture;
  class IfcPlacement extends IfcGeometricRepresentationItem {
    constructor(Location) {
      super();
      this.Location = Location;
      this.type = 2004835150;
    }
  }
  IFC4X32.IfcPlacement = IfcPlacement;
  class IfcPlanarExtent extends IfcGeometricRepresentationItem {
    constructor(SizeInX, SizeInY) {
      super();
      this.SizeInX = SizeInX;
      this.SizeInY = SizeInY;
      this.type = 1663979128;
    }
  }
  IFC4X32.IfcPlanarExtent = IfcPlanarExtent;
  class IfcPoint extends IfcGeometricRepresentationItem {
    constructor() {
      super();
      this.type = 2067069095;
    }
  }
  IFC4X32.IfcPoint = IfcPoint;
  class IfcPointByDistanceExpression extends IfcPoint {
    constructor(DistanceAlong, OffsetLateral, OffsetVertical, OffsetLongitudinal, BasisCurve) {
      super();
      this.DistanceAlong = DistanceAlong;
      this.OffsetLateral = OffsetLateral;
      this.OffsetVertical = OffsetVertical;
      this.OffsetLongitudinal = OffsetLongitudinal;
      this.BasisCurve = BasisCurve;
      this.type = 2165702409;
    }
  }
  IFC4X32.IfcPointByDistanceExpression = IfcPointByDistanceExpression;
  class IfcPointOnCurve extends IfcPoint {
    constructor(BasisCurve, PointParameter) {
      super();
      this.BasisCurve = BasisCurve;
      this.PointParameter = PointParameter;
      this.type = 4022376103;
    }
  }
  IFC4X32.IfcPointOnCurve = IfcPointOnCurve;
  class IfcPointOnSurface extends IfcPoint {
    constructor(BasisSurface, PointParameterU, PointParameterV) {
      super();
      this.BasisSurface = BasisSurface;
      this.PointParameterU = PointParameterU;
      this.PointParameterV = PointParameterV;
      this.type = 1423911732;
    }
  }
  IFC4X32.IfcPointOnSurface = IfcPointOnSurface;
  class IfcPolyLoop extends IfcLoop {
    constructor(Polygon) {
      super();
      this.Polygon = Polygon;
      this.type = 2924175390;
    }
  }
  IFC4X32.IfcPolyLoop = IfcPolyLoop;
  class IfcPolygonalBoundedHalfSpace extends IfcHalfSpaceSolid {
    constructor(BaseSurface, AgreementFlag, Position, PolygonalBoundary) {
      super(BaseSurface, AgreementFlag);
      this.BaseSurface = BaseSurface;
      this.AgreementFlag = AgreementFlag;
      this.Position = Position;
      this.PolygonalBoundary = PolygonalBoundary;
      this.type = 2775532180;
    }
  }
  IFC4X32.IfcPolygonalBoundedHalfSpace = IfcPolygonalBoundedHalfSpace;
  class IfcPreDefinedItem extends IfcPresentationItem {
    constructor(Name) {
      super();
      this.Name = Name;
      this.type = 3727388367;
    }
  }
  IFC4X32.IfcPreDefinedItem = IfcPreDefinedItem;
  class IfcPreDefinedProperties extends IfcPropertyAbstraction {
    constructor() {
      super();
      this.type = 3778827333;
    }
  }
  IFC4X32.IfcPreDefinedProperties = IfcPreDefinedProperties;
  class IfcPreDefinedTextFont extends IfcPreDefinedItem {
    constructor(Name) {
      super(Name);
      this.Name = Name;
      this.type = 1775413392;
    }
  }
  IFC4X32.IfcPreDefinedTextFont = IfcPreDefinedTextFont;
  class IfcProductDefinitionShape extends IfcProductRepresentation {
    constructor(Name, Description, Representations) {
      super(Name, Description, Representations);
      this.Name = Name;
      this.Description = Description;
      this.Representations = Representations;
      this.type = 673634403;
    }
  }
  IFC4X32.IfcProductDefinitionShape = IfcProductDefinitionShape;
  class IfcProfileProperties extends IfcExtendedProperties {
    constructor(Name, Description, Properties2, ProfileDefinition) {
      super(Name, Description, Properties2);
      this.Name = Name;
      this.Description = Description;
      this.Properties = Properties2;
      this.ProfileDefinition = ProfileDefinition;
      this.type = 2802850158;
    }
  }
  IFC4X32.IfcProfileProperties = IfcProfileProperties;
  class IfcProperty extends IfcPropertyAbstraction {
    constructor(Name, Specification) {
      super();
      this.Name = Name;
      this.Specification = Specification;
      this.type = 2598011224;
    }
  }
  IFC4X32.IfcProperty = IfcProperty;
  class IfcPropertyDefinition extends IfcRoot {
    constructor(GlobalId, OwnerHistory, Name, Description) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 1680319473;
    }
  }
  IFC4X32.IfcPropertyDefinition = IfcPropertyDefinition;
  class IfcPropertyDependencyRelationship extends IfcResourceLevelRelationship {
    constructor(Name, Description, DependingProperty, DependantProperty, Expression) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.DependingProperty = DependingProperty;
      this.DependantProperty = DependantProperty;
      this.Expression = Expression;
      this.type = 148025276;
    }
  }
  IFC4X32.IfcPropertyDependencyRelationship = IfcPropertyDependencyRelationship;
  class IfcPropertySetDefinition extends IfcPropertyDefinition {
    constructor(GlobalId, OwnerHistory, Name, Description) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 3357820518;
    }
  }
  IFC4X32.IfcPropertySetDefinition = IfcPropertySetDefinition;
  class IfcPropertyTemplateDefinition extends IfcPropertyDefinition {
    constructor(GlobalId, OwnerHistory, Name, Description) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 1482703590;
    }
  }
  IFC4X32.IfcPropertyTemplateDefinition = IfcPropertyTemplateDefinition;
  class IfcQuantitySet extends IfcPropertySetDefinition {
    constructor(GlobalId, OwnerHistory, Name, Description) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 2090586900;
    }
  }
  IFC4X32.IfcQuantitySet = IfcQuantitySet;
  class IfcRectangleProfileDef extends IfcParameterizedProfileDef {
    constructor(ProfileType, ProfileName, Position, XDim, YDim) {
      super(ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.XDim = XDim;
      this.YDim = YDim;
      this.type = 3615266464;
    }
  }
  IFC4X32.IfcRectangleProfileDef = IfcRectangleProfileDef;
  class IfcRegularTimeSeries extends IfcTimeSeries {
    constructor(Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit, TimeStep, Values) {
      super(Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit);
      this.Name = Name;
      this.Description = Description;
      this.StartTime = StartTime;
      this.EndTime = EndTime;
      this.TimeSeriesDataType = TimeSeriesDataType;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.Unit = Unit;
      this.TimeStep = TimeStep;
      this.Values = Values;
      this.type = 3413951693;
    }
  }
  IFC4X32.IfcRegularTimeSeries = IfcRegularTimeSeries;
  class IfcReinforcementBarProperties extends IfcPreDefinedProperties {
    constructor(TotalCrossSectionArea, SteelGrade, BarSurface, EffectiveDepth, NominalBarDiameter, BarCount) {
      super();
      this.TotalCrossSectionArea = TotalCrossSectionArea;
      this.SteelGrade = SteelGrade;
      this.BarSurface = BarSurface;
      this.EffectiveDepth = EffectiveDepth;
      this.NominalBarDiameter = NominalBarDiameter;
      this.BarCount = BarCount;
      this.type = 1580146022;
    }
  }
  IFC4X32.IfcReinforcementBarProperties = IfcReinforcementBarProperties;
  class IfcRelationship extends IfcRoot {
    constructor(GlobalId, OwnerHistory, Name, Description) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 478536968;
    }
  }
  IFC4X32.IfcRelationship = IfcRelationship;
  class IfcResourceApprovalRelationship extends IfcResourceLevelRelationship {
    constructor(Name, Description, RelatedResourceObjects, RelatingApproval) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.RelatedResourceObjects = RelatedResourceObjects;
      this.RelatingApproval = RelatingApproval;
      this.type = 2943643501;
    }
  }
  IFC4X32.IfcResourceApprovalRelationship = IfcResourceApprovalRelationship;
  class IfcResourceConstraintRelationship extends IfcResourceLevelRelationship {
    constructor(Name, Description, RelatingConstraint, RelatedResourceObjects) {
      super(Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.RelatingConstraint = RelatingConstraint;
      this.RelatedResourceObjects = RelatedResourceObjects;
      this.type = 1608871552;
    }
  }
  IFC4X32.IfcResourceConstraintRelationship = IfcResourceConstraintRelationship;
  class IfcResourceTime extends IfcSchedulingTime {
    constructor(Name, DataOrigin, UserDefinedDataOrigin, ScheduleWork, ScheduleUsage, ScheduleStart, ScheduleFinish, ScheduleContour, LevelingDelay, IsOverAllocated, StatusTime, ActualWork, ActualUsage, ActualStart, ActualFinish, RemainingWork, RemainingUsage, Completion) {
      super(Name, DataOrigin, UserDefinedDataOrigin);
      this.Name = Name;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.ScheduleWork = ScheduleWork;
      this.ScheduleUsage = ScheduleUsage;
      this.ScheduleStart = ScheduleStart;
      this.ScheduleFinish = ScheduleFinish;
      this.ScheduleContour = ScheduleContour;
      this.LevelingDelay = LevelingDelay;
      this.IsOverAllocated = IsOverAllocated;
      this.StatusTime = StatusTime;
      this.ActualWork = ActualWork;
      this.ActualUsage = ActualUsage;
      this.ActualStart = ActualStart;
      this.ActualFinish = ActualFinish;
      this.RemainingWork = RemainingWork;
      this.RemainingUsage = RemainingUsage;
      this.Completion = Completion;
      this.type = 1042787934;
    }
  }
  IFC4X32.IfcResourceTime = IfcResourceTime;
  class IfcRoundedRectangleProfileDef extends IfcRectangleProfileDef {
    constructor(ProfileType, ProfileName, Position, XDim, YDim, RoundingRadius) {
      super(ProfileType, ProfileName, Position, XDim, YDim);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.XDim = XDim;
      this.YDim = YDim;
      this.RoundingRadius = RoundingRadius;
      this.type = 2778083089;
    }
  }
  IFC4X32.IfcRoundedRectangleProfileDef = IfcRoundedRectangleProfileDef;
  class IfcSectionProperties extends IfcPreDefinedProperties {
    constructor(SectionType, StartProfile, EndProfile) {
      super();
      this.SectionType = SectionType;
      this.StartProfile = StartProfile;
      this.EndProfile = EndProfile;
      this.type = 2042790032;
    }
  }
  IFC4X32.IfcSectionProperties = IfcSectionProperties;
  class IfcSectionReinforcementProperties extends IfcPreDefinedProperties {
    constructor(LongitudinalStartPosition, LongitudinalEndPosition, TransversePosition, ReinforcementRole, SectionDefinition, CrossSectionReinforcementDefinitions) {
      super();
      this.LongitudinalStartPosition = LongitudinalStartPosition;
      this.LongitudinalEndPosition = LongitudinalEndPosition;
      this.TransversePosition = TransversePosition;
      this.ReinforcementRole = ReinforcementRole;
      this.SectionDefinition = SectionDefinition;
      this.CrossSectionReinforcementDefinitions = CrossSectionReinforcementDefinitions;
      this.type = 4165799628;
    }
  }
  IFC4X32.IfcSectionReinforcementProperties = IfcSectionReinforcementProperties;
  class IfcSectionedSpine extends IfcGeometricRepresentationItem {
    constructor(SpineCurve, CrossSections, CrossSectionPositions) {
      super();
      this.SpineCurve = SpineCurve;
      this.CrossSections = CrossSections;
      this.CrossSectionPositions = CrossSectionPositions;
      this.type = 1509187699;
    }
  }
  IFC4X32.IfcSectionedSpine = IfcSectionedSpine;
  class IfcSegment extends IfcGeometricRepresentationItem {
    constructor(Transition) {
      super();
      this.Transition = Transition;
      this.type = 823603102;
    }
  }
  IFC4X32.IfcSegment = IfcSegment;
  class IfcShellBasedSurfaceModel extends IfcGeometricRepresentationItem {
    constructor(SbsmBoundary) {
      super();
      this.SbsmBoundary = SbsmBoundary;
      this.type = 4124623270;
    }
  }
  IFC4X32.IfcShellBasedSurfaceModel = IfcShellBasedSurfaceModel;
  class IfcSimpleProperty extends IfcProperty {
    constructor(Name, Specification) {
      super(Name, Specification);
      this.Name = Name;
      this.Specification = Specification;
      this.type = 3692461612;
    }
  }
  IFC4X32.IfcSimpleProperty = IfcSimpleProperty;
  class IfcSlippageConnectionCondition extends IfcStructuralConnectionCondition {
    constructor(Name, SlippageX, SlippageY, SlippageZ) {
      super(Name);
      this.Name = Name;
      this.SlippageX = SlippageX;
      this.SlippageY = SlippageY;
      this.SlippageZ = SlippageZ;
      this.type = 2609359061;
    }
  }
  IFC4X32.IfcSlippageConnectionCondition = IfcSlippageConnectionCondition;
  class IfcSolidModel extends IfcGeometricRepresentationItem {
    constructor() {
      super();
      this.type = 723233188;
    }
  }
  IFC4X32.IfcSolidModel = IfcSolidModel;
  class IfcStructuralLoadLinearForce extends IfcStructuralLoadStatic {
    constructor(Name, LinearForceX, LinearForceY, LinearForceZ, LinearMomentX, LinearMomentY, LinearMomentZ) {
      super(Name);
      this.Name = Name;
      this.LinearForceX = LinearForceX;
      this.LinearForceY = LinearForceY;
      this.LinearForceZ = LinearForceZ;
      this.LinearMomentX = LinearMomentX;
      this.LinearMomentY = LinearMomentY;
      this.LinearMomentZ = LinearMomentZ;
      this.type = 1595516126;
    }
  }
  IFC4X32.IfcStructuralLoadLinearForce = IfcStructuralLoadLinearForce;
  class IfcStructuralLoadPlanarForce extends IfcStructuralLoadStatic {
    constructor(Name, PlanarForceX, PlanarForceY, PlanarForceZ) {
      super(Name);
      this.Name = Name;
      this.PlanarForceX = PlanarForceX;
      this.PlanarForceY = PlanarForceY;
      this.PlanarForceZ = PlanarForceZ;
      this.type = 2668620305;
    }
  }
  IFC4X32.IfcStructuralLoadPlanarForce = IfcStructuralLoadPlanarForce;
  class IfcStructuralLoadSingleDisplacement extends IfcStructuralLoadStatic {
    constructor(Name, DisplacementX, DisplacementY, DisplacementZ, RotationalDisplacementRX, RotationalDisplacementRY, RotationalDisplacementRZ) {
      super(Name);
      this.Name = Name;
      this.DisplacementX = DisplacementX;
      this.DisplacementY = DisplacementY;
      this.DisplacementZ = DisplacementZ;
      this.RotationalDisplacementRX = RotationalDisplacementRX;
      this.RotationalDisplacementRY = RotationalDisplacementRY;
      this.RotationalDisplacementRZ = RotationalDisplacementRZ;
      this.type = 2473145415;
    }
  }
  IFC4X32.IfcStructuralLoadSingleDisplacement = IfcStructuralLoadSingleDisplacement;
  class IfcStructuralLoadSingleDisplacementDistortion extends IfcStructuralLoadSingleDisplacement {
    constructor(Name, DisplacementX, DisplacementY, DisplacementZ, RotationalDisplacementRX, RotationalDisplacementRY, RotationalDisplacementRZ, Distortion) {
      super(Name, DisplacementX, DisplacementY, DisplacementZ, RotationalDisplacementRX, RotationalDisplacementRY, RotationalDisplacementRZ);
      this.Name = Name;
      this.DisplacementX = DisplacementX;
      this.DisplacementY = DisplacementY;
      this.DisplacementZ = DisplacementZ;
      this.RotationalDisplacementRX = RotationalDisplacementRX;
      this.RotationalDisplacementRY = RotationalDisplacementRY;
      this.RotationalDisplacementRZ = RotationalDisplacementRZ;
      this.Distortion = Distortion;
      this.type = 1973038258;
    }
  }
  IFC4X32.IfcStructuralLoadSingleDisplacementDistortion = IfcStructuralLoadSingleDisplacementDistortion;
  class IfcStructuralLoadSingleForce extends IfcStructuralLoadStatic {
    constructor(Name, ForceX, ForceY, ForceZ, MomentX, MomentY, MomentZ) {
      super(Name);
      this.Name = Name;
      this.ForceX = ForceX;
      this.ForceY = ForceY;
      this.ForceZ = ForceZ;
      this.MomentX = MomentX;
      this.MomentY = MomentY;
      this.MomentZ = MomentZ;
      this.type = 1597423693;
    }
  }
  IFC4X32.IfcStructuralLoadSingleForce = IfcStructuralLoadSingleForce;
  class IfcStructuralLoadSingleForceWarping extends IfcStructuralLoadSingleForce {
    constructor(Name, ForceX, ForceY, ForceZ, MomentX, MomentY, MomentZ, WarpingMoment) {
      super(Name, ForceX, ForceY, ForceZ, MomentX, MomentY, MomentZ);
      this.Name = Name;
      this.ForceX = ForceX;
      this.ForceY = ForceY;
      this.ForceZ = ForceZ;
      this.MomentX = MomentX;
      this.MomentY = MomentY;
      this.MomentZ = MomentZ;
      this.WarpingMoment = WarpingMoment;
      this.type = 1190533807;
    }
  }
  IFC4X32.IfcStructuralLoadSingleForceWarping = IfcStructuralLoadSingleForceWarping;
  class IfcSubedge extends IfcEdge {
    constructor(EdgeStart, EdgeEnd, ParentEdge) {
      super(EdgeStart, EdgeEnd);
      this.EdgeStart = EdgeStart;
      this.EdgeEnd = EdgeEnd;
      this.ParentEdge = ParentEdge;
      this.type = 2233826070;
    }
  }
  IFC4X32.IfcSubedge = IfcSubedge;
  class IfcSurface extends IfcGeometricRepresentationItem {
    constructor() {
      super();
      this.type = 2513912981;
    }
  }
  IFC4X32.IfcSurface = IfcSurface;
  class IfcSurfaceStyleRendering extends IfcSurfaceStyleShading {
    constructor(SurfaceColour, Transparency, DiffuseColour, TransmissionColour, DiffuseTransmissionColour, ReflectionColour, SpecularColour, SpecularHighlight, ReflectanceMethod) {
      super(SurfaceColour, Transparency);
      this.SurfaceColour = SurfaceColour;
      this.Transparency = Transparency;
      this.DiffuseColour = DiffuseColour;
      this.TransmissionColour = TransmissionColour;
      this.DiffuseTransmissionColour = DiffuseTransmissionColour;
      this.ReflectionColour = ReflectionColour;
      this.SpecularColour = SpecularColour;
      this.SpecularHighlight = SpecularHighlight;
      this.ReflectanceMethod = ReflectanceMethod;
      this.type = 1878645084;
    }
  }
  IFC4X32.IfcSurfaceStyleRendering = IfcSurfaceStyleRendering;
  class IfcSweptAreaSolid extends IfcSolidModel {
    constructor(SweptArea, Position) {
      super();
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.type = 2247615214;
    }
  }
  IFC4X32.IfcSweptAreaSolid = IfcSweptAreaSolid;
  class IfcSweptDiskSolid extends IfcSolidModel {
    constructor(Directrix, Radius, InnerRadius, StartParam, EndParam) {
      super();
      this.Directrix = Directrix;
      this.Radius = Radius;
      this.InnerRadius = InnerRadius;
      this.StartParam = StartParam;
      this.EndParam = EndParam;
      this.type = 1260650574;
    }
  }
  IFC4X32.IfcSweptDiskSolid = IfcSweptDiskSolid;
  class IfcSweptDiskSolidPolygonal extends IfcSweptDiskSolid {
    constructor(Directrix, Radius, InnerRadius, StartParam, EndParam, FilletRadius) {
      super(Directrix, Radius, InnerRadius, StartParam, EndParam);
      this.Directrix = Directrix;
      this.Radius = Radius;
      this.InnerRadius = InnerRadius;
      this.StartParam = StartParam;
      this.EndParam = EndParam;
      this.FilletRadius = FilletRadius;
      this.type = 1096409881;
    }
  }
  IFC4X32.IfcSweptDiskSolidPolygonal = IfcSweptDiskSolidPolygonal;
  class IfcSweptSurface extends IfcSurface {
    constructor(SweptCurve, Position) {
      super();
      this.SweptCurve = SweptCurve;
      this.Position = Position;
      this.type = 230924584;
    }
  }
  IFC4X32.IfcSweptSurface = IfcSweptSurface;
  class IfcTShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(ProfileType, ProfileName, Position, Depth, FlangeWidth, WebThickness, FlangeThickness, FilletRadius, FlangeEdgeRadius, WebEdgeRadius, WebSlope, FlangeSlope) {
      super(ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Depth = Depth;
      this.FlangeWidth = FlangeWidth;
      this.WebThickness = WebThickness;
      this.FlangeThickness = FlangeThickness;
      this.FilletRadius = FilletRadius;
      this.FlangeEdgeRadius = FlangeEdgeRadius;
      this.WebEdgeRadius = WebEdgeRadius;
      this.WebSlope = WebSlope;
      this.FlangeSlope = FlangeSlope;
      this.type = 3071757647;
    }
  }
  IFC4X32.IfcTShapeProfileDef = IfcTShapeProfileDef;
  class IfcTessellatedItem extends IfcGeometricRepresentationItem {
    constructor() {
      super();
      this.type = 901063453;
    }
  }
  IFC4X32.IfcTessellatedItem = IfcTessellatedItem;
  class IfcTextLiteral extends IfcGeometricRepresentationItem {
    constructor(Literal, Placement, Path) {
      super();
      this.Literal = Literal;
      this.Placement = Placement;
      this.Path = Path;
      this.type = 4282788508;
    }
  }
  IFC4X32.IfcTextLiteral = IfcTextLiteral;
  class IfcTextLiteralWithExtent extends IfcTextLiteral {
    constructor(Literal, Placement, Path, Extent, BoxAlignment) {
      super(Literal, Placement, Path);
      this.Literal = Literal;
      this.Placement = Placement;
      this.Path = Path;
      this.Extent = Extent;
      this.BoxAlignment = BoxAlignment;
      this.type = 3124975700;
    }
  }
  IFC4X32.IfcTextLiteralWithExtent = IfcTextLiteralWithExtent;
  class IfcTextStyleFontModel extends IfcPreDefinedTextFont {
    constructor(Name, FontFamily, FontStyle, FontVariant, FontWeight, FontSize) {
      super(Name);
      this.Name = Name;
      this.FontFamily = FontFamily;
      this.FontStyle = FontStyle;
      this.FontVariant = FontVariant;
      this.FontWeight = FontWeight;
      this.FontSize = FontSize;
      this.type = 1983826977;
    }
  }
  IFC4X32.IfcTextStyleFontModel = IfcTextStyleFontModel;
  class IfcTrapeziumProfileDef extends IfcParameterizedProfileDef {
    constructor(ProfileType, ProfileName, Position, BottomXDim, TopXDim, YDim, TopXOffset) {
      super(ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.BottomXDim = BottomXDim;
      this.TopXDim = TopXDim;
      this.YDim = YDim;
      this.TopXOffset = TopXOffset;
      this.type = 2715220739;
    }
  }
  IFC4X32.IfcTrapeziumProfileDef = IfcTrapeziumProfileDef;
  class IfcTypeObject extends IfcObjectDefinition {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.type = 1628702193;
    }
  }
  IFC4X32.IfcTypeObject = IfcTypeObject;
  class IfcTypeProcess extends IfcTypeObject {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ProcessType = ProcessType;
      this.type = 3736923433;
    }
  }
  IFC4X32.IfcTypeProcess = IfcTypeProcess;
  class IfcTypeProduct extends IfcTypeObject {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.type = 2347495698;
    }
  }
  IFC4X32.IfcTypeProduct = IfcTypeProduct;
  class IfcTypeResource extends IfcTypeObject {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ResourceType = ResourceType;
      this.type = 3698973494;
    }
  }
  IFC4X32.IfcTypeResource = IfcTypeResource;
  class IfcUShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(ProfileType, ProfileName, Position, Depth, FlangeWidth, WebThickness, FlangeThickness, FilletRadius, EdgeRadius, FlangeSlope) {
      super(ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Depth = Depth;
      this.FlangeWidth = FlangeWidth;
      this.WebThickness = WebThickness;
      this.FlangeThickness = FlangeThickness;
      this.FilletRadius = FilletRadius;
      this.EdgeRadius = EdgeRadius;
      this.FlangeSlope = FlangeSlope;
      this.type = 427810014;
    }
  }
  IFC4X32.IfcUShapeProfileDef = IfcUShapeProfileDef;
  class IfcVector extends IfcGeometricRepresentationItem {
    constructor(Orientation, Magnitude) {
      super();
      this.Orientation = Orientation;
      this.Magnitude = Magnitude;
      this.type = 1417489154;
    }
  }
  IFC4X32.IfcVector = IfcVector;
  class IfcVertexLoop extends IfcLoop {
    constructor(LoopVertex) {
      super();
      this.LoopVertex = LoopVertex;
      this.type = 2759199220;
    }
  }
  IFC4X32.IfcVertexLoop = IfcVertexLoop;
  class IfcZShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(ProfileType, ProfileName, Position, Depth, FlangeWidth, WebThickness, FlangeThickness, FilletRadius, EdgeRadius) {
      super(ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Depth = Depth;
      this.FlangeWidth = FlangeWidth;
      this.WebThickness = WebThickness;
      this.FlangeThickness = FlangeThickness;
      this.FilletRadius = FilletRadius;
      this.EdgeRadius = EdgeRadius;
      this.type = 2543172580;
    }
  }
  IFC4X32.IfcZShapeProfileDef = IfcZShapeProfileDef;
  class IfcAdvancedFace extends IfcFaceSurface {
    constructor(Bounds, FaceSurface, SameSense) {
      super(Bounds, FaceSurface, SameSense);
      this.Bounds = Bounds;
      this.FaceSurface = FaceSurface;
      this.SameSense = SameSense;
      this.type = 3406155212;
    }
  }
  IFC4X32.IfcAdvancedFace = IfcAdvancedFace;
  class IfcAnnotationFillArea extends IfcGeometricRepresentationItem {
    constructor(OuterBoundary, InnerBoundaries) {
      super();
      this.OuterBoundary = OuterBoundary;
      this.InnerBoundaries = InnerBoundaries;
      this.type = 669184980;
    }
  }
  IFC4X32.IfcAnnotationFillArea = IfcAnnotationFillArea;
  class IfcAsymmetricIShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(ProfileType, ProfileName, Position, BottomFlangeWidth, OverallDepth, WebThickness, BottomFlangeThickness, BottomFlangeFilletRadius, TopFlangeWidth, TopFlangeThickness, TopFlangeFilletRadius, BottomFlangeEdgeRadius, BottomFlangeSlope, TopFlangeEdgeRadius, TopFlangeSlope) {
      super(ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.BottomFlangeWidth = BottomFlangeWidth;
      this.OverallDepth = OverallDepth;
      this.WebThickness = WebThickness;
      this.BottomFlangeThickness = BottomFlangeThickness;
      this.BottomFlangeFilletRadius = BottomFlangeFilletRadius;
      this.TopFlangeWidth = TopFlangeWidth;
      this.TopFlangeThickness = TopFlangeThickness;
      this.TopFlangeFilletRadius = TopFlangeFilletRadius;
      this.BottomFlangeEdgeRadius = BottomFlangeEdgeRadius;
      this.BottomFlangeSlope = BottomFlangeSlope;
      this.TopFlangeEdgeRadius = TopFlangeEdgeRadius;
      this.TopFlangeSlope = TopFlangeSlope;
      this.type = 3207858831;
    }
  }
  IFC4X32.IfcAsymmetricIShapeProfileDef = IfcAsymmetricIShapeProfileDef;
  class IfcAxis1Placement extends IfcPlacement {
    constructor(Location, Axis) {
      super(Location);
      this.Location = Location;
      this.Axis = Axis;
      this.type = 4261334040;
    }
  }
  IFC4X32.IfcAxis1Placement = IfcAxis1Placement;
  class IfcAxis2Placement2D extends IfcPlacement {
    constructor(Location, RefDirection) {
      super(Location);
      this.Location = Location;
      this.RefDirection = RefDirection;
      this.type = 3125803723;
    }
  }
  IFC4X32.IfcAxis2Placement2D = IfcAxis2Placement2D;
  class IfcAxis2Placement3D extends IfcPlacement {
    constructor(Location, Axis, RefDirection) {
      super(Location);
      this.Location = Location;
      this.Axis = Axis;
      this.RefDirection = RefDirection;
      this.type = 2740243338;
    }
  }
  IFC4X32.IfcAxis2Placement3D = IfcAxis2Placement3D;
  class IfcAxis2PlacementLinear extends IfcPlacement {
    constructor(Location, Axis, RefDirection) {
      super(Location);
      this.Location = Location;
      this.Axis = Axis;
      this.RefDirection = RefDirection;
      this.type = 3425423356;
    }
  }
  IFC4X32.IfcAxis2PlacementLinear = IfcAxis2PlacementLinear;
  class IfcBooleanResult extends IfcGeometricRepresentationItem {
    constructor(Operator, FirstOperand, SecondOperand) {
      super();
      this.Operator = Operator;
      this.FirstOperand = FirstOperand;
      this.SecondOperand = SecondOperand;
      this.type = 2736907675;
    }
  }
  IFC4X32.IfcBooleanResult = IfcBooleanResult;
  class IfcBoundedSurface extends IfcSurface {
    constructor() {
      super();
      this.type = 4182860854;
    }
  }
  IFC4X32.IfcBoundedSurface = IfcBoundedSurface;
  class IfcBoundingBox extends IfcGeometricRepresentationItem {
    constructor(Corner, XDim, YDim, ZDim) {
      super();
      this.Corner = Corner;
      this.XDim = XDim;
      this.YDim = YDim;
      this.ZDim = ZDim;
      this.type = 2581212453;
    }
  }
  IFC4X32.IfcBoundingBox = IfcBoundingBox;
  class IfcBoxedHalfSpace extends IfcHalfSpaceSolid {
    constructor(BaseSurface, AgreementFlag, Enclosure) {
      super(BaseSurface, AgreementFlag);
      this.BaseSurface = BaseSurface;
      this.AgreementFlag = AgreementFlag;
      this.Enclosure = Enclosure;
      this.type = 2713105998;
    }
  }
  IFC4X32.IfcBoxedHalfSpace = IfcBoxedHalfSpace;
  class IfcCShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(ProfileType, ProfileName, Position, Depth, Width, WallThickness, Girth, InternalFilletRadius) {
      super(ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Depth = Depth;
      this.Width = Width;
      this.WallThickness = WallThickness;
      this.Girth = Girth;
      this.InternalFilletRadius = InternalFilletRadius;
      this.type = 2898889636;
    }
  }
  IFC4X32.IfcCShapeProfileDef = IfcCShapeProfileDef;
  class IfcCartesianPoint extends IfcPoint {
    constructor(Coordinates) {
      super();
      this.Coordinates = Coordinates;
      this.type = 1123145078;
    }
  }
  IFC4X32.IfcCartesianPoint = IfcCartesianPoint;
  class IfcCartesianPointList extends IfcGeometricRepresentationItem {
    constructor() {
      super();
      this.type = 574549367;
    }
  }
  IFC4X32.IfcCartesianPointList = IfcCartesianPointList;
  class IfcCartesianPointList2D extends IfcCartesianPointList {
    constructor(CoordList, TagList) {
      super();
      this.CoordList = CoordList;
      this.TagList = TagList;
      this.type = 1675464909;
    }
  }
  IFC4X32.IfcCartesianPointList2D = IfcCartesianPointList2D;
  class IfcCartesianPointList3D extends IfcCartesianPointList {
    constructor(CoordList, TagList) {
      super();
      this.CoordList = CoordList;
      this.TagList = TagList;
      this.type = 2059837836;
    }
  }
  IFC4X32.IfcCartesianPointList3D = IfcCartesianPointList3D;
  class IfcCartesianTransformationOperator extends IfcGeometricRepresentationItem {
    constructor(Axis1, Axis2, LocalOrigin, Scale) {
      super();
      this.Axis1 = Axis1;
      this.Axis2 = Axis2;
      this.LocalOrigin = LocalOrigin;
      this.Scale = Scale;
      this.type = 59481748;
    }
  }
  IFC4X32.IfcCartesianTransformationOperator = IfcCartesianTransformationOperator;
  class IfcCartesianTransformationOperator2D extends IfcCartesianTransformationOperator {
    constructor(Axis1, Axis2, LocalOrigin, Scale) {
      super(Axis1, Axis2, LocalOrigin, Scale);
      this.Axis1 = Axis1;
      this.Axis2 = Axis2;
      this.LocalOrigin = LocalOrigin;
      this.Scale = Scale;
      this.type = 3749851601;
    }
  }
  IFC4X32.IfcCartesianTransformationOperator2D = IfcCartesianTransformationOperator2D;
  class IfcCartesianTransformationOperator2DnonUniform extends IfcCartesianTransformationOperator2D {
    constructor(Axis1, Axis2, LocalOrigin, Scale, Scale2) {
      super(Axis1, Axis2, LocalOrigin, Scale);
      this.Axis1 = Axis1;
      this.Axis2 = Axis2;
      this.LocalOrigin = LocalOrigin;
      this.Scale = Scale;
      this.Scale2 = Scale2;
      this.type = 3486308946;
    }
  }
  IFC4X32.IfcCartesianTransformationOperator2DnonUniform = IfcCartesianTransformationOperator2DnonUniform;
  class IfcCartesianTransformationOperator3D extends IfcCartesianTransformationOperator {
    constructor(Axis1, Axis2, LocalOrigin, Scale, Axis3) {
      super(Axis1, Axis2, LocalOrigin, Scale);
      this.Axis1 = Axis1;
      this.Axis2 = Axis2;
      this.LocalOrigin = LocalOrigin;
      this.Scale = Scale;
      this.Axis3 = Axis3;
      this.type = 3331915920;
    }
  }
  IFC4X32.IfcCartesianTransformationOperator3D = IfcCartesianTransformationOperator3D;
  class IfcCartesianTransformationOperator3DnonUniform extends IfcCartesianTransformationOperator3D {
    constructor(Axis1, Axis2, LocalOrigin, Scale, Axis3, Scale2, Scale3) {
      super(Axis1, Axis2, LocalOrigin, Scale, Axis3);
      this.Axis1 = Axis1;
      this.Axis2 = Axis2;
      this.LocalOrigin = LocalOrigin;
      this.Scale = Scale;
      this.Axis3 = Axis3;
      this.Scale2 = Scale2;
      this.Scale3 = Scale3;
      this.type = 1416205885;
    }
  }
  IFC4X32.IfcCartesianTransformationOperator3DnonUniform = IfcCartesianTransformationOperator3DnonUniform;
  class IfcCircleProfileDef extends IfcParameterizedProfileDef {
    constructor(ProfileType, ProfileName, Position, Radius) {
      super(ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Radius = Radius;
      this.type = 1383045692;
    }
  }
  IFC4X32.IfcCircleProfileDef = IfcCircleProfileDef;
  class IfcClosedShell extends IfcConnectedFaceSet {
    constructor(CfsFaces) {
      super(CfsFaces);
      this.CfsFaces = CfsFaces;
      this.type = 2205249479;
    }
  }
  IFC4X32.IfcClosedShell = IfcClosedShell;
  class IfcColourRgb extends IfcColourSpecification {
    constructor(Name, Red, Green, Blue) {
      super(Name);
      this.Name = Name;
      this.Red = Red;
      this.Green = Green;
      this.Blue = Blue;
      this.type = 776857604;
    }
  }
  IFC4X32.IfcColourRgb = IfcColourRgb;
  class IfcComplexProperty extends IfcProperty {
    constructor(Name, Specification, UsageName, HasProperties) {
      super(Name, Specification);
      this.Name = Name;
      this.Specification = Specification;
      this.UsageName = UsageName;
      this.HasProperties = HasProperties;
      this.type = 2542286263;
    }
  }
  IFC4X32.IfcComplexProperty = IfcComplexProperty;
  class IfcCompositeCurveSegment extends IfcSegment {
    constructor(Transition, SameSense, ParentCurve) {
      super(Transition);
      this.Transition = Transition;
      this.SameSense = SameSense;
      this.ParentCurve = ParentCurve;
      this.type = 2485617015;
    }
  }
  IFC4X32.IfcCompositeCurveSegment = IfcCompositeCurveSegment;
  class IfcConstructionResourceType extends IfcTypeResource {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ResourceType = ResourceType;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.type = 2574617495;
    }
  }
  IFC4X32.IfcConstructionResourceType = IfcConstructionResourceType;
  class IfcContext extends IfcObjectDefinition {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.LongName = LongName;
      this.Phase = Phase;
      this.RepresentationContexts = RepresentationContexts;
      this.UnitsInContext = UnitsInContext;
      this.type = 3419103109;
    }
  }
  IFC4X32.IfcContext = IfcContext;
  class IfcCrewResourceType extends IfcConstructionResourceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ResourceType = ResourceType;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 1815067380;
    }
  }
  IFC4X32.IfcCrewResourceType = IfcCrewResourceType;
  class IfcCsgPrimitive3D extends IfcGeometricRepresentationItem {
    constructor(Position) {
      super();
      this.Position = Position;
      this.type = 2506170314;
    }
  }
  IFC4X32.IfcCsgPrimitive3D = IfcCsgPrimitive3D;
  class IfcCsgSolid extends IfcSolidModel {
    constructor(TreeRootExpression) {
      super();
      this.TreeRootExpression = TreeRootExpression;
      this.type = 2147822146;
    }
  }
  IFC4X32.IfcCsgSolid = IfcCsgSolid;
  class IfcCurve extends IfcGeometricRepresentationItem {
    constructor() {
      super();
      this.type = 2601014836;
    }
  }
  IFC4X32.IfcCurve = IfcCurve;
  class IfcCurveBoundedPlane extends IfcBoundedSurface {
    constructor(BasisSurface, OuterBoundary, InnerBoundaries) {
      super();
      this.BasisSurface = BasisSurface;
      this.OuterBoundary = OuterBoundary;
      this.InnerBoundaries = InnerBoundaries;
      this.type = 2827736869;
    }
  }
  IFC4X32.IfcCurveBoundedPlane = IfcCurveBoundedPlane;
  class IfcCurveBoundedSurface extends IfcBoundedSurface {
    constructor(BasisSurface, Boundaries, ImplicitOuter) {
      super();
      this.BasisSurface = BasisSurface;
      this.Boundaries = Boundaries;
      this.ImplicitOuter = ImplicitOuter;
      this.type = 2629017746;
    }
  }
  IFC4X32.IfcCurveBoundedSurface = IfcCurveBoundedSurface;
  class IfcCurveSegment extends IfcSegment {
    constructor(Transition, Placement, SegmentStart, SegmentLength, ParentCurve) {
      super(Transition);
      this.Transition = Transition;
      this.Placement = Placement;
      this.SegmentStart = SegmentStart;
      this.SegmentLength = SegmentLength;
      this.ParentCurve = ParentCurve;
      this.type = 4212018352;
    }
  }
  IFC4X32.IfcCurveSegment = IfcCurveSegment;
  class IfcDirection extends IfcGeometricRepresentationItem {
    constructor(DirectionRatios) {
      super();
      this.DirectionRatios = DirectionRatios;
      this.type = 32440307;
    }
  }
  IFC4X32.IfcDirection = IfcDirection;
  class IfcDirectrixCurveSweptAreaSolid extends IfcSweptAreaSolid {
    constructor(SweptArea, Position, Directrix, StartParam, EndParam) {
      super(SweptArea, Position);
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.Directrix = Directrix;
      this.StartParam = StartParam;
      this.EndParam = EndParam;
      this.type = 593015953;
    }
  }
  IFC4X32.IfcDirectrixCurveSweptAreaSolid = IfcDirectrixCurveSweptAreaSolid;
  class IfcEdgeLoop extends IfcLoop {
    constructor(EdgeList) {
      super();
      this.EdgeList = EdgeList;
      this.type = 1472233963;
    }
  }
  IFC4X32.IfcEdgeLoop = IfcEdgeLoop;
  class IfcElementQuantity extends IfcQuantitySet {
    constructor(GlobalId, OwnerHistory, Name, Description, MethodOfMeasurement, Quantities) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.MethodOfMeasurement = MethodOfMeasurement;
      this.Quantities = Quantities;
      this.type = 1883228015;
    }
  }
  IFC4X32.IfcElementQuantity = IfcElementQuantity;
  class IfcElementType extends IfcTypeProduct {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 339256511;
    }
  }
  IFC4X32.IfcElementType = IfcElementType;
  class IfcElementarySurface extends IfcSurface {
    constructor(Position) {
      super();
      this.Position = Position;
      this.type = 2777663545;
    }
  }
  IFC4X32.IfcElementarySurface = IfcElementarySurface;
  class IfcEllipseProfileDef extends IfcParameterizedProfileDef {
    constructor(ProfileType, ProfileName, Position, SemiAxis1, SemiAxis2) {
      super(ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.SemiAxis1 = SemiAxis1;
      this.SemiAxis2 = SemiAxis2;
      this.type = 2835456948;
    }
  }
  IFC4X32.IfcEllipseProfileDef = IfcEllipseProfileDef;
  class IfcEventType extends IfcTypeProcess {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType, PredefinedType, EventTriggerType, UserDefinedEventTriggerType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ProcessType = ProcessType;
      this.PredefinedType = PredefinedType;
      this.EventTriggerType = EventTriggerType;
      this.UserDefinedEventTriggerType = UserDefinedEventTriggerType;
      this.type = 4024345920;
    }
  }
  IFC4X32.IfcEventType = IfcEventType;
  class IfcExtrudedAreaSolid extends IfcSweptAreaSolid {
    constructor(SweptArea, Position, ExtrudedDirection, Depth) {
      super(SweptArea, Position);
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.ExtrudedDirection = ExtrudedDirection;
      this.Depth = Depth;
      this.type = 477187591;
    }
  }
  IFC4X32.IfcExtrudedAreaSolid = IfcExtrudedAreaSolid;
  class IfcExtrudedAreaSolidTapered extends IfcExtrudedAreaSolid {
    constructor(SweptArea, Position, ExtrudedDirection, Depth, EndSweptArea) {
      super(SweptArea, Position, ExtrudedDirection, Depth);
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.ExtrudedDirection = ExtrudedDirection;
      this.Depth = Depth;
      this.EndSweptArea = EndSweptArea;
      this.type = 2804161546;
    }
  }
  IFC4X32.IfcExtrudedAreaSolidTapered = IfcExtrudedAreaSolidTapered;
  class IfcFaceBasedSurfaceModel extends IfcGeometricRepresentationItem {
    constructor(FbsmFaces) {
      super();
      this.FbsmFaces = FbsmFaces;
      this.type = 2047409740;
    }
  }
  IFC4X32.IfcFaceBasedSurfaceModel = IfcFaceBasedSurfaceModel;
  class IfcFillAreaStyleHatching extends IfcGeometricRepresentationItem {
    constructor(HatchLineAppearance, StartOfNextHatchLine, PointOfReferenceHatchLine, PatternStart, HatchLineAngle) {
      super();
      this.HatchLineAppearance = HatchLineAppearance;
      this.StartOfNextHatchLine = StartOfNextHatchLine;
      this.PointOfReferenceHatchLine = PointOfReferenceHatchLine;
      this.PatternStart = PatternStart;
      this.HatchLineAngle = HatchLineAngle;
      this.type = 374418227;
    }
  }
  IFC4X32.IfcFillAreaStyleHatching = IfcFillAreaStyleHatching;
  class IfcFillAreaStyleTiles extends IfcGeometricRepresentationItem {
    constructor(TilingPattern, Tiles, TilingScale) {
      super();
      this.TilingPattern = TilingPattern;
      this.Tiles = Tiles;
      this.TilingScale = TilingScale;
      this.type = 315944413;
    }
  }
  IFC4X32.IfcFillAreaStyleTiles = IfcFillAreaStyleTiles;
  class IfcFixedReferenceSweptAreaSolid extends IfcDirectrixCurveSweptAreaSolid {
    constructor(SweptArea, Position, Directrix, StartParam, EndParam, FixedReference) {
      super(SweptArea, Position, Directrix, StartParam, EndParam);
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.Directrix = Directrix;
      this.StartParam = StartParam;
      this.EndParam = EndParam;
      this.FixedReference = FixedReference;
      this.type = 2652556860;
    }
  }
  IFC4X32.IfcFixedReferenceSweptAreaSolid = IfcFixedReferenceSweptAreaSolid;
  class IfcFurnishingElementType extends IfcElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 4238390223;
    }
  }
  IFC4X32.IfcFurnishingElementType = IfcFurnishingElementType;
  class IfcFurnitureType extends IfcFurnishingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, AssemblyPlace, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.AssemblyPlace = AssemblyPlace;
      this.PredefinedType = PredefinedType;
      this.type = 1268542332;
    }
  }
  IFC4X32.IfcFurnitureType = IfcFurnitureType;
  class IfcGeographicElementType extends IfcElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4095422895;
    }
  }
  IFC4X32.IfcGeographicElementType = IfcGeographicElementType;
  class IfcGeometricCurveSet extends IfcGeometricSet {
    constructor(Elements) {
      super(Elements);
      this.Elements = Elements;
      this.type = 987898635;
    }
  }
  IFC4X32.IfcGeometricCurveSet = IfcGeometricCurveSet;
  class IfcIShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(ProfileType, ProfileName, Position, OverallWidth, OverallDepth, WebThickness, FlangeThickness, FilletRadius, FlangeEdgeRadius, FlangeSlope) {
      super(ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.OverallWidth = OverallWidth;
      this.OverallDepth = OverallDepth;
      this.WebThickness = WebThickness;
      this.FlangeThickness = FlangeThickness;
      this.FilletRadius = FilletRadius;
      this.FlangeEdgeRadius = FlangeEdgeRadius;
      this.FlangeSlope = FlangeSlope;
      this.type = 1484403080;
    }
  }
  IFC4X32.IfcIShapeProfileDef = IfcIShapeProfileDef;
  class IfcIndexedPolygonalFace extends IfcTessellatedItem {
    constructor(CoordIndex) {
      super();
      this.CoordIndex = CoordIndex;
      this.type = 178912537;
    }
  }
  IFC4X32.IfcIndexedPolygonalFace = IfcIndexedPolygonalFace;
  class IfcIndexedPolygonalFaceWithVoids extends IfcIndexedPolygonalFace {
    constructor(CoordIndex, InnerCoordIndices) {
      super(CoordIndex);
      this.CoordIndex = CoordIndex;
      this.InnerCoordIndices = InnerCoordIndices;
      this.type = 2294589976;
    }
  }
  IFC4X32.IfcIndexedPolygonalFaceWithVoids = IfcIndexedPolygonalFaceWithVoids;
  class IfcIndexedPolygonalTextureMap extends IfcIndexedTextureMap {
    constructor(Maps, MappedTo, TexCoords, TexCoordIndices) {
      super(Maps, MappedTo, TexCoords);
      this.Maps = Maps;
      this.MappedTo = MappedTo;
      this.TexCoords = TexCoords;
      this.TexCoordIndices = TexCoordIndices;
      this.type = 3465909080;
    }
  }
  IFC4X32.IfcIndexedPolygonalTextureMap = IfcIndexedPolygonalTextureMap;
  class IfcLShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(ProfileType, ProfileName, Position, Depth, Width, Thickness, FilletRadius, EdgeRadius, LegSlope) {
      super(ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Depth = Depth;
      this.Width = Width;
      this.Thickness = Thickness;
      this.FilletRadius = FilletRadius;
      this.EdgeRadius = EdgeRadius;
      this.LegSlope = LegSlope;
      this.type = 572779678;
    }
  }
  IFC4X32.IfcLShapeProfileDef = IfcLShapeProfileDef;
  class IfcLaborResourceType extends IfcConstructionResourceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ResourceType = ResourceType;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 428585644;
    }
  }
  IFC4X32.IfcLaborResourceType = IfcLaborResourceType;
  class IfcLine extends IfcCurve {
    constructor(Pnt, Dir) {
      super();
      this.Pnt = Pnt;
      this.Dir = Dir;
      this.type = 1281925730;
    }
  }
  IFC4X32.IfcLine = IfcLine;
  class IfcManifoldSolidBrep extends IfcSolidModel {
    constructor(Outer) {
      super();
      this.Outer = Outer;
      this.type = 1425443689;
    }
  }
  IFC4X32.IfcManifoldSolidBrep = IfcManifoldSolidBrep;
  class IfcObject extends IfcObjectDefinition {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.type = 3888040117;
    }
  }
  IFC4X32.IfcObject = IfcObject;
  class IfcOffsetCurve extends IfcCurve {
    constructor(BasisCurve) {
      super();
      this.BasisCurve = BasisCurve;
      this.type = 590820931;
    }
  }
  IFC4X32.IfcOffsetCurve = IfcOffsetCurve;
  class IfcOffsetCurve2D extends IfcOffsetCurve {
    constructor(BasisCurve, Distance, SelfIntersect) {
      super(BasisCurve);
      this.BasisCurve = BasisCurve;
      this.Distance = Distance;
      this.SelfIntersect = SelfIntersect;
      this.type = 3388369263;
    }
  }
  IFC4X32.IfcOffsetCurve2D = IfcOffsetCurve2D;
  class IfcOffsetCurve3D extends IfcOffsetCurve {
    constructor(BasisCurve, Distance, SelfIntersect, RefDirection) {
      super(BasisCurve);
      this.BasisCurve = BasisCurve;
      this.Distance = Distance;
      this.SelfIntersect = SelfIntersect;
      this.RefDirection = RefDirection;
      this.type = 3505215534;
    }
  }
  IFC4X32.IfcOffsetCurve3D = IfcOffsetCurve3D;
  class IfcOffsetCurveByDistances extends IfcOffsetCurve {
    constructor(BasisCurve, OffsetValues, Tag) {
      super(BasisCurve);
      this.BasisCurve = BasisCurve;
      this.OffsetValues = OffsetValues;
      this.Tag = Tag;
      this.type = 2485787929;
    }
  }
  IFC4X32.IfcOffsetCurveByDistances = IfcOffsetCurveByDistances;
  class IfcPcurve extends IfcCurve {
    constructor(BasisSurface, ReferenceCurve) {
      super();
      this.BasisSurface = BasisSurface;
      this.ReferenceCurve = ReferenceCurve;
      this.type = 1682466193;
    }
  }
  IFC4X32.IfcPcurve = IfcPcurve;
  class IfcPlanarBox extends IfcPlanarExtent {
    constructor(SizeInX, SizeInY, Placement) {
      super(SizeInX, SizeInY);
      this.SizeInX = SizeInX;
      this.SizeInY = SizeInY;
      this.Placement = Placement;
      this.type = 603570806;
    }
  }
  IFC4X32.IfcPlanarBox = IfcPlanarBox;
  class IfcPlane extends IfcElementarySurface {
    constructor(Position) {
      super(Position);
      this.Position = Position;
      this.type = 220341763;
    }
  }
  IFC4X32.IfcPlane = IfcPlane;
  class IfcPolynomialCurve extends IfcCurve {
    constructor(Position, CoefficientsX, CoefficientsY, CoefficientsZ) {
      super();
      this.Position = Position;
      this.CoefficientsX = CoefficientsX;
      this.CoefficientsY = CoefficientsY;
      this.CoefficientsZ = CoefficientsZ;
      this.type = 3381221214;
    }
  }
  IFC4X32.IfcPolynomialCurve = IfcPolynomialCurve;
  class IfcPreDefinedColour extends IfcPreDefinedItem {
    constructor(Name) {
      super(Name);
      this.Name = Name;
      this.type = 759155922;
    }
  }
  IFC4X32.IfcPreDefinedColour = IfcPreDefinedColour;
  class IfcPreDefinedCurveFont extends IfcPreDefinedItem {
    constructor(Name) {
      super(Name);
      this.Name = Name;
      this.type = 2559016684;
    }
  }
  IFC4X32.IfcPreDefinedCurveFont = IfcPreDefinedCurveFont;
  class IfcPreDefinedPropertySet extends IfcPropertySetDefinition {
    constructor(GlobalId, OwnerHistory, Name, Description) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 3967405729;
    }
  }
  IFC4X32.IfcPreDefinedPropertySet = IfcPreDefinedPropertySet;
  class IfcProcedureType extends IfcTypeProcess {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ProcessType = ProcessType;
      this.PredefinedType = PredefinedType;
      this.type = 569719735;
    }
  }
  IFC4X32.IfcProcedureType = IfcProcedureType;
  class IfcProcess extends IfcObject {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.type = 2945172077;
    }
  }
  IFC4X32.IfcProcess = IfcProcess;
  class IfcProduct extends IfcObject {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.type = 4208778838;
    }
  }
  IFC4X32.IfcProduct = IfcProduct;
  class IfcProject extends IfcContext {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.LongName = LongName;
      this.Phase = Phase;
      this.RepresentationContexts = RepresentationContexts;
      this.UnitsInContext = UnitsInContext;
      this.type = 103090709;
    }
  }
  IFC4X32.IfcProject = IfcProject;
  class IfcProjectLibrary extends IfcContext {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.LongName = LongName;
      this.Phase = Phase;
      this.RepresentationContexts = RepresentationContexts;
      this.UnitsInContext = UnitsInContext;
      this.type = 653396225;
    }
  }
  IFC4X32.IfcProjectLibrary = IfcProjectLibrary;
  class IfcPropertyBoundedValue extends IfcSimpleProperty {
    constructor(Name, Specification, UpperBoundValue, LowerBoundValue, Unit, SetPointValue) {
      super(Name, Specification);
      this.Name = Name;
      this.Specification = Specification;
      this.UpperBoundValue = UpperBoundValue;
      this.LowerBoundValue = LowerBoundValue;
      this.Unit = Unit;
      this.SetPointValue = SetPointValue;
      this.type = 871118103;
    }
  }
  IFC4X32.IfcPropertyBoundedValue = IfcPropertyBoundedValue;
  class IfcPropertyEnumeratedValue extends IfcSimpleProperty {
    constructor(Name, Specification, EnumerationValues, EnumerationReference) {
      super(Name, Specification);
      this.Name = Name;
      this.Specification = Specification;
      this.EnumerationValues = EnumerationValues;
      this.EnumerationReference = EnumerationReference;
      this.type = 4166981789;
    }
  }
  IFC4X32.IfcPropertyEnumeratedValue = IfcPropertyEnumeratedValue;
  class IfcPropertyListValue extends IfcSimpleProperty {
    constructor(Name, Specification, ListValues, Unit) {
      super(Name, Specification);
      this.Name = Name;
      this.Specification = Specification;
      this.ListValues = ListValues;
      this.Unit = Unit;
      this.type = 2752243245;
    }
  }
  IFC4X32.IfcPropertyListValue = IfcPropertyListValue;
  class IfcPropertyReferenceValue extends IfcSimpleProperty {
    constructor(Name, Specification, UsageName, PropertyReference) {
      super(Name, Specification);
      this.Name = Name;
      this.Specification = Specification;
      this.UsageName = UsageName;
      this.PropertyReference = PropertyReference;
      this.type = 941946838;
    }
  }
  IFC4X32.IfcPropertyReferenceValue = IfcPropertyReferenceValue;
  class IfcPropertySet extends IfcPropertySetDefinition {
    constructor(GlobalId, OwnerHistory, Name, Description, HasProperties) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.HasProperties = HasProperties;
      this.type = 1451395588;
    }
  }
  IFC4X32.IfcPropertySet = IfcPropertySet;
  class IfcPropertySetTemplate extends IfcPropertyTemplateDefinition {
    constructor(GlobalId, OwnerHistory, Name, Description, TemplateType, ApplicableEntity, HasPropertyTemplates) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.TemplateType = TemplateType;
      this.ApplicableEntity = ApplicableEntity;
      this.HasPropertyTemplates = HasPropertyTemplates;
      this.type = 492091185;
    }
  }
  IFC4X32.IfcPropertySetTemplate = IfcPropertySetTemplate;
  class IfcPropertySingleValue extends IfcSimpleProperty {
    constructor(Name, Specification, NominalValue, Unit) {
      super(Name, Specification);
      this.Name = Name;
      this.Specification = Specification;
      this.NominalValue = NominalValue;
      this.Unit = Unit;
      this.type = 3650150729;
    }
  }
  IFC4X32.IfcPropertySingleValue = IfcPropertySingleValue;
  class IfcPropertyTableValue extends IfcSimpleProperty {
    constructor(Name, Specification, DefiningValues, DefinedValues, Expression, DefiningUnit, DefinedUnit, CurveInterpolation) {
      super(Name, Specification);
      this.Name = Name;
      this.Specification = Specification;
      this.DefiningValues = DefiningValues;
      this.DefinedValues = DefinedValues;
      this.Expression = Expression;
      this.DefiningUnit = DefiningUnit;
      this.DefinedUnit = DefinedUnit;
      this.CurveInterpolation = CurveInterpolation;
      this.type = 110355661;
    }
  }
  IFC4X32.IfcPropertyTableValue = IfcPropertyTableValue;
  class IfcPropertyTemplate extends IfcPropertyTemplateDefinition {
    constructor(GlobalId, OwnerHistory, Name, Description) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 3521284610;
    }
  }
  IFC4X32.IfcPropertyTemplate = IfcPropertyTemplate;
  class IfcRectangleHollowProfileDef extends IfcRectangleProfileDef {
    constructor(ProfileType, ProfileName, Position, XDim, YDim, WallThickness, InnerFilletRadius, OuterFilletRadius) {
      super(ProfileType, ProfileName, Position, XDim, YDim);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.XDim = XDim;
      this.YDim = YDim;
      this.WallThickness = WallThickness;
      this.InnerFilletRadius = InnerFilletRadius;
      this.OuterFilletRadius = OuterFilletRadius;
      this.type = 2770003689;
    }
  }
  IFC4X32.IfcRectangleHollowProfileDef = IfcRectangleHollowProfileDef;
  class IfcRectangularPyramid extends IfcCsgPrimitive3D {
    constructor(Position, XLength, YLength, Height) {
      super(Position);
      this.Position = Position;
      this.XLength = XLength;
      this.YLength = YLength;
      this.Height = Height;
      this.type = 2798486643;
    }
  }
  IFC4X32.IfcRectangularPyramid = IfcRectangularPyramid;
  class IfcRectangularTrimmedSurface extends IfcBoundedSurface {
    constructor(BasisSurface, U1, V1, U2, V2, Usense, Vsense) {
      super();
      this.BasisSurface = BasisSurface;
      this.U1 = U1;
      this.V1 = V1;
      this.U2 = U2;
      this.V2 = V2;
      this.Usense = Usense;
      this.Vsense = Vsense;
      this.type = 3454111270;
    }
  }
  IFC4X32.IfcRectangularTrimmedSurface = IfcRectangularTrimmedSurface;
  class IfcReinforcementDefinitionProperties extends IfcPreDefinedPropertySet {
    constructor(GlobalId, OwnerHistory, Name, Description, DefinitionType, ReinforcementSectionDefinitions) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.DefinitionType = DefinitionType;
      this.ReinforcementSectionDefinitions = ReinforcementSectionDefinitions;
      this.type = 3765753017;
    }
  }
  IFC4X32.IfcReinforcementDefinitionProperties = IfcReinforcementDefinitionProperties;
  class IfcRelAssigns extends IfcRelationship {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.type = 3939117080;
    }
  }
  IFC4X32.IfcRelAssigns = IfcRelAssigns;
  class IfcRelAssignsToActor extends IfcRelAssigns {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingActor, ActingRole) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingActor = RelatingActor;
      this.ActingRole = ActingRole;
      this.type = 1683148259;
    }
  }
  IFC4X32.IfcRelAssignsToActor = IfcRelAssignsToActor;
  class IfcRelAssignsToControl extends IfcRelAssigns {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingControl) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingControl = RelatingControl;
      this.type = 2495723537;
    }
  }
  IFC4X32.IfcRelAssignsToControl = IfcRelAssignsToControl;
  class IfcRelAssignsToGroup extends IfcRelAssigns {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingGroup) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingGroup = RelatingGroup;
      this.type = 1307041759;
    }
  }
  IFC4X32.IfcRelAssignsToGroup = IfcRelAssignsToGroup;
  class IfcRelAssignsToGroupByFactor extends IfcRelAssignsToGroup {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingGroup, Factor) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingGroup);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingGroup = RelatingGroup;
      this.Factor = Factor;
      this.type = 1027710054;
    }
  }
  IFC4X32.IfcRelAssignsToGroupByFactor = IfcRelAssignsToGroupByFactor;
  class IfcRelAssignsToProcess extends IfcRelAssigns {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingProcess, QuantityInProcess) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingProcess = RelatingProcess;
      this.QuantityInProcess = QuantityInProcess;
      this.type = 4278684876;
    }
  }
  IFC4X32.IfcRelAssignsToProcess = IfcRelAssignsToProcess;
  class IfcRelAssignsToProduct extends IfcRelAssigns {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingProduct) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingProduct = RelatingProduct;
      this.type = 2857406711;
    }
  }
  IFC4X32.IfcRelAssignsToProduct = IfcRelAssignsToProduct;
  class IfcRelAssignsToResource extends IfcRelAssigns {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingResource) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingResource = RelatingResource;
      this.type = 205026976;
    }
  }
  IFC4X32.IfcRelAssignsToResource = IfcRelAssignsToResource;
  class IfcRelAssociates extends IfcRelationship {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.type = 1865459582;
    }
  }
  IFC4X32.IfcRelAssociates = IfcRelAssociates;
  class IfcRelAssociatesApproval extends IfcRelAssociates {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingApproval) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingApproval = RelatingApproval;
      this.type = 4095574036;
    }
  }
  IFC4X32.IfcRelAssociatesApproval = IfcRelAssociatesApproval;
  class IfcRelAssociatesClassification extends IfcRelAssociates {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingClassification) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingClassification = RelatingClassification;
      this.type = 919958153;
    }
  }
  IFC4X32.IfcRelAssociatesClassification = IfcRelAssociatesClassification;
  class IfcRelAssociatesConstraint extends IfcRelAssociates {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, Intent, RelatingConstraint) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.Intent = Intent;
      this.RelatingConstraint = RelatingConstraint;
      this.type = 2728634034;
    }
  }
  IFC4X32.IfcRelAssociatesConstraint = IfcRelAssociatesConstraint;
  class IfcRelAssociatesDocument extends IfcRelAssociates {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingDocument) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingDocument = RelatingDocument;
      this.type = 982818633;
    }
  }
  IFC4X32.IfcRelAssociatesDocument = IfcRelAssociatesDocument;
  class IfcRelAssociatesLibrary extends IfcRelAssociates {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingLibrary) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingLibrary = RelatingLibrary;
      this.type = 3840914261;
    }
  }
  IFC4X32.IfcRelAssociatesLibrary = IfcRelAssociatesLibrary;
  class IfcRelAssociatesMaterial extends IfcRelAssociates {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingMaterial) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingMaterial = RelatingMaterial;
      this.type = 2655215786;
    }
  }
  IFC4X32.IfcRelAssociatesMaterial = IfcRelAssociatesMaterial;
  class IfcRelAssociatesProfileDef extends IfcRelAssociates {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingProfileDef) {
      super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingProfileDef = RelatingProfileDef;
      this.type = 1033248425;
    }
  }
  IFC4X32.IfcRelAssociatesProfileDef = IfcRelAssociatesProfileDef;
  class IfcRelConnects extends IfcRelationship {
    constructor(GlobalId, OwnerHistory, Name, Description) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 826625072;
    }
  }
  IFC4X32.IfcRelConnects = IfcRelConnects;
  class IfcRelConnectsElements extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ConnectionGeometry = ConnectionGeometry;
      this.RelatingElement = RelatingElement;
      this.RelatedElement = RelatedElement;
      this.type = 1204542856;
    }
  }
  IFC4X32.IfcRelConnectsElements = IfcRelConnectsElements;
  class IfcRelConnectsPathElements extends IfcRelConnectsElements {
    constructor(GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement, RelatingPriorities, RelatedPriorities, RelatedConnectionType, RelatingConnectionType) {
      super(GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ConnectionGeometry = ConnectionGeometry;
      this.RelatingElement = RelatingElement;
      this.RelatedElement = RelatedElement;
      this.RelatingPriorities = RelatingPriorities;
      this.RelatedPriorities = RelatedPriorities;
      this.RelatedConnectionType = RelatedConnectionType;
      this.RelatingConnectionType = RelatingConnectionType;
      this.type = 3945020480;
    }
  }
  IFC4X32.IfcRelConnectsPathElements = IfcRelConnectsPathElements;
  class IfcRelConnectsPortToElement extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingPort, RelatedElement) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingPort = RelatingPort;
      this.RelatedElement = RelatedElement;
      this.type = 4201705270;
    }
  }
  IFC4X32.IfcRelConnectsPortToElement = IfcRelConnectsPortToElement;
  class IfcRelConnectsPorts extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingPort, RelatedPort, RealizingElement) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingPort = RelatingPort;
      this.RelatedPort = RelatedPort;
      this.RealizingElement = RealizingElement;
      this.type = 3190031847;
    }
  }
  IFC4X32.IfcRelConnectsPorts = IfcRelConnectsPorts;
  class IfcRelConnectsStructuralActivity extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedStructuralActivity) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingElement = RelatingElement;
      this.RelatedStructuralActivity = RelatedStructuralActivity;
      this.type = 2127690289;
    }
  }
  IFC4X32.IfcRelConnectsStructuralActivity = IfcRelConnectsStructuralActivity;
  class IfcRelConnectsStructuralMember extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingStructuralMember, RelatedStructuralConnection, AppliedCondition, AdditionalConditions, SupportedLength, ConditionCoordinateSystem) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingStructuralMember = RelatingStructuralMember;
      this.RelatedStructuralConnection = RelatedStructuralConnection;
      this.AppliedCondition = AppliedCondition;
      this.AdditionalConditions = AdditionalConditions;
      this.SupportedLength = SupportedLength;
      this.ConditionCoordinateSystem = ConditionCoordinateSystem;
      this.type = 1638771189;
    }
  }
  IFC4X32.IfcRelConnectsStructuralMember = IfcRelConnectsStructuralMember;
  class IfcRelConnectsWithEccentricity extends IfcRelConnectsStructuralMember {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingStructuralMember, RelatedStructuralConnection, AppliedCondition, AdditionalConditions, SupportedLength, ConditionCoordinateSystem, ConnectionConstraint) {
      super(GlobalId, OwnerHistory, Name, Description, RelatingStructuralMember, RelatedStructuralConnection, AppliedCondition, AdditionalConditions, SupportedLength, ConditionCoordinateSystem);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingStructuralMember = RelatingStructuralMember;
      this.RelatedStructuralConnection = RelatedStructuralConnection;
      this.AppliedCondition = AppliedCondition;
      this.AdditionalConditions = AdditionalConditions;
      this.SupportedLength = SupportedLength;
      this.ConditionCoordinateSystem = ConditionCoordinateSystem;
      this.ConnectionConstraint = ConnectionConstraint;
      this.type = 504942748;
    }
  }
  IFC4X32.IfcRelConnectsWithEccentricity = IfcRelConnectsWithEccentricity;
  class IfcRelConnectsWithRealizingElements extends IfcRelConnectsElements {
    constructor(GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement, RealizingElements, ConnectionType) {
      super(GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ConnectionGeometry = ConnectionGeometry;
      this.RelatingElement = RelatingElement;
      this.RelatedElement = RelatedElement;
      this.RealizingElements = RealizingElements;
      this.ConnectionType = ConnectionType;
      this.type = 3678494232;
    }
  }
  IFC4X32.IfcRelConnectsWithRealizingElements = IfcRelConnectsWithRealizingElements;
  class IfcRelContainedInSpatialStructure extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedElements, RelatingStructure) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedElements = RelatedElements;
      this.RelatingStructure = RelatingStructure;
      this.type = 3242617779;
    }
  }
  IFC4X32.IfcRelContainedInSpatialStructure = IfcRelContainedInSpatialStructure;
  class IfcRelCoversBldgElements extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingBuildingElement, RelatedCoverings) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingBuildingElement = RelatingBuildingElement;
      this.RelatedCoverings = RelatedCoverings;
      this.type = 886880790;
    }
  }
  IFC4X32.IfcRelCoversBldgElements = IfcRelCoversBldgElements;
  class IfcRelCoversSpaces extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedCoverings) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingSpace = RelatingSpace;
      this.RelatedCoverings = RelatedCoverings;
      this.type = 2802773753;
    }
  }
  IFC4X32.IfcRelCoversSpaces = IfcRelCoversSpaces;
  class IfcRelDeclares extends IfcRelationship {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingContext, RelatedDefinitions) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingContext = RelatingContext;
      this.RelatedDefinitions = RelatedDefinitions;
      this.type = 2565941209;
    }
  }
  IFC4X32.IfcRelDeclares = IfcRelDeclares;
  class IfcRelDecomposes extends IfcRelationship {
    constructor(GlobalId, OwnerHistory, Name, Description) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 2551354335;
    }
  }
  IFC4X32.IfcRelDecomposes = IfcRelDecomposes;
  class IfcRelDefines extends IfcRelationship {
    constructor(GlobalId, OwnerHistory, Name, Description) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 693640335;
    }
  }
  IFC4X32.IfcRelDefines = IfcRelDefines;
  class IfcRelDefinesByObject extends IfcRelDefines {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingObject) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingObject = RelatingObject;
      this.type = 1462361463;
    }
  }
  IFC4X32.IfcRelDefinesByObject = IfcRelDefinesByObject;
  class IfcRelDefinesByProperties extends IfcRelDefines {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingPropertyDefinition) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingPropertyDefinition = RelatingPropertyDefinition;
      this.type = 4186316022;
    }
  }
  IFC4X32.IfcRelDefinesByProperties = IfcRelDefinesByProperties;
  class IfcRelDefinesByTemplate extends IfcRelDefines {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedPropertySets, RelatingTemplate) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedPropertySets = RelatedPropertySets;
      this.RelatingTemplate = RelatingTemplate;
      this.type = 307848117;
    }
  }
  IFC4X32.IfcRelDefinesByTemplate = IfcRelDefinesByTemplate;
  class IfcRelDefinesByType extends IfcRelDefines {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingType) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingType = RelatingType;
      this.type = 781010003;
    }
  }
  IFC4X32.IfcRelDefinesByType = IfcRelDefinesByType;
  class IfcRelFillsElement extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingOpeningElement, RelatedBuildingElement) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingOpeningElement = RelatingOpeningElement;
      this.RelatedBuildingElement = RelatedBuildingElement;
      this.type = 3940055652;
    }
  }
  IFC4X32.IfcRelFillsElement = IfcRelFillsElement;
  class IfcRelFlowControlElements extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedControlElements, RelatingFlowElement) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedControlElements = RelatedControlElements;
      this.RelatingFlowElement = RelatingFlowElement;
      this.type = 279856033;
    }
  }
  IFC4X32.IfcRelFlowControlElements = IfcRelFlowControlElements;
  class IfcRelInterferesElements extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedElement, InterferenceGeometry, InterferenceSpace, InterferenceType, ImpliedOrder) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingElement = RelatingElement;
      this.RelatedElement = RelatedElement;
      this.InterferenceGeometry = InterferenceGeometry;
      this.InterferenceSpace = InterferenceSpace;
      this.InterferenceType = InterferenceType;
      this.ImpliedOrder = ImpliedOrder;
      this.type = 427948657;
    }
  }
  IFC4X32.IfcRelInterferesElements = IfcRelInterferesElements;
  class IfcRelNests extends IfcRelDecomposes {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingObject, RelatedObjects) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingObject = RelatingObject;
      this.RelatedObjects = RelatedObjects;
      this.type = 3268803585;
    }
  }
  IFC4X32.IfcRelNests = IfcRelNests;
  class IfcRelPositions extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingPositioningElement, RelatedProducts) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingPositioningElement = RelatingPositioningElement;
      this.RelatedProducts = RelatedProducts;
      this.type = 1441486842;
    }
  }
  IFC4X32.IfcRelPositions = IfcRelPositions;
  class IfcRelProjectsElement extends IfcRelDecomposes {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedFeatureElement) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingElement = RelatingElement;
      this.RelatedFeatureElement = RelatedFeatureElement;
      this.type = 750771296;
    }
  }
  IFC4X32.IfcRelProjectsElement = IfcRelProjectsElement;
  class IfcRelReferencedInSpatialStructure extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatedElements, RelatingStructure) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedElements = RelatedElements;
      this.RelatingStructure = RelatingStructure;
      this.type = 1245217292;
    }
  }
  IFC4X32.IfcRelReferencedInSpatialStructure = IfcRelReferencedInSpatialStructure;
  class IfcRelSequence extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingProcess, RelatedProcess, TimeLag, SequenceType, UserDefinedSequenceType) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingProcess = RelatingProcess;
      this.RelatedProcess = RelatedProcess;
      this.TimeLag = TimeLag;
      this.SequenceType = SequenceType;
      this.UserDefinedSequenceType = UserDefinedSequenceType;
      this.type = 4122056220;
    }
  }
  IFC4X32.IfcRelSequence = IfcRelSequence;
  class IfcRelServicesBuildings extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingSystem, RelatedBuildings) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingSystem = RelatingSystem;
      this.RelatedBuildings = RelatedBuildings;
      this.type = 366585022;
    }
  }
  IFC4X32.IfcRelServicesBuildings = IfcRelServicesBuildings;
  class IfcRelSpaceBoundary extends IfcRelConnects {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingSpace = RelatingSpace;
      this.RelatedBuildingElement = RelatedBuildingElement;
      this.ConnectionGeometry = ConnectionGeometry;
      this.PhysicalOrVirtualBoundary = PhysicalOrVirtualBoundary;
      this.InternalOrExternalBoundary = InternalOrExternalBoundary;
      this.type = 3451746338;
    }
  }
  IFC4X32.IfcRelSpaceBoundary = IfcRelSpaceBoundary;
  class IfcRelSpaceBoundary1stLevel extends IfcRelSpaceBoundary {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary, ParentBoundary) {
      super(GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingSpace = RelatingSpace;
      this.RelatedBuildingElement = RelatedBuildingElement;
      this.ConnectionGeometry = ConnectionGeometry;
      this.PhysicalOrVirtualBoundary = PhysicalOrVirtualBoundary;
      this.InternalOrExternalBoundary = InternalOrExternalBoundary;
      this.ParentBoundary = ParentBoundary;
      this.type = 3523091289;
    }
  }
  IFC4X32.IfcRelSpaceBoundary1stLevel = IfcRelSpaceBoundary1stLevel;
  class IfcRelSpaceBoundary2ndLevel extends IfcRelSpaceBoundary1stLevel {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary, ParentBoundary, CorrespondingBoundary) {
      super(GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary, ParentBoundary);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingSpace = RelatingSpace;
      this.RelatedBuildingElement = RelatedBuildingElement;
      this.ConnectionGeometry = ConnectionGeometry;
      this.PhysicalOrVirtualBoundary = PhysicalOrVirtualBoundary;
      this.InternalOrExternalBoundary = InternalOrExternalBoundary;
      this.ParentBoundary = ParentBoundary;
      this.CorrespondingBoundary = CorrespondingBoundary;
      this.type = 1521410863;
    }
  }
  IFC4X32.IfcRelSpaceBoundary2ndLevel = IfcRelSpaceBoundary2ndLevel;
  class IfcRelVoidsElement extends IfcRelDecomposes {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingBuildingElement, RelatedOpeningElement) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingBuildingElement = RelatingBuildingElement;
      this.RelatedOpeningElement = RelatedOpeningElement;
      this.type = 1401173127;
    }
  }
  IFC4X32.IfcRelVoidsElement = IfcRelVoidsElement;
  class IfcReparametrisedCompositeCurveSegment extends IfcCompositeCurveSegment {
    constructor(Transition, SameSense, ParentCurve, ParamLength) {
      super(Transition, SameSense, ParentCurve);
      this.Transition = Transition;
      this.SameSense = SameSense;
      this.ParentCurve = ParentCurve;
      this.ParamLength = ParamLength;
      this.type = 816062949;
    }
  }
  IFC4X32.IfcReparametrisedCompositeCurveSegment = IfcReparametrisedCompositeCurveSegment;
  class IfcResource extends IfcObject {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.type = 2914609552;
    }
  }
  IFC4X32.IfcResource = IfcResource;
  class IfcRevolvedAreaSolid extends IfcSweptAreaSolid {
    constructor(SweptArea, Position, Axis, Angle) {
      super(SweptArea, Position);
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.Axis = Axis;
      this.Angle = Angle;
      this.type = 1856042241;
    }
  }
  IFC4X32.IfcRevolvedAreaSolid = IfcRevolvedAreaSolid;
  class IfcRevolvedAreaSolidTapered extends IfcRevolvedAreaSolid {
    constructor(SweptArea, Position, Axis, Angle, EndSweptArea) {
      super(SweptArea, Position, Axis, Angle);
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.Axis = Axis;
      this.Angle = Angle;
      this.EndSweptArea = EndSweptArea;
      this.type = 3243963512;
    }
  }
  IFC4X32.IfcRevolvedAreaSolidTapered = IfcRevolvedAreaSolidTapered;
  class IfcRightCircularCone extends IfcCsgPrimitive3D {
    constructor(Position, Height, BottomRadius) {
      super(Position);
      this.Position = Position;
      this.Height = Height;
      this.BottomRadius = BottomRadius;
      this.type = 4158566097;
    }
  }
  IFC4X32.IfcRightCircularCone = IfcRightCircularCone;
  class IfcRightCircularCylinder extends IfcCsgPrimitive3D {
    constructor(Position, Height, Radius) {
      super(Position);
      this.Position = Position;
      this.Height = Height;
      this.Radius = Radius;
      this.type = 3626867408;
    }
  }
  IFC4X32.IfcRightCircularCylinder = IfcRightCircularCylinder;
  class IfcSectionedSolid extends IfcSolidModel {
    constructor(Directrix, CrossSections) {
      super();
      this.Directrix = Directrix;
      this.CrossSections = CrossSections;
      this.type = 1862484736;
    }
  }
  IFC4X32.IfcSectionedSolid = IfcSectionedSolid;
  class IfcSectionedSolidHorizontal extends IfcSectionedSolid {
    constructor(Directrix, CrossSections, CrossSectionPositions) {
      super(Directrix, CrossSections);
      this.Directrix = Directrix;
      this.CrossSections = CrossSections;
      this.CrossSectionPositions = CrossSectionPositions;
      this.type = 1290935644;
    }
  }
  IFC4X32.IfcSectionedSolidHorizontal = IfcSectionedSolidHorizontal;
  class IfcSectionedSurface extends IfcSurface {
    constructor(Directrix, CrossSectionPositions, CrossSections) {
      super();
      this.Directrix = Directrix;
      this.CrossSectionPositions = CrossSectionPositions;
      this.CrossSections = CrossSections;
      this.type = 1356537516;
    }
  }
  IFC4X32.IfcSectionedSurface = IfcSectionedSurface;
  class IfcSimplePropertyTemplate extends IfcPropertyTemplate {
    constructor(GlobalId, OwnerHistory, Name, Description, TemplateType, PrimaryMeasureType, SecondaryMeasureType, Enumerators, PrimaryUnit, SecondaryUnit, Expression, AccessState) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.TemplateType = TemplateType;
      this.PrimaryMeasureType = PrimaryMeasureType;
      this.SecondaryMeasureType = SecondaryMeasureType;
      this.Enumerators = Enumerators;
      this.PrimaryUnit = PrimaryUnit;
      this.SecondaryUnit = SecondaryUnit;
      this.Expression = Expression;
      this.AccessState = AccessState;
      this.type = 3663146110;
    }
  }
  IFC4X32.IfcSimplePropertyTemplate = IfcSimplePropertyTemplate;
  class IfcSpatialElement extends IfcProduct {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.type = 1412071761;
    }
  }
  IFC4X32.IfcSpatialElement = IfcSpatialElement;
  class IfcSpatialElementType extends IfcTypeProduct {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 710998568;
    }
  }
  IFC4X32.IfcSpatialElementType = IfcSpatialElementType;
  class IfcSpatialStructureElement extends IfcSpatialElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.type = 2706606064;
    }
  }
  IFC4X32.IfcSpatialStructureElement = IfcSpatialStructureElement;
  class IfcSpatialStructureElementType extends IfcSpatialElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3893378262;
    }
  }
  IFC4X32.IfcSpatialStructureElementType = IfcSpatialStructureElementType;
  class IfcSpatialZone extends IfcSpatialElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.PredefinedType = PredefinedType;
      this.type = 463610769;
    }
  }
  IFC4X32.IfcSpatialZone = IfcSpatialZone;
  class IfcSpatialZoneType extends IfcSpatialElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, LongName) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.LongName = LongName;
      this.type = 2481509218;
    }
  }
  IFC4X32.IfcSpatialZoneType = IfcSpatialZoneType;
  class IfcSphere extends IfcCsgPrimitive3D {
    constructor(Position, Radius) {
      super(Position);
      this.Position = Position;
      this.Radius = Radius;
      this.type = 451544542;
    }
  }
  IFC4X32.IfcSphere = IfcSphere;
  class IfcSphericalSurface extends IfcElementarySurface {
    constructor(Position, Radius) {
      super(Position);
      this.Position = Position;
      this.Radius = Radius;
      this.type = 4015995234;
    }
  }
  IFC4X32.IfcSphericalSurface = IfcSphericalSurface;
  class IfcSpiral extends IfcCurve {
    constructor(Position) {
      super();
      this.Position = Position;
      this.type = 2735484536;
    }
  }
  IFC4X32.IfcSpiral = IfcSpiral;
  class IfcStructuralActivity extends IfcProduct {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.type = 3544373492;
    }
  }
  IFC4X32.IfcStructuralActivity = IfcStructuralActivity;
  class IfcStructuralItem extends IfcProduct {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.type = 3136571912;
    }
  }
  IFC4X32.IfcStructuralItem = IfcStructuralItem;
  class IfcStructuralMember extends IfcStructuralItem {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.type = 530289379;
    }
  }
  IFC4X32.IfcStructuralMember = IfcStructuralMember;
  class IfcStructuralReaction extends IfcStructuralActivity {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.type = 3689010777;
    }
  }
  IFC4X32.IfcStructuralReaction = IfcStructuralReaction;
  class IfcStructuralSurfaceMember extends IfcStructuralMember {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Thickness) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.PredefinedType = PredefinedType;
      this.Thickness = Thickness;
      this.type = 3979015343;
    }
  }
  IFC4X32.IfcStructuralSurfaceMember = IfcStructuralSurfaceMember;
  class IfcStructuralSurfaceMemberVarying extends IfcStructuralSurfaceMember {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Thickness) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Thickness);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.PredefinedType = PredefinedType;
      this.Thickness = Thickness;
      this.type = 2218152070;
    }
  }
  IFC4X32.IfcStructuralSurfaceMemberVarying = IfcStructuralSurfaceMemberVarying;
  class IfcStructuralSurfaceReaction extends IfcStructuralReaction {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.PredefinedType = PredefinedType;
      this.type = 603775116;
    }
  }
  IFC4X32.IfcStructuralSurfaceReaction = IfcStructuralSurfaceReaction;
  class IfcSubContractResourceType extends IfcConstructionResourceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ResourceType = ResourceType;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 4095615324;
    }
  }
  IFC4X32.IfcSubContractResourceType = IfcSubContractResourceType;
  class IfcSurfaceCurve extends IfcCurve {
    constructor(Curve3D, AssociatedGeometry, MasterRepresentation) {
      super();
      this.Curve3D = Curve3D;
      this.AssociatedGeometry = AssociatedGeometry;
      this.MasterRepresentation = MasterRepresentation;
      this.type = 699246055;
    }
  }
  IFC4X32.IfcSurfaceCurve = IfcSurfaceCurve;
  class IfcSurfaceCurveSweptAreaSolid extends IfcDirectrixCurveSweptAreaSolid {
    constructor(SweptArea, Position, Directrix, StartParam, EndParam, ReferenceSurface) {
      super(SweptArea, Position, Directrix, StartParam, EndParam);
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.Directrix = Directrix;
      this.StartParam = StartParam;
      this.EndParam = EndParam;
      this.ReferenceSurface = ReferenceSurface;
      this.type = 2028607225;
    }
  }
  IFC4X32.IfcSurfaceCurveSweptAreaSolid = IfcSurfaceCurveSweptAreaSolid;
  class IfcSurfaceOfLinearExtrusion extends IfcSweptSurface {
    constructor(SweptCurve, Position, ExtrudedDirection, Depth) {
      super(SweptCurve, Position);
      this.SweptCurve = SweptCurve;
      this.Position = Position;
      this.ExtrudedDirection = ExtrudedDirection;
      this.Depth = Depth;
      this.type = 2809605785;
    }
  }
  IFC4X32.IfcSurfaceOfLinearExtrusion = IfcSurfaceOfLinearExtrusion;
  class IfcSurfaceOfRevolution extends IfcSweptSurface {
    constructor(SweptCurve, Position, AxisPosition) {
      super(SweptCurve, Position);
      this.SweptCurve = SweptCurve;
      this.Position = Position;
      this.AxisPosition = AxisPosition;
      this.type = 4124788165;
    }
  }
  IFC4X32.IfcSurfaceOfRevolution = IfcSurfaceOfRevolution;
  class IfcSystemFurnitureElementType extends IfcFurnishingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1580310250;
    }
  }
  IFC4X32.IfcSystemFurnitureElementType = IfcSystemFurnitureElementType;
  class IfcTask extends IfcProcess {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Status, WorkMethod, IsMilestone, Priority, TaskTime, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.Status = Status;
      this.WorkMethod = WorkMethod;
      this.IsMilestone = IsMilestone;
      this.Priority = Priority;
      this.TaskTime = TaskTime;
      this.PredefinedType = PredefinedType;
      this.type = 3473067441;
    }
  }
  IFC4X32.IfcTask = IfcTask;
  class IfcTaskType extends IfcTypeProcess {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType, PredefinedType, WorkMethod) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ProcessType = ProcessType;
      this.PredefinedType = PredefinedType;
      this.WorkMethod = WorkMethod;
      this.type = 3206491090;
    }
  }
  IFC4X32.IfcTaskType = IfcTaskType;
  class IfcTessellatedFaceSet extends IfcTessellatedItem {
    constructor(Coordinates, Closed) {
      super();
      this.Coordinates = Coordinates;
      this.Closed = Closed;
      this.type = 2387106220;
    }
  }
  IFC4X32.IfcTessellatedFaceSet = IfcTessellatedFaceSet;
  class IfcThirdOrderPolynomialSpiral extends IfcSpiral {
    constructor(Position, CubicTerm, QuadraticTerm, LinearTerm, ConstantTerm) {
      super(Position);
      this.Position = Position;
      this.CubicTerm = CubicTerm;
      this.QuadraticTerm = QuadraticTerm;
      this.LinearTerm = LinearTerm;
      this.ConstantTerm = ConstantTerm;
      this.type = 782932809;
    }
  }
  IFC4X32.IfcThirdOrderPolynomialSpiral = IfcThirdOrderPolynomialSpiral;
  class IfcToroidalSurface extends IfcElementarySurface {
    constructor(Position, MajorRadius, MinorRadius) {
      super(Position);
      this.Position = Position;
      this.MajorRadius = MajorRadius;
      this.MinorRadius = MinorRadius;
      this.type = 1935646853;
    }
  }
  IFC4X32.IfcToroidalSurface = IfcToroidalSurface;
  class IfcTransportationDeviceType extends IfcElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3665877780;
    }
  }
  IFC4X32.IfcTransportationDeviceType = IfcTransportationDeviceType;
  class IfcTriangulatedFaceSet extends IfcTessellatedFaceSet {
    constructor(Coordinates, Closed, Normals, CoordIndex, PnIndex) {
      super(Coordinates, Closed);
      this.Coordinates = Coordinates;
      this.Closed = Closed;
      this.Normals = Normals;
      this.CoordIndex = CoordIndex;
      this.PnIndex = PnIndex;
      this.type = 2916149573;
    }
  }
  IFC4X32.IfcTriangulatedFaceSet = IfcTriangulatedFaceSet;
  class IfcTriangulatedIrregularNetwork extends IfcTriangulatedFaceSet {
    constructor(Coordinates, Closed, Normals, CoordIndex, PnIndex, Flags) {
      super(Coordinates, Closed, Normals, CoordIndex, PnIndex);
      this.Coordinates = Coordinates;
      this.Closed = Closed;
      this.Normals = Normals;
      this.CoordIndex = CoordIndex;
      this.PnIndex = PnIndex;
      this.Flags = Flags;
      this.type = 1229763772;
    }
  }
  IFC4X32.IfcTriangulatedIrregularNetwork = IfcTriangulatedIrregularNetwork;
  class IfcVehicleType extends IfcTransportationDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3651464721;
    }
  }
  IFC4X32.IfcVehicleType = IfcVehicleType;
  class IfcWindowLiningProperties extends IfcPreDefinedPropertySet {
    constructor(GlobalId, OwnerHistory, Name, Description, LiningDepth, LiningThickness, TransomThickness, MullionThickness, FirstTransomOffset, SecondTransomOffset, FirstMullionOffset, SecondMullionOffset, ShapeAspectStyle, LiningOffset, LiningToPanelOffsetX, LiningToPanelOffsetY) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.LiningDepth = LiningDepth;
      this.LiningThickness = LiningThickness;
      this.TransomThickness = TransomThickness;
      this.MullionThickness = MullionThickness;
      this.FirstTransomOffset = FirstTransomOffset;
      this.SecondTransomOffset = SecondTransomOffset;
      this.FirstMullionOffset = FirstMullionOffset;
      this.SecondMullionOffset = SecondMullionOffset;
      this.ShapeAspectStyle = ShapeAspectStyle;
      this.LiningOffset = LiningOffset;
      this.LiningToPanelOffsetX = LiningToPanelOffsetX;
      this.LiningToPanelOffsetY = LiningToPanelOffsetY;
      this.type = 336235671;
    }
  }
  IFC4X32.IfcWindowLiningProperties = IfcWindowLiningProperties;
  class IfcWindowPanelProperties extends IfcPreDefinedPropertySet {
    constructor(GlobalId, OwnerHistory, Name, Description, OperationType, PanelPosition, FrameDepth, FrameThickness, ShapeAspectStyle) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.OperationType = OperationType;
      this.PanelPosition = PanelPosition;
      this.FrameDepth = FrameDepth;
      this.FrameThickness = FrameThickness;
      this.ShapeAspectStyle = ShapeAspectStyle;
      this.type = 512836454;
    }
  }
  IFC4X32.IfcWindowPanelProperties = IfcWindowPanelProperties;
  class IfcActor extends IfcObject {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, TheActor) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.TheActor = TheActor;
      this.type = 2296667514;
    }
  }
  IFC4X32.IfcActor = IfcActor;
  class IfcAdvancedBrep extends IfcManifoldSolidBrep {
    constructor(Outer) {
      super(Outer);
      this.Outer = Outer;
      this.type = 1635779807;
    }
  }
  IFC4X32.IfcAdvancedBrep = IfcAdvancedBrep;
  class IfcAdvancedBrepWithVoids extends IfcAdvancedBrep {
    constructor(Outer, Voids) {
      super(Outer);
      this.Outer = Outer;
      this.Voids = Voids;
      this.type = 2603310189;
    }
  }
  IFC4X32.IfcAdvancedBrepWithVoids = IfcAdvancedBrepWithVoids;
  class IfcAnnotation extends IfcProduct {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.PredefinedType = PredefinedType;
      this.type = 1674181508;
    }
  }
  IFC4X32.IfcAnnotation = IfcAnnotation;
  class IfcBSplineSurface extends IfcBoundedSurface {
    constructor(UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect) {
      super();
      this.UDegree = UDegree;
      this.VDegree = VDegree;
      this.ControlPointsList = ControlPointsList;
      this.SurfaceForm = SurfaceForm;
      this.UClosed = UClosed;
      this.VClosed = VClosed;
      this.SelfIntersect = SelfIntersect;
      this.type = 2887950389;
    }
  }
  IFC4X32.IfcBSplineSurface = IfcBSplineSurface;
  class IfcBSplineSurfaceWithKnots extends IfcBSplineSurface {
    constructor(UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect, UMultiplicities, VMultiplicities, UKnots, VKnots, KnotSpec) {
      super(UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect);
      this.UDegree = UDegree;
      this.VDegree = VDegree;
      this.ControlPointsList = ControlPointsList;
      this.SurfaceForm = SurfaceForm;
      this.UClosed = UClosed;
      this.VClosed = VClosed;
      this.SelfIntersect = SelfIntersect;
      this.UMultiplicities = UMultiplicities;
      this.VMultiplicities = VMultiplicities;
      this.UKnots = UKnots;
      this.VKnots = VKnots;
      this.KnotSpec = KnotSpec;
      this.type = 167062518;
    }
  }
  IFC4X32.IfcBSplineSurfaceWithKnots = IfcBSplineSurfaceWithKnots;
  class IfcBlock extends IfcCsgPrimitive3D {
    constructor(Position, XLength, YLength, ZLength) {
      super(Position);
      this.Position = Position;
      this.XLength = XLength;
      this.YLength = YLength;
      this.ZLength = ZLength;
      this.type = 1334484129;
    }
  }
  IFC4X32.IfcBlock = IfcBlock;
  class IfcBooleanClippingResult extends IfcBooleanResult {
    constructor(Operator, FirstOperand, SecondOperand) {
      super(Operator, FirstOperand, SecondOperand);
      this.Operator = Operator;
      this.FirstOperand = FirstOperand;
      this.SecondOperand = SecondOperand;
      this.type = 3649129432;
    }
  }
  IFC4X32.IfcBooleanClippingResult = IfcBooleanClippingResult;
  class IfcBoundedCurve extends IfcCurve {
    constructor() {
      super();
      this.type = 1260505505;
    }
  }
  IFC4X32.IfcBoundedCurve = IfcBoundedCurve;
  class IfcBuildingStorey extends IfcSpatialStructureElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, Elevation) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.Elevation = Elevation;
      this.type = 3124254112;
    }
  }
  IFC4X32.IfcBuildingStorey = IfcBuildingStorey;
  class IfcBuiltElementType extends IfcElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 1626504194;
    }
  }
  IFC4X32.IfcBuiltElementType = IfcBuiltElementType;
  class IfcChimneyType extends IfcBuiltElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2197970202;
    }
  }
  IFC4X32.IfcChimneyType = IfcChimneyType;
  class IfcCircleHollowProfileDef extends IfcCircleProfileDef {
    constructor(ProfileType, ProfileName, Position, Radius, WallThickness) {
      super(ProfileType, ProfileName, Position, Radius);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Radius = Radius;
      this.WallThickness = WallThickness;
      this.type = 2937912522;
    }
  }
  IFC4X32.IfcCircleHollowProfileDef = IfcCircleHollowProfileDef;
  class IfcCivilElementType extends IfcElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3893394355;
    }
  }
  IFC4X32.IfcCivilElementType = IfcCivilElementType;
  class IfcClothoid extends IfcSpiral {
    constructor(Position, ClothoidConstant) {
      super(Position);
      this.Position = Position;
      this.ClothoidConstant = ClothoidConstant;
      this.type = 3497074424;
    }
  }
  IFC4X32.IfcClothoid = IfcClothoid;
  class IfcColumnType extends IfcBuiltElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 300633059;
    }
  }
  IFC4X32.IfcColumnType = IfcColumnType;
  class IfcComplexPropertyTemplate extends IfcPropertyTemplate {
    constructor(GlobalId, OwnerHistory, Name, Description, UsageName, TemplateType, HasPropertyTemplates) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.UsageName = UsageName;
      this.TemplateType = TemplateType;
      this.HasPropertyTemplates = HasPropertyTemplates;
      this.type = 3875453745;
    }
  }
  IFC4X32.IfcComplexPropertyTemplate = IfcComplexPropertyTemplate;
  class IfcCompositeCurve extends IfcBoundedCurve {
    constructor(Segments, SelfIntersect) {
      super();
      this.Segments = Segments;
      this.SelfIntersect = SelfIntersect;
      this.type = 3732776249;
    }
  }
  IFC4X32.IfcCompositeCurve = IfcCompositeCurve;
  class IfcCompositeCurveOnSurface extends IfcCompositeCurve {
    constructor(Segments, SelfIntersect) {
      super(Segments, SelfIntersect);
      this.Segments = Segments;
      this.SelfIntersect = SelfIntersect;
      this.type = 15328376;
    }
  }
  IFC4X32.IfcCompositeCurveOnSurface = IfcCompositeCurveOnSurface;
  class IfcConic extends IfcCurve {
    constructor(Position) {
      super();
      this.Position = Position;
      this.type = 2510884976;
    }
  }
  IFC4X32.IfcConic = IfcConic;
  class IfcConstructionEquipmentResourceType extends IfcConstructionResourceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ResourceType = ResourceType;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 2185764099;
    }
  }
  IFC4X32.IfcConstructionEquipmentResourceType = IfcConstructionEquipmentResourceType;
  class IfcConstructionMaterialResourceType extends IfcConstructionResourceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ResourceType = ResourceType;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 4105962743;
    }
  }
  IFC4X32.IfcConstructionMaterialResourceType = IfcConstructionMaterialResourceType;
  class IfcConstructionProductResourceType extends IfcConstructionResourceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ResourceType = ResourceType;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 1525564444;
    }
  }
  IFC4X32.IfcConstructionProductResourceType = IfcConstructionProductResourceType;
  class IfcConstructionResource extends IfcResource {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.Usage = Usage;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.type = 2559216714;
    }
  }
  IFC4X32.IfcConstructionResource = IfcConstructionResource;
  class IfcControl extends IfcObject {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.type = 3293443760;
    }
  }
  IFC4X32.IfcControl = IfcControl;
  class IfcCosineSpiral extends IfcSpiral {
    constructor(Position, CosineTerm, ConstantTerm) {
      super(Position);
      this.Position = Position;
      this.CosineTerm = CosineTerm;
      this.ConstantTerm = ConstantTerm;
      this.type = 2000195564;
    }
  }
  IFC4X32.IfcCosineSpiral = IfcCosineSpiral;
  class IfcCostItem extends IfcControl {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, CostValues, CostQuantities) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.PredefinedType = PredefinedType;
      this.CostValues = CostValues;
      this.CostQuantities = CostQuantities;
      this.type = 3895139033;
    }
  }
  IFC4X32.IfcCostItem = IfcCostItem;
  class IfcCostSchedule extends IfcControl {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, Status, SubmittedOn, UpdateDate) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.PredefinedType = PredefinedType;
      this.Status = Status;
      this.SubmittedOn = SubmittedOn;
      this.UpdateDate = UpdateDate;
      this.type = 1419761937;
    }
  }
  IFC4X32.IfcCostSchedule = IfcCostSchedule;
  class IfcCourseType extends IfcBuiltElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4189326743;
    }
  }
  IFC4X32.IfcCourseType = IfcCourseType;
  class IfcCoveringType extends IfcBuiltElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1916426348;
    }
  }
  IFC4X32.IfcCoveringType = IfcCoveringType;
  class IfcCrewResource extends IfcConstructionResource {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.Usage = Usage;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 3295246426;
    }
  }
  IFC4X32.IfcCrewResource = IfcCrewResource;
  class IfcCurtainWallType extends IfcBuiltElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1457835157;
    }
  }
  IFC4X32.IfcCurtainWallType = IfcCurtainWallType;
  class IfcCylindricalSurface extends IfcElementarySurface {
    constructor(Position, Radius) {
      super(Position);
      this.Position = Position;
      this.Radius = Radius;
      this.type = 1213902940;
    }
  }
  IFC4X32.IfcCylindricalSurface = IfcCylindricalSurface;
  class IfcDeepFoundationType extends IfcBuiltElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 1306400036;
    }
  }
  IFC4X32.IfcDeepFoundationType = IfcDeepFoundationType;
  class IfcDirectrixDerivedReferenceSweptAreaSolid extends IfcFixedReferenceSweptAreaSolid {
    constructor(SweptArea, Position, Directrix, StartParam, EndParam, FixedReference) {
      super(SweptArea, Position, Directrix, StartParam, EndParam, FixedReference);
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.Directrix = Directrix;
      this.StartParam = StartParam;
      this.EndParam = EndParam;
      this.FixedReference = FixedReference;
      this.type = 4234616927;
    }
  }
  IFC4X32.IfcDirectrixDerivedReferenceSweptAreaSolid = IfcDirectrixDerivedReferenceSweptAreaSolid;
  class IfcDistributionElementType extends IfcElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3256556792;
    }
  }
  IFC4X32.IfcDistributionElementType = IfcDistributionElementType;
  class IfcDistributionFlowElementType extends IfcDistributionElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3849074793;
    }
  }
  IFC4X32.IfcDistributionFlowElementType = IfcDistributionFlowElementType;
  class IfcDoorLiningProperties extends IfcPreDefinedPropertySet {
    constructor(GlobalId, OwnerHistory, Name, Description, LiningDepth, LiningThickness, ThresholdDepth, ThresholdThickness, TransomThickness, TransomOffset, LiningOffset, ThresholdOffset, CasingThickness, CasingDepth, ShapeAspectStyle, LiningToPanelOffsetX, LiningToPanelOffsetY) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.LiningDepth = LiningDepth;
      this.LiningThickness = LiningThickness;
      this.ThresholdDepth = ThresholdDepth;
      this.ThresholdThickness = ThresholdThickness;
      this.TransomThickness = TransomThickness;
      this.TransomOffset = TransomOffset;
      this.LiningOffset = LiningOffset;
      this.ThresholdOffset = ThresholdOffset;
      this.CasingThickness = CasingThickness;
      this.CasingDepth = CasingDepth;
      this.ShapeAspectStyle = ShapeAspectStyle;
      this.LiningToPanelOffsetX = LiningToPanelOffsetX;
      this.LiningToPanelOffsetY = LiningToPanelOffsetY;
      this.type = 2963535650;
    }
  }
  IFC4X32.IfcDoorLiningProperties = IfcDoorLiningProperties;
  class IfcDoorPanelProperties extends IfcPreDefinedPropertySet {
    constructor(GlobalId, OwnerHistory, Name, Description, PanelDepth, PanelOperation, PanelWidth, PanelPosition, ShapeAspectStyle) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.PanelDepth = PanelDepth;
      this.PanelOperation = PanelOperation;
      this.PanelWidth = PanelWidth;
      this.PanelPosition = PanelPosition;
      this.ShapeAspectStyle = ShapeAspectStyle;
      this.type = 1714330368;
    }
  }
  IFC4X32.IfcDoorPanelProperties = IfcDoorPanelProperties;
  class IfcDoorType extends IfcBuiltElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, OperationType, ParameterTakesPrecedence, UserDefinedOperationType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.OperationType = OperationType;
      this.ParameterTakesPrecedence = ParameterTakesPrecedence;
      this.UserDefinedOperationType = UserDefinedOperationType;
      this.type = 2323601079;
    }
  }
  IFC4X32.IfcDoorType = IfcDoorType;
  class IfcDraughtingPreDefinedColour extends IfcPreDefinedColour {
    constructor(Name) {
      super(Name);
      this.Name = Name;
      this.type = 445594917;
    }
  }
  IFC4X32.IfcDraughtingPreDefinedColour = IfcDraughtingPreDefinedColour;
  class IfcDraughtingPreDefinedCurveFont extends IfcPreDefinedCurveFont {
    constructor(Name) {
      super(Name);
      this.Name = Name;
      this.type = 4006246654;
    }
  }
  IFC4X32.IfcDraughtingPreDefinedCurveFont = IfcDraughtingPreDefinedCurveFont;
  class IfcElement extends IfcProduct {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1758889154;
    }
  }
  IFC4X32.IfcElement = IfcElement;
  class IfcElementAssembly extends IfcElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, AssemblyPlace, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.AssemblyPlace = AssemblyPlace;
      this.PredefinedType = PredefinedType;
      this.type = 4123344466;
    }
  }
  IFC4X32.IfcElementAssembly = IfcElementAssembly;
  class IfcElementAssemblyType extends IfcElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2397081782;
    }
  }
  IFC4X32.IfcElementAssemblyType = IfcElementAssemblyType;
  class IfcElementComponent extends IfcElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1623761950;
    }
  }
  IFC4X32.IfcElementComponent = IfcElementComponent;
  class IfcElementComponentType extends IfcElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 2590856083;
    }
  }
  IFC4X32.IfcElementComponentType = IfcElementComponentType;
  class IfcEllipse extends IfcConic {
    constructor(Position, SemiAxis1, SemiAxis2) {
      super(Position);
      this.Position = Position;
      this.SemiAxis1 = SemiAxis1;
      this.SemiAxis2 = SemiAxis2;
      this.type = 1704287377;
    }
  }
  IFC4X32.IfcEllipse = IfcEllipse;
  class IfcEnergyConversionDeviceType extends IfcDistributionFlowElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 2107101300;
    }
  }
  IFC4X32.IfcEnergyConversionDeviceType = IfcEnergyConversionDeviceType;
  class IfcEngineType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 132023988;
    }
  }
  IFC4X32.IfcEngineType = IfcEngineType;
  class IfcEvaporativeCoolerType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3174744832;
    }
  }
  IFC4X32.IfcEvaporativeCoolerType = IfcEvaporativeCoolerType;
  class IfcEvaporatorType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3390157468;
    }
  }
  IFC4X32.IfcEvaporatorType = IfcEvaporatorType;
  class IfcEvent extends IfcProcess {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, PredefinedType, EventTriggerType, UserDefinedEventTriggerType, EventOccurenceTime) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.PredefinedType = PredefinedType;
      this.EventTriggerType = EventTriggerType;
      this.UserDefinedEventTriggerType = UserDefinedEventTriggerType;
      this.EventOccurenceTime = EventOccurenceTime;
      this.type = 4148101412;
    }
  }
  IFC4X32.IfcEvent = IfcEvent;
  class IfcExternalSpatialStructureElement extends IfcSpatialElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.type = 2853485674;
    }
  }
  IFC4X32.IfcExternalSpatialStructureElement = IfcExternalSpatialStructureElement;
  class IfcFacetedBrep extends IfcManifoldSolidBrep {
    constructor(Outer) {
      super(Outer);
      this.Outer = Outer;
      this.type = 807026263;
    }
  }
  IFC4X32.IfcFacetedBrep = IfcFacetedBrep;
  class IfcFacetedBrepWithVoids extends IfcFacetedBrep {
    constructor(Outer, Voids) {
      super(Outer);
      this.Outer = Outer;
      this.Voids = Voids;
      this.type = 3737207727;
    }
  }
  IFC4X32.IfcFacetedBrepWithVoids = IfcFacetedBrepWithVoids;
  class IfcFacility extends IfcSpatialStructureElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.type = 24185140;
    }
  }
  IFC4X32.IfcFacility = IfcFacility;
  class IfcFacilityPart extends IfcSpatialStructureElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.UsageType = UsageType;
      this.type = 1310830890;
    }
  }
  IFC4X32.IfcFacilityPart = IfcFacilityPart;
  class IfcFacilityPartCommon extends IfcFacilityPart {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.UsageType = UsageType;
      this.PredefinedType = PredefinedType;
      this.type = 4228831410;
    }
  }
  IFC4X32.IfcFacilityPartCommon = IfcFacilityPartCommon;
  class IfcFastener extends IfcElementComponent {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 647756555;
    }
  }
  IFC4X32.IfcFastener = IfcFastener;
  class IfcFastenerType extends IfcElementComponentType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2489546625;
    }
  }
  IFC4X32.IfcFastenerType = IfcFastenerType;
  class IfcFeatureElement extends IfcElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 2827207264;
    }
  }
  IFC4X32.IfcFeatureElement = IfcFeatureElement;
  class IfcFeatureElementAddition extends IfcFeatureElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 2143335405;
    }
  }
  IFC4X32.IfcFeatureElementAddition = IfcFeatureElementAddition;
  class IfcFeatureElementSubtraction extends IfcFeatureElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1287392070;
    }
  }
  IFC4X32.IfcFeatureElementSubtraction = IfcFeatureElementSubtraction;
  class IfcFlowControllerType extends IfcDistributionFlowElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3907093117;
    }
  }
  IFC4X32.IfcFlowControllerType = IfcFlowControllerType;
  class IfcFlowFittingType extends IfcDistributionFlowElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3198132628;
    }
  }
  IFC4X32.IfcFlowFittingType = IfcFlowFittingType;
  class IfcFlowMeterType extends IfcFlowControllerType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3815607619;
    }
  }
  IFC4X32.IfcFlowMeterType = IfcFlowMeterType;
  class IfcFlowMovingDeviceType extends IfcDistributionFlowElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 1482959167;
    }
  }
  IFC4X32.IfcFlowMovingDeviceType = IfcFlowMovingDeviceType;
  class IfcFlowSegmentType extends IfcDistributionFlowElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 1834744321;
    }
  }
  IFC4X32.IfcFlowSegmentType = IfcFlowSegmentType;
  class IfcFlowStorageDeviceType extends IfcDistributionFlowElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 1339347760;
    }
  }
  IFC4X32.IfcFlowStorageDeviceType = IfcFlowStorageDeviceType;
  class IfcFlowTerminalType extends IfcDistributionFlowElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 2297155007;
    }
  }
  IFC4X32.IfcFlowTerminalType = IfcFlowTerminalType;
  class IfcFlowTreatmentDeviceType extends IfcDistributionFlowElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3009222698;
    }
  }
  IFC4X32.IfcFlowTreatmentDeviceType = IfcFlowTreatmentDeviceType;
  class IfcFootingType extends IfcBuiltElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1893162501;
    }
  }
  IFC4X32.IfcFootingType = IfcFootingType;
  class IfcFurnishingElement extends IfcElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 263784265;
    }
  }
  IFC4X32.IfcFurnishingElement = IfcFurnishingElement;
  class IfcFurniture extends IfcFurnishingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1509553395;
    }
  }
  IFC4X32.IfcFurniture = IfcFurniture;
  class IfcGeographicElement extends IfcElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3493046030;
    }
  }
  IFC4X32.IfcGeographicElement = IfcGeographicElement;
  class IfcGeotechnicalElement extends IfcElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 4230923436;
    }
  }
  IFC4X32.IfcGeotechnicalElement = IfcGeotechnicalElement;
  class IfcGeotechnicalStratum extends IfcGeotechnicalElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1594536857;
    }
  }
  IFC4X32.IfcGeotechnicalStratum = IfcGeotechnicalStratum;
  class IfcGradientCurve extends IfcCompositeCurve {
    constructor(Segments, SelfIntersect, BaseCurve, EndPoint) {
      super(Segments, SelfIntersect);
      this.Segments = Segments;
      this.SelfIntersect = SelfIntersect;
      this.BaseCurve = BaseCurve;
      this.EndPoint = EndPoint;
      this.type = 2898700619;
    }
  }
  IFC4X32.IfcGradientCurve = IfcGradientCurve;
  class IfcGroup extends IfcObject {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.type = 2706460486;
    }
  }
  IFC4X32.IfcGroup = IfcGroup;
  class IfcHeatExchangerType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1251058090;
    }
  }
  IFC4X32.IfcHeatExchangerType = IfcHeatExchangerType;
  class IfcHumidifierType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1806887404;
    }
  }
  IFC4X32.IfcHumidifierType = IfcHumidifierType;
  class IfcImpactProtectionDevice extends IfcElementComponent {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2568555532;
    }
  }
  IFC4X32.IfcImpactProtectionDevice = IfcImpactProtectionDevice;
  class IfcImpactProtectionDeviceType extends IfcElementComponentType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3948183225;
    }
  }
  IFC4X32.IfcImpactProtectionDeviceType = IfcImpactProtectionDeviceType;
  class IfcIndexedPolyCurve extends IfcBoundedCurve {
    constructor(Points, Segments, SelfIntersect) {
      super();
      this.Points = Points;
      this.Segments = Segments;
      this.SelfIntersect = SelfIntersect;
      this.type = 2571569899;
    }
  }
  IFC4X32.IfcIndexedPolyCurve = IfcIndexedPolyCurve;
  class IfcInterceptorType extends IfcFlowTreatmentDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3946677679;
    }
  }
  IFC4X32.IfcInterceptorType = IfcInterceptorType;
  class IfcIntersectionCurve extends IfcSurfaceCurve {
    constructor(Curve3D, AssociatedGeometry, MasterRepresentation) {
      super(Curve3D, AssociatedGeometry, MasterRepresentation);
      this.Curve3D = Curve3D;
      this.AssociatedGeometry = AssociatedGeometry;
      this.MasterRepresentation = MasterRepresentation;
      this.type = 3113134337;
    }
  }
  IFC4X32.IfcIntersectionCurve = IfcIntersectionCurve;
  class IfcInventory extends IfcGroup {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, Jurisdiction, ResponsiblePersons, LastUpdateDate, CurrentValue, OriginalValue) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.PredefinedType = PredefinedType;
      this.Jurisdiction = Jurisdiction;
      this.ResponsiblePersons = ResponsiblePersons;
      this.LastUpdateDate = LastUpdateDate;
      this.CurrentValue = CurrentValue;
      this.OriginalValue = OriginalValue;
      this.type = 2391368822;
    }
  }
  IFC4X32.IfcInventory = IfcInventory;
  class IfcJunctionBoxType extends IfcFlowFittingType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4288270099;
    }
  }
  IFC4X32.IfcJunctionBoxType = IfcJunctionBoxType;
  class IfcKerbType extends IfcBuiltElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, Mountable) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.Mountable = Mountable;
      this.type = 679976338;
    }
  }
  IFC4X32.IfcKerbType = IfcKerbType;
  class IfcLaborResource extends IfcConstructionResource {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.Usage = Usage;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 3827777499;
    }
  }
  IFC4X32.IfcLaborResource = IfcLaborResource;
  class IfcLampType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1051575348;
    }
  }
  IFC4X32.IfcLampType = IfcLampType;
  class IfcLightFixtureType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1161773419;
    }
  }
  IFC4X32.IfcLightFixtureType = IfcLightFixtureType;
  class IfcLinearElement extends IfcProduct {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.type = 2176059722;
    }
  }
  IFC4X32.IfcLinearElement = IfcLinearElement;
  class IfcLiquidTerminalType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1770583370;
    }
  }
  IFC4X32.IfcLiquidTerminalType = IfcLiquidTerminalType;
  class IfcMarineFacility extends IfcFacility {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.PredefinedType = PredefinedType;
      this.type = 525669439;
    }
  }
  IFC4X32.IfcMarineFacility = IfcMarineFacility;
  class IfcMarinePart extends IfcFacilityPart {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.UsageType = UsageType;
      this.PredefinedType = PredefinedType;
      this.type = 976884017;
    }
  }
  IFC4X32.IfcMarinePart = IfcMarinePart;
  class IfcMechanicalFastener extends IfcElementComponent {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, NominalDiameter, NominalLength, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.NominalDiameter = NominalDiameter;
      this.NominalLength = NominalLength;
      this.PredefinedType = PredefinedType;
      this.type = 377706215;
    }
  }
  IFC4X32.IfcMechanicalFastener = IfcMechanicalFastener;
  class IfcMechanicalFastenerType extends IfcElementComponentType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, NominalDiameter, NominalLength) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.NominalDiameter = NominalDiameter;
      this.NominalLength = NominalLength;
      this.type = 2108223431;
    }
  }
  IFC4X32.IfcMechanicalFastenerType = IfcMechanicalFastenerType;
  class IfcMedicalDeviceType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1114901282;
    }
  }
  IFC4X32.IfcMedicalDeviceType = IfcMedicalDeviceType;
  class IfcMemberType extends IfcBuiltElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3181161470;
    }
  }
  IFC4X32.IfcMemberType = IfcMemberType;
  class IfcMobileTelecommunicationsApplianceType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1950438474;
    }
  }
  IFC4X32.IfcMobileTelecommunicationsApplianceType = IfcMobileTelecommunicationsApplianceType;
  class IfcMooringDeviceType extends IfcBuiltElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 710110818;
    }
  }
  IFC4X32.IfcMooringDeviceType = IfcMooringDeviceType;
  class IfcMotorConnectionType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 977012517;
    }
  }
  IFC4X32.IfcMotorConnectionType = IfcMotorConnectionType;
  class IfcNavigationElementType extends IfcBuiltElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 506776471;
    }
  }
  IFC4X32.IfcNavigationElementType = IfcNavigationElementType;
  class IfcOccupant extends IfcActor {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, TheActor, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, TheActor);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.TheActor = TheActor;
      this.PredefinedType = PredefinedType;
      this.type = 4143007308;
    }
  }
  IFC4X32.IfcOccupant = IfcOccupant;
  class IfcOpeningElement extends IfcFeatureElementSubtraction {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3588315303;
    }
  }
  IFC4X32.IfcOpeningElement = IfcOpeningElement;
  class IfcOutletType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2837617999;
    }
  }
  IFC4X32.IfcOutletType = IfcOutletType;
  class IfcPavementType extends IfcBuiltElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 514975943;
    }
  }
  IFC4X32.IfcPavementType = IfcPavementType;
  class IfcPerformanceHistory extends IfcControl {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LifeCyclePhase, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LifeCyclePhase = LifeCyclePhase;
      this.PredefinedType = PredefinedType;
      this.type = 2382730787;
    }
  }
  IFC4X32.IfcPerformanceHistory = IfcPerformanceHistory;
  class IfcPermeableCoveringProperties extends IfcPreDefinedPropertySet {
    constructor(GlobalId, OwnerHistory, Name, Description, OperationType, PanelPosition, FrameDepth, FrameThickness, ShapeAspectStyle) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.OperationType = OperationType;
      this.PanelPosition = PanelPosition;
      this.FrameDepth = FrameDepth;
      this.FrameThickness = FrameThickness;
      this.ShapeAspectStyle = ShapeAspectStyle;
      this.type = 3566463478;
    }
  }
  IFC4X32.IfcPermeableCoveringProperties = IfcPermeableCoveringProperties;
  class IfcPermit extends IfcControl {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, Status, LongDescription) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.PredefinedType = PredefinedType;
      this.Status = Status;
      this.LongDescription = LongDescription;
      this.type = 3327091369;
    }
  }
  IFC4X32.IfcPermit = IfcPermit;
  class IfcPileType extends IfcDeepFoundationType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1158309216;
    }
  }
  IFC4X32.IfcPileType = IfcPileType;
  class IfcPipeFittingType extends IfcFlowFittingType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 804291784;
    }
  }
  IFC4X32.IfcPipeFittingType = IfcPipeFittingType;
  class IfcPipeSegmentType extends IfcFlowSegmentType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4231323485;
    }
  }
  IFC4X32.IfcPipeSegmentType = IfcPipeSegmentType;
  class IfcPlateType extends IfcBuiltElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4017108033;
    }
  }
  IFC4X32.IfcPlateType = IfcPlateType;
  class IfcPolygonalFaceSet extends IfcTessellatedFaceSet {
    constructor(Coordinates, Closed, Faces, PnIndex) {
      super(Coordinates, Closed);
      this.Coordinates = Coordinates;
      this.Closed = Closed;
      this.Faces = Faces;
      this.PnIndex = PnIndex;
      this.type = 2839578677;
    }
  }
  IFC4X32.IfcPolygonalFaceSet = IfcPolygonalFaceSet;
  class IfcPolyline extends IfcBoundedCurve {
    constructor(Points) {
      super();
      this.Points = Points;
      this.type = 3724593414;
    }
  }
  IFC4X32.IfcPolyline = IfcPolyline;
  class IfcPort extends IfcProduct {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.type = 3740093272;
    }
  }
  IFC4X32.IfcPort = IfcPort;
  class IfcPositioningElement extends IfcProduct {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.type = 1946335990;
    }
  }
  IFC4X32.IfcPositioningElement = IfcPositioningElement;
  class IfcProcedure extends IfcProcess {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.PredefinedType = PredefinedType;
      this.type = 2744685151;
    }
  }
  IFC4X32.IfcProcedure = IfcProcedure;
  class IfcProjectOrder extends IfcControl {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, Status, LongDescription) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.PredefinedType = PredefinedType;
      this.Status = Status;
      this.LongDescription = LongDescription;
      this.type = 2904328755;
    }
  }
  IFC4X32.IfcProjectOrder = IfcProjectOrder;
  class IfcProjectionElement extends IfcFeatureElementAddition {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3651124850;
    }
  }
  IFC4X32.IfcProjectionElement = IfcProjectionElement;
  class IfcProtectiveDeviceType extends IfcFlowControllerType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1842657554;
    }
  }
  IFC4X32.IfcProtectiveDeviceType = IfcProtectiveDeviceType;
  class IfcPumpType extends IfcFlowMovingDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2250791053;
    }
  }
  IFC4X32.IfcPumpType = IfcPumpType;
  class IfcRailType extends IfcBuiltElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1763565496;
    }
  }
  IFC4X32.IfcRailType = IfcRailType;
  class IfcRailingType extends IfcBuiltElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2893384427;
    }
  }
  IFC4X32.IfcRailingType = IfcRailingType;
  class IfcRailway extends IfcFacility {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.PredefinedType = PredefinedType;
      this.type = 3992365140;
    }
  }
  IFC4X32.IfcRailway = IfcRailway;
  class IfcRailwayPart extends IfcFacilityPart {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.UsageType = UsageType;
      this.PredefinedType = PredefinedType;
      this.type = 1891881377;
    }
  }
  IFC4X32.IfcRailwayPart = IfcRailwayPart;
  class IfcRampFlightType extends IfcBuiltElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2324767716;
    }
  }
  IFC4X32.IfcRampFlightType = IfcRampFlightType;
  class IfcRampType extends IfcBuiltElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1469900589;
    }
  }
  IFC4X32.IfcRampType = IfcRampType;
  class IfcRationalBSplineSurfaceWithKnots extends IfcBSplineSurfaceWithKnots {
    constructor(UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect, UMultiplicities, VMultiplicities, UKnots, VKnots, KnotSpec, WeightsData) {
      super(UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect, UMultiplicities, VMultiplicities, UKnots, VKnots, KnotSpec);
      this.UDegree = UDegree;
      this.VDegree = VDegree;
      this.ControlPointsList = ControlPointsList;
      this.SurfaceForm = SurfaceForm;
      this.UClosed = UClosed;
      this.VClosed = VClosed;
      this.SelfIntersect = SelfIntersect;
      this.UMultiplicities = UMultiplicities;
      this.VMultiplicities = VMultiplicities;
      this.UKnots = UKnots;
      this.VKnots = VKnots;
      this.KnotSpec = KnotSpec;
      this.WeightsData = WeightsData;
      this.type = 683857671;
    }
  }
  IFC4X32.IfcRationalBSplineSurfaceWithKnots = IfcRationalBSplineSurfaceWithKnots;
  class IfcReferent extends IfcPositioningElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.PredefinedType = PredefinedType;
      this.type = 4021432810;
    }
  }
  IFC4X32.IfcReferent = IfcReferent;
  class IfcReinforcingElement extends IfcElementComponent {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.SteelGrade = SteelGrade;
      this.type = 3027567501;
    }
  }
  IFC4X32.IfcReinforcingElement = IfcReinforcingElement;
  class IfcReinforcingElementType extends IfcElementComponentType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 964333572;
    }
  }
  IFC4X32.IfcReinforcingElementType = IfcReinforcingElementType;
  class IfcReinforcingMesh extends IfcReinforcingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, MeshLength, MeshWidth, LongitudinalBarNominalDiameter, TransverseBarNominalDiameter, LongitudinalBarCrossSectionArea, TransverseBarCrossSectionArea, LongitudinalBarSpacing, TransverseBarSpacing, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.SteelGrade = SteelGrade;
      this.MeshLength = MeshLength;
      this.MeshWidth = MeshWidth;
      this.LongitudinalBarNominalDiameter = LongitudinalBarNominalDiameter;
      this.TransverseBarNominalDiameter = TransverseBarNominalDiameter;
      this.LongitudinalBarCrossSectionArea = LongitudinalBarCrossSectionArea;
      this.TransverseBarCrossSectionArea = TransverseBarCrossSectionArea;
      this.LongitudinalBarSpacing = LongitudinalBarSpacing;
      this.TransverseBarSpacing = TransverseBarSpacing;
      this.PredefinedType = PredefinedType;
      this.type = 2320036040;
    }
  }
  IFC4X32.IfcReinforcingMesh = IfcReinforcingMesh;
  class IfcReinforcingMeshType extends IfcReinforcingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, MeshLength, MeshWidth, LongitudinalBarNominalDiameter, TransverseBarNominalDiameter, LongitudinalBarCrossSectionArea, TransverseBarCrossSectionArea, LongitudinalBarSpacing, TransverseBarSpacing, BendingShapeCode, BendingParameters) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.MeshLength = MeshLength;
      this.MeshWidth = MeshWidth;
      this.LongitudinalBarNominalDiameter = LongitudinalBarNominalDiameter;
      this.TransverseBarNominalDiameter = TransverseBarNominalDiameter;
      this.LongitudinalBarCrossSectionArea = LongitudinalBarCrossSectionArea;
      this.TransverseBarCrossSectionArea = TransverseBarCrossSectionArea;
      this.LongitudinalBarSpacing = LongitudinalBarSpacing;
      this.TransverseBarSpacing = TransverseBarSpacing;
      this.BendingShapeCode = BendingShapeCode;
      this.BendingParameters = BendingParameters;
      this.type = 2310774935;
    }
  }
  IFC4X32.IfcReinforcingMeshType = IfcReinforcingMeshType;
  class IfcRelAdheresToElement extends IfcRelDecomposes {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedSurfaceFeatures) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingElement = RelatingElement;
      this.RelatedSurfaceFeatures = RelatedSurfaceFeatures;
      this.type = 3818125796;
    }
  }
  IFC4X32.IfcRelAdheresToElement = IfcRelAdheresToElement;
  class IfcRelAggregates extends IfcRelDecomposes {
    constructor(GlobalId, OwnerHistory, Name, Description, RelatingObject, RelatedObjects) {
      super(GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingObject = RelatingObject;
      this.RelatedObjects = RelatedObjects;
      this.type = 160246688;
    }
  }
  IFC4X32.IfcRelAggregates = IfcRelAggregates;
  class IfcRoad extends IfcFacility {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.PredefinedType = PredefinedType;
      this.type = 146592293;
    }
  }
  IFC4X32.IfcRoad = IfcRoad;
  class IfcRoadPart extends IfcFacilityPart {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.UsageType = UsageType;
      this.PredefinedType = PredefinedType;
      this.type = 550521510;
    }
  }
  IFC4X32.IfcRoadPart = IfcRoadPart;
  class IfcRoofType extends IfcBuiltElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2781568857;
    }
  }
  IFC4X32.IfcRoofType = IfcRoofType;
  class IfcSanitaryTerminalType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1768891740;
    }
  }
  IFC4X32.IfcSanitaryTerminalType = IfcSanitaryTerminalType;
  class IfcSeamCurve extends IfcSurfaceCurve {
    constructor(Curve3D, AssociatedGeometry, MasterRepresentation) {
      super(Curve3D, AssociatedGeometry, MasterRepresentation);
      this.Curve3D = Curve3D;
      this.AssociatedGeometry = AssociatedGeometry;
      this.MasterRepresentation = MasterRepresentation;
      this.type = 2157484638;
    }
  }
  IFC4X32.IfcSeamCurve = IfcSeamCurve;
  class IfcSecondOrderPolynomialSpiral extends IfcSpiral {
    constructor(Position, QuadraticTerm, LinearTerm, ConstantTerm) {
      super(Position);
      this.Position = Position;
      this.QuadraticTerm = QuadraticTerm;
      this.LinearTerm = LinearTerm;
      this.ConstantTerm = ConstantTerm;
      this.type = 3649235739;
    }
  }
  IFC4X32.IfcSecondOrderPolynomialSpiral = IfcSecondOrderPolynomialSpiral;
  class IfcSegmentedReferenceCurve extends IfcCompositeCurve {
    constructor(Segments, SelfIntersect, BaseCurve, EndPoint) {
      super(Segments, SelfIntersect);
      this.Segments = Segments;
      this.SelfIntersect = SelfIntersect;
      this.BaseCurve = BaseCurve;
      this.EndPoint = EndPoint;
      this.type = 544395925;
    }
  }
  IFC4X32.IfcSegmentedReferenceCurve = IfcSegmentedReferenceCurve;
  class IfcSeventhOrderPolynomialSpiral extends IfcSpiral {
    constructor(Position, SepticTerm, SexticTerm, QuinticTerm, QuarticTerm, CubicTerm, QuadraticTerm, LinearTerm, ConstantTerm) {
      super(Position);
      this.Position = Position;
      this.SepticTerm = SepticTerm;
      this.SexticTerm = SexticTerm;
      this.QuinticTerm = QuinticTerm;
      this.QuarticTerm = QuarticTerm;
      this.CubicTerm = CubicTerm;
      this.QuadraticTerm = QuadraticTerm;
      this.LinearTerm = LinearTerm;
      this.ConstantTerm = ConstantTerm;
      this.type = 1027922057;
    }
  }
  IFC4X32.IfcSeventhOrderPolynomialSpiral = IfcSeventhOrderPolynomialSpiral;
  class IfcShadingDeviceType extends IfcBuiltElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4074543187;
    }
  }
  IFC4X32.IfcShadingDeviceType = IfcShadingDeviceType;
  class IfcSign extends IfcElementComponent {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 33720170;
    }
  }
  IFC4X32.IfcSign = IfcSign;
  class IfcSignType extends IfcElementComponentType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3599934289;
    }
  }
  IFC4X32.IfcSignType = IfcSignType;
  class IfcSignalType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1894708472;
    }
  }
  IFC4X32.IfcSignalType = IfcSignalType;
  class IfcSineSpiral extends IfcSpiral {
    constructor(Position, SineTerm, LinearTerm, ConstantTerm) {
      super(Position);
      this.Position = Position;
      this.SineTerm = SineTerm;
      this.LinearTerm = LinearTerm;
      this.ConstantTerm = ConstantTerm;
      this.type = 42703149;
    }
  }
  IFC4X32.IfcSineSpiral = IfcSineSpiral;
  class IfcSite extends IfcSpatialStructureElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, RefLatitude, RefLongitude, RefElevation, LandTitleNumber, SiteAddress) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.RefLatitude = RefLatitude;
      this.RefLongitude = RefLongitude;
      this.RefElevation = RefElevation;
      this.LandTitleNumber = LandTitleNumber;
      this.SiteAddress = SiteAddress;
      this.type = 4097777520;
    }
  }
  IFC4X32.IfcSite = IfcSite;
  class IfcSlabType extends IfcBuiltElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2533589738;
    }
  }
  IFC4X32.IfcSlabType = IfcSlabType;
  class IfcSolarDeviceType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1072016465;
    }
  }
  IFC4X32.IfcSolarDeviceType = IfcSolarDeviceType;
  class IfcSpace extends IfcSpatialStructureElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, PredefinedType, ElevationWithFlooring) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.PredefinedType = PredefinedType;
      this.ElevationWithFlooring = ElevationWithFlooring;
      this.type = 3856911033;
    }
  }
  IFC4X32.IfcSpace = IfcSpace;
  class IfcSpaceHeaterType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1305183839;
    }
  }
  IFC4X32.IfcSpaceHeaterType = IfcSpaceHeaterType;
  class IfcSpaceType extends IfcSpatialStructureElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, LongName) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.LongName = LongName;
      this.type = 3812236995;
    }
  }
  IFC4X32.IfcSpaceType = IfcSpaceType;
  class IfcStackTerminalType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3112655638;
    }
  }
  IFC4X32.IfcStackTerminalType = IfcStackTerminalType;
  class IfcStairFlightType extends IfcBuiltElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1039846685;
    }
  }
  IFC4X32.IfcStairFlightType = IfcStairFlightType;
  class IfcStairType extends IfcBuiltElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 338393293;
    }
  }
  IFC4X32.IfcStairType = IfcStairType;
  class IfcStructuralAction extends IfcStructuralActivity {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.DestabilizingLoad = DestabilizingLoad;
      this.type = 682877961;
    }
  }
  IFC4X32.IfcStructuralAction = IfcStructuralAction;
  class IfcStructuralConnection extends IfcStructuralItem {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedCondition = AppliedCondition;
      this.type = 1179482911;
    }
  }
  IFC4X32.IfcStructuralConnection = IfcStructuralConnection;
  class IfcStructuralCurveAction extends IfcStructuralAction {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.DestabilizingLoad = DestabilizingLoad;
      this.ProjectedOrTrue = ProjectedOrTrue;
      this.PredefinedType = PredefinedType;
      this.type = 1004757350;
    }
  }
  IFC4X32.IfcStructuralCurveAction = IfcStructuralCurveAction;
  class IfcStructuralCurveConnection extends IfcStructuralConnection {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition, AxisDirection) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedCondition = AppliedCondition;
      this.AxisDirection = AxisDirection;
      this.type = 4243806635;
    }
  }
  IFC4X32.IfcStructuralCurveConnection = IfcStructuralCurveConnection;
  class IfcStructuralCurveMember extends IfcStructuralMember {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Axis) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.PredefinedType = PredefinedType;
      this.Axis = Axis;
      this.type = 214636428;
    }
  }
  IFC4X32.IfcStructuralCurveMember = IfcStructuralCurveMember;
  class IfcStructuralCurveMemberVarying extends IfcStructuralCurveMember {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Axis) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Axis);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.PredefinedType = PredefinedType;
      this.Axis = Axis;
      this.type = 2445595289;
    }
  }
  IFC4X32.IfcStructuralCurveMemberVarying = IfcStructuralCurveMemberVarying;
  class IfcStructuralCurveReaction extends IfcStructuralReaction {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.PredefinedType = PredefinedType;
      this.type = 2757150158;
    }
  }
  IFC4X32.IfcStructuralCurveReaction = IfcStructuralCurveReaction;
  class IfcStructuralLinearAction extends IfcStructuralCurveAction {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.DestabilizingLoad = DestabilizingLoad;
      this.ProjectedOrTrue = ProjectedOrTrue;
      this.PredefinedType = PredefinedType;
      this.type = 1807405624;
    }
  }
  IFC4X32.IfcStructuralLinearAction = IfcStructuralLinearAction;
  class IfcStructuralLoadGroup extends IfcGroup {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, ActionType, ActionSource, Coefficient, Purpose) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.PredefinedType = PredefinedType;
      this.ActionType = ActionType;
      this.ActionSource = ActionSource;
      this.Coefficient = Coefficient;
      this.Purpose = Purpose;
      this.type = 1252848954;
    }
  }
  IFC4X32.IfcStructuralLoadGroup = IfcStructuralLoadGroup;
  class IfcStructuralPointAction extends IfcStructuralAction {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.DestabilizingLoad = DestabilizingLoad;
      this.type = 2082059205;
    }
  }
  IFC4X32.IfcStructuralPointAction = IfcStructuralPointAction;
  class IfcStructuralPointConnection extends IfcStructuralConnection {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition, ConditionCoordinateSystem) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedCondition = AppliedCondition;
      this.ConditionCoordinateSystem = ConditionCoordinateSystem;
      this.type = 734778138;
    }
  }
  IFC4X32.IfcStructuralPointConnection = IfcStructuralPointConnection;
  class IfcStructuralPointReaction extends IfcStructuralReaction {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.type = 1235345126;
    }
  }
  IFC4X32.IfcStructuralPointReaction = IfcStructuralPointReaction;
  class IfcStructuralResultGroup extends IfcGroup {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, TheoryType, ResultForLoadGroup, IsLinear) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.TheoryType = TheoryType;
      this.ResultForLoadGroup = ResultForLoadGroup;
      this.IsLinear = IsLinear;
      this.type = 2986769608;
    }
  }
  IFC4X32.IfcStructuralResultGroup = IfcStructuralResultGroup;
  class IfcStructuralSurfaceAction extends IfcStructuralAction {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.DestabilizingLoad = DestabilizingLoad;
      this.ProjectedOrTrue = ProjectedOrTrue;
      this.PredefinedType = PredefinedType;
      this.type = 3657597509;
    }
  }
  IFC4X32.IfcStructuralSurfaceAction = IfcStructuralSurfaceAction;
  class IfcStructuralSurfaceConnection extends IfcStructuralConnection {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedCondition = AppliedCondition;
      this.type = 1975003073;
    }
  }
  IFC4X32.IfcStructuralSurfaceConnection = IfcStructuralSurfaceConnection;
  class IfcSubContractResource extends IfcConstructionResource {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.Usage = Usage;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 148013059;
    }
  }
  IFC4X32.IfcSubContractResource = IfcSubContractResource;
  class IfcSurfaceFeature extends IfcFeatureElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3101698114;
    }
  }
  IFC4X32.IfcSurfaceFeature = IfcSurfaceFeature;
  class IfcSwitchingDeviceType extends IfcFlowControllerType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2315554128;
    }
  }
  IFC4X32.IfcSwitchingDeviceType = IfcSwitchingDeviceType;
  class IfcSystem extends IfcGroup {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.type = 2254336722;
    }
  }
  IFC4X32.IfcSystem = IfcSystem;
  class IfcSystemFurnitureElement extends IfcFurnishingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 413509423;
    }
  }
  IFC4X32.IfcSystemFurnitureElement = IfcSystemFurnitureElement;
  class IfcTankType extends IfcFlowStorageDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 5716631;
    }
  }
  IFC4X32.IfcTankType = IfcTankType;
  class IfcTendon extends IfcReinforcingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, PredefinedType, NominalDiameter, CrossSectionArea, TensionForce, PreStress, FrictionCoefficient, AnchorageSlip, MinCurvatureRadius) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.SteelGrade = SteelGrade;
      this.PredefinedType = PredefinedType;
      this.NominalDiameter = NominalDiameter;
      this.CrossSectionArea = CrossSectionArea;
      this.TensionForce = TensionForce;
      this.PreStress = PreStress;
      this.FrictionCoefficient = FrictionCoefficient;
      this.AnchorageSlip = AnchorageSlip;
      this.MinCurvatureRadius = MinCurvatureRadius;
      this.type = 3824725483;
    }
  }
  IFC4X32.IfcTendon = IfcTendon;
  class IfcTendonAnchor extends IfcReinforcingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.SteelGrade = SteelGrade;
      this.PredefinedType = PredefinedType;
      this.type = 2347447852;
    }
  }
  IFC4X32.IfcTendonAnchor = IfcTendonAnchor;
  class IfcTendonAnchorType extends IfcReinforcingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3081323446;
    }
  }
  IFC4X32.IfcTendonAnchorType = IfcTendonAnchorType;
  class IfcTendonConduit extends IfcReinforcingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.SteelGrade = SteelGrade;
      this.PredefinedType = PredefinedType;
      this.type = 3663046924;
    }
  }
  IFC4X32.IfcTendonConduit = IfcTendonConduit;
  class IfcTendonConduitType extends IfcReinforcingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2281632017;
    }
  }
  IFC4X32.IfcTendonConduitType = IfcTendonConduitType;
  class IfcTendonType extends IfcReinforcingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, NominalDiameter, CrossSectionArea, SheathDiameter) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.NominalDiameter = NominalDiameter;
      this.CrossSectionArea = CrossSectionArea;
      this.SheathDiameter = SheathDiameter;
      this.type = 2415094496;
    }
  }
  IFC4X32.IfcTendonType = IfcTendonType;
  class IfcTrackElementType extends IfcBuiltElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 618700268;
    }
  }
  IFC4X32.IfcTrackElementType = IfcTrackElementType;
  class IfcTransformerType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1692211062;
    }
  }
  IFC4X32.IfcTransformerType = IfcTransformerType;
  class IfcTransportElementType extends IfcTransportationDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2097647324;
    }
  }
  IFC4X32.IfcTransportElementType = IfcTransportElementType;
  class IfcTransportationDevice extends IfcElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1953115116;
    }
  }
  IFC4X32.IfcTransportationDevice = IfcTransportationDevice;
  class IfcTrimmedCurve extends IfcBoundedCurve {
    constructor(BasisCurve, Trim1, Trim2, SenseAgreement, MasterRepresentation) {
      super();
      this.BasisCurve = BasisCurve;
      this.Trim1 = Trim1;
      this.Trim2 = Trim2;
      this.SenseAgreement = SenseAgreement;
      this.MasterRepresentation = MasterRepresentation;
      this.type = 3593883385;
    }
  }
  IFC4X32.IfcTrimmedCurve = IfcTrimmedCurve;
  class IfcTubeBundleType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1600972822;
    }
  }
  IFC4X32.IfcTubeBundleType = IfcTubeBundleType;
  class IfcUnitaryEquipmentType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1911125066;
    }
  }
  IFC4X32.IfcUnitaryEquipmentType = IfcUnitaryEquipmentType;
  class IfcValveType extends IfcFlowControllerType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 728799441;
    }
  }
  IFC4X32.IfcValveType = IfcValveType;
  class IfcVehicle extends IfcTransportationDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 840318589;
    }
  }
  IFC4X32.IfcVehicle = IfcVehicle;
  class IfcVibrationDamper extends IfcElementComponent {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1530820697;
    }
  }
  IFC4X32.IfcVibrationDamper = IfcVibrationDamper;
  class IfcVibrationDamperType extends IfcElementComponentType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3956297820;
    }
  }
  IFC4X32.IfcVibrationDamperType = IfcVibrationDamperType;
  class IfcVibrationIsolator extends IfcElementComponent {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2391383451;
    }
  }
  IFC4X32.IfcVibrationIsolator = IfcVibrationIsolator;
  class IfcVibrationIsolatorType extends IfcElementComponentType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3313531582;
    }
  }
  IFC4X32.IfcVibrationIsolatorType = IfcVibrationIsolatorType;
  class IfcVirtualElement extends IfcElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2769231204;
    }
  }
  IFC4X32.IfcVirtualElement = IfcVirtualElement;
  class IfcVoidingFeature extends IfcFeatureElementSubtraction {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 926996030;
    }
  }
  IFC4X32.IfcVoidingFeature = IfcVoidingFeature;
  class IfcWallType extends IfcBuiltElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1898987631;
    }
  }
  IFC4X32.IfcWallType = IfcWallType;
  class IfcWasteTerminalType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1133259667;
    }
  }
  IFC4X32.IfcWasteTerminalType = IfcWasteTerminalType;
  class IfcWindowType extends IfcBuiltElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, PartitioningType, ParameterTakesPrecedence, UserDefinedPartitioningType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.PartitioningType = PartitioningType;
      this.ParameterTakesPrecedence = ParameterTakesPrecedence;
      this.UserDefinedPartitioningType = UserDefinedPartitioningType;
      this.type = 4009809668;
    }
  }
  IFC4X32.IfcWindowType = IfcWindowType;
  class IfcWorkCalendar extends IfcControl {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, WorkingTimes, ExceptionTimes, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.WorkingTimes = WorkingTimes;
      this.ExceptionTimes = ExceptionTimes;
      this.PredefinedType = PredefinedType;
      this.type = 4088093105;
    }
  }
  IFC4X32.IfcWorkCalendar = IfcWorkCalendar;
  class IfcWorkControl extends IfcControl {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.CreationDate = CreationDate;
      this.Creators = Creators;
      this.Purpose = Purpose;
      this.Duration = Duration;
      this.TotalFloat = TotalFloat;
      this.StartTime = StartTime;
      this.FinishTime = FinishTime;
      this.type = 1028945134;
    }
  }
  IFC4X32.IfcWorkControl = IfcWorkControl;
  class IfcWorkPlan extends IfcWorkControl {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.CreationDate = CreationDate;
      this.Creators = Creators;
      this.Purpose = Purpose;
      this.Duration = Duration;
      this.TotalFloat = TotalFloat;
      this.StartTime = StartTime;
      this.FinishTime = FinishTime;
      this.PredefinedType = PredefinedType;
      this.type = 4218914973;
    }
  }
  IFC4X32.IfcWorkPlan = IfcWorkPlan;
  class IfcWorkSchedule extends IfcWorkControl {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.CreationDate = CreationDate;
      this.Creators = Creators;
      this.Purpose = Purpose;
      this.Duration = Duration;
      this.TotalFloat = TotalFloat;
      this.StartTime = StartTime;
      this.FinishTime = FinishTime;
      this.PredefinedType = PredefinedType;
      this.type = 3342526732;
    }
  }
  IFC4X32.IfcWorkSchedule = IfcWorkSchedule;
  class IfcZone extends IfcSystem {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, LongName) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.LongName = LongName;
      this.type = 1033361043;
    }
  }
  IFC4X32.IfcZone = IfcZone;
  class IfcActionRequest extends IfcControl {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, Status, LongDescription) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.PredefinedType = PredefinedType;
      this.Status = Status;
      this.LongDescription = LongDescription;
      this.type = 3821786052;
    }
  }
  IFC4X32.IfcActionRequest = IfcActionRequest;
  class IfcAirTerminalBoxType extends IfcFlowControllerType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1411407467;
    }
  }
  IFC4X32.IfcAirTerminalBoxType = IfcAirTerminalBoxType;
  class IfcAirTerminalType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3352864051;
    }
  }
  IFC4X32.IfcAirTerminalType = IfcAirTerminalType;
  class IfcAirToAirHeatRecoveryType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1871374353;
    }
  }
  IFC4X32.IfcAirToAirHeatRecoveryType = IfcAirToAirHeatRecoveryType;
  class IfcAlignmentCant extends IfcLinearElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, RailHeadDistance) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.RailHeadDistance = RailHeadDistance;
      this.type = 4266260250;
    }
  }
  IFC4X32.IfcAlignmentCant = IfcAlignmentCant;
  class IfcAlignmentHorizontal extends IfcLinearElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.type = 1545765605;
    }
  }
  IFC4X32.IfcAlignmentHorizontal = IfcAlignmentHorizontal;
  class IfcAlignmentSegment extends IfcLinearElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, DesignParameters) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.DesignParameters = DesignParameters;
      this.type = 317615605;
    }
  }
  IFC4X32.IfcAlignmentSegment = IfcAlignmentSegment;
  class IfcAlignmentVertical extends IfcLinearElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.type = 1662888072;
    }
  }
  IFC4X32.IfcAlignmentVertical = IfcAlignmentVertical;
  class IfcAsset extends IfcGroup {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, OriginalValue, CurrentValue, TotalReplacementCost, Owner, User, ResponsiblePerson, IncorporationDate, DepreciatedValue) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.OriginalValue = OriginalValue;
      this.CurrentValue = CurrentValue;
      this.TotalReplacementCost = TotalReplacementCost;
      this.Owner = Owner;
      this.User = User;
      this.ResponsiblePerson = ResponsiblePerson;
      this.IncorporationDate = IncorporationDate;
      this.DepreciatedValue = DepreciatedValue;
      this.type = 3460190687;
    }
  }
  IFC4X32.IfcAsset = IfcAsset;
  class IfcAudioVisualApplianceType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1532957894;
    }
  }
  IFC4X32.IfcAudioVisualApplianceType = IfcAudioVisualApplianceType;
  class IfcBSplineCurve extends IfcBoundedCurve {
    constructor(Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect) {
      super();
      this.Degree = Degree;
      this.ControlPointsList = ControlPointsList;
      this.CurveForm = CurveForm;
      this.ClosedCurve = ClosedCurve;
      this.SelfIntersect = SelfIntersect;
      this.type = 1967976161;
    }
  }
  IFC4X32.IfcBSplineCurve = IfcBSplineCurve;
  class IfcBSplineCurveWithKnots extends IfcBSplineCurve {
    constructor(Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect, KnotMultiplicities, Knots, KnotSpec) {
      super(Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect);
      this.Degree = Degree;
      this.ControlPointsList = ControlPointsList;
      this.CurveForm = CurveForm;
      this.ClosedCurve = ClosedCurve;
      this.SelfIntersect = SelfIntersect;
      this.KnotMultiplicities = KnotMultiplicities;
      this.Knots = Knots;
      this.KnotSpec = KnotSpec;
      this.type = 2461110595;
    }
  }
  IFC4X32.IfcBSplineCurveWithKnots = IfcBSplineCurveWithKnots;
  class IfcBeamType extends IfcBuiltElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 819618141;
    }
  }
  IFC4X32.IfcBeamType = IfcBeamType;
  class IfcBearingType extends IfcBuiltElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3649138523;
    }
  }
  IFC4X32.IfcBearingType = IfcBearingType;
  class IfcBoilerType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 231477066;
    }
  }
  IFC4X32.IfcBoilerType = IfcBoilerType;
  class IfcBoundaryCurve extends IfcCompositeCurveOnSurface {
    constructor(Segments, SelfIntersect) {
      super(Segments, SelfIntersect);
      this.Segments = Segments;
      this.SelfIntersect = SelfIntersect;
      this.type = 1136057603;
    }
  }
  IFC4X32.IfcBoundaryCurve = IfcBoundaryCurve;
  class IfcBridge extends IfcFacility {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.PredefinedType = PredefinedType;
      this.type = 644574406;
    }
  }
  IFC4X32.IfcBridge = IfcBridge;
  class IfcBridgePart extends IfcFacilityPart {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.UsageType = UsageType;
      this.PredefinedType = PredefinedType;
      this.type = 963979645;
    }
  }
  IFC4X32.IfcBridgePart = IfcBridgePart;
  class IfcBuilding extends IfcFacility {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, ElevationOfRefHeight, ElevationOfTerrain, BuildingAddress) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.ElevationOfRefHeight = ElevationOfRefHeight;
      this.ElevationOfTerrain = ElevationOfTerrain;
      this.BuildingAddress = BuildingAddress;
      this.type = 4031249490;
    }
  }
  IFC4X32.IfcBuilding = IfcBuilding;
  class IfcBuildingElementPart extends IfcElementComponent {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2979338954;
    }
  }
  IFC4X32.IfcBuildingElementPart = IfcBuildingElementPart;
  class IfcBuildingElementPartType extends IfcElementComponentType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 39481116;
    }
  }
  IFC4X32.IfcBuildingElementPartType = IfcBuildingElementPartType;
  class IfcBuildingElementProxyType extends IfcBuiltElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1909888760;
    }
  }
  IFC4X32.IfcBuildingElementProxyType = IfcBuildingElementProxyType;
  class IfcBuildingSystem extends IfcSystem {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, LongName) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.PredefinedType = PredefinedType;
      this.LongName = LongName;
      this.type = 1177604601;
    }
  }
  IFC4X32.IfcBuildingSystem = IfcBuildingSystem;
  class IfcBuiltElement extends IfcElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1876633798;
    }
  }
  IFC4X32.IfcBuiltElement = IfcBuiltElement;
  class IfcBuiltSystem extends IfcSystem {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, LongName) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.PredefinedType = PredefinedType;
      this.LongName = LongName;
      this.type = 3862327254;
    }
  }
  IFC4X32.IfcBuiltSystem = IfcBuiltSystem;
  class IfcBurnerType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2188180465;
    }
  }
  IFC4X32.IfcBurnerType = IfcBurnerType;
  class IfcCableCarrierFittingType extends IfcFlowFittingType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 395041908;
    }
  }
  IFC4X32.IfcCableCarrierFittingType = IfcCableCarrierFittingType;
  class IfcCableCarrierSegmentType extends IfcFlowSegmentType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3293546465;
    }
  }
  IFC4X32.IfcCableCarrierSegmentType = IfcCableCarrierSegmentType;
  class IfcCableFittingType extends IfcFlowFittingType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2674252688;
    }
  }
  IFC4X32.IfcCableFittingType = IfcCableFittingType;
  class IfcCableSegmentType extends IfcFlowSegmentType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1285652485;
    }
  }
  IFC4X32.IfcCableSegmentType = IfcCableSegmentType;
  class IfcCaissonFoundationType extends IfcDeepFoundationType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3203706013;
    }
  }
  IFC4X32.IfcCaissonFoundationType = IfcCaissonFoundationType;
  class IfcChillerType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2951183804;
    }
  }
  IFC4X32.IfcChillerType = IfcChillerType;
  class IfcChimney extends IfcBuiltElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3296154744;
    }
  }
  IFC4X32.IfcChimney = IfcChimney;
  class IfcCircle extends IfcConic {
    constructor(Position, Radius) {
      super(Position);
      this.Position = Position;
      this.Radius = Radius;
      this.type = 2611217952;
    }
  }
  IFC4X32.IfcCircle = IfcCircle;
  class IfcCivilElement extends IfcElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1677625105;
    }
  }
  IFC4X32.IfcCivilElement = IfcCivilElement;
  class IfcCoilType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2301859152;
    }
  }
  IFC4X32.IfcCoilType = IfcCoilType;
  class IfcColumn extends IfcBuiltElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 843113511;
    }
  }
  IFC4X32.IfcColumn = IfcColumn;
  class IfcCommunicationsApplianceType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 400855858;
    }
  }
  IFC4X32.IfcCommunicationsApplianceType = IfcCommunicationsApplianceType;
  class IfcCompressorType extends IfcFlowMovingDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3850581409;
    }
  }
  IFC4X32.IfcCompressorType = IfcCompressorType;
  class IfcCondenserType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2816379211;
    }
  }
  IFC4X32.IfcCondenserType = IfcCondenserType;
  class IfcConstructionEquipmentResource extends IfcConstructionResource {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.Usage = Usage;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 3898045240;
    }
  }
  IFC4X32.IfcConstructionEquipmentResource = IfcConstructionEquipmentResource;
  class IfcConstructionMaterialResource extends IfcConstructionResource {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.Usage = Usage;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 1060000209;
    }
  }
  IFC4X32.IfcConstructionMaterialResource = IfcConstructionMaterialResource;
  class IfcConstructionProductResource extends IfcConstructionResource {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.Usage = Usage;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 488727124;
    }
  }
  IFC4X32.IfcConstructionProductResource = IfcConstructionProductResource;
  class IfcConveyorSegmentType extends IfcFlowSegmentType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2940368186;
    }
  }
  IFC4X32.IfcConveyorSegmentType = IfcConveyorSegmentType;
  class IfcCooledBeamType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 335055490;
    }
  }
  IFC4X32.IfcCooledBeamType = IfcCooledBeamType;
  class IfcCoolingTowerType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2954562838;
    }
  }
  IFC4X32.IfcCoolingTowerType = IfcCoolingTowerType;
  class IfcCourse extends IfcBuiltElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1502416096;
    }
  }
  IFC4X32.IfcCourse = IfcCourse;
  class IfcCovering extends IfcBuiltElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1973544240;
    }
  }
  IFC4X32.IfcCovering = IfcCovering;
  class IfcCurtainWall extends IfcBuiltElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3495092785;
    }
  }
  IFC4X32.IfcCurtainWall = IfcCurtainWall;
  class IfcDamperType extends IfcFlowControllerType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3961806047;
    }
  }
  IFC4X32.IfcDamperType = IfcDamperType;
  class IfcDeepFoundation extends IfcBuiltElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 3426335179;
    }
  }
  IFC4X32.IfcDeepFoundation = IfcDeepFoundation;
  class IfcDiscreteAccessory extends IfcElementComponent {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1335981549;
    }
  }
  IFC4X32.IfcDiscreteAccessory = IfcDiscreteAccessory;
  class IfcDiscreteAccessoryType extends IfcElementComponentType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2635815018;
    }
  }
  IFC4X32.IfcDiscreteAccessoryType = IfcDiscreteAccessoryType;
  class IfcDistributionBoardType extends IfcFlowControllerType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 479945903;
    }
  }
  IFC4X32.IfcDistributionBoardType = IfcDistributionBoardType;
  class IfcDistributionChamberElementType extends IfcDistributionFlowElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1599208980;
    }
  }
  IFC4X32.IfcDistributionChamberElementType = IfcDistributionChamberElementType;
  class IfcDistributionControlElementType extends IfcDistributionElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 2063403501;
    }
  }
  IFC4X32.IfcDistributionControlElementType = IfcDistributionControlElementType;
  class IfcDistributionElement extends IfcElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1945004755;
    }
  }
  IFC4X32.IfcDistributionElement = IfcDistributionElement;
  class IfcDistributionFlowElement extends IfcDistributionElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 3040386961;
    }
  }
  IFC4X32.IfcDistributionFlowElement = IfcDistributionFlowElement;
  class IfcDistributionPort extends IfcPort {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, FlowDirection, PredefinedType, SystemType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.FlowDirection = FlowDirection;
      this.PredefinedType = PredefinedType;
      this.SystemType = SystemType;
      this.type = 3041715199;
    }
  }
  IFC4X32.IfcDistributionPort = IfcDistributionPort;
  class IfcDistributionSystem extends IfcSystem {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.LongName = LongName;
      this.PredefinedType = PredefinedType;
      this.type = 3205830791;
    }
  }
  IFC4X32.IfcDistributionSystem = IfcDistributionSystem;
  class IfcDoor extends IfcBuiltElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth, PredefinedType, OperationType, UserDefinedOperationType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.OverallHeight = OverallHeight;
      this.OverallWidth = OverallWidth;
      this.PredefinedType = PredefinedType;
      this.OperationType = OperationType;
      this.UserDefinedOperationType = UserDefinedOperationType;
      this.type = 395920057;
    }
  }
  IFC4X32.IfcDoor = IfcDoor;
  class IfcDuctFittingType extends IfcFlowFittingType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 869906466;
    }
  }
  IFC4X32.IfcDuctFittingType = IfcDuctFittingType;
  class IfcDuctSegmentType extends IfcFlowSegmentType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3760055223;
    }
  }
  IFC4X32.IfcDuctSegmentType = IfcDuctSegmentType;
  class IfcDuctSilencerType extends IfcFlowTreatmentDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2030761528;
    }
  }
  IFC4X32.IfcDuctSilencerType = IfcDuctSilencerType;
  class IfcEarthworksCut extends IfcFeatureElementSubtraction {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3071239417;
    }
  }
  IFC4X32.IfcEarthworksCut = IfcEarthworksCut;
  class IfcEarthworksElement extends IfcBuiltElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1077100507;
    }
  }
  IFC4X32.IfcEarthworksElement = IfcEarthworksElement;
  class IfcEarthworksFill extends IfcEarthworksElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3376911765;
    }
  }
  IFC4X32.IfcEarthworksFill = IfcEarthworksFill;
  class IfcElectricApplianceType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 663422040;
    }
  }
  IFC4X32.IfcElectricApplianceType = IfcElectricApplianceType;
  class IfcElectricDistributionBoardType extends IfcFlowControllerType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2417008758;
    }
  }
  IFC4X32.IfcElectricDistributionBoardType = IfcElectricDistributionBoardType;
  class IfcElectricFlowStorageDeviceType extends IfcFlowStorageDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3277789161;
    }
  }
  IFC4X32.IfcElectricFlowStorageDeviceType = IfcElectricFlowStorageDeviceType;
  class IfcElectricFlowTreatmentDeviceType extends IfcFlowTreatmentDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2142170206;
    }
  }
  IFC4X32.IfcElectricFlowTreatmentDeviceType = IfcElectricFlowTreatmentDeviceType;
  class IfcElectricGeneratorType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1534661035;
    }
  }
  IFC4X32.IfcElectricGeneratorType = IfcElectricGeneratorType;
  class IfcElectricMotorType extends IfcEnergyConversionDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1217240411;
    }
  }
  IFC4X32.IfcElectricMotorType = IfcElectricMotorType;
  class IfcElectricTimeControlType extends IfcFlowControllerType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 712377611;
    }
  }
  IFC4X32.IfcElectricTimeControlType = IfcElectricTimeControlType;
  class IfcEnergyConversionDevice extends IfcDistributionFlowElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1658829314;
    }
  }
  IFC4X32.IfcEnergyConversionDevice = IfcEnergyConversionDevice;
  class IfcEngine extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2814081492;
    }
  }
  IFC4X32.IfcEngine = IfcEngine;
  class IfcEvaporativeCooler extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3747195512;
    }
  }
  IFC4X32.IfcEvaporativeCooler = IfcEvaporativeCooler;
  class IfcEvaporator extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 484807127;
    }
  }
  IFC4X32.IfcEvaporator = IfcEvaporator;
  class IfcExternalSpatialElement extends IfcExternalSpatialStructureElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.PredefinedType = PredefinedType;
      this.type = 1209101575;
    }
  }
  IFC4X32.IfcExternalSpatialElement = IfcExternalSpatialElement;
  class IfcFanType extends IfcFlowMovingDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 346874300;
    }
  }
  IFC4X32.IfcFanType = IfcFanType;
  class IfcFilterType extends IfcFlowTreatmentDeviceType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1810631287;
    }
  }
  IFC4X32.IfcFilterType = IfcFilterType;
  class IfcFireSuppressionTerminalType extends IfcFlowTerminalType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4222183408;
    }
  }
  IFC4X32.IfcFireSuppressionTerminalType = IfcFireSuppressionTerminalType;
  class IfcFlowController extends IfcDistributionFlowElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 2058353004;
    }
  }
  IFC4X32.IfcFlowController = IfcFlowController;
  class IfcFlowFitting extends IfcDistributionFlowElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 4278956645;
    }
  }
  IFC4X32.IfcFlowFitting = IfcFlowFitting;
  class IfcFlowInstrumentType extends IfcDistributionControlElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4037862832;
    }
  }
  IFC4X32.IfcFlowInstrumentType = IfcFlowInstrumentType;
  class IfcFlowMeter extends IfcFlowController {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2188021234;
    }
  }
  IFC4X32.IfcFlowMeter = IfcFlowMeter;
  class IfcFlowMovingDevice extends IfcDistributionFlowElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 3132237377;
    }
  }
  IFC4X32.IfcFlowMovingDevice = IfcFlowMovingDevice;
  class IfcFlowSegment extends IfcDistributionFlowElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 987401354;
    }
  }
  IFC4X32.IfcFlowSegment = IfcFlowSegment;
  class IfcFlowStorageDevice extends IfcDistributionFlowElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 707683696;
    }
  }
  IFC4X32.IfcFlowStorageDevice = IfcFlowStorageDevice;
  class IfcFlowTerminal extends IfcDistributionFlowElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 2223149337;
    }
  }
  IFC4X32.IfcFlowTerminal = IfcFlowTerminal;
  class IfcFlowTreatmentDevice extends IfcDistributionFlowElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 3508470533;
    }
  }
  IFC4X32.IfcFlowTreatmentDevice = IfcFlowTreatmentDevice;
  class IfcFooting extends IfcBuiltElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 900683007;
    }
  }
  IFC4X32.IfcFooting = IfcFooting;
  class IfcGeotechnicalAssembly extends IfcGeotechnicalElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 2713699986;
    }
  }
  IFC4X32.IfcGeotechnicalAssembly = IfcGeotechnicalAssembly;
  class IfcGrid extends IfcPositioningElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, UAxes, VAxes, WAxes, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.UAxes = UAxes;
      this.VAxes = VAxes;
      this.WAxes = WAxes;
      this.PredefinedType = PredefinedType;
      this.type = 3009204131;
    }
  }
  IFC4X32.IfcGrid = IfcGrid;
  class IfcHeatExchanger extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3319311131;
    }
  }
  IFC4X32.IfcHeatExchanger = IfcHeatExchanger;
  class IfcHumidifier extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2068733104;
    }
  }
  IFC4X32.IfcHumidifier = IfcHumidifier;
  class IfcInterceptor extends IfcFlowTreatmentDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4175244083;
    }
  }
  IFC4X32.IfcInterceptor = IfcInterceptor;
  class IfcJunctionBox extends IfcFlowFitting {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2176052936;
    }
  }
  IFC4X32.IfcJunctionBox = IfcJunctionBox;
  class IfcKerb extends IfcBuiltElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, Mountable) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.Mountable = Mountable;
      this.type = 2696325953;
    }
  }
  IFC4X32.IfcKerb = IfcKerb;
  class IfcLamp extends IfcFlowTerminal {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 76236018;
    }
  }
  IFC4X32.IfcLamp = IfcLamp;
  class IfcLightFixture extends IfcFlowTerminal {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 629592764;
    }
  }
  IFC4X32.IfcLightFixture = IfcLightFixture;
  class IfcLinearPositioningElement extends IfcPositioningElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.type = 1154579445;
    }
  }
  IFC4X32.IfcLinearPositioningElement = IfcLinearPositioningElement;
  class IfcLiquidTerminal extends IfcFlowTerminal {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1638804497;
    }
  }
  IFC4X32.IfcLiquidTerminal = IfcLiquidTerminal;
  class IfcMedicalDevice extends IfcFlowTerminal {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1437502449;
    }
  }
  IFC4X32.IfcMedicalDevice = IfcMedicalDevice;
  class IfcMember extends IfcBuiltElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1073191201;
    }
  }
  IFC4X32.IfcMember = IfcMember;
  class IfcMobileTelecommunicationsAppliance extends IfcFlowTerminal {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2078563270;
    }
  }
  IFC4X32.IfcMobileTelecommunicationsAppliance = IfcMobileTelecommunicationsAppliance;
  class IfcMooringDevice extends IfcBuiltElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 234836483;
    }
  }
  IFC4X32.IfcMooringDevice = IfcMooringDevice;
  class IfcMotorConnection extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2474470126;
    }
  }
  IFC4X32.IfcMotorConnection = IfcMotorConnection;
  class IfcNavigationElement extends IfcBuiltElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2182337498;
    }
  }
  IFC4X32.IfcNavigationElement = IfcNavigationElement;
  class IfcOuterBoundaryCurve extends IfcBoundaryCurve {
    constructor(Segments, SelfIntersect) {
      super(Segments, SelfIntersect);
      this.Segments = Segments;
      this.SelfIntersect = SelfIntersect;
      this.type = 144952367;
    }
  }
  IFC4X32.IfcOuterBoundaryCurve = IfcOuterBoundaryCurve;
  class IfcOutlet extends IfcFlowTerminal {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3694346114;
    }
  }
  IFC4X32.IfcOutlet = IfcOutlet;
  class IfcPavement extends IfcBuiltElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1383356374;
    }
  }
  IFC4X32.IfcPavement = IfcPavement;
  class IfcPile extends IfcDeepFoundation {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType, ConstructionType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.ConstructionType = ConstructionType;
      this.type = 1687234759;
    }
  }
  IFC4X32.IfcPile = IfcPile;
  class IfcPipeFitting extends IfcFlowFitting {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 310824031;
    }
  }
  IFC4X32.IfcPipeFitting = IfcPipeFitting;
  class IfcPipeSegment extends IfcFlowSegment {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3612865200;
    }
  }
  IFC4X32.IfcPipeSegment = IfcPipeSegment;
  class IfcPlate extends IfcBuiltElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3171933400;
    }
  }
  IFC4X32.IfcPlate = IfcPlate;
  class IfcProtectiveDevice extends IfcFlowController {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 738039164;
    }
  }
  IFC4X32.IfcProtectiveDevice = IfcProtectiveDevice;
  class IfcProtectiveDeviceTrippingUnitType extends IfcDistributionControlElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 655969474;
    }
  }
  IFC4X32.IfcProtectiveDeviceTrippingUnitType = IfcProtectiveDeviceTrippingUnitType;
  class IfcPump extends IfcFlowMovingDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 90941305;
    }
  }
  IFC4X32.IfcPump = IfcPump;
  class IfcRail extends IfcBuiltElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3290496277;
    }
  }
  IFC4X32.IfcRail = IfcRail;
  class IfcRailing extends IfcBuiltElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2262370178;
    }
  }
  IFC4X32.IfcRailing = IfcRailing;
  class IfcRamp extends IfcBuiltElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3024970846;
    }
  }
  IFC4X32.IfcRamp = IfcRamp;
  class IfcRampFlight extends IfcBuiltElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3283111854;
    }
  }
  IFC4X32.IfcRampFlight = IfcRampFlight;
  class IfcRationalBSplineCurveWithKnots extends IfcBSplineCurveWithKnots {
    constructor(Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect, KnotMultiplicities, Knots, KnotSpec, WeightsData) {
      super(Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect, KnotMultiplicities, Knots, KnotSpec);
      this.Degree = Degree;
      this.ControlPointsList = ControlPointsList;
      this.CurveForm = CurveForm;
      this.ClosedCurve = ClosedCurve;
      this.SelfIntersect = SelfIntersect;
      this.KnotMultiplicities = KnotMultiplicities;
      this.Knots = Knots;
      this.KnotSpec = KnotSpec;
      this.WeightsData = WeightsData;
      this.type = 1232101972;
    }
  }
  IFC4X32.IfcRationalBSplineCurveWithKnots = IfcRationalBSplineCurveWithKnots;
  class IfcReinforcedSoil extends IfcEarthworksElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3798194928;
    }
  }
  IFC4X32.IfcReinforcedSoil = IfcReinforcedSoil;
  class IfcReinforcingBar extends IfcReinforcingElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, NominalDiameter, CrossSectionArea, BarLength, PredefinedType, BarSurface) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.SteelGrade = SteelGrade;
      this.NominalDiameter = NominalDiameter;
      this.CrossSectionArea = CrossSectionArea;
      this.BarLength = BarLength;
      this.PredefinedType = PredefinedType;
      this.BarSurface = BarSurface;
      this.type = 979691226;
    }
  }
  IFC4X32.IfcReinforcingBar = IfcReinforcingBar;
  class IfcReinforcingBarType extends IfcReinforcingElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, NominalDiameter, CrossSectionArea, BarLength, BarSurface, BendingShapeCode, BendingParameters) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.NominalDiameter = NominalDiameter;
      this.CrossSectionArea = CrossSectionArea;
      this.BarLength = BarLength;
      this.BarSurface = BarSurface;
      this.BendingShapeCode = BendingShapeCode;
      this.BendingParameters = BendingParameters;
      this.type = 2572171363;
    }
  }
  IFC4X32.IfcReinforcingBarType = IfcReinforcingBarType;
  class IfcRoof extends IfcBuiltElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2016517767;
    }
  }
  IFC4X32.IfcRoof = IfcRoof;
  class IfcSanitaryTerminal extends IfcFlowTerminal {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3053780830;
    }
  }
  IFC4X32.IfcSanitaryTerminal = IfcSanitaryTerminal;
  class IfcSensorType extends IfcDistributionControlElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1783015770;
    }
  }
  IFC4X32.IfcSensorType = IfcSensorType;
  class IfcShadingDevice extends IfcBuiltElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1329646415;
    }
  }
  IFC4X32.IfcShadingDevice = IfcShadingDevice;
  class IfcSignal extends IfcFlowTerminal {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 991950508;
    }
  }
  IFC4X32.IfcSignal = IfcSignal;
  class IfcSlab extends IfcBuiltElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1529196076;
    }
  }
  IFC4X32.IfcSlab = IfcSlab;
  class IfcSolarDevice extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3420628829;
    }
  }
  IFC4X32.IfcSolarDevice = IfcSolarDevice;
  class IfcSpaceHeater extends IfcFlowTerminal {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1999602285;
    }
  }
  IFC4X32.IfcSpaceHeater = IfcSpaceHeater;
  class IfcStackTerminal extends IfcFlowTerminal {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1404847402;
    }
  }
  IFC4X32.IfcStackTerminal = IfcStackTerminal;
  class IfcStair extends IfcBuiltElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 331165859;
    }
  }
  IFC4X32.IfcStair = IfcStair;
  class IfcStairFlight extends IfcBuiltElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, NumberOfRisers, NumberOfTreads, RiserHeight, TreadLength, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.NumberOfRisers = NumberOfRisers;
      this.NumberOfTreads = NumberOfTreads;
      this.RiserHeight = RiserHeight;
      this.TreadLength = TreadLength;
      this.PredefinedType = PredefinedType;
      this.type = 4252922144;
    }
  }
  IFC4X32.IfcStairFlight = IfcStairFlight;
  class IfcStructuralAnalysisModel extends IfcSystem {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, OrientationOf2DPlane, LoadedBy, HasResults, SharedPlacement) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.PredefinedType = PredefinedType;
      this.OrientationOf2DPlane = OrientationOf2DPlane;
      this.LoadedBy = LoadedBy;
      this.HasResults = HasResults;
      this.SharedPlacement = SharedPlacement;
      this.type = 2515109513;
    }
  }
  IFC4X32.IfcStructuralAnalysisModel = IfcStructuralAnalysisModel;
  class IfcStructuralLoadCase extends IfcStructuralLoadGroup {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, ActionType, ActionSource, Coefficient, Purpose, SelfWeightCoefficients) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, ActionType, ActionSource, Coefficient, Purpose);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.PredefinedType = PredefinedType;
      this.ActionType = ActionType;
      this.ActionSource = ActionSource;
      this.Coefficient = Coefficient;
      this.Purpose = Purpose;
      this.SelfWeightCoefficients = SelfWeightCoefficients;
      this.type = 385403989;
    }
  }
  IFC4X32.IfcStructuralLoadCase = IfcStructuralLoadCase;
  class IfcStructuralPlanarAction extends IfcStructuralSurfaceAction {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.DestabilizingLoad = DestabilizingLoad;
      this.ProjectedOrTrue = ProjectedOrTrue;
      this.PredefinedType = PredefinedType;
      this.type = 1621171031;
    }
  }
  IFC4X32.IfcStructuralPlanarAction = IfcStructuralPlanarAction;
  class IfcSwitchingDevice extends IfcFlowController {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1162798199;
    }
  }
  IFC4X32.IfcSwitchingDevice = IfcSwitchingDevice;
  class IfcTank extends IfcFlowStorageDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 812556717;
    }
  }
  IFC4X32.IfcTank = IfcTank;
  class IfcTrackElement extends IfcBuiltElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3425753595;
    }
  }
  IFC4X32.IfcTrackElement = IfcTrackElement;
  class IfcTransformer extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3825984169;
    }
  }
  IFC4X32.IfcTransformer = IfcTransformer;
  class IfcTransportElement extends IfcTransportationDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1620046519;
    }
  }
  IFC4X32.IfcTransportElement = IfcTransportElement;
  class IfcTubeBundle extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3026737570;
    }
  }
  IFC4X32.IfcTubeBundle = IfcTubeBundle;
  class IfcUnitaryControlElementType extends IfcDistributionControlElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3179687236;
    }
  }
  IFC4X32.IfcUnitaryControlElementType = IfcUnitaryControlElementType;
  class IfcUnitaryEquipment extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4292641817;
    }
  }
  IFC4X32.IfcUnitaryEquipment = IfcUnitaryEquipment;
  class IfcValve extends IfcFlowController {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4207607924;
    }
  }
  IFC4X32.IfcValve = IfcValve;
  class IfcWall extends IfcBuiltElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2391406946;
    }
  }
  IFC4X32.IfcWall = IfcWall;
  class IfcWallStandardCase extends IfcWall {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3512223829;
    }
  }
  IFC4X32.IfcWallStandardCase = IfcWallStandardCase;
  class IfcWasteTerminal extends IfcFlowTerminal {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4237592921;
    }
  }
  IFC4X32.IfcWasteTerminal = IfcWasteTerminal;
  class IfcWindow extends IfcBuiltElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth, PredefinedType, PartitioningType, UserDefinedPartitioningType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.OverallHeight = OverallHeight;
      this.OverallWidth = OverallWidth;
      this.PredefinedType = PredefinedType;
      this.PartitioningType = PartitioningType;
      this.UserDefinedPartitioningType = UserDefinedPartitioningType;
      this.type = 3304561284;
    }
  }
  IFC4X32.IfcWindow = IfcWindow;
  class IfcActuatorType extends IfcDistributionControlElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2874132201;
    }
  }
  IFC4X32.IfcActuatorType = IfcActuatorType;
  class IfcAirTerminal extends IfcFlowTerminal {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1634111441;
    }
  }
  IFC4X32.IfcAirTerminal = IfcAirTerminal;
  class IfcAirTerminalBox extends IfcFlowController {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 177149247;
    }
  }
  IFC4X32.IfcAirTerminalBox = IfcAirTerminalBox;
  class IfcAirToAirHeatRecovery extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2056796094;
    }
  }
  IFC4X32.IfcAirToAirHeatRecovery = IfcAirToAirHeatRecovery;
  class IfcAlarmType extends IfcDistributionControlElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3001207471;
    }
  }
  IFC4X32.IfcAlarmType = IfcAlarmType;
  class IfcAlignment extends IfcLinearPositioningElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.PredefinedType = PredefinedType;
      this.type = 325726236;
    }
  }
  IFC4X32.IfcAlignment = IfcAlignment;
  class IfcAudioVisualAppliance extends IfcFlowTerminal {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 277319702;
    }
  }
  IFC4X32.IfcAudioVisualAppliance = IfcAudioVisualAppliance;
  class IfcBeam extends IfcBuiltElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 753842376;
    }
  }
  IFC4X32.IfcBeam = IfcBeam;
  class IfcBearing extends IfcBuiltElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4196446775;
    }
  }
  IFC4X32.IfcBearing = IfcBearing;
  class IfcBoiler extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 32344328;
    }
  }
  IFC4X32.IfcBoiler = IfcBoiler;
  class IfcBorehole extends IfcGeotechnicalAssembly {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 3314249567;
    }
  }
  IFC4X32.IfcBorehole = IfcBorehole;
  class IfcBuildingElementProxy extends IfcBuiltElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1095909175;
    }
  }
  IFC4X32.IfcBuildingElementProxy = IfcBuildingElementProxy;
  class IfcBurner extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2938176219;
    }
  }
  IFC4X32.IfcBurner = IfcBurner;
  class IfcCableCarrierFitting extends IfcFlowFitting {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 635142910;
    }
  }
  IFC4X32.IfcCableCarrierFitting = IfcCableCarrierFitting;
  class IfcCableCarrierSegment extends IfcFlowSegment {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3758799889;
    }
  }
  IFC4X32.IfcCableCarrierSegment = IfcCableCarrierSegment;
  class IfcCableFitting extends IfcFlowFitting {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1051757585;
    }
  }
  IFC4X32.IfcCableFitting = IfcCableFitting;
  class IfcCableSegment extends IfcFlowSegment {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4217484030;
    }
  }
  IFC4X32.IfcCableSegment = IfcCableSegment;
  class IfcCaissonFoundation extends IfcDeepFoundation {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3999819293;
    }
  }
  IFC4X32.IfcCaissonFoundation = IfcCaissonFoundation;
  class IfcChiller extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3902619387;
    }
  }
  IFC4X32.IfcChiller = IfcChiller;
  class IfcCoil extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 639361253;
    }
  }
  IFC4X32.IfcCoil = IfcCoil;
  class IfcCommunicationsAppliance extends IfcFlowTerminal {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3221913625;
    }
  }
  IFC4X32.IfcCommunicationsAppliance = IfcCommunicationsAppliance;
  class IfcCompressor extends IfcFlowMovingDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3571504051;
    }
  }
  IFC4X32.IfcCompressor = IfcCompressor;
  class IfcCondenser extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2272882330;
    }
  }
  IFC4X32.IfcCondenser = IfcCondenser;
  class IfcControllerType extends IfcDistributionControlElementType {
    constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 578613899;
    }
  }
  IFC4X32.IfcControllerType = IfcControllerType;
  class IfcConveyorSegment extends IfcFlowSegment {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3460952963;
    }
  }
  IFC4X32.IfcConveyorSegment = IfcConveyorSegment;
  class IfcCooledBeam extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4136498852;
    }
  }
  IFC4X32.IfcCooledBeam = IfcCooledBeam;
  class IfcCoolingTower extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3640358203;
    }
  }
  IFC4X32.IfcCoolingTower = IfcCoolingTower;
  class IfcDamper extends IfcFlowController {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4074379575;
    }
  }
  IFC4X32.IfcDamper = IfcDamper;
  class IfcDistributionBoard extends IfcFlowController {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3693000487;
    }
  }
  IFC4X32.IfcDistributionBoard = IfcDistributionBoard;
  class IfcDistributionChamberElement extends IfcDistributionFlowElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1052013943;
    }
  }
  IFC4X32.IfcDistributionChamberElement = IfcDistributionChamberElement;
  class IfcDistributionCircuit extends IfcDistributionSystem {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, PredefinedType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.LongName = LongName;
      this.PredefinedType = PredefinedType;
      this.type = 562808652;
    }
  }
  IFC4X32.IfcDistributionCircuit = IfcDistributionCircuit;
  class IfcDistributionControlElement extends IfcDistributionElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1062813311;
    }
  }
  IFC4X32.IfcDistributionControlElement = IfcDistributionControlElement;
  class IfcDuctFitting extends IfcFlowFitting {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 342316401;
    }
  }
  IFC4X32.IfcDuctFitting = IfcDuctFitting;
  class IfcDuctSegment extends IfcFlowSegment {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3518393246;
    }
  }
  IFC4X32.IfcDuctSegment = IfcDuctSegment;
  class IfcDuctSilencer extends IfcFlowTreatmentDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1360408905;
    }
  }
  IFC4X32.IfcDuctSilencer = IfcDuctSilencer;
  class IfcElectricAppliance extends IfcFlowTerminal {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1904799276;
    }
  }
  IFC4X32.IfcElectricAppliance = IfcElectricAppliance;
  class IfcElectricDistributionBoard extends IfcFlowController {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 862014818;
    }
  }
  IFC4X32.IfcElectricDistributionBoard = IfcElectricDistributionBoard;
  class IfcElectricFlowStorageDevice extends IfcFlowStorageDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3310460725;
    }
  }
  IFC4X32.IfcElectricFlowStorageDevice = IfcElectricFlowStorageDevice;
  class IfcElectricFlowTreatmentDevice extends IfcFlowTreatmentDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 24726584;
    }
  }
  IFC4X32.IfcElectricFlowTreatmentDevice = IfcElectricFlowTreatmentDevice;
  class IfcElectricGenerator extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 264262732;
    }
  }
  IFC4X32.IfcElectricGenerator = IfcElectricGenerator;
  class IfcElectricMotor extends IfcEnergyConversionDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 402227799;
    }
  }
  IFC4X32.IfcElectricMotor = IfcElectricMotor;
  class IfcElectricTimeControl extends IfcFlowController {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1003880860;
    }
  }
  IFC4X32.IfcElectricTimeControl = IfcElectricTimeControl;
  class IfcFan extends IfcFlowMovingDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3415622556;
    }
  }
  IFC4X32.IfcFan = IfcFan;
  class IfcFilter extends IfcFlowTreatmentDevice {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 819412036;
    }
  }
  IFC4X32.IfcFilter = IfcFilter;
  class IfcFireSuppressionTerminal extends IfcFlowTerminal {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1426591983;
    }
  }
  IFC4X32.IfcFireSuppressionTerminal = IfcFireSuppressionTerminal;
  class IfcFlowInstrument extends IfcDistributionControlElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 182646315;
    }
  }
  IFC4X32.IfcFlowInstrument = IfcFlowInstrument;
  class IfcGeomodel extends IfcGeotechnicalAssembly {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 2680139844;
    }
  }
  IFC4X32.IfcGeomodel = IfcGeomodel;
  class IfcGeoslice extends IfcGeotechnicalAssembly {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1971632696;
    }
  }
  IFC4X32.IfcGeoslice = IfcGeoslice;
  class IfcProtectiveDeviceTrippingUnit extends IfcDistributionControlElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2295281155;
    }
  }
  IFC4X32.IfcProtectiveDeviceTrippingUnit = IfcProtectiveDeviceTrippingUnit;
  class IfcSensor extends IfcDistributionControlElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4086658281;
    }
  }
  IFC4X32.IfcSensor = IfcSensor;
  class IfcUnitaryControlElement extends IfcDistributionControlElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 630975310;
    }
  }
  IFC4X32.IfcUnitaryControlElement = IfcUnitaryControlElement;
  class IfcActuator extends IfcDistributionControlElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4288193352;
    }
  }
  IFC4X32.IfcActuator = IfcActuator;
  class IfcAlarm extends IfcDistributionControlElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3087945054;
    }
  }
  IFC4X32.IfcAlarm = IfcAlarm;
  class IfcController extends IfcDistributionControlElement {
    constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 25142252;
    }
  }
  IFC4X32.IfcController = IfcController;
})(IFC4X3 || (IFC4X3 = {}));

// dist/helpers/properties.ts
var PropsNames = {
  aggregates: {
    name: IFCRELAGGREGATES,
    relating: "RelatingObject",
    related: "RelatedObjects",
    key: "children"
  },
  spatial: {
    name: IFCRELCONTAINEDINSPATIALSTRUCTURE,
    relating: "RelatingStructure",
    related: "RelatedElements",
    key: "children"
  },
  psets: {
    name: IFCRELDEFINESBYPROPERTIES,
    relating: "RelatingPropertyDefinition",
    related: "RelatedObjects",
    key: "IsDefinedBy"
  },
  materials: {
    name: IFCRELASSOCIATESMATERIAL,
    relating: "RelatingMaterial",
    related: "RelatedObjects",
    key: "HasAssociations"
  },
  type: {
    name: IFCRELDEFINESBYTYPE,
    relating: "RelatingType",
    related: "RelatedObjects",
    key: "IsDefinedBy"
  }
};
var Properties = class _Properties {
  /** @ignore */
  constructor(api) {
    this.api = api;
  }
  /**
   * 
   * @param modelID model handle
   * @param id  expressID of IfcElement
   * @param recursive default false, if true get all nested properties recursively
   * @param inverse default false, if true get all inverse properties recursively
   * @returns IfcElement
   */
  async getItemProperties(modelID, id, recursive = false, inverse = false) {
    return this.api.GetLine(modelID, id, recursive, inverse);
  }
  /**
   * Get IfcPropertySets of IfcElements
   * @param modelID model handle
   * @param elementID expressID of IfcElement, default 0 (all psets in model)
   * @param recursive default false, if true get all nested properties recursively
   * @returns array of IfcElements inheriting from IfcPropertySetDefinition
   */
  async getPropertySets(modelID, elementID = 0, recursive = false, includeTypeProperties = false) {
    if (includeTypeProperties) {
      let types = await this.getTypeProperties(modelID, elementID, false);
      let results = [];
      for (let t of types) results.push(...await this.getPropertySets(modelID, t.expressID, recursive));
      return results;
    } else return await this.getRelatedProperties(modelID, elementID, PropsNames.psets, recursive);
  }
  /**
   * Set IfcRelDefinesByProperties relations of IfcElements and IfcPropertySets
   * @param modelID model handle
   * @param elementID expressID or array of expressIDs of IfcElements
   * @param psetID expressID or array of expressIDs of IfcPropertySets
   * @returns true if success or false if error
   */
  async setPropertySets(modelID, elementID, psetID) {
    return this.setItemProperties(modelID, elementID, psetID, PropsNames.psets);
  }
  /**
   * Get TypeObject of IfcElements
   * @param modelID model handle
   * @param elementID expressID of IfcElement, default 0 (all type objects in model)
   * @param recursive default false, if true get all nested properties of the type object recursively
   * @returns array of objects inheriting from IfcTypeObject
   */
  async getTypeProperties(modelID, elementID = 0, recursive = false) {
    if (this.api.GetModelSchema(modelID) == "IFC2X3") {
      return await this.getRelatedProperties(modelID, elementID, PropsNames.type, recursive);
    } else {
      return await this.getRelatedProperties(modelID, elementID, { ...PropsNames.type, key: "IsTypedBy" }, recursive);
    }
  }
  /**
   * Get materials of IfcElement
   * @param modelID model handle
   * @param elementID expressID of IfcElement, default 0 (all materials in model)
   * @param recursive default false, if true get all nested properties recursively
   * @returns array of IfcElements inheriting from IfcMaterialDefinition
   */
  async getMaterialsProperties(modelID, elementID = 0, recursive = false, includeTypeMaterials = false) {
    if (includeTypeMaterials) {
      let types = await this.getTypeProperties(modelID, elementID, false);
      let results = [];
      for (let t of types) results.push(...await this.getMaterialsProperties(modelID, t.expressID, recursive));
      return results;
    } else return await this.getRelatedProperties(modelID, elementID, PropsNames.materials, recursive);
  }
  /**
   * Set IfcRelAssociatesMaterial relations of IfcElements and IfcMaterialDefinitions
   * @param modelID model handle
   * @param elementID expressID or array of expressIDs of IfcElements
   * @param materialID expressID or array of expressIDs of IfcMaterialDefinitions
   * @returns true if success or false if error
   */
  async setMaterialsProperties(modelID, elementID, materialID) {
    return this.setItemProperties(modelID, elementID, materialID, PropsNames.materials);
  }
  /**
   * Get Spatial Structure of IfcProject
   * @param modelID model handle
   * @param includeProperties default false
   * @returns IfcProject as Node
   */
  async getSpatialStructure(modelID, includeProperties = false) {
    const chunks = await this.getSpatialTreeChunks(modelID);
    const allLines = await this.api.GetLineIDsWithType(modelID, IFCPROJECT);
    const projectID = allLines.get(0);
    const project = _Properties.newIfcProject(projectID);
    await this.getSpatialNode(modelID, project, chunks, includeProperties);
    return project;
  }
  async getRelatedProperties(modelID, elementID, propsName, recursive = false) {
    const result = [];
    let rels = null;
    if (elementID !== 0)
      rels = await this.api.GetLine(modelID, elementID, false, true, propsName.key)[propsName.key];
    else {
      let vec = this.api.GetLineIDsWithType(modelID, propsName.name);
      rels = [];
      for (let i = 0; i < vec.size(); ++i)
        rels.push({ value: vec.get(i) });
    }
    if (rels == null) return result;
    if (!Array.isArray(rels)) rels = [rels];
    for (let i = 0; i < rels.length; i++) {
      let propSetIds = await this.api.GetLine(modelID, rels[i].value, false, false)[propsName.relating];
      if (propSetIds == null) continue;
      if (!Array.isArray(propSetIds)) propSetIds = [propSetIds];
      for (let x = 0; x < propSetIds.length; x++) {
        result.push(await this.api.GetLine(modelID, propSetIds[x].value, recursive));
      }
    }
    return result;
  }
  async getChunks(modelID, chunks, propNames) {
    const relation = await this.api.GetLineIDsWithType(modelID, propNames.name, true);
    for (let i = 0; i < relation.size(); i++) {
      const rel = await this.api.GetLine(modelID, relation.get(i), false);
      this.saveChunk(chunks, propNames, rel);
    }
  }
  static newIfcProject(id) {
    return {
      expressID: id,
      type: "IFCPROJECT",
      children: []
    };
  }
  async getSpatialNode(modelID, node, treeChunks, includeProperties) {
    await this.getChildren(modelID, node, treeChunks, PropsNames.aggregates, includeProperties);
    await this.getChildren(modelID, node, treeChunks, PropsNames.spatial, includeProperties);
  }
  async getChildren(modelID, node, treeChunks, propNames, includeProperties) {
    const children = treeChunks[node.expressID];
    if (children == void 0) return;
    const prop = propNames.key;
    const nodes = [];
    for (let i = 0; i < children.length; i++) {
      const child = children[i];
      let node2 = this.newNode(child, this.api.GetLineType(modelID, child));
      if (includeProperties) {
        const properties = await this.getItemProperties(modelID, node2.expressID);
        node2 = { ...properties, ...node2 };
      }
      await this.getSpatialNode(modelID, node2, treeChunks, includeProperties);
      nodes.push(node2);
    }
    node[prop] = nodes;
  }
  newNode(id, type) {
    return {
      expressID: id,
      type: this.api.GetNameFromTypeCode(type),
      children: []
    };
  }
  async getSpatialTreeChunks(modelID) {
    const treeChunks = {};
    await this.getChunks(modelID, treeChunks, PropsNames.aggregates);
    await this.getChunks(modelID, treeChunks, PropsNames.spatial);
    return treeChunks;
  }
  saveChunk(chunks, propNames, rel) {
    const relating = rel[propNames.relating].value;
    const related = rel[propNames.related].map((r) => r.value);
    if (chunks[relating] == void 0) {
      chunks[relating] = related;
    } else {
      chunks[relating] = chunks[relating].concat(related);
    }
  }
  async setItemProperties(modelID, elementID, propID, propsName) {
    if (!Array.isArray(elementID)) elementID = [elementID];
    if (!Array.isArray(propID)) propID = [propID];
    let foundRel = 0;
    const rels = [];
    const elements = [];
    for (const elID of elementID) {
      const element = await this.api.GetLine(modelID, elID, false, true);
      if (!element[propsName.key]) continue;
      elements.push(element);
    }
    if (elements.length < 1) return false;
    const relations = this.api.GetLineIDsWithType(modelID, propsName.name);
    for (let i = 0; i < relations.size(); ++i) {
      const rel = await this.api.GetLine(modelID, relations.get(i));
      if (propID.includes(Number(rel[propsName.relating].value))) {
        rels.push(rel);
        foundRel++;
      }
      if (foundRel == propID.length) break;
    }
    for (const element of elements) {
      for (const rel of rels) {
        if (!element[propsName.key].some((e) => e.value === rel.expressID))
          element[propsName.key].push({ type: 5, value: rel.expressID });
        if (!rel[propsName.related].some((e) => e.value === element.expressID)) {
          rel[propsName.related].push({ type: 5, value: element.expressID });
          this.api.WriteLine(modelID, rel);
        }
      }
      this.api.WriteLine(modelID, element);
    }
    return true;
  }
};

// dist/helpers/log.ts
var LogLevel = /* @__PURE__ */ ((LogLevel2) => {
  LogLevel2[LogLevel2["LOG_LEVEL_DEBUG"] = 1] = "LOG_LEVEL_DEBUG";
  LogLevel2[LogLevel2["LOG_LEVEL_WARN"] = 3] = "LOG_LEVEL_WARN";
  LogLevel2[LogLevel2["LOG_LEVEL_ERROR"] = 4] = "LOG_LEVEL_ERROR";
  LogLevel2[LogLevel2["LOG_LEVEL_OFF"] = 6] = "LOG_LEVEL_OFF";
  return LogLevel2;
})(LogLevel || {});
var Log = class {
  static {
    this.logLevel = 4 /* LOG_LEVEL_ERROR */;
  }
  static setLogLevel(level) {
    this.logLevel = level;
  }
  static log(msg, ...args) {
    if (this.logLevel <= 4 /* LOG_LEVEL_ERROR */) {
      console.log(msg, ...args);
    }
  }
  static debug(msg, ...args) {
    if (this.logLevel <= 1 /* LOG_LEVEL_DEBUG */) {
      console.trace("DEBUG: ", msg, ...args);
    }
  }
  static warn(msg, ...args) {
    if (this.logLevel <= 3 /* LOG_LEVEL_WARN */) {
      console.warn("WARN: ", msg, ...args);
    }
  }
  static error(msg, ...args) {
    if (this.logLevel <= 4 /* LOG_LEVEL_ERROR */) {
      console.error("ERROR: ", msg, ...args);
    }
  }
};

// dist/web-ifc-api.ts
var WebIFCWasm;
if (typeof self !== "undefined" && self.crossOriginIsolated) {
  try {
    WebIFCWasm = require_web_ifc_mt();
  } catch (ex) {
    WebIFCWasm = require_web_ifc_node();
  }
} else WebIFCWasm = require_web_ifc_node();
var UNKNOWN = 0;
var STRING = 1;
var LABEL = 2;
var ENUM = 3;
var REAL = 4;
var REF = 5;
var EMPTY = 6;
var SET_BEGIN = 7;
var SET_END = 8;
var LINE_END = 9;
var INTEGER = 10;
function ms() {
  return (/* @__PURE__ */ new Date()).getTime();
}
var IfcAPI2 = class {
  constructor() {
    /** @ignore */
    this.wasmModule = void 0;
    this.wasmPath = "";
    this.isWasmPathAbsolute = false;
    this.modelSchemaList = [];
    this.modelSchemaNameList = [];
    /** @ignore */
    this.ifcGuidMap = /* @__PURE__ */ new Map();
    this.deletedLines = /* @__PURE__ */ new Map();
    /**
     * Contains all the logic and methods regarding properties, psets, qsets, etc.
     */
    this.properties = new Properties(this);
  }
  /**
   * Initializes the WASM module (WebIFCWasm), required before using any other functionality.
   *
   * @param customLocateFileHandler An optional locateFile function that let's
   * you override the path from which the wasm module is loaded.
   */
  async Init(customLocateFileHandler) {
    if (WebIFCWasm && this.wasmModule == void 0) {
      let locateFileHandler = (path, prefix) => {
        if (path.endsWith(".wasm")) {
          if (this.isWasmPathAbsolute) {
            return this.wasmPath + path;
          }
          return prefix + this.wasmPath + path;
        }
        return prefix + path;
      };
      this.wasmModule = await WebIFCWasm({ noInitialRun: true, locateFile: customLocateFileHandler || locateFileHandler });
      this.SetLogLevel(4 /* LOG_LEVEL_ERROR */);
    } else {
      Log.error(`Could not find wasm module at './web-ifc' from web-ifc-api.ts`);
    }
  }
  /**
     * Opens a set of models and returns model IDs 
     * @param dataSets Array of Buffers containing IFC data (bytes)
     * @param settings Settings for loading the model @see LoaderSettings
  * @returns Array of model IDs
    */
  OpenModels(dataSets, settings) {
    let s = {
      MEMORY_LIMIT: 2147483648,
      ...settings
    };
    s.MEMORY_LIMIT = s.MEMORY_LIMIT / dataSets.length;
    let modelIDs = [];
    for (let dataSet of dataSets) modelIDs.push(this.OpenModel(dataSet, s));
    return modelIDs;
  }
  CreateSettings(settings) {
    let s = {
      COORDINATE_TO_ORIGIN: false,
      CIRCLE_SEGMENTS: 12,
      TAPE_SIZE: 67108864,
      MEMORY_LIMIT: 2147483648,
      LINEWRITER_BUFFER: 1e4,
      ...settings
    };
    return s;
  }
  LookupSchemaId(schemaName) {
    for (var i = 0; i < SchemaNames.length; i++) {
      if (typeof SchemaNames[i] !== "undefined") {
        for (var j = 0; j < SchemaNames[i].length; j++) {
          if (SchemaNames[i][j] == schemaName) return i;
        }
      }
    }
    return -1;
  }
  /**
     * Opens a model and returns a modelID number
     * @param data Buffer containing IFC data (bytes)
     * @param settings Settings for loading the model @see LoaderSettings
  * @returns ModelID or -1 if model fails to open
    */
  OpenModel(data, settings) {
    let s = this.CreateSettings(settings);
    let result = this.wasmModule.OpenModel(s, (destPtr, offsetInSrc, destSize) => {
      let srcSize = Math.min(data.byteLength - offsetInSrc, destSize);
      let dest = this.wasmModule.HEAPU8.subarray(destPtr, destPtr + srcSize);
      let src = data.subarray(offsetInSrc, offsetInSrc + srcSize);
      dest.set(src);
      return srcSize;
    });
    this.deletedLines.set(result, /* @__PURE__ */ new Set());
    var schemaName = this.GetHeaderLine(result, FILE_SCHEMA).arguments[0][0].value;
    this.modelSchemaList[result] = this.LookupSchemaId(schemaName);
    this.modelSchemaNameList[result] = schemaName;
    if (this.modelSchemaList[result] == -1) {
      Log.error("Unsupported Schema:" + schemaName);
      this.CloseModel(result);
      return -1;
    }
    Log.debug("Parsing Model using " + schemaName + " Schema");
    return result;
  }
  /**
   * Opens a model and returns a modelID number
   * @param callback a function of signature (offset:number, size: number) => Uint8Array that will retrieve the IFC data
   * @param settings Settings for loading the model @see LoaderSettings
   * @returns ModelID or -1 if model fails to open
  */
  OpenModelFromCallback(callback, settings) {
    let s = this.CreateSettings(settings);
    let result = this.wasmModule.OpenModel(s, (destPtr, offsetInSrc, destSize) => {
      let data = callback(offsetInSrc, destSize);
      let srcSize = Math.min(data.byteLength, destSize);
      let dest = this.wasmModule.HEAPU8.subarray(destPtr, destPtr + srcSize);
      dest.set(data);
      return srcSize;
    });
    this.deletedLines.set(result, /* @__PURE__ */ new Set());
    var schemaName = this.GetHeaderLine(result, FILE_SCHEMA).arguments[0][0].value;
    this.modelSchemaList[result] = this.LookupSchemaId(schemaName);
    this.modelSchemaNameList[result] = schemaName;
    if (this.modelSchemaList[result] == -1) {
      Log.error("Unsupported Schema:" + schemaName);
      this.CloseModel(result);
      return -1;
    }
    Log.debug("Parsing Model using " + schemaName + " Schema");
    return result;
  }
  /**
     * Fetches the ifc schema version of a given model
     * @param modelID Model ID
  * @returns IFC Schema version
    */
  GetModelSchema(modelID) {
    return this.modelSchemaNameList[modelID];
  }
  /**
     * Creates a new model and returns a modelID number
     * @param schema ifc schema version
  * @returns ModelID
    */
  CreateModel(model, settings) {
    let s = this.CreateSettings(settings);
    let result = this.wasmModule.CreateModel(s);
    this.modelSchemaList[result] = this.LookupSchemaId(model.schema);
    this.modelSchemaNameList[result] = model.schema;
    if (this.modelSchemaList[result] == -1) {
      Log.error("Unsupported Schema:" + model.schema);
      this.CloseModel(result);
      return -1;
    }
    this.deletedLines.set(result, /* @__PURE__ */ new Set());
    const modelName = model.name || "web-ifc-model-" + result + ".ifc";
    const timestamp = (/* @__PURE__ */ new Date()).toISOString().slice(0, 19);
    const description = model.description?.map((d) => ({ type: STRING, value: d })) || [{ type: STRING, value: "ViewDefinition [CoordinationView]" }];
    const authors = model.authors?.map((a) => ({ type: STRING, value: a })) || [null];
    const orgs = model.organizations?.map((o) => ({ type: STRING, value: o })) || [null];
    const auth = model.authorization ? { type: STRING, value: model.authorization } : null;
    this.wasmModule.WriteHeaderLine(result, FILE_DESCRIPTION, [
      description,
      { type: STRING, value: "2;1" }
    ]);
    this.wasmModule.WriteHeaderLine(result, FILE_NAME, [
      { type: STRING, value: modelName },
      { type: STRING, value: timestamp },
      authors,
      orgs,
      { type: STRING, value: "thatopen/web-ifc-api" },
      { type: STRING, value: "thatopen/web-ifc-api" },
      auth
    ]);
    this.wasmModule.WriteHeaderLine(result, FILE_SCHEMA, [[{ type: STRING, value: model.schema }]]);
    return result;
  }
  /**
   * Saves a model to a Buffer
   * @param modelID Model ID
   * @returns Buffer containing the model data
   */
  SaveModel(modelID) {
    let dataBuffer = new Uint8Array(0);
    this.wasmModule.SaveModel(modelID, (srcPtr, srcSize) => {
      let origSize = dataBuffer.byteLength;
      let src = this.wasmModule.HEAPU8.subarray(srcPtr, srcPtr + srcSize);
      let newBuffer = new Uint8Array(origSize + srcSize);
      newBuffer.set(dataBuffer);
      newBuffer.set(src, origSize);
      dataBuffer = newBuffer;
    });
    return dataBuffer;
  }
  /**
   * Saves a model to a Buffer
   * @param modelID Model ID
   * @returns Buffer containing the model data
   */
  SaveModelToCallback(modelID, callback) {
    this.wasmModule.SaveModel(modelID, (srcPtr, srcSize) => {
      let src = this.wasmModule.HEAPU8.subarray(srcPtr, srcPtr + srcSize);
      let newBuffer = new Uint8Array(srcSize);
      newBuffer.set(src);
      callback(newBuffer);
    });
  }
  /**
  * Retrieves the geometry of an element
  * @param modelID Model handle retrieved by OpenModel
  * @param geometryExpressID express ID of the element
  * @returns Geometry of the element as a list of vertices and indices
  */
  GetGeometry(modelID, geometryExpressID) {
    return this.wasmModule.GetGeometry(modelID, geometryExpressID);
  }
  /**
   * Gets the header information required by the user
   * @param modelID Model handle retrieved by OpenModel
   * @param headerType Type of header data you want to retrieve
   * ifc.FILE_NAME, ifc.FILE_DESCRIPTION or ifc.FILE_SCHEMA
   * @returns An object with parameters ID, type and arguments
   */
  GetHeaderLine(modelID, headerType) {
    return this.wasmModule.GetHeaderLine(modelID, headerType);
  }
  /**
   * Gets the list of all ifcTypes contained in the model
   * @param modelID Model handle retrieved by OpenModel
   * @returns Array of objects containing typeID and typeName
   */
  GetAllTypesOfModel(modelID) {
    let typesNames = [];
    const elements = Object.keys(FromRawLineData[this.modelSchemaList[modelID]]).map((e) => parseInt(e));
    for (let i = 0; i < elements.length; i++) {
      const lines = this.GetLineIDsWithType(modelID, elements[i]);
      if (lines.size() > 0) typesNames.push({ typeID: elements[i], typeName: this.wasmModule.GetNameFromTypeCode(elements[i]) });
    }
    return typesNames;
  }
  /**
   * Gets the ifc line data for a given express ID
   * @param modelID Model handle retrieved by OpenModel
   * @param expressID express ID of the line
   * @param flatten recursively flatten the line, default false
   * @param inverse get the inverse properties of the line, default false
   * @param inversePropKey filters out all other properties from a inverse search, for a increase in performance. Default null
   * @returns lineObject
   */
  GetLine(modelID, expressID, flatten = false, inverse = false, inversePropKey = null) {
    let expressCheck = this.wasmModule.ValidateExpressID(modelID, expressID);
    if (!expressCheck) {
      return;
    }
    let rawLineData = this.GetRawLineData(modelID, expressID);
    let lineData;
    try {
      lineData = FromRawLineData[this.modelSchemaList[modelID]][rawLineData.type](rawLineData.arguments);
      lineData.expressID = rawLineData.ID;
    } catch (e) {
      Log.error("Invalid IFC Line:" + expressID);
      if (rawLineData.ID) {
        throw e;
      } else {
        return;
      }
    }
    if (flatten) {
      this.FlattenLine(modelID, lineData);
    }
    let inverseData = InversePropertyDef[this.modelSchemaList[modelID]][rawLineData.type];
    if (inverse && inverseData != null) {
      for (let inverseProp of inverseData) {
        if (inversePropKey && inverseProp[0] !== inversePropKey) continue;
        if (!inverseProp[3]) lineData[inverseProp[0]] = null;
        else lineData[inverseProp[0]] = [];
        let targetTypes = [inverseProp[1]];
        if (typeof InheritanceDef[this.modelSchemaList[modelID]][inverseProp[1]] != "undefined") {
          targetTypes = targetTypes.concat(InheritanceDef[this.modelSchemaList[modelID]][inverseProp[1]]);
        }
        let inverseIDs = this.wasmModule.GetInversePropertyForItem(modelID, expressID, targetTypes, inverseProp[2], inverseProp[3]);
        if (!inverseProp[3] && inverseIDs.size() > 0) {
          if (!flatten) lineData[inverseProp[0]] = { type: 5, value: inverseIDs.get(0) };
          else lineData[inverseProp[0]] = this.GetLine(modelID, inverseIDs.get(0));
        } else {
          for (let x = 0; x < inverseIDs.size(); x++) {
            if (!flatten) lineData[inverseProp[0]].push({ type: 5, value: inverseIDs.get(x) });
            else lineData[inverseProp[0]].push(this.GetLine(modelID, inverseIDs.get(x)));
          }
        }
      }
    }
    return lineData;
  }
  /**
   * Gets the next unused expressID
   * @param modelID Model handle retrieved by OpenModel
   * @param expressID Starting expressID value 
   * @returns The next unused expressID starting from the value provided
   */
  GetNextExpressID(modelID, expressID) {
    return this.wasmModule.GetNextExpressID(modelID, expressID);
  }
  /**
   * Creates a new ifc entity
   * @param modelID Model handle retrieved by OpenModel
   * @param type Type code
   * @param args Arguments required by the entity
   * @returns An object contining the parameters of the new entity
   */
  CreateIfcEntity(modelID, type, ...args) {
    return Constructors[this.modelSchemaList[modelID]][type](args);
  }
  /**
   * Creates a new ifc type i.e. IfcLabel, IfcReal, ...
   * @param modelID Model handle retrieved by OpenModel
   * @param type Type code
   * @param value Type value
   * @returns An object with the parameters of the type
   */
  CreateIfcType(modelID, type, value) {
    return TypeInitialisers[this.modelSchemaList[modelID]][type](value);
  }
  /**
   * Gets the name from a type code
   * @param type Code
   * @returns Name
   */
  GetNameFromTypeCode(type) {
    Log.warn("GetNameFromTypeCode() now returns type names in camel case");
    return this.wasmModule.GetNameFromTypeCode(type);
  }
  /**
   * Gets the type code  from a name code
   * @param name
   * @returns type code
   */
  GetTypeCodeFromName(typeName) {
    return this.wasmModule.GetTypeCodeFromName(typeName);
  }
  /**
   * Evaluates if a type is subtype of IfcElement 
   * @param type Type code
   * @returns True if subtype of Ifcelement, False if it is not subtype
   */
  IsIfcElement(type) {
    return this.wasmModule.IsIfcElement(type);
  }
  /**
   * Returns a list with all entity types that are present in the current schema
   * @param modelID Model handle retrieved by OpenModel
   * @returns Array of type codes
   */
  GetIfcEntityList(modelID) {
    return Object.keys(FromRawLineData[this.modelSchemaList[modelID]]).map((x) => parseInt(x));
  }
  /**
   * Deletes an IFC line from the model
   * @param modelID Model handle retrieved by OpenModel
   * @param expressID express ID of the line to remove
   */
  DeleteLine(modelID, expressID) {
    this.wasmModule.RemoveLine(modelID, expressID);
    this.deletedLines.get(modelID).add(expressID);
  }
  /**
      * Writes a line to the model, can be used to write new lines or to update existing lines
      * @param modelID Model handle retrieved by OpenModel
      * @param lineObject array of line object to write
      */
  WriteLines(modelID, lineObjects) {
    this.wasmModule.ExtendLineStorage(modelID, lineObjects.length);
    for (let lineObject of lineObjects) this.WriteLine(modelID, lineObject);
  }
  /**
  * Writes a set of line to the model, can be used to write new lines or to update existing lines
  * @param modelID Model handle retrieved by OpenModel
  * @param lineObject line object to write
  */
  WriteLine(modelID, lineObject) {
    if (lineObject.expressID != -1 && this.deletedLines.get(modelID).has(lineObject.expressID)) {
      Log.error(`Cannot re-use deleted express ID`);
      return;
    }
    if (lineObject.expressID != -1 && lineObject.expressID <= this.GetMaxExpressID(modelID) && this.GetLineType(modelID, lineObject.expressID) != lineObject.type && this.GetLineType(modelID, lineObject.expressID) != 0) {
      Log.error(`Cannot change type of existing IFC Line`);
      return;
    }
    let property;
    for (property in lineObject) {
      const lineProperty = lineObject[property];
      if (lineProperty && lineProperty.expressID !== void 0) {
        this.WriteLine(modelID, lineProperty);
        lineObject[property] = new Handle(lineProperty.expressID);
      } else if (Array.isArray(lineProperty) && lineProperty.length > 0) {
        for (let i = 0; i < lineProperty.length; i++) {
          if (lineProperty[i].expressID !== void 0) {
            this.WriteLine(modelID, lineProperty[i]);
            lineObject[property][i] = new Handle(lineProperty[i].expressID);
          }
        }
      }
    }
    if (lineObject.expressID === void 0 || lineObject.expressID < 0) {
      lineObject.expressID = this.GetMaxExpressID(modelID) + 1;
    }
    let rawLineData = {
      ID: lineObject.expressID,
      type: lineObject.type,
      arguments: ToRawLineData[this.modelSchemaList[modelID]][lineObject.type](lineObject)
    };
    this.WriteRawLineData(modelID, rawLineData);
  }
  /** @ignore */
  FlattenLine(modelID, line) {
    Object.keys(line).forEach((propertyName) => {
      let property = line[propertyName];
      if (property && property.type === 5) {
        if (property.value) line[propertyName] = this.GetLine(modelID, property.value, true);
      } else if (Array.isArray(property) && property.length > 0 && property[0] && property[0].type === 5) {
        for (let i = 0; i < property.length; i++) {
          if (property[i].value) line[propertyName][i] = this.GetLine(modelID, property[i].value, true);
        }
      }
    });
  }
  /** @ignore */
  GetRawLineData(modelID, expressID) {
    return this.wasmModule.GetLine(modelID, expressID);
  }
  /** @ignore */
  WriteRawLineData(modelID, data) {
    this.wasmModule.WriteLine(modelID, data.ID, data.type, data.arguments);
  }
  /** @ignore */
  WriteRawLinesData(modelID, data) {
    this.wasmModule.ExtendLineStorage(modelID, data.length);
    for (let rawLine of data) this.wasmModule.WriteLine(modelID, rawLine.ID, rawLine.type, rawLine.arguments);
  }
  /**
   * Get all line IDs of a specific ifc type
   * @param modelID model ID
   * @param type ifc type, @see IfcEntities
   * @param includeInherited if true, also returns all inherited types 
   * @returns vector of line IDs
   */
  GetLineIDsWithType(modelID, type, includeInherited = false) {
    let types = [];
    types.push(type);
    if (includeInherited && typeof InheritanceDef[this.modelSchemaList[modelID]][type] != "undefined") {
      types = types.concat(InheritanceDef[this.modelSchemaList[modelID]][type]);
    }
    let lineIds = this.wasmModule.GetLineIDsWithType(modelID, types);
    lineIds[Symbol.iterator] = function* () {
      for (let i = 0; i < lineIds.size(); i++) yield lineIds.get(i);
    };
    return lineIds;
  }
  /**
   * Get all line IDs of a model
   * @param modelID model ID
   * @returns vector of all line IDs
   */
  GetAllLines(modelID) {
    let lineIds = this.wasmModule.GetAllLines(modelID);
    lineIds[Symbol.iterator] = function* () {
      for (let i = 0; i < lineIds.size(); i++) yield lineIds.get(i);
    };
    return lineIds;
  }
  /**
   * Returns all crossSections in 2D contained in IFCSECTIONEDSOLID, IFCSECTIONEDSURFACE, IFCSECTIONEDSOLIDHORIZONTAL (IFC4x3 or superior) 
   * @param modelID model ID
   * @returns Lists with the cross sections curves as sets of points
   */
  GetAllCrossSections2D(modelID) {
    const crossSections = this.wasmModule.GetAllCrossSections(modelID, 2);
    const crossSectionList = [];
    for (let i = 0; i < crossSections.size(); i++) {
      const alignment = crossSections.get(i);
      const curveList = [];
      const expressList = [];
      for (let j = 0; j < alignment.curves.size(); j++) {
        const curve = alignment.curves.get(j);
        const ptList = [];
        for (let p = 0; p < curve.points.size(); p++) {
          const pt = curve.points.get(p);
          const newPoint = { x: pt.x, y: pt.y, z: pt.z };
          ptList.push(newPoint);
        }
        const newCurve = { points: ptList };
        curveList.push(newCurve);
        expressList.push(alignment.expressID.get(j));
      }
      const align = { FlatCoordinationMatrix: this.GetCoordinationMatrix(modelID), curves: curveList, expressID: expressList };
      crossSectionList.push(align);
    }
    return crossSectionList;
  }
  /**
   * Returns all crossSections in 3D contained in IFCSECTIONEDSOLID, IFCSECTIONEDSURFACE, IFCSECTIONEDSOLIDHORIZONTAL (IFC4x3 or superior) 
   * @param modelID model ID
   * @returns Lists with the cross sections curves as sets of points
   */
  GetAllCrossSections3D(modelID) {
    const crossSections = this.wasmModule.GetAllCrossSections(modelID, 3);
    const crossSectionList = [];
    for (let i = 0; i < crossSections.size(); i++) {
      const alignment = crossSections.get(i);
      const curveList = [];
      const expressList = [];
      for (let j = 0; j < alignment.curves.size(); j++) {
        const curve = alignment.curves.get(j);
        const ptList = [];
        for (let p = 0; p < curve.points.size(); p++) {
          const pt = curve.points.get(p);
          const newPoint = { x: pt.x, y: pt.y, z: pt.z };
          ptList.push(newPoint);
        }
        const newCurve = { points: ptList };
        curveList.push(newCurve);
        expressList.push(alignment.expressID.get(j));
      }
      const align = { FlatCoordinationMatrix: this.GetCoordinationMatrix(modelID), curves: curveList, expressID: expressList };
      crossSectionList.push(align);
    }
    return crossSectionList;
  }
  /**
   * Returns all alignments contained in the IFC model (IFC4x3 or superior)
   * @param modelID model ID
   * @returns Lists with horizontal and vertical curves as sets of points
   */
  GetAllAlignments(modelID) {
    const alignments = this.wasmModule.GetAllAlignments(modelID);
    console.log("RAW");
    console.log(alignments);
    const alignmentList = [];
    for (let i = 0; i < alignments.size(); i++) {
      const alignment = alignments.get(i);
      const horList = [];
      for (let j = 0; j < alignment.Horizontal.curves.size(); j++) {
        const curve = alignment.Horizontal.curves.get(j);
        const ptList = [];
        for (let p = 0; p < curve.points.size(); p++) {
          const pt = curve.points.get(p);
          const newPoint = { x: pt.x, y: pt.y };
          ptList.push(newPoint);
        }
        const dtList = [];
        for (let p = 0; p < curve.userData.size(); p++) {
          const dt = curve.userData.get(p);
          dtList.push(dt);
        }
        const newCurve = { points: ptList, data: dtList };
        horList.push(newCurve);
      }
      const verList = [];
      for (let j = 0; j < alignment.Vertical.curves.size(); j++) {
        const curve = alignment.Vertical.curves.get(j);
        const ptList = [];
        for (let p = 0; p < curve.points.size(); p++) {
          const pt = curve.points.get(p);
          const newPoint = { x: pt.x, y: pt.y };
          ptList.push(newPoint);
        }
        const dtList = [];
        for (let p = 0; p < curve.userData.size(); p++) {
          const dt = curve.userData.get(p);
          dtList.push(dt);
        }
        const newCurve = { points: ptList, data: dtList };
        verList.push(newCurve);
      }
      const curve3DList = [];
      if (alignment.Horizontal.curves.size() > 0 && alignment.Vertical.curves.size() > 0) {
        const startH = { x: 0, y: 0, z: 0 };
        const startV = { x: 0, y: 0, z: 0 };
        let lastx = 0;
        let lasty = 0;
        let length = 0;
        for (let j = 0; j < alignment.Horizontal.curves.size(); j++) {
          const curve = alignment.Horizontal.curves.get(j);
          const points = [];
          for (let k = 0; k < curve.points.size(); k++) {
            let alt = 0;
            const pt = curve.points.get(k);
            if (j === 0 && k === 0) {
              lastx = pt.x;
              lasty = pt.y;
            }
            const valueX = pt.x - lastx;
            const valueY = pt.y - lasty;
            lastx = pt.x;
            lasty = pt.y;
            length += Math.sqrt(valueX * valueX + valueY * valueY);
            let first = true;
            let lastAlt = 0;
            let lastX = 0;
            let done = false;
            for (let ii = 0; ii < alignment.Vertical.curves.size(); ii++) {
              const curve2 = alignment.Vertical.curves.get(ii);
              for (let jj = 0; jj < curve2.points.size(); jj++) {
                const pt2 = curve2.points.get(jj);
                if (first) {
                  first = false;
                  alt = pt2.y;
                  lastAlt = pt2.y;
                  if (pt2.x >= length) {
                    break;
                  }
                }
                if (pt2.x >= length) {
                  const value1 = pt2.x - lastX;
                  const value2 = length - lastX;
                  const value3 = value2 / value1;
                  alt = lastAlt * (1 - value3) + pt2.y * value3;
                  done = true;
                  break;
                }
                lastAlt = pt2.y;
                lastX = pt2.x;
              }
              if (done) {
                break;
              }
            }
            points.push({
              x: pt.x - startH.x,
              y: alt - startV.y,
              z: startH.y - pt.y
            });
          }
          const newCurve = { points };
          curve3DList.push(newCurve);
        }
      }
      const align = {
        FlatCoordinationMatrix: this.GetCoordinationMatrix(modelID),
        horizontal: horList,
        vertical: verList,
        curve3D: curve3DList
      };
      alignmentList.push(align);
    }
    return alignmentList;
  }
  /**
   * Set the transformation matrix
   * @param modelID model ID
   * @param transformationMatrix transformation matrix, flat 4x4 matrix as array[16] 
   */
  SetGeometryTransformation(modelID, transformationMatrix) {
    if (transformationMatrix.length != 16) {
      throw new Error(`invalid matrix size: ${transformationMatrix.length}`);
    }
    this.wasmModule.SetGeometryTransformation(modelID, transformationMatrix);
  }
  /**
   * Get the coordination matrix
   * @param modelID model ID
   * @returns flat 4x4 matrix as array[16]
   */
  GetCoordinationMatrix(modelID) {
    return this.wasmModule.GetCoordinationMatrix(modelID);
  }
  GetVertexArray(ptr, size) {
    return this.getSubArray(this.wasmModule.HEAPF32, ptr, size);
  }
  GetIndexArray(ptr, size) {
    return this.getSubArray(this.wasmModule.HEAPU32, ptr, size);
  }
  getSubArray(heap, startPtr, sizeBytes) {
    return heap.subarray(startPtr / 4, startPtr / 4 + sizeBytes).slice(0);
  }
  /**
   * Closes a model and frees all related memory
   * @param modelID Model handle retrieved by OpenModel, model must be closed after use
  */
  CloseModel(modelID) {
    this.ifcGuidMap.delete(modelID);
    this.wasmModule.CloseModel(modelID);
  }
  /**
   * Closes all models and frees all related memory
  */
  Dispose() {
    this.ifcGuidMap.clear();
    this.wasmModule.CloseAllModels();
  }
  /**
  * Streams meshes of a model with specific express id
  * @param modelID Model handle retrieved by OpenModel
     * @param expressIDs expressIDs of elements to stream
  * @param meshCallback callback function that is called for each mesh
  */
  StreamMeshes(modelID, expressIDs, meshCallback) {
    this.wasmModule.StreamMeshes(modelID, expressIDs, meshCallback);
  }
  /**
   * Streams all meshes of a model
   * @param modelID Model handle retrieved by OpenModel
   * @param meshCallback callback function that is called for each mesh
   */
  StreamAllMeshes(modelID, meshCallback) {
    this.wasmModule.StreamAllMeshes(modelID, meshCallback);
  }
  /**
   * Streams all meshes of a model with a specific ifc type
   * @param modelID Model handle retrieved by OpenModel
   * @param types types of elements to stream
   * @param meshCallback callback function that is called for each mesh
   */
  StreamAllMeshesWithTypes(modelID, types, meshCallback) {
    this.wasmModule.StreamAllMeshesWithTypes(modelID, types, meshCallback);
  }
  /**
     * Checks if a specific model ID is open or closed
     * @param modelID Model handle retrieved by OpenModel
  * @returns true if model is open, false if model is closed
    */
  IsModelOpen(modelID) {
    return this.wasmModule.IsModelOpen(modelID);
  }
  /**
     * Load all geometry in a model
     * @param modelID Model handle retrieved by OpenModel
  * @returns Vector of FlatMesh objects
    */
  LoadAllGeometry(modelID) {
    let flatMeshes = this.wasmModule.LoadAllGeometry(modelID);
    flatMeshes[Symbol.iterator] = function* () {
      for (let i = 0; i < flatMeshes.size(); i++) yield flatMeshes.get(i);
    };
    return flatMeshes;
  }
  /**
     * Load geometry for a single element
     * @param modelID Model handle retrieved by OpenModel
  * @param expressID ExpressID of the element
  * @returns FlatMesh object
    */
  GetFlatMesh(modelID, expressID) {
    return this.wasmModule.GetFlatMesh(modelID, expressID);
  }
  /**
  * Returns the maximum ExpressID value in the IFC file, ex.- #9999999
  * @param modelID Model handle retrieved by OpenModel
  * @returns Express numerical value
  */
  GetMaxExpressID(modelID) {
    return this.wasmModule.GetMaxExpressID(modelID);
  }
  /**
  * Returns the type of a given ifc entity in the fiule.
  * @param modelID Model handle retrieved by OpenModel
  * @param expressID Line Number
  * @returns IFC Type Code
  */
  GetLineType(modelID, expressID) {
    return this.wasmModule.GetLineType(modelID, expressID);
  }
  /**
  * Returns the version number of web-ifc
  * @returns The current version number as a string
  */
  GetVersion() {
    return this.wasmModule.GetVersion();
  }
  /**
  * Looks up an entities express ID from its GlobalID.
  * @param modelID Model handle retrieved by OpenModel
  * @param guid GobalID to be looked up
  * @returns expressID numerical value
  */
  GetExpressIdFromGuid(modelID, guid) {
    if (!this.ifcGuidMap.has(modelID)) this.CreateIfcGuidToExpressIdMapping(modelID);
    return this.ifcGuidMap.get(modelID)?.get(guid);
  }
  /**
   * Looks up an entities GlobalID from its ExpressID.
   * @param modelID Model handle retrieved by OpenModel
   * @param expressID express ID to be looked up
   * @returns globalID string value
   */
  GetGuidFromExpressId(modelID, expressID) {
    if (!this.ifcGuidMap.has(modelID)) this.CreateIfcGuidToExpressIdMapping(modelID);
    return this.ifcGuidMap.get(modelID)?.get(expressID);
  }
  /** @ignore */
  CreateIfcGuidToExpressIdMapping(modelID) {
    const map = /* @__PURE__ */ new Map();
    let entities = this.GetIfcEntityList(modelID);
    for (const typeId of entities) {
      if (!this.IsIfcElement(typeId)) continue;
      const lines = this.GetLineIDsWithType(modelID, typeId);
      const size = lines.size();
      for (let y = 0; y < size; y++) {
        const expressID = lines.get(y);
        const info = this.GetLine(modelID, expressID);
        try {
          if ("GlobalId" in info) {
            const globalID = info.GlobalId.value;
            map.set(expressID, globalID);
            map.set(globalID, expressID);
          }
        } catch (e) {
          continue;
        }
      }
    }
    this.ifcGuidMap.set(modelID, map);
  }
  /**
   * Sets the path to the wasm file
   * @param path path to the wasm file
   * @param absolute if true, path is absolute, otherwise it is relative to executing script
   */
  SetWasmPath(path, absolute = false) {
    this.wasmPath = path;
    this.isWasmPathAbsolute = absolute;
  }
  /**
   * Sets the log level
   * @param level Log level to set
   */
  SetLogLevel(level) {
    Log.setLogLevel(level);
    this.wasmModule.SetLogLevel(level);
  }
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 730:
/***/ (function(__unused_webpack_module, exports) {

/*! pako 2.1.0 https://github.com/nodeca/pako @license (MIT AND Zlib) */
(function (global, factory) {
     true
        ? factory(exports)
        : 0;
})(this, function (exports) {
    "use strict";

    // (C) 1995-2013 Jean-loup Gailly and Mark Adler
    // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
    //
    // This software is provided 'as-is', without any express or implied
    // warranty. In no event will the authors be held liable for any damages
    // arising from the use of this software.
    //
    // Permission is granted to anyone to use this software for any purpose,
    // including commercial applications, and to alter it and redistribute it
    // freely, subject to the following restrictions:
    //
    // 1. The origin of this software must not be misrepresented; you must not
    //   claim that you wrote the original software. If you use this software
    //   in a product, an acknowledgment in the product documentation would be
    //   appreciated but is not required.
    // 2. Altered source versions must be plainly marked as such, and must not be
    //   misrepresented as being the original software.
    // 3. This notice may not be removed or altered from any source distribution.

    /* eslint-disable space-unary-ops */

    /* Public constants ==========================================================*/
    /* ===========================================================================*/

    //const Z_FILTERED          = 1;
    //const Z_HUFFMAN_ONLY      = 2;
    //const Z_RLE               = 3;
    const Z_FIXED$1 = 4;
    //const Z_DEFAULT_STRATEGY  = 0;

    /* Possible values of the data_type field (though see inflate()) */
    const Z_BINARY = 0;
    const Z_TEXT = 1;
    //const Z_ASCII             = 1; // = Z_TEXT
    const Z_UNKNOWN$1 = 2;

    /*============================================================================*/

    function zero$1(buf) {
        let len = buf.length;
        while (--len >= 0) {
            buf[len] = 0;
        }
    }

    // From zutil.h

    const STORED_BLOCK = 0;
    const STATIC_TREES = 1;
    const DYN_TREES = 2;
    /* The three kinds of block type */

    const MIN_MATCH$1 = 3;
    const MAX_MATCH$1 = 258;
    /* The minimum and maximum match lengths */

    // From deflate.h
    /* ===========================================================================
     * Internal compression state.
     */

    const LENGTH_CODES$1 = 29;
    /* number of length codes, not counting the special END_BLOCK code */

    const LITERALS$1 = 256;
    /* number of literal bytes 0..255 */

    const L_CODES$1 = LITERALS$1 + 1 + LENGTH_CODES$1;
    /* number of Literal or Length codes, including the END_BLOCK code */

    const D_CODES$1 = 30;
    /* number of distance codes */

    const BL_CODES$1 = 19;
    /* number of codes used to transfer the bit lengths */

    const HEAP_SIZE$1 = 2 * L_CODES$1 + 1;
    /* maximum heap size */

    const MAX_BITS$1 = 15;
    /* All codes must not exceed MAX_BITS bits */

    const Buf_size = 16;
    /* size of bit buffer in bi_buf */

    /* ===========================================================================
     * Constants
     */

    const MAX_BL_BITS = 7;
    /* Bit length codes must not exceed MAX_BL_BITS bits */

    const END_BLOCK = 256;
    /* end of block literal code */

    const REP_3_6 = 16;
    /* repeat previous bit length 3-6 times (2 bits of repeat count) */

    const REPZ_3_10 = 17;
    /* repeat a zero length 3-10 times  (3 bits of repeat count) */

    const REPZ_11_138 = 18;
    /* repeat a zero length 11-138 times  (7 bits of repeat count) */

    /* eslint-disable comma-spacing,array-bracket-spacing */
    const extra_lbits =
        /* extra bits for each length code */
        new Uint8Array([
            0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4,
            4, 5, 5, 5, 5, 0,
        ]);

    const extra_dbits =
        /* extra bits for each distance code */
        new Uint8Array([
            0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9,
            10, 10, 11, 11, 12, 12, 13, 13,
        ]);

    const extra_blbits =
        /* extra bits for each bit length code */
        new Uint8Array([
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7,
        ]);

    const bl_order = new Uint8Array([
        16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15,
    ]);
    /* eslint-enable comma-spacing,array-bracket-spacing */

    /* The lengths of the bit length codes are sent in order of decreasing
     * probability, to avoid transmitting the lengths for unused bit length codes.
     */

    /* ===========================================================================
     * Local data. These are initialized only once.
     */

    // We pre-fill arrays with 0 to avoid uninitialized gaps

    const DIST_CODE_LEN = 512; /* see definition of array dist_code below */

    // !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
    const static_ltree = new Array((L_CODES$1 + 2) * 2);
    zero$1(static_ltree);
    /* The static literal tree. Since the bit lengths are imposed, there is no
     * need for the L_CODES extra codes used during heap construction. However
     * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
     * below).
     */

    const static_dtree = new Array(D_CODES$1 * 2);
    zero$1(static_dtree);
    /* The static distance tree. (Actually a trivial tree since all codes use
     * 5 bits.)
     */

    const _dist_code = new Array(DIST_CODE_LEN);
    zero$1(_dist_code);
    /* Distance codes. The first 256 values correspond to the distances
     * 3 .. 258, the last 256 values correspond to the top 8 bits of
     * the 15 bit distances.
     */

    const _length_code = new Array(MAX_MATCH$1 - MIN_MATCH$1 + 1);
    zero$1(_length_code);
    /* length code for each normalized match length (0 == MIN_MATCH) */

    const base_length = new Array(LENGTH_CODES$1);
    zero$1(base_length);
    /* First normalized length for each code (0 = MIN_MATCH) */

    const base_dist = new Array(D_CODES$1);
    zero$1(base_dist);
    /* First normalized distance for each code (0 = distance of 1) */

    class StaticTreeDesc {
        constructor(static_tree, extra_bits, extra_base, elems, max_length) {
            this.static_tree = static_tree; /* static tree or NULL */
            this.extra_bits = extra_bits; /* extra bits for each code or NULL */
            this.extra_base = extra_base; /* base index for extra_bits */
            this.elems = elems; /* max number of elements in the tree */
            this.max_length = max_length; /* max bit length for the codes */

            // show if `static_tree` has data or dummy - needed for monomorphic objects
            this.has_stree = static_tree && static_tree.length;
        }
    }

    let static_l_desc;
    let static_d_desc;
    let static_bl_desc;

    class TreeDesc {
        constructor(dyn_tree, stat_desc) {
            this.dyn_tree = dyn_tree; /* the dynamic tree */
            this.max_code = 0; /* largest code with non zero frequency */
            this.stat_desc = stat_desc; /* the corresponding static tree */
        }
    }

    const d_code = (dist) => {
        return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
    };

    /* ===========================================================================
     * Output a short LSB first on the stream.
     * IN assertion: there is enough room in pendingBuf.
     */
    const put_short = (s, w) => {
        //    put_byte(s, (uch)((w) & 0xff));
        //    put_byte(s, (uch)((ush)(w) >> 8));
        s.pending_buf[s.pending++] = w & 0xff;
        s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
    };

    /* ===========================================================================
     * Send a value on a given number of bits.
     * IN assertion: length <= 16 and value fits in length bits.
     */
    const send_bits = (s, value, length) => {
        if (s.bi_valid > Buf_size - length) {
            s.bi_buf |= (value << s.bi_valid) & 0xffff;
            put_short(s, s.bi_buf);
            s.bi_buf = value >> (Buf_size - s.bi_valid);
            s.bi_valid += length - Buf_size;
        } else {
            s.bi_buf |= (value << s.bi_valid) & 0xffff;
            s.bi_valid += length;
        }
    };

    const send_code = (s, c, tree) => {
        send_bits(s, tree[c * 2] /*.Code*/, tree[c * 2 + 1] /*.Len*/);
    };

    /* ===========================================================================
     * Reverse the first len bits of a code, using straightforward code (a faster
     * method would use a table)
     * IN assertion: 1 <= len <= 15
     */
    const bi_reverse = (code, len) => {
        let res = 0;
        do {
            res |= code & 1;
            code >>>= 1;
            res <<= 1;
        } while (--len > 0);
        return res >>> 1;
    };

    /* ===========================================================================
     * Flush the bit buffer, keeping at most 7 bits in it.
     */
    const bi_flush = (s) => {
        if (s.bi_valid === 16) {
            put_short(s, s.bi_buf);
            s.bi_buf = 0;
            s.bi_valid = 0;
        } else if (s.bi_valid >= 8) {
            s.pending_buf[s.pending++] = s.bi_buf & 0xff;
            s.bi_buf >>= 8;
            s.bi_valid -= 8;
        }
    };

    /* ===========================================================================
     * Compute the optimal bit lengths for a tree and update the total bit length
     * for the current block.
     * IN assertion: the fields freq and dad are set, heap[heap_max] and
     *    above are the tree nodes sorted by increasing frequency.
     * OUT assertions: the field len is set to the optimal bit length, the
     *     array bl_count contains the frequencies for each bit length.
     *     The length opt_len is updated; static_len is also updated if stree is
     *     not null.
     */
    const gen_bitlen = (s, desc) => {
        //    deflate_state *s;
        //    tree_desc *desc;    /* the tree descriptor */

        const tree = desc.dyn_tree;
        const max_code = desc.max_code;
        const stree = desc.stat_desc.static_tree;
        const has_stree = desc.stat_desc.has_stree;
        const extra = desc.stat_desc.extra_bits;
        const base = desc.stat_desc.extra_base;
        const max_length = desc.stat_desc.max_length;
        let h; /* heap index */
        let n, m; /* iterate over the tree elements */
        let bits; /* bit length */
        let xbits; /* extra bits */
        let f; /* frequency */
        let overflow = 0; /* number of elements with bit length too large */

        for (bits = 0; bits <= MAX_BITS$1; bits++) {
            s.bl_count[bits] = 0;
        }

        /* In a first pass, compute the optimal bit lengths (which may
         * overflow in the case of the bit length tree).
         */
        tree[s.heap[s.heap_max] * 2 + 1] /*.Len*/ = 0; /* root of the heap */

        for (h = s.heap_max + 1; h < HEAP_SIZE$1; h++) {
            n = s.heap[h];
            bits = tree[tree[n * 2 + 1] /*.Dad*/ * 2 + 1] /*.Len*/ + 1;
            if (bits > max_length) {
                bits = max_length;
                overflow++;
            }
            tree[n * 2 + 1] /*.Len*/ = bits;
            /* We overwrite tree[n].Dad which is no longer needed */

            if (n > max_code) {
                continue;
            } /* not a leaf node */

            s.bl_count[bits]++;
            xbits = 0;
            if (n >= base) {
                xbits = extra[n - base];
            }
            f = tree[n * 2] /*.Freq*/;
            s.opt_len += f * (bits + xbits);
            if (has_stree) {
                s.static_len += f * (stree[n * 2 + 1] /*.Len*/ + xbits);
            }
        }
        if (overflow === 0) {
            return;
        }

        // Tracev((stderr,"\nbit length overflow\n"));
        /* This happens for example on obj2 and pic of the Calgary corpus */

        /* Find the first bit length which could increase: */
        do {
            bits = max_length - 1;
            while (s.bl_count[bits] === 0) {
                bits--;
            }
            s.bl_count[bits]--; /* move one leaf down the tree */
            s.bl_count[
                bits + 1
            ] += 2; /* move one overflow item as its brother */
            s.bl_count[max_length]--;
            /* The brother of the overflow item also moves one step up,
             * but this does not affect bl_count[max_length]
             */
            overflow -= 2;
        } while (overflow > 0);

        /* Now recompute all bit lengths, scanning in increasing frequency.
         * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
         * lengths instead of fixing only the wrong ones. This idea is taken
         * from 'ar' written by Haruhiko Okumura.)
         */
        for (bits = max_length; bits !== 0; bits--) {
            n = s.bl_count[bits];
            while (n !== 0) {
                m = s.heap[--h];
                if (m > max_code) {
                    continue;
                }
                if (tree[m * 2 + 1] /*.Len*/ !== bits) {
                    // Tracev((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                    s.opt_len +=
                        (bits - tree[m * 2 + 1]) /*.Len*/ *
                        tree[m * 2] /*.Freq*/;
                    tree[m * 2 + 1] /*.Len*/ = bits;
                }
                n--;
            }
        }
    };

    /* ===========================================================================
     * Generate the codes for a given tree and bit counts (which need not be
     * optimal).
     * IN assertion: the array bl_count contains the bit length statistics for
     * the given tree and the field len is set for all tree elements.
     * OUT assertion: the field code is set for all tree elements of non
     *     zero code length.
     */
    const gen_codes = (tree, max_code, bl_count) => {
        //    ct_data *tree;             /* the tree to decorate */
        //    int max_code;              /* largest code with non zero frequency */
        //    ushf *bl_count;            /* number of codes at each bit length */

        const next_code = new Array(
            MAX_BITS$1 + 1
        ); /* next code value for each bit length */
        let code = 0; /* running code value */
        let bits; /* bit index */
        let n; /* code index */

        /* The distribution counts are first used to generate the code values
         * without bit reversal.
         */
        for (bits = 1; bits <= MAX_BITS$1; bits++) {
            code = (code + bl_count[bits - 1]) << 1;
            next_code[bits] = code;
        }
        /* Check that the bit counts in bl_count are consistent. The last code
         * must be all ones.
         */
        //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
        //        "inconsistent bit counts");
        //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));

        for (n = 0; n <= max_code; n++) {
            let len = tree[n * 2 + 1]; /*.Len*/
            if (len === 0) {
                continue;
            }
            /* Now reverse the bits */
            tree[n * 2] /*.Code*/ = bi_reverse(next_code[len]++, len);

            //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
            //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
        }
    };

    /* ===========================================================================
     * Initialize the various 'constant' tables.
     */
    const tr_static_init = () => {
        let n; /* iterates over tree elements */
        let bits; /* bit counter */
        let length; /* length value */
        let code; /* code value */
        let dist; /* distance index */
        const bl_count = new Array(MAX_BITS$1 + 1);
        /* number of codes at each bit length for an optimal tree */

        // do check in _tr_init()
        //if (static_init_done) return;

        /* For some embedded targets, global variables are not initialized: */
        /*#ifdef NO_INIT_GLOBAL_POINTERS
    static_l_desc.static_tree = static_ltree;
    static_l_desc.extra_bits = extra_lbits;
    static_d_desc.static_tree = static_dtree;
    static_d_desc.extra_bits = extra_dbits;
    static_bl_desc.extra_bits = extra_blbits;
  #endif*/

        /* Initialize the mapping length (0..255) -> length code (0..28) */
        length = 0;
        for (code = 0; code < LENGTH_CODES$1 - 1; code++) {
            base_length[code] = length;
            for (n = 0; n < 1 << extra_lbits[code]; n++) {
                _length_code[length++] = code;
            }
        }
        //Assert (length == 256, "tr_static_init: length != 256");
        /* Note that the length 255 (match length 258) can be represented
         * in two different ways: code 284 + 5 bits or code 285, so we
         * overwrite length_code[255] to use the best encoding:
         */
        _length_code[length - 1] = code;

        /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
        dist = 0;
        for (code = 0; code < 16; code++) {
            base_dist[code] = dist;
            for (n = 0; n < 1 << extra_dbits[code]; n++) {
                _dist_code[dist++] = code;
            }
        }
        //Assert (dist == 256, "tr_static_init: dist != 256");
        dist >>= 7; /* from now on, all distances are divided by 128 */
        for (; code < D_CODES$1; code++) {
            base_dist[code] = dist << 7;
            for (n = 0; n < 1 << (extra_dbits[code] - 7); n++) {
                _dist_code[256 + dist++] = code;
            }
        }
        //Assert (dist == 256, "tr_static_init: 256+dist != 512");

        /* Construct the codes of the static literal tree */
        for (bits = 0; bits <= MAX_BITS$1; bits++) {
            bl_count[bits] = 0;
        }

        n = 0;
        while (n <= 143) {
            static_ltree[n * 2 + 1] /*.Len*/ = 8;
            n++;
            bl_count[8]++;
        }
        while (n <= 255) {
            static_ltree[n * 2 + 1] /*.Len*/ = 9;
            n++;
            bl_count[9]++;
        }
        while (n <= 279) {
            static_ltree[n * 2 + 1] /*.Len*/ = 7;
            n++;
            bl_count[7]++;
        }
        while (n <= 287) {
            static_ltree[n * 2 + 1] /*.Len*/ = 8;
            n++;
            bl_count[8]++;
        }
        /* Codes 286 and 287 do not exist, but we must include them in the
         * tree construction to get a canonical Huffman tree (longest code
         * all ones)
         */
        gen_codes(static_ltree, L_CODES$1 + 1, bl_count);

        /* The static distance tree is trivial: */
        for (n = 0; n < D_CODES$1; n++) {
            static_dtree[n * 2 + 1] /*.Len*/ = 5;
            static_dtree[n * 2] /*.Code*/ = bi_reverse(n, 5);
        }

        // Now data ready and we can init static trees
        static_l_desc = new StaticTreeDesc(
            static_ltree,
            extra_lbits,
            LITERALS$1 + 1,
            L_CODES$1,
            MAX_BITS$1
        );
        static_d_desc = new StaticTreeDesc(
            static_dtree,
            extra_dbits,
            0,
            D_CODES$1,
            MAX_BITS$1
        );
        static_bl_desc = new StaticTreeDesc(
            new Array(0),
            extra_blbits,
            0,
            BL_CODES$1,
            MAX_BL_BITS
        );

        //static_init_done = true;
    };

    /* ===========================================================================
     * Initialize a new block.
     */
    const init_block = (s) => {
        let n; /* iterates over tree elements */

        /* Initialize the trees. */
        for (n = 0; n < L_CODES$1; n++) {
            s.dyn_ltree[n * 2] /*.Freq*/ = 0;
        }
        for (n = 0; n < D_CODES$1; n++) {
            s.dyn_dtree[n * 2] /*.Freq*/ = 0;
        }
        for (n = 0; n < BL_CODES$1; n++) {
            s.bl_tree[n * 2] /*.Freq*/ = 0;
        }

        s.dyn_ltree[END_BLOCK * 2] /*.Freq*/ = 1;
        s.opt_len = s.static_len = 0;
        s.sym_next = s.matches = 0;
    };

    /* ===========================================================================
     * Flush the bit buffer and align the output on a byte boundary
     */
    const bi_windup = (s) => {
        if (s.bi_valid > 8) {
            put_short(s, s.bi_buf);
        } else if (s.bi_valid > 0) {
            //put_byte(s, (Byte)s->bi_buf);
            s.pending_buf[s.pending++] = s.bi_buf;
        }
        s.bi_buf = 0;
        s.bi_valid = 0;
    };

    /* ===========================================================================
     * Compares to subtrees, using the tree depth as tie breaker when
     * the subtrees have equal frequency. This minimizes the worst case length.
     */
    const smaller = (tree, n, m, depth) => {
        const _n2 = n * 2;
        const _m2 = m * 2;
        return (
            tree[_n2] /*.Freq*/ < tree[_m2] /*.Freq*/ ||
            (tree[_n2] /*.Freq*/ === tree[_m2] /*.Freq*/ &&
                depth[n] <= depth[m])
        );
    };

    /* ===========================================================================
     * Restore the heap property by moving down the tree starting at node k,
     * exchanging a node with the smallest of its two sons if necessary, stopping
     * when the heap property is re-established (each father smaller than its
     * two sons).
     */
    const pqdownheap = (s, tree, k) => {
        //    deflate_state *s;
        //    ct_data *tree;  /* the tree to restore */
        //    int k;               /* node to move down */

        const v = s.heap[k];
        let j = k << 1; /* left son of k */
        while (j <= s.heap_len) {
            /* Set j to the smallest of the two sons: */
            if (
                j < s.heap_len &&
                smaller(tree, s.heap[j + 1], s.heap[j], s.depth)
            ) {
                j++;
            }
            /* Exit if v is smaller than both sons */
            if (smaller(tree, v, s.heap[j], s.depth)) {
                break;
            }

            /* Exchange v with the smallest son */
            s.heap[k] = s.heap[j];
            k = j;

            /* And continue down the tree, setting j to the left son of k */
            j <<= 1;
        }
        s.heap[k] = v;
    };

    // inlined manually
    // const SMALLEST = 1;

    /* ===========================================================================
     * Send the block data compressed using the given Huffman trees
     */
    const compress_block = (s, ltree, dtree) => {
        //    deflate_state *s;
        //    const ct_data *ltree; /* literal tree */
        //    const ct_data *dtree; /* distance tree */

        let dist; /* distance of matched string */
        let lc; /* match length or unmatched char (if dist == 0) */
        let sx = 0; /* running index in sym_buf */
        let code; /* the code to send */
        let extra; /* number of extra bits to send */

        if (s.sym_next !== 0) {
            do {
                dist = s.pending_buf[s.sym_buf + sx++] & 0xff;
                dist += (s.pending_buf[s.sym_buf + sx++] & 0xff) << 8;
                lc = s.pending_buf[s.sym_buf + sx++];
                if (dist === 0) {
                    send_code(s, lc, ltree); /* send a literal byte */
                    //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
                } else {
                    /* Here, lc is the match length - MIN_MATCH */
                    code = _length_code[lc];
                    send_code(
                        s,
                        code + LITERALS$1 + 1,
                        ltree
                    ); /* send the length code */
                    extra = extra_lbits[code];
                    if (extra !== 0) {
                        lc -= base_length[code];
                        send_bits(
                            s,
                            lc,
                            extra
                        ); /* send the extra length bits */
                    }
                    dist--; /* dist is now the match distance - 1 */
                    code = d_code(dist);
                    //Assert (code < D_CODES, "bad d_code");

                    send_code(s, code, dtree); /* send the distance code */
                    extra = extra_dbits[code];
                    if (extra !== 0) {
                        dist -= base_dist[code];
                        send_bits(
                            s,
                            dist,
                            extra
                        ); /* send the extra distance bits */
                    }
                } /* literal or match pair ? */

                /* Check that the overlay between pending_buf and sym_buf is ok: */
                //Assert(s->pending < s->lit_bufsize + sx, "pendingBuf overflow");
            } while (sx < s.sym_next);
        }

        send_code(s, END_BLOCK, ltree);
    };

    /* ===========================================================================
     * Construct one Huffman tree and assigns the code bit strings and lengths.
     * Update the total bit length for the current block.
     * IN assertion: the field freq is set for all tree elements.
     * OUT assertions: the fields len and code are set to the optimal bit length
     *     and corresponding code. The length opt_len is updated; static_len is
     *     also updated if stree is not null. The field max_code is set.
     */
    const build_tree = (s, desc) => {
        //    deflate_state *s;
        //    tree_desc *desc; /* the tree descriptor */

        const tree = desc.dyn_tree;
        const stree = desc.stat_desc.static_tree;
        const has_stree = desc.stat_desc.has_stree;
        const elems = desc.stat_desc.elems;
        let n, m; /* iterate over heap elements */
        let max_code = -1; /* largest code with non zero frequency */
        let node; /* new node being created */

        /* Construct the initial heap, with least frequent element in
         * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
         * heap[0] is not used.
         */
        s.heap_len = 0;
        s.heap_max = HEAP_SIZE$1;

        for (n = 0; n < elems; n++) {
            if (tree[n * 2] /*.Freq*/ !== 0) {
                s.heap[++s.heap_len] = max_code = n;
                s.depth[n] = 0;
            } else {
                tree[n * 2 + 1] /*.Len*/ = 0;
            }
        }

        /* The pkzip format requires that at least one distance code exists,
         * and that at least one bit should be sent even if there is only one
         * possible code. So to avoid special checks later on we force at least
         * two codes of non zero frequency.
         */
        while (s.heap_len < 2) {
            node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
            tree[node * 2] /*.Freq*/ = 1;
            s.depth[node] = 0;
            s.opt_len--;

            if (has_stree) {
                s.static_len -= stree[node * 2 + 1] /*.Len*/;
            }
            /* node is 0 or 1 so it does not have extra bits */
        }
        desc.max_code = max_code;

        /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
         * establish sub-heaps of increasing lengths:
         */
        for (n = s.heap_len >> 1 /*int /2*/; n >= 1; n--) {
            pqdownheap(s, tree, n);
        }

        /* Construct the Huffman tree by repeatedly combining the least two
         * frequent nodes.
         */
        node = elems; /* next internal node of the tree */
        do {
            //pqremove(s, tree, n);  /* n = node of least frequency */
            /*** pqremove ***/
            n = s.heap[1 /*SMALLEST*/];
            s.heap[1 /*SMALLEST*/] = s.heap[s.heap_len--];
            pqdownheap(s, tree, 1 /*SMALLEST*/);
            /***/

            m = s.heap[1 /*SMALLEST*/]; /* m = node of next least frequency */

            s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
            s.heap[--s.heap_max] = m;

            /* Create a new node father of n and m */
            tree[node * 2] /*.Freq*/ =
                tree[n * 2] /*.Freq*/ + tree[m * 2] /*.Freq*/;
            s.depth[node] =
                (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
            tree[n * 2 + 1] /*.Dad*/ = tree[m * 2 + 1] /*.Dad*/ = node;

            /* and insert the new node in the heap */
            s.heap[1 /*SMALLEST*/] = node++;
            pqdownheap(s, tree, 1 /*SMALLEST*/);
        } while (s.heap_len >= 2);

        s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/];

        /* At this point, the fields freq and dad are set. We can now
         * generate the bit lengths.
         */
        gen_bitlen(s, desc);

        /* The field len is now set, we can generate the bit codes */
        gen_codes(tree, max_code, s.bl_count);
    };

    /* ===========================================================================
     * Scan a literal or distance tree to determine the frequencies of the codes
     * in the bit length tree.
     */
    const scan_tree = (s, tree, max_code) => {
        //    deflate_state *s;
        //    ct_data *tree;   /* the tree to be scanned */
        //    int max_code;    /* and its largest code of non zero frequency */

        let n; /* iterates over all tree elements */
        let prevlen = -1; /* last emitted length */
        let curlen; /* length of current code */

        let nextlen = tree[0 * 2 + 1]; /*.Len*/ /* length of next code */

        let count = 0; /* repeat count of the current code */
        let max_count = 7; /* max repeat count */
        let min_count = 4; /* min repeat count */

        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        }
        tree[(max_code + 1) * 2 + 1] /*.Len*/ = 0xffff; /* guard */

        for (n = 0; n <= max_code; n++) {
            curlen = nextlen;
            nextlen = tree[(n + 1) * 2 + 1] /*.Len*/;

            if (++count < max_count && curlen === nextlen) {
                continue;
            } else if (count < min_count) {
                s.bl_tree[curlen * 2] /*.Freq*/ += count;
            } else if (curlen !== 0) {
                if (curlen !== prevlen) {
                    s.bl_tree[curlen * 2] /*.Freq*/++;
                }
                s.bl_tree[REP_3_6 * 2] /*.Freq*/++;
            } else if (count <= 10) {
                s.bl_tree[REPZ_3_10 * 2] /*.Freq*/++;
            } else {
                s.bl_tree[REPZ_11_138 * 2] /*.Freq*/++;
            }

            count = 0;
            prevlen = curlen;

            if (nextlen === 0) {
                max_count = 138;
                min_count = 3;
            } else if (curlen === nextlen) {
                max_count = 6;
                min_count = 3;
            } else {
                max_count = 7;
                min_count = 4;
            }
        }
    };

    /* ===========================================================================
     * Send a literal or distance tree in compressed form, using the codes in
     * bl_tree.
     */
    const send_tree = (s, tree, max_code) => {
        //    deflate_state *s;
        //    ct_data *tree; /* the tree to be scanned */
        //    int max_code;       /* and its largest code of non zero frequency */

        let n; /* iterates over all tree elements */
        let prevlen = -1; /* last emitted length */
        let curlen; /* length of current code */

        let nextlen = tree[0 * 2 + 1]; /*.Len*/ /* length of next code */

        let count = 0; /* repeat count of the current code */
        let max_count = 7; /* max repeat count */
        let min_count = 4; /* min repeat count */

        /* tree[max_code+1].Len = -1; */ /* guard already set */
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        }

        for (n = 0; n <= max_code; n++) {
            curlen = nextlen;
            nextlen = tree[(n + 1) * 2 + 1] /*.Len*/;

            if (++count < max_count && curlen === nextlen) {
                continue;
            } else if (count < min_count) {
                do {
                    send_code(s, curlen, s.bl_tree);
                } while (--count !== 0);
            } else if (curlen !== 0) {
                if (curlen !== prevlen) {
                    send_code(s, curlen, s.bl_tree);
                    count--;
                }
                //Assert(count >= 3 && count <= 6, " 3_6?");
                send_code(s, REP_3_6, s.bl_tree);
                send_bits(s, count - 3, 2);
            } else if (count <= 10) {
                send_code(s, REPZ_3_10, s.bl_tree);
                send_bits(s, count - 3, 3);
            } else {
                send_code(s, REPZ_11_138, s.bl_tree);
                send_bits(s, count - 11, 7);
            }

            count = 0;
            prevlen = curlen;
            if (nextlen === 0) {
                max_count = 138;
                min_count = 3;
            } else if (curlen === nextlen) {
                max_count = 6;
                min_count = 3;
            } else {
                max_count = 7;
                min_count = 4;
            }
        }
    };

    /* ===========================================================================
     * Construct the Huffman tree for the bit lengths and return the index in
     * bl_order of the last bit length code to send.
     */
    const build_bl_tree = (s) => {
        let max_blindex; /* index of last bit length code of non zero freq */

        /* Determine the bit length frequencies for literal and distance trees */
        scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
        scan_tree(s, s.dyn_dtree, s.d_desc.max_code);

        /* Build the bit length tree: */
        build_tree(s, s.bl_desc);
        /* opt_len now includes the length of the tree representations, except
         * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
         */

        /* Determine the number of bit length codes to send. The pkzip format
         * requires that at least 4 bit length codes be sent. (appnote.txt says
         * 3 but the actual value used is 4.)
         */
        for (max_blindex = BL_CODES$1 - 1; max_blindex >= 3; max_blindex--) {
            if (s.bl_tree[bl_order[max_blindex] * 2 + 1] /*.Len*/ !== 0) {
                break;
            }
        }
        /* Update opt_len to include the bit length tree and counts */
        s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
        //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
        //        s->opt_len, s->static_len));

        return max_blindex;
    };

    /* ===========================================================================
     * Send the header for a block using dynamic Huffman trees: the counts, the
     * lengths of the bit length codes, the literal tree and the distance tree.
     * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
     */
    const send_all_trees = (s, lcodes, dcodes, blcodes) => {
        //    deflate_state *s;
        //    int lcodes, dcodes, blcodes; /* number of codes for each tree */

        let rank; /* index in bl_order */

        //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
        //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
        //        "too many codes");
        //Tracev((stderr, "\nbl counts: "));
        send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
        send_bits(s, dcodes - 1, 5);
        send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */
        for (rank = 0; rank < blcodes; rank++) {
            //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
            send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1] /*.Len*/, 3);
        }
        //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));

        send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
        //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));

        send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
        //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
    };

    /* ===========================================================================
     * Check if the data type is TEXT or BINARY, using the following algorithm:
     * - TEXT if the two conditions below are satisfied:
     *    a) There are no non-portable control characters belonging to the
     *       "block list" (0..6, 14..25, 28..31).
     *    b) There is at least one printable character belonging to the
     *       "allow list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
     * - BINARY otherwise.
     * - The following partially-portable control characters form a
     *   "gray list" that is ignored in this detection algorithm:
     *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
     * IN assertion: the fields Freq of dyn_ltree are set.
     */
    const detect_data_type = (s) => {
        /* block_mask is the bit mask of block-listed bytes
         * set bits 0..6, 14..25, and 28..31
         * 0xf3ffc07f = binary 11110011111111111100000001111111
         */
        let block_mask = 0xf3ffc07f;
        let n;

        /* Check for non-textual ("block-listed") bytes. */
        for (n = 0; n <= 31; n++, block_mask >>>= 1) {
            if (block_mask & 1 && s.dyn_ltree[n * 2] /*.Freq*/ !== 0) {
                return Z_BINARY;
            }
        }

        /* Check for textual ("allow-listed") bytes. */
        if (
            s.dyn_ltree[9 * 2] /*.Freq*/ !== 0 ||
            s.dyn_ltree[10 * 2] /*.Freq*/ !== 0 ||
            s.dyn_ltree[13 * 2] /*.Freq*/ !== 0
        ) {
            return Z_TEXT;
        }
        for (n = 32; n < LITERALS$1; n++) {
            if (s.dyn_ltree[n * 2] /*.Freq*/ !== 0) {
                return Z_TEXT;
            }
        }

        /* There are no "block-listed" or "allow-listed" bytes:
         * this stream either is empty or has tolerated ("gray-listed") bytes only.
         */
        return Z_BINARY;
    };

    let static_init_done = false;

    /* ===========================================================================
     * Initialize the tree data structures for a new zlib stream.
     */
    const _tr_init$1 = (s) => {
        if (!static_init_done) {
            tr_static_init();
            static_init_done = true;
        }

        s.l_desc = new TreeDesc(s.dyn_ltree, static_l_desc);
        s.d_desc = new TreeDesc(s.dyn_dtree, static_d_desc);
        s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);

        s.bi_buf = 0;
        s.bi_valid = 0;

        /* Initialize the first block of the first file: */
        init_block(s);
    };

    /* ===========================================================================
     * Send a stored block
     */
    const _tr_stored_block$1 = (s, buf, stored_len, last) => {
        //DeflateState *s;
        //charf *buf;       /* input block */
        //ulg stored_len;   /* length of input block */
        //int last;         /* one if this is the last block for a file */

        send_bits(
            s,
            (STORED_BLOCK << 1) + (last ? 1 : 0),
            3
        ); /* send block type */
        bi_windup(s); /* align on byte boundary */
        put_short(s, stored_len);
        put_short(s, ~stored_len);
        if (stored_len) {
            s.pending_buf.set(
                s.window.subarray(buf, buf + stored_len),
                s.pending
            );
        }
        s.pending += stored_len;
    };

    /* ===========================================================================
     * Send one empty static block to give enough lookahead for inflate.
     * This takes 10 bits, of which 7 may remain in the bit buffer.
     */
    const _tr_align$1 = (s) => {
        send_bits(s, STATIC_TREES << 1, 3);
        send_code(s, END_BLOCK, static_ltree);
        bi_flush(s);
    };

    /* ===========================================================================
     * Determine the best encoding for the current block: dynamic trees, static
     * trees or store, and write out the encoded block.
     */
    const _tr_flush_block$1 = (s, buf, stored_len, last) => {
        //DeflateState *s;
        //charf *buf;       /* input block, or NULL if too old */
        //ulg stored_len;   /* length of input block */
        //int last;         /* one if this is the last block for a file */

        let opt_lenb, static_lenb; /* opt_len and static_len in bytes */
        let max_blindex = 0; /* index of last bit length code of non zero freq */

        /* Build the Huffman trees unless a stored block is forced */
        if (s.level > 0) {
            /* Check if the file is binary or text */
            if (s.strm.data_type === Z_UNKNOWN$1) {
                s.strm.data_type = detect_data_type(s);
            }

            /* Construct the literal and distance trees */
            build_tree(s, s.l_desc);
            // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
            //        s->static_len));

            build_tree(s, s.d_desc);
            // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
            //        s->static_len));
            /* At this point, opt_len and static_len are the total bit lengths of
             * the compressed block data, excluding the tree representations.
             */

            /* Build the bit length tree for the above two trees, and get the index
             * in bl_order of the last bit length code to send.
             */
            max_blindex = build_bl_tree(s);

            /* Determine the best encoding. Compute the block lengths in bytes. */
            opt_lenb = (s.opt_len + 3 + 7) >>> 3;
            static_lenb = (s.static_len + 3 + 7) >>> 3;

            // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
            //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
            //        s->sym_next / 3));

            if (static_lenb <= opt_lenb) {
                opt_lenb = static_lenb;
            }
        } else {
            // Assert(buf != (char*)0, "lost buf");
            opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
        }

        if (stored_len + 4 <= opt_lenb && buf !== -1) {
            /* 4: two words for the lengths */

            /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
             * Otherwise we can't have processed more than WSIZE input bytes since
             * the last block flush, because compression would have been
             * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
             * transform a block into a stored block.
             */
            _tr_stored_block$1(s, buf, stored_len, last);
        } else if (s.strategy === Z_FIXED$1 || static_lenb === opt_lenb) {
            send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
            compress_block(s, static_ltree, static_dtree);
        } else {
            send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
            send_all_trees(
                s,
                s.l_desc.max_code + 1,
                s.d_desc.max_code + 1,
                max_blindex + 1
            );
            compress_block(s, s.dyn_ltree, s.dyn_dtree);
        }
        // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
        /* The above check is made mod 2^32, for files larger than 512 MB
         * and uLong implemented on 32 bits.
         */
        init_block(s);

        if (last) {
            bi_windup(s);
        }
        // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
        //       s->compressed_len-7*last));
    };

    /* ===========================================================================
     * Save the match info and tally the frequency counts. Return true if
     * the current block must be flushed.
     */
    const _tr_tally$1 = (s, dist, lc) => {
        //    deflate_state *s;
        //    unsigned dist;  /* distance of matched string */
        //    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */

        s.pending_buf[s.sym_buf + s.sym_next++] = dist;
        s.pending_buf[s.sym_buf + s.sym_next++] = dist >> 8;
        s.pending_buf[s.sym_buf + s.sym_next++] = lc;
        if (dist === 0) {
            /* lc is the unmatched char */
            s.dyn_ltree[lc * 2] /*.Freq*/++;
        } else {
            s.matches++;
            /* Here, lc is the match length - MIN_MATCH */
            dist--; /* dist = match distance - 1 */
            //Assert((ush)dist < (ush)MAX_DIST(s) &&
            //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
            //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");

            s.dyn_ltree[(_length_code[lc] + LITERALS$1 + 1) * 2] /*.Freq*/++;
            s.dyn_dtree[d_code(dist) * 2] /*.Freq*/++;
        }

        return s.sym_next === s.sym_end;
    };

    var _tr_init_1 = _tr_init$1;
    var _tr_stored_block_1 = _tr_stored_block$1;
    var _tr_flush_block_1 = _tr_flush_block$1;
    var _tr_tally_1 = _tr_tally$1;
    var _tr_align_1 = _tr_align$1;

    var trees = {
        _tr_init: _tr_init_1,
        _tr_stored_block: _tr_stored_block_1,
        _tr_flush_block: _tr_flush_block_1,
        _tr_tally: _tr_tally_1,
        _tr_align: _tr_align_1,
    };

    // Note: adler32 takes 12% for level 0 and 2% for level 6.
    // It isn't worth it to make additional optimizations as in original.
    // Small size is preferable.

    // (C) 1995-2013 Jean-loup Gailly and Mark Adler
    // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
    //
    // This software is provided 'as-is', without any express or implied
    // warranty. In no event will the authors be held liable for any damages
    // arising from the use of this software.
    //
    // Permission is granted to anyone to use this software for any purpose,
    // including commercial applications, and to alter it and redistribute it
    // freely, subject to the following restrictions:
    //
    // 1. The origin of this software must not be misrepresented; you must not
    //   claim that you wrote the original software. If you use this software
    //   in a product, an acknowledgment in the product documentation would be
    //   appreciated but is not required.
    // 2. Altered source versions must be plainly marked as such, and must not be
    //   misrepresented as being the original software.
    // 3. This notice may not be removed or altered from any source distribution.

    const adler32 = (adler, buf, len, pos) => {
        let s1 = (adler & 0xffff) | 0,
            s2 = ((adler >>> 16) & 0xffff) | 0,
            n = 0;

        while (len !== 0) {
            // Set limit ~ twice less than 5552, to keep
            // s2 in 31-bits, because we force signed ints.
            // in other case %= will fail.
            n = len > 2000 ? 2000 : len;
            len -= n;

            do {
                s1 = (s1 + buf[pos++]) | 0;
                s2 = (s2 + s1) | 0;
            } while (--n);

            s1 %= 65521;
            s2 %= 65521;
        }

        return s1 | (s2 << 16) | 0;
    };

    var adler32_1 = adler32;

    // Note: we can't get significant speed boost here.
    // So write code to minimize size - no pregenerated tables
    // and array tools dependencies.

    // (C) 1995-2013 Jean-loup Gailly and Mark Adler
    // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
    //
    // This software is provided 'as-is', without any express or implied
    // warranty. In no event will the authors be held liable for any damages
    // arising from the use of this software.
    //
    // Permission is granted to anyone to use this software for any purpose,
    // including commercial applications, and to alter it and redistribute it
    // freely, subject to the following restrictions:
    //
    // 1. The origin of this software must not be misrepresented; you must not
    //   claim that you wrote the original software. If you use this software
    //   in a product, an acknowledgment in the product documentation would be
    //   appreciated but is not required.
    // 2. Altered source versions must be plainly marked as such, and must not be
    //   misrepresented as being the original software.
    // 3. This notice may not be removed or altered from any source distribution.

    // Use ordinary array, since untyped makes no boost here
    const makeTable = () => {
        let c,
            table = [];

        for (var n = 0; n < 256; n++) {
            c = n;
            for (var k = 0; k < 8; k++) {
                c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
            }
            table[n] = c;
        }

        return table;
    };

    // Create table on load. Just 255 signed longs. Not a problem.
    const crcTable = new Uint32Array(makeTable());

    const crc32 = (crc, buf, len, pos) => {
        const t = crcTable;
        const end = pos + len;

        crc ^= -1;

        for (let i = pos; i < end; i++) {
            crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xff];
        }

        return crc ^ -1; // >>> 0;
    };

    var crc32_1 = crc32;

    // (C) 1995-2013 Jean-loup Gailly and Mark Adler
    // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
    //
    // This software is provided 'as-is', without any express or implied
    // warranty. In no event will the authors be held liable for any damages
    // arising from the use of this software.
    //
    // Permission is granted to anyone to use this software for any purpose,
    // including commercial applications, and to alter it and redistribute it
    // freely, subject to the following restrictions:
    //
    // 1. The origin of this software must not be misrepresented; you must not
    //   claim that you wrote the original software. If you use this software
    //   in a product, an acknowledgment in the product documentation would be
    //   appreciated but is not required.
    // 2. Altered source versions must be plainly marked as such, and must not be
    //   misrepresented as being the original software.
    // 3. This notice may not be removed or altered from any source distribution.

    var messages = {
        2: "need dictionary" /* Z_NEED_DICT       2  */,
        1: "stream end" /* Z_STREAM_END      1  */,
        0: "" /* Z_OK              0  */,
        "-1": "file error" /* Z_ERRNO         (-1) */,
        "-2": "stream error" /* Z_STREAM_ERROR  (-2) */,
        "-3": "data error" /* Z_DATA_ERROR    (-3) */,
        "-4": "insufficient memory" /* Z_MEM_ERROR     (-4) */,
        "-5": "buffer error" /* Z_BUF_ERROR     (-5) */,
        "-6": "incompatible version" /* Z_VERSION_ERROR (-6) */,
    };

    // (C) 1995-2013 Jean-loup Gailly and Mark Adler
    // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
    //
    // This software is provided 'as-is', without any express or implied
    // warranty. In no event will the authors be held liable for any damages
    // arising from the use of this software.
    //
    // Permission is granted to anyone to use this software for any purpose,
    // including commercial applications, and to alter it and redistribute it
    // freely, subject to the following restrictions:
    //
    // 1. The origin of this software must not be misrepresented; you must not
    //   claim that you wrote the original software. If you use this software
    //   in a product, an acknowledgment in the product documentation would be
    //   appreciated but is not required.
    // 2. Altered source versions must be plainly marked as such, and must not be
    //   misrepresented as being the original software.
    // 3. This notice may not be removed or altered from any source distribution.

    var constants$2 = {
        /* Allowed flush values; see deflate() and inflate() below for details */
        Z_NO_FLUSH: 0,
        Z_PARTIAL_FLUSH: 1,
        Z_SYNC_FLUSH: 2,
        Z_FULL_FLUSH: 3,
        Z_FINISH: 4,
        Z_BLOCK: 5,
        Z_TREES: 6,

        /* Return codes for the compression/decompression functions. Negative values
         * are errors, positive values are used for special but normal events.
         */
        Z_OK: 0,
        Z_STREAM_END: 1,
        Z_NEED_DICT: 2,
        Z_ERRNO: -1,
        Z_STREAM_ERROR: -2,
        Z_DATA_ERROR: -3,
        Z_MEM_ERROR: -4,
        Z_BUF_ERROR: -5,
        //Z_VERSION_ERROR: -6,

        /* compression levels */
        Z_NO_COMPRESSION: 0,
        Z_BEST_SPEED: 1,
        Z_BEST_COMPRESSION: 9,
        Z_DEFAULT_COMPRESSION: -1,

        Z_FILTERED: 1,
        Z_HUFFMAN_ONLY: 2,
        Z_RLE: 3,
        Z_FIXED: 4,
        Z_DEFAULT_STRATEGY: 0,

        /* Possible values of the data_type field (though see inflate()) */
        Z_BINARY: 0,
        Z_TEXT: 1,
        //Z_ASCII:                1, // = Z_TEXT (deprecated)
        Z_UNKNOWN: 2,

        /* The deflate compression method */
        Z_DEFLATED: 8,
        //Z_NULL:                 null // Use -1 or null inline, depending on var type
    };

    // (C) 1995-2013 Jean-loup Gailly and Mark Adler
    // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
    //
    // This software is provided 'as-is', without any express or implied
    // warranty. In no event will the authors be held liable for any damages
    // arising from the use of this software.
    //
    // Permission is granted to anyone to use this software for any purpose,
    // including commercial applications, and to alter it and redistribute it
    // freely, subject to the following restrictions:
    //
    // 1. The origin of this software must not be misrepresented; you must not
    //   claim that you wrote the original software. If you use this software
    //   in a product, an acknowledgment in the product documentation would be
    //   appreciated but is not required.
    // 2. Altered source versions must be plainly marked as such, and must not be
    //   misrepresented as being the original software.
    // 3. This notice may not be removed or altered from any source distribution.

    const {
        _tr_init,
        _tr_stored_block,
        _tr_flush_block,
        _tr_tally,
        _tr_align,
    } = trees;

    /* Public constants ==========================================================*/
    /* ===========================================================================*/

    const {
        Z_NO_FLUSH: Z_NO_FLUSH$2,
        Z_PARTIAL_FLUSH,
        Z_FULL_FLUSH: Z_FULL_FLUSH$1,
        Z_FINISH: Z_FINISH$3,
        Z_BLOCK: Z_BLOCK$1,
        Z_OK: Z_OK$3,
        Z_STREAM_END: Z_STREAM_END$3,
        Z_STREAM_ERROR: Z_STREAM_ERROR$2,
        Z_DATA_ERROR: Z_DATA_ERROR$2,
        Z_BUF_ERROR: Z_BUF_ERROR$1,
        Z_DEFAULT_COMPRESSION: Z_DEFAULT_COMPRESSION$1,
        Z_FILTERED,
        Z_HUFFMAN_ONLY,
        Z_RLE,
        Z_FIXED,
        Z_DEFAULT_STRATEGY: Z_DEFAULT_STRATEGY$1,
        Z_UNKNOWN,
        Z_DEFLATED: Z_DEFLATED$2,
    } = constants$2;

    /*============================================================================*/

    const MAX_MEM_LEVEL = 9;
    /* Maximum value for memLevel in deflateInit2 */
    const MAX_WBITS$1 = 15;
    /* 32K LZ77 window */
    const DEF_MEM_LEVEL = 8;

    const LENGTH_CODES = 29;
    /* number of length codes, not counting the special END_BLOCK code */
    const LITERALS = 256;
    /* number of literal bytes 0..255 */
    const L_CODES = LITERALS + 1 + LENGTH_CODES;
    /* number of Literal or Length codes, including the END_BLOCK code */
    const D_CODES = 30;
    /* number of distance codes */
    const BL_CODES = 19;
    /* number of codes used to transfer the bit lengths */
    const HEAP_SIZE = 2 * L_CODES + 1;
    /* maximum heap size */
    const MAX_BITS = 15;
    /* All codes must not exceed MAX_BITS bits */

    const MIN_MATCH = 3;
    const MAX_MATCH = 258;
    const MIN_LOOKAHEAD = MAX_MATCH + MIN_MATCH + 1;

    const PRESET_DICT = 0x20;

    const INIT_STATE = 42; /* zlib header -> BUSY_STATE */
    //#ifdef GZIP
    const GZIP_STATE = 57; /* gzip header -> BUSY_STATE | EXTRA_STATE */
    //#endif
    const EXTRA_STATE = 69; /* gzip extra block -> NAME_STATE */
    const NAME_STATE = 73; /* gzip file name -> COMMENT_STATE */
    const COMMENT_STATE = 91; /* gzip comment -> HCRC_STATE */
    const HCRC_STATE = 103; /* gzip header CRC -> BUSY_STATE */
    const BUSY_STATE = 113; /* deflate -> FINISH_STATE */
    const FINISH_STATE = 666; /* stream complete */

    const BS_NEED_MORE = 1; /* block not completed, need more input or more output */
    const BS_BLOCK_DONE = 2; /* block flush performed */
    const BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
    const BS_FINISH_DONE = 4; /* finish done, accept no more input or output */

    const OS_CODE = 0x03; // Unix :) . Don't detect, use this default.

    const err = (strm, errorCode) => {
        strm.msg = messages[errorCode];
        return errorCode;
    };

    const rank = (f) => {
        return f * 2 - (f > 4 ? 9 : 0);
    };

    const zero = (buf) => {
        let len = buf.length;
        while (--len >= 0) {
            buf[len] = 0;
        }
    };

    /* ===========================================================================
     * Slide the hash table when sliding the window down (could be avoided with 32
     * bit values at the expense of memory usage). We slide even when level == 0 to
     * keep the hash table consistent if we switch back to level > 0 later.
     */
    const slide_hash = (s) => {
        let n, m;
        let p;
        let wsize = s.w_size;

        n = s.hash_size;
        p = n;
        do {
            m = s.head[--p];
            s.head[p] = m >= wsize ? m - wsize : 0;
        } while (--n);
        n = wsize;
        //#ifndef FASTEST
        p = n;
        do {
            m = s.prev[--p];
            s.prev[p] = m >= wsize ? m - wsize : 0;
            /* If n is not on any hash chain, prev[n] is garbage but
             * its value will never be used.
             */
        } while (--n);
        //#endif
    };

    /* eslint-disable new-cap */
    let HASH_ZLIB = (s, prev, data) =>
        ((prev << s.hash_shift) ^ data) & s.hash_mask;
    // This hash causes less collisions, https://github.com/nodeca/pako/issues/135
    // But breaks binary compatibility
    //let HASH_FAST = (s, prev, data) => ((prev << 8) + (prev >> 8) + (data << 4)) & s.hash_mask;
    let HASH = HASH_ZLIB;

    /* =========================================================================
     * Flush as much pending output as possible. All deflate() output, except for
     * some deflate_stored() output, goes through this function so some
     * applications may wish to modify it to avoid allocating a large
     * strm->next_out buffer and copying into it. (See also read_buf()).
     */
    const flush_pending = (strm) => {
        const s = strm.state;

        //_tr_flush_bits(s);
        let len = s.pending;
        if (len > strm.avail_out) {
            len = strm.avail_out;
        }
        if (len === 0) {
            return;
        }

        strm.output.set(
            s.pending_buf.subarray(s.pending_out, s.pending_out + len),
            strm.next_out
        );
        strm.next_out += len;
        s.pending_out += len;
        strm.total_out += len;
        strm.avail_out -= len;
        s.pending -= len;
        if (s.pending === 0) {
            s.pending_out = 0;
        }
    };

    const flush_block_only = (s, last) => {
        _tr_flush_block(
            s,
            s.block_start >= 0 ? s.block_start : -1,
            s.strstart - s.block_start,
            last
        );
        s.block_start = s.strstart;
        flush_pending(s.strm);
    };

    const put_byte = (s, b) => {
        s.pending_buf[s.pending++] = b;
    };

    /* =========================================================================
     * Put a short in the pending buffer. The 16-bit value is put in MSB order.
     * IN assertion: the stream state is correct and there is enough room in
     * pending_buf.
     */
    const putShortMSB = (s, b) => {
        //  put_byte(s, (Byte)(b >> 8));
        //  put_byte(s, (Byte)(b & 0xff));
        s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
        s.pending_buf[s.pending++] = b & 0xff;
    };

    /* ===========================================================================
     * Read a new buffer from the current input stream, update the adler32
     * and total number of bytes read.  All deflate() input goes through
     * this function so some applications may wish to modify it to avoid
     * allocating a large strm->input buffer and copying from it.
     * (See also flush_pending()).
     */
    const read_buf = (strm, buf, start, size) => {
        let len = strm.avail_in;

        if (len > size) {
            len = size;
        }
        if (len === 0) {
            return 0;
        }

        strm.avail_in -= len;

        // zmemcpy(buf, strm->next_in, len);
        buf.set(strm.input.subarray(strm.next_in, strm.next_in + len), start);
        if (strm.state.wrap === 1) {
            strm.adler = adler32_1(strm.adler, buf, len, start);
        } else if (strm.state.wrap === 2) {
            strm.adler = crc32_1(strm.adler, buf, len, start);
        }

        strm.next_in += len;
        strm.total_in += len;

        return len;
    };

    /* ===========================================================================
     * Set match_start to the longest match starting at the given string and
     * return its length. Matches shorter or equal to prev_length are discarded,
     * in which case the result is equal to prev_length and match_start is
     * garbage.
     * IN assertions: cur_match is the head of the hash chain for the current
     *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
     * OUT assertion: the match length is not greater than s->lookahead.
     */
    const longest_match = (s, cur_match) => {
        let chain_length = s.max_chain_length; /* max hash chain length */
        let scan = s.strstart; /* current string */
        let match; /* matched string */
        let len; /* length of current match */
        let best_len = s.prev_length; /* best match length so far */
        let nice_match = s.nice_match; /* stop if match long enough */
        const limit =
            s.strstart > s.w_size - MIN_LOOKAHEAD
                ? s.strstart - (s.w_size - MIN_LOOKAHEAD)
                : 0; /*NIL*/

        const _win = s.window; // shortcut

        const wmask = s.w_mask;
        const prev = s.prev;

        /* Stop when cur_match becomes <= limit. To simplify the code,
         * we prevent matches with the string of window index 0.
         */

        const strend = s.strstart + MAX_MATCH;
        let scan_end1 = _win[scan + best_len - 1];
        let scan_end = _win[scan + best_len];

        /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
         * It is easy to get rid of this optimization if necessary.
         */
        // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");

        /* Do not waste too much time if we already have a good match: */
        if (s.prev_length >= s.good_match) {
            chain_length >>= 2;
        }
        /* Do not look for matches beyond the end of the input. This is necessary
         * to make deflate deterministic.
         */
        if (nice_match > s.lookahead) {
            nice_match = s.lookahead;
        }

        // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");

        do {
            // Assert(cur_match < s->strstart, "no future");
            match = cur_match;

            /* Skip to next match if the match length cannot increase
             * or if the match length is less than 2.  Note that the checks below
             * for insufficient lookahead only occur occasionally for performance
             * reasons.  Therefore uninitialized memory will be accessed, and
             * conditional jumps will be made that depend on those values.
             * However the length of the match is limited to the lookahead, so
             * the output of deflate is not affected by the uninitialized values.
             */

            if (
                _win[match + best_len] !== scan_end ||
                _win[match + best_len - 1] !== scan_end1 ||
                _win[match] !== _win[scan] ||
                _win[++match] !== _win[scan + 1]
            ) {
                continue;
            }

            /* The check at best_len-1 can be removed because it will be made
             * again later. (This heuristic is not always a win.)
             * It is not necessary to compare scan[2] and match[2] since they
             * are always equal when the other bytes match, given that
             * the hash keys are equal and that HASH_BITS >= 8.
             */
            scan += 2;
            match++;
            // Assert(*scan == *match, "match[2]?");

            /* We check for insufficient lookahead only every 8th comparison;
             * the 256th check will be made at strstart+258.
             */
            do {
                /*jshint noempty:false*/
            } while (
                _win[++scan] === _win[++match] &&
                _win[++scan] === _win[++match] &&
                _win[++scan] === _win[++match] &&
                _win[++scan] === _win[++match] &&
                _win[++scan] === _win[++match] &&
                _win[++scan] === _win[++match] &&
                _win[++scan] === _win[++match] &&
                _win[++scan] === _win[++match] &&
                scan < strend
            );

            // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");

            len = MAX_MATCH - (strend - scan);
            scan = strend - MAX_MATCH;

            if (len > best_len) {
                s.match_start = cur_match;
                best_len = len;
                if (len >= nice_match) {
                    break;
                }
                scan_end1 = _win[scan + best_len - 1];
                scan_end = _win[scan + best_len];
            }
        } while (
            (cur_match = prev[cur_match & wmask]) > limit &&
            --chain_length !== 0
        );

        if (best_len <= s.lookahead) {
            return best_len;
        }
        return s.lookahead;
    };

    /* ===========================================================================
     * Fill the window when the lookahead becomes insufficient.
     * Updates strstart and lookahead.
     *
     * IN assertion: lookahead < MIN_LOOKAHEAD
     * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
     *    At least one byte has been read, or avail_in == 0; reads are
     *    performed for at least two bytes (required for the zip translate_eol
     *    option -- not supported here).
     */
    const fill_window = (s) => {
        const _w_size = s.w_size;
        let n, more, str;

        //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");

        do {
            more = s.window_size - s.lookahead - s.strstart;

            // JS ints have 32 bit, block below not needed
            /* Deal with !@#$% 64K limit: */
            //if (sizeof(int) <= 2) {
            //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
            //        more = wsize;
            //
            //  } else if (more == (unsigned)(-1)) {
            //        /* Very unlikely, but possible on 16 bit machine if
            //         * strstart == 0 && lookahead == 1 (input done a byte at time)
            //         */
            //        more--;
            //    }
            //}

            /* If the window is almost full and there is insufficient lookahead,
             * move the upper half to the lower one to make room in the upper half.
             */
            if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
                s.window.set(
                    s.window.subarray(_w_size, _w_size + _w_size - more),
                    0
                );
                s.match_start -= _w_size;
                s.strstart -= _w_size;
                /* we now have strstart >= MAX_DIST */
                s.block_start -= _w_size;
                if (s.insert > s.strstart) {
                    s.insert = s.strstart;
                }
                slide_hash(s);
                more += _w_size;
            }
            if (s.strm.avail_in === 0) {
                break;
            }

            /* If there was no sliding:
             *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
             *    more == window_size - lookahead - strstart
             * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
             * => more >= window_size - 2*WSIZE + 2
             * In the BIG_MEM or MMAP case (not yet supported),
             *   window_size == input_size + MIN_LOOKAHEAD  &&
             *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
             * Otherwise, window_size == 2*WSIZE so more >= 2.
             * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
             */
            //Assert(more >= 2, "more < 2");
            n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
            s.lookahead += n;

            /* Initialize the hash value now that we have some input: */
            if (s.lookahead + s.insert >= MIN_MATCH) {
                str = s.strstart - s.insert;
                s.ins_h = s.window[str];

                /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
                s.ins_h = HASH(s, s.ins_h, s.window[str + 1]);
                //#if MIN_MATCH != 3
                //        Call update_hash() MIN_MATCH-3 more times
                //#endif
                while (s.insert) {
                    /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
                    s.ins_h = HASH(s, s.ins_h, s.window[str + MIN_MATCH - 1]);

                    s.prev[str & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = str;
                    str++;
                    s.insert--;
                    if (s.lookahead + s.insert < MIN_MATCH) {
                        break;
                    }
                }
            }
            /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
             * but this is not important since only literal bytes will be emitted.
             */
        } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);

        /* If the WIN_INIT bytes after the end of the current data have never been
         * written, then zero those bytes in order to avoid memory check reports of
         * the use of uninitialized (or uninitialised as Julian writes) bytes by
         * the longest match routines.  Update the high water mark for the next
         * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
         * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
         */
        //  if (s.high_water < s.window_size) {
        //    const curr = s.strstart + s.lookahead;
        //    let init = 0;
        //
        //    if (s.high_water < curr) {
        //      /* Previous high water mark below current data -- zero WIN_INIT
        //       * bytes or up to end of window, whichever is less.
        //       */
        //      init = s.window_size - curr;
        //      if (init > WIN_INIT)
        //        init = WIN_INIT;
        //      zmemzero(s->window + curr, (unsigned)init);
        //      s->high_water = curr + init;
        //    }
        //    else if (s->high_water < (ulg)curr + WIN_INIT) {
        //      /* High water mark at or above current data, but below current data
        //       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
        //       * to end of window, whichever is less.
        //       */
        //      init = (ulg)curr + WIN_INIT - s->high_water;
        //      if (init > s->window_size - s->high_water)
        //        init = s->window_size - s->high_water;
        //      zmemzero(s->window + s->high_water, (unsigned)init);
        //      s->high_water += init;
        //    }
        //  }
        //
        //  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
        //    "not enough room for search");
    };

    /* ===========================================================================
     * Copy without compression as much as possible from the input stream, return
     * the current block state.
     *
     * In case deflateParams() is used to later switch to a non-zero compression
     * level, s->matches (otherwise unused when storing) keeps track of the number
     * of hash table slides to perform. If s->matches is 1, then one hash table
     * slide will be done when switching. If s->matches is 2, the maximum value
     * allowed here, then the hash table will be cleared, since two or more slides
     * is the same as a clear.
     *
     * deflate_stored() is written to minimize the number of times an input byte is
     * copied. It is most efficient with large input and output buffers, which
     * maximizes the opportunites to have a single copy from next_in to next_out.
     */
    const deflate_stored = (s, flush) => {
        /* Smallest worthy block size when not flushing or finishing. By default
         * this is 32K. This can be as small as 507 bytes for memLevel == 1. For
         * large input and output buffers, the stored block size will be larger.
         */
        let min_block =
            s.pending_buf_size - 5 > s.w_size
                ? s.w_size
                : s.pending_buf_size - 5;

        /* Copy as many min_block or larger stored blocks directly to next_out as
         * possible. If flushing, copy the remaining available input to next_out as
         * stored blocks, if there is enough space.
         */
        let len,
            left,
            have,
            last = 0;
        let used = s.strm.avail_in;
        do {
            /* Set len to the maximum size block that we can copy directly with the
             * available input data and output space. Set left to how much of that
             * would be copied from what's left in the window.
             */
            len = 65535 /* MAX_STORED */; /* maximum deflate stored block length */
            have = (s.bi_valid + 42) >> 3; /* number of header bytes */
            if (s.strm.avail_out < have) {
                /* need room for header */
                break;
            }
            /* maximum stored block length that will fit in avail_out: */
            have = s.strm.avail_out - have;
            left = s.strstart - s.block_start; /* bytes left in window */
            if (len > left + s.strm.avail_in) {
                len = left + s.strm.avail_in; /* limit len to the input */
            }
            if (len > have) {
                len = have; /* limit len to the output */
            }

            /* If the stored block would be less than min_block in length, or if
             * unable to copy all of the available input when flushing, then try
             * copying to the window and the pending buffer instead. Also don't
             * write an empty block when flushing -- deflate() does that.
             */
            if (
                len < min_block &&
                ((len === 0 && flush !== Z_FINISH$3) ||
                    flush === Z_NO_FLUSH$2 ||
                    len !== left + s.strm.avail_in)
            ) {
                break;
            }

            /* Make a dummy stored block in pending to get the header bytes,
             * including any pending bits. This also updates the debugging counts.
             */
            last =
                flush === Z_FINISH$3 && len === left + s.strm.avail_in ? 1 : 0;
            _tr_stored_block(s, 0, 0, last);

            /* Replace the lengths in the dummy stored block with len. */
            s.pending_buf[s.pending - 4] = len;
            s.pending_buf[s.pending - 3] = len >> 8;
            s.pending_buf[s.pending - 2] = ~len;
            s.pending_buf[s.pending - 1] = ~len >> 8;

            /* Write the stored block header bytes. */
            flush_pending(s.strm);

            //#ifdef ZLIB_DEBUG
            //    /* Update debugging counts for the data about to be copied. */
            //    s->compressed_len += len << 3;
            //    s->bits_sent += len << 3;
            //#endif

            /* Copy uncompressed bytes from the window to next_out. */
            if (left) {
                if (left > len) {
                    left = len;
                }
                //zmemcpy(s->strm->next_out, s->window + s->block_start, left);
                s.strm.output.set(
                    s.window.subarray(s.block_start, s.block_start + left),
                    s.strm.next_out
                );
                s.strm.next_out += left;
                s.strm.avail_out -= left;
                s.strm.total_out += left;
                s.block_start += left;
                len -= left;
            }

            /* Copy uncompressed bytes directly from next_in to next_out, updating
             * the check value.
             */
            if (len) {
                read_buf(s.strm, s.strm.output, s.strm.next_out, len);
                s.strm.next_out += len;
                s.strm.avail_out -= len;
                s.strm.total_out += len;
            }
        } while (last === 0);

        /* Update the sliding window with the last s->w_size bytes of the copied
         * data, or append all of the copied data to the existing window if less
         * than s->w_size bytes were copied. Also update the number of bytes to
         * insert in the hash tables, in the event that deflateParams() switches to
         * a non-zero compression level.
         */
        used -= s.strm.avail_in; /* number of input bytes directly copied */
        if (used) {
            /* If any input was used, then no unused input remains in the window,
             * therefore s->block_start == s->strstart.
             */
            if (used >= s.w_size) {
                /* supplant the previous history */
                s.matches = 2; /* clear hash */
                //zmemcpy(s->window, s->strm->next_in - s->w_size, s->w_size);
                s.window.set(
                    s.strm.input.subarray(
                        s.strm.next_in - s.w_size,
                        s.strm.next_in
                    ),
                    0
                );
                s.strstart = s.w_size;
                s.insert = s.strstart;
            } else {
                if (s.window_size - s.strstart <= used) {
                    /* Slide the window down. */
                    s.strstart -= s.w_size;
                    //zmemcpy(s->window, s->window + s->w_size, s->strstart);
                    s.window.set(
                        s.window.subarray(s.w_size, s.w_size + s.strstart),
                        0
                    );
                    if (s.matches < 2) {
                        s.matches++; /* add a pending slide_hash() */
                    }
                    if (s.insert > s.strstart) {
                        s.insert = s.strstart;
                    }
                }
                //zmemcpy(s->window + s->strstart, s->strm->next_in - used, used);
                s.window.set(
                    s.strm.input.subarray(
                        s.strm.next_in - used,
                        s.strm.next_in
                    ),
                    s.strstart
                );
                s.strstart += used;
                s.insert +=
                    used > s.w_size - s.insert ? s.w_size - s.insert : used;
            }
            s.block_start = s.strstart;
        }
        if (s.high_water < s.strstart) {
            s.high_water = s.strstart;
        }

        /* If the last block was written to next_out, then done. */
        if (last) {
            return BS_FINISH_DONE;
        }

        /* If flushing and all input has been consumed, then done. */
        if (
            flush !== Z_NO_FLUSH$2 &&
            flush !== Z_FINISH$3 &&
            s.strm.avail_in === 0 &&
            s.strstart === s.block_start
        ) {
            return BS_BLOCK_DONE;
        }

        /* Fill the window with any remaining input. */
        have = s.window_size - s.strstart;
        if (s.strm.avail_in > have && s.block_start >= s.w_size) {
            /* Slide the window down. */
            s.block_start -= s.w_size;
            s.strstart -= s.w_size;
            //zmemcpy(s->window, s->window + s->w_size, s->strstart);
            s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
            if (s.matches < 2) {
                s.matches++; /* add a pending slide_hash() */
            }
            have += s.w_size; /* more space now */
            if (s.insert > s.strstart) {
                s.insert = s.strstart;
            }
        }
        if (have > s.strm.avail_in) {
            have = s.strm.avail_in;
        }
        if (have) {
            read_buf(s.strm, s.window, s.strstart, have);
            s.strstart += have;
            s.insert += have > s.w_size - s.insert ? s.w_size - s.insert : have;
        }
        if (s.high_water < s.strstart) {
            s.high_water = s.strstart;
        }

        /* There was not enough avail_out to write a complete worthy or flushed
         * stored block to next_out. Write a stored block to pending instead, if we
         * have enough input for a worthy block, or if flushing and there is enough
         * room for the remaining input as a stored block in the pending buffer.
         */
        have = (s.bi_valid + 42) >> 3; /* number of header bytes */
        /* maximum stored block length that will fit in pending: */
        have =
            s.pending_buf_size - have > 65535 /* MAX_STORED */
                ? 65535 /* MAX_STORED */
                : s.pending_buf_size - have;
        min_block = have > s.w_size ? s.w_size : have;
        left = s.strstart - s.block_start;
        if (
            left >= min_block ||
            ((left || flush === Z_FINISH$3) &&
                flush !== Z_NO_FLUSH$2 &&
                s.strm.avail_in === 0 &&
                left <= have)
        ) {
            len = left > have ? have : left;
            last =
                flush === Z_FINISH$3 && s.strm.avail_in === 0 && len === left
                    ? 1
                    : 0;
            _tr_stored_block(s, s.block_start, len, last);
            s.block_start += len;
            flush_pending(s.strm);
        }

        /* We've done all we can with the available input and output. */
        return last ? BS_FINISH_STARTED : BS_NEED_MORE;
    };

    /* ===========================================================================
     * Compress as much as possible from the input stream, return the current
     * block state.
     * This function does not perform lazy evaluation of matches and inserts
     * new strings in the dictionary only for unmatched strings or for short
     * matches. It is used only for the fast compression options.
     */
    const deflate_fast = (s, flush) => {
        let hash_head; /* head of the hash chain */
        let bflush; /* set if current block must be flushed */

        for (;;) {
            /* Make sure that we always have enough lookahead, except
             * at the end of the input file. We need MAX_MATCH bytes
             * for the next match, plus MIN_MATCH bytes to insert the
             * string following the next match.
             */
            if (s.lookahead < MIN_LOOKAHEAD) {
                fill_window(s);
                if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH$2) {
                    return BS_NEED_MORE;
                }
                if (s.lookahead === 0) {
                    break; /* flush the current block */
                }
            }

            /* Insert the string window[strstart .. strstart+2] in the
             * dictionary, and set hash_head to the head of the hash chain:
             */
            hash_head = 0 /*NIL*/;
            if (s.lookahead >= MIN_MATCH) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/
                s.ins_h = HASH(
                    s,
                    s.ins_h,
                    s.window[s.strstart + MIN_MATCH - 1]
                );
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
                /***/
            }

            /* Find the longest match, discarding those <= prev_length.
             * At this point we have always match_length < MIN_MATCH
             */
            if (
                hash_head !== 0 /*NIL*/ &&
                s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD
            ) {
                /* To simplify the code, we prevent matches with the string
                 * of window index 0 (in particular we have to avoid a match
                 * of the string with itself at the start of the input file).
                 */
                s.match_length = longest_match(s, hash_head);
                /* longest_match() sets match_start */
            }
            if (s.match_length >= MIN_MATCH) {
                // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only

                /*** _tr_tally_dist(s, s.strstart - s.match_start,
                       s.match_length - MIN_MATCH, bflush); ***/
                bflush = _tr_tally(
                    s,
                    s.strstart - s.match_start,
                    s.match_length - MIN_MATCH
                );

                s.lookahead -= s.match_length;

                /* Insert new strings in the hash table only if the match length
                 * is not too large. This saves time but degrades compression.
                 */
                if (
                    s.match_length <= s.max_lazy_match /*max_insert_length*/ &&
                    s.lookahead >= MIN_MATCH
                ) {
                    s.match_length--; /* string at strstart already in table */
                    do {
                        s.strstart++;
                        /*** INSERT_STRING(s, s.strstart, hash_head); ***/
                        s.ins_h = HASH(
                            s,
                            s.ins_h,
                            s.window[s.strstart + MIN_MATCH - 1]
                        );
                        hash_head = s.prev[s.strstart & s.w_mask] =
                            s.head[s.ins_h];
                        s.head[s.ins_h] = s.strstart;
                        /***/
                        /* strstart never exceeds WSIZE-MAX_MATCH, so there are
                         * always MIN_MATCH bytes ahead.
                         */
                    } while (--s.match_length !== 0);
                    s.strstart++;
                } else {
                    s.strstart += s.match_length;
                    s.match_length = 0;
                    s.ins_h = s.window[s.strstart];
                    /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
                    s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + 1]);

                    //#if MIN_MATCH != 3
                    //                Call UPDATE_HASH() MIN_MATCH-3 more times
                    //#endif
                    /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
                     * matter since it will be recomputed at next deflate call.
                     */
                }
            } else {
                /* No match, output a literal byte */
                //Tracevv((stderr,"%c", s.window[s.strstart]));
                /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
                bflush = _tr_tally(s, 0, s.window[s.strstart]);

                s.lookahead--;
                s.strstart++;
            }
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                }
                /***/
            }
        }
        s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
        if (flush === Z_FINISH$3) {
            /*** FLUSH_BLOCK(s, 1); ***/
            flush_block_only(s, true);
            if (s.strm.avail_out === 0) {
                return BS_FINISH_STARTED;
            }
            /***/
            return BS_FINISH_DONE;
        }
        if (s.sym_next) {
            /*** FLUSH_BLOCK(s, 0); ***/
            flush_block_only(s, false);
            if (s.strm.avail_out === 0) {
                return BS_NEED_MORE;
            }
            /***/
        }
        return BS_BLOCK_DONE;
    };

    /* ===========================================================================
     * Same as above, but achieves better compression. We use a lazy
     * evaluation for matches: a match is finally adopted only if there is
     * no better match at the next window position.
     */
    const deflate_slow = (s, flush) => {
        let hash_head; /* head of hash chain */
        let bflush; /* set if current block must be flushed */

        let max_insert;

        /* Process the input block. */
        for (;;) {
            /* Make sure that we always have enough lookahead, except
             * at the end of the input file. We need MAX_MATCH bytes
             * for the next match, plus MIN_MATCH bytes to insert the
             * string following the next match.
             */
            if (s.lookahead < MIN_LOOKAHEAD) {
                fill_window(s);
                if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH$2) {
                    return BS_NEED_MORE;
                }
                if (s.lookahead === 0) {
                    break;
                } /* flush the current block */
            }

            /* Insert the string window[strstart .. strstart+2] in the
             * dictionary, and set hash_head to the head of the hash chain:
             */
            hash_head = 0 /*NIL*/;
            if (s.lookahead >= MIN_MATCH) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/
                s.ins_h = HASH(
                    s,
                    s.ins_h,
                    s.window[s.strstart + MIN_MATCH - 1]
                );
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
                /***/
            }

            /* Find the longest match, discarding those <= prev_length.
             */
            s.prev_length = s.match_length;
            s.prev_match = s.match_start;
            s.match_length = MIN_MATCH - 1;

            if (
                hash_head !== 0 /*NIL*/ &&
                s.prev_length < s.max_lazy_match &&
                s.strstart - hash_head <=
                    s.w_size - MIN_LOOKAHEAD /*MAX_DIST(s)*/
            ) {
                /* To simplify the code, we prevent matches with the string
                 * of window index 0 (in particular we have to avoid a match
                 * of the string with itself at the start of the input file).
                 */
                s.match_length = longest_match(s, hash_head);
                /* longest_match() sets match_start */

                if (
                    s.match_length <= 5 &&
                    (s.strategy === Z_FILTERED ||
                        (s.match_length === MIN_MATCH &&
                            s.strstart - s.match_start > 4096)) /*TOO_FAR*/
                ) {
                    /* If prev_match is also MIN_MATCH, match_start is garbage
                     * but we will ignore the current match anyway.
                     */
                    s.match_length = MIN_MATCH - 1;
                }
            }
            /* If there was a match at the previous step and the current
             * match is not better, output the previous match:
             */
            if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
                max_insert = s.strstart + s.lookahead - MIN_MATCH;
                /* Do not insert strings in hash table beyond this. */

                //check_match(s, s.strstart-1, s.prev_match, s.prev_length);

                /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                       s.prev_length - MIN_MATCH, bflush);***/
                bflush = _tr_tally(
                    s,
                    s.strstart - 1 - s.prev_match,
                    s.prev_length - MIN_MATCH
                );
                /* Insert in hash table all strings up to the end of the match.
                 * strstart-1 and strstart are already inserted. If there is not
                 * enough lookahead, the last two strings are not inserted in
                 * the hash table.
                 */
                s.lookahead -= s.prev_length - 1;
                s.prev_length -= 2;
                do {
                    if (++s.strstart <= max_insert) {
                        /*** INSERT_STRING(s, s.strstart, hash_head); ***/
                        s.ins_h = HASH(
                            s,
                            s.ins_h,
                            s.window[s.strstart + MIN_MATCH - 1]
                        );
                        hash_head = s.prev[s.strstart & s.w_mask] =
                            s.head[s.ins_h];
                        s.head[s.ins_h] = s.strstart;
                        /***/
                    }
                } while (--s.prev_length !== 0);
                s.match_available = 0;
                s.match_length = MIN_MATCH - 1;
                s.strstart++;

                if (bflush) {
                    /*** FLUSH_BLOCK(s, 0); ***/
                    flush_block_only(s, false);
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                    /***/
                }
            } else if (s.match_available) {
                /* If there was no match at the previous position, output a
                 * single literal. If there was a match but the current match
                 * is longer, truncate the previous match to a single literal.
                 */
                //Tracevv((stderr,"%c", s->window[s->strstart-1]));
                /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
                bflush = _tr_tally(s, 0, s.window[s.strstart - 1]);

                if (bflush) {
                    /*** FLUSH_BLOCK_ONLY(s, 0) ***/
                    flush_block_only(s, false);
                    /***/
                }
                s.strstart++;
                s.lookahead--;
                if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                }
            } else {
                /* There is no previous match to compare with, wait for
                 * the next step to decide.
                 */
                s.match_available = 1;
                s.strstart++;
                s.lookahead--;
            }
        }
        //Assert (flush != Z_NO_FLUSH, "no flush?");
        if (s.match_available) {
            //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
            bflush = _tr_tally(s, 0, s.window[s.strstart - 1]);

            s.match_available = 0;
        }
        s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
        if (flush === Z_FINISH$3) {
            /*** FLUSH_BLOCK(s, 1); ***/
            flush_block_only(s, true);
            if (s.strm.avail_out === 0) {
                return BS_FINISH_STARTED;
            }
            /***/
            return BS_FINISH_DONE;
        }
        if (s.sym_next) {
            /*** FLUSH_BLOCK(s, 0); ***/
            flush_block_only(s, false);
            if (s.strm.avail_out === 0) {
                return BS_NEED_MORE;
            }
            /***/
        }

        return BS_BLOCK_DONE;
    };

    /* ===========================================================================
     * For Z_RLE, simply look for runs of bytes, generate matches only of distance
     * one.  Do not maintain a hash table.  (It will be regenerated if this run of
     * deflate switches away from Z_RLE.)
     */
    const deflate_rle = (s, flush) => {
        let bflush; /* set if current block must be flushed */
        let prev; /* byte at distance one to match */
        let scan, strend; /* scan goes up to strend for length of run */

        const _win = s.window;

        for (;;) {
            /* Make sure that we always have enough lookahead, except
             * at the end of the input file. We need MAX_MATCH bytes
             * for the longest run, plus one for the unrolled loop.
             */
            if (s.lookahead <= MAX_MATCH) {
                fill_window(s);
                if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH$2) {
                    return BS_NEED_MORE;
                }
                if (s.lookahead === 0) {
                    break;
                } /* flush the current block */
            }

            /* See how many times the previous byte repeats */
            s.match_length = 0;
            if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
                scan = s.strstart - 1;
                prev = _win[scan];
                if (
                    prev === _win[++scan] &&
                    prev === _win[++scan] &&
                    prev === _win[++scan]
                ) {
                    strend = s.strstart + MAX_MATCH;
                    do {
                        /*jshint noempty:false*/
                    } while (
                        prev === _win[++scan] &&
                        prev === _win[++scan] &&
                        prev === _win[++scan] &&
                        prev === _win[++scan] &&
                        prev === _win[++scan] &&
                        prev === _win[++scan] &&
                        prev === _win[++scan] &&
                        prev === _win[++scan] &&
                        scan < strend
                    );
                    s.match_length = MAX_MATCH - (strend - scan);
                    if (s.match_length > s.lookahead) {
                        s.match_length = s.lookahead;
                    }
                }
                //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
            }

            /* Emit match if have run of MIN_MATCH or longer, else emit literal */
            if (s.match_length >= MIN_MATCH) {
                //check_match(s, s.strstart, s.strstart - 1, s.match_length);

                /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
                bflush = _tr_tally(s, 1, s.match_length - MIN_MATCH);

                s.lookahead -= s.match_length;
                s.strstart += s.match_length;
                s.match_length = 0;
            } else {
                /* No match, output a literal byte */
                //Tracevv((stderr,"%c", s->window[s->strstart]));
                /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
                bflush = _tr_tally(s, 0, s.window[s.strstart]);

                s.lookahead--;
                s.strstart++;
            }
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                }
                /***/
            }
        }
        s.insert = 0;
        if (flush === Z_FINISH$3) {
            /*** FLUSH_BLOCK(s, 1); ***/
            flush_block_only(s, true);
            if (s.strm.avail_out === 0) {
                return BS_FINISH_STARTED;
            }
            /***/
            return BS_FINISH_DONE;
        }
        if (s.sym_next) {
            /*** FLUSH_BLOCK(s, 0); ***/
            flush_block_only(s, false);
            if (s.strm.avail_out === 0) {
                return BS_NEED_MORE;
            }
            /***/
        }
        return BS_BLOCK_DONE;
    };

    /* ===========================================================================
     * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
     * (It will be regenerated if this run of deflate switches away from Huffman.)
     */
    const deflate_huff = (s, flush) => {
        let bflush; /* set if current block must be flushed */

        for (;;) {
            /* Make sure that we have a literal to write. */
            if (s.lookahead === 0) {
                fill_window(s);
                if (s.lookahead === 0) {
                    if (flush === Z_NO_FLUSH$2) {
                        return BS_NEED_MORE;
                    }
                    break; /* flush the current block */
                }
            }

            /* Output a literal byte */
            s.match_length = 0;
            //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
            bflush = _tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                }
                /***/
            }
        }
        s.insert = 0;
        if (flush === Z_FINISH$3) {
            /*** FLUSH_BLOCK(s, 1); ***/
            flush_block_only(s, true);
            if (s.strm.avail_out === 0) {
                return BS_FINISH_STARTED;
            }
            /***/
            return BS_FINISH_DONE;
        }
        if (s.sym_next) {
            /*** FLUSH_BLOCK(s, 0); ***/
            flush_block_only(s, false);
            if (s.strm.avail_out === 0) {
                return BS_NEED_MORE;
            }
            /***/
        }
        return BS_BLOCK_DONE;
    };

    /* Values for max_lazy_match, good_match and max_chain_length, depending on
     * the desired pack level (0..9). The values given below have been tuned to
     * exclude worst case performance for pathological files. Better values may be
     * found for specific files.
     */
    class Config {
        constructor(good_length, max_lazy, nice_length, max_chain, func) {
            this.good_length = good_length;
            this.max_lazy = max_lazy;
            this.nice_length = nice_length;
            this.max_chain = max_chain;
            this.func = func;
        }
    }

    const configuration_table = [
        /*      good lazy nice chain */
        new Config(0, 0, 0, 0, deflate_stored) /* 0 store only */,
        new Config(4, 4, 8, 4, deflate_fast) /* 1 max speed, no lazy matches */,
        new Config(4, 5, 16, 8, deflate_fast) /* 2 */,
        new Config(4, 6, 32, 32, deflate_fast) /* 3 */,

        new Config(4, 4, 16, 16, deflate_slow) /* 4 lazy matches */,
        new Config(8, 16, 32, 32, deflate_slow) /* 5 */,
        new Config(8, 16, 128, 128, deflate_slow) /* 6 */,
        new Config(8, 32, 128, 256, deflate_slow) /* 7 */,
        new Config(32, 128, 258, 1024, deflate_slow) /* 8 */,
        new Config(32, 258, 258, 4096, deflate_slow) /* 9 max compression */,
    ];

    /* ===========================================================================
     * Initialize the "longest match" routines for a new zlib stream
     */
    const lm_init = (s) => {
        s.window_size = 2 * s.w_size;

        /*** CLEAR_HASH(s); ***/
        zero(s.head); // Fill with NIL (= 0);

        /* Set the default configuration parameters:
         */
        s.max_lazy_match = configuration_table[s.level].max_lazy;
        s.good_match = configuration_table[s.level].good_length;
        s.nice_match = configuration_table[s.level].nice_length;
        s.max_chain_length = configuration_table[s.level].max_chain;

        s.strstart = 0;
        s.block_start = 0;
        s.lookahead = 0;
        s.insert = 0;
        s.match_length = s.prev_length = MIN_MATCH - 1;
        s.match_available = 0;
        s.ins_h = 0;
    };

    class DeflateState {
        constructor() {
            this.strm = null; /* pointer back to this zlib stream */
            this.status = 0; /* as the name implies */
            this.pending_buf = null; /* output still pending */
            this.pending_buf_size = 0; /* size of pending_buf */
            this.pending_out = 0; /* next pending byte to output to the stream */
            this.pending = 0; /* nb of bytes in the pending buffer */
            this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */
            this.gzhead = null; /* gzip header information to write */
            this.gzindex = 0; /* where in extra, name, or comment */
            this.method = Z_DEFLATED$2; /* can only be DEFLATED */
            this.last_flush =
                -1; /* value of flush param for previous deflate call */

            this.w_size = 0; /* LZ77 window size (32K by default) */
            this.w_bits = 0; /* log2(w_size)  (8..16) */
            this.w_mask = 0; /* w_size - 1 */

            this.window = null;
            /* Sliding window. Input bytes are read into the second half of the window,
             * and move to the first half later to keep a dictionary of at least wSize
             * bytes. With this organization, matches are limited to a distance of
             * wSize-MAX_MATCH bytes, but this ensures that IO is always
             * performed with a length multiple of the block size.
             */
            this.window_size = 0;
            /* Actual size of window: 2*wSize, except when the user input buffer
             * is directly used as sliding window.
             */
            this.prev = null;
            /* Link to older string with same hash index. To limit the size of this
             * array to 64K, this link is maintained only for the last 32K strings.
             * An index in this array is thus a window index modulo 32K.
             */
            this.head = null; /* Heads of the hash chains or NIL. */

            this.ins_h = 0; /* hash index of string to be inserted */
            this.hash_size = 0; /* number of elements in hash table */
            this.hash_bits = 0; /* log2(hash_size) */
            this.hash_mask = 0; /* hash_size-1 */

            this.hash_shift = 0;
            /* Number of bits by which ins_h must be shifted at each input
             * step. It must be such that after MIN_MATCH steps, the oldest
             * byte no longer takes part in the hash key, that is:
             *   hash_shift * MIN_MATCH >= hash_bits
             */
            this.block_start = 0;
            /* Window position at the beginning of the current output block. Gets
             * negative when the window is moved backwards.
             */
            this.match_length = 0; /* length of best match */
            this.prev_match = 0; /* previous match */
            this.match_available = 0; /* set if previous match exists */
            this.strstart = 0; /* start of string to insert */
            this.match_start = 0; /* start of matching string */
            this.lookahead = 0; /* number of valid bytes ahead in window */

            this.prev_length = 0;
            /* Length of the best match at previous step. Matches not greater than this
             * are discarded. This is used in the lazy match evaluation.
             */
            this.max_chain_length = 0;
            /* To speed up deflation, hash chains are never searched beyond this
             * length.  A higher limit improves compression ratio but degrades the
             * speed.
             */
            this.max_lazy_match = 0;
            /* Attempt to find a better match only when the current match is strictly
             * smaller than this value. This mechanism is used only for compression
             * levels >= 4.
             */
            // That's alias to max_lazy_match, don't use directly
            //this.max_insert_length = 0;
            /* Insert new strings in the hash table only if the match length is not
             * greater than this length. This saves time but degrades compression.
             * max_insert_length is used only for compression levels <= 3.
             */
            this.level = 0; /* compression level (1..9) */
            this.strategy = 0; /* favor or force Huffman coding*/

            this.good_match = 0;
            /* Use a faster search when the previous match is longer than this */
            this.nice_match = 0; /* Stop searching when current match exceeds this */

            /* used by trees.c: */
            /* Didn't use ct_data typedef below to suppress compiler warning */
            // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
            // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
            // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
            // Use flat array of DOUBLE size, with interleaved fata,
            // because JS does not support effective
            this.dyn_ltree = new Uint16Array(HEAP_SIZE * 2);
            this.dyn_dtree = new Uint16Array((2 * D_CODES + 1) * 2);
            this.bl_tree = new Uint16Array((2 * BL_CODES + 1) * 2);
            zero(this.dyn_ltree);
            zero(this.dyn_dtree);
            zero(this.bl_tree);

            this.l_desc = null; /* desc. for literal tree */
            this.d_desc = null; /* desc. for distance tree */
            this.bl_desc = null; /* desc. for bit length tree */

            //ush bl_count[MAX_BITS+1];
            this.bl_count = new Uint16Array(MAX_BITS + 1);
            /* number of codes at each bit length for an optimal tree */
            //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
            this.heap = new Uint16Array(
                2 * L_CODES + 1
            ); /* heap used to build the Huffman trees */
            zero(this.heap);

            this.heap_len = 0; /* number of elements in the heap */
            this.heap_max = 0; /* element of largest frequency */

            /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
             * The same heap array is used to build all trees.
             */
            this.depth = new Uint16Array(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
            zero(this.depth);
            /* Depth of each subtree used as tie breaker for trees of equal frequency
             */
            this.sym_buf = 0; /* buffer for distances and literals/lengths */

            this.lit_bufsize = 0;
            /* Size of match buffer for literals/lengths.  There are 4 reasons for
             * limiting lit_bufsize to 64K:
             *   - frequencies can be kept in 16 bit counters
             *   - if compression is not successful for the first block, all input
             *     data is still in the window so we can still emit a stored block even
             *     when input comes from standard input.  (This can also be done for
             *     all blocks if lit_bufsize is not greater than 32K.)
             *   - if compression is not successful for a file smaller than 64K, we can
             *     even emit a stored file instead of a stored block (saving 5 bytes).
             *     This is applicable only for zip (not gzip or zlib).
             *   - creating new Huffman trees less frequently may not provide fast
             *     adaptation to changes in the input data statistics. (Take for
             *     example a binary file with poorly compressible code followed by
             *     a highly compressible string table.) Smaller buffer sizes give
             *     fast adaptation but have of course the overhead of transmitting
             *     trees more frequently.
             *   - I can't count above 4
             */
            this.sym_next = 0; /* running index in sym_buf */
            this.sym_end = 0; /* symbol table full when sym_next reaches this */

            this.opt_len = 0; /* bit length of current block with optimal trees */
            this.static_len = 0; /* bit length of current block with static trees */
            this.matches = 0; /* number of string matches in current block */
            this.insert = 0; /* bytes at end of window left to insert */

            this.bi_buf = 0;
            /* Output buffer. bits are inserted starting at the bottom (least
             * significant bits).
             */
            this.bi_valid = 0;
            /* Number of valid bits in bi_buf.  All bits above the last valid bit
             * are always zero.
             */
            // Used for window memory init. We safely ignore it for JS. That makes
            // sense only for pointers and memory check tools.
            //this.high_water = 0;
            /* High water mark offset in window for initialized bytes -- bytes above
             * this are set to zero in order to avoid memory check warnings when
             * longest match routines access bytes past the input.  This is then
             * updated to the new high water mark.
             */
        }
    }

    /* =========================================================================
     * Check for a valid deflate stream state. Return 0 if ok, 1 if not.
     */
    const deflateStateCheck = (strm) => {
        if (!strm) {
            return 1;
        }
        const s = strm.state;
        if (
            !s ||
            s.strm !== strm ||
            (s.status !== INIT_STATE &&
                //#ifdef GZIP
                s.status !== GZIP_STATE &&
                //#endif
                s.status !== EXTRA_STATE &&
                s.status !== NAME_STATE &&
                s.status !== COMMENT_STATE &&
                s.status !== HCRC_STATE &&
                s.status !== BUSY_STATE &&
                s.status !== FINISH_STATE)
        ) {
            return 1;
        }
        return 0;
    };

    const deflateResetKeep = (strm) => {
        if (deflateStateCheck(strm)) {
            return err(strm, Z_STREAM_ERROR$2);
        }

        strm.total_in = strm.total_out = 0;
        strm.data_type = Z_UNKNOWN;

        const s = strm.state;
        s.pending = 0;
        s.pending_out = 0;

        if (s.wrap < 0) {
            s.wrap = -s.wrap;
            /* was made negative by deflate(..., Z_FINISH); */
        }
        s.status =
            //#ifdef GZIP
            s.wrap === 2
                ? GZIP_STATE
                : //#endif
                s.wrap
                ? INIT_STATE
                : BUSY_STATE;
        strm.adler =
            s.wrap === 2
                ? 0 // crc32(0, Z_NULL, 0)
                : 1; // adler32(0, Z_NULL, 0)
        s.last_flush = -2;
        _tr_init(s);
        return Z_OK$3;
    };

    const deflateReset = (strm) => {
        const ret = deflateResetKeep(strm);
        if (ret === Z_OK$3) {
            lm_init(strm.state);
        }
        return ret;
    };

    const deflateSetHeader = (strm, head) => {
        if (deflateStateCheck(strm) || strm.state.wrap !== 2) {
            return Z_STREAM_ERROR$2;
        }
        strm.state.gzhead = head;
        return Z_OK$3;
    };

    const deflateInit2 = (
        strm,
        level,
        method,
        windowBits,
        memLevel,
        strategy
    ) => {
        if (!strm) {
            // === Z_NULL
            return Z_STREAM_ERROR$2;
        }
        let wrap = 1;

        if (level === Z_DEFAULT_COMPRESSION$1) {
            level = 6;
        }

        if (windowBits < 0) {
            /* suppress zlib wrapper */
            wrap = 0;
            windowBits = -windowBits;
        } else if (windowBits > 15) {
            wrap = 2; /* write gzip wrapper instead */
            windowBits -= 16;
        }

        if (
            memLevel < 1 ||
            memLevel > MAX_MEM_LEVEL ||
            method !== Z_DEFLATED$2 ||
            windowBits < 8 ||
            windowBits > 15 ||
            level < 0 ||
            level > 9 ||
            strategy < 0 ||
            strategy > Z_FIXED ||
            (windowBits === 8 && wrap !== 1)
        ) {
            return err(strm, Z_STREAM_ERROR$2);
        }

        if (windowBits === 8) {
            windowBits = 9;
        }
        /* until 256-byte window bug fixed */

        const s = new DeflateState();

        strm.state = s;
        s.strm = strm;
        s.status = INIT_STATE; /* to pass state test in deflateReset() */

        s.wrap = wrap;
        s.gzhead = null;
        s.w_bits = windowBits;
        s.w_size = 1 << s.w_bits;
        s.w_mask = s.w_size - 1;

        s.hash_bits = memLevel + 7;
        s.hash_size = 1 << s.hash_bits;
        s.hash_mask = s.hash_size - 1;
        s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);

        s.window = new Uint8Array(s.w_size * 2);
        s.head = new Uint16Array(s.hash_size);
        s.prev = new Uint16Array(s.w_size);

        // Don't need mem init magic for JS.
        //s.high_water = 0;  /* nothing written to s->window yet */

        s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */

        /* We overlay pending_buf and sym_buf. This works since the average size
         * for length/distance pairs over any compressed block is assured to be 31
         * bits or less.
         *
         * Analysis: The longest fixed codes are a length code of 8 bits plus 5
         * extra bits, for lengths 131 to 257. The longest fixed distance codes are
         * 5 bits plus 13 extra bits, for distances 16385 to 32768. The longest
         * possible fixed-codes length/distance pair is then 31 bits total.
         *
         * sym_buf starts one-fourth of the way into pending_buf. So there are
         * three bytes in sym_buf for every four bytes in pending_buf. Each symbol
         * in sym_buf is three bytes -- two for the distance and one for the
         * literal/length. As each symbol is consumed, the pointer to the next
         * sym_buf value to read moves forward three bytes. From that symbol, up to
         * 31 bits are written to pending_buf. The closest the written pending_buf
         * bits gets to the next sym_buf symbol to read is just before the last
         * code is written. At that time, 31*(n-2) bits have been written, just
         * after 24*(n-2) bits have been consumed from sym_buf. sym_buf starts at
         * 8*n bits into pending_buf. (Note that the symbol buffer fills when n-1
         * symbols are written.) The closest the writing gets to what is unread is
         * then n+14 bits. Here n is lit_bufsize, which is 16384 by default, and
         * can range from 128 to 32768.
         *
         * Therefore, at a minimum, there are 142 bits of space between what is
         * written and what is read in the overlain buffers, so the symbols cannot
         * be overwritten by the compressed data. That space is actually 139 bits,
         * due to the three-bit fixed-code block header.
         *
         * That covers the case where either Z_FIXED is specified, forcing fixed
         * codes, or when the use of fixed codes is chosen, because that choice
         * results in a smaller compressed block than dynamic codes. That latter
         * condition then assures that the above analysis also covers all dynamic
         * blocks. A dynamic-code block will only be chosen to be emitted if it has
         * fewer bits than a fixed-code block would for the same set of symbols.
         * Therefore its average symbol length is assured to be less than 31. So
         * the compressed data for a dynamic block also cannot overwrite the
         * symbols from which it is being constructed.
         */

        s.pending_buf_size = s.lit_bufsize * 4;
        s.pending_buf = new Uint8Array(s.pending_buf_size);

        // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
        //s->sym_buf = s->pending_buf + s->lit_bufsize;
        s.sym_buf = s.lit_bufsize;

        //s->sym_end = (s->lit_bufsize - 1) * 3;
        s.sym_end = (s.lit_bufsize - 1) * 3;
        /* We avoid equality with lit_bufsize*3 because of wraparound at 64K
         * on 16 bit machines and because stored blocks are restricted to
         * 64K-1 bytes.
         */

        s.level = level;
        s.strategy = strategy;
        s.method = method;

        return deflateReset(strm);
    };

    const deflateInit = (strm, level) => {
        return deflateInit2(
            strm,
            level,
            Z_DEFLATED$2,
            MAX_WBITS$1,
            DEF_MEM_LEVEL,
            Z_DEFAULT_STRATEGY$1
        );
    };

    /* ========================================================================= */
    const deflate$2 = (strm, flush) => {
        if (deflateStateCheck(strm) || flush > Z_BLOCK$1 || flush < 0) {
            return strm ? err(strm, Z_STREAM_ERROR$2) : Z_STREAM_ERROR$2;
        }

        const s = strm.state;

        if (
            !strm.output ||
            (strm.avail_in !== 0 && !strm.input) ||
            (s.status === FINISH_STATE && flush !== Z_FINISH$3)
        ) {
            return err(
                strm,
                strm.avail_out === 0 ? Z_BUF_ERROR$1 : Z_STREAM_ERROR$2
            );
        }

        const old_flush = s.last_flush;
        s.last_flush = flush;

        /* Flush as much pending output as possible */
        if (s.pending !== 0) {
            flush_pending(strm);
            if (strm.avail_out === 0) {
                /* Since avail_out is 0, deflate will be called again with
                 * more output space, but possibly with both pending and
                 * avail_in equal to zero. There won't be anything to do,
                 * but this is not an error situation so make sure we
                 * return OK instead of BUF_ERROR at next call of deflate:
                 */
                s.last_flush = -1;
                return Z_OK$3;
            }

            /* Make sure there is something to do and avoid duplicate consecutive
             * flushes. For repeated and useless calls with Z_FINISH, we keep
             * returning Z_STREAM_END instead of Z_BUF_ERROR.
             */
        } else if (
            strm.avail_in === 0 &&
            rank(flush) <= rank(old_flush) &&
            flush !== Z_FINISH$3
        ) {
            return err(strm, Z_BUF_ERROR$1);
        }

        /* User must not provide more input after the first FINISH: */
        if (s.status === FINISH_STATE && strm.avail_in !== 0) {
            return err(strm, Z_BUF_ERROR$1);
        }

        /* Write the header */
        if (s.status === INIT_STATE && s.wrap === 0) {
            s.status = BUSY_STATE;
        }
        if (s.status === INIT_STATE) {
            /* zlib header */
            let header = (Z_DEFLATED$2 + ((s.w_bits - 8) << 4)) << 8;
            let level_flags = -1;

            if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
                level_flags = 0;
            } else if (s.level < 6) {
                level_flags = 1;
            } else if (s.level === 6) {
                level_flags = 2;
            } else {
                level_flags = 3;
            }
            header |= level_flags << 6;
            if (s.strstart !== 0) {
                header |= PRESET_DICT;
            }
            header += 31 - (header % 31);

            putShortMSB(s, header);

            /* Save the adler32 of the preset dictionary: */
            if (s.strstart !== 0) {
                putShortMSB(s, strm.adler >>> 16);
                putShortMSB(s, strm.adler & 0xffff);
            }
            strm.adler = 1; // adler32(0L, Z_NULL, 0);
            s.status = BUSY_STATE;

            /* Compression must start with an empty pending buffer */
            flush_pending(strm);
            if (s.pending !== 0) {
                s.last_flush = -1;
                return Z_OK$3;
            }
        }
        //#ifdef GZIP
        if (s.status === GZIP_STATE) {
            /* gzip header */
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
            put_byte(s, 31);
            put_byte(s, 139);
            put_byte(s, 8);
            if (!s.gzhead) {
                // s->gzhead == Z_NULL
                put_byte(s, 0);
                put_byte(s, 0);
                put_byte(s, 0);
                put_byte(s, 0);
                put_byte(s, 0);
                put_byte(
                    s,
                    s.level === 9
                        ? 2
                        : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2
                        ? 4
                        : 0
                );
                put_byte(s, OS_CODE);
                s.status = BUSY_STATE;

                /* Compression must start with an empty pending buffer */
                flush_pending(strm);
                if (s.pending !== 0) {
                    s.last_flush = -1;
                    return Z_OK$3;
                }
            } else {
                put_byte(
                    s,
                    (s.gzhead.text ? 1 : 0) +
                        (s.gzhead.hcrc ? 2 : 0) +
                        (!s.gzhead.extra ? 0 : 4) +
                        (!s.gzhead.name ? 0 : 8) +
                        (!s.gzhead.comment ? 0 : 16)
                );
                put_byte(s, s.gzhead.time & 0xff);
                put_byte(s, (s.gzhead.time >> 8) & 0xff);
                put_byte(s, (s.gzhead.time >> 16) & 0xff);
                put_byte(s, (s.gzhead.time >> 24) & 0xff);
                put_byte(
                    s,
                    s.level === 9
                        ? 2
                        : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2
                        ? 4
                        : 0
                );
                put_byte(s, s.gzhead.os & 0xff);
                if (s.gzhead.extra && s.gzhead.extra.length) {
                    put_byte(s, s.gzhead.extra.length & 0xff);
                    put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
                }
                if (s.gzhead.hcrc) {
                    strm.adler = crc32_1(
                        strm.adler,
                        s.pending_buf,
                        s.pending,
                        0
                    );
                }
                s.gzindex = 0;
                s.status = EXTRA_STATE;
            }
        }
        if (s.status === EXTRA_STATE) {
            if (s.gzhead.extra /* != Z_NULL*/) {
                let beg = s.pending; /* start of bytes to update crc */
                let left = (s.gzhead.extra.length & 0xffff) - s.gzindex;
                while (s.pending + left > s.pending_buf_size) {
                    let copy = s.pending_buf_size - s.pending;
                    // zmemcpy(s.pending_buf + s.pending,
                    //    s.gzhead.extra + s.gzindex, copy);
                    s.pending_buf.set(
                        s.gzhead.extra.subarray(s.gzindex, s.gzindex + copy),
                        s.pending
                    );
                    s.pending = s.pending_buf_size;
                    //--- HCRC_UPDATE(beg) ---//
                    if (s.gzhead.hcrc && s.pending > beg) {
                        strm.adler = crc32_1(
                            strm.adler,
                            s.pending_buf,
                            s.pending - beg,
                            beg
                        );
                    }
                    //---//
                    s.gzindex += copy;
                    flush_pending(strm);
                    if (s.pending !== 0) {
                        s.last_flush = -1;
                        return Z_OK$3;
                    }
                    beg = 0;
                    left -= copy;
                }
                // JS specific: s.gzhead.extra may be TypedArray or Array for backward compatibility
                //              TypedArray.slice and TypedArray.from don't exist in IE10-IE11
                let gzhead_extra = new Uint8Array(s.gzhead.extra);
                // zmemcpy(s->pending_buf + s->pending,
                //     s->gzhead->extra + s->gzindex, left);
                s.pending_buf.set(
                    gzhead_extra.subarray(s.gzindex, s.gzindex + left),
                    s.pending
                );
                s.pending += left;
                //--- HCRC_UPDATE(beg) ---//
                if (s.gzhead.hcrc && s.pending > beg) {
                    strm.adler = crc32_1(
                        strm.adler,
                        s.pending_buf,
                        s.pending - beg,
                        beg
                    );
                }
                //---//
                s.gzindex = 0;
            }
            s.status = NAME_STATE;
        }
        if (s.status === NAME_STATE) {
            if (s.gzhead.name /* != Z_NULL*/) {
                let beg = s.pending; /* start of bytes to update crc */
                let val;
                do {
                    if (s.pending === s.pending_buf_size) {
                        //--- HCRC_UPDATE(beg) ---//
                        if (s.gzhead.hcrc && s.pending > beg) {
                            strm.adler = crc32_1(
                                strm.adler,
                                s.pending_buf,
                                s.pending - beg,
                                beg
                            );
                        }
                        //---//
                        flush_pending(strm);
                        if (s.pending !== 0) {
                            s.last_flush = -1;
                            return Z_OK$3;
                        }
                        beg = 0;
                    }
                    // JS specific: little magic to add zero terminator to end of string
                    if (s.gzindex < s.gzhead.name.length) {
                        val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                    } else {
                        val = 0;
                    }
                    put_byte(s, val);
                } while (val !== 0);
                //--- HCRC_UPDATE(beg) ---//
                if (s.gzhead.hcrc && s.pending > beg) {
                    strm.adler = crc32_1(
                        strm.adler,
                        s.pending_buf,
                        s.pending - beg,
                        beg
                    );
                }
                //---//
                s.gzindex = 0;
            }
            s.status = COMMENT_STATE;
        }
        if (s.status === COMMENT_STATE) {
            if (s.gzhead.comment /* != Z_NULL*/) {
                let beg = s.pending; /* start of bytes to update crc */
                let val;
                do {
                    if (s.pending === s.pending_buf_size) {
                        //--- HCRC_UPDATE(beg) ---//
                        if (s.gzhead.hcrc && s.pending > beg) {
                            strm.adler = crc32_1(
                                strm.adler,
                                s.pending_buf,
                                s.pending - beg,
                                beg
                            );
                        }
                        //---//
                        flush_pending(strm);
                        if (s.pending !== 0) {
                            s.last_flush = -1;
                            return Z_OK$3;
                        }
                        beg = 0;
                    }
                    // JS specific: little magic to add zero terminator to end of string
                    if (s.gzindex < s.gzhead.comment.length) {
                        val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                    } else {
                        val = 0;
                    }
                    put_byte(s, val);
                } while (val !== 0);
                //--- HCRC_UPDATE(beg) ---//
                if (s.gzhead.hcrc && s.pending > beg) {
                    strm.adler = crc32_1(
                        strm.adler,
                        s.pending_buf,
                        s.pending - beg,
                        beg
                    );
                }
                //---//
            }
            s.status = HCRC_STATE;
        }
        if (s.status === HCRC_STATE) {
            if (s.gzhead.hcrc) {
                if (s.pending + 2 > s.pending_buf_size) {
                    flush_pending(strm);
                    if (s.pending !== 0) {
                        s.last_flush = -1;
                        return Z_OK$3;
                    }
                }
                put_byte(s, strm.adler & 0xff);
                put_byte(s, (strm.adler >> 8) & 0xff);
                strm.adler = 0; //crc32(0L, Z_NULL, 0);
            }
            s.status = BUSY_STATE;

            /* Compression must start with an empty pending buffer */
            flush_pending(strm);
            if (s.pending !== 0) {
                s.last_flush = -1;
                return Z_OK$3;
            }
        }
        //#endif

        /* Start a new block or continue the current one.
         */
        if (
            strm.avail_in !== 0 ||
            s.lookahead !== 0 ||
            (flush !== Z_NO_FLUSH$2 && s.status !== FINISH_STATE)
        ) {
            let bstate =
                s.level === 0
                    ? deflate_stored(s, flush)
                    : s.strategy === Z_HUFFMAN_ONLY
                    ? deflate_huff(s, flush)
                    : s.strategy === Z_RLE
                    ? deflate_rle(s, flush)
                    : configuration_table[s.level].func(s, flush);

            if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
                s.status = FINISH_STATE;
            }
            if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
                if (strm.avail_out === 0) {
                    s.last_flush = -1;
                    /* avoid BUF_ERROR next call, see above */
                }
                return Z_OK$3;
                /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
                 * of deflate should use the same flush parameter to make sure
                 * that the flush is complete. So we don't have to output an
                 * empty block here, this will be done at next call. This also
                 * ensures that for a very small output buffer, we emit at most
                 * one empty block.
                 */
            }
            if (bstate === BS_BLOCK_DONE) {
                if (flush === Z_PARTIAL_FLUSH) {
                    _tr_align(s);
                } else if (flush !== Z_BLOCK$1) {
                    /* FULL_FLUSH or SYNC_FLUSH */

                    _tr_stored_block(s, 0, 0, false);
                    /* For a full flush, this empty block will be recognized
                     * as a special marker by inflate_sync().
                     */
                    if (flush === Z_FULL_FLUSH$1) {
                        /*** CLEAR_HASH(s); ***/ /* forget history */
                        zero(s.head); // Fill with NIL (= 0);

                        if (s.lookahead === 0) {
                            s.strstart = 0;
                            s.block_start = 0;
                            s.insert = 0;
                        }
                    }
                }
                flush_pending(strm);
                if (strm.avail_out === 0) {
                    s.last_flush =
                        -1; /* avoid BUF_ERROR at next call, see above */
                    return Z_OK$3;
                }
            }
        }

        if (flush !== Z_FINISH$3) {
            return Z_OK$3;
        }
        if (s.wrap <= 0) {
            return Z_STREAM_END$3;
        }

        /* Write the trailer */
        if (s.wrap === 2) {
            put_byte(s, strm.adler & 0xff);
            put_byte(s, (strm.adler >> 8) & 0xff);
            put_byte(s, (strm.adler >> 16) & 0xff);
            put_byte(s, (strm.adler >> 24) & 0xff);
            put_byte(s, strm.total_in & 0xff);
            put_byte(s, (strm.total_in >> 8) & 0xff);
            put_byte(s, (strm.total_in >> 16) & 0xff);
            put_byte(s, (strm.total_in >> 24) & 0xff);
        } else {
            putShortMSB(s, strm.adler >>> 16);
            putShortMSB(s, strm.adler & 0xffff);
        }

        flush_pending(strm);
        /* If avail_out is zero, the application will call deflate again
         * to flush the rest.
         */
        if (s.wrap > 0) {
            s.wrap = -s.wrap;
        }
        /* write the trailer only once! */
        return s.pending !== 0 ? Z_OK$3 : Z_STREAM_END$3;
    };

    const deflateEnd = (strm) => {
        if (deflateStateCheck(strm)) {
            return Z_STREAM_ERROR$2;
        }

        const status = strm.state.status;

        strm.state = null;

        return status === BUSY_STATE ? err(strm, Z_DATA_ERROR$2) : Z_OK$3;
    };

    /* =========================================================================
     * Initializes the compression dictionary from the given byte
     * sequence without producing any compressed output.
     */
    const deflateSetDictionary = (strm, dictionary) => {
        let dictLength = dictionary.length;

        if (deflateStateCheck(strm)) {
            return Z_STREAM_ERROR$2;
        }

        const s = strm.state;
        const wrap = s.wrap;

        if (
            wrap === 2 ||
            (wrap === 1 && s.status !== INIT_STATE) ||
            s.lookahead
        ) {
            return Z_STREAM_ERROR$2;
        }

        /* when using zlib wrappers, compute Adler-32 for provided dictionary */
        if (wrap === 1) {
            /* adler32(strm->adler, dictionary, dictLength); */
            strm.adler = adler32_1(strm.adler, dictionary, dictLength, 0);
        }

        s.wrap = 0; /* avoid computing Adler-32 in read_buf */

        /* if dictionary would fill window, just replace the history */
        if (dictLength >= s.w_size) {
            if (wrap === 0) {
                /* already empty otherwise */
                /*** CLEAR_HASH(s); ***/
                zero(s.head); // Fill with NIL (= 0);
                s.strstart = 0;
                s.block_start = 0;
                s.insert = 0;
            }
            /* use the tail */
            // dictionary = dictionary.slice(dictLength - s.w_size);
            let tmpDict = new Uint8Array(s.w_size);
            tmpDict.set(
                dictionary.subarray(dictLength - s.w_size, dictLength),
                0
            );
            dictionary = tmpDict;
            dictLength = s.w_size;
        }
        /* insert dictionary into window and hash */
        const avail = strm.avail_in;
        const next = strm.next_in;
        const input = strm.input;
        strm.avail_in = dictLength;
        strm.next_in = 0;
        strm.input = dictionary;
        fill_window(s);
        while (s.lookahead >= MIN_MATCH) {
            let str = s.strstart;
            let n = s.lookahead - (MIN_MATCH - 1);
            do {
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
                s.ins_h = HASH(s, s.ins_h, s.window[str + MIN_MATCH - 1]);

                s.prev[str & s.w_mask] = s.head[s.ins_h];

                s.head[s.ins_h] = str;
                str++;
            } while (--n);
            s.strstart = str;
            s.lookahead = MIN_MATCH - 1;
            fill_window(s);
        }
        s.strstart += s.lookahead;
        s.block_start = s.strstart;
        s.insert = s.lookahead;
        s.lookahead = 0;
        s.match_length = s.prev_length = MIN_MATCH - 1;
        s.match_available = 0;
        strm.next_in = next;
        strm.input = input;
        strm.avail_in = avail;
        s.wrap = wrap;
        return Z_OK$3;
    };

    var deflateInit_1 = deflateInit;
    var deflateInit2_1 = deflateInit2;
    var deflateReset_1 = deflateReset;
    var deflateResetKeep_1 = deflateResetKeep;
    var deflateSetHeader_1 = deflateSetHeader;
    var deflate_2$1 = deflate$2;
    var deflateEnd_1 = deflateEnd;
    var deflateSetDictionary_1 = deflateSetDictionary;
    var deflateInfo = "pako deflate (from Nodeca project)";

    /* Not implemented
  module.exports.deflateBound = deflateBound;
  module.exports.deflateCopy = deflateCopy;
  module.exports.deflateGetDictionary = deflateGetDictionary;
  module.exports.deflateParams = deflateParams;
  module.exports.deflatePending = deflatePending;
  module.exports.deflatePrime = deflatePrime;
  module.exports.deflateTune = deflateTune;
  */

    var deflate_1$2 = {
        deflateInit: deflateInit_1,
        deflateInit2: deflateInit2_1,
        deflateReset: deflateReset_1,
        deflateResetKeep: deflateResetKeep_1,
        deflateSetHeader: deflateSetHeader_1,
        deflate: deflate_2$1,
        deflateEnd: deflateEnd_1,
        deflateSetDictionary: deflateSetDictionary_1,
        deflateInfo: deflateInfo,
    };

    const _has = (obj, key) => {
        return Object.prototype.hasOwnProperty.call(obj, key);
    };

    var assign = function (obj /*from1, from2, from3, ...*/) {
        const sources = Array.prototype.slice.call(arguments, 1);
        while (sources.length) {
            const source = sources.shift();
            if (!source) {
                continue;
            }

            if (typeof source !== "object") {
                throw new TypeError(source + "must be non-object");
            }

            for (const p in source) {
                if (_has(source, p)) {
                    obj[p] = source[p];
                }
            }
        }

        return obj;
    };

    // Join array of chunks to single array.
    var flattenChunks = (chunks) => {
        // calculate data length
        let len = 0;

        for (let i = 0, l = chunks.length; i < l; i++) {
            len += chunks[i].length;
        }

        // join chunks
        const result = new Uint8Array(len);

        for (let i = 0, pos = 0, l = chunks.length; i < l; i++) {
            let chunk = chunks[i];
            result.set(chunk, pos);
            pos += chunk.length;
        }

        return result;
    };

    var common = {
        assign: assign,
        flattenChunks: flattenChunks,
    };

    // String encode/decode helpers

    // Quick check if we can use fast array to bin string conversion
    //
    // - apply(Array) can fail on Android 2.2
    // - apply(Uint8Array) can fail on iOS 5.1 Safari
    //
    let STR_APPLY_UIA_OK = true;

    try {
        String.fromCharCode.apply(null, new Uint8Array(1));
    } catch (__) {
        STR_APPLY_UIA_OK = false;
    }

    // Table with utf8 lengths (calculated by first byte of sequence)
    // Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
    // because max possible codepoint is 0x10ffff
    const _utf8len = new Uint8Array(256);
    for (let q = 0; q < 256; q++) {
        _utf8len[q] =
            q >= 252
                ? 6
                : q >= 248
                ? 5
                : q >= 240
                ? 4
                : q >= 224
                ? 3
                : q >= 192
                ? 2
                : 1;
    }
    _utf8len[254] = _utf8len[254] = 1; // Invalid sequence start

    // convert string to array (typed, when possible)
    var string2buf = (str) => {
        if (typeof TextEncoder === "function" && TextEncoder.prototype.encode) {
            return new TextEncoder().encode(str);
        }

        let buf,
            c,
            c2,
            m_pos,
            i,
            str_len = str.length,
            buf_len = 0;

        // count binary size
        for (m_pos = 0; m_pos < str_len; m_pos++) {
            c = str.charCodeAt(m_pos);
            if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
                c2 = str.charCodeAt(m_pos + 1);
                if ((c2 & 0xfc00) === 0xdc00) {
                    c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
                    m_pos++;
                }
            }
            buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
        }

        // allocate buffer
        buf = new Uint8Array(buf_len);

        // convert
        for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
            c = str.charCodeAt(m_pos);
            if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
                c2 = str.charCodeAt(m_pos + 1);
                if ((c2 & 0xfc00) === 0xdc00) {
                    c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
                    m_pos++;
                }
            }
            if (c < 0x80) {
                /* one byte */
                buf[i++] = c;
            } else if (c < 0x800) {
                /* two bytes */
                buf[i++] = 0xc0 | (c >>> 6);
                buf[i++] = 0x80 | (c & 0x3f);
            } else if (c < 0x10000) {
                /* three bytes */
                buf[i++] = 0xe0 | (c >>> 12);
                buf[i++] = 0x80 | ((c >>> 6) & 0x3f);
                buf[i++] = 0x80 | (c & 0x3f);
            } else {
                /* four bytes */
                buf[i++] = 0xf0 | (c >>> 18);
                buf[i++] = 0x80 | ((c >>> 12) & 0x3f);
                buf[i++] = 0x80 | ((c >>> 6) & 0x3f);
                buf[i++] = 0x80 | (c & 0x3f);
            }
        }

        return buf;
    };

    // Helper
    const buf2binstring = (buf, len) => {
        // On Chrome, the arguments in a function call that are allowed is `65534`.
        // If the length of the buffer is smaller than that, we can use this optimization,
        // otherwise we will take a slower path.
        if (len < 65534) {
            if (buf.subarray && STR_APPLY_UIA_OK) {
                return String.fromCharCode.apply(
                    null,
                    buf.length === len ? buf : buf.subarray(0, len)
                );
            }
        }

        let result = "";
        for (let i = 0; i < len; i++) {
            result += String.fromCharCode(buf[i]);
        }
        return result;
    };

    // convert array to string
    var buf2string = (buf, max) => {
        const len = max || buf.length;

        if (typeof TextDecoder === "function" && TextDecoder.prototype.decode) {
            return new TextDecoder().decode(buf.subarray(0, max));
        }

        let i, out;

        // Reserve max possible length (2 words per char)
        // NB: by unknown reasons, Array is significantly faster for
        //     String.fromCharCode.apply than Uint16Array.
        const utf16buf = new Array(len * 2);

        for (out = 0, i = 0; i < len; ) {
            let c = buf[i++];
            // quick process ascii
            if (c < 0x80) {
                utf16buf[out++] = c;
                continue;
            }

            let c_len = _utf8len[c];
            // skip 5 & 6 byte codes
            if (c_len > 4) {
                utf16buf[out++] = 0xfffd;
                i += c_len - 1;
                continue;
            }

            // apply mask on first byte
            c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
            // join the rest
            while (c_len > 1 && i < len) {
                c = (c << 6) | (buf[i++] & 0x3f);
                c_len--;
            }

            // terminated by end of string?
            if (c_len > 1) {
                utf16buf[out++] = 0xfffd;
                continue;
            }

            if (c < 0x10000) {
                utf16buf[out++] = c;
            } else {
                c -= 0x10000;
                utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
                utf16buf[out++] = 0xdc00 | (c & 0x3ff);
            }
        }

        return buf2binstring(utf16buf, out);
    };

    // Calculate max possible position in utf8 buffer,
    // that will not break sequence. If that's not possible
    // - (very small limits) return max size as is.
    //
    // buf[] - utf8 bytes array
    // max   - length limit (mandatory);
    var utf8border = (buf, max) => {
        max = max || buf.length;
        if (max > buf.length) {
            max = buf.length;
        }

        // go back from last position, until start of sequence found
        let pos = max - 1;
        while (pos >= 0 && (buf[pos] & 0xc0) === 0x80) {
            pos--;
        }

        // Very small and broken sequence,
        // return max, because we should return something anyway.
        if (pos < 0) {
            return max;
        }

        // If we came to start of buffer - that means buffer is too small,
        // return max too.
        if (pos === 0) {
            return max;
        }

        return pos + _utf8len[buf[pos]] > max ? pos : max;
    };

    var strings = {
        string2buf: string2buf,
        buf2string: buf2string,
        utf8border: utf8border,
    };

    // (C) 1995-2013 Jean-loup Gailly and Mark Adler
    // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
    //
    // This software is provided 'as-is', without any express or implied
    // warranty. In no event will the authors be held liable for any damages
    // arising from the use of this software.
    //
    // Permission is granted to anyone to use this software for any purpose,
    // including commercial applications, and to alter it and redistribute it
    // freely, subject to the following restrictions:
    //
    // 1. The origin of this software must not be misrepresented; you must not
    //   claim that you wrote the original software. If you use this software
    //   in a product, an acknowledgment in the product documentation would be
    //   appreciated but is not required.
    // 2. Altered source versions must be plainly marked as such, and must not be
    //   misrepresented as being the original software.
    // 3. This notice may not be removed or altered from any source distribution.

    class ZStream {
        constructor() {
            /* next input byte */
            this.input = null; // JS specific, because we have no pointers
            this.next_in = 0;
            /* number of bytes available at input */
            this.avail_in = 0;
            /* total number of input bytes read so far */
            this.total_in = 0;
            /* next output byte should be put there */
            this.output = null; // JS specific, because we have no pointers
            this.next_out = 0;
            /* remaining free space at output */
            this.avail_out = 0;
            /* total number of bytes output so far */
            this.total_out = 0;
            /* last error message, NULL if no error */
            this.msg = "" /*Z_NULL*/;
            /* not visible by applications */
            this.state = null;
            /* best guess about the data type: binary or text */
            this.data_type = 2 /*Z_UNKNOWN*/;
            /* adler32 value of the uncompressed data */
            this.adler = 0;
        }
    }

    var zstream = ZStream;

    const toString$1 = Object.prototype.toString;

    /* Public constants ==========================================================*/
    /* ===========================================================================*/

    const {
        Z_NO_FLUSH: Z_NO_FLUSH$1,
        Z_SYNC_FLUSH,
        Z_FULL_FLUSH,
        Z_FINISH: Z_FINISH$2,
        Z_OK: Z_OK$2,
        Z_STREAM_END: Z_STREAM_END$2,
        Z_DEFAULT_COMPRESSION,
        Z_DEFAULT_STRATEGY,
        Z_DEFLATED: Z_DEFLATED$1,
    } = constants$2;

    /* ===========================================================================*/

    /**
     * class Deflate
     *
     * Generic JS-style wrapper for zlib calls. If you don't need
     * streaming behaviour - use more simple functions: [[deflate]],
     * [[deflateRaw]] and [[gzip]].
     **/

    /* internal
     * Deflate.chunks -> Array
     *
     * Chunks of output data, if [[Deflate#onData]] not overridden.
     **/

    /**
     * Deflate.result -> Uint8Array
     *
     * Compressed result, generated by default [[Deflate#onData]]
     * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
     * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
     **/

    /**
     * Deflate.err -> Number
     *
     * Error code after deflate finished. 0 (Z_OK) on success.
     * You will not need it in real life, because deflate errors
     * are possible only on wrong options or bad `onData` / `onEnd`
     * custom handlers.
     **/

    /**
     * Deflate.msg -> String
     *
     * Error message, if [[Deflate.err]] != 0
     **/

    /**
     * new Deflate(options)
     * - options (Object): zlib deflate options.
     *
     * Creates new deflator instance with specified params. Throws exception
     * on bad params. Supported options:
     *
     * - `level`
     * - `windowBits`
     * - `memLevel`
     * - `strategy`
     * - `dictionary`
     *
     * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
     * for more information on these.
     *
     * Additional options, for internal needs:
     *
     * - `chunkSize` - size of generated data chunks (16K by default)
     * - `raw` (Boolean) - do raw deflate
     * - `gzip` (Boolean) - create gzip wrapper
     * - `header` (Object) - custom header for gzip
     *   - `text` (Boolean) - true if compressed data believed to be text
     *   - `time` (Number) - modification time, unix timestamp
     *   - `os` (Number) - operation system code
     *   - `extra` (Array) - array of bytes with extra data (max 65536)
     *   - `name` (String) - file name (binary string)
     *   - `comment` (String) - comment (binary string)
     *   - `hcrc` (Boolean) - true if header crc should be added
     *
     * ##### Example:
     *
     * ```javascript
     * const pako = require('pako')
     *   , chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
     *   , chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
     *
     * const deflate = new pako.Deflate({ level: 3});
     *
     * deflate.push(chunk1, false);
     * deflate.push(chunk2, true);  // true -> last chunk
     *
     * if (deflate.err) { throw new Error(deflate.err); }
     *
     * console.log(deflate.result);
     * ```
     **/
    class Deflate$1 {
        constructor(options) {
            this.options = common.assign(
                {
                    level: Z_DEFAULT_COMPRESSION,
                    method: Z_DEFLATED$1,
                    chunkSize: 16384,
                    windowBits: 15,
                    memLevel: 8,
                    strategy: Z_DEFAULT_STRATEGY,
                },
                options || {}
            );

            let opt = this.options;

            if (opt.raw && opt.windowBits > 0) {
                opt.windowBits = -opt.windowBits;
            } else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) {
                opt.windowBits += 16;
            }

            this.err = 0; // error code, if happens (0 = Z_OK)
            this.msg = ""; // error message
            this.ended = false; // used to avoid multiple onEnd() calls
            this.chunks = []; // chunks of compressed data

            this.strm = new zstream();
            this.strm.avail_out = 0;

            let status = deflate_1$2.deflateInit2(
                this.strm,
                opt.level,
                opt.method,
                opt.windowBits,
                opt.memLevel,
                opt.strategy
            );

            if (status !== Z_OK$2) {
                throw new Error(messages[status]);
            }

            if (opt.header) {
                deflate_1$2.deflateSetHeader(this.strm, opt.header);
            }

            if (opt.dictionary) {
                let dict;
                // Convert data if needed
                if (typeof opt.dictionary === "string") {
                    // If we need to compress text, change encoding to utf8.
                    dict = strings.string2buf(opt.dictionary);
                } else if (
                    toString$1.call(opt.dictionary) === "[object ArrayBuffer]"
                ) {
                    dict = new Uint8Array(opt.dictionary);
                } else {
                    dict = opt.dictionary;
                }

                status = deflate_1$2.deflateSetDictionary(this.strm, dict);

                if (status !== Z_OK$2) {
                    throw new Error(messages[status]);
                }

                this._dict_set = true;
            }
        }
        /**
         * Deflate#push(data[, flush_mode]) -> Boolean
         * - data (Uint8Array|ArrayBuffer|String): input data. Strings will be
         *   converted to utf8 byte sequence.
         * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
         *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
         *
         * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
         * new compressed chunks. Returns `true` on success. The last data block must
         * have `flush_mode` Z_FINISH (or `true`). That will flush internal pending
         * buffers and call [[Deflate#onEnd]].
         *
         * On fail call [[Deflate#onEnd]] with error code and return false.
         *
         * ##### Example
         *
         * ```javascript
         * push(chunk, false); // push one of data chunks
         * ...
         * push(chunk, true);  // push last chunk
         * ```
         **/
        push(data, flush_mode) {
            const strm = this.strm;
            const chunkSize = this.options.chunkSize;
            let status, _flush_mode;

            if (this.ended) {
                return false;
            }

            if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
            else _flush_mode = flush_mode === true ? Z_FINISH$2 : Z_NO_FLUSH$1;

            // Convert data if needed
            if (typeof data === "string") {
                // If we need to compress text, change encoding to utf8.
                strm.input = strings.string2buf(data);
            } else if (toString$1.call(data) === "[object ArrayBuffer]") {
                strm.input = new Uint8Array(data);
            } else {
                strm.input = data;
            }

            strm.next_in = 0;
            strm.avail_in = strm.input.length;

            for (;;) {
                if (strm.avail_out === 0) {
                    strm.output = new Uint8Array(chunkSize);
                    strm.next_out = 0;
                    strm.avail_out = chunkSize;
                }

                // Make sure avail_out > 6 to avoid repeating markers
                if (
                    (_flush_mode === Z_SYNC_FLUSH ||
                        _flush_mode === Z_FULL_FLUSH) &&
                    strm.avail_out <= 6
                ) {
                    this.onData(strm.output.subarray(0, strm.next_out));
                    strm.avail_out = 0;
                    continue;
                }

                status = deflate_1$2.deflate(strm, _flush_mode);

                // Ended => flush and finish
                if (status === Z_STREAM_END$2) {
                    if (strm.next_out > 0) {
                        this.onData(strm.output.subarray(0, strm.next_out));
                    }
                    status = deflate_1$2.deflateEnd(this.strm);
                    this.onEnd(status);
                    this.ended = true;
                    return status === Z_OK$2;
                }

                // Flush if out buffer full
                if (strm.avail_out === 0) {
                    this.onData(strm.output);
                    continue;
                }

                // Flush if requested and has data
                if (_flush_mode > 0 && strm.next_out > 0) {
                    this.onData(strm.output.subarray(0, strm.next_out));
                    strm.avail_out = 0;
                    continue;
                }

                if (strm.avail_in === 0) break;
            }

            return true;
        }
        /**
         * Deflate#onData(chunk) -> Void
         * - chunk (Uint8Array): output data.
         *
         * By default, stores data blocks in `chunks[]` property and glue
         * those in `onEnd`. Override this handler, if you need another behaviour.
         **/
        onData(chunk) {
            this.chunks.push(chunk);
        }
        /**
         * Deflate#onEnd(status) -> Void
         * - status (Number): deflate status. 0 (Z_OK) on success,
         *   other if not.
         *
         * Called once after you tell deflate that the input stream is
         * complete (Z_FINISH). By default - join collected chunks,
         * free memory and fill `results` / `err` properties.
         **/
        onEnd(status) {
            // On success - join
            if (status === Z_OK$2) {
                this.result = common.flattenChunks(this.chunks);
            }
            this.chunks = [];
            this.err = status;
            this.msg = this.strm.msg;
        }
    }

    /**
     * deflate(data[, options]) -> Uint8Array
     * - data (Uint8Array|ArrayBuffer|String): input data to compress.
     * - options (Object): zlib deflate options.
     *
     * Compress `data` with deflate algorithm and `options`.
     *
     * Supported options are:
     *
     * - level
     * - windowBits
     * - memLevel
     * - strategy
     * - dictionary
     *
     * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
     * for more information on these.
     *
     * Sugar (options):
     *
     * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
     *   negative windowBits implicitly.
     *
     * ##### Example:
     *
     * ```javascript
     * const pako = require('pako')
     * const data = new Uint8Array([1,2,3,4,5,6,7,8,9]);
     *
     * console.log(pako.deflate(data));
     * ```
     **/
    function deflate$1(input, options) {
        const deflator = new Deflate$1(options);

        deflator.push(input, true);

        // That will never happens, if you don't cheat with options :)
        if (deflator.err) {
            throw deflator.msg || messages[deflator.err];
        }

        return deflator.result;
    }

    /**
     * deflateRaw(data[, options]) -> Uint8Array
     * - data (Uint8Array|ArrayBuffer|String): input data to compress.
     * - options (Object): zlib deflate options.
     *
     * The same as [[deflate]], but creates raw data, without wrapper
     * (header and adler32 crc).
     **/
    function deflateRaw$1(input, options) {
        options = options || {};
        options.raw = true;
        return deflate$1(input, options);
    }

    /**
     * gzip(data[, options]) -> Uint8Array
     * - data (Uint8Array|ArrayBuffer|String): input data to compress.
     * - options (Object): zlib deflate options.
     *
     * The same as [[deflate]], but create gzip wrapper instead of
     * deflate one.
     **/
    function gzip$1(input, options) {
        options = options || {};
        options.gzip = true;
        return deflate$1(input, options);
    }

    var Deflate_1$1 = Deflate$1;
    var deflate_2 = deflate$1;
    var deflateRaw_1$1 = deflateRaw$1;
    var gzip_1$1 = gzip$1;
    var constants$1 = constants$2;

    var deflate_1$1 = {
        Deflate: Deflate_1$1,
        deflate: deflate_2,
        deflateRaw: deflateRaw_1$1,
        gzip: gzip_1$1,
        constants: constants$1,
    };

    // (C) 1995-2013 Jean-loup Gailly and Mark Adler
    // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
    //
    // This software is provided 'as-is', without any express or implied
    // warranty. In no event will the authors be held liable for any damages
    // arising from the use of this software.
    //
    // Permission is granted to anyone to use this software for any purpose,
    // including commercial applications, and to alter it and redistribute it
    // freely, subject to the following restrictions:
    //
    // 1. The origin of this software must not be misrepresented; you must not
    //   claim that you wrote the original software. If you use this software
    //   in a product, an acknowledgment in the product documentation would be
    //   appreciated but is not required.
    // 2. Altered source versions must be plainly marked as such, and must not be
    //   misrepresented as being the original software.
    // 3. This notice may not be removed or altered from any source distribution.

    // See state defs from inflate.js
    const BAD$1 = 16209; /* got a data error -- remain here until reset */
    const TYPE$1 = 16191; /* i: waiting for type bits, including last-flag bit */

    /*
     Decode literal, length, and distance codes and write out the resulting
     literal and match bytes until either not enough input or output is
     available, an end-of-block is encountered, or a data error is encountered.
     When large enough input and output buffers are supplied to inflate(), for
     example, a 16K input buffer and a 64K output buffer, more than 95% of the
     inflate execution time is spent in this routine.

     Entry assumptions:

          state.mode === LEN
          strm.avail_in >= 6
          strm.avail_out >= 258
          start >= strm.avail_out
          state.bits < 8

     On return, state.mode is one of:

          LEN -- ran out of enough output space or enough available input
          TYPE -- reached end of block code, inflate() to interpret next block
          BAD -- error in block data

     Notes:

      - The maximum input bits used by a length/distance pair is 15 bits for the
        length code, 5 bits for the length extra, 15 bits for the distance code,
        and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
        Therefore if strm.avail_in >= 6, then there is enough input to avoid
        checking for available input while decoding.

      - The maximum bytes that a single length/distance pair can output is 258
        bytes, which is the maximum length that can be coded.  inflate_fast()
        requires strm.avail_out >= 258 for each loop to avoid checking for
        output space.
   */
    var inffast = function inflate_fast(strm, start) {
        let _in; /* local strm.input */
        let last; /* have enough input while in < last */
        let _out; /* local strm.output */
        let beg; /* inflate()'s initial strm.output */
        let end; /* while out < end, enough space available */
        //#ifdef INFLATE_STRICT
        let dmax; /* maximum distance from zlib header */
        //#endif
        let wsize; /* window size or zero if not using window */
        let whave; /* valid bytes in the window */
        let wnext; /* window write index */
        // Use `s_window` instead `window`, avoid conflict with instrumentation tools
        let s_window; /* allocated sliding window, if wsize != 0 */
        let hold; /* local strm.hold */
        let bits; /* local strm.bits */
        let lcode; /* local strm.lencode */
        let dcode; /* local strm.distcode */
        let lmask; /* mask for first level of length codes */
        let dmask; /* mask for first level of distance codes */
        let here; /* retrieved table entry */
        let op; /* code bits, operation, extra bits, or */
        /*  window position, window bytes to copy */
        let len; /* match length, unused bytes */
        let dist; /* match distance */
        let from; /* where to copy match from */
        let from_source;

        let input, output; // JS specific, because we have no pointers

        /* copy state to local variables */
        const state = strm.state;
        //here = state.here;
        _in = strm.next_in;
        input = strm.input;
        last = _in + (strm.avail_in - 5);
        _out = strm.next_out;
        output = strm.output;
        beg = _out - (start - strm.avail_out);
        end = _out + (strm.avail_out - 257);
        //#ifdef INFLATE_STRICT
        dmax = state.dmax;
        //#endif
        wsize = state.wsize;
        whave = state.whave;
        wnext = state.wnext;
        s_window = state.window;
        hold = state.hold;
        bits = state.bits;
        lcode = state.lencode;
        dcode = state.distcode;
        lmask = (1 << state.lenbits) - 1;
        dmask = (1 << state.distbits) - 1;

        /* decode literals and length/distances until end-of-block or not enough
       input data or output space */

        top: do {
            if (bits < 15) {
                hold += input[_in++] << bits;
                bits += 8;
                hold += input[_in++] << bits;
                bits += 8;
            }

            here = lcode[hold & lmask];

            dolen: for (;;) {
                // Goto emulation
                op = here >>> 24 /*here.bits*/;
                hold >>>= op;
                bits -= op;
                op = (here >>> 16) & 0xff /*here.op*/;
                if (op === 0) {
                    /* literal */
                    //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                    //        "inflate:         literal '%c'\n" :
                    //        "inflate:         literal 0x%02x\n", here.val));
                    output[_out++] = here & 0xffff /*here.val*/;
                } else if (op & 16) {
                    /* length base */
                    len = here & 0xffff /*here.val*/;
                    op &= 15; /* number of extra bits */
                    if (op) {
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                        }
                        len += hold & ((1 << op) - 1);
                        hold >>>= op;
                        bits -= op;
                    }
                    //Tracevv((stderr, "inflate:         length %u\n", len));
                    if (bits < 15) {
                        hold += input[_in++] << bits;
                        bits += 8;
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    here = dcode[hold & dmask];

                    dodist: for (;;) {
                        // goto emulation
                        op = here >>> 24 /*here.bits*/;
                        hold >>>= op;
                        bits -= op;
                        op = (here >>> 16) & 0xff /*here.op*/;

                        if (op & 16) {
                            /* distance base */
                            dist = here & 0xffff /*here.val*/;
                            op &= 15; /* number of extra bits */
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                                if (bits < op) {
                                    hold += input[_in++] << bits;
                                    bits += 8;
                                }
                            }
                            dist += hold & ((1 << op) - 1);
                            //#ifdef INFLATE_STRICT
                            if (dist > dmax) {
                                strm.msg = "invalid distance too far back";
                                state.mode = BAD$1;
                                break top;
                            }
                            //#endif
                            hold >>>= op;
                            bits -= op;
                            //Tracevv((stderr, "inflate:         distance %u\n", dist));
                            op = _out - beg; /* max distance in output */
                            if (dist > op) {
                                /* see if copy from window */
                                op = dist - op; /* distance back in window */
                                if (op > whave) {
                                    if (state.sane) {
                                        strm.msg =
                                            "invalid distance too far back";
                                        state.mode = BAD$1;
                                        break top;
                                    }

                                    // (!) This block is disabled in zlib defaults,
                                    // don't enable it for binary compatibility
                                    //#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
                                    //                if (len <= op - whave) {
                                    //                  do {
                                    //                    output[_out++] = 0;
                                    //                  } while (--len);
                                    //                  continue top;
                                    //                }
                                    //                len -= op - whave;
                                    //                do {
                                    //                  output[_out++] = 0;
                                    //                } while (--op > whave);
                                    //                if (op === 0) {
                                    //                  from = _out - dist;
                                    //                  do {
                                    //                    output[_out++] = output[from++];
                                    //                  } while (--len);
                                    //                  continue top;
                                    //                }
                                    //#endif
                                }
                                from = 0; // window index
                                from_source = s_window;
                                if (wnext === 0) {
                                    /* very common case */
                                    from += wsize - op;
                                    if (op < len) {
                                        /* some from window */
                                        len -= op;
                                        do {
                                            output[_out++] = s_window[from++];
                                        } while (--op);
                                        from =
                                            _out - dist; /* rest from output */
                                        from_source = output;
                                    }
                                } else if (wnext < op) {
                                    /* wrap around window */
                                    from += wsize + wnext - op;
                                    op -= wnext;
                                    if (op < len) {
                                        /* some from end of window */
                                        len -= op;
                                        do {
                                            output[_out++] = s_window[from++];
                                        } while (--op);
                                        from = 0;
                                        if (wnext < len) {
                                            /* some from start of window */
                                            op = wnext;
                                            len -= op;
                                            do {
                                                output[_out++] =
                                                    s_window[from++];
                                            } while (--op);
                                            from =
                                                _out -
                                                dist; /* rest from output */
                                            from_source = output;
                                        }
                                    }
                                } else {
                                    /* contiguous in window */
                                    from += wnext - op;
                                    if (op < len) {
                                        /* some from window */
                                        len -= op;
                                        do {
                                            output[_out++] = s_window[from++];
                                        } while (--op);
                                        from =
                                            _out - dist; /* rest from output */
                                        from_source = output;
                                    }
                                }
                                while (len > 2) {
                                    output[_out++] = from_source[from++];
                                    output[_out++] = from_source[from++];
                                    output[_out++] = from_source[from++];
                                    len -= 3;
                                }
                                if (len) {
                                    output[_out++] = from_source[from++];
                                    if (len > 1) {
                                        output[_out++] = from_source[from++];
                                    }
                                }
                            } else {
                                from =
                                    _out - dist; /* copy direct from output */
                                do {
                                    /* minimum length is three */
                                    output[_out++] = output[from++];
                                    output[_out++] = output[from++];
                                    output[_out++] = output[from++];
                                    len -= 3;
                                } while (len > 2);
                                if (len) {
                                    output[_out++] = output[from++];
                                    if (len > 1) {
                                        output[_out++] = output[from++];
                                    }
                                }
                            }
                        } else if ((op & 64) === 0) {
                            /* 2nd level distance code */
                            here =
                                dcode[
                                    (here & 0xffff) /*here.val*/ +
                                        (hold & ((1 << op) - 1))
                                ];
                            continue dodist;
                        } else {
                            strm.msg = "invalid distance code";
                            state.mode = BAD$1;
                            break top;
                        }

                        break; // need to emulate goto via "continue"
                    }
                } else if ((op & 64) === 0) {
                    /* 2nd level length code */
                    here =
                        lcode[
                            (here & 0xffff) /*here.val*/ +
                                (hold & ((1 << op) - 1))
                        ];
                    continue dolen;
                } else if (op & 32) {
                    /* end-of-block */
                    //Tracevv((stderr, "inflate:         end of block\n"));
                    state.mode = TYPE$1;
                    break top;
                } else {
                    strm.msg = "invalid literal/length code";
                    state.mode = BAD$1;
                    break top;
                }

                break; // need to emulate goto via "continue"
            }
        } while (_in < last && _out < end);

        /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
        len = bits >> 3;
        _in -= len;
        bits -= len << 3;
        hold &= (1 << bits) - 1;

        /* update state and return */
        strm.next_in = _in;
        strm.next_out = _out;
        strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
        strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
        state.hold = hold;
        state.bits = bits;
        return;
    };

    // (C) 1995-2013 Jean-loup Gailly and Mark Adler
    // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
    //
    // This software is provided 'as-is', without any express or implied
    // warranty. In no event will the authors be held liable for any damages
    // arising from the use of this software.
    //
    // Permission is granted to anyone to use this software for any purpose,
    // including commercial applications, and to alter it and redistribute it
    // freely, subject to the following restrictions:
    //
    // 1. The origin of this software must not be misrepresented; you must not
    //   claim that you wrote the original software. If you use this software
    //   in a product, an acknowledgment in the product documentation would be
    //   appreciated but is not required.
    // 2. Altered source versions must be plainly marked as such, and must not be
    //   misrepresented as being the original software.
    // 3. This notice may not be removed or altered from any source distribution.

    const MAXBITS = 15;
    const ENOUGH_LENS$1 = 852;
    const ENOUGH_DISTS$1 = 592;
    //const ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);

    const CODES$1 = 0;
    const LENS$1 = 1;
    const DISTS$1 = 2;

    const lbase = new Uint16Array([
        /* Length codes 257..285 base */ 3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15,
        17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227,
        258, 0, 0,
    ]);

    const lext = new Uint8Array([
        /* Length codes 257..285 extra */ 16, 16, 16, 16, 16, 16, 16, 16, 17,
        17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21,
        21, 16, 72, 78,
    ]);

    const dbase = new Uint16Array([
        /* Distance codes 0..29 base */ 1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49,
        65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097,
        6145, 8193, 12289, 16385, 24577, 0, 0,
    ]);

    const dext = new Uint8Array([
        /* Distance codes 0..29 extra */ 16, 16, 16, 16, 17, 17, 18, 18, 19, 19,
        20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28,
        29, 29, 64, 64,
    ]);

    const inflate_table = (
        type,
        lens,
        lens_index,
        codes,
        table,
        table_index,
        work,
        opts
    ) => {
        const bits = opts.bits;
        //here = opts.here; /* table entry for duplication */

        let len = 0; /* a code's length in bits */
        let sym = 0; /* index of code symbols */
        let min = 0,
            max = 0; /* minimum and maximum code lengths */
        let root = 0; /* number of index bits for root table */
        let curr = 0; /* number of index bits for current table */
        let drop = 0; /* code bits to drop for sub-table */
        let left = 0; /* number of prefix codes available */
        let used = 0; /* code entries in table used */
        let huff = 0; /* Huffman code */
        let incr; /* for incrementing code, index */
        let fill; /* index for replicating entries */
        let low; /* low bits for current root entry */
        let mask; /* mask for low root bits */
        let next; /* next available space in table */
        let base = null; /* base value table to use */
        //  let shoextra;    /* extra bits table to use */
        let match; /* use base and extra for symbol >= match */
        const count = new Uint16Array(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
        const offs = new Uint16Array(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
        let extra = null;

        let here_bits, here_op, here_val;

        /*
     Process a set of code lengths to create a canonical Huffman code.  The
     code lengths are lens[0..codes-1].  Each length corresponds to the
     symbols 0..codes-1.  The Huffman code is generated by first sorting the
     symbols by length from short to long, and retaining the symbol order
     for codes with equal lengths.  Then the code starts with all zero bits
     for the first code of the shortest length, and the codes are integer
     increments for the same length, and zeros are appended as the length
     increases.  For the deflate format, these bits are stored backwards
     from their more natural integer increment ordering, and so when the
     decoding tables are built in the large loop below, the integer codes
     are incremented backwards.

     This routine assumes, but does not check, that all of the entries in
     lens[] are in the range 0..MAXBITS.  The caller must assure this.
     1..MAXBITS is interpreted as that code length.  zero means that that
     symbol does not occur in this code.

     The codes are sorted by computing a count of codes for each length,
     creating from that a table of starting indices for each length in the
     sorted table, and then entering the symbols in order in the sorted
     table.  The sorted table is work[], with that space being provided by
     the caller.

     The length counts are used for other purposes as well, i.e. finding
     the minimum and maximum length codes, determining if there are any
     codes at all, checking for a valid set of lengths, and looking ahead
     at length counts to determine sub-table sizes when building the
     decoding tables.
     */

        /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
        for (len = 0; len <= MAXBITS; len++) {
            count[len] = 0;
        }
        for (sym = 0; sym < codes; sym++) {
            count[lens[lens_index + sym]]++;
        }

        /* bound code lengths, force root to be within code lengths */
        root = bits;
        for (max = MAXBITS; max >= 1; max--) {
            if (count[max] !== 0) {
                break;
            }
        }
        if (root > max) {
            root = max;
        }
        if (max === 0) {
            /* no symbols to code at all */
            //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
            //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
            //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
            table[table_index++] = (1 << 24) | (64 << 16) | 0;

            //table.op[opts.table_index] = 64;
            //table.bits[opts.table_index] = 1;
            //table.val[opts.table_index++] = 0;
            table[table_index++] = (1 << 24) | (64 << 16) | 0;

            opts.bits = 1;
            return 0; /* no symbols, but wait for decoding to report error */
        }
        for (min = 1; min < max; min++) {
            if (count[min] !== 0) {
                break;
            }
        }
        if (root < min) {
            root = min;
        }

        /* check for an over-subscribed or incomplete set of lengths */
        left = 1;
        for (len = 1; len <= MAXBITS; len++) {
            left <<= 1;
            left -= count[len];
            if (left < 0) {
                return -1;
            } /* over-subscribed */
        }
        if (left > 0 && (type === CODES$1 || max !== 1)) {
            return -1; /* incomplete set */
        }

        /* generate offsets into symbol table for each length for sorting */
        offs[1] = 0;
        for (len = 1; len < MAXBITS; len++) {
            offs[len + 1] = offs[len] + count[len];
        }

        /* sort symbols by length, by symbol order within each length */
        for (sym = 0; sym < codes; sym++) {
            if (lens[lens_index + sym] !== 0) {
                work[offs[lens[lens_index + sym]]++] = sym;
            }
        }

        /*
     Create and fill in decoding tables.  In this loop, the table being
     filled is at next and has curr index bits.  The code being used is huff
     with length len.  That code is converted to an index by dropping drop
     bits off of the bottom.  For codes where len is less than drop + curr,
     those top drop + curr - len bits are incremented through all values to
     fill the table with replicated entries.

     root is the number of index bits for the root table.  When len exceeds
     root, sub-tables are created pointed to by the root entry with an index
     of the low root bits of huff.  This is saved in low to check for when a
     new sub-table should be started.  drop is zero when the root table is
     being filled, and drop is root when sub-tables are being filled.

     When a new sub-table is needed, it is necessary to look ahead in the
     code lengths to determine what size sub-table is needed.  The length
     counts are used for this, and so count[] is decremented as codes are
     entered in the tables.

     used keeps track of how many table entries have been allocated from the
     provided *table space.  It is checked for LENS and DIST tables against
     the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
     the initial root table size constants.  See the comments in inftrees.h
     for more information.

     sym increments through all symbols, and the loop terminates when
     all codes of length max, i.e. all codes, have been processed.  This
     routine permits incomplete codes, so another loop after this one fills
     in the rest of the decoding tables with invalid code markers.
     */

        /* set up for code type */
        // poor man optimization - use if-else instead of switch,
        // to avoid deopts in old v8
        if (type === CODES$1) {
            base = extra = work; /* dummy value--not used */
            match = 20;
        } else if (type === LENS$1) {
            base = lbase;
            extra = lext;
            match = 257;
        } else {
            /* DISTS */
            base = dbase;
            extra = dext;
            match = 0;
        }

        /* initialize opts for loop */
        huff = 0; /* starting code */
        sym = 0; /* starting code symbol */
        len = min; /* starting code length */
        next = table_index; /* current table to fill in */
        curr = root; /* current table index bits */
        drop = 0; /* current bits to drop from code for index */
        low = -1; /* trigger new sub-table when len > root */
        used = 1 << root; /* use root table entries */
        mask = used - 1; /* mask for comparing low */

        /* check available table space */
        if (
            (type === LENS$1 && used > ENOUGH_LENS$1) ||
            (type === DISTS$1 && used > ENOUGH_DISTS$1)
        ) {
            return 1;
        }

        /* process all codes and make table entries */
        for (;;) {
            /* create table entry */
            here_bits = len - drop;
            if (work[sym] + 1 < match) {
                here_op = 0;
                here_val = work[sym];
            } else if (work[sym] >= match) {
                here_op = extra[work[sym] - match];
                here_val = base[work[sym] - match];
            } else {
                here_op = 32 + 64; /* end of block */
                here_val = 0;
            }

            /* replicate for those indices with low len bits equal to huff */
            incr = 1 << (len - drop);
            fill = 1 << curr;
            min = fill; /* save offset to next table */
            do {
                fill -= incr;
                table[next + (huff >> drop) + fill] =
                    (here_bits << 24) | (here_op << 16) | here_val | 0;
            } while (fill !== 0);

            /* backwards increment the len-bit code huff */
            incr = 1 << (len - 1);
            while (huff & incr) {
                incr >>= 1;
            }
            if (incr !== 0) {
                huff &= incr - 1;
                huff += incr;
            } else {
                huff = 0;
            }

            /* go to next symbol, update count, len */
            sym++;
            if (--count[len] === 0) {
                if (len === max) {
                    break;
                }
                len = lens[lens_index + work[sym]];
            }

            /* create new sub-table if needed */
            if (len > root && (huff & mask) !== low) {
                /* if first time, transition to sub-tables */
                if (drop === 0) {
                    drop = root;
                }

                /* increment past last table */
                next += min; /* here min is 1 << curr */

                /* determine length of next table */
                curr = len - drop;
                left = 1 << curr;
                while (curr + drop < max) {
                    left -= count[curr + drop];
                    if (left <= 0) {
                        break;
                    }
                    curr++;
                    left <<= 1;
                }

                /* check for enough space */
                used += 1 << curr;
                if (
                    (type === LENS$1 && used > ENOUGH_LENS$1) ||
                    (type === DISTS$1 && used > ENOUGH_DISTS$1)
                ) {
                    return 1;
                }

                /* point entry in root table to sub-table */
                low = huff & mask;
                /*table.op[low] = curr;
        table.bits[low] = root;
        table.val[low] = next - opts.table_index;*/
                table[low] =
                    (root << 24) | (curr << 16) | (next - table_index) | 0;
            }
        }

        /* fill in remaining table entry if code is incomplete (guaranteed to have
     at most one remaining entry, since if the code is incomplete, the
     maximum code length that was allowed to get this far is one bit) */
        if (huff !== 0) {
            //table.op[next + huff] = 64;            /* invalid code marker */
            //table.bits[next + huff] = len - drop;
            //table.val[next + huff] = 0;
            table[next + huff] = ((len - drop) << 24) | (64 << 16) | 0;
        }

        /* set return parameters */
        //opts.table_index += used;
        opts.bits = root;
        return 0;
    };

    var inftrees = inflate_table;

    // (C) 1995-2013 Jean-loup Gailly and Mark Adler
    // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
    //
    // This software is provided 'as-is', without any express or implied
    // warranty. In no event will the authors be held liable for any damages
    // arising from the use of this software.
    //
    // Permission is granted to anyone to use this software for any purpose,
    // including commercial applications, and to alter it and redistribute it
    // freely, subject to the following restrictions:
    //
    // 1. The origin of this software must not be misrepresented; you must not
    //   claim that you wrote the original software. If you use this software
    //   in a product, an acknowledgment in the product documentation would be
    //   appreciated but is not required.
    // 2. Altered source versions must be plainly marked as such, and must not be
    //   misrepresented as being the original software.
    // 3. This notice may not be removed or altered from any source distribution.

    const CODES = 0;
    const LENS = 1;
    const DISTS = 2;

    /* Public constants ==========================================================*/
    /* ===========================================================================*/

    const {
        Z_FINISH: Z_FINISH$1,
        Z_BLOCK,
        Z_TREES,
        Z_OK: Z_OK$1,
        Z_STREAM_END: Z_STREAM_END$1,
        Z_NEED_DICT: Z_NEED_DICT$1,
        Z_STREAM_ERROR: Z_STREAM_ERROR$1,
        Z_DATA_ERROR: Z_DATA_ERROR$1,
        Z_MEM_ERROR: Z_MEM_ERROR$1,
        Z_BUF_ERROR,
        Z_DEFLATED,
    } = constants$2;

    /* STATES ====================================================================*/
    /* ===========================================================================*/

    const HEAD = 16180; /* i: waiting for magic header */
    const FLAGS = 16181; /* i: waiting for method and flags (gzip) */
    const TIME = 16182; /* i: waiting for modification time (gzip) */
    const OS = 16183; /* i: waiting for extra flags and operating system (gzip) */
    const EXLEN = 16184; /* i: waiting for extra length (gzip) */
    const EXTRA = 16185; /* i: waiting for extra bytes (gzip) */
    const NAME = 16186; /* i: waiting for end of file name (gzip) */
    const COMMENT = 16187; /* i: waiting for end of comment (gzip) */
    const HCRC = 16188; /* i: waiting for header crc (gzip) */
    const DICTID = 16189; /* i: waiting for dictionary check value */
    const DICT = 16190; /* waiting for inflateSetDictionary() call */
    const TYPE = 16191; /* i: waiting for type bits, including last-flag bit */
    const TYPEDO = 16192; /* i: same, but skip check to exit inflate on new block */
    const STORED = 16193; /* i: waiting for stored size (length and complement) */
    const COPY_ = 16194; /* i/o: same as COPY below, but only first time in */
    const COPY = 16195; /* i/o: waiting for input or output to copy stored block */
    const TABLE = 16196; /* i: waiting for dynamic block table lengths */
    const LENLENS = 16197; /* i: waiting for code length code lengths */
    const CODELENS = 16198; /* i: waiting for length/lit and distance code lengths */
    const LEN_ = 16199; /* i: same as LEN below, but only first time in */
    const LEN = 16200; /* i: waiting for length/lit/eob code */
    const LENEXT = 16201; /* i: waiting for length extra bits */
    const DIST = 16202; /* i: waiting for distance code */
    const DISTEXT = 16203; /* i: waiting for distance extra bits */
    const MATCH = 16204; /* o: waiting for output space to copy string */
    const LIT = 16205; /* o: waiting for output space to write literal */
    const CHECK = 16206; /* i: waiting for 32-bit check value */
    const LENGTH = 16207; /* i: waiting for 32-bit length (gzip) */
    const DONE = 16208; /* finished check, done -- remain here until reset */
    const BAD = 16209; /* got a data error -- remain here until reset */
    const MEM = 16210; /* got an inflate() memory error -- remain here until reset */
    const SYNC = 16211; /* looking for synchronization bytes to restart inflate() */

    /* ===========================================================================*/

    const ENOUGH_LENS = 852;
    const ENOUGH_DISTS = 592;
    //const ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);

    const MAX_WBITS = 15;
    /* 32K LZ77 window */
    const DEF_WBITS = MAX_WBITS;

    const zswap32 = (q) => {
        return (
            ((q >>> 24) & 0xff) +
            ((q >>> 8) & 0xff00) +
            ((q & 0xff00) << 8) +
            ((q & 0xff) << 24)
        );
    };

    class InflateState {
        constructor() {
            this.strm = null; /* pointer back to this zlib stream */
            this.mode = 0; /* current inflate mode */
            this.last = false; /* true if processing last block */
            this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip,
                                   bit 2 true to validate check value */

            this.havedict = false; /* true if dictionary provided */
            this.flags = 0; /* gzip header method and flags (0 if zlib), or
                                   -1 if raw or no header yet */

            this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */
            this.check = 0; /* protected copy of check value */
            this.total = 0; /* protected copy of output count */

            // TODO: may be {}
            this.head = null; /* where to save gzip header information */

            /* sliding window */
            this.wbits = 0; /* log base 2 of requested window size */
            this.wsize = 0; /* window size or zero if not using window */
            this.whave = 0; /* valid bytes in the window */
            this.wnext = 0; /* window write index */
            this.window = null; /* allocated sliding window, if needed */

            /* bit accumulator */
            this.hold = 0; /* input bit accumulator */
            this.bits = 0; /* number of bits in "in" */

            /* for string and stored block copying */
            this.length = 0; /* literal or length of data to copy */
            this.offset = 0; /* distance back to copy string from */

            /* for table and code decoding */
            this.extra = 0; /* extra bits needed */

            /* fixed and dynamic code tables */
            this.lencode = null; /* starting table for length/literal codes */
            this.distcode = null; /* starting table for distance codes */
            this.lenbits = 0; /* index bits for lencode */
            this.distbits = 0; /* index bits for distcode */

            /* dynamic table building */
            this.ncode = 0; /* number of code length code lengths */
            this.nlen = 0; /* number of length code lengths */
            this.ndist = 0; /* number of distance code lengths */
            this.have = 0; /* number of code lengths in lens[] */
            this.next = null; /* next available space in codes[] */

            this.lens = new Uint16Array(
                320
            ); /* temporary storage for code lengths */
            this.work = new Uint16Array(
                288
            ); /* work area for code table building */

            /*
         because we don't have pointers in js, we use lencode and distcode directly
         as buffers so we don't need codes
        */
            //this.codes = new Int32Array(ENOUGH);       /* space for code tables */
            this.lendyn =
                null; /* dynamic table for length/literal codes (JS specific) */
            this.distdyn =
                null; /* dynamic table for distance codes (JS specific) */
            this.sane = 0; /* if false, allow invalid distance too far */
            this.back = 0; /* bits back of last unprocessed length/lit */
            this.was = 0; /* initial length of match */
        }
    }

    const inflateStateCheck = (strm) => {
        if (!strm) {
            return 1;
        }
        const state = strm.state;
        if (
            !state ||
            state.strm !== strm ||
            state.mode < HEAD ||
            state.mode > SYNC
        ) {
            return 1;
        }
        return 0;
    };

    const inflateResetKeep = (strm) => {
        if (inflateStateCheck(strm)) {
            return Z_STREAM_ERROR$1;
        }
        const state = strm.state;
        strm.total_in = strm.total_out = state.total = 0;
        strm.msg = ""; /*Z_NULL*/
        if (state.wrap) {
            /* to support ill-conceived Java test suite */
            strm.adler = state.wrap & 1;
        }
        state.mode = HEAD;
        state.last = 0;
        state.havedict = 0;
        state.flags = -1;
        state.dmax = 32768;
        state.head = null /*Z_NULL*/;
        state.hold = 0;
        state.bits = 0;
        //state.lencode = state.distcode = state.next = state.codes;
        state.lencode = state.lendyn = new Int32Array(ENOUGH_LENS);
        state.distcode = state.distdyn = new Int32Array(ENOUGH_DISTS);

        state.sane = 1;
        state.back = -1;
        //Tracev((stderr, "inflate: reset\n"));
        return Z_OK$1;
    };

    const inflateReset = (strm) => {
        if (inflateStateCheck(strm)) {
            return Z_STREAM_ERROR$1;
        }
        const state = strm.state;
        state.wsize = 0;
        state.whave = 0;
        state.wnext = 0;
        return inflateResetKeep(strm);
    };

    const inflateReset2 = (strm, windowBits) => {
        let wrap;

        /* get the state */
        if (inflateStateCheck(strm)) {
            return Z_STREAM_ERROR$1;
        }
        const state = strm.state;

        /* extract wrap request from windowBits parameter */
        if (windowBits < 0) {
            wrap = 0;
            windowBits = -windowBits;
        } else {
            wrap = (windowBits >> 4) + 5;
            if (windowBits < 48) {
                windowBits &= 15;
            }
        }

        /* set number of window bits, free window if different */
        if (windowBits && (windowBits < 8 || windowBits > 15)) {
            return Z_STREAM_ERROR$1;
        }
        if (state.window !== null && state.wbits !== windowBits) {
            state.window = null;
        }

        /* update state and reset the rest of it */
        state.wrap = wrap;
        state.wbits = windowBits;
        return inflateReset(strm);
    };

    const inflateInit2 = (strm, windowBits) => {
        if (!strm) {
            return Z_STREAM_ERROR$1;
        }
        //strm.msg = Z_NULL;                 /* in case we return an error */

        const state = new InflateState();

        //if (state === Z_NULL) return Z_MEM_ERROR;
        //Tracev((stderr, "inflate: allocated\n"));
        strm.state = state;
        state.strm = strm;
        state.window = null /*Z_NULL*/;
        state.mode = HEAD; /* to pass state test in inflateReset2() */
        const ret = inflateReset2(strm, windowBits);
        if (ret !== Z_OK$1) {
            strm.state = null /*Z_NULL*/;
        }
        return ret;
    };

    const inflateInit = (strm) => {
        return inflateInit2(strm, DEF_WBITS);
    };

    /*
   Return state with length and distance decoding tables and index sizes set to
   fixed code decoding.  Normally this returns fixed tables from inffixed.h.
   If BUILDFIXED is defined, then instead this routine builds the tables the
   first time it's called, and returns those tables the first time and
   thereafter.  This reduces the size of the code by about 2K bytes, in
   exchange for a little execution time.  However, BUILDFIXED should not be
   used for threaded applications, since the rewriting of the tables and virgin
   may not be thread-safe.
   */
    let virgin = true;

    let lenfix, distfix; // We have no pointers in JS, so keep tables separate

    const fixedtables = (state) => {
        /* build fixed huffman tables if first call (may not be thread safe) */
        if (virgin) {
            lenfix = new Int32Array(512);
            distfix = new Int32Array(32);

            /* literal/length table */
            let sym = 0;
            while (sym < 144) {
                state.lens[sym++] = 8;
            }
            while (sym < 256) {
                state.lens[sym++] = 9;
            }
            while (sym < 280) {
                state.lens[sym++] = 7;
            }
            while (sym < 288) {
                state.lens[sym++] = 8;
            }

            inftrees(LENS, state.lens, 0, 288, lenfix, 0, state.work, {
                bits: 9,
            });

            /* distance table */
            sym = 0;
            while (sym < 32) {
                state.lens[sym++] = 5;
            }

            inftrees(DISTS, state.lens, 0, 32, distfix, 0, state.work, {
                bits: 5,
            });

            /* do this just once */
            virgin = false;
        }

        state.lencode = lenfix;
        state.lenbits = 9;
        state.distcode = distfix;
        state.distbits = 5;
    };

    /*
   Update the window with the last wsize (normally 32K) bytes written before
   returning.  If window does not exist yet, create it.  This is only called
   when a window is already in use, or when output has been written during this
   inflate call, but the end of the deflate stream has not been reached yet.
   It is also called to create a window for dictionary data when a dictionary
   is loaded.

   Providing output buffers larger than 32K to inflate() should provide a speed
   advantage, since only the last 32K of output is copied to the sliding window
   upon return from inflate(), and since all distances after the first 32K of
   output will fall in the output data, making match copies simpler and faster.
   The advantage may be dependent on the size of the processor's data caches.
   */
    const updatewindow = (strm, src, end, copy) => {
        let dist;
        const state = strm.state;

        /* if it hasn't been done already, allocate space for the window */
        if (state.window === null) {
            state.wsize = 1 << state.wbits;
            state.wnext = 0;
            state.whave = 0;

            state.window = new Uint8Array(state.wsize);
        }

        /* copy state->wsize or less output bytes into the circular window */
        if (copy >= state.wsize) {
            state.window.set(src.subarray(end - state.wsize, end), 0);
            state.wnext = 0;
            state.whave = state.wsize;
        } else {
            dist = state.wsize - state.wnext;
            if (dist > copy) {
                dist = copy;
            }
            //zmemcpy(state->window + state->wnext, end - copy, dist);
            state.window.set(
                src.subarray(end - copy, end - copy + dist),
                state.wnext
            );
            copy -= dist;
            if (copy) {
                //zmemcpy(state->window, end - copy, copy);
                state.window.set(src.subarray(end - copy, end), 0);
                state.wnext = copy;
                state.whave = state.wsize;
            } else {
                state.wnext += dist;
                if (state.wnext === state.wsize) {
                    state.wnext = 0;
                }
                if (state.whave < state.wsize) {
                    state.whave += dist;
                }
            }
        }
        return 0;
    };

    const inflate$2 = (strm, flush) => {
        let state;
        let input, output; // input/output buffers
        let next; /* next input INDEX */
        let put; /* next output INDEX */
        let have, left; /* available input and output */
        let hold; /* bit buffer */
        let bits; /* bits in bit buffer */
        let _in, _out; /* save starting available input and output */
        let copy; /* number of stored or match bytes to copy */
        let from; /* where to copy match bytes from */
        let from_source;
        let here = 0; /* current decoding table entry */
        let here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
        //let last;                   /* parent table entry */
        let last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
        let len; /* length to copy for repeats, bits to drop */
        let ret; /* return code */
        const hbuf = new Uint8Array(
            4
        ); /* buffer for gzip header crc calculation */
        let opts;

        let n; // temporary variable for NEED_BITS

        const order =
            /* permutation of code lengths */
            new Uint8Array([
                16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1,
                15,
            ]);

        if (
            inflateStateCheck(strm) ||
            !strm.output ||
            (!strm.input && strm.avail_in !== 0)
        ) {
            return Z_STREAM_ERROR$1;
        }

        state = strm.state;
        if (state.mode === TYPE) {
            state.mode = TYPEDO;
        } /* skip check */

        //--- LOAD() ---
        put = strm.next_out;
        output = strm.output;
        left = strm.avail_out;
        next = strm.next_in;
        input = strm.input;
        have = strm.avail_in;
        hold = state.hold;
        bits = state.bits;
        //---

        _in = have;
        _out = left;
        ret = Z_OK$1;

        // goto emulation
        inf_leave: for (;;) {
            switch (state.mode) {
                case HEAD:
                    if (state.wrap === 0) {
                        state.mode = TYPEDO;
                        break;
                    }
                    //=== NEEDBITS(16);
                    while (bits < 16) {
                        if (have === 0) {
                            break inf_leave;
                        }
                        have--;
                        hold += input[next++] << bits;
                        bits += 8;
                    }
                    //===//
                    if (state.wrap & 2 && hold === 0x8b1f) {
                        /* gzip header */
                        if (state.wbits === 0) {
                            state.wbits = 15;
                        }
                        state.check = 0 /*crc32(0L, Z_NULL, 0)*/;
                        //=== CRC2(state.check, hold);
                        hbuf[0] = hold & 0xff;
                        hbuf[1] = (hold >>> 8) & 0xff;
                        state.check = crc32_1(state.check, hbuf, 2, 0);
                        //===//

                        //=== INITBITS();
                        hold = 0;
                        bits = 0;
                        //===//
                        state.mode = FLAGS;
                        break;
                    }
                    if (state.head) {
                        state.head.done = false;
                    }
                    if (
                        !(state.wrap & 1) /* check if zlib header allowed */ ||
                        (((hold & 0xff) /*BITS(8)*/ << 8) + (hold >> 8)) % 31
                    ) {
                        strm.msg = "incorrect header check";
                        state.mode = BAD;
                        break;
                    }
                    if ((hold & 0x0f) /*BITS(4)*/ !== Z_DEFLATED) {
                        strm.msg = "unknown compression method";
                        state.mode = BAD;
                        break;
                    }
                    //--- DROPBITS(4) ---//
                    hold >>>= 4;
                    bits -= 4;
                    //---//
                    len = (hold & 0x0f) /*BITS(4)*/ + 8;
                    if (state.wbits === 0) {
                        state.wbits = len;
                    }
                    if (len > 15 || len > state.wbits) {
                        strm.msg = "invalid window size";
                        state.mode = BAD;
                        break;
                    }

                    // !!! pako patch. Force use `options.windowBits` if passed.
                    // Required to always use max window size by default.
                    state.dmax = 1 << state.wbits;
                    //state.dmax = 1 << len;

                    state.flags = 0; /* indicate zlib header */
                    //Tracev((stderr, "inflate:   zlib header ok\n"));
                    strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/;
                    state.mode = hold & 0x200 ? DICTID : TYPE;
                    //=== INITBITS();
                    hold = 0;
                    bits = 0;
                    //===//
                    break;
                case FLAGS:
                    //=== NEEDBITS(16); */
                    while (bits < 16) {
                        if (have === 0) {
                            break inf_leave;
                        }
                        have--;
                        hold += input[next++] << bits;
                        bits += 8;
                    }
                    //===//
                    state.flags = hold;
                    if ((state.flags & 0xff) !== Z_DEFLATED) {
                        strm.msg = "unknown compression method";
                        state.mode = BAD;
                        break;
                    }
                    if (state.flags & 0xe000) {
                        strm.msg = "unknown header flags set";
                        state.mode = BAD;
                        break;
                    }
                    if (state.head) {
                        state.head.text = (hold >> 8) & 1;
                    }
                    if (state.flags & 0x0200 && state.wrap & 4) {
                        //=== CRC2(state.check, hold);
                        hbuf[0] = hold & 0xff;
                        hbuf[1] = (hold >>> 8) & 0xff;
                        state.check = crc32_1(state.check, hbuf, 2, 0);
                        //===//
                    }
                    //=== INITBITS();
                    hold = 0;
                    bits = 0;
                    //===//
                    state.mode = TIME;
                /* falls through */
                case TIME:
                    //=== NEEDBITS(32); */
                    while (bits < 32) {
                        if (have === 0) {
                            break inf_leave;
                        }
                        have--;
                        hold += input[next++] << bits;
                        bits += 8;
                    }
                    //===//
                    if (state.head) {
                        state.head.time = hold;
                    }
                    if (state.flags & 0x0200 && state.wrap & 4) {
                        //=== CRC4(state.check, hold)
                        hbuf[0] = hold & 0xff;
                        hbuf[1] = (hold >>> 8) & 0xff;
                        hbuf[2] = (hold >>> 16) & 0xff;
                        hbuf[3] = (hold >>> 24) & 0xff;
                        state.check = crc32_1(state.check, hbuf, 4, 0);
                        //===
                    }
                    //=== INITBITS();
                    hold = 0;
                    bits = 0;
                    //===//
                    state.mode = OS;
                /* falls through */
                case OS:
                    //=== NEEDBITS(16); */
                    while (bits < 16) {
                        if (have === 0) {
                            break inf_leave;
                        }
                        have--;
                        hold += input[next++] << bits;
                        bits += 8;
                    }
                    //===//
                    if (state.head) {
                        state.head.xflags = hold & 0xff;
                        state.head.os = hold >> 8;
                    }
                    if (state.flags & 0x0200 && state.wrap & 4) {
                        //=== CRC2(state.check, hold);
                        hbuf[0] = hold & 0xff;
                        hbuf[1] = (hold >>> 8) & 0xff;
                        state.check = crc32_1(state.check, hbuf, 2, 0);
                        //===//
                    }
                    //=== INITBITS();
                    hold = 0;
                    bits = 0;
                    //===//
                    state.mode = EXLEN;
                /* falls through */
                case EXLEN:
                    if (state.flags & 0x0400) {
                        //=== NEEDBITS(16); */
                        while (bits < 16) {
                            if (have === 0) {
                                break inf_leave;
                            }
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        state.length = hold;
                        if (state.head) {
                            state.head.extra_len = hold;
                        }
                        if (state.flags & 0x0200 && state.wrap & 4) {
                            //=== CRC2(state.check, hold);
                            hbuf[0] = hold & 0xff;
                            hbuf[1] = (hold >>> 8) & 0xff;
                            state.check = crc32_1(state.check, hbuf, 2, 0);
                            //===//
                        }
                        //=== INITBITS();
                        hold = 0;
                        bits = 0;
                        //===//
                    } else if (state.head) {
                        state.head.extra = null /*Z_NULL*/;
                    }
                    state.mode = EXTRA;
                /* falls through */
                case EXTRA:
                    if (state.flags & 0x0400) {
                        copy = state.length;
                        if (copy > have) {
                            copy = have;
                        }
                        if (copy) {
                            if (state.head) {
                                len = state.head.extra_len - state.length;
                                if (!state.head.extra) {
                                    // Use untyped array for more convenient processing later
                                    state.head.extra = new Uint8Array(
                                        state.head.extra_len
                                    );
                                }
                                state.head.extra.set(
                                    input.subarray(
                                        next,
                                        // extra field is limited to 65536 bytes
                                        // - no need for additional size check
                                        next + copy
                                    ),
                                    /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
                                    len
                                );
                                //zmemcpy(state.head.extra + len, next,
                                //        len + copy > state.head.extra_max ?
                                //        state.head.extra_max - len : copy);
                            }
                            if (state.flags & 0x0200 && state.wrap & 4) {
                                state.check = crc32_1(
                                    state.check,
                                    input,
                                    copy,
                                    next
                                );
                            }
                            have -= copy;
                            next += copy;
                            state.length -= copy;
                        }
                        if (state.length) {
                            break inf_leave;
                        }
                    }
                    state.length = 0;
                    state.mode = NAME;
                /* falls through */
                case NAME:
                    if (state.flags & 0x0800) {
                        if (have === 0) {
                            break inf_leave;
                        }
                        copy = 0;
                        do {
                            // TODO: 2 or 1 bytes?
                            len = input[next + copy++];
                            /* use constant limit because in js we should not preallocate memory */
                            if (
                                state.head &&
                                len &&
                                state.length < 65536 /*state.head.name_max*/
                            ) {
                                state.head.name += String.fromCharCode(len);
                            }
                        } while (len && copy < have);

                        if (state.flags & 0x0200 && state.wrap & 4) {
                            state.check = crc32_1(
                                state.check,
                                input,
                                copy,
                                next
                            );
                        }
                        have -= copy;
                        next += copy;
                        if (len) {
                            break inf_leave;
                        }
                    } else if (state.head) {
                        state.head.name = null;
                    }
                    state.length = 0;
                    state.mode = COMMENT;
                /* falls through */
                case COMMENT:
                    if (state.flags & 0x1000) {
                        if (have === 0) {
                            break inf_leave;
                        }
                        copy = 0;
                        do {
                            len = input[next + copy++];
                            /* use constant limit because in js we should not preallocate memory */
                            if (
                                state.head &&
                                len &&
                                state.length < 65536 /*state.head.comm_max*/
                            ) {
                                state.head.comment += String.fromCharCode(len);
                            }
                        } while (len && copy < have);
                        if (state.flags & 0x0200 && state.wrap & 4) {
                            state.check = crc32_1(
                                state.check,
                                input,
                                copy,
                                next
                            );
                        }
                        have -= copy;
                        next += copy;
                        if (len) {
                            break inf_leave;
                        }
                    } else if (state.head) {
                        state.head.comment = null;
                    }
                    state.mode = HCRC;
                /* falls through */
                case HCRC:
                    if (state.flags & 0x0200) {
                        //=== NEEDBITS(16); */
                        while (bits < 16) {
                            if (have === 0) {
                                break inf_leave;
                            }
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        if (state.wrap & 4 && hold !== (state.check & 0xffff)) {
                            strm.msg = "header crc mismatch";
                            state.mode = BAD;
                            break;
                        }
                        //=== INITBITS();
                        hold = 0;
                        bits = 0;
                        //===//
                    }
                    if (state.head) {
                        state.head.hcrc = (state.flags >> 9) & 1;
                        state.head.done = true;
                    }
                    strm.adler = state.check = 0;
                    state.mode = TYPE;
                    break;
                case DICTID:
                    //=== NEEDBITS(32); */
                    while (bits < 32) {
                        if (have === 0) {
                            break inf_leave;
                        }
                        have--;
                        hold += input[next++] << bits;
                        bits += 8;
                    }
                    //===//
                    strm.adler = state.check = zswap32(hold);
                    //=== INITBITS();
                    hold = 0;
                    bits = 0;
                    //===//
                    state.mode = DICT;
                /* falls through */
                case DICT:
                    if (state.havedict === 0) {
                        //--- RESTORE() ---
                        strm.next_out = put;
                        strm.avail_out = left;
                        strm.next_in = next;
                        strm.avail_in = have;
                        state.hold = hold;
                        state.bits = bits;
                        //---
                        return Z_NEED_DICT$1;
                    }
                    strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/;
                    state.mode = TYPE;
                /* falls through */
                case TYPE:
                    if (flush === Z_BLOCK || flush === Z_TREES) {
                        break inf_leave;
                    }
                /* falls through */
                case TYPEDO:
                    if (state.last) {
                        //--- BYTEBITS() ---//
                        hold >>>= bits & 7;
                        bits -= bits & 7;
                        //---//
                        state.mode = CHECK;
                        break;
                    }
                    //=== NEEDBITS(3); */
                    while (bits < 3) {
                        if (have === 0) {
                            break inf_leave;
                        }
                        have--;
                        hold += input[next++] << bits;
                        bits += 8;
                    }
                    //===//
                    state.last = hold & 0x01 /*BITS(1)*/;
                    //--- DROPBITS(1) ---//
                    hold >>>= 1;
                    bits -= 1;
                    //---//

                    switch (hold & 0x03 /*BITS(2)*/) {
                        case 0 /* stored block */:
                            //Tracev((stderr, "inflate:     stored block%s\n",
                            //        state.last ? " (last)" : ""));
                            state.mode = STORED;
                            break;
                        case 1 /* fixed block */:
                            fixedtables(state);
                            //Tracev((stderr, "inflate:     fixed codes block%s\n",
                            //        state.last ? " (last)" : ""));
                            state.mode = LEN_; /* decode codes */
                            if (flush === Z_TREES) {
                                //--- DROPBITS(2) ---//
                                hold >>>= 2;
                                bits -= 2;
                                //---//
                                break inf_leave;
                            }
                            break;
                        case 2 /* dynamic block */:
                            //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                            //        state.last ? " (last)" : ""));
                            state.mode = TABLE;
                            break;
                        case 3:
                            strm.msg = "invalid block type";
                            state.mode = BAD;
                    }
                    //--- DROPBITS(2) ---//
                    hold >>>= 2;
                    bits -= 2;
                    //---//
                    break;
                case STORED:
                    //--- BYTEBITS() ---// /* go to byte boundary */
                    hold >>>= bits & 7;
                    bits -= bits & 7;
                    //---//
                    //=== NEEDBITS(32); */
                    while (bits < 32) {
                        if (have === 0) {
                            break inf_leave;
                        }
                        have--;
                        hold += input[next++] << bits;
                        bits += 8;
                    }
                    //===//
                    if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
                        strm.msg = "invalid stored block lengths";
                        state.mode = BAD;
                        break;
                    }
                    state.length = hold & 0xffff;
                    //Tracev((stderr, "inflate:       stored length %u\n",
                    //        state.length));
                    //=== INITBITS();
                    hold = 0;
                    bits = 0;
                    //===//
                    state.mode = COPY_;
                    if (flush === Z_TREES) {
                        break inf_leave;
                    }
                /* falls through */
                case COPY_:
                    state.mode = COPY;
                /* falls through */
                case COPY:
                    copy = state.length;
                    if (copy) {
                        if (copy > have) {
                            copy = have;
                        }
                        if (copy > left) {
                            copy = left;
                        }
                        if (copy === 0) {
                            break inf_leave;
                        }
                        //--- zmemcpy(put, next, copy); ---
                        output.set(input.subarray(next, next + copy), put);
                        //---//
                        have -= copy;
                        next += copy;
                        left -= copy;
                        put += copy;
                        state.length -= copy;
                        break;
                    }
                    //Tracev((stderr, "inflate:       stored end\n"));
                    state.mode = TYPE;
                    break;
                case TABLE:
                    //=== NEEDBITS(14); */
                    while (bits < 14) {
                        if (have === 0) {
                            break inf_leave;
                        }
                        have--;
                        hold += input[next++] << bits;
                        bits += 8;
                    }
                    //===//
                    state.nlen = (hold & 0x1f) /*BITS(5)*/ + 257;
                    //--- DROPBITS(5) ---//
                    hold >>>= 5;
                    bits -= 5;
                    //---//
                    state.ndist = (hold & 0x1f) /*BITS(5)*/ + 1;
                    //--- DROPBITS(5) ---//
                    hold >>>= 5;
                    bits -= 5;
                    //---//
                    state.ncode = (hold & 0x0f) /*BITS(4)*/ + 4;
                    //--- DROPBITS(4) ---//
                    hold >>>= 4;
                    bits -= 4;
                    //---//
                    //#ifndef PKZIP_BUG_WORKAROUND
                    if (state.nlen > 286 || state.ndist > 30) {
                        strm.msg = "too many length or distance symbols";
                        state.mode = BAD;
                        break;
                    }
                    //#endif
                    //Tracev((stderr, "inflate:       table sizes ok\n"));
                    state.have = 0;
                    state.mode = LENLENS;
                /* falls through */
                case LENLENS:
                    while (state.have < state.ncode) {
                        //=== NEEDBITS(3);
                        while (bits < 3) {
                            if (have === 0) {
                                break inf_leave;
                            }
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                        //---//
                    }
                    while (state.have < 19) {
                        state.lens[order[state.have++]] = 0;
                    }
                    // We have separate tables & no pointers. 2 commented lines below not needed.
                    //state.next = state.codes;
                    //state.lencode = state.next;
                    // Switch to use dynamic table
                    state.lencode = state.lendyn;
                    state.lenbits = 7;

                    opts = { bits: state.lenbits };
                    ret = inftrees(
                        CODES,
                        state.lens,
                        0,
                        19,
                        state.lencode,
                        0,
                        state.work,
                        opts
                    );
                    state.lenbits = opts.bits;

                    if (ret) {
                        strm.msg = "invalid code lengths set";
                        state.mode = BAD;
                        break;
                    }
                    //Tracev((stderr, "inflate:       code lengths ok\n"));
                    state.have = 0;
                    state.mode = CODELENS;
                /* falls through */
                case CODELENS:
                    while (state.have < state.nlen + state.ndist) {
                        for (;;) {
                            here =
                                state.lencode[
                                    hold & ((1 << state.lenbits) - 1)
                                ]; /*BITS(state.lenbits)*/
                            here_bits = here >>> 24;
                            here_op = (here >>> 16) & 0xff;
                            here_val = here & 0xffff;

                            if (here_bits <= bits) {
                                break;
                            }
                            //--- PULLBYTE() ---//
                            if (have === 0) {
                                break inf_leave;
                            }
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                            //---//
                        }
                        if (here_val < 16) {
                            //--- DROPBITS(here.bits) ---//
                            hold >>>= here_bits;
                            bits -= here_bits;
                            //---//
                            state.lens[state.have++] = here_val;
                        } else {
                            if (here_val === 16) {
                                //=== NEEDBITS(here.bits + 2);
                                n = here_bits + 2;
                                while (bits < n) {
                                    if (have === 0) {
                                        break inf_leave;
                                    }
                                    have--;
                                    hold += input[next++] << bits;
                                    bits += 8;
                                }
                                //===//
                                //--- DROPBITS(here.bits) ---//
                                hold >>>= here_bits;
                                bits -= here_bits;
                                //---//
                                if (state.have === 0) {
                                    strm.msg = "invalid bit length repeat";
                                    state.mode = BAD;
                                    break;
                                }
                                len = state.lens[state.have - 1];
                                copy = 3 + (hold & 0x03); //BITS(2);
                                //--- DROPBITS(2) ---//
                                hold >>>= 2;
                                bits -= 2;
                                //---//
                            } else if (here_val === 17) {
                                //=== NEEDBITS(here.bits + 3);
                                n = here_bits + 3;
                                while (bits < n) {
                                    if (have === 0) {
                                        break inf_leave;
                                    }
                                    have--;
                                    hold += input[next++] << bits;
                                    bits += 8;
                                }
                                //===//
                                //--- DROPBITS(here.bits) ---//
                                hold >>>= here_bits;
                                bits -= here_bits;
                                //---//
                                len = 0;
                                copy = 3 + (hold & 0x07); //BITS(3);
                                //--- DROPBITS(3) ---//
                                hold >>>= 3;
                                bits -= 3;
                                //---//
                            } else {
                                //=== NEEDBITS(here.bits + 7);
                                n = here_bits + 7;
                                while (bits < n) {
                                    if (have === 0) {
                                        break inf_leave;
                                    }
                                    have--;
                                    hold += input[next++] << bits;
                                    bits += 8;
                                }
                                //===//
                                //--- DROPBITS(here.bits) ---//
                                hold >>>= here_bits;
                                bits -= here_bits;
                                //---//
                                len = 0;
                                copy = 11 + (hold & 0x7f); //BITS(7);
                                //--- DROPBITS(7) ---//
                                hold >>>= 7;
                                bits -= 7;
                                //---//
                            }
                            if (state.have + copy > state.nlen + state.ndist) {
                                strm.msg = "invalid bit length repeat";
                                state.mode = BAD;
                                break;
                            }
                            while (copy--) {
                                state.lens[state.have++] = len;
                            }
                        }
                    }

                    /* handle error breaks in while */
                    if (state.mode === BAD) {
                        break;
                    }

                    /* check for end-of-block code (better have one) */
                    if (state.lens[256] === 0) {
                        strm.msg = "invalid code -- missing end-of-block";
                        state.mode = BAD;
                        break;
                    }

                    /* build code tables -- note: do not change the lenbits or distbits
             values here (9 and 6) without reading the comments in inftrees.h
             concerning the ENOUGH constants, which depend on those values */
                    state.lenbits = 9;

                    opts = { bits: state.lenbits };
                    ret = inftrees(
                        LENS,
                        state.lens,
                        0,
                        state.nlen,
                        state.lencode,
                        0,
                        state.work,
                        opts
                    );
                    // We have separate tables & no pointers. 2 commented lines below not needed.
                    // state.next_index = opts.table_index;
                    state.lenbits = opts.bits;
                    // state.lencode = state.next;

                    if (ret) {
                        strm.msg = "invalid literal/lengths set";
                        state.mode = BAD;
                        break;
                    }

                    state.distbits = 6;
                    //state.distcode.copy(state.codes);
                    // Switch to use dynamic table
                    state.distcode = state.distdyn;
                    opts = { bits: state.distbits };
                    ret = inftrees(
                        DISTS,
                        state.lens,
                        state.nlen,
                        state.ndist,
                        state.distcode,
                        0,
                        state.work,
                        opts
                    );
                    // We have separate tables & no pointers. 2 commented lines below not needed.
                    // state.next_index = opts.table_index;
                    state.distbits = opts.bits;
                    // state.distcode = state.next;

                    if (ret) {
                        strm.msg = "invalid distances set";
                        state.mode = BAD;
                        break;
                    }
                    //Tracev((stderr, 'inflate:       codes ok\n'));
                    state.mode = LEN_;
                    if (flush === Z_TREES) {
                        break inf_leave;
                    }
                /* falls through */
                case LEN_:
                    state.mode = LEN;
                /* falls through */
                case LEN:
                    if (have >= 6 && left >= 258) {
                        //--- RESTORE() ---
                        strm.next_out = put;
                        strm.avail_out = left;
                        strm.next_in = next;
                        strm.avail_in = have;
                        state.hold = hold;
                        state.bits = bits;
                        //---
                        inffast(strm, _out);
                        //--- LOAD() ---
                        put = strm.next_out;
                        output = strm.output;
                        left = strm.avail_out;
                        next = strm.next_in;
                        input = strm.input;
                        have = strm.avail_in;
                        hold = state.hold;
                        bits = state.bits;
                        //---

                        if (state.mode === TYPE) {
                            state.back = -1;
                        }
                        break;
                    }
                    state.back = 0;
                    for (;;) {
                        here =
                            state.lencode[
                                hold & ((1 << state.lenbits) - 1)
                            ]; /*BITS(state.lenbits)*/
                        here_bits = here >>> 24;
                        here_op = (here >>> 16) & 0xff;
                        here_val = here & 0xffff;

                        if (here_bits <= bits) {
                            break;
                        }
                        //--- PULLBYTE() ---//
                        if (have === 0) {
                            break inf_leave;
                        }
                        have--;
                        hold += input[next++] << bits;
                        bits += 8;
                        //---//
                    }
                    if (here_op && (here_op & 0xf0) === 0) {
                        last_bits = here_bits;
                        last_op = here_op;
                        last_val = here_val;
                        for (;;) {
                            here =
                                state.lencode[
                                    last_val +
                                        ((hold &
                                            ((1 << (last_bits + last_op)) -
                                                1)) /*BITS(last.bits + last.op)*/ >>
                                            last_bits)
                                ];
                            here_bits = here >>> 24;
                            here_op = (here >>> 16) & 0xff;
                            here_val = here & 0xffff;

                            if (last_bits + here_bits <= bits) {
                                break;
                            }
                            //--- PULLBYTE() ---//
                            if (have === 0) {
                                break inf_leave;
                            }
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                            //---//
                        }
                        //--- DROPBITS(last.bits) ---//
                        hold >>>= last_bits;
                        bits -= last_bits;
                        //---//
                        state.back += last_bits;
                    }
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.back += here_bits;
                    state.length = here_val;
                    if (here_op === 0) {
                        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                        //        "inflate:         literal '%c'\n" :
                        //        "inflate:         literal 0x%02x\n", here.val));
                        state.mode = LIT;
                        break;
                    }
                    if (here_op & 32) {
                        //Tracevv((stderr, "inflate:         end of block\n"));
                        state.back = -1;
                        state.mode = TYPE;
                        break;
                    }
                    if (here_op & 64) {
                        strm.msg = "invalid literal/length code";
                        state.mode = BAD;
                        break;
                    }
                    state.extra = here_op & 15;
                    state.mode = LENEXT;
                /* falls through */
                case LENEXT:
                    if (state.extra) {
                        //=== NEEDBITS(state.extra);
                        n = state.extra;
                        while (bits < n) {
                            if (have === 0) {
                                break inf_leave;
                            }
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        state.length +=
                            hold &
                            ((1 << state.extra) - 1) /*BITS(state.extra)*/;
                        //--- DROPBITS(state.extra) ---//
                        hold >>>= state.extra;
                        bits -= state.extra;
                        //---//
                        state.back += state.extra;
                    }
                    //Tracevv((stderr, "inflate:         length %u\n", state.length));
                    state.was = state.length;
                    state.mode = DIST;
                /* falls through */
                case DIST:
                    for (;;) {
                        here =
                            state.distcode[
                                hold & ((1 << state.distbits) - 1)
                            ]; /*BITS(state.distbits)*/
                        here_bits = here >>> 24;
                        here_op = (here >>> 16) & 0xff;
                        here_val = here & 0xffff;

                        if (here_bits <= bits) {
                            break;
                        }
                        //--- PULLBYTE() ---//
                        if (have === 0) {
                            break inf_leave;
                        }
                        have--;
                        hold += input[next++] << bits;
                        bits += 8;
                        //---//
                    }
                    if ((here_op & 0xf0) === 0) {
                        last_bits = here_bits;
                        last_op = here_op;
                        last_val = here_val;
                        for (;;) {
                            here =
                                state.distcode[
                                    last_val +
                                        ((hold &
                                            ((1 << (last_bits + last_op)) -
                                                1)) /*BITS(last.bits + last.op)*/ >>
                                            last_bits)
                                ];
                            here_bits = here >>> 24;
                            here_op = (here >>> 16) & 0xff;
                            here_val = here & 0xffff;

                            if (last_bits + here_bits <= bits) {
                                break;
                            }
                            //--- PULLBYTE() ---//
                            if (have === 0) {
                                break inf_leave;
                            }
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                            //---//
                        }
                        //--- DROPBITS(last.bits) ---//
                        hold >>>= last_bits;
                        bits -= last_bits;
                        //---//
                        state.back += last_bits;
                    }
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.back += here_bits;
                    if (here_op & 64) {
                        strm.msg = "invalid distance code";
                        state.mode = BAD;
                        break;
                    }
                    state.offset = here_val;
                    state.extra = here_op & 15;
                    state.mode = DISTEXT;
                /* falls through */
                case DISTEXT:
                    if (state.extra) {
                        //=== NEEDBITS(state.extra);
                        n = state.extra;
                        while (bits < n) {
                            if (have === 0) {
                                break inf_leave;
                            }
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        state.offset +=
                            hold &
                            ((1 << state.extra) - 1) /*BITS(state.extra)*/;
                        //--- DROPBITS(state.extra) ---//
                        hold >>>= state.extra;
                        bits -= state.extra;
                        //---//
                        state.back += state.extra;
                    }
                    //#ifdef INFLATE_STRICT
                    if (state.offset > state.dmax) {
                        strm.msg = "invalid distance too far back";
                        state.mode = BAD;
                        break;
                    }
                    //#endif
                    //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
                    state.mode = MATCH;
                /* falls through */
                case MATCH:
                    if (left === 0) {
                        break inf_leave;
                    }
                    copy = _out - left;
                    if (state.offset > copy) {
                        /* copy from window */
                        copy = state.offset - copy;
                        if (copy > state.whave) {
                            if (state.sane) {
                                strm.msg = "invalid distance too far back";
                                state.mode = BAD;
                                break;
                            }
                            // (!) This block is disabled in zlib defaults,
                            // don't enable it for binary compatibility
                            //#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
                            //          Trace((stderr, "inflate.c too far\n"));
                            //          copy -= state.whave;
                            //          if (copy > state.length) { copy = state.length; }
                            //          if (copy > left) { copy = left; }
                            //          left -= copy;
                            //          state.length -= copy;
                            //          do {
                            //            output[put++] = 0;
                            //          } while (--copy);
                            //          if (state.length === 0) { state.mode = LEN; }
                            //          break;
                            //#endif
                        }
                        if (copy > state.wnext) {
                            copy -= state.wnext;
                            from = state.wsize - copy;
                        } else {
                            from = state.wnext - copy;
                        }
                        if (copy > state.length) {
                            copy = state.length;
                        }
                        from_source = state.window;
                    } else {
                        /* copy from output */
                        from_source = output;
                        from = put - state.offset;
                        copy = state.length;
                    }
                    if (copy > left) {
                        copy = left;
                    }
                    left -= copy;
                    state.length -= copy;
                    do {
                        output[put++] = from_source[from++];
                    } while (--copy);
                    if (state.length === 0) {
                        state.mode = LEN;
                    }
                    break;
                case LIT:
                    if (left === 0) {
                        break inf_leave;
                    }
                    output[put++] = state.length;
                    left--;
                    state.mode = LEN;
                    break;
                case CHECK:
                    if (state.wrap) {
                        //=== NEEDBITS(32);
                        while (bits < 32) {
                            if (have === 0) {
                                break inf_leave;
                            }
                            have--;
                            // Use '|' instead of '+' to make sure that result is signed
                            hold |= input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        _out -= left;
                        strm.total_out += _out;
                        state.total += _out;
                        if (state.wrap & 4 && _out) {
                            strm.adler = state.check =
                                /*UPDATE_CHECK(state.check, put - _out, _out);*/
                                state.flags
                                    ? crc32_1(
                                          state.check,
                                          output,
                                          _out,
                                          put - _out
                                      )
                                    : adler32_1(
                                          state.check,
                                          output,
                                          _out,
                                          put - _out
                                      );
                        }
                        _out = left;
                        // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                        if (
                            state.wrap & 4 &&
                            (state.flags ? hold : zswap32(hold)) !== state.check
                        ) {
                            strm.msg = "incorrect data check";
                            state.mode = BAD;
                            break;
                        }
                        //=== INITBITS();
                        hold = 0;
                        bits = 0;
                        //===//
                        //Tracev((stderr, "inflate:   check matches trailer\n"));
                    }
                    state.mode = LENGTH;
                /* falls through */
                case LENGTH:
                    if (state.wrap && state.flags) {
                        //=== NEEDBITS(32);
                        while (bits < 32) {
                            if (have === 0) {
                                break inf_leave;
                            }
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        if (
                            state.wrap & 4 &&
                            hold !== (state.total & 0xffffffff)
                        ) {
                            strm.msg = "incorrect length check";
                            state.mode = BAD;
                            break;
                        }
                        //=== INITBITS();
                        hold = 0;
                        bits = 0;
                        //===//
                        //Tracev((stderr, "inflate:   length matches trailer\n"));
                    }
                    state.mode = DONE;
                /* falls through */
                case DONE:
                    ret = Z_STREAM_END$1;
                    break inf_leave;
                case BAD:
                    ret = Z_DATA_ERROR$1;
                    break inf_leave;
                case MEM:
                    return Z_MEM_ERROR$1;
                case SYNC:
                /* falls through */
                default:
                    return Z_STREAM_ERROR$1;
            }
        }

        // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"

        /*
       Return from inflate(), updating the total counts and the check value.
       If there was no progress during the inflate() call, return a buffer
       error.  Call updatewindow() to create and/or update the window state.
       Note: a memory error from inflate() is non-recoverable.
     */

        //--- RESTORE() ---
        strm.next_out = put;
        strm.avail_out = left;
        strm.next_in = next;
        strm.avail_in = have;
        state.hold = hold;
        state.bits = bits;
        //---

        if (
            state.wsize ||
            (_out !== strm.avail_out &&
                state.mode < BAD &&
                (state.mode < CHECK || flush !== Z_FINISH$1))
        ) {
            if (
                updatewindow(
                    strm,
                    strm.output,
                    strm.next_out,
                    _out - strm.avail_out
                )
            );
        }
        _in -= strm.avail_in;
        _out -= strm.avail_out;
        strm.total_in += _in;
        strm.total_out += _out;
        state.total += _out;
        if (state.wrap & 4 && _out) {
            strm.adler = state.check =
                /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/
                state.flags
                    ? crc32_1(state.check, output, _out, strm.next_out - _out)
                    : adler32_1(
                          state.check,
                          output,
                          _out,
                          strm.next_out - _out
                      );
        }
        strm.data_type =
            state.bits +
            (state.last ? 64 : 0) +
            (state.mode === TYPE ? 128 : 0) +
            (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
        if (
            ((_in === 0 && _out === 0) || flush === Z_FINISH$1) &&
            ret === Z_OK$1
        ) {
            ret = Z_BUF_ERROR;
        }
        return ret;
    };

    const inflateEnd = (strm) => {
        if (inflateStateCheck(strm)) {
            return Z_STREAM_ERROR$1;
        }

        let state = strm.state;
        if (state.window) {
            state.window = null;
        }
        strm.state = null;
        return Z_OK$1;
    };

    const inflateGetHeader = (strm, head) => {
        /* check state */
        if (inflateStateCheck(strm)) {
            return Z_STREAM_ERROR$1;
        }
        const state = strm.state;
        if ((state.wrap & 2) === 0) {
            return Z_STREAM_ERROR$1;
        }

        /* save header structure */
        state.head = head;
        head.done = false;
        return Z_OK$1;
    };

    const inflateSetDictionary = (strm, dictionary) => {
        const dictLength = dictionary.length;

        let state;
        let dictid;
        let ret;

        /* check state */
        if (inflateStateCheck(strm)) {
            return Z_STREAM_ERROR$1;
        }
        state = strm.state;

        if (state.wrap !== 0 && state.mode !== DICT) {
            return Z_STREAM_ERROR$1;
        }

        /* check for correct dictionary identifier */
        if (state.mode === DICT) {
            dictid = 1; /* adler32(0, null, 0)*/
            /* dictid = adler32(dictid, dictionary, dictLength); */
            dictid = adler32_1(dictid, dictionary, dictLength, 0);
            if (dictid !== state.check) {
                return Z_DATA_ERROR$1;
            }
        }
        /* copy dictionary to window using updatewindow(), which will amend the
     existing dictionary if appropriate */
        ret = updatewindow(strm, dictionary, dictLength, dictLength);
        if (ret) {
            state.mode = MEM;
            return Z_MEM_ERROR$1;
        }
        state.havedict = 1;
        // Tracev((stderr, "inflate:   dictionary set\n"));
        return Z_OK$1;
    };

    var inflateReset_1 = inflateReset;
    var inflateReset2_1 = inflateReset2;
    var inflateResetKeep_1 = inflateResetKeep;
    var inflateInit_1 = inflateInit;
    var inflateInit2_1 = inflateInit2;
    var inflate_2$1 = inflate$2;
    var inflateEnd_1 = inflateEnd;
    var inflateGetHeader_1 = inflateGetHeader;
    var inflateSetDictionary_1 = inflateSetDictionary;
    var inflateInfo = "pako inflate (from Nodeca project)";

    /* Not implemented
  module.exports.inflateCodesUsed = inflateCodesUsed;
  module.exports.inflateCopy = inflateCopy;
  module.exports.inflateGetDictionary = inflateGetDictionary;
  module.exports.inflateMark = inflateMark;
  module.exports.inflatePrime = inflatePrime;
  module.exports.inflateSync = inflateSync;
  module.exports.inflateSyncPoint = inflateSyncPoint;
  module.exports.inflateUndermine = inflateUndermine;
  module.exports.inflateValidate = inflateValidate;
  */

    var inflate_1$2 = {
        inflateReset: inflateReset_1,
        inflateReset2: inflateReset2_1,
        inflateResetKeep: inflateResetKeep_1,
        inflateInit: inflateInit_1,
        inflateInit2: inflateInit2_1,
        inflate: inflate_2$1,
        inflateEnd: inflateEnd_1,
        inflateGetHeader: inflateGetHeader_1,
        inflateSetDictionary: inflateSetDictionary_1,
        inflateInfo: inflateInfo,
    };

    // (C) 1995-2013 Jean-loup Gailly and Mark Adler
    // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
    //
    // This software is provided 'as-is', without any express or implied
    // warranty. In no event will the authors be held liable for any damages
    // arising from the use of this software.
    //
    // Permission is granted to anyone to use this software for any purpose,
    // including commercial applications, and to alter it and redistribute it
    // freely, subject to the following restrictions:
    //
    // 1. The origin of this software must not be misrepresented; you must not
    //   claim that you wrote the original software. If you use this software
    //   in a product, an acknowledgment in the product documentation would be
    //   appreciated but is not required.
    // 2. Altered source versions must be plainly marked as such, and must not be
    //   misrepresented as being the original software.
    // 3. This notice may not be removed or altered from any source distribution.

    class GZheader {
        constructor() {
            /* true if compressed data believed to be text */
            this.text = 0;
            /* modification time */
            this.time = 0;
            /* extra flags (not used when writing a gzip file) */
            this.xflags = 0;
            /* operating system */
            this.os = 0;
            /* pointer to extra field or Z_NULL if none */
            this.extra = null;
            /* extra field length (valid if extra != Z_NULL) */
            this.extra_len = 0; // Actually, we don't need it in JS,

            // but leave for few code modifications
            //
            // Setup limits is not necessary because in js we should not preallocate memory
            // for inflate use constant limit in 65536 bytes
            //
            /* space at extra (only when reading header) */
            // this.extra_max  = 0;
            /* pointer to zero-terminated file name or Z_NULL */
            this.name = "";
            /* space at name (only when reading header) */
            // this.name_max   = 0;
            /* pointer to zero-terminated comment or Z_NULL */
            this.comment = "";
            /* space at comment (only when reading header) */
            // this.comm_max   = 0;
            /* true if there was or will be a header crc */
            this.hcrc = 0;
            /* true when done reading gzip header (not used when writing a gzip file) */
            this.done = false;
        }
    }

    var gzheader = GZheader;

    const toString = Object.prototype.toString;

    /* Public constants ==========================================================*/
    /* ===========================================================================*/

    const {
        Z_NO_FLUSH,
        Z_FINISH,
        Z_OK,
        Z_STREAM_END,
        Z_NEED_DICT,
        Z_STREAM_ERROR,
        Z_DATA_ERROR,
        Z_MEM_ERROR,
    } = constants$2;

    /* ===========================================================================*/

    /**
     * class Inflate
     *
     * Generic JS-style wrapper for zlib calls. If you don't need
     * streaming behaviour - use more simple functions: [[inflate]]
     * and [[inflateRaw]].
     **/

    /* internal
     * inflate.chunks -> Array
     *
     * Chunks of output data, if [[Inflate#onData]] not overridden.
     **/

    /**
     * Inflate.result -> Uint8Array|String
     *
     * Uncompressed result, generated by default [[Inflate#onData]]
     * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
     * (call [[Inflate#push]] with `Z_FINISH` / `true` param).
     **/

    /**
     * Inflate.err -> Number
     *
     * Error code after inflate finished. 0 (Z_OK) on success.
     * Should be checked if broken data possible.
     **/

    /**
     * Inflate.msg -> String
     *
     * Error message, if [[Inflate.err]] != 0
     **/

    /**
     * new Inflate(options)
     * - options (Object): zlib inflate options.
     *
     * Creates new inflator instance with specified params. Throws exception
     * on bad params. Supported options:
     *
     * - `windowBits`
     * - `dictionary`
     *
     * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
     * for more information on these.
     *
     * Additional options, for internal needs:
     *
     * - `chunkSize` - size of generated data chunks (16K by default)
     * - `raw` (Boolean) - do raw inflate
     * - `to` (String) - if equal to 'string', then result will be converted
     *   from utf8 to utf16 (javascript) string. When string output requested,
     *   chunk length can differ from `chunkSize`, depending on content.
     *
     * By default, when no options set, autodetect deflate/gzip data format via
     * wrapper header.
     *
     * ##### Example:
     *
     * ```javascript
     * const pako = require('pako')
     * const chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
     * const chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
     *
     * const inflate = new pako.Inflate({ level: 3});
     *
     * inflate.push(chunk1, false);
     * inflate.push(chunk2, true);  // true -> last chunk
     *
     * if (inflate.err) { throw new Error(inflate.err); }
     *
     * console.log(inflate.result);
     * ```
     **/
    class Inflate$1 {
        constructor(options) {
            this.options = common.assign(
                {
                    chunkSize: 1024 * 64,
                    windowBits: 15,
                    to: "",
                },
                options || {}
            );

            const opt = this.options;

            // Force window size for `raw` data, if not set directly,
            // because we have no header for autodetect.
            if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
                opt.windowBits = -opt.windowBits;
                if (opt.windowBits === 0) {
                    opt.windowBits = -15;
                }
            }

            // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
            if (
                opt.windowBits >= 0 &&
                opt.windowBits < 16 &&
                !(options && options.windowBits)
            ) {
                opt.windowBits += 32;
            }

            // Gzip header has no info about windows size, we can do autodetect only
            // for deflate. So, if window size not set, force it to max when gzip possible
            if (opt.windowBits > 15 && opt.windowBits < 48) {
                // bit 3 (16) -> gzipped data
                // bit 4 (32) -> autodetect gzip/deflate
                if ((opt.windowBits & 15) === 0) {
                    opt.windowBits |= 15;
                }
            }

            this.err = 0; // error code, if happens (0 = Z_OK)
            this.msg = ""; // error message
            this.ended = false; // used to avoid multiple onEnd() calls
            this.chunks = []; // chunks of compressed data

            this.strm = new zstream();
            this.strm.avail_out = 0;

            let status = inflate_1$2.inflateInit2(this.strm, opt.windowBits);

            if (status !== Z_OK) {
                throw new Error(messages[status]);
            }

            this.header = new gzheader();

            inflate_1$2.inflateGetHeader(this.strm, this.header);

            // Setup dictionary
            if (opt.dictionary) {
                // Convert data if needed
                if (typeof opt.dictionary === "string") {
                    opt.dictionary = strings.string2buf(opt.dictionary);
                } else if (
                    toString.call(opt.dictionary) === "[object ArrayBuffer]"
                ) {
                    opt.dictionary = new Uint8Array(opt.dictionary);
                }
                if (opt.raw) {
                    //In raw mode we need to set the dictionary early
                    status = inflate_1$2.inflateSetDictionary(
                        this.strm,
                        opt.dictionary
                    );
                    if (status !== Z_OK) {
                        throw new Error(messages[status]);
                    }
                }
            }
        }
        /**
         * Inflate#push(data[, flush_mode]) -> Boolean
         * - data (Uint8Array|ArrayBuffer): input data
         * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE
         *   flush modes. See constants. Skipped or `false` means Z_NO_FLUSH,
         *   `true` means Z_FINISH.
         *
         * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
         * new output chunks. Returns `true` on success. If end of stream detected,
         * [[Inflate#onEnd]] will be called.
         *
         * `flush_mode` is not needed for normal operation, because end of stream
         * detected automatically. You may try to use it for advanced things, but
         * this functionality was not tested.
         *
         * On fail call [[Inflate#onEnd]] with error code and return false.
         *
         * ##### Example
         *
         * ```javascript
         * push(chunk, false); // push one of data chunks
         * ...
         * push(chunk, true);  // push last chunk
         * ```
         **/
        push(data, flush_mode) {
            const strm = this.strm;
            const chunkSize = this.options.chunkSize;
            const dictionary = this.options.dictionary;
            let status, _flush_mode, last_avail_out;

            if (this.ended) return false;

            if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
            else _flush_mode = flush_mode === true ? Z_FINISH : Z_NO_FLUSH;

            // Convert data if needed
            if (toString.call(data) === "[object ArrayBuffer]") {
                strm.input = new Uint8Array(data);
            } else {
                strm.input = data;
            }

            strm.next_in = 0;
            strm.avail_in = strm.input.length;

            for (;;) {
                if (strm.avail_out === 0) {
                    strm.output = new Uint8Array(chunkSize);
                    strm.next_out = 0;
                    strm.avail_out = chunkSize;
                }

                status = inflate_1$2.inflate(strm, _flush_mode);

                if (status === Z_NEED_DICT && dictionary) {
                    status = inflate_1$2.inflateSetDictionary(strm, dictionary);

                    if (status === Z_OK) {
                        status = inflate_1$2.inflate(strm, _flush_mode);
                    } else if (status === Z_DATA_ERROR) {
                        // Replace code with more verbose
                        status = Z_NEED_DICT;
                    }
                }

                // Skip snyc markers if more data follows and not raw mode
                while (
                    strm.avail_in > 0 &&
                    status === Z_STREAM_END &&
                    strm.state.wrap > 0 &&
                    data[strm.next_in] !== 0
                ) {
                    inflate_1$2.inflateReset(strm);
                    status = inflate_1$2.inflate(strm, _flush_mode);
                }

                switch (status) {
                    case Z_STREAM_ERROR:
                    case Z_DATA_ERROR:
                    case Z_NEED_DICT:
                    case Z_MEM_ERROR:
                        this.onEnd(status);
                        this.ended = true;
                        return false;
                }

                // Remember real `avail_out` value, because we may patch out buffer content
                // to align utf8 strings boundaries.
                last_avail_out = strm.avail_out;

                if (strm.next_out) {
                    if (strm.avail_out === 0 || status === Z_STREAM_END) {
                        if (this.options.to === "string") {
                            let next_out_utf8 = strings.utf8border(
                                strm.output,
                                strm.next_out
                            );

                            let tail = strm.next_out - next_out_utf8;
                            let utf8str = strings.buf2string(
                                strm.output,
                                next_out_utf8
                            );

                            // move tail & realign counters
                            strm.next_out = tail;
                            strm.avail_out = chunkSize - tail;
                            if (tail)
                                strm.output.set(
                                    strm.output.subarray(
                                        next_out_utf8,
                                        next_out_utf8 + tail
                                    ),
                                    0
                                );

                            this.onData(utf8str);
                        } else {
                            this.onData(
                                strm.output.length === strm.next_out
                                    ? strm.output
                                    : strm.output.subarray(0, strm.next_out)
                            );
                        }
                    }
                }

                // Must repeat iteration if out buffer is full
                if (status === Z_OK && last_avail_out === 0) continue;

                // Finalize if end of stream reached.
                if (status === Z_STREAM_END) {
                    status = inflate_1$2.inflateEnd(this.strm);
                    this.onEnd(status);
                    this.ended = true;
                    return true;
                }

                if (strm.avail_in === 0) break;
            }

            return true;
        }
        /**
         * Inflate#onData(chunk) -> Void
         * - chunk (Uint8Array|String): output data. When string output requested,
         *   each chunk will be string.
         *
         * By default, stores data blocks in `chunks[]` property and glue
         * those in `onEnd`. Override this handler, if you need another behaviour.
         **/
        onData(chunk) {
            this.chunks.push(chunk);
        }
        /**
         * Inflate#onEnd(status) -> Void
         * - status (Number): inflate status. 0 (Z_OK) on success,
         *   other if not.
         *
         * Called either after you tell inflate that the input stream is
         * complete (Z_FINISH). By default - join collected chunks,
         * free memory and fill `results` / `err` properties.
         **/
        onEnd(status) {
            // On success - join
            if (status === Z_OK) {
                if (this.options.to === "string") {
                    this.result = this.chunks.join("");
                } else {
                    this.result = common.flattenChunks(this.chunks);
                }
            }
            this.chunks = [];
            this.err = status;
            this.msg = this.strm.msg;
        }
    }

    /**
     * inflate(data[, options]) -> Uint8Array|String
     * - data (Uint8Array|ArrayBuffer): input data to decompress.
     * - options (Object): zlib inflate options.
     *
     * Decompress `data` with inflate/ungzip and `options`. Autodetect
     * format via wrapper header by default. That's why we don't provide
     * separate `ungzip` method.
     *
     * Supported options are:
     *
     * - windowBits
     *
     * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
     * for more information.
     *
     * Sugar (options):
     *
     * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
     *   negative windowBits implicitly.
     * - `to` (String) - if equal to 'string', then result will be converted
     *   from utf8 to utf16 (javascript) string. When string output requested,
     *   chunk length can differ from `chunkSize`, depending on content.
     *
     *
     * ##### Example:
     *
     * ```javascript
     * const pako = require('pako');
     * const input = pako.deflate(new Uint8Array([1,2,3,4,5,6,7,8,9]));
     * let output;
     *
     * try {
     *   output = pako.inflate(input);
     * } catch (err) {
     *   console.log(err);
     * }
     * ```
     **/
    function inflate$1(input, options) {
        const inflator = new Inflate$1(options);

        inflator.push(input);

        // That will never happens, if you don't cheat with options :)
        if (inflator.err) throw inflator.msg || messages[inflator.err];

        return inflator.result;
    }

    /**
     * inflateRaw(data[, options]) -> Uint8Array|String
     * - data (Uint8Array|ArrayBuffer): input data to decompress.
     * - options (Object): zlib inflate options.
     *
     * The same as [[inflate]], but creates raw data, without wrapper
     * (header and adler32 crc).
     **/
    function inflateRaw$1(input, options) {
        options = options || {};
        options.raw = true;
        return inflate$1(input, options);
    }

    /**
     * ungzip(data[, options]) -> Uint8Array|String
     * - data (Uint8Array|ArrayBuffer): input data to decompress.
     * - options (Object): zlib inflate options.
     *
     * Just shortcut to [[inflate]], because it autodetects format
     * by header.content. Done for convenience.
     **/

    var Inflate_1$1 = Inflate$1;
    var inflate_2 = inflate$1;
    var inflateRaw_1$1 = inflateRaw$1;
    var ungzip$1 = inflate$1;
    var constants = constants$2;

    var inflate_1$1 = {
        Inflate: Inflate_1$1,
        inflate: inflate_2,
        inflateRaw: inflateRaw_1$1,
        ungzip: ungzip$1,
        constants: constants,
    };

    const { Deflate, deflate, deflateRaw, gzip } = deflate_1$1;

    const { Inflate, inflate, inflateRaw, ungzip } = inflate_1$1;

    var Deflate_1 = Deflate;
    var deflate_1 = deflate;
    var deflateRaw_1 = deflateRaw;
    var gzip_1 = gzip;
    var Inflate_1 = Inflate;
    var inflate_1 = inflate;
    var inflateRaw_1 = inflateRaw;
    var ungzip_1 = ungzip;
    var constants_1 = constants$2;

    var pako = {
        Deflate: Deflate_1,
        deflate: deflate_1,
        deflateRaw: deflateRaw_1,
        gzip: gzip_1,
        Inflate: Inflate_1,
        inflate: inflate_1,
        inflateRaw: inflateRaw_1,
        ungzip: ungzip_1,
        constants: constants_1,
    };

    // exports.Deflate = Deflate_1;
    // exports.Inflate = Inflate_1;
    // exports.constants = constants_1;
    exports["default"] = pako;
    // exports.deflate = deflate_1;
    // exports.deflateRaw = deflateRaw_1;
    // exports.gzip = gzip_1;
    // exports.inflate = inflate_1;
    // exports.inflateRaw = inflateRaw_1;
    // exports.ungzip = ungzip_1;

    Object.defineProperty(exports, "__esModule", { value: true });
});


/***/ }),

/***/ 2925:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 6938:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 8631:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 5232:
/***/ ((__unused_webpack_module, exports) => {

"use strict";
/**
 * @license
 * Copyright 2010-2023 Three.js Authors
 * SPDX-License-Identifier: MIT
 */


const REVISION = '163';

const MOUSE = { LEFT: 0, MIDDLE: 1, RIGHT: 2, ROTATE: 0, DOLLY: 1, PAN: 2 };
const TOUCH = { ROTATE: 0, PAN: 1, DOLLY_PAN: 2, DOLLY_ROTATE: 3 };
const CullFaceNone = 0;
const CullFaceBack = 1;
const CullFaceFront = 2;
const CullFaceFrontBack = 3;
const BasicShadowMap = 0;
const PCFShadowMap = 1;
const PCFSoftShadowMap = 2;
const VSMShadowMap = 3;
const FrontSide = 0;
const BackSide = 1;
const DoubleSide = 2;
const NoBlending = 0;
const NormalBlending = 1;
const AdditiveBlending = 2;
const SubtractiveBlending = 3;
const MultiplyBlending = 4;
const CustomBlending = 5;
const AddEquation = 100;
const SubtractEquation = 101;
const ReverseSubtractEquation = 102;
const MinEquation = 103;
const MaxEquation = 104;
const ZeroFactor = 200;
const OneFactor = 201;
const SrcColorFactor = 202;
const OneMinusSrcColorFactor = 203;
const SrcAlphaFactor = 204;
const OneMinusSrcAlphaFactor = 205;
const DstAlphaFactor = 206;
const OneMinusDstAlphaFactor = 207;
const DstColorFactor = 208;
const OneMinusDstColorFactor = 209;
const SrcAlphaSaturateFactor = 210;
const ConstantColorFactor = 211;
const OneMinusConstantColorFactor = 212;
const ConstantAlphaFactor = 213;
const OneMinusConstantAlphaFactor = 214;
const NeverDepth = 0;
const AlwaysDepth = 1;
const LessDepth = 2;
const LessEqualDepth = 3;
const EqualDepth = 4;
const GreaterEqualDepth = 5;
const GreaterDepth = 6;
const NotEqualDepth = 7;
const MultiplyOperation = 0;
const MixOperation = 1;
const AddOperation = 2;
const NoToneMapping = 0;
const LinearToneMapping = 1;
const ReinhardToneMapping = 2;
const CineonToneMapping = 3;
const ACESFilmicToneMapping = 4;
const CustomToneMapping = 5;
const AgXToneMapping = 6;
const NeutralToneMapping = 7;
const AttachedBindMode = 'attached';
const DetachedBindMode = 'detached';

const UVMapping = 300;
const CubeReflectionMapping = 301;
const CubeRefractionMapping = 302;
const EquirectangularReflectionMapping = 303;
const EquirectangularRefractionMapping = 304;
const CubeUVReflectionMapping = 306;
const RepeatWrapping = 1000;
const ClampToEdgeWrapping = 1001;
const MirroredRepeatWrapping = 1002;
const NearestFilter = 1003;
const NearestMipmapNearestFilter = 1004;
const NearestMipMapNearestFilter = 1004;
const NearestMipmapLinearFilter = 1005;
const NearestMipMapLinearFilter = 1005;
const LinearFilter = 1006;
const LinearMipmapNearestFilter = 1007;
const LinearMipMapNearestFilter = 1007;
const LinearMipmapLinearFilter = 1008;
const LinearMipMapLinearFilter = 1008;
const UnsignedByteType = 1009;
const ByteType = 1010;
const ShortType = 1011;
const UnsignedShortType = 1012;
const IntType = 1013;
const UnsignedIntType = 1014;
const FloatType = 1015;
const HalfFloatType = 1016;
const UnsignedShort4444Type = 1017;
const UnsignedShort5551Type = 1018;
const UnsignedInt248Type = 1020;
const UnsignedInt5999Type = 35902;
const AlphaFormat = 1021;
const RGBFormat = 1022;
const RGBAFormat = 1023;
const LuminanceFormat = 1024;
const LuminanceAlphaFormat = 1025;
const DepthFormat = 1026;
const DepthStencilFormat = 1027;
const RedFormat = 1028;
const RedIntegerFormat = 1029;
const RGFormat = 1030;
const RGIntegerFormat = 1031;
const RGBAIntegerFormat = 1033;

const RGB_S3TC_DXT1_Format = 33776;
const RGBA_S3TC_DXT1_Format = 33777;
const RGBA_S3TC_DXT3_Format = 33778;
const RGBA_S3TC_DXT5_Format = 33779;
const RGB_PVRTC_4BPPV1_Format = 35840;
const RGB_PVRTC_2BPPV1_Format = 35841;
const RGBA_PVRTC_4BPPV1_Format = 35842;
const RGBA_PVRTC_2BPPV1_Format = 35843;
const RGB_ETC1_Format = 36196;
const RGB_ETC2_Format = 37492;
const RGBA_ETC2_EAC_Format = 37496;
const RGBA_ASTC_4x4_Format = 37808;
const RGBA_ASTC_5x4_Format = 37809;
const RGBA_ASTC_5x5_Format = 37810;
const RGBA_ASTC_6x5_Format = 37811;
const RGBA_ASTC_6x6_Format = 37812;
const RGBA_ASTC_8x5_Format = 37813;
const RGBA_ASTC_8x6_Format = 37814;
const RGBA_ASTC_8x8_Format = 37815;
const RGBA_ASTC_10x5_Format = 37816;
const RGBA_ASTC_10x6_Format = 37817;
const RGBA_ASTC_10x8_Format = 37818;
const RGBA_ASTC_10x10_Format = 37819;
const RGBA_ASTC_12x10_Format = 37820;
const RGBA_ASTC_12x12_Format = 37821;
const RGBA_BPTC_Format = 36492;
const RGB_BPTC_SIGNED_Format = 36494;
const RGB_BPTC_UNSIGNED_Format = 36495;
const RED_RGTC1_Format = 36283;
const SIGNED_RED_RGTC1_Format = 36284;
const RED_GREEN_RGTC2_Format = 36285;
const SIGNED_RED_GREEN_RGTC2_Format = 36286;
const LoopOnce = 2200;
const LoopRepeat = 2201;
const LoopPingPong = 2202;
const InterpolateDiscrete = 2300;
const InterpolateLinear = 2301;
const InterpolateSmooth = 2302;
const ZeroCurvatureEnding = 2400;
const ZeroSlopeEnding = 2401;
const WrapAroundEnding = 2402;
const NormalAnimationBlendMode = 2500;
const AdditiveAnimationBlendMode = 2501;
const TrianglesDrawMode = 0;
const TriangleStripDrawMode = 1;
const TriangleFanDrawMode = 2;
const BasicDepthPacking = 3200;
const RGBADepthPacking = 3201;
const TangentSpaceNormalMap = 0;
const ObjectSpaceNormalMap = 1;

// Color space string identifiers, matching CSS Color Module Level 4 and WebGPU names where available.
const NoColorSpace = '';
const SRGBColorSpace = 'srgb';
const LinearSRGBColorSpace = 'srgb-linear';
const DisplayP3ColorSpace = 'display-p3';
const LinearDisplayP3ColorSpace = 'display-p3-linear';

const LinearTransfer = 'linear';
const SRGBTransfer = 'srgb';

const Rec709Primaries = 'rec709';
const P3Primaries = 'p3';

const ZeroStencilOp = 0;
const KeepStencilOp = 7680;
const ReplaceStencilOp = 7681;
const IncrementStencilOp = 7682;
const DecrementStencilOp = 7683;
const IncrementWrapStencilOp = 34055;
const DecrementWrapStencilOp = 34056;
const InvertStencilOp = 5386;

const NeverStencilFunc = 512;
const LessStencilFunc = 513;
const EqualStencilFunc = 514;
const LessEqualStencilFunc = 515;
const GreaterStencilFunc = 516;
const NotEqualStencilFunc = 517;
const GreaterEqualStencilFunc = 518;
const AlwaysStencilFunc = 519;

const NeverCompare = 512;
const LessCompare = 513;
const EqualCompare = 514;
const LessEqualCompare = 515;
const GreaterCompare = 516;
const NotEqualCompare = 517;
const GreaterEqualCompare = 518;
const AlwaysCompare = 519;

const StaticDrawUsage = 35044;
const DynamicDrawUsage = 35048;
const StreamDrawUsage = 35040;
const StaticReadUsage = 35045;
const DynamicReadUsage = 35049;
const StreamReadUsage = 35041;
const StaticCopyUsage = 35046;
const DynamicCopyUsage = 35050;
const StreamCopyUsage = 35042;

const GLSL1 = '100';
const GLSL3 = '300 es';

const WebGLCoordinateSystem = 2000;
const WebGPUCoordinateSystem = 2001;

/**
 * https://github.com/mrdoob/eventdispatcher.js/
 */

class EventDispatcher {

	addEventListener( type, listener ) {

		if ( this._listeners === undefined ) this._listeners = {};

		const listeners = this._listeners;

		if ( listeners[ type ] === undefined ) {

			listeners[ type ] = [];

		}

		if ( listeners[ type ].indexOf( listener ) === - 1 ) {

			listeners[ type ].push( listener );

		}

	}

	hasEventListener( type, listener ) {

		if ( this._listeners === undefined ) return false;

		const listeners = this._listeners;

		return listeners[ type ] !== undefined && listeners[ type ].indexOf( listener ) !== - 1;

	}

	removeEventListener( type, listener ) {

		if ( this._listeners === undefined ) return;

		const listeners = this._listeners;
		const listenerArray = listeners[ type ];

		if ( listenerArray !== undefined ) {

			const index = listenerArray.indexOf( listener );

			if ( index !== - 1 ) {

				listenerArray.splice( index, 1 );

			}

		}

	}

	dispatchEvent( event ) {

		if ( this._listeners === undefined ) return;

		const listeners = this._listeners;
		const listenerArray = listeners[ event.type ];

		if ( listenerArray !== undefined ) {

			event.target = this;

			// Make a copy, in case listeners are removed while iterating.
			const array = listenerArray.slice( 0 );

			for ( let i = 0, l = array.length; i < l; i ++ ) {

				array[ i ].call( this, event );

			}

			event.target = null;

		}

	}

}

const _lut = [ '00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '0a', '0b', '0c', '0d', '0e', '0f', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '1a', '1b', '1c', '1d', '1e', '1f', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '2a', '2b', '2c', '2d', '2e', '2f', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '3a', '3b', '3c', '3d', '3e', '3f', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '4a', '4b', '4c', '4d', '4e', '4f', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59', '5a', '5b', '5c', '5d', '5e', '5f', '60', '61', '62', '63', '64', '65', '66', '67', '68', '69', '6a', '6b', '6c', '6d', '6e', '6f', '70', '71', '72', '73', '74', '75', '76', '77', '78', '79', '7a', '7b', '7c', '7d', '7e', '7f', '80', '81', '82', '83', '84', '85', '86', '87', '88', '89', '8a', '8b', '8c', '8d', '8e', '8f', '90', '91', '92', '93', '94', '95', '96', '97', '98', '99', '9a', '9b', '9c', '9d', '9e', '9f', 'a0', 'a1', 'a2', 'a3', 'a4', 'a5', 'a6', 'a7', 'a8', 'a9', 'aa', 'ab', 'ac', 'ad', 'ae', 'af', 'b0', 'b1', 'b2', 'b3', 'b4', 'b5', 'b6', 'b7', 'b8', 'b9', 'ba', 'bb', 'bc', 'bd', 'be', 'bf', 'c0', 'c1', 'c2', 'c3', 'c4', 'c5', 'c6', 'c7', 'c8', 'c9', 'ca', 'cb', 'cc', 'cd', 'ce', 'cf', 'd0', 'd1', 'd2', 'd3', 'd4', 'd5', 'd6', 'd7', 'd8', 'd9', 'da', 'db', 'dc', 'dd', 'de', 'df', 'e0', 'e1', 'e2', 'e3', 'e4', 'e5', 'e6', 'e7', 'e8', 'e9', 'ea', 'eb', 'ec', 'ed', 'ee', 'ef', 'f0', 'f1', 'f2', 'f3', 'f4', 'f5', 'f6', 'f7', 'f8', 'f9', 'fa', 'fb', 'fc', 'fd', 'fe', 'ff' ];

let _seed = 1234567;


const DEG2RAD = Math.PI / 180;
const RAD2DEG = 180 / Math.PI;

// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
function generateUUID() {

	const d0 = Math.random() * 0xffffffff | 0;
	const d1 = Math.random() * 0xffffffff | 0;
	const d2 = Math.random() * 0xffffffff | 0;
	const d3 = Math.random() * 0xffffffff | 0;
	const uuid = _lut[ d0 & 0xff ] + _lut[ d0 >> 8 & 0xff ] + _lut[ d0 >> 16 & 0xff ] + _lut[ d0 >> 24 & 0xff ] + '-' +
			_lut[ d1 & 0xff ] + _lut[ d1 >> 8 & 0xff ] + '-' + _lut[ d1 >> 16 & 0x0f | 0x40 ] + _lut[ d1 >> 24 & 0xff ] + '-' +
			_lut[ d2 & 0x3f | 0x80 ] + _lut[ d2 >> 8 & 0xff ] + '-' + _lut[ d2 >> 16 & 0xff ] + _lut[ d2 >> 24 & 0xff ] +
			_lut[ d3 & 0xff ] + _lut[ d3 >> 8 & 0xff ] + _lut[ d3 >> 16 & 0xff ] + _lut[ d3 >> 24 & 0xff ];

	// .toLowerCase() here flattens concatenated strings to save heap memory space.
	return uuid.toLowerCase();

}

function clamp( value, min, max ) {

	return Math.max( min, Math.min( max, value ) );

}

// compute euclidean modulo of m % n
// https://en.wikipedia.org/wiki/Modulo_operation
function euclideanModulo( n, m ) {

	return ( ( n % m ) + m ) % m;

}

// Linear mapping from range <a1, a2> to range <b1, b2>
function mapLinear( x, a1, a2, b1, b2 ) {

	return b1 + ( x - a1 ) * ( b2 - b1 ) / ( a2 - a1 );

}

// https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
function inverseLerp( x, y, value ) {

	if ( x !== y ) {

		return ( value - x ) / ( y - x );

	} else {

		return 0;

	}

}

// https://en.wikipedia.org/wiki/Linear_interpolation
function lerp( x, y, t ) {

	return ( 1 - t ) * x + t * y;

}

// http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/
function damp( x, y, lambda, dt ) {

	return lerp( x, y, 1 - Math.exp( - lambda * dt ) );

}

// https://www.desmos.com/calculator/vcsjnyz7x4
function pingpong( x, length = 1 ) {

	return length - Math.abs( euclideanModulo( x, length * 2 ) - length );

}

// http://en.wikipedia.org/wiki/Smoothstep
function smoothstep( x, min, max ) {

	if ( x <= min ) return 0;
	if ( x >= max ) return 1;

	x = ( x - min ) / ( max - min );

	return x * x * ( 3 - 2 * x );

}

function smootherstep( x, min, max ) {

	if ( x <= min ) return 0;
	if ( x >= max ) return 1;

	x = ( x - min ) / ( max - min );

	return x * x * x * ( x * ( x * 6 - 15 ) + 10 );

}

// Random integer from <low, high> interval
function randInt( low, high ) {

	return low + Math.floor( Math.random() * ( high - low + 1 ) );

}

// Random float from <low, high> interval
function randFloat( low, high ) {

	return low + Math.random() * ( high - low );

}

// Random float from <-range/2, range/2> interval
function randFloatSpread( range ) {

	return range * ( 0.5 - Math.random() );

}

// Deterministic pseudo-random float in the interval [ 0, 1 ]
function seededRandom( s ) {

	if ( s !== undefined ) _seed = s;

	// Mulberry32 generator

	let t = _seed += 0x6D2B79F5;

	t = Math.imul( t ^ t >>> 15, t | 1 );

	t ^= t + Math.imul( t ^ t >>> 7, t | 61 );

	return ( ( t ^ t >>> 14 ) >>> 0 ) / 4294967296;

}

function degToRad( degrees ) {

	return degrees * DEG2RAD;

}

function radToDeg( radians ) {

	return radians * RAD2DEG;

}

function isPowerOfTwo( value ) {

	return ( value & ( value - 1 ) ) === 0 && value !== 0;

}

function ceilPowerOfTwo( value ) {

	return Math.pow( 2, Math.ceil( Math.log( value ) / Math.LN2 ) );

}

function floorPowerOfTwo( value ) {

	return Math.pow( 2, Math.floor( Math.log( value ) / Math.LN2 ) );

}

function setQuaternionFromProperEuler( q, a, b, c, order ) {

	// Intrinsic Proper Euler Angles - see https://en.wikipedia.org/wiki/Euler_angles

	// rotations are applied to the axes in the order specified by 'order'
	// rotation by angle 'a' is applied first, then by angle 'b', then by angle 'c'
	// angles are in radians

	const cos = Math.cos;
	const sin = Math.sin;

	const c2 = cos( b / 2 );
	const s2 = sin( b / 2 );

	const c13 = cos( ( a + c ) / 2 );
	const s13 = sin( ( a + c ) / 2 );

	const c1_3 = cos( ( a - c ) / 2 );
	const s1_3 = sin( ( a - c ) / 2 );

	const c3_1 = cos( ( c - a ) / 2 );
	const s3_1 = sin( ( c - a ) / 2 );

	switch ( order ) {

		case 'XYX':
			q.set( c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13 );
			break;

		case 'YZY':
			q.set( s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13 );
			break;

		case 'ZXZ':
			q.set( s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13 );
			break;

		case 'XZX':
			q.set( c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13 );
			break;

		case 'YXY':
			q.set( s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13 );
			break;

		case 'ZYZ':
			q.set( s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13 );
			break;

		default:
			console.warn( 'THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: ' + order );

	}

}

function denormalize( value, array ) {

	switch ( array.constructor ) {

		case Float32Array:

			return value;

		case Uint32Array:

			return value / 4294967295.0;

		case Uint16Array:

			return value / 65535.0;

		case Uint8Array:

			return value / 255.0;

		case Int32Array:

			return Math.max( value / 2147483647.0, - 1.0 );

		case Int16Array:

			return Math.max( value / 32767.0, - 1.0 );

		case Int8Array:

			return Math.max( value / 127.0, - 1.0 );

		default:

			throw new Error( 'Invalid component type.' );

	}

}

function normalize( value, array ) {

	switch ( array.constructor ) {

		case Float32Array:

			return value;

		case Uint32Array:

			return Math.round( value * 4294967295.0 );

		case Uint16Array:

			return Math.round( value * 65535.0 );

		case Uint8Array:

			return Math.round( value * 255.0 );

		case Int32Array:

			return Math.round( value * 2147483647.0 );

		case Int16Array:

			return Math.round( value * 32767.0 );

		case Int8Array:

			return Math.round( value * 127.0 );

		default:

			throw new Error( 'Invalid component type.' );

	}

}

const MathUtils = {
	DEG2RAD: DEG2RAD,
	RAD2DEG: RAD2DEG,
	generateUUID: generateUUID,
	clamp: clamp,
	euclideanModulo: euclideanModulo,
	mapLinear: mapLinear,
	inverseLerp: inverseLerp,
	lerp: lerp,
	damp: damp,
	pingpong: pingpong,
	smoothstep: smoothstep,
	smootherstep: smootherstep,
	randInt: randInt,
	randFloat: randFloat,
	randFloatSpread: randFloatSpread,
	seededRandom: seededRandom,
	degToRad: degToRad,
	radToDeg: radToDeg,
	isPowerOfTwo: isPowerOfTwo,
	ceilPowerOfTwo: ceilPowerOfTwo,
	floorPowerOfTwo: floorPowerOfTwo,
	setQuaternionFromProperEuler: setQuaternionFromProperEuler,
	normalize: normalize,
	denormalize: denormalize
};

class Vector2 {

	constructor( x = 0, y = 0 ) {

		Vector2.prototype.isVector2 = true;

		this.x = x;
		this.y = y;

	}

	get width() {

		return this.x;

	}

	set width( value ) {

		this.x = value;

	}

	get height() {

		return this.y;

	}

	set height( value ) {

		this.y = value;

	}

	set( x, y ) {

		this.x = x;
		this.y = y;

		return this;

	}

	setScalar( scalar ) {

		this.x = scalar;
		this.y = scalar;

		return this;

	}

	setX( x ) {

		this.x = x;

		return this;

	}

	setY( y ) {

		this.y = y;

		return this;

	}

	setComponent( index, value ) {

		switch ( index ) {

			case 0: this.x = value; break;
			case 1: this.y = value; break;
			default: throw new Error( 'index is out of range: ' + index );

		}

		return this;

	}

	getComponent( index ) {

		switch ( index ) {

			case 0: return this.x;
			case 1: return this.y;
			default: throw new Error( 'index is out of range: ' + index );

		}

	}

	clone() {

		return new this.constructor( this.x, this.y );

	}

	copy( v ) {

		this.x = v.x;
		this.y = v.y;

		return this;

	}

	add( v ) {

		this.x += v.x;
		this.y += v.y;

		return this;

	}

	addScalar( s ) {

		this.x += s;
		this.y += s;

		return this;

	}

	addVectors( a, b ) {

		this.x = a.x + b.x;
		this.y = a.y + b.y;

		return this;

	}

	addScaledVector( v, s ) {

		this.x += v.x * s;
		this.y += v.y * s;

		return this;

	}

	sub( v ) {

		this.x -= v.x;
		this.y -= v.y;

		return this;

	}

	subScalar( s ) {

		this.x -= s;
		this.y -= s;

		return this;

	}

	subVectors( a, b ) {

		this.x = a.x - b.x;
		this.y = a.y - b.y;

		return this;

	}

	multiply( v ) {

		this.x *= v.x;
		this.y *= v.y;

		return this;

	}

	multiplyScalar( scalar ) {

		this.x *= scalar;
		this.y *= scalar;

		return this;

	}

	divide( v ) {

		this.x /= v.x;
		this.y /= v.y;

		return this;

	}

	divideScalar( scalar ) {

		return this.multiplyScalar( 1 / scalar );

	}

	applyMatrix3( m ) {

		const x = this.x, y = this.y;
		const e = m.elements;

		this.x = e[ 0 ] * x + e[ 3 ] * y + e[ 6 ];
		this.y = e[ 1 ] * x + e[ 4 ] * y + e[ 7 ];

		return this;

	}

	min( v ) {

		this.x = Math.min( this.x, v.x );
		this.y = Math.min( this.y, v.y );

		return this;

	}

	max( v ) {

		this.x = Math.max( this.x, v.x );
		this.y = Math.max( this.y, v.y );

		return this;

	}

	clamp( min, max ) {

		// assumes min < max, componentwise

		this.x = Math.max( min.x, Math.min( max.x, this.x ) );
		this.y = Math.max( min.y, Math.min( max.y, this.y ) );

		return this;

	}

	clampScalar( minVal, maxVal ) {

		this.x = Math.max( minVal, Math.min( maxVal, this.x ) );
		this.y = Math.max( minVal, Math.min( maxVal, this.y ) );

		return this;

	}

	clampLength( min, max ) {

		const length = this.length();

		return this.divideScalar( length || 1 ).multiplyScalar( Math.max( min, Math.min( max, length ) ) );

	}

	floor() {

		this.x = Math.floor( this.x );
		this.y = Math.floor( this.y );

		return this;

	}

	ceil() {

		this.x = Math.ceil( this.x );
		this.y = Math.ceil( this.y );

		return this;

	}

	round() {

		this.x = Math.round( this.x );
		this.y = Math.round( this.y );

		return this;

	}

	roundToZero() {

		this.x = Math.trunc( this.x );
		this.y = Math.trunc( this.y );

		return this;

	}

	negate() {

		this.x = - this.x;
		this.y = - this.y;

		return this;

	}

	dot( v ) {

		return this.x * v.x + this.y * v.y;

	}

	cross( v ) {

		return this.x * v.y - this.y * v.x;

	}

	lengthSq() {

		return this.x * this.x + this.y * this.y;

	}

	length() {

		return Math.sqrt( this.x * this.x + this.y * this.y );

	}

	manhattanLength() {

		return Math.abs( this.x ) + Math.abs( this.y );

	}

	normalize() {

		return this.divideScalar( this.length() || 1 );

	}

	angle() {

		// computes the angle in radians with respect to the positive x-axis

		const angle = Math.atan2( - this.y, - this.x ) + Math.PI;

		return angle;

	}

	angleTo( v ) {

		const denominator = Math.sqrt( this.lengthSq() * v.lengthSq() );

		if ( denominator === 0 ) return Math.PI / 2;

		const theta = this.dot( v ) / denominator;

		// clamp, to handle numerical problems

		return Math.acos( clamp( theta, - 1, 1 ) );

	}

	distanceTo( v ) {

		return Math.sqrt( this.distanceToSquared( v ) );

	}

	distanceToSquared( v ) {

		const dx = this.x - v.x, dy = this.y - v.y;
		return dx * dx + dy * dy;

	}

	manhattanDistanceTo( v ) {

		return Math.abs( this.x - v.x ) + Math.abs( this.y - v.y );

	}

	setLength( length ) {

		return this.normalize().multiplyScalar( length );

	}

	lerp( v, alpha ) {

		this.x += ( v.x - this.x ) * alpha;
		this.y += ( v.y - this.y ) * alpha;

		return this;

	}

	lerpVectors( v1, v2, alpha ) {

		this.x = v1.x + ( v2.x - v1.x ) * alpha;
		this.y = v1.y + ( v2.y - v1.y ) * alpha;

		return this;

	}

	equals( v ) {

		return ( ( v.x === this.x ) && ( v.y === this.y ) );

	}

	fromArray( array, offset = 0 ) {

		this.x = array[ offset ];
		this.y = array[ offset + 1 ];

		return this;

	}

	toArray( array = [], offset = 0 ) {

		array[ offset ] = this.x;
		array[ offset + 1 ] = this.y;

		return array;

	}

	fromBufferAttribute( attribute, index ) {

		this.x = attribute.getX( index );
		this.y = attribute.getY( index );

		return this;

	}

	rotateAround( center, angle ) {

		const c = Math.cos( angle ), s = Math.sin( angle );

		const x = this.x - center.x;
		const y = this.y - center.y;

		this.x = x * c - y * s + center.x;
		this.y = x * s + y * c + center.y;

		return this;

	}

	random() {

		this.x = Math.random();
		this.y = Math.random();

		return this;

	}

	*[ Symbol.iterator ]() {

		yield this.x;
		yield this.y;

	}

}

class Matrix3 {

	constructor( n11, n12, n13, n21, n22, n23, n31, n32, n33 ) {

		Matrix3.prototype.isMatrix3 = true;

		this.elements = [

			1, 0, 0,
			0, 1, 0,
			0, 0, 1

		];

		if ( n11 !== undefined ) {

			this.set( n11, n12, n13, n21, n22, n23, n31, n32, n33 );

		}

	}

	set( n11, n12, n13, n21, n22, n23, n31, n32, n33 ) {

		const te = this.elements;

		te[ 0 ] = n11; te[ 1 ] = n21; te[ 2 ] = n31;
		te[ 3 ] = n12; te[ 4 ] = n22; te[ 5 ] = n32;
		te[ 6 ] = n13; te[ 7 ] = n23; te[ 8 ] = n33;

		return this;

	}

	identity() {

		this.set(

			1, 0, 0,
			0, 1, 0,
			0, 0, 1

		);

		return this;

	}

	copy( m ) {

		const te = this.elements;
		const me = m.elements;

		te[ 0 ] = me[ 0 ]; te[ 1 ] = me[ 1 ]; te[ 2 ] = me[ 2 ];
		te[ 3 ] = me[ 3 ]; te[ 4 ] = me[ 4 ]; te[ 5 ] = me[ 5 ];
		te[ 6 ] = me[ 6 ]; te[ 7 ] = me[ 7 ]; te[ 8 ] = me[ 8 ];

		return this;

	}

	extractBasis( xAxis, yAxis, zAxis ) {

		xAxis.setFromMatrix3Column( this, 0 );
		yAxis.setFromMatrix3Column( this, 1 );
		zAxis.setFromMatrix3Column( this, 2 );

		return this;

	}

	setFromMatrix4( m ) {

		const me = m.elements;

		this.set(

			me[ 0 ], me[ 4 ], me[ 8 ],
			me[ 1 ], me[ 5 ], me[ 9 ],
			me[ 2 ], me[ 6 ], me[ 10 ]

		);

		return this;

	}

	multiply( m ) {

		return this.multiplyMatrices( this, m );

	}

	premultiply( m ) {

		return this.multiplyMatrices( m, this );

	}

	multiplyMatrices( a, b ) {

		const ae = a.elements;
		const be = b.elements;
		const te = this.elements;

		const a11 = ae[ 0 ], a12 = ae[ 3 ], a13 = ae[ 6 ];
		const a21 = ae[ 1 ], a22 = ae[ 4 ], a23 = ae[ 7 ];
		const a31 = ae[ 2 ], a32 = ae[ 5 ], a33 = ae[ 8 ];

		const b11 = be[ 0 ], b12 = be[ 3 ], b13 = be[ 6 ];
		const b21 = be[ 1 ], b22 = be[ 4 ], b23 = be[ 7 ];
		const b31 = be[ 2 ], b32 = be[ 5 ], b33 = be[ 8 ];

		te[ 0 ] = a11 * b11 + a12 * b21 + a13 * b31;
		te[ 3 ] = a11 * b12 + a12 * b22 + a13 * b32;
		te[ 6 ] = a11 * b13 + a12 * b23 + a13 * b33;

		te[ 1 ] = a21 * b11 + a22 * b21 + a23 * b31;
		te[ 4 ] = a21 * b12 + a22 * b22 + a23 * b32;
		te[ 7 ] = a21 * b13 + a22 * b23 + a23 * b33;

		te[ 2 ] = a31 * b11 + a32 * b21 + a33 * b31;
		te[ 5 ] = a31 * b12 + a32 * b22 + a33 * b32;
		te[ 8 ] = a31 * b13 + a32 * b23 + a33 * b33;

		return this;

	}

	multiplyScalar( s ) {

		const te = this.elements;

		te[ 0 ] *= s; te[ 3 ] *= s; te[ 6 ] *= s;
		te[ 1 ] *= s; te[ 4 ] *= s; te[ 7 ] *= s;
		te[ 2 ] *= s; te[ 5 ] *= s; te[ 8 ] *= s;

		return this;

	}

	determinant() {

		const te = this.elements;

		const a = te[ 0 ], b = te[ 1 ], c = te[ 2 ],
			d = te[ 3 ], e = te[ 4 ], f = te[ 5 ],
			g = te[ 6 ], h = te[ 7 ], i = te[ 8 ];

		return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;

	}

	invert() {

		const te = this.elements,

			n11 = te[ 0 ], n21 = te[ 1 ], n31 = te[ 2 ],
			n12 = te[ 3 ], n22 = te[ 4 ], n32 = te[ 5 ],
			n13 = te[ 6 ], n23 = te[ 7 ], n33 = te[ 8 ],

			t11 = n33 * n22 - n32 * n23,
			t12 = n32 * n13 - n33 * n12,
			t13 = n23 * n12 - n22 * n13,

			det = n11 * t11 + n21 * t12 + n31 * t13;

		if ( det === 0 ) return this.set( 0, 0, 0, 0, 0, 0, 0, 0, 0 );

		const detInv = 1 / det;

		te[ 0 ] = t11 * detInv;
		te[ 1 ] = ( n31 * n23 - n33 * n21 ) * detInv;
		te[ 2 ] = ( n32 * n21 - n31 * n22 ) * detInv;

		te[ 3 ] = t12 * detInv;
		te[ 4 ] = ( n33 * n11 - n31 * n13 ) * detInv;
		te[ 5 ] = ( n31 * n12 - n32 * n11 ) * detInv;

		te[ 6 ] = t13 * detInv;
		te[ 7 ] = ( n21 * n13 - n23 * n11 ) * detInv;
		te[ 8 ] = ( n22 * n11 - n21 * n12 ) * detInv;

		return this;

	}

	transpose() {

		let tmp;
		const m = this.elements;

		tmp = m[ 1 ]; m[ 1 ] = m[ 3 ]; m[ 3 ] = tmp;
		tmp = m[ 2 ]; m[ 2 ] = m[ 6 ]; m[ 6 ] = tmp;
		tmp = m[ 5 ]; m[ 5 ] = m[ 7 ]; m[ 7 ] = tmp;

		return this;

	}

	getNormalMatrix( matrix4 ) {

		return this.setFromMatrix4( matrix4 ).invert().transpose();

	}

	transposeIntoArray( r ) {

		const m = this.elements;

		r[ 0 ] = m[ 0 ];
		r[ 1 ] = m[ 3 ];
		r[ 2 ] = m[ 6 ];
		r[ 3 ] = m[ 1 ];
		r[ 4 ] = m[ 4 ];
		r[ 5 ] = m[ 7 ];
		r[ 6 ] = m[ 2 ];
		r[ 7 ] = m[ 5 ];
		r[ 8 ] = m[ 8 ];

		return this;

	}

	setUvTransform( tx, ty, sx, sy, rotation, cx, cy ) {

		const c = Math.cos( rotation );
		const s = Math.sin( rotation );

		this.set(
			sx * c, sx * s, - sx * ( c * cx + s * cy ) + cx + tx,
			- sy * s, sy * c, - sy * ( - s * cx + c * cy ) + cy + ty,
			0, 0, 1
		);

		return this;

	}

	//

	scale( sx, sy ) {

		this.premultiply( _m3.makeScale( sx, sy ) );

		return this;

	}

	rotate( theta ) {

		this.premultiply( _m3.makeRotation( - theta ) );

		return this;

	}

	translate( tx, ty ) {

		this.premultiply( _m3.makeTranslation( tx, ty ) );

		return this;

	}

	// for 2D Transforms

	makeTranslation( x, y ) {

		if ( x.isVector2 ) {

			this.set(

				1, 0, x.x,
				0, 1, x.y,
				0, 0, 1

			);

		} else {

			this.set(

				1, 0, x,
				0, 1, y,
				0, 0, 1

			);

		}

		return this;

	}

	makeRotation( theta ) {

		// counterclockwise

		const c = Math.cos( theta );
		const s = Math.sin( theta );

		this.set(

			c, - s, 0,
			s, c, 0,
			0, 0, 1

		);

		return this;

	}

	makeScale( x, y ) {

		this.set(

			x, 0, 0,
			0, y, 0,
			0, 0, 1

		);

		return this;

	}

	//

	equals( matrix ) {

		const te = this.elements;
		const me = matrix.elements;

		for ( let i = 0; i < 9; i ++ ) {

			if ( te[ i ] !== me[ i ] ) return false;

		}

		return true;

	}

	fromArray( array, offset = 0 ) {

		for ( let i = 0; i < 9; i ++ ) {

			this.elements[ i ] = array[ i + offset ];

		}

		return this;

	}

	toArray( array = [], offset = 0 ) {

		const te = this.elements;

		array[ offset ] = te[ 0 ];
		array[ offset + 1 ] = te[ 1 ];
		array[ offset + 2 ] = te[ 2 ];

		array[ offset + 3 ] = te[ 3 ];
		array[ offset + 4 ] = te[ 4 ];
		array[ offset + 5 ] = te[ 5 ];

		array[ offset + 6 ] = te[ 6 ];
		array[ offset + 7 ] = te[ 7 ];
		array[ offset + 8 ] = te[ 8 ];

		return array;

	}

	clone() {

		return new this.constructor().fromArray( this.elements );

	}

}

const _m3 = /*@__PURE__*/ new Matrix3();

function arrayNeedsUint32( array ) {

	// assumes larger values usually on last

	for ( let i = array.length - 1; i >= 0; -- i ) {

		if ( array[ i ] >= 65535 ) return true; // account for PRIMITIVE_RESTART_FIXED_INDEX, #24565

	}

	return false;

}

const TYPED_ARRAYS = {
	Int8Array: Int8Array,
	Uint8Array: Uint8Array,
	Uint8ClampedArray: Uint8ClampedArray,
	Int16Array: Int16Array,
	Uint16Array: Uint16Array,
	Int32Array: Int32Array,
	Uint32Array: Uint32Array,
	Float32Array: Float32Array,
	Float64Array: Float64Array
};

function getTypedArray( type, buffer ) {

	return new TYPED_ARRAYS[ type ]( buffer );

}

function createElementNS( name ) {

	return document.createElementNS( 'http://www.w3.org/1999/xhtml', name );

}

function createCanvasElement() {

	const canvas = createElementNS( 'canvas' );
	canvas.style.display = 'block';
	return canvas;

}

const _cache = {};

function warnOnce( message ) {

	if ( message in _cache ) return;

	_cache[ message ] = true;

	console.warn( message );

}

/**
 * Matrices converting P3 <-> Rec. 709 primaries, without gamut mapping
 * or clipping. Based on W3C specifications for sRGB and Display P3,
 * and ICC specifications for the D50 connection space. Values in/out
 * are _linear_ sRGB and _linear_ Display P3.
 *
 * Note that both sRGB and Display P3 use the sRGB transfer functions.
 *
 * Reference:
 * - http://www.russellcottrell.com/photo/matrixCalculator.htm
 */

const LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 = /*@__PURE__*/ new Matrix3().set(
	0.8224621, 0.177538, 0.0,
	0.0331941, 0.9668058, 0.0,
	0.0170827, 0.0723974, 0.9105199,
);

const LINEAR_DISPLAY_P3_TO_LINEAR_SRGB = /*@__PURE__*/ new Matrix3().set(
	1.2249401, - 0.2249404, 0.0,
	- 0.0420569, 1.0420571, 0.0,
	- 0.0196376, - 0.0786361, 1.0982735
);

/**
 * Defines supported color spaces by transfer function and primaries,
 * and provides conversions to/from the Linear-sRGB reference space.
 */
const COLOR_SPACES = {
	[ LinearSRGBColorSpace ]: {
		transfer: LinearTransfer,
		primaries: Rec709Primaries,
		toReference: ( color ) => color,
		fromReference: ( color ) => color,
	},
	[ SRGBColorSpace ]: {
		transfer: SRGBTransfer,
		primaries: Rec709Primaries,
		toReference: ( color ) => color.convertSRGBToLinear(),
		fromReference: ( color ) => color.convertLinearToSRGB(),
	},
	[ LinearDisplayP3ColorSpace ]: {
		transfer: LinearTransfer,
		primaries: P3Primaries,
		toReference: ( color ) => color.applyMatrix3( LINEAR_DISPLAY_P3_TO_LINEAR_SRGB ),
		fromReference: ( color ) => color.applyMatrix3( LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 ),
	},
	[ DisplayP3ColorSpace ]: {
		transfer: SRGBTransfer,
		primaries: P3Primaries,
		toReference: ( color ) => color.convertSRGBToLinear().applyMatrix3( LINEAR_DISPLAY_P3_TO_LINEAR_SRGB ),
		fromReference: ( color ) => color.applyMatrix3( LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 ).convertLinearToSRGB(),
	},
};

const SUPPORTED_WORKING_COLOR_SPACES = new Set( [ LinearSRGBColorSpace, LinearDisplayP3ColorSpace ] );

const ColorManagement = {

	enabled: true,

	_workingColorSpace: LinearSRGBColorSpace,

	get workingColorSpace() {

		return this._workingColorSpace;

	},

	set workingColorSpace( colorSpace ) {

		if ( ! SUPPORTED_WORKING_COLOR_SPACES.has( colorSpace ) ) {

			throw new Error( `Unsupported working color space, "${ colorSpace }".` );

		}

		this._workingColorSpace = colorSpace;

	},

	convert: function ( color, sourceColorSpace, targetColorSpace ) {

		if ( this.enabled === false || sourceColorSpace === targetColorSpace || ! sourceColorSpace || ! targetColorSpace ) {

			return color;

		}

		const sourceToReference = COLOR_SPACES[ sourceColorSpace ].toReference;
		const targetFromReference = COLOR_SPACES[ targetColorSpace ].fromReference;

		return targetFromReference( sourceToReference( color ) );

	},

	fromWorkingColorSpace: function ( color, targetColorSpace ) {

		return this.convert( color, this._workingColorSpace, targetColorSpace );

	},

	toWorkingColorSpace: function ( color, sourceColorSpace ) {

		return this.convert( color, sourceColorSpace, this._workingColorSpace );

	},

	getPrimaries: function ( colorSpace ) {

		return COLOR_SPACES[ colorSpace ].primaries;

	},

	getTransfer: function ( colorSpace ) {

		if ( colorSpace === NoColorSpace ) return LinearTransfer;

		return COLOR_SPACES[ colorSpace ].transfer;

	},

};


function SRGBToLinear( c ) {

	return ( c < 0.04045 ) ? c * 0.0773993808 : Math.pow( c * 0.9478672986 + 0.0521327014, 2.4 );

}

function LinearToSRGB( c ) {

	return ( c < 0.0031308 ) ? c * 12.92 : 1.055 * ( Math.pow( c, 0.41666 ) ) - 0.055;

}

let _canvas;

class ImageUtils {

	static getDataURL( image ) {

		if ( /^data:/i.test( image.src ) ) {

			return image.src;

		}

		if ( typeof HTMLCanvasElement === 'undefined' ) {

			return image.src;

		}

		let canvas;

		if ( image instanceof HTMLCanvasElement ) {

			canvas = image;

		} else {

			if ( _canvas === undefined ) _canvas = createElementNS( 'canvas' );

			_canvas.width = image.width;
			_canvas.height = image.height;

			const context = _canvas.getContext( '2d' );

			if ( image instanceof ImageData ) {

				context.putImageData( image, 0, 0 );

			} else {

				context.drawImage( image, 0, 0, image.width, image.height );

			}

			canvas = _canvas;

		}

		if ( canvas.width > 2048 || canvas.height > 2048 ) {

			console.warn( 'THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons', image );

			return canvas.toDataURL( 'image/jpeg', 0.6 );

		} else {

			return canvas.toDataURL( 'image/png' );

		}

	}

	static sRGBToLinear( image ) {

		if ( ( typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement ) ||
			( typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement ) ||
			( typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap ) ) {

			const canvas = createElementNS( 'canvas' );

			canvas.width = image.width;
			canvas.height = image.height;

			const context = canvas.getContext( '2d' );
			context.drawImage( image, 0, 0, image.width, image.height );

			const imageData = context.getImageData( 0, 0, image.width, image.height );
			const data = imageData.data;

			for ( let i = 0; i < data.length; i ++ ) {

				data[ i ] = SRGBToLinear( data[ i ] / 255 ) * 255;

			}

			context.putImageData( imageData, 0, 0 );

			return canvas;

		} else if ( image.data ) {

			const data = image.data.slice( 0 );

			for ( let i = 0; i < data.length; i ++ ) {

				if ( data instanceof Uint8Array || data instanceof Uint8ClampedArray ) {

					data[ i ] = Math.floor( SRGBToLinear( data[ i ] / 255 ) * 255 );

				} else {

					// assuming float

					data[ i ] = SRGBToLinear( data[ i ] );

				}

			}

			return {
				data: data,
				width: image.width,
				height: image.height
			};

		} else {

			console.warn( 'THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.' );
			return image;

		}

	}

}

let _sourceId = 0;

class Source {

	constructor( data = null ) {

		this.isSource = true;

		Object.defineProperty( this, 'id', { value: _sourceId ++ } );

		this.uuid = generateUUID();

		this.data = data;
		this.dataReady = true;

		this.version = 0;

	}

	set needsUpdate( value ) {

		if ( value === true ) this.version ++;

	}

	toJSON( meta ) {

		const isRootObject = ( meta === undefined || typeof meta === 'string' );

		if ( ! isRootObject && meta.images[ this.uuid ] !== undefined ) {

			return meta.images[ this.uuid ];

		}

		const output = {
			uuid: this.uuid,
			url: ''
		};

		const data = this.data;

		if ( data !== null ) {

			let url;

			if ( Array.isArray( data ) ) {

				// cube texture

				url = [];

				for ( let i = 0, l = data.length; i < l; i ++ ) {

					if ( data[ i ].isDataTexture ) {

						url.push( serializeImage( data[ i ].image ) );

					} else {

						url.push( serializeImage( data[ i ] ) );

					}

				}

			} else {

				// texture

				url = serializeImage( data );

			}

			output.url = url;

		}

		if ( ! isRootObject ) {

			meta.images[ this.uuid ] = output;

		}

		return output;

	}

}

function serializeImage( image ) {

	if ( ( typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement ) ||
		( typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement ) ||
		( typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap ) ) {

		// default images

		return ImageUtils.getDataURL( image );

	} else {

		if ( image.data ) {

			// images of DataTexture

			return {
				data: Array.from( image.data ),
				width: image.width,
				height: image.height,
				type: image.data.constructor.name
			};

		} else {

			console.warn( 'THREE.Texture: Unable to serialize Texture.' );
			return {};

		}

	}

}

let _textureId = 0;

class Texture extends EventDispatcher {

	constructor( image = Texture.DEFAULT_IMAGE, mapping = Texture.DEFAULT_MAPPING, wrapS = ClampToEdgeWrapping, wrapT = ClampToEdgeWrapping, magFilter = LinearFilter, minFilter = LinearMipmapLinearFilter, format = RGBAFormat, type = UnsignedByteType, anisotropy = Texture.DEFAULT_ANISOTROPY, colorSpace = NoColorSpace ) {

		super();

		this.isTexture = true;

		Object.defineProperty( this, 'id', { value: _textureId ++ } );

		this.uuid = generateUUID();

		this.name = '';

		this.source = new Source( image );
		this.mipmaps = [];

		this.mapping = mapping;
		this.channel = 0;

		this.wrapS = wrapS;
		this.wrapT = wrapT;

		this.magFilter = magFilter;
		this.minFilter = minFilter;

		this.anisotropy = anisotropy;

		this.format = format;
		this.internalFormat = null;
		this.type = type;

		this.offset = new Vector2( 0, 0 );
		this.repeat = new Vector2( 1, 1 );
		this.center = new Vector2( 0, 0 );
		this.rotation = 0;

		this.matrixAutoUpdate = true;
		this.matrix = new Matrix3();

		this.generateMipmaps = true;
		this.premultiplyAlpha = false;
		this.flipY = true;
		this.unpackAlignment = 4;	// valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)

		this.colorSpace = colorSpace;

		this.userData = {};

		this.version = 0;
		this.onUpdate = null;

		this.isRenderTargetTexture = false; // indicates whether a texture belongs to a render target or not
		this.pmremVersion = 0; // indicates whether this texture should be processed by PMREMGenerator or not (only relevant for render target textures)

	}

	get image() {

		return this.source.data;

	}

	set image( value = null ) {

		this.source.data = value;

	}

	updateMatrix() {

		this.matrix.setUvTransform( this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y );

	}

	clone() {

		return new this.constructor().copy( this );

	}

	copy( source ) {

		this.name = source.name;

		this.source = source.source;
		this.mipmaps = source.mipmaps.slice( 0 );

		this.mapping = source.mapping;
		this.channel = source.channel;

		this.wrapS = source.wrapS;
		this.wrapT = source.wrapT;

		this.magFilter = source.magFilter;
		this.minFilter = source.minFilter;

		this.anisotropy = source.anisotropy;

		this.format = source.format;
		this.internalFormat = source.internalFormat;
		this.type = source.type;

		this.offset.copy( source.offset );
		this.repeat.copy( source.repeat );
		this.center.copy( source.center );
		this.rotation = source.rotation;

		this.matrixAutoUpdate = source.matrixAutoUpdate;
		this.matrix.copy( source.matrix );

		this.generateMipmaps = source.generateMipmaps;
		this.premultiplyAlpha = source.premultiplyAlpha;
		this.flipY = source.flipY;
		this.unpackAlignment = source.unpackAlignment;
		this.colorSpace = source.colorSpace;

		this.userData = JSON.parse( JSON.stringify( source.userData ) );

		this.needsUpdate = true;

		return this;

	}

	toJSON( meta ) {

		const isRootObject = ( meta === undefined || typeof meta === 'string' );

		if ( ! isRootObject && meta.textures[ this.uuid ] !== undefined ) {

			return meta.textures[ this.uuid ];

		}

		const output = {

			metadata: {
				version: 4.6,
				type: 'Texture',
				generator: 'Texture.toJSON'
			},

			uuid: this.uuid,
			name: this.name,

			image: this.source.toJSON( meta ).uuid,

			mapping: this.mapping,
			channel: this.channel,

			repeat: [ this.repeat.x, this.repeat.y ],
			offset: [ this.offset.x, this.offset.y ],
			center: [ this.center.x, this.center.y ],
			rotation: this.rotation,

			wrap: [ this.wrapS, this.wrapT ],

			format: this.format,
			internalFormat: this.internalFormat,
			type: this.type,
			colorSpace: this.colorSpace,

			minFilter: this.minFilter,
			magFilter: this.magFilter,
			anisotropy: this.anisotropy,

			flipY: this.flipY,

			generateMipmaps: this.generateMipmaps,
			premultiplyAlpha: this.premultiplyAlpha,
			unpackAlignment: this.unpackAlignment

		};

		if ( Object.keys( this.userData ).length > 0 ) output.userData = this.userData;

		if ( ! isRootObject ) {

			meta.textures[ this.uuid ] = output;

		}

		return output;

	}

	dispose() {

		this.dispatchEvent( { type: 'dispose' } );

	}

	transformUv( uv ) {

		if ( this.mapping !== UVMapping ) return uv;

		uv.applyMatrix3( this.matrix );

		if ( uv.x < 0 || uv.x > 1 ) {

			switch ( this.wrapS ) {

				case RepeatWrapping:

					uv.x = uv.x - Math.floor( uv.x );
					break;

				case ClampToEdgeWrapping:

					uv.x = uv.x < 0 ? 0 : 1;
					break;

				case MirroredRepeatWrapping:

					if ( Math.abs( Math.floor( uv.x ) % 2 ) === 1 ) {

						uv.x = Math.ceil( uv.x ) - uv.x;

					} else {

						uv.x = uv.x - Math.floor( uv.x );

					}

					break;

			}

		}

		if ( uv.y < 0 || uv.y > 1 ) {

			switch ( this.wrapT ) {

				case RepeatWrapping:

					uv.y = uv.y - Math.floor( uv.y );
					break;

				case ClampToEdgeWrapping:

					uv.y = uv.y < 0 ? 0 : 1;
					break;

				case MirroredRepeatWrapping:

					if ( Math.abs( Math.floor( uv.y ) % 2 ) === 1 ) {

						uv.y = Math.ceil( uv.y ) - uv.y;

					} else {

						uv.y = uv.y - Math.floor( uv.y );

					}

					break;

			}

		}

		if ( this.flipY ) {

			uv.y = 1 - uv.y;

		}

		return uv;

	}

	set needsUpdate( value ) {

		if ( value === true ) {

			this.version ++;
			this.source.needsUpdate = true;

		}

	}

	set needsPMREMUpdate( value ) {

		if ( value === true ) {

			this.pmremVersion ++;

		}

	}

}

Texture.DEFAULT_IMAGE = null;
Texture.DEFAULT_MAPPING = UVMapping;
Texture.DEFAULT_ANISOTROPY = 1;

class Vector4 {

	constructor( x = 0, y = 0, z = 0, w = 1 ) {

		Vector4.prototype.isVector4 = true;

		this.x = x;
		this.y = y;
		this.z = z;
		this.w = w;

	}

	get width() {

		return this.z;

	}

	set width( value ) {

		this.z = value;

	}

	get height() {

		return this.w;

	}

	set height( value ) {

		this.w = value;

	}

	set( x, y, z, w ) {

		this.x = x;
		this.y = y;
		this.z = z;
		this.w = w;

		return this;

	}

	setScalar( scalar ) {

		this.x = scalar;
		this.y = scalar;
		this.z = scalar;
		this.w = scalar;

		return this;

	}

	setX( x ) {

		this.x = x;

		return this;

	}

	setY( y ) {

		this.y = y;

		return this;

	}

	setZ( z ) {

		this.z = z;

		return this;

	}

	setW( w ) {

		this.w = w;

		return this;

	}

	setComponent( index, value ) {

		switch ( index ) {

			case 0: this.x = value; break;
			case 1: this.y = value; break;
			case 2: this.z = value; break;
			case 3: this.w = value; break;
			default: throw new Error( 'index is out of range: ' + index );

		}

		return this;

	}

	getComponent( index ) {

		switch ( index ) {

			case 0: return this.x;
			case 1: return this.y;
			case 2: return this.z;
			case 3: return this.w;
			default: throw new Error( 'index is out of range: ' + index );

		}

	}

	clone() {

		return new this.constructor( this.x, this.y, this.z, this.w );

	}

	copy( v ) {

		this.x = v.x;
		this.y = v.y;
		this.z = v.z;
		this.w = ( v.w !== undefined ) ? v.w : 1;

		return this;

	}

	add( v ) {

		this.x += v.x;
		this.y += v.y;
		this.z += v.z;
		this.w += v.w;

		return this;

	}

	addScalar( s ) {

		this.x += s;
		this.y += s;
		this.z += s;
		this.w += s;

		return this;

	}

	addVectors( a, b ) {

		this.x = a.x + b.x;
		this.y = a.y + b.y;
		this.z = a.z + b.z;
		this.w = a.w + b.w;

		return this;

	}

	addScaledVector( v, s ) {

		this.x += v.x * s;
		this.y += v.y * s;
		this.z += v.z * s;
		this.w += v.w * s;

		return this;

	}

	sub( v ) {

		this.x -= v.x;
		this.y -= v.y;
		this.z -= v.z;
		this.w -= v.w;

		return this;

	}

	subScalar( s ) {

		this.x -= s;
		this.y -= s;
		this.z -= s;
		this.w -= s;

		return this;

	}

	subVectors( a, b ) {

		this.x = a.x - b.x;
		this.y = a.y - b.y;
		this.z = a.z - b.z;
		this.w = a.w - b.w;

		return this;

	}

	multiply( v ) {

		this.x *= v.x;
		this.y *= v.y;
		this.z *= v.z;
		this.w *= v.w;

		return this;

	}

	multiplyScalar( scalar ) {

		this.x *= scalar;
		this.y *= scalar;
		this.z *= scalar;
		this.w *= scalar;

		return this;

	}

	applyMatrix4( m ) {

		const x = this.x, y = this.y, z = this.z, w = this.w;
		const e = m.elements;

		this.x = e[ 0 ] * x + e[ 4 ] * y + e[ 8 ] * z + e[ 12 ] * w;
		this.y = e[ 1 ] * x + e[ 5 ] * y + e[ 9 ] * z + e[ 13 ] * w;
		this.z = e[ 2 ] * x + e[ 6 ] * y + e[ 10 ] * z + e[ 14 ] * w;
		this.w = e[ 3 ] * x + e[ 7 ] * y + e[ 11 ] * z + e[ 15 ] * w;

		return this;

	}

	divideScalar( scalar ) {

		return this.multiplyScalar( 1 / scalar );

	}

	setAxisAngleFromQuaternion( q ) {

		// http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm

		// q is assumed to be normalized

		this.w = 2 * Math.acos( q.w );

		const s = Math.sqrt( 1 - q.w * q.w );

		if ( s < 0.0001 ) {

			this.x = 1;
			this.y = 0;
			this.z = 0;

		} else {

			this.x = q.x / s;
			this.y = q.y / s;
			this.z = q.z / s;

		}

		return this;

	}

	setAxisAngleFromRotationMatrix( m ) {

		// http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm

		// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)

		let angle, x, y, z; // variables for result
		const epsilon = 0.01,		// margin to allow for rounding errors
			epsilon2 = 0.1,		// margin to distinguish between 0 and 180 degrees

			te = m.elements,

			m11 = te[ 0 ], m12 = te[ 4 ], m13 = te[ 8 ],
			m21 = te[ 1 ], m22 = te[ 5 ], m23 = te[ 9 ],
			m31 = te[ 2 ], m32 = te[ 6 ], m33 = te[ 10 ];

		if ( ( Math.abs( m12 - m21 ) < epsilon ) &&
		     ( Math.abs( m13 - m31 ) < epsilon ) &&
		     ( Math.abs( m23 - m32 ) < epsilon ) ) {

			// singularity found
			// first check for identity matrix which must have +1 for all terms
			// in leading diagonal and zero in other terms

			if ( ( Math.abs( m12 + m21 ) < epsilon2 ) &&
			     ( Math.abs( m13 + m31 ) < epsilon2 ) &&
			     ( Math.abs( m23 + m32 ) < epsilon2 ) &&
			     ( Math.abs( m11 + m22 + m33 - 3 ) < epsilon2 ) ) {

				// this singularity is identity matrix so angle = 0

				this.set( 1, 0, 0, 0 );

				return this; // zero angle, arbitrary axis

			}

			// otherwise this singularity is angle = 180

			angle = Math.PI;

			const xx = ( m11 + 1 ) / 2;
			const yy = ( m22 + 1 ) / 2;
			const zz = ( m33 + 1 ) / 2;
			const xy = ( m12 + m21 ) / 4;
			const xz = ( m13 + m31 ) / 4;
			const yz = ( m23 + m32 ) / 4;

			if ( ( xx > yy ) && ( xx > zz ) ) {

				// m11 is the largest diagonal term

				if ( xx < epsilon ) {

					x = 0;
					y = 0.707106781;
					z = 0.707106781;

				} else {

					x = Math.sqrt( xx );
					y = xy / x;
					z = xz / x;

				}

			} else if ( yy > zz ) {

				// m22 is the largest diagonal term

				if ( yy < epsilon ) {

					x = 0.707106781;
					y = 0;
					z = 0.707106781;

				} else {

					y = Math.sqrt( yy );
					x = xy / y;
					z = yz / y;

				}

			} else {

				// m33 is the largest diagonal term so base result on this

				if ( zz < epsilon ) {

					x = 0.707106781;
					y = 0.707106781;
					z = 0;

				} else {

					z = Math.sqrt( zz );
					x = xz / z;
					y = yz / z;

				}

			}

			this.set( x, y, z, angle );

			return this; // return 180 deg rotation

		}

		// as we have reached here there are no singularities so we can handle normally

		let s = Math.sqrt( ( m32 - m23 ) * ( m32 - m23 ) +
			( m13 - m31 ) * ( m13 - m31 ) +
			( m21 - m12 ) * ( m21 - m12 ) ); // used to normalize

		if ( Math.abs( s ) < 0.001 ) s = 1;

		// prevent divide by zero, should not happen if matrix is orthogonal and should be
		// caught by singularity test above, but I've left it in just in case

		this.x = ( m32 - m23 ) / s;
		this.y = ( m13 - m31 ) / s;
		this.z = ( m21 - m12 ) / s;
		this.w = Math.acos( ( m11 + m22 + m33 - 1 ) / 2 );

		return this;

	}

	min( v ) {

		this.x = Math.min( this.x, v.x );
		this.y = Math.min( this.y, v.y );
		this.z = Math.min( this.z, v.z );
		this.w = Math.min( this.w, v.w );

		return this;

	}

	max( v ) {

		this.x = Math.max( this.x, v.x );
		this.y = Math.max( this.y, v.y );
		this.z = Math.max( this.z, v.z );
		this.w = Math.max( this.w, v.w );

		return this;

	}

	clamp( min, max ) {

		// assumes min < max, componentwise

		this.x = Math.max( min.x, Math.min( max.x, this.x ) );
		this.y = Math.max( min.y, Math.min( max.y, this.y ) );
		this.z = Math.max( min.z, Math.min( max.z, this.z ) );
		this.w = Math.max( min.w, Math.min( max.w, this.w ) );

		return this;

	}

	clampScalar( minVal, maxVal ) {

		this.x = Math.max( minVal, Math.min( maxVal, this.x ) );
		this.y = Math.max( minVal, Math.min( maxVal, this.y ) );
		this.z = Math.max( minVal, Math.min( maxVal, this.z ) );
		this.w = Math.max( minVal, Math.min( maxVal, this.w ) );

		return this;

	}

	clampLength( min, max ) {

		const length = this.length();

		return this.divideScalar( length || 1 ).multiplyScalar( Math.max( min, Math.min( max, length ) ) );

	}

	floor() {

		this.x = Math.floor( this.x );
		this.y = Math.floor( this.y );
		this.z = Math.floor( this.z );
		this.w = Math.floor( this.w );

		return this;

	}

	ceil() {

		this.x = Math.ceil( this.x );
		this.y = Math.ceil( this.y );
		this.z = Math.ceil( this.z );
		this.w = Math.ceil( this.w );

		return this;

	}

	round() {

		this.x = Math.round( this.x );
		this.y = Math.round( this.y );
		this.z = Math.round( this.z );
		this.w = Math.round( this.w );

		return this;

	}

	roundToZero() {

		this.x = Math.trunc( this.x );
		this.y = Math.trunc( this.y );
		this.z = Math.trunc( this.z );
		this.w = Math.trunc( this.w );

		return this;

	}

	negate() {

		this.x = - this.x;
		this.y = - this.y;
		this.z = - this.z;
		this.w = - this.w;

		return this;

	}

	dot( v ) {

		return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;

	}

	lengthSq() {

		return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;

	}

	length() {

		return Math.sqrt( this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w );

	}

	manhattanLength() {

		return Math.abs( this.x ) + Math.abs( this.y ) + Math.abs( this.z ) + Math.abs( this.w );

	}

	normalize() {

		return this.divideScalar( this.length() || 1 );

	}

	setLength( length ) {

		return this.normalize().multiplyScalar( length );

	}

	lerp( v, alpha ) {

		this.x += ( v.x - this.x ) * alpha;
		this.y += ( v.y - this.y ) * alpha;
		this.z += ( v.z - this.z ) * alpha;
		this.w += ( v.w - this.w ) * alpha;

		return this;

	}

	lerpVectors( v1, v2, alpha ) {

		this.x = v1.x + ( v2.x - v1.x ) * alpha;
		this.y = v1.y + ( v2.y - v1.y ) * alpha;
		this.z = v1.z + ( v2.z - v1.z ) * alpha;
		this.w = v1.w + ( v2.w - v1.w ) * alpha;

		return this;

	}

	equals( v ) {

		return ( ( v.x === this.x ) && ( v.y === this.y ) && ( v.z === this.z ) && ( v.w === this.w ) );

	}

	fromArray( array, offset = 0 ) {

		this.x = array[ offset ];
		this.y = array[ offset + 1 ];
		this.z = array[ offset + 2 ];
		this.w = array[ offset + 3 ];

		return this;

	}

	toArray( array = [], offset = 0 ) {

		array[ offset ] = this.x;
		array[ offset + 1 ] = this.y;
		array[ offset + 2 ] = this.z;
		array[ offset + 3 ] = this.w;

		return array;

	}

	fromBufferAttribute( attribute, index ) {

		this.x = attribute.getX( index );
		this.y = attribute.getY( index );
		this.z = attribute.getZ( index );
		this.w = attribute.getW( index );

		return this;

	}

	random() {

		this.x = Math.random();
		this.y = Math.random();
		this.z = Math.random();
		this.w = Math.random();

		return this;

	}

	*[ Symbol.iterator ]() {

		yield this.x;
		yield this.y;
		yield this.z;
		yield this.w;

	}

}

/*
 In options, we can specify:
 * Texture parameters for an auto-generated target texture
 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
*/
class RenderTarget extends EventDispatcher {

	constructor( width = 1, height = 1, options = {} ) {

		super();

		this.isRenderTarget = true;

		this.width = width;
		this.height = height;
		this.depth = 1;

		this.scissor = new Vector4( 0, 0, width, height );
		this.scissorTest = false;

		this.viewport = new Vector4( 0, 0, width, height );

		const image = { width: width, height: height, depth: 1 };

		options = Object.assign( {
			generateMipmaps: false,
			internalFormat: null,
			minFilter: LinearFilter,
			depthBuffer: true,
			stencilBuffer: false,
			depthTexture: null,
			samples: 0,
			count: 1
		}, options );

		const texture = new Texture( image, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace );

		texture.flipY = false;
		texture.generateMipmaps = options.generateMipmaps;
		texture.internalFormat = options.internalFormat;

		this.textures = [];

		const count = options.count;
		for ( let i = 0; i < count; i ++ ) {

			this.textures[ i ] = texture.clone();
			this.textures[ i ].isRenderTargetTexture = true;

		}

		this.depthBuffer = options.depthBuffer;
		this.stencilBuffer = options.stencilBuffer;

		this.depthTexture = options.depthTexture;

		this.samples = options.samples;

	}

	get texture() {

		return this.textures[ 0 ];

	}

	set texture( value ) {

		this.textures[ 0 ] = value;

	}

	setSize( width, height, depth = 1 ) {

		if ( this.width !== width || this.height !== height || this.depth !== depth ) {

			this.width = width;
			this.height = height;
			this.depth = depth;

			for ( let i = 0, il = this.textures.length; i < il; i ++ ) {

				this.textures[ i ].image.width = width;
				this.textures[ i ].image.height = height;
				this.textures[ i ].image.depth = depth;

			}

			this.dispose();

		}

		this.viewport.set( 0, 0, width, height );
		this.scissor.set( 0, 0, width, height );

	}

	clone() {

		return new this.constructor().copy( this );

	}

	copy( source ) {

		this.width = source.width;
		this.height = source.height;
		this.depth = source.depth;

		this.scissor.copy( source.scissor );
		this.scissorTest = source.scissorTest;

		this.viewport.copy( source.viewport );

		this.textures.length = 0;

		for ( let i = 0, il = source.textures.length; i < il; i ++ ) {

			this.textures[ i ] = source.textures[ i ].clone();
			this.textures[ i ].isRenderTargetTexture = true;

		}

		// ensure image object is not shared, see #20328

		const image = Object.assign( {}, source.texture.image );
		this.texture.source = new Source( image );

		this.depthBuffer = source.depthBuffer;
		this.stencilBuffer = source.stencilBuffer;

		if ( source.depthTexture !== null ) this.depthTexture = source.depthTexture.clone();

		this.samples = source.samples;

		return this;

	}

	dispose() {

		this.dispatchEvent( { type: 'dispose' } );

	}

}

class WebGLRenderTarget extends RenderTarget {

	constructor( width = 1, height = 1, options = {} ) {

		super( width, height, options );

		this.isWebGLRenderTarget = true;

	}

}

class DataArrayTexture extends Texture {

	constructor( data = null, width = 1, height = 1, depth = 1 ) {

		super( null );

		this.isDataArrayTexture = true;

		this.image = { data, width, height, depth };

		this.magFilter = NearestFilter;
		this.minFilter = NearestFilter;

		this.wrapR = ClampToEdgeWrapping;

		this.generateMipmaps = false;
		this.flipY = false;
		this.unpackAlignment = 1;

	}

}

class WebGLArrayRenderTarget extends WebGLRenderTarget {

	constructor( width = 1, height = 1, depth = 1, options = {} ) {

		super( width, height, options );

		this.isWebGLArrayRenderTarget = true;

		this.depth = depth;

		this.texture = new DataArrayTexture( null, width, height, depth );

		this.texture.isRenderTargetTexture = true;

	}

}

class Data3DTexture extends Texture {

	constructor( data = null, width = 1, height = 1, depth = 1 ) {

		// We're going to add .setXXX() methods for setting properties later.
		// Users can still set in DataTexture3D directly.
		//
		//	const texture = new THREE.DataTexture3D( data, width, height, depth );
		// 	texture.anisotropy = 16;
		//
		// See #14839

		super( null );

		this.isData3DTexture = true;

		this.image = { data, width, height, depth };

		this.magFilter = NearestFilter;
		this.minFilter = NearestFilter;

		this.wrapR = ClampToEdgeWrapping;

		this.generateMipmaps = false;
		this.flipY = false;
		this.unpackAlignment = 1;

	}

}

class WebGL3DRenderTarget extends WebGLRenderTarget {

	constructor( width = 1, height = 1, depth = 1, options = {} ) {

		super( width, height, options );

		this.isWebGL3DRenderTarget = true;

		this.depth = depth;

		this.texture = new Data3DTexture( null, width, height, depth );

		this.texture.isRenderTargetTexture = true;

	}

}

class Quaternion {

	constructor( x = 0, y = 0, z = 0, w = 1 ) {

		this.isQuaternion = true;

		this._x = x;
		this._y = y;
		this._z = z;
		this._w = w;

	}

	static slerpFlat( dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t ) {

		// fuzz-free, array-based Quaternion SLERP operation

		let x0 = src0[ srcOffset0 + 0 ],
			y0 = src0[ srcOffset0 + 1 ],
			z0 = src0[ srcOffset0 + 2 ],
			w0 = src0[ srcOffset0 + 3 ];

		const x1 = src1[ srcOffset1 + 0 ],
			y1 = src1[ srcOffset1 + 1 ],
			z1 = src1[ srcOffset1 + 2 ],
			w1 = src1[ srcOffset1 + 3 ];

		if ( t === 0 ) {

			dst[ dstOffset + 0 ] = x0;
			dst[ dstOffset + 1 ] = y0;
			dst[ dstOffset + 2 ] = z0;
			dst[ dstOffset + 3 ] = w0;
			return;

		}

		if ( t === 1 ) {

			dst[ dstOffset + 0 ] = x1;
			dst[ dstOffset + 1 ] = y1;
			dst[ dstOffset + 2 ] = z1;
			dst[ dstOffset + 3 ] = w1;
			return;

		}

		if ( w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1 ) {

			let s = 1 - t;
			const cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1,
				dir = ( cos >= 0 ? 1 : - 1 ),
				sqrSin = 1 - cos * cos;

			// Skip the Slerp for tiny steps to avoid numeric problems:
			if ( sqrSin > Number.EPSILON ) {

				const sin = Math.sqrt( sqrSin ),
					len = Math.atan2( sin, cos * dir );

				s = Math.sin( s * len ) / sin;
				t = Math.sin( t * len ) / sin;

			}

			const tDir = t * dir;

			x0 = x0 * s + x1 * tDir;
			y0 = y0 * s + y1 * tDir;
			z0 = z0 * s + z1 * tDir;
			w0 = w0 * s + w1 * tDir;

			// Normalize in case we just did a lerp:
			if ( s === 1 - t ) {

				const f = 1 / Math.sqrt( x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0 );

				x0 *= f;
				y0 *= f;
				z0 *= f;
				w0 *= f;

			}

		}

		dst[ dstOffset ] = x0;
		dst[ dstOffset + 1 ] = y0;
		dst[ dstOffset + 2 ] = z0;
		dst[ dstOffset + 3 ] = w0;

	}

	static multiplyQuaternionsFlat( dst, dstOffset, src0, srcOffset0, src1, srcOffset1 ) {

		const x0 = src0[ srcOffset0 ];
		const y0 = src0[ srcOffset0 + 1 ];
		const z0 = src0[ srcOffset0 + 2 ];
		const w0 = src0[ srcOffset0 + 3 ];

		const x1 = src1[ srcOffset1 ];
		const y1 = src1[ srcOffset1 + 1 ];
		const z1 = src1[ srcOffset1 + 2 ];
		const w1 = src1[ srcOffset1 + 3 ];

		dst[ dstOffset ] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
		dst[ dstOffset + 1 ] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
		dst[ dstOffset + 2 ] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
		dst[ dstOffset + 3 ] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;

		return dst;

	}

	get x() {

		return this._x;

	}

	set x( value ) {

		this._x = value;
		this._onChangeCallback();

	}

	get y() {

		return this._y;

	}

	set y( value ) {

		this._y = value;
		this._onChangeCallback();

	}

	get z() {

		return this._z;

	}

	set z( value ) {

		this._z = value;
		this._onChangeCallback();

	}

	get w() {

		return this._w;

	}

	set w( value ) {

		this._w = value;
		this._onChangeCallback();

	}

	set( x, y, z, w ) {

		this._x = x;
		this._y = y;
		this._z = z;
		this._w = w;

		this._onChangeCallback();

		return this;

	}

	clone() {

		return new this.constructor( this._x, this._y, this._z, this._w );

	}

	copy( quaternion ) {

		this._x = quaternion.x;
		this._y = quaternion.y;
		this._z = quaternion.z;
		this._w = quaternion.w;

		this._onChangeCallback();

		return this;

	}

	setFromEuler( euler, update = true ) {

		const x = euler._x, y = euler._y, z = euler._z, order = euler._order;

		// http://www.mathworks.com/matlabcentral/fileexchange/
		// 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
		//	content/SpinCalc.m

		const cos = Math.cos;
		const sin = Math.sin;

		const c1 = cos( x / 2 );
		const c2 = cos( y / 2 );
		const c3 = cos( z / 2 );

		const s1 = sin( x / 2 );
		const s2 = sin( y / 2 );
		const s3 = sin( z / 2 );

		switch ( order ) {

			case 'XYZ':
				this._x = s1 * c2 * c3 + c1 * s2 * s3;
				this._y = c1 * s2 * c3 - s1 * c2 * s3;
				this._z = c1 * c2 * s3 + s1 * s2 * c3;
				this._w = c1 * c2 * c3 - s1 * s2 * s3;
				break;

			case 'YXZ':
				this._x = s1 * c2 * c3 + c1 * s2 * s3;
				this._y = c1 * s2 * c3 - s1 * c2 * s3;
				this._z = c1 * c2 * s3 - s1 * s2 * c3;
				this._w = c1 * c2 * c3 + s1 * s2 * s3;
				break;

			case 'ZXY':
				this._x = s1 * c2 * c3 - c1 * s2 * s3;
				this._y = c1 * s2 * c3 + s1 * c2 * s3;
				this._z = c1 * c2 * s3 + s1 * s2 * c3;
				this._w = c1 * c2 * c3 - s1 * s2 * s3;
				break;

			case 'ZYX':
				this._x = s1 * c2 * c3 - c1 * s2 * s3;
				this._y = c1 * s2 * c3 + s1 * c2 * s3;
				this._z = c1 * c2 * s3 - s1 * s2 * c3;
				this._w = c1 * c2 * c3 + s1 * s2 * s3;
				break;

			case 'YZX':
				this._x = s1 * c2 * c3 + c1 * s2 * s3;
				this._y = c1 * s2 * c3 + s1 * c2 * s3;
				this._z = c1 * c2 * s3 - s1 * s2 * c3;
				this._w = c1 * c2 * c3 - s1 * s2 * s3;
				break;

			case 'XZY':
				this._x = s1 * c2 * c3 - c1 * s2 * s3;
				this._y = c1 * s2 * c3 - s1 * c2 * s3;
				this._z = c1 * c2 * s3 + s1 * s2 * c3;
				this._w = c1 * c2 * c3 + s1 * s2 * s3;
				break;

			default:
				console.warn( 'THREE.Quaternion: .setFromEuler() encountered an unknown order: ' + order );

		}

		if ( update === true ) this._onChangeCallback();

		return this;

	}

	setFromAxisAngle( axis, angle ) {

		// http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm

		// assumes axis is normalized

		const halfAngle = angle / 2, s = Math.sin( halfAngle );

		this._x = axis.x * s;
		this._y = axis.y * s;
		this._z = axis.z * s;
		this._w = Math.cos( halfAngle );

		this._onChangeCallback();

		return this;

	}

	setFromRotationMatrix( m ) {

		// http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm

		// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)

		const te = m.elements,

			m11 = te[ 0 ], m12 = te[ 4 ], m13 = te[ 8 ],
			m21 = te[ 1 ], m22 = te[ 5 ], m23 = te[ 9 ],
			m31 = te[ 2 ], m32 = te[ 6 ], m33 = te[ 10 ],

			trace = m11 + m22 + m33;

		if ( trace > 0 ) {

			const s = 0.5 / Math.sqrt( trace + 1.0 );

			this._w = 0.25 / s;
			this._x = ( m32 - m23 ) * s;
			this._y = ( m13 - m31 ) * s;
			this._z = ( m21 - m12 ) * s;

		} else if ( m11 > m22 && m11 > m33 ) {

			const s = 2.0 * Math.sqrt( 1.0 + m11 - m22 - m33 );

			this._w = ( m32 - m23 ) / s;
			this._x = 0.25 * s;
			this._y = ( m12 + m21 ) / s;
			this._z = ( m13 + m31 ) / s;

		} else if ( m22 > m33 ) {

			const s = 2.0 * Math.sqrt( 1.0 + m22 - m11 - m33 );

			this._w = ( m13 - m31 ) / s;
			this._x = ( m12 + m21 ) / s;
			this._y = 0.25 * s;
			this._z = ( m23 + m32 ) / s;

		} else {

			const s = 2.0 * Math.sqrt( 1.0 + m33 - m11 - m22 );

			this._w = ( m21 - m12 ) / s;
			this._x = ( m13 + m31 ) / s;
			this._y = ( m23 + m32 ) / s;
			this._z = 0.25 * s;

		}

		this._onChangeCallback();

		return this;

	}

	setFromUnitVectors( vFrom, vTo ) {

		// assumes direction vectors vFrom and vTo are normalized

		let r = vFrom.dot( vTo ) + 1;

		if ( r < Number.EPSILON ) {

			// vFrom and vTo point in opposite directions

			r = 0;

			if ( Math.abs( vFrom.x ) > Math.abs( vFrom.z ) ) {

				this._x = - vFrom.y;
				this._y = vFrom.x;
				this._z = 0;
				this._w = r;

			} else {

				this._x = 0;
				this._y = - vFrom.z;
				this._z = vFrom.y;
				this._w = r;

			}

		} else {

			// crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3

			this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
			this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
			this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
			this._w = r;

		}

		return this.normalize();

	}

	angleTo( q ) {

		return 2 * Math.acos( Math.abs( clamp( this.dot( q ), - 1, 1 ) ) );

	}

	rotateTowards( q, step ) {

		const angle = this.angleTo( q );

		if ( angle === 0 ) return this;

		const t = Math.min( 1, step / angle );

		this.slerp( q, t );

		return this;

	}

	identity() {

		return this.set( 0, 0, 0, 1 );

	}

	invert() {

		// quaternion is assumed to have unit length

		return this.conjugate();

	}

	conjugate() {

		this._x *= - 1;
		this._y *= - 1;
		this._z *= - 1;

		this._onChangeCallback();

		return this;

	}

	dot( v ) {

		return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;

	}

	lengthSq() {

		return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;

	}

	length() {

		return Math.sqrt( this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w );

	}

	normalize() {

		let l = this.length();

		if ( l === 0 ) {

			this._x = 0;
			this._y = 0;
			this._z = 0;
			this._w = 1;

		} else {

			l = 1 / l;

			this._x = this._x * l;
			this._y = this._y * l;
			this._z = this._z * l;
			this._w = this._w * l;

		}

		this._onChangeCallback();

		return this;

	}

	multiply( q ) {

		return this.multiplyQuaternions( this, q );

	}

	premultiply( q ) {

		return this.multiplyQuaternions( q, this );

	}

	multiplyQuaternions( a, b ) {

		// from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm

		const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
		const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;

		this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
		this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
		this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
		this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;

		this._onChangeCallback();

		return this;

	}

	slerp( qb, t ) {

		if ( t === 0 ) return this;
		if ( t === 1 ) return this.copy( qb );

		const x = this._x, y = this._y, z = this._z, w = this._w;

		// http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/

		let cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;

		if ( cosHalfTheta < 0 ) {

			this._w = - qb._w;
			this._x = - qb._x;
			this._y = - qb._y;
			this._z = - qb._z;

			cosHalfTheta = - cosHalfTheta;

		} else {

			this.copy( qb );

		}

		if ( cosHalfTheta >= 1.0 ) {

			this._w = w;
			this._x = x;
			this._y = y;
			this._z = z;

			return this;

		}

		const sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;

		if ( sqrSinHalfTheta <= Number.EPSILON ) {

			const s = 1 - t;
			this._w = s * w + t * this._w;
			this._x = s * x + t * this._x;
			this._y = s * y + t * this._y;
			this._z = s * z + t * this._z;

			this.normalize(); // normalize calls _onChangeCallback()

			return this;

		}

		const sinHalfTheta = Math.sqrt( sqrSinHalfTheta );
		const halfTheta = Math.atan2( sinHalfTheta, cosHalfTheta );
		const ratioA = Math.sin( ( 1 - t ) * halfTheta ) / sinHalfTheta,
			ratioB = Math.sin( t * halfTheta ) / sinHalfTheta;

		this._w = ( w * ratioA + this._w * ratioB );
		this._x = ( x * ratioA + this._x * ratioB );
		this._y = ( y * ratioA + this._y * ratioB );
		this._z = ( z * ratioA + this._z * ratioB );

		this._onChangeCallback();

		return this;

	}

	slerpQuaternions( qa, qb, t ) {

		return this.copy( qa ).slerp( qb, t );

	}

	random() {

		// sets this quaternion to a uniform random unit quaternnion

		// Ken Shoemake
		// Uniform random rotations
		// D. Kirk, editor, Graphics Gems III, pages 124-132. Academic Press, New York, 1992.

		const theta1 = 2 * Math.PI * Math.random();
		const theta2 = 2 * Math.PI * Math.random();

		const x0 = Math.random();
		const r1 = Math.sqrt( 1 - x0 );
		const r2 = Math.sqrt( x0 );

		return this.set(
			r1 * Math.sin( theta1 ),
			r1 * Math.cos( theta1 ),
			r2 * Math.sin( theta2 ),
			r2 * Math.cos( theta2 ),
		);

	}

	equals( quaternion ) {

		return ( quaternion._x === this._x ) && ( quaternion._y === this._y ) && ( quaternion._z === this._z ) && ( quaternion._w === this._w );

	}

	fromArray( array, offset = 0 ) {

		this._x = array[ offset ];
		this._y = array[ offset + 1 ];
		this._z = array[ offset + 2 ];
		this._w = array[ offset + 3 ];

		this._onChangeCallback();

		return this;

	}

	toArray( array = [], offset = 0 ) {

		array[ offset ] = this._x;
		array[ offset + 1 ] = this._y;
		array[ offset + 2 ] = this._z;
		array[ offset + 3 ] = this._w;

		return array;

	}

	fromBufferAttribute( attribute, index ) {

		this._x = attribute.getX( index );
		this._y = attribute.getY( index );
		this._z = attribute.getZ( index );
		this._w = attribute.getW( index );

		this._onChangeCallback();

		return this;

	}

	toJSON() {

		return this.toArray();

	}

	_onChange( callback ) {

		this._onChangeCallback = callback;

		return this;

	}

	_onChangeCallback() {}

	*[ Symbol.iterator ]() {

		yield this._x;
		yield this._y;
		yield this._z;
		yield this._w;

	}

}

class Vector3 {

	constructor( x = 0, y = 0, z = 0 ) {

		Vector3.prototype.isVector3 = true;

		this.x = x;
		this.y = y;
		this.z = z;

	}

	set( x, y, z ) {

		if ( z === undefined ) z = this.z; // sprite.scale.set(x,y)

		this.x = x;
		this.y = y;
		this.z = z;

		return this;

	}

	setScalar( scalar ) {

		this.x = scalar;
		this.y = scalar;
		this.z = scalar;

		return this;

	}

	setX( x ) {

		this.x = x;

		return this;

	}

	setY( y ) {

		this.y = y;

		return this;

	}

	setZ( z ) {

		this.z = z;

		return this;

	}

	setComponent( index, value ) {

		switch ( index ) {

			case 0: this.x = value; break;
			case 1: this.y = value; break;
			case 2: this.z = value; break;
			default: throw new Error( 'index is out of range: ' + index );

		}

		return this;

	}

	getComponent( index ) {

		switch ( index ) {

			case 0: return this.x;
			case 1: return this.y;
			case 2: return this.z;
			default: throw new Error( 'index is out of range: ' + index );

		}

	}

	clone() {

		return new this.constructor( this.x, this.y, this.z );

	}

	copy( v ) {

		this.x = v.x;
		this.y = v.y;
		this.z = v.z;

		return this;

	}

	add( v ) {

		this.x += v.x;
		this.y += v.y;
		this.z += v.z;

		return this;

	}

	addScalar( s ) {

		this.x += s;
		this.y += s;
		this.z += s;

		return this;

	}

	addVectors( a, b ) {

		this.x = a.x + b.x;
		this.y = a.y + b.y;
		this.z = a.z + b.z;

		return this;

	}

	addScaledVector( v, s ) {

		this.x += v.x * s;
		this.y += v.y * s;
		this.z += v.z * s;

		return this;

	}

	sub( v ) {

		this.x -= v.x;
		this.y -= v.y;
		this.z -= v.z;

		return this;

	}

	subScalar( s ) {

		this.x -= s;
		this.y -= s;
		this.z -= s;

		return this;

	}

	subVectors( a, b ) {

		this.x = a.x - b.x;
		this.y = a.y - b.y;
		this.z = a.z - b.z;

		return this;

	}

	multiply( v ) {

		this.x *= v.x;
		this.y *= v.y;
		this.z *= v.z;

		return this;

	}

	multiplyScalar( scalar ) {

		this.x *= scalar;
		this.y *= scalar;
		this.z *= scalar;

		return this;

	}

	multiplyVectors( a, b ) {

		this.x = a.x * b.x;
		this.y = a.y * b.y;
		this.z = a.z * b.z;

		return this;

	}

	applyEuler( euler ) {

		return this.applyQuaternion( _quaternion$4.setFromEuler( euler ) );

	}

	applyAxisAngle( axis, angle ) {

		return this.applyQuaternion( _quaternion$4.setFromAxisAngle( axis, angle ) );

	}

	applyMatrix3( m ) {

		const x = this.x, y = this.y, z = this.z;
		const e = m.elements;

		this.x = e[ 0 ] * x + e[ 3 ] * y + e[ 6 ] * z;
		this.y = e[ 1 ] * x + e[ 4 ] * y + e[ 7 ] * z;
		this.z = e[ 2 ] * x + e[ 5 ] * y + e[ 8 ] * z;

		return this;

	}

	applyNormalMatrix( m ) {

		return this.applyMatrix3( m ).normalize();

	}

	applyMatrix4( m ) {

		const x = this.x, y = this.y, z = this.z;
		const e = m.elements;

		const w = 1 / ( e[ 3 ] * x + e[ 7 ] * y + e[ 11 ] * z + e[ 15 ] );

		this.x = ( e[ 0 ] * x + e[ 4 ] * y + e[ 8 ] * z + e[ 12 ] ) * w;
		this.y = ( e[ 1 ] * x + e[ 5 ] * y + e[ 9 ] * z + e[ 13 ] ) * w;
		this.z = ( e[ 2 ] * x + e[ 6 ] * y + e[ 10 ] * z + e[ 14 ] ) * w;

		return this;

	}

	applyQuaternion( q ) {

		// quaternion q is assumed to have unit length

		const vx = this.x, vy = this.y, vz = this.z;
		const qx = q.x, qy = q.y, qz = q.z, qw = q.w;

		// t = 2 * cross( q.xyz, v );
		const tx = 2 * ( qy * vz - qz * vy );
		const ty = 2 * ( qz * vx - qx * vz );
		const tz = 2 * ( qx * vy - qy * vx );

		// v + q.w * t + cross( q.xyz, t );
		this.x = vx + qw * tx + qy * tz - qz * ty;
		this.y = vy + qw * ty + qz * tx - qx * tz;
		this.z = vz + qw * tz + qx * ty - qy * tx;

		return this;

	}

	project( camera ) {

		return this.applyMatrix4( camera.matrixWorldInverse ).applyMatrix4( camera.projectionMatrix );

	}

	unproject( camera ) {

		return this.applyMatrix4( camera.projectionMatrixInverse ).applyMatrix4( camera.matrixWorld );

	}

	transformDirection( m ) {

		// input: THREE.Matrix4 affine matrix
		// vector interpreted as a direction

		const x = this.x, y = this.y, z = this.z;
		const e = m.elements;

		this.x = e[ 0 ] * x + e[ 4 ] * y + e[ 8 ] * z;
		this.y = e[ 1 ] * x + e[ 5 ] * y + e[ 9 ] * z;
		this.z = e[ 2 ] * x + e[ 6 ] * y + e[ 10 ] * z;

		return this.normalize();

	}

	divide( v ) {

		this.x /= v.x;
		this.y /= v.y;
		this.z /= v.z;

		return this;

	}

	divideScalar( scalar ) {

		return this.multiplyScalar( 1 / scalar );

	}

	min( v ) {

		this.x = Math.min( this.x, v.x );
		this.y = Math.min( this.y, v.y );
		this.z = Math.min( this.z, v.z );

		return this;

	}

	max( v ) {

		this.x = Math.max( this.x, v.x );
		this.y = Math.max( this.y, v.y );
		this.z = Math.max( this.z, v.z );

		return this;

	}

	clamp( min, max ) {

		// assumes min < max, componentwise

		this.x = Math.max( min.x, Math.min( max.x, this.x ) );
		this.y = Math.max( min.y, Math.min( max.y, this.y ) );
		this.z = Math.max( min.z, Math.min( max.z, this.z ) );

		return this;

	}

	clampScalar( minVal, maxVal ) {

		this.x = Math.max( minVal, Math.min( maxVal, this.x ) );
		this.y = Math.max( minVal, Math.min( maxVal, this.y ) );
		this.z = Math.max( minVal, Math.min( maxVal, this.z ) );

		return this;

	}

	clampLength( min, max ) {

		const length = this.length();

		return this.divideScalar( length || 1 ).multiplyScalar( Math.max( min, Math.min( max, length ) ) );

	}

	floor() {

		this.x = Math.floor( this.x );
		this.y = Math.floor( this.y );
		this.z = Math.floor( this.z );

		return this;

	}

	ceil() {

		this.x = Math.ceil( this.x );
		this.y = Math.ceil( this.y );
		this.z = Math.ceil( this.z );

		return this;

	}

	round() {

		this.x = Math.round( this.x );
		this.y = Math.round( this.y );
		this.z = Math.round( this.z );

		return this;

	}

	roundToZero() {

		this.x = Math.trunc( this.x );
		this.y = Math.trunc( this.y );
		this.z = Math.trunc( this.z );

		return this;

	}

	negate() {

		this.x = - this.x;
		this.y = - this.y;
		this.z = - this.z;

		return this;

	}

	dot( v ) {

		return this.x * v.x + this.y * v.y + this.z * v.z;

	}

	// TODO lengthSquared?

	lengthSq() {

		return this.x * this.x + this.y * this.y + this.z * this.z;

	}

	length() {

		return Math.sqrt( this.x * this.x + this.y * this.y + this.z * this.z );

	}

	manhattanLength() {

		return Math.abs( this.x ) + Math.abs( this.y ) + Math.abs( this.z );

	}

	normalize() {

		return this.divideScalar( this.length() || 1 );

	}

	setLength( length ) {

		return this.normalize().multiplyScalar( length );

	}

	lerp( v, alpha ) {

		this.x += ( v.x - this.x ) * alpha;
		this.y += ( v.y - this.y ) * alpha;
		this.z += ( v.z - this.z ) * alpha;

		return this;

	}

	lerpVectors( v1, v2, alpha ) {

		this.x = v1.x + ( v2.x - v1.x ) * alpha;
		this.y = v1.y + ( v2.y - v1.y ) * alpha;
		this.z = v1.z + ( v2.z - v1.z ) * alpha;

		return this;

	}

	cross( v ) {

		return this.crossVectors( this, v );

	}

	crossVectors( a, b ) {

		const ax = a.x, ay = a.y, az = a.z;
		const bx = b.x, by = b.y, bz = b.z;

		this.x = ay * bz - az * by;
		this.y = az * bx - ax * bz;
		this.z = ax * by - ay * bx;

		return this;

	}

	projectOnVector( v ) {

		const denominator = v.lengthSq();

		if ( denominator === 0 ) return this.set( 0, 0, 0 );

		const scalar = v.dot( this ) / denominator;

		return this.copy( v ).multiplyScalar( scalar );

	}

	projectOnPlane( planeNormal ) {

		_vector$c.copy( this ).projectOnVector( planeNormal );

		return this.sub( _vector$c );

	}

	reflect( normal ) {

		// reflect incident vector off plane orthogonal to normal
		// normal is assumed to have unit length

		return this.sub( _vector$c.copy( normal ).multiplyScalar( 2 * this.dot( normal ) ) );

	}

	angleTo( v ) {

		const denominator = Math.sqrt( this.lengthSq() * v.lengthSq() );

		if ( denominator === 0 ) return Math.PI / 2;

		const theta = this.dot( v ) / denominator;

		// clamp, to handle numerical problems

		return Math.acos( clamp( theta, - 1, 1 ) );

	}

	distanceTo( v ) {

		return Math.sqrt( this.distanceToSquared( v ) );

	}

	distanceToSquared( v ) {

		const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;

		return dx * dx + dy * dy + dz * dz;

	}

	manhattanDistanceTo( v ) {

		return Math.abs( this.x - v.x ) + Math.abs( this.y - v.y ) + Math.abs( this.z - v.z );

	}

	setFromSpherical( s ) {

		return this.setFromSphericalCoords( s.radius, s.phi, s.theta );

	}

	setFromSphericalCoords( radius, phi, theta ) {

		const sinPhiRadius = Math.sin( phi ) * radius;

		this.x = sinPhiRadius * Math.sin( theta );
		this.y = Math.cos( phi ) * radius;
		this.z = sinPhiRadius * Math.cos( theta );

		return this;

	}

	setFromCylindrical( c ) {

		return this.setFromCylindricalCoords( c.radius, c.theta, c.y );

	}

	setFromCylindricalCoords( radius, theta, y ) {

		this.x = radius * Math.sin( theta );
		this.y = y;
		this.z = radius * Math.cos( theta );

		return this;

	}

	setFromMatrixPosition( m ) {

		const e = m.elements;

		this.x = e[ 12 ];
		this.y = e[ 13 ];
		this.z = e[ 14 ];

		return this;

	}

	setFromMatrixScale( m ) {

		const sx = this.setFromMatrixColumn( m, 0 ).length();
		const sy = this.setFromMatrixColumn( m, 1 ).length();
		const sz = this.setFromMatrixColumn( m, 2 ).length();

		this.x = sx;
		this.y = sy;
		this.z = sz;

		return this;

	}

	setFromMatrixColumn( m, index ) {

		return this.fromArray( m.elements, index * 4 );

	}

	setFromMatrix3Column( m, index ) {

		return this.fromArray( m.elements, index * 3 );

	}

	setFromEuler( e ) {

		this.x = e._x;
		this.y = e._y;
		this.z = e._z;

		return this;

	}

	setFromColor( c ) {

		this.x = c.r;
		this.y = c.g;
		this.z = c.b;

		return this;

	}

	equals( v ) {

		return ( ( v.x === this.x ) && ( v.y === this.y ) && ( v.z === this.z ) );

	}

	fromArray( array, offset = 0 ) {

		this.x = array[ offset ];
		this.y = array[ offset + 1 ];
		this.z = array[ offset + 2 ];

		return this;

	}

	toArray( array = [], offset = 0 ) {

		array[ offset ] = this.x;
		array[ offset + 1 ] = this.y;
		array[ offset + 2 ] = this.z;

		return array;

	}

	fromBufferAttribute( attribute, index ) {

		this.x = attribute.getX( index );
		this.y = attribute.getY( index );
		this.z = attribute.getZ( index );

		return this;

	}

	random() {

		this.x = Math.random();
		this.y = Math.random();
		this.z = Math.random();

		return this;

	}

	randomDirection() {

		// https://mathworld.wolfram.com/SpherePointPicking.html

		const theta = Math.random() * Math.PI * 2;
		const u = Math.random() * 2 - 1;
		const c = Math.sqrt( 1 - u * u );

		this.x = c * Math.cos( theta );
		this.y = u;
		this.z = c * Math.sin( theta );

		return this;

	}

	*[ Symbol.iterator ]() {

		yield this.x;
		yield this.y;
		yield this.z;

	}

}

const _vector$c = /*@__PURE__*/ new Vector3();
const _quaternion$4 = /*@__PURE__*/ new Quaternion();

class Box3 {

	constructor( min = new Vector3( + Infinity, + Infinity, + Infinity ), max = new Vector3( - Infinity, - Infinity, - Infinity ) ) {

		this.isBox3 = true;

		this.min = min;
		this.max = max;

	}

	set( min, max ) {

		this.min.copy( min );
		this.max.copy( max );

		return this;

	}

	setFromArray( array ) {

		this.makeEmpty();

		for ( let i = 0, il = array.length; i < il; i += 3 ) {

			this.expandByPoint( _vector$b.fromArray( array, i ) );

		}

		return this;

	}

	setFromBufferAttribute( attribute ) {

		this.makeEmpty();

		for ( let i = 0, il = attribute.count; i < il; i ++ ) {

			this.expandByPoint( _vector$b.fromBufferAttribute( attribute, i ) );

		}

		return this;

	}

	setFromPoints( points ) {

		this.makeEmpty();

		for ( let i = 0, il = points.length; i < il; i ++ ) {

			this.expandByPoint( points[ i ] );

		}

		return this;

	}

	setFromCenterAndSize( center, size ) {

		const halfSize = _vector$b.copy( size ).multiplyScalar( 0.5 );

		this.min.copy( center ).sub( halfSize );
		this.max.copy( center ).add( halfSize );

		return this;

	}

	setFromObject( object, precise = false ) {

		this.makeEmpty();

		return this.expandByObject( object, precise );

	}

	clone() {

		return new this.constructor().copy( this );

	}

	copy( box ) {

		this.min.copy( box.min );
		this.max.copy( box.max );

		return this;

	}

	makeEmpty() {

		this.min.x = this.min.y = this.min.z = + Infinity;
		this.max.x = this.max.y = this.max.z = - Infinity;

		return this;

	}

	isEmpty() {

		// this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes

		return ( this.max.x < this.min.x ) || ( this.max.y < this.min.y ) || ( this.max.z < this.min.z );

	}

	getCenter( target ) {

		return this.isEmpty() ? target.set( 0, 0, 0 ) : target.addVectors( this.min, this.max ).multiplyScalar( 0.5 );

	}

	getSize( target ) {

		return this.isEmpty() ? target.set( 0, 0, 0 ) : target.subVectors( this.max, this.min );

	}

	expandByPoint( point ) {

		this.min.min( point );
		this.max.max( point );

		return this;

	}

	expandByVector( vector ) {

		this.min.sub( vector );
		this.max.add( vector );

		return this;

	}

	expandByScalar( scalar ) {

		this.min.addScalar( - scalar );
		this.max.addScalar( scalar );

		return this;

	}

	expandByObject( object, precise = false ) {

		// Computes the world-axis-aligned bounding box of an object (including its children),
		// accounting for both the object's, and children's, world transforms

		object.updateWorldMatrix( false, false );

		const geometry = object.geometry;

		if ( geometry !== undefined ) {

			const positionAttribute = geometry.getAttribute( 'position' );

			// precise AABB computation based on vertex data requires at least a position attribute.
			// instancing isn't supported so far and uses the normal (conservative) code path.

			if ( precise === true && positionAttribute !== undefined && object.isInstancedMesh !== true ) {

				for ( let i = 0, l = positionAttribute.count; i < l; i ++ ) {

					if ( object.isMesh === true ) {

						object.getVertexPosition( i, _vector$b );

					} else {

						_vector$b.fromBufferAttribute( positionAttribute, i );

					}

					_vector$b.applyMatrix4( object.matrixWorld );
					this.expandByPoint( _vector$b );

				}

			} else {

				if ( object.boundingBox !== undefined ) {

					// object-level bounding box

					if ( object.boundingBox === null ) {

						object.computeBoundingBox();

					}

					_box$4.copy( object.boundingBox );


				} else {

					// geometry-level bounding box

					if ( geometry.boundingBox === null ) {

						geometry.computeBoundingBox();

					}

					_box$4.copy( geometry.boundingBox );

				}

				_box$4.applyMatrix4( object.matrixWorld );

				this.union( _box$4 );

			}

		}

		const children = object.children;

		for ( let i = 0, l = children.length; i < l; i ++ ) {

			this.expandByObject( children[ i ], precise );

		}

		return this;

	}

	containsPoint( point ) {

		return point.x < this.min.x || point.x > this.max.x ||
			point.y < this.min.y || point.y > this.max.y ||
			point.z < this.min.z || point.z > this.max.z ? false : true;

	}

	containsBox( box ) {

		return this.min.x <= box.min.x && box.max.x <= this.max.x &&
			this.min.y <= box.min.y && box.max.y <= this.max.y &&
			this.min.z <= box.min.z && box.max.z <= this.max.z;

	}

	getParameter( point, target ) {

		// This can potentially have a divide by zero if the box
		// has a size dimension of 0.

		return target.set(
			( point.x - this.min.x ) / ( this.max.x - this.min.x ),
			( point.y - this.min.y ) / ( this.max.y - this.min.y ),
			( point.z - this.min.z ) / ( this.max.z - this.min.z )
		);

	}

	intersectsBox( box ) {

		// using 6 splitting planes to rule out intersections.
		return box.max.x < this.min.x || box.min.x > this.max.x ||
			box.max.y < this.min.y || box.min.y > this.max.y ||
			box.max.z < this.min.z || box.min.z > this.max.z ? false : true;

	}

	intersectsSphere( sphere ) {

		// Find the point on the AABB closest to the sphere center.
		this.clampPoint( sphere.center, _vector$b );

		// If that point is inside the sphere, the AABB and sphere intersect.
		return _vector$b.distanceToSquared( sphere.center ) <= ( sphere.radius * sphere.radius );

	}

	intersectsPlane( plane ) {

		// We compute the minimum and maximum dot product values. If those values
		// are on the same side (back or front) of the plane, then there is no intersection.

		let min, max;

		if ( plane.normal.x > 0 ) {

			min = plane.normal.x * this.min.x;
			max = plane.normal.x * this.max.x;

		} else {

			min = plane.normal.x * this.max.x;
			max = plane.normal.x * this.min.x;

		}

		if ( plane.normal.y > 0 ) {

			min += plane.normal.y * this.min.y;
			max += plane.normal.y * this.max.y;

		} else {

			min += plane.normal.y * this.max.y;
			max += plane.normal.y * this.min.y;

		}

		if ( plane.normal.z > 0 ) {

			min += plane.normal.z * this.min.z;
			max += plane.normal.z * this.max.z;

		} else {

			min += plane.normal.z * this.max.z;
			max += plane.normal.z * this.min.z;

		}

		return ( min <= - plane.constant && max >= - plane.constant );

	}

	intersectsTriangle( triangle ) {

		if ( this.isEmpty() ) {

			return false;

		}

		// compute box center and extents
		this.getCenter( _center );
		_extents.subVectors( this.max, _center );

		// translate triangle to aabb origin
		_v0$2.subVectors( triangle.a, _center );
		_v1$7.subVectors( triangle.b, _center );
		_v2$4.subVectors( triangle.c, _center );

		// compute edge vectors for triangle
		_f0.subVectors( _v1$7, _v0$2 );
		_f1.subVectors( _v2$4, _v1$7 );
		_f2.subVectors( _v0$2, _v2$4 );

		// test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
		// make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
		// axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
		let axes = [
			0, - _f0.z, _f0.y, 0, - _f1.z, _f1.y, 0, - _f2.z, _f2.y,
			_f0.z, 0, - _f0.x, _f1.z, 0, - _f1.x, _f2.z, 0, - _f2.x,
			- _f0.y, _f0.x, 0, - _f1.y, _f1.x, 0, - _f2.y, _f2.x, 0
		];
		if ( ! satForAxes( axes, _v0$2, _v1$7, _v2$4, _extents ) ) {

			return false;

		}

		// test 3 face normals from the aabb
		axes = [ 1, 0, 0, 0, 1, 0, 0, 0, 1 ];
		if ( ! satForAxes( axes, _v0$2, _v1$7, _v2$4, _extents ) ) {

			return false;

		}

		// finally testing the face normal of the triangle
		// use already existing triangle edge vectors here
		_triangleNormal.crossVectors( _f0, _f1 );
		axes = [ _triangleNormal.x, _triangleNormal.y, _triangleNormal.z ];

		return satForAxes( axes, _v0$2, _v1$7, _v2$4, _extents );

	}

	clampPoint( point, target ) {

		return target.copy( point ).clamp( this.min, this.max );

	}

	distanceToPoint( point ) {

		return this.clampPoint( point, _vector$b ).distanceTo( point );

	}

	getBoundingSphere( target ) {

		if ( this.isEmpty() ) {

			target.makeEmpty();

		} else {

			this.getCenter( target.center );

			target.radius = this.getSize( _vector$b ).length() * 0.5;

		}

		return target;

	}

	intersect( box ) {

		this.min.max( box.min );
		this.max.min( box.max );

		// ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
		if ( this.isEmpty() ) this.makeEmpty();

		return this;

	}

	union( box ) {

		this.min.min( box.min );
		this.max.max( box.max );

		return this;

	}

	applyMatrix4( matrix ) {

		// transform of empty box is an empty box.
		if ( this.isEmpty() ) return this;

		// NOTE: I am using a binary pattern to specify all 2^3 combinations below
		_points[ 0 ].set( this.min.x, this.min.y, this.min.z ).applyMatrix4( matrix ); // 000
		_points[ 1 ].set( this.min.x, this.min.y, this.max.z ).applyMatrix4( matrix ); // 001
		_points[ 2 ].set( this.min.x, this.max.y, this.min.z ).applyMatrix4( matrix ); // 010
		_points[ 3 ].set( this.min.x, this.max.y, this.max.z ).applyMatrix4( matrix ); // 011
		_points[ 4 ].set( this.max.x, this.min.y, this.min.z ).applyMatrix4( matrix ); // 100
		_points[ 5 ].set( this.max.x, this.min.y, this.max.z ).applyMatrix4( matrix ); // 101
		_points[ 6 ].set( this.max.x, this.max.y, this.min.z ).applyMatrix4( matrix ); // 110
		_points[ 7 ].set( this.max.x, this.max.y, this.max.z ).applyMatrix4( matrix ); // 111

		this.setFromPoints( _points );

		return this;

	}

	translate( offset ) {

		this.min.add( offset );
		this.max.add( offset );

		return this;

	}

	equals( box ) {

		return box.min.equals( this.min ) && box.max.equals( this.max );

	}

}

const _points = [
	/*@__PURE__*/ new Vector3(),
	/*@__PURE__*/ new Vector3(),
	/*@__PURE__*/ new Vector3(),
	/*@__PURE__*/ new Vector3(),
	/*@__PURE__*/ new Vector3(),
	/*@__PURE__*/ new Vector3(),
	/*@__PURE__*/ new Vector3(),
	/*@__PURE__*/ new Vector3()
];

const _vector$b = /*@__PURE__*/ new Vector3();

const _box$4 = /*@__PURE__*/ new Box3();

// triangle centered vertices

const _v0$2 = /*@__PURE__*/ new Vector3();
const _v1$7 = /*@__PURE__*/ new Vector3();
const _v2$4 = /*@__PURE__*/ new Vector3();

// triangle edge vectors

const _f0 = /*@__PURE__*/ new Vector3();
const _f1 = /*@__PURE__*/ new Vector3();
const _f2 = /*@__PURE__*/ new Vector3();

const _center = /*@__PURE__*/ new Vector3();
const _extents = /*@__PURE__*/ new Vector3();
const _triangleNormal = /*@__PURE__*/ new Vector3();
const _testAxis = /*@__PURE__*/ new Vector3();

function satForAxes( axes, v0, v1, v2, extents ) {

	for ( let i = 0, j = axes.length - 3; i <= j; i += 3 ) {

		_testAxis.fromArray( axes, i );
		// project the aabb onto the separating axis
		const r = extents.x * Math.abs( _testAxis.x ) + extents.y * Math.abs( _testAxis.y ) + extents.z * Math.abs( _testAxis.z );
		// project all 3 vertices of the triangle onto the separating axis
		const p0 = v0.dot( _testAxis );
		const p1 = v1.dot( _testAxis );
		const p2 = v2.dot( _testAxis );
		// actual test, basically see if either of the most extreme of the triangle points intersects r
		if ( Math.max( - Math.max( p0, p1, p2 ), Math.min( p0, p1, p2 ) ) > r ) {

			// points of the projected triangle are outside the projected half-length of the aabb
			// the axis is separating and we can exit
			return false;

		}

	}

	return true;

}

const _box$3 = /*@__PURE__*/ new Box3();
const _v1$6 = /*@__PURE__*/ new Vector3();
const _v2$3 = /*@__PURE__*/ new Vector3();

class Sphere {

	constructor( center = new Vector3(), radius = - 1 ) {

		this.isSphere = true;

		this.center = center;
		this.radius = radius;

	}

	set( center, radius ) {

		this.center.copy( center );
		this.radius = radius;

		return this;

	}

	setFromPoints( points, optionalCenter ) {

		const center = this.center;

		if ( optionalCenter !== undefined ) {

			center.copy( optionalCenter );

		} else {

			_box$3.setFromPoints( points ).getCenter( center );

		}

		let maxRadiusSq = 0;

		for ( let i = 0, il = points.length; i < il; i ++ ) {

			maxRadiusSq = Math.max( maxRadiusSq, center.distanceToSquared( points[ i ] ) );

		}

		this.radius = Math.sqrt( maxRadiusSq );

		return this;

	}

	copy( sphere ) {

		this.center.copy( sphere.center );
		this.radius = sphere.radius;

		return this;

	}

	isEmpty() {

		return ( this.radius < 0 );

	}

	makeEmpty() {

		this.center.set( 0, 0, 0 );
		this.radius = - 1;

		return this;

	}

	containsPoint( point ) {

		return ( point.distanceToSquared( this.center ) <= ( this.radius * this.radius ) );

	}

	distanceToPoint( point ) {

		return ( point.distanceTo( this.center ) - this.radius );

	}

	intersectsSphere( sphere ) {

		const radiusSum = this.radius + sphere.radius;

		return sphere.center.distanceToSquared( this.center ) <= ( radiusSum * radiusSum );

	}

	intersectsBox( box ) {

		return box.intersectsSphere( this );

	}

	intersectsPlane( plane ) {

		return Math.abs( plane.distanceToPoint( this.center ) ) <= this.radius;

	}

	clampPoint( point, target ) {

		const deltaLengthSq = this.center.distanceToSquared( point );

		target.copy( point );

		if ( deltaLengthSq > ( this.radius * this.radius ) ) {

			target.sub( this.center ).normalize();
			target.multiplyScalar( this.radius ).add( this.center );

		}

		return target;

	}

	getBoundingBox( target ) {

		if ( this.isEmpty() ) {

			// Empty sphere produces empty bounding box
			target.makeEmpty();
			return target;

		}

		target.set( this.center, this.center );
		target.expandByScalar( this.radius );

		return target;

	}

	applyMatrix4( matrix ) {

		this.center.applyMatrix4( matrix );
		this.radius = this.radius * matrix.getMaxScaleOnAxis();

		return this;

	}

	translate( offset ) {

		this.center.add( offset );

		return this;

	}

	expandByPoint( point ) {

		if ( this.isEmpty() ) {

			this.center.copy( point );

			this.radius = 0;

			return this;

		}

		_v1$6.subVectors( point, this.center );

		const lengthSq = _v1$6.lengthSq();

		if ( lengthSq > ( this.radius * this.radius ) ) {

			// calculate the minimal sphere

			const length = Math.sqrt( lengthSq );

			const delta = ( length - this.radius ) * 0.5;

			this.center.addScaledVector( _v1$6, delta / length );

			this.radius += delta;

		}

		return this;

	}

	union( sphere ) {

		if ( sphere.isEmpty() ) {

			return this;

		}

		if ( this.isEmpty() ) {

			this.copy( sphere );

			return this;

		}

		if ( this.center.equals( sphere.center ) === true ) {

			 this.radius = Math.max( this.radius, sphere.radius );

		} else {

			_v2$3.subVectors( sphere.center, this.center ).setLength( sphere.radius );

			this.expandByPoint( _v1$6.copy( sphere.center ).add( _v2$3 ) );

			this.expandByPoint( _v1$6.copy( sphere.center ).sub( _v2$3 ) );

		}

		return this;

	}

	equals( sphere ) {

		return sphere.center.equals( this.center ) && ( sphere.radius === this.radius );

	}

	clone() {

		return new this.constructor().copy( this );

	}

}

const _vector$a = /*@__PURE__*/ new Vector3();
const _segCenter = /*@__PURE__*/ new Vector3();
const _segDir = /*@__PURE__*/ new Vector3();
const _diff = /*@__PURE__*/ new Vector3();

const _edge1 = /*@__PURE__*/ new Vector3();
const _edge2 = /*@__PURE__*/ new Vector3();
const _normal$1 = /*@__PURE__*/ new Vector3();

class Ray {

	constructor( origin = new Vector3(), direction = new Vector3( 0, 0, - 1 ) ) {

		this.origin = origin;
		this.direction = direction;

	}

	set( origin, direction ) {

		this.origin.copy( origin );
		this.direction.copy( direction );

		return this;

	}

	copy( ray ) {

		this.origin.copy( ray.origin );
		this.direction.copy( ray.direction );

		return this;

	}

	at( t, target ) {

		return target.copy( this.origin ).addScaledVector( this.direction, t );

	}

	lookAt( v ) {

		this.direction.copy( v ).sub( this.origin ).normalize();

		return this;

	}

	recast( t ) {

		this.origin.copy( this.at( t, _vector$a ) );

		return this;

	}

	closestPointToPoint( point, target ) {

		target.subVectors( point, this.origin );

		const directionDistance = target.dot( this.direction );

		if ( directionDistance < 0 ) {

			return target.copy( this.origin );

		}

		return target.copy( this.origin ).addScaledVector( this.direction, directionDistance );

	}

	distanceToPoint( point ) {

		return Math.sqrt( this.distanceSqToPoint( point ) );

	}

	distanceSqToPoint( point ) {

		const directionDistance = _vector$a.subVectors( point, this.origin ).dot( this.direction );

		// point behind the ray

		if ( directionDistance < 0 ) {

			return this.origin.distanceToSquared( point );

		}

		_vector$a.copy( this.origin ).addScaledVector( this.direction, directionDistance );

		return _vector$a.distanceToSquared( point );

	}

	distanceSqToSegment( v0, v1, optionalPointOnRay, optionalPointOnSegment ) {

		// from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteDistRaySegment.h
		// It returns the min distance between the ray and the segment
		// defined by v0 and v1
		// It can also set two optional targets :
		// - The closest point on the ray
		// - The closest point on the segment

		_segCenter.copy( v0 ).add( v1 ).multiplyScalar( 0.5 );
		_segDir.copy( v1 ).sub( v0 ).normalize();
		_diff.copy( this.origin ).sub( _segCenter );

		const segExtent = v0.distanceTo( v1 ) * 0.5;
		const a01 = - this.direction.dot( _segDir );
		const b0 = _diff.dot( this.direction );
		const b1 = - _diff.dot( _segDir );
		const c = _diff.lengthSq();
		const det = Math.abs( 1 - a01 * a01 );
		let s0, s1, sqrDist, extDet;

		if ( det > 0 ) {

			// The ray and segment are not parallel.

			s0 = a01 * b1 - b0;
			s1 = a01 * b0 - b1;
			extDet = segExtent * det;

			if ( s0 >= 0 ) {

				if ( s1 >= - extDet ) {

					if ( s1 <= extDet ) {

						// region 0
						// Minimum at interior points of ray and segment.

						const invDet = 1 / det;
						s0 *= invDet;
						s1 *= invDet;
						sqrDist = s0 * ( s0 + a01 * s1 + 2 * b0 ) + s1 * ( a01 * s0 + s1 + 2 * b1 ) + c;

					} else {

						// region 1

						s1 = segExtent;
						s0 = Math.max( 0, - ( a01 * s1 + b0 ) );
						sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

					}

				} else {

					// region 5

					s1 = - segExtent;
					s0 = Math.max( 0, - ( a01 * s1 + b0 ) );
					sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

				}

			} else {

				if ( s1 <= - extDet ) {

					// region 4

					s0 = Math.max( 0, - ( - a01 * segExtent + b0 ) );
					s1 = ( s0 > 0 ) ? - segExtent : Math.min( Math.max( - segExtent, - b1 ), segExtent );
					sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

				} else if ( s1 <= extDet ) {

					// region 3

					s0 = 0;
					s1 = Math.min( Math.max( - segExtent, - b1 ), segExtent );
					sqrDist = s1 * ( s1 + 2 * b1 ) + c;

				} else {

					// region 2

					s0 = Math.max( 0, - ( a01 * segExtent + b0 ) );
					s1 = ( s0 > 0 ) ? segExtent : Math.min( Math.max( - segExtent, - b1 ), segExtent );
					sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

				}

			}

		} else {

			// Ray and segment are parallel.

			s1 = ( a01 > 0 ) ? - segExtent : segExtent;
			s0 = Math.max( 0, - ( a01 * s1 + b0 ) );
			sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

		}

		if ( optionalPointOnRay ) {

			optionalPointOnRay.copy( this.origin ).addScaledVector( this.direction, s0 );

		}

		if ( optionalPointOnSegment ) {

			optionalPointOnSegment.copy( _segCenter ).addScaledVector( _segDir, s1 );

		}

		return sqrDist;

	}

	intersectSphere( sphere, target ) {

		_vector$a.subVectors( sphere.center, this.origin );
		const tca = _vector$a.dot( this.direction );
		const d2 = _vector$a.dot( _vector$a ) - tca * tca;
		const radius2 = sphere.radius * sphere.radius;

		if ( d2 > radius2 ) return null;

		const thc = Math.sqrt( radius2 - d2 );

		// t0 = first intersect point - entrance on front of sphere
		const t0 = tca - thc;

		// t1 = second intersect point - exit point on back of sphere
		const t1 = tca + thc;

		// test to see if t1 is behind the ray - if so, return null
		if ( t1 < 0 ) return null;

		// test to see if t0 is behind the ray:
		// if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
		// in order to always return an intersect point that is in front of the ray.
		if ( t0 < 0 ) return this.at( t1, target );

		// else t0 is in front of the ray, so return the first collision point scaled by t0
		return this.at( t0, target );

	}

	intersectsSphere( sphere ) {

		return this.distanceSqToPoint( sphere.center ) <= ( sphere.radius * sphere.radius );

	}

	distanceToPlane( plane ) {

		const denominator = plane.normal.dot( this.direction );

		if ( denominator === 0 ) {

			// line is coplanar, return origin
			if ( plane.distanceToPoint( this.origin ) === 0 ) {

				return 0;

			}

			// Null is preferable to undefined since undefined means.... it is undefined

			return null;

		}

		const t = - ( this.origin.dot( plane.normal ) + plane.constant ) / denominator;

		// Return if the ray never intersects the plane

		return t >= 0 ? t : null;

	}

	intersectPlane( plane, target ) {

		const t = this.distanceToPlane( plane );

		if ( t === null ) {

			return null;

		}

		return this.at( t, target );

	}

	intersectsPlane( plane ) {

		// check if the ray lies on the plane first

		const distToPoint = plane.distanceToPoint( this.origin );

		if ( distToPoint === 0 ) {

			return true;

		}

		const denominator = plane.normal.dot( this.direction );

		if ( denominator * distToPoint < 0 ) {

			return true;

		}

		// ray origin is behind the plane (and is pointing behind it)

		return false;

	}

	intersectBox( box, target ) {

		let tmin, tmax, tymin, tymax, tzmin, tzmax;

		const invdirx = 1 / this.direction.x,
			invdiry = 1 / this.direction.y,
			invdirz = 1 / this.direction.z;

		const origin = this.origin;

		if ( invdirx >= 0 ) {

			tmin = ( box.min.x - origin.x ) * invdirx;
			tmax = ( box.max.x - origin.x ) * invdirx;

		} else {

			tmin = ( box.max.x - origin.x ) * invdirx;
			tmax = ( box.min.x - origin.x ) * invdirx;

		}

		if ( invdiry >= 0 ) {

			tymin = ( box.min.y - origin.y ) * invdiry;
			tymax = ( box.max.y - origin.y ) * invdiry;

		} else {

			tymin = ( box.max.y - origin.y ) * invdiry;
			tymax = ( box.min.y - origin.y ) * invdiry;

		}

		if ( ( tmin > tymax ) || ( tymin > tmax ) ) return null;

		if ( tymin > tmin || isNaN( tmin ) ) tmin = tymin;

		if ( tymax < tmax || isNaN( tmax ) ) tmax = tymax;

		if ( invdirz >= 0 ) {

			tzmin = ( box.min.z - origin.z ) * invdirz;
			tzmax = ( box.max.z - origin.z ) * invdirz;

		} else {

			tzmin = ( box.max.z - origin.z ) * invdirz;
			tzmax = ( box.min.z - origin.z ) * invdirz;

		}

		if ( ( tmin > tzmax ) || ( tzmin > tmax ) ) return null;

		if ( tzmin > tmin || tmin !== tmin ) tmin = tzmin;

		if ( tzmax < tmax || tmax !== tmax ) tmax = tzmax;

		//return point closest to the ray (positive side)

		if ( tmax < 0 ) return null;

		return this.at( tmin >= 0 ? tmin : tmax, target );

	}

	intersectsBox( box ) {

		return this.intersectBox( box, _vector$a ) !== null;

	}

	intersectTriangle( a, b, c, backfaceCulling, target ) {

		// Compute the offset origin, edges, and normal.

		// from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h

		_edge1.subVectors( b, a );
		_edge2.subVectors( c, a );
		_normal$1.crossVectors( _edge1, _edge2 );

		// Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
		// E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
		//   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
		//   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
		//   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
		let DdN = this.direction.dot( _normal$1 );
		let sign;

		if ( DdN > 0 ) {

			if ( backfaceCulling ) return null;
			sign = 1;

		} else if ( DdN < 0 ) {

			sign = - 1;
			DdN = - DdN;

		} else {

			return null;

		}

		_diff.subVectors( this.origin, a );
		const DdQxE2 = sign * this.direction.dot( _edge2.crossVectors( _diff, _edge2 ) );

		// b1 < 0, no intersection
		if ( DdQxE2 < 0 ) {

			return null;

		}

		const DdE1xQ = sign * this.direction.dot( _edge1.cross( _diff ) );

		// b2 < 0, no intersection
		if ( DdE1xQ < 0 ) {

			return null;

		}

		// b1+b2 > 1, no intersection
		if ( DdQxE2 + DdE1xQ > DdN ) {

			return null;

		}

		// Line intersects triangle, check if ray does.
		const QdN = - sign * _diff.dot( _normal$1 );

		// t < 0, no intersection
		if ( QdN < 0 ) {

			return null;

		}

		// Ray intersects triangle.
		return this.at( QdN / DdN, target );

	}

	applyMatrix4( matrix4 ) {

		this.origin.applyMatrix4( matrix4 );
		this.direction.transformDirection( matrix4 );

		return this;

	}

	equals( ray ) {

		return ray.origin.equals( this.origin ) && ray.direction.equals( this.direction );

	}

	clone() {

		return new this.constructor().copy( this );

	}

}

class Matrix4 {

	constructor( n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44 ) {

		Matrix4.prototype.isMatrix4 = true;

		this.elements = [

			1, 0, 0, 0,
			0, 1, 0, 0,
			0, 0, 1, 0,
			0, 0, 0, 1

		];

		if ( n11 !== undefined ) {

			this.set( n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44 );

		}

	}

	set( n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44 ) {

		const te = this.elements;

		te[ 0 ] = n11; te[ 4 ] = n12; te[ 8 ] = n13; te[ 12 ] = n14;
		te[ 1 ] = n21; te[ 5 ] = n22; te[ 9 ] = n23; te[ 13 ] = n24;
		te[ 2 ] = n31; te[ 6 ] = n32; te[ 10 ] = n33; te[ 14 ] = n34;
		te[ 3 ] = n41; te[ 7 ] = n42; te[ 11 ] = n43; te[ 15 ] = n44;

		return this;

	}

	identity() {

		this.set(

			1, 0, 0, 0,
			0, 1, 0, 0,
			0, 0, 1, 0,
			0, 0, 0, 1

		);

		return this;

	}

	clone() {

		return new Matrix4().fromArray( this.elements );

	}

	copy( m ) {

		const te = this.elements;
		const me = m.elements;

		te[ 0 ] = me[ 0 ]; te[ 1 ] = me[ 1 ]; te[ 2 ] = me[ 2 ]; te[ 3 ] = me[ 3 ];
		te[ 4 ] = me[ 4 ]; te[ 5 ] = me[ 5 ]; te[ 6 ] = me[ 6 ]; te[ 7 ] = me[ 7 ];
		te[ 8 ] = me[ 8 ]; te[ 9 ] = me[ 9 ]; te[ 10 ] = me[ 10 ]; te[ 11 ] = me[ 11 ];
		te[ 12 ] = me[ 12 ]; te[ 13 ] = me[ 13 ]; te[ 14 ] = me[ 14 ]; te[ 15 ] = me[ 15 ];

		return this;

	}

	copyPosition( m ) {

		const te = this.elements, me = m.elements;

		te[ 12 ] = me[ 12 ];
		te[ 13 ] = me[ 13 ];
		te[ 14 ] = me[ 14 ];

		return this;

	}

	setFromMatrix3( m ) {

		const me = m.elements;

		this.set(

			me[ 0 ], me[ 3 ], me[ 6 ], 0,
			me[ 1 ], me[ 4 ], me[ 7 ], 0,
			me[ 2 ], me[ 5 ], me[ 8 ], 0,
			0, 0, 0, 1

		);

		return this;

	}

	extractBasis( xAxis, yAxis, zAxis ) {

		xAxis.setFromMatrixColumn( this, 0 );
		yAxis.setFromMatrixColumn( this, 1 );
		zAxis.setFromMatrixColumn( this, 2 );

		return this;

	}

	makeBasis( xAxis, yAxis, zAxis ) {

		this.set(
			xAxis.x, yAxis.x, zAxis.x, 0,
			xAxis.y, yAxis.y, zAxis.y, 0,
			xAxis.z, yAxis.z, zAxis.z, 0,
			0, 0, 0, 1
		);

		return this;

	}

	extractRotation( m ) {

		// this method does not support reflection matrices

		const te = this.elements;
		const me = m.elements;

		const scaleX = 1 / _v1$5.setFromMatrixColumn( m, 0 ).length();
		const scaleY = 1 / _v1$5.setFromMatrixColumn( m, 1 ).length();
		const scaleZ = 1 / _v1$5.setFromMatrixColumn( m, 2 ).length();

		te[ 0 ] = me[ 0 ] * scaleX;
		te[ 1 ] = me[ 1 ] * scaleX;
		te[ 2 ] = me[ 2 ] * scaleX;
		te[ 3 ] = 0;

		te[ 4 ] = me[ 4 ] * scaleY;
		te[ 5 ] = me[ 5 ] * scaleY;
		te[ 6 ] = me[ 6 ] * scaleY;
		te[ 7 ] = 0;

		te[ 8 ] = me[ 8 ] * scaleZ;
		te[ 9 ] = me[ 9 ] * scaleZ;
		te[ 10 ] = me[ 10 ] * scaleZ;
		te[ 11 ] = 0;

		te[ 12 ] = 0;
		te[ 13 ] = 0;
		te[ 14 ] = 0;
		te[ 15 ] = 1;

		return this;

	}

	makeRotationFromEuler( euler ) {

		const te = this.elements;

		const x = euler.x, y = euler.y, z = euler.z;
		const a = Math.cos( x ), b = Math.sin( x );
		const c = Math.cos( y ), d = Math.sin( y );
		const e = Math.cos( z ), f = Math.sin( z );

		if ( euler.order === 'XYZ' ) {

			const ae = a * e, af = a * f, be = b * e, bf = b * f;

			te[ 0 ] = c * e;
			te[ 4 ] = - c * f;
			te[ 8 ] = d;

			te[ 1 ] = af + be * d;
			te[ 5 ] = ae - bf * d;
			te[ 9 ] = - b * c;

			te[ 2 ] = bf - ae * d;
			te[ 6 ] = be + af * d;
			te[ 10 ] = a * c;

		} else if ( euler.order === 'YXZ' ) {

			const ce = c * e, cf = c * f, de = d * e, df = d * f;

			te[ 0 ] = ce + df * b;
			te[ 4 ] = de * b - cf;
			te[ 8 ] = a * d;

			te[ 1 ] = a * f;
			te[ 5 ] = a * e;
			te[ 9 ] = - b;

			te[ 2 ] = cf * b - de;
			te[ 6 ] = df + ce * b;
			te[ 10 ] = a * c;

		} else if ( euler.order === 'ZXY' ) {

			const ce = c * e, cf = c * f, de = d * e, df = d * f;

			te[ 0 ] = ce - df * b;
			te[ 4 ] = - a * f;
			te[ 8 ] = de + cf * b;

			te[ 1 ] = cf + de * b;
			te[ 5 ] = a * e;
			te[ 9 ] = df - ce * b;

			te[ 2 ] = - a * d;
			te[ 6 ] = b;
			te[ 10 ] = a * c;

		} else if ( euler.order === 'ZYX' ) {

			const ae = a * e, af = a * f, be = b * e, bf = b * f;

			te[ 0 ] = c * e;
			te[ 4 ] = be * d - af;
			te[ 8 ] = ae * d + bf;

			te[ 1 ] = c * f;
			te[ 5 ] = bf * d + ae;
			te[ 9 ] = af * d - be;

			te[ 2 ] = - d;
			te[ 6 ] = b * c;
			te[ 10 ] = a * c;

		} else if ( euler.order === 'YZX' ) {

			const ac = a * c, ad = a * d, bc = b * c, bd = b * d;

			te[ 0 ] = c * e;
			te[ 4 ] = bd - ac * f;
			te[ 8 ] = bc * f + ad;

			te[ 1 ] = f;
			te[ 5 ] = a * e;
			te[ 9 ] = - b * e;

			te[ 2 ] = - d * e;
			te[ 6 ] = ad * f + bc;
			te[ 10 ] = ac - bd * f;

		} else if ( euler.order === 'XZY' ) {

			const ac = a * c, ad = a * d, bc = b * c, bd = b * d;

			te[ 0 ] = c * e;
			te[ 4 ] = - f;
			te[ 8 ] = d * e;

			te[ 1 ] = ac * f + bd;
			te[ 5 ] = a * e;
			te[ 9 ] = ad * f - bc;

			te[ 2 ] = bc * f - ad;
			te[ 6 ] = b * e;
			te[ 10 ] = bd * f + ac;

		}

		// bottom row
		te[ 3 ] = 0;
		te[ 7 ] = 0;
		te[ 11 ] = 0;

		// last column
		te[ 12 ] = 0;
		te[ 13 ] = 0;
		te[ 14 ] = 0;
		te[ 15 ] = 1;

		return this;

	}

	makeRotationFromQuaternion( q ) {

		return this.compose( _zero, q, _one );

	}

	lookAt( eye, target, up ) {

		const te = this.elements;

		_z.subVectors( eye, target );

		if ( _z.lengthSq() === 0 ) {

			// eye and target are in the same position

			_z.z = 1;

		}

		_z.normalize();
		_x.crossVectors( up, _z );

		if ( _x.lengthSq() === 0 ) {

			// up and z are parallel

			if ( Math.abs( up.z ) === 1 ) {

				_z.x += 0.0001;

			} else {

				_z.z += 0.0001;

			}

			_z.normalize();
			_x.crossVectors( up, _z );

		}

		_x.normalize();
		_y.crossVectors( _z, _x );

		te[ 0 ] = _x.x; te[ 4 ] = _y.x; te[ 8 ] = _z.x;
		te[ 1 ] = _x.y; te[ 5 ] = _y.y; te[ 9 ] = _z.y;
		te[ 2 ] = _x.z; te[ 6 ] = _y.z; te[ 10 ] = _z.z;

		return this;

	}

	multiply( m ) {

		return this.multiplyMatrices( this, m );

	}

	premultiply( m ) {

		return this.multiplyMatrices( m, this );

	}

	multiplyMatrices( a, b ) {

		const ae = a.elements;
		const be = b.elements;
		const te = this.elements;

		const a11 = ae[ 0 ], a12 = ae[ 4 ], a13 = ae[ 8 ], a14 = ae[ 12 ];
		const a21 = ae[ 1 ], a22 = ae[ 5 ], a23 = ae[ 9 ], a24 = ae[ 13 ];
		const a31 = ae[ 2 ], a32 = ae[ 6 ], a33 = ae[ 10 ], a34 = ae[ 14 ];
		const a41 = ae[ 3 ], a42 = ae[ 7 ], a43 = ae[ 11 ], a44 = ae[ 15 ];

		const b11 = be[ 0 ], b12 = be[ 4 ], b13 = be[ 8 ], b14 = be[ 12 ];
		const b21 = be[ 1 ], b22 = be[ 5 ], b23 = be[ 9 ], b24 = be[ 13 ];
		const b31 = be[ 2 ], b32 = be[ 6 ], b33 = be[ 10 ], b34 = be[ 14 ];
		const b41 = be[ 3 ], b42 = be[ 7 ], b43 = be[ 11 ], b44 = be[ 15 ];

		te[ 0 ] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
		te[ 4 ] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
		te[ 8 ] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
		te[ 12 ] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;

		te[ 1 ] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
		te[ 5 ] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
		te[ 9 ] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
		te[ 13 ] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;

		te[ 2 ] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
		te[ 6 ] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
		te[ 10 ] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
		te[ 14 ] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;

		te[ 3 ] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
		te[ 7 ] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
		te[ 11 ] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
		te[ 15 ] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;

		return this;

	}

	multiplyScalar( s ) {

		const te = this.elements;

		te[ 0 ] *= s; te[ 4 ] *= s; te[ 8 ] *= s; te[ 12 ] *= s;
		te[ 1 ] *= s; te[ 5 ] *= s; te[ 9 ] *= s; te[ 13 ] *= s;
		te[ 2 ] *= s; te[ 6 ] *= s; te[ 10 ] *= s; te[ 14 ] *= s;
		te[ 3 ] *= s; te[ 7 ] *= s; te[ 11 ] *= s; te[ 15 ] *= s;

		return this;

	}

	determinant() {

		const te = this.elements;

		const n11 = te[ 0 ], n12 = te[ 4 ], n13 = te[ 8 ], n14 = te[ 12 ];
		const n21 = te[ 1 ], n22 = te[ 5 ], n23 = te[ 9 ], n24 = te[ 13 ];
		const n31 = te[ 2 ], n32 = te[ 6 ], n33 = te[ 10 ], n34 = te[ 14 ];
		const n41 = te[ 3 ], n42 = te[ 7 ], n43 = te[ 11 ], n44 = te[ 15 ];

		//TODO: make this more efficient
		//( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )

		return (
			n41 * (
				+ n14 * n23 * n32
				 - n13 * n24 * n32
				 - n14 * n22 * n33
				 + n12 * n24 * n33
				 + n13 * n22 * n34
				 - n12 * n23 * n34
			) +
			n42 * (
				+ n11 * n23 * n34
				 - n11 * n24 * n33
				 + n14 * n21 * n33
				 - n13 * n21 * n34
				 + n13 * n24 * n31
				 - n14 * n23 * n31
			) +
			n43 * (
				+ n11 * n24 * n32
				 - n11 * n22 * n34
				 - n14 * n21 * n32
				 + n12 * n21 * n34
				 + n14 * n22 * n31
				 - n12 * n24 * n31
			) +
			n44 * (
				- n13 * n22 * n31
				 - n11 * n23 * n32
				 + n11 * n22 * n33
				 + n13 * n21 * n32
				 - n12 * n21 * n33
				 + n12 * n23 * n31
			)

		);

	}

	transpose() {

		const te = this.elements;
		let tmp;

		tmp = te[ 1 ]; te[ 1 ] = te[ 4 ]; te[ 4 ] = tmp;
		tmp = te[ 2 ]; te[ 2 ] = te[ 8 ]; te[ 8 ] = tmp;
		tmp = te[ 6 ]; te[ 6 ] = te[ 9 ]; te[ 9 ] = tmp;

		tmp = te[ 3 ]; te[ 3 ] = te[ 12 ]; te[ 12 ] = tmp;
		tmp = te[ 7 ]; te[ 7 ] = te[ 13 ]; te[ 13 ] = tmp;
		tmp = te[ 11 ]; te[ 11 ] = te[ 14 ]; te[ 14 ] = tmp;

		return this;

	}

	setPosition( x, y, z ) {

		const te = this.elements;

		if ( x.isVector3 ) {

			te[ 12 ] = x.x;
			te[ 13 ] = x.y;
			te[ 14 ] = x.z;

		} else {

			te[ 12 ] = x;
			te[ 13 ] = y;
			te[ 14 ] = z;

		}

		return this;

	}

	invert() {

		// based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
		const te = this.elements,

			n11 = te[ 0 ], n21 = te[ 1 ], n31 = te[ 2 ], n41 = te[ 3 ],
			n12 = te[ 4 ], n22 = te[ 5 ], n32 = te[ 6 ], n42 = te[ 7 ],
			n13 = te[ 8 ], n23 = te[ 9 ], n33 = te[ 10 ], n43 = te[ 11 ],
			n14 = te[ 12 ], n24 = te[ 13 ], n34 = te[ 14 ], n44 = te[ 15 ],

			t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44,
			t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44,
			t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44,
			t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;

		const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;

		if ( det === 0 ) return this.set( 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 );

		const detInv = 1 / det;

		te[ 0 ] = t11 * detInv;
		te[ 1 ] = ( n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44 ) * detInv;
		te[ 2 ] = ( n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44 ) * detInv;
		te[ 3 ] = ( n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43 ) * detInv;

		te[ 4 ] = t12 * detInv;
		te[ 5 ] = ( n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44 ) * detInv;
		te[ 6 ] = ( n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44 ) * detInv;
		te[ 7 ] = ( n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43 ) * detInv;

		te[ 8 ] = t13 * detInv;
		te[ 9 ] = ( n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44 ) * detInv;
		te[ 10 ] = ( n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44 ) * detInv;
		te[ 11 ] = ( n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43 ) * detInv;

		te[ 12 ] = t14 * detInv;
		te[ 13 ] = ( n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34 ) * detInv;
		te[ 14 ] = ( n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34 ) * detInv;
		te[ 15 ] = ( n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33 ) * detInv;

		return this;

	}

	scale( v ) {

		const te = this.elements;
		const x = v.x, y = v.y, z = v.z;

		te[ 0 ] *= x; te[ 4 ] *= y; te[ 8 ] *= z;
		te[ 1 ] *= x; te[ 5 ] *= y; te[ 9 ] *= z;
		te[ 2 ] *= x; te[ 6 ] *= y; te[ 10 ] *= z;
		te[ 3 ] *= x; te[ 7 ] *= y; te[ 11 ] *= z;

		return this;

	}

	getMaxScaleOnAxis() {

		const te = this.elements;

		const scaleXSq = te[ 0 ] * te[ 0 ] + te[ 1 ] * te[ 1 ] + te[ 2 ] * te[ 2 ];
		const scaleYSq = te[ 4 ] * te[ 4 ] + te[ 5 ] * te[ 5 ] + te[ 6 ] * te[ 6 ];
		const scaleZSq = te[ 8 ] * te[ 8 ] + te[ 9 ] * te[ 9 ] + te[ 10 ] * te[ 10 ];

		return Math.sqrt( Math.max( scaleXSq, scaleYSq, scaleZSq ) );

	}

	makeTranslation( x, y, z ) {

		if ( x.isVector3 ) {

			this.set(

				1, 0, 0, x.x,
				0, 1, 0, x.y,
				0, 0, 1, x.z,
				0, 0, 0, 1

			);

		} else {

			this.set(

				1, 0, 0, x,
				0, 1, 0, y,
				0, 0, 1, z,
				0, 0, 0, 1

			);

		}

		return this;

	}

	makeRotationX( theta ) {

		const c = Math.cos( theta ), s = Math.sin( theta );

		this.set(

			1, 0, 0, 0,
			0, c, - s, 0,
			0, s, c, 0,
			0, 0, 0, 1

		);

		return this;

	}

	makeRotationY( theta ) {

		const c = Math.cos( theta ), s = Math.sin( theta );

		this.set(

			 c, 0, s, 0,
			 0, 1, 0, 0,
			- s, 0, c, 0,
			 0, 0, 0, 1

		);

		return this;

	}

	makeRotationZ( theta ) {

		const c = Math.cos( theta ), s = Math.sin( theta );

		this.set(

			c, - s, 0, 0,
			s, c, 0, 0,
			0, 0, 1, 0,
			0, 0, 0, 1

		);

		return this;

	}

	makeRotationAxis( axis, angle ) {

		// Based on http://www.gamedev.net/reference/articles/article1199.asp

		const c = Math.cos( angle );
		const s = Math.sin( angle );
		const t = 1 - c;
		const x = axis.x, y = axis.y, z = axis.z;
		const tx = t * x, ty = t * y;

		this.set(

			tx * x + c, tx * y - s * z, tx * z + s * y, 0,
			tx * y + s * z, ty * y + c, ty * z - s * x, 0,
			tx * z - s * y, ty * z + s * x, t * z * z + c, 0,
			0, 0, 0, 1

		);

		return this;

	}

	makeScale( x, y, z ) {

		this.set(

			x, 0, 0, 0,
			0, y, 0, 0,
			0, 0, z, 0,
			0, 0, 0, 1

		);

		return this;

	}

	makeShear( xy, xz, yx, yz, zx, zy ) {

		this.set(

			1, yx, zx, 0,
			xy, 1, zy, 0,
			xz, yz, 1, 0,
			0, 0, 0, 1

		);

		return this;

	}

	compose( position, quaternion, scale ) {

		const te = this.elements;

		const x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
		const x2 = x + x,	y2 = y + y, z2 = z + z;
		const xx = x * x2, xy = x * y2, xz = x * z2;
		const yy = y * y2, yz = y * z2, zz = z * z2;
		const wx = w * x2, wy = w * y2, wz = w * z2;

		const sx = scale.x, sy = scale.y, sz = scale.z;

		te[ 0 ] = ( 1 - ( yy + zz ) ) * sx;
		te[ 1 ] = ( xy + wz ) * sx;
		te[ 2 ] = ( xz - wy ) * sx;
		te[ 3 ] = 0;

		te[ 4 ] = ( xy - wz ) * sy;
		te[ 5 ] = ( 1 - ( xx + zz ) ) * sy;
		te[ 6 ] = ( yz + wx ) * sy;
		te[ 7 ] = 0;

		te[ 8 ] = ( xz + wy ) * sz;
		te[ 9 ] = ( yz - wx ) * sz;
		te[ 10 ] = ( 1 - ( xx + yy ) ) * sz;
		te[ 11 ] = 0;

		te[ 12 ] = position.x;
		te[ 13 ] = position.y;
		te[ 14 ] = position.z;
		te[ 15 ] = 1;

		return this;

	}

	decompose( position, quaternion, scale ) {

		const te = this.elements;

		let sx = _v1$5.set( te[ 0 ], te[ 1 ], te[ 2 ] ).length();
		const sy = _v1$5.set( te[ 4 ], te[ 5 ], te[ 6 ] ).length();
		const sz = _v1$5.set( te[ 8 ], te[ 9 ], te[ 10 ] ).length();

		// if determine is negative, we need to invert one scale
		const det = this.determinant();
		if ( det < 0 ) sx = - sx;

		position.x = te[ 12 ];
		position.y = te[ 13 ];
		position.z = te[ 14 ];

		// scale the rotation part
		_m1$4.copy( this );

		const invSX = 1 / sx;
		const invSY = 1 / sy;
		const invSZ = 1 / sz;

		_m1$4.elements[ 0 ] *= invSX;
		_m1$4.elements[ 1 ] *= invSX;
		_m1$4.elements[ 2 ] *= invSX;

		_m1$4.elements[ 4 ] *= invSY;
		_m1$4.elements[ 5 ] *= invSY;
		_m1$4.elements[ 6 ] *= invSY;

		_m1$4.elements[ 8 ] *= invSZ;
		_m1$4.elements[ 9 ] *= invSZ;
		_m1$4.elements[ 10 ] *= invSZ;

		quaternion.setFromRotationMatrix( _m1$4 );

		scale.x = sx;
		scale.y = sy;
		scale.z = sz;

		return this;

	}

	makePerspective( left, right, top, bottom, near, far, coordinateSystem = WebGLCoordinateSystem ) {

		const te = this.elements;
		const x = 2 * near / ( right - left );
		const y = 2 * near / ( top - bottom );

		const a = ( right + left ) / ( right - left );
		const b = ( top + bottom ) / ( top - bottom );

		let c, d;

		if ( coordinateSystem === WebGLCoordinateSystem ) {

			c = - ( far + near ) / ( far - near );
			d = ( - 2 * far * near ) / ( far - near );

		} else if ( coordinateSystem === WebGPUCoordinateSystem ) {

			c = - far / ( far - near );
			d = ( - far * near ) / ( far - near );

		} else {

			throw new Error( 'THREE.Matrix4.makePerspective(): Invalid coordinate system: ' + coordinateSystem );

		}

		te[ 0 ] = x;	te[ 4 ] = 0;	te[ 8 ] = a; 	te[ 12 ] = 0;
		te[ 1 ] = 0;	te[ 5 ] = y;	te[ 9 ] = b; 	te[ 13 ] = 0;
		te[ 2 ] = 0;	te[ 6 ] = 0;	te[ 10 ] = c; 	te[ 14 ] = d;
		te[ 3 ] = 0;	te[ 7 ] = 0;	te[ 11 ] = - 1;	te[ 15 ] = 0;

		return this;

	}

	makeOrthographic( left, right, top, bottom, near, far, coordinateSystem = WebGLCoordinateSystem ) {

		const te = this.elements;
		const w = 1.0 / ( right - left );
		const h = 1.0 / ( top - bottom );
		const p = 1.0 / ( far - near );

		const x = ( right + left ) * w;
		const y = ( top + bottom ) * h;

		let z, zInv;

		if ( coordinateSystem === WebGLCoordinateSystem ) {

			z = ( far + near ) * p;
			zInv = - 2 * p;

		} else if ( coordinateSystem === WebGPUCoordinateSystem ) {

			z = near * p;
			zInv = - 1 * p;

		} else {

			throw new Error( 'THREE.Matrix4.makeOrthographic(): Invalid coordinate system: ' + coordinateSystem );

		}

		te[ 0 ] = 2 * w;	te[ 4 ] = 0;		te[ 8 ] = 0; 		te[ 12 ] = - x;
		te[ 1 ] = 0; 		te[ 5 ] = 2 * h;	te[ 9 ] = 0; 		te[ 13 ] = - y;
		te[ 2 ] = 0; 		te[ 6 ] = 0;		te[ 10 ] = zInv;	te[ 14 ] = - z;
		te[ 3 ] = 0; 		te[ 7 ] = 0;		te[ 11 ] = 0;		te[ 15 ] = 1;

		return this;

	}

	equals( matrix ) {

		const te = this.elements;
		const me = matrix.elements;

		for ( let i = 0; i < 16; i ++ ) {

			if ( te[ i ] !== me[ i ] ) return false;

		}

		return true;

	}

	fromArray( array, offset = 0 ) {

		for ( let i = 0; i < 16; i ++ ) {

			this.elements[ i ] = array[ i + offset ];

		}

		return this;

	}

	toArray( array = [], offset = 0 ) {

		const te = this.elements;

		array[ offset ] = te[ 0 ];
		array[ offset + 1 ] = te[ 1 ];
		array[ offset + 2 ] = te[ 2 ];
		array[ offset + 3 ] = te[ 3 ];

		array[ offset + 4 ] = te[ 4 ];
		array[ offset + 5 ] = te[ 5 ];
		array[ offset + 6 ] = te[ 6 ];
		array[ offset + 7 ] = te[ 7 ];

		array[ offset + 8 ] = te[ 8 ];
		array[ offset + 9 ] = te[ 9 ];
		array[ offset + 10 ] = te[ 10 ];
		array[ offset + 11 ] = te[ 11 ];

		array[ offset + 12 ] = te[ 12 ];
		array[ offset + 13 ] = te[ 13 ];
		array[ offset + 14 ] = te[ 14 ];
		array[ offset + 15 ] = te[ 15 ];

		return array;

	}

}

const _v1$5 = /*@__PURE__*/ new Vector3();
const _m1$4 = /*@__PURE__*/ new Matrix4();
const _zero = /*@__PURE__*/ new Vector3( 0, 0, 0 );
const _one = /*@__PURE__*/ new Vector3( 1, 1, 1 );
const _x = /*@__PURE__*/ new Vector3();
const _y = /*@__PURE__*/ new Vector3();
const _z = /*@__PURE__*/ new Vector3();

const _matrix$2 = /*@__PURE__*/ new Matrix4();
const _quaternion$3 = /*@__PURE__*/ new Quaternion();

class Euler {

	constructor( x = 0, y = 0, z = 0, order = Euler.DEFAULT_ORDER ) {

		this.isEuler = true;

		this._x = x;
		this._y = y;
		this._z = z;
		this._order = order;

	}

	get x() {

		return this._x;

	}

	set x( value ) {

		this._x = value;
		this._onChangeCallback();

	}

	get y() {

		return this._y;

	}

	set y( value ) {

		this._y = value;
		this._onChangeCallback();

	}

	get z() {

		return this._z;

	}

	set z( value ) {

		this._z = value;
		this._onChangeCallback();

	}

	get order() {

		return this._order;

	}

	set order( value ) {

		this._order = value;
		this._onChangeCallback();

	}

	set( x, y, z, order = this._order ) {

		this._x = x;
		this._y = y;
		this._z = z;
		this._order = order;

		this._onChangeCallback();

		return this;

	}

	clone() {

		return new this.constructor( this._x, this._y, this._z, this._order );

	}

	copy( euler ) {

		this._x = euler._x;
		this._y = euler._y;
		this._z = euler._z;
		this._order = euler._order;

		this._onChangeCallback();

		return this;

	}

	setFromRotationMatrix( m, order = this._order, update = true ) {

		// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)

		const te = m.elements;
		const m11 = te[ 0 ], m12 = te[ 4 ], m13 = te[ 8 ];
		const m21 = te[ 1 ], m22 = te[ 5 ], m23 = te[ 9 ];
		const m31 = te[ 2 ], m32 = te[ 6 ], m33 = te[ 10 ];

		switch ( order ) {

			case 'XYZ':

				this._y = Math.asin( clamp( m13, - 1, 1 ) );

				if ( Math.abs( m13 ) < 0.9999999 ) {

					this._x = Math.atan2( - m23, m33 );
					this._z = Math.atan2( - m12, m11 );

				} else {

					this._x = Math.atan2( m32, m22 );
					this._z = 0;

				}

				break;

			case 'YXZ':

				this._x = Math.asin( - clamp( m23, - 1, 1 ) );

				if ( Math.abs( m23 ) < 0.9999999 ) {

					this._y = Math.atan2( m13, m33 );
					this._z = Math.atan2( m21, m22 );

				} else {

					this._y = Math.atan2( - m31, m11 );
					this._z = 0;

				}

				break;

			case 'ZXY':

				this._x = Math.asin( clamp( m32, - 1, 1 ) );

				if ( Math.abs( m32 ) < 0.9999999 ) {

					this._y = Math.atan2( - m31, m33 );
					this._z = Math.atan2( - m12, m22 );

				} else {

					this._y = 0;
					this._z = Math.atan2( m21, m11 );

				}

				break;

			case 'ZYX':

				this._y = Math.asin( - clamp( m31, - 1, 1 ) );

				if ( Math.abs( m31 ) < 0.9999999 ) {

					this._x = Math.atan2( m32, m33 );
					this._z = Math.atan2( m21, m11 );

				} else {

					this._x = 0;
					this._z = Math.atan2( - m12, m22 );

				}

				break;

			case 'YZX':

				this._z = Math.asin( clamp( m21, - 1, 1 ) );

				if ( Math.abs( m21 ) < 0.9999999 ) {

					this._x = Math.atan2( - m23, m22 );
					this._y = Math.atan2( - m31, m11 );

				} else {

					this._x = 0;
					this._y = Math.atan2( m13, m33 );

				}

				break;

			case 'XZY':

				this._z = Math.asin( - clamp( m12, - 1, 1 ) );

				if ( Math.abs( m12 ) < 0.9999999 ) {

					this._x = Math.atan2( m32, m22 );
					this._y = Math.atan2( m13, m11 );

				} else {

					this._x = Math.atan2( - m23, m33 );
					this._y = 0;

				}

				break;

			default:

				console.warn( 'THREE.Euler: .setFromRotationMatrix() encountered an unknown order: ' + order );

		}

		this._order = order;

		if ( update === true ) this._onChangeCallback();

		return this;

	}

	setFromQuaternion( q, order, update ) {

		_matrix$2.makeRotationFromQuaternion( q );

		return this.setFromRotationMatrix( _matrix$2, order, update );

	}

	setFromVector3( v, order = this._order ) {

		return this.set( v.x, v.y, v.z, order );

	}

	reorder( newOrder ) {

		// WARNING: this discards revolution information -bhouston

		_quaternion$3.setFromEuler( this );

		return this.setFromQuaternion( _quaternion$3, newOrder );

	}

	equals( euler ) {

		return ( euler._x === this._x ) && ( euler._y === this._y ) && ( euler._z === this._z ) && ( euler._order === this._order );

	}

	fromArray( array ) {

		this._x = array[ 0 ];
		this._y = array[ 1 ];
		this._z = array[ 2 ];
		if ( array[ 3 ] !== undefined ) this._order = array[ 3 ];

		this._onChangeCallback();

		return this;

	}

	toArray( array = [], offset = 0 ) {

		array[ offset ] = this._x;
		array[ offset + 1 ] = this._y;
		array[ offset + 2 ] = this._z;
		array[ offset + 3 ] = this._order;

		return array;

	}

	_onChange( callback ) {

		this._onChangeCallback = callback;

		return this;

	}

	_onChangeCallback() {}

	*[ Symbol.iterator ]() {

		yield this._x;
		yield this._y;
		yield this._z;
		yield this._order;

	}

}

Euler.DEFAULT_ORDER = 'XYZ';

class Layers {

	constructor() {

		this.mask = 1 | 0;

	}

	set( channel ) {

		this.mask = ( 1 << channel | 0 ) >>> 0;

	}

	enable( channel ) {

		this.mask |= 1 << channel | 0;

	}

	enableAll() {

		this.mask = 0xffffffff | 0;

	}

	toggle( channel ) {

		this.mask ^= 1 << channel | 0;

	}

	disable( channel ) {

		this.mask &= ~ ( 1 << channel | 0 );

	}

	disableAll() {

		this.mask = 0;

	}

	test( layers ) {

		return ( this.mask & layers.mask ) !== 0;

	}

	isEnabled( channel ) {

		return ( this.mask & ( 1 << channel | 0 ) ) !== 0;

	}

}

let _object3DId = 0;

const _v1$4 = /*@__PURE__*/ new Vector3();
const _q1 = /*@__PURE__*/ new Quaternion();
const _m1$3 = /*@__PURE__*/ new Matrix4();
const _target = /*@__PURE__*/ new Vector3();

const _position$3 = /*@__PURE__*/ new Vector3();
const _scale$2 = /*@__PURE__*/ new Vector3();
const _quaternion$2 = /*@__PURE__*/ new Quaternion();

const _xAxis = /*@__PURE__*/ new Vector3( 1, 0, 0 );
const _yAxis = /*@__PURE__*/ new Vector3( 0, 1, 0 );
const _zAxis = /*@__PURE__*/ new Vector3( 0, 0, 1 );

const _addedEvent = { type: 'added' };
const _removedEvent = { type: 'removed' };

const _childaddedEvent = { type: 'childadded', child: null };
const _childremovedEvent = { type: 'childremoved', child: null };

class Object3D extends EventDispatcher {

	constructor() {

		super();

		this.isObject3D = true;

		Object.defineProperty( this, 'id', { value: _object3DId ++ } );

		this.uuid = generateUUID();

		this.name = '';
		this.type = 'Object3D';

		this.parent = null;
		this.children = [];

		this.up = Object3D.DEFAULT_UP.clone();

		const position = new Vector3();
		const rotation = new Euler();
		const quaternion = new Quaternion();
		const scale = new Vector3( 1, 1, 1 );

		function onRotationChange() {

			quaternion.setFromEuler( rotation, false );

		}

		function onQuaternionChange() {

			rotation.setFromQuaternion( quaternion, undefined, false );

		}

		rotation._onChange( onRotationChange );
		quaternion._onChange( onQuaternionChange );

		Object.defineProperties( this, {
			position: {
				configurable: true,
				enumerable: true,
				value: position
			},
			rotation: {
				configurable: true,
				enumerable: true,
				value: rotation
			},
			quaternion: {
				configurable: true,
				enumerable: true,
				value: quaternion
			},
			scale: {
				configurable: true,
				enumerable: true,
				value: scale
			},
			modelViewMatrix: {
				value: new Matrix4()
			},
			normalMatrix: {
				value: new Matrix3()
			}
		} );

		this.matrix = new Matrix4();
		this.matrixWorld = new Matrix4();

		this.matrixAutoUpdate = Object3D.DEFAULT_MATRIX_AUTO_UPDATE;

		this.matrixWorldAutoUpdate = Object3D.DEFAULT_MATRIX_WORLD_AUTO_UPDATE; // checked by the renderer
		this.matrixWorldNeedsUpdate = false;

		this.layers = new Layers();
		this.visible = true;

		this.castShadow = false;
		this.receiveShadow = false;

		this.frustumCulled = true;
		this.renderOrder = 0;

		this.animations = [];

		this.userData = {};

	}

	onBeforeShadow( /* renderer, object, camera, shadowCamera, geometry, depthMaterial, group */ ) {}

	onAfterShadow( /* renderer, object, camera, shadowCamera, geometry, depthMaterial, group */ ) {}

	onBeforeRender( /* renderer, scene, camera, geometry, material, group */ ) {}

	onAfterRender( /* renderer, scene, camera, geometry, material, group */ ) {}

	applyMatrix4( matrix ) {

		if ( this.matrixAutoUpdate ) this.updateMatrix();

		this.matrix.premultiply( matrix );

		this.matrix.decompose( this.position, this.quaternion, this.scale );

	}

	applyQuaternion( q ) {

		this.quaternion.premultiply( q );

		return this;

	}

	setRotationFromAxisAngle( axis, angle ) {

		// assumes axis is normalized

		this.quaternion.setFromAxisAngle( axis, angle );

	}

	setRotationFromEuler( euler ) {

		this.quaternion.setFromEuler( euler, true );

	}

	setRotationFromMatrix( m ) {

		// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)

		this.quaternion.setFromRotationMatrix( m );

	}

	setRotationFromQuaternion( q ) {

		// assumes q is normalized

		this.quaternion.copy( q );

	}

	rotateOnAxis( axis, angle ) {

		// rotate object on axis in object space
		// axis is assumed to be normalized

		_q1.setFromAxisAngle( axis, angle );

		this.quaternion.multiply( _q1 );

		return this;

	}

	rotateOnWorldAxis( axis, angle ) {

		// rotate object on axis in world space
		// axis is assumed to be normalized
		// method assumes no rotated parent

		_q1.setFromAxisAngle( axis, angle );

		this.quaternion.premultiply( _q1 );

		return this;

	}

	rotateX( angle ) {

		return this.rotateOnAxis( _xAxis, angle );

	}

	rotateY( angle ) {

		return this.rotateOnAxis( _yAxis, angle );

	}

	rotateZ( angle ) {

		return this.rotateOnAxis( _zAxis, angle );

	}

	translateOnAxis( axis, distance ) {

		// translate object by distance along axis in object space
		// axis is assumed to be normalized

		_v1$4.copy( axis ).applyQuaternion( this.quaternion );

		this.position.add( _v1$4.multiplyScalar( distance ) );

		return this;

	}

	translateX( distance ) {

		return this.translateOnAxis( _xAxis, distance );

	}

	translateY( distance ) {

		return this.translateOnAxis( _yAxis, distance );

	}

	translateZ( distance ) {

		return this.translateOnAxis( _zAxis, distance );

	}

	localToWorld( vector ) {

		this.updateWorldMatrix( true, false );

		return vector.applyMatrix4( this.matrixWorld );

	}

	worldToLocal( vector ) {

		this.updateWorldMatrix( true, false );

		return vector.applyMatrix4( _m1$3.copy( this.matrixWorld ).invert() );

	}

	lookAt( x, y, z ) {

		// This method does not support objects having non-uniformly-scaled parent(s)

		if ( x.isVector3 ) {

			_target.copy( x );

		} else {

			_target.set( x, y, z );

		}

		const parent = this.parent;

		this.updateWorldMatrix( true, false );

		_position$3.setFromMatrixPosition( this.matrixWorld );

		if ( this.isCamera || this.isLight ) {

			_m1$3.lookAt( _position$3, _target, this.up );

		} else {

			_m1$3.lookAt( _target, _position$3, this.up );

		}

		this.quaternion.setFromRotationMatrix( _m1$3 );

		if ( parent ) {

			_m1$3.extractRotation( parent.matrixWorld );
			_q1.setFromRotationMatrix( _m1$3 );
			this.quaternion.premultiply( _q1.invert() );

		}

	}

	add( object ) {

		if ( arguments.length > 1 ) {

			for ( let i = 0; i < arguments.length; i ++ ) {

				this.add( arguments[ i ] );

			}

			return this;

		}

		if ( object === this ) {

			console.error( 'THREE.Object3D.add: object can\'t be added as a child of itself.', object );
			return this;

		}

		if ( object && object.isObject3D ) {

			object.removeFromParent();
			object.parent = this;
			this.children.push( object );

			object.dispatchEvent( _addedEvent );

			_childaddedEvent.child = object;
			this.dispatchEvent( _childaddedEvent );
			_childaddedEvent.child = null;

		} else {

			console.error( 'THREE.Object3D.add: object not an instance of THREE.Object3D.', object );

		}

		return this;

	}

	remove( object ) {

		if ( arguments.length > 1 ) {

			for ( let i = 0; i < arguments.length; i ++ ) {

				this.remove( arguments[ i ] );

			}

			return this;

		}

		const index = this.children.indexOf( object );

		if ( index !== - 1 ) {

			object.parent = null;
			this.children.splice( index, 1 );

			object.dispatchEvent( _removedEvent );

			_childremovedEvent.child = object;
			this.dispatchEvent( _childremovedEvent );
			_childremovedEvent.child = null;

		}

		return this;

	}

	removeFromParent() {

		const parent = this.parent;

		if ( parent !== null ) {

			parent.remove( this );

		}

		return this;

	}

	clear() {

		return this.remove( ... this.children );

	}

	attach( object ) {

		// adds object as a child of this, while maintaining the object's world transform

		// Note: This method does not support scene graphs having non-uniformly-scaled nodes(s)

		this.updateWorldMatrix( true, false );

		_m1$3.copy( this.matrixWorld ).invert();

		if ( object.parent !== null ) {

			object.parent.updateWorldMatrix( true, false );

			_m1$3.multiply( object.parent.matrixWorld );

		}

		object.applyMatrix4( _m1$3 );

		object.removeFromParent();
		object.parent = this;
		this.children.push( object );

		object.updateWorldMatrix( false, true );

		object.dispatchEvent( _addedEvent );

		_childaddedEvent.child = object;
		this.dispatchEvent( _childaddedEvent );
		_childaddedEvent.child = null;

		return this;

	}

	getObjectById( id ) {

		return this.getObjectByProperty( 'id', id );

	}

	getObjectByName( name ) {

		return this.getObjectByProperty( 'name', name );

	}

	getObjectByProperty( name, value ) {

		if ( this[ name ] === value ) return this;

		for ( let i = 0, l = this.children.length; i < l; i ++ ) {

			const child = this.children[ i ];
			const object = child.getObjectByProperty( name, value );

			if ( object !== undefined ) {

				return object;

			}

		}

		return undefined;

	}

	getObjectsByProperty( name, value, result = [] ) {

		if ( this[ name ] === value ) result.push( this );

		const children = this.children;

		for ( let i = 0, l = children.length; i < l; i ++ ) {

			children[ i ].getObjectsByProperty( name, value, result );

		}

		return result;

	}

	getWorldPosition( target ) {

		this.updateWorldMatrix( true, false );

		return target.setFromMatrixPosition( this.matrixWorld );

	}

	getWorldQuaternion( target ) {

		this.updateWorldMatrix( true, false );

		this.matrixWorld.decompose( _position$3, target, _scale$2 );

		return target;

	}

	getWorldScale( target ) {

		this.updateWorldMatrix( true, false );

		this.matrixWorld.decompose( _position$3, _quaternion$2, target );

		return target;

	}

	getWorldDirection( target ) {

		this.updateWorldMatrix( true, false );

		const e = this.matrixWorld.elements;

		return target.set( e[ 8 ], e[ 9 ], e[ 10 ] ).normalize();

	}

	raycast( /* raycaster, intersects */ ) {}

	traverse( callback ) {

		callback( this );

		const children = this.children;

		for ( let i = 0, l = children.length; i < l; i ++ ) {

			children[ i ].traverse( callback );

		}

	}

	traverseVisible( callback ) {

		if ( this.visible === false ) return;

		callback( this );

		const children = this.children;

		for ( let i = 0, l = children.length; i < l; i ++ ) {

			children[ i ].traverseVisible( callback );

		}

	}

	traverseAncestors( callback ) {

		const parent = this.parent;

		if ( parent !== null ) {

			callback( parent );

			parent.traverseAncestors( callback );

		}

	}

	updateMatrix() {

		this.matrix.compose( this.position, this.quaternion, this.scale );

		this.matrixWorldNeedsUpdate = true;

	}

	updateMatrixWorld( force ) {

		if ( this.matrixAutoUpdate ) this.updateMatrix();

		if ( this.matrixWorldNeedsUpdate || force ) {

			if ( this.parent === null ) {

				this.matrixWorld.copy( this.matrix );

			} else {

				this.matrixWorld.multiplyMatrices( this.parent.matrixWorld, this.matrix );

			}

			this.matrixWorldNeedsUpdate = false;

			force = true;

		}

		// update children

		const children = this.children;

		for ( let i = 0, l = children.length; i < l; i ++ ) {

			const child = children[ i ];

			if ( child.matrixWorldAutoUpdate === true || force === true ) {

				child.updateMatrixWorld( force );

			}

		}

	}

	updateWorldMatrix( updateParents, updateChildren ) {

		const parent = this.parent;

		if ( updateParents === true && parent !== null && parent.matrixWorldAutoUpdate === true ) {

			parent.updateWorldMatrix( true, false );

		}

		if ( this.matrixAutoUpdate ) this.updateMatrix();

		if ( this.parent === null ) {

			this.matrixWorld.copy( this.matrix );

		} else {

			this.matrixWorld.multiplyMatrices( this.parent.matrixWorld, this.matrix );

		}

		// update children

		if ( updateChildren === true ) {

			const children = this.children;

			for ( let i = 0, l = children.length; i < l; i ++ ) {

				const child = children[ i ];

				if ( child.matrixWorldAutoUpdate === true ) {

					child.updateWorldMatrix( false, true );

				}

			}

		}

	}

	toJSON( meta ) {

		// meta is a string when called from JSON.stringify
		const isRootObject = ( meta === undefined || typeof meta === 'string' );

		const output = {};

		// meta is a hash used to collect geometries, materials.
		// not providing it implies that this is the root object
		// being serialized.
		if ( isRootObject ) {

			// initialize meta obj
			meta = {
				geometries: {},
				materials: {},
				textures: {},
				images: {},
				shapes: {},
				skeletons: {},
				animations: {},
				nodes: {}
			};

			output.metadata = {
				version: 4.6,
				type: 'Object',
				generator: 'Object3D.toJSON'
			};

		}

		// standard Object3D serialization

		const object = {};

		object.uuid = this.uuid;
		object.type = this.type;

		if ( this.name !== '' ) object.name = this.name;
		if ( this.castShadow === true ) object.castShadow = true;
		if ( this.receiveShadow === true ) object.receiveShadow = true;
		if ( this.visible === false ) object.visible = false;
		if ( this.frustumCulled === false ) object.frustumCulled = false;
		if ( this.renderOrder !== 0 ) object.renderOrder = this.renderOrder;
		if ( Object.keys( this.userData ).length > 0 ) object.userData = this.userData;

		object.layers = this.layers.mask;
		object.matrix = this.matrix.toArray();
		object.up = this.up.toArray();

		if ( this.matrixAutoUpdate === false ) object.matrixAutoUpdate = false;

		// object specific properties

		if ( this.isInstancedMesh ) {

			object.type = 'InstancedMesh';
			object.count = this.count;
			object.instanceMatrix = this.instanceMatrix.toJSON();
			if ( this.instanceColor !== null ) object.instanceColor = this.instanceColor.toJSON();

		}

		if ( this.isBatchedMesh ) {

			object.type = 'BatchedMesh';
			object.perObjectFrustumCulled = this.perObjectFrustumCulled;
			object.sortObjects = this.sortObjects;

			object.drawRanges = this._drawRanges;
			object.reservedRanges = this._reservedRanges;

			object.visibility = this._visibility;
			object.active = this._active;
			object.bounds = this._bounds.map( bound => ( {
				boxInitialized: bound.boxInitialized,
				boxMin: bound.box.min.toArray(),
				boxMax: bound.box.max.toArray(),

				sphereInitialized: bound.sphereInitialized,
				sphereRadius: bound.sphere.radius,
				sphereCenter: bound.sphere.center.toArray()
			} ) );

			object.maxGeometryCount = this._maxGeometryCount;
			object.maxVertexCount = this._maxVertexCount;
			object.maxIndexCount = this._maxIndexCount;

			object.geometryInitialized = this._geometryInitialized;
			object.geometryCount = this._geometryCount;

			object.matricesTexture = this._matricesTexture.toJSON( meta );

			if ( this.boundingSphere !== null ) {

				object.boundingSphere = {
					center: object.boundingSphere.center.toArray(),
					radius: object.boundingSphere.radius
				};

			}

			if ( this.boundingBox !== null ) {

				object.boundingBox = {
					min: object.boundingBox.min.toArray(),
					max: object.boundingBox.max.toArray()
				};

			}

		}

		//

		function serialize( library, element ) {

			if ( library[ element.uuid ] === undefined ) {

				library[ element.uuid ] = element.toJSON( meta );

			}

			return element.uuid;

		}

		if ( this.isScene ) {

			if ( this.background ) {

				if ( this.background.isColor ) {

					object.background = this.background.toJSON();

				} else if ( this.background.isTexture ) {

					object.background = this.background.toJSON( meta ).uuid;

				}

			}

			if ( this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== true ) {

				object.environment = this.environment.toJSON( meta ).uuid;

			}

		} else if ( this.isMesh || this.isLine || this.isPoints ) {

			object.geometry = serialize( meta.geometries, this.geometry );

			const parameters = this.geometry.parameters;

			if ( parameters !== undefined && parameters.shapes !== undefined ) {

				const shapes = parameters.shapes;

				if ( Array.isArray( shapes ) ) {

					for ( let i = 0, l = shapes.length; i < l; i ++ ) {

						const shape = shapes[ i ];

						serialize( meta.shapes, shape );

					}

				} else {

					serialize( meta.shapes, shapes );

				}

			}

		}

		if ( this.isSkinnedMesh ) {

			object.bindMode = this.bindMode;
			object.bindMatrix = this.bindMatrix.toArray();

			if ( this.skeleton !== undefined ) {

				serialize( meta.skeletons, this.skeleton );

				object.skeleton = this.skeleton.uuid;

			}

		}

		if ( this.material !== undefined ) {

			if ( Array.isArray( this.material ) ) {

				const uuids = [];

				for ( let i = 0, l = this.material.length; i < l; i ++ ) {

					uuids.push( serialize( meta.materials, this.material[ i ] ) );

				}

				object.material = uuids;

			} else {

				object.material = serialize( meta.materials, this.material );

			}

		}

		//

		if ( this.children.length > 0 ) {

			object.children = [];

			for ( let i = 0; i < this.children.length; i ++ ) {

				object.children.push( this.children[ i ].toJSON( meta ).object );

			}

		}

		//

		if ( this.animations.length > 0 ) {

			object.animations = [];

			for ( let i = 0; i < this.animations.length; i ++ ) {

				const animation = this.animations[ i ];

				object.animations.push( serialize( meta.animations, animation ) );

			}

		}

		if ( isRootObject ) {

			const geometries = extractFromCache( meta.geometries );
			const materials = extractFromCache( meta.materials );
			const textures = extractFromCache( meta.textures );
			const images = extractFromCache( meta.images );
			const shapes = extractFromCache( meta.shapes );
			const skeletons = extractFromCache( meta.skeletons );
			const animations = extractFromCache( meta.animations );
			const nodes = extractFromCache( meta.nodes );

			if ( geometries.length > 0 ) output.geometries = geometries;
			if ( materials.length > 0 ) output.materials = materials;
			if ( textures.length > 0 ) output.textures = textures;
			if ( images.length > 0 ) output.images = images;
			if ( shapes.length > 0 ) output.shapes = shapes;
			if ( skeletons.length > 0 ) output.skeletons = skeletons;
			if ( animations.length > 0 ) output.animations = animations;
			if ( nodes.length > 0 ) output.nodes = nodes;

		}

		output.object = object;

		return output;

		// extract data from the cache hash
		// remove metadata on each item
		// and return as array
		function extractFromCache( cache ) {

			const values = [];
			for ( const key in cache ) {

				const data = cache[ key ];
				delete data.metadata;
				values.push( data );

			}

			return values;

		}

	}

	clone( recursive ) {

		return new this.constructor().copy( this, recursive );

	}

	copy( source, recursive = true ) {

		this.name = source.name;

		this.up.copy( source.up );

		this.position.copy( source.position );
		this.rotation.order = source.rotation.order;
		this.quaternion.copy( source.quaternion );
		this.scale.copy( source.scale );

		this.matrix.copy( source.matrix );
		this.matrixWorld.copy( source.matrixWorld );

		this.matrixAutoUpdate = source.matrixAutoUpdate;

		this.matrixWorldAutoUpdate = source.matrixWorldAutoUpdate;
		this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;

		this.layers.mask = source.layers.mask;
		this.visible = source.visible;

		this.castShadow = source.castShadow;
		this.receiveShadow = source.receiveShadow;

		this.frustumCulled = source.frustumCulled;
		this.renderOrder = source.renderOrder;

		this.animations = source.animations.slice();

		this.userData = JSON.parse( JSON.stringify( source.userData ) );

		if ( recursive === true ) {

			for ( let i = 0; i < source.children.length; i ++ ) {

				const child = source.children[ i ];
				this.add( child.clone() );

			}

		}

		return this;

	}

}

Object3D.DEFAULT_UP = /*@__PURE__*/ new Vector3( 0, 1, 0 );
Object3D.DEFAULT_MATRIX_AUTO_UPDATE = true;
Object3D.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = true;

const _v0$1 = /*@__PURE__*/ new Vector3();
const _v1$3 = /*@__PURE__*/ new Vector3();
const _v2$2 = /*@__PURE__*/ new Vector3();
const _v3$2 = /*@__PURE__*/ new Vector3();

const _vab = /*@__PURE__*/ new Vector3();
const _vac = /*@__PURE__*/ new Vector3();
const _vbc = /*@__PURE__*/ new Vector3();
const _vap = /*@__PURE__*/ new Vector3();
const _vbp = /*@__PURE__*/ new Vector3();
const _vcp = /*@__PURE__*/ new Vector3();

class Triangle {

	constructor( a = new Vector3(), b = new Vector3(), c = new Vector3() ) {

		this.a = a;
		this.b = b;
		this.c = c;

	}

	static getNormal( a, b, c, target ) {

		target.subVectors( c, b );
		_v0$1.subVectors( a, b );
		target.cross( _v0$1 );

		const targetLengthSq = target.lengthSq();
		if ( targetLengthSq > 0 ) {

			return target.multiplyScalar( 1 / Math.sqrt( targetLengthSq ) );

		}

		return target.set( 0, 0, 0 );

	}

	// static/instance method to calculate barycentric coordinates
	// based on: http://www.blackpawn.com/texts/pointinpoly/default.html
	static getBarycoord( point, a, b, c, target ) {

		_v0$1.subVectors( c, a );
		_v1$3.subVectors( b, a );
		_v2$2.subVectors( point, a );

		const dot00 = _v0$1.dot( _v0$1 );
		const dot01 = _v0$1.dot( _v1$3 );
		const dot02 = _v0$1.dot( _v2$2 );
		const dot11 = _v1$3.dot( _v1$3 );
		const dot12 = _v1$3.dot( _v2$2 );

		const denom = ( dot00 * dot11 - dot01 * dot01 );

		// collinear or singular triangle
		if ( denom === 0 ) {

			target.set( 0, 0, 0 );
			return null;

		}

		const invDenom = 1 / denom;
		const u = ( dot11 * dot02 - dot01 * dot12 ) * invDenom;
		const v = ( dot00 * dot12 - dot01 * dot02 ) * invDenom;

		// barycentric coordinates must always sum to 1
		return target.set( 1 - u - v, v, u );

	}

	static containsPoint( point, a, b, c ) {

		// if the triangle is degenerate then we can't contain a point
		if ( this.getBarycoord( point, a, b, c, _v3$2 ) === null ) {

			return false;

		}

		return ( _v3$2.x >= 0 ) && ( _v3$2.y >= 0 ) && ( ( _v3$2.x + _v3$2.y ) <= 1 );

	}

	static getInterpolation( point, p1, p2, p3, v1, v2, v3, target ) {

		if ( this.getBarycoord( point, p1, p2, p3, _v3$2 ) === null ) {

			target.x = 0;
			target.y = 0;
			if ( 'z' in target ) target.z = 0;
			if ( 'w' in target ) target.w = 0;
			return null;

		}

		target.setScalar( 0 );
		target.addScaledVector( v1, _v3$2.x );
		target.addScaledVector( v2, _v3$2.y );
		target.addScaledVector( v3, _v3$2.z );

		return target;

	}

	static isFrontFacing( a, b, c, direction ) {

		_v0$1.subVectors( c, b );
		_v1$3.subVectors( a, b );

		// strictly front facing
		return ( _v0$1.cross( _v1$3 ).dot( direction ) < 0 ) ? true : false;

	}

	set( a, b, c ) {

		this.a.copy( a );
		this.b.copy( b );
		this.c.copy( c );

		return this;

	}

	setFromPointsAndIndices( points, i0, i1, i2 ) {

		this.a.copy( points[ i0 ] );
		this.b.copy( points[ i1 ] );
		this.c.copy( points[ i2 ] );

		return this;

	}

	setFromAttributeAndIndices( attribute, i0, i1, i2 ) {

		this.a.fromBufferAttribute( attribute, i0 );
		this.b.fromBufferAttribute( attribute, i1 );
		this.c.fromBufferAttribute( attribute, i2 );

		return this;

	}

	clone() {

		return new this.constructor().copy( this );

	}

	copy( triangle ) {

		this.a.copy( triangle.a );
		this.b.copy( triangle.b );
		this.c.copy( triangle.c );

		return this;

	}

	getArea() {

		_v0$1.subVectors( this.c, this.b );
		_v1$3.subVectors( this.a, this.b );

		return _v0$1.cross( _v1$3 ).length() * 0.5;

	}

	getMidpoint( target ) {

		return target.addVectors( this.a, this.b ).add( this.c ).multiplyScalar( 1 / 3 );

	}

	getNormal( target ) {

		return Triangle.getNormal( this.a, this.b, this.c, target );

	}

	getPlane( target ) {

		return target.setFromCoplanarPoints( this.a, this.b, this.c );

	}

	getBarycoord( point, target ) {

		return Triangle.getBarycoord( point, this.a, this.b, this.c, target );

	}

	getInterpolation( point, v1, v2, v3, target ) {

		return Triangle.getInterpolation( point, this.a, this.b, this.c, v1, v2, v3, target );

	}

	containsPoint( point ) {

		return Triangle.containsPoint( point, this.a, this.b, this.c );

	}

	isFrontFacing( direction ) {

		return Triangle.isFrontFacing( this.a, this.b, this.c, direction );

	}

	intersectsBox( box ) {

		return box.intersectsTriangle( this );

	}

	closestPointToPoint( p, target ) {

		const a = this.a, b = this.b, c = this.c;
		let v, w;

		// algorithm thanks to Real-Time Collision Detection by Christer Ericson,
		// published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
		// under the accompanying license; see chapter 5.1.5 for detailed explanation.
		// basically, we're distinguishing which of the voronoi regions of the triangle
		// the point lies in with the minimum amount of redundant computation.

		_vab.subVectors( b, a );
		_vac.subVectors( c, a );
		_vap.subVectors( p, a );
		const d1 = _vab.dot( _vap );
		const d2 = _vac.dot( _vap );
		if ( d1 <= 0 && d2 <= 0 ) {

			// vertex region of A; barycentric coords (1, 0, 0)
			return target.copy( a );

		}

		_vbp.subVectors( p, b );
		const d3 = _vab.dot( _vbp );
		const d4 = _vac.dot( _vbp );
		if ( d3 >= 0 && d4 <= d3 ) {

			// vertex region of B; barycentric coords (0, 1, 0)
			return target.copy( b );

		}

		const vc = d1 * d4 - d3 * d2;
		if ( vc <= 0 && d1 >= 0 && d3 <= 0 ) {

			v = d1 / ( d1 - d3 );
			// edge region of AB; barycentric coords (1-v, v, 0)
			return target.copy( a ).addScaledVector( _vab, v );

		}

		_vcp.subVectors( p, c );
		const d5 = _vab.dot( _vcp );
		const d6 = _vac.dot( _vcp );
		if ( d6 >= 0 && d5 <= d6 ) {

			// vertex region of C; barycentric coords (0, 0, 1)
			return target.copy( c );

		}

		const vb = d5 * d2 - d1 * d6;
		if ( vb <= 0 && d2 >= 0 && d6 <= 0 ) {

			w = d2 / ( d2 - d6 );
			// edge region of AC; barycentric coords (1-w, 0, w)
			return target.copy( a ).addScaledVector( _vac, w );

		}

		const va = d3 * d6 - d5 * d4;
		if ( va <= 0 && ( d4 - d3 ) >= 0 && ( d5 - d6 ) >= 0 ) {

			_vbc.subVectors( c, b );
			w = ( d4 - d3 ) / ( ( d4 - d3 ) + ( d5 - d6 ) );
			// edge region of BC; barycentric coords (0, 1-w, w)
			return target.copy( b ).addScaledVector( _vbc, w ); // edge region of BC

		}

		// face region
		const denom = 1 / ( va + vb + vc );
		// u = va * denom
		v = vb * denom;
		w = vc * denom;

		return target.copy( a ).addScaledVector( _vab, v ).addScaledVector( _vac, w );

	}

	equals( triangle ) {

		return triangle.a.equals( this.a ) && triangle.b.equals( this.b ) && triangle.c.equals( this.c );

	}

}

const _colorKeywords = { 'aliceblue': 0xF0F8FF, 'antiquewhite': 0xFAEBD7, 'aqua': 0x00FFFF, 'aquamarine': 0x7FFFD4, 'azure': 0xF0FFFF,
	'beige': 0xF5F5DC, 'bisque': 0xFFE4C4, 'black': 0x000000, 'blanchedalmond': 0xFFEBCD, 'blue': 0x0000FF, 'blueviolet': 0x8A2BE2,
	'brown': 0xA52A2A, 'burlywood': 0xDEB887, 'cadetblue': 0x5F9EA0, 'chartreuse': 0x7FFF00, 'chocolate': 0xD2691E, 'coral': 0xFF7F50,
	'cornflowerblue': 0x6495ED, 'cornsilk': 0xFFF8DC, 'crimson': 0xDC143C, 'cyan': 0x00FFFF, 'darkblue': 0x00008B, 'darkcyan': 0x008B8B,
	'darkgoldenrod': 0xB8860B, 'darkgray': 0xA9A9A9, 'darkgreen': 0x006400, 'darkgrey': 0xA9A9A9, 'darkkhaki': 0xBDB76B, 'darkmagenta': 0x8B008B,
	'darkolivegreen': 0x556B2F, 'darkorange': 0xFF8C00, 'darkorchid': 0x9932CC, 'darkred': 0x8B0000, 'darksalmon': 0xE9967A, 'darkseagreen': 0x8FBC8F,
	'darkslateblue': 0x483D8B, 'darkslategray': 0x2F4F4F, 'darkslategrey': 0x2F4F4F, 'darkturquoise': 0x00CED1, 'darkviolet': 0x9400D3,
	'deeppink': 0xFF1493, 'deepskyblue': 0x00BFFF, 'dimgray': 0x696969, 'dimgrey': 0x696969, 'dodgerblue': 0x1E90FF, 'firebrick': 0xB22222,
	'floralwhite': 0xFFFAF0, 'forestgreen': 0x228B22, 'fuchsia': 0xFF00FF, 'gainsboro': 0xDCDCDC, 'ghostwhite': 0xF8F8FF, 'gold': 0xFFD700,
	'goldenrod': 0xDAA520, 'gray': 0x808080, 'green': 0x008000, 'greenyellow': 0xADFF2F, 'grey': 0x808080, 'honeydew': 0xF0FFF0, 'hotpink': 0xFF69B4,
	'indianred': 0xCD5C5C, 'indigo': 0x4B0082, 'ivory': 0xFFFFF0, 'khaki': 0xF0E68C, 'lavender': 0xE6E6FA, 'lavenderblush': 0xFFF0F5, 'lawngreen': 0x7CFC00,
	'lemonchiffon': 0xFFFACD, 'lightblue': 0xADD8E6, 'lightcoral': 0xF08080, 'lightcyan': 0xE0FFFF, 'lightgoldenrodyellow': 0xFAFAD2, 'lightgray': 0xD3D3D3,
	'lightgreen': 0x90EE90, 'lightgrey': 0xD3D3D3, 'lightpink': 0xFFB6C1, 'lightsalmon': 0xFFA07A, 'lightseagreen': 0x20B2AA, 'lightskyblue': 0x87CEFA,
	'lightslategray': 0x778899, 'lightslategrey': 0x778899, 'lightsteelblue': 0xB0C4DE, 'lightyellow': 0xFFFFE0, 'lime': 0x00FF00, 'limegreen': 0x32CD32,
	'linen': 0xFAF0E6, 'magenta': 0xFF00FF, 'maroon': 0x800000, 'mediumaquamarine': 0x66CDAA, 'mediumblue': 0x0000CD, 'mediumorchid': 0xBA55D3,
	'mediumpurple': 0x9370DB, 'mediumseagreen': 0x3CB371, 'mediumslateblue': 0x7B68EE, 'mediumspringgreen': 0x00FA9A, 'mediumturquoise': 0x48D1CC,
	'mediumvioletred': 0xC71585, 'midnightblue': 0x191970, 'mintcream': 0xF5FFFA, 'mistyrose': 0xFFE4E1, 'moccasin': 0xFFE4B5, 'navajowhite': 0xFFDEAD,
	'navy': 0x000080, 'oldlace': 0xFDF5E6, 'olive': 0x808000, 'olivedrab': 0x6B8E23, 'orange': 0xFFA500, 'orangered': 0xFF4500, 'orchid': 0xDA70D6,
	'palegoldenrod': 0xEEE8AA, 'palegreen': 0x98FB98, 'paleturquoise': 0xAFEEEE, 'palevioletred': 0xDB7093, 'papayawhip': 0xFFEFD5, 'peachpuff': 0xFFDAB9,
	'peru': 0xCD853F, 'pink': 0xFFC0CB, 'plum': 0xDDA0DD, 'powderblue': 0xB0E0E6, 'purple': 0x800080, 'rebeccapurple': 0x663399, 'red': 0xFF0000, 'rosybrown': 0xBC8F8F,
	'royalblue': 0x4169E1, 'saddlebrown': 0x8B4513, 'salmon': 0xFA8072, 'sandybrown': 0xF4A460, 'seagreen': 0x2E8B57, 'seashell': 0xFFF5EE,
	'sienna': 0xA0522D, 'silver': 0xC0C0C0, 'skyblue': 0x87CEEB, 'slateblue': 0x6A5ACD, 'slategray': 0x708090, 'slategrey': 0x708090, 'snow': 0xFFFAFA,
	'springgreen': 0x00FF7F, 'steelblue': 0x4682B4, 'tan': 0xD2B48C, 'teal': 0x008080, 'thistle': 0xD8BFD8, 'tomato': 0xFF6347, 'turquoise': 0x40E0D0,
	'violet': 0xEE82EE, 'wheat': 0xF5DEB3, 'white': 0xFFFFFF, 'whitesmoke': 0xF5F5F5, 'yellow': 0xFFFF00, 'yellowgreen': 0x9ACD32 };

const _hslA = { h: 0, s: 0, l: 0 };
const _hslB = { h: 0, s: 0, l: 0 };

function hue2rgb( p, q, t ) {

	if ( t < 0 ) t += 1;
	if ( t > 1 ) t -= 1;
	if ( t < 1 / 6 ) return p + ( q - p ) * 6 * t;
	if ( t < 1 / 2 ) return q;
	if ( t < 2 / 3 ) return p + ( q - p ) * 6 * ( 2 / 3 - t );
	return p;

}

class Color {

	constructor( r, g, b ) {

		this.isColor = true;

		this.r = 1;
		this.g = 1;
		this.b = 1;

		return this.set( r, g, b );

	}

	set( r, g, b ) {

		if ( g === undefined && b === undefined ) {

			// r is THREE.Color, hex or string

			const value = r;

			if ( value && value.isColor ) {

				this.copy( value );

			} else if ( typeof value === 'number' ) {

				this.setHex( value );

			} else if ( typeof value === 'string' ) {

				this.setStyle( value );

			}

		} else {

			this.setRGB( r, g, b );

		}

		return this;

	}

	setScalar( scalar ) {

		this.r = scalar;
		this.g = scalar;
		this.b = scalar;

		return this;

	}

	setHex( hex, colorSpace = SRGBColorSpace ) {

		hex = Math.floor( hex );

		this.r = ( hex >> 16 & 255 ) / 255;
		this.g = ( hex >> 8 & 255 ) / 255;
		this.b = ( hex & 255 ) / 255;

		ColorManagement.toWorkingColorSpace( this, colorSpace );

		return this;

	}

	setRGB( r, g, b, colorSpace = ColorManagement.workingColorSpace ) {

		this.r = r;
		this.g = g;
		this.b = b;

		ColorManagement.toWorkingColorSpace( this, colorSpace );

		return this;

	}

	setHSL( h, s, l, colorSpace = ColorManagement.workingColorSpace ) {

		// h,s,l ranges are in 0.0 - 1.0
		h = euclideanModulo( h, 1 );
		s = clamp( s, 0, 1 );
		l = clamp( l, 0, 1 );

		if ( s === 0 ) {

			this.r = this.g = this.b = l;

		} else {

			const p = l <= 0.5 ? l * ( 1 + s ) : l + s - ( l * s );
			const q = ( 2 * l ) - p;

			this.r = hue2rgb( q, p, h + 1 / 3 );
			this.g = hue2rgb( q, p, h );
			this.b = hue2rgb( q, p, h - 1 / 3 );

		}

		ColorManagement.toWorkingColorSpace( this, colorSpace );

		return this;

	}

	setStyle( style, colorSpace = SRGBColorSpace ) {

		function handleAlpha( string ) {

			if ( string === undefined ) return;

			if ( parseFloat( string ) < 1 ) {

				console.warn( 'THREE.Color: Alpha component of ' + style + ' will be ignored.' );

			}

		}


		let m;

		if ( m = /^(\w+)\(([^\)]*)\)/.exec( style ) ) {

			// rgb / hsl

			let color;
			const name = m[ 1 ];
			const components = m[ 2 ];

			switch ( name ) {

				case 'rgb':
				case 'rgba':

					if ( color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec( components ) ) {

						// rgb(255,0,0) rgba(255,0,0,0.5)

						handleAlpha( color[ 4 ] );

						return this.setRGB(
							Math.min( 255, parseInt( color[ 1 ], 10 ) ) / 255,
							Math.min( 255, parseInt( color[ 2 ], 10 ) ) / 255,
							Math.min( 255, parseInt( color[ 3 ], 10 ) ) / 255,
							colorSpace
						);

					}

					if ( color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec( components ) ) {

						// rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)

						handleAlpha( color[ 4 ] );

						return this.setRGB(
							Math.min( 100, parseInt( color[ 1 ], 10 ) ) / 100,
							Math.min( 100, parseInt( color[ 2 ], 10 ) ) / 100,
							Math.min( 100, parseInt( color[ 3 ], 10 ) ) / 100,
							colorSpace
						);

					}

					break;

				case 'hsl':
				case 'hsla':

					if ( color = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec( components ) ) {

						// hsl(120,50%,50%) hsla(120,50%,50%,0.5)

						handleAlpha( color[ 4 ] );

						return this.setHSL(
							parseFloat( color[ 1 ] ) / 360,
							parseFloat( color[ 2 ] ) / 100,
							parseFloat( color[ 3 ] ) / 100,
							colorSpace
						);

					}

					break;

				default:

					console.warn( 'THREE.Color: Unknown color model ' + style );

			}

		} else if ( m = /^\#([A-Fa-f\d]+)$/.exec( style ) ) {

			// hex color

			const hex = m[ 1 ];
			const size = hex.length;

			if ( size === 3 ) {

				// #ff0
				return this.setRGB(
					parseInt( hex.charAt( 0 ), 16 ) / 15,
					parseInt( hex.charAt( 1 ), 16 ) / 15,
					parseInt( hex.charAt( 2 ), 16 ) / 15,
					colorSpace
				);

			} else if ( size === 6 ) {

				// #ff0000
				return this.setHex( parseInt( hex, 16 ), colorSpace );

			} else {

				console.warn( 'THREE.Color: Invalid hex color ' + style );

			}

		} else if ( style && style.length > 0 ) {

			return this.setColorName( style, colorSpace );

		}

		return this;

	}

	setColorName( style, colorSpace = SRGBColorSpace ) {

		// color keywords
		const hex = _colorKeywords[ style.toLowerCase() ];

		if ( hex !== undefined ) {

			// red
			this.setHex( hex, colorSpace );

		} else {

			// unknown color
			console.warn( 'THREE.Color: Unknown color ' + style );

		}

		return this;

	}

	clone() {

		return new this.constructor( this.r, this.g, this.b );

	}

	copy( color ) {

		this.r = color.r;
		this.g = color.g;
		this.b = color.b;

		return this;

	}

	copySRGBToLinear( color ) {

		this.r = SRGBToLinear( color.r );
		this.g = SRGBToLinear( color.g );
		this.b = SRGBToLinear( color.b );

		return this;

	}

	copyLinearToSRGB( color ) {

		this.r = LinearToSRGB( color.r );
		this.g = LinearToSRGB( color.g );
		this.b = LinearToSRGB( color.b );

		return this;

	}

	convertSRGBToLinear() {

		this.copySRGBToLinear( this );

		return this;

	}

	convertLinearToSRGB() {

		this.copyLinearToSRGB( this );

		return this;

	}

	getHex( colorSpace = SRGBColorSpace ) {

		ColorManagement.fromWorkingColorSpace( _color.copy( this ), colorSpace );

		return Math.round( clamp( _color.r * 255, 0, 255 ) ) * 65536 + Math.round( clamp( _color.g * 255, 0, 255 ) ) * 256 + Math.round( clamp( _color.b * 255, 0, 255 ) );

	}

	getHexString( colorSpace = SRGBColorSpace ) {

		return ( '000000' + this.getHex( colorSpace ).toString( 16 ) ).slice( - 6 );

	}

	getHSL( target, colorSpace = ColorManagement.workingColorSpace ) {

		// h,s,l ranges are in 0.0 - 1.0

		ColorManagement.fromWorkingColorSpace( _color.copy( this ), colorSpace );

		const r = _color.r, g = _color.g, b = _color.b;

		const max = Math.max( r, g, b );
		const min = Math.min( r, g, b );

		let hue, saturation;
		const lightness = ( min + max ) / 2.0;

		if ( min === max ) {

			hue = 0;
			saturation = 0;

		} else {

			const delta = max - min;

			saturation = lightness <= 0.5 ? delta / ( max + min ) : delta / ( 2 - max - min );

			switch ( max ) {

				case r: hue = ( g - b ) / delta + ( g < b ? 6 : 0 ); break;
				case g: hue = ( b - r ) / delta + 2; break;
				case b: hue = ( r - g ) / delta + 4; break;

			}

			hue /= 6;

		}

		target.h = hue;
		target.s = saturation;
		target.l = lightness;

		return target;

	}

	getRGB( target, colorSpace = ColorManagement.workingColorSpace ) {

		ColorManagement.fromWorkingColorSpace( _color.copy( this ), colorSpace );

		target.r = _color.r;
		target.g = _color.g;
		target.b = _color.b;

		return target;

	}

	getStyle( colorSpace = SRGBColorSpace ) {

		ColorManagement.fromWorkingColorSpace( _color.copy( this ), colorSpace );

		const r = _color.r, g = _color.g, b = _color.b;

		if ( colorSpace !== SRGBColorSpace ) {

			// Requires CSS Color Module Level 4 (https://www.w3.org/TR/css-color-4/).
			return `color(${ colorSpace } ${ r.toFixed( 3 ) } ${ g.toFixed( 3 ) } ${ b.toFixed( 3 ) })`;

		}

		return `rgb(${ Math.round( r * 255 ) },${ Math.round( g * 255 ) },${ Math.round( b * 255 ) })`;

	}

	offsetHSL( h, s, l ) {

		this.getHSL( _hslA );

		return this.setHSL( _hslA.h + h, _hslA.s + s, _hslA.l + l );

	}

	add( color ) {

		this.r += color.r;
		this.g += color.g;
		this.b += color.b;

		return this;

	}

	addColors( color1, color2 ) {

		this.r = color1.r + color2.r;
		this.g = color1.g + color2.g;
		this.b = color1.b + color2.b;

		return this;

	}

	addScalar( s ) {

		this.r += s;
		this.g += s;
		this.b += s;

		return this;

	}

	sub( color ) {

		this.r = Math.max( 0, this.r - color.r );
		this.g = Math.max( 0, this.g - color.g );
		this.b = Math.max( 0, this.b - color.b );

		return this;

	}

	multiply( color ) {

		this.r *= color.r;
		this.g *= color.g;
		this.b *= color.b;

		return this;

	}

	multiplyScalar( s ) {

		this.r *= s;
		this.g *= s;
		this.b *= s;

		return this;

	}

	lerp( color, alpha ) {

		this.r += ( color.r - this.r ) * alpha;
		this.g += ( color.g - this.g ) * alpha;
		this.b += ( color.b - this.b ) * alpha;

		return this;

	}

	lerpColors( color1, color2, alpha ) {

		this.r = color1.r + ( color2.r - color1.r ) * alpha;
		this.g = color1.g + ( color2.g - color1.g ) * alpha;
		this.b = color1.b + ( color2.b - color1.b ) * alpha;

		return this;

	}

	lerpHSL( color, alpha ) {

		this.getHSL( _hslA );
		color.getHSL( _hslB );

		const h = lerp( _hslA.h, _hslB.h, alpha );
		const s = lerp( _hslA.s, _hslB.s, alpha );
		const l = lerp( _hslA.l, _hslB.l, alpha );

		this.setHSL( h, s, l );

		return this;

	}

	setFromVector3( v ) {

		this.r = v.x;
		this.g = v.y;
		this.b = v.z;

		return this;

	}

	applyMatrix3( m ) {

		const r = this.r, g = this.g, b = this.b;
		const e = m.elements;

		this.r = e[ 0 ] * r + e[ 3 ] * g + e[ 6 ] * b;
		this.g = e[ 1 ] * r + e[ 4 ] * g + e[ 7 ] * b;
		this.b = e[ 2 ] * r + e[ 5 ] * g + e[ 8 ] * b;

		return this;

	}

	equals( c ) {

		return ( c.r === this.r ) && ( c.g === this.g ) && ( c.b === this.b );

	}

	fromArray( array, offset = 0 ) {

		this.r = array[ offset ];
		this.g = array[ offset + 1 ];
		this.b = array[ offset + 2 ];

		return this;

	}

	toArray( array = [], offset = 0 ) {

		array[ offset ] = this.r;
		array[ offset + 1 ] = this.g;
		array[ offset + 2 ] = this.b;

		return array;

	}

	fromBufferAttribute( attribute, index ) {

		this.r = attribute.getX( index );
		this.g = attribute.getY( index );
		this.b = attribute.getZ( index );

		return this;

	}

	toJSON() {

		return this.getHex();

	}

	*[ Symbol.iterator ]() {

		yield this.r;
		yield this.g;
		yield this.b;

	}

}

const _color = /*@__PURE__*/ new Color();

Color.NAMES = _colorKeywords;

let _materialId = 0;

class Material extends EventDispatcher {

	constructor() {

		super();

		this.isMaterial = true;

		Object.defineProperty( this, 'id', { value: _materialId ++ } );

		this.uuid = generateUUID();

		this.name = '';
		this.type = 'Material';

		this.blending = NormalBlending;
		this.side = FrontSide;
		this.vertexColors = false;

		this.opacity = 1;
		this.transparent = false;
		this.alphaHash = false;

		this.blendSrc = SrcAlphaFactor;
		this.blendDst = OneMinusSrcAlphaFactor;
		this.blendEquation = AddEquation;
		this.blendSrcAlpha = null;
		this.blendDstAlpha = null;
		this.blendEquationAlpha = null;
		this.blendColor = new Color( 0, 0, 0 );
		this.blendAlpha = 0;

		this.depthFunc = LessEqualDepth;
		this.depthTest = true;
		this.depthWrite = true;

		this.stencilWriteMask = 0xff;
		this.stencilFunc = AlwaysStencilFunc;
		this.stencilRef = 0;
		this.stencilFuncMask = 0xff;
		this.stencilFail = KeepStencilOp;
		this.stencilZFail = KeepStencilOp;
		this.stencilZPass = KeepStencilOp;
		this.stencilWrite = false;

		this.clippingPlanes = null;
		this.clipIntersection = false;
		this.clipShadows = false;

		this.shadowSide = null;

		this.colorWrite = true;

		this.precision = null; // override the renderer's default precision for this material

		this.polygonOffset = false;
		this.polygonOffsetFactor = 0;
		this.polygonOffsetUnits = 0;

		this.dithering = false;

		this.alphaToCoverage = false;
		this.premultipliedAlpha = false;
		this.forceSinglePass = false;

		this.visible = true;

		this.toneMapped = true;

		this.userData = {};

		this.version = 0;

		this._alphaTest = 0;

	}

	get alphaTest() {

		return this._alphaTest;

	}

	set alphaTest( value ) {

		if ( this._alphaTest > 0 !== value > 0 ) {

			this.version ++;

		}

		this._alphaTest = value;

	}

	onBuild( /* shaderobject, renderer */ ) {}

	onBeforeRender( /* renderer, scene, camera, geometry, object, group */ ) {}

	onBeforeCompile( /* shaderobject, renderer */ ) {}

	customProgramCacheKey() {

		return this.onBeforeCompile.toString();

	}

	setValues( values ) {

		if ( values === undefined ) return;

		for ( const key in values ) {

			const newValue = values[ key ];

			if ( newValue === undefined ) {

				console.warn( `THREE.Material: parameter '${ key }' has value of undefined.` );
				continue;

			}

			const currentValue = this[ key ];

			if ( currentValue === undefined ) {

				console.warn( `THREE.Material: '${ key }' is not a property of THREE.${ this.type }.` );
				continue;

			}

			if ( currentValue && currentValue.isColor ) {

				currentValue.set( newValue );

			} else if ( ( currentValue && currentValue.isVector3 ) && ( newValue && newValue.isVector3 ) ) {

				currentValue.copy( newValue );

			} else {

				this[ key ] = newValue;

			}

		}

	}

	toJSON( meta ) {

		const isRootObject = ( meta === undefined || typeof meta === 'string' );

		if ( isRootObject ) {

			meta = {
				textures: {},
				images: {}
			};

		}

		const data = {
			metadata: {
				version: 4.6,
				type: 'Material',
				generator: 'Material.toJSON'
			}
		};

		// standard Material serialization
		data.uuid = this.uuid;
		data.type = this.type;

		if ( this.name !== '' ) data.name = this.name;

		if ( this.color && this.color.isColor ) data.color = this.color.getHex();

		if ( this.roughness !== undefined ) data.roughness = this.roughness;
		if ( this.metalness !== undefined ) data.metalness = this.metalness;

		if ( this.sheen !== undefined ) data.sheen = this.sheen;
		if ( this.sheenColor && this.sheenColor.isColor ) data.sheenColor = this.sheenColor.getHex();
		if ( this.sheenRoughness !== undefined ) data.sheenRoughness = this.sheenRoughness;
		if ( this.emissive && this.emissive.isColor ) data.emissive = this.emissive.getHex();
		if ( this.emissiveIntensity !== undefined && this.emissiveIntensity !== 1 ) data.emissiveIntensity = this.emissiveIntensity;

		if ( this.specular && this.specular.isColor ) data.specular = this.specular.getHex();
		if ( this.specularIntensity !== undefined ) data.specularIntensity = this.specularIntensity;
		if ( this.specularColor && this.specularColor.isColor ) data.specularColor = this.specularColor.getHex();
		if ( this.shininess !== undefined ) data.shininess = this.shininess;
		if ( this.clearcoat !== undefined ) data.clearcoat = this.clearcoat;
		if ( this.clearcoatRoughness !== undefined ) data.clearcoatRoughness = this.clearcoatRoughness;

		if ( this.clearcoatMap && this.clearcoatMap.isTexture ) {

			data.clearcoatMap = this.clearcoatMap.toJSON( meta ).uuid;

		}

		if ( this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture ) {

			data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON( meta ).uuid;

		}

		if ( this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture ) {

			data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON( meta ).uuid;
			data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();

		}

		if ( this.iridescence !== undefined ) data.iridescence = this.iridescence;
		if ( this.iridescenceIOR !== undefined ) data.iridescenceIOR = this.iridescenceIOR;
		if ( this.iridescenceThicknessRange !== undefined ) data.iridescenceThicknessRange = this.iridescenceThicknessRange;

		if ( this.iridescenceMap && this.iridescenceMap.isTexture ) {

			data.iridescenceMap = this.iridescenceMap.toJSON( meta ).uuid;

		}

		if ( this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture ) {

			data.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON( meta ).uuid;

		}

		if ( this.anisotropy !== undefined ) data.anisotropy = this.anisotropy;
		if ( this.anisotropyRotation !== undefined ) data.anisotropyRotation = this.anisotropyRotation;

		if ( this.anisotropyMap && this.anisotropyMap.isTexture ) {

			data.anisotropyMap = this.anisotropyMap.toJSON( meta ).uuid;

		}

		if ( this.map && this.map.isTexture ) data.map = this.map.toJSON( meta ).uuid;
		if ( this.matcap && this.matcap.isTexture ) data.matcap = this.matcap.toJSON( meta ).uuid;
		if ( this.alphaMap && this.alphaMap.isTexture ) data.alphaMap = this.alphaMap.toJSON( meta ).uuid;

		if ( this.lightMap && this.lightMap.isTexture ) {

			data.lightMap = this.lightMap.toJSON( meta ).uuid;
			data.lightMapIntensity = this.lightMapIntensity;

		}

		if ( this.aoMap && this.aoMap.isTexture ) {

			data.aoMap = this.aoMap.toJSON( meta ).uuid;
			data.aoMapIntensity = this.aoMapIntensity;

		}

		if ( this.bumpMap && this.bumpMap.isTexture ) {

			data.bumpMap = this.bumpMap.toJSON( meta ).uuid;
			data.bumpScale = this.bumpScale;

		}

		if ( this.normalMap && this.normalMap.isTexture ) {

			data.normalMap = this.normalMap.toJSON( meta ).uuid;
			data.normalMapType = this.normalMapType;
			data.normalScale = this.normalScale.toArray();

		}

		if ( this.displacementMap && this.displacementMap.isTexture ) {

			data.displacementMap = this.displacementMap.toJSON( meta ).uuid;
			data.displacementScale = this.displacementScale;
			data.displacementBias = this.displacementBias;

		}

		if ( this.roughnessMap && this.roughnessMap.isTexture ) data.roughnessMap = this.roughnessMap.toJSON( meta ).uuid;
		if ( this.metalnessMap && this.metalnessMap.isTexture ) data.metalnessMap = this.metalnessMap.toJSON( meta ).uuid;

		if ( this.emissiveMap && this.emissiveMap.isTexture ) data.emissiveMap = this.emissiveMap.toJSON( meta ).uuid;
		if ( this.specularMap && this.specularMap.isTexture ) data.specularMap = this.specularMap.toJSON( meta ).uuid;
		if ( this.specularIntensityMap && this.specularIntensityMap.isTexture ) data.specularIntensityMap = this.specularIntensityMap.toJSON( meta ).uuid;
		if ( this.specularColorMap && this.specularColorMap.isTexture ) data.specularColorMap = this.specularColorMap.toJSON( meta ).uuid;

		if ( this.envMap && this.envMap.isTexture ) {

			data.envMap = this.envMap.toJSON( meta ).uuid;

			if ( this.combine !== undefined ) data.combine = this.combine;

		}

		if ( this.envMapRotation !== undefined ) data.envMapRotation = this.envMapRotation.toArray();
		if ( this.envMapIntensity !== undefined ) data.envMapIntensity = this.envMapIntensity;
		if ( this.reflectivity !== undefined ) data.reflectivity = this.reflectivity;
		if ( this.refractionRatio !== undefined ) data.refractionRatio = this.refractionRatio;

		if ( this.gradientMap && this.gradientMap.isTexture ) {

			data.gradientMap = this.gradientMap.toJSON( meta ).uuid;

		}

		if ( this.transmission !== undefined ) data.transmission = this.transmission;
		if ( this.transmissionMap && this.transmissionMap.isTexture ) data.transmissionMap = this.transmissionMap.toJSON( meta ).uuid;
		if ( this.thickness !== undefined ) data.thickness = this.thickness;
		if ( this.thicknessMap && this.thicknessMap.isTexture ) data.thicknessMap = this.thicknessMap.toJSON( meta ).uuid;
		if ( this.attenuationDistance !== undefined && this.attenuationDistance !== Infinity ) data.attenuationDistance = this.attenuationDistance;
		if ( this.attenuationColor !== undefined ) data.attenuationColor = this.attenuationColor.getHex();

		if ( this.size !== undefined ) data.size = this.size;
		if ( this.shadowSide !== null ) data.shadowSide = this.shadowSide;
		if ( this.sizeAttenuation !== undefined ) data.sizeAttenuation = this.sizeAttenuation;

		if ( this.blending !== NormalBlending ) data.blending = this.blending;
		if ( this.side !== FrontSide ) data.side = this.side;
		if ( this.vertexColors === true ) data.vertexColors = true;

		if ( this.opacity < 1 ) data.opacity = this.opacity;
		if ( this.transparent === true ) data.transparent = true;

		if ( this.blendSrc !== SrcAlphaFactor ) data.blendSrc = this.blendSrc;
		if ( this.blendDst !== OneMinusSrcAlphaFactor ) data.blendDst = this.blendDst;
		if ( this.blendEquation !== AddEquation ) data.blendEquation = this.blendEquation;
		if ( this.blendSrcAlpha !== null ) data.blendSrcAlpha = this.blendSrcAlpha;
		if ( this.blendDstAlpha !== null ) data.blendDstAlpha = this.blendDstAlpha;
		if ( this.blendEquationAlpha !== null ) data.blendEquationAlpha = this.blendEquationAlpha;
		if ( this.blendColor && this.blendColor.isColor ) data.blendColor = this.blendColor.getHex();
		if ( this.blendAlpha !== 0 ) data.blendAlpha = this.blendAlpha;

		if ( this.depthFunc !== LessEqualDepth ) data.depthFunc = this.depthFunc;
		if ( this.depthTest === false ) data.depthTest = this.depthTest;
		if ( this.depthWrite === false ) data.depthWrite = this.depthWrite;
		if ( this.colorWrite === false ) data.colorWrite = this.colorWrite;

		if ( this.stencilWriteMask !== 0xff ) data.stencilWriteMask = this.stencilWriteMask;
		if ( this.stencilFunc !== AlwaysStencilFunc ) data.stencilFunc = this.stencilFunc;
		if ( this.stencilRef !== 0 ) data.stencilRef = this.stencilRef;
		if ( this.stencilFuncMask !== 0xff ) data.stencilFuncMask = this.stencilFuncMask;
		if ( this.stencilFail !== KeepStencilOp ) data.stencilFail = this.stencilFail;
		if ( this.stencilZFail !== KeepStencilOp ) data.stencilZFail = this.stencilZFail;
		if ( this.stencilZPass !== KeepStencilOp ) data.stencilZPass = this.stencilZPass;
		if ( this.stencilWrite === true ) data.stencilWrite = this.stencilWrite;

		// rotation (SpriteMaterial)
		if ( this.rotation !== undefined && this.rotation !== 0 ) data.rotation = this.rotation;

		if ( this.polygonOffset === true ) data.polygonOffset = true;
		if ( this.polygonOffsetFactor !== 0 ) data.polygonOffsetFactor = this.polygonOffsetFactor;
		if ( this.polygonOffsetUnits !== 0 ) data.polygonOffsetUnits = this.polygonOffsetUnits;

		if ( this.linewidth !== undefined && this.linewidth !== 1 ) data.linewidth = this.linewidth;
		if ( this.dashSize !== undefined ) data.dashSize = this.dashSize;
		if ( this.gapSize !== undefined ) data.gapSize = this.gapSize;
		if ( this.scale !== undefined ) data.scale = this.scale;

		if ( this.dithering === true ) data.dithering = true;

		if ( this.alphaTest > 0 ) data.alphaTest = this.alphaTest;
		if ( this.alphaHash === true ) data.alphaHash = true;
		if ( this.alphaToCoverage === true ) data.alphaToCoverage = true;
		if ( this.premultipliedAlpha === true ) data.premultipliedAlpha = true;
		if ( this.forceSinglePass === true ) data.forceSinglePass = true;

		if ( this.wireframe === true ) data.wireframe = true;
		if ( this.wireframeLinewidth > 1 ) data.wireframeLinewidth = this.wireframeLinewidth;
		if ( this.wireframeLinecap !== 'round' ) data.wireframeLinecap = this.wireframeLinecap;
		if ( this.wireframeLinejoin !== 'round' ) data.wireframeLinejoin = this.wireframeLinejoin;

		if ( this.flatShading === true ) data.flatShading = true;

		if ( this.visible === false ) data.visible = false;

		if ( this.toneMapped === false ) data.toneMapped = false;

		if ( this.fog === false ) data.fog = false;

		if ( Object.keys( this.userData ).length > 0 ) data.userData = this.userData;

		// TODO: Copied from Object3D.toJSON

		function extractFromCache( cache ) {

			const values = [];

			for ( const key in cache ) {

				const data = cache[ key ];
				delete data.metadata;
				values.push( data );

			}

			return values;

		}

		if ( isRootObject ) {

			const textures = extractFromCache( meta.textures );
			const images = extractFromCache( meta.images );

			if ( textures.length > 0 ) data.textures = textures;
			if ( images.length > 0 ) data.images = images;

		}

		return data;

	}

	clone() {

		return new this.constructor().copy( this );

	}

	copy( source ) {

		this.name = source.name;

		this.blending = source.blending;
		this.side = source.side;
		this.vertexColors = source.vertexColors;

		this.opacity = source.opacity;
		this.transparent = source.transparent;

		this.blendSrc = source.blendSrc;
		this.blendDst = source.blendDst;
		this.blendEquation = source.blendEquation;
		this.blendSrcAlpha = source.blendSrcAlpha;
		this.blendDstAlpha = source.blendDstAlpha;
		this.blendEquationAlpha = source.blendEquationAlpha;
		this.blendColor.copy( source.blendColor );
		this.blendAlpha = source.blendAlpha;

		this.depthFunc = source.depthFunc;
		this.depthTest = source.depthTest;
		this.depthWrite = source.depthWrite;

		this.stencilWriteMask = source.stencilWriteMask;
		this.stencilFunc = source.stencilFunc;
		this.stencilRef = source.stencilRef;
		this.stencilFuncMask = source.stencilFuncMask;
		this.stencilFail = source.stencilFail;
		this.stencilZFail = source.stencilZFail;
		this.stencilZPass = source.stencilZPass;
		this.stencilWrite = source.stencilWrite;

		const srcPlanes = source.clippingPlanes;
		let dstPlanes = null;

		if ( srcPlanes !== null ) {

			const n = srcPlanes.length;
			dstPlanes = new Array( n );

			for ( let i = 0; i !== n; ++ i ) {

				dstPlanes[ i ] = srcPlanes[ i ].clone();

			}

		}

		this.clippingPlanes = dstPlanes;
		this.clipIntersection = source.clipIntersection;
		this.clipShadows = source.clipShadows;

		this.shadowSide = source.shadowSide;

		this.colorWrite = source.colorWrite;

		this.precision = source.precision;

		this.polygonOffset = source.polygonOffset;
		this.polygonOffsetFactor = source.polygonOffsetFactor;
		this.polygonOffsetUnits = source.polygonOffsetUnits;

		this.dithering = source.dithering;

		this.alphaTest = source.alphaTest;
		this.alphaHash = source.alphaHash;
		this.alphaToCoverage = source.alphaToCoverage;
		this.premultipliedAlpha = source.premultipliedAlpha;
		this.forceSinglePass = source.forceSinglePass;

		this.visible = source.visible;

		this.toneMapped = source.toneMapped;

		this.userData = JSON.parse( JSON.stringify( source.userData ) );

		return this;

	}

	dispose() {

		this.dispatchEvent( { type: 'dispose' } );

	}

	set needsUpdate( value ) {

		if ( value === true ) this.version ++;

	}

}

class MeshBasicMaterial extends Material {

	constructor( parameters ) {

		super();

		this.isMeshBasicMaterial = true;

		this.type = 'MeshBasicMaterial';

		this.color = new Color( 0xffffff ); // emissive

		this.map = null;

		this.lightMap = null;
		this.lightMapIntensity = 1.0;

		this.aoMap = null;
		this.aoMapIntensity = 1.0;

		this.specularMap = null;

		this.alphaMap = null;

		this.envMap = null;
		this.envMapRotation = new Euler();
		this.combine = MultiplyOperation;
		this.reflectivity = 1;
		this.refractionRatio = 0.98;

		this.wireframe = false;
		this.wireframeLinewidth = 1;
		this.wireframeLinecap = 'round';
		this.wireframeLinejoin = 'round';

		this.fog = true;

		this.setValues( parameters );

	}

	copy( source ) {

		super.copy( source );

		this.color.copy( source.color );

		this.map = source.map;

		this.lightMap = source.lightMap;
		this.lightMapIntensity = source.lightMapIntensity;

		this.aoMap = source.aoMap;
		this.aoMapIntensity = source.aoMapIntensity;

		this.specularMap = source.specularMap;

		this.alphaMap = source.alphaMap;

		this.envMap = source.envMap;
		this.envMapRotation.copy( source.envMapRotation );
		this.combine = source.combine;
		this.reflectivity = source.reflectivity;
		this.refractionRatio = source.refractionRatio;

		this.wireframe = source.wireframe;
		this.wireframeLinewidth = source.wireframeLinewidth;
		this.wireframeLinecap = source.wireframeLinecap;
		this.wireframeLinejoin = source.wireframeLinejoin;

		this.fog = source.fog;

		return this;

	}

}

// Fast Half Float Conversions, http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf

const _tables = /*@__PURE__*/ _generateTables();

function _generateTables() {

	// float32 to float16 helpers

	const buffer = new ArrayBuffer( 4 );
	const floatView = new Float32Array( buffer );
	const uint32View = new Uint32Array( buffer );

	const baseTable = new Uint32Array( 512 );
	const shiftTable = new Uint32Array( 512 );

	for ( let i = 0; i < 256; ++ i ) {

		const e = i - 127;

		// very small number (0, -0)

		if ( e < - 27 ) {

			baseTable[ i ] = 0x0000;
			baseTable[ i | 0x100 ] = 0x8000;
			shiftTable[ i ] = 24;
			shiftTable[ i | 0x100 ] = 24;

			// small number (denorm)

		} else if ( e < - 14 ) {

			baseTable[ i ] = 0x0400 >> ( - e - 14 );
			baseTable[ i | 0x100 ] = ( 0x0400 >> ( - e - 14 ) ) | 0x8000;
			shiftTable[ i ] = - e - 1;
			shiftTable[ i | 0x100 ] = - e - 1;

			// normal number

		} else if ( e <= 15 ) {

			baseTable[ i ] = ( e + 15 ) << 10;
			baseTable[ i | 0x100 ] = ( ( e + 15 ) << 10 ) | 0x8000;
			shiftTable[ i ] = 13;
			shiftTable[ i | 0x100 ] = 13;

			// large number (Infinity, -Infinity)

		} else if ( e < 128 ) {

			baseTable[ i ] = 0x7c00;
			baseTable[ i | 0x100 ] = 0xfc00;
			shiftTable[ i ] = 24;
			shiftTable[ i | 0x100 ] = 24;

			// stay (NaN, Infinity, -Infinity)

		} else {

			baseTable[ i ] = 0x7c00;
			baseTable[ i | 0x100 ] = 0xfc00;
			shiftTable[ i ] = 13;
			shiftTable[ i | 0x100 ] = 13;

		}

	}

	// float16 to float32 helpers

	const mantissaTable = new Uint32Array( 2048 );
	const exponentTable = new Uint32Array( 64 );
	const offsetTable = new Uint32Array( 64 );

	for ( let i = 1; i < 1024; ++ i ) {

		let m = i << 13; // zero pad mantissa bits
		let e = 0; // zero exponent

		// normalized
		while ( ( m & 0x00800000 ) === 0 ) {

			m <<= 1;
			e -= 0x00800000; // decrement exponent

		}

		m &= ~ 0x00800000; // clear leading 1 bit
		e += 0x38800000; // adjust bias

		mantissaTable[ i ] = m | e;

	}

	for ( let i = 1024; i < 2048; ++ i ) {

		mantissaTable[ i ] = 0x38000000 + ( ( i - 1024 ) << 13 );

	}

	for ( let i = 1; i < 31; ++ i ) {

		exponentTable[ i ] = i << 23;

	}

	exponentTable[ 31 ] = 0x47800000;
	exponentTable[ 32 ] = 0x80000000;

	for ( let i = 33; i < 63; ++ i ) {

		exponentTable[ i ] = 0x80000000 + ( ( i - 32 ) << 23 );

	}

	exponentTable[ 63 ] = 0xc7800000;

	for ( let i = 1; i < 64; ++ i ) {

		if ( i !== 32 ) {

			offsetTable[ i ] = 1024;

		}

	}

	return {
		floatView: floatView,
		uint32View: uint32View,
		baseTable: baseTable,
		shiftTable: shiftTable,
		mantissaTable: mantissaTable,
		exponentTable: exponentTable,
		offsetTable: offsetTable
	};

}

// float32 to float16

function toHalfFloat( val ) {

	if ( Math.abs( val ) > 65504 ) console.warn( 'THREE.DataUtils.toHalfFloat(): Value out of range.' );

	val = clamp( val, - 65504, 65504 );

	_tables.floatView[ 0 ] = val;
	const f = _tables.uint32View[ 0 ];
	const e = ( f >> 23 ) & 0x1ff;
	return _tables.baseTable[ e ] + ( ( f & 0x007fffff ) >> _tables.shiftTable[ e ] );

}

// float16 to float32

function fromHalfFloat( val ) {

	const m = val >> 10;
	_tables.uint32View[ 0 ] = _tables.mantissaTable[ _tables.offsetTable[ m ] + ( val & 0x3ff ) ] + _tables.exponentTable[ m ];
	return _tables.floatView[ 0 ];

}

const DataUtils = {
	toHalfFloat: toHalfFloat,
	fromHalfFloat: fromHalfFloat,
};

const _vector$9 = /*@__PURE__*/ new Vector3();
const _vector2$1 = /*@__PURE__*/ new Vector2();

class BufferAttribute {

	constructor( array, itemSize, normalized = false ) {

		if ( Array.isArray( array ) ) {

			throw new TypeError( 'THREE.BufferAttribute: array should be a Typed Array.' );

		}

		this.isBufferAttribute = true;

		this.name = '';

		this.array = array;
		this.itemSize = itemSize;
		this.count = array !== undefined ? array.length / itemSize : 0;
		this.normalized = normalized;

		this.usage = StaticDrawUsage;
		this._updateRange = { offset: 0, count: - 1 };
		this.updateRanges = [];
		this.gpuType = FloatType;

		this.version = 0;

	}

	onUploadCallback() {}

	set needsUpdate( value ) {

		if ( value === true ) this.version ++;

	}

	get updateRange() {

		warnOnce( 'THREE.BufferAttribute: updateRange() is deprecated and will be removed in r169. Use addUpdateRange() instead.' ); // @deprecated, r159
		return this._updateRange;

	}

	setUsage( value ) {

		this.usage = value;

		return this;

	}

	addUpdateRange( start, count ) {

		this.updateRanges.push( { start, count } );

	}

	clearUpdateRanges() {

		this.updateRanges.length = 0;

	}

	copy( source ) {

		this.name = source.name;
		this.array = new source.array.constructor( source.array );
		this.itemSize = source.itemSize;
		this.count = source.count;
		this.normalized = source.normalized;

		this.usage = source.usage;
		this.gpuType = source.gpuType;

		return this;

	}

	copyAt( index1, attribute, index2 ) {

		index1 *= this.itemSize;
		index2 *= attribute.itemSize;

		for ( let i = 0, l = this.itemSize; i < l; i ++ ) {

			this.array[ index1 + i ] = attribute.array[ index2 + i ];

		}

		return this;

	}

	copyArray( array ) {

		this.array.set( array );

		return this;

	}

	applyMatrix3( m ) {

		if ( this.itemSize === 2 ) {

			for ( let i = 0, l = this.count; i < l; i ++ ) {

				_vector2$1.fromBufferAttribute( this, i );
				_vector2$1.applyMatrix3( m );

				this.setXY( i, _vector2$1.x, _vector2$1.y );

			}

		} else if ( this.itemSize === 3 ) {

			for ( let i = 0, l = this.count; i < l; i ++ ) {

				_vector$9.fromBufferAttribute( this, i );
				_vector$9.applyMatrix3( m );

				this.setXYZ( i, _vector$9.x, _vector$9.y, _vector$9.z );

			}

		}

		return this;

	}

	applyMatrix4( m ) {

		for ( let i = 0, l = this.count; i < l; i ++ ) {

			_vector$9.fromBufferAttribute( this, i );

			_vector$9.applyMatrix4( m );

			this.setXYZ( i, _vector$9.x, _vector$9.y, _vector$9.z );

		}

		return this;

	}

	applyNormalMatrix( m ) {

		for ( let i = 0, l = this.count; i < l; i ++ ) {

			_vector$9.fromBufferAttribute( this, i );

			_vector$9.applyNormalMatrix( m );

			this.setXYZ( i, _vector$9.x, _vector$9.y, _vector$9.z );

		}

		return this;

	}

	transformDirection( m ) {

		for ( let i = 0, l = this.count; i < l; i ++ ) {

			_vector$9.fromBufferAttribute( this, i );

			_vector$9.transformDirection( m );

			this.setXYZ( i, _vector$9.x, _vector$9.y, _vector$9.z );

		}

		return this;

	}

	set( value, offset = 0 ) {

		// Matching BufferAttribute constructor, do not normalize the array.
		this.array.set( value, offset );

		return this;

	}

	getComponent( index, component ) {

		let value = this.array[ index * this.itemSize + component ];

		if ( this.normalized ) value = denormalize( value, this.array );

		return value;

	}

	setComponent( index, component, value ) {

		if ( this.normalized ) value = normalize( value, this.array );

		this.array[ index * this.itemSize + component ] = value;

		return this;

	}

	getX( index ) {

		let x = this.array[ index * this.itemSize ];

		if ( this.normalized ) x = denormalize( x, this.array );

		return x;

	}

	setX( index, x ) {

		if ( this.normalized ) x = normalize( x, this.array );

		this.array[ index * this.itemSize ] = x;

		return this;

	}

	getY( index ) {

		let y = this.array[ index * this.itemSize + 1 ];

		if ( this.normalized ) y = denormalize( y, this.array );

		return y;

	}

	setY( index, y ) {

		if ( this.normalized ) y = normalize( y, this.array );

		this.array[ index * this.itemSize + 1 ] = y;

		return this;

	}

	getZ( index ) {

		let z = this.array[ index * this.itemSize + 2 ];

		if ( this.normalized ) z = denormalize( z, this.array );

		return z;

	}

	setZ( index, z ) {

		if ( this.normalized ) z = normalize( z, this.array );

		this.array[ index * this.itemSize + 2 ] = z;

		return this;

	}

	getW( index ) {

		let w = this.array[ index * this.itemSize + 3 ];

		if ( this.normalized ) w = denormalize( w, this.array );

		return w;

	}

	setW( index, w ) {

		if ( this.normalized ) w = normalize( w, this.array );

		this.array[ index * this.itemSize + 3 ] = w;

		return this;

	}

	setXY( index, x, y ) {

		index *= this.itemSize;

		if ( this.normalized ) {

			x = normalize( x, this.array );
			y = normalize( y, this.array );

		}

		this.array[ index + 0 ] = x;
		this.array[ index + 1 ] = y;

		return this;

	}

	setXYZ( index, x, y, z ) {

		index *= this.itemSize;

		if ( this.normalized ) {

			x = normalize( x, this.array );
			y = normalize( y, this.array );
			z = normalize( z, this.array );

		}

		this.array[ index + 0 ] = x;
		this.array[ index + 1 ] = y;
		this.array[ index + 2 ] = z;

		return this;

	}

	setXYZW( index, x, y, z, w ) {

		index *= this.itemSize;

		if ( this.normalized ) {

			x = normalize( x, this.array );
			y = normalize( y, this.array );
			z = normalize( z, this.array );
			w = normalize( w, this.array );

		}

		this.array[ index + 0 ] = x;
		this.array[ index + 1 ] = y;
		this.array[ index + 2 ] = z;
		this.array[ index + 3 ] = w;

		return this;

	}

	onUpload( callback ) {

		this.onUploadCallback = callback;

		return this;

	}

	clone() {

		return new this.constructor( this.array, this.itemSize ).copy( this );

	}

	toJSON() {

		const data = {
			itemSize: this.itemSize,
			type: this.array.constructor.name,
			array: Array.from( this.array ),
			normalized: this.normalized
		};

		if ( this.name !== '' ) data.name = this.name;
		if ( this.usage !== StaticDrawUsage ) data.usage = this.usage;

		return data;

	}

}

//

class Int8BufferAttribute extends BufferAttribute {

	constructor( array, itemSize, normalized ) {

		super( new Int8Array( array ), itemSize, normalized );

	}

}

class Uint8BufferAttribute extends BufferAttribute {

	constructor( array, itemSize, normalized ) {

		super( new Uint8Array( array ), itemSize, normalized );

	}

}

class Uint8ClampedBufferAttribute extends BufferAttribute {

	constructor( array, itemSize, normalized ) {

		super( new Uint8ClampedArray( array ), itemSize, normalized );

	}

}

class Int16BufferAttribute extends BufferAttribute {

	constructor( array, itemSize, normalized ) {

		super( new Int16Array( array ), itemSize, normalized );

	}

}

class Uint16BufferAttribute extends BufferAttribute {

	constructor( array, itemSize, normalized ) {

		super( new Uint16Array( array ), itemSize, normalized );

	}

}

class Int32BufferAttribute extends BufferAttribute {

	constructor( array, itemSize, normalized ) {

		super( new Int32Array( array ), itemSize, normalized );

	}

}

class Uint32BufferAttribute extends BufferAttribute {

	constructor( array, itemSize, normalized ) {

		super( new Uint32Array( array ), itemSize, normalized );

	}

}

class Float16BufferAttribute extends BufferAttribute {

	constructor( array, itemSize, normalized ) {

		super( new Uint16Array( array ), itemSize, normalized );

		this.isFloat16BufferAttribute = true;

	}

	getX( index ) {

		let x = fromHalfFloat( this.array[ index * this.itemSize ] );

		if ( this.normalized ) x = denormalize( x, this.array );

		return x;

	}

	setX( index, x ) {

		if ( this.normalized ) x = normalize( x, this.array );

		this.array[ index * this.itemSize ] = toHalfFloat( x );

		return this;

	}

	getY( index ) {

		let y = fromHalfFloat( this.array[ index * this.itemSize + 1 ] );

		if ( this.normalized ) y = denormalize( y, this.array );

		return y;

	}

	setY( index, y ) {

		if ( this.normalized ) y = normalize( y, this.array );

		this.array[ index * this.itemSize + 1 ] = toHalfFloat( y );

		return this;

	}

	getZ( index ) {

		let z = fromHalfFloat( this.array[ index * this.itemSize + 2 ] );

		if ( this.normalized ) z = denormalize( z, this.array );

		return z;

	}

	setZ( index, z ) {

		if ( this.normalized ) z = normalize( z, this.array );

		this.array[ index * this.itemSize + 2 ] = toHalfFloat( z );

		return this;

	}

	getW( index ) {

		let w = fromHalfFloat( this.array[ index * this.itemSize + 3 ] );

		if ( this.normalized ) w = denormalize( w, this.array );

		return w;

	}

	setW( index, w ) {

		if ( this.normalized ) w = normalize( w, this.array );

		this.array[ index * this.itemSize + 3 ] = toHalfFloat( w );

		return this;

	}

	setXY( index, x, y ) {

		index *= this.itemSize;

		if ( this.normalized ) {

			x = normalize( x, this.array );
			y = normalize( y, this.array );

		}

		this.array[ index + 0 ] = toHalfFloat( x );
		this.array[ index + 1 ] = toHalfFloat( y );

		return this;

	}

	setXYZ( index, x, y, z ) {

		index *= this.itemSize;

		if ( this.normalized ) {

			x = normalize( x, this.array );
			y = normalize( y, this.array );
			z = normalize( z, this.array );

		}

		this.array[ index + 0 ] = toHalfFloat( x );
		this.array[ index + 1 ] = toHalfFloat( y );
		this.array[ index + 2 ] = toHalfFloat( z );

		return this;

	}

	setXYZW( index, x, y, z, w ) {

		index *= this.itemSize;

		if ( this.normalized ) {

			x = normalize( x, this.array );
			y = normalize( y, this.array );
			z = normalize( z, this.array );
			w = normalize( w, this.array );

		}

		this.array[ index + 0 ] = toHalfFloat( x );
		this.array[ index + 1 ] = toHalfFloat( y );
		this.array[ index + 2 ] = toHalfFloat( z );
		this.array[ index + 3 ] = toHalfFloat( w );

		return this;

	}

}


class Float32BufferAttribute extends BufferAttribute {

	constructor( array, itemSize, normalized ) {

		super( new Float32Array( array ), itemSize, normalized );

	}

}

let _id$2 = 0;

const _m1$2 = /*@__PURE__*/ new Matrix4();
const _obj = /*@__PURE__*/ new Object3D();
const _offset = /*@__PURE__*/ new Vector3();
const _box$2 = /*@__PURE__*/ new Box3();
const _boxMorphTargets = /*@__PURE__*/ new Box3();
const _vector$8 = /*@__PURE__*/ new Vector3();

class BufferGeometry extends EventDispatcher {

	constructor() {

		super();

		this.isBufferGeometry = true;

		Object.defineProperty( this, 'id', { value: _id$2 ++ } );

		this.uuid = generateUUID();

		this.name = '';
		this.type = 'BufferGeometry';

		this.index = null;
		this.attributes = {};

		this.morphAttributes = {};
		this.morphTargetsRelative = false;

		this.groups = [];

		this.boundingBox = null;
		this.boundingSphere = null;

		this.drawRange = { start: 0, count: Infinity };

		this.userData = {};

	}

	getIndex() {

		return this.index;

	}

	setIndex( index ) {

		if ( Array.isArray( index ) ) {

			this.index = new ( arrayNeedsUint32( index ) ? Uint32BufferAttribute : Uint16BufferAttribute )( index, 1 );

		} else {

			this.index = index;

		}

		return this;

	}

	getAttribute( name ) {

		return this.attributes[ name ];

	}

	setAttribute( name, attribute ) {

		this.attributes[ name ] = attribute;

		return this;

	}

	deleteAttribute( name ) {

		delete this.attributes[ name ];

		return this;

	}

	hasAttribute( name ) {

		return this.attributes[ name ] !== undefined;

	}

	addGroup( start, count, materialIndex = 0 ) {

		this.groups.push( {

			start: start,
			count: count,
			materialIndex: materialIndex

		} );

	}

	clearGroups() {

		this.groups = [];

	}

	setDrawRange( start, count ) {

		this.drawRange.start = start;
		this.drawRange.count = count;

	}

	applyMatrix4( matrix ) {

		const position = this.attributes.position;

		if ( position !== undefined ) {

			position.applyMatrix4( matrix );

			position.needsUpdate = true;

		}

		const normal = this.attributes.normal;

		if ( normal !== undefined ) {

			const normalMatrix = new Matrix3().getNormalMatrix( matrix );

			normal.applyNormalMatrix( normalMatrix );

			normal.needsUpdate = true;

		}

		const tangent = this.attributes.tangent;

		if ( tangent !== undefined ) {

			tangent.transformDirection( matrix );

			tangent.needsUpdate = true;

		}

		if ( this.boundingBox !== null ) {

			this.computeBoundingBox();

		}

		if ( this.boundingSphere !== null ) {

			this.computeBoundingSphere();

		}

		return this;

	}

	applyQuaternion( q ) {

		_m1$2.makeRotationFromQuaternion( q );

		this.applyMatrix4( _m1$2 );

		return this;

	}

	rotateX( angle ) {

		// rotate geometry around world x-axis

		_m1$2.makeRotationX( angle );

		this.applyMatrix4( _m1$2 );

		return this;

	}

	rotateY( angle ) {

		// rotate geometry around world y-axis

		_m1$2.makeRotationY( angle );

		this.applyMatrix4( _m1$2 );

		return this;

	}

	rotateZ( angle ) {

		// rotate geometry around world z-axis

		_m1$2.makeRotationZ( angle );

		this.applyMatrix4( _m1$2 );

		return this;

	}

	translate( x, y, z ) {

		// translate geometry

		_m1$2.makeTranslation( x, y, z );

		this.applyMatrix4( _m1$2 );

		return this;

	}

	scale( x, y, z ) {

		// scale geometry

		_m1$2.makeScale( x, y, z );

		this.applyMatrix4( _m1$2 );

		return this;

	}

	lookAt( vector ) {

		_obj.lookAt( vector );

		_obj.updateMatrix();

		this.applyMatrix4( _obj.matrix );

		return this;

	}

	center() {

		this.computeBoundingBox();

		this.boundingBox.getCenter( _offset ).negate();

		this.translate( _offset.x, _offset.y, _offset.z );

		return this;

	}

	setFromPoints( points ) {

		const position = [];

		for ( let i = 0, l = points.length; i < l; i ++ ) {

			const point = points[ i ];
			position.push( point.x, point.y, point.z || 0 );

		}

		this.setAttribute( 'position', new Float32BufferAttribute( position, 3 ) );

		return this;

	}

	computeBoundingBox() {

		if ( this.boundingBox === null ) {

			this.boundingBox = new Box3();

		}

		const position = this.attributes.position;
		const morphAttributesPosition = this.morphAttributes.position;

		if ( position && position.isGLBufferAttribute ) {

			console.error( 'THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.', this );

			this.boundingBox.set(
				new Vector3( - Infinity, - Infinity, - Infinity ),
				new Vector3( + Infinity, + Infinity, + Infinity )
			);

			return;

		}

		if ( position !== undefined ) {

			this.boundingBox.setFromBufferAttribute( position );

			// process morph attributes if present

			if ( morphAttributesPosition ) {

				for ( let i = 0, il = morphAttributesPosition.length; i < il; i ++ ) {

					const morphAttribute = morphAttributesPosition[ i ];
					_box$2.setFromBufferAttribute( morphAttribute );

					if ( this.morphTargetsRelative ) {

						_vector$8.addVectors( this.boundingBox.min, _box$2.min );
						this.boundingBox.expandByPoint( _vector$8 );

						_vector$8.addVectors( this.boundingBox.max, _box$2.max );
						this.boundingBox.expandByPoint( _vector$8 );

					} else {

						this.boundingBox.expandByPoint( _box$2.min );
						this.boundingBox.expandByPoint( _box$2.max );

					}

				}

			}

		} else {

			this.boundingBox.makeEmpty();

		}

		if ( isNaN( this.boundingBox.min.x ) || isNaN( this.boundingBox.min.y ) || isNaN( this.boundingBox.min.z ) ) {

			console.error( 'THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this );

		}

	}

	computeBoundingSphere() {

		if ( this.boundingSphere === null ) {

			this.boundingSphere = new Sphere();

		}

		const position = this.attributes.position;
		const morphAttributesPosition = this.morphAttributes.position;

		if ( position && position.isGLBufferAttribute ) {

			console.error( 'THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.', this );

			this.boundingSphere.set( new Vector3(), Infinity );

			return;

		}

		if ( position ) {

			// first, find the center of the bounding sphere

			const center = this.boundingSphere.center;

			_box$2.setFromBufferAttribute( position );

			// process morph attributes if present

			if ( morphAttributesPosition ) {

				for ( let i = 0, il = morphAttributesPosition.length; i < il; i ++ ) {

					const morphAttribute = morphAttributesPosition[ i ];
					_boxMorphTargets.setFromBufferAttribute( morphAttribute );

					if ( this.morphTargetsRelative ) {

						_vector$8.addVectors( _box$2.min, _boxMorphTargets.min );
						_box$2.expandByPoint( _vector$8 );

						_vector$8.addVectors( _box$2.max, _boxMorphTargets.max );
						_box$2.expandByPoint( _vector$8 );

					} else {

						_box$2.expandByPoint( _boxMorphTargets.min );
						_box$2.expandByPoint( _boxMorphTargets.max );

					}

				}

			}

			_box$2.getCenter( center );

			// second, try to find a boundingSphere with a radius smaller than the
			// boundingSphere of the boundingBox: sqrt(3) smaller in the best case

			let maxRadiusSq = 0;

			for ( let i = 0, il = position.count; i < il; i ++ ) {

				_vector$8.fromBufferAttribute( position, i );

				maxRadiusSq = Math.max( maxRadiusSq, center.distanceToSquared( _vector$8 ) );

			}

			// process morph attributes if present

			if ( morphAttributesPosition ) {

				for ( let i = 0, il = morphAttributesPosition.length; i < il; i ++ ) {

					const morphAttribute = morphAttributesPosition[ i ];
					const morphTargetsRelative = this.morphTargetsRelative;

					for ( let j = 0, jl = morphAttribute.count; j < jl; j ++ ) {

						_vector$8.fromBufferAttribute( morphAttribute, j );

						if ( morphTargetsRelative ) {

							_offset.fromBufferAttribute( position, j );
							_vector$8.add( _offset );

						}

						maxRadiusSq = Math.max( maxRadiusSq, center.distanceToSquared( _vector$8 ) );

					}

				}

			}

			this.boundingSphere.radius = Math.sqrt( maxRadiusSq );

			if ( isNaN( this.boundingSphere.radius ) ) {

				console.error( 'THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this );

			}

		}

	}

	computeTangents() {

		const index = this.index;
		const attributes = this.attributes;

		// based on http://www.terathon.com/code/tangent.html
		// (per vertex tangents)

		if ( index === null ||
			 attributes.position === undefined ||
			 attributes.normal === undefined ||
			 attributes.uv === undefined ) {

			console.error( 'THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)' );
			return;

		}

		const positionAttribute = attributes.position;
		const normalAttribute = attributes.normal;
		const uvAttribute = attributes.uv;

		if ( this.hasAttribute( 'tangent' ) === false ) {

			this.setAttribute( 'tangent', new BufferAttribute( new Float32Array( 4 * positionAttribute.count ), 4 ) );

		}

		const tangentAttribute = this.getAttribute( 'tangent' );

		const tan1 = [], tan2 = [];

		for ( let i = 0; i < positionAttribute.count; i ++ ) {

			tan1[ i ] = new Vector3();
			tan2[ i ] = new Vector3();

		}

		const vA = new Vector3(),
			vB = new Vector3(),
			vC = new Vector3(),

			uvA = new Vector2(),
			uvB = new Vector2(),
			uvC = new Vector2(),

			sdir = new Vector3(),
			tdir = new Vector3();

		function handleTriangle( a, b, c ) {

			vA.fromBufferAttribute( positionAttribute, a );
			vB.fromBufferAttribute( positionAttribute, b );
			vC.fromBufferAttribute( positionAttribute, c );

			uvA.fromBufferAttribute( uvAttribute, a );
			uvB.fromBufferAttribute( uvAttribute, b );
			uvC.fromBufferAttribute( uvAttribute, c );

			vB.sub( vA );
			vC.sub( vA );

			uvB.sub( uvA );
			uvC.sub( uvA );

			const r = 1.0 / ( uvB.x * uvC.y - uvC.x * uvB.y );

			// silently ignore degenerate uv triangles having coincident or colinear vertices

			if ( ! isFinite( r ) ) return;

			sdir.copy( vB ).multiplyScalar( uvC.y ).addScaledVector( vC, - uvB.y ).multiplyScalar( r );
			tdir.copy( vC ).multiplyScalar( uvB.x ).addScaledVector( vB, - uvC.x ).multiplyScalar( r );

			tan1[ a ].add( sdir );
			tan1[ b ].add( sdir );
			tan1[ c ].add( sdir );

			tan2[ a ].add( tdir );
			tan2[ b ].add( tdir );
			tan2[ c ].add( tdir );

		}

		let groups = this.groups;

		if ( groups.length === 0 ) {

			groups = [ {
				start: 0,
				count: index.count
			} ];

		}

		for ( let i = 0, il = groups.length; i < il; ++ i ) {

			const group = groups[ i ];

			const start = group.start;
			const count = group.count;

			for ( let j = start, jl = start + count; j < jl; j += 3 ) {

				handleTriangle(
					index.getX( j + 0 ),
					index.getX( j + 1 ),
					index.getX( j + 2 )
				);

			}

		}

		const tmp = new Vector3(), tmp2 = new Vector3();
		const n = new Vector3(), n2 = new Vector3();

		function handleVertex( v ) {

			n.fromBufferAttribute( normalAttribute, v );
			n2.copy( n );

			const t = tan1[ v ];

			// Gram-Schmidt orthogonalize

			tmp.copy( t );
			tmp.sub( n.multiplyScalar( n.dot( t ) ) ).normalize();

			// Calculate handedness

			tmp2.crossVectors( n2, t );
			const test = tmp2.dot( tan2[ v ] );
			const w = ( test < 0.0 ) ? - 1.0 : 1.0;

			tangentAttribute.setXYZW( v, tmp.x, tmp.y, tmp.z, w );

		}

		for ( let i = 0, il = groups.length; i < il; ++ i ) {

			const group = groups[ i ];

			const start = group.start;
			const count = group.count;

			for ( let j = start, jl = start + count; j < jl; j += 3 ) {

				handleVertex( index.getX( j + 0 ) );
				handleVertex( index.getX( j + 1 ) );
				handleVertex( index.getX( j + 2 ) );

			}

		}

	}

	computeVertexNormals() {

		const index = this.index;
		const positionAttribute = this.getAttribute( 'position' );

		if ( positionAttribute !== undefined ) {

			let normalAttribute = this.getAttribute( 'normal' );

			if ( normalAttribute === undefined ) {

				normalAttribute = new BufferAttribute( new Float32Array( positionAttribute.count * 3 ), 3 );
				this.setAttribute( 'normal', normalAttribute );

			} else {

				// reset existing normals to zero

				for ( let i = 0, il = normalAttribute.count; i < il; i ++ ) {

					normalAttribute.setXYZ( i, 0, 0, 0 );

				}

			}

			const pA = new Vector3(), pB = new Vector3(), pC = new Vector3();
			const nA = new Vector3(), nB = new Vector3(), nC = new Vector3();
			const cb = new Vector3(), ab = new Vector3();

			// indexed elements

			if ( index ) {

				for ( let i = 0, il = index.count; i < il; i += 3 ) {

					const vA = index.getX( i + 0 );
					const vB = index.getX( i + 1 );
					const vC = index.getX( i + 2 );

					pA.fromBufferAttribute( positionAttribute, vA );
					pB.fromBufferAttribute( positionAttribute, vB );
					pC.fromBufferAttribute( positionAttribute, vC );

					cb.subVectors( pC, pB );
					ab.subVectors( pA, pB );
					cb.cross( ab );

					nA.fromBufferAttribute( normalAttribute, vA );
					nB.fromBufferAttribute( normalAttribute, vB );
					nC.fromBufferAttribute( normalAttribute, vC );

					nA.add( cb );
					nB.add( cb );
					nC.add( cb );

					normalAttribute.setXYZ( vA, nA.x, nA.y, nA.z );
					normalAttribute.setXYZ( vB, nB.x, nB.y, nB.z );
					normalAttribute.setXYZ( vC, nC.x, nC.y, nC.z );

				}

			} else {

				// non-indexed elements (unconnected triangle soup)

				for ( let i = 0, il = positionAttribute.count; i < il; i += 3 ) {

					pA.fromBufferAttribute( positionAttribute, i + 0 );
					pB.fromBufferAttribute( positionAttribute, i + 1 );
					pC.fromBufferAttribute( positionAttribute, i + 2 );

					cb.subVectors( pC, pB );
					ab.subVectors( pA, pB );
					cb.cross( ab );

					normalAttribute.setXYZ( i + 0, cb.x, cb.y, cb.z );
					normalAttribute.setXYZ( i + 1, cb.x, cb.y, cb.z );
					normalAttribute.setXYZ( i + 2, cb.x, cb.y, cb.z );

				}

			}

			this.normalizeNormals();

			normalAttribute.needsUpdate = true;

		}

	}

	normalizeNormals() {

		const normals = this.attributes.normal;

		for ( let i = 0, il = normals.count; i < il; i ++ ) {

			_vector$8.fromBufferAttribute( normals, i );

			_vector$8.normalize();

			normals.setXYZ( i, _vector$8.x, _vector$8.y, _vector$8.z );

		}

	}

	toNonIndexed() {

		function convertBufferAttribute( attribute, indices ) {

			const array = attribute.array;
			const itemSize = attribute.itemSize;
			const normalized = attribute.normalized;

			const array2 = new array.constructor( indices.length * itemSize );

			let index = 0, index2 = 0;

			for ( let i = 0, l = indices.length; i < l; i ++ ) {

				if ( attribute.isInterleavedBufferAttribute ) {

					index = indices[ i ] * attribute.data.stride + attribute.offset;

				} else {

					index = indices[ i ] * itemSize;

				}

				for ( let j = 0; j < itemSize; j ++ ) {

					array2[ index2 ++ ] = array[ index ++ ];

				}

			}

			return new BufferAttribute( array2, itemSize, normalized );

		}

		//

		if ( this.index === null ) {

			console.warn( 'THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.' );
			return this;

		}

		const geometry2 = new BufferGeometry();

		const indices = this.index.array;
		const attributes = this.attributes;

		// attributes

		for ( const name in attributes ) {

			const attribute = attributes[ name ];

			const newAttribute = convertBufferAttribute( attribute, indices );

			geometry2.setAttribute( name, newAttribute );

		}

		// morph attributes

		const morphAttributes = this.morphAttributes;

		for ( const name in morphAttributes ) {

			const morphArray = [];
			const morphAttribute = morphAttributes[ name ]; // morphAttribute: array of Float32BufferAttributes

			for ( let i = 0, il = morphAttribute.length; i < il; i ++ ) {

				const attribute = morphAttribute[ i ];

				const newAttribute = convertBufferAttribute( attribute, indices );

				morphArray.push( newAttribute );

			}

			geometry2.morphAttributes[ name ] = morphArray;

		}

		geometry2.morphTargetsRelative = this.morphTargetsRelative;

		// groups

		const groups = this.groups;

		for ( let i = 0, l = groups.length; i < l; i ++ ) {

			const group = groups[ i ];
			geometry2.addGroup( group.start, group.count, group.materialIndex );

		}

		return geometry2;

	}

	toJSON() {

		const data = {
			metadata: {
				version: 4.6,
				type: 'BufferGeometry',
				generator: 'BufferGeometry.toJSON'
			}
		};

		// standard BufferGeometry serialization

		data.uuid = this.uuid;
		data.type = this.type;
		if ( this.name !== '' ) data.name = this.name;
		if ( Object.keys( this.userData ).length > 0 ) data.userData = this.userData;

		if ( this.parameters !== undefined ) {

			const parameters = this.parameters;

			for ( const key in parameters ) {

				if ( parameters[ key ] !== undefined ) data[ key ] = parameters[ key ];

			}

			return data;

		}

		// for simplicity the code assumes attributes are not shared across geometries, see #15811

		data.data = { attributes: {} };

		const index = this.index;

		if ( index !== null ) {

			data.data.index = {
				type: index.array.constructor.name,
				array: Array.prototype.slice.call( index.array )
			};

		}

		const attributes = this.attributes;

		for ( const key in attributes ) {

			const attribute = attributes[ key ];

			data.data.attributes[ key ] = attribute.toJSON( data.data );

		}

		const morphAttributes = {};
		let hasMorphAttributes = false;

		for ( const key in this.morphAttributes ) {

			const attributeArray = this.morphAttributes[ key ];

			const array = [];

			for ( let i = 0, il = attributeArray.length; i < il; i ++ ) {

				const attribute = attributeArray[ i ];

				array.push( attribute.toJSON( data.data ) );

			}

			if ( array.length > 0 ) {

				morphAttributes[ key ] = array;

				hasMorphAttributes = true;

			}

		}

		if ( hasMorphAttributes ) {

			data.data.morphAttributes = morphAttributes;
			data.data.morphTargetsRelative = this.morphTargetsRelative;

		}

		const groups = this.groups;

		if ( groups.length > 0 ) {

			data.data.groups = JSON.parse( JSON.stringify( groups ) );

		}

		const boundingSphere = this.boundingSphere;

		if ( boundingSphere !== null ) {

			data.data.boundingSphere = {
				center: boundingSphere.center.toArray(),
				radius: boundingSphere.radius
			};

		}

		return data;

	}

	clone() {

		return new this.constructor().copy( this );

	}

	copy( source ) {

		// reset

		this.index = null;
		this.attributes = {};
		this.morphAttributes = {};
		this.groups = [];
		this.boundingBox = null;
		this.boundingSphere = null;

		// used for storing cloned, shared data

		const data = {};

		// name

		this.name = source.name;

		// index

		const index = source.index;

		if ( index !== null ) {

			this.setIndex( index.clone( data ) );

		}

		// attributes

		const attributes = source.attributes;

		for ( const name in attributes ) {

			const attribute = attributes[ name ];
			this.setAttribute( name, attribute.clone( data ) );

		}

		// morph attributes

		const morphAttributes = source.morphAttributes;

		for ( const name in morphAttributes ) {

			const array = [];
			const morphAttribute = morphAttributes[ name ]; // morphAttribute: array of Float32BufferAttributes

			for ( let i = 0, l = morphAttribute.length; i < l; i ++ ) {

				array.push( morphAttribute[ i ].clone( data ) );

			}

			this.morphAttributes[ name ] = array;

		}

		this.morphTargetsRelative = source.morphTargetsRelative;

		// groups

		const groups = source.groups;

		for ( let i = 0, l = groups.length; i < l; i ++ ) {

			const group = groups[ i ];
			this.addGroup( group.start, group.count, group.materialIndex );

		}

		// bounding box

		const boundingBox = source.boundingBox;

		if ( boundingBox !== null ) {

			this.boundingBox = boundingBox.clone();

		}

		// bounding sphere

		const boundingSphere = source.boundingSphere;

		if ( boundingSphere !== null ) {

			this.boundingSphere = boundingSphere.clone();

		}

		// draw range

		this.drawRange.start = source.drawRange.start;
		this.drawRange.count = source.drawRange.count;

		// user data

		this.userData = source.userData;

		return this;

	}

	dispose() {

		this.dispatchEvent( { type: 'dispose' } );

	}

}

const _inverseMatrix$3 = /*@__PURE__*/ new Matrix4();
const _ray$3 = /*@__PURE__*/ new Ray();
const _sphere$6 = /*@__PURE__*/ new Sphere();
const _sphereHitAt = /*@__PURE__*/ new Vector3();

const _vA$1 = /*@__PURE__*/ new Vector3();
const _vB$1 = /*@__PURE__*/ new Vector3();
const _vC$1 = /*@__PURE__*/ new Vector3();

const _tempA = /*@__PURE__*/ new Vector3();
const _morphA = /*@__PURE__*/ new Vector3();

const _uvA$1 = /*@__PURE__*/ new Vector2();
const _uvB$1 = /*@__PURE__*/ new Vector2();
const _uvC$1 = /*@__PURE__*/ new Vector2();

const _normalA = /*@__PURE__*/ new Vector3();
const _normalB = /*@__PURE__*/ new Vector3();
const _normalC = /*@__PURE__*/ new Vector3();

const _intersectionPoint = /*@__PURE__*/ new Vector3();
const _intersectionPointWorld = /*@__PURE__*/ new Vector3();

class Mesh extends Object3D {

	constructor( geometry = new BufferGeometry(), material = new MeshBasicMaterial() ) {

		super();

		this.isMesh = true;

		this.type = 'Mesh';

		this.geometry = geometry;
		this.material = material;

		this.updateMorphTargets();

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		if ( source.morphTargetInfluences !== undefined ) {

			this.morphTargetInfluences = source.morphTargetInfluences.slice();

		}

		if ( source.morphTargetDictionary !== undefined ) {

			this.morphTargetDictionary = Object.assign( {}, source.morphTargetDictionary );

		}

		this.material = Array.isArray( source.material ) ? source.material.slice() : source.material;
		this.geometry = source.geometry;

		return this;

	}

	updateMorphTargets() {

		const geometry = this.geometry;

		const morphAttributes = geometry.morphAttributes;
		const keys = Object.keys( morphAttributes );

		if ( keys.length > 0 ) {

			const morphAttribute = morphAttributes[ keys[ 0 ] ];

			if ( morphAttribute !== undefined ) {

				this.morphTargetInfluences = [];
				this.morphTargetDictionary = {};

				for ( let m = 0, ml = morphAttribute.length; m < ml; m ++ ) {

					const name = morphAttribute[ m ].name || String( m );

					this.morphTargetInfluences.push( 0 );
					this.morphTargetDictionary[ name ] = m;

				}

			}

		}

	}

	getVertexPosition( index, target ) {

		const geometry = this.geometry;
		const position = geometry.attributes.position;
		const morphPosition = geometry.morphAttributes.position;
		const morphTargetsRelative = geometry.morphTargetsRelative;

		target.fromBufferAttribute( position, index );

		const morphInfluences = this.morphTargetInfluences;

		if ( morphPosition && morphInfluences ) {

			_morphA.set( 0, 0, 0 );

			for ( let i = 0, il = morphPosition.length; i < il; i ++ ) {

				const influence = morphInfluences[ i ];
				const morphAttribute = morphPosition[ i ];

				if ( influence === 0 ) continue;

				_tempA.fromBufferAttribute( morphAttribute, index );

				if ( morphTargetsRelative ) {

					_morphA.addScaledVector( _tempA, influence );

				} else {

					_morphA.addScaledVector( _tempA.sub( target ), influence );

				}

			}

			target.add( _morphA );

		}

		return target;

	}

	raycast( raycaster, intersects ) {

		const geometry = this.geometry;
		const material = this.material;
		const matrixWorld = this.matrixWorld;

		if ( material === undefined ) return;

		// test with bounding sphere in world space

		if ( geometry.boundingSphere === null ) geometry.computeBoundingSphere();

		_sphere$6.copy( geometry.boundingSphere );
		_sphere$6.applyMatrix4( matrixWorld );

		// check distance from ray origin to bounding sphere

		_ray$3.copy( raycaster.ray ).recast( raycaster.near );

		if ( _sphere$6.containsPoint( _ray$3.origin ) === false ) {

			if ( _ray$3.intersectSphere( _sphere$6, _sphereHitAt ) === null ) return;

			if ( _ray$3.origin.distanceToSquared( _sphereHitAt ) > ( raycaster.far - raycaster.near ) ** 2 ) return;

		}

		// convert ray to local space of mesh

		_inverseMatrix$3.copy( matrixWorld ).invert();
		_ray$3.copy( raycaster.ray ).applyMatrix4( _inverseMatrix$3 );

		// test with bounding box in local space

		if ( geometry.boundingBox !== null ) {

			if ( _ray$3.intersectsBox( geometry.boundingBox ) === false ) return;

		}

		// test for intersections with geometry

		this._computeIntersections( raycaster, intersects, _ray$3 );

	}

	_computeIntersections( raycaster, intersects, rayLocalSpace ) {

		let intersection;

		const geometry = this.geometry;
		const material = this.material;

		const index = geometry.index;
		const position = geometry.attributes.position;
		const uv = geometry.attributes.uv;
		const uv1 = geometry.attributes.uv1;
		const normal = geometry.attributes.normal;
		const groups = geometry.groups;
		const drawRange = geometry.drawRange;

		if ( index !== null ) {

			// indexed buffer geometry

			if ( Array.isArray( material ) ) {

				for ( let i = 0, il = groups.length; i < il; i ++ ) {

					const group = groups[ i ];
					const groupMaterial = material[ group.materialIndex ];

					const start = Math.max( group.start, drawRange.start );
					const end = Math.min( index.count, Math.min( ( group.start + group.count ), ( drawRange.start + drawRange.count ) ) );

					for ( let j = start, jl = end; j < jl; j += 3 ) {

						const a = index.getX( j );
						const b = index.getX( j + 1 );
						const c = index.getX( j + 2 );

						intersection = checkGeometryIntersection( this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c );

						if ( intersection ) {

							intersection.faceIndex = Math.floor( j / 3 ); // triangle number in indexed buffer semantics
							intersection.face.materialIndex = group.materialIndex;
							intersects.push( intersection );

						}

					}

				}

			} else {

				const start = Math.max( 0, drawRange.start );
				const end = Math.min( index.count, ( drawRange.start + drawRange.count ) );

				for ( let i = start, il = end; i < il; i += 3 ) {

					const a = index.getX( i );
					const b = index.getX( i + 1 );
					const c = index.getX( i + 2 );

					intersection = checkGeometryIntersection( this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c );

					if ( intersection ) {

						intersection.faceIndex = Math.floor( i / 3 ); // triangle number in indexed buffer semantics
						intersects.push( intersection );

					}

				}

			}

		} else if ( position !== undefined ) {

			// non-indexed buffer geometry

			if ( Array.isArray( material ) ) {

				for ( let i = 0, il = groups.length; i < il; i ++ ) {

					const group = groups[ i ];
					const groupMaterial = material[ group.materialIndex ];

					const start = Math.max( group.start, drawRange.start );
					const end = Math.min( position.count, Math.min( ( group.start + group.count ), ( drawRange.start + drawRange.count ) ) );

					for ( let j = start, jl = end; j < jl; j += 3 ) {

						const a = j;
						const b = j + 1;
						const c = j + 2;

						intersection = checkGeometryIntersection( this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c );

						if ( intersection ) {

							intersection.faceIndex = Math.floor( j / 3 ); // triangle number in non-indexed buffer semantics
							intersection.face.materialIndex = group.materialIndex;
							intersects.push( intersection );

						}

					}

				}

			} else {

				const start = Math.max( 0, drawRange.start );
				const end = Math.min( position.count, ( drawRange.start + drawRange.count ) );

				for ( let i = start, il = end; i < il; i += 3 ) {

					const a = i;
					const b = i + 1;
					const c = i + 2;

					intersection = checkGeometryIntersection( this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c );

					if ( intersection ) {

						intersection.faceIndex = Math.floor( i / 3 ); // triangle number in non-indexed buffer semantics
						intersects.push( intersection );

					}

				}

			}

		}

	}

}

function checkIntersection( object, material, raycaster, ray, pA, pB, pC, point ) {

	let intersect;

	if ( material.side === BackSide ) {

		intersect = ray.intersectTriangle( pC, pB, pA, true, point );

	} else {

		intersect = ray.intersectTriangle( pA, pB, pC, ( material.side === FrontSide ), point );

	}

	if ( intersect === null ) return null;

	_intersectionPointWorld.copy( point );
	_intersectionPointWorld.applyMatrix4( object.matrixWorld );

	const distance = raycaster.ray.origin.distanceTo( _intersectionPointWorld );

	if ( distance < raycaster.near || distance > raycaster.far ) return null;

	return {
		distance: distance,
		point: _intersectionPointWorld.clone(),
		object: object
	};

}

function checkGeometryIntersection( object, material, raycaster, ray, uv, uv1, normal, a, b, c ) {

	object.getVertexPosition( a, _vA$1 );
	object.getVertexPosition( b, _vB$1 );
	object.getVertexPosition( c, _vC$1 );

	const intersection = checkIntersection( object, material, raycaster, ray, _vA$1, _vB$1, _vC$1, _intersectionPoint );

	if ( intersection ) {

		if ( uv ) {

			_uvA$1.fromBufferAttribute( uv, a );
			_uvB$1.fromBufferAttribute( uv, b );
			_uvC$1.fromBufferAttribute( uv, c );

			intersection.uv = Triangle.getInterpolation( _intersectionPoint, _vA$1, _vB$1, _vC$1, _uvA$1, _uvB$1, _uvC$1, new Vector2() );

		}

		if ( uv1 ) {

			_uvA$1.fromBufferAttribute( uv1, a );
			_uvB$1.fromBufferAttribute( uv1, b );
			_uvC$1.fromBufferAttribute( uv1, c );

			intersection.uv1 = Triangle.getInterpolation( _intersectionPoint, _vA$1, _vB$1, _vC$1, _uvA$1, _uvB$1, _uvC$1, new Vector2() );

		}

		if ( normal ) {

			_normalA.fromBufferAttribute( normal, a );
			_normalB.fromBufferAttribute( normal, b );
			_normalC.fromBufferAttribute( normal, c );

			intersection.normal = Triangle.getInterpolation( _intersectionPoint, _vA$1, _vB$1, _vC$1, _normalA, _normalB, _normalC, new Vector3() );

			if ( intersection.normal.dot( ray.direction ) > 0 ) {

				intersection.normal.multiplyScalar( - 1 );

			}

		}

		const face = {
			a: a,
			b: b,
			c: c,
			normal: new Vector3(),
			materialIndex: 0
		};

		Triangle.getNormal( _vA$1, _vB$1, _vC$1, face.normal );

		intersection.face = face;

	}

	return intersection;

}

class BoxGeometry extends BufferGeometry {

	constructor( width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1 ) {

		super();

		this.type = 'BoxGeometry';

		this.parameters = {
			width: width,
			height: height,
			depth: depth,
			widthSegments: widthSegments,
			heightSegments: heightSegments,
			depthSegments: depthSegments
		};

		const scope = this;

		// segments

		widthSegments = Math.floor( widthSegments );
		heightSegments = Math.floor( heightSegments );
		depthSegments = Math.floor( depthSegments );

		// buffers

		const indices = [];
		const vertices = [];
		const normals = [];
		const uvs = [];

		// helper variables

		let numberOfVertices = 0;
		let groupStart = 0;

		// build each side of the box geometry

		buildPlane( 'z', 'y', 'x', - 1, - 1, depth, height, width, depthSegments, heightSegments, 0 ); // px
		buildPlane( 'z', 'y', 'x', 1, - 1, depth, height, - width, depthSegments, heightSegments, 1 ); // nx
		buildPlane( 'x', 'z', 'y', 1, 1, width, depth, height, widthSegments, depthSegments, 2 ); // py
		buildPlane( 'x', 'z', 'y', 1, - 1, width, depth, - height, widthSegments, depthSegments, 3 ); // ny
		buildPlane( 'x', 'y', 'z', 1, - 1, width, height, depth, widthSegments, heightSegments, 4 ); // pz
		buildPlane( 'x', 'y', 'z', - 1, - 1, width, height, - depth, widthSegments, heightSegments, 5 ); // nz

		// build geometry

		this.setIndex( indices );
		this.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.setAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
		this.setAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

		function buildPlane( u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex ) {

			const segmentWidth = width / gridX;
			const segmentHeight = height / gridY;

			const widthHalf = width / 2;
			const heightHalf = height / 2;
			const depthHalf = depth / 2;

			const gridX1 = gridX + 1;
			const gridY1 = gridY + 1;

			let vertexCounter = 0;
			let groupCount = 0;

			const vector = new Vector3();

			// generate vertices, normals and uvs

			for ( let iy = 0; iy < gridY1; iy ++ ) {

				const y = iy * segmentHeight - heightHalf;

				for ( let ix = 0; ix < gridX1; ix ++ ) {

					const x = ix * segmentWidth - widthHalf;

					// set values to correct vector component

					vector[ u ] = x * udir;
					vector[ v ] = y * vdir;
					vector[ w ] = depthHalf;

					// now apply vector to vertex buffer

					vertices.push( vector.x, vector.y, vector.z );

					// set values to correct vector component

					vector[ u ] = 0;
					vector[ v ] = 0;
					vector[ w ] = depth > 0 ? 1 : - 1;

					// now apply vector to normal buffer

					normals.push( vector.x, vector.y, vector.z );

					// uvs

					uvs.push( ix / gridX );
					uvs.push( 1 - ( iy / gridY ) );

					// counters

					vertexCounter += 1;

				}

			}

			// indices

			// 1. you need three indices to draw a single face
			// 2. a single segment consists of two faces
			// 3. so we need to generate six (2*3) indices per segment

			for ( let iy = 0; iy < gridY; iy ++ ) {

				for ( let ix = 0; ix < gridX; ix ++ ) {

					const a = numberOfVertices + ix + gridX1 * iy;
					const b = numberOfVertices + ix + gridX1 * ( iy + 1 );
					const c = numberOfVertices + ( ix + 1 ) + gridX1 * ( iy + 1 );
					const d = numberOfVertices + ( ix + 1 ) + gridX1 * iy;

					// faces

					indices.push( a, b, d );
					indices.push( b, c, d );

					// increase counter

					groupCount += 6;

				}

			}

			// add a group to the geometry. this will ensure multi material support

			scope.addGroup( groupStart, groupCount, materialIndex );

			// calculate new start value for groups

			groupStart += groupCount;

			// update total number of vertices

			numberOfVertices += vertexCounter;

		}

	}

	copy( source ) {

		super.copy( source );

		this.parameters = Object.assign( {}, source.parameters );

		return this;

	}

	static fromJSON( data ) {

		return new BoxGeometry( data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments );

	}

}

/**
 * Uniform Utilities
 */

function cloneUniforms( src ) {

	const dst = {};

	for ( const u in src ) {

		dst[ u ] = {};

		for ( const p in src[ u ] ) {

			const property = src[ u ][ p ];

			if ( property && ( property.isColor ||
				property.isMatrix3 || property.isMatrix4 ||
				property.isVector2 || property.isVector3 || property.isVector4 ||
				property.isTexture || property.isQuaternion ) ) {

				if ( property.isRenderTargetTexture ) {

					console.warn( 'UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms().' );
					dst[ u ][ p ] = null;

				} else {

					dst[ u ][ p ] = property.clone();

				}

			} else if ( Array.isArray( property ) ) {

				dst[ u ][ p ] = property.slice();

			} else {

				dst[ u ][ p ] = property;

			}

		}

	}

	return dst;

}

function mergeUniforms( uniforms ) {

	const merged = {};

	for ( let u = 0; u < uniforms.length; u ++ ) {

		const tmp = cloneUniforms( uniforms[ u ] );

		for ( const p in tmp ) {

			merged[ p ] = tmp[ p ];

		}

	}

	return merged;

}

function cloneUniformsGroups( src ) {

	const dst = [];

	for ( let u = 0; u < src.length; u ++ ) {

		dst.push( src[ u ].clone() );

	}

	return dst;

}

function getUnlitUniformColorSpace( renderer ) {

	const currentRenderTarget = renderer.getRenderTarget();

	if ( currentRenderTarget === null ) {

		// https://github.com/mrdoob/three.js/pull/23937#issuecomment-1111067398
		return renderer.outputColorSpace;

	}

	// https://github.com/mrdoob/three.js/issues/27868
	if ( currentRenderTarget.isXRRenderTarget === true ) {

		return currentRenderTarget.texture.colorSpace;

	}

	return ColorManagement.workingColorSpace;

}

// Legacy

const UniformsUtils = { clone: cloneUniforms, merge: mergeUniforms };

var default_vertex = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";

var default_fragment = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";

class ShaderMaterial extends Material {

	constructor( parameters ) {

		super();

		this.isShaderMaterial = true;

		this.type = 'ShaderMaterial';

		this.defines = {};
		this.uniforms = {};
		this.uniformsGroups = [];

		this.vertexShader = default_vertex;
		this.fragmentShader = default_fragment;

		this.linewidth = 1;

		this.wireframe = false;
		this.wireframeLinewidth = 1;

		this.fog = false; // set to use scene fog
		this.lights = false; // set to use scene lights
		this.clipping = false; // set to use user-defined clipping planes

		this.forceSinglePass = true;

		this.extensions = {
			clipCullDistance: false, // set to use vertex shader clipping
			multiDraw: false // set to use vertex shader multi_draw / enable gl_DrawID
		};

		// When rendered geometry doesn't include these attributes but the material does,
		// use these default values in WebGL. This avoids errors when buffer data is missing.
		this.defaultAttributeValues = {
			'color': [ 1, 1, 1 ],
			'uv': [ 0, 0 ],
			'uv1': [ 0, 0 ]
		};

		this.index0AttributeName = undefined;
		this.uniformsNeedUpdate = false;

		this.glslVersion = null;

		if ( parameters !== undefined ) {

			this.setValues( parameters );

		}

	}

	copy( source ) {

		super.copy( source );

		this.fragmentShader = source.fragmentShader;
		this.vertexShader = source.vertexShader;

		this.uniforms = cloneUniforms( source.uniforms );
		this.uniformsGroups = cloneUniformsGroups( source.uniformsGroups );

		this.defines = Object.assign( {}, source.defines );

		this.wireframe = source.wireframe;
		this.wireframeLinewidth = source.wireframeLinewidth;

		this.fog = source.fog;
		this.lights = source.lights;
		this.clipping = source.clipping;

		this.extensions = Object.assign( {}, source.extensions );

		this.glslVersion = source.glslVersion;

		return this;

	}

	toJSON( meta ) {

		const data = super.toJSON( meta );

		data.glslVersion = this.glslVersion;
		data.uniforms = {};

		for ( const name in this.uniforms ) {

			const uniform = this.uniforms[ name ];
			const value = uniform.value;

			if ( value && value.isTexture ) {

				data.uniforms[ name ] = {
					type: 't',
					value: value.toJSON( meta ).uuid
				};

			} else if ( value && value.isColor ) {

				data.uniforms[ name ] = {
					type: 'c',
					value: value.getHex()
				};

			} else if ( value && value.isVector2 ) {

				data.uniforms[ name ] = {
					type: 'v2',
					value: value.toArray()
				};

			} else if ( value && value.isVector3 ) {

				data.uniforms[ name ] = {
					type: 'v3',
					value: value.toArray()
				};

			} else if ( value && value.isVector4 ) {

				data.uniforms[ name ] = {
					type: 'v4',
					value: value.toArray()
				};

			} else if ( value && value.isMatrix3 ) {

				data.uniforms[ name ] = {
					type: 'm3',
					value: value.toArray()
				};

			} else if ( value && value.isMatrix4 ) {

				data.uniforms[ name ] = {
					type: 'm4',
					value: value.toArray()
				};

			} else {

				data.uniforms[ name ] = {
					value: value
				};

				// note: the array variants v2v, v3v, v4v, m4v and tv are not supported so far

			}

		}

		if ( Object.keys( this.defines ).length > 0 ) data.defines = this.defines;

		data.vertexShader = this.vertexShader;
		data.fragmentShader = this.fragmentShader;

		data.lights = this.lights;
		data.clipping = this.clipping;

		const extensions = {};

		for ( const key in this.extensions ) {

			if ( this.extensions[ key ] === true ) extensions[ key ] = true;

		}

		if ( Object.keys( extensions ).length > 0 ) data.extensions = extensions;

		return data;

	}

}

class Camera extends Object3D {

	constructor() {

		super();

		this.isCamera = true;

		this.type = 'Camera';

		this.matrixWorldInverse = new Matrix4();

		this.projectionMatrix = new Matrix4();
		this.projectionMatrixInverse = new Matrix4();

		this.coordinateSystem = WebGLCoordinateSystem;

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		this.matrixWorldInverse.copy( source.matrixWorldInverse );

		this.projectionMatrix.copy( source.projectionMatrix );
		this.projectionMatrixInverse.copy( source.projectionMatrixInverse );

		this.coordinateSystem = source.coordinateSystem;

		return this;

	}

	getWorldDirection( target ) {

		return super.getWorldDirection( target ).negate();

	}

	updateMatrixWorld( force ) {

		super.updateMatrixWorld( force );

		this.matrixWorldInverse.copy( this.matrixWorld ).invert();

	}

	updateWorldMatrix( updateParents, updateChildren ) {

		super.updateWorldMatrix( updateParents, updateChildren );

		this.matrixWorldInverse.copy( this.matrixWorld ).invert();

	}

	clone() {

		return new this.constructor().copy( this );

	}

}

const _v3$1 = /*@__PURE__*/ new Vector3();
const _minTarget = /*@__PURE__*/ new Vector2();
const _maxTarget = /*@__PURE__*/ new Vector2();


class PerspectiveCamera extends Camera {

	constructor( fov = 50, aspect = 1, near = 0.1, far = 2000 ) {

		super();

		this.isPerspectiveCamera = true;

		this.type = 'PerspectiveCamera';

		this.fov = fov;
		this.zoom = 1;

		this.near = near;
		this.far = far;
		this.focus = 10;

		this.aspect = aspect;
		this.view = null;

		this.filmGauge = 35;	// width of the film (default in millimeters)
		this.filmOffset = 0;	// horizontal film offset (same unit as gauge)

		this.updateProjectionMatrix();

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		this.fov = source.fov;
		this.zoom = source.zoom;

		this.near = source.near;
		this.far = source.far;
		this.focus = source.focus;

		this.aspect = source.aspect;
		this.view = source.view === null ? null : Object.assign( {}, source.view );

		this.filmGauge = source.filmGauge;
		this.filmOffset = source.filmOffset;

		return this;

	}

	/**
	 * Sets the FOV by focal length in respect to the current .filmGauge.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * Values for focal length and film gauge must have the same unit.
	 */
	setFocalLength( focalLength ) {

		/** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */
		const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;

		this.fov = RAD2DEG * 2 * Math.atan( vExtentSlope );
		this.updateProjectionMatrix();

	}

	/**
	 * Calculates the focal length from the current .fov and .filmGauge.
	 */
	getFocalLength() {

		const vExtentSlope = Math.tan( DEG2RAD * 0.5 * this.fov );

		return 0.5 * this.getFilmHeight() / vExtentSlope;

	}

	getEffectiveFOV() {

		return RAD2DEG * 2 * Math.atan(
			Math.tan( DEG2RAD * 0.5 * this.fov ) / this.zoom );

	}

	getFilmWidth() {

		// film not completely covered in portrait format (aspect < 1)
		return this.filmGauge * Math.min( this.aspect, 1 );

	}

	getFilmHeight() {

		// film not completely covered in landscape format (aspect > 1)
		return this.filmGauge / Math.max( this.aspect, 1 );

	}

	/**
	 * Computes the 2D bounds of the camera's viewable rectangle at a given distance along the viewing direction.
	 * Sets minTarget and maxTarget to the coordinates of the lower-left and upper-right corners of the view rectangle.
	 */
	getViewBounds( distance, minTarget, maxTarget ) {

		_v3$1.set( - 1, - 1, 0.5 ).applyMatrix4( this.projectionMatrixInverse );

		minTarget.set( _v3$1.x, _v3$1.y ).multiplyScalar( - distance / _v3$1.z );

		_v3$1.set( 1, 1, 0.5 ).applyMatrix4( this.projectionMatrixInverse );

		maxTarget.set( _v3$1.x, _v3$1.y ).multiplyScalar( - distance / _v3$1.z );

	}

	/**
	 * Computes the width and height of the camera's viewable rectangle at a given distance along the viewing direction.
	 * Copies the result into the target Vector2, where x is width and y is height.
	 */
	getViewSize( distance, target ) {

		this.getViewBounds( distance, _minTarget, _maxTarget );

		return target.subVectors( _maxTarget, _minTarget );

	}

	/**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *
	 * then for each monitor you would call it like this
	 *
	 *   const w = 1920;
	 *   const h = 1080;
	 *   const fullWidth = w * 3;
	 *   const fullHeight = h * 2;
	 *
	 *   --A--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 *   --B--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 *   --C--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 *   --D--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 *   --E--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 *   --F--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 *
	 *   Note there is no reason monitors have to be the same size or in a grid.
	 */
	setViewOffset( fullWidth, fullHeight, x, y, width, height ) {

		this.aspect = fullWidth / fullHeight;

		if ( this.view === null ) {

			this.view = {
				enabled: true,
				fullWidth: 1,
				fullHeight: 1,
				offsetX: 0,
				offsetY: 0,
				width: 1,
				height: 1
			};

		}

		this.view.enabled = true;
		this.view.fullWidth = fullWidth;
		this.view.fullHeight = fullHeight;
		this.view.offsetX = x;
		this.view.offsetY = y;
		this.view.width = width;
		this.view.height = height;

		this.updateProjectionMatrix();

	}

	clearViewOffset() {

		if ( this.view !== null ) {

			this.view.enabled = false;

		}

		this.updateProjectionMatrix();

	}

	updateProjectionMatrix() {

		const near = this.near;
		let top = near * Math.tan( DEG2RAD * 0.5 * this.fov ) / this.zoom;
		let height = 2 * top;
		let width = this.aspect * height;
		let left = - 0.5 * width;
		const view = this.view;

		if ( this.view !== null && this.view.enabled ) {

			const fullWidth = view.fullWidth,
				fullHeight = view.fullHeight;

			left += view.offsetX * width / fullWidth;
			top -= view.offsetY * height / fullHeight;
			width *= view.width / fullWidth;
			height *= view.height / fullHeight;

		}

		const skew = this.filmOffset;
		if ( skew !== 0 ) left += near * skew / this.getFilmWidth();

		this.projectionMatrix.makePerspective( left, left + width, top, top - height, near, this.far, this.coordinateSystem );

		this.projectionMatrixInverse.copy( this.projectionMatrix ).invert();

	}

	toJSON( meta ) {

		const data = super.toJSON( meta );

		data.object.fov = this.fov;
		data.object.zoom = this.zoom;

		data.object.near = this.near;
		data.object.far = this.far;
		data.object.focus = this.focus;

		data.object.aspect = this.aspect;

		if ( this.view !== null ) data.object.view = Object.assign( {}, this.view );

		data.object.filmGauge = this.filmGauge;
		data.object.filmOffset = this.filmOffset;

		return data;

	}

}

const fov = - 90; // negative fov is not an error
const aspect = 1;

class CubeCamera extends Object3D {

	constructor( near, far, renderTarget ) {

		super();

		this.type = 'CubeCamera';

		this.renderTarget = renderTarget;
		this.coordinateSystem = null;
		this.activeMipmapLevel = 0;

		const cameraPX = new PerspectiveCamera( fov, aspect, near, far );
		cameraPX.layers = this.layers;
		this.add( cameraPX );

		const cameraNX = new PerspectiveCamera( fov, aspect, near, far );
		cameraNX.layers = this.layers;
		this.add( cameraNX );

		const cameraPY = new PerspectiveCamera( fov, aspect, near, far );
		cameraPY.layers = this.layers;
		this.add( cameraPY );

		const cameraNY = new PerspectiveCamera( fov, aspect, near, far );
		cameraNY.layers = this.layers;
		this.add( cameraNY );

		const cameraPZ = new PerspectiveCamera( fov, aspect, near, far );
		cameraPZ.layers = this.layers;
		this.add( cameraPZ );

		const cameraNZ = new PerspectiveCamera( fov, aspect, near, far );
		cameraNZ.layers = this.layers;
		this.add( cameraNZ );

	}

	updateCoordinateSystem() {

		const coordinateSystem = this.coordinateSystem;

		const cameras = this.children.concat();

		const [ cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ ] = cameras;

		for ( const camera of cameras ) this.remove( camera );

		if ( coordinateSystem === WebGLCoordinateSystem ) {

			cameraPX.up.set( 0, 1, 0 );
			cameraPX.lookAt( 1, 0, 0 );

			cameraNX.up.set( 0, 1, 0 );
			cameraNX.lookAt( - 1, 0, 0 );

			cameraPY.up.set( 0, 0, - 1 );
			cameraPY.lookAt( 0, 1, 0 );

			cameraNY.up.set( 0, 0, 1 );
			cameraNY.lookAt( 0, - 1, 0 );

			cameraPZ.up.set( 0, 1, 0 );
			cameraPZ.lookAt( 0, 0, 1 );

			cameraNZ.up.set( 0, 1, 0 );
			cameraNZ.lookAt( 0, 0, - 1 );

		} else if ( coordinateSystem === WebGPUCoordinateSystem ) {

			cameraPX.up.set( 0, - 1, 0 );
			cameraPX.lookAt( - 1, 0, 0 );

			cameraNX.up.set( 0, - 1, 0 );
			cameraNX.lookAt( 1, 0, 0 );

			cameraPY.up.set( 0, 0, 1 );
			cameraPY.lookAt( 0, 1, 0 );

			cameraNY.up.set( 0, 0, - 1 );
			cameraNY.lookAt( 0, - 1, 0 );

			cameraPZ.up.set( 0, - 1, 0 );
			cameraPZ.lookAt( 0, 0, 1 );

			cameraNZ.up.set( 0, - 1, 0 );
			cameraNZ.lookAt( 0, 0, - 1 );

		} else {

			throw new Error( 'THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: ' + coordinateSystem );

		}

		for ( const camera of cameras ) {

			this.add( camera );

			camera.updateMatrixWorld();

		}

	}

	update( renderer, scene ) {

		if ( this.parent === null ) this.updateMatrixWorld();

		const { renderTarget, activeMipmapLevel } = this;

		if ( this.coordinateSystem !== renderer.coordinateSystem ) {

			this.coordinateSystem = renderer.coordinateSystem;

			this.updateCoordinateSystem();

		}

		const [ cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ ] = this.children;

		const currentRenderTarget = renderer.getRenderTarget();
		const currentActiveCubeFace = renderer.getActiveCubeFace();
		const currentActiveMipmapLevel = renderer.getActiveMipmapLevel();

		const currentXrEnabled = renderer.xr.enabled;

		renderer.xr.enabled = false;

		const generateMipmaps = renderTarget.texture.generateMipmaps;

		renderTarget.texture.generateMipmaps = false;

		renderer.setRenderTarget( renderTarget, 0, activeMipmapLevel );
		renderer.render( scene, cameraPX );

		renderer.setRenderTarget( renderTarget, 1, activeMipmapLevel );
		renderer.render( scene, cameraNX );

		renderer.setRenderTarget( renderTarget, 2, activeMipmapLevel );
		renderer.render( scene, cameraPY );

		renderer.setRenderTarget( renderTarget, 3, activeMipmapLevel );
		renderer.render( scene, cameraNY );

		renderer.setRenderTarget( renderTarget, 4, activeMipmapLevel );
		renderer.render( scene, cameraPZ );

		// mipmaps are generated during the last call of render()
		// at this point, all sides of the cube render target are defined

		renderTarget.texture.generateMipmaps = generateMipmaps;

		renderer.setRenderTarget( renderTarget, 5, activeMipmapLevel );
		renderer.render( scene, cameraNZ );

		renderer.setRenderTarget( currentRenderTarget, currentActiveCubeFace, currentActiveMipmapLevel );

		renderer.xr.enabled = currentXrEnabled;

		renderTarget.texture.needsPMREMUpdate = true;

	}

}

class CubeTexture extends Texture {

	constructor( images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace ) {

		images = images !== undefined ? images : [];
		mapping = mapping !== undefined ? mapping : CubeReflectionMapping;

		super( images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace );

		this.isCubeTexture = true;

		this.flipY = false;

	}

	get images() {

		return this.image;

	}

	set images( value ) {

		this.image = value;

	}

}

class WebGLCubeRenderTarget extends WebGLRenderTarget {

	constructor( size = 1, options = {} ) {

		super( size, size, options );

		this.isWebGLCubeRenderTarget = true;

		const image = { width: size, height: size, depth: 1 };
		const images = [ image, image, image, image, image, image ];

		this.texture = new CubeTexture( images, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace );

		// By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
		// in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
		// in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.

		// three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
		// and the flag isRenderTargetTexture controls this conversion. The flip is not required when using WebGLCubeRenderTarget.texture
		// as a cube texture (this is detected when isRenderTargetTexture is set to true for cube textures).

		this.texture.isRenderTargetTexture = true;

		this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
		this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : LinearFilter;

	}

	fromEquirectangularTexture( renderer, texture ) {

		this.texture.type = texture.type;
		this.texture.colorSpace = texture.colorSpace;

		this.texture.generateMipmaps = texture.generateMipmaps;
		this.texture.minFilter = texture.minFilter;
		this.texture.magFilter = texture.magFilter;

		const shader = {

			uniforms: {
				tEquirect: { value: null },
			},

			vertexShader: /* glsl */`

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,

			fragmentShader: /* glsl */`

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
		};

		const geometry = new BoxGeometry( 5, 5, 5 );

		const material = new ShaderMaterial( {

			name: 'CubemapFromEquirect',

			uniforms: cloneUniforms( shader.uniforms ),
			vertexShader: shader.vertexShader,
			fragmentShader: shader.fragmentShader,
			side: BackSide,
			blending: NoBlending

		} );

		material.uniforms.tEquirect.value = texture;

		const mesh = new Mesh( geometry, material );

		const currentMinFilter = texture.minFilter;

		// Avoid blurred poles
		if ( texture.minFilter === LinearMipmapLinearFilter ) texture.minFilter = LinearFilter;

		const camera = new CubeCamera( 1, 10, this );
		camera.update( renderer, mesh );

		texture.minFilter = currentMinFilter;

		mesh.geometry.dispose();
		mesh.material.dispose();

		return this;

	}

	clear( renderer, color, depth, stencil ) {

		const currentRenderTarget = renderer.getRenderTarget();

		for ( let i = 0; i < 6; i ++ ) {

			renderer.setRenderTarget( this, i );

			renderer.clear( color, depth, stencil );

		}

		renderer.setRenderTarget( currentRenderTarget );

	}

}

const _vector1 = /*@__PURE__*/ new Vector3();
const _vector2 = /*@__PURE__*/ new Vector3();
const _normalMatrix = /*@__PURE__*/ new Matrix3();

class Plane {

	constructor( normal = new Vector3( 1, 0, 0 ), constant = 0 ) {

		this.isPlane = true;

		// normal is assumed to be normalized

		this.normal = normal;
		this.constant = constant;

	}

	set( normal, constant ) {

		this.normal.copy( normal );
		this.constant = constant;

		return this;

	}

	setComponents( x, y, z, w ) {

		this.normal.set( x, y, z );
		this.constant = w;

		return this;

	}

	setFromNormalAndCoplanarPoint( normal, point ) {

		this.normal.copy( normal );
		this.constant = - point.dot( this.normal );

		return this;

	}

	setFromCoplanarPoints( a, b, c ) {

		const normal = _vector1.subVectors( c, b ).cross( _vector2.subVectors( a, b ) ).normalize();

		// Q: should an error be thrown if normal is zero (e.g. degenerate plane)?

		this.setFromNormalAndCoplanarPoint( normal, a );

		return this;

	}

	copy( plane ) {

		this.normal.copy( plane.normal );
		this.constant = plane.constant;

		return this;

	}

	normalize() {

		// Note: will lead to a divide by zero if the plane is invalid.

		const inverseNormalLength = 1.0 / this.normal.length();
		this.normal.multiplyScalar( inverseNormalLength );
		this.constant *= inverseNormalLength;

		return this;

	}

	negate() {

		this.constant *= - 1;
		this.normal.negate();

		return this;

	}

	distanceToPoint( point ) {

		return this.normal.dot( point ) + this.constant;

	}

	distanceToSphere( sphere ) {

		return this.distanceToPoint( sphere.center ) - sphere.radius;

	}

	projectPoint( point, target ) {

		return target.copy( point ).addScaledVector( this.normal, - this.distanceToPoint( point ) );

	}

	intersectLine( line, target ) {

		const direction = line.delta( _vector1 );

		const denominator = this.normal.dot( direction );

		if ( denominator === 0 ) {

			// line is coplanar, return origin
			if ( this.distanceToPoint( line.start ) === 0 ) {

				return target.copy( line.start );

			}

			// Unsure if this is the correct method to handle this case.
			return null;

		}

		const t = - ( line.start.dot( this.normal ) + this.constant ) / denominator;

		if ( t < 0 || t > 1 ) {

			return null;

		}

		return target.copy( line.start ).addScaledVector( direction, t );

	}

	intersectsLine( line ) {

		// Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.

		const startSign = this.distanceToPoint( line.start );
		const endSign = this.distanceToPoint( line.end );

		return ( startSign < 0 && endSign > 0 ) || ( endSign < 0 && startSign > 0 );

	}

	intersectsBox( box ) {

		return box.intersectsPlane( this );

	}

	intersectsSphere( sphere ) {

		return sphere.intersectsPlane( this );

	}

	coplanarPoint( target ) {

		return target.copy( this.normal ).multiplyScalar( - this.constant );

	}

	applyMatrix4( matrix, optionalNormalMatrix ) {

		const normalMatrix = optionalNormalMatrix || _normalMatrix.getNormalMatrix( matrix );

		const referencePoint = this.coplanarPoint( _vector1 ).applyMatrix4( matrix );

		const normal = this.normal.applyMatrix3( normalMatrix ).normalize();

		this.constant = - referencePoint.dot( normal );

		return this;

	}

	translate( offset ) {

		this.constant -= offset.dot( this.normal );

		return this;

	}

	equals( plane ) {

		return plane.normal.equals( this.normal ) && ( plane.constant === this.constant );

	}

	clone() {

		return new this.constructor().copy( this );

	}

}

const _sphere$5 = /*@__PURE__*/ new Sphere();
const _vector$7 = /*@__PURE__*/ new Vector3();

class Frustum {

	constructor( p0 = new Plane(), p1 = new Plane(), p2 = new Plane(), p3 = new Plane(), p4 = new Plane(), p5 = new Plane() ) {

		this.planes = [ p0, p1, p2, p3, p4, p5 ];

	}

	set( p0, p1, p2, p3, p4, p5 ) {

		const planes = this.planes;

		planes[ 0 ].copy( p0 );
		planes[ 1 ].copy( p1 );
		planes[ 2 ].copy( p2 );
		planes[ 3 ].copy( p3 );
		planes[ 4 ].copy( p4 );
		planes[ 5 ].copy( p5 );

		return this;

	}

	copy( frustum ) {

		const planes = this.planes;

		for ( let i = 0; i < 6; i ++ ) {

			planes[ i ].copy( frustum.planes[ i ] );

		}

		return this;

	}

	setFromProjectionMatrix( m, coordinateSystem = WebGLCoordinateSystem ) {

		const planes = this.planes;
		const me = m.elements;
		const me0 = me[ 0 ], me1 = me[ 1 ], me2 = me[ 2 ], me3 = me[ 3 ];
		const me4 = me[ 4 ], me5 = me[ 5 ], me6 = me[ 6 ], me7 = me[ 7 ];
		const me8 = me[ 8 ], me9 = me[ 9 ], me10 = me[ 10 ], me11 = me[ 11 ];
		const me12 = me[ 12 ], me13 = me[ 13 ], me14 = me[ 14 ], me15 = me[ 15 ];

		planes[ 0 ].setComponents( me3 - me0, me7 - me4, me11 - me8, me15 - me12 ).normalize();
		planes[ 1 ].setComponents( me3 + me0, me7 + me4, me11 + me8, me15 + me12 ).normalize();
		planes[ 2 ].setComponents( me3 + me1, me7 + me5, me11 + me9, me15 + me13 ).normalize();
		planes[ 3 ].setComponents( me3 - me1, me7 - me5, me11 - me9, me15 - me13 ).normalize();
		planes[ 4 ].setComponents( me3 - me2, me7 - me6, me11 - me10, me15 - me14 ).normalize();

		if ( coordinateSystem === WebGLCoordinateSystem ) {

			planes[ 5 ].setComponents( me3 + me2, me7 + me6, me11 + me10, me15 + me14 ).normalize();

		} else if ( coordinateSystem === WebGPUCoordinateSystem ) {

			planes[ 5 ].setComponents( me2, me6, me10, me14 ).normalize();

		} else {

			throw new Error( 'THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: ' + coordinateSystem );

		}

		return this;

	}

	intersectsObject( object ) {

		if ( object.boundingSphere !== undefined ) {

			if ( object.boundingSphere === null ) object.computeBoundingSphere();

			_sphere$5.copy( object.boundingSphere ).applyMatrix4( object.matrixWorld );

		} else {

			const geometry = object.geometry;

			if ( geometry.boundingSphere === null ) geometry.computeBoundingSphere();

			_sphere$5.copy( geometry.boundingSphere ).applyMatrix4( object.matrixWorld );

		}

		return this.intersectsSphere( _sphere$5 );

	}

	intersectsSprite( sprite ) {

		_sphere$5.center.set( 0, 0, 0 );
		_sphere$5.radius = 0.7071067811865476;
		_sphere$5.applyMatrix4( sprite.matrixWorld );

		return this.intersectsSphere( _sphere$5 );

	}

	intersectsSphere( sphere ) {

		const planes = this.planes;
		const center = sphere.center;
		const negRadius = - sphere.radius;

		for ( let i = 0; i < 6; i ++ ) {

			const distance = planes[ i ].distanceToPoint( center );

			if ( distance < negRadius ) {

				return false;

			}

		}

		return true;

	}

	intersectsBox( box ) {

		const planes = this.planes;

		for ( let i = 0; i < 6; i ++ ) {

			const plane = planes[ i ];

			// corner at max distance

			_vector$7.x = plane.normal.x > 0 ? box.max.x : box.min.x;
			_vector$7.y = plane.normal.y > 0 ? box.max.y : box.min.y;
			_vector$7.z = plane.normal.z > 0 ? box.max.z : box.min.z;

			if ( plane.distanceToPoint( _vector$7 ) < 0 ) {

				return false;

			}

		}

		return true;

	}

	containsPoint( point ) {

		const planes = this.planes;

		for ( let i = 0; i < 6; i ++ ) {

			if ( planes[ i ].distanceToPoint( point ) < 0 ) {

				return false;

			}

		}

		return true;

	}

	clone() {

		return new this.constructor().copy( this );

	}

}

function WebGLAnimation() {

	let context = null;
	let isAnimating = false;
	let animationLoop = null;
	let requestId = null;

	function onAnimationFrame( time, frame ) {

		animationLoop( time, frame );

		requestId = context.requestAnimationFrame( onAnimationFrame );

	}

	return {

		start: function () {

			if ( isAnimating === true ) return;
			if ( animationLoop === null ) return;

			requestId = context.requestAnimationFrame( onAnimationFrame );

			isAnimating = true;

		},

		stop: function () {

			context.cancelAnimationFrame( requestId );

			isAnimating = false;

		},

		setAnimationLoop: function ( callback ) {

			animationLoop = callback;

		},

		setContext: function ( value ) {

			context = value;

		}

	};

}

function WebGLAttributes( gl ) {

	const buffers = new WeakMap();

	function createBuffer( attribute, bufferType ) {

		const array = attribute.array;
		const usage = attribute.usage;
		const size = array.byteLength;

		const buffer = gl.createBuffer();

		gl.bindBuffer( bufferType, buffer );
		gl.bufferData( bufferType, array, usage );

		attribute.onUploadCallback();

		let type;

		if ( array instanceof Float32Array ) {

			type = gl.FLOAT;

		} else if ( array instanceof Uint16Array ) {

			if ( attribute.isFloat16BufferAttribute ) {

				type = gl.HALF_FLOAT;

			} else {

				type = gl.UNSIGNED_SHORT;

			}

		} else if ( array instanceof Int16Array ) {

			type = gl.SHORT;

		} else if ( array instanceof Uint32Array ) {

			type = gl.UNSIGNED_INT;

		} else if ( array instanceof Int32Array ) {

			type = gl.INT;

		} else if ( array instanceof Int8Array ) {

			type = gl.BYTE;

		} else if ( array instanceof Uint8Array ) {

			type = gl.UNSIGNED_BYTE;

		} else if ( array instanceof Uint8ClampedArray ) {

			type = gl.UNSIGNED_BYTE;

		} else {

			throw new Error( 'THREE.WebGLAttributes: Unsupported buffer data format: ' + array );

		}

		return {
			buffer: buffer,
			type: type,
			bytesPerElement: array.BYTES_PER_ELEMENT,
			version: attribute.version,
			size: size
		};

	}

	function updateBuffer( buffer, attribute, bufferType ) {

		const array = attribute.array;
		const updateRange = attribute._updateRange; // @deprecated, r159
		const updateRanges = attribute.updateRanges;

		gl.bindBuffer( bufferType, buffer );

		if ( updateRange.count === - 1 && updateRanges.length === 0 ) {

			// Not using update ranges
			gl.bufferSubData( bufferType, 0, array );

		}

		if ( updateRanges.length !== 0 ) {

			for ( let i = 0, l = updateRanges.length; i < l; i ++ ) {

				const range = updateRanges[ i ];

				gl.bufferSubData( bufferType, range.start * array.BYTES_PER_ELEMENT,
					array, range.start, range.count );

			}

			attribute.clearUpdateRanges();

		}

		// @deprecated, r159
		if ( updateRange.count !== - 1 ) {

			gl.bufferSubData( bufferType, updateRange.offset * array.BYTES_PER_ELEMENT,
				array, updateRange.offset, updateRange.count );

			updateRange.count = - 1; // reset range

		}

		attribute.onUploadCallback();

	}

	//

	function get( attribute ) {

		if ( attribute.isInterleavedBufferAttribute ) attribute = attribute.data;

		return buffers.get( attribute );

	}

	function remove( attribute ) {

		if ( attribute.isInterleavedBufferAttribute ) attribute = attribute.data;

		const data = buffers.get( attribute );

		if ( data ) {

			gl.deleteBuffer( data.buffer );

			buffers.delete( attribute );

		}

	}

	function update( attribute, bufferType ) {

		if ( attribute.isGLBufferAttribute ) {

			const cached = buffers.get( attribute );

			if ( ! cached || cached.version < attribute.version ) {

				buffers.set( attribute, {
					buffer: attribute.buffer,
					type: attribute.type,
					bytesPerElement: attribute.elementSize,
					version: attribute.version
				} );

			}

			return;

		}

		if ( attribute.isInterleavedBufferAttribute ) attribute = attribute.data;

		const data = buffers.get( attribute );

		if ( data === undefined ) {

			buffers.set( attribute, createBuffer( attribute, bufferType ) );

		} else if ( data.version < attribute.version ) {

			if ( data.size !== attribute.array.byteLength ) {

				throw new Error( 'THREE.WebGLAttributes: The size of the buffer attribute\'s array buffer does not match the original size. Resizing buffer attributes is not supported.' );

			}

			updateBuffer( data.buffer, attribute, bufferType );

			data.version = attribute.version;

		}

	}

	return {

		get: get,
		remove: remove,
		update: update

	};

}

class PlaneGeometry extends BufferGeometry {

	constructor( width = 1, height = 1, widthSegments = 1, heightSegments = 1 ) {

		super();

		this.type = 'PlaneGeometry';

		this.parameters = {
			width: width,
			height: height,
			widthSegments: widthSegments,
			heightSegments: heightSegments
		};

		const width_half = width / 2;
		const height_half = height / 2;

		const gridX = Math.floor( widthSegments );
		const gridY = Math.floor( heightSegments );

		const gridX1 = gridX + 1;
		const gridY1 = gridY + 1;

		const segment_width = width / gridX;
		const segment_height = height / gridY;

		//

		const indices = [];
		const vertices = [];
		const normals = [];
		const uvs = [];

		for ( let iy = 0; iy < gridY1; iy ++ ) {

			const y = iy * segment_height - height_half;

			for ( let ix = 0; ix < gridX1; ix ++ ) {

				const x = ix * segment_width - width_half;

				vertices.push( x, - y, 0 );

				normals.push( 0, 0, 1 );

				uvs.push( ix / gridX );
				uvs.push( 1 - ( iy / gridY ) );

			}

		}

		for ( let iy = 0; iy < gridY; iy ++ ) {

			for ( let ix = 0; ix < gridX; ix ++ ) {

				const a = ix + gridX1 * iy;
				const b = ix + gridX1 * ( iy + 1 );
				const c = ( ix + 1 ) + gridX1 * ( iy + 1 );
				const d = ( ix + 1 ) + gridX1 * iy;

				indices.push( a, b, d );
				indices.push( b, c, d );

			}

		}

		this.setIndex( indices );
		this.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.setAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
		this.setAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

	}

	copy( source ) {

		super.copy( source );

		this.parameters = Object.assign( {}, source.parameters );

		return this;

	}

	static fromJSON( data ) {

		return new PlaneGeometry( data.width, data.height, data.widthSegments, data.heightSegments );

	}

}

var alphahash_fragment = "#ifdef USE_ALPHAHASH\n\tif ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\n#endif";

var alphahash_pars_fragment = "#ifdef USE_ALPHAHASH\n\tconst float ALPHA_HASH_SCALE = 0.05;\n\tfloat hash2D( vec2 value ) {\n\t\treturn fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\n\t}\n\tfloat hash3D( vec3 value ) {\n\t\treturn hash2D( vec2( hash2D( value.xy ), value.z ) );\n\t}\n\tfloat getAlphaHashThreshold( vec3 position ) {\n\t\tfloat maxDeriv = max(\n\t\t\tlength( dFdx( position.xyz ) ),\n\t\t\tlength( dFdy( position.xyz ) )\n\t\t);\n\t\tfloat pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\n\t\tvec2 pixScales = vec2(\n\t\t\texp2( floor( log2( pixScale ) ) ),\n\t\t\texp2( ceil( log2( pixScale ) ) )\n\t\t);\n\t\tvec2 alpha = vec2(\n\t\t\thash3D( floor( pixScales.x * position.xyz ) ),\n\t\t\thash3D( floor( pixScales.y * position.xyz ) )\n\t\t);\n\t\tfloat lerpFactor = fract( log2( pixScale ) );\n\t\tfloat x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\n\t\tfloat a = min( lerpFactor, 1.0 - lerpFactor );\n\t\tvec3 cases = vec3(\n\t\t\tx * x / ( 2.0 * a * ( 1.0 - a ) ),\n\t\t\t( x - 0.5 * a ) / ( 1.0 - a ),\n\t\t\t1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\n\t\t);\n\t\tfloat threshold = ( x < ( 1.0 - a ) )\n\t\t\t? ( ( x < a ) ? cases.x : cases.y )\n\t\t\t: cases.z;\n\t\treturn clamp( threshold , 1.0e-6, 1.0 );\n\t}\n#endif";

var alphamap_fragment = "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif";

var alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";

var alphatest_fragment = "#ifdef USE_ALPHATEST\n\t#ifdef ALPHA_TO_COVERAGE\n\tdiffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );\n\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\tif ( diffuseColor.a < alphaTest ) discard;\n\t#endif\n#endif";

var alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n\tuniform float alphaTest;\n#endif";

var aomap_fragment = "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_CLEARCOAT ) \n\t\tclearcoatSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_SHEEN ) \n\t\tsheenSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometryNormal, geometryViewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n\t#endif\n#endif";

var aomap_pars_fragment = "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif";

var batching_pars_vertex = "#ifdef USE_BATCHING\n\tattribute float batchId;\n\tuniform highp sampler2D batchingTexture;\n\tmat4 getBatchingMatrix( const in float i ) {\n\t\tint size = textureSize( batchingTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n#endif";

var batching_vertex = "#ifdef USE_BATCHING\n\tmat4 batchingMatrix = getBatchingMatrix( batchId );\n#endif";

var begin_vertex = "vec3 transformed = vec3( position );\n#ifdef USE_ALPHAHASH\n\tvPosition = vec3( position );\n#endif";

var beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif";

var bsdfs = "float G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, 1.0, dotVH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n} // validated";

var iridescence_fragment = "#ifdef USE_IRIDESCENCE\n\tconst mat3 XYZ_TO_REC709 = mat3(\n\t\t 3.2404542, -0.9692660,  0.0556434,\n\t\t-1.5371385,  1.8760108, -0.2040259,\n\t\t-0.4985314,  0.0415560,  1.0572252\n\t);\n\tvec3 Fresnel0ToIor( vec3 fresnel0 ) {\n\t\tvec3 sqrtF0 = sqrt( fresnel0 );\n\t\treturn ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n\t}\n\tvec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n\t}\n\tfloat IorToFresnel0( float transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n\t}\n\tvec3 evalSensitivity( float OPD, vec3 shift ) {\n\t\tfloat phase = 2.0 * PI * OPD * 1.0e-9;\n\t\tvec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n\t\tvec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n\t\tvec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n\t\tvec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n\t\txyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n\t\txyz /= 1.0685e-7;\n\t\tvec3 rgb = XYZ_TO_REC709 * xyz;\n\t\treturn rgb;\n\t}\n\tvec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n\t\tvec3 I;\n\t\tfloat iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n\t\tfloat sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n\t\tfloat cosTheta2Sq = 1.0 - sinTheta2Sq;\n\t\tif ( cosTheta2Sq < 0.0 ) {\n\t\t\treturn vec3( 1.0 );\n\t\t}\n\t\tfloat cosTheta2 = sqrt( cosTheta2Sq );\n\t\tfloat R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n\t\tfloat R12 = F_Schlick( R0, 1.0, cosTheta1 );\n\t\tfloat T121 = 1.0 - R12;\n\t\tfloat phi12 = 0.0;\n\t\tif ( iridescenceIOR < outsideIOR ) phi12 = PI;\n\t\tfloat phi21 = PI - phi12;\n\t\tvec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );\t\tvec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n\t\tvec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n\t\tvec3 phi23 = vec3( 0.0 );\n\t\tif ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n\t\tif ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n\t\tif ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n\t\tfloat OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n\t\tvec3 phi = vec3( phi21 ) + phi23;\n\t\tvec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n\t\tvec3 r123 = sqrt( R123 );\n\t\tvec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n\t\tvec3 C0 = R12 + Rs;\n\t\tI = C0;\n\t\tvec3 Cm = Rs - T121;\n\t\tfor ( int m = 1; m <= 2; ++ m ) {\n\t\t\tCm *= r123;\n\t\t\tvec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n\t\t\tI += Cm * Sm;\n\t\t}\n\t\treturn max( I, vec3( 0.0 ) );\n\t}\n#endif";

var bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vBumpMapUv );\n\t\tvec2 dSTdy = dFdy( vBumpMapUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n\t\tvec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );\n\t\tvec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif";

var clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#ifdef ALPHA_TO_COVERAGE\n\t\tfloat distanceToPlane, distanceGradient;\n\t\tfloat clipOpacity = 1.0;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\tclipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\tif ( clipOpacity == 0.0 ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tfloat unionClipOpacity = 1.0;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\t\tunionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tclipOpacity *= 1.0 - unionClipOpacity;\n\t\t#endif\n\t\tdiffuseColor.a *= clipOpacity;\n\t\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tbool clipped = true;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tif ( clipped ) discard;\n\t\t#endif\n\t#endif\n#endif";

var clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";

var clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif";

var clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif";

var color_fragment = "#if defined( USE_COLOR_ALPHA )\n\tdiffuseColor *= vColor;\n#elif defined( USE_COLOR )\n\tdiffuseColor.rgb *= vColor;\n#endif";

var color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR )\n\tvarying vec3 vColor;\n#endif";

var color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvarying vec3 vColor;\n#endif";

var color_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n\tvColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.xyz *= instanceColor.xyz;\n#endif";

var common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\n#ifdef USE_ALPHAHASH\n\tvarying vec3 vPosition;\n#endif\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n\tmat3 tmp;\n\ttmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n\ttmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n\ttmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n\treturn tmp;\n}\nfloat luminance( const in vec3 rgb ) {\n\tconst vec3 weights = vec3( 0.2126729, 0.7151522, 0.0721750 );\n\treturn dot( weights, rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated";

var cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\thighp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tuv.x += filterInt * 3.0 * cubeUV_minTileSize;\n\t\tuv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n\t\tuv.x *= CUBEUV_TEXEL_WIDTH;\n\t\tuv.y *= CUBEUV_TEXEL_HEIGHT;\n\t\t#ifdef texture2DGradEXT\n\t\t\treturn texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n\t\t#else\n\t\t\treturn texture2D( envMap, uv ).rgb;\n\t\t#endif\n\t}\n\t#define cubeUV_r0 1.0\n\t#define cubeUV_m0 - 2.0\n\t#define cubeUV_r1 0.8\n\t#define cubeUV_m1 - 1.0\n\t#define cubeUV_r4 0.4\n\t#define cubeUV_m4 2.0\n\t#define cubeUV_r5 0.305\n\t#define cubeUV_m5 3.0\n\t#define cubeUV_r6 0.21\n\t#define cubeUV_m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= cubeUV_r1 ) {\n\t\t\tmip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n\t\t} else if ( roughness >= cubeUV_r4 ) {\n\t\t\tmip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n\t\t} else if ( roughness >= cubeUV_r5 ) {\n\t\t\tmip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n\t\t} else if ( roughness >= cubeUV_r6 ) {\n\t\t\tmip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif";

var defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = objectTangent;\n#endif\n#ifdef USE_BATCHING\n\tmat3 bm = mat3( batchingMatrix );\n\ttransformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );\n\ttransformedNormal = bm * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = bm * transformedTangent;\n\t#endif\n#endif\n#ifdef USE_INSTANCING\n\tmat3 im = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );\n\ttransformedNormal = im * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = im * transformedTangent;\n\t#endif\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\ttransformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;\n\t#ifdef FLIP_SIDED\n\t\ttransformedTangent = - transformedTangent;\n\t#endif\n#endif";

var displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif";

var displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif";

var emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif";

var emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif";

var colorspace_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";

var colorspace_pars_fragment = "\nconst mat3 LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 = mat3(\n\tvec3( 0.8224621, 0.177538, 0.0 ),\n\tvec3( 0.0331941, 0.9668058, 0.0 ),\n\tvec3( 0.0170827, 0.0723974, 0.9105199 )\n);\nconst mat3 LINEAR_DISPLAY_P3_TO_LINEAR_SRGB = mat3(\n\tvec3( 1.2249401, - 0.2249404, 0.0 ),\n\tvec3( - 0.0420569, 1.0420571, 0.0 ),\n\tvec3( - 0.0196376, - 0.0786361, 1.0982735 )\n);\nvec4 LinearSRGBToLinearDisplayP3( in vec4 value ) {\n\treturn vec4( value.rgb * LINEAR_SRGB_TO_LINEAR_DISPLAY_P3, value.a );\n}\nvec4 LinearDisplayP3ToLinearSRGB( in vec4 value ) {\n\treturn vec4( value.rgb * LINEAR_DISPLAY_P3_TO_LINEAR_SRGB, value.a );\n}\nvec4 LinearTransferOETF( in vec4 value ) {\n\treturn value;\n}\nvec4 sRGBTransferOETF( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}\nvec4 LinearToLinear( in vec4 value ) {\n\treturn value;\n}\nvec4 LinearTosRGB( in vec4 value ) {\n\treturn sRGBTransferOETF( value );\n}";

var envmap_fragment = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, envMapRotation * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif";

var envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform float flipEnvMap;\n\tuniform mat3 envMapRotation;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\t\n#endif";

var envmap_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif";

var envmap_pars_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif";

var envmap_vertex = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif";

var fog_vertex = "#ifdef USE_FOG\n\tvFogDepth = - mvPosition.z;\n#endif";

var fog_pars_vertex = "#ifdef USE_FOG\n\tvarying float vFogDepth;\n#endif";

var fog_fragment = "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";

var fog_pars_fragment = "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float vFogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif";

var gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn vec3( texture2D( gradientMap, coord ).r );\n\t#else\n\t\tvec2 fw = fwidth( coord ) * 0.5;\n\t\treturn mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n\t#endif\n}";

var lightmap_fragment = "#ifdef USE_LIGHTMAP\n\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\treflectedLight.indirectDiffuse += lightMapIrradiance;\n#endif";

var lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif";

var lights_lambert_fragment = "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;";

var lights_lambert_pars_fragment = "varying vec3 vViewPosition;\nstruct LambertMaterial {\n\tvec3 diffuseColor;\n\tfloat specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Lambert\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Lambert";

var lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\n#if defined( USE_LIGHT_PROBES )\n\tuniform vec3 lightProbe[ 9 ];\n#endif\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\treturn irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\t#if defined ( LEGACY_LIGHTS )\n\t\tif ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n\t\t\treturn pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );\n\t\t}\n\t\treturn 1.0;\n\t#else\n\t\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\t\tif ( cutoffDistance > 0.0 ) {\n\t\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t\t}\n\t\treturn distanceFalloff;\n\t#endif\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n\treturn smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {\n\t\tlight.color = directionalLight.color;\n\t\tlight.direction = directionalLight.direction;\n\t\tlight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = pointLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tlight.color = pointLight.color;\n\t\tlight.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = spotLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat angleCos = dot( light.direction, spotLight.direction );\n\t\tfloat spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\tif ( spotAttenuation > 0.0 ) {\n\t\t\tfloat lightDistance = length( lVector );\n\t\t\tlight.color = spotLight.color * spotAttenuation;\n\t\t\tlight.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t\t} else {\n\t\t\tlight.color = vec3( 0.0 );\n\t\t\tlight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n\t\tfloat dotNL = dot( normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\treturn irradiance;\n\t}\n#endif";

var envmap_physical_pars_fragment = "#ifdef USE_ENVMAP\n\tvec3 getIBLIrradiance( const in vec3 normal ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );\n\t\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\tvec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 reflectVec = reflect( - viewDir, normal );\n\t\t\treflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n\t\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );\n\t\t\treturn envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\t#ifdef USE_ANISOTROPY\n\t\tvec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n\t\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\t\tvec3 bentNormal = cross( bitangent, viewDir );\n\t\t\t\tbentNormal = normalize( cross( bentNormal, bitangent ) );\n\t\t\t\tbentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n\t\t\t\treturn getIBLRadiance( viewDir, bentNormal, roughness );\n\t\t\t#else\n\t\t\t\treturn vec3( 0.0 );\n\t\t\t#endif\n\t\t}\n\t#endif\n#endif";

var lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";

var lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon";

var lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";

var lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong";

var lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n\tmaterial.ior = ior;\n\t#ifdef USE_SPECULAR\n\t\tfloat specularIntensityFactor = specularIntensity;\n\t\tvec3 specularColorFactor = specularColor;\n\t\t#ifdef USE_SPECULAR_COLORMAP\n\t\t\tspecularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n\t\t#endif\n\t\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\t\tspecularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n\t\t#endif\n\t\tmaterial.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n\t#else\n\t\tfloat specularIntensityFactor = 1.0;\n\t\tvec3 specularColorFactor = vec3( 1.0 );\n\t\tmaterial.specularF90 = 1.0;\n\t#endif\n\tmaterial.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\tmaterial.clearcoatF0 = vec3( 0.04 );\n\tmaterial.clearcoatF90 = 1.0;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_IRIDESCENCE\n\tmaterial.iridescence = iridescence;\n\tmaterial.iridescenceIOR = iridescenceIOR;\n\t#ifdef USE_IRIDESCENCEMAP\n\t\tmaterial.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n\t#endif\n\t#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\t\tmaterial.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n\t#else\n\t\tmaterial.iridescenceThickness = iridescenceThicknessMaximum;\n\t#endif\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheenColor;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tmaterial.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n\t#endif\n\tmaterial.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tmaterial.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\t#ifdef USE_ANISOTROPYMAP\n\t\tmat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n\t\tvec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n\t\tvec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n\t#else\n\t\tvec2 anisotropyV = anisotropyVector;\n\t#endif\n\tmaterial.anisotropy = length( anisotropyV );\n\tif( material.anisotropy == 0.0 ) {\n\t\tanisotropyV = vec2( 1.0, 0.0 );\n\t} else {\n\t\tanisotropyV /= material.anisotropy;\n\t\tmaterial.anisotropy = saturate( material.anisotropy );\n\t}\n\tmaterial.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n\tmaterial.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;\n\tmaterial.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;\n#endif";

var lights_physical_pars_fragment = "struct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tfloat roughness;\n\tvec3 specularColor;\n\tfloat specularF90;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat clearcoat;\n\t\tfloat clearcoatRoughness;\n\t\tvec3 clearcoatF0;\n\t\tfloat clearcoatF90;\n\t#endif\n\t#ifdef USE_IRIDESCENCE\n\t\tfloat iridescence;\n\t\tfloat iridescenceIOR;\n\t\tfloat iridescenceThickness;\n\t\tvec3 iridescenceFresnel;\n\t\tvec3 iridescenceF0;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tvec3 sheenColor;\n\t\tfloat sheenRoughness;\n\t#endif\n\t#ifdef IOR\n\t\tfloat ior;\n\t#endif\n\t#ifdef USE_TRANSMISSION\n\t\tfloat transmission;\n\t\tfloat transmissionAlpha;\n\t\tfloat thickness;\n\t\tfloat attenuationDistance;\n\t\tvec3 attenuationColor;\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat anisotropy;\n\t\tfloat alphaT;\n\t\tvec3 anisotropyT;\n\t\tvec3 anisotropyB;\n\t#endif\n};\nvec3 clearcoatSpecularDirect = vec3( 0.0 );\nvec3 clearcoatSpecularIndirect = vec3( 0.0 );\nvec3 sheenSpecularDirect = vec3( 0.0 );\nvec3 sheenSpecularIndirect = vec3(0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n\tfloat V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n\t\tfloat gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n\t\tfloat gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n\t\tfloat v = 0.5 / ( gv + gl );\n\t\treturn saturate(v);\n\t}\n\tfloat D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n\t\tfloat a2 = alphaT * alphaB;\n\t\thighp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n\t\thighp float v2 = dot( v, v );\n\t\tfloat w2 = a2 / v2;\n\t\treturn RECIPROCAL_PI * a2 * pow2 ( w2 );\n\t}\n#endif\n#ifdef USE_CLEARCOAT\n\tvec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n\t\tvec3 f0 = material.clearcoatF0;\n\t\tfloat f90 = material.clearcoatF90;\n\t\tfloat roughness = material.clearcoatRoughness;\n\t\tfloat alpha = pow2( roughness );\n\t\tvec3 halfDir = normalize( lightDir + viewDir );\n\t\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\t\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\t\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\t\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\t\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t\treturn F * ( V * D );\n\t}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n\tvec3 f0 = material.specularColor;\n\tfloat f90 = material.specularF90;\n\tfloat roughness = material.roughness;\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t#ifdef USE_IRIDESCENCE\n\t\tF = mix( F, material.iridescenceFresnel, material.iridescence );\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat dotTL = dot( material.anisotropyT, lightDir );\n\t\tfloat dotTV = dot( material.anisotropyT, viewDir );\n\t\tfloat dotTH = dot( material.anisotropyT, halfDir );\n\t\tfloat dotBL = dot( material.anisotropyB, lightDir );\n\t\tfloat dotBV = dot( material.anisotropyB, viewDir );\n\t\tfloat dotBH = dot( material.anisotropyB, halfDir );\n\t\tfloat V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n\t\tfloat D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n\t#else\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t#endif\n\treturn F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n\tfloat alpha = pow2( roughness );\n\tfloat invAlpha = 1.0 / alpha;\n\tfloat cos2h = dotNH * dotNH;\n\tfloat sin2h = max( 1.0 - cos2h, 0.0078125 );\n\treturn ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n\treturn saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat D = D_Charlie( sheenRoughness, dotNH );\n\tfloat V = V_Neubelt( dotNV, dotNL );\n\treturn sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat r2 = roughness * roughness;\n\tfloat a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n\tfloat b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n\tfloat DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n\treturn saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\tvec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n\treturn fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\treturn specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\t#ifdef USE_IRIDESCENCE\n\t\tvec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n\t#else\n\t\tvec3 Fr = specularColor;\n\t#endif\n\tvec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n\tfloat Ess = fab.x + fab.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometryNormal;\n\t\tvec3 viewDir = geometryViewDir;\n\t\tvec3 position = geometryPosition;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.roughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = dotNLcc * directLight.color;\n\t\tclearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );\n\t#endif\n\treflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometryViewDir, geometryNormal, material );\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n\t#endif\n\tvec3 singleScattering = vec3( 0.0 );\n\tvec3 multiScattering = vec3( 0.0 );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\t#ifdef USE_IRIDESCENCE\n\t\tcomputeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n\t#else\n\t\tcomputeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n\t#endif\n\tvec3 totalScattering = singleScattering + multiScattering;\n\tvec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n\treflectedLight.indirectSpecular += radiance * singleScattering;\n\treflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n\treflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";

var lights_fragment_begin = "\nvec3 geometryPosition = - vViewPosition;\nvec3 geometryNormal = normal;\nvec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\nvec3 geometryClearcoatNormal = vec3( 0.0 );\n#ifdef USE_CLEARCOAT\n\tgeometryClearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n\tfloat dotNVi = saturate( dot( normal, geometryViewDir ) );\n\tif ( material.iridescenceThickness == 0.0 ) {\n\t\tmaterial.iridescence = 0.0;\n\t} else {\n\t\tmaterial.iridescence = saturate( material.iridescence );\n\t}\n\tif ( material.iridescence > 0.0 ) {\n\t\tmaterial.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n\t\tmaterial.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n\t}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointLightInfo( pointLight, geometryPosition, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\tvec4 spotColor;\n\tvec3 spotLightCoord;\n\tbool inSpotLightMap;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotLightInfo( spotLight, geometryPosition, directLight );\n\t\t#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n\t\t#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n\t\t#else\n\t\t#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#endif\n\t\t#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n\t\t\tspotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n\t\t\tinSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n\t\t\tspotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n\t\t\tdirectLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n\t\t#endif\n\t\t#undef SPOT_LIGHT_MAP_INDEX\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalLightInfo( directionalLight, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\t#if defined( USE_LIGHT_PROBES )\n\t\tirradiance += getLightProbeIrradiance( lightProbe, geometryNormal );\n\t#endif\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif";

var lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tiblIrradiance += getIBLIrradiance( geometryNormal );\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\t#ifdef USE_ANISOTROPY\n\t\tradiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );\n\t#else\n\t\tradiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );\n\t#endif\n#endif";

var lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n\tRE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif";

var logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF )\n\tgl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";

var logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";

var logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";

var logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n\tvFragDepth = 1.0 + gl_Position.w;\n\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n#endif";

var map_fragment = "#ifdef USE_MAP\n\tvec4 sampledDiffuseColor = texture2D( map, vMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\tsampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );\n\t\n\t#endif\n\tdiffuseColor *= sampledDiffuseColor;\n#endif";

var map_pars_fragment = "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif";

var map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t#if defined( USE_POINTS_UV )\n\t\tvec2 uv = vUv;\n\t#else\n\t\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tdiffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";

var map_particle_pars_fragment = "#if defined( USE_POINTS_UV )\n\tvarying vec2 vUv;\n#else\n\t#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t\tuniform mat3 uvTransform;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";

var metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif";

var metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif";

var morphinstance_vertex = "#ifdef USE_INSTANCING_MORPH\n\tfloat morphTargetInfluences[MORPHTARGETS_COUNT];\n\tfloat morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tmorphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;\n\t}\n#endif";

var morphcolor_vertex = "#if defined( USE_MORPHCOLORS ) && defined( MORPHTARGETS_TEXTURE )\n\tvColor *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t#if defined( USE_COLOR_ALPHA )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n\t\t#elif defined( USE_COLOR )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n\t\t#endif\n\t}\n#endif";

var morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n\t\t}\n\t#else\n\t\tobjectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n\t\tobjectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n\t\tobjectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n\t\tobjectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n\t#endif\n#endif";

var morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n\t#ifndef USE_INSTANCING_MORPH\n\t\tuniform float morphTargetBaseInfluence;\n\t#endif\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\t#ifndef USE_INSTANCING_MORPH\n\t\t\tuniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\t\t#endif\n\t\tuniform sampler2DArray morphTargetsTexture;\n\t\tuniform ivec2 morphTargetsTextureSize;\n\t\tvec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n\t\t\tint texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n\t\t\tint y = texelIndex / morphTargetsTextureSize.x;\n\t\t\tint x = texelIndex - y * morphTargetsTextureSize.x;\n\t\t\tivec3 morphUV = ivec3( x, y, morphTargetIndex );\n\t\t\treturn texelFetch( morphTargetsTexture, morphUV, 0 );\n\t\t}\n\t#else\n\t\t#ifndef USE_MORPHNORMALS\n\t\t\tuniform float morphTargetInfluences[ 8 ];\n\t\t#else\n\t\t\tuniform float morphTargetInfluences[ 4 ];\n\t\t#endif\n\t#endif\n#endif";

var morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n\t\t}\n\t#else\n\t\ttransformed += morphTarget0 * morphTargetInfluences[ 0 ];\n\t\ttransformed += morphTarget1 * morphTargetInfluences[ 1 ];\n\t\ttransformed += morphTarget2 * morphTargetInfluences[ 2 ];\n\t\ttransformed += morphTarget3 * morphTargetInfluences[ 3 ];\n\t\t#ifndef USE_MORPHNORMALS\n\t\t\ttransformed += morphTarget4 * morphTargetInfluences[ 4 ];\n\t\t\ttransformed += morphTarget5 * morphTargetInfluences[ 5 ];\n\t\t\ttransformed += morphTarget6 * morphTargetInfluences[ 6 ];\n\t\t\ttransformed += morphTarget7 * morphTargetInfluences[ 7 ];\n\t\t#endif\n\t#endif\n#endif";

var normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n\tvec3 fdx = dFdx( vViewPosition );\n\tvec3 fdy = dFdy( vViewPosition );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal *= faceDirection;\n\t#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn = getTangentFrame( - vViewPosition, normal,\n\t\t#if defined( USE_NORMALMAP )\n\t\t\tvNormalMapUv\n\t\t#elif defined( USE_CLEARCOAT_NORMALMAP )\n\t\t\tvClearcoatNormalMapUv\n\t\t#else\n\t\t\tvUv\n\t\t#endif\n\t\t);\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn[0] *= faceDirection;\n\t\ttbn[1] *= faceDirection;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn2[0] *= faceDirection;\n\t\ttbn2[1] *= faceDirection;\n\t#endif\n#endif\nvec3 nonPerturbedNormal = normal;";

var normal_fragment_maps = "#ifdef USE_NORMALMAP_OBJECTSPACE\n\tnormal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n\tvec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\tmapN.xy *= normalScale;\n\tnormal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";

var normal_pars_fragment = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";

var normal_pars_vertex = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";

var normal_vertex = "#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif";

var normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n\tmat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n\t\tvec3 q0 = dFdx( eye_pos.xyz );\n\t\tvec3 q1 = dFdy( eye_pos.xyz );\n\t\tvec2 st0 = dFdx( uv.st );\n\t\tvec2 st1 = dFdy( uv.st );\n\t\tvec3 N = surf_norm;\n\t\tvec3 q1perp = cross( q1, N );\n\t\tvec3 q0perp = cross( N, q0 );\n\t\tvec3 T = q1perp * st0.x + q0perp * st1.x;\n\t\tvec3 B = q1perp * st0.y + q0perp * st1.y;\n\t\tfloat det = max( dot( T, T ), dot( B, B ) );\n\t\tfloat scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n\t\treturn mat3( T * scale, B * scale, N );\n\t}\n#endif";

var clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal = nonPerturbedNormal;\n#endif";

var clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\tclearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif";

var clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif";

var iridescence_pars_fragment = "#ifdef USE_IRIDESCENCEMAP\n\tuniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform sampler2D iridescenceThicknessMap;\n#endif";

var opaque_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";

var packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n\tvec4 r = vec4( fract( v * PackFactors ), v );\n\tr.yzw -= r.xyz * ShiftRight8;\treturn r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors );\n}\nvec2 packDepthToRG( in highp float v ) {\n\treturn packDepthToRGBA( v ).yx;\n}\nfloat unpackRGToDepth( const in highp vec2 v ) {\n\treturn unpackRGBAToDepth( vec4( v.xy, 0.0, 0.0 ) );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * depth - far );\n}";

var premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif";

var project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_BATCHING\n\tmvPosition = batchingMatrix * mvPosition;\n#endif\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";

var dithering_fragment = "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";

var dithering_pars_fragment = "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif";

var roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n\troughnessFactor *= texelRoughness.g;\n#endif";

var roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif";

var shadowmap_pars_fragment = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n\tuniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tvec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n\t\treturn unpackRGBATo2Half( texture2D( shadow, uv ) );\n\t}\n\tfloat VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n\t\tfloat occlusion = 1.0;\n\t\tvec2 distribution = texture2DDistribution( shadow, uv );\n\t\tfloat hard_shadow = step( compare , distribution.x );\n\t\tif (hard_shadow != 1.0 ) {\n\t\t\tfloat distance = compare - distribution.x ;\n\t\t\tfloat variance = max( 0.00000, distribution.y * distribution.y );\n\t\t\tfloat softness_probability = variance / (variance + distance * distance );\t\t\tsoftness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );\t\t\tocclusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n\t\t}\n\t\treturn occlusion;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n\t\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tfloat dx2 = dx0 / 2.0;\n\t\t\tfloat dy2 = dy0 / 2.0;\n\t\t\tfloat dx3 = dx1 / 2.0;\n\t\t\tfloat dy3 = dy1 / 2.0;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 17.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx = texelSize.x;\n\t\t\tfloat dy = texelSize.y;\n\t\t\tvec2 uv = shadowCoord.xy;\n\t\t\tvec2 f = fract( uv * shadowMapSize + 0.5 );\n\t\t\tuv -= f * texelSize;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, uv, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t f.y )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\t\tshadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn shadow;\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tfloat shadow = 1.0;\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\t\n\t\tfloat lightToPositionLength = length( lightToPosition );\n\t\tif ( lightToPositionLength - shadowCameraFar <= 0.0 && lightToPositionLength - shadowCameraNear >= 0.0 ) {\n\t\t\tfloat dp = ( lightToPositionLength - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\t\tdp += shadowBias;\n\t\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n\t\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\t\tshadow = (\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t\t) * ( 1.0 / 9.0 );\n\t\t\t#else\n\t\t\t\tshadow = texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t\t#endif\n\t\t}\n\t\treturn shadow;\n\t}\n#endif";

var shadowmap_pars_vertex = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tuniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif";

var shadowmap_vertex = "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\tvec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition;\n\t\t#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t\tshadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n\t\t#endif\n\t\tvSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n#endif";

var shadowmask_pars_fragment = "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}";

var skinbase_vertex = "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";

var skinning_pars_vertex = "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\tuniform highp sampler2D boneTexture;\n\tmat4 getBoneMatrix( const in float i ) {\n\t\tint size = textureSize( boneTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n#endif";

var skinning_vertex = "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";

var skinnormal_vertex = "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif";

var specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif";

var specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif";

var tonemapping_fragment = "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";

var tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nconst mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(\n\tvec3( 1.6605, - 0.1246, - 0.0182 ),\n\tvec3( - 0.5876, 1.1329, - 0.1006 ),\n\tvec3( - 0.0728, - 0.0083, 1.1187 )\n);\nconst mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(\n\tvec3( 0.6274, 0.0691, 0.0164 ),\n\tvec3( 0.3293, 0.9195, 0.0880 ),\n\tvec3( 0.0433, 0.0113, 0.8956 )\n);\nvec3 agxDefaultContrastApprox( vec3 x ) {\n\tvec3 x2 = x * x;\n\tvec3 x4 = x2 * x2;\n\treturn + 15.5 * x4 * x2\n\t\t- 40.14 * x4 * x\n\t\t+ 31.96 * x4\n\t\t- 6.868 * x2 * x\n\t\t+ 0.4298 * x2\n\t\t+ 0.1191 * x\n\t\t- 0.00232;\n}\nvec3 AgXToneMapping( vec3 color ) {\n\tconst mat3 AgXInsetMatrix = mat3(\n\t\tvec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),\n\t\tvec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),\n\t\tvec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )\n\t);\n\tconst mat3 AgXOutsetMatrix = mat3(\n\t\tvec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),\n\t\tvec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),\n\t\tvec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )\n\t);\n\tconst float AgxMinEv = - 12.47393;\tconst float AgxMaxEv = 4.026069;\n\tcolor *= toneMappingExposure;\n\tcolor = LINEAR_SRGB_TO_LINEAR_REC2020 * color;\n\tcolor = AgXInsetMatrix * color;\n\tcolor = max( color, 1e-10 );\tcolor = log2( color );\n\tcolor = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );\n\tcolor = clamp( color, 0.0, 1.0 );\n\tcolor = agxDefaultContrastApprox( color );\n\tcolor = AgXOutsetMatrix * color;\n\tcolor = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );\n\tcolor = LINEAR_REC2020_TO_LINEAR_SRGB * color;\n\tcolor = clamp( color, 0.0, 1.0 );\n\treturn color;\n}\nvec3 NeutralToneMapping( vec3 color ) {\n\tfloat startCompression = 0.8 - 0.04;\n\tfloat desaturation = 0.15;\n\tcolor *= toneMappingExposure;\n\tfloat x = min(color.r, min(color.g, color.b));\n\tfloat offset = x < 0.08 ? x - 6.25 * x * x : 0.04;\n\tcolor -= offset;\n\tfloat peak = max(color.r, max(color.g, color.b));\n\tif (peak < startCompression) return color;\n\tfloat d = 1. - startCompression;\n\tfloat newPeak = 1. - d * d / (peak + d - startCompression);\n\tcolor *= newPeak / peak;\n\tfloat g = 1. - 1. / (desaturation * (peak - newPeak) + 1.);\n\treturn mix(color, newPeak * vec3(1, 1, 1), g);\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";

var transmission_fragment = "#ifdef USE_TRANSMISSION\n\tmaterial.transmission = transmission;\n\tmaterial.transmissionAlpha = 1.0;\n\tmaterial.thickness = thickness;\n\tmaterial.attenuationDistance = attenuationDistance;\n\tmaterial.attenuationColor = attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tmaterial.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tmaterial.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n\t#endif\n\tvec3 pos = vWorldPosition;\n\tvec3 v = normalize( cameraPosition - pos );\n\tvec3 n = inverseTransformDirection( normal, viewMatrix );\n\tvec4 transmitted = getIBLVolumeRefraction(\n\t\tn, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n\t\tpos, modelMatrix, viewMatrix, projectionMatrix, material.ior, material.thickness,\n\t\tmaterial.attenuationColor, material.attenuationDistance );\n\tmaterial.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n\ttotalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif";

var transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n\tuniform float transmission;\n\tuniform float thickness;\n\tuniform float attenuationDistance;\n\tuniform vec3 attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tuniform sampler2D transmissionMap;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tuniform sampler2D thicknessMap;\n\t#endif\n\tuniform vec2 transmissionSamplerSize;\n\tuniform sampler2D transmissionSamplerMap;\n\tuniform mat4 modelMatrix;\n\tuniform mat4 projectionMatrix;\n\tvarying vec3 vWorldPosition;\n\tfloat w0( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n\t}\n\tfloat w1( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n\t}\n\tfloat w2( float a ){\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n\t}\n\tfloat w3( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * a * a );\n\t}\n\tfloat g0( float a ) {\n\t\treturn w0( a ) + w1( a );\n\t}\n\tfloat g1( float a ) {\n\t\treturn w2( a ) + w3( a );\n\t}\n\tfloat h0( float a ) {\n\t\treturn - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n\t}\n\tfloat h1( float a ) {\n\t\treturn 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n\t}\n\tvec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n\t\tuv = uv * texelSize.zw + 0.5;\n\t\tvec2 iuv = floor( uv );\n\t\tvec2 fuv = fract( uv );\n\t\tfloat g0x = g0( fuv.x );\n\t\tfloat g1x = g1( fuv.x );\n\t\tfloat h0x = h0( fuv.x );\n\t\tfloat h1x = h1( fuv.x );\n\t\tfloat h0y = h0( fuv.y );\n\t\tfloat h1y = h1( fuv.y );\n\t\tvec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\treturn g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n\t\t\tg1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n\t}\n\tvec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n\t\tvec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n\t\tvec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n\t\tvec2 fLodSizeInv = 1.0 / fLodSize;\n\t\tvec2 cLodSizeInv = 1.0 / cLodSize;\n\t\tvec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n\t\tvec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n\t\treturn mix( fSample, cSample, fract( lod ) );\n\t}\n\tvec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n\t\tvec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n\t\tvec3 modelScale;\n\t\tmodelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n\t\tmodelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n\t\tmodelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n\t\treturn normalize( refractionVector ) * thickness * modelScale;\n\t}\n\tfloat applyIorToRoughness( const in float roughness, const in float ior ) {\n\t\treturn roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n\t}\n\tvec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n\t\tfloat lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n\t\treturn textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n\t}\n\tvec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tif ( isinf( attenuationDistance ) ) {\n\t\t\treturn vec3( 1.0 );\n\t\t} else {\n\t\t\tvec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n\t\t\tvec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );\t\t\treturn transmittance;\n\t\t}\n\t}\n\tvec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n\t\tconst in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n\t\tconst in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,\n\t\tconst in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\trefractionCoords += 1.0;\n\t\trefractionCoords /= 2.0;\n\t\tvec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n\t\tvec3 transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n\t\tvec3 attenuatedColor = transmittance * transmittedLight.rgb;\n\t\tvec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n\t\tfloat transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n\t\treturn vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n\t}\n#endif";

var uv_pars_fragment = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";

var uv_pars_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tuniform mat3 mapTransform;\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform mat3 alphaMapTransform;\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tuniform mat3 lightMapTransform;\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tuniform mat3 aoMapTransform;\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tuniform mat3 bumpMapTransform;\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tuniform mat3 normalMapTransform;\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tuniform mat3 displacementMapTransform;\n\tvarying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tuniform mat3 emissiveMapTransform;\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tuniform mat3 metalnessMapTransform;\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tuniform mat3 roughnessMapTransform;\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tuniform mat3 anisotropyMapTransform;\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tuniform mat3 clearcoatMapTransform;\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform mat3 clearcoatNormalMapTransform;\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform mat3 clearcoatRoughnessMapTransform;\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tuniform mat3 sheenColorMapTransform;\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tuniform mat3 sheenRoughnessMapTransform;\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tuniform mat3 iridescenceMapTransform;\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform mat3 iridescenceThicknessMapTransform;\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tuniform mat3 specularMapTransform;\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tuniform mat3 specularColorMapTransform;\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tuniform mat3 specularIntensityMapTransform;\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";

var uv_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n\tvMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n\tvAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n\tvLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n\tvAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n\tvBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n\tvNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tvDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n\tvMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n\tvSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tvTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n\tvThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif";

var worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_BATCHING\n\t\tworldPosition = batchingMatrix * worldPosition;\n\t#endif\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif";

const vertex$h = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}";

const fragment$h = "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n\tvec4 texColor = texture2D( t2D, vUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\ttexColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";

const vertex$g = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";

const fragment$g = "#ifdef ENVMAP_TYPE_CUBE\n\tuniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n\tuniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nuniform mat3 backgroundRotation;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 texColor = textureCube( envMap, backgroundRotation * vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );\n\t#else\n\t\tvec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";

const vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";

const fragment$f = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n\tvec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n\tgl_FragColor = texColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";

const vertex$e = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}";

const fragment$e = "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <logdepthbuf_fragment>\n\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#endif\n}";

const vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}";

const fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}";

const vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}";

const fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";

const vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";

const fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";

const vertex$a = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinbase_vertex>\n\t\t#include <skinnormal_vertex>\n\t\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}";

const fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\treflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";

const vertex$9 = "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";

const fragment$9 = "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_lambert_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";

const vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}";

const fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t#else\n\t\tvec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";

const vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}";

const fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), diffuseColor.a );\n\t#ifdef OPAQUE\n\t\tgl_FragColor.a = 1.0;\n\t#endif\n}";

const vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";

const fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";

const vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n\tvarying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n\tvWorldPosition = worldPosition.xyz;\n#endif\n}";

const fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n\t#define IOR\n\t#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n\tuniform float ior;\n#endif\n#ifdef USE_SPECULAR\n\tuniform float specularIntensity;\n\tuniform vec3 specularColor;\n\t#ifdef USE_SPECULAR_COLORMAP\n\t\tuniform sampler2D specularColorMap;\n\t#endif\n\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\tuniform sampler2D specularIntensityMap;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_IRIDESCENCE\n\tuniform float iridescence;\n\tuniform float iridescenceIOR;\n\tuniform float iridescenceThicknessMinimum;\n\tuniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheenColor;\n\tuniform float sheenRoughness;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tuniform sampler2D sheenColorMap;\n\t#endif\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tuniform sampler2D sheenRoughnessMap;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\tuniform vec2 anisotropyVector;\n\t#ifdef USE_ANISOTROPYMAP\n\t\tuniform sampler2D anisotropyMap;\n\t#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n\t#include <transmission_fragment>\n\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n\t#ifdef USE_SHEEN\n\t\tfloat sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n\t\toutgoingLight = outgoingLight * sheenEnergyComp + sheenSpecularDirect + sheenSpecularIndirect;\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );\n\t\tvec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n\t\toutgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;\n\t#endif\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";

const vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";

const fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";

const vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n\tvarying vec2 vUv;\n\tuniform mat3 uvTransform;\n#endif\nvoid main() {\n\t#ifdef USE_POINTS_UV\n\t\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\t#endif\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}";

const fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";

const vertex$2 = "#include <common>\n#include <batching_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";

const fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\t#include <logdepthbuf_fragment>\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}";

const vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n\tvec2 scale;\n\tscale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n\tscale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";

const fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}";

const ShaderChunk = {
	alphahash_fragment: alphahash_fragment,
	alphahash_pars_fragment: alphahash_pars_fragment,
	alphamap_fragment: alphamap_fragment,
	alphamap_pars_fragment: alphamap_pars_fragment,
	alphatest_fragment: alphatest_fragment,
	alphatest_pars_fragment: alphatest_pars_fragment,
	aomap_fragment: aomap_fragment,
	aomap_pars_fragment: aomap_pars_fragment,
	batching_pars_vertex: batching_pars_vertex,
	batching_vertex: batching_vertex,
	begin_vertex: begin_vertex,
	beginnormal_vertex: beginnormal_vertex,
	bsdfs: bsdfs,
	iridescence_fragment: iridescence_fragment,
	bumpmap_pars_fragment: bumpmap_pars_fragment,
	clipping_planes_fragment: clipping_planes_fragment,
	clipping_planes_pars_fragment: clipping_planes_pars_fragment,
	clipping_planes_pars_vertex: clipping_planes_pars_vertex,
	clipping_planes_vertex: clipping_planes_vertex,
	color_fragment: color_fragment,
	color_pars_fragment: color_pars_fragment,
	color_pars_vertex: color_pars_vertex,
	color_vertex: color_vertex,
	common: common,
	cube_uv_reflection_fragment: cube_uv_reflection_fragment,
	defaultnormal_vertex: defaultnormal_vertex,
	displacementmap_pars_vertex: displacementmap_pars_vertex,
	displacementmap_vertex: displacementmap_vertex,
	emissivemap_fragment: emissivemap_fragment,
	emissivemap_pars_fragment: emissivemap_pars_fragment,
	colorspace_fragment: colorspace_fragment,
	colorspace_pars_fragment: colorspace_pars_fragment,
	envmap_fragment: envmap_fragment,
	envmap_common_pars_fragment: envmap_common_pars_fragment,
	envmap_pars_fragment: envmap_pars_fragment,
	envmap_pars_vertex: envmap_pars_vertex,
	envmap_physical_pars_fragment: envmap_physical_pars_fragment,
	envmap_vertex: envmap_vertex,
	fog_vertex: fog_vertex,
	fog_pars_vertex: fog_pars_vertex,
	fog_fragment: fog_fragment,
	fog_pars_fragment: fog_pars_fragment,
	gradientmap_pars_fragment: gradientmap_pars_fragment,
	lightmap_fragment: lightmap_fragment,
	lightmap_pars_fragment: lightmap_pars_fragment,
	lights_lambert_fragment: lights_lambert_fragment,
	lights_lambert_pars_fragment: lights_lambert_pars_fragment,
	lights_pars_begin: lights_pars_begin,
	lights_toon_fragment: lights_toon_fragment,
	lights_toon_pars_fragment: lights_toon_pars_fragment,
	lights_phong_fragment: lights_phong_fragment,
	lights_phong_pars_fragment: lights_phong_pars_fragment,
	lights_physical_fragment: lights_physical_fragment,
	lights_physical_pars_fragment: lights_physical_pars_fragment,
	lights_fragment_begin: lights_fragment_begin,
	lights_fragment_maps: lights_fragment_maps,
	lights_fragment_end: lights_fragment_end,
	logdepthbuf_fragment: logdepthbuf_fragment,
	logdepthbuf_pars_fragment: logdepthbuf_pars_fragment,
	logdepthbuf_pars_vertex: logdepthbuf_pars_vertex,
	logdepthbuf_vertex: logdepthbuf_vertex,
	map_fragment: map_fragment,
	map_pars_fragment: map_pars_fragment,
	map_particle_fragment: map_particle_fragment,
	map_particle_pars_fragment: map_particle_pars_fragment,
	metalnessmap_fragment: metalnessmap_fragment,
	metalnessmap_pars_fragment: metalnessmap_pars_fragment,
	morphinstance_vertex: morphinstance_vertex,
	morphcolor_vertex: morphcolor_vertex,
	morphnormal_vertex: morphnormal_vertex,
	morphtarget_pars_vertex: morphtarget_pars_vertex,
	morphtarget_vertex: morphtarget_vertex,
	normal_fragment_begin: normal_fragment_begin,
	normal_fragment_maps: normal_fragment_maps,
	normal_pars_fragment: normal_pars_fragment,
	normal_pars_vertex: normal_pars_vertex,
	normal_vertex: normal_vertex,
	normalmap_pars_fragment: normalmap_pars_fragment,
	clearcoat_normal_fragment_begin: clearcoat_normal_fragment_begin,
	clearcoat_normal_fragment_maps: clearcoat_normal_fragment_maps,
	clearcoat_pars_fragment: clearcoat_pars_fragment,
	iridescence_pars_fragment: iridescence_pars_fragment,
	opaque_fragment: opaque_fragment,
	packing: packing,
	premultiplied_alpha_fragment: premultiplied_alpha_fragment,
	project_vertex: project_vertex,
	dithering_fragment: dithering_fragment,
	dithering_pars_fragment: dithering_pars_fragment,
	roughnessmap_fragment: roughnessmap_fragment,
	roughnessmap_pars_fragment: roughnessmap_pars_fragment,
	shadowmap_pars_fragment: shadowmap_pars_fragment,
	shadowmap_pars_vertex: shadowmap_pars_vertex,
	shadowmap_vertex: shadowmap_vertex,
	shadowmask_pars_fragment: shadowmask_pars_fragment,
	skinbase_vertex: skinbase_vertex,
	skinning_pars_vertex: skinning_pars_vertex,
	skinning_vertex: skinning_vertex,
	skinnormal_vertex: skinnormal_vertex,
	specularmap_fragment: specularmap_fragment,
	specularmap_pars_fragment: specularmap_pars_fragment,
	tonemapping_fragment: tonemapping_fragment,
	tonemapping_pars_fragment: tonemapping_pars_fragment,
	transmission_fragment: transmission_fragment,
	transmission_pars_fragment: transmission_pars_fragment,
	uv_pars_fragment: uv_pars_fragment,
	uv_pars_vertex: uv_pars_vertex,
	uv_vertex: uv_vertex,
	worldpos_vertex: worldpos_vertex,

	background_vert: vertex$h,
	background_frag: fragment$h,
	backgroundCube_vert: vertex$g,
	backgroundCube_frag: fragment$g,
	cube_vert: vertex$f,
	cube_frag: fragment$f,
	depth_vert: vertex$e,
	depth_frag: fragment$e,
	distanceRGBA_vert: vertex$d,
	distanceRGBA_frag: fragment$d,
	equirect_vert: vertex$c,
	equirect_frag: fragment$c,
	linedashed_vert: vertex$b,
	linedashed_frag: fragment$b,
	meshbasic_vert: vertex$a,
	meshbasic_frag: fragment$a,
	meshlambert_vert: vertex$9,
	meshlambert_frag: fragment$9,
	meshmatcap_vert: vertex$8,
	meshmatcap_frag: fragment$8,
	meshnormal_vert: vertex$7,
	meshnormal_frag: fragment$7,
	meshphong_vert: vertex$6,
	meshphong_frag: fragment$6,
	meshphysical_vert: vertex$5,
	meshphysical_frag: fragment$5,
	meshtoon_vert: vertex$4,
	meshtoon_frag: fragment$4,
	points_vert: vertex$3,
	points_frag: fragment$3,
	shadow_vert: vertex$2,
	shadow_frag: fragment$2,
	sprite_vert: vertex$1,
	sprite_frag: fragment$1
};

/**
 * Uniforms library for shared webgl shaders
 */

const UniformsLib = {

	common: {

		diffuse: { value: /*@__PURE__*/ new Color( 0xffffff ) },
		opacity: { value: 1.0 },

		map: { value: null },
		mapTransform: { value: /*@__PURE__*/ new Matrix3() },

		alphaMap: { value: null },
		alphaMapTransform: { value: /*@__PURE__*/ new Matrix3() },

		alphaTest: { value: 0 }

	},

	specularmap: {

		specularMap: { value: null },
		specularMapTransform: { value: /*@__PURE__*/ new Matrix3() }

	},

	envmap: {

		envMap: { value: null },
		envMapRotation: { value: /*@__PURE__*/ new Matrix3() },
		flipEnvMap: { value: - 1 },
		reflectivity: { value: 1.0 }, // basic, lambert, phong
		ior: { value: 1.5 }, // physical
		refractionRatio: { value: 0.98 }, // basic, lambert, phong

	},

	aomap: {

		aoMap: { value: null },
		aoMapIntensity: { value: 1 },
		aoMapTransform: { value: /*@__PURE__*/ new Matrix3() }

	},

	lightmap: {

		lightMap: { value: null },
		lightMapIntensity: { value: 1 },
		lightMapTransform: { value: /*@__PURE__*/ new Matrix3() }

	},

	bumpmap: {

		bumpMap: { value: null },
		bumpMapTransform: { value: /*@__PURE__*/ new Matrix3() },
		bumpScale: { value: 1 }

	},

	normalmap: {

		normalMap: { value: null },
		normalMapTransform: { value: /*@__PURE__*/ new Matrix3() },
		normalScale: { value: /*@__PURE__*/ new Vector2( 1, 1 ) }

	},

	displacementmap: {

		displacementMap: { value: null },
		displacementMapTransform: { value: /*@__PURE__*/ new Matrix3() },
		displacementScale: { value: 1 },
		displacementBias: { value: 0 }

	},

	emissivemap: {

		emissiveMap: { value: null },
		emissiveMapTransform: { value: /*@__PURE__*/ new Matrix3() }

	},

	metalnessmap: {

		metalnessMap: { value: null },
		metalnessMapTransform: { value: /*@__PURE__*/ new Matrix3() }

	},

	roughnessmap: {

		roughnessMap: { value: null },
		roughnessMapTransform: { value: /*@__PURE__*/ new Matrix3() }

	},

	gradientmap: {

		gradientMap: { value: null }

	},

	fog: {

		fogDensity: { value: 0.00025 },
		fogNear: { value: 1 },
		fogFar: { value: 2000 },
		fogColor: { value: /*@__PURE__*/ new Color( 0xffffff ) }

	},

	lights: {

		ambientLightColor: { value: [] },

		lightProbe: { value: [] },

		directionalLights: { value: [], properties: {
			direction: {},
			color: {}
		} },

		directionalLightShadows: { value: [], properties: {
			shadowBias: {},
			shadowNormalBias: {},
			shadowRadius: {},
			shadowMapSize: {}
		} },

		directionalShadowMap: { value: [] },
		directionalShadowMatrix: { value: [] },

		spotLights: { value: [], properties: {
			color: {},
			position: {},
			direction: {},
			distance: {},
			coneCos: {},
			penumbraCos: {},
			decay: {}
		} },

		spotLightShadows: { value: [], properties: {
			shadowBias: {},
			shadowNormalBias: {},
			shadowRadius: {},
			shadowMapSize: {}
		} },

		spotLightMap: { value: [] },
		spotShadowMap: { value: [] },
		spotLightMatrix: { value: [] },

		pointLights: { value: [], properties: {
			color: {},
			position: {},
			decay: {},
			distance: {}
		} },

		pointLightShadows: { value: [], properties: {
			shadowBias: {},
			shadowNormalBias: {},
			shadowRadius: {},
			shadowMapSize: {},
			shadowCameraNear: {},
			shadowCameraFar: {}
		} },

		pointShadowMap: { value: [] },
		pointShadowMatrix: { value: [] },

		hemisphereLights: { value: [], properties: {
			direction: {},
			skyColor: {},
			groundColor: {}
		} },

		// TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
		rectAreaLights: { value: [], properties: {
			color: {},
			position: {},
			width: {},
			height: {}
		} },

		ltc_1: { value: null },
		ltc_2: { value: null }

	},

	points: {

		diffuse: { value: /*@__PURE__*/ new Color( 0xffffff ) },
		opacity: { value: 1.0 },
		size: { value: 1.0 },
		scale: { value: 1.0 },
		map: { value: null },
		alphaMap: { value: null },
		alphaMapTransform: { value: /*@__PURE__*/ new Matrix3() },
		alphaTest: { value: 0 },
		uvTransform: { value: /*@__PURE__*/ new Matrix3() }

	},

	sprite: {

		diffuse: { value: /*@__PURE__*/ new Color( 0xffffff ) },
		opacity: { value: 1.0 },
		center: { value: /*@__PURE__*/ new Vector2( 0.5, 0.5 ) },
		rotation: { value: 0.0 },
		map: { value: null },
		mapTransform: { value: /*@__PURE__*/ new Matrix3() },
		alphaMap: { value: null },
		alphaMapTransform: { value: /*@__PURE__*/ new Matrix3() },
		alphaTest: { value: 0 }

	}

};

const ShaderLib = {

	basic: {

		uniforms: /*@__PURE__*/ mergeUniforms( [
			UniformsLib.common,
			UniformsLib.specularmap,
			UniformsLib.envmap,
			UniformsLib.aomap,
			UniformsLib.lightmap,
			UniformsLib.fog
		] ),

		vertexShader: ShaderChunk.meshbasic_vert,
		fragmentShader: ShaderChunk.meshbasic_frag

	},

	lambert: {

		uniforms: /*@__PURE__*/ mergeUniforms( [
			UniformsLib.common,
			UniformsLib.specularmap,
			UniformsLib.envmap,
			UniformsLib.aomap,
			UniformsLib.lightmap,
			UniformsLib.emissivemap,
			UniformsLib.bumpmap,
			UniformsLib.normalmap,
			UniformsLib.displacementmap,
			UniformsLib.fog,
			UniformsLib.lights,
			{
				emissive: { value: /*@__PURE__*/ new Color( 0x000000 ) }
			}
		] ),

		vertexShader: ShaderChunk.meshlambert_vert,
		fragmentShader: ShaderChunk.meshlambert_frag

	},

	phong: {

		uniforms: /*@__PURE__*/ mergeUniforms( [
			UniformsLib.common,
			UniformsLib.specularmap,
			UniformsLib.envmap,
			UniformsLib.aomap,
			UniformsLib.lightmap,
			UniformsLib.emissivemap,
			UniformsLib.bumpmap,
			UniformsLib.normalmap,
			UniformsLib.displacementmap,
			UniformsLib.fog,
			UniformsLib.lights,
			{
				emissive: { value: /*@__PURE__*/ new Color( 0x000000 ) },
				specular: { value: /*@__PURE__*/ new Color( 0x111111 ) },
				shininess: { value: 30 }
			}
		] ),

		vertexShader: ShaderChunk.meshphong_vert,
		fragmentShader: ShaderChunk.meshphong_frag

	},

	standard: {

		uniforms: /*@__PURE__*/ mergeUniforms( [
			UniformsLib.common,
			UniformsLib.envmap,
			UniformsLib.aomap,
			UniformsLib.lightmap,
			UniformsLib.emissivemap,
			UniformsLib.bumpmap,
			UniformsLib.normalmap,
			UniformsLib.displacementmap,
			UniformsLib.roughnessmap,
			UniformsLib.metalnessmap,
			UniformsLib.fog,
			UniformsLib.lights,
			{
				emissive: { value: /*@__PURE__*/ new Color( 0x000000 ) },
				roughness: { value: 1.0 },
				metalness: { value: 0.0 },
				envMapIntensity: { value: 1 }
			}
		] ),

		vertexShader: ShaderChunk.meshphysical_vert,
		fragmentShader: ShaderChunk.meshphysical_frag

	},

	toon: {

		uniforms: /*@__PURE__*/ mergeUniforms( [
			UniformsLib.common,
			UniformsLib.aomap,
			UniformsLib.lightmap,
			UniformsLib.emissivemap,
			UniformsLib.bumpmap,
			UniformsLib.normalmap,
			UniformsLib.displacementmap,
			UniformsLib.gradientmap,
			UniformsLib.fog,
			UniformsLib.lights,
			{
				emissive: { value: /*@__PURE__*/ new Color( 0x000000 ) }
			}
		] ),

		vertexShader: ShaderChunk.meshtoon_vert,
		fragmentShader: ShaderChunk.meshtoon_frag

	},

	matcap: {

		uniforms: /*@__PURE__*/ mergeUniforms( [
			UniformsLib.common,
			UniformsLib.bumpmap,
			UniformsLib.normalmap,
			UniformsLib.displacementmap,
			UniformsLib.fog,
			{
				matcap: { value: null }
			}
		] ),

		vertexShader: ShaderChunk.meshmatcap_vert,
		fragmentShader: ShaderChunk.meshmatcap_frag

	},

	points: {

		uniforms: /*@__PURE__*/ mergeUniforms( [
			UniformsLib.points,
			UniformsLib.fog
		] ),

		vertexShader: ShaderChunk.points_vert,
		fragmentShader: ShaderChunk.points_frag

	},

	dashed: {

		uniforms: /*@__PURE__*/ mergeUniforms( [
			UniformsLib.common,
			UniformsLib.fog,
			{
				scale: { value: 1 },
				dashSize: { value: 1 },
				totalSize: { value: 2 }
			}
		] ),

		vertexShader: ShaderChunk.linedashed_vert,
		fragmentShader: ShaderChunk.linedashed_frag

	},

	depth: {

		uniforms: /*@__PURE__*/ mergeUniforms( [
			UniformsLib.common,
			UniformsLib.displacementmap
		] ),

		vertexShader: ShaderChunk.depth_vert,
		fragmentShader: ShaderChunk.depth_frag

	},

	normal: {

		uniforms: /*@__PURE__*/ mergeUniforms( [
			UniformsLib.common,
			UniformsLib.bumpmap,
			UniformsLib.normalmap,
			UniformsLib.displacementmap,
			{
				opacity: { value: 1.0 }
			}
		] ),

		vertexShader: ShaderChunk.meshnormal_vert,
		fragmentShader: ShaderChunk.meshnormal_frag

	},

	sprite: {

		uniforms: /*@__PURE__*/ mergeUniforms( [
			UniformsLib.sprite,
			UniformsLib.fog
		] ),

		vertexShader: ShaderChunk.sprite_vert,
		fragmentShader: ShaderChunk.sprite_frag

	},

	background: {

		uniforms: {
			uvTransform: { value: /*@__PURE__*/ new Matrix3() },
			t2D: { value: null },
			backgroundIntensity: { value: 1 }
		},

		vertexShader: ShaderChunk.background_vert,
		fragmentShader: ShaderChunk.background_frag

	},

	backgroundCube: {

		uniforms: {
			envMap: { value: null },
			flipEnvMap: { value: - 1 },
			backgroundBlurriness: { value: 0 },
			backgroundIntensity: { value: 1 },
			backgroundRotation: { value: /*@__PURE__*/ new Matrix3() }
		},

		vertexShader: ShaderChunk.backgroundCube_vert,
		fragmentShader: ShaderChunk.backgroundCube_frag

	},

	cube: {

		uniforms: {
			tCube: { value: null },
			tFlip: { value: - 1 },
			opacity: { value: 1.0 }
		},

		vertexShader: ShaderChunk.cube_vert,
		fragmentShader: ShaderChunk.cube_frag

	},

	equirect: {

		uniforms: {
			tEquirect: { value: null },
		},

		vertexShader: ShaderChunk.equirect_vert,
		fragmentShader: ShaderChunk.equirect_frag

	},

	distanceRGBA: {

		uniforms: /*@__PURE__*/ mergeUniforms( [
			UniformsLib.common,
			UniformsLib.displacementmap,
			{
				referencePosition: { value: /*@__PURE__*/ new Vector3() },
				nearDistance: { value: 1 },
				farDistance: { value: 1000 }
			}
		] ),

		vertexShader: ShaderChunk.distanceRGBA_vert,
		fragmentShader: ShaderChunk.distanceRGBA_frag

	},

	shadow: {

		uniforms: /*@__PURE__*/ mergeUniforms( [
			UniformsLib.lights,
			UniformsLib.fog,
			{
				color: { value: /*@__PURE__*/ new Color( 0x00000 ) },
				opacity: { value: 1.0 }
			},
		] ),

		vertexShader: ShaderChunk.shadow_vert,
		fragmentShader: ShaderChunk.shadow_frag

	}

};

ShaderLib.physical = {

	uniforms: /*@__PURE__*/ mergeUniforms( [
		ShaderLib.standard.uniforms,
		{
			clearcoat: { value: 0 },
			clearcoatMap: { value: null },
			clearcoatMapTransform: { value: /*@__PURE__*/ new Matrix3() },
			clearcoatNormalMap: { value: null },
			clearcoatNormalMapTransform: { value: /*@__PURE__*/ new Matrix3() },
			clearcoatNormalScale: { value: /*@__PURE__*/ new Vector2( 1, 1 ) },
			clearcoatRoughness: { value: 0 },
			clearcoatRoughnessMap: { value: null },
			clearcoatRoughnessMapTransform: { value: /*@__PURE__*/ new Matrix3() },
			iridescence: { value: 0 },
			iridescenceMap: { value: null },
			iridescenceMapTransform: { value: /*@__PURE__*/ new Matrix3() },
			iridescenceIOR: { value: 1.3 },
			iridescenceThicknessMinimum: { value: 100 },
			iridescenceThicknessMaximum: { value: 400 },
			iridescenceThicknessMap: { value: null },
			iridescenceThicknessMapTransform: { value: /*@__PURE__*/ new Matrix3() },
			sheen: { value: 0 },
			sheenColor: { value: /*@__PURE__*/ new Color( 0x000000 ) },
			sheenColorMap: { value: null },
			sheenColorMapTransform: { value: /*@__PURE__*/ new Matrix3() },
			sheenRoughness: { value: 1 },
			sheenRoughnessMap: { value: null },
			sheenRoughnessMapTransform: { value: /*@__PURE__*/ new Matrix3() },
			transmission: { value: 0 },
			transmissionMap: { value: null },
			transmissionMapTransform: { value: /*@__PURE__*/ new Matrix3() },
			transmissionSamplerSize: { value: /*@__PURE__*/ new Vector2() },
			transmissionSamplerMap: { value: null },
			thickness: { value: 0 },
			thicknessMap: { value: null },
			thicknessMapTransform: { value: /*@__PURE__*/ new Matrix3() },
			attenuationDistance: { value: 0 },
			attenuationColor: { value: /*@__PURE__*/ new Color( 0x000000 ) },
			specularColor: { value: /*@__PURE__*/ new Color( 1, 1, 1 ) },
			specularColorMap: { value: null },
			specularColorMapTransform: { value: /*@__PURE__*/ new Matrix3() },
			specularIntensity: { value: 1 },
			specularIntensityMap: { value: null },
			specularIntensityMapTransform: { value: /*@__PURE__*/ new Matrix3() },
			anisotropyVector: { value: /*@__PURE__*/ new Vector2() },
			anisotropyMap: { value: null },
			anisotropyMapTransform: { value: /*@__PURE__*/ new Matrix3() },
		}
	] ),

	vertexShader: ShaderChunk.meshphysical_vert,
	fragmentShader: ShaderChunk.meshphysical_frag

};

const _rgb = { r: 0, b: 0, g: 0 };
const _e1$1 = /*@__PURE__*/ new Euler();
const _m1$1 = /*@__PURE__*/ new Matrix4();

function WebGLBackground( renderer, cubemaps, cubeuvmaps, state, objects, alpha, premultipliedAlpha ) {

	const clearColor = new Color( 0x000000 );
	let clearAlpha = alpha === true ? 0 : 1;

	let planeMesh;
	let boxMesh;

	let currentBackground = null;
	let currentBackgroundVersion = 0;
	let currentTonemapping = null;

	function render( renderList, scene ) {

		let forceClear = false;
		let background = scene.isScene === true ? scene.background : null;

		if ( background && background.isTexture ) {

			const usePMREM = scene.backgroundBlurriness > 0; // use PMREM if the user wants to blur the background
			background = ( usePMREM ? cubeuvmaps : cubemaps ).get( background );

		}

		if ( background === null ) {

			setClear( clearColor, clearAlpha );

		} else if ( background && background.isColor ) {

			setClear( background, 1 );
			forceClear = true;

		}

		const environmentBlendMode = renderer.xr.getEnvironmentBlendMode();

		if ( environmentBlendMode === 'additive' ) {

			state.buffers.color.setClear( 0, 0, 0, 1, premultipliedAlpha );

		} else if ( environmentBlendMode === 'alpha-blend' ) {

			state.buffers.color.setClear( 0, 0, 0, 0, premultipliedAlpha );

		}

		if ( renderer.autoClear || forceClear ) {

			renderer.clear( renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil );

		}

		if ( background && ( background.isCubeTexture || background.mapping === CubeUVReflectionMapping ) ) {

			if ( boxMesh === undefined ) {

				boxMesh = new Mesh(
					new BoxGeometry( 1, 1, 1 ),
					new ShaderMaterial( {
						name: 'BackgroundCubeMaterial',
						uniforms: cloneUniforms( ShaderLib.backgroundCube.uniforms ),
						vertexShader: ShaderLib.backgroundCube.vertexShader,
						fragmentShader: ShaderLib.backgroundCube.fragmentShader,
						side: BackSide,
						depthTest: false,
						depthWrite: false,
						fog: false
					} )
				);

				boxMesh.geometry.deleteAttribute( 'normal' );
				boxMesh.geometry.deleteAttribute( 'uv' );

				boxMesh.onBeforeRender = function ( renderer, scene, camera ) {

					this.matrixWorld.copyPosition( camera.matrixWorld );

				};

				// add "envMap" material property so the renderer can evaluate it like for built-in materials
				Object.defineProperty( boxMesh.material, 'envMap', {

					get: function () {

						return this.uniforms.envMap.value;

					}

				} );

				objects.update( boxMesh );

			}

			_e1$1.copy( scene.backgroundRotation );

			// accommodate left-handed frame
			_e1$1.x *= - 1; _e1$1.y *= - 1; _e1$1.z *= - 1;

			if ( background.isCubeTexture && background.isRenderTargetTexture === false ) {

				// environment maps which are not cube render targets or PMREMs follow a different convention
				_e1$1.y *= - 1;
				_e1$1.z *= - 1;

			}

			boxMesh.material.uniforms.envMap.value = background;
			boxMesh.material.uniforms.flipEnvMap.value = ( background.isCubeTexture && background.isRenderTargetTexture === false ) ? - 1 : 1;
			boxMesh.material.uniforms.backgroundBlurriness.value = scene.backgroundBlurriness;
			boxMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
			boxMesh.material.uniforms.backgroundRotation.value.setFromMatrix4( _m1$1.makeRotationFromEuler( _e1$1 ) );
			boxMesh.material.toneMapped = ColorManagement.getTransfer( background.colorSpace ) !== SRGBTransfer;

			if ( currentBackground !== background ||
				currentBackgroundVersion !== background.version ||
				currentTonemapping !== renderer.toneMapping ) {

				boxMesh.material.needsUpdate = true;

				currentBackground = background;
				currentBackgroundVersion = background.version;
				currentTonemapping = renderer.toneMapping;

			}

			boxMesh.layers.enableAll();

			// push to the pre-sorted opaque render list
			renderList.unshift( boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null );

		} else if ( background && background.isTexture ) {

			if ( planeMesh === undefined ) {

				planeMesh = new Mesh(
					new PlaneGeometry( 2, 2 ),
					new ShaderMaterial( {
						name: 'BackgroundMaterial',
						uniforms: cloneUniforms( ShaderLib.background.uniforms ),
						vertexShader: ShaderLib.background.vertexShader,
						fragmentShader: ShaderLib.background.fragmentShader,
						side: FrontSide,
						depthTest: false,
						depthWrite: false,
						fog: false
					} )
				);

				planeMesh.geometry.deleteAttribute( 'normal' );

				// add "map" material property so the renderer can evaluate it like for built-in materials
				Object.defineProperty( planeMesh.material, 'map', {

					get: function () {

						return this.uniforms.t2D.value;

					}

				} );

				objects.update( planeMesh );

			}

			planeMesh.material.uniforms.t2D.value = background;
			planeMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
			planeMesh.material.toneMapped = ColorManagement.getTransfer( background.colorSpace ) !== SRGBTransfer;

			if ( background.matrixAutoUpdate === true ) {

				background.updateMatrix();

			}

			planeMesh.material.uniforms.uvTransform.value.copy( background.matrix );

			if ( currentBackground !== background ||
				currentBackgroundVersion !== background.version ||
				currentTonemapping !== renderer.toneMapping ) {

				planeMesh.material.needsUpdate = true;

				currentBackground = background;
				currentBackgroundVersion = background.version;
				currentTonemapping = renderer.toneMapping;

			}

			planeMesh.layers.enableAll();

			// push to the pre-sorted opaque render list
			renderList.unshift( planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null );

		}

	}

	function setClear( color, alpha ) {

		color.getRGB( _rgb, getUnlitUniformColorSpace( renderer ) );

		state.buffers.color.setClear( _rgb.r, _rgb.g, _rgb.b, alpha, premultipliedAlpha );

	}

	return {

		getClearColor: function () {

			return clearColor;

		},
		setClearColor: function ( color, alpha = 1 ) {

			clearColor.set( color );
			clearAlpha = alpha;
			setClear( clearColor, clearAlpha );

		},
		getClearAlpha: function () {

			return clearAlpha;

		},
		setClearAlpha: function ( alpha ) {

			clearAlpha = alpha;
			setClear( clearColor, clearAlpha );

		},
		render: render

	};

}

function WebGLBindingStates( gl, attributes ) {

	const maxVertexAttributes = gl.getParameter( gl.MAX_VERTEX_ATTRIBS );

	const bindingStates = {};

	const defaultState = createBindingState( null );
	let currentState = defaultState;
	let forceUpdate = false;

	function setup( object, material, program, geometry, index ) {

		let updateBuffers = false;

		const state = getBindingState( geometry, program, material );

		if ( currentState !== state ) {

			currentState = state;
			bindVertexArrayObject( currentState.object );

		}

		updateBuffers = needsUpdate( object, geometry, program, index );

		if ( updateBuffers ) saveCache( object, geometry, program, index );

		if ( index !== null ) {

			attributes.update( index, gl.ELEMENT_ARRAY_BUFFER );

		}

		if ( updateBuffers || forceUpdate ) {

			forceUpdate = false;

			setupVertexAttributes( object, material, program, geometry );

			if ( index !== null ) {

				gl.bindBuffer( gl.ELEMENT_ARRAY_BUFFER, attributes.get( index ).buffer );

			}

		}

	}

	function createVertexArrayObject() {

		return gl.createVertexArray();

	}

	function bindVertexArrayObject( vao ) {

		return gl.bindVertexArray( vao );

	}

	function deleteVertexArrayObject( vao ) {

		return gl.deleteVertexArray( vao );

	}

	function getBindingState( geometry, program, material ) {

		const wireframe = ( material.wireframe === true );

		let programMap = bindingStates[ geometry.id ];

		if ( programMap === undefined ) {

			programMap = {};
			bindingStates[ geometry.id ] = programMap;

		}

		let stateMap = programMap[ program.id ];

		if ( stateMap === undefined ) {

			stateMap = {};
			programMap[ program.id ] = stateMap;

		}

		let state = stateMap[ wireframe ];

		if ( state === undefined ) {

			state = createBindingState( createVertexArrayObject() );
			stateMap[ wireframe ] = state;

		}

		return state;

	}

	function createBindingState( vao ) {

		const newAttributes = [];
		const enabledAttributes = [];
		const attributeDivisors = [];

		for ( let i = 0; i < maxVertexAttributes; i ++ ) {

			newAttributes[ i ] = 0;
			enabledAttributes[ i ] = 0;
			attributeDivisors[ i ] = 0;

		}

		return {

			// for backward compatibility on non-VAO support browser
			geometry: null,
			program: null,
			wireframe: false,

			newAttributes: newAttributes,
			enabledAttributes: enabledAttributes,
			attributeDivisors: attributeDivisors,
			object: vao,
			attributes: {},
			index: null

		};

	}

	function needsUpdate( object, geometry, program, index ) {

		const cachedAttributes = currentState.attributes;
		const geometryAttributes = geometry.attributes;

		let attributesNum = 0;

		const programAttributes = program.getAttributes();

		for ( const name in programAttributes ) {

			const programAttribute = programAttributes[ name ];

			if ( programAttribute.location >= 0 ) {

				const cachedAttribute = cachedAttributes[ name ];
				let geometryAttribute = geometryAttributes[ name ];

				if ( geometryAttribute === undefined ) {

					if ( name === 'instanceMatrix' && object.instanceMatrix ) geometryAttribute = object.instanceMatrix;
					if ( name === 'instanceColor' && object.instanceColor ) geometryAttribute = object.instanceColor;

				}

				if ( cachedAttribute === undefined ) return true;

				if ( cachedAttribute.attribute !== geometryAttribute ) return true;

				if ( geometryAttribute && cachedAttribute.data !== geometryAttribute.data ) return true;

				attributesNum ++;

			}

		}

		if ( currentState.attributesNum !== attributesNum ) return true;

		if ( currentState.index !== index ) return true;

		return false;

	}

	function saveCache( object, geometry, program, index ) {

		const cache = {};
		const attributes = geometry.attributes;
		let attributesNum = 0;

		const programAttributes = program.getAttributes();

		for ( const name in programAttributes ) {

			const programAttribute = programAttributes[ name ];

			if ( programAttribute.location >= 0 ) {

				let attribute = attributes[ name ];

				if ( attribute === undefined ) {

					if ( name === 'instanceMatrix' && object.instanceMatrix ) attribute = object.instanceMatrix;
					if ( name === 'instanceColor' && object.instanceColor ) attribute = object.instanceColor;

				}

				const data = {};
				data.attribute = attribute;

				if ( attribute && attribute.data ) {

					data.data = attribute.data;

				}

				cache[ name ] = data;

				attributesNum ++;

			}

		}

		currentState.attributes = cache;
		currentState.attributesNum = attributesNum;

		currentState.index = index;

	}

	function initAttributes() {

		const newAttributes = currentState.newAttributes;

		for ( let i = 0, il = newAttributes.length; i < il; i ++ ) {

			newAttributes[ i ] = 0;

		}

	}

	function enableAttribute( attribute ) {

		enableAttributeAndDivisor( attribute, 0 );

	}

	function enableAttributeAndDivisor( attribute, meshPerAttribute ) {

		const newAttributes = currentState.newAttributes;
		const enabledAttributes = currentState.enabledAttributes;
		const attributeDivisors = currentState.attributeDivisors;

		newAttributes[ attribute ] = 1;

		if ( enabledAttributes[ attribute ] === 0 ) {

			gl.enableVertexAttribArray( attribute );
			enabledAttributes[ attribute ] = 1;

		}

		if ( attributeDivisors[ attribute ] !== meshPerAttribute ) {

			gl.vertexAttribDivisor( attribute, meshPerAttribute );
			attributeDivisors[ attribute ] = meshPerAttribute;

		}

	}

	function disableUnusedAttributes() {

		const newAttributes = currentState.newAttributes;
		const enabledAttributes = currentState.enabledAttributes;

		for ( let i = 0, il = enabledAttributes.length; i < il; i ++ ) {

			if ( enabledAttributes[ i ] !== newAttributes[ i ] ) {

				gl.disableVertexAttribArray( i );
				enabledAttributes[ i ] = 0;

			}

		}

	}

	function vertexAttribPointer( index, size, type, normalized, stride, offset, integer ) {

		if ( integer === true ) {

			gl.vertexAttribIPointer( index, size, type, stride, offset );

		} else {

			gl.vertexAttribPointer( index, size, type, normalized, stride, offset );

		}

	}

	function setupVertexAttributes( object, material, program, geometry ) {

		initAttributes();

		const geometryAttributes = geometry.attributes;

		const programAttributes = program.getAttributes();

		const materialDefaultAttributeValues = material.defaultAttributeValues;

		for ( const name in programAttributes ) {

			const programAttribute = programAttributes[ name ];

			if ( programAttribute.location >= 0 ) {

				let geometryAttribute = geometryAttributes[ name ];

				if ( geometryAttribute === undefined ) {

					if ( name === 'instanceMatrix' && object.instanceMatrix ) geometryAttribute = object.instanceMatrix;
					if ( name === 'instanceColor' && object.instanceColor ) geometryAttribute = object.instanceColor;

				}

				if ( geometryAttribute !== undefined ) {

					const normalized = geometryAttribute.normalized;
					const size = geometryAttribute.itemSize;

					const attribute = attributes.get( geometryAttribute );

					// TODO Attribute may not be available on context restore

					if ( attribute === undefined ) continue;

					const buffer = attribute.buffer;
					const type = attribute.type;
					const bytesPerElement = attribute.bytesPerElement;

					// check for integer attributes

					const integer = ( type === gl.INT || type === gl.UNSIGNED_INT || geometryAttribute.gpuType === IntType );

					if ( geometryAttribute.isInterleavedBufferAttribute ) {

						const data = geometryAttribute.data;
						const stride = data.stride;
						const offset = geometryAttribute.offset;

						if ( data.isInstancedInterleavedBuffer ) {

							for ( let i = 0; i < programAttribute.locationSize; i ++ ) {

								enableAttributeAndDivisor( programAttribute.location + i, data.meshPerAttribute );

							}

							if ( object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined ) {

								geometry._maxInstanceCount = data.meshPerAttribute * data.count;

							}

						} else {

							for ( let i = 0; i < programAttribute.locationSize; i ++ ) {

								enableAttribute( programAttribute.location + i );

							}

						}

						gl.bindBuffer( gl.ARRAY_BUFFER, buffer );

						for ( let i = 0; i < programAttribute.locationSize; i ++ ) {

							vertexAttribPointer(
								programAttribute.location + i,
								size / programAttribute.locationSize,
								type,
								normalized,
								stride * bytesPerElement,
								( offset + ( size / programAttribute.locationSize ) * i ) * bytesPerElement,
								integer
							);

						}

					} else {

						if ( geometryAttribute.isInstancedBufferAttribute ) {

							for ( let i = 0; i < programAttribute.locationSize; i ++ ) {

								enableAttributeAndDivisor( programAttribute.location + i, geometryAttribute.meshPerAttribute );

							}

							if ( object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined ) {

								geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;

							}

						} else {

							for ( let i = 0; i < programAttribute.locationSize; i ++ ) {

								enableAttribute( programAttribute.location + i );

							}

						}

						gl.bindBuffer( gl.ARRAY_BUFFER, buffer );

						for ( let i = 0; i < programAttribute.locationSize; i ++ ) {

							vertexAttribPointer(
								programAttribute.location + i,
								size / programAttribute.locationSize,
								type,
								normalized,
								size * bytesPerElement,
								( size / programAttribute.locationSize ) * i * bytesPerElement,
								integer
							);

						}

					}

				} else if ( materialDefaultAttributeValues !== undefined ) {

					const value = materialDefaultAttributeValues[ name ];

					if ( value !== undefined ) {

						switch ( value.length ) {

							case 2:
								gl.vertexAttrib2fv( programAttribute.location, value );
								break;

							case 3:
								gl.vertexAttrib3fv( programAttribute.location, value );
								break;

							case 4:
								gl.vertexAttrib4fv( programAttribute.location, value );
								break;

							default:
								gl.vertexAttrib1fv( programAttribute.location, value );

						}

					}

				}

			}

		}

		disableUnusedAttributes();

	}

	function dispose() {

		reset();

		for ( const geometryId in bindingStates ) {

			const programMap = bindingStates[ geometryId ];

			for ( const programId in programMap ) {

				const stateMap = programMap[ programId ];

				for ( const wireframe in stateMap ) {

					deleteVertexArrayObject( stateMap[ wireframe ].object );

					delete stateMap[ wireframe ];

				}

				delete programMap[ programId ];

			}

			delete bindingStates[ geometryId ];

		}

	}

	function releaseStatesOfGeometry( geometry ) {

		if ( bindingStates[ geometry.id ] === undefined ) return;

		const programMap = bindingStates[ geometry.id ];

		for ( const programId in programMap ) {

			const stateMap = programMap[ programId ];

			for ( const wireframe in stateMap ) {

				deleteVertexArrayObject( stateMap[ wireframe ].object );

				delete stateMap[ wireframe ];

			}

			delete programMap[ programId ];

		}

		delete bindingStates[ geometry.id ];

	}

	function releaseStatesOfProgram( program ) {

		for ( const geometryId in bindingStates ) {

			const programMap = bindingStates[ geometryId ];

			if ( programMap[ program.id ] === undefined ) continue;

			const stateMap = programMap[ program.id ];

			for ( const wireframe in stateMap ) {

				deleteVertexArrayObject( stateMap[ wireframe ].object );

				delete stateMap[ wireframe ];

			}

			delete programMap[ program.id ];

		}

	}

	function reset() {

		resetDefaultState();
		forceUpdate = true;

		if ( currentState === defaultState ) return;

		currentState = defaultState;
		bindVertexArrayObject( currentState.object );

	}

	// for backward-compatibility

	function resetDefaultState() {

		defaultState.geometry = null;
		defaultState.program = null;
		defaultState.wireframe = false;

	}

	return {

		setup: setup,
		reset: reset,
		resetDefaultState: resetDefaultState,
		dispose: dispose,
		releaseStatesOfGeometry: releaseStatesOfGeometry,
		releaseStatesOfProgram: releaseStatesOfProgram,

		initAttributes: initAttributes,
		enableAttribute: enableAttribute,
		disableUnusedAttributes: disableUnusedAttributes

	};

}

function WebGLBufferRenderer( gl, extensions, info ) {

	let mode;

	function setMode( value ) {

		mode = value;

	}

	function render( start, count ) {

		gl.drawArrays( mode, start, count );

		info.update( count, mode, 1 );

	}

	function renderInstances( start, count, primcount ) {

		if ( primcount === 0 ) return;

		gl.drawArraysInstanced( mode, start, count, primcount );

		info.update( count, mode, primcount );

	}

	function renderMultiDraw( starts, counts, drawCount ) {

		if ( drawCount === 0 ) return;

		const extension = extensions.get( 'WEBGL_multi_draw' );

		if ( extension === null ) {

			for ( let i = 0; i < drawCount; i ++ ) {

				this.render( starts[ i ], counts[ i ] );

			}

		} else {

			extension.multiDrawArraysWEBGL( mode, starts, 0, counts, 0, drawCount );

			let elementCount = 0;
			for ( let i = 0; i < drawCount; i ++ ) {

				elementCount += counts[ i ];

			}

			info.update( elementCount, mode, 1 );

		}

	}

	//

	this.setMode = setMode;
	this.render = render;
	this.renderInstances = renderInstances;
	this.renderMultiDraw = renderMultiDraw;

}

function WebGLCapabilities( gl, extensions, parameters ) {

	let maxAnisotropy;

	function getMaxAnisotropy() {

		if ( maxAnisotropy !== undefined ) return maxAnisotropy;

		if ( extensions.has( 'EXT_texture_filter_anisotropic' ) === true ) {

			const extension = extensions.get( 'EXT_texture_filter_anisotropic' );

			maxAnisotropy = gl.getParameter( extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT );

		} else {

			maxAnisotropy = 0;

		}

		return maxAnisotropy;

	}

	function getMaxPrecision( precision ) {

		if ( precision === 'highp' ) {

			if ( gl.getShaderPrecisionFormat( gl.VERTEX_SHADER, gl.HIGH_FLOAT ).precision > 0 &&
				gl.getShaderPrecisionFormat( gl.FRAGMENT_SHADER, gl.HIGH_FLOAT ).precision > 0 ) {

				return 'highp';

			}

			precision = 'mediump';

		}

		if ( precision === 'mediump' ) {

			if ( gl.getShaderPrecisionFormat( gl.VERTEX_SHADER, gl.MEDIUM_FLOAT ).precision > 0 &&
				gl.getShaderPrecisionFormat( gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT ).precision > 0 ) {

				return 'mediump';

			}

		}

		return 'lowp';

	}

	let precision = parameters.precision !== undefined ? parameters.precision : 'highp';
	const maxPrecision = getMaxPrecision( precision );

	if ( maxPrecision !== precision ) {

		console.warn( 'THREE.WebGLRenderer:', precision, 'not supported, using', maxPrecision, 'instead.' );
		precision = maxPrecision;

	}

	const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;

	const maxTextures = gl.getParameter( gl.MAX_TEXTURE_IMAGE_UNITS );
	const maxVertexTextures = gl.getParameter( gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS );
	const maxTextureSize = gl.getParameter( gl.MAX_TEXTURE_SIZE );
	const maxCubemapSize = gl.getParameter( gl.MAX_CUBE_MAP_TEXTURE_SIZE );

	const maxAttributes = gl.getParameter( gl.MAX_VERTEX_ATTRIBS );
	const maxVertexUniforms = gl.getParameter( gl.MAX_VERTEX_UNIFORM_VECTORS );
	const maxVaryings = gl.getParameter( gl.MAX_VARYING_VECTORS );
	const maxFragmentUniforms = gl.getParameter( gl.MAX_FRAGMENT_UNIFORM_VECTORS );

	const vertexTextures = maxVertexTextures > 0;

	const maxSamples = gl.getParameter( gl.MAX_SAMPLES );

	return {

		isWebGL2: true, // keeping this for backwards compatibility

		getMaxAnisotropy: getMaxAnisotropy,
		getMaxPrecision: getMaxPrecision,

		precision: precision,
		logarithmicDepthBuffer: logarithmicDepthBuffer,

		maxTextures: maxTextures,
		maxVertexTextures: maxVertexTextures,
		maxTextureSize: maxTextureSize,
		maxCubemapSize: maxCubemapSize,

		maxAttributes: maxAttributes,
		maxVertexUniforms: maxVertexUniforms,
		maxVaryings: maxVaryings,
		maxFragmentUniforms: maxFragmentUniforms,

		vertexTextures: vertexTextures,

		maxSamples: maxSamples

	};

}

function WebGLClipping( properties ) {

	const scope = this;

	let globalState = null,
		numGlobalPlanes = 0,
		localClippingEnabled = false,
		renderingShadows = false;

	const plane = new Plane(),
		viewNormalMatrix = new Matrix3(),

		uniform = { value: null, needsUpdate: false };

	this.uniform = uniform;
	this.numPlanes = 0;
	this.numIntersection = 0;

	this.init = function ( planes, enableLocalClipping ) {

		const enabled =
			planes.length !== 0 ||
			enableLocalClipping ||
			// enable state of previous frame - the clipping code has to
			// run another frame in order to reset the state:
			numGlobalPlanes !== 0 ||
			localClippingEnabled;

		localClippingEnabled = enableLocalClipping;

		numGlobalPlanes = planes.length;

		return enabled;

	};

	this.beginShadows = function () {

		renderingShadows = true;
		projectPlanes( null );

	};

	this.endShadows = function () {

		renderingShadows = false;

	};

	this.setGlobalState = function ( planes, camera ) {

		globalState = projectPlanes( planes, camera, 0 );

	};

	this.setState = function ( material, camera, useCache ) {

		const planes = material.clippingPlanes,
			clipIntersection = material.clipIntersection,
			clipShadows = material.clipShadows;

		const materialProperties = properties.get( material );

		if ( ! localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && ! clipShadows ) {

			// there's no local clipping

			if ( renderingShadows ) {

				// there's no global clipping

				projectPlanes( null );

			} else {

				resetGlobalState();

			}

		} else {

			const nGlobal = renderingShadows ? 0 : numGlobalPlanes,
				lGlobal = nGlobal * 4;

			let dstArray = materialProperties.clippingState || null;

			uniform.value = dstArray; // ensure unique state

			dstArray = projectPlanes( planes, camera, lGlobal, useCache );

			for ( let i = 0; i !== lGlobal; ++ i ) {

				dstArray[ i ] = globalState[ i ];

			}

			materialProperties.clippingState = dstArray;
			this.numIntersection = clipIntersection ? this.numPlanes : 0;
			this.numPlanes += nGlobal;

		}


	};

	function resetGlobalState() {

		if ( uniform.value !== globalState ) {

			uniform.value = globalState;
			uniform.needsUpdate = numGlobalPlanes > 0;

		}

		scope.numPlanes = numGlobalPlanes;
		scope.numIntersection = 0;

	}

	function projectPlanes( planes, camera, dstOffset, skipTransform ) {

		const nPlanes = planes !== null ? planes.length : 0;
		let dstArray = null;

		if ( nPlanes !== 0 ) {

			dstArray = uniform.value;

			if ( skipTransform !== true || dstArray === null ) {

				const flatSize = dstOffset + nPlanes * 4,
					viewMatrix = camera.matrixWorldInverse;

				viewNormalMatrix.getNormalMatrix( viewMatrix );

				if ( dstArray === null || dstArray.length < flatSize ) {

					dstArray = new Float32Array( flatSize );

				}

				for ( let i = 0, i4 = dstOffset; i !== nPlanes; ++ i, i4 += 4 ) {

					plane.copy( planes[ i ] ).applyMatrix4( viewMatrix, viewNormalMatrix );

					plane.normal.toArray( dstArray, i4 );
					dstArray[ i4 + 3 ] = plane.constant;

				}

			}

			uniform.value = dstArray;
			uniform.needsUpdate = true;

		}

		scope.numPlanes = nPlanes;
		scope.numIntersection = 0;

		return dstArray;

	}

}

function WebGLCubeMaps( renderer ) {

	let cubemaps = new WeakMap();

	function mapTextureMapping( texture, mapping ) {

		if ( mapping === EquirectangularReflectionMapping ) {

			texture.mapping = CubeReflectionMapping;

		} else if ( mapping === EquirectangularRefractionMapping ) {

			texture.mapping = CubeRefractionMapping;

		}

		return texture;

	}

	function get( texture ) {

		if ( texture && texture.isTexture ) {

			const mapping = texture.mapping;

			if ( mapping === EquirectangularReflectionMapping || mapping === EquirectangularRefractionMapping ) {

				if ( cubemaps.has( texture ) ) {

					const cubemap = cubemaps.get( texture ).texture;
					return mapTextureMapping( cubemap, texture.mapping );

				} else {

					const image = texture.image;

					if ( image && image.height > 0 ) {

						const renderTarget = new WebGLCubeRenderTarget( image.height );
						renderTarget.fromEquirectangularTexture( renderer, texture );
						cubemaps.set( texture, renderTarget );

						texture.addEventListener( 'dispose', onTextureDispose );

						return mapTextureMapping( renderTarget.texture, texture.mapping );

					} else {

						// image not yet ready. try the conversion next frame

						return null;

					}

				}

			}

		}

		return texture;

	}

	function onTextureDispose( event ) {

		const texture = event.target;

		texture.removeEventListener( 'dispose', onTextureDispose );

		const cubemap = cubemaps.get( texture );

		if ( cubemap !== undefined ) {

			cubemaps.delete( texture );
			cubemap.dispose();

		}

	}

	function dispose() {

		cubemaps = new WeakMap();

	}

	return {
		get: get,
		dispose: dispose
	};

}

class OrthographicCamera extends Camera {

	constructor( left = - 1, right = 1, top = 1, bottom = - 1, near = 0.1, far = 2000 ) {

		super();

		this.isOrthographicCamera = true;

		this.type = 'OrthographicCamera';

		this.zoom = 1;
		this.view = null;

		this.left = left;
		this.right = right;
		this.top = top;
		this.bottom = bottom;

		this.near = near;
		this.far = far;

		this.updateProjectionMatrix();

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		this.left = source.left;
		this.right = source.right;
		this.top = source.top;
		this.bottom = source.bottom;
		this.near = source.near;
		this.far = source.far;

		this.zoom = source.zoom;
		this.view = source.view === null ? null : Object.assign( {}, source.view );

		return this;

	}

	setViewOffset( fullWidth, fullHeight, x, y, width, height ) {

		if ( this.view === null ) {

			this.view = {
				enabled: true,
				fullWidth: 1,
				fullHeight: 1,
				offsetX: 0,
				offsetY: 0,
				width: 1,
				height: 1
			};

		}

		this.view.enabled = true;
		this.view.fullWidth = fullWidth;
		this.view.fullHeight = fullHeight;
		this.view.offsetX = x;
		this.view.offsetY = y;
		this.view.width = width;
		this.view.height = height;

		this.updateProjectionMatrix();

	}

	clearViewOffset() {

		if ( this.view !== null ) {

			this.view.enabled = false;

		}

		this.updateProjectionMatrix();

	}

	updateProjectionMatrix() {

		const dx = ( this.right - this.left ) / ( 2 * this.zoom );
		const dy = ( this.top - this.bottom ) / ( 2 * this.zoom );
		const cx = ( this.right + this.left ) / 2;
		const cy = ( this.top + this.bottom ) / 2;

		let left = cx - dx;
		let right = cx + dx;
		let top = cy + dy;
		let bottom = cy - dy;

		if ( this.view !== null && this.view.enabled ) {

			const scaleW = ( this.right - this.left ) / this.view.fullWidth / this.zoom;
			const scaleH = ( this.top - this.bottom ) / this.view.fullHeight / this.zoom;

			left += scaleW * this.view.offsetX;
			right = left + scaleW * this.view.width;
			top -= scaleH * this.view.offsetY;
			bottom = top - scaleH * this.view.height;

		}

		this.projectionMatrix.makeOrthographic( left, right, top, bottom, this.near, this.far, this.coordinateSystem );

		this.projectionMatrixInverse.copy( this.projectionMatrix ).invert();

	}

	toJSON( meta ) {

		const data = super.toJSON( meta );

		data.object.zoom = this.zoom;
		data.object.left = this.left;
		data.object.right = this.right;
		data.object.top = this.top;
		data.object.bottom = this.bottom;
		data.object.near = this.near;
		data.object.far = this.far;

		if ( this.view !== null ) data.object.view = Object.assign( {}, this.view );

		return data;

	}

}

const LOD_MIN = 4;

// The standard deviations (radians) associated with the extra mips. These are
// chosen to approximate a Trowbridge-Reitz distribution function times the
// geometric shadowing function. These sigma values squared must match the
// variance #defines in cube_uv_reflection_fragment.glsl.js.
const EXTRA_LOD_SIGMA = [ 0.125, 0.215, 0.35, 0.446, 0.526, 0.582 ];

// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
const MAX_SAMPLES = 20;

const _flatCamera = /*@__PURE__*/ new OrthographicCamera();
const _clearColor = /*@__PURE__*/ new Color();
let _oldTarget = null;
let _oldActiveCubeFace = 0;
let _oldActiveMipmapLevel = 0;
let _oldXrEnabled = false;

// Golden Ratio
const PHI = ( 1 + Math.sqrt( 5 ) ) / 2;
const INV_PHI = 1 / PHI;

// Vertices of a dodecahedron (except the opposites, which represent the
// same axis), used as axis directions evenly spread on a sphere.
const _axisDirections = [
	/*@__PURE__*/ new Vector3( 1, 1, 1 ),
	/*@__PURE__*/ new Vector3( - 1, 1, 1 ),
	/*@__PURE__*/ new Vector3( 1, 1, - 1 ),
	/*@__PURE__*/ new Vector3( - 1, 1, - 1 ),
	/*@__PURE__*/ new Vector3( 0, PHI, INV_PHI ),
	/*@__PURE__*/ new Vector3( 0, PHI, - INV_PHI ),
	/*@__PURE__*/ new Vector3( INV_PHI, 0, PHI ),
	/*@__PURE__*/ new Vector3( - INV_PHI, 0, PHI ),
	/*@__PURE__*/ new Vector3( PHI, INV_PHI, 0 ),
	/*@__PURE__*/ new Vector3( - PHI, INV_PHI, 0 ) ];

/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * Paper: Fast, Accurate Image-Based Lighting
 * https://drive.google.com/file/d/15y8r_UpKlU9SvV4ILb0C3qCPecS8pvLz/view
*/

class PMREMGenerator {

	constructor( renderer ) {

		this._renderer = renderer;
		this._pingPongRenderTarget = null;

		this._lodMax = 0;
		this._cubeSize = 0;
		this._lodPlanes = [];
		this._sizeLods = [];
		this._sigmas = [];

		this._blurMaterial = null;
		this._cubemapMaterial = null;
		this._equirectMaterial = null;

		this._compileMaterial( this._blurMaterial );

	}

	/**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety (the cubeCamera
	 * is placed at the origin).
	 */
	fromScene( scene, sigma = 0, near = 0.1, far = 100 ) {

		_oldTarget = this._renderer.getRenderTarget();
		_oldActiveCubeFace = this._renderer.getActiveCubeFace();
		_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
		_oldXrEnabled = this._renderer.xr.enabled;

		this._renderer.xr.enabled = false;

		this._setSize( 256 );

		const cubeUVRenderTarget = this._allocateTargets();
		cubeUVRenderTarget.depthBuffer = true;

		this._sceneToCubeUV( scene, near, far, cubeUVRenderTarget );

		if ( sigma > 0 ) {

			this._blur( cubeUVRenderTarget, 0, 0, sigma );

		}

		this._applyPMREM( cubeUVRenderTarget );
		this._cleanup( cubeUVRenderTarget );

		return cubeUVRenderTarget;

	}

	/**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * or HDR. The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 * The smallest supported equirectangular image size is 64 x 32.
	 */
	fromEquirectangular( equirectangular, renderTarget = null ) {

		return this._fromTexture( equirectangular, renderTarget );

	}

	/**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * or HDR. The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 * The smallest supported cube size is 16 x 16.
	 */
	fromCubemap( cubemap, renderTarget = null ) {

		return this._fromTexture( cubemap, renderTarget );

	}

	/**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */
	compileCubemapShader() {

		if ( this._cubemapMaterial === null ) {

			this._cubemapMaterial = _getCubemapMaterial();
			this._compileMaterial( this._cubemapMaterial );

		}

	}

	/**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */
	compileEquirectangularShader() {

		if ( this._equirectMaterial === null ) {

			this._equirectMaterial = _getEquirectMaterial();
			this._compileMaterial( this._equirectMaterial );

		}

	}

	/**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */
	dispose() {

		this._dispose();

		if ( this._cubemapMaterial !== null ) this._cubemapMaterial.dispose();
		if ( this._equirectMaterial !== null ) this._equirectMaterial.dispose();

	}

	// private interface

	_setSize( cubeSize ) {

		this._lodMax = Math.floor( Math.log2( cubeSize ) );
		this._cubeSize = Math.pow( 2, this._lodMax );

	}

	_dispose() {

		if ( this._blurMaterial !== null ) this._blurMaterial.dispose();

		if ( this._pingPongRenderTarget !== null ) this._pingPongRenderTarget.dispose();

		for ( let i = 0; i < this._lodPlanes.length; i ++ ) {

			this._lodPlanes[ i ].dispose();

		}

	}

	_cleanup( outputTarget ) {

		this._renderer.setRenderTarget( _oldTarget, _oldActiveCubeFace, _oldActiveMipmapLevel );
		this._renderer.xr.enabled = _oldXrEnabled;

		outputTarget.scissorTest = false;
		_setViewport( outputTarget, 0, 0, outputTarget.width, outputTarget.height );

	}

	_fromTexture( texture, renderTarget ) {

		if ( texture.mapping === CubeReflectionMapping || texture.mapping === CubeRefractionMapping ) {

			this._setSize( texture.image.length === 0 ? 16 : ( texture.image[ 0 ].width || texture.image[ 0 ].image.width ) );

		} else { // Equirectangular

			this._setSize( texture.image.width / 4 );

		}

		_oldTarget = this._renderer.getRenderTarget();
		_oldActiveCubeFace = this._renderer.getActiveCubeFace();
		_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
		_oldXrEnabled = this._renderer.xr.enabled;

		this._renderer.xr.enabled = false;

		const cubeUVRenderTarget = renderTarget || this._allocateTargets();
		this._textureToCubeUV( texture, cubeUVRenderTarget );
		this._applyPMREM( cubeUVRenderTarget );
		this._cleanup( cubeUVRenderTarget );

		return cubeUVRenderTarget;

	}

	_allocateTargets() {

		const width = 3 * Math.max( this._cubeSize, 16 * 7 );
		const height = 4 * this._cubeSize;

		const params = {
			magFilter: LinearFilter,
			minFilter: LinearFilter,
			generateMipmaps: false,
			type: HalfFloatType,
			format: RGBAFormat,
			colorSpace: LinearSRGBColorSpace,
			depthBuffer: false
		};

		const cubeUVRenderTarget = _createRenderTarget( width, height, params );

		if ( this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== width || this._pingPongRenderTarget.height !== height ) {

			if ( this._pingPongRenderTarget !== null ) {

				this._dispose();

			}

			this._pingPongRenderTarget = _createRenderTarget( width, height, params );

			const { _lodMax } = this;
			( { sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = _createPlanes( _lodMax ) );

			this._blurMaterial = _getBlurShader( _lodMax, width, height );

		}

		return cubeUVRenderTarget;

	}

	_compileMaterial( material ) {

		const tmpMesh = new Mesh( this._lodPlanes[ 0 ], material );
		this._renderer.compile( tmpMesh, _flatCamera );

	}

	_sceneToCubeUV( scene, near, far, cubeUVRenderTarget ) {

		const fov = 90;
		const aspect = 1;
		const cubeCamera = new PerspectiveCamera( fov, aspect, near, far );
		const upSign = [ 1, - 1, 1, 1, 1, 1 ];
		const forwardSign = [ 1, 1, 1, - 1, - 1, - 1 ];
		const renderer = this._renderer;

		const originalAutoClear = renderer.autoClear;
		const toneMapping = renderer.toneMapping;
		renderer.getClearColor( _clearColor );

		renderer.toneMapping = NoToneMapping;
		renderer.autoClear = false;

		const backgroundMaterial = new MeshBasicMaterial( {
			name: 'PMREM.Background',
			side: BackSide,
			depthWrite: false,
			depthTest: false,
		} );

		const backgroundBox = new Mesh( new BoxGeometry(), backgroundMaterial );

		let useSolidColor = false;
		const background = scene.background;

		if ( background ) {

			if ( background.isColor ) {

				backgroundMaterial.color.copy( background );
				scene.background = null;
				useSolidColor = true;

			}

		} else {

			backgroundMaterial.color.copy( _clearColor );
			useSolidColor = true;

		}

		for ( let i = 0; i < 6; i ++ ) {

			const col = i % 3;

			if ( col === 0 ) {

				cubeCamera.up.set( 0, upSign[ i ], 0 );
				cubeCamera.lookAt( forwardSign[ i ], 0, 0 );

			} else if ( col === 1 ) {

				cubeCamera.up.set( 0, 0, upSign[ i ] );
				cubeCamera.lookAt( 0, forwardSign[ i ], 0 );

			} else {

				cubeCamera.up.set( 0, upSign[ i ], 0 );
				cubeCamera.lookAt( 0, 0, forwardSign[ i ] );

			}

			const size = this._cubeSize;

			_setViewport( cubeUVRenderTarget, col * size, i > 2 ? size : 0, size, size );

			renderer.setRenderTarget( cubeUVRenderTarget );

			if ( useSolidColor ) {

				renderer.render( backgroundBox, cubeCamera );

			}

			renderer.render( scene, cubeCamera );

		}

		backgroundBox.geometry.dispose();
		backgroundBox.material.dispose();

		renderer.toneMapping = toneMapping;
		renderer.autoClear = originalAutoClear;
		scene.background = background;

	}

	_textureToCubeUV( texture, cubeUVRenderTarget ) {

		const renderer = this._renderer;

		const isCubeTexture = ( texture.mapping === CubeReflectionMapping || texture.mapping === CubeRefractionMapping );

		if ( isCubeTexture ) {

			if ( this._cubemapMaterial === null ) {

				this._cubemapMaterial = _getCubemapMaterial();

			}

			this._cubemapMaterial.uniforms.flipEnvMap.value = ( texture.isRenderTargetTexture === false ) ? - 1 : 1;

		} else {

			if ( this._equirectMaterial === null ) {

				this._equirectMaterial = _getEquirectMaterial();

			}

		}

		const material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
		const mesh = new Mesh( this._lodPlanes[ 0 ], material );

		const uniforms = material.uniforms;

		uniforms[ 'envMap' ].value = texture;

		const size = this._cubeSize;

		_setViewport( cubeUVRenderTarget, 0, 0, 3 * size, 2 * size );

		renderer.setRenderTarget( cubeUVRenderTarget );
		renderer.render( mesh, _flatCamera );

	}

	_applyPMREM( cubeUVRenderTarget ) {

		const renderer = this._renderer;
		const autoClear = renderer.autoClear;
		renderer.autoClear = false;

		for ( let i = 1; i < this._lodPlanes.length; i ++ ) {

			const sigma = Math.sqrt( this._sigmas[ i ] * this._sigmas[ i ] - this._sigmas[ i - 1 ] * this._sigmas[ i - 1 ] );

			const poleAxis = _axisDirections[ ( i - 1 ) % _axisDirections.length ];

			this._blur( cubeUVRenderTarget, i - 1, i, sigma, poleAxis );

		}

		renderer.autoClear = autoClear;

	}

	/**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 */
	_blur( cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis ) {

		const pingPongRenderTarget = this._pingPongRenderTarget;

		this._halfBlur(
			cubeUVRenderTarget,
			pingPongRenderTarget,
			lodIn,
			lodOut,
			sigma,
			'latitudinal',
			poleAxis );

		this._halfBlur(
			pingPongRenderTarget,
			cubeUVRenderTarget,
			lodOut,
			lodOut,
			sigma,
			'longitudinal',
			poleAxis );

	}

	_halfBlur( targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis ) {

		const renderer = this._renderer;
		const blurMaterial = this._blurMaterial;

		if ( direction !== 'latitudinal' && direction !== 'longitudinal' ) {

			console.error(
				'blur direction must be either latitudinal or longitudinal!' );

		}

		// Number of standard deviations at which to cut off the discrete approximation.
		const STANDARD_DEVIATIONS = 3;

		const blurMesh = new Mesh( this._lodPlanes[ lodOut ], blurMaterial );
		const blurUniforms = blurMaterial.uniforms;

		const pixels = this._sizeLods[ lodIn ] - 1;
		const radiansPerPixel = isFinite( sigmaRadians ) ? Math.PI / ( 2 * pixels ) : 2 * Math.PI / ( 2 * MAX_SAMPLES - 1 );
		const sigmaPixels = sigmaRadians / radiansPerPixel;
		const samples = isFinite( sigmaRadians ) ? 1 + Math.floor( STANDARD_DEVIATIONS * sigmaPixels ) : MAX_SAMPLES;

		if ( samples > MAX_SAMPLES ) {

			console.warn( `sigmaRadians, ${
				sigmaRadians}, is too large and will clip, as it requested ${
				samples} samples when the maximum is set to ${MAX_SAMPLES}` );

		}

		const weights = [];
		let sum = 0;

		for ( let i = 0; i < MAX_SAMPLES; ++ i ) {

			const x = i / sigmaPixels;
			const weight = Math.exp( - x * x / 2 );
			weights.push( weight );

			if ( i === 0 ) {

				sum += weight;

			} else if ( i < samples ) {

				sum += 2 * weight;

			}

		}

		for ( let i = 0; i < weights.length; i ++ ) {

			weights[ i ] = weights[ i ] / sum;

		}

		blurUniforms[ 'envMap' ].value = targetIn.texture;
		blurUniforms[ 'samples' ].value = samples;
		blurUniforms[ 'weights' ].value = weights;
		blurUniforms[ 'latitudinal' ].value = direction === 'latitudinal';

		if ( poleAxis ) {

			blurUniforms[ 'poleAxis' ].value = poleAxis;

		}

		const { _lodMax } = this;
		blurUniforms[ 'dTheta' ].value = radiansPerPixel;
		blurUniforms[ 'mipInt' ].value = _lodMax - lodIn;

		const outputSize = this._sizeLods[ lodOut ];
		const x = 3 * outputSize * ( lodOut > _lodMax - LOD_MIN ? lodOut - _lodMax + LOD_MIN : 0 );
		const y = 4 * ( this._cubeSize - outputSize );

		_setViewport( targetOut, x, y, 3 * outputSize, 2 * outputSize );
		renderer.setRenderTarget( targetOut );
		renderer.render( blurMesh, _flatCamera );

	}

}



function _createPlanes( lodMax ) {

	const lodPlanes = [];
	const sizeLods = [];
	const sigmas = [];

	let lod = lodMax;

	const totalLods = lodMax - LOD_MIN + 1 + EXTRA_LOD_SIGMA.length;

	for ( let i = 0; i < totalLods; i ++ ) {

		const sizeLod = Math.pow( 2, lod );
		sizeLods.push( sizeLod );
		let sigma = 1.0 / sizeLod;

		if ( i > lodMax - LOD_MIN ) {

			sigma = EXTRA_LOD_SIGMA[ i - lodMax + LOD_MIN - 1 ];

		} else if ( i === 0 ) {

			sigma = 0;

		}

		sigmas.push( sigma );

		const texelSize = 1.0 / ( sizeLod - 2 );
		const min = - texelSize;
		const max = 1 + texelSize;
		const uv1 = [ min, min, max, min, max, max, min, min, max, max, min, max ];

		const cubeFaces = 6;
		const vertices = 6;
		const positionSize = 3;
		const uvSize = 2;
		const faceIndexSize = 1;

		const position = new Float32Array( positionSize * vertices * cubeFaces );
		const uv = new Float32Array( uvSize * vertices * cubeFaces );
		const faceIndex = new Float32Array( faceIndexSize * vertices * cubeFaces );

		for ( let face = 0; face < cubeFaces; face ++ ) {

			const x = ( face % 3 ) * 2 / 3 - 1;
			const y = face > 2 ? 0 : - 1;
			const coordinates = [
				x, y, 0,
				x + 2 / 3, y, 0,
				x + 2 / 3, y + 1, 0,
				x, y, 0,
				x + 2 / 3, y + 1, 0,
				x, y + 1, 0
			];
			position.set( coordinates, positionSize * vertices * face );
			uv.set( uv1, uvSize * vertices * face );
			const fill = [ face, face, face, face, face, face ];
			faceIndex.set( fill, faceIndexSize * vertices * face );

		}

		const planes = new BufferGeometry();
		planes.setAttribute( 'position', new BufferAttribute( position, positionSize ) );
		planes.setAttribute( 'uv', new BufferAttribute( uv, uvSize ) );
		planes.setAttribute( 'faceIndex', new BufferAttribute( faceIndex, faceIndexSize ) );
		lodPlanes.push( planes );

		if ( lod > LOD_MIN ) {

			lod --;

		}

	}

	return { lodPlanes, sizeLods, sigmas };

}

function _createRenderTarget( width, height, params ) {

	const cubeUVRenderTarget = new WebGLRenderTarget( width, height, params );
	cubeUVRenderTarget.texture.mapping = CubeUVReflectionMapping;
	cubeUVRenderTarget.texture.name = 'PMREM.cubeUv';
	cubeUVRenderTarget.scissorTest = true;
	return cubeUVRenderTarget;

}

function _setViewport( target, x, y, width, height ) {

	target.viewport.set( x, y, width, height );
	target.scissor.set( x, y, width, height );

}

function _getBlurShader( lodMax, width, height ) {

	const weights = new Float32Array( MAX_SAMPLES );
	const poleAxis = new Vector3( 0, 1, 0 );
	const shaderMaterial = new ShaderMaterial( {

		name: 'SphericalGaussianBlur',

		defines: {
			'n': MAX_SAMPLES,
			'CUBEUV_TEXEL_WIDTH': 1.0 / width,
			'CUBEUV_TEXEL_HEIGHT': 1.0 / height,
			'CUBEUV_MAX_MIP': `${lodMax}.0`,
		},

		uniforms: {
			'envMap': { value: null },
			'samples': { value: 1 },
			'weights': { value: weights },
			'latitudinal': { value: false },
			'dTheta': { value: 0 },
			'mipInt': { value: 0 },
			'poleAxis': { value: poleAxis }
		},

		vertexShader: _getCommonVertexShader(),

		fragmentShader: /* glsl */`

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,

		blending: NoBlending,
		depthTest: false,
		depthWrite: false

	} );

	return shaderMaterial;

}

function _getEquirectMaterial() {

	return new ShaderMaterial( {

		name: 'EquirectangularToCubeUV',

		uniforms: {
			'envMap': { value: null }
		},

		vertexShader: _getCommonVertexShader(),

		fragmentShader: /* glsl */`

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,

		blending: NoBlending,
		depthTest: false,
		depthWrite: false

	} );

}

function _getCubemapMaterial() {

	return new ShaderMaterial( {

		name: 'CubemapToCubeUV',

		uniforms: {
			'envMap': { value: null },
			'flipEnvMap': { value: - 1 }
		},

		vertexShader: _getCommonVertexShader(),

		fragmentShader: /* glsl */`

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,

		blending: NoBlending,
		depthTest: false,
		depthWrite: false

	} );

}

function _getCommonVertexShader() {

	return /* glsl */`

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;

}

function WebGLCubeUVMaps( renderer ) {

	let cubeUVmaps = new WeakMap();

	let pmremGenerator = null;

	function get( texture ) {

		if ( texture && texture.isTexture ) {

			const mapping = texture.mapping;

			const isEquirectMap = ( mapping === EquirectangularReflectionMapping || mapping === EquirectangularRefractionMapping );
			const isCubeMap = ( mapping === CubeReflectionMapping || mapping === CubeRefractionMapping );

			// equirect/cube map to cubeUV conversion

			if ( isEquirectMap || isCubeMap ) {

				let renderTarget = cubeUVmaps.get( texture );

				const currentPMREMVersion = renderTarget !== undefined ? renderTarget.texture.pmremVersion : 0;

				if ( texture.isRenderTargetTexture && texture.pmremVersion !== currentPMREMVersion ) {

					if ( pmremGenerator === null ) pmremGenerator = new PMREMGenerator( renderer );

					renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular( texture, renderTarget ) : pmremGenerator.fromCubemap( texture, renderTarget );
					renderTarget.texture.pmremVersion = texture.pmremVersion;

					cubeUVmaps.set( texture, renderTarget );

					return renderTarget.texture;

				} else {

					if ( renderTarget !== undefined ) {

						return renderTarget.texture;

					} else {

						const image = texture.image;

						if ( ( isEquirectMap && image && image.height > 0 ) || ( isCubeMap && image && isCubeTextureComplete( image ) ) ) {

							if ( pmremGenerator === null ) pmremGenerator = new PMREMGenerator( renderer );

							renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular( texture ) : pmremGenerator.fromCubemap( texture );
							renderTarget.texture.pmremVersion = texture.pmremVersion;

							cubeUVmaps.set( texture, renderTarget );

							texture.addEventListener( 'dispose', onTextureDispose );

							return renderTarget.texture;

						} else {

							// image not yet ready. try the conversion next frame

							return null;

						}

					}

				}

			}

		}

		return texture;

	}

	function isCubeTextureComplete( image ) {

		let count = 0;
		const length = 6;

		for ( let i = 0; i < length; i ++ ) {

			if ( image[ i ] !== undefined ) count ++;

		}

		return count === length;


	}

	function onTextureDispose( event ) {

		const texture = event.target;

		texture.removeEventListener( 'dispose', onTextureDispose );

		const cubemapUV = cubeUVmaps.get( texture );

		if ( cubemapUV !== undefined ) {

			cubeUVmaps.delete( texture );
			cubemapUV.dispose();

		}

	}

	function dispose() {

		cubeUVmaps = new WeakMap();

		if ( pmremGenerator !== null ) {

			pmremGenerator.dispose();
			pmremGenerator = null;

		}

	}

	return {
		get: get,
		dispose: dispose
	};

}

function WebGLExtensions( gl ) {

	const extensions = {};

	function getExtension( name ) {

		if ( extensions[ name ] !== undefined ) {

			return extensions[ name ];

		}

		let extension;

		switch ( name ) {

			case 'WEBGL_depth_texture':
				extension = gl.getExtension( 'WEBGL_depth_texture' ) || gl.getExtension( 'MOZ_WEBGL_depth_texture' ) || gl.getExtension( 'WEBKIT_WEBGL_depth_texture' );
				break;

			case 'EXT_texture_filter_anisotropic':
				extension = gl.getExtension( 'EXT_texture_filter_anisotropic' ) || gl.getExtension( 'MOZ_EXT_texture_filter_anisotropic' ) || gl.getExtension( 'WEBKIT_EXT_texture_filter_anisotropic' );
				break;

			case 'WEBGL_compressed_texture_s3tc':
				extension = gl.getExtension( 'WEBGL_compressed_texture_s3tc' ) || gl.getExtension( 'MOZ_WEBGL_compressed_texture_s3tc' ) || gl.getExtension( 'WEBKIT_WEBGL_compressed_texture_s3tc' );
				break;

			case 'WEBGL_compressed_texture_pvrtc':
				extension = gl.getExtension( 'WEBGL_compressed_texture_pvrtc' ) || gl.getExtension( 'WEBKIT_WEBGL_compressed_texture_pvrtc' );
				break;

			default:
				extension = gl.getExtension( name );

		}

		extensions[ name ] = extension;

		return extension;

	}

	return {

		has: function ( name ) {

			return getExtension( name ) !== null;

		},

		init: function () {

			getExtension( 'EXT_color_buffer_float' );
			getExtension( 'WEBGL_clip_cull_distance' );
			getExtension( 'OES_texture_float_linear' );
			getExtension( 'EXT_color_buffer_half_float' );
			getExtension( 'WEBGL_multisampled_render_to_texture' );
			getExtension( 'WEBGL_render_shared_exponent' );

		},

		get: function ( name ) {

			const extension = getExtension( name );

			if ( extension === null ) {

				console.warn( 'THREE.WebGLRenderer: ' + name + ' extension not supported.' );

			}

			return extension;

		}

	};

}

function WebGLGeometries( gl, attributes, info, bindingStates ) {

	const geometries = {};
	const wireframeAttributes = new WeakMap();

	function onGeometryDispose( event ) {

		const geometry = event.target;

		if ( geometry.index !== null ) {

			attributes.remove( geometry.index );

		}

		for ( const name in geometry.attributes ) {

			attributes.remove( geometry.attributes[ name ] );

		}

		for ( const name in geometry.morphAttributes ) {

			const array = geometry.morphAttributes[ name ];

			for ( let i = 0, l = array.length; i < l; i ++ ) {

				attributes.remove( array[ i ] );

			}

		}

		geometry.removeEventListener( 'dispose', onGeometryDispose );

		delete geometries[ geometry.id ];

		const attribute = wireframeAttributes.get( geometry );

		if ( attribute ) {

			attributes.remove( attribute );
			wireframeAttributes.delete( geometry );

		}

		bindingStates.releaseStatesOfGeometry( geometry );

		if ( geometry.isInstancedBufferGeometry === true ) {

			delete geometry._maxInstanceCount;

		}

		//

		info.memory.geometries --;

	}

	function get( object, geometry ) {

		if ( geometries[ geometry.id ] === true ) return geometry;

		geometry.addEventListener( 'dispose', onGeometryDispose );

		geometries[ geometry.id ] = true;

		info.memory.geometries ++;

		return geometry;

	}

	function update( geometry ) {

		const geometryAttributes = geometry.attributes;

		// Updating index buffer in VAO now. See WebGLBindingStates.

		for ( const name in geometryAttributes ) {

			attributes.update( geometryAttributes[ name ], gl.ARRAY_BUFFER );

		}

		// morph targets

		const morphAttributes = geometry.morphAttributes;

		for ( const name in morphAttributes ) {

			const array = morphAttributes[ name ];

			for ( let i = 0, l = array.length; i < l; i ++ ) {

				attributes.update( array[ i ], gl.ARRAY_BUFFER );

			}

		}

	}

	function updateWireframeAttribute( geometry ) {

		const indices = [];

		const geometryIndex = geometry.index;
		const geometryPosition = geometry.attributes.position;
		let version = 0;

		if ( geometryIndex !== null ) {

			const array = geometryIndex.array;
			version = geometryIndex.version;

			for ( let i = 0, l = array.length; i < l; i += 3 ) {

				const a = array[ i + 0 ];
				const b = array[ i + 1 ];
				const c = array[ i + 2 ];

				indices.push( a, b, b, c, c, a );

			}

		} else if ( geometryPosition !== undefined ) {

			const array = geometryPosition.array;
			version = geometryPosition.version;

			for ( let i = 0, l = ( array.length / 3 ) - 1; i < l; i += 3 ) {

				const a = i + 0;
				const b = i + 1;
				const c = i + 2;

				indices.push( a, b, b, c, c, a );

			}

		} else {

			return;

		}

		const attribute = new ( arrayNeedsUint32( indices ) ? Uint32BufferAttribute : Uint16BufferAttribute )( indices, 1 );
		attribute.version = version;

		// Updating index buffer in VAO now. See WebGLBindingStates

		//

		const previousAttribute = wireframeAttributes.get( geometry );

		if ( previousAttribute ) attributes.remove( previousAttribute );

		//

		wireframeAttributes.set( geometry, attribute );

	}

	function getWireframeAttribute( geometry ) {

		const currentAttribute = wireframeAttributes.get( geometry );

		if ( currentAttribute ) {

			const geometryIndex = geometry.index;

			if ( geometryIndex !== null ) {

				// if the attribute is obsolete, create a new one

				if ( currentAttribute.version < geometryIndex.version ) {

					updateWireframeAttribute( geometry );

				}

			}

		} else {

			updateWireframeAttribute( geometry );

		}

		return wireframeAttributes.get( geometry );

	}

	return {

		get: get,
		update: update,

		getWireframeAttribute: getWireframeAttribute

	};

}

function WebGLIndexedBufferRenderer( gl, extensions, info ) {

	let mode;

	function setMode( value ) {

		mode = value;

	}

	let type, bytesPerElement;

	function setIndex( value ) {

		type = value.type;
		bytesPerElement = value.bytesPerElement;

	}

	function render( start, count ) {

		gl.drawElements( mode, count, type, start * bytesPerElement );

		info.update( count, mode, 1 );

	}

	function renderInstances( start, count, primcount ) {

		if ( primcount === 0 ) return;

		gl.drawElementsInstanced( mode, count, type, start * bytesPerElement, primcount );

		info.update( count, mode, primcount );

	}

	function renderMultiDraw( starts, counts, drawCount ) {

		if ( drawCount === 0 ) return;

		const extension = extensions.get( 'WEBGL_multi_draw' );

		if ( extension === null ) {

			for ( let i = 0; i < drawCount; i ++ ) {

				this.render( starts[ i ] / bytesPerElement, counts[ i ] );

			}

		} else {

			extension.multiDrawElementsWEBGL( mode, counts, 0, type, starts, 0, drawCount );

			let elementCount = 0;
			for ( let i = 0; i < drawCount; i ++ ) {

				elementCount += counts[ i ];

			}

			info.update( elementCount, mode, 1 );

		}

	}

	//

	this.setMode = setMode;
	this.setIndex = setIndex;
	this.render = render;
	this.renderInstances = renderInstances;
	this.renderMultiDraw = renderMultiDraw;

}

function WebGLInfo( gl ) {

	const memory = {
		geometries: 0,
		textures: 0
	};

	const render = {
		frame: 0,
		calls: 0,
		triangles: 0,
		points: 0,
		lines: 0
	};

	function update( count, mode, instanceCount ) {

		render.calls ++;

		switch ( mode ) {

			case gl.TRIANGLES:
				render.triangles += instanceCount * ( count / 3 );
				break;

			case gl.LINES:
				render.lines += instanceCount * ( count / 2 );
				break;

			case gl.LINE_STRIP:
				render.lines += instanceCount * ( count - 1 );
				break;

			case gl.LINE_LOOP:
				render.lines += instanceCount * count;
				break;

			case gl.POINTS:
				render.points += instanceCount * count;
				break;

			default:
				console.error( 'THREE.WebGLInfo: Unknown draw mode:', mode );
				break;

		}

	}

	function reset() {

		render.calls = 0;
		render.triangles = 0;
		render.points = 0;
		render.lines = 0;

	}

	return {
		memory: memory,
		render: render,
		programs: null,
		autoReset: true,
		reset: reset,
		update: update
	};

}

function WebGLMorphtargets( gl, capabilities, textures ) {

	const morphTextures = new WeakMap();
	const morph = new Vector4();

	function update( object, geometry, program ) {

		const objectInfluences = object.morphTargetInfluences;

		// instead of using attributes, the WebGL 2 code path encodes morph targets
		// into an array of data textures. Each layer represents a single morph target.

		const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
		const morphTargetsCount = ( morphAttribute !== undefined ) ? morphAttribute.length : 0;

		let entry = morphTextures.get( geometry );

		if ( entry === undefined || entry.count !== morphTargetsCount ) {

			if ( entry !== undefined ) entry.texture.dispose();

			const hasMorphPosition = geometry.morphAttributes.position !== undefined;
			const hasMorphNormals = geometry.morphAttributes.normal !== undefined;
			const hasMorphColors = geometry.morphAttributes.color !== undefined;

			const morphTargets = geometry.morphAttributes.position || [];
			const morphNormals = geometry.morphAttributes.normal || [];
			const morphColors = geometry.morphAttributes.color || [];

			let vertexDataCount = 0;

			if ( hasMorphPosition === true ) vertexDataCount = 1;
			if ( hasMorphNormals === true ) vertexDataCount = 2;
			if ( hasMorphColors === true ) vertexDataCount = 3;

			let width = geometry.attributes.position.count * vertexDataCount;
			let height = 1;

			if ( width > capabilities.maxTextureSize ) {

				height = Math.ceil( width / capabilities.maxTextureSize );
				width = capabilities.maxTextureSize;

			}

			const buffer = new Float32Array( width * height * 4 * morphTargetsCount );

			const texture = new DataArrayTexture( buffer, width, height, morphTargetsCount );
			texture.type = FloatType;
			texture.needsUpdate = true;

			// fill buffer

			const vertexDataStride = vertexDataCount * 4;

			for ( let i = 0; i < morphTargetsCount; i ++ ) {

				const morphTarget = morphTargets[ i ];
				const morphNormal = morphNormals[ i ];
				const morphColor = morphColors[ i ];

				const offset = width * height * 4 * i;

				for ( let j = 0; j < morphTarget.count; j ++ ) {

					const stride = j * vertexDataStride;

					if ( hasMorphPosition === true ) {

						morph.fromBufferAttribute( morphTarget, j );

						buffer[ offset + stride + 0 ] = morph.x;
						buffer[ offset + stride + 1 ] = morph.y;
						buffer[ offset + stride + 2 ] = morph.z;
						buffer[ offset + stride + 3 ] = 0;

					}

					if ( hasMorphNormals === true ) {

						morph.fromBufferAttribute( morphNormal, j );

						buffer[ offset + stride + 4 ] = morph.x;
						buffer[ offset + stride + 5 ] = morph.y;
						buffer[ offset + stride + 6 ] = morph.z;
						buffer[ offset + stride + 7 ] = 0;

					}

					if ( hasMorphColors === true ) {

						morph.fromBufferAttribute( morphColor, j );

						buffer[ offset + stride + 8 ] = morph.x;
						buffer[ offset + stride + 9 ] = morph.y;
						buffer[ offset + stride + 10 ] = morph.z;
						buffer[ offset + stride + 11 ] = ( morphColor.itemSize === 4 ) ? morph.w : 1;

					}

				}

			}

			entry = {
				count: morphTargetsCount,
				texture: texture,
				size: new Vector2( width, height )
			};

			morphTextures.set( geometry, entry );

			function disposeTexture() {

				texture.dispose();

				morphTextures.delete( geometry );

				geometry.removeEventListener( 'dispose', disposeTexture );

			}

			geometry.addEventListener( 'dispose', disposeTexture );

		}

		//
		if ( object.isInstancedMesh === true && object.morphTexture !== null ) {

			program.getUniforms().setValue( gl, 'morphTexture', object.morphTexture, textures );

		} else {

			let morphInfluencesSum = 0;

			for ( let i = 0; i < objectInfluences.length; i ++ ) {

				morphInfluencesSum += objectInfluences[ i ];

			}

			const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;


			program.getUniforms().setValue( gl, 'morphTargetBaseInfluence', morphBaseInfluence );
			program.getUniforms().setValue( gl, 'morphTargetInfluences', objectInfluences );

		}

		program.getUniforms().setValue( gl, 'morphTargetsTexture', entry.texture, textures );
		program.getUniforms().setValue( gl, 'morphTargetsTextureSize', entry.size );

	}

	return {

		update: update

	};

}

function WebGLObjects( gl, geometries, attributes, info ) {

	let updateMap = new WeakMap();

	function update( object ) {

		const frame = info.render.frame;

		const geometry = object.geometry;
		const buffergeometry = geometries.get( object, geometry );

		// Update once per frame

		if ( updateMap.get( buffergeometry ) !== frame ) {

			geometries.update( buffergeometry );

			updateMap.set( buffergeometry, frame );

		}

		if ( object.isInstancedMesh ) {

			if ( object.hasEventListener( 'dispose', onInstancedMeshDispose ) === false ) {

				object.addEventListener( 'dispose', onInstancedMeshDispose );

			}

			if ( updateMap.get( object ) !== frame ) {

				attributes.update( object.instanceMatrix, gl.ARRAY_BUFFER );

				if ( object.instanceColor !== null ) {

					attributes.update( object.instanceColor, gl.ARRAY_BUFFER );

				}

				updateMap.set( object, frame );

			}

		}

		if ( object.isSkinnedMesh ) {

			const skeleton = object.skeleton;

			if ( updateMap.get( skeleton ) !== frame ) {

				skeleton.update();

				updateMap.set( skeleton, frame );

			}

		}

		return buffergeometry;

	}

	function dispose() {

		updateMap = new WeakMap();

	}

	function onInstancedMeshDispose( event ) {

		const instancedMesh = event.target;

		instancedMesh.removeEventListener( 'dispose', onInstancedMeshDispose );

		attributes.remove( instancedMesh.instanceMatrix );

		if ( instancedMesh.instanceColor !== null ) attributes.remove( instancedMesh.instanceColor );

	}

	return {

		update: update,
		dispose: dispose

	};

}

class DepthTexture extends Texture {

	constructor( width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format ) {

		format = format !== undefined ? format : DepthFormat;

		if ( format !== DepthFormat && format !== DepthStencilFormat ) {

			throw new Error( 'DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat' );

		}

		if ( type === undefined && format === DepthFormat ) type = UnsignedIntType;
		if ( type === undefined && format === DepthStencilFormat ) type = UnsignedInt248Type;

		super( null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy );

		this.isDepthTexture = true;

		this.image = { width: width, height: height };

		this.magFilter = magFilter !== undefined ? magFilter : NearestFilter;
		this.minFilter = minFilter !== undefined ? minFilter : NearestFilter;

		this.flipY = false;
		this.generateMipmaps = false;

		this.compareFunction = null;

	}


	copy( source ) {

		super.copy( source );

		this.compareFunction = source.compareFunction;

		return this;

	}

	toJSON( meta ) {

		const data = super.toJSON( meta );

		if ( this.compareFunction !== null ) data.compareFunction = this.compareFunction;

		return data;

	}

}

/**
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [textures] )
 *
 * 		uploads a uniform value(s)
 *  	the 'textures' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (textures factorizations):
 *
 * .upload( gl, seq, values, textures )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (textures factorizations):
 *
 * .setValue( gl, name, value, textures )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */


const emptyTexture = /*@__PURE__*/ new Texture();

const emptyShadowTexture = /*@__PURE__*/ new DepthTexture( 1, 1 );
emptyShadowTexture.compareFunction = LessEqualCompare;

const emptyArrayTexture = /*@__PURE__*/ new DataArrayTexture();
const empty3dTexture = /*@__PURE__*/ new Data3DTexture();
const emptyCubeTexture = /*@__PURE__*/ new CubeTexture();

// --- Utilities ---

// Array Caches (provide typed arrays for temporary by size)

const arrayCacheF32 = [];
const arrayCacheI32 = [];

// Float32Array caches used for uploading Matrix uniforms

const mat4array = new Float32Array( 16 );
const mat3array = new Float32Array( 9 );
const mat2array = new Float32Array( 4 );

// Flattening for arrays of vectors and matrices

function flatten( array, nBlocks, blockSize ) {

	const firstElem = array[ 0 ];

	if ( firstElem <= 0 || firstElem > 0 ) return array;
	// unoptimized: ! isNaN( firstElem )
	// see http://jacksondunstan.com/articles/983

	const n = nBlocks * blockSize;
	let r = arrayCacheF32[ n ];

	if ( r === undefined ) {

		r = new Float32Array( n );
		arrayCacheF32[ n ] = r;

	}

	if ( nBlocks !== 0 ) {

		firstElem.toArray( r, 0 );

		for ( let i = 1, offset = 0; i !== nBlocks; ++ i ) {

			offset += blockSize;
			array[ i ].toArray( r, offset );

		}

	}

	return r;

}

function arraysEqual( a, b ) {

	if ( a.length !== b.length ) return false;

	for ( let i = 0, l = a.length; i < l; i ++ ) {

		if ( a[ i ] !== b[ i ] ) return false;

	}

	return true;

}

function copyArray( a, b ) {

	for ( let i = 0, l = b.length; i < l; i ++ ) {

		a[ i ] = b[ i ];

	}

}

// Texture unit allocation

function allocTexUnits( textures, n ) {

	let r = arrayCacheI32[ n ];

	if ( r === undefined ) {

		r = new Int32Array( n );
		arrayCacheI32[ n ] = r;

	}

	for ( let i = 0; i !== n; ++ i ) {

		r[ i ] = textures.allocateTextureUnit();

	}

	return r;

}

// --- Setters ---

// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.

// Single scalar

function setValueV1f( gl, v ) {

	const cache = this.cache;

	if ( cache[ 0 ] === v ) return;

	gl.uniform1f( this.addr, v );

	cache[ 0 ] = v;

}

// Single float vector (from flat array or THREE.VectorN)

function setValueV2f( gl, v ) {

	const cache = this.cache;

	if ( v.x !== undefined ) {

		if ( cache[ 0 ] !== v.x || cache[ 1 ] !== v.y ) {

			gl.uniform2f( this.addr, v.x, v.y );

			cache[ 0 ] = v.x;
			cache[ 1 ] = v.y;

		}

	} else {

		if ( arraysEqual( cache, v ) ) return;

		gl.uniform2fv( this.addr, v );

		copyArray( cache, v );

	}

}

function setValueV3f( gl, v ) {

	const cache = this.cache;

	if ( v.x !== undefined ) {

		if ( cache[ 0 ] !== v.x || cache[ 1 ] !== v.y || cache[ 2 ] !== v.z ) {

			gl.uniform3f( this.addr, v.x, v.y, v.z );

			cache[ 0 ] = v.x;
			cache[ 1 ] = v.y;
			cache[ 2 ] = v.z;

		}

	} else if ( v.r !== undefined ) {

		if ( cache[ 0 ] !== v.r || cache[ 1 ] !== v.g || cache[ 2 ] !== v.b ) {

			gl.uniform3f( this.addr, v.r, v.g, v.b );

			cache[ 0 ] = v.r;
			cache[ 1 ] = v.g;
			cache[ 2 ] = v.b;

		}

	} else {

		if ( arraysEqual( cache, v ) ) return;

		gl.uniform3fv( this.addr, v );

		copyArray( cache, v );

	}

}

function setValueV4f( gl, v ) {

	const cache = this.cache;

	if ( v.x !== undefined ) {

		if ( cache[ 0 ] !== v.x || cache[ 1 ] !== v.y || cache[ 2 ] !== v.z || cache[ 3 ] !== v.w ) {

			gl.uniform4f( this.addr, v.x, v.y, v.z, v.w );

			cache[ 0 ] = v.x;
			cache[ 1 ] = v.y;
			cache[ 2 ] = v.z;
			cache[ 3 ] = v.w;

		}

	} else {

		if ( arraysEqual( cache, v ) ) return;

		gl.uniform4fv( this.addr, v );

		copyArray( cache, v );

	}

}

// Single matrix (from flat array or THREE.MatrixN)

function setValueM2( gl, v ) {

	const cache = this.cache;
	const elements = v.elements;

	if ( elements === undefined ) {

		if ( arraysEqual( cache, v ) ) return;

		gl.uniformMatrix2fv( this.addr, false, v );

		copyArray( cache, v );

	} else {

		if ( arraysEqual( cache, elements ) ) return;

		mat2array.set( elements );

		gl.uniformMatrix2fv( this.addr, false, mat2array );

		copyArray( cache, elements );

	}

}

function setValueM3( gl, v ) {

	const cache = this.cache;
	const elements = v.elements;

	if ( elements === undefined ) {

		if ( arraysEqual( cache, v ) ) return;

		gl.uniformMatrix3fv( this.addr, false, v );

		copyArray( cache, v );

	} else {

		if ( arraysEqual( cache, elements ) ) return;

		mat3array.set( elements );

		gl.uniformMatrix3fv( this.addr, false, mat3array );

		copyArray( cache, elements );

	}

}

function setValueM4( gl, v ) {

	const cache = this.cache;
	const elements = v.elements;

	if ( elements === undefined ) {

		if ( arraysEqual( cache, v ) ) return;

		gl.uniformMatrix4fv( this.addr, false, v );

		copyArray( cache, v );

	} else {

		if ( arraysEqual( cache, elements ) ) return;

		mat4array.set( elements );

		gl.uniformMatrix4fv( this.addr, false, mat4array );

		copyArray( cache, elements );

	}

}

// Single integer / boolean

function setValueV1i( gl, v ) {

	const cache = this.cache;

	if ( cache[ 0 ] === v ) return;

	gl.uniform1i( this.addr, v );

	cache[ 0 ] = v;

}

// Single integer / boolean vector (from flat array or THREE.VectorN)

function setValueV2i( gl, v ) {

	const cache = this.cache;

	if ( v.x !== undefined ) {

		if ( cache[ 0 ] !== v.x || cache[ 1 ] !== v.y ) {

			gl.uniform2i( this.addr, v.x, v.y );

			cache[ 0 ] = v.x;
			cache[ 1 ] = v.y;

		}

	} else {

		if ( arraysEqual( cache, v ) ) return;

		gl.uniform2iv( this.addr, v );

		copyArray( cache, v );

	}

}

function setValueV3i( gl, v ) {

	const cache = this.cache;

	if ( v.x !== undefined ) {

		if ( cache[ 0 ] !== v.x || cache[ 1 ] !== v.y || cache[ 2 ] !== v.z ) {

			gl.uniform3i( this.addr, v.x, v.y, v.z );

			cache[ 0 ] = v.x;
			cache[ 1 ] = v.y;
			cache[ 2 ] = v.z;

		}

	} else {

		if ( arraysEqual( cache, v ) ) return;

		gl.uniform3iv( this.addr, v );

		copyArray( cache, v );

	}

}

function setValueV4i( gl, v ) {

	const cache = this.cache;

	if ( v.x !== undefined ) {

		if ( cache[ 0 ] !== v.x || cache[ 1 ] !== v.y || cache[ 2 ] !== v.z || cache[ 3 ] !== v.w ) {

			gl.uniform4i( this.addr, v.x, v.y, v.z, v.w );

			cache[ 0 ] = v.x;
			cache[ 1 ] = v.y;
			cache[ 2 ] = v.z;
			cache[ 3 ] = v.w;

		}

	} else {

		if ( arraysEqual( cache, v ) ) return;

		gl.uniform4iv( this.addr, v );

		copyArray( cache, v );

	}

}

// Single unsigned integer

function setValueV1ui( gl, v ) {

	const cache = this.cache;

	if ( cache[ 0 ] === v ) return;

	gl.uniform1ui( this.addr, v );

	cache[ 0 ] = v;

}

// Single unsigned integer vector (from flat array or THREE.VectorN)

function setValueV2ui( gl, v ) {

	const cache = this.cache;

	if ( v.x !== undefined ) {

		if ( cache[ 0 ] !== v.x || cache[ 1 ] !== v.y ) {

			gl.uniform2ui( this.addr, v.x, v.y );

			cache[ 0 ] = v.x;
			cache[ 1 ] = v.y;

		}

	} else {

		if ( arraysEqual( cache, v ) ) return;

		gl.uniform2uiv( this.addr, v );

		copyArray( cache, v );

	}

}

function setValueV3ui( gl, v ) {

	const cache = this.cache;

	if ( v.x !== undefined ) {

		if ( cache[ 0 ] !== v.x || cache[ 1 ] !== v.y || cache[ 2 ] !== v.z ) {

			gl.uniform3ui( this.addr, v.x, v.y, v.z );

			cache[ 0 ] = v.x;
			cache[ 1 ] = v.y;
			cache[ 2 ] = v.z;

		}

	} else {

		if ( arraysEqual( cache, v ) ) return;

		gl.uniform3uiv( this.addr, v );

		copyArray( cache, v );

	}

}

function setValueV4ui( gl, v ) {

	const cache = this.cache;

	if ( v.x !== undefined ) {

		if ( cache[ 0 ] !== v.x || cache[ 1 ] !== v.y || cache[ 2 ] !== v.z || cache[ 3 ] !== v.w ) {

			gl.uniform4ui( this.addr, v.x, v.y, v.z, v.w );

			cache[ 0 ] = v.x;
			cache[ 1 ] = v.y;
			cache[ 2 ] = v.z;
			cache[ 3 ] = v.w;

		}

	} else {

		if ( arraysEqual( cache, v ) ) return;

		gl.uniform4uiv( this.addr, v );

		copyArray( cache, v );

	}

}


// Single texture (2D / Cube)

function setValueT1( gl, v, textures ) {

	const cache = this.cache;
	const unit = textures.allocateTextureUnit();

	if ( cache[ 0 ] !== unit ) {

		gl.uniform1i( this.addr, unit );
		cache[ 0 ] = unit;

	}

	const emptyTexture2D = ( this.type === gl.SAMPLER_2D_SHADOW ) ? emptyShadowTexture : emptyTexture;

	textures.setTexture2D( v || emptyTexture2D, unit );

}

function setValueT3D1( gl, v, textures ) {

	const cache = this.cache;
	const unit = textures.allocateTextureUnit();

	if ( cache[ 0 ] !== unit ) {

		gl.uniform1i( this.addr, unit );
		cache[ 0 ] = unit;

	}

	textures.setTexture3D( v || empty3dTexture, unit );

}

function setValueT6( gl, v, textures ) {

	const cache = this.cache;
	const unit = textures.allocateTextureUnit();

	if ( cache[ 0 ] !== unit ) {

		gl.uniform1i( this.addr, unit );
		cache[ 0 ] = unit;

	}

	textures.setTextureCube( v || emptyCubeTexture, unit );

}

function setValueT2DArray1( gl, v, textures ) {

	const cache = this.cache;
	const unit = textures.allocateTextureUnit();

	if ( cache[ 0 ] !== unit ) {

		gl.uniform1i( this.addr, unit );
		cache[ 0 ] = unit;

	}

	textures.setTexture2DArray( v || emptyArrayTexture, unit );

}

// Helper to pick the right setter for the singular case

function getSingularSetter( type ) {

	switch ( type ) {

		case 0x1406: return setValueV1f; // FLOAT
		case 0x8b50: return setValueV2f; // _VEC2
		case 0x8b51: return setValueV3f; // _VEC3
		case 0x8b52: return setValueV4f; // _VEC4

		case 0x8b5a: return setValueM2; // _MAT2
		case 0x8b5b: return setValueM3; // _MAT3
		case 0x8b5c: return setValueM4; // _MAT4

		case 0x1404: case 0x8b56: return setValueV1i; // INT, BOOL
		case 0x8b53: case 0x8b57: return setValueV2i; // _VEC2
		case 0x8b54: case 0x8b58: return setValueV3i; // _VEC3
		case 0x8b55: case 0x8b59: return setValueV4i; // _VEC4

		case 0x1405: return setValueV1ui; // UINT
		case 0x8dc6: return setValueV2ui; // _VEC2
		case 0x8dc7: return setValueV3ui; // _VEC3
		case 0x8dc8: return setValueV4ui; // _VEC4

		case 0x8b5e: // SAMPLER_2D
		case 0x8d66: // SAMPLER_EXTERNAL_OES
		case 0x8dca: // INT_SAMPLER_2D
		case 0x8dd2: // UNSIGNED_INT_SAMPLER_2D
		case 0x8b62: // SAMPLER_2D_SHADOW
			return setValueT1;

		case 0x8b5f: // SAMPLER_3D
		case 0x8dcb: // INT_SAMPLER_3D
		case 0x8dd3: // UNSIGNED_INT_SAMPLER_3D
			return setValueT3D1;

		case 0x8b60: // SAMPLER_CUBE
		case 0x8dcc: // INT_SAMPLER_CUBE
		case 0x8dd4: // UNSIGNED_INT_SAMPLER_CUBE
		case 0x8dc5: // SAMPLER_CUBE_SHADOW
			return setValueT6;

		case 0x8dc1: // SAMPLER_2D_ARRAY
		case 0x8dcf: // INT_SAMPLER_2D_ARRAY
		case 0x8dd7: // UNSIGNED_INT_SAMPLER_2D_ARRAY
		case 0x8dc4: // SAMPLER_2D_ARRAY_SHADOW
			return setValueT2DArray1;

	}

}


// Array of scalars

function setValueV1fArray( gl, v ) {

	gl.uniform1fv( this.addr, v );

}

// Array of vectors (from flat array or array of THREE.VectorN)

function setValueV2fArray( gl, v ) {

	const data = flatten( v, this.size, 2 );

	gl.uniform2fv( this.addr, data );

}

function setValueV3fArray( gl, v ) {

	const data = flatten( v, this.size, 3 );

	gl.uniform3fv( this.addr, data );

}

function setValueV4fArray( gl, v ) {

	const data = flatten( v, this.size, 4 );

	gl.uniform4fv( this.addr, data );

}

// Array of matrices (from flat array or array of THREE.MatrixN)

function setValueM2Array( gl, v ) {

	const data = flatten( v, this.size, 4 );

	gl.uniformMatrix2fv( this.addr, false, data );

}

function setValueM3Array( gl, v ) {

	const data = flatten( v, this.size, 9 );

	gl.uniformMatrix3fv( this.addr, false, data );

}

function setValueM4Array( gl, v ) {

	const data = flatten( v, this.size, 16 );

	gl.uniformMatrix4fv( this.addr, false, data );

}

// Array of integer / boolean

function setValueV1iArray( gl, v ) {

	gl.uniform1iv( this.addr, v );

}

// Array of integer / boolean vectors (from flat array)

function setValueV2iArray( gl, v ) {

	gl.uniform2iv( this.addr, v );

}

function setValueV3iArray( gl, v ) {

	gl.uniform3iv( this.addr, v );

}

function setValueV4iArray( gl, v ) {

	gl.uniform4iv( this.addr, v );

}

// Array of unsigned integer

function setValueV1uiArray( gl, v ) {

	gl.uniform1uiv( this.addr, v );

}

// Array of unsigned integer vectors (from flat array)

function setValueV2uiArray( gl, v ) {

	gl.uniform2uiv( this.addr, v );

}

function setValueV3uiArray( gl, v ) {

	gl.uniform3uiv( this.addr, v );

}

function setValueV4uiArray( gl, v ) {

	gl.uniform4uiv( this.addr, v );

}


// Array of textures (2D / 3D / Cube / 2DArray)

function setValueT1Array( gl, v, textures ) {

	const cache = this.cache;

	const n = v.length;

	const units = allocTexUnits( textures, n );

	if ( ! arraysEqual( cache, units ) ) {

		gl.uniform1iv( this.addr, units );

		copyArray( cache, units );

	}

	for ( let i = 0; i !== n; ++ i ) {

		textures.setTexture2D( v[ i ] || emptyTexture, units[ i ] );

	}

}

function setValueT3DArray( gl, v, textures ) {

	const cache = this.cache;

	const n = v.length;

	const units = allocTexUnits( textures, n );

	if ( ! arraysEqual( cache, units ) ) {

		gl.uniform1iv( this.addr, units );

		copyArray( cache, units );

	}

	for ( let i = 0; i !== n; ++ i ) {

		textures.setTexture3D( v[ i ] || empty3dTexture, units[ i ] );

	}

}

function setValueT6Array( gl, v, textures ) {

	const cache = this.cache;

	const n = v.length;

	const units = allocTexUnits( textures, n );

	if ( ! arraysEqual( cache, units ) ) {

		gl.uniform1iv( this.addr, units );

		copyArray( cache, units );

	}

	for ( let i = 0; i !== n; ++ i ) {

		textures.setTextureCube( v[ i ] || emptyCubeTexture, units[ i ] );

	}

}

function setValueT2DArrayArray( gl, v, textures ) {

	const cache = this.cache;

	const n = v.length;

	const units = allocTexUnits( textures, n );

	if ( ! arraysEqual( cache, units ) ) {

		gl.uniform1iv( this.addr, units );

		copyArray( cache, units );

	}

	for ( let i = 0; i !== n; ++ i ) {

		textures.setTexture2DArray( v[ i ] || emptyArrayTexture, units[ i ] );

	}

}


// Helper to pick the right setter for a pure (bottom-level) array

function getPureArraySetter( type ) {

	switch ( type ) {

		case 0x1406: return setValueV1fArray; // FLOAT
		case 0x8b50: return setValueV2fArray; // _VEC2
		case 0x8b51: return setValueV3fArray; // _VEC3
		case 0x8b52: return setValueV4fArray; // _VEC4

		case 0x8b5a: return setValueM2Array; // _MAT2
		case 0x8b5b: return setValueM3Array; // _MAT3
		case 0x8b5c: return setValueM4Array; // _MAT4

		case 0x1404: case 0x8b56: return setValueV1iArray; // INT, BOOL
		case 0x8b53: case 0x8b57: return setValueV2iArray; // _VEC2
		case 0x8b54: case 0x8b58: return setValueV3iArray; // _VEC3
		case 0x8b55: case 0x8b59: return setValueV4iArray; // _VEC4

		case 0x1405: return setValueV1uiArray; // UINT
		case 0x8dc6: return setValueV2uiArray; // _VEC2
		case 0x8dc7: return setValueV3uiArray; // _VEC3
		case 0x8dc8: return setValueV4uiArray; // _VEC4

		case 0x8b5e: // SAMPLER_2D
		case 0x8d66: // SAMPLER_EXTERNAL_OES
		case 0x8dca: // INT_SAMPLER_2D
		case 0x8dd2: // UNSIGNED_INT_SAMPLER_2D
		case 0x8b62: // SAMPLER_2D_SHADOW
			return setValueT1Array;

		case 0x8b5f: // SAMPLER_3D
		case 0x8dcb: // INT_SAMPLER_3D
		case 0x8dd3: // UNSIGNED_INT_SAMPLER_3D
			return setValueT3DArray;

		case 0x8b60: // SAMPLER_CUBE
		case 0x8dcc: // INT_SAMPLER_CUBE
		case 0x8dd4: // UNSIGNED_INT_SAMPLER_CUBE
		case 0x8dc5: // SAMPLER_CUBE_SHADOW
			return setValueT6Array;

		case 0x8dc1: // SAMPLER_2D_ARRAY
		case 0x8dcf: // INT_SAMPLER_2D_ARRAY
		case 0x8dd7: // UNSIGNED_INT_SAMPLER_2D_ARRAY
		case 0x8dc4: // SAMPLER_2D_ARRAY_SHADOW
			return setValueT2DArrayArray;

	}

}

// --- Uniform Classes ---

class SingleUniform {

	constructor( id, activeInfo, addr ) {

		this.id = id;
		this.addr = addr;
		this.cache = [];
		this.type = activeInfo.type;
		this.setValue = getSingularSetter( activeInfo.type );

		// this.path = activeInfo.name; // DEBUG

	}

}

class PureArrayUniform {

	constructor( id, activeInfo, addr ) {

		this.id = id;
		this.addr = addr;
		this.cache = [];
		this.type = activeInfo.type;
		this.size = activeInfo.size;
		this.setValue = getPureArraySetter( activeInfo.type );

		// this.path = activeInfo.name; // DEBUG

	}

}

class StructuredUniform {

	constructor( id ) {

		this.id = id;

		this.seq = [];
		this.map = {};

	}

	setValue( gl, value, textures ) {

		const seq = this.seq;

		for ( let i = 0, n = seq.length; i !== n; ++ i ) {

			const u = seq[ i ];
			u.setValue( gl, value[ u.id ], textures );

		}

	}

}

// --- Top-level ---

// Parser - builds up the property tree from the path strings

const RePathPart = /(\w+)(\])?(\[|\.)?/g;

// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.

function addUniform( container, uniformObject ) {

	container.seq.push( uniformObject );
	container.map[ uniformObject.id ] = uniformObject;

}

function parseUniform( activeInfo, addr, container ) {

	const path = activeInfo.name,
		pathLength = path.length;

	// reset RegExp object, because of the early exit of a previous run
	RePathPart.lastIndex = 0;

	while ( true ) {

		const match = RePathPart.exec( path ),
			matchEnd = RePathPart.lastIndex;

		let id = match[ 1 ];
		const idIsIndex = match[ 2 ] === ']',
			subscript = match[ 3 ];

		if ( idIsIndex ) id = id | 0; // convert to integer

		if ( subscript === undefined || subscript === '[' && matchEnd + 2 === pathLength ) {

			// bare name or "pure" bottom-level array "[0]" suffix

			addUniform( container, subscript === undefined ?
				new SingleUniform( id, activeInfo, addr ) :
				new PureArrayUniform( id, activeInfo, addr ) );

			break;

		} else {

			// step into inner node / create it in case it doesn't exist

			const map = container.map;
			let next = map[ id ];

			if ( next === undefined ) {

				next = new StructuredUniform( id );
				addUniform( container, next );

			}

			container = next;

		}

	}

}

// Root Container

class WebGLUniforms {

	constructor( gl, program ) {

		this.seq = [];
		this.map = {};

		const n = gl.getProgramParameter( program, gl.ACTIVE_UNIFORMS );

		for ( let i = 0; i < n; ++ i ) {

			const info = gl.getActiveUniform( program, i ),
				addr = gl.getUniformLocation( program, info.name );

			parseUniform( info, addr, this );

		}

	}

	setValue( gl, name, value, textures ) {

		const u = this.map[ name ];

		if ( u !== undefined ) u.setValue( gl, value, textures );

	}

	setOptional( gl, object, name ) {

		const v = object[ name ];

		if ( v !== undefined ) this.setValue( gl, name, v );

	}

	static upload( gl, seq, values, textures ) {

		for ( let i = 0, n = seq.length; i !== n; ++ i ) {

			const u = seq[ i ],
				v = values[ u.id ];

			if ( v.needsUpdate !== false ) {

				// note: always updating when .needsUpdate is undefined
				u.setValue( gl, v.value, textures );

			}

		}

	}

	static seqWithValue( seq, values ) {

		const r = [];

		for ( let i = 0, n = seq.length; i !== n; ++ i ) {

			const u = seq[ i ];
			if ( u.id in values ) r.push( u );

		}

		return r;

	}

}

function WebGLShader( gl, type, string ) {

	const shader = gl.createShader( type );

	gl.shaderSource( shader, string );
	gl.compileShader( shader );

	return shader;

}

// From https://www.khronos.org/registry/webgl/extensions/KHR_parallel_shader_compile/
const COMPLETION_STATUS_KHR = 0x91B1;

let programIdCount = 0;

function handleSource( string, errorLine ) {

	const lines = string.split( '\n' );
	const lines2 = [];

	const from = Math.max( errorLine - 6, 0 );
	const to = Math.min( errorLine + 6, lines.length );

	for ( let i = from; i < to; i ++ ) {

		const line = i + 1;
		lines2.push( `${line === errorLine ? '>' : ' '} ${line}: ${lines[ i ]}` );

	}

	return lines2.join( '\n' );

}

function getEncodingComponents( colorSpace ) {

	const workingPrimaries = ColorManagement.getPrimaries( ColorManagement.workingColorSpace );
	const encodingPrimaries = ColorManagement.getPrimaries( colorSpace );

	let gamutMapping;

	if ( workingPrimaries === encodingPrimaries ) {

		gamutMapping = '';

	} else if ( workingPrimaries === P3Primaries && encodingPrimaries === Rec709Primaries ) {

		gamutMapping = 'LinearDisplayP3ToLinearSRGB';

	} else if ( workingPrimaries === Rec709Primaries && encodingPrimaries === P3Primaries ) {

		gamutMapping = 'LinearSRGBToLinearDisplayP3';

	}

	switch ( colorSpace ) {

		case LinearSRGBColorSpace:
		case LinearDisplayP3ColorSpace:
			return [ gamutMapping, 'LinearTransferOETF' ];

		case SRGBColorSpace:
		case DisplayP3ColorSpace:
			return [ gamutMapping, 'sRGBTransferOETF' ];

		default:
			console.warn( 'THREE.WebGLProgram: Unsupported color space:', colorSpace );
			return [ gamutMapping, 'LinearTransferOETF' ];

	}

}

function getShaderErrors( gl, shader, type ) {

	const status = gl.getShaderParameter( shader, gl.COMPILE_STATUS );
	const errors = gl.getShaderInfoLog( shader ).trim();

	if ( status && errors === '' ) return '';

	const errorMatches = /ERROR: 0:(\d+)/.exec( errors );
	if ( errorMatches ) {

		// --enable-privileged-webgl-extension
		// console.log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );

		const errorLine = parseInt( errorMatches[ 1 ] );
		return type.toUpperCase() + '\n\n' + errors + '\n\n' + handleSource( gl.getShaderSource( shader ), errorLine );

	} else {

		return errors;

	}

}

function getTexelEncodingFunction( functionName, colorSpace ) {

	const components = getEncodingComponents( colorSpace );
	return `vec4 ${functionName}( vec4 value ) { return ${components[ 0 ]}( ${components[ 1 ]}( value ) ); }`;

}

function getToneMappingFunction( functionName, toneMapping ) {

	let toneMappingName;

	switch ( toneMapping ) {

		case LinearToneMapping:
			toneMappingName = 'Linear';
			break;

		case ReinhardToneMapping:
			toneMappingName = 'Reinhard';
			break;

		case CineonToneMapping:
			toneMappingName = 'OptimizedCineon';
			break;

		case ACESFilmicToneMapping:
			toneMappingName = 'ACESFilmic';
			break;

		case AgXToneMapping:
			toneMappingName = 'AgX';
			break;

		case NeutralToneMapping:
			toneMappingName = 'Neutral';
			break;

		case CustomToneMapping:
			toneMappingName = 'Custom';
			break;

		default:
			console.warn( 'THREE.WebGLProgram: Unsupported toneMapping:', toneMapping );
			toneMappingName = 'Linear';

	}

	return 'vec3 ' + functionName + '( vec3 color ) { return ' + toneMappingName + 'ToneMapping( color ); }';

}

function generateVertexExtensions( parameters ) {

	const chunks = [
		parameters.extensionClipCullDistance ? '#extension GL_ANGLE_clip_cull_distance : require' : '',
		parameters.extensionMultiDraw ? '#extension GL_ANGLE_multi_draw : require' : '',
	];

	return chunks.filter( filterEmptyLine ).join( '\n' );

}

function generateDefines( defines ) {

	const chunks = [];

	for ( const name in defines ) {

		const value = defines[ name ];

		if ( value === false ) continue;

		chunks.push( '#define ' + name + ' ' + value );

	}

	return chunks.join( '\n' );

}

function fetchAttributeLocations( gl, program ) {

	const attributes = {};

	const n = gl.getProgramParameter( program, gl.ACTIVE_ATTRIBUTES );

	for ( let i = 0; i < n; i ++ ) {

		const info = gl.getActiveAttrib( program, i );
		const name = info.name;

		let locationSize = 1;
		if ( info.type === gl.FLOAT_MAT2 ) locationSize = 2;
		if ( info.type === gl.FLOAT_MAT3 ) locationSize = 3;
		if ( info.type === gl.FLOAT_MAT4 ) locationSize = 4;

		// console.log( 'THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );

		attributes[ name ] = {
			type: info.type,
			location: gl.getAttribLocation( program, name ),
			locationSize: locationSize
		};

	}

	return attributes;

}

function filterEmptyLine( string ) {

	return string !== '';

}

function replaceLightNums( string, parameters ) {

	const numSpotLightCoords = parameters.numSpotLightShadows + parameters.numSpotLightMaps - parameters.numSpotLightShadowsWithMaps;

	return string
		.replace( /NUM_DIR_LIGHTS/g, parameters.numDirLights )
		.replace( /NUM_SPOT_LIGHTS/g, parameters.numSpotLights )
		.replace( /NUM_SPOT_LIGHT_MAPS/g, parameters.numSpotLightMaps )
		.replace( /NUM_SPOT_LIGHT_COORDS/g, numSpotLightCoords )
		.replace( /NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights )
		.replace( /NUM_POINT_LIGHTS/g, parameters.numPointLights )
		.replace( /NUM_HEMI_LIGHTS/g, parameters.numHemiLights )
		.replace( /NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows )
		.replace( /NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, parameters.numSpotLightShadowsWithMaps )
		.replace( /NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows )
		.replace( /NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows );

}

function replaceClippingPlaneNums( string, parameters ) {

	return string
		.replace( /NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes )
		.replace( /UNION_CLIPPING_PLANES/g, ( parameters.numClippingPlanes - parameters.numClipIntersection ) );

}

// Resolve Includes

const includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;

function resolveIncludes( string ) {

	return string.replace( includePattern, includeReplacer );

}

const shaderChunkMap = new Map( [
	[ 'encodings_fragment', 'colorspace_fragment' ], // @deprecated, r154
	[ 'encodings_pars_fragment', 'colorspace_pars_fragment' ], // @deprecated, r154
	[ 'output_fragment', 'opaque_fragment' ], // @deprecated, r154
] );

function includeReplacer( match, include ) {

	let string = ShaderChunk[ include ];

	if ( string === undefined ) {

		const newInclude = shaderChunkMap.get( include );

		if ( newInclude !== undefined ) {

			string = ShaderChunk[ newInclude ];
			console.warn( 'THREE.WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', include, newInclude );

		} else {

			throw new Error( 'Can not resolve #include <' + include + '>' );

		}

	}

	return resolveIncludes( string );

}

// Unroll Loops

const unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;

function unrollLoops( string ) {

	return string.replace( unrollLoopPattern, loopReplacer );

}

function loopReplacer( match, start, end, snippet ) {

	let string = '';

	for ( let i = parseInt( start ); i < parseInt( end ); i ++ ) {

		string += snippet
			.replace( /\[\s*i\s*\]/g, '[ ' + i + ' ]' )
			.replace( /UNROLLED_LOOP_INDEX/g, i );

	}

	return string;

}

//

function generatePrecision( parameters ) {

	let precisionstring = `precision ${parameters.precision} float;
	precision ${parameters.precision} int;
	precision ${parameters.precision} sampler2D;
	precision ${parameters.precision} samplerCube;
	precision ${parameters.precision} sampler3D;
	precision ${parameters.precision} sampler2DArray;
	precision ${parameters.precision} sampler2DShadow;
	precision ${parameters.precision} samplerCubeShadow;
	precision ${parameters.precision} sampler2DArrayShadow;
	precision ${parameters.precision} isampler2D;
	precision ${parameters.precision} isampler3D;
	precision ${parameters.precision} isamplerCube;
	precision ${parameters.precision} isampler2DArray;
	precision ${parameters.precision} usampler2D;
	precision ${parameters.precision} usampler3D;
	precision ${parameters.precision} usamplerCube;
	precision ${parameters.precision} usampler2DArray;
	`;

	if ( parameters.precision === 'highp' ) {

		precisionstring += '\n#define HIGH_PRECISION';

	} else if ( parameters.precision === 'mediump' ) {

		precisionstring += '\n#define MEDIUM_PRECISION';

	} else if ( parameters.precision === 'lowp' ) {

		precisionstring += '\n#define LOW_PRECISION';

	}

	return precisionstring;

}

function generateShadowMapTypeDefine( parameters ) {

	let shadowMapTypeDefine = 'SHADOWMAP_TYPE_BASIC';

	if ( parameters.shadowMapType === PCFShadowMap ) {

		shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF';

	} else if ( parameters.shadowMapType === PCFSoftShadowMap ) {

		shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF_SOFT';

	} else if ( parameters.shadowMapType === VSMShadowMap ) {

		shadowMapTypeDefine = 'SHADOWMAP_TYPE_VSM';

	}

	return shadowMapTypeDefine;

}

function generateEnvMapTypeDefine( parameters ) {

	let envMapTypeDefine = 'ENVMAP_TYPE_CUBE';

	if ( parameters.envMap ) {

		switch ( parameters.envMapMode ) {

			case CubeReflectionMapping:
			case CubeRefractionMapping:
				envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
				break;

			case CubeUVReflectionMapping:
				envMapTypeDefine = 'ENVMAP_TYPE_CUBE_UV';
				break;

		}

	}

	return envMapTypeDefine;

}

function generateEnvMapModeDefine( parameters ) {

	let envMapModeDefine = 'ENVMAP_MODE_REFLECTION';

	if ( parameters.envMap ) {

		switch ( parameters.envMapMode ) {

			case CubeRefractionMapping:

				envMapModeDefine = 'ENVMAP_MODE_REFRACTION';
				break;

		}

	}

	return envMapModeDefine;

}

function generateEnvMapBlendingDefine( parameters ) {

	let envMapBlendingDefine = 'ENVMAP_BLENDING_NONE';

	if ( parameters.envMap ) {

		switch ( parameters.combine ) {

			case MultiplyOperation:
				envMapBlendingDefine = 'ENVMAP_BLENDING_MULTIPLY';
				break;

			case MixOperation:
				envMapBlendingDefine = 'ENVMAP_BLENDING_MIX';
				break;

			case AddOperation:
				envMapBlendingDefine = 'ENVMAP_BLENDING_ADD';
				break;

		}

	}

	return envMapBlendingDefine;

}

function generateCubeUVSize( parameters ) {

	const imageHeight = parameters.envMapCubeUVHeight;

	if ( imageHeight === null ) return null;

	const maxMip = Math.log2( imageHeight ) - 2;

	const texelHeight = 1.0 / imageHeight;

	const texelWidth = 1.0 / ( 3 * Math.max( Math.pow( 2, maxMip ), 7 * 16 ) );

	return { texelWidth, texelHeight, maxMip };

}

function WebGLProgram( renderer, cacheKey, parameters, bindingStates ) {

	// TODO Send this event to Three.js DevTools
	// console.log( 'WebGLProgram', cacheKey );

	const gl = renderer.getContext();

	const defines = parameters.defines;

	let vertexShader = parameters.vertexShader;
	let fragmentShader = parameters.fragmentShader;

	const shadowMapTypeDefine = generateShadowMapTypeDefine( parameters );
	const envMapTypeDefine = generateEnvMapTypeDefine( parameters );
	const envMapModeDefine = generateEnvMapModeDefine( parameters );
	const envMapBlendingDefine = generateEnvMapBlendingDefine( parameters );
	const envMapCubeUVSize = generateCubeUVSize( parameters );

	const customVertexExtensions = generateVertexExtensions( parameters );

	const customDefines = generateDefines( defines );

	const program = gl.createProgram();

	let prefixVertex, prefixFragment;
	let versionString = parameters.glslVersion ? '#version ' + parameters.glslVersion + '\n' : '';

	if ( parameters.isRawShaderMaterial ) {

		prefixVertex = [

			'#define SHADER_TYPE ' + parameters.shaderType,
			'#define SHADER_NAME ' + parameters.shaderName,

			customDefines

		].filter( filterEmptyLine ).join( '\n' );

		if ( prefixVertex.length > 0 ) {

			prefixVertex += '\n';

		}

		prefixFragment = [

			'#define SHADER_TYPE ' + parameters.shaderType,
			'#define SHADER_NAME ' + parameters.shaderName,

			customDefines

		].filter( filterEmptyLine ).join( '\n' );

		if ( prefixFragment.length > 0 ) {

			prefixFragment += '\n';

		}

	} else {

		prefixVertex = [

			generatePrecision( parameters ),

			'#define SHADER_TYPE ' + parameters.shaderType,
			'#define SHADER_NAME ' + parameters.shaderName,

			customDefines,

			parameters.extensionClipCullDistance ? '#define USE_CLIP_DISTANCE' : '',
			parameters.batching ? '#define USE_BATCHING' : '',
			parameters.instancing ? '#define USE_INSTANCING' : '',
			parameters.instancingColor ? '#define USE_INSTANCING_COLOR' : '',
			parameters.instancingMorph ? '#define USE_INSTANCING_MORPH' : '',

			parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
			parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',

			parameters.map ? '#define USE_MAP' : '',
			parameters.envMap ? '#define USE_ENVMAP' : '',
			parameters.envMap ? '#define ' + envMapModeDefine : '',
			parameters.lightMap ? '#define USE_LIGHTMAP' : '',
			parameters.aoMap ? '#define USE_AOMAP' : '',
			parameters.bumpMap ? '#define USE_BUMPMAP' : '',
			parameters.normalMap ? '#define USE_NORMALMAP' : '',
			parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
			parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
			parameters.displacementMap ? '#define USE_DISPLACEMENTMAP' : '',
			parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',

			parameters.anisotropy ? '#define USE_ANISOTROPY' : '',
			parameters.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',

			parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
			parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
			parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',

			parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
			parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',

			parameters.specularMap ? '#define USE_SPECULARMAP' : '',
			parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
			parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',

			parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
			parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
			parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
			parameters.alphaHash ? '#define USE_ALPHAHASH' : '',

			parameters.transmission ? '#define USE_TRANSMISSION' : '',
			parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
			parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',

			parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
			parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',

			//

			parameters.mapUv ? '#define MAP_UV ' + parameters.mapUv : '',
			parameters.alphaMapUv ? '#define ALPHAMAP_UV ' + parameters.alphaMapUv : '',
			parameters.lightMapUv ? '#define LIGHTMAP_UV ' + parameters.lightMapUv : '',
			parameters.aoMapUv ? '#define AOMAP_UV ' + parameters.aoMapUv : '',
			parameters.emissiveMapUv ? '#define EMISSIVEMAP_UV ' + parameters.emissiveMapUv : '',
			parameters.bumpMapUv ? '#define BUMPMAP_UV ' + parameters.bumpMapUv : '',
			parameters.normalMapUv ? '#define NORMALMAP_UV ' + parameters.normalMapUv : '',
			parameters.displacementMapUv ? '#define DISPLACEMENTMAP_UV ' + parameters.displacementMapUv : '',

			parameters.metalnessMapUv ? '#define METALNESSMAP_UV ' + parameters.metalnessMapUv : '',
			parameters.roughnessMapUv ? '#define ROUGHNESSMAP_UV ' + parameters.roughnessMapUv : '',

			parameters.anisotropyMapUv ? '#define ANISOTROPYMAP_UV ' + parameters.anisotropyMapUv : '',

			parameters.clearcoatMapUv ? '#define CLEARCOATMAP_UV ' + parameters.clearcoatMapUv : '',
			parameters.clearcoatNormalMapUv ? '#define CLEARCOAT_NORMALMAP_UV ' + parameters.clearcoatNormalMapUv : '',
			parameters.clearcoatRoughnessMapUv ? '#define CLEARCOAT_ROUGHNESSMAP_UV ' + parameters.clearcoatRoughnessMapUv : '',

			parameters.iridescenceMapUv ? '#define IRIDESCENCEMAP_UV ' + parameters.iridescenceMapUv : '',
			parameters.iridescenceThicknessMapUv ? '#define IRIDESCENCE_THICKNESSMAP_UV ' + parameters.iridescenceThicknessMapUv : '',

			parameters.sheenColorMapUv ? '#define SHEEN_COLORMAP_UV ' + parameters.sheenColorMapUv : '',
			parameters.sheenRoughnessMapUv ? '#define SHEEN_ROUGHNESSMAP_UV ' + parameters.sheenRoughnessMapUv : '',

			parameters.specularMapUv ? '#define SPECULARMAP_UV ' + parameters.specularMapUv : '',
			parameters.specularColorMapUv ? '#define SPECULAR_COLORMAP_UV ' + parameters.specularColorMapUv : '',
			parameters.specularIntensityMapUv ? '#define SPECULAR_INTENSITYMAP_UV ' + parameters.specularIntensityMapUv : '',

			parameters.transmissionMapUv ? '#define TRANSMISSIONMAP_UV ' + parameters.transmissionMapUv : '',
			parameters.thicknessMapUv ? '#define THICKNESSMAP_UV ' + parameters.thicknessMapUv : '',

			//

			parameters.vertexTangents && parameters.flatShading === false ? '#define USE_TANGENT' : '',
			parameters.vertexColors ? '#define USE_COLOR' : '',
			parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
			parameters.vertexUv1s ? '#define USE_UV1' : '',
			parameters.vertexUv2s ? '#define USE_UV2' : '',
			parameters.vertexUv3s ? '#define USE_UV3' : '',

			parameters.pointsUvs ? '#define USE_POINTS_UV' : '',

			parameters.flatShading ? '#define FLAT_SHADED' : '',

			parameters.skinning ? '#define USE_SKINNING' : '',

			parameters.morphTargets ? '#define USE_MORPHTARGETS' : '',
			parameters.morphNormals && parameters.flatShading === false ? '#define USE_MORPHNORMALS' : '',
			( parameters.morphColors ) ? '#define USE_MORPHCOLORS' : '',
			( parameters.morphTargetsCount > 0 ) ? '#define MORPHTARGETS_TEXTURE' : '',
			( parameters.morphTargetsCount > 0 ) ? '#define MORPHTARGETS_TEXTURE_STRIDE ' + parameters.morphTextureStride : '',
			( parameters.morphTargetsCount > 0 ) ? '#define MORPHTARGETS_COUNT ' + parameters.morphTargetsCount : '',
			parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
			parameters.flipSided ? '#define FLIP_SIDED' : '',

			parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
			parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',

			parameters.sizeAttenuation ? '#define USE_SIZEATTENUATION' : '',

			parameters.numLightProbes > 0 ? '#define USE_LIGHT_PROBES' : '',

			parameters.useLegacyLights ? '#define LEGACY_LIGHTS' : '',

			parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',

			'uniform mat4 modelMatrix;',
			'uniform mat4 modelViewMatrix;',
			'uniform mat4 projectionMatrix;',
			'uniform mat4 viewMatrix;',
			'uniform mat3 normalMatrix;',
			'uniform vec3 cameraPosition;',
			'uniform bool isOrthographic;',

			'#ifdef USE_INSTANCING',

			'	attribute mat4 instanceMatrix;',

			'#endif',

			'#ifdef USE_INSTANCING_COLOR',

			'	attribute vec3 instanceColor;',

			'#endif',

			'#ifdef USE_INSTANCING_MORPH',

			'	uniform sampler2D morphTexture;',

			'#endif',

			'attribute vec3 position;',
			'attribute vec3 normal;',
			'attribute vec2 uv;',

			'#ifdef USE_UV1',

			'	attribute vec2 uv1;',

			'#endif',

			'#ifdef USE_UV2',

			'	attribute vec2 uv2;',

			'#endif',

			'#ifdef USE_UV3',

			'	attribute vec2 uv3;',

			'#endif',

			'#ifdef USE_TANGENT',

			'	attribute vec4 tangent;',

			'#endif',

			'#if defined( USE_COLOR_ALPHA )',

			'	attribute vec4 color;',

			'#elif defined( USE_COLOR )',

			'	attribute vec3 color;',

			'#endif',

			'#if ( defined( USE_MORPHTARGETS ) && ! defined( MORPHTARGETS_TEXTURE ) )',

			'	attribute vec3 morphTarget0;',
			'	attribute vec3 morphTarget1;',
			'	attribute vec3 morphTarget2;',
			'	attribute vec3 morphTarget3;',

			'	#ifdef USE_MORPHNORMALS',

			'		attribute vec3 morphNormal0;',
			'		attribute vec3 morphNormal1;',
			'		attribute vec3 morphNormal2;',
			'		attribute vec3 morphNormal3;',

			'	#else',

			'		attribute vec3 morphTarget4;',
			'		attribute vec3 morphTarget5;',
			'		attribute vec3 morphTarget6;',
			'		attribute vec3 morphTarget7;',

			'	#endif',

			'#endif',

			'#ifdef USE_SKINNING',

			'	attribute vec4 skinIndex;',
			'	attribute vec4 skinWeight;',

			'#endif',

			'\n'

		].filter( filterEmptyLine ).join( '\n' );

		prefixFragment = [

			generatePrecision( parameters ),

			'#define SHADER_TYPE ' + parameters.shaderType,
			'#define SHADER_NAME ' + parameters.shaderName,

			customDefines,

			parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
			parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',

			parameters.alphaToCoverage ? '#define ALPHA_TO_COVERAGE' : '',
			parameters.map ? '#define USE_MAP' : '',
			parameters.matcap ? '#define USE_MATCAP' : '',
			parameters.envMap ? '#define USE_ENVMAP' : '',
			parameters.envMap ? '#define ' + envMapTypeDefine : '',
			parameters.envMap ? '#define ' + envMapModeDefine : '',
			parameters.envMap ? '#define ' + envMapBlendingDefine : '',
			envMapCubeUVSize ? '#define CUBEUV_TEXEL_WIDTH ' + envMapCubeUVSize.texelWidth : '',
			envMapCubeUVSize ? '#define CUBEUV_TEXEL_HEIGHT ' + envMapCubeUVSize.texelHeight : '',
			envMapCubeUVSize ? '#define CUBEUV_MAX_MIP ' + envMapCubeUVSize.maxMip + '.0' : '',
			parameters.lightMap ? '#define USE_LIGHTMAP' : '',
			parameters.aoMap ? '#define USE_AOMAP' : '',
			parameters.bumpMap ? '#define USE_BUMPMAP' : '',
			parameters.normalMap ? '#define USE_NORMALMAP' : '',
			parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
			parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
			parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',

			parameters.anisotropy ? '#define USE_ANISOTROPY' : '',
			parameters.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',

			parameters.clearcoat ? '#define USE_CLEARCOAT' : '',
			parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
			parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
			parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',

			parameters.iridescence ? '#define USE_IRIDESCENCE' : '',
			parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
			parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',

			parameters.specularMap ? '#define USE_SPECULARMAP' : '',
			parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
			parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',

			parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
			parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',

			parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
			parameters.alphaTest ? '#define USE_ALPHATEST' : '',
			parameters.alphaHash ? '#define USE_ALPHAHASH' : '',

			parameters.sheen ? '#define USE_SHEEN' : '',
			parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
			parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',

			parameters.transmission ? '#define USE_TRANSMISSION' : '',
			parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
			parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',

			parameters.vertexTangents && parameters.flatShading === false ? '#define USE_TANGENT' : '',
			parameters.vertexColors || parameters.instancingColor ? '#define USE_COLOR' : '',
			parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
			parameters.vertexUv1s ? '#define USE_UV1' : '',
			parameters.vertexUv2s ? '#define USE_UV2' : '',
			parameters.vertexUv3s ? '#define USE_UV3' : '',

			parameters.pointsUvs ? '#define USE_POINTS_UV' : '',

			parameters.gradientMap ? '#define USE_GRADIENTMAP' : '',

			parameters.flatShading ? '#define FLAT_SHADED' : '',

			parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
			parameters.flipSided ? '#define FLIP_SIDED' : '',

			parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
			parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',

			parameters.premultipliedAlpha ? '#define PREMULTIPLIED_ALPHA' : '',

			parameters.numLightProbes > 0 ? '#define USE_LIGHT_PROBES' : '',

			parameters.useLegacyLights ? '#define LEGACY_LIGHTS' : '',

			parameters.decodeVideoTexture ? '#define DECODE_VIDEO_TEXTURE' : '',

			parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',

			'uniform mat4 viewMatrix;',
			'uniform vec3 cameraPosition;',
			'uniform bool isOrthographic;',

			( parameters.toneMapping !== NoToneMapping ) ? '#define TONE_MAPPING' : '',
			( parameters.toneMapping !== NoToneMapping ) ? ShaderChunk[ 'tonemapping_pars_fragment' ] : '', // this code is required here because it is used by the toneMapping() function defined below
			( parameters.toneMapping !== NoToneMapping ) ? getToneMappingFunction( 'toneMapping', parameters.toneMapping ) : '',

			parameters.dithering ? '#define DITHERING' : '',
			parameters.opaque ? '#define OPAQUE' : '',

			ShaderChunk[ 'colorspace_pars_fragment' ], // this code is required here because it is used by the various encoding/decoding function defined below
			getTexelEncodingFunction( 'linearToOutputTexel', parameters.outputColorSpace ),

			parameters.useDepthPacking ? '#define DEPTH_PACKING ' + parameters.depthPacking : '',

			'\n'

		].filter( filterEmptyLine ).join( '\n' );

	}

	vertexShader = resolveIncludes( vertexShader );
	vertexShader = replaceLightNums( vertexShader, parameters );
	vertexShader = replaceClippingPlaneNums( vertexShader, parameters );

	fragmentShader = resolveIncludes( fragmentShader );
	fragmentShader = replaceLightNums( fragmentShader, parameters );
	fragmentShader = replaceClippingPlaneNums( fragmentShader, parameters );

	vertexShader = unrollLoops( vertexShader );
	fragmentShader = unrollLoops( fragmentShader );

	if ( parameters.isRawShaderMaterial !== true ) {

		// GLSL 3.0 conversion for built-in materials and ShaderMaterial

		versionString = '#version 300 es\n';

		prefixVertex = [
			customVertexExtensions,
			'#define attribute in',
			'#define varying out',
			'#define texture2D texture'
		].join( '\n' ) + '\n' + prefixVertex;

		prefixFragment = [
			'#define varying in',
			( parameters.glslVersion === GLSL3 ) ? '' : 'layout(location = 0) out highp vec4 pc_fragColor;',
			( parameters.glslVersion === GLSL3 ) ? '' : '#define gl_FragColor pc_fragColor',
			'#define gl_FragDepthEXT gl_FragDepth',
			'#define texture2D texture',
			'#define textureCube texture',
			'#define texture2DProj textureProj',
			'#define texture2DLodEXT textureLod',
			'#define texture2DProjLodEXT textureProjLod',
			'#define textureCubeLodEXT textureLod',
			'#define texture2DGradEXT textureGrad',
			'#define texture2DProjGradEXT textureProjGrad',
			'#define textureCubeGradEXT textureGrad'
		].join( '\n' ) + '\n' + prefixFragment;

	}

	const vertexGlsl = versionString + prefixVertex + vertexShader;
	const fragmentGlsl = versionString + prefixFragment + fragmentShader;

	// console.log( '*VERTEX*', vertexGlsl );
	// console.log( '*FRAGMENT*', fragmentGlsl );

	const glVertexShader = WebGLShader( gl, gl.VERTEX_SHADER, vertexGlsl );
	const glFragmentShader = WebGLShader( gl, gl.FRAGMENT_SHADER, fragmentGlsl );

	gl.attachShader( program, glVertexShader );
	gl.attachShader( program, glFragmentShader );

	// Force a particular attribute to index 0.

	if ( parameters.index0AttributeName !== undefined ) {

		gl.bindAttribLocation( program, 0, parameters.index0AttributeName );

	} else if ( parameters.morphTargets === true ) {

		// programs with morphTargets displace position out of attribute 0
		gl.bindAttribLocation( program, 0, 'position' );

	}

	gl.linkProgram( program );

	function onFirstUse( self ) {

		// check for link errors
		if ( renderer.debug.checkShaderErrors ) {

			const programLog = gl.getProgramInfoLog( program ).trim();
			const vertexLog = gl.getShaderInfoLog( glVertexShader ).trim();
			const fragmentLog = gl.getShaderInfoLog( glFragmentShader ).trim();

			let runnable = true;
			let haveDiagnostics = true;

			if ( gl.getProgramParameter( program, gl.LINK_STATUS ) === false ) {

				runnable = false;

				if ( typeof renderer.debug.onShaderError === 'function' ) {

					renderer.debug.onShaderError( gl, program, glVertexShader, glFragmentShader );

				} else {

					// default error reporting

					const vertexErrors = getShaderErrors( gl, glVertexShader, 'vertex' );
					const fragmentErrors = getShaderErrors( gl, glFragmentShader, 'fragment' );

					console.error(
						'THREE.WebGLProgram: Shader Error ' + gl.getError() + ' - ' +
						'VALIDATE_STATUS ' + gl.getProgramParameter( program, gl.VALIDATE_STATUS ) + '\n\n' +
						'Material Name: ' + self.name + '\n' +
						'Material Type: ' + self.type + '\n\n' +
						'Program Info Log: ' + programLog + '\n' +
						vertexErrors + '\n' +
						fragmentErrors
					);

				}

			} else if ( programLog !== '' ) {

				console.warn( 'THREE.WebGLProgram: Program Info Log:', programLog );

			} else if ( vertexLog === '' || fragmentLog === '' ) {

				haveDiagnostics = false;

			}

			if ( haveDiagnostics ) {

				self.diagnostics = {

					runnable: runnable,

					programLog: programLog,

					vertexShader: {

						log: vertexLog,
						prefix: prefixVertex

					},

					fragmentShader: {

						log: fragmentLog,
						prefix: prefixFragment

					}

				};

			}

		}

		// Clean up

		// Crashes in iOS9 and iOS10. #18402
		// gl.detachShader( program, glVertexShader );
		// gl.detachShader( program, glFragmentShader );

		gl.deleteShader( glVertexShader );
		gl.deleteShader( glFragmentShader );

		cachedUniforms = new WebGLUniforms( gl, program );
		cachedAttributes = fetchAttributeLocations( gl, program );

	}

	// set up caching for uniform locations

	let cachedUniforms;

	this.getUniforms = function () {

		if ( cachedUniforms === undefined ) {

			// Populates cachedUniforms and cachedAttributes
			onFirstUse( this );

		}

		return cachedUniforms;

	};

	// set up caching for attribute locations

	let cachedAttributes;

	this.getAttributes = function () {

		if ( cachedAttributes === undefined ) {

			// Populates cachedAttributes and cachedUniforms
			onFirstUse( this );

		}

		return cachedAttributes;

	};

	// indicate when the program is ready to be used. if the KHR_parallel_shader_compile extension isn't supported,
	// flag the program as ready immediately. It may cause a stall when it's first used.

	let programReady = ( parameters.rendererExtensionParallelShaderCompile === false );

	this.isReady = function () {

		if ( programReady === false ) {

			programReady = gl.getProgramParameter( program, COMPLETION_STATUS_KHR );

		}

		return programReady;

	};

	// free resource

	this.destroy = function () {

		bindingStates.releaseStatesOfProgram( this );

		gl.deleteProgram( program );
		this.program = undefined;

	};

	//

	this.type = parameters.shaderType;
	this.name = parameters.shaderName;
	this.id = programIdCount ++;
	this.cacheKey = cacheKey;
	this.usedTimes = 1;
	this.program = program;
	this.vertexShader = glVertexShader;
	this.fragmentShader = glFragmentShader;

	return this;

}

let _id$1 = 0;

class WebGLShaderCache {

	constructor() {

		this.shaderCache = new Map();
		this.materialCache = new Map();

	}

	update( material ) {

		const vertexShader = material.vertexShader;
		const fragmentShader = material.fragmentShader;

		const vertexShaderStage = this._getShaderStage( vertexShader );
		const fragmentShaderStage = this._getShaderStage( fragmentShader );

		const materialShaders = this._getShaderCacheForMaterial( material );

		if ( materialShaders.has( vertexShaderStage ) === false ) {

			materialShaders.add( vertexShaderStage );
			vertexShaderStage.usedTimes ++;

		}

		if ( materialShaders.has( fragmentShaderStage ) === false ) {

			materialShaders.add( fragmentShaderStage );
			fragmentShaderStage.usedTimes ++;

		}

		return this;

	}

	remove( material ) {

		const materialShaders = this.materialCache.get( material );

		for ( const shaderStage of materialShaders ) {

			shaderStage.usedTimes --;

			if ( shaderStage.usedTimes === 0 ) this.shaderCache.delete( shaderStage.code );

		}

		this.materialCache.delete( material );

		return this;

	}

	getVertexShaderID( material ) {

		return this._getShaderStage( material.vertexShader ).id;

	}

	getFragmentShaderID( material ) {

		return this._getShaderStage( material.fragmentShader ).id;

	}

	dispose() {

		this.shaderCache.clear();
		this.materialCache.clear();

	}

	_getShaderCacheForMaterial( material ) {

		const cache = this.materialCache;
		let set = cache.get( material );

		if ( set === undefined ) {

			set = new Set();
			cache.set( material, set );

		}

		return set;

	}

	_getShaderStage( code ) {

		const cache = this.shaderCache;
		let stage = cache.get( code );

		if ( stage === undefined ) {

			stage = new WebGLShaderStage( code );
			cache.set( code, stage );

		}

		return stage;

	}

}

class WebGLShaderStage {

	constructor( code ) {

		this.id = _id$1 ++;

		this.code = code;
		this.usedTimes = 0;

	}

}

function WebGLPrograms( renderer, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping ) {

	const _programLayers = new Layers();
	const _customShaders = new WebGLShaderCache();
	const _activeChannels = new Set();
	const programs = [];

	const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
	const SUPPORTS_VERTEX_TEXTURES = capabilities.vertexTextures;

	let precision = capabilities.precision;

	const shaderIDs = {
		MeshDepthMaterial: 'depth',
		MeshDistanceMaterial: 'distanceRGBA',
		MeshNormalMaterial: 'normal',
		MeshBasicMaterial: 'basic',
		MeshLambertMaterial: 'lambert',
		MeshPhongMaterial: 'phong',
		MeshToonMaterial: 'toon',
		MeshStandardMaterial: 'physical',
		MeshPhysicalMaterial: 'physical',
		MeshMatcapMaterial: 'matcap',
		LineBasicMaterial: 'basic',
		LineDashedMaterial: 'dashed',
		PointsMaterial: 'points',
		ShadowMaterial: 'shadow',
		SpriteMaterial: 'sprite'
	};

	function getChannel( value ) {

		_activeChannels.add( value );

		if ( value === 0 ) return 'uv';

		return `uv${ value }`;

	}

	function getParameters( material, lights, shadows, scene, object ) {

		const fog = scene.fog;
		const geometry = object.geometry;
		const environment = material.isMeshStandardMaterial ? scene.environment : null;

		const envMap = ( material.isMeshStandardMaterial ? cubeuvmaps : cubemaps ).get( material.envMap || environment );
		const envMapCubeUVHeight = ( !! envMap ) && ( envMap.mapping === CubeUVReflectionMapping ) ? envMap.image.height : null;

		const shaderID = shaderIDs[ material.type ];

		// heuristics to create shader parameters according to lights in the scene
		// (not to blow over maxLights budget)

		if ( material.precision !== null ) {

			precision = capabilities.getMaxPrecision( material.precision );

			if ( precision !== material.precision ) {

				console.warn( 'THREE.WebGLProgram.getParameters:', material.precision, 'not supported, using', precision, 'instead.' );

			}

		}

		//

		const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
		const morphTargetsCount = ( morphAttribute !== undefined ) ? morphAttribute.length : 0;

		let morphTextureStride = 0;

		if ( geometry.morphAttributes.position !== undefined ) morphTextureStride = 1;
		if ( geometry.morphAttributes.normal !== undefined ) morphTextureStride = 2;
		if ( geometry.morphAttributes.color !== undefined ) morphTextureStride = 3;

		//

		let vertexShader, fragmentShader;
		let customVertexShaderID, customFragmentShaderID;

		if ( shaderID ) {

			const shader = ShaderLib[ shaderID ];

			vertexShader = shader.vertexShader;
			fragmentShader = shader.fragmentShader;

		} else {

			vertexShader = material.vertexShader;
			fragmentShader = material.fragmentShader;

			_customShaders.update( material );

			customVertexShaderID = _customShaders.getVertexShaderID( material );
			customFragmentShaderID = _customShaders.getFragmentShaderID( material );

		}

		const currentRenderTarget = renderer.getRenderTarget();

		const IS_INSTANCEDMESH = object.isInstancedMesh === true;
		const IS_BATCHEDMESH = object.isBatchedMesh === true;

		const HAS_MAP = !! material.map;
		const HAS_MATCAP = !! material.matcap;
		const HAS_ENVMAP = !! envMap;
		const HAS_AOMAP = !! material.aoMap;
		const HAS_LIGHTMAP = !! material.lightMap;
		const HAS_BUMPMAP = !! material.bumpMap;
		const HAS_NORMALMAP = !! material.normalMap;
		const HAS_DISPLACEMENTMAP = !! material.displacementMap;
		const HAS_EMISSIVEMAP = !! material.emissiveMap;

		const HAS_METALNESSMAP = !! material.metalnessMap;
		const HAS_ROUGHNESSMAP = !! material.roughnessMap;

		const HAS_ANISOTROPY = material.anisotropy > 0;
		const HAS_CLEARCOAT = material.clearcoat > 0;
		const HAS_IRIDESCENCE = material.iridescence > 0;
		const HAS_SHEEN = material.sheen > 0;
		const HAS_TRANSMISSION = material.transmission > 0;

		const HAS_ANISOTROPYMAP = HAS_ANISOTROPY && !! material.anisotropyMap;

		const HAS_CLEARCOATMAP = HAS_CLEARCOAT && !! material.clearcoatMap;
		const HAS_CLEARCOAT_NORMALMAP = HAS_CLEARCOAT && !! material.clearcoatNormalMap;
		const HAS_CLEARCOAT_ROUGHNESSMAP = HAS_CLEARCOAT && !! material.clearcoatRoughnessMap;

		const HAS_IRIDESCENCEMAP = HAS_IRIDESCENCE && !! material.iridescenceMap;
		const HAS_IRIDESCENCE_THICKNESSMAP = HAS_IRIDESCENCE && !! material.iridescenceThicknessMap;

		const HAS_SHEEN_COLORMAP = HAS_SHEEN && !! material.sheenColorMap;
		const HAS_SHEEN_ROUGHNESSMAP = HAS_SHEEN && !! material.sheenRoughnessMap;

		const HAS_SPECULARMAP = !! material.specularMap;
		const HAS_SPECULAR_COLORMAP = !! material.specularColorMap;
		const HAS_SPECULAR_INTENSITYMAP = !! material.specularIntensityMap;

		const HAS_TRANSMISSIONMAP = HAS_TRANSMISSION && !! material.transmissionMap;
		const HAS_THICKNESSMAP = HAS_TRANSMISSION && !! material.thicknessMap;

		const HAS_GRADIENTMAP = !! material.gradientMap;

		const HAS_ALPHAMAP = !! material.alphaMap;

		const HAS_ALPHATEST = material.alphaTest > 0;

		const HAS_ALPHAHASH = !! material.alphaHash;

		const HAS_EXTENSIONS = !! material.extensions;

		let toneMapping = NoToneMapping;

		if ( material.toneMapped ) {

			if ( currentRenderTarget === null || currentRenderTarget.isXRRenderTarget === true ) {

				toneMapping = renderer.toneMapping;

			}

		}

		const parameters = {

			shaderID: shaderID,
			shaderType: material.type,
			shaderName: material.name,

			vertexShader: vertexShader,
			fragmentShader: fragmentShader,
			defines: material.defines,

			customVertexShaderID: customVertexShaderID,
			customFragmentShaderID: customFragmentShaderID,

			isRawShaderMaterial: material.isRawShaderMaterial === true,
			glslVersion: material.glslVersion,

			precision: precision,

			batching: IS_BATCHEDMESH,
			instancing: IS_INSTANCEDMESH,
			instancingColor: IS_INSTANCEDMESH && object.instanceColor !== null,
			instancingMorph: IS_INSTANCEDMESH && object.morphTexture !== null,

			supportsVertexTextures: SUPPORTS_VERTEX_TEXTURES,
			outputColorSpace: ( currentRenderTarget === null ) ? renderer.outputColorSpace : ( currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.colorSpace : LinearSRGBColorSpace ),
			alphaToCoverage: !! material.alphaToCoverage,

			map: HAS_MAP,
			matcap: HAS_MATCAP,
			envMap: HAS_ENVMAP,
			envMapMode: HAS_ENVMAP && envMap.mapping,
			envMapCubeUVHeight: envMapCubeUVHeight,
			aoMap: HAS_AOMAP,
			lightMap: HAS_LIGHTMAP,
			bumpMap: HAS_BUMPMAP,
			normalMap: HAS_NORMALMAP,
			displacementMap: SUPPORTS_VERTEX_TEXTURES && HAS_DISPLACEMENTMAP,
			emissiveMap: HAS_EMISSIVEMAP,

			normalMapObjectSpace: HAS_NORMALMAP && material.normalMapType === ObjectSpaceNormalMap,
			normalMapTangentSpace: HAS_NORMALMAP && material.normalMapType === TangentSpaceNormalMap,

			metalnessMap: HAS_METALNESSMAP,
			roughnessMap: HAS_ROUGHNESSMAP,

			anisotropy: HAS_ANISOTROPY,
			anisotropyMap: HAS_ANISOTROPYMAP,

			clearcoat: HAS_CLEARCOAT,
			clearcoatMap: HAS_CLEARCOATMAP,
			clearcoatNormalMap: HAS_CLEARCOAT_NORMALMAP,
			clearcoatRoughnessMap: HAS_CLEARCOAT_ROUGHNESSMAP,

			iridescence: HAS_IRIDESCENCE,
			iridescenceMap: HAS_IRIDESCENCEMAP,
			iridescenceThicknessMap: HAS_IRIDESCENCE_THICKNESSMAP,

			sheen: HAS_SHEEN,
			sheenColorMap: HAS_SHEEN_COLORMAP,
			sheenRoughnessMap: HAS_SHEEN_ROUGHNESSMAP,

			specularMap: HAS_SPECULARMAP,
			specularColorMap: HAS_SPECULAR_COLORMAP,
			specularIntensityMap: HAS_SPECULAR_INTENSITYMAP,

			transmission: HAS_TRANSMISSION,
			transmissionMap: HAS_TRANSMISSIONMAP,
			thicknessMap: HAS_THICKNESSMAP,

			gradientMap: HAS_GRADIENTMAP,

			opaque: material.transparent === false && material.blending === NormalBlending && material.alphaToCoverage === false,

			alphaMap: HAS_ALPHAMAP,
			alphaTest: HAS_ALPHATEST,
			alphaHash: HAS_ALPHAHASH,

			combine: material.combine,

			//

			mapUv: HAS_MAP && getChannel( material.map.channel ),
			aoMapUv: HAS_AOMAP && getChannel( material.aoMap.channel ),
			lightMapUv: HAS_LIGHTMAP && getChannel( material.lightMap.channel ),
			bumpMapUv: HAS_BUMPMAP && getChannel( material.bumpMap.channel ),
			normalMapUv: HAS_NORMALMAP && getChannel( material.normalMap.channel ),
			displacementMapUv: HAS_DISPLACEMENTMAP && getChannel( material.displacementMap.channel ),
			emissiveMapUv: HAS_EMISSIVEMAP && getChannel( material.emissiveMap.channel ),

			metalnessMapUv: HAS_METALNESSMAP && getChannel( material.metalnessMap.channel ),
			roughnessMapUv: HAS_ROUGHNESSMAP && getChannel( material.roughnessMap.channel ),

			anisotropyMapUv: HAS_ANISOTROPYMAP && getChannel( material.anisotropyMap.channel ),

			clearcoatMapUv: HAS_CLEARCOATMAP && getChannel( material.clearcoatMap.channel ),
			clearcoatNormalMapUv: HAS_CLEARCOAT_NORMALMAP && getChannel( material.clearcoatNormalMap.channel ),
			clearcoatRoughnessMapUv: HAS_CLEARCOAT_ROUGHNESSMAP && getChannel( material.clearcoatRoughnessMap.channel ),

			iridescenceMapUv: HAS_IRIDESCENCEMAP && getChannel( material.iridescenceMap.channel ),
			iridescenceThicknessMapUv: HAS_IRIDESCENCE_THICKNESSMAP && getChannel( material.iridescenceThicknessMap.channel ),

			sheenColorMapUv: HAS_SHEEN_COLORMAP && getChannel( material.sheenColorMap.channel ),
			sheenRoughnessMapUv: HAS_SHEEN_ROUGHNESSMAP && getChannel( material.sheenRoughnessMap.channel ),

			specularMapUv: HAS_SPECULARMAP && getChannel( material.specularMap.channel ),
			specularColorMapUv: HAS_SPECULAR_COLORMAP && getChannel( material.specularColorMap.channel ),
			specularIntensityMapUv: HAS_SPECULAR_INTENSITYMAP && getChannel( material.specularIntensityMap.channel ),

			transmissionMapUv: HAS_TRANSMISSIONMAP && getChannel( material.transmissionMap.channel ),
			thicknessMapUv: HAS_THICKNESSMAP && getChannel( material.thicknessMap.channel ),

			alphaMapUv: HAS_ALPHAMAP && getChannel( material.alphaMap.channel ),

			//

			vertexTangents: !! geometry.attributes.tangent && ( HAS_NORMALMAP || HAS_ANISOTROPY ),
			vertexColors: material.vertexColors,
			vertexAlphas: material.vertexColors === true && !! geometry.attributes.color && geometry.attributes.color.itemSize === 4,

			pointsUvs: object.isPoints === true && !! geometry.attributes.uv && ( HAS_MAP || HAS_ALPHAMAP ),

			fog: !! fog,
			useFog: material.fog === true,
			fogExp2: ( !! fog && fog.isFogExp2 ),

			flatShading: material.flatShading === true,

			sizeAttenuation: material.sizeAttenuation === true,
			logarithmicDepthBuffer: logarithmicDepthBuffer,

			skinning: object.isSkinnedMesh === true,

			morphTargets: geometry.morphAttributes.position !== undefined,
			morphNormals: geometry.morphAttributes.normal !== undefined,
			morphColors: geometry.morphAttributes.color !== undefined,
			morphTargetsCount: morphTargetsCount,
			morphTextureStride: morphTextureStride,

			numDirLights: lights.directional.length,
			numPointLights: lights.point.length,
			numSpotLights: lights.spot.length,
			numSpotLightMaps: lights.spotLightMap.length,
			numRectAreaLights: lights.rectArea.length,
			numHemiLights: lights.hemi.length,

			numDirLightShadows: lights.directionalShadowMap.length,
			numPointLightShadows: lights.pointShadowMap.length,
			numSpotLightShadows: lights.spotShadowMap.length,
			numSpotLightShadowsWithMaps: lights.numSpotLightShadowsWithMaps,

			numLightProbes: lights.numLightProbes,

			numClippingPlanes: clipping.numPlanes,
			numClipIntersection: clipping.numIntersection,

			dithering: material.dithering,

			shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
			shadowMapType: renderer.shadowMap.type,

			toneMapping: toneMapping,
			useLegacyLights: renderer._useLegacyLights,

			decodeVideoTexture: HAS_MAP && ( material.map.isVideoTexture === true ) && ( ColorManagement.getTransfer( material.map.colorSpace ) === SRGBTransfer ),

			premultipliedAlpha: material.premultipliedAlpha,

			doubleSided: material.side === DoubleSide,
			flipSided: material.side === BackSide,

			useDepthPacking: material.depthPacking >= 0,
			depthPacking: material.depthPacking || 0,

			index0AttributeName: material.index0AttributeName,

			extensionClipCullDistance: HAS_EXTENSIONS && material.extensions.clipCullDistance === true && extensions.has( 'WEBGL_clip_cull_distance' ),
			extensionMultiDraw: HAS_EXTENSIONS && material.extensions.multiDraw === true && extensions.has( 'WEBGL_multi_draw' ),

			rendererExtensionParallelShaderCompile: extensions.has( 'KHR_parallel_shader_compile' ),

			customProgramCacheKey: material.customProgramCacheKey()

		};

		// the usage of getChannel() determines the active texture channels for this shader

		parameters.vertexUv1s = _activeChannels.has( 1 );
		parameters.vertexUv2s = _activeChannels.has( 2 );
		parameters.vertexUv3s = _activeChannels.has( 3 );

		_activeChannels.clear();

		return parameters;

	}

	function getProgramCacheKey( parameters ) {

		const array = [];

		if ( parameters.shaderID ) {

			array.push( parameters.shaderID );

		} else {

			array.push( parameters.customVertexShaderID );
			array.push( parameters.customFragmentShaderID );

		}

		if ( parameters.defines !== undefined ) {

			for ( const name in parameters.defines ) {

				array.push( name );
				array.push( parameters.defines[ name ] );

			}

		}

		if ( parameters.isRawShaderMaterial === false ) {

			getProgramCacheKeyParameters( array, parameters );
			getProgramCacheKeyBooleans( array, parameters );
			array.push( renderer.outputColorSpace );

		}

		array.push( parameters.customProgramCacheKey );

		return array.join();

	}

	function getProgramCacheKeyParameters( array, parameters ) {

		array.push( parameters.precision );
		array.push( parameters.outputColorSpace );
		array.push( parameters.envMapMode );
		array.push( parameters.envMapCubeUVHeight );
		array.push( parameters.mapUv );
		array.push( parameters.alphaMapUv );
		array.push( parameters.lightMapUv );
		array.push( parameters.aoMapUv );
		array.push( parameters.bumpMapUv );
		array.push( parameters.normalMapUv );
		array.push( parameters.displacementMapUv );
		array.push( parameters.emissiveMapUv );
		array.push( parameters.metalnessMapUv );
		array.push( parameters.roughnessMapUv );
		array.push( parameters.anisotropyMapUv );
		array.push( parameters.clearcoatMapUv );
		array.push( parameters.clearcoatNormalMapUv );
		array.push( parameters.clearcoatRoughnessMapUv );
		array.push( parameters.iridescenceMapUv );
		array.push( parameters.iridescenceThicknessMapUv );
		array.push( parameters.sheenColorMapUv );
		array.push( parameters.sheenRoughnessMapUv );
		array.push( parameters.specularMapUv );
		array.push( parameters.specularColorMapUv );
		array.push( parameters.specularIntensityMapUv );
		array.push( parameters.transmissionMapUv );
		array.push( parameters.thicknessMapUv );
		array.push( parameters.combine );
		array.push( parameters.fogExp2 );
		array.push( parameters.sizeAttenuation );
		array.push( parameters.morphTargetsCount );
		array.push( parameters.morphAttributeCount );
		array.push( parameters.numDirLights );
		array.push( parameters.numPointLights );
		array.push( parameters.numSpotLights );
		array.push( parameters.numSpotLightMaps );
		array.push( parameters.numHemiLights );
		array.push( parameters.numRectAreaLights );
		array.push( parameters.numDirLightShadows );
		array.push( parameters.numPointLightShadows );
		array.push( parameters.numSpotLightShadows );
		array.push( parameters.numSpotLightShadowsWithMaps );
		array.push( parameters.numLightProbes );
		array.push( parameters.shadowMapType );
		array.push( parameters.toneMapping );
		array.push( parameters.numClippingPlanes );
		array.push( parameters.numClipIntersection );
		array.push( parameters.depthPacking );

	}

	function getProgramCacheKeyBooleans( array, parameters ) {

		_programLayers.disableAll();

		if ( parameters.supportsVertexTextures )
			_programLayers.enable( 0 );
		if ( parameters.instancing )
			_programLayers.enable( 1 );
		if ( parameters.instancingColor )
			_programLayers.enable( 2 );
		if ( parameters.instancingMorph )
			_programLayers.enable( 3 );
		if ( parameters.matcap )
			_programLayers.enable( 4 );
		if ( parameters.envMap )
			_programLayers.enable( 5 );
		if ( parameters.normalMapObjectSpace )
			_programLayers.enable( 6 );
		if ( parameters.normalMapTangentSpace )
			_programLayers.enable( 7 );
		if ( parameters.clearcoat )
			_programLayers.enable( 8 );
		if ( parameters.iridescence )
			_programLayers.enable( 9 );
		if ( parameters.alphaTest )
			_programLayers.enable( 10 );
		if ( parameters.vertexColors )
			_programLayers.enable( 11 );
		if ( parameters.vertexAlphas )
			_programLayers.enable( 12 );
		if ( parameters.vertexUv1s )
			_programLayers.enable( 13 );
		if ( parameters.vertexUv2s )
			_programLayers.enable( 14 );
		if ( parameters.vertexUv3s )
			_programLayers.enable( 15 );
		if ( parameters.vertexTangents )
			_programLayers.enable( 16 );
		if ( parameters.anisotropy )
			_programLayers.enable( 17 );
		if ( parameters.alphaHash )
			_programLayers.enable( 18 );
		if ( parameters.batching )
			_programLayers.enable( 19 );

		array.push( _programLayers.mask );
		_programLayers.disableAll();

		if ( parameters.fog )
			_programLayers.enable( 0 );
		if ( parameters.useFog )
			_programLayers.enable( 1 );
		if ( parameters.flatShading )
			_programLayers.enable( 2 );
		if ( parameters.logarithmicDepthBuffer )
			_programLayers.enable( 3 );
		if ( parameters.skinning )
			_programLayers.enable( 4 );
		if ( parameters.morphTargets )
			_programLayers.enable( 5 );
		if ( parameters.morphNormals )
			_programLayers.enable( 6 );
		if ( parameters.morphColors )
			_programLayers.enable( 7 );
		if ( parameters.premultipliedAlpha )
			_programLayers.enable( 8 );
		if ( parameters.shadowMapEnabled )
			_programLayers.enable( 9 );
		if ( parameters.useLegacyLights )
			_programLayers.enable( 10 );
		if ( parameters.doubleSided )
			_programLayers.enable( 11 );
		if ( parameters.flipSided )
			_programLayers.enable( 12 );
		if ( parameters.useDepthPacking )
			_programLayers.enable( 13 );
		if ( parameters.dithering )
			_programLayers.enable( 14 );
		if ( parameters.transmission )
			_programLayers.enable( 15 );
		if ( parameters.sheen )
			_programLayers.enable( 16 );
		if ( parameters.opaque )
			_programLayers.enable( 17 );
		if ( parameters.pointsUvs )
			_programLayers.enable( 18 );
		if ( parameters.decodeVideoTexture )
			_programLayers.enable( 19 );
		if ( parameters.alphaToCoverage )
			_programLayers.enable( 20 );

		array.push( _programLayers.mask );

	}

	function getUniforms( material ) {

		const shaderID = shaderIDs[ material.type ];
		let uniforms;

		if ( shaderID ) {

			const shader = ShaderLib[ shaderID ];
			uniforms = UniformsUtils.clone( shader.uniforms );

		} else {

			uniforms = material.uniforms;

		}

		return uniforms;

	}

	function acquireProgram( parameters, cacheKey ) {

		let program;

		// Check if code has been already compiled
		for ( let p = 0, pl = programs.length; p < pl; p ++ ) {

			const preexistingProgram = programs[ p ];

			if ( preexistingProgram.cacheKey === cacheKey ) {

				program = preexistingProgram;
				++ program.usedTimes;

				break;

			}

		}

		if ( program === undefined ) {

			program = new WebGLProgram( renderer, cacheKey, parameters, bindingStates );
			programs.push( program );

		}

		return program;

	}

	function releaseProgram( program ) {

		if ( -- program.usedTimes === 0 ) {

			// Remove from unordered set
			const i = programs.indexOf( program );
			programs[ i ] = programs[ programs.length - 1 ];
			programs.pop();

			// Free WebGL resources
			program.destroy();

		}

	}

	function releaseShaderCache( material ) {

		_customShaders.remove( material );

	}

	function dispose() {

		_customShaders.dispose();

	}

	return {
		getParameters: getParameters,
		getProgramCacheKey: getProgramCacheKey,
		getUniforms: getUniforms,
		acquireProgram: acquireProgram,
		releaseProgram: releaseProgram,
		releaseShaderCache: releaseShaderCache,
		// Exposed for resource monitoring & error feedback via renderer.info:
		programs: programs,
		dispose: dispose
	};

}

function WebGLProperties() {

	let properties = new WeakMap();

	function get( object ) {

		let map = properties.get( object );

		if ( map === undefined ) {

			map = {};
			properties.set( object, map );

		}

		return map;

	}

	function remove( object ) {

		properties.delete( object );

	}

	function update( object, key, value ) {

		properties.get( object )[ key ] = value;

	}

	function dispose() {

		properties = new WeakMap();

	}

	return {
		get: get,
		remove: remove,
		update: update,
		dispose: dispose
	};

}

function painterSortStable( a, b ) {

	if ( a.groupOrder !== b.groupOrder ) {

		return a.groupOrder - b.groupOrder;

	} else if ( a.renderOrder !== b.renderOrder ) {

		return a.renderOrder - b.renderOrder;

	} else if ( a.material.id !== b.material.id ) {

		return a.material.id - b.material.id;

	} else if ( a.z !== b.z ) {

		return a.z - b.z;

	} else {

		return a.id - b.id;

	}

}

function reversePainterSortStable( a, b ) {

	if ( a.groupOrder !== b.groupOrder ) {

		return a.groupOrder - b.groupOrder;

	} else if ( a.renderOrder !== b.renderOrder ) {

		return a.renderOrder - b.renderOrder;

	} else if ( a.z !== b.z ) {

		return b.z - a.z;

	} else {

		return a.id - b.id;

	}

}


function WebGLRenderList() {

	const renderItems = [];
	let renderItemsIndex = 0;

	const opaque = [];
	const transmissive = [];
	const transparent = [];

	function init() {

		renderItemsIndex = 0;

		opaque.length = 0;
		transmissive.length = 0;
		transparent.length = 0;

	}

	function getNextRenderItem( object, geometry, material, groupOrder, z, group ) {

		let renderItem = renderItems[ renderItemsIndex ];

		if ( renderItem === undefined ) {

			renderItem = {
				id: object.id,
				object: object,
				geometry: geometry,
				material: material,
				groupOrder: groupOrder,
				renderOrder: object.renderOrder,
				z: z,
				group: group
			};

			renderItems[ renderItemsIndex ] = renderItem;

		} else {

			renderItem.id = object.id;
			renderItem.object = object;
			renderItem.geometry = geometry;
			renderItem.material = material;
			renderItem.groupOrder = groupOrder;
			renderItem.renderOrder = object.renderOrder;
			renderItem.z = z;
			renderItem.group = group;

		}

		renderItemsIndex ++;

		return renderItem;

	}

	function push( object, geometry, material, groupOrder, z, group ) {

		const renderItem = getNextRenderItem( object, geometry, material, groupOrder, z, group );

		if ( material.transmission > 0.0 ) {

			transmissive.push( renderItem );

		} else if ( material.transparent === true ) {

			transparent.push( renderItem );

		} else {

			opaque.push( renderItem );

		}

	}

	function unshift( object, geometry, material, groupOrder, z, group ) {

		const renderItem = getNextRenderItem( object, geometry, material, groupOrder, z, group );

		if ( material.transmission > 0.0 ) {

			transmissive.unshift( renderItem );

		} else if ( material.transparent === true ) {

			transparent.unshift( renderItem );

		} else {

			opaque.unshift( renderItem );

		}

	}

	function sort( customOpaqueSort, customTransparentSort ) {

		if ( opaque.length > 1 ) opaque.sort( customOpaqueSort || painterSortStable );
		if ( transmissive.length > 1 ) transmissive.sort( customTransparentSort || reversePainterSortStable );
		if ( transparent.length > 1 ) transparent.sort( customTransparentSort || reversePainterSortStable );

	}

	function finish() {

		// Clear references from inactive renderItems in the list

		for ( let i = renderItemsIndex, il = renderItems.length; i < il; i ++ ) {

			const renderItem = renderItems[ i ];

			if ( renderItem.id === null ) break;

			renderItem.id = null;
			renderItem.object = null;
			renderItem.geometry = null;
			renderItem.material = null;
			renderItem.group = null;

		}

	}

	return {

		opaque: opaque,
		transmissive: transmissive,
		transparent: transparent,

		init: init,
		push: push,
		unshift: unshift,
		finish: finish,

		sort: sort
	};

}

function WebGLRenderLists() {

	let lists = new WeakMap();

	function get( scene, renderCallDepth ) {

		const listArray = lists.get( scene );
		let list;

		if ( listArray === undefined ) {

			list = new WebGLRenderList();
			lists.set( scene, [ list ] );

		} else {

			if ( renderCallDepth >= listArray.length ) {

				list = new WebGLRenderList();
				listArray.push( list );

			} else {

				list = listArray[ renderCallDepth ];

			}

		}

		return list;

	}

	function dispose() {

		lists = new WeakMap();

	}

	return {
		get: get,
		dispose: dispose
	};

}

function UniformsCache() {

	const lights = {};

	return {

		get: function ( light ) {

			if ( lights[ light.id ] !== undefined ) {

				return lights[ light.id ];

			}

			let uniforms;

			switch ( light.type ) {

				case 'DirectionalLight':
					uniforms = {
						direction: new Vector3(),
						color: new Color()
					};
					break;

				case 'SpotLight':
					uniforms = {
						position: new Vector3(),
						direction: new Vector3(),
						color: new Color(),
						distance: 0,
						coneCos: 0,
						penumbraCos: 0,
						decay: 0
					};
					break;

				case 'PointLight':
					uniforms = {
						position: new Vector3(),
						color: new Color(),
						distance: 0,
						decay: 0
					};
					break;

				case 'HemisphereLight':
					uniforms = {
						direction: new Vector3(),
						skyColor: new Color(),
						groundColor: new Color()
					};
					break;

				case 'RectAreaLight':
					uniforms = {
						color: new Color(),
						position: new Vector3(),
						halfWidth: new Vector3(),
						halfHeight: new Vector3()
					};
					break;

			}

			lights[ light.id ] = uniforms;

			return uniforms;

		}

	};

}

function ShadowUniformsCache() {

	const lights = {};

	return {

		get: function ( light ) {

			if ( lights[ light.id ] !== undefined ) {

				return lights[ light.id ];

			}

			let uniforms;

			switch ( light.type ) {

				case 'DirectionalLight':
					uniforms = {
						shadowBias: 0,
						shadowNormalBias: 0,
						shadowRadius: 1,
						shadowMapSize: new Vector2()
					};
					break;

				case 'SpotLight':
					uniforms = {
						shadowBias: 0,
						shadowNormalBias: 0,
						shadowRadius: 1,
						shadowMapSize: new Vector2()
					};
					break;

				case 'PointLight':
					uniforms = {
						shadowBias: 0,
						shadowNormalBias: 0,
						shadowRadius: 1,
						shadowMapSize: new Vector2(),
						shadowCameraNear: 1,
						shadowCameraFar: 1000
					};
					break;

				// TODO (abelnation): set RectAreaLight shadow uniforms

			}

			lights[ light.id ] = uniforms;

			return uniforms;

		}

	};

}



let nextVersion = 0;

function shadowCastingAndTexturingLightsFirst( lightA, lightB ) {

	return ( lightB.castShadow ? 2 : 0 ) - ( lightA.castShadow ? 2 : 0 ) + ( lightB.map ? 1 : 0 ) - ( lightA.map ? 1 : 0 );

}

function WebGLLights( extensions ) {

	const cache = new UniformsCache();

	const shadowCache = ShadowUniformsCache();

	const state = {

		version: 0,

		hash: {
			directionalLength: - 1,
			pointLength: - 1,
			spotLength: - 1,
			rectAreaLength: - 1,
			hemiLength: - 1,

			numDirectionalShadows: - 1,
			numPointShadows: - 1,
			numSpotShadows: - 1,
			numSpotMaps: - 1,

			numLightProbes: - 1
		},

		ambient: [ 0, 0, 0 ],
		probe: [],
		directional: [],
		directionalShadow: [],
		directionalShadowMap: [],
		directionalShadowMatrix: [],
		spot: [],
		spotLightMap: [],
		spotShadow: [],
		spotShadowMap: [],
		spotLightMatrix: [],
		rectArea: [],
		rectAreaLTC1: null,
		rectAreaLTC2: null,
		point: [],
		pointShadow: [],
		pointShadowMap: [],
		pointShadowMatrix: [],
		hemi: [],
		numSpotLightShadowsWithMaps: 0,
		numLightProbes: 0

	};

	for ( let i = 0; i < 9; i ++ ) state.probe.push( new Vector3() );

	const vector3 = new Vector3();
	const matrix4 = new Matrix4();
	const matrix42 = new Matrix4();

	function setup( lights, useLegacyLights ) {

		let r = 0, g = 0, b = 0;

		for ( let i = 0; i < 9; i ++ ) state.probe[ i ].set( 0, 0, 0 );

		let directionalLength = 0;
		let pointLength = 0;
		let spotLength = 0;
		let rectAreaLength = 0;
		let hemiLength = 0;

		let numDirectionalShadows = 0;
		let numPointShadows = 0;
		let numSpotShadows = 0;
		let numSpotMaps = 0;
		let numSpotShadowsWithMaps = 0;

		let numLightProbes = 0;

		// ordering : [shadow casting + map texturing, map texturing, shadow casting, none ]
		lights.sort( shadowCastingAndTexturingLightsFirst );

		// artist-friendly light intensity scaling factor
		const scaleFactor = ( useLegacyLights === true ) ? Math.PI : 1;

		for ( let i = 0, l = lights.length; i < l; i ++ ) {

			const light = lights[ i ];

			const color = light.color;
			const intensity = light.intensity;
			const distance = light.distance;

			const shadowMap = ( light.shadow && light.shadow.map ) ? light.shadow.map.texture : null;

			if ( light.isAmbientLight ) {

				r += color.r * intensity * scaleFactor;
				g += color.g * intensity * scaleFactor;
				b += color.b * intensity * scaleFactor;

			} else if ( light.isLightProbe ) {

				for ( let j = 0; j < 9; j ++ ) {

					state.probe[ j ].addScaledVector( light.sh.coefficients[ j ], intensity );

				}

				numLightProbes ++;

			} else if ( light.isDirectionalLight ) {

				const uniforms = cache.get( light );

				uniforms.color.copy( light.color ).multiplyScalar( light.intensity * scaleFactor );

				if ( light.castShadow ) {

					const shadow = light.shadow;

					const shadowUniforms = shadowCache.get( light );

					shadowUniforms.shadowBias = shadow.bias;
					shadowUniforms.shadowNormalBias = shadow.normalBias;
					shadowUniforms.shadowRadius = shadow.radius;
					shadowUniforms.shadowMapSize = shadow.mapSize;

					state.directionalShadow[ directionalLength ] = shadowUniforms;
					state.directionalShadowMap[ directionalLength ] = shadowMap;
					state.directionalShadowMatrix[ directionalLength ] = light.shadow.matrix;

					numDirectionalShadows ++;

				}

				state.directional[ directionalLength ] = uniforms;

				directionalLength ++;

			} else if ( light.isSpotLight ) {

				const uniforms = cache.get( light );

				uniforms.position.setFromMatrixPosition( light.matrixWorld );

				uniforms.color.copy( color ).multiplyScalar( intensity * scaleFactor );
				uniforms.distance = distance;

				uniforms.coneCos = Math.cos( light.angle );
				uniforms.penumbraCos = Math.cos( light.angle * ( 1 - light.penumbra ) );
				uniforms.decay = light.decay;

				state.spot[ spotLength ] = uniforms;

				const shadow = light.shadow;

				if ( light.map ) {

					state.spotLightMap[ numSpotMaps ] = light.map;
					numSpotMaps ++;

					// make sure the lightMatrix is up to date
					// TODO : do it if required only
					shadow.updateMatrices( light );

					if ( light.castShadow ) numSpotShadowsWithMaps ++;

				}

				state.spotLightMatrix[ spotLength ] = shadow.matrix;

				if ( light.castShadow ) {

					const shadowUniforms = shadowCache.get( light );

					shadowUniforms.shadowBias = shadow.bias;
					shadowUniforms.shadowNormalBias = shadow.normalBias;
					shadowUniforms.shadowRadius = shadow.radius;
					shadowUniforms.shadowMapSize = shadow.mapSize;

					state.spotShadow[ spotLength ] = shadowUniforms;
					state.spotShadowMap[ spotLength ] = shadowMap;

					numSpotShadows ++;

				}

				spotLength ++;

			} else if ( light.isRectAreaLight ) {

				const uniforms = cache.get( light );

				uniforms.color.copy( color ).multiplyScalar( intensity );

				uniforms.halfWidth.set( light.width * 0.5, 0.0, 0.0 );
				uniforms.halfHeight.set( 0.0, light.height * 0.5, 0.0 );

				state.rectArea[ rectAreaLength ] = uniforms;

				rectAreaLength ++;

			} else if ( light.isPointLight ) {

				const uniforms = cache.get( light );

				uniforms.color.copy( light.color ).multiplyScalar( light.intensity * scaleFactor );
				uniforms.distance = light.distance;
				uniforms.decay = light.decay;

				if ( light.castShadow ) {

					const shadow = light.shadow;

					const shadowUniforms = shadowCache.get( light );

					shadowUniforms.shadowBias = shadow.bias;
					shadowUniforms.shadowNormalBias = shadow.normalBias;
					shadowUniforms.shadowRadius = shadow.radius;
					shadowUniforms.shadowMapSize = shadow.mapSize;
					shadowUniforms.shadowCameraNear = shadow.camera.near;
					shadowUniforms.shadowCameraFar = shadow.camera.far;

					state.pointShadow[ pointLength ] = shadowUniforms;
					state.pointShadowMap[ pointLength ] = shadowMap;
					state.pointShadowMatrix[ pointLength ] = light.shadow.matrix;

					numPointShadows ++;

				}

				state.point[ pointLength ] = uniforms;

				pointLength ++;

			} else if ( light.isHemisphereLight ) {

				const uniforms = cache.get( light );

				uniforms.skyColor.copy( light.color ).multiplyScalar( intensity * scaleFactor );
				uniforms.groundColor.copy( light.groundColor ).multiplyScalar( intensity * scaleFactor );

				state.hemi[ hemiLength ] = uniforms;

				hemiLength ++;

			}

		}

		if ( rectAreaLength > 0 ) {

			if ( extensions.has( 'OES_texture_float_linear' ) === true ) {

				state.rectAreaLTC1 = UniformsLib.LTC_FLOAT_1;
				state.rectAreaLTC2 = UniformsLib.LTC_FLOAT_2;

			} else {

				state.rectAreaLTC1 = UniformsLib.LTC_HALF_1;
				state.rectAreaLTC2 = UniformsLib.LTC_HALF_2;

			}

		}

		state.ambient[ 0 ] = r;
		state.ambient[ 1 ] = g;
		state.ambient[ 2 ] = b;

		const hash = state.hash;

		if ( hash.directionalLength !== directionalLength ||
			hash.pointLength !== pointLength ||
			hash.spotLength !== spotLength ||
			hash.rectAreaLength !== rectAreaLength ||
			hash.hemiLength !== hemiLength ||
			hash.numDirectionalShadows !== numDirectionalShadows ||
			hash.numPointShadows !== numPointShadows ||
			hash.numSpotShadows !== numSpotShadows ||
			hash.numSpotMaps !== numSpotMaps ||
			hash.numLightProbes !== numLightProbes ) {

			state.directional.length = directionalLength;
			state.spot.length = spotLength;
			state.rectArea.length = rectAreaLength;
			state.point.length = pointLength;
			state.hemi.length = hemiLength;

			state.directionalShadow.length = numDirectionalShadows;
			state.directionalShadowMap.length = numDirectionalShadows;
			state.pointShadow.length = numPointShadows;
			state.pointShadowMap.length = numPointShadows;
			state.spotShadow.length = numSpotShadows;
			state.spotShadowMap.length = numSpotShadows;
			state.directionalShadowMatrix.length = numDirectionalShadows;
			state.pointShadowMatrix.length = numPointShadows;
			state.spotLightMatrix.length = numSpotShadows + numSpotMaps - numSpotShadowsWithMaps;
			state.spotLightMap.length = numSpotMaps;
			state.numSpotLightShadowsWithMaps = numSpotShadowsWithMaps;
			state.numLightProbes = numLightProbes;

			hash.directionalLength = directionalLength;
			hash.pointLength = pointLength;
			hash.spotLength = spotLength;
			hash.rectAreaLength = rectAreaLength;
			hash.hemiLength = hemiLength;

			hash.numDirectionalShadows = numDirectionalShadows;
			hash.numPointShadows = numPointShadows;
			hash.numSpotShadows = numSpotShadows;
			hash.numSpotMaps = numSpotMaps;

			hash.numLightProbes = numLightProbes;

			state.version = nextVersion ++;

		}

	}

	function setupView( lights, camera ) {

		let directionalLength = 0;
		let pointLength = 0;
		let spotLength = 0;
		let rectAreaLength = 0;
		let hemiLength = 0;

		const viewMatrix = camera.matrixWorldInverse;

		for ( let i = 0, l = lights.length; i < l; i ++ ) {

			const light = lights[ i ];

			if ( light.isDirectionalLight ) {

				const uniforms = state.directional[ directionalLength ];

				uniforms.direction.setFromMatrixPosition( light.matrixWorld );
				vector3.setFromMatrixPosition( light.target.matrixWorld );
				uniforms.direction.sub( vector3 );
				uniforms.direction.transformDirection( viewMatrix );

				directionalLength ++;

			} else if ( light.isSpotLight ) {

				const uniforms = state.spot[ spotLength ];

				uniforms.position.setFromMatrixPosition( light.matrixWorld );
				uniforms.position.applyMatrix4( viewMatrix );

				uniforms.direction.setFromMatrixPosition( light.matrixWorld );
				vector3.setFromMatrixPosition( light.target.matrixWorld );
				uniforms.direction.sub( vector3 );
				uniforms.direction.transformDirection( viewMatrix );

				spotLength ++;

			} else if ( light.isRectAreaLight ) {

				const uniforms = state.rectArea[ rectAreaLength ];

				uniforms.position.setFromMatrixPosition( light.matrixWorld );
				uniforms.position.applyMatrix4( viewMatrix );

				// extract local rotation of light to derive width/height half vectors
				matrix42.identity();
				matrix4.copy( light.matrixWorld );
				matrix4.premultiply( viewMatrix );
				matrix42.extractRotation( matrix4 );

				uniforms.halfWidth.set( light.width * 0.5, 0.0, 0.0 );
				uniforms.halfHeight.set( 0.0, light.height * 0.5, 0.0 );

				uniforms.halfWidth.applyMatrix4( matrix42 );
				uniforms.halfHeight.applyMatrix4( matrix42 );

				rectAreaLength ++;

			} else if ( light.isPointLight ) {

				const uniforms = state.point[ pointLength ];

				uniforms.position.setFromMatrixPosition( light.matrixWorld );
				uniforms.position.applyMatrix4( viewMatrix );

				pointLength ++;

			} else if ( light.isHemisphereLight ) {

				const uniforms = state.hemi[ hemiLength ];

				uniforms.direction.setFromMatrixPosition( light.matrixWorld );
				uniforms.direction.transformDirection( viewMatrix );

				hemiLength ++;

			}

		}

	}

	return {
		setup: setup,
		setupView: setupView,
		state: state
	};

}

function WebGLRenderState( extensions ) {

	const lights = new WebGLLights( extensions );

	const lightsArray = [];
	const shadowsArray = [];

	function init() {

		lightsArray.length = 0;
		shadowsArray.length = 0;

	}

	function pushLight( light ) {

		lightsArray.push( light );

	}

	function pushShadow( shadowLight ) {

		shadowsArray.push( shadowLight );

	}

	function setupLights( useLegacyLights ) {

		lights.setup( lightsArray, useLegacyLights );

	}

	function setupLightsView( camera ) {

		lights.setupView( lightsArray, camera );

	}

	const state = {
		lightsArray: lightsArray,
		shadowsArray: shadowsArray,

		lights: lights,

		transmissionRenderTarget: null
	};

	return {
		init: init,
		state: state,
		setupLights: setupLights,
		setupLightsView: setupLightsView,

		pushLight: pushLight,
		pushShadow: pushShadow
	};

}

function WebGLRenderStates( extensions ) {

	let renderStates = new WeakMap();

	function get( scene, renderCallDepth = 0 ) {

		const renderStateArray = renderStates.get( scene );
		let renderState;

		if ( renderStateArray === undefined ) {

			renderState = new WebGLRenderState( extensions );
			renderStates.set( scene, [ renderState ] );

		} else {

			if ( renderCallDepth >= renderStateArray.length ) {

				renderState = new WebGLRenderState( extensions );
				renderStateArray.push( renderState );

			} else {

				renderState = renderStateArray[ renderCallDepth ];

			}

		}

		return renderState;

	}

	function dispose() {

		renderStates = new WeakMap();

	}

	return {
		get: get,
		dispose: dispose
	};

}

class MeshDepthMaterial extends Material {

	constructor( parameters ) {

		super();

		this.isMeshDepthMaterial = true;

		this.type = 'MeshDepthMaterial';

		this.depthPacking = BasicDepthPacking;

		this.map = null;

		this.alphaMap = null;

		this.displacementMap = null;
		this.displacementScale = 1;
		this.displacementBias = 0;

		this.wireframe = false;
		this.wireframeLinewidth = 1;

		this.setValues( parameters );

	}

	copy( source ) {

		super.copy( source );

		this.depthPacking = source.depthPacking;

		this.map = source.map;

		this.alphaMap = source.alphaMap;

		this.displacementMap = source.displacementMap;
		this.displacementScale = source.displacementScale;
		this.displacementBias = source.displacementBias;

		this.wireframe = source.wireframe;
		this.wireframeLinewidth = source.wireframeLinewidth;

		return this;

	}

}

class MeshDistanceMaterial extends Material {

	constructor( parameters ) {

		super();

		this.isMeshDistanceMaterial = true;

		this.type = 'MeshDistanceMaterial';

		this.map = null;

		this.alphaMap = null;

		this.displacementMap = null;
		this.displacementScale = 1;
		this.displacementBias = 0;

		this.setValues( parameters );

	}

	copy( source ) {

		super.copy( source );

		this.map = source.map;

		this.alphaMap = source.alphaMap;

		this.displacementMap = source.displacementMap;
		this.displacementScale = source.displacementScale;
		this.displacementBias = source.displacementBias;

		return this;

	}

}

const vertex = "void main() {\n\tgl_Position = vec4( position, 1.0 );\n}";

const fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n\tconst float samples = float( VSM_SAMPLES );\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n\tfloat uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n\tfor ( float i = 0.0; i < samples; i ++ ) {\n\t\tfloat uvOffset = uvStart + i * uvStride;\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean / samples;\n\tsquared_mean = squared_mean / samples;\n\tfloat std_dev = sqrt( squared_mean - mean * mean );\n\tgl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";

function WebGLShadowMap( _renderer, _objects, _capabilities ) {

	let _frustum = new Frustum();

	const _shadowMapSize = new Vector2(),
		_viewportSize = new Vector2(),

		_viewport = new Vector4(),

		_depthMaterial = new MeshDepthMaterial( { depthPacking: RGBADepthPacking } ),
		_distanceMaterial = new MeshDistanceMaterial(),

		_materialCache = {},

		_maxTextureSize = _capabilities.maxTextureSize;

	const shadowSide = { [ FrontSide ]: BackSide, [ BackSide ]: FrontSide, [ DoubleSide ]: DoubleSide };

	const shadowMaterialVertical = new ShaderMaterial( {
		defines: {
			VSM_SAMPLES: 8
		},
		uniforms: {
			shadow_pass: { value: null },
			resolution: { value: new Vector2() },
			radius: { value: 4.0 }
		},

		vertexShader: vertex,
		fragmentShader: fragment

	} );

	const shadowMaterialHorizontal = shadowMaterialVertical.clone();
	shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;

	const fullScreenTri = new BufferGeometry();
	fullScreenTri.setAttribute(
		'position',
		new BufferAttribute(
			new Float32Array( [ - 1, - 1, 0.5, 3, - 1, 0.5, - 1, 3, 0.5 ] ),
			3
		)
	);

	const fullScreenMesh = new Mesh( fullScreenTri, shadowMaterialVertical );

	const scope = this;

	this.enabled = false;

	this.autoUpdate = true;
	this.needsUpdate = false;

	this.type = PCFShadowMap;
	let _previousType = this.type;

	this.render = function ( lights, scene, camera ) {

		if ( scope.enabled === false ) return;
		if ( scope.autoUpdate === false && scope.needsUpdate === false ) return;

		if ( lights.length === 0 ) return;

		const currentRenderTarget = _renderer.getRenderTarget();
		const activeCubeFace = _renderer.getActiveCubeFace();
		const activeMipmapLevel = _renderer.getActiveMipmapLevel();

		const _state = _renderer.state;

		// Set GL state for depth map.
		_state.setBlending( NoBlending );
		_state.buffers.color.setClear( 1, 1, 1, 1 );
		_state.buffers.depth.setTest( true );
		_state.setScissorTest( false );

		// check for shadow map type changes

		const toVSM = ( _previousType !== VSMShadowMap && this.type === VSMShadowMap );
		const fromVSM = ( _previousType === VSMShadowMap && this.type !== VSMShadowMap );

		// render depth map

		for ( let i = 0, il = lights.length; i < il; i ++ ) {

			const light = lights[ i ];
			const shadow = light.shadow;

			if ( shadow === undefined ) {

				console.warn( 'THREE.WebGLShadowMap:', light, 'has no shadow.' );
				continue;

			}

			if ( shadow.autoUpdate === false && shadow.needsUpdate === false ) continue;

			_shadowMapSize.copy( shadow.mapSize );

			const shadowFrameExtents = shadow.getFrameExtents();

			_shadowMapSize.multiply( shadowFrameExtents );

			_viewportSize.copy( shadow.mapSize );

			if ( _shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize ) {

				if ( _shadowMapSize.x > _maxTextureSize ) {

					_viewportSize.x = Math.floor( _maxTextureSize / shadowFrameExtents.x );
					_shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
					shadow.mapSize.x = _viewportSize.x;

				}

				if ( _shadowMapSize.y > _maxTextureSize ) {

					_viewportSize.y = Math.floor( _maxTextureSize / shadowFrameExtents.y );
					_shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
					shadow.mapSize.y = _viewportSize.y;

				}

			}

			if ( shadow.map === null || toVSM === true || fromVSM === true ) {

				const pars = ( this.type !== VSMShadowMap ) ? { minFilter: NearestFilter, magFilter: NearestFilter } : {};

				if ( shadow.map !== null ) {

					shadow.map.dispose();

				}

				shadow.map = new WebGLRenderTarget( _shadowMapSize.x, _shadowMapSize.y, pars );
				shadow.map.texture.name = light.name + '.shadowMap';

				shadow.camera.updateProjectionMatrix();

			}

			_renderer.setRenderTarget( shadow.map );
			_renderer.clear();

			const viewportCount = shadow.getViewportCount();

			for ( let vp = 0; vp < viewportCount; vp ++ ) {

				const viewport = shadow.getViewport( vp );

				_viewport.set(
					_viewportSize.x * viewport.x,
					_viewportSize.y * viewport.y,
					_viewportSize.x * viewport.z,
					_viewportSize.y * viewport.w
				);

				_state.viewport( _viewport );

				shadow.updateMatrices( light, vp );

				_frustum = shadow.getFrustum();

				renderObject( scene, camera, shadow.camera, light, this.type );

			}

			// do blur pass for VSM

			if ( shadow.isPointLightShadow !== true && this.type === VSMShadowMap ) {

				VSMPass( shadow, camera );

			}

			shadow.needsUpdate = false;

		}

		_previousType = this.type;

		scope.needsUpdate = false;

		_renderer.setRenderTarget( currentRenderTarget, activeCubeFace, activeMipmapLevel );

	};

	function VSMPass( shadow, camera ) {

		const geometry = _objects.update( fullScreenMesh );

		if ( shadowMaterialVertical.defines.VSM_SAMPLES !== shadow.blurSamples ) {

			shadowMaterialVertical.defines.VSM_SAMPLES = shadow.blurSamples;
			shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow.blurSamples;

			shadowMaterialVertical.needsUpdate = true;
			shadowMaterialHorizontal.needsUpdate = true;

		}

		if ( shadow.mapPass === null ) {

			shadow.mapPass = new WebGLRenderTarget( _shadowMapSize.x, _shadowMapSize.y );

		}

		// vertical pass

		shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
		shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
		shadowMaterialVertical.uniforms.radius.value = shadow.radius;
		_renderer.setRenderTarget( shadow.mapPass );
		_renderer.clear();
		_renderer.renderBufferDirect( camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null );

		// horizontal pass

		shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
		shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
		shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
		_renderer.setRenderTarget( shadow.map );
		_renderer.clear();
		_renderer.renderBufferDirect( camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null );

	}

	function getDepthMaterial( object, material, light, type ) {

		let result = null;

		const customMaterial = ( light.isPointLight === true ) ? object.customDistanceMaterial : object.customDepthMaterial;

		if ( customMaterial !== undefined ) {

			result = customMaterial;

		} else {

			result = ( light.isPointLight === true ) ? _distanceMaterial : _depthMaterial;

			if ( ( _renderer.localClippingEnabled && material.clipShadows === true && Array.isArray( material.clippingPlanes ) && material.clippingPlanes.length !== 0 ) ||
				( material.displacementMap && material.displacementScale !== 0 ) ||
				( material.alphaMap && material.alphaTest > 0 ) ||
				( material.map && material.alphaTest > 0 ) ) {

				// in this case we need a unique material instance reflecting the
				// appropriate state

				const keyA = result.uuid, keyB = material.uuid;

				let materialsForVariant = _materialCache[ keyA ];

				if ( materialsForVariant === undefined ) {

					materialsForVariant = {};
					_materialCache[ keyA ] = materialsForVariant;

				}

				let cachedMaterial = materialsForVariant[ keyB ];

				if ( cachedMaterial === undefined ) {

					cachedMaterial = result.clone();
					materialsForVariant[ keyB ] = cachedMaterial;
					material.addEventListener( 'dispose', onMaterialDispose );

				}

				result = cachedMaterial;

			}

		}

		result.visible = material.visible;
		result.wireframe = material.wireframe;

		if ( type === VSMShadowMap ) {

			result.side = ( material.shadowSide !== null ) ? material.shadowSide : material.side;

		} else {

			result.side = ( material.shadowSide !== null ) ? material.shadowSide : shadowSide[ material.side ];

		}

		result.alphaMap = material.alphaMap;
		result.alphaTest = material.alphaTest;
		result.map = material.map;

		result.clipShadows = material.clipShadows;
		result.clippingPlanes = material.clippingPlanes;
		result.clipIntersection = material.clipIntersection;

		result.displacementMap = material.displacementMap;
		result.displacementScale = material.displacementScale;
		result.displacementBias = material.displacementBias;

		result.wireframeLinewidth = material.wireframeLinewidth;
		result.linewidth = material.linewidth;

		if ( light.isPointLight === true && result.isMeshDistanceMaterial === true ) {

			const materialProperties = _renderer.properties.get( result );
			materialProperties.light = light;

		}

		return result;

	}

	function renderObject( object, camera, shadowCamera, light, type ) {

		if ( object.visible === false ) return;

		const visible = object.layers.test( camera.layers );

		if ( visible && ( object.isMesh || object.isLine || object.isPoints ) ) {

			if ( ( object.castShadow || ( object.receiveShadow && type === VSMShadowMap ) ) && ( ! object.frustumCulled || _frustum.intersectsObject( object ) ) ) {

				object.modelViewMatrix.multiplyMatrices( shadowCamera.matrixWorldInverse, object.matrixWorld );

				const geometry = _objects.update( object );
				const material = object.material;

				if ( Array.isArray( material ) ) {

					const groups = geometry.groups;

					for ( let k = 0, kl = groups.length; k < kl; k ++ ) {

						const group = groups[ k ];
						const groupMaterial = material[ group.materialIndex ];

						if ( groupMaterial && groupMaterial.visible ) {

							const depthMaterial = getDepthMaterial( object, groupMaterial, light, type );

							object.onBeforeShadow( _renderer, object, camera, shadowCamera, geometry, depthMaterial, group );

							_renderer.renderBufferDirect( shadowCamera, null, geometry, depthMaterial, object, group );

							object.onAfterShadow( _renderer, object, camera, shadowCamera, geometry, depthMaterial, group );

						}

					}

				} else if ( material.visible ) {

					const depthMaterial = getDepthMaterial( object, material, light, type );

					object.onBeforeShadow( _renderer, object, camera, shadowCamera, geometry, depthMaterial, null );

					_renderer.renderBufferDirect( shadowCamera, null, geometry, depthMaterial, object, null );

					object.onAfterShadow( _renderer, object, camera, shadowCamera, geometry, depthMaterial, null );

				}

			}

		}

		const children = object.children;

		for ( let i = 0, l = children.length; i < l; i ++ ) {

			renderObject( children[ i ], camera, shadowCamera, light, type );

		}

	}

	function onMaterialDispose( event ) {

		const material = event.target;

		material.removeEventListener( 'dispose', onMaterialDispose );

		// make sure to remove the unique distance/depth materials used for shadow map rendering

		for ( const id in _materialCache ) {

			const cache = _materialCache[ id ];

			const uuid = event.target.uuid;

			if ( uuid in cache ) {

				const shadowMaterial = cache[ uuid ];
				shadowMaterial.dispose();
				delete cache[ uuid ];

			}

		}

	}

}

function WebGLState( gl ) {

	function ColorBuffer() {

		let locked = false;

		const color = new Vector4();
		let currentColorMask = null;
		const currentColorClear = new Vector4( 0, 0, 0, 0 );

		return {

			setMask: function ( colorMask ) {

				if ( currentColorMask !== colorMask && ! locked ) {

					gl.colorMask( colorMask, colorMask, colorMask, colorMask );
					currentColorMask = colorMask;

				}

			},

			setLocked: function ( lock ) {

				locked = lock;

			},

			setClear: function ( r, g, b, a, premultipliedAlpha ) {

				if ( premultipliedAlpha === true ) {

					r *= a; g *= a; b *= a;

				}

				color.set( r, g, b, a );

				if ( currentColorClear.equals( color ) === false ) {

					gl.clearColor( r, g, b, a );
					currentColorClear.copy( color );

				}

			},

			reset: function () {

				locked = false;

				currentColorMask = null;
				currentColorClear.set( - 1, 0, 0, 0 ); // set to invalid state

			}

		};

	}

	function DepthBuffer() {

		let locked = false;

		let currentDepthMask = null;
		let currentDepthFunc = null;
		let currentDepthClear = null;

		return {

			setTest: function ( depthTest ) {

				if ( depthTest ) {

					enable( gl.DEPTH_TEST );

				} else {

					disable( gl.DEPTH_TEST );

				}

			},

			setMask: function ( depthMask ) {

				if ( currentDepthMask !== depthMask && ! locked ) {

					gl.depthMask( depthMask );
					currentDepthMask = depthMask;

				}

			},

			setFunc: function ( depthFunc ) {

				if ( currentDepthFunc !== depthFunc ) {

					switch ( depthFunc ) {

						case NeverDepth:

							gl.depthFunc( gl.NEVER );
							break;

						case AlwaysDepth:

							gl.depthFunc( gl.ALWAYS );
							break;

						case LessDepth:

							gl.depthFunc( gl.LESS );
							break;

						case LessEqualDepth:

							gl.depthFunc( gl.LEQUAL );
							break;

						case EqualDepth:

							gl.depthFunc( gl.EQUAL );
							break;

						case GreaterEqualDepth:

							gl.depthFunc( gl.GEQUAL );
							break;

						case GreaterDepth:

							gl.depthFunc( gl.GREATER );
							break;

						case NotEqualDepth:

							gl.depthFunc( gl.NOTEQUAL );
							break;

						default:

							gl.depthFunc( gl.LEQUAL );

					}

					currentDepthFunc = depthFunc;

				}

			},

			setLocked: function ( lock ) {

				locked = lock;

			},

			setClear: function ( depth ) {

				if ( currentDepthClear !== depth ) {

					gl.clearDepth( depth );
					currentDepthClear = depth;

				}

			},

			reset: function () {

				locked = false;

				currentDepthMask = null;
				currentDepthFunc = null;
				currentDepthClear = null;

			}

		};

	}

	function StencilBuffer() {

		let locked = false;

		let currentStencilMask = null;
		let currentStencilFunc = null;
		let currentStencilRef = null;
		let currentStencilFuncMask = null;
		let currentStencilFail = null;
		let currentStencilZFail = null;
		let currentStencilZPass = null;
		let currentStencilClear = null;

		return {

			setTest: function ( stencilTest ) {

				if ( ! locked ) {

					if ( stencilTest ) {

						enable( gl.STENCIL_TEST );

					} else {

						disable( gl.STENCIL_TEST );

					}

				}

			},

			setMask: function ( stencilMask ) {

				if ( currentStencilMask !== stencilMask && ! locked ) {

					gl.stencilMask( stencilMask );
					currentStencilMask = stencilMask;

				}

			},

			setFunc: function ( stencilFunc, stencilRef, stencilMask ) {

				if ( currentStencilFunc !== stencilFunc ||
				     currentStencilRef !== stencilRef ||
				     currentStencilFuncMask !== stencilMask ) {

					gl.stencilFunc( stencilFunc, stencilRef, stencilMask );

					currentStencilFunc = stencilFunc;
					currentStencilRef = stencilRef;
					currentStencilFuncMask = stencilMask;

				}

			},

			setOp: function ( stencilFail, stencilZFail, stencilZPass ) {

				if ( currentStencilFail !== stencilFail ||
				     currentStencilZFail !== stencilZFail ||
				     currentStencilZPass !== stencilZPass ) {

					gl.stencilOp( stencilFail, stencilZFail, stencilZPass );

					currentStencilFail = stencilFail;
					currentStencilZFail = stencilZFail;
					currentStencilZPass = stencilZPass;

				}

			},

			setLocked: function ( lock ) {

				locked = lock;

			},

			setClear: function ( stencil ) {

				if ( currentStencilClear !== stencil ) {

					gl.clearStencil( stencil );
					currentStencilClear = stencil;

				}

			},

			reset: function () {

				locked = false;

				currentStencilMask = null;
				currentStencilFunc = null;
				currentStencilRef = null;
				currentStencilFuncMask = null;
				currentStencilFail = null;
				currentStencilZFail = null;
				currentStencilZPass = null;
				currentStencilClear = null;

			}

		};

	}

	//

	const colorBuffer = new ColorBuffer();
	const depthBuffer = new DepthBuffer();
	const stencilBuffer = new StencilBuffer();

	const uboBindings = new WeakMap();
	const uboProgramMap = new WeakMap();

	let enabledCapabilities = {};

	let currentBoundFramebuffers = {};
	let currentDrawbuffers = new WeakMap();
	let defaultDrawbuffers = [];

	let currentProgram = null;

	let currentBlendingEnabled = false;
	let currentBlending = null;
	let currentBlendEquation = null;
	let currentBlendSrc = null;
	let currentBlendDst = null;
	let currentBlendEquationAlpha = null;
	let currentBlendSrcAlpha = null;
	let currentBlendDstAlpha = null;
	let currentBlendColor = new Color( 0, 0, 0 );
	let currentBlendAlpha = 0;
	let currentPremultipledAlpha = false;

	let currentFlipSided = null;
	let currentCullFace = null;

	let currentLineWidth = null;

	let currentPolygonOffsetFactor = null;
	let currentPolygonOffsetUnits = null;

	const maxTextures = gl.getParameter( gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS );

	let lineWidthAvailable = false;
	let version = 0;
	const glVersion = gl.getParameter( gl.VERSION );

	if ( glVersion.indexOf( 'WebGL' ) !== - 1 ) {

		version = parseFloat( /^WebGL (\d)/.exec( glVersion )[ 1 ] );
		lineWidthAvailable = ( version >= 1.0 );

	} else if ( glVersion.indexOf( 'OpenGL ES' ) !== - 1 ) {

		version = parseFloat( /^OpenGL ES (\d)/.exec( glVersion )[ 1 ] );
		lineWidthAvailable = ( version >= 2.0 );

	}

	let currentTextureSlot = null;
	let currentBoundTextures = {};

	const scissorParam = gl.getParameter( gl.SCISSOR_BOX );
	const viewportParam = gl.getParameter( gl.VIEWPORT );

	const currentScissor = new Vector4().fromArray( scissorParam );
	const currentViewport = new Vector4().fromArray( viewportParam );

	function createTexture( type, target, count, dimensions ) {

		const data = new Uint8Array( 4 ); // 4 is required to match default unpack alignment of 4.
		const texture = gl.createTexture();

		gl.bindTexture( type, texture );
		gl.texParameteri( type, gl.TEXTURE_MIN_FILTER, gl.NEAREST );
		gl.texParameteri( type, gl.TEXTURE_MAG_FILTER, gl.NEAREST );

		for ( let i = 0; i < count; i ++ ) {

			if ( type === gl.TEXTURE_3D || type === gl.TEXTURE_2D_ARRAY ) {

				gl.texImage3D( target, 0, gl.RGBA, 1, 1, dimensions, 0, gl.RGBA, gl.UNSIGNED_BYTE, data );

			} else {

				gl.texImage2D( target + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data );

			}

		}

		return texture;

	}

	const emptyTextures = {};
	emptyTextures[ gl.TEXTURE_2D ] = createTexture( gl.TEXTURE_2D, gl.TEXTURE_2D, 1 );
	emptyTextures[ gl.TEXTURE_CUBE_MAP ] = createTexture( gl.TEXTURE_CUBE_MAP, gl.TEXTURE_CUBE_MAP_POSITIVE_X, 6 );
	emptyTextures[ gl.TEXTURE_2D_ARRAY ] = createTexture( gl.TEXTURE_2D_ARRAY, gl.TEXTURE_2D_ARRAY, 1, 1 );
	emptyTextures[ gl.TEXTURE_3D ] = createTexture( gl.TEXTURE_3D, gl.TEXTURE_3D, 1, 1 );

	// init

	colorBuffer.setClear( 0, 0, 0, 1 );
	depthBuffer.setClear( 1 );
	stencilBuffer.setClear( 0 );

	enable( gl.DEPTH_TEST );
	depthBuffer.setFunc( LessEqualDepth );

	setFlipSided( false );
	setCullFace( CullFaceBack );
	enable( gl.CULL_FACE );

	setBlending( NoBlending );

	//

	function enable( id ) {

		if ( enabledCapabilities[ id ] !== true ) {

			gl.enable( id );
			enabledCapabilities[ id ] = true;

		}

	}

	function disable( id ) {

		if ( enabledCapabilities[ id ] !== false ) {

			gl.disable( id );
			enabledCapabilities[ id ] = false;

		}

	}

	function bindFramebuffer( target, framebuffer ) {

		if ( currentBoundFramebuffers[ target ] !== framebuffer ) {

			gl.bindFramebuffer( target, framebuffer );

			currentBoundFramebuffers[ target ] = framebuffer;

			// gl.DRAW_FRAMEBUFFER is equivalent to gl.FRAMEBUFFER

			if ( target === gl.DRAW_FRAMEBUFFER ) {

				currentBoundFramebuffers[ gl.FRAMEBUFFER ] = framebuffer;

			}

			if ( target === gl.FRAMEBUFFER ) {

				currentBoundFramebuffers[ gl.DRAW_FRAMEBUFFER ] = framebuffer;

			}

			return true;

		}

		return false;

	}

	function drawBuffers( renderTarget, framebuffer ) {

		let drawBuffers = defaultDrawbuffers;

		let needsUpdate = false;

		if ( renderTarget ) {

			drawBuffers = currentDrawbuffers.get( framebuffer );

			if ( drawBuffers === undefined ) {

				drawBuffers = [];
				currentDrawbuffers.set( framebuffer, drawBuffers );

			}

			const textures = renderTarget.textures;

			if ( drawBuffers.length !== textures.length || drawBuffers[ 0 ] !== gl.COLOR_ATTACHMENT0 ) {

				for ( let i = 0, il = textures.length; i < il; i ++ ) {

					drawBuffers[ i ] = gl.COLOR_ATTACHMENT0 + i;

				}

				drawBuffers.length = textures.length;

				needsUpdate = true;

			}

		} else {

			if ( drawBuffers[ 0 ] !== gl.BACK ) {

				drawBuffers[ 0 ] = gl.BACK;

				needsUpdate = true;

			}

		}

		if ( needsUpdate ) {

			gl.drawBuffers( drawBuffers );

		}

	}

	function useProgram( program ) {

		if ( currentProgram !== program ) {

			gl.useProgram( program );

			currentProgram = program;

			return true;

		}

		return false;

	}

	const equationToGL = {
		[ AddEquation ]: gl.FUNC_ADD,
		[ SubtractEquation ]: gl.FUNC_SUBTRACT,
		[ ReverseSubtractEquation ]: gl.FUNC_REVERSE_SUBTRACT
	};

	equationToGL[ MinEquation ] = gl.MIN;
	equationToGL[ MaxEquation ] = gl.MAX;

	const factorToGL = {
		[ ZeroFactor ]: gl.ZERO,
		[ OneFactor ]: gl.ONE,
		[ SrcColorFactor ]: gl.SRC_COLOR,
		[ SrcAlphaFactor ]: gl.SRC_ALPHA,
		[ SrcAlphaSaturateFactor ]: gl.SRC_ALPHA_SATURATE,
		[ DstColorFactor ]: gl.DST_COLOR,
		[ DstAlphaFactor ]: gl.DST_ALPHA,
		[ OneMinusSrcColorFactor ]: gl.ONE_MINUS_SRC_COLOR,
		[ OneMinusSrcAlphaFactor ]: gl.ONE_MINUS_SRC_ALPHA,
		[ OneMinusDstColorFactor ]: gl.ONE_MINUS_DST_COLOR,
		[ OneMinusDstAlphaFactor ]: gl.ONE_MINUS_DST_ALPHA,
		[ ConstantColorFactor ]: gl.CONSTANT_COLOR,
		[ OneMinusConstantColorFactor ]: gl.ONE_MINUS_CONSTANT_COLOR,
		[ ConstantAlphaFactor ]: gl.CONSTANT_ALPHA,
		[ OneMinusConstantAlphaFactor ]: gl.ONE_MINUS_CONSTANT_ALPHA
	};

	function setBlending( blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, blendColor, blendAlpha, premultipliedAlpha ) {

		if ( blending === NoBlending ) {

			if ( currentBlendingEnabled === true ) {

				disable( gl.BLEND );
				currentBlendingEnabled = false;

			}

			return;

		}

		if ( currentBlendingEnabled === false ) {

			enable( gl.BLEND );
			currentBlendingEnabled = true;

		}

		if ( blending !== CustomBlending ) {

			if ( blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha ) {

				if ( currentBlendEquation !== AddEquation || currentBlendEquationAlpha !== AddEquation ) {

					gl.blendEquation( gl.FUNC_ADD );

					currentBlendEquation = AddEquation;
					currentBlendEquationAlpha = AddEquation;

				}

				if ( premultipliedAlpha ) {

					switch ( blending ) {

						case NormalBlending:
							gl.blendFuncSeparate( gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA );
							break;

						case AdditiveBlending:
							gl.blendFunc( gl.ONE, gl.ONE );
							break;

						case SubtractiveBlending:
							gl.blendFuncSeparate( gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE );
							break;

						case MultiplyBlending:
							gl.blendFuncSeparate( gl.ZERO, gl.SRC_COLOR, gl.ZERO, gl.SRC_ALPHA );
							break;

						default:
							console.error( 'THREE.WebGLState: Invalid blending: ', blending );
							break;

					}

				} else {

					switch ( blending ) {

						case NormalBlending:
							gl.blendFuncSeparate( gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA );
							break;

						case AdditiveBlending:
							gl.blendFunc( gl.SRC_ALPHA, gl.ONE );
							break;

						case SubtractiveBlending:
							gl.blendFuncSeparate( gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE );
							break;

						case MultiplyBlending:
							gl.blendFunc( gl.ZERO, gl.SRC_COLOR );
							break;

						default:
							console.error( 'THREE.WebGLState: Invalid blending: ', blending );
							break;

					}

				}

				currentBlendSrc = null;
				currentBlendDst = null;
				currentBlendSrcAlpha = null;
				currentBlendDstAlpha = null;
				currentBlendColor.set( 0, 0, 0 );
				currentBlendAlpha = 0;

				currentBlending = blending;
				currentPremultipledAlpha = premultipliedAlpha;

			}

			return;

		}

		// custom blending

		blendEquationAlpha = blendEquationAlpha || blendEquation;
		blendSrcAlpha = blendSrcAlpha || blendSrc;
		blendDstAlpha = blendDstAlpha || blendDst;

		if ( blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha ) {

			gl.blendEquationSeparate( equationToGL[ blendEquation ], equationToGL[ blendEquationAlpha ] );

			currentBlendEquation = blendEquation;
			currentBlendEquationAlpha = blendEquationAlpha;

		}

		if ( blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha ) {

			gl.blendFuncSeparate( factorToGL[ blendSrc ], factorToGL[ blendDst ], factorToGL[ blendSrcAlpha ], factorToGL[ blendDstAlpha ] );

			currentBlendSrc = blendSrc;
			currentBlendDst = blendDst;
			currentBlendSrcAlpha = blendSrcAlpha;
			currentBlendDstAlpha = blendDstAlpha;

		}

		if ( blendColor.equals( currentBlendColor ) === false || blendAlpha !== currentBlendAlpha ) {

			gl.blendColor( blendColor.r, blendColor.g, blendColor.b, blendAlpha );

			currentBlendColor.copy( blendColor );
			currentBlendAlpha = blendAlpha;

		}

		currentBlending = blending;
		currentPremultipledAlpha = false;

	}

	function setMaterial( material, frontFaceCW ) {

		material.side === DoubleSide
			? disable( gl.CULL_FACE )
			: enable( gl.CULL_FACE );

		let flipSided = ( material.side === BackSide );
		if ( frontFaceCW ) flipSided = ! flipSided;

		setFlipSided( flipSided );

		( material.blending === NormalBlending && material.transparent === false )
			? setBlending( NoBlending )
			: setBlending( material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.blendColor, material.blendAlpha, material.premultipliedAlpha );

		depthBuffer.setFunc( material.depthFunc );
		depthBuffer.setTest( material.depthTest );
		depthBuffer.setMask( material.depthWrite );
		colorBuffer.setMask( material.colorWrite );

		const stencilWrite = material.stencilWrite;
		stencilBuffer.setTest( stencilWrite );
		if ( stencilWrite ) {

			stencilBuffer.setMask( material.stencilWriteMask );
			stencilBuffer.setFunc( material.stencilFunc, material.stencilRef, material.stencilFuncMask );
			stencilBuffer.setOp( material.stencilFail, material.stencilZFail, material.stencilZPass );

		}

		setPolygonOffset( material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits );

		material.alphaToCoverage === true
			? enable( gl.SAMPLE_ALPHA_TO_COVERAGE )
			: disable( gl.SAMPLE_ALPHA_TO_COVERAGE );

	}

	//

	function setFlipSided( flipSided ) {

		if ( currentFlipSided !== flipSided ) {

			if ( flipSided ) {

				gl.frontFace( gl.CW );

			} else {

				gl.frontFace( gl.CCW );

			}

			currentFlipSided = flipSided;

		}

	}

	function setCullFace( cullFace ) {

		if ( cullFace !== CullFaceNone ) {

			enable( gl.CULL_FACE );

			if ( cullFace !== currentCullFace ) {

				if ( cullFace === CullFaceBack ) {

					gl.cullFace( gl.BACK );

				} else if ( cullFace === CullFaceFront ) {

					gl.cullFace( gl.FRONT );

				} else {

					gl.cullFace( gl.FRONT_AND_BACK );

				}

			}

		} else {

			disable( gl.CULL_FACE );

		}

		currentCullFace = cullFace;

	}

	function setLineWidth( width ) {

		if ( width !== currentLineWidth ) {

			if ( lineWidthAvailable ) gl.lineWidth( width );

			currentLineWidth = width;

		}

	}

	function setPolygonOffset( polygonOffset, factor, units ) {

		if ( polygonOffset ) {

			enable( gl.POLYGON_OFFSET_FILL );

			if ( currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units ) {

				gl.polygonOffset( factor, units );

				currentPolygonOffsetFactor = factor;
				currentPolygonOffsetUnits = units;

			}

		} else {

			disable( gl.POLYGON_OFFSET_FILL );

		}

	}

	function setScissorTest( scissorTest ) {

		if ( scissorTest ) {

			enable( gl.SCISSOR_TEST );

		} else {

			disable( gl.SCISSOR_TEST );

		}

	}

	// texture

	function activeTexture( webglSlot ) {

		if ( webglSlot === undefined ) webglSlot = gl.TEXTURE0 + maxTextures - 1;

		if ( currentTextureSlot !== webglSlot ) {

			gl.activeTexture( webglSlot );
			currentTextureSlot = webglSlot;

		}

	}

	function bindTexture( webglType, webglTexture, webglSlot ) {

		if ( webglSlot === undefined ) {

			if ( currentTextureSlot === null ) {

				webglSlot = gl.TEXTURE0 + maxTextures - 1;

			} else {

				webglSlot = currentTextureSlot;

			}

		}

		let boundTexture = currentBoundTextures[ webglSlot ];

		if ( boundTexture === undefined ) {

			boundTexture = { type: undefined, texture: undefined };
			currentBoundTextures[ webglSlot ] = boundTexture;

		}

		if ( boundTexture.type !== webglType || boundTexture.texture !== webglTexture ) {

			if ( currentTextureSlot !== webglSlot ) {

				gl.activeTexture( webglSlot );
				currentTextureSlot = webglSlot;

			}

			gl.bindTexture( webglType, webglTexture || emptyTextures[ webglType ] );

			boundTexture.type = webglType;
			boundTexture.texture = webglTexture;

		}

	}

	function unbindTexture() {

		const boundTexture = currentBoundTextures[ currentTextureSlot ];

		if ( boundTexture !== undefined && boundTexture.type !== undefined ) {

			gl.bindTexture( boundTexture.type, null );

			boundTexture.type = undefined;
			boundTexture.texture = undefined;

		}

	}

	function compressedTexImage2D() {

		try {

			gl.compressedTexImage2D.apply( gl, arguments );

		} catch ( error ) {

			console.error( 'THREE.WebGLState:', error );

		}

	}

	function compressedTexImage3D() {

		try {

			gl.compressedTexImage3D.apply( gl, arguments );

		} catch ( error ) {

			console.error( 'THREE.WebGLState:', error );

		}

	}

	function texSubImage2D() {

		try {

			gl.texSubImage2D.apply( gl, arguments );

		} catch ( error ) {

			console.error( 'THREE.WebGLState:', error );

		}

	}

	function texSubImage3D() {

		try {

			gl.texSubImage3D.apply( gl, arguments );

		} catch ( error ) {

			console.error( 'THREE.WebGLState:', error );

		}

	}

	function compressedTexSubImage2D() {

		try {

			gl.compressedTexSubImage2D.apply( gl, arguments );

		} catch ( error ) {

			console.error( 'THREE.WebGLState:', error );

		}

	}

	function compressedTexSubImage3D() {

		try {

			gl.compressedTexSubImage3D.apply( gl, arguments );

		} catch ( error ) {

			console.error( 'THREE.WebGLState:', error );

		}

	}

	function texStorage2D() {

		try {

			gl.texStorage2D.apply( gl, arguments );

		} catch ( error ) {

			console.error( 'THREE.WebGLState:', error );

		}

	}

	function texStorage3D() {

		try {

			gl.texStorage3D.apply( gl, arguments );

		} catch ( error ) {

			console.error( 'THREE.WebGLState:', error );

		}

	}

	function texImage2D() {

		try {

			gl.texImage2D.apply( gl, arguments );

		} catch ( error ) {

			console.error( 'THREE.WebGLState:', error );

		}

	}

	function texImage3D() {

		try {

			gl.texImage3D.apply( gl, arguments );

		} catch ( error ) {

			console.error( 'THREE.WebGLState:', error );

		}

	}

	//

	function scissor( scissor ) {

		if ( currentScissor.equals( scissor ) === false ) {

			gl.scissor( scissor.x, scissor.y, scissor.z, scissor.w );
			currentScissor.copy( scissor );

		}

	}

	function viewport( viewport ) {

		if ( currentViewport.equals( viewport ) === false ) {

			gl.viewport( viewport.x, viewport.y, viewport.z, viewport.w );
			currentViewport.copy( viewport );

		}

	}

	function updateUBOMapping( uniformsGroup, program ) {

		let mapping = uboProgramMap.get( program );

		if ( mapping === undefined ) {

			mapping = new WeakMap();

			uboProgramMap.set( program, mapping );

		}

		let blockIndex = mapping.get( uniformsGroup );

		if ( blockIndex === undefined ) {

			blockIndex = gl.getUniformBlockIndex( program, uniformsGroup.name );

			mapping.set( uniformsGroup, blockIndex );

		}

	}

	function uniformBlockBinding( uniformsGroup, program ) {

		const mapping = uboProgramMap.get( program );
		const blockIndex = mapping.get( uniformsGroup );

		if ( uboBindings.get( program ) !== blockIndex ) {

			// bind shader specific block index to global block point
			gl.uniformBlockBinding( program, blockIndex, uniformsGroup.__bindingPointIndex );

			uboBindings.set( program, blockIndex );

		}

	}

	//

	function reset() {

		// reset state

		gl.disable( gl.BLEND );
		gl.disable( gl.CULL_FACE );
		gl.disable( gl.DEPTH_TEST );
		gl.disable( gl.POLYGON_OFFSET_FILL );
		gl.disable( gl.SCISSOR_TEST );
		gl.disable( gl.STENCIL_TEST );
		gl.disable( gl.SAMPLE_ALPHA_TO_COVERAGE );

		gl.blendEquation( gl.FUNC_ADD );
		gl.blendFunc( gl.ONE, gl.ZERO );
		gl.blendFuncSeparate( gl.ONE, gl.ZERO, gl.ONE, gl.ZERO );
		gl.blendColor( 0, 0, 0, 0 );

		gl.colorMask( true, true, true, true );
		gl.clearColor( 0, 0, 0, 0 );

		gl.depthMask( true );
		gl.depthFunc( gl.LESS );
		gl.clearDepth( 1 );

		gl.stencilMask( 0xffffffff );
		gl.stencilFunc( gl.ALWAYS, 0, 0xffffffff );
		gl.stencilOp( gl.KEEP, gl.KEEP, gl.KEEP );
		gl.clearStencil( 0 );

		gl.cullFace( gl.BACK );
		gl.frontFace( gl.CCW );

		gl.polygonOffset( 0, 0 );

		gl.activeTexture( gl.TEXTURE0 );

		gl.bindFramebuffer( gl.FRAMEBUFFER, null );
		gl.bindFramebuffer( gl.DRAW_FRAMEBUFFER, null );
		gl.bindFramebuffer( gl.READ_FRAMEBUFFER, null );

		gl.useProgram( null );

		gl.lineWidth( 1 );

		gl.scissor( 0, 0, gl.canvas.width, gl.canvas.height );
		gl.viewport( 0, 0, gl.canvas.width, gl.canvas.height );

		// reset internals

		enabledCapabilities = {};

		currentTextureSlot = null;
		currentBoundTextures = {};

		currentBoundFramebuffers = {};
		currentDrawbuffers = new WeakMap();
		defaultDrawbuffers = [];

		currentProgram = null;

		currentBlendingEnabled = false;
		currentBlending = null;
		currentBlendEquation = null;
		currentBlendSrc = null;
		currentBlendDst = null;
		currentBlendEquationAlpha = null;
		currentBlendSrcAlpha = null;
		currentBlendDstAlpha = null;
		currentBlendColor = new Color( 0, 0, 0 );
		currentBlendAlpha = 0;
		currentPremultipledAlpha = false;

		currentFlipSided = null;
		currentCullFace = null;

		currentLineWidth = null;

		currentPolygonOffsetFactor = null;
		currentPolygonOffsetUnits = null;

		currentScissor.set( 0, 0, gl.canvas.width, gl.canvas.height );
		currentViewport.set( 0, 0, gl.canvas.width, gl.canvas.height );

		colorBuffer.reset();
		depthBuffer.reset();
		stencilBuffer.reset();

	}

	return {

		buffers: {
			color: colorBuffer,
			depth: depthBuffer,
			stencil: stencilBuffer
		},

		enable: enable,
		disable: disable,

		bindFramebuffer: bindFramebuffer,
		drawBuffers: drawBuffers,

		useProgram: useProgram,

		setBlending: setBlending,
		setMaterial: setMaterial,

		setFlipSided: setFlipSided,
		setCullFace: setCullFace,

		setLineWidth: setLineWidth,
		setPolygonOffset: setPolygonOffset,

		setScissorTest: setScissorTest,

		activeTexture: activeTexture,
		bindTexture: bindTexture,
		unbindTexture: unbindTexture,
		compressedTexImage2D: compressedTexImage2D,
		compressedTexImage3D: compressedTexImage3D,
		texImage2D: texImage2D,
		texImage3D: texImage3D,

		updateUBOMapping: updateUBOMapping,
		uniformBlockBinding: uniformBlockBinding,

		texStorage2D: texStorage2D,
		texStorage3D: texStorage3D,
		texSubImage2D: texSubImage2D,
		texSubImage3D: texSubImage3D,
		compressedTexSubImage2D: compressedTexSubImage2D,
		compressedTexSubImage3D: compressedTexSubImage3D,

		scissor: scissor,
		viewport: viewport,

		reset: reset

	};

}

function WebGLTextures( _gl, extensions, state, properties, capabilities, utils, info ) {

	const multisampledRTTExt = extensions.has( 'WEBGL_multisampled_render_to_texture' ) ? extensions.get( 'WEBGL_multisampled_render_to_texture' ) : null;
	const supportsInvalidateFramebuffer = typeof navigator === 'undefined' ? false : /OculusBrowser/g.test( navigator.userAgent );

	const _imageDimensions = new Vector2();
	const _videoTextures = new WeakMap();
	let _canvas;

	const _sources = new WeakMap(); // maps WebglTexture objects to instances of Source

	// cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
	// also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
	// Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).

	let useOffscreenCanvas = false;

	try {

		useOffscreenCanvas = typeof OffscreenCanvas !== 'undefined'
			// eslint-disable-next-line compat/compat
			&& ( new OffscreenCanvas( 1, 1 ).getContext( '2d' ) ) !== null;

	} catch ( err ) {

		// Ignore any errors

	}

	function createCanvas( width, height ) {

		// Use OffscreenCanvas when available. Specially needed in web workers

		return useOffscreenCanvas ?
			// eslint-disable-next-line compat/compat
			new OffscreenCanvas( width, height ) : createElementNS( 'canvas' );

	}

	function resizeImage( image, needsNewCanvas, maxSize ) {

		let scale = 1;

		const dimensions = getDimensions( image );

		// handle case if texture exceeds max size

		if ( dimensions.width > maxSize || dimensions.height > maxSize ) {

			scale = maxSize / Math.max( dimensions.width, dimensions.height );

		}

		// only perform resize if necessary

		if ( scale < 1 ) {

			// only perform resize for certain image types

			if ( ( typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement ) ||
				( typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement ) ||
				( typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap ) ||
				( typeof VideoFrame !== 'undefined' && image instanceof VideoFrame ) ) {

				const width = Math.floor( scale * dimensions.width );
				const height = Math.floor( scale * dimensions.height );

				if ( _canvas === undefined ) _canvas = createCanvas( width, height );

				// cube textures can't reuse the same canvas

				const canvas = needsNewCanvas ? createCanvas( width, height ) : _canvas;

				canvas.width = width;
				canvas.height = height;

				const context = canvas.getContext( '2d' );
				context.drawImage( image, 0, 0, width, height );

				console.warn( 'THREE.WebGLRenderer: Texture has been resized from (' + dimensions.width + 'x' + dimensions.height + ') to (' + width + 'x' + height + ').' );

				return canvas;

			} else {

				if ( 'data' in image ) {

					console.warn( 'THREE.WebGLRenderer: Image in DataTexture is too big (' + dimensions.width + 'x' + dimensions.height + ').' );

				}

				return image;

			}

		}

		return image;

	}

	function textureNeedsGenerateMipmaps( texture ) {

		return texture.generateMipmaps && texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter;

	}

	function generateMipmap( target ) {

		_gl.generateMipmap( target );

	}

	function getInternalFormat( internalFormatName, glFormat, glType, colorSpace, forceLinearTransfer = false ) {

		if ( internalFormatName !== null ) {

			if ( _gl[ internalFormatName ] !== undefined ) return _gl[ internalFormatName ];

			console.warn( 'THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format \'' + internalFormatName + '\'' );

		}

		let internalFormat = glFormat;

		if ( glFormat === _gl.RED ) {

			if ( glType === _gl.FLOAT ) internalFormat = _gl.R32F;
			if ( glType === _gl.HALF_FLOAT ) internalFormat = _gl.R16F;
			if ( glType === _gl.UNSIGNED_BYTE ) internalFormat = _gl.R8;

		}

		if ( glFormat === _gl.RED_INTEGER ) {

			if ( glType === _gl.UNSIGNED_BYTE ) internalFormat = _gl.R8UI;
			if ( glType === _gl.UNSIGNED_SHORT ) internalFormat = _gl.R16UI;
			if ( glType === _gl.UNSIGNED_INT ) internalFormat = _gl.R32UI;
			if ( glType === _gl.BYTE ) internalFormat = _gl.R8I;
			if ( glType === _gl.SHORT ) internalFormat = _gl.R16I;
			if ( glType === _gl.INT ) internalFormat = _gl.R32I;

		}

		if ( glFormat === _gl.RG ) {

			if ( glType === _gl.FLOAT ) internalFormat = _gl.RG32F;
			if ( glType === _gl.HALF_FLOAT ) internalFormat = _gl.RG16F;
			if ( glType === _gl.UNSIGNED_BYTE ) internalFormat = _gl.RG8;

		}

		if ( glFormat === _gl.RG_INTEGER ) {

			if ( glType === _gl.UNSIGNED_BYTE ) internalFormat = _gl.RG8UI;
			if ( glType === _gl.UNSIGNED_SHORT ) internalFormat = _gl.RG16UI;
			if ( glType === _gl.UNSIGNED_INT ) internalFormat = _gl.RG32UI;
			if ( glType === _gl.BYTE ) internalFormat = _gl.RG8I;
			if ( glType === _gl.SHORT ) internalFormat = _gl.RG16I;
			if ( glType === _gl.INT ) internalFormat = _gl.RG32I;

		}

		if ( glFormat === _gl.RGB ) {

			if ( glType === _gl.UNSIGNED_INT_5_9_9_9_REV ) internalFormat = _gl.RGB9_E5;

		}

		if ( glFormat === _gl.RGBA ) {

			const transfer = forceLinearTransfer ? LinearTransfer : ColorManagement.getTransfer( colorSpace );

			if ( glType === _gl.FLOAT ) internalFormat = _gl.RGBA32F;
			if ( glType === _gl.HALF_FLOAT ) internalFormat = _gl.RGBA16F;
			if ( glType === _gl.UNSIGNED_BYTE ) internalFormat = ( transfer === SRGBTransfer ) ? _gl.SRGB8_ALPHA8 : _gl.RGBA8;
			if ( glType === _gl.UNSIGNED_SHORT_4_4_4_4 ) internalFormat = _gl.RGBA4;
			if ( glType === _gl.UNSIGNED_SHORT_5_5_5_1 ) internalFormat = _gl.RGB5_A1;

		}

		if ( internalFormat === _gl.R16F || internalFormat === _gl.R32F ||
			internalFormat === _gl.RG16F || internalFormat === _gl.RG32F ||
			internalFormat === _gl.RGBA16F || internalFormat === _gl.RGBA32F ) {

			extensions.get( 'EXT_color_buffer_float' );

		}

		return internalFormat;

	}

	function getMipLevels( texture, image ) {

		if ( textureNeedsGenerateMipmaps( texture ) === true || ( texture.isFramebufferTexture && texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter ) ) {

			return Math.log2( Math.max( image.width, image.height ) ) + 1;

		} else if ( texture.mipmaps !== undefined && texture.mipmaps.length > 0 ) {

			// user-defined mipmaps

			return texture.mipmaps.length;

		} else if ( texture.isCompressedTexture && Array.isArray( texture.image ) ) {

			return image.mipmaps.length;

		} else {

			// texture without mipmaps (only base level)

			return 1;

		}

	}

	//

	function onTextureDispose( event ) {

		const texture = event.target;

		texture.removeEventListener( 'dispose', onTextureDispose );

		deallocateTexture( texture );

		if ( texture.isVideoTexture ) {

			_videoTextures.delete( texture );

		}

	}

	function onRenderTargetDispose( event ) {

		const renderTarget = event.target;

		renderTarget.removeEventListener( 'dispose', onRenderTargetDispose );

		deallocateRenderTarget( renderTarget );

	}

	//

	function deallocateTexture( texture ) {

		const textureProperties = properties.get( texture );

		if ( textureProperties.__webglInit === undefined ) return;

		// check if it's necessary to remove the WebGLTexture object

		const source = texture.source;
		const webglTextures = _sources.get( source );

		if ( webglTextures ) {

			const webglTexture = webglTextures[ textureProperties.__cacheKey ];
			webglTexture.usedTimes --;

			// the WebGLTexture object is not used anymore, remove it

			if ( webglTexture.usedTimes === 0 ) {

				deleteTexture( texture );

			}

			// remove the weak map entry if no WebGLTexture uses the source anymore

			if ( Object.keys( webglTextures ).length === 0 ) {

				_sources.delete( source );

			}

		}

		properties.remove( texture );

	}

	function deleteTexture( texture ) {

		const textureProperties = properties.get( texture );
		_gl.deleteTexture( textureProperties.__webglTexture );

		const source = texture.source;
		const webglTextures = _sources.get( source );
		delete webglTextures[ textureProperties.__cacheKey ];

		info.memory.textures --;

	}

	function deallocateRenderTarget( renderTarget ) {

		const renderTargetProperties = properties.get( renderTarget );

		if ( renderTarget.depthTexture ) {

			renderTarget.depthTexture.dispose();

		}

		if ( renderTarget.isWebGLCubeRenderTarget ) {

			for ( let i = 0; i < 6; i ++ ) {

				if ( Array.isArray( renderTargetProperties.__webglFramebuffer[ i ] ) ) {

					for ( let level = 0; level < renderTargetProperties.__webglFramebuffer[ i ].length; level ++ ) _gl.deleteFramebuffer( renderTargetProperties.__webglFramebuffer[ i ][ level ] );

				} else {

					_gl.deleteFramebuffer( renderTargetProperties.__webglFramebuffer[ i ] );

				}

				if ( renderTargetProperties.__webglDepthbuffer ) _gl.deleteRenderbuffer( renderTargetProperties.__webglDepthbuffer[ i ] );

			}

		} else {

			if ( Array.isArray( renderTargetProperties.__webglFramebuffer ) ) {

				for ( let level = 0; level < renderTargetProperties.__webglFramebuffer.length; level ++ ) _gl.deleteFramebuffer( renderTargetProperties.__webglFramebuffer[ level ] );

			} else {

				_gl.deleteFramebuffer( renderTargetProperties.__webglFramebuffer );

			}

			if ( renderTargetProperties.__webglDepthbuffer ) _gl.deleteRenderbuffer( renderTargetProperties.__webglDepthbuffer );
			if ( renderTargetProperties.__webglMultisampledFramebuffer ) _gl.deleteFramebuffer( renderTargetProperties.__webglMultisampledFramebuffer );

			if ( renderTargetProperties.__webglColorRenderbuffer ) {

				for ( let i = 0; i < renderTargetProperties.__webglColorRenderbuffer.length; i ++ ) {

					if ( renderTargetProperties.__webglColorRenderbuffer[ i ] ) _gl.deleteRenderbuffer( renderTargetProperties.__webglColorRenderbuffer[ i ] );

				}

			}

			if ( renderTargetProperties.__webglDepthRenderbuffer ) _gl.deleteRenderbuffer( renderTargetProperties.__webglDepthRenderbuffer );

		}

		const textures = renderTarget.textures;

		for ( let i = 0, il = textures.length; i < il; i ++ ) {

			const attachmentProperties = properties.get( textures[ i ] );

			if ( attachmentProperties.__webglTexture ) {

				_gl.deleteTexture( attachmentProperties.__webglTexture );

				info.memory.textures --;

			}

			properties.remove( textures[ i ] );

		}

		properties.remove( renderTarget );

	}

	//

	let textureUnits = 0;

	function resetTextureUnits() {

		textureUnits = 0;

	}

	function allocateTextureUnit() {

		const textureUnit = textureUnits;

		if ( textureUnit >= capabilities.maxTextures ) {

			console.warn( 'THREE.WebGLTextures: Trying to use ' + textureUnit + ' texture units while this GPU supports only ' + capabilities.maxTextures );

		}

		textureUnits += 1;

		return textureUnit;

	}

	function getTextureCacheKey( texture ) {

		const array = [];

		array.push( texture.wrapS );
		array.push( texture.wrapT );
		array.push( texture.wrapR || 0 );
		array.push( texture.magFilter );
		array.push( texture.minFilter );
		array.push( texture.anisotropy );
		array.push( texture.internalFormat );
		array.push( texture.format );
		array.push( texture.type );
		array.push( texture.generateMipmaps );
		array.push( texture.premultiplyAlpha );
		array.push( texture.flipY );
		array.push( texture.unpackAlignment );
		array.push( texture.colorSpace );

		return array.join();

	}

	//

	function setTexture2D( texture, slot ) {

		const textureProperties = properties.get( texture );

		if ( texture.isVideoTexture ) updateVideoTexture( texture );

		if ( texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version ) {

			const image = texture.image;

			if ( image === null ) {

				console.warn( 'THREE.WebGLRenderer: Texture marked for update but no image data found.' );

			} else if ( image.complete === false ) {

				console.warn( 'THREE.WebGLRenderer: Texture marked for update but image is incomplete' );

			} else {

				uploadTexture( textureProperties, texture, slot );
				return;

			}

		}

		state.bindTexture( _gl.TEXTURE_2D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot );

	}

	function setTexture2DArray( texture, slot ) {

		const textureProperties = properties.get( texture );

		if ( texture.version > 0 && textureProperties.__version !== texture.version ) {

			uploadTexture( textureProperties, texture, slot );
			return;

		}

		state.bindTexture( _gl.TEXTURE_2D_ARRAY, textureProperties.__webglTexture, _gl.TEXTURE0 + slot );

	}

	function setTexture3D( texture, slot ) {

		const textureProperties = properties.get( texture );

		if ( texture.version > 0 && textureProperties.__version !== texture.version ) {

			uploadTexture( textureProperties, texture, slot );
			return;

		}

		state.bindTexture( _gl.TEXTURE_3D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot );

	}

	function setTextureCube( texture, slot ) {

		const textureProperties = properties.get( texture );

		if ( texture.version > 0 && textureProperties.__version !== texture.version ) {

			uploadCubeTexture( textureProperties, texture, slot );
			return;

		}

		state.bindTexture( _gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot );

	}

	const wrappingToGL = {
		[ RepeatWrapping ]: _gl.REPEAT,
		[ ClampToEdgeWrapping ]: _gl.CLAMP_TO_EDGE,
		[ MirroredRepeatWrapping ]: _gl.MIRRORED_REPEAT
	};

	const filterToGL = {
		[ NearestFilter ]: _gl.NEAREST,
		[ NearestMipmapNearestFilter ]: _gl.NEAREST_MIPMAP_NEAREST,
		[ NearestMipmapLinearFilter ]: _gl.NEAREST_MIPMAP_LINEAR,

		[ LinearFilter ]: _gl.LINEAR,
		[ LinearMipmapNearestFilter ]: _gl.LINEAR_MIPMAP_NEAREST,
		[ LinearMipmapLinearFilter ]: _gl.LINEAR_MIPMAP_LINEAR
	};

	const compareToGL = {
		[ NeverCompare ]: _gl.NEVER,
		[ AlwaysCompare ]: _gl.ALWAYS,
		[ LessCompare ]: _gl.LESS,
		[ LessEqualCompare ]: _gl.LEQUAL,
		[ EqualCompare ]: _gl.EQUAL,
		[ GreaterEqualCompare ]: _gl.GEQUAL,
		[ GreaterCompare ]: _gl.GREATER,
		[ NotEqualCompare ]: _gl.NOTEQUAL
	};

	function setTextureParameters( textureType, texture ) {

		if ( texture.type === FloatType && extensions.has( 'OES_texture_float_linear' ) === false &&
			( texture.magFilter === LinearFilter || texture.magFilter === LinearMipmapNearestFilter || texture.magFilter === NearestMipmapLinearFilter || texture.magFilter === LinearMipmapLinearFilter ||
			texture.minFilter === LinearFilter || texture.minFilter === LinearMipmapNearestFilter || texture.minFilter === NearestMipmapLinearFilter || texture.minFilter === LinearMipmapLinearFilter ) ) {

			console.warn( 'THREE.WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device.' );

		}

		_gl.texParameteri( textureType, _gl.TEXTURE_WRAP_S, wrappingToGL[ texture.wrapS ] );
		_gl.texParameteri( textureType, _gl.TEXTURE_WRAP_T, wrappingToGL[ texture.wrapT ] );

		if ( textureType === _gl.TEXTURE_3D || textureType === _gl.TEXTURE_2D_ARRAY ) {

			_gl.texParameteri( textureType, _gl.TEXTURE_WRAP_R, wrappingToGL[ texture.wrapR ] );

		}

		_gl.texParameteri( textureType, _gl.TEXTURE_MAG_FILTER, filterToGL[ texture.magFilter ] );
		_gl.texParameteri( textureType, _gl.TEXTURE_MIN_FILTER, filterToGL[ texture.minFilter ] );

		if ( texture.compareFunction ) {

			_gl.texParameteri( textureType, _gl.TEXTURE_COMPARE_MODE, _gl.COMPARE_REF_TO_TEXTURE );
			_gl.texParameteri( textureType, _gl.TEXTURE_COMPARE_FUNC, compareToGL[ texture.compareFunction ] );

		}

		if ( extensions.has( 'EXT_texture_filter_anisotropic' ) === true ) {

			if ( texture.magFilter === NearestFilter ) return;
			if ( texture.minFilter !== NearestMipmapLinearFilter && texture.minFilter !== LinearMipmapLinearFilter ) return;
			if ( texture.type === FloatType && extensions.has( 'OES_texture_float_linear' ) === false ) return; // verify extension

			if ( texture.anisotropy > 1 || properties.get( texture ).__currentAnisotropy ) {

				const extension = extensions.get( 'EXT_texture_filter_anisotropic' );
				_gl.texParameterf( textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min( texture.anisotropy, capabilities.getMaxAnisotropy() ) );
				properties.get( texture ).__currentAnisotropy = texture.anisotropy;

			}

		}

	}

	function initTexture( textureProperties, texture ) {

		let forceUpload = false;

		if ( textureProperties.__webglInit === undefined ) {

			textureProperties.__webglInit = true;

			texture.addEventListener( 'dispose', onTextureDispose );

		}

		// create Source <-> WebGLTextures mapping if necessary

		const source = texture.source;
		let webglTextures = _sources.get( source );

		if ( webglTextures === undefined ) {

			webglTextures = {};
			_sources.set( source, webglTextures );

		}

		// check if there is already a WebGLTexture object for the given texture parameters

		const textureCacheKey = getTextureCacheKey( texture );

		if ( textureCacheKey !== textureProperties.__cacheKey ) {

			// if not, create a new instance of WebGLTexture

			if ( webglTextures[ textureCacheKey ] === undefined ) {

				// create new entry

				webglTextures[ textureCacheKey ] = {
					texture: _gl.createTexture(),
					usedTimes: 0
				};

				info.memory.textures ++;

				// when a new instance of WebGLTexture was created, a texture upload is required
				// even if the image contents are identical

				forceUpload = true;

			}

			webglTextures[ textureCacheKey ].usedTimes ++;

			// every time the texture cache key changes, it's necessary to check if an instance of
			// WebGLTexture can be deleted in order to avoid a memory leak.

			const webglTexture = webglTextures[ textureProperties.__cacheKey ];

			if ( webglTexture !== undefined ) {

				webglTextures[ textureProperties.__cacheKey ].usedTimes --;

				if ( webglTexture.usedTimes === 0 ) {

					deleteTexture( texture );

				}

			}

			// store references to cache key and WebGLTexture object

			textureProperties.__cacheKey = textureCacheKey;
			textureProperties.__webglTexture = webglTextures[ textureCacheKey ].texture;

		}

		return forceUpload;

	}

	function uploadTexture( textureProperties, texture, slot ) {

		let textureType = _gl.TEXTURE_2D;

		if ( texture.isDataArrayTexture || texture.isCompressedArrayTexture ) textureType = _gl.TEXTURE_2D_ARRAY;
		if ( texture.isData3DTexture ) textureType = _gl.TEXTURE_3D;

		const forceUpload = initTexture( textureProperties, texture );
		const source = texture.source;

		state.bindTexture( textureType, textureProperties.__webglTexture, _gl.TEXTURE0 + slot );

		const sourceProperties = properties.get( source );

		if ( source.version !== sourceProperties.__version || forceUpload === true ) {

			state.activeTexture( _gl.TEXTURE0 + slot );

			const workingPrimaries = ColorManagement.getPrimaries( ColorManagement.workingColorSpace );
			const texturePrimaries = texture.colorSpace === NoColorSpace ? null : ColorManagement.getPrimaries( texture.colorSpace );
			const unpackConversion = texture.colorSpace === NoColorSpace || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;

			_gl.pixelStorei( _gl.UNPACK_FLIP_Y_WEBGL, texture.flipY );
			_gl.pixelStorei( _gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha );
			_gl.pixelStorei( _gl.UNPACK_ALIGNMENT, texture.unpackAlignment );
			_gl.pixelStorei( _gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion );

			let image = resizeImage( texture.image, false, capabilities.maxTextureSize );
			image = verifyColorSpace( texture, image );

			const glFormat = utils.convert( texture.format, texture.colorSpace );

			const glType = utils.convert( texture.type );
			let glInternalFormat = getInternalFormat( texture.internalFormat, glFormat, glType, texture.colorSpace, texture.isVideoTexture );

			setTextureParameters( textureType, texture );

			let mipmap;
			const mipmaps = texture.mipmaps;

			const useTexStorage = ( texture.isVideoTexture !== true && glInternalFormat !== RGB_ETC1_Format );
			const allocateMemory = ( sourceProperties.__version === undefined ) || ( forceUpload === true );
			const dataReady = source.dataReady;
			const levels = getMipLevels( texture, image );

			if ( texture.isDepthTexture ) {

				// populate depth texture with dummy data

				glInternalFormat = _gl.DEPTH_COMPONENT16;

				if ( texture.type === FloatType ) {

					glInternalFormat = _gl.DEPTH_COMPONENT32F;

				} else if ( texture.type === UnsignedIntType ) {

					glInternalFormat = _gl.DEPTH_COMPONENT24;

				} else if ( texture.type === UnsignedInt248Type ) {

					glInternalFormat = _gl.DEPTH24_STENCIL8;

				}

				//

				if ( allocateMemory ) {

					if ( useTexStorage ) {

						state.texStorage2D( _gl.TEXTURE_2D, 1, glInternalFormat, image.width, image.height );

					} else {

						state.texImage2D( _gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null );

					}

				}

			} else if ( texture.isDataTexture ) {

				// use manually created mipmaps if available
				// if there are no manual mipmaps
				// set 0 level mipmap and then use GL to generate other mipmap levels

				if ( mipmaps.length > 0 ) {

					if ( useTexStorage && allocateMemory ) {

						state.texStorage2D( _gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[ 0 ].width, mipmaps[ 0 ].height );

					}

					for ( let i = 0, il = mipmaps.length; i < il; i ++ ) {

						mipmap = mipmaps[ i ];

						if ( useTexStorage ) {

							if ( dataReady ) {

								state.texSubImage2D( _gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data );

							}

						} else {

							state.texImage2D( _gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data );

						}

					}

					texture.generateMipmaps = false;

				} else {

					if ( useTexStorage ) {

						if ( allocateMemory ) {

							state.texStorage2D( _gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height );

						}

						if ( dataReady ) {

							state.texSubImage2D( _gl.TEXTURE_2D, 0, 0, 0, image.width, image.height, glFormat, glType, image.data );

						}

					} else {

						state.texImage2D( _gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data );

					}

				}

			} else if ( texture.isCompressedTexture ) {

				if ( texture.isCompressedArrayTexture ) {

					if ( useTexStorage && allocateMemory ) {

						state.texStorage3D( _gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, mipmaps[ 0 ].width, mipmaps[ 0 ].height, image.depth );

					}

					for ( let i = 0, il = mipmaps.length; i < il; i ++ ) {

						mipmap = mipmaps[ i ];

						if ( texture.format !== RGBAFormat ) {

							if ( glFormat !== null ) {

								if ( useTexStorage ) {

									if ( dataReady ) {

										state.compressedTexSubImage3D( _gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, mipmap.data, 0, 0 );

									}

								} else {

									state.compressedTexImage3D( _gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, mipmap.data, 0, 0 );

								}

							} else {

								console.warn( 'THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()' );

							}

						} else {

							if ( useTexStorage ) {

								if ( dataReady ) {

									state.texSubImage3D( _gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, glType, mipmap.data );

								}

							} else {

								state.texImage3D( _gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, glFormat, glType, mipmap.data );

							}

						}

					}

				} else {

					if ( useTexStorage && allocateMemory ) {

						state.texStorage2D( _gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[ 0 ].width, mipmaps[ 0 ].height );

					}

					for ( let i = 0, il = mipmaps.length; i < il; i ++ ) {

						mipmap = mipmaps[ i ];

						if ( texture.format !== RGBAFormat ) {

							if ( glFormat !== null ) {

								if ( useTexStorage ) {

									if ( dataReady ) {

										state.compressedTexSubImage2D( _gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data );

									}

								} else {

									state.compressedTexImage2D( _gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data );

								}

							} else {

								console.warn( 'THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()' );

							}

						} else {

							if ( useTexStorage ) {

								if ( dataReady ) {

									state.texSubImage2D( _gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data );

								}

							} else {

								state.texImage2D( _gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data );

							}

						}

					}

				}

			} else if ( texture.isDataArrayTexture ) {

				if ( useTexStorage ) {

					if ( allocateMemory ) {

						state.texStorage3D( _gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, image.width, image.height, image.depth );

					}

					if ( dataReady ) {

						state.texSubImage3D( _gl.TEXTURE_2D_ARRAY, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data );

					}

				} else {

					state.texImage3D( _gl.TEXTURE_2D_ARRAY, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data );

				}

			} else if ( texture.isData3DTexture ) {

				if ( useTexStorage ) {

					if ( allocateMemory ) {

						state.texStorage3D( _gl.TEXTURE_3D, levels, glInternalFormat, image.width, image.height, image.depth );

					}

					if ( dataReady ) {

						state.texSubImage3D( _gl.TEXTURE_3D, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data );

					}

				} else {

					state.texImage3D( _gl.TEXTURE_3D, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data );

				}

			} else if ( texture.isFramebufferTexture ) {

				if ( allocateMemory ) {

					if ( useTexStorage ) {

						state.texStorage2D( _gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height );

					} else {

						let width = image.width, height = image.height;

						for ( let i = 0; i < levels; i ++ ) {

							state.texImage2D( _gl.TEXTURE_2D, i, glInternalFormat, width, height, 0, glFormat, glType, null );

							width >>= 1;
							height >>= 1;

						}

					}

				}

			} else {

				// regular Texture (image, video, canvas)

				// use manually created mipmaps if available
				// if there are no manual mipmaps
				// set 0 level mipmap and then use GL to generate other mipmap levels

				if ( mipmaps.length > 0 ) {

					if ( useTexStorage && allocateMemory ) {

						const dimensions = getDimensions( mipmaps[ 0 ] );

						state.texStorage2D( _gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height );

					}

					for ( let i = 0, il = mipmaps.length; i < il; i ++ ) {

						mipmap = mipmaps[ i ];

						if ( useTexStorage ) {

							if ( dataReady ) {

								state.texSubImage2D( _gl.TEXTURE_2D, i, 0, 0, glFormat, glType, mipmap );

							}

						} else {

							state.texImage2D( _gl.TEXTURE_2D, i, glInternalFormat, glFormat, glType, mipmap );

						}

					}

					texture.generateMipmaps = false;

				} else {

					if ( useTexStorage ) {

						if ( allocateMemory ) {

							const dimensions = getDimensions( image );

							state.texStorage2D( _gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height );

						}

						if ( dataReady ) {

							state.texSubImage2D( _gl.TEXTURE_2D, 0, 0, 0, glFormat, glType, image );

						}

					} else {

						state.texImage2D( _gl.TEXTURE_2D, 0, glInternalFormat, glFormat, glType, image );

					}

				}

			}

			if ( textureNeedsGenerateMipmaps( texture ) ) {

				generateMipmap( textureType );

			}

			sourceProperties.__version = source.version;

			if ( texture.onUpdate ) texture.onUpdate( texture );

		}

		textureProperties.__version = texture.version;

	}

	function uploadCubeTexture( textureProperties, texture, slot ) {

		if ( texture.image.length !== 6 ) return;

		const forceUpload = initTexture( textureProperties, texture );
		const source = texture.source;

		state.bindTexture( _gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot );

		const sourceProperties = properties.get( source );

		if ( source.version !== sourceProperties.__version || forceUpload === true ) {

			state.activeTexture( _gl.TEXTURE0 + slot );

			const workingPrimaries = ColorManagement.getPrimaries( ColorManagement.workingColorSpace );
			const texturePrimaries = texture.colorSpace === NoColorSpace ? null : ColorManagement.getPrimaries( texture.colorSpace );
			const unpackConversion = texture.colorSpace === NoColorSpace || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;

			_gl.pixelStorei( _gl.UNPACK_FLIP_Y_WEBGL, texture.flipY );
			_gl.pixelStorei( _gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha );
			_gl.pixelStorei( _gl.UNPACK_ALIGNMENT, texture.unpackAlignment );
			_gl.pixelStorei( _gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion );

			const isCompressed = ( texture.isCompressedTexture || texture.image[ 0 ].isCompressedTexture );
			const isDataTexture = ( texture.image[ 0 ] && texture.image[ 0 ].isDataTexture );

			const cubeImage = [];

			for ( let i = 0; i < 6; i ++ ) {

				if ( ! isCompressed && ! isDataTexture ) {

					cubeImage[ i ] = resizeImage( texture.image[ i ], true, capabilities.maxCubemapSize );

				} else {

					cubeImage[ i ] = isDataTexture ? texture.image[ i ].image : texture.image[ i ];

				}

				cubeImage[ i ] = verifyColorSpace( texture, cubeImage[ i ] );

			}

			const image = cubeImage[ 0 ],
				glFormat = utils.convert( texture.format, texture.colorSpace ),
				glType = utils.convert( texture.type ),
				glInternalFormat = getInternalFormat( texture.internalFormat, glFormat, glType, texture.colorSpace );

			const useTexStorage = ( texture.isVideoTexture !== true );
			const allocateMemory = ( sourceProperties.__version === undefined ) || ( forceUpload === true );
			const dataReady = source.dataReady;
			let levels = getMipLevels( texture, image );

			setTextureParameters( _gl.TEXTURE_CUBE_MAP, texture );

			let mipmaps;

			if ( isCompressed ) {

				if ( useTexStorage && allocateMemory ) {

					state.texStorage2D( _gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, image.width, image.height );

				}

				for ( let i = 0; i < 6; i ++ ) {

					mipmaps = cubeImage[ i ].mipmaps;

					for ( let j = 0; j < mipmaps.length; j ++ ) {

						const mipmap = mipmaps[ j ];

						if ( texture.format !== RGBAFormat ) {

							if ( glFormat !== null ) {

								if ( useTexStorage ) {

									if ( dataReady ) {

										state.compressedTexSubImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data );

									}

								} else {

									state.compressedTexImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data );

								}

							} else {

								console.warn( 'THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()' );

							}

						} else {

							if ( useTexStorage ) {

								if ( dataReady ) {

									state.texSubImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data );

								}

							} else {

								state.texImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data );

							}

						}

					}

				}

			} else {

				mipmaps = texture.mipmaps;

				if ( useTexStorage && allocateMemory ) {

					// TODO: Uniformly handle mipmap definitions
					// Normal textures and compressed cube textures define base level + mips with their mipmap array
					// Uncompressed cube textures use their mipmap array only for mips (no base level)

					if ( mipmaps.length > 0 ) levels ++;

					const dimensions = getDimensions( cubeImage[ 0 ] );

					state.texStorage2D( _gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, dimensions.width, dimensions.height );

				}

				for ( let i = 0; i < 6; i ++ ) {

					if ( isDataTexture ) {

						if ( useTexStorage ) {

							if ( dataReady ) {

								state.texSubImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, cubeImage[ i ].width, cubeImage[ i ].height, glFormat, glType, cubeImage[ i ].data );

							}

						} else {

							state.texImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, cubeImage[ i ].width, cubeImage[ i ].height, 0, glFormat, glType, cubeImage[ i ].data );

						}

						for ( let j = 0; j < mipmaps.length; j ++ ) {

							const mipmap = mipmaps[ j ];
							const mipmapImage = mipmap.image[ i ].image;

							if ( useTexStorage ) {

								if ( dataReady ) {

									state.texSubImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data );

								}

							} else {

								state.texImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data );

							}

						}

					} else {

						if ( useTexStorage ) {

							if ( dataReady ) {

								state.texSubImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, glFormat, glType, cubeImage[ i ] );

							}

						} else {

							state.texImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, glFormat, glType, cubeImage[ i ] );

						}

						for ( let j = 0; j < mipmaps.length; j ++ ) {

							const mipmap = mipmaps[ j ];

							if ( useTexStorage ) {

								if ( dataReady ) {

									state.texSubImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, glFormat, glType, mipmap.image[ i ] );

								}

							} else {

								state.texImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, glFormat, glType, mipmap.image[ i ] );

							}

						}

					}

				}

			}

			if ( textureNeedsGenerateMipmaps( texture ) ) {

				// We assume images for cube map have the same size.
				generateMipmap( _gl.TEXTURE_CUBE_MAP );

			}

			sourceProperties.__version = source.version;

			if ( texture.onUpdate ) texture.onUpdate( texture );

		}

		textureProperties.__version = texture.version;

	}

	// Render targets

	// Setup storage for target texture and bind it to correct framebuffer
	function setupFrameBufferTexture( framebuffer, renderTarget, texture, attachment, textureTarget, level ) {

		const glFormat = utils.convert( texture.format, texture.colorSpace );
		const glType = utils.convert( texture.type );
		const glInternalFormat = getInternalFormat( texture.internalFormat, glFormat, glType, texture.colorSpace );
		const renderTargetProperties = properties.get( renderTarget );

		if ( ! renderTargetProperties.__hasExternalTextures ) {

			const width = Math.max( 1, renderTarget.width >> level );
			const height = Math.max( 1, renderTarget.height >> level );

			if ( textureTarget === _gl.TEXTURE_3D || textureTarget === _gl.TEXTURE_2D_ARRAY ) {

				state.texImage3D( textureTarget, level, glInternalFormat, width, height, renderTarget.depth, 0, glFormat, glType, null );

			} else {

				state.texImage2D( textureTarget, level, glInternalFormat, width, height, 0, glFormat, glType, null );

			}

		}

		state.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );

		if ( useMultisampledRTT( renderTarget ) ) {

			multisampledRTTExt.framebufferTexture2DMultisampleEXT( _gl.FRAMEBUFFER, attachment, textureTarget, properties.get( texture ).__webglTexture, 0, getRenderTargetSamples( renderTarget ) );

		} else if ( textureTarget === _gl.TEXTURE_2D || ( textureTarget >= _gl.TEXTURE_CUBE_MAP_POSITIVE_X && textureTarget <= _gl.TEXTURE_CUBE_MAP_NEGATIVE_Z ) ) { // see #24753

			_gl.framebufferTexture2D( _gl.FRAMEBUFFER, attachment, textureTarget, properties.get( texture ).__webglTexture, level );

		}

		state.bindFramebuffer( _gl.FRAMEBUFFER, null );

	}


	// Setup storage for internal depth/stencil buffers and bind to correct framebuffer
	function setupRenderBufferStorage( renderbuffer, renderTarget, isMultisample ) {

		_gl.bindRenderbuffer( _gl.RENDERBUFFER, renderbuffer );

		if ( renderTarget.depthBuffer && ! renderTarget.stencilBuffer ) {

			let glInternalFormat = _gl.DEPTH_COMPONENT24;

			if ( isMultisample || useMultisampledRTT( renderTarget ) ) {

				const depthTexture = renderTarget.depthTexture;

				if ( depthTexture && depthTexture.isDepthTexture ) {

					if ( depthTexture.type === FloatType ) {

						glInternalFormat = _gl.DEPTH_COMPONENT32F;

					} else if ( depthTexture.type === UnsignedIntType ) {

						glInternalFormat = _gl.DEPTH_COMPONENT24;

					}

				}

				const samples = getRenderTargetSamples( renderTarget );

				if ( useMultisampledRTT( renderTarget ) ) {

					multisampledRTTExt.renderbufferStorageMultisampleEXT( _gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height );

				} else {

					_gl.renderbufferStorageMultisample( _gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height );

				}

			} else {

				_gl.renderbufferStorage( _gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height );

			}

			_gl.framebufferRenderbuffer( _gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.RENDERBUFFER, renderbuffer );

		} else if ( renderTarget.depthBuffer && renderTarget.stencilBuffer ) {

			const samples = getRenderTargetSamples( renderTarget );

			if ( isMultisample && useMultisampledRTT( renderTarget ) === false ) {

				_gl.renderbufferStorageMultisample( _gl.RENDERBUFFER, samples, _gl.DEPTH24_STENCIL8, renderTarget.width, renderTarget.height );

			} else if ( useMultisampledRTT( renderTarget ) ) {

				multisampledRTTExt.renderbufferStorageMultisampleEXT( _gl.RENDERBUFFER, samples, _gl.DEPTH24_STENCIL8, renderTarget.width, renderTarget.height );

			} else {

				_gl.renderbufferStorage( _gl.RENDERBUFFER, _gl.DEPTH_STENCIL, renderTarget.width, renderTarget.height );

			}


			_gl.framebufferRenderbuffer( _gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.RENDERBUFFER, renderbuffer );

		} else {

			const textures = renderTarget.textures;

			for ( let i = 0; i < textures.length; i ++ ) {

				const texture = textures[ i ];

				const glFormat = utils.convert( texture.format, texture.colorSpace );
				const glType = utils.convert( texture.type );
				const glInternalFormat = getInternalFormat( texture.internalFormat, glFormat, glType, texture.colorSpace );
				const samples = getRenderTargetSamples( renderTarget );

				if ( isMultisample && useMultisampledRTT( renderTarget ) === false ) {

					_gl.renderbufferStorageMultisample( _gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height );

				} else if ( useMultisampledRTT( renderTarget ) ) {

					multisampledRTTExt.renderbufferStorageMultisampleEXT( _gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height );

				} else {

					_gl.renderbufferStorage( _gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height );

				}

			}

		}

		_gl.bindRenderbuffer( _gl.RENDERBUFFER, null );

	}

	// Setup resources for a Depth Texture for a FBO (needs an extension)
	function setupDepthTexture( framebuffer, renderTarget ) {

		const isCube = ( renderTarget && renderTarget.isWebGLCubeRenderTarget );
		if ( isCube ) throw new Error( 'Depth Texture with cube render targets is not supported' );

		state.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );

		if ( ! ( renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture ) ) {

			throw new Error( 'renderTarget.depthTexture must be an instance of THREE.DepthTexture' );

		}

		// upload an empty depth texture with framebuffer size
		if ( ! properties.get( renderTarget.depthTexture ).__webglTexture ||
				renderTarget.depthTexture.image.width !== renderTarget.width ||
				renderTarget.depthTexture.image.height !== renderTarget.height ) {

			renderTarget.depthTexture.image.width = renderTarget.width;
			renderTarget.depthTexture.image.height = renderTarget.height;
			renderTarget.depthTexture.needsUpdate = true;

		}

		setTexture2D( renderTarget.depthTexture, 0 );

		const webglDepthTexture = properties.get( renderTarget.depthTexture ).__webglTexture;
		const samples = getRenderTargetSamples( renderTarget );

		if ( renderTarget.depthTexture.format === DepthFormat ) {

			if ( useMultisampledRTT( renderTarget ) ) {

				multisampledRTTExt.framebufferTexture2DMultisampleEXT( _gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples );

			} else {

				_gl.framebufferTexture2D( _gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0 );

			}

		} else if ( renderTarget.depthTexture.format === DepthStencilFormat ) {

			if ( useMultisampledRTT( renderTarget ) ) {

				multisampledRTTExt.framebufferTexture2DMultisampleEXT( _gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples );

			} else {

				_gl.framebufferTexture2D( _gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0 );

			}

		} else {

			throw new Error( 'Unknown depthTexture format' );

		}

	}

	// Setup GL resources for a non-texture depth buffer
	function setupDepthRenderbuffer( renderTarget ) {

		const renderTargetProperties = properties.get( renderTarget );
		const isCube = ( renderTarget.isWebGLCubeRenderTarget === true );

		if ( renderTarget.depthTexture && ! renderTargetProperties.__autoAllocateDepthBuffer ) {

			if ( isCube ) throw new Error( 'target.depthTexture not supported in Cube render targets' );

			setupDepthTexture( renderTargetProperties.__webglFramebuffer, renderTarget );

		} else {

			if ( isCube ) {

				renderTargetProperties.__webglDepthbuffer = [];

				for ( let i = 0; i < 6; i ++ ) {

					state.bindFramebuffer( _gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[ i ] );
					renderTargetProperties.__webglDepthbuffer[ i ] = _gl.createRenderbuffer();
					setupRenderBufferStorage( renderTargetProperties.__webglDepthbuffer[ i ], renderTarget, false );

				}

			} else {

				state.bindFramebuffer( _gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer );
				renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
				setupRenderBufferStorage( renderTargetProperties.__webglDepthbuffer, renderTarget, false );

			}

		}

		state.bindFramebuffer( _gl.FRAMEBUFFER, null );

	}

	// rebind framebuffer with external textures
	function rebindTextures( renderTarget, colorTexture, depthTexture ) {

		const renderTargetProperties = properties.get( renderTarget );

		if ( colorTexture !== undefined ) {

			setupFrameBufferTexture( renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, 0 );

		}

		if ( depthTexture !== undefined ) {

			setupDepthRenderbuffer( renderTarget );

		}

	}

	// Set up GL resources for the render target
	function setupRenderTarget( renderTarget ) {

		const texture = renderTarget.texture;

		const renderTargetProperties = properties.get( renderTarget );
		const textureProperties = properties.get( texture );

		renderTarget.addEventListener( 'dispose', onRenderTargetDispose );

		const textures = renderTarget.textures;

		const isCube = ( renderTarget.isWebGLCubeRenderTarget === true );
		const isMultipleRenderTargets = ( textures.length > 1 );

		if ( ! isMultipleRenderTargets ) {

			if ( textureProperties.__webglTexture === undefined ) {

				textureProperties.__webglTexture = _gl.createTexture();

			}

			textureProperties.__version = texture.version;
			info.memory.textures ++;

		}

		// Setup framebuffer

		if ( isCube ) {

			renderTargetProperties.__webglFramebuffer = [];

			for ( let i = 0; i < 6; i ++ ) {

				if ( texture.mipmaps && texture.mipmaps.length > 0 ) {

					renderTargetProperties.__webglFramebuffer[ i ] = [];

					for ( let level = 0; level < texture.mipmaps.length; level ++ ) {

						renderTargetProperties.__webglFramebuffer[ i ][ level ] = _gl.createFramebuffer();

					}

				} else {

					renderTargetProperties.__webglFramebuffer[ i ] = _gl.createFramebuffer();

				}

			}

		} else {

			if ( texture.mipmaps && texture.mipmaps.length > 0 ) {

				renderTargetProperties.__webglFramebuffer = [];

				for ( let level = 0; level < texture.mipmaps.length; level ++ ) {

					renderTargetProperties.__webglFramebuffer[ level ] = _gl.createFramebuffer();

				}

			} else {

				renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();

			}

			if ( isMultipleRenderTargets ) {

				for ( let i = 0, il = textures.length; i < il; i ++ ) {

					const attachmentProperties = properties.get( textures[ i ] );

					if ( attachmentProperties.__webglTexture === undefined ) {

						attachmentProperties.__webglTexture = _gl.createTexture();

						info.memory.textures ++;

					}

				}

			}

			if ( ( renderTarget.samples > 0 ) && useMultisampledRTT( renderTarget ) === false ) {

				renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
				renderTargetProperties.__webglColorRenderbuffer = [];

				state.bindFramebuffer( _gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer );

				for ( let i = 0; i < textures.length; i ++ ) {

					const texture = textures[ i ];
					renderTargetProperties.__webglColorRenderbuffer[ i ] = _gl.createRenderbuffer();

					_gl.bindRenderbuffer( _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[ i ] );

					const glFormat = utils.convert( texture.format, texture.colorSpace );
					const glType = utils.convert( texture.type );
					const glInternalFormat = getInternalFormat( texture.internalFormat, glFormat, glType, texture.colorSpace, renderTarget.isXRRenderTarget === true );
					const samples = getRenderTargetSamples( renderTarget );
					_gl.renderbufferStorageMultisample( _gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height );

					_gl.framebufferRenderbuffer( _gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[ i ] );

				}

				_gl.bindRenderbuffer( _gl.RENDERBUFFER, null );

				if ( renderTarget.depthBuffer ) {

					renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
					setupRenderBufferStorage( renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true );

				}

				state.bindFramebuffer( _gl.FRAMEBUFFER, null );

			}

		}

		// Setup color buffer

		if ( isCube ) {

			state.bindTexture( _gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture );
			setTextureParameters( _gl.TEXTURE_CUBE_MAP, texture );

			for ( let i = 0; i < 6; i ++ ) {

				if ( texture.mipmaps && texture.mipmaps.length > 0 ) {

					for ( let level = 0; level < texture.mipmaps.length; level ++ ) {

						setupFrameBufferTexture( renderTargetProperties.__webglFramebuffer[ i ][ level ], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, level );

					}

				} else {

					setupFrameBufferTexture( renderTargetProperties.__webglFramebuffer[ i ], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0 );

				}

			}

			if ( textureNeedsGenerateMipmaps( texture ) ) {

				generateMipmap( _gl.TEXTURE_CUBE_MAP );

			}

			state.unbindTexture();

		} else if ( isMultipleRenderTargets ) {

			for ( let i = 0, il = textures.length; i < il; i ++ ) {

				const attachment = textures[ i ];
				const attachmentProperties = properties.get( attachment );

				state.bindTexture( _gl.TEXTURE_2D, attachmentProperties.__webglTexture );
				setTextureParameters( _gl.TEXTURE_2D, attachment );
				setupFrameBufferTexture( renderTargetProperties.__webglFramebuffer, renderTarget, attachment, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, 0 );

				if ( textureNeedsGenerateMipmaps( attachment ) ) {

					generateMipmap( _gl.TEXTURE_2D );

				}

			}

			state.unbindTexture();

		} else {

			let glTextureType = _gl.TEXTURE_2D;

			if ( renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget ) {

				glTextureType = renderTarget.isWebGL3DRenderTarget ? _gl.TEXTURE_3D : _gl.TEXTURE_2D_ARRAY;

			}

			state.bindTexture( glTextureType, textureProperties.__webglTexture );
			setTextureParameters( glTextureType, texture );

			if ( texture.mipmaps && texture.mipmaps.length > 0 ) {

				for ( let level = 0; level < texture.mipmaps.length; level ++ ) {

					setupFrameBufferTexture( renderTargetProperties.__webglFramebuffer[ level ], renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, level );

				}

			} else {

				setupFrameBufferTexture( renderTargetProperties.__webglFramebuffer, renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, 0 );

			}

			if ( textureNeedsGenerateMipmaps( texture ) ) {

				generateMipmap( glTextureType );

			}

			state.unbindTexture();

		}

		// Setup depth and stencil buffers

		if ( renderTarget.depthBuffer ) {

			setupDepthRenderbuffer( renderTarget );

		}

	}

	function updateRenderTargetMipmap( renderTarget ) {

		const textures = renderTarget.textures;

		for ( let i = 0, il = textures.length; i < il; i ++ ) {

			const texture = textures[ i ];

			if ( textureNeedsGenerateMipmaps( texture ) ) {

				const target = renderTarget.isWebGLCubeRenderTarget ? _gl.TEXTURE_CUBE_MAP : _gl.TEXTURE_2D;
				const webglTexture = properties.get( texture ).__webglTexture;

				state.bindTexture( target, webglTexture );
				generateMipmap( target );
				state.unbindTexture();

			}

		}

	}

	function updateMultisampleRenderTarget( renderTarget ) {

		if ( ( renderTarget.samples > 0 ) && useMultisampledRTT( renderTarget ) === false ) {

			const textures = renderTarget.textures;
			const width = renderTarget.width;
			const height = renderTarget.height;
			let mask = _gl.COLOR_BUFFER_BIT;
			const invalidationArray = [];
			const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
			const renderTargetProperties = properties.get( renderTarget );
			const isMultipleRenderTargets = ( textures.length > 1 );

			// If MRT we need to remove FBO attachments
			if ( isMultipleRenderTargets ) {

				for ( let i = 0; i < textures.length; i ++ ) {

					state.bindFramebuffer( _gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer );
					_gl.framebufferRenderbuffer( _gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, null );

					state.bindFramebuffer( _gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer );
					_gl.framebufferTexture2D( _gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, null, 0 );

				}

			}

			state.bindFramebuffer( _gl.READ_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer );
			state.bindFramebuffer( _gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglFramebuffer );

			for ( let i = 0; i < textures.length; i ++ ) {

				invalidationArray.push( _gl.COLOR_ATTACHMENT0 + i );

				if ( renderTarget.depthBuffer ) {

					invalidationArray.push( depthStyle );

				}

				const ignoreDepthValues = ( renderTargetProperties.__ignoreDepthValues !== undefined ) ? renderTargetProperties.__ignoreDepthValues : false;

				if ( ignoreDepthValues === false ) {

					if ( renderTarget.depthBuffer ) mask |= _gl.DEPTH_BUFFER_BIT;

					// resolving stencil is slow with a D3D backend. disable it for all transmission render targets (see #27799)

					if ( renderTarget.stencilBuffer && renderTargetProperties.__isTransmissionRenderTarget !== true ) mask |= _gl.STENCIL_BUFFER_BIT;

				}

				if ( isMultipleRenderTargets ) {

					_gl.framebufferRenderbuffer( _gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[ i ] );

				}

				if ( ignoreDepthValues === true ) {

					_gl.invalidateFramebuffer( _gl.READ_FRAMEBUFFER, [ depthStyle ] );
					_gl.invalidateFramebuffer( _gl.DRAW_FRAMEBUFFER, [ depthStyle ] );

				}

				if ( isMultipleRenderTargets ) {

					const webglTexture = properties.get( textures[ i ] ).__webglTexture;
					_gl.framebufferTexture2D( _gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, webglTexture, 0 );

				}

				_gl.blitFramebuffer( 0, 0, width, height, 0, 0, width, height, mask, _gl.NEAREST );

				if ( supportsInvalidateFramebuffer ) {

					_gl.invalidateFramebuffer( _gl.READ_FRAMEBUFFER, invalidationArray );

				}


			}

			state.bindFramebuffer( _gl.READ_FRAMEBUFFER, null );
			state.bindFramebuffer( _gl.DRAW_FRAMEBUFFER, null );

			// If MRT since pre-blit we removed the FBO we need to reconstruct the attachments
			if ( isMultipleRenderTargets ) {

				for ( let i = 0; i < textures.length; i ++ ) {

					state.bindFramebuffer( _gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer );
					_gl.framebufferRenderbuffer( _gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[ i ] );

					const webglTexture = properties.get( textures[ i ] ).__webglTexture;

					state.bindFramebuffer( _gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer );
					_gl.framebufferTexture2D( _gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, webglTexture, 0 );

				}

			}

			state.bindFramebuffer( _gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer );

		}

	}

	function getRenderTargetSamples( renderTarget ) {

		return Math.min( capabilities.maxSamples, renderTarget.samples );

	}

	function useMultisampledRTT( renderTarget ) {

		const renderTargetProperties = properties.get( renderTarget );

		return renderTarget.samples > 0 && extensions.has( 'WEBGL_multisampled_render_to_texture' ) === true && renderTargetProperties.__useRenderToTexture !== false;

	}

	function updateVideoTexture( texture ) {

		const frame = info.render.frame;

		// Check the last frame we updated the VideoTexture

		if ( _videoTextures.get( texture ) !== frame ) {

			_videoTextures.set( texture, frame );
			texture.update();

		}

	}

	function verifyColorSpace( texture, image ) {

		const colorSpace = texture.colorSpace;
		const format = texture.format;
		const type = texture.type;

		if ( texture.isCompressedTexture === true || texture.isVideoTexture === true ) return image;

		if ( colorSpace !== LinearSRGBColorSpace && colorSpace !== NoColorSpace ) {

			// sRGB

			if ( ColorManagement.getTransfer( colorSpace ) === SRGBTransfer ) {

				// in WebGL 2 uncompressed textures can only be sRGB encoded if they have the RGBA8 format

				if ( format !== RGBAFormat || type !== UnsignedByteType ) {

					console.warn( 'THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.' );

				}

			} else {

				console.error( 'THREE.WebGLTextures: Unsupported texture color space:', colorSpace );

			}

		}

		return image;

	}

	function getDimensions( image ) {

		if ( typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement ) {

			// if intrinsic data are not available, fallback to width/height

			_imageDimensions.width = image.naturalWidth || image.width;
			_imageDimensions.height = image.naturalHeight || image.height;

		} else if ( typeof VideoFrame !== 'undefined' && image instanceof VideoFrame ) {

			_imageDimensions.width = image.displayWidth;
			_imageDimensions.height = image.displayHeight;

		} else {

			_imageDimensions.width = image.width;
			_imageDimensions.height = image.height;

		}

		return _imageDimensions;

	}

	//

	this.allocateTextureUnit = allocateTextureUnit;
	this.resetTextureUnits = resetTextureUnits;

	this.setTexture2D = setTexture2D;
	this.setTexture2DArray = setTexture2DArray;
	this.setTexture3D = setTexture3D;
	this.setTextureCube = setTextureCube;
	this.rebindTextures = rebindTextures;
	this.setupRenderTarget = setupRenderTarget;
	this.updateRenderTargetMipmap = updateRenderTargetMipmap;
	this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
	this.setupDepthRenderbuffer = setupDepthRenderbuffer;
	this.setupFrameBufferTexture = setupFrameBufferTexture;
	this.useMultisampledRTT = useMultisampledRTT;

}

function WebGLUtils( gl, extensions ) {

	function convert( p, colorSpace = NoColorSpace ) {

		let extension;

		const transfer = ColorManagement.getTransfer( colorSpace );

		if ( p === UnsignedByteType ) return gl.UNSIGNED_BYTE;
		if ( p === UnsignedShort4444Type ) return gl.UNSIGNED_SHORT_4_4_4_4;
		if ( p === UnsignedShort5551Type ) return gl.UNSIGNED_SHORT_5_5_5_1;
		if ( p === UnsignedInt5999Type ) return gl.UNSIGNED_INT_5_9_9_9_REV;

		if ( p === ByteType ) return gl.BYTE;
		if ( p === ShortType ) return gl.SHORT;
		if ( p === UnsignedShortType ) return gl.UNSIGNED_SHORT;
		if ( p === IntType ) return gl.INT;
		if ( p === UnsignedIntType ) return gl.UNSIGNED_INT;
		if ( p === FloatType ) return gl.FLOAT;
		if ( p === HalfFloatType ) return gl.HALF_FLOAT;

		if ( p === AlphaFormat ) return gl.ALPHA;
		if ( p === RGBFormat ) return gl.RGB;
		if ( p === RGBAFormat ) return gl.RGBA;
		if ( p === LuminanceFormat ) return gl.LUMINANCE;
		if ( p === LuminanceAlphaFormat ) return gl.LUMINANCE_ALPHA;
		if ( p === DepthFormat ) return gl.DEPTH_COMPONENT;
		if ( p === DepthStencilFormat ) return gl.DEPTH_STENCIL;

		// WebGL2 formats.

		if ( p === RedFormat ) return gl.RED;
		if ( p === RedIntegerFormat ) return gl.RED_INTEGER;
		if ( p === RGFormat ) return gl.RG;
		if ( p === RGIntegerFormat ) return gl.RG_INTEGER;
		if ( p === RGBAIntegerFormat ) return gl.RGBA_INTEGER;

		// S3TC

		if ( p === RGB_S3TC_DXT1_Format || p === RGBA_S3TC_DXT1_Format || p === RGBA_S3TC_DXT3_Format || p === RGBA_S3TC_DXT5_Format ) {

			if ( transfer === SRGBTransfer ) {

				extension = extensions.get( 'WEBGL_compressed_texture_s3tc_srgb' );

				if ( extension !== null ) {

					if ( p === RGB_S3TC_DXT1_Format ) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
					if ( p === RGBA_S3TC_DXT1_Format ) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
					if ( p === RGBA_S3TC_DXT3_Format ) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
					if ( p === RGBA_S3TC_DXT5_Format ) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;

				} else {

					return null;

				}

			} else {

				extension = extensions.get( 'WEBGL_compressed_texture_s3tc' );

				if ( extension !== null ) {

					if ( p === RGB_S3TC_DXT1_Format ) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
					if ( p === RGBA_S3TC_DXT1_Format ) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
					if ( p === RGBA_S3TC_DXT3_Format ) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
					if ( p === RGBA_S3TC_DXT5_Format ) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;

				} else {

					return null;

				}

			}

		}

		// PVRTC

		if ( p === RGB_PVRTC_4BPPV1_Format || p === RGB_PVRTC_2BPPV1_Format || p === RGBA_PVRTC_4BPPV1_Format || p === RGBA_PVRTC_2BPPV1_Format ) {

			extension = extensions.get( 'WEBGL_compressed_texture_pvrtc' );

			if ( extension !== null ) {

				if ( p === RGB_PVRTC_4BPPV1_Format ) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
				if ( p === RGB_PVRTC_2BPPV1_Format ) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
				if ( p === RGBA_PVRTC_4BPPV1_Format ) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
				if ( p === RGBA_PVRTC_2BPPV1_Format ) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;

			} else {

				return null;

			}

		}

		// ETC1

		if ( p === RGB_ETC1_Format ) {

			extension = extensions.get( 'WEBGL_compressed_texture_etc1' );

			if ( extension !== null ) {

				return extension.COMPRESSED_RGB_ETC1_WEBGL;

			} else {

				return null;

			}

		}

		// ETC2

		if ( p === RGB_ETC2_Format || p === RGBA_ETC2_EAC_Format ) {

			extension = extensions.get( 'WEBGL_compressed_texture_etc' );

			if ( extension !== null ) {

				if ( p === RGB_ETC2_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
				if ( p === RGBA_ETC2_EAC_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;

			} else {

				return null;

			}

		}

		// ASTC

		if ( p === RGBA_ASTC_4x4_Format || p === RGBA_ASTC_5x4_Format || p === RGBA_ASTC_5x5_Format ||
			p === RGBA_ASTC_6x5_Format || p === RGBA_ASTC_6x6_Format || p === RGBA_ASTC_8x5_Format ||
			p === RGBA_ASTC_8x6_Format || p === RGBA_ASTC_8x8_Format || p === RGBA_ASTC_10x5_Format ||
			p === RGBA_ASTC_10x6_Format || p === RGBA_ASTC_10x8_Format || p === RGBA_ASTC_10x10_Format ||
			p === RGBA_ASTC_12x10_Format || p === RGBA_ASTC_12x12_Format ) {

			extension = extensions.get( 'WEBGL_compressed_texture_astc' );

			if ( extension !== null ) {

				if ( p === RGBA_ASTC_4x4_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
				if ( p === RGBA_ASTC_5x4_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
				if ( p === RGBA_ASTC_5x5_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
				if ( p === RGBA_ASTC_6x5_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
				if ( p === RGBA_ASTC_6x6_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
				if ( p === RGBA_ASTC_8x5_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
				if ( p === RGBA_ASTC_8x6_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
				if ( p === RGBA_ASTC_8x8_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
				if ( p === RGBA_ASTC_10x5_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
				if ( p === RGBA_ASTC_10x6_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
				if ( p === RGBA_ASTC_10x8_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
				if ( p === RGBA_ASTC_10x10_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
				if ( p === RGBA_ASTC_12x10_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
				if ( p === RGBA_ASTC_12x12_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;

			} else {

				return null;

			}

		}

		// BPTC

		if ( p === RGBA_BPTC_Format || p === RGB_BPTC_SIGNED_Format || p === RGB_BPTC_UNSIGNED_Format ) {

			extension = extensions.get( 'EXT_texture_compression_bptc' );

			if ( extension !== null ) {

				if ( p === RGBA_BPTC_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
				if ( p === RGB_BPTC_SIGNED_Format ) return extension.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
				if ( p === RGB_BPTC_UNSIGNED_Format ) return extension.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;

			} else {

				return null;

			}

		}

		// RGTC

		if ( p === RED_RGTC1_Format || p === SIGNED_RED_RGTC1_Format || p === RED_GREEN_RGTC2_Format || p === SIGNED_RED_GREEN_RGTC2_Format ) {

			extension = extensions.get( 'EXT_texture_compression_rgtc' );

			if ( extension !== null ) {

				if ( p === RGBA_BPTC_Format ) return extension.COMPRESSED_RED_RGTC1_EXT;
				if ( p === SIGNED_RED_RGTC1_Format ) return extension.COMPRESSED_SIGNED_RED_RGTC1_EXT;
				if ( p === RED_GREEN_RGTC2_Format ) return extension.COMPRESSED_RED_GREEN_RGTC2_EXT;
				if ( p === SIGNED_RED_GREEN_RGTC2_Format ) return extension.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;

			} else {

				return null;

			}

		}

		//

		if ( p === UnsignedInt248Type ) return gl.UNSIGNED_INT_24_8;

		// if "p" can't be resolved, assume the user defines a WebGL constant as a string (fallback/workaround for packed RGB formats)

		return ( gl[ p ] !== undefined ) ? gl[ p ] : null;

	}

	return { convert: convert };

}

class ArrayCamera extends PerspectiveCamera {

	constructor( array = [] ) {

		super();

		this.isArrayCamera = true;

		this.cameras = array;

	}

}

class Group extends Object3D {

	constructor() {

		super();

		this.isGroup = true;

		this.type = 'Group';

	}

}

const _moveEvent = { type: 'move' };

class WebXRController {

	constructor() {

		this._targetRay = null;
		this._grip = null;
		this._hand = null;

	}

	getHandSpace() {

		if ( this._hand === null ) {

			this._hand = new Group();
			this._hand.matrixAutoUpdate = false;
			this._hand.visible = false;

			this._hand.joints = {};
			this._hand.inputState = { pinching: false };

		}

		return this._hand;

	}

	getTargetRaySpace() {

		if ( this._targetRay === null ) {

			this._targetRay = new Group();
			this._targetRay.matrixAutoUpdate = false;
			this._targetRay.visible = false;
			this._targetRay.hasLinearVelocity = false;
			this._targetRay.linearVelocity = new Vector3();
			this._targetRay.hasAngularVelocity = false;
			this._targetRay.angularVelocity = new Vector3();

		}

		return this._targetRay;

	}

	getGripSpace() {

		if ( this._grip === null ) {

			this._grip = new Group();
			this._grip.matrixAutoUpdate = false;
			this._grip.visible = false;
			this._grip.hasLinearVelocity = false;
			this._grip.linearVelocity = new Vector3();
			this._grip.hasAngularVelocity = false;
			this._grip.angularVelocity = new Vector3();

		}

		return this._grip;

	}

	dispatchEvent( event ) {

		if ( this._targetRay !== null ) {

			this._targetRay.dispatchEvent( event );

		}

		if ( this._grip !== null ) {

			this._grip.dispatchEvent( event );

		}

		if ( this._hand !== null ) {

			this._hand.dispatchEvent( event );

		}

		return this;

	}

	connect( inputSource ) {

		if ( inputSource && inputSource.hand ) {

			const hand = this._hand;

			if ( hand ) {

				for ( const inputjoint of inputSource.hand.values() ) {

					// Initialize hand with joints when connected
					this._getHandJoint( hand, inputjoint );

				}

			}

		}

		this.dispatchEvent( { type: 'connected', data: inputSource } );

		return this;

	}

	disconnect( inputSource ) {

		this.dispatchEvent( { type: 'disconnected', data: inputSource } );

		if ( this._targetRay !== null ) {

			this._targetRay.visible = false;

		}

		if ( this._grip !== null ) {

			this._grip.visible = false;

		}

		if ( this._hand !== null ) {

			this._hand.visible = false;

		}

		return this;

	}

	update( inputSource, frame, referenceSpace ) {

		let inputPose = null;
		let gripPose = null;
		let handPose = null;

		const targetRay = this._targetRay;
		const grip = this._grip;
		const hand = this._hand;

		if ( inputSource && frame.session.visibilityState !== 'visible-blurred' ) {

			if ( hand && inputSource.hand ) {

				handPose = true;

				for ( const inputjoint of inputSource.hand.values() ) {

					// Update the joints groups with the XRJoint poses
					const jointPose = frame.getJointPose( inputjoint, referenceSpace );

					// The transform of this joint will be updated with the joint pose on each frame
					const joint = this._getHandJoint( hand, inputjoint );

					if ( jointPose !== null ) {

						joint.matrix.fromArray( jointPose.transform.matrix );
						joint.matrix.decompose( joint.position, joint.rotation, joint.scale );
						joint.matrixWorldNeedsUpdate = true;
						joint.jointRadius = jointPose.radius;

					}

					joint.visible = jointPose !== null;

				}

				// Custom events

				// Check pinchz
				const indexTip = hand.joints[ 'index-finger-tip' ];
				const thumbTip = hand.joints[ 'thumb-tip' ];
				const distance = indexTip.position.distanceTo( thumbTip.position );

				const distanceToPinch = 0.02;
				const threshold = 0.005;

				if ( hand.inputState.pinching && distance > distanceToPinch + threshold ) {

					hand.inputState.pinching = false;
					this.dispatchEvent( {
						type: 'pinchend',
						handedness: inputSource.handedness,
						target: this
					} );

				} else if ( ! hand.inputState.pinching && distance <= distanceToPinch - threshold ) {

					hand.inputState.pinching = true;
					this.dispatchEvent( {
						type: 'pinchstart',
						handedness: inputSource.handedness,
						target: this
					} );

				}

			} else {

				if ( grip !== null && inputSource.gripSpace ) {

					gripPose = frame.getPose( inputSource.gripSpace, referenceSpace );

					if ( gripPose !== null ) {

						grip.matrix.fromArray( gripPose.transform.matrix );
						grip.matrix.decompose( grip.position, grip.rotation, grip.scale );
						grip.matrixWorldNeedsUpdate = true;

						if ( gripPose.linearVelocity ) {

							grip.hasLinearVelocity = true;
							grip.linearVelocity.copy( gripPose.linearVelocity );

						} else {

							grip.hasLinearVelocity = false;

						}

						if ( gripPose.angularVelocity ) {

							grip.hasAngularVelocity = true;
							grip.angularVelocity.copy( gripPose.angularVelocity );

						} else {

							grip.hasAngularVelocity = false;

						}

					}

				}

			}

			if ( targetRay !== null ) {

				inputPose = frame.getPose( inputSource.targetRaySpace, referenceSpace );

				// Some runtimes (namely Vive Cosmos with Vive OpenXR Runtime) have only grip space and ray space is equal to it
				if ( inputPose === null && gripPose !== null ) {

					inputPose = gripPose;

				}

				if ( inputPose !== null ) {

					targetRay.matrix.fromArray( inputPose.transform.matrix );
					targetRay.matrix.decompose( targetRay.position, targetRay.rotation, targetRay.scale );
					targetRay.matrixWorldNeedsUpdate = true;

					if ( inputPose.linearVelocity ) {

						targetRay.hasLinearVelocity = true;
						targetRay.linearVelocity.copy( inputPose.linearVelocity );

					} else {

						targetRay.hasLinearVelocity = false;

					}

					if ( inputPose.angularVelocity ) {

						targetRay.hasAngularVelocity = true;
						targetRay.angularVelocity.copy( inputPose.angularVelocity );

					} else {

						targetRay.hasAngularVelocity = false;

					}

					this.dispatchEvent( _moveEvent );

				}

			}


		}

		if ( targetRay !== null ) {

			targetRay.visible = ( inputPose !== null );

		}

		if ( grip !== null ) {

			grip.visible = ( gripPose !== null );

		}

		if ( hand !== null ) {

			hand.visible = ( handPose !== null );

		}

		return this;

	}

	// private method

	_getHandJoint( hand, inputjoint ) {

		if ( hand.joints[ inputjoint.jointName ] === undefined ) {

			const joint = new Group();
			joint.matrixAutoUpdate = false;
			joint.visible = false;
			hand.joints[ inputjoint.jointName ] = joint;

			hand.add( joint );

		}

		return hand.joints[ inputjoint.jointName ];

	}

}

const _occlusion_vertex = `
void main() {

	gl_Position = vec4( position, 1.0 );

}`;

const _occlusion_fragment = `
uniform sampler2DArray depthColor;
uniform float depthWidth;
uniform float depthHeight;

void main() {

	vec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );

	if ( coord.x >= 1.0 ) {

		gl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;

	} else {

		gl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;

	}

}`;

class WebXRDepthSensing {

	constructor() {

		this.texture = null;
		this.mesh = null;

		this.depthNear = 0;
		this.depthFar = 0;

	}

	init( renderer, depthData, renderState ) {

		if ( this.texture === null ) {

			const texture = new Texture();

			const texProps = renderer.properties.get( texture );
			texProps.__webglTexture = depthData.texture;

			if ( ( depthData.depthNear != renderState.depthNear ) || ( depthData.depthFar != renderState.depthFar ) ) {

				this.depthNear = depthData.depthNear;
				this.depthFar = depthData.depthFar;

			}

			this.texture = texture;

		}

	}

	render( renderer, cameraXR ) {

		if ( this.texture !== null ) {

			if ( this.mesh === null ) {

				const viewport = cameraXR.cameras[ 0 ].viewport;
				const material = new ShaderMaterial( {
					vertexShader: _occlusion_vertex,
					fragmentShader: _occlusion_fragment,
					uniforms: {
						depthColor: { value: this.texture },
						depthWidth: { value: viewport.z },
						depthHeight: { value: viewport.w }
					}
				} );

				this.mesh = new Mesh( new PlaneGeometry( 20, 20 ), material );

			}

			renderer.render( this.mesh, cameraXR );

		}

	}

	reset() {

		this.texture = null;
		this.mesh = null;

	}

}

class WebXRManager extends EventDispatcher {

	constructor( renderer, gl ) {

		super();

		const scope = this;

		let session = null;

		let framebufferScaleFactor = 1.0;

		let referenceSpace = null;
		let referenceSpaceType = 'local-floor';
		// Set default foveation to maximum.
		let foveation = 1.0;
		let customReferenceSpace = null;

		let pose = null;
		let glBinding = null;
		let glProjLayer = null;
		let glBaseLayer = null;
		let xrFrame = null;

		const depthSensing = new WebXRDepthSensing();
		const attributes = gl.getContextAttributes();

		let initialRenderTarget = null;
		let newRenderTarget = null;

		const controllers = [];
		const controllerInputSources = [];

		const currentSize = new Vector2();
		let currentPixelRatio = null;

		//

		const cameraL = new PerspectiveCamera();
		cameraL.layers.enable( 1 );
		cameraL.viewport = new Vector4();

		const cameraR = new PerspectiveCamera();
		cameraR.layers.enable( 2 );
		cameraR.viewport = new Vector4();

		const cameras = [ cameraL, cameraR ];

		const cameraXR = new ArrayCamera();
		cameraXR.layers.enable( 1 );
		cameraXR.layers.enable( 2 );

		let _currentDepthNear = null;
		let _currentDepthFar = null;

		//

		this.cameraAutoUpdate = true;
		this.enabled = false;

		this.isPresenting = false;

		this.getController = function ( index ) {

			let controller = controllers[ index ];

			if ( controller === undefined ) {

				controller = new WebXRController();
				controllers[ index ] = controller;

			}

			return controller.getTargetRaySpace();

		};

		this.getControllerGrip = function ( index ) {

			let controller = controllers[ index ];

			if ( controller === undefined ) {

				controller = new WebXRController();
				controllers[ index ] = controller;

			}

			return controller.getGripSpace();

		};

		this.getHand = function ( index ) {

			let controller = controllers[ index ];

			if ( controller === undefined ) {

				controller = new WebXRController();
				controllers[ index ] = controller;

			}

			return controller.getHandSpace();

		};

		//

		function onSessionEvent( event ) {

			const controllerIndex = controllerInputSources.indexOf( event.inputSource );

			if ( controllerIndex === - 1 ) {

				return;

			}

			const controller = controllers[ controllerIndex ];

			if ( controller !== undefined ) {

				controller.update( event.inputSource, event.frame, customReferenceSpace || referenceSpace );
				controller.dispatchEvent( { type: event.type, data: event.inputSource } );

			}

		}

		function onSessionEnd() {

			session.removeEventListener( 'select', onSessionEvent );
			session.removeEventListener( 'selectstart', onSessionEvent );
			session.removeEventListener( 'selectend', onSessionEvent );
			session.removeEventListener( 'squeeze', onSessionEvent );
			session.removeEventListener( 'squeezestart', onSessionEvent );
			session.removeEventListener( 'squeezeend', onSessionEvent );
			session.removeEventListener( 'end', onSessionEnd );
			session.removeEventListener( 'inputsourceschange', onInputSourcesChange );

			for ( let i = 0; i < controllers.length; i ++ ) {

				const inputSource = controllerInputSources[ i ];

				if ( inputSource === null ) continue;

				controllerInputSources[ i ] = null;

				controllers[ i ].disconnect( inputSource );

			}

			_currentDepthNear = null;
			_currentDepthFar = null;

			depthSensing.reset();

			// restore framebuffer/rendering state

			renderer.setRenderTarget( initialRenderTarget );

			glBaseLayer = null;
			glProjLayer = null;
			glBinding = null;
			session = null;
			newRenderTarget = null;

			//

			animation.stop();

			scope.isPresenting = false;

			renderer.setPixelRatio( currentPixelRatio );
			renderer.setSize( currentSize.width, currentSize.height, false );

			scope.dispatchEvent( { type: 'sessionend' } );

		}

		this.setFramebufferScaleFactor = function ( value ) {

			framebufferScaleFactor = value;

			if ( scope.isPresenting === true ) {

				console.warn( 'THREE.WebXRManager: Cannot change framebuffer scale while presenting.' );

			}

		};

		this.setReferenceSpaceType = function ( value ) {

			referenceSpaceType = value;

			if ( scope.isPresenting === true ) {

				console.warn( 'THREE.WebXRManager: Cannot change reference space type while presenting.' );

			}

		};

		this.getReferenceSpace = function () {

			return customReferenceSpace || referenceSpace;

		};

		this.setReferenceSpace = function ( space ) {

			customReferenceSpace = space;

		};

		this.getBaseLayer = function () {

			return glProjLayer !== null ? glProjLayer : glBaseLayer;

		};

		this.getBinding = function () {

			return glBinding;

		};

		this.getFrame = function () {

			return xrFrame;

		};

		this.getSession = function () {

			return session;

		};

		this.setSession = async function ( value ) {

			session = value;

			if ( session !== null ) {

				initialRenderTarget = renderer.getRenderTarget();

				session.addEventListener( 'select', onSessionEvent );
				session.addEventListener( 'selectstart', onSessionEvent );
				session.addEventListener( 'selectend', onSessionEvent );
				session.addEventListener( 'squeeze', onSessionEvent );
				session.addEventListener( 'squeezestart', onSessionEvent );
				session.addEventListener( 'squeezeend', onSessionEvent );
				session.addEventListener( 'end', onSessionEnd );
				session.addEventListener( 'inputsourceschange', onInputSourcesChange );

				if ( attributes.xrCompatible !== true ) {

					await gl.makeXRCompatible();

				}

				currentPixelRatio = renderer.getPixelRatio();
				renderer.getSize( currentSize );

				if ( session.renderState.layers === undefined ) {

					const layerInit = {
						antialias: attributes.antialias,
						alpha: true,
						depth: attributes.depth,
						stencil: attributes.stencil,
						framebufferScaleFactor: framebufferScaleFactor
					};

					glBaseLayer = new XRWebGLLayer( session, gl, layerInit );

					session.updateRenderState( { baseLayer: glBaseLayer } );

					renderer.setPixelRatio( 1 );
					renderer.setSize( glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, false );

					newRenderTarget = new WebGLRenderTarget(
						glBaseLayer.framebufferWidth,
						glBaseLayer.framebufferHeight,
						{
							format: RGBAFormat,
							type: UnsignedByteType,
							colorSpace: renderer.outputColorSpace,
							stencilBuffer: attributes.stencil
						}
					);

				} else {

					let depthFormat = null;
					let depthType = null;
					let glDepthFormat = null;

					if ( attributes.depth ) {

						glDepthFormat = attributes.stencil ? gl.DEPTH24_STENCIL8 : gl.DEPTH_COMPONENT24;
						depthFormat = attributes.stencil ? DepthStencilFormat : DepthFormat;
						depthType = attributes.stencil ? UnsignedInt248Type : UnsignedIntType;

					}

					const projectionlayerInit = {
						colorFormat: gl.RGBA8,
						depthFormat: glDepthFormat,
						scaleFactor: framebufferScaleFactor
					};

					glBinding = new XRWebGLBinding( session, gl );

					glProjLayer = glBinding.createProjectionLayer( projectionlayerInit );

					session.updateRenderState( { layers: [ glProjLayer ] } );

					renderer.setPixelRatio( 1 );
					renderer.setSize( glProjLayer.textureWidth, glProjLayer.textureHeight, false );

					newRenderTarget = new WebGLRenderTarget(
						glProjLayer.textureWidth,
						glProjLayer.textureHeight,
						{
							format: RGBAFormat,
							type: UnsignedByteType,
							depthTexture: new DepthTexture( glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, undefined, undefined, undefined, undefined, undefined, undefined, depthFormat ),
							stencilBuffer: attributes.stencil,
							colorSpace: renderer.outputColorSpace,
							samples: attributes.antialias ? 4 : 0
						} );

					const renderTargetProperties = renderer.properties.get( newRenderTarget );
					renderTargetProperties.__ignoreDepthValues = glProjLayer.ignoreDepthValues;

				}

				newRenderTarget.isXRRenderTarget = true; // TODO Remove this when possible, see #23278

				this.setFoveation( foveation );

				customReferenceSpace = null;
				referenceSpace = await session.requestReferenceSpace( referenceSpaceType );

				animation.setContext( session );
				animation.start();

				scope.isPresenting = true;

				scope.dispatchEvent( { type: 'sessionstart' } );

			}

		};

		this.getEnvironmentBlendMode = function () {

			if ( session !== null ) {

				return session.environmentBlendMode;

			}

		};

		function onInputSourcesChange( event ) {

			// Notify disconnected

			for ( let i = 0; i < event.removed.length; i ++ ) {

				const inputSource = event.removed[ i ];
				const index = controllerInputSources.indexOf( inputSource );

				if ( index >= 0 ) {

					controllerInputSources[ index ] = null;
					controllers[ index ].disconnect( inputSource );

				}

			}

			// Notify connected

			for ( let i = 0; i < event.added.length; i ++ ) {

				const inputSource = event.added[ i ];

				let controllerIndex = controllerInputSources.indexOf( inputSource );

				if ( controllerIndex === - 1 ) {

					// Assign input source a controller that currently has no input source

					for ( let i = 0; i < controllers.length; i ++ ) {

						if ( i >= controllerInputSources.length ) {

							controllerInputSources.push( inputSource );
							controllerIndex = i;
							break;

						} else if ( controllerInputSources[ i ] === null ) {

							controllerInputSources[ i ] = inputSource;
							controllerIndex = i;
							break;

						}

					}

					// If all controllers do currently receive input we ignore new ones

					if ( controllerIndex === - 1 ) break;

				}

				const controller = controllers[ controllerIndex ];

				if ( controller ) {

					controller.connect( inputSource );

				}

			}

		}

		//

		const cameraLPos = new Vector3();
		const cameraRPos = new Vector3();

		/**
		 * Assumes 2 cameras that are parallel and share an X-axis, and that
		 * the cameras' projection and world matrices have already been set.
		 * And that near and far planes are identical for both cameras.
		 * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
		 */
		function setProjectionFromUnion( camera, cameraL, cameraR ) {

			cameraLPos.setFromMatrixPosition( cameraL.matrixWorld );
			cameraRPos.setFromMatrixPosition( cameraR.matrixWorld );

			const ipd = cameraLPos.distanceTo( cameraRPos );

			const projL = cameraL.projectionMatrix.elements;
			const projR = cameraR.projectionMatrix.elements;

			// VR systems will have identical far and near planes, and
			// most likely identical top and bottom frustum extents.
			// Use the left camera for these values.
			const near = projL[ 14 ] / ( projL[ 10 ] - 1 );
			const far = projL[ 14 ] / ( projL[ 10 ] + 1 );
			const topFov = ( projL[ 9 ] + 1 ) / projL[ 5 ];
			const bottomFov = ( projL[ 9 ] - 1 ) / projL[ 5 ];

			const leftFov = ( projL[ 8 ] - 1 ) / projL[ 0 ];
			const rightFov = ( projR[ 8 ] + 1 ) / projR[ 0 ];
			const left = near * leftFov;
			const right = near * rightFov;

			// Calculate the new camera's position offset from the
			// left camera. xOffset should be roughly half `ipd`.
			const zOffset = ipd / ( - leftFov + rightFov );
			const xOffset = zOffset * - leftFov;

			// TODO: Better way to apply this offset?
			cameraL.matrixWorld.decompose( camera.position, camera.quaternion, camera.scale );
			camera.translateX( xOffset );
			camera.translateZ( zOffset );
			camera.matrixWorld.compose( camera.position, camera.quaternion, camera.scale );
			camera.matrixWorldInverse.copy( camera.matrixWorld ).invert();

			// Find the union of the frustum values of the cameras and scale
			// the values so that the near plane's position does not change in world space,
			// although must now be relative to the new union camera.
			const near2 = near + zOffset;
			const far2 = far + zOffset;
			const left2 = left - xOffset;
			const right2 = right + ( ipd - xOffset );
			const top2 = topFov * far / far2 * near2;
			const bottom2 = bottomFov * far / far2 * near2;

			camera.projectionMatrix.makePerspective( left2, right2, top2, bottom2, near2, far2 );
			camera.projectionMatrixInverse.copy( camera.projectionMatrix ).invert();

		}

		function updateCamera( camera, parent ) {

			if ( parent === null ) {

				camera.matrixWorld.copy( camera.matrix );

			} else {

				camera.matrixWorld.multiplyMatrices( parent.matrixWorld, camera.matrix );

			}

			camera.matrixWorldInverse.copy( camera.matrixWorld ).invert();

		}

		this.updateCamera = function ( camera ) {

			if ( session === null ) return;

			if ( depthSensing.texture !== null ) {

				camera.near = depthSensing.depthNear;
				camera.far = depthSensing.depthFar;

			}

			cameraXR.near = cameraR.near = cameraL.near = camera.near;
			cameraXR.far = cameraR.far = cameraL.far = camera.far;

			if ( _currentDepthNear !== cameraXR.near || _currentDepthFar !== cameraXR.far ) {

				// Note that the new renderState won't apply until the next frame. See #18320

				session.updateRenderState( {
					depthNear: cameraXR.near,
					depthFar: cameraXR.far
				} );

				_currentDepthNear = cameraXR.near;
				_currentDepthFar = cameraXR.far;

				cameraL.near = _currentDepthNear;
				cameraL.far = _currentDepthFar;
				cameraR.near = _currentDepthNear;
				cameraR.far = _currentDepthFar;

				cameraL.updateProjectionMatrix();
				cameraR.updateProjectionMatrix();
				camera.updateProjectionMatrix();

			}

			const parent = camera.parent;
			const cameras = cameraXR.cameras;

			updateCamera( cameraXR, parent );

			for ( let i = 0; i < cameras.length; i ++ ) {

				updateCamera( cameras[ i ], parent );

			}

			// update projection matrix for proper view frustum culling

			if ( cameras.length === 2 ) {

				setProjectionFromUnion( cameraXR, cameraL, cameraR );

			} else {

				// assume single camera setup (AR)

				cameraXR.projectionMatrix.copy( cameraL.projectionMatrix );

			}

			// update user camera and its children

			updateUserCamera( camera, cameraXR, parent );

		};

		function updateUserCamera( camera, cameraXR, parent ) {

			if ( parent === null ) {

				camera.matrix.copy( cameraXR.matrixWorld );

			} else {

				camera.matrix.copy( parent.matrixWorld );
				camera.matrix.invert();
				camera.matrix.multiply( cameraXR.matrixWorld );

			}

			camera.matrix.decompose( camera.position, camera.quaternion, camera.scale );
			camera.updateMatrixWorld( true );

			camera.projectionMatrix.copy( cameraXR.projectionMatrix );
			camera.projectionMatrixInverse.copy( cameraXR.projectionMatrixInverse );

			if ( camera.isPerspectiveCamera ) {

				camera.fov = RAD2DEG * 2 * Math.atan( 1 / camera.projectionMatrix.elements[ 5 ] );
				camera.zoom = 1;

			}

		}

		this.getCamera = function () {

			return cameraXR;

		};

		this.getFoveation = function () {

			if ( glProjLayer === null && glBaseLayer === null ) {

				return undefined;

			}

			return foveation;

		};

		this.setFoveation = function ( value ) {

			// 0 = no foveation = full resolution
			// 1 = maximum foveation = the edges render at lower resolution

			foveation = value;

			if ( glProjLayer !== null ) {

				glProjLayer.fixedFoveation = value;

			}

			if ( glBaseLayer !== null && glBaseLayer.fixedFoveation !== undefined ) {

				glBaseLayer.fixedFoveation = value;

			}

		};

		this.hasDepthSensing = function () {

			return depthSensing.texture !== null;

		};

		// Animation Loop

		let onAnimationFrameCallback = null;

		function onAnimationFrame( time, frame ) {

			pose = frame.getViewerPose( customReferenceSpace || referenceSpace );
			xrFrame = frame;

			if ( pose !== null ) {

				const views = pose.views;

				if ( glBaseLayer !== null ) {

					renderer.setRenderTargetFramebuffer( newRenderTarget, glBaseLayer.framebuffer );
					renderer.setRenderTarget( newRenderTarget );

				}

				let cameraXRNeedsUpdate = false;

				// check if it's necessary to rebuild cameraXR's camera list

				if ( views.length !== cameraXR.cameras.length ) {

					cameraXR.cameras.length = 0;
					cameraXRNeedsUpdate = true;

				}

				for ( let i = 0; i < views.length; i ++ ) {

					const view = views[ i ];

					let viewport = null;

					if ( glBaseLayer !== null ) {

						viewport = glBaseLayer.getViewport( view );

					} else {

						const glSubImage = glBinding.getViewSubImage( glProjLayer, view );
						viewport = glSubImage.viewport;

						// For side-by-side projection, we only produce a single texture for both eyes.
						if ( i === 0 ) {

							renderer.setRenderTargetTextures(
								newRenderTarget,
								glSubImage.colorTexture,
								glProjLayer.ignoreDepthValues ? undefined : glSubImage.depthStencilTexture );

							renderer.setRenderTarget( newRenderTarget );

						}

					}

					let camera = cameras[ i ];

					if ( camera === undefined ) {

						camera = new PerspectiveCamera();
						camera.layers.enable( i );
						camera.viewport = new Vector4();
						cameras[ i ] = camera;

					}

					camera.matrix.fromArray( view.transform.matrix );
					camera.matrix.decompose( camera.position, camera.quaternion, camera.scale );
					camera.projectionMatrix.fromArray( view.projectionMatrix );
					camera.projectionMatrixInverse.copy( camera.projectionMatrix ).invert();
					camera.viewport.set( viewport.x, viewport.y, viewport.width, viewport.height );

					if ( i === 0 ) {

						cameraXR.matrix.copy( camera.matrix );
						cameraXR.matrix.decompose( cameraXR.position, cameraXR.quaternion, cameraXR.scale );

					}

					if ( cameraXRNeedsUpdate === true ) {

						cameraXR.cameras.push( camera );

					}

				}

				//

				const enabledFeatures = session.enabledFeatures;

				if ( enabledFeatures && enabledFeatures.includes( 'depth-sensing' ) ) {

					const depthData = glBinding.getDepthInformation( views[ 0 ] );

					if ( depthData && depthData.isValid && depthData.texture ) {

						depthSensing.init( renderer, depthData, session.renderState );

					}

				}

			}

			//

			for ( let i = 0; i < controllers.length; i ++ ) {

				const inputSource = controllerInputSources[ i ];
				const controller = controllers[ i ];

				if ( inputSource !== null && controller !== undefined ) {

					controller.update( inputSource, frame, customReferenceSpace || referenceSpace );

				}

			}

			depthSensing.render( renderer, cameraXR );

			if ( onAnimationFrameCallback ) onAnimationFrameCallback( time, frame );

			if ( frame.detectedPlanes ) {

				scope.dispatchEvent( { type: 'planesdetected', data: frame } );

			}

			xrFrame = null;

		}

		const animation = new WebGLAnimation();

		animation.setAnimationLoop( onAnimationFrame );

		this.setAnimationLoop = function ( callback ) {

			onAnimationFrameCallback = callback;

		};

		this.dispose = function () {};

	}

}

const _e1 = /*@__PURE__*/ new Euler();
const _m1 = /*@__PURE__*/ new Matrix4();

function WebGLMaterials( renderer, properties ) {

	function refreshTransformUniform( map, uniform ) {

		if ( map.matrixAutoUpdate === true ) {

			map.updateMatrix();

		}

		uniform.value.copy( map.matrix );

	}

	function refreshFogUniforms( uniforms, fog ) {

		fog.color.getRGB( uniforms.fogColor.value, getUnlitUniformColorSpace( renderer ) );

		if ( fog.isFog ) {

			uniforms.fogNear.value = fog.near;
			uniforms.fogFar.value = fog.far;

		} else if ( fog.isFogExp2 ) {

			uniforms.fogDensity.value = fog.density;

		}

	}

	function refreshMaterialUniforms( uniforms, material, pixelRatio, height, transmissionRenderTarget ) {

		if ( material.isMeshBasicMaterial ) {

			refreshUniformsCommon( uniforms, material );

		} else if ( material.isMeshLambertMaterial ) {

			refreshUniformsCommon( uniforms, material );

		} else if ( material.isMeshToonMaterial ) {

			refreshUniformsCommon( uniforms, material );
			refreshUniformsToon( uniforms, material );

		} else if ( material.isMeshPhongMaterial ) {

			refreshUniformsCommon( uniforms, material );
			refreshUniformsPhong( uniforms, material );

		} else if ( material.isMeshStandardMaterial ) {

			refreshUniformsCommon( uniforms, material );
			refreshUniformsStandard( uniforms, material );

			if ( material.isMeshPhysicalMaterial ) {

				refreshUniformsPhysical( uniforms, material, transmissionRenderTarget );

			}

		} else if ( material.isMeshMatcapMaterial ) {

			refreshUniformsCommon( uniforms, material );
			refreshUniformsMatcap( uniforms, material );

		} else if ( material.isMeshDepthMaterial ) {

			refreshUniformsCommon( uniforms, material );

		} else if ( material.isMeshDistanceMaterial ) {

			refreshUniformsCommon( uniforms, material );
			refreshUniformsDistance( uniforms, material );

		} else if ( material.isMeshNormalMaterial ) {

			refreshUniformsCommon( uniforms, material );

		} else if ( material.isLineBasicMaterial ) {

			refreshUniformsLine( uniforms, material );

			if ( material.isLineDashedMaterial ) {

				refreshUniformsDash( uniforms, material );

			}

		} else if ( material.isPointsMaterial ) {

			refreshUniformsPoints( uniforms, material, pixelRatio, height );

		} else if ( material.isSpriteMaterial ) {

			refreshUniformsSprites( uniforms, material );

		} else if ( material.isShadowMaterial ) {

			uniforms.color.value.copy( material.color );
			uniforms.opacity.value = material.opacity;

		} else if ( material.isShaderMaterial ) {

			material.uniformsNeedUpdate = false; // #15581

		}

	}

	function refreshUniformsCommon( uniforms, material ) {

		uniforms.opacity.value = material.opacity;

		if ( material.color ) {

			uniforms.diffuse.value.copy( material.color );

		}

		if ( material.emissive ) {

			uniforms.emissive.value.copy( material.emissive ).multiplyScalar( material.emissiveIntensity );

		}

		if ( material.map ) {

			uniforms.map.value = material.map;

			refreshTransformUniform( material.map, uniforms.mapTransform );

		}

		if ( material.alphaMap ) {

			uniforms.alphaMap.value = material.alphaMap;

			refreshTransformUniform( material.alphaMap, uniforms.alphaMapTransform );

		}

		if ( material.bumpMap ) {

			uniforms.bumpMap.value = material.bumpMap;

			refreshTransformUniform( material.bumpMap, uniforms.bumpMapTransform );

			uniforms.bumpScale.value = material.bumpScale;

			if ( material.side === BackSide ) {

				uniforms.bumpScale.value *= - 1;

			}

		}

		if ( material.normalMap ) {

			uniforms.normalMap.value = material.normalMap;

			refreshTransformUniform( material.normalMap, uniforms.normalMapTransform );

			uniforms.normalScale.value.copy( material.normalScale );

			if ( material.side === BackSide ) {

				uniforms.normalScale.value.negate();

			}

		}

		if ( material.displacementMap ) {

			uniforms.displacementMap.value = material.displacementMap;

			refreshTransformUniform( material.displacementMap, uniforms.displacementMapTransform );

			uniforms.displacementScale.value = material.displacementScale;
			uniforms.displacementBias.value = material.displacementBias;

		}

		if ( material.emissiveMap ) {

			uniforms.emissiveMap.value = material.emissiveMap;

			refreshTransformUniform( material.emissiveMap, uniforms.emissiveMapTransform );

		}

		if ( material.specularMap ) {

			uniforms.specularMap.value = material.specularMap;

			refreshTransformUniform( material.specularMap, uniforms.specularMapTransform );

		}

		if ( material.alphaTest > 0 ) {

			uniforms.alphaTest.value = material.alphaTest;

		}

		const materialProperties = properties.get( material );

		const envMap = materialProperties.envMap;
		const envMapRotation = materialProperties.envMapRotation;

		if ( envMap ) {

			uniforms.envMap.value = envMap;

			_e1.copy( envMapRotation );

			// accommodate left-handed frame
			_e1.x *= - 1; _e1.y *= - 1; _e1.z *= - 1;

			if ( envMap.isCubeTexture && envMap.isRenderTargetTexture === false ) {

				// environment maps which are not cube render targets or PMREMs follow a different convention
				_e1.y *= - 1;
				_e1.z *= - 1;

			}

			uniforms.envMapRotation.value.setFromMatrix4( _m1.makeRotationFromEuler( _e1 ) );

			uniforms.flipEnvMap.value = ( envMap.isCubeTexture && envMap.isRenderTargetTexture === false ) ? - 1 : 1;

			uniforms.reflectivity.value = material.reflectivity;
			uniforms.ior.value = material.ior;
			uniforms.refractionRatio.value = material.refractionRatio;

		}

		if ( material.lightMap ) {

			uniforms.lightMap.value = material.lightMap;

			// artist-friendly light intensity scaling factor
			const scaleFactor = ( renderer._useLegacyLights === true ) ? Math.PI : 1;

			uniforms.lightMapIntensity.value = material.lightMapIntensity * scaleFactor;

			refreshTransformUniform( material.lightMap, uniforms.lightMapTransform );

		}

		if ( material.aoMap ) {

			uniforms.aoMap.value = material.aoMap;
			uniforms.aoMapIntensity.value = material.aoMapIntensity;

			refreshTransformUniform( material.aoMap, uniforms.aoMapTransform );

		}

	}

	function refreshUniformsLine( uniforms, material ) {

		uniforms.diffuse.value.copy( material.color );
		uniforms.opacity.value = material.opacity;

		if ( material.map ) {

			uniforms.map.value = material.map;

			refreshTransformUniform( material.map, uniforms.mapTransform );

		}

	}

	function refreshUniformsDash( uniforms, material ) {

		uniforms.dashSize.value = material.dashSize;
		uniforms.totalSize.value = material.dashSize + material.gapSize;
		uniforms.scale.value = material.scale;

	}

	function refreshUniformsPoints( uniforms, material, pixelRatio, height ) {

		uniforms.diffuse.value.copy( material.color );
		uniforms.opacity.value = material.opacity;
		uniforms.size.value = material.size * pixelRatio;
		uniforms.scale.value = height * 0.5;

		if ( material.map ) {

			uniforms.map.value = material.map;

			refreshTransformUniform( material.map, uniforms.uvTransform );

		}

		if ( material.alphaMap ) {

			uniforms.alphaMap.value = material.alphaMap;

			refreshTransformUniform( material.alphaMap, uniforms.alphaMapTransform );

		}

		if ( material.alphaTest > 0 ) {

			uniforms.alphaTest.value = material.alphaTest;

		}

	}

	function refreshUniformsSprites( uniforms, material ) {

		uniforms.diffuse.value.copy( material.color );
		uniforms.opacity.value = material.opacity;
		uniforms.rotation.value = material.rotation;

		if ( material.map ) {

			uniforms.map.value = material.map;

			refreshTransformUniform( material.map, uniforms.mapTransform );

		}

		if ( material.alphaMap ) {

			uniforms.alphaMap.value = material.alphaMap;

			refreshTransformUniform( material.alphaMap, uniforms.alphaMapTransform );

		}

		if ( material.alphaTest > 0 ) {

			uniforms.alphaTest.value = material.alphaTest;

		}

	}

	function refreshUniformsPhong( uniforms, material ) {

		uniforms.specular.value.copy( material.specular );
		uniforms.shininess.value = Math.max( material.shininess, 1e-4 ); // to prevent pow( 0.0, 0.0 )

	}

	function refreshUniformsToon( uniforms, material ) {

		if ( material.gradientMap ) {

			uniforms.gradientMap.value = material.gradientMap;

		}

	}

	function refreshUniformsStandard( uniforms, material ) {

		uniforms.metalness.value = material.metalness;

		if ( material.metalnessMap ) {

			uniforms.metalnessMap.value = material.metalnessMap;

			refreshTransformUniform( material.metalnessMap, uniforms.metalnessMapTransform );

		}

		uniforms.roughness.value = material.roughness;

		if ( material.roughnessMap ) {

			uniforms.roughnessMap.value = material.roughnessMap;

			refreshTransformUniform( material.roughnessMap, uniforms.roughnessMapTransform );

		}

		if ( material.envMap ) {

			//uniforms.envMap.value = material.envMap; // part of uniforms common

			uniforms.envMapIntensity.value = material.envMapIntensity;

		}

	}

	function refreshUniformsPhysical( uniforms, material, transmissionRenderTarget ) {

		uniforms.ior.value = material.ior; // also part of uniforms common

		if ( material.sheen > 0 ) {

			uniforms.sheenColor.value.copy( material.sheenColor ).multiplyScalar( material.sheen );

			uniforms.sheenRoughness.value = material.sheenRoughness;

			if ( material.sheenColorMap ) {

				uniforms.sheenColorMap.value = material.sheenColorMap;

				refreshTransformUniform( material.sheenColorMap, uniforms.sheenColorMapTransform );

			}

			if ( material.sheenRoughnessMap ) {

				uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;

				refreshTransformUniform( material.sheenRoughnessMap, uniforms.sheenRoughnessMapTransform );

			}

		}

		if ( material.clearcoat > 0 ) {

			uniforms.clearcoat.value = material.clearcoat;
			uniforms.clearcoatRoughness.value = material.clearcoatRoughness;

			if ( material.clearcoatMap ) {

				uniforms.clearcoatMap.value = material.clearcoatMap;

				refreshTransformUniform( material.clearcoatMap, uniforms.clearcoatMapTransform );

			}

			if ( material.clearcoatRoughnessMap ) {

				uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;

				refreshTransformUniform( material.clearcoatRoughnessMap, uniforms.clearcoatRoughnessMapTransform );

			}

			if ( material.clearcoatNormalMap ) {

				uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;

				refreshTransformUniform( material.clearcoatNormalMap, uniforms.clearcoatNormalMapTransform );

				uniforms.clearcoatNormalScale.value.copy( material.clearcoatNormalScale );

				if ( material.side === BackSide ) {

					uniforms.clearcoatNormalScale.value.negate();

				}

			}

		}

		if ( material.iridescence > 0 ) {

			uniforms.iridescence.value = material.iridescence;
			uniforms.iridescenceIOR.value = material.iridescenceIOR;
			uniforms.iridescenceThicknessMinimum.value = material.iridescenceThicknessRange[ 0 ];
			uniforms.iridescenceThicknessMaximum.value = material.iridescenceThicknessRange[ 1 ];

			if ( material.iridescenceMap ) {

				uniforms.iridescenceMap.value = material.iridescenceMap;

				refreshTransformUniform( material.iridescenceMap, uniforms.iridescenceMapTransform );

			}

			if ( material.iridescenceThicknessMap ) {

				uniforms.iridescenceThicknessMap.value = material.iridescenceThicknessMap;

				refreshTransformUniform( material.iridescenceThicknessMap, uniforms.iridescenceThicknessMapTransform );

			}

		}

		if ( material.transmission > 0 ) {

			uniforms.transmission.value = material.transmission;
			uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
			uniforms.transmissionSamplerSize.value.set( transmissionRenderTarget.width, transmissionRenderTarget.height );

			if ( material.transmissionMap ) {

				uniforms.transmissionMap.value = material.transmissionMap;

				refreshTransformUniform( material.transmissionMap, uniforms.transmissionMapTransform );

			}

			uniforms.thickness.value = material.thickness;

			if ( material.thicknessMap ) {

				uniforms.thicknessMap.value = material.thicknessMap;

				refreshTransformUniform( material.thicknessMap, uniforms.thicknessMapTransform );

			}

			uniforms.attenuationDistance.value = material.attenuationDistance;
			uniforms.attenuationColor.value.copy( material.attenuationColor );

		}

		if ( material.anisotropy > 0 ) {

			uniforms.anisotropyVector.value.set( material.anisotropy * Math.cos( material.anisotropyRotation ), material.anisotropy * Math.sin( material.anisotropyRotation ) );

			if ( material.anisotropyMap ) {

				uniforms.anisotropyMap.value = material.anisotropyMap;

				refreshTransformUniform( material.anisotropyMap, uniforms.anisotropyMapTransform );

			}

		}

		uniforms.specularIntensity.value = material.specularIntensity;
		uniforms.specularColor.value.copy( material.specularColor );

		if ( material.specularColorMap ) {

			uniforms.specularColorMap.value = material.specularColorMap;

			refreshTransformUniform( material.specularColorMap, uniforms.specularColorMapTransform );

		}

		if ( material.specularIntensityMap ) {

			uniforms.specularIntensityMap.value = material.specularIntensityMap;

			refreshTransformUniform( material.specularIntensityMap, uniforms.specularIntensityMapTransform );

		}

	}

	function refreshUniformsMatcap( uniforms, material ) {

		if ( material.matcap ) {

			uniforms.matcap.value = material.matcap;

		}

	}

	function refreshUniformsDistance( uniforms, material ) {

		const light = properties.get( material ).light;

		uniforms.referencePosition.value.setFromMatrixPosition( light.matrixWorld );
		uniforms.nearDistance.value = light.shadow.camera.near;
		uniforms.farDistance.value = light.shadow.camera.far;

	}

	return {
		refreshFogUniforms: refreshFogUniforms,
		refreshMaterialUniforms: refreshMaterialUniforms
	};

}

function WebGLUniformsGroups( gl, info, capabilities, state ) {

	let buffers = {};
	let updateList = {};
	let allocatedBindingPoints = [];

	const maxBindingPoints = gl.getParameter( gl.MAX_UNIFORM_BUFFER_BINDINGS ); // binding points are global whereas block indices are per shader program

	function bind( uniformsGroup, program ) {

		const webglProgram = program.program;
		state.uniformBlockBinding( uniformsGroup, webglProgram );

	}

	function update( uniformsGroup, program ) {

		let buffer = buffers[ uniformsGroup.id ];

		if ( buffer === undefined ) {

			prepareUniformsGroup( uniformsGroup );

			buffer = createBuffer( uniformsGroup );
			buffers[ uniformsGroup.id ] = buffer;

			uniformsGroup.addEventListener( 'dispose', onUniformsGroupsDispose );

		}

		// ensure to update the binding points/block indices mapping for this program

		const webglProgram = program.program;
		state.updateUBOMapping( uniformsGroup, webglProgram );

		// update UBO once per frame

		const frame = info.render.frame;

		if ( updateList[ uniformsGroup.id ] !== frame ) {

			updateBufferData( uniformsGroup );

			updateList[ uniformsGroup.id ] = frame;

		}

	}

	function createBuffer( uniformsGroup ) {

		// the setup of an UBO is independent of a particular shader program but global

		const bindingPointIndex = allocateBindingPointIndex();
		uniformsGroup.__bindingPointIndex = bindingPointIndex;

		const buffer = gl.createBuffer();
		const size = uniformsGroup.__size;
		const usage = uniformsGroup.usage;

		gl.bindBuffer( gl.UNIFORM_BUFFER, buffer );
		gl.bufferData( gl.UNIFORM_BUFFER, size, usage );
		gl.bindBuffer( gl.UNIFORM_BUFFER, null );
		gl.bindBufferBase( gl.UNIFORM_BUFFER, bindingPointIndex, buffer );

		return buffer;

	}

	function allocateBindingPointIndex() {

		for ( let i = 0; i < maxBindingPoints; i ++ ) {

			if ( allocatedBindingPoints.indexOf( i ) === - 1 ) {

				allocatedBindingPoints.push( i );
				return i;

			}

		}

		console.error( 'THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached.' );

		return 0;

	}

	function updateBufferData( uniformsGroup ) {

		const buffer = buffers[ uniformsGroup.id ];
		const uniforms = uniformsGroup.uniforms;
		const cache = uniformsGroup.__cache;

		gl.bindBuffer( gl.UNIFORM_BUFFER, buffer );

		for ( let i = 0, il = uniforms.length; i < il; i ++ ) {

			const uniformArray = Array.isArray( uniforms[ i ] ) ? uniforms[ i ] : [ uniforms[ i ] ];

			for ( let j = 0, jl = uniformArray.length; j < jl; j ++ ) {

				const uniform = uniformArray[ j ];

				if ( hasUniformChanged( uniform, i, j, cache ) === true ) {

					const offset = uniform.__offset;

					const values = Array.isArray( uniform.value ) ? uniform.value : [ uniform.value ];

					let arrayOffset = 0;

					for ( let k = 0; k < values.length; k ++ ) {

						const value = values[ k ];

						const info = getUniformSize( value );

						// TODO add integer and struct support
						if ( typeof value === 'number' || typeof value === 'boolean' ) {

							uniform.__data[ 0 ] = value;
							gl.bufferSubData( gl.UNIFORM_BUFFER, offset + arrayOffset, uniform.__data );

						} else if ( value.isMatrix3 ) {

							// manually converting 3x3 to 3x4

							uniform.__data[ 0 ] = value.elements[ 0 ];
							uniform.__data[ 1 ] = value.elements[ 1 ];
							uniform.__data[ 2 ] = value.elements[ 2 ];
							uniform.__data[ 3 ] = 0;
							uniform.__data[ 4 ] = value.elements[ 3 ];
							uniform.__data[ 5 ] = value.elements[ 4 ];
							uniform.__data[ 6 ] = value.elements[ 5 ];
							uniform.__data[ 7 ] = 0;
							uniform.__data[ 8 ] = value.elements[ 6 ];
							uniform.__data[ 9 ] = value.elements[ 7 ];
							uniform.__data[ 10 ] = value.elements[ 8 ];
							uniform.__data[ 11 ] = 0;

						} else {

							value.toArray( uniform.__data, arrayOffset );

							arrayOffset += info.storage / Float32Array.BYTES_PER_ELEMENT;

						}

					}

					gl.bufferSubData( gl.UNIFORM_BUFFER, offset, uniform.__data );

				}

			}

		}

		gl.bindBuffer( gl.UNIFORM_BUFFER, null );

	}

	function hasUniformChanged( uniform, index, indexArray, cache ) {

		const value = uniform.value;
		const indexString = index + '_' + indexArray;

		if ( cache[ indexString ] === undefined ) {

			// cache entry does not exist so far

			if ( typeof value === 'number' || typeof value === 'boolean' ) {

				cache[ indexString ] = value;

			} else {

				cache[ indexString ] = value.clone();

			}

			return true;

		} else {

			const cachedObject = cache[ indexString ];

			// compare current value with cached entry

			if ( typeof value === 'number' || typeof value === 'boolean' ) {

				if ( cachedObject !== value ) {

					cache[ indexString ] = value;
					return true;

				}

			} else {

				if ( cachedObject.equals( value ) === false ) {

					cachedObject.copy( value );
					return true;

				}

			}

		}

		return false;

	}

	function prepareUniformsGroup( uniformsGroup ) {

		// determine total buffer size according to the STD140 layout
		// Hint: STD140 is the only supported layout in WebGL 2

		const uniforms = uniformsGroup.uniforms;

		let offset = 0; // global buffer offset in bytes
		const chunkSize = 16; // size of a chunk in bytes

		for ( let i = 0, l = uniforms.length; i < l; i ++ ) {

			const uniformArray = Array.isArray( uniforms[ i ] ) ? uniforms[ i ] : [ uniforms[ i ] ];

			for ( let j = 0, jl = uniformArray.length; j < jl; j ++ ) {

				const uniform = uniformArray[ j ];

				const values = Array.isArray( uniform.value ) ? uniform.value : [ uniform.value ];

				for ( let k = 0, kl = values.length; k < kl; k ++ ) {

					const value = values[ k ];

					const info = getUniformSize( value );

					// Calculate the chunk offset
					const chunkOffsetUniform = offset % chunkSize;

					// Check for chunk overflow
					if ( chunkOffsetUniform !== 0 && ( chunkSize - chunkOffsetUniform ) < info.boundary ) {

						// Add padding and adjust offset
						offset += ( chunkSize - chunkOffsetUniform );

					}

					// the following two properties will be used for partial buffer updates

					uniform.__data = new Float32Array( info.storage / Float32Array.BYTES_PER_ELEMENT );
					uniform.__offset = offset;


					// Update the global offset
					offset += info.storage;


				}

			}

		}

		// ensure correct final padding

		const chunkOffset = offset % chunkSize;

		if ( chunkOffset > 0 ) offset += ( chunkSize - chunkOffset );

		//

		uniformsGroup.__size = offset;
		uniformsGroup.__cache = {};

		return this;

	}

	function getUniformSize( value ) {

		const info = {
			boundary: 0, // bytes
			storage: 0 // bytes
		};

		// determine sizes according to STD140

		if ( typeof value === 'number' || typeof value === 'boolean' ) {

			// float/int/bool

			info.boundary = 4;
			info.storage = 4;

		} else if ( value.isVector2 ) {

			// vec2

			info.boundary = 8;
			info.storage = 8;

		} else if ( value.isVector3 || value.isColor ) {

			// vec3

			info.boundary = 16;
			info.storage = 12; // evil: vec3 must start on a 16-byte boundary but it only consumes 12 bytes

		} else if ( value.isVector4 ) {

			// vec4

			info.boundary = 16;
			info.storage = 16;

		} else if ( value.isMatrix3 ) {

			// mat3 (in STD140 a 3x3 matrix is represented as 3x4)

			info.boundary = 48;
			info.storage = 48;

		} else if ( value.isMatrix4 ) {

			// mat4

			info.boundary = 64;
			info.storage = 64;

		} else if ( value.isTexture ) {

			console.warn( 'THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.' );

		} else {

			console.warn( 'THREE.WebGLRenderer: Unsupported uniform value type.', value );

		}

		return info;

	}

	function onUniformsGroupsDispose( event ) {

		const uniformsGroup = event.target;

		uniformsGroup.removeEventListener( 'dispose', onUniformsGroupsDispose );

		const index = allocatedBindingPoints.indexOf( uniformsGroup.__bindingPointIndex );
		allocatedBindingPoints.splice( index, 1 );

		gl.deleteBuffer( buffers[ uniformsGroup.id ] );

		delete buffers[ uniformsGroup.id ];
		delete updateList[ uniformsGroup.id ];

	}

	function dispose() {

		for ( const id in buffers ) {

			gl.deleteBuffer( buffers[ id ] );

		}

		allocatedBindingPoints = [];
		buffers = {};
		updateList = {};

	}

	return {

		bind: bind,
		update: update,

		dispose: dispose

	};

}

class WebGLRenderer {

	constructor( parameters = {} ) {

		const {
			canvas = createCanvasElement(),
			context = null,
			depth = true,
			stencil = false,
			alpha = false,
			antialias = false,
			premultipliedAlpha = true,
			preserveDrawingBuffer = false,
			powerPreference = 'default',
			failIfMajorPerformanceCaveat = false,
		} = parameters;

		this.isWebGLRenderer = true;

		let _alpha;

		if ( context !== null ) {

			if ( typeof WebGLRenderingContext !== 'undefined' && context instanceof WebGLRenderingContext ) {

				throw new Error( 'THREE.WebGLRenderer: WebGL 1 is not supported since r163.' );

			}

			_alpha = context.getContextAttributes().alpha;

		} else {

			_alpha = alpha;

		}

		const uintClearColor = new Uint32Array( 4 );
		const intClearColor = new Int32Array( 4 );

		let currentRenderList = null;
		let currentRenderState = null;

		// render() can be called from within a callback triggered by another render.
		// We track this so that the nested render call gets its list and state isolated from the parent render call.

		const renderListStack = [];
		const renderStateStack = [];

		// public properties

		this.domElement = canvas;

		// Debug configuration container
		this.debug = {

			/**
			 * Enables error checking and reporting when shader programs are being compiled
			 * @type {boolean}
			 */
			checkShaderErrors: true,
			/**
			 * Callback for custom error reporting.
			 * @type {?Function}
			 */
			onShaderError: null
		};

		// clearing

		this.autoClear = true;
		this.autoClearColor = true;
		this.autoClearDepth = true;
		this.autoClearStencil = true;

		// scene graph

		this.sortObjects = true;

		// user-defined clipping

		this.clippingPlanes = [];
		this.localClippingEnabled = false;

		// physically based shading

		this._outputColorSpace = SRGBColorSpace;

		// physical lights

		this._useLegacyLights = false;

		// tone mapping

		this.toneMapping = NoToneMapping;
		this.toneMappingExposure = 1.0;

		// internal properties

		const _this = this;

		let _isContextLost = false;

		// internal state cache

		let _currentActiveCubeFace = 0;
		let _currentActiveMipmapLevel = 0;
		let _currentRenderTarget = null;
		let _currentMaterialId = - 1;

		let _currentCamera = null;

		const _currentViewport = new Vector4();
		const _currentScissor = new Vector4();
		let _currentScissorTest = null;

		const _currentClearColor = new Color( 0x000000 );
		let _currentClearAlpha = 0;

		//

		let _width = canvas.width;
		let _height = canvas.height;

		let _pixelRatio = 1;
		let _opaqueSort = null;
		let _transparentSort = null;

		const _viewport = new Vector4( 0, 0, _width, _height );
		const _scissor = new Vector4( 0, 0, _width, _height );
		let _scissorTest = false;

		// frustum

		const _frustum = new Frustum();

		// clipping

		let _clippingEnabled = false;
		let _localClippingEnabled = false;

		// camera matrices cache

		const _projScreenMatrix = new Matrix4();

		const _vector2 = new Vector2();
		const _vector3 = new Vector3();

		const _emptyScene = { background: null, fog: null, environment: null, overrideMaterial: null, isScene: true };

		function getTargetPixelRatio() {

			return _currentRenderTarget === null ? _pixelRatio : 1;

		}

		// initialize

		let _gl = context;

		function getContext( contextName, contextAttributes ) {

			const context = canvas.getContext( contextName, contextAttributes );
			if ( context !== null ) return context;

			return null;

		}

		try {

			const contextAttributes = {
				alpha: true,
				depth,
				stencil,
				antialias,
				premultipliedAlpha,
				preserveDrawingBuffer,
				powerPreference,
				failIfMajorPerformanceCaveat,
			};

			// OffscreenCanvas does not have setAttribute, see #22811
			if ( 'setAttribute' in canvas ) canvas.setAttribute( 'data-engine', `three.js r${REVISION}` );

			// event listeners must be registered before WebGL context is created, see #12753
			canvas.addEventListener( 'webglcontextlost', onContextLost, false );
			canvas.addEventListener( 'webglcontextrestored', onContextRestore, false );
			canvas.addEventListener( 'webglcontextcreationerror', onContextCreationError, false );

			if ( _gl === null ) {

				const contextName = 'webgl2';

				_gl = getContext( contextName, contextAttributes );

				if ( _gl === null ) {

					if ( getContext( contextName ) ) {

						throw new Error( 'Error creating WebGL context with your selected attributes.' );

					} else {

						throw new Error( 'Error creating WebGL context.' );

					}

				}

			}

		} catch ( error ) {

			console.error( 'THREE.WebGLRenderer: ' + error.message );
			throw error;

		}

		let extensions, capabilities, state, info;
		let properties, textures, cubemaps, cubeuvmaps, attributes, geometries, objects;
		let programCache, materials, renderLists, renderStates, clipping, shadowMap;

		let background, morphtargets, bufferRenderer, indexedBufferRenderer;

		let utils, bindingStates, uniformsGroups;

		function initGLContext() {

			extensions = new WebGLExtensions( _gl );
			extensions.init();

			capabilities = new WebGLCapabilities( _gl, extensions, parameters );

			utils = new WebGLUtils( _gl, extensions );

			state = new WebGLState( _gl );

			info = new WebGLInfo( _gl );
			properties = new WebGLProperties();
			textures = new WebGLTextures( _gl, extensions, state, properties, capabilities, utils, info );
			cubemaps = new WebGLCubeMaps( _this );
			cubeuvmaps = new WebGLCubeUVMaps( _this );
			attributes = new WebGLAttributes( _gl );
			bindingStates = new WebGLBindingStates( _gl, attributes );
			geometries = new WebGLGeometries( _gl, attributes, info, bindingStates );
			objects = new WebGLObjects( _gl, geometries, attributes, info );
			morphtargets = new WebGLMorphtargets( _gl, capabilities, textures );
			clipping = new WebGLClipping( properties );
			programCache = new WebGLPrograms( _this, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping );
			materials = new WebGLMaterials( _this, properties );
			renderLists = new WebGLRenderLists();
			renderStates = new WebGLRenderStates( extensions );
			background = new WebGLBackground( _this, cubemaps, cubeuvmaps, state, objects, _alpha, premultipliedAlpha );
			shadowMap = new WebGLShadowMap( _this, objects, capabilities );
			uniformsGroups = new WebGLUniformsGroups( _gl, info, capabilities, state );

			bufferRenderer = new WebGLBufferRenderer( _gl, extensions, info );
			indexedBufferRenderer = new WebGLIndexedBufferRenderer( _gl, extensions, info );

			info.programs = programCache.programs;

			_this.capabilities = capabilities;
			_this.extensions = extensions;
			_this.properties = properties;
			_this.renderLists = renderLists;
			_this.shadowMap = shadowMap;
			_this.state = state;
			_this.info = info;

		}

		initGLContext();

		// xr

		const xr = new WebXRManager( _this, _gl );

		this.xr = xr;

		// API

		this.getContext = function () {

			return _gl;

		};

		this.getContextAttributes = function () {

			return _gl.getContextAttributes();

		};

		this.forceContextLoss = function () {

			const extension = extensions.get( 'WEBGL_lose_context' );
			if ( extension ) extension.loseContext();

		};

		this.forceContextRestore = function () {

			const extension = extensions.get( 'WEBGL_lose_context' );
			if ( extension ) extension.restoreContext();

		};

		this.getPixelRatio = function () {

			return _pixelRatio;

		};

		this.setPixelRatio = function ( value ) {

			if ( value === undefined ) return;

			_pixelRatio = value;

			this.setSize( _width, _height, false );

		};

		this.getSize = function ( target ) {

			return target.set( _width, _height );

		};

		this.setSize = function ( width, height, updateStyle = true ) {

			if ( xr.isPresenting ) {

				console.warn( 'THREE.WebGLRenderer: Can\'t change size while VR device is presenting.' );
				return;

			}

			_width = width;
			_height = height;

			canvas.width = Math.floor( width * _pixelRatio );
			canvas.height = Math.floor( height * _pixelRatio );

			if ( updateStyle === true ) {

				canvas.style.width = width + 'px';
				canvas.style.height = height + 'px';

			}

			this.setViewport( 0, 0, width, height );

		};

		this.getDrawingBufferSize = function ( target ) {

			return target.set( _width * _pixelRatio, _height * _pixelRatio ).floor();

		};

		this.setDrawingBufferSize = function ( width, height, pixelRatio ) {

			_width = width;
			_height = height;

			_pixelRatio = pixelRatio;

			canvas.width = Math.floor( width * pixelRatio );
			canvas.height = Math.floor( height * pixelRatio );

			this.setViewport( 0, 0, width, height );

		};

		this.getCurrentViewport = function ( target ) {

			return target.copy( _currentViewport );

		};

		this.getViewport = function ( target ) {

			return target.copy( _viewport );

		};

		this.setViewport = function ( x, y, width, height ) {

			if ( x.isVector4 ) {

				_viewport.set( x.x, x.y, x.z, x.w );

			} else {

				_viewport.set( x, y, width, height );

			}

			state.viewport( _currentViewport.copy( _viewport ).multiplyScalar( _pixelRatio ).round() );

		};

		this.getScissor = function ( target ) {

			return target.copy( _scissor );

		};

		this.setScissor = function ( x, y, width, height ) {

			if ( x.isVector4 ) {

				_scissor.set( x.x, x.y, x.z, x.w );

			} else {

				_scissor.set( x, y, width, height );

			}

			state.scissor( _currentScissor.copy( _scissor ).multiplyScalar( _pixelRatio ).round() );

		};

		this.getScissorTest = function () {

			return _scissorTest;

		};

		this.setScissorTest = function ( boolean ) {

			state.setScissorTest( _scissorTest = boolean );

		};

		this.setOpaqueSort = function ( method ) {

			_opaqueSort = method;

		};

		this.setTransparentSort = function ( method ) {

			_transparentSort = method;

		};

		// Clearing

		this.getClearColor = function ( target ) {

			return target.copy( background.getClearColor() );

		};

		this.setClearColor = function () {

			background.setClearColor.apply( background, arguments );

		};

		this.getClearAlpha = function () {

			return background.getClearAlpha();

		};

		this.setClearAlpha = function () {

			background.setClearAlpha.apply( background, arguments );

		};

		this.clear = function ( color = true, depth = true, stencil = true ) {

			let bits = 0;

			if ( color ) {

				// check if we're trying to clear an integer target
				let isIntegerFormat = false;
				if ( _currentRenderTarget !== null ) {

					const targetFormat = _currentRenderTarget.texture.format;
					isIntegerFormat = targetFormat === RGBAIntegerFormat ||
						targetFormat === RGIntegerFormat ||
						targetFormat === RedIntegerFormat;

				}

				// use the appropriate clear functions to clear the target if it's a signed
				// or unsigned integer target
				if ( isIntegerFormat ) {

					const targetType = _currentRenderTarget.texture.type;
					const isUnsignedType = targetType === UnsignedByteType ||
						targetType === UnsignedIntType ||
						targetType === UnsignedShortType ||
						targetType === UnsignedInt248Type ||
						targetType === UnsignedShort4444Type ||
						targetType === UnsignedShort5551Type;

					const clearColor = background.getClearColor();
					const a = background.getClearAlpha();
					const r = clearColor.r;
					const g = clearColor.g;
					const b = clearColor.b;

					if ( isUnsignedType ) {

						uintClearColor[ 0 ] = r;
						uintClearColor[ 1 ] = g;
						uintClearColor[ 2 ] = b;
						uintClearColor[ 3 ] = a;
						_gl.clearBufferuiv( _gl.COLOR, 0, uintClearColor );

					} else {

						intClearColor[ 0 ] = r;
						intClearColor[ 1 ] = g;
						intClearColor[ 2 ] = b;
						intClearColor[ 3 ] = a;
						_gl.clearBufferiv( _gl.COLOR, 0, intClearColor );

					}

				} else {

					bits |= _gl.COLOR_BUFFER_BIT;

				}

			}

			if ( depth ) bits |= _gl.DEPTH_BUFFER_BIT;
			if ( stencil ) {

				bits |= _gl.STENCIL_BUFFER_BIT;
				this.state.buffers.stencil.setMask( 0xffffffff );

			}

			_gl.clear( bits );

		};

		this.clearColor = function () {

			this.clear( true, false, false );

		};

		this.clearDepth = function () {

			this.clear( false, true, false );

		};

		this.clearStencil = function () {

			this.clear( false, false, true );

		};

		//

		this.dispose = function () {

			canvas.removeEventListener( 'webglcontextlost', onContextLost, false );
			canvas.removeEventListener( 'webglcontextrestored', onContextRestore, false );
			canvas.removeEventListener( 'webglcontextcreationerror', onContextCreationError, false );

			renderLists.dispose();
			renderStates.dispose();
			properties.dispose();
			cubemaps.dispose();
			cubeuvmaps.dispose();
			objects.dispose();
			bindingStates.dispose();
			uniformsGroups.dispose();
			programCache.dispose();

			xr.dispose();

			xr.removeEventListener( 'sessionstart', onXRSessionStart );
			xr.removeEventListener( 'sessionend', onXRSessionEnd );

			animation.stop();

		};

		// Events

		function onContextLost( event ) {

			event.preventDefault();

			console.log( 'THREE.WebGLRenderer: Context Lost.' );

			_isContextLost = true;

		}

		function onContextRestore( /* event */ ) {

			console.log( 'THREE.WebGLRenderer: Context Restored.' );

			_isContextLost = false;

			const infoAutoReset = info.autoReset;
			const shadowMapEnabled = shadowMap.enabled;
			const shadowMapAutoUpdate = shadowMap.autoUpdate;
			const shadowMapNeedsUpdate = shadowMap.needsUpdate;
			const shadowMapType = shadowMap.type;

			initGLContext();

			info.autoReset = infoAutoReset;
			shadowMap.enabled = shadowMapEnabled;
			shadowMap.autoUpdate = shadowMapAutoUpdate;
			shadowMap.needsUpdate = shadowMapNeedsUpdate;
			shadowMap.type = shadowMapType;

		}

		function onContextCreationError( event ) {

			console.error( 'THREE.WebGLRenderer: A WebGL context could not be created. Reason: ', event.statusMessage );

		}

		function onMaterialDispose( event ) {

			const material = event.target;

			material.removeEventListener( 'dispose', onMaterialDispose );

			deallocateMaterial( material );

		}

		// Buffer deallocation

		function deallocateMaterial( material ) {

			releaseMaterialProgramReferences( material );

			properties.remove( material );

		}


		function releaseMaterialProgramReferences( material ) {

			const programs = properties.get( material ).programs;

			if ( programs !== undefined ) {

				programs.forEach( function ( program ) {

					programCache.releaseProgram( program );

				} );

				if ( material.isShaderMaterial ) {

					programCache.releaseShaderCache( material );

				}

			}

		}

		// Buffer rendering

		this.renderBufferDirect = function ( camera, scene, geometry, material, object, group ) {

			if ( scene === null ) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)

			const frontFaceCW = ( object.isMesh && object.matrixWorld.determinant() < 0 );

			const program = setProgram( camera, scene, geometry, material, object );

			state.setMaterial( material, frontFaceCW );

			//

			let index = geometry.index;
			let rangeFactor = 1;

			if ( material.wireframe === true ) {

				index = geometries.getWireframeAttribute( geometry );

				if ( index === undefined ) return;

				rangeFactor = 2;

			}

			//

			const drawRange = geometry.drawRange;
			const position = geometry.attributes.position;

			let drawStart = drawRange.start * rangeFactor;
			let drawEnd = ( drawRange.start + drawRange.count ) * rangeFactor;

			if ( group !== null ) {

				drawStart = Math.max( drawStart, group.start * rangeFactor );
				drawEnd = Math.min( drawEnd, ( group.start + group.count ) * rangeFactor );

			}

			if ( index !== null ) {

				drawStart = Math.max( drawStart, 0 );
				drawEnd = Math.min( drawEnd, index.count );

			} else if ( position !== undefined && position !== null ) {

				drawStart = Math.max( drawStart, 0 );
				drawEnd = Math.min( drawEnd, position.count );

			}

			const drawCount = drawEnd - drawStart;

			if ( drawCount < 0 || drawCount === Infinity ) return;

			//

			bindingStates.setup( object, material, program, geometry, index );

			let attribute;
			let renderer = bufferRenderer;

			if ( index !== null ) {

				attribute = attributes.get( index );

				renderer = indexedBufferRenderer;
				renderer.setIndex( attribute );

			}

			//

			if ( object.isMesh ) {

				if ( material.wireframe === true ) {

					state.setLineWidth( material.wireframeLinewidth * getTargetPixelRatio() );
					renderer.setMode( _gl.LINES );

				} else {

					renderer.setMode( _gl.TRIANGLES );

				}

			} else if ( object.isLine ) {

				let lineWidth = material.linewidth;

				if ( lineWidth === undefined ) lineWidth = 1; // Not using Line*Material

				state.setLineWidth( lineWidth * getTargetPixelRatio() );

				if ( object.isLineSegments ) {

					renderer.setMode( _gl.LINES );

				} else if ( object.isLineLoop ) {

					renderer.setMode( _gl.LINE_LOOP );

				} else {

					renderer.setMode( _gl.LINE_STRIP );

				}

			} else if ( object.isPoints ) {

				renderer.setMode( _gl.POINTS );

			} else if ( object.isSprite ) {

				renderer.setMode( _gl.TRIANGLES );

			}

			if ( object.isBatchedMesh ) {

				renderer.renderMultiDraw( object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount );

			} else if ( object.isInstancedMesh ) {

				renderer.renderInstances( drawStart, drawCount, object.count );

			} else if ( geometry.isInstancedBufferGeometry ) {

				const maxInstanceCount = geometry._maxInstanceCount !== undefined ? geometry._maxInstanceCount : Infinity;
				const instanceCount = Math.min( geometry.instanceCount, maxInstanceCount );

				renderer.renderInstances( drawStart, drawCount, instanceCount );

			} else {

				renderer.render( drawStart, drawCount );

			}

		};

		// Compile

		function prepareMaterial( material, scene, object ) {

			if ( material.transparent === true && material.side === DoubleSide && material.forceSinglePass === false ) {

				material.side = BackSide;
				material.needsUpdate = true;
				getProgram( material, scene, object );

				material.side = FrontSide;
				material.needsUpdate = true;
				getProgram( material, scene, object );

				material.side = DoubleSide;

			} else {

				getProgram( material, scene, object );

			}

		}

		this.compile = function ( scene, camera, targetScene = null ) {

			if ( targetScene === null ) targetScene = scene;

			currentRenderState = renderStates.get( targetScene );
			currentRenderState.init();

			renderStateStack.push( currentRenderState );

			// gather lights from both the target scene and the new object that will be added to the scene.

			targetScene.traverseVisible( function ( object ) {

				if ( object.isLight && object.layers.test( camera.layers ) ) {

					currentRenderState.pushLight( object );

					if ( object.castShadow ) {

						currentRenderState.pushShadow( object );

					}

				}

			} );

			if ( scene !== targetScene ) {

				scene.traverseVisible( function ( object ) {

					if ( object.isLight && object.layers.test( camera.layers ) ) {

						currentRenderState.pushLight( object );

						if ( object.castShadow ) {

							currentRenderState.pushShadow( object );

						}

					}

				} );

			}

			currentRenderState.setupLights( _this._useLegacyLights );

			// Only initialize materials in the new scene, not the targetScene.

			const materials = new Set();

			scene.traverse( function ( object ) {

				const material = object.material;

				if ( material ) {

					if ( Array.isArray( material ) ) {

						for ( let i = 0; i < material.length; i ++ ) {

							const material2 = material[ i ];

							prepareMaterial( material2, targetScene, object );
							materials.add( material2 );

						}

					} else {

						prepareMaterial( material, targetScene, object );
						materials.add( material );

					}

				}

			} );

			renderStateStack.pop();
			currentRenderState = null;

			return materials;

		};

		// compileAsync

		this.compileAsync = function ( scene, camera, targetScene = null ) {

			const materials = this.compile( scene, camera, targetScene );

			// Wait for all the materials in the new object to indicate that they're
			// ready to be used before resolving the promise.

			return new Promise( ( resolve ) => {

				function checkMaterialsReady() {

					materials.forEach( function ( material ) {

						const materialProperties = properties.get( material );
						const program = materialProperties.currentProgram;

						if ( program.isReady() ) {

							// remove any programs that report they're ready to use from the list
							materials.delete( material );

						}

					} );

					// once the list of compiling materials is empty, call the callback

					if ( materials.size === 0 ) {

						resolve( scene );
						return;

					}

					// if some materials are still not ready, wait a bit and check again

					setTimeout( checkMaterialsReady, 10 );

				}

				if ( extensions.get( 'KHR_parallel_shader_compile' ) !== null ) {

					// If we can check the compilation status of the materials without
					// blocking then do so right away.

					checkMaterialsReady();

				} else {

					// Otherwise start by waiting a bit to give the materials we just
					// initialized a chance to finish.

					setTimeout( checkMaterialsReady, 10 );

				}

			} );

		};

		// Animation Loop

		let onAnimationFrameCallback = null;

		function onAnimationFrame( time ) {

			if ( onAnimationFrameCallback ) onAnimationFrameCallback( time );

		}

		function onXRSessionStart() {

			animation.stop();

		}

		function onXRSessionEnd() {

			animation.start();

		}

		const animation = new WebGLAnimation();
		animation.setAnimationLoop( onAnimationFrame );

		if ( typeof self !== 'undefined' ) animation.setContext( self );

		this.setAnimationLoop = function ( callback ) {

			onAnimationFrameCallback = callback;
			xr.setAnimationLoop( callback );

			( callback === null ) ? animation.stop() : animation.start();

		};

		xr.addEventListener( 'sessionstart', onXRSessionStart );
		xr.addEventListener( 'sessionend', onXRSessionEnd );

		// Rendering

		this.render = function ( scene, camera ) {

			if ( camera !== undefined && camera.isCamera !== true ) {

				console.error( 'THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.' );
				return;

			}

			if ( _isContextLost === true ) return;

			// update scene graph

			if ( scene.matrixWorldAutoUpdate === true ) scene.updateMatrixWorld();

			// update camera matrices and frustum

			if ( camera.parent === null && camera.matrixWorldAutoUpdate === true ) camera.updateMatrixWorld();

			if ( xr.enabled === true && xr.isPresenting === true ) {

				if ( xr.cameraAutoUpdate === true ) xr.updateCamera( camera );

				camera = xr.getCamera(); // use XR camera for rendering

			}

			//
			if ( scene.isScene === true ) scene.onBeforeRender( _this, scene, camera, _currentRenderTarget );

			currentRenderState = renderStates.get( scene, renderStateStack.length );
			currentRenderState.init();

			renderStateStack.push( currentRenderState );

			_projScreenMatrix.multiplyMatrices( camera.projectionMatrix, camera.matrixWorldInverse );
			_frustum.setFromProjectionMatrix( _projScreenMatrix );

			_localClippingEnabled = this.localClippingEnabled;
			_clippingEnabled = clipping.init( this.clippingPlanes, _localClippingEnabled );

			currentRenderList = renderLists.get( scene, renderListStack.length );
			currentRenderList.init();

			renderListStack.push( currentRenderList );

			projectObject( scene, camera, 0, _this.sortObjects );

			currentRenderList.finish();

			if ( _this.sortObjects === true ) {

				currentRenderList.sort( _opaqueSort, _transparentSort );

			}

			//

			this.info.render.frame ++;

			if ( _clippingEnabled === true ) clipping.beginShadows();

			const shadowsArray = currentRenderState.state.shadowsArray;

			shadowMap.render( shadowsArray, scene, camera );

			if ( _clippingEnabled === true ) clipping.endShadows();

			//

			if ( this.info.autoReset === true ) this.info.reset();


			//

			if ( xr.enabled === false || xr.isPresenting === false || xr.hasDepthSensing() === false ) {

				background.render( currentRenderList, scene );

			}

			// render scene

			currentRenderState.setupLights( _this._useLegacyLights );

			if ( camera.isArrayCamera ) {

				const cameras = camera.cameras;

				for ( let i = 0, l = cameras.length; i < l; i ++ ) {

					const camera2 = cameras[ i ];

					renderScene( currentRenderList, scene, camera2, camera2.viewport );

				}

			} else {

				renderScene( currentRenderList, scene, camera );

			}

			//

			if ( _currentRenderTarget !== null ) {

				// resolve multisample renderbuffers to a single-sample texture if necessary

				textures.updateMultisampleRenderTarget( _currentRenderTarget );

				// Generate mipmap if we're using any kind of mipmap filtering

				textures.updateRenderTargetMipmap( _currentRenderTarget );

			}

			//

			if ( scene.isScene === true ) scene.onAfterRender( _this, scene, camera );

			// _gl.finish();

			bindingStates.resetDefaultState();
			_currentMaterialId = - 1;
			_currentCamera = null;

			renderStateStack.pop();

			if ( renderStateStack.length > 0 ) {

				currentRenderState = renderStateStack[ renderStateStack.length - 1 ];

			} else {

				currentRenderState = null;

			}

			renderListStack.pop();

			if ( renderListStack.length > 0 ) {

				currentRenderList = renderListStack[ renderListStack.length - 1 ];

			} else {

				currentRenderList = null;

			}

		};

		function projectObject( object, camera, groupOrder, sortObjects ) {

			if ( object.visible === false ) return;

			const visible = object.layers.test( camera.layers );

			if ( visible ) {

				if ( object.isGroup ) {

					groupOrder = object.renderOrder;

				} else if ( object.isLOD ) {

					if ( object.autoUpdate === true ) object.update( camera );

				} else if ( object.isLight ) {

					currentRenderState.pushLight( object );

					if ( object.castShadow ) {

						currentRenderState.pushShadow( object );

					}

				} else if ( object.isSprite ) {

					if ( ! object.frustumCulled || _frustum.intersectsSprite( object ) ) {

						if ( sortObjects ) {

							_vector3.setFromMatrixPosition( object.matrixWorld )
								.applyMatrix4( _projScreenMatrix );

						}

						const geometry = objects.update( object );
						const material = object.material;

						if ( material.visible ) {

							currentRenderList.push( object, geometry, material, groupOrder, _vector3.z, null );

						}

					}

				} else if ( object.isMesh || object.isLine || object.isPoints ) {

					if ( ! object.frustumCulled || _frustum.intersectsObject( object ) ) {

						const geometry = objects.update( object );
						const material = object.material;

						if ( sortObjects ) {

							if ( object.boundingSphere !== undefined ) {

								if ( object.boundingSphere === null ) object.computeBoundingSphere();
								_vector3.copy( object.boundingSphere.center );

							} else {

								if ( geometry.boundingSphere === null ) geometry.computeBoundingSphere();
								_vector3.copy( geometry.boundingSphere.center );

							}

							_vector3
								.applyMatrix4( object.matrixWorld )
								.applyMatrix4( _projScreenMatrix );

						}

						if ( Array.isArray( material ) ) {

							const groups = geometry.groups;

							for ( let i = 0, l = groups.length; i < l; i ++ ) {

								const group = groups[ i ];
								const groupMaterial = material[ group.materialIndex ];

								if ( groupMaterial && groupMaterial.visible ) {

									currentRenderList.push( object, geometry, groupMaterial, groupOrder, _vector3.z, group );

								}

							}

						} else if ( material.visible ) {

							currentRenderList.push( object, geometry, material, groupOrder, _vector3.z, null );

						}

					}

				}

			}

			const children = object.children;

			for ( let i = 0, l = children.length; i < l; i ++ ) {

				projectObject( children[ i ], camera, groupOrder, sortObjects );

			}

		}

		function renderScene( currentRenderList, scene, camera, viewport ) {

			const opaqueObjects = currentRenderList.opaque;
			const transmissiveObjects = currentRenderList.transmissive;
			const transparentObjects = currentRenderList.transparent;

			currentRenderState.setupLightsView( camera );

			if ( _clippingEnabled === true ) clipping.setGlobalState( _this.clippingPlanes, camera );

			if ( transmissiveObjects.length > 0 ) renderTransmissionPass( opaqueObjects, transmissiveObjects, scene, camera );

			if ( viewport ) state.viewport( _currentViewport.copy( viewport ) );

			if ( opaqueObjects.length > 0 ) renderObjects( opaqueObjects, scene, camera );
			if ( transmissiveObjects.length > 0 ) renderObjects( transmissiveObjects, scene, camera );
			if ( transparentObjects.length > 0 ) renderObjects( transparentObjects, scene, camera );

			// Ensure depth buffer writing is enabled so it can be cleared on next render

			state.buffers.depth.setTest( true );
			state.buffers.depth.setMask( true );
			state.buffers.color.setMask( true );

			state.setPolygonOffset( false );

		}

		function renderTransmissionPass( opaqueObjects, transmissiveObjects, scene, camera ) {

			const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;

			if ( overrideMaterial !== null ) {

				return;

			}

			if ( currentRenderState.state.transmissionRenderTarget === null ) {

				currentRenderState.state.transmissionRenderTarget = new WebGLRenderTarget( 1, 1, {
					generateMipmaps: true,
					type: ( extensions.has( 'EXT_color_buffer_half_float' ) || extensions.has( 'EXT_color_buffer_float' ) ) ? HalfFloatType : UnsignedByteType,
					minFilter: LinearMipmapLinearFilter,
					samples: 4,
					stencilBuffer: stencil
				} );

				const renderTargetProperties = properties.get( currentRenderState.state.transmissionRenderTarget );
				renderTargetProperties.__isTransmissionRenderTarget = true;

				// debug

				/*
				const geometry = new PlaneGeometry();
				const material = new MeshBasicMaterial( { map: _transmissionRenderTarget.texture } );

				const mesh = new Mesh( geometry, material );
				scene.add( mesh );
				*/

			}

			const transmissionRenderTarget = currentRenderState.state.transmissionRenderTarget;

			_this.getDrawingBufferSize( _vector2 );
			transmissionRenderTarget.setSize( _vector2.x, _vector2.y );

			//

			const currentRenderTarget = _this.getRenderTarget();
			_this.setRenderTarget( transmissionRenderTarget );

			_this.getClearColor( _currentClearColor );
			_currentClearAlpha = _this.getClearAlpha();
			if ( _currentClearAlpha < 1 ) _this.setClearColor( 0xffffff, 0.5 );

			_this.clear();

			// Turn off the features which can affect the frag color for opaque objects pass.
			// Otherwise they are applied twice in opaque objects pass and transmission objects pass.
			const currentToneMapping = _this.toneMapping;
			_this.toneMapping = NoToneMapping;

			renderObjects( opaqueObjects, scene, camera );

			textures.updateMultisampleRenderTarget( transmissionRenderTarget );
			textures.updateRenderTargetMipmap( transmissionRenderTarget );

			let renderTargetNeedsUpdate = false;

			for ( let i = 0, l = transmissiveObjects.length; i < l; i ++ ) {

				const renderItem = transmissiveObjects[ i ];

				const object = renderItem.object;
				const geometry = renderItem.geometry;
				const material = renderItem.material;
				const group = renderItem.group;

				if ( material.side === DoubleSide && object.layers.test( camera.layers ) ) {

					const currentSide = material.side;

					material.side = BackSide;
					material.needsUpdate = true;

					renderObject( object, scene, camera, geometry, material, group );

					material.side = currentSide;
					material.needsUpdate = true;

					renderTargetNeedsUpdate = true;

				}

			}

			if ( renderTargetNeedsUpdate === true ) {

				textures.updateMultisampleRenderTarget( transmissionRenderTarget );
				textures.updateRenderTargetMipmap( transmissionRenderTarget );

			}

			_this.setRenderTarget( currentRenderTarget );

			_this.setClearColor( _currentClearColor, _currentClearAlpha );

			_this.toneMapping = currentToneMapping;

		}

		function renderObjects( renderList, scene, camera ) {

			const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;

			for ( let i = 0, l = renderList.length; i < l; i ++ ) {

				const renderItem = renderList[ i ];

				const object = renderItem.object;
				const geometry = renderItem.geometry;
				const material = overrideMaterial === null ? renderItem.material : overrideMaterial;
				const group = renderItem.group;

				if ( object.layers.test( camera.layers ) ) {

					renderObject( object, scene, camera, geometry, material, group );

				}

			}

		}

		function renderObject( object, scene, camera, geometry, material, group ) {

			object.onBeforeRender( _this, scene, camera, geometry, material, group );

			object.modelViewMatrix.multiplyMatrices( camera.matrixWorldInverse, object.matrixWorld );
			object.normalMatrix.getNormalMatrix( object.modelViewMatrix );

			material.onBeforeRender( _this, scene, camera, geometry, object, group );

			if ( material.transparent === true && material.side === DoubleSide && material.forceSinglePass === false ) {

				material.side = BackSide;
				material.needsUpdate = true;
				_this.renderBufferDirect( camera, scene, geometry, material, object, group );

				material.side = FrontSide;
				material.needsUpdate = true;
				_this.renderBufferDirect( camera, scene, geometry, material, object, group );

				material.side = DoubleSide;

			} else {

				_this.renderBufferDirect( camera, scene, geometry, material, object, group );

			}

			object.onAfterRender( _this, scene, camera, geometry, material, group );

		}

		function getProgram( material, scene, object ) {

			if ( scene.isScene !== true ) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...

			const materialProperties = properties.get( material );

			const lights = currentRenderState.state.lights;
			const shadowsArray = currentRenderState.state.shadowsArray;

			const lightsStateVersion = lights.state.version;

			const parameters = programCache.getParameters( material, lights.state, shadowsArray, scene, object );
			const programCacheKey = programCache.getProgramCacheKey( parameters );

			let programs = materialProperties.programs;

			// always update environment and fog - changing these trigger an getProgram call, but it's possible that the program doesn't change

			materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
			materialProperties.fog = scene.fog;
			materialProperties.envMap = ( material.isMeshStandardMaterial ? cubeuvmaps : cubemaps ).get( material.envMap || materialProperties.environment );
			materialProperties.envMapRotation = ( materialProperties.environment !== null && material.envMap === null ) ? scene.environmentRotation : material.envMapRotation;

			if ( programs === undefined ) {

				// new material

				material.addEventListener( 'dispose', onMaterialDispose );

				programs = new Map();
				materialProperties.programs = programs;

			}

			let program = programs.get( programCacheKey );

			if ( program !== undefined ) {

				// early out if program and light state is identical

				if ( materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion ) {

					updateCommonMaterialProperties( material, parameters );

					return program;

				}

			} else {

				parameters.uniforms = programCache.getUniforms( material );

				material.onBuild( object, parameters, _this );

				material.onBeforeCompile( parameters, _this );

				program = programCache.acquireProgram( parameters, programCacheKey );
				programs.set( programCacheKey, program );

				materialProperties.uniforms = parameters.uniforms;

			}

			const uniforms = materialProperties.uniforms;

			if ( ( ! material.isShaderMaterial && ! material.isRawShaderMaterial ) || material.clipping === true ) {

				uniforms.clippingPlanes = clipping.uniform;

			}

			updateCommonMaterialProperties( material, parameters );

			// store the light setup it was created for

			materialProperties.needsLights = materialNeedsLights( material );
			materialProperties.lightsStateVersion = lightsStateVersion;

			if ( materialProperties.needsLights ) {

				// wire up the material to this renderer's lighting state

				uniforms.ambientLightColor.value = lights.state.ambient;
				uniforms.lightProbe.value = lights.state.probe;
				uniforms.directionalLights.value = lights.state.directional;
				uniforms.directionalLightShadows.value = lights.state.directionalShadow;
				uniforms.spotLights.value = lights.state.spot;
				uniforms.spotLightShadows.value = lights.state.spotShadow;
				uniforms.rectAreaLights.value = lights.state.rectArea;
				uniforms.ltc_1.value = lights.state.rectAreaLTC1;
				uniforms.ltc_2.value = lights.state.rectAreaLTC2;
				uniforms.pointLights.value = lights.state.point;
				uniforms.pointLightShadows.value = lights.state.pointShadow;
				uniforms.hemisphereLights.value = lights.state.hemi;

				uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
				uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
				uniforms.spotShadowMap.value = lights.state.spotShadowMap;
				uniforms.spotLightMatrix.value = lights.state.spotLightMatrix;
				uniforms.spotLightMap.value = lights.state.spotLightMap;
				uniforms.pointShadowMap.value = lights.state.pointShadowMap;
				uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
				// TODO (abelnation): add area lights shadow info to uniforms

			}

			materialProperties.currentProgram = program;
			materialProperties.uniformsList = null;

			return program;

		}

		function getUniformList( materialProperties ) {

			if ( materialProperties.uniformsList === null ) {

				const progUniforms = materialProperties.currentProgram.getUniforms();
				materialProperties.uniformsList = WebGLUniforms.seqWithValue( progUniforms.seq, materialProperties.uniforms );

			}

			return materialProperties.uniformsList;

		}

		function updateCommonMaterialProperties( material, parameters ) {

			const materialProperties = properties.get( material );

			materialProperties.outputColorSpace = parameters.outputColorSpace;
			materialProperties.batching = parameters.batching;
			materialProperties.instancing = parameters.instancing;
			materialProperties.instancingColor = parameters.instancingColor;
			materialProperties.instancingMorph = parameters.instancingMorph;
			materialProperties.skinning = parameters.skinning;
			materialProperties.morphTargets = parameters.morphTargets;
			materialProperties.morphNormals = parameters.morphNormals;
			materialProperties.morphColors = parameters.morphColors;
			materialProperties.morphTargetsCount = parameters.morphTargetsCount;
			materialProperties.numClippingPlanes = parameters.numClippingPlanes;
			materialProperties.numIntersection = parameters.numClipIntersection;
			materialProperties.vertexAlphas = parameters.vertexAlphas;
			materialProperties.vertexTangents = parameters.vertexTangents;
			materialProperties.toneMapping = parameters.toneMapping;

		}

		function setProgram( camera, scene, geometry, material, object ) {

			if ( scene.isScene !== true ) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...

			textures.resetTextureUnits();

			const fog = scene.fog;
			const environment = material.isMeshStandardMaterial ? scene.environment : null;
			const colorSpace = ( _currentRenderTarget === null ) ? _this.outputColorSpace : ( _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.colorSpace : LinearSRGBColorSpace );
			const envMap = ( material.isMeshStandardMaterial ? cubeuvmaps : cubemaps ).get( material.envMap || environment );
			const vertexAlphas = material.vertexColors === true && !! geometry.attributes.color && geometry.attributes.color.itemSize === 4;
			const vertexTangents = !! geometry.attributes.tangent && ( !! material.normalMap || material.anisotropy > 0 );
			const morphTargets = !! geometry.morphAttributes.position;
			const morphNormals = !! geometry.morphAttributes.normal;
			const morphColors = !! geometry.morphAttributes.color;

			let toneMapping = NoToneMapping;

			if ( material.toneMapped ) {

				if ( _currentRenderTarget === null || _currentRenderTarget.isXRRenderTarget === true ) {

					toneMapping = _this.toneMapping;

				}

			}

			const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
			const morphTargetsCount = ( morphAttribute !== undefined ) ? morphAttribute.length : 0;

			const materialProperties = properties.get( material );
			const lights = currentRenderState.state.lights;

			if ( _clippingEnabled === true ) {

				if ( _localClippingEnabled === true || camera !== _currentCamera ) {

					const useCache =
						camera === _currentCamera &&
						material.id === _currentMaterialId;

					// we might want to call this function with some ClippingGroup
					// object instead of the material, once it becomes feasible
					// (#8465, #8379)
					clipping.setState( material, camera, useCache );

				}

			}

			//

			let needsProgramChange = false;

			if ( material.version === materialProperties.__version ) {

				if ( materialProperties.needsLights && ( materialProperties.lightsStateVersion !== lights.state.version ) ) {

					needsProgramChange = true;

				} else if ( materialProperties.outputColorSpace !== colorSpace ) {

					needsProgramChange = true;

				} else if ( object.isBatchedMesh && materialProperties.batching === false ) {

					needsProgramChange = true;

				} else if ( ! object.isBatchedMesh && materialProperties.batching === true ) {

					needsProgramChange = true;

				} else if ( object.isInstancedMesh && materialProperties.instancing === false ) {

					needsProgramChange = true;

				} else if ( ! object.isInstancedMesh && materialProperties.instancing === true ) {

					needsProgramChange = true;

				} else if ( object.isSkinnedMesh && materialProperties.skinning === false ) {

					needsProgramChange = true;

				} else if ( ! object.isSkinnedMesh && materialProperties.skinning === true ) {

					needsProgramChange = true;

				} else if ( object.isInstancedMesh && materialProperties.instancingColor === true && object.instanceColor === null ) {

					needsProgramChange = true;

				} else if ( object.isInstancedMesh && materialProperties.instancingColor === false && object.instanceColor !== null ) {

					needsProgramChange = true;

				} else if ( object.isInstancedMesh && materialProperties.instancingMorph === true && object.morphTexture === null ) {

					needsProgramChange = true;

				} else if ( object.isInstancedMesh && materialProperties.instancingMorph === false && object.morphTexture !== null ) {

					needsProgramChange = true;

				} else if ( materialProperties.envMap !== envMap ) {

					needsProgramChange = true;

				} else if ( material.fog === true && materialProperties.fog !== fog ) {

					needsProgramChange = true;

				} else if ( materialProperties.numClippingPlanes !== undefined &&
					( materialProperties.numClippingPlanes !== clipping.numPlanes ||
					materialProperties.numIntersection !== clipping.numIntersection ) ) {

					needsProgramChange = true;

				} else if ( materialProperties.vertexAlphas !== vertexAlphas ) {

					needsProgramChange = true;

				} else if ( materialProperties.vertexTangents !== vertexTangents ) {

					needsProgramChange = true;

				} else if ( materialProperties.morphTargets !== morphTargets ) {

					needsProgramChange = true;

				} else if ( materialProperties.morphNormals !== morphNormals ) {

					needsProgramChange = true;

				} else if ( materialProperties.morphColors !== morphColors ) {

					needsProgramChange = true;

				} else if ( materialProperties.toneMapping !== toneMapping ) {

					needsProgramChange = true;

				} else if ( materialProperties.morphTargetsCount !== morphTargetsCount ) {

					needsProgramChange = true;

				}

			} else {

				needsProgramChange = true;
				materialProperties.__version = material.version;

			}

			//

			let program = materialProperties.currentProgram;

			if ( needsProgramChange === true ) {

				program = getProgram( material, scene, object );

			}

			let refreshProgram = false;
			let refreshMaterial = false;
			let refreshLights = false;

			const p_uniforms = program.getUniforms(),
				m_uniforms = materialProperties.uniforms;

			if ( state.useProgram( program.program ) ) {

				refreshProgram = true;
				refreshMaterial = true;
				refreshLights = true;

			}

			if ( material.id !== _currentMaterialId ) {

				_currentMaterialId = material.id;

				refreshMaterial = true;

			}

			if ( refreshProgram || _currentCamera !== camera ) {

				// common camera uniforms

				p_uniforms.setValue( _gl, 'projectionMatrix', camera.projectionMatrix );
				p_uniforms.setValue( _gl, 'viewMatrix', camera.matrixWorldInverse );

				const uCamPos = p_uniforms.map.cameraPosition;

				if ( uCamPos !== undefined ) {

					uCamPos.setValue( _gl, _vector3.setFromMatrixPosition( camera.matrixWorld ) );

				}

				if ( capabilities.logarithmicDepthBuffer ) {

					p_uniforms.setValue( _gl, 'logDepthBufFC',
						2.0 / ( Math.log( camera.far + 1.0 ) / Math.LN2 ) );

				}

				// consider moving isOrthographic to UniformLib and WebGLMaterials, see https://github.com/mrdoob/three.js/pull/26467#issuecomment-1645185067

				if ( material.isMeshPhongMaterial ||
					material.isMeshToonMaterial ||
					material.isMeshLambertMaterial ||
					material.isMeshBasicMaterial ||
					material.isMeshStandardMaterial ||
					material.isShaderMaterial ) {

					p_uniforms.setValue( _gl, 'isOrthographic', camera.isOrthographicCamera === true );

				}

				if ( _currentCamera !== camera ) {

					_currentCamera = camera;

					// lighting uniforms depend on the camera so enforce an update
					// now, in case this material supports lights - or later, when
					// the next material that does gets activated:

					refreshMaterial = true;		// set to true on material change
					refreshLights = true;		// remains set until update done

				}

			}

			// skinning and morph target uniforms must be set even if material didn't change
			// auto-setting of texture unit for bone and morph texture must go before other textures
			// otherwise textures used for skinning and morphing can take over texture units reserved for other material textures

			if ( object.isSkinnedMesh ) {

				p_uniforms.setOptional( _gl, object, 'bindMatrix' );
				p_uniforms.setOptional( _gl, object, 'bindMatrixInverse' );

				const skeleton = object.skeleton;

				if ( skeleton ) {

					if ( skeleton.boneTexture === null ) skeleton.computeBoneTexture();

					p_uniforms.setValue( _gl, 'boneTexture', skeleton.boneTexture, textures );

				}

			}

			if ( object.isBatchedMesh ) {

				p_uniforms.setOptional( _gl, object, 'batchingTexture' );
				p_uniforms.setValue( _gl, 'batchingTexture', object._matricesTexture, textures );

			}

			const morphAttributes = geometry.morphAttributes;

			if ( morphAttributes.position !== undefined || morphAttributes.normal !== undefined || ( morphAttributes.color !== undefined ) ) {

				morphtargets.update( object, geometry, program );

			}

			if ( refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow ) {

				materialProperties.receiveShadow = object.receiveShadow;
				p_uniforms.setValue( _gl, 'receiveShadow', object.receiveShadow );

			}

			// https://github.com/mrdoob/three.js/pull/24467#issuecomment-1209031512

			if ( material.isMeshGouraudMaterial && material.envMap !== null ) {

				m_uniforms.envMap.value = envMap;

				m_uniforms.flipEnvMap.value = ( envMap.isCubeTexture && envMap.isRenderTargetTexture === false ) ? - 1 : 1;

			}

			if ( material.isMeshStandardMaterial && material.envMap === null && scene.environment !== null ) {

				m_uniforms.envMapIntensity.value = scene.environmentIntensity;

			}

			if ( refreshMaterial ) {

				p_uniforms.setValue( _gl, 'toneMappingExposure', _this.toneMappingExposure );

				if ( materialProperties.needsLights ) {

					// the current material requires lighting info

					// note: all lighting uniforms are always set correctly
					// they simply reference the renderer's state for their
					// values
					//
					// use the current material's .needsUpdate flags to set
					// the GL state when required

					markUniformsLightsNeedsUpdate( m_uniforms, refreshLights );

				}

				// refresh uniforms common to several materials

				if ( fog && material.fog === true ) {

					materials.refreshFogUniforms( m_uniforms, fog );

				}

				materials.refreshMaterialUniforms( m_uniforms, material, _pixelRatio, _height, currentRenderState.state.transmissionRenderTarget );

				WebGLUniforms.upload( _gl, getUniformList( materialProperties ), m_uniforms, textures );

			}

			if ( material.isShaderMaterial && material.uniformsNeedUpdate === true ) {

				WebGLUniforms.upload( _gl, getUniformList( materialProperties ), m_uniforms, textures );
				material.uniformsNeedUpdate = false;

			}

			if ( material.isSpriteMaterial ) {

				p_uniforms.setValue( _gl, 'center', object.center );

			}

			// common matrices

			p_uniforms.setValue( _gl, 'modelViewMatrix', object.modelViewMatrix );
			p_uniforms.setValue( _gl, 'normalMatrix', object.normalMatrix );
			p_uniforms.setValue( _gl, 'modelMatrix', object.matrixWorld );

			// UBOs

			if ( material.isShaderMaterial || material.isRawShaderMaterial ) {

				const groups = material.uniformsGroups;

				for ( let i = 0, l = groups.length; i < l; i ++ ) {

					const group = groups[ i ];

					uniformsGroups.update( group, program );
					uniformsGroups.bind( group, program );

				}

			}

			return program;

		}

		// If uniforms are marked as clean, they don't need to be loaded to the GPU.

		function markUniformsLightsNeedsUpdate( uniforms, value ) {

			uniforms.ambientLightColor.needsUpdate = value;
			uniforms.lightProbe.needsUpdate = value;

			uniforms.directionalLights.needsUpdate = value;
			uniforms.directionalLightShadows.needsUpdate = value;
			uniforms.pointLights.needsUpdate = value;
			uniforms.pointLightShadows.needsUpdate = value;
			uniforms.spotLights.needsUpdate = value;
			uniforms.spotLightShadows.needsUpdate = value;
			uniforms.rectAreaLights.needsUpdate = value;
			uniforms.hemisphereLights.needsUpdate = value;

		}

		function materialNeedsLights( material ) {

			return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial ||
				material.isMeshStandardMaterial || material.isShadowMaterial ||
				( material.isShaderMaterial && material.lights === true );

		}

		this.getActiveCubeFace = function () {

			return _currentActiveCubeFace;

		};

		this.getActiveMipmapLevel = function () {

			return _currentActiveMipmapLevel;

		};

		this.getRenderTarget = function () {

			return _currentRenderTarget;

		};

		this.setRenderTargetTextures = function ( renderTarget, colorTexture, depthTexture ) {

			properties.get( renderTarget.texture ).__webglTexture = colorTexture;
			properties.get( renderTarget.depthTexture ).__webglTexture = depthTexture;

			const renderTargetProperties = properties.get( renderTarget );
			renderTargetProperties.__hasExternalTextures = true;

			renderTargetProperties.__autoAllocateDepthBuffer = depthTexture === undefined;

			if ( ! renderTargetProperties.__autoAllocateDepthBuffer ) {

				// The multisample_render_to_texture extension doesn't work properly if there
				// are midframe flushes and an external depth buffer. Disable use of the extension.
				if ( extensions.has( 'WEBGL_multisampled_render_to_texture' ) === true ) {

					console.warn( 'THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided' );
					renderTargetProperties.__useRenderToTexture = false;

				}

			}

		};

		this.setRenderTargetFramebuffer = function ( renderTarget, defaultFramebuffer ) {

			const renderTargetProperties = properties.get( renderTarget );
			renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
			renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === undefined;

		};

		this.setRenderTarget = function ( renderTarget, activeCubeFace = 0, activeMipmapLevel = 0 ) {

			_currentRenderTarget = renderTarget;
			_currentActiveCubeFace = activeCubeFace;
			_currentActiveMipmapLevel = activeMipmapLevel;

			let useDefaultFramebuffer = true;
			let framebuffer = null;
			let isCube = false;
			let isRenderTarget3D = false;

			if ( renderTarget ) {

				const renderTargetProperties = properties.get( renderTarget );

				if ( renderTargetProperties.__useDefaultFramebuffer !== undefined ) {

					// We need to make sure to rebind the framebuffer.
					state.bindFramebuffer( _gl.FRAMEBUFFER, null );
					useDefaultFramebuffer = false;

				} else if ( renderTargetProperties.__webglFramebuffer === undefined ) {

					textures.setupRenderTarget( renderTarget );

				} else if ( renderTargetProperties.__hasExternalTextures ) {

					// Color and depth texture must be rebound in order for the swapchain to update.
					textures.rebindTextures( renderTarget, properties.get( renderTarget.texture ).__webglTexture, properties.get( renderTarget.depthTexture ).__webglTexture );

				}

				const texture = renderTarget.texture;

				if ( texture.isData3DTexture || texture.isDataArrayTexture || texture.isCompressedArrayTexture ) {

					isRenderTarget3D = true;

				}

				const __webglFramebuffer = properties.get( renderTarget ).__webglFramebuffer;

				if ( renderTarget.isWebGLCubeRenderTarget ) {

					if ( Array.isArray( __webglFramebuffer[ activeCubeFace ] ) ) {

						framebuffer = __webglFramebuffer[ activeCubeFace ][ activeMipmapLevel ];

					} else {

						framebuffer = __webglFramebuffer[ activeCubeFace ];

					}

					isCube = true;

				} else if ( ( renderTarget.samples > 0 ) && textures.useMultisampledRTT( renderTarget ) === false ) {

					framebuffer = properties.get( renderTarget ).__webglMultisampledFramebuffer;

				} else {

					if ( Array.isArray( __webglFramebuffer ) ) {

						framebuffer = __webglFramebuffer[ activeMipmapLevel ];

					} else {

						framebuffer = __webglFramebuffer;

					}

				}

				_currentViewport.copy( renderTarget.viewport );
				_currentScissor.copy( renderTarget.scissor );
				_currentScissorTest = renderTarget.scissorTest;

			} else {

				_currentViewport.copy( _viewport ).multiplyScalar( _pixelRatio ).floor();
				_currentScissor.copy( _scissor ).multiplyScalar( _pixelRatio ).floor();
				_currentScissorTest = _scissorTest;

			}

			const framebufferBound = state.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );

			if ( framebufferBound && useDefaultFramebuffer ) {

				state.drawBuffers( renderTarget, framebuffer );

			}

			state.viewport( _currentViewport );
			state.scissor( _currentScissor );
			state.setScissorTest( _currentScissorTest );

			if ( isCube ) {

				const textureProperties = properties.get( renderTarget.texture );
				_gl.framebufferTexture2D( _gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel );

			} else if ( isRenderTarget3D ) {

				const textureProperties = properties.get( renderTarget.texture );
				const layer = activeCubeFace || 0;
				_gl.framebufferTextureLayer( _gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, textureProperties.__webglTexture, activeMipmapLevel || 0, layer );

			}

			_currentMaterialId = - 1; // reset current material to ensure correct uniform bindings

		};

		this.readRenderTargetPixels = function ( renderTarget, x, y, width, height, buffer, activeCubeFaceIndex ) {

			if ( ! ( renderTarget && renderTarget.isWebGLRenderTarget ) ) {

				console.error( 'THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.' );
				return;

			}

			let framebuffer = properties.get( renderTarget ).__webglFramebuffer;

			if ( renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined ) {

				framebuffer = framebuffer[ activeCubeFaceIndex ];

			}

			if ( framebuffer ) {

				state.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );

				try {

					const texture = renderTarget.texture;
					const textureFormat = texture.format;
					const textureType = texture.type;

					if ( textureFormat !== RGBAFormat && utils.convert( textureFormat ) !== _gl.getParameter( _gl.IMPLEMENTATION_COLOR_READ_FORMAT ) ) {

						console.error( 'THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.' );
						return;

					}

					const halfFloatSupportedByExt = ( textureType === HalfFloatType ) && ( extensions.has( 'EXT_color_buffer_half_float' ) || extensions.has( 'EXT_color_buffer_float' ) );

					if ( textureType !== UnsignedByteType && utils.convert( textureType ) !== _gl.getParameter( _gl.IMPLEMENTATION_COLOR_READ_TYPE ) && // Edge and Chrome Mac < 52 (#9513)
						textureType !== FloatType && ! halfFloatSupportedByExt ) {

						console.error( 'THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.' );
						return;

					}

					// the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)

					if ( ( x >= 0 && x <= ( renderTarget.width - width ) ) && ( y >= 0 && y <= ( renderTarget.height - height ) ) ) {

						_gl.readPixels( x, y, width, height, utils.convert( textureFormat ), utils.convert( textureType ), buffer );

					}

				} finally {

					// restore framebuffer of current render target if necessary

					const framebuffer = ( _currentRenderTarget !== null ) ? properties.get( _currentRenderTarget ).__webglFramebuffer : null;
					state.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );

				}

			}

		};

		this.copyFramebufferToTexture = function ( position, texture, level = 0 ) {

			const levelScale = Math.pow( 2, - level );
			const width = Math.floor( texture.image.width * levelScale );
			const height = Math.floor( texture.image.height * levelScale );

			textures.setTexture2D( texture, 0 );

			_gl.copyTexSubImage2D( _gl.TEXTURE_2D, level, 0, 0, position.x, position.y, width, height );

			state.unbindTexture();

		};

		this.copyTextureToTexture = function ( position, srcTexture, dstTexture, level = 0 ) {

			const width = srcTexture.image.width;
			const height = srcTexture.image.height;
			const glFormat = utils.convert( dstTexture.format );
			const glType = utils.convert( dstTexture.type );

			textures.setTexture2D( dstTexture, 0 );

			// As another texture upload may have changed pixelStorei
			// parameters, make sure they are correct for the dstTexture
			_gl.pixelStorei( _gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY );
			_gl.pixelStorei( _gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha );
			_gl.pixelStorei( _gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment );

			if ( srcTexture.isDataTexture ) {

				_gl.texSubImage2D( _gl.TEXTURE_2D, level, position.x, position.y, width, height, glFormat, glType, srcTexture.image.data );

			} else {

				if ( srcTexture.isCompressedTexture ) {

					_gl.compressedTexSubImage2D( _gl.TEXTURE_2D, level, position.x, position.y, srcTexture.mipmaps[ 0 ].width, srcTexture.mipmaps[ 0 ].height, glFormat, srcTexture.mipmaps[ 0 ].data );

				} else {

					_gl.texSubImage2D( _gl.TEXTURE_2D, level, position.x, position.y, glFormat, glType, srcTexture.image );

				}

			}

			// Generate mipmaps only when copying level 0
			if ( level === 0 && dstTexture.generateMipmaps ) _gl.generateMipmap( _gl.TEXTURE_2D );

			state.unbindTexture();

		};

		this.copyTextureToTexture3D = function ( sourceBox, position, srcTexture, dstTexture, level = 0 ) {

			const width = Math.round( sourceBox.max.x - sourceBox.min.x );
			const height = Math.round( sourceBox.max.y - sourceBox.min.y );
			const depth = sourceBox.max.z - sourceBox.min.z + 1;
			const glFormat = utils.convert( dstTexture.format );
			const glType = utils.convert( dstTexture.type );
			let glTarget;

			if ( dstTexture.isData3DTexture ) {

				textures.setTexture3D( dstTexture, 0 );
				glTarget = _gl.TEXTURE_3D;

			} else if ( dstTexture.isDataArrayTexture || dstTexture.isCompressedArrayTexture ) {

				textures.setTexture2DArray( dstTexture, 0 );
				glTarget = _gl.TEXTURE_2D_ARRAY;

			} else {

				console.warn( 'THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.' );
				return;

			}

			_gl.pixelStorei( _gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY );
			_gl.pixelStorei( _gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha );
			_gl.pixelStorei( _gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment );

			const unpackRowLen = _gl.getParameter( _gl.UNPACK_ROW_LENGTH );
			const unpackImageHeight = _gl.getParameter( _gl.UNPACK_IMAGE_HEIGHT );
			const unpackSkipPixels = _gl.getParameter( _gl.UNPACK_SKIP_PIXELS );
			const unpackSkipRows = _gl.getParameter( _gl.UNPACK_SKIP_ROWS );
			const unpackSkipImages = _gl.getParameter( _gl.UNPACK_SKIP_IMAGES );

			const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[ level ] : srcTexture.image;

			_gl.pixelStorei( _gl.UNPACK_ROW_LENGTH, image.width );
			_gl.pixelStorei( _gl.UNPACK_IMAGE_HEIGHT, image.height );
			_gl.pixelStorei( _gl.UNPACK_SKIP_PIXELS, sourceBox.min.x );
			_gl.pixelStorei( _gl.UNPACK_SKIP_ROWS, sourceBox.min.y );
			_gl.pixelStorei( _gl.UNPACK_SKIP_IMAGES, sourceBox.min.z );

			if ( srcTexture.isDataTexture || srcTexture.isData3DTexture ) {

				_gl.texSubImage3D( glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image.data );

			} else {

				if ( dstTexture.isCompressedArrayTexture ) {

					_gl.compressedTexSubImage3D( glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, image.data );

				} else {

					_gl.texSubImage3D( glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image );

				}

			}

			_gl.pixelStorei( _gl.UNPACK_ROW_LENGTH, unpackRowLen );
			_gl.pixelStorei( _gl.UNPACK_IMAGE_HEIGHT, unpackImageHeight );
			_gl.pixelStorei( _gl.UNPACK_SKIP_PIXELS, unpackSkipPixels );
			_gl.pixelStorei( _gl.UNPACK_SKIP_ROWS, unpackSkipRows );
			_gl.pixelStorei( _gl.UNPACK_SKIP_IMAGES, unpackSkipImages );

			// Generate mipmaps only when copying level 0
			if ( level === 0 && dstTexture.generateMipmaps ) _gl.generateMipmap( glTarget );

			state.unbindTexture();

		};

		this.initTexture = function ( texture ) {

			if ( texture.isCubeTexture ) {

				textures.setTextureCube( texture, 0 );

			} else if ( texture.isData3DTexture ) {

				textures.setTexture3D( texture, 0 );

			} else if ( texture.isDataArrayTexture || texture.isCompressedArrayTexture ) {

				textures.setTexture2DArray( texture, 0 );

			} else {

				textures.setTexture2D( texture, 0 );

			}

			state.unbindTexture();

		};

		this.resetState = function () {

			_currentActiveCubeFace = 0;
			_currentActiveMipmapLevel = 0;
			_currentRenderTarget = null;

			state.reset();
			bindingStates.reset();

		};

		if ( typeof __THREE_DEVTOOLS__ !== 'undefined' ) {

			__THREE_DEVTOOLS__.dispatchEvent( new CustomEvent( 'observe', { detail: this } ) );

		}

	}

	get coordinateSystem() {

		return WebGLCoordinateSystem;

	}

	get outputColorSpace() {

		return this._outputColorSpace;

	}

	set outputColorSpace( colorSpace ) {

		this._outputColorSpace = colorSpace;

		const gl = this.getContext();
		gl.drawingBufferColorSpace = colorSpace === DisplayP3ColorSpace ? 'display-p3' : 'srgb';
		gl.unpackColorSpace = ColorManagement.workingColorSpace === LinearDisplayP3ColorSpace ? 'display-p3' : 'srgb';

	}

	get useLegacyLights() { // @deprecated, r155

		console.warn( 'THREE.WebGLRenderer: The property .useLegacyLights has been deprecated. Migrate your lighting according to the following guide: https://discourse.threejs.org/t/updates-to-lighting-in-three-js-r155/53733.' );
		return this._useLegacyLights;

	}

	set useLegacyLights( value ) { // @deprecated, r155

		console.warn( 'THREE.WebGLRenderer: The property .useLegacyLights has been deprecated. Migrate your lighting according to the following guide: https://discourse.threejs.org/t/updates-to-lighting-in-three-js-r155/53733.' );
		this._useLegacyLights = value;

	}

}

class FogExp2 {

	constructor( color, density = 0.00025 ) {

		this.isFogExp2 = true;

		this.name = '';

		this.color = new Color( color );
		this.density = density;

	}

	clone() {

		return new FogExp2( this.color, this.density );

	}

	toJSON( /* meta */ ) {

		return {
			type: 'FogExp2',
			name: this.name,
			color: this.color.getHex(),
			density: this.density
		};

	}

}

class Fog {

	constructor( color, near = 1, far = 1000 ) {

		this.isFog = true;

		this.name = '';

		this.color = new Color( color );

		this.near = near;
		this.far = far;

	}

	clone() {

		return new Fog( this.color, this.near, this.far );

	}

	toJSON( /* meta */ ) {

		return {
			type: 'Fog',
			name: this.name,
			color: this.color.getHex(),
			near: this.near,
			far: this.far
		};

	}

}

class Scene extends Object3D {

	constructor() {

		super();

		this.isScene = true;

		this.type = 'Scene';

		this.background = null;
		this.environment = null;
		this.fog = null;

		this.backgroundBlurriness = 0;
		this.backgroundIntensity = 1;
		this.backgroundRotation = new Euler();

		this.environmentIntensity = 1;
		this.environmentRotation = new Euler();

		this.overrideMaterial = null;

		if ( typeof __THREE_DEVTOOLS__ !== 'undefined' ) {

			__THREE_DEVTOOLS__.dispatchEvent( new CustomEvent( 'observe', { detail: this } ) );

		}

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		if ( source.background !== null ) this.background = source.background.clone();
		if ( source.environment !== null ) this.environment = source.environment.clone();
		if ( source.fog !== null ) this.fog = source.fog.clone();

		this.backgroundBlurriness = source.backgroundBlurriness;
		this.backgroundIntensity = source.backgroundIntensity;
		this.backgroundRotation.copy( source.backgroundRotation );

		this.environmentIntensity = source.environmentIntensity;
		this.environmentRotation.copy( source.environmentRotation );

		if ( source.overrideMaterial !== null ) this.overrideMaterial = source.overrideMaterial.clone();

		this.matrixAutoUpdate = source.matrixAutoUpdate;

		return this;

	}

	toJSON( meta ) {

		const data = super.toJSON( meta );

		if ( this.fog !== null ) data.object.fog = this.fog.toJSON();

		if ( this.backgroundBlurriness > 0 ) data.object.backgroundBlurriness = this.backgroundBlurriness;
		if ( this.backgroundIntensity !== 1 ) data.object.backgroundIntensity = this.backgroundIntensity;
		data.object.backgroundRotation = this.backgroundRotation.toArray();

		if ( this.environmentIntensity !== 1 ) data.object.environmentIntensity = this.environmentIntensity;
		data.object.environmentRotation = this.environmentRotation.toArray();

		return data;

	}

}

class InterleavedBuffer {

	constructor( array, stride ) {

		this.isInterleavedBuffer = true;

		this.array = array;
		this.stride = stride;
		this.count = array !== undefined ? array.length / stride : 0;

		this.usage = StaticDrawUsage;
		this._updateRange = { offset: 0, count: - 1 };
		this.updateRanges = [];

		this.version = 0;

		this.uuid = generateUUID();

	}

	onUploadCallback() {}

	set needsUpdate( value ) {

		if ( value === true ) this.version ++;

	}

	get updateRange() {

		warnOnce( 'THREE.InterleavedBuffer: updateRange() is deprecated and will be removed in r169. Use addUpdateRange() instead.' ); // @deprecated, r159
		return this._updateRange;

	}

	setUsage( value ) {

		this.usage = value;

		return this;

	}

	addUpdateRange( start, count ) {

		this.updateRanges.push( { start, count } );

	}

	clearUpdateRanges() {

		this.updateRanges.length = 0;

	}

	copy( source ) {

		this.array = new source.array.constructor( source.array );
		this.count = source.count;
		this.stride = source.stride;
		this.usage = source.usage;

		return this;

	}

	copyAt( index1, attribute, index2 ) {

		index1 *= this.stride;
		index2 *= attribute.stride;

		for ( let i = 0, l = this.stride; i < l; i ++ ) {

			this.array[ index1 + i ] = attribute.array[ index2 + i ];

		}

		return this;

	}

	set( value, offset = 0 ) {

		this.array.set( value, offset );

		return this;

	}

	clone( data ) {

		if ( data.arrayBuffers === undefined ) {

			data.arrayBuffers = {};

		}

		if ( this.array.buffer._uuid === undefined ) {

			this.array.buffer._uuid = generateUUID();

		}

		if ( data.arrayBuffers[ this.array.buffer._uuid ] === undefined ) {

			data.arrayBuffers[ this.array.buffer._uuid ] = this.array.slice( 0 ).buffer;

		}

		const array = new this.array.constructor( data.arrayBuffers[ this.array.buffer._uuid ] );

		const ib = new this.constructor( array, this.stride );
		ib.setUsage( this.usage );

		return ib;

	}

	onUpload( callback ) {

		this.onUploadCallback = callback;

		return this;

	}

	toJSON( data ) {

		if ( data.arrayBuffers === undefined ) {

			data.arrayBuffers = {};

		}

		// generate UUID for array buffer if necessary

		if ( this.array.buffer._uuid === undefined ) {

			this.array.buffer._uuid = generateUUID();

		}

		if ( data.arrayBuffers[ this.array.buffer._uuid ] === undefined ) {

			data.arrayBuffers[ this.array.buffer._uuid ] = Array.from( new Uint32Array( this.array.buffer ) );

		}

		//

		return {
			uuid: this.uuid,
			buffer: this.array.buffer._uuid,
			type: this.array.constructor.name,
			stride: this.stride
		};

	}

}

const _vector$6 = /*@__PURE__*/ new Vector3();

class InterleavedBufferAttribute {

	constructor( interleavedBuffer, itemSize, offset, normalized = false ) {

		this.isInterleavedBufferAttribute = true;

		this.name = '';

		this.data = interleavedBuffer;
		this.itemSize = itemSize;
		this.offset = offset;

		this.normalized = normalized;

	}

	get count() {

		return this.data.count;

	}

	get array() {

		return this.data.array;

	}

	set needsUpdate( value ) {

		this.data.needsUpdate = value;

	}

	applyMatrix4( m ) {

		for ( let i = 0, l = this.data.count; i < l; i ++ ) {

			_vector$6.fromBufferAttribute( this, i );

			_vector$6.applyMatrix4( m );

			this.setXYZ( i, _vector$6.x, _vector$6.y, _vector$6.z );

		}

		return this;

	}

	applyNormalMatrix( m ) {

		for ( let i = 0, l = this.count; i < l; i ++ ) {

			_vector$6.fromBufferAttribute( this, i );

			_vector$6.applyNormalMatrix( m );

			this.setXYZ( i, _vector$6.x, _vector$6.y, _vector$6.z );

		}

		return this;

	}

	transformDirection( m ) {

		for ( let i = 0, l = this.count; i < l; i ++ ) {

			_vector$6.fromBufferAttribute( this, i );

			_vector$6.transformDirection( m );

			this.setXYZ( i, _vector$6.x, _vector$6.y, _vector$6.z );

		}

		return this;

	}

	getComponent( index, component ) {

		let value = this.array[ index * this.data.stride + this.offset + component ];

		if ( this.normalized ) value = denormalize( value, this.array );

		return value;

	}

	setComponent( index, component, value ) {

		if ( this.normalized ) value = normalize( value, this.array );

		this.data.array[ index * this.data.stride + this.offset + component ] = value;

		return this;

	}

	setX( index, x ) {

		if ( this.normalized ) x = normalize( x, this.array );

		this.data.array[ index * this.data.stride + this.offset ] = x;

		return this;

	}

	setY( index, y ) {

		if ( this.normalized ) y = normalize( y, this.array );

		this.data.array[ index * this.data.stride + this.offset + 1 ] = y;

		return this;

	}

	setZ( index, z ) {

		if ( this.normalized ) z = normalize( z, this.array );

		this.data.array[ index * this.data.stride + this.offset + 2 ] = z;

		return this;

	}

	setW( index, w ) {

		if ( this.normalized ) w = normalize( w, this.array );

		this.data.array[ index * this.data.stride + this.offset + 3 ] = w;

		return this;

	}

	getX( index ) {

		let x = this.data.array[ index * this.data.stride + this.offset ];

		if ( this.normalized ) x = denormalize( x, this.array );

		return x;

	}

	getY( index ) {

		let y = this.data.array[ index * this.data.stride + this.offset + 1 ];

		if ( this.normalized ) y = denormalize( y, this.array );

		return y;

	}

	getZ( index ) {

		let z = this.data.array[ index * this.data.stride + this.offset + 2 ];

		if ( this.normalized ) z = denormalize( z, this.array );

		return z;

	}

	getW( index ) {

		let w = this.data.array[ index * this.data.stride + this.offset + 3 ];

		if ( this.normalized ) w = denormalize( w, this.array );

		return w;

	}

	setXY( index, x, y ) {

		index = index * this.data.stride + this.offset;

		if ( this.normalized ) {

			x = normalize( x, this.array );
			y = normalize( y, this.array );

		}

		this.data.array[ index + 0 ] = x;
		this.data.array[ index + 1 ] = y;

		return this;

	}

	setXYZ( index, x, y, z ) {

		index = index * this.data.stride + this.offset;

		if ( this.normalized ) {

			x = normalize( x, this.array );
			y = normalize( y, this.array );
			z = normalize( z, this.array );

		}

		this.data.array[ index + 0 ] = x;
		this.data.array[ index + 1 ] = y;
		this.data.array[ index + 2 ] = z;

		return this;

	}

	setXYZW( index, x, y, z, w ) {

		index = index * this.data.stride + this.offset;

		if ( this.normalized ) {

			x = normalize( x, this.array );
			y = normalize( y, this.array );
			z = normalize( z, this.array );
			w = normalize( w, this.array );

		}

		this.data.array[ index + 0 ] = x;
		this.data.array[ index + 1 ] = y;
		this.data.array[ index + 2 ] = z;
		this.data.array[ index + 3 ] = w;

		return this;

	}

	clone( data ) {

		if ( data === undefined ) {

			console.log( 'THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.' );

			const array = [];

			for ( let i = 0; i < this.count; i ++ ) {

				const index = i * this.data.stride + this.offset;

				for ( let j = 0; j < this.itemSize; j ++ ) {

					array.push( this.data.array[ index + j ] );

				}

			}

			return new BufferAttribute( new this.array.constructor( array ), this.itemSize, this.normalized );

		} else {

			if ( data.interleavedBuffers === undefined ) {

				data.interleavedBuffers = {};

			}

			if ( data.interleavedBuffers[ this.data.uuid ] === undefined ) {

				data.interleavedBuffers[ this.data.uuid ] = this.data.clone( data );

			}

			return new InterleavedBufferAttribute( data.interleavedBuffers[ this.data.uuid ], this.itemSize, this.offset, this.normalized );

		}

	}

	toJSON( data ) {

		if ( data === undefined ) {

			console.log( 'THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.' );

			const array = [];

			for ( let i = 0; i < this.count; i ++ ) {

				const index = i * this.data.stride + this.offset;

				for ( let j = 0; j < this.itemSize; j ++ ) {

					array.push( this.data.array[ index + j ] );

				}

			}

			// de-interleave data and save it as an ordinary buffer attribute for now

			return {
				itemSize: this.itemSize,
				type: this.array.constructor.name,
				array: array,
				normalized: this.normalized
			};

		} else {

			// save as true interleaved attribute

			if ( data.interleavedBuffers === undefined ) {

				data.interleavedBuffers = {};

			}

			if ( data.interleavedBuffers[ this.data.uuid ] === undefined ) {

				data.interleavedBuffers[ this.data.uuid ] = this.data.toJSON( data );

			}

			return {
				isInterleavedBufferAttribute: true,
				itemSize: this.itemSize,
				data: this.data.uuid,
				offset: this.offset,
				normalized: this.normalized
			};

		}

	}

}

class SpriteMaterial extends Material {

	constructor( parameters ) {

		super();

		this.isSpriteMaterial = true;

		this.type = 'SpriteMaterial';

		this.color = new Color( 0xffffff );

		this.map = null;

		this.alphaMap = null;

		this.rotation = 0;

		this.sizeAttenuation = true;

		this.transparent = true;

		this.fog = true;

		this.setValues( parameters );

	}

	copy( source ) {

		super.copy( source );

		this.color.copy( source.color );

		this.map = source.map;

		this.alphaMap = source.alphaMap;

		this.rotation = source.rotation;

		this.sizeAttenuation = source.sizeAttenuation;

		this.fog = source.fog;

		return this;

	}

}

let _geometry;

const _intersectPoint = /*@__PURE__*/ new Vector3();
const _worldScale = /*@__PURE__*/ new Vector3();
const _mvPosition = /*@__PURE__*/ new Vector3();

const _alignedPosition = /*@__PURE__*/ new Vector2();
const _rotatedPosition = /*@__PURE__*/ new Vector2();
const _viewWorldMatrix = /*@__PURE__*/ new Matrix4();

const _vA = /*@__PURE__*/ new Vector3();
const _vB = /*@__PURE__*/ new Vector3();
const _vC = /*@__PURE__*/ new Vector3();

const _uvA = /*@__PURE__*/ new Vector2();
const _uvB = /*@__PURE__*/ new Vector2();
const _uvC = /*@__PURE__*/ new Vector2();

class Sprite extends Object3D {

	constructor( material = new SpriteMaterial() ) {

		super();

		this.isSprite = true;

		this.type = 'Sprite';

		if ( _geometry === undefined ) {

			_geometry = new BufferGeometry();

			const float32Array = new Float32Array( [
				- 0.5, - 0.5, 0, 0, 0,
				0.5, - 0.5, 0, 1, 0,
				0.5, 0.5, 0, 1, 1,
				- 0.5, 0.5, 0, 0, 1
			] );

			const interleavedBuffer = new InterleavedBuffer( float32Array, 5 );

			_geometry.setIndex( [ 0, 1, 2,	0, 2, 3 ] );
			_geometry.setAttribute( 'position', new InterleavedBufferAttribute( interleavedBuffer, 3, 0, false ) );
			_geometry.setAttribute( 'uv', new InterleavedBufferAttribute( interleavedBuffer, 2, 3, false ) );

		}

		this.geometry = _geometry;
		this.material = material;

		this.center = new Vector2( 0.5, 0.5 );

	}

	raycast( raycaster, intersects ) {

		if ( raycaster.camera === null ) {

			console.error( 'THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.' );

		}

		_worldScale.setFromMatrixScale( this.matrixWorld );

		_viewWorldMatrix.copy( raycaster.camera.matrixWorld );
		this.modelViewMatrix.multiplyMatrices( raycaster.camera.matrixWorldInverse, this.matrixWorld );

		_mvPosition.setFromMatrixPosition( this.modelViewMatrix );

		if ( raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false ) {

			_worldScale.multiplyScalar( - _mvPosition.z );

		}

		const rotation = this.material.rotation;
		let sin, cos;

		if ( rotation !== 0 ) {

			cos = Math.cos( rotation );
			sin = Math.sin( rotation );

		}

		const center = this.center;

		transformVertex( _vA.set( - 0.5, - 0.5, 0 ), _mvPosition, center, _worldScale, sin, cos );
		transformVertex( _vB.set( 0.5, - 0.5, 0 ), _mvPosition, center, _worldScale, sin, cos );
		transformVertex( _vC.set( 0.5, 0.5, 0 ), _mvPosition, center, _worldScale, sin, cos );

		_uvA.set( 0, 0 );
		_uvB.set( 1, 0 );
		_uvC.set( 1, 1 );

		// check first triangle
		let intersect = raycaster.ray.intersectTriangle( _vA, _vB, _vC, false, _intersectPoint );

		if ( intersect === null ) {

			// check second triangle
			transformVertex( _vB.set( - 0.5, 0.5, 0 ), _mvPosition, center, _worldScale, sin, cos );
			_uvB.set( 0, 1 );

			intersect = raycaster.ray.intersectTriangle( _vA, _vC, _vB, false, _intersectPoint );
			if ( intersect === null ) {

				return;

			}

		}

		const distance = raycaster.ray.origin.distanceTo( _intersectPoint );

		if ( distance < raycaster.near || distance > raycaster.far ) return;

		intersects.push( {

			distance: distance,
			point: _intersectPoint.clone(),
			uv: Triangle.getInterpolation( _intersectPoint, _vA, _vB, _vC, _uvA, _uvB, _uvC, new Vector2() ),
			face: null,
			object: this

		} );

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		if ( source.center !== undefined ) this.center.copy( source.center );

		this.material = source.material;

		return this;

	}

}

function transformVertex( vertexPosition, mvPosition, center, scale, sin, cos ) {

	// compute position in camera space
	_alignedPosition.subVectors( vertexPosition, center ).addScalar( 0.5 ).multiply( scale );

	// to check if rotation is not zero
	if ( sin !== undefined ) {

		_rotatedPosition.x = ( cos * _alignedPosition.x ) - ( sin * _alignedPosition.y );
		_rotatedPosition.y = ( sin * _alignedPosition.x ) + ( cos * _alignedPosition.y );

	} else {

		_rotatedPosition.copy( _alignedPosition );

	}


	vertexPosition.copy( mvPosition );
	vertexPosition.x += _rotatedPosition.x;
	vertexPosition.y += _rotatedPosition.y;

	// transform to world space
	vertexPosition.applyMatrix4( _viewWorldMatrix );

}

const _v1$2 = /*@__PURE__*/ new Vector3();
const _v2$1 = /*@__PURE__*/ new Vector3();

class LOD extends Object3D {

	constructor() {

		super();

		this._currentLevel = 0;

		this.type = 'LOD';

		Object.defineProperties( this, {
			levels: {
				enumerable: true,
				value: []
			},
			isLOD: {
				value: true,
			}
		} );

		this.autoUpdate = true;

	}

	copy( source ) {

		super.copy( source, false );

		const levels = source.levels;

		for ( let i = 0, l = levels.length; i < l; i ++ ) {

			const level = levels[ i ];

			this.addLevel( level.object.clone(), level.distance, level.hysteresis );

		}

		this.autoUpdate = source.autoUpdate;

		return this;

	}

	addLevel( object, distance = 0, hysteresis = 0 ) {

		distance = Math.abs( distance );

		const levels = this.levels;

		let l;

		for ( l = 0; l < levels.length; l ++ ) {

			if ( distance < levels[ l ].distance ) {

				break;

			}

		}

		levels.splice( l, 0, { distance: distance, hysteresis: hysteresis, object: object } );

		this.add( object );

		return this;

	}

	getCurrentLevel() {

		return this._currentLevel;

	}



	getObjectForDistance( distance ) {

		const levels = this.levels;

		if ( levels.length > 0 ) {

			let i, l;

			for ( i = 1, l = levels.length; i < l; i ++ ) {

				let levelDistance = levels[ i ].distance;

				if ( levels[ i ].object.visible ) {

					levelDistance -= levelDistance * levels[ i ].hysteresis;

				}

				if ( distance < levelDistance ) {

					break;

				}

			}

			return levels[ i - 1 ].object;

		}

		return null;

	}

	raycast( raycaster, intersects ) {

		const levels = this.levels;

		if ( levels.length > 0 ) {

			_v1$2.setFromMatrixPosition( this.matrixWorld );

			const distance = raycaster.ray.origin.distanceTo( _v1$2 );

			this.getObjectForDistance( distance ).raycast( raycaster, intersects );

		}

	}

	update( camera ) {

		const levels = this.levels;

		if ( levels.length > 1 ) {

			_v1$2.setFromMatrixPosition( camera.matrixWorld );
			_v2$1.setFromMatrixPosition( this.matrixWorld );

			const distance = _v1$2.distanceTo( _v2$1 ) / camera.zoom;

			levels[ 0 ].object.visible = true;

			let i, l;

			for ( i = 1, l = levels.length; i < l; i ++ ) {

				let levelDistance = levels[ i ].distance;

				if ( levels[ i ].object.visible ) {

					levelDistance -= levelDistance * levels[ i ].hysteresis;

				}

				if ( distance >= levelDistance ) {

					levels[ i - 1 ].object.visible = false;
					levels[ i ].object.visible = true;

				} else {

					break;

				}

			}

			this._currentLevel = i - 1;

			for ( ; i < l; i ++ ) {

				levels[ i ].object.visible = false;

			}

		}

	}

	toJSON( meta ) {

		const data = super.toJSON( meta );

		if ( this.autoUpdate === false ) data.object.autoUpdate = false;

		data.object.levels = [];

		const levels = this.levels;

		for ( let i = 0, l = levels.length; i < l; i ++ ) {

			const level = levels[ i ];

			data.object.levels.push( {
				object: level.object.uuid,
				distance: level.distance,
				hysteresis: level.hysteresis
			} );

		}

		return data;

	}

}

const _basePosition = /*@__PURE__*/ new Vector3();

const _skinIndex = /*@__PURE__*/ new Vector4();
const _skinWeight = /*@__PURE__*/ new Vector4();

const _vector3 = /*@__PURE__*/ new Vector3();
const _matrix4 = /*@__PURE__*/ new Matrix4();
const _vertex = /*@__PURE__*/ new Vector3();

const _sphere$4 = /*@__PURE__*/ new Sphere();
const _inverseMatrix$2 = /*@__PURE__*/ new Matrix4();
const _ray$2 = /*@__PURE__*/ new Ray();

class SkinnedMesh extends Mesh {

	constructor( geometry, material ) {

		super( geometry, material );

		this.isSkinnedMesh = true;

		this.type = 'SkinnedMesh';

		this.bindMode = AttachedBindMode;
		this.bindMatrix = new Matrix4();
		this.bindMatrixInverse = new Matrix4();

		this.boundingBox = null;
		this.boundingSphere = null;

	}

	computeBoundingBox() {

		const geometry = this.geometry;

		if ( this.boundingBox === null ) {

			this.boundingBox = new Box3();

		}

		this.boundingBox.makeEmpty();

		const positionAttribute = geometry.getAttribute( 'position' );

		for ( let i = 0; i < positionAttribute.count; i ++ ) {

			this.getVertexPosition( i, _vertex );
			this.boundingBox.expandByPoint( _vertex );

		}

	}

	computeBoundingSphere() {

		const geometry = this.geometry;

		if ( this.boundingSphere === null ) {

			this.boundingSphere = new Sphere();

		}

		this.boundingSphere.makeEmpty();

		const positionAttribute = geometry.getAttribute( 'position' );

		for ( let i = 0; i < positionAttribute.count; i ++ ) {

			this.getVertexPosition( i, _vertex );
			this.boundingSphere.expandByPoint( _vertex );

		}

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		this.bindMode = source.bindMode;
		this.bindMatrix.copy( source.bindMatrix );
		this.bindMatrixInverse.copy( source.bindMatrixInverse );

		this.skeleton = source.skeleton;

		if ( source.boundingBox !== null ) this.boundingBox = source.boundingBox.clone();
		if ( source.boundingSphere !== null ) this.boundingSphere = source.boundingSphere.clone();

		return this;

	}

	raycast( raycaster, intersects ) {

		const material = this.material;
		const matrixWorld = this.matrixWorld;

		if ( material === undefined ) return;

		// test with bounding sphere in world space

		if ( this.boundingSphere === null ) this.computeBoundingSphere();

		_sphere$4.copy( this.boundingSphere );
		_sphere$4.applyMatrix4( matrixWorld );

		if ( raycaster.ray.intersectsSphere( _sphere$4 ) === false ) return;

		// convert ray to local space of skinned mesh

		_inverseMatrix$2.copy( matrixWorld ).invert();
		_ray$2.copy( raycaster.ray ).applyMatrix4( _inverseMatrix$2 );

		// test with bounding box in local space

		if ( this.boundingBox !== null ) {

			if ( _ray$2.intersectsBox( this.boundingBox ) === false ) return;

		}

		// test for intersections with geometry

		this._computeIntersections( raycaster, intersects, _ray$2 );

	}

	getVertexPosition( index, target ) {

		super.getVertexPosition( index, target );

		this.applyBoneTransform( index, target );

		return target;

	}

	bind( skeleton, bindMatrix ) {

		this.skeleton = skeleton;

		if ( bindMatrix === undefined ) {

			this.updateMatrixWorld( true );

			this.skeleton.calculateInverses();

			bindMatrix = this.matrixWorld;

		}

		this.bindMatrix.copy( bindMatrix );
		this.bindMatrixInverse.copy( bindMatrix ).invert();

	}

	pose() {

		this.skeleton.pose();

	}

	normalizeSkinWeights() {

		const vector = new Vector4();

		const skinWeight = this.geometry.attributes.skinWeight;

		for ( let i = 0, l = skinWeight.count; i < l; i ++ ) {

			vector.fromBufferAttribute( skinWeight, i );

			const scale = 1.0 / vector.manhattanLength();

			if ( scale !== Infinity ) {

				vector.multiplyScalar( scale );

			} else {

				vector.set( 1, 0, 0, 0 ); // do something reasonable

			}

			skinWeight.setXYZW( i, vector.x, vector.y, vector.z, vector.w );

		}

	}

	updateMatrixWorld( force ) {

		super.updateMatrixWorld( force );

		if ( this.bindMode === AttachedBindMode ) {

			this.bindMatrixInverse.copy( this.matrixWorld ).invert();

		} else if ( this.bindMode === DetachedBindMode ) {

			this.bindMatrixInverse.copy( this.bindMatrix ).invert();

		} else {

			console.warn( 'THREE.SkinnedMesh: Unrecognized bindMode: ' + this.bindMode );

		}

	}

	applyBoneTransform( index, vector ) {

		const skeleton = this.skeleton;
		const geometry = this.geometry;

		_skinIndex.fromBufferAttribute( geometry.attributes.skinIndex, index );
		_skinWeight.fromBufferAttribute( geometry.attributes.skinWeight, index );

		_basePosition.copy( vector ).applyMatrix4( this.bindMatrix );

		vector.set( 0, 0, 0 );

		for ( let i = 0; i < 4; i ++ ) {

			const weight = _skinWeight.getComponent( i );

			if ( weight !== 0 ) {

				const boneIndex = _skinIndex.getComponent( i );

				_matrix4.multiplyMatrices( skeleton.bones[ boneIndex ].matrixWorld, skeleton.boneInverses[ boneIndex ] );

				vector.addScaledVector( _vector3.copy( _basePosition ).applyMatrix4( _matrix4 ), weight );

			}

		}

		return vector.applyMatrix4( this.bindMatrixInverse );

	}

}

class Bone extends Object3D {

	constructor() {

		super();

		this.isBone = true;

		this.type = 'Bone';

	}

}

class DataTexture extends Texture {

	constructor( data = null, width = 1, height = 1, format, type, mapping, wrapS, wrapT, magFilter = NearestFilter, minFilter = NearestFilter, anisotropy, colorSpace ) {

		super( null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace );

		this.isDataTexture = true;

		this.image = { data: data, width: width, height: height };

		this.generateMipmaps = false;
		this.flipY = false;
		this.unpackAlignment = 1;

	}

}

const _offsetMatrix = /*@__PURE__*/ new Matrix4();
const _identityMatrix$1 = /*@__PURE__*/ new Matrix4();

class Skeleton {

	constructor( bones = [], boneInverses = [] ) {

		this.uuid = generateUUID();

		this.bones = bones.slice( 0 );
		this.boneInverses = boneInverses;
		this.boneMatrices = null;

		this.boneTexture = null;

		this.init();

	}

	init() {

		const bones = this.bones;
		const boneInverses = this.boneInverses;

		this.boneMatrices = new Float32Array( bones.length * 16 );

		// calculate inverse bone matrices if necessary

		if ( boneInverses.length === 0 ) {

			this.calculateInverses();

		} else {

			// handle special case

			if ( bones.length !== boneInverses.length ) {

				console.warn( 'THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.' );

				this.boneInverses = [];

				for ( let i = 0, il = this.bones.length; i < il; i ++ ) {

					this.boneInverses.push( new Matrix4() );

				}

			}

		}

	}

	calculateInverses() {

		this.boneInverses.length = 0;

		for ( let i = 0, il = this.bones.length; i < il; i ++ ) {

			const inverse = new Matrix4();

			if ( this.bones[ i ] ) {

				inverse.copy( this.bones[ i ].matrixWorld ).invert();

			}

			this.boneInverses.push( inverse );

		}

	}

	pose() {

		// recover the bind-time world matrices

		for ( let i = 0, il = this.bones.length; i < il; i ++ ) {

			const bone = this.bones[ i ];

			if ( bone ) {

				bone.matrixWorld.copy( this.boneInverses[ i ] ).invert();

			}

		}

		// compute the local matrices, positions, rotations and scales

		for ( let i = 0, il = this.bones.length; i < il; i ++ ) {

			const bone = this.bones[ i ];

			if ( bone ) {

				if ( bone.parent && bone.parent.isBone ) {

					bone.matrix.copy( bone.parent.matrixWorld ).invert();
					bone.matrix.multiply( bone.matrixWorld );

				} else {

					bone.matrix.copy( bone.matrixWorld );

				}

				bone.matrix.decompose( bone.position, bone.quaternion, bone.scale );

			}

		}

	}

	update() {

		const bones = this.bones;
		const boneInverses = this.boneInverses;
		const boneMatrices = this.boneMatrices;
		const boneTexture = this.boneTexture;

		// flatten bone matrices to array

		for ( let i = 0, il = bones.length; i < il; i ++ ) {

			// compute the offset between the current and the original transform

			const matrix = bones[ i ] ? bones[ i ].matrixWorld : _identityMatrix$1;

			_offsetMatrix.multiplyMatrices( matrix, boneInverses[ i ] );
			_offsetMatrix.toArray( boneMatrices, i * 16 );

		}

		if ( boneTexture !== null ) {

			boneTexture.needsUpdate = true;

		}

	}

	clone() {

		return new Skeleton( this.bones, this.boneInverses );

	}

	computeBoneTexture() {

		// layout (1 matrix = 4 pixels)
		//      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
		//  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
		//       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
		//       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
		//       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)

		let size = Math.sqrt( this.bones.length * 4 ); // 4 pixels needed for 1 matrix
		size = Math.ceil( size / 4 ) * 4;
		size = Math.max( size, 4 );

		const boneMatrices = new Float32Array( size * size * 4 ); // 4 floats per RGBA pixel
		boneMatrices.set( this.boneMatrices ); // copy current values

		const boneTexture = new DataTexture( boneMatrices, size, size, RGBAFormat, FloatType );
		boneTexture.needsUpdate = true;

		this.boneMatrices = boneMatrices;
		this.boneTexture = boneTexture;

		return this;

	}

	getBoneByName( name ) {

		for ( let i = 0, il = this.bones.length; i < il; i ++ ) {

			const bone = this.bones[ i ];

			if ( bone.name === name ) {

				return bone;

			}

		}

		return undefined;

	}

	dispose( ) {

		if ( this.boneTexture !== null ) {

			this.boneTexture.dispose();

			this.boneTexture = null;

		}

	}

	fromJSON( json, bones ) {

		this.uuid = json.uuid;

		for ( let i = 0, l = json.bones.length; i < l; i ++ ) {

			const uuid = json.bones[ i ];
			let bone = bones[ uuid ];

			if ( bone === undefined ) {

				console.warn( 'THREE.Skeleton: No bone found with UUID:', uuid );
				bone = new Bone();

			}

			this.bones.push( bone );
			this.boneInverses.push( new Matrix4().fromArray( json.boneInverses[ i ] ) );

		}

		this.init();

		return this;

	}

	toJSON() {

		const data = {
			metadata: {
				version: 4.6,
				type: 'Skeleton',
				generator: 'Skeleton.toJSON'
			},
			bones: [],
			boneInverses: []
		};

		data.uuid = this.uuid;

		const bones = this.bones;
		const boneInverses = this.boneInverses;

		for ( let i = 0, l = bones.length; i < l; i ++ ) {

			const bone = bones[ i ];
			data.bones.push( bone.uuid );

			const boneInverse = boneInverses[ i ];
			data.boneInverses.push( boneInverse.toArray() );

		}

		return data;

	}

}

class InstancedBufferAttribute extends BufferAttribute {

	constructor( array, itemSize, normalized, meshPerAttribute = 1 ) {

		super( array, itemSize, normalized );

		this.isInstancedBufferAttribute = true;

		this.meshPerAttribute = meshPerAttribute;

	}

	copy( source ) {

		super.copy( source );

		this.meshPerAttribute = source.meshPerAttribute;

		return this;

	}

	toJSON() {

		const data = super.toJSON();

		data.meshPerAttribute = this.meshPerAttribute;

		data.isInstancedBufferAttribute = true;

		return data;

	}

}

const _instanceLocalMatrix = /*@__PURE__*/ new Matrix4();
const _instanceWorldMatrix = /*@__PURE__*/ new Matrix4();

const _instanceIntersects = [];

const _box3 = /*@__PURE__*/ new Box3();
const _identity = /*@__PURE__*/ new Matrix4();
const _mesh$1 = /*@__PURE__*/ new Mesh();
const _sphere$3 = /*@__PURE__*/ new Sphere();

class InstancedMesh extends Mesh {

	constructor( geometry, material, count ) {

		super( geometry, material );

		this.isInstancedMesh = true;

		this.instanceMatrix = new InstancedBufferAttribute( new Float32Array( count * 16 ), 16 );
		this.instanceColor = null;
		this.morphTexture = null;

		this.count = count;

		this.boundingBox = null;
		this.boundingSphere = null;

		for ( let i = 0; i < count; i ++ ) {

			this.setMatrixAt( i, _identity );

		}

	}

	computeBoundingBox() {

		const geometry = this.geometry;
		const count = this.count;

		if ( this.boundingBox === null ) {

			this.boundingBox = new Box3();

		}

		if ( geometry.boundingBox === null ) {

			geometry.computeBoundingBox();

		}

		this.boundingBox.makeEmpty();

		for ( let i = 0; i < count; i ++ ) {

			this.getMatrixAt( i, _instanceLocalMatrix );

			_box3.copy( geometry.boundingBox ).applyMatrix4( _instanceLocalMatrix );

			this.boundingBox.union( _box3 );

		}

	}

	computeBoundingSphere() {

		const geometry = this.geometry;
		const count = this.count;

		if ( this.boundingSphere === null ) {

			this.boundingSphere = new Sphere();

		}

		if ( geometry.boundingSphere === null ) {

			geometry.computeBoundingSphere();

		}

		this.boundingSphere.makeEmpty();

		for ( let i = 0; i < count; i ++ ) {

			this.getMatrixAt( i, _instanceLocalMatrix );

			_sphere$3.copy( geometry.boundingSphere ).applyMatrix4( _instanceLocalMatrix );

			this.boundingSphere.union( _sphere$3 );

		}

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		this.instanceMatrix.copy( source.instanceMatrix );

		if ( source.morphTexture !== null ) this.morphTexture = source.morphTexture.clone();
		if ( source.instanceColor !== null ) this.instanceColor = source.instanceColor.clone();

		this.count = source.count;

		if ( source.boundingBox !== null ) this.boundingBox = source.boundingBox.clone();
		if ( source.boundingSphere !== null ) this.boundingSphere = source.boundingSphere.clone();

		return this;

	}

	getColorAt( index, color ) {

		color.fromArray( this.instanceColor.array, index * 3 );

	}

	getMatrixAt( index, matrix ) {

		matrix.fromArray( this.instanceMatrix.array, index * 16 );

	}

	getMorphAt( index, object ) {

		const objectInfluences = object.morphTargetInfluences;

		const array = this.morphTexture.source.data.data;

		const len = objectInfluences.length + 1; // All influences + the baseInfluenceSum

		const dataIndex = index * len + 1; // Skip the baseInfluenceSum at the beginning

		for ( let i = 0; i < objectInfluences.length; i ++ ) {

			objectInfluences[ i ] = array[ dataIndex + i ];

		}

	}

	raycast( raycaster, intersects ) {

		const matrixWorld = this.matrixWorld;
		const raycastTimes = this.count;

		_mesh$1.geometry = this.geometry;
		_mesh$1.material = this.material;

		if ( _mesh$1.material === undefined ) return;

		// test with bounding sphere first

		if ( this.boundingSphere === null ) this.computeBoundingSphere();

		_sphere$3.copy( this.boundingSphere );
		_sphere$3.applyMatrix4( matrixWorld );

		if ( raycaster.ray.intersectsSphere( _sphere$3 ) === false ) return;

		// now test each instance

		for ( let instanceId = 0; instanceId < raycastTimes; instanceId ++ ) {

			// calculate the world matrix for each instance

			this.getMatrixAt( instanceId, _instanceLocalMatrix );

			_instanceWorldMatrix.multiplyMatrices( matrixWorld, _instanceLocalMatrix );

			// the mesh represents this single instance

			_mesh$1.matrixWorld = _instanceWorldMatrix;

			_mesh$1.raycast( raycaster, _instanceIntersects );

			// process the result of raycast

			for ( let i = 0, l = _instanceIntersects.length; i < l; i ++ ) {

				const intersect = _instanceIntersects[ i ];
				intersect.instanceId = instanceId;
				intersect.object = this;
				intersects.push( intersect );

			}

			_instanceIntersects.length = 0;

		}

	}

	setColorAt( index, color ) {

		if ( this.instanceColor === null ) {

			this.instanceColor = new InstancedBufferAttribute( new Float32Array( this.instanceMatrix.count * 3 ), 3 );

		}

		color.toArray( this.instanceColor.array, index * 3 );

	}

	setMatrixAt( index, matrix ) {

		matrix.toArray( this.instanceMatrix.array, index * 16 );

	}

	setMorphAt( index, object ) {

		const objectInfluences = object.morphTargetInfluences;

		const len = objectInfluences.length + 1; // morphBaseInfluence + all influences

		if ( this.morphTexture === null ) {

			this.morphTexture = new DataTexture( new Float32Array( len * this.count ), len, this.count, RedFormat, FloatType );

		}

		const array = this.morphTexture.source.data.data;

		let morphInfluencesSum = 0;

		for ( let i = 0; i < objectInfluences.length; i ++ ) {

			morphInfluencesSum += objectInfluences[ i ];

		}

		const morphBaseInfluence = this.geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;

		const dataIndex = len * index;

		array[ dataIndex ] = morphBaseInfluence;

		array.set( objectInfluences, dataIndex + 1 );

	}

	updateMorphTargets() {

	}

	dispose() {

		this.dispatchEvent( { type: 'dispose' } );

		if ( this.morphTexture !== null ) {

			this.morphTexture.dispose();
			this.morphTexture = null;

		}

		return this;

	}

}

function sortOpaque( a, b ) {

	return a.z - b.z;

}

function sortTransparent( a, b ) {

	return b.z - a.z;

}

class MultiDrawRenderList {

	constructor() {

		this.index = 0;
		this.pool = [];
		this.list = [];

	}

	push( drawRange, z ) {

		const pool = this.pool;
		const list = this.list;
		if ( this.index >= pool.length ) {

			pool.push( {

				start: - 1,
				count: - 1,
				z: - 1,

			} );

		}

		const item = pool[ this.index ];
		list.push( item );
		this.index ++;

		item.start = drawRange.start;
		item.count = drawRange.count;
		item.z = z;

	}

	reset() {

		this.list.length = 0;
		this.index = 0;

	}

}

const ID_ATTR_NAME = 'batchId';
const _matrix$1 = /*@__PURE__*/ new Matrix4();
const _invMatrixWorld = /*@__PURE__*/ new Matrix4();
const _identityMatrix = /*@__PURE__*/ new Matrix4();
const _projScreenMatrix$2 = /*@__PURE__*/ new Matrix4();
const _frustum = /*@__PURE__*/ new Frustum();
const _box$1 = /*@__PURE__*/ new Box3();
const _sphere$2 = /*@__PURE__*/ new Sphere();
const _vector$5 = /*@__PURE__*/ new Vector3();
const _renderList = /*@__PURE__*/ new MultiDrawRenderList();
const _mesh = /*@__PURE__*/ new Mesh();
const _batchIntersects = [];

// @TODO: SkinnedMesh support?
// @TODO: geometry.groups support?
// @TODO: geometry.drawRange support?
// @TODO: geometry.morphAttributes support?
// @TODO: Support uniform parameter per geometry
// @TODO: Add an "optimize" function to pack geometry and remove data gaps

// copies data from attribute "src" into "target" starting at "targetOffset"
function copyAttributeData( src, target, targetOffset = 0 ) {

	const itemSize = target.itemSize;
	if ( src.isInterleavedBufferAttribute || src.array.constructor !== target.array.constructor ) {

		// use the component getters and setters if the array data cannot
		// be copied directly
		const vertexCount = src.count;
		for ( let i = 0; i < vertexCount; i ++ ) {

			for ( let c = 0; c < itemSize; c ++ ) {

				target.setComponent( i + targetOffset, c, src.getComponent( i, c ) );

			}

		}

	} else {

		// faster copy approach using typed array set function
		target.array.set( src.array, targetOffset * itemSize );

	}

	target.needsUpdate = true;

}

class BatchedMesh extends Mesh {

	get maxGeometryCount() {

		return this._maxGeometryCount;

	}

	constructor( maxGeometryCount, maxVertexCount, maxIndexCount = maxVertexCount * 2, material ) {

		super( new BufferGeometry(), material );

		this.isBatchedMesh = true;
		this.perObjectFrustumCulled = true;
		this.sortObjects = true;
		this.boundingBox = null;
		this.boundingSphere = null;
		this.customSort = null;

		this._drawRanges = [];
		this._reservedRanges = [];

		this._visibility = [];
		this._active = [];
		this._bounds = [];

		this._maxGeometryCount = maxGeometryCount;
		this._maxVertexCount = maxVertexCount;
		this._maxIndexCount = maxIndexCount;

		this._geometryInitialized = false;
		this._geometryCount = 0;
		this._multiDrawCounts = new Int32Array( maxGeometryCount );
		this._multiDrawStarts = new Int32Array( maxGeometryCount );
		this._multiDrawCount = 0;
		this._visibilityChanged = true;

		// Local matrix per geometry by using data texture
		this._matricesTexture = null;

		this._initMatricesTexture();

	}

	_initMatricesTexture() {

		// layout (1 matrix = 4 pixels)
		//      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
		//  with  8x8  pixel texture max   16 matrices * 4 pixels =  (8 * 8)
		//       16x16 pixel texture max   64 matrices * 4 pixels = (16 * 16)
		//       32x32 pixel texture max  256 matrices * 4 pixels = (32 * 32)
		//       64x64 pixel texture max 1024 matrices * 4 pixels = (64 * 64)

		let size = Math.sqrt( this._maxGeometryCount * 4 ); // 4 pixels needed for 1 matrix
		size = Math.ceil( size / 4 ) * 4;
		size = Math.max( size, 4 );

		const matricesArray = new Float32Array( size * size * 4 ); // 4 floats per RGBA pixel
		const matricesTexture = new DataTexture( matricesArray, size, size, RGBAFormat, FloatType );

		this._matricesTexture = matricesTexture;

	}

	_initializeGeometry( reference ) {

		const geometry = this.geometry;
		const maxVertexCount = this._maxVertexCount;
		const maxGeometryCount = this._maxGeometryCount;
		const maxIndexCount = this._maxIndexCount;
		if ( this._geometryInitialized === false ) {

			for ( const attributeName in reference.attributes ) {

				const srcAttribute = reference.getAttribute( attributeName );
				const { array, itemSize, normalized } = srcAttribute;

				const dstArray = new array.constructor( maxVertexCount * itemSize );
				const dstAttribute = new BufferAttribute( dstArray, itemSize, normalized );

				geometry.setAttribute( attributeName, dstAttribute );

			}

			if ( reference.getIndex() !== null ) {

				const indexArray = maxVertexCount > 65536
					? new Uint32Array( maxIndexCount )
					: new Uint16Array( maxIndexCount );

				geometry.setIndex( new BufferAttribute( indexArray, 1 ) );

			}

			const idArray = maxGeometryCount > 65536
				? new Uint32Array( maxVertexCount )
				: new Uint16Array( maxVertexCount );
			geometry.setAttribute( ID_ATTR_NAME, new BufferAttribute( idArray, 1 ) );

			this._geometryInitialized = true;

		}

	}

	// Make sure the geometry is compatible with the existing combined geometry attributes
	_validateGeometry( geometry ) {

		// check that the geometry doesn't have a version of our reserved id attribute
		if ( geometry.getAttribute( ID_ATTR_NAME ) ) {

			throw new Error( `BatchedMesh: Geometry cannot use attribute "${ ID_ATTR_NAME }"` );

		}

		// check to ensure the geometries are using consistent attributes and indices
		const batchGeometry = this.geometry;
		if ( Boolean( geometry.getIndex() ) !== Boolean( batchGeometry.getIndex() ) ) {

			throw new Error( 'BatchedMesh: All geometries must consistently have "index".' );

		}

		for ( const attributeName in batchGeometry.attributes ) {

			if ( attributeName === ID_ATTR_NAME ) {

				continue;

			}

			if ( ! geometry.hasAttribute( attributeName ) ) {

				throw new Error( `BatchedMesh: Added geometry missing "${ attributeName }". All geometries must have consistent attributes.` );

			}

			const srcAttribute = geometry.getAttribute( attributeName );
			const dstAttribute = batchGeometry.getAttribute( attributeName );
			if ( srcAttribute.itemSize !== dstAttribute.itemSize || srcAttribute.normalized !== dstAttribute.normalized ) {

				throw new Error( 'BatchedMesh: All attributes must have a consistent itemSize and normalized value.' );

			}

		}

	}

	setCustomSort( func ) {

		this.customSort = func;
		return this;

	}

	computeBoundingBox() {

		if ( this.boundingBox === null ) {

			this.boundingBox = new Box3();

		}

		const geometryCount = this._geometryCount;
		const boundingBox = this.boundingBox;
		const active = this._active;

		boundingBox.makeEmpty();
		for ( let i = 0; i < geometryCount; i ++ ) {

			if ( active[ i ] === false ) continue;

			this.getMatrixAt( i, _matrix$1 );
			this.getBoundingBoxAt( i, _box$1 ).applyMatrix4( _matrix$1 );
			boundingBox.union( _box$1 );

		}

	}

	computeBoundingSphere() {

		if ( this.boundingSphere === null ) {

			this.boundingSphere = new Sphere();

		}

		const geometryCount = this._geometryCount;
		const boundingSphere = this.boundingSphere;
		const active = this._active;

		boundingSphere.makeEmpty();
		for ( let i = 0; i < geometryCount; i ++ ) {

			if ( active[ i ] === false ) continue;

			this.getMatrixAt( i, _matrix$1 );
			this.getBoundingSphereAt( i, _sphere$2 ).applyMatrix4( _matrix$1 );
			boundingSphere.union( _sphere$2 );

		}

	}

	addGeometry( geometry, vertexCount = - 1, indexCount = - 1 ) {

		this._initializeGeometry( geometry );

		this._validateGeometry( geometry );

		// ensure we're not over geometry
		if ( this._geometryCount >= this._maxGeometryCount ) {

			throw new Error( 'BatchedMesh: Maximum geometry count reached.' );

		}

		// get the necessary range fo the geometry
		const reservedRange = {
			vertexStart: - 1,
			vertexCount: - 1,
			indexStart: - 1,
			indexCount: - 1,
		};

		let lastRange = null;
		const reservedRanges = this._reservedRanges;
		const drawRanges = this._drawRanges;
		const bounds = this._bounds;
		if ( this._geometryCount !== 0 ) {

			lastRange = reservedRanges[ reservedRanges.length - 1 ];

		}

		if ( vertexCount === - 1 ) {

			reservedRange.vertexCount = geometry.getAttribute( 'position' ).count;

		} else {

			reservedRange.vertexCount = vertexCount;

		}

		if ( lastRange === null ) {

			reservedRange.vertexStart = 0;

		} else {

			reservedRange.vertexStart = lastRange.vertexStart + lastRange.vertexCount;

		}

		const index = geometry.getIndex();
		const hasIndex = index !== null;
		if ( hasIndex ) {

			if ( indexCount	=== - 1 ) {

				reservedRange.indexCount = index.count;

			} else {

				reservedRange.indexCount = indexCount;

			}

			if ( lastRange === null ) {

				reservedRange.indexStart = 0;

			} else {

				reservedRange.indexStart = lastRange.indexStart + lastRange.indexCount;

			}

		}

		if (
			reservedRange.indexStart !== - 1 &&
			reservedRange.indexStart + reservedRange.indexCount > this._maxIndexCount ||
			reservedRange.vertexStart + reservedRange.vertexCount > this._maxVertexCount
		) {

			throw new Error( 'BatchedMesh: Reserved space request exceeds the maximum buffer size.' );

		}

		const visibility = this._visibility;
		const active = this._active;
		const matricesTexture = this._matricesTexture;
		const matricesArray = this._matricesTexture.image.data;

		// push new visibility states
		visibility.push( true );
		active.push( true );

		// update id
		const geometryId = this._geometryCount;
		this._geometryCount ++;

		// initialize matrix information
		_identityMatrix.toArray( matricesArray, geometryId * 16 );
		matricesTexture.needsUpdate = true;

		// add the reserved range and draw range objects
		reservedRanges.push( reservedRange );
		drawRanges.push( {
			start: hasIndex ? reservedRange.indexStart : reservedRange.vertexStart,
			count: - 1
		} );
		bounds.push( {
			boxInitialized: false,
			box: new Box3(),

			sphereInitialized: false,
			sphere: new Sphere()
		} );

		// set the id for the geometry
		const idAttribute = this.geometry.getAttribute( ID_ATTR_NAME );
		for ( let i = 0; i < reservedRange.vertexCount; i ++ ) {

			idAttribute.setX( reservedRange.vertexStart + i, geometryId );

		}

		idAttribute.needsUpdate = true;

		// update the geometry
		this.setGeometryAt( geometryId, geometry );

		return geometryId;

	}

	setGeometryAt( id, geometry ) {

		if ( id >= this._geometryCount ) {

			throw new Error( 'BatchedMesh: Maximum geometry count reached.' );

		}

		this._validateGeometry( geometry );

		const batchGeometry = this.geometry;
		const hasIndex = batchGeometry.getIndex() !== null;
		const dstIndex = batchGeometry.getIndex();
		const srcIndex = geometry.getIndex();
		const reservedRange = this._reservedRanges[ id ];
		if (
			hasIndex &&
			srcIndex.count > reservedRange.indexCount ||
			geometry.attributes.position.count > reservedRange.vertexCount
		) {

			throw new Error( 'BatchedMesh: Reserved space not large enough for provided geometry.' );

		}

		// copy geometry over
		const vertexStart = reservedRange.vertexStart;
		const vertexCount = reservedRange.vertexCount;
		for ( const attributeName in batchGeometry.attributes ) {

			if ( attributeName === ID_ATTR_NAME ) {

				continue;

			}

			// copy attribute data
			const srcAttribute = geometry.getAttribute( attributeName );
			const dstAttribute = batchGeometry.getAttribute( attributeName );
			copyAttributeData( srcAttribute, dstAttribute, vertexStart );

			// fill the rest in with zeroes
			const itemSize = srcAttribute.itemSize;
			for ( let i = srcAttribute.count, l = vertexCount; i < l; i ++ ) {

				const index = vertexStart + i;
				for ( let c = 0; c < itemSize; c ++ ) {

					dstAttribute.setComponent( index, c, 0 );

				}

			}

			dstAttribute.needsUpdate = true;
			dstAttribute.addUpdateRange( vertexStart * itemSize, vertexCount * itemSize );

		}

		// copy index
		if ( hasIndex ) {

			const indexStart = reservedRange.indexStart;

			// copy index data over
			for ( let i = 0; i < srcIndex.count; i ++ ) {

				dstIndex.setX( indexStart + i, vertexStart + srcIndex.getX( i ) );

			}

			// fill the rest in with zeroes
			for ( let i = srcIndex.count, l = reservedRange.indexCount; i < l; i ++ ) {

				dstIndex.setX( indexStart + i, vertexStart );

			}

			dstIndex.needsUpdate = true;
			dstIndex.addUpdateRange( indexStart, reservedRange.indexCount );

		}

		// store the bounding boxes
		const bound = this._bounds[ id ];
		if ( geometry.boundingBox !== null ) {

			bound.box.copy( geometry.boundingBox );
			bound.boxInitialized = true;

		} else {

			bound.boxInitialized = false;

		}

		if ( geometry.boundingSphere !== null ) {

			bound.sphere.copy( geometry.boundingSphere );
			bound.sphereInitialized = true;

		} else {

			bound.sphereInitialized = false;

		}

		// set drawRange count
		const drawRange = this._drawRanges[ id ];
		const posAttr = geometry.getAttribute( 'position' );
		drawRange.count = hasIndex ? srcIndex.count : posAttr.count;
		this._visibilityChanged = true;

		return id;

	}

	deleteGeometry( geometryId ) {

		// Note: User needs to call optimize() afterward to pack the data.

		const active = this._active;
		if ( geometryId >= active.length || active[ geometryId ] === false ) {

			return this;

		}

		active[ geometryId ] = false;
		this._visibilityChanged = true;

		return this;

	}

	// get bounding box and compute it if it doesn't exist
	getBoundingBoxAt( id, target ) {

		const active = this._active;
		if ( active[ id ] === false ) {

			return null;

		}

		// compute bounding box
		const bound = this._bounds[ id ];
		const box = bound.box;
		const geometry = this.geometry;
		if ( bound.boxInitialized === false ) {

			box.makeEmpty();

			const index = geometry.index;
			const position = geometry.attributes.position;
			const drawRange = this._drawRanges[ id ];
			for ( let i = drawRange.start, l = drawRange.start + drawRange.count; i < l; i ++ ) {

				let iv = i;
				if ( index ) {

					iv = index.getX( iv );

				}

				box.expandByPoint( _vector$5.fromBufferAttribute( position, iv ) );

			}

			bound.boxInitialized = true;

		}

		target.copy( box );
		return target;

	}

	// get bounding sphere and compute it if it doesn't exist
	getBoundingSphereAt( id, target ) {

		const active = this._active;
		if ( active[ id ] === false ) {

			return null;

		}

		// compute bounding sphere
		const bound = this._bounds[ id ];
		const sphere = bound.sphere;
		const geometry = this.geometry;
		if ( bound.sphereInitialized === false ) {

			sphere.makeEmpty();

			this.getBoundingBoxAt( id, _box$1 );
			_box$1.getCenter( sphere.center );

			const index = geometry.index;
			const position = geometry.attributes.position;
			const drawRange = this._drawRanges[ id ];

			let maxRadiusSq = 0;
			for ( let i = drawRange.start, l = drawRange.start + drawRange.count; i < l; i ++ ) {

				let iv = i;
				if ( index ) {

					iv = index.getX( iv );

				}

				_vector$5.fromBufferAttribute( position, iv );
				maxRadiusSq = Math.max( maxRadiusSq, sphere.center.distanceToSquared( _vector$5 ) );

			}

			sphere.radius = Math.sqrt( maxRadiusSq );
			bound.sphereInitialized = true;

		}

		target.copy( sphere );
		return target;

	}

	setMatrixAt( geometryId, matrix ) {

		// @TODO: Map geometryId to index of the arrays because
		//        optimize() can make geometryId mismatch the index

		const active = this._active;
		const matricesTexture = this._matricesTexture;
		const matricesArray = this._matricesTexture.image.data;
		const geometryCount = this._geometryCount;
		if ( geometryId >= geometryCount || active[ geometryId ] === false ) {

			return this;

		}

		matrix.toArray( matricesArray, geometryId * 16 );
		matricesTexture.needsUpdate = true;

		return this;

	}

	getMatrixAt( geometryId, matrix ) {

		const active = this._active;
		const matricesArray = this._matricesTexture.image.data;
		const geometryCount = this._geometryCount;
		if ( geometryId >= geometryCount || active[ geometryId ] === false ) {

			return null;

		}

		return matrix.fromArray( matricesArray, geometryId * 16 );

	}

	setVisibleAt( geometryId, value ) {

		const visibility = this._visibility;
		const active = this._active;
		const geometryCount = this._geometryCount;

		// if the geometry is out of range, not active, or visibility state
		// does not change then return early
		if (
			geometryId >= geometryCount ||
			active[ geometryId ] === false ||
			visibility[ geometryId ] === value
		) {

			return this;

		}

		visibility[ geometryId ] = value;
		this._visibilityChanged = true;

		return this;

	}

	getVisibleAt( geometryId ) {

		const visibility = this._visibility;
		const active = this._active;
		const geometryCount = this._geometryCount;

		// return early if the geometry is out of range or not active
		if ( geometryId >= geometryCount || active[ geometryId ] === false ) {

			return false;

		}

		return visibility[ geometryId ];

	}

	raycast( raycaster, intersects ) {

		const visibility = this._visibility;
		const active = this._active;
		const drawRanges = this._drawRanges;
		const geometryCount = this._geometryCount;
		const matrixWorld = this.matrixWorld;
		const batchGeometry = this.geometry;

		// iterate over each geometry
		_mesh.material = this.material;
		_mesh.geometry.index = batchGeometry.index;
		_mesh.geometry.attributes = batchGeometry.attributes;
		if ( _mesh.geometry.boundingBox === null ) {

			_mesh.geometry.boundingBox = new Box3();

		}

		if ( _mesh.geometry.boundingSphere === null ) {

			_mesh.geometry.boundingSphere = new Sphere();

		}

		for ( let i = 0; i < geometryCount; i ++ ) {

			if ( ! visibility[ i ] || ! active[ i ] ) {

				continue;

			}

			const drawRange = drawRanges[ i ];
			_mesh.geometry.setDrawRange( drawRange.start, drawRange.count );

			// ge the intersects
			this.getMatrixAt( i, _mesh.matrixWorld ).premultiply( matrixWorld );
			this.getBoundingBoxAt( i, _mesh.geometry.boundingBox );
			this.getBoundingSphereAt( i, _mesh.geometry.boundingSphere );
			_mesh.raycast( raycaster, _batchIntersects );

			// add batch id to the intersects
			for ( let j = 0, l = _batchIntersects.length; j < l; j ++ ) {

				const intersect = _batchIntersects[ j ];
				intersect.object = this;
				intersect.batchId = i;
				intersects.push( intersect );

			}

			_batchIntersects.length = 0;

		}

		_mesh.material = null;
		_mesh.geometry.index = null;
		_mesh.geometry.attributes = {};
		_mesh.geometry.setDrawRange( 0, Infinity );

	}

	copy( source ) {

		super.copy( source );

		this.geometry = source.geometry.clone();
		this.perObjectFrustumCulled = source.perObjectFrustumCulled;
		this.sortObjects = source.sortObjects;
		this.boundingBox = source.boundingBox !== null ? source.boundingBox.clone() : null;
		this.boundingSphere = source.boundingSphere !== null ? source.boundingSphere.clone() : null;

		this._drawRanges = source._drawRanges.map( range => ( { ...range } ) );
		this._reservedRanges = source._reservedRanges.map( range => ( { ...range } ) );

		this._visibility = source._visibility.slice();
		this._active = source._active.slice();
		this._bounds = source._bounds.map( bound => ( {
			boxInitialized: bound.boxInitialized,
			box: bound.box.clone(),

			sphereInitialized: bound.sphereInitialized,
			sphere: bound.sphere.clone()
		} ) );

		this._maxGeometryCount = source._maxGeometryCount;
		this._maxVertexCount = source._maxVertexCount;
		this._maxIndexCount = source._maxIndexCount;

		this._geometryInitialized = source._geometryInitialized;
		this._geometryCount = source._geometryCount;
		this._multiDrawCounts = source._multiDrawCounts.slice();
		this._multiDrawStarts = source._multiDrawStarts.slice();

		this._matricesTexture = source._matricesTexture.clone();
		this._matricesTexture.image.data = this._matricesTexture.image.slice();

		return this;

	}

	dispose() {

		// Assuming the geometry is not shared with other meshes
		this.geometry.dispose();

		this._matricesTexture.dispose();
		this._matricesTexture = null;
		return this;

	}

	onBeforeRender( renderer, scene, camera, geometry, material/*, _group*/ ) {

		// if visibility has not changed and frustum culling and object sorting is not required
		// then skip iterating over all items
		if ( ! this._visibilityChanged && ! this.perObjectFrustumCulled && ! this.sortObjects ) {

			return;

		}

		// the indexed version of the multi draw function requires specifying the start
		// offset in bytes.
		const index = geometry.getIndex();
		const bytesPerElement = index === null ? 1 : index.array.BYTES_PER_ELEMENT;

		const active = this._active;
		const visibility = this._visibility;
		const multiDrawStarts = this._multiDrawStarts;
		const multiDrawCounts = this._multiDrawCounts;
		const drawRanges = this._drawRanges;
		const perObjectFrustumCulled = this.perObjectFrustumCulled;

		// prepare the frustum in the local frame
		if ( perObjectFrustumCulled ) {

			_projScreenMatrix$2
				.multiplyMatrices( camera.projectionMatrix, camera.matrixWorldInverse )
				.multiply( this.matrixWorld );
			_frustum.setFromProjectionMatrix(
				_projScreenMatrix$2,
				renderer.coordinateSystem
			);

		}

		let count = 0;
		if ( this.sortObjects ) {

			// get the camera position in the local frame
			_invMatrixWorld.copy( this.matrixWorld ).invert();
			_vector$5.setFromMatrixPosition( camera.matrixWorld ).applyMatrix4( _invMatrixWorld );

			for ( let i = 0, l = visibility.length; i < l; i ++ ) {

				if ( visibility[ i ] && active[ i ] ) {

					// get the bounds in world space
					this.getMatrixAt( i, _matrix$1 );
					this.getBoundingSphereAt( i, _sphere$2 ).applyMatrix4( _matrix$1 );

					// determine whether the batched geometry is within the frustum
					let culled = false;
					if ( perObjectFrustumCulled ) {

						culled = ! _frustum.intersectsSphere( _sphere$2 );

					}

					if ( ! culled ) {

						// get the distance from camera used for sorting
						const z = _vector$5.distanceTo( _sphere$2.center );
						_renderList.push( drawRanges[ i ], z );

					}

				}

			}

			// Sort the draw ranges and prep for rendering
			const list = _renderList.list;
			const customSort = this.customSort;
			if ( customSort === null ) {

				list.sort( material.transparent ? sortTransparent : sortOpaque );

			} else {

				customSort.call( this, list, camera );

			}

			for ( let i = 0, l = list.length; i < l; i ++ ) {

				const item = list[ i ];
				multiDrawStarts[ count ] = item.start * bytesPerElement;
				multiDrawCounts[ count ] = item.count;
				count ++;

			}

			_renderList.reset();

		} else {

			for ( let i = 0, l = visibility.length; i < l; i ++ ) {

				if ( visibility[ i ] && active[ i ] ) {

					// determine whether the batched geometry is within the frustum
					let culled = false;
					if ( perObjectFrustumCulled ) {

						// get the bounds in world space
						this.getMatrixAt( i, _matrix$1 );
						this.getBoundingSphereAt( i, _sphere$2 ).applyMatrix4( _matrix$1 );
						culled = ! _frustum.intersectsSphere( _sphere$2 );

					}

					if ( ! culled ) {

						const range = drawRanges[ i ];
						multiDrawStarts[ count ] = range.start * bytesPerElement;
						multiDrawCounts[ count ] = range.count;
						count ++;

					}

				}

			}

		}

		this._multiDrawCount = count;
		this._visibilityChanged = false;

	}

	onBeforeShadow( renderer, object, camera, shadowCamera, geometry, depthMaterial/* , group */ ) {

		this.onBeforeRender( renderer, null, shadowCamera, geometry, depthMaterial );

	}

}

class LineBasicMaterial extends Material {

	constructor( parameters ) {

		super();

		this.isLineBasicMaterial = true;

		this.type = 'LineBasicMaterial';

		this.color = new Color( 0xffffff );

		this.map = null;

		this.linewidth = 1;
		this.linecap = 'round';
		this.linejoin = 'round';

		this.fog = true;

		this.setValues( parameters );

	}


	copy( source ) {

		super.copy( source );

		this.color.copy( source.color );

		this.map = source.map;

		this.linewidth = source.linewidth;
		this.linecap = source.linecap;
		this.linejoin = source.linejoin;

		this.fog = source.fog;

		return this;

	}

}

const _start$1 = /*@__PURE__*/ new Vector3();
const _end$1 = /*@__PURE__*/ new Vector3();
const _inverseMatrix$1 = /*@__PURE__*/ new Matrix4();
const _ray$1 = /*@__PURE__*/ new Ray();
const _sphere$1 = /*@__PURE__*/ new Sphere();

class Line extends Object3D {

	constructor( geometry = new BufferGeometry(), material = new LineBasicMaterial() ) {

		super();

		this.isLine = true;

		this.type = 'Line';

		this.geometry = geometry;
		this.material = material;

		this.updateMorphTargets();

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		this.material = Array.isArray( source.material ) ? source.material.slice() : source.material;
		this.geometry = source.geometry;

		return this;

	}

	computeLineDistances() {

		const geometry = this.geometry;

		// we assume non-indexed geometry

		if ( geometry.index === null ) {

			const positionAttribute = geometry.attributes.position;
			const lineDistances = [ 0 ];

			for ( let i = 1, l = positionAttribute.count; i < l; i ++ ) {

				_start$1.fromBufferAttribute( positionAttribute, i - 1 );
				_end$1.fromBufferAttribute( positionAttribute, i );

				lineDistances[ i ] = lineDistances[ i - 1 ];
				lineDistances[ i ] += _start$1.distanceTo( _end$1 );

			}

			geometry.setAttribute( 'lineDistance', new Float32BufferAttribute( lineDistances, 1 ) );

		} else {

			console.warn( 'THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.' );

		}

		return this;

	}

	raycast( raycaster, intersects ) {

		const geometry = this.geometry;
		const matrixWorld = this.matrixWorld;
		const threshold = raycaster.params.Line.threshold;
		const drawRange = geometry.drawRange;

		// Checking boundingSphere distance to ray

		if ( geometry.boundingSphere === null ) geometry.computeBoundingSphere();

		_sphere$1.copy( geometry.boundingSphere );
		_sphere$1.applyMatrix4( matrixWorld );
		_sphere$1.radius += threshold;

		if ( raycaster.ray.intersectsSphere( _sphere$1 ) === false ) return;

		//

		_inverseMatrix$1.copy( matrixWorld ).invert();
		_ray$1.copy( raycaster.ray ).applyMatrix4( _inverseMatrix$1 );

		const localThreshold = threshold / ( ( this.scale.x + this.scale.y + this.scale.z ) / 3 );
		const localThresholdSq = localThreshold * localThreshold;

		const vStart = new Vector3();
		const vEnd = new Vector3();
		const interSegment = new Vector3();
		const interRay = new Vector3();
		const step = this.isLineSegments ? 2 : 1;

		const index = geometry.index;
		const attributes = geometry.attributes;
		const positionAttribute = attributes.position;

		if ( index !== null ) {

			const start = Math.max( 0, drawRange.start );
			const end = Math.min( index.count, ( drawRange.start + drawRange.count ) );

			for ( let i = start, l = end - 1; i < l; i += step ) {

				const a = index.getX( i );
				const b = index.getX( i + 1 );

				vStart.fromBufferAttribute( positionAttribute, a );
				vEnd.fromBufferAttribute( positionAttribute, b );

				const distSq = _ray$1.distanceSqToSegment( vStart, vEnd, interRay, interSegment );

				if ( distSq > localThresholdSq ) continue;

				interRay.applyMatrix4( this.matrixWorld ); //Move back to world space for distance calculation

				const distance = raycaster.ray.origin.distanceTo( interRay );

				if ( distance < raycaster.near || distance > raycaster.far ) continue;

				intersects.push( {

					distance: distance,
					// What do we want? intersection point on the ray or on the segment??
					// point: raycaster.ray.at( distance ),
					point: interSegment.clone().applyMatrix4( this.matrixWorld ),
					index: i,
					face: null,
					faceIndex: null,
					object: this

				} );

			}

		} else {

			const start = Math.max( 0, drawRange.start );
			const end = Math.min( positionAttribute.count, ( drawRange.start + drawRange.count ) );

			for ( let i = start, l = end - 1; i < l; i += step ) {

				vStart.fromBufferAttribute( positionAttribute, i );
				vEnd.fromBufferAttribute( positionAttribute, i + 1 );

				const distSq = _ray$1.distanceSqToSegment( vStart, vEnd, interRay, interSegment );

				if ( distSq > localThresholdSq ) continue;

				interRay.applyMatrix4( this.matrixWorld ); //Move back to world space for distance calculation

				const distance = raycaster.ray.origin.distanceTo( interRay );

				if ( distance < raycaster.near || distance > raycaster.far ) continue;

				intersects.push( {

					distance: distance,
					// What do we want? intersection point on the ray or on the segment??
					// point: raycaster.ray.at( distance ),
					point: interSegment.clone().applyMatrix4( this.matrixWorld ),
					index: i,
					face: null,
					faceIndex: null,
					object: this

				} );

			}

		}

	}

	updateMorphTargets() {

		const geometry = this.geometry;

		const morphAttributes = geometry.morphAttributes;
		const keys = Object.keys( morphAttributes );

		if ( keys.length > 0 ) {

			const morphAttribute = morphAttributes[ keys[ 0 ] ];

			if ( morphAttribute !== undefined ) {

				this.morphTargetInfluences = [];
				this.morphTargetDictionary = {};

				for ( let m = 0, ml = morphAttribute.length; m < ml; m ++ ) {

					const name = morphAttribute[ m ].name || String( m );

					this.morphTargetInfluences.push( 0 );
					this.morphTargetDictionary[ name ] = m;

				}

			}

		}

	}

}

const _start = /*@__PURE__*/ new Vector3();
const _end = /*@__PURE__*/ new Vector3();

class LineSegments extends Line {

	constructor( geometry, material ) {

		super( geometry, material );

		this.isLineSegments = true;

		this.type = 'LineSegments';

	}

	computeLineDistances() {

		const geometry = this.geometry;

		// we assume non-indexed geometry

		if ( geometry.index === null ) {

			const positionAttribute = geometry.attributes.position;
			const lineDistances = [];

			for ( let i = 0, l = positionAttribute.count; i < l; i += 2 ) {

				_start.fromBufferAttribute( positionAttribute, i );
				_end.fromBufferAttribute( positionAttribute, i + 1 );

				lineDistances[ i ] = ( i === 0 ) ? 0 : lineDistances[ i - 1 ];
				lineDistances[ i + 1 ] = lineDistances[ i ] + _start.distanceTo( _end );

			}

			geometry.setAttribute( 'lineDistance', new Float32BufferAttribute( lineDistances, 1 ) );

		} else {

			console.warn( 'THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.' );

		}

		return this;

	}

}

class LineLoop extends Line {

	constructor( geometry, material ) {

		super( geometry, material );

		this.isLineLoop = true;

		this.type = 'LineLoop';

	}

}

class PointsMaterial extends Material {

	constructor( parameters ) {

		super();

		this.isPointsMaterial = true;

		this.type = 'PointsMaterial';

		this.color = new Color( 0xffffff );

		this.map = null;

		this.alphaMap = null;

		this.size = 1;
		this.sizeAttenuation = true;

		this.fog = true;

		this.setValues( parameters );

	}

	copy( source ) {

		super.copy( source );

		this.color.copy( source.color );

		this.map = source.map;

		this.alphaMap = source.alphaMap;

		this.size = source.size;
		this.sizeAttenuation = source.sizeAttenuation;

		this.fog = source.fog;

		return this;

	}

}

const _inverseMatrix = /*@__PURE__*/ new Matrix4();
const _ray = /*@__PURE__*/ new Ray();
const _sphere = /*@__PURE__*/ new Sphere();
const _position$2 = /*@__PURE__*/ new Vector3();

class Points extends Object3D {

	constructor( geometry = new BufferGeometry(), material = new PointsMaterial() ) {

		super();

		this.isPoints = true;

		this.type = 'Points';

		this.geometry = geometry;
		this.material = material;

		this.updateMorphTargets();

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		this.material = Array.isArray( source.material ) ? source.material.slice() : source.material;
		this.geometry = source.geometry;

		return this;

	}

	raycast( raycaster, intersects ) {

		const geometry = this.geometry;
		const matrixWorld = this.matrixWorld;
		const threshold = raycaster.params.Points.threshold;
		const drawRange = geometry.drawRange;

		// Checking boundingSphere distance to ray

		if ( geometry.boundingSphere === null ) geometry.computeBoundingSphere();

		_sphere.copy( geometry.boundingSphere );
		_sphere.applyMatrix4( matrixWorld );
		_sphere.radius += threshold;

		if ( raycaster.ray.intersectsSphere( _sphere ) === false ) return;

		//

		_inverseMatrix.copy( matrixWorld ).invert();
		_ray.copy( raycaster.ray ).applyMatrix4( _inverseMatrix );

		const localThreshold = threshold / ( ( this.scale.x + this.scale.y + this.scale.z ) / 3 );
		const localThresholdSq = localThreshold * localThreshold;

		const index = geometry.index;
		const attributes = geometry.attributes;
		const positionAttribute = attributes.position;

		if ( index !== null ) {

			const start = Math.max( 0, drawRange.start );
			const end = Math.min( index.count, ( drawRange.start + drawRange.count ) );

			for ( let i = start, il = end; i < il; i ++ ) {

				const a = index.getX( i );

				_position$2.fromBufferAttribute( positionAttribute, a );

				testPoint( _position$2, a, localThresholdSq, matrixWorld, raycaster, intersects, this );

			}

		} else {

			const start = Math.max( 0, drawRange.start );
			const end = Math.min( positionAttribute.count, ( drawRange.start + drawRange.count ) );

			for ( let i = start, l = end; i < l; i ++ ) {

				_position$2.fromBufferAttribute( positionAttribute, i );

				testPoint( _position$2, i, localThresholdSq, matrixWorld, raycaster, intersects, this );

			}

		}

	}

	updateMorphTargets() {

		const geometry = this.geometry;

		const morphAttributes = geometry.morphAttributes;
		const keys = Object.keys( morphAttributes );

		if ( keys.length > 0 ) {

			const morphAttribute = morphAttributes[ keys[ 0 ] ];

			if ( morphAttribute !== undefined ) {

				this.morphTargetInfluences = [];
				this.morphTargetDictionary = {};

				for ( let m = 0, ml = morphAttribute.length; m < ml; m ++ ) {

					const name = morphAttribute[ m ].name || String( m );

					this.morphTargetInfluences.push( 0 );
					this.morphTargetDictionary[ name ] = m;

				}

			}

		}

	}

}

function testPoint( point, index, localThresholdSq, matrixWorld, raycaster, intersects, object ) {

	const rayPointDistanceSq = _ray.distanceSqToPoint( point );

	if ( rayPointDistanceSq < localThresholdSq ) {

		const intersectPoint = new Vector3();

		_ray.closestPointToPoint( point, intersectPoint );
		intersectPoint.applyMatrix4( matrixWorld );

		const distance = raycaster.ray.origin.distanceTo( intersectPoint );

		if ( distance < raycaster.near || distance > raycaster.far ) return;

		intersects.push( {

			distance: distance,
			distanceToRay: Math.sqrt( rayPointDistanceSq ),
			point: intersectPoint,
			index: index,
			face: null,
			object: object

		} );

	}

}

class VideoTexture extends Texture {

	constructor( video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy ) {

		super( video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy );

		this.isVideoTexture = true;

		this.minFilter = minFilter !== undefined ? minFilter : LinearFilter;
		this.magFilter = magFilter !== undefined ? magFilter : LinearFilter;

		this.generateMipmaps = false;

		const scope = this;

		function updateVideo() {

			scope.needsUpdate = true;
			video.requestVideoFrameCallback( updateVideo );

		}

		if ( 'requestVideoFrameCallback' in video ) {

			video.requestVideoFrameCallback( updateVideo );

		}

	}

	clone() {

		return new this.constructor( this.image ).copy( this );

	}

	update() {

		const video = this.image;
		const hasVideoFrameCallback = 'requestVideoFrameCallback' in video;

		if ( hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA ) {

			this.needsUpdate = true;

		}

	}

}

class FramebufferTexture extends Texture {

	constructor( width, height ) {

		super( { width, height } );

		this.isFramebufferTexture = true;

		this.magFilter = NearestFilter;
		this.minFilter = NearestFilter;

		this.generateMipmaps = false;

		this.needsUpdate = true;

	}

}

class CompressedTexture extends Texture {

	constructor( mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, colorSpace ) {

		super( null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace );

		this.isCompressedTexture = true;

		this.image = { width: width, height: height };
		this.mipmaps = mipmaps;

		// no flipping for cube textures
		// (also flipping doesn't work for compressed textures )

		this.flipY = false;

		// can't generate mipmaps for compressed textures
		// mips must be embedded in DDS files

		this.generateMipmaps = false;

	}

}

class CompressedArrayTexture extends CompressedTexture {

	constructor( mipmaps, width, height, depth, format, type ) {

		super( mipmaps, width, height, format, type );

		this.isCompressedArrayTexture = true;
		this.image.depth = depth;
		this.wrapR = ClampToEdgeWrapping;

	}

}

class CompressedCubeTexture extends CompressedTexture {

	constructor( images, format, type ) {

		super( undefined, images[ 0 ].width, images[ 0 ].height, format, type, CubeReflectionMapping );

		this.isCompressedCubeTexture = true;
		this.isCubeTexture = true;

		this.image = images;

	}

}

class CanvasTexture extends Texture {

	constructor( canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy ) {

		super( canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy );

		this.isCanvasTexture = true;

		this.needsUpdate = true;

	}

}

/**
 * Extensible curve object.
 *
 * Some common of curve methods:
 * .getPoint( t, optionalTarget ), .getTangent( t, optionalTarget )
 * .getPointAt( u, optionalTarget ), .getTangentAt( u, optionalTarget )
 * .getPoints(), .getSpacedPoints()
 * .getLength()
 * .updateArcLengths()
 *
 * This following curves inherit from THREE.Curve:
 *
 * -- 2D curves --
 * THREE.ArcCurve
 * THREE.CubicBezierCurve
 * THREE.EllipseCurve
 * THREE.LineCurve
 * THREE.QuadraticBezierCurve
 * THREE.SplineCurve
 *
 * -- 3D curves --
 * THREE.CatmullRomCurve3
 * THREE.CubicBezierCurve3
 * THREE.LineCurve3
 * THREE.QuadraticBezierCurve3
 *
 * A series of curves can be represented as a THREE.CurvePath.
 *
 **/

class Curve {

	constructor() {

		this.type = 'Curve';

		this.arcLengthDivisions = 200;

	}

	// Virtual base class method to overwrite and implement in subclasses
	//	- t [0 .. 1]

	getPoint( /* t, optionalTarget */ ) {

		console.warn( 'THREE.Curve: .getPoint() not implemented.' );
		return null;

	}

	// Get point at relative position in curve according to arc length
	// - u [0 .. 1]

	getPointAt( u, optionalTarget ) {

		const t = this.getUtoTmapping( u );
		return this.getPoint( t, optionalTarget );

	}

	// Get sequence of points using getPoint( t )

	getPoints( divisions = 5 ) {

		const points = [];

		for ( let d = 0; d <= divisions; d ++ ) {

			points.push( this.getPoint( d / divisions ) );

		}

		return points;

	}

	// Get sequence of points using getPointAt( u )

	getSpacedPoints( divisions = 5 ) {

		const points = [];

		for ( let d = 0; d <= divisions; d ++ ) {

			points.push( this.getPointAt( d / divisions ) );

		}

		return points;

	}

	// Get total curve arc length

	getLength() {

		const lengths = this.getLengths();
		return lengths[ lengths.length - 1 ];

	}

	// Get list of cumulative segment lengths

	getLengths( divisions = this.arcLengthDivisions ) {

		if ( this.cacheArcLengths &&
			( this.cacheArcLengths.length === divisions + 1 ) &&
			! this.needsUpdate ) {

			return this.cacheArcLengths;

		}

		this.needsUpdate = false;

		const cache = [];
		let current, last = this.getPoint( 0 );
		let sum = 0;

		cache.push( 0 );

		for ( let p = 1; p <= divisions; p ++ ) {

			current = this.getPoint( p / divisions );
			sum += current.distanceTo( last );
			cache.push( sum );
			last = current;

		}

		this.cacheArcLengths = cache;

		return cache; // { sums: cache, sum: sum }; Sum is in the last element.

	}

	updateArcLengths() {

		this.needsUpdate = true;
		this.getLengths();

	}

	// Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant

	getUtoTmapping( u, distance ) {

		const arcLengths = this.getLengths();

		let i = 0;
		const il = arcLengths.length;

		let targetArcLength; // The targeted u distance value to get

		if ( distance ) {

			targetArcLength = distance;

		} else {

			targetArcLength = u * arcLengths[ il - 1 ];

		}

		// binary search for the index with largest value smaller than target u distance

		let low = 0, high = il - 1, comparison;

		while ( low <= high ) {

			i = Math.floor( low + ( high - low ) / 2 ); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats

			comparison = arcLengths[ i ] - targetArcLength;

			if ( comparison < 0 ) {

				low = i + 1;

			} else if ( comparison > 0 ) {

				high = i - 1;

			} else {

				high = i;
				break;

				// DONE

			}

		}

		i = high;

		if ( arcLengths[ i ] === targetArcLength ) {

			return i / ( il - 1 );

		}

		// we could get finer grain at lengths, or use simple interpolation between two points

		const lengthBefore = arcLengths[ i ];
		const lengthAfter = arcLengths[ i + 1 ];

		const segmentLength = lengthAfter - lengthBefore;

		// determine where we are between the 'before' and 'after' points

		const segmentFraction = ( targetArcLength - lengthBefore ) / segmentLength;

		// add that fractional amount to t

		const t = ( i + segmentFraction ) / ( il - 1 );

		return t;

	}

	// Returns a unit vector tangent at t
	// In case any sub curve does not implement its tangent derivation,
	// 2 points a small delta apart will be used to find its gradient
	// which seems to give a reasonable approximation

	getTangent( t, optionalTarget ) {

		const delta = 0.0001;
		let t1 = t - delta;
		let t2 = t + delta;

		// Capping in case of danger

		if ( t1 < 0 ) t1 = 0;
		if ( t2 > 1 ) t2 = 1;

		const pt1 = this.getPoint( t1 );
		const pt2 = this.getPoint( t2 );

		const tangent = optionalTarget || ( ( pt1.isVector2 ) ? new Vector2() : new Vector3() );

		tangent.copy( pt2 ).sub( pt1 ).normalize();

		return tangent;

	}

	getTangentAt( u, optionalTarget ) {

		const t = this.getUtoTmapping( u );
		return this.getTangent( t, optionalTarget );

	}

	computeFrenetFrames( segments, closed ) {

		// see http://www.cs.indiana.edu/pub/techreports/TR425.pdf

		const normal = new Vector3();

		const tangents = [];
		const normals = [];
		const binormals = [];

		const vec = new Vector3();
		const mat = new Matrix4();

		// compute the tangent vectors for each segment on the curve

		for ( let i = 0; i <= segments; i ++ ) {

			const u = i / segments;

			tangents[ i ] = this.getTangentAt( u, new Vector3() );

		}

		// select an initial normal vector perpendicular to the first tangent vector,
		// and in the direction of the minimum tangent xyz component

		normals[ 0 ] = new Vector3();
		binormals[ 0 ] = new Vector3();
		let min = Number.MAX_VALUE;
		const tx = Math.abs( tangents[ 0 ].x );
		const ty = Math.abs( tangents[ 0 ].y );
		const tz = Math.abs( tangents[ 0 ].z );

		if ( tx <= min ) {

			min = tx;
			normal.set( 1, 0, 0 );

		}

		if ( ty <= min ) {

			min = ty;
			normal.set( 0, 1, 0 );

		}

		if ( tz <= min ) {

			normal.set( 0, 0, 1 );

		}

		vec.crossVectors( tangents[ 0 ], normal ).normalize();

		normals[ 0 ].crossVectors( tangents[ 0 ], vec );
		binormals[ 0 ].crossVectors( tangents[ 0 ], normals[ 0 ] );


		// compute the slowly-varying normal and binormal vectors for each segment on the curve

		for ( let i = 1; i <= segments; i ++ ) {

			normals[ i ] = normals[ i - 1 ].clone();

			binormals[ i ] = binormals[ i - 1 ].clone();

			vec.crossVectors( tangents[ i - 1 ], tangents[ i ] );

			if ( vec.length() > Number.EPSILON ) {

				vec.normalize();

				const theta = Math.acos( clamp( tangents[ i - 1 ].dot( tangents[ i ] ), - 1, 1 ) ); // clamp for floating pt errors

				normals[ i ].applyMatrix4( mat.makeRotationAxis( vec, theta ) );

			}

			binormals[ i ].crossVectors( tangents[ i ], normals[ i ] );

		}

		// if the curve is closed, postprocess the vectors so the first and last normal vectors are the same

		if ( closed === true ) {

			let theta = Math.acos( clamp( normals[ 0 ].dot( normals[ segments ] ), - 1, 1 ) );
			theta /= segments;

			if ( tangents[ 0 ].dot( vec.crossVectors( normals[ 0 ], normals[ segments ] ) ) > 0 ) {

				theta = - theta;

			}

			for ( let i = 1; i <= segments; i ++ ) {

				// twist a little...
				normals[ i ].applyMatrix4( mat.makeRotationAxis( tangents[ i ], theta * i ) );
				binormals[ i ].crossVectors( tangents[ i ], normals[ i ] );

			}

		}

		return {
			tangents: tangents,
			normals: normals,
			binormals: binormals
		};

	}

	clone() {

		return new this.constructor().copy( this );

	}

	copy( source ) {

		this.arcLengthDivisions = source.arcLengthDivisions;

		return this;

	}

	toJSON() {

		const data = {
			metadata: {
				version: 4.6,
				type: 'Curve',
				generator: 'Curve.toJSON'
			}
		};

		data.arcLengthDivisions = this.arcLengthDivisions;
		data.type = this.type;

		return data;

	}

	fromJSON( json ) {

		this.arcLengthDivisions = json.arcLengthDivisions;

		return this;

	}

}

class EllipseCurve extends Curve {

	constructor( aX = 0, aY = 0, xRadius = 1, yRadius = 1, aStartAngle = 0, aEndAngle = Math.PI * 2, aClockwise = false, aRotation = 0 ) {

		super();

		this.isEllipseCurve = true;

		this.type = 'EllipseCurve';

		this.aX = aX;
		this.aY = aY;

		this.xRadius = xRadius;
		this.yRadius = yRadius;

		this.aStartAngle = aStartAngle;
		this.aEndAngle = aEndAngle;

		this.aClockwise = aClockwise;

		this.aRotation = aRotation;

	}

	getPoint( t, optionalTarget = new Vector2() ) {

		const point = optionalTarget;

		const twoPi = Math.PI * 2;
		let deltaAngle = this.aEndAngle - this.aStartAngle;
		const samePoints = Math.abs( deltaAngle ) < Number.EPSILON;

		// ensures that deltaAngle is 0 .. 2 PI
		while ( deltaAngle < 0 ) deltaAngle += twoPi;
		while ( deltaAngle > twoPi ) deltaAngle -= twoPi;

		if ( deltaAngle < Number.EPSILON ) {

			if ( samePoints ) {

				deltaAngle = 0;

			} else {

				deltaAngle = twoPi;

			}

		}

		if ( this.aClockwise === true && ! samePoints ) {

			if ( deltaAngle === twoPi ) {

				deltaAngle = - twoPi;

			} else {

				deltaAngle = deltaAngle - twoPi;

			}

		}

		const angle = this.aStartAngle + t * deltaAngle;
		let x = this.aX + this.xRadius * Math.cos( angle );
		let y = this.aY + this.yRadius * Math.sin( angle );

		if ( this.aRotation !== 0 ) {

			const cos = Math.cos( this.aRotation );
			const sin = Math.sin( this.aRotation );

			const tx = x - this.aX;
			const ty = y - this.aY;

			// Rotate the point about the center of the ellipse.
			x = tx * cos - ty * sin + this.aX;
			y = tx * sin + ty * cos + this.aY;

		}

		return point.set( x, y );

	}

	copy( source ) {

		super.copy( source );

		this.aX = source.aX;
		this.aY = source.aY;

		this.xRadius = source.xRadius;
		this.yRadius = source.yRadius;

		this.aStartAngle = source.aStartAngle;
		this.aEndAngle = source.aEndAngle;

		this.aClockwise = source.aClockwise;

		this.aRotation = source.aRotation;

		return this;

	}

	toJSON() {

		const data = super.toJSON();

		data.aX = this.aX;
		data.aY = this.aY;

		data.xRadius = this.xRadius;
		data.yRadius = this.yRadius;

		data.aStartAngle = this.aStartAngle;
		data.aEndAngle = this.aEndAngle;

		data.aClockwise = this.aClockwise;

		data.aRotation = this.aRotation;

		return data;

	}

	fromJSON( json ) {

		super.fromJSON( json );

		this.aX = json.aX;
		this.aY = json.aY;

		this.xRadius = json.xRadius;
		this.yRadius = json.yRadius;

		this.aStartAngle = json.aStartAngle;
		this.aEndAngle = json.aEndAngle;

		this.aClockwise = json.aClockwise;

		this.aRotation = json.aRotation;

		return this;

	}

}

class ArcCurve extends EllipseCurve {

	constructor( aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise ) {

		super( aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise );

		this.isArcCurve = true;

		this.type = 'ArcCurve';

	}

}

/**
 * Centripetal CatmullRom Curve - which is useful for avoiding
 * cusps and self-intersections in non-uniform catmull rom curves.
 * http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
 *
 * curve.type accepts centripetal(default), chordal and catmullrom
 * curve.tension is used for catmullrom which defaults to 0.5
 */


/*
Based on an optimized c++ solution in
 - http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
 - http://ideone.com/NoEbVM

This CubicPoly class could be used for reusing some variables and calculations,
but for three.js curve use, it could be possible inlined and flatten into a single function call
which can be placed in CurveUtils.
*/

function CubicPoly() {

	let c0 = 0, c1 = 0, c2 = 0, c3 = 0;

	/*
	 * Compute coefficients for a cubic polynomial
	 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
	 * such that
	 *   p(0) = x0, p(1) = x1
	 *  and
	 *   p'(0) = t0, p'(1) = t1.
	 */
	function init( x0, x1, t0, t1 ) {

		c0 = x0;
		c1 = t0;
		c2 = - 3 * x0 + 3 * x1 - 2 * t0 - t1;
		c3 = 2 * x0 - 2 * x1 + t0 + t1;

	}

	return {

		initCatmullRom: function ( x0, x1, x2, x3, tension ) {

			init( x1, x2, tension * ( x2 - x0 ), tension * ( x3 - x1 ) );

		},

		initNonuniformCatmullRom: function ( x0, x1, x2, x3, dt0, dt1, dt2 ) {

			// compute tangents when parameterized in [t1,t2]
			let t1 = ( x1 - x0 ) / dt0 - ( x2 - x0 ) / ( dt0 + dt1 ) + ( x2 - x1 ) / dt1;
			let t2 = ( x2 - x1 ) / dt1 - ( x3 - x1 ) / ( dt1 + dt2 ) + ( x3 - x2 ) / dt2;

			// rescale tangents for parametrization in [0,1]
			t1 *= dt1;
			t2 *= dt1;

			init( x1, x2, t1, t2 );

		},

		calc: function ( t ) {

			const t2 = t * t;
			const t3 = t2 * t;
			return c0 + c1 * t + c2 * t2 + c3 * t3;

		}

	};

}

//

const tmp = /*@__PURE__*/ new Vector3();
const px = /*@__PURE__*/ new CubicPoly();
const py = /*@__PURE__*/ new CubicPoly();
const pz = /*@__PURE__*/ new CubicPoly();

class CatmullRomCurve3 extends Curve {

	constructor( points = [], closed = false, curveType = 'centripetal', tension = 0.5 ) {

		super();

		this.isCatmullRomCurve3 = true;

		this.type = 'CatmullRomCurve3';

		this.points = points;
		this.closed = closed;
		this.curveType = curveType;
		this.tension = tension;

	}

	getPoint( t, optionalTarget = new Vector3() ) {

		const point = optionalTarget;

		const points = this.points;
		const l = points.length;

		const p = ( l - ( this.closed ? 0 : 1 ) ) * t;
		let intPoint = Math.floor( p );
		let weight = p - intPoint;

		if ( this.closed ) {

			intPoint += intPoint > 0 ? 0 : ( Math.floor( Math.abs( intPoint ) / l ) + 1 ) * l;

		} else if ( weight === 0 && intPoint === l - 1 ) {

			intPoint = l - 2;
			weight = 1;

		}

		let p0, p3; // 4 points (p1 & p2 defined below)

		if ( this.closed || intPoint > 0 ) {

			p0 = points[ ( intPoint - 1 ) % l ];

		} else {

			// extrapolate first point
			tmp.subVectors( points[ 0 ], points[ 1 ] ).add( points[ 0 ] );
			p0 = tmp;

		}

		const p1 = points[ intPoint % l ];
		const p2 = points[ ( intPoint + 1 ) % l ];

		if ( this.closed || intPoint + 2 < l ) {

			p3 = points[ ( intPoint + 2 ) % l ];

		} else {

			// extrapolate last point
			tmp.subVectors( points[ l - 1 ], points[ l - 2 ] ).add( points[ l - 1 ] );
			p3 = tmp;

		}

		if ( this.curveType === 'centripetal' || this.curveType === 'chordal' ) {

			// init Centripetal / Chordal Catmull-Rom
			const pow = this.curveType === 'chordal' ? 0.5 : 0.25;
			let dt0 = Math.pow( p0.distanceToSquared( p1 ), pow );
			let dt1 = Math.pow( p1.distanceToSquared( p2 ), pow );
			let dt2 = Math.pow( p2.distanceToSquared( p3 ), pow );

			// safety check for repeated points
			if ( dt1 < 1e-4 ) dt1 = 1.0;
			if ( dt0 < 1e-4 ) dt0 = dt1;
			if ( dt2 < 1e-4 ) dt2 = dt1;

			px.initNonuniformCatmullRom( p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2 );
			py.initNonuniformCatmullRom( p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2 );
			pz.initNonuniformCatmullRom( p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2 );

		} else if ( this.curveType === 'catmullrom' ) {

			px.initCatmullRom( p0.x, p1.x, p2.x, p3.x, this.tension );
			py.initCatmullRom( p0.y, p1.y, p2.y, p3.y, this.tension );
			pz.initCatmullRom( p0.z, p1.z, p2.z, p3.z, this.tension );

		}

		point.set(
			px.calc( weight ),
			py.calc( weight ),
			pz.calc( weight )
		);

		return point;

	}

	copy( source ) {

		super.copy( source );

		this.points = [];

		for ( let i = 0, l = source.points.length; i < l; i ++ ) {

			const point = source.points[ i ];

			this.points.push( point.clone() );

		}

		this.closed = source.closed;
		this.curveType = source.curveType;
		this.tension = source.tension;

		return this;

	}

	toJSON() {

		const data = super.toJSON();

		data.points = [];

		for ( let i = 0, l = this.points.length; i < l; i ++ ) {

			const point = this.points[ i ];
			data.points.push( point.toArray() );

		}

		data.closed = this.closed;
		data.curveType = this.curveType;
		data.tension = this.tension;

		return data;

	}

	fromJSON( json ) {

		super.fromJSON( json );

		this.points = [];

		for ( let i = 0, l = json.points.length; i < l; i ++ ) {

			const point = json.points[ i ];
			this.points.push( new Vector3().fromArray( point ) );

		}

		this.closed = json.closed;
		this.curveType = json.curveType;
		this.tension = json.tension;

		return this;

	}

}

/**
 * Bezier Curves formulas obtained from
 * https://en.wikipedia.org/wiki/B%C3%A9zier_curve
 */

function CatmullRom( t, p0, p1, p2, p3 ) {

	const v0 = ( p2 - p0 ) * 0.5;
	const v1 = ( p3 - p1 ) * 0.5;
	const t2 = t * t;
	const t3 = t * t2;
	return ( 2 * p1 - 2 * p2 + v0 + v1 ) * t3 + ( - 3 * p1 + 3 * p2 - 2 * v0 - v1 ) * t2 + v0 * t + p1;

}

//

function QuadraticBezierP0( t, p ) {

	const k = 1 - t;
	return k * k * p;

}

function QuadraticBezierP1( t, p ) {

	return 2 * ( 1 - t ) * t * p;

}

function QuadraticBezierP2( t, p ) {

	return t * t * p;

}

function QuadraticBezier( t, p0, p1, p2 ) {

	return QuadraticBezierP0( t, p0 ) + QuadraticBezierP1( t, p1 ) +
		QuadraticBezierP2( t, p2 );

}

//

function CubicBezierP0( t, p ) {

	const k = 1 - t;
	return k * k * k * p;

}

function CubicBezierP1( t, p ) {

	const k = 1 - t;
	return 3 * k * k * t * p;

}

function CubicBezierP2( t, p ) {

	return 3 * ( 1 - t ) * t * t * p;

}

function CubicBezierP3( t, p ) {

	return t * t * t * p;

}

function CubicBezier( t, p0, p1, p2, p3 ) {

	return CubicBezierP0( t, p0 ) + CubicBezierP1( t, p1 ) + CubicBezierP2( t, p2 ) +
		CubicBezierP3( t, p3 );

}

class CubicBezierCurve extends Curve {

	constructor( v0 = new Vector2(), v1 = new Vector2(), v2 = new Vector2(), v3 = new Vector2() ) {

		super();

		this.isCubicBezierCurve = true;

		this.type = 'CubicBezierCurve';

		this.v0 = v0;
		this.v1 = v1;
		this.v2 = v2;
		this.v3 = v3;

	}

	getPoint( t, optionalTarget = new Vector2() ) {

		const point = optionalTarget;

		const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;

		point.set(
			CubicBezier( t, v0.x, v1.x, v2.x, v3.x ),
			CubicBezier( t, v0.y, v1.y, v2.y, v3.y )
		);

		return point;

	}

	copy( source ) {

		super.copy( source );

		this.v0.copy( source.v0 );
		this.v1.copy( source.v1 );
		this.v2.copy( source.v2 );
		this.v3.copy( source.v3 );

		return this;

	}

	toJSON() {

		const data = super.toJSON();

		data.v0 = this.v0.toArray();
		data.v1 = this.v1.toArray();
		data.v2 = this.v2.toArray();
		data.v3 = this.v3.toArray();

		return data;

	}

	fromJSON( json ) {

		super.fromJSON( json );

		this.v0.fromArray( json.v0 );
		this.v1.fromArray( json.v1 );
		this.v2.fromArray( json.v2 );
		this.v3.fromArray( json.v3 );

		return this;

	}

}

class CubicBezierCurve3 extends Curve {

	constructor( v0 = new Vector3(), v1 = new Vector3(), v2 = new Vector3(), v3 = new Vector3() ) {

		super();

		this.isCubicBezierCurve3 = true;

		this.type = 'CubicBezierCurve3';

		this.v0 = v0;
		this.v1 = v1;
		this.v2 = v2;
		this.v3 = v3;

	}

	getPoint( t, optionalTarget = new Vector3() ) {

		const point = optionalTarget;

		const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;

		point.set(
			CubicBezier( t, v0.x, v1.x, v2.x, v3.x ),
			CubicBezier( t, v0.y, v1.y, v2.y, v3.y ),
			CubicBezier( t, v0.z, v1.z, v2.z, v3.z )
		);

		return point;

	}

	copy( source ) {

		super.copy( source );

		this.v0.copy( source.v0 );
		this.v1.copy( source.v1 );
		this.v2.copy( source.v2 );
		this.v3.copy( source.v3 );

		return this;

	}

	toJSON() {

		const data = super.toJSON();

		data.v0 = this.v0.toArray();
		data.v1 = this.v1.toArray();
		data.v2 = this.v2.toArray();
		data.v3 = this.v3.toArray();

		return data;

	}

	fromJSON( json ) {

		super.fromJSON( json );

		this.v0.fromArray( json.v0 );
		this.v1.fromArray( json.v1 );
		this.v2.fromArray( json.v2 );
		this.v3.fromArray( json.v3 );

		return this;

	}

}

class LineCurve extends Curve {

	constructor( v1 = new Vector2(), v2 = new Vector2() ) {

		super();

		this.isLineCurve = true;

		this.type = 'LineCurve';

		this.v1 = v1;
		this.v2 = v2;

	}

	getPoint( t, optionalTarget = new Vector2() ) {

		const point = optionalTarget;

		if ( t === 1 ) {

			point.copy( this.v2 );

		} else {

			point.copy( this.v2 ).sub( this.v1 );
			point.multiplyScalar( t ).add( this.v1 );

		}

		return point;

	}

	// Line curve is linear, so we can overwrite default getPointAt
	getPointAt( u, optionalTarget ) {

		return this.getPoint( u, optionalTarget );

	}

	getTangent( t, optionalTarget = new Vector2() ) {

		return optionalTarget.subVectors( this.v2, this.v1 ).normalize();

	}

	getTangentAt( u, optionalTarget ) {

		return this.getTangent( u, optionalTarget );

	}

	copy( source ) {

		super.copy( source );

		this.v1.copy( source.v1 );
		this.v2.copy( source.v2 );

		return this;

	}

	toJSON() {

		const data = super.toJSON();

		data.v1 = this.v1.toArray();
		data.v2 = this.v2.toArray();

		return data;

	}

	fromJSON( json ) {

		super.fromJSON( json );

		this.v1.fromArray( json.v1 );
		this.v2.fromArray( json.v2 );

		return this;

	}

}

class LineCurve3 extends Curve {

	constructor( v1 = new Vector3(), v2 = new Vector3() ) {

		super();

		this.isLineCurve3 = true;

		this.type = 'LineCurve3';

		this.v1 = v1;
		this.v2 = v2;

	}

	getPoint( t, optionalTarget = new Vector3() ) {

		const point = optionalTarget;

		if ( t === 1 ) {

			point.copy( this.v2 );

		} else {

			point.copy( this.v2 ).sub( this.v1 );
			point.multiplyScalar( t ).add( this.v1 );

		}

		return point;

	}

	// Line curve is linear, so we can overwrite default getPointAt
	getPointAt( u, optionalTarget ) {

		return this.getPoint( u, optionalTarget );

	}

	getTangent( t, optionalTarget = new Vector3() ) {

		return optionalTarget.subVectors( this.v2, this.v1 ).normalize();

	}

	getTangentAt( u, optionalTarget ) {

		return this.getTangent( u, optionalTarget );

	}

	copy( source ) {

		super.copy( source );

		this.v1.copy( source.v1 );
		this.v2.copy( source.v2 );

		return this;

	}

	toJSON() {

		const data = super.toJSON();

		data.v1 = this.v1.toArray();
		data.v2 = this.v2.toArray();

		return data;

	}

	fromJSON( json ) {

		super.fromJSON( json );

		this.v1.fromArray( json.v1 );
		this.v2.fromArray( json.v2 );

		return this;

	}

}

class QuadraticBezierCurve extends Curve {

	constructor( v0 = new Vector2(), v1 = new Vector2(), v2 = new Vector2() ) {

		super();

		this.isQuadraticBezierCurve = true;

		this.type = 'QuadraticBezierCurve';

		this.v0 = v0;
		this.v1 = v1;
		this.v2 = v2;

	}

	getPoint( t, optionalTarget = new Vector2() ) {

		const point = optionalTarget;

		const v0 = this.v0, v1 = this.v1, v2 = this.v2;

		point.set(
			QuadraticBezier( t, v0.x, v1.x, v2.x ),
			QuadraticBezier( t, v0.y, v1.y, v2.y )
		);

		return point;

	}

	copy( source ) {

		super.copy( source );

		this.v0.copy( source.v0 );
		this.v1.copy( source.v1 );
		this.v2.copy( source.v2 );

		return this;

	}

	toJSON() {

		const data = super.toJSON();

		data.v0 = this.v0.toArray();
		data.v1 = this.v1.toArray();
		data.v2 = this.v2.toArray();

		return data;

	}

	fromJSON( json ) {

		super.fromJSON( json );

		this.v0.fromArray( json.v0 );
		this.v1.fromArray( json.v1 );
		this.v2.fromArray( json.v2 );

		return this;

	}

}

class QuadraticBezierCurve3 extends Curve {

	constructor( v0 = new Vector3(), v1 = new Vector3(), v2 = new Vector3() ) {

		super();

		this.isQuadraticBezierCurve3 = true;

		this.type = 'QuadraticBezierCurve3';

		this.v0 = v0;
		this.v1 = v1;
		this.v2 = v2;

	}

	getPoint( t, optionalTarget = new Vector3() ) {

		const point = optionalTarget;

		const v0 = this.v0, v1 = this.v1, v2 = this.v2;

		point.set(
			QuadraticBezier( t, v0.x, v1.x, v2.x ),
			QuadraticBezier( t, v0.y, v1.y, v2.y ),
			QuadraticBezier( t, v0.z, v1.z, v2.z )
		);

		return point;

	}

	copy( source ) {

		super.copy( source );

		this.v0.copy( source.v0 );
		this.v1.copy( source.v1 );
		this.v2.copy( source.v2 );

		return this;

	}

	toJSON() {

		const data = super.toJSON();

		data.v0 = this.v0.toArray();
		data.v1 = this.v1.toArray();
		data.v2 = this.v2.toArray();

		return data;

	}

	fromJSON( json ) {

		super.fromJSON( json );

		this.v0.fromArray( json.v0 );
		this.v1.fromArray( json.v1 );
		this.v2.fromArray( json.v2 );

		return this;

	}

}

class SplineCurve extends Curve {

	constructor( points = [] ) {

		super();

		this.isSplineCurve = true;

		this.type = 'SplineCurve';

		this.points = points;

	}

	getPoint( t, optionalTarget = new Vector2() ) {

		const point = optionalTarget;

		const points = this.points;
		const p = ( points.length - 1 ) * t;

		const intPoint = Math.floor( p );
		const weight = p - intPoint;

		const p0 = points[ intPoint === 0 ? intPoint : intPoint - 1 ];
		const p1 = points[ intPoint ];
		const p2 = points[ intPoint > points.length - 2 ? points.length - 1 : intPoint + 1 ];
		const p3 = points[ intPoint > points.length - 3 ? points.length - 1 : intPoint + 2 ];

		point.set(
			CatmullRom( weight, p0.x, p1.x, p2.x, p3.x ),
			CatmullRom( weight, p0.y, p1.y, p2.y, p3.y )
		);

		return point;

	}

	copy( source ) {

		super.copy( source );

		this.points = [];

		for ( let i = 0, l = source.points.length; i < l; i ++ ) {

			const point = source.points[ i ];

			this.points.push( point.clone() );

		}

		return this;

	}

	toJSON() {

		const data = super.toJSON();

		data.points = [];

		for ( let i = 0, l = this.points.length; i < l; i ++ ) {

			const point = this.points[ i ];
			data.points.push( point.toArray() );

		}

		return data;

	}

	fromJSON( json ) {

		super.fromJSON( json );

		this.points = [];

		for ( let i = 0, l = json.points.length; i < l; i ++ ) {

			const point = json.points[ i ];
			this.points.push( new Vector2().fromArray( point ) );

		}

		return this;

	}

}

var Curves = /*#__PURE__*/Object.freeze({
	__proto__: null,
	ArcCurve: ArcCurve,
	CatmullRomCurve3: CatmullRomCurve3,
	CubicBezierCurve: CubicBezierCurve,
	CubicBezierCurve3: CubicBezierCurve3,
	EllipseCurve: EllipseCurve,
	LineCurve: LineCurve,
	LineCurve3: LineCurve3,
	QuadraticBezierCurve: QuadraticBezierCurve,
	QuadraticBezierCurve3: QuadraticBezierCurve3,
	SplineCurve: SplineCurve
});

/**************************************************************
 *	Curved Path - a curve path is simply a array of connected
 *  curves, but retains the api of a curve
 **************************************************************/

class CurvePath extends Curve {

	constructor() {

		super();

		this.type = 'CurvePath';

		this.curves = [];
		this.autoClose = false; // Automatically closes the path

	}

	add( curve ) {

		this.curves.push( curve );

	}

	closePath() {

		// Add a line curve if start and end of lines are not connected
		const startPoint = this.curves[ 0 ].getPoint( 0 );
		const endPoint = this.curves[ this.curves.length - 1 ].getPoint( 1 );

		if ( ! startPoint.equals( endPoint ) ) {

			const lineType = ( startPoint.isVector2 === true ) ? 'LineCurve' : 'LineCurve3';
			this.curves.push( new Curves[ lineType ]( endPoint, startPoint ) );

		}

		return this;

	}

	// To get accurate point with reference to
	// entire path distance at time t,
	// following has to be done:

	// 1. Length of each sub path have to be known
	// 2. Locate and identify type of curve
	// 3. Get t for the curve
	// 4. Return curve.getPointAt(t')

	getPoint( t, optionalTarget ) {

		const d = t * this.getLength();
		const curveLengths = this.getCurveLengths();
		let i = 0;

		// To think about boundaries points.

		while ( i < curveLengths.length ) {

			if ( curveLengths[ i ] >= d ) {

				const diff = curveLengths[ i ] - d;
				const curve = this.curves[ i ];

				const segmentLength = curve.getLength();
				const u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;

				return curve.getPointAt( u, optionalTarget );

			}

			i ++;

		}

		return null;

		// loop where sum != 0, sum > d , sum+1 <d

	}

	// We cannot use the default THREE.Curve getPoint() with getLength() because in
	// THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
	// getPoint() depends on getLength

	getLength() {

		const lens = this.getCurveLengths();
		return lens[ lens.length - 1 ];

	}

	// cacheLengths must be recalculated.
	updateArcLengths() {

		this.needsUpdate = true;
		this.cacheLengths = null;
		this.getCurveLengths();

	}

	// Compute lengths and cache them
	// We cannot overwrite getLengths() because UtoT mapping uses it.

	getCurveLengths() {

		// We use cache values if curves and cache array are same length

		if ( this.cacheLengths && this.cacheLengths.length === this.curves.length ) {

			return this.cacheLengths;

		}

		// Get length of sub-curve
		// Push sums into cached array

		const lengths = [];
		let sums = 0;

		for ( let i = 0, l = this.curves.length; i < l; i ++ ) {

			sums += this.curves[ i ].getLength();
			lengths.push( sums );

		}

		this.cacheLengths = lengths;

		return lengths;

	}

	getSpacedPoints( divisions = 40 ) {

		const points = [];

		for ( let i = 0; i <= divisions; i ++ ) {

			points.push( this.getPoint( i / divisions ) );

		}

		if ( this.autoClose ) {

			points.push( points[ 0 ] );

		}

		return points;

	}

	getPoints( divisions = 12 ) {

		const points = [];
		let last;

		for ( let i = 0, curves = this.curves; i < curves.length; i ++ ) {

			const curve = curves[ i ];
			const resolution = curve.isEllipseCurve ? divisions * 2
				: ( curve.isLineCurve || curve.isLineCurve3 ) ? 1
					: curve.isSplineCurve ? divisions * curve.points.length
						: divisions;

			const pts = curve.getPoints( resolution );

			for ( let j = 0; j < pts.length; j ++ ) {

				const point = pts[ j ];

				if ( last && last.equals( point ) ) continue; // ensures no consecutive points are duplicates

				points.push( point );
				last = point;

			}

		}

		if ( this.autoClose && points.length > 1 && ! points[ points.length - 1 ].equals( points[ 0 ] ) ) {

			points.push( points[ 0 ] );

		}

		return points;

	}

	copy( source ) {

		super.copy( source );

		this.curves = [];

		for ( let i = 0, l = source.curves.length; i < l; i ++ ) {

			const curve = source.curves[ i ];

			this.curves.push( curve.clone() );

		}

		this.autoClose = source.autoClose;

		return this;

	}

	toJSON() {

		const data = super.toJSON();

		data.autoClose = this.autoClose;
		data.curves = [];

		for ( let i = 0, l = this.curves.length; i < l; i ++ ) {

			const curve = this.curves[ i ];
			data.curves.push( curve.toJSON() );

		}

		return data;

	}

	fromJSON( json ) {

		super.fromJSON( json );

		this.autoClose = json.autoClose;
		this.curves = [];

		for ( let i = 0, l = json.curves.length; i < l; i ++ ) {

			const curve = json.curves[ i ];
			this.curves.push( new Curves[ curve.type ]().fromJSON( curve ) );

		}

		return this;

	}

}

class Path extends CurvePath {

	constructor( points ) {

		super();

		this.type = 'Path';

		this.currentPoint = new Vector2();

		if ( points ) {

			this.setFromPoints( points );

		}

	}

	setFromPoints( points ) {

		this.moveTo( points[ 0 ].x, points[ 0 ].y );

		for ( let i = 1, l = points.length; i < l; i ++ ) {

			this.lineTo( points[ i ].x, points[ i ].y );

		}

		return this;

	}

	moveTo( x, y ) {

		this.currentPoint.set( x, y ); // TODO consider referencing vectors instead of copying?

		return this;

	}

	lineTo( x, y ) {

		const curve = new LineCurve( this.currentPoint.clone(), new Vector2( x, y ) );
		this.curves.push( curve );

		this.currentPoint.set( x, y );

		return this;

	}

	quadraticCurveTo( aCPx, aCPy, aX, aY ) {

		const curve = new QuadraticBezierCurve(
			this.currentPoint.clone(),
			new Vector2( aCPx, aCPy ),
			new Vector2( aX, aY )
		);

		this.curves.push( curve );

		this.currentPoint.set( aX, aY );

		return this;

	}

	bezierCurveTo( aCP1x, aCP1y, aCP2x, aCP2y, aX, aY ) {

		const curve = new CubicBezierCurve(
			this.currentPoint.clone(),
			new Vector2( aCP1x, aCP1y ),
			new Vector2( aCP2x, aCP2y ),
			new Vector2( aX, aY )
		);

		this.curves.push( curve );

		this.currentPoint.set( aX, aY );

		return this;

	}

	splineThru( pts /*Array of Vector*/ ) {

		const npts = [ this.currentPoint.clone() ].concat( pts );

		const curve = new SplineCurve( npts );
		this.curves.push( curve );

		this.currentPoint.copy( pts[ pts.length - 1 ] );

		return this;

	}

	arc( aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise ) {

		const x0 = this.currentPoint.x;
		const y0 = this.currentPoint.y;

		this.absarc( aX + x0, aY + y0, aRadius,
			aStartAngle, aEndAngle, aClockwise );

		return this;

	}

	absarc( aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise ) {

		this.absellipse( aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise );

		return this;

	}

	ellipse( aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation ) {

		const x0 = this.currentPoint.x;
		const y0 = this.currentPoint.y;

		this.absellipse( aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation );

		return this;

	}

	absellipse( aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation ) {

		const curve = new EllipseCurve( aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation );

		if ( this.curves.length > 0 ) {

			// if a previous curve is present, attempt to join
			const firstPoint = curve.getPoint( 0 );

			if ( ! firstPoint.equals( this.currentPoint ) ) {

				this.lineTo( firstPoint.x, firstPoint.y );

			}

		}

		this.curves.push( curve );

		const lastPoint = curve.getPoint( 1 );
		this.currentPoint.copy( lastPoint );

		return this;

	}

	copy( source ) {

		super.copy( source );

		this.currentPoint.copy( source.currentPoint );

		return this;

	}

	toJSON() {

		const data = super.toJSON();

		data.currentPoint = this.currentPoint.toArray();

		return data;

	}

	fromJSON( json ) {

		super.fromJSON( json );

		this.currentPoint.fromArray( json.currentPoint );

		return this;

	}

}

class LatheGeometry extends BufferGeometry {

	constructor( points = [ new Vector2( 0, - 0.5 ), new Vector2( 0.5, 0 ), new Vector2( 0, 0.5 ) ], segments = 12, phiStart = 0, phiLength = Math.PI * 2 ) {

		super();

		this.type = 'LatheGeometry';

		this.parameters = {
			points: points,
			segments: segments,
			phiStart: phiStart,
			phiLength: phiLength
		};

		segments = Math.floor( segments );

		// clamp phiLength so it's in range of [ 0, 2PI ]

		phiLength = clamp( phiLength, 0, Math.PI * 2 );

		// buffers

		const indices = [];
		const vertices = [];
		const uvs = [];
		const initNormals = [];
		const normals = [];

		// helper variables

		const inverseSegments = 1.0 / segments;
		const vertex = new Vector3();
		const uv = new Vector2();
		const normal = new Vector3();
		const curNormal = new Vector3();
		const prevNormal = new Vector3();
		let dx = 0;
		let dy = 0;

		// pre-compute normals for initial "meridian"

		for ( let j = 0; j <= ( points.length - 1 ); j ++ ) {

			switch ( j ) {

				case 0:				// special handling for 1st vertex on path

					dx = points[ j + 1 ].x - points[ j ].x;
					dy = points[ j + 1 ].y - points[ j ].y;

					normal.x = dy * 1.0;
					normal.y = - dx;
					normal.z = dy * 0.0;

					prevNormal.copy( normal );

					normal.normalize();

					initNormals.push( normal.x, normal.y, normal.z );

					break;

				case ( points.length - 1 ):	// special handling for last Vertex on path

					initNormals.push( prevNormal.x, prevNormal.y, prevNormal.z );

					break;

				default:			// default handling for all vertices in between

					dx = points[ j + 1 ].x - points[ j ].x;
					dy = points[ j + 1 ].y - points[ j ].y;

					normal.x = dy * 1.0;
					normal.y = - dx;
					normal.z = dy * 0.0;

					curNormal.copy( normal );

					normal.x += prevNormal.x;
					normal.y += prevNormal.y;
					normal.z += prevNormal.z;

					normal.normalize();

					initNormals.push( normal.x, normal.y, normal.z );

					prevNormal.copy( curNormal );

			}

		}

		// generate vertices, uvs and normals

		for ( let i = 0; i <= segments; i ++ ) {

			const phi = phiStart + i * inverseSegments * phiLength;

			const sin = Math.sin( phi );
			const cos = Math.cos( phi );

			for ( let j = 0; j <= ( points.length - 1 ); j ++ ) {

				// vertex

				vertex.x = points[ j ].x * sin;
				vertex.y = points[ j ].y;
				vertex.z = points[ j ].x * cos;

				vertices.push( vertex.x, vertex.y, vertex.z );

				// uv

				uv.x = i / segments;
				uv.y = j / ( points.length - 1 );

				uvs.push( uv.x, uv.y );

				// normal

				const x = initNormals[ 3 * j + 0 ] * sin;
				const y = initNormals[ 3 * j + 1 ];
				const z = initNormals[ 3 * j + 0 ] * cos;

				normals.push( x, y, z );

			}

		}

		// indices

		for ( let i = 0; i < segments; i ++ ) {

			for ( let j = 0; j < ( points.length - 1 ); j ++ ) {

				const base = j + i * points.length;

				const a = base;
				const b = base + points.length;
				const c = base + points.length + 1;
				const d = base + 1;

				// faces

				indices.push( a, b, d );
				indices.push( c, d, b );

			}

		}

		// build geometry

		this.setIndex( indices );
		this.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.setAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );
		this.setAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );

	}

	copy( source ) {

		super.copy( source );

		this.parameters = Object.assign( {}, source.parameters );

		return this;

	}

	static fromJSON( data ) {

		return new LatheGeometry( data.points, data.segments, data.phiStart, data.phiLength );

	}

}

class CapsuleGeometry extends LatheGeometry {

	constructor( radius = 1, length = 1, capSegments = 4, radialSegments = 8 ) {

		const path = new Path();
		path.absarc( 0, - length / 2, radius, Math.PI * 1.5, 0 );
		path.absarc( 0, length / 2, radius, 0, Math.PI * 0.5 );

		super( path.getPoints( capSegments ), radialSegments );

		this.type = 'CapsuleGeometry';

		this.parameters = {
			radius: radius,
			length: length,
			capSegments: capSegments,
			radialSegments: radialSegments,
		};

	}

	static fromJSON( data ) {

		return new CapsuleGeometry( data.radius, data.length, data.capSegments, data.radialSegments );

	}

}

class CircleGeometry extends BufferGeometry {

	constructor( radius = 1, segments = 32, thetaStart = 0, thetaLength = Math.PI * 2 ) {

		super();

		this.type = 'CircleGeometry';

		this.parameters = {
			radius: radius,
			segments: segments,
			thetaStart: thetaStart,
			thetaLength: thetaLength
		};

		segments = Math.max( 3, segments );

		// buffers

		const indices = [];
		const vertices = [];
		const normals = [];
		const uvs = [];

		// helper variables

		const vertex = new Vector3();
		const uv = new Vector2();

		// center point

		vertices.push( 0, 0, 0 );
		normals.push( 0, 0, 1 );
		uvs.push( 0.5, 0.5 );

		for ( let s = 0, i = 3; s <= segments; s ++, i += 3 ) {

			const segment = thetaStart + s / segments * thetaLength;

			// vertex

			vertex.x = radius * Math.cos( segment );
			vertex.y = radius * Math.sin( segment );

			vertices.push( vertex.x, vertex.y, vertex.z );

			// normal

			normals.push( 0, 0, 1 );

			// uvs

			uv.x = ( vertices[ i ] / radius + 1 ) / 2;
			uv.y = ( vertices[ i + 1 ] / radius + 1 ) / 2;

			uvs.push( uv.x, uv.y );

		}

		// indices

		for ( let i = 1; i <= segments; i ++ ) {

			indices.push( i, i + 1, 0 );

		}

		// build geometry

		this.setIndex( indices );
		this.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.setAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
		this.setAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

	}

	copy( source ) {

		super.copy( source );

		this.parameters = Object.assign( {}, source.parameters );

		return this;

	}

	static fromJSON( data ) {

		return new CircleGeometry( data.radius, data.segments, data.thetaStart, data.thetaLength );

	}

}

class CylinderGeometry extends BufferGeometry {

	constructor( radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2 ) {

		super();

		this.type = 'CylinderGeometry';

		this.parameters = {
			radiusTop: radiusTop,
			radiusBottom: radiusBottom,
			height: height,
			radialSegments: radialSegments,
			heightSegments: heightSegments,
			openEnded: openEnded,
			thetaStart: thetaStart,
			thetaLength: thetaLength
		};

		const scope = this;

		radialSegments = Math.floor( radialSegments );
		heightSegments = Math.floor( heightSegments );

		// buffers

		const indices = [];
		const vertices = [];
		const normals = [];
		const uvs = [];

		// helper variables

		let index = 0;
		const indexArray = [];
		const halfHeight = height / 2;
		let groupStart = 0;

		// generate geometry

		generateTorso();

		if ( openEnded === false ) {

			if ( radiusTop > 0 ) generateCap( true );
			if ( radiusBottom > 0 ) generateCap( false );

		}

		// build geometry

		this.setIndex( indices );
		this.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.setAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
		this.setAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

		function generateTorso() {

			const normal = new Vector3();
			const vertex = new Vector3();

			let groupCount = 0;

			// this will be used to calculate the normal
			const slope = ( radiusBottom - radiusTop ) / height;

			// generate vertices, normals and uvs

			for ( let y = 0; y <= heightSegments; y ++ ) {

				const indexRow = [];

				const v = y / heightSegments;

				// calculate the radius of the current row

				const radius = v * ( radiusBottom - radiusTop ) + radiusTop;

				for ( let x = 0; x <= radialSegments; x ++ ) {

					const u = x / radialSegments;

					const theta = u * thetaLength + thetaStart;

					const sinTheta = Math.sin( theta );
					const cosTheta = Math.cos( theta );

					// vertex

					vertex.x = radius * sinTheta;
					vertex.y = - v * height + halfHeight;
					vertex.z = radius * cosTheta;
					vertices.push( vertex.x, vertex.y, vertex.z );

					// normal

					normal.set( sinTheta, slope, cosTheta ).normalize();
					normals.push( normal.x, normal.y, normal.z );

					// uv

					uvs.push( u, 1 - v );

					// save index of vertex in respective row

					indexRow.push( index ++ );

				}

				// now save vertices of the row in our index array

				indexArray.push( indexRow );

			}

			// generate indices

			for ( let x = 0; x < radialSegments; x ++ ) {

				for ( let y = 0; y < heightSegments; y ++ ) {

					// we use the index array to access the correct indices

					const a = indexArray[ y ][ x ];
					const b = indexArray[ y + 1 ][ x ];
					const c = indexArray[ y + 1 ][ x + 1 ];
					const d = indexArray[ y ][ x + 1 ];

					// faces

					indices.push( a, b, d );
					indices.push( b, c, d );

					// update group counter

					groupCount += 6;

				}

			}

			// add a group to the geometry. this will ensure multi material support

			scope.addGroup( groupStart, groupCount, 0 );

			// calculate new start value for groups

			groupStart += groupCount;

		}

		function generateCap( top ) {

			// save the index of the first center vertex
			const centerIndexStart = index;

			const uv = new Vector2();
			const vertex = new Vector3();

			let groupCount = 0;

			const radius = ( top === true ) ? radiusTop : radiusBottom;
			const sign = ( top === true ) ? 1 : - 1;

			// first we generate the center vertex data of the cap.
			// because the geometry needs one set of uvs per face,
			// we must generate a center vertex per face/segment

			for ( let x = 1; x <= radialSegments; x ++ ) {

				// vertex

				vertices.push( 0, halfHeight * sign, 0 );

				// normal

				normals.push( 0, sign, 0 );

				// uv

				uvs.push( 0.5, 0.5 );

				// increase index

				index ++;

			}

			// save the index of the last center vertex
			const centerIndexEnd = index;

			// now we generate the surrounding vertices, normals and uvs

			for ( let x = 0; x <= radialSegments; x ++ ) {

				const u = x / radialSegments;
				const theta = u * thetaLength + thetaStart;

				const cosTheta = Math.cos( theta );
				const sinTheta = Math.sin( theta );

				// vertex

				vertex.x = radius * sinTheta;
				vertex.y = halfHeight * sign;
				vertex.z = radius * cosTheta;
				vertices.push( vertex.x, vertex.y, vertex.z );

				// normal

				normals.push( 0, sign, 0 );

				// uv

				uv.x = ( cosTheta * 0.5 ) + 0.5;
				uv.y = ( sinTheta * 0.5 * sign ) + 0.5;
				uvs.push( uv.x, uv.y );

				// increase index

				index ++;

			}

			// generate indices

			for ( let x = 0; x < radialSegments; x ++ ) {

				const c = centerIndexStart + x;
				const i = centerIndexEnd + x;

				if ( top === true ) {

					// face top

					indices.push( i, i + 1, c );

				} else {

					// face bottom

					indices.push( i + 1, i, c );

				}

				groupCount += 3;

			}

			// add a group to the geometry. this will ensure multi material support

			scope.addGroup( groupStart, groupCount, top === true ? 1 : 2 );

			// calculate new start value for groups

			groupStart += groupCount;

		}

	}

	copy( source ) {

		super.copy( source );

		this.parameters = Object.assign( {}, source.parameters );

		return this;

	}

	static fromJSON( data ) {

		return new CylinderGeometry( data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength );

	}

}

class ConeGeometry extends CylinderGeometry {

	constructor( radius = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2 ) {

		super( 0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength );

		this.type = 'ConeGeometry';

		this.parameters = {
			radius: radius,
			height: height,
			radialSegments: radialSegments,
			heightSegments: heightSegments,
			openEnded: openEnded,
			thetaStart: thetaStart,
			thetaLength: thetaLength
		};

	}

	static fromJSON( data ) {

		return new ConeGeometry( data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength );

	}

}

class PolyhedronGeometry extends BufferGeometry {

	constructor( vertices = [], indices = [], radius = 1, detail = 0 ) {

		super();

		this.type = 'PolyhedronGeometry';

		this.parameters = {
			vertices: vertices,
			indices: indices,
			radius: radius,
			detail: detail
		};

		// default buffer data

		const vertexBuffer = [];
		const uvBuffer = [];

		// the subdivision creates the vertex buffer data

		subdivide( detail );

		// all vertices should lie on a conceptual sphere with a given radius

		applyRadius( radius );

		// finally, create the uv data

		generateUVs();

		// build non-indexed geometry

		this.setAttribute( 'position', new Float32BufferAttribute( vertexBuffer, 3 ) );
		this.setAttribute( 'normal', new Float32BufferAttribute( vertexBuffer.slice(), 3 ) );
		this.setAttribute( 'uv', new Float32BufferAttribute( uvBuffer, 2 ) );

		if ( detail === 0 ) {

			this.computeVertexNormals(); // flat normals

		} else {

			this.normalizeNormals(); // smooth normals

		}

		// helper functions

		function subdivide( detail ) {

			const a = new Vector3();
			const b = new Vector3();
			const c = new Vector3();

			// iterate over all faces and apply a subdivision with the given detail value

			for ( let i = 0; i < indices.length; i += 3 ) {

				// get the vertices of the face

				getVertexByIndex( indices[ i + 0 ], a );
				getVertexByIndex( indices[ i + 1 ], b );
				getVertexByIndex( indices[ i + 2 ], c );

				// perform subdivision

				subdivideFace( a, b, c, detail );

			}

		}

		function subdivideFace( a, b, c, detail ) {

			const cols = detail + 1;

			// we use this multidimensional array as a data structure for creating the subdivision

			const v = [];

			// construct all of the vertices for this subdivision

			for ( let i = 0; i <= cols; i ++ ) {

				v[ i ] = [];

				const aj = a.clone().lerp( c, i / cols );
				const bj = b.clone().lerp( c, i / cols );

				const rows = cols - i;

				for ( let j = 0; j <= rows; j ++ ) {

					if ( j === 0 && i === cols ) {

						v[ i ][ j ] = aj;

					} else {

						v[ i ][ j ] = aj.clone().lerp( bj, j / rows );

					}

				}

			}

			// construct all of the faces

			for ( let i = 0; i < cols; i ++ ) {

				for ( let j = 0; j < 2 * ( cols - i ) - 1; j ++ ) {

					const k = Math.floor( j / 2 );

					if ( j % 2 === 0 ) {

						pushVertex( v[ i ][ k + 1 ] );
						pushVertex( v[ i + 1 ][ k ] );
						pushVertex( v[ i ][ k ] );

					} else {

						pushVertex( v[ i ][ k + 1 ] );
						pushVertex( v[ i + 1 ][ k + 1 ] );
						pushVertex( v[ i + 1 ][ k ] );

					}

				}

			}

		}

		function applyRadius( radius ) {

			const vertex = new Vector3();

			// iterate over the entire buffer and apply the radius to each vertex

			for ( let i = 0; i < vertexBuffer.length; i += 3 ) {

				vertex.x = vertexBuffer[ i + 0 ];
				vertex.y = vertexBuffer[ i + 1 ];
				vertex.z = vertexBuffer[ i + 2 ];

				vertex.normalize().multiplyScalar( radius );

				vertexBuffer[ i + 0 ] = vertex.x;
				vertexBuffer[ i + 1 ] = vertex.y;
				vertexBuffer[ i + 2 ] = vertex.z;

			}

		}

		function generateUVs() {

			const vertex = new Vector3();

			for ( let i = 0; i < vertexBuffer.length; i += 3 ) {

				vertex.x = vertexBuffer[ i + 0 ];
				vertex.y = vertexBuffer[ i + 1 ];
				vertex.z = vertexBuffer[ i + 2 ];

				const u = azimuth( vertex ) / 2 / Math.PI + 0.5;
				const v = inclination( vertex ) / Math.PI + 0.5;
				uvBuffer.push( u, 1 - v );

			}

			correctUVs();

			correctSeam();

		}

		function correctSeam() {

			// handle case when face straddles the seam, see #3269

			for ( let i = 0; i < uvBuffer.length; i += 6 ) {

				// uv data of a single face

				const x0 = uvBuffer[ i + 0 ];
				const x1 = uvBuffer[ i + 2 ];
				const x2 = uvBuffer[ i + 4 ];

				const max = Math.max( x0, x1, x2 );
				const min = Math.min( x0, x1, x2 );

				// 0.9 is somewhat arbitrary

				if ( max > 0.9 && min < 0.1 ) {

					if ( x0 < 0.2 ) uvBuffer[ i + 0 ] += 1;
					if ( x1 < 0.2 ) uvBuffer[ i + 2 ] += 1;
					if ( x2 < 0.2 ) uvBuffer[ i + 4 ] += 1;

				}

			}

		}

		function pushVertex( vertex ) {

			vertexBuffer.push( vertex.x, vertex.y, vertex.z );

		}

		function getVertexByIndex( index, vertex ) {

			const stride = index * 3;

			vertex.x = vertices[ stride + 0 ];
			vertex.y = vertices[ stride + 1 ];
			vertex.z = vertices[ stride + 2 ];

		}

		function correctUVs() {

			const a = new Vector3();
			const b = new Vector3();
			const c = new Vector3();

			const centroid = new Vector3();

			const uvA = new Vector2();
			const uvB = new Vector2();
			const uvC = new Vector2();

			for ( let i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6 ) {

				a.set( vertexBuffer[ i + 0 ], vertexBuffer[ i + 1 ], vertexBuffer[ i + 2 ] );
				b.set( vertexBuffer[ i + 3 ], vertexBuffer[ i + 4 ], vertexBuffer[ i + 5 ] );
				c.set( vertexBuffer[ i + 6 ], vertexBuffer[ i + 7 ], vertexBuffer[ i + 8 ] );

				uvA.set( uvBuffer[ j + 0 ], uvBuffer[ j + 1 ] );
				uvB.set( uvBuffer[ j + 2 ], uvBuffer[ j + 3 ] );
				uvC.set( uvBuffer[ j + 4 ], uvBuffer[ j + 5 ] );

				centroid.copy( a ).add( b ).add( c ).divideScalar( 3 );

				const azi = azimuth( centroid );

				correctUV( uvA, j + 0, a, azi );
				correctUV( uvB, j + 2, b, azi );
				correctUV( uvC, j + 4, c, azi );

			}

		}

		function correctUV( uv, stride, vector, azimuth ) {

			if ( ( azimuth < 0 ) && ( uv.x === 1 ) ) {

				uvBuffer[ stride ] = uv.x - 1;

			}

			if ( ( vector.x === 0 ) && ( vector.z === 0 ) ) {

				uvBuffer[ stride ] = azimuth / 2 / Math.PI + 0.5;

			}

		}

		// Angle around the Y axis, counter-clockwise when looking from above.

		function azimuth( vector ) {

			return Math.atan2( vector.z, - vector.x );

		}


		// Angle above the XZ plane.

		function inclination( vector ) {

			return Math.atan2( - vector.y, Math.sqrt( ( vector.x * vector.x ) + ( vector.z * vector.z ) ) );

		}

	}

	copy( source ) {

		super.copy( source );

		this.parameters = Object.assign( {}, source.parameters );

		return this;

	}

	static fromJSON( data ) {

		return new PolyhedronGeometry( data.vertices, data.indices, data.radius, data.details );

	}

}

class DodecahedronGeometry extends PolyhedronGeometry {

	constructor( radius = 1, detail = 0 ) {

		const t = ( 1 + Math.sqrt( 5 ) ) / 2;
		const r = 1 / t;

		const vertices = [

			// (±1, ±1, ±1)
			- 1, - 1, - 1,	- 1, - 1, 1,
			- 1, 1, - 1, - 1, 1, 1,
			1, - 1, - 1, 1, - 1, 1,
			1, 1, - 1, 1, 1, 1,

			// (0, ±1/φ, ±φ)
			0, - r, - t, 0, - r, t,
			0, r, - t, 0, r, t,

			// (±1/φ, ±φ, 0)
			- r, - t, 0, - r, t, 0,
			r, - t, 0, r, t, 0,

			// (±φ, 0, ±1/φ)
			- t, 0, - r, t, 0, - r,
			- t, 0, r, t, 0, r
		];

		const indices = [
			3, 11, 7, 	3, 7, 15, 	3, 15, 13,
			7, 19, 17, 	7, 17, 6, 	7, 6, 15,
			17, 4, 8, 	17, 8, 10, 	17, 10, 6,
			8, 0, 16, 	8, 16, 2, 	8, 2, 10,
			0, 12, 1, 	0, 1, 18, 	0, 18, 16,
			6, 10, 2, 	6, 2, 13, 	6, 13, 15,
			2, 16, 18, 	2, 18, 3, 	2, 3, 13,
			18, 1, 9, 	18, 9, 11, 	18, 11, 3,
			4, 14, 12, 	4, 12, 0, 	4, 0, 8,
			11, 9, 5, 	11, 5, 19, 	11, 19, 7,
			19, 5, 14, 	19, 14, 4, 	19, 4, 17,
			1, 12, 14, 	1, 14, 5, 	1, 5, 9
		];

		super( vertices, indices, radius, detail );

		this.type = 'DodecahedronGeometry';

		this.parameters = {
			radius: radius,
			detail: detail
		};

	}

	static fromJSON( data ) {

		return new DodecahedronGeometry( data.radius, data.detail );

	}

}

const _v0 = /*@__PURE__*/ new Vector3();
const _v1$1 = /*@__PURE__*/ new Vector3();
const _normal = /*@__PURE__*/ new Vector3();
const _triangle = /*@__PURE__*/ new Triangle();

class EdgesGeometry extends BufferGeometry {

	constructor( geometry = null, thresholdAngle = 1 ) {

		super();

		this.type = 'EdgesGeometry';

		this.parameters = {
			geometry: geometry,
			thresholdAngle: thresholdAngle
		};

		if ( geometry !== null ) {

			const precisionPoints = 4;
			const precision = Math.pow( 10, precisionPoints );
			const thresholdDot = Math.cos( DEG2RAD * thresholdAngle );

			const indexAttr = geometry.getIndex();
			const positionAttr = geometry.getAttribute( 'position' );
			const indexCount = indexAttr ? indexAttr.count : positionAttr.count;

			const indexArr = [ 0, 0, 0 ];
			const vertKeys = [ 'a', 'b', 'c' ];
			const hashes = new Array( 3 );

			const edgeData = {};
			const vertices = [];
			for ( let i = 0; i < indexCount; i += 3 ) {

				if ( indexAttr ) {

					indexArr[ 0 ] = indexAttr.getX( i );
					indexArr[ 1 ] = indexAttr.getX( i + 1 );
					indexArr[ 2 ] = indexAttr.getX( i + 2 );

				} else {

					indexArr[ 0 ] = i;
					indexArr[ 1 ] = i + 1;
					indexArr[ 2 ] = i + 2;

				}

				const { a, b, c } = _triangle;
				a.fromBufferAttribute( positionAttr, indexArr[ 0 ] );
				b.fromBufferAttribute( positionAttr, indexArr[ 1 ] );
				c.fromBufferAttribute( positionAttr, indexArr[ 2 ] );
				_triangle.getNormal( _normal );

				// create hashes for the edge from the vertices
				hashes[ 0 ] = `${ Math.round( a.x * precision ) },${ Math.round( a.y * precision ) },${ Math.round( a.z * precision ) }`;
				hashes[ 1 ] = `${ Math.round( b.x * precision ) },${ Math.round( b.y * precision ) },${ Math.round( b.z * precision ) }`;
				hashes[ 2 ] = `${ Math.round( c.x * precision ) },${ Math.round( c.y * precision ) },${ Math.round( c.z * precision ) }`;

				// skip degenerate triangles
				if ( hashes[ 0 ] === hashes[ 1 ] || hashes[ 1 ] === hashes[ 2 ] || hashes[ 2 ] === hashes[ 0 ] ) {

					continue;

				}

				// iterate over every edge
				for ( let j = 0; j < 3; j ++ ) {

					// get the first and next vertex making up the edge
					const jNext = ( j + 1 ) % 3;
					const vecHash0 = hashes[ j ];
					const vecHash1 = hashes[ jNext ];
					const v0 = _triangle[ vertKeys[ j ] ];
					const v1 = _triangle[ vertKeys[ jNext ] ];

					const hash = `${ vecHash0 }_${ vecHash1 }`;
					const reverseHash = `${ vecHash1 }_${ vecHash0 }`;

					if ( reverseHash in edgeData && edgeData[ reverseHash ] ) {

						// if we found a sibling edge add it into the vertex array if
						// it meets the angle threshold and delete the edge from the map.
						if ( _normal.dot( edgeData[ reverseHash ].normal ) <= thresholdDot ) {

							vertices.push( v0.x, v0.y, v0.z );
							vertices.push( v1.x, v1.y, v1.z );

						}

						edgeData[ reverseHash ] = null;

					} else if ( ! ( hash in edgeData ) ) {

						// if we've already got an edge here then skip adding a new one
						edgeData[ hash ] = {

							index0: indexArr[ j ],
							index1: indexArr[ jNext ],
							normal: _normal.clone(),

						};

					}

				}

			}

			// iterate over all remaining, unmatched edges and add them to the vertex array
			for ( const key in edgeData ) {

				if ( edgeData[ key ] ) {

					const { index0, index1 } = edgeData[ key ];
					_v0.fromBufferAttribute( positionAttr, index0 );
					_v1$1.fromBufferAttribute( positionAttr, index1 );

					vertices.push( _v0.x, _v0.y, _v0.z );
					vertices.push( _v1$1.x, _v1$1.y, _v1$1.z );

				}

			}

			this.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );

		}

	}

	copy( source ) {

		super.copy( source );

		this.parameters = Object.assign( {}, source.parameters );

		return this;

	}

}

class Shape extends Path {

	constructor( points ) {

		super( points );

		this.uuid = generateUUID();

		this.type = 'Shape';

		this.holes = [];

	}

	getPointsHoles( divisions ) {

		const holesPts = [];

		for ( let i = 0, l = this.holes.length; i < l; i ++ ) {

			holesPts[ i ] = this.holes[ i ].getPoints( divisions );

		}

		return holesPts;

	}

	// get points of shape and holes (keypoints based on segments parameter)

	extractPoints( divisions ) {

		return {

			shape: this.getPoints( divisions ),
			holes: this.getPointsHoles( divisions )

		};

	}

	copy( source ) {

		super.copy( source );

		this.holes = [];

		for ( let i = 0, l = source.holes.length; i < l; i ++ ) {

			const hole = source.holes[ i ];

			this.holes.push( hole.clone() );

		}

		return this;

	}

	toJSON() {

		const data = super.toJSON();

		data.uuid = this.uuid;
		data.holes = [];

		for ( let i = 0, l = this.holes.length; i < l; i ++ ) {

			const hole = this.holes[ i ];
			data.holes.push( hole.toJSON() );

		}

		return data;

	}

	fromJSON( json ) {

		super.fromJSON( json );

		this.uuid = json.uuid;
		this.holes = [];

		for ( let i = 0, l = json.holes.length; i < l; i ++ ) {

			const hole = json.holes[ i ];
			this.holes.push( new Path().fromJSON( hole ) );

		}

		return this;

	}

}

/**
 * Port from https://github.com/mapbox/earcut (v2.2.4)
 */

const Earcut = {

	triangulate: function ( data, holeIndices, dim = 2 ) {

		const hasHoles = holeIndices && holeIndices.length;
		const outerLen = hasHoles ? holeIndices[ 0 ] * dim : data.length;
		let outerNode = linkedList( data, 0, outerLen, dim, true );
		const triangles = [];

		if ( ! outerNode || outerNode.next === outerNode.prev ) return triangles;

		let minX, minY, maxX, maxY, x, y, invSize;

		if ( hasHoles ) outerNode = eliminateHoles( data, holeIndices, outerNode, dim );

		// if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
		if ( data.length > 80 * dim ) {

			minX = maxX = data[ 0 ];
			minY = maxY = data[ 1 ];

			for ( let i = dim; i < outerLen; i += dim ) {

				x = data[ i ];
				y = data[ i + 1 ];
				if ( x < minX ) minX = x;
				if ( y < minY ) minY = y;
				if ( x > maxX ) maxX = x;
				if ( y > maxY ) maxY = y;

			}

			// minX, minY and invSize are later used to transform coords into integers for z-order calculation
			invSize = Math.max( maxX - minX, maxY - minY );
			invSize = invSize !== 0 ? 32767 / invSize : 0;

		}

		earcutLinked( outerNode, triangles, dim, minX, minY, invSize, 0 );

		return triangles;

	}

};

// create a circular doubly linked list from polygon points in the specified winding order
function linkedList( data, start, end, dim, clockwise ) {

	let i, last;

	if ( clockwise === ( signedArea( data, start, end, dim ) > 0 ) ) {

		for ( i = start; i < end; i += dim ) last = insertNode( i, data[ i ], data[ i + 1 ], last );

	} else {

		for ( i = end - dim; i >= start; i -= dim ) last = insertNode( i, data[ i ], data[ i + 1 ], last );

	}

	if ( last && equals( last, last.next ) ) {

		removeNode( last );
		last = last.next;

	}

	return last;

}

// eliminate colinear or duplicate points
function filterPoints( start, end ) {

	if ( ! start ) return start;
	if ( ! end ) end = start;

	let p = start,
		again;
	do {

		again = false;

		if ( ! p.steiner && ( equals( p, p.next ) || area( p.prev, p, p.next ) === 0 ) ) {

			removeNode( p );
			p = end = p.prev;
			if ( p === p.next ) break;
			again = true;

		} else {

			p = p.next;

		}

	} while ( again || p !== end );

	return end;

}

// main ear slicing loop which triangulates a polygon (given as a linked list)
function earcutLinked( ear, triangles, dim, minX, minY, invSize, pass ) {

	if ( ! ear ) return;

	// interlink polygon nodes in z-order
	if ( ! pass && invSize ) indexCurve( ear, minX, minY, invSize );

	let stop = ear,
		prev, next;

	// iterate through ears, slicing them one by one
	while ( ear.prev !== ear.next ) {

		prev = ear.prev;
		next = ear.next;

		if ( invSize ? isEarHashed( ear, minX, minY, invSize ) : isEar( ear ) ) {

			// cut off the triangle
			triangles.push( prev.i / dim | 0 );
			triangles.push( ear.i / dim | 0 );
			triangles.push( next.i / dim | 0 );

			removeNode( ear );

			// skipping the next vertex leads to less sliver triangles
			ear = next.next;
			stop = next.next;

			continue;

		}

		ear = next;

		// if we looped through the whole remaining polygon and can't find any more ears
		if ( ear === stop ) {

			// try filtering points and slicing again
			if ( ! pass ) {

				earcutLinked( filterPoints( ear ), triangles, dim, minX, minY, invSize, 1 );

				// if this didn't work, try curing all small self-intersections locally

			} else if ( pass === 1 ) {

				ear = cureLocalIntersections( filterPoints( ear ), triangles, dim );
				earcutLinked( ear, triangles, dim, minX, minY, invSize, 2 );

				// as a last resort, try splitting the remaining polygon into two

			} else if ( pass === 2 ) {

				splitEarcut( ear, triangles, dim, minX, minY, invSize );

			}

			break;

		}

	}

}

// check whether a polygon node forms a valid ear with adjacent nodes
function isEar( ear ) {

	const a = ear.prev,
		b = ear,
		c = ear.next;

	if ( area( a, b, c ) >= 0 ) return false; // reflex, can't be an ear

	// now make sure we don't have other points inside the potential ear
	const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;

	// triangle bbox; min & max are calculated like this for speed
	const x0 = ax < bx ? ( ax < cx ? ax : cx ) : ( bx < cx ? bx : cx ),
		y0 = ay < by ? ( ay < cy ? ay : cy ) : ( by < cy ? by : cy ),
		x1 = ax > bx ? ( ax > cx ? ax : cx ) : ( bx > cx ? bx : cx ),
		y1 = ay > by ? ( ay > cy ? ay : cy ) : ( by > cy ? by : cy );

	let p = c.next;
	while ( p !== a ) {

		if ( p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 &&
			pointInTriangle( ax, ay, bx, by, cx, cy, p.x, p.y ) &&
			area( p.prev, p, p.next ) >= 0 ) return false;
		p = p.next;

	}

	return true;

}

function isEarHashed( ear, minX, minY, invSize ) {

	const a = ear.prev,
		b = ear,
		c = ear.next;

	if ( area( a, b, c ) >= 0 ) return false; // reflex, can't be an ear

	const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;

	// triangle bbox; min & max are calculated like this for speed
	const x0 = ax < bx ? ( ax < cx ? ax : cx ) : ( bx < cx ? bx : cx ),
		y0 = ay < by ? ( ay < cy ? ay : cy ) : ( by < cy ? by : cy ),
		x1 = ax > bx ? ( ax > cx ? ax : cx ) : ( bx > cx ? bx : cx ),
		y1 = ay > by ? ( ay > cy ? ay : cy ) : ( by > cy ? by : cy );

	// z-order range for the current triangle bbox;
	const minZ = zOrder( x0, y0, minX, minY, invSize ),
		maxZ = zOrder( x1, y1, minX, minY, invSize );

	let p = ear.prevZ,
		n = ear.nextZ;

	// look for points inside the triangle in both directions
	while ( p && p.z >= minZ && n && n.z <= maxZ ) {

		if ( p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c &&
			pointInTriangle( ax, ay, bx, by, cx, cy, p.x, p.y ) && area( p.prev, p, p.next ) >= 0 ) return false;
		p = p.prevZ;

		if ( n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c &&
			pointInTriangle( ax, ay, bx, by, cx, cy, n.x, n.y ) && area( n.prev, n, n.next ) >= 0 ) return false;
		n = n.nextZ;

	}

	// look for remaining points in decreasing z-order
	while ( p && p.z >= minZ ) {

		if ( p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c &&
			pointInTriangle( ax, ay, bx, by, cx, cy, p.x, p.y ) && area( p.prev, p, p.next ) >= 0 ) return false;
		p = p.prevZ;

	}

	// look for remaining points in increasing z-order
	while ( n && n.z <= maxZ ) {

		if ( n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c &&
			pointInTriangle( ax, ay, bx, by, cx, cy, n.x, n.y ) && area( n.prev, n, n.next ) >= 0 ) return false;
		n = n.nextZ;

	}

	return true;

}

// go through all polygon nodes and cure small local self-intersections
function cureLocalIntersections( start, triangles, dim ) {

	let p = start;
	do {

		const a = p.prev,
			b = p.next.next;

		if ( ! equals( a, b ) && intersects( a, p, p.next, b ) && locallyInside( a, b ) && locallyInside( b, a ) ) {

			triangles.push( a.i / dim | 0 );
			triangles.push( p.i / dim | 0 );
			triangles.push( b.i / dim | 0 );

			// remove two nodes involved
			removeNode( p );
			removeNode( p.next );

			p = start = b;

		}

		p = p.next;

	} while ( p !== start );

	return filterPoints( p );

}

// try splitting polygon into two and triangulate them independently
function splitEarcut( start, triangles, dim, minX, minY, invSize ) {

	// look for a valid diagonal that divides the polygon into two
	let a = start;
	do {

		let b = a.next.next;
		while ( b !== a.prev ) {

			if ( a.i !== b.i && isValidDiagonal( a, b ) ) {

				// split the polygon in two by the diagonal
				let c = splitPolygon( a, b );

				// filter colinear points around the cuts
				a = filterPoints( a, a.next );
				c = filterPoints( c, c.next );

				// run earcut on each half
				earcutLinked( a, triangles, dim, minX, minY, invSize, 0 );
				earcutLinked( c, triangles, dim, minX, minY, invSize, 0 );
				return;

			}

			b = b.next;

		}

		a = a.next;

	} while ( a !== start );

}

// link every hole into the outer loop, producing a single-ring polygon without holes
function eliminateHoles( data, holeIndices, outerNode, dim ) {

	const queue = [];
	let i, len, start, end, list;

	for ( i = 0, len = holeIndices.length; i < len; i ++ ) {

		start = holeIndices[ i ] * dim;
		end = i < len - 1 ? holeIndices[ i + 1 ] * dim : data.length;
		list = linkedList( data, start, end, dim, false );
		if ( list === list.next ) list.steiner = true;
		queue.push( getLeftmost( list ) );

	}

	queue.sort( compareX );

	// process holes from left to right
	for ( i = 0; i < queue.length; i ++ ) {

		outerNode = eliminateHole( queue[ i ], outerNode );

	}

	return outerNode;

}

function compareX( a, b ) {

	return a.x - b.x;

}

// find a bridge between vertices that connects hole with an outer ring and link it
function eliminateHole( hole, outerNode ) {

	const bridge = findHoleBridge( hole, outerNode );
	if ( ! bridge ) {

		return outerNode;

	}

	const bridgeReverse = splitPolygon( bridge, hole );

	// filter collinear points around the cuts
	filterPoints( bridgeReverse, bridgeReverse.next );
	return filterPoints( bridge, bridge.next );

}

// David Eberly's algorithm for finding a bridge between hole and outer polygon
function findHoleBridge( hole, outerNode ) {

	let p = outerNode,
		qx = - Infinity,
		m;

	const hx = hole.x, hy = hole.y;

	// find a segment intersected by a ray from the hole's leftmost point to the left;
	// segment's endpoint with lesser x will be potential connection point
	do {

		if ( hy <= p.y && hy >= p.next.y && p.next.y !== p.y ) {

			const x = p.x + ( hy - p.y ) * ( p.next.x - p.x ) / ( p.next.y - p.y );
			if ( x <= hx && x > qx ) {

				qx = x;
				m = p.x < p.next.x ? p : p.next;
				if ( x === hx ) return m; // hole touches outer segment; pick leftmost endpoint

			}

		}

		p = p.next;

	} while ( p !== outerNode );

	if ( ! m ) return null;

	// look for points inside the triangle of hole point, segment intersection and endpoint;
	// if there are no points found, we have a valid connection;
	// otherwise choose the point of the minimum angle with the ray as connection point

	const stop = m,
		mx = m.x,
		my = m.y;
	let tanMin = Infinity, tan;

	p = m;

	do {

		if ( hx >= p.x && p.x >= mx && hx !== p.x &&
				pointInTriangle( hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y ) ) {

			tan = Math.abs( hy - p.y ) / ( hx - p.x ); // tangential

			if ( locallyInside( p, hole ) && ( tan < tanMin || ( tan === tanMin && ( p.x > m.x || ( p.x === m.x && sectorContainsSector( m, p ) ) ) ) ) ) {

				m = p;
				tanMin = tan;

			}

		}

		p = p.next;

	} while ( p !== stop );

	return m;

}

// whether sector in vertex m contains sector in vertex p in the same coordinates
function sectorContainsSector( m, p ) {

	return area( m.prev, m, p.prev ) < 0 && area( p.next, m, m.next ) < 0;

}

// interlink polygon nodes in z-order
function indexCurve( start, minX, minY, invSize ) {

	let p = start;
	do {

		if ( p.z === 0 ) p.z = zOrder( p.x, p.y, minX, minY, invSize );
		p.prevZ = p.prev;
		p.nextZ = p.next;
		p = p.next;

	} while ( p !== start );

	p.prevZ.nextZ = null;
	p.prevZ = null;

	sortLinked( p );

}

// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function sortLinked( list ) {

	let i, p, q, e, tail, numMerges, pSize, qSize,
		inSize = 1;

	do {

		p = list;
		list = null;
		tail = null;
		numMerges = 0;

		while ( p ) {

			numMerges ++;
			q = p;
			pSize = 0;
			for ( i = 0; i < inSize; i ++ ) {

				pSize ++;
				q = q.nextZ;
				if ( ! q ) break;

			}

			qSize = inSize;

			while ( pSize > 0 || ( qSize > 0 && q ) ) {

				if ( pSize !== 0 && ( qSize === 0 || ! q || p.z <= q.z ) ) {

					e = p;
					p = p.nextZ;
					pSize --;

				} else {

					e = q;
					q = q.nextZ;
					qSize --;

				}

				if ( tail ) tail.nextZ = e;
				else list = e;

				e.prevZ = tail;
				tail = e;

			}

			p = q;

		}

		tail.nextZ = null;
		inSize *= 2;

	} while ( numMerges > 1 );

	return list;

}

// z-order of a point given coords and inverse of the longer side of data bbox
function zOrder( x, y, minX, minY, invSize ) {

	// coords are transformed into non-negative 15-bit integer range
	x = ( x - minX ) * invSize | 0;
	y = ( y - minY ) * invSize | 0;

	x = ( x | ( x << 8 ) ) & 0x00FF00FF;
	x = ( x | ( x << 4 ) ) & 0x0F0F0F0F;
	x = ( x | ( x << 2 ) ) & 0x33333333;
	x = ( x | ( x << 1 ) ) & 0x55555555;

	y = ( y | ( y << 8 ) ) & 0x00FF00FF;
	y = ( y | ( y << 4 ) ) & 0x0F0F0F0F;
	y = ( y | ( y << 2 ) ) & 0x33333333;
	y = ( y | ( y << 1 ) ) & 0x55555555;

	return x | ( y << 1 );

}

// find the leftmost node of a polygon ring
function getLeftmost( start ) {

	let p = start,
		leftmost = start;
	do {

		if ( p.x < leftmost.x || ( p.x === leftmost.x && p.y < leftmost.y ) ) leftmost = p;
		p = p.next;

	} while ( p !== start );

	return leftmost;

}

// check if a point lies within a convex triangle
function pointInTriangle( ax, ay, bx, by, cx, cy, px, py ) {

	return ( cx - px ) * ( ay - py ) >= ( ax - px ) * ( cy - py ) &&
           ( ax - px ) * ( by - py ) >= ( bx - px ) * ( ay - py ) &&
           ( bx - px ) * ( cy - py ) >= ( cx - px ) * ( by - py );

}

// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function isValidDiagonal( a, b ) {

	return a.next.i !== b.i && a.prev.i !== b.i && ! intersectsPolygon( a, b ) && // dones't intersect other edges
           ( locallyInside( a, b ) && locallyInside( b, a ) && middleInside( a, b ) && // locally visible
            ( area( a.prev, a, b.prev ) || area( a, b.prev, b ) ) || // does not create opposite-facing sectors
            equals( a, b ) && area( a.prev, a, a.next ) > 0 && area( b.prev, b, b.next ) > 0 ); // special zero-length case

}

// signed area of a triangle
function area( p, q, r ) {

	return ( q.y - p.y ) * ( r.x - q.x ) - ( q.x - p.x ) * ( r.y - q.y );

}

// check if two points are equal
function equals( p1, p2 ) {

	return p1.x === p2.x && p1.y === p2.y;

}

// check if two segments intersect
function intersects( p1, q1, p2, q2 ) {

	const o1 = sign( area( p1, q1, p2 ) );
	const o2 = sign( area( p1, q1, q2 ) );
	const o3 = sign( area( p2, q2, p1 ) );
	const o4 = sign( area( p2, q2, q1 ) );

	if ( o1 !== o2 && o3 !== o4 ) return true; // general case

	if ( o1 === 0 && onSegment( p1, p2, q1 ) ) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
	if ( o2 === 0 && onSegment( p1, q2, q1 ) ) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
	if ( o3 === 0 && onSegment( p2, p1, q2 ) ) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
	if ( o4 === 0 && onSegment( p2, q1, q2 ) ) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2

	return false;

}

// for collinear points p, q, r, check if point q lies on segment pr
function onSegment( p, q, r ) {

	return q.x <= Math.max( p.x, r.x ) && q.x >= Math.min( p.x, r.x ) && q.y <= Math.max( p.y, r.y ) && q.y >= Math.min( p.y, r.y );

}

function sign( num ) {

	return num > 0 ? 1 : num < 0 ? - 1 : 0;

}

// check if a polygon diagonal intersects any polygon segments
function intersectsPolygon( a, b ) {

	let p = a;
	do {

		if ( p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i &&
			intersects( p, p.next, a, b ) ) return true;
		p = p.next;

	} while ( p !== a );

	return false;

}

// check if a polygon diagonal is locally inside the polygon
function locallyInside( a, b ) {

	return area( a.prev, a, a.next ) < 0 ?
		area( a, b, a.next ) >= 0 && area( a, a.prev, b ) >= 0 :
		area( a, b, a.prev ) < 0 || area( a, a.next, b ) < 0;

}

// check if the middle point of a polygon diagonal is inside the polygon
function middleInside( a, b ) {

	let p = a,
		inside = false;
	const px = ( a.x + b.x ) / 2,
		py = ( a.y + b.y ) / 2;
	do {

		if ( ( ( p.y > py ) !== ( p.next.y > py ) ) && p.next.y !== p.y &&
			( px < ( p.next.x - p.x ) * ( py - p.y ) / ( p.next.y - p.y ) + p.x ) )
			inside = ! inside;
		p = p.next;

	} while ( p !== a );

	return inside;

}

// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function splitPolygon( a, b ) {

	const a2 = new Node( a.i, a.x, a.y ),
		b2 = new Node( b.i, b.x, b.y ),
		an = a.next,
		bp = b.prev;

	a.next = b;
	b.prev = a;

	a2.next = an;
	an.prev = a2;

	b2.next = a2;
	a2.prev = b2;

	bp.next = b2;
	b2.prev = bp;

	return b2;

}

// create a node and optionally link it with previous one (in a circular doubly linked list)
function insertNode( i, x, y, last ) {

	const p = new Node( i, x, y );

	if ( ! last ) {

		p.prev = p;
		p.next = p;

	} else {

		p.next = last.next;
		p.prev = last;
		last.next.prev = p;
		last.next = p;

	}

	return p;

}

function removeNode( p ) {

	p.next.prev = p.prev;
	p.prev.next = p.next;

	if ( p.prevZ ) p.prevZ.nextZ = p.nextZ;
	if ( p.nextZ ) p.nextZ.prevZ = p.prevZ;

}

function Node( i, x, y ) {

	// vertex index in coordinates array
	this.i = i;

	// vertex coordinates
	this.x = x;
	this.y = y;

	// previous and next vertex nodes in a polygon ring
	this.prev = null;
	this.next = null;

	// z-order curve value
	this.z = 0;

	// previous and next nodes in z-order
	this.prevZ = null;
	this.nextZ = null;

	// indicates whether this is a steiner point
	this.steiner = false;

}

function signedArea( data, start, end, dim ) {

	let sum = 0;
	for ( let i = start, j = end - dim; i < end; i += dim ) {

		sum += ( data[ j ] - data[ i ] ) * ( data[ i + 1 ] + data[ j + 1 ] );
		j = i;

	}

	return sum;

}

class ShapeUtils {

	// calculate area of the contour polygon

	static area( contour ) {

		const n = contour.length;
		let a = 0.0;

		for ( let p = n - 1, q = 0; q < n; p = q ++ ) {

			a += contour[ p ].x * contour[ q ].y - contour[ q ].x * contour[ p ].y;

		}

		return a * 0.5;

	}

	static isClockWise( pts ) {

		return ShapeUtils.area( pts ) < 0;

	}

	static triangulateShape( contour, holes ) {

		const vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
		const holeIndices = []; // array of hole indices
		const faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]

		removeDupEndPts( contour );
		addContour( vertices, contour );

		//

		let holeIndex = contour.length;

		holes.forEach( removeDupEndPts );

		for ( let i = 0; i < holes.length; i ++ ) {

			holeIndices.push( holeIndex );
			holeIndex += holes[ i ].length;
			addContour( vertices, holes[ i ] );

		}

		//

		const triangles = Earcut.triangulate( vertices, holeIndices );

		//

		for ( let i = 0; i < triangles.length; i += 3 ) {

			faces.push( triangles.slice( i, i + 3 ) );

		}

		return faces;

	}

}

function removeDupEndPts( points ) {

	const l = points.length;

	if ( l > 2 && points[ l - 1 ].equals( points[ 0 ] ) ) {

		points.pop();

	}

}

function addContour( vertices, contour ) {

	for ( let i = 0; i < contour.length; i ++ ) {

		vertices.push( contour[ i ].x );
		vertices.push( contour[ i ].y );

	}

}

/**
 * Creates extruded geometry from a path shape.
 *
 * parameters = {
 *
 *  curveSegments: <int>, // number of points on the curves
 *  steps: <int>, // number of points for z-side extrusions / used for subdividing segments of extrude spline too
 *  depth: <float>, // Depth to extrude the shape
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into the original shape bevel goes
 *  bevelSize: <float>, // how far from shape outline (including bevelOffset) is bevel
 *  bevelOffset: <float>, // how far from shape outline does bevel start
 *  bevelSegments: <int>, // number of bevel layers
 *
 *  extrudePath: <THREE.Curve> // curve to extrude shape along
 *
 *  UVGenerator: <Object> // object that provides UV generator functions
 *
 * }
 */


class ExtrudeGeometry extends BufferGeometry {

	constructor( shapes = new Shape( [ new Vector2( 0.5, 0.5 ), new Vector2( - 0.5, 0.5 ), new Vector2( - 0.5, - 0.5 ), new Vector2( 0.5, - 0.5 ) ] ), options = {} ) {

		super();

		this.type = 'ExtrudeGeometry';

		this.parameters = {
			shapes: shapes,
			options: options
		};

		shapes = Array.isArray( shapes ) ? shapes : [ shapes ];

		const scope = this;

		const verticesArray = [];
		const uvArray = [];

		for ( let i = 0, l = shapes.length; i < l; i ++ ) {

			const shape = shapes[ i ];
			addShape( shape );

		}

		// build geometry

		this.setAttribute( 'position', new Float32BufferAttribute( verticesArray, 3 ) );
		this.setAttribute( 'uv', new Float32BufferAttribute( uvArray, 2 ) );

		this.computeVertexNormals();

		// functions

		function addShape( shape ) {

			const placeholder = [];

			// options

			const curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
			const steps = options.steps !== undefined ? options.steps : 1;
			const depth = options.depth !== undefined ? options.depth : 1;

			let bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true;
			let bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 0.2;
			let bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 0.1;
			let bevelOffset = options.bevelOffset !== undefined ? options.bevelOffset : 0;
			let bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;

			const extrudePath = options.extrudePath;

			const uvgen = options.UVGenerator !== undefined ? options.UVGenerator : WorldUVGenerator;

			//

			let extrudePts, extrudeByPath = false;
			let splineTube, binormal, normal, position2;

			if ( extrudePath ) {

				extrudePts = extrudePath.getSpacedPoints( steps );

				extrudeByPath = true;
				bevelEnabled = false; // bevels not supported for path extrusion

				// SETUP TNB variables

				// TODO1 - have a .isClosed in spline?

				splineTube = extrudePath.computeFrenetFrames( steps, false );

				// console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);

				binormal = new Vector3();
				normal = new Vector3();
				position2 = new Vector3();

			}

			// Safeguards if bevels are not enabled

			if ( ! bevelEnabled ) {

				bevelSegments = 0;
				bevelThickness = 0;
				bevelSize = 0;
				bevelOffset = 0;

			}

			// Variables initialization

			const shapePoints = shape.extractPoints( curveSegments );

			let vertices = shapePoints.shape;
			const holes = shapePoints.holes;

			const reverse = ! ShapeUtils.isClockWise( vertices );

			if ( reverse ) {

				vertices = vertices.reverse();

				// Maybe we should also check if holes are in the opposite direction, just to be safe ...

				for ( let h = 0, hl = holes.length; h < hl; h ++ ) {

					const ahole = holes[ h ];

					if ( ShapeUtils.isClockWise( ahole ) ) {

						holes[ h ] = ahole.reverse();

					}

				}

			}


			const faces = ShapeUtils.triangulateShape( vertices, holes );

			/* Vertices */

			const contour = vertices; // vertices has all points but contour has only points of circumference

			for ( let h = 0, hl = holes.length; h < hl; h ++ ) {

				const ahole = holes[ h ];

				vertices = vertices.concat( ahole );

			}


			function scalePt2( pt, vec, size ) {

				if ( ! vec ) console.error( 'THREE.ExtrudeGeometry: vec does not exist' );

				return pt.clone().addScaledVector( vec, size );

			}

			const vlen = vertices.length, flen = faces.length;


			// Find directions for point movement


			function getBevelVec( inPt, inPrev, inNext ) {

				// computes for inPt the corresponding point inPt' on a new contour
				//   shifted by 1 unit (length of normalized vector) to the left
				// if we walk along contour clockwise, this new contour is outside the old one
				//
				// inPt' is the intersection of the two lines parallel to the two
				//  adjacent edges of inPt at a distance of 1 unit on the left side.

				let v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt

				// good reading for geometry algorithms (here: line-line intersection)
				// http://geomalgorithms.com/a05-_intersect-1.html

				const v_prev_x = inPt.x - inPrev.x,
					v_prev_y = inPt.y - inPrev.y;
				const v_next_x = inNext.x - inPt.x,
					v_next_y = inNext.y - inPt.y;

				const v_prev_lensq = ( v_prev_x * v_prev_x + v_prev_y * v_prev_y );

				// check for collinear edges
				const collinear0 = ( v_prev_x * v_next_y - v_prev_y * v_next_x );

				if ( Math.abs( collinear0 ) > Number.EPSILON ) {

					// not collinear

					// length of vectors for normalizing

					const v_prev_len = Math.sqrt( v_prev_lensq );
					const v_next_len = Math.sqrt( v_next_x * v_next_x + v_next_y * v_next_y );

					// shift adjacent points by unit vectors to the left

					const ptPrevShift_x = ( inPrev.x - v_prev_y / v_prev_len );
					const ptPrevShift_y = ( inPrev.y + v_prev_x / v_prev_len );

					const ptNextShift_x = ( inNext.x - v_next_y / v_next_len );
					const ptNextShift_y = ( inNext.y + v_next_x / v_next_len );

					// scaling factor for v_prev to intersection point

					const sf = ( ( ptNextShift_x - ptPrevShift_x ) * v_next_y -
							( ptNextShift_y - ptPrevShift_y ) * v_next_x ) /
						( v_prev_x * v_next_y - v_prev_y * v_next_x );

					// vector from inPt to intersection point

					v_trans_x = ( ptPrevShift_x + v_prev_x * sf - inPt.x );
					v_trans_y = ( ptPrevShift_y + v_prev_y * sf - inPt.y );

					// Don't normalize!, otherwise sharp corners become ugly
					//  but prevent crazy spikes
					const v_trans_lensq = ( v_trans_x * v_trans_x + v_trans_y * v_trans_y );
					if ( v_trans_lensq <= 2 ) {

						return new Vector2( v_trans_x, v_trans_y );

					} else {

						shrink_by = Math.sqrt( v_trans_lensq / 2 );

					}

				} else {

					// handle special case of collinear edges

					let direction_eq = false; // assumes: opposite

					if ( v_prev_x > Number.EPSILON ) {

						if ( v_next_x > Number.EPSILON ) {

							direction_eq = true;

						}

					} else {

						if ( v_prev_x < - Number.EPSILON ) {

							if ( v_next_x < - Number.EPSILON ) {

								direction_eq = true;

							}

						} else {

							if ( Math.sign( v_prev_y ) === Math.sign( v_next_y ) ) {

								direction_eq = true;

							}

						}

					}

					if ( direction_eq ) {

						// console.log("Warning: lines are a straight sequence");
						v_trans_x = - v_prev_y;
						v_trans_y = v_prev_x;
						shrink_by = Math.sqrt( v_prev_lensq );

					} else {

						// console.log("Warning: lines are a straight spike");
						v_trans_x = v_prev_x;
						v_trans_y = v_prev_y;
						shrink_by = Math.sqrt( v_prev_lensq / 2 );

					}

				}

				return new Vector2( v_trans_x / shrink_by, v_trans_y / shrink_by );

			}


			const contourMovements = [];

			for ( let i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i ++, j ++, k ++ ) {

				if ( j === il ) j = 0;
				if ( k === il ) k = 0;

				//  (j)---(i)---(k)
				// console.log('i,j,k', i, j , k)

				contourMovements[ i ] = getBevelVec( contour[ i ], contour[ j ], contour[ k ] );

			}

			const holesMovements = [];
			let oneHoleMovements, verticesMovements = contourMovements.concat();

			for ( let h = 0, hl = holes.length; h < hl; h ++ ) {

				const ahole = holes[ h ];

				oneHoleMovements = [];

				for ( let i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i ++, j ++, k ++ ) {

					if ( j === il ) j = 0;
					if ( k === il ) k = 0;

					//  (j)---(i)---(k)
					oneHoleMovements[ i ] = getBevelVec( ahole[ i ], ahole[ j ], ahole[ k ] );

				}

				holesMovements.push( oneHoleMovements );
				verticesMovements = verticesMovements.concat( oneHoleMovements );

			}


			// Loop bevelSegments, 1 for the front, 1 for the back

			for ( let b = 0; b < bevelSegments; b ++ ) {

				//for ( b = bevelSegments; b > 0; b -- ) {

				const t = b / bevelSegments;
				const z = bevelThickness * Math.cos( t * Math.PI / 2 );
				const bs = bevelSize * Math.sin( t * Math.PI / 2 ) + bevelOffset;

				// contract shape

				for ( let i = 0, il = contour.length; i < il; i ++ ) {

					const vert = scalePt2( contour[ i ], contourMovements[ i ], bs );

					v( vert.x, vert.y, - z );

				}

				// expand holes

				for ( let h = 0, hl = holes.length; h < hl; h ++ ) {

					const ahole = holes[ h ];
					oneHoleMovements = holesMovements[ h ];

					for ( let i = 0, il = ahole.length; i < il; i ++ ) {

						const vert = scalePt2( ahole[ i ], oneHoleMovements[ i ], bs );

						v( vert.x, vert.y, - z );

					}

				}

			}

			const bs = bevelSize + bevelOffset;

			// Back facing vertices

			for ( let i = 0; i < vlen; i ++ ) {

				const vert = bevelEnabled ? scalePt2( vertices[ i ], verticesMovements[ i ], bs ) : vertices[ i ];

				if ( ! extrudeByPath ) {

					v( vert.x, vert.y, 0 );

				} else {

					// v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );

					normal.copy( splineTube.normals[ 0 ] ).multiplyScalar( vert.x );
					binormal.copy( splineTube.binormals[ 0 ] ).multiplyScalar( vert.y );

					position2.copy( extrudePts[ 0 ] ).add( normal ).add( binormal );

					v( position2.x, position2.y, position2.z );

				}

			}

			// Add stepped vertices...
			// Including front facing vertices

			for ( let s = 1; s <= steps; s ++ ) {

				for ( let i = 0; i < vlen; i ++ ) {

					const vert = bevelEnabled ? scalePt2( vertices[ i ], verticesMovements[ i ], bs ) : vertices[ i ];

					if ( ! extrudeByPath ) {

						v( vert.x, vert.y, depth / steps * s );

					} else {

						// v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );

						normal.copy( splineTube.normals[ s ] ).multiplyScalar( vert.x );
						binormal.copy( splineTube.binormals[ s ] ).multiplyScalar( vert.y );

						position2.copy( extrudePts[ s ] ).add( normal ).add( binormal );

						v( position2.x, position2.y, position2.z );

					}

				}

			}


			// Add bevel segments planes

			//for ( b = 1; b <= bevelSegments; b ++ ) {
			for ( let b = bevelSegments - 1; b >= 0; b -- ) {

				const t = b / bevelSegments;
				const z = bevelThickness * Math.cos( t * Math.PI / 2 );
				const bs = bevelSize * Math.sin( t * Math.PI / 2 ) + bevelOffset;

				// contract shape

				for ( let i = 0, il = contour.length; i < il; i ++ ) {

					const vert = scalePt2( contour[ i ], contourMovements[ i ], bs );
					v( vert.x, vert.y, depth + z );

				}

				// expand holes

				for ( let h = 0, hl = holes.length; h < hl; h ++ ) {

					const ahole = holes[ h ];
					oneHoleMovements = holesMovements[ h ];

					for ( let i = 0, il = ahole.length; i < il; i ++ ) {

						const vert = scalePt2( ahole[ i ], oneHoleMovements[ i ], bs );

						if ( ! extrudeByPath ) {

							v( vert.x, vert.y, depth + z );

						} else {

							v( vert.x, vert.y + extrudePts[ steps - 1 ].y, extrudePts[ steps - 1 ].x + z );

						}

					}

				}

			}

			/* Faces */

			// Top and bottom faces

			buildLidFaces();

			// Sides faces

			buildSideFaces();


			/////  Internal functions

			function buildLidFaces() {

				const start = verticesArray.length / 3;

				if ( bevelEnabled ) {

					let layer = 0; // steps + 1
					let offset = vlen * layer;

					// Bottom faces

					for ( let i = 0; i < flen; i ++ ) {

						const face = faces[ i ];
						f3( face[ 2 ] + offset, face[ 1 ] + offset, face[ 0 ] + offset );

					}

					layer = steps + bevelSegments * 2;
					offset = vlen * layer;

					// Top faces

					for ( let i = 0; i < flen; i ++ ) {

						const face = faces[ i ];
						f3( face[ 0 ] + offset, face[ 1 ] + offset, face[ 2 ] + offset );

					}

				} else {

					// Bottom faces

					for ( let i = 0; i < flen; i ++ ) {

						const face = faces[ i ];
						f3( face[ 2 ], face[ 1 ], face[ 0 ] );

					}

					// Top faces

					for ( let i = 0; i < flen; i ++ ) {

						const face = faces[ i ];
						f3( face[ 0 ] + vlen * steps, face[ 1 ] + vlen * steps, face[ 2 ] + vlen * steps );

					}

				}

				scope.addGroup( start, verticesArray.length / 3 - start, 0 );

			}

			// Create faces for the z-sides of the shape

			function buildSideFaces() {

				const start = verticesArray.length / 3;
				let layeroffset = 0;
				sidewalls( contour, layeroffset );
				layeroffset += contour.length;

				for ( let h = 0, hl = holes.length; h < hl; h ++ ) {

					const ahole = holes[ h ];
					sidewalls( ahole, layeroffset );

					//, true
					layeroffset += ahole.length;

				}


				scope.addGroup( start, verticesArray.length / 3 - start, 1 );


			}

			function sidewalls( contour, layeroffset ) {

				let i = contour.length;

				while ( -- i >= 0 ) {

					const j = i;
					let k = i - 1;
					if ( k < 0 ) k = contour.length - 1;

					//console.log('b', i,j, i-1, k,vertices.length);

					for ( let s = 0, sl = ( steps + bevelSegments * 2 ); s < sl; s ++ ) {

						const slen1 = vlen * s;
						const slen2 = vlen * ( s + 1 );

						const a = layeroffset + j + slen1,
							b = layeroffset + k + slen1,
							c = layeroffset + k + slen2,
							d = layeroffset + j + slen2;

						f4( a, b, c, d );

					}

				}

			}

			function v( x, y, z ) {

				placeholder.push( x );
				placeholder.push( y );
				placeholder.push( z );

			}


			function f3( a, b, c ) {

				addVertex( a );
				addVertex( b );
				addVertex( c );

				const nextIndex = verticesArray.length / 3;
				const uvs = uvgen.generateTopUV( scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1 );

				addUV( uvs[ 0 ] );
				addUV( uvs[ 1 ] );
				addUV( uvs[ 2 ] );

			}

			function f4( a, b, c, d ) {

				addVertex( a );
				addVertex( b );
				addVertex( d );

				addVertex( b );
				addVertex( c );
				addVertex( d );


				const nextIndex = verticesArray.length / 3;
				const uvs = uvgen.generateSideWallUV( scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1 );

				addUV( uvs[ 0 ] );
				addUV( uvs[ 1 ] );
				addUV( uvs[ 3 ] );

				addUV( uvs[ 1 ] );
				addUV( uvs[ 2 ] );
				addUV( uvs[ 3 ] );

			}

			function addVertex( index ) {

				verticesArray.push( placeholder[ index * 3 + 0 ] );
				verticesArray.push( placeholder[ index * 3 + 1 ] );
				verticesArray.push( placeholder[ index * 3 + 2 ] );

			}


			function addUV( vector2 ) {

				uvArray.push( vector2.x );
				uvArray.push( vector2.y );

			}

		}

	}

	copy( source ) {

		super.copy( source );

		this.parameters = Object.assign( {}, source.parameters );

		return this;

	}

	toJSON() {

		const data = super.toJSON();

		const shapes = this.parameters.shapes;
		const options = this.parameters.options;

		return toJSON$1( shapes, options, data );

	}

	static fromJSON( data, shapes ) {

		const geometryShapes = [];

		for ( let j = 0, jl = data.shapes.length; j < jl; j ++ ) {

			const shape = shapes[ data.shapes[ j ] ];

			geometryShapes.push( shape );

		}

		const extrudePath = data.options.extrudePath;

		if ( extrudePath !== undefined ) {

			data.options.extrudePath = new Curves[ extrudePath.type ]().fromJSON( extrudePath );

		}

		return new ExtrudeGeometry( geometryShapes, data.options );

	}

}

const WorldUVGenerator = {

	generateTopUV: function ( geometry, vertices, indexA, indexB, indexC ) {

		const a_x = vertices[ indexA * 3 ];
		const a_y = vertices[ indexA * 3 + 1 ];
		const b_x = vertices[ indexB * 3 ];
		const b_y = vertices[ indexB * 3 + 1 ];
		const c_x = vertices[ indexC * 3 ];
		const c_y = vertices[ indexC * 3 + 1 ];

		return [
			new Vector2( a_x, a_y ),
			new Vector2( b_x, b_y ),
			new Vector2( c_x, c_y )
		];

	},

	generateSideWallUV: function ( geometry, vertices, indexA, indexB, indexC, indexD ) {

		const a_x = vertices[ indexA * 3 ];
		const a_y = vertices[ indexA * 3 + 1 ];
		const a_z = vertices[ indexA * 3 + 2 ];
		const b_x = vertices[ indexB * 3 ];
		const b_y = vertices[ indexB * 3 + 1 ];
		const b_z = vertices[ indexB * 3 + 2 ];
		const c_x = vertices[ indexC * 3 ];
		const c_y = vertices[ indexC * 3 + 1 ];
		const c_z = vertices[ indexC * 3 + 2 ];
		const d_x = vertices[ indexD * 3 ];
		const d_y = vertices[ indexD * 3 + 1 ];
		const d_z = vertices[ indexD * 3 + 2 ];

		if ( Math.abs( a_y - b_y ) < Math.abs( a_x - b_x ) ) {

			return [
				new Vector2( a_x, 1 - a_z ),
				new Vector2( b_x, 1 - b_z ),
				new Vector2( c_x, 1 - c_z ),
				new Vector2( d_x, 1 - d_z )
			];

		} else {

			return [
				new Vector2( a_y, 1 - a_z ),
				new Vector2( b_y, 1 - b_z ),
				new Vector2( c_y, 1 - c_z ),
				new Vector2( d_y, 1 - d_z )
			];

		}

	}

};

function toJSON$1( shapes, options, data ) {

	data.shapes = [];

	if ( Array.isArray( shapes ) ) {

		for ( let i = 0, l = shapes.length; i < l; i ++ ) {

			const shape = shapes[ i ];

			data.shapes.push( shape.uuid );

		}

	} else {

		data.shapes.push( shapes.uuid );

	}

	data.options = Object.assign( {}, options );

	if ( options.extrudePath !== undefined ) data.options.extrudePath = options.extrudePath.toJSON();

	return data;

}

class IcosahedronGeometry extends PolyhedronGeometry {

	constructor( radius = 1, detail = 0 ) {

		const t = ( 1 + Math.sqrt( 5 ) ) / 2;

		const vertices = [
			- 1, t, 0, 	1, t, 0, 	- 1, - t, 0, 	1, - t, 0,
			0, - 1, t, 	0, 1, t,	0, - 1, - t, 	0, 1, - t,
			t, 0, - 1, 	t, 0, 1, 	- t, 0, - 1, 	- t, 0, 1
		];

		const indices = [
			0, 11, 5, 	0, 5, 1, 	0, 1, 7, 	0, 7, 10, 	0, 10, 11,
			1, 5, 9, 	5, 11, 4,	11, 10, 2,	10, 7, 6,	7, 1, 8,
			3, 9, 4, 	3, 4, 2,	3, 2, 6,	3, 6, 8,	3, 8, 9,
			4, 9, 5, 	2, 4, 11,	6, 2, 10,	8, 6, 7,	9, 8, 1
		];

		super( vertices, indices, radius, detail );

		this.type = 'IcosahedronGeometry';

		this.parameters = {
			radius: radius,
			detail: detail
		};

	}

	static fromJSON( data ) {

		return new IcosahedronGeometry( data.radius, data.detail );

	}

}

class OctahedronGeometry extends PolyhedronGeometry {

	constructor( radius = 1, detail = 0 ) {

		const vertices = [
			1, 0, 0, 	- 1, 0, 0,	0, 1, 0,
			0, - 1, 0, 	0, 0, 1,	0, 0, - 1
		];

		const indices = [
			0, 2, 4,	0, 4, 3,	0, 3, 5,
			0, 5, 2,	1, 2, 5,	1, 5, 3,
			1, 3, 4,	1, 4, 2
		];

		super( vertices, indices, radius, detail );

		this.type = 'OctahedronGeometry';

		this.parameters = {
			radius: radius,
			detail: detail
		};

	}

	static fromJSON( data ) {

		return new OctahedronGeometry( data.radius, data.detail );

	}

}

class RingGeometry extends BufferGeometry {

	constructor( innerRadius = 0.5, outerRadius = 1, thetaSegments = 32, phiSegments = 1, thetaStart = 0, thetaLength = Math.PI * 2 ) {

		super();

		this.type = 'RingGeometry';

		this.parameters = {
			innerRadius: innerRadius,
			outerRadius: outerRadius,
			thetaSegments: thetaSegments,
			phiSegments: phiSegments,
			thetaStart: thetaStart,
			thetaLength: thetaLength
		};

		thetaSegments = Math.max( 3, thetaSegments );
		phiSegments = Math.max( 1, phiSegments );

		// buffers

		const indices = [];
		const vertices = [];
		const normals = [];
		const uvs = [];

		// some helper variables

		let radius = innerRadius;
		const radiusStep = ( ( outerRadius - innerRadius ) / phiSegments );
		const vertex = new Vector3();
		const uv = new Vector2();

		// generate vertices, normals and uvs

		for ( let j = 0; j <= phiSegments; j ++ ) {

			for ( let i = 0; i <= thetaSegments; i ++ ) {

				// values are generate from the inside of the ring to the outside

				const segment = thetaStart + i / thetaSegments * thetaLength;

				// vertex

				vertex.x = radius * Math.cos( segment );
				vertex.y = radius * Math.sin( segment );

				vertices.push( vertex.x, vertex.y, vertex.z );

				// normal

				normals.push( 0, 0, 1 );

				// uv

				uv.x = ( vertex.x / outerRadius + 1 ) / 2;
				uv.y = ( vertex.y / outerRadius + 1 ) / 2;

				uvs.push( uv.x, uv.y );

			}

			// increase the radius for next row of vertices

			radius += radiusStep;

		}

		// indices

		for ( let j = 0; j < phiSegments; j ++ ) {

			const thetaSegmentLevel = j * ( thetaSegments + 1 );

			for ( let i = 0; i < thetaSegments; i ++ ) {

				const segment = i + thetaSegmentLevel;

				const a = segment;
				const b = segment + thetaSegments + 1;
				const c = segment + thetaSegments + 2;
				const d = segment + 1;

				// faces

				indices.push( a, b, d );
				indices.push( b, c, d );

			}

		}

		// build geometry

		this.setIndex( indices );
		this.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.setAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
		this.setAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

	}

	copy( source ) {

		super.copy( source );

		this.parameters = Object.assign( {}, source.parameters );

		return this;

	}

	static fromJSON( data ) {

		return new RingGeometry( data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength );

	}

}

class ShapeGeometry extends BufferGeometry {

	constructor( shapes = new Shape( [ new Vector2( 0, 0.5 ), new Vector2( - 0.5, - 0.5 ), new Vector2( 0.5, - 0.5 ) ] ), curveSegments = 12 ) {

		super();

		this.type = 'ShapeGeometry';

		this.parameters = {
			shapes: shapes,
			curveSegments: curveSegments
		};

		// buffers

		const indices = [];
		const vertices = [];
		const normals = [];
		const uvs = [];

		// helper variables

		let groupStart = 0;
		let groupCount = 0;

		// allow single and array values for "shapes" parameter

		if ( Array.isArray( shapes ) === false ) {

			addShape( shapes );

		} else {

			for ( let i = 0; i < shapes.length; i ++ ) {

				addShape( shapes[ i ] );

				this.addGroup( groupStart, groupCount, i ); // enables MultiMaterial support

				groupStart += groupCount;
				groupCount = 0;

			}

		}

		// build geometry

		this.setIndex( indices );
		this.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.setAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
		this.setAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );


		// helper functions

		function addShape( shape ) {

			const indexOffset = vertices.length / 3;
			const points = shape.extractPoints( curveSegments );

			let shapeVertices = points.shape;
			const shapeHoles = points.holes;

			// check direction of vertices

			if ( ShapeUtils.isClockWise( shapeVertices ) === false ) {

				shapeVertices = shapeVertices.reverse();

			}

			for ( let i = 0, l = shapeHoles.length; i < l; i ++ ) {

				const shapeHole = shapeHoles[ i ];

				if ( ShapeUtils.isClockWise( shapeHole ) === true ) {

					shapeHoles[ i ] = shapeHole.reverse();

				}

			}

			const faces = ShapeUtils.triangulateShape( shapeVertices, shapeHoles );

			// join vertices of inner and outer paths to a single array

			for ( let i = 0, l = shapeHoles.length; i < l; i ++ ) {

				const shapeHole = shapeHoles[ i ];
				shapeVertices = shapeVertices.concat( shapeHole );

			}

			// vertices, normals, uvs

			for ( let i = 0, l = shapeVertices.length; i < l; i ++ ) {

				const vertex = shapeVertices[ i ];

				vertices.push( vertex.x, vertex.y, 0 );
				normals.push( 0, 0, 1 );
				uvs.push( vertex.x, vertex.y ); // world uvs

			}

			// indices

			for ( let i = 0, l = faces.length; i < l; i ++ ) {

				const face = faces[ i ];

				const a = face[ 0 ] + indexOffset;
				const b = face[ 1 ] + indexOffset;
				const c = face[ 2 ] + indexOffset;

				indices.push( a, b, c );
				groupCount += 3;

			}

		}

	}

	copy( source ) {

		super.copy( source );

		this.parameters = Object.assign( {}, source.parameters );

		return this;

	}

	toJSON() {

		const data = super.toJSON();

		const shapes = this.parameters.shapes;

		return toJSON( shapes, data );

	}

	static fromJSON( data, shapes ) {

		const geometryShapes = [];

		for ( let j = 0, jl = data.shapes.length; j < jl; j ++ ) {

			const shape = shapes[ data.shapes[ j ] ];

			geometryShapes.push( shape );

		}

		return new ShapeGeometry( geometryShapes, data.curveSegments );

	}

}

function toJSON( shapes, data ) {

	data.shapes = [];

	if ( Array.isArray( shapes ) ) {

		for ( let i = 0, l = shapes.length; i < l; i ++ ) {

			const shape = shapes[ i ];

			data.shapes.push( shape.uuid );

		}

	} else {

		data.shapes.push( shapes.uuid );

	}

	return data;

}

class SphereGeometry extends BufferGeometry {

	constructor( radius = 1, widthSegments = 32, heightSegments = 16, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI ) {

		super();

		this.type = 'SphereGeometry';

		this.parameters = {
			radius: radius,
			widthSegments: widthSegments,
			heightSegments: heightSegments,
			phiStart: phiStart,
			phiLength: phiLength,
			thetaStart: thetaStart,
			thetaLength: thetaLength
		};

		widthSegments = Math.max( 3, Math.floor( widthSegments ) );
		heightSegments = Math.max( 2, Math.floor( heightSegments ) );

		const thetaEnd = Math.min( thetaStart + thetaLength, Math.PI );

		let index = 0;
		const grid = [];

		const vertex = new Vector3();
		const normal = new Vector3();

		// buffers

		const indices = [];
		const vertices = [];
		const normals = [];
		const uvs = [];

		// generate vertices, normals and uvs

		for ( let iy = 0; iy <= heightSegments; iy ++ ) {

			const verticesRow = [];

			const v = iy / heightSegments;

			// special case for the poles

			let uOffset = 0;

			if ( iy === 0 && thetaStart === 0 ) {

				uOffset = 0.5 / widthSegments;

			} else if ( iy === heightSegments && thetaEnd === Math.PI ) {

				uOffset = - 0.5 / widthSegments;

			}

			for ( let ix = 0; ix <= widthSegments; ix ++ ) {

				const u = ix / widthSegments;

				// vertex

				vertex.x = - radius * Math.cos( phiStart + u * phiLength ) * Math.sin( thetaStart + v * thetaLength );
				vertex.y = radius * Math.cos( thetaStart + v * thetaLength );
				vertex.z = radius * Math.sin( phiStart + u * phiLength ) * Math.sin( thetaStart + v * thetaLength );

				vertices.push( vertex.x, vertex.y, vertex.z );

				// normal

				normal.copy( vertex ).normalize();
				normals.push( normal.x, normal.y, normal.z );

				// uv

				uvs.push( u + uOffset, 1 - v );

				verticesRow.push( index ++ );

			}

			grid.push( verticesRow );

		}

		// indices

		for ( let iy = 0; iy < heightSegments; iy ++ ) {

			for ( let ix = 0; ix < widthSegments; ix ++ ) {

				const a = grid[ iy ][ ix + 1 ];
				const b = grid[ iy ][ ix ];
				const c = grid[ iy + 1 ][ ix ];
				const d = grid[ iy + 1 ][ ix + 1 ];

				if ( iy !== 0 || thetaStart > 0 ) indices.push( a, b, d );
				if ( iy !== heightSegments - 1 || thetaEnd < Math.PI ) indices.push( b, c, d );

			}

		}

		// build geometry

		this.setIndex( indices );
		this.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.setAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
		this.setAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

	}

	copy( source ) {

		super.copy( source );

		this.parameters = Object.assign( {}, source.parameters );

		return this;

	}

	static fromJSON( data ) {

		return new SphereGeometry( data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength );

	}

}

class TetrahedronGeometry extends PolyhedronGeometry {

	constructor( radius = 1, detail = 0 ) {

		const vertices = [
			1, 1, 1, 	- 1, - 1, 1, 	- 1, 1, - 1, 	1, - 1, - 1
		];

		const indices = [
			2, 1, 0, 	0, 3, 2,	1, 3, 0,	2, 3, 1
		];

		super( vertices, indices, radius, detail );

		this.type = 'TetrahedronGeometry';

		this.parameters = {
			radius: radius,
			detail: detail
		};

	}

	static fromJSON( data ) {

		return new TetrahedronGeometry( data.radius, data.detail );

	}

}

class TorusGeometry extends BufferGeometry {

	constructor( radius = 1, tube = 0.4, radialSegments = 12, tubularSegments = 48, arc = Math.PI * 2 ) {

		super();

		this.type = 'TorusGeometry';

		this.parameters = {
			radius: radius,
			tube: tube,
			radialSegments: radialSegments,
			tubularSegments: tubularSegments,
			arc: arc
		};

		radialSegments = Math.floor( radialSegments );
		tubularSegments = Math.floor( tubularSegments );

		// buffers

		const indices = [];
		const vertices = [];
		const normals = [];
		const uvs = [];

		// helper variables

		const center = new Vector3();
		const vertex = new Vector3();
		const normal = new Vector3();

		// generate vertices, normals and uvs

		for ( let j = 0; j <= radialSegments; j ++ ) {

			for ( let i = 0; i <= tubularSegments; i ++ ) {

				const u = i / tubularSegments * arc;
				const v = j / radialSegments * Math.PI * 2;

				// vertex

				vertex.x = ( radius + tube * Math.cos( v ) ) * Math.cos( u );
				vertex.y = ( radius + tube * Math.cos( v ) ) * Math.sin( u );
				vertex.z = tube * Math.sin( v );

				vertices.push( vertex.x, vertex.y, vertex.z );

				// normal

				center.x = radius * Math.cos( u );
				center.y = radius * Math.sin( u );
				normal.subVectors( vertex, center ).normalize();

				normals.push( normal.x, normal.y, normal.z );

				// uv

				uvs.push( i / tubularSegments );
				uvs.push( j / radialSegments );

			}

		}

		// generate indices

		for ( let j = 1; j <= radialSegments; j ++ ) {

			for ( let i = 1; i <= tubularSegments; i ++ ) {

				// indices

				const a = ( tubularSegments + 1 ) * j + i - 1;
				const b = ( tubularSegments + 1 ) * ( j - 1 ) + i - 1;
				const c = ( tubularSegments + 1 ) * ( j - 1 ) + i;
				const d = ( tubularSegments + 1 ) * j + i;

				// faces

				indices.push( a, b, d );
				indices.push( b, c, d );

			}

		}

		// build geometry

		this.setIndex( indices );
		this.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.setAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
		this.setAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

	}

	copy( source ) {

		super.copy( source );

		this.parameters = Object.assign( {}, source.parameters );

		return this;

	}

	static fromJSON( data ) {

		return new TorusGeometry( data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc );

	}

}

class TorusKnotGeometry extends BufferGeometry {

	constructor( radius = 1, tube = 0.4, tubularSegments = 64, radialSegments = 8, p = 2, q = 3 ) {

		super();

		this.type = 'TorusKnotGeometry';

		this.parameters = {
			radius: radius,
			tube: tube,
			tubularSegments: tubularSegments,
			radialSegments: radialSegments,
			p: p,
			q: q
		};

		tubularSegments = Math.floor( tubularSegments );
		radialSegments = Math.floor( radialSegments );

		// buffers

		const indices = [];
		const vertices = [];
		const normals = [];
		const uvs = [];

		// helper variables

		const vertex = new Vector3();
		const normal = new Vector3();

		const P1 = new Vector3();
		const P2 = new Vector3();

		const B = new Vector3();
		const T = new Vector3();
		const N = new Vector3();

		// generate vertices, normals and uvs

		for ( let i = 0; i <= tubularSegments; ++ i ) {

			// the radian "u" is used to calculate the position on the torus curve of the current tubular segment

			const u = i / tubularSegments * p * Math.PI * 2;

			// now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
			// these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions

			calculatePositionOnCurve( u, p, q, radius, P1 );
			calculatePositionOnCurve( u + 0.01, p, q, radius, P2 );

			// calculate orthonormal basis

			T.subVectors( P2, P1 );
			N.addVectors( P2, P1 );
			B.crossVectors( T, N );
			N.crossVectors( B, T );

			// normalize B, N. T can be ignored, we don't use it

			B.normalize();
			N.normalize();

			for ( let j = 0; j <= radialSegments; ++ j ) {

				// now calculate the vertices. they are nothing more than an extrusion of the torus curve.
				// because we extrude a shape in the xy-plane, there is no need to calculate a z-value.

				const v = j / radialSegments * Math.PI * 2;
				const cx = - tube * Math.cos( v );
				const cy = tube * Math.sin( v );

				// now calculate the final vertex position.
				// first we orient the extrusion with our basis vectors, then we add it to the current position on the curve

				vertex.x = P1.x + ( cx * N.x + cy * B.x );
				vertex.y = P1.y + ( cx * N.y + cy * B.y );
				vertex.z = P1.z + ( cx * N.z + cy * B.z );

				vertices.push( vertex.x, vertex.y, vertex.z );

				// normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)

				normal.subVectors( vertex, P1 ).normalize();

				normals.push( normal.x, normal.y, normal.z );

				// uv

				uvs.push( i / tubularSegments );
				uvs.push( j / radialSegments );

			}

		}

		// generate indices

		for ( let j = 1; j <= tubularSegments; j ++ ) {

			for ( let i = 1; i <= radialSegments; i ++ ) {

				// indices

				const a = ( radialSegments + 1 ) * ( j - 1 ) + ( i - 1 );
				const b = ( radialSegments + 1 ) * j + ( i - 1 );
				const c = ( radialSegments + 1 ) * j + i;
				const d = ( radialSegments + 1 ) * ( j - 1 ) + i;

				// faces

				indices.push( a, b, d );
				indices.push( b, c, d );

			}

		}

		// build geometry

		this.setIndex( indices );
		this.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.setAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
		this.setAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

		// this function calculates the current position on the torus curve

		function calculatePositionOnCurve( u, p, q, radius, position ) {

			const cu = Math.cos( u );
			const su = Math.sin( u );
			const quOverP = q / p * u;
			const cs = Math.cos( quOverP );

			position.x = radius * ( 2 + cs ) * 0.5 * cu;
			position.y = radius * ( 2 + cs ) * su * 0.5;
			position.z = radius * Math.sin( quOverP ) * 0.5;

		}

	}

	copy( source ) {

		super.copy( source );

		this.parameters = Object.assign( {}, source.parameters );

		return this;

	}

	static fromJSON( data ) {

		return new TorusKnotGeometry( data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q );

	}

}

class TubeGeometry extends BufferGeometry {

	constructor( path = new QuadraticBezierCurve3( new Vector3( - 1, - 1, 0 ), new Vector3( - 1, 1, 0 ), new Vector3( 1, 1, 0 ) ), tubularSegments = 64, radius = 1, radialSegments = 8, closed = false ) {

		super();

		this.type = 'TubeGeometry';

		this.parameters = {
			path: path,
			tubularSegments: tubularSegments,
			radius: radius,
			radialSegments: radialSegments,
			closed: closed
		};

		const frames = path.computeFrenetFrames( tubularSegments, closed );

		// expose internals

		this.tangents = frames.tangents;
		this.normals = frames.normals;
		this.binormals = frames.binormals;

		// helper variables

		const vertex = new Vector3();
		const normal = new Vector3();
		const uv = new Vector2();
		let P = new Vector3();

		// buffer

		const vertices = [];
		const normals = [];
		const uvs = [];
		const indices = [];

		// create buffer data

		generateBufferData();

		// build geometry

		this.setIndex( indices );
		this.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.setAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
		this.setAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

		// functions

		function generateBufferData() {

			for ( let i = 0; i < tubularSegments; i ++ ) {

				generateSegment( i );

			}

			// if the geometry is not closed, generate the last row of vertices and normals
			// at the regular position on the given path
			//
			// if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)

			generateSegment( ( closed === false ) ? tubularSegments : 0 );

			// uvs are generated in a separate function.
			// this makes it easy compute correct values for closed geometries

			generateUVs();

			// finally create faces

			generateIndices();

		}

		function generateSegment( i ) {

			// we use getPointAt to sample evenly distributed points from the given path

			P = path.getPointAt( i / tubularSegments, P );

			// retrieve corresponding normal and binormal

			const N = frames.normals[ i ];
			const B = frames.binormals[ i ];

			// generate normals and vertices for the current segment

			for ( let j = 0; j <= radialSegments; j ++ ) {

				const v = j / radialSegments * Math.PI * 2;

				const sin = Math.sin( v );
				const cos = - Math.cos( v );

				// normal

				normal.x = ( cos * N.x + sin * B.x );
				normal.y = ( cos * N.y + sin * B.y );
				normal.z = ( cos * N.z + sin * B.z );
				normal.normalize();

				normals.push( normal.x, normal.y, normal.z );

				// vertex

				vertex.x = P.x + radius * normal.x;
				vertex.y = P.y + radius * normal.y;
				vertex.z = P.z + radius * normal.z;

				vertices.push( vertex.x, vertex.y, vertex.z );

			}

		}

		function generateIndices() {

			for ( let j = 1; j <= tubularSegments; j ++ ) {

				for ( let i = 1; i <= radialSegments; i ++ ) {

					const a = ( radialSegments + 1 ) * ( j - 1 ) + ( i - 1 );
					const b = ( radialSegments + 1 ) * j + ( i - 1 );
					const c = ( radialSegments + 1 ) * j + i;
					const d = ( radialSegments + 1 ) * ( j - 1 ) + i;

					// faces

					indices.push( a, b, d );
					indices.push( b, c, d );

				}

			}

		}

		function generateUVs() {

			for ( let i = 0; i <= tubularSegments; i ++ ) {

				for ( let j = 0; j <= radialSegments; j ++ ) {

					uv.x = i / tubularSegments;
					uv.y = j / radialSegments;

					uvs.push( uv.x, uv.y );

				}

			}

		}

	}

	copy( source ) {

		super.copy( source );

		this.parameters = Object.assign( {}, source.parameters );

		return this;

	}

	toJSON() {

		const data = super.toJSON();

		data.path = this.parameters.path.toJSON();

		return data;

	}

	static fromJSON( data ) {

		// This only works for built-in curves (e.g. CatmullRomCurve3).
		// User defined curves or instances of CurvePath will not be deserialized.
		return new TubeGeometry(
			new Curves[ data.path.type ]().fromJSON( data.path ),
			data.tubularSegments,
			data.radius,
			data.radialSegments,
			data.closed
		);

	}

}

class WireframeGeometry extends BufferGeometry {

	constructor( geometry = null ) {

		super();

		this.type = 'WireframeGeometry';

		this.parameters = {
			geometry: geometry
		};

		if ( geometry !== null ) {

			// buffer

			const vertices = [];
			const edges = new Set();

			// helper variables

			const start = new Vector3();
			const end = new Vector3();

			if ( geometry.index !== null ) {

				// indexed BufferGeometry

				const position = geometry.attributes.position;
				const indices = geometry.index;
				let groups = geometry.groups;

				if ( groups.length === 0 ) {

					groups = [ { start: 0, count: indices.count, materialIndex: 0 } ];

				}

				// create a data structure that contains all edges without duplicates

				for ( let o = 0, ol = groups.length; o < ol; ++ o ) {

					const group = groups[ o ];

					const groupStart = group.start;
					const groupCount = group.count;

					for ( let i = groupStart, l = ( groupStart + groupCount ); i < l; i += 3 ) {

						for ( let j = 0; j < 3; j ++ ) {

							const index1 = indices.getX( i + j );
							const index2 = indices.getX( i + ( j + 1 ) % 3 );

							start.fromBufferAttribute( position, index1 );
							end.fromBufferAttribute( position, index2 );

							if ( isUniqueEdge( start, end, edges ) === true ) {

								vertices.push( start.x, start.y, start.z );
								vertices.push( end.x, end.y, end.z );

							}

						}

					}

				}

			} else {

				// non-indexed BufferGeometry

				const position = geometry.attributes.position;

				for ( let i = 0, l = ( position.count / 3 ); i < l; i ++ ) {

					for ( let j = 0; j < 3; j ++ ) {

						// three edges per triangle, an edge is represented as (index1, index2)
						// e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)

						const index1 = 3 * i + j;
						const index2 = 3 * i + ( ( j + 1 ) % 3 );

						start.fromBufferAttribute( position, index1 );
						end.fromBufferAttribute( position, index2 );

						if ( isUniqueEdge( start, end, edges ) === true ) {

							vertices.push( start.x, start.y, start.z );
							vertices.push( end.x, end.y, end.z );

						}

					}

				}

			}

			// build geometry

			this.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );

		}

	}

	copy( source ) {

		super.copy( source );

		this.parameters = Object.assign( {}, source.parameters );

		return this;

	}

}

function isUniqueEdge( start, end, edges ) {

	const hash1 = `${start.x},${start.y},${start.z}-${end.x},${end.y},${end.z}`;
	const hash2 = `${end.x},${end.y},${end.z}-${start.x},${start.y},${start.z}`; // coincident edge

	if ( edges.has( hash1 ) === true || edges.has( hash2 ) === true ) {

		return false;

	} else {

		edges.add( hash1 );
		edges.add( hash2 );
		return true;

	}

}

var Geometries = /*#__PURE__*/Object.freeze({
	__proto__: null,
	BoxGeometry: BoxGeometry,
	CapsuleGeometry: CapsuleGeometry,
	CircleGeometry: CircleGeometry,
	ConeGeometry: ConeGeometry,
	CylinderGeometry: CylinderGeometry,
	DodecahedronGeometry: DodecahedronGeometry,
	EdgesGeometry: EdgesGeometry,
	ExtrudeGeometry: ExtrudeGeometry,
	IcosahedronGeometry: IcosahedronGeometry,
	LatheGeometry: LatheGeometry,
	OctahedronGeometry: OctahedronGeometry,
	PlaneGeometry: PlaneGeometry,
	PolyhedronGeometry: PolyhedronGeometry,
	RingGeometry: RingGeometry,
	ShapeGeometry: ShapeGeometry,
	SphereGeometry: SphereGeometry,
	TetrahedronGeometry: TetrahedronGeometry,
	TorusGeometry: TorusGeometry,
	TorusKnotGeometry: TorusKnotGeometry,
	TubeGeometry: TubeGeometry,
	WireframeGeometry: WireframeGeometry
});

class ShadowMaterial extends Material {

	constructor( parameters ) {

		super();

		this.isShadowMaterial = true;

		this.type = 'ShadowMaterial';

		this.color = new Color( 0x000000 );
		this.transparent = true;

		this.fog = true;

		this.setValues( parameters );

	}

	copy( source ) {

		super.copy( source );

		this.color.copy( source.color );

		this.fog = source.fog;

		return this;

	}

}

class RawShaderMaterial extends ShaderMaterial {

	constructor( parameters ) {

		super( parameters );

		this.isRawShaderMaterial = true;

		this.type = 'RawShaderMaterial';

	}

}

class MeshStandardMaterial extends Material {

	constructor( parameters ) {

		super();

		this.isMeshStandardMaterial = true;

		this.defines = { 'STANDARD': '' };

		this.type = 'MeshStandardMaterial';

		this.color = new Color( 0xffffff ); // diffuse
		this.roughness = 1.0;
		this.metalness = 0.0;

		this.map = null;

		this.lightMap = null;
		this.lightMapIntensity = 1.0;

		this.aoMap = null;
		this.aoMapIntensity = 1.0;

		this.emissive = new Color( 0x000000 );
		this.emissiveIntensity = 1.0;
		this.emissiveMap = null;

		this.bumpMap = null;
		this.bumpScale = 1;

		this.normalMap = null;
		this.normalMapType = TangentSpaceNormalMap;
		this.normalScale = new Vector2( 1, 1 );

		this.displacementMap = null;
		this.displacementScale = 1;
		this.displacementBias = 0;

		this.roughnessMap = null;

		this.metalnessMap = null;

		this.alphaMap = null;

		this.envMap = null;
		this.envMapRotation = new Euler();
		this.envMapIntensity = 1.0;

		this.wireframe = false;
		this.wireframeLinewidth = 1;
		this.wireframeLinecap = 'round';
		this.wireframeLinejoin = 'round';

		this.flatShading = false;

		this.fog = true;

		this.setValues( parameters );

	}

	copy( source ) {

		super.copy( source );

		this.defines = { 'STANDARD': '' };

		this.color.copy( source.color );
		this.roughness = source.roughness;
		this.metalness = source.metalness;

		this.map = source.map;

		this.lightMap = source.lightMap;
		this.lightMapIntensity = source.lightMapIntensity;

		this.aoMap = source.aoMap;
		this.aoMapIntensity = source.aoMapIntensity;

		this.emissive.copy( source.emissive );
		this.emissiveMap = source.emissiveMap;
		this.emissiveIntensity = source.emissiveIntensity;

		this.bumpMap = source.bumpMap;
		this.bumpScale = source.bumpScale;

		this.normalMap = source.normalMap;
		this.normalMapType = source.normalMapType;
		this.normalScale.copy( source.normalScale );

		this.displacementMap = source.displacementMap;
		this.displacementScale = source.displacementScale;
		this.displacementBias = source.displacementBias;

		this.roughnessMap = source.roughnessMap;

		this.metalnessMap = source.metalnessMap;

		this.alphaMap = source.alphaMap;

		this.envMap = source.envMap;
		this.envMapRotation.copy( source.envMapRotation );
		this.envMapIntensity = source.envMapIntensity;

		this.wireframe = source.wireframe;
		this.wireframeLinewidth = source.wireframeLinewidth;
		this.wireframeLinecap = source.wireframeLinecap;
		this.wireframeLinejoin = source.wireframeLinejoin;

		this.flatShading = source.flatShading;

		this.fog = source.fog;

		return this;

	}

}

class MeshPhysicalMaterial extends MeshStandardMaterial {

	constructor( parameters ) {

		super();

		this.isMeshPhysicalMaterial = true;

		this.defines = {

			'STANDARD': '',
			'PHYSICAL': ''

		};

		this.type = 'MeshPhysicalMaterial';

		this.anisotropyRotation = 0;
		this.anisotropyMap = null;

		this.clearcoatMap = null;
		this.clearcoatRoughness = 0.0;
		this.clearcoatRoughnessMap = null;
		this.clearcoatNormalScale = new Vector2( 1, 1 );
		this.clearcoatNormalMap = null;

		this.ior = 1.5;

		Object.defineProperty( this, 'reflectivity', {
			get: function () {

				return ( clamp( 2.5 * ( this.ior - 1 ) / ( this.ior + 1 ), 0, 1 ) );

			},
			set: function ( reflectivity ) {

				this.ior = ( 1 + 0.4 * reflectivity ) / ( 1 - 0.4 * reflectivity );

			}
		} );

		this.iridescenceMap = null;
		this.iridescenceIOR = 1.3;
		this.iridescenceThicknessRange = [ 100, 400 ];
		this.iridescenceThicknessMap = null;

		this.sheenColor = new Color( 0x000000 );
		this.sheenColorMap = null;
		this.sheenRoughness = 1.0;
		this.sheenRoughnessMap = null;

		this.transmissionMap = null;

		this.thickness = 0;
		this.thicknessMap = null;
		this.attenuationDistance = Infinity;
		this.attenuationColor = new Color( 1, 1, 1 );

		this.specularIntensity = 1.0;
		this.specularIntensityMap = null;
		this.specularColor = new Color( 1, 1, 1 );
		this.specularColorMap = null;

		this._anisotropy = 0;
		this._clearcoat = 0;
		this._iridescence = 0;
		this._sheen = 0.0;
		this._transmission = 0;

		this.setValues( parameters );

	}

	get anisotropy() {

		return this._anisotropy;

	}

	set anisotropy( value ) {

		if ( this._anisotropy > 0 !== value > 0 ) {

			this.version ++;

		}

		this._anisotropy = value;

	}

	get clearcoat() {

		return this._clearcoat;

	}

	set clearcoat( value ) {

		if ( this._clearcoat > 0 !== value > 0 ) {

			this.version ++;

		}

		this._clearcoat = value;

	}

	get iridescence() {

		return this._iridescence;

	}

	set iridescence( value ) {

		if ( this._iridescence > 0 !== value > 0 ) {

			this.version ++;

		}

		this._iridescence = value;

	}

	get sheen() {

		return this._sheen;

	}

	set sheen( value ) {

		if ( this._sheen > 0 !== value > 0 ) {

			this.version ++;

		}

		this._sheen = value;

	}

	get transmission() {

		return this._transmission;

	}

	set transmission( value ) {

		if ( this._transmission > 0 !== value > 0 ) {

			this.version ++;

		}

		this._transmission = value;

	}

	copy( source ) {

		super.copy( source );

		this.defines = {

			'STANDARD': '',
			'PHYSICAL': ''

		};

		this.anisotropy = source.anisotropy;
		this.anisotropyRotation = source.anisotropyRotation;
		this.anisotropyMap = source.anisotropyMap;

		this.clearcoat = source.clearcoat;
		this.clearcoatMap = source.clearcoatMap;
		this.clearcoatRoughness = source.clearcoatRoughness;
		this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
		this.clearcoatNormalMap = source.clearcoatNormalMap;
		this.clearcoatNormalScale.copy( source.clearcoatNormalScale );

		this.ior = source.ior;

		this.iridescence = source.iridescence;
		this.iridescenceMap = source.iridescenceMap;
		this.iridescenceIOR = source.iridescenceIOR;
		this.iridescenceThicknessRange = [ ...source.iridescenceThicknessRange ];
		this.iridescenceThicknessMap = source.iridescenceThicknessMap;

		this.sheen = source.sheen;
		this.sheenColor.copy( source.sheenColor );
		this.sheenColorMap = source.sheenColorMap;
		this.sheenRoughness = source.sheenRoughness;
		this.sheenRoughnessMap = source.sheenRoughnessMap;

		this.transmission = source.transmission;
		this.transmissionMap = source.transmissionMap;

		this.thickness = source.thickness;
		this.thicknessMap = source.thicknessMap;
		this.attenuationDistance = source.attenuationDistance;
		this.attenuationColor.copy( source.attenuationColor );

		this.specularIntensity = source.specularIntensity;
		this.specularIntensityMap = source.specularIntensityMap;
		this.specularColor.copy( source.specularColor );
		this.specularColorMap = source.specularColorMap;

		return this;

	}

}

class MeshPhongMaterial extends Material {

	constructor( parameters ) {

		super();

		this.isMeshPhongMaterial = true;

		this.type = 'MeshPhongMaterial';

		this.color = new Color( 0xffffff ); // diffuse
		this.specular = new Color( 0x111111 );
		this.shininess = 30;

		this.map = null;

		this.lightMap = null;
		this.lightMapIntensity = 1.0;

		this.aoMap = null;
		this.aoMapIntensity = 1.0;

		this.emissive = new Color( 0x000000 );
		this.emissiveIntensity = 1.0;
		this.emissiveMap = null;

		this.bumpMap = null;
		this.bumpScale = 1;

		this.normalMap = null;
		this.normalMapType = TangentSpaceNormalMap;
		this.normalScale = new Vector2( 1, 1 );

		this.displacementMap = null;
		this.displacementScale = 1;
		this.displacementBias = 0;

		this.specularMap = null;

		this.alphaMap = null;

		this.envMap = null;
		this.envMapRotation = new Euler();
		this.combine = MultiplyOperation;
		this.reflectivity = 1;
		this.refractionRatio = 0.98;

		this.wireframe = false;
		this.wireframeLinewidth = 1;
		this.wireframeLinecap = 'round';
		this.wireframeLinejoin = 'round';

		this.flatShading = false;

		this.fog = true;

		this.setValues( parameters );

	}

	copy( source ) {

		super.copy( source );

		this.color.copy( source.color );
		this.specular.copy( source.specular );
		this.shininess = source.shininess;

		this.map = source.map;

		this.lightMap = source.lightMap;
		this.lightMapIntensity = source.lightMapIntensity;

		this.aoMap = source.aoMap;
		this.aoMapIntensity = source.aoMapIntensity;

		this.emissive.copy( source.emissive );
		this.emissiveMap = source.emissiveMap;
		this.emissiveIntensity = source.emissiveIntensity;

		this.bumpMap = source.bumpMap;
		this.bumpScale = source.bumpScale;

		this.normalMap = source.normalMap;
		this.normalMapType = source.normalMapType;
		this.normalScale.copy( source.normalScale );

		this.displacementMap = source.displacementMap;
		this.displacementScale = source.displacementScale;
		this.displacementBias = source.displacementBias;

		this.specularMap = source.specularMap;

		this.alphaMap = source.alphaMap;

		this.envMap = source.envMap;
		this.envMapRotation.copy( source.envMapRotation );
		this.combine = source.combine;
		this.reflectivity = source.reflectivity;
		this.refractionRatio = source.refractionRatio;

		this.wireframe = source.wireframe;
		this.wireframeLinewidth = source.wireframeLinewidth;
		this.wireframeLinecap = source.wireframeLinecap;
		this.wireframeLinejoin = source.wireframeLinejoin;

		this.flatShading = source.flatShading;

		this.fog = source.fog;

		return this;

	}

}

class MeshToonMaterial extends Material {

	constructor( parameters ) {

		super();

		this.isMeshToonMaterial = true;

		this.defines = { 'TOON': '' };

		this.type = 'MeshToonMaterial';

		this.color = new Color( 0xffffff );

		this.map = null;
		this.gradientMap = null;

		this.lightMap = null;
		this.lightMapIntensity = 1.0;

		this.aoMap = null;
		this.aoMapIntensity = 1.0;

		this.emissive = new Color( 0x000000 );
		this.emissiveIntensity = 1.0;
		this.emissiveMap = null;

		this.bumpMap = null;
		this.bumpScale = 1;

		this.normalMap = null;
		this.normalMapType = TangentSpaceNormalMap;
		this.normalScale = new Vector2( 1, 1 );

		this.displacementMap = null;
		this.displacementScale = 1;
		this.displacementBias = 0;

		this.alphaMap = null;

		this.wireframe = false;
		this.wireframeLinewidth = 1;
		this.wireframeLinecap = 'round';
		this.wireframeLinejoin = 'round';

		this.fog = true;

		this.setValues( parameters );

	}

	copy( source ) {

		super.copy( source );

		this.color.copy( source.color );

		this.map = source.map;
		this.gradientMap = source.gradientMap;

		this.lightMap = source.lightMap;
		this.lightMapIntensity = source.lightMapIntensity;

		this.aoMap = source.aoMap;
		this.aoMapIntensity = source.aoMapIntensity;

		this.emissive.copy( source.emissive );
		this.emissiveMap = source.emissiveMap;
		this.emissiveIntensity = source.emissiveIntensity;

		this.bumpMap = source.bumpMap;
		this.bumpScale = source.bumpScale;

		this.normalMap = source.normalMap;
		this.normalMapType = source.normalMapType;
		this.normalScale.copy( source.normalScale );

		this.displacementMap = source.displacementMap;
		this.displacementScale = source.displacementScale;
		this.displacementBias = source.displacementBias;

		this.alphaMap = source.alphaMap;

		this.wireframe = source.wireframe;
		this.wireframeLinewidth = source.wireframeLinewidth;
		this.wireframeLinecap = source.wireframeLinecap;
		this.wireframeLinejoin = source.wireframeLinejoin;

		this.fog = source.fog;

		return this;

	}

}

class MeshNormalMaterial extends Material {

	constructor( parameters ) {

		super();

		this.isMeshNormalMaterial = true;

		this.type = 'MeshNormalMaterial';

		this.bumpMap = null;
		this.bumpScale = 1;

		this.normalMap = null;
		this.normalMapType = TangentSpaceNormalMap;
		this.normalScale = new Vector2( 1, 1 );

		this.displacementMap = null;
		this.displacementScale = 1;
		this.displacementBias = 0;

		this.wireframe = false;
		this.wireframeLinewidth = 1;

		this.flatShading = false;

		this.setValues( parameters );

	}

	copy( source ) {

		super.copy( source );

		this.bumpMap = source.bumpMap;
		this.bumpScale = source.bumpScale;

		this.normalMap = source.normalMap;
		this.normalMapType = source.normalMapType;
		this.normalScale.copy( source.normalScale );

		this.displacementMap = source.displacementMap;
		this.displacementScale = source.displacementScale;
		this.displacementBias = source.displacementBias;

		this.wireframe = source.wireframe;
		this.wireframeLinewidth = source.wireframeLinewidth;

		this.flatShading = source.flatShading;

		return this;

	}

}

class MeshLambertMaterial extends Material {

	constructor( parameters ) {

		super();

		this.isMeshLambertMaterial = true;

		this.type = 'MeshLambertMaterial';

		this.color = new Color( 0xffffff ); // diffuse

		this.map = null;

		this.lightMap = null;
		this.lightMapIntensity = 1.0;

		this.aoMap = null;
		this.aoMapIntensity = 1.0;

		this.emissive = new Color( 0x000000 );
		this.emissiveIntensity = 1.0;
		this.emissiveMap = null;

		this.bumpMap = null;
		this.bumpScale = 1;

		this.normalMap = null;
		this.normalMapType = TangentSpaceNormalMap;
		this.normalScale = new Vector2( 1, 1 );

		this.displacementMap = null;
		this.displacementScale = 1;
		this.displacementBias = 0;

		this.specularMap = null;

		this.alphaMap = null;

		this.envMap = null;
		this.envMapRotation = new Euler();
		this.combine = MultiplyOperation;
		this.reflectivity = 1;
		this.refractionRatio = 0.98;

		this.wireframe = false;
		this.wireframeLinewidth = 1;
		this.wireframeLinecap = 'round';
		this.wireframeLinejoin = 'round';

		this.flatShading = false;

		this.fog = true;

		this.setValues( parameters );

	}

	copy( source ) {

		super.copy( source );

		this.color.copy( source.color );

		this.map = source.map;

		this.lightMap = source.lightMap;
		this.lightMapIntensity = source.lightMapIntensity;

		this.aoMap = source.aoMap;
		this.aoMapIntensity = source.aoMapIntensity;

		this.emissive.copy( source.emissive );
		this.emissiveMap = source.emissiveMap;
		this.emissiveIntensity = source.emissiveIntensity;

		this.bumpMap = source.bumpMap;
		this.bumpScale = source.bumpScale;

		this.normalMap = source.normalMap;
		this.normalMapType = source.normalMapType;
		this.normalScale.copy( source.normalScale );

		this.displacementMap = source.displacementMap;
		this.displacementScale = source.displacementScale;
		this.displacementBias = source.displacementBias;

		this.specularMap = source.specularMap;

		this.alphaMap = source.alphaMap;

		this.envMap = source.envMap;
		this.envMapRotation.copy( source.envMapRotation );
		this.combine = source.combine;
		this.reflectivity = source.reflectivity;
		this.refractionRatio = source.refractionRatio;

		this.wireframe = source.wireframe;
		this.wireframeLinewidth = source.wireframeLinewidth;
		this.wireframeLinecap = source.wireframeLinecap;
		this.wireframeLinejoin = source.wireframeLinejoin;

		this.flatShading = source.flatShading;

		this.fog = source.fog;

		return this;

	}

}

class MeshMatcapMaterial extends Material {

	constructor( parameters ) {

		super();

		this.isMeshMatcapMaterial = true;

		this.defines = { 'MATCAP': '' };

		this.type = 'MeshMatcapMaterial';

		this.color = new Color( 0xffffff ); // diffuse

		this.matcap = null;

		this.map = null;

		this.bumpMap = null;
		this.bumpScale = 1;

		this.normalMap = null;
		this.normalMapType = TangentSpaceNormalMap;
		this.normalScale = new Vector2( 1, 1 );

		this.displacementMap = null;
		this.displacementScale = 1;
		this.displacementBias = 0;

		this.alphaMap = null;

		this.flatShading = false;

		this.fog = true;

		this.setValues( parameters );

	}


	copy( source ) {

		super.copy( source );

		this.defines = { 'MATCAP': '' };

		this.color.copy( source.color );

		this.matcap = source.matcap;

		this.map = source.map;

		this.bumpMap = source.bumpMap;
		this.bumpScale = source.bumpScale;

		this.normalMap = source.normalMap;
		this.normalMapType = source.normalMapType;
		this.normalScale.copy( source.normalScale );

		this.displacementMap = source.displacementMap;
		this.displacementScale = source.displacementScale;
		this.displacementBias = source.displacementBias;

		this.alphaMap = source.alphaMap;

		this.flatShading = source.flatShading;

		this.fog = source.fog;

		return this;

	}

}

class LineDashedMaterial extends LineBasicMaterial {

	constructor( parameters ) {

		super();

		this.isLineDashedMaterial = true;

		this.type = 'LineDashedMaterial';

		this.scale = 1;
		this.dashSize = 3;
		this.gapSize = 1;

		this.setValues( parameters );

	}

	copy( source ) {

		super.copy( source );

		this.scale = source.scale;
		this.dashSize = source.dashSize;
		this.gapSize = source.gapSize;

		return this;

	}

}

// converts an array to a specific type
function convertArray( array, type, forceClone ) {

	if ( ! array || // let 'undefined' and 'null' pass
		! forceClone && array.constructor === type ) return array;

	if ( typeof type.BYTES_PER_ELEMENT === 'number' ) {

		return new type( array ); // create typed array

	}

	return Array.prototype.slice.call( array ); // create Array

}

function isTypedArray( object ) {

	return ArrayBuffer.isView( object ) &&
		! ( object instanceof DataView );

}

// returns an array by which times and values can be sorted
function getKeyframeOrder( times ) {

	function compareTime( i, j ) {

		return times[ i ] - times[ j ];

	}

	const n = times.length;
	const result = new Array( n );
	for ( let i = 0; i !== n; ++ i ) result[ i ] = i;

	result.sort( compareTime );

	return result;

}

// uses the array previously returned by 'getKeyframeOrder' to sort data
function sortedArray( values, stride, order ) {

	const nValues = values.length;
	const result = new values.constructor( nValues );

	for ( let i = 0, dstOffset = 0; dstOffset !== nValues; ++ i ) {

		const srcOffset = order[ i ] * stride;

		for ( let j = 0; j !== stride; ++ j ) {

			result[ dstOffset ++ ] = values[ srcOffset + j ];

		}

	}

	return result;

}

// function for parsing AOS keyframe formats
function flattenJSON( jsonKeys, times, values, valuePropertyName ) {

	let i = 1, key = jsonKeys[ 0 ];

	while ( key !== undefined && key[ valuePropertyName ] === undefined ) {

		key = jsonKeys[ i ++ ];

	}

	if ( key === undefined ) return; // no data

	let value = key[ valuePropertyName ];
	if ( value === undefined ) return; // no data

	if ( Array.isArray( value ) ) {

		do {

			value = key[ valuePropertyName ];

			if ( value !== undefined ) {

				times.push( key.time );
				values.push.apply( values, value ); // push all elements

			}

			key = jsonKeys[ i ++ ];

		} while ( key !== undefined );

	} else if ( value.toArray !== undefined ) {

		// ...assume THREE.Math-ish

		do {

			value = key[ valuePropertyName ];

			if ( value !== undefined ) {

				times.push( key.time );
				value.toArray( values, values.length );

			}

			key = jsonKeys[ i ++ ];

		} while ( key !== undefined );

	} else {

		// otherwise push as-is

		do {

			value = key[ valuePropertyName ];

			if ( value !== undefined ) {

				times.push( key.time );
				values.push( value );

			}

			key = jsonKeys[ i ++ ];

		} while ( key !== undefined );

	}

}

function subclip( sourceClip, name, startFrame, endFrame, fps = 30 ) {

	const clip = sourceClip.clone();

	clip.name = name;

	const tracks = [];

	for ( let i = 0; i < clip.tracks.length; ++ i ) {

		const track = clip.tracks[ i ];
		const valueSize = track.getValueSize();

		const times = [];
		const values = [];

		for ( let j = 0; j < track.times.length; ++ j ) {

			const frame = track.times[ j ] * fps;

			if ( frame < startFrame || frame >= endFrame ) continue;

			times.push( track.times[ j ] );

			for ( let k = 0; k < valueSize; ++ k ) {

				values.push( track.values[ j * valueSize + k ] );

			}

		}

		if ( times.length === 0 ) continue;

		track.times = convertArray( times, track.times.constructor );
		track.values = convertArray( values, track.values.constructor );

		tracks.push( track );

	}

	clip.tracks = tracks;

	// find minimum .times value across all tracks in the trimmed clip

	let minStartTime = Infinity;

	for ( let i = 0; i < clip.tracks.length; ++ i ) {

		if ( minStartTime > clip.tracks[ i ].times[ 0 ] ) {

			minStartTime = clip.tracks[ i ].times[ 0 ];

		}

	}

	// shift all tracks such that clip begins at t=0

	for ( let i = 0; i < clip.tracks.length; ++ i ) {

		clip.tracks[ i ].shift( - 1 * minStartTime );

	}

	clip.resetDuration();

	return clip;

}

function makeClipAdditive( targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30 ) {

	if ( fps <= 0 ) fps = 30;

	const numTracks = referenceClip.tracks.length;
	const referenceTime = referenceFrame / fps;

	// Make each track's values relative to the values at the reference frame
	for ( let i = 0; i < numTracks; ++ i ) {

		const referenceTrack = referenceClip.tracks[ i ];
		const referenceTrackType = referenceTrack.ValueTypeName;

		// Skip this track if it's non-numeric
		if ( referenceTrackType === 'bool' || referenceTrackType === 'string' ) continue;

		// Find the track in the target clip whose name and type matches the reference track
		const targetTrack = targetClip.tracks.find( function ( track ) {

			return track.name === referenceTrack.name
				&& track.ValueTypeName === referenceTrackType;

		} );

		if ( targetTrack === undefined ) continue;

		let referenceOffset = 0;
		const referenceValueSize = referenceTrack.getValueSize();

		if ( referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline ) {

			referenceOffset = referenceValueSize / 3;

		}

		let targetOffset = 0;
		const targetValueSize = targetTrack.getValueSize();

		if ( targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline ) {

			targetOffset = targetValueSize / 3;

		}

		const lastIndex = referenceTrack.times.length - 1;
		let referenceValue;

		// Find the value to subtract out of the track
		if ( referenceTime <= referenceTrack.times[ 0 ] ) {

			// Reference frame is earlier than the first keyframe, so just use the first keyframe
			const startIndex = referenceOffset;
			const endIndex = referenceValueSize - referenceOffset;
			referenceValue = referenceTrack.values.slice( startIndex, endIndex );

		} else if ( referenceTime >= referenceTrack.times[ lastIndex ] ) {

			// Reference frame is after the last keyframe, so just use the last keyframe
			const startIndex = lastIndex * referenceValueSize + referenceOffset;
			const endIndex = startIndex + referenceValueSize - referenceOffset;
			referenceValue = referenceTrack.values.slice( startIndex, endIndex );

		} else {

			// Interpolate to the reference value
			const interpolant = referenceTrack.createInterpolant();
			const startIndex = referenceOffset;
			const endIndex = referenceValueSize - referenceOffset;
			interpolant.evaluate( referenceTime );
			referenceValue = interpolant.resultBuffer.slice( startIndex, endIndex );

		}

		// Conjugate the quaternion
		if ( referenceTrackType === 'quaternion' ) {

			const referenceQuat = new Quaternion().fromArray( referenceValue ).normalize().conjugate();
			referenceQuat.toArray( referenceValue );

		}

		// Subtract the reference value from all of the track values

		const numTimes = targetTrack.times.length;
		for ( let j = 0; j < numTimes; ++ j ) {

			const valueStart = j * targetValueSize + targetOffset;

			if ( referenceTrackType === 'quaternion' ) {

				// Multiply the conjugate for quaternion track types
				Quaternion.multiplyQuaternionsFlat(
					targetTrack.values,
					valueStart,
					referenceValue,
					0,
					targetTrack.values,
					valueStart
				);

			} else {

				const valueEnd = targetValueSize - targetOffset * 2;

				// Subtract each value for all other numeric track types
				for ( let k = 0; k < valueEnd; ++ k ) {

					targetTrack.values[ valueStart + k ] -= referenceValue[ k ];

				}

			}

		}

	}

	targetClip.blendMode = AdditiveAnimationBlendMode;

	return targetClip;

}

const AnimationUtils = {
	convertArray: convertArray,
	isTypedArray: isTypedArray,
	getKeyframeOrder: getKeyframeOrder,
	sortedArray: sortedArray,
	flattenJSON: flattenJSON,
	subclip: subclip,
	makeClipAdditive: makeClipAdditive
};

/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References:
 *
 * 		http://www.oodesign.com/template-method-pattern.html
 *
 */

class Interpolant {

	constructor( parameterPositions, sampleValues, sampleSize, resultBuffer ) {

		this.parameterPositions = parameterPositions;
		this._cachedIndex = 0;

		this.resultBuffer = resultBuffer !== undefined ?
			resultBuffer : new sampleValues.constructor( sampleSize );
		this.sampleValues = sampleValues;
		this.valueSize = sampleSize;

		this.settings = null;
		this.DefaultSettings_ = {};

	}

	evaluate( t ) {

		const pp = this.parameterPositions;
		let i1 = this._cachedIndex,
			t1 = pp[ i1 ],
			t0 = pp[ i1 - 1 ];

		validate_interval: {

			seek: {

				let right;

				linear_scan: {

					//- See http://jsperf.com/comparison-to-undefined/3
					//- slower code:
					//-
					//- 				if ( t >= t1 || t1 === undefined ) {
					forward_scan: if ( ! ( t < t1 ) ) {

						for ( let giveUpAt = i1 + 2; ; ) {

							if ( t1 === undefined ) {

								if ( t < t0 ) break forward_scan;

								// after end

								i1 = pp.length;
								this._cachedIndex = i1;
								return this.copySampleValue_( i1 - 1 );

							}

							if ( i1 === giveUpAt ) break; // this loop

							t0 = t1;
							t1 = pp[ ++ i1 ];

							if ( t < t1 ) {

								// we have arrived at the sought interval
								break seek;

							}

						}

						// prepare binary search on the right side of the index
						right = pp.length;
						break linear_scan;

					}

					//- slower code:
					//-					if ( t < t0 || t0 === undefined ) {
					if ( ! ( t >= t0 ) ) {

						// looping?

						const t1global = pp[ 1 ];

						if ( t < t1global ) {

							i1 = 2; // + 1, using the scan for the details
							t0 = t1global;

						}

						// linear reverse scan

						for ( let giveUpAt = i1 - 2; ; ) {

							if ( t0 === undefined ) {

								// before start

								this._cachedIndex = 0;
								return this.copySampleValue_( 0 );

							}

							if ( i1 === giveUpAt ) break; // this loop

							t1 = t0;
							t0 = pp[ -- i1 - 1 ];

							if ( t >= t0 ) {

								// we have arrived at the sought interval
								break seek;

							}

						}

						// prepare binary search on the left side of the index
						right = i1;
						i1 = 0;
						break linear_scan;

					}

					// the interval is valid

					break validate_interval;

				} // linear scan

				// binary search

				while ( i1 < right ) {

					const mid = ( i1 + right ) >>> 1;

					if ( t < pp[ mid ] ) {

						right = mid;

					} else {

						i1 = mid + 1;

					}

				}

				t1 = pp[ i1 ];
				t0 = pp[ i1 - 1 ];

				// check boundary cases, again

				if ( t0 === undefined ) {

					this._cachedIndex = 0;
					return this.copySampleValue_( 0 );

				}

				if ( t1 === undefined ) {

					i1 = pp.length;
					this._cachedIndex = i1;
					return this.copySampleValue_( i1 - 1 );

				}

			} // seek

			this._cachedIndex = i1;

			this.intervalChanged_( i1, t0, t1 );

		} // validate_interval

		return this.interpolate_( i1, t0, t, t1 );

	}

	getSettings_() {

		return this.settings || this.DefaultSettings_;

	}

	copySampleValue_( index ) {

		// copies a sample value to the result buffer

		const result = this.resultBuffer,
			values = this.sampleValues,
			stride = this.valueSize,
			offset = index * stride;

		for ( let i = 0; i !== stride; ++ i ) {

			result[ i ] = values[ offset + i ];

		}

		return result;

	}

	// Template methods for derived classes:

	interpolate_( /* i1, t0, t, t1 */ ) {

		throw new Error( 'call to abstract method' );
		// implementations shall return this.resultBuffer

	}

	intervalChanged_( /* i1, t0, t1 */ ) {

		// empty

	}

}

/**
 * Fast and simple cubic spline interpolant.
 *
 * It was derived from a Hermitian construction setting the first derivative
 * at each sample position to the linear slope between neighboring positions
 * over their parameter interval.
 */

class CubicInterpolant extends Interpolant {

	constructor( parameterPositions, sampleValues, sampleSize, resultBuffer ) {

		super( parameterPositions, sampleValues, sampleSize, resultBuffer );

		this._weightPrev = - 0;
		this._offsetPrev = - 0;
		this._weightNext = - 0;
		this._offsetNext = - 0;

		this.DefaultSettings_ = {

			endingStart: ZeroCurvatureEnding,
			endingEnd: ZeroCurvatureEnding

		};

	}

	intervalChanged_( i1, t0, t1 ) {

		const pp = this.parameterPositions;
		let iPrev = i1 - 2,
			iNext = i1 + 1,

			tPrev = pp[ iPrev ],
			tNext = pp[ iNext ];

		if ( tPrev === undefined ) {

			switch ( this.getSettings_().endingStart ) {

				case ZeroSlopeEnding:

					// f'(t0) = 0
					iPrev = i1;
					tPrev = 2 * t0 - t1;

					break;

				case WrapAroundEnding:

					// use the other end of the curve
					iPrev = pp.length - 2;
					tPrev = t0 + pp[ iPrev ] - pp[ iPrev + 1 ];

					break;

				default: // ZeroCurvatureEnding

					// f''(t0) = 0 a.k.a. Natural Spline
					iPrev = i1;
					tPrev = t1;

			}

		}

		if ( tNext === undefined ) {

			switch ( this.getSettings_().endingEnd ) {

				case ZeroSlopeEnding:

					// f'(tN) = 0
					iNext = i1;
					tNext = 2 * t1 - t0;

					break;

				case WrapAroundEnding:

					// use the other end of the curve
					iNext = 1;
					tNext = t1 + pp[ 1 ] - pp[ 0 ];

					break;

				default: // ZeroCurvatureEnding

					// f''(tN) = 0, a.k.a. Natural Spline
					iNext = i1 - 1;
					tNext = t0;

			}

		}

		const halfDt = ( t1 - t0 ) * 0.5,
			stride = this.valueSize;

		this._weightPrev = halfDt / ( t0 - tPrev );
		this._weightNext = halfDt / ( tNext - t1 );
		this._offsetPrev = iPrev * stride;
		this._offsetNext = iNext * stride;

	}

	interpolate_( i1, t0, t, t1 ) {

		const result = this.resultBuffer,
			values = this.sampleValues,
			stride = this.valueSize,

			o1 = i1 * stride,		o0 = o1 - stride,
			oP = this._offsetPrev, 	oN = this._offsetNext,
			wP = this._weightPrev,	wN = this._weightNext,

			p = ( t - t0 ) / ( t1 - t0 ),
			pp = p * p,
			ppp = pp * p;

		// evaluate polynomials

		const sP = - wP * ppp + 2 * wP * pp - wP * p;
		const s0 = ( 1 + wP ) * ppp + ( - 1.5 - 2 * wP ) * pp + ( - 0.5 + wP ) * p + 1;
		const s1 = ( - 1 - wN ) * ppp + ( 1.5 + wN ) * pp + 0.5 * p;
		const sN = wN * ppp - wN * pp;

		// combine data linearly

		for ( let i = 0; i !== stride; ++ i ) {

			result[ i ] =
					sP * values[ oP + i ] +
					s0 * values[ o0 + i ] +
					s1 * values[ o1 + i ] +
					sN * values[ oN + i ];

		}

		return result;

	}

}

class LinearInterpolant extends Interpolant {

	constructor( parameterPositions, sampleValues, sampleSize, resultBuffer ) {

		super( parameterPositions, sampleValues, sampleSize, resultBuffer );

	}

	interpolate_( i1, t0, t, t1 ) {

		const result = this.resultBuffer,
			values = this.sampleValues,
			stride = this.valueSize,

			offset1 = i1 * stride,
			offset0 = offset1 - stride,

			weight1 = ( t - t0 ) / ( t1 - t0 ),
			weight0 = 1 - weight1;

		for ( let i = 0; i !== stride; ++ i ) {

			result[ i ] =
					values[ offset0 + i ] * weight0 +
					values[ offset1 + i ] * weight1;

		}

		return result;

	}

}

/**
 *
 * Interpolant that evaluates to the sample value at the position preceding
 * the parameter.
 */

class DiscreteInterpolant extends Interpolant {

	constructor( parameterPositions, sampleValues, sampleSize, resultBuffer ) {

		super( parameterPositions, sampleValues, sampleSize, resultBuffer );

	}

	interpolate_( i1 /*, t0, t, t1 */ ) {

		return this.copySampleValue_( i1 - 1 );

	}

}

class KeyframeTrack {

	constructor( name, times, values, interpolation ) {

		if ( name === undefined ) throw new Error( 'THREE.KeyframeTrack: track name is undefined' );
		if ( times === undefined || times.length === 0 ) throw new Error( 'THREE.KeyframeTrack: no keyframes in track named ' + name );

		this.name = name;

		this.times = convertArray( times, this.TimeBufferType );
		this.values = convertArray( values, this.ValueBufferType );

		this.setInterpolation( interpolation || this.DefaultInterpolation );

	}

	// Serialization (in static context, because of constructor invocation
	// and automatic invocation of .toJSON):

	static toJSON( track ) {

		const trackType = track.constructor;

		let json;

		// derived classes can define a static toJSON method
		if ( trackType.toJSON !== this.toJSON ) {

			json = trackType.toJSON( track );

		} else {

			// by default, we assume the data can be serialized as-is
			json = {

				'name': track.name,
				'times': convertArray( track.times, Array ),
				'values': convertArray( track.values, Array )

			};

			const interpolation = track.getInterpolation();

			if ( interpolation !== track.DefaultInterpolation ) {

				json.interpolation = interpolation;

			}

		}

		json.type = track.ValueTypeName; // mandatory

		return json;

	}

	InterpolantFactoryMethodDiscrete( result ) {

		return new DiscreteInterpolant( this.times, this.values, this.getValueSize(), result );

	}

	InterpolantFactoryMethodLinear( result ) {

		return new LinearInterpolant( this.times, this.values, this.getValueSize(), result );

	}

	InterpolantFactoryMethodSmooth( result ) {

		return new CubicInterpolant( this.times, this.values, this.getValueSize(), result );

	}

	setInterpolation( interpolation ) {

		let factoryMethod;

		switch ( interpolation ) {

			case InterpolateDiscrete:

				factoryMethod = this.InterpolantFactoryMethodDiscrete;

				break;

			case InterpolateLinear:

				factoryMethod = this.InterpolantFactoryMethodLinear;

				break;

			case InterpolateSmooth:

				factoryMethod = this.InterpolantFactoryMethodSmooth;

				break;

		}

		if ( factoryMethod === undefined ) {

			const message = 'unsupported interpolation for ' +
				this.ValueTypeName + ' keyframe track named ' + this.name;

			if ( this.createInterpolant === undefined ) {

				// fall back to default, unless the default itself is messed up
				if ( interpolation !== this.DefaultInterpolation ) {

					this.setInterpolation( this.DefaultInterpolation );

				} else {

					throw new Error( message ); // fatal, in this case

				}

			}

			console.warn( 'THREE.KeyframeTrack:', message );
			return this;

		}

		this.createInterpolant = factoryMethod;

		return this;

	}

	getInterpolation() {

		switch ( this.createInterpolant ) {

			case this.InterpolantFactoryMethodDiscrete:

				return InterpolateDiscrete;

			case this.InterpolantFactoryMethodLinear:

				return InterpolateLinear;

			case this.InterpolantFactoryMethodSmooth:

				return InterpolateSmooth;

		}

	}

	getValueSize() {

		return this.values.length / this.times.length;

	}

	// move all keyframes either forwards or backwards in time
	shift( timeOffset ) {

		if ( timeOffset !== 0.0 ) {

			const times = this.times;

			for ( let i = 0, n = times.length; i !== n; ++ i ) {

				times[ i ] += timeOffset;

			}

		}

		return this;

	}

	// scale all keyframe times by a factor (useful for frame <-> seconds conversions)
	scale( timeScale ) {

		if ( timeScale !== 1.0 ) {

			const times = this.times;

			for ( let i = 0, n = times.length; i !== n; ++ i ) {

				times[ i ] *= timeScale;

			}

		}

		return this;

	}

	// removes keyframes before and after animation without changing any values within the range [startTime, endTime].
	// IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
	trim( startTime, endTime ) {

		const times = this.times,
			nKeys = times.length;

		let from = 0,
			to = nKeys - 1;

		while ( from !== nKeys && times[ from ] < startTime ) {

			++ from;

		}

		while ( to !== - 1 && times[ to ] > endTime ) {

			-- to;

		}

		++ to; // inclusive -> exclusive bound

		if ( from !== 0 || to !== nKeys ) {

			// empty tracks are forbidden, so keep at least one keyframe
			if ( from >= to ) {

				to = Math.max( to, 1 );
				from = to - 1;

			}

			const stride = this.getValueSize();
			this.times = times.slice( from, to );
			this.values = this.values.slice( from * stride, to * stride );

		}

		return this;

	}

	// ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
	validate() {

		let valid = true;

		const valueSize = this.getValueSize();
		if ( valueSize - Math.floor( valueSize ) !== 0 ) {

			console.error( 'THREE.KeyframeTrack: Invalid value size in track.', this );
			valid = false;

		}

		const times = this.times,
			values = this.values,

			nKeys = times.length;

		if ( nKeys === 0 ) {

			console.error( 'THREE.KeyframeTrack: Track is empty.', this );
			valid = false;

		}

		let prevTime = null;

		for ( let i = 0; i !== nKeys; i ++ ) {

			const currTime = times[ i ];

			if ( typeof currTime === 'number' && isNaN( currTime ) ) {

				console.error( 'THREE.KeyframeTrack: Time is not a valid number.', this, i, currTime );
				valid = false;
				break;

			}

			if ( prevTime !== null && prevTime > currTime ) {

				console.error( 'THREE.KeyframeTrack: Out of order keys.', this, i, currTime, prevTime );
				valid = false;
				break;

			}

			prevTime = currTime;

		}

		if ( values !== undefined ) {

			if ( isTypedArray( values ) ) {

				for ( let i = 0, n = values.length; i !== n; ++ i ) {

					const value = values[ i ];

					if ( isNaN( value ) ) {

						console.error( 'THREE.KeyframeTrack: Value is not a valid number.', this, i, value );
						valid = false;
						break;

					}

				}

			}

		}

		return valid;

	}

	// removes equivalent sequential keys as common in morph target sequences
	// (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
	optimize() {

		// times or values may be shared with other tracks, so overwriting is unsafe
		const times = this.times.slice(),
			values = this.values.slice(),
			stride = this.getValueSize(),

			smoothInterpolation = this.getInterpolation() === InterpolateSmooth,

			lastIndex = times.length - 1;

		let writeIndex = 1;

		for ( let i = 1; i < lastIndex; ++ i ) {

			let keep = false;

			const time = times[ i ];
			const timeNext = times[ i + 1 ];

			// remove adjacent keyframes scheduled at the same time

			if ( time !== timeNext && ( i !== 1 || time !== times[ 0 ] ) ) {

				if ( ! smoothInterpolation ) {

					// remove unnecessary keyframes same as their neighbors

					const offset = i * stride,
						offsetP = offset - stride,
						offsetN = offset + stride;

					for ( let j = 0; j !== stride; ++ j ) {

						const value = values[ offset + j ];

						if ( value !== values[ offsetP + j ] ||
							value !== values[ offsetN + j ] ) {

							keep = true;
							break;

						}

					}

				} else {

					keep = true;

				}

			}

			// in-place compaction

			if ( keep ) {

				if ( i !== writeIndex ) {

					times[ writeIndex ] = times[ i ];

					const readOffset = i * stride,
						writeOffset = writeIndex * stride;

					for ( let j = 0; j !== stride; ++ j ) {

						values[ writeOffset + j ] = values[ readOffset + j ];

					}

				}

				++ writeIndex;

			}

		}

		// flush last keyframe (compaction looks ahead)

		if ( lastIndex > 0 ) {

			times[ writeIndex ] = times[ lastIndex ];

			for ( let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++ j ) {

				values[ writeOffset + j ] = values[ readOffset + j ];

			}

			++ writeIndex;

		}

		if ( writeIndex !== times.length ) {

			this.times = times.slice( 0, writeIndex );
			this.values = values.slice( 0, writeIndex * stride );

		} else {

			this.times = times;
			this.values = values;

		}

		return this;

	}

	clone() {

		const times = this.times.slice();
		const values = this.values.slice();

		const TypedKeyframeTrack = this.constructor;
		const track = new TypedKeyframeTrack( this.name, times, values );

		// Interpolant argument to constructor is not saved, so copy the factory method directly.
		track.createInterpolant = this.createInterpolant;

		return track;

	}

}

KeyframeTrack.prototype.TimeBufferType = Float32Array;
KeyframeTrack.prototype.ValueBufferType = Float32Array;
KeyframeTrack.prototype.DefaultInterpolation = InterpolateLinear;

/**
 * A Track of Boolean keyframe values.
 */
class BooleanKeyframeTrack extends KeyframeTrack {}

BooleanKeyframeTrack.prototype.ValueTypeName = 'bool';
BooleanKeyframeTrack.prototype.ValueBufferType = Array;
BooleanKeyframeTrack.prototype.DefaultInterpolation = InterpolateDiscrete;
BooleanKeyframeTrack.prototype.InterpolantFactoryMethodLinear = undefined;
BooleanKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = undefined;

/**
 * A Track of keyframe values that represent color.
 */
class ColorKeyframeTrack extends KeyframeTrack {}

ColorKeyframeTrack.prototype.ValueTypeName = 'color';

/**
 * A Track of numeric keyframe values.
 */
class NumberKeyframeTrack extends KeyframeTrack {}

NumberKeyframeTrack.prototype.ValueTypeName = 'number';

/**
 * Spherical linear unit quaternion interpolant.
 */

class QuaternionLinearInterpolant extends Interpolant {

	constructor( parameterPositions, sampleValues, sampleSize, resultBuffer ) {

		super( parameterPositions, sampleValues, sampleSize, resultBuffer );

	}

	interpolate_( i1, t0, t, t1 ) {

		const result = this.resultBuffer,
			values = this.sampleValues,
			stride = this.valueSize,

			alpha = ( t - t0 ) / ( t1 - t0 );

		let offset = i1 * stride;

		for ( let end = offset + stride; offset !== end; offset += 4 ) {

			Quaternion.slerpFlat( result, 0, values, offset - stride, values, offset, alpha );

		}

		return result;

	}

}

/**
 * A Track of quaternion keyframe values.
 */
class QuaternionKeyframeTrack extends KeyframeTrack {

	InterpolantFactoryMethodLinear( result ) {

		return new QuaternionLinearInterpolant( this.times, this.values, this.getValueSize(), result );

	}

}

QuaternionKeyframeTrack.prototype.ValueTypeName = 'quaternion';
// ValueBufferType is inherited
QuaternionKeyframeTrack.prototype.DefaultInterpolation = InterpolateLinear;
QuaternionKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = undefined;

/**
 * A Track that interpolates Strings
 */
class StringKeyframeTrack extends KeyframeTrack {}

StringKeyframeTrack.prototype.ValueTypeName = 'string';
StringKeyframeTrack.prototype.ValueBufferType = Array;
StringKeyframeTrack.prototype.DefaultInterpolation = InterpolateDiscrete;
StringKeyframeTrack.prototype.InterpolantFactoryMethodLinear = undefined;
StringKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = undefined;

/**
 * A Track of vectored keyframe values.
 */
class VectorKeyframeTrack extends KeyframeTrack {}

VectorKeyframeTrack.prototype.ValueTypeName = 'vector';

class AnimationClip {

	constructor( name = '', duration = - 1, tracks = [], blendMode = NormalAnimationBlendMode ) {

		this.name = name;
		this.tracks = tracks;
		this.duration = duration;
		this.blendMode = blendMode;

		this.uuid = generateUUID();

		// this means it should figure out its duration by scanning the tracks
		if ( this.duration < 0 ) {

			this.resetDuration();

		}

	}


	static parse( json ) {

		const tracks = [],
			jsonTracks = json.tracks,
			frameTime = 1.0 / ( json.fps || 1.0 );

		for ( let i = 0, n = jsonTracks.length; i !== n; ++ i ) {

			tracks.push( parseKeyframeTrack( jsonTracks[ i ] ).scale( frameTime ) );

		}

		const clip = new this( json.name, json.duration, tracks, json.blendMode );
		clip.uuid = json.uuid;

		return clip;

	}

	static toJSON( clip ) {

		const tracks = [],
			clipTracks = clip.tracks;

		const json = {

			'name': clip.name,
			'duration': clip.duration,
			'tracks': tracks,
			'uuid': clip.uuid,
			'blendMode': clip.blendMode

		};

		for ( let i = 0, n = clipTracks.length; i !== n; ++ i ) {

			tracks.push( KeyframeTrack.toJSON( clipTracks[ i ] ) );

		}

		return json;

	}

	static CreateFromMorphTargetSequence( name, morphTargetSequence, fps, noLoop ) {

		const numMorphTargets = morphTargetSequence.length;
		const tracks = [];

		for ( let i = 0; i < numMorphTargets; i ++ ) {

			let times = [];
			let values = [];

			times.push(
				( i + numMorphTargets - 1 ) % numMorphTargets,
				i,
				( i + 1 ) % numMorphTargets );

			values.push( 0, 1, 0 );

			const order = getKeyframeOrder( times );
			times = sortedArray( times, 1, order );
			values = sortedArray( values, 1, order );

			// if there is a key at the first frame, duplicate it as the
			// last frame as well for perfect loop.
			if ( ! noLoop && times[ 0 ] === 0 ) {

				times.push( numMorphTargets );
				values.push( values[ 0 ] );

			}

			tracks.push(
				new NumberKeyframeTrack(
					'.morphTargetInfluences[' + morphTargetSequence[ i ].name + ']',
					times, values
				).scale( 1.0 / fps ) );

		}

		return new this( name, - 1, tracks );

	}

	static findByName( objectOrClipArray, name ) {

		let clipArray = objectOrClipArray;

		if ( ! Array.isArray( objectOrClipArray ) ) {

			const o = objectOrClipArray;
			clipArray = o.geometry && o.geometry.animations || o.animations;

		}

		for ( let i = 0; i < clipArray.length; i ++ ) {

			if ( clipArray[ i ].name === name ) {

				return clipArray[ i ];

			}

		}

		return null;

	}

	static CreateClipsFromMorphTargetSequences( morphTargets, fps, noLoop ) {

		const animationToMorphTargets = {};

		// tested with https://regex101.com/ on trick sequences
		// such flamingo_flyA_003, flamingo_run1_003, crdeath0059
		const pattern = /^([\w-]*?)([\d]+)$/;

		// sort morph target names into animation groups based
		// patterns like Walk_001, Walk_002, Run_001, Run_002
		for ( let i = 0, il = morphTargets.length; i < il; i ++ ) {

			const morphTarget = morphTargets[ i ];
			const parts = morphTarget.name.match( pattern );

			if ( parts && parts.length > 1 ) {

				const name = parts[ 1 ];

				let animationMorphTargets = animationToMorphTargets[ name ];

				if ( ! animationMorphTargets ) {

					animationToMorphTargets[ name ] = animationMorphTargets = [];

				}

				animationMorphTargets.push( morphTarget );

			}

		}

		const clips = [];

		for ( const name in animationToMorphTargets ) {

			clips.push( this.CreateFromMorphTargetSequence( name, animationToMorphTargets[ name ], fps, noLoop ) );

		}

		return clips;

	}

	// parse the animation.hierarchy format
	static parseAnimation( animation, bones ) {

		if ( ! animation ) {

			console.error( 'THREE.AnimationClip: No animation in JSONLoader data.' );
			return null;

		}

		const addNonemptyTrack = function ( trackType, trackName, animationKeys, propertyName, destTracks ) {

			// only return track if there are actually keys.
			if ( animationKeys.length !== 0 ) {

				const times = [];
				const values = [];

				flattenJSON( animationKeys, times, values, propertyName );

				// empty keys are filtered out, so check again
				if ( times.length !== 0 ) {

					destTracks.push( new trackType( trackName, times, values ) );

				}

			}

		};

		const tracks = [];

		const clipName = animation.name || 'default';
		const fps = animation.fps || 30;
		const blendMode = animation.blendMode;

		// automatic length determination in AnimationClip.
		let duration = animation.length || - 1;

		const hierarchyTracks = animation.hierarchy || [];

		for ( let h = 0; h < hierarchyTracks.length; h ++ ) {

			const animationKeys = hierarchyTracks[ h ].keys;

			// skip empty tracks
			if ( ! animationKeys || animationKeys.length === 0 ) continue;

			// process morph targets
			if ( animationKeys[ 0 ].morphTargets ) {

				// figure out all morph targets used in this track
				const morphTargetNames = {};

				let k;

				for ( k = 0; k < animationKeys.length; k ++ ) {

					if ( animationKeys[ k ].morphTargets ) {

						for ( let m = 0; m < animationKeys[ k ].morphTargets.length; m ++ ) {

							morphTargetNames[ animationKeys[ k ].morphTargets[ m ] ] = - 1;

						}

					}

				}

				// create a track for each morph target with all zero
				// morphTargetInfluences except for the keys in which
				// the morphTarget is named.
				for ( const morphTargetName in morphTargetNames ) {

					const times = [];
					const values = [];

					for ( let m = 0; m !== animationKeys[ k ].morphTargets.length; ++ m ) {

						const animationKey = animationKeys[ k ];

						times.push( animationKey.time );
						values.push( ( animationKey.morphTarget === morphTargetName ) ? 1 : 0 );

					}

					tracks.push( new NumberKeyframeTrack( '.morphTargetInfluence[' + morphTargetName + ']', times, values ) );

				}

				duration = morphTargetNames.length * fps;

			} else {

				// ...assume skeletal animation

				const boneName = '.bones[' + bones[ h ].name + ']';

				addNonemptyTrack(
					VectorKeyframeTrack, boneName + '.position',
					animationKeys, 'pos', tracks );

				addNonemptyTrack(
					QuaternionKeyframeTrack, boneName + '.quaternion',
					animationKeys, 'rot', tracks );

				addNonemptyTrack(
					VectorKeyframeTrack, boneName + '.scale',
					animationKeys, 'scl', tracks );

			}

		}

		if ( tracks.length === 0 ) {

			return null;

		}

		const clip = new this( clipName, duration, tracks, blendMode );

		return clip;

	}

	resetDuration() {

		const tracks = this.tracks;
		let duration = 0;

		for ( let i = 0, n = tracks.length; i !== n; ++ i ) {

			const track = this.tracks[ i ];

			duration = Math.max( duration, track.times[ track.times.length - 1 ] );

		}

		this.duration = duration;

		return this;

	}

	trim() {

		for ( let i = 0; i < this.tracks.length; i ++ ) {

			this.tracks[ i ].trim( 0, this.duration );

		}

		return this;

	}

	validate() {

		let valid = true;

		for ( let i = 0; i < this.tracks.length; i ++ ) {

			valid = valid && this.tracks[ i ].validate();

		}

		return valid;

	}

	optimize() {

		for ( let i = 0; i < this.tracks.length; i ++ ) {

			this.tracks[ i ].optimize();

		}

		return this;

	}

	clone() {

		const tracks = [];

		for ( let i = 0; i < this.tracks.length; i ++ ) {

			tracks.push( this.tracks[ i ].clone() );

		}

		return new this.constructor( this.name, this.duration, tracks, this.blendMode );

	}

	toJSON() {

		return this.constructor.toJSON( this );

	}

}

function getTrackTypeForValueTypeName( typeName ) {

	switch ( typeName.toLowerCase() ) {

		case 'scalar':
		case 'double':
		case 'float':
		case 'number':
		case 'integer':

			return NumberKeyframeTrack;

		case 'vector':
		case 'vector2':
		case 'vector3':
		case 'vector4':

			return VectorKeyframeTrack;

		case 'color':

			return ColorKeyframeTrack;

		case 'quaternion':

			return QuaternionKeyframeTrack;

		case 'bool':
		case 'boolean':

			return BooleanKeyframeTrack;

		case 'string':

			return StringKeyframeTrack;

	}

	throw new Error( 'THREE.KeyframeTrack: Unsupported typeName: ' + typeName );

}

function parseKeyframeTrack( json ) {

	if ( json.type === undefined ) {

		throw new Error( 'THREE.KeyframeTrack: track type undefined, can not parse' );

	}

	const trackType = getTrackTypeForValueTypeName( json.type );

	if ( json.times === undefined ) {

		const times = [], values = [];

		flattenJSON( json.keys, times, values, 'value' );

		json.times = times;
		json.values = values;

	}

	// derived classes can define a static parse method
	if ( trackType.parse !== undefined ) {

		return trackType.parse( json );

	} else {

		// by default, we assume a constructor compatible with the base
		return new trackType( json.name, json.times, json.values, json.interpolation );

	}

}

const Cache = {

	enabled: false,

	files: {},

	add: function ( key, file ) {

		if ( this.enabled === false ) return;

		// console.log( 'THREE.Cache', 'Adding key:', key );

		this.files[ key ] = file;

	},

	get: function ( key ) {

		if ( this.enabled === false ) return;

		// console.log( 'THREE.Cache', 'Checking key:', key );

		return this.files[ key ];

	},

	remove: function ( key ) {

		delete this.files[ key ];

	},

	clear: function () {

		this.files = {};

	}

};

class LoadingManager {

	constructor( onLoad, onProgress, onError ) {

		const scope = this;

		let isLoading = false;
		let itemsLoaded = 0;
		let itemsTotal = 0;
		let urlModifier = undefined;
		const handlers = [];

		// Refer to #5689 for the reason why we don't set .onStart
		// in the constructor

		this.onStart = undefined;
		this.onLoad = onLoad;
		this.onProgress = onProgress;
		this.onError = onError;

		this.itemStart = function ( url ) {

			itemsTotal ++;

			if ( isLoading === false ) {

				if ( scope.onStart !== undefined ) {

					scope.onStart( url, itemsLoaded, itemsTotal );

				}

			}

			isLoading = true;

		};

		this.itemEnd = function ( url ) {

			itemsLoaded ++;

			if ( scope.onProgress !== undefined ) {

				scope.onProgress( url, itemsLoaded, itemsTotal );

			}

			if ( itemsLoaded === itemsTotal ) {

				isLoading = false;

				if ( scope.onLoad !== undefined ) {

					scope.onLoad();

				}

			}

		};

		this.itemError = function ( url ) {

			if ( scope.onError !== undefined ) {

				scope.onError( url );

			}

		};

		this.resolveURL = function ( url ) {

			if ( urlModifier ) {

				return urlModifier( url );

			}

			return url;

		};

		this.setURLModifier = function ( transform ) {

			urlModifier = transform;

			return this;

		};

		this.addHandler = function ( regex, loader ) {

			handlers.push( regex, loader );

			return this;

		};

		this.removeHandler = function ( regex ) {

			const index = handlers.indexOf( regex );

			if ( index !== - 1 ) {

				handlers.splice( index, 2 );

			}

			return this;

		};

		this.getHandler = function ( file ) {

			for ( let i = 0, l = handlers.length; i < l; i += 2 ) {

				const regex = handlers[ i ];
				const loader = handlers[ i + 1 ];

				if ( regex.global ) regex.lastIndex = 0; // see #17920

				if ( regex.test( file ) ) {

					return loader;

				}

			}

			return null;

		};

	}

}

const DefaultLoadingManager = /*@__PURE__*/ new LoadingManager();

class Loader {

	constructor( manager ) {

		this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

		this.crossOrigin = 'anonymous';
		this.withCredentials = false;
		this.path = '';
		this.resourcePath = '';
		this.requestHeader = {};

	}

	load( /* url, onLoad, onProgress, onError */ ) {}

	loadAsync( url, onProgress ) {

		const scope = this;

		return new Promise( function ( resolve, reject ) {

			scope.load( url, resolve, onProgress, reject );

		} );

	}

	parse( /* data */ ) {}

	setCrossOrigin( crossOrigin ) {

		this.crossOrigin = crossOrigin;
		return this;

	}

	setWithCredentials( value ) {

		this.withCredentials = value;
		return this;

	}

	setPath( path ) {

		this.path = path;
		return this;

	}

	setResourcePath( resourcePath ) {

		this.resourcePath = resourcePath;
		return this;

	}

	setRequestHeader( requestHeader ) {

		this.requestHeader = requestHeader;
		return this;

	}

}

Loader.DEFAULT_MATERIAL_NAME = '__DEFAULT';

const loading = {};

class HttpError extends Error {

	constructor( message, response ) {

		super( message );
		this.response = response;

	}

}

class FileLoader extends Loader {

	constructor( manager ) {

		super( manager );

	}

	load( url, onLoad, onProgress, onError ) {

		if ( url === undefined ) url = '';

		if ( this.path !== undefined ) url = this.path + url;

		url = this.manager.resolveURL( url );

		const cached = Cache.get( url );

		if ( cached !== undefined ) {

			this.manager.itemStart( url );

			setTimeout( () => {

				if ( onLoad ) onLoad( cached );

				this.manager.itemEnd( url );

			}, 0 );

			return cached;

		}

		// Check if request is duplicate

		if ( loading[ url ] !== undefined ) {

			loading[ url ].push( {

				onLoad: onLoad,
				onProgress: onProgress,
				onError: onError

			} );

			return;

		}

		// Initialise array for duplicate requests
		loading[ url ] = [];

		loading[ url ].push( {
			onLoad: onLoad,
			onProgress: onProgress,
			onError: onError,
		} );

		// create request
		const req = new Request( url, {
			headers: new Headers( this.requestHeader ),
			credentials: this.withCredentials ? 'include' : 'same-origin',
			// An abort controller could be added within a future PR
		} );

		// record states ( avoid data race )
		const mimeType = this.mimeType;
		const responseType = this.responseType;

		// start the fetch
		fetch( req )
			.then( response => {

				if ( response.status === 200 || response.status === 0 ) {

					// Some browsers return HTTP Status 0 when using non-http protocol
					// e.g. 'file://' or 'data://'. Handle as success.

					if ( response.status === 0 ) {

						console.warn( 'THREE.FileLoader: HTTP Status 0 received.' );

					}

					// Workaround: Checking if response.body === undefined for Alipay browser #23548

					if ( typeof ReadableStream === 'undefined' || response.body === undefined || response.body.getReader === undefined ) {

						return response;

					}

					const callbacks = loading[ url ];
					const reader = response.body.getReader();

					// Nginx needs X-File-Size check
					// https://serverfault.com/questions/482875/why-does-nginx-remove-content-length-header-for-chunked-content
					const contentLength = response.headers.get( 'Content-Length' ) || response.headers.get( 'X-File-Size' );
					const total = contentLength ? parseInt( contentLength ) : 0;
					const lengthComputable = total !== 0;
					let loaded = 0;

					// periodically read data into the new stream tracking while download progress
					const stream = new ReadableStream( {
						start( controller ) {

							readData();

							function readData() {

								reader.read().then( ( { done, value } ) => {

									if ( done ) {

										controller.close();

									} else {

										loaded += value.byteLength;

										const event = new ProgressEvent( 'progress', { lengthComputable, loaded, total } );
										for ( let i = 0, il = callbacks.length; i < il; i ++ ) {

											const callback = callbacks[ i ];
											if ( callback.onProgress ) callback.onProgress( event );

										}

										controller.enqueue( value );
										readData();

									}

								} );

							}

						}

					} );

					return new Response( stream );

				} else {

					throw new HttpError( `fetch for "${response.url}" responded with ${response.status}: ${response.statusText}`, response );

				}

			} )
			.then( response => {

				switch ( responseType ) {

					case 'arraybuffer':

						return response.arrayBuffer();

					case 'blob':

						return response.blob();

					case 'document':

						return response.text()
							.then( text => {

								const parser = new DOMParser();
								return parser.parseFromString( text, mimeType );

							} );

					case 'json':

						return response.json();

					default:

						if ( mimeType === undefined ) {

							return response.text();

						} else {

							// sniff encoding
							const re = /charset="?([^;"\s]*)"?/i;
							const exec = re.exec( mimeType );
							const label = exec && exec[ 1 ] ? exec[ 1 ].toLowerCase() : undefined;
							const decoder = new TextDecoder( label );
							return response.arrayBuffer().then( ab => decoder.decode( ab ) );

						}

				}

			} )
			.then( data => {

				// Add to cache only on HTTP success, so that we do not cache
				// error response bodies as proper responses to requests.
				Cache.add( url, data );

				const callbacks = loading[ url ];
				delete loading[ url ];

				for ( let i = 0, il = callbacks.length; i < il; i ++ ) {

					const callback = callbacks[ i ];
					if ( callback.onLoad ) callback.onLoad( data );

				}

			} )
			.catch( err => {

				// Abort errors and other errors are handled the same

				const callbacks = loading[ url ];

				if ( callbacks === undefined ) {

					// When onLoad was called and url was deleted in `loading`
					this.manager.itemError( url );
					throw err;

				}

				delete loading[ url ];

				for ( let i = 0, il = callbacks.length; i < il; i ++ ) {

					const callback = callbacks[ i ];
					if ( callback.onError ) callback.onError( err );

				}

				this.manager.itemError( url );

			} )
			.finally( () => {

				this.manager.itemEnd( url );

			} );

		this.manager.itemStart( url );

	}

	setResponseType( value ) {

		this.responseType = value;
		return this;

	}

	setMimeType( value ) {

		this.mimeType = value;
		return this;

	}

}

class AnimationLoader extends Loader {

	constructor( manager ) {

		super( manager );

	}

	load( url, onLoad, onProgress, onError ) {

		const scope = this;

		const loader = new FileLoader( this.manager );
		loader.setPath( this.path );
		loader.setRequestHeader( this.requestHeader );
		loader.setWithCredentials( this.withCredentials );
		loader.load( url, function ( text ) {

			try {

				onLoad( scope.parse( JSON.parse( text ) ) );

			} catch ( e ) {

				if ( onError ) {

					onError( e );

				} else {

					console.error( e );

				}

				scope.manager.itemError( url );

			}

		}, onProgress, onError );

	}

	parse( json ) {

		const animations = [];

		for ( let i = 0; i < json.length; i ++ ) {

			const clip = AnimationClip.parse( json[ i ] );

			animations.push( clip );

		}

		return animations;

	}

}

/**
 * Abstract Base class to block based textures loader (dds, pvr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */

class CompressedTextureLoader extends Loader {

	constructor( manager ) {

		super( manager );

	}

	load( url, onLoad, onProgress, onError ) {

		const scope = this;

		const images = [];

		const texture = new CompressedTexture();

		const loader = new FileLoader( this.manager );
		loader.setPath( this.path );
		loader.setResponseType( 'arraybuffer' );
		loader.setRequestHeader( this.requestHeader );
		loader.setWithCredentials( scope.withCredentials );

		let loaded = 0;

		function loadTexture( i ) {

			loader.load( url[ i ], function ( buffer ) {

				const texDatas = scope.parse( buffer, true );

				images[ i ] = {
					width: texDatas.width,
					height: texDatas.height,
					format: texDatas.format,
					mipmaps: texDatas.mipmaps
				};

				loaded += 1;

				if ( loaded === 6 ) {

					if ( texDatas.mipmapCount === 1 ) texture.minFilter = LinearFilter;

					texture.image = images;
					texture.format = texDatas.format;
					texture.needsUpdate = true;

					if ( onLoad ) onLoad( texture );

				}

			}, onProgress, onError );

		}

		if ( Array.isArray( url ) ) {

			for ( let i = 0, il = url.length; i < il; ++ i ) {

				loadTexture( i );

			}

		} else {

			// compressed cubemap texture stored in a single DDS file

			loader.load( url, function ( buffer ) {

				const texDatas = scope.parse( buffer, true );

				if ( texDatas.isCubemap ) {

					const faces = texDatas.mipmaps.length / texDatas.mipmapCount;

					for ( let f = 0; f < faces; f ++ ) {

						images[ f ] = { mipmaps: [] };

						for ( let i = 0; i < texDatas.mipmapCount; i ++ ) {

							images[ f ].mipmaps.push( texDatas.mipmaps[ f * texDatas.mipmapCount + i ] );
							images[ f ].format = texDatas.format;
							images[ f ].width = texDatas.width;
							images[ f ].height = texDatas.height;

						}

					}

					texture.image = images;

				} else {

					texture.image.width = texDatas.width;
					texture.image.height = texDatas.height;
					texture.mipmaps = texDatas.mipmaps;

				}

				if ( texDatas.mipmapCount === 1 ) {

					texture.minFilter = LinearFilter;

				}

				texture.format = texDatas.format;
				texture.needsUpdate = true;

				if ( onLoad ) onLoad( texture );

			}, onProgress, onError );

		}

		return texture;

	}

}

class ImageLoader extends Loader {

	constructor( manager ) {

		super( manager );

	}

	load( url, onLoad, onProgress, onError ) {

		if ( this.path !== undefined ) url = this.path + url;

		url = this.manager.resolveURL( url );

		const scope = this;

		const cached = Cache.get( url );

		if ( cached !== undefined ) {

			scope.manager.itemStart( url );

			setTimeout( function () {

				if ( onLoad ) onLoad( cached );

				scope.manager.itemEnd( url );

			}, 0 );

			return cached;

		}

		const image = createElementNS( 'img' );

		function onImageLoad() {

			removeEventListeners();

			Cache.add( url, this );

			if ( onLoad ) onLoad( this );

			scope.manager.itemEnd( url );

		}

		function onImageError( event ) {

			removeEventListeners();

			if ( onError ) onError( event );

			scope.manager.itemError( url );
			scope.manager.itemEnd( url );

		}

		function removeEventListeners() {

			image.removeEventListener( 'load', onImageLoad, false );
			image.removeEventListener( 'error', onImageError, false );

		}

		image.addEventListener( 'load', onImageLoad, false );
		image.addEventListener( 'error', onImageError, false );

		if ( url.slice( 0, 5 ) !== 'data:' ) {

			if ( this.crossOrigin !== undefined ) image.crossOrigin = this.crossOrigin;

		}

		scope.manager.itemStart( url );

		image.src = url;

		return image;

	}

}

class CubeTextureLoader extends Loader {

	constructor( manager ) {

		super( manager );

	}

	load( urls, onLoad, onProgress, onError ) {

		const texture = new CubeTexture();
		texture.colorSpace = SRGBColorSpace;

		const loader = new ImageLoader( this.manager );
		loader.setCrossOrigin( this.crossOrigin );
		loader.setPath( this.path );

		let loaded = 0;

		function loadTexture( i ) {

			loader.load( urls[ i ], function ( image ) {

				texture.images[ i ] = image;

				loaded ++;

				if ( loaded === 6 ) {

					texture.needsUpdate = true;

					if ( onLoad ) onLoad( texture );

				}

			}, undefined, onError );

		}

		for ( let i = 0; i < urls.length; ++ i ) {

			loadTexture( i );

		}

		return texture;

	}

}

/**
 * Abstract Base class to load generic binary textures formats (rgbe, hdr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */

class DataTextureLoader extends Loader {

	constructor( manager ) {

		super( manager );

	}

	load( url, onLoad, onProgress, onError ) {

		const scope = this;

		const texture = new DataTexture();

		const loader = new FileLoader( this.manager );
		loader.setResponseType( 'arraybuffer' );
		loader.setRequestHeader( this.requestHeader );
		loader.setPath( this.path );
		loader.setWithCredentials( scope.withCredentials );
		loader.load( url, function ( buffer ) {

			let texData;

			try {

				texData = scope.parse( buffer );

			} catch ( error ) {

				if ( onError !== undefined ) {

					onError( error );

				} else {

					console.error( error );
					return;

				}

			}

			if ( texData.image !== undefined ) {

				texture.image = texData.image;

			} else if ( texData.data !== undefined ) {

				texture.image.width = texData.width;
				texture.image.height = texData.height;
				texture.image.data = texData.data;

			}

			texture.wrapS = texData.wrapS !== undefined ? texData.wrapS : ClampToEdgeWrapping;
			texture.wrapT = texData.wrapT !== undefined ? texData.wrapT : ClampToEdgeWrapping;

			texture.magFilter = texData.magFilter !== undefined ? texData.magFilter : LinearFilter;
			texture.minFilter = texData.minFilter !== undefined ? texData.minFilter : LinearFilter;

			texture.anisotropy = texData.anisotropy !== undefined ? texData.anisotropy : 1;

			if ( texData.colorSpace !== undefined ) {

				texture.colorSpace = texData.colorSpace;

			}

			if ( texData.flipY !== undefined ) {

				texture.flipY = texData.flipY;

			}

			if ( texData.format !== undefined ) {

				texture.format = texData.format;

			}

			if ( texData.type !== undefined ) {

				texture.type = texData.type;

			}

			if ( texData.mipmaps !== undefined ) {

				texture.mipmaps = texData.mipmaps;
				texture.minFilter = LinearMipmapLinearFilter; // presumably...

			}

			if ( texData.mipmapCount === 1 ) {

				texture.minFilter = LinearFilter;

			}

			if ( texData.generateMipmaps !== undefined ) {

				texture.generateMipmaps = texData.generateMipmaps;

			}

			texture.needsUpdate = true;

			if ( onLoad ) onLoad( texture, texData );

		}, onProgress, onError );


		return texture;

	}

}

class TextureLoader extends Loader {

	constructor( manager ) {

		super( manager );

	}

	load( url, onLoad, onProgress, onError ) {

		const texture = new Texture();

		const loader = new ImageLoader( this.manager );
		loader.setCrossOrigin( this.crossOrigin );
		loader.setPath( this.path );

		loader.load( url, function ( image ) {

			texture.image = image;
			texture.needsUpdate = true;

			if ( onLoad !== undefined ) {

				onLoad( texture );

			}

		}, onProgress, onError );

		return texture;

	}

}

class Light extends Object3D {

	constructor( color, intensity = 1 ) {

		super();

		this.isLight = true;

		this.type = 'Light';

		this.color = new Color( color );
		this.intensity = intensity;

	}

	dispose() {

		// Empty here in base class; some subclasses override.

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		this.color.copy( source.color );
		this.intensity = source.intensity;

		return this;

	}

	toJSON( meta ) {

		const data = super.toJSON( meta );

		data.object.color = this.color.getHex();
		data.object.intensity = this.intensity;

		if ( this.groundColor !== undefined ) data.object.groundColor = this.groundColor.getHex();

		if ( this.distance !== undefined ) data.object.distance = this.distance;
		if ( this.angle !== undefined ) data.object.angle = this.angle;
		if ( this.decay !== undefined ) data.object.decay = this.decay;
		if ( this.penumbra !== undefined ) data.object.penumbra = this.penumbra;

		if ( this.shadow !== undefined ) data.object.shadow = this.shadow.toJSON();

		return data;

	}

}

class HemisphereLight extends Light {

	constructor( skyColor, groundColor, intensity ) {

		super( skyColor, intensity );

		this.isHemisphereLight = true;

		this.type = 'HemisphereLight';

		this.position.copy( Object3D.DEFAULT_UP );
		this.updateMatrix();

		this.groundColor = new Color( groundColor );

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		this.groundColor.copy( source.groundColor );

		return this;

	}

}

const _projScreenMatrix$1 = /*@__PURE__*/ new Matrix4();
const _lightPositionWorld$1 = /*@__PURE__*/ new Vector3();
const _lookTarget$1 = /*@__PURE__*/ new Vector3();

class LightShadow {

	constructor( camera ) {

		this.camera = camera;

		this.bias = 0;
		this.normalBias = 0;
		this.radius = 1;
		this.blurSamples = 8;

		this.mapSize = new Vector2( 512, 512 );

		this.map = null;
		this.mapPass = null;
		this.matrix = new Matrix4();

		this.autoUpdate = true;
		this.needsUpdate = false;

		this._frustum = new Frustum();
		this._frameExtents = new Vector2( 1, 1 );

		this._viewportCount = 1;

		this._viewports = [

			new Vector4( 0, 0, 1, 1 )

		];

	}

	getViewportCount() {

		return this._viewportCount;

	}

	getFrustum() {

		return this._frustum;

	}

	updateMatrices( light ) {

		const shadowCamera = this.camera;
		const shadowMatrix = this.matrix;

		_lightPositionWorld$1.setFromMatrixPosition( light.matrixWorld );
		shadowCamera.position.copy( _lightPositionWorld$1 );

		_lookTarget$1.setFromMatrixPosition( light.target.matrixWorld );
		shadowCamera.lookAt( _lookTarget$1 );
		shadowCamera.updateMatrixWorld();

		_projScreenMatrix$1.multiplyMatrices( shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse );
		this._frustum.setFromProjectionMatrix( _projScreenMatrix$1 );

		shadowMatrix.set(
			0.5, 0.0, 0.0, 0.5,
			0.0, 0.5, 0.0, 0.5,
			0.0, 0.0, 0.5, 0.5,
			0.0, 0.0, 0.0, 1.0
		);

		shadowMatrix.multiply( _projScreenMatrix$1 );

	}

	getViewport( viewportIndex ) {

		return this._viewports[ viewportIndex ];

	}

	getFrameExtents() {

		return this._frameExtents;

	}

	dispose() {

		if ( this.map ) {

			this.map.dispose();

		}

		if ( this.mapPass ) {

			this.mapPass.dispose();

		}

	}

	copy( source ) {

		this.camera = source.camera.clone();

		this.bias = source.bias;
		this.radius = source.radius;

		this.mapSize.copy( source.mapSize );

		return this;

	}

	clone() {

		return new this.constructor().copy( this );

	}

	toJSON() {

		const object = {};

		if ( this.bias !== 0 ) object.bias = this.bias;
		if ( this.normalBias !== 0 ) object.normalBias = this.normalBias;
		if ( this.radius !== 1 ) object.radius = this.radius;
		if ( this.mapSize.x !== 512 || this.mapSize.y !== 512 ) object.mapSize = this.mapSize.toArray();

		object.camera = this.camera.toJSON( false ).object;
		delete object.camera.matrix;

		return object;

	}

}

class SpotLightShadow extends LightShadow {

	constructor() {

		super( new PerspectiveCamera( 50, 1, 0.5, 500 ) );

		this.isSpotLightShadow = true;

		this.focus = 1;

	}

	updateMatrices( light ) {

		const camera = this.camera;

		const fov = RAD2DEG * 2 * light.angle * this.focus;
		const aspect = this.mapSize.width / this.mapSize.height;
		const far = light.distance || camera.far;

		if ( fov !== camera.fov || aspect !== camera.aspect || far !== camera.far ) {

			camera.fov = fov;
			camera.aspect = aspect;
			camera.far = far;
			camera.updateProjectionMatrix();

		}

		super.updateMatrices( light );

	}

	copy( source ) {

		super.copy( source );

		this.focus = source.focus;

		return this;

	}

}

class SpotLight extends Light {

	constructor( color, intensity, distance = 0, angle = Math.PI / 3, penumbra = 0, decay = 2 ) {

		super( color, intensity );

		this.isSpotLight = true;

		this.type = 'SpotLight';

		this.position.copy( Object3D.DEFAULT_UP );
		this.updateMatrix();

		this.target = new Object3D();

		this.distance = distance;
		this.angle = angle;
		this.penumbra = penumbra;
		this.decay = decay;

		this.map = null;

		this.shadow = new SpotLightShadow();

	}

	get power() {

		// compute the light's luminous power (in lumens) from its intensity (in candela)
		// by convention for a spotlight, luminous power (lm) = π * luminous intensity (cd)
		return this.intensity * Math.PI;

	}

	set power( power ) {

		// set the light's intensity (in candela) from the desired luminous power (in lumens)
		this.intensity = power / Math.PI;

	}

	dispose() {

		this.shadow.dispose();

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		this.distance = source.distance;
		this.angle = source.angle;
		this.penumbra = source.penumbra;
		this.decay = source.decay;

		this.target = source.target.clone();

		this.shadow = source.shadow.clone();

		return this;

	}

}

const _projScreenMatrix = /*@__PURE__*/ new Matrix4();
const _lightPositionWorld = /*@__PURE__*/ new Vector3();
const _lookTarget = /*@__PURE__*/ new Vector3();

class PointLightShadow extends LightShadow {

	constructor() {

		super( new PerspectiveCamera( 90, 1, 0.5, 500 ) );

		this.isPointLightShadow = true;

		this._frameExtents = new Vector2( 4, 2 );

		this._viewportCount = 6;

		this._viewports = [
			// These viewports map a cube-map onto a 2D texture with the
			// following orientation:
			//
			//  xzXZ
			//   y Y
			//
			// X - Positive x direction
			// x - Negative x direction
			// Y - Positive y direction
			// y - Negative y direction
			// Z - Positive z direction
			// z - Negative z direction

			// positive X
			new Vector4( 2, 1, 1, 1 ),
			// negative X
			new Vector4( 0, 1, 1, 1 ),
			// positive Z
			new Vector4( 3, 1, 1, 1 ),
			// negative Z
			new Vector4( 1, 1, 1, 1 ),
			// positive Y
			new Vector4( 3, 0, 1, 1 ),
			// negative Y
			new Vector4( 1, 0, 1, 1 )
		];

		this._cubeDirections = [
			new Vector3( 1, 0, 0 ), new Vector3( - 1, 0, 0 ), new Vector3( 0, 0, 1 ),
			new Vector3( 0, 0, - 1 ), new Vector3( 0, 1, 0 ), new Vector3( 0, - 1, 0 )
		];

		this._cubeUps = [
			new Vector3( 0, 1, 0 ), new Vector3( 0, 1, 0 ), new Vector3( 0, 1, 0 ),
			new Vector3( 0, 1, 0 ), new Vector3( 0, 0, 1 ),	new Vector3( 0, 0, - 1 )
		];

	}

	updateMatrices( light, viewportIndex = 0 ) {

		const camera = this.camera;
		const shadowMatrix = this.matrix;

		const far = light.distance || camera.far;

		if ( far !== camera.far ) {

			camera.far = far;
			camera.updateProjectionMatrix();

		}

		_lightPositionWorld.setFromMatrixPosition( light.matrixWorld );
		camera.position.copy( _lightPositionWorld );

		_lookTarget.copy( camera.position );
		_lookTarget.add( this._cubeDirections[ viewportIndex ] );
		camera.up.copy( this._cubeUps[ viewportIndex ] );
		camera.lookAt( _lookTarget );
		camera.updateMatrixWorld();

		shadowMatrix.makeTranslation( - _lightPositionWorld.x, - _lightPositionWorld.y, - _lightPositionWorld.z );

		_projScreenMatrix.multiplyMatrices( camera.projectionMatrix, camera.matrixWorldInverse );
		this._frustum.setFromProjectionMatrix( _projScreenMatrix );

	}

}

class PointLight extends Light {

	constructor( color, intensity, distance = 0, decay = 2 ) {

		super( color, intensity );

		this.isPointLight = true;

		this.type = 'PointLight';

		this.distance = distance;
		this.decay = decay;

		this.shadow = new PointLightShadow();

	}

	get power() {

		// compute the light's luminous power (in lumens) from its intensity (in candela)
		// for an isotropic light source, luminous power (lm) = 4 π luminous intensity (cd)
		return this.intensity * 4 * Math.PI;

	}

	set power( power ) {

		// set the light's intensity (in candela) from the desired luminous power (in lumens)
		this.intensity = power / ( 4 * Math.PI );

	}

	dispose() {

		this.shadow.dispose();

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		this.distance = source.distance;
		this.decay = source.decay;

		this.shadow = source.shadow.clone();

		return this;

	}

}

class DirectionalLightShadow extends LightShadow {

	constructor() {

		super( new OrthographicCamera( - 5, 5, 5, - 5, 0.5, 500 ) );

		this.isDirectionalLightShadow = true;

	}

}

class DirectionalLight extends Light {

	constructor( color, intensity ) {

		super( color, intensity );

		this.isDirectionalLight = true;

		this.type = 'DirectionalLight';

		this.position.copy( Object3D.DEFAULT_UP );
		this.updateMatrix();

		this.target = new Object3D();

		this.shadow = new DirectionalLightShadow();

	}

	dispose() {

		this.shadow.dispose();

	}

	copy( source ) {

		super.copy( source );

		this.target = source.target.clone();
		this.shadow = source.shadow.clone();

		return this;

	}

}

class AmbientLight extends Light {

	constructor( color, intensity ) {

		super( color, intensity );

		this.isAmbientLight = true;

		this.type = 'AmbientLight';

	}

}

class RectAreaLight extends Light {

	constructor( color, intensity, width = 10, height = 10 ) {

		super( color, intensity );

		this.isRectAreaLight = true;

		this.type = 'RectAreaLight';

		this.width = width;
		this.height = height;

	}

	get power() {

		// compute the light's luminous power (in lumens) from its intensity (in nits)
		return this.intensity * this.width * this.height * Math.PI;

	}

	set power( power ) {

		// set the light's intensity (in nits) from the desired luminous power (in lumens)
		this.intensity = power / ( this.width * this.height * Math.PI );

	}

	copy( source ) {

		super.copy( source );

		this.width = source.width;
		this.height = source.height;

		return this;

	}

	toJSON( meta ) {

		const data = super.toJSON( meta );

		data.object.width = this.width;
		data.object.height = this.height;

		return data;

	}

}

/**
 * Primary reference:
 *   https://graphics.stanford.edu/papers/envmap/envmap.pdf
 *
 * Secondary reference:
 *   https://www.ppsloan.org/publications/StupidSH36.pdf
 */

// 3-band SH defined by 9 coefficients

class SphericalHarmonics3 {

	constructor() {

		this.isSphericalHarmonics3 = true;

		this.coefficients = [];

		for ( let i = 0; i < 9; i ++ ) {

			this.coefficients.push( new Vector3() );

		}

	}

	set( coefficients ) {

		for ( let i = 0; i < 9; i ++ ) {

			this.coefficients[ i ].copy( coefficients[ i ] );

		}

		return this;

	}

	zero() {

		for ( let i = 0; i < 9; i ++ ) {

			this.coefficients[ i ].set( 0, 0, 0 );

		}

		return this;

	}

	// get the radiance in the direction of the normal
	// target is a Vector3
	getAt( normal, target ) {

		// normal is assumed to be unit length

		const x = normal.x, y = normal.y, z = normal.z;

		const coeff = this.coefficients;

		// band 0
		target.copy( coeff[ 0 ] ).multiplyScalar( 0.282095 );

		// band 1
		target.addScaledVector( coeff[ 1 ], 0.488603 * y );
		target.addScaledVector( coeff[ 2 ], 0.488603 * z );
		target.addScaledVector( coeff[ 3 ], 0.488603 * x );

		// band 2
		target.addScaledVector( coeff[ 4 ], 1.092548 * ( x * y ) );
		target.addScaledVector( coeff[ 5 ], 1.092548 * ( y * z ) );
		target.addScaledVector( coeff[ 6 ], 0.315392 * ( 3.0 * z * z - 1.0 ) );
		target.addScaledVector( coeff[ 7 ], 1.092548 * ( x * z ) );
		target.addScaledVector( coeff[ 8 ], 0.546274 * ( x * x - y * y ) );

		return target;

	}

	// get the irradiance (radiance convolved with cosine lobe) in the direction of the normal
	// target is a Vector3
	// https://graphics.stanford.edu/papers/envmap/envmap.pdf
	getIrradianceAt( normal, target ) {

		// normal is assumed to be unit length

		const x = normal.x, y = normal.y, z = normal.z;

		const coeff = this.coefficients;

		// band 0
		target.copy( coeff[ 0 ] ).multiplyScalar( 0.886227 ); // π * 0.282095

		// band 1
		target.addScaledVector( coeff[ 1 ], 2.0 * 0.511664 * y ); // ( 2 * π / 3 ) * 0.488603
		target.addScaledVector( coeff[ 2 ], 2.0 * 0.511664 * z );
		target.addScaledVector( coeff[ 3 ], 2.0 * 0.511664 * x );

		// band 2
		target.addScaledVector( coeff[ 4 ], 2.0 * 0.429043 * x * y ); // ( π / 4 ) * 1.092548
		target.addScaledVector( coeff[ 5 ], 2.0 * 0.429043 * y * z );
		target.addScaledVector( coeff[ 6 ], 0.743125 * z * z - 0.247708 ); // ( π / 4 ) * 0.315392 * 3
		target.addScaledVector( coeff[ 7 ], 2.0 * 0.429043 * x * z );
		target.addScaledVector( coeff[ 8 ], 0.429043 * ( x * x - y * y ) ); // ( π / 4 ) * 0.546274

		return target;

	}

	add( sh ) {

		for ( let i = 0; i < 9; i ++ ) {

			this.coefficients[ i ].add( sh.coefficients[ i ] );

		}

		return this;

	}

	addScaledSH( sh, s ) {

		for ( let i = 0; i < 9; i ++ ) {

			this.coefficients[ i ].addScaledVector( sh.coefficients[ i ], s );

		}

		return this;

	}

	scale( s ) {

		for ( let i = 0; i < 9; i ++ ) {

			this.coefficients[ i ].multiplyScalar( s );

		}

		return this;

	}

	lerp( sh, alpha ) {

		for ( let i = 0; i < 9; i ++ ) {

			this.coefficients[ i ].lerp( sh.coefficients[ i ], alpha );

		}

		return this;

	}

	equals( sh ) {

		for ( let i = 0; i < 9; i ++ ) {

			if ( ! this.coefficients[ i ].equals( sh.coefficients[ i ] ) ) {

				return false;

			}

		}

		return true;

	}

	copy( sh ) {

		return this.set( sh.coefficients );

	}

	clone() {

		return new this.constructor().copy( this );

	}

	fromArray( array, offset = 0 ) {

		const coefficients = this.coefficients;

		for ( let i = 0; i < 9; i ++ ) {

			coefficients[ i ].fromArray( array, offset + ( i * 3 ) );

		}

		return this;

	}

	toArray( array = [], offset = 0 ) {

		const coefficients = this.coefficients;

		for ( let i = 0; i < 9; i ++ ) {

			coefficients[ i ].toArray( array, offset + ( i * 3 ) );

		}

		return array;

	}

	// evaluate the basis functions
	// shBasis is an Array[ 9 ]
	static getBasisAt( normal, shBasis ) {

		// normal is assumed to be unit length

		const x = normal.x, y = normal.y, z = normal.z;

		// band 0
		shBasis[ 0 ] = 0.282095;

		// band 1
		shBasis[ 1 ] = 0.488603 * y;
		shBasis[ 2 ] = 0.488603 * z;
		shBasis[ 3 ] = 0.488603 * x;

		// band 2
		shBasis[ 4 ] = 1.092548 * x * y;
		shBasis[ 5 ] = 1.092548 * y * z;
		shBasis[ 6 ] = 0.315392 * ( 3 * z * z - 1 );
		shBasis[ 7 ] = 1.092548 * x * z;
		shBasis[ 8 ] = 0.546274 * ( x * x - y * y );

	}

}

class LightProbe extends Light {

	constructor( sh = new SphericalHarmonics3(), intensity = 1 ) {

		super( undefined, intensity );

		this.isLightProbe = true;

		this.sh = sh;

	}

	copy( source ) {

		super.copy( source );

		this.sh.copy( source.sh );

		return this;

	}

	fromJSON( json ) {

		this.intensity = json.intensity; // TODO: Move this bit to Light.fromJSON();
		this.sh.fromArray( json.sh );

		return this;

	}

	toJSON( meta ) {

		const data = super.toJSON( meta );

		data.object.sh = this.sh.toArray();

		return data;

	}

}

class MaterialLoader extends Loader {

	constructor( manager ) {

		super( manager );
		this.textures = {};

	}

	load( url, onLoad, onProgress, onError ) {

		const scope = this;

		const loader = new FileLoader( scope.manager );
		loader.setPath( scope.path );
		loader.setRequestHeader( scope.requestHeader );
		loader.setWithCredentials( scope.withCredentials );
		loader.load( url, function ( text ) {

			try {

				onLoad( scope.parse( JSON.parse( text ) ) );

			} catch ( e ) {

				if ( onError ) {

					onError( e );

				} else {

					console.error( e );

				}

				scope.manager.itemError( url );

			}

		}, onProgress, onError );

	}

	parse( json ) {

		const textures = this.textures;

		function getTexture( name ) {

			if ( textures[ name ] === undefined ) {

				console.warn( 'THREE.MaterialLoader: Undefined texture', name );

			}

			return textures[ name ];

		}

		const material = MaterialLoader.createMaterialFromType( json.type );

		if ( json.uuid !== undefined ) material.uuid = json.uuid;
		if ( json.name !== undefined ) material.name = json.name;
		if ( json.color !== undefined && material.color !== undefined ) material.color.setHex( json.color );
		if ( json.roughness !== undefined ) material.roughness = json.roughness;
		if ( json.metalness !== undefined ) material.metalness = json.metalness;
		if ( json.sheen !== undefined ) material.sheen = json.sheen;
		if ( json.sheenColor !== undefined ) material.sheenColor = new Color().setHex( json.sheenColor );
		if ( json.sheenRoughness !== undefined ) material.sheenRoughness = json.sheenRoughness;
		if ( json.emissive !== undefined && material.emissive !== undefined ) material.emissive.setHex( json.emissive );
		if ( json.specular !== undefined && material.specular !== undefined ) material.specular.setHex( json.specular );
		if ( json.specularIntensity !== undefined ) material.specularIntensity = json.specularIntensity;
		if ( json.specularColor !== undefined && material.specularColor !== undefined ) material.specularColor.setHex( json.specularColor );
		if ( json.shininess !== undefined ) material.shininess = json.shininess;
		if ( json.clearcoat !== undefined ) material.clearcoat = json.clearcoat;
		if ( json.clearcoatRoughness !== undefined ) material.clearcoatRoughness = json.clearcoatRoughness;
		if ( json.iridescence !== undefined ) material.iridescence = json.iridescence;
		if ( json.iridescenceIOR !== undefined ) material.iridescenceIOR = json.iridescenceIOR;
		if ( json.iridescenceThicknessRange !== undefined ) material.iridescenceThicknessRange = json.iridescenceThicknessRange;
		if ( json.transmission !== undefined ) material.transmission = json.transmission;
		if ( json.thickness !== undefined ) material.thickness = json.thickness;
		if ( json.attenuationDistance !== undefined ) material.attenuationDistance = json.attenuationDistance;
		if ( json.attenuationColor !== undefined && material.attenuationColor !== undefined ) material.attenuationColor.setHex( json.attenuationColor );
		if ( json.anisotropy !== undefined ) material.anisotropy = json.anisotropy;
		if ( json.anisotropyRotation !== undefined ) material.anisotropyRotation = json.anisotropyRotation;
		if ( json.fog !== undefined ) material.fog = json.fog;
		if ( json.flatShading !== undefined ) material.flatShading = json.flatShading;
		if ( json.blending !== undefined ) material.blending = json.blending;
		if ( json.combine !== undefined ) material.combine = json.combine;
		if ( json.side !== undefined ) material.side = json.side;
		if ( json.shadowSide !== undefined ) material.shadowSide = json.shadowSide;
		if ( json.opacity !== undefined ) material.opacity = json.opacity;
		if ( json.transparent !== undefined ) material.transparent = json.transparent;
		if ( json.alphaTest !== undefined ) material.alphaTest = json.alphaTest;
		if ( json.alphaHash !== undefined ) material.alphaHash = json.alphaHash;
		if ( json.depthFunc !== undefined ) material.depthFunc = json.depthFunc;
		if ( json.depthTest !== undefined ) material.depthTest = json.depthTest;
		if ( json.depthWrite !== undefined ) material.depthWrite = json.depthWrite;
		if ( json.colorWrite !== undefined ) material.colorWrite = json.colorWrite;
		if ( json.blendSrc !== undefined ) material.blendSrc = json.blendSrc;
		if ( json.blendDst !== undefined ) material.blendDst = json.blendDst;
		if ( json.blendEquation !== undefined ) material.blendEquation = json.blendEquation;
		if ( json.blendSrcAlpha !== undefined ) material.blendSrcAlpha = json.blendSrcAlpha;
		if ( json.blendDstAlpha !== undefined ) material.blendDstAlpha = json.blendDstAlpha;
		if ( json.blendEquationAlpha !== undefined ) material.blendEquationAlpha = json.blendEquationAlpha;
		if ( json.blendColor !== undefined && material.blendColor !== undefined ) material.blendColor.setHex( json.blendColor );
		if ( json.blendAlpha !== undefined ) material.blendAlpha = json.blendAlpha;
		if ( json.stencilWriteMask !== undefined ) material.stencilWriteMask = json.stencilWriteMask;
		if ( json.stencilFunc !== undefined ) material.stencilFunc = json.stencilFunc;
		if ( json.stencilRef !== undefined ) material.stencilRef = json.stencilRef;
		if ( json.stencilFuncMask !== undefined ) material.stencilFuncMask = json.stencilFuncMask;
		if ( json.stencilFail !== undefined ) material.stencilFail = json.stencilFail;
		if ( json.stencilZFail !== undefined ) material.stencilZFail = json.stencilZFail;
		if ( json.stencilZPass !== undefined ) material.stencilZPass = json.stencilZPass;
		if ( json.stencilWrite !== undefined ) material.stencilWrite = json.stencilWrite;

		if ( json.wireframe !== undefined ) material.wireframe = json.wireframe;
		if ( json.wireframeLinewidth !== undefined ) material.wireframeLinewidth = json.wireframeLinewidth;
		if ( json.wireframeLinecap !== undefined ) material.wireframeLinecap = json.wireframeLinecap;
		if ( json.wireframeLinejoin !== undefined ) material.wireframeLinejoin = json.wireframeLinejoin;

		if ( json.rotation !== undefined ) material.rotation = json.rotation;

		if ( json.linewidth !== undefined ) material.linewidth = json.linewidth;
		if ( json.dashSize !== undefined ) material.dashSize = json.dashSize;
		if ( json.gapSize !== undefined ) material.gapSize = json.gapSize;
		if ( json.scale !== undefined ) material.scale = json.scale;

		if ( json.polygonOffset !== undefined ) material.polygonOffset = json.polygonOffset;
		if ( json.polygonOffsetFactor !== undefined ) material.polygonOffsetFactor = json.polygonOffsetFactor;
		if ( json.polygonOffsetUnits !== undefined ) material.polygonOffsetUnits = json.polygonOffsetUnits;

		if ( json.dithering !== undefined ) material.dithering = json.dithering;

		if ( json.alphaToCoverage !== undefined ) material.alphaToCoverage = json.alphaToCoverage;
		if ( json.premultipliedAlpha !== undefined ) material.premultipliedAlpha = json.premultipliedAlpha;
		if ( json.forceSinglePass !== undefined ) material.forceSinglePass = json.forceSinglePass;

		if ( json.visible !== undefined ) material.visible = json.visible;

		if ( json.toneMapped !== undefined ) material.toneMapped = json.toneMapped;

		if ( json.userData !== undefined ) material.userData = json.userData;

		if ( json.vertexColors !== undefined ) {

			if ( typeof json.vertexColors === 'number' ) {

				material.vertexColors = ( json.vertexColors > 0 ) ? true : false;

			} else {

				material.vertexColors = json.vertexColors;

			}

		}

		// Shader Material

		if ( json.uniforms !== undefined ) {

			for ( const name in json.uniforms ) {

				const uniform = json.uniforms[ name ];

				material.uniforms[ name ] = {};

				switch ( uniform.type ) {

					case 't':
						material.uniforms[ name ].value = getTexture( uniform.value );
						break;

					case 'c':
						material.uniforms[ name ].value = new Color().setHex( uniform.value );
						break;

					case 'v2':
						material.uniforms[ name ].value = new Vector2().fromArray( uniform.value );
						break;

					case 'v3':
						material.uniforms[ name ].value = new Vector3().fromArray( uniform.value );
						break;

					case 'v4':
						material.uniforms[ name ].value = new Vector4().fromArray( uniform.value );
						break;

					case 'm3':
						material.uniforms[ name ].value = new Matrix3().fromArray( uniform.value );
						break;

					case 'm4':
						material.uniforms[ name ].value = new Matrix4().fromArray( uniform.value );
						break;

					default:
						material.uniforms[ name ].value = uniform.value;

				}

			}

		}

		if ( json.defines !== undefined ) material.defines = json.defines;
		if ( json.vertexShader !== undefined ) material.vertexShader = json.vertexShader;
		if ( json.fragmentShader !== undefined ) material.fragmentShader = json.fragmentShader;
		if ( json.glslVersion !== undefined ) material.glslVersion = json.glslVersion;

		if ( json.extensions !== undefined ) {

			for ( const key in json.extensions ) {

				material.extensions[ key ] = json.extensions[ key ];

			}

		}

		if ( json.lights !== undefined ) material.lights = json.lights;
		if ( json.clipping !== undefined ) material.clipping = json.clipping;

		// for PointsMaterial

		if ( json.size !== undefined ) material.size = json.size;
		if ( json.sizeAttenuation !== undefined ) material.sizeAttenuation = json.sizeAttenuation;

		// maps

		if ( json.map !== undefined ) material.map = getTexture( json.map );
		if ( json.matcap !== undefined ) material.matcap = getTexture( json.matcap );

		if ( json.alphaMap !== undefined ) material.alphaMap = getTexture( json.alphaMap );

		if ( json.bumpMap !== undefined ) material.bumpMap = getTexture( json.bumpMap );
		if ( json.bumpScale !== undefined ) material.bumpScale = json.bumpScale;

		if ( json.normalMap !== undefined ) material.normalMap = getTexture( json.normalMap );
		if ( json.normalMapType !== undefined ) material.normalMapType = json.normalMapType;
		if ( json.normalScale !== undefined ) {

			let normalScale = json.normalScale;

			if ( Array.isArray( normalScale ) === false ) {

				// Blender exporter used to export a scalar. See #7459

				normalScale = [ normalScale, normalScale ];

			}

			material.normalScale = new Vector2().fromArray( normalScale );

		}

		if ( json.displacementMap !== undefined ) material.displacementMap = getTexture( json.displacementMap );
		if ( json.displacementScale !== undefined ) material.displacementScale = json.displacementScale;
		if ( json.displacementBias !== undefined ) material.displacementBias = json.displacementBias;

		if ( json.roughnessMap !== undefined ) material.roughnessMap = getTexture( json.roughnessMap );
		if ( json.metalnessMap !== undefined ) material.metalnessMap = getTexture( json.metalnessMap );

		if ( json.emissiveMap !== undefined ) material.emissiveMap = getTexture( json.emissiveMap );
		if ( json.emissiveIntensity !== undefined ) material.emissiveIntensity = json.emissiveIntensity;

		if ( json.specularMap !== undefined ) material.specularMap = getTexture( json.specularMap );
		if ( json.specularIntensityMap !== undefined ) material.specularIntensityMap = getTexture( json.specularIntensityMap );
		if ( json.specularColorMap !== undefined ) material.specularColorMap = getTexture( json.specularColorMap );

		if ( json.envMap !== undefined ) material.envMap = getTexture( json.envMap );
		if ( json.envMapRotation !== undefined ) material.envMapRotation.fromArray( json.envMapRotation );
		if ( json.envMapIntensity !== undefined ) material.envMapIntensity = json.envMapIntensity;

		if ( json.reflectivity !== undefined ) material.reflectivity = json.reflectivity;
		if ( json.refractionRatio !== undefined ) material.refractionRatio = json.refractionRatio;

		if ( json.lightMap !== undefined ) material.lightMap = getTexture( json.lightMap );
		if ( json.lightMapIntensity !== undefined ) material.lightMapIntensity = json.lightMapIntensity;

		if ( json.aoMap !== undefined ) material.aoMap = getTexture( json.aoMap );
		if ( json.aoMapIntensity !== undefined ) material.aoMapIntensity = json.aoMapIntensity;

		if ( json.gradientMap !== undefined ) material.gradientMap = getTexture( json.gradientMap );

		if ( json.clearcoatMap !== undefined ) material.clearcoatMap = getTexture( json.clearcoatMap );
		if ( json.clearcoatRoughnessMap !== undefined ) material.clearcoatRoughnessMap = getTexture( json.clearcoatRoughnessMap );
		if ( json.clearcoatNormalMap !== undefined ) material.clearcoatNormalMap = getTexture( json.clearcoatNormalMap );
		if ( json.clearcoatNormalScale !== undefined ) material.clearcoatNormalScale = new Vector2().fromArray( json.clearcoatNormalScale );

		if ( json.iridescenceMap !== undefined ) material.iridescenceMap = getTexture( json.iridescenceMap );
		if ( json.iridescenceThicknessMap !== undefined ) material.iridescenceThicknessMap = getTexture( json.iridescenceThicknessMap );

		if ( json.transmissionMap !== undefined ) material.transmissionMap = getTexture( json.transmissionMap );
		if ( json.thicknessMap !== undefined ) material.thicknessMap = getTexture( json.thicknessMap );

		if ( json.anisotropyMap !== undefined ) material.anisotropyMap = getTexture( json.anisotropyMap );

		if ( json.sheenColorMap !== undefined ) material.sheenColorMap = getTexture( json.sheenColorMap );
		if ( json.sheenRoughnessMap !== undefined ) material.sheenRoughnessMap = getTexture( json.sheenRoughnessMap );

		return material;

	}

	setTextures( value ) {

		this.textures = value;
		return this;

	}

	static createMaterialFromType( type ) {

		const materialLib = {
			ShadowMaterial,
			SpriteMaterial,
			RawShaderMaterial,
			ShaderMaterial,
			PointsMaterial,
			MeshPhysicalMaterial,
			MeshStandardMaterial,
			MeshPhongMaterial,
			MeshToonMaterial,
			MeshNormalMaterial,
			MeshLambertMaterial,
			MeshDepthMaterial,
			MeshDistanceMaterial,
			MeshBasicMaterial,
			MeshMatcapMaterial,
			LineDashedMaterial,
			LineBasicMaterial,
			Material
		};

		return new materialLib[ type ]();

	}

}

class LoaderUtils {

	static decodeText( array ) {

		if ( typeof TextDecoder !== 'undefined' ) {

			return new TextDecoder().decode( array );

		}

		// Avoid the String.fromCharCode.apply(null, array) shortcut, which
		// throws a "maximum call stack size exceeded" error for large arrays.

		let s = '';

		for ( let i = 0, il = array.length; i < il; i ++ ) {

			// Implicitly assumes little-endian.
			s += String.fromCharCode( array[ i ] );

		}

		try {

			// merges multi-byte utf-8 characters.

			return decodeURIComponent( escape( s ) );

		} catch ( e ) { // see #16358

			return s;

		}

	}

	static extractUrlBase( url ) {

		const index = url.lastIndexOf( '/' );

		if ( index === - 1 ) return './';

		return url.slice( 0, index + 1 );

	}

	static resolveURL( url, path ) {

		// Invalid URL
		if ( typeof url !== 'string' || url === '' ) return '';

		// Host Relative URL
		if ( /^https?:\/\//i.test( path ) && /^\//.test( url ) ) {

			path = path.replace( /(^https?:\/\/[^\/]+).*/i, '$1' );

		}

		// Absolute URL http://,https://,//
		if ( /^(https?:)?\/\//i.test( url ) ) return url;

		// Data URI
		if ( /^data:.*,.*$/i.test( url ) ) return url;

		// Blob URL
		if ( /^blob:.*$/i.test( url ) ) return url;

		// Relative URL
		return path + url;

	}

}

class InstancedBufferGeometry extends BufferGeometry {

	constructor() {

		super();

		this.isInstancedBufferGeometry = true;

		this.type = 'InstancedBufferGeometry';
		this.instanceCount = Infinity;

	}

	copy( source ) {

		super.copy( source );

		this.instanceCount = source.instanceCount;

		return this;

	}

	toJSON() {

		const data = super.toJSON();

		data.instanceCount = this.instanceCount;

		data.isInstancedBufferGeometry = true;

		return data;

	}

}

class BufferGeometryLoader extends Loader {

	constructor( manager ) {

		super( manager );

	}

	load( url, onLoad, onProgress, onError ) {

		const scope = this;

		const loader = new FileLoader( scope.manager );
		loader.setPath( scope.path );
		loader.setRequestHeader( scope.requestHeader );
		loader.setWithCredentials( scope.withCredentials );
		loader.load( url, function ( text ) {

			try {

				onLoad( scope.parse( JSON.parse( text ) ) );

			} catch ( e ) {

				if ( onError ) {

					onError( e );

				} else {

					console.error( e );

				}

				scope.manager.itemError( url );

			}

		}, onProgress, onError );

	}

	parse( json ) {

		const interleavedBufferMap = {};
		const arrayBufferMap = {};

		function getInterleavedBuffer( json, uuid ) {

			if ( interleavedBufferMap[ uuid ] !== undefined ) return interleavedBufferMap[ uuid ];

			const interleavedBuffers = json.interleavedBuffers;
			const interleavedBuffer = interleavedBuffers[ uuid ];

			const buffer = getArrayBuffer( json, interleavedBuffer.buffer );

			const array = getTypedArray( interleavedBuffer.type, buffer );
			const ib = new InterleavedBuffer( array, interleavedBuffer.stride );
			ib.uuid = interleavedBuffer.uuid;

			interleavedBufferMap[ uuid ] = ib;

			return ib;

		}

		function getArrayBuffer( json, uuid ) {

			if ( arrayBufferMap[ uuid ] !== undefined ) return arrayBufferMap[ uuid ];

			const arrayBuffers = json.arrayBuffers;
			const arrayBuffer = arrayBuffers[ uuid ];

			const ab = new Uint32Array( arrayBuffer ).buffer;

			arrayBufferMap[ uuid ] = ab;

			return ab;

		}

		const geometry = json.isInstancedBufferGeometry ? new InstancedBufferGeometry() : new BufferGeometry();

		const index = json.data.index;

		if ( index !== undefined ) {

			const typedArray = getTypedArray( index.type, index.array );
			geometry.setIndex( new BufferAttribute( typedArray, 1 ) );

		}

		const attributes = json.data.attributes;

		for ( const key in attributes ) {

			const attribute = attributes[ key ];
			let bufferAttribute;

			if ( attribute.isInterleavedBufferAttribute ) {

				const interleavedBuffer = getInterleavedBuffer( json.data, attribute.data );
				bufferAttribute = new InterleavedBufferAttribute( interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized );

			} else {

				const typedArray = getTypedArray( attribute.type, attribute.array );
				const bufferAttributeConstr = attribute.isInstancedBufferAttribute ? InstancedBufferAttribute : BufferAttribute;
				bufferAttribute = new bufferAttributeConstr( typedArray, attribute.itemSize, attribute.normalized );

			}

			if ( attribute.name !== undefined ) bufferAttribute.name = attribute.name;
			if ( attribute.usage !== undefined ) bufferAttribute.setUsage( attribute.usage );

			geometry.setAttribute( key, bufferAttribute );

		}

		const morphAttributes = json.data.morphAttributes;

		if ( morphAttributes ) {

			for ( const key in morphAttributes ) {

				const attributeArray = morphAttributes[ key ];

				const array = [];

				for ( let i = 0, il = attributeArray.length; i < il; i ++ ) {

					const attribute = attributeArray[ i ];
					let bufferAttribute;

					if ( attribute.isInterleavedBufferAttribute ) {

						const interleavedBuffer = getInterleavedBuffer( json.data, attribute.data );
						bufferAttribute = new InterleavedBufferAttribute( interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized );

					} else {

						const typedArray = getTypedArray( attribute.type, attribute.array );
						bufferAttribute = new BufferAttribute( typedArray, attribute.itemSize, attribute.normalized );

					}

					if ( attribute.name !== undefined ) bufferAttribute.name = attribute.name;
					array.push( bufferAttribute );

				}

				geometry.morphAttributes[ key ] = array;

			}

		}

		const morphTargetsRelative = json.data.morphTargetsRelative;

		if ( morphTargetsRelative ) {

			geometry.morphTargetsRelative = true;

		}

		const groups = json.data.groups || json.data.drawcalls || json.data.offsets;

		if ( groups !== undefined ) {

			for ( let i = 0, n = groups.length; i !== n; ++ i ) {

				const group = groups[ i ];

				geometry.addGroup( group.start, group.count, group.materialIndex );

			}

		}

		const boundingSphere = json.data.boundingSphere;

		if ( boundingSphere !== undefined ) {

			const center = new Vector3();

			if ( boundingSphere.center !== undefined ) {

				center.fromArray( boundingSphere.center );

			}

			geometry.boundingSphere = new Sphere( center, boundingSphere.radius );

		}

		if ( json.name ) geometry.name = json.name;
		if ( json.userData ) geometry.userData = json.userData;

		return geometry;

	}

}

class ObjectLoader extends Loader {

	constructor( manager ) {

		super( manager );

	}

	load( url, onLoad, onProgress, onError ) {

		const scope = this;

		const path = ( this.path === '' ) ? LoaderUtils.extractUrlBase( url ) : this.path;
		this.resourcePath = this.resourcePath || path;

		const loader = new FileLoader( this.manager );
		loader.setPath( this.path );
		loader.setRequestHeader( this.requestHeader );
		loader.setWithCredentials( this.withCredentials );
		loader.load( url, function ( text ) {

			let json = null;

			try {

				json = JSON.parse( text );

			} catch ( error ) {

				if ( onError !== undefined ) onError( error );

				console.error( 'THREE:ObjectLoader: Can\'t parse ' + url + '.', error.message );

				return;

			}

			const metadata = json.metadata;

			if ( metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry' ) {

				if ( onError !== undefined ) onError( new Error( 'THREE.ObjectLoader: Can\'t load ' + url ) );

				console.error( 'THREE.ObjectLoader: Can\'t load ' + url );
				return;

			}

			scope.parse( json, onLoad );

		}, onProgress, onError );

	}

	async loadAsync( url, onProgress ) {

		const scope = this;

		const path = ( this.path === '' ) ? LoaderUtils.extractUrlBase( url ) : this.path;
		this.resourcePath = this.resourcePath || path;

		const loader = new FileLoader( this.manager );
		loader.setPath( this.path );
		loader.setRequestHeader( this.requestHeader );
		loader.setWithCredentials( this.withCredentials );

		const text = await loader.loadAsync( url, onProgress );

		const json = JSON.parse( text );

		const metadata = json.metadata;

		if ( metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry' ) {

			throw new Error( 'THREE.ObjectLoader: Can\'t load ' + url );

		}

		return await scope.parseAsync( json );

	}

	parse( json, onLoad ) {

		const animations = this.parseAnimations( json.animations );
		const shapes = this.parseShapes( json.shapes );
		const geometries = this.parseGeometries( json.geometries, shapes );

		const images = this.parseImages( json.images, function () {

			if ( onLoad !== undefined ) onLoad( object );

		} );

		const textures = this.parseTextures( json.textures, images );
		const materials = this.parseMaterials( json.materials, textures );

		const object = this.parseObject( json.object, geometries, materials, textures, animations );
		const skeletons = this.parseSkeletons( json.skeletons, object );

		this.bindSkeletons( object, skeletons );

		//

		if ( onLoad !== undefined ) {

			let hasImages = false;

			for ( const uuid in images ) {

				if ( images[ uuid ].data instanceof HTMLImageElement ) {

					hasImages = true;
					break;

				}

			}

			if ( hasImages === false ) onLoad( object );

		}

		return object;

	}

	async parseAsync( json ) {

		const animations = this.parseAnimations( json.animations );
		const shapes = this.parseShapes( json.shapes );
		const geometries = this.parseGeometries( json.geometries, shapes );

		const images = await this.parseImagesAsync( json.images );

		const textures = this.parseTextures( json.textures, images );
		const materials = this.parseMaterials( json.materials, textures );

		const object = this.parseObject( json.object, geometries, materials, textures, animations );
		const skeletons = this.parseSkeletons( json.skeletons, object );

		this.bindSkeletons( object, skeletons );

		return object;

	}

	parseShapes( json ) {

		const shapes = {};

		if ( json !== undefined ) {

			for ( let i = 0, l = json.length; i < l; i ++ ) {

				const shape = new Shape().fromJSON( json[ i ] );

				shapes[ shape.uuid ] = shape;

			}

		}

		return shapes;

	}

	parseSkeletons( json, object ) {

		const skeletons = {};
		const bones = {};

		// generate bone lookup table

		object.traverse( function ( child ) {

			if ( child.isBone ) bones[ child.uuid ] = child;

		} );

		// create skeletons

		if ( json !== undefined ) {

			for ( let i = 0, l = json.length; i < l; i ++ ) {

				const skeleton = new Skeleton().fromJSON( json[ i ], bones );

				skeletons[ skeleton.uuid ] = skeleton;

			}

		}

		return skeletons;

	}

	parseGeometries( json, shapes ) {

		const geometries = {};

		if ( json !== undefined ) {

			const bufferGeometryLoader = new BufferGeometryLoader();

			for ( let i = 0, l = json.length; i < l; i ++ ) {

				let geometry;
				const data = json[ i ];

				switch ( data.type ) {

					case 'BufferGeometry':
					case 'InstancedBufferGeometry':

						geometry = bufferGeometryLoader.parse( data );
						break;

					default:

						if ( data.type in Geometries ) {

							geometry = Geometries[ data.type ].fromJSON( data, shapes );

						} else {

							console.warn( `THREE.ObjectLoader: Unsupported geometry type "${ data.type }"` );

						}

				}

				geometry.uuid = data.uuid;

				if ( data.name !== undefined ) geometry.name = data.name;
				if ( data.userData !== undefined ) geometry.userData = data.userData;

				geometries[ data.uuid ] = geometry;

			}

		}

		return geometries;

	}

	parseMaterials( json, textures ) {

		const cache = {}; // MultiMaterial
		const materials = {};

		if ( json !== undefined ) {

			const loader = new MaterialLoader();
			loader.setTextures( textures );

			for ( let i = 0, l = json.length; i < l; i ++ ) {

				const data = json[ i ];

				if ( cache[ data.uuid ] === undefined ) {

					cache[ data.uuid ] = loader.parse( data );

				}

				materials[ data.uuid ] = cache[ data.uuid ];

			}

		}

		return materials;

	}

	parseAnimations( json ) {

		const animations = {};

		if ( json !== undefined ) {

			for ( let i = 0; i < json.length; i ++ ) {

				const data = json[ i ];

				const clip = AnimationClip.parse( data );

				animations[ clip.uuid ] = clip;

			}

		}

		return animations;

	}

	parseImages( json, onLoad ) {

		const scope = this;
		const images = {};

		let loader;

		function loadImage( url ) {

			scope.manager.itemStart( url );

			return loader.load( url, function () {

				scope.manager.itemEnd( url );

			}, undefined, function () {

				scope.manager.itemError( url );
				scope.manager.itemEnd( url );

			} );

		}

		function deserializeImage( image ) {

			if ( typeof image === 'string' ) {

				const url = image;

				const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test( url ) ? url : scope.resourcePath + url;

				return loadImage( path );

			} else {

				if ( image.data ) {

					return {
						data: getTypedArray( image.type, image.data ),
						width: image.width,
						height: image.height
					};

				} else {

					return null;

				}

			}

		}

		if ( json !== undefined && json.length > 0 ) {

			const manager = new LoadingManager( onLoad );

			loader = new ImageLoader( manager );
			loader.setCrossOrigin( this.crossOrigin );

			for ( let i = 0, il = json.length; i < il; i ++ ) {

				const image = json[ i ];
				const url = image.url;

				if ( Array.isArray( url ) ) {

					// load array of images e.g CubeTexture

					const imageArray = [];

					for ( let j = 0, jl = url.length; j < jl; j ++ ) {

						const currentUrl = url[ j ];

						const deserializedImage = deserializeImage( currentUrl );

						if ( deserializedImage !== null ) {

							if ( deserializedImage instanceof HTMLImageElement ) {

								imageArray.push( deserializedImage );

							} else {

								// special case: handle array of data textures for cube textures

								imageArray.push( new DataTexture( deserializedImage.data, deserializedImage.width, deserializedImage.height ) );

							}

						}

					}

					images[ image.uuid ] = new Source( imageArray );

				} else {

					// load single image

					const deserializedImage = deserializeImage( image.url );
					images[ image.uuid ] = new Source( deserializedImage );


				}

			}

		}

		return images;

	}

	async parseImagesAsync( json ) {

		const scope = this;
		const images = {};

		let loader;

		async function deserializeImage( image ) {

			if ( typeof image === 'string' ) {

				const url = image;

				const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test( url ) ? url : scope.resourcePath + url;

				return await loader.loadAsync( path );

			} else {

				if ( image.data ) {

					return {
						data: getTypedArray( image.type, image.data ),
						width: image.width,
						height: image.height
					};

				} else {

					return null;

				}

			}

		}

		if ( json !== undefined && json.length > 0 ) {

			loader = new ImageLoader( this.manager );
			loader.setCrossOrigin( this.crossOrigin );

			for ( let i = 0, il = json.length; i < il; i ++ ) {

				const image = json[ i ];
				const url = image.url;

				if ( Array.isArray( url ) ) {

					// load array of images e.g CubeTexture

					const imageArray = [];

					for ( let j = 0, jl = url.length; j < jl; j ++ ) {

						const currentUrl = url[ j ];

						const deserializedImage = await deserializeImage( currentUrl );

						if ( deserializedImage !== null ) {

							if ( deserializedImage instanceof HTMLImageElement ) {

								imageArray.push( deserializedImage );

							} else {

								// special case: handle array of data textures for cube textures

								imageArray.push( new DataTexture( deserializedImage.data, deserializedImage.width, deserializedImage.height ) );

							}

						}

					}

					images[ image.uuid ] = new Source( imageArray );

				} else {

					// load single image

					const deserializedImage = await deserializeImage( image.url );
					images[ image.uuid ] = new Source( deserializedImage );

				}

			}

		}

		return images;

	}

	parseTextures( json, images ) {

		function parseConstant( value, type ) {

			if ( typeof value === 'number' ) return value;

			console.warn( 'THREE.ObjectLoader.parseTexture: Constant should be in numeric form.', value );

			return type[ value ];

		}

		const textures = {};

		if ( json !== undefined ) {

			for ( let i = 0, l = json.length; i < l; i ++ ) {

				const data = json[ i ];

				if ( data.image === undefined ) {

					console.warn( 'THREE.ObjectLoader: No "image" specified for', data.uuid );

				}

				if ( images[ data.image ] === undefined ) {

					console.warn( 'THREE.ObjectLoader: Undefined image', data.image );

				}

				const source = images[ data.image ];
				const image = source.data;

				let texture;

				if ( Array.isArray( image ) ) {

					texture = new CubeTexture();

					if ( image.length === 6 ) texture.needsUpdate = true;

				} else {

					if ( image && image.data ) {

						texture = new DataTexture();

					} else {

						texture = new Texture();

					}

					if ( image ) texture.needsUpdate = true; // textures can have undefined image data

				}

				texture.source = source;

				texture.uuid = data.uuid;

				if ( data.name !== undefined ) texture.name = data.name;

				if ( data.mapping !== undefined ) texture.mapping = parseConstant( data.mapping, TEXTURE_MAPPING );
				if ( data.channel !== undefined ) texture.channel = data.channel;

				if ( data.offset !== undefined ) texture.offset.fromArray( data.offset );
				if ( data.repeat !== undefined ) texture.repeat.fromArray( data.repeat );
				if ( data.center !== undefined ) texture.center.fromArray( data.center );
				if ( data.rotation !== undefined ) texture.rotation = data.rotation;

				if ( data.wrap !== undefined ) {

					texture.wrapS = parseConstant( data.wrap[ 0 ], TEXTURE_WRAPPING );
					texture.wrapT = parseConstant( data.wrap[ 1 ], TEXTURE_WRAPPING );

				}

				if ( data.format !== undefined ) texture.format = data.format;
				if ( data.internalFormat !== undefined ) texture.internalFormat = data.internalFormat;
				if ( data.type !== undefined ) texture.type = data.type;
				if ( data.colorSpace !== undefined ) texture.colorSpace = data.colorSpace;

				if ( data.minFilter !== undefined ) texture.minFilter = parseConstant( data.minFilter, TEXTURE_FILTER );
				if ( data.magFilter !== undefined ) texture.magFilter = parseConstant( data.magFilter, TEXTURE_FILTER );
				if ( data.anisotropy !== undefined ) texture.anisotropy = data.anisotropy;

				if ( data.flipY !== undefined ) texture.flipY = data.flipY;

				if ( data.generateMipmaps !== undefined ) texture.generateMipmaps = data.generateMipmaps;
				if ( data.premultiplyAlpha !== undefined ) texture.premultiplyAlpha = data.premultiplyAlpha;
				if ( data.unpackAlignment !== undefined ) texture.unpackAlignment = data.unpackAlignment;
				if ( data.compareFunction !== undefined ) texture.compareFunction = data.compareFunction;

				if ( data.userData !== undefined ) texture.userData = data.userData;

				textures[ data.uuid ] = texture;

			}

		}

		return textures;

	}

	parseObject( data, geometries, materials, textures, animations ) {

		let object;

		function getGeometry( name ) {

			if ( geometries[ name ] === undefined ) {

				console.warn( 'THREE.ObjectLoader: Undefined geometry', name );

			}

			return geometries[ name ];

		}

		function getMaterial( name ) {

			if ( name === undefined ) return undefined;

			if ( Array.isArray( name ) ) {

				const array = [];

				for ( let i = 0, l = name.length; i < l; i ++ ) {

					const uuid = name[ i ];

					if ( materials[ uuid ] === undefined ) {

						console.warn( 'THREE.ObjectLoader: Undefined material', uuid );

					}

					array.push( materials[ uuid ] );

				}

				return array;

			}

			if ( materials[ name ] === undefined ) {

				console.warn( 'THREE.ObjectLoader: Undefined material', name );

			}

			return materials[ name ];

		}

		function getTexture( uuid ) {

			if ( textures[ uuid ] === undefined ) {

				console.warn( 'THREE.ObjectLoader: Undefined texture', uuid );

			}

			return textures[ uuid ];

		}

		let geometry, material;

		switch ( data.type ) {

			case 'Scene':

				object = new Scene();

				if ( data.background !== undefined ) {

					if ( Number.isInteger( data.background ) ) {

						object.background = new Color( data.background );

					} else {

						object.background = getTexture( data.background );

					}

				}

				if ( data.environment !== undefined ) {

					object.environment = getTexture( data.environment );

				}

				if ( data.fog !== undefined ) {

					if ( data.fog.type === 'Fog' ) {

						object.fog = new Fog( data.fog.color, data.fog.near, data.fog.far );

					} else if ( data.fog.type === 'FogExp2' ) {

						object.fog = new FogExp2( data.fog.color, data.fog.density );

					}

					if ( data.fog.name !== '' ) {

						object.fog.name = data.fog.name;

					}

				}

				if ( data.backgroundBlurriness !== undefined ) object.backgroundBlurriness = data.backgroundBlurriness;
				if ( data.backgroundIntensity !== undefined ) object.backgroundIntensity = data.backgroundIntensity;
				if ( data.backgroundRotation !== undefined ) object.backgroundRotation.fromArray( data.backgroundRotation );

				if ( data.environmentIntensity !== undefined ) object.environmentIntensity = data.environmentIntensity;
				if ( data.environmentRotation !== undefined ) object.environmentRotation.fromArray( data.environmentRotation );

				break;

			case 'PerspectiveCamera':

				object = new PerspectiveCamera( data.fov, data.aspect, data.near, data.far );

				if ( data.focus !== undefined ) object.focus = data.focus;
				if ( data.zoom !== undefined ) object.zoom = data.zoom;
				if ( data.filmGauge !== undefined ) object.filmGauge = data.filmGauge;
				if ( data.filmOffset !== undefined ) object.filmOffset = data.filmOffset;
				if ( data.view !== undefined ) object.view = Object.assign( {}, data.view );

				break;

			case 'OrthographicCamera':

				object = new OrthographicCamera( data.left, data.right, data.top, data.bottom, data.near, data.far );

				if ( data.zoom !== undefined ) object.zoom = data.zoom;
				if ( data.view !== undefined ) object.view = Object.assign( {}, data.view );

				break;

			case 'AmbientLight':

				object = new AmbientLight( data.color, data.intensity );

				break;

			case 'DirectionalLight':

				object = new DirectionalLight( data.color, data.intensity );

				break;

			case 'PointLight':

				object = new PointLight( data.color, data.intensity, data.distance, data.decay );

				break;

			case 'RectAreaLight':

				object = new RectAreaLight( data.color, data.intensity, data.width, data.height );

				break;

			case 'SpotLight':

				object = new SpotLight( data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay );

				break;

			case 'HemisphereLight':

				object = new HemisphereLight( data.color, data.groundColor, data.intensity );

				break;

			case 'LightProbe':

				object = new LightProbe().fromJSON( data );

				break;

			case 'SkinnedMesh':

				geometry = getGeometry( data.geometry );
			 	material = getMaterial( data.material );

				object = new SkinnedMesh( geometry, material );

				if ( data.bindMode !== undefined ) object.bindMode = data.bindMode;
				if ( data.bindMatrix !== undefined ) object.bindMatrix.fromArray( data.bindMatrix );
				if ( data.skeleton !== undefined ) object.skeleton = data.skeleton;

				break;

			case 'Mesh':

				geometry = getGeometry( data.geometry );
				material = getMaterial( data.material );

				object = new Mesh( geometry, material );

				break;

			case 'InstancedMesh':

				geometry = getGeometry( data.geometry );
				material = getMaterial( data.material );
				const count = data.count;
				const instanceMatrix = data.instanceMatrix;
				const instanceColor = data.instanceColor;

				object = new InstancedMesh( geometry, material, count );
				object.instanceMatrix = new InstancedBufferAttribute( new Float32Array( instanceMatrix.array ), 16 );
				if ( instanceColor !== undefined ) object.instanceColor = new InstancedBufferAttribute( new Float32Array( instanceColor.array ), instanceColor.itemSize );

				break;

			case 'BatchedMesh':

				geometry = getGeometry( data.geometry );
				material = getMaterial( data.material );

				object = new BatchedMesh( data.maxGeometryCount, data.maxVertexCount, data.maxIndexCount, material );
				object.geometry = geometry;
				object.perObjectFrustumCulled = data.perObjectFrustumCulled;
				object.sortObjects = data.sortObjects;

				object._drawRanges = data.drawRanges;
				object._reservedRanges = data.reservedRanges;

				object._visibility = data.visibility;
				object._active = data.active;
				object._bounds = data.bounds.map( bound => {

					const box = new Box3();
					box.min.fromArray( bound.boxMin );
					box.max.fromArray( bound.boxMax );

					const sphere = new Sphere();
					sphere.radius = bound.sphereRadius;
					sphere.center.fromArray( bound.sphereCenter );

					return {
						boxInitialized: bound.boxInitialized,
						box: box,

						sphereInitialized: bound.sphereInitialized,
						sphere: sphere
					};

				} );

				object._maxGeometryCount = data.maxGeometryCount;
				object._maxVertexCount = data.maxVertexCount;
				object._maxIndexCount = data.maxIndexCount;

				object._geometryInitialized = data.geometryInitialized;
				object._geometryCount = data.geometryCount;

				object._matricesTexture = getTexture( data.matricesTexture.uuid );

				break;

			case 'LOD':

				object = new LOD();

				break;

			case 'Line':

				object = new Line( getGeometry( data.geometry ), getMaterial( data.material ) );

				break;

			case 'LineLoop':

				object = new LineLoop( getGeometry( data.geometry ), getMaterial( data.material ) );

				break;

			case 'LineSegments':

				object = new LineSegments( getGeometry( data.geometry ), getMaterial( data.material ) );

				break;

			case 'PointCloud':
			case 'Points':

				object = new Points( getGeometry( data.geometry ), getMaterial( data.material ) );

				break;

			case 'Sprite':

				object = new Sprite( getMaterial( data.material ) );

				break;

			case 'Group':

				object = new Group();

				break;

			case 'Bone':

				object = new Bone();

				break;

			default:

				object = new Object3D();

		}

		object.uuid = data.uuid;

		if ( data.name !== undefined ) object.name = data.name;

		if ( data.matrix !== undefined ) {

			object.matrix.fromArray( data.matrix );

			if ( data.matrixAutoUpdate !== undefined ) object.matrixAutoUpdate = data.matrixAutoUpdate;
			if ( object.matrixAutoUpdate ) object.matrix.decompose( object.position, object.quaternion, object.scale );

		} else {

			if ( data.position !== undefined ) object.position.fromArray( data.position );
			if ( data.rotation !== undefined ) object.rotation.fromArray( data.rotation );
			if ( data.quaternion !== undefined ) object.quaternion.fromArray( data.quaternion );
			if ( data.scale !== undefined ) object.scale.fromArray( data.scale );

		}

		if ( data.up !== undefined ) object.up.fromArray( data.up );

		if ( data.castShadow !== undefined ) object.castShadow = data.castShadow;
		if ( data.receiveShadow !== undefined ) object.receiveShadow = data.receiveShadow;

		if ( data.shadow ) {

			if ( data.shadow.bias !== undefined ) object.shadow.bias = data.shadow.bias;
			if ( data.shadow.normalBias !== undefined ) object.shadow.normalBias = data.shadow.normalBias;
			if ( data.shadow.radius !== undefined ) object.shadow.radius = data.shadow.radius;
			if ( data.shadow.mapSize !== undefined ) object.shadow.mapSize.fromArray( data.shadow.mapSize );
			if ( data.shadow.camera !== undefined ) object.shadow.camera = this.parseObject( data.shadow.camera );

		}

		if ( data.visible !== undefined ) object.visible = data.visible;
		if ( data.frustumCulled !== undefined ) object.frustumCulled = data.frustumCulled;
		if ( data.renderOrder !== undefined ) object.renderOrder = data.renderOrder;
		if ( data.userData !== undefined ) object.userData = data.userData;
		if ( data.layers !== undefined ) object.layers.mask = data.layers;

		if ( data.children !== undefined ) {

			const children = data.children;

			for ( let i = 0; i < children.length; i ++ ) {

				object.add( this.parseObject( children[ i ], geometries, materials, textures, animations ) );

			}

		}

		if ( data.animations !== undefined ) {

			const objectAnimations = data.animations;

			for ( let i = 0; i < objectAnimations.length; i ++ ) {

				const uuid = objectAnimations[ i ];

				object.animations.push( animations[ uuid ] );

			}

		}

		if ( data.type === 'LOD' ) {

			if ( data.autoUpdate !== undefined ) object.autoUpdate = data.autoUpdate;

			const levels = data.levels;

			for ( let l = 0; l < levels.length; l ++ ) {

				const level = levels[ l ];
				const child = object.getObjectByProperty( 'uuid', level.object );

				if ( child !== undefined ) {

					object.addLevel( child, level.distance, level.hysteresis );

				}

			}

		}

		return object;

	}

	bindSkeletons( object, skeletons ) {

		if ( Object.keys( skeletons ).length === 0 ) return;

		object.traverse( function ( child ) {

			if ( child.isSkinnedMesh === true && child.skeleton !== undefined ) {

				const skeleton = skeletons[ child.skeleton ];

				if ( skeleton === undefined ) {

					console.warn( 'THREE.ObjectLoader: No skeleton found with UUID:', child.skeleton );

				} else {

					child.bind( skeleton, child.bindMatrix );

				}

			}

		} );

	}

}

const TEXTURE_MAPPING = {
	UVMapping: UVMapping,
	CubeReflectionMapping: CubeReflectionMapping,
	CubeRefractionMapping: CubeRefractionMapping,
	EquirectangularReflectionMapping: EquirectangularReflectionMapping,
	EquirectangularRefractionMapping: EquirectangularRefractionMapping,
	CubeUVReflectionMapping: CubeUVReflectionMapping
};

const TEXTURE_WRAPPING = {
	RepeatWrapping: RepeatWrapping,
	ClampToEdgeWrapping: ClampToEdgeWrapping,
	MirroredRepeatWrapping: MirroredRepeatWrapping
};

const TEXTURE_FILTER = {
	NearestFilter: NearestFilter,
	NearestMipmapNearestFilter: NearestMipmapNearestFilter,
	NearestMipmapLinearFilter: NearestMipmapLinearFilter,
	LinearFilter: LinearFilter,
	LinearMipmapNearestFilter: LinearMipmapNearestFilter,
	LinearMipmapLinearFilter: LinearMipmapLinearFilter
};

class ImageBitmapLoader extends Loader {

	constructor( manager ) {

		super( manager );

		this.isImageBitmapLoader = true;

		if ( typeof createImageBitmap === 'undefined' ) {

			console.warn( 'THREE.ImageBitmapLoader: createImageBitmap() not supported.' );

		}

		if ( typeof fetch === 'undefined' ) {

			console.warn( 'THREE.ImageBitmapLoader: fetch() not supported.' );

		}

		this.options = { premultiplyAlpha: 'none' };

	}

	setOptions( options ) {

		this.options = options;

		return this;

	}

	load( url, onLoad, onProgress, onError ) {

		if ( url === undefined ) url = '';

		if ( this.path !== undefined ) url = this.path + url;

		url = this.manager.resolveURL( url );

		const scope = this;

		const cached = Cache.get( url );

		if ( cached !== undefined ) {

			scope.manager.itemStart( url );

			// If cached is a promise, wait for it to resolve
			if ( cached.then ) {

				cached.then( imageBitmap => {

					if ( onLoad ) onLoad( imageBitmap );

					scope.manager.itemEnd( url );

				} ).catch( e => {

					if ( onError ) onError( e );

				} );
				return;

			}

			// If cached is not a promise (i.e., it's already an imageBitmap)
			setTimeout( function () {

				if ( onLoad ) onLoad( cached );

				scope.manager.itemEnd( url );

			}, 0 );

			return cached;

		}

		const fetchOptions = {};
		fetchOptions.credentials = ( this.crossOrigin === 'anonymous' ) ? 'same-origin' : 'include';
		fetchOptions.headers = this.requestHeader;

		const promise = fetch( url, fetchOptions ).then( function ( res ) {

			return res.blob();

		} ).then( function ( blob ) {

			return createImageBitmap( blob, Object.assign( scope.options, { colorSpaceConversion: 'none' } ) );

		} ).then( function ( imageBitmap ) {

			Cache.add( url, imageBitmap );

			if ( onLoad ) onLoad( imageBitmap );

			scope.manager.itemEnd( url );

			return imageBitmap;

		} ).catch( function ( e ) {

			if ( onError ) onError( e );

			Cache.remove( url );

			scope.manager.itemError( url );
			scope.manager.itemEnd( url );

		} );

		Cache.add( url, promise );
		scope.manager.itemStart( url );

	}

}

let _context;

class AudioContext {

	static getContext() {

		if ( _context === undefined ) {

			_context = new ( window.AudioContext || window.webkitAudioContext )();

		}

		return _context;

	}

	static setContext( value ) {

		_context = value;

	}

}

class AudioLoader extends Loader {

	constructor( manager ) {

		super( manager );

	}

	load( url, onLoad, onProgress, onError ) {

		const scope = this;

		const loader = new FileLoader( this.manager );
		loader.setResponseType( 'arraybuffer' );
		loader.setPath( this.path );
		loader.setRequestHeader( this.requestHeader );
		loader.setWithCredentials( this.withCredentials );
		loader.load( url, function ( buffer ) {

			try {

				// Create a copy of the buffer. The `decodeAudioData` method
				// detaches the buffer when complete, preventing reuse.
				const bufferCopy = buffer.slice( 0 );

				const context = AudioContext.getContext();
				context.decodeAudioData( bufferCopy, function ( audioBuffer ) {

					onLoad( audioBuffer );

				} ).catch( handleError );

			} catch ( e ) {

				handleError( e );

			}

		}, onProgress, onError );

		function handleError( e ) {

			if ( onError ) {

				onError( e );

			} else {

				console.error( e );

			}

			scope.manager.itemError( url );

		}

	}

}

const _eyeRight = /*@__PURE__*/ new Matrix4();
const _eyeLeft = /*@__PURE__*/ new Matrix4();
const _projectionMatrix = /*@__PURE__*/ new Matrix4();

class StereoCamera {

	constructor() {

		this.type = 'StereoCamera';

		this.aspect = 1;

		this.eyeSep = 0.064;

		this.cameraL = new PerspectiveCamera();
		this.cameraL.layers.enable( 1 );
		this.cameraL.matrixAutoUpdate = false;

		this.cameraR = new PerspectiveCamera();
		this.cameraR.layers.enable( 2 );
		this.cameraR.matrixAutoUpdate = false;

		this._cache = {
			focus: null,
			fov: null,
			aspect: null,
			near: null,
			far: null,
			zoom: null,
			eyeSep: null
		};

	}

	update( camera ) {

		const cache = this._cache;

		const needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov ||
			cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near ||
			cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;

		if ( needsUpdate ) {

			cache.focus = camera.focus;
			cache.fov = camera.fov;
			cache.aspect = camera.aspect * this.aspect;
			cache.near = camera.near;
			cache.far = camera.far;
			cache.zoom = camera.zoom;
			cache.eyeSep = this.eyeSep;

			// Off-axis stereoscopic effect based on
			// http://paulbourke.net/stereographics/stereorender/

			_projectionMatrix.copy( camera.projectionMatrix );
			const eyeSepHalf = cache.eyeSep / 2;
			const eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
			const ymax = ( cache.near * Math.tan( DEG2RAD * cache.fov * 0.5 ) ) / cache.zoom;
			let xmin, xmax;

			// translate xOffset

			_eyeLeft.elements[ 12 ] = - eyeSepHalf;
			_eyeRight.elements[ 12 ] = eyeSepHalf;

			// for left eye

			xmin = - ymax * cache.aspect + eyeSepOnProjection;
			xmax = ymax * cache.aspect + eyeSepOnProjection;

			_projectionMatrix.elements[ 0 ] = 2 * cache.near / ( xmax - xmin );
			_projectionMatrix.elements[ 8 ] = ( xmax + xmin ) / ( xmax - xmin );

			this.cameraL.projectionMatrix.copy( _projectionMatrix );

			// for right eye

			xmin = - ymax * cache.aspect - eyeSepOnProjection;
			xmax = ymax * cache.aspect - eyeSepOnProjection;

			_projectionMatrix.elements[ 0 ] = 2 * cache.near / ( xmax - xmin );
			_projectionMatrix.elements[ 8 ] = ( xmax + xmin ) / ( xmax - xmin );

			this.cameraR.projectionMatrix.copy( _projectionMatrix );

		}

		this.cameraL.matrixWorld.copy( camera.matrixWorld ).multiply( _eyeLeft );
		this.cameraR.matrixWorld.copy( camera.matrixWorld ).multiply( _eyeRight );

	}

}

class Clock {

	constructor( autoStart = true ) {

		this.autoStart = autoStart;

		this.startTime = 0;
		this.oldTime = 0;
		this.elapsedTime = 0;

		this.running = false;

	}

	start() {

		this.startTime = now();

		this.oldTime = this.startTime;
		this.elapsedTime = 0;
		this.running = true;

	}

	stop() {

		this.getElapsedTime();
		this.running = false;
		this.autoStart = false;

	}

	getElapsedTime() {

		this.getDelta();
		return this.elapsedTime;

	}

	getDelta() {

		let diff = 0;

		if ( this.autoStart && ! this.running ) {

			this.start();
			return 0;

		}

		if ( this.running ) {

			const newTime = now();

			diff = ( newTime - this.oldTime ) / 1000;
			this.oldTime = newTime;

			this.elapsedTime += diff;

		}

		return diff;

	}

}

function now() {

	return ( typeof performance === 'undefined' ? Date : performance ).now(); // see #10732

}

const _position$1 = /*@__PURE__*/ new Vector3();
const _quaternion$1 = /*@__PURE__*/ new Quaternion();
const _scale$1 = /*@__PURE__*/ new Vector3();
const _orientation$1 = /*@__PURE__*/ new Vector3();

class AudioListener extends Object3D {

	constructor() {

		super();

		this.type = 'AudioListener';

		this.context = AudioContext.getContext();

		this.gain = this.context.createGain();
		this.gain.connect( this.context.destination );

		this.filter = null;

		this.timeDelta = 0;

		// private

		this._clock = new Clock();

	}

	getInput() {

		return this.gain;

	}

	removeFilter() {

		if ( this.filter !== null ) {

			this.gain.disconnect( this.filter );
			this.filter.disconnect( this.context.destination );
			this.gain.connect( this.context.destination );
			this.filter = null;

		}

		return this;

	}

	getFilter() {

		return this.filter;

	}

	setFilter( value ) {

		if ( this.filter !== null ) {

			this.gain.disconnect( this.filter );
			this.filter.disconnect( this.context.destination );

		} else {

			this.gain.disconnect( this.context.destination );

		}

		this.filter = value;
		this.gain.connect( this.filter );
		this.filter.connect( this.context.destination );

		return this;

	}

	getMasterVolume() {

		return this.gain.gain.value;

	}

	setMasterVolume( value ) {

		this.gain.gain.setTargetAtTime( value, this.context.currentTime, 0.01 );

		return this;

	}

	updateMatrixWorld( force ) {

		super.updateMatrixWorld( force );

		const listener = this.context.listener;
		const up = this.up;

		this.timeDelta = this._clock.getDelta();

		this.matrixWorld.decompose( _position$1, _quaternion$1, _scale$1 );

		_orientation$1.set( 0, 0, - 1 ).applyQuaternion( _quaternion$1 );

		if ( listener.positionX ) {

			// code path for Chrome (see #14393)

			const endTime = this.context.currentTime + this.timeDelta;

			listener.positionX.linearRampToValueAtTime( _position$1.x, endTime );
			listener.positionY.linearRampToValueAtTime( _position$1.y, endTime );
			listener.positionZ.linearRampToValueAtTime( _position$1.z, endTime );
			listener.forwardX.linearRampToValueAtTime( _orientation$1.x, endTime );
			listener.forwardY.linearRampToValueAtTime( _orientation$1.y, endTime );
			listener.forwardZ.linearRampToValueAtTime( _orientation$1.z, endTime );
			listener.upX.linearRampToValueAtTime( up.x, endTime );
			listener.upY.linearRampToValueAtTime( up.y, endTime );
			listener.upZ.linearRampToValueAtTime( up.z, endTime );

		} else {

			listener.setPosition( _position$1.x, _position$1.y, _position$1.z );
			listener.setOrientation( _orientation$1.x, _orientation$1.y, _orientation$1.z, up.x, up.y, up.z );

		}

	}

}

class Audio extends Object3D {

	constructor( listener ) {

		super();

		this.type = 'Audio';

		this.listener = listener;
		this.context = listener.context;

		this.gain = this.context.createGain();
		this.gain.connect( listener.getInput() );

		this.autoplay = false;

		this.buffer = null;
		this.detune = 0;
		this.loop = false;
		this.loopStart = 0;
		this.loopEnd = 0;
		this.offset = 0;
		this.duration = undefined;
		this.playbackRate = 1;
		this.isPlaying = false;
		this.hasPlaybackControl = true;
		this.source = null;
		this.sourceType = 'empty';

		this._startedAt = 0;
		this._progress = 0;
		this._connected = false;

		this.filters = [];

	}

	getOutput() {

		return this.gain;

	}

	setNodeSource( audioNode ) {

		this.hasPlaybackControl = false;
		this.sourceType = 'audioNode';
		this.source = audioNode;
		this.connect();

		return this;

	}

	setMediaElementSource( mediaElement ) {

		this.hasPlaybackControl = false;
		this.sourceType = 'mediaNode';
		this.source = this.context.createMediaElementSource( mediaElement );
		this.connect();

		return this;

	}

	setMediaStreamSource( mediaStream ) {

		this.hasPlaybackControl = false;
		this.sourceType = 'mediaStreamNode';
		this.source = this.context.createMediaStreamSource( mediaStream );
		this.connect();

		return this;

	}

	setBuffer( audioBuffer ) {

		this.buffer = audioBuffer;
		this.sourceType = 'buffer';

		if ( this.autoplay ) this.play();

		return this;

	}

	play( delay = 0 ) {

		if ( this.isPlaying === true ) {

			console.warn( 'THREE.Audio: Audio is already playing.' );
			return;

		}

		if ( this.hasPlaybackControl === false ) {

			console.warn( 'THREE.Audio: this Audio has no playback control.' );
			return;

		}

		this._startedAt = this.context.currentTime + delay;

		const source = this.context.createBufferSource();
		source.buffer = this.buffer;
		source.loop = this.loop;
		source.loopStart = this.loopStart;
		source.loopEnd = this.loopEnd;
		source.onended = this.onEnded.bind( this );
		source.start( this._startedAt, this._progress + this.offset, this.duration );

		this.isPlaying = true;

		this.source = source;

		this.setDetune( this.detune );
		this.setPlaybackRate( this.playbackRate );

		return this.connect();

	}

	pause() {

		if ( this.hasPlaybackControl === false ) {

			console.warn( 'THREE.Audio: this Audio has no playback control.' );
			return;

		}

		if ( this.isPlaying === true ) {

			// update current progress

			this._progress += Math.max( this.context.currentTime - this._startedAt, 0 ) * this.playbackRate;

			if ( this.loop === true ) {

				// ensure _progress does not exceed duration with looped audios

				this._progress = this._progress % ( this.duration || this.buffer.duration );

			}

			this.source.stop();
			this.source.onended = null;

			this.isPlaying = false;

		}

		return this;

	}

	stop() {

		if ( this.hasPlaybackControl === false ) {

			console.warn( 'THREE.Audio: this Audio has no playback control.' );
			return;

		}

		this._progress = 0;

		if ( this.source !== null ) {

			this.source.stop();
			this.source.onended = null;

		}

		this.isPlaying = false;

		return this;

	}

	connect() {

		if ( this.filters.length > 0 ) {

			this.source.connect( this.filters[ 0 ] );

			for ( let i = 1, l = this.filters.length; i < l; i ++ ) {

				this.filters[ i - 1 ].connect( this.filters[ i ] );

			}

			this.filters[ this.filters.length - 1 ].connect( this.getOutput() );

		} else {

			this.source.connect( this.getOutput() );

		}

		this._connected = true;

		return this;

	}

	disconnect() {

		if ( this._connected === false ) {

			return;

		}

		if ( this.filters.length > 0 ) {

			this.source.disconnect( this.filters[ 0 ] );

			for ( let i = 1, l = this.filters.length; i < l; i ++ ) {

				this.filters[ i - 1 ].disconnect( this.filters[ i ] );

			}

			this.filters[ this.filters.length - 1 ].disconnect( this.getOutput() );

		} else {

			this.source.disconnect( this.getOutput() );

		}

		this._connected = false;

		return this;

	}

	getFilters() {

		return this.filters;

	}

	setFilters( value ) {

		if ( ! value ) value = [];

		if ( this._connected === true ) {

			this.disconnect();
			this.filters = value.slice();
			this.connect();

		} else {

			this.filters = value.slice();

		}

		return this;

	}

	setDetune( value ) {

		this.detune = value;

		if ( this.isPlaying === true && this.source.detune !== undefined ) {

			this.source.detune.setTargetAtTime( this.detune, this.context.currentTime, 0.01 );

		}

		return this;

	}

	getDetune() {

		return this.detune;

	}

	getFilter() {

		return this.getFilters()[ 0 ];

	}

	setFilter( filter ) {

		return this.setFilters( filter ? [ filter ] : [] );

	}

	setPlaybackRate( value ) {

		if ( this.hasPlaybackControl === false ) {

			console.warn( 'THREE.Audio: this Audio has no playback control.' );
			return;

		}

		this.playbackRate = value;

		if ( this.isPlaying === true ) {

			this.source.playbackRate.setTargetAtTime( this.playbackRate, this.context.currentTime, 0.01 );

		}

		return this;

	}

	getPlaybackRate() {

		return this.playbackRate;

	}

	onEnded() {

		this.isPlaying = false;

	}

	getLoop() {

		if ( this.hasPlaybackControl === false ) {

			console.warn( 'THREE.Audio: this Audio has no playback control.' );
			return false;

		}

		return this.loop;

	}

	setLoop( value ) {

		if ( this.hasPlaybackControl === false ) {

			console.warn( 'THREE.Audio: this Audio has no playback control.' );
			return;

		}

		this.loop = value;

		if ( this.isPlaying === true ) {

			this.source.loop = this.loop;

		}

		return this;

	}

	setLoopStart( value ) {

		this.loopStart = value;

		return this;

	}

	setLoopEnd( value ) {

		this.loopEnd = value;

		return this;

	}

	getVolume() {

		return this.gain.gain.value;

	}

	setVolume( value ) {

		this.gain.gain.setTargetAtTime( value, this.context.currentTime, 0.01 );

		return this;

	}

}

const _position = /*@__PURE__*/ new Vector3();
const _quaternion = /*@__PURE__*/ new Quaternion();
const _scale = /*@__PURE__*/ new Vector3();
const _orientation = /*@__PURE__*/ new Vector3();

class PositionalAudio extends Audio {

	constructor( listener ) {

		super( listener );

		this.panner = this.context.createPanner();
		this.panner.panningModel = 'HRTF';
		this.panner.connect( this.gain );

	}

	connect() {

		super.connect();

		this.panner.connect( this.gain );

	}

	disconnect() {

		super.disconnect();

		this.panner.disconnect( this.gain );

	}

	getOutput() {

		return this.panner;

	}

	getRefDistance() {

		return this.panner.refDistance;

	}

	setRefDistance( value ) {

		this.panner.refDistance = value;

		return this;

	}

	getRolloffFactor() {

		return this.panner.rolloffFactor;

	}

	setRolloffFactor( value ) {

		this.panner.rolloffFactor = value;

		return this;

	}

	getDistanceModel() {

		return this.panner.distanceModel;

	}

	setDistanceModel( value ) {

		this.panner.distanceModel = value;

		return this;

	}

	getMaxDistance() {

		return this.panner.maxDistance;

	}

	setMaxDistance( value ) {

		this.panner.maxDistance = value;

		return this;

	}

	setDirectionalCone( coneInnerAngle, coneOuterAngle, coneOuterGain ) {

		this.panner.coneInnerAngle = coneInnerAngle;
		this.panner.coneOuterAngle = coneOuterAngle;
		this.panner.coneOuterGain = coneOuterGain;

		return this;

	}

	updateMatrixWorld( force ) {

		super.updateMatrixWorld( force );

		if ( this.hasPlaybackControl === true && this.isPlaying === false ) return;

		this.matrixWorld.decompose( _position, _quaternion, _scale );

		_orientation.set( 0, 0, 1 ).applyQuaternion( _quaternion );

		const panner = this.panner;

		if ( panner.positionX ) {

			// code path for Chrome and Firefox (see #14393)

			const endTime = this.context.currentTime + this.listener.timeDelta;

			panner.positionX.linearRampToValueAtTime( _position.x, endTime );
			panner.positionY.linearRampToValueAtTime( _position.y, endTime );
			panner.positionZ.linearRampToValueAtTime( _position.z, endTime );
			panner.orientationX.linearRampToValueAtTime( _orientation.x, endTime );
			panner.orientationY.linearRampToValueAtTime( _orientation.y, endTime );
			panner.orientationZ.linearRampToValueAtTime( _orientation.z, endTime );

		} else {

			panner.setPosition( _position.x, _position.y, _position.z );
			panner.setOrientation( _orientation.x, _orientation.y, _orientation.z );

		}

	}

}

class AudioAnalyser {

	constructor( audio, fftSize = 2048 ) {

		this.analyser = audio.context.createAnalyser();
		this.analyser.fftSize = fftSize;

		this.data = new Uint8Array( this.analyser.frequencyBinCount );

		audio.getOutput().connect( this.analyser );

	}


	getFrequencyData() {

		this.analyser.getByteFrequencyData( this.data );

		return this.data;

	}

	getAverageFrequency() {

		let value = 0;
		const data = this.getFrequencyData();

		for ( let i = 0; i < data.length; i ++ ) {

			value += data[ i ];

		}

		return value / data.length;

	}

}

class PropertyMixer {

	constructor( binding, typeName, valueSize ) {

		this.binding = binding;
		this.valueSize = valueSize;

		let mixFunction,
			mixFunctionAdditive,
			setIdentity;

		// buffer layout: [ incoming | accu0 | accu1 | orig | addAccu | (optional work) ]
		//
		// interpolators can use .buffer as their .result
		// the data then goes to 'incoming'
		//
		// 'accu0' and 'accu1' are used frame-interleaved for
		// the cumulative result and are compared to detect
		// changes
		//
		// 'orig' stores the original state of the property
		//
		// 'add' is used for additive cumulative results
		//
		// 'work' is optional and is only present for quaternion types. It is used
		// to store intermediate quaternion multiplication results

		switch ( typeName ) {

			case 'quaternion':
				mixFunction = this._slerp;
				mixFunctionAdditive = this._slerpAdditive;
				setIdentity = this._setAdditiveIdentityQuaternion;

				this.buffer = new Float64Array( valueSize * 6 );
				this._workIndex = 5;
				break;

			case 'string':
			case 'bool':
				mixFunction = this._select;

				// Use the regular mix function and for additive on these types,
				// additive is not relevant for non-numeric types
				mixFunctionAdditive = this._select;

				setIdentity = this._setAdditiveIdentityOther;

				this.buffer = new Array( valueSize * 5 );
				break;

			default:
				mixFunction = this._lerp;
				mixFunctionAdditive = this._lerpAdditive;
				setIdentity = this._setAdditiveIdentityNumeric;

				this.buffer = new Float64Array( valueSize * 5 );

		}

		this._mixBufferRegion = mixFunction;
		this._mixBufferRegionAdditive = mixFunctionAdditive;
		this._setIdentity = setIdentity;
		this._origIndex = 3;
		this._addIndex = 4;

		this.cumulativeWeight = 0;
		this.cumulativeWeightAdditive = 0;

		this.useCount = 0;
		this.referenceCount = 0;

	}

	// accumulate data in the 'incoming' region into 'accu<i>'
	accumulate( accuIndex, weight ) {

		// note: happily accumulating nothing when weight = 0, the caller knows
		// the weight and shouldn't have made the call in the first place

		const buffer = this.buffer,
			stride = this.valueSize,
			offset = accuIndex * stride + stride;

		let currentWeight = this.cumulativeWeight;

		if ( currentWeight === 0 ) {

			// accuN := incoming * weight

			for ( let i = 0; i !== stride; ++ i ) {

				buffer[ offset + i ] = buffer[ i ];

			}

			currentWeight = weight;

		} else {

			// accuN := accuN + incoming * weight

			currentWeight += weight;
			const mix = weight / currentWeight;
			this._mixBufferRegion( buffer, offset, 0, mix, stride );

		}

		this.cumulativeWeight = currentWeight;

	}

	// accumulate data in the 'incoming' region into 'add'
	accumulateAdditive( weight ) {

		const buffer = this.buffer,
			stride = this.valueSize,
			offset = stride * this._addIndex;

		if ( this.cumulativeWeightAdditive === 0 ) {

			// add = identity

			this._setIdentity();

		}

		// add := add + incoming * weight

		this._mixBufferRegionAdditive( buffer, offset, 0, weight, stride );
		this.cumulativeWeightAdditive += weight;

	}

	// apply the state of 'accu<i>' to the binding when accus differ
	apply( accuIndex ) {

		const stride = this.valueSize,
			buffer = this.buffer,
			offset = accuIndex * stride + stride,

			weight = this.cumulativeWeight,
			weightAdditive = this.cumulativeWeightAdditive,

			binding = this.binding;

		this.cumulativeWeight = 0;
		this.cumulativeWeightAdditive = 0;

		if ( weight < 1 ) {

			// accuN := accuN + original * ( 1 - cumulativeWeight )

			const originalValueOffset = stride * this._origIndex;

			this._mixBufferRegion(
				buffer, offset, originalValueOffset, 1 - weight, stride );

		}

		if ( weightAdditive > 0 ) {

			// accuN := accuN + additive accuN

			this._mixBufferRegionAdditive( buffer, offset, this._addIndex * stride, 1, stride );

		}

		for ( let i = stride, e = stride + stride; i !== e; ++ i ) {

			if ( buffer[ i ] !== buffer[ i + stride ] ) {

				// value has changed -> update scene graph

				binding.setValue( buffer, offset );
				break;

			}

		}

	}

	// remember the state of the bound property and copy it to both accus
	saveOriginalState() {

		const binding = this.binding;

		const buffer = this.buffer,
			stride = this.valueSize,

			originalValueOffset = stride * this._origIndex;

		binding.getValue( buffer, originalValueOffset );

		// accu[0..1] := orig -- initially detect changes against the original
		for ( let i = stride, e = originalValueOffset; i !== e; ++ i ) {

			buffer[ i ] = buffer[ originalValueOffset + ( i % stride ) ];

		}

		// Add to identity for additive
		this._setIdentity();

		this.cumulativeWeight = 0;
		this.cumulativeWeightAdditive = 0;

	}

	// apply the state previously taken via 'saveOriginalState' to the binding
	restoreOriginalState() {

		const originalValueOffset = this.valueSize * 3;
		this.binding.setValue( this.buffer, originalValueOffset );

	}

	_setAdditiveIdentityNumeric() {

		const startIndex = this._addIndex * this.valueSize;
		const endIndex = startIndex + this.valueSize;

		for ( let i = startIndex; i < endIndex; i ++ ) {

			this.buffer[ i ] = 0;

		}

	}

	_setAdditiveIdentityQuaternion() {

		this._setAdditiveIdentityNumeric();
		this.buffer[ this._addIndex * this.valueSize + 3 ] = 1;

	}

	_setAdditiveIdentityOther() {

		const startIndex = this._origIndex * this.valueSize;
		const targetIndex = this._addIndex * this.valueSize;

		for ( let i = 0; i < this.valueSize; i ++ ) {

			this.buffer[ targetIndex + i ] = this.buffer[ startIndex + i ];

		}

	}


	// mix functions

	_select( buffer, dstOffset, srcOffset, t, stride ) {

		if ( t >= 0.5 ) {

			for ( let i = 0; i !== stride; ++ i ) {

				buffer[ dstOffset + i ] = buffer[ srcOffset + i ];

			}

		}

	}

	_slerp( buffer, dstOffset, srcOffset, t ) {

		Quaternion.slerpFlat( buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t );

	}

	_slerpAdditive( buffer, dstOffset, srcOffset, t, stride ) {

		const workOffset = this._workIndex * stride;

		// Store result in intermediate buffer offset
		Quaternion.multiplyQuaternionsFlat( buffer, workOffset, buffer, dstOffset, buffer, srcOffset );

		// Slerp to the intermediate result
		Quaternion.slerpFlat( buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t );

	}

	_lerp( buffer, dstOffset, srcOffset, t, stride ) {

		const s = 1 - t;

		for ( let i = 0; i !== stride; ++ i ) {

			const j = dstOffset + i;

			buffer[ j ] = buffer[ j ] * s + buffer[ srcOffset + i ] * t;

		}

	}

	_lerpAdditive( buffer, dstOffset, srcOffset, t, stride ) {

		for ( let i = 0; i !== stride; ++ i ) {

			const j = dstOffset + i;

			buffer[ j ] = buffer[ j ] + buffer[ srcOffset + i ] * t;

		}

	}

}

// Characters [].:/ are reserved for track binding syntax.
const _RESERVED_CHARS_RE = '\\[\\]\\.:\\/';
const _reservedRe = new RegExp( '[' + _RESERVED_CHARS_RE + ']', 'g' );

// Attempts to allow node names from any language. ES5's `\w` regexp matches
// only latin characters, and the unicode \p{L} is not yet supported. So
// instead, we exclude reserved characters and match everything else.
const _wordChar = '[^' + _RESERVED_CHARS_RE + ']';
const _wordCharOrDot = '[^' + _RESERVED_CHARS_RE.replace( '\\.', '' ) + ']';

// Parent directories, delimited by '/' or ':'. Currently unused, but must
// be matched to parse the rest of the track name.
const _directoryRe = /*@__PURE__*/ /((?:WC+[\/:])*)/.source.replace( 'WC', _wordChar );

// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
const _nodeRe = /*@__PURE__*/ /(WCOD+)?/.source.replace( 'WCOD', _wordCharOrDot );

// Object on target node, and accessor. May not contain reserved
// characters. Accessor may contain any character except closing bracket.
const _objectRe = /*@__PURE__*/ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace( 'WC', _wordChar );

// Property and accessor. May not contain reserved characters. Accessor may
// contain any non-bracket characters.
const _propertyRe = /*@__PURE__*/ /\.(WC+)(?:\[(.+)\])?/.source.replace( 'WC', _wordChar );

const _trackRe = new RegExp( ''
	+ '^'
	+ _directoryRe
	+ _nodeRe
	+ _objectRe
	+ _propertyRe
	+ '$'
);

const _supportedObjectNames = [ 'material', 'materials', 'bones', 'map' ];

class Composite {

	constructor( targetGroup, path, optionalParsedPath ) {

		const parsedPath = optionalParsedPath || PropertyBinding.parseTrackName( path );

		this._targetGroup = targetGroup;
		this._bindings = targetGroup.subscribe_( path, parsedPath );

	}

	getValue( array, offset ) {

		this.bind(); // bind all binding

		const firstValidIndex = this._targetGroup.nCachedObjects_,
			binding = this._bindings[ firstValidIndex ];

		// and only call .getValue on the first
		if ( binding !== undefined ) binding.getValue( array, offset );

	}

	setValue( array, offset ) {

		const bindings = this._bindings;

		for ( let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++ i ) {

			bindings[ i ].setValue( array, offset );

		}

	}

	bind() {

		const bindings = this._bindings;

		for ( let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++ i ) {

			bindings[ i ].bind();

		}

	}

	unbind() {

		const bindings = this._bindings;

		for ( let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++ i ) {

			bindings[ i ].unbind();

		}

	}

}

// Note: This class uses a State pattern on a per-method basis:
// 'bind' sets 'this.getValue' / 'setValue' and shadows the
// prototype version of these methods with one that represents
// the bound state. When the property is not found, the methods
// become no-ops.
class PropertyBinding {

	constructor( rootNode, path, parsedPath ) {

		this.path = path;
		this.parsedPath = parsedPath || PropertyBinding.parseTrackName( path );

		this.node = PropertyBinding.findNode( rootNode, this.parsedPath.nodeName );

		this.rootNode = rootNode;

		// initial state of these methods that calls 'bind'
		this.getValue = this._getValue_unbound;
		this.setValue = this._setValue_unbound;

	}


	static create( root, path, parsedPath ) {

		if ( ! ( root && root.isAnimationObjectGroup ) ) {

			return new PropertyBinding( root, path, parsedPath );

		} else {

			return new PropertyBinding.Composite( root, path, parsedPath );

		}

	}

	/**
	 * Replaces spaces with underscores and removes unsupported characters from
	 * node names, to ensure compatibility with parseTrackName().
	 *
	 * @param {string} name Node name to be sanitized.
	 * @return {string}
	 */
	static sanitizeNodeName( name ) {

		return name.replace( /\s/g, '_' ).replace( _reservedRe, '' );

	}

	static parseTrackName( trackName ) {

		const matches = _trackRe.exec( trackName );

		if ( matches === null ) {

			throw new Error( 'PropertyBinding: Cannot parse trackName: ' + trackName );

		}

		const results = {
			// directoryName: matches[ 1 ], // (tschw) currently unused
			nodeName: matches[ 2 ],
			objectName: matches[ 3 ],
			objectIndex: matches[ 4 ],
			propertyName: matches[ 5 ], // required
			propertyIndex: matches[ 6 ]
		};

		const lastDot = results.nodeName && results.nodeName.lastIndexOf( '.' );

		if ( lastDot !== undefined && lastDot !== - 1 ) {

			const objectName = results.nodeName.substring( lastDot + 1 );

			// Object names must be checked against an allowlist. Otherwise, there
			// is no way to parse 'foo.bar.baz': 'baz' must be a property, but
			// 'bar' could be the objectName, or part of a nodeName (which can
			// include '.' characters).
			if ( _supportedObjectNames.indexOf( objectName ) !== - 1 ) {

				results.nodeName = results.nodeName.substring( 0, lastDot );
				results.objectName = objectName;

			}

		}

		if ( results.propertyName === null || results.propertyName.length === 0 ) {

			throw new Error( 'PropertyBinding: can not parse propertyName from trackName: ' + trackName );

		}

		return results;

	}

	static findNode( root, nodeName ) {

		if ( nodeName === undefined || nodeName === '' || nodeName === '.' || nodeName === - 1 || nodeName === root.name || nodeName === root.uuid ) {

			return root;

		}

		// search into skeleton bones.
		if ( root.skeleton ) {

			const bone = root.skeleton.getBoneByName( nodeName );

			if ( bone !== undefined ) {

				return bone;

			}

		}

		// search into node subtree.
		if ( root.children ) {

			const searchNodeSubtree = function ( children ) {

				for ( let i = 0; i < children.length; i ++ ) {

					const childNode = children[ i ];

					if ( childNode.name === nodeName || childNode.uuid === nodeName ) {

						return childNode;

					}

					const result = searchNodeSubtree( childNode.children );

					if ( result ) return result;

				}

				return null;

			};

			const subTreeNode = searchNodeSubtree( root.children );

			if ( subTreeNode ) {

				return subTreeNode;

			}

		}

		return null;

	}

	// these are used to "bind" a nonexistent property
	_getValue_unavailable() {}
	_setValue_unavailable() {}

	// Getters

	_getValue_direct( buffer, offset ) {

		buffer[ offset ] = this.targetObject[ this.propertyName ];

	}

	_getValue_array( buffer, offset ) {

		const source = this.resolvedProperty;

		for ( let i = 0, n = source.length; i !== n; ++ i ) {

			buffer[ offset ++ ] = source[ i ];

		}

	}

	_getValue_arrayElement( buffer, offset ) {

		buffer[ offset ] = this.resolvedProperty[ this.propertyIndex ];

	}

	_getValue_toArray( buffer, offset ) {

		this.resolvedProperty.toArray( buffer, offset );

	}

	// Direct

	_setValue_direct( buffer, offset ) {

		this.targetObject[ this.propertyName ] = buffer[ offset ];

	}

	_setValue_direct_setNeedsUpdate( buffer, offset ) {

		this.targetObject[ this.propertyName ] = buffer[ offset ];
		this.targetObject.needsUpdate = true;

	}

	_setValue_direct_setMatrixWorldNeedsUpdate( buffer, offset ) {

		this.targetObject[ this.propertyName ] = buffer[ offset ];
		this.targetObject.matrixWorldNeedsUpdate = true;

	}

	// EntireArray

	_setValue_array( buffer, offset ) {

		const dest = this.resolvedProperty;

		for ( let i = 0, n = dest.length; i !== n; ++ i ) {

			dest[ i ] = buffer[ offset ++ ];

		}

	}

	_setValue_array_setNeedsUpdate( buffer, offset ) {

		const dest = this.resolvedProperty;

		for ( let i = 0, n = dest.length; i !== n; ++ i ) {

			dest[ i ] = buffer[ offset ++ ];

		}

		this.targetObject.needsUpdate = true;

	}

	_setValue_array_setMatrixWorldNeedsUpdate( buffer, offset ) {

		const dest = this.resolvedProperty;

		for ( let i = 0, n = dest.length; i !== n; ++ i ) {

			dest[ i ] = buffer[ offset ++ ];

		}

		this.targetObject.matrixWorldNeedsUpdate = true;

	}

	// ArrayElement

	_setValue_arrayElement( buffer, offset ) {

		this.resolvedProperty[ this.propertyIndex ] = buffer[ offset ];

	}

	_setValue_arrayElement_setNeedsUpdate( buffer, offset ) {

		this.resolvedProperty[ this.propertyIndex ] = buffer[ offset ];
		this.targetObject.needsUpdate = true;

	}

	_setValue_arrayElement_setMatrixWorldNeedsUpdate( buffer, offset ) {

		this.resolvedProperty[ this.propertyIndex ] = buffer[ offset ];
		this.targetObject.matrixWorldNeedsUpdate = true;

	}

	// HasToFromArray

	_setValue_fromArray( buffer, offset ) {

		this.resolvedProperty.fromArray( buffer, offset );

	}

	_setValue_fromArray_setNeedsUpdate( buffer, offset ) {

		this.resolvedProperty.fromArray( buffer, offset );
		this.targetObject.needsUpdate = true;

	}

	_setValue_fromArray_setMatrixWorldNeedsUpdate( buffer, offset ) {

		this.resolvedProperty.fromArray( buffer, offset );
		this.targetObject.matrixWorldNeedsUpdate = true;

	}

	_getValue_unbound( targetArray, offset ) {

		this.bind();
		this.getValue( targetArray, offset );

	}

	_setValue_unbound( sourceArray, offset ) {

		this.bind();
		this.setValue( sourceArray, offset );

	}

	// create getter / setter pair for a property in the scene graph
	bind() {

		let targetObject = this.node;
		const parsedPath = this.parsedPath;

		const objectName = parsedPath.objectName;
		const propertyName = parsedPath.propertyName;
		let propertyIndex = parsedPath.propertyIndex;

		if ( ! targetObject ) {

			targetObject = PropertyBinding.findNode( this.rootNode, parsedPath.nodeName );

			this.node = targetObject;

		}

		// set fail state so we can just 'return' on error
		this.getValue = this._getValue_unavailable;
		this.setValue = this._setValue_unavailable;

		// ensure there is a value node
		if ( ! targetObject ) {

			console.warn( 'THREE.PropertyBinding: No target node found for track: ' + this.path + '.' );
			return;

		}

		if ( objectName ) {

			let objectIndex = parsedPath.objectIndex;

			// special cases were we need to reach deeper into the hierarchy to get the face materials....
			switch ( objectName ) {

				case 'materials':

					if ( ! targetObject.material ) {

						console.error( 'THREE.PropertyBinding: Can not bind to material as node does not have a material.', this );
						return;

					}

					if ( ! targetObject.material.materials ) {

						console.error( 'THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.', this );
						return;

					}

					targetObject = targetObject.material.materials;

					break;

				case 'bones':

					if ( ! targetObject.skeleton ) {

						console.error( 'THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.', this );
						return;

					}

					// potential future optimization: skip this if propertyIndex is already an integer
					// and convert the integer string to a true integer.

					targetObject = targetObject.skeleton.bones;

					// support resolving morphTarget names into indices.
					for ( let i = 0; i < targetObject.length; i ++ ) {

						if ( targetObject[ i ].name === objectIndex ) {

							objectIndex = i;
							break;

						}

					}

					break;

				case 'map':

					if ( 'map' in targetObject ) {

						targetObject = targetObject.map;
						break;

					}

					if ( ! targetObject.material ) {

						console.error( 'THREE.PropertyBinding: Can not bind to material as node does not have a material.', this );
						return;

					}

					if ( ! targetObject.material.map ) {

						console.error( 'THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.', this );
						return;

					}

					targetObject = targetObject.material.map;
					break;

				default:

					if ( targetObject[ objectName ] === undefined ) {

						console.error( 'THREE.PropertyBinding: Can not bind to objectName of node undefined.', this );
						return;

					}

					targetObject = targetObject[ objectName ];

			}


			if ( objectIndex !== undefined ) {

				if ( targetObject[ objectIndex ] === undefined ) {

					console.error( 'THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.', this, targetObject );
					return;

				}

				targetObject = targetObject[ objectIndex ];

			}

		}

		// resolve property
		const nodeProperty = targetObject[ propertyName ];

		if ( nodeProperty === undefined ) {

			const nodeName = parsedPath.nodeName;

			console.error( 'THREE.PropertyBinding: Trying to update property for track: ' + nodeName +
				'.' + propertyName + ' but it wasn\'t found.', targetObject );
			return;

		}

		// determine versioning scheme
		let versioning = this.Versioning.None;

		this.targetObject = targetObject;

		if ( targetObject.needsUpdate !== undefined ) { // material

			versioning = this.Versioning.NeedsUpdate;

		} else if ( targetObject.matrixWorldNeedsUpdate !== undefined ) { // node transform

			versioning = this.Versioning.MatrixWorldNeedsUpdate;

		}

		// determine how the property gets bound
		let bindingType = this.BindingType.Direct;

		if ( propertyIndex !== undefined ) {

			// access a sub element of the property array (only primitives are supported right now)

			if ( propertyName === 'morphTargetInfluences' ) {

				// potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.

				// support resolving morphTarget names into indices.
				if ( ! targetObject.geometry ) {

					console.error( 'THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.', this );
					return;

				}

				if ( ! targetObject.geometry.morphAttributes ) {

					console.error( 'THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.', this );
					return;

				}

				if ( targetObject.morphTargetDictionary[ propertyIndex ] !== undefined ) {

					propertyIndex = targetObject.morphTargetDictionary[ propertyIndex ];

				}

			}

			bindingType = this.BindingType.ArrayElement;

			this.resolvedProperty = nodeProperty;
			this.propertyIndex = propertyIndex;

		} else if ( nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined ) {

			// must use copy for Object3D.Euler/Quaternion

			bindingType = this.BindingType.HasFromToArray;

			this.resolvedProperty = nodeProperty;

		} else if ( Array.isArray( nodeProperty ) ) {

			bindingType = this.BindingType.EntireArray;

			this.resolvedProperty = nodeProperty;

		} else {

			this.propertyName = propertyName;

		}

		// select getter / setter
		this.getValue = this.GetterByBindingType[ bindingType ];
		this.setValue = this.SetterByBindingTypeAndVersioning[ bindingType ][ versioning ];

	}

	unbind() {

		this.node = null;

		// back to the prototype version of getValue / setValue
		// note: avoiding to mutate the shape of 'this' via 'delete'
		this.getValue = this._getValue_unbound;
		this.setValue = this._setValue_unbound;

	}

}

PropertyBinding.Composite = Composite;

PropertyBinding.prototype.BindingType = {
	Direct: 0,
	EntireArray: 1,
	ArrayElement: 2,
	HasFromToArray: 3
};

PropertyBinding.prototype.Versioning = {
	None: 0,
	NeedsUpdate: 1,
	MatrixWorldNeedsUpdate: 2
};

PropertyBinding.prototype.GetterByBindingType = [

	PropertyBinding.prototype._getValue_direct,
	PropertyBinding.prototype._getValue_array,
	PropertyBinding.prototype._getValue_arrayElement,
	PropertyBinding.prototype._getValue_toArray,

];

PropertyBinding.prototype.SetterByBindingTypeAndVersioning = [

	[
		// Direct
		PropertyBinding.prototype._setValue_direct,
		PropertyBinding.prototype._setValue_direct_setNeedsUpdate,
		PropertyBinding.prototype._setValue_direct_setMatrixWorldNeedsUpdate,

	], [

		// EntireArray

		PropertyBinding.prototype._setValue_array,
		PropertyBinding.prototype._setValue_array_setNeedsUpdate,
		PropertyBinding.prototype._setValue_array_setMatrixWorldNeedsUpdate,

	], [

		// ArrayElement
		PropertyBinding.prototype._setValue_arrayElement,
		PropertyBinding.prototype._setValue_arrayElement_setNeedsUpdate,
		PropertyBinding.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate,

	], [

		// HasToFromArray
		PropertyBinding.prototype._setValue_fromArray,
		PropertyBinding.prototype._setValue_fromArray_setNeedsUpdate,
		PropertyBinding.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate,

	]

];

/**
 *
 * A group of objects that receives a shared animation state.
 *
 * Usage:
 *
 *  - Add objects you would otherwise pass as 'root' to the
 *    constructor or the .clipAction method of AnimationMixer.
 *
 *  - Instead pass this object as 'root'.
 *
 *  - You can also add and remove objects later when the mixer
 *    is running.
 *
 * Note:
 *
 *    Objects of this class appear as one object to the mixer,
 *    so cache control of the individual objects must be done
 *    on the group.
 *
 * Limitation:
 *
 *  - The animated properties must be compatible among the
 *    all objects in the group.
 *
 *  - A single property can either be controlled through a
 *    target group or directly, but not both.
 */

class AnimationObjectGroup {

	constructor() {

		this.isAnimationObjectGroup = true;

		this.uuid = generateUUID();

		// cached objects followed by the active ones
		this._objects = Array.prototype.slice.call( arguments );

		this.nCachedObjects_ = 0; // threshold
		// note: read by PropertyBinding.Composite

		const indices = {};
		this._indicesByUUID = indices; // for bookkeeping

		for ( let i = 0, n = arguments.length; i !== n; ++ i ) {

			indices[ arguments[ i ].uuid ] = i;

		}

		this._paths = []; // inside: string
		this._parsedPaths = []; // inside: { we don't care, here }
		this._bindings = []; // inside: Array< PropertyBinding >
		this._bindingsIndicesByPath = {}; // inside: indices in these arrays

		const scope = this;

		this.stats = {

			objects: {
				get total() {

					return scope._objects.length;

				},
				get inUse() {

					return this.total - scope.nCachedObjects_;

				}
			},
			get bindingsPerObject() {

				return scope._bindings.length;

			}

		};

	}

	add() {

		const objects = this._objects,
			indicesByUUID = this._indicesByUUID,
			paths = this._paths,
			parsedPaths = this._parsedPaths,
			bindings = this._bindings,
			nBindings = bindings.length;

		let knownObject = undefined,
			nObjects = objects.length,
			nCachedObjects = this.nCachedObjects_;

		for ( let i = 0, n = arguments.length; i !== n; ++ i ) {

			const object = arguments[ i ],
				uuid = object.uuid;
			let index = indicesByUUID[ uuid ];

			if ( index === undefined ) {

				// unknown object -> add it to the ACTIVE region

				index = nObjects ++;
				indicesByUUID[ uuid ] = index;
				objects.push( object );

				// accounting is done, now do the same for all bindings

				for ( let j = 0, m = nBindings; j !== m; ++ j ) {

					bindings[ j ].push( new PropertyBinding( object, paths[ j ], parsedPaths[ j ] ) );

				}

			} else if ( index < nCachedObjects ) {

				knownObject = objects[ index ];

				// move existing object to the ACTIVE region

				const firstActiveIndex = -- nCachedObjects,
					lastCachedObject = objects[ firstActiveIndex ];

				indicesByUUID[ lastCachedObject.uuid ] = index;
				objects[ index ] = lastCachedObject;

				indicesByUUID[ uuid ] = firstActiveIndex;
				objects[ firstActiveIndex ] = object;

				// accounting is done, now do the same for all bindings

				for ( let j = 0, m = nBindings; j !== m; ++ j ) {

					const bindingsForPath = bindings[ j ],
						lastCached = bindingsForPath[ firstActiveIndex ];

					let binding = bindingsForPath[ index ];

					bindingsForPath[ index ] = lastCached;

					if ( binding === undefined ) {

						// since we do not bother to create new bindings
						// for objects that are cached, the binding may
						// or may not exist

						binding = new PropertyBinding( object, paths[ j ], parsedPaths[ j ] );

					}

					bindingsForPath[ firstActiveIndex ] = binding;

				}

			} else if ( objects[ index ] !== knownObject ) {

				console.error( 'THREE.AnimationObjectGroup: Different objects with the same UUID ' +
					'detected. Clean the caches or recreate your infrastructure when reloading scenes.' );

			} // else the object is already where we want it to be

		} // for arguments

		this.nCachedObjects_ = nCachedObjects;

	}

	remove() {

		const objects = this._objects,
			indicesByUUID = this._indicesByUUID,
			bindings = this._bindings,
			nBindings = bindings.length;

		let nCachedObjects = this.nCachedObjects_;

		for ( let i = 0, n = arguments.length; i !== n; ++ i ) {

			const object = arguments[ i ],
				uuid = object.uuid,
				index = indicesByUUID[ uuid ];

			if ( index !== undefined && index >= nCachedObjects ) {

				// move existing object into the CACHED region

				const lastCachedIndex = nCachedObjects ++,
					firstActiveObject = objects[ lastCachedIndex ];

				indicesByUUID[ firstActiveObject.uuid ] = index;
				objects[ index ] = firstActiveObject;

				indicesByUUID[ uuid ] = lastCachedIndex;
				objects[ lastCachedIndex ] = object;

				// accounting is done, now do the same for all bindings

				for ( let j = 0, m = nBindings; j !== m; ++ j ) {

					const bindingsForPath = bindings[ j ],
						firstActive = bindingsForPath[ lastCachedIndex ],
						binding = bindingsForPath[ index ];

					bindingsForPath[ index ] = firstActive;
					bindingsForPath[ lastCachedIndex ] = binding;

				}

			}

		} // for arguments

		this.nCachedObjects_ = nCachedObjects;

	}

	// remove & forget
	uncache() {

		const objects = this._objects,
			indicesByUUID = this._indicesByUUID,
			bindings = this._bindings,
			nBindings = bindings.length;

		let nCachedObjects = this.nCachedObjects_,
			nObjects = objects.length;

		for ( let i = 0, n = arguments.length; i !== n; ++ i ) {

			const object = arguments[ i ],
				uuid = object.uuid,
				index = indicesByUUID[ uuid ];

			if ( index !== undefined ) {

				delete indicesByUUID[ uuid ];

				if ( index < nCachedObjects ) {

					// object is cached, shrink the CACHED region

					const firstActiveIndex = -- nCachedObjects,
						lastCachedObject = objects[ firstActiveIndex ],
						lastIndex = -- nObjects,
						lastObject = objects[ lastIndex ];

					// last cached object takes this object's place
					indicesByUUID[ lastCachedObject.uuid ] = index;
					objects[ index ] = lastCachedObject;

					// last object goes to the activated slot and pop
					indicesByUUID[ lastObject.uuid ] = firstActiveIndex;
					objects[ firstActiveIndex ] = lastObject;
					objects.pop();

					// accounting is done, now do the same for all bindings

					for ( let j = 0, m = nBindings; j !== m; ++ j ) {

						const bindingsForPath = bindings[ j ],
							lastCached = bindingsForPath[ firstActiveIndex ],
							last = bindingsForPath[ lastIndex ];

						bindingsForPath[ index ] = lastCached;
						bindingsForPath[ firstActiveIndex ] = last;
						bindingsForPath.pop();

					}

				} else {

					// object is active, just swap with the last and pop

					const lastIndex = -- nObjects,
						lastObject = objects[ lastIndex ];

					if ( lastIndex > 0 ) {

						indicesByUUID[ lastObject.uuid ] = index;

					}

					objects[ index ] = lastObject;
					objects.pop();

					// accounting is done, now do the same for all bindings

					for ( let j = 0, m = nBindings; j !== m; ++ j ) {

						const bindingsForPath = bindings[ j ];

						bindingsForPath[ index ] = bindingsForPath[ lastIndex ];
						bindingsForPath.pop();

					}

				} // cached or active

			} // if object is known

		} // for arguments

		this.nCachedObjects_ = nCachedObjects;

	}

	// Internal interface used by befriended PropertyBinding.Composite:

	subscribe_( path, parsedPath ) {

		// returns an array of bindings for the given path that is changed
		// according to the contained objects in the group

		const indicesByPath = this._bindingsIndicesByPath;
		let index = indicesByPath[ path ];
		const bindings = this._bindings;

		if ( index !== undefined ) return bindings[ index ];

		const paths = this._paths,
			parsedPaths = this._parsedPaths,
			objects = this._objects,
			nObjects = objects.length,
			nCachedObjects = this.nCachedObjects_,
			bindingsForPath = new Array( nObjects );

		index = bindings.length;

		indicesByPath[ path ] = index;

		paths.push( path );
		parsedPaths.push( parsedPath );
		bindings.push( bindingsForPath );

		for ( let i = nCachedObjects, n = objects.length; i !== n; ++ i ) {

			const object = objects[ i ];
			bindingsForPath[ i ] = new PropertyBinding( object, path, parsedPath );

		}

		return bindingsForPath;

	}

	unsubscribe_( path ) {

		// tells the group to forget about a property path and no longer
		// update the array previously obtained with 'subscribe_'

		const indicesByPath = this._bindingsIndicesByPath,
			index = indicesByPath[ path ];

		if ( index !== undefined ) {

			const paths = this._paths,
				parsedPaths = this._parsedPaths,
				bindings = this._bindings,
				lastBindingsIndex = bindings.length - 1,
				lastBindings = bindings[ lastBindingsIndex ],
				lastBindingsPath = path[ lastBindingsIndex ];

			indicesByPath[ lastBindingsPath ] = index;

			bindings[ index ] = lastBindings;
			bindings.pop();

			parsedPaths[ index ] = parsedPaths[ lastBindingsIndex ];
			parsedPaths.pop();

			paths[ index ] = paths[ lastBindingsIndex ];
			paths.pop();

		}

	}

}

class AnimationAction {

	constructor( mixer, clip, localRoot = null, blendMode = clip.blendMode ) {

		this._mixer = mixer;
		this._clip = clip;
		this._localRoot = localRoot;
		this.blendMode = blendMode;

		const tracks = clip.tracks,
			nTracks = tracks.length,
			interpolants = new Array( nTracks );

		const interpolantSettings = {
			endingStart: ZeroCurvatureEnding,
			endingEnd: ZeroCurvatureEnding
		};

		for ( let i = 0; i !== nTracks; ++ i ) {

			const interpolant = tracks[ i ].createInterpolant( null );
			interpolants[ i ] = interpolant;
			interpolant.settings = interpolantSettings;

		}

		this._interpolantSettings = interpolantSettings;

		this._interpolants = interpolants; // bound by the mixer

		// inside: PropertyMixer (managed by the mixer)
		this._propertyBindings = new Array( nTracks );

		this._cacheIndex = null; // for the memory manager
		this._byClipCacheIndex = null; // for the memory manager

		this._timeScaleInterpolant = null;
		this._weightInterpolant = null;

		this.loop = LoopRepeat;
		this._loopCount = - 1;

		// global mixer time when the action is to be started
		// it's set back to 'null' upon start of the action
		this._startTime = null;

		// scaled local time of the action
		// gets clamped or wrapped to 0..clip.duration according to loop
		this.time = 0;

		this.timeScale = 1;
		this._effectiveTimeScale = 1;

		this.weight = 1;
		this._effectiveWeight = 1;

		this.repetitions = Infinity; // no. of repetitions when looping

		this.paused = false; // true -> zero effective time scale
		this.enabled = true; // false -> zero effective weight

		this.clampWhenFinished = false;// keep feeding the last frame?

		this.zeroSlopeAtStart = true;// for smooth interpolation w/o separate
		this.zeroSlopeAtEnd = true;// clips for start, loop and end

	}

	// State & Scheduling

	play() {

		this._mixer._activateAction( this );

		return this;

	}

	stop() {

		this._mixer._deactivateAction( this );

		return this.reset();

	}

	reset() {

		this.paused = false;
		this.enabled = true;

		this.time = 0; // restart clip
		this._loopCount = - 1;// forget previous loops
		this._startTime = null;// forget scheduling

		return this.stopFading().stopWarping();

	}

	isRunning() {

		return this.enabled && ! this.paused && this.timeScale !== 0 &&
			this._startTime === null && this._mixer._isActiveAction( this );

	}

	// return true when play has been called
	isScheduled() {

		return this._mixer._isActiveAction( this );

	}

	startAt( time ) {

		this._startTime = time;

		return this;

	}

	setLoop( mode, repetitions ) {

		this.loop = mode;
		this.repetitions = repetitions;

		return this;

	}

	// Weight

	// set the weight stopping any scheduled fading
	// although .enabled = false yields an effective weight of zero, this
	// method does *not* change .enabled, because it would be confusing
	setEffectiveWeight( weight ) {

		this.weight = weight;

		// note: same logic as when updated at runtime
		this._effectiveWeight = this.enabled ? weight : 0;

		return this.stopFading();

	}

	// return the weight considering fading and .enabled
	getEffectiveWeight() {

		return this._effectiveWeight;

	}

	fadeIn( duration ) {

		return this._scheduleFading( duration, 0, 1 );

	}

	fadeOut( duration ) {

		return this._scheduleFading( duration, 1, 0 );

	}

	crossFadeFrom( fadeOutAction, duration, warp ) {

		fadeOutAction.fadeOut( duration );
		this.fadeIn( duration );

		if ( warp ) {

			const fadeInDuration = this._clip.duration,
				fadeOutDuration = fadeOutAction._clip.duration,

				startEndRatio = fadeOutDuration / fadeInDuration,
				endStartRatio = fadeInDuration / fadeOutDuration;

			fadeOutAction.warp( 1.0, startEndRatio, duration );
			this.warp( endStartRatio, 1.0, duration );

		}

		return this;

	}

	crossFadeTo( fadeInAction, duration, warp ) {

		return fadeInAction.crossFadeFrom( this, duration, warp );

	}

	stopFading() {

		const weightInterpolant = this._weightInterpolant;

		if ( weightInterpolant !== null ) {

			this._weightInterpolant = null;
			this._mixer._takeBackControlInterpolant( weightInterpolant );

		}

		return this;

	}

	// Time Scale Control

	// set the time scale stopping any scheduled warping
	// although .paused = true yields an effective time scale of zero, this
	// method does *not* change .paused, because it would be confusing
	setEffectiveTimeScale( timeScale ) {

		this.timeScale = timeScale;
		this._effectiveTimeScale = this.paused ? 0 : timeScale;

		return this.stopWarping();

	}

	// return the time scale considering warping and .paused
	getEffectiveTimeScale() {

		return this._effectiveTimeScale;

	}

	setDuration( duration ) {

		this.timeScale = this._clip.duration / duration;

		return this.stopWarping();

	}

	syncWith( action ) {

		this.time = action.time;
		this.timeScale = action.timeScale;

		return this.stopWarping();

	}

	halt( duration ) {

		return this.warp( this._effectiveTimeScale, 0, duration );

	}

	warp( startTimeScale, endTimeScale, duration ) {

		const mixer = this._mixer,
			now = mixer.time,
			timeScale = this.timeScale;

		let interpolant = this._timeScaleInterpolant;

		if ( interpolant === null ) {

			interpolant = mixer._lendControlInterpolant();
			this._timeScaleInterpolant = interpolant;

		}

		const times = interpolant.parameterPositions,
			values = interpolant.sampleValues;

		times[ 0 ] = now;
		times[ 1 ] = now + duration;

		values[ 0 ] = startTimeScale / timeScale;
		values[ 1 ] = endTimeScale / timeScale;

		return this;

	}

	stopWarping() {

		const timeScaleInterpolant = this._timeScaleInterpolant;

		if ( timeScaleInterpolant !== null ) {

			this._timeScaleInterpolant = null;
			this._mixer._takeBackControlInterpolant( timeScaleInterpolant );

		}

		return this;

	}

	// Object Accessors

	getMixer() {

		return this._mixer;

	}

	getClip() {

		return this._clip;

	}

	getRoot() {

		return this._localRoot || this._mixer._root;

	}

	// Interna

	_update( time, deltaTime, timeDirection, accuIndex ) {

		// called by the mixer

		if ( ! this.enabled ) {

			// call ._updateWeight() to update ._effectiveWeight

			this._updateWeight( time );
			return;

		}

		const startTime = this._startTime;

		if ( startTime !== null ) {

			// check for scheduled start of action

			const timeRunning = ( time - startTime ) * timeDirection;
			if ( timeRunning < 0 || timeDirection === 0 ) {

				deltaTime = 0;

			} else {


				this._startTime = null; // unschedule
				deltaTime = timeDirection * timeRunning;

			}

		}

		// apply time scale and advance time

		deltaTime *= this._updateTimeScale( time );
		const clipTime = this._updateTime( deltaTime );

		// note: _updateTime may disable the action resulting in
		// an effective weight of 0

		const weight = this._updateWeight( time );

		if ( weight > 0 ) {

			const interpolants = this._interpolants;
			const propertyMixers = this._propertyBindings;

			switch ( this.blendMode ) {

				case AdditiveAnimationBlendMode:

					for ( let j = 0, m = interpolants.length; j !== m; ++ j ) {

						interpolants[ j ].evaluate( clipTime );
						propertyMixers[ j ].accumulateAdditive( weight );

					}

					break;

				case NormalAnimationBlendMode:
				default:

					for ( let j = 0, m = interpolants.length; j !== m; ++ j ) {

						interpolants[ j ].evaluate( clipTime );
						propertyMixers[ j ].accumulate( accuIndex, weight );

					}

			}

		}

	}

	_updateWeight( time ) {

		let weight = 0;

		if ( this.enabled ) {

			weight = this.weight;
			const interpolant = this._weightInterpolant;

			if ( interpolant !== null ) {

				const interpolantValue = interpolant.evaluate( time )[ 0 ];

				weight *= interpolantValue;

				if ( time > interpolant.parameterPositions[ 1 ] ) {

					this.stopFading();

					if ( interpolantValue === 0 ) {

						// faded out, disable
						this.enabled = false;

					}

				}

			}

		}

		this._effectiveWeight = weight;
		return weight;

	}

	_updateTimeScale( time ) {

		let timeScale = 0;

		if ( ! this.paused ) {

			timeScale = this.timeScale;

			const interpolant = this._timeScaleInterpolant;

			if ( interpolant !== null ) {

				const interpolantValue = interpolant.evaluate( time )[ 0 ];

				timeScale *= interpolantValue;

				if ( time > interpolant.parameterPositions[ 1 ] ) {

					this.stopWarping();

					if ( timeScale === 0 ) {

						// motion has halted, pause
						this.paused = true;

					} else {

						// warp done - apply final time scale
						this.timeScale = timeScale;

					}

				}

			}

		}

		this._effectiveTimeScale = timeScale;
		return timeScale;

	}

	_updateTime( deltaTime ) {

		const duration = this._clip.duration;
		const loop = this.loop;

		let time = this.time + deltaTime;
		let loopCount = this._loopCount;

		const pingPong = ( loop === LoopPingPong );

		if ( deltaTime === 0 ) {

			if ( loopCount === - 1 ) return time;

			return ( pingPong && ( loopCount & 1 ) === 1 ) ? duration - time : time;

		}

		if ( loop === LoopOnce ) {

			if ( loopCount === - 1 ) {

				// just started

				this._loopCount = 0;
				this._setEndings( true, true, false );

			}

			handle_stop: {

				if ( time >= duration ) {

					time = duration;

				} else if ( time < 0 ) {

					time = 0;

				} else {

					this.time = time;

					break handle_stop;

				}

				if ( this.clampWhenFinished ) this.paused = true;
				else this.enabled = false;

				this.time = time;

				this._mixer.dispatchEvent( {
					type: 'finished', action: this,
					direction: deltaTime < 0 ? - 1 : 1
				} );

			}

		} else { // repetitive Repeat or PingPong

			if ( loopCount === - 1 ) {

				// just started

				if ( deltaTime >= 0 ) {

					loopCount = 0;

					this._setEndings( true, this.repetitions === 0, pingPong );

				} else {

					// when looping in reverse direction, the initial
					// transition through zero counts as a repetition,
					// so leave loopCount at -1

					this._setEndings( this.repetitions === 0, true, pingPong );

				}

			}

			if ( time >= duration || time < 0 ) {

				// wrap around

				const loopDelta = Math.floor( time / duration ); // signed
				time -= duration * loopDelta;

				loopCount += Math.abs( loopDelta );

				const pending = this.repetitions - loopCount;

				if ( pending <= 0 ) {

					// have to stop (switch state, clamp time, fire event)

					if ( this.clampWhenFinished ) this.paused = true;
					else this.enabled = false;

					time = deltaTime > 0 ? duration : 0;

					this.time = time;

					this._mixer.dispatchEvent( {
						type: 'finished', action: this,
						direction: deltaTime > 0 ? 1 : - 1
					} );

				} else {

					// keep running

					if ( pending === 1 ) {

						// entering the last round

						const atStart = deltaTime < 0;
						this._setEndings( atStart, ! atStart, pingPong );

					} else {

						this._setEndings( false, false, pingPong );

					}

					this._loopCount = loopCount;

					this.time = time;

					this._mixer.dispatchEvent( {
						type: 'loop', action: this, loopDelta: loopDelta
					} );

				}

			} else {

				this.time = time;

			}

			if ( pingPong && ( loopCount & 1 ) === 1 ) {

				// invert time for the "pong round"

				return duration - time;

			}

		}

		return time;

	}

	_setEndings( atStart, atEnd, pingPong ) {

		const settings = this._interpolantSettings;

		if ( pingPong ) {

			settings.endingStart = ZeroSlopeEnding;
			settings.endingEnd = ZeroSlopeEnding;

		} else {

			// assuming for LoopOnce atStart == atEnd == true

			if ( atStart ) {

				settings.endingStart = this.zeroSlopeAtStart ? ZeroSlopeEnding : ZeroCurvatureEnding;

			} else {

				settings.endingStart = WrapAroundEnding;

			}

			if ( atEnd ) {

				settings.endingEnd = this.zeroSlopeAtEnd ? ZeroSlopeEnding : ZeroCurvatureEnding;

			} else {

				settings.endingEnd 	 = WrapAroundEnding;

			}

		}

	}

	_scheduleFading( duration, weightNow, weightThen ) {

		const mixer = this._mixer, now = mixer.time;
		let interpolant = this._weightInterpolant;

		if ( interpolant === null ) {

			interpolant = mixer._lendControlInterpolant();
			this._weightInterpolant = interpolant;

		}

		const times = interpolant.parameterPositions,
			values = interpolant.sampleValues;

		times[ 0 ] = now;
		values[ 0 ] = weightNow;
		times[ 1 ] = now + duration;
		values[ 1 ] = weightThen;

		return this;

	}

}

const _controlInterpolantsResultBuffer = new Float32Array( 1 );


class AnimationMixer extends EventDispatcher {

	constructor( root ) {

		super();

		this._root = root;
		this._initMemoryManager();
		this._accuIndex = 0;
		this.time = 0;
		this.timeScale = 1.0;

	}

	_bindAction( action, prototypeAction ) {

		const root = action._localRoot || this._root,
			tracks = action._clip.tracks,
			nTracks = tracks.length,
			bindings = action._propertyBindings,
			interpolants = action._interpolants,
			rootUuid = root.uuid,
			bindingsByRoot = this._bindingsByRootAndName;

		let bindingsByName = bindingsByRoot[ rootUuid ];

		if ( bindingsByName === undefined ) {

			bindingsByName = {};
			bindingsByRoot[ rootUuid ] = bindingsByName;

		}

		for ( let i = 0; i !== nTracks; ++ i ) {

			const track = tracks[ i ],
				trackName = track.name;

			let binding = bindingsByName[ trackName ];

			if ( binding !== undefined ) {

				++ binding.referenceCount;
				bindings[ i ] = binding;

			} else {

				binding = bindings[ i ];

				if ( binding !== undefined ) {

					// existing binding, make sure the cache knows

					if ( binding._cacheIndex === null ) {

						++ binding.referenceCount;
						this._addInactiveBinding( binding, rootUuid, trackName );

					}

					continue;

				}

				const path = prototypeAction && prototypeAction.
					_propertyBindings[ i ].binding.parsedPath;

				binding = new PropertyMixer(
					PropertyBinding.create( root, trackName, path ),
					track.ValueTypeName, track.getValueSize() );

				++ binding.referenceCount;
				this._addInactiveBinding( binding, rootUuid, trackName );

				bindings[ i ] = binding;

			}

			interpolants[ i ].resultBuffer = binding.buffer;

		}

	}

	_activateAction( action ) {

		if ( ! this._isActiveAction( action ) ) {

			if ( action._cacheIndex === null ) {

				// this action has been forgotten by the cache, but the user
				// appears to be still using it -> rebind

				const rootUuid = ( action._localRoot || this._root ).uuid,
					clipUuid = action._clip.uuid,
					actionsForClip = this._actionsByClip[ clipUuid ];

				this._bindAction( action,
					actionsForClip && actionsForClip.knownActions[ 0 ] );

				this._addInactiveAction( action, clipUuid, rootUuid );

			}

			const bindings = action._propertyBindings;

			// increment reference counts / sort out state
			for ( let i = 0, n = bindings.length; i !== n; ++ i ) {

				const binding = bindings[ i ];

				if ( binding.useCount ++ === 0 ) {

					this._lendBinding( binding );
					binding.saveOriginalState();

				}

			}

			this._lendAction( action );

		}

	}

	_deactivateAction( action ) {

		if ( this._isActiveAction( action ) ) {

			const bindings = action._propertyBindings;

			// decrement reference counts / sort out state
			for ( let i = 0, n = bindings.length; i !== n; ++ i ) {

				const binding = bindings[ i ];

				if ( -- binding.useCount === 0 ) {

					binding.restoreOriginalState();
					this._takeBackBinding( binding );

				}

			}

			this._takeBackAction( action );

		}

	}

	// Memory manager

	_initMemoryManager() {

		this._actions = []; // 'nActiveActions' followed by inactive ones
		this._nActiveActions = 0;

		this._actionsByClip = {};
		// inside:
		// {
		// 	knownActions: Array< AnimationAction > - used as prototypes
		// 	actionByRoot: AnimationAction - lookup
		// }


		this._bindings = []; // 'nActiveBindings' followed by inactive ones
		this._nActiveBindings = 0;

		this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >


		this._controlInterpolants = []; // same game as above
		this._nActiveControlInterpolants = 0;

		const scope = this;

		this.stats = {

			actions: {
				get total() {

					return scope._actions.length;

				},
				get inUse() {

					return scope._nActiveActions;

				}
			},
			bindings: {
				get total() {

					return scope._bindings.length;

				},
				get inUse() {

					return scope._nActiveBindings;

				}
			},
			controlInterpolants: {
				get total() {

					return scope._controlInterpolants.length;

				},
				get inUse() {

					return scope._nActiveControlInterpolants;

				}
			}

		};

	}

	// Memory management for AnimationAction objects

	_isActiveAction( action ) {

		const index = action._cacheIndex;
		return index !== null && index < this._nActiveActions;

	}

	_addInactiveAction( action, clipUuid, rootUuid ) {

		const actions = this._actions,
			actionsByClip = this._actionsByClip;

		let actionsForClip = actionsByClip[ clipUuid ];

		if ( actionsForClip === undefined ) {

			actionsForClip = {

				knownActions: [ action ],
				actionByRoot: {}

			};

			action._byClipCacheIndex = 0;

			actionsByClip[ clipUuid ] = actionsForClip;

		} else {

			const knownActions = actionsForClip.knownActions;

			action._byClipCacheIndex = knownActions.length;
			knownActions.push( action );

		}

		action._cacheIndex = actions.length;
		actions.push( action );

		actionsForClip.actionByRoot[ rootUuid ] = action;

	}

	_removeInactiveAction( action ) {

		const actions = this._actions,
			lastInactiveAction = actions[ actions.length - 1 ],
			cacheIndex = action._cacheIndex;

		lastInactiveAction._cacheIndex = cacheIndex;
		actions[ cacheIndex ] = lastInactiveAction;
		actions.pop();

		action._cacheIndex = null;


		const clipUuid = action._clip.uuid,
			actionsByClip = this._actionsByClip,
			actionsForClip = actionsByClip[ clipUuid ],
			knownActionsForClip = actionsForClip.knownActions,

			lastKnownAction =
				knownActionsForClip[ knownActionsForClip.length - 1 ],

			byClipCacheIndex = action._byClipCacheIndex;

		lastKnownAction._byClipCacheIndex = byClipCacheIndex;
		knownActionsForClip[ byClipCacheIndex ] = lastKnownAction;
		knownActionsForClip.pop();

		action._byClipCacheIndex = null;


		const actionByRoot = actionsForClip.actionByRoot,
			rootUuid = ( action._localRoot || this._root ).uuid;

		delete actionByRoot[ rootUuid ];

		if ( knownActionsForClip.length === 0 ) {

			delete actionsByClip[ clipUuid ];

		}

		this._removeInactiveBindingsForAction( action );

	}

	_removeInactiveBindingsForAction( action ) {

		const bindings = action._propertyBindings;

		for ( let i = 0, n = bindings.length; i !== n; ++ i ) {

			const binding = bindings[ i ];

			if ( -- binding.referenceCount === 0 ) {

				this._removeInactiveBinding( binding );

			}

		}

	}

	_lendAction( action ) {

		// [ active actions |  inactive actions  ]
		// [  active actions >| inactive actions ]
		//                 s        a
		//                  <-swap->
		//                 a        s

		const actions = this._actions,
			prevIndex = action._cacheIndex,

			lastActiveIndex = this._nActiveActions ++,

			firstInactiveAction = actions[ lastActiveIndex ];

		action._cacheIndex = lastActiveIndex;
		actions[ lastActiveIndex ] = action;

		firstInactiveAction._cacheIndex = prevIndex;
		actions[ prevIndex ] = firstInactiveAction;

	}

	_takeBackAction( action ) {

		// [  active actions  | inactive actions ]
		// [ active actions |< inactive actions  ]
		//        a        s
		//         <-swap->
		//        s        a

		const actions = this._actions,
			prevIndex = action._cacheIndex,

			firstInactiveIndex = -- this._nActiveActions,

			lastActiveAction = actions[ firstInactiveIndex ];

		action._cacheIndex = firstInactiveIndex;
		actions[ firstInactiveIndex ] = action;

		lastActiveAction._cacheIndex = prevIndex;
		actions[ prevIndex ] = lastActiveAction;

	}

	// Memory management for PropertyMixer objects

	_addInactiveBinding( binding, rootUuid, trackName ) {

		const bindingsByRoot = this._bindingsByRootAndName,
			bindings = this._bindings;

		let bindingByName = bindingsByRoot[ rootUuid ];

		if ( bindingByName === undefined ) {

			bindingByName = {};
			bindingsByRoot[ rootUuid ] = bindingByName;

		}

		bindingByName[ trackName ] = binding;

		binding._cacheIndex = bindings.length;
		bindings.push( binding );

	}

	_removeInactiveBinding( binding ) {

		const bindings = this._bindings,
			propBinding = binding.binding,
			rootUuid = propBinding.rootNode.uuid,
			trackName = propBinding.path,
			bindingsByRoot = this._bindingsByRootAndName,
			bindingByName = bindingsByRoot[ rootUuid ],

			lastInactiveBinding = bindings[ bindings.length - 1 ],
			cacheIndex = binding._cacheIndex;

		lastInactiveBinding._cacheIndex = cacheIndex;
		bindings[ cacheIndex ] = lastInactiveBinding;
		bindings.pop();

		delete bindingByName[ trackName ];

		if ( Object.keys( bindingByName ).length === 0 ) {

			delete bindingsByRoot[ rootUuid ];

		}

	}

	_lendBinding( binding ) {

		const bindings = this._bindings,
			prevIndex = binding._cacheIndex,

			lastActiveIndex = this._nActiveBindings ++,

			firstInactiveBinding = bindings[ lastActiveIndex ];

		binding._cacheIndex = lastActiveIndex;
		bindings[ lastActiveIndex ] = binding;

		firstInactiveBinding._cacheIndex = prevIndex;
		bindings[ prevIndex ] = firstInactiveBinding;

	}

	_takeBackBinding( binding ) {

		const bindings = this._bindings,
			prevIndex = binding._cacheIndex,

			firstInactiveIndex = -- this._nActiveBindings,

			lastActiveBinding = bindings[ firstInactiveIndex ];

		binding._cacheIndex = firstInactiveIndex;
		bindings[ firstInactiveIndex ] = binding;

		lastActiveBinding._cacheIndex = prevIndex;
		bindings[ prevIndex ] = lastActiveBinding;

	}


	// Memory management of Interpolants for weight and time scale

	_lendControlInterpolant() {

		const interpolants = this._controlInterpolants,
			lastActiveIndex = this._nActiveControlInterpolants ++;

		let interpolant = interpolants[ lastActiveIndex ];

		if ( interpolant === undefined ) {

			interpolant = new LinearInterpolant(
				new Float32Array( 2 ), new Float32Array( 2 ),
				1, _controlInterpolantsResultBuffer );

			interpolant.__cacheIndex = lastActiveIndex;
			interpolants[ lastActiveIndex ] = interpolant;

		}

		return interpolant;

	}

	_takeBackControlInterpolant( interpolant ) {

		const interpolants = this._controlInterpolants,
			prevIndex = interpolant.__cacheIndex,

			firstInactiveIndex = -- this._nActiveControlInterpolants,

			lastActiveInterpolant = interpolants[ firstInactiveIndex ];

		interpolant.__cacheIndex = firstInactiveIndex;
		interpolants[ firstInactiveIndex ] = interpolant;

		lastActiveInterpolant.__cacheIndex = prevIndex;
		interpolants[ prevIndex ] = lastActiveInterpolant;

	}

	// return an action for a clip optionally using a custom root target
	// object (this method allocates a lot of dynamic memory in case a
	// previously unknown clip/root combination is specified)
	clipAction( clip, optionalRoot, blendMode ) {

		const root = optionalRoot || this._root,
			rootUuid = root.uuid;

		let clipObject = typeof clip === 'string' ? AnimationClip.findByName( root, clip ) : clip;

		const clipUuid = clipObject !== null ? clipObject.uuid : clip;

		const actionsForClip = this._actionsByClip[ clipUuid ];
		let prototypeAction = null;

		if ( blendMode === undefined ) {

			if ( clipObject !== null ) {

				blendMode = clipObject.blendMode;

			} else {

				blendMode = NormalAnimationBlendMode;

			}

		}

		if ( actionsForClip !== undefined ) {

			const existingAction = actionsForClip.actionByRoot[ rootUuid ];

			if ( existingAction !== undefined && existingAction.blendMode === blendMode ) {

				return existingAction;

			}

			// we know the clip, so we don't have to parse all
			// the bindings again but can just copy
			prototypeAction = actionsForClip.knownActions[ 0 ];

			// also, take the clip from the prototype action
			if ( clipObject === null )
				clipObject = prototypeAction._clip;

		}

		// clip must be known when specified via string
		if ( clipObject === null ) return null;

		// allocate all resources required to run it
		const newAction = new AnimationAction( this, clipObject, optionalRoot, blendMode );

		this._bindAction( newAction, prototypeAction );

		// and make the action known to the memory manager
		this._addInactiveAction( newAction, clipUuid, rootUuid );

		return newAction;

	}

	// get an existing action
	existingAction( clip, optionalRoot ) {

		const root = optionalRoot || this._root,
			rootUuid = root.uuid,

			clipObject = typeof clip === 'string' ?
				AnimationClip.findByName( root, clip ) : clip,

			clipUuid = clipObject ? clipObject.uuid : clip,

			actionsForClip = this._actionsByClip[ clipUuid ];

		if ( actionsForClip !== undefined ) {

			return actionsForClip.actionByRoot[ rootUuid ] || null;

		}

		return null;

	}

	// deactivates all previously scheduled actions
	stopAllAction() {

		const actions = this._actions,
			nActions = this._nActiveActions;

		for ( let i = nActions - 1; i >= 0; -- i ) {

			actions[ i ].stop();

		}

		return this;

	}

	// advance the time and update apply the animation
	update( deltaTime ) {

		deltaTime *= this.timeScale;

		const actions = this._actions,
			nActions = this._nActiveActions,

			time = this.time += deltaTime,
			timeDirection = Math.sign( deltaTime ),

			accuIndex = this._accuIndex ^= 1;

		// run active actions

		for ( let i = 0; i !== nActions; ++ i ) {

			const action = actions[ i ];

			action._update( time, deltaTime, timeDirection, accuIndex );

		}

		// update scene graph

		const bindings = this._bindings,
			nBindings = this._nActiveBindings;

		for ( let i = 0; i !== nBindings; ++ i ) {

			bindings[ i ].apply( accuIndex );

		}

		return this;

	}

	// Allows you to seek to a specific time in an animation.
	setTime( timeInSeconds ) {

		this.time = 0; // Zero out time attribute for AnimationMixer object;
		for ( let i = 0; i < this._actions.length; i ++ ) {

			this._actions[ i ].time = 0; // Zero out time attribute for all associated AnimationAction objects.

		}

		return this.update( timeInSeconds ); // Update used to set exact time. Returns "this" AnimationMixer object.

	}

	// return this mixer's root target object
	getRoot() {

		return this._root;

	}

	// free all resources specific to a particular clip
	uncacheClip( clip ) {

		const actions = this._actions,
			clipUuid = clip.uuid,
			actionsByClip = this._actionsByClip,
			actionsForClip = actionsByClip[ clipUuid ];

		if ( actionsForClip !== undefined ) {

			// note: just calling _removeInactiveAction would mess up the
			// iteration state and also require updating the state we can
			// just throw away

			const actionsToRemove = actionsForClip.knownActions;

			for ( let i = 0, n = actionsToRemove.length; i !== n; ++ i ) {

				const action = actionsToRemove[ i ];

				this._deactivateAction( action );

				const cacheIndex = action._cacheIndex,
					lastInactiveAction = actions[ actions.length - 1 ];

				action._cacheIndex = null;
				action._byClipCacheIndex = null;

				lastInactiveAction._cacheIndex = cacheIndex;
				actions[ cacheIndex ] = lastInactiveAction;
				actions.pop();

				this._removeInactiveBindingsForAction( action );

			}

			delete actionsByClip[ clipUuid ];

		}

	}

	// free all resources specific to a particular root target object
	uncacheRoot( root ) {

		const rootUuid = root.uuid,
			actionsByClip = this._actionsByClip;

		for ( const clipUuid in actionsByClip ) {

			const actionByRoot = actionsByClip[ clipUuid ].actionByRoot,
				action = actionByRoot[ rootUuid ];

			if ( action !== undefined ) {

				this._deactivateAction( action );
				this._removeInactiveAction( action );

			}

		}

		const bindingsByRoot = this._bindingsByRootAndName,
			bindingByName = bindingsByRoot[ rootUuid ];

		if ( bindingByName !== undefined ) {

			for ( const trackName in bindingByName ) {

				const binding = bindingByName[ trackName ];
				binding.restoreOriginalState();
				this._removeInactiveBinding( binding );

			}

		}

	}

	// remove a targeted clip from the cache
	uncacheAction( clip, optionalRoot ) {

		const action = this.existingAction( clip, optionalRoot );

		if ( action !== null ) {

			this._deactivateAction( action );
			this._removeInactiveAction( action );

		}

	}

}

class Uniform {

	constructor( value ) {

		this.value = value;

	}

	clone() {

		return new Uniform( this.value.clone === undefined ? this.value : this.value.clone() );

	}

}

let _id = 0;

class UniformsGroup extends EventDispatcher {

	constructor() {

		super();

		this.isUniformsGroup = true;

		Object.defineProperty( this, 'id', { value: _id ++ } );

		this.name = '';

		this.usage = StaticDrawUsage;
		this.uniforms = [];

	}

	add( uniform ) {

		this.uniforms.push( uniform );

		return this;

	}

	remove( uniform ) {

		const index = this.uniforms.indexOf( uniform );

		if ( index !== - 1 ) this.uniforms.splice( index, 1 );

		return this;

	}

	setName( name ) {

		this.name = name;

		return this;

	}

	setUsage( value ) {

		this.usage = value;

		return this;

	}

	dispose() {

		this.dispatchEvent( { type: 'dispose' } );

		return this;

	}

	copy( source ) {

		this.name = source.name;
		this.usage = source.usage;

		const uniformsSource = source.uniforms;

		this.uniforms.length = 0;

		for ( let i = 0, l = uniformsSource.length; i < l; i ++ ) {

			const uniforms = Array.isArray( uniformsSource[ i ] ) ? uniformsSource[ i ] : [ uniformsSource[ i ] ];

			for ( let j = 0; j < uniforms.length; j ++ ) {

				this.uniforms.push( uniforms[ j ].clone() );

			}

		}

		return this;

	}

	clone() {

		return new this.constructor().copy( this );

	}

}

class InstancedInterleavedBuffer extends InterleavedBuffer {

	constructor( array, stride, meshPerAttribute = 1 ) {

		super( array, stride );

		this.isInstancedInterleavedBuffer = true;

		this.meshPerAttribute = meshPerAttribute;

	}

	copy( source ) {

		super.copy( source );

		this.meshPerAttribute = source.meshPerAttribute;

		return this;

	}

	clone( data ) {

		const ib = super.clone( data );

		ib.meshPerAttribute = this.meshPerAttribute;

		return ib;

	}

	toJSON( data ) {

		const json = super.toJSON( data );

		json.isInstancedInterleavedBuffer = true;
		json.meshPerAttribute = this.meshPerAttribute;

		return json;

	}

}

class GLBufferAttribute {

	constructor( buffer, type, itemSize, elementSize, count ) {

		this.isGLBufferAttribute = true;

		this.name = '';

		this.buffer = buffer;
		this.type = type;
		this.itemSize = itemSize;
		this.elementSize = elementSize;
		this.count = count;

		this.version = 0;

	}

	set needsUpdate( value ) {

		if ( value === true ) this.version ++;

	}

	setBuffer( buffer ) {

		this.buffer = buffer;

		return this;

	}

	setType( type, elementSize ) {

		this.type = type;
		this.elementSize = elementSize;

		return this;

	}

	setItemSize( itemSize ) {

		this.itemSize = itemSize;

		return this;

	}

	setCount( count ) {

		this.count = count;

		return this;

	}

}

const _matrix = /*@__PURE__*/ new Matrix4();

class Raycaster {

	constructor( origin, direction, near = 0, far = Infinity ) {

		this.ray = new Ray( origin, direction );
		// direction is assumed to be normalized (for accurate distance calculations)

		this.near = near;
		this.far = far;
		this.camera = null;
		this.layers = new Layers();

		this.params = {
			Mesh: {},
			Line: { threshold: 1 },
			LOD: {},
			Points: { threshold: 1 },
			Sprite: {}
		};

	}

	set( origin, direction ) {

		// direction is assumed to be normalized (for accurate distance calculations)

		this.ray.set( origin, direction );

	}

	setFromCamera( coords, camera ) {

		if ( camera.isPerspectiveCamera ) {

			this.ray.origin.setFromMatrixPosition( camera.matrixWorld );
			this.ray.direction.set( coords.x, coords.y, 0.5 ).unproject( camera ).sub( this.ray.origin ).normalize();
			this.camera = camera;

		} else if ( camera.isOrthographicCamera ) {

			this.ray.origin.set( coords.x, coords.y, ( camera.near + camera.far ) / ( camera.near - camera.far ) ).unproject( camera ); // set origin in plane of camera
			this.ray.direction.set( 0, 0, - 1 ).transformDirection( camera.matrixWorld );
			this.camera = camera;

		} else {

			console.error( 'THREE.Raycaster: Unsupported camera type: ' + camera.type );

		}

	}

	setFromXRController( controller ) {

		_matrix.identity().extractRotation( controller.matrixWorld );

		this.ray.origin.setFromMatrixPosition( controller.matrixWorld );
		this.ray.direction.set( 0, 0, - 1 ).applyMatrix4( _matrix );

		return this;

	}

	intersectObject( object, recursive = true, intersects = [] ) {

		intersect( object, this, intersects, recursive );

		intersects.sort( ascSort );

		return intersects;

	}

	intersectObjects( objects, recursive = true, intersects = [] ) {

		for ( let i = 0, l = objects.length; i < l; i ++ ) {

			intersect( objects[ i ], this, intersects, recursive );

		}

		intersects.sort( ascSort );

		return intersects;

	}

}

function ascSort( a, b ) {

	return a.distance - b.distance;

}

function intersect( object, raycaster, intersects, recursive ) {

	if ( object.layers.test( raycaster.layers ) ) {

		object.raycast( raycaster, intersects );

	}

	if ( recursive === true ) {

		const children = object.children;

		for ( let i = 0, l = children.length; i < l; i ++ ) {

			intersect( children[ i ], raycaster, intersects, true );

		}

	}

}

/**
 * Ref: https://en.wikipedia.org/wiki/Spherical_coordinate_system
 *
 * phi (the polar angle) is measured from the positive y-axis. The positive y-axis is up.
 * theta (the azimuthal angle) is measured from the positive z-axis.
 */
class Spherical {

	constructor( radius = 1, phi = 0, theta = 0 ) {

		this.radius = radius;
		this.phi = phi; // polar angle
		this.theta = theta; // azimuthal angle

		return this;

	}

	set( radius, phi, theta ) {

		this.radius = radius;
		this.phi = phi;
		this.theta = theta;

		return this;

	}

	copy( other ) {

		this.radius = other.radius;
		this.phi = other.phi;
		this.theta = other.theta;

		return this;

	}

	// restrict phi to be between EPS and PI-EPS
	makeSafe() {

		const EPS = 0.000001;
		this.phi = Math.max( EPS, Math.min( Math.PI - EPS, this.phi ) );

		return this;

	}

	setFromVector3( v ) {

		return this.setFromCartesianCoords( v.x, v.y, v.z );

	}

	setFromCartesianCoords( x, y, z ) {

		this.radius = Math.sqrt( x * x + y * y + z * z );

		if ( this.radius === 0 ) {

			this.theta = 0;
			this.phi = 0;

		} else {

			this.theta = Math.atan2( x, z );
			this.phi = Math.acos( clamp( y / this.radius, - 1, 1 ) );

		}

		return this;

	}

	clone() {

		return new this.constructor().copy( this );

	}

}

/**
 * Ref: https://en.wikipedia.org/wiki/Cylindrical_coordinate_system
 */

class Cylindrical {

	constructor( radius = 1, theta = 0, y = 0 ) {

		this.radius = radius; // distance from the origin to a point in the x-z plane
		this.theta = theta; // counterclockwise angle in the x-z plane measured in radians from the positive z-axis
		this.y = y; // height above the x-z plane

		return this;

	}

	set( radius, theta, y ) {

		this.radius = radius;
		this.theta = theta;
		this.y = y;

		return this;

	}

	copy( other ) {

		this.radius = other.radius;
		this.theta = other.theta;
		this.y = other.y;

		return this;

	}

	setFromVector3( v ) {

		return this.setFromCartesianCoords( v.x, v.y, v.z );

	}

	setFromCartesianCoords( x, y, z ) {

		this.radius = Math.sqrt( x * x + z * z );
		this.theta = Math.atan2( x, z );
		this.y = y;

		return this;

	}

	clone() {

		return new this.constructor().copy( this );

	}

}

const _vector$4 = /*@__PURE__*/ new Vector2();

class Box2 {

	constructor( min = new Vector2( + Infinity, + Infinity ), max = new Vector2( - Infinity, - Infinity ) ) {

		this.isBox2 = true;

		this.min = min;
		this.max = max;

	}

	set( min, max ) {

		this.min.copy( min );
		this.max.copy( max );

		return this;

	}

	setFromPoints( points ) {

		this.makeEmpty();

		for ( let i = 0, il = points.length; i < il; i ++ ) {

			this.expandByPoint( points[ i ] );

		}

		return this;

	}

	setFromCenterAndSize( center, size ) {

		const halfSize = _vector$4.copy( size ).multiplyScalar( 0.5 );
		this.min.copy( center ).sub( halfSize );
		this.max.copy( center ).add( halfSize );

		return this;

	}

	clone() {

		return new this.constructor().copy( this );

	}

	copy( box ) {

		this.min.copy( box.min );
		this.max.copy( box.max );

		return this;

	}

	makeEmpty() {

		this.min.x = this.min.y = + Infinity;
		this.max.x = this.max.y = - Infinity;

		return this;

	}

	isEmpty() {

		// this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes

		return ( this.max.x < this.min.x ) || ( this.max.y < this.min.y );

	}

	getCenter( target ) {

		return this.isEmpty() ? target.set( 0, 0 ) : target.addVectors( this.min, this.max ).multiplyScalar( 0.5 );

	}

	getSize( target ) {

		return this.isEmpty() ? target.set( 0, 0 ) : target.subVectors( this.max, this.min );

	}

	expandByPoint( point ) {

		this.min.min( point );
		this.max.max( point );

		return this;

	}

	expandByVector( vector ) {

		this.min.sub( vector );
		this.max.add( vector );

		return this;

	}

	expandByScalar( scalar ) {

		this.min.addScalar( - scalar );
		this.max.addScalar( scalar );

		return this;

	}

	containsPoint( point ) {

		return point.x < this.min.x || point.x > this.max.x ||
			point.y < this.min.y || point.y > this.max.y ? false : true;

	}

	containsBox( box ) {

		return this.min.x <= box.min.x && box.max.x <= this.max.x &&
			this.min.y <= box.min.y && box.max.y <= this.max.y;

	}

	getParameter( point, target ) {

		// This can potentially have a divide by zero if the box
		// has a size dimension of 0.

		return target.set(
			( point.x - this.min.x ) / ( this.max.x - this.min.x ),
			( point.y - this.min.y ) / ( this.max.y - this.min.y )
		);

	}

	intersectsBox( box ) {

		// using 4 splitting planes to rule out intersections

		return box.max.x < this.min.x || box.min.x > this.max.x ||
			box.max.y < this.min.y || box.min.y > this.max.y ? false : true;

	}

	clampPoint( point, target ) {

		return target.copy( point ).clamp( this.min, this.max );

	}

	distanceToPoint( point ) {

		return this.clampPoint( point, _vector$4 ).distanceTo( point );

	}

	intersect( box ) {

		this.min.max( box.min );
		this.max.min( box.max );

		if ( this.isEmpty() ) this.makeEmpty();

		return this;

	}

	union( box ) {

		this.min.min( box.min );
		this.max.max( box.max );

		return this;

	}

	translate( offset ) {

		this.min.add( offset );
		this.max.add( offset );

		return this;

	}

	equals( box ) {

		return box.min.equals( this.min ) && box.max.equals( this.max );

	}

}

const _startP = /*@__PURE__*/ new Vector3();
const _startEnd = /*@__PURE__*/ new Vector3();

class Line3 {

	constructor( start = new Vector3(), end = new Vector3() ) {

		this.start = start;
		this.end = end;

	}

	set( start, end ) {

		this.start.copy( start );
		this.end.copy( end );

		return this;

	}

	copy( line ) {

		this.start.copy( line.start );
		this.end.copy( line.end );

		return this;

	}

	getCenter( target ) {

		return target.addVectors( this.start, this.end ).multiplyScalar( 0.5 );

	}

	delta( target ) {

		return target.subVectors( this.end, this.start );

	}

	distanceSq() {

		return this.start.distanceToSquared( this.end );

	}

	distance() {

		return this.start.distanceTo( this.end );

	}

	at( t, target ) {

		return this.delta( target ).multiplyScalar( t ).add( this.start );

	}

	closestPointToPointParameter( point, clampToLine ) {

		_startP.subVectors( point, this.start );
		_startEnd.subVectors( this.end, this.start );

		const startEnd2 = _startEnd.dot( _startEnd );
		const startEnd_startP = _startEnd.dot( _startP );

		let t = startEnd_startP / startEnd2;

		if ( clampToLine ) {

			t = clamp( t, 0, 1 );

		}

		return t;

	}

	closestPointToPoint( point, clampToLine, target ) {

		const t = this.closestPointToPointParameter( point, clampToLine );

		return this.delta( target ).multiplyScalar( t ).add( this.start );

	}

	applyMatrix4( matrix ) {

		this.start.applyMatrix4( matrix );
		this.end.applyMatrix4( matrix );

		return this;

	}

	equals( line ) {

		return line.start.equals( this.start ) && line.end.equals( this.end );

	}

	clone() {

		return new this.constructor().copy( this );

	}

}

const _vector$3 = /*@__PURE__*/ new Vector3();

class SpotLightHelper extends Object3D {

	constructor( light, color ) {

		super();

		this.light = light;

		this.matrixAutoUpdate = false;

		this.color = color;

		this.type = 'SpotLightHelper';

		const geometry = new BufferGeometry();

		const positions = [
			0, 0, 0, 	0, 0, 1,
			0, 0, 0, 	1, 0, 1,
			0, 0, 0,	- 1, 0, 1,
			0, 0, 0, 	0, 1, 1,
			0, 0, 0, 	0, - 1, 1
		];

		for ( let i = 0, j = 1, l = 32; i < l; i ++, j ++ ) {

			const p1 = ( i / l ) * Math.PI * 2;
			const p2 = ( j / l ) * Math.PI * 2;

			positions.push(
				Math.cos( p1 ), Math.sin( p1 ), 1,
				Math.cos( p2 ), Math.sin( p2 ), 1
			);

		}

		geometry.setAttribute( 'position', new Float32BufferAttribute( positions, 3 ) );

		const material = new LineBasicMaterial( { fog: false, toneMapped: false } );

		this.cone = new LineSegments( geometry, material );
		this.add( this.cone );

		this.update();

	}

	dispose() {

		this.cone.geometry.dispose();
		this.cone.material.dispose();

	}

	update() {

		this.light.updateWorldMatrix( true, false );
		this.light.target.updateWorldMatrix( true, false );

		// update the local matrix based on the parent and light target transforms
		if ( this.parent ) {

			this.parent.updateWorldMatrix( true );

			this.matrix
				.copy( this.parent.matrixWorld )
				.invert()
				.multiply( this.light.matrixWorld );

		} else {

			this.matrix.copy( this.light.matrixWorld );

		}

		this.matrixWorld.copy( this.light.matrixWorld );

		const coneLength = this.light.distance ? this.light.distance : 1000;
		const coneWidth = coneLength * Math.tan( this.light.angle );

		this.cone.scale.set( coneWidth, coneWidth, coneLength );

		_vector$3.setFromMatrixPosition( this.light.target.matrixWorld );

		this.cone.lookAt( _vector$3 );

		if ( this.color !== undefined ) {

			this.cone.material.color.set( this.color );

		} else {

			this.cone.material.color.copy( this.light.color );

		}

	}

}

const _vector$2 = /*@__PURE__*/ new Vector3();
const _boneMatrix = /*@__PURE__*/ new Matrix4();
const _matrixWorldInv = /*@__PURE__*/ new Matrix4();


class SkeletonHelper extends LineSegments {

	constructor( object ) {

		const bones = getBoneList( object );

		const geometry = new BufferGeometry();

		const vertices = [];
		const colors = [];

		const color1 = new Color( 0, 0, 1 );
		const color2 = new Color( 0, 1, 0 );

		for ( let i = 0; i < bones.length; i ++ ) {

			const bone = bones[ i ];

			if ( bone.parent && bone.parent.isBone ) {

				vertices.push( 0, 0, 0 );
				vertices.push( 0, 0, 0 );
				colors.push( color1.r, color1.g, color1.b );
				colors.push( color2.r, color2.g, color2.b );

			}

		}

		geometry.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		geometry.setAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );

		const material = new LineBasicMaterial( { vertexColors: true, depthTest: false, depthWrite: false, toneMapped: false, transparent: true } );

		super( geometry, material );

		this.isSkeletonHelper = true;

		this.type = 'SkeletonHelper';

		this.root = object;
		this.bones = bones;

		this.matrix = object.matrixWorld;
		this.matrixAutoUpdate = false;

	}

	updateMatrixWorld( force ) {

		const bones = this.bones;

		const geometry = this.geometry;
		const position = geometry.getAttribute( 'position' );

		_matrixWorldInv.copy( this.root.matrixWorld ).invert();

		for ( let i = 0, j = 0; i < bones.length; i ++ ) {

			const bone = bones[ i ];

			if ( bone.parent && bone.parent.isBone ) {

				_boneMatrix.multiplyMatrices( _matrixWorldInv, bone.matrixWorld );
				_vector$2.setFromMatrixPosition( _boneMatrix );
				position.setXYZ( j, _vector$2.x, _vector$2.y, _vector$2.z );

				_boneMatrix.multiplyMatrices( _matrixWorldInv, bone.parent.matrixWorld );
				_vector$2.setFromMatrixPosition( _boneMatrix );
				position.setXYZ( j + 1, _vector$2.x, _vector$2.y, _vector$2.z );

				j += 2;

			}

		}

		geometry.getAttribute( 'position' ).needsUpdate = true;

		super.updateMatrixWorld( force );

	}

	dispose() {

		this.geometry.dispose();
		this.material.dispose();

	}

}


function getBoneList( object ) {

	const boneList = [];

	if ( object.isBone === true ) {

		boneList.push( object );

	}

	for ( let i = 0; i < object.children.length; i ++ ) {

		boneList.push.apply( boneList, getBoneList( object.children[ i ] ) );

	}

	return boneList;

}

class PointLightHelper extends Mesh {

	constructor( light, sphereSize, color ) {

		const geometry = new SphereGeometry( sphereSize, 4, 2 );
		const material = new MeshBasicMaterial( { wireframe: true, fog: false, toneMapped: false } );

		super( geometry, material );

		this.light = light;

		this.color = color;

		this.type = 'PointLightHelper';

		this.matrix = this.light.matrixWorld;
		this.matrixAutoUpdate = false;

		this.update();


		/*
	// TODO: delete this comment?
	const distanceGeometry = new THREE.IcosahedronGeometry( 1, 2 );
	const distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );

	this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
	this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );

	const d = light.distance;

	if ( d === 0.0 ) {

		this.lightDistance.visible = false;

	} else {

		this.lightDistance.scale.set( d, d, d );

	}

	this.add( this.lightDistance );
	*/

	}

	dispose() {

		this.geometry.dispose();
		this.material.dispose();

	}

	update() {

		this.light.updateWorldMatrix( true, false );

		if ( this.color !== undefined ) {

			this.material.color.set( this.color );

		} else {

			this.material.color.copy( this.light.color );

		}

		/*
		const d = this.light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.visible = true;
			this.lightDistance.scale.set( d, d, d );

		}
		*/

	}

}

const _vector$1 = /*@__PURE__*/ new Vector3();
const _color1 = /*@__PURE__*/ new Color();
const _color2 = /*@__PURE__*/ new Color();

class HemisphereLightHelper extends Object3D {

	constructor( light, size, color ) {

		super();

		this.light = light;

		this.matrix = light.matrixWorld;
		this.matrixAutoUpdate = false;

		this.color = color;

		this.type = 'HemisphereLightHelper';

		const geometry = new OctahedronGeometry( size );
		geometry.rotateY( Math.PI * 0.5 );

		this.material = new MeshBasicMaterial( { wireframe: true, fog: false, toneMapped: false } );
		if ( this.color === undefined ) this.material.vertexColors = true;

		const position = geometry.getAttribute( 'position' );
		const colors = new Float32Array( position.count * 3 );

		geometry.setAttribute( 'color', new BufferAttribute( colors, 3 ) );

		this.add( new Mesh( geometry, this.material ) );

		this.update();

	}

	dispose() {

		this.children[ 0 ].geometry.dispose();
		this.children[ 0 ].material.dispose();

	}

	update() {

		const mesh = this.children[ 0 ];

		if ( this.color !== undefined ) {

			this.material.color.set( this.color );

		} else {

			const colors = mesh.geometry.getAttribute( 'color' );

			_color1.copy( this.light.color );
			_color2.copy( this.light.groundColor );

			for ( let i = 0, l = colors.count; i < l; i ++ ) {

				const color = ( i < ( l / 2 ) ) ? _color1 : _color2;

				colors.setXYZ( i, color.r, color.g, color.b );

			}

			colors.needsUpdate = true;

		}

		this.light.updateWorldMatrix( true, false );

		mesh.lookAt( _vector$1.setFromMatrixPosition( this.light.matrixWorld ).negate() );

	}

}

class GridHelper extends LineSegments {

	constructor( size = 10, divisions = 10, color1 = 0x444444, color2 = 0x888888 ) {

		color1 = new Color( color1 );
		color2 = new Color( color2 );

		const center = divisions / 2;
		const step = size / divisions;
		const halfSize = size / 2;

		const vertices = [], colors = [];

		for ( let i = 0, j = 0, k = - halfSize; i <= divisions; i ++, k += step ) {

			vertices.push( - halfSize, 0, k, halfSize, 0, k );
			vertices.push( k, 0, - halfSize, k, 0, halfSize );

			const color = i === center ? color1 : color2;

			color.toArray( colors, j ); j += 3;
			color.toArray( colors, j ); j += 3;
			color.toArray( colors, j ); j += 3;
			color.toArray( colors, j ); j += 3;

		}

		const geometry = new BufferGeometry();
		geometry.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		geometry.setAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );

		const material = new LineBasicMaterial( { vertexColors: true, toneMapped: false } );

		super( geometry, material );

		this.type = 'GridHelper';

	}

	dispose() {

		this.geometry.dispose();
		this.material.dispose();

	}

}

class PolarGridHelper extends LineSegments {

	constructor( radius = 10, sectors = 16, rings = 8, divisions = 64, color1 = 0x444444, color2 = 0x888888 ) {

		color1 = new Color( color1 );
		color2 = new Color( color2 );

		const vertices = [];
		const colors = [];

		// create the sectors

		if ( sectors > 1 ) {

			for ( let i = 0; i < sectors; i ++ ) {

				const v = ( i / sectors ) * ( Math.PI * 2 );

				const x = Math.sin( v ) * radius;
				const z = Math.cos( v ) * radius;

				vertices.push( 0, 0, 0 );
				vertices.push( x, 0, z );

				const color = ( i & 1 ) ? color1 : color2;

				colors.push( color.r, color.g, color.b );
				colors.push( color.r, color.g, color.b );

			}

		}

		// create the rings

		for ( let i = 0; i < rings; i ++ ) {

			const color = ( i & 1 ) ? color1 : color2;

			const r = radius - ( radius / rings * i );

			for ( let j = 0; j < divisions; j ++ ) {

				// first vertex

				let v = ( j / divisions ) * ( Math.PI * 2 );

				let x = Math.sin( v ) * r;
				let z = Math.cos( v ) * r;

				vertices.push( x, 0, z );
				colors.push( color.r, color.g, color.b );

				// second vertex

				v = ( ( j + 1 ) / divisions ) * ( Math.PI * 2 );

				x = Math.sin( v ) * r;
				z = Math.cos( v ) * r;

				vertices.push( x, 0, z );
				colors.push( color.r, color.g, color.b );

			}

		}

		const geometry = new BufferGeometry();
		geometry.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		geometry.setAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );

		const material = new LineBasicMaterial( { vertexColors: true, toneMapped: false } );

		super( geometry, material );

		this.type = 'PolarGridHelper';

	}

	dispose() {

		this.geometry.dispose();
		this.material.dispose();

	}

}

const _v1 = /*@__PURE__*/ new Vector3();
const _v2 = /*@__PURE__*/ new Vector3();
const _v3 = /*@__PURE__*/ new Vector3();

class DirectionalLightHelper extends Object3D {

	constructor( light, size, color ) {

		super();

		this.light = light;

		this.matrix = light.matrixWorld;
		this.matrixAutoUpdate = false;

		this.color = color;

		this.type = 'DirectionalLightHelper';

		if ( size === undefined ) size = 1;

		let geometry = new BufferGeometry();
		geometry.setAttribute( 'position', new Float32BufferAttribute( [
			- size, size, 0,
			size, size, 0,
			size, - size, 0,
			- size, - size, 0,
			- size, size, 0
		], 3 ) );

		const material = new LineBasicMaterial( { fog: false, toneMapped: false } );

		this.lightPlane = new Line( geometry, material );
		this.add( this.lightPlane );

		geometry = new BufferGeometry();
		geometry.setAttribute( 'position', new Float32BufferAttribute( [ 0, 0, 0, 0, 0, 1 ], 3 ) );

		this.targetLine = new Line( geometry, material );
		this.add( this.targetLine );

		this.update();

	}

	dispose() {

		this.lightPlane.geometry.dispose();
		this.lightPlane.material.dispose();
		this.targetLine.geometry.dispose();
		this.targetLine.material.dispose();

	}

	update() {

		this.light.updateWorldMatrix( true, false );
		this.light.target.updateWorldMatrix( true, false );

		_v1.setFromMatrixPosition( this.light.matrixWorld );
		_v2.setFromMatrixPosition( this.light.target.matrixWorld );
		_v3.subVectors( _v2, _v1 );

		this.lightPlane.lookAt( _v2 );

		if ( this.color !== undefined ) {

			this.lightPlane.material.color.set( this.color );
			this.targetLine.material.color.set( this.color );

		} else {

			this.lightPlane.material.color.copy( this.light.color );
			this.targetLine.material.color.copy( this.light.color );

		}

		this.targetLine.lookAt( _v2 );
		this.targetLine.scale.z = _v3.length();

	}

}

const _vector = /*@__PURE__*/ new Vector3();
const _camera = /*@__PURE__*/ new Camera();

/**
 *	- shows frustum, line of sight and up of the camera
 *	- suitable for fast updates
 * 	- based on frustum visualization in lightgl.js shadowmap example
 *		https://github.com/evanw/lightgl.js/blob/master/tests/shadowmap.html
 */

class CameraHelper extends LineSegments {

	constructor( camera ) {

		const geometry = new BufferGeometry();
		const material = new LineBasicMaterial( { color: 0xffffff, vertexColors: true, toneMapped: false } );

		const vertices = [];
		const colors = [];

		const pointMap = {};

		// near

		addLine( 'n1', 'n2' );
		addLine( 'n2', 'n4' );
		addLine( 'n4', 'n3' );
		addLine( 'n3', 'n1' );

		// far

		addLine( 'f1', 'f2' );
		addLine( 'f2', 'f4' );
		addLine( 'f4', 'f3' );
		addLine( 'f3', 'f1' );

		// sides

		addLine( 'n1', 'f1' );
		addLine( 'n2', 'f2' );
		addLine( 'n3', 'f3' );
		addLine( 'n4', 'f4' );

		// cone

		addLine( 'p', 'n1' );
		addLine( 'p', 'n2' );
		addLine( 'p', 'n3' );
		addLine( 'p', 'n4' );

		// up

		addLine( 'u1', 'u2' );
		addLine( 'u2', 'u3' );
		addLine( 'u3', 'u1' );

		// target

		addLine( 'c', 't' );
		addLine( 'p', 'c' );

		// cross

		addLine( 'cn1', 'cn2' );
		addLine( 'cn3', 'cn4' );

		addLine( 'cf1', 'cf2' );
		addLine( 'cf3', 'cf4' );

		function addLine( a, b ) {

			addPoint( a );
			addPoint( b );

		}

		function addPoint( id ) {

			vertices.push( 0, 0, 0 );
			colors.push( 0, 0, 0 );

			if ( pointMap[ id ] === undefined ) {

				pointMap[ id ] = [];

			}

			pointMap[ id ].push( ( vertices.length / 3 ) - 1 );

		}

		geometry.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		geometry.setAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );

		super( geometry, material );

		this.type = 'CameraHelper';

		this.camera = camera;
		if ( this.camera.updateProjectionMatrix ) this.camera.updateProjectionMatrix();

		this.matrix = camera.matrixWorld;
		this.matrixAutoUpdate = false;

		this.pointMap = pointMap;

		this.update();

		// colors

		const colorFrustum = new Color( 0xffaa00 );
		const colorCone = new Color( 0xff0000 );
		const colorUp = new Color( 0x00aaff );
		const colorTarget = new Color( 0xffffff );
		const colorCross = new Color( 0x333333 );

		this.setColors( colorFrustum, colorCone, colorUp, colorTarget, colorCross );

	}

	setColors( frustum, cone, up, target, cross ) {

		const geometry = this.geometry;

		const colorAttribute = geometry.getAttribute( 'color' );

		// near

		colorAttribute.setXYZ( 0, frustum.r, frustum.g, frustum.b ); colorAttribute.setXYZ( 1, frustum.r, frustum.g, frustum.b ); // n1, n2
		colorAttribute.setXYZ( 2, frustum.r, frustum.g, frustum.b ); colorAttribute.setXYZ( 3, frustum.r, frustum.g, frustum.b ); // n2, n4
		colorAttribute.setXYZ( 4, frustum.r, frustum.g, frustum.b ); colorAttribute.setXYZ( 5, frustum.r, frustum.g, frustum.b ); // n4, n3
		colorAttribute.setXYZ( 6, frustum.r, frustum.g, frustum.b ); colorAttribute.setXYZ( 7, frustum.r, frustum.g, frustum.b ); // n3, n1

		// far

		colorAttribute.setXYZ( 8, frustum.r, frustum.g, frustum.b ); colorAttribute.setXYZ( 9, frustum.r, frustum.g, frustum.b ); // f1, f2
		colorAttribute.setXYZ( 10, frustum.r, frustum.g, frustum.b ); colorAttribute.setXYZ( 11, frustum.r, frustum.g, frustum.b ); // f2, f4
		colorAttribute.setXYZ( 12, frustum.r, frustum.g, frustum.b ); colorAttribute.setXYZ( 13, frustum.r, frustum.g, frustum.b ); // f4, f3
		colorAttribute.setXYZ( 14, frustum.r, frustum.g, frustum.b ); colorAttribute.setXYZ( 15, frustum.r, frustum.g, frustum.b ); // f3, f1

		// sides

		colorAttribute.setXYZ( 16, frustum.r, frustum.g, frustum.b ); colorAttribute.setXYZ( 17, frustum.r, frustum.g, frustum.b ); // n1, f1
		colorAttribute.setXYZ( 18, frustum.r, frustum.g, frustum.b ); colorAttribute.setXYZ( 19, frustum.r, frustum.g, frustum.b ); // n2, f2
		colorAttribute.setXYZ( 20, frustum.r, frustum.g, frustum.b ); colorAttribute.setXYZ( 21, frustum.r, frustum.g, frustum.b ); // n3, f3
		colorAttribute.setXYZ( 22, frustum.r, frustum.g, frustum.b ); colorAttribute.setXYZ( 23, frustum.r, frustum.g, frustum.b ); // n4, f4

		// cone

		colorAttribute.setXYZ( 24, cone.r, cone.g, cone.b ); colorAttribute.setXYZ( 25, cone.r, cone.g, cone.b ); // p, n1
		colorAttribute.setXYZ( 26, cone.r, cone.g, cone.b ); colorAttribute.setXYZ( 27, cone.r, cone.g, cone.b ); // p, n2
		colorAttribute.setXYZ( 28, cone.r, cone.g, cone.b ); colorAttribute.setXYZ( 29, cone.r, cone.g, cone.b ); // p, n3
		colorAttribute.setXYZ( 30, cone.r, cone.g, cone.b ); colorAttribute.setXYZ( 31, cone.r, cone.g, cone.b ); // p, n4

		// up

		colorAttribute.setXYZ( 32, up.r, up.g, up.b ); colorAttribute.setXYZ( 33, up.r, up.g, up.b ); // u1, u2
		colorAttribute.setXYZ( 34, up.r, up.g, up.b ); colorAttribute.setXYZ( 35, up.r, up.g, up.b ); // u2, u3
		colorAttribute.setXYZ( 36, up.r, up.g, up.b ); colorAttribute.setXYZ( 37, up.r, up.g, up.b ); // u3, u1

		// target

		colorAttribute.setXYZ( 38, target.r, target.g, target.b ); colorAttribute.setXYZ( 39, target.r, target.g, target.b ); // c, t
		colorAttribute.setXYZ( 40, cross.r, cross.g, cross.b ); colorAttribute.setXYZ( 41, cross.r, cross.g, cross.b ); // p, c

		// cross

		colorAttribute.setXYZ( 42, cross.r, cross.g, cross.b ); colorAttribute.setXYZ( 43, cross.r, cross.g, cross.b ); // cn1, cn2
		colorAttribute.setXYZ( 44, cross.r, cross.g, cross.b ); colorAttribute.setXYZ( 45, cross.r, cross.g, cross.b ); // cn3, cn4

		colorAttribute.setXYZ( 46, cross.r, cross.g, cross.b ); colorAttribute.setXYZ( 47, cross.r, cross.g, cross.b ); // cf1, cf2
		colorAttribute.setXYZ( 48, cross.r, cross.g, cross.b ); colorAttribute.setXYZ( 49, cross.r, cross.g, cross.b ); // cf3, cf4

		colorAttribute.needsUpdate = true;

	}

	update() {

		const geometry = this.geometry;
		const pointMap = this.pointMap;

		const w = 1, h = 1;

		// we need just camera projection matrix inverse
		// world matrix must be identity

		_camera.projectionMatrixInverse.copy( this.camera.projectionMatrixInverse );

		// center / target

		setPoint( 'c', pointMap, geometry, _camera, 0, 0, - 1 );
		setPoint( 't', pointMap, geometry, _camera, 0, 0, 1 );

		// near

		setPoint( 'n1', pointMap, geometry, _camera, - w, - h, - 1 );
		setPoint( 'n2', pointMap, geometry, _camera, w, - h, - 1 );
		setPoint( 'n3', pointMap, geometry, _camera, - w, h, - 1 );
		setPoint( 'n4', pointMap, geometry, _camera, w, h, - 1 );

		// far

		setPoint( 'f1', pointMap, geometry, _camera, - w, - h, 1 );
		setPoint( 'f2', pointMap, geometry, _camera, w, - h, 1 );
		setPoint( 'f3', pointMap, geometry, _camera, - w, h, 1 );
		setPoint( 'f4', pointMap, geometry, _camera, w, h, 1 );

		// up

		setPoint( 'u1', pointMap, geometry, _camera, w * 0.7, h * 1.1, - 1 );
		setPoint( 'u2', pointMap, geometry, _camera, - w * 0.7, h * 1.1, - 1 );
		setPoint( 'u3', pointMap, geometry, _camera, 0, h * 2, - 1 );

		// cross

		setPoint( 'cf1', pointMap, geometry, _camera, - w, 0, 1 );
		setPoint( 'cf2', pointMap, geometry, _camera, w, 0, 1 );
		setPoint( 'cf3', pointMap, geometry, _camera, 0, - h, 1 );
		setPoint( 'cf4', pointMap, geometry, _camera, 0, h, 1 );

		setPoint( 'cn1', pointMap, geometry, _camera, - w, 0, - 1 );
		setPoint( 'cn2', pointMap, geometry, _camera, w, 0, - 1 );
		setPoint( 'cn3', pointMap, geometry, _camera, 0, - h, - 1 );
		setPoint( 'cn4', pointMap, geometry, _camera, 0, h, - 1 );

		geometry.getAttribute( 'position' ).needsUpdate = true;

	}

	dispose() {

		this.geometry.dispose();
		this.material.dispose();

	}

}


function setPoint( point, pointMap, geometry, camera, x, y, z ) {

	_vector.set( x, y, z ).unproject( camera );

	const points = pointMap[ point ];

	if ( points !== undefined ) {

		const position = geometry.getAttribute( 'position' );

		for ( let i = 0, l = points.length; i < l; i ++ ) {

			position.setXYZ( points[ i ], _vector.x, _vector.y, _vector.z );

		}

	}

}

const _box = /*@__PURE__*/ new Box3();

class BoxHelper extends LineSegments {

	constructor( object, color = 0xffff00 ) {

		const indices = new Uint16Array( [ 0, 1, 1, 2, 2, 3, 3, 0, 4, 5, 5, 6, 6, 7, 7, 4, 0, 4, 1, 5, 2, 6, 3, 7 ] );
		const positions = new Float32Array( 8 * 3 );

		const geometry = new BufferGeometry();
		geometry.setIndex( new BufferAttribute( indices, 1 ) );
		geometry.setAttribute( 'position', new BufferAttribute( positions, 3 ) );

		super( geometry, new LineBasicMaterial( { color: color, toneMapped: false } ) );

		this.object = object;
		this.type = 'BoxHelper';

		this.matrixAutoUpdate = false;

		this.update();

	}

	update( object ) {

		if ( object !== undefined ) {

			console.warn( 'THREE.BoxHelper: .update() has no longer arguments.' );

		}

		if ( this.object !== undefined ) {

			_box.setFromObject( this.object );

		}

		if ( _box.isEmpty() ) return;

		const min = _box.min;
		const max = _box.max;

		/*
			5____4
		1/___0/|
		| 6__|_7
		2/___3/

		0: max.x, max.y, max.z
		1: min.x, max.y, max.z
		2: min.x, min.y, max.z
		3: max.x, min.y, max.z
		4: max.x, max.y, min.z
		5: min.x, max.y, min.z
		6: min.x, min.y, min.z
		7: max.x, min.y, min.z
		*/

		const position = this.geometry.attributes.position;
		const array = position.array;

		array[ 0 ] = max.x; array[ 1 ] = max.y; array[ 2 ] = max.z;
		array[ 3 ] = min.x; array[ 4 ] = max.y; array[ 5 ] = max.z;
		array[ 6 ] = min.x; array[ 7 ] = min.y; array[ 8 ] = max.z;
		array[ 9 ] = max.x; array[ 10 ] = min.y; array[ 11 ] = max.z;
		array[ 12 ] = max.x; array[ 13 ] = max.y; array[ 14 ] = min.z;
		array[ 15 ] = min.x; array[ 16 ] = max.y; array[ 17 ] = min.z;
		array[ 18 ] = min.x; array[ 19 ] = min.y; array[ 20 ] = min.z;
		array[ 21 ] = max.x; array[ 22 ] = min.y; array[ 23 ] = min.z;

		position.needsUpdate = true;

		this.geometry.computeBoundingSphere();

	}

	setFromObject( object ) {

		this.object = object;
		this.update();

		return this;

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		this.object = source.object;

		return this;

	}

	dispose() {

		this.geometry.dispose();
		this.material.dispose();

	}

}

class Box3Helper extends LineSegments {

	constructor( box, color = 0xffff00 ) {

		const indices = new Uint16Array( [ 0, 1, 1, 2, 2, 3, 3, 0, 4, 5, 5, 6, 6, 7, 7, 4, 0, 4, 1, 5, 2, 6, 3, 7 ] );

		const positions = [ 1, 1, 1, - 1, 1, 1, - 1, - 1, 1, 1, - 1, 1, 1, 1, - 1, - 1, 1, - 1, - 1, - 1, - 1, 1, - 1, - 1 ];

		const geometry = new BufferGeometry();

		geometry.setIndex( new BufferAttribute( indices, 1 ) );

		geometry.setAttribute( 'position', new Float32BufferAttribute( positions, 3 ) );

		super( geometry, new LineBasicMaterial( { color: color, toneMapped: false } ) );

		this.box = box;

		this.type = 'Box3Helper';

		this.geometry.computeBoundingSphere();

	}

	updateMatrixWorld( force ) {

		const box = this.box;

		if ( box.isEmpty() ) return;

		box.getCenter( this.position );

		box.getSize( this.scale );

		this.scale.multiplyScalar( 0.5 );

		super.updateMatrixWorld( force );

	}

	dispose() {

		this.geometry.dispose();
		this.material.dispose();

	}

}

class PlaneHelper extends Line {

	constructor( plane, size = 1, hex = 0xffff00 ) {

		const color = hex;

		const positions = [ 1, - 1, 0, - 1, 1, 0, - 1, - 1, 0, 1, 1, 0, - 1, 1, 0, - 1, - 1, 0, 1, - 1, 0, 1, 1, 0 ];

		const geometry = new BufferGeometry();
		geometry.setAttribute( 'position', new Float32BufferAttribute( positions, 3 ) );
		geometry.computeBoundingSphere();

		super( geometry, new LineBasicMaterial( { color: color, toneMapped: false } ) );

		this.type = 'PlaneHelper';

		this.plane = plane;

		this.size = size;

		const positions2 = [ 1, 1, 0, - 1, 1, 0, - 1, - 1, 0, 1, 1, 0, - 1, - 1, 0, 1, - 1, 0 ];

		const geometry2 = new BufferGeometry();
		geometry2.setAttribute( 'position', new Float32BufferAttribute( positions2, 3 ) );
		geometry2.computeBoundingSphere();

		this.add( new Mesh( geometry2, new MeshBasicMaterial( { color: color, opacity: 0.2, transparent: true, depthWrite: false, toneMapped: false } ) ) );

	}

	updateMatrixWorld( force ) {

		this.position.set( 0, 0, 0 );

		this.scale.set( 0.5 * this.size, 0.5 * this.size, 1 );

		this.lookAt( this.plane.normal );

		this.translateZ( - this.plane.constant );

		super.updateMatrixWorld( force );

	}

	dispose() {

		this.geometry.dispose();
		this.material.dispose();
		this.children[ 0 ].geometry.dispose();
		this.children[ 0 ].material.dispose();

	}

}

const _axis = /*@__PURE__*/ new Vector3();
let _lineGeometry, _coneGeometry;

class ArrowHelper extends Object3D {

	// dir is assumed to be normalized

	constructor( dir = new Vector3( 0, 0, 1 ), origin = new Vector3( 0, 0, 0 ), length = 1, color = 0xffff00, headLength = length * 0.2, headWidth = headLength * 0.2 ) {

		super();

		this.type = 'ArrowHelper';

		if ( _lineGeometry === undefined ) {

			_lineGeometry = new BufferGeometry();
			_lineGeometry.setAttribute( 'position', new Float32BufferAttribute( [ 0, 0, 0, 0, 1, 0 ], 3 ) );

			_coneGeometry = new CylinderGeometry( 0, 0.5, 1, 5, 1 );
			_coneGeometry.translate( 0, - 0.5, 0 );

		}

		this.position.copy( origin );

		this.line = new Line( _lineGeometry, new LineBasicMaterial( { color: color, toneMapped: false } ) );
		this.line.matrixAutoUpdate = false;
		this.add( this.line );

		this.cone = new Mesh( _coneGeometry, new MeshBasicMaterial( { color: color, toneMapped: false } ) );
		this.cone.matrixAutoUpdate = false;
		this.add( this.cone );

		this.setDirection( dir );
		this.setLength( length, headLength, headWidth );

	}

	setDirection( dir ) {

		// dir is assumed to be normalized

		if ( dir.y > 0.99999 ) {

			this.quaternion.set( 0, 0, 0, 1 );

		} else if ( dir.y < - 0.99999 ) {

			this.quaternion.set( 1, 0, 0, 0 );

		} else {

			_axis.set( dir.z, 0, - dir.x ).normalize();

			const radians = Math.acos( dir.y );

			this.quaternion.setFromAxisAngle( _axis, radians );

		}

	}

	setLength( length, headLength = length * 0.2, headWidth = headLength * 0.2 ) {

		this.line.scale.set( 1, Math.max( 0.0001, length - headLength ), 1 ); // see #17458
		this.line.updateMatrix();

		this.cone.scale.set( headWidth, headLength, headWidth );
		this.cone.position.y = length;
		this.cone.updateMatrix();

	}

	setColor( color ) {

		this.line.material.color.set( color );
		this.cone.material.color.set( color );

	}

	copy( source ) {

		super.copy( source, false );

		this.line.copy( source.line );
		this.cone.copy( source.cone );

		return this;

	}

	dispose() {

		this.line.geometry.dispose();
		this.line.material.dispose();
		this.cone.geometry.dispose();
		this.cone.material.dispose();

	}

}

class AxesHelper extends LineSegments {

	constructor( size = 1 ) {

		const vertices = [
			0, 0, 0,	size, 0, 0,
			0, 0, 0,	0, size, 0,
			0, 0, 0,	0, 0, size
		];

		const colors = [
			1, 0, 0,	1, 0.6, 0,
			0, 1, 0,	0.6, 1, 0,
			0, 0, 1,	0, 0.6, 1
		];

		const geometry = new BufferGeometry();
		geometry.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		geometry.setAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );

		const material = new LineBasicMaterial( { vertexColors: true, toneMapped: false } );

		super( geometry, material );

		this.type = 'AxesHelper';

	}

	setColors( xAxisColor, yAxisColor, zAxisColor ) {

		const color = new Color();
		const array = this.geometry.attributes.color.array;

		color.set( xAxisColor );
		color.toArray( array, 0 );
		color.toArray( array, 3 );

		color.set( yAxisColor );
		color.toArray( array, 6 );
		color.toArray( array, 9 );

		color.set( zAxisColor );
		color.toArray( array, 12 );
		color.toArray( array, 15 );

		this.geometry.attributes.color.needsUpdate = true;

		return this;

	}

	dispose() {

		this.geometry.dispose();
		this.material.dispose();

	}

}

class ShapePath {

	constructor() {

		this.type = 'ShapePath';

		this.color = new Color();

		this.subPaths = [];
		this.currentPath = null;

	}

	moveTo( x, y ) {

		this.currentPath = new Path();
		this.subPaths.push( this.currentPath );
		this.currentPath.moveTo( x, y );

		return this;

	}

	lineTo( x, y ) {

		this.currentPath.lineTo( x, y );

		return this;

	}

	quadraticCurveTo( aCPx, aCPy, aX, aY ) {

		this.currentPath.quadraticCurveTo( aCPx, aCPy, aX, aY );

		return this;

	}

	bezierCurveTo( aCP1x, aCP1y, aCP2x, aCP2y, aX, aY ) {

		this.currentPath.bezierCurveTo( aCP1x, aCP1y, aCP2x, aCP2y, aX, aY );

		return this;

	}

	splineThru( pts ) {

		this.currentPath.splineThru( pts );

		return this;

	}

	toShapes( isCCW ) {

		function toShapesNoHoles( inSubpaths ) {

			const shapes = [];

			for ( let i = 0, l = inSubpaths.length; i < l; i ++ ) {

				const tmpPath = inSubpaths[ i ];

				const tmpShape = new Shape();
				tmpShape.curves = tmpPath.curves;

				shapes.push( tmpShape );

			}

			return shapes;

		}

		function isPointInsidePolygon( inPt, inPolygon ) {

			const polyLen = inPolygon.length;

			// inPt on polygon contour => immediate success    or
			// toggling of inside/outside at every single! intersection point of an edge
			//  with the horizontal line through inPt, left of inPt
			//  not counting lowerY endpoints of edges and whole edges on that line
			let inside = false;
			for ( let p = polyLen - 1, q = 0; q < polyLen; p = q ++ ) {

				let edgeLowPt = inPolygon[ p ];
				let edgeHighPt = inPolygon[ q ];

				let edgeDx = edgeHighPt.x - edgeLowPt.x;
				let edgeDy = edgeHighPt.y - edgeLowPt.y;

				if ( Math.abs( edgeDy ) > Number.EPSILON ) {

					// not parallel
					if ( edgeDy < 0 ) {

						edgeLowPt = inPolygon[ q ]; edgeDx = - edgeDx;
						edgeHighPt = inPolygon[ p ]; edgeDy = - edgeDy;

					}

					if ( ( inPt.y < edgeLowPt.y ) || ( inPt.y > edgeHighPt.y ) ) 		continue;

					if ( inPt.y === edgeLowPt.y ) {

						if ( inPt.x === edgeLowPt.x )		return	true;		// inPt is on contour ?
						// continue;				// no intersection or edgeLowPt => doesn't count !!!

					} else {

						const perpEdge = edgeDy * ( inPt.x - edgeLowPt.x ) - edgeDx * ( inPt.y - edgeLowPt.y );
						if ( perpEdge === 0 )				return	true;		// inPt is on contour ?
						if ( perpEdge < 0 ) 				continue;
						inside = ! inside;		// true intersection left of inPt

					}

				} else {

					// parallel or collinear
					if ( inPt.y !== edgeLowPt.y ) 		continue;			// parallel
					// edge lies on the same horizontal line as inPt
					if ( ( ( edgeHighPt.x <= inPt.x ) && ( inPt.x <= edgeLowPt.x ) ) ||
						 ( ( edgeLowPt.x <= inPt.x ) && ( inPt.x <= edgeHighPt.x ) ) )		return	true;	// inPt: Point on contour !
					// continue;

				}

			}

			return	inside;

		}

		const isClockWise = ShapeUtils.isClockWise;

		const subPaths = this.subPaths;
		if ( subPaths.length === 0 ) return [];

		let solid, tmpPath, tmpShape;
		const shapes = [];

		if ( subPaths.length === 1 ) {

			tmpPath = subPaths[ 0 ];
			tmpShape = new Shape();
			tmpShape.curves = tmpPath.curves;
			shapes.push( tmpShape );
			return shapes;

		}

		let holesFirst = ! isClockWise( subPaths[ 0 ].getPoints() );
		holesFirst = isCCW ? ! holesFirst : holesFirst;

		// console.log("Holes first", holesFirst);

		const betterShapeHoles = [];
		const newShapes = [];
		let newShapeHoles = [];
		let mainIdx = 0;
		let tmpPoints;

		newShapes[ mainIdx ] = undefined;
		newShapeHoles[ mainIdx ] = [];

		for ( let i = 0, l = subPaths.length; i < l; i ++ ) {

			tmpPath = subPaths[ i ];
			tmpPoints = tmpPath.getPoints();
			solid = isClockWise( tmpPoints );
			solid = isCCW ? ! solid : solid;

			if ( solid ) {

				if ( ( ! holesFirst ) && ( newShapes[ mainIdx ] ) )	mainIdx ++;

				newShapes[ mainIdx ] = { s: new Shape(), p: tmpPoints };
				newShapes[ mainIdx ].s.curves = tmpPath.curves;

				if ( holesFirst )	mainIdx ++;
				newShapeHoles[ mainIdx ] = [];

				//console.log('cw', i);

			} else {

				newShapeHoles[ mainIdx ].push( { h: tmpPath, p: tmpPoints[ 0 ] } );

				//console.log('ccw', i);

			}

		}

		// only Holes? -> probably all Shapes with wrong orientation
		if ( ! newShapes[ 0 ] )	return	toShapesNoHoles( subPaths );


		if ( newShapes.length > 1 ) {

			let ambiguous = false;
			let toChange = 0;

			for ( let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx ++ ) {

				betterShapeHoles[ sIdx ] = [];

			}

			for ( let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx ++ ) {

				const sho = newShapeHoles[ sIdx ];

				for ( let hIdx = 0; hIdx < sho.length; hIdx ++ ) {

					const ho = sho[ hIdx ];
					let hole_unassigned = true;

					for ( let s2Idx = 0; s2Idx < newShapes.length; s2Idx ++ ) {

						if ( isPointInsidePolygon( ho.p, newShapes[ s2Idx ].p ) ) {

							if ( sIdx !== s2Idx )	toChange ++;

							if ( hole_unassigned ) {

								hole_unassigned = false;
								betterShapeHoles[ s2Idx ].push( ho );

							} else {

								ambiguous = true;

							}

						}

					}

					if ( hole_unassigned ) {

						betterShapeHoles[ sIdx ].push( ho );

					}

				}

			}

			if ( toChange > 0 && ambiguous === false ) {

				newShapeHoles = betterShapeHoles;

			}

		}

		let tmpHoles;

		for ( let i = 0, il = newShapes.length; i < il; i ++ ) {

			tmpShape = newShapes[ i ].s;
			shapes.push( tmpShape );
			tmpHoles = newShapeHoles[ i ];

			for ( let j = 0, jl = tmpHoles.length; j < jl; j ++ ) {

				tmpShape.holes.push( tmpHoles[ j ].h );

			}

		}

		//console.log("shape", shapes);

		return shapes;

	}

}

class WebGLMultipleRenderTargets extends WebGLRenderTarget { // @deprecated, r162

	constructor( width = 1, height = 1, count = 1, options = {} ) {

		console.warn( 'THREE.WebGLMultipleRenderTargets has been deprecated and will be removed in r172. Use THREE.WebGLRenderTarget and set the "count" parameter to enable MRT.' );

		super( width, height, { ...options, count } );

		this.isWebGLMultipleRenderTargets = true;

	}

	get texture() {

		return this.textures;

	}

}

if ( typeof __THREE_DEVTOOLS__ !== 'undefined' ) {

	__THREE_DEVTOOLS__.dispatchEvent( new CustomEvent( 'register', { detail: {
		revision: REVISION,
	} } ) );

}

if ( typeof window !== 'undefined' ) {

	if ( window.__THREE__ ) {

		console.warn( 'WARNING: Multiple instances of Three.js being imported.' );

	} else {

		window.__THREE__ = REVISION;

	}

}

exports.ACESFilmicToneMapping = ACESFilmicToneMapping;
exports.AddEquation = AddEquation;
exports.AddOperation = AddOperation;
exports.AdditiveAnimationBlendMode = AdditiveAnimationBlendMode;
exports.AdditiveBlending = AdditiveBlending;
exports.AgXToneMapping = AgXToneMapping;
exports.AlphaFormat = AlphaFormat;
exports.AlwaysCompare = AlwaysCompare;
exports.AlwaysDepth = AlwaysDepth;
exports.AlwaysStencilFunc = AlwaysStencilFunc;
exports.AmbientLight = AmbientLight;
exports.AnimationAction = AnimationAction;
exports.AnimationClip = AnimationClip;
exports.AnimationLoader = AnimationLoader;
exports.AnimationMixer = AnimationMixer;
exports.AnimationObjectGroup = AnimationObjectGroup;
exports.AnimationUtils = AnimationUtils;
exports.ArcCurve = ArcCurve;
exports.ArrayCamera = ArrayCamera;
exports.ArrowHelper = ArrowHelper;
exports.AttachedBindMode = AttachedBindMode;
exports.Audio = Audio;
exports.AudioAnalyser = AudioAnalyser;
exports.AudioContext = AudioContext;
exports.AudioListener = AudioListener;
exports.AudioLoader = AudioLoader;
exports.AxesHelper = AxesHelper;
exports.BackSide = BackSide;
exports.BasicDepthPacking = BasicDepthPacking;
exports.BasicShadowMap = BasicShadowMap;
exports.BatchedMesh = BatchedMesh;
exports.Bone = Bone;
exports.BooleanKeyframeTrack = BooleanKeyframeTrack;
exports.Box2 = Box2;
exports.Box3 = Box3;
exports.Box3Helper = Box3Helper;
exports.BoxGeometry = BoxGeometry;
exports.BoxHelper = BoxHelper;
exports.BufferAttribute = BufferAttribute;
exports.BufferGeometry = BufferGeometry;
exports.BufferGeometryLoader = BufferGeometryLoader;
exports.ByteType = ByteType;
exports.Cache = Cache;
exports.Camera = Camera;
exports.CameraHelper = CameraHelper;
exports.CanvasTexture = CanvasTexture;
exports.CapsuleGeometry = CapsuleGeometry;
exports.CatmullRomCurve3 = CatmullRomCurve3;
exports.CineonToneMapping = CineonToneMapping;
exports.CircleGeometry = CircleGeometry;
exports.ClampToEdgeWrapping = ClampToEdgeWrapping;
exports.Clock = Clock;
exports.Color = Color;
exports.ColorKeyframeTrack = ColorKeyframeTrack;
exports.ColorManagement = ColorManagement;
exports.CompressedArrayTexture = CompressedArrayTexture;
exports.CompressedCubeTexture = CompressedCubeTexture;
exports.CompressedTexture = CompressedTexture;
exports.CompressedTextureLoader = CompressedTextureLoader;
exports.ConeGeometry = ConeGeometry;
exports.ConstantAlphaFactor = ConstantAlphaFactor;
exports.ConstantColorFactor = ConstantColorFactor;
exports.CubeCamera = CubeCamera;
exports.CubeReflectionMapping = CubeReflectionMapping;
exports.CubeRefractionMapping = CubeRefractionMapping;
exports.CubeTexture = CubeTexture;
exports.CubeTextureLoader = CubeTextureLoader;
exports.CubeUVReflectionMapping = CubeUVReflectionMapping;
exports.CubicBezierCurve = CubicBezierCurve;
exports.CubicBezierCurve3 = CubicBezierCurve3;
exports.CubicInterpolant = CubicInterpolant;
exports.CullFaceBack = CullFaceBack;
exports.CullFaceFront = CullFaceFront;
exports.CullFaceFrontBack = CullFaceFrontBack;
exports.CullFaceNone = CullFaceNone;
exports.Curve = Curve;
exports.CurvePath = CurvePath;
exports.CustomBlending = CustomBlending;
exports.CustomToneMapping = CustomToneMapping;
exports.CylinderGeometry = CylinderGeometry;
exports.Cylindrical = Cylindrical;
exports.Data3DTexture = Data3DTexture;
exports.DataArrayTexture = DataArrayTexture;
exports.DataTexture = DataTexture;
exports.DataTextureLoader = DataTextureLoader;
exports.DataUtils = DataUtils;
exports.DecrementStencilOp = DecrementStencilOp;
exports.DecrementWrapStencilOp = DecrementWrapStencilOp;
exports.DefaultLoadingManager = DefaultLoadingManager;
exports.DepthFormat = DepthFormat;
exports.DepthStencilFormat = DepthStencilFormat;
exports.DepthTexture = DepthTexture;
exports.DetachedBindMode = DetachedBindMode;
exports.DirectionalLight = DirectionalLight;
exports.DirectionalLightHelper = DirectionalLightHelper;
exports.DiscreteInterpolant = DiscreteInterpolant;
exports.DisplayP3ColorSpace = DisplayP3ColorSpace;
exports.DodecahedronGeometry = DodecahedronGeometry;
exports.DoubleSide = DoubleSide;
exports.DstAlphaFactor = DstAlphaFactor;
exports.DstColorFactor = DstColorFactor;
exports.DynamicCopyUsage = DynamicCopyUsage;
exports.DynamicDrawUsage = DynamicDrawUsage;
exports.DynamicReadUsage = DynamicReadUsage;
exports.EdgesGeometry = EdgesGeometry;
exports.EllipseCurve = EllipseCurve;
exports.EqualCompare = EqualCompare;
exports.EqualDepth = EqualDepth;
exports.EqualStencilFunc = EqualStencilFunc;
exports.EquirectangularReflectionMapping = EquirectangularReflectionMapping;
exports.EquirectangularRefractionMapping = EquirectangularRefractionMapping;
exports.Euler = Euler;
exports.EventDispatcher = EventDispatcher;
exports.ExtrudeGeometry = ExtrudeGeometry;
exports.FileLoader = FileLoader;
exports.Float16BufferAttribute = Float16BufferAttribute;
exports.Float32BufferAttribute = Float32BufferAttribute;
exports.FloatType = FloatType;
exports.Fog = Fog;
exports.FogExp2 = FogExp2;
exports.FramebufferTexture = FramebufferTexture;
exports.FrontSide = FrontSide;
exports.Frustum = Frustum;
exports.GLBufferAttribute = GLBufferAttribute;
exports.GLSL1 = GLSL1;
exports.GLSL3 = GLSL3;
exports.GreaterCompare = GreaterCompare;
exports.GreaterDepth = GreaterDepth;
exports.GreaterEqualCompare = GreaterEqualCompare;
exports.GreaterEqualDepth = GreaterEqualDepth;
exports.GreaterEqualStencilFunc = GreaterEqualStencilFunc;
exports.GreaterStencilFunc = GreaterStencilFunc;
exports.GridHelper = GridHelper;
exports.Group = Group;
exports.HalfFloatType = HalfFloatType;
exports.HemisphereLight = HemisphereLight;
exports.HemisphereLightHelper = HemisphereLightHelper;
exports.IcosahedronGeometry = IcosahedronGeometry;
exports.ImageBitmapLoader = ImageBitmapLoader;
exports.ImageLoader = ImageLoader;
exports.ImageUtils = ImageUtils;
exports.IncrementStencilOp = IncrementStencilOp;
exports.IncrementWrapStencilOp = IncrementWrapStencilOp;
exports.InstancedBufferAttribute = InstancedBufferAttribute;
exports.InstancedBufferGeometry = InstancedBufferGeometry;
exports.InstancedInterleavedBuffer = InstancedInterleavedBuffer;
exports.InstancedMesh = InstancedMesh;
exports.Int16BufferAttribute = Int16BufferAttribute;
exports.Int32BufferAttribute = Int32BufferAttribute;
exports.Int8BufferAttribute = Int8BufferAttribute;
exports.IntType = IntType;
exports.InterleavedBuffer = InterleavedBuffer;
exports.InterleavedBufferAttribute = InterleavedBufferAttribute;
exports.Interpolant = Interpolant;
exports.InterpolateDiscrete = InterpolateDiscrete;
exports.InterpolateLinear = InterpolateLinear;
exports.InterpolateSmooth = InterpolateSmooth;
exports.InvertStencilOp = InvertStencilOp;
exports.KeepStencilOp = KeepStencilOp;
exports.KeyframeTrack = KeyframeTrack;
exports.LOD = LOD;
exports.LatheGeometry = LatheGeometry;
exports.Layers = Layers;
exports.LessCompare = LessCompare;
exports.LessDepth = LessDepth;
exports.LessEqualCompare = LessEqualCompare;
exports.LessEqualDepth = LessEqualDepth;
exports.LessEqualStencilFunc = LessEqualStencilFunc;
exports.LessStencilFunc = LessStencilFunc;
exports.Light = Light;
exports.LightProbe = LightProbe;
exports.Line = Line;
exports.Line3 = Line3;
exports.LineBasicMaterial = LineBasicMaterial;
exports.LineCurve = LineCurve;
exports.LineCurve3 = LineCurve3;
exports.LineDashedMaterial = LineDashedMaterial;
exports.LineLoop = LineLoop;
exports.LineSegments = LineSegments;
exports.LinearDisplayP3ColorSpace = LinearDisplayP3ColorSpace;
exports.LinearFilter = LinearFilter;
exports.LinearInterpolant = LinearInterpolant;
exports.LinearMipMapLinearFilter = LinearMipMapLinearFilter;
exports.LinearMipMapNearestFilter = LinearMipMapNearestFilter;
exports.LinearMipmapLinearFilter = LinearMipmapLinearFilter;
exports.LinearMipmapNearestFilter = LinearMipmapNearestFilter;
exports.LinearSRGBColorSpace = LinearSRGBColorSpace;
exports.LinearToneMapping = LinearToneMapping;
exports.LinearTransfer = LinearTransfer;
exports.Loader = Loader;
exports.LoaderUtils = LoaderUtils;
exports.LoadingManager = LoadingManager;
exports.LoopOnce = LoopOnce;
exports.LoopPingPong = LoopPingPong;
exports.LoopRepeat = LoopRepeat;
exports.LuminanceAlphaFormat = LuminanceAlphaFormat;
exports.LuminanceFormat = LuminanceFormat;
exports.MOUSE = MOUSE;
exports.Material = Material;
exports.MaterialLoader = MaterialLoader;
exports.MathUtils = MathUtils;
exports.Matrix3 = Matrix3;
exports.Matrix4 = Matrix4;
exports.MaxEquation = MaxEquation;
exports.Mesh = Mesh;
exports.MeshBasicMaterial = MeshBasicMaterial;
exports.MeshDepthMaterial = MeshDepthMaterial;
exports.MeshDistanceMaterial = MeshDistanceMaterial;
exports.MeshLambertMaterial = MeshLambertMaterial;
exports.MeshMatcapMaterial = MeshMatcapMaterial;
exports.MeshNormalMaterial = MeshNormalMaterial;
exports.MeshPhongMaterial = MeshPhongMaterial;
exports.MeshPhysicalMaterial = MeshPhysicalMaterial;
exports.MeshStandardMaterial = MeshStandardMaterial;
exports.MeshToonMaterial = MeshToonMaterial;
exports.MinEquation = MinEquation;
exports.MirroredRepeatWrapping = MirroredRepeatWrapping;
exports.MixOperation = MixOperation;
exports.MultiplyBlending = MultiplyBlending;
exports.MultiplyOperation = MultiplyOperation;
exports.NearestFilter = NearestFilter;
exports.NearestMipMapLinearFilter = NearestMipMapLinearFilter;
exports.NearestMipMapNearestFilter = NearestMipMapNearestFilter;
exports.NearestMipmapLinearFilter = NearestMipmapLinearFilter;
exports.NearestMipmapNearestFilter = NearestMipmapNearestFilter;
exports.NeutralToneMapping = NeutralToneMapping;
exports.NeverCompare = NeverCompare;
exports.NeverDepth = NeverDepth;
exports.NeverStencilFunc = NeverStencilFunc;
exports.NoBlending = NoBlending;
exports.NoColorSpace = NoColorSpace;
exports.NoToneMapping = NoToneMapping;
exports.NormalAnimationBlendMode = NormalAnimationBlendMode;
exports.NormalBlending = NormalBlending;
exports.NotEqualCompare = NotEqualCompare;
exports.NotEqualDepth = NotEqualDepth;
exports.NotEqualStencilFunc = NotEqualStencilFunc;
exports.NumberKeyframeTrack = NumberKeyframeTrack;
exports.Object3D = Object3D;
exports.ObjectLoader = ObjectLoader;
exports.ObjectSpaceNormalMap = ObjectSpaceNormalMap;
exports.OctahedronGeometry = OctahedronGeometry;
exports.OneFactor = OneFactor;
exports.OneMinusConstantAlphaFactor = OneMinusConstantAlphaFactor;
exports.OneMinusConstantColorFactor = OneMinusConstantColorFactor;
exports.OneMinusDstAlphaFactor = OneMinusDstAlphaFactor;
exports.OneMinusDstColorFactor = OneMinusDstColorFactor;
exports.OneMinusSrcAlphaFactor = OneMinusSrcAlphaFactor;
exports.OneMinusSrcColorFactor = OneMinusSrcColorFactor;
exports.OrthographicCamera = OrthographicCamera;
exports.P3Primaries = P3Primaries;
exports.PCFShadowMap = PCFShadowMap;
exports.PCFSoftShadowMap = PCFSoftShadowMap;
exports.PMREMGenerator = PMREMGenerator;
exports.Path = Path;
exports.PerspectiveCamera = PerspectiveCamera;
exports.Plane = Plane;
exports.PlaneGeometry = PlaneGeometry;
exports.PlaneHelper = PlaneHelper;
exports.PointLight = PointLight;
exports.PointLightHelper = PointLightHelper;
exports.Points = Points;
exports.PointsMaterial = PointsMaterial;
exports.PolarGridHelper = PolarGridHelper;
exports.PolyhedronGeometry = PolyhedronGeometry;
exports.PositionalAudio = PositionalAudio;
exports.PropertyBinding = PropertyBinding;
exports.PropertyMixer = PropertyMixer;
exports.QuadraticBezierCurve = QuadraticBezierCurve;
exports.QuadraticBezierCurve3 = QuadraticBezierCurve3;
exports.Quaternion = Quaternion;
exports.QuaternionKeyframeTrack = QuaternionKeyframeTrack;
exports.QuaternionLinearInterpolant = QuaternionLinearInterpolant;
exports.RED_GREEN_RGTC2_Format = RED_GREEN_RGTC2_Format;
exports.RED_RGTC1_Format = RED_RGTC1_Format;
exports.REVISION = REVISION;
exports.RGBADepthPacking = RGBADepthPacking;
exports.RGBAFormat = RGBAFormat;
exports.RGBAIntegerFormat = RGBAIntegerFormat;
exports.RGBA_ASTC_10x10_Format = RGBA_ASTC_10x10_Format;
exports.RGBA_ASTC_10x5_Format = RGBA_ASTC_10x5_Format;
exports.RGBA_ASTC_10x6_Format = RGBA_ASTC_10x6_Format;
exports.RGBA_ASTC_10x8_Format = RGBA_ASTC_10x8_Format;
exports.RGBA_ASTC_12x10_Format = RGBA_ASTC_12x10_Format;
exports.RGBA_ASTC_12x12_Format = RGBA_ASTC_12x12_Format;
exports.RGBA_ASTC_4x4_Format = RGBA_ASTC_4x4_Format;
exports.RGBA_ASTC_5x4_Format = RGBA_ASTC_5x4_Format;
exports.RGBA_ASTC_5x5_Format = RGBA_ASTC_5x5_Format;
exports.RGBA_ASTC_6x5_Format = RGBA_ASTC_6x5_Format;
exports.RGBA_ASTC_6x6_Format = RGBA_ASTC_6x6_Format;
exports.RGBA_ASTC_8x5_Format = RGBA_ASTC_8x5_Format;
exports.RGBA_ASTC_8x6_Format = RGBA_ASTC_8x6_Format;
exports.RGBA_ASTC_8x8_Format = RGBA_ASTC_8x8_Format;
exports.RGBA_BPTC_Format = RGBA_BPTC_Format;
exports.RGBA_ETC2_EAC_Format = RGBA_ETC2_EAC_Format;
exports.RGBA_PVRTC_2BPPV1_Format = RGBA_PVRTC_2BPPV1_Format;
exports.RGBA_PVRTC_4BPPV1_Format = RGBA_PVRTC_4BPPV1_Format;
exports.RGBA_S3TC_DXT1_Format = RGBA_S3TC_DXT1_Format;
exports.RGBA_S3TC_DXT3_Format = RGBA_S3TC_DXT3_Format;
exports.RGBA_S3TC_DXT5_Format = RGBA_S3TC_DXT5_Format;
exports.RGBFormat = RGBFormat;
exports.RGB_BPTC_SIGNED_Format = RGB_BPTC_SIGNED_Format;
exports.RGB_BPTC_UNSIGNED_Format = RGB_BPTC_UNSIGNED_Format;
exports.RGB_ETC1_Format = RGB_ETC1_Format;
exports.RGB_ETC2_Format = RGB_ETC2_Format;
exports.RGB_PVRTC_2BPPV1_Format = RGB_PVRTC_2BPPV1_Format;
exports.RGB_PVRTC_4BPPV1_Format = RGB_PVRTC_4BPPV1_Format;
exports.RGB_S3TC_DXT1_Format = RGB_S3TC_DXT1_Format;
exports.RGFormat = RGFormat;
exports.RGIntegerFormat = RGIntegerFormat;
exports.RawShaderMaterial = RawShaderMaterial;
exports.Ray = Ray;
exports.Raycaster = Raycaster;
exports.Rec709Primaries = Rec709Primaries;
exports.RectAreaLight = RectAreaLight;
exports.RedFormat = RedFormat;
exports.RedIntegerFormat = RedIntegerFormat;
exports.ReinhardToneMapping = ReinhardToneMapping;
exports.RenderTarget = RenderTarget;
exports.RepeatWrapping = RepeatWrapping;
exports.ReplaceStencilOp = ReplaceStencilOp;
exports.ReverseSubtractEquation = ReverseSubtractEquation;
exports.RingGeometry = RingGeometry;
exports.SIGNED_RED_GREEN_RGTC2_Format = SIGNED_RED_GREEN_RGTC2_Format;
exports.SIGNED_RED_RGTC1_Format = SIGNED_RED_RGTC1_Format;
exports.SRGBColorSpace = SRGBColorSpace;
exports.SRGBTransfer = SRGBTransfer;
exports.Scene = Scene;
exports.ShaderChunk = ShaderChunk;
exports.ShaderLib = ShaderLib;
exports.ShaderMaterial = ShaderMaterial;
exports.ShadowMaterial = ShadowMaterial;
exports.Shape = Shape;
exports.ShapeGeometry = ShapeGeometry;
exports.ShapePath = ShapePath;
exports.ShapeUtils = ShapeUtils;
exports.ShortType = ShortType;
exports.Skeleton = Skeleton;
exports.SkeletonHelper = SkeletonHelper;
exports.SkinnedMesh = SkinnedMesh;
exports.Source = Source;
exports.Sphere = Sphere;
exports.SphereGeometry = SphereGeometry;
exports.Spherical = Spherical;
exports.SphericalHarmonics3 = SphericalHarmonics3;
exports.SplineCurve = SplineCurve;
exports.SpotLight = SpotLight;
exports.SpotLightHelper = SpotLightHelper;
exports.Sprite = Sprite;
exports.SpriteMaterial = SpriteMaterial;
exports.SrcAlphaFactor = SrcAlphaFactor;
exports.SrcAlphaSaturateFactor = SrcAlphaSaturateFactor;
exports.SrcColorFactor = SrcColorFactor;
exports.StaticCopyUsage = StaticCopyUsage;
exports.StaticDrawUsage = StaticDrawUsage;
exports.StaticReadUsage = StaticReadUsage;
exports.StereoCamera = StereoCamera;
exports.StreamCopyUsage = StreamCopyUsage;
exports.StreamDrawUsage = StreamDrawUsage;
exports.StreamReadUsage = StreamReadUsage;
exports.StringKeyframeTrack = StringKeyframeTrack;
exports.SubtractEquation = SubtractEquation;
exports.SubtractiveBlending = SubtractiveBlending;
exports.TOUCH = TOUCH;
exports.TangentSpaceNormalMap = TangentSpaceNormalMap;
exports.TetrahedronGeometry = TetrahedronGeometry;
exports.Texture = Texture;
exports.TextureLoader = TextureLoader;
exports.TorusGeometry = TorusGeometry;
exports.TorusKnotGeometry = TorusKnotGeometry;
exports.Triangle = Triangle;
exports.TriangleFanDrawMode = TriangleFanDrawMode;
exports.TriangleStripDrawMode = TriangleStripDrawMode;
exports.TrianglesDrawMode = TrianglesDrawMode;
exports.TubeGeometry = TubeGeometry;
exports.UVMapping = UVMapping;
exports.Uint16BufferAttribute = Uint16BufferAttribute;
exports.Uint32BufferAttribute = Uint32BufferAttribute;
exports.Uint8BufferAttribute = Uint8BufferAttribute;
exports.Uint8ClampedBufferAttribute = Uint8ClampedBufferAttribute;
exports.Uniform = Uniform;
exports.UniformsGroup = UniformsGroup;
exports.UniformsLib = UniformsLib;
exports.UniformsUtils = UniformsUtils;
exports.UnsignedByteType = UnsignedByteType;
exports.UnsignedInt248Type = UnsignedInt248Type;
exports.UnsignedInt5999Type = UnsignedInt5999Type;
exports.UnsignedIntType = UnsignedIntType;
exports.UnsignedShort4444Type = UnsignedShort4444Type;
exports.UnsignedShort5551Type = UnsignedShort5551Type;
exports.UnsignedShortType = UnsignedShortType;
exports.VSMShadowMap = VSMShadowMap;
exports.Vector2 = Vector2;
exports.Vector3 = Vector3;
exports.Vector4 = Vector4;
exports.VectorKeyframeTrack = VectorKeyframeTrack;
exports.VideoTexture = VideoTexture;
exports.WebGL3DRenderTarget = WebGL3DRenderTarget;
exports.WebGLArrayRenderTarget = WebGLArrayRenderTarget;
exports.WebGLCoordinateSystem = WebGLCoordinateSystem;
exports.WebGLCubeRenderTarget = WebGLCubeRenderTarget;
exports.WebGLMultipleRenderTargets = WebGLMultipleRenderTargets;
exports.WebGLRenderTarget = WebGLRenderTarget;
exports.WebGLRenderer = WebGLRenderer;
exports.WebGLUtils = WebGLUtils;
exports.WebGPUCoordinateSystem = WebGPUCoordinateSystem;
exports.WireframeGeometry = WireframeGeometry;
exports.WrapAroundEnding = WrapAroundEnding;
exports.ZeroCurvatureEnding = ZeroCurvatureEnding;
exports.ZeroFactor = ZeroFactor;
exports.ZeroSlopeEnding = ZeroSlopeEnding;
exports.ZeroStencilOp = ZeroStencilOp;
exports.createCanvasElement = createCanvasElement;


/***/ }),

/***/ 885:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  AVERAGE: () => (/* reexport */ AVERAGE),
  BVHShaderGLSL: () => (/* reexport */ BVHShaderGLSL_namespaceObject),
  CENTER: () => (/* reexport */ CENTER),
  CONTAINED: () => (/* reexport */ CONTAINED),
  ExtendedTriangle: () => (/* reexport */ ExtendedTriangle),
  FloatVertexAttributeTexture: () => (/* reexport */ FloatVertexAttributeTexture),
  INTERSECTED: () => (/* reexport */ INTERSECTED),
  IntVertexAttributeTexture: () => (/* reexport */ IntVertexAttributeTexture),
  MeshBVH: () => (/* reexport */ MeshBVH),
  MeshBVHHelper: () => (/* reexport */ MeshBVHHelper),
  MeshBVHUniformStruct: () => (/* reexport */ MeshBVHUniformStruct),
  NOT_INTERSECTED: () => (/* reexport */ NOT_INTERSECTED),
  OrientedBox: () => (/* reexport */ OrientedBox),
  SAH: () => (/* reexport */ SAH),
  StaticGeometryGenerator: () => (/* reexport */ StaticGeometryGenerator),
  UIntVertexAttributeTexture: () => (/* reexport */ UIntVertexAttributeTexture),
  VertexAttributeTexture: () => (/* reexport */ VertexAttributeTexture),
  acceleratedRaycast: () => (/* reexport */ acceleratedRaycast),
  computeBoundsTree: () => (/* reexport */ computeBoundsTree),
  disposeBoundsTree: () => (/* reexport */ disposeBoundsTree),
  estimateMemoryInBytes: () => (/* reexport */ estimateMemoryInBytes),
  getBVHExtremes: () => (/* reexport */ getBVHExtremes),
  getJSONStructure: () => (/* reexport */ getJSONStructure),
  getTriangleHitPointInfo: () => (/* reexport */ getTriangleHitPointInfo),
  shaderDistanceFunction: () => (/* binding */ shaderDistanceFunction),
  shaderIntersectFunction: () => (/* binding */ shaderIntersectFunction),
  shaderStructs: () => (/* binding */ shaderStructs),
  validateBounds: () => (/* reexport */ validateBounds)
});

// NAMESPACE OBJECT: ./node_modules/three-mesh-bvh/src/gpu/BVHShaderGLSL.js
var BVHShaderGLSL_namespaceObject = {};
__webpack_require__.r(BVHShaderGLSL_namespaceObject);
__webpack_require__.d(BVHShaderGLSL_namespaceObject, {
  bvh_distance_functions: () => (bvh_distance_functions),
  bvh_ray_functions: () => (bvh_ray_functions),
  bvh_struct_definitions: () => (bvh_struct_definitions),
  common_functions: () => (common_functions)
});

// EXTERNAL MODULE: ./node_modules/three/build/three.module.js
var three_module = __webpack_require__(9477);
;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/core/Constants.js
// Split strategy constants
const CENTER = 0;
const AVERAGE = 1;
const SAH = 2;

// Traversal constants
const NOT_INTERSECTED = 0;
const INTERSECTED = 1;
const CONTAINED = 2;

// SAH cost constants
// TODO: hone these costs more. The relative difference between them should be the
// difference in measured time to perform a triangle intersection vs traversing
// bounds.
const TRIANGLE_INTERSECT_COST = 1.25;
const TRAVERSAL_COST = 1;


// Build constants
const BYTES_PER_NODE = 6 * 4 + 4 + 4;
const IS_LEAFNODE_FLAG = 0xFFFF;

// EPSILON for computing floating point error during build
// https://en.wikipedia.org/wiki/Machine_epsilon#Values_for_standard_hardware_floating_point_arithmetics
const FLOAT32_EPSILON = Math.pow( 2, - 24 );

const SKIP_GENERATION = Symbol( 'SKIP_GENERATION' );

;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/core/build/geometryUtils.js


function getVertexCount( geo ) {

	return geo.index ? geo.index.count : geo.attributes.position.count;

}

function getTriCount( geo ) {

	return getVertexCount( geo ) / 3;

}

function getIndexArray( vertexCount, BufferConstructor = ArrayBuffer ) {

	if ( vertexCount > 65535 ) {

		return new Uint32Array( new BufferConstructor( 4 * vertexCount ) );

	} else {

		return new Uint16Array( new BufferConstructor( 2 * vertexCount ) );

	}

}

// ensures that an index is present on the geometry
function ensureIndex( geo, options ) {

	if ( ! geo.index ) {

		const vertexCount = geo.attributes.position.count;
		const BufferConstructor = options.useSharedArrayBuffer ? SharedArrayBuffer : ArrayBuffer;
		const index = getIndexArray( vertexCount, BufferConstructor );
		geo.setIndex( new three_module/* BufferAttribute */.TlE( index, 1 ) );

		for ( let i = 0; i < vertexCount; i ++ ) {

			index[ i ] = i;

		}

	}

}

// Computes the set of { offset, count } ranges which need independent BVH roots. Each
// region in the geometry index that belongs to a different set of material groups requires
// a separate BVH root, so that triangles indices belonging to one group never get swapped
// with triangle indices belongs to another group. For example, if the groups were like this:
//
// [-------------------------------------------------------------]
// |__________________|
//   g0 = [0, 20]  |______________________||_____________________|
//                      g1 = [16, 40]           g2 = [41, 60]
//
// we would need four BVH roots: [0, 15], [16, 20], [21, 40], [41, 60].
function getFullGeometryRange( geo ) {

	const triCount = getTriCount( geo );
	const drawRange = geo.drawRange;
	const start = drawRange.start / 3;
	const end = ( drawRange.start + drawRange.count ) / 3;

	const offset = Math.max( 0, start );
	const count = Math.min( triCount, end ) - offset;
	return [ {
		offset: Math.floor( offset ),
		count: Math.floor( count ),
	} ];

}

function getRootIndexRanges( geo ) {

	if ( ! geo.groups || ! geo.groups.length ) {

		return getFullGeometryRange( geo );

	}

	const ranges = [];
	const rangeBoundaries = new Set();

	const drawRange = geo.drawRange;
	const drawRangeStart = drawRange.start / 3;
	const drawRangeEnd = ( drawRange.start + drawRange.count ) / 3;
	for ( const group of geo.groups ) {

		const groupStart = group.start / 3;
		const groupEnd = ( group.start + group.count ) / 3;
		rangeBoundaries.add( Math.max( drawRangeStart, groupStart ) );
		rangeBoundaries.add( Math.min( drawRangeEnd, groupEnd ) );

	}


	// note that if you don't pass in a comparator, it sorts them lexicographically as strings :-(
	const sortedBoundaries = Array.from( rangeBoundaries.values() ).sort( ( a, b ) => a - b );
	for ( let i = 0; i < sortedBoundaries.length - 1; i ++ ) {

		const start = sortedBoundaries[ i ];
		const end = sortedBoundaries[ i + 1 ];

		ranges.push( {
			offset: Math.floor( start ),
			count: Math.floor( end - start ),
		} );

	}

	return ranges;

}

function hasGroupGaps( geometry ) {

	if ( geometry.groups.length === 0 ) {

		return false;

	}

	const vertexCount = getTriCount( geometry );
	const groups = getRootIndexRanges( geometry )
		.sort( ( a, b ) => a.offset - b.offset );

	const finalGroup = groups[ groups.length - 1 ];
	finalGroup.count = Math.min( vertexCount - finalGroup.offset, finalGroup.count );

	let total = 0;
	groups.forEach( ( { count } ) => total += count );
	return vertexCount !== total;

}

;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/core/build/computeBoundsUtils.js



// computes the union of the bounds of all of the given triangles and puts the resulting box in "target".
// A bounding box is computed for the centroids of the triangles, as well, and placed in "centroidTarget".
// These are computed together to avoid redundant accesses to bounds array.
function getBounds( triangleBounds, offset, count, target, centroidTarget ) {

	let minx = Infinity;
	let miny = Infinity;
	let minz = Infinity;
	let maxx = - Infinity;
	let maxy = - Infinity;
	let maxz = - Infinity;

	let cminx = Infinity;
	let cminy = Infinity;
	let cminz = Infinity;
	let cmaxx = - Infinity;
	let cmaxy = - Infinity;
	let cmaxz = - Infinity;

	for ( let i = offset * 6, end = ( offset + count ) * 6; i < end; i += 6 ) {

		const cx = triangleBounds[ i + 0 ];
		const hx = triangleBounds[ i + 1 ];
		const lx = cx - hx;
		const rx = cx + hx;
		if ( lx < minx ) minx = lx;
		if ( rx > maxx ) maxx = rx;
		if ( cx < cminx ) cminx = cx;
		if ( cx > cmaxx ) cmaxx = cx;

		const cy = triangleBounds[ i + 2 ];
		const hy = triangleBounds[ i + 3 ];
		const ly = cy - hy;
		const ry = cy + hy;
		if ( ly < miny ) miny = ly;
		if ( ry > maxy ) maxy = ry;
		if ( cy < cminy ) cminy = cy;
		if ( cy > cmaxy ) cmaxy = cy;

		const cz = triangleBounds[ i + 4 ];
		const hz = triangleBounds[ i + 5 ];
		const lz = cz - hz;
		const rz = cz + hz;
		if ( lz < minz ) minz = lz;
		if ( rz > maxz ) maxz = rz;
		if ( cz < cminz ) cminz = cz;
		if ( cz > cmaxz ) cmaxz = cz;

	}

	target[ 0 ] = minx;
	target[ 1 ] = miny;
	target[ 2 ] = minz;

	target[ 3 ] = maxx;
	target[ 4 ] = maxy;
	target[ 5 ] = maxz;

	centroidTarget[ 0 ] = cminx;
	centroidTarget[ 1 ] = cminy;
	centroidTarget[ 2 ] = cminz;

	centroidTarget[ 3 ] = cmaxx;
	centroidTarget[ 4 ] = cmaxy;
	centroidTarget[ 5 ] = cmaxz;

}

// precomputes the bounding box for each triangle; required for quickly calculating tree splits.
// result is an array of size tris.length * 6 where triangle i maps to a
// [x_center, x_delta, y_center, y_delta, z_center, z_delta] tuple starting at index i * 6,
// representing the center and half-extent in each dimension of triangle i
function computeTriangleBounds( geo, target = null, offset = null, count = null ) {

	const posAttr = geo.attributes.position;
	const index = geo.index ? geo.index.array : null;
	const triCount = getTriCount( geo );
	const normalized = posAttr.normalized;
	let triangleBounds;
	if ( target === null ) {

		triangleBounds = new Float32Array( triCount * 6 * 4 );
		offset = 0;
		count = triCount;

	} else {

		triangleBounds = target;
		offset = offset || 0;
		count = count || triCount;

	}

	// used for non-normalized positions
	const posArr = posAttr.array;

	// support for an interleaved position buffer
	const bufferOffset = posAttr.offset || 0;
	let stride = 3;
	if ( posAttr.isInterleavedBufferAttribute ) {

		stride = posAttr.data.stride;

	}

	// used for normalized positions
	const getters = [ 'getX', 'getY', 'getZ' ];

	for ( let tri = offset; tri < offset + count; tri ++ ) {

		const tri3 = tri * 3;
		const tri6 = tri * 6;

		let ai = tri3 + 0;
		let bi = tri3 + 1;
		let ci = tri3 + 2;

		if ( index ) {

			ai = index[ ai ];
			bi = index[ bi ];
			ci = index[ ci ];

		}

		// we add the stride and offset here since we access the array directly
		// below for the sake of performance
		if ( ! normalized ) {

			ai = ai * stride + bufferOffset;
			bi = bi * stride + bufferOffset;
			ci = ci * stride + bufferOffset;

		}

		for ( let el = 0; el < 3; el ++ ) {

			let a, b, c;

			if ( normalized ) {

				a = posAttr[ getters[ el ] ]( ai );
				b = posAttr[ getters[ el ] ]( bi );
				c = posAttr[ getters[ el ] ]( ci );

			} else {

				a = posArr[ ai + el ];
				b = posArr[ bi + el ];
				c = posArr[ ci + el ];

			}

			let min = a;
			if ( b < min ) min = b;
			if ( c < min ) min = c;

			let max = a;
			if ( b > max ) max = b;
			if ( c > max ) max = c;

			// Increase the bounds size by float32 epsilon to avoid precision errors when
			// converting to 32 bit float. Scale the epsilon by the size of the numbers being
			// worked with.
			const halfExtents = ( max - min ) / 2;
			const el2 = el * 2;
			triangleBounds[ tri6 + el2 + 0 ] = min + halfExtents;
			triangleBounds[ tri6 + el2 + 1 ] = halfExtents + ( Math.abs( min ) + halfExtents ) * FLOAT32_EPSILON;

		}

	}

	return triangleBounds;

}

;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/utils/ArrayBoxUtilities.js
function arrayToBox( nodeIndex32, array, target ) {

	target.min.x = array[ nodeIndex32 ];
	target.min.y = array[ nodeIndex32 + 1 ];
	target.min.z = array[ nodeIndex32 + 2 ];

	target.max.x = array[ nodeIndex32 + 3 ];
	target.max.y = array[ nodeIndex32 + 4 ];
	target.max.z = array[ nodeIndex32 + 5 ];

	return target;

}

function makeEmptyBounds( target ) {

	target[ 0 ] = target[ 1 ] = target[ 2 ] = Infinity;
	target[ 3 ] = target[ 4 ] = target[ 5 ] = - Infinity;

}

function getLongestEdgeIndex( bounds ) {

	let splitDimIdx = - 1;
	let splitDist = - Infinity;

	for ( let i = 0; i < 3; i ++ ) {

		const dist = bounds[ i + 3 ] - bounds[ i ];
		if ( dist > splitDist ) {

			splitDist = dist;
			splitDimIdx = i;

		}

	}

	return splitDimIdx;

}

// copies bounds a into bounds b
function copyBounds( source, target ) {

	target.set( source );

}

// sets bounds target to the union of bounds a and b
function unionBounds( a, b, target ) {

	let aVal, bVal;
	for ( let d = 0; d < 3; d ++ ) {

		const d3 = d + 3;

		// set the minimum values
		aVal = a[ d ];
		bVal = b[ d ];
		target[ d ] = aVal < bVal ? aVal : bVal;

		// set the max values
		aVal = a[ d3 ];
		bVal = b[ d3 ];
		target[ d3 ] = aVal > bVal ? aVal : bVal;

	}

}

// expands the given bounds by the provided triangle bounds
function expandByTriangleBounds( startIndex, triangleBounds, bounds ) {

	for ( let d = 0; d < 3; d ++ ) {

		const tCenter = triangleBounds[ startIndex + 2 * d ];
		const tHalf = triangleBounds[ startIndex + 2 * d + 1 ];

		const tMin = tCenter - tHalf;
		const tMax = tCenter + tHalf;

		if ( tMin < bounds[ d ] ) {

			bounds[ d ] = tMin;

		}

		if ( tMax > bounds[ d + 3 ] ) {

			bounds[ d + 3 ] = tMax;

		}

	}

}

// compute bounds surface area
function computeSurfaceArea( bounds ) {

	const d0 = bounds[ 3 ] - bounds[ 0 ];
	const d1 = bounds[ 4 ] - bounds[ 1 ];
	const d2 = bounds[ 5 ] - bounds[ 2 ];

	return 2 * ( d0 * d1 + d1 * d2 + d2 * d0 );

}

;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/core/build/splitUtils.js



const BIN_COUNT = 32;
const binsSort = ( a, b ) => a.candidate - b.candidate;
const sahBins = new Array( BIN_COUNT ).fill().map( () => {

	return {

		count: 0,
		bounds: new Float32Array( 6 ),
		rightCacheBounds: new Float32Array( 6 ),
		leftCacheBounds: new Float32Array( 6 ),
		candidate: 0,

	};

} );
const leftBounds = new Float32Array( 6 );

function getOptimalSplit( nodeBoundingData, centroidBoundingData, triangleBounds, offset, count, strategy ) {

	let axis = - 1;
	let pos = 0;

	// Center
	if ( strategy === CENTER ) {

		axis = getLongestEdgeIndex( centroidBoundingData );
		if ( axis !== - 1 ) {

			pos = ( centroidBoundingData[ axis ] + centroidBoundingData[ axis + 3 ] ) / 2;

		}

	} else if ( strategy === AVERAGE ) {

		axis = getLongestEdgeIndex( nodeBoundingData );
		if ( axis !== - 1 ) {

			pos = getAverage( triangleBounds, offset, count, axis );

		}

	} else if ( strategy === SAH ) {

		const rootSurfaceArea = computeSurfaceArea( nodeBoundingData );
		let bestCost = TRIANGLE_INTERSECT_COST * count;

		// iterate over all axes
		const cStart = offset * 6;
		const cEnd = ( offset + count ) * 6;
		for ( let a = 0; a < 3; a ++ ) {

			const axisLeft = centroidBoundingData[ a ];
			const axisRight = centroidBoundingData[ a + 3 ];
			const axisLength = axisRight - axisLeft;
			const binWidth = axisLength / BIN_COUNT;

			// If we have fewer triangles than we're planning to split then just check all
			// the triangle positions because it will be faster.
			if ( count < BIN_COUNT / 4 ) {

				// initialize the bin candidates
				const truncatedBins = [ ...sahBins ];
				truncatedBins.length = count;

				// set the candidates
				let b = 0;
				for ( let c = cStart; c < cEnd; c += 6, b ++ ) {

					const bin = truncatedBins[ b ];
					bin.candidate = triangleBounds[ c + 2 * a ];
					bin.count = 0;

					const {
						bounds,
						leftCacheBounds,
						rightCacheBounds,
					} = bin;
					for ( let d = 0; d < 3; d ++ ) {

						rightCacheBounds[ d ] = Infinity;
						rightCacheBounds[ d + 3 ] = - Infinity;

						leftCacheBounds[ d ] = Infinity;
						leftCacheBounds[ d + 3 ] = - Infinity;

						bounds[ d ] = Infinity;
						bounds[ d + 3 ] = - Infinity;

					}

					expandByTriangleBounds( c, triangleBounds, bounds );

				}

				truncatedBins.sort( binsSort );

				// remove redundant splits
				let splitCount = count;
				for ( let bi = 0; bi < splitCount; bi ++ ) {

					const bin = truncatedBins[ bi ];
					while ( bi + 1 < splitCount && truncatedBins[ bi + 1 ].candidate === bin.candidate ) {

						truncatedBins.splice( bi + 1, 1 );
						splitCount --;

					}

				}

				// find the appropriate bin for each triangle and expand the bounds.
				for ( let c = cStart; c < cEnd; c += 6 ) {

					const center = triangleBounds[ c + 2 * a ];
					for ( let bi = 0; bi < splitCount; bi ++ ) {

						const bin = truncatedBins[ bi ];
						if ( center >= bin.candidate ) {

							expandByTriangleBounds( c, triangleBounds, bin.rightCacheBounds );

						} else {

							expandByTriangleBounds( c, triangleBounds, bin.leftCacheBounds );
							bin.count ++;

						}

					}

				}

				// expand all the bounds
				for ( let bi = 0; bi < splitCount; bi ++ ) {

					const bin = truncatedBins[ bi ];
					const leftCount = bin.count;
					const rightCount = count - bin.count;

					// check the cost of this split
					const leftBounds = bin.leftCacheBounds;
					const rightBounds = bin.rightCacheBounds;

					let leftProb = 0;
					if ( leftCount !== 0 ) {

						leftProb = computeSurfaceArea( leftBounds ) / rootSurfaceArea;

					}

					let rightProb = 0;
					if ( rightCount !== 0 ) {

						rightProb = computeSurfaceArea( rightBounds ) / rootSurfaceArea;

					}

					const cost = TRAVERSAL_COST + TRIANGLE_INTERSECT_COST * (
						leftProb * leftCount + rightProb * rightCount
					);

					if ( cost < bestCost ) {

						axis = a;
						bestCost = cost;
						pos = bin.candidate;

					}

				}

			} else {

				// reset the bins
				for ( let i = 0; i < BIN_COUNT; i ++ ) {

					const bin = sahBins[ i ];
					bin.count = 0;
					bin.candidate = axisLeft + binWidth + i * binWidth;

					const bounds = bin.bounds;
					for ( let d = 0; d < 3; d ++ ) {

						bounds[ d ] = Infinity;
						bounds[ d + 3 ] = - Infinity;

					}

				}

				// iterate over all center positions
				for ( let c = cStart; c < cEnd; c += 6 ) {

					const triCenter = triangleBounds[ c + 2 * a ];
					const relativeCenter = triCenter - axisLeft;

					// in the partition function if the centroid lies on the split plane then it is
					// considered to be on the right side of the split
					let binIndex = ~ ~ ( relativeCenter / binWidth );
					if ( binIndex >= BIN_COUNT ) binIndex = BIN_COUNT - 1;

					const bin = sahBins[ binIndex ];
					bin.count ++;

					expandByTriangleBounds( c, triangleBounds, bin.bounds );

				}

				// cache the unioned bounds from right to left so we don't have to regenerate them each time
				const lastBin = sahBins[ BIN_COUNT - 1 ];
				copyBounds( lastBin.bounds, lastBin.rightCacheBounds );
				for ( let i = BIN_COUNT - 2; i >= 0; i -- ) {

					const bin = sahBins[ i ];
					const nextBin = sahBins[ i + 1 ];
					unionBounds( bin.bounds, nextBin.rightCacheBounds, bin.rightCacheBounds );

				}

				let leftCount = 0;
				for ( let i = 0; i < BIN_COUNT - 1; i ++ ) {

					const bin = sahBins[ i ];
					const binCount = bin.count;
					const bounds = bin.bounds;

					const nextBin = sahBins[ i + 1 ];
					const rightBounds = nextBin.rightCacheBounds;

					// don't do anything with the bounds if the new bounds have no triangles
					if ( binCount !== 0 ) {

						if ( leftCount === 0 ) {

							copyBounds( bounds, leftBounds );

						} else {

							unionBounds( bounds, leftBounds, leftBounds );

						}

					}

					leftCount += binCount;

					// check the cost of this split
					let leftProb = 0;
					let rightProb = 0;

					if ( leftCount !== 0 ) {

						leftProb = computeSurfaceArea( leftBounds ) / rootSurfaceArea;

					}

					const rightCount = count - leftCount;
					if ( rightCount !== 0 ) {

						rightProb = computeSurfaceArea( rightBounds ) / rootSurfaceArea;

					}

					const cost = TRAVERSAL_COST + TRIANGLE_INTERSECT_COST * (
						leftProb * leftCount + rightProb * rightCount
					);

					if ( cost < bestCost ) {

						axis = a;
						bestCost = cost;
						pos = bin.candidate;

					}

				}

			}

		}

	} else {

		console.warn( `MeshBVH: Invalid build strategy value ${ strategy } used.` );

	}

	return { axis, pos };

}

// returns the average coordinate on the specified axis of the all the provided triangles
function getAverage( triangleBounds, offset, count, axis ) {

	let avg = 0;
	for ( let i = offset, end = offset + count; i < end; i ++ ) {

		avg += triangleBounds[ i * 6 + axis * 2 ];

	}

	return avg / count;

}

;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/core/MeshBVHNode.js
class MeshBVHNode {

	constructor() {

		// internal nodes have boundingData, left, right, and splitAxis
		// leaf nodes have offset and count (referring to primitives in the mesh geometry)

		this.boundingData = new Float32Array( 6 );

	}

}

;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/core/build/sortUtils.generated.js
/********************************************************/
/* This file is generated from "sortUtils.template.js". */
/********************************************************/
// reorders `tris` such that for `count` elements after `offset`, elements on the left side of the split
// will be on the left and elements on the right side of the split will be on the right. returns the index
// of the first element on the right side, or offset + count if there are no elements on the right side.
function partition( indirectBuffer, index, triangleBounds, offset, count, split ) {

	let left = offset;
	let right = offset + count - 1;
	const pos = split.pos;
	const axisOffset = split.axis * 2;

	// hoare partitioning, see e.g. https://en.wikipedia.org/wiki/Quicksort#Hoare_partition_scheme
	while ( true ) {

		while ( left <= right && triangleBounds[ left * 6 + axisOffset ] < pos ) {

			left ++;

		}

		// if a triangle center lies on the partition plane it is considered to be on the right side
		while ( left <= right && triangleBounds[ right * 6 + axisOffset ] >= pos ) {

			right --;

		}

		if ( left < right ) {

			// we need to swap all of the information associated with the triangles at index
			// left and right; that's the verts in the geometry index, the bounds,
			// and perhaps the SAH planes

			for ( let i = 0; i < 3; i ++ ) {

				let t0 = index[ left * 3 + i ];
				index[ left * 3 + i ] = index[ right * 3 + i ];
				index[ right * 3 + i ] = t0;

			}


			// swap bounds
			for ( let i = 0; i < 6; i ++ ) {

				let tb = triangleBounds[ left * 6 + i ];
				triangleBounds[ left * 6 + i ] = triangleBounds[ right * 6 + i ];
				triangleBounds[ right * 6 + i ] = tb;

			}

			left ++;
			right --;

		} else {

			return left;

		}

	}

}



;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/core/build/sortUtils_indirect.generated.js
/********************************************************/
/* This file is generated from "sortUtils.template.js". */
/********************************************************/
// reorders `tris` such that for `count` elements after `offset`, elements on the left side of the split
// will be on the left and elements on the right side of the split will be on the right. returns the index
// of the first element on the right side, or offset + count if there are no elements on the right side.
function partition_indirect( indirectBuffer, index, triangleBounds, offset, count, split ) {

	let left = offset;
	let right = offset + count - 1;
	const pos = split.pos;
	const axisOffset = split.axis * 2;

	// hoare partitioning, see e.g. https://en.wikipedia.org/wiki/Quicksort#Hoare_partition_scheme
	while ( true ) {

		while ( left <= right && triangleBounds[ left * 6 + axisOffset ] < pos ) {

			left ++;

		}

		// if a triangle center lies on the partition plane it is considered to be on the right side
		while ( left <= right && triangleBounds[ right * 6 + axisOffset ] >= pos ) {

			right --;

		}

		if ( left < right ) {

			// we need to swap all of the information associated with the triangles at index
			// left and right; that's the verts in the geometry index, the bounds,
			// and perhaps the SAH planes
			let t = indirectBuffer[ left ];
			indirectBuffer[ left ] = indirectBuffer[ right ];
			indirectBuffer[ right ] = t;


			// swap bounds
			for ( let i = 0; i < 6; i ++ ) {

				let tb = triangleBounds[ left * 6 + i ];
				triangleBounds[ left * 6 + i ] = triangleBounds[ right * 6 + i ];
				triangleBounds[ right * 6 + i ] = tb;

			}

			left ++;
			right --;

		} else {

			return left;

		}

	}

}



;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/core/utils/nodeBufferUtils.js
function IS_LEAF( n16, uint16Array ) {

	return uint16Array[ n16 + 15 ] === 0xFFFF;

}

function OFFSET( n32, uint32Array ) {

	return uint32Array[ n32 + 6 ];

}

function COUNT( n16, uint16Array ) {

	return uint16Array[ n16 + 14 ];

}

function LEFT_NODE( n32 ) {

	return n32 + 8;

}

function RIGHT_NODE( n32, uint32Array ) {

	return uint32Array[ n32 + 6 ];

}

function SPLIT_AXIS( n32, uint32Array ) {

	return uint32Array[ n32 + 7 ];

}

function BOUNDING_DATA_INDEX( n32 ) {

	return n32;

}

;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/core/build/buildUtils.js



let float32Array, uint32Array, uint16Array, uint8Array;
const MAX_POINTER = Math.pow( 2, 32 );

function countNodes( node ) {

	if ( 'count' in node ) {

		return 1;

	} else {

		return 1 + countNodes( node.left ) + countNodes( node.right );

	}

}

function populateBuffer( byteOffset, node, buffer ) {

	float32Array = new Float32Array( buffer );
	uint32Array = new Uint32Array( buffer );
	uint16Array = new Uint16Array( buffer );
	uint8Array = new Uint8Array( buffer );

	return _populateBuffer( byteOffset, node );

}

// pack structure
// boundingData  				: 6 float32
// right / offset 				: 1 uint32
// splitAxis / isLeaf + count 	: 1 uint32 / 2 uint16
function _populateBuffer( byteOffset, node ) {

	const stride4Offset = byteOffset / 4;
	const stride2Offset = byteOffset / 2;
	const isLeaf = 'count' in node;
	const boundingData = node.boundingData;
	for ( let i = 0; i < 6; i ++ ) {

		float32Array[ stride4Offset + i ] = boundingData[ i ];

	}

	if ( isLeaf ) {

		if ( node.buffer ) {

			const buffer = node.buffer;
			uint8Array.set( new Uint8Array( buffer ), byteOffset );

			for ( let offset = byteOffset, l = byteOffset + buffer.byteLength; offset < l; offset += BYTES_PER_NODE ) {

				const offset2 = offset / 2;
				if ( ! IS_LEAF( offset2, uint16Array ) ) {

					uint32Array[ ( offset / 4 ) + 6 ] += stride4Offset;


				}

			}

			return byteOffset + buffer.byteLength;

		} else {

			const offset = node.offset;
			const count = node.count;
			uint32Array[ stride4Offset + 6 ] = offset;
			uint16Array[ stride2Offset + 14 ] = count;
			uint16Array[ stride2Offset + 15 ] = IS_LEAFNODE_FLAG;
			return byteOffset + BYTES_PER_NODE;

		}

	} else {

		const left = node.left;
		const right = node.right;
		const splitAxis = node.splitAxis;

		let nextUnusedPointer;
		nextUnusedPointer = _populateBuffer( byteOffset + BYTES_PER_NODE, left );

		if ( ( nextUnusedPointer / 4 ) > MAX_POINTER ) {

			throw new Error( 'MeshBVH: Cannot store child pointer greater than 32 bits.' );

		}

		uint32Array[ stride4Offset + 6 ] = nextUnusedPointer / 4;
		nextUnusedPointer = _populateBuffer( nextUnusedPointer, right );

		uint32Array[ stride4Offset + 7 ] = splitAxis;
		return nextUnusedPointer;

	}

}

;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/core/build/buildTree.js










function generateIndirectBuffer( geometry, useSharedArrayBuffer ) {

	const triCount = ( geometry.index ? geometry.index.count : geometry.attributes.position.count ) / 3;
	const useUint32 = triCount > 2 ** 16;
	const byteCount = useUint32 ? 4 : 2;

	const buffer = useSharedArrayBuffer ? new SharedArrayBuffer( triCount * byteCount ) : new ArrayBuffer( triCount * byteCount );
	const indirectBuffer = useUint32 ? new Uint32Array( buffer ) : new Uint16Array( buffer );
	for ( let i = 0, l = indirectBuffer.length; i < l; i ++ ) {

		indirectBuffer[ i ] = i;

	}

	return indirectBuffer;

}

function buildTree( bvh, triangleBounds, offset, count, options ) {

	// epxand variables
	const {
		maxDepth,
		verbose,
		maxLeafTris,
		strategy,
		onProgress,
		indirect,
	} = options;
	const indirectBuffer = bvh._indirectBuffer;
	const geometry = bvh.geometry;
	const indexArray = geometry.index ? geometry.index.array : null;
	const partionFunc = indirect ? partition_indirect : partition;

	// generate intermediate variables
	const totalTriangles = getTriCount( geometry );
	const cacheCentroidBoundingData = new Float32Array( 6 );
	let reachedMaxDepth = false;

	const root = new MeshBVHNode();
	getBounds( triangleBounds, offset, count, root.boundingData, cacheCentroidBoundingData );
	splitNode( root, offset, count, cacheCentroidBoundingData );
	return root;

	function triggerProgress( trianglesProcessed ) {

		if ( onProgress ) {

			onProgress( trianglesProcessed / totalTriangles );

		}

	}

	// either recursively splits the given node, creating left and right subtrees for it, or makes it a leaf node,
	// recording the offset and count of its triangles and writing them into the reordered geometry index.
	function splitNode( node, offset, count, centroidBoundingData = null, depth = 0 ) {

		if ( ! reachedMaxDepth && depth >= maxDepth ) {

			reachedMaxDepth = true;
			if ( verbose ) {

				console.warn( `MeshBVH: Max depth of ${ maxDepth } reached when generating BVH. Consider increasing maxDepth.` );
				console.warn( geometry );

			}

		}

		// early out if we've met our capacity
		if ( count <= maxLeafTris || depth >= maxDepth ) {

			triggerProgress( offset + count );
			node.offset = offset;
			node.count = count;
			return node;

		}

		// Find where to split the volume
		const split = getOptimalSplit( node.boundingData, centroidBoundingData, triangleBounds, offset, count, strategy );
		if ( split.axis === - 1 ) {

			triggerProgress( offset + count );
			node.offset = offset;
			node.count = count;
			return node;

		}

		const splitOffset = partionFunc( indirectBuffer, indexArray, triangleBounds, offset, count, split );

		// create the two new child nodes
		if ( splitOffset === offset || splitOffset === offset + count ) {

			triggerProgress( offset + count );
			node.offset = offset;
			node.count = count;

		} else {

			node.splitAxis = split.axis;

			// create the left child and compute its bounding box
			const left = new MeshBVHNode();
			const lstart = offset;
			const lcount = splitOffset - offset;
			node.left = left;

			getBounds( triangleBounds, lstart, lcount, left.boundingData, cacheCentroidBoundingData );
			splitNode( left, lstart, lcount, cacheCentroidBoundingData, depth + 1 );

			// repeat for right
			const right = new MeshBVHNode();
			const rstart = splitOffset;
			const rcount = count - lcount;
			node.right = right;

			getBounds( triangleBounds, rstart, rcount, right.boundingData, cacheCentroidBoundingData );
			splitNode( right, rstart, rcount, cacheCentroidBoundingData, depth + 1 );

		}

		return node;

	}

}

function buildPackedTree( bvh, options ) {

	const geometry = bvh.geometry;
	if ( options.indirect ) {

		bvh._indirectBuffer = generateIndirectBuffer( geometry, options.useSharedArrayBuffer );

		if ( hasGroupGaps( geometry ) && ! options.verbose ) {

			console.warn(
				'MeshBVH: Provided geometry contains groups that do not fully span the vertex contents while using the "indirect" option. ' +
				'BVH may incorrectly report intersections on unrendered portions of the geometry.'
			);

		}

	}

	if ( ! bvh._indirectBuffer ) {

		ensureIndex( geometry, options );

	}

	const BufferConstructor = options.useSharedArrayBuffer ? SharedArrayBuffer : ArrayBuffer;

	const triangleBounds = computeTriangleBounds( geometry );
	const geometryRanges = options.indirect ? getFullGeometryRange( geometry ) : getRootIndexRanges( geometry );
	bvh._roots = geometryRanges.map( range => {

		const root = buildTree( bvh, triangleBounds, range.offset, range.count, options );
		const nodeCount = countNodes( root );
		const buffer = new BufferConstructor( BYTES_PER_NODE * nodeCount );
		populateBuffer( 0, root, buffer );
		return buffer;

	} );

}

;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/math/SeparatingAxisBounds.js


class SeparatingAxisBounds {

	constructor() {

		this.min = Infinity;
		this.max = - Infinity;

	}

	setFromPointsField( points, field ) {

		let min = Infinity;
		let max = - Infinity;
		for ( let i = 0, l = points.length; i < l; i ++ ) {

			const p = points[ i ];
			const val = p[ field ];
			min = val < min ? val : min;
			max = val > max ? val : max;

		}

		this.min = min;
		this.max = max;

	}

	setFromPoints( axis, points ) {

		let min = Infinity;
		let max = - Infinity;
		for ( let i = 0, l = points.length; i < l; i ++ ) {

			const p = points[ i ];
			const val = axis.dot( p );
			min = val < min ? val : min;
			max = val > max ? val : max;

		}

		this.min = min;
		this.max = max;

	}

	isSeparated( other ) {

		return this.min > other.max || other.min > this.max;

	}

}

SeparatingAxisBounds.prototype.setFromBox = ( function () {

	const p = new three_module/* Vector3 */.Pa4();
	return function setFromBox( axis, box ) {

		const boxMin = box.min;
		const boxMax = box.max;
		let min = Infinity;
		let max = - Infinity;
		for ( let x = 0; x <= 1; x ++ ) {

			for ( let y = 0; y <= 1; y ++ ) {

				for ( let z = 0; z <= 1; z ++ ) {

					p.x = boxMin.x * x + boxMax.x * ( 1 - x );
					p.y = boxMin.y * y + boxMax.y * ( 1 - y );
					p.z = boxMin.z * z + boxMax.z * ( 1 - z );

					const val = axis.dot( p );
					min = Math.min( val, min );
					max = Math.max( val, max );

				}

			}

		}

		this.min = min;
		this.max = max;

	};

} )();

const areIntersecting = ( function () {

	const cacheSatBounds = new SeparatingAxisBounds();
	return function areIntersecting( shape1, shape2 ) {

		const points1 = shape1.points;
		const satAxes1 = shape1.satAxes;
		const satBounds1 = shape1.satBounds;

		const points2 = shape2.points;
		const satAxes2 = shape2.satAxes;
		const satBounds2 = shape2.satBounds;

		// check axes of the first shape
		for ( let i = 0; i < 3; i ++ ) {

			const sb = satBounds1[ i ];
			const sa = satAxes1[ i ];
			cacheSatBounds.setFromPoints( sa, points2 );
			if ( sb.isSeparated( cacheSatBounds ) ) return false;

		}

		// check axes of the second shape
		for ( let i = 0; i < 3; i ++ ) {

			const sb = satBounds2[ i ];
			const sa = satAxes2[ i ];
			cacheSatBounds.setFromPoints( sa, points1 );
			if ( sb.isSeparated( cacheSatBounds ) ) return false;

		}

	};

} )();

;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/math/MathUtilities.js


const closestPointLineToLine = ( function () {

	// https://github.com/juj/MathGeoLib/blob/master/src/Geometry/Line.cpp#L56
	const dir1 = new three_module/* Vector3 */.Pa4();
	const dir2 = new three_module/* Vector3 */.Pa4();
	const v02 = new three_module/* Vector3 */.Pa4();
	return function closestPointLineToLine( l1, l2, result ) {

		const v0 = l1.start;
		const v10 = dir1;
		const v2 = l2.start;
		const v32 = dir2;

		v02.subVectors( v0, v2 );
		dir1.subVectors( l1.end, l1.start );
		dir2.subVectors( l2.end, l2.start );

		// float d0232 = v02.Dot(v32);
		const d0232 = v02.dot( v32 );

		// float d3210 = v32.Dot(v10);
		const d3210 = v32.dot( v10 );

		// float d3232 = v32.Dot(v32);
		const d3232 = v32.dot( v32 );

		// float d0210 = v02.Dot(v10);
		const d0210 = v02.dot( v10 );

		// float d1010 = v10.Dot(v10);
		const d1010 = v10.dot( v10 );

		// float denom = d1010*d3232 - d3210*d3210;
		const denom = d1010 * d3232 - d3210 * d3210;

		let d, d2;
		if ( denom !== 0 ) {

			d = ( d0232 * d3210 - d0210 * d3232 ) / denom;

		} else {

			d = 0;

		}

		d2 = ( d0232 + d * d3210 ) / d3232;

		result.x = d;
		result.y = d2;

	};

} )();

const closestPointsSegmentToSegment = ( function () {

	// https://github.com/juj/MathGeoLib/blob/master/src/Geometry/LineSegment.cpp#L187
	const paramResult = new three_module/* Vector2 */.FM8();
	const temp1 = new three_module/* Vector3 */.Pa4();
	const temp2 = new three_module/* Vector3 */.Pa4();
	return function closestPointsSegmentToSegment( l1, l2, target1, target2 ) {

		closestPointLineToLine( l1, l2, paramResult );

		let d = paramResult.x;
		let d2 = paramResult.y;
		if ( d >= 0 && d <= 1 && d2 >= 0 && d2 <= 1 ) {

			l1.at( d, target1 );
			l2.at( d2, target2 );

			return;

		} else if ( d >= 0 && d <= 1 ) {

			// Only d2 is out of bounds.
			if ( d2 < 0 ) {

				l2.at( 0, target2 );

			} else {

				l2.at( 1, target2 );

			}

			l1.closestPointToPoint( target2, true, target1 );
			return;

		} else if ( d2 >= 0 && d2 <= 1 ) {

			// Only d is out of bounds.
			if ( d < 0 ) {

				l1.at( 0, target1 );

			} else {

				l1.at( 1, target1 );

			}

			l2.closestPointToPoint( target1, true, target2 );
			return;

		} else {

			// Both u and u2 are out of bounds.
			let p;
			if ( d < 0 ) {

				p = l1.start;

			} else {

				p = l1.end;

			}

			let p2;
			if ( d2 < 0 ) {

				p2 = l2.start;

			} else {

				p2 = l2.end;

			}

			const closestPoint = temp1;
			const closestPoint2 = temp2;
			l1.closestPointToPoint( p2, true, temp1 );
			l2.closestPointToPoint( p, true, temp2 );

			if ( closestPoint.distanceToSquared( p2 ) <= closestPoint2.distanceToSquared( p ) ) {

				target1.copy( closestPoint );
				target2.copy( p2 );
				return;

			} else {

				target1.copy( p );
				target2.copy( closestPoint2 );
				return;

			}

		}

	};

} )();


const sphereIntersectTriangle = ( function () {

	// https://stackoverflow.com/questions/34043955/detect-collision-between-sphere-and-triangle-in-three-js
	const closestPointTemp = new three_module/* Vector3 */.Pa4();
	const projectedPointTemp = new three_module/* Vector3 */.Pa4();
	const planeTemp = new three_module/* Plane */.JOQ();
	const lineTemp = new three_module/* Line3 */.Zzh();
	return function sphereIntersectTriangle( sphere, triangle ) {

		const { radius, center } = sphere;
		const { a, b, c } = triangle;

		// phase 1
		lineTemp.start = a;
		lineTemp.end = b;
		const closestPoint1 = lineTemp.closestPointToPoint( center, true, closestPointTemp );
		if ( closestPoint1.distanceTo( center ) <= radius ) return true;

		lineTemp.start = a;
		lineTemp.end = c;
		const closestPoint2 = lineTemp.closestPointToPoint( center, true, closestPointTemp );
		if ( closestPoint2.distanceTo( center ) <= radius ) return true;

		lineTemp.start = b;
		lineTemp.end = c;
		const closestPoint3 = lineTemp.closestPointToPoint( center, true, closestPointTemp );
		if ( closestPoint3.distanceTo( center ) <= radius ) return true;

		// phase 2
		const plane = triangle.getPlane( planeTemp );
		const dp = Math.abs( plane.distanceToPoint( center ) );
		if ( dp <= radius ) {

			const pp = plane.projectPoint( center, projectedPointTemp );
			const cp = triangle.containsPoint( pp );
			if ( cp ) return true;

		}

		return false;

	};

} )();

;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/math/ExtendedTriangle.js




const ZERO_EPSILON = 1e-15;
function isNearZero( value ) {

	return Math.abs( value ) < ZERO_EPSILON;

}

class ExtendedTriangle extends three_module/* Triangle */.CJI {

	constructor( ...args ) {

		super( ...args );

		this.isExtendedTriangle = true;
		this.satAxes = new Array( 4 ).fill().map( () => new three_module/* Vector3 */.Pa4() );
		this.satBounds = new Array( 4 ).fill().map( () => new SeparatingAxisBounds() );
		this.points = [ this.a, this.b, this.c ];
		this.sphere = new three_module/* Sphere */.aLr();
		this.plane = new three_module/* Plane */.JOQ();
		this.needsUpdate = true;

	}

	intersectsSphere( sphere ) {

		return sphereIntersectTriangle( sphere, this );

	}

	update() {

		const a = this.a;
		const b = this.b;
		const c = this.c;
		const points = this.points;

		const satAxes = this.satAxes;
		const satBounds = this.satBounds;

		const axis0 = satAxes[ 0 ];
		const sab0 = satBounds[ 0 ];
		this.getNormal( axis0 );
		sab0.setFromPoints( axis0, points );

		const axis1 = satAxes[ 1 ];
		const sab1 = satBounds[ 1 ];
		axis1.subVectors( a, b );
		sab1.setFromPoints( axis1, points );

		const axis2 = satAxes[ 2 ];
		const sab2 = satBounds[ 2 ];
		axis2.subVectors( b, c );
		sab2.setFromPoints( axis2, points );

		const axis3 = satAxes[ 3 ];
		const sab3 = satBounds[ 3 ];
		axis3.subVectors( c, a );
		sab3.setFromPoints( axis3, points );

		this.sphere.setFromPoints( this.points );
		this.plane.setFromNormalAndCoplanarPoint( axis0, a );
		this.needsUpdate = false;

	}

}

ExtendedTriangle.prototype.closestPointToSegment = ( function () {

	const point1 = new three_module/* Vector3 */.Pa4();
	const point2 = new three_module/* Vector3 */.Pa4();
	const edge = new three_module/* Line3 */.Zzh();

	return function distanceToSegment( segment, target1 = null, target2 = null ) {

		const { start, end } = segment;
		const points = this.points;
		let distSq;
		let closestDistanceSq = Infinity;

		// check the triangle edges
		for ( let i = 0; i < 3; i ++ ) {

			const nexti = ( i + 1 ) % 3;
			edge.start.copy( points[ i ] );
			edge.end.copy( points[ nexti ] );

			closestPointsSegmentToSegment( edge, segment, point1, point2 );

			distSq = point1.distanceToSquared( point2 );
			if ( distSq < closestDistanceSq ) {

				closestDistanceSq = distSq;
				if ( target1 ) target1.copy( point1 );
				if ( target2 ) target2.copy( point2 );

			}

		}

		// check end points
		this.closestPointToPoint( start, point1 );
		distSq = start.distanceToSquared( point1 );
		if ( distSq < closestDistanceSq ) {

			closestDistanceSq = distSq;
			if ( target1 ) target1.copy( point1 );
			if ( target2 ) target2.copy( start );

		}

		this.closestPointToPoint( end, point1 );
		distSq = end.distanceToSquared( point1 );
		if ( distSq < closestDistanceSq ) {

			closestDistanceSq = distSq;
			if ( target1 ) target1.copy( point1 );
			if ( target2 ) target2.copy( end );

		}

		return Math.sqrt( closestDistanceSq );

	};

} )();

ExtendedTriangle.prototype.intersectsTriangle = ( function () {

	const saTri2 = new ExtendedTriangle();
	const arr1 = new Array( 3 );
	const arr2 = new Array( 3 );
	const cachedSatBounds = new SeparatingAxisBounds();
	const cachedSatBounds2 = new SeparatingAxisBounds();
	const cachedAxis = new three_module/* Vector3 */.Pa4();
	const dir = new three_module/* Vector3 */.Pa4();
	const dir1 = new three_module/* Vector3 */.Pa4();
	const dir2 = new three_module/* Vector3 */.Pa4();
	const tempDir = new three_module/* Vector3 */.Pa4();
	const edge = new three_module/* Line3 */.Zzh();
	const edge1 = new three_module/* Line3 */.Zzh();
	const edge2 = new three_module/* Line3 */.Zzh();
	const tempPoint = new three_module/* Vector3 */.Pa4();

	function triIntersectPlane( tri, plane, targetEdge ) {

		// find the edge that intersects the other triangle plane
		const points = tri.points;
		let count = 0;
		let startPointIntersection = - 1;
		for ( let i = 0; i < 3; i ++ ) {

			const { start, end } = edge;
			start.copy( points[ i ] );
			end.copy( points[ ( i + 1 ) % 3 ] );
			edge.delta( dir );

			const startIntersects = isNearZero( plane.distanceToPoint( start ) );
			if ( isNearZero( plane.normal.dot( dir ) ) && startIntersects ) {

				// if the edge lies on the plane then take the line
				targetEdge.copy( edge );
				count = 2;
				break;

			}

			// check if the start point is near the plane because "intersectLine" is not robust to that case
			const doesIntersect = plane.intersectLine( edge, tempPoint );
			if ( ! doesIntersect && startIntersects ) {

				tempPoint.copy( start );

			}

			// ignore the end point
			if ( ( doesIntersect || startIntersects ) && ! isNearZero( tempPoint.distanceTo( end ) ) ) {

				if ( count <= 1 ) {

					// assign to the start or end point and save which index was snapped to
					// the start point if necessary
					const point = count === 1 ? targetEdge.start : targetEdge.end;
					point.copy( tempPoint );
					if ( startIntersects ) {

						startPointIntersection = count;

					}

				} else if ( count >= 2 ) {

					// if we're here that means that there must have been one point that had
					// snapped to the start point so replace it here
					const point = startPointIntersection === 1 ? targetEdge.start : targetEdge.end;
					point.copy( tempPoint );
					count = 2;
					break;

				}

				count ++;
				if ( count === 2 && startPointIntersection === - 1 ) {

					break;

				}

			}

		}

		return count;

	}

	// TODO: If the triangles are coplanar and intersecting the target is nonsensical. It should at least
	// be a line contained by both triangles if not a different special case somehow represented in the return result.
	return function intersectsTriangle( other, target = null, suppressLog = false ) {

		if ( this.needsUpdate ) {

			this.update();

		}

		if ( ! other.isExtendedTriangle ) {

			saTri2.copy( other );
			saTri2.update();
			other = saTri2;

		} else if ( other.needsUpdate ) {

			other.update();

		}

		const plane1 = this.plane;
		const plane2 = other.plane;

		if ( Math.abs( plane1.normal.dot( plane2.normal ) ) > 1.0 - 1e-10 ) {

			// perform separating axis intersection test only for coplanar triangles
			const satBounds1 = this.satBounds;
			const satAxes1 = this.satAxes;
			arr2[ 0 ] = other.a;
			arr2[ 1 ] = other.b;
			arr2[ 2 ] = other.c;
			for ( let i = 0; i < 4; i ++ ) {

				const sb = satBounds1[ i ];
				const sa = satAxes1[ i ];
				cachedSatBounds.setFromPoints( sa, arr2 );
				if ( sb.isSeparated( cachedSatBounds ) ) return false;

			}

			const satBounds2 = other.satBounds;
			const satAxes2 = other.satAxes;
			arr1[ 0 ] = this.a;
			arr1[ 1 ] = this.b;
			arr1[ 2 ] = this.c;
			for ( let i = 0; i < 4; i ++ ) {

				const sb = satBounds2[ i ];
				const sa = satAxes2[ i ];
				cachedSatBounds.setFromPoints( sa, arr1 );
				if ( sb.isSeparated( cachedSatBounds ) ) return false;

			}

			// check crossed axes
			for ( let i = 0; i < 4; i ++ ) {

				const sa1 = satAxes1[ i ];
				for ( let i2 = 0; i2 < 4; i2 ++ ) {

					const sa2 = satAxes2[ i2 ];
					cachedAxis.crossVectors( sa1, sa2 );
					cachedSatBounds.setFromPoints( cachedAxis, arr1 );
					cachedSatBounds2.setFromPoints( cachedAxis, arr2 );
					if ( cachedSatBounds.isSeparated( cachedSatBounds2 ) ) return false;

				}

			}

			if ( target ) {

				// TODO find two points that intersect on the edges and make that the result
				if ( ! suppressLog ) {

					console.warn( 'ExtendedTriangle.intersectsTriangle: Triangles are coplanar which does not support an output edge. Setting edge to 0, 0, 0.' );

				}

				target.start.set( 0, 0, 0 );
				target.end.set( 0, 0, 0 );

			}

			return true;

		} else {

			// find the edge that intersects the other triangle plane
			const count1 = triIntersectPlane( this, plane2, edge1 );
			if ( count1 === 1 && other.containsPoint( edge1.end ) ) {

				if ( target ) {

					target.start.copy( edge1.end );
					target.end.copy( edge1.end );

				}

				return true;

			} else if ( count1 !== 2 ) {

				return false;

			}

			// find the other triangles edge that intersects this plane
			const count2 = triIntersectPlane( other, plane1, edge2 );
			if ( count2 === 1 && this.containsPoint( edge2.end ) ) {

				if ( target ) {

					target.start.copy( edge2.end );
					target.end.copy( edge2.end );

				}

				return true;

			} else if ( count2 !== 2 ) {

				return false;

			}

			// find swap the second edge so both lines are running the same direction
			edge1.delta( dir1 );
			edge2.delta( dir2 );

			if ( dir1.dot( dir2 ) < 0 ) {

				let tmp = edge2.start;
				edge2.start = edge2.end;
				edge2.end = tmp;

			}

			// check if the edges are overlapping
			const s1 = edge1.start.dot( dir1 );
			const e1 = edge1.end.dot( dir1 );
			const s2 = edge2.start.dot( dir1 );
			const e2 = edge2.end.dot( dir1 );
			const separated1 = e1 < s2;
			const separated2 = s1 < e2;

			if ( s1 !== e2 && s2 !== e1 && separated1 === separated2 ) {

				return false;

			}

			// assign the target output
			if ( target ) {

				tempDir.subVectors( edge1.start, edge2.start );
				if ( tempDir.dot( dir1 ) > 0 ) {

					target.start.copy( edge1.start );

				} else {

					target.start.copy( edge2.start );

				}

				tempDir.subVectors( edge1.end, edge2.end );
				if ( tempDir.dot( dir1 ) < 0 ) {

					target.end.copy( edge1.end );

				} else {

					target.end.copy( edge2.end );

				}

			}

			return true;

		}

	};

} )();


ExtendedTriangle.prototype.distanceToPoint = ( function () {

	const target = new three_module/* Vector3 */.Pa4();
	return function distanceToPoint( point ) {

		this.closestPointToPoint( point, target );
		return point.distanceTo( target );

	};

} )();


ExtendedTriangle.prototype.distanceToTriangle = ( function () {

	const point = new three_module/* Vector3 */.Pa4();
	const point2 = new three_module/* Vector3 */.Pa4();
	const cornerFields = [ 'a', 'b', 'c' ];
	const line1 = new three_module/* Line3 */.Zzh();
	const line2 = new three_module/* Line3 */.Zzh();

	return function distanceToTriangle( other, target1 = null, target2 = null ) {

		const lineTarget = target1 || target2 ? line1 : null;
		if ( this.intersectsTriangle( other, lineTarget ) ) {

			if ( target1 || target2 ) {

				if ( target1 ) lineTarget.getCenter( target1 );
				if ( target2 ) lineTarget.getCenter( target2 );

			}

			return 0;

		}

		let closestDistanceSq = Infinity;

		// check all point distances
		for ( let i = 0; i < 3; i ++ ) {

			let dist;
			const field = cornerFields[ i ];
			const otherVec = other[ field ];
			this.closestPointToPoint( otherVec, point );

			dist = otherVec.distanceToSquared( point );

			if ( dist < closestDistanceSq ) {

				closestDistanceSq = dist;
				if ( target1 ) target1.copy( point );
				if ( target2 ) target2.copy( otherVec );

			}


			const thisVec = this[ field ];
			other.closestPointToPoint( thisVec, point );

			dist = thisVec.distanceToSquared( point );

			if ( dist < closestDistanceSq ) {

				closestDistanceSq = dist;
				if ( target1 ) target1.copy( thisVec );
				if ( target2 ) target2.copy( point );

			}

		}

		for ( let i = 0; i < 3; i ++ ) {

			const f11 = cornerFields[ i ];
			const f12 = cornerFields[ ( i + 1 ) % 3 ];
			line1.set( this[ f11 ], this[ f12 ] );
			for ( let i2 = 0; i2 < 3; i2 ++ ) {

				const f21 = cornerFields[ i2 ];
				const f22 = cornerFields[ ( i2 + 1 ) % 3 ];
				line2.set( other[ f21 ], other[ f22 ] );

				closestPointsSegmentToSegment( line1, line2, point, point2 );

				const dist = point.distanceToSquared( point2 );
				if ( dist < closestDistanceSq ) {

					closestDistanceSq = dist;
					if ( target1 ) target1.copy( point );
					if ( target2 ) target2.copy( point2 );

				}

			}

		}

		return Math.sqrt( closestDistanceSq );

	};

} )();

;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/math/OrientedBox.js





class OrientedBox {

	constructor( min, max, matrix ) {

		this.isOrientedBox = true;
		this.min = new three_module/* Vector3 */.Pa4();
		this.max = new three_module/* Vector3 */.Pa4();
		this.matrix = new three_module/* Matrix4 */.yGw();
		this.invMatrix = new three_module/* Matrix4 */.yGw();
		this.points = new Array( 8 ).fill().map( () => new three_module/* Vector3 */.Pa4() );
		this.satAxes = new Array( 3 ).fill().map( () => new three_module/* Vector3 */.Pa4() );
		this.satBounds = new Array( 3 ).fill().map( () => new SeparatingAxisBounds() );
		this.alignedSatBounds = new Array( 3 ).fill().map( () => new SeparatingAxisBounds() );
		this.needsUpdate = false;

		if ( min ) this.min.copy( min );
		if ( max ) this.max.copy( max );
		if ( matrix ) this.matrix.copy( matrix );

	}

	set( min, max, matrix ) {

		this.min.copy( min );
		this.max.copy( max );
		this.matrix.copy( matrix );
		this.needsUpdate = true;

	}

	copy( other ) {

		this.min.copy( other.min );
		this.max.copy( other.max );
		this.matrix.copy( other.matrix );
		this.needsUpdate = true;

	}

}

OrientedBox.prototype.update = ( function () {

	return function update() {

		const matrix = this.matrix;
		const min = this.min;
		const max = this.max;

		const points = this.points;
		for ( let x = 0; x <= 1; x ++ ) {

			for ( let y = 0; y <= 1; y ++ ) {

				for ( let z = 0; z <= 1; z ++ ) {

					const i = ( ( 1 << 0 ) * x ) | ( ( 1 << 1 ) * y ) | ( ( 1 << 2 ) * z );
					const v = points[ i ];
					v.x = x ? max.x : min.x;
					v.y = y ? max.y : min.y;
					v.z = z ? max.z : min.z;

					v.applyMatrix4( matrix );

				}

			}

		}

		const satBounds = this.satBounds;
		const satAxes = this.satAxes;
		const minVec = points[ 0 ];
		for ( let i = 0; i < 3; i ++ ) {

			const axis = satAxes[ i ];
			const sb = satBounds[ i ];
			const index = 1 << i;
			const pi = points[ index ];

			axis.subVectors( minVec, pi );
			sb.setFromPoints( axis, points );

		}

		const alignedSatBounds = this.alignedSatBounds;
		alignedSatBounds[ 0 ].setFromPointsField( points, 'x' );
		alignedSatBounds[ 1 ].setFromPointsField( points, 'y' );
		alignedSatBounds[ 2 ].setFromPointsField( points, 'z' );

		this.invMatrix.copy( this.matrix ).invert();
		this.needsUpdate = false;

	};

} )();

OrientedBox.prototype.intersectsBox = ( function () {

	const aabbBounds = new SeparatingAxisBounds();
	return function intersectsBox( box ) {

		// TODO: should this be doing SAT against the AABB?
		if ( this.needsUpdate ) {

			this.update();

		}

		const min = box.min;
		const max = box.max;
		const satBounds = this.satBounds;
		const satAxes = this.satAxes;
		const alignedSatBounds = this.alignedSatBounds;

		aabbBounds.min = min.x;
		aabbBounds.max = max.x;
		if ( alignedSatBounds[ 0 ].isSeparated( aabbBounds ) ) return false;

		aabbBounds.min = min.y;
		aabbBounds.max = max.y;
		if ( alignedSatBounds[ 1 ].isSeparated( aabbBounds ) ) return false;

		aabbBounds.min = min.z;
		aabbBounds.max = max.z;
		if ( alignedSatBounds[ 2 ].isSeparated( aabbBounds ) ) return false;

		for ( let i = 0; i < 3; i ++ ) {

			const axis = satAxes[ i ];
			const sb = satBounds[ i ];
			aabbBounds.setFromBox( axis, box );
			if ( sb.isSeparated( aabbBounds ) ) return false;

		}

		return true;

	};

} )();

OrientedBox.prototype.intersectsTriangle = ( function () {

	const saTri = new ExtendedTriangle();
	const pointsArr = new Array( 3 );
	const cachedSatBounds = new SeparatingAxisBounds();
	const cachedSatBounds2 = new SeparatingAxisBounds();
	const cachedAxis = new three_module/* Vector3 */.Pa4();
	return function intersectsTriangle( triangle ) {

		if ( this.needsUpdate ) {

			this.update();

		}

		if ( ! triangle.isExtendedTriangle ) {

			saTri.copy( triangle );
			saTri.update();
			triangle = saTri;

		} else if ( triangle.needsUpdate ) {

			triangle.update();

		}

		const satBounds = this.satBounds;
		const satAxes = this.satAxes;

		pointsArr[ 0 ] = triangle.a;
		pointsArr[ 1 ] = triangle.b;
		pointsArr[ 2 ] = triangle.c;

		for ( let i = 0; i < 3; i ++ ) {

			const sb = satBounds[ i ];
			const sa = satAxes[ i ];
			cachedSatBounds.setFromPoints( sa, pointsArr );
			if ( sb.isSeparated( cachedSatBounds ) ) return false;

		}

		const triSatBounds = triangle.satBounds;
		const triSatAxes = triangle.satAxes;
		const points = this.points;
		for ( let i = 0; i < 3; i ++ ) {

			const sb = triSatBounds[ i ];
			const sa = triSatAxes[ i ];
			cachedSatBounds.setFromPoints( sa, points );
			if ( sb.isSeparated( cachedSatBounds ) ) return false;

		}

		// check crossed axes
		for ( let i = 0; i < 3; i ++ ) {

			const sa1 = satAxes[ i ];
			for ( let i2 = 0; i2 < 4; i2 ++ ) {

				const sa2 = triSatAxes[ i2 ];
				cachedAxis.crossVectors( sa1, sa2 );
				cachedSatBounds.setFromPoints( cachedAxis, pointsArr );
				cachedSatBounds2.setFromPoints( cachedAxis, points );
				if ( cachedSatBounds.isSeparated( cachedSatBounds2 ) ) return false;

			}

		}

		return true;

	};

} )();

OrientedBox.prototype.closestPointToPoint = ( function () {

	return function closestPointToPoint( point, target1 ) {

		if ( this.needsUpdate ) {

			this.update();

		}

		target1
			.copy( point )
			.applyMatrix4( this.invMatrix )
			.clamp( this.min, this.max )
			.applyMatrix4( this.matrix );

		return target1;

	};

} )();

OrientedBox.prototype.distanceToPoint = ( function () {

	const target = new three_module/* Vector3 */.Pa4();
	return function distanceToPoint( point ) {

		this.closestPointToPoint( point, target );
		return point.distanceTo( target );

	};

} )();

OrientedBox.prototype.distanceToBox = ( function () {

	const xyzFields = [ 'x', 'y', 'z' ];
	const segments1 = new Array( 12 ).fill().map( () => new three_module/* Line3 */.Zzh() );
	const segments2 = new Array( 12 ).fill().map( () => new three_module/* Line3 */.Zzh() );

	const point1 = new three_module/* Vector3 */.Pa4();
	const point2 = new three_module/* Vector3 */.Pa4();

	// early out if we find a value below threshold
	return function distanceToBox( box, threshold = 0, target1 = null, target2 = null ) {

		if ( this.needsUpdate ) {

			this.update();

		}

		if ( this.intersectsBox( box ) ) {

			if ( target1 || target2 ) {

				box.getCenter( point2 );
				this.closestPointToPoint( point2, point1 );
				box.closestPointToPoint( point1, point2 );

				if ( target1 ) target1.copy( point1 );
				if ( target2 ) target2.copy( point2 );

			}

			return 0;

		}

		const threshold2 = threshold * threshold;
		const min = box.min;
		const max = box.max;
		const points = this.points;


		// iterate over every edge and compare distances
		let closestDistanceSq = Infinity;

		// check over all these points
		for ( let i = 0; i < 8; i ++ ) {

			const p = points[ i ];
			point2.copy( p ).clamp( min, max );

			const dist = p.distanceToSquared( point2 );
			if ( dist < closestDistanceSq ) {

				closestDistanceSq = dist;
				if ( target1 ) target1.copy( p );
				if ( target2 ) target2.copy( point2 );

				if ( dist < threshold2 ) return Math.sqrt( dist );

			}

		}

		// generate and check all line segment distances
		let count = 0;
		for ( let i = 0; i < 3; i ++ ) {

			for ( let i1 = 0; i1 <= 1; i1 ++ ) {

				for ( let i2 = 0; i2 <= 1; i2 ++ ) {

					const nextIndex = ( i + 1 ) % 3;
					const nextIndex2 = ( i + 2 ) % 3;

					// get obb line segments
					const index = i1 << nextIndex | i2 << nextIndex2;
					const index2 = 1 << i | i1 << nextIndex | i2 << nextIndex2;
					const p1 = points[ index ];
					const p2 = points[ index2 ];
					const line1 = segments1[ count ];
					line1.set( p1, p2 );


					// get aabb line segments
					const f1 = xyzFields[ i ];
					const f2 = xyzFields[ nextIndex ];
					const f3 = xyzFields[ nextIndex2 ];
					const line2 = segments2[ count ];
					const start = line2.start;
					const end = line2.end;

					start[ f1 ] = min[ f1 ];
					start[ f2 ] = i1 ? min[ f2 ] : max[ f2 ];
					start[ f3 ] = i2 ? min[ f3 ] : max[ f2 ];

					end[ f1 ] = max[ f1 ];
					end[ f2 ] = i1 ? min[ f2 ] : max[ f2 ];
					end[ f3 ] = i2 ? min[ f3 ] : max[ f2 ];

					count ++;

				}

			}

		}

		// check all the other boxes point
		for ( let x = 0; x <= 1; x ++ ) {

			for ( let y = 0; y <= 1; y ++ ) {

				for ( let z = 0; z <= 1; z ++ ) {

					point2.x = x ? max.x : min.x;
					point2.y = y ? max.y : min.y;
					point2.z = z ? max.z : min.z;

					this.closestPointToPoint( point2, point1 );
					const dist = point2.distanceToSquared( point1 );
					if ( dist < closestDistanceSq ) {

						closestDistanceSq = dist;
						if ( target1 ) target1.copy( point1 );
						if ( target2 ) target2.copy( point2 );

						if ( dist < threshold2 ) return Math.sqrt( dist );

					}

				}

			}

		}

		for ( let i = 0; i < 12; i ++ ) {

			const l1 = segments1[ i ];
			for ( let i2 = 0; i2 < 12; i2 ++ ) {

				const l2 = segments2[ i2 ];
				closestPointsSegmentToSegment( l1, l2, point1, point2 );
				const dist = point1.distanceToSquared( point2 );
				if ( dist < closestDistanceSq ) {

					closestDistanceSq = dist;
					if ( target1 ) target1.copy( point1 );
					if ( target2 ) target2.copy( point2 );

					if ( dist < threshold2 ) return Math.sqrt( dist );

				}

			}

		}

		return Math.sqrt( closestDistanceSq );

	};

} )();

;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/utils/PrimitivePool.js
class PrimitivePool {

	constructor( getNewPrimitive ) {

		this._getNewPrimitive = getNewPrimitive;
		this._primitives = [];

	}

	getPrimitive() {

		const primitives = this._primitives;
		if ( primitives.length === 0 ) {

			return this._getNewPrimitive();

		} else {

			return primitives.pop();

		}

	}

	releasePrimitive( primitive ) {

		this._primitives.push( primitive );

	}

}

;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/utils/ExtendedTrianglePool.js



class ExtendedTrianglePoolBase extends PrimitivePool {

	constructor() {

		super( () => new ExtendedTriangle() );

	}

}

const ExtendedTrianglePool = /* @__PURE__ */ new ExtendedTrianglePoolBase();

;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/core/utils/BufferStack.js
class _BufferStack {

	constructor() {

		this.float32Array = null;
		this.uint16Array = null;
		this.uint32Array = null;

		const stack = [];
		let prevBuffer = null;
		this.setBuffer = buffer => {

			if ( prevBuffer ) {

				stack.push( prevBuffer );

			}

			prevBuffer = buffer;
			this.float32Array = new Float32Array( buffer );
			this.uint16Array = new Uint16Array( buffer );
			this.uint32Array = new Uint32Array( buffer );

		};

		this.clearBuffer = () => {

			prevBuffer = null;
			this.float32Array = null;
			this.uint16Array = null;
			this.uint32Array = null;

			if ( stack.length !== 0 ) {

				this.setBuffer( stack.pop() );

			}

		};

	}

}

const BufferStack = new _BufferStack();

;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/core/cast/shapecast.js







let _box1, _box2;
const boxStack = [];
const boxPool = /* @__PURE__ */ new PrimitivePool( () => new three_module/* Box3 */.ZzF() );

function shapecast( bvh, root, intersectsBounds, intersectsRange, boundsTraverseOrder, byteOffset ) {

	// setup
	_box1 = boxPool.getPrimitive();
	_box2 = boxPool.getPrimitive();
	boxStack.push( _box1, _box2 );
	BufferStack.setBuffer( bvh._roots[ root ] );

	const result = shapecastTraverse( 0, bvh.geometry, intersectsBounds, intersectsRange, boundsTraverseOrder, byteOffset );

	// cleanup
	BufferStack.clearBuffer();
	boxPool.releasePrimitive( _box1 );
	boxPool.releasePrimitive( _box2 );
	boxStack.pop();
	boxStack.pop();

	const length = boxStack.length;
	if ( length > 0 ) {

		_box2 = boxStack[ length - 1 ];
		_box1 = boxStack[ length - 2 ];

	}

	return result;

}

function shapecastTraverse(
	nodeIndex32,
	geometry,
	intersectsBoundsFunc,
	intersectsRangeFunc,
	nodeScoreFunc = null,
	nodeIndexByteOffset = 0, // offset for unique node identifier
	depth = 0
) {

	const { float32Array, uint16Array, uint32Array } = BufferStack;
	let nodeIndex16 = nodeIndex32 * 2;

	const isLeaf = IS_LEAF( nodeIndex16, uint16Array );
	if ( isLeaf ) {

		const offset = OFFSET( nodeIndex32, uint32Array );
		const count = COUNT( nodeIndex16, uint16Array );
		arrayToBox( BOUNDING_DATA_INDEX( nodeIndex32 ), float32Array, _box1 );
		return intersectsRangeFunc( offset, count, false, depth, nodeIndexByteOffset + nodeIndex32, _box1 );

	} else {

		const left = LEFT_NODE( nodeIndex32 );
		const right = RIGHT_NODE( nodeIndex32, uint32Array );
		let c1 = left;
		let c2 = right;

		let score1, score2;
		let box1, box2;
		if ( nodeScoreFunc ) {

			box1 = _box1;
			box2 = _box2;

			// bounding data is not offset
			arrayToBox( BOUNDING_DATA_INDEX( c1 ), float32Array, box1 );
			arrayToBox( BOUNDING_DATA_INDEX( c2 ), float32Array, box2 );

			score1 = nodeScoreFunc( box1 );
			score2 = nodeScoreFunc( box2 );

			if ( score2 < score1 ) {

				c1 = right;
				c2 = left;

				const temp = score1;
				score1 = score2;
				score2 = temp;

				box1 = box2;
				// box2 is always set before use below

			}

		}

		// Check box 1 intersection
		if ( ! box1 ) {

			box1 = _box1;
			arrayToBox( BOUNDING_DATA_INDEX( c1 ), float32Array, box1 );

		}

		const isC1Leaf = IS_LEAF( c1 * 2, uint16Array );
		const c1Intersection = intersectsBoundsFunc( box1, isC1Leaf, score1, depth + 1, nodeIndexByteOffset + c1 );

		let c1StopTraversal;
		if ( c1Intersection === CONTAINED ) {

			const offset = getLeftOffset( c1 );
			const end = getRightEndOffset( c1 );
			const count = end - offset;

			c1StopTraversal = intersectsRangeFunc( offset, count, true, depth + 1, nodeIndexByteOffset + c1, box1 );

		} else {

			c1StopTraversal =
				c1Intersection &&
				shapecastTraverse(
					c1,
					geometry,
					intersectsBoundsFunc,
					intersectsRangeFunc,
					nodeScoreFunc,
					nodeIndexByteOffset,
					depth + 1
				);

		}

		if ( c1StopTraversal ) return true;

		// Check box 2 intersection
		// cached box2 will have been overwritten by previous traversal
		box2 = _box2;
		arrayToBox( BOUNDING_DATA_INDEX( c2 ), float32Array, box2 );

		const isC2Leaf = IS_LEAF( c2 * 2, uint16Array );
		const c2Intersection = intersectsBoundsFunc( box2, isC2Leaf, score2, depth + 1, nodeIndexByteOffset + c2 );

		let c2StopTraversal;
		if ( c2Intersection === CONTAINED ) {

			const offset = getLeftOffset( c2 );
			const end = getRightEndOffset( c2 );
			const count = end - offset;

			c2StopTraversal = intersectsRangeFunc( offset, count, true, depth + 1, nodeIndexByteOffset + c2, box2 );

		} else {

			c2StopTraversal =
				c2Intersection &&
				shapecastTraverse(
					c2,
					geometry,
					intersectsBoundsFunc,
					intersectsRangeFunc,
					nodeScoreFunc,
					nodeIndexByteOffset,
					depth + 1
				);

		}

		if ( c2StopTraversal ) return true;

		return false;

		// Define these inside the function so it has access to the local variables needed
		// when converting to the buffer equivalents
		function getLeftOffset( nodeIndex32 ) {

			const { uint16Array, uint32Array } = BufferStack;
			let nodeIndex16 = nodeIndex32 * 2;

			// traverse until we find a leaf
			while ( ! IS_LEAF( nodeIndex16, uint16Array ) ) {

				nodeIndex32 = LEFT_NODE( nodeIndex32 );
				nodeIndex16 = nodeIndex32 * 2;

			}

			return OFFSET( nodeIndex32, uint32Array );

		}

		function getRightEndOffset( nodeIndex32 ) {

			const { uint16Array, uint32Array } = BufferStack;
			let nodeIndex16 = nodeIndex32 * 2;

			// traverse until we find a leaf
			while ( ! IS_LEAF( nodeIndex16, uint16Array ) ) {

				// adjust offset to point to the right node
				nodeIndex32 = RIGHT_NODE( nodeIndex32, uint32Array );
				nodeIndex16 = nodeIndex32 * 2;

			}

			// return the end offset of the triangle range
			return OFFSET( nodeIndex32, uint32Array ) + COUNT( nodeIndex16, uint16Array );

		}

	}

}

;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/core/cast/closestPointToPoint.js


const temp = /* @__PURE__ */ new three_module/* Vector3 */.Pa4();
const temp1 = /* @__PURE__ */ new three_module/* Vector3 */.Pa4();

function closestPointToPoint(
	bvh,
	point,
	target = { },
	minThreshold = 0,
	maxThreshold = Infinity,
) {

	// early out if under minThreshold
	// skip checking if over maxThreshold
	// set minThreshold = maxThreshold to quickly check if a point is within a threshold
	// returns Infinity if no value found
	const minThresholdSq = minThreshold * minThreshold;
	const maxThresholdSq = maxThreshold * maxThreshold;
	let closestDistanceSq = Infinity;
	let closestDistanceTriIndex = null;
	bvh.shapecast(

		{

			boundsTraverseOrder: box => {

				temp.copy( point ).clamp( box.min, box.max );
				return temp.distanceToSquared( point );

			},

			intersectsBounds: ( box, isLeaf, score ) => {

				return score < closestDistanceSq && score < maxThresholdSq;

			},

			intersectsTriangle: ( tri, triIndex ) => {

				tri.closestPointToPoint( point, temp );
				const distSq = point.distanceToSquared( temp );
				if ( distSq < closestDistanceSq ) {

					temp1.copy( temp );
					closestDistanceSq = distSq;
					closestDistanceTriIndex = triIndex;

				}

				if ( distSq < minThresholdSq ) {

					return true;

				} else {

					return false;

				}

			},

		}

	);

	if ( closestDistanceSq === Infinity ) return null;

	const closestDistance = Math.sqrt( closestDistanceSq );

	if ( ! target.point ) target.point = temp1.clone();
	else target.point.copy( temp1 );
	target.distance = closestDistance,
	target.faceIndex = closestDistanceTriIndex;

	return target;

}

;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/utils/ThreeRayIntersectUtilities.js


// Ripped and modified From THREE.js Mesh raycast
// https://github.com/mrdoob/three.js/blob/0aa87c999fe61e216c1133fba7a95772b503eddf/src/objects/Mesh.js#L115
const _vA = /* @__PURE__ */ new three_module/* Vector3 */.Pa4();
const _vB = /* @__PURE__ */ new three_module/* Vector3 */.Pa4();
const _vC = /* @__PURE__ */ new three_module/* Vector3 */.Pa4();

const _uvA = /* @__PURE__ */ new three_module/* Vector2 */.FM8();
const _uvB = /* @__PURE__ */ new three_module/* Vector2 */.FM8();
const _uvC = /* @__PURE__ */ new three_module/* Vector2 */.FM8();

const _normalA = /* @__PURE__ */ new three_module/* Vector3 */.Pa4();
const _normalB = /* @__PURE__ */ new three_module/* Vector3 */.Pa4();
const _normalC = /* @__PURE__ */ new three_module/* Vector3 */.Pa4();

const _intersectionPoint = /* @__PURE__ */ new three_module/* Vector3 */.Pa4();
function checkIntersection( ray, pA, pB, pC, point, side ) {

	let intersect;
	if ( side === three_module/* BackSide */._Li ) {

		intersect = ray.intersectTriangle( pC, pB, pA, true, point );

	} else {

		intersect = ray.intersectTriangle( pA, pB, pC, side !== three_module/* DoubleSide */.ehD, point );

	}

	if ( intersect === null ) return null;

	const distance = ray.origin.distanceTo( point );

	return {

		distance: distance,
		point: point.clone(),

	};

}

function checkBufferGeometryIntersection( ray, position, normal, uv, uv1, a, b, c, side ) {

	_vA.fromBufferAttribute( position, a );
	_vB.fromBufferAttribute( position, b );
	_vC.fromBufferAttribute( position, c );

	const intersection = checkIntersection( ray, _vA, _vB, _vC, _intersectionPoint, side );

	if ( intersection ) {

		if ( uv ) {

			_uvA.fromBufferAttribute( uv, a );
			_uvB.fromBufferAttribute( uv, b );
			_uvC.fromBufferAttribute( uv, c );

			intersection.uv = three_module/* Triangle */.CJI.getInterpolation( _intersectionPoint, _vA, _vB, _vC, _uvA, _uvB, _uvC, new three_module/* Vector2 */.FM8() );

		}

		if ( uv1 ) {

			_uvA.fromBufferAttribute( uv1, a );
			_uvB.fromBufferAttribute( uv1, b );
			_uvC.fromBufferAttribute( uv1, c );

			intersection.uv1 = three_module/* Triangle */.CJI.getInterpolation( _intersectionPoint, _vA, _vB, _vC, _uvA, _uvB, _uvC, new three_module/* Vector2 */.FM8() );

		}

		if ( normal ) {

			_normalA.fromBufferAttribute( normal, a );
			_normalB.fromBufferAttribute( normal, b );
			_normalC.fromBufferAttribute( normal, c );

			intersection.normal = three_module/* Triangle */.CJI.getInterpolation( _intersectionPoint, _vA, _vB, _vC, _normalA, _normalB, _normalC, new three_module/* Vector3 */.Pa4() );
			if ( intersection.normal.dot( ray.direction ) > 0 ) {

				intersection.normal.multiplyScalar( - 1 );

			}

		}

		const face = {
			a: a,
			b: b,
			c: c,
			normal: new three_module/* Vector3 */.Pa4(),
			materialIndex: 0
		};

		three_module/* Triangle */.CJI.getNormal( _vA, _vB, _vC, face.normal );

		intersection.face = face;
		intersection.faceIndex = a;

	}

	return intersection;

}

// https://github.com/mrdoob/three.js/blob/0aa87c999fe61e216c1133fba7a95772b503eddf/src/objects/Mesh.js#L258
function intersectTri( geo, side, ray, tri, intersections ) {

	const triOffset = tri * 3;
	let a = triOffset + 0;
	let b = triOffset + 1;
	let c = triOffset + 2;

	const index = geo.index;
	if ( geo.index ) {

		a = index.getX( a );
		b = index.getX( b );
		c = index.getX( c );

	}

	const { position, normal, uv, uv1 } = geo.attributes;
	const intersection = checkBufferGeometryIntersection( ray, position, normal, uv, uv1, a, b, c, side );

	if ( intersection ) {

		intersection.faceIndex = tri;
		if ( intersections ) intersections.push( intersection );
		return intersection;

	}

	return null;

}



;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/utils/TriangleUtilities.js



// sets the vertices of triangle `tri` with the 3 vertices after i
function setTriangle( tri, i, index, pos ) {

	const ta = tri.a;
	const tb = tri.b;
	const tc = tri.c;

	let i0 = i;
	let i1 = i + 1;
	let i2 = i + 2;
	if ( index ) {

		i0 = index.getX( i0 );
		i1 = index.getX( i1 );
		i2 = index.getX( i2 );

	}

	ta.x = pos.getX( i0 );
	ta.y = pos.getY( i0 );
	ta.z = pos.getZ( i0 );

	tb.x = pos.getX( i1 );
	tb.y = pos.getY( i1 );
	tb.z = pos.getZ( i1 );

	tc.x = pos.getX( i2 );
	tc.y = pos.getY( i2 );
	tc.z = pos.getZ( i2 );

}

const tempV1 = /* @__PURE__ */ new three_module/* Vector3 */.Pa4();
const tempV2 = /* @__PURE__ */ new three_module/* Vector3 */.Pa4();
const tempV3 = /* @__PURE__ */ new three_module/* Vector3 */.Pa4();
const tempUV1 = /* @__PURE__ */ new three_module/* Vector2 */.FM8();
const tempUV2 = /* @__PURE__ */ new three_module/* Vector2 */.FM8();
const tempUV3 = /* @__PURE__ */ new three_module/* Vector2 */.FM8();

function getTriangleHitPointInfo( point, geometry, triangleIndex, target ) {

	const indices = geometry.getIndex().array;
	const positions = geometry.getAttribute( 'position' );
	const uvs = geometry.getAttribute( 'uv' );

	const a = indices[ triangleIndex * 3 ];
	const b = indices[ triangleIndex * 3 + 1 ];
	const c = indices[ triangleIndex * 3 + 2 ];

	tempV1.fromBufferAttribute( positions, a );
	tempV2.fromBufferAttribute( positions, b );
	tempV3.fromBufferAttribute( positions, c );

	// find the associated material index
	let materialIndex = 0;
	const groups = geometry.groups;
	const firstVertexIndex = triangleIndex * 3;
	for ( let i = 0, l = groups.length; i < l; i ++ ) {

		const group = groups[ i ];
		const { start, count } = group;
		if ( firstVertexIndex >= start && firstVertexIndex < start + count ) {

			materialIndex = group.materialIndex;
			break;

		}

	}

	// extract uvs
	let uv = null;
	if ( uvs ) {

		tempUV1.fromBufferAttribute( uvs, a );
		tempUV2.fromBufferAttribute( uvs, b );
		tempUV3.fromBufferAttribute( uvs, c );

		if ( target && target.uv ) uv = target.uv;
		else uv = new three_module/* Vector2 */.FM8();

		three_module/* Triangle */.CJI.getInterpolation( point, tempV1, tempV2, tempV3, tempUV1, tempUV2, tempUV3, uv );

	}

	// adjust the provided target or create a new one
	if ( target ) {

		if ( ! target.face ) target.face = { };
		target.face.a = a;
		target.face.b = b;
		target.face.c = c;
		target.face.materialIndex = materialIndex;
		if ( ! target.face.normal ) target.face.normal = new three_module/* Vector3 */.Pa4();
		three_module/* Triangle */.CJI.getNormal( tempV1, tempV2, tempV3, target.face.normal );

		if ( uv ) target.uv = uv;

		return target;

	} else {

		return {
			face: {
				a: a,
				b: b,
				c: c,
				materialIndex: materialIndex,
				normal: three_module/* Triangle */.CJI.getNormal( tempV1, tempV2, tempV3, new three_module/* Vector3 */.Pa4() )
			},
			uv: uv
		};

	}

}

;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/core/utils/iterationUtils.generated.js



/*************************************************************/
/* This file is generated from "iterationUtils.template.js". */
/*************************************************************/
/* eslint-disable indent */

function intersectTris( bvh, side, ray, offset, count, intersections ) {

	const { geometry, _indirectBuffer } = bvh;
	for ( let i = offset, end = offset + count; i < end; i ++ ) {


		intersectTri( geometry, side, ray, i, intersections );


	}

}

function intersectClosestTri( bvh, side, ray, offset, count ) {

	const { geometry, _indirectBuffer } = bvh;
	let dist = Infinity;
	let res = null;
	for ( let i = offset, end = offset + count; i < end; i ++ ) {

		let intersection;

		intersection = intersectTri( geometry, side, ray, i );


		if ( intersection && intersection.distance < dist ) {

			res = intersection;
			dist = intersection.distance;

		}

	}

	return res;

}

function iterateOverTriangles(
	offset,
	count,
	bvh,
	intersectsTriangleFunc,
	contained,
	depth,
	triangle
) {

	const { geometry } = bvh;
	const { index } = geometry;
	const pos = geometry.attributes.position;
	for ( let i = offset, l = count + offset; i < l; i ++ ) {

		let tri;

		tri = i;

		setTriangle( triangle, tri * 3, index, pos );
		triangle.needsUpdate = true;

		if ( intersectsTriangleFunc( triangle, tri, contained, depth ) ) {

			return true;

		}

	}

	return false;

}



;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/core/cast/refit.generated.js


/****************************************************/
/* This file is generated from "refit.template.js". */
/****************************************************/

function refit( bvh, nodeIndices = null ) {

	if ( nodeIndices && Array.isArray( nodeIndices ) ) {

		nodeIndices = new Set( nodeIndices );

	}

	const geometry = bvh.geometry;
	const indexArr = geometry.index ? geometry.index.array : null;
	const posAttr = geometry.attributes.position;

	let buffer, uint32Array, uint16Array, float32Array;
	let byteOffset = 0;
	const roots = bvh._roots;
	for ( let i = 0, l = roots.length; i < l; i ++ ) {

		buffer = roots[ i ];
		uint32Array = new Uint32Array( buffer );
		uint16Array = new Uint16Array( buffer );
		float32Array = new Float32Array( buffer );

		_traverse( 0, byteOffset );
		byteOffset += buffer.byteLength;

	}

	function _traverse( node32Index, byteOffset, force = false ) {

		const node16Index = node32Index * 2;
		const isLeaf = uint16Array[ node16Index + 15 ] === IS_LEAFNODE_FLAG;
		if ( isLeaf ) {

			const offset = uint32Array[ node32Index + 6 ];
			const count = uint16Array[ node16Index + 14 ];

			let minx = Infinity;
			let miny = Infinity;
			let minz = Infinity;
			let maxx = - Infinity;
			let maxy = - Infinity;
			let maxz = - Infinity;


			for ( let i = 3 * offset, l = 3 * ( offset + count ); i < l; i ++ ) {

				let index = indexArr[ i ];
				const x = posAttr.getX( index );
				const y = posAttr.getY( index );
				const z = posAttr.getZ( index );

				if ( x < minx ) minx = x;
				if ( x > maxx ) maxx = x;

				if ( y < miny ) miny = y;
				if ( y > maxy ) maxy = y;

				if ( z < minz ) minz = z;
				if ( z > maxz ) maxz = z;

			}


			if (
				float32Array[ node32Index + 0 ] !== minx ||
				float32Array[ node32Index + 1 ] !== miny ||
				float32Array[ node32Index + 2 ] !== minz ||

				float32Array[ node32Index + 3 ] !== maxx ||
				float32Array[ node32Index + 4 ] !== maxy ||
				float32Array[ node32Index + 5 ] !== maxz
			) {

				float32Array[ node32Index + 0 ] = minx;
				float32Array[ node32Index + 1 ] = miny;
				float32Array[ node32Index + 2 ] = minz;

				float32Array[ node32Index + 3 ] = maxx;
				float32Array[ node32Index + 4 ] = maxy;
				float32Array[ node32Index + 5 ] = maxz;

				return true;

			} else {

				return false;

			}

		} else {

			const left = node32Index + 8;
			const right = uint32Array[ node32Index + 6 ];

			// the identifying node indices provided by the shapecast function include offsets of all
			// root buffers to guarantee they're unique between roots so offset left and right indices here.
			const offsetLeft = left + byteOffset;
			const offsetRight = right + byteOffset;
			let forceChildren = force;
			let includesLeft = false;
			let includesRight = false;

			if ( nodeIndices ) {

				// if we see that neither the left or right child are included in the set that need to be updated
				// then we assume that all children need to be updated.
				if ( ! forceChildren ) {

					includesLeft = nodeIndices.has( offsetLeft );
					includesRight = nodeIndices.has( offsetRight );
					forceChildren = ! includesLeft && ! includesRight;

				}

			} else {

				includesLeft = true;
				includesRight = true;

			}

			const traverseLeft = forceChildren || includesLeft;
			const traverseRight = forceChildren || includesRight;

			let leftChange = false;
			if ( traverseLeft ) {

				leftChange = _traverse( left, byteOffset, forceChildren );

			}

			let rightChange = false;
			if ( traverseRight ) {

				rightChange = _traverse( right, byteOffset, forceChildren );

			}

			const didChange = leftChange || rightChange;
			if ( didChange ) {

				for ( let i = 0; i < 3; i ++ ) {

					const lefti = left + i;
					const righti = right + i;
					const minLeftValue = float32Array[ lefti ];
					const maxLeftValue = float32Array[ lefti + 3 ];
					const minRightValue = float32Array[ righti ];
					const maxRightValue = float32Array[ righti + 3 ];

					float32Array[ node32Index + i ] = minLeftValue < minRightValue ? minLeftValue : minRightValue;
					float32Array[ node32Index + i + 3 ] = maxLeftValue > maxRightValue ? maxLeftValue : maxRightValue;

				}

			}

			return didChange;

		}

	}

}



;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/core/utils/intersectUtils.js



const _boundingBox = /* @__PURE__ */ new three_module/* Box3 */.ZzF();
function intersectRay( nodeIndex32, array, ray, target ) {

	arrayToBox( nodeIndex32, array, _boundingBox );
	return ray.intersectBox( _boundingBox, target );

}

;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/core/cast/raycast.generated.js







/******************************************************/
/* This file is generated from "raycast.template.js". */
/******************************************************/

const _boxIntersection = /* @__PURE__ */ new three_module/* Vector3 */.Pa4();
function raycast( bvh, root, side, ray, intersects ) {

	BufferStack.setBuffer( bvh._roots[ root ] );
	_raycast( 0, bvh, side, ray, intersects );
	BufferStack.clearBuffer();

}

function _raycast( nodeIndex32, bvh, side, ray, intersects ) {

	const { float32Array, uint16Array, uint32Array } = BufferStack;
	const nodeIndex16 = nodeIndex32 * 2;
	const isLeaf = IS_LEAF( nodeIndex16, uint16Array );
	if ( isLeaf ) {

		const offset = OFFSET( nodeIndex32, uint32Array );
		const count = COUNT( nodeIndex16, uint16Array );


		intersectTris( bvh, side, ray, offset, count, intersects );


	} else {

		const leftIndex = LEFT_NODE( nodeIndex32 );
		if ( intersectRay( leftIndex, float32Array, ray, _boxIntersection ) ) {

			_raycast( leftIndex, bvh, side, ray, intersects );

		}

		const rightIndex = RIGHT_NODE( nodeIndex32, uint32Array );
		if ( intersectRay( rightIndex, float32Array, ray, _boxIntersection ) ) {

			_raycast( rightIndex, bvh, side, ray, intersects );

		}

	}

}



;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/core/cast/raycastFirst.generated.js







/***********************************************************/
/* This file is generated from "raycastFirst.template.js". */
/***********************************************************/
const raycastFirst_generated_boxIntersection = /* @__PURE__ */ new three_module/* Vector3 */.Pa4();
const _xyzFields = [ 'x', 'y', 'z' ];
function raycastFirst( bvh, root, side, ray ) {

	BufferStack.setBuffer( bvh._roots[ root ] );
	const result = _raycastFirst( 0, bvh, side, ray );
	BufferStack.clearBuffer();

	return result;

}

function _raycastFirst( nodeIndex32, bvh, side, ray ) {

	const { float32Array, uint16Array, uint32Array } = BufferStack;
	let nodeIndex16 = nodeIndex32 * 2;

	const isLeaf = IS_LEAF( nodeIndex16, uint16Array );
	if ( isLeaf ) {

		const offset = OFFSET( nodeIndex32, uint32Array );
		const count = COUNT( nodeIndex16, uint16Array );


		return intersectClosestTri( bvh, side, ray, offset, count );


	} else {

		// consider the position of the split plane with respect to the oncoming ray; whichever direction
		// the ray is coming from, look for an intersection among that side of the tree first
		const splitAxis = SPLIT_AXIS( nodeIndex32, uint32Array );
		const xyzAxis = _xyzFields[ splitAxis ];
		const rayDir = ray.direction[ xyzAxis ];
		const leftToRight = rayDir >= 0;

		// c1 is the child to check first
		let c1, c2;
		if ( leftToRight ) {

			c1 = LEFT_NODE( nodeIndex32 );
			c2 = RIGHT_NODE( nodeIndex32, uint32Array );

		} else {

			c1 = RIGHT_NODE( nodeIndex32, uint32Array );
			c2 = LEFT_NODE( nodeIndex32 );

		}

		const c1Intersection = intersectRay( c1, float32Array, ray, raycastFirst_generated_boxIntersection );
		const c1Result = c1Intersection ? _raycastFirst( c1, bvh, side, ray ) : null;

		// if we got an intersection in the first node and it's closer than the second node's bounding
		// box, we don't need to consider the second node because it couldn't possibly be a better result
		if ( c1Result ) {

			// check if the point is within the second bounds
			// "point" is in the local frame of the bvh
			const point = c1Result.point[ xyzAxis ];
			const isOutside = leftToRight ?
				point <= float32Array[ c2 + splitAxis ] : // min bounding data
				point >= float32Array[ c2 + splitAxis + 3 ]; // max bounding data

			if ( isOutside ) {

				return c1Result;

			}

		}

		// either there was no intersection in the first node, or there could still be a closer
		// intersection in the second, so check the second node and then take the better of the two
		const c2Intersection = intersectRay( c2, float32Array, ray, raycastFirst_generated_boxIntersection );
		const c2Result = c2Intersection ? _raycastFirst( c2, bvh, side, ray ) : null;

		if ( c1Result && c2Result ) {

			return c1Result.distance <= c2Result.distance ? c1Result : c2Result;

		} else {

			return c1Result || c2Result || null;

		}

	}

}



;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/core/cast/intersectsGeometry.generated.js








/*****************************************************************/
/* This file is generated from "intersectsGeometry.template.js". */
/*****************************************************************/
/* eslint-disable indent */

const boundingBox = /* @__PURE__ */ new three_module/* Box3 */.ZzF();
const triangle = /* @__PURE__ */ new ExtendedTriangle();
const triangle2 = /* @__PURE__ */ new ExtendedTriangle();
const invertedMat = /* @__PURE__ */ new three_module/* Matrix4 */.yGw();

const obb = /* @__PURE__ */ new OrientedBox();
const obb2 = /* @__PURE__ */ new OrientedBox();

function intersectsGeometry( bvh, root, otherGeometry, geometryToBvh ) {

	BufferStack.setBuffer( bvh._roots[ root ] );
	const result = _intersectsGeometry( 0, bvh, otherGeometry, geometryToBvh );
	BufferStack.clearBuffer();

	return result;

}

function _intersectsGeometry( nodeIndex32, bvh, otherGeometry, geometryToBvh, cachedObb = null ) {

	const { float32Array, uint16Array, uint32Array } = BufferStack;
	let nodeIndex16 = nodeIndex32 * 2;

	if ( cachedObb === null ) {

		if ( ! otherGeometry.boundingBox ) {

			otherGeometry.computeBoundingBox();

		}

		obb.set( otherGeometry.boundingBox.min, otherGeometry.boundingBox.max, geometryToBvh );
		cachedObb = obb;

	}

	const isLeaf = IS_LEAF( nodeIndex16, uint16Array );
	if ( isLeaf ) {

		const thisGeometry = bvh.geometry;
		const thisIndex = thisGeometry.index;
		const thisPos = thisGeometry.attributes.position;

		const index = otherGeometry.index;
		const pos = otherGeometry.attributes.position;

		const offset = OFFSET( nodeIndex32, uint32Array );
		const count = COUNT( nodeIndex16, uint16Array );

		// get the inverse of the geometry matrix so we can transform our triangles into the
		// geometry space we're trying to test. We assume there are fewer triangles being checked
		// here.
		invertedMat.copy( geometryToBvh ).invert();

		if ( otherGeometry.boundsTree ) {

			// if there's a bounds tree
			arrayToBox( BOUNDING_DATA_INDEX( nodeIndex32 ), float32Array, obb2 );
			obb2.matrix.copy( invertedMat );
			obb2.needsUpdate = true;

			// TODO: use a triangle iteration function here
			const res = otherGeometry.boundsTree.shapecast( {

				intersectsBounds: box => obb2.intersectsBox( box ),

				intersectsTriangle: tri => {

					tri.a.applyMatrix4( geometryToBvh );
					tri.b.applyMatrix4( geometryToBvh );
					tri.c.applyMatrix4( geometryToBvh );
					tri.needsUpdate = true;


					for ( let i = offset * 3, l = ( count + offset ) * 3; i < l; i += 3 ) {

						// this triangle needs to be transformed into the current BVH coordinate frame
						setTriangle( triangle2, i, thisIndex, thisPos );
						triangle2.needsUpdate = true;
						if ( tri.intersectsTriangle( triangle2 ) ) {

							return true;

						}

					}


					return false;

				}

			} );

			return res;

		} else {

			// if we're just dealing with raw geometry

			for ( let i = offset * 3, l = ( count + offset ) * 3; i < l; i += 3 ) {

				// this triangle needs to be transformed into the current BVH coordinate frame
				setTriangle( triangle, i, thisIndex, thisPos );


				triangle.a.applyMatrix4( invertedMat );
				triangle.b.applyMatrix4( invertedMat );
				triangle.c.applyMatrix4( invertedMat );
				triangle.needsUpdate = true;

				for ( let i2 = 0, l2 = index.count; i2 < l2; i2 += 3 ) {

					setTriangle( triangle2, i2, index, pos );
					triangle2.needsUpdate = true;

					if ( triangle.intersectsTriangle( triangle2 ) ) {

						return true;

					}

				}


			}


		}

	} else {

		const left = nodeIndex32 + 8;
		const right = uint32Array[ nodeIndex32 + 6 ];

		arrayToBox( BOUNDING_DATA_INDEX( left ), float32Array, boundingBox );
		const leftIntersection =
			cachedObb.intersectsBox( boundingBox ) &&
			_intersectsGeometry( left, bvh, otherGeometry, geometryToBvh, cachedObb );

		if ( leftIntersection ) return true;

		arrayToBox( BOUNDING_DATA_INDEX( right ), float32Array, boundingBox );
		const rightIntersection =
			cachedObb.intersectsBox( boundingBox ) &&
			_intersectsGeometry( right, bvh, otherGeometry, geometryToBvh, cachedObb );

		if ( rightIntersection ) return true;

		return false;

	}

}



;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/core/cast/closestPointToGeometry.generated.js






/*********************************************************************/
/* This file is generated from "closestPointToGeometry.template.js". */
/*********************************************************************/

const tempMatrix = /* @__PURE__ */ new three_module/* Matrix4 */.yGw();
const closestPointToGeometry_generated_obb = /* @__PURE__ */ new OrientedBox();
const closestPointToGeometry_generated_obb2 = /* @__PURE__ */ new OrientedBox();
const closestPointToGeometry_generated_temp1 = /* @__PURE__ */ new three_module/* Vector3 */.Pa4();
const temp2 = /* @__PURE__ */ new three_module/* Vector3 */.Pa4();
const temp3 = /* @__PURE__ */ new three_module/* Vector3 */.Pa4();
const temp4 = /* @__PURE__ */ new three_module/* Vector3 */.Pa4();

function closestPointToGeometry(
	bvh,
	otherGeometry,
	geometryToBvh,
	target1 = { },
	target2 = { },
	minThreshold = 0,
	maxThreshold = Infinity,
) {

	if ( ! otherGeometry.boundingBox ) {

		otherGeometry.computeBoundingBox();

	}

	closestPointToGeometry_generated_obb.set( otherGeometry.boundingBox.min, otherGeometry.boundingBox.max, geometryToBvh );
	closestPointToGeometry_generated_obb.needsUpdate = true;

	const geometry = bvh.geometry;
	const pos = geometry.attributes.position;
	const index = geometry.index;
	const otherPos = otherGeometry.attributes.position;
	const otherIndex = otherGeometry.index;
	const triangle = ExtendedTrianglePool.getPrimitive();
	const triangle2 = ExtendedTrianglePool.getPrimitive();

	let tempTarget1 = closestPointToGeometry_generated_temp1;
	let tempTargetDest1 = temp2;
	let tempTarget2 = null;
	let tempTargetDest2 = null;

	if ( target2 ) {

		tempTarget2 = temp3;
		tempTargetDest2 = temp4;

	}

	let closestDistance = Infinity;
	let closestDistanceTriIndex = null;
	let closestDistanceOtherTriIndex = null;
	tempMatrix.copy( geometryToBvh ).invert();
	closestPointToGeometry_generated_obb2.matrix.copy( tempMatrix );
	bvh.shapecast(
		{

			boundsTraverseOrder: box => {

				return closestPointToGeometry_generated_obb.distanceToBox( box );

			},

			intersectsBounds: ( box, isLeaf, score ) => {

				if ( score < closestDistance && score < maxThreshold ) {

					// if we know the triangles of this bounds will be intersected next then
					// save the bounds to use during triangle checks.
					if ( isLeaf ) {

						closestPointToGeometry_generated_obb2.min.copy( box.min );
						closestPointToGeometry_generated_obb2.max.copy( box.max );
						closestPointToGeometry_generated_obb2.needsUpdate = true;

					}

					return true;

				}

				return false;

			},

			intersectsRange: ( offset, count ) => {

				if ( otherGeometry.boundsTree ) {

					// if the other geometry has a bvh then use the accelerated path where we use shapecast to find
					// the closest bounds in the other geometry to check.
					const otherBvh = otherGeometry.boundsTree;
					return otherBvh.shapecast( {
						boundsTraverseOrder: box => {

							return closestPointToGeometry_generated_obb2.distanceToBox( box );

						},

						intersectsBounds: ( box, isLeaf, score ) => {

							return score < closestDistance && score < maxThreshold;

						},

						intersectsRange: ( otherOffset, otherCount ) => {

							for ( let i2 = otherOffset, l2 = otherOffset + otherCount; i2 < l2; i2 ++ ) {


								setTriangle( triangle2, 3 * i2, otherIndex, otherPos );

								triangle2.a.applyMatrix4( geometryToBvh );
								triangle2.b.applyMatrix4( geometryToBvh );
								triangle2.c.applyMatrix4( geometryToBvh );
								triangle2.needsUpdate = true;

								for ( let i = offset, l = offset + count; i < l; i ++ ) {


									setTriangle( triangle, 3 * i, index, pos );

									triangle.needsUpdate = true;

									const dist = triangle.distanceToTriangle( triangle2, tempTarget1, tempTarget2 );
									if ( dist < closestDistance ) {

										tempTargetDest1.copy( tempTarget1 );

										if ( tempTargetDest2 ) {

											tempTargetDest2.copy( tempTarget2 );

										}

										closestDistance = dist;
										closestDistanceTriIndex = i;
										closestDistanceOtherTriIndex = i2;

									}

									// stop traversal if we find a point that's under the given threshold
									if ( dist < minThreshold ) {

										return true;

									}

								}

							}

						},
					} );

				} else {

					// If no bounds tree then we'll just check every triangle.
					const triCount = getTriCount( otherGeometry );
					for ( let i2 = 0, l2 = triCount; i2 < l2; i2 ++ ) {

						setTriangle( triangle2, 3 * i2, otherIndex, otherPos );
						triangle2.a.applyMatrix4( geometryToBvh );
						triangle2.b.applyMatrix4( geometryToBvh );
						triangle2.c.applyMatrix4( geometryToBvh );
						triangle2.needsUpdate = true;

						for ( let i = offset, l = offset + count; i < l; i ++ ) {


							setTriangle( triangle, 3 * i, index, pos );

							triangle.needsUpdate = true;

							const dist = triangle.distanceToTriangle( triangle2, tempTarget1, tempTarget2 );
							if ( dist < closestDistance ) {

								tempTargetDest1.copy( tempTarget1 );

								if ( tempTargetDest2 ) {

									tempTargetDest2.copy( tempTarget2 );

								}

								closestDistance = dist;
								closestDistanceTriIndex = i;
								closestDistanceOtherTriIndex = i2;

							}

							// stop traversal if we find a point that's under the given threshold
							if ( dist < minThreshold ) {

								return true;

							}

						}

					}

				}

			},

		}

	);

	ExtendedTrianglePool.releasePrimitive( triangle );
	ExtendedTrianglePool.releasePrimitive( triangle2 );

	if ( closestDistance === Infinity ) {

		return null;

	}

	if ( ! target1.point ) {

		target1.point = tempTargetDest1.clone();

	} else {

		target1.point.copy( tempTargetDest1 );

	}

	target1.distance = closestDistance,
	target1.faceIndex = closestDistanceTriIndex;

	if ( target2 ) {

		if ( ! target2.point ) target2.point = tempTargetDest2.clone();
		else target2.point.copy( tempTargetDest2 );
		target2.point.applyMatrix4( tempMatrix );
		tempTargetDest1.applyMatrix4( tempMatrix );
		target2.distance = tempTargetDest1.sub( target2.point ).length();
		target2.faceIndex = closestDistanceOtherTriIndex;

	}

	return target1;

}



;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/core/utils/iterationUtils_indirect.generated.js



/*************************************************************/
/* This file is generated from "iterationUtils.template.js". */
/*************************************************************/
/* eslint-disable indent */

function intersectTris_indirect( bvh, side, ray, offset, count, intersections ) {

	const { geometry, _indirectBuffer } = bvh;
	for ( let i = offset, end = offset + count; i < end; i ++ ) {

		let vi = _indirectBuffer ? _indirectBuffer[ i ] : i;
		intersectTri( geometry, side, ray, vi, intersections );


	}

}

function intersectClosestTri_indirect( bvh, side, ray, offset, count ) {

	const { geometry, _indirectBuffer } = bvh;
	let dist = Infinity;
	let res = null;
	for ( let i = offset, end = offset + count; i < end; i ++ ) {

		let intersection;
		intersection = intersectTri( geometry, side, ray, _indirectBuffer ? _indirectBuffer[ i ] : i );


		if ( intersection && intersection.distance < dist ) {

			res = intersection;
			dist = intersection.distance;

		}

	}

	return res;

}

function iterateOverTriangles_indirect(
	offset,
	count,
	bvh,
	intersectsTriangleFunc,
	contained,
	depth,
	triangle
) {

	const { geometry } = bvh;
	const { index } = geometry;
	const pos = geometry.attributes.position;
	for ( let i = offset, l = count + offset; i < l; i ++ ) {

		let tri;
		tri = bvh.resolveTriangleIndex( i );

		setTriangle( triangle, tri * 3, index, pos );
		triangle.needsUpdate = true;

		if ( intersectsTriangleFunc( triangle, tri, contained, depth ) ) {

			return true;

		}

	}

	return false;

}



;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/core/cast/refit_indirect.generated.js


/****************************************************/
/* This file is generated from "refit.template.js". */
/****************************************************/

function refit_indirect( bvh, nodeIndices = null ) {

	if ( nodeIndices && Array.isArray( nodeIndices ) ) {

		nodeIndices = new Set( nodeIndices );

	}

	const geometry = bvh.geometry;
	const indexArr = geometry.index ? geometry.index.array : null;
	const posAttr = geometry.attributes.position;

	let buffer, uint32Array, uint16Array, float32Array;
	let byteOffset = 0;
	const roots = bvh._roots;
	for ( let i = 0, l = roots.length; i < l; i ++ ) {

		buffer = roots[ i ];
		uint32Array = new Uint32Array( buffer );
		uint16Array = new Uint16Array( buffer );
		float32Array = new Float32Array( buffer );

		_traverse( 0, byteOffset );
		byteOffset += buffer.byteLength;

	}

	function _traverse( node32Index, byteOffset, force = false ) {

		const node16Index = node32Index * 2;
		const isLeaf = uint16Array[ node16Index + 15 ] === IS_LEAFNODE_FLAG;
		if ( isLeaf ) {

			const offset = uint32Array[ node32Index + 6 ];
			const count = uint16Array[ node16Index + 14 ];

			let minx = Infinity;
			let miny = Infinity;
			let minz = Infinity;
			let maxx = - Infinity;
			let maxy = - Infinity;
			let maxz = - Infinity;

			for ( let i = offset, l = offset + count; i < l; i ++ ) {

				const t = 3 * bvh.resolveTriangleIndex( i );
				for ( let j = 0; j < 3; j ++ ) {

					let index = t + j;
					index = indexArr ? indexArr[ index ] : index;

					const x = posAttr.getX( index );
					const y = posAttr.getY( index );
					const z = posAttr.getZ( index );

					if ( x < minx ) minx = x;
					if ( x > maxx ) maxx = x;

					if ( y < miny ) miny = y;
					if ( y > maxy ) maxy = y;

					if ( z < minz ) minz = z;
					if ( z > maxz ) maxz = z;


				}

			}


			if (
				float32Array[ node32Index + 0 ] !== minx ||
				float32Array[ node32Index + 1 ] !== miny ||
				float32Array[ node32Index + 2 ] !== minz ||

				float32Array[ node32Index + 3 ] !== maxx ||
				float32Array[ node32Index + 4 ] !== maxy ||
				float32Array[ node32Index + 5 ] !== maxz
			) {

				float32Array[ node32Index + 0 ] = minx;
				float32Array[ node32Index + 1 ] = miny;
				float32Array[ node32Index + 2 ] = minz;

				float32Array[ node32Index + 3 ] = maxx;
				float32Array[ node32Index + 4 ] = maxy;
				float32Array[ node32Index + 5 ] = maxz;

				return true;

			} else {

				return false;

			}

		} else {

			const left = node32Index + 8;
			const right = uint32Array[ node32Index + 6 ];

			// the identifying node indices provided by the shapecast function include offsets of all
			// root buffers to guarantee they're unique between roots so offset left and right indices here.
			const offsetLeft = left + byteOffset;
			const offsetRight = right + byteOffset;
			let forceChildren = force;
			let includesLeft = false;
			let includesRight = false;

			if ( nodeIndices ) {

				// if we see that neither the left or right child are included in the set that need to be updated
				// then we assume that all children need to be updated.
				if ( ! forceChildren ) {

					includesLeft = nodeIndices.has( offsetLeft );
					includesRight = nodeIndices.has( offsetRight );
					forceChildren = ! includesLeft && ! includesRight;

				}

			} else {

				includesLeft = true;
				includesRight = true;

			}

			const traverseLeft = forceChildren || includesLeft;
			const traverseRight = forceChildren || includesRight;

			let leftChange = false;
			if ( traverseLeft ) {

				leftChange = _traverse( left, byteOffset, forceChildren );

			}

			let rightChange = false;
			if ( traverseRight ) {

				rightChange = _traverse( right, byteOffset, forceChildren );

			}

			const didChange = leftChange || rightChange;
			if ( didChange ) {

				for ( let i = 0; i < 3; i ++ ) {

					const lefti = left + i;
					const righti = right + i;
					const minLeftValue = float32Array[ lefti ];
					const maxLeftValue = float32Array[ lefti + 3 ];
					const minRightValue = float32Array[ righti ];
					const maxRightValue = float32Array[ righti + 3 ];

					float32Array[ node32Index + i ] = minLeftValue < minRightValue ? minLeftValue : minRightValue;
					float32Array[ node32Index + i + 3 ] = maxLeftValue > maxRightValue ? maxLeftValue : maxRightValue;

				}

			}

			return didChange;

		}

	}

}



;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/core/cast/raycast_indirect.generated.js







/******************************************************/
/* This file is generated from "raycast.template.js". */
/******************************************************/

const raycast_indirect_generated_boxIntersection = /* @__PURE__ */ new three_module/* Vector3 */.Pa4();
function raycast_indirect( bvh, root, side, ray, intersects ) {

	BufferStack.setBuffer( bvh._roots[ root ] );
	raycast_indirect_generated_raycast( 0, bvh, side, ray, intersects );
	BufferStack.clearBuffer();

}

function raycast_indirect_generated_raycast( nodeIndex32, bvh, side, ray, intersects ) {

	const { float32Array, uint16Array, uint32Array } = BufferStack;
	const nodeIndex16 = nodeIndex32 * 2;
	const isLeaf = IS_LEAF( nodeIndex16, uint16Array );
	if ( isLeaf ) {

		const offset = OFFSET( nodeIndex32, uint32Array );
		const count = COUNT( nodeIndex16, uint16Array );

		intersectTris_indirect( bvh, side, ray, offset, count, intersects );


	} else {

		const leftIndex = LEFT_NODE( nodeIndex32 );
		if ( intersectRay( leftIndex, float32Array, ray, raycast_indirect_generated_boxIntersection ) ) {

			raycast_indirect_generated_raycast( leftIndex, bvh, side, ray, intersects );

		}

		const rightIndex = RIGHT_NODE( nodeIndex32, uint32Array );
		if ( intersectRay( rightIndex, float32Array, ray, raycast_indirect_generated_boxIntersection ) ) {

			raycast_indirect_generated_raycast( rightIndex, bvh, side, ray, intersects );

		}

	}

}



;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/core/cast/raycastFirst_indirect.generated.js







/***********************************************************/
/* This file is generated from "raycastFirst.template.js". */
/***********************************************************/
const raycastFirst_indirect_generated_boxIntersection = /* @__PURE__ */ new three_module/* Vector3 */.Pa4();
const raycastFirst_indirect_generated_xyzFields = [ 'x', 'y', 'z' ];
function raycastFirst_indirect( bvh, root, side, ray ) {

	BufferStack.setBuffer( bvh._roots[ root ] );
	const result = raycastFirst_indirect_generated_raycastFirst( 0, bvh, side, ray );
	BufferStack.clearBuffer();

	return result;

}

function raycastFirst_indirect_generated_raycastFirst( nodeIndex32, bvh, side, ray ) {

	const { float32Array, uint16Array, uint32Array } = BufferStack;
	let nodeIndex16 = nodeIndex32 * 2;

	const isLeaf = IS_LEAF( nodeIndex16, uint16Array );
	if ( isLeaf ) {

		const offset = OFFSET( nodeIndex32, uint32Array );
		const count = COUNT( nodeIndex16, uint16Array );

		return intersectClosestTri_indirect( bvh, side, ray, offset, count );


	} else {

		// consider the position of the split plane with respect to the oncoming ray; whichever direction
		// the ray is coming from, look for an intersection among that side of the tree first
		const splitAxis = SPLIT_AXIS( nodeIndex32, uint32Array );
		const xyzAxis = raycastFirst_indirect_generated_xyzFields[ splitAxis ];
		const rayDir = ray.direction[ xyzAxis ];
		const leftToRight = rayDir >= 0;

		// c1 is the child to check first
		let c1, c2;
		if ( leftToRight ) {

			c1 = LEFT_NODE( nodeIndex32 );
			c2 = RIGHT_NODE( nodeIndex32, uint32Array );

		} else {

			c1 = RIGHT_NODE( nodeIndex32, uint32Array );
			c2 = LEFT_NODE( nodeIndex32 );

		}

		const c1Intersection = intersectRay( c1, float32Array, ray, raycastFirst_indirect_generated_boxIntersection );
		const c1Result = c1Intersection ? raycastFirst_indirect_generated_raycastFirst( c1, bvh, side, ray ) : null;

		// if we got an intersection in the first node and it's closer than the second node's bounding
		// box, we don't need to consider the second node because it couldn't possibly be a better result
		if ( c1Result ) {

			// check if the point is within the second bounds
			// "point" is in the local frame of the bvh
			const point = c1Result.point[ xyzAxis ];
			const isOutside = leftToRight ?
				point <= float32Array[ c2 + splitAxis ] : // min bounding data
				point >= float32Array[ c2 + splitAxis + 3 ]; // max bounding data

			if ( isOutside ) {

				return c1Result;

			}

		}

		// either there was no intersection in the first node, or there could still be a closer
		// intersection in the second, so check the second node and then take the better of the two
		const c2Intersection = intersectRay( c2, float32Array, ray, raycastFirst_indirect_generated_boxIntersection );
		const c2Result = c2Intersection ? raycastFirst_indirect_generated_raycastFirst( c2, bvh, side, ray ) : null;

		if ( c1Result && c2Result ) {

			return c1Result.distance <= c2Result.distance ? c1Result : c2Result;

		} else {

			return c1Result || c2Result || null;

		}

	}

}



;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/core/cast/intersectsGeometry_indirect.generated.js








/*****************************************************************/
/* This file is generated from "intersectsGeometry.template.js". */
/*****************************************************************/
/* eslint-disable indent */

const intersectsGeometry_indirect_generated_boundingBox = /* @__PURE__ */ new three_module/* Box3 */.ZzF();
const intersectsGeometry_indirect_generated_triangle = /* @__PURE__ */ new ExtendedTriangle();
const intersectsGeometry_indirect_generated_triangle2 = /* @__PURE__ */ new ExtendedTriangle();
const intersectsGeometry_indirect_generated_invertedMat = /* @__PURE__ */ new three_module/* Matrix4 */.yGw();

const intersectsGeometry_indirect_generated_obb = /* @__PURE__ */ new OrientedBox();
const intersectsGeometry_indirect_generated_obb2 = /* @__PURE__ */ new OrientedBox();

function intersectsGeometry_indirect( bvh, root, otherGeometry, geometryToBvh ) {

	BufferStack.setBuffer( bvh._roots[ root ] );
	const result = intersectsGeometry_indirect_generated_intersectsGeometry( 0, bvh, otherGeometry, geometryToBvh );
	BufferStack.clearBuffer();

	return result;

}

function intersectsGeometry_indirect_generated_intersectsGeometry( nodeIndex32, bvh, otherGeometry, geometryToBvh, cachedObb = null ) {

	const { float32Array, uint16Array, uint32Array } = BufferStack;
	let nodeIndex16 = nodeIndex32 * 2;

	if ( cachedObb === null ) {

		if ( ! otherGeometry.boundingBox ) {

			otherGeometry.computeBoundingBox();

		}

		intersectsGeometry_indirect_generated_obb.set( otherGeometry.boundingBox.min, otherGeometry.boundingBox.max, geometryToBvh );
		cachedObb = intersectsGeometry_indirect_generated_obb;

	}

	const isLeaf = IS_LEAF( nodeIndex16, uint16Array );
	if ( isLeaf ) {

		const thisGeometry = bvh.geometry;
		const thisIndex = thisGeometry.index;
		const thisPos = thisGeometry.attributes.position;

		const index = otherGeometry.index;
		const pos = otherGeometry.attributes.position;

		const offset = OFFSET( nodeIndex32, uint32Array );
		const count = COUNT( nodeIndex16, uint16Array );

		// get the inverse of the geometry matrix so we can transform our triangles into the
		// geometry space we're trying to test. We assume there are fewer triangles being checked
		// here.
		intersectsGeometry_indirect_generated_invertedMat.copy( geometryToBvh ).invert();

		if ( otherGeometry.boundsTree ) {

			// if there's a bounds tree
			arrayToBox( BOUNDING_DATA_INDEX( nodeIndex32 ), float32Array, intersectsGeometry_indirect_generated_obb2 );
			intersectsGeometry_indirect_generated_obb2.matrix.copy( intersectsGeometry_indirect_generated_invertedMat );
			intersectsGeometry_indirect_generated_obb2.needsUpdate = true;

			// TODO: use a triangle iteration function here
			const res = otherGeometry.boundsTree.shapecast( {

				intersectsBounds: box => intersectsGeometry_indirect_generated_obb2.intersectsBox( box ),

				intersectsTriangle: tri => {

					tri.a.applyMatrix4( geometryToBvh );
					tri.b.applyMatrix4( geometryToBvh );
					tri.c.applyMatrix4( geometryToBvh );
					tri.needsUpdate = true;

					for ( let i = offset, l = count + offset; i < l; i ++ ) {

						// this triangle needs to be transformed into the current BVH coordinate frame
						setTriangle( intersectsGeometry_indirect_generated_triangle2, 3 * bvh.resolveTriangleIndex( i ), thisIndex, thisPos );
						intersectsGeometry_indirect_generated_triangle2.needsUpdate = true;
						if ( tri.intersectsTriangle( intersectsGeometry_indirect_generated_triangle2 ) ) {

							return true;

						}

					}


					return false;

				}

			} );

			return res;

		} else {

			// if we're just dealing with raw geometry
			for ( let i = offset, l = count + offset; i < l; i ++ ) {

				// this triangle needs to be transformed into the current BVH coordinate frame
				const ti = bvh.resolveTriangleIndex( i );
				setTriangle( intersectsGeometry_indirect_generated_triangle, 3 * ti, thisIndex, thisPos );


				intersectsGeometry_indirect_generated_triangle.a.applyMatrix4( intersectsGeometry_indirect_generated_invertedMat );
				intersectsGeometry_indirect_generated_triangle.b.applyMatrix4( intersectsGeometry_indirect_generated_invertedMat );
				intersectsGeometry_indirect_generated_triangle.c.applyMatrix4( intersectsGeometry_indirect_generated_invertedMat );
				intersectsGeometry_indirect_generated_triangle.needsUpdate = true;

				for ( let i2 = 0, l2 = index.count; i2 < l2; i2 += 3 ) {

					setTriangle( intersectsGeometry_indirect_generated_triangle2, i2, index, pos );
					intersectsGeometry_indirect_generated_triangle2.needsUpdate = true;

					if ( intersectsGeometry_indirect_generated_triangle.intersectsTriangle( intersectsGeometry_indirect_generated_triangle2 ) ) {

						return true;

					}

				}

			}


		}

	} else {

		const left = nodeIndex32 + 8;
		const right = uint32Array[ nodeIndex32 + 6 ];

		arrayToBox( BOUNDING_DATA_INDEX( left ), float32Array, intersectsGeometry_indirect_generated_boundingBox );
		const leftIntersection =
			cachedObb.intersectsBox( intersectsGeometry_indirect_generated_boundingBox ) &&
			intersectsGeometry_indirect_generated_intersectsGeometry( left, bvh, otherGeometry, geometryToBvh, cachedObb );

		if ( leftIntersection ) return true;

		arrayToBox( BOUNDING_DATA_INDEX( right ), float32Array, intersectsGeometry_indirect_generated_boundingBox );
		const rightIntersection =
			cachedObb.intersectsBox( intersectsGeometry_indirect_generated_boundingBox ) &&
			intersectsGeometry_indirect_generated_intersectsGeometry( right, bvh, otherGeometry, geometryToBvh, cachedObb );

		if ( rightIntersection ) return true;

		return false;

	}

}



;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/core/cast/closestPointToGeometry_indirect.generated.js






/*********************************************************************/
/* This file is generated from "closestPointToGeometry.template.js". */
/*********************************************************************/

const closestPointToGeometry_indirect_generated_tempMatrix = /* @__PURE__ */ new three_module/* Matrix4 */.yGw();
const closestPointToGeometry_indirect_generated_obb = /* @__PURE__ */ new OrientedBox();
const closestPointToGeometry_indirect_generated_obb2 = /* @__PURE__ */ new OrientedBox();
const closestPointToGeometry_indirect_generated_temp1 = /* @__PURE__ */ new three_module/* Vector3 */.Pa4();
const closestPointToGeometry_indirect_generated_temp2 = /* @__PURE__ */ new three_module/* Vector3 */.Pa4();
const closestPointToGeometry_indirect_generated_temp3 = /* @__PURE__ */ new three_module/* Vector3 */.Pa4();
const closestPointToGeometry_indirect_generated_temp4 = /* @__PURE__ */ new three_module/* Vector3 */.Pa4();

function closestPointToGeometry_indirect(
	bvh,
	otherGeometry,
	geometryToBvh,
	target1 = { },
	target2 = { },
	minThreshold = 0,
	maxThreshold = Infinity,
) {

	if ( ! otherGeometry.boundingBox ) {

		otherGeometry.computeBoundingBox();

	}

	closestPointToGeometry_indirect_generated_obb.set( otherGeometry.boundingBox.min, otherGeometry.boundingBox.max, geometryToBvh );
	closestPointToGeometry_indirect_generated_obb.needsUpdate = true;

	const geometry = bvh.geometry;
	const pos = geometry.attributes.position;
	const index = geometry.index;
	const otherPos = otherGeometry.attributes.position;
	const otherIndex = otherGeometry.index;
	const triangle = ExtendedTrianglePool.getPrimitive();
	const triangle2 = ExtendedTrianglePool.getPrimitive();

	let tempTarget1 = closestPointToGeometry_indirect_generated_temp1;
	let tempTargetDest1 = closestPointToGeometry_indirect_generated_temp2;
	let tempTarget2 = null;
	let tempTargetDest2 = null;

	if ( target2 ) {

		tempTarget2 = closestPointToGeometry_indirect_generated_temp3;
		tempTargetDest2 = closestPointToGeometry_indirect_generated_temp4;

	}

	let closestDistance = Infinity;
	let closestDistanceTriIndex = null;
	let closestDistanceOtherTriIndex = null;
	closestPointToGeometry_indirect_generated_tempMatrix.copy( geometryToBvh ).invert();
	closestPointToGeometry_indirect_generated_obb2.matrix.copy( closestPointToGeometry_indirect_generated_tempMatrix );
	bvh.shapecast(
		{

			boundsTraverseOrder: box => {

				return closestPointToGeometry_indirect_generated_obb.distanceToBox( box );

			},

			intersectsBounds: ( box, isLeaf, score ) => {

				if ( score < closestDistance && score < maxThreshold ) {

					// if we know the triangles of this bounds will be intersected next then
					// save the bounds to use during triangle checks.
					if ( isLeaf ) {

						closestPointToGeometry_indirect_generated_obb2.min.copy( box.min );
						closestPointToGeometry_indirect_generated_obb2.max.copy( box.max );
						closestPointToGeometry_indirect_generated_obb2.needsUpdate = true;

					}

					return true;

				}

				return false;

			},

			intersectsRange: ( offset, count ) => {

				if ( otherGeometry.boundsTree ) {

					// if the other geometry has a bvh then use the accelerated path where we use shapecast to find
					// the closest bounds in the other geometry to check.
					const otherBvh = otherGeometry.boundsTree;
					return otherBvh.shapecast( {
						boundsTraverseOrder: box => {

							return closestPointToGeometry_indirect_generated_obb2.distanceToBox( box );

						},

						intersectsBounds: ( box, isLeaf, score ) => {

							return score < closestDistance && score < maxThreshold;

						},

						intersectsRange: ( otherOffset, otherCount ) => {

							for ( let i2 = otherOffset, l2 = otherOffset + otherCount; i2 < l2; i2 ++ ) {

								const ti2 = otherBvh.resolveTriangleIndex( i2 );
								setTriangle( triangle2, 3 * ti2, otherIndex, otherPos );

								triangle2.a.applyMatrix4( geometryToBvh );
								triangle2.b.applyMatrix4( geometryToBvh );
								triangle2.c.applyMatrix4( geometryToBvh );
								triangle2.needsUpdate = true;

								for ( let i = offset, l = offset + count; i < l; i ++ ) {

									const ti = bvh.resolveTriangleIndex( i );
									setTriangle( triangle, 3 * ti, index, pos );

									triangle.needsUpdate = true;

									const dist = triangle.distanceToTriangle( triangle2, tempTarget1, tempTarget2 );
									if ( dist < closestDistance ) {

										tempTargetDest1.copy( tempTarget1 );

										if ( tempTargetDest2 ) {

											tempTargetDest2.copy( tempTarget2 );

										}

										closestDistance = dist;
										closestDistanceTriIndex = i;
										closestDistanceOtherTriIndex = i2;

									}

									// stop traversal if we find a point that's under the given threshold
									if ( dist < minThreshold ) {

										return true;

									}

								}

							}

						},
					} );

				} else {

					// If no bounds tree then we'll just check every triangle.
					const triCount = getTriCount( otherGeometry );
					for ( let i2 = 0, l2 = triCount; i2 < l2; i2 ++ ) {

						setTriangle( triangle2, 3 * i2, otherIndex, otherPos );
						triangle2.a.applyMatrix4( geometryToBvh );
						triangle2.b.applyMatrix4( geometryToBvh );
						triangle2.c.applyMatrix4( geometryToBvh );
						triangle2.needsUpdate = true;

						for ( let i = offset, l = offset + count; i < l; i ++ ) {

							const ti = bvh.resolveTriangleIndex( i );
							setTriangle( triangle, 3 * ti, index, pos );

							triangle.needsUpdate = true;

							const dist = triangle.distanceToTriangle( triangle2, tempTarget1, tempTarget2 );
							if ( dist < closestDistance ) {

								tempTargetDest1.copy( tempTarget1 );

								if ( tempTargetDest2 ) {

									tempTargetDest2.copy( tempTarget2 );

								}

								closestDistance = dist;
								closestDistanceTriIndex = i;
								closestDistanceOtherTriIndex = i2;

							}

							// stop traversal if we find a point that's under the given threshold
							if ( dist < minThreshold ) {

								return true;

							}

						}

					}

				}

			},

		}

	);

	ExtendedTrianglePool.releasePrimitive( triangle );
	ExtendedTrianglePool.releasePrimitive( triangle2 );

	if ( closestDistance === Infinity ) {

		return null;

	}

	if ( ! target1.point ) {

		target1.point = tempTargetDest1.clone();

	} else {

		target1.point.copy( tempTargetDest1 );

	}

	target1.distance = closestDistance,
	target1.faceIndex = closestDistanceTriIndex;

	if ( target2 ) {

		if ( ! target2.point ) target2.point = tempTargetDest2.clone();
		else target2.point.copy( tempTargetDest2 );
		target2.point.applyMatrix4( closestPointToGeometry_indirect_generated_tempMatrix );
		tempTargetDest1.applyMatrix4( closestPointToGeometry_indirect_generated_tempMatrix );
		target2.distance = tempTargetDest1.sub( target2.point ).length();
		target2.faceIndex = closestDistanceOtherTriIndex;

	}

	return target1;

}



;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/utils/BufferUtils.js
function isSharedArrayBufferSupported() {

	return typeof SharedArrayBuffer !== 'undefined';

}

function convertToBufferType( array, BufferConstructor ) {

	if ( array === null ) {

		return array;

	} else if ( array.buffer ) {

		const buffer = array.buffer;
		if ( buffer.constructor === BufferConstructor ) {

			return array;

		}

		const ArrayConstructor = array.constructor;
		const result = new ArrayConstructor( new BufferConstructor( buffer.byteLength ) );
		result.set( array );
		return result;

	} else {

		if ( array.constructor === BufferConstructor ) {

			return array;

		}

		const result = new BufferConstructor( array.byteLength );
		new Uint8Array( result ).set( new Uint8Array( array ) );
		return result;

	}

}

;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/core/cast/bvhcast.js






const _bufferStack1 = new BufferStack.constructor();
const _bufferStack2 = new BufferStack.constructor();
const _boxPool = new PrimitivePool( () => new three_module/* Box3 */.ZzF() );
const _leftBox1 = new three_module/* Box3 */.ZzF();
const _rightBox1 = new three_module/* Box3 */.ZzF();

const _leftBox2 = new three_module/* Box3 */.ZzF();
const _rightBox2 = new three_module/* Box3 */.ZzF();

let _active = false;

function bvhcast( bvh, otherBvh, matrixToLocal, intersectsRanges ) {

	if ( _active ) {

		throw new Error( 'MeshBVH: Recursive calls to bvhcast not supported.' );

	}

	_active = true;

	const roots = bvh._roots;
	const otherRoots = otherBvh._roots;
	let result;
	let offset1 = 0;
	let offset2 = 0;
	const invMat = new three_module/* Matrix4 */.yGw().copy( matrixToLocal ).invert();

	// iterate over the first set of roots
	for ( let i = 0, il = roots.length; i < il; i ++ ) {

		_bufferStack1.setBuffer( roots[ i ] );
		offset2 = 0;

		// prep the initial root box
		const localBox = _boxPool.getPrimitive();
		arrayToBox( BOUNDING_DATA_INDEX( 0 ), _bufferStack1.float32Array, localBox );
		localBox.applyMatrix4( invMat );

		// iterate over the second set of roots
		for ( let j = 0, jl = otherRoots.length; j < jl; j ++ ) {

			_bufferStack2.setBuffer( otherRoots[ i ] );

			result = _traverse(
				0, 0, matrixToLocal, invMat, intersectsRanges,
				offset1, offset2, 0, 0,
				localBox,
			);

			_bufferStack2.clearBuffer();
			offset2 += otherRoots[ j ].length;

			if ( result ) {

				break;

			}

		}

		// release stack info
		_boxPool.releasePrimitive( localBox );
		_bufferStack1.clearBuffer();
		offset1 += roots[ i ].length;

		if ( result ) {

			break;

		}

	}

	_active = false;
	return result;

}

function _traverse(
	node1Index32,
	node2Index32,
	matrix2to1,
	matrix1to2,
	intersectsRangesFunc,

	// offsets for ids
	node1IndexByteOffset = 0,
	node2IndexByteOffset = 0,

	// tree depth
	depth1 = 0,
	depth2 = 0,

	currBox = null,
	reversed = false,

) {

	// get the buffer stacks associated with the current indices
	let bufferStack1, bufferStack2;
	if ( reversed ) {

		bufferStack1 = _bufferStack2;
		bufferStack2 = _bufferStack1;

	} else {

		bufferStack1 = _bufferStack1;
		bufferStack2 = _bufferStack2;

	}

	// get the local instances of the typed buffers
	const
		float32Array1 = bufferStack1.float32Array,
		uint32Array1 = bufferStack1.uint32Array,
		uint16Array1 = bufferStack1.uint16Array,
		float32Array2 = bufferStack2.float32Array,
		uint32Array2 = bufferStack2.uint32Array,
		uint16Array2 = bufferStack2.uint16Array;

	const node1Index16 = node1Index32 * 2;
	const node2Index16 = node2Index32 * 2;
	const isLeaf1 = IS_LEAF( node1Index16, uint16Array1 );
	const isLeaf2 = IS_LEAF( node2Index16, uint16Array2 );
	let result = false;
	if ( isLeaf2 && isLeaf1 ) {

		// if both bounds are leaf nodes then fire the callback if the boxes intersect
		if ( reversed ) {

			result = intersectsRangesFunc(
				OFFSET( node2Index32, uint32Array2 ), COUNT( node2Index32 * 2, uint16Array2 ),
				OFFSET( node1Index32, uint32Array1 ), COUNT( node1Index32 * 2, uint16Array1 ),
				depth2, node2IndexByteOffset + node2Index32,
				depth1, node1IndexByteOffset + node1Index32,
			);

		} else {

			result = intersectsRangesFunc(
				OFFSET( node1Index32, uint32Array1 ), COUNT( node1Index32 * 2, uint16Array1 ),
				OFFSET( node2Index32, uint32Array2 ), COUNT( node2Index32 * 2, uint16Array2 ),
				depth1, node1IndexByteOffset + node1Index32,
				depth2, node2IndexByteOffset + node2Index32,
			);

		}

	} else if ( isLeaf2 ) {

		// SWAP
		// If we've traversed to the leaf node on the other bvh then we need to swap over
		// to traverse down the first one

		// get the new box to use
		const newBox = _boxPool.getPrimitive();
		arrayToBox( BOUNDING_DATA_INDEX( node2Index32 ), float32Array2, newBox );
		newBox.applyMatrix4( matrix2to1 );

		// get the child bounds to check before traversal
		const cl1 = LEFT_NODE( node1Index32 );
		const cr1 = RIGHT_NODE( node1Index32, uint32Array1 );
		arrayToBox( BOUNDING_DATA_INDEX( cl1 ), float32Array1, _leftBox1 );
		arrayToBox( BOUNDING_DATA_INDEX( cr1 ), float32Array1, _rightBox1 );

		// precompute the intersections otherwise the global boxes will be modified during traversal
		const intersectCl1 = newBox.intersectsBox( _leftBox1 );
		const intersectCr1 = newBox.intersectsBox( _rightBox1 );
		result = (
			intersectCl1 && _traverse(
				node2Index32, cl1, matrix1to2, matrix2to1, intersectsRangesFunc,
				node2IndexByteOffset, node1IndexByteOffset, depth2, depth1 + 1,
				newBox, ! reversed,
			)
		) || (
			intersectCr1 && _traverse(
				node2Index32, cr1, matrix1to2, matrix2to1, intersectsRangesFunc,
				node2IndexByteOffset, node1IndexByteOffset, depth2, depth1 + 1,
				newBox, ! reversed,
			)
		);

		_boxPool.releasePrimitive( newBox );

	} else {

		// if neither are leaves then we should swap if one of the children does not
		// intersect with the current bounds

		// get the child bounds to check
		const cl2 = LEFT_NODE( node2Index32 );
		const cr2 = RIGHT_NODE( node2Index32, uint32Array2 );
		arrayToBox( BOUNDING_DATA_INDEX( cl2 ), float32Array2, _leftBox2 );
		arrayToBox( BOUNDING_DATA_INDEX( cr2 ), float32Array2, _rightBox2 );

		const leftIntersects = currBox.intersectsBox( _leftBox2 );
		const rightIntersects = currBox.intersectsBox( _rightBox2 );
		if ( leftIntersects && rightIntersects ) {

			// continue to traverse both children if they both intersect
			result = _traverse(
				node1Index32, cl2, matrix2to1, matrix1to2, intersectsRangesFunc,
				node1IndexByteOffset, node2IndexByteOffset, depth1, depth2 + 1,
				currBox, reversed,
			) || _traverse(
				node1Index32, cr2, matrix2to1, matrix1to2, intersectsRangesFunc,
				node1IndexByteOffset, node2IndexByteOffset, depth1, depth2 + 1,
				currBox, reversed,
			);

		} else if ( leftIntersects ) {

			if ( isLeaf1 ) {

				// if the current box is a leaf then just continue
				result = _traverse(
					node1Index32, cl2, matrix2to1, matrix1to2, intersectsRangesFunc,
					node1IndexByteOffset, node2IndexByteOffset, depth1, depth2 + 1,
					currBox, reversed,
				);

			} else {

				// SWAP
				// if only one box intersects then we have to swap to the other bvh to continue
				const newBox = _boxPool.getPrimitive();
				newBox.copy( _leftBox2 ).applyMatrix4( matrix2to1 );

				const cl1 = LEFT_NODE( node1Index32 );
				const cr1 = RIGHT_NODE( node1Index32, uint32Array1 );
				arrayToBox( BOUNDING_DATA_INDEX( cl1 ), float32Array1, _leftBox1 );
				arrayToBox( BOUNDING_DATA_INDEX( cr1 ), float32Array1, _rightBox1 );

				// precompute the intersections otherwise the global boxes will be modified during traversal
				const intersectCl1 = newBox.intersectsBox( _leftBox1 );
				const intersectCr1 = newBox.intersectsBox( _rightBox1 );
				result = (
					intersectCl1 && _traverse(
						cl2, cl1, matrix1to2, matrix2to1, intersectsRangesFunc,
						node2IndexByteOffset, node1IndexByteOffset, depth2, depth1 + 1,
						newBox, ! reversed,
					)
				) || (
					intersectCr1 && _traverse(
						cl2, cr1, matrix1to2, matrix2to1, intersectsRangesFunc,
						node2IndexByteOffset, node1IndexByteOffset, depth2, depth1 + 1,
						newBox, ! reversed,
					)
				);

				_boxPool.releasePrimitive( newBox );

			}

		} else if ( rightIntersects ) {

			if ( isLeaf1 ) {

				// if the current box is a leaf then just continue
				result = _traverse(
					node1Index32, cr2, matrix2to1, matrix1to2, intersectsRangesFunc,
					node1IndexByteOffset, node2IndexByteOffset, depth1, depth2 + 1,
					currBox, reversed,
				);

			} else {

				// SWAP
				// if only one box intersects then we have to swap to the other bvh to continue
				const newBox = _boxPool.getPrimitive();
				newBox.copy( _rightBox2 ).applyMatrix4( matrix2to1 );

				const cl1 = LEFT_NODE( node1Index32 );
				const cr1 = RIGHT_NODE( node1Index32, uint32Array1 );
				arrayToBox( BOUNDING_DATA_INDEX( cl1 ), float32Array1, _leftBox1 );
				arrayToBox( BOUNDING_DATA_INDEX( cr1 ), float32Array1, _rightBox1 );

				// precompute the intersections otherwise the global boxes will be modified during traversal
				const intersectCl1 = newBox.intersectsBox( _leftBox1 );
				const intersectCr1 = newBox.intersectsBox( _rightBox1 );
				result = (
					intersectCl1 && _traverse(
						cr2, cl1, matrix1to2, matrix2to1, intersectsRangesFunc,
						node2IndexByteOffset, node1IndexByteOffset, depth2, depth1 + 1,
						newBox, ! reversed,
					)
				) || (
					intersectCr1 && _traverse(
						cr2, cr1, matrix1to2, matrix2to1, intersectsRangesFunc,
						node2IndexByteOffset, node1IndexByteOffset, depth2, depth1 + 1,
						newBox, ! reversed,
					)
				);

				_boxPool.releasePrimitive( newBox );

			}

		}

	}

	return result;

}


;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/core/MeshBVH.js


























const MeshBVH_obb = /* @__PURE__ */ new OrientedBox();
const tempBox = /* @__PURE__ */ new three_module/* Box3 */.ZzF();
const DEFAULT_OPTIONS = {
	strategy: CENTER,
	maxDepth: 40,
	maxLeafTris: 10,
	useSharedArrayBuffer: false,
	setBoundingBox: true,
	onProgress: null,
	indirect: false,
	verbose: true,
};

class MeshBVH {

	static serialize( bvh, options = {} ) {

		options = {
			cloneBuffers: true,
			...options,
		};

		const geometry = bvh.geometry;
		const rootData = bvh._roots;
		const indirectBuffer = bvh._indirectBuffer;
		const indexAttribute = geometry.getIndex();
		let result;
		if ( options.cloneBuffers ) {

			result = {
				roots: rootData.map( root => root.slice() ),
				index: indexAttribute.array.slice(),
				indirectBuffer: indirectBuffer ? indirectBuffer.slice() : null,
			};

		} else {

			result = {
				roots: rootData,
				index: indexAttribute.array,
				indirectBuffer: indirectBuffer,
			};

		}

		return result;

	}

	static deserialize( data, geometry, options = {} ) {

		options = {
			setIndex: true,
			indirect: Boolean( data.indirectBuffer ),
			...options,
		};

		const { index, roots, indirectBuffer } = data;
		const bvh = new MeshBVH( geometry, { ...options, [ SKIP_GENERATION ]: true } );
		bvh._roots = roots;
		bvh._indirectBuffer = indirectBuffer || null;

		if ( options.setIndex ) {

			const indexAttribute = geometry.getIndex();
			if ( indexAttribute === null ) {

				const newIndex = new three_module/* BufferAttribute */.TlE( data.index, 1, false );
				geometry.setIndex( newIndex );

			} else if ( indexAttribute.array !== index ) {

				indexAttribute.array.set( index );
				indexAttribute.needsUpdate = true;

			}

		}

		return bvh;

	}

	get indirect() {

		return ! ! this._indirectBuffer;

	}

	constructor( geometry, options = {} ) {

		if ( ! geometry.isBufferGeometry ) {

			throw new Error( 'MeshBVH: Only BufferGeometries are supported.' );

		} else if ( geometry.index && geometry.index.isInterleavedBufferAttribute ) {

			throw new Error( 'MeshBVH: InterleavedBufferAttribute is not supported for the index attribute.' );

		}

		// default options
		options = Object.assign( {

			...DEFAULT_OPTIONS,

			// undocumented options

			// Whether to skip generating the tree. Used for deserialization.
			[ SKIP_GENERATION ]: false,

		}, options );

		if ( options.useSharedArrayBuffer && ! isSharedArrayBufferSupported() ) {

			throw new Error( 'MeshBVH: SharedArrayBuffer is not available.' );

		}

		// retain references to the geometry so we can use them it without having to
		// take a geometry reference in every function.
		this.geometry = geometry;
		this._roots = null;
		this._indirectBuffer = null;
		if ( ! options[ SKIP_GENERATION ] ) {

			buildPackedTree( this, options );

			if ( ! geometry.boundingBox && options.setBoundingBox ) {

				geometry.boundingBox = this.getBoundingBox( new three_module/* Box3 */.ZzF() );

			}

		}

		const { _indirectBuffer } = this;
		this.resolveTriangleIndex = options.indirect ? i => _indirectBuffer[ i ] : i => i;

	}

	refit( nodeIndices = null ) {

		const refitFunc = this.indirect ? refit_indirect : refit;
		return refitFunc( this, nodeIndices );

	}

	traverse( callback, rootIndex = 0 ) {

		const buffer = this._roots[ rootIndex ];
		const uint32Array = new Uint32Array( buffer );
		const uint16Array = new Uint16Array( buffer );
		_traverse( 0 );

		function _traverse( node32Index, depth = 0 ) {

			const node16Index = node32Index * 2;
			const isLeaf = uint16Array[ node16Index + 15 ] === IS_LEAFNODE_FLAG;
			if ( isLeaf ) {

				const offset = uint32Array[ node32Index + 6 ];
				const count = uint16Array[ node16Index + 14 ];
				callback( depth, isLeaf, new Float32Array( buffer, node32Index * 4, 6 ), offset, count );

			} else {

				// TODO: use node functions here
				const left = node32Index + BYTES_PER_NODE / 4;
				const right = uint32Array[ node32Index + 6 ];
				const splitAxis = uint32Array[ node32Index + 7 ];
				const stopTraversal = callback( depth, isLeaf, new Float32Array( buffer, node32Index * 4, 6 ), splitAxis );

				if ( ! stopTraversal ) {

					_traverse( left, depth + 1 );
					_traverse( right, depth + 1 );

				}

			}

		}

	}

	/* Core Cast Functions */
	raycast( ray, materialOrSide = three_module/* FrontSide */.Wl3 ) {

		const roots = this._roots;
		const geometry = this.geometry;
		const intersects = [];
		const isMaterial = materialOrSide.isMaterial;
		const isArrayMaterial = Array.isArray( materialOrSide );

		const groups = geometry.groups;
		const side = isMaterial ? materialOrSide.side : materialOrSide;
		const raycastFunc = this.indirect ? raycast_indirect : raycast;
		for ( let i = 0, l = roots.length; i < l; i ++ ) {

			const materialSide = isArrayMaterial ? materialOrSide[ groups[ i ].materialIndex ].side : side;
			const startCount = intersects.length;

			raycastFunc( this, i, materialSide, ray, intersects );

			if ( isArrayMaterial ) {

				const materialIndex = groups[ i ].materialIndex;
				for ( let j = startCount, jl = intersects.length; j < jl; j ++ ) {

					intersects[ j ].face.materialIndex = materialIndex;

				}

			}

		}

		return intersects;

	}

	raycastFirst( ray, materialOrSide = three_module/* FrontSide */.Wl3 ) {

		const roots = this._roots;
		const geometry = this.geometry;
		const isMaterial = materialOrSide.isMaterial;
		const isArrayMaterial = Array.isArray( materialOrSide );

		let closestResult = null;

		const groups = geometry.groups;
		const side = isMaterial ? materialOrSide.side : materialOrSide;
		const raycastFirstFunc = this.indirect ? raycastFirst_indirect : raycastFirst;
		for ( let i = 0, l = roots.length; i < l; i ++ ) {

			const materialSide = isArrayMaterial ? materialOrSide[ groups[ i ].materialIndex ].side : side;
			const result = raycastFirstFunc( this, i, materialSide, ray );
			if ( result != null && ( closestResult == null || result.distance < closestResult.distance ) ) {

				closestResult = result;
				if ( isArrayMaterial ) {

					result.face.materialIndex = groups[ i ].materialIndex;

				}

			}

		}

		return closestResult;

	}

	intersectsGeometry( otherGeometry, geomToMesh ) {

		let result = false;
		const roots = this._roots;
		const intersectsGeometryFunc = this.indirect ? intersectsGeometry_indirect : intersectsGeometry;
		for ( let i = 0, l = roots.length; i < l; i ++ ) {

			result = intersectsGeometryFunc( this, i, otherGeometry, geomToMesh );

			if ( result ) {

				break;

			}

		}

		return result;

	}

	shapecast( callbacks ) {

		const triangle = ExtendedTrianglePool.getPrimitive();
		const iterateFunc = this.indirect ? iterateOverTriangles_indirect : iterateOverTriangles;
		let {
			boundsTraverseOrder,
			intersectsBounds,
			intersectsRange,
			intersectsTriangle,
		} = callbacks;

		// wrap the intersectsRange function
		if ( intersectsRange && intersectsTriangle ) {

			const originalIntersectsRange = intersectsRange;
			intersectsRange = ( offset, count, contained, depth, nodeIndex ) => {

				if ( ! originalIntersectsRange( offset, count, contained, depth, nodeIndex ) ) {

					return iterateFunc( offset, count, this, intersectsTriangle, contained, depth, triangle );

				}

				return true;

			};

		} else if ( ! intersectsRange ) {

			if ( intersectsTriangle ) {

				intersectsRange = ( offset, count, contained, depth ) => {

					return iterateFunc( offset, count, this, intersectsTriangle, contained, depth, triangle );

				};

			} else {

				intersectsRange = ( offset, count, contained ) => {

					return contained;

				};

			}

		}

		// run shapecast
		let result = false;
		let byteOffset = 0;
		const roots = this._roots;
		for ( let i = 0, l = roots.length; i < l; i ++ ) {

			const root = roots[ i ];
			result = shapecast( this, i, intersectsBounds, intersectsRange, boundsTraverseOrder, byteOffset );

			if ( result ) {

				break;

			}

			byteOffset += root.byteLength;

		}

		ExtendedTrianglePool.releasePrimitive( triangle );

		return result;

	}

	bvhcast( otherBvh, matrixToLocal, callbacks ) {

		let {
			intersectsRanges,
			intersectsTriangles,
		} = callbacks;

		const triangle1 = ExtendedTrianglePool.getPrimitive();
		const indexAttr1 = this.geometry.index;
		const positionAttr1 = this.geometry.attributes.position;
		const assignTriangle1 = this.indirect ?
			i1 => {


				const ti = this.resolveTriangleIndex( i1 );
				setTriangle( triangle1, ti * 3, indexAttr1, positionAttr1 );

			} :
			i1 => {

				setTriangle( triangle1, i1 * 3, indexAttr1, positionAttr1 );

			};

		const triangle2 = ExtendedTrianglePool.getPrimitive();
		const indexAttr2 = otherBvh.geometry.index;
		const positionAttr2 = otherBvh.geometry.attributes.position;
		const assignTriangle2 = otherBvh.indirect ?
			i2 => {

				const ti2 = otherBvh.resolveTriangleIndex( i2 );
				setTriangle( triangle2, ti2 * 3, indexAttr2, positionAttr2 );

			} :
			i2 => {

				setTriangle( triangle2, i2 * 3, indexAttr2, positionAttr2 );

			};

		// generate triangle callback if needed
		if ( intersectsTriangles ) {

			const iterateOverDoubleTriangles = ( offset1, count1, offset2, count2, depth1, index1, depth2, index2 ) => {

				for ( let i2 = offset2, l2 = offset2 + count2; i2 < l2; i2 ++ ) {

					assignTriangle2( i2 );

					triangle2.a.applyMatrix4( matrixToLocal );
					triangle2.b.applyMatrix4( matrixToLocal );
					triangle2.c.applyMatrix4( matrixToLocal );
					triangle2.needsUpdate = true;

					for ( let i1 = offset1, l1 = offset1 + count1; i1 < l1; i1 ++ ) {

						assignTriangle1( i1 );

						triangle1.needsUpdate = true;

						if ( intersectsTriangles( triangle1, triangle2, i1, i2, depth1, index1, depth2, index2 ) ) {

							return true;

						}

					}

				}

				return false;

			};

			if ( intersectsRanges ) {

				const originalIntersectsRanges = intersectsRanges;
				intersectsRanges = function ( offset1, count1, offset2, count2, depth1, index1, depth2, index2 ) {

					if ( ! originalIntersectsRanges( offset1, count1, offset2, count2, depth1, index1, depth2, index2 ) ) {

						return iterateOverDoubleTriangles( offset1, count1, offset2, count2, depth1, index1, depth2, index2 );

					}

					return true;

				};

			} else {

				intersectsRanges = iterateOverDoubleTriangles;

			}

		}

		return bvhcast( this, otherBvh, matrixToLocal, intersectsRanges );

	}


	/* Derived Cast Functions */
	intersectsBox( box, boxToMesh ) {

		MeshBVH_obb.set( box.min, box.max, boxToMesh );
		MeshBVH_obb.needsUpdate = true;

		return this.shapecast(
			{
				intersectsBounds: box => MeshBVH_obb.intersectsBox( box ),
				intersectsTriangle: tri => MeshBVH_obb.intersectsTriangle( tri )
			}
		);

	}

	intersectsSphere( sphere ) {

		return this.shapecast(
			{
				intersectsBounds: box => sphere.intersectsBox( box ),
				intersectsTriangle: tri => tri.intersectsSphere( sphere )
			}
		);

	}

	closestPointToGeometry( otherGeometry, geometryToBvh, target1 = { }, target2 = { }, minThreshold = 0, maxThreshold = Infinity ) {

		const closestPointToGeometryFunc = this.indirect ? closestPointToGeometry_indirect : closestPointToGeometry;
		return closestPointToGeometryFunc(
			this,
			otherGeometry,
			geometryToBvh,
			target1,
			target2,
			minThreshold,
			maxThreshold,
		);

	}

	closestPointToPoint( point, target = { }, minThreshold = 0, maxThreshold = Infinity ) {

		return closestPointToPoint(
			this,
			point,
			target,
			minThreshold,
			maxThreshold,
		);

	}

	getBoundingBox( target ) {

		target.makeEmpty();

		const roots = this._roots;
		roots.forEach( buffer => {

			arrayToBox( 0, new Float32Array( buffer ), tempBox );
			target.union( tempBox );

		} );

		return target;

	}

}

;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/objects/MeshBVHHelper.js




const MeshBVHHelper_boundingBox = /* @__PURE__ */ new three_module/* Box3 */.ZzF();
class MeshBVHRootHelper extends three_module/* Object3D */.Tme {

	get isMesh() {

		return ! this.displayEdges;

	}

	get isLineSegments() {

		return this.displayEdges;

	}

	get isLine() {

		return this.displayEdges;

	}

	constructor( bvh, material, depth = 10, group = 0 ) {

		super();

		this.material = material;
		this.geometry = new three_module/* BufferGeometry */.u9r();
		this.name = 'MeshBVHRootHelper';
		this.depth = depth;
		this.displayParents = false;
		this.bvh = bvh;
		this.displayEdges = true;
		this._group = group;

	}

	raycast() {}

	update() {

		const geometry = this.geometry;
		const boundsTree = this.bvh;
		const group = this._group;
		geometry.dispose();
		this.visible = false;
		if ( boundsTree ) {

			// count the number of bounds required
			const targetDepth = this.depth - 1;
			const displayParents = this.displayParents;
			let boundsCount = 0;
			boundsTree.traverse( ( depth, isLeaf ) => {

				if ( depth >= targetDepth || isLeaf ) {

					boundsCount ++;
					return true;

				} else if ( displayParents ) {

					boundsCount ++;

				}

			}, group );

			// fill in the position buffer with the bounds corners
			let posIndex = 0;
			const positionArray = new Float32Array( 8 * 3 * boundsCount );
			boundsTree.traverse( ( depth, isLeaf, boundingData ) => {

				const terminate = depth >= targetDepth || isLeaf;
				if ( terminate || displayParents ) {

					arrayToBox( 0, boundingData, MeshBVHHelper_boundingBox );

					const { min, max } = MeshBVHHelper_boundingBox;
					for ( let x = - 1; x <= 1; x += 2 ) {

						const xVal = x < 0 ? min.x : max.x;
						for ( let y = - 1; y <= 1; y += 2 ) {

							const yVal = y < 0 ? min.y : max.y;
							for ( let z = - 1; z <= 1; z += 2 ) {

								const zVal = z < 0 ? min.z : max.z;
								positionArray[ posIndex + 0 ] = xVal;
								positionArray[ posIndex + 1 ] = yVal;
								positionArray[ posIndex + 2 ] = zVal;

								posIndex += 3;

							}

						}

					}

					return terminate;

				}

			}, group );

			let indexArray;
			let indices;
			if ( this.displayEdges ) {

				// fill in the index buffer to point to the corner points
				indices = new Uint8Array( [
					// x axis
					0, 4,
					1, 5,
					2, 6,
					3, 7,

					// y axis
					0, 2,
					1, 3,
					4, 6,
					5, 7,

					// z axis
					0, 1,
					2, 3,
					4, 5,
					6, 7,
				] );

			} else {

				indices = new Uint8Array( [

					// X-, X+
					0, 1, 2,
					2, 1, 3,

					4, 6, 5,
					6, 7, 5,

					// Y-, Y+
					1, 4, 5,
					0, 4, 1,

					2, 3, 6,
					3, 7, 6,

					// Z-, Z+
					0, 2, 4,
					2, 6, 4,

					1, 5, 3,
					3, 5, 7,

				] );

			}

			if ( positionArray.length > 65535 ) {

				indexArray = new Uint32Array( indices.length * boundsCount );

			} else {

				indexArray = new Uint16Array( indices.length * boundsCount );

			}

			const indexLength = indices.length;
			for ( let i = 0; i < boundsCount; i ++ ) {

				const posOffset = i * 8;
				const indexOffset = i * indexLength;
				for ( let j = 0; j < indexLength; j ++ ) {

					indexArray[ indexOffset + j ] = posOffset + indices[ j ];

				}

			}

			// update the geometry
			geometry.setIndex(
				new three_module/* BufferAttribute */.TlE( indexArray, 1, false ),
			);
			geometry.setAttribute(
				'position',
				new three_module/* BufferAttribute */.TlE( positionArray, 3, false ),
			);
			this.visible = true;

		}

	}

}

class MeshBVHHelper extends three_module/* Group */.ZAu {

	get color() {

		return this.edgeMaterial.color;

	}

	get opacity() {

		return this.edgeMaterial.opacity;

	}

	set opacity( v ) {

		this.edgeMaterial.opacity = v;
		this.meshMaterial.opacity = v;

	}

	constructor( mesh = null, bvh = null, depth = 10 ) {

		// handle bvh, depth signature
		if ( mesh instanceof MeshBVH ) {

			depth = bvh || 10;
			bvh = mesh;
			mesh = null;

		}

		// handle mesh, depth signature
		if ( typeof bvh === 'number' ) {

			depth = bvh;
			bvh = null;

		}

		super();

		this.name = 'MeshBVHHelper';
		this.depth = depth;
		this.mesh = mesh;
		this.bvh = bvh;
		this.displayParents = false;
		this.displayEdges = true;
		this._roots = [];

		const edgeMaterial = new three_module/* LineBasicMaterial */.nls( {
			color: 0x00FF88,
			transparent: true,
			opacity: 0.3,
			depthWrite: false,
		} );

		const meshMaterial = new three_module/* MeshBasicMaterial */.vBJ( {
			color: 0x00FF88,
			transparent: true,
			opacity: 0.3,
			depthWrite: false,
		} );

		meshMaterial.color = edgeMaterial.color;

		this.edgeMaterial = edgeMaterial;
		this.meshMaterial = meshMaterial;

		this.update();

	}

	update() {

		const bvh = this.bvh || this.mesh.geometry.boundsTree;
		const totalRoots = bvh ? bvh._roots.length : 0;
		while ( this._roots.length > totalRoots ) {

			const root = this._roots.pop();
			root.geometry.dispose();
			this.remove( root );

		}

		for ( let i = 0; i < totalRoots; i ++ ) {

			const { depth, edgeMaterial, meshMaterial, displayParents, displayEdges } = this;

			if ( i >= this._roots.length ) {

				const root = new MeshBVHRootHelper( bvh, edgeMaterial, depth, i );
				this.add( root );
				this._roots.push( root );

			}

			const root = this._roots[ i ];
			root.bvh = bvh;
			root.depth = depth;
			root.displayParents = displayParents;
			root.displayEdges = displayEdges;
			root.material = displayEdges ? edgeMaterial : meshMaterial;
			root.update();

		}

	}

	updateMatrixWorld( ...args ) {

		const mesh = this.mesh;
		const parent = this.parent;

		if ( mesh !== null ) {

			mesh.updateWorldMatrix( true, false );

			if ( parent ) {

				this.matrix
					.copy( parent.matrixWorld )
					.invert()
					.multiply( mesh.matrixWorld );

			} else {

				this.matrix
					.copy( mesh.matrixWorld );

			}

			this.matrix.decompose(
				this.position,
				this.quaternion,
				this.scale,
			);

		}

		super.updateMatrixWorld( ...args );

	}

	copy( source ) {

		this.depth = source.depth;
		this.mesh = source.mesh;
		this.bvh = source.bvh;
		this.opacity = source.opacity;
		this.color.copy( source.color );

	}

	clone() {

		return new MeshBVHHelper( this.mesh, this.bvh, this.depth );

	}

	dispose() {

		this.edgeMaterial.dispose();
		this.meshMaterial.dispose();

		const children = this.children;
		for ( let i = 0, l = children.length; i < l; i ++ ) {

			children[ i ].geometry.dispose();

		}

	}

}

class MeshBVHVisualizer extends (/* unused pure expression or super */ null && (MeshBVHHelper)) {

	constructor( ...args ) {

		super( ...args );

		console.warn( 'MeshBVHVisualizer: MeshBVHVisualizer has been deprecated. Use MeshBVHHelper, instead.' );

	}

}



;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/debug/Debug.js





const Debug_box1 = /* @__PURE__ */ new three_module/* Box3 */.ZzF();
const Debug_box2 = /* @__PURE__ */ new three_module/* Box3 */.ZzF();
const _vec = /* @__PURE__ */ new three_module/* Vector3 */.Pa4();

// https://stackoverflow.com/questions/1248302/how-to-get-the-size-of-a-javascript-object
function getPrimitiveSize( el ) {

	switch ( typeof el ) {

		case 'number':
			return 8;
		case 'string':
			return el.length * 2;
		case 'boolean':
			return 4;
		default:
			return 0;

	}

}

function isTypedArray( arr ) {

	const regex = /(Uint|Int|Float)(8|16|32)Array/;
	return regex.test( arr.constructor.name );

}

function getRootExtremes( bvh, group ) {

	const result = {
		nodeCount: 0,
		leafNodeCount: 0,

		depth: {
			min: Infinity, max: - Infinity
		},
		tris: {
			min: Infinity, max: - Infinity
		},
		splits: [ 0, 0, 0 ],
		surfaceAreaScore: 0,
	};

	bvh.traverse( ( depth, isLeaf, boundingData, offsetOrSplit, count ) => {

		const l0 = boundingData[ 0 + 3 ] - boundingData[ 0 ];
		const l1 = boundingData[ 1 + 3 ] - boundingData[ 1 ];
		const l2 = boundingData[ 2 + 3 ] - boundingData[ 2 ];

		const surfaceArea = 2 * ( l0 * l1 + l1 * l2 + l2 * l0 );

		result.nodeCount ++;
		if ( isLeaf ) {

			result.leafNodeCount ++;

			result.depth.min = Math.min( depth, result.depth.min );
			result.depth.max = Math.max( depth, result.depth.max );

			result.tris.min = Math.min( count, result.tris.min );
			result.tris.max = Math.max( count, result.tris.max );

			result.surfaceAreaScore += surfaceArea * TRIANGLE_INTERSECT_COST * count;

		} else {

			result.splits[ offsetOrSplit ] ++;

			result.surfaceAreaScore += surfaceArea * TRAVERSAL_COST;

		}

	}, group );

	// If there are no leaf nodes because the tree hasn't finished generating yet.
	if ( result.tris.min === Infinity ) {

		result.tris.min = 0;
		result.tris.max = 0;

	}

	if ( result.depth.min === Infinity ) {

		result.depth.min = 0;
		result.depth.max = 0;

	}

	return result;

}

function getBVHExtremes( bvh ) {

	return bvh._roots.map( ( root, i ) => getRootExtremes( bvh, i ) );

}

function estimateMemoryInBytes( obj ) {

	const traversed = new Set();
	const stack = [ obj ];
	let bytes = 0;

	while ( stack.length ) {

		const curr = stack.pop();
		if ( traversed.has( curr ) ) {

			continue;

		}

		traversed.add( curr );

		for ( let key in curr ) {

			if ( ! curr.hasOwnProperty( key ) ) {

				continue;

			}

			bytes += getPrimitiveSize( key );

			const value = curr[ key ];
			if ( value && ( typeof value === 'object' || typeof value === 'function' ) ) {

				if ( isTypedArray( value ) ) {

					bytes += value.byteLength;

				} else if ( isSharedArrayBufferSupported() && value instanceof SharedArrayBuffer ) {

					bytes += value.byteLength;

				} else if ( value instanceof ArrayBuffer ) {

					bytes += value.byteLength;

				} else {

					stack.push( value );

				}

			} else {

				bytes += getPrimitiveSize( value );

			}


		}

	}

	return bytes;

}

function validateBounds( bvh ) {

	const geometry = bvh.geometry;
	const depthStack = [];
	const index = geometry.index;
	const position = geometry.getAttribute( 'position' );
	let passes = true;

	bvh.traverse( ( depth, isLeaf, boundingData, offset, count ) => {

		const info = {
			depth,
			isLeaf,
			boundingData,
			offset,
			count,
		};
		depthStack[ depth ] = info;

		arrayToBox( 0, boundingData, Debug_box1 );
		const parent = depthStack[ depth - 1 ];

		if ( isLeaf ) {

			// check triangles
			for ( let i = offset, l = offset + count; i < l; i ++ ) {

				const triIndex = bvh.resolveTriangleIndex( i );
				let i0 = 3 * triIndex;
				let i1 = 3 * triIndex + 1;
				let i2 = 3 * triIndex + 2;

				if ( index ) {

					i0 = index.getX( i0 );
					i1 = index.getX( i1 );
					i2 = index.getX( i2 );

				}

				let isContained;

				_vec.fromBufferAttribute( position, i0 );
				isContained = Debug_box1.containsPoint( _vec );

				_vec.fromBufferAttribute( position, i1 );
				isContained = isContained && Debug_box1.containsPoint( _vec );

				_vec.fromBufferAttribute( position, i2 );
				isContained = isContained && Debug_box1.containsPoint( _vec );

				console.assert( isContained, 'Leaf bounds does not fully contain triangle.' );
				passes = passes && isContained;

			}

		}

		if ( parent ) {

			// check if my bounds fit in my parents
			arrayToBox( 0, boundingData, Debug_box2 );

			const isContained = Debug_box2.containsBox( Debug_box1 );
			console.assert( isContained, 'Parent bounds does not fully contain child.' );
			passes = passes && isContained;

		}

	} );

	return passes;

}

// Returns a simple, human readable object that represents the BVH.
function getJSONStructure( bvh ) {

	const depthStack = [];

	bvh.traverse( ( depth, isLeaf, boundingData, offset, count ) => {

		const info = {
			bounds: arrayToBox( 0, boundingData, new three_module/* Box3 */.ZzF() ),
		};

		if ( isLeaf ) {

			info.count = count;
			info.offset = offset;

		} else {

			info.left = null;
			info.right = null;

		}

		depthStack[ depth ] = info;

		// traversal hits the left then right node
		const parent = depthStack[ depth - 1 ];
		if ( parent ) {

			if ( parent.left === null ) {

				parent.left = info;

			} else {

				parent.right = info;

			}

		}

	} );

	return depthStack[ 0 ];

}



;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/utils/GeometryRayIntersectUtilities.js
// converts the given BVH raycast intersection to align with the three.js raycast
// structure (include object, world space distance and point).
function convertRaycastIntersect( hit, object, raycaster ) {

	if ( hit === null ) {

		return null;

	}

	hit.point.applyMatrix4( object.matrixWorld );
	hit.distance = hit.point.distanceTo( raycaster.ray.origin );
	hit.object = object;

	if ( hit.distance < raycaster.near || hit.distance > raycaster.far ) {

		return null;

	} else {

		return hit;

	}

}

;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/utils/ExtensionUtilities.js




const ray = /* @__PURE__ */ new three_module/* Ray */.zHn();
const tmpInverseMatrix = /* @__PURE__ */ new three_module/* Matrix4 */.yGw();
const origMeshRaycastFunc = three_module/* Mesh */.Kj0.prototype.raycast;

function acceleratedRaycast( raycaster, intersects ) {

	if ( this.geometry.boundsTree ) {

		if ( this.material === undefined ) return;

		tmpInverseMatrix.copy( this.matrixWorld ).invert();
		ray.copy( raycaster.ray ).applyMatrix4( tmpInverseMatrix );

		const bvh = this.geometry.boundsTree;
		if ( raycaster.firstHitOnly === true ) {

			const hit = convertRaycastIntersect( bvh.raycastFirst( ray, this.material ), this, raycaster );
			if ( hit ) {

				intersects.push( hit );

			}

		} else {

			const hits = bvh.raycast( ray, this.material );
			for ( let i = 0, l = hits.length; i < l; i ++ ) {

				const hit = convertRaycastIntersect( hits[ i ], this, raycaster );
				if ( hit ) {

					intersects.push( hit );

				}

			}

		}

	} else {

		origMeshRaycastFunc.call( this, raycaster, intersects );

	}

}

function computeBoundsTree( options ) {

	this.boundsTree = new MeshBVH( this, options );
	return this.boundsTree;

}

function disposeBoundsTree() {

	this.boundsTree = null;

}

;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/gpu/VertexAttributeTexture.js


function countToStringFormat( count ) {

	switch ( count ) {

		case 1: return 'R';
		case 2: return 'RG';
		case 3: return 'RGBA';
		case 4: return 'RGBA';

	}

	throw new Error();

}

function countToFormat( count ) {

	switch ( count ) {

		case 1: return three_module/* RedFormat */.hEm;
		case 2: return three_module/* RGFormat */.av9;
		case 3: return three_module/* RGBAFormat */.wk1;
		case 4: return three_module/* RGBAFormat */.wk1;

	}

}

function countToIntFormat( count ) {

	switch ( count ) {

		case 1: return three_module/* RedIntegerFormat */.D9w;
		case 2: return three_module/* RGIntegerFormat */.CtA;
		case 3: return three_module/* RGBAIntegerFormat */.E2K;
		case 4: return three_module/* RGBAIntegerFormat */.E2K;

	}

}

class VertexAttributeTexture extends three_module/* DataTexture */.IEO {

	constructor() {

		super();
		this.minFilter = three_module/* NearestFilter */.TyD;
		this.magFilter = three_module/* NearestFilter */.TyD;
		this.generateMipmaps = false;
		this.overrideItemSize = null;
		this._forcedType = null;

	}

	updateFrom( attr ) {

		const overrideItemSize = this.overrideItemSize;
		const originalItemSize = attr.itemSize;
		const originalCount = attr.count;
		if ( overrideItemSize !== null ) {

			if ( ( originalItemSize * originalCount ) % overrideItemSize !== 0.0 ) {

				throw new Error( 'VertexAttributeTexture: overrideItemSize must divide evenly into buffer length.' );

			}

			attr.itemSize = overrideItemSize;
			attr.count = originalCount * originalItemSize / overrideItemSize;

		}

		const itemSize = attr.itemSize;
		const count = attr.count;
		const normalized = attr.normalized;
		const originalBufferCons = attr.array.constructor;
		const byteCount = originalBufferCons.BYTES_PER_ELEMENT;
		let targetType = this._forcedType;
		let finalStride = itemSize;

		// derive the type of texture this should be in the shader
		if ( targetType === null ) {

			switch ( originalBufferCons ) {

				case Float32Array:
					targetType = three_module/* FloatType */.VzW;
					break;

				case Uint8Array:
				case Uint16Array:
				case Uint32Array:
					targetType = three_module/* UnsignedIntType */.JQ4;
					break;

				case Int8Array:
				case Int16Array:
				case Int32Array:
					targetType = three_module/* IntType */.Kz5;
					break;

			}

		}

		// get the target format to store the texture as
		let type, format, normalizeValue, targetBufferCons;
		let internalFormat = countToStringFormat( itemSize );
		switch ( targetType ) {

			case three_module/* FloatType */.VzW:
				normalizeValue = 1.0;
				format = countToFormat( itemSize );

				if ( normalized && byteCount === 1 ) {

					targetBufferCons = originalBufferCons;
					internalFormat += '8';

					if ( originalBufferCons === Uint8Array ) {

						type = three_module/* UnsignedByteType */.ywz;

					} else {

						type = three_module/* ByteType */.T95;
						internalFormat += '_SNORM';

					}

				} else {

					targetBufferCons = Float32Array;
					internalFormat += '32F';
					type = three_module/* FloatType */.VzW;

				}

				break;

			case three_module/* IntType */.Kz5:
				internalFormat += byteCount * 8 + 'I';
				normalizeValue = normalized ? Math.pow( 2, originalBufferCons.BYTES_PER_ELEMENT * 8 - 1 ) : 1.0;
				format = countToIntFormat( itemSize );

				if ( byteCount === 1 ) {

					targetBufferCons = Int8Array;
					type = three_module/* ByteType */.T95;

				} else if ( byteCount === 2 ) {

					targetBufferCons = Int16Array;
					type = three_module/* ShortType */.iAb;

				} else {

					targetBufferCons = Int32Array;
					type = three_module/* IntType */.Kz5;

				}

				break;

			case three_module/* UnsignedIntType */.JQ4:
				internalFormat += byteCount * 8 + 'UI';
				normalizeValue = normalized ? Math.pow( 2, originalBufferCons.BYTES_PER_ELEMENT * 8 - 1 ) : 1.0;
				format = countToIntFormat( itemSize );

				if ( byteCount === 1 ) {

					targetBufferCons = Uint8Array;
					type = three_module/* UnsignedByteType */.ywz;

				} else if ( byteCount === 2 ) {

					targetBufferCons = Uint16Array;
					type = three_module/* UnsignedShortType */.LsT;

				} else {

					targetBufferCons = Uint32Array;
					type = three_module/* UnsignedIntType */.JQ4;

				}

				break;

		}

		// there will be a mismatch between format length and final length because
		// RGBFormat and RGBIntegerFormat was removed
		if ( finalStride === 3 && ( format === three_module/* RGBAFormat */.wk1 || format === three_module/* RGBAIntegerFormat */.E2K ) ) {

			finalStride = 4;

		}

		// copy the data over to the new texture array
		const dimension = Math.ceil( Math.sqrt( count ) ) || 1;
		const length = finalStride * dimension * dimension;
		const dataArray = new targetBufferCons( length );

		// temporarily set the normalized state to false since we have custom normalization logic
		const originalNormalized = attr.normalized;
		attr.normalized = false;
		for ( let i = 0; i < count; i ++ ) {

			const ii = finalStride * i;
			dataArray[ ii ] = attr.getX( i ) / normalizeValue;

			if ( itemSize >= 2 ) {

				dataArray[ ii + 1 ] = attr.getY( i ) / normalizeValue;

			}

			if ( itemSize >= 3 ) {

				dataArray[ ii + 2 ] = attr.getZ( i ) / normalizeValue;

				if ( finalStride === 4 ) {

					dataArray[ ii + 3 ] = 1.0;

				}

			}

			if ( itemSize >= 4 ) {

				dataArray[ ii + 3 ] = attr.getW( i ) / normalizeValue;

			}

		}

		attr.normalized = originalNormalized;

		this.internalFormat = internalFormat;
		this.format = format;
		this.type = type;
		this.image.width = dimension;
		this.image.height = dimension;
		this.image.data = dataArray;
		this.needsUpdate = true;
		this.dispose();

		attr.itemSize = originalItemSize;
		attr.count = originalCount;

	}

}

class UIntVertexAttributeTexture extends VertexAttributeTexture {

	constructor() {

		super();
		this._forcedType = three_module/* UnsignedIntType */.JQ4;

	}

}

class IntVertexAttributeTexture extends VertexAttributeTexture {

	constructor() {

		super();
		this._forcedType = three_module/* IntType */.Kz5;

	}


}

class FloatVertexAttributeTexture extends VertexAttributeTexture {

	constructor() {

		super();
		this._forcedType = three_module/* FloatType */.VzW;

	}

}

;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/gpu/MeshBVHUniformStruct.js






class MeshBVHUniformStruct {

	constructor() {

		this.index = new UIntVertexAttributeTexture();
		this.position = new FloatVertexAttributeTexture();
		this.bvhBounds = new three_module/* DataTexture */.IEO();
		this.bvhContents = new three_module/* DataTexture */.IEO();
		this._cachedIndexAttr = null;

		this.index.overrideItemSize = 3;

	}

	updateFrom( bvh ) {

		const { geometry } = bvh;
		bvhToTextures( bvh, this.bvhBounds, this.bvhContents );

		this.position.updateFrom( geometry.attributes.position );

		// dereference a new index attribute if we're using indirect storage
		if ( bvh.indirect ) {

			const indirectBuffer = bvh._indirectBuffer;
			if (
				this._cachedIndexAttr === null ||
				this._cachedIndexAttr.count !== indirectBuffer.length
			) {

				if ( geometry.index ) {

					this._cachedIndexAttr = geometry.index.clone();

				} else {

					const array = getIndexArray( getVertexCount( geometry ) );
					this._cachedIndexAttr = new three_module/* BufferAttribute */.TlE( array, 1, false );

				}

			}

			dereferenceIndex( geometry, indirectBuffer, this._cachedIndexAttr );
			this.index.updateFrom( this._cachedIndexAttr );

		} else {

			this.index.updateFrom( geometry.index );

		}

	}

	dispose() {

		const { index, position, bvhBounds, bvhContents } = this;

		if ( index ) index.dispose();
		if ( position ) position.dispose();
		if ( bvhBounds ) bvhBounds.dispose();
		if ( bvhContents ) bvhContents.dispose();

	}

}

function dereferenceIndex( geometry, indirectBuffer, target ) {

	const unpacked = target.array;
	const indexArray = geometry.index ? geometry.index.array : null;
	for ( let i = 0, l = indirectBuffer.length; i < l; i ++ ) {

		const i3 = 3 * i;
		const v3 = 3 * indirectBuffer[ i ];
		for ( let c = 0; c < 3; c ++ ) {

			unpacked[ i3 + c ] = indexArray ? indexArray[ v3 + c ] : v3 + c;

		}

	}

}

function bvhToTextures( bvh, boundsTexture, contentsTexture ) {

	const roots = bvh._roots;

	if ( roots.length !== 1 ) {

		throw new Error( 'MeshBVHUniformStruct: Multi-root BVHs not supported.' );

	}

	const root = roots[ 0 ];
	const uint16Array = new Uint16Array( root );
	const uint32Array = new Uint32Array( root );
	const float32Array = new Float32Array( root );

	// Both bounds need two elements per node so compute the height so it's twice as long as
	// the width so we can expand the row by two and still have a square texture
	const nodeCount = root.byteLength / BYTES_PER_NODE;
	const boundsDimension = 2 * Math.ceil( Math.sqrt( nodeCount / 2 ) );
	const boundsArray = new Float32Array( 4 * boundsDimension * boundsDimension );

	const contentsDimension = Math.ceil( Math.sqrt( nodeCount ) );
	const contentsArray = new Uint32Array( 2 * contentsDimension * contentsDimension );

	for ( let i = 0; i < nodeCount; i ++ ) {

		const nodeIndex32 = i * BYTES_PER_NODE / 4;
		const nodeIndex16 = nodeIndex32 * 2;
		const boundsIndex = BOUNDING_DATA_INDEX( nodeIndex32 );
		for ( let b = 0; b < 3; b ++ ) {

			boundsArray[ 8 * i + 0 + b ] = float32Array[ boundsIndex + 0 + b ];
			boundsArray[ 8 * i + 4 + b ] = float32Array[ boundsIndex + 3 + b ];

		}

		if ( IS_LEAF( nodeIndex16, uint16Array ) ) {

			const count = COUNT( nodeIndex16, uint16Array );
			const offset = OFFSET( nodeIndex32, uint32Array );

			const mergedLeafCount = 0xffff0000 | count;
			contentsArray[ i * 2 + 0 ] = mergedLeafCount;
			contentsArray[ i * 2 + 1 ] = offset;

		} else {

			const rightIndex = 4 * RIGHT_NODE( nodeIndex32, uint32Array ) / BYTES_PER_NODE;
			const splitAxis = SPLIT_AXIS( nodeIndex32, uint32Array );

			contentsArray[ i * 2 + 0 ] = splitAxis;
			contentsArray[ i * 2 + 1 ] = rightIndex;

		}

	}

	boundsTexture.image.data = boundsArray;
	boundsTexture.image.width = boundsDimension;
	boundsTexture.image.height = boundsDimension;
	boundsTexture.format = three_module/* RGBAFormat */.wk1;
	boundsTexture.type = three_module/* FloatType */.VzW;
	boundsTexture.internalFormat = 'RGBA32F';
	boundsTexture.minFilter = three_module/* NearestFilter */.TyD;
	boundsTexture.magFilter = three_module/* NearestFilter */.TyD;
	boundsTexture.generateMipmaps = false;
	boundsTexture.needsUpdate = true;
	boundsTexture.dispose();

	contentsTexture.image.data = contentsArray;
	contentsTexture.image.width = contentsDimension;
	contentsTexture.image.height = contentsDimension;
	contentsTexture.format = three_module/* RGIntegerFormat */.CtA;
	contentsTexture.type = three_module/* UnsignedIntType */.JQ4;
	contentsTexture.internalFormat = 'RG32UI';
	contentsTexture.minFilter = three_module/* NearestFilter */.TyD;
	contentsTexture.magFilter = three_module/* NearestFilter */.TyD;
	contentsTexture.generateMipmaps = false;
	contentsTexture.needsUpdate = true;
	contentsTexture.dispose();

}

;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/utils/StaticGeometryGenerator.js


const _positionVector = /*@__PURE__*/ new three_module/* Vector3 */.Pa4();
const _normalVector = /*@__PURE__*/ new three_module/* Vector3 */.Pa4();
const _tangentVector = /*@__PURE__*/ new three_module/* Vector3 */.Pa4();
const _tangentVector4 = /*@__PURE__*/ new three_module/* Vector4 */.Ltg();

const _morphVector = /*@__PURE__*/ new three_module/* Vector3 */.Pa4();
const _temp = /*@__PURE__*/ new three_module/* Vector3 */.Pa4();

const _skinIndex = /*@__PURE__*/ new three_module/* Vector4 */.Ltg();
const _skinWeight = /*@__PURE__*/ new three_module/* Vector4 */.Ltg();
const _matrix = /*@__PURE__*/ new three_module/* Matrix4 */.yGw();
const _boneMatrix = /*@__PURE__*/ new three_module/* Matrix4 */.yGw();

// Confirms that the two provided attributes are compatible
function validateAttributes( attr1, attr2 ) {

	if ( ! attr1 && ! attr2 ) {

		return;

	}

	const sameCount = attr1.count === attr2.count;
	const sameNormalized = attr1.normalized === attr2.normalized;
	const sameType = attr1.array.constructor === attr2.array.constructor;
	const sameItemSize = attr1.itemSize === attr2.itemSize;

	if ( ! sameCount || ! sameNormalized || ! sameType || ! sameItemSize ) {

		throw new Error();

	}

}

// Clones the given attribute with a new compatible buffer attribute but no data
function createAttributeClone( attr, countOverride = null ) {

	const cons = attr.array.constructor;
	const normalized = attr.normalized;
	const itemSize = attr.itemSize;
	const count = countOverride === null ? attr.count : countOverride;

	return new three_module/* BufferAttribute */.TlE( new cons( itemSize * count ), itemSize, normalized );

}

// target offset is the number of elements in the target buffer stride to skip before copying the
// attributes contents in to.
function copyAttributeContents( attr, target, targetOffset = 0 ) {

	if ( attr.isInterleavedBufferAttribute ) {

		const itemSize = attr.itemSize;
		for ( let i = 0, l = attr.count; i < l; i ++ ) {

			const io = i + targetOffset;
			target.setX( io, attr.getX( i ) );
			if ( itemSize >= 2 ) target.setY( io, attr.getY( i ) );
			if ( itemSize >= 3 ) target.setZ( io, attr.getZ( i ) );
			if ( itemSize >= 4 ) target.setW( io, attr.getW( i ) );

		}

	} else {

		const array = target.array;
		const cons = array.constructor;
		const byteOffset = array.BYTES_PER_ELEMENT * attr.itemSize * targetOffset;
		const temp = new cons( array.buffer, byteOffset, attr.array.length );
		temp.set( attr.array );

	}

}

// Adds the "matrix" multiplied by "scale" to "target"
function addScaledMatrix( target, matrix, scale ) {

	const targetArray = target.elements;
	const matrixArray = matrix.elements;
	for ( let i = 0, l = matrixArray.length; i < l; i ++ ) {

		targetArray[ i ] += matrixArray[ i ] * scale;

	}

}

// A version of "SkinnedMesh.boneTransform" for normals
function boneNormalTransform( mesh, index, target ) {

	const skeleton = mesh.skeleton;
	const geometry = mesh.geometry;
	const bones = skeleton.bones;
	const boneInverses = skeleton.boneInverses;

	_skinIndex.fromBufferAttribute( geometry.attributes.skinIndex, index );
	_skinWeight.fromBufferAttribute( geometry.attributes.skinWeight, index );

	_matrix.elements.fill( 0 );

	for ( let i = 0; i < 4; i ++ ) {

		const weight = _skinWeight.getComponent( i );

		if ( weight !== 0 ) {

			const boneIndex = _skinIndex.getComponent( i );
			_boneMatrix.multiplyMatrices( bones[ boneIndex ].matrixWorld, boneInverses[ boneIndex ] );

			addScaledMatrix( _matrix, _boneMatrix, weight );

		}

	}

	_matrix.multiply( mesh.bindMatrix ).premultiply( mesh.bindMatrixInverse );
	target.transformDirection( _matrix );

	return target;

}

// Applies the morph target data to the target vector
function applyMorphTarget( morphData, morphInfluences, morphTargetsRelative, i, target ) {

	_morphVector.set( 0, 0, 0 );
	for ( let j = 0, jl = morphData.length; j < jl; j ++ ) {

		const influence = morphInfluences[ j ];
		const morphAttribute = morphData[ j ];

		if ( influence === 0 ) continue;

		_temp.fromBufferAttribute( morphAttribute, i );

		if ( morphTargetsRelative ) {

			_morphVector.addScaledVector( _temp, influence );

		} else {

			_morphVector.addScaledVector( _temp.sub( target ), influence );

		}

	}

	target.add( _morphVector );

}

// Modified version of BufferGeometryUtils.mergeBufferGeometries that ignores morph targets and updates a attributes in place
function mergeBufferGeometries( geometries, options = { useGroups: false, updateIndex: false, skipAttributes: [] }, targetGeometry = new three_module/* BufferGeometry */.u9r() ) {

	const isIndexed = geometries[ 0 ].index !== null;
	const { useGroups = false, updateIndex = false, skipAttributes = [] } = options;

	const attributesUsed = new Set( Object.keys( geometries[ 0 ].attributes ) );
	const attributes = {};

	let offset = 0;

	targetGeometry.clearGroups();
	for ( let i = 0; i < geometries.length; ++ i ) {

		const geometry = geometries[ i ];
		let attributesCount = 0;

		// ensure that all geometries are indexed, or none
		if ( isIndexed !== ( geometry.index !== null ) ) {

			throw new Error( 'StaticGeometryGenerator: All geometries must have compatible attributes; make sure index attribute exists among all geometries, or in none of them.' );

		}

		// gather attributes, exit early if they're different
		for ( const name in geometry.attributes ) {

			if ( ! attributesUsed.has( name ) ) {

				throw new Error( 'StaticGeometryGenerator: All geometries must have compatible attributes; make sure "' + name + '" attribute exists among all geometries, or in none of them.' );

			}

			if ( attributes[ name ] === undefined ) {

				attributes[ name ] = [];

			}

			attributes[ name ].push( geometry.attributes[ name ] );
			attributesCount ++;

		}

		// ensure geometries have the same number of attributes
		if ( attributesCount !== attributesUsed.size ) {

			throw new Error( 'StaticGeometryGenerator: Make sure all geometries have the same number of attributes.' );

		}

		if ( useGroups ) {

			let count;
			if ( isIndexed ) {

				count = geometry.index.count;

			} else if ( geometry.attributes.position !== undefined ) {

				count = geometry.attributes.position.count;

			} else {

				throw new Error( 'StaticGeometryGenerator: The geometry must have either an index or a position attribute' );

			}

			targetGeometry.addGroup( offset, count, i );
			offset += count;

		}

	}

	// merge indices
	if ( isIndexed ) {

		let forceUpdateIndex = false;
		if ( ! targetGeometry.index ) {

			let indexCount = 0;
			for ( let i = 0; i < geometries.length; ++ i ) {

				indexCount += geometries[ i ].index.count;

			}

			targetGeometry.setIndex( new three_module/* BufferAttribute */.TlE( new Uint32Array( indexCount ), 1, false ) );
			forceUpdateIndex = true;

		}

		if ( updateIndex || forceUpdateIndex ) {

			const targetIndex = targetGeometry.index;
			let targetOffset = 0;
			let indexOffset = 0;
			for ( let i = 0; i < geometries.length; ++ i ) {

				const geometry = geometries[ i ];
				const index = geometry.index;
				if ( skipAttributes[ i ] !== true ) {

					for ( let j = 0; j < index.count; ++ j ) {

						targetIndex.setX( targetOffset, index.getX( j ) + indexOffset );
						targetOffset ++;

					}

				}

				indexOffset += geometry.attributes.position.count;

			}

		}

	}

	// merge attributes
	for ( const name in attributes ) {

		const attrList = attributes[ name ];
		if ( ! ( name in targetGeometry.attributes ) ) {

			let count = 0;
			for ( const key in attrList ) {

				count += attrList[ key ].count;

			}

			targetGeometry.setAttribute( name, createAttributeClone( attributes[ name ][ 0 ], count ) );

		}

		const targetAttribute = targetGeometry.attributes[ name ];
		let offset = 0;
		for ( let i = 0, l = attrList.length; i < l; i ++ ) {

			const attr = attrList[ i ];
			if ( skipAttributes[ i ] !== true ) {

				copyAttributeContents( attr, targetAttribute, offset );

			}

			offset += attr.count;

		}

	}

	return targetGeometry;

}

function checkTypedArrayEquality( a, b ) {

	if ( a === null || b === null ) {

		return a === b;

	}

	if ( a.length !== b.length ) {

		return false;

	}

	for ( let i = 0, l = a.length; i < l; i ++ ) {

		if ( a[ i ] !== b[ i ] ) {

			return false;

		}

	}

	return true;

}

function invertGeometry( geometry ) {

	const { index, attributes } = geometry;
	if ( index ) {

		for ( let i = 0, l = index.count; i < l; i += 3 ) {

			const v0 = index.getX( i );
			const v2 = index.getX( i + 2 );
			index.setX( i, v2 );
			index.setX( i + 2, v0 );

		}

	} else {

		for ( const key in attributes ) {

			const attr = attributes[ key ];
			const itemSize = attr.itemSize;
			for ( let i = 0, l = attr.count; i < l; i += 3 ) {

				for ( let j = 0; j < itemSize; j ++ ) {

					const v0 = attr.getComponent( i, j );
					const v2 = attr.getComponent( i + 2, j );
					attr.setComponent( i, j, v2 );
					attr.setComponent( i + 2, j, v0 );

				}

			}

		}

	}

	return geometry;


}

// Checks whether the geometry changed between this and last evaluation
class GeometryDiff {

	constructor( mesh ) {

		this.matrixWorld = new three_module/* Matrix4 */.yGw();
		this.geometryHash = null;
		this.boneMatrices = null;
		this.primitiveCount = - 1;
		this.mesh = mesh;

		this.update();

	}

	update() {

		const mesh = this.mesh;
		const geometry = mesh.geometry;
		const skeleton = mesh.skeleton;
		const primitiveCount = ( geometry.index ? geometry.index.count : geometry.attributes.position.count ) / 3;
		this.matrixWorld.copy( mesh.matrixWorld );
		this.geometryHash = geometry.attributes.position.version;
		this.primitiveCount = primitiveCount;

		if ( skeleton ) {

			// ensure the bone matrix array is updated to the appropriate length
			if ( ! skeleton.boneTexture ) {

				skeleton.computeBoneTexture();

			}

			skeleton.update();

			// copy data if possible otherwise clone it
			const boneMatrices = skeleton.boneMatrices;
			if ( ! this.boneMatrices || this.boneMatrices.length !== boneMatrices.length ) {

				this.boneMatrices = boneMatrices.slice();

			} else {

				this.boneMatrices.set( boneMatrices );

			}

		} else {

			this.boneMatrices = null;

		}

	}

	didChange() {

		const mesh = this.mesh;
		const geometry = mesh.geometry;
		const primitiveCount = ( geometry.index ? geometry.index.count : geometry.attributes.position.count ) / 3;
		const identical =
			this.matrixWorld.equals( mesh.matrixWorld ) &&
			this.geometryHash === geometry.attributes.position.version &&
			checkTypedArrayEquality( mesh.skeleton && mesh.skeleton.boneMatrices || null, this.boneMatrices ) &&
			this.primitiveCount === primitiveCount;

		return ! identical;

	}

}

class StaticGeometryGenerator {

	constructor( meshes ) {

		if ( ! Array.isArray( meshes ) ) {

			meshes = [ meshes ];

		}

		const finalMeshes = [];
		meshes.forEach( object => {

			object.traverseVisible( c => {

				if ( c.isMesh ) {

					finalMeshes.push( c );

				}

			} );

		} );

		this.meshes = finalMeshes;
		this.useGroups = true;
		this.applyWorldTransforms = true;
		this.attributes = [ 'position', 'normal', 'color', 'tangent', 'uv', 'uv2' ];
		this._intermediateGeometry = new Array( finalMeshes.length ).fill().map( () => new three_module/* BufferGeometry */.u9r() );
		this._diffMap = new WeakMap();

	}

	getMaterials() {

		const materials = [];
		this.meshes.forEach( mesh => {

			if ( Array.isArray( mesh.material ) ) {

				materials.push( ...mesh.material );

			} else {

				materials.push( mesh.material );

			}

		} );
		return materials;

	}

	generate( targetGeometry = new three_module/* BufferGeometry */.u9r() ) {

		// track which attributes have been updated and which to skip to avoid unnecessary attribute copies
		let skipAttributes = [];
		const { meshes, useGroups, _intermediateGeometry, _diffMap } = this;
		for ( let i = 0, l = meshes.length; i < l; i ++ ) {

			const mesh = meshes[ i ];
			const geom = _intermediateGeometry[ i ];
			const diff = _diffMap.get( mesh );
			if ( ! diff || diff.didChange( mesh ) ) {

				this._convertToStaticGeometry( mesh, geom );
				skipAttributes.push( false );

				if ( ! diff ) {

					_diffMap.set( mesh, new GeometryDiff( mesh ) );

				} else {

					diff.update();

				}

			} else {

				skipAttributes.push( true );

			}

		}

		if ( _intermediateGeometry.length === 0 ) {

			// if there are no geometries then just create a fake empty geometry to provide
			targetGeometry.setIndex( null );

			// remove all geometry
			const attrs = targetGeometry.attributes;
			for ( const key in attrs ) {

				targetGeometry.deleteAttribute( key );

			}

			// create dummy attributes
			for ( const key in this.attributes ) {

				targetGeometry.setAttribute( this.attributes[ key ], new three_module/* BufferAttribute */.TlE( new Float32Array( 0 ), 4, false ) );

			}

		} else {

			mergeBufferGeometries( _intermediateGeometry, { useGroups, skipAttributes }, targetGeometry );

		}

		for ( const key in targetGeometry.attributes ) {

			targetGeometry.attributes[ key ].needsUpdate = true;

		}

		return targetGeometry;

	}

	_convertToStaticGeometry( mesh, targetGeometry = new three_module/* BufferGeometry */.u9r() ) {

		const geometry = mesh.geometry;
		const applyWorldTransforms = this.applyWorldTransforms;
		const includeNormal = this.attributes.includes( 'normal' );
		const includeTangent = this.attributes.includes( 'tangent' );
		const attributes = geometry.attributes;
		const targetAttributes = targetGeometry.attributes;

		// initialize the attributes if they don't exist
		if ( ! targetGeometry.index && geometry.index ) {

			targetGeometry.index = geometry.index.clone();

		}

		if ( ! targetAttributes.position ) {

			targetGeometry.setAttribute( 'position', createAttributeClone( attributes.position ) );

		}

		if ( includeNormal && ! targetAttributes.normal && attributes.normal ) {

			targetGeometry.setAttribute( 'normal', createAttributeClone( attributes.normal ) );

		}

		if ( includeTangent && ! targetAttributes.tangent && attributes.tangent ) {

			targetGeometry.setAttribute( 'tangent', createAttributeClone( attributes.tangent ) );

		}

		// ensure the attributes are consistent
		validateAttributes( geometry.index, targetGeometry.index );
		validateAttributes( attributes.position, targetAttributes.position );

		if ( includeNormal ) {

			validateAttributes( attributes.normal, targetAttributes.normal );

		}

		if ( includeTangent ) {

			validateAttributes( attributes.tangent, targetAttributes.tangent );

		}

		// generate transformed vertex attribute data
		const position = attributes.position;
		const normal = includeNormal ? attributes.normal : null;
		const tangent = includeTangent ? attributes.tangent : null;
		const morphPosition = geometry.morphAttributes.position;
		const morphNormal = geometry.morphAttributes.normal;
		const morphTangent = geometry.morphAttributes.tangent;
		const morphTargetsRelative = geometry.morphTargetsRelative;
		const morphInfluences = mesh.morphTargetInfluences;
		const normalMatrix = new three_module/* Matrix3 */.Vkp();
		normalMatrix.getNormalMatrix( mesh.matrixWorld );

		// copy the index
		if ( geometry.index ) {

			targetGeometry.index.array.set( geometry.index.array );

		}

		// copy and apply other attributes
		for ( let i = 0, l = attributes.position.count; i < l; i ++ ) {

			_positionVector.fromBufferAttribute( position, i );
			if ( normal ) {

				_normalVector.fromBufferAttribute( normal, i );

			}

			if ( tangent ) {

				_tangentVector4.fromBufferAttribute( tangent, i );
				_tangentVector.fromBufferAttribute( tangent, i );

			}

			// apply morph target transform
			if ( morphInfluences ) {

				if ( morphPosition ) {

					applyMorphTarget( morphPosition, morphInfluences, morphTargetsRelative, i, _positionVector );

				}

				if ( morphNormal ) {

					applyMorphTarget( morphNormal, morphInfluences, morphTargetsRelative, i, _normalVector );

				}

				if ( morphTangent ) {

					applyMorphTarget( morphTangent, morphInfluences, morphTargetsRelative, i, _tangentVector );

				}

			}

			// apply bone transform
			if ( mesh.isSkinnedMesh ) {

				mesh.applyBoneTransform( i, _positionVector );
				if ( normal ) {

					boneNormalTransform( mesh, i, _normalVector );

				}

				if ( tangent ) {

					boneNormalTransform( mesh, i, _tangentVector );

				}

			}

			// update the vectors of the attributes
			if ( applyWorldTransforms ) {

				_positionVector.applyMatrix4( mesh.matrixWorld );

			}

			targetAttributes.position.setXYZ( i, _positionVector.x, _positionVector.y, _positionVector.z );

			if ( normal ) {

				if ( applyWorldTransforms ) {

					_normalVector.applyNormalMatrix( normalMatrix );

				}

				targetAttributes.normal.setXYZ( i, _normalVector.x, _normalVector.y, _normalVector.z );

			}

			if ( tangent ) {

				if ( applyWorldTransforms ) {

					_tangentVector.transformDirection( mesh.matrixWorld );

				}

				targetAttributes.tangent.setXYZW( i, _tangentVector.x, _tangentVector.y, _tangentVector.z, _tangentVector4.w );

			}

		}

		// copy other attributes over
		for ( const i in this.attributes ) {

			const key = this.attributes[ i ];
			if ( key === 'position' || key === 'tangent' || key === 'normal' || ! ( key in attributes ) ) {

				continue;

			}

			if ( ! targetAttributes[ key ] ) {

				targetGeometry.setAttribute( key, createAttributeClone( attributes[ key ] ) );

			}

			validateAttributes( attributes[ key ], targetAttributes[ key ] );
			copyAttributeContents( attributes[ key ], targetAttributes[ key ] );

		}

		if ( mesh.matrixWorld.determinant() < 0 ) {

			invertGeometry( targetGeometry );

		}

		return targetGeometry;

	}

}

;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/gpu/glsl/common_functions.glsl.js
const common_functions = /* glsl */`

// A stack of uint32 indices can can store the indices for
// a perfectly balanced tree with a depth up to 31. Lower stack
// depth gets higher performance.
//
// However not all trees are balanced. Best value to set this to
// is the trees max depth.
#ifndef BVH_STACK_DEPTH
#define BVH_STACK_DEPTH 60
#endif

#ifndef INFINITY
#define INFINITY 1e20
#endif

// Utilities
uvec4 uTexelFetch1D( usampler2D tex, uint index ) {

	uint width = uint( textureSize( tex, 0 ).x );
	uvec2 uv;
	uv.x = index % width;
	uv.y = index / width;

	return texelFetch( tex, ivec2( uv ), 0 );

}

ivec4 iTexelFetch1D( isampler2D tex, uint index ) {

	uint width = uint( textureSize( tex, 0 ).x );
	uvec2 uv;
	uv.x = index % width;
	uv.y = index / width;

	return texelFetch( tex, ivec2( uv ), 0 );

}

vec4 texelFetch1D( sampler2D tex, uint index ) {

	uint width = uint( textureSize( tex, 0 ).x );
	uvec2 uv;
	uv.x = index % width;
	uv.y = index / width;

	return texelFetch( tex, ivec2( uv ), 0 );

}

vec4 textureSampleBarycoord( sampler2D tex, vec3 barycoord, uvec3 faceIndices ) {

	return
		barycoord.x * texelFetch1D( tex, faceIndices.x ) +
		barycoord.y * texelFetch1D( tex, faceIndices.y ) +
		barycoord.z * texelFetch1D( tex, faceIndices.z );

}

void ndcToCameraRay(
	vec2 coord, mat4 cameraWorld, mat4 invProjectionMatrix,
	out vec3 rayOrigin, out vec3 rayDirection
) {

	// get camera look direction and near plane for camera clipping
	vec4 lookDirection = cameraWorld * vec4( 0.0, 0.0, - 1.0, 0.0 );
	vec4 nearVector = invProjectionMatrix * vec4( 0.0, 0.0, - 1.0, 1.0 );
	float near = abs( nearVector.z / nearVector.w );

	// get the camera direction and position from camera matrices
	vec4 origin = cameraWorld * vec4( 0.0, 0.0, 0.0, 1.0 );
	vec4 direction = invProjectionMatrix * vec4( coord, 0.5, 1.0 );
	direction /= direction.w;
	direction = cameraWorld * direction - origin;

	// slide the origin along the ray until it sits at the near clip plane position
	origin.xyz += direction.xyz * near / dot( direction, lookDirection );

	rayOrigin = origin.xyz;
	rayDirection = direction.xyz;

}
`;

;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/gpu/glsl/bvh_distance_functions.glsl.js
// Distance to Point
const bvh_distance_functions = /* glsl */`

float dot2( vec3 v ) {

	return dot( v, v );

}

// https://www.shadertoy.com/view/ttfGWl
vec3 closestPointToTriangle( vec3 p, vec3 v0, vec3 v1, vec3 v2, out vec3 barycoord ) {

    vec3 v10 = v1 - v0;
    vec3 v21 = v2 - v1;
    vec3 v02 = v0 - v2;

	vec3 p0 = p - v0;
	vec3 p1 = p - v1;
	vec3 p2 = p - v2;

    vec3 nor = cross( v10, v02 );

    // method 2, in barycentric space
    vec3  q = cross( nor, p0 );
    float d = 1.0 / dot2( nor );
    float u = d * dot( q, v02 );
    float v = d * dot( q, v10 );
    float w = 1.0 - u - v;

	if( u < 0.0 ) {

		w = clamp( dot( p2, v02 ) / dot2( v02 ), 0.0, 1.0 );
		u = 0.0;
		v = 1.0 - w;

	} else if( v < 0.0 ) {

		u = clamp( dot( p0, v10 ) / dot2( v10 ), 0.0, 1.0 );
		v = 0.0;
		w = 1.0 - u;

	} else if( w < 0.0 ) {

		v = clamp( dot( p1, v21 ) / dot2( v21 ), 0.0, 1.0 );
		w = 0.0;
		u = 1.0-v;

	}

	barycoord = vec3( u, v, w );
    return u * v1 + v * v2 + w * v0;

}

float distanceToTriangles(
	// geometry info and triangle range
	sampler2D positionAttr, usampler2D indexAttr, uint offset, uint count,

	// point and cut off range
	vec3 point, float closestDistanceSquared,

	// outputs
	inout uvec4 faceIndices, inout vec3 faceNormal, inout vec3 barycoord, inout float side, inout vec3 outPoint
) {

	bool found = false;
	vec3 localBarycoord;
	for ( uint i = offset, l = offset + count; i < l; i ++ ) {

		uvec3 indices = uTexelFetch1D( indexAttr, i ).xyz;
		vec3 a = texelFetch1D( positionAttr, indices.x ).rgb;
		vec3 b = texelFetch1D( positionAttr, indices.y ).rgb;
		vec3 c = texelFetch1D( positionAttr, indices.z ).rgb;

		// get the closest point and barycoord
		vec3 closestPoint = closestPointToTriangle( point, a, b, c, localBarycoord );
		vec3 delta = point - closestPoint;
		float sqDist = dot2( delta );
		if ( sqDist < closestDistanceSquared ) {

			// set the output results
			closestDistanceSquared = sqDist;
			faceIndices = uvec4( indices.xyz, i );
			faceNormal = normalize( cross( a - b, b - c ) );
			barycoord = localBarycoord;
			outPoint = closestPoint;
			side = sign( dot( faceNormal, delta ) );

		}

	}

	return closestDistanceSquared;

}

float distanceSqToBounds( vec3 point, vec3 boundsMin, vec3 boundsMax ) {

	vec3 clampedPoint = clamp( point, boundsMin, boundsMax );
	vec3 delta = point - clampedPoint;
	return dot( delta, delta );

}

float distanceSqToBVHNodeBoundsPoint( vec3 point, sampler2D bvhBounds, uint currNodeIndex ) {

	uint cni2 = currNodeIndex * 2u;
	vec3 boundsMin = texelFetch1D( bvhBounds, cni2 ).xyz;
	vec3 boundsMax = texelFetch1D( bvhBounds, cni2 + 1u ).xyz;
	return distanceSqToBounds( point, boundsMin, boundsMax );

}

// use a macro to hide the fact that we need to expand the struct into separate fields
#define\
	bvhClosestPointToPoint(\
		bvh,\
		point, faceIndices, faceNormal, barycoord, side, outPoint\
	)\
	_bvhClosestPointToPoint(\
		bvh.position, bvh.index, bvh.bvhBounds, bvh.bvhContents,\
		point, faceIndices, faceNormal, barycoord, side, outPoint\
	)

float _bvhClosestPointToPoint(
	// bvh info
	sampler2D bvh_position, usampler2D bvh_index, sampler2D bvh_bvhBounds, usampler2D bvh_bvhContents,

	// point to check
	vec3 point,

	// output variables
	inout uvec4 faceIndices, inout vec3 faceNormal, inout vec3 barycoord,
	inout float side, inout vec3 outPoint
 ) {

	// stack needs to be twice as long as the deepest tree we expect because
	// we push both the left and right child onto the stack every traversal
	int ptr = 0;
	uint stack[ BVH_STACK_DEPTH ];
	stack[ 0 ] = 0u;

	float closestDistanceSquared = pow( 100000.0, 2.0 );
	bool found = false;
	while ( ptr > - 1 && ptr < BVH_STACK_DEPTH ) {

		uint currNodeIndex = stack[ ptr ];
		ptr --;

		// check if we intersect the current bounds
		float boundsHitDistance = distanceSqToBVHNodeBoundsPoint( point, bvh_bvhBounds, currNodeIndex );
		if ( boundsHitDistance > closestDistanceSquared ) {

			continue;

		}

		uvec2 boundsInfo = uTexelFetch1D( bvh_bvhContents, currNodeIndex ).xy;
		bool isLeaf = bool( boundsInfo.x & 0xffff0000u );
		if ( isLeaf ) {

			uint count = boundsInfo.x & 0x0000ffffu;
			uint offset = boundsInfo.y;
			closestDistanceSquared = distanceToTriangles(
				bvh_position, bvh_index, offset, count, point, closestDistanceSquared,

				// outputs
				faceIndices, faceNormal, barycoord, side, outPoint
			);

		} else {

			uint leftIndex = currNodeIndex + 1u;
			uint splitAxis = boundsInfo.x & 0x0000ffffu;
			uint rightIndex = boundsInfo.y;
			bool leftToRight = distanceSqToBVHNodeBoundsPoint( point, bvh_bvhBounds, leftIndex ) < distanceSqToBVHNodeBoundsPoint( point, bvh_bvhBounds, rightIndex );//rayDirection[ splitAxis ] >= 0.0;
			uint c1 = leftToRight ? leftIndex : rightIndex;
			uint c2 = leftToRight ? rightIndex : leftIndex;

			// set c2 in the stack so we traverse it later. We need to keep track of a pointer in
			// the stack while we traverse. The second pointer added is the one that will be
			// traversed first
			ptr ++;
			stack[ ptr ] = c2;
			ptr ++;
			stack[ ptr ] = c1;

		}

	}

	return sqrt( closestDistanceSquared );

}
`;

;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/gpu/glsl/bvh_ray_functions.glsl.js
const bvh_ray_functions = /* glsl */`

#ifndef TRI_INTERSECT_EPSILON
#define TRI_INTERSECT_EPSILON 1e-5
#endif

// Raycasting
bool intersectsBounds( vec3 rayOrigin, vec3 rayDirection, vec3 boundsMin, vec3 boundsMax, out float dist ) {

	// https://www.reddit.com/r/opengl/comments/8ntzz5/fast_glsl_ray_box_intersection/
	// https://tavianator.com/2011/ray_box.html
	vec3 invDir = 1.0 / rayDirection;

	// find intersection distances for each plane
	vec3 tMinPlane = invDir * ( boundsMin - rayOrigin );
	vec3 tMaxPlane = invDir * ( boundsMax - rayOrigin );

	// get the min and max distances from each intersection
	vec3 tMinHit = min( tMaxPlane, tMinPlane );
	vec3 tMaxHit = max( tMaxPlane, tMinPlane );

	// get the furthest hit distance
	vec2 t = max( tMinHit.xx, tMinHit.yz );
	float t0 = max( t.x, t.y );

	// get the minimum hit distance
	t = min( tMaxHit.xx, tMaxHit.yz );
	float t1 = min( t.x, t.y );

	// set distance to 0.0 if the ray starts inside the box
	dist = max( t0, 0.0 );

	return t1 >= dist;

}

bool intersectsTriangle(
	vec3 rayOrigin, vec3 rayDirection, vec3 a, vec3 b, vec3 c,
	out vec3 barycoord, out vec3 norm, out float dist, out float side
) {

	// https://stackoverflow.com/questions/42740765/intersection-between-line-and-triangle-in-3d
	vec3 edge1 = b - a;
	vec3 edge2 = c - a;
	norm = cross( edge1, edge2 );

	float det = - dot( rayDirection, norm );
	float invdet = 1.0 / det;

	vec3 AO = rayOrigin - a;
	vec3 DAO = cross( AO, rayDirection );

	vec4 uvt;
	uvt.x = dot( edge2, DAO ) * invdet;
	uvt.y = - dot( edge1, DAO ) * invdet;
	uvt.z = dot( AO, norm ) * invdet;
	uvt.w = 1.0 - uvt.x - uvt.y;

	// set the hit information
	barycoord = uvt.wxy; // arranged in A, B, C order
	dist = uvt.z;
	side = sign( det );
	norm = side * normalize( norm );

	// add an epsilon to avoid misses between triangles
	uvt += vec4( TRI_INTERSECT_EPSILON );

	return all( greaterThanEqual( uvt, vec4( 0.0 ) ) );

}

bool intersectTriangles(
	// geometry info and triangle range
	sampler2D positionAttr, usampler2D indexAttr, uint offset, uint count,

	// ray
	vec3 rayOrigin, vec3 rayDirection,

	// outputs
	inout float minDistance, inout uvec4 faceIndices, inout vec3 faceNormal, inout vec3 barycoord,
	inout float side, inout float dist
) {

	bool found = false;
	vec3 localBarycoord, localNormal;
	float localDist, localSide;
	for ( uint i = offset, l = offset + count; i < l; i ++ ) {

		uvec3 indices = uTexelFetch1D( indexAttr, i ).xyz;
		vec3 a = texelFetch1D( positionAttr, indices.x ).rgb;
		vec3 b = texelFetch1D( positionAttr, indices.y ).rgb;
		vec3 c = texelFetch1D( positionAttr, indices.z ).rgb;

		if (
			intersectsTriangle( rayOrigin, rayDirection, a, b, c, localBarycoord, localNormal, localDist, localSide )
			&& localDist < minDistance
		) {

			found = true;
			minDistance = localDist;

			faceIndices = uvec4( indices.xyz, i );
			faceNormal = localNormal;

			side = localSide;
			barycoord = localBarycoord;
			dist = localDist;

		}

	}

	return found;

}

bool intersectsBVHNodeBounds( vec3 rayOrigin, vec3 rayDirection, sampler2D bvhBounds, uint currNodeIndex, out float dist ) {

	uint cni2 = currNodeIndex * 2u;
	vec3 boundsMin = texelFetch1D( bvhBounds, cni2 ).xyz;
	vec3 boundsMax = texelFetch1D( bvhBounds, cni2 + 1u ).xyz;
	return intersectsBounds( rayOrigin, rayDirection, boundsMin, boundsMax, dist );

}

// use a macro to hide the fact that we need to expand the struct into separate fields
#define\
	bvhIntersectFirstHit(\
		bvh,\
		rayOrigin, rayDirection, faceIndices, faceNormal, barycoord, side, dist\
	)\
	_bvhIntersectFirstHit(\
		bvh.position, bvh.index, bvh.bvhBounds, bvh.bvhContents,\
		rayOrigin, rayDirection, faceIndices, faceNormal, barycoord, side, dist\
	)

bool _bvhIntersectFirstHit(
	// bvh info
	sampler2D bvh_position, usampler2D bvh_index, sampler2D bvh_bvhBounds, usampler2D bvh_bvhContents,

	// ray
	vec3 rayOrigin, vec3 rayDirection,

	// output variables split into separate variables due to output precision
	inout uvec4 faceIndices, inout vec3 faceNormal, inout vec3 barycoord,
	inout float side, inout float dist
) {

	// stack needs to be twice as long as the deepest tree we expect because
	// we push both the left and right child onto the stack every traversal
	int ptr = 0;
	uint stack[ BVH_STACK_DEPTH ];
	stack[ 0 ] = 0u;

	float triangleDistance = INFINITY;
	bool found = false;
	while ( ptr > - 1 && ptr < BVH_STACK_DEPTH ) {

		uint currNodeIndex = stack[ ptr ];
		ptr --;

		// check if we intersect the current bounds
		float boundsHitDistance;
		if (
			! intersectsBVHNodeBounds( rayOrigin, rayDirection, bvh_bvhBounds, currNodeIndex, boundsHitDistance )
			|| boundsHitDistance > triangleDistance
		) {

			continue;

		}

		uvec2 boundsInfo = uTexelFetch1D( bvh_bvhContents, currNodeIndex ).xy;
		bool isLeaf = bool( boundsInfo.x & 0xffff0000u );

		if ( isLeaf ) {

			uint count = boundsInfo.x & 0x0000ffffu;
			uint offset = boundsInfo.y;

			found = intersectTriangles(
				bvh_position, bvh_index, offset, count,
				rayOrigin, rayDirection, triangleDistance,
				faceIndices, faceNormal, barycoord, side, dist
			) || found;

		} else {

			uint leftIndex = currNodeIndex + 1u;
			uint splitAxis = boundsInfo.x & 0x0000ffffu;
			uint rightIndex = boundsInfo.y;

			bool leftToRight = rayDirection[ splitAxis ] >= 0.0;
			uint c1 = leftToRight ? leftIndex : rightIndex;
			uint c2 = leftToRight ? rightIndex : leftIndex;

			// set c2 in the stack so we traverse it later. We need to keep track of a pointer in
			// the stack while we traverse. The second pointer added is the one that will be
			// traversed first
			ptr ++;
			stack[ ptr ] = c2;

			ptr ++;
			stack[ ptr ] = c1;

		}

	}

	return found;

}
`;

;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/gpu/glsl/bvh_struct_definitions.glsl.js
// Note that a struct cannot be used for the hit record including faceIndices, faceNormal, barycoord,
// side, and dist because on some mobile GPUS (such as Adreno) numbers are afforded less precision specifically
// when in a struct leading to inaccurate hit results. See KhronosGroup/WebGL#3351 for more details.
const bvh_struct_definitions = /* glsl */`
struct BVH {

	usampler2D index;
	sampler2D position;

	sampler2D bvhBounds;
	usampler2D bvhContents;

};
`;

;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/gpu/BVHShaderGLSL.js





;// CONCATENATED MODULE: ./node_modules/three-mesh-bvh/src/index.js













// backwards compatibility

const shaderStructs = bvh_struct_definitions;
const shaderDistanceFunction = bvh_distance_functions;
const shaderIntersectFunction = `
	${ common_functions }
	${ bvh_ray_functions }
`;


/***/ }),

/***/ 9477:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $V: () => (/* binding */ Spherical),
/* harmony export */   CJI: () => (/* binding */ Triangle),
/* harmony export */   CtA: () => (/* binding */ RGIntegerFormat),
/* harmony export */   D9w: () => (/* binding */ RedIntegerFormat),
/* harmony export */   E2K: () => (/* binding */ RGBAIntegerFormat),
/* harmony export */   FM8: () => (/* binding */ Vector2),
/* harmony export */   IEO: () => (/* binding */ DataTexture),
/* harmony export */   JOQ: () => (/* binding */ Plane),
/* harmony export */   JQ4: () => (/* binding */ UnsignedIntType),
/* harmony export */   Kj0: () => (/* binding */ Mesh),
/* harmony export */   Kz5: () => (/* binding */ IntType),
/* harmony export */   LsT: () => (/* binding */ UnsignedShortType),
/* harmony export */   Ltg: () => (/* binding */ Vector4),
/* harmony export */   M8C: () => (/* binding */ MathUtils),
/* harmony export */   Pa4: () => (/* binding */ Vector3),
/* harmony export */   T95: () => (/* binding */ ByteType),
/* harmony export */   TlE: () => (/* binding */ BufferAttribute),
/* harmony export */   Tme: () => (/* binding */ Object3D),
/* harmony export */   TyD: () => (/* binding */ NearestFilter),
/* harmony export */   UlW: () => (/* binding */ TriangleStripDrawMode),
/* harmony export */   Vkp: () => (/* binding */ Matrix3),
/* harmony export */   VzW: () => (/* binding */ FloatType),
/* harmony export */   Wl3: () => (/* binding */ FrontSide),
/* harmony export */   WwZ: () => (/* binding */ TrianglesDrawMode),
/* harmony export */   Xcj: () => (/* binding */ AnimationMixer),
/* harmony export */   ZAu: () => (/* binding */ Group),
/* harmony export */   ZzF: () => (/* binding */ Box3),
/* harmony export */   Zzh: () => (/* binding */ Line3),
/* harmony export */   _Li: () => (/* binding */ BackSide),
/* harmony export */   _fP: () => (/* binding */ Quaternion),
/* harmony export */   a$l: () => (/* binding */ Float32BufferAttribute),
/* harmony export */   aLr: () => (/* binding */ Sphere),
/* harmony export */   av9: () => (/* binding */ RGFormat),
/* harmony export */   ehD: () => (/* binding */ DoubleSide),
/* harmony export */   hEm: () => (/* binding */ RedFormat),
/* harmony export */   iAb: () => (/* binding */ ShortType),
/* harmony export */   iMs: () => (/* binding */ Raycaster),
/* harmony export */   kB5: () => (/* binding */ InterleavedBufferAttribute),
/* harmony export */   lb7: () => (/* binding */ InstancedBufferAttribute),
/* harmony export */   nls: () => (/* binding */ LineBasicMaterial),
/* harmony export */   pBf: () => (/* binding */ EventDispatcher),
/* harmony export */   u9r: () => (/* binding */ BufferGeometry),
/* harmony export */   vBJ: () => (/* binding */ MeshBasicMaterial),
/* harmony export */   vpT: () => (/* binding */ InterleavedBuffer),
/* harmony export */   wk1: () => (/* binding */ RGBAFormat),
/* harmony export */   yGw: () => (/* binding */ Matrix4),
/* harmony export */   ywz: () => (/* binding */ UnsignedByteType),
/* harmony export */   z$h: () => (/* binding */ TriangleFanDrawMode),
/* harmony export */   zHn: () => (/* binding */ Ray)
/* harmony export */ });
/* unused harmony exports ACESFilmicToneMapping, AddEquation, AddOperation, AdditiveAnimationBlendMode, AdditiveBlending, AgXToneMapping, AlphaFormat, AlwaysCompare, AlwaysDepth, AlwaysStencilFunc, AmbientLight, AnimationAction, AnimationClip, AnimationLoader, AnimationObjectGroup, AnimationUtils, ArcCurve, ArrayCamera, ArrowHelper, AttachedBindMode, Audio, AudioAnalyser, AudioContext, AudioListener, AudioLoader, AxesHelper, BasicDepthPacking, BasicShadowMap, BatchedMesh, Bone, BooleanKeyframeTrack, Box2, Box3Helper, BoxGeometry, BoxHelper, BufferGeometryLoader, Cache, Camera, CameraHelper, CanvasTexture, CapsuleGeometry, CatmullRomCurve3, CineonToneMapping, CircleGeometry, ClampToEdgeWrapping, Clock, Color, ColorKeyframeTrack, ColorManagement, CompressedArrayTexture, CompressedCubeTexture, CompressedTexture, CompressedTextureLoader, ConeGeometry, ConstantAlphaFactor, ConstantColorFactor, CubeCamera, CubeReflectionMapping, CubeRefractionMapping, CubeTexture, CubeTextureLoader, CubeUVReflectionMapping, CubicBezierCurve, CubicBezierCurve3, CubicInterpolant, CullFaceBack, CullFaceFront, CullFaceFrontBack, CullFaceNone, Curve, CurvePath, CustomBlending, CustomToneMapping, CylinderGeometry, Cylindrical, Data3DTexture, DataArrayTexture, DataTextureLoader, DataUtils, DecrementStencilOp, DecrementWrapStencilOp, DefaultLoadingManager, DepthFormat, DepthStencilFormat, DepthTexture, DetachedBindMode, DirectionalLight, DirectionalLightHelper, DiscreteInterpolant, DisplayP3ColorSpace, DodecahedronGeometry, DstAlphaFactor, DstColorFactor, DynamicCopyUsage, DynamicDrawUsage, DynamicReadUsage, EdgesGeometry, EllipseCurve, EqualCompare, EqualDepth, EqualStencilFunc, EquirectangularReflectionMapping, EquirectangularRefractionMapping, Euler, ExtrudeGeometry, FileLoader, Float16BufferAttribute, Fog, FogExp2, FramebufferTexture, Frustum, GLBufferAttribute, GLSL1, GLSL3, GreaterCompare, GreaterDepth, GreaterEqualCompare, GreaterEqualDepth, GreaterEqualStencilFunc, GreaterStencilFunc, GridHelper, HalfFloatType, HemisphereLight, HemisphereLightHelper, IcosahedronGeometry, ImageBitmapLoader, ImageLoader, ImageUtils, IncrementStencilOp, IncrementWrapStencilOp, InstancedBufferGeometry, InstancedInterleavedBuffer, InstancedMesh, Int16BufferAttribute, Int32BufferAttribute, Int8BufferAttribute, Interpolant, InterpolateDiscrete, InterpolateLinear, InterpolateSmooth, InvertStencilOp, KeepStencilOp, KeyframeTrack, LOD, LatheGeometry, Layers, LessCompare, LessDepth, LessEqualCompare, LessEqualDepth, LessEqualStencilFunc, LessStencilFunc, Light, LightProbe, Line, LineCurve, LineCurve3, LineDashedMaterial, LineLoop, LineSegments, LinearDisplayP3ColorSpace, LinearFilter, LinearInterpolant, LinearMipMapLinearFilter, LinearMipMapNearestFilter, LinearMipmapLinearFilter, LinearMipmapNearestFilter, LinearSRGBColorSpace, LinearToneMapping, LinearTransfer, Loader, LoaderUtils, LoadingManager, LoopOnce, LoopPingPong, LoopRepeat, LuminanceAlphaFormat, LuminanceFormat, MOUSE, Material, MaterialLoader, MaxEquation, MeshDepthMaterial, MeshDistanceMaterial, MeshLambertMaterial, MeshMatcapMaterial, MeshNormalMaterial, MeshPhongMaterial, MeshPhysicalMaterial, MeshStandardMaterial, MeshToonMaterial, MinEquation, MirroredRepeatWrapping, MixOperation, MultiplyBlending, MultiplyOperation, NearestMipMapLinearFilter, NearestMipMapNearestFilter, NearestMipmapLinearFilter, NearestMipmapNearestFilter, NeutralToneMapping, NeverCompare, NeverDepth, NeverStencilFunc, NoBlending, NoColorSpace, NoToneMapping, NormalAnimationBlendMode, NormalBlending, NotEqualCompare, NotEqualDepth, NotEqualStencilFunc, NumberKeyframeTrack, ObjectLoader, ObjectSpaceNormalMap, OctahedronGeometry, OneFactor, OneMinusConstantAlphaFactor, OneMinusConstantColorFactor, OneMinusDstAlphaFactor, OneMinusDstColorFactor, OneMinusSrcAlphaFactor, OneMinusSrcColorFactor, OrthographicCamera, P3Primaries, PCFShadowMap, PCFSoftShadowMap, PMREMGenerator, Path, PerspectiveCamera, PlaneGeometry, PlaneHelper, PointLight, PointLightHelper, Points, PointsMaterial, PolarGridHelper, PolyhedronGeometry, PositionalAudio, PropertyBinding, PropertyMixer, QuadraticBezierCurve, QuadraticBezierCurve3, QuaternionKeyframeTrack, QuaternionLinearInterpolant, RED_GREEN_RGTC2_Format, RED_RGTC1_Format, REVISION, RGBADepthPacking, RGBA_ASTC_10x10_Format, RGBA_ASTC_10x5_Format, RGBA_ASTC_10x6_Format, RGBA_ASTC_10x8_Format, RGBA_ASTC_12x10_Format, RGBA_ASTC_12x12_Format, RGBA_ASTC_4x4_Format, RGBA_ASTC_5x4_Format, RGBA_ASTC_5x5_Format, RGBA_ASTC_6x5_Format, RGBA_ASTC_6x6_Format, RGBA_ASTC_8x5_Format, RGBA_ASTC_8x6_Format, RGBA_ASTC_8x8_Format, RGBA_BPTC_Format, RGBA_ETC2_EAC_Format, RGBA_PVRTC_2BPPV1_Format, RGBA_PVRTC_4BPPV1_Format, RGBA_S3TC_DXT1_Format, RGBA_S3TC_DXT3_Format, RGBA_S3TC_DXT5_Format, RGBFormat, RGB_BPTC_SIGNED_Format, RGB_BPTC_UNSIGNED_Format, RGB_ETC1_Format, RGB_ETC2_Format, RGB_PVRTC_2BPPV1_Format, RGB_PVRTC_4BPPV1_Format, RGB_S3TC_DXT1_Format, RawShaderMaterial, Rec709Primaries, RectAreaLight, ReinhardToneMapping, RenderTarget, RepeatWrapping, ReplaceStencilOp, ReverseSubtractEquation, RingGeometry, SIGNED_RED_GREEN_RGTC2_Format, SIGNED_RED_RGTC1_Format, SRGBColorSpace, SRGBTransfer, Scene, ShaderChunk, ShaderLib, ShaderMaterial, ShadowMaterial, Shape, ShapeGeometry, ShapePath, ShapeUtils, Skeleton, SkeletonHelper, SkinnedMesh, Source, SphereGeometry, SphericalHarmonics3, SplineCurve, SpotLight, SpotLightHelper, Sprite, SpriteMaterial, SrcAlphaFactor, SrcAlphaSaturateFactor, SrcColorFactor, StaticCopyUsage, StaticDrawUsage, StaticReadUsage, StereoCamera, StreamCopyUsage, StreamDrawUsage, StreamReadUsage, StringKeyframeTrack, SubtractEquation, SubtractiveBlending, TOUCH, TangentSpaceNormalMap, TetrahedronGeometry, Texture, TextureLoader, TorusGeometry, TorusKnotGeometry, TubeGeometry, UVMapping, Uint16BufferAttribute, Uint32BufferAttribute, Uint8BufferAttribute, Uint8ClampedBufferAttribute, Uniform, UniformsGroup, UniformsLib, UniformsUtils, UnsignedInt248Type, UnsignedInt5999Type, UnsignedShort4444Type, UnsignedShort5551Type, VSMShadowMap, VectorKeyframeTrack, VideoTexture, WebGL3DRenderTarget, WebGLArrayRenderTarget, WebGLCoordinateSystem, WebGLCubeRenderTarget, WebGLMultipleRenderTargets, WebGLRenderTarget, WebGLRenderer, WebGLUtils, WebGPUCoordinateSystem, WireframeGeometry, WrapAroundEnding, ZeroCurvatureEnding, ZeroFactor, ZeroSlopeEnding, ZeroStencilOp, createCanvasElement */
/**
 * @license
 * Copyright 2010-2023 Three.js Authors
 * SPDX-License-Identifier: MIT
 */
const REVISION = '163';

const MOUSE = { LEFT: 0, MIDDLE: 1, RIGHT: 2, ROTATE: 0, DOLLY: 1, PAN: 2 };
const TOUCH = { ROTATE: 0, PAN: 1, DOLLY_PAN: 2, DOLLY_ROTATE: 3 };
const CullFaceNone = 0;
const CullFaceBack = 1;
const CullFaceFront = 2;
const CullFaceFrontBack = 3;
const BasicShadowMap = 0;
const PCFShadowMap = 1;
const PCFSoftShadowMap = 2;
const VSMShadowMap = 3;
const FrontSide = 0;
const BackSide = 1;
const DoubleSide = 2;
const NoBlending = 0;
const NormalBlending = 1;
const AdditiveBlending = 2;
const SubtractiveBlending = 3;
const MultiplyBlending = 4;
const CustomBlending = 5;
const AddEquation = 100;
const SubtractEquation = 101;
const ReverseSubtractEquation = 102;
const MinEquation = 103;
const MaxEquation = 104;
const ZeroFactor = 200;
const OneFactor = 201;
const SrcColorFactor = 202;
const OneMinusSrcColorFactor = 203;
const SrcAlphaFactor = 204;
const OneMinusSrcAlphaFactor = 205;
const DstAlphaFactor = 206;
const OneMinusDstAlphaFactor = 207;
const DstColorFactor = 208;
const OneMinusDstColorFactor = 209;
const SrcAlphaSaturateFactor = 210;
const ConstantColorFactor = 211;
const OneMinusConstantColorFactor = 212;
const ConstantAlphaFactor = 213;
const OneMinusConstantAlphaFactor = 214;
const NeverDepth = 0;
const AlwaysDepth = 1;
const LessDepth = 2;
const LessEqualDepth = 3;
const EqualDepth = 4;
const GreaterEqualDepth = 5;
const GreaterDepth = 6;
const NotEqualDepth = 7;
const MultiplyOperation = 0;
const MixOperation = 1;
const AddOperation = 2;
const NoToneMapping = 0;
const LinearToneMapping = 1;
const ReinhardToneMapping = 2;
const CineonToneMapping = 3;
const ACESFilmicToneMapping = 4;
const CustomToneMapping = 5;
const AgXToneMapping = 6;
const NeutralToneMapping = 7;
const AttachedBindMode = 'attached';
const DetachedBindMode = 'detached';

const UVMapping = 300;
const CubeReflectionMapping = 301;
const CubeRefractionMapping = 302;
const EquirectangularReflectionMapping = 303;
const EquirectangularRefractionMapping = 304;
const CubeUVReflectionMapping = 306;
const RepeatWrapping = 1000;
const ClampToEdgeWrapping = 1001;
const MirroredRepeatWrapping = 1002;
const NearestFilter = 1003;
const NearestMipmapNearestFilter = 1004;
const NearestMipMapNearestFilter = 1004;
const NearestMipmapLinearFilter = 1005;
const NearestMipMapLinearFilter = 1005;
const LinearFilter = 1006;
const LinearMipmapNearestFilter = 1007;
const LinearMipMapNearestFilter = 1007;
const LinearMipmapLinearFilter = 1008;
const LinearMipMapLinearFilter = 1008;
const UnsignedByteType = 1009;
const ByteType = 1010;
const ShortType = 1011;
const UnsignedShortType = 1012;
const IntType = 1013;
const UnsignedIntType = 1014;
const FloatType = 1015;
const HalfFloatType = 1016;
const UnsignedShort4444Type = 1017;
const UnsignedShort5551Type = 1018;
const UnsignedInt248Type = 1020;
const UnsignedInt5999Type = 35902;
const AlphaFormat = 1021;
const RGBFormat = 1022;
const RGBAFormat = 1023;
const LuminanceFormat = 1024;
const LuminanceAlphaFormat = 1025;
const DepthFormat = 1026;
const DepthStencilFormat = 1027;
const RedFormat = 1028;
const RedIntegerFormat = 1029;
const RGFormat = 1030;
const RGIntegerFormat = 1031;
const RGBAIntegerFormat = 1033;

const RGB_S3TC_DXT1_Format = 33776;
const RGBA_S3TC_DXT1_Format = 33777;
const RGBA_S3TC_DXT3_Format = 33778;
const RGBA_S3TC_DXT5_Format = 33779;
const RGB_PVRTC_4BPPV1_Format = 35840;
const RGB_PVRTC_2BPPV1_Format = 35841;
const RGBA_PVRTC_4BPPV1_Format = 35842;
const RGBA_PVRTC_2BPPV1_Format = 35843;
const RGB_ETC1_Format = 36196;
const RGB_ETC2_Format = 37492;
const RGBA_ETC2_EAC_Format = 37496;
const RGBA_ASTC_4x4_Format = 37808;
const RGBA_ASTC_5x4_Format = 37809;
const RGBA_ASTC_5x5_Format = 37810;
const RGBA_ASTC_6x5_Format = 37811;
const RGBA_ASTC_6x6_Format = 37812;
const RGBA_ASTC_8x5_Format = 37813;
const RGBA_ASTC_8x6_Format = 37814;
const RGBA_ASTC_8x8_Format = 37815;
const RGBA_ASTC_10x5_Format = 37816;
const RGBA_ASTC_10x6_Format = 37817;
const RGBA_ASTC_10x8_Format = 37818;
const RGBA_ASTC_10x10_Format = 37819;
const RGBA_ASTC_12x10_Format = 37820;
const RGBA_ASTC_12x12_Format = 37821;
const RGBA_BPTC_Format = 36492;
const RGB_BPTC_SIGNED_Format = 36494;
const RGB_BPTC_UNSIGNED_Format = 36495;
const RED_RGTC1_Format = 36283;
const SIGNED_RED_RGTC1_Format = 36284;
const RED_GREEN_RGTC2_Format = 36285;
const SIGNED_RED_GREEN_RGTC2_Format = 36286;
const LoopOnce = 2200;
const LoopRepeat = 2201;
const LoopPingPong = 2202;
const InterpolateDiscrete = 2300;
const InterpolateLinear = 2301;
const InterpolateSmooth = 2302;
const ZeroCurvatureEnding = 2400;
const ZeroSlopeEnding = 2401;
const WrapAroundEnding = 2402;
const NormalAnimationBlendMode = 2500;
const AdditiveAnimationBlendMode = 2501;
const TrianglesDrawMode = 0;
const TriangleStripDrawMode = 1;
const TriangleFanDrawMode = 2;
const BasicDepthPacking = 3200;
const RGBADepthPacking = 3201;
const TangentSpaceNormalMap = 0;
const ObjectSpaceNormalMap = 1;

// Color space string identifiers, matching CSS Color Module Level 4 and WebGPU names where available.
const NoColorSpace = '';
const SRGBColorSpace = 'srgb';
const LinearSRGBColorSpace = 'srgb-linear';
const DisplayP3ColorSpace = 'display-p3';
const LinearDisplayP3ColorSpace = 'display-p3-linear';

const LinearTransfer = 'linear';
const SRGBTransfer = 'srgb';

const Rec709Primaries = 'rec709';
const P3Primaries = 'p3';

const ZeroStencilOp = 0;
const KeepStencilOp = 7680;
const ReplaceStencilOp = 7681;
const IncrementStencilOp = 7682;
const DecrementStencilOp = 7683;
const IncrementWrapStencilOp = 34055;
const DecrementWrapStencilOp = 34056;
const InvertStencilOp = 5386;

const NeverStencilFunc = 512;
const LessStencilFunc = 513;
const EqualStencilFunc = 514;
const LessEqualStencilFunc = 515;
const GreaterStencilFunc = 516;
const NotEqualStencilFunc = 517;
const GreaterEqualStencilFunc = 518;
const AlwaysStencilFunc = 519;

const NeverCompare = 512;
const LessCompare = 513;
const EqualCompare = 514;
const LessEqualCompare = 515;
const GreaterCompare = 516;
const NotEqualCompare = 517;
const GreaterEqualCompare = 518;
const AlwaysCompare = 519;

const StaticDrawUsage = 35044;
const DynamicDrawUsage = 35048;
const StreamDrawUsage = 35040;
const StaticReadUsage = 35045;
const DynamicReadUsage = 35049;
const StreamReadUsage = 35041;
const StaticCopyUsage = 35046;
const DynamicCopyUsage = 35050;
const StreamCopyUsage = 35042;

const GLSL1 = '100';
const GLSL3 = '300 es';

const WebGLCoordinateSystem = 2000;
const WebGPUCoordinateSystem = 2001;

/**
 * https://github.com/mrdoob/eventdispatcher.js/
 */

class EventDispatcher {

	addEventListener( type, listener ) {

		if ( this._listeners === undefined ) this._listeners = {};

		const listeners = this._listeners;

		if ( listeners[ type ] === undefined ) {

			listeners[ type ] = [];

		}

		if ( listeners[ type ].indexOf( listener ) === - 1 ) {

			listeners[ type ].push( listener );

		}

	}

	hasEventListener( type, listener ) {

		if ( this._listeners === undefined ) return false;

		const listeners = this._listeners;

		return listeners[ type ] !== undefined && listeners[ type ].indexOf( listener ) !== - 1;

	}

	removeEventListener( type, listener ) {

		if ( this._listeners === undefined ) return;

		const listeners = this._listeners;
		const listenerArray = listeners[ type ];

		if ( listenerArray !== undefined ) {

			const index = listenerArray.indexOf( listener );

			if ( index !== - 1 ) {

				listenerArray.splice( index, 1 );

			}

		}

	}

	dispatchEvent( event ) {

		if ( this._listeners === undefined ) return;

		const listeners = this._listeners;
		const listenerArray = listeners[ event.type ];

		if ( listenerArray !== undefined ) {

			event.target = this;

			// Make a copy, in case listeners are removed while iterating.
			const array = listenerArray.slice( 0 );

			for ( let i = 0, l = array.length; i < l; i ++ ) {

				array[ i ].call( this, event );

			}

			event.target = null;

		}

	}

}

const _lut = [ '00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '0a', '0b', '0c', '0d', '0e', '0f', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '1a', '1b', '1c', '1d', '1e', '1f', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '2a', '2b', '2c', '2d', '2e', '2f', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '3a', '3b', '3c', '3d', '3e', '3f', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '4a', '4b', '4c', '4d', '4e', '4f', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59', '5a', '5b', '5c', '5d', '5e', '5f', '60', '61', '62', '63', '64', '65', '66', '67', '68', '69', '6a', '6b', '6c', '6d', '6e', '6f', '70', '71', '72', '73', '74', '75', '76', '77', '78', '79', '7a', '7b', '7c', '7d', '7e', '7f', '80', '81', '82', '83', '84', '85', '86', '87', '88', '89', '8a', '8b', '8c', '8d', '8e', '8f', '90', '91', '92', '93', '94', '95', '96', '97', '98', '99', '9a', '9b', '9c', '9d', '9e', '9f', 'a0', 'a1', 'a2', 'a3', 'a4', 'a5', 'a6', 'a7', 'a8', 'a9', 'aa', 'ab', 'ac', 'ad', 'ae', 'af', 'b0', 'b1', 'b2', 'b3', 'b4', 'b5', 'b6', 'b7', 'b8', 'b9', 'ba', 'bb', 'bc', 'bd', 'be', 'bf', 'c0', 'c1', 'c2', 'c3', 'c4', 'c5', 'c6', 'c7', 'c8', 'c9', 'ca', 'cb', 'cc', 'cd', 'ce', 'cf', 'd0', 'd1', 'd2', 'd3', 'd4', 'd5', 'd6', 'd7', 'd8', 'd9', 'da', 'db', 'dc', 'dd', 'de', 'df', 'e0', 'e1', 'e2', 'e3', 'e4', 'e5', 'e6', 'e7', 'e8', 'e9', 'ea', 'eb', 'ec', 'ed', 'ee', 'ef', 'f0', 'f1', 'f2', 'f3', 'f4', 'f5', 'f6', 'f7', 'f8', 'f9', 'fa', 'fb', 'fc', 'fd', 'fe', 'ff' ];

let _seed = 1234567;


const DEG2RAD = Math.PI / 180;
const RAD2DEG = 180 / Math.PI;

// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
function generateUUID() {

	const d0 = Math.random() * 0xffffffff | 0;
	const d1 = Math.random() * 0xffffffff | 0;
	const d2 = Math.random() * 0xffffffff | 0;
	const d3 = Math.random() * 0xffffffff | 0;
	const uuid = _lut[ d0 & 0xff ] + _lut[ d0 >> 8 & 0xff ] + _lut[ d0 >> 16 & 0xff ] + _lut[ d0 >> 24 & 0xff ] + '-' +
			_lut[ d1 & 0xff ] + _lut[ d1 >> 8 & 0xff ] + '-' + _lut[ d1 >> 16 & 0x0f | 0x40 ] + _lut[ d1 >> 24 & 0xff ] + '-' +
			_lut[ d2 & 0x3f | 0x80 ] + _lut[ d2 >> 8 & 0xff ] + '-' + _lut[ d2 >> 16 & 0xff ] + _lut[ d2 >> 24 & 0xff ] +
			_lut[ d3 & 0xff ] + _lut[ d3 >> 8 & 0xff ] + _lut[ d3 >> 16 & 0xff ] + _lut[ d3 >> 24 & 0xff ];

	// .toLowerCase() here flattens concatenated strings to save heap memory space.
	return uuid.toLowerCase();

}

function clamp( value, min, max ) {

	return Math.max( min, Math.min( max, value ) );

}

// compute euclidean modulo of m % n
// https://en.wikipedia.org/wiki/Modulo_operation
function euclideanModulo( n, m ) {

	return ( ( n % m ) + m ) % m;

}

// Linear mapping from range <a1, a2> to range <b1, b2>
function mapLinear( x, a1, a2, b1, b2 ) {

	return b1 + ( x - a1 ) * ( b2 - b1 ) / ( a2 - a1 );

}

// https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
function inverseLerp( x, y, value ) {

	if ( x !== y ) {

		return ( value - x ) / ( y - x );

	} else {

		return 0;

	}

}

// https://en.wikipedia.org/wiki/Linear_interpolation
function lerp( x, y, t ) {

	return ( 1 - t ) * x + t * y;

}

// http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/
function damp( x, y, lambda, dt ) {

	return lerp( x, y, 1 - Math.exp( - lambda * dt ) );

}

// https://www.desmos.com/calculator/vcsjnyz7x4
function pingpong( x, length = 1 ) {

	return length - Math.abs( euclideanModulo( x, length * 2 ) - length );

}

// http://en.wikipedia.org/wiki/Smoothstep
function smoothstep( x, min, max ) {

	if ( x <= min ) return 0;
	if ( x >= max ) return 1;

	x = ( x - min ) / ( max - min );

	return x * x * ( 3 - 2 * x );

}

function smootherstep( x, min, max ) {

	if ( x <= min ) return 0;
	if ( x >= max ) return 1;

	x = ( x - min ) / ( max - min );

	return x * x * x * ( x * ( x * 6 - 15 ) + 10 );

}

// Random integer from <low, high> interval
function randInt( low, high ) {

	return low + Math.floor( Math.random() * ( high - low + 1 ) );

}

// Random float from <low, high> interval
function randFloat( low, high ) {

	return low + Math.random() * ( high - low );

}

// Random float from <-range/2, range/2> interval
function randFloatSpread( range ) {

	return range * ( 0.5 - Math.random() );

}

// Deterministic pseudo-random float in the interval [ 0, 1 ]
function seededRandom( s ) {

	if ( s !== undefined ) _seed = s;

	// Mulberry32 generator

	let t = _seed += 0x6D2B79F5;

	t = Math.imul( t ^ t >>> 15, t | 1 );

	t ^= t + Math.imul( t ^ t >>> 7, t | 61 );

	return ( ( t ^ t >>> 14 ) >>> 0 ) / 4294967296;

}

function degToRad( degrees ) {

	return degrees * DEG2RAD;

}

function radToDeg( radians ) {

	return radians * RAD2DEG;

}

function isPowerOfTwo( value ) {

	return ( value & ( value - 1 ) ) === 0 && value !== 0;

}

function ceilPowerOfTwo( value ) {

	return Math.pow( 2, Math.ceil( Math.log( value ) / Math.LN2 ) );

}

function floorPowerOfTwo( value ) {

	return Math.pow( 2, Math.floor( Math.log( value ) / Math.LN2 ) );

}

function setQuaternionFromProperEuler( q, a, b, c, order ) {

	// Intrinsic Proper Euler Angles - see https://en.wikipedia.org/wiki/Euler_angles

	// rotations are applied to the axes in the order specified by 'order'
	// rotation by angle 'a' is applied first, then by angle 'b', then by angle 'c'
	// angles are in radians

	const cos = Math.cos;
	const sin = Math.sin;

	const c2 = cos( b / 2 );
	const s2 = sin( b / 2 );

	const c13 = cos( ( a + c ) / 2 );
	const s13 = sin( ( a + c ) / 2 );

	const c1_3 = cos( ( a - c ) / 2 );
	const s1_3 = sin( ( a - c ) / 2 );

	const c3_1 = cos( ( c - a ) / 2 );
	const s3_1 = sin( ( c - a ) / 2 );

	switch ( order ) {

		case 'XYX':
			q.set( c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13 );
			break;

		case 'YZY':
			q.set( s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13 );
			break;

		case 'ZXZ':
			q.set( s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13 );
			break;

		case 'XZX':
			q.set( c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13 );
			break;

		case 'YXY':
			q.set( s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13 );
			break;

		case 'ZYZ':
			q.set( s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13 );
			break;

		default:
			console.warn( 'THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: ' + order );

	}

}

function denormalize( value, array ) {

	switch ( array.constructor ) {

		case Float32Array:

			return value;

		case Uint32Array:

			return value / 4294967295.0;

		case Uint16Array:

			return value / 65535.0;

		case Uint8Array:

			return value / 255.0;

		case Int32Array:

			return Math.max( value / 2147483647.0, - 1.0 );

		case Int16Array:

			return Math.max( value / 32767.0, - 1.0 );

		case Int8Array:

			return Math.max( value / 127.0, - 1.0 );

		default:

			throw new Error( 'Invalid component type.' );

	}

}

function normalize( value, array ) {

	switch ( array.constructor ) {

		case Float32Array:

			return value;

		case Uint32Array:

			return Math.round( value * 4294967295.0 );

		case Uint16Array:

			return Math.round( value * 65535.0 );

		case Uint8Array:

			return Math.round( value * 255.0 );

		case Int32Array:

			return Math.round( value * 2147483647.0 );

		case Int16Array:

			return Math.round( value * 32767.0 );

		case Int8Array:

			return Math.round( value * 127.0 );

		default:

			throw new Error( 'Invalid component type.' );

	}

}

const MathUtils = {
	DEG2RAD: DEG2RAD,
	RAD2DEG: RAD2DEG,
	generateUUID: generateUUID,
	clamp: clamp,
	euclideanModulo: euclideanModulo,
	mapLinear: mapLinear,
	inverseLerp: inverseLerp,
	lerp: lerp,
	damp: damp,
	pingpong: pingpong,
	smoothstep: smoothstep,
	smootherstep: smootherstep,
	randInt: randInt,
	randFloat: randFloat,
	randFloatSpread: randFloatSpread,
	seededRandom: seededRandom,
	degToRad: degToRad,
	radToDeg: radToDeg,
	isPowerOfTwo: isPowerOfTwo,
	ceilPowerOfTwo: ceilPowerOfTwo,
	floorPowerOfTwo: floorPowerOfTwo,
	setQuaternionFromProperEuler: setQuaternionFromProperEuler,
	normalize: normalize,
	denormalize: denormalize
};

class Vector2 {

	constructor( x = 0, y = 0 ) {

		Vector2.prototype.isVector2 = true;

		this.x = x;
		this.y = y;

	}

	get width() {

		return this.x;

	}

	set width( value ) {

		this.x = value;

	}

	get height() {

		return this.y;

	}

	set height( value ) {

		this.y = value;

	}

	set( x, y ) {

		this.x = x;
		this.y = y;

		return this;

	}

	setScalar( scalar ) {

		this.x = scalar;
		this.y = scalar;

		return this;

	}

	setX( x ) {

		this.x = x;

		return this;

	}

	setY( y ) {

		this.y = y;

		return this;

	}

	setComponent( index, value ) {

		switch ( index ) {

			case 0: this.x = value; break;
			case 1: this.y = value; break;
			default: throw new Error( 'index is out of range: ' + index );

		}

		return this;

	}

	getComponent( index ) {

		switch ( index ) {

			case 0: return this.x;
			case 1: return this.y;
			default: throw new Error( 'index is out of range: ' + index );

		}

	}

	clone() {

		return new this.constructor( this.x, this.y );

	}

	copy( v ) {

		this.x = v.x;
		this.y = v.y;

		return this;

	}

	add( v ) {

		this.x += v.x;
		this.y += v.y;

		return this;

	}

	addScalar( s ) {

		this.x += s;
		this.y += s;

		return this;

	}

	addVectors( a, b ) {

		this.x = a.x + b.x;
		this.y = a.y + b.y;

		return this;

	}

	addScaledVector( v, s ) {

		this.x += v.x * s;
		this.y += v.y * s;

		return this;

	}

	sub( v ) {

		this.x -= v.x;
		this.y -= v.y;

		return this;

	}

	subScalar( s ) {

		this.x -= s;
		this.y -= s;

		return this;

	}

	subVectors( a, b ) {

		this.x = a.x - b.x;
		this.y = a.y - b.y;

		return this;

	}

	multiply( v ) {

		this.x *= v.x;
		this.y *= v.y;

		return this;

	}

	multiplyScalar( scalar ) {

		this.x *= scalar;
		this.y *= scalar;

		return this;

	}

	divide( v ) {

		this.x /= v.x;
		this.y /= v.y;

		return this;

	}

	divideScalar( scalar ) {

		return this.multiplyScalar( 1 / scalar );

	}

	applyMatrix3( m ) {

		const x = this.x, y = this.y;
		const e = m.elements;

		this.x = e[ 0 ] * x + e[ 3 ] * y + e[ 6 ];
		this.y = e[ 1 ] * x + e[ 4 ] * y + e[ 7 ];

		return this;

	}

	min( v ) {

		this.x = Math.min( this.x, v.x );
		this.y = Math.min( this.y, v.y );

		return this;

	}

	max( v ) {

		this.x = Math.max( this.x, v.x );
		this.y = Math.max( this.y, v.y );

		return this;

	}

	clamp( min, max ) {

		// assumes min < max, componentwise

		this.x = Math.max( min.x, Math.min( max.x, this.x ) );
		this.y = Math.max( min.y, Math.min( max.y, this.y ) );

		return this;

	}

	clampScalar( minVal, maxVal ) {

		this.x = Math.max( minVal, Math.min( maxVal, this.x ) );
		this.y = Math.max( minVal, Math.min( maxVal, this.y ) );

		return this;

	}

	clampLength( min, max ) {

		const length = this.length();

		return this.divideScalar( length || 1 ).multiplyScalar( Math.max( min, Math.min( max, length ) ) );

	}

	floor() {

		this.x = Math.floor( this.x );
		this.y = Math.floor( this.y );

		return this;

	}

	ceil() {

		this.x = Math.ceil( this.x );
		this.y = Math.ceil( this.y );

		return this;

	}

	round() {

		this.x = Math.round( this.x );
		this.y = Math.round( this.y );

		return this;

	}

	roundToZero() {

		this.x = Math.trunc( this.x );
		this.y = Math.trunc( this.y );

		return this;

	}

	negate() {

		this.x = - this.x;
		this.y = - this.y;

		return this;

	}

	dot( v ) {

		return this.x * v.x + this.y * v.y;

	}

	cross( v ) {

		return this.x * v.y - this.y * v.x;

	}

	lengthSq() {

		return this.x * this.x + this.y * this.y;

	}

	length() {

		return Math.sqrt( this.x * this.x + this.y * this.y );

	}

	manhattanLength() {

		return Math.abs( this.x ) + Math.abs( this.y );

	}

	normalize() {

		return this.divideScalar( this.length() || 1 );

	}

	angle() {

		// computes the angle in radians with respect to the positive x-axis

		const angle = Math.atan2( - this.y, - this.x ) + Math.PI;

		return angle;

	}

	angleTo( v ) {

		const denominator = Math.sqrt( this.lengthSq() * v.lengthSq() );

		if ( denominator === 0 ) return Math.PI / 2;

		const theta = this.dot( v ) / denominator;

		// clamp, to handle numerical problems

		return Math.acos( clamp( theta, - 1, 1 ) );

	}

	distanceTo( v ) {

		return Math.sqrt( this.distanceToSquared( v ) );

	}

	distanceToSquared( v ) {

		const dx = this.x - v.x, dy = this.y - v.y;
		return dx * dx + dy * dy;

	}

	manhattanDistanceTo( v ) {

		return Math.abs( this.x - v.x ) + Math.abs( this.y - v.y );

	}

	setLength( length ) {

		return this.normalize().multiplyScalar( length );

	}

	lerp( v, alpha ) {

		this.x += ( v.x - this.x ) * alpha;
		this.y += ( v.y - this.y ) * alpha;

		return this;

	}

	lerpVectors( v1, v2, alpha ) {

		this.x = v1.x + ( v2.x - v1.x ) * alpha;
		this.y = v1.y + ( v2.y - v1.y ) * alpha;

		return this;

	}

	equals( v ) {

		return ( ( v.x === this.x ) && ( v.y === this.y ) );

	}

	fromArray( array, offset = 0 ) {

		this.x = array[ offset ];
		this.y = array[ offset + 1 ];

		return this;

	}

	toArray( array = [], offset = 0 ) {

		array[ offset ] = this.x;
		array[ offset + 1 ] = this.y;

		return array;

	}

	fromBufferAttribute( attribute, index ) {

		this.x = attribute.getX( index );
		this.y = attribute.getY( index );

		return this;

	}

	rotateAround( center, angle ) {

		const c = Math.cos( angle ), s = Math.sin( angle );

		const x = this.x - center.x;
		const y = this.y - center.y;

		this.x = x * c - y * s + center.x;
		this.y = x * s + y * c + center.y;

		return this;

	}

	random() {

		this.x = Math.random();
		this.y = Math.random();

		return this;

	}

	*[ Symbol.iterator ]() {

		yield this.x;
		yield this.y;

	}

}

class Matrix3 {

	constructor( n11, n12, n13, n21, n22, n23, n31, n32, n33 ) {

		Matrix3.prototype.isMatrix3 = true;

		this.elements = [

			1, 0, 0,
			0, 1, 0,
			0, 0, 1

		];

		if ( n11 !== undefined ) {

			this.set( n11, n12, n13, n21, n22, n23, n31, n32, n33 );

		}

	}

	set( n11, n12, n13, n21, n22, n23, n31, n32, n33 ) {

		const te = this.elements;

		te[ 0 ] = n11; te[ 1 ] = n21; te[ 2 ] = n31;
		te[ 3 ] = n12; te[ 4 ] = n22; te[ 5 ] = n32;
		te[ 6 ] = n13; te[ 7 ] = n23; te[ 8 ] = n33;

		return this;

	}

	identity() {

		this.set(

			1, 0, 0,
			0, 1, 0,
			0, 0, 1

		);

		return this;

	}

	copy( m ) {

		const te = this.elements;
		const me = m.elements;

		te[ 0 ] = me[ 0 ]; te[ 1 ] = me[ 1 ]; te[ 2 ] = me[ 2 ];
		te[ 3 ] = me[ 3 ]; te[ 4 ] = me[ 4 ]; te[ 5 ] = me[ 5 ];
		te[ 6 ] = me[ 6 ]; te[ 7 ] = me[ 7 ]; te[ 8 ] = me[ 8 ];

		return this;

	}

	extractBasis( xAxis, yAxis, zAxis ) {

		xAxis.setFromMatrix3Column( this, 0 );
		yAxis.setFromMatrix3Column( this, 1 );
		zAxis.setFromMatrix3Column( this, 2 );

		return this;

	}

	setFromMatrix4( m ) {

		const me = m.elements;

		this.set(

			me[ 0 ], me[ 4 ], me[ 8 ],
			me[ 1 ], me[ 5 ], me[ 9 ],
			me[ 2 ], me[ 6 ], me[ 10 ]

		);

		return this;

	}

	multiply( m ) {

		return this.multiplyMatrices( this, m );

	}

	premultiply( m ) {

		return this.multiplyMatrices( m, this );

	}

	multiplyMatrices( a, b ) {

		const ae = a.elements;
		const be = b.elements;
		const te = this.elements;

		const a11 = ae[ 0 ], a12 = ae[ 3 ], a13 = ae[ 6 ];
		const a21 = ae[ 1 ], a22 = ae[ 4 ], a23 = ae[ 7 ];
		const a31 = ae[ 2 ], a32 = ae[ 5 ], a33 = ae[ 8 ];

		const b11 = be[ 0 ], b12 = be[ 3 ], b13 = be[ 6 ];
		const b21 = be[ 1 ], b22 = be[ 4 ], b23 = be[ 7 ];
		const b31 = be[ 2 ], b32 = be[ 5 ], b33 = be[ 8 ];

		te[ 0 ] = a11 * b11 + a12 * b21 + a13 * b31;
		te[ 3 ] = a11 * b12 + a12 * b22 + a13 * b32;
		te[ 6 ] = a11 * b13 + a12 * b23 + a13 * b33;

		te[ 1 ] = a21 * b11 + a22 * b21 + a23 * b31;
		te[ 4 ] = a21 * b12 + a22 * b22 + a23 * b32;
		te[ 7 ] = a21 * b13 + a22 * b23 + a23 * b33;

		te[ 2 ] = a31 * b11 + a32 * b21 + a33 * b31;
		te[ 5 ] = a31 * b12 + a32 * b22 + a33 * b32;
		te[ 8 ] = a31 * b13 + a32 * b23 + a33 * b33;

		return this;

	}

	multiplyScalar( s ) {

		const te = this.elements;

		te[ 0 ] *= s; te[ 3 ] *= s; te[ 6 ] *= s;
		te[ 1 ] *= s; te[ 4 ] *= s; te[ 7 ] *= s;
		te[ 2 ] *= s; te[ 5 ] *= s; te[ 8 ] *= s;

		return this;

	}

	determinant() {

		const te = this.elements;

		const a = te[ 0 ], b = te[ 1 ], c = te[ 2 ],
			d = te[ 3 ], e = te[ 4 ], f = te[ 5 ],
			g = te[ 6 ], h = te[ 7 ], i = te[ 8 ];

		return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;

	}

	invert() {

		const te = this.elements,

			n11 = te[ 0 ], n21 = te[ 1 ], n31 = te[ 2 ],
			n12 = te[ 3 ], n22 = te[ 4 ], n32 = te[ 5 ],
			n13 = te[ 6 ], n23 = te[ 7 ], n33 = te[ 8 ],

			t11 = n33 * n22 - n32 * n23,
			t12 = n32 * n13 - n33 * n12,
			t13 = n23 * n12 - n22 * n13,

			det = n11 * t11 + n21 * t12 + n31 * t13;

		if ( det === 0 ) return this.set( 0, 0, 0, 0, 0, 0, 0, 0, 0 );

		const detInv = 1 / det;

		te[ 0 ] = t11 * detInv;
		te[ 1 ] = ( n31 * n23 - n33 * n21 ) * detInv;
		te[ 2 ] = ( n32 * n21 - n31 * n22 ) * detInv;

		te[ 3 ] = t12 * detInv;
		te[ 4 ] = ( n33 * n11 - n31 * n13 ) * detInv;
		te[ 5 ] = ( n31 * n12 - n32 * n11 ) * detInv;

		te[ 6 ] = t13 * detInv;
		te[ 7 ] = ( n21 * n13 - n23 * n11 ) * detInv;
		te[ 8 ] = ( n22 * n11 - n21 * n12 ) * detInv;

		return this;

	}

	transpose() {

		let tmp;
		const m = this.elements;

		tmp = m[ 1 ]; m[ 1 ] = m[ 3 ]; m[ 3 ] = tmp;
		tmp = m[ 2 ]; m[ 2 ] = m[ 6 ]; m[ 6 ] = tmp;
		tmp = m[ 5 ]; m[ 5 ] = m[ 7 ]; m[ 7 ] = tmp;

		return this;

	}

	getNormalMatrix( matrix4 ) {

		return this.setFromMatrix4( matrix4 ).invert().transpose();

	}

	transposeIntoArray( r ) {

		const m = this.elements;

		r[ 0 ] = m[ 0 ];
		r[ 1 ] = m[ 3 ];
		r[ 2 ] = m[ 6 ];
		r[ 3 ] = m[ 1 ];
		r[ 4 ] = m[ 4 ];
		r[ 5 ] = m[ 7 ];
		r[ 6 ] = m[ 2 ];
		r[ 7 ] = m[ 5 ];
		r[ 8 ] = m[ 8 ];

		return this;

	}

	setUvTransform( tx, ty, sx, sy, rotation, cx, cy ) {

		const c = Math.cos( rotation );
		const s = Math.sin( rotation );

		this.set(
			sx * c, sx * s, - sx * ( c * cx + s * cy ) + cx + tx,
			- sy * s, sy * c, - sy * ( - s * cx + c * cy ) + cy + ty,
			0, 0, 1
		);

		return this;

	}

	//

	scale( sx, sy ) {

		this.premultiply( _m3.makeScale( sx, sy ) );

		return this;

	}

	rotate( theta ) {

		this.premultiply( _m3.makeRotation( - theta ) );

		return this;

	}

	translate( tx, ty ) {

		this.premultiply( _m3.makeTranslation( tx, ty ) );

		return this;

	}

	// for 2D Transforms

	makeTranslation( x, y ) {

		if ( x.isVector2 ) {

			this.set(

				1, 0, x.x,
				0, 1, x.y,
				0, 0, 1

			);

		} else {

			this.set(

				1, 0, x,
				0, 1, y,
				0, 0, 1

			);

		}

		return this;

	}

	makeRotation( theta ) {

		// counterclockwise

		const c = Math.cos( theta );
		const s = Math.sin( theta );

		this.set(

			c, - s, 0,
			s, c, 0,
			0, 0, 1

		);

		return this;

	}

	makeScale( x, y ) {

		this.set(

			x, 0, 0,
			0, y, 0,
			0, 0, 1

		);

		return this;

	}

	//

	equals( matrix ) {

		const te = this.elements;
		const me = matrix.elements;

		for ( let i = 0; i < 9; i ++ ) {

			if ( te[ i ] !== me[ i ] ) return false;

		}

		return true;

	}

	fromArray( array, offset = 0 ) {

		for ( let i = 0; i < 9; i ++ ) {

			this.elements[ i ] = array[ i + offset ];

		}

		return this;

	}

	toArray( array = [], offset = 0 ) {

		const te = this.elements;

		array[ offset ] = te[ 0 ];
		array[ offset + 1 ] = te[ 1 ];
		array[ offset + 2 ] = te[ 2 ];

		array[ offset + 3 ] = te[ 3 ];
		array[ offset + 4 ] = te[ 4 ];
		array[ offset + 5 ] = te[ 5 ];

		array[ offset + 6 ] = te[ 6 ];
		array[ offset + 7 ] = te[ 7 ];
		array[ offset + 8 ] = te[ 8 ];

		return array;

	}

	clone() {

		return new this.constructor().fromArray( this.elements );

	}

}

const _m3 = /*@__PURE__*/ new Matrix3();

function arrayNeedsUint32( array ) {

	// assumes larger values usually on last

	for ( let i = array.length - 1; i >= 0; -- i ) {

		if ( array[ i ] >= 65535 ) return true; // account for PRIMITIVE_RESTART_FIXED_INDEX, #24565

	}

	return false;

}

const TYPED_ARRAYS = {
	Int8Array: Int8Array,
	Uint8Array: Uint8Array,
	Uint8ClampedArray: Uint8ClampedArray,
	Int16Array: Int16Array,
	Uint16Array: Uint16Array,
	Int32Array: Int32Array,
	Uint32Array: Uint32Array,
	Float32Array: Float32Array,
	Float64Array: Float64Array
};

function getTypedArray( type, buffer ) {

	return new TYPED_ARRAYS[ type ]( buffer );

}

function createElementNS( name ) {

	return document.createElementNS( 'http://www.w3.org/1999/xhtml', name );

}

function createCanvasElement() {

	const canvas = createElementNS( 'canvas' );
	canvas.style.display = 'block';
	return canvas;

}

const _cache = {};

function warnOnce( message ) {

	if ( message in _cache ) return;

	_cache[ message ] = true;

	console.warn( message );

}

/**
 * Matrices converting P3 <-> Rec. 709 primaries, without gamut mapping
 * or clipping. Based on W3C specifications for sRGB and Display P3,
 * and ICC specifications for the D50 connection space. Values in/out
 * are _linear_ sRGB and _linear_ Display P3.
 *
 * Note that both sRGB and Display P3 use the sRGB transfer functions.
 *
 * Reference:
 * - http://www.russellcottrell.com/photo/matrixCalculator.htm
 */

const LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 = /*@__PURE__*/ new Matrix3().set(
	0.8224621, 0.177538, 0.0,
	0.0331941, 0.9668058, 0.0,
	0.0170827, 0.0723974, 0.9105199,
);

const LINEAR_DISPLAY_P3_TO_LINEAR_SRGB = /*@__PURE__*/ new Matrix3().set(
	1.2249401, - 0.2249404, 0.0,
	- 0.0420569, 1.0420571, 0.0,
	- 0.0196376, - 0.0786361, 1.0982735
);

/**
 * Defines supported color spaces by transfer function and primaries,
 * and provides conversions to/from the Linear-sRGB reference space.
 */
const COLOR_SPACES = {
	[ LinearSRGBColorSpace ]: {
		transfer: LinearTransfer,
		primaries: Rec709Primaries,
		toReference: ( color ) => color,
		fromReference: ( color ) => color,
	},
	[ SRGBColorSpace ]: {
		transfer: SRGBTransfer,
		primaries: Rec709Primaries,
		toReference: ( color ) => color.convertSRGBToLinear(),
		fromReference: ( color ) => color.convertLinearToSRGB(),
	},
	[ LinearDisplayP3ColorSpace ]: {
		transfer: LinearTransfer,
		primaries: P3Primaries,
		toReference: ( color ) => color.applyMatrix3( LINEAR_DISPLAY_P3_TO_LINEAR_SRGB ),
		fromReference: ( color ) => color.applyMatrix3( LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 ),
	},
	[ DisplayP3ColorSpace ]: {
		transfer: SRGBTransfer,
		primaries: P3Primaries,
		toReference: ( color ) => color.convertSRGBToLinear().applyMatrix3( LINEAR_DISPLAY_P3_TO_LINEAR_SRGB ),
		fromReference: ( color ) => color.applyMatrix3( LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 ).convertLinearToSRGB(),
	},
};

const SUPPORTED_WORKING_COLOR_SPACES = new Set( [ LinearSRGBColorSpace, LinearDisplayP3ColorSpace ] );

const ColorManagement = {

	enabled: true,

	_workingColorSpace: LinearSRGBColorSpace,

	get workingColorSpace() {

		return this._workingColorSpace;

	},

	set workingColorSpace( colorSpace ) {

		if ( ! SUPPORTED_WORKING_COLOR_SPACES.has( colorSpace ) ) {

			throw new Error( `Unsupported working color space, "${ colorSpace }".` );

		}

		this._workingColorSpace = colorSpace;

	},

	convert: function ( color, sourceColorSpace, targetColorSpace ) {

		if ( this.enabled === false || sourceColorSpace === targetColorSpace || ! sourceColorSpace || ! targetColorSpace ) {

			return color;

		}

		const sourceToReference = COLOR_SPACES[ sourceColorSpace ].toReference;
		const targetFromReference = COLOR_SPACES[ targetColorSpace ].fromReference;

		return targetFromReference( sourceToReference( color ) );

	},

	fromWorkingColorSpace: function ( color, targetColorSpace ) {

		return this.convert( color, this._workingColorSpace, targetColorSpace );

	},

	toWorkingColorSpace: function ( color, sourceColorSpace ) {

		return this.convert( color, sourceColorSpace, this._workingColorSpace );

	},

	getPrimaries: function ( colorSpace ) {

		return COLOR_SPACES[ colorSpace ].primaries;

	},

	getTransfer: function ( colorSpace ) {

		if ( colorSpace === NoColorSpace ) return LinearTransfer;

		return COLOR_SPACES[ colorSpace ].transfer;

	},

};


function SRGBToLinear( c ) {

	return ( c < 0.04045 ) ? c * 0.0773993808 : Math.pow( c * 0.9478672986 + 0.0521327014, 2.4 );

}

function LinearToSRGB( c ) {

	return ( c < 0.0031308 ) ? c * 12.92 : 1.055 * ( Math.pow( c, 0.41666 ) ) - 0.055;

}

let _canvas;

class ImageUtils {

	static getDataURL( image ) {

		if ( /^data:/i.test( image.src ) ) {

			return image.src;

		}

		if ( typeof HTMLCanvasElement === 'undefined' ) {

			return image.src;

		}

		let canvas;

		if ( image instanceof HTMLCanvasElement ) {

			canvas = image;

		} else {

			if ( _canvas === undefined ) _canvas = createElementNS( 'canvas' );

			_canvas.width = image.width;
			_canvas.height = image.height;

			const context = _canvas.getContext( '2d' );

			if ( image instanceof ImageData ) {

				context.putImageData( image, 0, 0 );

			} else {

				context.drawImage( image, 0, 0, image.width, image.height );

			}

			canvas = _canvas;

		}

		if ( canvas.width > 2048 || canvas.height > 2048 ) {

			console.warn( 'THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons', image );

			return canvas.toDataURL( 'image/jpeg', 0.6 );

		} else {

			return canvas.toDataURL( 'image/png' );

		}

	}

	static sRGBToLinear( image ) {

		if ( ( typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement ) ||
			( typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement ) ||
			( typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap ) ) {

			const canvas = createElementNS( 'canvas' );

			canvas.width = image.width;
			canvas.height = image.height;

			const context = canvas.getContext( '2d' );
			context.drawImage( image, 0, 0, image.width, image.height );

			const imageData = context.getImageData( 0, 0, image.width, image.height );
			const data = imageData.data;

			for ( let i = 0; i < data.length; i ++ ) {

				data[ i ] = SRGBToLinear( data[ i ] / 255 ) * 255;

			}

			context.putImageData( imageData, 0, 0 );

			return canvas;

		} else if ( image.data ) {

			const data = image.data.slice( 0 );

			for ( let i = 0; i < data.length; i ++ ) {

				if ( data instanceof Uint8Array || data instanceof Uint8ClampedArray ) {

					data[ i ] = Math.floor( SRGBToLinear( data[ i ] / 255 ) * 255 );

				} else {

					// assuming float

					data[ i ] = SRGBToLinear( data[ i ] );

				}

			}

			return {
				data: data,
				width: image.width,
				height: image.height
			};

		} else {

			console.warn( 'THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.' );
			return image;

		}

	}

}

let _sourceId = 0;

class Source {

	constructor( data = null ) {

		this.isSource = true;

		Object.defineProperty( this, 'id', { value: _sourceId ++ } );

		this.uuid = generateUUID();

		this.data = data;
		this.dataReady = true;

		this.version = 0;

	}

	set needsUpdate( value ) {

		if ( value === true ) this.version ++;

	}

	toJSON( meta ) {

		const isRootObject = ( meta === undefined || typeof meta === 'string' );

		if ( ! isRootObject && meta.images[ this.uuid ] !== undefined ) {

			return meta.images[ this.uuid ];

		}

		const output = {
			uuid: this.uuid,
			url: ''
		};

		const data = this.data;

		if ( data !== null ) {

			let url;

			if ( Array.isArray( data ) ) {

				// cube texture

				url = [];

				for ( let i = 0, l = data.length; i < l; i ++ ) {

					if ( data[ i ].isDataTexture ) {

						url.push( serializeImage( data[ i ].image ) );

					} else {

						url.push( serializeImage( data[ i ] ) );

					}

				}

			} else {

				// texture

				url = serializeImage( data );

			}

			output.url = url;

		}

		if ( ! isRootObject ) {

			meta.images[ this.uuid ] = output;

		}

		return output;

	}

}

function serializeImage( image ) {

	if ( ( typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement ) ||
		( typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement ) ||
		( typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap ) ) {

		// default images

		return ImageUtils.getDataURL( image );

	} else {

		if ( image.data ) {

			// images of DataTexture

			return {
				data: Array.from( image.data ),
				width: image.width,
				height: image.height,
				type: image.data.constructor.name
			};

		} else {

			console.warn( 'THREE.Texture: Unable to serialize Texture.' );
			return {};

		}

	}

}

let _textureId = 0;

class Texture extends EventDispatcher {

	constructor( image = Texture.DEFAULT_IMAGE, mapping = Texture.DEFAULT_MAPPING, wrapS = ClampToEdgeWrapping, wrapT = ClampToEdgeWrapping, magFilter = LinearFilter, minFilter = LinearMipmapLinearFilter, format = RGBAFormat, type = UnsignedByteType, anisotropy = Texture.DEFAULT_ANISOTROPY, colorSpace = NoColorSpace ) {

		super();

		this.isTexture = true;

		Object.defineProperty( this, 'id', { value: _textureId ++ } );

		this.uuid = generateUUID();

		this.name = '';

		this.source = new Source( image );
		this.mipmaps = [];

		this.mapping = mapping;
		this.channel = 0;

		this.wrapS = wrapS;
		this.wrapT = wrapT;

		this.magFilter = magFilter;
		this.minFilter = minFilter;

		this.anisotropy = anisotropy;

		this.format = format;
		this.internalFormat = null;
		this.type = type;

		this.offset = new Vector2( 0, 0 );
		this.repeat = new Vector2( 1, 1 );
		this.center = new Vector2( 0, 0 );
		this.rotation = 0;

		this.matrixAutoUpdate = true;
		this.matrix = new Matrix3();

		this.generateMipmaps = true;
		this.premultiplyAlpha = false;
		this.flipY = true;
		this.unpackAlignment = 4;	// valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)

		this.colorSpace = colorSpace;

		this.userData = {};

		this.version = 0;
		this.onUpdate = null;

		this.isRenderTargetTexture = false; // indicates whether a texture belongs to a render target or not
		this.pmremVersion = 0; // indicates whether this texture should be processed by PMREMGenerator or not (only relevant for render target textures)

	}

	get image() {

		return this.source.data;

	}

	set image( value = null ) {

		this.source.data = value;

	}

	updateMatrix() {

		this.matrix.setUvTransform( this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y );

	}

	clone() {

		return new this.constructor().copy( this );

	}

	copy( source ) {

		this.name = source.name;

		this.source = source.source;
		this.mipmaps = source.mipmaps.slice( 0 );

		this.mapping = source.mapping;
		this.channel = source.channel;

		this.wrapS = source.wrapS;
		this.wrapT = source.wrapT;

		this.magFilter = source.magFilter;
		this.minFilter = source.minFilter;

		this.anisotropy = source.anisotropy;

		this.format = source.format;
		this.internalFormat = source.internalFormat;
		this.type = source.type;

		this.offset.copy( source.offset );
		this.repeat.copy( source.repeat );
		this.center.copy( source.center );
		this.rotation = source.rotation;

		this.matrixAutoUpdate = source.matrixAutoUpdate;
		this.matrix.copy( source.matrix );

		this.generateMipmaps = source.generateMipmaps;
		this.premultiplyAlpha = source.premultiplyAlpha;
		this.flipY = source.flipY;
		this.unpackAlignment = source.unpackAlignment;
		this.colorSpace = source.colorSpace;

		this.userData = JSON.parse( JSON.stringify( source.userData ) );

		this.needsUpdate = true;

		return this;

	}

	toJSON( meta ) {

		const isRootObject = ( meta === undefined || typeof meta === 'string' );

		if ( ! isRootObject && meta.textures[ this.uuid ] !== undefined ) {

			return meta.textures[ this.uuid ];

		}

		const output = {

			metadata: {
				version: 4.6,
				type: 'Texture',
				generator: 'Texture.toJSON'
			},

			uuid: this.uuid,
			name: this.name,

			image: this.source.toJSON( meta ).uuid,

			mapping: this.mapping,
			channel: this.channel,

			repeat: [ this.repeat.x, this.repeat.y ],
			offset: [ this.offset.x, this.offset.y ],
			center: [ this.center.x, this.center.y ],
			rotation: this.rotation,

			wrap: [ this.wrapS, this.wrapT ],

			format: this.format,
			internalFormat: this.internalFormat,
			type: this.type,
			colorSpace: this.colorSpace,

			minFilter: this.minFilter,
			magFilter: this.magFilter,
			anisotropy: this.anisotropy,

			flipY: this.flipY,

			generateMipmaps: this.generateMipmaps,
			premultiplyAlpha: this.premultiplyAlpha,
			unpackAlignment: this.unpackAlignment

		};

		if ( Object.keys( this.userData ).length > 0 ) output.userData = this.userData;

		if ( ! isRootObject ) {

			meta.textures[ this.uuid ] = output;

		}

		return output;

	}

	dispose() {

		this.dispatchEvent( { type: 'dispose' } );

	}

	transformUv( uv ) {

		if ( this.mapping !== UVMapping ) return uv;

		uv.applyMatrix3( this.matrix );

		if ( uv.x < 0 || uv.x > 1 ) {

			switch ( this.wrapS ) {

				case RepeatWrapping:

					uv.x = uv.x - Math.floor( uv.x );
					break;

				case ClampToEdgeWrapping:

					uv.x = uv.x < 0 ? 0 : 1;
					break;

				case MirroredRepeatWrapping:

					if ( Math.abs( Math.floor( uv.x ) % 2 ) === 1 ) {

						uv.x = Math.ceil( uv.x ) - uv.x;

					} else {

						uv.x = uv.x - Math.floor( uv.x );

					}

					break;

			}

		}

		if ( uv.y < 0 || uv.y > 1 ) {

			switch ( this.wrapT ) {

				case RepeatWrapping:

					uv.y = uv.y - Math.floor( uv.y );
					break;

				case ClampToEdgeWrapping:

					uv.y = uv.y < 0 ? 0 : 1;
					break;

				case MirroredRepeatWrapping:

					if ( Math.abs( Math.floor( uv.y ) % 2 ) === 1 ) {

						uv.y = Math.ceil( uv.y ) - uv.y;

					} else {

						uv.y = uv.y - Math.floor( uv.y );

					}

					break;

			}

		}

		if ( this.flipY ) {

			uv.y = 1 - uv.y;

		}

		return uv;

	}

	set needsUpdate( value ) {

		if ( value === true ) {

			this.version ++;
			this.source.needsUpdate = true;

		}

	}

	set needsPMREMUpdate( value ) {

		if ( value === true ) {

			this.pmremVersion ++;

		}

	}

}

Texture.DEFAULT_IMAGE = null;
Texture.DEFAULT_MAPPING = UVMapping;
Texture.DEFAULT_ANISOTROPY = 1;

class Vector4 {

	constructor( x = 0, y = 0, z = 0, w = 1 ) {

		Vector4.prototype.isVector4 = true;

		this.x = x;
		this.y = y;
		this.z = z;
		this.w = w;

	}

	get width() {

		return this.z;

	}

	set width( value ) {

		this.z = value;

	}

	get height() {

		return this.w;

	}

	set height( value ) {

		this.w = value;

	}

	set( x, y, z, w ) {

		this.x = x;
		this.y = y;
		this.z = z;
		this.w = w;

		return this;

	}

	setScalar( scalar ) {

		this.x = scalar;
		this.y = scalar;
		this.z = scalar;
		this.w = scalar;

		return this;

	}

	setX( x ) {

		this.x = x;

		return this;

	}

	setY( y ) {

		this.y = y;

		return this;

	}

	setZ( z ) {

		this.z = z;

		return this;

	}

	setW( w ) {

		this.w = w;

		return this;

	}

	setComponent( index, value ) {

		switch ( index ) {

			case 0: this.x = value; break;
			case 1: this.y = value; break;
			case 2: this.z = value; break;
			case 3: this.w = value; break;
			default: throw new Error( 'index is out of range: ' + index );

		}

		return this;

	}

	getComponent( index ) {

		switch ( index ) {

			case 0: return this.x;
			case 1: return this.y;
			case 2: return this.z;
			case 3: return this.w;
			default: throw new Error( 'index is out of range: ' + index );

		}

	}

	clone() {

		return new this.constructor( this.x, this.y, this.z, this.w );

	}

	copy( v ) {

		this.x = v.x;
		this.y = v.y;
		this.z = v.z;
		this.w = ( v.w !== undefined ) ? v.w : 1;

		return this;

	}

	add( v ) {

		this.x += v.x;
		this.y += v.y;
		this.z += v.z;
		this.w += v.w;

		return this;

	}

	addScalar( s ) {

		this.x += s;
		this.y += s;
		this.z += s;
		this.w += s;

		return this;

	}

	addVectors( a, b ) {

		this.x = a.x + b.x;
		this.y = a.y + b.y;
		this.z = a.z + b.z;
		this.w = a.w + b.w;

		return this;

	}

	addScaledVector( v, s ) {

		this.x += v.x * s;
		this.y += v.y * s;
		this.z += v.z * s;
		this.w += v.w * s;

		return this;

	}

	sub( v ) {

		this.x -= v.x;
		this.y -= v.y;
		this.z -= v.z;
		this.w -= v.w;

		return this;

	}

	subScalar( s ) {

		this.x -= s;
		this.y -= s;
		this.z -= s;
		this.w -= s;

		return this;

	}

	subVectors( a, b ) {

		this.x = a.x - b.x;
		this.y = a.y - b.y;
		this.z = a.z - b.z;
		this.w = a.w - b.w;

		return this;

	}

	multiply( v ) {

		this.x *= v.x;
		this.y *= v.y;
		this.z *= v.z;
		this.w *= v.w;

		return this;

	}

	multiplyScalar( scalar ) {

		this.x *= scalar;
		this.y *= scalar;
		this.z *= scalar;
		this.w *= scalar;

		return this;

	}

	applyMatrix4( m ) {

		const x = this.x, y = this.y, z = this.z, w = this.w;
		const e = m.elements;

		this.x = e[ 0 ] * x + e[ 4 ] * y + e[ 8 ] * z + e[ 12 ] * w;
		this.y = e[ 1 ] * x + e[ 5 ] * y + e[ 9 ] * z + e[ 13 ] * w;
		this.z = e[ 2 ] * x + e[ 6 ] * y + e[ 10 ] * z + e[ 14 ] * w;
		this.w = e[ 3 ] * x + e[ 7 ] * y + e[ 11 ] * z + e[ 15 ] * w;

		return this;

	}

	divideScalar( scalar ) {

		return this.multiplyScalar( 1 / scalar );

	}

	setAxisAngleFromQuaternion( q ) {

		// http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm

		// q is assumed to be normalized

		this.w = 2 * Math.acos( q.w );

		const s = Math.sqrt( 1 - q.w * q.w );

		if ( s < 0.0001 ) {

			this.x = 1;
			this.y = 0;
			this.z = 0;

		} else {

			this.x = q.x / s;
			this.y = q.y / s;
			this.z = q.z / s;

		}

		return this;

	}

	setAxisAngleFromRotationMatrix( m ) {

		// http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm

		// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)

		let angle, x, y, z; // variables for result
		const epsilon = 0.01,		// margin to allow for rounding errors
			epsilon2 = 0.1,		// margin to distinguish between 0 and 180 degrees

			te = m.elements,

			m11 = te[ 0 ], m12 = te[ 4 ], m13 = te[ 8 ],
			m21 = te[ 1 ], m22 = te[ 5 ], m23 = te[ 9 ],
			m31 = te[ 2 ], m32 = te[ 6 ], m33 = te[ 10 ];

		if ( ( Math.abs( m12 - m21 ) < epsilon ) &&
		     ( Math.abs( m13 - m31 ) < epsilon ) &&
		     ( Math.abs( m23 - m32 ) < epsilon ) ) {

			// singularity found
			// first check for identity matrix which must have +1 for all terms
			// in leading diagonal and zero in other terms

			if ( ( Math.abs( m12 + m21 ) < epsilon2 ) &&
			     ( Math.abs( m13 + m31 ) < epsilon2 ) &&
			     ( Math.abs( m23 + m32 ) < epsilon2 ) &&
			     ( Math.abs( m11 + m22 + m33 - 3 ) < epsilon2 ) ) {

				// this singularity is identity matrix so angle = 0

				this.set( 1, 0, 0, 0 );

				return this; // zero angle, arbitrary axis

			}

			// otherwise this singularity is angle = 180

			angle = Math.PI;

			const xx = ( m11 + 1 ) / 2;
			const yy = ( m22 + 1 ) / 2;
			const zz = ( m33 + 1 ) / 2;
			const xy = ( m12 + m21 ) / 4;
			const xz = ( m13 + m31 ) / 4;
			const yz = ( m23 + m32 ) / 4;

			if ( ( xx > yy ) && ( xx > zz ) ) {

				// m11 is the largest diagonal term

				if ( xx < epsilon ) {

					x = 0;
					y = 0.707106781;
					z = 0.707106781;

				} else {

					x = Math.sqrt( xx );
					y = xy / x;
					z = xz / x;

				}

			} else if ( yy > zz ) {

				// m22 is the largest diagonal term

				if ( yy < epsilon ) {

					x = 0.707106781;
					y = 0;
					z = 0.707106781;

				} else {

					y = Math.sqrt( yy );
					x = xy / y;
					z = yz / y;

				}

			} else {

				// m33 is the largest diagonal term so base result on this

				if ( zz < epsilon ) {

					x = 0.707106781;
					y = 0.707106781;
					z = 0;

				} else {

					z = Math.sqrt( zz );
					x = xz / z;
					y = yz / z;

				}

			}

			this.set( x, y, z, angle );

			return this; // return 180 deg rotation

		}

		// as we have reached here there are no singularities so we can handle normally

		let s = Math.sqrt( ( m32 - m23 ) * ( m32 - m23 ) +
			( m13 - m31 ) * ( m13 - m31 ) +
			( m21 - m12 ) * ( m21 - m12 ) ); // used to normalize

		if ( Math.abs( s ) < 0.001 ) s = 1;

		// prevent divide by zero, should not happen if matrix is orthogonal and should be
		// caught by singularity test above, but I've left it in just in case

		this.x = ( m32 - m23 ) / s;
		this.y = ( m13 - m31 ) / s;
		this.z = ( m21 - m12 ) / s;
		this.w = Math.acos( ( m11 + m22 + m33 - 1 ) / 2 );

		return this;

	}

	min( v ) {

		this.x = Math.min( this.x, v.x );
		this.y = Math.min( this.y, v.y );
		this.z = Math.min( this.z, v.z );
		this.w = Math.min( this.w, v.w );

		return this;

	}

	max( v ) {

		this.x = Math.max( this.x, v.x );
		this.y = Math.max( this.y, v.y );
		this.z = Math.max( this.z, v.z );
		this.w = Math.max( this.w, v.w );

		return this;

	}

	clamp( min, max ) {

		// assumes min < max, componentwise

		this.x = Math.max( min.x, Math.min( max.x, this.x ) );
		this.y = Math.max( min.y, Math.min( max.y, this.y ) );
		this.z = Math.max( min.z, Math.min( max.z, this.z ) );
		this.w = Math.max( min.w, Math.min( max.w, this.w ) );

		return this;

	}

	clampScalar( minVal, maxVal ) {

		this.x = Math.max( minVal, Math.min( maxVal, this.x ) );
		this.y = Math.max( minVal, Math.min( maxVal, this.y ) );
		this.z = Math.max( minVal, Math.min( maxVal, this.z ) );
		this.w = Math.max( minVal, Math.min( maxVal, this.w ) );

		return this;

	}

	clampLength( min, max ) {

		const length = this.length();

		return this.divideScalar( length || 1 ).multiplyScalar( Math.max( min, Math.min( max, length ) ) );

	}

	floor() {

		this.x = Math.floor( this.x );
		this.y = Math.floor( this.y );
		this.z = Math.floor( this.z );
		this.w = Math.floor( this.w );

		return this;

	}

	ceil() {

		this.x = Math.ceil( this.x );
		this.y = Math.ceil( this.y );
		this.z = Math.ceil( this.z );
		this.w = Math.ceil( this.w );

		return this;

	}

	round() {

		this.x = Math.round( this.x );
		this.y = Math.round( this.y );
		this.z = Math.round( this.z );
		this.w = Math.round( this.w );

		return this;

	}

	roundToZero() {

		this.x = Math.trunc( this.x );
		this.y = Math.trunc( this.y );
		this.z = Math.trunc( this.z );
		this.w = Math.trunc( this.w );

		return this;

	}

	negate() {

		this.x = - this.x;
		this.y = - this.y;
		this.z = - this.z;
		this.w = - this.w;

		return this;

	}

	dot( v ) {

		return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;

	}

	lengthSq() {

		return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;

	}

	length() {

		return Math.sqrt( this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w );

	}

	manhattanLength() {

		return Math.abs( this.x ) + Math.abs( this.y ) + Math.abs( this.z ) + Math.abs( this.w );

	}

	normalize() {

		return this.divideScalar( this.length() || 1 );

	}

	setLength( length ) {

		return this.normalize().multiplyScalar( length );

	}

	lerp( v, alpha ) {

		this.x += ( v.x - this.x ) * alpha;
		this.y += ( v.y - this.y ) * alpha;
		this.z += ( v.z - this.z ) * alpha;
		this.w += ( v.w - this.w ) * alpha;

		return this;

	}

	lerpVectors( v1, v2, alpha ) {

		this.x = v1.x + ( v2.x - v1.x ) * alpha;
		this.y = v1.y + ( v2.y - v1.y ) * alpha;
		this.z = v1.z + ( v2.z - v1.z ) * alpha;
		this.w = v1.w + ( v2.w - v1.w ) * alpha;

		return this;

	}

	equals( v ) {

		return ( ( v.x === this.x ) && ( v.y === this.y ) && ( v.z === this.z ) && ( v.w === this.w ) );

	}

	fromArray( array, offset = 0 ) {

		this.x = array[ offset ];
		this.y = array[ offset + 1 ];
		this.z = array[ offset + 2 ];
		this.w = array[ offset + 3 ];

		return this;

	}

	toArray( array = [], offset = 0 ) {

		array[ offset ] = this.x;
		array[ offset + 1 ] = this.y;
		array[ offset + 2 ] = this.z;
		array[ offset + 3 ] = this.w;

		return array;

	}

	fromBufferAttribute( attribute, index ) {

		this.x = attribute.getX( index );
		this.y = attribute.getY( index );
		this.z = attribute.getZ( index );
		this.w = attribute.getW( index );

		return this;

	}

	random() {

		this.x = Math.random();
		this.y = Math.random();
		this.z = Math.random();
		this.w = Math.random();

		return this;

	}

	*[ Symbol.iterator ]() {

		yield this.x;
		yield this.y;
		yield this.z;
		yield this.w;

	}

}

/*
 In options, we can specify:
 * Texture parameters for an auto-generated target texture
 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
*/
class RenderTarget extends (/* unused pure expression or super */ null && (EventDispatcher)) {

	constructor( width = 1, height = 1, options = {} ) {

		super();

		this.isRenderTarget = true;

		this.width = width;
		this.height = height;
		this.depth = 1;

		this.scissor = new Vector4( 0, 0, width, height );
		this.scissorTest = false;

		this.viewport = new Vector4( 0, 0, width, height );

		const image = { width: width, height: height, depth: 1 };

		options = Object.assign( {
			generateMipmaps: false,
			internalFormat: null,
			minFilter: LinearFilter,
			depthBuffer: true,
			stencilBuffer: false,
			depthTexture: null,
			samples: 0,
			count: 1
		}, options );

		const texture = new Texture( image, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace );

		texture.flipY = false;
		texture.generateMipmaps = options.generateMipmaps;
		texture.internalFormat = options.internalFormat;

		this.textures = [];

		const count = options.count;
		for ( let i = 0; i < count; i ++ ) {

			this.textures[ i ] = texture.clone();
			this.textures[ i ].isRenderTargetTexture = true;

		}

		this.depthBuffer = options.depthBuffer;
		this.stencilBuffer = options.stencilBuffer;

		this.depthTexture = options.depthTexture;

		this.samples = options.samples;

	}

	get texture() {

		return this.textures[ 0 ];

	}

	set texture( value ) {

		this.textures[ 0 ] = value;

	}

	setSize( width, height, depth = 1 ) {

		if ( this.width !== width || this.height !== height || this.depth !== depth ) {

			this.width = width;
			this.height = height;
			this.depth = depth;

			for ( let i = 0, il = this.textures.length; i < il; i ++ ) {

				this.textures[ i ].image.width = width;
				this.textures[ i ].image.height = height;
				this.textures[ i ].image.depth = depth;

			}

			this.dispose();

		}

		this.viewport.set( 0, 0, width, height );
		this.scissor.set( 0, 0, width, height );

	}

	clone() {

		return new this.constructor().copy( this );

	}

	copy( source ) {

		this.width = source.width;
		this.height = source.height;
		this.depth = source.depth;

		this.scissor.copy( source.scissor );
		this.scissorTest = source.scissorTest;

		this.viewport.copy( source.viewport );

		this.textures.length = 0;

		for ( let i = 0, il = source.textures.length; i < il; i ++ ) {

			this.textures[ i ] = source.textures[ i ].clone();
			this.textures[ i ].isRenderTargetTexture = true;

		}

		// ensure image object is not shared, see #20328

		const image = Object.assign( {}, source.texture.image );
		this.texture.source = new Source( image );

		this.depthBuffer = source.depthBuffer;
		this.stencilBuffer = source.stencilBuffer;

		if ( source.depthTexture !== null ) this.depthTexture = source.depthTexture.clone();

		this.samples = source.samples;

		return this;

	}

	dispose() {

		this.dispatchEvent( { type: 'dispose' } );

	}

}

class WebGLRenderTarget extends (/* unused pure expression or super */ null && (RenderTarget)) {

	constructor( width = 1, height = 1, options = {} ) {

		super( width, height, options );

		this.isWebGLRenderTarget = true;

	}

}

class DataArrayTexture extends Texture {

	constructor( data = null, width = 1, height = 1, depth = 1 ) {

		super( null );

		this.isDataArrayTexture = true;

		this.image = { data, width, height, depth };

		this.magFilter = NearestFilter;
		this.minFilter = NearestFilter;

		this.wrapR = ClampToEdgeWrapping;

		this.generateMipmaps = false;
		this.flipY = false;
		this.unpackAlignment = 1;

	}

}

class WebGLArrayRenderTarget extends (/* unused pure expression or super */ null && (WebGLRenderTarget)) {

	constructor( width = 1, height = 1, depth = 1, options = {} ) {

		super( width, height, options );

		this.isWebGLArrayRenderTarget = true;

		this.depth = depth;

		this.texture = new DataArrayTexture( null, width, height, depth );

		this.texture.isRenderTargetTexture = true;

	}

}

class Data3DTexture extends Texture {

	constructor( data = null, width = 1, height = 1, depth = 1 ) {

		// We're going to add .setXXX() methods for setting properties later.
		// Users can still set in DataTexture3D directly.
		//
		//	const texture = new THREE.DataTexture3D( data, width, height, depth );
		// 	texture.anisotropy = 16;
		//
		// See #14839

		super( null );

		this.isData3DTexture = true;

		this.image = { data, width, height, depth };

		this.magFilter = NearestFilter;
		this.minFilter = NearestFilter;

		this.wrapR = ClampToEdgeWrapping;

		this.generateMipmaps = false;
		this.flipY = false;
		this.unpackAlignment = 1;

	}

}

class WebGL3DRenderTarget extends (/* unused pure expression or super */ null && (WebGLRenderTarget)) {

	constructor( width = 1, height = 1, depth = 1, options = {} ) {

		super( width, height, options );

		this.isWebGL3DRenderTarget = true;

		this.depth = depth;

		this.texture = new Data3DTexture( null, width, height, depth );

		this.texture.isRenderTargetTexture = true;

	}

}

class Quaternion {

	constructor( x = 0, y = 0, z = 0, w = 1 ) {

		this.isQuaternion = true;

		this._x = x;
		this._y = y;
		this._z = z;
		this._w = w;

	}

	static slerpFlat( dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t ) {

		// fuzz-free, array-based Quaternion SLERP operation

		let x0 = src0[ srcOffset0 + 0 ],
			y0 = src0[ srcOffset0 + 1 ],
			z0 = src0[ srcOffset0 + 2 ],
			w0 = src0[ srcOffset0 + 3 ];

		const x1 = src1[ srcOffset1 + 0 ],
			y1 = src1[ srcOffset1 + 1 ],
			z1 = src1[ srcOffset1 + 2 ],
			w1 = src1[ srcOffset1 + 3 ];

		if ( t === 0 ) {

			dst[ dstOffset + 0 ] = x0;
			dst[ dstOffset + 1 ] = y0;
			dst[ dstOffset + 2 ] = z0;
			dst[ dstOffset + 3 ] = w0;
			return;

		}

		if ( t === 1 ) {

			dst[ dstOffset + 0 ] = x1;
			dst[ dstOffset + 1 ] = y1;
			dst[ dstOffset + 2 ] = z1;
			dst[ dstOffset + 3 ] = w1;
			return;

		}

		if ( w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1 ) {

			let s = 1 - t;
			const cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1,
				dir = ( cos >= 0 ? 1 : - 1 ),
				sqrSin = 1 - cos * cos;

			// Skip the Slerp for tiny steps to avoid numeric problems:
			if ( sqrSin > Number.EPSILON ) {

				const sin = Math.sqrt( sqrSin ),
					len = Math.atan2( sin, cos * dir );

				s = Math.sin( s * len ) / sin;
				t = Math.sin( t * len ) / sin;

			}

			const tDir = t * dir;

			x0 = x0 * s + x1 * tDir;
			y0 = y0 * s + y1 * tDir;
			z0 = z0 * s + z1 * tDir;
			w0 = w0 * s + w1 * tDir;

			// Normalize in case we just did a lerp:
			if ( s === 1 - t ) {

				const f = 1 / Math.sqrt( x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0 );

				x0 *= f;
				y0 *= f;
				z0 *= f;
				w0 *= f;

			}

		}

		dst[ dstOffset ] = x0;
		dst[ dstOffset + 1 ] = y0;
		dst[ dstOffset + 2 ] = z0;
		dst[ dstOffset + 3 ] = w0;

	}

	static multiplyQuaternionsFlat( dst, dstOffset, src0, srcOffset0, src1, srcOffset1 ) {

		const x0 = src0[ srcOffset0 ];
		const y0 = src0[ srcOffset0 + 1 ];
		const z0 = src0[ srcOffset0 + 2 ];
		const w0 = src0[ srcOffset0 + 3 ];

		const x1 = src1[ srcOffset1 ];
		const y1 = src1[ srcOffset1 + 1 ];
		const z1 = src1[ srcOffset1 + 2 ];
		const w1 = src1[ srcOffset1 + 3 ];

		dst[ dstOffset ] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
		dst[ dstOffset + 1 ] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
		dst[ dstOffset + 2 ] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
		dst[ dstOffset + 3 ] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;

		return dst;

	}

	get x() {

		return this._x;

	}

	set x( value ) {

		this._x = value;
		this._onChangeCallback();

	}

	get y() {

		return this._y;

	}

	set y( value ) {

		this._y = value;
		this._onChangeCallback();

	}

	get z() {

		return this._z;

	}

	set z( value ) {

		this._z = value;
		this._onChangeCallback();

	}

	get w() {

		return this._w;

	}

	set w( value ) {

		this._w = value;
		this._onChangeCallback();

	}

	set( x, y, z, w ) {

		this._x = x;
		this._y = y;
		this._z = z;
		this._w = w;

		this._onChangeCallback();

		return this;

	}

	clone() {

		return new this.constructor( this._x, this._y, this._z, this._w );

	}

	copy( quaternion ) {

		this._x = quaternion.x;
		this._y = quaternion.y;
		this._z = quaternion.z;
		this._w = quaternion.w;

		this._onChangeCallback();

		return this;

	}

	setFromEuler( euler, update = true ) {

		const x = euler._x, y = euler._y, z = euler._z, order = euler._order;

		// http://www.mathworks.com/matlabcentral/fileexchange/
		// 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
		//	content/SpinCalc.m

		const cos = Math.cos;
		const sin = Math.sin;

		const c1 = cos( x / 2 );
		const c2 = cos( y / 2 );
		const c3 = cos( z / 2 );

		const s1 = sin( x / 2 );
		const s2 = sin( y / 2 );
		const s3 = sin( z / 2 );

		switch ( order ) {

			case 'XYZ':
				this._x = s1 * c2 * c3 + c1 * s2 * s3;
				this._y = c1 * s2 * c3 - s1 * c2 * s3;
				this._z = c1 * c2 * s3 + s1 * s2 * c3;
				this._w = c1 * c2 * c3 - s1 * s2 * s3;
				break;

			case 'YXZ':
				this._x = s1 * c2 * c3 + c1 * s2 * s3;
				this._y = c1 * s2 * c3 - s1 * c2 * s3;
				this._z = c1 * c2 * s3 - s1 * s2 * c3;
				this._w = c1 * c2 * c3 + s1 * s2 * s3;
				break;

			case 'ZXY':
				this._x = s1 * c2 * c3 - c1 * s2 * s3;
				this._y = c1 * s2 * c3 + s1 * c2 * s3;
				this._z = c1 * c2 * s3 + s1 * s2 * c3;
				this._w = c1 * c2 * c3 - s1 * s2 * s3;
				break;

			case 'ZYX':
				this._x = s1 * c2 * c3 - c1 * s2 * s3;
				this._y = c1 * s2 * c3 + s1 * c2 * s3;
				this._z = c1 * c2 * s3 - s1 * s2 * c3;
				this._w = c1 * c2 * c3 + s1 * s2 * s3;
				break;

			case 'YZX':
				this._x = s1 * c2 * c3 + c1 * s2 * s3;
				this._y = c1 * s2 * c3 + s1 * c2 * s3;
				this._z = c1 * c2 * s3 - s1 * s2 * c3;
				this._w = c1 * c2 * c3 - s1 * s2 * s3;
				break;

			case 'XZY':
				this._x = s1 * c2 * c3 - c1 * s2 * s3;
				this._y = c1 * s2 * c3 - s1 * c2 * s3;
				this._z = c1 * c2 * s3 + s1 * s2 * c3;
				this._w = c1 * c2 * c3 + s1 * s2 * s3;
				break;

			default:
				console.warn( 'THREE.Quaternion: .setFromEuler() encountered an unknown order: ' + order );

		}

		if ( update === true ) this._onChangeCallback();

		return this;

	}

	setFromAxisAngle( axis, angle ) {

		// http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm

		// assumes axis is normalized

		const halfAngle = angle / 2, s = Math.sin( halfAngle );

		this._x = axis.x * s;
		this._y = axis.y * s;
		this._z = axis.z * s;
		this._w = Math.cos( halfAngle );

		this._onChangeCallback();

		return this;

	}

	setFromRotationMatrix( m ) {

		// http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm

		// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)

		const te = m.elements,

			m11 = te[ 0 ], m12 = te[ 4 ], m13 = te[ 8 ],
			m21 = te[ 1 ], m22 = te[ 5 ], m23 = te[ 9 ],
			m31 = te[ 2 ], m32 = te[ 6 ], m33 = te[ 10 ],

			trace = m11 + m22 + m33;

		if ( trace > 0 ) {

			const s = 0.5 / Math.sqrt( trace + 1.0 );

			this._w = 0.25 / s;
			this._x = ( m32 - m23 ) * s;
			this._y = ( m13 - m31 ) * s;
			this._z = ( m21 - m12 ) * s;

		} else if ( m11 > m22 && m11 > m33 ) {

			const s = 2.0 * Math.sqrt( 1.0 + m11 - m22 - m33 );

			this._w = ( m32 - m23 ) / s;
			this._x = 0.25 * s;
			this._y = ( m12 + m21 ) / s;
			this._z = ( m13 + m31 ) / s;

		} else if ( m22 > m33 ) {

			const s = 2.0 * Math.sqrt( 1.0 + m22 - m11 - m33 );

			this._w = ( m13 - m31 ) / s;
			this._x = ( m12 + m21 ) / s;
			this._y = 0.25 * s;
			this._z = ( m23 + m32 ) / s;

		} else {

			const s = 2.0 * Math.sqrt( 1.0 + m33 - m11 - m22 );

			this._w = ( m21 - m12 ) / s;
			this._x = ( m13 + m31 ) / s;
			this._y = ( m23 + m32 ) / s;
			this._z = 0.25 * s;

		}

		this._onChangeCallback();

		return this;

	}

	setFromUnitVectors( vFrom, vTo ) {

		// assumes direction vectors vFrom and vTo are normalized

		let r = vFrom.dot( vTo ) + 1;

		if ( r < Number.EPSILON ) {

			// vFrom and vTo point in opposite directions

			r = 0;

			if ( Math.abs( vFrom.x ) > Math.abs( vFrom.z ) ) {

				this._x = - vFrom.y;
				this._y = vFrom.x;
				this._z = 0;
				this._w = r;

			} else {

				this._x = 0;
				this._y = - vFrom.z;
				this._z = vFrom.y;
				this._w = r;

			}

		} else {

			// crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3

			this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
			this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
			this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
			this._w = r;

		}

		return this.normalize();

	}

	angleTo( q ) {

		return 2 * Math.acos( Math.abs( clamp( this.dot( q ), - 1, 1 ) ) );

	}

	rotateTowards( q, step ) {

		const angle = this.angleTo( q );

		if ( angle === 0 ) return this;

		const t = Math.min( 1, step / angle );

		this.slerp( q, t );

		return this;

	}

	identity() {

		return this.set( 0, 0, 0, 1 );

	}

	invert() {

		// quaternion is assumed to have unit length

		return this.conjugate();

	}

	conjugate() {

		this._x *= - 1;
		this._y *= - 1;
		this._z *= - 1;

		this._onChangeCallback();

		return this;

	}

	dot( v ) {

		return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;

	}

	lengthSq() {

		return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;

	}

	length() {

		return Math.sqrt( this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w );

	}

	normalize() {

		let l = this.length();

		if ( l === 0 ) {

			this._x = 0;
			this._y = 0;
			this._z = 0;
			this._w = 1;

		} else {

			l = 1 / l;

			this._x = this._x * l;
			this._y = this._y * l;
			this._z = this._z * l;
			this._w = this._w * l;

		}

		this._onChangeCallback();

		return this;

	}

	multiply( q ) {

		return this.multiplyQuaternions( this, q );

	}

	premultiply( q ) {

		return this.multiplyQuaternions( q, this );

	}

	multiplyQuaternions( a, b ) {

		// from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm

		const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
		const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;

		this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
		this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
		this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
		this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;

		this._onChangeCallback();

		return this;

	}

	slerp( qb, t ) {

		if ( t === 0 ) return this;
		if ( t === 1 ) return this.copy( qb );

		const x = this._x, y = this._y, z = this._z, w = this._w;

		// http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/

		let cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;

		if ( cosHalfTheta < 0 ) {

			this._w = - qb._w;
			this._x = - qb._x;
			this._y = - qb._y;
			this._z = - qb._z;

			cosHalfTheta = - cosHalfTheta;

		} else {

			this.copy( qb );

		}

		if ( cosHalfTheta >= 1.0 ) {

			this._w = w;
			this._x = x;
			this._y = y;
			this._z = z;

			return this;

		}

		const sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;

		if ( sqrSinHalfTheta <= Number.EPSILON ) {

			const s = 1 - t;
			this._w = s * w + t * this._w;
			this._x = s * x + t * this._x;
			this._y = s * y + t * this._y;
			this._z = s * z + t * this._z;

			this.normalize(); // normalize calls _onChangeCallback()

			return this;

		}

		const sinHalfTheta = Math.sqrt( sqrSinHalfTheta );
		const halfTheta = Math.atan2( sinHalfTheta, cosHalfTheta );
		const ratioA = Math.sin( ( 1 - t ) * halfTheta ) / sinHalfTheta,
			ratioB = Math.sin( t * halfTheta ) / sinHalfTheta;

		this._w = ( w * ratioA + this._w * ratioB );
		this._x = ( x * ratioA + this._x * ratioB );
		this._y = ( y * ratioA + this._y * ratioB );
		this._z = ( z * ratioA + this._z * ratioB );

		this._onChangeCallback();

		return this;

	}

	slerpQuaternions( qa, qb, t ) {

		return this.copy( qa ).slerp( qb, t );

	}

	random() {

		// sets this quaternion to a uniform random unit quaternnion

		// Ken Shoemake
		// Uniform random rotations
		// D. Kirk, editor, Graphics Gems III, pages 124-132. Academic Press, New York, 1992.

		const theta1 = 2 * Math.PI * Math.random();
		const theta2 = 2 * Math.PI * Math.random();

		const x0 = Math.random();
		const r1 = Math.sqrt( 1 - x0 );
		const r2 = Math.sqrt( x0 );

		return this.set(
			r1 * Math.sin( theta1 ),
			r1 * Math.cos( theta1 ),
			r2 * Math.sin( theta2 ),
			r2 * Math.cos( theta2 ),
		);

	}

	equals( quaternion ) {

		return ( quaternion._x === this._x ) && ( quaternion._y === this._y ) && ( quaternion._z === this._z ) && ( quaternion._w === this._w );

	}

	fromArray( array, offset = 0 ) {

		this._x = array[ offset ];
		this._y = array[ offset + 1 ];
		this._z = array[ offset + 2 ];
		this._w = array[ offset + 3 ];

		this._onChangeCallback();

		return this;

	}

	toArray( array = [], offset = 0 ) {

		array[ offset ] = this._x;
		array[ offset + 1 ] = this._y;
		array[ offset + 2 ] = this._z;
		array[ offset + 3 ] = this._w;

		return array;

	}

	fromBufferAttribute( attribute, index ) {

		this._x = attribute.getX( index );
		this._y = attribute.getY( index );
		this._z = attribute.getZ( index );
		this._w = attribute.getW( index );

		this._onChangeCallback();

		return this;

	}

	toJSON() {

		return this.toArray();

	}

	_onChange( callback ) {

		this._onChangeCallback = callback;

		return this;

	}

	_onChangeCallback() {}

	*[ Symbol.iterator ]() {

		yield this._x;
		yield this._y;
		yield this._z;
		yield this._w;

	}

}

class Vector3 {

	constructor( x = 0, y = 0, z = 0 ) {

		Vector3.prototype.isVector3 = true;

		this.x = x;
		this.y = y;
		this.z = z;

	}

	set( x, y, z ) {

		if ( z === undefined ) z = this.z; // sprite.scale.set(x,y)

		this.x = x;
		this.y = y;
		this.z = z;

		return this;

	}

	setScalar( scalar ) {

		this.x = scalar;
		this.y = scalar;
		this.z = scalar;

		return this;

	}

	setX( x ) {

		this.x = x;

		return this;

	}

	setY( y ) {

		this.y = y;

		return this;

	}

	setZ( z ) {

		this.z = z;

		return this;

	}

	setComponent( index, value ) {

		switch ( index ) {

			case 0: this.x = value; break;
			case 1: this.y = value; break;
			case 2: this.z = value; break;
			default: throw new Error( 'index is out of range: ' + index );

		}

		return this;

	}

	getComponent( index ) {

		switch ( index ) {

			case 0: return this.x;
			case 1: return this.y;
			case 2: return this.z;
			default: throw new Error( 'index is out of range: ' + index );

		}

	}

	clone() {

		return new this.constructor( this.x, this.y, this.z );

	}

	copy( v ) {

		this.x = v.x;
		this.y = v.y;
		this.z = v.z;

		return this;

	}

	add( v ) {

		this.x += v.x;
		this.y += v.y;
		this.z += v.z;

		return this;

	}

	addScalar( s ) {

		this.x += s;
		this.y += s;
		this.z += s;

		return this;

	}

	addVectors( a, b ) {

		this.x = a.x + b.x;
		this.y = a.y + b.y;
		this.z = a.z + b.z;

		return this;

	}

	addScaledVector( v, s ) {

		this.x += v.x * s;
		this.y += v.y * s;
		this.z += v.z * s;

		return this;

	}

	sub( v ) {

		this.x -= v.x;
		this.y -= v.y;
		this.z -= v.z;

		return this;

	}

	subScalar( s ) {

		this.x -= s;
		this.y -= s;
		this.z -= s;

		return this;

	}

	subVectors( a, b ) {

		this.x = a.x - b.x;
		this.y = a.y - b.y;
		this.z = a.z - b.z;

		return this;

	}

	multiply( v ) {

		this.x *= v.x;
		this.y *= v.y;
		this.z *= v.z;

		return this;

	}

	multiplyScalar( scalar ) {

		this.x *= scalar;
		this.y *= scalar;
		this.z *= scalar;

		return this;

	}

	multiplyVectors( a, b ) {

		this.x = a.x * b.x;
		this.y = a.y * b.y;
		this.z = a.z * b.z;

		return this;

	}

	applyEuler( euler ) {

		return this.applyQuaternion( _quaternion$4.setFromEuler( euler ) );

	}

	applyAxisAngle( axis, angle ) {

		return this.applyQuaternion( _quaternion$4.setFromAxisAngle( axis, angle ) );

	}

	applyMatrix3( m ) {

		const x = this.x, y = this.y, z = this.z;
		const e = m.elements;

		this.x = e[ 0 ] * x + e[ 3 ] * y + e[ 6 ] * z;
		this.y = e[ 1 ] * x + e[ 4 ] * y + e[ 7 ] * z;
		this.z = e[ 2 ] * x + e[ 5 ] * y + e[ 8 ] * z;

		return this;

	}

	applyNormalMatrix( m ) {

		return this.applyMatrix3( m ).normalize();

	}

	applyMatrix4( m ) {

		const x = this.x, y = this.y, z = this.z;
		const e = m.elements;

		const w = 1 / ( e[ 3 ] * x + e[ 7 ] * y + e[ 11 ] * z + e[ 15 ] );

		this.x = ( e[ 0 ] * x + e[ 4 ] * y + e[ 8 ] * z + e[ 12 ] ) * w;
		this.y = ( e[ 1 ] * x + e[ 5 ] * y + e[ 9 ] * z + e[ 13 ] ) * w;
		this.z = ( e[ 2 ] * x + e[ 6 ] * y + e[ 10 ] * z + e[ 14 ] ) * w;

		return this;

	}

	applyQuaternion( q ) {

		// quaternion q is assumed to have unit length

		const vx = this.x, vy = this.y, vz = this.z;
		const qx = q.x, qy = q.y, qz = q.z, qw = q.w;

		// t = 2 * cross( q.xyz, v );
		const tx = 2 * ( qy * vz - qz * vy );
		const ty = 2 * ( qz * vx - qx * vz );
		const tz = 2 * ( qx * vy - qy * vx );

		// v + q.w * t + cross( q.xyz, t );
		this.x = vx + qw * tx + qy * tz - qz * ty;
		this.y = vy + qw * ty + qz * tx - qx * tz;
		this.z = vz + qw * tz + qx * ty - qy * tx;

		return this;

	}

	project( camera ) {

		return this.applyMatrix4( camera.matrixWorldInverse ).applyMatrix4( camera.projectionMatrix );

	}

	unproject( camera ) {

		return this.applyMatrix4( camera.projectionMatrixInverse ).applyMatrix4( camera.matrixWorld );

	}

	transformDirection( m ) {

		// input: THREE.Matrix4 affine matrix
		// vector interpreted as a direction

		const x = this.x, y = this.y, z = this.z;
		const e = m.elements;

		this.x = e[ 0 ] * x + e[ 4 ] * y + e[ 8 ] * z;
		this.y = e[ 1 ] * x + e[ 5 ] * y + e[ 9 ] * z;
		this.z = e[ 2 ] * x + e[ 6 ] * y + e[ 10 ] * z;

		return this.normalize();

	}

	divide( v ) {

		this.x /= v.x;
		this.y /= v.y;
		this.z /= v.z;

		return this;

	}

	divideScalar( scalar ) {

		return this.multiplyScalar( 1 / scalar );

	}

	min( v ) {

		this.x = Math.min( this.x, v.x );
		this.y = Math.min( this.y, v.y );
		this.z = Math.min( this.z, v.z );

		return this;

	}

	max( v ) {

		this.x = Math.max( this.x, v.x );
		this.y = Math.max( this.y, v.y );
		this.z = Math.max( this.z, v.z );

		return this;

	}

	clamp( min, max ) {

		// assumes min < max, componentwise

		this.x = Math.max( min.x, Math.min( max.x, this.x ) );
		this.y = Math.max( min.y, Math.min( max.y, this.y ) );
		this.z = Math.max( min.z, Math.min( max.z, this.z ) );

		return this;

	}

	clampScalar( minVal, maxVal ) {

		this.x = Math.max( minVal, Math.min( maxVal, this.x ) );
		this.y = Math.max( minVal, Math.min( maxVal, this.y ) );
		this.z = Math.max( minVal, Math.min( maxVal, this.z ) );

		return this;

	}

	clampLength( min, max ) {

		const length = this.length();

		return this.divideScalar( length || 1 ).multiplyScalar( Math.max( min, Math.min( max, length ) ) );

	}

	floor() {

		this.x = Math.floor( this.x );
		this.y = Math.floor( this.y );
		this.z = Math.floor( this.z );

		return this;

	}

	ceil() {

		this.x = Math.ceil( this.x );
		this.y = Math.ceil( this.y );
		this.z = Math.ceil( this.z );

		return this;

	}

	round() {

		this.x = Math.round( this.x );
		this.y = Math.round( this.y );
		this.z = Math.round( this.z );

		return this;

	}

	roundToZero() {

		this.x = Math.trunc( this.x );
		this.y = Math.trunc( this.y );
		this.z = Math.trunc( this.z );

		return this;

	}

	negate() {

		this.x = - this.x;
		this.y = - this.y;
		this.z = - this.z;

		return this;

	}

	dot( v ) {

		return this.x * v.x + this.y * v.y + this.z * v.z;

	}

	// TODO lengthSquared?

	lengthSq() {

		return this.x * this.x + this.y * this.y + this.z * this.z;

	}

	length() {

		return Math.sqrt( this.x * this.x + this.y * this.y + this.z * this.z );

	}

	manhattanLength() {

		return Math.abs( this.x ) + Math.abs( this.y ) + Math.abs( this.z );

	}

	normalize() {

		return this.divideScalar( this.length() || 1 );

	}

	setLength( length ) {

		return this.normalize().multiplyScalar( length );

	}

	lerp( v, alpha ) {

		this.x += ( v.x - this.x ) * alpha;
		this.y += ( v.y - this.y ) * alpha;
		this.z += ( v.z - this.z ) * alpha;

		return this;

	}

	lerpVectors( v1, v2, alpha ) {

		this.x = v1.x + ( v2.x - v1.x ) * alpha;
		this.y = v1.y + ( v2.y - v1.y ) * alpha;
		this.z = v1.z + ( v2.z - v1.z ) * alpha;

		return this;

	}

	cross( v ) {

		return this.crossVectors( this, v );

	}

	crossVectors( a, b ) {

		const ax = a.x, ay = a.y, az = a.z;
		const bx = b.x, by = b.y, bz = b.z;

		this.x = ay * bz - az * by;
		this.y = az * bx - ax * bz;
		this.z = ax * by - ay * bx;

		return this;

	}

	projectOnVector( v ) {

		const denominator = v.lengthSq();

		if ( denominator === 0 ) return this.set( 0, 0, 0 );

		const scalar = v.dot( this ) / denominator;

		return this.copy( v ).multiplyScalar( scalar );

	}

	projectOnPlane( planeNormal ) {

		_vector$c.copy( this ).projectOnVector( planeNormal );

		return this.sub( _vector$c );

	}

	reflect( normal ) {

		// reflect incident vector off plane orthogonal to normal
		// normal is assumed to have unit length

		return this.sub( _vector$c.copy( normal ).multiplyScalar( 2 * this.dot( normal ) ) );

	}

	angleTo( v ) {

		const denominator = Math.sqrt( this.lengthSq() * v.lengthSq() );

		if ( denominator === 0 ) return Math.PI / 2;

		const theta = this.dot( v ) / denominator;

		// clamp, to handle numerical problems

		return Math.acos( clamp( theta, - 1, 1 ) );

	}

	distanceTo( v ) {

		return Math.sqrt( this.distanceToSquared( v ) );

	}

	distanceToSquared( v ) {

		const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;

		return dx * dx + dy * dy + dz * dz;

	}

	manhattanDistanceTo( v ) {

		return Math.abs( this.x - v.x ) + Math.abs( this.y - v.y ) + Math.abs( this.z - v.z );

	}

	setFromSpherical( s ) {

		return this.setFromSphericalCoords( s.radius, s.phi, s.theta );

	}

	setFromSphericalCoords( radius, phi, theta ) {

		const sinPhiRadius = Math.sin( phi ) * radius;

		this.x = sinPhiRadius * Math.sin( theta );
		this.y = Math.cos( phi ) * radius;
		this.z = sinPhiRadius * Math.cos( theta );

		return this;

	}

	setFromCylindrical( c ) {

		return this.setFromCylindricalCoords( c.radius, c.theta, c.y );

	}

	setFromCylindricalCoords( radius, theta, y ) {

		this.x = radius * Math.sin( theta );
		this.y = y;
		this.z = radius * Math.cos( theta );

		return this;

	}

	setFromMatrixPosition( m ) {

		const e = m.elements;

		this.x = e[ 12 ];
		this.y = e[ 13 ];
		this.z = e[ 14 ];

		return this;

	}

	setFromMatrixScale( m ) {

		const sx = this.setFromMatrixColumn( m, 0 ).length();
		const sy = this.setFromMatrixColumn( m, 1 ).length();
		const sz = this.setFromMatrixColumn( m, 2 ).length();

		this.x = sx;
		this.y = sy;
		this.z = sz;

		return this;

	}

	setFromMatrixColumn( m, index ) {

		return this.fromArray( m.elements, index * 4 );

	}

	setFromMatrix3Column( m, index ) {

		return this.fromArray( m.elements, index * 3 );

	}

	setFromEuler( e ) {

		this.x = e._x;
		this.y = e._y;
		this.z = e._z;

		return this;

	}

	setFromColor( c ) {

		this.x = c.r;
		this.y = c.g;
		this.z = c.b;

		return this;

	}

	equals( v ) {

		return ( ( v.x === this.x ) && ( v.y === this.y ) && ( v.z === this.z ) );

	}

	fromArray( array, offset = 0 ) {

		this.x = array[ offset ];
		this.y = array[ offset + 1 ];
		this.z = array[ offset + 2 ];

		return this;

	}

	toArray( array = [], offset = 0 ) {

		array[ offset ] = this.x;
		array[ offset + 1 ] = this.y;
		array[ offset + 2 ] = this.z;

		return array;

	}

	fromBufferAttribute( attribute, index ) {

		this.x = attribute.getX( index );
		this.y = attribute.getY( index );
		this.z = attribute.getZ( index );

		return this;

	}

	random() {

		this.x = Math.random();
		this.y = Math.random();
		this.z = Math.random();

		return this;

	}

	randomDirection() {

		// https://mathworld.wolfram.com/SpherePointPicking.html

		const theta = Math.random() * Math.PI * 2;
		const u = Math.random() * 2 - 1;
		const c = Math.sqrt( 1 - u * u );

		this.x = c * Math.cos( theta );
		this.y = u;
		this.z = c * Math.sin( theta );

		return this;

	}

	*[ Symbol.iterator ]() {

		yield this.x;
		yield this.y;
		yield this.z;

	}

}

const _vector$c = /*@__PURE__*/ new Vector3();
const _quaternion$4 = /*@__PURE__*/ new Quaternion();

class Box3 {

	constructor( min = new Vector3( + Infinity, + Infinity, + Infinity ), max = new Vector3( - Infinity, - Infinity, - Infinity ) ) {

		this.isBox3 = true;

		this.min = min;
		this.max = max;

	}

	set( min, max ) {

		this.min.copy( min );
		this.max.copy( max );

		return this;

	}

	setFromArray( array ) {

		this.makeEmpty();

		for ( let i = 0, il = array.length; i < il; i += 3 ) {

			this.expandByPoint( _vector$b.fromArray( array, i ) );

		}

		return this;

	}

	setFromBufferAttribute( attribute ) {

		this.makeEmpty();

		for ( let i = 0, il = attribute.count; i < il; i ++ ) {

			this.expandByPoint( _vector$b.fromBufferAttribute( attribute, i ) );

		}

		return this;

	}

	setFromPoints( points ) {

		this.makeEmpty();

		for ( let i = 0, il = points.length; i < il; i ++ ) {

			this.expandByPoint( points[ i ] );

		}

		return this;

	}

	setFromCenterAndSize( center, size ) {

		const halfSize = _vector$b.copy( size ).multiplyScalar( 0.5 );

		this.min.copy( center ).sub( halfSize );
		this.max.copy( center ).add( halfSize );

		return this;

	}

	setFromObject( object, precise = false ) {

		this.makeEmpty();

		return this.expandByObject( object, precise );

	}

	clone() {

		return new this.constructor().copy( this );

	}

	copy( box ) {

		this.min.copy( box.min );
		this.max.copy( box.max );

		return this;

	}

	makeEmpty() {

		this.min.x = this.min.y = this.min.z = + Infinity;
		this.max.x = this.max.y = this.max.z = - Infinity;

		return this;

	}

	isEmpty() {

		// this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes

		return ( this.max.x < this.min.x ) || ( this.max.y < this.min.y ) || ( this.max.z < this.min.z );

	}

	getCenter( target ) {

		return this.isEmpty() ? target.set( 0, 0, 0 ) : target.addVectors( this.min, this.max ).multiplyScalar( 0.5 );

	}

	getSize( target ) {

		return this.isEmpty() ? target.set( 0, 0, 0 ) : target.subVectors( this.max, this.min );

	}

	expandByPoint( point ) {

		this.min.min( point );
		this.max.max( point );

		return this;

	}

	expandByVector( vector ) {

		this.min.sub( vector );
		this.max.add( vector );

		return this;

	}

	expandByScalar( scalar ) {

		this.min.addScalar( - scalar );
		this.max.addScalar( scalar );

		return this;

	}

	expandByObject( object, precise = false ) {

		// Computes the world-axis-aligned bounding box of an object (including its children),
		// accounting for both the object's, and children's, world transforms

		object.updateWorldMatrix( false, false );

		const geometry = object.geometry;

		if ( geometry !== undefined ) {

			const positionAttribute = geometry.getAttribute( 'position' );

			// precise AABB computation based on vertex data requires at least a position attribute.
			// instancing isn't supported so far and uses the normal (conservative) code path.

			if ( precise === true && positionAttribute !== undefined && object.isInstancedMesh !== true ) {

				for ( let i = 0, l = positionAttribute.count; i < l; i ++ ) {

					if ( object.isMesh === true ) {

						object.getVertexPosition( i, _vector$b );

					} else {

						_vector$b.fromBufferAttribute( positionAttribute, i );

					}

					_vector$b.applyMatrix4( object.matrixWorld );
					this.expandByPoint( _vector$b );

				}

			} else {

				if ( object.boundingBox !== undefined ) {

					// object-level bounding box

					if ( object.boundingBox === null ) {

						object.computeBoundingBox();

					}

					_box$4.copy( object.boundingBox );


				} else {

					// geometry-level bounding box

					if ( geometry.boundingBox === null ) {

						geometry.computeBoundingBox();

					}

					_box$4.copy( geometry.boundingBox );

				}

				_box$4.applyMatrix4( object.matrixWorld );

				this.union( _box$4 );

			}

		}

		const children = object.children;

		for ( let i = 0, l = children.length; i < l; i ++ ) {

			this.expandByObject( children[ i ], precise );

		}

		return this;

	}

	containsPoint( point ) {

		return point.x < this.min.x || point.x > this.max.x ||
			point.y < this.min.y || point.y > this.max.y ||
			point.z < this.min.z || point.z > this.max.z ? false : true;

	}

	containsBox( box ) {

		return this.min.x <= box.min.x && box.max.x <= this.max.x &&
			this.min.y <= box.min.y && box.max.y <= this.max.y &&
			this.min.z <= box.min.z && box.max.z <= this.max.z;

	}

	getParameter( point, target ) {

		// This can potentially have a divide by zero if the box
		// has a size dimension of 0.

		return target.set(
			( point.x - this.min.x ) / ( this.max.x - this.min.x ),
			( point.y - this.min.y ) / ( this.max.y - this.min.y ),
			( point.z - this.min.z ) / ( this.max.z - this.min.z )
		);

	}

	intersectsBox( box ) {

		// using 6 splitting planes to rule out intersections.
		return box.max.x < this.min.x || box.min.x > this.max.x ||
			box.max.y < this.min.y || box.min.y > this.max.y ||
			box.max.z < this.min.z || box.min.z > this.max.z ? false : true;

	}

	intersectsSphere( sphere ) {

		// Find the point on the AABB closest to the sphere center.
		this.clampPoint( sphere.center, _vector$b );

		// If that point is inside the sphere, the AABB and sphere intersect.
		return _vector$b.distanceToSquared( sphere.center ) <= ( sphere.radius * sphere.radius );

	}

	intersectsPlane( plane ) {

		// We compute the minimum and maximum dot product values. If those values
		// are on the same side (back or front) of the plane, then there is no intersection.

		let min, max;

		if ( plane.normal.x > 0 ) {

			min = plane.normal.x * this.min.x;
			max = plane.normal.x * this.max.x;

		} else {

			min = plane.normal.x * this.max.x;
			max = plane.normal.x * this.min.x;

		}

		if ( plane.normal.y > 0 ) {

			min += plane.normal.y * this.min.y;
			max += plane.normal.y * this.max.y;

		} else {

			min += plane.normal.y * this.max.y;
			max += plane.normal.y * this.min.y;

		}

		if ( plane.normal.z > 0 ) {

			min += plane.normal.z * this.min.z;
			max += plane.normal.z * this.max.z;

		} else {

			min += plane.normal.z * this.max.z;
			max += plane.normal.z * this.min.z;

		}

		return ( min <= - plane.constant && max >= - plane.constant );

	}

	intersectsTriangle( triangle ) {

		if ( this.isEmpty() ) {

			return false;

		}

		// compute box center and extents
		this.getCenter( _center );
		_extents.subVectors( this.max, _center );

		// translate triangle to aabb origin
		_v0$2.subVectors( triangle.a, _center );
		_v1$7.subVectors( triangle.b, _center );
		_v2$4.subVectors( triangle.c, _center );

		// compute edge vectors for triangle
		_f0.subVectors( _v1$7, _v0$2 );
		_f1.subVectors( _v2$4, _v1$7 );
		_f2.subVectors( _v0$2, _v2$4 );

		// test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
		// make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
		// axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
		let axes = [
			0, - _f0.z, _f0.y, 0, - _f1.z, _f1.y, 0, - _f2.z, _f2.y,
			_f0.z, 0, - _f0.x, _f1.z, 0, - _f1.x, _f2.z, 0, - _f2.x,
			- _f0.y, _f0.x, 0, - _f1.y, _f1.x, 0, - _f2.y, _f2.x, 0
		];
		if ( ! satForAxes( axes, _v0$2, _v1$7, _v2$4, _extents ) ) {

			return false;

		}

		// test 3 face normals from the aabb
		axes = [ 1, 0, 0, 0, 1, 0, 0, 0, 1 ];
		if ( ! satForAxes( axes, _v0$2, _v1$7, _v2$4, _extents ) ) {

			return false;

		}

		// finally testing the face normal of the triangle
		// use already existing triangle edge vectors here
		_triangleNormal.crossVectors( _f0, _f1 );
		axes = [ _triangleNormal.x, _triangleNormal.y, _triangleNormal.z ];

		return satForAxes( axes, _v0$2, _v1$7, _v2$4, _extents );

	}

	clampPoint( point, target ) {

		return target.copy( point ).clamp( this.min, this.max );

	}

	distanceToPoint( point ) {

		return this.clampPoint( point, _vector$b ).distanceTo( point );

	}

	getBoundingSphere( target ) {

		if ( this.isEmpty() ) {

			target.makeEmpty();

		} else {

			this.getCenter( target.center );

			target.radius = this.getSize( _vector$b ).length() * 0.5;

		}

		return target;

	}

	intersect( box ) {

		this.min.max( box.min );
		this.max.min( box.max );

		// ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
		if ( this.isEmpty() ) this.makeEmpty();

		return this;

	}

	union( box ) {

		this.min.min( box.min );
		this.max.max( box.max );

		return this;

	}

	applyMatrix4( matrix ) {

		// transform of empty box is an empty box.
		if ( this.isEmpty() ) return this;

		// NOTE: I am using a binary pattern to specify all 2^3 combinations below
		_points[ 0 ].set( this.min.x, this.min.y, this.min.z ).applyMatrix4( matrix ); // 000
		_points[ 1 ].set( this.min.x, this.min.y, this.max.z ).applyMatrix4( matrix ); // 001
		_points[ 2 ].set( this.min.x, this.max.y, this.min.z ).applyMatrix4( matrix ); // 010
		_points[ 3 ].set( this.min.x, this.max.y, this.max.z ).applyMatrix4( matrix ); // 011
		_points[ 4 ].set( this.max.x, this.min.y, this.min.z ).applyMatrix4( matrix ); // 100
		_points[ 5 ].set( this.max.x, this.min.y, this.max.z ).applyMatrix4( matrix ); // 101
		_points[ 6 ].set( this.max.x, this.max.y, this.min.z ).applyMatrix4( matrix ); // 110
		_points[ 7 ].set( this.max.x, this.max.y, this.max.z ).applyMatrix4( matrix ); // 111

		this.setFromPoints( _points );

		return this;

	}

	translate( offset ) {

		this.min.add( offset );
		this.max.add( offset );

		return this;

	}

	equals( box ) {

		return box.min.equals( this.min ) && box.max.equals( this.max );

	}

}

const _points = [
	/*@__PURE__*/ new Vector3(),
	/*@__PURE__*/ new Vector3(),
	/*@__PURE__*/ new Vector3(),
	/*@__PURE__*/ new Vector3(),
	/*@__PURE__*/ new Vector3(),
	/*@__PURE__*/ new Vector3(),
	/*@__PURE__*/ new Vector3(),
	/*@__PURE__*/ new Vector3()
];

const _vector$b = /*@__PURE__*/ new Vector3();

const _box$4 = /*@__PURE__*/ new Box3();

// triangle centered vertices

const _v0$2 = /*@__PURE__*/ new Vector3();
const _v1$7 = /*@__PURE__*/ new Vector3();
const _v2$4 = /*@__PURE__*/ new Vector3();

// triangle edge vectors

const _f0 = /*@__PURE__*/ new Vector3();
const _f1 = /*@__PURE__*/ new Vector3();
const _f2 = /*@__PURE__*/ new Vector3();

const _center = /*@__PURE__*/ new Vector3();
const _extents = /*@__PURE__*/ new Vector3();
const _triangleNormal = /*@__PURE__*/ new Vector3();
const _testAxis = /*@__PURE__*/ new Vector3();

function satForAxes( axes, v0, v1, v2, extents ) {

	for ( let i = 0, j = axes.length - 3; i <= j; i += 3 ) {

		_testAxis.fromArray( axes, i );
		// project the aabb onto the separating axis
		const r = extents.x * Math.abs( _testAxis.x ) + extents.y * Math.abs( _testAxis.y ) + extents.z * Math.abs( _testAxis.z );
		// project all 3 vertices of the triangle onto the separating axis
		const p0 = v0.dot( _testAxis );
		const p1 = v1.dot( _testAxis );
		const p2 = v2.dot( _testAxis );
		// actual test, basically see if either of the most extreme of the triangle points intersects r
		if ( Math.max( - Math.max( p0, p1, p2 ), Math.min( p0, p1, p2 ) ) > r ) {

			// points of the projected triangle are outside the projected half-length of the aabb
			// the axis is separating and we can exit
			return false;

		}

	}

	return true;

}

const _box$3 = /*@__PURE__*/ new Box3();
const _v1$6 = /*@__PURE__*/ new Vector3();
const _v2$3 = /*@__PURE__*/ new Vector3();

class Sphere {

	constructor( center = new Vector3(), radius = - 1 ) {

		this.isSphere = true;

		this.center = center;
		this.radius = radius;

	}

	set( center, radius ) {

		this.center.copy( center );
		this.radius = radius;

		return this;

	}

	setFromPoints( points, optionalCenter ) {

		const center = this.center;

		if ( optionalCenter !== undefined ) {

			center.copy( optionalCenter );

		} else {

			_box$3.setFromPoints( points ).getCenter( center );

		}

		let maxRadiusSq = 0;

		for ( let i = 0, il = points.length; i < il; i ++ ) {

			maxRadiusSq = Math.max( maxRadiusSq, center.distanceToSquared( points[ i ] ) );

		}

		this.radius = Math.sqrt( maxRadiusSq );

		return this;

	}

	copy( sphere ) {

		this.center.copy( sphere.center );
		this.radius = sphere.radius;

		return this;

	}

	isEmpty() {

		return ( this.radius < 0 );

	}

	makeEmpty() {

		this.center.set( 0, 0, 0 );
		this.radius = - 1;

		return this;

	}

	containsPoint( point ) {

		return ( point.distanceToSquared( this.center ) <= ( this.radius * this.radius ) );

	}

	distanceToPoint( point ) {

		return ( point.distanceTo( this.center ) - this.radius );

	}

	intersectsSphere( sphere ) {

		const radiusSum = this.radius + sphere.radius;

		return sphere.center.distanceToSquared( this.center ) <= ( radiusSum * radiusSum );

	}

	intersectsBox( box ) {

		return box.intersectsSphere( this );

	}

	intersectsPlane( plane ) {

		return Math.abs( plane.distanceToPoint( this.center ) ) <= this.radius;

	}

	clampPoint( point, target ) {

		const deltaLengthSq = this.center.distanceToSquared( point );

		target.copy( point );

		if ( deltaLengthSq > ( this.radius * this.radius ) ) {

			target.sub( this.center ).normalize();
			target.multiplyScalar( this.radius ).add( this.center );

		}

		return target;

	}

	getBoundingBox( target ) {

		if ( this.isEmpty() ) {

			// Empty sphere produces empty bounding box
			target.makeEmpty();
			return target;

		}

		target.set( this.center, this.center );
		target.expandByScalar( this.radius );

		return target;

	}

	applyMatrix4( matrix ) {

		this.center.applyMatrix4( matrix );
		this.radius = this.radius * matrix.getMaxScaleOnAxis();

		return this;

	}

	translate( offset ) {

		this.center.add( offset );

		return this;

	}

	expandByPoint( point ) {

		if ( this.isEmpty() ) {

			this.center.copy( point );

			this.radius = 0;

			return this;

		}

		_v1$6.subVectors( point, this.center );

		const lengthSq = _v1$6.lengthSq();

		if ( lengthSq > ( this.radius * this.radius ) ) {

			// calculate the minimal sphere

			const length = Math.sqrt( lengthSq );

			const delta = ( length - this.radius ) * 0.5;

			this.center.addScaledVector( _v1$6, delta / length );

			this.radius += delta;

		}

		return this;

	}

	union( sphere ) {

		if ( sphere.isEmpty() ) {

			return this;

		}

		if ( this.isEmpty() ) {

			this.copy( sphere );

			return this;

		}

		if ( this.center.equals( sphere.center ) === true ) {

			 this.radius = Math.max( this.radius, sphere.radius );

		} else {

			_v2$3.subVectors( sphere.center, this.center ).setLength( sphere.radius );

			this.expandByPoint( _v1$6.copy( sphere.center ).add( _v2$3 ) );

			this.expandByPoint( _v1$6.copy( sphere.center ).sub( _v2$3 ) );

		}

		return this;

	}

	equals( sphere ) {

		return sphere.center.equals( this.center ) && ( sphere.radius === this.radius );

	}

	clone() {

		return new this.constructor().copy( this );

	}

}

const _vector$a = /*@__PURE__*/ new Vector3();
const _segCenter = /*@__PURE__*/ new Vector3();
const _segDir = /*@__PURE__*/ new Vector3();
const _diff = /*@__PURE__*/ new Vector3();

const _edge1 = /*@__PURE__*/ new Vector3();
const _edge2 = /*@__PURE__*/ new Vector3();
const _normal$1 = /*@__PURE__*/ new Vector3();

class Ray {

	constructor( origin = new Vector3(), direction = new Vector3( 0, 0, - 1 ) ) {

		this.origin = origin;
		this.direction = direction;

	}

	set( origin, direction ) {

		this.origin.copy( origin );
		this.direction.copy( direction );

		return this;

	}

	copy( ray ) {

		this.origin.copy( ray.origin );
		this.direction.copy( ray.direction );

		return this;

	}

	at( t, target ) {

		return target.copy( this.origin ).addScaledVector( this.direction, t );

	}

	lookAt( v ) {

		this.direction.copy( v ).sub( this.origin ).normalize();

		return this;

	}

	recast( t ) {

		this.origin.copy( this.at( t, _vector$a ) );

		return this;

	}

	closestPointToPoint( point, target ) {

		target.subVectors( point, this.origin );

		const directionDistance = target.dot( this.direction );

		if ( directionDistance < 0 ) {

			return target.copy( this.origin );

		}

		return target.copy( this.origin ).addScaledVector( this.direction, directionDistance );

	}

	distanceToPoint( point ) {

		return Math.sqrt( this.distanceSqToPoint( point ) );

	}

	distanceSqToPoint( point ) {

		const directionDistance = _vector$a.subVectors( point, this.origin ).dot( this.direction );

		// point behind the ray

		if ( directionDistance < 0 ) {

			return this.origin.distanceToSquared( point );

		}

		_vector$a.copy( this.origin ).addScaledVector( this.direction, directionDistance );

		return _vector$a.distanceToSquared( point );

	}

	distanceSqToSegment( v0, v1, optionalPointOnRay, optionalPointOnSegment ) {

		// from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteDistRaySegment.h
		// It returns the min distance between the ray and the segment
		// defined by v0 and v1
		// It can also set two optional targets :
		// - The closest point on the ray
		// - The closest point on the segment

		_segCenter.copy( v0 ).add( v1 ).multiplyScalar( 0.5 );
		_segDir.copy( v1 ).sub( v0 ).normalize();
		_diff.copy( this.origin ).sub( _segCenter );

		const segExtent = v0.distanceTo( v1 ) * 0.5;
		const a01 = - this.direction.dot( _segDir );
		const b0 = _diff.dot( this.direction );
		const b1 = - _diff.dot( _segDir );
		const c = _diff.lengthSq();
		const det = Math.abs( 1 - a01 * a01 );
		let s0, s1, sqrDist, extDet;

		if ( det > 0 ) {

			// The ray and segment are not parallel.

			s0 = a01 * b1 - b0;
			s1 = a01 * b0 - b1;
			extDet = segExtent * det;

			if ( s0 >= 0 ) {

				if ( s1 >= - extDet ) {

					if ( s1 <= extDet ) {

						// region 0
						// Minimum at interior points of ray and segment.

						const invDet = 1 / det;
						s0 *= invDet;
						s1 *= invDet;
						sqrDist = s0 * ( s0 + a01 * s1 + 2 * b0 ) + s1 * ( a01 * s0 + s1 + 2 * b1 ) + c;

					} else {

						// region 1

						s1 = segExtent;
						s0 = Math.max( 0, - ( a01 * s1 + b0 ) );
						sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

					}

				} else {

					// region 5

					s1 = - segExtent;
					s0 = Math.max( 0, - ( a01 * s1 + b0 ) );
					sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

				}

			} else {

				if ( s1 <= - extDet ) {

					// region 4

					s0 = Math.max( 0, - ( - a01 * segExtent + b0 ) );
					s1 = ( s0 > 0 ) ? - segExtent : Math.min( Math.max( - segExtent, - b1 ), segExtent );
					sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

				} else if ( s1 <= extDet ) {

					// region 3

					s0 = 0;
					s1 = Math.min( Math.max( - segExtent, - b1 ), segExtent );
					sqrDist = s1 * ( s1 + 2 * b1 ) + c;

				} else {

					// region 2

					s0 = Math.max( 0, - ( a01 * segExtent + b0 ) );
					s1 = ( s0 > 0 ) ? segExtent : Math.min( Math.max( - segExtent, - b1 ), segExtent );
					sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

				}

			}

		} else {

			// Ray and segment are parallel.

			s1 = ( a01 > 0 ) ? - segExtent : segExtent;
			s0 = Math.max( 0, - ( a01 * s1 + b0 ) );
			sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

		}

		if ( optionalPointOnRay ) {

			optionalPointOnRay.copy( this.origin ).addScaledVector( this.direction, s0 );

		}

		if ( optionalPointOnSegment ) {

			optionalPointOnSegment.copy( _segCenter ).addScaledVector( _segDir, s1 );

		}

		return sqrDist;

	}

	intersectSphere( sphere, target ) {

		_vector$a.subVectors( sphere.center, this.origin );
		const tca = _vector$a.dot( this.direction );
		const d2 = _vector$a.dot( _vector$a ) - tca * tca;
		const radius2 = sphere.radius * sphere.radius;

		if ( d2 > radius2 ) return null;

		const thc = Math.sqrt( radius2 - d2 );

		// t0 = first intersect point - entrance on front of sphere
		const t0 = tca - thc;

		// t1 = second intersect point - exit point on back of sphere
		const t1 = tca + thc;

		// test to see if t1 is behind the ray - if so, return null
		if ( t1 < 0 ) return null;

		// test to see if t0 is behind the ray:
		// if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
		// in order to always return an intersect point that is in front of the ray.
		if ( t0 < 0 ) return this.at( t1, target );

		// else t0 is in front of the ray, so return the first collision point scaled by t0
		return this.at( t0, target );

	}

	intersectsSphere( sphere ) {

		return this.distanceSqToPoint( sphere.center ) <= ( sphere.radius * sphere.radius );

	}

	distanceToPlane( plane ) {

		const denominator = plane.normal.dot( this.direction );

		if ( denominator === 0 ) {

			// line is coplanar, return origin
			if ( plane.distanceToPoint( this.origin ) === 0 ) {

				return 0;

			}

			// Null is preferable to undefined since undefined means.... it is undefined

			return null;

		}

		const t = - ( this.origin.dot( plane.normal ) + plane.constant ) / denominator;

		// Return if the ray never intersects the plane

		return t >= 0 ? t : null;

	}

	intersectPlane( plane, target ) {

		const t = this.distanceToPlane( plane );

		if ( t === null ) {

			return null;

		}

		return this.at( t, target );

	}

	intersectsPlane( plane ) {

		// check if the ray lies on the plane first

		const distToPoint = plane.distanceToPoint( this.origin );

		if ( distToPoint === 0 ) {

			return true;

		}

		const denominator = plane.normal.dot( this.direction );

		if ( denominator * distToPoint < 0 ) {

			return true;

		}

		// ray origin is behind the plane (and is pointing behind it)

		return false;

	}

	intersectBox( box, target ) {

		let tmin, tmax, tymin, tymax, tzmin, tzmax;

		const invdirx = 1 / this.direction.x,
			invdiry = 1 / this.direction.y,
			invdirz = 1 / this.direction.z;

		const origin = this.origin;

		if ( invdirx >= 0 ) {

			tmin = ( box.min.x - origin.x ) * invdirx;
			tmax = ( box.max.x - origin.x ) * invdirx;

		} else {

			tmin = ( box.max.x - origin.x ) * invdirx;
			tmax = ( box.min.x - origin.x ) * invdirx;

		}

		if ( invdiry >= 0 ) {

			tymin = ( box.min.y - origin.y ) * invdiry;
			tymax = ( box.max.y - origin.y ) * invdiry;

		} else {

			tymin = ( box.max.y - origin.y ) * invdiry;
			tymax = ( box.min.y - origin.y ) * invdiry;

		}

		if ( ( tmin > tymax ) || ( tymin > tmax ) ) return null;

		if ( tymin > tmin || isNaN( tmin ) ) tmin = tymin;

		if ( tymax < tmax || isNaN( tmax ) ) tmax = tymax;

		if ( invdirz >= 0 ) {

			tzmin = ( box.min.z - origin.z ) * invdirz;
			tzmax = ( box.max.z - origin.z ) * invdirz;

		} else {

			tzmin = ( box.max.z - origin.z ) * invdirz;
			tzmax = ( box.min.z - origin.z ) * invdirz;

		}

		if ( ( tmin > tzmax ) || ( tzmin > tmax ) ) return null;

		if ( tzmin > tmin || tmin !== tmin ) tmin = tzmin;

		if ( tzmax < tmax || tmax !== tmax ) tmax = tzmax;

		//return point closest to the ray (positive side)

		if ( tmax < 0 ) return null;

		return this.at( tmin >= 0 ? tmin : tmax, target );

	}

	intersectsBox( box ) {

		return this.intersectBox( box, _vector$a ) !== null;

	}

	intersectTriangle( a, b, c, backfaceCulling, target ) {

		// Compute the offset origin, edges, and normal.

		// from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h

		_edge1.subVectors( b, a );
		_edge2.subVectors( c, a );
		_normal$1.crossVectors( _edge1, _edge2 );

		// Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
		// E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
		//   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
		//   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
		//   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
		let DdN = this.direction.dot( _normal$1 );
		let sign;

		if ( DdN > 0 ) {

			if ( backfaceCulling ) return null;
			sign = 1;

		} else if ( DdN < 0 ) {

			sign = - 1;
			DdN = - DdN;

		} else {

			return null;

		}

		_diff.subVectors( this.origin, a );
		const DdQxE2 = sign * this.direction.dot( _edge2.crossVectors( _diff, _edge2 ) );

		// b1 < 0, no intersection
		if ( DdQxE2 < 0 ) {

			return null;

		}

		const DdE1xQ = sign * this.direction.dot( _edge1.cross( _diff ) );

		// b2 < 0, no intersection
		if ( DdE1xQ < 0 ) {

			return null;

		}

		// b1+b2 > 1, no intersection
		if ( DdQxE2 + DdE1xQ > DdN ) {

			return null;

		}

		// Line intersects triangle, check if ray does.
		const QdN = - sign * _diff.dot( _normal$1 );

		// t < 0, no intersection
		if ( QdN < 0 ) {

			return null;

		}

		// Ray intersects triangle.
		return this.at( QdN / DdN, target );

	}

	applyMatrix4( matrix4 ) {

		this.origin.applyMatrix4( matrix4 );
		this.direction.transformDirection( matrix4 );

		return this;

	}

	equals( ray ) {

		return ray.origin.equals( this.origin ) && ray.direction.equals( this.direction );

	}

	clone() {

		return new this.constructor().copy( this );

	}

}

class Matrix4 {

	constructor( n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44 ) {

		Matrix4.prototype.isMatrix4 = true;

		this.elements = [

			1, 0, 0, 0,
			0, 1, 0, 0,
			0, 0, 1, 0,
			0, 0, 0, 1

		];

		if ( n11 !== undefined ) {

			this.set( n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44 );

		}

	}

	set( n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44 ) {

		const te = this.elements;

		te[ 0 ] = n11; te[ 4 ] = n12; te[ 8 ] = n13; te[ 12 ] = n14;
		te[ 1 ] = n21; te[ 5 ] = n22; te[ 9 ] = n23; te[ 13 ] = n24;
		te[ 2 ] = n31; te[ 6 ] = n32; te[ 10 ] = n33; te[ 14 ] = n34;
		te[ 3 ] = n41; te[ 7 ] = n42; te[ 11 ] = n43; te[ 15 ] = n44;

		return this;

	}

	identity() {

		this.set(

			1, 0, 0, 0,
			0, 1, 0, 0,
			0, 0, 1, 0,
			0, 0, 0, 1

		);

		return this;

	}

	clone() {

		return new Matrix4().fromArray( this.elements );

	}

	copy( m ) {

		const te = this.elements;
		const me = m.elements;

		te[ 0 ] = me[ 0 ]; te[ 1 ] = me[ 1 ]; te[ 2 ] = me[ 2 ]; te[ 3 ] = me[ 3 ];
		te[ 4 ] = me[ 4 ]; te[ 5 ] = me[ 5 ]; te[ 6 ] = me[ 6 ]; te[ 7 ] = me[ 7 ];
		te[ 8 ] = me[ 8 ]; te[ 9 ] = me[ 9 ]; te[ 10 ] = me[ 10 ]; te[ 11 ] = me[ 11 ];
		te[ 12 ] = me[ 12 ]; te[ 13 ] = me[ 13 ]; te[ 14 ] = me[ 14 ]; te[ 15 ] = me[ 15 ];

		return this;

	}

	copyPosition( m ) {

		const te = this.elements, me = m.elements;

		te[ 12 ] = me[ 12 ];
		te[ 13 ] = me[ 13 ];
		te[ 14 ] = me[ 14 ];

		return this;

	}

	setFromMatrix3( m ) {

		const me = m.elements;

		this.set(

			me[ 0 ], me[ 3 ], me[ 6 ], 0,
			me[ 1 ], me[ 4 ], me[ 7 ], 0,
			me[ 2 ], me[ 5 ], me[ 8 ], 0,
			0, 0, 0, 1

		);

		return this;

	}

	extractBasis( xAxis, yAxis, zAxis ) {

		xAxis.setFromMatrixColumn( this, 0 );
		yAxis.setFromMatrixColumn( this, 1 );
		zAxis.setFromMatrixColumn( this, 2 );

		return this;

	}

	makeBasis( xAxis, yAxis, zAxis ) {

		this.set(
			xAxis.x, yAxis.x, zAxis.x, 0,
			xAxis.y, yAxis.y, zAxis.y, 0,
			xAxis.z, yAxis.z, zAxis.z, 0,
			0, 0, 0, 1
		);

		return this;

	}

	extractRotation( m ) {

		// this method does not support reflection matrices

		const te = this.elements;
		const me = m.elements;

		const scaleX = 1 / _v1$5.setFromMatrixColumn( m, 0 ).length();
		const scaleY = 1 / _v1$5.setFromMatrixColumn( m, 1 ).length();
		const scaleZ = 1 / _v1$5.setFromMatrixColumn( m, 2 ).length();

		te[ 0 ] = me[ 0 ] * scaleX;
		te[ 1 ] = me[ 1 ] * scaleX;
		te[ 2 ] = me[ 2 ] * scaleX;
		te[ 3 ] = 0;

		te[ 4 ] = me[ 4 ] * scaleY;
		te[ 5 ] = me[ 5 ] * scaleY;
		te[ 6 ] = me[ 6 ] * scaleY;
		te[ 7 ] = 0;

		te[ 8 ] = me[ 8 ] * scaleZ;
		te[ 9 ] = me[ 9 ] * scaleZ;
		te[ 10 ] = me[ 10 ] * scaleZ;
		te[ 11 ] = 0;

		te[ 12 ] = 0;
		te[ 13 ] = 0;
		te[ 14 ] = 0;
		te[ 15 ] = 1;

		return this;

	}

	makeRotationFromEuler( euler ) {

		const te = this.elements;

		const x = euler.x, y = euler.y, z = euler.z;
		const a = Math.cos( x ), b = Math.sin( x );
		const c = Math.cos( y ), d = Math.sin( y );
		const e = Math.cos( z ), f = Math.sin( z );

		if ( euler.order === 'XYZ' ) {

			const ae = a * e, af = a * f, be = b * e, bf = b * f;

			te[ 0 ] = c * e;
			te[ 4 ] = - c * f;
			te[ 8 ] = d;

			te[ 1 ] = af + be * d;
			te[ 5 ] = ae - bf * d;
			te[ 9 ] = - b * c;

			te[ 2 ] = bf - ae * d;
			te[ 6 ] = be + af * d;
			te[ 10 ] = a * c;

		} else if ( euler.order === 'YXZ' ) {

			const ce = c * e, cf = c * f, de = d * e, df = d * f;

			te[ 0 ] = ce + df * b;
			te[ 4 ] = de * b - cf;
			te[ 8 ] = a * d;

			te[ 1 ] = a * f;
			te[ 5 ] = a * e;
			te[ 9 ] = - b;

			te[ 2 ] = cf * b - de;
			te[ 6 ] = df + ce * b;
			te[ 10 ] = a * c;

		} else if ( euler.order === 'ZXY' ) {

			const ce = c * e, cf = c * f, de = d * e, df = d * f;

			te[ 0 ] = ce - df * b;
			te[ 4 ] = - a * f;
			te[ 8 ] = de + cf * b;

			te[ 1 ] = cf + de * b;
			te[ 5 ] = a * e;
			te[ 9 ] = df - ce * b;

			te[ 2 ] = - a * d;
			te[ 6 ] = b;
			te[ 10 ] = a * c;

		} else if ( euler.order === 'ZYX' ) {

			const ae = a * e, af = a * f, be = b * e, bf = b * f;

			te[ 0 ] = c * e;
			te[ 4 ] = be * d - af;
			te[ 8 ] = ae * d + bf;

			te[ 1 ] = c * f;
			te[ 5 ] = bf * d + ae;
			te[ 9 ] = af * d - be;

			te[ 2 ] = - d;
			te[ 6 ] = b * c;
			te[ 10 ] = a * c;

		} else if ( euler.order === 'YZX' ) {

			const ac = a * c, ad = a * d, bc = b * c, bd = b * d;

			te[ 0 ] = c * e;
			te[ 4 ] = bd - ac * f;
			te[ 8 ] = bc * f + ad;

			te[ 1 ] = f;
			te[ 5 ] = a * e;
			te[ 9 ] = - b * e;

			te[ 2 ] = - d * e;
			te[ 6 ] = ad * f + bc;
			te[ 10 ] = ac - bd * f;

		} else if ( euler.order === 'XZY' ) {

			const ac = a * c, ad = a * d, bc = b * c, bd = b * d;

			te[ 0 ] = c * e;
			te[ 4 ] = - f;
			te[ 8 ] = d * e;

			te[ 1 ] = ac * f + bd;
			te[ 5 ] = a * e;
			te[ 9 ] = ad * f - bc;

			te[ 2 ] = bc * f - ad;
			te[ 6 ] = b * e;
			te[ 10 ] = bd * f + ac;

		}

		// bottom row
		te[ 3 ] = 0;
		te[ 7 ] = 0;
		te[ 11 ] = 0;

		// last column
		te[ 12 ] = 0;
		te[ 13 ] = 0;
		te[ 14 ] = 0;
		te[ 15 ] = 1;

		return this;

	}

	makeRotationFromQuaternion( q ) {

		return this.compose( _zero, q, _one );

	}

	lookAt( eye, target, up ) {

		const te = this.elements;

		_z.subVectors( eye, target );

		if ( _z.lengthSq() === 0 ) {

			// eye and target are in the same position

			_z.z = 1;

		}

		_z.normalize();
		_x.crossVectors( up, _z );

		if ( _x.lengthSq() === 0 ) {

			// up and z are parallel

			if ( Math.abs( up.z ) === 1 ) {

				_z.x += 0.0001;

			} else {

				_z.z += 0.0001;

			}

			_z.normalize();
			_x.crossVectors( up, _z );

		}

		_x.normalize();
		_y.crossVectors( _z, _x );

		te[ 0 ] = _x.x; te[ 4 ] = _y.x; te[ 8 ] = _z.x;
		te[ 1 ] = _x.y; te[ 5 ] = _y.y; te[ 9 ] = _z.y;
		te[ 2 ] = _x.z; te[ 6 ] = _y.z; te[ 10 ] = _z.z;

		return this;

	}

	multiply( m ) {

		return this.multiplyMatrices( this, m );

	}

	premultiply( m ) {

		return this.multiplyMatrices( m, this );

	}

	multiplyMatrices( a, b ) {

		const ae = a.elements;
		const be = b.elements;
		const te = this.elements;

		const a11 = ae[ 0 ], a12 = ae[ 4 ], a13 = ae[ 8 ], a14 = ae[ 12 ];
		const a21 = ae[ 1 ], a22 = ae[ 5 ], a23 = ae[ 9 ], a24 = ae[ 13 ];
		const a31 = ae[ 2 ], a32 = ae[ 6 ], a33 = ae[ 10 ], a34 = ae[ 14 ];
		const a41 = ae[ 3 ], a42 = ae[ 7 ], a43 = ae[ 11 ], a44 = ae[ 15 ];

		const b11 = be[ 0 ], b12 = be[ 4 ], b13 = be[ 8 ], b14 = be[ 12 ];
		const b21 = be[ 1 ], b22 = be[ 5 ], b23 = be[ 9 ], b24 = be[ 13 ];
		const b31 = be[ 2 ], b32 = be[ 6 ], b33 = be[ 10 ], b34 = be[ 14 ];
		const b41 = be[ 3 ], b42 = be[ 7 ], b43 = be[ 11 ], b44 = be[ 15 ];

		te[ 0 ] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
		te[ 4 ] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
		te[ 8 ] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
		te[ 12 ] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;

		te[ 1 ] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
		te[ 5 ] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
		te[ 9 ] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
		te[ 13 ] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;

		te[ 2 ] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
		te[ 6 ] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
		te[ 10 ] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
		te[ 14 ] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;

		te[ 3 ] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
		te[ 7 ] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
		te[ 11 ] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
		te[ 15 ] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;

		return this;

	}

	multiplyScalar( s ) {

		const te = this.elements;

		te[ 0 ] *= s; te[ 4 ] *= s; te[ 8 ] *= s; te[ 12 ] *= s;
		te[ 1 ] *= s; te[ 5 ] *= s; te[ 9 ] *= s; te[ 13 ] *= s;
		te[ 2 ] *= s; te[ 6 ] *= s; te[ 10 ] *= s; te[ 14 ] *= s;
		te[ 3 ] *= s; te[ 7 ] *= s; te[ 11 ] *= s; te[ 15 ] *= s;

		return this;

	}

	determinant() {

		const te = this.elements;

		const n11 = te[ 0 ], n12 = te[ 4 ], n13 = te[ 8 ], n14 = te[ 12 ];
		const n21 = te[ 1 ], n22 = te[ 5 ], n23 = te[ 9 ], n24 = te[ 13 ];
		const n31 = te[ 2 ], n32 = te[ 6 ], n33 = te[ 10 ], n34 = te[ 14 ];
		const n41 = te[ 3 ], n42 = te[ 7 ], n43 = te[ 11 ], n44 = te[ 15 ];

		//TODO: make this more efficient
		//( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )

		return (
			n41 * (
				+ n14 * n23 * n32
				 - n13 * n24 * n32
				 - n14 * n22 * n33
				 + n12 * n24 * n33
				 + n13 * n22 * n34
				 - n12 * n23 * n34
			) +
			n42 * (
				+ n11 * n23 * n34
				 - n11 * n24 * n33
				 + n14 * n21 * n33
				 - n13 * n21 * n34
				 + n13 * n24 * n31
				 - n14 * n23 * n31
			) +
			n43 * (
				+ n11 * n24 * n32
				 - n11 * n22 * n34
				 - n14 * n21 * n32
				 + n12 * n21 * n34
				 + n14 * n22 * n31
				 - n12 * n24 * n31
			) +
			n44 * (
				- n13 * n22 * n31
				 - n11 * n23 * n32
				 + n11 * n22 * n33
				 + n13 * n21 * n32
				 - n12 * n21 * n33
				 + n12 * n23 * n31
			)

		);

	}

	transpose() {

		const te = this.elements;
		let tmp;

		tmp = te[ 1 ]; te[ 1 ] = te[ 4 ]; te[ 4 ] = tmp;
		tmp = te[ 2 ]; te[ 2 ] = te[ 8 ]; te[ 8 ] = tmp;
		tmp = te[ 6 ]; te[ 6 ] = te[ 9 ]; te[ 9 ] = tmp;

		tmp = te[ 3 ]; te[ 3 ] = te[ 12 ]; te[ 12 ] = tmp;
		tmp = te[ 7 ]; te[ 7 ] = te[ 13 ]; te[ 13 ] = tmp;
		tmp = te[ 11 ]; te[ 11 ] = te[ 14 ]; te[ 14 ] = tmp;

		return this;

	}

	setPosition( x, y, z ) {

		const te = this.elements;

		if ( x.isVector3 ) {

			te[ 12 ] = x.x;
			te[ 13 ] = x.y;
			te[ 14 ] = x.z;

		} else {

			te[ 12 ] = x;
			te[ 13 ] = y;
			te[ 14 ] = z;

		}

		return this;

	}

	invert() {

		// based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
		const te = this.elements,

			n11 = te[ 0 ], n21 = te[ 1 ], n31 = te[ 2 ], n41 = te[ 3 ],
			n12 = te[ 4 ], n22 = te[ 5 ], n32 = te[ 6 ], n42 = te[ 7 ],
			n13 = te[ 8 ], n23 = te[ 9 ], n33 = te[ 10 ], n43 = te[ 11 ],
			n14 = te[ 12 ], n24 = te[ 13 ], n34 = te[ 14 ], n44 = te[ 15 ],

			t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44,
			t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44,
			t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44,
			t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;

		const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;

		if ( det === 0 ) return this.set( 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 );

		const detInv = 1 / det;

		te[ 0 ] = t11 * detInv;
		te[ 1 ] = ( n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44 ) * detInv;
		te[ 2 ] = ( n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44 ) * detInv;
		te[ 3 ] = ( n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43 ) * detInv;

		te[ 4 ] = t12 * detInv;
		te[ 5 ] = ( n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44 ) * detInv;
		te[ 6 ] = ( n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44 ) * detInv;
		te[ 7 ] = ( n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43 ) * detInv;

		te[ 8 ] = t13 * detInv;
		te[ 9 ] = ( n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44 ) * detInv;
		te[ 10 ] = ( n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44 ) * detInv;
		te[ 11 ] = ( n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43 ) * detInv;

		te[ 12 ] = t14 * detInv;
		te[ 13 ] = ( n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34 ) * detInv;
		te[ 14 ] = ( n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34 ) * detInv;
		te[ 15 ] = ( n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33 ) * detInv;

		return this;

	}

	scale( v ) {

		const te = this.elements;
		const x = v.x, y = v.y, z = v.z;

		te[ 0 ] *= x; te[ 4 ] *= y; te[ 8 ] *= z;
		te[ 1 ] *= x; te[ 5 ] *= y; te[ 9 ] *= z;
		te[ 2 ] *= x; te[ 6 ] *= y; te[ 10 ] *= z;
		te[ 3 ] *= x; te[ 7 ] *= y; te[ 11 ] *= z;

		return this;

	}

	getMaxScaleOnAxis() {

		const te = this.elements;

		const scaleXSq = te[ 0 ] * te[ 0 ] + te[ 1 ] * te[ 1 ] + te[ 2 ] * te[ 2 ];
		const scaleYSq = te[ 4 ] * te[ 4 ] + te[ 5 ] * te[ 5 ] + te[ 6 ] * te[ 6 ];
		const scaleZSq = te[ 8 ] * te[ 8 ] + te[ 9 ] * te[ 9 ] + te[ 10 ] * te[ 10 ];

		return Math.sqrt( Math.max( scaleXSq, scaleYSq, scaleZSq ) );

	}

	makeTranslation( x, y, z ) {

		if ( x.isVector3 ) {

			this.set(

				1, 0, 0, x.x,
				0, 1, 0, x.y,
				0, 0, 1, x.z,
				0, 0, 0, 1

			);

		} else {

			this.set(

				1, 0, 0, x,
				0, 1, 0, y,
				0, 0, 1, z,
				0, 0, 0, 1

			);

		}

		return this;

	}

	makeRotationX( theta ) {

		const c = Math.cos( theta ), s = Math.sin( theta );

		this.set(

			1, 0, 0, 0,
			0, c, - s, 0,
			0, s, c, 0,
			0, 0, 0, 1

		);

		return this;

	}

	makeRotationY( theta ) {

		const c = Math.cos( theta ), s = Math.sin( theta );

		this.set(

			 c, 0, s, 0,
			 0, 1, 0, 0,
			- s, 0, c, 0,
			 0, 0, 0, 1

		);

		return this;

	}

	makeRotationZ( theta ) {

		const c = Math.cos( theta ), s = Math.sin( theta );

		this.set(

			c, - s, 0, 0,
			s, c, 0, 0,
			0, 0, 1, 0,
			0, 0, 0, 1

		);

		return this;

	}

	makeRotationAxis( axis, angle ) {

		// Based on http://www.gamedev.net/reference/articles/article1199.asp

		const c = Math.cos( angle );
		const s = Math.sin( angle );
		const t = 1 - c;
		const x = axis.x, y = axis.y, z = axis.z;
		const tx = t * x, ty = t * y;

		this.set(

			tx * x + c, tx * y - s * z, tx * z + s * y, 0,
			tx * y + s * z, ty * y + c, ty * z - s * x, 0,
			tx * z - s * y, ty * z + s * x, t * z * z + c, 0,
			0, 0, 0, 1

		);

		return this;

	}

	makeScale( x, y, z ) {

		this.set(

			x, 0, 0, 0,
			0, y, 0, 0,
			0, 0, z, 0,
			0, 0, 0, 1

		);

		return this;

	}

	makeShear( xy, xz, yx, yz, zx, zy ) {

		this.set(

			1, yx, zx, 0,
			xy, 1, zy, 0,
			xz, yz, 1, 0,
			0, 0, 0, 1

		);

		return this;

	}

	compose( position, quaternion, scale ) {

		const te = this.elements;

		const x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
		const x2 = x + x,	y2 = y + y, z2 = z + z;
		const xx = x * x2, xy = x * y2, xz = x * z2;
		const yy = y * y2, yz = y * z2, zz = z * z2;
		const wx = w * x2, wy = w * y2, wz = w * z2;

		const sx = scale.x, sy = scale.y, sz = scale.z;

		te[ 0 ] = ( 1 - ( yy + zz ) ) * sx;
		te[ 1 ] = ( xy + wz ) * sx;
		te[ 2 ] = ( xz - wy ) * sx;
		te[ 3 ] = 0;

		te[ 4 ] = ( xy - wz ) * sy;
		te[ 5 ] = ( 1 - ( xx + zz ) ) * sy;
		te[ 6 ] = ( yz + wx ) * sy;
		te[ 7 ] = 0;

		te[ 8 ] = ( xz + wy ) * sz;
		te[ 9 ] = ( yz - wx ) * sz;
		te[ 10 ] = ( 1 - ( xx + yy ) ) * sz;
		te[ 11 ] = 0;

		te[ 12 ] = position.x;
		te[ 13 ] = position.y;
		te[ 14 ] = position.z;
		te[ 15 ] = 1;

		return this;

	}

	decompose( position, quaternion, scale ) {

		const te = this.elements;

		let sx = _v1$5.set( te[ 0 ], te[ 1 ], te[ 2 ] ).length();
		const sy = _v1$5.set( te[ 4 ], te[ 5 ], te[ 6 ] ).length();
		const sz = _v1$5.set( te[ 8 ], te[ 9 ], te[ 10 ] ).length();

		// if determine is negative, we need to invert one scale
		const det = this.determinant();
		if ( det < 0 ) sx = - sx;

		position.x = te[ 12 ];
		position.y = te[ 13 ];
		position.z = te[ 14 ];

		// scale the rotation part
		_m1$4.copy( this );

		const invSX = 1 / sx;
		const invSY = 1 / sy;
		const invSZ = 1 / sz;

		_m1$4.elements[ 0 ] *= invSX;
		_m1$4.elements[ 1 ] *= invSX;
		_m1$4.elements[ 2 ] *= invSX;

		_m1$4.elements[ 4 ] *= invSY;
		_m1$4.elements[ 5 ] *= invSY;
		_m1$4.elements[ 6 ] *= invSY;

		_m1$4.elements[ 8 ] *= invSZ;
		_m1$4.elements[ 9 ] *= invSZ;
		_m1$4.elements[ 10 ] *= invSZ;

		quaternion.setFromRotationMatrix( _m1$4 );

		scale.x = sx;
		scale.y = sy;
		scale.z = sz;

		return this;

	}

	makePerspective( left, right, top, bottom, near, far, coordinateSystem = WebGLCoordinateSystem ) {

		const te = this.elements;
		const x = 2 * near / ( right - left );
		const y = 2 * near / ( top - bottom );

		const a = ( right + left ) / ( right - left );
		const b = ( top + bottom ) / ( top - bottom );

		let c, d;

		if ( coordinateSystem === WebGLCoordinateSystem ) {

			c = - ( far + near ) / ( far - near );
			d = ( - 2 * far * near ) / ( far - near );

		} else if ( coordinateSystem === WebGPUCoordinateSystem ) {

			c = - far / ( far - near );
			d = ( - far * near ) / ( far - near );

		} else {

			throw new Error( 'THREE.Matrix4.makePerspective(): Invalid coordinate system: ' + coordinateSystem );

		}

		te[ 0 ] = x;	te[ 4 ] = 0;	te[ 8 ] = a; 	te[ 12 ] = 0;
		te[ 1 ] = 0;	te[ 5 ] = y;	te[ 9 ] = b; 	te[ 13 ] = 0;
		te[ 2 ] = 0;	te[ 6 ] = 0;	te[ 10 ] = c; 	te[ 14 ] = d;
		te[ 3 ] = 0;	te[ 7 ] = 0;	te[ 11 ] = - 1;	te[ 15 ] = 0;

		return this;

	}

	makeOrthographic( left, right, top, bottom, near, far, coordinateSystem = WebGLCoordinateSystem ) {

		const te = this.elements;
		const w = 1.0 / ( right - left );
		const h = 1.0 / ( top - bottom );
		const p = 1.0 / ( far - near );

		const x = ( right + left ) * w;
		const y = ( top + bottom ) * h;

		let z, zInv;

		if ( coordinateSystem === WebGLCoordinateSystem ) {

			z = ( far + near ) * p;
			zInv = - 2 * p;

		} else if ( coordinateSystem === WebGPUCoordinateSystem ) {

			z = near * p;
			zInv = - 1 * p;

		} else {

			throw new Error( 'THREE.Matrix4.makeOrthographic(): Invalid coordinate system: ' + coordinateSystem );

		}

		te[ 0 ] = 2 * w;	te[ 4 ] = 0;		te[ 8 ] = 0; 		te[ 12 ] = - x;
		te[ 1 ] = 0; 		te[ 5 ] = 2 * h;	te[ 9 ] = 0; 		te[ 13 ] = - y;
		te[ 2 ] = 0; 		te[ 6 ] = 0;		te[ 10 ] = zInv;	te[ 14 ] = - z;
		te[ 3 ] = 0; 		te[ 7 ] = 0;		te[ 11 ] = 0;		te[ 15 ] = 1;

		return this;

	}

	equals( matrix ) {

		const te = this.elements;
		const me = matrix.elements;

		for ( let i = 0; i < 16; i ++ ) {

			if ( te[ i ] !== me[ i ] ) return false;

		}

		return true;

	}

	fromArray( array, offset = 0 ) {

		for ( let i = 0; i < 16; i ++ ) {

			this.elements[ i ] = array[ i + offset ];

		}

		return this;

	}

	toArray( array = [], offset = 0 ) {

		const te = this.elements;

		array[ offset ] = te[ 0 ];
		array[ offset + 1 ] = te[ 1 ];
		array[ offset + 2 ] = te[ 2 ];
		array[ offset + 3 ] = te[ 3 ];

		array[ offset + 4 ] = te[ 4 ];
		array[ offset + 5 ] = te[ 5 ];
		array[ offset + 6 ] = te[ 6 ];
		array[ offset + 7 ] = te[ 7 ];

		array[ offset + 8 ] = te[ 8 ];
		array[ offset + 9 ] = te[ 9 ];
		array[ offset + 10 ] = te[ 10 ];
		array[ offset + 11 ] = te[ 11 ];

		array[ offset + 12 ] = te[ 12 ];
		array[ offset + 13 ] = te[ 13 ];
		array[ offset + 14 ] = te[ 14 ];
		array[ offset + 15 ] = te[ 15 ];

		return array;

	}

}

const _v1$5 = /*@__PURE__*/ new Vector3();
const _m1$4 = /*@__PURE__*/ new Matrix4();
const _zero = /*@__PURE__*/ new Vector3( 0, 0, 0 );
const _one = /*@__PURE__*/ new Vector3( 1, 1, 1 );
const _x = /*@__PURE__*/ new Vector3();
const _y = /*@__PURE__*/ new Vector3();
const _z = /*@__PURE__*/ new Vector3();

const _matrix$2 = /*@__PURE__*/ new Matrix4();
const _quaternion$3 = /*@__PURE__*/ new Quaternion();

class Euler {

	constructor( x = 0, y = 0, z = 0, order = Euler.DEFAULT_ORDER ) {

		this.isEuler = true;

		this._x = x;
		this._y = y;
		this._z = z;
		this._order = order;

	}

	get x() {

		return this._x;

	}

	set x( value ) {

		this._x = value;
		this._onChangeCallback();

	}

	get y() {

		return this._y;

	}

	set y( value ) {

		this._y = value;
		this._onChangeCallback();

	}

	get z() {

		return this._z;

	}

	set z( value ) {

		this._z = value;
		this._onChangeCallback();

	}

	get order() {

		return this._order;

	}

	set order( value ) {

		this._order = value;
		this._onChangeCallback();

	}

	set( x, y, z, order = this._order ) {

		this._x = x;
		this._y = y;
		this._z = z;
		this._order = order;

		this._onChangeCallback();

		return this;

	}

	clone() {

		return new this.constructor( this._x, this._y, this._z, this._order );

	}

	copy( euler ) {

		this._x = euler._x;
		this._y = euler._y;
		this._z = euler._z;
		this._order = euler._order;

		this._onChangeCallback();

		return this;

	}

	setFromRotationMatrix( m, order = this._order, update = true ) {

		// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)

		const te = m.elements;
		const m11 = te[ 0 ], m12 = te[ 4 ], m13 = te[ 8 ];
		const m21 = te[ 1 ], m22 = te[ 5 ], m23 = te[ 9 ];
		const m31 = te[ 2 ], m32 = te[ 6 ], m33 = te[ 10 ];

		switch ( order ) {

			case 'XYZ':

				this._y = Math.asin( clamp( m13, - 1, 1 ) );

				if ( Math.abs( m13 ) < 0.9999999 ) {

					this._x = Math.atan2( - m23, m33 );
					this._z = Math.atan2( - m12, m11 );

				} else {

					this._x = Math.atan2( m32, m22 );
					this._z = 0;

				}

				break;

			case 'YXZ':

				this._x = Math.asin( - clamp( m23, - 1, 1 ) );

				if ( Math.abs( m23 ) < 0.9999999 ) {

					this._y = Math.atan2( m13, m33 );
					this._z = Math.atan2( m21, m22 );

				} else {

					this._y = Math.atan2( - m31, m11 );
					this._z = 0;

				}

				break;

			case 'ZXY':

				this._x = Math.asin( clamp( m32, - 1, 1 ) );

				if ( Math.abs( m32 ) < 0.9999999 ) {

					this._y = Math.atan2( - m31, m33 );
					this._z = Math.atan2( - m12, m22 );

				} else {

					this._y = 0;
					this._z = Math.atan2( m21, m11 );

				}

				break;

			case 'ZYX':

				this._y = Math.asin( - clamp( m31, - 1, 1 ) );

				if ( Math.abs( m31 ) < 0.9999999 ) {

					this._x = Math.atan2( m32, m33 );
					this._z = Math.atan2( m21, m11 );

				} else {

					this._x = 0;
					this._z = Math.atan2( - m12, m22 );

				}

				break;

			case 'YZX':

				this._z = Math.asin( clamp( m21, - 1, 1 ) );

				if ( Math.abs( m21 ) < 0.9999999 ) {

					this._x = Math.atan2( - m23, m22 );
					this._y = Math.atan2( - m31, m11 );

				} else {

					this._x = 0;
					this._y = Math.atan2( m13, m33 );

				}

				break;

			case 'XZY':

				this._z = Math.asin( - clamp( m12, - 1, 1 ) );

				if ( Math.abs( m12 ) < 0.9999999 ) {

					this._x = Math.atan2( m32, m22 );
					this._y = Math.atan2( m13, m11 );

				} else {

					this._x = Math.atan2( - m23, m33 );
					this._y = 0;

				}

				break;

			default:

				console.warn( 'THREE.Euler: .setFromRotationMatrix() encountered an unknown order: ' + order );

		}

		this._order = order;

		if ( update === true ) this._onChangeCallback();

		return this;

	}

	setFromQuaternion( q, order, update ) {

		_matrix$2.makeRotationFromQuaternion( q );

		return this.setFromRotationMatrix( _matrix$2, order, update );

	}

	setFromVector3( v, order = this._order ) {

		return this.set( v.x, v.y, v.z, order );

	}

	reorder( newOrder ) {

		// WARNING: this discards revolution information -bhouston

		_quaternion$3.setFromEuler( this );

		return this.setFromQuaternion( _quaternion$3, newOrder );

	}

	equals( euler ) {

		return ( euler._x === this._x ) && ( euler._y === this._y ) && ( euler._z === this._z ) && ( euler._order === this._order );

	}

	fromArray( array ) {

		this._x = array[ 0 ];
		this._y = array[ 1 ];
		this._z = array[ 2 ];
		if ( array[ 3 ] !== undefined ) this._order = array[ 3 ];

		this._onChangeCallback();

		return this;

	}

	toArray( array = [], offset = 0 ) {

		array[ offset ] = this._x;
		array[ offset + 1 ] = this._y;
		array[ offset + 2 ] = this._z;
		array[ offset + 3 ] = this._order;

		return array;

	}

	_onChange( callback ) {

		this._onChangeCallback = callback;

		return this;

	}

	_onChangeCallback() {}

	*[ Symbol.iterator ]() {

		yield this._x;
		yield this._y;
		yield this._z;
		yield this._order;

	}

}

Euler.DEFAULT_ORDER = 'XYZ';

class Layers {

	constructor() {

		this.mask = 1 | 0;

	}

	set( channel ) {

		this.mask = ( 1 << channel | 0 ) >>> 0;

	}

	enable( channel ) {

		this.mask |= 1 << channel | 0;

	}

	enableAll() {

		this.mask = 0xffffffff | 0;

	}

	toggle( channel ) {

		this.mask ^= 1 << channel | 0;

	}

	disable( channel ) {

		this.mask &= ~ ( 1 << channel | 0 );

	}

	disableAll() {

		this.mask = 0;

	}

	test( layers ) {

		return ( this.mask & layers.mask ) !== 0;

	}

	isEnabled( channel ) {

		return ( this.mask & ( 1 << channel | 0 ) ) !== 0;

	}

}

let _object3DId = 0;

const _v1$4 = /*@__PURE__*/ new Vector3();
const _q1 = /*@__PURE__*/ new Quaternion();
const _m1$3 = /*@__PURE__*/ new Matrix4();
const _target = /*@__PURE__*/ new Vector3();

const _position$3 = /*@__PURE__*/ new Vector3();
const _scale$2 = /*@__PURE__*/ new Vector3();
const _quaternion$2 = /*@__PURE__*/ new Quaternion();

const _xAxis = /*@__PURE__*/ new Vector3( 1, 0, 0 );
const _yAxis = /*@__PURE__*/ new Vector3( 0, 1, 0 );
const _zAxis = /*@__PURE__*/ new Vector3( 0, 0, 1 );

const _addedEvent = { type: 'added' };
const _removedEvent = { type: 'removed' };

const _childaddedEvent = { type: 'childadded', child: null };
const _childremovedEvent = { type: 'childremoved', child: null };

class Object3D extends EventDispatcher {

	constructor() {

		super();

		this.isObject3D = true;

		Object.defineProperty( this, 'id', { value: _object3DId ++ } );

		this.uuid = generateUUID();

		this.name = '';
		this.type = 'Object3D';

		this.parent = null;
		this.children = [];

		this.up = Object3D.DEFAULT_UP.clone();

		const position = new Vector3();
		const rotation = new Euler();
		const quaternion = new Quaternion();
		const scale = new Vector3( 1, 1, 1 );

		function onRotationChange() {

			quaternion.setFromEuler( rotation, false );

		}

		function onQuaternionChange() {

			rotation.setFromQuaternion( quaternion, undefined, false );

		}

		rotation._onChange( onRotationChange );
		quaternion._onChange( onQuaternionChange );

		Object.defineProperties( this, {
			position: {
				configurable: true,
				enumerable: true,
				value: position
			},
			rotation: {
				configurable: true,
				enumerable: true,
				value: rotation
			},
			quaternion: {
				configurable: true,
				enumerable: true,
				value: quaternion
			},
			scale: {
				configurable: true,
				enumerable: true,
				value: scale
			},
			modelViewMatrix: {
				value: new Matrix4()
			},
			normalMatrix: {
				value: new Matrix3()
			}
		} );

		this.matrix = new Matrix4();
		this.matrixWorld = new Matrix4();

		this.matrixAutoUpdate = Object3D.DEFAULT_MATRIX_AUTO_UPDATE;

		this.matrixWorldAutoUpdate = Object3D.DEFAULT_MATRIX_WORLD_AUTO_UPDATE; // checked by the renderer
		this.matrixWorldNeedsUpdate = false;

		this.layers = new Layers();
		this.visible = true;

		this.castShadow = false;
		this.receiveShadow = false;

		this.frustumCulled = true;
		this.renderOrder = 0;

		this.animations = [];

		this.userData = {};

	}

	onBeforeShadow( /* renderer, object, camera, shadowCamera, geometry, depthMaterial, group */ ) {}

	onAfterShadow( /* renderer, object, camera, shadowCamera, geometry, depthMaterial, group */ ) {}

	onBeforeRender( /* renderer, scene, camera, geometry, material, group */ ) {}

	onAfterRender( /* renderer, scene, camera, geometry, material, group */ ) {}

	applyMatrix4( matrix ) {

		if ( this.matrixAutoUpdate ) this.updateMatrix();

		this.matrix.premultiply( matrix );

		this.matrix.decompose( this.position, this.quaternion, this.scale );

	}

	applyQuaternion( q ) {

		this.quaternion.premultiply( q );

		return this;

	}

	setRotationFromAxisAngle( axis, angle ) {

		// assumes axis is normalized

		this.quaternion.setFromAxisAngle( axis, angle );

	}

	setRotationFromEuler( euler ) {

		this.quaternion.setFromEuler( euler, true );

	}

	setRotationFromMatrix( m ) {

		// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)

		this.quaternion.setFromRotationMatrix( m );

	}

	setRotationFromQuaternion( q ) {

		// assumes q is normalized

		this.quaternion.copy( q );

	}

	rotateOnAxis( axis, angle ) {

		// rotate object on axis in object space
		// axis is assumed to be normalized

		_q1.setFromAxisAngle( axis, angle );

		this.quaternion.multiply( _q1 );

		return this;

	}

	rotateOnWorldAxis( axis, angle ) {

		// rotate object on axis in world space
		// axis is assumed to be normalized
		// method assumes no rotated parent

		_q1.setFromAxisAngle( axis, angle );

		this.quaternion.premultiply( _q1 );

		return this;

	}

	rotateX( angle ) {

		return this.rotateOnAxis( _xAxis, angle );

	}

	rotateY( angle ) {

		return this.rotateOnAxis( _yAxis, angle );

	}

	rotateZ( angle ) {

		return this.rotateOnAxis( _zAxis, angle );

	}

	translateOnAxis( axis, distance ) {

		// translate object by distance along axis in object space
		// axis is assumed to be normalized

		_v1$4.copy( axis ).applyQuaternion( this.quaternion );

		this.position.add( _v1$4.multiplyScalar( distance ) );

		return this;

	}

	translateX( distance ) {

		return this.translateOnAxis( _xAxis, distance );

	}

	translateY( distance ) {

		return this.translateOnAxis( _yAxis, distance );

	}

	translateZ( distance ) {

		return this.translateOnAxis( _zAxis, distance );

	}

	localToWorld( vector ) {

		this.updateWorldMatrix( true, false );

		return vector.applyMatrix4( this.matrixWorld );

	}

	worldToLocal( vector ) {

		this.updateWorldMatrix( true, false );

		return vector.applyMatrix4( _m1$3.copy( this.matrixWorld ).invert() );

	}

	lookAt( x, y, z ) {

		// This method does not support objects having non-uniformly-scaled parent(s)

		if ( x.isVector3 ) {

			_target.copy( x );

		} else {

			_target.set( x, y, z );

		}

		const parent = this.parent;

		this.updateWorldMatrix( true, false );

		_position$3.setFromMatrixPosition( this.matrixWorld );

		if ( this.isCamera || this.isLight ) {

			_m1$3.lookAt( _position$3, _target, this.up );

		} else {

			_m1$3.lookAt( _target, _position$3, this.up );

		}

		this.quaternion.setFromRotationMatrix( _m1$3 );

		if ( parent ) {

			_m1$3.extractRotation( parent.matrixWorld );
			_q1.setFromRotationMatrix( _m1$3 );
			this.quaternion.premultiply( _q1.invert() );

		}

	}

	add( object ) {

		if ( arguments.length > 1 ) {

			for ( let i = 0; i < arguments.length; i ++ ) {

				this.add( arguments[ i ] );

			}

			return this;

		}

		if ( object === this ) {

			console.error( 'THREE.Object3D.add: object can\'t be added as a child of itself.', object );
			return this;

		}

		if ( object && object.isObject3D ) {

			object.removeFromParent();
			object.parent = this;
			this.children.push( object );

			object.dispatchEvent( _addedEvent );

			_childaddedEvent.child = object;
			this.dispatchEvent( _childaddedEvent );
			_childaddedEvent.child = null;

		} else {

			console.error( 'THREE.Object3D.add: object not an instance of THREE.Object3D.', object );

		}

		return this;

	}

	remove( object ) {

		if ( arguments.length > 1 ) {

			for ( let i = 0; i < arguments.length; i ++ ) {

				this.remove( arguments[ i ] );

			}

			return this;

		}

		const index = this.children.indexOf( object );

		if ( index !== - 1 ) {

			object.parent = null;
			this.children.splice( index, 1 );

			object.dispatchEvent( _removedEvent );

			_childremovedEvent.child = object;
			this.dispatchEvent( _childremovedEvent );
			_childremovedEvent.child = null;

		}

		return this;

	}

	removeFromParent() {

		const parent = this.parent;

		if ( parent !== null ) {

			parent.remove( this );

		}

		return this;

	}

	clear() {

		return this.remove( ... this.children );

	}

	attach( object ) {

		// adds object as a child of this, while maintaining the object's world transform

		// Note: This method does not support scene graphs having non-uniformly-scaled nodes(s)

		this.updateWorldMatrix( true, false );

		_m1$3.copy( this.matrixWorld ).invert();

		if ( object.parent !== null ) {

			object.parent.updateWorldMatrix( true, false );

			_m1$3.multiply( object.parent.matrixWorld );

		}

		object.applyMatrix4( _m1$3 );

		object.removeFromParent();
		object.parent = this;
		this.children.push( object );

		object.updateWorldMatrix( false, true );

		object.dispatchEvent( _addedEvent );

		_childaddedEvent.child = object;
		this.dispatchEvent( _childaddedEvent );
		_childaddedEvent.child = null;

		return this;

	}

	getObjectById( id ) {

		return this.getObjectByProperty( 'id', id );

	}

	getObjectByName( name ) {

		return this.getObjectByProperty( 'name', name );

	}

	getObjectByProperty( name, value ) {

		if ( this[ name ] === value ) return this;

		for ( let i = 0, l = this.children.length; i < l; i ++ ) {

			const child = this.children[ i ];
			const object = child.getObjectByProperty( name, value );

			if ( object !== undefined ) {

				return object;

			}

		}

		return undefined;

	}

	getObjectsByProperty( name, value, result = [] ) {

		if ( this[ name ] === value ) result.push( this );

		const children = this.children;

		for ( let i = 0, l = children.length; i < l; i ++ ) {

			children[ i ].getObjectsByProperty( name, value, result );

		}

		return result;

	}

	getWorldPosition( target ) {

		this.updateWorldMatrix( true, false );

		return target.setFromMatrixPosition( this.matrixWorld );

	}

	getWorldQuaternion( target ) {

		this.updateWorldMatrix( true, false );

		this.matrixWorld.decompose( _position$3, target, _scale$2 );

		return target;

	}

	getWorldScale( target ) {

		this.updateWorldMatrix( true, false );

		this.matrixWorld.decompose( _position$3, _quaternion$2, target );

		return target;

	}

	getWorldDirection( target ) {

		this.updateWorldMatrix( true, false );

		const e = this.matrixWorld.elements;

		return target.set( e[ 8 ], e[ 9 ], e[ 10 ] ).normalize();

	}

	raycast( /* raycaster, intersects */ ) {}

	traverse( callback ) {

		callback( this );

		const children = this.children;

		for ( let i = 0, l = children.length; i < l; i ++ ) {

			children[ i ].traverse( callback );

		}

	}

	traverseVisible( callback ) {

		if ( this.visible === false ) return;

		callback( this );

		const children = this.children;

		for ( let i = 0, l = children.length; i < l; i ++ ) {

			children[ i ].traverseVisible( callback );

		}

	}

	traverseAncestors( callback ) {

		const parent = this.parent;

		if ( parent !== null ) {

			callback( parent );

			parent.traverseAncestors( callback );

		}

	}

	updateMatrix() {

		this.matrix.compose( this.position, this.quaternion, this.scale );

		this.matrixWorldNeedsUpdate = true;

	}

	updateMatrixWorld( force ) {

		if ( this.matrixAutoUpdate ) this.updateMatrix();

		if ( this.matrixWorldNeedsUpdate || force ) {

			if ( this.parent === null ) {

				this.matrixWorld.copy( this.matrix );

			} else {

				this.matrixWorld.multiplyMatrices( this.parent.matrixWorld, this.matrix );

			}

			this.matrixWorldNeedsUpdate = false;

			force = true;

		}

		// update children

		const children = this.children;

		for ( let i = 0, l = children.length; i < l; i ++ ) {

			const child = children[ i ];

			if ( child.matrixWorldAutoUpdate === true || force === true ) {

				child.updateMatrixWorld( force );

			}

		}

	}

	updateWorldMatrix( updateParents, updateChildren ) {

		const parent = this.parent;

		if ( updateParents === true && parent !== null && parent.matrixWorldAutoUpdate === true ) {

			parent.updateWorldMatrix( true, false );

		}

		if ( this.matrixAutoUpdate ) this.updateMatrix();

		if ( this.parent === null ) {

			this.matrixWorld.copy( this.matrix );

		} else {

			this.matrixWorld.multiplyMatrices( this.parent.matrixWorld, this.matrix );

		}

		// update children

		if ( updateChildren === true ) {

			const children = this.children;

			for ( let i = 0, l = children.length; i < l; i ++ ) {

				const child = children[ i ];

				if ( child.matrixWorldAutoUpdate === true ) {

					child.updateWorldMatrix( false, true );

				}

			}

		}

	}

	toJSON( meta ) {

		// meta is a string when called from JSON.stringify
		const isRootObject = ( meta === undefined || typeof meta === 'string' );

		const output = {};

		// meta is a hash used to collect geometries, materials.
		// not providing it implies that this is the root object
		// being serialized.
		if ( isRootObject ) {

			// initialize meta obj
			meta = {
				geometries: {},
				materials: {},
				textures: {},
				images: {},
				shapes: {},
				skeletons: {},
				animations: {},
				nodes: {}
			};

			output.metadata = {
				version: 4.6,
				type: 'Object',
				generator: 'Object3D.toJSON'
			};

		}

		// standard Object3D serialization

		const object = {};

		object.uuid = this.uuid;
		object.type = this.type;

		if ( this.name !== '' ) object.name = this.name;
		if ( this.castShadow === true ) object.castShadow = true;
		if ( this.receiveShadow === true ) object.receiveShadow = true;
		if ( this.visible === false ) object.visible = false;
		if ( this.frustumCulled === false ) object.frustumCulled = false;
		if ( this.renderOrder !== 0 ) object.renderOrder = this.renderOrder;
		if ( Object.keys( this.userData ).length > 0 ) object.userData = this.userData;

		object.layers = this.layers.mask;
		object.matrix = this.matrix.toArray();
		object.up = this.up.toArray();

		if ( this.matrixAutoUpdate === false ) object.matrixAutoUpdate = false;

		// object specific properties

		if ( this.isInstancedMesh ) {

			object.type = 'InstancedMesh';
			object.count = this.count;
			object.instanceMatrix = this.instanceMatrix.toJSON();
			if ( this.instanceColor !== null ) object.instanceColor = this.instanceColor.toJSON();

		}

		if ( this.isBatchedMesh ) {

			object.type = 'BatchedMesh';
			object.perObjectFrustumCulled = this.perObjectFrustumCulled;
			object.sortObjects = this.sortObjects;

			object.drawRanges = this._drawRanges;
			object.reservedRanges = this._reservedRanges;

			object.visibility = this._visibility;
			object.active = this._active;
			object.bounds = this._bounds.map( bound => ( {
				boxInitialized: bound.boxInitialized,
				boxMin: bound.box.min.toArray(),
				boxMax: bound.box.max.toArray(),

				sphereInitialized: bound.sphereInitialized,
				sphereRadius: bound.sphere.radius,
				sphereCenter: bound.sphere.center.toArray()
			} ) );

			object.maxGeometryCount = this._maxGeometryCount;
			object.maxVertexCount = this._maxVertexCount;
			object.maxIndexCount = this._maxIndexCount;

			object.geometryInitialized = this._geometryInitialized;
			object.geometryCount = this._geometryCount;

			object.matricesTexture = this._matricesTexture.toJSON( meta );

			if ( this.boundingSphere !== null ) {

				object.boundingSphere = {
					center: object.boundingSphere.center.toArray(),
					radius: object.boundingSphere.radius
				};

			}

			if ( this.boundingBox !== null ) {

				object.boundingBox = {
					min: object.boundingBox.min.toArray(),
					max: object.boundingBox.max.toArray()
				};

			}

		}

		//

		function serialize( library, element ) {

			if ( library[ element.uuid ] === undefined ) {

				library[ element.uuid ] = element.toJSON( meta );

			}

			return element.uuid;

		}

		if ( this.isScene ) {

			if ( this.background ) {

				if ( this.background.isColor ) {

					object.background = this.background.toJSON();

				} else if ( this.background.isTexture ) {

					object.background = this.background.toJSON( meta ).uuid;

				}

			}

			if ( this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== true ) {

				object.environment = this.environment.toJSON( meta ).uuid;

			}

		} else if ( this.isMesh || this.isLine || this.isPoints ) {

			object.geometry = serialize( meta.geometries, this.geometry );

			const parameters = this.geometry.parameters;

			if ( parameters !== undefined && parameters.shapes !== undefined ) {

				const shapes = parameters.shapes;

				if ( Array.isArray( shapes ) ) {

					for ( let i = 0, l = shapes.length; i < l; i ++ ) {

						const shape = shapes[ i ];

						serialize( meta.shapes, shape );

					}

				} else {

					serialize( meta.shapes, shapes );

				}

			}

		}

		if ( this.isSkinnedMesh ) {

			object.bindMode = this.bindMode;
			object.bindMatrix = this.bindMatrix.toArray();

			if ( this.skeleton !== undefined ) {

				serialize( meta.skeletons, this.skeleton );

				object.skeleton = this.skeleton.uuid;

			}

		}

		if ( this.material !== undefined ) {

			if ( Array.isArray( this.material ) ) {

				const uuids = [];

				for ( let i = 0, l = this.material.length; i < l; i ++ ) {

					uuids.push( serialize( meta.materials, this.material[ i ] ) );

				}

				object.material = uuids;

			} else {

				object.material = serialize( meta.materials, this.material );

			}

		}

		//

		if ( this.children.length > 0 ) {

			object.children = [];

			for ( let i = 0; i < this.children.length; i ++ ) {

				object.children.push( this.children[ i ].toJSON( meta ).object );

			}

		}

		//

		if ( this.animations.length > 0 ) {

			object.animations = [];

			for ( let i = 0; i < this.animations.length; i ++ ) {

				const animation = this.animations[ i ];

				object.animations.push( serialize( meta.animations, animation ) );

			}

		}

		if ( isRootObject ) {

			const geometries = extractFromCache( meta.geometries );
			const materials = extractFromCache( meta.materials );
			const textures = extractFromCache( meta.textures );
			const images = extractFromCache( meta.images );
			const shapes = extractFromCache( meta.shapes );
			const skeletons = extractFromCache( meta.skeletons );
			const animations = extractFromCache( meta.animations );
			const nodes = extractFromCache( meta.nodes );

			if ( geometries.length > 0 ) output.geometries = geometries;
			if ( materials.length > 0 ) output.materials = materials;
			if ( textures.length > 0 ) output.textures = textures;
			if ( images.length > 0 ) output.images = images;
			if ( shapes.length > 0 ) output.shapes = shapes;
			if ( skeletons.length > 0 ) output.skeletons = skeletons;
			if ( animations.length > 0 ) output.animations = animations;
			if ( nodes.length > 0 ) output.nodes = nodes;

		}

		output.object = object;

		return output;

		// extract data from the cache hash
		// remove metadata on each item
		// and return as array
		function extractFromCache( cache ) {

			const values = [];
			for ( const key in cache ) {

				const data = cache[ key ];
				delete data.metadata;
				values.push( data );

			}

			return values;

		}

	}

	clone( recursive ) {

		return new this.constructor().copy( this, recursive );

	}

	copy( source, recursive = true ) {

		this.name = source.name;

		this.up.copy( source.up );

		this.position.copy( source.position );
		this.rotation.order = source.rotation.order;
		this.quaternion.copy( source.quaternion );
		this.scale.copy( source.scale );

		this.matrix.copy( source.matrix );
		this.matrixWorld.copy( source.matrixWorld );

		this.matrixAutoUpdate = source.matrixAutoUpdate;

		this.matrixWorldAutoUpdate = source.matrixWorldAutoUpdate;
		this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;

		this.layers.mask = source.layers.mask;
		this.visible = source.visible;

		this.castShadow = source.castShadow;
		this.receiveShadow = source.receiveShadow;

		this.frustumCulled = source.frustumCulled;
		this.renderOrder = source.renderOrder;

		this.animations = source.animations.slice();

		this.userData = JSON.parse( JSON.stringify( source.userData ) );

		if ( recursive === true ) {

			for ( let i = 0; i < source.children.length; i ++ ) {

				const child = source.children[ i ];
				this.add( child.clone() );

			}

		}

		return this;

	}

}

Object3D.DEFAULT_UP = /*@__PURE__*/ new Vector3( 0, 1, 0 );
Object3D.DEFAULT_MATRIX_AUTO_UPDATE = true;
Object3D.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = true;

const _v0$1 = /*@__PURE__*/ new Vector3();
const _v1$3 = /*@__PURE__*/ new Vector3();
const _v2$2 = /*@__PURE__*/ new Vector3();
const _v3$2 = /*@__PURE__*/ new Vector3();

const _vab = /*@__PURE__*/ new Vector3();
const _vac = /*@__PURE__*/ new Vector3();
const _vbc = /*@__PURE__*/ new Vector3();
const _vap = /*@__PURE__*/ new Vector3();
const _vbp = /*@__PURE__*/ new Vector3();
const _vcp = /*@__PURE__*/ new Vector3();

class Triangle {

	constructor( a = new Vector3(), b = new Vector3(), c = new Vector3() ) {

		this.a = a;
		this.b = b;
		this.c = c;

	}

	static getNormal( a, b, c, target ) {

		target.subVectors( c, b );
		_v0$1.subVectors( a, b );
		target.cross( _v0$1 );

		const targetLengthSq = target.lengthSq();
		if ( targetLengthSq > 0 ) {

			return target.multiplyScalar( 1 / Math.sqrt( targetLengthSq ) );

		}

		return target.set( 0, 0, 0 );

	}

	// static/instance method to calculate barycentric coordinates
	// based on: http://www.blackpawn.com/texts/pointinpoly/default.html
	static getBarycoord( point, a, b, c, target ) {

		_v0$1.subVectors( c, a );
		_v1$3.subVectors( b, a );
		_v2$2.subVectors( point, a );

		const dot00 = _v0$1.dot( _v0$1 );
		const dot01 = _v0$1.dot( _v1$3 );
		const dot02 = _v0$1.dot( _v2$2 );
		const dot11 = _v1$3.dot( _v1$3 );
		const dot12 = _v1$3.dot( _v2$2 );

		const denom = ( dot00 * dot11 - dot01 * dot01 );

		// collinear or singular triangle
		if ( denom === 0 ) {

			target.set( 0, 0, 0 );
			return null;

		}

		const invDenom = 1 / denom;
		const u = ( dot11 * dot02 - dot01 * dot12 ) * invDenom;
		const v = ( dot00 * dot12 - dot01 * dot02 ) * invDenom;

		// barycentric coordinates must always sum to 1
		return target.set( 1 - u - v, v, u );

	}

	static containsPoint( point, a, b, c ) {

		// if the triangle is degenerate then we can't contain a point
		if ( this.getBarycoord( point, a, b, c, _v3$2 ) === null ) {

			return false;

		}

		return ( _v3$2.x >= 0 ) && ( _v3$2.y >= 0 ) && ( ( _v3$2.x + _v3$2.y ) <= 1 );

	}

	static getInterpolation( point, p1, p2, p3, v1, v2, v3, target ) {

		if ( this.getBarycoord( point, p1, p2, p3, _v3$2 ) === null ) {

			target.x = 0;
			target.y = 0;
			if ( 'z' in target ) target.z = 0;
			if ( 'w' in target ) target.w = 0;
			return null;

		}

		target.setScalar( 0 );
		target.addScaledVector( v1, _v3$2.x );
		target.addScaledVector( v2, _v3$2.y );
		target.addScaledVector( v3, _v3$2.z );

		return target;

	}

	static isFrontFacing( a, b, c, direction ) {

		_v0$1.subVectors( c, b );
		_v1$3.subVectors( a, b );

		// strictly front facing
		return ( _v0$1.cross( _v1$3 ).dot( direction ) < 0 ) ? true : false;

	}

	set( a, b, c ) {

		this.a.copy( a );
		this.b.copy( b );
		this.c.copy( c );

		return this;

	}

	setFromPointsAndIndices( points, i0, i1, i2 ) {

		this.a.copy( points[ i0 ] );
		this.b.copy( points[ i1 ] );
		this.c.copy( points[ i2 ] );

		return this;

	}

	setFromAttributeAndIndices( attribute, i0, i1, i2 ) {

		this.a.fromBufferAttribute( attribute, i0 );
		this.b.fromBufferAttribute( attribute, i1 );
		this.c.fromBufferAttribute( attribute, i2 );

		return this;

	}

	clone() {

		return new this.constructor().copy( this );

	}

	copy( triangle ) {

		this.a.copy( triangle.a );
		this.b.copy( triangle.b );
		this.c.copy( triangle.c );

		return this;

	}

	getArea() {

		_v0$1.subVectors( this.c, this.b );
		_v1$3.subVectors( this.a, this.b );

		return _v0$1.cross( _v1$3 ).length() * 0.5;

	}

	getMidpoint( target ) {

		return target.addVectors( this.a, this.b ).add( this.c ).multiplyScalar( 1 / 3 );

	}

	getNormal( target ) {

		return Triangle.getNormal( this.a, this.b, this.c, target );

	}

	getPlane( target ) {

		return target.setFromCoplanarPoints( this.a, this.b, this.c );

	}

	getBarycoord( point, target ) {

		return Triangle.getBarycoord( point, this.a, this.b, this.c, target );

	}

	getInterpolation( point, v1, v2, v3, target ) {

		return Triangle.getInterpolation( point, this.a, this.b, this.c, v1, v2, v3, target );

	}

	containsPoint( point ) {

		return Triangle.containsPoint( point, this.a, this.b, this.c );

	}

	isFrontFacing( direction ) {

		return Triangle.isFrontFacing( this.a, this.b, this.c, direction );

	}

	intersectsBox( box ) {

		return box.intersectsTriangle( this );

	}

	closestPointToPoint( p, target ) {

		const a = this.a, b = this.b, c = this.c;
		let v, w;

		// algorithm thanks to Real-Time Collision Detection by Christer Ericson,
		// published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
		// under the accompanying license; see chapter 5.1.5 for detailed explanation.
		// basically, we're distinguishing which of the voronoi regions of the triangle
		// the point lies in with the minimum amount of redundant computation.

		_vab.subVectors( b, a );
		_vac.subVectors( c, a );
		_vap.subVectors( p, a );
		const d1 = _vab.dot( _vap );
		const d2 = _vac.dot( _vap );
		if ( d1 <= 0 && d2 <= 0 ) {

			// vertex region of A; barycentric coords (1, 0, 0)
			return target.copy( a );

		}

		_vbp.subVectors( p, b );
		const d3 = _vab.dot( _vbp );
		const d4 = _vac.dot( _vbp );
		if ( d3 >= 0 && d4 <= d3 ) {

			// vertex region of B; barycentric coords (0, 1, 0)
			return target.copy( b );

		}

		const vc = d1 * d4 - d3 * d2;
		if ( vc <= 0 && d1 >= 0 && d3 <= 0 ) {

			v = d1 / ( d1 - d3 );
			// edge region of AB; barycentric coords (1-v, v, 0)
			return target.copy( a ).addScaledVector( _vab, v );

		}

		_vcp.subVectors( p, c );
		const d5 = _vab.dot( _vcp );
		const d6 = _vac.dot( _vcp );
		if ( d6 >= 0 && d5 <= d6 ) {

			// vertex region of C; barycentric coords (0, 0, 1)
			return target.copy( c );

		}

		const vb = d5 * d2 - d1 * d6;
		if ( vb <= 0 && d2 >= 0 && d6 <= 0 ) {

			w = d2 / ( d2 - d6 );
			// edge region of AC; barycentric coords (1-w, 0, w)
			return target.copy( a ).addScaledVector( _vac, w );

		}

		const va = d3 * d6 - d5 * d4;
		if ( va <= 0 && ( d4 - d3 ) >= 0 && ( d5 - d6 ) >= 0 ) {

			_vbc.subVectors( c, b );
			w = ( d4 - d3 ) / ( ( d4 - d3 ) + ( d5 - d6 ) );
			// edge region of BC; barycentric coords (0, 1-w, w)
			return target.copy( b ).addScaledVector( _vbc, w ); // edge region of BC

		}

		// face region
		const denom = 1 / ( va + vb + vc );
		// u = va * denom
		v = vb * denom;
		w = vc * denom;

		return target.copy( a ).addScaledVector( _vab, v ).addScaledVector( _vac, w );

	}

	equals( triangle ) {

		return triangle.a.equals( this.a ) && triangle.b.equals( this.b ) && triangle.c.equals( this.c );

	}

}

const _colorKeywords = { 'aliceblue': 0xF0F8FF, 'antiquewhite': 0xFAEBD7, 'aqua': 0x00FFFF, 'aquamarine': 0x7FFFD4, 'azure': 0xF0FFFF,
	'beige': 0xF5F5DC, 'bisque': 0xFFE4C4, 'black': 0x000000, 'blanchedalmond': 0xFFEBCD, 'blue': 0x0000FF, 'blueviolet': 0x8A2BE2,
	'brown': 0xA52A2A, 'burlywood': 0xDEB887, 'cadetblue': 0x5F9EA0, 'chartreuse': 0x7FFF00, 'chocolate': 0xD2691E, 'coral': 0xFF7F50,
	'cornflowerblue': 0x6495ED, 'cornsilk': 0xFFF8DC, 'crimson': 0xDC143C, 'cyan': 0x00FFFF, 'darkblue': 0x00008B, 'darkcyan': 0x008B8B,
	'darkgoldenrod': 0xB8860B, 'darkgray': 0xA9A9A9, 'darkgreen': 0x006400, 'darkgrey': 0xA9A9A9, 'darkkhaki': 0xBDB76B, 'darkmagenta': 0x8B008B,
	'darkolivegreen': 0x556B2F, 'darkorange': 0xFF8C00, 'darkorchid': 0x9932CC, 'darkred': 0x8B0000, 'darksalmon': 0xE9967A, 'darkseagreen': 0x8FBC8F,
	'darkslateblue': 0x483D8B, 'darkslategray': 0x2F4F4F, 'darkslategrey': 0x2F4F4F, 'darkturquoise': 0x00CED1, 'darkviolet': 0x9400D3,
	'deeppink': 0xFF1493, 'deepskyblue': 0x00BFFF, 'dimgray': 0x696969, 'dimgrey': 0x696969, 'dodgerblue': 0x1E90FF, 'firebrick': 0xB22222,
	'floralwhite': 0xFFFAF0, 'forestgreen': 0x228B22, 'fuchsia': 0xFF00FF, 'gainsboro': 0xDCDCDC, 'ghostwhite': 0xF8F8FF, 'gold': 0xFFD700,
	'goldenrod': 0xDAA520, 'gray': 0x808080, 'green': 0x008000, 'greenyellow': 0xADFF2F, 'grey': 0x808080, 'honeydew': 0xF0FFF0, 'hotpink': 0xFF69B4,
	'indianred': 0xCD5C5C, 'indigo': 0x4B0082, 'ivory': 0xFFFFF0, 'khaki': 0xF0E68C, 'lavender': 0xE6E6FA, 'lavenderblush': 0xFFF0F5, 'lawngreen': 0x7CFC00,
	'lemonchiffon': 0xFFFACD, 'lightblue': 0xADD8E6, 'lightcoral': 0xF08080, 'lightcyan': 0xE0FFFF, 'lightgoldenrodyellow': 0xFAFAD2, 'lightgray': 0xD3D3D3,
	'lightgreen': 0x90EE90, 'lightgrey': 0xD3D3D3, 'lightpink': 0xFFB6C1, 'lightsalmon': 0xFFA07A, 'lightseagreen': 0x20B2AA, 'lightskyblue': 0x87CEFA,
	'lightslategray': 0x778899, 'lightslategrey': 0x778899, 'lightsteelblue': 0xB0C4DE, 'lightyellow': 0xFFFFE0, 'lime': 0x00FF00, 'limegreen': 0x32CD32,
	'linen': 0xFAF0E6, 'magenta': 0xFF00FF, 'maroon': 0x800000, 'mediumaquamarine': 0x66CDAA, 'mediumblue': 0x0000CD, 'mediumorchid': 0xBA55D3,
	'mediumpurple': 0x9370DB, 'mediumseagreen': 0x3CB371, 'mediumslateblue': 0x7B68EE, 'mediumspringgreen': 0x00FA9A, 'mediumturquoise': 0x48D1CC,
	'mediumvioletred': 0xC71585, 'midnightblue': 0x191970, 'mintcream': 0xF5FFFA, 'mistyrose': 0xFFE4E1, 'moccasin': 0xFFE4B5, 'navajowhite': 0xFFDEAD,
	'navy': 0x000080, 'oldlace': 0xFDF5E6, 'olive': 0x808000, 'olivedrab': 0x6B8E23, 'orange': 0xFFA500, 'orangered': 0xFF4500, 'orchid': 0xDA70D6,
	'palegoldenrod': 0xEEE8AA, 'palegreen': 0x98FB98, 'paleturquoise': 0xAFEEEE, 'palevioletred': 0xDB7093, 'papayawhip': 0xFFEFD5, 'peachpuff': 0xFFDAB9,
	'peru': 0xCD853F, 'pink': 0xFFC0CB, 'plum': 0xDDA0DD, 'powderblue': 0xB0E0E6, 'purple': 0x800080, 'rebeccapurple': 0x663399, 'red': 0xFF0000, 'rosybrown': 0xBC8F8F,
	'royalblue': 0x4169E1, 'saddlebrown': 0x8B4513, 'salmon': 0xFA8072, 'sandybrown': 0xF4A460, 'seagreen': 0x2E8B57, 'seashell': 0xFFF5EE,
	'sienna': 0xA0522D, 'silver': 0xC0C0C0, 'skyblue': 0x87CEEB, 'slateblue': 0x6A5ACD, 'slategray': 0x708090, 'slategrey': 0x708090, 'snow': 0xFFFAFA,
	'springgreen': 0x00FF7F, 'steelblue': 0x4682B4, 'tan': 0xD2B48C, 'teal': 0x008080, 'thistle': 0xD8BFD8, 'tomato': 0xFF6347, 'turquoise': 0x40E0D0,
	'violet': 0xEE82EE, 'wheat': 0xF5DEB3, 'white': 0xFFFFFF, 'whitesmoke': 0xF5F5F5, 'yellow': 0xFFFF00, 'yellowgreen': 0x9ACD32 };

const _hslA = { h: 0, s: 0, l: 0 };
const _hslB = { h: 0, s: 0, l: 0 };

function hue2rgb( p, q, t ) {

	if ( t < 0 ) t += 1;
	if ( t > 1 ) t -= 1;
	if ( t < 1 / 6 ) return p + ( q - p ) * 6 * t;
	if ( t < 1 / 2 ) return q;
	if ( t < 2 / 3 ) return p + ( q - p ) * 6 * ( 2 / 3 - t );
	return p;

}

class Color {

	constructor( r, g, b ) {

		this.isColor = true;

		this.r = 1;
		this.g = 1;
		this.b = 1;

		return this.set( r, g, b );

	}

	set( r, g, b ) {

		if ( g === undefined && b === undefined ) {

			// r is THREE.Color, hex or string

			const value = r;

			if ( value && value.isColor ) {

				this.copy( value );

			} else if ( typeof value === 'number' ) {

				this.setHex( value );

			} else if ( typeof value === 'string' ) {

				this.setStyle( value );

			}

		} else {

			this.setRGB( r, g, b );

		}

		return this;

	}

	setScalar( scalar ) {

		this.r = scalar;
		this.g = scalar;
		this.b = scalar;

		return this;

	}

	setHex( hex, colorSpace = SRGBColorSpace ) {

		hex = Math.floor( hex );

		this.r = ( hex >> 16 & 255 ) / 255;
		this.g = ( hex >> 8 & 255 ) / 255;
		this.b = ( hex & 255 ) / 255;

		ColorManagement.toWorkingColorSpace( this, colorSpace );

		return this;

	}

	setRGB( r, g, b, colorSpace = ColorManagement.workingColorSpace ) {

		this.r = r;
		this.g = g;
		this.b = b;

		ColorManagement.toWorkingColorSpace( this, colorSpace );

		return this;

	}

	setHSL( h, s, l, colorSpace = ColorManagement.workingColorSpace ) {

		// h,s,l ranges are in 0.0 - 1.0
		h = euclideanModulo( h, 1 );
		s = clamp( s, 0, 1 );
		l = clamp( l, 0, 1 );

		if ( s === 0 ) {

			this.r = this.g = this.b = l;

		} else {

			const p = l <= 0.5 ? l * ( 1 + s ) : l + s - ( l * s );
			const q = ( 2 * l ) - p;

			this.r = hue2rgb( q, p, h + 1 / 3 );
			this.g = hue2rgb( q, p, h );
			this.b = hue2rgb( q, p, h - 1 / 3 );

		}

		ColorManagement.toWorkingColorSpace( this, colorSpace );

		return this;

	}

	setStyle( style, colorSpace = SRGBColorSpace ) {

		function handleAlpha( string ) {

			if ( string === undefined ) return;

			if ( parseFloat( string ) < 1 ) {

				console.warn( 'THREE.Color: Alpha component of ' + style + ' will be ignored.' );

			}

		}


		let m;

		if ( m = /^(\w+)\(([^\)]*)\)/.exec( style ) ) {

			// rgb / hsl

			let color;
			const name = m[ 1 ];
			const components = m[ 2 ];

			switch ( name ) {

				case 'rgb':
				case 'rgba':

					if ( color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec( components ) ) {

						// rgb(255,0,0) rgba(255,0,0,0.5)

						handleAlpha( color[ 4 ] );

						return this.setRGB(
							Math.min( 255, parseInt( color[ 1 ], 10 ) ) / 255,
							Math.min( 255, parseInt( color[ 2 ], 10 ) ) / 255,
							Math.min( 255, parseInt( color[ 3 ], 10 ) ) / 255,
							colorSpace
						);

					}

					if ( color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec( components ) ) {

						// rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)

						handleAlpha( color[ 4 ] );

						return this.setRGB(
							Math.min( 100, parseInt( color[ 1 ], 10 ) ) / 100,
							Math.min( 100, parseInt( color[ 2 ], 10 ) ) / 100,
							Math.min( 100, parseInt( color[ 3 ], 10 ) ) / 100,
							colorSpace
						);

					}

					break;

				case 'hsl':
				case 'hsla':

					if ( color = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec( components ) ) {

						// hsl(120,50%,50%) hsla(120,50%,50%,0.5)

						handleAlpha( color[ 4 ] );

						return this.setHSL(
							parseFloat( color[ 1 ] ) / 360,
							parseFloat( color[ 2 ] ) / 100,
							parseFloat( color[ 3 ] ) / 100,
							colorSpace
						);

					}

					break;

				default:

					console.warn( 'THREE.Color: Unknown color model ' + style );

			}

		} else if ( m = /^\#([A-Fa-f\d]+)$/.exec( style ) ) {

			// hex color

			const hex = m[ 1 ];
			const size = hex.length;

			if ( size === 3 ) {

				// #ff0
				return this.setRGB(
					parseInt( hex.charAt( 0 ), 16 ) / 15,
					parseInt( hex.charAt( 1 ), 16 ) / 15,
					parseInt( hex.charAt( 2 ), 16 ) / 15,
					colorSpace
				);

			} else if ( size === 6 ) {

				// #ff0000
				return this.setHex( parseInt( hex, 16 ), colorSpace );

			} else {

				console.warn( 'THREE.Color: Invalid hex color ' + style );

			}

		} else if ( style && style.length > 0 ) {

			return this.setColorName( style, colorSpace );

		}

		return this;

	}

	setColorName( style, colorSpace = SRGBColorSpace ) {

		// color keywords
		const hex = _colorKeywords[ style.toLowerCase() ];

		if ( hex !== undefined ) {

			// red
			this.setHex( hex, colorSpace );

		} else {

			// unknown color
			console.warn( 'THREE.Color: Unknown color ' + style );

		}

		return this;

	}

	clone() {

		return new this.constructor( this.r, this.g, this.b );

	}

	copy( color ) {

		this.r = color.r;
		this.g = color.g;
		this.b = color.b;

		return this;

	}

	copySRGBToLinear( color ) {

		this.r = SRGBToLinear( color.r );
		this.g = SRGBToLinear( color.g );
		this.b = SRGBToLinear( color.b );

		return this;

	}

	copyLinearToSRGB( color ) {

		this.r = LinearToSRGB( color.r );
		this.g = LinearToSRGB( color.g );
		this.b = LinearToSRGB( color.b );

		return this;

	}

	convertSRGBToLinear() {

		this.copySRGBToLinear( this );

		return this;

	}

	convertLinearToSRGB() {

		this.copyLinearToSRGB( this );

		return this;

	}

	getHex( colorSpace = SRGBColorSpace ) {

		ColorManagement.fromWorkingColorSpace( _color.copy( this ), colorSpace );

		return Math.round( clamp( _color.r * 255, 0, 255 ) ) * 65536 + Math.round( clamp( _color.g * 255, 0, 255 ) ) * 256 + Math.round( clamp( _color.b * 255, 0, 255 ) );

	}

	getHexString( colorSpace = SRGBColorSpace ) {

		return ( '000000' + this.getHex( colorSpace ).toString( 16 ) ).slice( - 6 );

	}

	getHSL( target, colorSpace = ColorManagement.workingColorSpace ) {

		// h,s,l ranges are in 0.0 - 1.0

		ColorManagement.fromWorkingColorSpace( _color.copy( this ), colorSpace );

		const r = _color.r, g = _color.g, b = _color.b;

		const max = Math.max( r, g, b );
		const min = Math.min( r, g, b );

		let hue, saturation;
		const lightness = ( min + max ) / 2.0;

		if ( min === max ) {

			hue = 0;
			saturation = 0;

		} else {

			const delta = max - min;

			saturation = lightness <= 0.5 ? delta / ( max + min ) : delta / ( 2 - max - min );

			switch ( max ) {

				case r: hue = ( g - b ) / delta + ( g < b ? 6 : 0 ); break;
				case g: hue = ( b - r ) / delta + 2; break;
				case b: hue = ( r - g ) / delta + 4; break;

			}

			hue /= 6;

		}

		target.h = hue;
		target.s = saturation;
		target.l = lightness;

		return target;

	}

	getRGB( target, colorSpace = ColorManagement.workingColorSpace ) {

		ColorManagement.fromWorkingColorSpace( _color.copy( this ), colorSpace );

		target.r = _color.r;
		target.g = _color.g;
		target.b = _color.b;

		return target;

	}

	getStyle( colorSpace = SRGBColorSpace ) {

		ColorManagement.fromWorkingColorSpace( _color.copy( this ), colorSpace );

		const r = _color.r, g = _color.g, b = _color.b;

		if ( colorSpace !== SRGBColorSpace ) {

			// Requires CSS Color Module Level 4 (https://www.w3.org/TR/css-color-4/).
			return `color(${ colorSpace } ${ r.toFixed( 3 ) } ${ g.toFixed( 3 ) } ${ b.toFixed( 3 ) })`;

		}

		return `rgb(${ Math.round( r * 255 ) },${ Math.round( g * 255 ) },${ Math.round( b * 255 ) })`;

	}

	offsetHSL( h, s, l ) {

		this.getHSL( _hslA );

		return this.setHSL( _hslA.h + h, _hslA.s + s, _hslA.l + l );

	}

	add( color ) {

		this.r += color.r;
		this.g += color.g;
		this.b += color.b;

		return this;

	}

	addColors( color1, color2 ) {

		this.r = color1.r + color2.r;
		this.g = color1.g + color2.g;
		this.b = color1.b + color2.b;

		return this;

	}

	addScalar( s ) {

		this.r += s;
		this.g += s;
		this.b += s;

		return this;

	}

	sub( color ) {

		this.r = Math.max( 0, this.r - color.r );
		this.g = Math.max( 0, this.g - color.g );
		this.b = Math.max( 0, this.b - color.b );

		return this;

	}

	multiply( color ) {

		this.r *= color.r;
		this.g *= color.g;
		this.b *= color.b;

		return this;

	}

	multiplyScalar( s ) {

		this.r *= s;
		this.g *= s;
		this.b *= s;

		return this;

	}

	lerp( color, alpha ) {

		this.r += ( color.r - this.r ) * alpha;
		this.g += ( color.g - this.g ) * alpha;
		this.b += ( color.b - this.b ) * alpha;

		return this;

	}

	lerpColors( color1, color2, alpha ) {

		this.r = color1.r + ( color2.r - color1.r ) * alpha;
		this.g = color1.g + ( color2.g - color1.g ) * alpha;
		this.b = color1.b + ( color2.b - color1.b ) * alpha;

		return this;

	}

	lerpHSL( color, alpha ) {

		this.getHSL( _hslA );
		color.getHSL( _hslB );

		const h = lerp( _hslA.h, _hslB.h, alpha );
		const s = lerp( _hslA.s, _hslB.s, alpha );
		const l = lerp( _hslA.l, _hslB.l, alpha );

		this.setHSL( h, s, l );

		return this;

	}

	setFromVector3( v ) {

		this.r = v.x;
		this.g = v.y;
		this.b = v.z;

		return this;

	}

	applyMatrix3( m ) {

		const r = this.r, g = this.g, b = this.b;
		const e = m.elements;

		this.r = e[ 0 ] * r + e[ 3 ] * g + e[ 6 ] * b;
		this.g = e[ 1 ] * r + e[ 4 ] * g + e[ 7 ] * b;
		this.b = e[ 2 ] * r + e[ 5 ] * g + e[ 8 ] * b;

		return this;

	}

	equals( c ) {

		return ( c.r === this.r ) && ( c.g === this.g ) && ( c.b === this.b );

	}

	fromArray( array, offset = 0 ) {

		this.r = array[ offset ];
		this.g = array[ offset + 1 ];
		this.b = array[ offset + 2 ];

		return this;

	}

	toArray( array = [], offset = 0 ) {

		array[ offset ] = this.r;
		array[ offset + 1 ] = this.g;
		array[ offset + 2 ] = this.b;

		return array;

	}

	fromBufferAttribute( attribute, index ) {

		this.r = attribute.getX( index );
		this.g = attribute.getY( index );
		this.b = attribute.getZ( index );

		return this;

	}

	toJSON() {

		return this.getHex();

	}

	*[ Symbol.iterator ]() {

		yield this.r;
		yield this.g;
		yield this.b;

	}

}

const _color = /*@__PURE__*/ new Color();

Color.NAMES = _colorKeywords;

let _materialId = 0;

class Material extends EventDispatcher {

	constructor() {

		super();

		this.isMaterial = true;

		Object.defineProperty( this, 'id', { value: _materialId ++ } );

		this.uuid = generateUUID();

		this.name = '';
		this.type = 'Material';

		this.blending = NormalBlending;
		this.side = FrontSide;
		this.vertexColors = false;

		this.opacity = 1;
		this.transparent = false;
		this.alphaHash = false;

		this.blendSrc = SrcAlphaFactor;
		this.blendDst = OneMinusSrcAlphaFactor;
		this.blendEquation = AddEquation;
		this.blendSrcAlpha = null;
		this.blendDstAlpha = null;
		this.blendEquationAlpha = null;
		this.blendColor = new Color( 0, 0, 0 );
		this.blendAlpha = 0;

		this.depthFunc = LessEqualDepth;
		this.depthTest = true;
		this.depthWrite = true;

		this.stencilWriteMask = 0xff;
		this.stencilFunc = AlwaysStencilFunc;
		this.stencilRef = 0;
		this.stencilFuncMask = 0xff;
		this.stencilFail = KeepStencilOp;
		this.stencilZFail = KeepStencilOp;
		this.stencilZPass = KeepStencilOp;
		this.stencilWrite = false;

		this.clippingPlanes = null;
		this.clipIntersection = false;
		this.clipShadows = false;

		this.shadowSide = null;

		this.colorWrite = true;

		this.precision = null; // override the renderer's default precision for this material

		this.polygonOffset = false;
		this.polygonOffsetFactor = 0;
		this.polygonOffsetUnits = 0;

		this.dithering = false;

		this.alphaToCoverage = false;
		this.premultipliedAlpha = false;
		this.forceSinglePass = false;

		this.visible = true;

		this.toneMapped = true;

		this.userData = {};

		this.version = 0;

		this._alphaTest = 0;

	}

	get alphaTest() {

		return this._alphaTest;

	}

	set alphaTest( value ) {

		if ( this._alphaTest > 0 !== value > 0 ) {

			this.version ++;

		}

		this._alphaTest = value;

	}

	onBuild( /* shaderobject, renderer */ ) {}

	onBeforeRender( /* renderer, scene, camera, geometry, object, group */ ) {}

	onBeforeCompile( /* shaderobject, renderer */ ) {}

	customProgramCacheKey() {

		return this.onBeforeCompile.toString();

	}

	setValues( values ) {

		if ( values === undefined ) return;

		for ( const key in values ) {

			const newValue = values[ key ];

			if ( newValue === undefined ) {

				console.warn( `THREE.Material: parameter '${ key }' has value of undefined.` );
				continue;

			}

			const currentValue = this[ key ];

			if ( currentValue === undefined ) {

				console.warn( `THREE.Material: '${ key }' is not a property of THREE.${ this.type }.` );
				continue;

			}

			if ( currentValue && currentValue.isColor ) {

				currentValue.set( newValue );

			} else if ( ( currentValue && currentValue.isVector3 ) && ( newValue && newValue.isVector3 ) ) {

				currentValue.copy( newValue );

			} else {

				this[ key ] = newValue;

			}

		}

	}

	toJSON( meta ) {

		const isRootObject = ( meta === undefined || typeof meta === 'string' );

		if ( isRootObject ) {

			meta = {
				textures: {},
				images: {}
			};

		}

		const data = {
			metadata: {
				version: 4.6,
				type: 'Material',
				generator: 'Material.toJSON'
			}
		};

		// standard Material serialization
		data.uuid = this.uuid;
		data.type = this.type;

		if ( this.name !== '' ) data.name = this.name;

		if ( this.color && this.color.isColor ) data.color = this.color.getHex();

		if ( this.roughness !== undefined ) data.roughness = this.roughness;
		if ( this.metalness !== undefined ) data.metalness = this.metalness;

		if ( this.sheen !== undefined ) data.sheen = this.sheen;
		if ( this.sheenColor && this.sheenColor.isColor ) data.sheenColor = this.sheenColor.getHex();
		if ( this.sheenRoughness !== undefined ) data.sheenRoughness = this.sheenRoughness;
		if ( this.emissive && this.emissive.isColor ) data.emissive = this.emissive.getHex();
		if ( this.emissiveIntensity !== undefined && this.emissiveIntensity !== 1 ) data.emissiveIntensity = this.emissiveIntensity;

		if ( this.specular && this.specular.isColor ) data.specular = this.specular.getHex();
		if ( this.specularIntensity !== undefined ) data.specularIntensity = this.specularIntensity;
		if ( this.specularColor && this.specularColor.isColor ) data.specularColor = this.specularColor.getHex();
		if ( this.shininess !== undefined ) data.shininess = this.shininess;
		if ( this.clearcoat !== undefined ) data.clearcoat = this.clearcoat;
		if ( this.clearcoatRoughness !== undefined ) data.clearcoatRoughness = this.clearcoatRoughness;

		if ( this.clearcoatMap && this.clearcoatMap.isTexture ) {

			data.clearcoatMap = this.clearcoatMap.toJSON( meta ).uuid;

		}

		if ( this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture ) {

			data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON( meta ).uuid;

		}

		if ( this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture ) {

			data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON( meta ).uuid;
			data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();

		}

		if ( this.iridescence !== undefined ) data.iridescence = this.iridescence;
		if ( this.iridescenceIOR !== undefined ) data.iridescenceIOR = this.iridescenceIOR;
		if ( this.iridescenceThicknessRange !== undefined ) data.iridescenceThicknessRange = this.iridescenceThicknessRange;

		if ( this.iridescenceMap && this.iridescenceMap.isTexture ) {

			data.iridescenceMap = this.iridescenceMap.toJSON( meta ).uuid;

		}

		if ( this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture ) {

			data.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON( meta ).uuid;

		}

		if ( this.anisotropy !== undefined ) data.anisotropy = this.anisotropy;
		if ( this.anisotropyRotation !== undefined ) data.anisotropyRotation = this.anisotropyRotation;

		if ( this.anisotropyMap && this.anisotropyMap.isTexture ) {

			data.anisotropyMap = this.anisotropyMap.toJSON( meta ).uuid;

		}

		if ( this.map && this.map.isTexture ) data.map = this.map.toJSON( meta ).uuid;
		if ( this.matcap && this.matcap.isTexture ) data.matcap = this.matcap.toJSON( meta ).uuid;
		if ( this.alphaMap && this.alphaMap.isTexture ) data.alphaMap = this.alphaMap.toJSON( meta ).uuid;

		if ( this.lightMap && this.lightMap.isTexture ) {

			data.lightMap = this.lightMap.toJSON( meta ).uuid;
			data.lightMapIntensity = this.lightMapIntensity;

		}

		if ( this.aoMap && this.aoMap.isTexture ) {

			data.aoMap = this.aoMap.toJSON( meta ).uuid;
			data.aoMapIntensity = this.aoMapIntensity;

		}

		if ( this.bumpMap && this.bumpMap.isTexture ) {

			data.bumpMap = this.bumpMap.toJSON( meta ).uuid;
			data.bumpScale = this.bumpScale;

		}

		if ( this.normalMap && this.normalMap.isTexture ) {

			data.normalMap = this.normalMap.toJSON( meta ).uuid;
			data.normalMapType = this.normalMapType;
			data.normalScale = this.normalScale.toArray();

		}

		if ( this.displacementMap && this.displacementMap.isTexture ) {

			data.displacementMap = this.displacementMap.toJSON( meta ).uuid;
			data.displacementScale = this.displacementScale;
			data.displacementBias = this.displacementBias;

		}

		if ( this.roughnessMap && this.roughnessMap.isTexture ) data.roughnessMap = this.roughnessMap.toJSON( meta ).uuid;
		if ( this.metalnessMap && this.metalnessMap.isTexture ) data.metalnessMap = this.metalnessMap.toJSON( meta ).uuid;

		if ( this.emissiveMap && this.emissiveMap.isTexture ) data.emissiveMap = this.emissiveMap.toJSON( meta ).uuid;
		if ( this.specularMap && this.specularMap.isTexture ) data.specularMap = this.specularMap.toJSON( meta ).uuid;
		if ( this.specularIntensityMap && this.specularIntensityMap.isTexture ) data.specularIntensityMap = this.specularIntensityMap.toJSON( meta ).uuid;
		if ( this.specularColorMap && this.specularColorMap.isTexture ) data.specularColorMap = this.specularColorMap.toJSON( meta ).uuid;

		if ( this.envMap && this.envMap.isTexture ) {

			data.envMap = this.envMap.toJSON( meta ).uuid;

			if ( this.combine !== undefined ) data.combine = this.combine;

		}

		if ( this.envMapRotation !== undefined ) data.envMapRotation = this.envMapRotation.toArray();
		if ( this.envMapIntensity !== undefined ) data.envMapIntensity = this.envMapIntensity;
		if ( this.reflectivity !== undefined ) data.reflectivity = this.reflectivity;
		if ( this.refractionRatio !== undefined ) data.refractionRatio = this.refractionRatio;

		if ( this.gradientMap && this.gradientMap.isTexture ) {

			data.gradientMap = this.gradientMap.toJSON( meta ).uuid;

		}

		if ( this.transmission !== undefined ) data.transmission = this.transmission;
		if ( this.transmissionMap && this.transmissionMap.isTexture ) data.transmissionMap = this.transmissionMap.toJSON( meta ).uuid;
		if ( this.thickness !== undefined ) data.thickness = this.thickness;
		if ( this.thicknessMap && this.thicknessMap.isTexture ) data.thicknessMap = this.thicknessMap.toJSON( meta ).uuid;
		if ( this.attenuationDistance !== undefined && this.attenuationDistance !== Infinity ) data.attenuationDistance = this.attenuationDistance;
		if ( this.attenuationColor !== undefined ) data.attenuationColor = this.attenuationColor.getHex();

		if ( this.size !== undefined ) data.size = this.size;
		if ( this.shadowSide !== null ) data.shadowSide = this.shadowSide;
		if ( this.sizeAttenuation !== undefined ) data.sizeAttenuation = this.sizeAttenuation;

		if ( this.blending !== NormalBlending ) data.blending = this.blending;
		if ( this.side !== FrontSide ) data.side = this.side;
		if ( this.vertexColors === true ) data.vertexColors = true;

		if ( this.opacity < 1 ) data.opacity = this.opacity;
		if ( this.transparent === true ) data.transparent = true;

		if ( this.blendSrc !== SrcAlphaFactor ) data.blendSrc = this.blendSrc;
		if ( this.blendDst !== OneMinusSrcAlphaFactor ) data.blendDst = this.blendDst;
		if ( this.blendEquation !== AddEquation ) data.blendEquation = this.blendEquation;
		if ( this.blendSrcAlpha !== null ) data.blendSrcAlpha = this.blendSrcAlpha;
		if ( this.blendDstAlpha !== null ) data.blendDstAlpha = this.blendDstAlpha;
		if ( this.blendEquationAlpha !== null ) data.blendEquationAlpha = this.blendEquationAlpha;
		if ( this.blendColor && this.blendColor.isColor ) data.blendColor = this.blendColor.getHex();
		if ( this.blendAlpha !== 0 ) data.blendAlpha = this.blendAlpha;

		if ( this.depthFunc !== LessEqualDepth ) data.depthFunc = this.depthFunc;
		if ( this.depthTest === false ) data.depthTest = this.depthTest;
		if ( this.depthWrite === false ) data.depthWrite = this.depthWrite;
		if ( this.colorWrite === false ) data.colorWrite = this.colorWrite;

		if ( this.stencilWriteMask !== 0xff ) data.stencilWriteMask = this.stencilWriteMask;
		if ( this.stencilFunc !== AlwaysStencilFunc ) data.stencilFunc = this.stencilFunc;
		if ( this.stencilRef !== 0 ) data.stencilRef = this.stencilRef;
		if ( this.stencilFuncMask !== 0xff ) data.stencilFuncMask = this.stencilFuncMask;
		if ( this.stencilFail !== KeepStencilOp ) data.stencilFail = this.stencilFail;
		if ( this.stencilZFail !== KeepStencilOp ) data.stencilZFail = this.stencilZFail;
		if ( this.stencilZPass !== KeepStencilOp ) data.stencilZPass = this.stencilZPass;
		if ( this.stencilWrite === true ) data.stencilWrite = this.stencilWrite;

		// rotation (SpriteMaterial)
		if ( this.rotation !== undefined && this.rotation !== 0 ) data.rotation = this.rotation;

		if ( this.polygonOffset === true ) data.polygonOffset = true;
		if ( this.polygonOffsetFactor !== 0 ) data.polygonOffsetFactor = this.polygonOffsetFactor;
		if ( this.polygonOffsetUnits !== 0 ) data.polygonOffsetUnits = this.polygonOffsetUnits;

		if ( this.linewidth !== undefined && this.linewidth !== 1 ) data.linewidth = this.linewidth;
		if ( this.dashSize !== undefined ) data.dashSize = this.dashSize;
		if ( this.gapSize !== undefined ) data.gapSize = this.gapSize;
		if ( this.scale !== undefined ) data.scale = this.scale;

		if ( this.dithering === true ) data.dithering = true;

		if ( this.alphaTest > 0 ) data.alphaTest = this.alphaTest;
		if ( this.alphaHash === true ) data.alphaHash = true;
		if ( this.alphaToCoverage === true ) data.alphaToCoverage = true;
		if ( this.premultipliedAlpha === true ) data.premultipliedAlpha = true;
		if ( this.forceSinglePass === true ) data.forceSinglePass = true;

		if ( this.wireframe === true ) data.wireframe = true;
		if ( this.wireframeLinewidth > 1 ) data.wireframeLinewidth = this.wireframeLinewidth;
		if ( this.wireframeLinecap !== 'round' ) data.wireframeLinecap = this.wireframeLinecap;
		if ( this.wireframeLinejoin !== 'round' ) data.wireframeLinejoin = this.wireframeLinejoin;

		if ( this.flatShading === true ) data.flatShading = true;

		if ( this.visible === false ) data.visible = false;

		if ( this.toneMapped === false ) data.toneMapped = false;

		if ( this.fog === false ) data.fog = false;

		if ( Object.keys( this.userData ).length > 0 ) data.userData = this.userData;

		// TODO: Copied from Object3D.toJSON

		function extractFromCache( cache ) {

			const values = [];

			for ( const key in cache ) {

				const data = cache[ key ];
				delete data.metadata;
				values.push( data );

			}

			return values;

		}

		if ( isRootObject ) {

			const textures = extractFromCache( meta.textures );
			const images = extractFromCache( meta.images );

			if ( textures.length > 0 ) data.textures = textures;
			if ( images.length > 0 ) data.images = images;

		}

		return data;

	}

	clone() {

		return new this.constructor().copy( this );

	}

	copy( source ) {

		this.name = source.name;

		this.blending = source.blending;
		this.side = source.side;
		this.vertexColors = source.vertexColors;

		this.opacity = source.opacity;
		this.transparent = source.transparent;

		this.blendSrc = source.blendSrc;
		this.blendDst = source.blendDst;
		this.blendEquation = source.blendEquation;
		this.blendSrcAlpha = source.blendSrcAlpha;
		this.blendDstAlpha = source.blendDstAlpha;
		this.blendEquationAlpha = source.blendEquationAlpha;
		this.blendColor.copy( source.blendColor );
		this.blendAlpha = source.blendAlpha;

		this.depthFunc = source.depthFunc;
		this.depthTest = source.depthTest;
		this.depthWrite = source.depthWrite;

		this.stencilWriteMask = source.stencilWriteMask;
		this.stencilFunc = source.stencilFunc;
		this.stencilRef = source.stencilRef;
		this.stencilFuncMask = source.stencilFuncMask;
		this.stencilFail = source.stencilFail;
		this.stencilZFail = source.stencilZFail;
		this.stencilZPass = source.stencilZPass;
		this.stencilWrite = source.stencilWrite;

		const srcPlanes = source.clippingPlanes;
		let dstPlanes = null;

		if ( srcPlanes !== null ) {

			const n = srcPlanes.length;
			dstPlanes = new Array( n );

			for ( let i = 0; i !== n; ++ i ) {

				dstPlanes[ i ] = srcPlanes[ i ].clone();

			}

		}

		this.clippingPlanes = dstPlanes;
		this.clipIntersection = source.clipIntersection;
		this.clipShadows = source.clipShadows;

		this.shadowSide = source.shadowSide;

		this.colorWrite = source.colorWrite;

		this.precision = source.precision;

		this.polygonOffset = source.polygonOffset;
		this.polygonOffsetFactor = source.polygonOffsetFactor;
		this.polygonOffsetUnits = source.polygonOffsetUnits;

		this.dithering = source.dithering;

		this.alphaTest = source.alphaTest;
		this.alphaHash = source.alphaHash;
		this.alphaToCoverage = source.alphaToCoverage;
		this.premultipliedAlpha = source.premultipliedAlpha;
		this.forceSinglePass = source.forceSinglePass;

		this.visible = source.visible;

		this.toneMapped = source.toneMapped;

		this.userData = JSON.parse( JSON.stringify( source.userData ) );

		return this;

	}

	dispose() {

		this.dispatchEvent( { type: 'dispose' } );

	}

	set needsUpdate( value ) {

		if ( value === true ) this.version ++;

	}

}

class MeshBasicMaterial extends Material {

	constructor( parameters ) {

		super();

		this.isMeshBasicMaterial = true;

		this.type = 'MeshBasicMaterial';

		this.color = new Color( 0xffffff ); // emissive

		this.map = null;

		this.lightMap = null;
		this.lightMapIntensity = 1.0;

		this.aoMap = null;
		this.aoMapIntensity = 1.0;

		this.specularMap = null;

		this.alphaMap = null;

		this.envMap = null;
		this.envMapRotation = new Euler();
		this.combine = MultiplyOperation;
		this.reflectivity = 1;
		this.refractionRatio = 0.98;

		this.wireframe = false;
		this.wireframeLinewidth = 1;
		this.wireframeLinecap = 'round';
		this.wireframeLinejoin = 'round';

		this.fog = true;

		this.setValues( parameters );

	}

	copy( source ) {

		super.copy( source );

		this.color.copy( source.color );

		this.map = source.map;

		this.lightMap = source.lightMap;
		this.lightMapIntensity = source.lightMapIntensity;

		this.aoMap = source.aoMap;
		this.aoMapIntensity = source.aoMapIntensity;

		this.specularMap = source.specularMap;

		this.alphaMap = source.alphaMap;

		this.envMap = source.envMap;
		this.envMapRotation.copy( source.envMapRotation );
		this.combine = source.combine;
		this.reflectivity = source.reflectivity;
		this.refractionRatio = source.refractionRatio;

		this.wireframe = source.wireframe;
		this.wireframeLinewidth = source.wireframeLinewidth;
		this.wireframeLinecap = source.wireframeLinecap;
		this.wireframeLinejoin = source.wireframeLinejoin;

		this.fog = source.fog;

		return this;

	}

}

// Fast Half Float Conversions, http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf

const _tables = /*@__PURE__*/ _generateTables();

function _generateTables() {

	// float32 to float16 helpers

	const buffer = new ArrayBuffer( 4 );
	const floatView = new Float32Array( buffer );
	const uint32View = new Uint32Array( buffer );

	const baseTable = new Uint32Array( 512 );
	const shiftTable = new Uint32Array( 512 );

	for ( let i = 0; i < 256; ++ i ) {

		const e = i - 127;

		// very small number (0, -0)

		if ( e < - 27 ) {

			baseTable[ i ] = 0x0000;
			baseTable[ i | 0x100 ] = 0x8000;
			shiftTable[ i ] = 24;
			shiftTable[ i | 0x100 ] = 24;

			// small number (denorm)

		} else if ( e < - 14 ) {

			baseTable[ i ] = 0x0400 >> ( - e - 14 );
			baseTable[ i | 0x100 ] = ( 0x0400 >> ( - e - 14 ) ) | 0x8000;
			shiftTable[ i ] = - e - 1;
			shiftTable[ i | 0x100 ] = - e - 1;

			// normal number

		} else if ( e <= 15 ) {

			baseTable[ i ] = ( e + 15 ) << 10;
			baseTable[ i | 0x100 ] = ( ( e + 15 ) << 10 ) | 0x8000;
			shiftTable[ i ] = 13;
			shiftTable[ i | 0x100 ] = 13;

			// large number (Infinity, -Infinity)

		} else if ( e < 128 ) {

			baseTable[ i ] = 0x7c00;
			baseTable[ i | 0x100 ] = 0xfc00;
			shiftTable[ i ] = 24;
			shiftTable[ i | 0x100 ] = 24;

			// stay (NaN, Infinity, -Infinity)

		} else {

			baseTable[ i ] = 0x7c00;
			baseTable[ i | 0x100 ] = 0xfc00;
			shiftTable[ i ] = 13;
			shiftTable[ i | 0x100 ] = 13;

		}

	}

	// float16 to float32 helpers

	const mantissaTable = new Uint32Array( 2048 );
	const exponentTable = new Uint32Array( 64 );
	const offsetTable = new Uint32Array( 64 );

	for ( let i = 1; i < 1024; ++ i ) {

		let m = i << 13; // zero pad mantissa bits
		let e = 0; // zero exponent

		// normalized
		while ( ( m & 0x00800000 ) === 0 ) {

			m <<= 1;
			e -= 0x00800000; // decrement exponent

		}

		m &= ~ 0x00800000; // clear leading 1 bit
		e += 0x38800000; // adjust bias

		mantissaTable[ i ] = m | e;

	}

	for ( let i = 1024; i < 2048; ++ i ) {

		mantissaTable[ i ] = 0x38000000 + ( ( i - 1024 ) << 13 );

	}

	for ( let i = 1; i < 31; ++ i ) {

		exponentTable[ i ] = i << 23;

	}

	exponentTable[ 31 ] = 0x47800000;
	exponentTable[ 32 ] = 0x80000000;

	for ( let i = 33; i < 63; ++ i ) {

		exponentTable[ i ] = 0x80000000 + ( ( i - 32 ) << 23 );

	}

	exponentTable[ 63 ] = 0xc7800000;

	for ( let i = 1; i < 64; ++ i ) {

		if ( i !== 32 ) {

			offsetTable[ i ] = 1024;

		}

	}

	return {
		floatView: floatView,
		uint32View: uint32View,
		baseTable: baseTable,
		shiftTable: shiftTable,
		mantissaTable: mantissaTable,
		exponentTable: exponentTable,
		offsetTable: offsetTable
	};

}

// float32 to float16

function toHalfFloat( val ) {

	if ( Math.abs( val ) > 65504 ) console.warn( 'THREE.DataUtils.toHalfFloat(): Value out of range.' );

	val = clamp( val, - 65504, 65504 );

	_tables.floatView[ 0 ] = val;
	const f = _tables.uint32View[ 0 ];
	const e = ( f >> 23 ) & 0x1ff;
	return _tables.baseTable[ e ] + ( ( f & 0x007fffff ) >> _tables.shiftTable[ e ] );

}

// float16 to float32

function fromHalfFloat( val ) {

	const m = val >> 10;
	_tables.uint32View[ 0 ] = _tables.mantissaTable[ _tables.offsetTable[ m ] + ( val & 0x3ff ) ] + _tables.exponentTable[ m ];
	return _tables.floatView[ 0 ];

}

const DataUtils = {
	toHalfFloat: toHalfFloat,
	fromHalfFloat: fromHalfFloat,
};

const _vector$9 = /*@__PURE__*/ new Vector3();
const _vector2$1 = /*@__PURE__*/ new Vector2();

class BufferAttribute {

	constructor( array, itemSize, normalized = false ) {

		if ( Array.isArray( array ) ) {

			throw new TypeError( 'THREE.BufferAttribute: array should be a Typed Array.' );

		}

		this.isBufferAttribute = true;

		this.name = '';

		this.array = array;
		this.itemSize = itemSize;
		this.count = array !== undefined ? array.length / itemSize : 0;
		this.normalized = normalized;

		this.usage = StaticDrawUsage;
		this._updateRange = { offset: 0, count: - 1 };
		this.updateRanges = [];
		this.gpuType = FloatType;

		this.version = 0;

	}

	onUploadCallback() {}

	set needsUpdate( value ) {

		if ( value === true ) this.version ++;

	}

	get updateRange() {

		warnOnce( 'THREE.BufferAttribute: updateRange() is deprecated and will be removed in r169. Use addUpdateRange() instead.' ); // @deprecated, r159
		return this._updateRange;

	}

	setUsage( value ) {

		this.usage = value;

		return this;

	}

	addUpdateRange( start, count ) {

		this.updateRanges.push( { start, count } );

	}

	clearUpdateRanges() {

		this.updateRanges.length = 0;

	}

	copy( source ) {

		this.name = source.name;
		this.array = new source.array.constructor( source.array );
		this.itemSize = source.itemSize;
		this.count = source.count;
		this.normalized = source.normalized;

		this.usage = source.usage;
		this.gpuType = source.gpuType;

		return this;

	}

	copyAt( index1, attribute, index2 ) {

		index1 *= this.itemSize;
		index2 *= attribute.itemSize;

		for ( let i = 0, l = this.itemSize; i < l; i ++ ) {

			this.array[ index1 + i ] = attribute.array[ index2 + i ];

		}

		return this;

	}

	copyArray( array ) {

		this.array.set( array );

		return this;

	}

	applyMatrix3( m ) {

		if ( this.itemSize === 2 ) {

			for ( let i = 0, l = this.count; i < l; i ++ ) {

				_vector2$1.fromBufferAttribute( this, i );
				_vector2$1.applyMatrix3( m );

				this.setXY( i, _vector2$1.x, _vector2$1.y );

			}

		} else if ( this.itemSize === 3 ) {

			for ( let i = 0, l = this.count; i < l; i ++ ) {

				_vector$9.fromBufferAttribute( this, i );
				_vector$9.applyMatrix3( m );

				this.setXYZ( i, _vector$9.x, _vector$9.y, _vector$9.z );

			}

		}

		return this;

	}

	applyMatrix4( m ) {

		for ( let i = 0, l = this.count; i < l; i ++ ) {

			_vector$9.fromBufferAttribute( this, i );

			_vector$9.applyMatrix4( m );

			this.setXYZ( i, _vector$9.x, _vector$9.y, _vector$9.z );

		}

		return this;

	}

	applyNormalMatrix( m ) {

		for ( let i = 0, l = this.count; i < l; i ++ ) {

			_vector$9.fromBufferAttribute( this, i );

			_vector$9.applyNormalMatrix( m );

			this.setXYZ( i, _vector$9.x, _vector$9.y, _vector$9.z );

		}

		return this;

	}

	transformDirection( m ) {

		for ( let i = 0, l = this.count; i < l; i ++ ) {

			_vector$9.fromBufferAttribute( this, i );

			_vector$9.transformDirection( m );

			this.setXYZ( i, _vector$9.x, _vector$9.y, _vector$9.z );

		}

		return this;

	}

	set( value, offset = 0 ) {

		// Matching BufferAttribute constructor, do not normalize the array.
		this.array.set( value, offset );

		return this;

	}

	getComponent( index, component ) {

		let value = this.array[ index * this.itemSize + component ];

		if ( this.normalized ) value = denormalize( value, this.array );

		return value;

	}

	setComponent( index, component, value ) {

		if ( this.normalized ) value = normalize( value, this.array );

		this.array[ index * this.itemSize + component ] = value;

		return this;

	}

	getX( index ) {

		let x = this.array[ index * this.itemSize ];

		if ( this.normalized ) x = denormalize( x, this.array );

		return x;

	}

	setX( index, x ) {

		if ( this.normalized ) x = normalize( x, this.array );

		this.array[ index * this.itemSize ] = x;

		return this;

	}

	getY( index ) {

		let y = this.array[ index * this.itemSize + 1 ];

		if ( this.normalized ) y = denormalize( y, this.array );

		return y;

	}

	setY( index, y ) {

		if ( this.normalized ) y = normalize( y, this.array );

		this.array[ index * this.itemSize + 1 ] = y;

		return this;

	}

	getZ( index ) {

		let z = this.array[ index * this.itemSize + 2 ];

		if ( this.normalized ) z = denormalize( z, this.array );

		return z;

	}

	setZ( index, z ) {

		if ( this.normalized ) z = normalize( z, this.array );

		this.array[ index * this.itemSize + 2 ] = z;

		return this;

	}

	getW( index ) {

		let w = this.array[ index * this.itemSize + 3 ];

		if ( this.normalized ) w = denormalize( w, this.array );

		return w;

	}

	setW( index, w ) {

		if ( this.normalized ) w = normalize( w, this.array );

		this.array[ index * this.itemSize + 3 ] = w;

		return this;

	}

	setXY( index, x, y ) {

		index *= this.itemSize;

		if ( this.normalized ) {

			x = normalize( x, this.array );
			y = normalize( y, this.array );

		}

		this.array[ index + 0 ] = x;
		this.array[ index + 1 ] = y;

		return this;

	}

	setXYZ( index, x, y, z ) {

		index *= this.itemSize;

		if ( this.normalized ) {

			x = normalize( x, this.array );
			y = normalize( y, this.array );
			z = normalize( z, this.array );

		}

		this.array[ index + 0 ] = x;
		this.array[ index + 1 ] = y;
		this.array[ index + 2 ] = z;

		return this;

	}

	setXYZW( index, x, y, z, w ) {

		index *= this.itemSize;

		if ( this.normalized ) {

			x = normalize( x, this.array );
			y = normalize( y, this.array );
			z = normalize( z, this.array );
			w = normalize( w, this.array );

		}

		this.array[ index + 0 ] = x;
		this.array[ index + 1 ] = y;
		this.array[ index + 2 ] = z;
		this.array[ index + 3 ] = w;

		return this;

	}

	onUpload( callback ) {

		this.onUploadCallback = callback;

		return this;

	}

	clone() {

		return new this.constructor( this.array, this.itemSize ).copy( this );

	}

	toJSON() {

		const data = {
			itemSize: this.itemSize,
			type: this.array.constructor.name,
			array: Array.from( this.array ),
			normalized: this.normalized
		};

		if ( this.name !== '' ) data.name = this.name;
		if ( this.usage !== StaticDrawUsage ) data.usage = this.usage;

		return data;

	}

}

//

class Int8BufferAttribute extends (/* unused pure expression or super */ null && (BufferAttribute)) {

	constructor( array, itemSize, normalized ) {

		super( new Int8Array( array ), itemSize, normalized );

	}

}

class Uint8BufferAttribute extends (/* unused pure expression or super */ null && (BufferAttribute)) {

	constructor( array, itemSize, normalized ) {

		super( new Uint8Array( array ), itemSize, normalized );

	}

}

class Uint8ClampedBufferAttribute extends (/* unused pure expression or super */ null && (BufferAttribute)) {

	constructor( array, itemSize, normalized ) {

		super( new Uint8ClampedArray( array ), itemSize, normalized );

	}

}

class Int16BufferAttribute extends (/* unused pure expression or super */ null && (BufferAttribute)) {

	constructor( array, itemSize, normalized ) {

		super( new Int16Array( array ), itemSize, normalized );

	}

}

class Uint16BufferAttribute extends BufferAttribute {

	constructor( array, itemSize, normalized ) {

		super( new Uint16Array( array ), itemSize, normalized );

	}

}

class Int32BufferAttribute extends (/* unused pure expression or super */ null && (BufferAttribute)) {

	constructor( array, itemSize, normalized ) {

		super( new Int32Array( array ), itemSize, normalized );

	}

}

class Uint32BufferAttribute extends BufferAttribute {

	constructor( array, itemSize, normalized ) {

		super( new Uint32Array( array ), itemSize, normalized );

	}

}

class Float16BufferAttribute extends (/* unused pure expression or super */ null && (BufferAttribute)) {

	constructor( array, itemSize, normalized ) {

		super( new Uint16Array( array ), itemSize, normalized );

		this.isFloat16BufferAttribute = true;

	}

	getX( index ) {

		let x = fromHalfFloat( this.array[ index * this.itemSize ] );

		if ( this.normalized ) x = denormalize( x, this.array );

		return x;

	}

	setX( index, x ) {

		if ( this.normalized ) x = normalize( x, this.array );

		this.array[ index * this.itemSize ] = toHalfFloat( x );

		return this;

	}

	getY( index ) {

		let y = fromHalfFloat( this.array[ index * this.itemSize + 1 ] );

		if ( this.normalized ) y = denormalize( y, this.array );

		return y;

	}

	setY( index, y ) {

		if ( this.normalized ) y = normalize( y, this.array );

		this.array[ index * this.itemSize + 1 ] = toHalfFloat( y );

		return this;

	}

	getZ( index ) {

		let z = fromHalfFloat( this.array[ index * this.itemSize + 2 ] );

		if ( this.normalized ) z = denormalize( z, this.array );

		return z;

	}

	setZ( index, z ) {

		if ( this.normalized ) z = normalize( z, this.array );

		this.array[ index * this.itemSize + 2 ] = toHalfFloat( z );

		return this;

	}

	getW( index ) {

		let w = fromHalfFloat( this.array[ index * this.itemSize + 3 ] );

		if ( this.normalized ) w = denormalize( w, this.array );

		return w;

	}

	setW( index, w ) {

		if ( this.normalized ) w = normalize( w, this.array );

		this.array[ index * this.itemSize + 3 ] = toHalfFloat( w );

		return this;

	}

	setXY( index, x, y ) {

		index *= this.itemSize;

		if ( this.normalized ) {

			x = normalize( x, this.array );
			y = normalize( y, this.array );

		}

		this.array[ index + 0 ] = toHalfFloat( x );
		this.array[ index + 1 ] = toHalfFloat( y );

		return this;

	}

	setXYZ( index, x, y, z ) {

		index *= this.itemSize;

		if ( this.normalized ) {

			x = normalize( x, this.array );
			y = normalize( y, this.array );
			z = normalize( z, this.array );

		}

		this.array[ index + 0 ] = toHalfFloat( x );
		this.array[ index + 1 ] = toHalfFloat( y );
		this.array[ index + 2 ] = toHalfFloat( z );

		return this;

	}

	setXYZW( index, x, y, z, w ) {

		index *= this.itemSize;

		if ( this.normalized ) {

			x = normalize( x, this.array );
			y = normalize( y, this.array );
			z = normalize( z, this.array );
			w = normalize( w, this.array );

		}

		this.array[ index + 0 ] = toHalfFloat( x );
		this.array[ index + 1 ] = toHalfFloat( y );
		this.array[ index + 2 ] = toHalfFloat( z );
		this.array[ index + 3 ] = toHalfFloat( w );

		return this;

	}

}


class Float32BufferAttribute extends BufferAttribute {

	constructor( array, itemSize, normalized ) {

		super( new Float32Array( array ), itemSize, normalized );

	}

}

let _id$2 = 0;

const _m1$2 = /*@__PURE__*/ new Matrix4();
const _obj = /*@__PURE__*/ new Object3D();
const _offset = /*@__PURE__*/ new Vector3();
const _box$2 = /*@__PURE__*/ new Box3();
const _boxMorphTargets = /*@__PURE__*/ new Box3();
const _vector$8 = /*@__PURE__*/ new Vector3();

class BufferGeometry extends EventDispatcher {

	constructor() {

		super();

		this.isBufferGeometry = true;

		Object.defineProperty( this, 'id', { value: _id$2 ++ } );

		this.uuid = generateUUID();

		this.name = '';
		this.type = 'BufferGeometry';

		this.index = null;
		this.attributes = {};

		this.morphAttributes = {};
		this.morphTargetsRelative = false;

		this.groups = [];

		this.boundingBox = null;
		this.boundingSphere = null;

		this.drawRange = { start: 0, count: Infinity };

		this.userData = {};

	}

	getIndex() {

		return this.index;

	}

	setIndex( index ) {

		if ( Array.isArray( index ) ) {

			this.index = new ( arrayNeedsUint32( index ) ? Uint32BufferAttribute : Uint16BufferAttribute )( index, 1 );

		} else {

			this.index = index;

		}

		return this;

	}

	getAttribute( name ) {

		return this.attributes[ name ];

	}

	setAttribute( name, attribute ) {

		this.attributes[ name ] = attribute;

		return this;

	}

	deleteAttribute( name ) {

		delete this.attributes[ name ];

		return this;

	}

	hasAttribute( name ) {

		return this.attributes[ name ] !== undefined;

	}

	addGroup( start, count, materialIndex = 0 ) {

		this.groups.push( {

			start: start,
			count: count,
			materialIndex: materialIndex

		} );

	}

	clearGroups() {

		this.groups = [];

	}

	setDrawRange( start, count ) {

		this.drawRange.start = start;
		this.drawRange.count = count;

	}

	applyMatrix4( matrix ) {

		const position = this.attributes.position;

		if ( position !== undefined ) {

			position.applyMatrix4( matrix );

			position.needsUpdate = true;

		}

		const normal = this.attributes.normal;

		if ( normal !== undefined ) {

			const normalMatrix = new Matrix3().getNormalMatrix( matrix );

			normal.applyNormalMatrix( normalMatrix );

			normal.needsUpdate = true;

		}

		const tangent = this.attributes.tangent;

		if ( tangent !== undefined ) {

			tangent.transformDirection( matrix );

			tangent.needsUpdate = true;

		}

		if ( this.boundingBox !== null ) {

			this.computeBoundingBox();

		}

		if ( this.boundingSphere !== null ) {

			this.computeBoundingSphere();

		}

		return this;

	}

	applyQuaternion( q ) {

		_m1$2.makeRotationFromQuaternion( q );

		this.applyMatrix4( _m1$2 );

		return this;

	}

	rotateX( angle ) {

		// rotate geometry around world x-axis

		_m1$2.makeRotationX( angle );

		this.applyMatrix4( _m1$2 );

		return this;

	}

	rotateY( angle ) {

		// rotate geometry around world y-axis

		_m1$2.makeRotationY( angle );

		this.applyMatrix4( _m1$2 );

		return this;

	}

	rotateZ( angle ) {

		// rotate geometry around world z-axis

		_m1$2.makeRotationZ( angle );

		this.applyMatrix4( _m1$2 );

		return this;

	}

	translate( x, y, z ) {

		// translate geometry

		_m1$2.makeTranslation( x, y, z );

		this.applyMatrix4( _m1$2 );

		return this;

	}

	scale( x, y, z ) {

		// scale geometry

		_m1$2.makeScale( x, y, z );

		this.applyMatrix4( _m1$2 );

		return this;

	}

	lookAt( vector ) {

		_obj.lookAt( vector );

		_obj.updateMatrix();

		this.applyMatrix4( _obj.matrix );

		return this;

	}

	center() {

		this.computeBoundingBox();

		this.boundingBox.getCenter( _offset ).negate();

		this.translate( _offset.x, _offset.y, _offset.z );

		return this;

	}

	setFromPoints( points ) {

		const position = [];

		for ( let i = 0, l = points.length; i < l; i ++ ) {

			const point = points[ i ];
			position.push( point.x, point.y, point.z || 0 );

		}

		this.setAttribute( 'position', new Float32BufferAttribute( position, 3 ) );

		return this;

	}

	computeBoundingBox() {

		if ( this.boundingBox === null ) {

			this.boundingBox = new Box3();

		}

		const position = this.attributes.position;
		const morphAttributesPosition = this.morphAttributes.position;

		if ( position && position.isGLBufferAttribute ) {

			console.error( 'THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.', this );

			this.boundingBox.set(
				new Vector3( - Infinity, - Infinity, - Infinity ),
				new Vector3( + Infinity, + Infinity, + Infinity )
			);

			return;

		}

		if ( position !== undefined ) {

			this.boundingBox.setFromBufferAttribute( position );

			// process morph attributes if present

			if ( morphAttributesPosition ) {

				for ( let i = 0, il = morphAttributesPosition.length; i < il; i ++ ) {

					const morphAttribute = morphAttributesPosition[ i ];
					_box$2.setFromBufferAttribute( morphAttribute );

					if ( this.morphTargetsRelative ) {

						_vector$8.addVectors( this.boundingBox.min, _box$2.min );
						this.boundingBox.expandByPoint( _vector$8 );

						_vector$8.addVectors( this.boundingBox.max, _box$2.max );
						this.boundingBox.expandByPoint( _vector$8 );

					} else {

						this.boundingBox.expandByPoint( _box$2.min );
						this.boundingBox.expandByPoint( _box$2.max );

					}

				}

			}

		} else {

			this.boundingBox.makeEmpty();

		}

		if ( isNaN( this.boundingBox.min.x ) || isNaN( this.boundingBox.min.y ) || isNaN( this.boundingBox.min.z ) ) {

			console.error( 'THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this );

		}

	}

	computeBoundingSphere() {

		if ( this.boundingSphere === null ) {

			this.boundingSphere = new Sphere();

		}

		const position = this.attributes.position;
		const morphAttributesPosition = this.morphAttributes.position;

		if ( position && position.isGLBufferAttribute ) {

			console.error( 'THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.', this );

			this.boundingSphere.set( new Vector3(), Infinity );

			return;

		}

		if ( position ) {

			// first, find the center of the bounding sphere

			const center = this.boundingSphere.center;

			_box$2.setFromBufferAttribute( position );

			// process morph attributes if present

			if ( morphAttributesPosition ) {

				for ( let i = 0, il = morphAttributesPosition.length; i < il; i ++ ) {

					const morphAttribute = morphAttributesPosition[ i ];
					_boxMorphTargets.setFromBufferAttribute( morphAttribute );

					if ( this.morphTargetsRelative ) {

						_vector$8.addVectors( _box$2.min, _boxMorphTargets.min );
						_box$2.expandByPoint( _vector$8 );

						_vector$8.addVectors( _box$2.max, _boxMorphTargets.max );
						_box$2.expandByPoint( _vector$8 );

					} else {

						_box$2.expandByPoint( _boxMorphTargets.min );
						_box$2.expandByPoint( _boxMorphTargets.max );

					}

				}

			}

			_box$2.getCenter( center );

			// second, try to find a boundingSphere with a radius smaller than the
			// boundingSphere of the boundingBox: sqrt(3) smaller in the best case

			let maxRadiusSq = 0;

			for ( let i = 0, il = position.count; i < il; i ++ ) {

				_vector$8.fromBufferAttribute( position, i );

				maxRadiusSq = Math.max( maxRadiusSq, center.distanceToSquared( _vector$8 ) );

			}

			// process morph attributes if present

			if ( morphAttributesPosition ) {

				for ( let i = 0, il = morphAttributesPosition.length; i < il; i ++ ) {

					const morphAttribute = morphAttributesPosition[ i ];
					const morphTargetsRelative = this.morphTargetsRelative;

					for ( let j = 0, jl = morphAttribute.count; j < jl; j ++ ) {

						_vector$8.fromBufferAttribute( morphAttribute, j );

						if ( morphTargetsRelative ) {

							_offset.fromBufferAttribute( position, j );
							_vector$8.add( _offset );

						}

						maxRadiusSq = Math.max( maxRadiusSq, center.distanceToSquared( _vector$8 ) );

					}

				}

			}

			this.boundingSphere.radius = Math.sqrt( maxRadiusSq );

			if ( isNaN( this.boundingSphere.radius ) ) {

				console.error( 'THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this );

			}

		}

	}

	computeTangents() {

		const index = this.index;
		const attributes = this.attributes;

		// based on http://www.terathon.com/code/tangent.html
		// (per vertex tangents)

		if ( index === null ||
			 attributes.position === undefined ||
			 attributes.normal === undefined ||
			 attributes.uv === undefined ) {

			console.error( 'THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)' );
			return;

		}

		const positionAttribute = attributes.position;
		const normalAttribute = attributes.normal;
		const uvAttribute = attributes.uv;

		if ( this.hasAttribute( 'tangent' ) === false ) {

			this.setAttribute( 'tangent', new BufferAttribute( new Float32Array( 4 * positionAttribute.count ), 4 ) );

		}

		const tangentAttribute = this.getAttribute( 'tangent' );

		const tan1 = [], tan2 = [];

		for ( let i = 0; i < positionAttribute.count; i ++ ) {

			tan1[ i ] = new Vector3();
			tan2[ i ] = new Vector3();

		}

		const vA = new Vector3(),
			vB = new Vector3(),
			vC = new Vector3(),

			uvA = new Vector2(),
			uvB = new Vector2(),
			uvC = new Vector2(),

			sdir = new Vector3(),
			tdir = new Vector3();

		function handleTriangle( a, b, c ) {

			vA.fromBufferAttribute( positionAttribute, a );
			vB.fromBufferAttribute( positionAttribute, b );
			vC.fromBufferAttribute( positionAttribute, c );

			uvA.fromBufferAttribute( uvAttribute, a );
			uvB.fromBufferAttribute( uvAttribute, b );
			uvC.fromBufferAttribute( uvAttribute, c );

			vB.sub( vA );
			vC.sub( vA );

			uvB.sub( uvA );
			uvC.sub( uvA );

			const r = 1.0 / ( uvB.x * uvC.y - uvC.x * uvB.y );

			// silently ignore degenerate uv triangles having coincident or colinear vertices

			if ( ! isFinite( r ) ) return;

			sdir.copy( vB ).multiplyScalar( uvC.y ).addScaledVector( vC, - uvB.y ).multiplyScalar( r );
			tdir.copy( vC ).multiplyScalar( uvB.x ).addScaledVector( vB, - uvC.x ).multiplyScalar( r );

			tan1[ a ].add( sdir );
			tan1[ b ].add( sdir );
			tan1[ c ].add( sdir );

			tan2[ a ].add( tdir );
			tan2[ b ].add( tdir );
			tan2[ c ].add( tdir );

		}

		let groups = this.groups;

		if ( groups.length === 0 ) {

			groups = [ {
				start: 0,
				count: index.count
			} ];

		}

		for ( let i = 0, il = groups.length; i < il; ++ i ) {

			const group = groups[ i ];

			const start = group.start;
			const count = group.count;

			for ( let j = start, jl = start + count; j < jl; j += 3 ) {

				handleTriangle(
					index.getX( j + 0 ),
					index.getX( j + 1 ),
					index.getX( j + 2 )
				);

			}

		}

		const tmp = new Vector3(), tmp2 = new Vector3();
		const n = new Vector3(), n2 = new Vector3();

		function handleVertex( v ) {

			n.fromBufferAttribute( normalAttribute, v );
			n2.copy( n );

			const t = tan1[ v ];

			// Gram-Schmidt orthogonalize

			tmp.copy( t );
			tmp.sub( n.multiplyScalar( n.dot( t ) ) ).normalize();

			// Calculate handedness

			tmp2.crossVectors( n2, t );
			const test = tmp2.dot( tan2[ v ] );
			const w = ( test < 0.0 ) ? - 1.0 : 1.0;

			tangentAttribute.setXYZW( v, tmp.x, tmp.y, tmp.z, w );

		}

		for ( let i = 0, il = groups.length; i < il; ++ i ) {

			const group = groups[ i ];

			const start = group.start;
			const count = group.count;

			for ( let j = start, jl = start + count; j < jl; j += 3 ) {

				handleVertex( index.getX( j + 0 ) );
				handleVertex( index.getX( j + 1 ) );
				handleVertex( index.getX( j + 2 ) );

			}

		}

	}

	computeVertexNormals() {

		const index = this.index;
		const positionAttribute = this.getAttribute( 'position' );

		if ( positionAttribute !== undefined ) {

			let normalAttribute = this.getAttribute( 'normal' );

			if ( normalAttribute === undefined ) {

				normalAttribute = new BufferAttribute( new Float32Array( positionAttribute.count * 3 ), 3 );
				this.setAttribute( 'normal', normalAttribute );

			} else {

				// reset existing normals to zero

				for ( let i = 0, il = normalAttribute.count; i < il; i ++ ) {

					normalAttribute.setXYZ( i, 0, 0, 0 );

				}

			}

			const pA = new Vector3(), pB = new Vector3(), pC = new Vector3();
			const nA = new Vector3(), nB = new Vector3(), nC = new Vector3();
			const cb = new Vector3(), ab = new Vector3();

			// indexed elements

			if ( index ) {

				for ( let i = 0, il = index.count; i < il; i += 3 ) {

					const vA = index.getX( i + 0 );
					const vB = index.getX( i + 1 );
					const vC = index.getX( i + 2 );

					pA.fromBufferAttribute( positionAttribute, vA );
					pB.fromBufferAttribute( positionAttribute, vB );
					pC.fromBufferAttribute( positionAttribute, vC );

					cb.subVectors( pC, pB );
					ab.subVectors( pA, pB );
					cb.cross( ab );

					nA.fromBufferAttribute( normalAttribute, vA );
					nB.fromBufferAttribute( normalAttribute, vB );
					nC.fromBufferAttribute( normalAttribute, vC );

					nA.add( cb );
					nB.add( cb );
					nC.add( cb );

					normalAttribute.setXYZ( vA, nA.x, nA.y, nA.z );
					normalAttribute.setXYZ( vB, nB.x, nB.y, nB.z );
					normalAttribute.setXYZ( vC, nC.x, nC.y, nC.z );

				}

			} else {

				// non-indexed elements (unconnected triangle soup)

				for ( let i = 0, il = positionAttribute.count; i < il; i += 3 ) {

					pA.fromBufferAttribute( positionAttribute, i + 0 );
					pB.fromBufferAttribute( positionAttribute, i + 1 );
					pC.fromBufferAttribute( positionAttribute, i + 2 );

					cb.subVectors( pC, pB );
					ab.subVectors( pA, pB );
					cb.cross( ab );

					normalAttribute.setXYZ( i + 0, cb.x, cb.y, cb.z );
					normalAttribute.setXYZ( i + 1, cb.x, cb.y, cb.z );
					normalAttribute.setXYZ( i + 2, cb.x, cb.y, cb.z );

				}

			}

			this.normalizeNormals();

			normalAttribute.needsUpdate = true;

		}

	}

	normalizeNormals() {

		const normals = this.attributes.normal;

		for ( let i = 0, il = normals.count; i < il; i ++ ) {

			_vector$8.fromBufferAttribute( normals, i );

			_vector$8.normalize();

			normals.setXYZ( i, _vector$8.x, _vector$8.y, _vector$8.z );

		}

	}

	toNonIndexed() {

		function convertBufferAttribute( attribute, indices ) {

			const array = attribute.array;
			const itemSize = attribute.itemSize;
			const normalized = attribute.normalized;

			const array2 = new array.constructor( indices.length * itemSize );

			let index = 0, index2 = 0;

			for ( let i = 0, l = indices.length; i < l; i ++ ) {

				if ( attribute.isInterleavedBufferAttribute ) {

					index = indices[ i ] * attribute.data.stride + attribute.offset;

				} else {

					index = indices[ i ] * itemSize;

				}

				for ( let j = 0; j < itemSize; j ++ ) {

					array2[ index2 ++ ] = array[ index ++ ];

				}

			}

			return new BufferAttribute( array2, itemSize, normalized );

		}

		//

		if ( this.index === null ) {

			console.warn( 'THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.' );
			return this;

		}

		const geometry2 = new BufferGeometry();

		const indices = this.index.array;
		const attributes = this.attributes;

		// attributes

		for ( const name in attributes ) {

			const attribute = attributes[ name ];

			const newAttribute = convertBufferAttribute( attribute, indices );

			geometry2.setAttribute( name, newAttribute );

		}

		// morph attributes

		const morphAttributes = this.morphAttributes;

		for ( const name in morphAttributes ) {

			const morphArray = [];
			const morphAttribute = morphAttributes[ name ]; // morphAttribute: array of Float32BufferAttributes

			for ( let i = 0, il = morphAttribute.length; i < il; i ++ ) {

				const attribute = morphAttribute[ i ];

				const newAttribute = convertBufferAttribute( attribute, indices );

				morphArray.push( newAttribute );

			}

			geometry2.morphAttributes[ name ] = morphArray;

		}

		geometry2.morphTargetsRelative = this.morphTargetsRelative;

		// groups

		const groups = this.groups;

		for ( let i = 0, l = groups.length; i < l; i ++ ) {

			const group = groups[ i ];
			geometry2.addGroup( group.start, group.count, group.materialIndex );

		}

		return geometry2;

	}

	toJSON() {

		const data = {
			metadata: {
				version: 4.6,
				type: 'BufferGeometry',
				generator: 'BufferGeometry.toJSON'
			}
		};

		// standard BufferGeometry serialization

		data.uuid = this.uuid;
		data.type = this.type;
		if ( this.name !== '' ) data.name = this.name;
		if ( Object.keys( this.userData ).length > 0 ) data.userData = this.userData;

		if ( this.parameters !== undefined ) {

			const parameters = this.parameters;

			for ( const key in parameters ) {

				if ( parameters[ key ] !== undefined ) data[ key ] = parameters[ key ];

			}

			return data;

		}

		// for simplicity the code assumes attributes are not shared across geometries, see #15811

		data.data = { attributes: {} };

		const index = this.index;

		if ( index !== null ) {

			data.data.index = {
				type: index.array.constructor.name,
				array: Array.prototype.slice.call( index.array )
			};

		}

		const attributes = this.attributes;

		for ( const key in attributes ) {

			const attribute = attributes[ key ];

			data.data.attributes[ key ] = attribute.toJSON( data.data );

		}

		const morphAttributes = {};
		let hasMorphAttributes = false;

		for ( const key in this.morphAttributes ) {

			const attributeArray = this.morphAttributes[ key ];

			const array = [];

			for ( let i = 0, il = attributeArray.length; i < il; i ++ ) {

				const attribute = attributeArray[ i ];

				array.push( attribute.toJSON( data.data ) );

			}

			if ( array.length > 0 ) {

				morphAttributes[ key ] = array;

				hasMorphAttributes = true;

			}

		}

		if ( hasMorphAttributes ) {

			data.data.morphAttributes = morphAttributes;
			data.data.morphTargetsRelative = this.morphTargetsRelative;

		}

		const groups = this.groups;

		if ( groups.length > 0 ) {

			data.data.groups = JSON.parse( JSON.stringify( groups ) );

		}

		const boundingSphere = this.boundingSphere;

		if ( boundingSphere !== null ) {

			data.data.boundingSphere = {
				center: boundingSphere.center.toArray(),
				radius: boundingSphere.radius
			};

		}

		return data;

	}

	clone() {

		return new this.constructor().copy( this );

	}

	copy( source ) {

		// reset

		this.index = null;
		this.attributes = {};
		this.morphAttributes = {};
		this.groups = [];
		this.boundingBox = null;
		this.boundingSphere = null;

		// used for storing cloned, shared data

		const data = {};

		// name

		this.name = source.name;

		// index

		const index = source.index;

		if ( index !== null ) {

			this.setIndex( index.clone( data ) );

		}

		// attributes

		const attributes = source.attributes;

		for ( const name in attributes ) {

			const attribute = attributes[ name ];
			this.setAttribute( name, attribute.clone( data ) );

		}

		// morph attributes

		const morphAttributes = source.morphAttributes;

		for ( const name in morphAttributes ) {

			const array = [];
			const morphAttribute = morphAttributes[ name ]; // morphAttribute: array of Float32BufferAttributes

			for ( let i = 0, l = morphAttribute.length; i < l; i ++ ) {

				array.push( morphAttribute[ i ].clone( data ) );

			}

			this.morphAttributes[ name ] = array;

		}

		this.morphTargetsRelative = source.morphTargetsRelative;

		// groups

		const groups = source.groups;

		for ( let i = 0, l = groups.length; i < l; i ++ ) {

			const group = groups[ i ];
			this.addGroup( group.start, group.count, group.materialIndex );

		}

		// bounding box

		const boundingBox = source.boundingBox;

		if ( boundingBox !== null ) {

			this.boundingBox = boundingBox.clone();

		}

		// bounding sphere

		const boundingSphere = source.boundingSphere;

		if ( boundingSphere !== null ) {

			this.boundingSphere = boundingSphere.clone();

		}

		// draw range

		this.drawRange.start = source.drawRange.start;
		this.drawRange.count = source.drawRange.count;

		// user data

		this.userData = source.userData;

		return this;

	}

	dispose() {

		this.dispatchEvent( { type: 'dispose' } );

	}

}

const _inverseMatrix$3 = /*@__PURE__*/ new Matrix4();
const _ray$3 = /*@__PURE__*/ new Ray();
const _sphere$6 = /*@__PURE__*/ new Sphere();
const _sphereHitAt = /*@__PURE__*/ new Vector3();

const _vA$1 = /*@__PURE__*/ new Vector3();
const _vB$1 = /*@__PURE__*/ new Vector3();
const _vC$1 = /*@__PURE__*/ new Vector3();

const _tempA = /*@__PURE__*/ new Vector3();
const _morphA = /*@__PURE__*/ new Vector3();

const _uvA$1 = /*@__PURE__*/ new Vector2();
const _uvB$1 = /*@__PURE__*/ new Vector2();
const _uvC$1 = /*@__PURE__*/ new Vector2();

const _normalA = /*@__PURE__*/ new Vector3();
const _normalB = /*@__PURE__*/ new Vector3();
const _normalC = /*@__PURE__*/ new Vector3();

const _intersectionPoint = /*@__PURE__*/ new Vector3();
const _intersectionPointWorld = /*@__PURE__*/ new Vector3();

class Mesh extends Object3D {

	constructor( geometry = new BufferGeometry(), material = new MeshBasicMaterial() ) {

		super();

		this.isMesh = true;

		this.type = 'Mesh';

		this.geometry = geometry;
		this.material = material;

		this.updateMorphTargets();

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		if ( source.morphTargetInfluences !== undefined ) {

			this.morphTargetInfluences = source.morphTargetInfluences.slice();

		}

		if ( source.morphTargetDictionary !== undefined ) {

			this.morphTargetDictionary = Object.assign( {}, source.morphTargetDictionary );

		}

		this.material = Array.isArray( source.material ) ? source.material.slice() : source.material;
		this.geometry = source.geometry;

		return this;

	}

	updateMorphTargets() {

		const geometry = this.geometry;

		const morphAttributes = geometry.morphAttributes;
		const keys = Object.keys( morphAttributes );

		if ( keys.length > 0 ) {

			const morphAttribute = morphAttributes[ keys[ 0 ] ];

			if ( morphAttribute !== undefined ) {

				this.morphTargetInfluences = [];
				this.morphTargetDictionary = {};

				for ( let m = 0, ml = morphAttribute.length; m < ml; m ++ ) {

					const name = morphAttribute[ m ].name || String( m );

					this.morphTargetInfluences.push( 0 );
					this.morphTargetDictionary[ name ] = m;

				}

			}

		}

	}

	getVertexPosition( index, target ) {

		const geometry = this.geometry;
		const position = geometry.attributes.position;
		const morphPosition = geometry.morphAttributes.position;
		const morphTargetsRelative = geometry.morphTargetsRelative;

		target.fromBufferAttribute( position, index );

		const morphInfluences = this.morphTargetInfluences;

		if ( morphPosition && morphInfluences ) {

			_morphA.set( 0, 0, 0 );

			for ( let i = 0, il = morphPosition.length; i < il; i ++ ) {

				const influence = morphInfluences[ i ];
				const morphAttribute = morphPosition[ i ];

				if ( influence === 0 ) continue;

				_tempA.fromBufferAttribute( morphAttribute, index );

				if ( morphTargetsRelative ) {

					_morphA.addScaledVector( _tempA, influence );

				} else {

					_morphA.addScaledVector( _tempA.sub( target ), influence );

				}

			}

			target.add( _morphA );

		}

		return target;

	}

	raycast( raycaster, intersects ) {

		const geometry = this.geometry;
		const material = this.material;
		const matrixWorld = this.matrixWorld;

		if ( material === undefined ) return;

		// test with bounding sphere in world space

		if ( geometry.boundingSphere === null ) geometry.computeBoundingSphere();

		_sphere$6.copy( geometry.boundingSphere );
		_sphere$6.applyMatrix4( matrixWorld );

		// check distance from ray origin to bounding sphere

		_ray$3.copy( raycaster.ray ).recast( raycaster.near );

		if ( _sphere$6.containsPoint( _ray$3.origin ) === false ) {

			if ( _ray$3.intersectSphere( _sphere$6, _sphereHitAt ) === null ) return;

			if ( _ray$3.origin.distanceToSquared( _sphereHitAt ) > ( raycaster.far - raycaster.near ) ** 2 ) return;

		}

		// convert ray to local space of mesh

		_inverseMatrix$3.copy( matrixWorld ).invert();
		_ray$3.copy( raycaster.ray ).applyMatrix4( _inverseMatrix$3 );

		// test with bounding box in local space

		if ( geometry.boundingBox !== null ) {

			if ( _ray$3.intersectsBox( geometry.boundingBox ) === false ) return;

		}

		// test for intersections with geometry

		this._computeIntersections( raycaster, intersects, _ray$3 );

	}

	_computeIntersections( raycaster, intersects, rayLocalSpace ) {

		let intersection;

		const geometry = this.geometry;
		const material = this.material;

		const index = geometry.index;
		const position = geometry.attributes.position;
		const uv = geometry.attributes.uv;
		const uv1 = geometry.attributes.uv1;
		const normal = geometry.attributes.normal;
		const groups = geometry.groups;
		const drawRange = geometry.drawRange;

		if ( index !== null ) {

			// indexed buffer geometry

			if ( Array.isArray( material ) ) {

				for ( let i = 0, il = groups.length; i < il; i ++ ) {

					const group = groups[ i ];
					const groupMaterial = material[ group.materialIndex ];

					const start = Math.max( group.start, drawRange.start );
					const end = Math.min( index.count, Math.min( ( group.start + group.count ), ( drawRange.start + drawRange.count ) ) );

					for ( let j = start, jl = end; j < jl; j += 3 ) {

						const a = index.getX( j );
						const b = index.getX( j + 1 );
						const c = index.getX( j + 2 );

						intersection = checkGeometryIntersection( this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c );

						if ( intersection ) {

							intersection.faceIndex = Math.floor( j / 3 ); // triangle number in indexed buffer semantics
							intersection.face.materialIndex = group.materialIndex;
							intersects.push( intersection );

						}

					}

				}

			} else {

				const start = Math.max( 0, drawRange.start );
				const end = Math.min( index.count, ( drawRange.start + drawRange.count ) );

				for ( let i = start, il = end; i < il; i += 3 ) {

					const a = index.getX( i );
					const b = index.getX( i + 1 );
					const c = index.getX( i + 2 );

					intersection = checkGeometryIntersection( this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c );

					if ( intersection ) {

						intersection.faceIndex = Math.floor( i / 3 ); // triangle number in indexed buffer semantics
						intersects.push( intersection );

					}

				}

			}

		} else if ( position !== undefined ) {

			// non-indexed buffer geometry

			if ( Array.isArray( material ) ) {

				for ( let i = 0, il = groups.length; i < il; i ++ ) {

					const group = groups[ i ];
					const groupMaterial = material[ group.materialIndex ];

					const start = Math.max( group.start, drawRange.start );
					const end = Math.min( position.count, Math.min( ( group.start + group.count ), ( drawRange.start + drawRange.count ) ) );

					for ( let j = start, jl = end; j < jl; j += 3 ) {

						const a = j;
						const b = j + 1;
						const c = j + 2;

						intersection = checkGeometryIntersection( this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c );

						if ( intersection ) {

							intersection.faceIndex = Math.floor( j / 3 ); // triangle number in non-indexed buffer semantics
							intersection.face.materialIndex = group.materialIndex;
							intersects.push( intersection );

						}

					}

				}

			} else {

				const start = Math.max( 0, drawRange.start );
				const end = Math.min( position.count, ( drawRange.start + drawRange.count ) );

				for ( let i = start, il = end; i < il; i += 3 ) {

					const a = i;
					const b = i + 1;
					const c = i + 2;

					intersection = checkGeometryIntersection( this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c );

					if ( intersection ) {

						intersection.faceIndex = Math.floor( i / 3 ); // triangle number in non-indexed buffer semantics
						intersects.push( intersection );

					}

				}

			}

		}

	}

}

function checkIntersection( object, material, raycaster, ray, pA, pB, pC, point ) {

	let intersect;

	if ( material.side === BackSide ) {

		intersect = ray.intersectTriangle( pC, pB, pA, true, point );

	} else {

		intersect = ray.intersectTriangle( pA, pB, pC, ( material.side === FrontSide ), point );

	}

	if ( intersect === null ) return null;

	_intersectionPointWorld.copy( point );
	_intersectionPointWorld.applyMatrix4( object.matrixWorld );

	const distance = raycaster.ray.origin.distanceTo( _intersectionPointWorld );

	if ( distance < raycaster.near || distance > raycaster.far ) return null;

	return {
		distance: distance,
		point: _intersectionPointWorld.clone(),
		object: object
	};

}

function checkGeometryIntersection( object, material, raycaster, ray, uv, uv1, normal, a, b, c ) {

	object.getVertexPosition( a, _vA$1 );
	object.getVertexPosition( b, _vB$1 );
	object.getVertexPosition( c, _vC$1 );

	const intersection = checkIntersection( object, material, raycaster, ray, _vA$1, _vB$1, _vC$1, _intersectionPoint );

	if ( intersection ) {

		if ( uv ) {

			_uvA$1.fromBufferAttribute( uv, a );
			_uvB$1.fromBufferAttribute( uv, b );
			_uvC$1.fromBufferAttribute( uv, c );

			intersection.uv = Triangle.getInterpolation( _intersectionPoint, _vA$1, _vB$1, _vC$1, _uvA$1, _uvB$1, _uvC$1, new Vector2() );

		}

		if ( uv1 ) {

			_uvA$1.fromBufferAttribute( uv1, a );
			_uvB$1.fromBufferAttribute( uv1, b );
			_uvC$1.fromBufferAttribute( uv1, c );

			intersection.uv1 = Triangle.getInterpolation( _intersectionPoint, _vA$1, _vB$1, _vC$1, _uvA$1, _uvB$1, _uvC$1, new Vector2() );

		}

		if ( normal ) {

			_normalA.fromBufferAttribute( normal, a );
			_normalB.fromBufferAttribute( normal, b );
			_normalC.fromBufferAttribute( normal, c );

			intersection.normal = Triangle.getInterpolation( _intersectionPoint, _vA$1, _vB$1, _vC$1, _normalA, _normalB, _normalC, new Vector3() );

			if ( intersection.normal.dot( ray.direction ) > 0 ) {

				intersection.normal.multiplyScalar( - 1 );

			}

		}

		const face = {
			a: a,
			b: b,
			c: c,
			normal: new Vector3(),
			materialIndex: 0
		};

		Triangle.getNormal( _vA$1, _vB$1, _vC$1, face.normal );

		intersection.face = face;

	}

	return intersection;

}

class BoxGeometry extends BufferGeometry {

	constructor( width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1 ) {

		super();

		this.type = 'BoxGeometry';

		this.parameters = {
			width: width,
			height: height,
			depth: depth,
			widthSegments: widthSegments,
			heightSegments: heightSegments,
			depthSegments: depthSegments
		};

		const scope = this;

		// segments

		widthSegments = Math.floor( widthSegments );
		heightSegments = Math.floor( heightSegments );
		depthSegments = Math.floor( depthSegments );

		// buffers

		const indices = [];
		const vertices = [];
		const normals = [];
		const uvs = [];

		// helper variables

		let numberOfVertices = 0;
		let groupStart = 0;

		// build each side of the box geometry

		buildPlane( 'z', 'y', 'x', - 1, - 1, depth, height, width, depthSegments, heightSegments, 0 ); // px
		buildPlane( 'z', 'y', 'x', 1, - 1, depth, height, - width, depthSegments, heightSegments, 1 ); // nx
		buildPlane( 'x', 'z', 'y', 1, 1, width, depth, height, widthSegments, depthSegments, 2 ); // py
		buildPlane( 'x', 'z', 'y', 1, - 1, width, depth, - height, widthSegments, depthSegments, 3 ); // ny
		buildPlane( 'x', 'y', 'z', 1, - 1, width, height, depth, widthSegments, heightSegments, 4 ); // pz
		buildPlane( 'x', 'y', 'z', - 1, - 1, width, height, - depth, widthSegments, heightSegments, 5 ); // nz

		// build geometry

		this.setIndex( indices );
		this.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.setAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
		this.setAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

		function buildPlane( u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex ) {

			const segmentWidth = width / gridX;
			const segmentHeight = height / gridY;

			const widthHalf = width / 2;
			const heightHalf = height / 2;
			const depthHalf = depth / 2;

			const gridX1 = gridX + 1;
			const gridY1 = gridY + 1;

			let vertexCounter = 0;
			let groupCount = 0;

			const vector = new Vector3();

			// generate vertices, normals and uvs

			for ( let iy = 0; iy < gridY1; iy ++ ) {

				const y = iy * segmentHeight - heightHalf;

				for ( let ix = 0; ix < gridX1; ix ++ ) {

					const x = ix * segmentWidth - widthHalf;

					// set values to correct vector component

					vector[ u ] = x * udir;
					vector[ v ] = y * vdir;
					vector[ w ] = depthHalf;

					// now apply vector to vertex buffer

					vertices.push( vector.x, vector.y, vector.z );

					// set values to correct vector component

					vector[ u ] = 0;
					vector[ v ] = 0;
					vector[ w ] = depth > 0 ? 1 : - 1;

					// now apply vector to normal buffer

					normals.push( vector.x, vector.y, vector.z );

					// uvs

					uvs.push( ix / gridX );
					uvs.push( 1 - ( iy / gridY ) );

					// counters

					vertexCounter += 1;

				}

			}

			// indices

			// 1. you need three indices to draw a single face
			// 2. a single segment consists of two faces
			// 3. so we need to generate six (2*3) indices per segment

			for ( let iy = 0; iy < gridY; iy ++ ) {

				for ( let ix = 0; ix < gridX; ix ++ ) {

					const a = numberOfVertices + ix + gridX1 * iy;
					const b = numberOfVertices + ix + gridX1 * ( iy + 1 );
					const c = numberOfVertices + ( ix + 1 ) + gridX1 * ( iy + 1 );
					const d = numberOfVertices + ( ix + 1 ) + gridX1 * iy;

					// faces

					indices.push( a, b, d );
					indices.push( b, c, d );

					// increase counter

					groupCount += 6;

				}

			}

			// add a group to the geometry. this will ensure multi material support

			scope.addGroup( groupStart, groupCount, materialIndex );

			// calculate new start value for groups

			groupStart += groupCount;

			// update total number of vertices

			numberOfVertices += vertexCounter;

		}

	}

	copy( source ) {

		super.copy( source );

		this.parameters = Object.assign( {}, source.parameters );

		return this;

	}

	static fromJSON( data ) {

		return new BoxGeometry( data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments );

	}

}

/**
 * Uniform Utilities
 */

function cloneUniforms( src ) {

	const dst = {};

	for ( const u in src ) {

		dst[ u ] = {};

		for ( const p in src[ u ] ) {

			const property = src[ u ][ p ];

			if ( property && ( property.isColor ||
				property.isMatrix3 || property.isMatrix4 ||
				property.isVector2 || property.isVector3 || property.isVector4 ||
				property.isTexture || property.isQuaternion ) ) {

				if ( property.isRenderTargetTexture ) {

					console.warn( 'UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms().' );
					dst[ u ][ p ] = null;

				} else {

					dst[ u ][ p ] = property.clone();

				}

			} else if ( Array.isArray( property ) ) {

				dst[ u ][ p ] = property.slice();

			} else {

				dst[ u ][ p ] = property;

			}

		}

	}

	return dst;

}

function mergeUniforms( uniforms ) {

	const merged = {};

	for ( let u = 0; u < uniforms.length; u ++ ) {

		const tmp = cloneUniforms( uniforms[ u ] );

		for ( const p in tmp ) {

			merged[ p ] = tmp[ p ];

		}

	}

	return merged;

}

function cloneUniformsGroups( src ) {

	const dst = [];

	for ( let u = 0; u < src.length; u ++ ) {

		dst.push( src[ u ].clone() );

	}

	return dst;

}

function getUnlitUniformColorSpace( renderer ) {

	const currentRenderTarget = renderer.getRenderTarget();

	if ( currentRenderTarget === null ) {

		// https://github.com/mrdoob/three.js/pull/23937#issuecomment-1111067398
		return renderer.outputColorSpace;

	}

	// https://github.com/mrdoob/three.js/issues/27868
	if ( currentRenderTarget.isXRRenderTarget === true ) {

		return currentRenderTarget.texture.colorSpace;

	}

	return ColorManagement.workingColorSpace;

}

// Legacy

const UniformsUtils = { clone: cloneUniforms, merge: mergeUniforms };

var default_vertex = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";

var default_fragment = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";

class ShaderMaterial extends (/* unused pure expression or super */ null && (Material)) {

	constructor( parameters ) {

		super();

		this.isShaderMaterial = true;

		this.type = 'ShaderMaterial';

		this.defines = {};
		this.uniforms = {};
		this.uniformsGroups = [];

		this.vertexShader = default_vertex;
		this.fragmentShader = default_fragment;

		this.linewidth = 1;

		this.wireframe = false;
		this.wireframeLinewidth = 1;

		this.fog = false; // set to use scene fog
		this.lights = false; // set to use scene lights
		this.clipping = false; // set to use user-defined clipping planes

		this.forceSinglePass = true;

		this.extensions = {
			clipCullDistance: false, // set to use vertex shader clipping
			multiDraw: false // set to use vertex shader multi_draw / enable gl_DrawID
		};

		// When rendered geometry doesn't include these attributes but the material does,
		// use these default values in WebGL. This avoids errors when buffer data is missing.
		this.defaultAttributeValues = {
			'color': [ 1, 1, 1 ],
			'uv': [ 0, 0 ],
			'uv1': [ 0, 0 ]
		};

		this.index0AttributeName = undefined;
		this.uniformsNeedUpdate = false;

		this.glslVersion = null;

		if ( parameters !== undefined ) {

			this.setValues( parameters );

		}

	}

	copy( source ) {

		super.copy( source );

		this.fragmentShader = source.fragmentShader;
		this.vertexShader = source.vertexShader;

		this.uniforms = cloneUniforms( source.uniforms );
		this.uniformsGroups = cloneUniformsGroups( source.uniformsGroups );

		this.defines = Object.assign( {}, source.defines );

		this.wireframe = source.wireframe;
		this.wireframeLinewidth = source.wireframeLinewidth;

		this.fog = source.fog;
		this.lights = source.lights;
		this.clipping = source.clipping;

		this.extensions = Object.assign( {}, source.extensions );

		this.glslVersion = source.glslVersion;

		return this;

	}

	toJSON( meta ) {

		const data = super.toJSON( meta );

		data.glslVersion = this.glslVersion;
		data.uniforms = {};

		for ( const name in this.uniforms ) {

			const uniform = this.uniforms[ name ];
			const value = uniform.value;

			if ( value && value.isTexture ) {

				data.uniforms[ name ] = {
					type: 't',
					value: value.toJSON( meta ).uuid
				};

			} else if ( value && value.isColor ) {

				data.uniforms[ name ] = {
					type: 'c',
					value: value.getHex()
				};

			} else if ( value && value.isVector2 ) {

				data.uniforms[ name ] = {
					type: 'v2',
					value: value.toArray()
				};

			} else if ( value && value.isVector3 ) {

				data.uniforms[ name ] = {
					type: 'v3',
					value: value.toArray()
				};

			} else if ( value && value.isVector4 ) {

				data.uniforms[ name ] = {
					type: 'v4',
					value: value.toArray()
				};

			} else if ( value && value.isMatrix3 ) {

				data.uniforms[ name ] = {
					type: 'm3',
					value: value.toArray()
				};

			} else if ( value && value.isMatrix4 ) {

				data.uniforms[ name ] = {
					type: 'm4',
					value: value.toArray()
				};

			} else {

				data.uniforms[ name ] = {
					value: value
				};

				// note: the array variants v2v, v3v, v4v, m4v and tv are not supported so far

			}

		}

		if ( Object.keys( this.defines ).length > 0 ) data.defines = this.defines;

		data.vertexShader = this.vertexShader;
		data.fragmentShader = this.fragmentShader;

		data.lights = this.lights;
		data.clipping = this.clipping;

		const extensions = {};

		for ( const key in this.extensions ) {

			if ( this.extensions[ key ] === true ) extensions[ key ] = true;

		}

		if ( Object.keys( extensions ).length > 0 ) data.extensions = extensions;

		return data;

	}

}

class Camera extends Object3D {

	constructor() {

		super();

		this.isCamera = true;

		this.type = 'Camera';

		this.matrixWorldInverse = new Matrix4();

		this.projectionMatrix = new Matrix4();
		this.projectionMatrixInverse = new Matrix4();

		this.coordinateSystem = WebGLCoordinateSystem;

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		this.matrixWorldInverse.copy( source.matrixWorldInverse );

		this.projectionMatrix.copy( source.projectionMatrix );
		this.projectionMatrixInverse.copy( source.projectionMatrixInverse );

		this.coordinateSystem = source.coordinateSystem;

		return this;

	}

	getWorldDirection( target ) {

		return super.getWorldDirection( target ).negate();

	}

	updateMatrixWorld( force ) {

		super.updateMatrixWorld( force );

		this.matrixWorldInverse.copy( this.matrixWorld ).invert();

	}

	updateWorldMatrix( updateParents, updateChildren ) {

		super.updateWorldMatrix( updateParents, updateChildren );

		this.matrixWorldInverse.copy( this.matrixWorld ).invert();

	}

	clone() {

		return new this.constructor().copy( this );

	}

}

const _v3$1 = /*@__PURE__*/ new Vector3();
const _minTarget = /*@__PURE__*/ new Vector2();
const _maxTarget = /*@__PURE__*/ new Vector2();


class PerspectiveCamera extends (/* unused pure expression or super */ null && (Camera)) {

	constructor( fov = 50, aspect = 1, near = 0.1, far = 2000 ) {

		super();

		this.isPerspectiveCamera = true;

		this.type = 'PerspectiveCamera';

		this.fov = fov;
		this.zoom = 1;

		this.near = near;
		this.far = far;
		this.focus = 10;

		this.aspect = aspect;
		this.view = null;

		this.filmGauge = 35;	// width of the film (default in millimeters)
		this.filmOffset = 0;	// horizontal film offset (same unit as gauge)

		this.updateProjectionMatrix();

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		this.fov = source.fov;
		this.zoom = source.zoom;

		this.near = source.near;
		this.far = source.far;
		this.focus = source.focus;

		this.aspect = source.aspect;
		this.view = source.view === null ? null : Object.assign( {}, source.view );

		this.filmGauge = source.filmGauge;
		this.filmOffset = source.filmOffset;

		return this;

	}

	/**
	 * Sets the FOV by focal length in respect to the current .filmGauge.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * Values for focal length and film gauge must have the same unit.
	 */
	setFocalLength( focalLength ) {

		/** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */
		const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;

		this.fov = RAD2DEG * 2 * Math.atan( vExtentSlope );
		this.updateProjectionMatrix();

	}

	/**
	 * Calculates the focal length from the current .fov and .filmGauge.
	 */
	getFocalLength() {

		const vExtentSlope = Math.tan( DEG2RAD * 0.5 * this.fov );

		return 0.5 * this.getFilmHeight() / vExtentSlope;

	}

	getEffectiveFOV() {

		return RAD2DEG * 2 * Math.atan(
			Math.tan( DEG2RAD * 0.5 * this.fov ) / this.zoom );

	}

	getFilmWidth() {

		// film not completely covered in portrait format (aspect < 1)
		return this.filmGauge * Math.min( this.aspect, 1 );

	}

	getFilmHeight() {

		// film not completely covered in landscape format (aspect > 1)
		return this.filmGauge / Math.max( this.aspect, 1 );

	}

	/**
	 * Computes the 2D bounds of the camera's viewable rectangle at a given distance along the viewing direction.
	 * Sets minTarget and maxTarget to the coordinates of the lower-left and upper-right corners of the view rectangle.
	 */
	getViewBounds( distance, minTarget, maxTarget ) {

		_v3$1.set( - 1, - 1, 0.5 ).applyMatrix4( this.projectionMatrixInverse );

		minTarget.set( _v3$1.x, _v3$1.y ).multiplyScalar( - distance / _v3$1.z );

		_v3$1.set( 1, 1, 0.5 ).applyMatrix4( this.projectionMatrixInverse );

		maxTarget.set( _v3$1.x, _v3$1.y ).multiplyScalar( - distance / _v3$1.z );

	}

	/**
	 * Computes the width and height of the camera's viewable rectangle at a given distance along the viewing direction.
	 * Copies the result into the target Vector2, where x is width and y is height.
	 */
	getViewSize( distance, target ) {

		this.getViewBounds( distance, _minTarget, _maxTarget );

		return target.subVectors( _maxTarget, _minTarget );

	}

	/**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *
	 * then for each monitor you would call it like this
	 *
	 *   const w = 1920;
	 *   const h = 1080;
	 *   const fullWidth = w * 3;
	 *   const fullHeight = h * 2;
	 *
	 *   --A--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 *   --B--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 *   --C--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 *   --D--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 *   --E--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 *   --F--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 *
	 *   Note there is no reason monitors have to be the same size or in a grid.
	 */
	setViewOffset( fullWidth, fullHeight, x, y, width, height ) {

		this.aspect = fullWidth / fullHeight;

		if ( this.view === null ) {

			this.view = {
				enabled: true,
				fullWidth: 1,
				fullHeight: 1,
				offsetX: 0,
				offsetY: 0,
				width: 1,
				height: 1
			};

		}

		this.view.enabled = true;
		this.view.fullWidth = fullWidth;
		this.view.fullHeight = fullHeight;
		this.view.offsetX = x;
		this.view.offsetY = y;
		this.view.width = width;
		this.view.height = height;

		this.updateProjectionMatrix();

	}

	clearViewOffset() {

		if ( this.view !== null ) {

			this.view.enabled = false;

		}

		this.updateProjectionMatrix();

	}

	updateProjectionMatrix() {

		const near = this.near;
		let top = near * Math.tan( DEG2RAD * 0.5 * this.fov ) / this.zoom;
		let height = 2 * top;
		let width = this.aspect * height;
		let left = - 0.5 * width;
		const view = this.view;

		if ( this.view !== null && this.view.enabled ) {

			const fullWidth = view.fullWidth,
				fullHeight = view.fullHeight;

			left += view.offsetX * width / fullWidth;
			top -= view.offsetY * height / fullHeight;
			width *= view.width / fullWidth;
			height *= view.height / fullHeight;

		}

		const skew = this.filmOffset;
		if ( skew !== 0 ) left += near * skew / this.getFilmWidth();

		this.projectionMatrix.makePerspective( left, left + width, top, top - height, near, this.far, this.coordinateSystem );

		this.projectionMatrixInverse.copy( this.projectionMatrix ).invert();

	}

	toJSON( meta ) {

		const data = super.toJSON( meta );

		data.object.fov = this.fov;
		data.object.zoom = this.zoom;

		data.object.near = this.near;
		data.object.far = this.far;
		data.object.focus = this.focus;

		data.object.aspect = this.aspect;

		if ( this.view !== null ) data.object.view = Object.assign( {}, this.view );

		data.object.filmGauge = this.filmGauge;
		data.object.filmOffset = this.filmOffset;

		return data;

	}

}

const fov = (/* unused pure expression or super */ null && (- 90)); // negative fov is not an error
const aspect = 1;

class CubeCamera extends (/* unused pure expression or super */ null && (Object3D)) {

	constructor( near, far, renderTarget ) {

		super();

		this.type = 'CubeCamera';

		this.renderTarget = renderTarget;
		this.coordinateSystem = null;
		this.activeMipmapLevel = 0;

		const cameraPX = new PerspectiveCamera( fov, aspect, near, far );
		cameraPX.layers = this.layers;
		this.add( cameraPX );

		const cameraNX = new PerspectiveCamera( fov, aspect, near, far );
		cameraNX.layers = this.layers;
		this.add( cameraNX );

		const cameraPY = new PerspectiveCamera( fov, aspect, near, far );
		cameraPY.layers = this.layers;
		this.add( cameraPY );

		const cameraNY = new PerspectiveCamera( fov, aspect, near, far );
		cameraNY.layers = this.layers;
		this.add( cameraNY );

		const cameraPZ = new PerspectiveCamera( fov, aspect, near, far );
		cameraPZ.layers = this.layers;
		this.add( cameraPZ );

		const cameraNZ = new PerspectiveCamera( fov, aspect, near, far );
		cameraNZ.layers = this.layers;
		this.add( cameraNZ );

	}

	updateCoordinateSystem() {

		const coordinateSystem = this.coordinateSystem;

		const cameras = this.children.concat();

		const [ cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ ] = cameras;

		for ( const camera of cameras ) this.remove( camera );

		if ( coordinateSystem === WebGLCoordinateSystem ) {

			cameraPX.up.set( 0, 1, 0 );
			cameraPX.lookAt( 1, 0, 0 );

			cameraNX.up.set( 0, 1, 0 );
			cameraNX.lookAt( - 1, 0, 0 );

			cameraPY.up.set( 0, 0, - 1 );
			cameraPY.lookAt( 0, 1, 0 );

			cameraNY.up.set( 0, 0, 1 );
			cameraNY.lookAt( 0, - 1, 0 );

			cameraPZ.up.set( 0, 1, 0 );
			cameraPZ.lookAt( 0, 0, 1 );

			cameraNZ.up.set( 0, 1, 0 );
			cameraNZ.lookAt( 0, 0, - 1 );

		} else if ( coordinateSystem === WebGPUCoordinateSystem ) {

			cameraPX.up.set( 0, - 1, 0 );
			cameraPX.lookAt( - 1, 0, 0 );

			cameraNX.up.set( 0, - 1, 0 );
			cameraNX.lookAt( 1, 0, 0 );

			cameraPY.up.set( 0, 0, 1 );
			cameraPY.lookAt( 0, 1, 0 );

			cameraNY.up.set( 0, 0, - 1 );
			cameraNY.lookAt( 0, - 1, 0 );

			cameraPZ.up.set( 0, - 1, 0 );
			cameraPZ.lookAt( 0, 0, 1 );

			cameraNZ.up.set( 0, - 1, 0 );
			cameraNZ.lookAt( 0, 0, - 1 );

		} else {

			throw new Error( 'THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: ' + coordinateSystem );

		}

		for ( const camera of cameras ) {

			this.add( camera );

			camera.updateMatrixWorld();

		}

	}

	update( renderer, scene ) {

		if ( this.parent === null ) this.updateMatrixWorld();

		const { renderTarget, activeMipmapLevel } = this;

		if ( this.coordinateSystem !== renderer.coordinateSystem ) {

			this.coordinateSystem = renderer.coordinateSystem;

			this.updateCoordinateSystem();

		}

		const [ cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ ] = this.children;

		const currentRenderTarget = renderer.getRenderTarget();
		const currentActiveCubeFace = renderer.getActiveCubeFace();
		const currentActiveMipmapLevel = renderer.getActiveMipmapLevel();

		const currentXrEnabled = renderer.xr.enabled;

		renderer.xr.enabled = false;

		const generateMipmaps = renderTarget.texture.generateMipmaps;

		renderTarget.texture.generateMipmaps = false;

		renderer.setRenderTarget( renderTarget, 0, activeMipmapLevel );
		renderer.render( scene, cameraPX );

		renderer.setRenderTarget( renderTarget, 1, activeMipmapLevel );
		renderer.render( scene, cameraNX );

		renderer.setRenderTarget( renderTarget, 2, activeMipmapLevel );
		renderer.render( scene, cameraPY );

		renderer.setRenderTarget( renderTarget, 3, activeMipmapLevel );
		renderer.render( scene, cameraNY );

		renderer.setRenderTarget( renderTarget, 4, activeMipmapLevel );
		renderer.render( scene, cameraPZ );

		// mipmaps are generated during the last call of render()
		// at this point, all sides of the cube render target are defined

		renderTarget.texture.generateMipmaps = generateMipmaps;

		renderer.setRenderTarget( renderTarget, 5, activeMipmapLevel );
		renderer.render( scene, cameraNZ );

		renderer.setRenderTarget( currentRenderTarget, currentActiveCubeFace, currentActiveMipmapLevel );

		renderer.xr.enabled = currentXrEnabled;

		renderTarget.texture.needsPMREMUpdate = true;

	}

}

class CubeTexture extends Texture {

	constructor( images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace ) {

		images = images !== undefined ? images : [];
		mapping = mapping !== undefined ? mapping : CubeReflectionMapping;

		super( images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace );

		this.isCubeTexture = true;

		this.flipY = false;

	}

	get images() {

		return this.image;

	}

	set images( value ) {

		this.image = value;

	}

}

class WebGLCubeRenderTarget extends (/* unused pure expression or super */ null && (WebGLRenderTarget)) {

	constructor( size = 1, options = {} ) {

		super( size, size, options );

		this.isWebGLCubeRenderTarget = true;

		const image = { width: size, height: size, depth: 1 };
		const images = [ image, image, image, image, image, image ];

		this.texture = new CubeTexture( images, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace );

		// By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
		// in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
		// in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.

		// three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
		// and the flag isRenderTargetTexture controls this conversion. The flip is not required when using WebGLCubeRenderTarget.texture
		// as a cube texture (this is detected when isRenderTargetTexture is set to true for cube textures).

		this.texture.isRenderTargetTexture = true;

		this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
		this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : LinearFilter;

	}

	fromEquirectangularTexture( renderer, texture ) {

		this.texture.type = texture.type;
		this.texture.colorSpace = texture.colorSpace;

		this.texture.generateMipmaps = texture.generateMipmaps;
		this.texture.minFilter = texture.minFilter;
		this.texture.magFilter = texture.magFilter;

		const shader = {

			uniforms: {
				tEquirect: { value: null },
			},

			vertexShader: /* glsl */`

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,

			fragmentShader: /* glsl */`

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
		};

		const geometry = new BoxGeometry( 5, 5, 5 );

		const material = new ShaderMaterial( {

			name: 'CubemapFromEquirect',

			uniforms: cloneUniforms( shader.uniforms ),
			vertexShader: shader.vertexShader,
			fragmentShader: shader.fragmentShader,
			side: BackSide,
			blending: NoBlending

		} );

		material.uniforms.tEquirect.value = texture;

		const mesh = new Mesh( geometry, material );

		const currentMinFilter = texture.minFilter;

		// Avoid blurred poles
		if ( texture.minFilter === LinearMipmapLinearFilter ) texture.minFilter = LinearFilter;

		const camera = new CubeCamera( 1, 10, this );
		camera.update( renderer, mesh );

		texture.minFilter = currentMinFilter;

		mesh.geometry.dispose();
		mesh.material.dispose();

		return this;

	}

	clear( renderer, color, depth, stencil ) {

		const currentRenderTarget = renderer.getRenderTarget();

		for ( let i = 0; i < 6; i ++ ) {

			renderer.setRenderTarget( this, i );

			renderer.clear( color, depth, stencil );

		}

		renderer.setRenderTarget( currentRenderTarget );

	}

}

const _vector1 = /*@__PURE__*/ new Vector3();
const _vector2 = /*@__PURE__*/ new Vector3();
const _normalMatrix = /*@__PURE__*/ new Matrix3();

class Plane {

	constructor( normal = new Vector3( 1, 0, 0 ), constant = 0 ) {

		this.isPlane = true;

		// normal is assumed to be normalized

		this.normal = normal;
		this.constant = constant;

	}

	set( normal, constant ) {

		this.normal.copy( normal );
		this.constant = constant;

		return this;

	}

	setComponents( x, y, z, w ) {

		this.normal.set( x, y, z );
		this.constant = w;

		return this;

	}

	setFromNormalAndCoplanarPoint( normal, point ) {

		this.normal.copy( normal );
		this.constant = - point.dot( this.normal );

		return this;

	}

	setFromCoplanarPoints( a, b, c ) {

		const normal = _vector1.subVectors( c, b ).cross( _vector2.subVectors( a, b ) ).normalize();

		// Q: should an error be thrown if normal is zero (e.g. degenerate plane)?

		this.setFromNormalAndCoplanarPoint( normal, a );

		return this;

	}

	copy( plane ) {

		this.normal.copy( plane.normal );
		this.constant = plane.constant;

		return this;

	}

	normalize() {

		// Note: will lead to a divide by zero if the plane is invalid.

		const inverseNormalLength = 1.0 / this.normal.length();
		this.normal.multiplyScalar( inverseNormalLength );
		this.constant *= inverseNormalLength;

		return this;

	}

	negate() {

		this.constant *= - 1;
		this.normal.negate();

		return this;

	}

	distanceToPoint( point ) {

		return this.normal.dot( point ) + this.constant;

	}

	distanceToSphere( sphere ) {

		return this.distanceToPoint( sphere.center ) - sphere.radius;

	}

	projectPoint( point, target ) {

		return target.copy( point ).addScaledVector( this.normal, - this.distanceToPoint( point ) );

	}

	intersectLine( line, target ) {

		const direction = line.delta( _vector1 );

		const denominator = this.normal.dot( direction );

		if ( denominator === 0 ) {

			// line is coplanar, return origin
			if ( this.distanceToPoint( line.start ) === 0 ) {

				return target.copy( line.start );

			}

			// Unsure if this is the correct method to handle this case.
			return null;

		}

		const t = - ( line.start.dot( this.normal ) + this.constant ) / denominator;

		if ( t < 0 || t > 1 ) {

			return null;

		}

		return target.copy( line.start ).addScaledVector( direction, t );

	}

	intersectsLine( line ) {

		// Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.

		const startSign = this.distanceToPoint( line.start );
		const endSign = this.distanceToPoint( line.end );

		return ( startSign < 0 && endSign > 0 ) || ( endSign < 0 && startSign > 0 );

	}

	intersectsBox( box ) {

		return box.intersectsPlane( this );

	}

	intersectsSphere( sphere ) {

		return sphere.intersectsPlane( this );

	}

	coplanarPoint( target ) {

		return target.copy( this.normal ).multiplyScalar( - this.constant );

	}

	applyMatrix4( matrix, optionalNormalMatrix ) {

		const normalMatrix = optionalNormalMatrix || _normalMatrix.getNormalMatrix( matrix );

		const referencePoint = this.coplanarPoint( _vector1 ).applyMatrix4( matrix );

		const normal = this.normal.applyMatrix3( normalMatrix ).normalize();

		this.constant = - referencePoint.dot( normal );

		return this;

	}

	translate( offset ) {

		this.constant -= offset.dot( this.normal );

		return this;

	}

	equals( plane ) {

		return plane.normal.equals( this.normal ) && ( plane.constant === this.constant );

	}

	clone() {

		return new this.constructor().copy( this );

	}

}

const _sphere$5 = /*@__PURE__*/ new Sphere();
const _vector$7 = /*@__PURE__*/ new Vector3();

class Frustum {

	constructor( p0 = new Plane(), p1 = new Plane(), p2 = new Plane(), p3 = new Plane(), p4 = new Plane(), p5 = new Plane() ) {

		this.planes = [ p0, p1, p2, p3, p4, p5 ];

	}

	set( p0, p1, p2, p3, p4, p5 ) {

		const planes = this.planes;

		planes[ 0 ].copy( p0 );
		planes[ 1 ].copy( p1 );
		planes[ 2 ].copy( p2 );
		planes[ 3 ].copy( p3 );
		planes[ 4 ].copy( p4 );
		planes[ 5 ].copy( p5 );

		return this;

	}

	copy( frustum ) {

		const planes = this.planes;

		for ( let i = 0; i < 6; i ++ ) {

			planes[ i ].copy( frustum.planes[ i ] );

		}

		return this;

	}

	setFromProjectionMatrix( m, coordinateSystem = WebGLCoordinateSystem ) {

		const planes = this.planes;
		const me = m.elements;
		const me0 = me[ 0 ], me1 = me[ 1 ], me2 = me[ 2 ], me3 = me[ 3 ];
		const me4 = me[ 4 ], me5 = me[ 5 ], me6 = me[ 6 ], me7 = me[ 7 ];
		const me8 = me[ 8 ], me9 = me[ 9 ], me10 = me[ 10 ], me11 = me[ 11 ];
		const me12 = me[ 12 ], me13 = me[ 13 ], me14 = me[ 14 ], me15 = me[ 15 ];

		planes[ 0 ].setComponents( me3 - me0, me7 - me4, me11 - me8, me15 - me12 ).normalize();
		planes[ 1 ].setComponents( me3 + me0, me7 + me4, me11 + me8, me15 + me12 ).normalize();
		planes[ 2 ].setComponents( me3 + me1, me7 + me5, me11 + me9, me15 + me13 ).normalize();
		planes[ 3 ].setComponents( me3 - me1, me7 - me5, me11 - me9, me15 - me13 ).normalize();
		planes[ 4 ].setComponents( me3 - me2, me7 - me6, me11 - me10, me15 - me14 ).normalize();

		if ( coordinateSystem === WebGLCoordinateSystem ) {

			planes[ 5 ].setComponents( me3 + me2, me7 + me6, me11 + me10, me15 + me14 ).normalize();

		} else if ( coordinateSystem === WebGPUCoordinateSystem ) {

			planes[ 5 ].setComponents( me2, me6, me10, me14 ).normalize();

		} else {

			throw new Error( 'THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: ' + coordinateSystem );

		}

		return this;

	}

	intersectsObject( object ) {

		if ( object.boundingSphere !== undefined ) {

			if ( object.boundingSphere === null ) object.computeBoundingSphere();

			_sphere$5.copy( object.boundingSphere ).applyMatrix4( object.matrixWorld );

		} else {

			const geometry = object.geometry;

			if ( geometry.boundingSphere === null ) geometry.computeBoundingSphere();

			_sphere$5.copy( geometry.boundingSphere ).applyMatrix4( object.matrixWorld );

		}

		return this.intersectsSphere( _sphere$5 );

	}

	intersectsSprite( sprite ) {

		_sphere$5.center.set( 0, 0, 0 );
		_sphere$5.radius = 0.7071067811865476;
		_sphere$5.applyMatrix4( sprite.matrixWorld );

		return this.intersectsSphere( _sphere$5 );

	}

	intersectsSphere( sphere ) {

		const planes = this.planes;
		const center = sphere.center;
		const negRadius = - sphere.radius;

		for ( let i = 0; i < 6; i ++ ) {

			const distance = planes[ i ].distanceToPoint( center );

			if ( distance < negRadius ) {

				return false;

			}

		}

		return true;

	}

	intersectsBox( box ) {

		const planes = this.planes;

		for ( let i = 0; i < 6; i ++ ) {

			const plane = planes[ i ];

			// corner at max distance

			_vector$7.x = plane.normal.x > 0 ? box.max.x : box.min.x;
			_vector$7.y = plane.normal.y > 0 ? box.max.y : box.min.y;
			_vector$7.z = plane.normal.z > 0 ? box.max.z : box.min.z;

			if ( plane.distanceToPoint( _vector$7 ) < 0 ) {

				return false;

			}

		}

		return true;

	}

	containsPoint( point ) {

		const planes = this.planes;

		for ( let i = 0; i < 6; i ++ ) {

			if ( planes[ i ].distanceToPoint( point ) < 0 ) {

				return false;

			}

		}

		return true;

	}

	clone() {

		return new this.constructor().copy( this );

	}

}

function WebGLAnimation() {

	let context = null;
	let isAnimating = false;
	let animationLoop = null;
	let requestId = null;

	function onAnimationFrame( time, frame ) {

		animationLoop( time, frame );

		requestId = context.requestAnimationFrame( onAnimationFrame );

	}

	return {

		start: function () {

			if ( isAnimating === true ) return;
			if ( animationLoop === null ) return;

			requestId = context.requestAnimationFrame( onAnimationFrame );

			isAnimating = true;

		},

		stop: function () {

			context.cancelAnimationFrame( requestId );

			isAnimating = false;

		},

		setAnimationLoop: function ( callback ) {

			animationLoop = callback;

		},

		setContext: function ( value ) {

			context = value;

		}

	};

}

function WebGLAttributes( gl ) {

	const buffers = new WeakMap();

	function createBuffer( attribute, bufferType ) {

		const array = attribute.array;
		const usage = attribute.usage;
		const size = array.byteLength;

		const buffer = gl.createBuffer();

		gl.bindBuffer( bufferType, buffer );
		gl.bufferData( bufferType, array, usage );

		attribute.onUploadCallback();

		let type;

		if ( array instanceof Float32Array ) {

			type = gl.FLOAT;

		} else if ( array instanceof Uint16Array ) {

			if ( attribute.isFloat16BufferAttribute ) {

				type = gl.HALF_FLOAT;

			} else {

				type = gl.UNSIGNED_SHORT;

			}

		} else if ( array instanceof Int16Array ) {

			type = gl.SHORT;

		} else if ( array instanceof Uint32Array ) {

			type = gl.UNSIGNED_INT;

		} else if ( array instanceof Int32Array ) {

			type = gl.INT;

		} else if ( array instanceof Int8Array ) {

			type = gl.BYTE;

		} else if ( array instanceof Uint8Array ) {

			type = gl.UNSIGNED_BYTE;

		} else if ( array instanceof Uint8ClampedArray ) {

			type = gl.UNSIGNED_BYTE;

		} else {

			throw new Error( 'THREE.WebGLAttributes: Unsupported buffer data format: ' + array );

		}

		return {
			buffer: buffer,
			type: type,
			bytesPerElement: array.BYTES_PER_ELEMENT,
			version: attribute.version,
			size: size
		};

	}

	function updateBuffer( buffer, attribute, bufferType ) {

		const array = attribute.array;
		const updateRange = attribute._updateRange; // @deprecated, r159
		const updateRanges = attribute.updateRanges;

		gl.bindBuffer( bufferType, buffer );

		if ( updateRange.count === - 1 && updateRanges.length === 0 ) {

			// Not using update ranges
			gl.bufferSubData( bufferType, 0, array );

		}

		if ( updateRanges.length !== 0 ) {

			for ( let i = 0, l = updateRanges.length; i < l; i ++ ) {

				const range = updateRanges[ i ];

				gl.bufferSubData( bufferType, range.start * array.BYTES_PER_ELEMENT,
					array, range.start, range.count );

			}

			attribute.clearUpdateRanges();

		}

		// @deprecated, r159
		if ( updateRange.count !== - 1 ) {

			gl.bufferSubData( bufferType, updateRange.offset * array.BYTES_PER_ELEMENT,
				array, updateRange.offset, updateRange.count );

			updateRange.count = - 1; // reset range

		}

		attribute.onUploadCallback();

	}

	//

	function get( attribute ) {

		if ( attribute.isInterleavedBufferAttribute ) attribute = attribute.data;

		return buffers.get( attribute );

	}

	function remove( attribute ) {

		if ( attribute.isInterleavedBufferAttribute ) attribute = attribute.data;

		const data = buffers.get( attribute );

		if ( data ) {

			gl.deleteBuffer( data.buffer );

			buffers.delete( attribute );

		}

	}

	function update( attribute, bufferType ) {

		if ( attribute.isGLBufferAttribute ) {

			const cached = buffers.get( attribute );

			if ( ! cached || cached.version < attribute.version ) {

				buffers.set( attribute, {
					buffer: attribute.buffer,
					type: attribute.type,
					bytesPerElement: attribute.elementSize,
					version: attribute.version
				} );

			}

			return;

		}

		if ( attribute.isInterleavedBufferAttribute ) attribute = attribute.data;

		const data = buffers.get( attribute );

		if ( data === undefined ) {

			buffers.set( attribute, createBuffer( attribute, bufferType ) );

		} else if ( data.version < attribute.version ) {

			if ( data.size !== attribute.array.byteLength ) {

				throw new Error( 'THREE.WebGLAttributes: The size of the buffer attribute\'s array buffer does not match the original size. Resizing buffer attributes is not supported.' );

			}

			updateBuffer( data.buffer, attribute, bufferType );

			data.version = attribute.version;

		}

	}

	return {

		get: get,
		remove: remove,
		update: update

	};

}

class PlaneGeometry extends BufferGeometry {

	constructor( width = 1, height = 1, widthSegments = 1, heightSegments = 1 ) {

		super();

		this.type = 'PlaneGeometry';

		this.parameters = {
			width: width,
			height: height,
			widthSegments: widthSegments,
			heightSegments: heightSegments
		};

		const width_half = width / 2;
		const height_half = height / 2;

		const gridX = Math.floor( widthSegments );
		const gridY = Math.floor( heightSegments );

		const gridX1 = gridX + 1;
		const gridY1 = gridY + 1;

		const segment_width = width / gridX;
		const segment_height = height / gridY;

		//

		const indices = [];
		const vertices = [];
		const normals = [];
		const uvs = [];

		for ( let iy = 0; iy < gridY1; iy ++ ) {

			const y = iy * segment_height - height_half;

			for ( let ix = 0; ix < gridX1; ix ++ ) {

				const x = ix * segment_width - width_half;

				vertices.push( x, - y, 0 );

				normals.push( 0, 0, 1 );

				uvs.push( ix / gridX );
				uvs.push( 1 - ( iy / gridY ) );

			}

		}

		for ( let iy = 0; iy < gridY; iy ++ ) {

			for ( let ix = 0; ix < gridX; ix ++ ) {

				const a = ix + gridX1 * iy;
				const b = ix + gridX1 * ( iy + 1 );
				const c = ( ix + 1 ) + gridX1 * ( iy + 1 );
				const d = ( ix + 1 ) + gridX1 * iy;

				indices.push( a, b, d );
				indices.push( b, c, d );

			}

		}

		this.setIndex( indices );
		this.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.setAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
		this.setAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

	}

	copy( source ) {

		super.copy( source );

		this.parameters = Object.assign( {}, source.parameters );

		return this;

	}

	static fromJSON( data ) {

		return new PlaneGeometry( data.width, data.height, data.widthSegments, data.heightSegments );

	}

}

var alphahash_fragment = "#ifdef USE_ALPHAHASH\n\tif ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\n#endif";

var alphahash_pars_fragment = "#ifdef USE_ALPHAHASH\n\tconst float ALPHA_HASH_SCALE = 0.05;\n\tfloat hash2D( vec2 value ) {\n\t\treturn fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\n\t}\n\tfloat hash3D( vec3 value ) {\n\t\treturn hash2D( vec2( hash2D( value.xy ), value.z ) );\n\t}\n\tfloat getAlphaHashThreshold( vec3 position ) {\n\t\tfloat maxDeriv = max(\n\t\t\tlength( dFdx( position.xyz ) ),\n\t\t\tlength( dFdy( position.xyz ) )\n\t\t);\n\t\tfloat pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\n\t\tvec2 pixScales = vec2(\n\t\t\texp2( floor( log2( pixScale ) ) ),\n\t\t\texp2( ceil( log2( pixScale ) ) )\n\t\t);\n\t\tvec2 alpha = vec2(\n\t\t\thash3D( floor( pixScales.x * position.xyz ) ),\n\t\t\thash3D( floor( pixScales.y * position.xyz ) )\n\t\t);\n\t\tfloat lerpFactor = fract( log2( pixScale ) );\n\t\tfloat x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\n\t\tfloat a = min( lerpFactor, 1.0 - lerpFactor );\n\t\tvec3 cases = vec3(\n\t\t\tx * x / ( 2.0 * a * ( 1.0 - a ) ),\n\t\t\t( x - 0.5 * a ) / ( 1.0 - a ),\n\t\t\t1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\n\t\t);\n\t\tfloat threshold = ( x < ( 1.0 - a ) )\n\t\t\t? ( ( x < a ) ? cases.x : cases.y )\n\t\t\t: cases.z;\n\t\treturn clamp( threshold , 1.0e-6, 1.0 );\n\t}\n#endif";

var alphamap_fragment = "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif";

var alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";

var alphatest_fragment = "#ifdef USE_ALPHATEST\n\t#ifdef ALPHA_TO_COVERAGE\n\tdiffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );\n\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\tif ( diffuseColor.a < alphaTest ) discard;\n\t#endif\n#endif";

var alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n\tuniform float alphaTest;\n#endif";

var aomap_fragment = "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_CLEARCOAT ) \n\t\tclearcoatSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_SHEEN ) \n\t\tsheenSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometryNormal, geometryViewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n\t#endif\n#endif";

var aomap_pars_fragment = "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif";

var batching_pars_vertex = "#ifdef USE_BATCHING\n\tattribute float batchId;\n\tuniform highp sampler2D batchingTexture;\n\tmat4 getBatchingMatrix( const in float i ) {\n\t\tint size = textureSize( batchingTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n#endif";

var batching_vertex = "#ifdef USE_BATCHING\n\tmat4 batchingMatrix = getBatchingMatrix( batchId );\n#endif";

var begin_vertex = "vec3 transformed = vec3( position );\n#ifdef USE_ALPHAHASH\n\tvPosition = vec3( position );\n#endif";

var beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif";

var bsdfs = "float G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, 1.0, dotVH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n} // validated";

var iridescence_fragment = "#ifdef USE_IRIDESCENCE\n\tconst mat3 XYZ_TO_REC709 = mat3(\n\t\t 3.2404542, -0.9692660,  0.0556434,\n\t\t-1.5371385,  1.8760108, -0.2040259,\n\t\t-0.4985314,  0.0415560,  1.0572252\n\t);\n\tvec3 Fresnel0ToIor( vec3 fresnel0 ) {\n\t\tvec3 sqrtF0 = sqrt( fresnel0 );\n\t\treturn ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n\t}\n\tvec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n\t}\n\tfloat IorToFresnel0( float transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n\t}\n\tvec3 evalSensitivity( float OPD, vec3 shift ) {\n\t\tfloat phase = 2.0 * PI * OPD * 1.0e-9;\n\t\tvec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n\t\tvec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n\t\tvec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n\t\tvec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n\t\txyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n\t\txyz /= 1.0685e-7;\n\t\tvec3 rgb = XYZ_TO_REC709 * xyz;\n\t\treturn rgb;\n\t}\n\tvec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n\t\tvec3 I;\n\t\tfloat iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n\t\tfloat sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n\t\tfloat cosTheta2Sq = 1.0 - sinTheta2Sq;\n\t\tif ( cosTheta2Sq < 0.0 ) {\n\t\t\treturn vec3( 1.0 );\n\t\t}\n\t\tfloat cosTheta2 = sqrt( cosTheta2Sq );\n\t\tfloat R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n\t\tfloat R12 = F_Schlick( R0, 1.0, cosTheta1 );\n\t\tfloat T121 = 1.0 - R12;\n\t\tfloat phi12 = 0.0;\n\t\tif ( iridescenceIOR < outsideIOR ) phi12 = PI;\n\t\tfloat phi21 = PI - phi12;\n\t\tvec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );\t\tvec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n\t\tvec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n\t\tvec3 phi23 = vec3( 0.0 );\n\t\tif ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n\t\tif ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n\t\tif ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n\t\tfloat OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n\t\tvec3 phi = vec3( phi21 ) + phi23;\n\t\tvec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n\t\tvec3 r123 = sqrt( R123 );\n\t\tvec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n\t\tvec3 C0 = R12 + Rs;\n\t\tI = C0;\n\t\tvec3 Cm = Rs - T121;\n\t\tfor ( int m = 1; m <= 2; ++ m ) {\n\t\t\tCm *= r123;\n\t\t\tvec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n\t\t\tI += Cm * Sm;\n\t\t}\n\t\treturn max( I, vec3( 0.0 ) );\n\t}\n#endif";

var bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vBumpMapUv );\n\t\tvec2 dSTdy = dFdy( vBumpMapUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n\t\tvec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );\n\t\tvec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif";

var clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#ifdef ALPHA_TO_COVERAGE\n\t\tfloat distanceToPlane, distanceGradient;\n\t\tfloat clipOpacity = 1.0;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\tclipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\tif ( clipOpacity == 0.0 ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tfloat unionClipOpacity = 1.0;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\t\tunionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tclipOpacity *= 1.0 - unionClipOpacity;\n\t\t#endif\n\t\tdiffuseColor.a *= clipOpacity;\n\t\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tbool clipped = true;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tif ( clipped ) discard;\n\t\t#endif\n\t#endif\n#endif";

var clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";

var clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif";

var clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif";

var color_fragment = "#if defined( USE_COLOR_ALPHA )\n\tdiffuseColor *= vColor;\n#elif defined( USE_COLOR )\n\tdiffuseColor.rgb *= vColor;\n#endif";

var color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR )\n\tvarying vec3 vColor;\n#endif";

var color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvarying vec3 vColor;\n#endif";

var color_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n\tvColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.xyz *= instanceColor.xyz;\n#endif";

var common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\n#ifdef USE_ALPHAHASH\n\tvarying vec3 vPosition;\n#endif\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n\tmat3 tmp;\n\ttmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n\ttmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n\ttmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n\treturn tmp;\n}\nfloat luminance( const in vec3 rgb ) {\n\tconst vec3 weights = vec3( 0.2126729, 0.7151522, 0.0721750 );\n\treturn dot( weights, rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated";

var cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\thighp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tuv.x += filterInt * 3.0 * cubeUV_minTileSize;\n\t\tuv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n\t\tuv.x *= CUBEUV_TEXEL_WIDTH;\n\t\tuv.y *= CUBEUV_TEXEL_HEIGHT;\n\t\t#ifdef texture2DGradEXT\n\t\t\treturn texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n\t\t#else\n\t\t\treturn texture2D( envMap, uv ).rgb;\n\t\t#endif\n\t}\n\t#define cubeUV_r0 1.0\n\t#define cubeUV_m0 - 2.0\n\t#define cubeUV_r1 0.8\n\t#define cubeUV_m1 - 1.0\n\t#define cubeUV_r4 0.4\n\t#define cubeUV_m4 2.0\n\t#define cubeUV_r5 0.305\n\t#define cubeUV_m5 3.0\n\t#define cubeUV_r6 0.21\n\t#define cubeUV_m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= cubeUV_r1 ) {\n\t\t\tmip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n\t\t} else if ( roughness >= cubeUV_r4 ) {\n\t\t\tmip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n\t\t} else if ( roughness >= cubeUV_r5 ) {\n\t\t\tmip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n\t\t} else if ( roughness >= cubeUV_r6 ) {\n\t\t\tmip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif";

var defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = objectTangent;\n#endif\n#ifdef USE_BATCHING\n\tmat3 bm = mat3( batchingMatrix );\n\ttransformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );\n\ttransformedNormal = bm * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = bm * transformedTangent;\n\t#endif\n#endif\n#ifdef USE_INSTANCING\n\tmat3 im = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );\n\ttransformedNormal = im * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = im * transformedTangent;\n\t#endif\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\ttransformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;\n\t#ifdef FLIP_SIDED\n\t\ttransformedTangent = - transformedTangent;\n\t#endif\n#endif";

var displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif";

var displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif";

var emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif";

var emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif";

var colorspace_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";

var colorspace_pars_fragment = "\nconst mat3 LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 = mat3(\n\tvec3( 0.8224621, 0.177538, 0.0 ),\n\tvec3( 0.0331941, 0.9668058, 0.0 ),\n\tvec3( 0.0170827, 0.0723974, 0.9105199 )\n);\nconst mat3 LINEAR_DISPLAY_P3_TO_LINEAR_SRGB = mat3(\n\tvec3( 1.2249401, - 0.2249404, 0.0 ),\n\tvec3( - 0.0420569, 1.0420571, 0.0 ),\n\tvec3( - 0.0196376, - 0.0786361, 1.0982735 )\n);\nvec4 LinearSRGBToLinearDisplayP3( in vec4 value ) {\n\treturn vec4( value.rgb * LINEAR_SRGB_TO_LINEAR_DISPLAY_P3, value.a );\n}\nvec4 LinearDisplayP3ToLinearSRGB( in vec4 value ) {\n\treturn vec4( value.rgb * LINEAR_DISPLAY_P3_TO_LINEAR_SRGB, value.a );\n}\nvec4 LinearTransferOETF( in vec4 value ) {\n\treturn value;\n}\nvec4 sRGBTransferOETF( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}\nvec4 LinearToLinear( in vec4 value ) {\n\treturn value;\n}\nvec4 LinearTosRGB( in vec4 value ) {\n\treturn sRGBTransferOETF( value );\n}";

var envmap_fragment = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, envMapRotation * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif";

var envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform float flipEnvMap;\n\tuniform mat3 envMapRotation;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\t\n#endif";

var envmap_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif";

var envmap_pars_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif";

var envmap_vertex = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif";

var fog_vertex = "#ifdef USE_FOG\n\tvFogDepth = - mvPosition.z;\n#endif";

var fog_pars_vertex = "#ifdef USE_FOG\n\tvarying float vFogDepth;\n#endif";

var fog_fragment = "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";

var fog_pars_fragment = "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float vFogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif";

var gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn vec3( texture2D( gradientMap, coord ).r );\n\t#else\n\t\tvec2 fw = fwidth( coord ) * 0.5;\n\t\treturn mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n\t#endif\n}";

var lightmap_fragment = "#ifdef USE_LIGHTMAP\n\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\treflectedLight.indirectDiffuse += lightMapIrradiance;\n#endif";

var lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif";

var lights_lambert_fragment = "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;";

var lights_lambert_pars_fragment = "varying vec3 vViewPosition;\nstruct LambertMaterial {\n\tvec3 diffuseColor;\n\tfloat specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Lambert\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Lambert";

var lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\n#if defined( USE_LIGHT_PROBES )\n\tuniform vec3 lightProbe[ 9 ];\n#endif\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\treturn irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\t#if defined ( LEGACY_LIGHTS )\n\t\tif ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n\t\t\treturn pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );\n\t\t}\n\t\treturn 1.0;\n\t#else\n\t\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\t\tif ( cutoffDistance > 0.0 ) {\n\t\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t\t}\n\t\treturn distanceFalloff;\n\t#endif\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n\treturn smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {\n\t\tlight.color = directionalLight.color;\n\t\tlight.direction = directionalLight.direction;\n\t\tlight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = pointLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tlight.color = pointLight.color;\n\t\tlight.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = spotLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat angleCos = dot( light.direction, spotLight.direction );\n\t\tfloat spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\tif ( spotAttenuation > 0.0 ) {\n\t\t\tfloat lightDistance = length( lVector );\n\t\t\tlight.color = spotLight.color * spotAttenuation;\n\t\t\tlight.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t\t} else {\n\t\t\tlight.color = vec3( 0.0 );\n\t\t\tlight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n\t\tfloat dotNL = dot( normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\treturn irradiance;\n\t}\n#endif";

var envmap_physical_pars_fragment = "#ifdef USE_ENVMAP\n\tvec3 getIBLIrradiance( const in vec3 normal ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );\n\t\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\tvec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 reflectVec = reflect( - viewDir, normal );\n\t\t\treflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n\t\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );\n\t\t\treturn envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\t#ifdef USE_ANISOTROPY\n\t\tvec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n\t\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\t\tvec3 bentNormal = cross( bitangent, viewDir );\n\t\t\t\tbentNormal = normalize( cross( bentNormal, bitangent ) );\n\t\t\t\tbentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n\t\t\t\treturn getIBLRadiance( viewDir, bentNormal, roughness );\n\t\t\t#else\n\t\t\t\treturn vec3( 0.0 );\n\t\t\t#endif\n\t\t}\n\t#endif\n#endif";

var lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";

var lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon";

var lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";

var lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong";

var lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n\tmaterial.ior = ior;\n\t#ifdef USE_SPECULAR\n\t\tfloat specularIntensityFactor = specularIntensity;\n\t\tvec3 specularColorFactor = specularColor;\n\t\t#ifdef USE_SPECULAR_COLORMAP\n\t\t\tspecularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n\t\t#endif\n\t\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\t\tspecularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n\t\t#endif\n\t\tmaterial.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n\t#else\n\t\tfloat specularIntensityFactor = 1.0;\n\t\tvec3 specularColorFactor = vec3( 1.0 );\n\t\tmaterial.specularF90 = 1.0;\n\t#endif\n\tmaterial.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\tmaterial.clearcoatF0 = vec3( 0.04 );\n\tmaterial.clearcoatF90 = 1.0;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_IRIDESCENCE\n\tmaterial.iridescence = iridescence;\n\tmaterial.iridescenceIOR = iridescenceIOR;\n\t#ifdef USE_IRIDESCENCEMAP\n\t\tmaterial.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n\t#endif\n\t#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\t\tmaterial.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n\t#else\n\t\tmaterial.iridescenceThickness = iridescenceThicknessMaximum;\n\t#endif\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheenColor;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tmaterial.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n\t#endif\n\tmaterial.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tmaterial.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\t#ifdef USE_ANISOTROPYMAP\n\t\tmat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n\t\tvec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n\t\tvec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n\t#else\n\t\tvec2 anisotropyV = anisotropyVector;\n\t#endif\n\tmaterial.anisotropy = length( anisotropyV );\n\tif( material.anisotropy == 0.0 ) {\n\t\tanisotropyV = vec2( 1.0, 0.0 );\n\t} else {\n\t\tanisotropyV /= material.anisotropy;\n\t\tmaterial.anisotropy = saturate( material.anisotropy );\n\t}\n\tmaterial.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n\tmaterial.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;\n\tmaterial.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;\n#endif";

var lights_physical_pars_fragment = "struct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tfloat roughness;\n\tvec3 specularColor;\n\tfloat specularF90;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat clearcoat;\n\t\tfloat clearcoatRoughness;\n\t\tvec3 clearcoatF0;\n\t\tfloat clearcoatF90;\n\t#endif\n\t#ifdef USE_IRIDESCENCE\n\t\tfloat iridescence;\n\t\tfloat iridescenceIOR;\n\t\tfloat iridescenceThickness;\n\t\tvec3 iridescenceFresnel;\n\t\tvec3 iridescenceF0;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tvec3 sheenColor;\n\t\tfloat sheenRoughness;\n\t#endif\n\t#ifdef IOR\n\t\tfloat ior;\n\t#endif\n\t#ifdef USE_TRANSMISSION\n\t\tfloat transmission;\n\t\tfloat transmissionAlpha;\n\t\tfloat thickness;\n\t\tfloat attenuationDistance;\n\t\tvec3 attenuationColor;\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat anisotropy;\n\t\tfloat alphaT;\n\t\tvec3 anisotropyT;\n\t\tvec3 anisotropyB;\n\t#endif\n};\nvec3 clearcoatSpecularDirect = vec3( 0.0 );\nvec3 clearcoatSpecularIndirect = vec3( 0.0 );\nvec3 sheenSpecularDirect = vec3( 0.0 );\nvec3 sheenSpecularIndirect = vec3(0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n\tfloat V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n\t\tfloat gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n\t\tfloat gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n\t\tfloat v = 0.5 / ( gv + gl );\n\t\treturn saturate(v);\n\t}\n\tfloat D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n\t\tfloat a2 = alphaT * alphaB;\n\t\thighp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n\t\thighp float v2 = dot( v, v );\n\t\tfloat w2 = a2 / v2;\n\t\treturn RECIPROCAL_PI * a2 * pow2 ( w2 );\n\t}\n#endif\n#ifdef USE_CLEARCOAT\n\tvec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n\t\tvec3 f0 = material.clearcoatF0;\n\t\tfloat f90 = material.clearcoatF90;\n\t\tfloat roughness = material.clearcoatRoughness;\n\t\tfloat alpha = pow2( roughness );\n\t\tvec3 halfDir = normalize( lightDir + viewDir );\n\t\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\t\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\t\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\t\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\t\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t\treturn F * ( V * D );\n\t}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n\tvec3 f0 = material.specularColor;\n\tfloat f90 = material.specularF90;\n\tfloat roughness = material.roughness;\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t#ifdef USE_IRIDESCENCE\n\t\tF = mix( F, material.iridescenceFresnel, material.iridescence );\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat dotTL = dot( material.anisotropyT, lightDir );\n\t\tfloat dotTV = dot( material.anisotropyT, viewDir );\n\t\tfloat dotTH = dot( material.anisotropyT, halfDir );\n\t\tfloat dotBL = dot( material.anisotropyB, lightDir );\n\t\tfloat dotBV = dot( material.anisotropyB, viewDir );\n\t\tfloat dotBH = dot( material.anisotropyB, halfDir );\n\t\tfloat V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n\t\tfloat D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n\t#else\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t#endif\n\treturn F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n\tfloat alpha = pow2( roughness );\n\tfloat invAlpha = 1.0 / alpha;\n\tfloat cos2h = dotNH * dotNH;\n\tfloat sin2h = max( 1.0 - cos2h, 0.0078125 );\n\treturn ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n\treturn saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat D = D_Charlie( sheenRoughness, dotNH );\n\tfloat V = V_Neubelt( dotNV, dotNL );\n\treturn sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat r2 = roughness * roughness;\n\tfloat a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n\tfloat b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n\tfloat DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n\treturn saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\tvec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n\treturn fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\treturn specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\t#ifdef USE_IRIDESCENCE\n\t\tvec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n\t#else\n\t\tvec3 Fr = specularColor;\n\t#endif\n\tvec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n\tfloat Ess = fab.x + fab.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometryNormal;\n\t\tvec3 viewDir = geometryViewDir;\n\t\tvec3 position = geometryPosition;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.roughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = dotNLcc * directLight.color;\n\t\tclearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );\n\t#endif\n\treflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometryViewDir, geometryNormal, material );\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n\t#endif\n\tvec3 singleScattering = vec3( 0.0 );\n\tvec3 multiScattering = vec3( 0.0 );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\t#ifdef USE_IRIDESCENCE\n\t\tcomputeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n\t#else\n\t\tcomputeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n\t#endif\n\tvec3 totalScattering = singleScattering + multiScattering;\n\tvec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n\treflectedLight.indirectSpecular += radiance * singleScattering;\n\treflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n\treflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";

var lights_fragment_begin = "\nvec3 geometryPosition = - vViewPosition;\nvec3 geometryNormal = normal;\nvec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\nvec3 geometryClearcoatNormal = vec3( 0.0 );\n#ifdef USE_CLEARCOAT\n\tgeometryClearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n\tfloat dotNVi = saturate( dot( normal, geometryViewDir ) );\n\tif ( material.iridescenceThickness == 0.0 ) {\n\t\tmaterial.iridescence = 0.0;\n\t} else {\n\t\tmaterial.iridescence = saturate( material.iridescence );\n\t}\n\tif ( material.iridescence > 0.0 ) {\n\t\tmaterial.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n\t\tmaterial.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n\t}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointLightInfo( pointLight, geometryPosition, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\tvec4 spotColor;\n\tvec3 spotLightCoord;\n\tbool inSpotLightMap;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotLightInfo( spotLight, geometryPosition, directLight );\n\t\t#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n\t\t#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n\t\t#else\n\t\t#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#endif\n\t\t#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n\t\t\tspotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n\t\t\tinSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n\t\t\tspotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n\t\t\tdirectLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n\t\t#endif\n\t\t#undef SPOT_LIGHT_MAP_INDEX\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalLightInfo( directionalLight, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\t#if defined( USE_LIGHT_PROBES )\n\t\tirradiance += getLightProbeIrradiance( lightProbe, geometryNormal );\n\t#endif\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif";

var lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tiblIrradiance += getIBLIrradiance( geometryNormal );\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\t#ifdef USE_ANISOTROPY\n\t\tradiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );\n\t#else\n\t\tradiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );\n\t#endif\n#endif";

var lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n\tRE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif";

var logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF )\n\tgl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";

var logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";

var logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";

var logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n\tvFragDepth = 1.0 + gl_Position.w;\n\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n#endif";

var map_fragment = "#ifdef USE_MAP\n\tvec4 sampledDiffuseColor = texture2D( map, vMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\tsampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );\n\t\n\t#endif\n\tdiffuseColor *= sampledDiffuseColor;\n#endif";

var map_pars_fragment = "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif";

var map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t#if defined( USE_POINTS_UV )\n\t\tvec2 uv = vUv;\n\t#else\n\t\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tdiffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";

var map_particle_pars_fragment = "#if defined( USE_POINTS_UV )\n\tvarying vec2 vUv;\n#else\n\t#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t\tuniform mat3 uvTransform;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";

var metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif";

var metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif";

var morphinstance_vertex = "#ifdef USE_INSTANCING_MORPH\n\tfloat morphTargetInfluences[MORPHTARGETS_COUNT];\n\tfloat morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tmorphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;\n\t}\n#endif";

var morphcolor_vertex = "#if defined( USE_MORPHCOLORS ) && defined( MORPHTARGETS_TEXTURE )\n\tvColor *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t#if defined( USE_COLOR_ALPHA )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n\t\t#elif defined( USE_COLOR )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n\t\t#endif\n\t}\n#endif";

var morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n\t\t}\n\t#else\n\t\tobjectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n\t\tobjectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n\t\tobjectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n\t\tobjectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n\t#endif\n#endif";

var morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n\t#ifndef USE_INSTANCING_MORPH\n\t\tuniform float morphTargetBaseInfluence;\n\t#endif\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\t#ifndef USE_INSTANCING_MORPH\n\t\t\tuniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\t\t#endif\n\t\tuniform sampler2DArray morphTargetsTexture;\n\t\tuniform ivec2 morphTargetsTextureSize;\n\t\tvec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n\t\t\tint texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n\t\t\tint y = texelIndex / morphTargetsTextureSize.x;\n\t\t\tint x = texelIndex - y * morphTargetsTextureSize.x;\n\t\t\tivec3 morphUV = ivec3( x, y, morphTargetIndex );\n\t\t\treturn texelFetch( morphTargetsTexture, morphUV, 0 );\n\t\t}\n\t#else\n\t\t#ifndef USE_MORPHNORMALS\n\t\t\tuniform float morphTargetInfluences[ 8 ];\n\t\t#else\n\t\t\tuniform float morphTargetInfluences[ 4 ];\n\t\t#endif\n\t#endif\n#endif";

var morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n\t\t}\n\t#else\n\t\ttransformed += morphTarget0 * morphTargetInfluences[ 0 ];\n\t\ttransformed += morphTarget1 * morphTargetInfluences[ 1 ];\n\t\ttransformed += morphTarget2 * morphTargetInfluences[ 2 ];\n\t\ttransformed += morphTarget3 * morphTargetInfluences[ 3 ];\n\t\t#ifndef USE_MORPHNORMALS\n\t\t\ttransformed += morphTarget4 * morphTargetInfluences[ 4 ];\n\t\t\ttransformed += morphTarget5 * morphTargetInfluences[ 5 ];\n\t\t\ttransformed += morphTarget6 * morphTargetInfluences[ 6 ];\n\t\t\ttransformed += morphTarget7 * morphTargetInfluences[ 7 ];\n\t\t#endif\n\t#endif\n#endif";

var normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n\tvec3 fdx = dFdx( vViewPosition );\n\tvec3 fdy = dFdy( vViewPosition );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal *= faceDirection;\n\t#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn = getTangentFrame( - vViewPosition, normal,\n\t\t#if defined( USE_NORMALMAP )\n\t\t\tvNormalMapUv\n\t\t#elif defined( USE_CLEARCOAT_NORMALMAP )\n\t\t\tvClearcoatNormalMapUv\n\t\t#else\n\t\t\tvUv\n\t\t#endif\n\t\t);\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn[0] *= faceDirection;\n\t\ttbn[1] *= faceDirection;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn2[0] *= faceDirection;\n\t\ttbn2[1] *= faceDirection;\n\t#endif\n#endif\nvec3 nonPerturbedNormal = normal;";

var normal_fragment_maps = "#ifdef USE_NORMALMAP_OBJECTSPACE\n\tnormal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n\tvec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\tmapN.xy *= normalScale;\n\tnormal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";

var normal_pars_fragment = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";

var normal_pars_vertex = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";

var normal_vertex = "#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif";

var normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n\tmat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n\t\tvec3 q0 = dFdx( eye_pos.xyz );\n\t\tvec3 q1 = dFdy( eye_pos.xyz );\n\t\tvec2 st0 = dFdx( uv.st );\n\t\tvec2 st1 = dFdy( uv.st );\n\t\tvec3 N = surf_norm;\n\t\tvec3 q1perp = cross( q1, N );\n\t\tvec3 q0perp = cross( N, q0 );\n\t\tvec3 T = q1perp * st0.x + q0perp * st1.x;\n\t\tvec3 B = q1perp * st0.y + q0perp * st1.y;\n\t\tfloat det = max( dot( T, T ), dot( B, B ) );\n\t\tfloat scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n\t\treturn mat3( T * scale, B * scale, N );\n\t}\n#endif";

var clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal = nonPerturbedNormal;\n#endif";

var clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\tclearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif";

var clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif";

var iridescence_pars_fragment = "#ifdef USE_IRIDESCENCEMAP\n\tuniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform sampler2D iridescenceThicknessMap;\n#endif";

var opaque_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";

var packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n\tvec4 r = vec4( fract( v * PackFactors ), v );\n\tr.yzw -= r.xyz * ShiftRight8;\treturn r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors );\n}\nvec2 packDepthToRG( in highp float v ) {\n\treturn packDepthToRGBA( v ).yx;\n}\nfloat unpackRGToDepth( const in highp vec2 v ) {\n\treturn unpackRGBAToDepth( vec4( v.xy, 0.0, 0.0 ) );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * depth - far );\n}";

var premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif";

var project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_BATCHING\n\tmvPosition = batchingMatrix * mvPosition;\n#endif\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";

var dithering_fragment = "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";

var dithering_pars_fragment = "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif";

var roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n\troughnessFactor *= texelRoughness.g;\n#endif";

var roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif";

var shadowmap_pars_fragment = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n\tuniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tvec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n\t\treturn unpackRGBATo2Half( texture2D( shadow, uv ) );\n\t}\n\tfloat VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n\t\tfloat occlusion = 1.0;\n\t\tvec2 distribution = texture2DDistribution( shadow, uv );\n\t\tfloat hard_shadow = step( compare , distribution.x );\n\t\tif (hard_shadow != 1.0 ) {\n\t\t\tfloat distance = compare - distribution.x ;\n\t\t\tfloat variance = max( 0.00000, distribution.y * distribution.y );\n\t\t\tfloat softness_probability = variance / (variance + distance * distance );\t\t\tsoftness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );\t\t\tocclusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n\t\t}\n\t\treturn occlusion;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n\t\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tfloat dx2 = dx0 / 2.0;\n\t\t\tfloat dy2 = dy0 / 2.0;\n\t\t\tfloat dx3 = dx1 / 2.0;\n\t\t\tfloat dy3 = dy1 / 2.0;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 17.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx = texelSize.x;\n\t\t\tfloat dy = texelSize.y;\n\t\t\tvec2 uv = shadowCoord.xy;\n\t\t\tvec2 f = fract( uv * shadowMapSize + 0.5 );\n\t\t\tuv -= f * texelSize;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, uv, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t f.y )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\t\tshadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn shadow;\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tfloat shadow = 1.0;\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\t\n\t\tfloat lightToPositionLength = length( lightToPosition );\n\t\tif ( lightToPositionLength - shadowCameraFar <= 0.0 && lightToPositionLength - shadowCameraNear >= 0.0 ) {\n\t\t\tfloat dp = ( lightToPositionLength - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\t\tdp += shadowBias;\n\t\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n\t\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\t\tshadow = (\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t\t) * ( 1.0 / 9.0 );\n\t\t\t#else\n\t\t\t\tshadow = texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t\t#endif\n\t\t}\n\t\treturn shadow;\n\t}\n#endif";

var shadowmap_pars_vertex = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tuniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif";

var shadowmap_vertex = "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\tvec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition;\n\t\t#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t\tshadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n\t\t#endif\n\t\tvSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n#endif";

var shadowmask_pars_fragment = "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}";

var skinbase_vertex = "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";

var skinning_pars_vertex = "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\tuniform highp sampler2D boneTexture;\n\tmat4 getBoneMatrix( const in float i ) {\n\t\tint size = textureSize( boneTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n#endif";

var skinning_vertex = "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";

var skinnormal_vertex = "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif";

var specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif";

var specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif";

var tonemapping_fragment = "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";

var tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nconst mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(\n\tvec3( 1.6605, - 0.1246, - 0.0182 ),\n\tvec3( - 0.5876, 1.1329, - 0.1006 ),\n\tvec3( - 0.0728, - 0.0083, 1.1187 )\n);\nconst mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(\n\tvec3( 0.6274, 0.0691, 0.0164 ),\n\tvec3( 0.3293, 0.9195, 0.0880 ),\n\tvec3( 0.0433, 0.0113, 0.8956 )\n);\nvec3 agxDefaultContrastApprox( vec3 x ) {\n\tvec3 x2 = x * x;\n\tvec3 x4 = x2 * x2;\n\treturn + 15.5 * x4 * x2\n\t\t- 40.14 * x4 * x\n\t\t+ 31.96 * x4\n\t\t- 6.868 * x2 * x\n\t\t+ 0.4298 * x2\n\t\t+ 0.1191 * x\n\t\t- 0.00232;\n}\nvec3 AgXToneMapping( vec3 color ) {\n\tconst mat3 AgXInsetMatrix = mat3(\n\t\tvec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),\n\t\tvec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),\n\t\tvec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )\n\t);\n\tconst mat3 AgXOutsetMatrix = mat3(\n\t\tvec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),\n\t\tvec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),\n\t\tvec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )\n\t);\n\tconst float AgxMinEv = - 12.47393;\tconst float AgxMaxEv = 4.026069;\n\tcolor *= toneMappingExposure;\n\tcolor = LINEAR_SRGB_TO_LINEAR_REC2020 * color;\n\tcolor = AgXInsetMatrix * color;\n\tcolor = max( color, 1e-10 );\tcolor = log2( color );\n\tcolor = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );\n\tcolor = clamp( color, 0.0, 1.0 );\n\tcolor = agxDefaultContrastApprox( color );\n\tcolor = AgXOutsetMatrix * color;\n\tcolor = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );\n\tcolor = LINEAR_REC2020_TO_LINEAR_SRGB * color;\n\tcolor = clamp( color, 0.0, 1.0 );\n\treturn color;\n}\nvec3 NeutralToneMapping( vec3 color ) {\n\tfloat startCompression = 0.8 - 0.04;\n\tfloat desaturation = 0.15;\n\tcolor *= toneMappingExposure;\n\tfloat x = min(color.r, min(color.g, color.b));\n\tfloat offset = x < 0.08 ? x - 6.25 * x * x : 0.04;\n\tcolor -= offset;\n\tfloat peak = max(color.r, max(color.g, color.b));\n\tif (peak < startCompression) return color;\n\tfloat d = 1. - startCompression;\n\tfloat newPeak = 1. - d * d / (peak + d - startCompression);\n\tcolor *= newPeak / peak;\n\tfloat g = 1. - 1. / (desaturation * (peak - newPeak) + 1.);\n\treturn mix(color, newPeak * vec3(1, 1, 1), g);\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";

var transmission_fragment = "#ifdef USE_TRANSMISSION\n\tmaterial.transmission = transmission;\n\tmaterial.transmissionAlpha = 1.0;\n\tmaterial.thickness = thickness;\n\tmaterial.attenuationDistance = attenuationDistance;\n\tmaterial.attenuationColor = attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tmaterial.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tmaterial.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n\t#endif\n\tvec3 pos = vWorldPosition;\n\tvec3 v = normalize( cameraPosition - pos );\n\tvec3 n = inverseTransformDirection( normal, viewMatrix );\n\tvec4 transmitted = getIBLVolumeRefraction(\n\t\tn, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n\t\tpos, modelMatrix, viewMatrix, projectionMatrix, material.ior, material.thickness,\n\t\tmaterial.attenuationColor, material.attenuationDistance );\n\tmaterial.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n\ttotalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif";

var transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n\tuniform float transmission;\n\tuniform float thickness;\n\tuniform float attenuationDistance;\n\tuniform vec3 attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tuniform sampler2D transmissionMap;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tuniform sampler2D thicknessMap;\n\t#endif\n\tuniform vec2 transmissionSamplerSize;\n\tuniform sampler2D transmissionSamplerMap;\n\tuniform mat4 modelMatrix;\n\tuniform mat4 projectionMatrix;\n\tvarying vec3 vWorldPosition;\n\tfloat w0( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n\t}\n\tfloat w1( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n\t}\n\tfloat w2( float a ){\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n\t}\n\tfloat w3( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * a * a );\n\t}\n\tfloat g0( float a ) {\n\t\treturn w0( a ) + w1( a );\n\t}\n\tfloat g1( float a ) {\n\t\treturn w2( a ) + w3( a );\n\t}\n\tfloat h0( float a ) {\n\t\treturn - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n\t}\n\tfloat h1( float a ) {\n\t\treturn 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n\t}\n\tvec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n\t\tuv = uv * texelSize.zw + 0.5;\n\t\tvec2 iuv = floor( uv );\n\t\tvec2 fuv = fract( uv );\n\t\tfloat g0x = g0( fuv.x );\n\t\tfloat g1x = g1( fuv.x );\n\t\tfloat h0x = h0( fuv.x );\n\t\tfloat h1x = h1( fuv.x );\n\t\tfloat h0y = h0( fuv.y );\n\t\tfloat h1y = h1( fuv.y );\n\t\tvec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\treturn g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n\t\t\tg1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n\t}\n\tvec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n\t\tvec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n\t\tvec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n\t\tvec2 fLodSizeInv = 1.0 / fLodSize;\n\t\tvec2 cLodSizeInv = 1.0 / cLodSize;\n\t\tvec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n\t\tvec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n\t\treturn mix( fSample, cSample, fract( lod ) );\n\t}\n\tvec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n\t\tvec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n\t\tvec3 modelScale;\n\t\tmodelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n\t\tmodelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n\t\tmodelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n\t\treturn normalize( refractionVector ) * thickness * modelScale;\n\t}\n\tfloat applyIorToRoughness( const in float roughness, const in float ior ) {\n\t\treturn roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n\t}\n\tvec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n\t\tfloat lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n\t\treturn textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n\t}\n\tvec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tif ( isinf( attenuationDistance ) ) {\n\t\t\treturn vec3( 1.0 );\n\t\t} else {\n\t\t\tvec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n\t\t\tvec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );\t\t\treturn transmittance;\n\t\t}\n\t}\n\tvec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n\t\tconst in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n\t\tconst in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,\n\t\tconst in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\trefractionCoords += 1.0;\n\t\trefractionCoords /= 2.0;\n\t\tvec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n\t\tvec3 transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n\t\tvec3 attenuatedColor = transmittance * transmittedLight.rgb;\n\t\tvec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n\t\tfloat transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n\t\treturn vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n\t}\n#endif";

var uv_pars_fragment = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";

var uv_pars_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tuniform mat3 mapTransform;\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform mat3 alphaMapTransform;\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tuniform mat3 lightMapTransform;\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tuniform mat3 aoMapTransform;\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tuniform mat3 bumpMapTransform;\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tuniform mat3 normalMapTransform;\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tuniform mat3 displacementMapTransform;\n\tvarying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tuniform mat3 emissiveMapTransform;\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tuniform mat3 metalnessMapTransform;\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tuniform mat3 roughnessMapTransform;\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tuniform mat3 anisotropyMapTransform;\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tuniform mat3 clearcoatMapTransform;\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform mat3 clearcoatNormalMapTransform;\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform mat3 clearcoatRoughnessMapTransform;\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tuniform mat3 sheenColorMapTransform;\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tuniform mat3 sheenRoughnessMapTransform;\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tuniform mat3 iridescenceMapTransform;\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform mat3 iridescenceThicknessMapTransform;\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tuniform mat3 specularMapTransform;\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tuniform mat3 specularColorMapTransform;\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tuniform mat3 specularIntensityMapTransform;\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";

var uv_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n\tvMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n\tvAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n\tvLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n\tvAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n\tvBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n\tvNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tvDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n\tvMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n\tvSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tvTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n\tvThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif";

var worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_BATCHING\n\t\tworldPosition = batchingMatrix * worldPosition;\n\t#endif\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif";

const vertex$h = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}";

const fragment$h = "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n\tvec4 texColor = texture2D( t2D, vUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\ttexColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";

const vertex$g = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";

const fragment$g = "#ifdef ENVMAP_TYPE_CUBE\n\tuniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n\tuniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nuniform mat3 backgroundRotation;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 texColor = textureCube( envMap, backgroundRotation * vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );\n\t#else\n\t\tvec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";

const vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";

const fragment$f = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n\tvec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n\tgl_FragColor = texColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";

const vertex$e = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}";

const fragment$e = "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <logdepthbuf_fragment>\n\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#endif\n}";

const vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}";

const fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}";

const vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}";

const fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";

const vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";

const fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";

const vertex$a = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinbase_vertex>\n\t\t#include <skinnormal_vertex>\n\t\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}";

const fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\treflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";

const vertex$9 = "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";

const fragment$9 = "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_lambert_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";

const vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}";

const fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t#else\n\t\tvec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";

const vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}";

const fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), diffuseColor.a );\n\t#ifdef OPAQUE\n\t\tgl_FragColor.a = 1.0;\n\t#endif\n}";

const vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";

const fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";

const vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n\tvarying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n\tvWorldPosition = worldPosition.xyz;\n#endif\n}";

const fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n\t#define IOR\n\t#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n\tuniform float ior;\n#endif\n#ifdef USE_SPECULAR\n\tuniform float specularIntensity;\n\tuniform vec3 specularColor;\n\t#ifdef USE_SPECULAR_COLORMAP\n\t\tuniform sampler2D specularColorMap;\n\t#endif\n\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\tuniform sampler2D specularIntensityMap;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_IRIDESCENCE\n\tuniform float iridescence;\n\tuniform float iridescenceIOR;\n\tuniform float iridescenceThicknessMinimum;\n\tuniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheenColor;\n\tuniform float sheenRoughness;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tuniform sampler2D sheenColorMap;\n\t#endif\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tuniform sampler2D sheenRoughnessMap;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\tuniform vec2 anisotropyVector;\n\t#ifdef USE_ANISOTROPYMAP\n\t\tuniform sampler2D anisotropyMap;\n\t#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n\t#include <transmission_fragment>\n\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n\t#ifdef USE_SHEEN\n\t\tfloat sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n\t\toutgoingLight = outgoingLight * sheenEnergyComp + sheenSpecularDirect + sheenSpecularIndirect;\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );\n\t\tvec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n\t\toutgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;\n\t#endif\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";

const vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";

const fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";

const vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n\tvarying vec2 vUv;\n\tuniform mat3 uvTransform;\n#endif\nvoid main() {\n\t#ifdef USE_POINTS_UV\n\t\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\t#endif\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}";

const fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";

const vertex$2 = "#include <common>\n#include <batching_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";

const fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\t#include <logdepthbuf_fragment>\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}";

const vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n\tvec2 scale;\n\tscale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n\tscale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";

const fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}";

const ShaderChunk = {
	alphahash_fragment: alphahash_fragment,
	alphahash_pars_fragment: alphahash_pars_fragment,
	alphamap_fragment: alphamap_fragment,
	alphamap_pars_fragment: alphamap_pars_fragment,
	alphatest_fragment: alphatest_fragment,
	alphatest_pars_fragment: alphatest_pars_fragment,
	aomap_fragment: aomap_fragment,
	aomap_pars_fragment: aomap_pars_fragment,
	batching_pars_vertex: batching_pars_vertex,
	batching_vertex: batching_vertex,
	begin_vertex: begin_vertex,
	beginnormal_vertex: beginnormal_vertex,
	bsdfs: bsdfs,
	iridescence_fragment: iridescence_fragment,
	bumpmap_pars_fragment: bumpmap_pars_fragment,
	clipping_planes_fragment: clipping_planes_fragment,
	clipping_planes_pars_fragment: clipping_planes_pars_fragment,
	clipping_planes_pars_vertex: clipping_planes_pars_vertex,
	clipping_planes_vertex: clipping_planes_vertex,
	color_fragment: color_fragment,
	color_pars_fragment: color_pars_fragment,
	color_pars_vertex: color_pars_vertex,
	color_vertex: color_vertex,
	common: common,
	cube_uv_reflection_fragment: cube_uv_reflection_fragment,
	defaultnormal_vertex: defaultnormal_vertex,
	displacementmap_pars_vertex: displacementmap_pars_vertex,
	displacementmap_vertex: displacementmap_vertex,
	emissivemap_fragment: emissivemap_fragment,
	emissivemap_pars_fragment: emissivemap_pars_fragment,
	colorspace_fragment: colorspace_fragment,
	colorspace_pars_fragment: colorspace_pars_fragment,
	envmap_fragment: envmap_fragment,
	envmap_common_pars_fragment: envmap_common_pars_fragment,
	envmap_pars_fragment: envmap_pars_fragment,
	envmap_pars_vertex: envmap_pars_vertex,
	envmap_physical_pars_fragment: envmap_physical_pars_fragment,
	envmap_vertex: envmap_vertex,
	fog_vertex: fog_vertex,
	fog_pars_vertex: fog_pars_vertex,
	fog_fragment: fog_fragment,
	fog_pars_fragment: fog_pars_fragment,
	gradientmap_pars_fragment: gradientmap_pars_fragment,
	lightmap_fragment: lightmap_fragment,
	lightmap_pars_fragment: lightmap_pars_fragment,
	lights_lambert_fragment: lights_lambert_fragment,
	lights_lambert_pars_fragment: lights_lambert_pars_fragment,
	lights_pars_begin: lights_pars_begin,
	lights_toon_fragment: lights_toon_fragment,
	lights_toon_pars_fragment: lights_toon_pars_fragment,
	lights_phong_fragment: lights_phong_fragment,
	lights_phong_pars_fragment: lights_phong_pars_fragment,
	lights_physical_fragment: lights_physical_fragment,
	lights_physical_pars_fragment: lights_physical_pars_fragment,
	lights_fragment_begin: lights_fragment_begin,
	lights_fragment_maps: lights_fragment_maps,
	lights_fragment_end: lights_fragment_end,
	logdepthbuf_fragment: logdepthbuf_fragment,
	logdepthbuf_pars_fragment: logdepthbuf_pars_fragment,
	logdepthbuf_pars_vertex: logdepthbuf_pars_vertex,
	logdepthbuf_vertex: logdepthbuf_vertex,
	map_fragment: map_fragment,
	map_pars_fragment: map_pars_fragment,
	map_particle_fragment: map_particle_fragment,
	map_particle_pars_fragment: map_particle_pars_fragment,
	metalnessmap_fragment: metalnessmap_fragment,
	metalnessmap_pars_fragment: metalnessmap_pars_fragment,
	morphinstance_vertex: morphinstance_vertex,
	morphcolor_vertex: morphcolor_vertex,
	morphnormal_vertex: morphnormal_vertex,
	morphtarget_pars_vertex: morphtarget_pars_vertex,
	morphtarget_vertex: morphtarget_vertex,
	normal_fragment_begin: normal_fragment_begin,
	normal_fragment_maps: normal_fragment_maps,
	normal_pars_fragment: normal_pars_fragment,
	normal_pars_vertex: normal_pars_vertex,
	normal_vertex: normal_vertex,
	normalmap_pars_fragment: normalmap_pars_fragment,
	clearcoat_normal_fragment_begin: clearcoat_normal_fragment_begin,
	clearcoat_normal_fragment_maps: clearcoat_normal_fragment_maps,
	clearcoat_pars_fragment: clearcoat_pars_fragment,
	iridescence_pars_fragment: iridescence_pars_fragment,
	opaque_fragment: opaque_fragment,
	packing: packing,
	premultiplied_alpha_fragment: premultiplied_alpha_fragment,
	project_vertex: project_vertex,
	dithering_fragment: dithering_fragment,
	dithering_pars_fragment: dithering_pars_fragment,
	roughnessmap_fragment: roughnessmap_fragment,
	roughnessmap_pars_fragment: roughnessmap_pars_fragment,
	shadowmap_pars_fragment: shadowmap_pars_fragment,
	shadowmap_pars_vertex: shadowmap_pars_vertex,
	shadowmap_vertex: shadowmap_vertex,
	shadowmask_pars_fragment: shadowmask_pars_fragment,
	skinbase_vertex: skinbase_vertex,
	skinning_pars_vertex: skinning_pars_vertex,
	skinning_vertex: skinning_vertex,
	skinnormal_vertex: skinnormal_vertex,
	specularmap_fragment: specularmap_fragment,
	specularmap_pars_fragment: specularmap_pars_fragment,
	tonemapping_fragment: tonemapping_fragment,
	tonemapping_pars_fragment: tonemapping_pars_fragment,
	transmission_fragment: transmission_fragment,
	transmission_pars_fragment: transmission_pars_fragment,
	uv_pars_fragment: uv_pars_fragment,
	uv_pars_vertex: uv_pars_vertex,
	uv_vertex: uv_vertex,
	worldpos_vertex: worldpos_vertex,

	background_vert: vertex$h,
	background_frag: fragment$h,
	backgroundCube_vert: vertex$g,
	backgroundCube_frag: fragment$g,
	cube_vert: vertex$f,
	cube_frag: fragment$f,
	depth_vert: vertex$e,
	depth_frag: fragment$e,
	distanceRGBA_vert: vertex$d,
	distanceRGBA_frag: fragment$d,
	equirect_vert: vertex$c,
	equirect_frag: fragment$c,
	linedashed_vert: vertex$b,
	linedashed_frag: fragment$b,
	meshbasic_vert: vertex$a,
	meshbasic_frag: fragment$a,
	meshlambert_vert: vertex$9,
	meshlambert_frag: fragment$9,
	meshmatcap_vert: vertex$8,
	meshmatcap_frag: fragment$8,
	meshnormal_vert: vertex$7,
	meshnormal_frag: fragment$7,
	meshphong_vert: vertex$6,
	meshphong_frag: fragment$6,
	meshphysical_vert: vertex$5,
	meshphysical_frag: fragment$5,
	meshtoon_vert: vertex$4,
	meshtoon_frag: fragment$4,
	points_vert: vertex$3,
	points_frag: fragment$3,
	shadow_vert: vertex$2,
	shadow_frag: fragment$2,
	sprite_vert: vertex$1,
	sprite_frag: fragment$1
};

/**
 * Uniforms library for shared webgl shaders
 */

const UniformsLib = {

	common: {

		diffuse: { value: /*@__PURE__*/ new Color( 0xffffff ) },
		opacity: { value: 1.0 },

		map: { value: null },
		mapTransform: { value: /*@__PURE__*/ new Matrix3() },

		alphaMap: { value: null },
		alphaMapTransform: { value: /*@__PURE__*/ new Matrix3() },

		alphaTest: { value: 0 }

	},

	specularmap: {

		specularMap: { value: null },
		specularMapTransform: { value: /*@__PURE__*/ new Matrix3() }

	},

	envmap: {

		envMap: { value: null },
		envMapRotation: { value: /*@__PURE__*/ new Matrix3() },
		flipEnvMap: { value: - 1 },
		reflectivity: { value: 1.0 }, // basic, lambert, phong
		ior: { value: 1.5 }, // physical
		refractionRatio: { value: 0.98 }, // basic, lambert, phong

	},

	aomap: {

		aoMap: { value: null },
		aoMapIntensity: { value: 1 },
		aoMapTransform: { value: /*@__PURE__*/ new Matrix3() }

	},

	lightmap: {

		lightMap: { value: null },
		lightMapIntensity: { value: 1 },
		lightMapTransform: { value: /*@__PURE__*/ new Matrix3() }

	},

	bumpmap: {

		bumpMap: { value: null },
		bumpMapTransform: { value: /*@__PURE__*/ new Matrix3() },
		bumpScale: { value: 1 }

	},

	normalmap: {

		normalMap: { value: null },
		normalMapTransform: { value: /*@__PURE__*/ new Matrix3() },
		normalScale: { value: /*@__PURE__*/ new Vector2( 1, 1 ) }

	},

	displacementmap: {

		displacementMap: { value: null },
		displacementMapTransform: { value: /*@__PURE__*/ new Matrix3() },
		displacementScale: { value: 1 },
		displacementBias: { value: 0 }

	},

	emissivemap: {

		emissiveMap: { value: null },
		emissiveMapTransform: { value: /*@__PURE__*/ new Matrix3() }

	},

	metalnessmap: {

		metalnessMap: { value: null },
		metalnessMapTransform: { value: /*@__PURE__*/ new Matrix3() }

	},

	roughnessmap: {

		roughnessMap: { value: null },
		roughnessMapTransform: { value: /*@__PURE__*/ new Matrix3() }

	},

	gradientmap: {

		gradientMap: { value: null }

	},

	fog: {

		fogDensity: { value: 0.00025 },
		fogNear: { value: 1 },
		fogFar: { value: 2000 },
		fogColor: { value: /*@__PURE__*/ new Color( 0xffffff ) }

	},

	lights: {

		ambientLightColor: { value: [] },

		lightProbe: { value: [] },

		directionalLights: { value: [], properties: {
			direction: {},
			color: {}
		} },

		directionalLightShadows: { value: [], properties: {
			shadowBias: {},
			shadowNormalBias: {},
			shadowRadius: {},
			shadowMapSize: {}
		} },

		directionalShadowMap: { value: [] },
		directionalShadowMatrix: { value: [] },

		spotLights: { value: [], properties: {
			color: {},
			position: {},
			direction: {},
			distance: {},
			coneCos: {},
			penumbraCos: {},
			decay: {}
		} },

		spotLightShadows: { value: [], properties: {
			shadowBias: {},
			shadowNormalBias: {},
			shadowRadius: {},
			shadowMapSize: {}
		} },

		spotLightMap: { value: [] },
		spotShadowMap: { value: [] },
		spotLightMatrix: { value: [] },

		pointLights: { value: [], properties: {
			color: {},
			position: {},
			decay: {},
			distance: {}
		} },

		pointLightShadows: { value: [], properties: {
			shadowBias: {},
			shadowNormalBias: {},
			shadowRadius: {},
			shadowMapSize: {},
			shadowCameraNear: {},
			shadowCameraFar: {}
		} },

		pointShadowMap: { value: [] },
		pointShadowMatrix: { value: [] },

		hemisphereLights: { value: [], properties: {
			direction: {},
			skyColor: {},
			groundColor: {}
		} },

		// TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
		rectAreaLights: { value: [], properties: {
			color: {},
			position: {},
			width: {},
			height: {}
		} },

		ltc_1: { value: null },
		ltc_2: { value: null }

	},

	points: {

		diffuse: { value: /*@__PURE__*/ new Color( 0xffffff ) },
		opacity: { value: 1.0 },
		size: { value: 1.0 },
		scale: { value: 1.0 },
		map: { value: null },
		alphaMap: { value: null },
		alphaMapTransform: { value: /*@__PURE__*/ new Matrix3() },
		alphaTest: { value: 0 },
		uvTransform: { value: /*@__PURE__*/ new Matrix3() }

	},

	sprite: {

		diffuse: { value: /*@__PURE__*/ new Color( 0xffffff ) },
		opacity: { value: 1.0 },
		center: { value: /*@__PURE__*/ new Vector2( 0.5, 0.5 ) },
		rotation: { value: 0.0 },
		map: { value: null },
		mapTransform: { value: /*@__PURE__*/ new Matrix3() },
		alphaMap: { value: null },
		alphaMapTransform: { value: /*@__PURE__*/ new Matrix3() },
		alphaTest: { value: 0 }

	}

};

const ShaderLib = {

	basic: {

		uniforms: /*@__PURE__*/ mergeUniforms( [
			UniformsLib.common,
			UniformsLib.specularmap,
			UniformsLib.envmap,
			UniformsLib.aomap,
			UniformsLib.lightmap,
			UniformsLib.fog
		] ),

		vertexShader: ShaderChunk.meshbasic_vert,
		fragmentShader: ShaderChunk.meshbasic_frag

	},

	lambert: {

		uniforms: /*@__PURE__*/ mergeUniforms( [
			UniformsLib.common,
			UniformsLib.specularmap,
			UniformsLib.envmap,
			UniformsLib.aomap,
			UniformsLib.lightmap,
			UniformsLib.emissivemap,
			UniformsLib.bumpmap,
			UniformsLib.normalmap,
			UniformsLib.displacementmap,
			UniformsLib.fog,
			UniformsLib.lights,
			{
				emissive: { value: /*@__PURE__*/ new Color( 0x000000 ) }
			}
		] ),

		vertexShader: ShaderChunk.meshlambert_vert,
		fragmentShader: ShaderChunk.meshlambert_frag

	},

	phong: {

		uniforms: /*@__PURE__*/ mergeUniforms( [
			UniformsLib.common,
			UniformsLib.specularmap,
			UniformsLib.envmap,
			UniformsLib.aomap,
			UniformsLib.lightmap,
			UniformsLib.emissivemap,
			UniformsLib.bumpmap,
			UniformsLib.normalmap,
			UniformsLib.displacementmap,
			UniformsLib.fog,
			UniformsLib.lights,
			{
				emissive: { value: /*@__PURE__*/ new Color( 0x000000 ) },
				specular: { value: /*@__PURE__*/ new Color( 0x111111 ) },
				shininess: { value: 30 }
			}
		] ),

		vertexShader: ShaderChunk.meshphong_vert,
		fragmentShader: ShaderChunk.meshphong_frag

	},

	standard: {

		uniforms: /*@__PURE__*/ mergeUniforms( [
			UniformsLib.common,
			UniformsLib.envmap,
			UniformsLib.aomap,
			UniformsLib.lightmap,
			UniformsLib.emissivemap,
			UniformsLib.bumpmap,
			UniformsLib.normalmap,
			UniformsLib.displacementmap,
			UniformsLib.roughnessmap,
			UniformsLib.metalnessmap,
			UniformsLib.fog,
			UniformsLib.lights,
			{
				emissive: { value: /*@__PURE__*/ new Color( 0x000000 ) },
				roughness: { value: 1.0 },
				metalness: { value: 0.0 },
				envMapIntensity: { value: 1 }
			}
		] ),

		vertexShader: ShaderChunk.meshphysical_vert,
		fragmentShader: ShaderChunk.meshphysical_frag

	},

	toon: {

		uniforms: /*@__PURE__*/ mergeUniforms( [
			UniformsLib.common,
			UniformsLib.aomap,
			UniformsLib.lightmap,
			UniformsLib.emissivemap,
			UniformsLib.bumpmap,
			UniformsLib.normalmap,
			UniformsLib.displacementmap,
			UniformsLib.gradientmap,
			UniformsLib.fog,
			UniformsLib.lights,
			{
				emissive: { value: /*@__PURE__*/ new Color( 0x000000 ) }
			}
		] ),

		vertexShader: ShaderChunk.meshtoon_vert,
		fragmentShader: ShaderChunk.meshtoon_frag

	},

	matcap: {

		uniforms: /*@__PURE__*/ mergeUniforms( [
			UniformsLib.common,
			UniformsLib.bumpmap,
			UniformsLib.normalmap,
			UniformsLib.displacementmap,
			UniformsLib.fog,
			{
				matcap: { value: null }
			}
		] ),

		vertexShader: ShaderChunk.meshmatcap_vert,
		fragmentShader: ShaderChunk.meshmatcap_frag

	},

	points: {

		uniforms: /*@__PURE__*/ mergeUniforms( [
			UniformsLib.points,
			UniformsLib.fog
		] ),

		vertexShader: ShaderChunk.points_vert,
		fragmentShader: ShaderChunk.points_frag

	},

	dashed: {

		uniforms: /*@__PURE__*/ mergeUniforms( [
			UniformsLib.common,
			UniformsLib.fog,
			{
				scale: { value: 1 },
				dashSize: { value: 1 },
				totalSize: { value: 2 }
			}
		] ),

		vertexShader: ShaderChunk.linedashed_vert,
		fragmentShader: ShaderChunk.linedashed_frag

	},

	depth: {

		uniforms: /*@__PURE__*/ mergeUniforms( [
			UniformsLib.common,
			UniformsLib.displacementmap
		] ),

		vertexShader: ShaderChunk.depth_vert,
		fragmentShader: ShaderChunk.depth_frag

	},

	normal: {

		uniforms: /*@__PURE__*/ mergeUniforms( [
			UniformsLib.common,
			UniformsLib.bumpmap,
			UniformsLib.normalmap,
			UniformsLib.displacementmap,
			{
				opacity: { value: 1.0 }
			}
		] ),

		vertexShader: ShaderChunk.meshnormal_vert,
		fragmentShader: ShaderChunk.meshnormal_frag

	},

	sprite: {

		uniforms: /*@__PURE__*/ mergeUniforms( [
			UniformsLib.sprite,
			UniformsLib.fog
		] ),

		vertexShader: ShaderChunk.sprite_vert,
		fragmentShader: ShaderChunk.sprite_frag

	},

	background: {

		uniforms: {
			uvTransform: { value: /*@__PURE__*/ new Matrix3() },
			t2D: { value: null },
			backgroundIntensity: { value: 1 }
		},

		vertexShader: ShaderChunk.background_vert,
		fragmentShader: ShaderChunk.background_frag

	},

	backgroundCube: {

		uniforms: {
			envMap: { value: null },
			flipEnvMap: { value: - 1 },
			backgroundBlurriness: { value: 0 },
			backgroundIntensity: { value: 1 },
			backgroundRotation: { value: /*@__PURE__*/ new Matrix3() }
		},

		vertexShader: ShaderChunk.backgroundCube_vert,
		fragmentShader: ShaderChunk.backgroundCube_frag

	},

	cube: {

		uniforms: {
			tCube: { value: null },
			tFlip: { value: - 1 },
			opacity: { value: 1.0 }
		},

		vertexShader: ShaderChunk.cube_vert,
		fragmentShader: ShaderChunk.cube_frag

	},

	equirect: {

		uniforms: {
			tEquirect: { value: null },
		},

		vertexShader: ShaderChunk.equirect_vert,
		fragmentShader: ShaderChunk.equirect_frag

	},

	distanceRGBA: {

		uniforms: /*@__PURE__*/ mergeUniforms( [
			UniformsLib.common,
			UniformsLib.displacementmap,
			{
				referencePosition: { value: /*@__PURE__*/ new Vector3() },
				nearDistance: { value: 1 },
				farDistance: { value: 1000 }
			}
		] ),

		vertexShader: ShaderChunk.distanceRGBA_vert,
		fragmentShader: ShaderChunk.distanceRGBA_frag

	},

	shadow: {

		uniforms: /*@__PURE__*/ mergeUniforms( [
			UniformsLib.lights,
			UniformsLib.fog,
			{
				color: { value: /*@__PURE__*/ new Color( 0x00000 ) },
				opacity: { value: 1.0 }
			},
		] ),

		vertexShader: ShaderChunk.shadow_vert,
		fragmentShader: ShaderChunk.shadow_frag

	}

};

ShaderLib.physical = {

	uniforms: /*@__PURE__*/ mergeUniforms( [
		ShaderLib.standard.uniforms,
		{
			clearcoat: { value: 0 },
			clearcoatMap: { value: null },
			clearcoatMapTransform: { value: /*@__PURE__*/ new Matrix3() },
			clearcoatNormalMap: { value: null },
			clearcoatNormalMapTransform: { value: /*@__PURE__*/ new Matrix3() },
			clearcoatNormalScale: { value: /*@__PURE__*/ new Vector2( 1, 1 ) },
			clearcoatRoughness: { value: 0 },
			clearcoatRoughnessMap: { value: null },
			clearcoatRoughnessMapTransform: { value: /*@__PURE__*/ new Matrix3() },
			iridescence: { value: 0 },
			iridescenceMap: { value: null },
			iridescenceMapTransform: { value: /*@__PURE__*/ new Matrix3() },
			iridescenceIOR: { value: 1.3 },
			iridescenceThicknessMinimum: { value: 100 },
			iridescenceThicknessMaximum: { value: 400 },
			iridescenceThicknessMap: { value: null },
			iridescenceThicknessMapTransform: { value: /*@__PURE__*/ new Matrix3() },
			sheen: { value: 0 },
			sheenColor: { value: /*@__PURE__*/ new Color( 0x000000 ) },
			sheenColorMap: { value: null },
			sheenColorMapTransform: { value: /*@__PURE__*/ new Matrix3() },
			sheenRoughness: { value: 1 },
			sheenRoughnessMap: { value: null },
			sheenRoughnessMapTransform: { value: /*@__PURE__*/ new Matrix3() },
			transmission: { value: 0 },
			transmissionMap: { value: null },
			transmissionMapTransform: { value: /*@__PURE__*/ new Matrix3() },
			transmissionSamplerSize: { value: /*@__PURE__*/ new Vector2() },
			transmissionSamplerMap: { value: null },
			thickness: { value: 0 },
			thicknessMap: { value: null },
			thicknessMapTransform: { value: /*@__PURE__*/ new Matrix3() },
			attenuationDistance: { value: 0 },
			attenuationColor: { value: /*@__PURE__*/ new Color( 0x000000 ) },
			specularColor: { value: /*@__PURE__*/ new Color( 1, 1, 1 ) },
			specularColorMap: { value: null },
			specularColorMapTransform: { value: /*@__PURE__*/ new Matrix3() },
			specularIntensity: { value: 1 },
			specularIntensityMap: { value: null },
			specularIntensityMapTransform: { value: /*@__PURE__*/ new Matrix3() },
			anisotropyVector: { value: /*@__PURE__*/ new Vector2() },
			anisotropyMap: { value: null },
			anisotropyMapTransform: { value: /*@__PURE__*/ new Matrix3() },
		}
	] ),

	vertexShader: ShaderChunk.meshphysical_vert,
	fragmentShader: ShaderChunk.meshphysical_frag

};

const _rgb = { r: 0, b: 0, g: 0 };
const _e1$1 = /*@__PURE__*/ new Euler();
const _m1$1 = /*@__PURE__*/ new Matrix4();

function WebGLBackground( renderer, cubemaps, cubeuvmaps, state, objects, alpha, premultipliedAlpha ) {

	const clearColor = new Color( 0x000000 );
	let clearAlpha = alpha === true ? 0 : 1;

	let planeMesh;
	let boxMesh;

	let currentBackground = null;
	let currentBackgroundVersion = 0;
	let currentTonemapping = null;

	function render( renderList, scene ) {

		let forceClear = false;
		let background = scene.isScene === true ? scene.background : null;

		if ( background && background.isTexture ) {

			const usePMREM = scene.backgroundBlurriness > 0; // use PMREM if the user wants to blur the background
			background = ( usePMREM ? cubeuvmaps : cubemaps ).get( background );

		}

		if ( background === null ) {

			setClear( clearColor, clearAlpha );

		} else if ( background && background.isColor ) {

			setClear( background, 1 );
			forceClear = true;

		}

		const environmentBlendMode = renderer.xr.getEnvironmentBlendMode();

		if ( environmentBlendMode === 'additive' ) {

			state.buffers.color.setClear( 0, 0, 0, 1, premultipliedAlpha );

		} else if ( environmentBlendMode === 'alpha-blend' ) {

			state.buffers.color.setClear( 0, 0, 0, 0, premultipliedAlpha );

		}

		if ( renderer.autoClear || forceClear ) {

			renderer.clear( renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil );

		}

		if ( background && ( background.isCubeTexture || background.mapping === CubeUVReflectionMapping ) ) {

			if ( boxMesh === undefined ) {

				boxMesh = new Mesh(
					new BoxGeometry( 1, 1, 1 ),
					new ShaderMaterial( {
						name: 'BackgroundCubeMaterial',
						uniforms: cloneUniforms( ShaderLib.backgroundCube.uniforms ),
						vertexShader: ShaderLib.backgroundCube.vertexShader,
						fragmentShader: ShaderLib.backgroundCube.fragmentShader,
						side: BackSide,
						depthTest: false,
						depthWrite: false,
						fog: false
					} )
				);

				boxMesh.geometry.deleteAttribute( 'normal' );
				boxMesh.geometry.deleteAttribute( 'uv' );

				boxMesh.onBeforeRender = function ( renderer, scene, camera ) {

					this.matrixWorld.copyPosition( camera.matrixWorld );

				};

				// add "envMap" material property so the renderer can evaluate it like for built-in materials
				Object.defineProperty( boxMesh.material, 'envMap', {

					get: function () {

						return this.uniforms.envMap.value;

					}

				} );

				objects.update( boxMesh );

			}

			_e1$1.copy( scene.backgroundRotation );

			// accommodate left-handed frame
			_e1$1.x *= - 1; _e1$1.y *= - 1; _e1$1.z *= - 1;

			if ( background.isCubeTexture && background.isRenderTargetTexture === false ) {

				// environment maps which are not cube render targets or PMREMs follow a different convention
				_e1$1.y *= - 1;
				_e1$1.z *= - 1;

			}

			boxMesh.material.uniforms.envMap.value = background;
			boxMesh.material.uniforms.flipEnvMap.value = ( background.isCubeTexture && background.isRenderTargetTexture === false ) ? - 1 : 1;
			boxMesh.material.uniforms.backgroundBlurriness.value = scene.backgroundBlurriness;
			boxMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
			boxMesh.material.uniforms.backgroundRotation.value.setFromMatrix4( _m1$1.makeRotationFromEuler( _e1$1 ) );
			boxMesh.material.toneMapped = ColorManagement.getTransfer( background.colorSpace ) !== SRGBTransfer;

			if ( currentBackground !== background ||
				currentBackgroundVersion !== background.version ||
				currentTonemapping !== renderer.toneMapping ) {

				boxMesh.material.needsUpdate = true;

				currentBackground = background;
				currentBackgroundVersion = background.version;
				currentTonemapping = renderer.toneMapping;

			}

			boxMesh.layers.enableAll();

			// push to the pre-sorted opaque render list
			renderList.unshift( boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null );

		} else if ( background && background.isTexture ) {

			if ( planeMesh === undefined ) {

				planeMesh = new Mesh(
					new PlaneGeometry( 2, 2 ),
					new ShaderMaterial( {
						name: 'BackgroundMaterial',
						uniforms: cloneUniforms( ShaderLib.background.uniforms ),
						vertexShader: ShaderLib.background.vertexShader,
						fragmentShader: ShaderLib.background.fragmentShader,
						side: FrontSide,
						depthTest: false,
						depthWrite: false,
						fog: false
					} )
				);

				planeMesh.geometry.deleteAttribute( 'normal' );

				// add "map" material property so the renderer can evaluate it like for built-in materials
				Object.defineProperty( planeMesh.material, 'map', {

					get: function () {

						return this.uniforms.t2D.value;

					}

				} );

				objects.update( planeMesh );

			}

			planeMesh.material.uniforms.t2D.value = background;
			planeMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
			planeMesh.material.toneMapped = ColorManagement.getTransfer( background.colorSpace ) !== SRGBTransfer;

			if ( background.matrixAutoUpdate === true ) {

				background.updateMatrix();

			}

			planeMesh.material.uniforms.uvTransform.value.copy( background.matrix );

			if ( currentBackground !== background ||
				currentBackgroundVersion !== background.version ||
				currentTonemapping !== renderer.toneMapping ) {

				planeMesh.material.needsUpdate = true;

				currentBackground = background;
				currentBackgroundVersion = background.version;
				currentTonemapping = renderer.toneMapping;

			}

			planeMesh.layers.enableAll();

			// push to the pre-sorted opaque render list
			renderList.unshift( planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null );

		}

	}

	function setClear( color, alpha ) {

		color.getRGB( _rgb, getUnlitUniformColorSpace( renderer ) );

		state.buffers.color.setClear( _rgb.r, _rgb.g, _rgb.b, alpha, premultipliedAlpha );

	}

	return {

		getClearColor: function () {

			return clearColor;

		},
		setClearColor: function ( color, alpha = 1 ) {

			clearColor.set( color );
			clearAlpha = alpha;
			setClear( clearColor, clearAlpha );

		},
		getClearAlpha: function () {

			return clearAlpha;

		},
		setClearAlpha: function ( alpha ) {

			clearAlpha = alpha;
			setClear( clearColor, clearAlpha );

		},
		render: render

	};

}

function WebGLBindingStates( gl, attributes ) {

	const maxVertexAttributes = gl.getParameter( gl.MAX_VERTEX_ATTRIBS );

	const bindingStates = {};

	const defaultState = createBindingState( null );
	let currentState = defaultState;
	let forceUpdate = false;

	function setup( object, material, program, geometry, index ) {

		let updateBuffers = false;

		const state = getBindingState( geometry, program, material );

		if ( currentState !== state ) {

			currentState = state;
			bindVertexArrayObject( currentState.object );

		}

		updateBuffers = needsUpdate( object, geometry, program, index );

		if ( updateBuffers ) saveCache( object, geometry, program, index );

		if ( index !== null ) {

			attributes.update( index, gl.ELEMENT_ARRAY_BUFFER );

		}

		if ( updateBuffers || forceUpdate ) {

			forceUpdate = false;

			setupVertexAttributes( object, material, program, geometry );

			if ( index !== null ) {

				gl.bindBuffer( gl.ELEMENT_ARRAY_BUFFER, attributes.get( index ).buffer );

			}

		}

	}

	function createVertexArrayObject() {

		return gl.createVertexArray();

	}

	function bindVertexArrayObject( vao ) {

		return gl.bindVertexArray( vao );

	}

	function deleteVertexArrayObject( vao ) {

		return gl.deleteVertexArray( vao );

	}

	function getBindingState( geometry, program, material ) {

		const wireframe = ( material.wireframe === true );

		let programMap = bindingStates[ geometry.id ];

		if ( programMap === undefined ) {

			programMap = {};
			bindingStates[ geometry.id ] = programMap;

		}

		let stateMap = programMap[ program.id ];

		if ( stateMap === undefined ) {

			stateMap = {};
			programMap[ program.id ] = stateMap;

		}

		let state = stateMap[ wireframe ];

		if ( state === undefined ) {

			state = createBindingState( createVertexArrayObject() );
			stateMap[ wireframe ] = state;

		}

		return state;

	}

	function createBindingState( vao ) {

		const newAttributes = [];
		const enabledAttributes = [];
		const attributeDivisors = [];

		for ( let i = 0; i < maxVertexAttributes; i ++ ) {

			newAttributes[ i ] = 0;
			enabledAttributes[ i ] = 0;
			attributeDivisors[ i ] = 0;

		}

		return {

			// for backward compatibility on non-VAO support browser
			geometry: null,
			program: null,
			wireframe: false,

			newAttributes: newAttributes,
			enabledAttributes: enabledAttributes,
			attributeDivisors: attributeDivisors,
			object: vao,
			attributes: {},
			index: null

		};

	}

	function needsUpdate( object, geometry, program, index ) {

		const cachedAttributes = currentState.attributes;
		const geometryAttributes = geometry.attributes;

		let attributesNum = 0;

		const programAttributes = program.getAttributes();

		for ( const name in programAttributes ) {

			const programAttribute = programAttributes[ name ];

			if ( programAttribute.location >= 0 ) {

				const cachedAttribute = cachedAttributes[ name ];
				let geometryAttribute = geometryAttributes[ name ];

				if ( geometryAttribute === undefined ) {

					if ( name === 'instanceMatrix' && object.instanceMatrix ) geometryAttribute = object.instanceMatrix;
					if ( name === 'instanceColor' && object.instanceColor ) geometryAttribute = object.instanceColor;

				}

				if ( cachedAttribute === undefined ) return true;

				if ( cachedAttribute.attribute !== geometryAttribute ) return true;

				if ( geometryAttribute && cachedAttribute.data !== geometryAttribute.data ) return true;

				attributesNum ++;

			}

		}

		if ( currentState.attributesNum !== attributesNum ) return true;

		if ( currentState.index !== index ) return true;

		return false;

	}

	function saveCache( object, geometry, program, index ) {

		const cache = {};
		const attributes = geometry.attributes;
		let attributesNum = 0;

		const programAttributes = program.getAttributes();

		for ( const name in programAttributes ) {

			const programAttribute = programAttributes[ name ];

			if ( programAttribute.location >= 0 ) {

				let attribute = attributes[ name ];

				if ( attribute === undefined ) {

					if ( name === 'instanceMatrix' && object.instanceMatrix ) attribute = object.instanceMatrix;
					if ( name === 'instanceColor' && object.instanceColor ) attribute = object.instanceColor;

				}

				const data = {};
				data.attribute = attribute;

				if ( attribute && attribute.data ) {

					data.data = attribute.data;

				}

				cache[ name ] = data;

				attributesNum ++;

			}

		}

		currentState.attributes = cache;
		currentState.attributesNum = attributesNum;

		currentState.index = index;

	}

	function initAttributes() {

		const newAttributes = currentState.newAttributes;

		for ( let i = 0, il = newAttributes.length; i < il; i ++ ) {

			newAttributes[ i ] = 0;

		}

	}

	function enableAttribute( attribute ) {

		enableAttributeAndDivisor( attribute, 0 );

	}

	function enableAttributeAndDivisor( attribute, meshPerAttribute ) {

		const newAttributes = currentState.newAttributes;
		const enabledAttributes = currentState.enabledAttributes;
		const attributeDivisors = currentState.attributeDivisors;

		newAttributes[ attribute ] = 1;

		if ( enabledAttributes[ attribute ] === 0 ) {

			gl.enableVertexAttribArray( attribute );
			enabledAttributes[ attribute ] = 1;

		}

		if ( attributeDivisors[ attribute ] !== meshPerAttribute ) {

			gl.vertexAttribDivisor( attribute, meshPerAttribute );
			attributeDivisors[ attribute ] = meshPerAttribute;

		}

	}

	function disableUnusedAttributes() {

		const newAttributes = currentState.newAttributes;
		const enabledAttributes = currentState.enabledAttributes;

		for ( let i = 0, il = enabledAttributes.length; i < il; i ++ ) {

			if ( enabledAttributes[ i ] !== newAttributes[ i ] ) {

				gl.disableVertexAttribArray( i );
				enabledAttributes[ i ] = 0;

			}

		}

	}

	function vertexAttribPointer( index, size, type, normalized, stride, offset, integer ) {

		if ( integer === true ) {

			gl.vertexAttribIPointer( index, size, type, stride, offset );

		} else {

			gl.vertexAttribPointer( index, size, type, normalized, stride, offset );

		}

	}

	function setupVertexAttributes( object, material, program, geometry ) {

		initAttributes();

		const geometryAttributes = geometry.attributes;

		const programAttributes = program.getAttributes();

		const materialDefaultAttributeValues = material.defaultAttributeValues;

		for ( const name in programAttributes ) {

			const programAttribute = programAttributes[ name ];

			if ( programAttribute.location >= 0 ) {

				let geometryAttribute = geometryAttributes[ name ];

				if ( geometryAttribute === undefined ) {

					if ( name === 'instanceMatrix' && object.instanceMatrix ) geometryAttribute = object.instanceMatrix;
					if ( name === 'instanceColor' && object.instanceColor ) geometryAttribute = object.instanceColor;

				}

				if ( geometryAttribute !== undefined ) {

					const normalized = geometryAttribute.normalized;
					const size = geometryAttribute.itemSize;

					const attribute = attributes.get( geometryAttribute );

					// TODO Attribute may not be available on context restore

					if ( attribute === undefined ) continue;

					const buffer = attribute.buffer;
					const type = attribute.type;
					const bytesPerElement = attribute.bytesPerElement;

					// check for integer attributes

					const integer = ( type === gl.INT || type === gl.UNSIGNED_INT || geometryAttribute.gpuType === IntType );

					if ( geometryAttribute.isInterleavedBufferAttribute ) {

						const data = geometryAttribute.data;
						const stride = data.stride;
						const offset = geometryAttribute.offset;

						if ( data.isInstancedInterleavedBuffer ) {

							for ( let i = 0; i < programAttribute.locationSize; i ++ ) {

								enableAttributeAndDivisor( programAttribute.location + i, data.meshPerAttribute );

							}

							if ( object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined ) {

								geometry._maxInstanceCount = data.meshPerAttribute * data.count;

							}

						} else {

							for ( let i = 0; i < programAttribute.locationSize; i ++ ) {

								enableAttribute( programAttribute.location + i );

							}

						}

						gl.bindBuffer( gl.ARRAY_BUFFER, buffer );

						for ( let i = 0; i < programAttribute.locationSize; i ++ ) {

							vertexAttribPointer(
								programAttribute.location + i,
								size / programAttribute.locationSize,
								type,
								normalized,
								stride * bytesPerElement,
								( offset + ( size / programAttribute.locationSize ) * i ) * bytesPerElement,
								integer
							);

						}

					} else {

						if ( geometryAttribute.isInstancedBufferAttribute ) {

							for ( let i = 0; i < programAttribute.locationSize; i ++ ) {

								enableAttributeAndDivisor( programAttribute.location + i, geometryAttribute.meshPerAttribute );

							}

							if ( object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined ) {

								geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;

							}

						} else {

							for ( let i = 0; i < programAttribute.locationSize; i ++ ) {

								enableAttribute( programAttribute.location + i );

							}

						}

						gl.bindBuffer( gl.ARRAY_BUFFER, buffer );

						for ( let i = 0; i < programAttribute.locationSize; i ++ ) {

							vertexAttribPointer(
								programAttribute.location + i,
								size / programAttribute.locationSize,
								type,
								normalized,
								size * bytesPerElement,
								( size / programAttribute.locationSize ) * i * bytesPerElement,
								integer
							);

						}

					}

				} else if ( materialDefaultAttributeValues !== undefined ) {

					const value = materialDefaultAttributeValues[ name ];

					if ( value !== undefined ) {

						switch ( value.length ) {

							case 2:
								gl.vertexAttrib2fv( programAttribute.location, value );
								break;

							case 3:
								gl.vertexAttrib3fv( programAttribute.location, value );
								break;

							case 4:
								gl.vertexAttrib4fv( programAttribute.location, value );
								break;

							default:
								gl.vertexAttrib1fv( programAttribute.location, value );

						}

					}

				}

			}

		}

		disableUnusedAttributes();

	}

	function dispose() {

		reset();

		for ( const geometryId in bindingStates ) {

			const programMap = bindingStates[ geometryId ];

			for ( const programId in programMap ) {

				const stateMap = programMap[ programId ];

				for ( const wireframe in stateMap ) {

					deleteVertexArrayObject( stateMap[ wireframe ].object );

					delete stateMap[ wireframe ];

				}

				delete programMap[ programId ];

			}

			delete bindingStates[ geometryId ];

		}

	}

	function releaseStatesOfGeometry( geometry ) {

		if ( bindingStates[ geometry.id ] === undefined ) return;

		const programMap = bindingStates[ geometry.id ];

		for ( const programId in programMap ) {

			const stateMap = programMap[ programId ];

			for ( const wireframe in stateMap ) {

				deleteVertexArrayObject( stateMap[ wireframe ].object );

				delete stateMap[ wireframe ];

			}

			delete programMap[ programId ];

		}

		delete bindingStates[ geometry.id ];

	}

	function releaseStatesOfProgram( program ) {

		for ( const geometryId in bindingStates ) {

			const programMap = bindingStates[ geometryId ];

			if ( programMap[ program.id ] === undefined ) continue;

			const stateMap = programMap[ program.id ];

			for ( const wireframe in stateMap ) {

				deleteVertexArrayObject( stateMap[ wireframe ].object );

				delete stateMap[ wireframe ];

			}

			delete programMap[ program.id ];

		}

	}

	function reset() {

		resetDefaultState();
		forceUpdate = true;

		if ( currentState === defaultState ) return;

		currentState = defaultState;
		bindVertexArrayObject( currentState.object );

	}

	// for backward-compatibility

	function resetDefaultState() {

		defaultState.geometry = null;
		defaultState.program = null;
		defaultState.wireframe = false;

	}

	return {

		setup: setup,
		reset: reset,
		resetDefaultState: resetDefaultState,
		dispose: dispose,
		releaseStatesOfGeometry: releaseStatesOfGeometry,
		releaseStatesOfProgram: releaseStatesOfProgram,

		initAttributes: initAttributes,
		enableAttribute: enableAttribute,
		disableUnusedAttributes: disableUnusedAttributes

	};

}

function WebGLBufferRenderer( gl, extensions, info ) {

	let mode;

	function setMode( value ) {

		mode = value;

	}

	function render( start, count ) {

		gl.drawArrays( mode, start, count );

		info.update( count, mode, 1 );

	}

	function renderInstances( start, count, primcount ) {

		if ( primcount === 0 ) return;

		gl.drawArraysInstanced( mode, start, count, primcount );

		info.update( count, mode, primcount );

	}

	function renderMultiDraw( starts, counts, drawCount ) {

		if ( drawCount === 0 ) return;

		const extension = extensions.get( 'WEBGL_multi_draw' );

		if ( extension === null ) {

			for ( let i = 0; i < drawCount; i ++ ) {

				this.render( starts[ i ], counts[ i ] );

			}

		} else {

			extension.multiDrawArraysWEBGL( mode, starts, 0, counts, 0, drawCount );

			let elementCount = 0;
			for ( let i = 0; i < drawCount; i ++ ) {

				elementCount += counts[ i ];

			}

			info.update( elementCount, mode, 1 );

		}

	}

	//

	this.setMode = setMode;
	this.render = render;
	this.renderInstances = renderInstances;
	this.renderMultiDraw = renderMultiDraw;

}

function WebGLCapabilities( gl, extensions, parameters ) {

	let maxAnisotropy;

	function getMaxAnisotropy() {

		if ( maxAnisotropy !== undefined ) return maxAnisotropy;

		if ( extensions.has( 'EXT_texture_filter_anisotropic' ) === true ) {

			const extension = extensions.get( 'EXT_texture_filter_anisotropic' );

			maxAnisotropy = gl.getParameter( extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT );

		} else {

			maxAnisotropy = 0;

		}

		return maxAnisotropy;

	}

	function getMaxPrecision( precision ) {

		if ( precision === 'highp' ) {

			if ( gl.getShaderPrecisionFormat( gl.VERTEX_SHADER, gl.HIGH_FLOAT ).precision > 0 &&
				gl.getShaderPrecisionFormat( gl.FRAGMENT_SHADER, gl.HIGH_FLOAT ).precision > 0 ) {

				return 'highp';

			}

			precision = 'mediump';

		}

		if ( precision === 'mediump' ) {

			if ( gl.getShaderPrecisionFormat( gl.VERTEX_SHADER, gl.MEDIUM_FLOAT ).precision > 0 &&
				gl.getShaderPrecisionFormat( gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT ).precision > 0 ) {

				return 'mediump';

			}

		}

		return 'lowp';

	}

	let precision = parameters.precision !== undefined ? parameters.precision : 'highp';
	const maxPrecision = getMaxPrecision( precision );

	if ( maxPrecision !== precision ) {

		console.warn( 'THREE.WebGLRenderer:', precision, 'not supported, using', maxPrecision, 'instead.' );
		precision = maxPrecision;

	}

	const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;

	const maxTextures = gl.getParameter( gl.MAX_TEXTURE_IMAGE_UNITS );
	const maxVertexTextures = gl.getParameter( gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS );
	const maxTextureSize = gl.getParameter( gl.MAX_TEXTURE_SIZE );
	const maxCubemapSize = gl.getParameter( gl.MAX_CUBE_MAP_TEXTURE_SIZE );

	const maxAttributes = gl.getParameter( gl.MAX_VERTEX_ATTRIBS );
	const maxVertexUniforms = gl.getParameter( gl.MAX_VERTEX_UNIFORM_VECTORS );
	const maxVaryings = gl.getParameter( gl.MAX_VARYING_VECTORS );
	const maxFragmentUniforms = gl.getParameter( gl.MAX_FRAGMENT_UNIFORM_VECTORS );

	const vertexTextures = maxVertexTextures > 0;

	const maxSamples = gl.getParameter( gl.MAX_SAMPLES );

	return {

		isWebGL2: true, // keeping this for backwards compatibility

		getMaxAnisotropy: getMaxAnisotropy,
		getMaxPrecision: getMaxPrecision,

		precision: precision,
		logarithmicDepthBuffer: logarithmicDepthBuffer,

		maxTextures: maxTextures,
		maxVertexTextures: maxVertexTextures,
		maxTextureSize: maxTextureSize,
		maxCubemapSize: maxCubemapSize,

		maxAttributes: maxAttributes,
		maxVertexUniforms: maxVertexUniforms,
		maxVaryings: maxVaryings,
		maxFragmentUniforms: maxFragmentUniforms,

		vertexTextures: vertexTextures,

		maxSamples: maxSamples

	};

}

function WebGLClipping( properties ) {

	const scope = this;

	let globalState = null,
		numGlobalPlanes = 0,
		localClippingEnabled = false,
		renderingShadows = false;

	const plane = new Plane(),
		viewNormalMatrix = new Matrix3(),

		uniform = { value: null, needsUpdate: false };

	this.uniform = uniform;
	this.numPlanes = 0;
	this.numIntersection = 0;

	this.init = function ( planes, enableLocalClipping ) {

		const enabled =
			planes.length !== 0 ||
			enableLocalClipping ||
			// enable state of previous frame - the clipping code has to
			// run another frame in order to reset the state:
			numGlobalPlanes !== 0 ||
			localClippingEnabled;

		localClippingEnabled = enableLocalClipping;

		numGlobalPlanes = planes.length;

		return enabled;

	};

	this.beginShadows = function () {

		renderingShadows = true;
		projectPlanes( null );

	};

	this.endShadows = function () {

		renderingShadows = false;

	};

	this.setGlobalState = function ( planes, camera ) {

		globalState = projectPlanes( planes, camera, 0 );

	};

	this.setState = function ( material, camera, useCache ) {

		const planes = material.clippingPlanes,
			clipIntersection = material.clipIntersection,
			clipShadows = material.clipShadows;

		const materialProperties = properties.get( material );

		if ( ! localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && ! clipShadows ) {

			// there's no local clipping

			if ( renderingShadows ) {

				// there's no global clipping

				projectPlanes( null );

			} else {

				resetGlobalState();

			}

		} else {

			const nGlobal = renderingShadows ? 0 : numGlobalPlanes,
				lGlobal = nGlobal * 4;

			let dstArray = materialProperties.clippingState || null;

			uniform.value = dstArray; // ensure unique state

			dstArray = projectPlanes( planes, camera, lGlobal, useCache );

			for ( let i = 0; i !== lGlobal; ++ i ) {

				dstArray[ i ] = globalState[ i ];

			}

			materialProperties.clippingState = dstArray;
			this.numIntersection = clipIntersection ? this.numPlanes : 0;
			this.numPlanes += nGlobal;

		}


	};

	function resetGlobalState() {

		if ( uniform.value !== globalState ) {

			uniform.value = globalState;
			uniform.needsUpdate = numGlobalPlanes > 0;

		}

		scope.numPlanes = numGlobalPlanes;
		scope.numIntersection = 0;

	}

	function projectPlanes( planes, camera, dstOffset, skipTransform ) {

		const nPlanes = planes !== null ? planes.length : 0;
		let dstArray = null;

		if ( nPlanes !== 0 ) {

			dstArray = uniform.value;

			if ( skipTransform !== true || dstArray === null ) {

				const flatSize = dstOffset + nPlanes * 4,
					viewMatrix = camera.matrixWorldInverse;

				viewNormalMatrix.getNormalMatrix( viewMatrix );

				if ( dstArray === null || dstArray.length < flatSize ) {

					dstArray = new Float32Array( flatSize );

				}

				for ( let i = 0, i4 = dstOffset; i !== nPlanes; ++ i, i4 += 4 ) {

					plane.copy( planes[ i ] ).applyMatrix4( viewMatrix, viewNormalMatrix );

					plane.normal.toArray( dstArray, i4 );
					dstArray[ i4 + 3 ] = plane.constant;

				}

			}

			uniform.value = dstArray;
			uniform.needsUpdate = true;

		}

		scope.numPlanes = nPlanes;
		scope.numIntersection = 0;

		return dstArray;

	}

}

function WebGLCubeMaps( renderer ) {

	let cubemaps = new WeakMap();

	function mapTextureMapping( texture, mapping ) {

		if ( mapping === EquirectangularReflectionMapping ) {

			texture.mapping = CubeReflectionMapping;

		} else if ( mapping === EquirectangularRefractionMapping ) {

			texture.mapping = CubeRefractionMapping;

		}

		return texture;

	}

	function get( texture ) {

		if ( texture && texture.isTexture ) {

			const mapping = texture.mapping;

			if ( mapping === EquirectangularReflectionMapping || mapping === EquirectangularRefractionMapping ) {

				if ( cubemaps.has( texture ) ) {

					const cubemap = cubemaps.get( texture ).texture;
					return mapTextureMapping( cubemap, texture.mapping );

				} else {

					const image = texture.image;

					if ( image && image.height > 0 ) {

						const renderTarget = new WebGLCubeRenderTarget( image.height );
						renderTarget.fromEquirectangularTexture( renderer, texture );
						cubemaps.set( texture, renderTarget );

						texture.addEventListener( 'dispose', onTextureDispose );

						return mapTextureMapping( renderTarget.texture, texture.mapping );

					} else {

						// image not yet ready. try the conversion next frame

						return null;

					}

				}

			}

		}

		return texture;

	}

	function onTextureDispose( event ) {

		const texture = event.target;

		texture.removeEventListener( 'dispose', onTextureDispose );

		const cubemap = cubemaps.get( texture );

		if ( cubemap !== undefined ) {

			cubemaps.delete( texture );
			cubemap.dispose();

		}

	}

	function dispose() {

		cubemaps = new WeakMap();

	}

	return {
		get: get,
		dispose: dispose
	};

}

class OrthographicCamera extends Camera {

	constructor( left = - 1, right = 1, top = 1, bottom = - 1, near = 0.1, far = 2000 ) {

		super();

		this.isOrthographicCamera = true;

		this.type = 'OrthographicCamera';

		this.zoom = 1;
		this.view = null;

		this.left = left;
		this.right = right;
		this.top = top;
		this.bottom = bottom;

		this.near = near;
		this.far = far;

		this.updateProjectionMatrix();

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		this.left = source.left;
		this.right = source.right;
		this.top = source.top;
		this.bottom = source.bottom;
		this.near = source.near;
		this.far = source.far;

		this.zoom = source.zoom;
		this.view = source.view === null ? null : Object.assign( {}, source.view );

		return this;

	}

	setViewOffset( fullWidth, fullHeight, x, y, width, height ) {

		if ( this.view === null ) {

			this.view = {
				enabled: true,
				fullWidth: 1,
				fullHeight: 1,
				offsetX: 0,
				offsetY: 0,
				width: 1,
				height: 1
			};

		}

		this.view.enabled = true;
		this.view.fullWidth = fullWidth;
		this.view.fullHeight = fullHeight;
		this.view.offsetX = x;
		this.view.offsetY = y;
		this.view.width = width;
		this.view.height = height;

		this.updateProjectionMatrix();

	}

	clearViewOffset() {

		if ( this.view !== null ) {

			this.view.enabled = false;

		}

		this.updateProjectionMatrix();

	}

	updateProjectionMatrix() {

		const dx = ( this.right - this.left ) / ( 2 * this.zoom );
		const dy = ( this.top - this.bottom ) / ( 2 * this.zoom );
		const cx = ( this.right + this.left ) / 2;
		const cy = ( this.top + this.bottom ) / 2;

		let left = cx - dx;
		let right = cx + dx;
		let top = cy + dy;
		let bottom = cy - dy;

		if ( this.view !== null && this.view.enabled ) {

			const scaleW = ( this.right - this.left ) / this.view.fullWidth / this.zoom;
			const scaleH = ( this.top - this.bottom ) / this.view.fullHeight / this.zoom;

			left += scaleW * this.view.offsetX;
			right = left + scaleW * this.view.width;
			top -= scaleH * this.view.offsetY;
			bottom = top - scaleH * this.view.height;

		}

		this.projectionMatrix.makeOrthographic( left, right, top, bottom, this.near, this.far, this.coordinateSystem );

		this.projectionMatrixInverse.copy( this.projectionMatrix ).invert();

	}

	toJSON( meta ) {

		const data = super.toJSON( meta );

		data.object.zoom = this.zoom;
		data.object.left = this.left;
		data.object.right = this.right;
		data.object.top = this.top;
		data.object.bottom = this.bottom;
		data.object.near = this.near;
		data.object.far = this.far;

		if ( this.view !== null ) data.object.view = Object.assign( {}, this.view );

		return data;

	}

}

const LOD_MIN = 4;

// The standard deviations (radians) associated with the extra mips. These are
// chosen to approximate a Trowbridge-Reitz distribution function times the
// geometric shadowing function. These sigma values squared must match the
// variance #defines in cube_uv_reflection_fragment.glsl.js.
const EXTRA_LOD_SIGMA = (/* unused pure expression or super */ null && ([ 0.125, 0.215, 0.35, 0.446, 0.526, 0.582 ]));

// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
const MAX_SAMPLES = 20;

const _flatCamera = /*@__PURE__*/ new OrthographicCamera();
const _clearColor = /*@__PURE__*/ new Color();
let _oldTarget = null;
let _oldActiveCubeFace = 0;
let _oldActiveMipmapLevel = 0;
let _oldXrEnabled = false;

// Golden Ratio
const PHI = ( 1 + Math.sqrt( 5 ) ) / 2;
const INV_PHI = 1 / PHI;

// Vertices of a dodecahedron (except the opposites, which represent the
// same axis), used as axis directions evenly spread on a sphere.
const _axisDirections = [
	/*@__PURE__*/ new Vector3( 1, 1, 1 ),
	/*@__PURE__*/ new Vector3( - 1, 1, 1 ),
	/*@__PURE__*/ new Vector3( 1, 1, - 1 ),
	/*@__PURE__*/ new Vector3( - 1, 1, - 1 ),
	/*@__PURE__*/ new Vector3( 0, PHI, INV_PHI ),
	/*@__PURE__*/ new Vector3( 0, PHI, - INV_PHI ),
	/*@__PURE__*/ new Vector3( INV_PHI, 0, PHI ),
	/*@__PURE__*/ new Vector3( - INV_PHI, 0, PHI ),
	/*@__PURE__*/ new Vector3( PHI, INV_PHI, 0 ),
	/*@__PURE__*/ new Vector3( - PHI, INV_PHI, 0 ) ];

/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * Paper: Fast, Accurate Image-Based Lighting
 * https://drive.google.com/file/d/15y8r_UpKlU9SvV4ILb0C3qCPecS8pvLz/view
*/

class PMREMGenerator {

	constructor( renderer ) {

		this._renderer = renderer;
		this._pingPongRenderTarget = null;

		this._lodMax = 0;
		this._cubeSize = 0;
		this._lodPlanes = [];
		this._sizeLods = [];
		this._sigmas = [];

		this._blurMaterial = null;
		this._cubemapMaterial = null;
		this._equirectMaterial = null;

		this._compileMaterial( this._blurMaterial );

	}

	/**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety (the cubeCamera
	 * is placed at the origin).
	 */
	fromScene( scene, sigma = 0, near = 0.1, far = 100 ) {

		_oldTarget = this._renderer.getRenderTarget();
		_oldActiveCubeFace = this._renderer.getActiveCubeFace();
		_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
		_oldXrEnabled = this._renderer.xr.enabled;

		this._renderer.xr.enabled = false;

		this._setSize( 256 );

		const cubeUVRenderTarget = this._allocateTargets();
		cubeUVRenderTarget.depthBuffer = true;

		this._sceneToCubeUV( scene, near, far, cubeUVRenderTarget );

		if ( sigma > 0 ) {

			this._blur( cubeUVRenderTarget, 0, 0, sigma );

		}

		this._applyPMREM( cubeUVRenderTarget );
		this._cleanup( cubeUVRenderTarget );

		return cubeUVRenderTarget;

	}

	/**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * or HDR. The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 * The smallest supported equirectangular image size is 64 x 32.
	 */
	fromEquirectangular( equirectangular, renderTarget = null ) {

		return this._fromTexture( equirectangular, renderTarget );

	}

	/**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * or HDR. The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 * The smallest supported cube size is 16 x 16.
	 */
	fromCubemap( cubemap, renderTarget = null ) {

		return this._fromTexture( cubemap, renderTarget );

	}

	/**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */
	compileCubemapShader() {

		if ( this._cubemapMaterial === null ) {

			this._cubemapMaterial = _getCubemapMaterial();
			this._compileMaterial( this._cubemapMaterial );

		}

	}

	/**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */
	compileEquirectangularShader() {

		if ( this._equirectMaterial === null ) {

			this._equirectMaterial = _getEquirectMaterial();
			this._compileMaterial( this._equirectMaterial );

		}

	}

	/**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */
	dispose() {

		this._dispose();

		if ( this._cubemapMaterial !== null ) this._cubemapMaterial.dispose();
		if ( this._equirectMaterial !== null ) this._equirectMaterial.dispose();

	}

	// private interface

	_setSize( cubeSize ) {

		this._lodMax = Math.floor( Math.log2( cubeSize ) );
		this._cubeSize = Math.pow( 2, this._lodMax );

	}

	_dispose() {

		if ( this._blurMaterial !== null ) this._blurMaterial.dispose();

		if ( this._pingPongRenderTarget !== null ) this._pingPongRenderTarget.dispose();

		for ( let i = 0; i < this._lodPlanes.length; i ++ ) {

			this._lodPlanes[ i ].dispose();

		}

	}

	_cleanup( outputTarget ) {

		this._renderer.setRenderTarget( _oldTarget, _oldActiveCubeFace, _oldActiveMipmapLevel );
		this._renderer.xr.enabled = _oldXrEnabled;

		outputTarget.scissorTest = false;
		_setViewport( outputTarget, 0, 0, outputTarget.width, outputTarget.height );

	}

	_fromTexture( texture, renderTarget ) {

		if ( texture.mapping === CubeReflectionMapping || texture.mapping === CubeRefractionMapping ) {

			this._setSize( texture.image.length === 0 ? 16 : ( texture.image[ 0 ].width || texture.image[ 0 ].image.width ) );

		} else { // Equirectangular

			this._setSize( texture.image.width / 4 );

		}

		_oldTarget = this._renderer.getRenderTarget();
		_oldActiveCubeFace = this._renderer.getActiveCubeFace();
		_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
		_oldXrEnabled = this._renderer.xr.enabled;

		this._renderer.xr.enabled = false;

		const cubeUVRenderTarget = renderTarget || this._allocateTargets();
		this._textureToCubeUV( texture, cubeUVRenderTarget );
		this._applyPMREM( cubeUVRenderTarget );
		this._cleanup( cubeUVRenderTarget );

		return cubeUVRenderTarget;

	}

	_allocateTargets() {

		const width = 3 * Math.max( this._cubeSize, 16 * 7 );
		const height = 4 * this._cubeSize;

		const params = {
			magFilter: LinearFilter,
			minFilter: LinearFilter,
			generateMipmaps: false,
			type: HalfFloatType,
			format: RGBAFormat,
			colorSpace: LinearSRGBColorSpace,
			depthBuffer: false
		};

		const cubeUVRenderTarget = _createRenderTarget( width, height, params );

		if ( this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== width || this._pingPongRenderTarget.height !== height ) {

			if ( this._pingPongRenderTarget !== null ) {

				this._dispose();

			}

			this._pingPongRenderTarget = _createRenderTarget( width, height, params );

			const { _lodMax } = this;
			( { sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = _createPlanes( _lodMax ) );

			this._blurMaterial = _getBlurShader( _lodMax, width, height );

		}

		return cubeUVRenderTarget;

	}

	_compileMaterial( material ) {

		const tmpMesh = new Mesh( this._lodPlanes[ 0 ], material );
		this._renderer.compile( tmpMesh, _flatCamera );

	}

	_sceneToCubeUV( scene, near, far, cubeUVRenderTarget ) {

		const fov = 90;
		const aspect = 1;
		const cubeCamera = new PerspectiveCamera( fov, aspect, near, far );
		const upSign = [ 1, - 1, 1, 1, 1, 1 ];
		const forwardSign = [ 1, 1, 1, - 1, - 1, - 1 ];
		const renderer = this._renderer;

		const originalAutoClear = renderer.autoClear;
		const toneMapping = renderer.toneMapping;
		renderer.getClearColor( _clearColor );

		renderer.toneMapping = NoToneMapping;
		renderer.autoClear = false;

		const backgroundMaterial = new MeshBasicMaterial( {
			name: 'PMREM.Background',
			side: BackSide,
			depthWrite: false,
			depthTest: false,
		} );

		const backgroundBox = new Mesh( new BoxGeometry(), backgroundMaterial );

		let useSolidColor = false;
		const background = scene.background;

		if ( background ) {

			if ( background.isColor ) {

				backgroundMaterial.color.copy( background );
				scene.background = null;
				useSolidColor = true;

			}

		} else {

			backgroundMaterial.color.copy( _clearColor );
			useSolidColor = true;

		}

		for ( let i = 0; i < 6; i ++ ) {

			const col = i % 3;

			if ( col === 0 ) {

				cubeCamera.up.set( 0, upSign[ i ], 0 );
				cubeCamera.lookAt( forwardSign[ i ], 0, 0 );

			} else if ( col === 1 ) {

				cubeCamera.up.set( 0, 0, upSign[ i ] );
				cubeCamera.lookAt( 0, forwardSign[ i ], 0 );

			} else {

				cubeCamera.up.set( 0, upSign[ i ], 0 );
				cubeCamera.lookAt( 0, 0, forwardSign[ i ] );

			}

			const size = this._cubeSize;

			_setViewport( cubeUVRenderTarget, col * size, i > 2 ? size : 0, size, size );

			renderer.setRenderTarget( cubeUVRenderTarget );

			if ( useSolidColor ) {

				renderer.render( backgroundBox, cubeCamera );

			}

			renderer.render( scene, cubeCamera );

		}

		backgroundBox.geometry.dispose();
		backgroundBox.material.dispose();

		renderer.toneMapping = toneMapping;
		renderer.autoClear = originalAutoClear;
		scene.background = background;

	}

	_textureToCubeUV( texture, cubeUVRenderTarget ) {

		const renderer = this._renderer;

		const isCubeTexture = ( texture.mapping === CubeReflectionMapping || texture.mapping === CubeRefractionMapping );

		if ( isCubeTexture ) {

			if ( this._cubemapMaterial === null ) {

				this._cubemapMaterial = _getCubemapMaterial();

			}

			this._cubemapMaterial.uniforms.flipEnvMap.value = ( texture.isRenderTargetTexture === false ) ? - 1 : 1;

		} else {

			if ( this._equirectMaterial === null ) {

				this._equirectMaterial = _getEquirectMaterial();

			}

		}

		const material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
		const mesh = new Mesh( this._lodPlanes[ 0 ], material );

		const uniforms = material.uniforms;

		uniforms[ 'envMap' ].value = texture;

		const size = this._cubeSize;

		_setViewport( cubeUVRenderTarget, 0, 0, 3 * size, 2 * size );

		renderer.setRenderTarget( cubeUVRenderTarget );
		renderer.render( mesh, _flatCamera );

	}

	_applyPMREM( cubeUVRenderTarget ) {

		const renderer = this._renderer;
		const autoClear = renderer.autoClear;
		renderer.autoClear = false;

		for ( let i = 1; i < this._lodPlanes.length; i ++ ) {

			const sigma = Math.sqrt( this._sigmas[ i ] * this._sigmas[ i ] - this._sigmas[ i - 1 ] * this._sigmas[ i - 1 ] );

			const poleAxis = _axisDirections[ ( i - 1 ) % _axisDirections.length ];

			this._blur( cubeUVRenderTarget, i - 1, i, sigma, poleAxis );

		}

		renderer.autoClear = autoClear;

	}

	/**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 */
	_blur( cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis ) {

		const pingPongRenderTarget = this._pingPongRenderTarget;

		this._halfBlur(
			cubeUVRenderTarget,
			pingPongRenderTarget,
			lodIn,
			lodOut,
			sigma,
			'latitudinal',
			poleAxis );

		this._halfBlur(
			pingPongRenderTarget,
			cubeUVRenderTarget,
			lodOut,
			lodOut,
			sigma,
			'longitudinal',
			poleAxis );

	}

	_halfBlur( targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis ) {

		const renderer = this._renderer;
		const blurMaterial = this._blurMaterial;

		if ( direction !== 'latitudinal' && direction !== 'longitudinal' ) {

			console.error(
				'blur direction must be either latitudinal or longitudinal!' );

		}

		// Number of standard deviations at which to cut off the discrete approximation.
		const STANDARD_DEVIATIONS = 3;

		const blurMesh = new Mesh( this._lodPlanes[ lodOut ], blurMaterial );
		const blurUniforms = blurMaterial.uniforms;

		const pixels = this._sizeLods[ lodIn ] - 1;
		const radiansPerPixel = isFinite( sigmaRadians ) ? Math.PI / ( 2 * pixels ) : 2 * Math.PI / ( 2 * MAX_SAMPLES - 1 );
		const sigmaPixels = sigmaRadians / radiansPerPixel;
		const samples = isFinite( sigmaRadians ) ? 1 + Math.floor( STANDARD_DEVIATIONS * sigmaPixels ) : MAX_SAMPLES;

		if ( samples > MAX_SAMPLES ) {

			console.warn( `sigmaRadians, ${
				sigmaRadians}, is too large and will clip, as it requested ${
				samples} samples when the maximum is set to ${MAX_SAMPLES}` );

		}

		const weights = [];
		let sum = 0;

		for ( let i = 0; i < MAX_SAMPLES; ++ i ) {

			const x = i / sigmaPixels;
			const weight = Math.exp( - x * x / 2 );
			weights.push( weight );

			if ( i === 0 ) {

				sum += weight;

			} else if ( i < samples ) {

				sum += 2 * weight;

			}

		}

		for ( let i = 0; i < weights.length; i ++ ) {

			weights[ i ] = weights[ i ] / sum;

		}

		blurUniforms[ 'envMap' ].value = targetIn.texture;
		blurUniforms[ 'samples' ].value = samples;
		blurUniforms[ 'weights' ].value = weights;
		blurUniforms[ 'latitudinal' ].value = direction === 'latitudinal';

		if ( poleAxis ) {

			blurUniforms[ 'poleAxis' ].value = poleAxis;

		}

		const { _lodMax } = this;
		blurUniforms[ 'dTheta' ].value = radiansPerPixel;
		blurUniforms[ 'mipInt' ].value = _lodMax - lodIn;

		const outputSize = this._sizeLods[ lodOut ];
		const x = 3 * outputSize * ( lodOut > _lodMax - LOD_MIN ? lodOut - _lodMax + LOD_MIN : 0 );
		const y = 4 * ( this._cubeSize - outputSize );

		_setViewport( targetOut, x, y, 3 * outputSize, 2 * outputSize );
		renderer.setRenderTarget( targetOut );
		renderer.render( blurMesh, _flatCamera );

	}

}



function _createPlanes( lodMax ) {

	const lodPlanes = [];
	const sizeLods = [];
	const sigmas = [];

	let lod = lodMax;

	const totalLods = lodMax - LOD_MIN + 1 + EXTRA_LOD_SIGMA.length;

	for ( let i = 0; i < totalLods; i ++ ) {

		const sizeLod = Math.pow( 2, lod );
		sizeLods.push( sizeLod );
		let sigma = 1.0 / sizeLod;

		if ( i > lodMax - LOD_MIN ) {

			sigma = EXTRA_LOD_SIGMA[ i - lodMax + LOD_MIN - 1 ];

		} else if ( i === 0 ) {

			sigma = 0;

		}

		sigmas.push( sigma );

		const texelSize = 1.0 / ( sizeLod - 2 );
		const min = - texelSize;
		const max = 1 + texelSize;
		const uv1 = [ min, min, max, min, max, max, min, min, max, max, min, max ];

		const cubeFaces = 6;
		const vertices = 6;
		const positionSize = 3;
		const uvSize = 2;
		const faceIndexSize = 1;

		const position = new Float32Array( positionSize * vertices * cubeFaces );
		const uv = new Float32Array( uvSize * vertices * cubeFaces );
		const faceIndex = new Float32Array( faceIndexSize * vertices * cubeFaces );

		for ( let face = 0; face < cubeFaces; face ++ ) {

			const x = ( face % 3 ) * 2 / 3 - 1;
			const y = face > 2 ? 0 : - 1;
			const coordinates = [
				x, y, 0,
				x + 2 / 3, y, 0,
				x + 2 / 3, y + 1, 0,
				x, y, 0,
				x + 2 / 3, y + 1, 0,
				x, y + 1, 0
			];
			position.set( coordinates, positionSize * vertices * face );
			uv.set( uv1, uvSize * vertices * face );
			const fill = [ face, face, face, face, face, face ];
			faceIndex.set( fill, faceIndexSize * vertices * face );

		}

		const planes = new BufferGeometry();
		planes.setAttribute( 'position', new BufferAttribute( position, positionSize ) );
		planes.setAttribute( 'uv', new BufferAttribute( uv, uvSize ) );
		planes.setAttribute( 'faceIndex', new BufferAttribute( faceIndex, faceIndexSize ) );
		lodPlanes.push( planes );

		if ( lod > LOD_MIN ) {

			lod --;

		}

	}

	return { lodPlanes, sizeLods, sigmas };

}

function _createRenderTarget( width, height, params ) {

	const cubeUVRenderTarget = new WebGLRenderTarget( width, height, params );
	cubeUVRenderTarget.texture.mapping = CubeUVReflectionMapping;
	cubeUVRenderTarget.texture.name = 'PMREM.cubeUv';
	cubeUVRenderTarget.scissorTest = true;
	return cubeUVRenderTarget;

}

function _setViewport( target, x, y, width, height ) {

	target.viewport.set( x, y, width, height );
	target.scissor.set( x, y, width, height );

}

function _getBlurShader( lodMax, width, height ) {

	const weights = new Float32Array( MAX_SAMPLES );
	const poleAxis = new Vector3( 0, 1, 0 );
	const shaderMaterial = new ShaderMaterial( {

		name: 'SphericalGaussianBlur',

		defines: {
			'n': MAX_SAMPLES,
			'CUBEUV_TEXEL_WIDTH': 1.0 / width,
			'CUBEUV_TEXEL_HEIGHT': 1.0 / height,
			'CUBEUV_MAX_MIP': `${lodMax}.0`,
		},

		uniforms: {
			'envMap': { value: null },
			'samples': { value: 1 },
			'weights': { value: weights },
			'latitudinal': { value: false },
			'dTheta': { value: 0 },
			'mipInt': { value: 0 },
			'poleAxis': { value: poleAxis }
		},

		vertexShader: _getCommonVertexShader(),

		fragmentShader: /* glsl */`

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,

		blending: NoBlending,
		depthTest: false,
		depthWrite: false

	} );

	return shaderMaterial;

}

function _getEquirectMaterial() {

	return new ShaderMaterial( {

		name: 'EquirectangularToCubeUV',

		uniforms: {
			'envMap': { value: null }
		},

		vertexShader: _getCommonVertexShader(),

		fragmentShader: /* glsl */`

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,

		blending: NoBlending,
		depthTest: false,
		depthWrite: false

	} );

}

function _getCubemapMaterial() {

	return new ShaderMaterial( {

		name: 'CubemapToCubeUV',

		uniforms: {
			'envMap': { value: null },
			'flipEnvMap': { value: - 1 }
		},

		vertexShader: _getCommonVertexShader(),

		fragmentShader: /* glsl */`

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,

		blending: NoBlending,
		depthTest: false,
		depthWrite: false

	} );

}

function _getCommonVertexShader() {

	return /* glsl */`

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;

}

function WebGLCubeUVMaps( renderer ) {

	let cubeUVmaps = new WeakMap();

	let pmremGenerator = null;

	function get( texture ) {

		if ( texture && texture.isTexture ) {

			const mapping = texture.mapping;

			const isEquirectMap = ( mapping === EquirectangularReflectionMapping || mapping === EquirectangularRefractionMapping );
			const isCubeMap = ( mapping === CubeReflectionMapping || mapping === CubeRefractionMapping );

			// equirect/cube map to cubeUV conversion

			if ( isEquirectMap || isCubeMap ) {

				let renderTarget = cubeUVmaps.get( texture );

				const currentPMREMVersion = renderTarget !== undefined ? renderTarget.texture.pmremVersion : 0;

				if ( texture.isRenderTargetTexture && texture.pmremVersion !== currentPMREMVersion ) {

					if ( pmremGenerator === null ) pmremGenerator = new PMREMGenerator( renderer );

					renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular( texture, renderTarget ) : pmremGenerator.fromCubemap( texture, renderTarget );
					renderTarget.texture.pmremVersion = texture.pmremVersion;

					cubeUVmaps.set( texture, renderTarget );

					return renderTarget.texture;

				} else {

					if ( renderTarget !== undefined ) {

						return renderTarget.texture;

					} else {

						const image = texture.image;

						if ( ( isEquirectMap && image && image.height > 0 ) || ( isCubeMap && image && isCubeTextureComplete( image ) ) ) {

							if ( pmremGenerator === null ) pmremGenerator = new PMREMGenerator( renderer );

							renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular( texture ) : pmremGenerator.fromCubemap( texture );
							renderTarget.texture.pmremVersion = texture.pmremVersion;

							cubeUVmaps.set( texture, renderTarget );

							texture.addEventListener( 'dispose', onTextureDispose );

							return renderTarget.texture;

						} else {

							// image not yet ready. try the conversion next frame

							return null;

						}

					}

				}

			}

		}

		return texture;

	}

	function isCubeTextureComplete( image ) {

		let count = 0;
		const length = 6;

		for ( let i = 0; i < length; i ++ ) {

			if ( image[ i ] !== undefined ) count ++;

		}

		return count === length;


	}

	function onTextureDispose( event ) {

		const texture = event.target;

		texture.removeEventListener( 'dispose', onTextureDispose );

		const cubemapUV = cubeUVmaps.get( texture );

		if ( cubemapUV !== undefined ) {

			cubeUVmaps.delete( texture );
			cubemapUV.dispose();

		}

	}

	function dispose() {

		cubeUVmaps = new WeakMap();

		if ( pmremGenerator !== null ) {

			pmremGenerator.dispose();
			pmremGenerator = null;

		}

	}

	return {
		get: get,
		dispose: dispose
	};

}

function WebGLExtensions( gl ) {

	const extensions = {};

	function getExtension( name ) {

		if ( extensions[ name ] !== undefined ) {

			return extensions[ name ];

		}

		let extension;

		switch ( name ) {

			case 'WEBGL_depth_texture':
				extension = gl.getExtension( 'WEBGL_depth_texture' ) || gl.getExtension( 'MOZ_WEBGL_depth_texture' ) || gl.getExtension( 'WEBKIT_WEBGL_depth_texture' );
				break;

			case 'EXT_texture_filter_anisotropic':
				extension = gl.getExtension( 'EXT_texture_filter_anisotropic' ) || gl.getExtension( 'MOZ_EXT_texture_filter_anisotropic' ) || gl.getExtension( 'WEBKIT_EXT_texture_filter_anisotropic' );
				break;

			case 'WEBGL_compressed_texture_s3tc':
				extension = gl.getExtension( 'WEBGL_compressed_texture_s3tc' ) || gl.getExtension( 'MOZ_WEBGL_compressed_texture_s3tc' ) || gl.getExtension( 'WEBKIT_WEBGL_compressed_texture_s3tc' );
				break;

			case 'WEBGL_compressed_texture_pvrtc':
				extension = gl.getExtension( 'WEBGL_compressed_texture_pvrtc' ) || gl.getExtension( 'WEBKIT_WEBGL_compressed_texture_pvrtc' );
				break;

			default:
				extension = gl.getExtension( name );

		}

		extensions[ name ] = extension;

		return extension;

	}

	return {

		has: function ( name ) {

			return getExtension( name ) !== null;

		},

		init: function () {

			getExtension( 'EXT_color_buffer_float' );
			getExtension( 'WEBGL_clip_cull_distance' );
			getExtension( 'OES_texture_float_linear' );
			getExtension( 'EXT_color_buffer_half_float' );
			getExtension( 'WEBGL_multisampled_render_to_texture' );
			getExtension( 'WEBGL_render_shared_exponent' );

		},

		get: function ( name ) {

			const extension = getExtension( name );

			if ( extension === null ) {

				console.warn( 'THREE.WebGLRenderer: ' + name + ' extension not supported.' );

			}

			return extension;

		}

	};

}

function WebGLGeometries( gl, attributes, info, bindingStates ) {

	const geometries = {};
	const wireframeAttributes = new WeakMap();

	function onGeometryDispose( event ) {

		const geometry = event.target;

		if ( geometry.index !== null ) {

			attributes.remove( geometry.index );

		}

		for ( const name in geometry.attributes ) {

			attributes.remove( geometry.attributes[ name ] );

		}

		for ( const name in geometry.morphAttributes ) {

			const array = geometry.morphAttributes[ name ];

			for ( let i = 0, l = array.length; i < l; i ++ ) {

				attributes.remove( array[ i ] );

			}

		}

		geometry.removeEventListener( 'dispose', onGeometryDispose );

		delete geometries[ geometry.id ];

		const attribute = wireframeAttributes.get( geometry );

		if ( attribute ) {

			attributes.remove( attribute );
			wireframeAttributes.delete( geometry );

		}

		bindingStates.releaseStatesOfGeometry( geometry );

		if ( geometry.isInstancedBufferGeometry === true ) {

			delete geometry._maxInstanceCount;

		}

		//

		info.memory.geometries --;

	}

	function get( object, geometry ) {

		if ( geometries[ geometry.id ] === true ) return geometry;

		geometry.addEventListener( 'dispose', onGeometryDispose );

		geometries[ geometry.id ] = true;

		info.memory.geometries ++;

		return geometry;

	}

	function update( geometry ) {

		const geometryAttributes = geometry.attributes;

		// Updating index buffer in VAO now. See WebGLBindingStates.

		for ( const name in geometryAttributes ) {

			attributes.update( geometryAttributes[ name ], gl.ARRAY_BUFFER );

		}

		// morph targets

		const morphAttributes = geometry.morphAttributes;

		for ( const name in morphAttributes ) {

			const array = morphAttributes[ name ];

			for ( let i = 0, l = array.length; i < l; i ++ ) {

				attributes.update( array[ i ], gl.ARRAY_BUFFER );

			}

		}

	}

	function updateWireframeAttribute( geometry ) {

		const indices = [];

		const geometryIndex = geometry.index;
		const geometryPosition = geometry.attributes.position;
		let version = 0;

		if ( geometryIndex !== null ) {

			const array = geometryIndex.array;
			version = geometryIndex.version;

			for ( let i = 0, l = array.length; i < l; i += 3 ) {

				const a = array[ i + 0 ];
				const b = array[ i + 1 ];
				const c = array[ i + 2 ];

				indices.push( a, b, b, c, c, a );

			}

		} else if ( geometryPosition !== undefined ) {

			const array = geometryPosition.array;
			version = geometryPosition.version;

			for ( let i = 0, l = ( array.length / 3 ) - 1; i < l; i += 3 ) {

				const a = i + 0;
				const b = i + 1;
				const c = i + 2;

				indices.push( a, b, b, c, c, a );

			}

		} else {

			return;

		}

		const attribute = new ( arrayNeedsUint32( indices ) ? Uint32BufferAttribute : Uint16BufferAttribute )( indices, 1 );
		attribute.version = version;

		// Updating index buffer in VAO now. See WebGLBindingStates

		//

		const previousAttribute = wireframeAttributes.get( geometry );

		if ( previousAttribute ) attributes.remove( previousAttribute );

		//

		wireframeAttributes.set( geometry, attribute );

	}

	function getWireframeAttribute( geometry ) {

		const currentAttribute = wireframeAttributes.get( geometry );

		if ( currentAttribute ) {

			const geometryIndex = geometry.index;

			if ( geometryIndex !== null ) {

				// if the attribute is obsolete, create a new one

				if ( currentAttribute.version < geometryIndex.version ) {

					updateWireframeAttribute( geometry );

				}

			}

		} else {

			updateWireframeAttribute( geometry );

		}

		return wireframeAttributes.get( geometry );

	}

	return {

		get: get,
		update: update,

		getWireframeAttribute: getWireframeAttribute

	};

}

function WebGLIndexedBufferRenderer( gl, extensions, info ) {

	let mode;

	function setMode( value ) {

		mode = value;

	}

	let type, bytesPerElement;

	function setIndex( value ) {

		type = value.type;
		bytesPerElement = value.bytesPerElement;

	}

	function render( start, count ) {

		gl.drawElements( mode, count, type, start * bytesPerElement );

		info.update( count, mode, 1 );

	}

	function renderInstances( start, count, primcount ) {

		if ( primcount === 0 ) return;

		gl.drawElementsInstanced( mode, count, type, start * bytesPerElement, primcount );

		info.update( count, mode, primcount );

	}

	function renderMultiDraw( starts, counts, drawCount ) {

		if ( drawCount === 0 ) return;

		const extension = extensions.get( 'WEBGL_multi_draw' );

		if ( extension === null ) {

			for ( let i = 0; i < drawCount; i ++ ) {

				this.render( starts[ i ] / bytesPerElement, counts[ i ] );

			}

		} else {

			extension.multiDrawElementsWEBGL( mode, counts, 0, type, starts, 0, drawCount );

			let elementCount = 0;
			for ( let i = 0; i < drawCount; i ++ ) {

				elementCount += counts[ i ];

			}

			info.update( elementCount, mode, 1 );

		}

	}

	//

	this.setMode = setMode;
	this.setIndex = setIndex;
	this.render = render;
	this.renderInstances = renderInstances;
	this.renderMultiDraw = renderMultiDraw;

}

function WebGLInfo( gl ) {

	const memory = {
		geometries: 0,
		textures: 0
	};

	const render = {
		frame: 0,
		calls: 0,
		triangles: 0,
		points: 0,
		lines: 0
	};

	function update( count, mode, instanceCount ) {

		render.calls ++;

		switch ( mode ) {

			case gl.TRIANGLES:
				render.triangles += instanceCount * ( count / 3 );
				break;

			case gl.LINES:
				render.lines += instanceCount * ( count / 2 );
				break;

			case gl.LINE_STRIP:
				render.lines += instanceCount * ( count - 1 );
				break;

			case gl.LINE_LOOP:
				render.lines += instanceCount * count;
				break;

			case gl.POINTS:
				render.points += instanceCount * count;
				break;

			default:
				console.error( 'THREE.WebGLInfo: Unknown draw mode:', mode );
				break;

		}

	}

	function reset() {

		render.calls = 0;
		render.triangles = 0;
		render.points = 0;
		render.lines = 0;

	}

	return {
		memory: memory,
		render: render,
		programs: null,
		autoReset: true,
		reset: reset,
		update: update
	};

}

function WebGLMorphtargets( gl, capabilities, textures ) {

	const morphTextures = new WeakMap();
	const morph = new Vector4();

	function update( object, geometry, program ) {

		const objectInfluences = object.morphTargetInfluences;

		// instead of using attributes, the WebGL 2 code path encodes morph targets
		// into an array of data textures. Each layer represents a single morph target.

		const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
		const morphTargetsCount = ( morphAttribute !== undefined ) ? morphAttribute.length : 0;

		let entry = morphTextures.get( geometry );

		if ( entry === undefined || entry.count !== morphTargetsCount ) {

			if ( entry !== undefined ) entry.texture.dispose();

			const hasMorphPosition = geometry.morphAttributes.position !== undefined;
			const hasMorphNormals = geometry.morphAttributes.normal !== undefined;
			const hasMorphColors = geometry.morphAttributes.color !== undefined;

			const morphTargets = geometry.morphAttributes.position || [];
			const morphNormals = geometry.morphAttributes.normal || [];
			const morphColors = geometry.morphAttributes.color || [];

			let vertexDataCount = 0;

			if ( hasMorphPosition === true ) vertexDataCount = 1;
			if ( hasMorphNormals === true ) vertexDataCount = 2;
			if ( hasMorphColors === true ) vertexDataCount = 3;

			let width = geometry.attributes.position.count * vertexDataCount;
			let height = 1;

			if ( width > capabilities.maxTextureSize ) {

				height = Math.ceil( width / capabilities.maxTextureSize );
				width = capabilities.maxTextureSize;

			}

			const buffer = new Float32Array( width * height * 4 * morphTargetsCount );

			const texture = new DataArrayTexture( buffer, width, height, morphTargetsCount );
			texture.type = FloatType;
			texture.needsUpdate = true;

			// fill buffer

			const vertexDataStride = vertexDataCount * 4;

			for ( let i = 0; i < morphTargetsCount; i ++ ) {

				const morphTarget = morphTargets[ i ];
				const morphNormal = morphNormals[ i ];
				const morphColor = morphColors[ i ];

				const offset = width * height * 4 * i;

				for ( let j = 0; j < morphTarget.count; j ++ ) {

					const stride = j * vertexDataStride;

					if ( hasMorphPosition === true ) {

						morph.fromBufferAttribute( morphTarget, j );

						buffer[ offset + stride + 0 ] = morph.x;
						buffer[ offset + stride + 1 ] = morph.y;
						buffer[ offset + stride + 2 ] = morph.z;
						buffer[ offset + stride + 3 ] = 0;

					}

					if ( hasMorphNormals === true ) {

						morph.fromBufferAttribute( morphNormal, j );

						buffer[ offset + stride + 4 ] = morph.x;
						buffer[ offset + stride + 5 ] = morph.y;
						buffer[ offset + stride + 6 ] = morph.z;
						buffer[ offset + stride + 7 ] = 0;

					}

					if ( hasMorphColors === true ) {

						morph.fromBufferAttribute( morphColor, j );

						buffer[ offset + stride + 8 ] = morph.x;
						buffer[ offset + stride + 9 ] = morph.y;
						buffer[ offset + stride + 10 ] = morph.z;
						buffer[ offset + stride + 11 ] = ( morphColor.itemSize === 4 ) ? morph.w : 1;

					}

				}

			}

			entry = {
				count: morphTargetsCount,
				texture: texture,
				size: new Vector2( width, height )
			};

			morphTextures.set( geometry, entry );

			function disposeTexture() {

				texture.dispose();

				morphTextures.delete( geometry );

				geometry.removeEventListener( 'dispose', disposeTexture );

			}

			geometry.addEventListener( 'dispose', disposeTexture );

		}

		//
		if ( object.isInstancedMesh === true && object.morphTexture !== null ) {

			program.getUniforms().setValue( gl, 'morphTexture', object.morphTexture, textures );

		} else {

			let morphInfluencesSum = 0;

			for ( let i = 0; i < objectInfluences.length; i ++ ) {

				morphInfluencesSum += objectInfluences[ i ];

			}

			const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;


			program.getUniforms().setValue( gl, 'morphTargetBaseInfluence', morphBaseInfluence );
			program.getUniforms().setValue( gl, 'morphTargetInfluences', objectInfluences );

		}

		program.getUniforms().setValue( gl, 'morphTargetsTexture', entry.texture, textures );
		program.getUniforms().setValue( gl, 'morphTargetsTextureSize', entry.size );

	}

	return {

		update: update

	};

}

function WebGLObjects( gl, geometries, attributes, info ) {

	let updateMap = new WeakMap();

	function update( object ) {

		const frame = info.render.frame;

		const geometry = object.geometry;
		const buffergeometry = geometries.get( object, geometry );

		// Update once per frame

		if ( updateMap.get( buffergeometry ) !== frame ) {

			geometries.update( buffergeometry );

			updateMap.set( buffergeometry, frame );

		}

		if ( object.isInstancedMesh ) {

			if ( object.hasEventListener( 'dispose', onInstancedMeshDispose ) === false ) {

				object.addEventListener( 'dispose', onInstancedMeshDispose );

			}

			if ( updateMap.get( object ) !== frame ) {

				attributes.update( object.instanceMatrix, gl.ARRAY_BUFFER );

				if ( object.instanceColor !== null ) {

					attributes.update( object.instanceColor, gl.ARRAY_BUFFER );

				}

				updateMap.set( object, frame );

			}

		}

		if ( object.isSkinnedMesh ) {

			const skeleton = object.skeleton;

			if ( updateMap.get( skeleton ) !== frame ) {

				skeleton.update();

				updateMap.set( skeleton, frame );

			}

		}

		return buffergeometry;

	}

	function dispose() {

		updateMap = new WeakMap();

	}

	function onInstancedMeshDispose( event ) {

		const instancedMesh = event.target;

		instancedMesh.removeEventListener( 'dispose', onInstancedMeshDispose );

		attributes.remove( instancedMesh.instanceMatrix );

		if ( instancedMesh.instanceColor !== null ) attributes.remove( instancedMesh.instanceColor );

	}

	return {

		update: update,
		dispose: dispose

	};

}

class DepthTexture extends Texture {

	constructor( width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format ) {

		format = format !== undefined ? format : DepthFormat;

		if ( format !== DepthFormat && format !== DepthStencilFormat ) {

			throw new Error( 'DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat' );

		}

		if ( type === undefined && format === DepthFormat ) type = UnsignedIntType;
		if ( type === undefined && format === DepthStencilFormat ) type = UnsignedInt248Type;

		super( null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy );

		this.isDepthTexture = true;

		this.image = { width: width, height: height };

		this.magFilter = magFilter !== undefined ? magFilter : NearestFilter;
		this.minFilter = minFilter !== undefined ? minFilter : NearestFilter;

		this.flipY = false;
		this.generateMipmaps = false;

		this.compareFunction = null;

	}


	copy( source ) {

		super.copy( source );

		this.compareFunction = source.compareFunction;

		return this;

	}

	toJSON( meta ) {

		const data = super.toJSON( meta );

		if ( this.compareFunction !== null ) data.compareFunction = this.compareFunction;

		return data;

	}

}

/**
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [textures] )
 *
 * 		uploads a uniform value(s)
 *  	the 'textures' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (textures factorizations):
 *
 * .upload( gl, seq, values, textures )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (textures factorizations):
 *
 * .setValue( gl, name, value, textures )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */


const emptyTexture = /*@__PURE__*/ new Texture();

const emptyShadowTexture = /*@__PURE__*/ new DepthTexture( 1, 1 );
emptyShadowTexture.compareFunction = LessEqualCompare;

const emptyArrayTexture = /*@__PURE__*/ new DataArrayTexture();
const empty3dTexture = /*@__PURE__*/ new Data3DTexture();
const emptyCubeTexture = /*@__PURE__*/ new CubeTexture();

// --- Utilities ---

// Array Caches (provide typed arrays for temporary by size)

const arrayCacheF32 = (/* unused pure expression or super */ null && ([]));
const arrayCacheI32 = (/* unused pure expression or super */ null && ([]));

// Float32Array caches used for uploading Matrix uniforms

const mat4array = new Float32Array( 16 );
const mat3array = new Float32Array( 9 );
const mat2array = new Float32Array( 4 );

// Flattening for arrays of vectors and matrices

function flatten( array, nBlocks, blockSize ) {

	const firstElem = array[ 0 ];

	if ( firstElem <= 0 || firstElem > 0 ) return array;
	// unoptimized: ! isNaN( firstElem )
	// see http://jacksondunstan.com/articles/983

	const n = nBlocks * blockSize;
	let r = arrayCacheF32[ n ];

	if ( r === undefined ) {

		r = new Float32Array( n );
		arrayCacheF32[ n ] = r;

	}

	if ( nBlocks !== 0 ) {

		firstElem.toArray( r, 0 );

		for ( let i = 1, offset = 0; i !== nBlocks; ++ i ) {

			offset += blockSize;
			array[ i ].toArray( r, offset );

		}

	}

	return r;

}

function arraysEqual( a, b ) {

	if ( a.length !== b.length ) return false;

	for ( let i = 0, l = a.length; i < l; i ++ ) {

		if ( a[ i ] !== b[ i ] ) return false;

	}

	return true;

}

function copyArray( a, b ) {

	for ( let i = 0, l = b.length; i < l; i ++ ) {

		a[ i ] = b[ i ];

	}

}

// Texture unit allocation

function allocTexUnits( textures, n ) {

	let r = arrayCacheI32[ n ];

	if ( r === undefined ) {

		r = new Int32Array( n );
		arrayCacheI32[ n ] = r;

	}

	for ( let i = 0; i !== n; ++ i ) {

		r[ i ] = textures.allocateTextureUnit();

	}

	return r;

}

// --- Setters ---

// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.

// Single scalar

function setValueV1f( gl, v ) {

	const cache = this.cache;

	if ( cache[ 0 ] === v ) return;

	gl.uniform1f( this.addr, v );

	cache[ 0 ] = v;

}

// Single float vector (from flat array or THREE.VectorN)

function setValueV2f( gl, v ) {

	const cache = this.cache;

	if ( v.x !== undefined ) {

		if ( cache[ 0 ] !== v.x || cache[ 1 ] !== v.y ) {

			gl.uniform2f( this.addr, v.x, v.y );

			cache[ 0 ] = v.x;
			cache[ 1 ] = v.y;

		}

	} else {

		if ( arraysEqual( cache, v ) ) return;

		gl.uniform2fv( this.addr, v );

		copyArray( cache, v );

	}

}

function setValueV3f( gl, v ) {

	const cache = this.cache;

	if ( v.x !== undefined ) {

		if ( cache[ 0 ] !== v.x || cache[ 1 ] !== v.y || cache[ 2 ] !== v.z ) {

			gl.uniform3f( this.addr, v.x, v.y, v.z );

			cache[ 0 ] = v.x;
			cache[ 1 ] = v.y;
			cache[ 2 ] = v.z;

		}

	} else if ( v.r !== undefined ) {

		if ( cache[ 0 ] !== v.r || cache[ 1 ] !== v.g || cache[ 2 ] !== v.b ) {

			gl.uniform3f( this.addr, v.r, v.g, v.b );

			cache[ 0 ] = v.r;
			cache[ 1 ] = v.g;
			cache[ 2 ] = v.b;

		}

	} else {

		if ( arraysEqual( cache, v ) ) return;

		gl.uniform3fv( this.addr, v );

		copyArray( cache, v );

	}

}

function setValueV4f( gl, v ) {

	const cache = this.cache;

	if ( v.x !== undefined ) {

		if ( cache[ 0 ] !== v.x || cache[ 1 ] !== v.y || cache[ 2 ] !== v.z || cache[ 3 ] !== v.w ) {

			gl.uniform4f( this.addr, v.x, v.y, v.z, v.w );

			cache[ 0 ] = v.x;
			cache[ 1 ] = v.y;
			cache[ 2 ] = v.z;
			cache[ 3 ] = v.w;

		}

	} else {

		if ( arraysEqual( cache, v ) ) return;

		gl.uniform4fv( this.addr, v );

		copyArray( cache, v );

	}

}

// Single matrix (from flat array or THREE.MatrixN)

function setValueM2( gl, v ) {

	const cache = this.cache;
	const elements = v.elements;

	if ( elements === undefined ) {

		if ( arraysEqual( cache, v ) ) return;

		gl.uniformMatrix2fv( this.addr, false, v );

		copyArray( cache, v );

	} else {

		if ( arraysEqual( cache, elements ) ) return;

		mat2array.set( elements );

		gl.uniformMatrix2fv( this.addr, false, mat2array );

		copyArray( cache, elements );

	}

}

function setValueM3( gl, v ) {

	const cache = this.cache;
	const elements = v.elements;

	if ( elements === undefined ) {

		if ( arraysEqual( cache, v ) ) return;

		gl.uniformMatrix3fv( this.addr, false, v );

		copyArray( cache, v );

	} else {

		if ( arraysEqual( cache, elements ) ) return;

		mat3array.set( elements );

		gl.uniformMatrix3fv( this.addr, false, mat3array );

		copyArray( cache, elements );

	}

}

function setValueM4( gl, v ) {

	const cache = this.cache;
	const elements = v.elements;

	if ( elements === undefined ) {

		if ( arraysEqual( cache, v ) ) return;

		gl.uniformMatrix4fv( this.addr, false, v );

		copyArray( cache, v );

	} else {

		if ( arraysEqual( cache, elements ) ) return;

		mat4array.set( elements );

		gl.uniformMatrix4fv( this.addr, false, mat4array );

		copyArray( cache, elements );

	}

}

// Single integer / boolean

function setValueV1i( gl, v ) {

	const cache = this.cache;

	if ( cache[ 0 ] === v ) return;

	gl.uniform1i( this.addr, v );

	cache[ 0 ] = v;

}

// Single integer / boolean vector (from flat array or THREE.VectorN)

function setValueV2i( gl, v ) {

	const cache = this.cache;

	if ( v.x !== undefined ) {

		if ( cache[ 0 ] !== v.x || cache[ 1 ] !== v.y ) {

			gl.uniform2i( this.addr, v.x, v.y );

			cache[ 0 ] = v.x;
			cache[ 1 ] = v.y;

		}

	} else {

		if ( arraysEqual( cache, v ) ) return;

		gl.uniform2iv( this.addr, v );

		copyArray( cache, v );

	}

}

function setValueV3i( gl, v ) {

	const cache = this.cache;

	if ( v.x !== undefined ) {

		if ( cache[ 0 ] !== v.x || cache[ 1 ] !== v.y || cache[ 2 ] !== v.z ) {

			gl.uniform3i( this.addr, v.x, v.y, v.z );

			cache[ 0 ] = v.x;
			cache[ 1 ] = v.y;
			cache[ 2 ] = v.z;

		}

	} else {

		if ( arraysEqual( cache, v ) ) return;

		gl.uniform3iv( this.addr, v );

		copyArray( cache, v );

	}

}

function setValueV4i( gl, v ) {

	const cache = this.cache;

	if ( v.x !== undefined ) {

		if ( cache[ 0 ] !== v.x || cache[ 1 ] !== v.y || cache[ 2 ] !== v.z || cache[ 3 ] !== v.w ) {

			gl.uniform4i( this.addr, v.x, v.y, v.z, v.w );

			cache[ 0 ] = v.x;
			cache[ 1 ] = v.y;
			cache[ 2 ] = v.z;
			cache[ 3 ] = v.w;

		}

	} else {

		if ( arraysEqual( cache, v ) ) return;

		gl.uniform4iv( this.addr, v );

		copyArray( cache, v );

	}

}

// Single unsigned integer

function setValueV1ui( gl, v ) {

	const cache = this.cache;

	if ( cache[ 0 ] === v ) return;

	gl.uniform1ui( this.addr, v );

	cache[ 0 ] = v;

}

// Single unsigned integer vector (from flat array or THREE.VectorN)

function setValueV2ui( gl, v ) {

	const cache = this.cache;

	if ( v.x !== undefined ) {

		if ( cache[ 0 ] !== v.x || cache[ 1 ] !== v.y ) {

			gl.uniform2ui( this.addr, v.x, v.y );

			cache[ 0 ] = v.x;
			cache[ 1 ] = v.y;

		}

	} else {

		if ( arraysEqual( cache, v ) ) return;

		gl.uniform2uiv( this.addr, v );

		copyArray( cache, v );

	}

}

function setValueV3ui( gl, v ) {

	const cache = this.cache;

	if ( v.x !== undefined ) {

		if ( cache[ 0 ] !== v.x || cache[ 1 ] !== v.y || cache[ 2 ] !== v.z ) {

			gl.uniform3ui( this.addr, v.x, v.y, v.z );

			cache[ 0 ] = v.x;
			cache[ 1 ] = v.y;
			cache[ 2 ] = v.z;

		}

	} else {

		if ( arraysEqual( cache, v ) ) return;

		gl.uniform3uiv( this.addr, v );

		copyArray( cache, v );

	}

}

function setValueV4ui( gl, v ) {

	const cache = this.cache;

	if ( v.x !== undefined ) {

		if ( cache[ 0 ] !== v.x || cache[ 1 ] !== v.y || cache[ 2 ] !== v.z || cache[ 3 ] !== v.w ) {

			gl.uniform4ui( this.addr, v.x, v.y, v.z, v.w );

			cache[ 0 ] = v.x;
			cache[ 1 ] = v.y;
			cache[ 2 ] = v.z;
			cache[ 3 ] = v.w;

		}

	} else {

		if ( arraysEqual( cache, v ) ) return;

		gl.uniform4uiv( this.addr, v );

		copyArray( cache, v );

	}

}


// Single texture (2D / Cube)

function setValueT1( gl, v, textures ) {

	const cache = this.cache;
	const unit = textures.allocateTextureUnit();

	if ( cache[ 0 ] !== unit ) {

		gl.uniform1i( this.addr, unit );
		cache[ 0 ] = unit;

	}

	const emptyTexture2D = ( this.type === gl.SAMPLER_2D_SHADOW ) ? emptyShadowTexture : emptyTexture;

	textures.setTexture2D( v || emptyTexture2D, unit );

}

function setValueT3D1( gl, v, textures ) {

	const cache = this.cache;
	const unit = textures.allocateTextureUnit();

	if ( cache[ 0 ] !== unit ) {

		gl.uniform1i( this.addr, unit );
		cache[ 0 ] = unit;

	}

	textures.setTexture3D( v || empty3dTexture, unit );

}

function setValueT6( gl, v, textures ) {

	const cache = this.cache;
	const unit = textures.allocateTextureUnit();

	if ( cache[ 0 ] !== unit ) {

		gl.uniform1i( this.addr, unit );
		cache[ 0 ] = unit;

	}

	textures.setTextureCube( v || emptyCubeTexture, unit );

}

function setValueT2DArray1( gl, v, textures ) {

	const cache = this.cache;
	const unit = textures.allocateTextureUnit();

	if ( cache[ 0 ] !== unit ) {

		gl.uniform1i( this.addr, unit );
		cache[ 0 ] = unit;

	}

	textures.setTexture2DArray( v || emptyArrayTexture, unit );

}

// Helper to pick the right setter for the singular case

function getSingularSetter( type ) {

	switch ( type ) {

		case 0x1406: return setValueV1f; // FLOAT
		case 0x8b50: return setValueV2f; // _VEC2
		case 0x8b51: return setValueV3f; // _VEC3
		case 0x8b52: return setValueV4f; // _VEC4

		case 0x8b5a: return setValueM2; // _MAT2
		case 0x8b5b: return setValueM3; // _MAT3
		case 0x8b5c: return setValueM4; // _MAT4

		case 0x1404: case 0x8b56: return setValueV1i; // INT, BOOL
		case 0x8b53: case 0x8b57: return setValueV2i; // _VEC2
		case 0x8b54: case 0x8b58: return setValueV3i; // _VEC3
		case 0x8b55: case 0x8b59: return setValueV4i; // _VEC4

		case 0x1405: return setValueV1ui; // UINT
		case 0x8dc6: return setValueV2ui; // _VEC2
		case 0x8dc7: return setValueV3ui; // _VEC3
		case 0x8dc8: return setValueV4ui; // _VEC4

		case 0x8b5e: // SAMPLER_2D
		case 0x8d66: // SAMPLER_EXTERNAL_OES
		case 0x8dca: // INT_SAMPLER_2D
		case 0x8dd2: // UNSIGNED_INT_SAMPLER_2D
		case 0x8b62: // SAMPLER_2D_SHADOW
			return setValueT1;

		case 0x8b5f: // SAMPLER_3D
		case 0x8dcb: // INT_SAMPLER_3D
		case 0x8dd3: // UNSIGNED_INT_SAMPLER_3D
			return setValueT3D1;

		case 0x8b60: // SAMPLER_CUBE
		case 0x8dcc: // INT_SAMPLER_CUBE
		case 0x8dd4: // UNSIGNED_INT_SAMPLER_CUBE
		case 0x8dc5: // SAMPLER_CUBE_SHADOW
			return setValueT6;

		case 0x8dc1: // SAMPLER_2D_ARRAY
		case 0x8dcf: // INT_SAMPLER_2D_ARRAY
		case 0x8dd7: // UNSIGNED_INT_SAMPLER_2D_ARRAY
		case 0x8dc4: // SAMPLER_2D_ARRAY_SHADOW
			return setValueT2DArray1;

	}

}


// Array of scalars

function setValueV1fArray( gl, v ) {

	gl.uniform1fv( this.addr, v );

}

// Array of vectors (from flat array or array of THREE.VectorN)

function setValueV2fArray( gl, v ) {

	const data = flatten( v, this.size, 2 );

	gl.uniform2fv( this.addr, data );

}

function setValueV3fArray( gl, v ) {

	const data = flatten( v, this.size, 3 );

	gl.uniform3fv( this.addr, data );

}

function setValueV4fArray( gl, v ) {

	const data = flatten( v, this.size, 4 );

	gl.uniform4fv( this.addr, data );

}

// Array of matrices (from flat array or array of THREE.MatrixN)

function setValueM2Array( gl, v ) {

	const data = flatten( v, this.size, 4 );

	gl.uniformMatrix2fv( this.addr, false, data );

}

function setValueM3Array( gl, v ) {

	const data = flatten( v, this.size, 9 );

	gl.uniformMatrix3fv( this.addr, false, data );

}

function setValueM4Array( gl, v ) {

	const data = flatten( v, this.size, 16 );

	gl.uniformMatrix4fv( this.addr, false, data );

}

// Array of integer / boolean

function setValueV1iArray( gl, v ) {

	gl.uniform1iv( this.addr, v );

}

// Array of integer / boolean vectors (from flat array)

function setValueV2iArray( gl, v ) {

	gl.uniform2iv( this.addr, v );

}

function setValueV3iArray( gl, v ) {

	gl.uniform3iv( this.addr, v );

}

function setValueV4iArray( gl, v ) {

	gl.uniform4iv( this.addr, v );

}

// Array of unsigned integer

function setValueV1uiArray( gl, v ) {

	gl.uniform1uiv( this.addr, v );

}

// Array of unsigned integer vectors (from flat array)

function setValueV2uiArray( gl, v ) {

	gl.uniform2uiv( this.addr, v );

}

function setValueV3uiArray( gl, v ) {

	gl.uniform3uiv( this.addr, v );

}

function setValueV4uiArray( gl, v ) {

	gl.uniform4uiv( this.addr, v );

}


// Array of textures (2D / 3D / Cube / 2DArray)

function setValueT1Array( gl, v, textures ) {

	const cache = this.cache;

	const n = v.length;

	const units = allocTexUnits( textures, n );

	if ( ! arraysEqual( cache, units ) ) {

		gl.uniform1iv( this.addr, units );

		copyArray( cache, units );

	}

	for ( let i = 0; i !== n; ++ i ) {

		textures.setTexture2D( v[ i ] || emptyTexture, units[ i ] );

	}

}

function setValueT3DArray( gl, v, textures ) {

	const cache = this.cache;

	const n = v.length;

	const units = allocTexUnits( textures, n );

	if ( ! arraysEqual( cache, units ) ) {

		gl.uniform1iv( this.addr, units );

		copyArray( cache, units );

	}

	for ( let i = 0; i !== n; ++ i ) {

		textures.setTexture3D( v[ i ] || empty3dTexture, units[ i ] );

	}

}

function setValueT6Array( gl, v, textures ) {

	const cache = this.cache;

	const n = v.length;

	const units = allocTexUnits( textures, n );

	if ( ! arraysEqual( cache, units ) ) {

		gl.uniform1iv( this.addr, units );

		copyArray( cache, units );

	}

	for ( let i = 0; i !== n; ++ i ) {

		textures.setTextureCube( v[ i ] || emptyCubeTexture, units[ i ] );

	}

}

function setValueT2DArrayArray( gl, v, textures ) {

	const cache = this.cache;

	const n = v.length;

	const units = allocTexUnits( textures, n );

	if ( ! arraysEqual( cache, units ) ) {

		gl.uniform1iv( this.addr, units );

		copyArray( cache, units );

	}

	for ( let i = 0; i !== n; ++ i ) {

		textures.setTexture2DArray( v[ i ] || emptyArrayTexture, units[ i ] );

	}

}


// Helper to pick the right setter for a pure (bottom-level) array

function getPureArraySetter( type ) {

	switch ( type ) {

		case 0x1406: return setValueV1fArray; // FLOAT
		case 0x8b50: return setValueV2fArray; // _VEC2
		case 0x8b51: return setValueV3fArray; // _VEC3
		case 0x8b52: return setValueV4fArray; // _VEC4

		case 0x8b5a: return setValueM2Array; // _MAT2
		case 0x8b5b: return setValueM3Array; // _MAT3
		case 0x8b5c: return setValueM4Array; // _MAT4

		case 0x1404: case 0x8b56: return setValueV1iArray; // INT, BOOL
		case 0x8b53: case 0x8b57: return setValueV2iArray; // _VEC2
		case 0x8b54: case 0x8b58: return setValueV3iArray; // _VEC3
		case 0x8b55: case 0x8b59: return setValueV4iArray; // _VEC4

		case 0x1405: return setValueV1uiArray; // UINT
		case 0x8dc6: return setValueV2uiArray; // _VEC2
		case 0x8dc7: return setValueV3uiArray; // _VEC3
		case 0x8dc8: return setValueV4uiArray; // _VEC4

		case 0x8b5e: // SAMPLER_2D
		case 0x8d66: // SAMPLER_EXTERNAL_OES
		case 0x8dca: // INT_SAMPLER_2D
		case 0x8dd2: // UNSIGNED_INT_SAMPLER_2D
		case 0x8b62: // SAMPLER_2D_SHADOW
			return setValueT1Array;

		case 0x8b5f: // SAMPLER_3D
		case 0x8dcb: // INT_SAMPLER_3D
		case 0x8dd3: // UNSIGNED_INT_SAMPLER_3D
			return setValueT3DArray;

		case 0x8b60: // SAMPLER_CUBE
		case 0x8dcc: // INT_SAMPLER_CUBE
		case 0x8dd4: // UNSIGNED_INT_SAMPLER_CUBE
		case 0x8dc5: // SAMPLER_CUBE_SHADOW
			return setValueT6Array;

		case 0x8dc1: // SAMPLER_2D_ARRAY
		case 0x8dcf: // INT_SAMPLER_2D_ARRAY
		case 0x8dd7: // UNSIGNED_INT_SAMPLER_2D_ARRAY
		case 0x8dc4: // SAMPLER_2D_ARRAY_SHADOW
			return setValueT2DArrayArray;

	}

}

// --- Uniform Classes ---

class SingleUniform {

	constructor( id, activeInfo, addr ) {

		this.id = id;
		this.addr = addr;
		this.cache = [];
		this.type = activeInfo.type;
		this.setValue = getSingularSetter( activeInfo.type );

		// this.path = activeInfo.name; // DEBUG

	}

}

class PureArrayUniform {

	constructor( id, activeInfo, addr ) {

		this.id = id;
		this.addr = addr;
		this.cache = [];
		this.type = activeInfo.type;
		this.size = activeInfo.size;
		this.setValue = getPureArraySetter( activeInfo.type );

		// this.path = activeInfo.name; // DEBUG

	}

}

class StructuredUniform {

	constructor( id ) {

		this.id = id;

		this.seq = [];
		this.map = {};

	}

	setValue( gl, value, textures ) {

		const seq = this.seq;

		for ( let i = 0, n = seq.length; i !== n; ++ i ) {

			const u = seq[ i ];
			u.setValue( gl, value[ u.id ], textures );

		}

	}

}

// --- Top-level ---

// Parser - builds up the property tree from the path strings

const RePathPart = /(\w+)(\])?(\[|\.)?/g;

// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.

function addUniform( container, uniformObject ) {

	container.seq.push( uniformObject );
	container.map[ uniformObject.id ] = uniformObject;

}

function parseUniform( activeInfo, addr, container ) {

	const path = activeInfo.name,
		pathLength = path.length;

	// reset RegExp object, because of the early exit of a previous run
	RePathPart.lastIndex = 0;

	while ( true ) {

		const match = RePathPart.exec( path ),
			matchEnd = RePathPart.lastIndex;

		let id = match[ 1 ];
		const idIsIndex = match[ 2 ] === ']',
			subscript = match[ 3 ];

		if ( idIsIndex ) id = id | 0; // convert to integer

		if ( subscript === undefined || subscript === '[' && matchEnd + 2 === pathLength ) {

			// bare name or "pure" bottom-level array "[0]" suffix

			addUniform( container, subscript === undefined ?
				new SingleUniform( id, activeInfo, addr ) :
				new PureArrayUniform( id, activeInfo, addr ) );

			break;

		} else {

			// step into inner node / create it in case it doesn't exist

			const map = container.map;
			let next = map[ id ];

			if ( next === undefined ) {

				next = new StructuredUniform( id );
				addUniform( container, next );

			}

			container = next;

		}

	}

}

// Root Container

class WebGLUniforms {

	constructor( gl, program ) {

		this.seq = [];
		this.map = {};

		const n = gl.getProgramParameter( program, gl.ACTIVE_UNIFORMS );

		for ( let i = 0; i < n; ++ i ) {

			const info = gl.getActiveUniform( program, i ),
				addr = gl.getUniformLocation( program, info.name );

			parseUniform( info, addr, this );

		}

	}

	setValue( gl, name, value, textures ) {

		const u = this.map[ name ];

		if ( u !== undefined ) u.setValue( gl, value, textures );

	}

	setOptional( gl, object, name ) {

		const v = object[ name ];

		if ( v !== undefined ) this.setValue( gl, name, v );

	}

	static upload( gl, seq, values, textures ) {

		for ( let i = 0, n = seq.length; i !== n; ++ i ) {

			const u = seq[ i ],
				v = values[ u.id ];

			if ( v.needsUpdate !== false ) {

				// note: always updating when .needsUpdate is undefined
				u.setValue( gl, v.value, textures );

			}

		}

	}

	static seqWithValue( seq, values ) {

		const r = [];

		for ( let i = 0, n = seq.length; i !== n; ++ i ) {

			const u = seq[ i ];
			if ( u.id in values ) r.push( u );

		}

		return r;

	}

}

function WebGLShader( gl, type, string ) {

	const shader = gl.createShader( type );

	gl.shaderSource( shader, string );
	gl.compileShader( shader );

	return shader;

}

// From https://www.khronos.org/registry/webgl/extensions/KHR_parallel_shader_compile/
const COMPLETION_STATUS_KHR = 0x91B1;

let programIdCount = 0;

function handleSource( string, errorLine ) {

	const lines = string.split( '\n' );
	const lines2 = [];

	const from = Math.max( errorLine - 6, 0 );
	const to = Math.min( errorLine + 6, lines.length );

	for ( let i = from; i < to; i ++ ) {

		const line = i + 1;
		lines2.push( `${line === errorLine ? '>' : ' '} ${line}: ${lines[ i ]}` );

	}

	return lines2.join( '\n' );

}

function getEncodingComponents( colorSpace ) {

	const workingPrimaries = ColorManagement.getPrimaries( ColorManagement.workingColorSpace );
	const encodingPrimaries = ColorManagement.getPrimaries( colorSpace );

	let gamutMapping;

	if ( workingPrimaries === encodingPrimaries ) {

		gamutMapping = '';

	} else if ( workingPrimaries === P3Primaries && encodingPrimaries === Rec709Primaries ) {

		gamutMapping = 'LinearDisplayP3ToLinearSRGB';

	} else if ( workingPrimaries === Rec709Primaries && encodingPrimaries === P3Primaries ) {

		gamutMapping = 'LinearSRGBToLinearDisplayP3';

	}

	switch ( colorSpace ) {

		case LinearSRGBColorSpace:
		case LinearDisplayP3ColorSpace:
			return [ gamutMapping, 'LinearTransferOETF' ];

		case SRGBColorSpace:
		case DisplayP3ColorSpace:
			return [ gamutMapping, 'sRGBTransferOETF' ];

		default:
			console.warn( 'THREE.WebGLProgram: Unsupported color space:', colorSpace );
			return [ gamutMapping, 'LinearTransferOETF' ];

	}

}

function getShaderErrors( gl, shader, type ) {

	const status = gl.getShaderParameter( shader, gl.COMPILE_STATUS );
	const errors = gl.getShaderInfoLog( shader ).trim();

	if ( status && errors === '' ) return '';

	const errorMatches = /ERROR: 0:(\d+)/.exec( errors );
	if ( errorMatches ) {

		// --enable-privileged-webgl-extension
		// console.log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );

		const errorLine = parseInt( errorMatches[ 1 ] );
		return type.toUpperCase() + '\n\n' + errors + '\n\n' + handleSource( gl.getShaderSource( shader ), errorLine );

	} else {

		return errors;

	}

}

function getTexelEncodingFunction( functionName, colorSpace ) {

	const components = getEncodingComponents( colorSpace );
	return `vec4 ${functionName}( vec4 value ) { return ${components[ 0 ]}( ${components[ 1 ]}( value ) ); }`;

}

function getToneMappingFunction( functionName, toneMapping ) {

	let toneMappingName;

	switch ( toneMapping ) {

		case LinearToneMapping:
			toneMappingName = 'Linear';
			break;

		case ReinhardToneMapping:
			toneMappingName = 'Reinhard';
			break;

		case CineonToneMapping:
			toneMappingName = 'OptimizedCineon';
			break;

		case ACESFilmicToneMapping:
			toneMappingName = 'ACESFilmic';
			break;

		case AgXToneMapping:
			toneMappingName = 'AgX';
			break;

		case NeutralToneMapping:
			toneMappingName = 'Neutral';
			break;

		case CustomToneMapping:
			toneMappingName = 'Custom';
			break;

		default:
			console.warn( 'THREE.WebGLProgram: Unsupported toneMapping:', toneMapping );
			toneMappingName = 'Linear';

	}

	return 'vec3 ' + functionName + '( vec3 color ) { return ' + toneMappingName + 'ToneMapping( color ); }';

}

function generateVertexExtensions( parameters ) {

	const chunks = [
		parameters.extensionClipCullDistance ? '#extension GL_ANGLE_clip_cull_distance : require' : '',
		parameters.extensionMultiDraw ? '#extension GL_ANGLE_multi_draw : require' : '',
	];

	return chunks.filter( filterEmptyLine ).join( '\n' );

}

function generateDefines( defines ) {

	const chunks = [];

	for ( const name in defines ) {

		const value = defines[ name ];

		if ( value === false ) continue;

		chunks.push( '#define ' + name + ' ' + value );

	}

	return chunks.join( '\n' );

}

function fetchAttributeLocations( gl, program ) {

	const attributes = {};

	const n = gl.getProgramParameter( program, gl.ACTIVE_ATTRIBUTES );

	for ( let i = 0; i < n; i ++ ) {

		const info = gl.getActiveAttrib( program, i );
		const name = info.name;

		let locationSize = 1;
		if ( info.type === gl.FLOAT_MAT2 ) locationSize = 2;
		if ( info.type === gl.FLOAT_MAT3 ) locationSize = 3;
		if ( info.type === gl.FLOAT_MAT4 ) locationSize = 4;

		// console.log( 'THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );

		attributes[ name ] = {
			type: info.type,
			location: gl.getAttribLocation( program, name ),
			locationSize: locationSize
		};

	}

	return attributes;

}

function filterEmptyLine( string ) {

	return string !== '';

}

function replaceLightNums( string, parameters ) {

	const numSpotLightCoords = parameters.numSpotLightShadows + parameters.numSpotLightMaps - parameters.numSpotLightShadowsWithMaps;

	return string
		.replace( /NUM_DIR_LIGHTS/g, parameters.numDirLights )
		.replace( /NUM_SPOT_LIGHTS/g, parameters.numSpotLights )
		.replace( /NUM_SPOT_LIGHT_MAPS/g, parameters.numSpotLightMaps )
		.replace( /NUM_SPOT_LIGHT_COORDS/g, numSpotLightCoords )
		.replace( /NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights )
		.replace( /NUM_POINT_LIGHTS/g, parameters.numPointLights )
		.replace( /NUM_HEMI_LIGHTS/g, parameters.numHemiLights )
		.replace( /NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows )
		.replace( /NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, parameters.numSpotLightShadowsWithMaps )
		.replace( /NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows )
		.replace( /NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows );

}

function replaceClippingPlaneNums( string, parameters ) {

	return string
		.replace( /NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes )
		.replace( /UNION_CLIPPING_PLANES/g, ( parameters.numClippingPlanes - parameters.numClipIntersection ) );

}

// Resolve Includes

const includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;

function resolveIncludes( string ) {

	return string.replace( includePattern, includeReplacer );

}

const shaderChunkMap = new Map( [
	[ 'encodings_fragment', 'colorspace_fragment' ], // @deprecated, r154
	[ 'encodings_pars_fragment', 'colorspace_pars_fragment' ], // @deprecated, r154
	[ 'output_fragment', 'opaque_fragment' ], // @deprecated, r154
] );

function includeReplacer( match, include ) {

	let string = ShaderChunk[ include ];

	if ( string === undefined ) {

		const newInclude = shaderChunkMap.get( include );

		if ( newInclude !== undefined ) {

			string = ShaderChunk[ newInclude ];
			console.warn( 'THREE.WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', include, newInclude );

		} else {

			throw new Error( 'Can not resolve #include <' + include + '>' );

		}

	}

	return resolveIncludes( string );

}

// Unroll Loops

const unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;

function unrollLoops( string ) {

	return string.replace( unrollLoopPattern, loopReplacer );

}

function loopReplacer( match, start, end, snippet ) {

	let string = '';

	for ( let i = parseInt( start ); i < parseInt( end ); i ++ ) {

		string += snippet
			.replace( /\[\s*i\s*\]/g, '[ ' + i + ' ]' )
			.replace( /UNROLLED_LOOP_INDEX/g, i );

	}

	return string;

}

//

function generatePrecision( parameters ) {

	let precisionstring = `precision ${parameters.precision} float;
	precision ${parameters.precision} int;
	precision ${parameters.precision} sampler2D;
	precision ${parameters.precision} samplerCube;
	precision ${parameters.precision} sampler3D;
	precision ${parameters.precision} sampler2DArray;
	precision ${parameters.precision} sampler2DShadow;
	precision ${parameters.precision} samplerCubeShadow;
	precision ${parameters.precision} sampler2DArrayShadow;
	precision ${parameters.precision} isampler2D;
	precision ${parameters.precision} isampler3D;
	precision ${parameters.precision} isamplerCube;
	precision ${parameters.precision} isampler2DArray;
	precision ${parameters.precision} usampler2D;
	precision ${parameters.precision} usampler3D;
	precision ${parameters.precision} usamplerCube;
	precision ${parameters.precision} usampler2DArray;
	`;

	if ( parameters.precision === 'highp' ) {

		precisionstring += '\n#define HIGH_PRECISION';

	} else if ( parameters.precision === 'mediump' ) {

		precisionstring += '\n#define MEDIUM_PRECISION';

	} else if ( parameters.precision === 'lowp' ) {

		precisionstring += '\n#define LOW_PRECISION';

	}

	return precisionstring;

}

function generateShadowMapTypeDefine( parameters ) {

	let shadowMapTypeDefine = 'SHADOWMAP_TYPE_BASIC';

	if ( parameters.shadowMapType === PCFShadowMap ) {

		shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF';

	} else if ( parameters.shadowMapType === PCFSoftShadowMap ) {

		shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF_SOFT';

	} else if ( parameters.shadowMapType === VSMShadowMap ) {

		shadowMapTypeDefine = 'SHADOWMAP_TYPE_VSM';

	}

	return shadowMapTypeDefine;

}

function generateEnvMapTypeDefine( parameters ) {

	let envMapTypeDefine = 'ENVMAP_TYPE_CUBE';

	if ( parameters.envMap ) {

		switch ( parameters.envMapMode ) {

			case CubeReflectionMapping:
			case CubeRefractionMapping:
				envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
				break;

			case CubeUVReflectionMapping:
				envMapTypeDefine = 'ENVMAP_TYPE_CUBE_UV';
				break;

		}

	}

	return envMapTypeDefine;

}

function generateEnvMapModeDefine( parameters ) {

	let envMapModeDefine = 'ENVMAP_MODE_REFLECTION';

	if ( parameters.envMap ) {

		switch ( parameters.envMapMode ) {

			case CubeRefractionMapping:

				envMapModeDefine = 'ENVMAP_MODE_REFRACTION';
				break;

		}

	}

	return envMapModeDefine;

}

function generateEnvMapBlendingDefine( parameters ) {

	let envMapBlendingDefine = 'ENVMAP_BLENDING_NONE';

	if ( parameters.envMap ) {

		switch ( parameters.combine ) {

			case MultiplyOperation:
				envMapBlendingDefine = 'ENVMAP_BLENDING_MULTIPLY';
				break;

			case MixOperation:
				envMapBlendingDefine = 'ENVMAP_BLENDING_MIX';
				break;

			case AddOperation:
				envMapBlendingDefine = 'ENVMAP_BLENDING_ADD';
				break;

		}

	}

	return envMapBlendingDefine;

}

function generateCubeUVSize( parameters ) {

	const imageHeight = parameters.envMapCubeUVHeight;

	if ( imageHeight === null ) return null;

	const maxMip = Math.log2( imageHeight ) - 2;

	const texelHeight = 1.0 / imageHeight;

	const texelWidth = 1.0 / ( 3 * Math.max( Math.pow( 2, maxMip ), 7 * 16 ) );

	return { texelWidth, texelHeight, maxMip };

}

function WebGLProgram( renderer, cacheKey, parameters, bindingStates ) {

	// TODO Send this event to Three.js DevTools
	// console.log( 'WebGLProgram', cacheKey );

	const gl = renderer.getContext();

	const defines = parameters.defines;

	let vertexShader = parameters.vertexShader;
	let fragmentShader = parameters.fragmentShader;

	const shadowMapTypeDefine = generateShadowMapTypeDefine( parameters );
	const envMapTypeDefine = generateEnvMapTypeDefine( parameters );
	const envMapModeDefine = generateEnvMapModeDefine( parameters );
	const envMapBlendingDefine = generateEnvMapBlendingDefine( parameters );
	const envMapCubeUVSize = generateCubeUVSize( parameters );

	const customVertexExtensions = generateVertexExtensions( parameters );

	const customDefines = generateDefines( defines );

	const program = gl.createProgram();

	let prefixVertex, prefixFragment;
	let versionString = parameters.glslVersion ? '#version ' + parameters.glslVersion + '\n' : '';

	if ( parameters.isRawShaderMaterial ) {

		prefixVertex = [

			'#define SHADER_TYPE ' + parameters.shaderType,
			'#define SHADER_NAME ' + parameters.shaderName,

			customDefines

		].filter( filterEmptyLine ).join( '\n' );

		if ( prefixVertex.length > 0 ) {

			prefixVertex += '\n';

		}

		prefixFragment = [

			'#define SHADER_TYPE ' + parameters.shaderType,
			'#define SHADER_NAME ' + parameters.shaderName,

			customDefines

		].filter( filterEmptyLine ).join( '\n' );

		if ( prefixFragment.length > 0 ) {

			prefixFragment += '\n';

		}

	} else {

		prefixVertex = [

			generatePrecision( parameters ),

			'#define SHADER_TYPE ' + parameters.shaderType,
			'#define SHADER_NAME ' + parameters.shaderName,

			customDefines,

			parameters.extensionClipCullDistance ? '#define USE_CLIP_DISTANCE' : '',
			parameters.batching ? '#define USE_BATCHING' : '',
			parameters.instancing ? '#define USE_INSTANCING' : '',
			parameters.instancingColor ? '#define USE_INSTANCING_COLOR' : '',
			parameters.instancingMorph ? '#define USE_INSTANCING_MORPH' : '',

			parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
			parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',

			parameters.map ? '#define USE_MAP' : '',
			parameters.envMap ? '#define USE_ENVMAP' : '',
			parameters.envMap ? '#define ' + envMapModeDefine : '',
			parameters.lightMap ? '#define USE_LIGHTMAP' : '',
			parameters.aoMap ? '#define USE_AOMAP' : '',
			parameters.bumpMap ? '#define USE_BUMPMAP' : '',
			parameters.normalMap ? '#define USE_NORMALMAP' : '',
			parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
			parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
			parameters.displacementMap ? '#define USE_DISPLACEMENTMAP' : '',
			parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',

			parameters.anisotropy ? '#define USE_ANISOTROPY' : '',
			parameters.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',

			parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
			parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
			parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',

			parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
			parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',

			parameters.specularMap ? '#define USE_SPECULARMAP' : '',
			parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
			parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',

			parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
			parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
			parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
			parameters.alphaHash ? '#define USE_ALPHAHASH' : '',

			parameters.transmission ? '#define USE_TRANSMISSION' : '',
			parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
			parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',

			parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
			parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',

			//

			parameters.mapUv ? '#define MAP_UV ' + parameters.mapUv : '',
			parameters.alphaMapUv ? '#define ALPHAMAP_UV ' + parameters.alphaMapUv : '',
			parameters.lightMapUv ? '#define LIGHTMAP_UV ' + parameters.lightMapUv : '',
			parameters.aoMapUv ? '#define AOMAP_UV ' + parameters.aoMapUv : '',
			parameters.emissiveMapUv ? '#define EMISSIVEMAP_UV ' + parameters.emissiveMapUv : '',
			parameters.bumpMapUv ? '#define BUMPMAP_UV ' + parameters.bumpMapUv : '',
			parameters.normalMapUv ? '#define NORMALMAP_UV ' + parameters.normalMapUv : '',
			parameters.displacementMapUv ? '#define DISPLACEMENTMAP_UV ' + parameters.displacementMapUv : '',

			parameters.metalnessMapUv ? '#define METALNESSMAP_UV ' + parameters.metalnessMapUv : '',
			parameters.roughnessMapUv ? '#define ROUGHNESSMAP_UV ' + parameters.roughnessMapUv : '',

			parameters.anisotropyMapUv ? '#define ANISOTROPYMAP_UV ' + parameters.anisotropyMapUv : '',

			parameters.clearcoatMapUv ? '#define CLEARCOATMAP_UV ' + parameters.clearcoatMapUv : '',
			parameters.clearcoatNormalMapUv ? '#define CLEARCOAT_NORMALMAP_UV ' + parameters.clearcoatNormalMapUv : '',
			parameters.clearcoatRoughnessMapUv ? '#define CLEARCOAT_ROUGHNESSMAP_UV ' + parameters.clearcoatRoughnessMapUv : '',

			parameters.iridescenceMapUv ? '#define IRIDESCENCEMAP_UV ' + parameters.iridescenceMapUv : '',
			parameters.iridescenceThicknessMapUv ? '#define IRIDESCENCE_THICKNESSMAP_UV ' + parameters.iridescenceThicknessMapUv : '',

			parameters.sheenColorMapUv ? '#define SHEEN_COLORMAP_UV ' + parameters.sheenColorMapUv : '',
			parameters.sheenRoughnessMapUv ? '#define SHEEN_ROUGHNESSMAP_UV ' + parameters.sheenRoughnessMapUv : '',

			parameters.specularMapUv ? '#define SPECULARMAP_UV ' + parameters.specularMapUv : '',
			parameters.specularColorMapUv ? '#define SPECULAR_COLORMAP_UV ' + parameters.specularColorMapUv : '',
			parameters.specularIntensityMapUv ? '#define SPECULAR_INTENSITYMAP_UV ' + parameters.specularIntensityMapUv : '',

			parameters.transmissionMapUv ? '#define TRANSMISSIONMAP_UV ' + parameters.transmissionMapUv : '',
			parameters.thicknessMapUv ? '#define THICKNESSMAP_UV ' + parameters.thicknessMapUv : '',

			//

			parameters.vertexTangents && parameters.flatShading === false ? '#define USE_TANGENT' : '',
			parameters.vertexColors ? '#define USE_COLOR' : '',
			parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
			parameters.vertexUv1s ? '#define USE_UV1' : '',
			parameters.vertexUv2s ? '#define USE_UV2' : '',
			parameters.vertexUv3s ? '#define USE_UV3' : '',

			parameters.pointsUvs ? '#define USE_POINTS_UV' : '',

			parameters.flatShading ? '#define FLAT_SHADED' : '',

			parameters.skinning ? '#define USE_SKINNING' : '',

			parameters.morphTargets ? '#define USE_MORPHTARGETS' : '',
			parameters.morphNormals && parameters.flatShading === false ? '#define USE_MORPHNORMALS' : '',
			( parameters.morphColors ) ? '#define USE_MORPHCOLORS' : '',
			( parameters.morphTargetsCount > 0 ) ? '#define MORPHTARGETS_TEXTURE' : '',
			( parameters.morphTargetsCount > 0 ) ? '#define MORPHTARGETS_TEXTURE_STRIDE ' + parameters.morphTextureStride : '',
			( parameters.morphTargetsCount > 0 ) ? '#define MORPHTARGETS_COUNT ' + parameters.morphTargetsCount : '',
			parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
			parameters.flipSided ? '#define FLIP_SIDED' : '',

			parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
			parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',

			parameters.sizeAttenuation ? '#define USE_SIZEATTENUATION' : '',

			parameters.numLightProbes > 0 ? '#define USE_LIGHT_PROBES' : '',

			parameters.useLegacyLights ? '#define LEGACY_LIGHTS' : '',

			parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',

			'uniform mat4 modelMatrix;',
			'uniform mat4 modelViewMatrix;',
			'uniform mat4 projectionMatrix;',
			'uniform mat4 viewMatrix;',
			'uniform mat3 normalMatrix;',
			'uniform vec3 cameraPosition;',
			'uniform bool isOrthographic;',

			'#ifdef USE_INSTANCING',

			'	attribute mat4 instanceMatrix;',

			'#endif',

			'#ifdef USE_INSTANCING_COLOR',

			'	attribute vec3 instanceColor;',

			'#endif',

			'#ifdef USE_INSTANCING_MORPH',

			'	uniform sampler2D morphTexture;',

			'#endif',

			'attribute vec3 position;',
			'attribute vec3 normal;',
			'attribute vec2 uv;',

			'#ifdef USE_UV1',

			'	attribute vec2 uv1;',

			'#endif',

			'#ifdef USE_UV2',

			'	attribute vec2 uv2;',

			'#endif',

			'#ifdef USE_UV3',

			'	attribute vec2 uv3;',

			'#endif',

			'#ifdef USE_TANGENT',

			'	attribute vec4 tangent;',

			'#endif',

			'#if defined( USE_COLOR_ALPHA )',

			'	attribute vec4 color;',

			'#elif defined( USE_COLOR )',

			'	attribute vec3 color;',

			'#endif',

			'#if ( defined( USE_MORPHTARGETS ) && ! defined( MORPHTARGETS_TEXTURE ) )',

			'	attribute vec3 morphTarget0;',
			'	attribute vec3 morphTarget1;',
			'	attribute vec3 morphTarget2;',
			'	attribute vec3 morphTarget3;',

			'	#ifdef USE_MORPHNORMALS',

			'		attribute vec3 morphNormal0;',
			'		attribute vec3 morphNormal1;',
			'		attribute vec3 morphNormal2;',
			'		attribute vec3 morphNormal3;',

			'	#else',

			'		attribute vec3 morphTarget4;',
			'		attribute vec3 morphTarget5;',
			'		attribute vec3 morphTarget6;',
			'		attribute vec3 morphTarget7;',

			'	#endif',

			'#endif',

			'#ifdef USE_SKINNING',

			'	attribute vec4 skinIndex;',
			'	attribute vec4 skinWeight;',

			'#endif',

			'\n'

		].filter( filterEmptyLine ).join( '\n' );

		prefixFragment = [

			generatePrecision( parameters ),

			'#define SHADER_TYPE ' + parameters.shaderType,
			'#define SHADER_NAME ' + parameters.shaderName,

			customDefines,

			parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
			parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',

			parameters.alphaToCoverage ? '#define ALPHA_TO_COVERAGE' : '',
			parameters.map ? '#define USE_MAP' : '',
			parameters.matcap ? '#define USE_MATCAP' : '',
			parameters.envMap ? '#define USE_ENVMAP' : '',
			parameters.envMap ? '#define ' + envMapTypeDefine : '',
			parameters.envMap ? '#define ' + envMapModeDefine : '',
			parameters.envMap ? '#define ' + envMapBlendingDefine : '',
			envMapCubeUVSize ? '#define CUBEUV_TEXEL_WIDTH ' + envMapCubeUVSize.texelWidth : '',
			envMapCubeUVSize ? '#define CUBEUV_TEXEL_HEIGHT ' + envMapCubeUVSize.texelHeight : '',
			envMapCubeUVSize ? '#define CUBEUV_MAX_MIP ' + envMapCubeUVSize.maxMip + '.0' : '',
			parameters.lightMap ? '#define USE_LIGHTMAP' : '',
			parameters.aoMap ? '#define USE_AOMAP' : '',
			parameters.bumpMap ? '#define USE_BUMPMAP' : '',
			parameters.normalMap ? '#define USE_NORMALMAP' : '',
			parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
			parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
			parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',

			parameters.anisotropy ? '#define USE_ANISOTROPY' : '',
			parameters.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',

			parameters.clearcoat ? '#define USE_CLEARCOAT' : '',
			parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
			parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
			parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',

			parameters.iridescence ? '#define USE_IRIDESCENCE' : '',
			parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
			parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',

			parameters.specularMap ? '#define USE_SPECULARMAP' : '',
			parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
			parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',

			parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
			parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',

			parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
			parameters.alphaTest ? '#define USE_ALPHATEST' : '',
			parameters.alphaHash ? '#define USE_ALPHAHASH' : '',

			parameters.sheen ? '#define USE_SHEEN' : '',
			parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
			parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',

			parameters.transmission ? '#define USE_TRANSMISSION' : '',
			parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
			parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',

			parameters.vertexTangents && parameters.flatShading === false ? '#define USE_TANGENT' : '',
			parameters.vertexColors || parameters.instancingColor ? '#define USE_COLOR' : '',
			parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
			parameters.vertexUv1s ? '#define USE_UV1' : '',
			parameters.vertexUv2s ? '#define USE_UV2' : '',
			parameters.vertexUv3s ? '#define USE_UV3' : '',

			parameters.pointsUvs ? '#define USE_POINTS_UV' : '',

			parameters.gradientMap ? '#define USE_GRADIENTMAP' : '',

			parameters.flatShading ? '#define FLAT_SHADED' : '',

			parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
			parameters.flipSided ? '#define FLIP_SIDED' : '',

			parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
			parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',

			parameters.premultipliedAlpha ? '#define PREMULTIPLIED_ALPHA' : '',

			parameters.numLightProbes > 0 ? '#define USE_LIGHT_PROBES' : '',

			parameters.useLegacyLights ? '#define LEGACY_LIGHTS' : '',

			parameters.decodeVideoTexture ? '#define DECODE_VIDEO_TEXTURE' : '',

			parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',

			'uniform mat4 viewMatrix;',
			'uniform vec3 cameraPosition;',
			'uniform bool isOrthographic;',

			( parameters.toneMapping !== NoToneMapping ) ? '#define TONE_MAPPING' : '',
			( parameters.toneMapping !== NoToneMapping ) ? ShaderChunk[ 'tonemapping_pars_fragment' ] : '', // this code is required here because it is used by the toneMapping() function defined below
			( parameters.toneMapping !== NoToneMapping ) ? getToneMappingFunction( 'toneMapping', parameters.toneMapping ) : '',

			parameters.dithering ? '#define DITHERING' : '',
			parameters.opaque ? '#define OPAQUE' : '',

			ShaderChunk[ 'colorspace_pars_fragment' ], // this code is required here because it is used by the various encoding/decoding function defined below
			getTexelEncodingFunction( 'linearToOutputTexel', parameters.outputColorSpace ),

			parameters.useDepthPacking ? '#define DEPTH_PACKING ' + parameters.depthPacking : '',

			'\n'

		].filter( filterEmptyLine ).join( '\n' );

	}

	vertexShader = resolveIncludes( vertexShader );
	vertexShader = replaceLightNums( vertexShader, parameters );
	vertexShader = replaceClippingPlaneNums( vertexShader, parameters );

	fragmentShader = resolveIncludes( fragmentShader );
	fragmentShader = replaceLightNums( fragmentShader, parameters );
	fragmentShader = replaceClippingPlaneNums( fragmentShader, parameters );

	vertexShader = unrollLoops( vertexShader );
	fragmentShader = unrollLoops( fragmentShader );

	if ( parameters.isRawShaderMaterial !== true ) {

		// GLSL 3.0 conversion for built-in materials and ShaderMaterial

		versionString = '#version 300 es\n';

		prefixVertex = [
			customVertexExtensions,
			'#define attribute in',
			'#define varying out',
			'#define texture2D texture'
		].join( '\n' ) + '\n' + prefixVertex;

		prefixFragment = [
			'#define varying in',
			( parameters.glslVersion === GLSL3 ) ? '' : 'layout(location = 0) out highp vec4 pc_fragColor;',
			( parameters.glslVersion === GLSL3 ) ? '' : '#define gl_FragColor pc_fragColor',
			'#define gl_FragDepthEXT gl_FragDepth',
			'#define texture2D texture',
			'#define textureCube texture',
			'#define texture2DProj textureProj',
			'#define texture2DLodEXT textureLod',
			'#define texture2DProjLodEXT textureProjLod',
			'#define textureCubeLodEXT textureLod',
			'#define texture2DGradEXT textureGrad',
			'#define texture2DProjGradEXT textureProjGrad',
			'#define textureCubeGradEXT textureGrad'
		].join( '\n' ) + '\n' + prefixFragment;

	}

	const vertexGlsl = versionString + prefixVertex + vertexShader;
	const fragmentGlsl = versionString + prefixFragment + fragmentShader;

	// console.log( '*VERTEX*', vertexGlsl );
	// console.log( '*FRAGMENT*', fragmentGlsl );

	const glVertexShader = WebGLShader( gl, gl.VERTEX_SHADER, vertexGlsl );
	const glFragmentShader = WebGLShader( gl, gl.FRAGMENT_SHADER, fragmentGlsl );

	gl.attachShader( program, glVertexShader );
	gl.attachShader( program, glFragmentShader );

	// Force a particular attribute to index 0.

	if ( parameters.index0AttributeName !== undefined ) {

		gl.bindAttribLocation( program, 0, parameters.index0AttributeName );

	} else if ( parameters.morphTargets === true ) {

		// programs with morphTargets displace position out of attribute 0
		gl.bindAttribLocation( program, 0, 'position' );

	}

	gl.linkProgram( program );

	function onFirstUse( self ) {

		// check for link errors
		if ( renderer.debug.checkShaderErrors ) {

			const programLog = gl.getProgramInfoLog( program ).trim();
			const vertexLog = gl.getShaderInfoLog( glVertexShader ).trim();
			const fragmentLog = gl.getShaderInfoLog( glFragmentShader ).trim();

			let runnable = true;
			let haveDiagnostics = true;

			if ( gl.getProgramParameter( program, gl.LINK_STATUS ) === false ) {

				runnable = false;

				if ( typeof renderer.debug.onShaderError === 'function' ) {

					renderer.debug.onShaderError( gl, program, glVertexShader, glFragmentShader );

				} else {

					// default error reporting

					const vertexErrors = getShaderErrors( gl, glVertexShader, 'vertex' );
					const fragmentErrors = getShaderErrors( gl, glFragmentShader, 'fragment' );

					console.error(
						'THREE.WebGLProgram: Shader Error ' + gl.getError() + ' - ' +
						'VALIDATE_STATUS ' + gl.getProgramParameter( program, gl.VALIDATE_STATUS ) + '\n\n' +
						'Material Name: ' + self.name + '\n' +
						'Material Type: ' + self.type + '\n\n' +
						'Program Info Log: ' + programLog + '\n' +
						vertexErrors + '\n' +
						fragmentErrors
					);

				}

			} else if ( programLog !== '' ) {

				console.warn( 'THREE.WebGLProgram: Program Info Log:', programLog );

			} else if ( vertexLog === '' || fragmentLog === '' ) {

				haveDiagnostics = false;

			}

			if ( haveDiagnostics ) {

				self.diagnostics = {

					runnable: runnable,

					programLog: programLog,

					vertexShader: {

						log: vertexLog,
						prefix: prefixVertex

					},

					fragmentShader: {

						log: fragmentLog,
						prefix: prefixFragment

					}

				};

			}

		}

		// Clean up

		// Crashes in iOS9 and iOS10. #18402
		// gl.detachShader( program, glVertexShader );
		// gl.detachShader( program, glFragmentShader );

		gl.deleteShader( glVertexShader );
		gl.deleteShader( glFragmentShader );

		cachedUniforms = new WebGLUniforms( gl, program );
		cachedAttributes = fetchAttributeLocations( gl, program );

	}

	// set up caching for uniform locations

	let cachedUniforms;

	this.getUniforms = function () {

		if ( cachedUniforms === undefined ) {

			// Populates cachedUniforms and cachedAttributes
			onFirstUse( this );

		}

		return cachedUniforms;

	};

	// set up caching for attribute locations

	let cachedAttributes;

	this.getAttributes = function () {

		if ( cachedAttributes === undefined ) {

			// Populates cachedAttributes and cachedUniforms
			onFirstUse( this );

		}

		return cachedAttributes;

	};

	// indicate when the program is ready to be used. if the KHR_parallel_shader_compile extension isn't supported,
	// flag the program as ready immediately. It may cause a stall when it's first used.

	let programReady = ( parameters.rendererExtensionParallelShaderCompile === false );

	this.isReady = function () {

		if ( programReady === false ) {

			programReady = gl.getProgramParameter( program, COMPLETION_STATUS_KHR );

		}

		return programReady;

	};

	// free resource

	this.destroy = function () {

		bindingStates.releaseStatesOfProgram( this );

		gl.deleteProgram( program );
		this.program = undefined;

	};

	//

	this.type = parameters.shaderType;
	this.name = parameters.shaderName;
	this.id = programIdCount ++;
	this.cacheKey = cacheKey;
	this.usedTimes = 1;
	this.program = program;
	this.vertexShader = glVertexShader;
	this.fragmentShader = glFragmentShader;

	return this;

}

let _id$1 = 0;

class WebGLShaderCache {

	constructor() {

		this.shaderCache = new Map();
		this.materialCache = new Map();

	}

	update( material ) {

		const vertexShader = material.vertexShader;
		const fragmentShader = material.fragmentShader;

		const vertexShaderStage = this._getShaderStage( vertexShader );
		const fragmentShaderStage = this._getShaderStage( fragmentShader );

		const materialShaders = this._getShaderCacheForMaterial( material );

		if ( materialShaders.has( vertexShaderStage ) === false ) {

			materialShaders.add( vertexShaderStage );
			vertexShaderStage.usedTimes ++;

		}

		if ( materialShaders.has( fragmentShaderStage ) === false ) {

			materialShaders.add( fragmentShaderStage );
			fragmentShaderStage.usedTimes ++;

		}

		return this;

	}

	remove( material ) {

		const materialShaders = this.materialCache.get( material );

		for ( const shaderStage of materialShaders ) {

			shaderStage.usedTimes --;

			if ( shaderStage.usedTimes === 0 ) this.shaderCache.delete( shaderStage.code );

		}

		this.materialCache.delete( material );

		return this;

	}

	getVertexShaderID( material ) {

		return this._getShaderStage( material.vertexShader ).id;

	}

	getFragmentShaderID( material ) {

		return this._getShaderStage( material.fragmentShader ).id;

	}

	dispose() {

		this.shaderCache.clear();
		this.materialCache.clear();

	}

	_getShaderCacheForMaterial( material ) {

		const cache = this.materialCache;
		let set = cache.get( material );

		if ( set === undefined ) {

			set = new Set();
			cache.set( material, set );

		}

		return set;

	}

	_getShaderStage( code ) {

		const cache = this.shaderCache;
		let stage = cache.get( code );

		if ( stage === undefined ) {

			stage = new WebGLShaderStage( code );
			cache.set( code, stage );

		}

		return stage;

	}

}

class WebGLShaderStage {

	constructor( code ) {

		this.id = _id$1 ++;

		this.code = code;
		this.usedTimes = 0;

	}

}

function WebGLPrograms( renderer, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping ) {

	const _programLayers = new Layers();
	const _customShaders = new WebGLShaderCache();
	const _activeChannels = new Set();
	const programs = [];

	const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
	const SUPPORTS_VERTEX_TEXTURES = capabilities.vertexTextures;

	let precision = capabilities.precision;

	const shaderIDs = {
		MeshDepthMaterial: 'depth',
		MeshDistanceMaterial: 'distanceRGBA',
		MeshNormalMaterial: 'normal',
		MeshBasicMaterial: 'basic',
		MeshLambertMaterial: 'lambert',
		MeshPhongMaterial: 'phong',
		MeshToonMaterial: 'toon',
		MeshStandardMaterial: 'physical',
		MeshPhysicalMaterial: 'physical',
		MeshMatcapMaterial: 'matcap',
		LineBasicMaterial: 'basic',
		LineDashedMaterial: 'dashed',
		PointsMaterial: 'points',
		ShadowMaterial: 'shadow',
		SpriteMaterial: 'sprite'
	};

	function getChannel( value ) {

		_activeChannels.add( value );

		if ( value === 0 ) return 'uv';

		return `uv${ value }`;

	}

	function getParameters( material, lights, shadows, scene, object ) {

		const fog = scene.fog;
		const geometry = object.geometry;
		const environment = material.isMeshStandardMaterial ? scene.environment : null;

		const envMap = ( material.isMeshStandardMaterial ? cubeuvmaps : cubemaps ).get( material.envMap || environment );
		const envMapCubeUVHeight = ( !! envMap ) && ( envMap.mapping === CubeUVReflectionMapping ) ? envMap.image.height : null;

		const shaderID = shaderIDs[ material.type ];

		// heuristics to create shader parameters according to lights in the scene
		// (not to blow over maxLights budget)

		if ( material.precision !== null ) {

			precision = capabilities.getMaxPrecision( material.precision );

			if ( precision !== material.precision ) {

				console.warn( 'THREE.WebGLProgram.getParameters:', material.precision, 'not supported, using', precision, 'instead.' );

			}

		}

		//

		const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
		const morphTargetsCount = ( morphAttribute !== undefined ) ? morphAttribute.length : 0;

		let morphTextureStride = 0;

		if ( geometry.morphAttributes.position !== undefined ) morphTextureStride = 1;
		if ( geometry.morphAttributes.normal !== undefined ) morphTextureStride = 2;
		if ( geometry.morphAttributes.color !== undefined ) morphTextureStride = 3;

		//

		let vertexShader, fragmentShader;
		let customVertexShaderID, customFragmentShaderID;

		if ( shaderID ) {

			const shader = ShaderLib[ shaderID ];

			vertexShader = shader.vertexShader;
			fragmentShader = shader.fragmentShader;

		} else {

			vertexShader = material.vertexShader;
			fragmentShader = material.fragmentShader;

			_customShaders.update( material );

			customVertexShaderID = _customShaders.getVertexShaderID( material );
			customFragmentShaderID = _customShaders.getFragmentShaderID( material );

		}

		const currentRenderTarget = renderer.getRenderTarget();

		const IS_INSTANCEDMESH = object.isInstancedMesh === true;
		const IS_BATCHEDMESH = object.isBatchedMesh === true;

		const HAS_MAP = !! material.map;
		const HAS_MATCAP = !! material.matcap;
		const HAS_ENVMAP = !! envMap;
		const HAS_AOMAP = !! material.aoMap;
		const HAS_LIGHTMAP = !! material.lightMap;
		const HAS_BUMPMAP = !! material.bumpMap;
		const HAS_NORMALMAP = !! material.normalMap;
		const HAS_DISPLACEMENTMAP = !! material.displacementMap;
		const HAS_EMISSIVEMAP = !! material.emissiveMap;

		const HAS_METALNESSMAP = !! material.metalnessMap;
		const HAS_ROUGHNESSMAP = !! material.roughnessMap;

		const HAS_ANISOTROPY = material.anisotropy > 0;
		const HAS_CLEARCOAT = material.clearcoat > 0;
		const HAS_IRIDESCENCE = material.iridescence > 0;
		const HAS_SHEEN = material.sheen > 0;
		const HAS_TRANSMISSION = material.transmission > 0;

		const HAS_ANISOTROPYMAP = HAS_ANISOTROPY && !! material.anisotropyMap;

		const HAS_CLEARCOATMAP = HAS_CLEARCOAT && !! material.clearcoatMap;
		const HAS_CLEARCOAT_NORMALMAP = HAS_CLEARCOAT && !! material.clearcoatNormalMap;
		const HAS_CLEARCOAT_ROUGHNESSMAP = HAS_CLEARCOAT && !! material.clearcoatRoughnessMap;

		const HAS_IRIDESCENCEMAP = HAS_IRIDESCENCE && !! material.iridescenceMap;
		const HAS_IRIDESCENCE_THICKNESSMAP = HAS_IRIDESCENCE && !! material.iridescenceThicknessMap;

		const HAS_SHEEN_COLORMAP = HAS_SHEEN && !! material.sheenColorMap;
		const HAS_SHEEN_ROUGHNESSMAP = HAS_SHEEN && !! material.sheenRoughnessMap;

		const HAS_SPECULARMAP = !! material.specularMap;
		const HAS_SPECULAR_COLORMAP = !! material.specularColorMap;
		const HAS_SPECULAR_INTENSITYMAP = !! material.specularIntensityMap;

		const HAS_TRANSMISSIONMAP = HAS_TRANSMISSION && !! material.transmissionMap;
		const HAS_THICKNESSMAP = HAS_TRANSMISSION && !! material.thicknessMap;

		const HAS_GRADIENTMAP = !! material.gradientMap;

		const HAS_ALPHAMAP = !! material.alphaMap;

		const HAS_ALPHATEST = material.alphaTest > 0;

		const HAS_ALPHAHASH = !! material.alphaHash;

		const HAS_EXTENSIONS = !! material.extensions;

		let toneMapping = NoToneMapping;

		if ( material.toneMapped ) {

			if ( currentRenderTarget === null || currentRenderTarget.isXRRenderTarget === true ) {

				toneMapping = renderer.toneMapping;

			}

		}

		const parameters = {

			shaderID: shaderID,
			shaderType: material.type,
			shaderName: material.name,

			vertexShader: vertexShader,
			fragmentShader: fragmentShader,
			defines: material.defines,

			customVertexShaderID: customVertexShaderID,
			customFragmentShaderID: customFragmentShaderID,

			isRawShaderMaterial: material.isRawShaderMaterial === true,
			glslVersion: material.glslVersion,

			precision: precision,

			batching: IS_BATCHEDMESH,
			instancing: IS_INSTANCEDMESH,
			instancingColor: IS_INSTANCEDMESH && object.instanceColor !== null,
			instancingMorph: IS_INSTANCEDMESH && object.morphTexture !== null,

			supportsVertexTextures: SUPPORTS_VERTEX_TEXTURES,
			outputColorSpace: ( currentRenderTarget === null ) ? renderer.outputColorSpace : ( currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.colorSpace : LinearSRGBColorSpace ),
			alphaToCoverage: !! material.alphaToCoverage,

			map: HAS_MAP,
			matcap: HAS_MATCAP,
			envMap: HAS_ENVMAP,
			envMapMode: HAS_ENVMAP && envMap.mapping,
			envMapCubeUVHeight: envMapCubeUVHeight,
			aoMap: HAS_AOMAP,
			lightMap: HAS_LIGHTMAP,
			bumpMap: HAS_BUMPMAP,
			normalMap: HAS_NORMALMAP,
			displacementMap: SUPPORTS_VERTEX_TEXTURES && HAS_DISPLACEMENTMAP,
			emissiveMap: HAS_EMISSIVEMAP,

			normalMapObjectSpace: HAS_NORMALMAP && material.normalMapType === ObjectSpaceNormalMap,
			normalMapTangentSpace: HAS_NORMALMAP && material.normalMapType === TangentSpaceNormalMap,

			metalnessMap: HAS_METALNESSMAP,
			roughnessMap: HAS_ROUGHNESSMAP,

			anisotropy: HAS_ANISOTROPY,
			anisotropyMap: HAS_ANISOTROPYMAP,

			clearcoat: HAS_CLEARCOAT,
			clearcoatMap: HAS_CLEARCOATMAP,
			clearcoatNormalMap: HAS_CLEARCOAT_NORMALMAP,
			clearcoatRoughnessMap: HAS_CLEARCOAT_ROUGHNESSMAP,

			iridescence: HAS_IRIDESCENCE,
			iridescenceMap: HAS_IRIDESCENCEMAP,
			iridescenceThicknessMap: HAS_IRIDESCENCE_THICKNESSMAP,

			sheen: HAS_SHEEN,
			sheenColorMap: HAS_SHEEN_COLORMAP,
			sheenRoughnessMap: HAS_SHEEN_ROUGHNESSMAP,

			specularMap: HAS_SPECULARMAP,
			specularColorMap: HAS_SPECULAR_COLORMAP,
			specularIntensityMap: HAS_SPECULAR_INTENSITYMAP,

			transmission: HAS_TRANSMISSION,
			transmissionMap: HAS_TRANSMISSIONMAP,
			thicknessMap: HAS_THICKNESSMAP,

			gradientMap: HAS_GRADIENTMAP,

			opaque: material.transparent === false && material.blending === NormalBlending && material.alphaToCoverage === false,

			alphaMap: HAS_ALPHAMAP,
			alphaTest: HAS_ALPHATEST,
			alphaHash: HAS_ALPHAHASH,

			combine: material.combine,

			//

			mapUv: HAS_MAP && getChannel( material.map.channel ),
			aoMapUv: HAS_AOMAP && getChannel( material.aoMap.channel ),
			lightMapUv: HAS_LIGHTMAP && getChannel( material.lightMap.channel ),
			bumpMapUv: HAS_BUMPMAP && getChannel( material.bumpMap.channel ),
			normalMapUv: HAS_NORMALMAP && getChannel( material.normalMap.channel ),
			displacementMapUv: HAS_DISPLACEMENTMAP && getChannel( material.displacementMap.channel ),
			emissiveMapUv: HAS_EMISSIVEMAP && getChannel( material.emissiveMap.channel ),

			metalnessMapUv: HAS_METALNESSMAP && getChannel( material.metalnessMap.channel ),
			roughnessMapUv: HAS_ROUGHNESSMAP && getChannel( material.roughnessMap.channel ),

			anisotropyMapUv: HAS_ANISOTROPYMAP && getChannel( material.anisotropyMap.channel ),

			clearcoatMapUv: HAS_CLEARCOATMAP && getChannel( material.clearcoatMap.channel ),
			clearcoatNormalMapUv: HAS_CLEARCOAT_NORMALMAP && getChannel( material.clearcoatNormalMap.channel ),
			clearcoatRoughnessMapUv: HAS_CLEARCOAT_ROUGHNESSMAP && getChannel( material.clearcoatRoughnessMap.channel ),

			iridescenceMapUv: HAS_IRIDESCENCEMAP && getChannel( material.iridescenceMap.channel ),
			iridescenceThicknessMapUv: HAS_IRIDESCENCE_THICKNESSMAP && getChannel( material.iridescenceThicknessMap.channel ),

			sheenColorMapUv: HAS_SHEEN_COLORMAP && getChannel( material.sheenColorMap.channel ),
			sheenRoughnessMapUv: HAS_SHEEN_ROUGHNESSMAP && getChannel( material.sheenRoughnessMap.channel ),

			specularMapUv: HAS_SPECULARMAP && getChannel( material.specularMap.channel ),
			specularColorMapUv: HAS_SPECULAR_COLORMAP && getChannel( material.specularColorMap.channel ),
			specularIntensityMapUv: HAS_SPECULAR_INTENSITYMAP && getChannel( material.specularIntensityMap.channel ),

			transmissionMapUv: HAS_TRANSMISSIONMAP && getChannel( material.transmissionMap.channel ),
			thicknessMapUv: HAS_THICKNESSMAP && getChannel( material.thicknessMap.channel ),

			alphaMapUv: HAS_ALPHAMAP && getChannel( material.alphaMap.channel ),

			//

			vertexTangents: !! geometry.attributes.tangent && ( HAS_NORMALMAP || HAS_ANISOTROPY ),
			vertexColors: material.vertexColors,
			vertexAlphas: material.vertexColors === true && !! geometry.attributes.color && geometry.attributes.color.itemSize === 4,

			pointsUvs: object.isPoints === true && !! geometry.attributes.uv && ( HAS_MAP || HAS_ALPHAMAP ),

			fog: !! fog,
			useFog: material.fog === true,
			fogExp2: ( !! fog && fog.isFogExp2 ),

			flatShading: material.flatShading === true,

			sizeAttenuation: material.sizeAttenuation === true,
			logarithmicDepthBuffer: logarithmicDepthBuffer,

			skinning: object.isSkinnedMesh === true,

			morphTargets: geometry.morphAttributes.position !== undefined,
			morphNormals: geometry.morphAttributes.normal !== undefined,
			morphColors: geometry.morphAttributes.color !== undefined,
			morphTargetsCount: morphTargetsCount,
			morphTextureStride: morphTextureStride,

			numDirLights: lights.directional.length,
			numPointLights: lights.point.length,
			numSpotLights: lights.spot.length,
			numSpotLightMaps: lights.spotLightMap.length,
			numRectAreaLights: lights.rectArea.length,
			numHemiLights: lights.hemi.length,

			numDirLightShadows: lights.directionalShadowMap.length,
			numPointLightShadows: lights.pointShadowMap.length,
			numSpotLightShadows: lights.spotShadowMap.length,
			numSpotLightShadowsWithMaps: lights.numSpotLightShadowsWithMaps,

			numLightProbes: lights.numLightProbes,

			numClippingPlanes: clipping.numPlanes,
			numClipIntersection: clipping.numIntersection,

			dithering: material.dithering,

			shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
			shadowMapType: renderer.shadowMap.type,

			toneMapping: toneMapping,
			useLegacyLights: renderer._useLegacyLights,

			decodeVideoTexture: HAS_MAP && ( material.map.isVideoTexture === true ) && ( ColorManagement.getTransfer( material.map.colorSpace ) === SRGBTransfer ),

			premultipliedAlpha: material.premultipliedAlpha,

			doubleSided: material.side === DoubleSide,
			flipSided: material.side === BackSide,

			useDepthPacking: material.depthPacking >= 0,
			depthPacking: material.depthPacking || 0,

			index0AttributeName: material.index0AttributeName,

			extensionClipCullDistance: HAS_EXTENSIONS && material.extensions.clipCullDistance === true && extensions.has( 'WEBGL_clip_cull_distance' ),
			extensionMultiDraw: HAS_EXTENSIONS && material.extensions.multiDraw === true && extensions.has( 'WEBGL_multi_draw' ),

			rendererExtensionParallelShaderCompile: extensions.has( 'KHR_parallel_shader_compile' ),

			customProgramCacheKey: material.customProgramCacheKey()

		};

		// the usage of getChannel() determines the active texture channels for this shader

		parameters.vertexUv1s = _activeChannels.has( 1 );
		parameters.vertexUv2s = _activeChannels.has( 2 );
		parameters.vertexUv3s = _activeChannels.has( 3 );

		_activeChannels.clear();

		return parameters;

	}

	function getProgramCacheKey( parameters ) {

		const array = [];

		if ( parameters.shaderID ) {

			array.push( parameters.shaderID );

		} else {

			array.push( parameters.customVertexShaderID );
			array.push( parameters.customFragmentShaderID );

		}

		if ( parameters.defines !== undefined ) {

			for ( const name in parameters.defines ) {

				array.push( name );
				array.push( parameters.defines[ name ] );

			}

		}

		if ( parameters.isRawShaderMaterial === false ) {

			getProgramCacheKeyParameters( array, parameters );
			getProgramCacheKeyBooleans( array, parameters );
			array.push( renderer.outputColorSpace );

		}

		array.push( parameters.customProgramCacheKey );

		return array.join();

	}

	function getProgramCacheKeyParameters( array, parameters ) {

		array.push( parameters.precision );
		array.push( parameters.outputColorSpace );
		array.push( parameters.envMapMode );
		array.push( parameters.envMapCubeUVHeight );
		array.push( parameters.mapUv );
		array.push( parameters.alphaMapUv );
		array.push( parameters.lightMapUv );
		array.push( parameters.aoMapUv );
		array.push( parameters.bumpMapUv );
		array.push( parameters.normalMapUv );
		array.push( parameters.displacementMapUv );
		array.push( parameters.emissiveMapUv );
		array.push( parameters.metalnessMapUv );
		array.push( parameters.roughnessMapUv );
		array.push( parameters.anisotropyMapUv );
		array.push( parameters.clearcoatMapUv );
		array.push( parameters.clearcoatNormalMapUv );
		array.push( parameters.clearcoatRoughnessMapUv );
		array.push( parameters.iridescenceMapUv );
		array.push( parameters.iridescenceThicknessMapUv );
		array.push( parameters.sheenColorMapUv );
		array.push( parameters.sheenRoughnessMapUv );
		array.push( parameters.specularMapUv );
		array.push( parameters.specularColorMapUv );
		array.push( parameters.specularIntensityMapUv );
		array.push( parameters.transmissionMapUv );
		array.push( parameters.thicknessMapUv );
		array.push( parameters.combine );
		array.push( parameters.fogExp2 );
		array.push( parameters.sizeAttenuation );
		array.push( parameters.morphTargetsCount );
		array.push( parameters.morphAttributeCount );
		array.push( parameters.numDirLights );
		array.push( parameters.numPointLights );
		array.push( parameters.numSpotLights );
		array.push( parameters.numSpotLightMaps );
		array.push( parameters.numHemiLights );
		array.push( parameters.numRectAreaLights );
		array.push( parameters.numDirLightShadows );
		array.push( parameters.numPointLightShadows );
		array.push( parameters.numSpotLightShadows );
		array.push( parameters.numSpotLightShadowsWithMaps );
		array.push( parameters.numLightProbes );
		array.push( parameters.shadowMapType );
		array.push( parameters.toneMapping );
		array.push( parameters.numClippingPlanes );
		array.push( parameters.numClipIntersection );
		array.push( parameters.depthPacking );

	}

	function getProgramCacheKeyBooleans( array, parameters ) {

		_programLayers.disableAll();

		if ( parameters.supportsVertexTextures )
			_programLayers.enable( 0 );
		if ( parameters.instancing )
			_programLayers.enable( 1 );
		if ( parameters.instancingColor )
			_programLayers.enable( 2 );
		if ( parameters.instancingMorph )
			_programLayers.enable( 3 );
		if ( parameters.matcap )
			_programLayers.enable( 4 );
		if ( parameters.envMap )
			_programLayers.enable( 5 );
		if ( parameters.normalMapObjectSpace )
			_programLayers.enable( 6 );
		if ( parameters.normalMapTangentSpace )
			_programLayers.enable( 7 );
		if ( parameters.clearcoat )
			_programLayers.enable( 8 );
		if ( parameters.iridescence )
			_programLayers.enable( 9 );
		if ( parameters.alphaTest )
			_programLayers.enable( 10 );
		if ( parameters.vertexColors )
			_programLayers.enable( 11 );
		if ( parameters.vertexAlphas )
			_programLayers.enable( 12 );
		if ( parameters.vertexUv1s )
			_programLayers.enable( 13 );
		if ( parameters.vertexUv2s )
			_programLayers.enable( 14 );
		if ( parameters.vertexUv3s )
			_programLayers.enable( 15 );
		if ( parameters.vertexTangents )
			_programLayers.enable( 16 );
		if ( parameters.anisotropy )
			_programLayers.enable( 17 );
		if ( parameters.alphaHash )
			_programLayers.enable( 18 );
		if ( parameters.batching )
			_programLayers.enable( 19 );

		array.push( _programLayers.mask );
		_programLayers.disableAll();

		if ( parameters.fog )
			_programLayers.enable( 0 );
		if ( parameters.useFog )
			_programLayers.enable( 1 );
		if ( parameters.flatShading )
			_programLayers.enable( 2 );
		if ( parameters.logarithmicDepthBuffer )
			_programLayers.enable( 3 );
		if ( parameters.skinning )
			_programLayers.enable( 4 );
		if ( parameters.morphTargets )
			_programLayers.enable( 5 );
		if ( parameters.morphNormals )
			_programLayers.enable( 6 );
		if ( parameters.morphColors )
			_programLayers.enable( 7 );
		if ( parameters.premultipliedAlpha )
			_programLayers.enable( 8 );
		if ( parameters.shadowMapEnabled )
			_programLayers.enable( 9 );
		if ( parameters.useLegacyLights )
			_programLayers.enable( 10 );
		if ( parameters.doubleSided )
			_programLayers.enable( 11 );
		if ( parameters.flipSided )
			_programLayers.enable( 12 );
		if ( parameters.useDepthPacking )
			_programLayers.enable( 13 );
		if ( parameters.dithering )
			_programLayers.enable( 14 );
		if ( parameters.transmission )
			_programLayers.enable( 15 );
		if ( parameters.sheen )
			_programLayers.enable( 16 );
		if ( parameters.opaque )
			_programLayers.enable( 17 );
		if ( parameters.pointsUvs )
			_programLayers.enable( 18 );
		if ( parameters.decodeVideoTexture )
			_programLayers.enable( 19 );
		if ( parameters.alphaToCoverage )
			_programLayers.enable( 20 );

		array.push( _programLayers.mask );

	}

	function getUniforms( material ) {

		const shaderID = shaderIDs[ material.type ];
		let uniforms;

		if ( shaderID ) {

			const shader = ShaderLib[ shaderID ];
			uniforms = UniformsUtils.clone( shader.uniforms );

		} else {

			uniforms = material.uniforms;

		}

		return uniforms;

	}

	function acquireProgram( parameters, cacheKey ) {

		let program;

		// Check if code has been already compiled
		for ( let p = 0, pl = programs.length; p < pl; p ++ ) {

			const preexistingProgram = programs[ p ];

			if ( preexistingProgram.cacheKey === cacheKey ) {

				program = preexistingProgram;
				++ program.usedTimes;

				break;

			}

		}

		if ( program === undefined ) {

			program = new WebGLProgram( renderer, cacheKey, parameters, bindingStates );
			programs.push( program );

		}

		return program;

	}

	function releaseProgram( program ) {

		if ( -- program.usedTimes === 0 ) {

			// Remove from unordered set
			const i = programs.indexOf( program );
			programs[ i ] = programs[ programs.length - 1 ];
			programs.pop();

			// Free WebGL resources
			program.destroy();

		}

	}

	function releaseShaderCache( material ) {

		_customShaders.remove( material );

	}

	function dispose() {

		_customShaders.dispose();

	}

	return {
		getParameters: getParameters,
		getProgramCacheKey: getProgramCacheKey,
		getUniforms: getUniforms,
		acquireProgram: acquireProgram,
		releaseProgram: releaseProgram,
		releaseShaderCache: releaseShaderCache,
		// Exposed for resource monitoring & error feedback via renderer.info:
		programs: programs,
		dispose: dispose
	};

}

function WebGLProperties() {

	let properties = new WeakMap();

	function get( object ) {

		let map = properties.get( object );

		if ( map === undefined ) {

			map = {};
			properties.set( object, map );

		}

		return map;

	}

	function remove( object ) {

		properties.delete( object );

	}

	function update( object, key, value ) {

		properties.get( object )[ key ] = value;

	}

	function dispose() {

		properties = new WeakMap();

	}

	return {
		get: get,
		remove: remove,
		update: update,
		dispose: dispose
	};

}

function painterSortStable( a, b ) {

	if ( a.groupOrder !== b.groupOrder ) {

		return a.groupOrder - b.groupOrder;

	} else if ( a.renderOrder !== b.renderOrder ) {

		return a.renderOrder - b.renderOrder;

	} else if ( a.material.id !== b.material.id ) {

		return a.material.id - b.material.id;

	} else if ( a.z !== b.z ) {

		return a.z - b.z;

	} else {

		return a.id - b.id;

	}

}

function reversePainterSortStable( a, b ) {

	if ( a.groupOrder !== b.groupOrder ) {

		return a.groupOrder - b.groupOrder;

	} else if ( a.renderOrder !== b.renderOrder ) {

		return a.renderOrder - b.renderOrder;

	} else if ( a.z !== b.z ) {

		return b.z - a.z;

	} else {

		return a.id - b.id;

	}

}


function WebGLRenderList() {

	const renderItems = [];
	let renderItemsIndex = 0;

	const opaque = [];
	const transmissive = [];
	const transparent = [];

	function init() {

		renderItemsIndex = 0;

		opaque.length = 0;
		transmissive.length = 0;
		transparent.length = 0;

	}

	function getNextRenderItem( object, geometry, material, groupOrder, z, group ) {

		let renderItem = renderItems[ renderItemsIndex ];

		if ( renderItem === undefined ) {

			renderItem = {
				id: object.id,
				object: object,
				geometry: geometry,
				material: material,
				groupOrder: groupOrder,
				renderOrder: object.renderOrder,
				z: z,
				group: group
			};

			renderItems[ renderItemsIndex ] = renderItem;

		} else {

			renderItem.id = object.id;
			renderItem.object = object;
			renderItem.geometry = geometry;
			renderItem.material = material;
			renderItem.groupOrder = groupOrder;
			renderItem.renderOrder = object.renderOrder;
			renderItem.z = z;
			renderItem.group = group;

		}

		renderItemsIndex ++;

		return renderItem;

	}

	function push( object, geometry, material, groupOrder, z, group ) {

		const renderItem = getNextRenderItem( object, geometry, material, groupOrder, z, group );

		if ( material.transmission > 0.0 ) {

			transmissive.push( renderItem );

		} else if ( material.transparent === true ) {

			transparent.push( renderItem );

		} else {

			opaque.push( renderItem );

		}

	}

	function unshift( object, geometry, material, groupOrder, z, group ) {

		const renderItem = getNextRenderItem( object, geometry, material, groupOrder, z, group );

		if ( material.transmission > 0.0 ) {

			transmissive.unshift( renderItem );

		} else if ( material.transparent === true ) {

			transparent.unshift( renderItem );

		} else {

			opaque.unshift( renderItem );

		}

	}

	function sort( customOpaqueSort, customTransparentSort ) {

		if ( opaque.length > 1 ) opaque.sort( customOpaqueSort || painterSortStable );
		if ( transmissive.length > 1 ) transmissive.sort( customTransparentSort || reversePainterSortStable );
		if ( transparent.length > 1 ) transparent.sort( customTransparentSort || reversePainterSortStable );

	}

	function finish() {

		// Clear references from inactive renderItems in the list

		for ( let i = renderItemsIndex, il = renderItems.length; i < il; i ++ ) {

			const renderItem = renderItems[ i ];

			if ( renderItem.id === null ) break;

			renderItem.id = null;
			renderItem.object = null;
			renderItem.geometry = null;
			renderItem.material = null;
			renderItem.group = null;

		}

	}

	return {

		opaque: opaque,
		transmissive: transmissive,
		transparent: transparent,

		init: init,
		push: push,
		unshift: unshift,
		finish: finish,

		sort: sort
	};

}

function WebGLRenderLists() {

	let lists = new WeakMap();

	function get( scene, renderCallDepth ) {

		const listArray = lists.get( scene );
		let list;

		if ( listArray === undefined ) {

			list = new WebGLRenderList();
			lists.set( scene, [ list ] );

		} else {

			if ( renderCallDepth >= listArray.length ) {

				list = new WebGLRenderList();
				listArray.push( list );

			} else {

				list = listArray[ renderCallDepth ];

			}

		}

		return list;

	}

	function dispose() {

		lists = new WeakMap();

	}

	return {
		get: get,
		dispose: dispose
	};

}

function UniformsCache() {

	const lights = {};

	return {

		get: function ( light ) {

			if ( lights[ light.id ] !== undefined ) {

				return lights[ light.id ];

			}

			let uniforms;

			switch ( light.type ) {

				case 'DirectionalLight':
					uniforms = {
						direction: new Vector3(),
						color: new Color()
					};
					break;

				case 'SpotLight':
					uniforms = {
						position: new Vector3(),
						direction: new Vector3(),
						color: new Color(),
						distance: 0,
						coneCos: 0,
						penumbraCos: 0,
						decay: 0
					};
					break;

				case 'PointLight':
					uniforms = {
						position: new Vector3(),
						color: new Color(),
						distance: 0,
						decay: 0
					};
					break;

				case 'HemisphereLight':
					uniforms = {
						direction: new Vector3(),
						skyColor: new Color(),
						groundColor: new Color()
					};
					break;

				case 'RectAreaLight':
					uniforms = {
						color: new Color(),
						position: new Vector3(),
						halfWidth: new Vector3(),
						halfHeight: new Vector3()
					};
					break;

			}

			lights[ light.id ] = uniforms;

			return uniforms;

		}

	};

}

function ShadowUniformsCache() {

	const lights = {};

	return {

		get: function ( light ) {

			if ( lights[ light.id ] !== undefined ) {

				return lights[ light.id ];

			}

			let uniforms;

			switch ( light.type ) {

				case 'DirectionalLight':
					uniforms = {
						shadowBias: 0,
						shadowNormalBias: 0,
						shadowRadius: 1,
						shadowMapSize: new Vector2()
					};
					break;

				case 'SpotLight':
					uniforms = {
						shadowBias: 0,
						shadowNormalBias: 0,
						shadowRadius: 1,
						shadowMapSize: new Vector2()
					};
					break;

				case 'PointLight':
					uniforms = {
						shadowBias: 0,
						shadowNormalBias: 0,
						shadowRadius: 1,
						shadowMapSize: new Vector2(),
						shadowCameraNear: 1,
						shadowCameraFar: 1000
					};
					break;

				// TODO (abelnation): set RectAreaLight shadow uniforms

			}

			lights[ light.id ] = uniforms;

			return uniforms;

		}

	};

}



let nextVersion = 0;

function shadowCastingAndTexturingLightsFirst( lightA, lightB ) {

	return ( lightB.castShadow ? 2 : 0 ) - ( lightA.castShadow ? 2 : 0 ) + ( lightB.map ? 1 : 0 ) - ( lightA.map ? 1 : 0 );

}

function WebGLLights( extensions ) {

	const cache = new UniformsCache();

	const shadowCache = ShadowUniformsCache();

	const state = {

		version: 0,

		hash: {
			directionalLength: - 1,
			pointLength: - 1,
			spotLength: - 1,
			rectAreaLength: - 1,
			hemiLength: - 1,

			numDirectionalShadows: - 1,
			numPointShadows: - 1,
			numSpotShadows: - 1,
			numSpotMaps: - 1,

			numLightProbes: - 1
		},

		ambient: [ 0, 0, 0 ],
		probe: [],
		directional: [],
		directionalShadow: [],
		directionalShadowMap: [],
		directionalShadowMatrix: [],
		spot: [],
		spotLightMap: [],
		spotShadow: [],
		spotShadowMap: [],
		spotLightMatrix: [],
		rectArea: [],
		rectAreaLTC1: null,
		rectAreaLTC2: null,
		point: [],
		pointShadow: [],
		pointShadowMap: [],
		pointShadowMatrix: [],
		hemi: [],
		numSpotLightShadowsWithMaps: 0,
		numLightProbes: 0

	};

	for ( let i = 0; i < 9; i ++ ) state.probe.push( new Vector3() );

	const vector3 = new Vector3();
	const matrix4 = new Matrix4();
	const matrix42 = new Matrix4();

	function setup( lights, useLegacyLights ) {

		let r = 0, g = 0, b = 0;

		for ( let i = 0; i < 9; i ++ ) state.probe[ i ].set( 0, 0, 0 );

		let directionalLength = 0;
		let pointLength = 0;
		let spotLength = 0;
		let rectAreaLength = 0;
		let hemiLength = 0;

		let numDirectionalShadows = 0;
		let numPointShadows = 0;
		let numSpotShadows = 0;
		let numSpotMaps = 0;
		let numSpotShadowsWithMaps = 0;

		let numLightProbes = 0;

		// ordering : [shadow casting + map texturing, map texturing, shadow casting, none ]
		lights.sort( shadowCastingAndTexturingLightsFirst );

		// artist-friendly light intensity scaling factor
		const scaleFactor = ( useLegacyLights === true ) ? Math.PI : 1;

		for ( let i = 0, l = lights.length; i < l; i ++ ) {

			const light = lights[ i ];

			const color = light.color;
			const intensity = light.intensity;
			const distance = light.distance;

			const shadowMap = ( light.shadow && light.shadow.map ) ? light.shadow.map.texture : null;

			if ( light.isAmbientLight ) {

				r += color.r * intensity * scaleFactor;
				g += color.g * intensity * scaleFactor;
				b += color.b * intensity * scaleFactor;

			} else if ( light.isLightProbe ) {

				for ( let j = 0; j < 9; j ++ ) {

					state.probe[ j ].addScaledVector( light.sh.coefficients[ j ], intensity );

				}

				numLightProbes ++;

			} else if ( light.isDirectionalLight ) {

				const uniforms = cache.get( light );

				uniforms.color.copy( light.color ).multiplyScalar( light.intensity * scaleFactor );

				if ( light.castShadow ) {

					const shadow = light.shadow;

					const shadowUniforms = shadowCache.get( light );

					shadowUniforms.shadowBias = shadow.bias;
					shadowUniforms.shadowNormalBias = shadow.normalBias;
					shadowUniforms.shadowRadius = shadow.radius;
					shadowUniforms.shadowMapSize = shadow.mapSize;

					state.directionalShadow[ directionalLength ] = shadowUniforms;
					state.directionalShadowMap[ directionalLength ] = shadowMap;
					state.directionalShadowMatrix[ directionalLength ] = light.shadow.matrix;

					numDirectionalShadows ++;

				}

				state.directional[ directionalLength ] = uniforms;

				directionalLength ++;

			} else if ( light.isSpotLight ) {

				const uniforms = cache.get( light );

				uniforms.position.setFromMatrixPosition( light.matrixWorld );

				uniforms.color.copy( color ).multiplyScalar( intensity * scaleFactor );
				uniforms.distance = distance;

				uniforms.coneCos = Math.cos( light.angle );
				uniforms.penumbraCos = Math.cos( light.angle * ( 1 - light.penumbra ) );
				uniforms.decay = light.decay;

				state.spot[ spotLength ] = uniforms;

				const shadow = light.shadow;

				if ( light.map ) {

					state.spotLightMap[ numSpotMaps ] = light.map;
					numSpotMaps ++;

					// make sure the lightMatrix is up to date
					// TODO : do it if required only
					shadow.updateMatrices( light );

					if ( light.castShadow ) numSpotShadowsWithMaps ++;

				}

				state.spotLightMatrix[ spotLength ] = shadow.matrix;

				if ( light.castShadow ) {

					const shadowUniforms = shadowCache.get( light );

					shadowUniforms.shadowBias = shadow.bias;
					shadowUniforms.shadowNormalBias = shadow.normalBias;
					shadowUniforms.shadowRadius = shadow.radius;
					shadowUniforms.shadowMapSize = shadow.mapSize;

					state.spotShadow[ spotLength ] = shadowUniforms;
					state.spotShadowMap[ spotLength ] = shadowMap;

					numSpotShadows ++;

				}

				spotLength ++;

			} else if ( light.isRectAreaLight ) {

				const uniforms = cache.get( light );

				uniforms.color.copy( color ).multiplyScalar( intensity );

				uniforms.halfWidth.set( light.width * 0.5, 0.0, 0.0 );
				uniforms.halfHeight.set( 0.0, light.height * 0.5, 0.0 );

				state.rectArea[ rectAreaLength ] = uniforms;

				rectAreaLength ++;

			} else if ( light.isPointLight ) {

				const uniforms = cache.get( light );

				uniforms.color.copy( light.color ).multiplyScalar( light.intensity * scaleFactor );
				uniforms.distance = light.distance;
				uniforms.decay = light.decay;

				if ( light.castShadow ) {

					const shadow = light.shadow;

					const shadowUniforms = shadowCache.get( light );

					shadowUniforms.shadowBias = shadow.bias;
					shadowUniforms.shadowNormalBias = shadow.normalBias;
					shadowUniforms.shadowRadius = shadow.radius;
					shadowUniforms.shadowMapSize = shadow.mapSize;
					shadowUniforms.shadowCameraNear = shadow.camera.near;
					shadowUniforms.shadowCameraFar = shadow.camera.far;

					state.pointShadow[ pointLength ] = shadowUniforms;
					state.pointShadowMap[ pointLength ] = shadowMap;
					state.pointShadowMatrix[ pointLength ] = light.shadow.matrix;

					numPointShadows ++;

				}

				state.point[ pointLength ] = uniforms;

				pointLength ++;

			} else if ( light.isHemisphereLight ) {

				const uniforms = cache.get( light );

				uniforms.skyColor.copy( light.color ).multiplyScalar( intensity * scaleFactor );
				uniforms.groundColor.copy( light.groundColor ).multiplyScalar( intensity * scaleFactor );

				state.hemi[ hemiLength ] = uniforms;

				hemiLength ++;

			}

		}

		if ( rectAreaLength > 0 ) {

			if ( extensions.has( 'OES_texture_float_linear' ) === true ) {

				state.rectAreaLTC1 = UniformsLib.LTC_FLOAT_1;
				state.rectAreaLTC2 = UniformsLib.LTC_FLOAT_2;

			} else {

				state.rectAreaLTC1 = UniformsLib.LTC_HALF_1;
				state.rectAreaLTC2 = UniformsLib.LTC_HALF_2;

			}

		}

		state.ambient[ 0 ] = r;
		state.ambient[ 1 ] = g;
		state.ambient[ 2 ] = b;

		const hash = state.hash;

		if ( hash.directionalLength !== directionalLength ||
			hash.pointLength !== pointLength ||
			hash.spotLength !== spotLength ||
			hash.rectAreaLength !== rectAreaLength ||
			hash.hemiLength !== hemiLength ||
			hash.numDirectionalShadows !== numDirectionalShadows ||
			hash.numPointShadows !== numPointShadows ||
			hash.numSpotShadows !== numSpotShadows ||
			hash.numSpotMaps !== numSpotMaps ||
			hash.numLightProbes !== numLightProbes ) {

			state.directional.length = directionalLength;
			state.spot.length = spotLength;
			state.rectArea.length = rectAreaLength;
			state.point.length = pointLength;
			state.hemi.length = hemiLength;

			state.directionalShadow.length = numDirectionalShadows;
			state.directionalShadowMap.length = numDirectionalShadows;
			state.pointShadow.length = numPointShadows;
			state.pointShadowMap.length = numPointShadows;
			state.spotShadow.length = numSpotShadows;
			state.spotShadowMap.length = numSpotShadows;
			state.directionalShadowMatrix.length = numDirectionalShadows;
			state.pointShadowMatrix.length = numPointShadows;
			state.spotLightMatrix.length = numSpotShadows + numSpotMaps - numSpotShadowsWithMaps;
			state.spotLightMap.length = numSpotMaps;
			state.numSpotLightShadowsWithMaps = numSpotShadowsWithMaps;
			state.numLightProbes = numLightProbes;

			hash.directionalLength = directionalLength;
			hash.pointLength = pointLength;
			hash.spotLength = spotLength;
			hash.rectAreaLength = rectAreaLength;
			hash.hemiLength = hemiLength;

			hash.numDirectionalShadows = numDirectionalShadows;
			hash.numPointShadows = numPointShadows;
			hash.numSpotShadows = numSpotShadows;
			hash.numSpotMaps = numSpotMaps;

			hash.numLightProbes = numLightProbes;

			state.version = nextVersion ++;

		}

	}

	function setupView( lights, camera ) {

		let directionalLength = 0;
		let pointLength = 0;
		let spotLength = 0;
		let rectAreaLength = 0;
		let hemiLength = 0;

		const viewMatrix = camera.matrixWorldInverse;

		for ( let i = 0, l = lights.length; i < l; i ++ ) {

			const light = lights[ i ];

			if ( light.isDirectionalLight ) {

				const uniforms = state.directional[ directionalLength ];

				uniforms.direction.setFromMatrixPosition( light.matrixWorld );
				vector3.setFromMatrixPosition( light.target.matrixWorld );
				uniforms.direction.sub( vector3 );
				uniforms.direction.transformDirection( viewMatrix );

				directionalLength ++;

			} else if ( light.isSpotLight ) {

				const uniforms = state.spot[ spotLength ];

				uniforms.position.setFromMatrixPosition( light.matrixWorld );
				uniforms.position.applyMatrix4( viewMatrix );

				uniforms.direction.setFromMatrixPosition( light.matrixWorld );
				vector3.setFromMatrixPosition( light.target.matrixWorld );
				uniforms.direction.sub( vector3 );
				uniforms.direction.transformDirection( viewMatrix );

				spotLength ++;

			} else if ( light.isRectAreaLight ) {

				const uniforms = state.rectArea[ rectAreaLength ];

				uniforms.position.setFromMatrixPosition( light.matrixWorld );
				uniforms.position.applyMatrix4( viewMatrix );

				// extract local rotation of light to derive width/height half vectors
				matrix42.identity();
				matrix4.copy( light.matrixWorld );
				matrix4.premultiply( viewMatrix );
				matrix42.extractRotation( matrix4 );

				uniforms.halfWidth.set( light.width * 0.5, 0.0, 0.0 );
				uniforms.halfHeight.set( 0.0, light.height * 0.5, 0.0 );

				uniforms.halfWidth.applyMatrix4( matrix42 );
				uniforms.halfHeight.applyMatrix4( matrix42 );

				rectAreaLength ++;

			} else if ( light.isPointLight ) {

				const uniforms = state.point[ pointLength ];

				uniforms.position.setFromMatrixPosition( light.matrixWorld );
				uniforms.position.applyMatrix4( viewMatrix );

				pointLength ++;

			} else if ( light.isHemisphereLight ) {

				const uniforms = state.hemi[ hemiLength ];

				uniforms.direction.setFromMatrixPosition( light.matrixWorld );
				uniforms.direction.transformDirection( viewMatrix );

				hemiLength ++;

			}

		}

	}

	return {
		setup: setup,
		setupView: setupView,
		state: state
	};

}

function WebGLRenderState( extensions ) {

	const lights = new WebGLLights( extensions );

	const lightsArray = [];
	const shadowsArray = [];

	function init() {

		lightsArray.length = 0;
		shadowsArray.length = 0;

	}

	function pushLight( light ) {

		lightsArray.push( light );

	}

	function pushShadow( shadowLight ) {

		shadowsArray.push( shadowLight );

	}

	function setupLights( useLegacyLights ) {

		lights.setup( lightsArray, useLegacyLights );

	}

	function setupLightsView( camera ) {

		lights.setupView( lightsArray, camera );

	}

	const state = {
		lightsArray: lightsArray,
		shadowsArray: shadowsArray,

		lights: lights,

		transmissionRenderTarget: null
	};

	return {
		init: init,
		state: state,
		setupLights: setupLights,
		setupLightsView: setupLightsView,

		pushLight: pushLight,
		pushShadow: pushShadow
	};

}

function WebGLRenderStates( extensions ) {

	let renderStates = new WeakMap();

	function get( scene, renderCallDepth = 0 ) {

		const renderStateArray = renderStates.get( scene );
		let renderState;

		if ( renderStateArray === undefined ) {

			renderState = new WebGLRenderState( extensions );
			renderStates.set( scene, [ renderState ] );

		} else {

			if ( renderCallDepth >= renderStateArray.length ) {

				renderState = new WebGLRenderState( extensions );
				renderStateArray.push( renderState );

			} else {

				renderState = renderStateArray[ renderCallDepth ];

			}

		}

		return renderState;

	}

	function dispose() {

		renderStates = new WeakMap();

	}

	return {
		get: get,
		dispose: dispose
	};

}

class MeshDepthMaterial extends (/* unused pure expression or super */ null && (Material)) {

	constructor( parameters ) {

		super();

		this.isMeshDepthMaterial = true;

		this.type = 'MeshDepthMaterial';

		this.depthPacking = BasicDepthPacking;

		this.map = null;

		this.alphaMap = null;

		this.displacementMap = null;
		this.displacementScale = 1;
		this.displacementBias = 0;

		this.wireframe = false;
		this.wireframeLinewidth = 1;

		this.setValues( parameters );

	}

	copy( source ) {

		super.copy( source );

		this.depthPacking = source.depthPacking;

		this.map = source.map;

		this.alphaMap = source.alphaMap;

		this.displacementMap = source.displacementMap;
		this.displacementScale = source.displacementScale;
		this.displacementBias = source.displacementBias;

		this.wireframe = source.wireframe;
		this.wireframeLinewidth = source.wireframeLinewidth;

		return this;

	}

}

class MeshDistanceMaterial extends (/* unused pure expression or super */ null && (Material)) {

	constructor( parameters ) {

		super();

		this.isMeshDistanceMaterial = true;

		this.type = 'MeshDistanceMaterial';

		this.map = null;

		this.alphaMap = null;

		this.displacementMap = null;
		this.displacementScale = 1;
		this.displacementBias = 0;

		this.setValues( parameters );

	}

	copy( source ) {

		super.copy( source );

		this.map = source.map;

		this.alphaMap = source.alphaMap;

		this.displacementMap = source.displacementMap;
		this.displacementScale = source.displacementScale;
		this.displacementBias = source.displacementBias;

		return this;

	}

}

const vertex = "void main() {\n\tgl_Position = vec4( position, 1.0 );\n}";

const fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n\tconst float samples = float( VSM_SAMPLES );\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n\tfloat uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n\tfor ( float i = 0.0; i < samples; i ++ ) {\n\t\tfloat uvOffset = uvStart + i * uvStride;\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean / samples;\n\tsquared_mean = squared_mean / samples;\n\tfloat std_dev = sqrt( squared_mean - mean * mean );\n\tgl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";

function WebGLShadowMap( _renderer, _objects, _capabilities ) {

	let _frustum = new Frustum();

	const _shadowMapSize = new Vector2(),
		_viewportSize = new Vector2(),

		_viewport = new Vector4(),

		_depthMaterial = new MeshDepthMaterial( { depthPacking: RGBADepthPacking } ),
		_distanceMaterial = new MeshDistanceMaterial(),

		_materialCache = {},

		_maxTextureSize = _capabilities.maxTextureSize;

	const shadowSide = { [ FrontSide ]: BackSide, [ BackSide ]: FrontSide, [ DoubleSide ]: DoubleSide };

	const shadowMaterialVertical = new ShaderMaterial( {
		defines: {
			VSM_SAMPLES: 8
		},
		uniforms: {
			shadow_pass: { value: null },
			resolution: { value: new Vector2() },
			radius: { value: 4.0 }
		},

		vertexShader: vertex,
		fragmentShader: fragment

	} );

	const shadowMaterialHorizontal = shadowMaterialVertical.clone();
	shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;

	const fullScreenTri = new BufferGeometry();
	fullScreenTri.setAttribute(
		'position',
		new BufferAttribute(
			new Float32Array( [ - 1, - 1, 0.5, 3, - 1, 0.5, - 1, 3, 0.5 ] ),
			3
		)
	);

	const fullScreenMesh = new Mesh( fullScreenTri, shadowMaterialVertical );

	const scope = this;

	this.enabled = false;

	this.autoUpdate = true;
	this.needsUpdate = false;

	this.type = PCFShadowMap;
	let _previousType = this.type;

	this.render = function ( lights, scene, camera ) {

		if ( scope.enabled === false ) return;
		if ( scope.autoUpdate === false && scope.needsUpdate === false ) return;

		if ( lights.length === 0 ) return;

		const currentRenderTarget = _renderer.getRenderTarget();
		const activeCubeFace = _renderer.getActiveCubeFace();
		const activeMipmapLevel = _renderer.getActiveMipmapLevel();

		const _state = _renderer.state;

		// Set GL state for depth map.
		_state.setBlending( NoBlending );
		_state.buffers.color.setClear( 1, 1, 1, 1 );
		_state.buffers.depth.setTest( true );
		_state.setScissorTest( false );

		// check for shadow map type changes

		const toVSM = ( _previousType !== VSMShadowMap && this.type === VSMShadowMap );
		const fromVSM = ( _previousType === VSMShadowMap && this.type !== VSMShadowMap );

		// render depth map

		for ( let i = 0, il = lights.length; i < il; i ++ ) {

			const light = lights[ i ];
			const shadow = light.shadow;

			if ( shadow === undefined ) {

				console.warn( 'THREE.WebGLShadowMap:', light, 'has no shadow.' );
				continue;

			}

			if ( shadow.autoUpdate === false && shadow.needsUpdate === false ) continue;

			_shadowMapSize.copy( shadow.mapSize );

			const shadowFrameExtents = shadow.getFrameExtents();

			_shadowMapSize.multiply( shadowFrameExtents );

			_viewportSize.copy( shadow.mapSize );

			if ( _shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize ) {

				if ( _shadowMapSize.x > _maxTextureSize ) {

					_viewportSize.x = Math.floor( _maxTextureSize / shadowFrameExtents.x );
					_shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
					shadow.mapSize.x = _viewportSize.x;

				}

				if ( _shadowMapSize.y > _maxTextureSize ) {

					_viewportSize.y = Math.floor( _maxTextureSize / shadowFrameExtents.y );
					_shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
					shadow.mapSize.y = _viewportSize.y;

				}

			}

			if ( shadow.map === null || toVSM === true || fromVSM === true ) {

				const pars = ( this.type !== VSMShadowMap ) ? { minFilter: NearestFilter, magFilter: NearestFilter } : {};

				if ( shadow.map !== null ) {

					shadow.map.dispose();

				}

				shadow.map = new WebGLRenderTarget( _shadowMapSize.x, _shadowMapSize.y, pars );
				shadow.map.texture.name = light.name + '.shadowMap';

				shadow.camera.updateProjectionMatrix();

			}

			_renderer.setRenderTarget( shadow.map );
			_renderer.clear();

			const viewportCount = shadow.getViewportCount();

			for ( let vp = 0; vp < viewportCount; vp ++ ) {

				const viewport = shadow.getViewport( vp );

				_viewport.set(
					_viewportSize.x * viewport.x,
					_viewportSize.y * viewport.y,
					_viewportSize.x * viewport.z,
					_viewportSize.y * viewport.w
				);

				_state.viewport( _viewport );

				shadow.updateMatrices( light, vp );

				_frustum = shadow.getFrustum();

				renderObject( scene, camera, shadow.camera, light, this.type );

			}

			// do blur pass for VSM

			if ( shadow.isPointLightShadow !== true && this.type === VSMShadowMap ) {

				VSMPass( shadow, camera );

			}

			shadow.needsUpdate = false;

		}

		_previousType = this.type;

		scope.needsUpdate = false;

		_renderer.setRenderTarget( currentRenderTarget, activeCubeFace, activeMipmapLevel );

	};

	function VSMPass( shadow, camera ) {

		const geometry = _objects.update( fullScreenMesh );

		if ( shadowMaterialVertical.defines.VSM_SAMPLES !== shadow.blurSamples ) {

			shadowMaterialVertical.defines.VSM_SAMPLES = shadow.blurSamples;
			shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow.blurSamples;

			shadowMaterialVertical.needsUpdate = true;
			shadowMaterialHorizontal.needsUpdate = true;

		}

		if ( shadow.mapPass === null ) {

			shadow.mapPass = new WebGLRenderTarget( _shadowMapSize.x, _shadowMapSize.y );

		}

		// vertical pass

		shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
		shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
		shadowMaterialVertical.uniforms.radius.value = shadow.radius;
		_renderer.setRenderTarget( shadow.mapPass );
		_renderer.clear();
		_renderer.renderBufferDirect( camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null );

		// horizontal pass

		shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
		shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
		shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
		_renderer.setRenderTarget( shadow.map );
		_renderer.clear();
		_renderer.renderBufferDirect( camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null );

	}

	function getDepthMaterial( object, material, light, type ) {

		let result = null;

		const customMaterial = ( light.isPointLight === true ) ? object.customDistanceMaterial : object.customDepthMaterial;

		if ( customMaterial !== undefined ) {

			result = customMaterial;

		} else {

			result = ( light.isPointLight === true ) ? _distanceMaterial : _depthMaterial;

			if ( ( _renderer.localClippingEnabled && material.clipShadows === true && Array.isArray( material.clippingPlanes ) && material.clippingPlanes.length !== 0 ) ||
				( material.displacementMap && material.displacementScale !== 0 ) ||
				( material.alphaMap && material.alphaTest > 0 ) ||
				( material.map && material.alphaTest > 0 ) ) {

				// in this case we need a unique material instance reflecting the
				// appropriate state

				const keyA = result.uuid, keyB = material.uuid;

				let materialsForVariant = _materialCache[ keyA ];

				if ( materialsForVariant === undefined ) {

					materialsForVariant = {};
					_materialCache[ keyA ] = materialsForVariant;

				}

				let cachedMaterial = materialsForVariant[ keyB ];

				if ( cachedMaterial === undefined ) {

					cachedMaterial = result.clone();
					materialsForVariant[ keyB ] = cachedMaterial;
					material.addEventListener( 'dispose', onMaterialDispose );

				}

				result = cachedMaterial;

			}

		}

		result.visible = material.visible;
		result.wireframe = material.wireframe;

		if ( type === VSMShadowMap ) {

			result.side = ( material.shadowSide !== null ) ? material.shadowSide : material.side;

		} else {

			result.side = ( material.shadowSide !== null ) ? material.shadowSide : shadowSide[ material.side ];

		}

		result.alphaMap = material.alphaMap;
		result.alphaTest = material.alphaTest;
		result.map = material.map;

		result.clipShadows = material.clipShadows;
		result.clippingPlanes = material.clippingPlanes;
		result.clipIntersection = material.clipIntersection;

		result.displacementMap = material.displacementMap;
		result.displacementScale = material.displacementScale;
		result.displacementBias = material.displacementBias;

		result.wireframeLinewidth = material.wireframeLinewidth;
		result.linewidth = material.linewidth;

		if ( light.isPointLight === true && result.isMeshDistanceMaterial === true ) {

			const materialProperties = _renderer.properties.get( result );
			materialProperties.light = light;

		}

		return result;

	}

	function renderObject( object, camera, shadowCamera, light, type ) {

		if ( object.visible === false ) return;

		const visible = object.layers.test( camera.layers );

		if ( visible && ( object.isMesh || object.isLine || object.isPoints ) ) {

			if ( ( object.castShadow || ( object.receiveShadow && type === VSMShadowMap ) ) && ( ! object.frustumCulled || _frustum.intersectsObject( object ) ) ) {

				object.modelViewMatrix.multiplyMatrices( shadowCamera.matrixWorldInverse, object.matrixWorld );

				const geometry = _objects.update( object );
				const material = object.material;

				if ( Array.isArray( material ) ) {

					const groups = geometry.groups;

					for ( let k = 0, kl = groups.length; k < kl; k ++ ) {

						const group = groups[ k ];
						const groupMaterial = material[ group.materialIndex ];

						if ( groupMaterial && groupMaterial.visible ) {

							const depthMaterial = getDepthMaterial( object, groupMaterial, light, type );

							object.onBeforeShadow( _renderer, object, camera, shadowCamera, geometry, depthMaterial, group );

							_renderer.renderBufferDirect( shadowCamera, null, geometry, depthMaterial, object, group );

							object.onAfterShadow( _renderer, object, camera, shadowCamera, geometry, depthMaterial, group );

						}

					}

				} else if ( material.visible ) {

					const depthMaterial = getDepthMaterial( object, material, light, type );

					object.onBeforeShadow( _renderer, object, camera, shadowCamera, geometry, depthMaterial, null );

					_renderer.renderBufferDirect( shadowCamera, null, geometry, depthMaterial, object, null );

					object.onAfterShadow( _renderer, object, camera, shadowCamera, geometry, depthMaterial, null );

				}

			}

		}

		const children = object.children;

		for ( let i = 0, l = children.length; i < l; i ++ ) {

			renderObject( children[ i ], camera, shadowCamera, light, type );

		}

	}

	function onMaterialDispose( event ) {

		const material = event.target;

		material.removeEventListener( 'dispose', onMaterialDispose );

		// make sure to remove the unique distance/depth materials used for shadow map rendering

		for ( const id in _materialCache ) {

			const cache = _materialCache[ id ];

			const uuid = event.target.uuid;

			if ( uuid in cache ) {

				const shadowMaterial = cache[ uuid ];
				shadowMaterial.dispose();
				delete cache[ uuid ];

			}

		}

	}

}

function WebGLState( gl ) {

	function ColorBuffer() {

		let locked = false;

		const color = new Vector4();
		let currentColorMask = null;
		const currentColorClear = new Vector4( 0, 0, 0, 0 );

		return {

			setMask: function ( colorMask ) {

				if ( currentColorMask !== colorMask && ! locked ) {

					gl.colorMask( colorMask, colorMask, colorMask, colorMask );
					currentColorMask = colorMask;

				}

			},

			setLocked: function ( lock ) {

				locked = lock;

			},

			setClear: function ( r, g, b, a, premultipliedAlpha ) {

				if ( premultipliedAlpha === true ) {

					r *= a; g *= a; b *= a;

				}

				color.set( r, g, b, a );

				if ( currentColorClear.equals( color ) === false ) {

					gl.clearColor( r, g, b, a );
					currentColorClear.copy( color );

				}

			},

			reset: function () {

				locked = false;

				currentColorMask = null;
				currentColorClear.set( - 1, 0, 0, 0 ); // set to invalid state

			}

		};

	}

	function DepthBuffer() {

		let locked = false;

		let currentDepthMask = null;
		let currentDepthFunc = null;
		let currentDepthClear = null;

		return {

			setTest: function ( depthTest ) {

				if ( depthTest ) {

					enable( gl.DEPTH_TEST );

				} else {

					disable( gl.DEPTH_TEST );

				}

			},

			setMask: function ( depthMask ) {

				if ( currentDepthMask !== depthMask && ! locked ) {

					gl.depthMask( depthMask );
					currentDepthMask = depthMask;

				}

			},

			setFunc: function ( depthFunc ) {

				if ( currentDepthFunc !== depthFunc ) {

					switch ( depthFunc ) {

						case NeverDepth:

							gl.depthFunc( gl.NEVER );
							break;

						case AlwaysDepth:

							gl.depthFunc( gl.ALWAYS );
							break;

						case LessDepth:

							gl.depthFunc( gl.LESS );
							break;

						case LessEqualDepth:

							gl.depthFunc( gl.LEQUAL );
							break;

						case EqualDepth:

							gl.depthFunc( gl.EQUAL );
							break;

						case GreaterEqualDepth:

							gl.depthFunc( gl.GEQUAL );
							break;

						case GreaterDepth:

							gl.depthFunc( gl.GREATER );
							break;

						case NotEqualDepth:

							gl.depthFunc( gl.NOTEQUAL );
							break;

						default:

							gl.depthFunc( gl.LEQUAL );

					}

					currentDepthFunc = depthFunc;

				}

			},

			setLocked: function ( lock ) {

				locked = lock;

			},

			setClear: function ( depth ) {

				if ( currentDepthClear !== depth ) {

					gl.clearDepth( depth );
					currentDepthClear = depth;

				}

			},

			reset: function () {

				locked = false;

				currentDepthMask = null;
				currentDepthFunc = null;
				currentDepthClear = null;

			}

		};

	}

	function StencilBuffer() {

		let locked = false;

		let currentStencilMask = null;
		let currentStencilFunc = null;
		let currentStencilRef = null;
		let currentStencilFuncMask = null;
		let currentStencilFail = null;
		let currentStencilZFail = null;
		let currentStencilZPass = null;
		let currentStencilClear = null;

		return {

			setTest: function ( stencilTest ) {

				if ( ! locked ) {

					if ( stencilTest ) {

						enable( gl.STENCIL_TEST );

					} else {

						disable( gl.STENCIL_TEST );

					}

				}

			},

			setMask: function ( stencilMask ) {

				if ( currentStencilMask !== stencilMask && ! locked ) {

					gl.stencilMask( stencilMask );
					currentStencilMask = stencilMask;

				}

			},

			setFunc: function ( stencilFunc, stencilRef, stencilMask ) {

				if ( currentStencilFunc !== stencilFunc ||
				     currentStencilRef !== stencilRef ||
				     currentStencilFuncMask !== stencilMask ) {

					gl.stencilFunc( stencilFunc, stencilRef, stencilMask );

					currentStencilFunc = stencilFunc;
					currentStencilRef = stencilRef;
					currentStencilFuncMask = stencilMask;

				}

			},

			setOp: function ( stencilFail, stencilZFail, stencilZPass ) {

				if ( currentStencilFail !== stencilFail ||
				     currentStencilZFail !== stencilZFail ||
				     currentStencilZPass !== stencilZPass ) {

					gl.stencilOp( stencilFail, stencilZFail, stencilZPass );

					currentStencilFail = stencilFail;
					currentStencilZFail = stencilZFail;
					currentStencilZPass = stencilZPass;

				}

			},

			setLocked: function ( lock ) {

				locked = lock;

			},

			setClear: function ( stencil ) {

				if ( currentStencilClear !== stencil ) {

					gl.clearStencil( stencil );
					currentStencilClear = stencil;

				}

			},

			reset: function () {

				locked = false;

				currentStencilMask = null;
				currentStencilFunc = null;
				currentStencilRef = null;
				currentStencilFuncMask = null;
				currentStencilFail = null;
				currentStencilZFail = null;
				currentStencilZPass = null;
				currentStencilClear = null;

			}

		};

	}

	//

	const colorBuffer = new ColorBuffer();
	const depthBuffer = new DepthBuffer();
	const stencilBuffer = new StencilBuffer();

	const uboBindings = new WeakMap();
	const uboProgramMap = new WeakMap();

	let enabledCapabilities = {};

	let currentBoundFramebuffers = {};
	let currentDrawbuffers = new WeakMap();
	let defaultDrawbuffers = [];

	let currentProgram = null;

	let currentBlendingEnabled = false;
	let currentBlending = null;
	let currentBlendEquation = null;
	let currentBlendSrc = null;
	let currentBlendDst = null;
	let currentBlendEquationAlpha = null;
	let currentBlendSrcAlpha = null;
	let currentBlendDstAlpha = null;
	let currentBlendColor = new Color( 0, 0, 0 );
	let currentBlendAlpha = 0;
	let currentPremultipledAlpha = false;

	let currentFlipSided = null;
	let currentCullFace = null;

	let currentLineWidth = null;

	let currentPolygonOffsetFactor = null;
	let currentPolygonOffsetUnits = null;

	const maxTextures = gl.getParameter( gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS );

	let lineWidthAvailable = false;
	let version = 0;
	const glVersion = gl.getParameter( gl.VERSION );

	if ( glVersion.indexOf( 'WebGL' ) !== - 1 ) {

		version = parseFloat( /^WebGL (\d)/.exec( glVersion )[ 1 ] );
		lineWidthAvailable = ( version >= 1.0 );

	} else if ( glVersion.indexOf( 'OpenGL ES' ) !== - 1 ) {

		version = parseFloat( /^OpenGL ES (\d)/.exec( glVersion )[ 1 ] );
		lineWidthAvailable = ( version >= 2.0 );

	}

	let currentTextureSlot = null;
	let currentBoundTextures = {};

	const scissorParam = gl.getParameter( gl.SCISSOR_BOX );
	const viewportParam = gl.getParameter( gl.VIEWPORT );

	const currentScissor = new Vector4().fromArray( scissorParam );
	const currentViewport = new Vector4().fromArray( viewportParam );

	function createTexture( type, target, count, dimensions ) {

		const data = new Uint8Array( 4 ); // 4 is required to match default unpack alignment of 4.
		const texture = gl.createTexture();

		gl.bindTexture( type, texture );
		gl.texParameteri( type, gl.TEXTURE_MIN_FILTER, gl.NEAREST );
		gl.texParameteri( type, gl.TEXTURE_MAG_FILTER, gl.NEAREST );

		for ( let i = 0; i < count; i ++ ) {

			if ( type === gl.TEXTURE_3D || type === gl.TEXTURE_2D_ARRAY ) {

				gl.texImage3D( target, 0, gl.RGBA, 1, 1, dimensions, 0, gl.RGBA, gl.UNSIGNED_BYTE, data );

			} else {

				gl.texImage2D( target + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data );

			}

		}

		return texture;

	}

	const emptyTextures = {};
	emptyTextures[ gl.TEXTURE_2D ] = createTexture( gl.TEXTURE_2D, gl.TEXTURE_2D, 1 );
	emptyTextures[ gl.TEXTURE_CUBE_MAP ] = createTexture( gl.TEXTURE_CUBE_MAP, gl.TEXTURE_CUBE_MAP_POSITIVE_X, 6 );
	emptyTextures[ gl.TEXTURE_2D_ARRAY ] = createTexture( gl.TEXTURE_2D_ARRAY, gl.TEXTURE_2D_ARRAY, 1, 1 );
	emptyTextures[ gl.TEXTURE_3D ] = createTexture( gl.TEXTURE_3D, gl.TEXTURE_3D, 1, 1 );

	// init

	colorBuffer.setClear( 0, 0, 0, 1 );
	depthBuffer.setClear( 1 );
	stencilBuffer.setClear( 0 );

	enable( gl.DEPTH_TEST );
	depthBuffer.setFunc( LessEqualDepth );

	setFlipSided( false );
	setCullFace( CullFaceBack );
	enable( gl.CULL_FACE );

	setBlending( NoBlending );

	//

	function enable( id ) {

		if ( enabledCapabilities[ id ] !== true ) {

			gl.enable( id );
			enabledCapabilities[ id ] = true;

		}

	}

	function disable( id ) {

		if ( enabledCapabilities[ id ] !== false ) {

			gl.disable( id );
			enabledCapabilities[ id ] = false;

		}

	}

	function bindFramebuffer( target, framebuffer ) {

		if ( currentBoundFramebuffers[ target ] !== framebuffer ) {

			gl.bindFramebuffer( target, framebuffer );

			currentBoundFramebuffers[ target ] = framebuffer;

			// gl.DRAW_FRAMEBUFFER is equivalent to gl.FRAMEBUFFER

			if ( target === gl.DRAW_FRAMEBUFFER ) {

				currentBoundFramebuffers[ gl.FRAMEBUFFER ] = framebuffer;

			}

			if ( target === gl.FRAMEBUFFER ) {

				currentBoundFramebuffers[ gl.DRAW_FRAMEBUFFER ] = framebuffer;

			}

			return true;

		}

		return false;

	}

	function drawBuffers( renderTarget, framebuffer ) {

		let drawBuffers = defaultDrawbuffers;

		let needsUpdate = false;

		if ( renderTarget ) {

			drawBuffers = currentDrawbuffers.get( framebuffer );

			if ( drawBuffers === undefined ) {

				drawBuffers = [];
				currentDrawbuffers.set( framebuffer, drawBuffers );

			}

			const textures = renderTarget.textures;

			if ( drawBuffers.length !== textures.length || drawBuffers[ 0 ] !== gl.COLOR_ATTACHMENT0 ) {

				for ( let i = 0, il = textures.length; i < il; i ++ ) {

					drawBuffers[ i ] = gl.COLOR_ATTACHMENT0 + i;

				}

				drawBuffers.length = textures.length;

				needsUpdate = true;

			}

		} else {

			if ( drawBuffers[ 0 ] !== gl.BACK ) {

				drawBuffers[ 0 ] = gl.BACK;

				needsUpdate = true;

			}

		}

		if ( needsUpdate ) {

			gl.drawBuffers( drawBuffers );

		}

	}

	function useProgram( program ) {

		if ( currentProgram !== program ) {

			gl.useProgram( program );

			currentProgram = program;

			return true;

		}

		return false;

	}

	const equationToGL = {
		[ AddEquation ]: gl.FUNC_ADD,
		[ SubtractEquation ]: gl.FUNC_SUBTRACT,
		[ ReverseSubtractEquation ]: gl.FUNC_REVERSE_SUBTRACT
	};

	equationToGL[ MinEquation ] = gl.MIN;
	equationToGL[ MaxEquation ] = gl.MAX;

	const factorToGL = {
		[ ZeroFactor ]: gl.ZERO,
		[ OneFactor ]: gl.ONE,
		[ SrcColorFactor ]: gl.SRC_COLOR,
		[ SrcAlphaFactor ]: gl.SRC_ALPHA,
		[ SrcAlphaSaturateFactor ]: gl.SRC_ALPHA_SATURATE,
		[ DstColorFactor ]: gl.DST_COLOR,
		[ DstAlphaFactor ]: gl.DST_ALPHA,
		[ OneMinusSrcColorFactor ]: gl.ONE_MINUS_SRC_COLOR,
		[ OneMinusSrcAlphaFactor ]: gl.ONE_MINUS_SRC_ALPHA,
		[ OneMinusDstColorFactor ]: gl.ONE_MINUS_DST_COLOR,
		[ OneMinusDstAlphaFactor ]: gl.ONE_MINUS_DST_ALPHA,
		[ ConstantColorFactor ]: gl.CONSTANT_COLOR,
		[ OneMinusConstantColorFactor ]: gl.ONE_MINUS_CONSTANT_COLOR,
		[ ConstantAlphaFactor ]: gl.CONSTANT_ALPHA,
		[ OneMinusConstantAlphaFactor ]: gl.ONE_MINUS_CONSTANT_ALPHA
	};

	function setBlending( blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, blendColor, blendAlpha, premultipliedAlpha ) {

		if ( blending === NoBlending ) {

			if ( currentBlendingEnabled === true ) {

				disable( gl.BLEND );
				currentBlendingEnabled = false;

			}

			return;

		}

		if ( currentBlendingEnabled === false ) {

			enable( gl.BLEND );
			currentBlendingEnabled = true;

		}

		if ( blending !== CustomBlending ) {

			if ( blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha ) {

				if ( currentBlendEquation !== AddEquation || currentBlendEquationAlpha !== AddEquation ) {

					gl.blendEquation( gl.FUNC_ADD );

					currentBlendEquation = AddEquation;
					currentBlendEquationAlpha = AddEquation;

				}

				if ( premultipliedAlpha ) {

					switch ( blending ) {

						case NormalBlending:
							gl.blendFuncSeparate( gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA );
							break;

						case AdditiveBlending:
							gl.blendFunc( gl.ONE, gl.ONE );
							break;

						case SubtractiveBlending:
							gl.blendFuncSeparate( gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE );
							break;

						case MultiplyBlending:
							gl.blendFuncSeparate( gl.ZERO, gl.SRC_COLOR, gl.ZERO, gl.SRC_ALPHA );
							break;

						default:
							console.error( 'THREE.WebGLState: Invalid blending: ', blending );
							break;

					}

				} else {

					switch ( blending ) {

						case NormalBlending:
							gl.blendFuncSeparate( gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA );
							break;

						case AdditiveBlending:
							gl.blendFunc( gl.SRC_ALPHA, gl.ONE );
							break;

						case SubtractiveBlending:
							gl.blendFuncSeparate( gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE );
							break;

						case MultiplyBlending:
							gl.blendFunc( gl.ZERO, gl.SRC_COLOR );
							break;

						default:
							console.error( 'THREE.WebGLState: Invalid blending: ', blending );
							break;

					}

				}

				currentBlendSrc = null;
				currentBlendDst = null;
				currentBlendSrcAlpha = null;
				currentBlendDstAlpha = null;
				currentBlendColor.set( 0, 0, 0 );
				currentBlendAlpha = 0;

				currentBlending = blending;
				currentPremultipledAlpha = premultipliedAlpha;

			}

			return;

		}

		// custom blending

		blendEquationAlpha = blendEquationAlpha || blendEquation;
		blendSrcAlpha = blendSrcAlpha || blendSrc;
		blendDstAlpha = blendDstAlpha || blendDst;

		if ( blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha ) {

			gl.blendEquationSeparate( equationToGL[ blendEquation ], equationToGL[ blendEquationAlpha ] );

			currentBlendEquation = blendEquation;
			currentBlendEquationAlpha = blendEquationAlpha;

		}

		if ( blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha ) {

			gl.blendFuncSeparate( factorToGL[ blendSrc ], factorToGL[ blendDst ], factorToGL[ blendSrcAlpha ], factorToGL[ blendDstAlpha ] );

			currentBlendSrc = blendSrc;
			currentBlendDst = blendDst;
			currentBlendSrcAlpha = blendSrcAlpha;
			currentBlendDstAlpha = blendDstAlpha;

		}

		if ( blendColor.equals( currentBlendColor ) === false || blendAlpha !== currentBlendAlpha ) {

			gl.blendColor( blendColor.r, blendColor.g, blendColor.b, blendAlpha );

			currentBlendColor.copy( blendColor );
			currentBlendAlpha = blendAlpha;

		}

		currentBlending = blending;
		currentPremultipledAlpha = false;

	}

	function setMaterial( material, frontFaceCW ) {

		material.side === DoubleSide
			? disable( gl.CULL_FACE )
			: enable( gl.CULL_FACE );

		let flipSided = ( material.side === BackSide );
		if ( frontFaceCW ) flipSided = ! flipSided;

		setFlipSided( flipSided );

		( material.blending === NormalBlending && material.transparent === false )
			? setBlending( NoBlending )
			: setBlending( material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.blendColor, material.blendAlpha, material.premultipliedAlpha );

		depthBuffer.setFunc( material.depthFunc );
		depthBuffer.setTest( material.depthTest );
		depthBuffer.setMask( material.depthWrite );
		colorBuffer.setMask( material.colorWrite );

		const stencilWrite = material.stencilWrite;
		stencilBuffer.setTest( stencilWrite );
		if ( stencilWrite ) {

			stencilBuffer.setMask( material.stencilWriteMask );
			stencilBuffer.setFunc( material.stencilFunc, material.stencilRef, material.stencilFuncMask );
			stencilBuffer.setOp( material.stencilFail, material.stencilZFail, material.stencilZPass );

		}

		setPolygonOffset( material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits );

		material.alphaToCoverage === true
			? enable( gl.SAMPLE_ALPHA_TO_COVERAGE )
			: disable( gl.SAMPLE_ALPHA_TO_COVERAGE );

	}

	//

	function setFlipSided( flipSided ) {

		if ( currentFlipSided !== flipSided ) {

			if ( flipSided ) {

				gl.frontFace( gl.CW );

			} else {

				gl.frontFace( gl.CCW );

			}

			currentFlipSided = flipSided;

		}

	}

	function setCullFace( cullFace ) {

		if ( cullFace !== CullFaceNone ) {

			enable( gl.CULL_FACE );

			if ( cullFace !== currentCullFace ) {

				if ( cullFace === CullFaceBack ) {

					gl.cullFace( gl.BACK );

				} else if ( cullFace === CullFaceFront ) {

					gl.cullFace( gl.FRONT );

				} else {

					gl.cullFace( gl.FRONT_AND_BACK );

				}

			}

		} else {

			disable( gl.CULL_FACE );

		}

		currentCullFace = cullFace;

	}

	function setLineWidth( width ) {

		if ( width !== currentLineWidth ) {

			if ( lineWidthAvailable ) gl.lineWidth( width );

			currentLineWidth = width;

		}

	}

	function setPolygonOffset( polygonOffset, factor, units ) {

		if ( polygonOffset ) {

			enable( gl.POLYGON_OFFSET_FILL );

			if ( currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units ) {

				gl.polygonOffset( factor, units );

				currentPolygonOffsetFactor = factor;
				currentPolygonOffsetUnits = units;

			}

		} else {

			disable( gl.POLYGON_OFFSET_FILL );

		}

	}

	function setScissorTest( scissorTest ) {

		if ( scissorTest ) {

			enable( gl.SCISSOR_TEST );

		} else {

			disable( gl.SCISSOR_TEST );

		}

	}

	// texture

	function activeTexture( webglSlot ) {

		if ( webglSlot === undefined ) webglSlot = gl.TEXTURE0 + maxTextures - 1;

		if ( currentTextureSlot !== webglSlot ) {

			gl.activeTexture( webglSlot );
			currentTextureSlot = webglSlot;

		}

	}

	function bindTexture( webglType, webglTexture, webglSlot ) {

		if ( webglSlot === undefined ) {

			if ( currentTextureSlot === null ) {

				webglSlot = gl.TEXTURE0 + maxTextures - 1;

			} else {

				webglSlot = currentTextureSlot;

			}

		}

		let boundTexture = currentBoundTextures[ webglSlot ];

		if ( boundTexture === undefined ) {

			boundTexture = { type: undefined, texture: undefined };
			currentBoundTextures[ webglSlot ] = boundTexture;

		}

		if ( boundTexture.type !== webglType || boundTexture.texture !== webglTexture ) {

			if ( currentTextureSlot !== webglSlot ) {

				gl.activeTexture( webglSlot );
				currentTextureSlot = webglSlot;

			}

			gl.bindTexture( webglType, webglTexture || emptyTextures[ webglType ] );

			boundTexture.type = webglType;
			boundTexture.texture = webglTexture;

		}

	}

	function unbindTexture() {

		const boundTexture = currentBoundTextures[ currentTextureSlot ];

		if ( boundTexture !== undefined && boundTexture.type !== undefined ) {

			gl.bindTexture( boundTexture.type, null );

			boundTexture.type = undefined;
			boundTexture.texture = undefined;

		}

	}

	function compressedTexImage2D() {

		try {

			gl.compressedTexImage2D.apply( gl, arguments );

		} catch ( error ) {

			console.error( 'THREE.WebGLState:', error );

		}

	}

	function compressedTexImage3D() {

		try {

			gl.compressedTexImage3D.apply( gl, arguments );

		} catch ( error ) {

			console.error( 'THREE.WebGLState:', error );

		}

	}

	function texSubImage2D() {

		try {

			gl.texSubImage2D.apply( gl, arguments );

		} catch ( error ) {

			console.error( 'THREE.WebGLState:', error );

		}

	}

	function texSubImage3D() {

		try {

			gl.texSubImage3D.apply( gl, arguments );

		} catch ( error ) {

			console.error( 'THREE.WebGLState:', error );

		}

	}

	function compressedTexSubImage2D() {

		try {

			gl.compressedTexSubImage2D.apply( gl, arguments );

		} catch ( error ) {

			console.error( 'THREE.WebGLState:', error );

		}

	}

	function compressedTexSubImage3D() {

		try {

			gl.compressedTexSubImage3D.apply( gl, arguments );

		} catch ( error ) {

			console.error( 'THREE.WebGLState:', error );

		}

	}

	function texStorage2D() {

		try {

			gl.texStorage2D.apply( gl, arguments );

		} catch ( error ) {

			console.error( 'THREE.WebGLState:', error );

		}

	}

	function texStorage3D() {

		try {

			gl.texStorage3D.apply( gl, arguments );

		} catch ( error ) {

			console.error( 'THREE.WebGLState:', error );

		}

	}

	function texImage2D() {

		try {

			gl.texImage2D.apply( gl, arguments );

		} catch ( error ) {

			console.error( 'THREE.WebGLState:', error );

		}

	}

	function texImage3D() {

		try {

			gl.texImage3D.apply( gl, arguments );

		} catch ( error ) {

			console.error( 'THREE.WebGLState:', error );

		}

	}

	//

	function scissor( scissor ) {

		if ( currentScissor.equals( scissor ) === false ) {

			gl.scissor( scissor.x, scissor.y, scissor.z, scissor.w );
			currentScissor.copy( scissor );

		}

	}

	function viewport( viewport ) {

		if ( currentViewport.equals( viewport ) === false ) {

			gl.viewport( viewport.x, viewport.y, viewport.z, viewport.w );
			currentViewport.copy( viewport );

		}

	}

	function updateUBOMapping( uniformsGroup, program ) {

		let mapping = uboProgramMap.get( program );

		if ( mapping === undefined ) {

			mapping = new WeakMap();

			uboProgramMap.set( program, mapping );

		}

		let blockIndex = mapping.get( uniformsGroup );

		if ( blockIndex === undefined ) {

			blockIndex = gl.getUniformBlockIndex( program, uniformsGroup.name );

			mapping.set( uniformsGroup, blockIndex );

		}

	}

	function uniformBlockBinding( uniformsGroup, program ) {

		const mapping = uboProgramMap.get( program );
		const blockIndex = mapping.get( uniformsGroup );

		if ( uboBindings.get( program ) !== blockIndex ) {

			// bind shader specific block index to global block point
			gl.uniformBlockBinding( program, blockIndex, uniformsGroup.__bindingPointIndex );

			uboBindings.set( program, blockIndex );

		}

	}

	//

	function reset() {

		// reset state

		gl.disable( gl.BLEND );
		gl.disable( gl.CULL_FACE );
		gl.disable( gl.DEPTH_TEST );
		gl.disable( gl.POLYGON_OFFSET_FILL );
		gl.disable( gl.SCISSOR_TEST );
		gl.disable( gl.STENCIL_TEST );
		gl.disable( gl.SAMPLE_ALPHA_TO_COVERAGE );

		gl.blendEquation( gl.FUNC_ADD );
		gl.blendFunc( gl.ONE, gl.ZERO );
		gl.blendFuncSeparate( gl.ONE, gl.ZERO, gl.ONE, gl.ZERO );
		gl.blendColor( 0, 0, 0, 0 );

		gl.colorMask( true, true, true, true );
		gl.clearColor( 0, 0, 0, 0 );

		gl.depthMask( true );
		gl.depthFunc( gl.LESS );
		gl.clearDepth( 1 );

		gl.stencilMask( 0xffffffff );
		gl.stencilFunc( gl.ALWAYS, 0, 0xffffffff );
		gl.stencilOp( gl.KEEP, gl.KEEP, gl.KEEP );
		gl.clearStencil( 0 );

		gl.cullFace( gl.BACK );
		gl.frontFace( gl.CCW );

		gl.polygonOffset( 0, 0 );

		gl.activeTexture( gl.TEXTURE0 );

		gl.bindFramebuffer( gl.FRAMEBUFFER, null );
		gl.bindFramebuffer( gl.DRAW_FRAMEBUFFER, null );
		gl.bindFramebuffer( gl.READ_FRAMEBUFFER, null );

		gl.useProgram( null );

		gl.lineWidth( 1 );

		gl.scissor( 0, 0, gl.canvas.width, gl.canvas.height );
		gl.viewport( 0, 0, gl.canvas.width, gl.canvas.height );

		// reset internals

		enabledCapabilities = {};

		currentTextureSlot = null;
		currentBoundTextures = {};

		currentBoundFramebuffers = {};
		currentDrawbuffers = new WeakMap();
		defaultDrawbuffers = [];

		currentProgram = null;

		currentBlendingEnabled = false;
		currentBlending = null;
		currentBlendEquation = null;
		currentBlendSrc = null;
		currentBlendDst = null;
		currentBlendEquationAlpha = null;
		currentBlendSrcAlpha = null;
		currentBlendDstAlpha = null;
		currentBlendColor = new Color( 0, 0, 0 );
		currentBlendAlpha = 0;
		currentPremultipledAlpha = false;

		currentFlipSided = null;
		currentCullFace = null;

		currentLineWidth = null;

		currentPolygonOffsetFactor = null;
		currentPolygonOffsetUnits = null;

		currentScissor.set( 0, 0, gl.canvas.width, gl.canvas.height );
		currentViewport.set( 0, 0, gl.canvas.width, gl.canvas.height );

		colorBuffer.reset();
		depthBuffer.reset();
		stencilBuffer.reset();

	}

	return {

		buffers: {
			color: colorBuffer,
			depth: depthBuffer,
			stencil: stencilBuffer
		},

		enable: enable,
		disable: disable,

		bindFramebuffer: bindFramebuffer,
		drawBuffers: drawBuffers,

		useProgram: useProgram,

		setBlending: setBlending,
		setMaterial: setMaterial,

		setFlipSided: setFlipSided,
		setCullFace: setCullFace,

		setLineWidth: setLineWidth,
		setPolygonOffset: setPolygonOffset,

		setScissorTest: setScissorTest,

		activeTexture: activeTexture,
		bindTexture: bindTexture,
		unbindTexture: unbindTexture,
		compressedTexImage2D: compressedTexImage2D,
		compressedTexImage3D: compressedTexImage3D,
		texImage2D: texImage2D,
		texImage3D: texImage3D,

		updateUBOMapping: updateUBOMapping,
		uniformBlockBinding: uniformBlockBinding,

		texStorage2D: texStorage2D,
		texStorage3D: texStorage3D,
		texSubImage2D: texSubImage2D,
		texSubImage3D: texSubImage3D,
		compressedTexSubImage2D: compressedTexSubImage2D,
		compressedTexSubImage3D: compressedTexSubImage3D,

		scissor: scissor,
		viewport: viewport,

		reset: reset

	};

}

function WebGLTextures( _gl, extensions, state, properties, capabilities, utils, info ) {

	const multisampledRTTExt = extensions.has( 'WEBGL_multisampled_render_to_texture' ) ? extensions.get( 'WEBGL_multisampled_render_to_texture' ) : null;
	const supportsInvalidateFramebuffer = typeof navigator === 'undefined' ? false : /OculusBrowser/g.test( navigator.userAgent );

	const _imageDimensions = new Vector2();
	const _videoTextures = new WeakMap();
	let _canvas;

	const _sources = new WeakMap(); // maps WebglTexture objects to instances of Source

	// cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
	// also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
	// Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).

	let useOffscreenCanvas = false;

	try {

		useOffscreenCanvas = typeof OffscreenCanvas !== 'undefined'
			// eslint-disable-next-line compat/compat
			&& ( new OffscreenCanvas( 1, 1 ).getContext( '2d' ) ) !== null;

	} catch ( err ) {

		// Ignore any errors

	}

	function createCanvas( width, height ) {

		// Use OffscreenCanvas when available. Specially needed in web workers

		return useOffscreenCanvas ?
			// eslint-disable-next-line compat/compat
			new OffscreenCanvas( width, height ) : createElementNS( 'canvas' );

	}

	function resizeImage( image, needsNewCanvas, maxSize ) {

		let scale = 1;

		const dimensions = getDimensions( image );

		// handle case if texture exceeds max size

		if ( dimensions.width > maxSize || dimensions.height > maxSize ) {

			scale = maxSize / Math.max( dimensions.width, dimensions.height );

		}

		// only perform resize if necessary

		if ( scale < 1 ) {

			// only perform resize for certain image types

			if ( ( typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement ) ||
				( typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement ) ||
				( typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap ) ||
				( typeof VideoFrame !== 'undefined' && image instanceof VideoFrame ) ) {

				const width = Math.floor( scale * dimensions.width );
				const height = Math.floor( scale * dimensions.height );

				if ( _canvas === undefined ) _canvas = createCanvas( width, height );

				// cube textures can't reuse the same canvas

				const canvas = needsNewCanvas ? createCanvas( width, height ) : _canvas;

				canvas.width = width;
				canvas.height = height;

				const context = canvas.getContext( '2d' );
				context.drawImage( image, 0, 0, width, height );

				console.warn( 'THREE.WebGLRenderer: Texture has been resized from (' + dimensions.width + 'x' + dimensions.height + ') to (' + width + 'x' + height + ').' );

				return canvas;

			} else {

				if ( 'data' in image ) {

					console.warn( 'THREE.WebGLRenderer: Image in DataTexture is too big (' + dimensions.width + 'x' + dimensions.height + ').' );

				}

				return image;

			}

		}

		return image;

	}

	function textureNeedsGenerateMipmaps( texture ) {

		return texture.generateMipmaps && texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter;

	}

	function generateMipmap( target ) {

		_gl.generateMipmap( target );

	}

	function getInternalFormat( internalFormatName, glFormat, glType, colorSpace, forceLinearTransfer = false ) {

		if ( internalFormatName !== null ) {

			if ( _gl[ internalFormatName ] !== undefined ) return _gl[ internalFormatName ];

			console.warn( 'THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format \'' + internalFormatName + '\'' );

		}

		let internalFormat = glFormat;

		if ( glFormat === _gl.RED ) {

			if ( glType === _gl.FLOAT ) internalFormat = _gl.R32F;
			if ( glType === _gl.HALF_FLOAT ) internalFormat = _gl.R16F;
			if ( glType === _gl.UNSIGNED_BYTE ) internalFormat = _gl.R8;

		}

		if ( glFormat === _gl.RED_INTEGER ) {

			if ( glType === _gl.UNSIGNED_BYTE ) internalFormat = _gl.R8UI;
			if ( glType === _gl.UNSIGNED_SHORT ) internalFormat = _gl.R16UI;
			if ( glType === _gl.UNSIGNED_INT ) internalFormat = _gl.R32UI;
			if ( glType === _gl.BYTE ) internalFormat = _gl.R8I;
			if ( glType === _gl.SHORT ) internalFormat = _gl.R16I;
			if ( glType === _gl.INT ) internalFormat = _gl.R32I;

		}

		if ( glFormat === _gl.RG ) {

			if ( glType === _gl.FLOAT ) internalFormat = _gl.RG32F;
			if ( glType === _gl.HALF_FLOAT ) internalFormat = _gl.RG16F;
			if ( glType === _gl.UNSIGNED_BYTE ) internalFormat = _gl.RG8;

		}

		if ( glFormat === _gl.RG_INTEGER ) {

			if ( glType === _gl.UNSIGNED_BYTE ) internalFormat = _gl.RG8UI;
			if ( glType === _gl.UNSIGNED_SHORT ) internalFormat = _gl.RG16UI;
			if ( glType === _gl.UNSIGNED_INT ) internalFormat = _gl.RG32UI;
			if ( glType === _gl.BYTE ) internalFormat = _gl.RG8I;
			if ( glType === _gl.SHORT ) internalFormat = _gl.RG16I;
			if ( glType === _gl.INT ) internalFormat = _gl.RG32I;

		}

		if ( glFormat === _gl.RGB ) {

			if ( glType === _gl.UNSIGNED_INT_5_9_9_9_REV ) internalFormat = _gl.RGB9_E5;

		}

		if ( glFormat === _gl.RGBA ) {

			const transfer = forceLinearTransfer ? LinearTransfer : ColorManagement.getTransfer( colorSpace );

			if ( glType === _gl.FLOAT ) internalFormat = _gl.RGBA32F;
			if ( glType === _gl.HALF_FLOAT ) internalFormat = _gl.RGBA16F;
			if ( glType === _gl.UNSIGNED_BYTE ) internalFormat = ( transfer === SRGBTransfer ) ? _gl.SRGB8_ALPHA8 : _gl.RGBA8;
			if ( glType === _gl.UNSIGNED_SHORT_4_4_4_4 ) internalFormat = _gl.RGBA4;
			if ( glType === _gl.UNSIGNED_SHORT_5_5_5_1 ) internalFormat = _gl.RGB5_A1;

		}

		if ( internalFormat === _gl.R16F || internalFormat === _gl.R32F ||
			internalFormat === _gl.RG16F || internalFormat === _gl.RG32F ||
			internalFormat === _gl.RGBA16F || internalFormat === _gl.RGBA32F ) {

			extensions.get( 'EXT_color_buffer_float' );

		}

		return internalFormat;

	}

	function getMipLevels( texture, image ) {

		if ( textureNeedsGenerateMipmaps( texture ) === true || ( texture.isFramebufferTexture && texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter ) ) {

			return Math.log2( Math.max( image.width, image.height ) ) + 1;

		} else if ( texture.mipmaps !== undefined && texture.mipmaps.length > 0 ) {

			// user-defined mipmaps

			return texture.mipmaps.length;

		} else if ( texture.isCompressedTexture && Array.isArray( texture.image ) ) {

			return image.mipmaps.length;

		} else {

			// texture without mipmaps (only base level)

			return 1;

		}

	}

	//

	function onTextureDispose( event ) {

		const texture = event.target;

		texture.removeEventListener( 'dispose', onTextureDispose );

		deallocateTexture( texture );

		if ( texture.isVideoTexture ) {

			_videoTextures.delete( texture );

		}

	}

	function onRenderTargetDispose( event ) {

		const renderTarget = event.target;

		renderTarget.removeEventListener( 'dispose', onRenderTargetDispose );

		deallocateRenderTarget( renderTarget );

	}

	//

	function deallocateTexture( texture ) {

		const textureProperties = properties.get( texture );

		if ( textureProperties.__webglInit === undefined ) return;

		// check if it's necessary to remove the WebGLTexture object

		const source = texture.source;
		const webglTextures = _sources.get( source );

		if ( webglTextures ) {

			const webglTexture = webglTextures[ textureProperties.__cacheKey ];
			webglTexture.usedTimes --;

			// the WebGLTexture object is not used anymore, remove it

			if ( webglTexture.usedTimes === 0 ) {

				deleteTexture( texture );

			}

			// remove the weak map entry if no WebGLTexture uses the source anymore

			if ( Object.keys( webglTextures ).length === 0 ) {

				_sources.delete( source );

			}

		}

		properties.remove( texture );

	}

	function deleteTexture( texture ) {

		const textureProperties = properties.get( texture );
		_gl.deleteTexture( textureProperties.__webglTexture );

		const source = texture.source;
		const webglTextures = _sources.get( source );
		delete webglTextures[ textureProperties.__cacheKey ];

		info.memory.textures --;

	}

	function deallocateRenderTarget( renderTarget ) {

		const renderTargetProperties = properties.get( renderTarget );

		if ( renderTarget.depthTexture ) {

			renderTarget.depthTexture.dispose();

		}

		if ( renderTarget.isWebGLCubeRenderTarget ) {

			for ( let i = 0; i < 6; i ++ ) {

				if ( Array.isArray( renderTargetProperties.__webglFramebuffer[ i ] ) ) {

					for ( let level = 0; level < renderTargetProperties.__webglFramebuffer[ i ].length; level ++ ) _gl.deleteFramebuffer( renderTargetProperties.__webglFramebuffer[ i ][ level ] );

				} else {

					_gl.deleteFramebuffer( renderTargetProperties.__webglFramebuffer[ i ] );

				}

				if ( renderTargetProperties.__webglDepthbuffer ) _gl.deleteRenderbuffer( renderTargetProperties.__webglDepthbuffer[ i ] );

			}

		} else {

			if ( Array.isArray( renderTargetProperties.__webglFramebuffer ) ) {

				for ( let level = 0; level < renderTargetProperties.__webglFramebuffer.length; level ++ ) _gl.deleteFramebuffer( renderTargetProperties.__webglFramebuffer[ level ] );

			} else {

				_gl.deleteFramebuffer( renderTargetProperties.__webglFramebuffer );

			}

			if ( renderTargetProperties.__webglDepthbuffer ) _gl.deleteRenderbuffer( renderTargetProperties.__webglDepthbuffer );
			if ( renderTargetProperties.__webglMultisampledFramebuffer ) _gl.deleteFramebuffer( renderTargetProperties.__webglMultisampledFramebuffer );

			if ( renderTargetProperties.__webglColorRenderbuffer ) {

				for ( let i = 0; i < renderTargetProperties.__webglColorRenderbuffer.length; i ++ ) {

					if ( renderTargetProperties.__webglColorRenderbuffer[ i ] ) _gl.deleteRenderbuffer( renderTargetProperties.__webglColorRenderbuffer[ i ] );

				}

			}

			if ( renderTargetProperties.__webglDepthRenderbuffer ) _gl.deleteRenderbuffer( renderTargetProperties.__webglDepthRenderbuffer );

		}

		const textures = renderTarget.textures;

		for ( let i = 0, il = textures.length; i < il; i ++ ) {

			const attachmentProperties = properties.get( textures[ i ] );

			if ( attachmentProperties.__webglTexture ) {

				_gl.deleteTexture( attachmentProperties.__webglTexture );

				info.memory.textures --;

			}

			properties.remove( textures[ i ] );

		}

		properties.remove( renderTarget );

	}

	//

	let textureUnits = 0;

	function resetTextureUnits() {

		textureUnits = 0;

	}

	function allocateTextureUnit() {

		const textureUnit = textureUnits;

		if ( textureUnit >= capabilities.maxTextures ) {

			console.warn( 'THREE.WebGLTextures: Trying to use ' + textureUnit + ' texture units while this GPU supports only ' + capabilities.maxTextures );

		}

		textureUnits += 1;

		return textureUnit;

	}

	function getTextureCacheKey( texture ) {

		const array = [];

		array.push( texture.wrapS );
		array.push( texture.wrapT );
		array.push( texture.wrapR || 0 );
		array.push( texture.magFilter );
		array.push( texture.minFilter );
		array.push( texture.anisotropy );
		array.push( texture.internalFormat );
		array.push( texture.format );
		array.push( texture.type );
		array.push( texture.generateMipmaps );
		array.push( texture.premultiplyAlpha );
		array.push( texture.flipY );
		array.push( texture.unpackAlignment );
		array.push( texture.colorSpace );

		return array.join();

	}

	//

	function setTexture2D( texture, slot ) {

		const textureProperties = properties.get( texture );

		if ( texture.isVideoTexture ) updateVideoTexture( texture );

		if ( texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version ) {

			const image = texture.image;

			if ( image === null ) {

				console.warn( 'THREE.WebGLRenderer: Texture marked for update but no image data found.' );

			} else if ( image.complete === false ) {

				console.warn( 'THREE.WebGLRenderer: Texture marked for update but image is incomplete' );

			} else {

				uploadTexture( textureProperties, texture, slot );
				return;

			}

		}

		state.bindTexture( _gl.TEXTURE_2D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot );

	}

	function setTexture2DArray( texture, slot ) {

		const textureProperties = properties.get( texture );

		if ( texture.version > 0 && textureProperties.__version !== texture.version ) {

			uploadTexture( textureProperties, texture, slot );
			return;

		}

		state.bindTexture( _gl.TEXTURE_2D_ARRAY, textureProperties.__webglTexture, _gl.TEXTURE0 + slot );

	}

	function setTexture3D( texture, slot ) {

		const textureProperties = properties.get( texture );

		if ( texture.version > 0 && textureProperties.__version !== texture.version ) {

			uploadTexture( textureProperties, texture, slot );
			return;

		}

		state.bindTexture( _gl.TEXTURE_3D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot );

	}

	function setTextureCube( texture, slot ) {

		const textureProperties = properties.get( texture );

		if ( texture.version > 0 && textureProperties.__version !== texture.version ) {

			uploadCubeTexture( textureProperties, texture, slot );
			return;

		}

		state.bindTexture( _gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot );

	}

	const wrappingToGL = {
		[ RepeatWrapping ]: _gl.REPEAT,
		[ ClampToEdgeWrapping ]: _gl.CLAMP_TO_EDGE,
		[ MirroredRepeatWrapping ]: _gl.MIRRORED_REPEAT
	};

	const filterToGL = {
		[ NearestFilter ]: _gl.NEAREST,
		[ NearestMipmapNearestFilter ]: _gl.NEAREST_MIPMAP_NEAREST,
		[ NearestMipmapLinearFilter ]: _gl.NEAREST_MIPMAP_LINEAR,

		[ LinearFilter ]: _gl.LINEAR,
		[ LinearMipmapNearestFilter ]: _gl.LINEAR_MIPMAP_NEAREST,
		[ LinearMipmapLinearFilter ]: _gl.LINEAR_MIPMAP_LINEAR
	};

	const compareToGL = {
		[ NeverCompare ]: _gl.NEVER,
		[ AlwaysCompare ]: _gl.ALWAYS,
		[ LessCompare ]: _gl.LESS,
		[ LessEqualCompare ]: _gl.LEQUAL,
		[ EqualCompare ]: _gl.EQUAL,
		[ GreaterEqualCompare ]: _gl.GEQUAL,
		[ GreaterCompare ]: _gl.GREATER,
		[ NotEqualCompare ]: _gl.NOTEQUAL
	};

	function setTextureParameters( textureType, texture ) {

		if ( texture.type === FloatType && extensions.has( 'OES_texture_float_linear' ) === false &&
			( texture.magFilter === LinearFilter || texture.magFilter === LinearMipmapNearestFilter || texture.magFilter === NearestMipmapLinearFilter || texture.magFilter === LinearMipmapLinearFilter ||
			texture.minFilter === LinearFilter || texture.minFilter === LinearMipmapNearestFilter || texture.minFilter === NearestMipmapLinearFilter || texture.minFilter === LinearMipmapLinearFilter ) ) {

			console.warn( 'THREE.WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device.' );

		}

		_gl.texParameteri( textureType, _gl.TEXTURE_WRAP_S, wrappingToGL[ texture.wrapS ] );
		_gl.texParameteri( textureType, _gl.TEXTURE_WRAP_T, wrappingToGL[ texture.wrapT ] );

		if ( textureType === _gl.TEXTURE_3D || textureType === _gl.TEXTURE_2D_ARRAY ) {

			_gl.texParameteri( textureType, _gl.TEXTURE_WRAP_R, wrappingToGL[ texture.wrapR ] );

		}

		_gl.texParameteri( textureType, _gl.TEXTURE_MAG_FILTER, filterToGL[ texture.magFilter ] );
		_gl.texParameteri( textureType, _gl.TEXTURE_MIN_FILTER, filterToGL[ texture.minFilter ] );

		if ( texture.compareFunction ) {

			_gl.texParameteri( textureType, _gl.TEXTURE_COMPARE_MODE, _gl.COMPARE_REF_TO_TEXTURE );
			_gl.texParameteri( textureType, _gl.TEXTURE_COMPARE_FUNC, compareToGL[ texture.compareFunction ] );

		}

		if ( extensions.has( 'EXT_texture_filter_anisotropic' ) === true ) {

			if ( texture.magFilter === NearestFilter ) return;
			if ( texture.minFilter !== NearestMipmapLinearFilter && texture.minFilter !== LinearMipmapLinearFilter ) return;
			if ( texture.type === FloatType && extensions.has( 'OES_texture_float_linear' ) === false ) return; // verify extension

			if ( texture.anisotropy > 1 || properties.get( texture ).__currentAnisotropy ) {

				const extension = extensions.get( 'EXT_texture_filter_anisotropic' );
				_gl.texParameterf( textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min( texture.anisotropy, capabilities.getMaxAnisotropy() ) );
				properties.get( texture ).__currentAnisotropy = texture.anisotropy;

			}

		}

	}

	function initTexture( textureProperties, texture ) {

		let forceUpload = false;

		if ( textureProperties.__webglInit === undefined ) {

			textureProperties.__webglInit = true;

			texture.addEventListener( 'dispose', onTextureDispose );

		}

		// create Source <-> WebGLTextures mapping if necessary

		const source = texture.source;
		let webglTextures = _sources.get( source );

		if ( webglTextures === undefined ) {

			webglTextures = {};
			_sources.set( source, webglTextures );

		}

		// check if there is already a WebGLTexture object for the given texture parameters

		const textureCacheKey = getTextureCacheKey( texture );

		if ( textureCacheKey !== textureProperties.__cacheKey ) {

			// if not, create a new instance of WebGLTexture

			if ( webglTextures[ textureCacheKey ] === undefined ) {

				// create new entry

				webglTextures[ textureCacheKey ] = {
					texture: _gl.createTexture(),
					usedTimes: 0
				};

				info.memory.textures ++;

				// when a new instance of WebGLTexture was created, a texture upload is required
				// even if the image contents are identical

				forceUpload = true;

			}

			webglTextures[ textureCacheKey ].usedTimes ++;

			// every time the texture cache key changes, it's necessary to check if an instance of
			// WebGLTexture can be deleted in order to avoid a memory leak.

			const webglTexture = webglTextures[ textureProperties.__cacheKey ];

			if ( webglTexture !== undefined ) {

				webglTextures[ textureProperties.__cacheKey ].usedTimes --;

				if ( webglTexture.usedTimes === 0 ) {

					deleteTexture( texture );

				}

			}

			// store references to cache key and WebGLTexture object

			textureProperties.__cacheKey = textureCacheKey;
			textureProperties.__webglTexture = webglTextures[ textureCacheKey ].texture;

		}

		return forceUpload;

	}

	function uploadTexture( textureProperties, texture, slot ) {

		let textureType = _gl.TEXTURE_2D;

		if ( texture.isDataArrayTexture || texture.isCompressedArrayTexture ) textureType = _gl.TEXTURE_2D_ARRAY;
		if ( texture.isData3DTexture ) textureType = _gl.TEXTURE_3D;

		const forceUpload = initTexture( textureProperties, texture );
		const source = texture.source;

		state.bindTexture( textureType, textureProperties.__webglTexture, _gl.TEXTURE0 + slot );

		const sourceProperties = properties.get( source );

		if ( source.version !== sourceProperties.__version || forceUpload === true ) {

			state.activeTexture( _gl.TEXTURE0 + slot );

			const workingPrimaries = ColorManagement.getPrimaries( ColorManagement.workingColorSpace );
			const texturePrimaries = texture.colorSpace === NoColorSpace ? null : ColorManagement.getPrimaries( texture.colorSpace );
			const unpackConversion = texture.colorSpace === NoColorSpace || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;

			_gl.pixelStorei( _gl.UNPACK_FLIP_Y_WEBGL, texture.flipY );
			_gl.pixelStorei( _gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha );
			_gl.pixelStorei( _gl.UNPACK_ALIGNMENT, texture.unpackAlignment );
			_gl.pixelStorei( _gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion );

			let image = resizeImage( texture.image, false, capabilities.maxTextureSize );
			image = verifyColorSpace( texture, image );

			const glFormat = utils.convert( texture.format, texture.colorSpace );

			const glType = utils.convert( texture.type );
			let glInternalFormat = getInternalFormat( texture.internalFormat, glFormat, glType, texture.colorSpace, texture.isVideoTexture );

			setTextureParameters( textureType, texture );

			let mipmap;
			const mipmaps = texture.mipmaps;

			const useTexStorage = ( texture.isVideoTexture !== true && glInternalFormat !== RGB_ETC1_Format );
			const allocateMemory = ( sourceProperties.__version === undefined ) || ( forceUpload === true );
			const dataReady = source.dataReady;
			const levels = getMipLevels( texture, image );

			if ( texture.isDepthTexture ) {

				// populate depth texture with dummy data

				glInternalFormat = _gl.DEPTH_COMPONENT16;

				if ( texture.type === FloatType ) {

					glInternalFormat = _gl.DEPTH_COMPONENT32F;

				} else if ( texture.type === UnsignedIntType ) {

					glInternalFormat = _gl.DEPTH_COMPONENT24;

				} else if ( texture.type === UnsignedInt248Type ) {

					glInternalFormat = _gl.DEPTH24_STENCIL8;

				}

				//

				if ( allocateMemory ) {

					if ( useTexStorage ) {

						state.texStorage2D( _gl.TEXTURE_2D, 1, glInternalFormat, image.width, image.height );

					} else {

						state.texImage2D( _gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null );

					}

				}

			} else if ( texture.isDataTexture ) {

				// use manually created mipmaps if available
				// if there are no manual mipmaps
				// set 0 level mipmap and then use GL to generate other mipmap levels

				if ( mipmaps.length > 0 ) {

					if ( useTexStorage && allocateMemory ) {

						state.texStorage2D( _gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[ 0 ].width, mipmaps[ 0 ].height );

					}

					for ( let i = 0, il = mipmaps.length; i < il; i ++ ) {

						mipmap = mipmaps[ i ];

						if ( useTexStorage ) {

							if ( dataReady ) {

								state.texSubImage2D( _gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data );

							}

						} else {

							state.texImage2D( _gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data );

						}

					}

					texture.generateMipmaps = false;

				} else {

					if ( useTexStorage ) {

						if ( allocateMemory ) {

							state.texStorage2D( _gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height );

						}

						if ( dataReady ) {

							state.texSubImage2D( _gl.TEXTURE_2D, 0, 0, 0, image.width, image.height, glFormat, glType, image.data );

						}

					} else {

						state.texImage2D( _gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data );

					}

				}

			} else if ( texture.isCompressedTexture ) {

				if ( texture.isCompressedArrayTexture ) {

					if ( useTexStorage && allocateMemory ) {

						state.texStorage3D( _gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, mipmaps[ 0 ].width, mipmaps[ 0 ].height, image.depth );

					}

					for ( let i = 0, il = mipmaps.length; i < il; i ++ ) {

						mipmap = mipmaps[ i ];

						if ( texture.format !== RGBAFormat ) {

							if ( glFormat !== null ) {

								if ( useTexStorage ) {

									if ( dataReady ) {

										state.compressedTexSubImage3D( _gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, mipmap.data, 0, 0 );

									}

								} else {

									state.compressedTexImage3D( _gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, mipmap.data, 0, 0 );

								}

							} else {

								console.warn( 'THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()' );

							}

						} else {

							if ( useTexStorage ) {

								if ( dataReady ) {

									state.texSubImage3D( _gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, glType, mipmap.data );

								}

							} else {

								state.texImage3D( _gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, glFormat, glType, mipmap.data );

							}

						}

					}

				} else {

					if ( useTexStorage && allocateMemory ) {

						state.texStorage2D( _gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[ 0 ].width, mipmaps[ 0 ].height );

					}

					for ( let i = 0, il = mipmaps.length; i < il; i ++ ) {

						mipmap = mipmaps[ i ];

						if ( texture.format !== RGBAFormat ) {

							if ( glFormat !== null ) {

								if ( useTexStorage ) {

									if ( dataReady ) {

										state.compressedTexSubImage2D( _gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data );

									}

								} else {

									state.compressedTexImage2D( _gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data );

								}

							} else {

								console.warn( 'THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()' );

							}

						} else {

							if ( useTexStorage ) {

								if ( dataReady ) {

									state.texSubImage2D( _gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data );

								}

							} else {

								state.texImage2D( _gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data );

							}

						}

					}

				}

			} else if ( texture.isDataArrayTexture ) {

				if ( useTexStorage ) {

					if ( allocateMemory ) {

						state.texStorage3D( _gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, image.width, image.height, image.depth );

					}

					if ( dataReady ) {

						state.texSubImage3D( _gl.TEXTURE_2D_ARRAY, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data );

					}

				} else {

					state.texImage3D( _gl.TEXTURE_2D_ARRAY, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data );

				}

			} else if ( texture.isData3DTexture ) {

				if ( useTexStorage ) {

					if ( allocateMemory ) {

						state.texStorage3D( _gl.TEXTURE_3D, levels, glInternalFormat, image.width, image.height, image.depth );

					}

					if ( dataReady ) {

						state.texSubImage3D( _gl.TEXTURE_3D, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data );

					}

				} else {

					state.texImage3D( _gl.TEXTURE_3D, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data );

				}

			} else if ( texture.isFramebufferTexture ) {

				if ( allocateMemory ) {

					if ( useTexStorage ) {

						state.texStorage2D( _gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height );

					} else {

						let width = image.width, height = image.height;

						for ( let i = 0; i < levels; i ++ ) {

							state.texImage2D( _gl.TEXTURE_2D, i, glInternalFormat, width, height, 0, glFormat, glType, null );

							width >>= 1;
							height >>= 1;

						}

					}

				}

			} else {

				// regular Texture (image, video, canvas)

				// use manually created mipmaps if available
				// if there are no manual mipmaps
				// set 0 level mipmap and then use GL to generate other mipmap levels

				if ( mipmaps.length > 0 ) {

					if ( useTexStorage && allocateMemory ) {

						const dimensions = getDimensions( mipmaps[ 0 ] );

						state.texStorage2D( _gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height );

					}

					for ( let i = 0, il = mipmaps.length; i < il; i ++ ) {

						mipmap = mipmaps[ i ];

						if ( useTexStorage ) {

							if ( dataReady ) {

								state.texSubImage2D( _gl.TEXTURE_2D, i, 0, 0, glFormat, glType, mipmap );

							}

						} else {

							state.texImage2D( _gl.TEXTURE_2D, i, glInternalFormat, glFormat, glType, mipmap );

						}

					}

					texture.generateMipmaps = false;

				} else {

					if ( useTexStorage ) {

						if ( allocateMemory ) {

							const dimensions = getDimensions( image );

							state.texStorage2D( _gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height );

						}

						if ( dataReady ) {

							state.texSubImage2D( _gl.TEXTURE_2D, 0, 0, 0, glFormat, glType, image );

						}

					} else {

						state.texImage2D( _gl.TEXTURE_2D, 0, glInternalFormat, glFormat, glType, image );

					}

				}

			}

			if ( textureNeedsGenerateMipmaps( texture ) ) {

				generateMipmap( textureType );

			}

			sourceProperties.__version = source.version;

			if ( texture.onUpdate ) texture.onUpdate( texture );

		}

		textureProperties.__version = texture.version;

	}

	function uploadCubeTexture( textureProperties, texture, slot ) {

		if ( texture.image.length !== 6 ) return;

		const forceUpload = initTexture( textureProperties, texture );
		const source = texture.source;

		state.bindTexture( _gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot );

		const sourceProperties = properties.get( source );

		if ( source.version !== sourceProperties.__version || forceUpload === true ) {

			state.activeTexture( _gl.TEXTURE0 + slot );

			const workingPrimaries = ColorManagement.getPrimaries( ColorManagement.workingColorSpace );
			const texturePrimaries = texture.colorSpace === NoColorSpace ? null : ColorManagement.getPrimaries( texture.colorSpace );
			const unpackConversion = texture.colorSpace === NoColorSpace || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;

			_gl.pixelStorei( _gl.UNPACK_FLIP_Y_WEBGL, texture.flipY );
			_gl.pixelStorei( _gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha );
			_gl.pixelStorei( _gl.UNPACK_ALIGNMENT, texture.unpackAlignment );
			_gl.pixelStorei( _gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion );

			const isCompressed = ( texture.isCompressedTexture || texture.image[ 0 ].isCompressedTexture );
			const isDataTexture = ( texture.image[ 0 ] && texture.image[ 0 ].isDataTexture );

			const cubeImage = [];

			for ( let i = 0; i < 6; i ++ ) {

				if ( ! isCompressed && ! isDataTexture ) {

					cubeImage[ i ] = resizeImage( texture.image[ i ], true, capabilities.maxCubemapSize );

				} else {

					cubeImage[ i ] = isDataTexture ? texture.image[ i ].image : texture.image[ i ];

				}

				cubeImage[ i ] = verifyColorSpace( texture, cubeImage[ i ] );

			}

			const image = cubeImage[ 0 ],
				glFormat = utils.convert( texture.format, texture.colorSpace ),
				glType = utils.convert( texture.type ),
				glInternalFormat = getInternalFormat( texture.internalFormat, glFormat, glType, texture.colorSpace );

			const useTexStorage = ( texture.isVideoTexture !== true );
			const allocateMemory = ( sourceProperties.__version === undefined ) || ( forceUpload === true );
			const dataReady = source.dataReady;
			let levels = getMipLevels( texture, image );

			setTextureParameters( _gl.TEXTURE_CUBE_MAP, texture );

			let mipmaps;

			if ( isCompressed ) {

				if ( useTexStorage && allocateMemory ) {

					state.texStorage2D( _gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, image.width, image.height );

				}

				for ( let i = 0; i < 6; i ++ ) {

					mipmaps = cubeImage[ i ].mipmaps;

					for ( let j = 0; j < mipmaps.length; j ++ ) {

						const mipmap = mipmaps[ j ];

						if ( texture.format !== RGBAFormat ) {

							if ( glFormat !== null ) {

								if ( useTexStorage ) {

									if ( dataReady ) {

										state.compressedTexSubImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data );

									}

								} else {

									state.compressedTexImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data );

								}

							} else {

								console.warn( 'THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()' );

							}

						} else {

							if ( useTexStorage ) {

								if ( dataReady ) {

									state.texSubImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data );

								}

							} else {

								state.texImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data );

							}

						}

					}

				}

			} else {

				mipmaps = texture.mipmaps;

				if ( useTexStorage && allocateMemory ) {

					// TODO: Uniformly handle mipmap definitions
					// Normal textures and compressed cube textures define base level + mips with their mipmap array
					// Uncompressed cube textures use their mipmap array only for mips (no base level)

					if ( mipmaps.length > 0 ) levels ++;

					const dimensions = getDimensions( cubeImage[ 0 ] );

					state.texStorage2D( _gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, dimensions.width, dimensions.height );

				}

				for ( let i = 0; i < 6; i ++ ) {

					if ( isDataTexture ) {

						if ( useTexStorage ) {

							if ( dataReady ) {

								state.texSubImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, cubeImage[ i ].width, cubeImage[ i ].height, glFormat, glType, cubeImage[ i ].data );

							}

						} else {

							state.texImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, cubeImage[ i ].width, cubeImage[ i ].height, 0, glFormat, glType, cubeImage[ i ].data );

						}

						for ( let j = 0; j < mipmaps.length; j ++ ) {

							const mipmap = mipmaps[ j ];
							const mipmapImage = mipmap.image[ i ].image;

							if ( useTexStorage ) {

								if ( dataReady ) {

									state.texSubImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data );

								}

							} else {

								state.texImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data );

							}

						}

					} else {

						if ( useTexStorage ) {

							if ( dataReady ) {

								state.texSubImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, glFormat, glType, cubeImage[ i ] );

							}

						} else {

							state.texImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, glFormat, glType, cubeImage[ i ] );

						}

						for ( let j = 0; j < mipmaps.length; j ++ ) {

							const mipmap = mipmaps[ j ];

							if ( useTexStorage ) {

								if ( dataReady ) {

									state.texSubImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, glFormat, glType, mipmap.image[ i ] );

								}

							} else {

								state.texImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, glFormat, glType, mipmap.image[ i ] );

							}

						}

					}

				}

			}

			if ( textureNeedsGenerateMipmaps( texture ) ) {

				// We assume images for cube map have the same size.
				generateMipmap( _gl.TEXTURE_CUBE_MAP );

			}

			sourceProperties.__version = source.version;

			if ( texture.onUpdate ) texture.onUpdate( texture );

		}

		textureProperties.__version = texture.version;

	}

	// Render targets

	// Setup storage for target texture and bind it to correct framebuffer
	function setupFrameBufferTexture( framebuffer, renderTarget, texture, attachment, textureTarget, level ) {

		const glFormat = utils.convert( texture.format, texture.colorSpace );
		const glType = utils.convert( texture.type );
		const glInternalFormat = getInternalFormat( texture.internalFormat, glFormat, glType, texture.colorSpace );
		const renderTargetProperties = properties.get( renderTarget );

		if ( ! renderTargetProperties.__hasExternalTextures ) {

			const width = Math.max( 1, renderTarget.width >> level );
			const height = Math.max( 1, renderTarget.height >> level );

			if ( textureTarget === _gl.TEXTURE_3D || textureTarget === _gl.TEXTURE_2D_ARRAY ) {

				state.texImage3D( textureTarget, level, glInternalFormat, width, height, renderTarget.depth, 0, glFormat, glType, null );

			} else {

				state.texImage2D( textureTarget, level, glInternalFormat, width, height, 0, glFormat, glType, null );

			}

		}

		state.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );

		if ( useMultisampledRTT( renderTarget ) ) {

			multisampledRTTExt.framebufferTexture2DMultisampleEXT( _gl.FRAMEBUFFER, attachment, textureTarget, properties.get( texture ).__webglTexture, 0, getRenderTargetSamples( renderTarget ) );

		} else if ( textureTarget === _gl.TEXTURE_2D || ( textureTarget >= _gl.TEXTURE_CUBE_MAP_POSITIVE_X && textureTarget <= _gl.TEXTURE_CUBE_MAP_NEGATIVE_Z ) ) { // see #24753

			_gl.framebufferTexture2D( _gl.FRAMEBUFFER, attachment, textureTarget, properties.get( texture ).__webglTexture, level );

		}

		state.bindFramebuffer( _gl.FRAMEBUFFER, null );

	}


	// Setup storage for internal depth/stencil buffers and bind to correct framebuffer
	function setupRenderBufferStorage( renderbuffer, renderTarget, isMultisample ) {

		_gl.bindRenderbuffer( _gl.RENDERBUFFER, renderbuffer );

		if ( renderTarget.depthBuffer && ! renderTarget.stencilBuffer ) {

			let glInternalFormat = _gl.DEPTH_COMPONENT24;

			if ( isMultisample || useMultisampledRTT( renderTarget ) ) {

				const depthTexture = renderTarget.depthTexture;

				if ( depthTexture && depthTexture.isDepthTexture ) {

					if ( depthTexture.type === FloatType ) {

						glInternalFormat = _gl.DEPTH_COMPONENT32F;

					} else if ( depthTexture.type === UnsignedIntType ) {

						glInternalFormat = _gl.DEPTH_COMPONENT24;

					}

				}

				const samples = getRenderTargetSamples( renderTarget );

				if ( useMultisampledRTT( renderTarget ) ) {

					multisampledRTTExt.renderbufferStorageMultisampleEXT( _gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height );

				} else {

					_gl.renderbufferStorageMultisample( _gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height );

				}

			} else {

				_gl.renderbufferStorage( _gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height );

			}

			_gl.framebufferRenderbuffer( _gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.RENDERBUFFER, renderbuffer );

		} else if ( renderTarget.depthBuffer && renderTarget.stencilBuffer ) {

			const samples = getRenderTargetSamples( renderTarget );

			if ( isMultisample && useMultisampledRTT( renderTarget ) === false ) {

				_gl.renderbufferStorageMultisample( _gl.RENDERBUFFER, samples, _gl.DEPTH24_STENCIL8, renderTarget.width, renderTarget.height );

			} else if ( useMultisampledRTT( renderTarget ) ) {

				multisampledRTTExt.renderbufferStorageMultisampleEXT( _gl.RENDERBUFFER, samples, _gl.DEPTH24_STENCIL8, renderTarget.width, renderTarget.height );

			} else {

				_gl.renderbufferStorage( _gl.RENDERBUFFER, _gl.DEPTH_STENCIL, renderTarget.width, renderTarget.height );

			}


			_gl.framebufferRenderbuffer( _gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.RENDERBUFFER, renderbuffer );

		} else {

			const textures = renderTarget.textures;

			for ( let i = 0; i < textures.length; i ++ ) {

				const texture = textures[ i ];

				const glFormat = utils.convert( texture.format, texture.colorSpace );
				const glType = utils.convert( texture.type );
				const glInternalFormat = getInternalFormat( texture.internalFormat, glFormat, glType, texture.colorSpace );
				const samples = getRenderTargetSamples( renderTarget );

				if ( isMultisample && useMultisampledRTT( renderTarget ) === false ) {

					_gl.renderbufferStorageMultisample( _gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height );

				} else if ( useMultisampledRTT( renderTarget ) ) {

					multisampledRTTExt.renderbufferStorageMultisampleEXT( _gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height );

				} else {

					_gl.renderbufferStorage( _gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height );

				}

			}

		}

		_gl.bindRenderbuffer( _gl.RENDERBUFFER, null );

	}

	// Setup resources for a Depth Texture for a FBO (needs an extension)
	function setupDepthTexture( framebuffer, renderTarget ) {

		const isCube = ( renderTarget && renderTarget.isWebGLCubeRenderTarget );
		if ( isCube ) throw new Error( 'Depth Texture with cube render targets is not supported' );

		state.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );

		if ( ! ( renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture ) ) {

			throw new Error( 'renderTarget.depthTexture must be an instance of THREE.DepthTexture' );

		}

		// upload an empty depth texture with framebuffer size
		if ( ! properties.get( renderTarget.depthTexture ).__webglTexture ||
				renderTarget.depthTexture.image.width !== renderTarget.width ||
				renderTarget.depthTexture.image.height !== renderTarget.height ) {

			renderTarget.depthTexture.image.width = renderTarget.width;
			renderTarget.depthTexture.image.height = renderTarget.height;
			renderTarget.depthTexture.needsUpdate = true;

		}

		setTexture2D( renderTarget.depthTexture, 0 );

		const webglDepthTexture = properties.get( renderTarget.depthTexture ).__webglTexture;
		const samples = getRenderTargetSamples( renderTarget );

		if ( renderTarget.depthTexture.format === DepthFormat ) {

			if ( useMultisampledRTT( renderTarget ) ) {

				multisampledRTTExt.framebufferTexture2DMultisampleEXT( _gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples );

			} else {

				_gl.framebufferTexture2D( _gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0 );

			}

		} else if ( renderTarget.depthTexture.format === DepthStencilFormat ) {

			if ( useMultisampledRTT( renderTarget ) ) {

				multisampledRTTExt.framebufferTexture2DMultisampleEXT( _gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples );

			} else {

				_gl.framebufferTexture2D( _gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0 );

			}

		} else {

			throw new Error( 'Unknown depthTexture format' );

		}

	}

	// Setup GL resources for a non-texture depth buffer
	function setupDepthRenderbuffer( renderTarget ) {

		const renderTargetProperties = properties.get( renderTarget );
		const isCube = ( renderTarget.isWebGLCubeRenderTarget === true );

		if ( renderTarget.depthTexture && ! renderTargetProperties.__autoAllocateDepthBuffer ) {

			if ( isCube ) throw new Error( 'target.depthTexture not supported in Cube render targets' );

			setupDepthTexture( renderTargetProperties.__webglFramebuffer, renderTarget );

		} else {

			if ( isCube ) {

				renderTargetProperties.__webglDepthbuffer = [];

				for ( let i = 0; i < 6; i ++ ) {

					state.bindFramebuffer( _gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[ i ] );
					renderTargetProperties.__webglDepthbuffer[ i ] = _gl.createRenderbuffer();
					setupRenderBufferStorage( renderTargetProperties.__webglDepthbuffer[ i ], renderTarget, false );

				}

			} else {

				state.bindFramebuffer( _gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer );
				renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
				setupRenderBufferStorage( renderTargetProperties.__webglDepthbuffer, renderTarget, false );

			}

		}

		state.bindFramebuffer( _gl.FRAMEBUFFER, null );

	}

	// rebind framebuffer with external textures
	function rebindTextures( renderTarget, colorTexture, depthTexture ) {

		const renderTargetProperties = properties.get( renderTarget );

		if ( colorTexture !== undefined ) {

			setupFrameBufferTexture( renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, 0 );

		}

		if ( depthTexture !== undefined ) {

			setupDepthRenderbuffer( renderTarget );

		}

	}

	// Set up GL resources for the render target
	function setupRenderTarget( renderTarget ) {

		const texture = renderTarget.texture;

		const renderTargetProperties = properties.get( renderTarget );
		const textureProperties = properties.get( texture );

		renderTarget.addEventListener( 'dispose', onRenderTargetDispose );

		const textures = renderTarget.textures;

		const isCube = ( renderTarget.isWebGLCubeRenderTarget === true );
		const isMultipleRenderTargets = ( textures.length > 1 );

		if ( ! isMultipleRenderTargets ) {

			if ( textureProperties.__webglTexture === undefined ) {

				textureProperties.__webglTexture = _gl.createTexture();

			}

			textureProperties.__version = texture.version;
			info.memory.textures ++;

		}

		// Setup framebuffer

		if ( isCube ) {

			renderTargetProperties.__webglFramebuffer = [];

			for ( let i = 0; i < 6; i ++ ) {

				if ( texture.mipmaps && texture.mipmaps.length > 0 ) {

					renderTargetProperties.__webglFramebuffer[ i ] = [];

					for ( let level = 0; level < texture.mipmaps.length; level ++ ) {

						renderTargetProperties.__webglFramebuffer[ i ][ level ] = _gl.createFramebuffer();

					}

				} else {

					renderTargetProperties.__webglFramebuffer[ i ] = _gl.createFramebuffer();

				}

			}

		} else {

			if ( texture.mipmaps && texture.mipmaps.length > 0 ) {

				renderTargetProperties.__webglFramebuffer = [];

				for ( let level = 0; level < texture.mipmaps.length; level ++ ) {

					renderTargetProperties.__webglFramebuffer[ level ] = _gl.createFramebuffer();

				}

			} else {

				renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();

			}

			if ( isMultipleRenderTargets ) {

				for ( let i = 0, il = textures.length; i < il; i ++ ) {

					const attachmentProperties = properties.get( textures[ i ] );

					if ( attachmentProperties.__webglTexture === undefined ) {

						attachmentProperties.__webglTexture = _gl.createTexture();

						info.memory.textures ++;

					}

				}

			}

			if ( ( renderTarget.samples > 0 ) && useMultisampledRTT( renderTarget ) === false ) {

				renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
				renderTargetProperties.__webglColorRenderbuffer = [];

				state.bindFramebuffer( _gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer );

				for ( let i = 0; i < textures.length; i ++ ) {

					const texture = textures[ i ];
					renderTargetProperties.__webglColorRenderbuffer[ i ] = _gl.createRenderbuffer();

					_gl.bindRenderbuffer( _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[ i ] );

					const glFormat = utils.convert( texture.format, texture.colorSpace );
					const glType = utils.convert( texture.type );
					const glInternalFormat = getInternalFormat( texture.internalFormat, glFormat, glType, texture.colorSpace, renderTarget.isXRRenderTarget === true );
					const samples = getRenderTargetSamples( renderTarget );
					_gl.renderbufferStorageMultisample( _gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height );

					_gl.framebufferRenderbuffer( _gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[ i ] );

				}

				_gl.bindRenderbuffer( _gl.RENDERBUFFER, null );

				if ( renderTarget.depthBuffer ) {

					renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
					setupRenderBufferStorage( renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true );

				}

				state.bindFramebuffer( _gl.FRAMEBUFFER, null );

			}

		}

		// Setup color buffer

		if ( isCube ) {

			state.bindTexture( _gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture );
			setTextureParameters( _gl.TEXTURE_CUBE_MAP, texture );

			for ( let i = 0; i < 6; i ++ ) {

				if ( texture.mipmaps && texture.mipmaps.length > 0 ) {

					for ( let level = 0; level < texture.mipmaps.length; level ++ ) {

						setupFrameBufferTexture( renderTargetProperties.__webglFramebuffer[ i ][ level ], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, level );

					}

				} else {

					setupFrameBufferTexture( renderTargetProperties.__webglFramebuffer[ i ], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0 );

				}

			}

			if ( textureNeedsGenerateMipmaps( texture ) ) {

				generateMipmap( _gl.TEXTURE_CUBE_MAP );

			}

			state.unbindTexture();

		} else if ( isMultipleRenderTargets ) {

			for ( let i = 0, il = textures.length; i < il; i ++ ) {

				const attachment = textures[ i ];
				const attachmentProperties = properties.get( attachment );

				state.bindTexture( _gl.TEXTURE_2D, attachmentProperties.__webglTexture );
				setTextureParameters( _gl.TEXTURE_2D, attachment );
				setupFrameBufferTexture( renderTargetProperties.__webglFramebuffer, renderTarget, attachment, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, 0 );

				if ( textureNeedsGenerateMipmaps( attachment ) ) {

					generateMipmap( _gl.TEXTURE_2D );

				}

			}

			state.unbindTexture();

		} else {

			let glTextureType = _gl.TEXTURE_2D;

			if ( renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget ) {

				glTextureType = renderTarget.isWebGL3DRenderTarget ? _gl.TEXTURE_3D : _gl.TEXTURE_2D_ARRAY;

			}

			state.bindTexture( glTextureType, textureProperties.__webglTexture );
			setTextureParameters( glTextureType, texture );

			if ( texture.mipmaps && texture.mipmaps.length > 0 ) {

				for ( let level = 0; level < texture.mipmaps.length; level ++ ) {

					setupFrameBufferTexture( renderTargetProperties.__webglFramebuffer[ level ], renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, level );

				}

			} else {

				setupFrameBufferTexture( renderTargetProperties.__webglFramebuffer, renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, 0 );

			}

			if ( textureNeedsGenerateMipmaps( texture ) ) {

				generateMipmap( glTextureType );

			}

			state.unbindTexture();

		}

		// Setup depth and stencil buffers

		if ( renderTarget.depthBuffer ) {

			setupDepthRenderbuffer( renderTarget );

		}

	}

	function updateRenderTargetMipmap( renderTarget ) {

		const textures = renderTarget.textures;

		for ( let i = 0, il = textures.length; i < il; i ++ ) {

			const texture = textures[ i ];

			if ( textureNeedsGenerateMipmaps( texture ) ) {

				const target = renderTarget.isWebGLCubeRenderTarget ? _gl.TEXTURE_CUBE_MAP : _gl.TEXTURE_2D;
				const webglTexture = properties.get( texture ).__webglTexture;

				state.bindTexture( target, webglTexture );
				generateMipmap( target );
				state.unbindTexture();

			}

		}

	}

	function updateMultisampleRenderTarget( renderTarget ) {

		if ( ( renderTarget.samples > 0 ) && useMultisampledRTT( renderTarget ) === false ) {

			const textures = renderTarget.textures;
			const width = renderTarget.width;
			const height = renderTarget.height;
			let mask = _gl.COLOR_BUFFER_BIT;
			const invalidationArray = [];
			const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
			const renderTargetProperties = properties.get( renderTarget );
			const isMultipleRenderTargets = ( textures.length > 1 );

			// If MRT we need to remove FBO attachments
			if ( isMultipleRenderTargets ) {

				for ( let i = 0; i < textures.length; i ++ ) {

					state.bindFramebuffer( _gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer );
					_gl.framebufferRenderbuffer( _gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, null );

					state.bindFramebuffer( _gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer );
					_gl.framebufferTexture2D( _gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, null, 0 );

				}

			}

			state.bindFramebuffer( _gl.READ_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer );
			state.bindFramebuffer( _gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglFramebuffer );

			for ( let i = 0; i < textures.length; i ++ ) {

				invalidationArray.push( _gl.COLOR_ATTACHMENT0 + i );

				if ( renderTarget.depthBuffer ) {

					invalidationArray.push( depthStyle );

				}

				const ignoreDepthValues = ( renderTargetProperties.__ignoreDepthValues !== undefined ) ? renderTargetProperties.__ignoreDepthValues : false;

				if ( ignoreDepthValues === false ) {

					if ( renderTarget.depthBuffer ) mask |= _gl.DEPTH_BUFFER_BIT;

					// resolving stencil is slow with a D3D backend. disable it for all transmission render targets (see #27799)

					if ( renderTarget.stencilBuffer && renderTargetProperties.__isTransmissionRenderTarget !== true ) mask |= _gl.STENCIL_BUFFER_BIT;

				}

				if ( isMultipleRenderTargets ) {

					_gl.framebufferRenderbuffer( _gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[ i ] );

				}

				if ( ignoreDepthValues === true ) {

					_gl.invalidateFramebuffer( _gl.READ_FRAMEBUFFER, [ depthStyle ] );
					_gl.invalidateFramebuffer( _gl.DRAW_FRAMEBUFFER, [ depthStyle ] );

				}

				if ( isMultipleRenderTargets ) {

					const webglTexture = properties.get( textures[ i ] ).__webglTexture;
					_gl.framebufferTexture2D( _gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, webglTexture, 0 );

				}

				_gl.blitFramebuffer( 0, 0, width, height, 0, 0, width, height, mask, _gl.NEAREST );

				if ( supportsInvalidateFramebuffer ) {

					_gl.invalidateFramebuffer( _gl.READ_FRAMEBUFFER, invalidationArray );

				}


			}

			state.bindFramebuffer( _gl.READ_FRAMEBUFFER, null );
			state.bindFramebuffer( _gl.DRAW_FRAMEBUFFER, null );

			// If MRT since pre-blit we removed the FBO we need to reconstruct the attachments
			if ( isMultipleRenderTargets ) {

				for ( let i = 0; i < textures.length; i ++ ) {

					state.bindFramebuffer( _gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer );
					_gl.framebufferRenderbuffer( _gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[ i ] );

					const webglTexture = properties.get( textures[ i ] ).__webglTexture;

					state.bindFramebuffer( _gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer );
					_gl.framebufferTexture2D( _gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, webglTexture, 0 );

				}

			}

			state.bindFramebuffer( _gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer );

		}

	}

	function getRenderTargetSamples( renderTarget ) {

		return Math.min( capabilities.maxSamples, renderTarget.samples );

	}

	function useMultisampledRTT( renderTarget ) {

		const renderTargetProperties = properties.get( renderTarget );

		return renderTarget.samples > 0 && extensions.has( 'WEBGL_multisampled_render_to_texture' ) === true && renderTargetProperties.__useRenderToTexture !== false;

	}

	function updateVideoTexture( texture ) {

		const frame = info.render.frame;

		// Check the last frame we updated the VideoTexture

		if ( _videoTextures.get( texture ) !== frame ) {

			_videoTextures.set( texture, frame );
			texture.update();

		}

	}

	function verifyColorSpace( texture, image ) {

		const colorSpace = texture.colorSpace;
		const format = texture.format;
		const type = texture.type;

		if ( texture.isCompressedTexture === true || texture.isVideoTexture === true ) return image;

		if ( colorSpace !== LinearSRGBColorSpace && colorSpace !== NoColorSpace ) {

			// sRGB

			if ( ColorManagement.getTransfer( colorSpace ) === SRGBTransfer ) {

				// in WebGL 2 uncompressed textures can only be sRGB encoded if they have the RGBA8 format

				if ( format !== RGBAFormat || type !== UnsignedByteType ) {

					console.warn( 'THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.' );

				}

			} else {

				console.error( 'THREE.WebGLTextures: Unsupported texture color space:', colorSpace );

			}

		}

		return image;

	}

	function getDimensions( image ) {

		if ( typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement ) {

			// if intrinsic data are not available, fallback to width/height

			_imageDimensions.width = image.naturalWidth || image.width;
			_imageDimensions.height = image.naturalHeight || image.height;

		} else if ( typeof VideoFrame !== 'undefined' && image instanceof VideoFrame ) {

			_imageDimensions.width = image.displayWidth;
			_imageDimensions.height = image.displayHeight;

		} else {

			_imageDimensions.width = image.width;
			_imageDimensions.height = image.height;

		}

		return _imageDimensions;

	}

	//

	this.allocateTextureUnit = allocateTextureUnit;
	this.resetTextureUnits = resetTextureUnits;

	this.setTexture2D = setTexture2D;
	this.setTexture2DArray = setTexture2DArray;
	this.setTexture3D = setTexture3D;
	this.setTextureCube = setTextureCube;
	this.rebindTextures = rebindTextures;
	this.setupRenderTarget = setupRenderTarget;
	this.updateRenderTargetMipmap = updateRenderTargetMipmap;
	this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
	this.setupDepthRenderbuffer = setupDepthRenderbuffer;
	this.setupFrameBufferTexture = setupFrameBufferTexture;
	this.useMultisampledRTT = useMultisampledRTT;

}

function WebGLUtils( gl, extensions ) {

	function convert( p, colorSpace = NoColorSpace ) {

		let extension;

		const transfer = ColorManagement.getTransfer( colorSpace );

		if ( p === UnsignedByteType ) return gl.UNSIGNED_BYTE;
		if ( p === UnsignedShort4444Type ) return gl.UNSIGNED_SHORT_4_4_4_4;
		if ( p === UnsignedShort5551Type ) return gl.UNSIGNED_SHORT_5_5_5_1;
		if ( p === UnsignedInt5999Type ) return gl.UNSIGNED_INT_5_9_9_9_REV;

		if ( p === ByteType ) return gl.BYTE;
		if ( p === ShortType ) return gl.SHORT;
		if ( p === UnsignedShortType ) return gl.UNSIGNED_SHORT;
		if ( p === IntType ) return gl.INT;
		if ( p === UnsignedIntType ) return gl.UNSIGNED_INT;
		if ( p === FloatType ) return gl.FLOAT;
		if ( p === HalfFloatType ) return gl.HALF_FLOAT;

		if ( p === AlphaFormat ) return gl.ALPHA;
		if ( p === RGBFormat ) return gl.RGB;
		if ( p === RGBAFormat ) return gl.RGBA;
		if ( p === LuminanceFormat ) return gl.LUMINANCE;
		if ( p === LuminanceAlphaFormat ) return gl.LUMINANCE_ALPHA;
		if ( p === DepthFormat ) return gl.DEPTH_COMPONENT;
		if ( p === DepthStencilFormat ) return gl.DEPTH_STENCIL;

		// WebGL2 formats.

		if ( p === RedFormat ) return gl.RED;
		if ( p === RedIntegerFormat ) return gl.RED_INTEGER;
		if ( p === RGFormat ) return gl.RG;
		if ( p === RGIntegerFormat ) return gl.RG_INTEGER;
		if ( p === RGBAIntegerFormat ) return gl.RGBA_INTEGER;

		// S3TC

		if ( p === RGB_S3TC_DXT1_Format || p === RGBA_S3TC_DXT1_Format || p === RGBA_S3TC_DXT3_Format || p === RGBA_S3TC_DXT5_Format ) {

			if ( transfer === SRGBTransfer ) {

				extension = extensions.get( 'WEBGL_compressed_texture_s3tc_srgb' );

				if ( extension !== null ) {

					if ( p === RGB_S3TC_DXT1_Format ) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
					if ( p === RGBA_S3TC_DXT1_Format ) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
					if ( p === RGBA_S3TC_DXT3_Format ) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
					if ( p === RGBA_S3TC_DXT5_Format ) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;

				} else {

					return null;

				}

			} else {

				extension = extensions.get( 'WEBGL_compressed_texture_s3tc' );

				if ( extension !== null ) {

					if ( p === RGB_S3TC_DXT1_Format ) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
					if ( p === RGBA_S3TC_DXT1_Format ) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
					if ( p === RGBA_S3TC_DXT3_Format ) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
					if ( p === RGBA_S3TC_DXT5_Format ) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;

				} else {

					return null;

				}

			}

		}

		// PVRTC

		if ( p === RGB_PVRTC_4BPPV1_Format || p === RGB_PVRTC_2BPPV1_Format || p === RGBA_PVRTC_4BPPV1_Format || p === RGBA_PVRTC_2BPPV1_Format ) {

			extension = extensions.get( 'WEBGL_compressed_texture_pvrtc' );

			if ( extension !== null ) {

				if ( p === RGB_PVRTC_4BPPV1_Format ) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
				if ( p === RGB_PVRTC_2BPPV1_Format ) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
				if ( p === RGBA_PVRTC_4BPPV1_Format ) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
				if ( p === RGBA_PVRTC_2BPPV1_Format ) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;

			} else {

				return null;

			}

		}

		// ETC1

		if ( p === RGB_ETC1_Format ) {

			extension = extensions.get( 'WEBGL_compressed_texture_etc1' );

			if ( extension !== null ) {

				return extension.COMPRESSED_RGB_ETC1_WEBGL;

			} else {

				return null;

			}

		}

		// ETC2

		if ( p === RGB_ETC2_Format || p === RGBA_ETC2_EAC_Format ) {

			extension = extensions.get( 'WEBGL_compressed_texture_etc' );

			if ( extension !== null ) {

				if ( p === RGB_ETC2_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
				if ( p === RGBA_ETC2_EAC_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;

			} else {

				return null;

			}

		}

		// ASTC

		if ( p === RGBA_ASTC_4x4_Format || p === RGBA_ASTC_5x4_Format || p === RGBA_ASTC_5x5_Format ||
			p === RGBA_ASTC_6x5_Format || p === RGBA_ASTC_6x6_Format || p === RGBA_ASTC_8x5_Format ||
			p === RGBA_ASTC_8x6_Format || p === RGBA_ASTC_8x8_Format || p === RGBA_ASTC_10x5_Format ||
			p === RGBA_ASTC_10x6_Format || p === RGBA_ASTC_10x8_Format || p === RGBA_ASTC_10x10_Format ||
			p === RGBA_ASTC_12x10_Format || p === RGBA_ASTC_12x12_Format ) {

			extension = extensions.get( 'WEBGL_compressed_texture_astc' );

			if ( extension !== null ) {

				if ( p === RGBA_ASTC_4x4_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
				if ( p === RGBA_ASTC_5x4_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
				if ( p === RGBA_ASTC_5x5_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
				if ( p === RGBA_ASTC_6x5_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
				if ( p === RGBA_ASTC_6x6_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
				if ( p === RGBA_ASTC_8x5_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
				if ( p === RGBA_ASTC_8x6_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
				if ( p === RGBA_ASTC_8x8_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
				if ( p === RGBA_ASTC_10x5_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
				if ( p === RGBA_ASTC_10x6_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
				if ( p === RGBA_ASTC_10x8_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
				if ( p === RGBA_ASTC_10x10_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
				if ( p === RGBA_ASTC_12x10_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
				if ( p === RGBA_ASTC_12x12_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;

			} else {

				return null;

			}

		}

		// BPTC

		if ( p === RGBA_BPTC_Format || p === RGB_BPTC_SIGNED_Format || p === RGB_BPTC_UNSIGNED_Format ) {

			extension = extensions.get( 'EXT_texture_compression_bptc' );

			if ( extension !== null ) {

				if ( p === RGBA_BPTC_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
				if ( p === RGB_BPTC_SIGNED_Format ) return extension.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
				if ( p === RGB_BPTC_UNSIGNED_Format ) return extension.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;

			} else {

				return null;

			}

		}

		// RGTC

		if ( p === RED_RGTC1_Format || p === SIGNED_RED_RGTC1_Format || p === RED_GREEN_RGTC2_Format || p === SIGNED_RED_GREEN_RGTC2_Format ) {

			extension = extensions.get( 'EXT_texture_compression_rgtc' );

			if ( extension !== null ) {

				if ( p === RGBA_BPTC_Format ) return extension.COMPRESSED_RED_RGTC1_EXT;
				if ( p === SIGNED_RED_RGTC1_Format ) return extension.COMPRESSED_SIGNED_RED_RGTC1_EXT;
				if ( p === RED_GREEN_RGTC2_Format ) return extension.COMPRESSED_RED_GREEN_RGTC2_EXT;
				if ( p === SIGNED_RED_GREEN_RGTC2_Format ) return extension.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;

			} else {

				return null;

			}

		}

		//

		if ( p === UnsignedInt248Type ) return gl.UNSIGNED_INT_24_8;

		// if "p" can't be resolved, assume the user defines a WebGL constant as a string (fallback/workaround for packed RGB formats)

		return ( gl[ p ] !== undefined ) ? gl[ p ] : null;

	}

	return { convert: convert };

}

class ArrayCamera extends (/* unused pure expression or super */ null && (PerspectiveCamera)) {

	constructor( array = [] ) {

		super();

		this.isArrayCamera = true;

		this.cameras = array;

	}

}

class Group extends Object3D {

	constructor() {

		super();

		this.isGroup = true;

		this.type = 'Group';

	}

}

const _moveEvent = { type: 'move' };

class WebXRController {

	constructor() {

		this._targetRay = null;
		this._grip = null;
		this._hand = null;

	}

	getHandSpace() {

		if ( this._hand === null ) {

			this._hand = new Group();
			this._hand.matrixAutoUpdate = false;
			this._hand.visible = false;

			this._hand.joints = {};
			this._hand.inputState = { pinching: false };

		}

		return this._hand;

	}

	getTargetRaySpace() {

		if ( this._targetRay === null ) {

			this._targetRay = new Group();
			this._targetRay.matrixAutoUpdate = false;
			this._targetRay.visible = false;
			this._targetRay.hasLinearVelocity = false;
			this._targetRay.linearVelocity = new Vector3();
			this._targetRay.hasAngularVelocity = false;
			this._targetRay.angularVelocity = new Vector3();

		}

		return this._targetRay;

	}

	getGripSpace() {

		if ( this._grip === null ) {

			this._grip = new Group();
			this._grip.matrixAutoUpdate = false;
			this._grip.visible = false;
			this._grip.hasLinearVelocity = false;
			this._grip.linearVelocity = new Vector3();
			this._grip.hasAngularVelocity = false;
			this._grip.angularVelocity = new Vector3();

		}

		return this._grip;

	}

	dispatchEvent( event ) {

		if ( this._targetRay !== null ) {

			this._targetRay.dispatchEvent( event );

		}

		if ( this._grip !== null ) {

			this._grip.dispatchEvent( event );

		}

		if ( this._hand !== null ) {

			this._hand.dispatchEvent( event );

		}

		return this;

	}

	connect( inputSource ) {

		if ( inputSource && inputSource.hand ) {

			const hand = this._hand;

			if ( hand ) {

				for ( const inputjoint of inputSource.hand.values() ) {

					// Initialize hand with joints when connected
					this._getHandJoint( hand, inputjoint );

				}

			}

		}

		this.dispatchEvent( { type: 'connected', data: inputSource } );

		return this;

	}

	disconnect( inputSource ) {

		this.dispatchEvent( { type: 'disconnected', data: inputSource } );

		if ( this._targetRay !== null ) {

			this._targetRay.visible = false;

		}

		if ( this._grip !== null ) {

			this._grip.visible = false;

		}

		if ( this._hand !== null ) {

			this._hand.visible = false;

		}

		return this;

	}

	update( inputSource, frame, referenceSpace ) {

		let inputPose = null;
		let gripPose = null;
		let handPose = null;

		const targetRay = this._targetRay;
		const grip = this._grip;
		const hand = this._hand;

		if ( inputSource && frame.session.visibilityState !== 'visible-blurred' ) {

			if ( hand && inputSource.hand ) {

				handPose = true;

				for ( const inputjoint of inputSource.hand.values() ) {

					// Update the joints groups with the XRJoint poses
					const jointPose = frame.getJointPose( inputjoint, referenceSpace );

					// The transform of this joint will be updated with the joint pose on each frame
					const joint = this._getHandJoint( hand, inputjoint );

					if ( jointPose !== null ) {

						joint.matrix.fromArray( jointPose.transform.matrix );
						joint.matrix.decompose( joint.position, joint.rotation, joint.scale );
						joint.matrixWorldNeedsUpdate = true;
						joint.jointRadius = jointPose.radius;

					}

					joint.visible = jointPose !== null;

				}

				// Custom events

				// Check pinchz
				const indexTip = hand.joints[ 'index-finger-tip' ];
				const thumbTip = hand.joints[ 'thumb-tip' ];
				const distance = indexTip.position.distanceTo( thumbTip.position );

				const distanceToPinch = 0.02;
				const threshold = 0.005;

				if ( hand.inputState.pinching && distance > distanceToPinch + threshold ) {

					hand.inputState.pinching = false;
					this.dispatchEvent( {
						type: 'pinchend',
						handedness: inputSource.handedness,
						target: this
					} );

				} else if ( ! hand.inputState.pinching && distance <= distanceToPinch - threshold ) {

					hand.inputState.pinching = true;
					this.dispatchEvent( {
						type: 'pinchstart',
						handedness: inputSource.handedness,
						target: this
					} );

				}

			} else {

				if ( grip !== null && inputSource.gripSpace ) {

					gripPose = frame.getPose( inputSource.gripSpace, referenceSpace );

					if ( gripPose !== null ) {

						grip.matrix.fromArray( gripPose.transform.matrix );
						grip.matrix.decompose( grip.position, grip.rotation, grip.scale );
						grip.matrixWorldNeedsUpdate = true;

						if ( gripPose.linearVelocity ) {

							grip.hasLinearVelocity = true;
							grip.linearVelocity.copy( gripPose.linearVelocity );

						} else {

							grip.hasLinearVelocity = false;

						}

						if ( gripPose.angularVelocity ) {

							grip.hasAngularVelocity = true;
							grip.angularVelocity.copy( gripPose.angularVelocity );

						} else {

							grip.hasAngularVelocity = false;

						}

					}

				}

			}

			if ( targetRay !== null ) {

				inputPose = frame.getPose( inputSource.targetRaySpace, referenceSpace );

				// Some runtimes (namely Vive Cosmos with Vive OpenXR Runtime) have only grip space and ray space is equal to it
				if ( inputPose === null && gripPose !== null ) {

					inputPose = gripPose;

				}

				if ( inputPose !== null ) {

					targetRay.matrix.fromArray( inputPose.transform.matrix );
					targetRay.matrix.decompose( targetRay.position, targetRay.rotation, targetRay.scale );
					targetRay.matrixWorldNeedsUpdate = true;

					if ( inputPose.linearVelocity ) {

						targetRay.hasLinearVelocity = true;
						targetRay.linearVelocity.copy( inputPose.linearVelocity );

					} else {

						targetRay.hasLinearVelocity = false;

					}

					if ( inputPose.angularVelocity ) {

						targetRay.hasAngularVelocity = true;
						targetRay.angularVelocity.copy( inputPose.angularVelocity );

					} else {

						targetRay.hasAngularVelocity = false;

					}

					this.dispatchEvent( _moveEvent );

				}

			}


		}

		if ( targetRay !== null ) {

			targetRay.visible = ( inputPose !== null );

		}

		if ( grip !== null ) {

			grip.visible = ( gripPose !== null );

		}

		if ( hand !== null ) {

			hand.visible = ( handPose !== null );

		}

		return this;

	}

	// private method

	_getHandJoint( hand, inputjoint ) {

		if ( hand.joints[ inputjoint.jointName ] === undefined ) {

			const joint = new Group();
			joint.matrixAutoUpdate = false;
			joint.visible = false;
			hand.joints[ inputjoint.jointName ] = joint;

			hand.add( joint );

		}

		return hand.joints[ inputjoint.jointName ];

	}

}

const _occlusion_vertex = (/* unused pure expression or super */ null && (`
void main() {

	gl_Position = vec4( position, 1.0 );

}`));

const _occlusion_fragment = (/* unused pure expression or super */ null && (`
uniform sampler2DArray depthColor;
uniform float depthWidth;
uniform float depthHeight;

void main() {

	vec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );

	if ( coord.x >= 1.0 ) {

		gl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;

	} else {

		gl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;

	}

}`));

class WebXRDepthSensing {

	constructor() {

		this.texture = null;
		this.mesh = null;

		this.depthNear = 0;
		this.depthFar = 0;

	}

	init( renderer, depthData, renderState ) {

		if ( this.texture === null ) {

			const texture = new Texture();

			const texProps = renderer.properties.get( texture );
			texProps.__webglTexture = depthData.texture;

			if ( ( depthData.depthNear != renderState.depthNear ) || ( depthData.depthFar != renderState.depthFar ) ) {

				this.depthNear = depthData.depthNear;
				this.depthFar = depthData.depthFar;

			}

			this.texture = texture;

		}

	}

	render( renderer, cameraXR ) {

		if ( this.texture !== null ) {

			if ( this.mesh === null ) {

				const viewport = cameraXR.cameras[ 0 ].viewport;
				const material = new ShaderMaterial( {
					vertexShader: _occlusion_vertex,
					fragmentShader: _occlusion_fragment,
					uniforms: {
						depthColor: { value: this.texture },
						depthWidth: { value: viewport.z },
						depthHeight: { value: viewport.w }
					}
				} );

				this.mesh = new Mesh( new PlaneGeometry( 20, 20 ), material );

			}

			renderer.render( this.mesh, cameraXR );

		}

	}

	reset() {

		this.texture = null;
		this.mesh = null;

	}

}

class WebXRManager extends (/* unused pure expression or super */ null && (EventDispatcher)) {

	constructor( renderer, gl ) {

		super();

		const scope = this;

		let session = null;

		let framebufferScaleFactor = 1.0;

		let referenceSpace = null;
		let referenceSpaceType = 'local-floor';
		// Set default foveation to maximum.
		let foveation = 1.0;
		let customReferenceSpace = null;

		let pose = null;
		let glBinding = null;
		let glProjLayer = null;
		let glBaseLayer = null;
		let xrFrame = null;

		const depthSensing = new WebXRDepthSensing();
		const attributes = gl.getContextAttributes();

		let initialRenderTarget = null;
		let newRenderTarget = null;

		const controllers = [];
		const controllerInputSources = [];

		const currentSize = new Vector2();
		let currentPixelRatio = null;

		//

		const cameraL = new PerspectiveCamera();
		cameraL.layers.enable( 1 );
		cameraL.viewport = new Vector4();

		const cameraR = new PerspectiveCamera();
		cameraR.layers.enable( 2 );
		cameraR.viewport = new Vector4();

		const cameras = [ cameraL, cameraR ];

		const cameraXR = new ArrayCamera();
		cameraXR.layers.enable( 1 );
		cameraXR.layers.enable( 2 );

		let _currentDepthNear = null;
		let _currentDepthFar = null;

		//

		this.cameraAutoUpdate = true;
		this.enabled = false;

		this.isPresenting = false;

		this.getController = function ( index ) {

			let controller = controllers[ index ];

			if ( controller === undefined ) {

				controller = new WebXRController();
				controllers[ index ] = controller;

			}

			return controller.getTargetRaySpace();

		};

		this.getControllerGrip = function ( index ) {

			let controller = controllers[ index ];

			if ( controller === undefined ) {

				controller = new WebXRController();
				controllers[ index ] = controller;

			}

			return controller.getGripSpace();

		};

		this.getHand = function ( index ) {

			let controller = controllers[ index ];

			if ( controller === undefined ) {

				controller = new WebXRController();
				controllers[ index ] = controller;

			}

			return controller.getHandSpace();

		};

		//

		function onSessionEvent( event ) {

			const controllerIndex = controllerInputSources.indexOf( event.inputSource );

			if ( controllerIndex === - 1 ) {

				return;

			}

			const controller = controllers[ controllerIndex ];

			if ( controller !== undefined ) {

				controller.update( event.inputSource, event.frame, customReferenceSpace || referenceSpace );
				controller.dispatchEvent( { type: event.type, data: event.inputSource } );

			}

		}

		function onSessionEnd() {

			session.removeEventListener( 'select', onSessionEvent );
			session.removeEventListener( 'selectstart', onSessionEvent );
			session.removeEventListener( 'selectend', onSessionEvent );
			session.removeEventListener( 'squeeze', onSessionEvent );
			session.removeEventListener( 'squeezestart', onSessionEvent );
			session.removeEventListener( 'squeezeend', onSessionEvent );
			session.removeEventListener( 'end', onSessionEnd );
			session.removeEventListener( 'inputsourceschange', onInputSourcesChange );

			for ( let i = 0; i < controllers.length; i ++ ) {

				const inputSource = controllerInputSources[ i ];

				if ( inputSource === null ) continue;

				controllerInputSources[ i ] = null;

				controllers[ i ].disconnect( inputSource );

			}

			_currentDepthNear = null;
			_currentDepthFar = null;

			depthSensing.reset();

			// restore framebuffer/rendering state

			renderer.setRenderTarget( initialRenderTarget );

			glBaseLayer = null;
			glProjLayer = null;
			glBinding = null;
			session = null;
			newRenderTarget = null;

			//

			animation.stop();

			scope.isPresenting = false;

			renderer.setPixelRatio( currentPixelRatio );
			renderer.setSize( currentSize.width, currentSize.height, false );

			scope.dispatchEvent( { type: 'sessionend' } );

		}

		this.setFramebufferScaleFactor = function ( value ) {

			framebufferScaleFactor = value;

			if ( scope.isPresenting === true ) {

				console.warn( 'THREE.WebXRManager: Cannot change framebuffer scale while presenting.' );

			}

		};

		this.setReferenceSpaceType = function ( value ) {

			referenceSpaceType = value;

			if ( scope.isPresenting === true ) {

				console.warn( 'THREE.WebXRManager: Cannot change reference space type while presenting.' );

			}

		};

		this.getReferenceSpace = function () {

			return customReferenceSpace || referenceSpace;

		};

		this.setReferenceSpace = function ( space ) {

			customReferenceSpace = space;

		};

		this.getBaseLayer = function () {

			return glProjLayer !== null ? glProjLayer : glBaseLayer;

		};

		this.getBinding = function () {

			return glBinding;

		};

		this.getFrame = function () {

			return xrFrame;

		};

		this.getSession = function () {

			return session;

		};

		this.setSession = async function ( value ) {

			session = value;

			if ( session !== null ) {

				initialRenderTarget = renderer.getRenderTarget();

				session.addEventListener( 'select', onSessionEvent );
				session.addEventListener( 'selectstart', onSessionEvent );
				session.addEventListener( 'selectend', onSessionEvent );
				session.addEventListener( 'squeeze', onSessionEvent );
				session.addEventListener( 'squeezestart', onSessionEvent );
				session.addEventListener( 'squeezeend', onSessionEvent );
				session.addEventListener( 'end', onSessionEnd );
				session.addEventListener( 'inputsourceschange', onInputSourcesChange );

				if ( attributes.xrCompatible !== true ) {

					await gl.makeXRCompatible();

				}

				currentPixelRatio = renderer.getPixelRatio();
				renderer.getSize( currentSize );

				if ( session.renderState.layers === undefined ) {

					const layerInit = {
						antialias: attributes.antialias,
						alpha: true,
						depth: attributes.depth,
						stencil: attributes.stencil,
						framebufferScaleFactor: framebufferScaleFactor
					};

					glBaseLayer = new XRWebGLLayer( session, gl, layerInit );

					session.updateRenderState( { baseLayer: glBaseLayer } );

					renderer.setPixelRatio( 1 );
					renderer.setSize( glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, false );

					newRenderTarget = new WebGLRenderTarget(
						glBaseLayer.framebufferWidth,
						glBaseLayer.framebufferHeight,
						{
							format: RGBAFormat,
							type: UnsignedByteType,
							colorSpace: renderer.outputColorSpace,
							stencilBuffer: attributes.stencil
						}
					);

				} else {

					let depthFormat = null;
					let depthType = null;
					let glDepthFormat = null;

					if ( attributes.depth ) {

						glDepthFormat = attributes.stencil ? gl.DEPTH24_STENCIL8 : gl.DEPTH_COMPONENT24;
						depthFormat = attributes.stencil ? DepthStencilFormat : DepthFormat;
						depthType = attributes.stencil ? UnsignedInt248Type : UnsignedIntType;

					}

					const projectionlayerInit = {
						colorFormat: gl.RGBA8,
						depthFormat: glDepthFormat,
						scaleFactor: framebufferScaleFactor
					};

					glBinding = new XRWebGLBinding( session, gl );

					glProjLayer = glBinding.createProjectionLayer( projectionlayerInit );

					session.updateRenderState( { layers: [ glProjLayer ] } );

					renderer.setPixelRatio( 1 );
					renderer.setSize( glProjLayer.textureWidth, glProjLayer.textureHeight, false );

					newRenderTarget = new WebGLRenderTarget(
						glProjLayer.textureWidth,
						glProjLayer.textureHeight,
						{
							format: RGBAFormat,
							type: UnsignedByteType,
							depthTexture: new DepthTexture( glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, undefined, undefined, undefined, undefined, undefined, undefined, depthFormat ),
							stencilBuffer: attributes.stencil,
							colorSpace: renderer.outputColorSpace,
							samples: attributes.antialias ? 4 : 0
						} );

					const renderTargetProperties = renderer.properties.get( newRenderTarget );
					renderTargetProperties.__ignoreDepthValues = glProjLayer.ignoreDepthValues;

				}

				newRenderTarget.isXRRenderTarget = true; // TODO Remove this when possible, see #23278

				this.setFoveation( foveation );

				customReferenceSpace = null;
				referenceSpace = await session.requestReferenceSpace( referenceSpaceType );

				animation.setContext( session );
				animation.start();

				scope.isPresenting = true;

				scope.dispatchEvent( { type: 'sessionstart' } );

			}

		};

		this.getEnvironmentBlendMode = function () {

			if ( session !== null ) {

				return session.environmentBlendMode;

			}

		};

		function onInputSourcesChange( event ) {

			// Notify disconnected

			for ( let i = 0; i < event.removed.length; i ++ ) {

				const inputSource = event.removed[ i ];
				const index = controllerInputSources.indexOf( inputSource );

				if ( index >= 0 ) {

					controllerInputSources[ index ] = null;
					controllers[ index ].disconnect( inputSource );

				}

			}

			// Notify connected

			for ( let i = 0; i < event.added.length; i ++ ) {

				const inputSource = event.added[ i ];

				let controllerIndex = controllerInputSources.indexOf( inputSource );

				if ( controllerIndex === - 1 ) {

					// Assign input source a controller that currently has no input source

					for ( let i = 0; i < controllers.length; i ++ ) {

						if ( i >= controllerInputSources.length ) {

							controllerInputSources.push( inputSource );
							controllerIndex = i;
							break;

						} else if ( controllerInputSources[ i ] === null ) {

							controllerInputSources[ i ] = inputSource;
							controllerIndex = i;
							break;

						}

					}

					// If all controllers do currently receive input we ignore new ones

					if ( controllerIndex === - 1 ) break;

				}

				const controller = controllers[ controllerIndex ];

				if ( controller ) {

					controller.connect( inputSource );

				}

			}

		}

		//

		const cameraLPos = new Vector3();
		const cameraRPos = new Vector3();

		/**
		 * Assumes 2 cameras that are parallel and share an X-axis, and that
		 * the cameras' projection and world matrices have already been set.
		 * And that near and far planes are identical for both cameras.
		 * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
		 */
		function setProjectionFromUnion( camera, cameraL, cameraR ) {

			cameraLPos.setFromMatrixPosition( cameraL.matrixWorld );
			cameraRPos.setFromMatrixPosition( cameraR.matrixWorld );

			const ipd = cameraLPos.distanceTo( cameraRPos );

			const projL = cameraL.projectionMatrix.elements;
			const projR = cameraR.projectionMatrix.elements;

			// VR systems will have identical far and near planes, and
			// most likely identical top and bottom frustum extents.
			// Use the left camera for these values.
			const near = projL[ 14 ] / ( projL[ 10 ] - 1 );
			const far = projL[ 14 ] / ( projL[ 10 ] + 1 );
			const topFov = ( projL[ 9 ] + 1 ) / projL[ 5 ];
			const bottomFov = ( projL[ 9 ] - 1 ) / projL[ 5 ];

			const leftFov = ( projL[ 8 ] - 1 ) / projL[ 0 ];
			const rightFov = ( projR[ 8 ] + 1 ) / projR[ 0 ];
			const left = near * leftFov;
			const right = near * rightFov;

			// Calculate the new camera's position offset from the
			// left camera. xOffset should be roughly half `ipd`.
			const zOffset = ipd / ( - leftFov + rightFov );
			const xOffset = zOffset * - leftFov;

			// TODO: Better way to apply this offset?
			cameraL.matrixWorld.decompose( camera.position, camera.quaternion, camera.scale );
			camera.translateX( xOffset );
			camera.translateZ( zOffset );
			camera.matrixWorld.compose( camera.position, camera.quaternion, camera.scale );
			camera.matrixWorldInverse.copy( camera.matrixWorld ).invert();

			// Find the union of the frustum values of the cameras and scale
			// the values so that the near plane's position does not change in world space,
			// although must now be relative to the new union camera.
			const near2 = near + zOffset;
			const far2 = far + zOffset;
			const left2 = left - xOffset;
			const right2 = right + ( ipd - xOffset );
			const top2 = topFov * far / far2 * near2;
			const bottom2 = bottomFov * far / far2 * near2;

			camera.projectionMatrix.makePerspective( left2, right2, top2, bottom2, near2, far2 );
			camera.projectionMatrixInverse.copy( camera.projectionMatrix ).invert();

		}

		function updateCamera( camera, parent ) {

			if ( parent === null ) {

				camera.matrixWorld.copy( camera.matrix );

			} else {

				camera.matrixWorld.multiplyMatrices( parent.matrixWorld, camera.matrix );

			}

			camera.matrixWorldInverse.copy( camera.matrixWorld ).invert();

		}

		this.updateCamera = function ( camera ) {

			if ( session === null ) return;

			if ( depthSensing.texture !== null ) {

				camera.near = depthSensing.depthNear;
				camera.far = depthSensing.depthFar;

			}

			cameraXR.near = cameraR.near = cameraL.near = camera.near;
			cameraXR.far = cameraR.far = cameraL.far = camera.far;

			if ( _currentDepthNear !== cameraXR.near || _currentDepthFar !== cameraXR.far ) {

				// Note that the new renderState won't apply until the next frame. See #18320

				session.updateRenderState( {
					depthNear: cameraXR.near,
					depthFar: cameraXR.far
				} );

				_currentDepthNear = cameraXR.near;
				_currentDepthFar = cameraXR.far;

				cameraL.near = _currentDepthNear;
				cameraL.far = _currentDepthFar;
				cameraR.near = _currentDepthNear;
				cameraR.far = _currentDepthFar;

				cameraL.updateProjectionMatrix();
				cameraR.updateProjectionMatrix();
				camera.updateProjectionMatrix();

			}

			const parent = camera.parent;
			const cameras = cameraXR.cameras;

			updateCamera( cameraXR, parent );

			for ( let i = 0; i < cameras.length; i ++ ) {

				updateCamera( cameras[ i ], parent );

			}

			// update projection matrix for proper view frustum culling

			if ( cameras.length === 2 ) {

				setProjectionFromUnion( cameraXR, cameraL, cameraR );

			} else {

				// assume single camera setup (AR)

				cameraXR.projectionMatrix.copy( cameraL.projectionMatrix );

			}

			// update user camera and its children

			updateUserCamera( camera, cameraXR, parent );

		};

		function updateUserCamera( camera, cameraXR, parent ) {

			if ( parent === null ) {

				camera.matrix.copy( cameraXR.matrixWorld );

			} else {

				camera.matrix.copy( parent.matrixWorld );
				camera.matrix.invert();
				camera.matrix.multiply( cameraXR.matrixWorld );

			}

			camera.matrix.decompose( camera.position, camera.quaternion, camera.scale );
			camera.updateMatrixWorld( true );

			camera.projectionMatrix.copy( cameraXR.projectionMatrix );
			camera.projectionMatrixInverse.copy( cameraXR.projectionMatrixInverse );

			if ( camera.isPerspectiveCamera ) {

				camera.fov = RAD2DEG * 2 * Math.atan( 1 / camera.projectionMatrix.elements[ 5 ] );
				camera.zoom = 1;

			}

		}

		this.getCamera = function () {

			return cameraXR;

		};

		this.getFoveation = function () {

			if ( glProjLayer === null && glBaseLayer === null ) {

				return undefined;

			}

			return foveation;

		};

		this.setFoveation = function ( value ) {

			// 0 = no foveation = full resolution
			// 1 = maximum foveation = the edges render at lower resolution

			foveation = value;

			if ( glProjLayer !== null ) {

				glProjLayer.fixedFoveation = value;

			}

			if ( glBaseLayer !== null && glBaseLayer.fixedFoveation !== undefined ) {

				glBaseLayer.fixedFoveation = value;

			}

		};

		this.hasDepthSensing = function () {

			return depthSensing.texture !== null;

		};

		// Animation Loop

		let onAnimationFrameCallback = null;

		function onAnimationFrame( time, frame ) {

			pose = frame.getViewerPose( customReferenceSpace || referenceSpace );
			xrFrame = frame;

			if ( pose !== null ) {

				const views = pose.views;

				if ( glBaseLayer !== null ) {

					renderer.setRenderTargetFramebuffer( newRenderTarget, glBaseLayer.framebuffer );
					renderer.setRenderTarget( newRenderTarget );

				}

				let cameraXRNeedsUpdate = false;

				// check if it's necessary to rebuild cameraXR's camera list

				if ( views.length !== cameraXR.cameras.length ) {

					cameraXR.cameras.length = 0;
					cameraXRNeedsUpdate = true;

				}

				for ( let i = 0; i < views.length; i ++ ) {

					const view = views[ i ];

					let viewport = null;

					if ( glBaseLayer !== null ) {

						viewport = glBaseLayer.getViewport( view );

					} else {

						const glSubImage = glBinding.getViewSubImage( glProjLayer, view );
						viewport = glSubImage.viewport;

						// For side-by-side projection, we only produce a single texture for both eyes.
						if ( i === 0 ) {

							renderer.setRenderTargetTextures(
								newRenderTarget,
								glSubImage.colorTexture,
								glProjLayer.ignoreDepthValues ? undefined : glSubImage.depthStencilTexture );

							renderer.setRenderTarget( newRenderTarget );

						}

					}

					let camera = cameras[ i ];

					if ( camera === undefined ) {

						camera = new PerspectiveCamera();
						camera.layers.enable( i );
						camera.viewport = new Vector4();
						cameras[ i ] = camera;

					}

					camera.matrix.fromArray( view.transform.matrix );
					camera.matrix.decompose( camera.position, camera.quaternion, camera.scale );
					camera.projectionMatrix.fromArray( view.projectionMatrix );
					camera.projectionMatrixInverse.copy( camera.projectionMatrix ).invert();
					camera.viewport.set( viewport.x, viewport.y, viewport.width, viewport.height );

					if ( i === 0 ) {

						cameraXR.matrix.copy( camera.matrix );
						cameraXR.matrix.decompose( cameraXR.position, cameraXR.quaternion, cameraXR.scale );

					}

					if ( cameraXRNeedsUpdate === true ) {

						cameraXR.cameras.push( camera );

					}

				}

				//

				const enabledFeatures = session.enabledFeatures;

				if ( enabledFeatures && enabledFeatures.includes( 'depth-sensing' ) ) {

					const depthData = glBinding.getDepthInformation( views[ 0 ] );

					if ( depthData && depthData.isValid && depthData.texture ) {

						depthSensing.init( renderer, depthData, session.renderState );

					}

				}

			}

			//

			for ( let i = 0; i < controllers.length; i ++ ) {

				const inputSource = controllerInputSources[ i ];
				const controller = controllers[ i ];

				if ( inputSource !== null && controller !== undefined ) {

					controller.update( inputSource, frame, customReferenceSpace || referenceSpace );

				}

			}

			depthSensing.render( renderer, cameraXR );

			if ( onAnimationFrameCallback ) onAnimationFrameCallback( time, frame );

			if ( frame.detectedPlanes ) {

				scope.dispatchEvent( { type: 'planesdetected', data: frame } );

			}

			xrFrame = null;

		}

		const animation = new WebGLAnimation();

		animation.setAnimationLoop( onAnimationFrame );

		this.setAnimationLoop = function ( callback ) {

			onAnimationFrameCallback = callback;

		};

		this.dispose = function () {};

	}

}

const _e1 = /*@__PURE__*/ new Euler();
const _m1 = /*@__PURE__*/ new Matrix4();

function WebGLMaterials( renderer, properties ) {

	function refreshTransformUniform( map, uniform ) {

		if ( map.matrixAutoUpdate === true ) {

			map.updateMatrix();

		}

		uniform.value.copy( map.matrix );

	}

	function refreshFogUniforms( uniforms, fog ) {

		fog.color.getRGB( uniforms.fogColor.value, getUnlitUniformColorSpace( renderer ) );

		if ( fog.isFog ) {

			uniforms.fogNear.value = fog.near;
			uniforms.fogFar.value = fog.far;

		} else if ( fog.isFogExp2 ) {

			uniforms.fogDensity.value = fog.density;

		}

	}

	function refreshMaterialUniforms( uniforms, material, pixelRatio, height, transmissionRenderTarget ) {

		if ( material.isMeshBasicMaterial ) {

			refreshUniformsCommon( uniforms, material );

		} else if ( material.isMeshLambertMaterial ) {

			refreshUniformsCommon( uniforms, material );

		} else if ( material.isMeshToonMaterial ) {

			refreshUniformsCommon( uniforms, material );
			refreshUniformsToon( uniforms, material );

		} else if ( material.isMeshPhongMaterial ) {

			refreshUniformsCommon( uniforms, material );
			refreshUniformsPhong( uniforms, material );

		} else if ( material.isMeshStandardMaterial ) {

			refreshUniformsCommon( uniforms, material );
			refreshUniformsStandard( uniforms, material );

			if ( material.isMeshPhysicalMaterial ) {

				refreshUniformsPhysical( uniforms, material, transmissionRenderTarget );

			}

		} else if ( material.isMeshMatcapMaterial ) {

			refreshUniformsCommon( uniforms, material );
			refreshUniformsMatcap( uniforms, material );

		} else if ( material.isMeshDepthMaterial ) {

			refreshUniformsCommon( uniforms, material );

		} else if ( material.isMeshDistanceMaterial ) {

			refreshUniformsCommon( uniforms, material );
			refreshUniformsDistance( uniforms, material );

		} else if ( material.isMeshNormalMaterial ) {

			refreshUniformsCommon( uniforms, material );

		} else if ( material.isLineBasicMaterial ) {

			refreshUniformsLine( uniforms, material );

			if ( material.isLineDashedMaterial ) {

				refreshUniformsDash( uniforms, material );

			}

		} else if ( material.isPointsMaterial ) {

			refreshUniformsPoints( uniforms, material, pixelRatio, height );

		} else if ( material.isSpriteMaterial ) {

			refreshUniformsSprites( uniforms, material );

		} else if ( material.isShadowMaterial ) {

			uniforms.color.value.copy( material.color );
			uniforms.opacity.value = material.opacity;

		} else if ( material.isShaderMaterial ) {

			material.uniformsNeedUpdate = false; // #15581

		}

	}

	function refreshUniformsCommon( uniforms, material ) {

		uniforms.opacity.value = material.opacity;

		if ( material.color ) {

			uniforms.diffuse.value.copy( material.color );

		}

		if ( material.emissive ) {

			uniforms.emissive.value.copy( material.emissive ).multiplyScalar( material.emissiveIntensity );

		}

		if ( material.map ) {

			uniforms.map.value = material.map;

			refreshTransformUniform( material.map, uniforms.mapTransform );

		}

		if ( material.alphaMap ) {

			uniforms.alphaMap.value = material.alphaMap;

			refreshTransformUniform( material.alphaMap, uniforms.alphaMapTransform );

		}

		if ( material.bumpMap ) {

			uniforms.bumpMap.value = material.bumpMap;

			refreshTransformUniform( material.bumpMap, uniforms.bumpMapTransform );

			uniforms.bumpScale.value = material.bumpScale;

			if ( material.side === BackSide ) {

				uniforms.bumpScale.value *= - 1;

			}

		}

		if ( material.normalMap ) {

			uniforms.normalMap.value = material.normalMap;

			refreshTransformUniform( material.normalMap, uniforms.normalMapTransform );

			uniforms.normalScale.value.copy( material.normalScale );

			if ( material.side === BackSide ) {

				uniforms.normalScale.value.negate();

			}

		}

		if ( material.displacementMap ) {

			uniforms.displacementMap.value = material.displacementMap;

			refreshTransformUniform( material.displacementMap, uniforms.displacementMapTransform );

			uniforms.displacementScale.value = material.displacementScale;
			uniforms.displacementBias.value = material.displacementBias;

		}

		if ( material.emissiveMap ) {

			uniforms.emissiveMap.value = material.emissiveMap;

			refreshTransformUniform( material.emissiveMap, uniforms.emissiveMapTransform );

		}

		if ( material.specularMap ) {

			uniforms.specularMap.value = material.specularMap;

			refreshTransformUniform( material.specularMap, uniforms.specularMapTransform );

		}

		if ( material.alphaTest > 0 ) {

			uniforms.alphaTest.value = material.alphaTest;

		}

		const materialProperties = properties.get( material );

		const envMap = materialProperties.envMap;
		const envMapRotation = materialProperties.envMapRotation;

		if ( envMap ) {

			uniforms.envMap.value = envMap;

			_e1.copy( envMapRotation );

			// accommodate left-handed frame
			_e1.x *= - 1; _e1.y *= - 1; _e1.z *= - 1;

			if ( envMap.isCubeTexture && envMap.isRenderTargetTexture === false ) {

				// environment maps which are not cube render targets or PMREMs follow a different convention
				_e1.y *= - 1;
				_e1.z *= - 1;

			}

			uniforms.envMapRotation.value.setFromMatrix4( _m1.makeRotationFromEuler( _e1 ) );

			uniforms.flipEnvMap.value = ( envMap.isCubeTexture && envMap.isRenderTargetTexture === false ) ? - 1 : 1;

			uniforms.reflectivity.value = material.reflectivity;
			uniforms.ior.value = material.ior;
			uniforms.refractionRatio.value = material.refractionRatio;

		}

		if ( material.lightMap ) {

			uniforms.lightMap.value = material.lightMap;

			// artist-friendly light intensity scaling factor
			const scaleFactor = ( renderer._useLegacyLights === true ) ? Math.PI : 1;

			uniforms.lightMapIntensity.value = material.lightMapIntensity * scaleFactor;

			refreshTransformUniform( material.lightMap, uniforms.lightMapTransform );

		}

		if ( material.aoMap ) {

			uniforms.aoMap.value = material.aoMap;
			uniforms.aoMapIntensity.value = material.aoMapIntensity;

			refreshTransformUniform( material.aoMap, uniforms.aoMapTransform );

		}

	}

	function refreshUniformsLine( uniforms, material ) {

		uniforms.diffuse.value.copy( material.color );
		uniforms.opacity.value = material.opacity;

		if ( material.map ) {

			uniforms.map.value = material.map;

			refreshTransformUniform( material.map, uniforms.mapTransform );

		}

	}

	function refreshUniformsDash( uniforms, material ) {

		uniforms.dashSize.value = material.dashSize;
		uniforms.totalSize.value = material.dashSize + material.gapSize;
		uniforms.scale.value = material.scale;

	}

	function refreshUniformsPoints( uniforms, material, pixelRatio, height ) {

		uniforms.diffuse.value.copy( material.color );
		uniforms.opacity.value = material.opacity;
		uniforms.size.value = material.size * pixelRatio;
		uniforms.scale.value = height * 0.5;

		if ( material.map ) {

			uniforms.map.value = material.map;

			refreshTransformUniform( material.map, uniforms.uvTransform );

		}

		if ( material.alphaMap ) {

			uniforms.alphaMap.value = material.alphaMap;

			refreshTransformUniform( material.alphaMap, uniforms.alphaMapTransform );

		}

		if ( material.alphaTest > 0 ) {

			uniforms.alphaTest.value = material.alphaTest;

		}

	}

	function refreshUniformsSprites( uniforms, material ) {

		uniforms.diffuse.value.copy( material.color );
		uniforms.opacity.value = material.opacity;
		uniforms.rotation.value = material.rotation;

		if ( material.map ) {

			uniforms.map.value = material.map;

			refreshTransformUniform( material.map, uniforms.mapTransform );

		}

		if ( material.alphaMap ) {

			uniforms.alphaMap.value = material.alphaMap;

			refreshTransformUniform( material.alphaMap, uniforms.alphaMapTransform );

		}

		if ( material.alphaTest > 0 ) {

			uniforms.alphaTest.value = material.alphaTest;

		}

	}

	function refreshUniformsPhong( uniforms, material ) {

		uniforms.specular.value.copy( material.specular );
		uniforms.shininess.value = Math.max( material.shininess, 1e-4 ); // to prevent pow( 0.0, 0.0 )

	}

	function refreshUniformsToon( uniforms, material ) {

		if ( material.gradientMap ) {

			uniforms.gradientMap.value = material.gradientMap;

		}

	}

	function refreshUniformsStandard( uniforms, material ) {

		uniforms.metalness.value = material.metalness;

		if ( material.metalnessMap ) {

			uniforms.metalnessMap.value = material.metalnessMap;

			refreshTransformUniform( material.metalnessMap, uniforms.metalnessMapTransform );

		}

		uniforms.roughness.value = material.roughness;

		if ( material.roughnessMap ) {

			uniforms.roughnessMap.value = material.roughnessMap;

			refreshTransformUniform( material.roughnessMap, uniforms.roughnessMapTransform );

		}

		if ( material.envMap ) {

			//uniforms.envMap.value = material.envMap; // part of uniforms common

			uniforms.envMapIntensity.value = material.envMapIntensity;

		}

	}

	function refreshUniformsPhysical( uniforms, material, transmissionRenderTarget ) {

		uniforms.ior.value = material.ior; // also part of uniforms common

		if ( material.sheen > 0 ) {

			uniforms.sheenColor.value.copy( material.sheenColor ).multiplyScalar( material.sheen );

			uniforms.sheenRoughness.value = material.sheenRoughness;

			if ( material.sheenColorMap ) {

				uniforms.sheenColorMap.value = material.sheenColorMap;

				refreshTransformUniform( material.sheenColorMap, uniforms.sheenColorMapTransform );

			}

			if ( material.sheenRoughnessMap ) {

				uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;

				refreshTransformUniform( material.sheenRoughnessMap, uniforms.sheenRoughnessMapTransform );

			}

		}

		if ( material.clearcoat > 0 ) {

			uniforms.clearcoat.value = material.clearcoat;
			uniforms.clearcoatRoughness.value = material.clearcoatRoughness;

			if ( material.clearcoatMap ) {

				uniforms.clearcoatMap.value = material.clearcoatMap;

				refreshTransformUniform( material.clearcoatMap, uniforms.clearcoatMapTransform );

			}

			if ( material.clearcoatRoughnessMap ) {

				uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;

				refreshTransformUniform( material.clearcoatRoughnessMap, uniforms.clearcoatRoughnessMapTransform );

			}

			if ( material.clearcoatNormalMap ) {

				uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;

				refreshTransformUniform( material.clearcoatNormalMap, uniforms.clearcoatNormalMapTransform );

				uniforms.clearcoatNormalScale.value.copy( material.clearcoatNormalScale );

				if ( material.side === BackSide ) {

					uniforms.clearcoatNormalScale.value.negate();

				}

			}

		}

		if ( material.iridescence > 0 ) {

			uniforms.iridescence.value = material.iridescence;
			uniforms.iridescenceIOR.value = material.iridescenceIOR;
			uniforms.iridescenceThicknessMinimum.value = material.iridescenceThicknessRange[ 0 ];
			uniforms.iridescenceThicknessMaximum.value = material.iridescenceThicknessRange[ 1 ];

			if ( material.iridescenceMap ) {

				uniforms.iridescenceMap.value = material.iridescenceMap;

				refreshTransformUniform( material.iridescenceMap, uniforms.iridescenceMapTransform );

			}

			if ( material.iridescenceThicknessMap ) {

				uniforms.iridescenceThicknessMap.value = material.iridescenceThicknessMap;

				refreshTransformUniform( material.iridescenceThicknessMap, uniforms.iridescenceThicknessMapTransform );

			}

		}

		if ( material.transmission > 0 ) {

			uniforms.transmission.value = material.transmission;
			uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
			uniforms.transmissionSamplerSize.value.set( transmissionRenderTarget.width, transmissionRenderTarget.height );

			if ( material.transmissionMap ) {

				uniforms.transmissionMap.value = material.transmissionMap;

				refreshTransformUniform( material.transmissionMap, uniforms.transmissionMapTransform );

			}

			uniforms.thickness.value = material.thickness;

			if ( material.thicknessMap ) {

				uniforms.thicknessMap.value = material.thicknessMap;

				refreshTransformUniform( material.thicknessMap, uniforms.thicknessMapTransform );

			}

			uniforms.attenuationDistance.value = material.attenuationDistance;
			uniforms.attenuationColor.value.copy( material.attenuationColor );

		}

		if ( material.anisotropy > 0 ) {

			uniforms.anisotropyVector.value.set( material.anisotropy * Math.cos( material.anisotropyRotation ), material.anisotropy * Math.sin( material.anisotropyRotation ) );

			if ( material.anisotropyMap ) {

				uniforms.anisotropyMap.value = material.anisotropyMap;

				refreshTransformUniform( material.anisotropyMap, uniforms.anisotropyMapTransform );

			}

		}

		uniforms.specularIntensity.value = material.specularIntensity;
		uniforms.specularColor.value.copy( material.specularColor );

		if ( material.specularColorMap ) {

			uniforms.specularColorMap.value = material.specularColorMap;

			refreshTransformUniform( material.specularColorMap, uniforms.specularColorMapTransform );

		}

		if ( material.specularIntensityMap ) {

			uniforms.specularIntensityMap.value = material.specularIntensityMap;

			refreshTransformUniform( material.specularIntensityMap, uniforms.specularIntensityMapTransform );

		}

	}

	function refreshUniformsMatcap( uniforms, material ) {

		if ( material.matcap ) {

			uniforms.matcap.value = material.matcap;

		}

	}

	function refreshUniformsDistance( uniforms, material ) {

		const light = properties.get( material ).light;

		uniforms.referencePosition.value.setFromMatrixPosition( light.matrixWorld );
		uniforms.nearDistance.value = light.shadow.camera.near;
		uniforms.farDistance.value = light.shadow.camera.far;

	}

	return {
		refreshFogUniforms: refreshFogUniforms,
		refreshMaterialUniforms: refreshMaterialUniforms
	};

}

function WebGLUniformsGroups( gl, info, capabilities, state ) {

	let buffers = {};
	let updateList = {};
	let allocatedBindingPoints = [];

	const maxBindingPoints = gl.getParameter( gl.MAX_UNIFORM_BUFFER_BINDINGS ); // binding points are global whereas block indices are per shader program

	function bind( uniformsGroup, program ) {

		const webglProgram = program.program;
		state.uniformBlockBinding( uniformsGroup, webglProgram );

	}

	function update( uniformsGroup, program ) {

		let buffer = buffers[ uniformsGroup.id ];

		if ( buffer === undefined ) {

			prepareUniformsGroup( uniformsGroup );

			buffer = createBuffer( uniformsGroup );
			buffers[ uniformsGroup.id ] = buffer;

			uniformsGroup.addEventListener( 'dispose', onUniformsGroupsDispose );

		}

		// ensure to update the binding points/block indices mapping for this program

		const webglProgram = program.program;
		state.updateUBOMapping( uniformsGroup, webglProgram );

		// update UBO once per frame

		const frame = info.render.frame;

		if ( updateList[ uniformsGroup.id ] !== frame ) {

			updateBufferData( uniformsGroup );

			updateList[ uniformsGroup.id ] = frame;

		}

	}

	function createBuffer( uniformsGroup ) {

		// the setup of an UBO is independent of a particular shader program but global

		const bindingPointIndex = allocateBindingPointIndex();
		uniformsGroup.__bindingPointIndex = bindingPointIndex;

		const buffer = gl.createBuffer();
		const size = uniformsGroup.__size;
		const usage = uniformsGroup.usage;

		gl.bindBuffer( gl.UNIFORM_BUFFER, buffer );
		gl.bufferData( gl.UNIFORM_BUFFER, size, usage );
		gl.bindBuffer( gl.UNIFORM_BUFFER, null );
		gl.bindBufferBase( gl.UNIFORM_BUFFER, bindingPointIndex, buffer );

		return buffer;

	}

	function allocateBindingPointIndex() {

		for ( let i = 0; i < maxBindingPoints; i ++ ) {

			if ( allocatedBindingPoints.indexOf( i ) === - 1 ) {

				allocatedBindingPoints.push( i );
				return i;

			}

		}

		console.error( 'THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached.' );

		return 0;

	}

	function updateBufferData( uniformsGroup ) {

		const buffer = buffers[ uniformsGroup.id ];
		const uniforms = uniformsGroup.uniforms;
		const cache = uniformsGroup.__cache;

		gl.bindBuffer( gl.UNIFORM_BUFFER, buffer );

		for ( let i = 0, il = uniforms.length; i < il; i ++ ) {

			const uniformArray = Array.isArray( uniforms[ i ] ) ? uniforms[ i ] : [ uniforms[ i ] ];

			for ( let j = 0, jl = uniformArray.length; j < jl; j ++ ) {

				const uniform = uniformArray[ j ];

				if ( hasUniformChanged( uniform, i, j, cache ) === true ) {

					const offset = uniform.__offset;

					const values = Array.isArray( uniform.value ) ? uniform.value : [ uniform.value ];

					let arrayOffset = 0;

					for ( let k = 0; k < values.length; k ++ ) {

						const value = values[ k ];

						const info = getUniformSize( value );

						// TODO add integer and struct support
						if ( typeof value === 'number' || typeof value === 'boolean' ) {

							uniform.__data[ 0 ] = value;
							gl.bufferSubData( gl.UNIFORM_BUFFER, offset + arrayOffset, uniform.__data );

						} else if ( value.isMatrix3 ) {

							// manually converting 3x3 to 3x4

							uniform.__data[ 0 ] = value.elements[ 0 ];
							uniform.__data[ 1 ] = value.elements[ 1 ];
							uniform.__data[ 2 ] = value.elements[ 2 ];
							uniform.__data[ 3 ] = 0;
							uniform.__data[ 4 ] = value.elements[ 3 ];
							uniform.__data[ 5 ] = value.elements[ 4 ];
							uniform.__data[ 6 ] = value.elements[ 5 ];
							uniform.__data[ 7 ] = 0;
							uniform.__data[ 8 ] = value.elements[ 6 ];
							uniform.__data[ 9 ] = value.elements[ 7 ];
							uniform.__data[ 10 ] = value.elements[ 8 ];
							uniform.__data[ 11 ] = 0;

						} else {

							value.toArray( uniform.__data, arrayOffset );

							arrayOffset += info.storage / Float32Array.BYTES_PER_ELEMENT;

						}

					}

					gl.bufferSubData( gl.UNIFORM_BUFFER, offset, uniform.__data );

				}

			}

		}

		gl.bindBuffer( gl.UNIFORM_BUFFER, null );

	}

	function hasUniformChanged( uniform, index, indexArray, cache ) {

		const value = uniform.value;
		const indexString = index + '_' + indexArray;

		if ( cache[ indexString ] === undefined ) {

			// cache entry does not exist so far

			if ( typeof value === 'number' || typeof value === 'boolean' ) {

				cache[ indexString ] = value;

			} else {

				cache[ indexString ] = value.clone();

			}

			return true;

		} else {

			const cachedObject = cache[ indexString ];

			// compare current value with cached entry

			if ( typeof value === 'number' || typeof value === 'boolean' ) {

				if ( cachedObject !== value ) {

					cache[ indexString ] = value;
					return true;

				}

			} else {

				if ( cachedObject.equals( value ) === false ) {

					cachedObject.copy( value );
					return true;

				}

			}

		}

		return false;

	}

	function prepareUniformsGroup( uniformsGroup ) {

		// determine total buffer size according to the STD140 layout
		// Hint: STD140 is the only supported layout in WebGL 2

		const uniforms = uniformsGroup.uniforms;

		let offset = 0; // global buffer offset in bytes
		const chunkSize = 16; // size of a chunk in bytes

		for ( let i = 0, l = uniforms.length; i < l; i ++ ) {

			const uniformArray = Array.isArray( uniforms[ i ] ) ? uniforms[ i ] : [ uniforms[ i ] ];

			for ( let j = 0, jl = uniformArray.length; j < jl; j ++ ) {

				const uniform = uniformArray[ j ];

				const values = Array.isArray( uniform.value ) ? uniform.value : [ uniform.value ];

				for ( let k = 0, kl = values.length; k < kl; k ++ ) {

					const value = values[ k ];

					const info = getUniformSize( value );

					// Calculate the chunk offset
					const chunkOffsetUniform = offset % chunkSize;

					// Check for chunk overflow
					if ( chunkOffsetUniform !== 0 && ( chunkSize - chunkOffsetUniform ) < info.boundary ) {

						// Add padding and adjust offset
						offset += ( chunkSize - chunkOffsetUniform );

					}

					// the following two properties will be used for partial buffer updates

					uniform.__data = new Float32Array( info.storage / Float32Array.BYTES_PER_ELEMENT );
					uniform.__offset = offset;


					// Update the global offset
					offset += info.storage;


				}

			}

		}

		// ensure correct final padding

		const chunkOffset = offset % chunkSize;

		if ( chunkOffset > 0 ) offset += ( chunkSize - chunkOffset );

		//

		uniformsGroup.__size = offset;
		uniformsGroup.__cache = {};

		return this;

	}

	function getUniformSize( value ) {

		const info = {
			boundary: 0, // bytes
			storage: 0 // bytes
		};

		// determine sizes according to STD140

		if ( typeof value === 'number' || typeof value === 'boolean' ) {

			// float/int/bool

			info.boundary = 4;
			info.storage = 4;

		} else if ( value.isVector2 ) {

			// vec2

			info.boundary = 8;
			info.storage = 8;

		} else if ( value.isVector3 || value.isColor ) {

			// vec3

			info.boundary = 16;
			info.storage = 12; // evil: vec3 must start on a 16-byte boundary but it only consumes 12 bytes

		} else if ( value.isVector4 ) {

			// vec4

			info.boundary = 16;
			info.storage = 16;

		} else if ( value.isMatrix3 ) {

			// mat3 (in STD140 a 3x3 matrix is represented as 3x4)

			info.boundary = 48;
			info.storage = 48;

		} else if ( value.isMatrix4 ) {

			// mat4

			info.boundary = 64;
			info.storage = 64;

		} else if ( value.isTexture ) {

			console.warn( 'THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.' );

		} else {

			console.warn( 'THREE.WebGLRenderer: Unsupported uniform value type.', value );

		}

		return info;

	}

	function onUniformsGroupsDispose( event ) {

		const uniformsGroup = event.target;

		uniformsGroup.removeEventListener( 'dispose', onUniformsGroupsDispose );

		const index = allocatedBindingPoints.indexOf( uniformsGroup.__bindingPointIndex );
		allocatedBindingPoints.splice( index, 1 );

		gl.deleteBuffer( buffers[ uniformsGroup.id ] );

		delete buffers[ uniformsGroup.id ];
		delete updateList[ uniformsGroup.id ];

	}

	function dispose() {

		for ( const id in buffers ) {

			gl.deleteBuffer( buffers[ id ] );

		}

		allocatedBindingPoints = [];
		buffers = {};
		updateList = {};

	}

	return {

		bind: bind,
		update: update,

		dispose: dispose

	};

}

class WebGLRenderer {

	constructor( parameters = {} ) {

		const {
			canvas = createCanvasElement(),
			context = null,
			depth = true,
			stencil = false,
			alpha = false,
			antialias = false,
			premultipliedAlpha = true,
			preserveDrawingBuffer = false,
			powerPreference = 'default',
			failIfMajorPerformanceCaveat = false,
		} = parameters;

		this.isWebGLRenderer = true;

		let _alpha;

		if ( context !== null ) {

			if ( typeof WebGLRenderingContext !== 'undefined' && context instanceof WebGLRenderingContext ) {

				throw new Error( 'THREE.WebGLRenderer: WebGL 1 is not supported since r163.' );

			}

			_alpha = context.getContextAttributes().alpha;

		} else {

			_alpha = alpha;

		}

		const uintClearColor = new Uint32Array( 4 );
		const intClearColor = new Int32Array( 4 );

		let currentRenderList = null;
		let currentRenderState = null;

		// render() can be called from within a callback triggered by another render.
		// We track this so that the nested render call gets its list and state isolated from the parent render call.

		const renderListStack = [];
		const renderStateStack = [];

		// public properties

		this.domElement = canvas;

		// Debug configuration container
		this.debug = {

			/**
			 * Enables error checking and reporting when shader programs are being compiled
			 * @type {boolean}
			 */
			checkShaderErrors: true,
			/**
			 * Callback for custom error reporting.
			 * @type {?Function}
			 */
			onShaderError: null
		};

		// clearing

		this.autoClear = true;
		this.autoClearColor = true;
		this.autoClearDepth = true;
		this.autoClearStencil = true;

		// scene graph

		this.sortObjects = true;

		// user-defined clipping

		this.clippingPlanes = [];
		this.localClippingEnabled = false;

		// physically based shading

		this._outputColorSpace = SRGBColorSpace;

		// physical lights

		this._useLegacyLights = false;

		// tone mapping

		this.toneMapping = NoToneMapping;
		this.toneMappingExposure = 1.0;

		// internal properties

		const _this = this;

		let _isContextLost = false;

		// internal state cache

		let _currentActiveCubeFace = 0;
		let _currentActiveMipmapLevel = 0;
		let _currentRenderTarget = null;
		let _currentMaterialId = - 1;

		let _currentCamera = null;

		const _currentViewport = new Vector4();
		const _currentScissor = new Vector4();
		let _currentScissorTest = null;

		const _currentClearColor = new Color( 0x000000 );
		let _currentClearAlpha = 0;

		//

		let _width = canvas.width;
		let _height = canvas.height;

		let _pixelRatio = 1;
		let _opaqueSort = null;
		let _transparentSort = null;

		const _viewport = new Vector4( 0, 0, _width, _height );
		const _scissor = new Vector4( 0, 0, _width, _height );
		let _scissorTest = false;

		// frustum

		const _frustum = new Frustum();

		// clipping

		let _clippingEnabled = false;
		let _localClippingEnabled = false;

		// camera matrices cache

		const _projScreenMatrix = new Matrix4();

		const _vector2 = new Vector2();
		const _vector3 = new Vector3();

		const _emptyScene = { background: null, fog: null, environment: null, overrideMaterial: null, isScene: true };

		function getTargetPixelRatio() {

			return _currentRenderTarget === null ? _pixelRatio : 1;

		}

		// initialize

		let _gl = context;

		function getContext( contextName, contextAttributes ) {

			const context = canvas.getContext( contextName, contextAttributes );
			if ( context !== null ) return context;

			return null;

		}

		try {

			const contextAttributes = {
				alpha: true,
				depth,
				stencil,
				antialias,
				premultipliedAlpha,
				preserveDrawingBuffer,
				powerPreference,
				failIfMajorPerformanceCaveat,
			};

			// OffscreenCanvas does not have setAttribute, see #22811
			if ( 'setAttribute' in canvas ) canvas.setAttribute( 'data-engine', `three.js r${REVISION}` );

			// event listeners must be registered before WebGL context is created, see #12753
			canvas.addEventListener( 'webglcontextlost', onContextLost, false );
			canvas.addEventListener( 'webglcontextrestored', onContextRestore, false );
			canvas.addEventListener( 'webglcontextcreationerror', onContextCreationError, false );

			if ( _gl === null ) {

				const contextName = 'webgl2';

				_gl = getContext( contextName, contextAttributes );

				if ( _gl === null ) {

					if ( getContext( contextName ) ) {

						throw new Error( 'Error creating WebGL context with your selected attributes.' );

					} else {

						throw new Error( 'Error creating WebGL context.' );

					}

				}

			}

		} catch ( error ) {

			console.error( 'THREE.WebGLRenderer: ' + error.message );
			throw error;

		}

		let extensions, capabilities, state, info;
		let properties, textures, cubemaps, cubeuvmaps, attributes, geometries, objects;
		let programCache, materials, renderLists, renderStates, clipping, shadowMap;

		let background, morphtargets, bufferRenderer, indexedBufferRenderer;

		let utils, bindingStates, uniformsGroups;

		function initGLContext() {

			extensions = new WebGLExtensions( _gl );
			extensions.init();

			capabilities = new WebGLCapabilities( _gl, extensions, parameters );

			utils = new WebGLUtils( _gl, extensions );

			state = new WebGLState( _gl );

			info = new WebGLInfo( _gl );
			properties = new WebGLProperties();
			textures = new WebGLTextures( _gl, extensions, state, properties, capabilities, utils, info );
			cubemaps = new WebGLCubeMaps( _this );
			cubeuvmaps = new WebGLCubeUVMaps( _this );
			attributes = new WebGLAttributes( _gl );
			bindingStates = new WebGLBindingStates( _gl, attributes );
			geometries = new WebGLGeometries( _gl, attributes, info, bindingStates );
			objects = new WebGLObjects( _gl, geometries, attributes, info );
			morphtargets = new WebGLMorphtargets( _gl, capabilities, textures );
			clipping = new WebGLClipping( properties );
			programCache = new WebGLPrograms( _this, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping );
			materials = new WebGLMaterials( _this, properties );
			renderLists = new WebGLRenderLists();
			renderStates = new WebGLRenderStates( extensions );
			background = new WebGLBackground( _this, cubemaps, cubeuvmaps, state, objects, _alpha, premultipliedAlpha );
			shadowMap = new WebGLShadowMap( _this, objects, capabilities );
			uniformsGroups = new WebGLUniformsGroups( _gl, info, capabilities, state );

			bufferRenderer = new WebGLBufferRenderer( _gl, extensions, info );
			indexedBufferRenderer = new WebGLIndexedBufferRenderer( _gl, extensions, info );

			info.programs = programCache.programs;

			_this.capabilities = capabilities;
			_this.extensions = extensions;
			_this.properties = properties;
			_this.renderLists = renderLists;
			_this.shadowMap = shadowMap;
			_this.state = state;
			_this.info = info;

		}

		initGLContext();

		// xr

		const xr = new WebXRManager( _this, _gl );

		this.xr = xr;

		// API

		this.getContext = function () {

			return _gl;

		};

		this.getContextAttributes = function () {

			return _gl.getContextAttributes();

		};

		this.forceContextLoss = function () {

			const extension = extensions.get( 'WEBGL_lose_context' );
			if ( extension ) extension.loseContext();

		};

		this.forceContextRestore = function () {

			const extension = extensions.get( 'WEBGL_lose_context' );
			if ( extension ) extension.restoreContext();

		};

		this.getPixelRatio = function () {

			return _pixelRatio;

		};

		this.setPixelRatio = function ( value ) {

			if ( value === undefined ) return;

			_pixelRatio = value;

			this.setSize( _width, _height, false );

		};

		this.getSize = function ( target ) {

			return target.set( _width, _height );

		};

		this.setSize = function ( width, height, updateStyle = true ) {

			if ( xr.isPresenting ) {

				console.warn( 'THREE.WebGLRenderer: Can\'t change size while VR device is presenting.' );
				return;

			}

			_width = width;
			_height = height;

			canvas.width = Math.floor( width * _pixelRatio );
			canvas.height = Math.floor( height * _pixelRatio );

			if ( updateStyle === true ) {

				canvas.style.width = width + 'px';
				canvas.style.height = height + 'px';

			}

			this.setViewport( 0, 0, width, height );

		};

		this.getDrawingBufferSize = function ( target ) {

			return target.set( _width * _pixelRatio, _height * _pixelRatio ).floor();

		};

		this.setDrawingBufferSize = function ( width, height, pixelRatio ) {

			_width = width;
			_height = height;

			_pixelRatio = pixelRatio;

			canvas.width = Math.floor( width * pixelRatio );
			canvas.height = Math.floor( height * pixelRatio );

			this.setViewport( 0, 0, width, height );

		};

		this.getCurrentViewport = function ( target ) {

			return target.copy( _currentViewport );

		};

		this.getViewport = function ( target ) {

			return target.copy( _viewport );

		};

		this.setViewport = function ( x, y, width, height ) {

			if ( x.isVector4 ) {

				_viewport.set( x.x, x.y, x.z, x.w );

			} else {

				_viewport.set( x, y, width, height );

			}

			state.viewport( _currentViewport.copy( _viewport ).multiplyScalar( _pixelRatio ).round() );

		};

		this.getScissor = function ( target ) {

			return target.copy( _scissor );

		};

		this.setScissor = function ( x, y, width, height ) {

			if ( x.isVector4 ) {

				_scissor.set( x.x, x.y, x.z, x.w );

			} else {

				_scissor.set( x, y, width, height );

			}

			state.scissor( _currentScissor.copy( _scissor ).multiplyScalar( _pixelRatio ).round() );

		};

		this.getScissorTest = function () {

			return _scissorTest;

		};

		this.setScissorTest = function ( boolean ) {

			state.setScissorTest( _scissorTest = boolean );

		};

		this.setOpaqueSort = function ( method ) {

			_opaqueSort = method;

		};

		this.setTransparentSort = function ( method ) {

			_transparentSort = method;

		};

		// Clearing

		this.getClearColor = function ( target ) {

			return target.copy( background.getClearColor() );

		};

		this.setClearColor = function () {

			background.setClearColor.apply( background, arguments );

		};

		this.getClearAlpha = function () {

			return background.getClearAlpha();

		};

		this.setClearAlpha = function () {

			background.setClearAlpha.apply( background, arguments );

		};

		this.clear = function ( color = true, depth = true, stencil = true ) {

			let bits = 0;

			if ( color ) {

				// check if we're trying to clear an integer target
				let isIntegerFormat = false;
				if ( _currentRenderTarget !== null ) {

					const targetFormat = _currentRenderTarget.texture.format;
					isIntegerFormat = targetFormat === RGBAIntegerFormat ||
						targetFormat === RGIntegerFormat ||
						targetFormat === RedIntegerFormat;

				}

				// use the appropriate clear functions to clear the target if it's a signed
				// or unsigned integer target
				if ( isIntegerFormat ) {

					const targetType = _currentRenderTarget.texture.type;
					const isUnsignedType = targetType === UnsignedByteType ||
						targetType === UnsignedIntType ||
						targetType === UnsignedShortType ||
						targetType === UnsignedInt248Type ||
						targetType === UnsignedShort4444Type ||
						targetType === UnsignedShort5551Type;

					const clearColor = background.getClearColor();
					const a = background.getClearAlpha();
					const r = clearColor.r;
					const g = clearColor.g;
					const b = clearColor.b;

					if ( isUnsignedType ) {

						uintClearColor[ 0 ] = r;
						uintClearColor[ 1 ] = g;
						uintClearColor[ 2 ] = b;
						uintClearColor[ 3 ] = a;
						_gl.clearBufferuiv( _gl.COLOR, 0, uintClearColor );

					} else {

						intClearColor[ 0 ] = r;
						intClearColor[ 1 ] = g;
						intClearColor[ 2 ] = b;
						intClearColor[ 3 ] = a;
						_gl.clearBufferiv( _gl.COLOR, 0, intClearColor );

					}

				} else {

					bits |= _gl.COLOR_BUFFER_BIT;

				}

			}

			if ( depth ) bits |= _gl.DEPTH_BUFFER_BIT;
			if ( stencil ) {

				bits |= _gl.STENCIL_BUFFER_BIT;
				this.state.buffers.stencil.setMask( 0xffffffff );

			}

			_gl.clear( bits );

		};

		this.clearColor = function () {

			this.clear( true, false, false );

		};

		this.clearDepth = function () {

			this.clear( false, true, false );

		};

		this.clearStencil = function () {

			this.clear( false, false, true );

		};

		//

		this.dispose = function () {

			canvas.removeEventListener( 'webglcontextlost', onContextLost, false );
			canvas.removeEventListener( 'webglcontextrestored', onContextRestore, false );
			canvas.removeEventListener( 'webglcontextcreationerror', onContextCreationError, false );

			renderLists.dispose();
			renderStates.dispose();
			properties.dispose();
			cubemaps.dispose();
			cubeuvmaps.dispose();
			objects.dispose();
			bindingStates.dispose();
			uniformsGroups.dispose();
			programCache.dispose();

			xr.dispose();

			xr.removeEventListener( 'sessionstart', onXRSessionStart );
			xr.removeEventListener( 'sessionend', onXRSessionEnd );

			animation.stop();

		};

		// Events

		function onContextLost( event ) {

			event.preventDefault();

			console.log( 'THREE.WebGLRenderer: Context Lost.' );

			_isContextLost = true;

		}

		function onContextRestore( /* event */ ) {

			console.log( 'THREE.WebGLRenderer: Context Restored.' );

			_isContextLost = false;

			const infoAutoReset = info.autoReset;
			const shadowMapEnabled = shadowMap.enabled;
			const shadowMapAutoUpdate = shadowMap.autoUpdate;
			const shadowMapNeedsUpdate = shadowMap.needsUpdate;
			const shadowMapType = shadowMap.type;

			initGLContext();

			info.autoReset = infoAutoReset;
			shadowMap.enabled = shadowMapEnabled;
			shadowMap.autoUpdate = shadowMapAutoUpdate;
			shadowMap.needsUpdate = shadowMapNeedsUpdate;
			shadowMap.type = shadowMapType;

		}

		function onContextCreationError( event ) {

			console.error( 'THREE.WebGLRenderer: A WebGL context could not be created. Reason: ', event.statusMessage );

		}

		function onMaterialDispose( event ) {

			const material = event.target;

			material.removeEventListener( 'dispose', onMaterialDispose );

			deallocateMaterial( material );

		}

		// Buffer deallocation

		function deallocateMaterial( material ) {

			releaseMaterialProgramReferences( material );

			properties.remove( material );

		}


		function releaseMaterialProgramReferences( material ) {

			const programs = properties.get( material ).programs;

			if ( programs !== undefined ) {

				programs.forEach( function ( program ) {

					programCache.releaseProgram( program );

				} );

				if ( material.isShaderMaterial ) {

					programCache.releaseShaderCache( material );

				}

			}

		}

		// Buffer rendering

		this.renderBufferDirect = function ( camera, scene, geometry, material, object, group ) {

			if ( scene === null ) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)

			const frontFaceCW = ( object.isMesh && object.matrixWorld.determinant() < 0 );

			const program = setProgram( camera, scene, geometry, material, object );

			state.setMaterial( material, frontFaceCW );

			//

			let index = geometry.index;
			let rangeFactor = 1;

			if ( material.wireframe === true ) {

				index = geometries.getWireframeAttribute( geometry );

				if ( index === undefined ) return;

				rangeFactor = 2;

			}

			//

			const drawRange = geometry.drawRange;
			const position = geometry.attributes.position;

			let drawStart = drawRange.start * rangeFactor;
			let drawEnd = ( drawRange.start + drawRange.count ) * rangeFactor;

			if ( group !== null ) {

				drawStart = Math.max( drawStart, group.start * rangeFactor );
				drawEnd = Math.min( drawEnd, ( group.start + group.count ) * rangeFactor );

			}

			if ( index !== null ) {

				drawStart = Math.max( drawStart, 0 );
				drawEnd = Math.min( drawEnd, index.count );

			} else if ( position !== undefined && position !== null ) {

				drawStart = Math.max( drawStart, 0 );
				drawEnd = Math.min( drawEnd, position.count );

			}

			const drawCount = drawEnd - drawStart;

			if ( drawCount < 0 || drawCount === Infinity ) return;

			//

			bindingStates.setup( object, material, program, geometry, index );

			let attribute;
			let renderer = bufferRenderer;

			if ( index !== null ) {

				attribute = attributes.get( index );

				renderer = indexedBufferRenderer;
				renderer.setIndex( attribute );

			}

			//

			if ( object.isMesh ) {

				if ( material.wireframe === true ) {

					state.setLineWidth( material.wireframeLinewidth * getTargetPixelRatio() );
					renderer.setMode( _gl.LINES );

				} else {

					renderer.setMode( _gl.TRIANGLES );

				}

			} else if ( object.isLine ) {

				let lineWidth = material.linewidth;

				if ( lineWidth === undefined ) lineWidth = 1; // Not using Line*Material

				state.setLineWidth( lineWidth * getTargetPixelRatio() );

				if ( object.isLineSegments ) {

					renderer.setMode( _gl.LINES );

				} else if ( object.isLineLoop ) {

					renderer.setMode( _gl.LINE_LOOP );

				} else {

					renderer.setMode( _gl.LINE_STRIP );

				}

			} else if ( object.isPoints ) {

				renderer.setMode( _gl.POINTS );

			} else if ( object.isSprite ) {

				renderer.setMode( _gl.TRIANGLES );

			}

			if ( object.isBatchedMesh ) {

				renderer.renderMultiDraw( object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount );

			} else if ( object.isInstancedMesh ) {

				renderer.renderInstances( drawStart, drawCount, object.count );

			} else if ( geometry.isInstancedBufferGeometry ) {

				const maxInstanceCount = geometry._maxInstanceCount !== undefined ? geometry._maxInstanceCount : Infinity;
				const instanceCount = Math.min( geometry.instanceCount, maxInstanceCount );

				renderer.renderInstances( drawStart, drawCount, instanceCount );

			} else {

				renderer.render( drawStart, drawCount );

			}

		};

		// Compile

		function prepareMaterial( material, scene, object ) {

			if ( material.transparent === true && material.side === DoubleSide && material.forceSinglePass === false ) {

				material.side = BackSide;
				material.needsUpdate = true;
				getProgram( material, scene, object );

				material.side = FrontSide;
				material.needsUpdate = true;
				getProgram( material, scene, object );

				material.side = DoubleSide;

			} else {

				getProgram( material, scene, object );

			}

		}

		this.compile = function ( scene, camera, targetScene = null ) {

			if ( targetScene === null ) targetScene = scene;

			currentRenderState = renderStates.get( targetScene );
			currentRenderState.init();

			renderStateStack.push( currentRenderState );

			// gather lights from both the target scene and the new object that will be added to the scene.

			targetScene.traverseVisible( function ( object ) {

				if ( object.isLight && object.layers.test( camera.layers ) ) {

					currentRenderState.pushLight( object );

					if ( object.castShadow ) {

						currentRenderState.pushShadow( object );

					}

				}

			} );

			if ( scene !== targetScene ) {

				scene.traverseVisible( function ( object ) {

					if ( object.isLight && object.layers.test( camera.layers ) ) {

						currentRenderState.pushLight( object );

						if ( object.castShadow ) {

							currentRenderState.pushShadow( object );

						}

					}

				} );

			}

			currentRenderState.setupLights( _this._useLegacyLights );

			// Only initialize materials in the new scene, not the targetScene.

			const materials = new Set();

			scene.traverse( function ( object ) {

				const material = object.material;

				if ( material ) {

					if ( Array.isArray( material ) ) {

						for ( let i = 0; i < material.length; i ++ ) {

							const material2 = material[ i ];

							prepareMaterial( material2, targetScene, object );
							materials.add( material2 );

						}

					} else {

						prepareMaterial( material, targetScene, object );
						materials.add( material );

					}

				}

			} );

			renderStateStack.pop();
			currentRenderState = null;

			return materials;

		};

		// compileAsync

		this.compileAsync = function ( scene, camera, targetScene = null ) {

			const materials = this.compile( scene, camera, targetScene );

			// Wait for all the materials in the new object to indicate that they're
			// ready to be used before resolving the promise.

			return new Promise( ( resolve ) => {

				function checkMaterialsReady() {

					materials.forEach( function ( material ) {

						const materialProperties = properties.get( material );
						const program = materialProperties.currentProgram;

						if ( program.isReady() ) {

							// remove any programs that report they're ready to use from the list
							materials.delete( material );

						}

					} );

					// once the list of compiling materials is empty, call the callback

					if ( materials.size === 0 ) {

						resolve( scene );
						return;

					}

					// if some materials are still not ready, wait a bit and check again

					setTimeout( checkMaterialsReady, 10 );

				}

				if ( extensions.get( 'KHR_parallel_shader_compile' ) !== null ) {

					// If we can check the compilation status of the materials without
					// blocking then do so right away.

					checkMaterialsReady();

				} else {

					// Otherwise start by waiting a bit to give the materials we just
					// initialized a chance to finish.

					setTimeout( checkMaterialsReady, 10 );

				}

			} );

		};

		// Animation Loop

		let onAnimationFrameCallback = null;

		function onAnimationFrame( time ) {

			if ( onAnimationFrameCallback ) onAnimationFrameCallback( time );

		}

		function onXRSessionStart() {

			animation.stop();

		}

		function onXRSessionEnd() {

			animation.start();

		}

		const animation = new WebGLAnimation();
		animation.setAnimationLoop( onAnimationFrame );

		if ( typeof self !== 'undefined' ) animation.setContext( self );

		this.setAnimationLoop = function ( callback ) {

			onAnimationFrameCallback = callback;
			xr.setAnimationLoop( callback );

			( callback === null ) ? animation.stop() : animation.start();

		};

		xr.addEventListener( 'sessionstart', onXRSessionStart );
		xr.addEventListener( 'sessionend', onXRSessionEnd );

		// Rendering

		this.render = function ( scene, camera ) {

			if ( camera !== undefined && camera.isCamera !== true ) {

				console.error( 'THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.' );
				return;

			}

			if ( _isContextLost === true ) return;

			// update scene graph

			if ( scene.matrixWorldAutoUpdate === true ) scene.updateMatrixWorld();

			// update camera matrices and frustum

			if ( camera.parent === null && camera.matrixWorldAutoUpdate === true ) camera.updateMatrixWorld();

			if ( xr.enabled === true && xr.isPresenting === true ) {

				if ( xr.cameraAutoUpdate === true ) xr.updateCamera( camera );

				camera = xr.getCamera(); // use XR camera for rendering

			}

			//
			if ( scene.isScene === true ) scene.onBeforeRender( _this, scene, camera, _currentRenderTarget );

			currentRenderState = renderStates.get( scene, renderStateStack.length );
			currentRenderState.init();

			renderStateStack.push( currentRenderState );

			_projScreenMatrix.multiplyMatrices( camera.projectionMatrix, camera.matrixWorldInverse );
			_frustum.setFromProjectionMatrix( _projScreenMatrix );

			_localClippingEnabled = this.localClippingEnabled;
			_clippingEnabled = clipping.init( this.clippingPlanes, _localClippingEnabled );

			currentRenderList = renderLists.get( scene, renderListStack.length );
			currentRenderList.init();

			renderListStack.push( currentRenderList );

			projectObject( scene, camera, 0, _this.sortObjects );

			currentRenderList.finish();

			if ( _this.sortObjects === true ) {

				currentRenderList.sort( _opaqueSort, _transparentSort );

			}

			//

			this.info.render.frame ++;

			if ( _clippingEnabled === true ) clipping.beginShadows();

			const shadowsArray = currentRenderState.state.shadowsArray;

			shadowMap.render( shadowsArray, scene, camera );

			if ( _clippingEnabled === true ) clipping.endShadows();

			//

			if ( this.info.autoReset === true ) this.info.reset();


			//

			if ( xr.enabled === false || xr.isPresenting === false || xr.hasDepthSensing() === false ) {

				background.render( currentRenderList, scene );

			}

			// render scene

			currentRenderState.setupLights( _this._useLegacyLights );

			if ( camera.isArrayCamera ) {

				const cameras = camera.cameras;

				for ( let i = 0, l = cameras.length; i < l; i ++ ) {

					const camera2 = cameras[ i ];

					renderScene( currentRenderList, scene, camera2, camera2.viewport );

				}

			} else {

				renderScene( currentRenderList, scene, camera );

			}

			//

			if ( _currentRenderTarget !== null ) {

				// resolve multisample renderbuffers to a single-sample texture if necessary

				textures.updateMultisampleRenderTarget( _currentRenderTarget );

				// Generate mipmap if we're using any kind of mipmap filtering

				textures.updateRenderTargetMipmap( _currentRenderTarget );

			}

			//

			if ( scene.isScene === true ) scene.onAfterRender( _this, scene, camera );

			// _gl.finish();

			bindingStates.resetDefaultState();
			_currentMaterialId = - 1;
			_currentCamera = null;

			renderStateStack.pop();

			if ( renderStateStack.length > 0 ) {

				currentRenderState = renderStateStack[ renderStateStack.length - 1 ];

			} else {

				currentRenderState = null;

			}

			renderListStack.pop();

			if ( renderListStack.length > 0 ) {

				currentRenderList = renderListStack[ renderListStack.length - 1 ];

			} else {

				currentRenderList = null;

			}

		};

		function projectObject( object, camera, groupOrder, sortObjects ) {

			if ( object.visible === false ) return;

			const visible = object.layers.test( camera.layers );

			if ( visible ) {

				if ( object.isGroup ) {

					groupOrder = object.renderOrder;

				} else if ( object.isLOD ) {

					if ( object.autoUpdate === true ) object.update( camera );

				} else if ( object.isLight ) {

					currentRenderState.pushLight( object );

					if ( object.castShadow ) {

						currentRenderState.pushShadow( object );

					}

				} else if ( object.isSprite ) {

					if ( ! object.frustumCulled || _frustum.intersectsSprite( object ) ) {

						if ( sortObjects ) {

							_vector3.setFromMatrixPosition( object.matrixWorld )
								.applyMatrix4( _projScreenMatrix );

						}

						const geometry = objects.update( object );
						const material = object.material;

						if ( material.visible ) {

							currentRenderList.push( object, geometry, material, groupOrder, _vector3.z, null );

						}

					}

				} else if ( object.isMesh || object.isLine || object.isPoints ) {

					if ( ! object.frustumCulled || _frustum.intersectsObject( object ) ) {

						const geometry = objects.update( object );
						const material = object.material;

						if ( sortObjects ) {

							if ( object.boundingSphere !== undefined ) {

								if ( object.boundingSphere === null ) object.computeBoundingSphere();
								_vector3.copy( object.boundingSphere.center );

							} else {

								if ( geometry.boundingSphere === null ) geometry.computeBoundingSphere();
								_vector3.copy( geometry.boundingSphere.center );

							}

							_vector3
								.applyMatrix4( object.matrixWorld )
								.applyMatrix4( _projScreenMatrix );

						}

						if ( Array.isArray( material ) ) {

							const groups = geometry.groups;

							for ( let i = 0, l = groups.length; i < l; i ++ ) {

								const group = groups[ i ];
								const groupMaterial = material[ group.materialIndex ];

								if ( groupMaterial && groupMaterial.visible ) {

									currentRenderList.push( object, geometry, groupMaterial, groupOrder, _vector3.z, group );

								}

							}

						} else if ( material.visible ) {

							currentRenderList.push( object, geometry, material, groupOrder, _vector3.z, null );

						}

					}

				}

			}

			const children = object.children;

			for ( let i = 0, l = children.length; i < l; i ++ ) {

				projectObject( children[ i ], camera, groupOrder, sortObjects );

			}

		}

		function renderScene( currentRenderList, scene, camera, viewport ) {

			const opaqueObjects = currentRenderList.opaque;
			const transmissiveObjects = currentRenderList.transmissive;
			const transparentObjects = currentRenderList.transparent;

			currentRenderState.setupLightsView( camera );

			if ( _clippingEnabled === true ) clipping.setGlobalState( _this.clippingPlanes, camera );

			if ( transmissiveObjects.length > 0 ) renderTransmissionPass( opaqueObjects, transmissiveObjects, scene, camera );

			if ( viewport ) state.viewport( _currentViewport.copy( viewport ) );

			if ( opaqueObjects.length > 0 ) renderObjects( opaqueObjects, scene, camera );
			if ( transmissiveObjects.length > 0 ) renderObjects( transmissiveObjects, scene, camera );
			if ( transparentObjects.length > 0 ) renderObjects( transparentObjects, scene, camera );

			// Ensure depth buffer writing is enabled so it can be cleared on next render

			state.buffers.depth.setTest( true );
			state.buffers.depth.setMask( true );
			state.buffers.color.setMask( true );

			state.setPolygonOffset( false );

		}

		function renderTransmissionPass( opaqueObjects, transmissiveObjects, scene, camera ) {

			const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;

			if ( overrideMaterial !== null ) {

				return;

			}

			if ( currentRenderState.state.transmissionRenderTarget === null ) {

				currentRenderState.state.transmissionRenderTarget = new WebGLRenderTarget( 1, 1, {
					generateMipmaps: true,
					type: ( extensions.has( 'EXT_color_buffer_half_float' ) || extensions.has( 'EXT_color_buffer_float' ) ) ? HalfFloatType : UnsignedByteType,
					minFilter: LinearMipmapLinearFilter,
					samples: 4,
					stencilBuffer: stencil
				} );

				const renderTargetProperties = properties.get( currentRenderState.state.transmissionRenderTarget );
				renderTargetProperties.__isTransmissionRenderTarget = true;

				// debug

				/*
				const geometry = new PlaneGeometry();
				const material = new MeshBasicMaterial( { map: _transmissionRenderTarget.texture } );

				const mesh = new Mesh( geometry, material );
				scene.add( mesh );
				*/

			}

			const transmissionRenderTarget = currentRenderState.state.transmissionRenderTarget;

			_this.getDrawingBufferSize( _vector2 );
			transmissionRenderTarget.setSize( _vector2.x, _vector2.y );

			//

			const currentRenderTarget = _this.getRenderTarget();
			_this.setRenderTarget( transmissionRenderTarget );

			_this.getClearColor( _currentClearColor );
			_currentClearAlpha = _this.getClearAlpha();
			if ( _currentClearAlpha < 1 ) _this.setClearColor( 0xffffff, 0.5 );

			_this.clear();

			// Turn off the features which can affect the frag color for opaque objects pass.
			// Otherwise they are applied twice in opaque objects pass and transmission objects pass.
			const currentToneMapping = _this.toneMapping;
			_this.toneMapping = NoToneMapping;

			renderObjects( opaqueObjects, scene, camera );

			textures.updateMultisampleRenderTarget( transmissionRenderTarget );
			textures.updateRenderTargetMipmap( transmissionRenderTarget );

			let renderTargetNeedsUpdate = false;

			for ( let i = 0, l = transmissiveObjects.length; i < l; i ++ ) {

				const renderItem = transmissiveObjects[ i ];

				const object = renderItem.object;
				const geometry = renderItem.geometry;
				const material = renderItem.material;
				const group = renderItem.group;

				if ( material.side === DoubleSide && object.layers.test( camera.layers ) ) {

					const currentSide = material.side;

					material.side = BackSide;
					material.needsUpdate = true;

					renderObject( object, scene, camera, geometry, material, group );

					material.side = currentSide;
					material.needsUpdate = true;

					renderTargetNeedsUpdate = true;

				}

			}

			if ( renderTargetNeedsUpdate === true ) {

				textures.updateMultisampleRenderTarget( transmissionRenderTarget );
				textures.updateRenderTargetMipmap( transmissionRenderTarget );

			}

			_this.setRenderTarget( currentRenderTarget );

			_this.setClearColor( _currentClearColor, _currentClearAlpha );

			_this.toneMapping = currentToneMapping;

		}

		function renderObjects( renderList, scene, camera ) {

			const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;

			for ( let i = 0, l = renderList.length; i < l; i ++ ) {

				const renderItem = renderList[ i ];

				const object = renderItem.object;
				const geometry = renderItem.geometry;
				const material = overrideMaterial === null ? renderItem.material : overrideMaterial;
				const group = renderItem.group;

				if ( object.layers.test( camera.layers ) ) {

					renderObject( object, scene, camera, geometry, material, group );

				}

			}

		}

		function renderObject( object, scene, camera, geometry, material, group ) {

			object.onBeforeRender( _this, scene, camera, geometry, material, group );

			object.modelViewMatrix.multiplyMatrices( camera.matrixWorldInverse, object.matrixWorld );
			object.normalMatrix.getNormalMatrix( object.modelViewMatrix );

			material.onBeforeRender( _this, scene, camera, geometry, object, group );

			if ( material.transparent === true && material.side === DoubleSide && material.forceSinglePass === false ) {

				material.side = BackSide;
				material.needsUpdate = true;
				_this.renderBufferDirect( camera, scene, geometry, material, object, group );

				material.side = FrontSide;
				material.needsUpdate = true;
				_this.renderBufferDirect( camera, scene, geometry, material, object, group );

				material.side = DoubleSide;

			} else {

				_this.renderBufferDirect( camera, scene, geometry, material, object, group );

			}

			object.onAfterRender( _this, scene, camera, geometry, material, group );

		}

		function getProgram( material, scene, object ) {

			if ( scene.isScene !== true ) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...

			const materialProperties = properties.get( material );

			const lights = currentRenderState.state.lights;
			const shadowsArray = currentRenderState.state.shadowsArray;

			const lightsStateVersion = lights.state.version;

			const parameters = programCache.getParameters( material, lights.state, shadowsArray, scene, object );
			const programCacheKey = programCache.getProgramCacheKey( parameters );

			let programs = materialProperties.programs;

			// always update environment and fog - changing these trigger an getProgram call, but it's possible that the program doesn't change

			materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
			materialProperties.fog = scene.fog;
			materialProperties.envMap = ( material.isMeshStandardMaterial ? cubeuvmaps : cubemaps ).get( material.envMap || materialProperties.environment );
			materialProperties.envMapRotation = ( materialProperties.environment !== null && material.envMap === null ) ? scene.environmentRotation : material.envMapRotation;

			if ( programs === undefined ) {

				// new material

				material.addEventListener( 'dispose', onMaterialDispose );

				programs = new Map();
				materialProperties.programs = programs;

			}

			let program = programs.get( programCacheKey );

			if ( program !== undefined ) {

				// early out if program and light state is identical

				if ( materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion ) {

					updateCommonMaterialProperties( material, parameters );

					return program;

				}

			} else {

				parameters.uniforms = programCache.getUniforms( material );

				material.onBuild( object, parameters, _this );

				material.onBeforeCompile( parameters, _this );

				program = programCache.acquireProgram( parameters, programCacheKey );
				programs.set( programCacheKey, program );

				materialProperties.uniforms = parameters.uniforms;

			}

			const uniforms = materialProperties.uniforms;

			if ( ( ! material.isShaderMaterial && ! material.isRawShaderMaterial ) || material.clipping === true ) {

				uniforms.clippingPlanes = clipping.uniform;

			}

			updateCommonMaterialProperties( material, parameters );

			// store the light setup it was created for

			materialProperties.needsLights = materialNeedsLights( material );
			materialProperties.lightsStateVersion = lightsStateVersion;

			if ( materialProperties.needsLights ) {

				// wire up the material to this renderer's lighting state

				uniforms.ambientLightColor.value = lights.state.ambient;
				uniforms.lightProbe.value = lights.state.probe;
				uniforms.directionalLights.value = lights.state.directional;
				uniforms.directionalLightShadows.value = lights.state.directionalShadow;
				uniforms.spotLights.value = lights.state.spot;
				uniforms.spotLightShadows.value = lights.state.spotShadow;
				uniforms.rectAreaLights.value = lights.state.rectArea;
				uniforms.ltc_1.value = lights.state.rectAreaLTC1;
				uniforms.ltc_2.value = lights.state.rectAreaLTC2;
				uniforms.pointLights.value = lights.state.point;
				uniforms.pointLightShadows.value = lights.state.pointShadow;
				uniforms.hemisphereLights.value = lights.state.hemi;

				uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
				uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
				uniforms.spotShadowMap.value = lights.state.spotShadowMap;
				uniforms.spotLightMatrix.value = lights.state.spotLightMatrix;
				uniforms.spotLightMap.value = lights.state.spotLightMap;
				uniforms.pointShadowMap.value = lights.state.pointShadowMap;
				uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
				// TODO (abelnation): add area lights shadow info to uniforms

			}

			materialProperties.currentProgram = program;
			materialProperties.uniformsList = null;

			return program;

		}

		function getUniformList( materialProperties ) {

			if ( materialProperties.uniformsList === null ) {

				const progUniforms = materialProperties.currentProgram.getUniforms();
				materialProperties.uniformsList = WebGLUniforms.seqWithValue( progUniforms.seq, materialProperties.uniforms );

			}

			return materialProperties.uniformsList;

		}

		function updateCommonMaterialProperties( material, parameters ) {

			const materialProperties = properties.get( material );

			materialProperties.outputColorSpace = parameters.outputColorSpace;
			materialProperties.batching = parameters.batching;
			materialProperties.instancing = parameters.instancing;
			materialProperties.instancingColor = parameters.instancingColor;
			materialProperties.instancingMorph = parameters.instancingMorph;
			materialProperties.skinning = parameters.skinning;
			materialProperties.morphTargets = parameters.morphTargets;
			materialProperties.morphNormals = parameters.morphNormals;
			materialProperties.morphColors = parameters.morphColors;
			materialProperties.morphTargetsCount = parameters.morphTargetsCount;
			materialProperties.numClippingPlanes = parameters.numClippingPlanes;
			materialProperties.numIntersection = parameters.numClipIntersection;
			materialProperties.vertexAlphas = parameters.vertexAlphas;
			materialProperties.vertexTangents = parameters.vertexTangents;
			materialProperties.toneMapping = parameters.toneMapping;

		}

		function setProgram( camera, scene, geometry, material, object ) {

			if ( scene.isScene !== true ) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...

			textures.resetTextureUnits();

			const fog = scene.fog;
			const environment = material.isMeshStandardMaterial ? scene.environment : null;
			const colorSpace = ( _currentRenderTarget === null ) ? _this.outputColorSpace : ( _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.colorSpace : LinearSRGBColorSpace );
			const envMap = ( material.isMeshStandardMaterial ? cubeuvmaps : cubemaps ).get( material.envMap || environment );
			const vertexAlphas = material.vertexColors === true && !! geometry.attributes.color && geometry.attributes.color.itemSize === 4;
			const vertexTangents = !! geometry.attributes.tangent && ( !! material.normalMap || material.anisotropy > 0 );
			const morphTargets = !! geometry.morphAttributes.position;
			const morphNormals = !! geometry.morphAttributes.normal;
			const morphColors = !! geometry.morphAttributes.color;

			let toneMapping = NoToneMapping;

			if ( material.toneMapped ) {

				if ( _currentRenderTarget === null || _currentRenderTarget.isXRRenderTarget === true ) {

					toneMapping = _this.toneMapping;

				}

			}

			const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
			const morphTargetsCount = ( morphAttribute !== undefined ) ? morphAttribute.length : 0;

			const materialProperties = properties.get( material );
			const lights = currentRenderState.state.lights;

			if ( _clippingEnabled === true ) {

				if ( _localClippingEnabled === true || camera !== _currentCamera ) {

					const useCache =
						camera === _currentCamera &&
						material.id === _currentMaterialId;

					// we might want to call this function with some ClippingGroup
					// object instead of the material, once it becomes feasible
					// (#8465, #8379)
					clipping.setState( material, camera, useCache );

				}

			}

			//

			let needsProgramChange = false;

			if ( material.version === materialProperties.__version ) {

				if ( materialProperties.needsLights && ( materialProperties.lightsStateVersion !== lights.state.version ) ) {

					needsProgramChange = true;

				} else if ( materialProperties.outputColorSpace !== colorSpace ) {

					needsProgramChange = true;

				} else if ( object.isBatchedMesh && materialProperties.batching === false ) {

					needsProgramChange = true;

				} else if ( ! object.isBatchedMesh && materialProperties.batching === true ) {

					needsProgramChange = true;

				} else if ( object.isInstancedMesh && materialProperties.instancing === false ) {

					needsProgramChange = true;

				} else if ( ! object.isInstancedMesh && materialProperties.instancing === true ) {

					needsProgramChange = true;

				} else if ( object.isSkinnedMesh && materialProperties.skinning === false ) {

					needsProgramChange = true;

				} else if ( ! object.isSkinnedMesh && materialProperties.skinning === true ) {

					needsProgramChange = true;

				} else if ( object.isInstancedMesh && materialProperties.instancingColor === true && object.instanceColor === null ) {

					needsProgramChange = true;

				} else if ( object.isInstancedMesh && materialProperties.instancingColor === false && object.instanceColor !== null ) {

					needsProgramChange = true;

				} else if ( object.isInstancedMesh && materialProperties.instancingMorph === true && object.morphTexture === null ) {

					needsProgramChange = true;

				} else if ( object.isInstancedMesh && materialProperties.instancingMorph === false && object.morphTexture !== null ) {

					needsProgramChange = true;

				} else if ( materialProperties.envMap !== envMap ) {

					needsProgramChange = true;

				} else if ( material.fog === true && materialProperties.fog !== fog ) {

					needsProgramChange = true;

				} else if ( materialProperties.numClippingPlanes !== undefined &&
					( materialProperties.numClippingPlanes !== clipping.numPlanes ||
					materialProperties.numIntersection !== clipping.numIntersection ) ) {

					needsProgramChange = true;

				} else if ( materialProperties.vertexAlphas !== vertexAlphas ) {

					needsProgramChange = true;

				} else if ( materialProperties.vertexTangents !== vertexTangents ) {

					needsProgramChange = true;

				} else if ( materialProperties.morphTargets !== morphTargets ) {

					needsProgramChange = true;

				} else if ( materialProperties.morphNormals !== morphNormals ) {

					needsProgramChange = true;

				} else if ( materialProperties.morphColors !== morphColors ) {

					needsProgramChange = true;

				} else if ( materialProperties.toneMapping !== toneMapping ) {

					needsProgramChange = true;

				} else if ( materialProperties.morphTargetsCount !== morphTargetsCount ) {

					needsProgramChange = true;

				}

			} else {

				needsProgramChange = true;
				materialProperties.__version = material.version;

			}

			//

			let program = materialProperties.currentProgram;

			if ( needsProgramChange === true ) {

				program = getProgram( material, scene, object );

			}

			let refreshProgram = false;
			let refreshMaterial = false;
			let refreshLights = false;

			const p_uniforms = program.getUniforms(),
				m_uniforms = materialProperties.uniforms;

			if ( state.useProgram( program.program ) ) {

				refreshProgram = true;
				refreshMaterial = true;
				refreshLights = true;

			}

			if ( material.id !== _currentMaterialId ) {

				_currentMaterialId = material.id;

				refreshMaterial = true;

			}

			if ( refreshProgram || _currentCamera !== camera ) {

				// common camera uniforms

				p_uniforms.setValue( _gl, 'projectionMatrix', camera.projectionMatrix );
				p_uniforms.setValue( _gl, 'viewMatrix', camera.matrixWorldInverse );

				const uCamPos = p_uniforms.map.cameraPosition;

				if ( uCamPos !== undefined ) {

					uCamPos.setValue( _gl, _vector3.setFromMatrixPosition( camera.matrixWorld ) );

				}

				if ( capabilities.logarithmicDepthBuffer ) {

					p_uniforms.setValue( _gl, 'logDepthBufFC',
						2.0 / ( Math.log( camera.far + 1.0 ) / Math.LN2 ) );

				}

				// consider moving isOrthographic to UniformLib and WebGLMaterials, see https://github.com/mrdoob/three.js/pull/26467#issuecomment-1645185067

				if ( material.isMeshPhongMaterial ||
					material.isMeshToonMaterial ||
					material.isMeshLambertMaterial ||
					material.isMeshBasicMaterial ||
					material.isMeshStandardMaterial ||
					material.isShaderMaterial ) {

					p_uniforms.setValue( _gl, 'isOrthographic', camera.isOrthographicCamera === true );

				}

				if ( _currentCamera !== camera ) {

					_currentCamera = camera;

					// lighting uniforms depend on the camera so enforce an update
					// now, in case this material supports lights - or later, when
					// the next material that does gets activated:

					refreshMaterial = true;		// set to true on material change
					refreshLights = true;		// remains set until update done

				}

			}

			// skinning and morph target uniforms must be set even if material didn't change
			// auto-setting of texture unit for bone and morph texture must go before other textures
			// otherwise textures used for skinning and morphing can take over texture units reserved for other material textures

			if ( object.isSkinnedMesh ) {

				p_uniforms.setOptional( _gl, object, 'bindMatrix' );
				p_uniforms.setOptional( _gl, object, 'bindMatrixInverse' );

				const skeleton = object.skeleton;

				if ( skeleton ) {

					if ( skeleton.boneTexture === null ) skeleton.computeBoneTexture();

					p_uniforms.setValue( _gl, 'boneTexture', skeleton.boneTexture, textures );

				}

			}

			if ( object.isBatchedMesh ) {

				p_uniforms.setOptional( _gl, object, 'batchingTexture' );
				p_uniforms.setValue( _gl, 'batchingTexture', object._matricesTexture, textures );

			}

			const morphAttributes = geometry.morphAttributes;

			if ( morphAttributes.position !== undefined || morphAttributes.normal !== undefined || ( morphAttributes.color !== undefined ) ) {

				morphtargets.update( object, geometry, program );

			}

			if ( refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow ) {

				materialProperties.receiveShadow = object.receiveShadow;
				p_uniforms.setValue( _gl, 'receiveShadow', object.receiveShadow );

			}

			// https://github.com/mrdoob/three.js/pull/24467#issuecomment-1209031512

			if ( material.isMeshGouraudMaterial && material.envMap !== null ) {

				m_uniforms.envMap.value = envMap;

				m_uniforms.flipEnvMap.value = ( envMap.isCubeTexture && envMap.isRenderTargetTexture === false ) ? - 1 : 1;

			}

			if ( material.isMeshStandardMaterial && material.envMap === null && scene.environment !== null ) {

				m_uniforms.envMapIntensity.value = scene.environmentIntensity;

			}

			if ( refreshMaterial ) {

				p_uniforms.setValue( _gl, 'toneMappingExposure', _this.toneMappingExposure );

				if ( materialProperties.needsLights ) {

					// the current material requires lighting info

					// note: all lighting uniforms are always set correctly
					// they simply reference the renderer's state for their
					// values
					//
					// use the current material's .needsUpdate flags to set
					// the GL state when required

					markUniformsLightsNeedsUpdate( m_uniforms, refreshLights );

				}

				// refresh uniforms common to several materials

				if ( fog && material.fog === true ) {

					materials.refreshFogUniforms( m_uniforms, fog );

				}

				materials.refreshMaterialUniforms( m_uniforms, material, _pixelRatio, _height, currentRenderState.state.transmissionRenderTarget );

				WebGLUniforms.upload( _gl, getUniformList( materialProperties ), m_uniforms, textures );

			}

			if ( material.isShaderMaterial && material.uniformsNeedUpdate === true ) {

				WebGLUniforms.upload( _gl, getUniformList( materialProperties ), m_uniforms, textures );
				material.uniformsNeedUpdate = false;

			}

			if ( material.isSpriteMaterial ) {

				p_uniforms.setValue( _gl, 'center', object.center );

			}

			// common matrices

			p_uniforms.setValue( _gl, 'modelViewMatrix', object.modelViewMatrix );
			p_uniforms.setValue( _gl, 'normalMatrix', object.normalMatrix );
			p_uniforms.setValue( _gl, 'modelMatrix', object.matrixWorld );

			// UBOs

			if ( material.isShaderMaterial || material.isRawShaderMaterial ) {

				const groups = material.uniformsGroups;

				for ( let i = 0, l = groups.length; i < l; i ++ ) {

					const group = groups[ i ];

					uniformsGroups.update( group, program );
					uniformsGroups.bind( group, program );

				}

			}

			return program;

		}

		// If uniforms are marked as clean, they don't need to be loaded to the GPU.

		function markUniformsLightsNeedsUpdate( uniforms, value ) {

			uniforms.ambientLightColor.needsUpdate = value;
			uniforms.lightProbe.needsUpdate = value;

			uniforms.directionalLights.needsUpdate = value;
			uniforms.directionalLightShadows.needsUpdate = value;
			uniforms.pointLights.needsUpdate = value;
			uniforms.pointLightShadows.needsUpdate = value;
			uniforms.spotLights.needsUpdate = value;
			uniforms.spotLightShadows.needsUpdate = value;
			uniforms.rectAreaLights.needsUpdate = value;
			uniforms.hemisphereLights.needsUpdate = value;

		}

		function materialNeedsLights( material ) {

			return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial ||
				material.isMeshStandardMaterial || material.isShadowMaterial ||
				( material.isShaderMaterial && material.lights === true );

		}

		this.getActiveCubeFace = function () {

			return _currentActiveCubeFace;

		};

		this.getActiveMipmapLevel = function () {

			return _currentActiveMipmapLevel;

		};

		this.getRenderTarget = function () {

			return _currentRenderTarget;

		};

		this.setRenderTargetTextures = function ( renderTarget, colorTexture, depthTexture ) {

			properties.get( renderTarget.texture ).__webglTexture = colorTexture;
			properties.get( renderTarget.depthTexture ).__webglTexture = depthTexture;

			const renderTargetProperties = properties.get( renderTarget );
			renderTargetProperties.__hasExternalTextures = true;

			renderTargetProperties.__autoAllocateDepthBuffer = depthTexture === undefined;

			if ( ! renderTargetProperties.__autoAllocateDepthBuffer ) {

				// The multisample_render_to_texture extension doesn't work properly if there
				// are midframe flushes and an external depth buffer. Disable use of the extension.
				if ( extensions.has( 'WEBGL_multisampled_render_to_texture' ) === true ) {

					console.warn( 'THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided' );
					renderTargetProperties.__useRenderToTexture = false;

				}

			}

		};

		this.setRenderTargetFramebuffer = function ( renderTarget, defaultFramebuffer ) {

			const renderTargetProperties = properties.get( renderTarget );
			renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
			renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === undefined;

		};

		this.setRenderTarget = function ( renderTarget, activeCubeFace = 0, activeMipmapLevel = 0 ) {

			_currentRenderTarget = renderTarget;
			_currentActiveCubeFace = activeCubeFace;
			_currentActiveMipmapLevel = activeMipmapLevel;

			let useDefaultFramebuffer = true;
			let framebuffer = null;
			let isCube = false;
			let isRenderTarget3D = false;

			if ( renderTarget ) {

				const renderTargetProperties = properties.get( renderTarget );

				if ( renderTargetProperties.__useDefaultFramebuffer !== undefined ) {

					// We need to make sure to rebind the framebuffer.
					state.bindFramebuffer( _gl.FRAMEBUFFER, null );
					useDefaultFramebuffer = false;

				} else if ( renderTargetProperties.__webglFramebuffer === undefined ) {

					textures.setupRenderTarget( renderTarget );

				} else if ( renderTargetProperties.__hasExternalTextures ) {

					// Color and depth texture must be rebound in order for the swapchain to update.
					textures.rebindTextures( renderTarget, properties.get( renderTarget.texture ).__webglTexture, properties.get( renderTarget.depthTexture ).__webglTexture );

				}

				const texture = renderTarget.texture;

				if ( texture.isData3DTexture || texture.isDataArrayTexture || texture.isCompressedArrayTexture ) {

					isRenderTarget3D = true;

				}

				const __webglFramebuffer = properties.get( renderTarget ).__webglFramebuffer;

				if ( renderTarget.isWebGLCubeRenderTarget ) {

					if ( Array.isArray( __webglFramebuffer[ activeCubeFace ] ) ) {

						framebuffer = __webglFramebuffer[ activeCubeFace ][ activeMipmapLevel ];

					} else {

						framebuffer = __webglFramebuffer[ activeCubeFace ];

					}

					isCube = true;

				} else if ( ( renderTarget.samples > 0 ) && textures.useMultisampledRTT( renderTarget ) === false ) {

					framebuffer = properties.get( renderTarget ).__webglMultisampledFramebuffer;

				} else {

					if ( Array.isArray( __webglFramebuffer ) ) {

						framebuffer = __webglFramebuffer[ activeMipmapLevel ];

					} else {

						framebuffer = __webglFramebuffer;

					}

				}

				_currentViewport.copy( renderTarget.viewport );
				_currentScissor.copy( renderTarget.scissor );
				_currentScissorTest = renderTarget.scissorTest;

			} else {

				_currentViewport.copy( _viewport ).multiplyScalar( _pixelRatio ).floor();
				_currentScissor.copy( _scissor ).multiplyScalar( _pixelRatio ).floor();
				_currentScissorTest = _scissorTest;

			}

			const framebufferBound = state.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );

			if ( framebufferBound && useDefaultFramebuffer ) {

				state.drawBuffers( renderTarget, framebuffer );

			}

			state.viewport( _currentViewport );
			state.scissor( _currentScissor );
			state.setScissorTest( _currentScissorTest );

			if ( isCube ) {

				const textureProperties = properties.get( renderTarget.texture );
				_gl.framebufferTexture2D( _gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel );

			} else if ( isRenderTarget3D ) {

				const textureProperties = properties.get( renderTarget.texture );
				const layer = activeCubeFace || 0;
				_gl.framebufferTextureLayer( _gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, textureProperties.__webglTexture, activeMipmapLevel || 0, layer );

			}

			_currentMaterialId = - 1; // reset current material to ensure correct uniform bindings

		};

		this.readRenderTargetPixels = function ( renderTarget, x, y, width, height, buffer, activeCubeFaceIndex ) {

			if ( ! ( renderTarget && renderTarget.isWebGLRenderTarget ) ) {

				console.error( 'THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.' );
				return;

			}

			let framebuffer = properties.get( renderTarget ).__webglFramebuffer;

			if ( renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined ) {

				framebuffer = framebuffer[ activeCubeFaceIndex ];

			}

			if ( framebuffer ) {

				state.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );

				try {

					const texture = renderTarget.texture;
					const textureFormat = texture.format;
					const textureType = texture.type;

					if ( textureFormat !== RGBAFormat && utils.convert( textureFormat ) !== _gl.getParameter( _gl.IMPLEMENTATION_COLOR_READ_FORMAT ) ) {

						console.error( 'THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.' );
						return;

					}

					const halfFloatSupportedByExt = ( textureType === HalfFloatType ) && ( extensions.has( 'EXT_color_buffer_half_float' ) || extensions.has( 'EXT_color_buffer_float' ) );

					if ( textureType !== UnsignedByteType && utils.convert( textureType ) !== _gl.getParameter( _gl.IMPLEMENTATION_COLOR_READ_TYPE ) && // Edge and Chrome Mac < 52 (#9513)
						textureType !== FloatType && ! halfFloatSupportedByExt ) {

						console.error( 'THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.' );
						return;

					}

					// the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)

					if ( ( x >= 0 && x <= ( renderTarget.width - width ) ) && ( y >= 0 && y <= ( renderTarget.height - height ) ) ) {

						_gl.readPixels( x, y, width, height, utils.convert( textureFormat ), utils.convert( textureType ), buffer );

					}

				} finally {

					// restore framebuffer of current render target if necessary

					const framebuffer = ( _currentRenderTarget !== null ) ? properties.get( _currentRenderTarget ).__webglFramebuffer : null;
					state.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );

				}

			}

		};

		this.copyFramebufferToTexture = function ( position, texture, level = 0 ) {

			const levelScale = Math.pow( 2, - level );
			const width = Math.floor( texture.image.width * levelScale );
			const height = Math.floor( texture.image.height * levelScale );

			textures.setTexture2D( texture, 0 );

			_gl.copyTexSubImage2D( _gl.TEXTURE_2D, level, 0, 0, position.x, position.y, width, height );

			state.unbindTexture();

		};

		this.copyTextureToTexture = function ( position, srcTexture, dstTexture, level = 0 ) {

			const width = srcTexture.image.width;
			const height = srcTexture.image.height;
			const glFormat = utils.convert( dstTexture.format );
			const glType = utils.convert( dstTexture.type );

			textures.setTexture2D( dstTexture, 0 );

			// As another texture upload may have changed pixelStorei
			// parameters, make sure they are correct for the dstTexture
			_gl.pixelStorei( _gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY );
			_gl.pixelStorei( _gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha );
			_gl.pixelStorei( _gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment );

			if ( srcTexture.isDataTexture ) {

				_gl.texSubImage2D( _gl.TEXTURE_2D, level, position.x, position.y, width, height, glFormat, glType, srcTexture.image.data );

			} else {

				if ( srcTexture.isCompressedTexture ) {

					_gl.compressedTexSubImage2D( _gl.TEXTURE_2D, level, position.x, position.y, srcTexture.mipmaps[ 0 ].width, srcTexture.mipmaps[ 0 ].height, glFormat, srcTexture.mipmaps[ 0 ].data );

				} else {

					_gl.texSubImage2D( _gl.TEXTURE_2D, level, position.x, position.y, glFormat, glType, srcTexture.image );

				}

			}

			// Generate mipmaps only when copying level 0
			if ( level === 0 && dstTexture.generateMipmaps ) _gl.generateMipmap( _gl.TEXTURE_2D );

			state.unbindTexture();

		};

		this.copyTextureToTexture3D = function ( sourceBox, position, srcTexture, dstTexture, level = 0 ) {

			const width = Math.round( sourceBox.max.x - sourceBox.min.x );
			const height = Math.round( sourceBox.max.y - sourceBox.min.y );
			const depth = sourceBox.max.z - sourceBox.min.z + 1;
			const glFormat = utils.convert( dstTexture.format );
			const glType = utils.convert( dstTexture.type );
			let glTarget;

			if ( dstTexture.isData3DTexture ) {

				textures.setTexture3D( dstTexture, 0 );
				glTarget = _gl.TEXTURE_3D;

			} else if ( dstTexture.isDataArrayTexture || dstTexture.isCompressedArrayTexture ) {

				textures.setTexture2DArray( dstTexture, 0 );
				glTarget = _gl.TEXTURE_2D_ARRAY;

			} else {

				console.warn( 'THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.' );
				return;

			}

			_gl.pixelStorei( _gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY );
			_gl.pixelStorei( _gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha );
			_gl.pixelStorei( _gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment );

			const unpackRowLen = _gl.getParameter( _gl.UNPACK_ROW_LENGTH );
			const unpackImageHeight = _gl.getParameter( _gl.UNPACK_IMAGE_HEIGHT );
			const unpackSkipPixels = _gl.getParameter( _gl.UNPACK_SKIP_PIXELS );
			const unpackSkipRows = _gl.getParameter( _gl.UNPACK_SKIP_ROWS );
			const unpackSkipImages = _gl.getParameter( _gl.UNPACK_SKIP_IMAGES );

			const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[ level ] : srcTexture.image;

			_gl.pixelStorei( _gl.UNPACK_ROW_LENGTH, image.width );
			_gl.pixelStorei( _gl.UNPACK_IMAGE_HEIGHT, image.height );
			_gl.pixelStorei( _gl.UNPACK_SKIP_PIXELS, sourceBox.min.x );
			_gl.pixelStorei( _gl.UNPACK_SKIP_ROWS, sourceBox.min.y );
			_gl.pixelStorei( _gl.UNPACK_SKIP_IMAGES, sourceBox.min.z );

			if ( srcTexture.isDataTexture || srcTexture.isData3DTexture ) {

				_gl.texSubImage3D( glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image.data );

			} else {

				if ( dstTexture.isCompressedArrayTexture ) {

					_gl.compressedTexSubImage3D( glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, image.data );

				} else {

					_gl.texSubImage3D( glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image );

				}

			}

			_gl.pixelStorei( _gl.UNPACK_ROW_LENGTH, unpackRowLen );
			_gl.pixelStorei( _gl.UNPACK_IMAGE_HEIGHT, unpackImageHeight );
			_gl.pixelStorei( _gl.UNPACK_SKIP_PIXELS, unpackSkipPixels );
			_gl.pixelStorei( _gl.UNPACK_SKIP_ROWS, unpackSkipRows );
			_gl.pixelStorei( _gl.UNPACK_SKIP_IMAGES, unpackSkipImages );

			// Generate mipmaps only when copying level 0
			if ( level === 0 && dstTexture.generateMipmaps ) _gl.generateMipmap( glTarget );

			state.unbindTexture();

		};

		this.initTexture = function ( texture ) {

			if ( texture.isCubeTexture ) {

				textures.setTextureCube( texture, 0 );

			} else if ( texture.isData3DTexture ) {

				textures.setTexture3D( texture, 0 );

			} else if ( texture.isDataArrayTexture || texture.isCompressedArrayTexture ) {

				textures.setTexture2DArray( texture, 0 );

			} else {

				textures.setTexture2D( texture, 0 );

			}

			state.unbindTexture();

		};

		this.resetState = function () {

			_currentActiveCubeFace = 0;
			_currentActiveMipmapLevel = 0;
			_currentRenderTarget = null;

			state.reset();
			bindingStates.reset();

		};

		if ( typeof __THREE_DEVTOOLS__ !== 'undefined' ) {

			__THREE_DEVTOOLS__.dispatchEvent( new CustomEvent( 'observe', { detail: this } ) );

		}

	}

	get coordinateSystem() {

		return WebGLCoordinateSystem;

	}

	get outputColorSpace() {

		return this._outputColorSpace;

	}

	set outputColorSpace( colorSpace ) {

		this._outputColorSpace = colorSpace;

		const gl = this.getContext();
		gl.drawingBufferColorSpace = colorSpace === DisplayP3ColorSpace ? 'display-p3' : 'srgb';
		gl.unpackColorSpace = ColorManagement.workingColorSpace === LinearDisplayP3ColorSpace ? 'display-p3' : 'srgb';

	}

	get useLegacyLights() { // @deprecated, r155

		console.warn( 'THREE.WebGLRenderer: The property .useLegacyLights has been deprecated. Migrate your lighting according to the following guide: https://discourse.threejs.org/t/updates-to-lighting-in-three-js-r155/53733.' );
		return this._useLegacyLights;

	}

	set useLegacyLights( value ) { // @deprecated, r155

		console.warn( 'THREE.WebGLRenderer: The property .useLegacyLights has been deprecated. Migrate your lighting according to the following guide: https://discourse.threejs.org/t/updates-to-lighting-in-three-js-r155/53733.' );
		this._useLegacyLights = value;

	}

}

class FogExp2 {

	constructor( color, density = 0.00025 ) {

		this.isFogExp2 = true;

		this.name = '';

		this.color = new Color( color );
		this.density = density;

	}

	clone() {

		return new FogExp2( this.color, this.density );

	}

	toJSON( /* meta */ ) {

		return {
			type: 'FogExp2',
			name: this.name,
			color: this.color.getHex(),
			density: this.density
		};

	}

}

class Fog {

	constructor( color, near = 1, far = 1000 ) {

		this.isFog = true;

		this.name = '';

		this.color = new Color( color );

		this.near = near;
		this.far = far;

	}

	clone() {

		return new Fog( this.color, this.near, this.far );

	}

	toJSON( /* meta */ ) {

		return {
			type: 'Fog',
			name: this.name,
			color: this.color.getHex(),
			near: this.near,
			far: this.far
		};

	}

}

class Scene extends (/* unused pure expression or super */ null && (Object3D)) {

	constructor() {

		super();

		this.isScene = true;

		this.type = 'Scene';

		this.background = null;
		this.environment = null;
		this.fog = null;

		this.backgroundBlurriness = 0;
		this.backgroundIntensity = 1;
		this.backgroundRotation = new Euler();

		this.environmentIntensity = 1;
		this.environmentRotation = new Euler();

		this.overrideMaterial = null;

		if ( typeof __THREE_DEVTOOLS__ !== 'undefined' ) {

			__THREE_DEVTOOLS__.dispatchEvent( new CustomEvent( 'observe', { detail: this } ) );

		}

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		if ( source.background !== null ) this.background = source.background.clone();
		if ( source.environment !== null ) this.environment = source.environment.clone();
		if ( source.fog !== null ) this.fog = source.fog.clone();

		this.backgroundBlurriness = source.backgroundBlurriness;
		this.backgroundIntensity = source.backgroundIntensity;
		this.backgroundRotation.copy( source.backgroundRotation );

		this.environmentIntensity = source.environmentIntensity;
		this.environmentRotation.copy( source.environmentRotation );

		if ( source.overrideMaterial !== null ) this.overrideMaterial = source.overrideMaterial.clone();

		this.matrixAutoUpdate = source.matrixAutoUpdate;

		return this;

	}

	toJSON( meta ) {

		const data = super.toJSON( meta );

		if ( this.fog !== null ) data.object.fog = this.fog.toJSON();

		if ( this.backgroundBlurriness > 0 ) data.object.backgroundBlurriness = this.backgroundBlurriness;
		if ( this.backgroundIntensity !== 1 ) data.object.backgroundIntensity = this.backgroundIntensity;
		data.object.backgroundRotation = this.backgroundRotation.toArray();

		if ( this.environmentIntensity !== 1 ) data.object.environmentIntensity = this.environmentIntensity;
		data.object.environmentRotation = this.environmentRotation.toArray();

		return data;

	}

}

class InterleavedBuffer {

	constructor( array, stride ) {

		this.isInterleavedBuffer = true;

		this.array = array;
		this.stride = stride;
		this.count = array !== undefined ? array.length / stride : 0;

		this.usage = StaticDrawUsage;
		this._updateRange = { offset: 0, count: - 1 };
		this.updateRanges = [];

		this.version = 0;

		this.uuid = generateUUID();

	}

	onUploadCallback() {}

	set needsUpdate( value ) {

		if ( value === true ) this.version ++;

	}

	get updateRange() {

		warnOnce( 'THREE.InterleavedBuffer: updateRange() is deprecated and will be removed in r169. Use addUpdateRange() instead.' ); // @deprecated, r159
		return this._updateRange;

	}

	setUsage( value ) {

		this.usage = value;

		return this;

	}

	addUpdateRange( start, count ) {

		this.updateRanges.push( { start, count } );

	}

	clearUpdateRanges() {

		this.updateRanges.length = 0;

	}

	copy( source ) {

		this.array = new source.array.constructor( source.array );
		this.count = source.count;
		this.stride = source.stride;
		this.usage = source.usage;

		return this;

	}

	copyAt( index1, attribute, index2 ) {

		index1 *= this.stride;
		index2 *= attribute.stride;

		for ( let i = 0, l = this.stride; i < l; i ++ ) {

			this.array[ index1 + i ] = attribute.array[ index2 + i ];

		}

		return this;

	}

	set( value, offset = 0 ) {

		this.array.set( value, offset );

		return this;

	}

	clone( data ) {

		if ( data.arrayBuffers === undefined ) {

			data.arrayBuffers = {};

		}

		if ( this.array.buffer._uuid === undefined ) {

			this.array.buffer._uuid = generateUUID();

		}

		if ( data.arrayBuffers[ this.array.buffer._uuid ] === undefined ) {

			data.arrayBuffers[ this.array.buffer._uuid ] = this.array.slice( 0 ).buffer;

		}

		const array = new this.array.constructor( data.arrayBuffers[ this.array.buffer._uuid ] );

		const ib = new this.constructor( array, this.stride );
		ib.setUsage( this.usage );

		return ib;

	}

	onUpload( callback ) {

		this.onUploadCallback = callback;

		return this;

	}

	toJSON( data ) {

		if ( data.arrayBuffers === undefined ) {

			data.arrayBuffers = {};

		}

		// generate UUID for array buffer if necessary

		if ( this.array.buffer._uuid === undefined ) {

			this.array.buffer._uuid = generateUUID();

		}

		if ( data.arrayBuffers[ this.array.buffer._uuid ] === undefined ) {

			data.arrayBuffers[ this.array.buffer._uuid ] = Array.from( new Uint32Array( this.array.buffer ) );

		}

		//

		return {
			uuid: this.uuid,
			buffer: this.array.buffer._uuid,
			type: this.array.constructor.name,
			stride: this.stride
		};

	}

}

const _vector$6 = /*@__PURE__*/ new Vector3();

class InterleavedBufferAttribute {

	constructor( interleavedBuffer, itemSize, offset, normalized = false ) {

		this.isInterleavedBufferAttribute = true;

		this.name = '';

		this.data = interleavedBuffer;
		this.itemSize = itemSize;
		this.offset = offset;

		this.normalized = normalized;

	}

	get count() {

		return this.data.count;

	}

	get array() {

		return this.data.array;

	}

	set needsUpdate( value ) {

		this.data.needsUpdate = value;

	}

	applyMatrix4( m ) {

		for ( let i = 0, l = this.data.count; i < l; i ++ ) {

			_vector$6.fromBufferAttribute( this, i );

			_vector$6.applyMatrix4( m );

			this.setXYZ( i, _vector$6.x, _vector$6.y, _vector$6.z );

		}

		return this;

	}

	applyNormalMatrix( m ) {

		for ( let i = 0, l = this.count; i < l; i ++ ) {

			_vector$6.fromBufferAttribute( this, i );

			_vector$6.applyNormalMatrix( m );

			this.setXYZ( i, _vector$6.x, _vector$6.y, _vector$6.z );

		}

		return this;

	}

	transformDirection( m ) {

		for ( let i = 0, l = this.count; i < l; i ++ ) {

			_vector$6.fromBufferAttribute( this, i );

			_vector$6.transformDirection( m );

			this.setXYZ( i, _vector$6.x, _vector$6.y, _vector$6.z );

		}

		return this;

	}

	getComponent( index, component ) {

		let value = this.array[ index * this.data.stride + this.offset + component ];

		if ( this.normalized ) value = denormalize( value, this.array );

		return value;

	}

	setComponent( index, component, value ) {

		if ( this.normalized ) value = normalize( value, this.array );

		this.data.array[ index * this.data.stride + this.offset + component ] = value;

		return this;

	}

	setX( index, x ) {

		if ( this.normalized ) x = normalize( x, this.array );

		this.data.array[ index * this.data.stride + this.offset ] = x;

		return this;

	}

	setY( index, y ) {

		if ( this.normalized ) y = normalize( y, this.array );

		this.data.array[ index * this.data.stride + this.offset + 1 ] = y;

		return this;

	}

	setZ( index, z ) {

		if ( this.normalized ) z = normalize( z, this.array );

		this.data.array[ index * this.data.stride + this.offset + 2 ] = z;

		return this;

	}

	setW( index, w ) {

		if ( this.normalized ) w = normalize( w, this.array );

		this.data.array[ index * this.data.stride + this.offset + 3 ] = w;

		return this;

	}

	getX( index ) {

		let x = this.data.array[ index * this.data.stride + this.offset ];

		if ( this.normalized ) x = denormalize( x, this.array );

		return x;

	}

	getY( index ) {

		let y = this.data.array[ index * this.data.stride + this.offset + 1 ];

		if ( this.normalized ) y = denormalize( y, this.array );

		return y;

	}

	getZ( index ) {

		let z = this.data.array[ index * this.data.stride + this.offset + 2 ];

		if ( this.normalized ) z = denormalize( z, this.array );

		return z;

	}

	getW( index ) {

		let w = this.data.array[ index * this.data.stride + this.offset + 3 ];

		if ( this.normalized ) w = denormalize( w, this.array );

		return w;

	}

	setXY( index, x, y ) {

		index = index * this.data.stride + this.offset;

		if ( this.normalized ) {

			x = normalize( x, this.array );
			y = normalize( y, this.array );

		}

		this.data.array[ index + 0 ] = x;
		this.data.array[ index + 1 ] = y;

		return this;

	}

	setXYZ( index, x, y, z ) {

		index = index * this.data.stride + this.offset;

		if ( this.normalized ) {

			x = normalize( x, this.array );
			y = normalize( y, this.array );
			z = normalize( z, this.array );

		}

		this.data.array[ index + 0 ] = x;
		this.data.array[ index + 1 ] = y;
		this.data.array[ index + 2 ] = z;

		return this;

	}

	setXYZW( index, x, y, z, w ) {

		index = index * this.data.stride + this.offset;

		if ( this.normalized ) {

			x = normalize( x, this.array );
			y = normalize( y, this.array );
			z = normalize( z, this.array );
			w = normalize( w, this.array );

		}

		this.data.array[ index + 0 ] = x;
		this.data.array[ index + 1 ] = y;
		this.data.array[ index + 2 ] = z;
		this.data.array[ index + 3 ] = w;

		return this;

	}

	clone( data ) {

		if ( data === undefined ) {

			console.log( 'THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.' );

			const array = [];

			for ( let i = 0; i < this.count; i ++ ) {

				const index = i * this.data.stride + this.offset;

				for ( let j = 0; j < this.itemSize; j ++ ) {

					array.push( this.data.array[ index + j ] );

				}

			}

			return new BufferAttribute( new this.array.constructor( array ), this.itemSize, this.normalized );

		} else {

			if ( data.interleavedBuffers === undefined ) {

				data.interleavedBuffers = {};

			}

			if ( data.interleavedBuffers[ this.data.uuid ] === undefined ) {

				data.interleavedBuffers[ this.data.uuid ] = this.data.clone( data );

			}

			return new InterleavedBufferAttribute( data.interleavedBuffers[ this.data.uuid ], this.itemSize, this.offset, this.normalized );

		}

	}

	toJSON( data ) {

		if ( data === undefined ) {

			console.log( 'THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.' );

			const array = [];

			for ( let i = 0; i < this.count; i ++ ) {

				const index = i * this.data.stride + this.offset;

				for ( let j = 0; j < this.itemSize; j ++ ) {

					array.push( this.data.array[ index + j ] );

				}

			}

			// de-interleave data and save it as an ordinary buffer attribute for now

			return {
				itemSize: this.itemSize,
				type: this.array.constructor.name,
				array: array,
				normalized: this.normalized
			};

		} else {

			// save as true interleaved attribute

			if ( data.interleavedBuffers === undefined ) {

				data.interleavedBuffers = {};

			}

			if ( data.interleavedBuffers[ this.data.uuid ] === undefined ) {

				data.interleavedBuffers[ this.data.uuid ] = this.data.toJSON( data );

			}

			return {
				isInterleavedBufferAttribute: true,
				itemSize: this.itemSize,
				data: this.data.uuid,
				offset: this.offset,
				normalized: this.normalized
			};

		}

	}

}

class SpriteMaterial extends (/* unused pure expression or super */ null && (Material)) {

	constructor( parameters ) {

		super();

		this.isSpriteMaterial = true;

		this.type = 'SpriteMaterial';

		this.color = new Color( 0xffffff );

		this.map = null;

		this.alphaMap = null;

		this.rotation = 0;

		this.sizeAttenuation = true;

		this.transparent = true;

		this.fog = true;

		this.setValues( parameters );

	}

	copy( source ) {

		super.copy( source );

		this.color.copy( source.color );

		this.map = source.map;

		this.alphaMap = source.alphaMap;

		this.rotation = source.rotation;

		this.sizeAttenuation = source.sizeAttenuation;

		this.fog = source.fog;

		return this;

	}

}

let _geometry;

const _intersectPoint = /*@__PURE__*/ new Vector3();
const _worldScale = /*@__PURE__*/ new Vector3();
const _mvPosition = /*@__PURE__*/ new Vector3();

const _alignedPosition = /*@__PURE__*/ new Vector2();
const _rotatedPosition = /*@__PURE__*/ new Vector2();
const _viewWorldMatrix = /*@__PURE__*/ new Matrix4();

const _vA = /*@__PURE__*/ new Vector3();
const _vB = /*@__PURE__*/ new Vector3();
const _vC = /*@__PURE__*/ new Vector3();

const _uvA = /*@__PURE__*/ new Vector2();
const _uvB = /*@__PURE__*/ new Vector2();
const _uvC = /*@__PURE__*/ new Vector2();

class Sprite extends (/* unused pure expression or super */ null && (Object3D)) {

	constructor( material = new SpriteMaterial() ) {

		super();

		this.isSprite = true;

		this.type = 'Sprite';

		if ( _geometry === undefined ) {

			_geometry = new BufferGeometry();

			const float32Array = new Float32Array( [
				- 0.5, - 0.5, 0, 0, 0,
				0.5, - 0.5, 0, 1, 0,
				0.5, 0.5, 0, 1, 1,
				- 0.5, 0.5, 0, 0, 1
			] );

			const interleavedBuffer = new InterleavedBuffer( float32Array, 5 );

			_geometry.setIndex( [ 0, 1, 2,	0, 2, 3 ] );
			_geometry.setAttribute( 'position', new InterleavedBufferAttribute( interleavedBuffer, 3, 0, false ) );
			_geometry.setAttribute( 'uv', new InterleavedBufferAttribute( interleavedBuffer, 2, 3, false ) );

		}

		this.geometry = _geometry;
		this.material = material;

		this.center = new Vector2( 0.5, 0.5 );

	}

	raycast( raycaster, intersects ) {

		if ( raycaster.camera === null ) {

			console.error( 'THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.' );

		}

		_worldScale.setFromMatrixScale( this.matrixWorld );

		_viewWorldMatrix.copy( raycaster.camera.matrixWorld );
		this.modelViewMatrix.multiplyMatrices( raycaster.camera.matrixWorldInverse, this.matrixWorld );

		_mvPosition.setFromMatrixPosition( this.modelViewMatrix );

		if ( raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false ) {

			_worldScale.multiplyScalar( - _mvPosition.z );

		}

		const rotation = this.material.rotation;
		let sin, cos;

		if ( rotation !== 0 ) {

			cos = Math.cos( rotation );
			sin = Math.sin( rotation );

		}

		const center = this.center;

		transformVertex( _vA.set( - 0.5, - 0.5, 0 ), _mvPosition, center, _worldScale, sin, cos );
		transformVertex( _vB.set( 0.5, - 0.5, 0 ), _mvPosition, center, _worldScale, sin, cos );
		transformVertex( _vC.set( 0.5, 0.5, 0 ), _mvPosition, center, _worldScale, sin, cos );

		_uvA.set( 0, 0 );
		_uvB.set( 1, 0 );
		_uvC.set( 1, 1 );

		// check first triangle
		let intersect = raycaster.ray.intersectTriangle( _vA, _vB, _vC, false, _intersectPoint );

		if ( intersect === null ) {

			// check second triangle
			transformVertex( _vB.set( - 0.5, 0.5, 0 ), _mvPosition, center, _worldScale, sin, cos );
			_uvB.set( 0, 1 );

			intersect = raycaster.ray.intersectTriangle( _vA, _vC, _vB, false, _intersectPoint );
			if ( intersect === null ) {

				return;

			}

		}

		const distance = raycaster.ray.origin.distanceTo( _intersectPoint );

		if ( distance < raycaster.near || distance > raycaster.far ) return;

		intersects.push( {

			distance: distance,
			point: _intersectPoint.clone(),
			uv: Triangle.getInterpolation( _intersectPoint, _vA, _vB, _vC, _uvA, _uvB, _uvC, new Vector2() ),
			face: null,
			object: this

		} );

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		if ( source.center !== undefined ) this.center.copy( source.center );

		this.material = source.material;

		return this;

	}

}

function transformVertex( vertexPosition, mvPosition, center, scale, sin, cos ) {

	// compute position in camera space
	_alignedPosition.subVectors( vertexPosition, center ).addScalar( 0.5 ).multiply( scale );

	// to check if rotation is not zero
	if ( sin !== undefined ) {

		_rotatedPosition.x = ( cos * _alignedPosition.x ) - ( sin * _alignedPosition.y );
		_rotatedPosition.y = ( sin * _alignedPosition.x ) + ( cos * _alignedPosition.y );

	} else {

		_rotatedPosition.copy( _alignedPosition );

	}


	vertexPosition.copy( mvPosition );
	vertexPosition.x += _rotatedPosition.x;
	vertexPosition.y += _rotatedPosition.y;

	// transform to world space
	vertexPosition.applyMatrix4( _viewWorldMatrix );

}

const _v1$2 = /*@__PURE__*/ new Vector3();
const _v2$1 = /*@__PURE__*/ new Vector3();

class LOD extends (/* unused pure expression or super */ null && (Object3D)) {

	constructor() {

		super();

		this._currentLevel = 0;

		this.type = 'LOD';

		Object.defineProperties( this, {
			levels: {
				enumerable: true,
				value: []
			},
			isLOD: {
				value: true,
			}
		} );

		this.autoUpdate = true;

	}

	copy( source ) {

		super.copy( source, false );

		const levels = source.levels;

		for ( let i = 0, l = levels.length; i < l; i ++ ) {

			const level = levels[ i ];

			this.addLevel( level.object.clone(), level.distance, level.hysteresis );

		}

		this.autoUpdate = source.autoUpdate;

		return this;

	}

	addLevel( object, distance = 0, hysteresis = 0 ) {

		distance = Math.abs( distance );

		const levels = this.levels;

		let l;

		for ( l = 0; l < levels.length; l ++ ) {

			if ( distance < levels[ l ].distance ) {

				break;

			}

		}

		levels.splice( l, 0, { distance: distance, hysteresis: hysteresis, object: object } );

		this.add( object );

		return this;

	}

	getCurrentLevel() {

		return this._currentLevel;

	}



	getObjectForDistance( distance ) {

		const levels = this.levels;

		if ( levels.length > 0 ) {

			let i, l;

			for ( i = 1, l = levels.length; i < l; i ++ ) {

				let levelDistance = levels[ i ].distance;

				if ( levels[ i ].object.visible ) {

					levelDistance -= levelDistance * levels[ i ].hysteresis;

				}

				if ( distance < levelDistance ) {

					break;

				}

			}

			return levels[ i - 1 ].object;

		}

		return null;

	}

	raycast( raycaster, intersects ) {

		const levels = this.levels;

		if ( levels.length > 0 ) {

			_v1$2.setFromMatrixPosition( this.matrixWorld );

			const distance = raycaster.ray.origin.distanceTo( _v1$2 );

			this.getObjectForDistance( distance ).raycast( raycaster, intersects );

		}

	}

	update( camera ) {

		const levels = this.levels;

		if ( levels.length > 1 ) {

			_v1$2.setFromMatrixPosition( camera.matrixWorld );
			_v2$1.setFromMatrixPosition( this.matrixWorld );

			const distance = _v1$2.distanceTo( _v2$1 ) / camera.zoom;

			levels[ 0 ].object.visible = true;

			let i, l;

			for ( i = 1, l = levels.length; i < l; i ++ ) {

				let levelDistance = levels[ i ].distance;

				if ( levels[ i ].object.visible ) {

					levelDistance -= levelDistance * levels[ i ].hysteresis;

				}

				if ( distance >= levelDistance ) {

					levels[ i - 1 ].object.visible = false;
					levels[ i ].object.visible = true;

				} else {

					break;

				}

			}

			this._currentLevel = i - 1;

			for ( ; i < l; i ++ ) {

				levels[ i ].object.visible = false;

			}

		}

	}

	toJSON( meta ) {

		const data = super.toJSON( meta );

		if ( this.autoUpdate === false ) data.object.autoUpdate = false;

		data.object.levels = [];

		const levels = this.levels;

		for ( let i = 0, l = levels.length; i < l; i ++ ) {

			const level = levels[ i ];

			data.object.levels.push( {
				object: level.object.uuid,
				distance: level.distance,
				hysteresis: level.hysteresis
			} );

		}

		return data;

	}

}

const _basePosition = /*@__PURE__*/ new Vector3();

const _skinIndex = /*@__PURE__*/ new Vector4();
const _skinWeight = /*@__PURE__*/ new Vector4();

const _vector3 = /*@__PURE__*/ new Vector3();
const _matrix4 = /*@__PURE__*/ new Matrix4();
const _vertex = /*@__PURE__*/ new Vector3();

const _sphere$4 = /*@__PURE__*/ new Sphere();
const _inverseMatrix$2 = /*@__PURE__*/ new Matrix4();
const _ray$2 = /*@__PURE__*/ new Ray();

class SkinnedMesh extends (/* unused pure expression or super */ null && (Mesh)) {

	constructor( geometry, material ) {

		super( geometry, material );

		this.isSkinnedMesh = true;

		this.type = 'SkinnedMesh';

		this.bindMode = AttachedBindMode;
		this.bindMatrix = new Matrix4();
		this.bindMatrixInverse = new Matrix4();

		this.boundingBox = null;
		this.boundingSphere = null;

	}

	computeBoundingBox() {

		const geometry = this.geometry;

		if ( this.boundingBox === null ) {

			this.boundingBox = new Box3();

		}

		this.boundingBox.makeEmpty();

		const positionAttribute = geometry.getAttribute( 'position' );

		for ( let i = 0; i < positionAttribute.count; i ++ ) {

			this.getVertexPosition( i, _vertex );
			this.boundingBox.expandByPoint( _vertex );

		}

	}

	computeBoundingSphere() {

		const geometry = this.geometry;

		if ( this.boundingSphere === null ) {

			this.boundingSphere = new Sphere();

		}

		this.boundingSphere.makeEmpty();

		const positionAttribute = geometry.getAttribute( 'position' );

		for ( let i = 0; i < positionAttribute.count; i ++ ) {

			this.getVertexPosition( i, _vertex );
			this.boundingSphere.expandByPoint( _vertex );

		}

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		this.bindMode = source.bindMode;
		this.bindMatrix.copy( source.bindMatrix );
		this.bindMatrixInverse.copy( source.bindMatrixInverse );

		this.skeleton = source.skeleton;

		if ( source.boundingBox !== null ) this.boundingBox = source.boundingBox.clone();
		if ( source.boundingSphere !== null ) this.boundingSphere = source.boundingSphere.clone();

		return this;

	}

	raycast( raycaster, intersects ) {

		const material = this.material;
		const matrixWorld = this.matrixWorld;

		if ( material === undefined ) return;

		// test with bounding sphere in world space

		if ( this.boundingSphere === null ) this.computeBoundingSphere();

		_sphere$4.copy( this.boundingSphere );
		_sphere$4.applyMatrix4( matrixWorld );

		if ( raycaster.ray.intersectsSphere( _sphere$4 ) === false ) return;

		// convert ray to local space of skinned mesh

		_inverseMatrix$2.copy( matrixWorld ).invert();
		_ray$2.copy( raycaster.ray ).applyMatrix4( _inverseMatrix$2 );

		// test with bounding box in local space

		if ( this.boundingBox !== null ) {

			if ( _ray$2.intersectsBox( this.boundingBox ) === false ) return;

		}

		// test for intersections with geometry

		this._computeIntersections( raycaster, intersects, _ray$2 );

	}

	getVertexPosition( index, target ) {

		super.getVertexPosition( index, target );

		this.applyBoneTransform( index, target );

		return target;

	}

	bind( skeleton, bindMatrix ) {

		this.skeleton = skeleton;

		if ( bindMatrix === undefined ) {

			this.updateMatrixWorld( true );

			this.skeleton.calculateInverses();

			bindMatrix = this.matrixWorld;

		}

		this.bindMatrix.copy( bindMatrix );
		this.bindMatrixInverse.copy( bindMatrix ).invert();

	}

	pose() {

		this.skeleton.pose();

	}

	normalizeSkinWeights() {

		const vector = new Vector4();

		const skinWeight = this.geometry.attributes.skinWeight;

		for ( let i = 0, l = skinWeight.count; i < l; i ++ ) {

			vector.fromBufferAttribute( skinWeight, i );

			const scale = 1.0 / vector.manhattanLength();

			if ( scale !== Infinity ) {

				vector.multiplyScalar( scale );

			} else {

				vector.set( 1, 0, 0, 0 ); // do something reasonable

			}

			skinWeight.setXYZW( i, vector.x, vector.y, vector.z, vector.w );

		}

	}

	updateMatrixWorld( force ) {

		super.updateMatrixWorld( force );

		if ( this.bindMode === AttachedBindMode ) {

			this.bindMatrixInverse.copy( this.matrixWorld ).invert();

		} else if ( this.bindMode === DetachedBindMode ) {

			this.bindMatrixInverse.copy( this.bindMatrix ).invert();

		} else {

			console.warn( 'THREE.SkinnedMesh: Unrecognized bindMode: ' + this.bindMode );

		}

	}

	applyBoneTransform( index, vector ) {

		const skeleton = this.skeleton;
		const geometry = this.geometry;

		_skinIndex.fromBufferAttribute( geometry.attributes.skinIndex, index );
		_skinWeight.fromBufferAttribute( geometry.attributes.skinWeight, index );

		_basePosition.copy( vector ).applyMatrix4( this.bindMatrix );

		vector.set( 0, 0, 0 );

		for ( let i = 0; i < 4; i ++ ) {

			const weight = _skinWeight.getComponent( i );

			if ( weight !== 0 ) {

				const boneIndex = _skinIndex.getComponent( i );

				_matrix4.multiplyMatrices( skeleton.bones[ boneIndex ].matrixWorld, skeleton.boneInverses[ boneIndex ] );

				vector.addScaledVector( _vector3.copy( _basePosition ).applyMatrix4( _matrix4 ), weight );

			}

		}

		return vector.applyMatrix4( this.bindMatrixInverse );

	}

}

class Bone extends (/* unused pure expression or super */ null && (Object3D)) {

	constructor() {

		super();

		this.isBone = true;

		this.type = 'Bone';

	}

}

class DataTexture extends Texture {

	constructor( data = null, width = 1, height = 1, format, type, mapping, wrapS, wrapT, magFilter = NearestFilter, minFilter = NearestFilter, anisotropy, colorSpace ) {

		super( null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace );

		this.isDataTexture = true;

		this.image = { data: data, width: width, height: height };

		this.generateMipmaps = false;
		this.flipY = false;
		this.unpackAlignment = 1;

	}

}

const _offsetMatrix = /*@__PURE__*/ new Matrix4();
const _identityMatrix$1 = /*@__PURE__*/ new Matrix4();

class Skeleton {

	constructor( bones = [], boneInverses = [] ) {

		this.uuid = generateUUID();

		this.bones = bones.slice( 0 );
		this.boneInverses = boneInverses;
		this.boneMatrices = null;

		this.boneTexture = null;

		this.init();

	}

	init() {

		const bones = this.bones;
		const boneInverses = this.boneInverses;

		this.boneMatrices = new Float32Array( bones.length * 16 );

		// calculate inverse bone matrices if necessary

		if ( boneInverses.length === 0 ) {

			this.calculateInverses();

		} else {

			// handle special case

			if ( bones.length !== boneInverses.length ) {

				console.warn( 'THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.' );

				this.boneInverses = [];

				for ( let i = 0, il = this.bones.length; i < il; i ++ ) {

					this.boneInverses.push( new Matrix4() );

				}

			}

		}

	}

	calculateInverses() {

		this.boneInverses.length = 0;

		for ( let i = 0, il = this.bones.length; i < il; i ++ ) {

			const inverse = new Matrix4();

			if ( this.bones[ i ] ) {

				inverse.copy( this.bones[ i ].matrixWorld ).invert();

			}

			this.boneInverses.push( inverse );

		}

	}

	pose() {

		// recover the bind-time world matrices

		for ( let i = 0, il = this.bones.length; i < il; i ++ ) {

			const bone = this.bones[ i ];

			if ( bone ) {

				bone.matrixWorld.copy( this.boneInverses[ i ] ).invert();

			}

		}

		// compute the local matrices, positions, rotations and scales

		for ( let i = 0, il = this.bones.length; i < il; i ++ ) {

			const bone = this.bones[ i ];

			if ( bone ) {

				if ( bone.parent && bone.parent.isBone ) {

					bone.matrix.copy( bone.parent.matrixWorld ).invert();
					bone.matrix.multiply( bone.matrixWorld );

				} else {

					bone.matrix.copy( bone.matrixWorld );

				}

				bone.matrix.decompose( bone.position, bone.quaternion, bone.scale );

			}

		}

	}

	update() {

		const bones = this.bones;
		const boneInverses = this.boneInverses;
		const boneMatrices = this.boneMatrices;
		const boneTexture = this.boneTexture;

		// flatten bone matrices to array

		for ( let i = 0, il = bones.length; i < il; i ++ ) {

			// compute the offset between the current and the original transform

			const matrix = bones[ i ] ? bones[ i ].matrixWorld : _identityMatrix$1;

			_offsetMatrix.multiplyMatrices( matrix, boneInverses[ i ] );
			_offsetMatrix.toArray( boneMatrices, i * 16 );

		}

		if ( boneTexture !== null ) {

			boneTexture.needsUpdate = true;

		}

	}

	clone() {

		return new Skeleton( this.bones, this.boneInverses );

	}

	computeBoneTexture() {

		// layout (1 matrix = 4 pixels)
		//      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
		//  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
		//       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
		//       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
		//       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)

		let size = Math.sqrt( this.bones.length * 4 ); // 4 pixels needed for 1 matrix
		size = Math.ceil( size / 4 ) * 4;
		size = Math.max( size, 4 );

		const boneMatrices = new Float32Array( size * size * 4 ); // 4 floats per RGBA pixel
		boneMatrices.set( this.boneMatrices ); // copy current values

		const boneTexture = new DataTexture( boneMatrices, size, size, RGBAFormat, FloatType );
		boneTexture.needsUpdate = true;

		this.boneMatrices = boneMatrices;
		this.boneTexture = boneTexture;

		return this;

	}

	getBoneByName( name ) {

		for ( let i = 0, il = this.bones.length; i < il; i ++ ) {

			const bone = this.bones[ i ];

			if ( bone.name === name ) {

				return bone;

			}

		}

		return undefined;

	}

	dispose( ) {

		if ( this.boneTexture !== null ) {

			this.boneTexture.dispose();

			this.boneTexture = null;

		}

	}

	fromJSON( json, bones ) {

		this.uuid = json.uuid;

		for ( let i = 0, l = json.bones.length; i < l; i ++ ) {

			const uuid = json.bones[ i ];
			let bone = bones[ uuid ];

			if ( bone === undefined ) {

				console.warn( 'THREE.Skeleton: No bone found with UUID:', uuid );
				bone = new Bone();

			}

			this.bones.push( bone );
			this.boneInverses.push( new Matrix4().fromArray( json.boneInverses[ i ] ) );

		}

		this.init();

		return this;

	}

	toJSON() {

		const data = {
			metadata: {
				version: 4.6,
				type: 'Skeleton',
				generator: 'Skeleton.toJSON'
			},
			bones: [],
			boneInverses: []
		};

		data.uuid = this.uuid;

		const bones = this.bones;
		const boneInverses = this.boneInverses;

		for ( let i = 0, l = bones.length; i < l; i ++ ) {

			const bone = bones[ i ];
			data.bones.push( bone.uuid );

			const boneInverse = boneInverses[ i ];
			data.boneInverses.push( boneInverse.toArray() );

		}

		return data;

	}

}

class InstancedBufferAttribute extends BufferAttribute {

	constructor( array, itemSize, normalized, meshPerAttribute = 1 ) {

		super( array, itemSize, normalized );

		this.isInstancedBufferAttribute = true;

		this.meshPerAttribute = meshPerAttribute;

	}

	copy( source ) {

		super.copy( source );

		this.meshPerAttribute = source.meshPerAttribute;

		return this;

	}

	toJSON() {

		const data = super.toJSON();

		data.meshPerAttribute = this.meshPerAttribute;

		data.isInstancedBufferAttribute = true;

		return data;

	}

}

const _instanceLocalMatrix = /*@__PURE__*/ new Matrix4();
const _instanceWorldMatrix = /*@__PURE__*/ new Matrix4();

const _instanceIntersects = (/* unused pure expression or super */ null && ([]));

const _box3 = /*@__PURE__*/ new Box3();
const _identity = /*@__PURE__*/ new Matrix4();
const _mesh$1 = /*@__PURE__*/ new Mesh();
const _sphere$3 = /*@__PURE__*/ new Sphere();

class InstancedMesh extends (/* unused pure expression or super */ null && (Mesh)) {

	constructor( geometry, material, count ) {

		super( geometry, material );

		this.isInstancedMesh = true;

		this.instanceMatrix = new InstancedBufferAttribute( new Float32Array( count * 16 ), 16 );
		this.instanceColor = null;
		this.morphTexture = null;

		this.count = count;

		this.boundingBox = null;
		this.boundingSphere = null;

		for ( let i = 0; i < count; i ++ ) {

			this.setMatrixAt( i, _identity );

		}

	}

	computeBoundingBox() {

		const geometry = this.geometry;
		const count = this.count;

		if ( this.boundingBox === null ) {

			this.boundingBox = new Box3();

		}

		if ( geometry.boundingBox === null ) {

			geometry.computeBoundingBox();

		}

		this.boundingBox.makeEmpty();

		for ( let i = 0; i < count; i ++ ) {

			this.getMatrixAt( i, _instanceLocalMatrix );

			_box3.copy( geometry.boundingBox ).applyMatrix4( _instanceLocalMatrix );

			this.boundingBox.union( _box3 );

		}

	}

	computeBoundingSphere() {

		const geometry = this.geometry;
		const count = this.count;

		if ( this.boundingSphere === null ) {

			this.boundingSphere = new Sphere();

		}

		if ( geometry.boundingSphere === null ) {

			geometry.computeBoundingSphere();

		}

		this.boundingSphere.makeEmpty();

		for ( let i = 0; i < count; i ++ ) {

			this.getMatrixAt( i, _instanceLocalMatrix );

			_sphere$3.copy( geometry.boundingSphere ).applyMatrix4( _instanceLocalMatrix );

			this.boundingSphere.union( _sphere$3 );

		}

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		this.instanceMatrix.copy( source.instanceMatrix );

		if ( source.morphTexture !== null ) this.morphTexture = source.morphTexture.clone();
		if ( source.instanceColor !== null ) this.instanceColor = source.instanceColor.clone();

		this.count = source.count;

		if ( source.boundingBox !== null ) this.boundingBox = source.boundingBox.clone();
		if ( source.boundingSphere !== null ) this.boundingSphere = source.boundingSphere.clone();

		return this;

	}

	getColorAt( index, color ) {

		color.fromArray( this.instanceColor.array, index * 3 );

	}

	getMatrixAt( index, matrix ) {

		matrix.fromArray( this.instanceMatrix.array, index * 16 );

	}

	getMorphAt( index, object ) {

		const objectInfluences = object.morphTargetInfluences;

		const array = this.morphTexture.source.data.data;

		const len = objectInfluences.length + 1; // All influences + the baseInfluenceSum

		const dataIndex = index * len + 1; // Skip the baseInfluenceSum at the beginning

		for ( let i = 0; i < objectInfluences.length; i ++ ) {

			objectInfluences[ i ] = array[ dataIndex + i ];

		}

	}

	raycast( raycaster, intersects ) {

		const matrixWorld = this.matrixWorld;
		const raycastTimes = this.count;

		_mesh$1.geometry = this.geometry;
		_mesh$1.material = this.material;

		if ( _mesh$1.material === undefined ) return;

		// test with bounding sphere first

		if ( this.boundingSphere === null ) this.computeBoundingSphere();

		_sphere$3.copy( this.boundingSphere );
		_sphere$3.applyMatrix4( matrixWorld );

		if ( raycaster.ray.intersectsSphere( _sphere$3 ) === false ) return;

		// now test each instance

		for ( let instanceId = 0; instanceId < raycastTimes; instanceId ++ ) {

			// calculate the world matrix for each instance

			this.getMatrixAt( instanceId, _instanceLocalMatrix );

			_instanceWorldMatrix.multiplyMatrices( matrixWorld, _instanceLocalMatrix );

			// the mesh represents this single instance

			_mesh$1.matrixWorld = _instanceWorldMatrix;

			_mesh$1.raycast( raycaster, _instanceIntersects );

			// process the result of raycast

			for ( let i = 0, l = _instanceIntersects.length; i < l; i ++ ) {

				const intersect = _instanceIntersects[ i ];
				intersect.instanceId = instanceId;
				intersect.object = this;
				intersects.push( intersect );

			}

			_instanceIntersects.length = 0;

		}

	}

	setColorAt( index, color ) {

		if ( this.instanceColor === null ) {

			this.instanceColor = new InstancedBufferAttribute( new Float32Array( this.instanceMatrix.count * 3 ), 3 );

		}

		color.toArray( this.instanceColor.array, index * 3 );

	}

	setMatrixAt( index, matrix ) {

		matrix.toArray( this.instanceMatrix.array, index * 16 );

	}

	setMorphAt( index, object ) {

		const objectInfluences = object.morphTargetInfluences;

		const len = objectInfluences.length + 1; // morphBaseInfluence + all influences

		if ( this.morphTexture === null ) {

			this.morphTexture = new DataTexture( new Float32Array( len * this.count ), len, this.count, RedFormat, FloatType );

		}

		const array = this.morphTexture.source.data.data;

		let morphInfluencesSum = 0;

		for ( let i = 0; i < objectInfluences.length; i ++ ) {

			morphInfluencesSum += objectInfluences[ i ];

		}

		const morphBaseInfluence = this.geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;

		const dataIndex = len * index;

		array[ dataIndex ] = morphBaseInfluence;

		array.set( objectInfluences, dataIndex + 1 );

	}

	updateMorphTargets() {

	}

	dispose() {

		this.dispatchEvent( { type: 'dispose' } );

		if ( this.morphTexture !== null ) {

			this.morphTexture.dispose();
			this.morphTexture = null;

		}

		return this;

	}

}

function sortOpaque( a, b ) {

	return a.z - b.z;

}

function sortTransparent( a, b ) {

	return b.z - a.z;

}

class MultiDrawRenderList {

	constructor() {

		this.index = 0;
		this.pool = [];
		this.list = [];

	}

	push( drawRange, z ) {

		const pool = this.pool;
		const list = this.list;
		if ( this.index >= pool.length ) {

			pool.push( {

				start: - 1,
				count: - 1,
				z: - 1,

			} );

		}

		const item = pool[ this.index ];
		list.push( item );
		this.index ++;

		item.start = drawRange.start;
		item.count = drawRange.count;
		item.z = z;

	}

	reset() {

		this.list.length = 0;
		this.index = 0;

	}

}

const ID_ATTR_NAME = 'batchId';
const _matrix$1 = /*@__PURE__*/ new Matrix4();
const _invMatrixWorld = /*@__PURE__*/ new Matrix4();
const _identityMatrix = /*@__PURE__*/ new Matrix4();
const _projScreenMatrix$2 = /*@__PURE__*/ new Matrix4();
const _frustum = /*@__PURE__*/ new Frustum();
const _box$1 = /*@__PURE__*/ new Box3();
const _sphere$2 = /*@__PURE__*/ new Sphere();
const _vector$5 = /*@__PURE__*/ new Vector3();
const _renderList = /*@__PURE__*/ new MultiDrawRenderList();
const _mesh = /*@__PURE__*/ new Mesh();
const _batchIntersects = (/* unused pure expression or super */ null && ([]));

// @TODO: SkinnedMesh support?
// @TODO: geometry.groups support?
// @TODO: geometry.drawRange support?
// @TODO: geometry.morphAttributes support?
// @TODO: Support uniform parameter per geometry
// @TODO: Add an "optimize" function to pack geometry and remove data gaps

// copies data from attribute "src" into "target" starting at "targetOffset"
function copyAttributeData( src, target, targetOffset = 0 ) {

	const itemSize = target.itemSize;
	if ( src.isInterleavedBufferAttribute || src.array.constructor !== target.array.constructor ) {

		// use the component getters and setters if the array data cannot
		// be copied directly
		const vertexCount = src.count;
		for ( let i = 0; i < vertexCount; i ++ ) {

			for ( let c = 0; c < itemSize; c ++ ) {

				target.setComponent( i + targetOffset, c, src.getComponent( i, c ) );

			}

		}

	} else {

		// faster copy approach using typed array set function
		target.array.set( src.array, targetOffset * itemSize );

	}

	target.needsUpdate = true;

}

class BatchedMesh extends (/* unused pure expression or super */ null && (Mesh)) {

	get maxGeometryCount() {

		return this._maxGeometryCount;

	}

	constructor( maxGeometryCount, maxVertexCount, maxIndexCount = maxVertexCount * 2, material ) {

		super( new BufferGeometry(), material );

		this.isBatchedMesh = true;
		this.perObjectFrustumCulled = true;
		this.sortObjects = true;
		this.boundingBox = null;
		this.boundingSphere = null;
		this.customSort = null;

		this._drawRanges = [];
		this._reservedRanges = [];

		this._visibility = [];
		this._active = [];
		this._bounds = [];

		this._maxGeometryCount = maxGeometryCount;
		this._maxVertexCount = maxVertexCount;
		this._maxIndexCount = maxIndexCount;

		this._geometryInitialized = false;
		this._geometryCount = 0;
		this._multiDrawCounts = new Int32Array( maxGeometryCount );
		this._multiDrawStarts = new Int32Array( maxGeometryCount );
		this._multiDrawCount = 0;
		this._visibilityChanged = true;

		// Local matrix per geometry by using data texture
		this._matricesTexture = null;

		this._initMatricesTexture();

	}

	_initMatricesTexture() {

		// layout (1 matrix = 4 pixels)
		//      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
		//  with  8x8  pixel texture max   16 matrices * 4 pixels =  (8 * 8)
		//       16x16 pixel texture max   64 matrices * 4 pixels = (16 * 16)
		//       32x32 pixel texture max  256 matrices * 4 pixels = (32 * 32)
		//       64x64 pixel texture max 1024 matrices * 4 pixels = (64 * 64)

		let size = Math.sqrt( this._maxGeometryCount * 4 ); // 4 pixels needed for 1 matrix
		size = Math.ceil( size / 4 ) * 4;
		size = Math.max( size, 4 );

		const matricesArray = new Float32Array( size * size * 4 ); // 4 floats per RGBA pixel
		const matricesTexture = new DataTexture( matricesArray, size, size, RGBAFormat, FloatType );

		this._matricesTexture = matricesTexture;

	}

	_initializeGeometry( reference ) {

		const geometry = this.geometry;
		const maxVertexCount = this._maxVertexCount;
		const maxGeometryCount = this._maxGeometryCount;
		const maxIndexCount = this._maxIndexCount;
		if ( this._geometryInitialized === false ) {

			for ( const attributeName in reference.attributes ) {

				const srcAttribute = reference.getAttribute( attributeName );
				const { array, itemSize, normalized } = srcAttribute;

				const dstArray = new array.constructor( maxVertexCount * itemSize );
				const dstAttribute = new BufferAttribute( dstArray, itemSize, normalized );

				geometry.setAttribute( attributeName, dstAttribute );

			}

			if ( reference.getIndex() !== null ) {

				const indexArray = maxVertexCount > 65536
					? new Uint32Array( maxIndexCount )
					: new Uint16Array( maxIndexCount );

				geometry.setIndex( new BufferAttribute( indexArray, 1 ) );

			}

			const idArray = maxGeometryCount > 65536
				? new Uint32Array( maxVertexCount )
				: new Uint16Array( maxVertexCount );
			geometry.setAttribute( ID_ATTR_NAME, new BufferAttribute( idArray, 1 ) );

			this._geometryInitialized = true;

		}

	}

	// Make sure the geometry is compatible with the existing combined geometry attributes
	_validateGeometry( geometry ) {

		// check that the geometry doesn't have a version of our reserved id attribute
		if ( geometry.getAttribute( ID_ATTR_NAME ) ) {

			throw new Error( `BatchedMesh: Geometry cannot use attribute "${ ID_ATTR_NAME }"` );

		}

		// check to ensure the geometries are using consistent attributes and indices
		const batchGeometry = this.geometry;
		if ( Boolean( geometry.getIndex() ) !== Boolean( batchGeometry.getIndex() ) ) {

			throw new Error( 'BatchedMesh: All geometries must consistently have "index".' );

		}

		for ( const attributeName in batchGeometry.attributes ) {

			if ( attributeName === ID_ATTR_NAME ) {

				continue;

			}

			if ( ! geometry.hasAttribute( attributeName ) ) {

				throw new Error( `BatchedMesh: Added geometry missing "${ attributeName }". All geometries must have consistent attributes.` );

			}

			const srcAttribute = geometry.getAttribute( attributeName );
			const dstAttribute = batchGeometry.getAttribute( attributeName );
			if ( srcAttribute.itemSize !== dstAttribute.itemSize || srcAttribute.normalized !== dstAttribute.normalized ) {

				throw new Error( 'BatchedMesh: All attributes must have a consistent itemSize and normalized value.' );

			}

		}

	}

	setCustomSort( func ) {

		this.customSort = func;
		return this;

	}

	computeBoundingBox() {

		if ( this.boundingBox === null ) {

			this.boundingBox = new Box3();

		}

		const geometryCount = this._geometryCount;
		const boundingBox = this.boundingBox;
		const active = this._active;

		boundingBox.makeEmpty();
		for ( let i = 0; i < geometryCount; i ++ ) {

			if ( active[ i ] === false ) continue;

			this.getMatrixAt( i, _matrix$1 );
			this.getBoundingBoxAt( i, _box$1 ).applyMatrix4( _matrix$1 );
			boundingBox.union( _box$1 );

		}

	}

	computeBoundingSphere() {

		if ( this.boundingSphere === null ) {

			this.boundingSphere = new Sphere();

		}

		const geometryCount = this._geometryCount;
		const boundingSphere = this.boundingSphere;
		const active = this._active;

		boundingSphere.makeEmpty();
		for ( let i = 0; i < geometryCount; i ++ ) {

			if ( active[ i ] === false ) continue;

			this.getMatrixAt( i, _matrix$1 );
			this.getBoundingSphereAt( i, _sphere$2 ).applyMatrix4( _matrix$1 );
			boundingSphere.union( _sphere$2 );

		}

	}

	addGeometry( geometry, vertexCount = - 1, indexCount = - 1 ) {

		this._initializeGeometry( geometry );

		this._validateGeometry( geometry );

		// ensure we're not over geometry
		if ( this._geometryCount >= this._maxGeometryCount ) {

			throw new Error( 'BatchedMesh: Maximum geometry count reached.' );

		}

		// get the necessary range fo the geometry
		const reservedRange = {
			vertexStart: - 1,
			vertexCount: - 1,
			indexStart: - 1,
			indexCount: - 1,
		};

		let lastRange = null;
		const reservedRanges = this._reservedRanges;
		const drawRanges = this._drawRanges;
		const bounds = this._bounds;
		if ( this._geometryCount !== 0 ) {

			lastRange = reservedRanges[ reservedRanges.length - 1 ];

		}

		if ( vertexCount === - 1 ) {

			reservedRange.vertexCount = geometry.getAttribute( 'position' ).count;

		} else {

			reservedRange.vertexCount = vertexCount;

		}

		if ( lastRange === null ) {

			reservedRange.vertexStart = 0;

		} else {

			reservedRange.vertexStart = lastRange.vertexStart + lastRange.vertexCount;

		}

		const index = geometry.getIndex();
		const hasIndex = index !== null;
		if ( hasIndex ) {

			if ( indexCount	=== - 1 ) {

				reservedRange.indexCount = index.count;

			} else {

				reservedRange.indexCount = indexCount;

			}

			if ( lastRange === null ) {

				reservedRange.indexStart = 0;

			} else {

				reservedRange.indexStart = lastRange.indexStart + lastRange.indexCount;

			}

		}

		if (
			reservedRange.indexStart !== - 1 &&
			reservedRange.indexStart + reservedRange.indexCount > this._maxIndexCount ||
			reservedRange.vertexStart + reservedRange.vertexCount > this._maxVertexCount
		) {

			throw new Error( 'BatchedMesh: Reserved space request exceeds the maximum buffer size.' );

		}

		const visibility = this._visibility;
		const active = this._active;
		const matricesTexture = this._matricesTexture;
		const matricesArray = this._matricesTexture.image.data;

		// push new visibility states
		visibility.push( true );
		active.push( true );

		// update id
		const geometryId = this._geometryCount;
		this._geometryCount ++;

		// initialize matrix information
		_identityMatrix.toArray( matricesArray, geometryId * 16 );
		matricesTexture.needsUpdate = true;

		// add the reserved range and draw range objects
		reservedRanges.push( reservedRange );
		drawRanges.push( {
			start: hasIndex ? reservedRange.indexStart : reservedRange.vertexStart,
			count: - 1
		} );
		bounds.push( {
			boxInitialized: false,
			box: new Box3(),

			sphereInitialized: false,
			sphere: new Sphere()
		} );

		// set the id for the geometry
		const idAttribute = this.geometry.getAttribute( ID_ATTR_NAME );
		for ( let i = 0; i < reservedRange.vertexCount; i ++ ) {

			idAttribute.setX( reservedRange.vertexStart + i, geometryId );

		}

		idAttribute.needsUpdate = true;

		// update the geometry
		this.setGeometryAt( geometryId, geometry );

		return geometryId;

	}

	setGeometryAt( id, geometry ) {

		if ( id >= this._geometryCount ) {

			throw new Error( 'BatchedMesh: Maximum geometry count reached.' );

		}

		this._validateGeometry( geometry );

		const batchGeometry = this.geometry;
		const hasIndex = batchGeometry.getIndex() !== null;
		const dstIndex = batchGeometry.getIndex();
		const srcIndex = geometry.getIndex();
		const reservedRange = this._reservedRanges[ id ];
		if (
			hasIndex &&
			srcIndex.count > reservedRange.indexCount ||
			geometry.attributes.position.count > reservedRange.vertexCount
		) {

			throw new Error( 'BatchedMesh: Reserved space not large enough for provided geometry.' );

		}

		// copy geometry over
		const vertexStart = reservedRange.vertexStart;
		const vertexCount = reservedRange.vertexCount;
		for ( const attributeName in batchGeometry.attributes ) {

			if ( attributeName === ID_ATTR_NAME ) {

				continue;

			}

			// copy attribute data
			const srcAttribute = geometry.getAttribute( attributeName );
			const dstAttribute = batchGeometry.getAttribute( attributeName );
			copyAttributeData( srcAttribute, dstAttribute, vertexStart );

			// fill the rest in with zeroes
			const itemSize = srcAttribute.itemSize;
			for ( let i = srcAttribute.count, l = vertexCount; i < l; i ++ ) {

				const index = vertexStart + i;
				for ( let c = 0; c < itemSize; c ++ ) {

					dstAttribute.setComponent( index, c, 0 );

				}

			}

			dstAttribute.needsUpdate = true;
			dstAttribute.addUpdateRange( vertexStart * itemSize, vertexCount * itemSize );

		}

		// copy index
		if ( hasIndex ) {

			const indexStart = reservedRange.indexStart;

			// copy index data over
			for ( let i = 0; i < srcIndex.count; i ++ ) {

				dstIndex.setX( indexStart + i, vertexStart + srcIndex.getX( i ) );

			}

			// fill the rest in with zeroes
			for ( let i = srcIndex.count, l = reservedRange.indexCount; i < l; i ++ ) {

				dstIndex.setX( indexStart + i, vertexStart );

			}

			dstIndex.needsUpdate = true;
			dstIndex.addUpdateRange( indexStart, reservedRange.indexCount );

		}

		// store the bounding boxes
		const bound = this._bounds[ id ];
		if ( geometry.boundingBox !== null ) {

			bound.box.copy( geometry.boundingBox );
			bound.boxInitialized = true;

		} else {

			bound.boxInitialized = false;

		}

		if ( geometry.boundingSphere !== null ) {

			bound.sphere.copy( geometry.boundingSphere );
			bound.sphereInitialized = true;

		} else {

			bound.sphereInitialized = false;

		}

		// set drawRange count
		const drawRange = this._drawRanges[ id ];
		const posAttr = geometry.getAttribute( 'position' );
		drawRange.count = hasIndex ? srcIndex.count : posAttr.count;
		this._visibilityChanged = true;

		return id;

	}

	deleteGeometry( geometryId ) {

		// Note: User needs to call optimize() afterward to pack the data.

		const active = this._active;
		if ( geometryId >= active.length || active[ geometryId ] === false ) {

			return this;

		}

		active[ geometryId ] = false;
		this._visibilityChanged = true;

		return this;

	}

	// get bounding box and compute it if it doesn't exist
	getBoundingBoxAt( id, target ) {

		const active = this._active;
		if ( active[ id ] === false ) {

			return null;

		}

		// compute bounding box
		const bound = this._bounds[ id ];
		const box = bound.box;
		const geometry = this.geometry;
		if ( bound.boxInitialized === false ) {

			box.makeEmpty();

			const index = geometry.index;
			const position = geometry.attributes.position;
			const drawRange = this._drawRanges[ id ];
			for ( let i = drawRange.start, l = drawRange.start + drawRange.count; i < l; i ++ ) {

				let iv = i;
				if ( index ) {

					iv = index.getX( iv );

				}

				box.expandByPoint( _vector$5.fromBufferAttribute( position, iv ) );

			}

			bound.boxInitialized = true;

		}

		target.copy( box );
		return target;

	}

	// get bounding sphere and compute it if it doesn't exist
	getBoundingSphereAt( id, target ) {

		const active = this._active;
		if ( active[ id ] === false ) {

			return null;

		}

		// compute bounding sphere
		const bound = this._bounds[ id ];
		const sphere = bound.sphere;
		const geometry = this.geometry;
		if ( bound.sphereInitialized === false ) {

			sphere.makeEmpty();

			this.getBoundingBoxAt( id, _box$1 );
			_box$1.getCenter( sphere.center );

			const index = geometry.index;
			const position = geometry.attributes.position;
			const drawRange = this._drawRanges[ id ];

			let maxRadiusSq = 0;
			for ( let i = drawRange.start, l = drawRange.start + drawRange.count; i < l; i ++ ) {

				let iv = i;
				if ( index ) {

					iv = index.getX( iv );

				}

				_vector$5.fromBufferAttribute( position, iv );
				maxRadiusSq = Math.max( maxRadiusSq, sphere.center.distanceToSquared( _vector$5 ) );

			}

			sphere.radius = Math.sqrt( maxRadiusSq );
			bound.sphereInitialized = true;

		}

		target.copy( sphere );
		return target;

	}

	setMatrixAt( geometryId, matrix ) {

		// @TODO: Map geometryId to index of the arrays because
		//        optimize() can make geometryId mismatch the index

		const active = this._active;
		const matricesTexture = this._matricesTexture;
		const matricesArray = this._matricesTexture.image.data;
		const geometryCount = this._geometryCount;
		if ( geometryId >= geometryCount || active[ geometryId ] === false ) {

			return this;

		}

		matrix.toArray( matricesArray, geometryId * 16 );
		matricesTexture.needsUpdate = true;

		return this;

	}

	getMatrixAt( geometryId, matrix ) {

		const active = this._active;
		const matricesArray = this._matricesTexture.image.data;
		const geometryCount = this._geometryCount;
		if ( geometryId >= geometryCount || active[ geometryId ] === false ) {

			return null;

		}

		return matrix.fromArray( matricesArray, geometryId * 16 );

	}

	setVisibleAt( geometryId, value ) {

		const visibility = this._visibility;
		const active = this._active;
		const geometryCount = this._geometryCount;

		// if the geometry is out of range, not active, or visibility state
		// does not change then return early
		if (
			geometryId >= geometryCount ||
			active[ geometryId ] === false ||
			visibility[ geometryId ] === value
		) {

			return this;

		}

		visibility[ geometryId ] = value;
		this._visibilityChanged = true;

		return this;

	}

	getVisibleAt( geometryId ) {

		const visibility = this._visibility;
		const active = this._active;
		const geometryCount = this._geometryCount;

		// return early if the geometry is out of range or not active
		if ( geometryId >= geometryCount || active[ geometryId ] === false ) {

			return false;

		}

		return visibility[ geometryId ];

	}

	raycast( raycaster, intersects ) {

		const visibility = this._visibility;
		const active = this._active;
		const drawRanges = this._drawRanges;
		const geometryCount = this._geometryCount;
		const matrixWorld = this.matrixWorld;
		const batchGeometry = this.geometry;

		// iterate over each geometry
		_mesh.material = this.material;
		_mesh.geometry.index = batchGeometry.index;
		_mesh.geometry.attributes = batchGeometry.attributes;
		if ( _mesh.geometry.boundingBox === null ) {

			_mesh.geometry.boundingBox = new Box3();

		}

		if ( _mesh.geometry.boundingSphere === null ) {

			_mesh.geometry.boundingSphere = new Sphere();

		}

		for ( let i = 0; i < geometryCount; i ++ ) {

			if ( ! visibility[ i ] || ! active[ i ] ) {

				continue;

			}

			const drawRange = drawRanges[ i ];
			_mesh.geometry.setDrawRange( drawRange.start, drawRange.count );

			// ge the intersects
			this.getMatrixAt( i, _mesh.matrixWorld ).premultiply( matrixWorld );
			this.getBoundingBoxAt( i, _mesh.geometry.boundingBox );
			this.getBoundingSphereAt( i, _mesh.geometry.boundingSphere );
			_mesh.raycast( raycaster, _batchIntersects );

			// add batch id to the intersects
			for ( let j = 0, l = _batchIntersects.length; j < l; j ++ ) {

				const intersect = _batchIntersects[ j ];
				intersect.object = this;
				intersect.batchId = i;
				intersects.push( intersect );

			}

			_batchIntersects.length = 0;

		}

		_mesh.material = null;
		_mesh.geometry.index = null;
		_mesh.geometry.attributes = {};
		_mesh.geometry.setDrawRange( 0, Infinity );

	}

	copy( source ) {

		super.copy( source );

		this.geometry = source.geometry.clone();
		this.perObjectFrustumCulled = source.perObjectFrustumCulled;
		this.sortObjects = source.sortObjects;
		this.boundingBox = source.boundingBox !== null ? source.boundingBox.clone() : null;
		this.boundingSphere = source.boundingSphere !== null ? source.boundingSphere.clone() : null;

		this._drawRanges = source._drawRanges.map( range => ( { ...range } ) );
		this._reservedRanges = source._reservedRanges.map( range => ( { ...range } ) );

		this._visibility = source._visibility.slice();
		this._active = source._active.slice();
		this._bounds = source._bounds.map( bound => ( {
			boxInitialized: bound.boxInitialized,
			box: bound.box.clone(),

			sphereInitialized: bound.sphereInitialized,
			sphere: bound.sphere.clone()
		} ) );

		this._maxGeometryCount = source._maxGeometryCount;
		this._maxVertexCount = source._maxVertexCount;
		this._maxIndexCount = source._maxIndexCount;

		this._geometryInitialized = source._geometryInitialized;
		this._geometryCount = source._geometryCount;
		this._multiDrawCounts = source._multiDrawCounts.slice();
		this._multiDrawStarts = source._multiDrawStarts.slice();

		this._matricesTexture = source._matricesTexture.clone();
		this._matricesTexture.image.data = this._matricesTexture.image.slice();

		return this;

	}

	dispose() {

		// Assuming the geometry is not shared with other meshes
		this.geometry.dispose();

		this._matricesTexture.dispose();
		this._matricesTexture = null;
		return this;

	}

	onBeforeRender( renderer, scene, camera, geometry, material/*, _group*/ ) {

		// if visibility has not changed and frustum culling and object sorting is not required
		// then skip iterating over all items
		if ( ! this._visibilityChanged && ! this.perObjectFrustumCulled && ! this.sortObjects ) {

			return;

		}

		// the indexed version of the multi draw function requires specifying the start
		// offset in bytes.
		const index = geometry.getIndex();
		const bytesPerElement = index === null ? 1 : index.array.BYTES_PER_ELEMENT;

		const active = this._active;
		const visibility = this._visibility;
		const multiDrawStarts = this._multiDrawStarts;
		const multiDrawCounts = this._multiDrawCounts;
		const drawRanges = this._drawRanges;
		const perObjectFrustumCulled = this.perObjectFrustumCulled;

		// prepare the frustum in the local frame
		if ( perObjectFrustumCulled ) {

			_projScreenMatrix$2
				.multiplyMatrices( camera.projectionMatrix, camera.matrixWorldInverse )
				.multiply( this.matrixWorld );
			_frustum.setFromProjectionMatrix(
				_projScreenMatrix$2,
				renderer.coordinateSystem
			);

		}

		let count = 0;
		if ( this.sortObjects ) {

			// get the camera position in the local frame
			_invMatrixWorld.copy( this.matrixWorld ).invert();
			_vector$5.setFromMatrixPosition( camera.matrixWorld ).applyMatrix4( _invMatrixWorld );

			for ( let i = 0, l = visibility.length; i < l; i ++ ) {

				if ( visibility[ i ] && active[ i ] ) {

					// get the bounds in world space
					this.getMatrixAt( i, _matrix$1 );
					this.getBoundingSphereAt( i, _sphere$2 ).applyMatrix4( _matrix$1 );

					// determine whether the batched geometry is within the frustum
					let culled = false;
					if ( perObjectFrustumCulled ) {

						culled = ! _frustum.intersectsSphere( _sphere$2 );

					}

					if ( ! culled ) {

						// get the distance from camera used for sorting
						const z = _vector$5.distanceTo( _sphere$2.center );
						_renderList.push( drawRanges[ i ], z );

					}

				}

			}

			// Sort the draw ranges and prep for rendering
			const list = _renderList.list;
			const customSort = this.customSort;
			if ( customSort === null ) {

				list.sort( material.transparent ? sortTransparent : sortOpaque );

			} else {

				customSort.call( this, list, camera );

			}

			for ( let i = 0, l = list.length; i < l; i ++ ) {

				const item = list[ i ];
				multiDrawStarts[ count ] = item.start * bytesPerElement;
				multiDrawCounts[ count ] = item.count;
				count ++;

			}

			_renderList.reset();

		} else {

			for ( let i = 0, l = visibility.length; i < l; i ++ ) {

				if ( visibility[ i ] && active[ i ] ) {

					// determine whether the batched geometry is within the frustum
					let culled = false;
					if ( perObjectFrustumCulled ) {

						// get the bounds in world space
						this.getMatrixAt( i, _matrix$1 );
						this.getBoundingSphereAt( i, _sphere$2 ).applyMatrix4( _matrix$1 );
						culled = ! _frustum.intersectsSphere( _sphere$2 );

					}

					if ( ! culled ) {

						const range = drawRanges[ i ];
						multiDrawStarts[ count ] = range.start * bytesPerElement;
						multiDrawCounts[ count ] = range.count;
						count ++;

					}

				}

			}

		}

		this._multiDrawCount = count;
		this._visibilityChanged = false;

	}

	onBeforeShadow( renderer, object, camera, shadowCamera, geometry, depthMaterial/* , group */ ) {

		this.onBeforeRender( renderer, null, shadowCamera, geometry, depthMaterial );

	}

}

class LineBasicMaterial extends Material {

	constructor( parameters ) {

		super();

		this.isLineBasicMaterial = true;

		this.type = 'LineBasicMaterial';

		this.color = new Color( 0xffffff );

		this.map = null;

		this.linewidth = 1;
		this.linecap = 'round';
		this.linejoin = 'round';

		this.fog = true;

		this.setValues( parameters );

	}


	copy( source ) {

		super.copy( source );

		this.color.copy( source.color );

		this.map = source.map;

		this.linewidth = source.linewidth;
		this.linecap = source.linecap;
		this.linejoin = source.linejoin;

		this.fog = source.fog;

		return this;

	}

}

const _start$1 = /*@__PURE__*/ new Vector3();
const _end$1 = /*@__PURE__*/ new Vector3();
const _inverseMatrix$1 = /*@__PURE__*/ new Matrix4();
const _ray$1 = /*@__PURE__*/ new Ray();
const _sphere$1 = /*@__PURE__*/ new Sphere();

class Line extends (/* unused pure expression or super */ null && (Object3D)) {

	constructor( geometry = new BufferGeometry(), material = new LineBasicMaterial() ) {

		super();

		this.isLine = true;

		this.type = 'Line';

		this.geometry = geometry;
		this.material = material;

		this.updateMorphTargets();

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		this.material = Array.isArray( source.material ) ? source.material.slice() : source.material;
		this.geometry = source.geometry;

		return this;

	}

	computeLineDistances() {

		const geometry = this.geometry;

		// we assume non-indexed geometry

		if ( geometry.index === null ) {

			const positionAttribute = geometry.attributes.position;
			const lineDistances = [ 0 ];

			for ( let i = 1, l = positionAttribute.count; i < l; i ++ ) {

				_start$1.fromBufferAttribute( positionAttribute, i - 1 );
				_end$1.fromBufferAttribute( positionAttribute, i );

				lineDistances[ i ] = lineDistances[ i - 1 ];
				lineDistances[ i ] += _start$1.distanceTo( _end$1 );

			}

			geometry.setAttribute( 'lineDistance', new Float32BufferAttribute( lineDistances, 1 ) );

		} else {

			console.warn( 'THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.' );

		}

		return this;

	}

	raycast( raycaster, intersects ) {

		const geometry = this.geometry;
		const matrixWorld = this.matrixWorld;
		const threshold = raycaster.params.Line.threshold;
		const drawRange = geometry.drawRange;

		// Checking boundingSphere distance to ray

		if ( geometry.boundingSphere === null ) geometry.computeBoundingSphere();

		_sphere$1.copy( geometry.boundingSphere );
		_sphere$1.applyMatrix4( matrixWorld );
		_sphere$1.radius += threshold;

		if ( raycaster.ray.intersectsSphere( _sphere$1 ) === false ) return;

		//

		_inverseMatrix$1.copy( matrixWorld ).invert();
		_ray$1.copy( raycaster.ray ).applyMatrix4( _inverseMatrix$1 );

		const localThreshold = threshold / ( ( this.scale.x + this.scale.y + this.scale.z ) / 3 );
		const localThresholdSq = localThreshold * localThreshold;

		const vStart = new Vector3();
		const vEnd = new Vector3();
		const interSegment = new Vector3();
		const interRay = new Vector3();
		const step = this.isLineSegments ? 2 : 1;

		const index = geometry.index;
		const attributes = geometry.attributes;
		const positionAttribute = attributes.position;

		if ( index !== null ) {

			const start = Math.max( 0, drawRange.start );
			const end = Math.min( index.count, ( drawRange.start + drawRange.count ) );

			for ( let i = start, l = end - 1; i < l; i += step ) {

				const a = index.getX( i );
				const b = index.getX( i + 1 );

				vStart.fromBufferAttribute( positionAttribute, a );
				vEnd.fromBufferAttribute( positionAttribute, b );

				const distSq = _ray$1.distanceSqToSegment( vStart, vEnd, interRay, interSegment );

				if ( distSq > localThresholdSq ) continue;

				interRay.applyMatrix4( this.matrixWorld ); //Move back to world space for distance calculation

				const distance = raycaster.ray.origin.distanceTo( interRay );

				if ( distance < raycaster.near || distance > raycaster.far ) continue;

				intersects.push( {

					distance: distance,
					// What do we want? intersection point on the ray or on the segment??
					// point: raycaster.ray.at( distance ),
					point: interSegment.clone().applyMatrix4( this.matrixWorld ),
					index: i,
					face: null,
					faceIndex: null,
					object: this

				} );

			}

		} else {

			const start = Math.max( 0, drawRange.start );
			const end = Math.min( positionAttribute.count, ( drawRange.start + drawRange.count ) );

			for ( let i = start, l = end - 1; i < l; i += step ) {

				vStart.fromBufferAttribute( positionAttribute, i );
				vEnd.fromBufferAttribute( positionAttribute, i + 1 );

				const distSq = _ray$1.distanceSqToSegment( vStart, vEnd, interRay, interSegment );

				if ( distSq > localThresholdSq ) continue;

				interRay.applyMatrix4( this.matrixWorld ); //Move back to world space for distance calculation

				const distance = raycaster.ray.origin.distanceTo( interRay );

				if ( distance < raycaster.near || distance > raycaster.far ) continue;

				intersects.push( {

					distance: distance,
					// What do we want? intersection point on the ray or on the segment??
					// point: raycaster.ray.at( distance ),
					point: interSegment.clone().applyMatrix4( this.matrixWorld ),
					index: i,
					face: null,
					faceIndex: null,
					object: this

				} );

			}

		}

	}

	updateMorphTargets() {

		const geometry = this.geometry;

		const morphAttributes = geometry.morphAttributes;
		const keys = Object.keys( morphAttributes );

		if ( keys.length > 0 ) {

			const morphAttribute = morphAttributes[ keys[ 0 ] ];

			if ( morphAttribute !== undefined ) {

				this.morphTargetInfluences = [];
				this.morphTargetDictionary = {};

				for ( let m = 0, ml = morphAttribute.length; m < ml; m ++ ) {

					const name = morphAttribute[ m ].name || String( m );

					this.morphTargetInfluences.push( 0 );
					this.morphTargetDictionary[ name ] = m;

				}

			}

		}

	}

}

const _start = /*@__PURE__*/ new Vector3();
const _end = /*@__PURE__*/ new Vector3();

class LineSegments extends (/* unused pure expression or super */ null && (Line)) {

	constructor( geometry, material ) {

		super( geometry, material );

		this.isLineSegments = true;

		this.type = 'LineSegments';

	}

	computeLineDistances() {

		const geometry = this.geometry;

		// we assume non-indexed geometry

		if ( geometry.index === null ) {

			const positionAttribute = geometry.attributes.position;
			const lineDistances = [];

			for ( let i = 0, l = positionAttribute.count; i < l; i += 2 ) {

				_start.fromBufferAttribute( positionAttribute, i );
				_end.fromBufferAttribute( positionAttribute, i + 1 );

				lineDistances[ i ] = ( i === 0 ) ? 0 : lineDistances[ i - 1 ];
				lineDistances[ i + 1 ] = lineDistances[ i ] + _start.distanceTo( _end );

			}

			geometry.setAttribute( 'lineDistance', new Float32BufferAttribute( lineDistances, 1 ) );

		} else {

			console.warn( 'THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.' );

		}

		return this;

	}

}

class LineLoop extends (/* unused pure expression or super */ null && (Line)) {

	constructor( geometry, material ) {

		super( geometry, material );

		this.isLineLoop = true;

		this.type = 'LineLoop';

	}

}

class PointsMaterial extends (/* unused pure expression or super */ null && (Material)) {

	constructor( parameters ) {

		super();

		this.isPointsMaterial = true;

		this.type = 'PointsMaterial';

		this.color = new Color( 0xffffff );

		this.map = null;

		this.alphaMap = null;

		this.size = 1;
		this.sizeAttenuation = true;

		this.fog = true;

		this.setValues( parameters );

	}

	copy( source ) {

		super.copy( source );

		this.color.copy( source.color );

		this.map = source.map;

		this.alphaMap = source.alphaMap;

		this.size = source.size;
		this.sizeAttenuation = source.sizeAttenuation;

		this.fog = source.fog;

		return this;

	}

}

const _inverseMatrix = /*@__PURE__*/ new Matrix4();
const _ray = /*@__PURE__*/ new Ray();
const _sphere = /*@__PURE__*/ new Sphere();
const _position$2 = /*@__PURE__*/ new Vector3();

class Points extends (/* unused pure expression or super */ null && (Object3D)) {

	constructor( geometry = new BufferGeometry(), material = new PointsMaterial() ) {

		super();

		this.isPoints = true;

		this.type = 'Points';

		this.geometry = geometry;
		this.material = material;

		this.updateMorphTargets();

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		this.material = Array.isArray( source.material ) ? source.material.slice() : source.material;
		this.geometry = source.geometry;

		return this;

	}

	raycast( raycaster, intersects ) {

		const geometry = this.geometry;
		const matrixWorld = this.matrixWorld;
		const threshold = raycaster.params.Points.threshold;
		const drawRange = geometry.drawRange;

		// Checking boundingSphere distance to ray

		if ( geometry.boundingSphere === null ) geometry.computeBoundingSphere();

		_sphere.copy( geometry.boundingSphere );
		_sphere.applyMatrix4( matrixWorld );
		_sphere.radius += threshold;

		if ( raycaster.ray.intersectsSphere( _sphere ) === false ) return;

		//

		_inverseMatrix.copy( matrixWorld ).invert();
		_ray.copy( raycaster.ray ).applyMatrix4( _inverseMatrix );

		const localThreshold = threshold / ( ( this.scale.x + this.scale.y + this.scale.z ) / 3 );
		const localThresholdSq = localThreshold * localThreshold;

		const index = geometry.index;
		const attributes = geometry.attributes;
		const positionAttribute = attributes.position;

		if ( index !== null ) {

			const start = Math.max( 0, drawRange.start );
			const end = Math.min( index.count, ( drawRange.start + drawRange.count ) );

			for ( let i = start, il = end; i < il; i ++ ) {

				const a = index.getX( i );

				_position$2.fromBufferAttribute( positionAttribute, a );

				testPoint( _position$2, a, localThresholdSq, matrixWorld, raycaster, intersects, this );

			}

		} else {

			const start = Math.max( 0, drawRange.start );
			const end = Math.min( positionAttribute.count, ( drawRange.start + drawRange.count ) );

			for ( let i = start, l = end; i < l; i ++ ) {

				_position$2.fromBufferAttribute( positionAttribute, i );

				testPoint( _position$2, i, localThresholdSq, matrixWorld, raycaster, intersects, this );

			}

		}

	}

	updateMorphTargets() {

		const geometry = this.geometry;

		const morphAttributes = geometry.morphAttributes;
		const keys = Object.keys( morphAttributes );

		if ( keys.length > 0 ) {

			const morphAttribute = morphAttributes[ keys[ 0 ] ];

			if ( morphAttribute !== undefined ) {

				this.morphTargetInfluences = [];
				this.morphTargetDictionary = {};

				for ( let m = 0, ml = morphAttribute.length; m < ml; m ++ ) {

					const name = morphAttribute[ m ].name || String( m );

					this.morphTargetInfluences.push( 0 );
					this.morphTargetDictionary[ name ] = m;

				}

			}

		}

	}

}

function testPoint( point, index, localThresholdSq, matrixWorld, raycaster, intersects, object ) {

	const rayPointDistanceSq = _ray.distanceSqToPoint( point );

	if ( rayPointDistanceSq < localThresholdSq ) {

		const intersectPoint = new Vector3();

		_ray.closestPointToPoint( point, intersectPoint );
		intersectPoint.applyMatrix4( matrixWorld );

		const distance = raycaster.ray.origin.distanceTo( intersectPoint );

		if ( distance < raycaster.near || distance > raycaster.far ) return;

		intersects.push( {

			distance: distance,
			distanceToRay: Math.sqrt( rayPointDistanceSq ),
			point: intersectPoint,
			index: index,
			face: null,
			object: object

		} );

	}

}

class VideoTexture extends (/* unused pure expression or super */ null && (Texture)) {

	constructor( video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy ) {

		super( video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy );

		this.isVideoTexture = true;

		this.minFilter = minFilter !== undefined ? minFilter : LinearFilter;
		this.magFilter = magFilter !== undefined ? magFilter : LinearFilter;

		this.generateMipmaps = false;

		const scope = this;

		function updateVideo() {

			scope.needsUpdate = true;
			video.requestVideoFrameCallback( updateVideo );

		}

		if ( 'requestVideoFrameCallback' in video ) {

			video.requestVideoFrameCallback( updateVideo );

		}

	}

	clone() {

		return new this.constructor( this.image ).copy( this );

	}

	update() {

		const video = this.image;
		const hasVideoFrameCallback = 'requestVideoFrameCallback' in video;

		if ( hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA ) {

			this.needsUpdate = true;

		}

	}

}

class FramebufferTexture extends (/* unused pure expression or super */ null && (Texture)) {

	constructor( width, height ) {

		super( { width, height } );

		this.isFramebufferTexture = true;

		this.magFilter = NearestFilter;
		this.minFilter = NearestFilter;

		this.generateMipmaps = false;

		this.needsUpdate = true;

	}

}

class CompressedTexture extends (/* unused pure expression or super */ null && (Texture)) {

	constructor( mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, colorSpace ) {

		super( null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace );

		this.isCompressedTexture = true;

		this.image = { width: width, height: height };
		this.mipmaps = mipmaps;

		// no flipping for cube textures
		// (also flipping doesn't work for compressed textures )

		this.flipY = false;

		// can't generate mipmaps for compressed textures
		// mips must be embedded in DDS files

		this.generateMipmaps = false;

	}

}

class CompressedArrayTexture extends (/* unused pure expression or super */ null && (CompressedTexture)) {

	constructor( mipmaps, width, height, depth, format, type ) {

		super( mipmaps, width, height, format, type );

		this.isCompressedArrayTexture = true;
		this.image.depth = depth;
		this.wrapR = ClampToEdgeWrapping;

	}

}

class CompressedCubeTexture extends (/* unused pure expression or super */ null && (CompressedTexture)) {

	constructor( images, format, type ) {

		super( undefined, images[ 0 ].width, images[ 0 ].height, format, type, CubeReflectionMapping );

		this.isCompressedCubeTexture = true;
		this.isCubeTexture = true;

		this.image = images;

	}

}

class CanvasTexture extends (/* unused pure expression or super */ null && (Texture)) {

	constructor( canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy ) {

		super( canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy );

		this.isCanvasTexture = true;

		this.needsUpdate = true;

	}

}

/**
 * Extensible curve object.
 *
 * Some common of curve methods:
 * .getPoint( t, optionalTarget ), .getTangent( t, optionalTarget )
 * .getPointAt( u, optionalTarget ), .getTangentAt( u, optionalTarget )
 * .getPoints(), .getSpacedPoints()
 * .getLength()
 * .updateArcLengths()
 *
 * This following curves inherit from THREE.Curve:
 *
 * -- 2D curves --
 * THREE.ArcCurve
 * THREE.CubicBezierCurve
 * THREE.EllipseCurve
 * THREE.LineCurve
 * THREE.QuadraticBezierCurve
 * THREE.SplineCurve
 *
 * -- 3D curves --
 * THREE.CatmullRomCurve3
 * THREE.CubicBezierCurve3
 * THREE.LineCurve3
 * THREE.QuadraticBezierCurve3
 *
 * A series of curves can be represented as a THREE.CurvePath.
 *
 **/

class Curve {

	constructor() {

		this.type = 'Curve';

		this.arcLengthDivisions = 200;

	}

	// Virtual base class method to overwrite and implement in subclasses
	//	- t [0 .. 1]

	getPoint( /* t, optionalTarget */ ) {

		console.warn( 'THREE.Curve: .getPoint() not implemented.' );
		return null;

	}

	// Get point at relative position in curve according to arc length
	// - u [0 .. 1]

	getPointAt( u, optionalTarget ) {

		const t = this.getUtoTmapping( u );
		return this.getPoint( t, optionalTarget );

	}

	// Get sequence of points using getPoint( t )

	getPoints( divisions = 5 ) {

		const points = [];

		for ( let d = 0; d <= divisions; d ++ ) {

			points.push( this.getPoint( d / divisions ) );

		}

		return points;

	}

	// Get sequence of points using getPointAt( u )

	getSpacedPoints( divisions = 5 ) {

		const points = [];

		for ( let d = 0; d <= divisions; d ++ ) {

			points.push( this.getPointAt( d / divisions ) );

		}

		return points;

	}

	// Get total curve arc length

	getLength() {

		const lengths = this.getLengths();
		return lengths[ lengths.length - 1 ];

	}

	// Get list of cumulative segment lengths

	getLengths( divisions = this.arcLengthDivisions ) {

		if ( this.cacheArcLengths &&
			( this.cacheArcLengths.length === divisions + 1 ) &&
			! this.needsUpdate ) {

			return this.cacheArcLengths;

		}

		this.needsUpdate = false;

		const cache = [];
		let current, last = this.getPoint( 0 );
		let sum = 0;

		cache.push( 0 );

		for ( let p = 1; p <= divisions; p ++ ) {

			current = this.getPoint( p / divisions );
			sum += current.distanceTo( last );
			cache.push( sum );
			last = current;

		}

		this.cacheArcLengths = cache;

		return cache; // { sums: cache, sum: sum }; Sum is in the last element.

	}

	updateArcLengths() {

		this.needsUpdate = true;
		this.getLengths();

	}

	// Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant

	getUtoTmapping( u, distance ) {

		const arcLengths = this.getLengths();

		let i = 0;
		const il = arcLengths.length;

		let targetArcLength; // The targeted u distance value to get

		if ( distance ) {

			targetArcLength = distance;

		} else {

			targetArcLength = u * arcLengths[ il - 1 ];

		}

		// binary search for the index with largest value smaller than target u distance

		let low = 0, high = il - 1, comparison;

		while ( low <= high ) {

			i = Math.floor( low + ( high - low ) / 2 ); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats

			comparison = arcLengths[ i ] - targetArcLength;

			if ( comparison < 0 ) {

				low = i + 1;

			} else if ( comparison > 0 ) {

				high = i - 1;

			} else {

				high = i;
				break;

				// DONE

			}

		}

		i = high;

		if ( arcLengths[ i ] === targetArcLength ) {

			return i / ( il - 1 );

		}

		// we could get finer grain at lengths, or use simple interpolation between two points

		const lengthBefore = arcLengths[ i ];
		const lengthAfter = arcLengths[ i + 1 ];

		const segmentLength = lengthAfter - lengthBefore;

		// determine where we are between the 'before' and 'after' points

		const segmentFraction = ( targetArcLength - lengthBefore ) / segmentLength;

		// add that fractional amount to t

		const t = ( i + segmentFraction ) / ( il - 1 );

		return t;

	}

	// Returns a unit vector tangent at t
	// In case any sub curve does not implement its tangent derivation,
	// 2 points a small delta apart will be used to find its gradient
	// which seems to give a reasonable approximation

	getTangent( t, optionalTarget ) {

		const delta = 0.0001;
		let t1 = t - delta;
		let t2 = t + delta;

		// Capping in case of danger

		if ( t1 < 0 ) t1 = 0;
		if ( t2 > 1 ) t2 = 1;

		const pt1 = this.getPoint( t1 );
		const pt2 = this.getPoint( t2 );

		const tangent = optionalTarget || ( ( pt1.isVector2 ) ? new Vector2() : new Vector3() );

		tangent.copy( pt2 ).sub( pt1 ).normalize();

		return tangent;

	}

	getTangentAt( u, optionalTarget ) {

		const t = this.getUtoTmapping( u );
		return this.getTangent( t, optionalTarget );

	}

	computeFrenetFrames( segments, closed ) {

		// see http://www.cs.indiana.edu/pub/techreports/TR425.pdf

		const normal = new Vector3();

		const tangents = [];
		const normals = [];
		const binormals = [];

		const vec = new Vector3();
		const mat = new Matrix4();

		// compute the tangent vectors for each segment on the curve

		for ( let i = 0; i <= segments; i ++ ) {

			const u = i / segments;

			tangents[ i ] = this.getTangentAt( u, new Vector3() );

		}

		// select an initial normal vector perpendicular to the first tangent vector,
		// and in the direction of the minimum tangent xyz component

		normals[ 0 ] = new Vector3();
		binormals[ 0 ] = new Vector3();
		let min = Number.MAX_VALUE;
		const tx = Math.abs( tangents[ 0 ].x );
		const ty = Math.abs( tangents[ 0 ].y );
		const tz = Math.abs( tangents[ 0 ].z );

		if ( tx <= min ) {

			min = tx;
			normal.set( 1, 0, 0 );

		}

		if ( ty <= min ) {

			min = ty;
			normal.set( 0, 1, 0 );

		}

		if ( tz <= min ) {

			normal.set( 0, 0, 1 );

		}

		vec.crossVectors( tangents[ 0 ], normal ).normalize();

		normals[ 0 ].crossVectors( tangents[ 0 ], vec );
		binormals[ 0 ].crossVectors( tangents[ 0 ], normals[ 0 ] );


		// compute the slowly-varying normal and binormal vectors for each segment on the curve

		for ( let i = 1; i <= segments; i ++ ) {

			normals[ i ] = normals[ i - 1 ].clone();

			binormals[ i ] = binormals[ i - 1 ].clone();

			vec.crossVectors( tangents[ i - 1 ], tangents[ i ] );

			if ( vec.length() > Number.EPSILON ) {

				vec.normalize();

				const theta = Math.acos( clamp( tangents[ i - 1 ].dot( tangents[ i ] ), - 1, 1 ) ); // clamp for floating pt errors

				normals[ i ].applyMatrix4( mat.makeRotationAxis( vec, theta ) );

			}

			binormals[ i ].crossVectors( tangents[ i ], normals[ i ] );

		}

		// if the curve is closed, postprocess the vectors so the first and last normal vectors are the same

		if ( closed === true ) {

			let theta = Math.acos( clamp( normals[ 0 ].dot( normals[ segments ] ), - 1, 1 ) );
			theta /= segments;

			if ( tangents[ 0 ].dot( vec.crossVectors( normals[ 0 ], normals[ segments ] ) ) > 0 ) {

				theta = - theta;

			}

			for ( let i = 1; i <= segments; i ++ ) {

				// twist a little...
				normals[ i ].applyMatrix4( mat.makeRotationAxis( tangents[ i ], theta * i ) );
				binormals[ i ].crossVectors( tangents[ i ], normals[ i ] );

			}

		}

		return {
			tangents: tangents,
			normals: normals,
			binormals: binormals
		};

	}

	clone() {

		return new this.constructor().copy( this );

	}

	copy( source ) {

		this.arcLengthDivisions = source.arcLengthDivisions;

		return this;

	}

	toJSON() {

		const data = {
			metadata: {
				version: 4.6,
				type: 'Curve',
				generator: 'Curve.toJSON'
			}
		};

		data.arcLengthDivisions = this.arcLengthDivisions;
		data.type = this.type;

		return data;

	}

	fromJSON( json ) {

		this.arcLengthDivisions = json.arcLengthDivisions;

		return this;

	}

}

class EllipseCurve extends Curve {

	constructor( aX = 0, aY = 0, xRadius = 1, yRadius = 1, aStartAngle = 0, aEndAngle = Math.PI * 2, aClockwise = false, aRotation = 0 ) {

		super();

		this.isEllipseCurve = true;

		this.type = 'EllipseCurve';

		this.aX = aX;
		this.aY = aY;

		this.xRadius = xRadius;
		this.yRadius = yRadius;

		this.aStartAngle = aStartAngle;
		this.aEndAngle = aEndAngle;

		this.aClockwise = aClockwise;

		this.aRotation = aRotation;

	}

	getPoint( t, optionalTarget = new Vector2() ) {

		const point = optionalTarget;

		const twoPi = Math.PI * 2;
		let deltaAngle = this.aEndAngle - this.aStartAngle;
		const samePoints = Math.abs( deltaAngle ) < Number.EPSILON;

		// ensures that deltaAngle is 0 .. 2 PI
		while ( deltaAngle < 0 ) deltaAngle += twoPi;
		while ( deltaAngle > twoPi ) deltaAngle -= twoPi;

		if ( deltaAngle < Number.EPSILON ) {

			if ( samePoints ) {

				deltaAngle = 0;

			} else {

				deltaAngle = twoPi;

			}

		}

		if ( this.aClockwise === true && ! samePoints ) {

			if ( deltaAngle === twoPi ) {

				deltaAngle = - twoPi;

			} else {

				deltaAngle = deltaAngle - twoPi;

			}

		}

		const angle = this.aStartAngle + t * deltaAngle;
		let x = this.aX + this.xRadius * Math.cos( angle );
		let y = this.aY + this.yRadius * Math.sin( angle );

		if ( this.aRotation !== 0 ) {

			const cos = Math.cos( this.aRotation );
			const sin = Math.sin( this.aRotation );

			const tx = x - this.aX;
			const ty = y - this.aY;

			// Rotate the point about the center of the ellipse.
			x = tx * cos - ty * sin + this.aX;
			y = tx * sin + ty * cos + this.aY;

		}

		return point.set( x, y );

	}

	copy( source ) {

		super.copy( source );

		this.aX = source.aX;
		this.aY = source.aY;

		this.xRadius = source.xRadius;
		this.yRadius = source.yRadius;

		this.aStartAngle = source.aStartAngle;
		this.aEndAngle = source.aEndAngle;

		this.aClockwise = source.aClockwise;

		this.aRotation = source.aRotation;

		return this;

	}

	toJSON() {

		const data = super.toJSON();

		data.aX = this.aX;
		data.aY = this.aY;

		data.xRadius = this.xRadius;
		data.yRadius = this.yRadius;

		data.aStartAngle = this.aStartAngle;
		data.aEndAngle = this.aEndAngle;

		data.aClockwise = this.aClockwise;

		data.aRotation = this.aRotation;

		return data;

	}

	fromJSON( json ) {

		super.fromJSON( json );

		this.aX = json.aX;
		this.aY = json.aY;

		this.xRadius = json.xRadius;
		this.yRadius = json.yRadius;

		this.aStartAngle = json.aStartAngle;
		this.aEndAngle = json.aEndAngle;

		this.aClockwise = json.aClockwise;

		this.aRotation = json.aRotation;

		return this;

	}

}

class ArcCurve extends EllipseCurve {

	constructor( aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise ) {

		super( aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise );

		this.isArcCurve = true;

		this.type = 'ArcCurve';

	}

}

/**
 * Centripetal CatmullRom Curve - which is useful for avoiding
 * cusps and self-intersections in non-uniform catmull rom curves.
 * http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
 *
 * curve.type accepts centripetal(default), chordal and catmullrom
 * curve.tension is used for catmullrom which defaults to 0.5
 */


/*
Based on an optimized c++ solution in
 - http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
 - http://ideone.com/NoEbVM

This CubicPoly class could be used for reusing some variables and calculations,
but for three.js curve use, it could be possible inlined and flatten into a single function call
which can be placed in CurveUtils.
*/

function CubicPoly() {

	let c0 = 0, c1 = 0, c2 = 0, c3 = 0;

	/*
	 * Compute coefficients for a cubic polynomial
	 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
	 * such that
	 *   p(0) = x0, p(1) = x1
	 *  and
	 *   p'(0) = t0, p'(1) = t1.
	 */
	function init( x0, x1, t0, t1 ) {

		c0 = x0;
		c1 = t0;
		c2 = - 3 * x0 + 3 * x1 - 2 * t0 - t1;
		c3 = 2 * x0 - 2 * x1 + t0 + t1;

	}

	return {

		initCatmullRom: function ( x0, x1, x2, x3, tension ) {

			init( x1, x2, tension * ( x2 - x0 ), tension * ( x3 - x1 ) );

		},

		initNonuniformCatmullRom: function ( x0, x1, x2, x3, dt0, dt1, dt2 ) {

			// compute tangents when parameterized in [t1,t2]
			let t1 = ( x1 - x0 ) / dt0 - ( x2 - x0 ) / ( dt0 + dt1 ) + ( x2 - x1 ) / dt1;
			let t2 = ( x2 - x1 ) / dt1 - ( x3 - x1 ) / ( dt1 + dt2 ) + ( x3 - x2 ) / dt2;

			// rescale tangents for parametrization in [0,1]
			t1 *= dt1;
			t2 *= dt1;

			init( x1, x2, t1, t2 );

		},

		calc: function ( t ) {

			const t2 = t * t;
			const t3 = t2 * t;
			return c0 + c1 * t + c2 * t2 + c3 * t3;

		}

	};

}

//

const tmp = /*@__PURE__*/ new Vector3();
const px = /*@__PURE__*/ new CubicPoly();
const py = /*@__PURE__*/ new CubicPoly();
const pz = /*@__PURE__*/ new CubicPoly();

class CatmullRomCurve3 extends Curve {

	constructor( points = [], closed = false, curveType = 'centripetal', tension = 0.5 ) {

		super();

		this.isCatmullRomCurve3 = true;

		this.type = 'CatmullRomCurve3';

		this.points = points;
		this.closed = closed;
		this.curveType = curveType;
		this.tension = tension;

	}

	getPoint( t, optionalTarget = new Vector3() ) {

		const point = optionalTarget;

		const points = this.points;
		const l = points.length;

		const p = ( l - ( this.closed ? 0 : 1 ) ) * t;
		let intPoint = Math.floor( p );
		let weight = p - intPoint;

		if ( this.closed ) {

			intPoint += intPoint > 0 ? 0 : ( Math.floor( Math.abs( intPoint ) / l ) + 1 ) * l;

		} else if ( weight === 0 && intPoint === l - 1 ) {

			intPoint = l - 2;
			weight = 1;

		}

		let p0, p3; // 4 points (p1 & p2 defined below)

		if ( this.closed || intPoint > 0 ) {

			p0 = points[ ( intPoint - 1 ) % l ];

		} else {

			// extrapolate first point
			tmp.subVectors( points[ 0 ], points[ 1 ] ).add( points[ 0 ] );
			p0 = tmp;

		}

		const p1 = points[ intPoint % l ];
		const p2 = points[ ( intPoint + 1 ) % l ];

		if ( this.closed || intPoint + 2 < l ) {

			p3 = points[ ( intPoint + 2 ) % l ];

		} else {

			// extrapolate last point
			tmp.subVectors( points[ l - 1 ], points[ l - 2 ] ).add( points[ l - 1 ] );
			p3 = tmp;

		}

		if ( this.curveType === 'centripetal' || this.curveType === 'chordal' ) {

			// init Centripetal / Chordal Catmull-Rom
			const pow = this.curveType === 'chordal' ? 0.5 : 0.25;
			let dt0 = Math.pow( p0.distanceToSquared( p1 ), pow );
			let dt1 = Math.pow( p1.distanceToSquared( p2 ), pow );
			let dt2 = Math.pow( p2.distanceToSquared( p3 ), pow );

			// safety check for repeated points
			if ( dt1 < 1e-4 ) dt1 = 1.0;
			if ( dt0 < 1e-4 ) dt0 = dt1;
			if ( dt2 < 1e-4 ) dt2 = dt1;

			px.initNonuniformCatmullRom( p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2 );
			py.initNonuniformCatmullRom( p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2 );
			pz.initNonuniformCatmullRom( p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2 );

		} else if ( this.curveType === 'catmullrom' ) {

			px.initCatmullRom( p0.x, p1.x, p2.x, p3.x, this.tension );
			py.initCatmullRom( p0.y, p1.y, p2.y, p3.y, this.tension );
			pz.initCatmullRom( p0.z, p1.z, p2.z, p3.z, this.tension );

		}

		point.set(
			px.calc( weight ),
			py.calc( weight ),
			pz.calc( weight )
		);

		return point;

	}

	copy( source ) {

		super.copy( source );

		this.points = [];

		for ( let i = 0, l = source.points.length; i < l; i ++ ) {

			const point = source.points[ i ];

			this.points.push( point.clone() );

		}

		this.closed = source.closed;
		this.curveType = source.curveType;
		this.tension = source.tension;

		return this;

	}

	toJSON() {

		const data = super.toJSON();

		data.points = [];

		for ( let i = 0, l = this.points.length; i < l; i ++ ) {

			const point = this.points[ i ];
			data.points.push( point.toArray() );

		}

		data.closed = this.closed;
		data.curveType = this.curveType;
		data.tension = this.tension;

		return data;

	}

	fromJSON( json ) {

		super.fromJSON( json );

		this.points = [];

		for ( let i = 0, l = json.points.length; i < l; i ++ ) {

			const point = json.points[ i ];
			this.points.push( new Vector3().fromArray( point ) );

		}

		this.closed = json.closed;
		this.curveType = json.curveType;
		this.tension = json.tension;

		return this;

	}

}

/**
 * Bezier Curves formulas obtained from
 * https://en.wikipedia.org/wiki/B%C3%A9zier_curve
 */

function CatmullRom( t, p0, p1, p2, p3 ) {

	const v0 = ( p2 - p0 ) * 0.5;
	const v1 = ( p3 - p1 ) * 0.5;
	const t2 = t * t;
	const t3 = t * t2;
	return ( 2 * p1 - 2 * p2 + v0 + v1 ) * t3 + ( - 3 * p1 + 3 * p2 - 2 * v0 - v1 ) * t2 + v0 * t + p1;

}

//

function QuadraticBezierP0( t, p ) {

	const k = 1 - t;
	return k * k * p;

}

function QuadraticBezierP1( t, p ) {

	return 2 * ( 1 - t ) * t * p;

}

function QuadraticBezierP2( t, p ) {

	return t * t * p;

}

function QuadraticBezier( t, p0, p1, p2 ) {

	return QuadraticBezierP0( t, p0 ) + QuadraticBezierP1( t, p1 ) +
		QuadraticBezierP2( t, p2 );

}

//

function CubicBezierP0( t, p ) {

	const k = 1 - t;
	return k * k * k * p;

}

function CubicBezierP1( t, p ) {

	const k = 1 - t;
	return 3 * k * k * t * p;

}

function CubicBezierP2( t, p ) {

	return 3 * ( 1 - t ) * t * t * p;

}

function CubicBezierP3( t, p ) {

	return t * t * t * p;

}

function CubicBezier( t, p0, p1, p2, p3 ) {

	return CubicBezierP0( t, p0 ) + CubicBezierP1( t, p1 ) + CubicBezierP2( t, p2 ) +
		CubicBezierP3( t, p3 );

}

class CubicBezierCurve extends Curve {

	constructor( v0 = new Vector2(), v1 = new Vector2(), v2 = new Vector2(), v3 = new Vector2() ) {

		super();

		this.isCubicBezierCurve = true;

		this.type = 'CubicBezierCurve';

		this.v0 = v0;
		this.v1 = v1;
		this.v2 = v2;
		this.v3 = v3;

	}

	getPoint( t, optionalTarget = new Vector2() ) {

		const point = optionalTarget;

		const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;

		point.set(
			CubicBezier( t, v0.x, v1.x, v2.x, v3.x ),
			CubicBezier( t, v0.y, v1.y, v2.y, v3.y )
		);

		return point;

	}

	copy( source ) {

		super.copy( source );

		this.v0.copy( source.v0 );
		this.v1.copy( source.v1 );
		this.v2.copy( source.v2 );
		this.v3.copy( source.v3 );

		return this;

	}

	toJSON() {

		const data = super.toJSON();

		data.v0 = this.v0.toArray();
		data.v1 = this.v1.toArray();
		data.v2 = this.v2.toArray();
		data.v3 = this.v3.toArray();

		return data;

	}

	fromJSON( json ) {

		super.fromJSON( json );

		this.v0.fromArray( json.v0 );
		this.v1.fromArray( json.v1 );
		this.v2.fromArray( json.v2 );
		this.v3.fromArray( json.v3 );

		return this;

	}

}

class CubicBezierCurve3 extends Curve {

	constructor( v0 = new Vector3(), v1 = new Vector3(), v2 = new Vector3(), v3 = new Vector3() ) {

		super();

		this.isCubicBezierCurve3 = true;

		this.type = 'CubicBezierCurve3';

		this.v0 = v0;
		this.v1 = v1;
		this.v2 = v2;
		this.v3 = v3;

	}

	getPoint( t, optionalTarget = new Vector3() ) {

		const point = optionalTarget;

		const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;

		point.set(
			CubicBezier( t, v0.x, v1.x, v2.x, v3.x ),
			CubicBezier( t, v0.y, v1.y, v2.y, v3.y ),
			CubicBezier( t, v0.z, v1.z, v2.z, v3.z )
		);

		return point;

	}

	copy( source ) {

		super.copy( source );

		this.v0.copy( source.v0 );
		this.v1.copy( source.v1 );
		this.v2.copy( source.v2 );
		this.v3.copy( source.v3 );

		return this;

	}

	toJSON() {

		const data = super.toJSON();

		data.v0 = this.v0.toArray();
		data.v1 = this.v1.toArray();
		data.v2 = this.v2.toArray();
		data.v3 = this.v3.toArray();

		return data;

	}

	fromJSON( json ) {

		super.fromJSON( json );

		this.v0.fromArray( json.v0 );
		this.v1.fromArray( json.v1 );
		this.v2.fromArray( json.v2 );
		this.v3.fromArray( json.v3 );

		return this;

	}

}

class LineCurve extends Curve {

	constructor( v1 = new Vector2(), v2 = new Vector2() ) {

		super();

		this.isLineCurve = true;

		this.type = 'LineCurve';

		this.v1 = v1;
		this.v2 = v2;

	}

	getPoint( t, optionalTarget = new Vector2() ) {

		const point = optionalTarget;

		if ( t === 1 ) {

			point.copy( this.v2 );

		} else {

			point.copy( this.v2 ).sub( this.v1 );
			point.multiplyScalar( t ).add( this.v1 );

		}

		return point;

	}

	// Line curve is linear, so we can overwrite default getPointAt
	getPointAt( u, optionalTarget ) {

		return this.getPoint( u, optionalTarget );

	}

	getTangent( t, optionalTarget = new Vector2() ) {

		return optionalTarget.subVectors( this.v2, this.v1 ).normalize();

	}

	getTangentAt( u, optionalTarget ) {

		return this.getTangent( u, optionalTarget );

	}

	copy( source ) {

		super.copy( source );

		this.v1.copy( source.v1 );
		this.v2.copy( source.v2 );

		return this;

	}

	toJSON() {

		const data = super.toJSON();

		data.v1 = this.v1.toArray();
		data.v2 = this.v2.toArray();

		return data;

	}

	fromJSON( json ) {

		super.fromJSON( json );

		this.v1.fromArray( json.v1 );
		this.v2.fromArray( json.v2 );

		return this;

	}

}

class LineCurve3 extends Curve {

	constructor( v1 = new Vector3(), v2 = new Vector3() ) {

		super();

		this.isLineCurve3 = true;

		this.type = 'LineCurve3';

		this.v1 = v1;
		this.v2 = v2;

	}

	getPoint( t, optionalTarget = new Vector3() ) {

		const point = optionalTarget;

		if ( t === 1 ) {

			point.copy( this.v2 );

		} else {

			point.copy( this.v2 ).sub( this.v1 );
			point.multiplyScalar( t ).add( this.v1 );

		}

		return point;

	}

	// Line curve is linear, so we can overwrite default getPointAt
	getPointAt( u, optionalTarget ) {

		return this.getPoint( u, optionalTarget );

	}

	getTangent( t, optionalTarget = new Vector3() ) {

		return optionalTarget.subVectors( this.v2, this.v1 ).normalize();

	}

	getTangentAt( u, optionalTarget ) {

		return this.getTangent( u, optionalTarget );

	}

	copy( source ) {

		super.copy( source );

		this.v1.copy( source.v1 );
		this.v2.copy( source.v2 );

		return this;

	}

	toJSON() {

		const data = super.toJSON();

		data.v1 = this.v1.toArray();
		data.v2 = this.v2.toArray();

		return data;

	}

	fromJSON( json ) {

		super.fromJSON( json );

		this.v1.fromArray( json.v1 );
		this.v2.fromArray( json.v2 );

		return this;

	}

}

class QuadraticBezierCurve extends Curve {

	constructor( v0 = new Vector2(), v1 = new Vector2(), v2 = new Vector2() ) {

		super();

		this.isQuadraticBezierCurve = true;

		this.type = 'QuadraticBezierCurve';

		this.v0 = v0;
		this.v1 = v1;
		this.v2 = v2;

	}

	getPoint( t, optionalTarget = new Vector2() ) {

		const point = optionalTarget;

		const v0 = this.v0, v1 = this.v1, v2 = this.v2;

		point.set(
			QuadraticBezier( t, v0.x, v1.x, v2.x ),
			QuadraticBezier( t, v0.y, v1.y, v2.y )
		);

		return point;

	}

	copy( source ) {

		super.copy( source );

		this.v0.copy( source.v0 );
		this.v1.copy( source.v1 );
		this.v2.copy( source.v2 );

		return this;

	}

	toJSON() {

		const data = super.toJSON();

		data.v0 = this.v0.toArray();
		data.v1 = this.v1.toArray();
		data.v2 = this.v2.toArray();

		return data;

	}

	fromJSON( json ) {

		super.fromJSON( json );

		this.v0.fromArray( json.v0 );
		this.v1.fromArray( json.v1 );
		this.v2.fromArray( json.v2 );

		return this;

	}

}

class QuadraticBezierCurve3 extends Curve {

	constructor( v0 = new Vector3(), v1 = new Vector3(), v2 = new Vector3() ) {

		super();

		this.isQuadraticBezierCurve3 = true;

		this.type = 'QuadraticBezierCurve3';

		this.v0 = v0;
		this.v1 = v1;
		this.v2 = v2;

	}

	getPoint( t, optionalTarget = new Vector3() ) {

		const point = optionalTarget;

		const v0 = this.v0, v1 = this.v1, v2 = this.v2;

		point.set(
			QuadraticBezier( t, v0.x, v1.x, v2.x ),
			QuadraticBezier( t, v0.y, v1.y, v2.y ),
			QuadraticBezier( t, v0.z, v1.z, v2.z )
		);

		return point;

	}

	copy( source ) {

		super.copy( source );

		this.v0.copy( source.v0 );
		this.v1.copy( source.v1 );
		this.v2.copy( source.v2 );

		return this;

	}

	toJSON() {

		const data = super.toJSON();

		data.v0 = this.v0.toArray();
		data.v1 = this.v1.toArray();
		data.v2 = this.v2.toArray();

		return data;

	}

	fromJSON( json ) {

		super.fromJSON( json );

		this.v0.fromArray( json.v0 );
		this.v1.fromArray( json.v1 );
		this.v2.fromArray( json.v2 );

		return this;

	}

}

class SplineCurve extends Curve {

	constructor( points = [] ) {

		super();

		this.isSplineCurve = true;

		this.type = 'SplineCurve';

		this.points = points;

	}

	getPoint( t, optionalTarget = new Vector2() ) {

		const point = optionalTarget;

		const points = this.points;
		const p = ( points.length - 1 ) * t;

		const intPoint = Math.floor( p );
		const weight = p - intPoint;

		const p0 = points[ intPoint === 0 ? intPoint : intPoint - 1 ];
		const p1 = points[ intPoint ];
		const p2 = points[ intPoint > points.length - 2 ? points.length - 1 : intPoint + 1 ];
		const p3 = points[ intPoint > points.length - 3 ? points.length - 1 : intPoint + 2 ];

		point.set(
			CatmullRom( weight, p0.x, p1.x, p2.x, p3.x ),
			CatmullRom( weight, p0.y, p1.y, p2.y, p3.y )
		);

		return point;

	}

	copy( source ) {

		super.copy( source );

		this.points = [];

		for ( let i = 0, l = source.points.length; i < l; i ++ ) {

			const point = source.points[ i ];

			this.points.push( point.clone() );

		}

		return this;

	}

	toJSON() {

		const data = super.toJSON();

		data.points = [];

		for ( let i = 0, l = this.points.length; i < l; i ++ ) {

			const point = this.points[ i ];
			data.points.push( point.toArray() );

		}

		return data;

	}

	fromJSON( json ) {

		super.fromJSON( json );

		this.points = [];

		for ( let i = 0, l = json.points.length; i < l; i ++ ) {

			const point = json.points[ i ];
			this.points.push( new Vector2().fromArray( point ) );

		}

		return this;

	}

}

var Curves = /*#__PURE__*/Object.freeze({
	__proto__: null,
	ArcCurve: ArcCurve,
	CatmullRomCurve3: CatmullRomCurve3,
	CubicBezierCurve: CubicBezierCurve,
	CubicBezierCurve3: CubicBezierCurve3,
	EllipseCurve: EllipseCurve,
	LineCurve: LineCurve,
	LineCurve3: LineCurve3,
	QuadraticBezierCurve: QuadraticBezierCurve,
	QuadraticBezierCurve3: QuadraticBezierCurve3,
	SplineCurve: SplineCurve
});

/**************************************************************
 *	Curved Path - a curve path is simply a array of connected
 *  curves, but retains the api of a curve
 **************************************************************/

class CurvePath extends Curve {

	constructor() {

		super();

		this.type = 'CurvePath';

		this.curves = [];
		this.autoClose = false; // Automatically closes the path

	}

	add( curve ) {

		this.curves.push( curve );

	}

	closePath() {

		// Add a line curve if start and end of lines are not connected
		const startPoint = this.curves[ 0 ].getPoint( 0 );
		const endPoint = this.curves[ this.curves.length - 1 ].getPoint( 1 );

		if ( ! startPoint.equals( endPoint ) ) {

			const lineType = ( startPoint.isVector2 === true ) ? 'LineCurve' : 'LineCurve3';
			this.curves.push( new Curves[ lineType ]( endPoint, startPoint ) );

		}

		return this;

	}

	// To get accurate point with reference to
	// entire path distance at time t,
	// following has to be done:

	// 1. Length of each sub path have to be known
	// 2. Locate and identify type of curve
	// 3. Get t for the curve
	// 4. Return curve.getPointAt(t')

	getPoint( t, optionalTarget ) {

		const d = t * this.getLength();
		const curveLengths = this.getCurveLengths();
		let i = 0;

		// To think about boundaries points.

		while ( i < curveLengths.length ) {

			if ( curveLengths[ i ] >= d ) {

				const diff = curveLengths[ i ] - d;
				const curve = this.curves[ i ];

				const segmentLength = curve.getLength();
				const u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;

				return curve.getPointAt( u, optionalTarget );

			}

			i ++;

		}

		return null;

		// loop where sum != 0, sum > d , sum+1 <d

	}

	// We cannot use the default THREE.Curve getPoint() with getLength() because in
	// THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
	// getPoint() depends on getLength

	getLength() {

		const lens = this.getCurveLengths();
		return lens[ lens.length - 1 ];

	}

	// cacheLengths must be recalculated.
	updateArcLengths() {

		this.needsUpdate = true;
		this.cacheLengths = null;
		this.getCurveLengths();

	}

	// Compute lengths and cache them
	// We cannot overwrite getLengths() because UtoT mapping uses it.

	getCurveLengths() {

		// We use cache values if curves and cache array are same length

		if ( this.cacheLengths && this.cacheLengths.length === this.curves.length ) {

			return this.cacheLengths;

		}

		// Get length of sub-curve
		// Push sums into cached array

		const lengths = [];
		let sums = 0;

		for ( let i = 0, l = this.curves.length; i < l; i ++ ) {

			sums += this.curves[ i ].getLength();
			lengths.push( sums );

		}

		this.cacheLengths = lengths;

		return lengths;

	}

	getSpacedPoints( divisions = 40 ) {

		const points = [];

		for ( let i = 0; i <= divisions; i ++ ) {

			points.push( this.getPoint( i / divisions ) );

		}

		if ( this.autoClose ) {

			points.push( points[ 0 ] );

		}

		return points;

	}

	getPoints( divisions = 12 ) {

		const points = [];
		let last;

		for ( let i = 0, curves = this.curves; i < curves.length; i ++ ) {

			const curve = curves[ i ];
			const resolution = curve.isEllipseCurve ? divisions * 2
				: ( curve.isLineCurve || curve.isLineCurve3 ) ? 1
					: curve.isSplineCurve ? divisions * curve.points.length
						: divisions;

			const pts = curve.getPoints( resolution );

			for ( let j = 0; j < pts.length; j ++ ) {

				const point = pts[ j ];

				if ( last && last.equals( point ) ) continue; // ensures no consecutive points are duplicates

				points.push( point );
				last = point;

			}

		}

		if ( this.autoClose && points.length > 1 && ! points[ points.length - 1 ].equals( points[ 0 ] ) ) {

			points.push( points[ 0 ] );

		}

		return points;

	}

	copy( source ) {

		super.copy( source );

		this.curves = [];

		for ( let i = 0, l = source.curves.length; i < l; i ++ ) {

			const curve = source.curves[ i ];

			this.curves.push( curve.clone() );

		}

		this.autoClose = source.autoClose;

		return this;

	}

	toJSON() {

		const data = super.toJSON();

		data.autoClose = this.autoClose;
		data.curves = [];

		for ( let i = 0, l = this.curves.length; i < l; i ++ ) {

			const curve = this.curves[ i ];
			data.curves.push( curve.toJSON() );

		}

		return data;

	}

	fromJSON( json ) {

		super.fromJSON( json );

		this.autoClose = json.autoClose;
		this.curves = [];

		for ( let i = 0, l = json.curves.length; i < l; i ++ ) {

			const curve = json.curves[ i ];
			this.curves.push( new Curves[ curve.type ]().fromJSON( curve ) );

		}

		return this;

	}

}

class Path extends CurvePath {

	constructor( points ) {

		super();

		this.type = 'Path';

		this.currentPoint = new Vector2();

		if ( points ) {

			this.setFromPoints( points );

		}

	}

	setFromPoints( points ) {

		this.moveTo( points[ 0 ].x, points[ 0 ].y );

		for ( let i = 1, l = points.length; i < l; i ++ ) {

			this.lineTo( points[ i ].x, points[ i ].y );

		}

		return this;

	}

	moveTo( x, y ) {

		this.currentPoint.set( x, y ); // TODO consider referencing vectors instead of copying?

		return this;

	}

	lineTo( x, y ) {

		const curve = new LineCurve( this.currentPoint.clone(), new Vector2( x, y ) );
		this.curves.push( curve );

		this.currentPoint.set( x, y );

		return this;

	}

	quadraticCurveTo( aCPx, aCPy, aX, aY ) {

		const curve = new QuadraticBezierCurve(
			this.currentPoint.clone(),
			new Vector2( aCPx, aCPy ),
			new Vector2( aX, aY )
		);

		this.curves.push( curve );

		this.currentPoint.set( aX, aY );

		return this;

	}

	bezierCurveTo( aCP1x, aCP1y, aCP2x, aCP2y, aX, aY ) {

		const curve = new CubicBezierCurve(
			this.currentPoint.clone(),
			new Vector2( aCP1x, aCP1y ),
			new Vector2( aCP2x, aCP2y ),
			new Vector2( aX, aY )
		);

		this.curves.push( curve );

		this.currentPoint.set( aX, aY );

		return this;

	}

	splineThru( pts /*Array of Vector*/ ) {

		const npts = [ this.currentPoint.clone() ].concat( pts );

		const curve = new SplineCurve( npts );
		this.curves.push( curve );

		this.currentPoint.copy( pts[ pts.length - 1 ] );

		return this;

	}

	arc( aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise ) {

		const x0 = this.currentPoint.x;
		const y0 = this.currentPoint.y;

		this.absarc( aX + x0, aY + y0, aRadius,
			aStartAngle, aEndAngle, aClockwise );

		return this;

	}

	absarc( aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise ) {

		this.absellipse( aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise );

		return this;

	}

	ellipse( aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation ) {

		const x0 = this.currentPoint.x;
		const y0 = this.currentPoint.y;

		this.absellipse( aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation );

		return this;

	}

	absellipse( aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation ) {

		const curve = new EllipseCurve( aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation );

		if ( this.curves.length > 0 ) {

			// if a previous curve is present, attempt to join
			const firstPoint = curve.getPoint( 0 );

			if ( ! firstPoint.equals( this.currentPoint ) ) {

				this.lineTo( firstPoint.x, firstPoint.y );

			}

		}

		this.curves.push( curve );

		const lastPoint = curve.getPoint( 1 );
		this.currentPoint.copy( lastPoint );

		return this;

	}

	copy( source ) {

		super.copy( source );

		this.currentPoint.copy( source.currentPoint );

		return this;

	}

	toJSON() {

		const data = super.toJSON();

		data.currentPoint = this.currentPoint.toArray();

		return data;

	}

	fromJSON( json ) {

		super.fromJSON( json );

		this.currentPoint.fromArray( json.currentPoint );

		return this;

	}

}

class LatheGeometry extends BufferGeometry {

	constructor( points = [ new Vector2( 0, - 0.5 ), new Vector2( 0.5, 0 ), new Vector2( 0, 0.5 ) ], segments = 12, phiStart = 0, phiLength = Math.PI * 2 ) {

		super();

		this.type = 'LatheGeometry';

		this.parameters = {
			points: points,
			segments: segments,
			phiStart: phiStart,
			phiLength: phiLength
		};

		segments = Math.floor( segments );

		// clamp phiLength so it's in range of [ 0, 2PI ]

		phiLength = clamp( phiLength, 0, Math.PI * 2 );

		// buffers

		const indices = [];
		const vertices = [];
		const uvs = [];
		const initNormals = [];
		const normals = [];

		// helper variables

		const inverseSegments = 1.0 / segments;
		const vertex = new Vector3();
		const uv = new Vector2();
		const normal = new Vector3();
		const curNormal = new Vector3();
		const prevNormal = new Vector3();
		let dx = 0;
		let dy = 0;

		// pre-compute normals for initial "meridian"

		for ( let j = 0; j <= ( points.length - 1 ); j ++ ) {

			switch ( j ) {

				case 0:				// special handling for 1st vertex on path

					dx = points[ j + 1 ].x - points[ j ].x;
					dy = points[ j + 1 ].y - points[ j ].y;

					normal.x = dy * 1.0;
					normal.y = - dx;
					normal.z = dy * 0.0;

					prevNormal.copy( normal );

					normal.normalize();

					initNormals.push( normal.x, normal.y, normal.z );

					break;

				case ( points.length - 1 ):	// special handling for last Vertex on path

					initNormals.push( prevNormal.x, prevNormal.y, prevNormal.z );

					break;

				default:			// default handling for all vertices in between

					dx = points[ j + 1 ].x - points[ j ].x;
					dy = points[ j + 1 ].y - points[ j ].y;

					normal.x = dy * 1.0;
					normal.y = - dx;
					normal.z = dy * 0.0;

					curNormal.copy( normal );

					normal.x += prevNormal.x;
					normal.y += prevNormal.y;
					normal.z += prevNormal.z;

					normal.normalize();

					initNormals.push( normal.x, normal.y, normal.z );

					prevNormal.copy( curNormal );

			}

		}

		// generate vertices, uvs and normals

		for ( let i = 0; i <= segments; i ++ ) {

			const phi = phiStart + i * inverseSegments * phiLength;

			const sin = Math.sin( phi );
			const cos = Math.cos( phi );

			for ( let j = 0; j <= ( points.length - 1 ); j ++ ) {

				// vertex

				vertex.x = points[ j ].x * sin;
				vertex.y = points[ j ].y;
				vertex.z = points[ j ].x * cos;

				vertices.push( vertex.x, vertex.y, vertex.z );

				// uv

				uv.x = i / segments;
				uv.y = j / ( points.length - 1 );

				uvs.push( uv.x, uv.y );

				// normal

				const x = initNormals[ 3 * j + 0 ] * sin;
				const y = initNormals[ 3 * j + 1 ];
				const z = initNormals[ 3 * j + 0 ] * cos;

				normals.push( x, y, z );

			}

		}

		// indices

		for ( let i = 0; i < segments; i ++ ) {

			for ( let j = 0; j < ( points.length - 1 ); j ++ ) {

				const base = j + i * points.length;

				const a = base;
				const b = base + points.length;
				const c = base + points.length + 1;
				const d = base + 1;

				// faces

				indices.push( a, b, d );
				indices.push( c, d, b );

			}

		}

		// build geometry

		this.setIndex( indices );
		this.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.setAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );
		this.setAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );

	}

	copy( source ) {

		super.copy( source );

		this.parameters = Object.assign( {}, source.parameters );

		return this;

	}

	static fromJSON( data ) {

		return new LatheGeometry( data.points, data.segments, data.phiStart, data.phiLength );

	}

}

class CapsuleGeometry extends LatheGeometry {

	constructor( radius = 1, length = 1, capSegments = 4, radialSegments = 8 ) {

		const path = new Path();
		path.absarc( 0, - length / 2, radius, Math.PI * 1.5, 0 );
		path.absarc( 0, length / 2, radius, 0, Math.PI * 0.5 );

		super( path.getPoints( capSegments ), radialSegments );

		this.type = 'CapsuleGeometry';

		this.parameters = {
			radius: radius,
			length: length,
			capSegments: capSegments,
			radialSegments: radialSegments,
		};

	}

	static fromJSON( data ) {

		return new CapsuleGeometry( data.radius, data.length, data.capSegments, data.radialSegments );

	}

}

class CircleGeometry extends BufferGeometry {

	constructor( radius = 1, segments = 32, thetaStart = 0, thetaLength = Math.PI * 2 ) {

		super();

		this.type = 'CircleGeometry';

		this.parameters = {
			radius: radius,
			segments: segments,
			thetaStart: thetaStart,
			thetaLength: thetaLength
		};

		segments = Math.max( 3, segments );

		// buffers

		const indices = [];
		const vertices = [];
		const normals = [];
		const uvs = [];

		// helper variables

		const vertex = new Vector3();
		const uv = new Vector2();

		// center point

		vertices.push( 0, 0, 0 );
		normals.push( 0, 0, 1 );
		uvs.push( 0.5, 0.5 );

		for ( let s = 0, i = 3; s <= segments; s ++, i += 3 ) {

			const segment = thetaStart + s / segments * thetaLength;

			// vertex

			vertex.x = radius * Math.cos( segment );
			vertex.y = radius * Math.sin( segment );

			vertices.push( vertex.x, vertex.y, vertex.z );

			// normal

			normals.push( 0, 0, 1 );

			// uvs

			uv.x = ( vertices[ i ] / radius + 1 ) / 2;
			uv.y = ( vertices[ i + 1 ] / radius + 1 ) / 2;

			uvs.push( uv.x, uv.y );

		}

		// indices

		for ( let i = 1; i <= segments; i ++ ) {

			indices.push( i, i + 1, 0 );

		}

		// build geometry

		this.setIndex( indices );
		this.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.setAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
		this.setAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

	}

	copy( source ) {

		super.copy( source );

		this.parameters = Object.assign( {}, source.parameters );

		return this;

	}

	static fromJSON( data ) {

		return new CircleGeometry( data.radius, data.segments, data.thetaStart, data.thetaLength );

	}

}

class CylinderGeometry extends BufferGeometry {

	constructor( radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2 ) {

		super();

		this.type = 'CylinderGeometry';

		this.parameters = {
			radiusTop: radiusTop,
			radiusBottom: radiusBottom,
			height: height,
			radialSegments: radialSegments,
			heightSegments: heightSegments,
			openEnded: openEnded,
			thetaStart: thetaStart,
			thetaLength: thetaLength
		};

		const scope = this;

		radialSegments = Math.floor( radialSegments );
		heightSegments = Math.floor( heightSegments );

		// buffers

		const indices = [];
		const vertices = [];
		const normals = [];
		const uvs = [];

		// helper variables

		let index = 0;
		const indexArray = [];
		const halfHeight = height / 2;
		let groupStart = 0;

		// generate geometry

		generateTorso();

		if ( openEnded === false ) {

			if ( radiusTop > 0 ) generateCap( true );
			if ( radiusBottom > 0 ) generateCap( false );

		}

		// build geometry

		this.setIndex( indices );
		this.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.setAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
		this.setAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

		function generateTorso() {

			const normal = new Vector3();
			const vertex = new Vector3();

			let groupCount = 0;

			// this will be used to calculate the normal
			const slope = ( radiusBottom - radiusTop ) / height;

			// generate vertices, normals and uvs

			for ( let y = 0; y <= heightSegments; y ++ ) {

				const indexRow = [];

				const v = y / heightSegments;

				// calculate the radius of the current row

				const radius = v * ( radiusBottom - radiusTop ) + radiusTop;

				for ( let x = 0; x <= radialSegments; x ++ ) {

					const u = x / radialSegments;

					const theta = u * thetaLength + thetaStart;

					const sinTheta = Math.sin( theta );
					const cosTheta = Math.cos( theta );

					// vertex

					vertex.x = radius * sinTheta;
					vertex.y = - v * height + halfHeight;
					vertex.z = radius * cosTheta;
					vertices.push( vertex.x, vertex.y, vertex.z );

					// normal

					normal.set( sinTheta, slope, cosTheta ).normalize();
					normals.push( normal.x, normal.y, normal.z );

					// uv

					uvs.push( u, 1 - v );

					// save index of vertex in respective row

					indexRow.push( index ++ );

				}

				// now save vertices of the row in our index array

				indexArray.push( indexRow );

			}

			// generate indices

			for ( let x = 0; x < radialSegments; x ++ ) {

				for ( let y = 0; y < heightSegments; y ++ ) {

					// we use the index array to access the correct indices

					const a = indexArray[ y ][ x ];
					const b = indexArray[ y + 1 ][ x ];
					const c = indexArray[ y + 1 ][ x + 1 ];
					const d = indexArray[ y ][ x + 1 ];

					// faces

					indices.push( a, b, d );
					indices.push( b, c, d );

					// update group counter

					groupCount += 6;

				}

			}

			// add a group to the geometry. this will ensure multi material support

			scope.addGroup( groupStart, groupCount, 0 );

			// calculate new start value for groups

			groupStart += groupCount;

		}

		function generateCap( top ) {

			// save the index of the first center vertex
			const centerIndexStart = index;

			const uv = new Vector2();
			const vertex = new Vector3();

			let groupCount = 0;

			const radius = ( top === true ) ? radiusTop : radiusBottom;
			const sign = ( top === true ) ? 1 : - 1;

			// first we generate the center vertex data of the cap.
			// because the geometry needs one set of uvs per face,
			// we must generate a center vertex per face/segment

			for ( let x = 1; x <= radialSegments; x ++ ) {

				// vertex

				vertices.push( 0, halfHeight * sign, 0 );

				// normal

				normals.push( 0, sign, 0 );

				// uv

				uvs.push( 0.5, 0.5 );

				// increase index

				index ++;

			}

			// save the index of the last center vertex
			const centerIndexEnd = index;

			// now we generate the surrounding vertices, normals and uvs

			for ( let x = 0; x <= radialSegments; x ++ ) {

				const u = x / radialSegments;
				const theta = u * thetaLength + thetaStart;

				const cosTheta = Math.cos( theta );
				const sinTheta = Math.sin( theta );

				// vertex

				vertex.x = radius * sinTheta;
				vertex.y = halfHeight * sign;
				vertex.z = radius * cosTheta;
				vertices.push( vertex.x, vertex.y, vertex.z );

				// normal

				normals.push( 0, sign, 0 );

				// uv

				uv.x = ( cosTheta * 0.5 ) + 0.5;
				uv.y = ( sinTheta * 0.5 * sign ) + 0.5;
				uvs.push( uv.x, uv.y );

				// increase index

				index ++;

			}

			// generate indices

			for ( let x = 0; x < radialSegments; x ++ ) {

				const c = centerIndexStart + x;
				const i = centerIndexEnd + x;

				if ( top === true ) {

					// face top

					indices.push( i, i + 1, c );

				} else {

					// face bottom

					indices.push( i + 1, i, c );

				}

				groupCount += 3;

			}

			// add a group to the geometry. this will ensure multi material support

			scope.addGroup( groupStart, groupCount, top === true ? 1 : 2 );

			// calculate new start value for groups

			groupStart += groupCount;

		}

	}

	copy( source ) {

		super.copy( source );

		this.parameters = Object.assign( {}, source.parameters );

		return this;

	}

	static fromJSON( data ) {

		return new CylinderGeometry( data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength );

	}

}

class ConeGeometry extends CylinderGeometry {

	constructor( radius = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2 ) {

		super( 0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength );

		this.type = 'ConeGeometry';

		this.parameters = {
			radius: radius,
			height: height,
			radialSegments: radialSegments,
			heightSegments: heightSegments,
			openEnded: openEnded,
			thetaStart: thetaStart,
			thetaLength: thetaLength
		};

	}

	static fromJSON( data ) {

		return new ConeGeometry( data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength );

	}

}

class PolyhedronGeometry extends BufferGeometry {

	constructor( vertices = [], indices = [], radius = 1, detail = 0 ) {

		super();

		this.type = 'PolyhedronGeometry';

		this.parameters = {
			vertices: vertices,
			indices: indices,
			radius: radius,
			detail: detail
		};

		// default buffer data

		const vertexBuffer = [];
		const uvBuffer = [];

		// the subdivision creates the vertex buffer data

		subdivide( detail );

		// all vertices should lie on a conceptual sphere with a given radius

		applyRadius( radius );

		// finally, create the uv data

		generateUVs();

		// build non-indexed geometry

		this.setAttribute( 'position', new Float32BufferAttribute( vertexBuffer, 3 ) );
		this.setAttribute( 'normal', new Float32BufferAttribute( vertexBuffer.slice(), 3 ) );
		this.setAttribute( 'uv', new Float32BufferAttribute( uvBuffer, 2 ) );

		if ( detail === 0 ) {

			this.computeVertexNormals(); // flat normals

		} else {

			this.normalizeNormals(); // smooth normals

		}

		// helper functions

		function subdivide( detail ) {

			const a = new Vector3();
			const b = new Vector3();
			const c = new Vector3();

			// iterate over all faces and apply a subdivision with the given detail value

			for ( let i = 0; i < indices.length; i += 3 ) {

				// get the vertices of the face

				getVertexByIndex( indices[ i + 0 ], a );
				getVertexByIndex( indices[ i + 1 ], b );
				getVertexByIndex( indices[ i + 2 ], c );

				// perform subdivision

				subdivideFace( a, b, c, detail );

			}

		}

		function subdivideFace( a, b, c, detail ) {

			const cols = detail + 1;

			// we use this multidimensional array as a data structure for creating the subdivision

			const v = [];

			// construct all of the vertices for this subdivision

			for ( let i = 0; i <= cols; i ++ ) {

				v[ i ] = [];

				const aj = a.clone().lerp( c, i / cols );
				const bj = b.clone().lerp( c, i / cols );

				const rows = cols - i;

				for ( let j = 0; j <= rows; j ++ ) {

					if ( j === 0 && i === cols ) {

						v[ i ][ j ] = aj;

					} else {

						v[ i ][ j ] = aj.clone().lerp( bj, j / rows );

					}

				}

			}

			// construct all of the faces

			for ( let i = 0; i < cols; i ++ ) {

				for ( let j = 0; j < 2 * ( cols - i ) - 1; j ++ ) {

					const k = Math.floor( j / 2 );

					if ( j % 2 === 0 ) {

						pushVertex( v[ i ][ k + 1 ] );
						pushVertex( v[ i + 1 ][ k ] );
						pushVertex( v[ i ][ k ] );

					} else {

						pushVertex( v[ i ][ k + 1 ] );
						pushVertex( v[ i + 1 ][ k + 1 ] );
						pushVertex( v[ i + 1 ][ k ] );

					}

				}

			}

		}

		function applyRadius( radius ) {

			const vertex = new Vector3();

			// iterate over the entire buffer and apply the radius to each vertex

			for ( let i = 0; i < vertexBuffer.length; i += 3 ) {

				vertex.x = vertexBuffer[ i + 0 ];
				vertex.y = vertexBuffer[ i + 1 ];
				vertex.z = vertexBuffer[ i + 2 ];

				vertex.normalize().multiplyScalar( radius );

				vertexBuffer[ i + 0 ] = vertex.x;
				vertexBuffer[ i + 1 ] = vertex.y;
				vertexBuffer[ i + 2 ] = vertex.z;

			}

		}

		function generateUVs() {

			const vertex = new Vector3();

			for ( let i = 0; i < vertexBuffer.length; i += 3 ) {

				vertex.x = vertexBuffer[ i + 0 ];
				vertex.y = vertexBuffer[ i + 1 ];
				vertex.z = vertexBuffer[ i + 2 ];

				const u = azimuth( vertex ) / 2 / Math.PI + 0.5;
				const v = inclination( vertex ) / Math.PI + 0.5;
				uvBuffer.push( u, 1 - v );

			}

			correctUVs();

			correctSeam();

		}

		function correctSeam() {

			// handle case when face straddles the seam, see #3269

			for ( let i = 0; i < uvBuffer.length; i += 6 ) {

				// uv data of a single face

				const x0 = uvBuffer[ i + 0 ];
				const x1 = uvBuffer[ i + 2 ];
				const x2 = uvBuffer[ i + 4 ];

				const max = Math.max( x0, x1, x2 );
				const min = Math.min( x0, x1, x2 );

				// 0.9 is somewhat arbitrary

				if ( max > 0.9 && min < 0.1 ) {

					if ( x0 < 0.2 ) uvBuffer[ i + 0 ] += 1;
					if ( x1 < 0.2 ) uvBuffer[ i + 2 ] += 1;
					if ( x2 < 0.2 ) uvBuffer[ i + 4 ] += 1;

				}

			}

		}

		function pushVertex( vertex ) {

			vertexBuffer.push( vertex.x, vertex.y, vertex.z );

		}

		function getVertexByIndex( index, vertex ) {

			const stride = index * 3;

			vertex.x = vertices[ stride + 0 ];
			vertex.y = vertices[ stride + 1 ];
			vertex.z = vertices[ stride + 2 ];

		}

		function correctUVs() {

			const a = new Vector3();
			const b = new Vector3();
			const c = new Vector3();

			const centroid = new Vector3();

			const uvA = new Vector2();
			const uvB = new Vector2();
			const uvC = new Vector2();

			for ( let i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6 ) {

				a.set( vertexBuffer[ i + 0 ], vertexBuffer[ i + 1 ], vertexBuffer[ i + 2 ] );
				b.set( vertexBuffer[ i + 3 ], vertexBuffer[ i + 4 ], vertexBuffer[ i + 5 ] );
				c.set( vertexBuffer[ i + 6 ], vertexBuffer[ i + 7 ], vertexBuffer[ i + 8 ] );

				uvA.set( uvBuffer[ j + 0 ], uvBuffer[ j + 1 ] );
				uvB.set( uvBuffer[ j + 2 ], uvBuffer[ j + 3 ] );
				uvC.set( uvBuffer[ j + 4 ], uvBuffer[ j + 5 ] );

				centroid.copy( a ).add( b ).add( c ).divideScalar( 3 );

				const azi = azimuth( centroid );

				correctUV( uvA, j + 0, a, azi );
				correctUV( uvB, j + 2, b, azi );
				correctUV( uvC, j + 4, c, azi );

			}

		}

		function correctUV( uv, stride, vector, azimuth ) {

			if ( ( azimuth < 0 ) && ( uv.x === 1 ) ) {

				uvBuffer[ stride ] = uv.x - 1;

			}

			if ( ( vector.x === 0 ) && ( vector.z === 0 ) ) {

				uvBuffer[ stride ] = azimuth / 2 / Math.PI + 0.5;

			}

		}

		// Angle around the Y axis, counter-clockwise when looking from above.

		function azimuth( vector ) {

			return Math.atan2( vector.z, - vector.x );

		}


		// Angle above the XZ plane.

		function inclination( vector ) {

			return Math.atan2( - vector.y, Math.sqrt( ( vector.x * vector.x ) + ( vector.z * vector.z ) ) );

		}

	}

	copy( source ) {

		super.copy( source );

		this.parameters = Object.assign( {}, source.parameters );

		return this;

	}

	static fromJSON( data ) {

		return new PolyhedronGeometry( data.vertices, data.indices, data.radius, data.details );

	}

}

class DodecahedronGeometry extends PolyhedronGeometry {

	constructor( radius = 1, detail = 0 ) {

		const t = ( 1 + Math.sqrt( 5 ) ) / 2;
		const r = 1 / t;

		const vertices = [

			// (±1, ±1, ±1)
			- 1, - 1, - 1,	- 1, - 1, 1,
			- 1, 1, - 1, - 1, 1, 1,
			1, - 1, - 1, 1, - 1, 1,
			1, 1, - 1, 1, 1, 1,

			// (0, ±1/φ, ±φ)
			0, - r, - t, 0, - r, t,
			0, r, - t, 0, r, t,

			// (±1/φ, ±φ, 0)
			- r, - t, 0, - r, t, 0,
			r, - t, 0, r, t, 0,

			// (±φ, 0, ±1/φ)
			- t, 0, - r, t, 0, - r,
			- t, 0, r, t, 0, r
		];

		const indices = [
			3, 11, 7, 	3, 7, 15, 	3, 15, 13,
			7, 19, 17, 	7, 17, 6, 	7, 6, 15,
			17, 4, 8, 	17, 8, 10, 	17, 10, 6,
			8, 0, 16, 	8, 16, 2, 	8, 2, 10,
			0, 12, 1, 	0, 1, 18, 	0, 18, 16,
			6, 10, 2, 	6, 2, 13, 	6, 13, 15,
			2, 16, 18, 	2, 18, 3, 	2, 3, 13,
			18, 1, 9, 	18, 9, 11, 	18, 11, 3,
			4, 14, 12, 	4, 12, 0, 	4, 0, 8,
			11, 9, 5, 	11, 5, 19, 	11, 19, 7,
			19, 5, 14, 	19, 14, 4, 	19, 4, 17,
			1, 12, 14, 	1, 14, 5, 	1, 5, 9
		];

		super( vertices, indices, radius, detail );

		this.type = 'DodecahedronGeometry';

		this.parameters = {
			radius: radius,
			detail: detail
		};

	}

	static fromJSON( data ) {

		return new DodecahedronGeometry( data.radius, data.detail );

	}

}

const _v0 = /*@__PURE__*/ new Vector3();
const _v1$1 = /*@__PURE__*/ new Vector3();
const _normal = /*@__PURE__*/ new Vector3();
const _triangle = /*@__PURE__*/ new Triangle();

class EdgesGeometry extends BufferGeometry {

	constructor( geometry = null, thresholdAngle = 1 ) {

		super();

		this.type = 'EdgesGeometry';

		this.parameters = {
			geometry: geometry,
			thresholdAngle: thresholdAngle
		};

		if ( geometry !== null ) {

			const precisionPoints = 4;
			const precision = Math.pow( 10, precisionPoints );
			const thresholdDot = Math.cos( DEG2RAD * thresholdAngle );

			const indexAttr = geometry.getIndex();
			const positionAttr = geometry.getAttribute( 'position' );
			const indexCount = indexAttr ? indexAttr.count : positionAttr.count;

			const indexArr = [ 0, 0, 0 ];
			const vertKeys = [ 'a', 'b', 'c' ];
			const hashes = new Array( 3 );

			const edgeData = {};
			const vertices = [];
			for ( let i = 0; i < indexCount; i += 3 ) {

				if ( indexAttr ) {

					indexArr[ 0 ] = indexAttr.getX( i );
					indexArr[ 1 ] = indexAttr.getX( i + 1 );
					indexArr[ 2 ] = indexAttr.getX( i + 2 );

				} else {

					indexArr[ 0 ] = i;
					indexArr[ 1 ] = i + 1;
					indexArr[ 2 ] = i + 2;

				}

				const { a, b, c } = _triangle;
				a.fromBufferAttribute( positionAttr, indexArr[ 0 ] );
				b.fromBufferAttribute( positionAttr, indexArr[ 1 ] );
				c.fromBufferAttribute( positionAttr, indexArr[ 2 ] );
				_triangle.getNormal( _normal );

				// create hashes for the edge from the vertices
				hashes[ 0 ] = `${ Math.round( a.x * precision ) },${ Math.round( a.y * precision ) },${ Math.round( a.z * precision ) }`;
				hashes[ 1 ] = `${ Math.round( b.x * precision ) },${ Math.round( b.y * precision ) },${ Math.round( b.z * precision ) }`;
				hashes[ 2 ] = `${ Math.round( c.x * precision ) },${ Math.round( c.y * precision ) },${ Math.round( c.z * precision ) }`;

				// skip degenerate triangles
				if ( hashes[ 0 ] === hashes[ 1 ] || hashes[ 1 ] === hashes[ 2 ] || hashes[ 2 ] === hashes[ 0 ] ) {

					continue;

				}

				// iterate over every edge
				for ( let j = 0; j < 3; j ++ ) {

					// get the first and next vertex making up the edge
					const jNext = ( j + 1 ) % 3;
					const vecHash0 = hashes[ j ];
					const vecHash1 = hashes[ jNext ];
					const v0 = _triangle[ vertKeys[ j ] ];
					const v1 = _triangle[ vertKeys[ jNext ] ];

					const hash = `${ vecHash0 }_${ vecHash1 }`;
					const reverseHash = `${ vecHash1 }_${ vecHash0 }`;

					if ( reverseHash in edgeData && edgeData[ reverseHash ] ) {

						// if we found a sibling edge add it into the vertex array if
						// it meets the angle threshold and delete the edge from the map.
						if ( _normal.dot( edgeData[ reverseHash ].normal ) <= thresholdDot ) {

							vertices.push( v0.x, v0.y, v0.z );
							vertices.push( v1.x, v1.y, v1.z );

						}

						edgeData[ reverseHash ] = null;

					} else if ( ! ( hash in edgeData ) ) {

						// if we've already got an edge here then skip adding a new one
						edgeData[ hash ] = {

							index0: indexArr[ j ],
							index1: indexArr[ jNext ],
							normal: _normal.clone(),

						};

					}

				}

			}

			// iterate over all remaining, unmatched edges and add them to the vertex array
			for ( const key in edgeData ) {

				if ( edgeData[ key ] ) {

					const { index0, index1 } = edgeData[ key ];
					_v0.fromBufferAttribute( positionAttr, index0 );
					_v1$1.fromBufferAttribute( positionAttr, index1 );

					vertices.push( _v0.x, _v0.y, _v0.z );
					vertices.push( _v1$1.x, _v1$1.y, _v1$1.z );

				}

			}

			this.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );

		}

	}

	copy( source ) {

		super.copy( source );

		this.parameters = Object.assign( {}, source.parameters );

		return this;

	}

}

class Shape extends Path {

	constructor( points ) {

		super( points );

		this.uuid = generateUUID();

		this.type = 'Shape';

		this.holes = [];

	}

	getPointsHoles( divisions ) {

		const holesPts = [];

		for ( let i = 0, l = this.holes.length; i < l; i ++ ) {

			holesPts[ i ] = this.holes[ i ].getPoints( divisions );

		}

		return holesPts;

	}

	// get points of shape and holes (keypoints based on segments parameter)

	extractPoints( divisions ) {

		return {

			shape: this.getPoints( divisions ),
			holes: this.getPointsHoles( divisions )

		};

	}

	copy( source ) {

		super.copy( source );

		this.holes = [];

		for ( let i = 0, l = source.holes.length; i < l; i ++ ) {

			const hole = source.holes[ i ];

			this.holes.push( hole.clone() );

		}

		return this;

	}

	toJSON() {

		const data = super.toJSON();

		data.uuid = this.uuid;
		data.holes = [];

		for ( let i = 0, l = this.holes.length; i < l; i ++ ) {

			const hole = this.holes[ i ];
			data.holes.push( hole.toJSON() );

		}

		return data;

	}

	fromJSON( json ) {

		super.fromJSON( json );

		this.uuid = json.uuid;
		this.holes = [];

		for ( let i = 0, l = json.holes.length; i < l; i ++ ) {

			const hole = json.holes[ i ];
			this.holes.push( new Path().fromJSON( hole ) );

		}

		return this;

	}

}

/**
 * Port from https://github.com/mapbox/earcut (v2.2.4)
 */

const Earcut = {

	triangulate: function ( data, holeIndices, dim = 2 ) {

		const hasHoles = holeIndices && holeIndices.length;
		const outerLen = hasHoles ? holeIndices[ 0 ] * dim : data.length;
		let outerNode = linkedList( data, 0, outerLen, dim, true );
		const triangles = [];

		if ( ! outerNode || outerNode.next === outerNode.prev ) return triangles;

		let minX, minY, maxX, maxY, x, y, invSize;

		if ( hasHoles ) outerNode = eliminateHoles( data, holeIndices, outerNode, dim );

		// if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
		if ( data.length > 80 * dim ) {

			minX = maxX = data[ 0 ];
			minY = maxY = data[ 1 ];

			for ( let i = dim; i < outerLen; i += dim ) {

				x = data[ i ];
				y = data[ i + 1 ];
				if ( x < minX ) minX = x;
				if ( y < minY ) minY = y;
				if ( x > maxX ) maxX = x;
				if ( y > maxY ) maxY = y;

			}

			// minX, minY and invSize are later used to transform coords into integers for z-order calculation
			invSize = Math.max( maxX - minX, maxY - minY );
			invSize = invSize !== 0 ? 32767 / invSize : 0;

		}

		earcutLinked( outerNode, triangles, dim, minX, minY, invSize, 0 );

		return triangles;

	}

};

// create a circular doubly linked list from polygon points in the specified winding order
function linkedList( data, start, end, dim, clockwise ) {

	let i, last;

	if ( clockwise === ( signedArea( data, start, end, dim ) > 0 ) ) {

		for ( i = start; i < end; i += dim ) last = insertNode( i, data[ i ], data[ i + 1 ], last );

	} else {

		for ( i = end - dim; i >= start; i -= dim ) last = insertNode( i, data[ i ], data[ i + 1 ], last );

	}

	if ( last && equals( last, last.next ) ) {

		removeNode( last );
		last = last.next;

	}

	return last;

}

// eliminate colinear or duplicate points
function filterPoints( start, end ) {

	if ( ! start ) return start;
	if ( ! end ) end = start;

	let p = start,
		again;
	do {

		again = false;

		if ( ! p.steiner && ( equals( p, p.next ) || area( p.prev, p, p.next ) === 0 ) ) {

			removeNode( p );
			p = end = p.prev;
			if ( p === p.next ) break;
			again = true;

		} else {

			p = p.next;

		}

	} while ( again || p !== end );

	return end;

}

// main ear slicing loop which triangulates a polygon (given as a linked list)
function earcutLinked( ear, triangles, dim, minX, minY, invSize, pass ) {

	if ( ! ear ) return;

	// interlink polygon nodes in z-order
	if ( ! pass && invSize ) indexCurve( ear, minX, minY, invSize );

	let stop = ear,
		prev, next;

	// iterate through ears, slicing them one by one
	while ( ear.prev !== ear.next ) {

		prev = ear.prev;
		next = ear.next;

		if ( invSize ? isEarHashed( ear, minX, minY, invSize ) : isEar( ear ) ) {

			// cut off the triangle
			triangles.push( prev.i / dim | 0 );
			triangles.push( ear.i / dim | 0 );
			triangles.push( next.i / dim | 0 );

			removeNode( ear );

			// skipping the next vertex leads to less sliver triangles
			ear = next.next;
			stop = next.next;

			continue;

		}

		ear = next;

		// if we looped through the whole remaining polygon and can't find any more ears
		if ( ear === stop ) {

			// try filtering points and slicing again
			if ( ! pass ) {

				earcutLinked( filterPoints( ear ), triangles, dim, minX, minY, invSize, 1 );

				// if this didn't work, try curing all small self-intersections locally

			} else if ( pass === 1 ) {

				ear = cureLocalIntersections( filterPoints( ear ), triangles, dim );
				earcutLinked( ear, triangles, dim, minX, minY, invSize, 2 );

				// as a last resort, try splitting the remaining polygon into two

			} else if ( pass === 2 ) {

				splitEarcut( ear, triangles, dim, minX, minY, invSize );

			}

			break;

		}

	}

}

// check whether a polygon node forms a valid ear with adjacent nodes
function isEar( ear ) {

	const a = ear.prev,
		b = ear,
		c = ear.next;

	if ( area( a, b, c ) >= 0 ) return false; // reflex, can't be an ear

	// now make sure we don't have other points inside the potential ear
	const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;

	// triangle bbox; min & max are calculated like this for speed
	const x0 = ax < bx ? ( ax < cx ? ax : cx ) : ( bx < cx ? bx : cx ),
		y0 = ay < by ? ( ay < cy ? ay : cy ) : ( by < cy ? by : cy ),
		x1 = ax > bx ? ( ax > cx ? ax : cx ) : ( bx > cx ? bx : cx ),
		y1 = ay > by ? ( ay > cy ? ay : cy ) : ( by > cy ? by : cy );

	let p = c.next;
	while ( p !== a ) {

		if ( p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 &&
			pointInTriangle( ax, ay, bx, by, cx, cy, p.x, p.y ) &&
			area( p.prev, p, p.next ) >= 0 ) return false;
		p = p.next;

	}

	return true;

}

function isEarHashed( ear, minX, minY, invSize ) {

	const a = ear.prev,
		b = ear,
		c = ear.next;

	if ( area( a, b, c ) >= 0 ) return false; // reflex, can't be an ear

	const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;

	// triangle bbox; min & max are calculated like this for speed
	const x0 = ax < bx ? ( ax < cx ? ax : cx ) : ( bx < cx ? bx : cx ),
		y0 = ay < by ? ( ay < cy ? ay : cy ) : ( by < cy ? by : cy ),
		x1 = ax > bx ? ( ax > cx ? ax : cx ) : ( bx > cx ? bx : cx ),
		y1 = ay > by ? ( ay > cy ? ay : cy ) : ( by > cy ? by : cy );

	// z-order range for the current triangle bbox;
	const minZ = zOrder( x0, y0, minX, minY, invSize ),
		maxZ = zOrder( x1, y1, minX, minY, invSize );

	let p = ear.prevZ,
		n = ear.nextZ;

	// look for points inside the triangle in both directions
	while ( p && p.z >= minZ && n && n.z <= maxZ ) {

		if ( p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c &&
			pointInTriangle( ax, ay, bx, by, cx, cy, p.x, p.y ) && area( p.prev, p, p.next ) >= 0 ) return false;
		p = p.prevZ;

		if ( n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c &&
			pointInTriangle( ax, ay, bx, by, cx, cy, n.x, n.y ) && area( n.prev, n, n.next ) >= 0 ) return false;
		n = n.nextZ;

	}

	// look for remaining points in decreasing z-order
	while ( p && p.z >= minZ ) {

		if ( p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c &&
			pointInTriangle( ax, ay, bx, by, cx, cy, p.x, p.y ) && area( p.prev, p, p.next ) >= 0 ) return false;
		p = p.prevZ;

	}

	// look for remaining points in increasing z-order
	while ( n && n.z <= maxZ ) {

		if ( n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c &&
			pointInTriangle( ax, ay, bx, by, cx, cy, n.x, n.y ) && area( n.prev, n, n.next ) >= 0 ) return false;
		n = n.nextZ;

	}

	return true;

}

// go through all polygon nodes and cure small local self-intersections
function cureLocalIntersections( start, triangles, dim ) {

	let p = start;
	do {

		const a = p.prev,
			b = p.next.next;

		if ( ! equals( a, b ) && intersects( a, p, p.next, b ) && locallyInside( a, b ) && locallyInside( b, a ) ) {

			triangles.push( a.i / dim | 0 );
			triangles.push( p.i / dim | 0 );
			triangles.push( b.i / dim | 0 );

			// remove two nodes involved
			removeNode( p );
			removeNode( p.next );

			p = start = b;

		}

		p = p.next;

	} while ( p !== start );

	return filterPoints( p );

}

// try splitting polygon into two and triangulate them independently
function splitEarcut( start, triangles, dim, minX, minY, invSize ) {

	// look for a valid diagonal that divides the polygon into two
	let a = start;
	do {

		let b = a.next.next;
		while ( b !== a.prev ) {

			if ( a.i !== b.i && isValidDiagonal( a, b ) ) {

				// split the polygon in two by the diagonal
				let c = splitPolygon( a, b );

				// filter colinear points around the cuts
				a = filterPoints( a, a.next );
				c = filterPoints( c, c.next );

				// run earcut on each half
				earcutLinked( a, triangles, dim, minX, minY, invSize, 0 );
				earcutLinked( c, triangles, dim, minX, minY, invSize, 0 );
				return;

			}

			b = b.next;

		}

		a = a.next;

	} while ( a !== start );

}

// link every hole into the outer loop, producing a single-ring polygon without holes
function eliminateHoles( data, holeIndices, outerNode, dim ) {

	const queue = [];
	let i, len, start, end, list;

	for ( i = 0, len = holeIndices.length; i < len; i ++ ) {

		start = holeIndices[ i ] * dim;
		end = i < len - 1 ? holeIndices[ i + 1 ] * dim : data.length;
		list = linkedList( data, start, end, dim, false );
		if ( list === list.next ) list.steiner = true;
		queue.push( getLeftmost( list ) );

	}

	queue.sort( compareX );

	// process holes from left to right
	for ( i = 0; i < queue.length; i ++ ) {

		outerNode = eliminateHole( queue[ i ], outerNode );

	}

	return outerNode;

}

function compareX( a, b ) {

	return a.x - b.x;

}

// find a bridge between vertices that connects hole with an outer ring and link it
function eliminateHole( hole, outerNode ) {

	const bridge = findHoleBridge( hole, outerNode );
	if ( ! bridge ) {

		return outerNode;

	}

	const bridgeReverse = splitPolygon( bridge, hole );

	// filter collinear points around the cuts
	filterPoints( bridgeReverse, bridgeReverse.next );
	return filterPoints( bridge, bridge.next );

}

// David Eberly's algorithm for finding a bridge between hole and outer polygon
function findHoleBridge( hole, outerNode ) {

	let p = outerNode,
		qx = - Infinity,
		m;

	const hx = hole.x, hy = hole.y;

	// find a segment intersected by a ray from the hole's leftmost point to the left;
	// segment's endpoint with lesser x will be potential connection point
	do {

		if ( hy <= p.y && hy >= p.next.y && p.next.y !== p.y ) {

			const x = p.x + ( hy - p.y ) * ( p.next.x - p.x ) / ( p.next.y - p.y );
			if ( x <= hx && x > qx ) {

				qx = x;
				m = p.x < p.next.x ? p : p.next;
				if ( x === hx ) return m; // hole touches outer segment; pick leftmost endpoint

			}

		}

		p = p.next;

	} while ( p !== outerNode );

	if ( ! m ) return null;

	// look for points inside the triangle of hole point, segment intersection and endpoint;
	// if there are no points found, we have a valid connection;
	// otherwise choose the point of the minimum angle with the ray as connection point

	const stop = m,
		mx = m.x,
		my = m.y;
	let tanMin = Infinity, tan;

	p = m;

	do {

		if ( hx >= p.x && p.x >= mx && hx !== p.x &&
				pointInTriangle( hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y ) ) {

			tan = Math.abs( hy - p.y ) / ( hx - p.x ); // tangential

			if ( locallyInside( p, hole ) && ( tan < tanMin || ( tan === tanMin && ( p.x > m.x || ( p.x === m.x && sectorContainsSector( m, p ) ) ) ) ) ) {

				m = p;
				tanMin = tan;

			}

		}

		p = p.next;

	} while ( p !== stop );

	return m;

}

// whether sector in vertex m contains sector in vertex p in the same coordinates
function sectorContainsSector( m, p ) {

	return area( m.prev, m, p.prev ) < 0 && area( p.next, m, m.next ) < 0;

}

// interlink polygon nodes in z-order
function indexCurve( start, minX, minY, invSize ) {

	let p = start;
	do {

		if ( p.z === 0 ) p.z = zOrder( p.x, p.y, minX, minY, invSize );
		p.prevZ = p.prev;
		p.nextZ = p.next;
		p = p.next;

	} while ( p !== start );

	p.prevZ.nextZ = null;
	p.prevZ = null;

	sortLinked( p );

}

// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function sortLinked( list ) {

	let i, p, q, e, tail, numMerges, pSize, qSize,
		inSize = 1;

	do {

		p = list;
		list = null;
		tail = null;
		numMerges = 0;

		while ( p ) {

			numMerges ++;
			q = p;
			pSize = 0;
			for ( i = 0; i < inSize; i ++ ) {

				pSize ++;
				q = q.nextZ;
				if ( ! q ) break;

			}

			qSize = inSize;

			while ( pSize > 0 || ( qSize > 0 && q ) ) {

				if ( pSize !== 0 && ( qSize === 0 || ! q || p.z <= q.z ) ) {

					e = p;
					p = p.nextZ;
					pSize --;

				} else {

					e = q;
					q = q.nextZ;
					qSize --;

				}

				if ( tail ) tail.nextZ = e;
				else list = e;

				e.prevZ = tail;
				tail = e;

			}

			p = q;

		}

		tail.nextZ = null;
		inSize *= 2;

	} while ( numMerges > 1 );

	return list;

}

// z-order of a point given coords and inverse of the longer side of data bbox
function zOrder( x, y, minX, minY, invSize ) {

	// coords are transformed into non-negative 15-bit integer range
	x = ( x - minX ) * invSize | 0;
	y = ( y - minY ) * invSize | 0;

	x = ( x | ( x << 8 ) ) & 0x00FF00FF;
	x = ( x | ( x << 4 ) ) & 0x0F0F0F0F;
	x = ( x | ( x << 2 ) ) & 0x33333333;
	x = ( x | ( x << 1 ) ) & 0x55555555;

	y = ( y | ( y << 8 ) ) & 0x00FF00FF;
	y = ( y | ( y << 4 ) ) & 0x0F0F0F0F;
	y = ( y | ( y << 2 ) ) & 0x33333333;
	y = ( y | ( y << 1 ) ) & 0x55555555;

	return x | ( y << 1 );

}

// find the leftmost node of a polygon ring
function getLeftmost( start ) {

	let p = start,
		leftmost = start;
	do {

		if ( p.x < leftmost.x || ( p.x === leftmost.x && p.y < leftmost.y ) ) leftmost = p;
		p = p.next;

	} while ( p !== start );

	return leftmost;

}

// check if a point lies within a convex triangle
function pointInTriangle( ax, ay, bx, by, cx, cy, px, py ) {

	return ( cx - px ) * ( ay - py ) >= ( ax - px ) * ( cy - py ) &&
           ( ax - px ) * ( by - py ) >= ( bx - px ) * ( ay - py ) &&
           ( bx - px ) * ( cy - py ) >= ( cx - px ) * ( by - py );

}

// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function isValidDiagonal( a, b ) {

	return a.next.i !== b.i && a.prev.i !== b.i && ! intersectsPolygon( a, b ) && // dones't intersect other edges
           ( locallyInside( a, b ) && locallyInside( b, a ) && middleInside( a, b ) && // locally visible
            ( area( a.prev, a, b.prev ) || area( a, b.prev, b ) ) || // does not create opposite-facing sectors
            equals( a, b ) && area( a.prev, a, a.next ) > 0 && area( b.prev, b, b.next ) > 0 ); // special zero-length case

}

// signed area of a triangle
function area( p, q, r ) {

	return ( q.y - p.y ) * ( r.x - q.x ) - ( q.x - p.x ) * ( r.y - q.y );

}

// check if two points are equal
function equals( p1, p2 ) {

	return p1.x === p2.x && p1.y === p2.y;

}

// check if two segments intersect
function intersects( p1, q1, p2, q2 ) {

	const o1 = sign( area( p1, q1, p2 ) );
	const o2 = sign( area( p1, q1, q2 ) );
	const o3 = sign( area( p2, q2, p1 ) );
	const o4 = sign( area( p2, q2, q1 ) );

	if ( o1 !== o2 && o3 !== o4 ) return true; // general case

	if ( o1 === 0 && onSegment( p1, p2, q1 ) ) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
	if ( o2 === 0 && onSegment( p1, q2, q1 ) ) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
	if ( o3 === 0 && onSegment( p2, p1, q2 ) ) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
	if ( o4 === 0 && onSegment( p2, q1, q2 ) ) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2

	return false;

}

// for collinear points p, q, r, check if point q lies on segment pr
function onSegment( p, q, r ) {

	return q.x <= Math.max( p.x, r.x ) && q.x >= Math.min( p.x, r.x ) && q.y <= Math.max( p.y, r.y ) && q.y >= Math.min( p.y, r.y );

}

function sign( num ) {

	return num > 0 ? 1 : num < 0 ? - 1 : 0;

}

// check if a polygon diagonal intersects any polygon segments
function intersectsPolygon( a, b ) {

	let p = a;
	do {

		if ( p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i &&
			intersects( p, p.next, a, b ) ) return true;
		p = p.next;

	} while ( p !== a );

	return false;

}

// check if a polygon diagonal is locally inside the polygon
function locallyInside( a, b ) {

	return area( a.prev, a, a.next ) < 0 ?
		area( a, b, a.next ) >= 0 && area( a, a.prev, b ) >= 0 :
		area( a, b, a.prev ) < 0 || area( a, a.next, b ) < 0;

}

// check if the middle point of a polygon diagonal is inside the polygon
function middleInside( a, b ) {

	let p = a,
		inside = false;
	const px = ( a.x + b.x ) / 2,
		py = ( a.y + b.y ) / 2;
	do {

		if ( ( ( p.y > py ) !== ( p.next.y > py ) ) && p.next.y !== p.y &&
			( px < ( p.next.x - p.x ) * ( py - p.y ) / ( p.next.y - p.y ) + p.x ) )
			inside = ! inside;
		p = p.next;

	} while ( p !== a );

	return inside;

}

// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function splitPolygon( a, b ) {

	const a2 = new Node( a.i, a.x, a.y ),
		b2 = new Node( b.i, b.x, b.y ),
		an = a.next,
		bp = b.prev;

	a.next = b;
	b.prev = a;

	a2.next = an;
	an.prev = a2;

	b2.next = a2;
	a2.prev = b2;

	bp.next = b2;
	b2.prev = bp;

	return b2;

}

// create a node and optionally link it with previous one (in a circular doubly linked list)
function insertNode( i, x, y, last ) {

	const p = new Node( i, x, y );

	if ( ! last ) {

		p.prev = p;
		p.next = p;

	} else {

		p.next = last.next;
		p.prev = last;
		last.next.prev = p;
		last.next = p;

	}

	return p;

}

function removeNode( p ) {

	p.next.prev = p.prev;
	p.prev.next = p.next;

	if ( p.prevZ ) p.prevZ.nextZ = p.nextZ;
	if ( p.nextZ ) p.nextZ.prevZ = p.prevZ;

}

function Node( i, x, y ) {

	// vertex index in coordinates array
	this.i = i;

	// vertex coordinates
	this.x = x;
	this.y = y;

	// previous and next vertex nodes in a polygon ring
	this.prev = null;
	this.next = null;

	// z-order curve value
	this.z = 0;

	// previous and next nodes in z-order
	this.prevZ = null;
	this.nextZ = null;

	// indicates whether this is a steiner point
	this.steiner = false;

}

function signedArea( data, start, end, dim ) {

	let sum = 0;
	for ( let i = start, j = end - dim; i < end; i += dim ) {

		sum += ( data[ j ] - data[ i ] ) * ( data[ i + 1 ] + data[ j + 1 ] );
		j = i;

	}

	return sum;

}

class ShapeUtils {

	// calculate area of the contour polygon

	static area( contour ) {

		const n = contour.length;
		let a = 0.0;

		for ( let p = n - 1, q = 0; q < n; p = q ++ ) {

			a += contour[ p ].x * contour[ q ].y - contour[ q ].x * contour[ p ].y;

		}

		return a * 0.5;

	}

	static isClockWise( pts ) {

		return ShapeUtils.area( pts ) < 0;

	}

	static triangulateShape( contour, holes ) {

		const vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
		const holeIndices = []; // array of hole indices
		const faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]

		removeDupEndPts( contour );
		addContour( vertices, contour );

		//

		let holeIndex = contour.length;

		holes.forEach( removeDupEndPts );

		for ( let i = 0; i < holes.length; i ++ ) {

			holeIndices.push( holeIndex );
			holeIndex += holes[ i ].length;
			addContour( vertices, holes[ i ] );

		}

		//

		const triangles = Earcut.triangulate( vertices, holeIndices );

		//

		for ( let i = 0; i < triangles.length; i += 3 ) {

			faces.push( triangles.slice( i, i + 3 ) );

		}

		return faces;

	}

}

function removeDupEndPts( points ) {

	const l = points.length;

	if ( l > 2 && points[ l - 1 ].equals( points[ 0 ] ) ) {

		points.pop();

	}

}

function addContour( vertices, contour ) {

	for ( let i = 0; i < contour.length; i ++ ) {

		vertices.push( contour[ i ].x );
		vertices.push( contour[ i ].y );

	}

}

/**
 * Creates extruded geometry from a path shape.
 *
 * parameters = {
 *
 *  curveSegments: <int>, // number of points on the curves
 *  steps: <int>, // number of points for z-side extrusions / used for subdividing segments of extrude spline too
 *  depth: <float>, // Depth to extrude the shape
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into the original shape bevel goes
 *  bevelSize: <float>, // how far from shape outline (including bevelOffset) is bevel
 *  bevelOffset: <float>, // how far from shape outline does bevel start
 *  bevelSegments: <int>, // number of bevel layers
 *
 *  extrudePath: <THREE.Curve> // curve to extrude shape along
 *
 *  UVGenerator: <Object> // object that provides UV generator functions
 *
 * }
 */


class ExtrudeGeometry extends BufferGeometry {

	constructor( shapes = new Shape( [ new Vector2( 0.5, 0.5 ), new Vector2( - 0.5, 0.5 ), new Vector2( - 0.5, - 0.5 ), new Vector2( 0.5, - 0.5 ) ] ), options = {} ) {

		super();

		this.type = 'ExtrudeGeometry';

		this.parameters = {
			shapes: shapes,
			options: options
		};

		shapes = Array.isArray( shapes ) ? shapes : [ shapes ];

		const scope = this;

		const verticesArray = [];
		const uvArray = [];

		for ( let i = 0, l = shapes.length; i < l; i ++ ) {

			const shape = shapes[ i ];
			addShape( shape );

		}

		// build geometry

		this.setAttribute( 'position', new Float32BufferAttribute( verticesArray, 3 ) );
		this.setAttribute( 'uv', new Float32BufferAttribute( uvArray, 2 ) );

		this.computeVertexNormals();

		// functions

		function addShape( shape ) {

			const placeholder = [];

			// options

			const curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
			const steps = options.steps !== undefined ? options.steps : 1;
			const depth = options.depth !== undefined ? options.depth : 1;

			let bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true;
			let bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 0.2;
			let bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 0.1;
			let bevelOffset = options.bevelOffset !== undefined ? options.bevelOffset : 0;
			let bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;

			const extrudePath = options.extrudePath;

			const uvgen = options.UVGenerator !== undefined ? options.UVGenerator : WorldUVGenerator;

			//

			let extrudePts, extrudeByPath = false;
			let splineTube, binormal, normal, position2;

			if ( extrudePath ) {

				extrudePts = extrudePath.getSpacedPoints( steps );

				extrudeByPath = true;
				bevelEnabled = false; // bevels not supported for path extrusion

				// SETUP TNB variables

				// TODO1 - have a .isClosed in spline?

				splineTube = extrudePath.computeFrenetFrames( steps, false );

				// console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);

				binormal = new Vector3();
				normal = new Vector3();
				position2 = new Vector3();

			}

			// Safeguards if bevels are not enabled

			if ( ! bevelEnabled ) {

				bevelSegments = 0;
				bevelThickness = 0;
				bevelSize = 0;
				bevelOffset = 0;

			}

			// Variables initialization

			const shapePoints = shape.extractPoints( curveSegments );

			let vertices = shapePoints.shape;
			const holes = shapePoints.holes;

			const reverse = ! ShapeUtils.isClockWise( vertices );

			if ( reverse ) {

				vertices = vertices.reverse();

				// Maybe we should also check if holes are in the opposite direction, just to be safe ...

				for ( let h = 0, hl = holes.length; h < hl; h ++ ) {

					const ahole = holes[ h ];

					if ( ShapeUtils.isClockWise( ahole ) ) {

						holes[ h ] = ahole.reverse();

					}

				}

			}


			const faces = ShapeUtils.triangulateShape( vertices, holes );

			/* Vertices */

			const contour = vertices; // vertices has all points but contour has only points of circumference

			for ( let h = 0, hl = holes.length; h < hl; h ++ ) {

				const ahole = holes[ h ];

				vertices = vertices.concat( ahole );

			}


			function scalePt2( pt, vec, size ) {

				if ( ! vec ) console.error( 'THREE.ExtrudeGeometry: vec does not exist' );

				return pt.clone().addScaledVector( vec, size );

			}

			const vlen = vertices.length, flen = faces.length;


			// Find directions for point movement


			function getBevelVec( inPt, inPrev, inNext ) {

				// computes for inPt the corresponding point inPt' on a new contour
				//   shifted by 1 unit (length of normalized vector) to the left
				// if we walk along contour clockwise, this new contour is outside the old one
				//
				// inPt' is the intersection of the two lines parallel to the two
				//  adjacent edges of inPt at a distance of 1 unit on the left side.

				let v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt

				// good reading for geometry algorithms (here: line-line intersection)
				// http://geomalgorithms.com/a05-_intersect-1.html

				const v_prev_x = inPt.x - inPrev.x,
					v_prev_y = inPt.y - inPrev.y;
				const v_next_x = inNext.x - inPt.x,
					v_next_y = inNext.y - inPt.y;

				const v_prev_lensq = ( v_prev_x * v_prev_x + v_prev_y * v_prev_y );

				// check for collinear edges
				const collinear0 = ( v_prev_x * v_next_y - v_prev_y * v_next_x );

				if ( Math.abs( collinear0 ) > Number.EPSILON ) {

					// not collinear

					// length of vectors for normalizing

					const v_prev_len = Math.sqrt( v_prev_lensq );
					const v_next_len = Math.sqrt( v_next_x * v_next_x + v_next_y * v_next_y );

					// shift adjacent points by unit vectors to the left

					const ptPrevShift_x = ( inPrev.x - v_prev_y / v_prev_len );
					const ptPrevShift_y = ( inPrev.y + v_prev_x / v_prev_len );

					const ptNextShift_x = ( inNext.x - v_next_y / v_next_len );
					const ptNextShift_y = ( inNext.y + v_next_x / v_next_len );

					// scaling factor for v_prev to intersection point

					const sf = ( ( ptNextShift_x - ptPrevShift_x ) * v_next_y -
							( ptNextShift_y - ptPrevShift_y ) * v_next_x ) /
						( v_prev_x * v_next_y - v_prev_y * v_next_x );

					// vector from inPt to intersection point

					v_trans_x = ( ptPrevShift_x + v_prev_x * sf - inPt.x );
					v_trans_y = ( ptPrevShift_y + v_prev_y * sf - inPt.y );

					// Don't normalize!, otherwise sharp corners become ugly
					//  but prevent crazy spikes
					const v_trans_lensq = ( v_trans_x * v_trans_x + v_trans_y * v_trans_y );
					if ( v_trans_lensq <= 2 ) {

						return new Vector2( v_trans_x, v_trans_y );

					} else {

						shrink_by = Math.sqrt( v_trans_lensq / 2 );

					}

				} else {

					// handle special case of collinear edges

					let direction_eq = false; // assumes: opposite

					if ( v_prev_x > Number.EPSILON ) {

						if ( v_next_x > Number.EPSILON ) {

							direction_eq = true;

						}

					} else {

						if ( v_prev_x < - Number.EPSILON ) {

							if ( v_next_x < - Number.EPSILON ) {

								direction_eq = true;

							}

						} else {

							if ( Math.sign( v_prev_y ) === Math.sign( v_next_y ) ) {

								direction_eq = true;

							}

						}

					}

					if ( direction_eq ) {

						// console.log("Warning: lines are a straight sequence");
						v_trans_x = - v_prev_y;
						v_trans_y = v_prev_x;
						shrink_by = Math.sqrt( v_prev_lensq );

					} else {

						// console.log("Warning: lines are a straight spike");
						v_trans_x = v_prev_x;
						v_trans_y = v_prev_y;
						shrink_by = Math.sqrt( v_prev_lensq / 2 );

					}

				}

				return new Vector2( v_trans_x / shrink_by, v_trans_y / shrink_by );

			}


			const contourMovements = [];

			for ( let i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i ++, j ++, k ++ ) {

				if ( j === il ) j = 0;
				if ( k === il ) k = 0;

				//  (j)---(i)---(k)
				// console.log('i,j,k', i, j , k)

				contourMovements[ i ] = getBevelVec( contour[ i ], contour[ j ], contour[ k ] );

			}

			const holesMovements = [];
			let oneHoleMovements, verticesMovements = contourMovements.concat();

			for ( let h = 0, hl = holes.length; h < hl; h ++ ) {

				const ahole = holes[ h ];

				oneHoleMovements = [];

				for ( let i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i ++, j ++, k ++ ) {

					if ( j === il ) j = 0;
					if ( k === il ) k = 0;

					//  (j)---(i)---(k)
					oneHoleMovements[ i ] = getBevelVec( ahole[ i ], ahole[ j ], ahole[ k ] );

				}

				holesMovements.push( oneHoleMovements );
				verticesMovements = verticesMovements.concat( oneHoleMovements );

			}


			// Loop bevelSegments, 1 for the front, 1 for the back

			for ( let b = 0; b < bevelSegments; b ++ ) {

				//for ( b = bevelSegments; b > 0; b -- ) {

				const t = b / bevelSegments;
				const z = bevelThickness * Math.cos( t * Math.PI / 2 );
				const bs = bevelSize * Math.sin( t * Math.PI / 2 ) + bevelOffset;

				// contract shape

				for ( let i = 0, il = contour.length; i < il; i ++ ) {

					const vert = scalePt2( contour[ i ], contourMovements[ i ], bs );

					v( vert.x, vert.y, - z );

				}

				// expand holes

				for ( let h = 0, hl = holes.length; h < hl; h ++ ) {

					const ahole = holes[ h ];
					oneHoleMovements = holesMovements[ h ];

					for ( let i = 0, il = ahole.length; i < il; i ++ ) {

						const vert = scalePt2( ahole[ i ], oneHoleMovements[ i ], bs );

						v( vert.x, vert.y, - z );

					}

				}

			}

			const bs = bevelSize + bevelOffset;

			// Back facing vertices

			for ( let i = 0; i < vlen; i ++ ) {

				const vert = bevelEnabled ? scalePt2( vertices[ i ], verticesMovements[ i ], bs ) : vertices[ i ];

				if ( ! extrudeByPath ) {

					v( vert.x, vert.y, 0 );

				} else {

					// v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );

					normal.copy( splineTube.normals[ 0 ] ).multiplyScalar( vert.x );
					binormal.copy( splineTube.binormals[ 0 ] ).multiplyScalar( vert.y );

					position2.copy( extrudePts[ 0 ] ).add( normal ).add( binormal );

					v( position2.x, position2.y, position2.z );

				}

			}

			// Add stepped vertices...
			// Including front facing vertices

			for ( let s = 1; s <= steps; s ++ ) {

				for ( let i = 0; i < vlen; i ++ ) {

					const vert = bevelEnabled ? scalePt2( vertices[ i ], verticesMovements[ i ], bs ) : vertices[ i ];

					if ( ! extrudeByPath ) {

						v( vert.x, vert.y, depth / steps * s );

					} else {

						// v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );

						normal.copy( splineTube.normals[ s ] ).multiplyScalar( vert.x );
						binormal.copy( splineTube.binormals[ s ] ).multiplyScalar( vert.y );

						position2.copy( extrudePts[ s ] ).add( normal ).add( binormal );

						v( position2.x, position2.y, position2.z );

					}

				}

			}


			// Add bevel segments planes

			//for ( b = 1; b <= bevelSegments; b ++ ) {
			for ( let b = bevelSegments - 1; b >= 0; b -- ) {

				const t = b / bevelSegments;
				const z = bevelThickness * Math.cos( t * Math.PI / 2 );
				const bs = bevelSize * Math.sin( t * Math.PI / 2 ) + bevelOffset;

				// contract shape

				for ( let i = 0, il = contour.length; i < il; i ++ ) {

					const vert = scalePt2( contour[ i ], contourMovements[ i ], bs );
					v( vert.x, vert.y, depth + z );

				}

				// expand holes

				for ( let h = 0, hl = holes.length; h < hl; h ++ ) {

					const ahole = holes[ h ];
					oneHoleMovements = holesMovements[ h ];

					for ( let i = 0, il = ahole.length; i < il; i ++ ) {

						const vert = scalePt2( ahole[ i ], oneHoleMovements[ i ], bs );

						if ( ! extrudeByPath ) {

							v( vert.x, vert.y, depth + z );

						} else {

							v( vert.x, vert.y + extrudePts[ steps - 1 ].y, extrudePts[ steps - 1 ].x + z );

						}

					}

				}

			}

			/* Faces */

			// Top and bottom faces

			buildLidFaces();

			// Sides faces

			buildSideFaces();


			/////  Internal functions

			function buildLidFaces() {

				const start = verticesArray.length / 3;

				if ( bevelEnabled ) {

					let layer = 0; // steps + 1
					let offset = vlen * layer;

					// Bottom faces

					for ( let i = 0; i < flen; i ++ ) {

						const face = faces[ i ];
						f3( face[ 2 ] + offset, face[ 1 ] + offset, face[ 0 ] + offset );

					}

					layer = steps + bevelSegments * 2;
					offset = vlen * layer;

					// Top faces

					for ( let i = 0; i < flen; i ++ ) {

						const face = faces[ i ];
						f3( face[ 0 ] + offset, face[ 1 ] + offset, face[ 2 ] + offset );

					}

				} else {

					// Bottom faces

					for ( let i = 0; i < flen; i ++ ) {

						const face = faces[ i ];
						f3( face[ 2 ], face[ 1 ], face[ 0 ] );

					}

					// Top faces

					for ( let i = 0; i < flen; i ++ ) {

						const face = faces[ i ];
						f3( face[ 0 ] + vlen * steps, face[ 1 ] + vlen * steps, face[ 2 ] + vlen * steps );

					}

				}

				scope.addGroup( start, verticesArray.length / 3 - start, 0 );

			}

			// Create faces for the z-sides of the shape

			function buildSideFaces() {

				const start = verticesArray.length / 3;
				let layeroffset = 0;
				sidewalls( contour, layeroffset );
				layeroffset += contour.length;

				for ( let h = 0, hl = holes.length; h < hl; h ++ ) {

					const ahole = holes[ h ];
					sidewalls( ahole, layeroffset );

					//, true
					layeroffset += ahole.length;

				}


				scope.addGroup( start, verticesArray.length / 3 - start, 1 );


			}

			function sidewalls( contour, layeroffset ) {

				let i = contour.length;

				while ( -- i >= 0 ) {

					const j = i;
					let k = i - 1;
					if ( k < 0 ) k = contour.length - 1;

					//console.log('b', i,j, i-1, k,vertices.length);

					for ( let s = 0, sl = ( steps + bevelSegments * 2 ); s < sl; s ++ ) {

						const slen1 = vlen * s;
						const slen2 = vlen * ( s + 1 );

						const a = layeroffset + j + slen1,
							b = layeroffset + k + slen1,
							c = layeroffset + k + slen2,
							d = layeroffset + j + slen2;

						f4( a, b, c, d );

					}

				}

			}

			function v( x, y, z ) {

				placeholder.push( x );
				placeholder.push( y );
				placeholder.push( z );

			}


			function f3( a, b, c ) {

				addVertex( a );
				addVertex( b );
				addVertex( c );

				const nextIndex = verticesArray.length / 3;
				const uvs = uvgen.generateTopUV( scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1 );

				addUV( uvs[ 0 ] );
				addUV( uvs[ 1 ] );
				addUV( uvs[ 2 ] );

			}

			function f4( a, b, c, d ) {

				addVertex( a );
				addVertex( b );
				addVertex( d );

				addVertex( b );
				addVertex( c );
				addVertex( d );


				const nextIndex = verticesArray.length / 3;
				const uvs = uvgen.generateSideWallUV( scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1 );

				addUV( uvs[ 0 ] );
				addUV( uvs[ 1 ] );
				addUV( uvs[ 3 ] );

				addUV( uvs[ 1 ] );
				addUV( uvs[ 2 ] );
				addUV( uvs[ 3 ] );

			}

			function addVertex( index ) {

				verticesArray.push( placeholder[ index * 3 + 0 ] );
				verticesArray.push( placeholder[ index * 3 + 1 ] );
				verticesArray.push( placeholder[ index * 3 + 2 ] );

			}


			function addUV( vector2 ) {

				uvArray.push( vector2.x );
				uvArray.push( vector2.y );

			}

		}

	}

	copy( source ) {

		super.copy( source );

		this.parameters = Object.assign( {}, source.parameters );

		return this;

	}

	toJSON() {

		const data = super.toJSON();

		const shapes = this.parameters.shapes;
		const options = this.parameters.options;

		return toJSON$1( shapes, options, data );

	}

	static fromJSON( data, shapes ) {

		const geometryShapes = [];

		for ( let j = 0, jl = data.shapes.length; j < jl; j ++ ) {

			const shape = shapes[ data.shapes[ j ] ];

			geometryShapes.push( shape );

		}

		const extrudePath = data.options.extrudePath;

		if ( extrudePath !== undefined ) {

			data.options.extrudePath = new Curves[ extrudePath.type ]().fromJSON( extrudePath );

		}

		return new ExtrudeGeometry( geometryShapes, data.options );

	}

}

const WorldUVGenerator = {

	generateTopUV: function ( geometry, vertices, indexA, indexB, indexC ) {

		const a_x = vertices[ indexA * 3 ];
		const a_y = vertices[ indexA * 3 + 1 ];
		const b_x = vertices[ indexB * 3 ];
		const b_y = vertices[ indexB * 3 + 1 ];
		const c_x = vertices[ indexC * 3 ];
		const c_y = vertices[ indexC * 3 + 1 ];

		return [
			new Vector2( a_x, a_y ),
			new Vector2( b_x, b_y ),
			new Vector2( c_x, c_y )
		];

	},

	generateSideWallUV: function ( geometry, vertices, indexA, indexB, indexC, indexD ) {

		const a_x = vertices[ indexA * 3 ];
		const a_y = vertices[ indexA * 3 + 1 ];
		const a_z = vertices[ indexA * 3 + 2 ];
		const b_x = vertices[ indexB * 3 ];
		const b_y = vertices[ indexB * 3 + 1 ];
		const b_z = vertices[ indexB * 3 + 2 ];
		const c_x = vertices[ indexC * 3 ];
		const c_y = vertices[ indexC * 3 + 1 ];
		const c_z = vertices[ indexC * 3 + 2 ];
		const d_x = vertices[ indexD * 3 ];
		const d_y = vertices[ indexD * 3 + 1 ];
		const d_z = vertices[ indexD * 3 + 2 ];

		if ( Math.abs( a_y - b_y ) < Math.abs( a_x - b_x ) ) {

			return [
				new Vector2( a_x, 1 - a_z ),
				new Vector2( b_x, 1 - b_z ),
				new Vector2( c_x, 1 - c_z ),
				new Vector2( d_x, 1 - d_z )
			];

		} else {

			return [
				new Vector2( a_y, 1 - a_z ),
				new Vector2( b_y, 1 - b_z ),
				new Vector2( c_y, 1 - c_z ),
				new Vector2( d_y, 1 - d_z )
			];

		}

	}

};

function toJSON$1( shapes, options, data ) {

	data.shapes = [];

	if ( Array.isArray( shapes ) ) {

		for ( let i = 0, l = shapes.length; i < l; i ++ ) {

			const shape = shapes[ i ];

			data.shapes.push( shape.uuid );

		}

	} else {

		data.shapes.push( shapes.uuid );

	}

	data.options = Object.assign( {}, options );

	if ( options.extrudePath !== undefined ) data.options.extrudePath = options.extrudePath.toJSON();

	return data;

}

class IcosahedronGeometry extends PolyhedronGeometry {

	constructor( radius = 1, detail = 0 ) {

		const t = ( 1 + Math.sqrt( 5 ) ) / 2;

		const vertices = [
			- 1, t, 0, 	1, t, 0, 	- 1, - t, 0, 	1, - t, 0,
			0, - 1, t, 	0, 1, t,	0, - 1, - t, 	0, 1, - t,
			t, 0, - 1, 	t, 0, 1, 	- t, 0, - 1, 	- t, 0, 1
		];

		const indices = [
			0, 11, 5, 	0, 5, 1, 	0, 1, 7, 	0, 7, 10, 	0, 10, 11,
			1, 5, 9, 	5, 11, 4,	11, 10, 2,	10, 7, 6,	7, 1, 8,
			3, 9, 4, 	3, 4, 2,	3, 2, 6,	3, 6, 8,	3, 8, 9,
			4, 9, 5, 	2, 4, 11,	6, 2, 10,	8, 6, 7,	9, 8, 1
		];

		super( vertices, indices, radius, detail );

		this.type = 'IcosahedronGeometry';

		this.parameters = {
			radius: radius,
			detail: detail
		};

	}

	static fromJSON( data ) {

		return new IcosahedronGeometry( data.radius, data.detail );

	}

}

class OctahedronGeometry extends PolyhedronGeometry {

	constructor( radius = 1, detail = 0 ) {

		const vertices = [
			1, 0, 0, 	- 1, 0, 0,	0, 1, 0,
			0, - 1, 0, 	0, 0, 1,	0, 0, - 1
		];

		const indices = [
			0, 2, 4,	0, 4, 3,	0, 3, 5,
			0, 5, 2,	1, 2, 5,	1, 5, 3,
			1, 3, 4,	1, 4, 2
		];

		super( vertices, indices, radius, detail );

		this.type = 'OctahedronGeometry';

		this.parameters = {
			radius: radius,
			detail: detail
		};

	}

	static fromJSON( data ) {

		return new OctahedronGeometry( data.radius, data.detail );

	}

}

class RingGeometry extends BufferGeometry {

	constructor( innerRadius = 0.5, outerRadius = 1, thetaSegments = 32, phiSegments = 1, thetaStart = 0, thetaLength = Math.PI * 2 ) {

		super();

		this.type = 'RingGeometry';

		this.parameters = {
			innerRadius: innerRadius,
			outerRadius: outerRadius,
			thetaSegments: thetaSegments,
			phiSegments: phiSegments,
			thetaStart: thetaStart,
			thetaLength: thetaLength
		};

		thetaSegments = Math.max( 3, thetaSegments );
		phiSegments = Math.max( 1, phiSegments );

		// buffers

		const indices = [];
		const vertices = [];
		const normals = [];
		const uvs = [];

		// some helper variables

		let radius = innerRadius;
		const radiusStep = ( ( outerRadius - innerRadius ) / phiSegments );
		const vertex = new Vector3();
		const uv = new Vector2();

		// generate vertices, normals and uvs

		for ( let j = 0; j <= phiSegments; j ++ ) {

			for ( let i = 0; i <= thetaSegments; i ++ ) {

				// values are generate from the inside of the ring to the outside

				const segment = thetaStart + i / thetaSegments * thetaLength;

				// vertex

				vertex.x = radius * Math.cos( segment );
				vertex.y = radius * Math.sin( segment );

				vertices.push( vertex.x, vertex.y, vertex.z );

				// normal

				normals.push( 0, 0, 1 );

				// uv

				uv.x = ( vertex.x / outerRadius + 1 ) / 2;
				uv.y = ( vertex.y / outerRadius + 1 ) / 2;

				uvs.push( uv.x, uv.y );

			}

			// increase the radius for next row of vertices

			radius += radiusStep;

		}

		// indices

		for ( let j = 0; j < phiSegments; j ++ ) {

			const thetaSegmentLevel = j * ( thetaSegments + 1 );

			for ( let i = 0; i < thetaSegments; i ++ ) {

				const segment = i + thetaSegmentLevel;

				const a = segment;
				const b = segment + thetaSegments + 1;
				const c = segment + thetaSegments + 2;
				const d = segment + 1;

				// faces

				indices.push( a, b, d );
				indices.push( b, c, d );

			}

		}

		// build geometry

		this.setIndex( indices );
		this.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.setAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
		this.setAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

	}

	copy( source ) {

		super.copy( source );

		this.parameters = Object.assign( {}, source.parameters );

		return this;

	}

	static fromJSON( data ) {

		return new RingGeometry( data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength );

	}

}

class ShapeGeometry extends BufferGeometry {

	constructor( shapes = new Shape( [ new Vector2( 0, 0.5 ), new Vector2( - 0.5, - 0.5 ), new Vector2( 0.5, - 0.5 ) ] ), curveSegments = 12 ) {

		super();

		this.type = 'ShapeGeometry';

		this.parameters = {
			shapes: shapes,
			curveSegments: curveSegments
		};

		// buffers

		const indices = [];
		const vertices = [];
		const normals = [];
		const uvs = [];

		// helper variables

		let groupStart = 0;
		let groupCount = 0;

		// allow single and array values for "shapes" parameter

		if ( Array.isArray( shapes ) === false ) {

			addShape( shapes );

		} else {

			for ( let i = 0; i < shapes.length; i ++ ) {

				addShape( shapes[ i ] );

				this.addGroup( groupStart, groupCount, i ); // enables MultiMaterial support

				groupStart += groupCount;
				groupCount = 0;

			}

		}

		// build geometry

		this.setIndex( indices );
		this.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.setAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
		this.setAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );


		// helper functions

		function addShape( shape ) {

			const indexOffset = vertices.length / 3;
			const points = shape.extractPoints( curveSegments );

			let shapeVertices = points.shape;
			const shapeHoles = points.holes;

			// check direction of vertices

			if ( ShapeUtils.isClockWise( shapeVertices ) === false ) {

				shapeVertices = shapeVertices.reverse();

			}

			for ( let i = 0, l = shapeHoles.length; i < l; i ++ ) {

				const shapeHole = shapeHoles[ i ];

				if ( ShapeUtils.isClockWise( shapeHole ) === true ) {

					shapeHoles[ i ] = shapeHole.reverse();

				}

			}

			const faces = ShapeUtils.triangulateShape( shapeVertices, shapeHoles );

			// join vertices of inner and outer paths to a single array

			for ( let i = 0, l = shapeHoles.length; i < l; i ++ ) {

				const shapeHole = shapeHoles[ i ];
				shapeVertices = shapeVertices.concat( shapeHole );

			}

			// vertices, normals, uvs

			for ( let i = 0, l = shapeVertices.length; i < l; i ++ ) {

				const vertex = shapeVertices[ i ];

				vertices.push( vertex.x, vertex.y, 0 );
				normals.push( 0, 0, 1 );
				uvs.push( vertex.x, vertex.y ); // world uvs

			}

			// indices

			for ( let i = 0, l = faces.length; i < l; i ++ ) {

				const face = faces[ i ];

				const a = face[ 0 ] + indexOffset;
				const b = face[ 1 ] + indexOffset;
				const c = face[ 2 ] + indexOffset;

				indices.push( a, b, c );
				groupCount += 3;

			}

		}

	}

	copy( source ) {

		super.copy( source );

		this.parameters = Object.assign( {}, source.parameters );

		return this;

	}

	toJSON() {

		const data = super.toJSON();

		const shapes = this.parameters.shapes;

		return toJSON( shapes, data );

	}

	static fromJSON( data, shapes ) {

		const geometryShapes = [];

		for ( let j = 0, jl = data.shapes.length; j < jl; j ++ ) {

			const shape = shapes[ data.shapes[ j ] ];

			geometryShapes.push( shape );

		}

		return new ShapeGeometry( geometryShapes, data.curveSegments );

	}

}

function toJSON( shapes, data ) {

	data.shapes = [];

	if ( Array.isArray( shapes ) ) {

		for ( let i = 0, l = shapes.length; i < l; i ++ ) {

			const shape = shapes[ i ];

			data.shapes.push( shape.uuid );

		}

	} else {

		data.shapes.push( shapes.uuid );

	}

	return data;

}

class SphereGeometry extends BufferGeometry {

	constructor( radius = 1, widthSegments = 32, heightSegments = 16, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI ) {

		super();

		this.type = 'SphereGeometry';

		this.parameters = {
			radius: radius,
			widthSegments: widthSegments,
			heightSegments: heightSegments,
			phiStart: phiStart,
			phiLength: phiLength,
			thetaStart: thetaStart,
			thetaLength: thetaLength
		};

		widthSegments = Math.max( 3, Math.floor( widthSegments ) );
		heightSegments = Math.max( 2, Math.floor( heightSegments ) );

		const thetaEnd = Math.min( thetaStart + thetaLength, Math.PI );

		let index = 0;
		const grid = [];

		const vertex = new Vector3();
		const normal = new Vector3();

		// buffers

		const indices = [];
		const vertices = [];
		const normals = [];
		const uvs = [];

		// generate vertices, normals and uvs

		for ( let iy = 0; iy <= heightSegments; iy ++ ) {

			const verticesRow = [];

			const v = iy / heightSegments;

			// special case for the poles

			let uOffset = 0;

			if ( iy === 0 && thetaStart === 0 ) {

				uOffset = 0.5 / widthSegments;

			} else if ( iy === heightSegments && thetaEnd === Math.PI ) {

				uOffset = - 0.5 / widthSegments;

			}

			for ( let ix = 0; ix <= widthSegments; ix ++ ) {

				const u = ix / widthSegments;

				// vertex

				vertex.x = - radius * Math.cos( phiStart + u * phiLength ) * Math.sin( thetaStart + v * thetaLength );
				vertex.y = radius * Math.cos( thetaStart + v * thetaLength );
				vertex.z = radius * Math.sin( phiStart + u * phiLength ) * Math.sin( thetaStart + v * thetaLength );

				vertices.push( vertex.x, vertex.y, vertex.z );

				// normal

				normal.copy( vertex ).normalize();
				normals.push( normal.x, normal.y, normal.z );

				// uv

				uvs.push( u + uOffset, 1 - v );

				verticesRow.push( index ++ );

			}

			grid.push( verticesRow );

		}

		// indices

		for ( let iy = 0; iy < heightSegments; iy ++ ) {

			for ( let ix = 0; ix < widthSegments; ix ++ ) {

				const a = grid[ iy ][ ix + 1 ];
				const b = grid[ iy ][ ix ];
				const c = grid[ iy + 1 ][ ix ];
				const d = grid[ iy + 1 ][ ix + 1 ];

				if ( iy !== 0 || thetaStart > 0 ) indices.push( a, b, d );
				if ( iy !== heightSegments - 1 || thetaEnd < Math.PI ) indices.push( b, c, d );

			}

		}

		// build geometry

		this.setIndex( indices );
		this.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.setAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
		this.setAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

	}

	copy( source ) {

		super.copy( source );

		this.parameters = Object.assign( {}, source.parameters );

		return this;

	}

	static fromJSON( data ) {

		return new SphereGeometry( data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength );

	}

}

class TetrahedronGeometry extends PolyhedronGeometry {

	constructor( radius = 1, detail = 0 ) {

		const vertices = [
			1, 1, 1, 	- 1, - 1, 1, 	- 1, 1, - 1, 	1, - 1, - 1
		];

		const indices = [
			2, 1, 0, 	0, 3, 2,	1, 3, 0,	2, 3, 1
		];

		super( vertices, indices, radius, detail );

		this.type = 'TetrahedronGeometry';

		this.parameters = {
			radius: radius,
			detail: detail
		};

	}

	static fromJSON( data ) {

		return new TetrahedronGeometry( data.radius, data.detail );

	}

}

class TorusGeometry extends BufferGeometry {

	constructor( radius = 1, tube = 0.4, radialSegments = 12, tubularSegments = 48, arc = Math.PI * 2 ) {

		super();

		this.type = 'TorusGeometry';

		this.parameters = {
			radius: radius,
			tube: tube,
			radialSegments: radialSegments,
			tubularSegments: tubularSegments,
			arc: arc
		};

		radialSegments = Math.floor( radialSegments );
		tubularSegments = Math.floor( tubularSegments );

		// buffers

		const indices = [];
		const vertices = [];
		const normals = [];
		const uvs = [];

		// helper variables

		const center = new Vector3();
		const vertex = new Vector3();
		const normal = new Vector3();

		// generate vertices, normals and uvs

		for ( let j = 0; j <= radialSegments; j ++ ) {

			for ( let i = 0; i <= tubularSegments; i ++ ) {

				const u = i / tubularSegments * arc;
				const v = j / radialSegments * Math.PI * 2;

				// vertex

				vertex.x = ( radius + tube * Math.cos( v ) ) * Math.cos( u );
				vertex.y = ( radius + tube * Math.cos( v ) ) * Math.sin( u );
				vertex.z = tube * Math.sin( v );

				vertices.push( vertex.x, vertex.y, vertex.z );

				// normal

				center.x = radius * Math.cos( u );
				center.y = radius * Math.sin( u );
				normal.subVectors( vertex, center ).normalize();

				normals.push( normal.x, normal.y, normal.z );

				// uv

				uvs.push( i / tubularSegments );
				uvs.push( j / radialSegments );

			}

		}

		// generate indices

		for ( let j = 1; j <= radialSegments; j ++ ) {

			for ( let i = 1; i <= tubularSegments; i ++ ) {

				// indices

				const a = ( tubularSegments + 1 ) * j + i - 1;
				const b = ( tubularSegments + 1 ) * ( j - 1 ) + i - 1;
				const c = ( tubularSegments + 1 ) * ( j - 1 ) + i;
				const d = ( tubularSegments + 1 ) * j + i;

				// faces

				indices.push( a, b, d );
				indices.push( b, c, d );

			}

		}

		// build geometry

		this.setIndex( indices );
		this.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.setAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
		this.setAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

	}

	copy( source ) {

		super.copy( source );

		this.parameters = Object.assign( {}, source.parameters );

		return this;

	}

	static fromJSON( data ) {

		return new TorusGeometry( data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc );

	}

}

class TorusKnotGeometry extends BufferGeometry {

	constructor( radius = 1, tube = 0.4, tubularSegments = 64, radialSegments = 8, p = 2, q = 3 ) {

		super();

		this.type = 'TorusKnotGeometry';

		this.parameters = {
			radius: radius,
			tube: tube,
			tubularSegments: tubularSegments,
			radialSegments: radialSegments,
			p: p,
			q: q
		};

		tubularSegments = Math.floor( tubularSegments );
		radialSegments = Math.floor( radialSegments );

		// buffers

		const indices = [];
		const vertices = [];
		const normals = [];
		const uvs = [];

		// helper variables

		const vertex = new Vector3();
		const normal = new Vector3();

		const P1 = new Vector3();
		const P2 = new Vector3();

		const B = new Vector3();
		const T = new Vector3();
		const N = new Vector3();

		// generate vertices, normals and uvs

		for ( let i = 0; i <= tubularSegments; ++ i ) {

			// the radian "u" is used to calculate the position on the torus curve of the current tubular segment

			const u = i / tubularSegments * p * Math.PI * 2;

			// now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
			// these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions

			calculatePositionOnCurve( u, p, q, radius, P1 );
			calculatePositionOnCurve( u + 0.01, p, q, radius, P2 );

			// calculate orthonormal basis

			T.subVectors( P2, P1 );
			N.addVectors( P2, P1 );
			B.crossVectors( T, N );
			N.crossVectors( B, T );

			// normalize B, N. T can be ignored, we don't use it

			B.normalize();
			N.normalize();

			for ( let j = 0; j <= radialSegments; ++ j ) {

				// now calculate the vertices. they are nothing more than an extrusion of the torus curve.
				// because we extrude a shape in the xy-plane, there is no need to calculate a z-value.

				const v = j / radialSegments * Math.PI * 2;
				const cx = - tube * Math.cos( v );
				const cy = tube * Math.sin( v );

				// now calculate the final vertex position.
				// first we orient the extrusion with our basis vectors, then we add it to the current position on the curve

				vertex.x = P1.x + ( cx * N.x + cy * B.x );
				vertex.y = P1.y + ( cx * N.y + cy * B.y );
				vertex.z = P1.z + ( cx * N.z + cy * B.z );

				vertices.push( vertex.x, vertex.y, vertex.z );

				// normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)

				normal.subVectors( vertex, P1 ).normalize();

				normals.push( normal.x, normal.y, normal.z );

				// uv

				uvs.push( i / tubularSegments );
				uvs.push( j / radialSegments );

			}

		}

		// generate indices

		for ( let j = 1; j <= tubularSegments; j ++ ) {

			for ( let i = 1; i <= radialSegments; i ++ ) {

				// indices

				const a = ( radialSegments + 1 ) * ( j - 1 ) + ( i - 1 );
				const b = ( radialSegments + 1 ) * j + ( i - 1 );
				const c = ( radialSegments + 1 ) * j + i;
				const d = ( radialSegments + 1 ) * ( j - 1 ) + i;

				// faces

				indices.push( a, b, d );
				indices.push( b, c, d );

			}

		}

		// build geometry

		this.setIndex( indices );
		this.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.setAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
		this.setAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

		// this function calculates the current position on the torus curve

		function calculatePositionOnCurve( u, p, q, radius, position ) {

			const cu = Math.cos( u );
			const su = Math.sin( u );
			const quOverP = q / p * u;
			const cs = Math.cos( quOverP );

			position.x = radius * ( 2 + cs ) * 0.5 * cu;
			position.y = radius * ( 2 + cs ) * su * 0.5;
			position.z = radius * Math.sin( quOverP ) * 0.5;

		}

	}

	copy( source ) {

		super.copy( source );

		this.parameters = Object.assign( {}, source.parameters );

		return this;

	}

	static fromJSON( data ) {

		return new TorusKnotGeometry( data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q );

	}

}

class TubeGeometry extends BufferGeometry {

	constructor( path = new QuadraticBezierCurve3( new Vector3( - 1, - 1, 0 ), new Vector3( - 1, 1, 0 ), new Vector3( 1, 1, 0 ) ), tubularSegments = 64, radius = 1, radialSegments = 8, closed = false ) {

		super();

		this.type = 'TubeGeometry';

		this.parameters = {
			path: path,
			tubularSegments: tubularSegments,
			radius: radius,
			radialSegments: radialSegments,
			closed: closed
		};

		const frames = path.computeFrenetFrames( tubularSegments, closed );

		// expose internals

		this.tangents = frames.tangents;
		this.normals = frames.normals;
		this.binormals = frames.binormals;

		// helper variables

		const vertex = new Vector3();
		const normal = new Vector3();
		const uv = new Vector2();
		let P = new Vector3();

		// buffer

		const vertices = [];
		const normals = [];
		const uvs = [];
		const indices = [];

		// create buffer data

		generateBufferData();

		// build geometry

		this.setIndex( indices );
		this.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.setAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
		this.setAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

		// functions

		function generateBufferData() {

			for ( let i = 0; i < tubularSegments; i ++ ) {

				generateSegment( i );

			}

			// if the geometry is not closed, generate the last row of vertices and normals
			// at the regular position on the given path
			//
			// if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)

			generateSegment( ( closed === false ) ? tubularSegments : 0 );

			// uvs are generated in a separate function.
			// this makes it easy compute correct values for closed geometries

			generateUVs();

			// finally create faces

			generateIndices();

		}

		function generateSegment( i ) {

			// we use getPointAt to sample evenly distributed points from the given path

			P = path.getPointAt( i / tubularSegments, P );

			// retrieve corresponding normal and binormal

			const N = frames.normals[ i ];
			const B = frames.binormals[ i ];

			// generate normals and vertices for the current segment

			for ( let j = 0; j <= radialSegments; j ++ ) {

				const v = j / radialSegments * Math.PI * 2;

				const sin = Math.sin( v );
				const cos = - Math.cos( v );

				// normal

				normal.x = ( cos * N.x + sin * B.x );
				normal.y = ( cos * N.y + sin * B.y );
				normal.z = ( cos * N.z + sin * B.z );
				normal.normalize();

				normals.push( normal.x, normal.y, normal.z );

				// vertex

				vertex.x = P.x + radius * normal.x;
				vertex.y = P.y + radius * normal.y;
				vertex.z = P.z + radius * normal.z;

				vertices.push( vertex.x, vertex.y, vertex.z );

			}

		}

		function generateIndices() {

			for ( let j = 1; j <= tubularSegments; j ++ ) {

				for ( let i = 1; i <= radialSegments; i ++ ) {

					const a = ( radialSegments + 1 ) * ( j - 1 ) + ( i - 1 );
					const b = ( radialSegments + 1 ) * j + ( i - 1 );
					const c = ( radialSegments + 1 ) * j + i;
					const d = ( radialSegments + 1 ) * ( j - 1 ) + i;

					// faces

					indices.push( a, b, d );
					indices.push( b, c, d );

				}

			}

		}

		function generateUVs() {

			for ( let i = 0; i <= tubularSegments; i ++ ) {

				for ( let j = 0; j <= radialSegments; j ++ ) {

					uv.x = i / tubularSegments;
					uv.y = j / radialSegments;

					uvs.push( uv.x, uv.y );

				}

			}

		}

	}

	copy( source ) {

		super.copy( source );

		this.parameters = Object.assign( {}, source.parameters );

		return this;

	}

	toJSON() {

		const data = super.toJSON();

		data.path = this.parameters.path.toJSON();

		return data;

	}

	static fromJSON( data ) {

		// This only works for built-in curves (e.g. CatmullRomCurve3).
		// User defined curves or instances of CurvePath will not be deserialized.
		return new TubeGeometry(
			new Curves[ data.path.type ]().fromJSON( data.path ),
			data.tubularSegments,
			data.radius,
			data.radialSegments,
			data.closed
		);

	}

}

class WireframeGeometry extends BufferGeometry {

	constructor( geometry = null ) {

		super();

		this.type = 'WireframeGeometry';

		this.parameters = {
			geometry: geometry
		};

		if ( geometry !== null ) {

			// buffer

			const vertices = [];
			const edges = new Set();

			// helper variables

			const start = new Vector3();
			const end = new Vector3();

			if ( geometry.index !== null ) {

				// indexed BufferGeometry

				const position = geometry.attributes.position;
				const indices = geometry.index;
				let groups = geometry.groups;

				if ( groups.length === 0 ) {

					groups = [ { start: 0, count: indices.count, materialIndex: 0 } ];

				}

				// create a data structure that contains all edges without duplicates

				for ( let o = 0, ol = groups.length; o < ol; ++ o ) {

					const group = groups[ o ];

					const groupStart = group.start;
					const groupCount = group.count;

					for ( let i = groupStart, l = ( groupStart + groupCount ); i < l; i += 3 ) {

						for ( let j = 0; j < 3; j ++ ) {

							const index1 = indices.getX( i + j );
							const index2 = indices.getX( i + ( j + 1 ) % 3 );

							start.fromBufferAttribute( position, index1 );
							end.fromBufferAttribute( position, index2 );

							if ( isUniqueEdge( start, end, edges ) === true ) {

								vertices.push( start.x, start.y, start.z );
								vertices.push( end.x, end.y, end.z );

							}

						}

					}

				}

			} else {

				// non-indexed BufferGeometry

				const position = geometry.attributes.position;

				for ( let i = 0, l = ( position.count / 3 ); i < l; i ++ ) {

					for ( let j = 0; j < 3; j ++ ) {

						// three edges per triangle, an edge is represented as (index1, index2)
						// e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)

						const index1 = 3 * i + j;
						const index2 = 3 * i + ( ( j + 1 ) % 3 );

						start.fromBufferAttribute( position, index1 );
						end.fromBufferAttribute( position, index2 );

						if ( isUniqueEdge( start, end, edges ) === true ) {

							vertices.push( start.x, start.y, start.z );
							vertices.push( end.x, end.y, end.z );

						}

					}

				}

			}

			// build geometry

			this.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );

		}

	}

	copy( source ) {

		super.copy( source );

		this.parameters = Object.assign( {}, source.parameters );

		return this;

	}

}

function isUniqueEdge( start, end, edges ) {

	const hash1 = `${start.x},${start.y},${start.z}-${end.x},${end.y},${end.z}`;
	const hash2 = `${end.x},${end.y},${end.z}-${start.x},${start.y},${start.z}`; // coincident edge

	if ( edges.has( hash1 ) === true || edges.has( hash2 ) === true ) {

		return false;

	} else {

		edges.add( hash1 );
		edges.add( hash2 );
		return true;

	}

}

var Geometries = /*#__PURE__*/Object.freeze({
	__proto__: null,
	BoxGeometry: BoxGeometry,
	CapsuleGeometry: CapsuleGeometry,
	CircleGeometry: CircleGeometry,
	ConeGeometry: ConeGeometry,
	CylinderGeometry: CylinderGeometry,
	DodecahedronGeometry: DodecahedronGeometry,
	EdgesGeometry: EdgesGeometry,
	ExtrudeGeometry: ExtrudeGeometry,
	IcosahedronGeometry: IcosahedronGeometry,
	LatheGeometry: LatheGeometry,
	OctahedronGeometry: OctahedronGeometry,
	PlaneGeometry: PlaneGeometry,
	PolyhedronGeometry: PolyhedronGeometry,
	RingGeometry: RingGeometry,
	ShapeGeometry: ShapeGeometry,
	SphereGeometry: SphereGeometry,
	TetrahedronGeometry: TetrahedronGeometry,
	TorusGeometry: TorusGeometry,
	TorusKnotGeometry: TorusKnotGeometry,
	TubeGeometry: TubeGeometry,
	WireframeGeometry: WireframeGeometry
});

class ShadowMaterial extends (/* unused pure expression or super */ null && (Material)) {

	constructor( parameters ) {

		super();

		this.isShadowMaterial = true;

		this.type = 'ShadowMaterial';

		this.color = new Color( 0x000000 );
		this.transparent = true;

		this.fog = true;

		this.setValues( parameters );

	}

	copy( source ) {

		super.copy( source );

		this.color.copy( source.color );

		this.fog = source.fog;

		return this;

	}

}

class RawShaderMaterial extends (/* unused pure expression or super */ null && (ShaderMaterial)) {

	constructor( parameters ) {

		super( parameters );

		this.isRawShaderMaterial = true;

		this.type = 'RawShaderMaterial';

	}

}

class MeshStandardMaterial extends (/* unused pure expression or super */ null && (Material)) {

	constructor( parameters ) {

		super();

		this.isMeshStandardMaterial = true;

		this.defines = { 'STANDARD': '' };

		this.type = 'MeshStandardMaterial';

		this.color = new Color( 0xffffff ); // diffuse
		this.roughness = 1.0;
		this.metalness = 0.0;

		this.map = null;

		this.lightMap = null;
		this.lightMapIntensity = 1.0;

		this.aoMap = null;
		this.aoMapIntensity = 1.0;

		this.emissive = new Color( 0x000000 );
		this.emissiveIntensity = 1.0;
		this.emissiveMap = null;

		this.bumpMap = null;
		this.bumpScale = 1;

		this.normalMap = null;
		this.normalMapType = TangentSpaceNormalMap;
		this.normalScale = new Vector2( 1, 1 );

		this.displacementMap = null;
		this.displacementScale = 1;
		this.displacementBias = 0;

		this.roughnessMap = null;

		this.metalnessMap = null;

		this.alphaMap = null;

		this.envMap = null;
		this.envMapRotation = new Euler();
		this.envMapIntensity = 1.0;

		this.wireframe = false;
		this.wireframeLinewidth = 1;
		this.wireframeLinecap = 'round';
		this.wireframeLinejoin = 'round';

		this.flatShading = false;

		this.fog = true;

		this.setValues( parameters );

	}

	copy( source ) {

		super.copy( source );

		this.defines = { 'STANDARD': '' };

		this.color.copy( source.color );
		this.roughness = source.roughness;
		this.metalness = source.metalness;

		this.map = source.map;

		this.lightMap = source.lightMap;
		this.lightMapIntensity = source.lightMapIntensity;

		this.aoMap = source.aoMap;
		this.aoMapIntensity = source.aoMapIntensity;

		this.emissive.copy( source.emissive );
		this.emissiveMap = source.emissiveMap;
		this.emissiveIntensity = source.emissiveIntensity;

		this.bumpMap = source.bumpMap;
		this.bumpScale = source.bumpScale;

		this.normalMap = source.normalMap;
		this.normalMapType = source.normalMapType;
		this.normalScale.copy( source.normalScale );

		this.displacementMap = source.displacementMap;
		this.displacementScale = source.displacementScale;
		this.displacementBias = source.displacementBias;

		this.roughnessMap = source.roughnessMap;

		this.metalnessMap = source.metalnessMap;

		this.alphaMap = source.alphaMap;

		this.envMap = source.envMap;
		this.envMapRotation.copy( source.envMapRotation );
		this.envMapIntensity = source.envMapIntensity;

		this.wireframe = source.wireframe;
		this.wireframeLinewidth = source.wireframeLinewidth;
		this.wireframeLinecap = source.wireframeLinecap;
		this.wireframeLinejoin = source.wireframeLinejoin;

		this.flatShading = source.flatShading;

		this.fog = source.fog;

		return this;

	}

}

class MeshPhysicalMaterial extends (/* unused pure expression or super */ null && (MeshStandardMaterial)) {

	constructor( parameters ) {

		super();

		this.isMeshPhysicalMaterial = true;

		this.defines = {

			'STANDARD': '',
			'PHYSICAL': ''

		};

		this.type = 'MeshPhysicalMaterial';

		this.anisotropyRotation = 0;
		this.anisotropyMap = null;

		this.clearcoatMap = null;
		this.clearcoatRoughness = 0.0;
		this.clearcoatRoughnessMap = null;
		this.clearcoatNormalScale = new Vector2( 1, 1 );
		this.clearcoatNormalMap = null;

		this.ior = 1.5;

		Object.defineProperty( this, 'reflectivity', {
			get: function () {

				return ( clamp( 2.5 * ( this.ior - 1 ) / ( this.ior + 1 ), 0, 1 ) );

			},
			set: function ( reflectivity ) {

				this.ior = ( 1 + 0.4 * reflectivity ) / ( 1 - 0.4 * reflectivity );

			}
		} );

		this.iridescenceMap = null;
		this.iridescenceIOR = 1.3;
		this.iridescenceThicknessRange = [ 100, 400 ];
		this.iridescenceThicknessMap = null;

		this.sheenColor = new Color( 0x000000 );
		this.sheenColorMap = null;
		this.sheenRoughness = 1.0;
		this.sheenRoughnessMap = null;

		this.transmissionMap = null;

		this.thickness = 0;
		this.thicknessMap = null;
		this.attenuationDistance = Infinity;
		this.attenuationColor = new Color( 1, 1, 1 );

		this.specularIntensity = 1.0;
		this.specularIntensityMap = null;
		this.specularColor = new Color( 1, 1, 1 );
		this.specularColorMap = null;

		this._anisotropy = 0;
		this._clearcoat = 0;
		this._iridescence = 0;
		this._sheen = 0.0;
		this._transmission = 0;

		this.setValues( parameters );

	}

	get anisotropy() {

		return this._anisotropy;

	}

	set anisotropy( value ) {

		if ( this._anisotropy > 0 !== value > 0 ) {

			this.version ++;

		}

		this._anisotropy = value;

	}

	get clearcoat() {

		return this._clearcoat;

	}

	set clearcoat( value ) {

		if ( this._clearcoat > 0 !== value > 0 ) {

			this.version ++;

		}

		this._clearcoat = value;

	}

	get iridescence() {

		return this._iridescence;

	}

	set iridescence( value ) {

		if ( this._iridescence > 0 !== value > 0 ) {

			this.version ++;

		}

		this._iridescence = value;

	}

	get sheen() {

		return this._sheen;

	}

	set sheen( value ) {

		if ( this._sheen > 0 !== value > 0 ) {

			this.version ++;

		}

		this._sheen = value;

	}

	get transmission() {

		return this._transmission;

	}

	set transmission( value ) {

		if ( this._transmission > 0 !== value > 0 ) {

			this.version ++;

		}

		this._transmission = value;

	}

	copy( source ) {

		super.copy( source );

		this.defines = {

			'STANDARD': '',
			'PHYSICAL': ''

		};

		this.anisotropy = source.anisotropy;
		this.anisotropyRotation = source.anisotropyRotation;
		this.anisotropyMap = source.anisotropyMap;

		this.clearcoat = source.clearcoat;
		this.clearcoatMap = source.clearcoatMap;
		this.clearcoatRoughness = source.clearcoatRoughness;
		this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
		this.clearcoatNormalMap = source.clearcoatNormalMap;
		this.clearcoatNormalScale.copy( source.clearcoatNormalScale );

		this.ior = source.ior;

		this.iridescence = source.iridescence;
		this.iridescenceMap = source.iridescenceMap;
		this.iridescenceIOR = source.iridescenceIOR;
		this.iridescenceThicknessRange = [ ...source.iridescenceThicknessRange ];
		this.iridescenceThicknessMap = source.iridescenceThicknessMap;

		this.sheen = source.sheen;
		this.sheenColor.copy( source.sheenColor );
		this.sheenColorMap = source.sheenColorMap;
		this.sheenRoughness = source.sheenRoughness;
		this.sheenRoughnessMap = source.sheenRoughnessMap;

		this.transmission = source.transmission;
		this.transmissionMap = source.transmissionMap;

		this.thickness = source.thickness;
		this.thicknessMap = source.thicknessMap;
		this.attenuationDistance = source.attenuationDistance;
		this.attenuationColor.copy( source.attenuationColor );

		this.specularIntensity = source.specularIntensity;
		this.specularIntensityMap = source.specularIntensityMap;
		this.specularColor.copy( source.specularColor );
		this.specularColorMap = source.specularColorMap;

		return this;

	}

}

class MeshPhongMaterial extends (/* unused pure expression or super */ null && (Material)) {

	constructor( parameters ) {

		super();

		this.isMeshPhongMaterial = true;

		this.type = 'MeshPhongMaterial';

		this.color = new Color( 0xffffff ); // diffuse
		this.specular = new Color( 0x111111 );
		this.shininess = 30;

		this.map = null;

		this.lightMap = null;
		this.lightMapIntensity = 1.0;

		this.aoMap = null;
		this.aoMapIntensity = 1.0;

		this.emissive = new Color( 0x000000 );
		this.emissiveIntensity = 1.0;
		this.emissiveMap = null;

		this.bumpMap = null;
		this.bumpScale = 1;

		this.normalMap = null;
		this.normalMapType = TangentSpaceNormalMap;
		this.normalScale = new Vector2( 1, 1 );

		this.displacementMap = null;
		this.displacementScale = 1;
		this.displacementBias = 0;

		this.specularMap = null;

		this.alphaMap = null;

		this.envMap = null;
		this.envMapRotation = new Euler();
		this.combine = MultiplyOperation;
		this.reflectivity = 1;
		this.refractionRatio = 0.98;

		this.wireframe = false;
		this.wireframeLinewidth = 1;
		this.wireframeLinecap = 'round';
		this.wireframeLinejoin = 'round';

		this.flatShading = false;

		this.fog = true;

		this.setValues( parameters );

	}

	copy( source ) {

		super.copy( source );

		this.color.copy( source.color );
		this.specular.copy( source.specular );
		this.shininess = source.shininess;

		this.map = source.map;

		this.lightMap = source.lightMap;
		this.lightMapIntensity = source.lightMapIntensity;

		this.aoMap = source.aoMap;
		this.aoMapIntensity = source.aoMapIntensity;

		this.emissive.copy( source.emissive );
		this.emissiveMap = source.emissiveMap;
		this.emissiveIntensity = source.emissiveIntensity;

		this.bumpMap = source.bumpMap;
		this.bumpScale = source.bumpScale;

		this.normalMap = source.normalMap;
		this.normalMapType = source.normalMapType;
		this.normalScale.copy( source.normalScale );

		this.displacementMap = source.displacementMap;
		this.displacementScale = source.displacementScale;
		this.displacementBias = source.displacementBias;

		this.specularMap = source.specularMap;

		this.alphaMap = source.alphaMap;

		this.envMap = source.envMap;
		this.envMapRotation.copy( source.envMapRotation );
		this.combine = source.combine;
		this.reflectivity = source.reflectivity;
		this.refractionRatio = source.refractionRatio;

		this.wireframe = source.wireframe;
		this.wireframeLinewidth = source.wireframeLinewidth;
		this.wireframeLinecap = source.wireframeLinecap;
		this.wireframeLinejoin = source.wireframeLinejoin;

		this.flatShading = source.flatShading;

		this.fog = source.fog;

		return this;

	}

}

class MeshToonMaterial extends (/* unused pure expression or super */ null && (Material)) {

	constructor( parameters ) {

		super();

		this.isMeshToonMaterial = true;

		this.defines = { 'TOON': '' };

		this.type = 'MeshToonMaterial';

		this.color = new Color( 0xffffff );

		this.map = null;
		this.gradientMap = null;

		this.lightMap = null;
		this.lightMapIntensity = 1.0;

		this.aoMap = null;
		this.aoMapIntensity = 1.0;

		this.emissive = new Color( 0x000000 );
		this.emissiveIntensity = 1.0;
		this.emissiveMap = null;

		this.bumpMap = null;
		this.bumpScale = 1;

		this.normalMap = null;
		this.normalMapType = TangentSpaceNormalMap;
		this.normalScale = new Vector2( 1, 1 );

		this.displacementMap = null;
		this.displacementScale = 1;
		this.displacementBias = 0;

		this.alphaMap = null;

		this.wireframe = false;
		this.wireframeLinewidth = 1;
		this.wireframeLinecap = 'round';
		this.wireframeLinejoin = 'round';

		this.fog = true;

		this.setValues( parameters );

	}

	copy( source ) {

		super.copy( source );

		this.color.copy( source.color );

		this.map = source.map;
		this.gradientMap = source.gradientMap;

		this.lightMap = source.lightMap;
		this.lightMapIntensity = source.lightMapIntensity;

		this.aoMap = source.aoMap;
		this.aoMapIntensity = source.aoMapIntensity;

		this.emissive.copy( source.emissive );
		this.emissiveMap = source.emissiveMap;
		this.emissiveIntensity = source.emissiveIntensity;

		this.bumpMap = source.bumpMap;
		this.bumpScale = source.bumpScale;

		this.normalMap = source.normalMap;
		this.normalMapType = source.normalMapType;
		this.normalScale.copy( source.normalScale );

		this.displacementMap = source.displacementMap;
		this.displacementScale = source.displacementScale;
		this.displacementBias = source.displacementBias;

		this.alphaMap = source.alphaMap;

		this.wireframe = source.wireframe;
		this.wireframeLinewidth = source.wireframeLinewidth;
		this.wireframeLinecap = source.wireframeLinecap;
		this.wireframeLinejoin = source.wireframeLinejoin;

		this.fog = source.fog;

		return this;

	}

}

class MeshNormalMaterial extends (/* unused pure expression or super */ null && (Material)) {

	constructor( parameters ) {

		super();

		this.isMeshNormalMaterial = true;

		this.type = 'MeshNormalMaterial';

		this.bumpMap = null;
		this.bumpScale = 1;

		this.normalMap = null;
		this.normalMapType = TangentSpaceNormalMap;
		this.normalScale = new Vector2( 1, 1 );

		this.displacementMap = null;
		this.displacementScale = 1;
		this.displacementBias = 0;

		this.wireframe = false;
		this.wireframeLinewidth = 1;

		this.flatShading = false;

		this.setValues( parameters );

	}

	copy( source ) {

		super.copy( source );

		this.bumpMap = source.bumpMap;
		this.bumpScale = source.bumpScale;

		this.normalMap = source.normalMap;
		this.normalMapType = source.normalMapType;
		this.normalScale.copy( source.normalScale );

		this.displacementMap = source.displacementMap;
		this.displacementScale = source.displacementScale;
		this.displacementBias = source.displacementBias;

		this.wireframe = source.wireframe;
		this.wireframeLinewidth = source.wireframeLinewidth;

		this.flatShading = source.flatShading;

		return this;

	}

}

class MeshLambertMaterial extends (/* unused pure expression or super */ null && (Material)) {

	constructor( parameters ) {

		super();

		this.isMeshLambertMaterial = true;

		this.type = 'MeshLambertMaterial';

		this.color = new Color( 0xffffff ); // diffuse

		this.map = null;

		this.lightMap = null;
		this.lightMapIntensity = 1.0;

		this.aoMap = null;
		this.aoMapIntensity = 1.0;

		this.emissive = new Color( 0x000000 );
		this.emissiveIntensity = 1.0;
		this.emissiveMap = null;

		this.bumpMap = null;
		this.bumpScale = 1;

		this.normalMap = null;
		this.normalMapType = TangentSpaceNormalMap;
		this.normalScale = new Vector2( 1, 1 );

		this.displacementMap = null;
		this.displacementScale = 1;
		this.displacementBias = 0;

		this.specularMap = null;

		this.alphaMap = null;

		this.envMap = null;
		this.envMapRotation = new Euler();
		this.combine = MultiplyOperation;
		this.reflectivity = 1;
		this.refractionRatio = 0.98;

		this.wireframe = false;
		this.wireframeLinewidth = 1;
		this.wireframeLinecap = 'round';
		this.wireframeLinejoin = 'round';

		this.flatShading = false;

		this.fog = true;

		this.setValues( parameters );

	}

	copy( source ) {

		super.copy( source );

		this.color.copy( source.color );

		this.map = source.map;

		this.lightMap = source.lightMap;
		this.lightMapIntensity = source.lightMapIntensity;

		this.aoMap = source.aoMap;
		this.aoMapIntensity = source.aoMapIntensity;

		this.emissive.copy( source.emissive );
		this.emissiveMap = source.emissiveMap;
		this.emissiveIntensity = source.emissiveIntensity;

		this.bumpMap = source.bumpMap;
		this.bumpScale = source.bumpScale;

		this.normalMap = source.normalMap;
		this.normalMapType = source.normalMapType;
		this.normalScale.copy( source.normalScale );

		this.displacementMap = source.displacementMap;
		this.displacementScale = source.displacementScale;
		this.displacementBias = source.displacementBias;

		this.specularMap = source.specularMap;

		this.alphaMap = source.alphaMap;

		this.envMap = source.envMap;
		this.envMapRotation.copy( source.envMapRotation );
		this.combine = source.combine;
		this.reflectivity = source.reflectivity;
		this.refractionRatio = source.refractionRatio;

		this.wireframe = source.wireframe;
		this.wireframeLinewidth = source.wireframeLinewidth;
		this.wireframeLinecap = source.wireframeLinecap;
		this.wireframeLinejoin = source.wireframeLinejoin;

		this.flatShading = source.flatShading;

		this.fog = source.fog;

		return this;

	}

}

class MeshMatcapMaterial extends (/* unused pure expression or super */ null && (Material)) {

	constructor( parameters ) {

		super();

		this.isMeshMatcapMaterial = true;

		this.defines = { 'MATCAP': '' };

		this.type = 'MeshMatcapMaterial';

		this.color = new Color( 0xffffff ); // diffuse

		this.matcap = null;

		this.map = null;

		this.bumpMap = null;
		this.bumpScale = 1;

		this.normalMap = null;
		this.normalMapType = TangentSpaceNormalMap;
		this.normalScale = new Vector2( 1, 1 );

		this.displacementMap = null;
		this.displacementScale = 1;
		this.displacementBias = 0;

		this.alphaMap = null;

		this.flatShading = false;

		this.fog = true;

		this.setValues( parameters );

	}


	copy( source ) {

		super.copy( source );

		this.defines = { 'MATCAP': '' };

		this.color.copy( source.color );

		this.matcap = source.matcap;

		this.map = source.map;

		this.bumpMap = source.bumpMap;
		this.bumpScale = source.bumpScale;

		this.normalMap = source.normalMap;
		this.normalMapType = source.normalMapType;
		this.normalScale.copy( source.normalScale );

		this.displacementMap = source.displacementMap;
		this.displacementScale = source.displacementScale;
		this.displacementBias = source.displacementBias;

		this.alphaMap = source.alphaMap;

		this.flatShading = source.flatShading;

		this.fog = source.fog;

		return this;

	}

}

class LineDashedMaterial extends (/* unused pure expression or super */ null && (LineBasicMaterial)) {

	constructor( parameters ) {

		super();

		this.isLineDashedMaterial = true;

		this.type = 'LineDashedMaterial';

		this.scale = 1;
		this.dashSize = 3;
		this.gapSize = 1;

		this.setValues( parameters );

	}

	copy( source ) {

		super.copy( source );

		this.scale = source.scale;
		this.dashSize = source.dashSize;
		this.gapSize = source.gapSize;

		return this;

	}

}

// converts an array to a specific type
function convertArray( array, type, forceClone ) {

	if ( ! array || // let 'undefined' and 'null' pass
		! forceClone && array.constructor === type ) return array;

	if ( typeof type.BYTES_PER_ELEMENT === 'number' ) {

		return new type( array ); // create typed array

	}

	return Array.prototype.slice.call( array ); // create Array

}

function isTypedArray( object ) {

	return ArrayBuffer.isView( object ) &&
		! ( object instanceof DataView );

}

// returns an array by which times and values can be sorted
function getKeyframeOrder( times ) {

	function compareTime( i, j ) {

		return times[ i ] - times[ j ];

	}

	const n = times.length;
	const result = new Array( n );
	for ( let i = 0; i !== n; ++ i ) result[ i ] = i;

	result.sort( compareTime );

	return result;

}

// uses the array previously returned by 'getKeyframeOrder' to sort data
function sortedArray( values, stride, order ) {

	const nValues = values.length;
	const result = new values.constructor( nValues );

	for ( let i = 0, dstOffset = 0; dstOffset !== nValues; ++ i ) {

		const srcOffset = order[ i ] * stride;

		for ( let j = 0; j !== stride; ++ j ) {

			result[ dstOffset ++ ] = values[ srcOffset + j ];

		}

	}

	return result;

}

// function for parsing AOS keyframe formats
function flattenJSON( jsonKeys, times, values, valuePropertyName ) {

	let i = 1, key = jsonKeys[ 0 ];

	while ( key !== undefined && key[ valuePropertyName ] === undefined ) {

		key = jsonKeys[ i ++ ];

	}

	if ( key === undefined ) return; // no data

	let value = key[ valuePropertyName ];
	if ( value === undefined ) return; // no data

	if ( Array.isArray( value ) ) {

		do {

			value = key[ valuePropertyName ];

			if ( value !== undefined ) {

				times.push( key.time );
				values.push.apply( values, value ); // push all elements

			}

			key = jsonKeys[ i ++ ];

		} while ( key !== undefined );

	} else if ( value.toArray !== undefined ) {

		// ...assume THREE.Math-ish

		do {

			value = key[ valuePropertyName ];

			if ( value !== undefined ) {

				times.push( key.time );
				value.toArray( values, values.length );

			}

			key = jsonKeys[ i ++ ];

		} while ( key !== undefined );

	} else {

		// otherwise push as-is

		do {

			value = key[ valuePropertyName ];

			if ( value !== undefined ) {

				times.push( key.time );
				values.push( value );

			}

			key = jsonKeys[ i ++ ];

		} while ( key !== undefined );

	}

}

function subclip( sourceClip, name, startFrame, endFrame, fps = 30 ) {

	const clip = sourceClip.clone();

	clip.name = name;

	const tracks = [];

	for ( let i = 0; i < clip.tracks.length; ++ i ) {

		const track = clip.tracks[ i ];
		const valueSize = track.getValueSize();

		const times = [];
		const values = [];

		for ( let j = 0; j < track.times.length; ++ j ) {

			const frame = track.times[ j ] * fps;

			if ( frame < startFrame || frame >= endFrame ) continue;

			times.push( track.times[ j ] );

			for ( let k = 0; k < valueSize; ++ k ) {

				values.push( track.values[ j * valueSize + k ] );

			}

		}

		if ( times.length === 0 ) continue;

		track.times = convertArray( times, track.times.constructor );
		track.values = convertArray( values, track.values.constructor );

		tracks.push( track );

	}

	clip.tracks = tracks;

	// find minimum .times value across all tracks in the trimmed clip

	let minStartTime = Infinity;

	for ( let i = 0; i < clip.tracks.length; ++ i ) {

		if ( minStartTime > clip.tracks[ i ].times[ 0 ] ) {

			minStartTime = clip.tracks[ i ].times[ 0 ];

		}

	}

	// shift all tracks such that clip begins at t=0

	for ( let i = 0; i < clip.tracks.length; ++ i ) {

		clip.tracks[ i ].shift( - 1 * minStartTime );

	}

	clip.resetDuration();

	return clip;

}

function makeClipAdditive( targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30 ) {

	if ( fps <= 0 ) fps = 30;

	const numTracks = referenceClip.tracks.length;
	const referenceTime = referenceFrame / fps;

	// Make each track's values relative to the values at the reference frame
	for ( let i = 0; i < numTracks; ++ i ) {

		const referenceTrack = referenceClip.tracks[ i ];
		const referenceTrackType = referenceTrack.ValueTypeName;

		// Skip this track if it's non-numeric
		if ( referenceTrackType === 'bool' || referenceTrackType === 'string' ) continue;

		// Find the track in the target clip whose name and type matches the reference track
		const targetTrack = targetClip.tracks.find( function ( track ) {

			return track.name === referenceTrack.name
				&& track.ValueTypeName === referenceTrackType;

		} );

		if ( targetTrack === undefined ) continue;

		let referenceOffset = 0;
		const referenceValueSize = referenceTrack.getValueSize();

		if ( referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline ) {

			referenceOffset = referenceValueSize / 3;

		}

		let targetOffset = 0;
		const targetValueSize = targetTrack.getValueSize();

		if ( targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline ) {

			targetOffset = targetValueSize / 3;

		}

		const lastIndex = referenceTrack.times.length - 1;
		let referenceValue;

		// Find the value to subtract out of the track
		if ( referenceTime <= referenceTrack.times[ 0 ] ) {

			// Reference frame is earlier than the first keyframe, so just use the first keyframe
			const startIndex = referenceOffset;
			const endIndex = referenceValueSize - referenceOffset;
			referenceValue = referenceTrack.values.slice( startIndex, endIndex );

		} else if ( referenceTime >= referenceTrack.times[ lastIndex ] ) {

			// Reference frame is after the last keyframe, so just use the last keyframe
			const startIndex = lastIndex * referenceValueSize + referenceOffset;
			const endIndex = startIndex + referenceValueSize - referenceOffset;
			referenceValue = referenceTrack.values.slice( startIndex, endIndex );

		} else {

			// Interpolate to the reference value
			const interpolant = referenceTrack.createInterpolant();
			const startIndex = referenceOffset;
			const endIndex = referenceValueSize - referenceOffset;
			interpolant.evaluate( referenceTime );
			referenceValue = interpolant.resultBuffer.slice( startIndex, endIndex );

		}

		// Conjugate the quaternion
		if ( referenceTrackType === 'quaternion' ) {

			const referenceQuat = new Quaternion().fromArray( referenceValue ).normalize().conjugate();
			referenceQuat.toArray( referenceValue );

		}

		// Subtract the reference value from all of the track values

		const numTimes = targetTrack.times.length;
		for ( let j = 0; j < numTimes; ++ j ) {

			const valueStart = j * targetValueSize + targetOffset;

			if ( referenceTrackType === 'quaternion' ) {

				// Multiply the conjugate for quaternion track types
				Quaternion.multiplyQuaternionsFlat(
					targetTrack.values,
					valueStart,
					referenceValue,
					0,
					targetTrack.values,
					valueStart
				);

			} else {

				const valueEnd = targetValueSize - targetOffset * 2;

				// Subtract each value for all other numeric track types
				for ( let k = 0; k < valueEnd; ++ k ) {

					targetTrack.values[ valueStart + k ] -= referenceValue[ k ];

				}

			}

		}

	}

	targetClip.blendMode = AdditiveAnimationBlendMode;

	return targetClip;

}

const AnimationUtils = {
	convertArray: convertArray,
	isTypedArray: isTypedArray,
	getKeyframeOrder: getKeyframeOrder,
	sortedArray: sortedArray,
	flattenJSON: flattenJSON,
	subclip: subclip,
	makeClipAdditive: makeClipAdditive
};

/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References:
 *
 * 		http://www.oodesign.com/template-method-pattern.html
 *
 */

class Interpolant {

	constructor( parameterPositions, sampleValues, sampleSize, resultBuffer ) {

		this.parameterPositions = parameterPositions;
		this._cachedIndex = 0;

		this.resultBuffer = resultBuffer !== undefined ?
			resultBuffer : new sampleValues.constructor( sampleSize );
		this.sampleValues = sampleValues;
		this.valueSize = sampleSize;

		this.settings = null;
		this.DefaultSettings_ = {};

	}

	evaluate( t ) {

		const pp = this.parameterPositions;
		let i1 = this._cachedIndex,
			t1 = pp[ i1 ],
			t0 = pp[ i1 - 1 ];

		validate_interval: {

			seek: {

				let right;

				linear_scan: {

					//- See http://jsperf.com/comparison-to-undefined/3
					//- slower code:
					//-
					//- 				if ( t >= t1 || t1 === undefined ) {
					forward_scan: if ( ! ( t < t1 ) ) {

						for ( let giveUpAt = i1 + 2; ; ) {

							if ( t1 === undefined ) {

								if ( t < t0 ) break forward_scan;

								// after end

								i1 = pp.length;
								this._cachedIndex = i1;
								return this.copySampleValue_( i1 - 1 );

							}

							if ( i1 === giveUpAt ) break; // this loop

							t0 = t1;
							t1 = pp[ ++ i1 ];

							if ( t < t1 ) {

								// we have arrived at the sought interval
								break seek;

							}

						}

						// prepare binary search on the right side of the index
						right = pp.length;
						break linear_scan;

					}

					//- slower code:
					//-					if ( t < t0 || t0 === undefined ) {
					if ( ! ( t >= t0 ) ) {

						// looping?

						const t1global = pp[ 1 ];

						if ( t < t1global ) {

							i1 = 2; // + 1, using the scan for the details
							t0 = t1global;

						}

						// linear reverse scan

						for ( let giveUpAt = i1 - 2; ; ) {

							if ( t0 === undefined ) {

								// before start

								this._cachedIndex = 0;
								return this.copySampleValue_( 0 );

							}

							if ( i1 === giveUpAt ) break; // this loop

							t1 = t0;
							t0 = pp[ -- i1 - 1 ];

							if ( t >= t0 ) {

								// we have arrived at the sought interval
								break seek;

							}

						}

						// prepare binary search on the left side of the index
						right = i1;
						i1 = 0;
						break linear_scan;

					}

					// the interval is valid

					break validate_interval;

				} // linear scan

				// binary search

				while ( i1 < right ) {

					const mid = ( i1 + right ) >>> 1;

					if ( t < pp[ mid ] ) {

						right = mid;

					} else {

						i1 = mid + 1;

					}

				}

				t1 = pp[ i1 ];
				t0 = pp[ i1 - 1 ];

				// check boundary cases, again

				if ( t0 === undefined ) {

					this._cachedIndex = 0;
					return this.copySampleValue_( 0 );

				}

				if ( t1 === undefined ) {

					i1 = pp.length;
					this._cachedIndex = i1;
					return this.copySampleValue_( i1 - 1 );

				}

			} // seek

			this._cachedIndex = i1;

			this.intervalChanged_( i1, t0, t1 );

		} // validate_interval

		return this.interpolate_( i1, t0, t, t1 );

	}

	getSettings_() {

		return this.settings || this.DefaultSettings_;

	}

	copySampleValue_( index ) {

		// copies a sample value to the result buffer

		const result = this.resultBuffer,
			values = this.sampleValues,
			stride = this.valueSize,
			offset = index * stride;

		for ( let i = 0; i !== stride; ++ i ) {

			result[ i ] = values[ offset + i ];

		}

		return result;

	}

	// Template methods for derived classes:

	interpolate_( /* i1, t0, t, t1 */ ) {

		throw new Error( 'call to abstract method' );
		// implementations shall return this.resultBuffer

	}

	intervalChanged_( /* i1, t0, t1 */ ) {

		// empty

	}

}

/**
 * Fast and simple cubic spline interpolant.
 *
 * It was derived from a Hermitian construction setting the first derivative
 * at each sample position to the linear slope between neighboring positions
 * over their parameter interval.
 */

class CubicInterpolant extends Interpolant {

	constructor( parameterPositions, sampleValues, sampleSize, resultBuffer ) {

		super( parameterPositions, sampleValues, sampleSize, resultBuffer );

		this._weightPrev = - 0;
		this._offsetPrev = - 0;
		this._weightNext = - 0;
		this._offsetNext = - 0;

		this.DefaultSettings_ = {

			endingStart: ZeroCurvatureEnding,
			endingEnd: ZeroCurvatureEnding

		};

	}

	intervalChanged_( i1, t0, t1 ) {

		const pp = this.parameterPositions;
		let iPrev = i1 - 2,
			iNext = i1 + 1,

			tPrev = pp[ iPrev ],
			tNext = pp[ iNext ];

		if ( tPrev === undefined ) {

			switch ( this.getSettings_().endingStart ) {

				case ZeroSlopeEnding:

					// f'(t0) = 0
					iPrev = i1;
					tPrev = 2 * t0 - t1;

					break;

				case WrapAroundEnding:

					// use the other end of the curve
					iPrev = pp.length - 2;
					tPrev = t0 + pp[ iPrev ] - pp[ iPrev + 1 ];

					break;

				default: // ZeroCurvatureEnding

					// f''(t0) = 0 a.k.a. Natural Spline
					iPrev = i1;
					tPrev = t1;

			}

		}

		if ( tNext === undefined ) {

			switch ( this.getSettings_().endingEnd ) {

				case ZeroSlopeEnding:

					// f'(tN) = 0
					iNext = i1;
					tNext = 2 * t1 - t0;

					break;

				case WrapAroundEnding:

					// use the other end of the curve
					iNext = 1;
					tNext = t1 + pp[ 1 ] - pp[ 0 ];

					break;

				default: // ZeroCurvatureEnding

					// f''(tN) = 0, a.k.a. Natural Spline
					iNext = i1 - 1;
					tNext = t0;

			}

		}

		const halfDt = ( t1 - t0 ) * 0.5,
			stride = this.valueSize;

		this._weightPrev = halfDt / ( t0 - tPrev );
		this._weightNext = halfDt / ( tNext - t1 );
		this._offsetPrev = iPrev * stride;
		this._offsetNext = iNext * stride;

	}

	interpolate_( i1, t0, t, t1 ) {

		const result = this.resultBuffer,
			values = this.sampleValues,
			stride = this.valueSize,

			o1 = i1 * stride,		o0 = o1 - stride,
			oP = this._offsetPrev, 	oN = this._offsetNext,
			wP = this._weightPrev,	wN = this._weightNext,

			p = ( t - t0 ) / ( t1 - t0 ),
			pp = p * p,
			ppp = pp * p;

		// evaluate polynomials

		const sP = - wP * ppp + 2 * wP * pp - wP * p;
		const s0 = ( 1 + wP ) * ppp + ( - 1.5 - 2 * wP ) * pp + ( - 0.5 + wP ) * p + 1;
		const s1 = ( - 1 - wN ) * ppp + ( 1.5 + wN ) * pp + 0.5 * p;
		const sN = wN * ppp - wN * pp;

		// combine data linearly

		for ( let i = 0; i !== stride; ++ i ) {

			result[ i ] =
					sP * values[ oP + i ] +
					s0 * values[ o0 + i ] +
					s1 * values[ o1 + i ] +
					sN * values[ oN + i ];

		}

		return result;

	}

}

class LinearInterpolant extends Interpolant {

	constructor( parameterPositions, sampleValues, sampleSize, resultBuffer ) {

		super( parameterPositions, sampleValues, sampleSize, resultBuffer );

	}

	interpolate_( i1, t0, t, t1 ) {

		const result = this.resultBuffer,
			values = this.sampleValues,
			stride = this.valueSize,

			offset1 = i1 * stride,
			offset0 = offset1 - stride,

			weight1 = ( t - t0 ) / ( t1 - t0 ),
			weight0 = 1 - weight1;

		for ( let i = 0; i !== stride; ++ i ) {

			result[ i ] =
					values[ offset0 + i ] * weight0 +
					values[ offset1 + i ] * weight1;

		}

		return result;

	}

}

/**
 *
 * Interpolant that evaluates to the sample value at the position preceding
 * the parameter.
 */

class DiscreteInterpolant extends Interpolant {

	constructor( parameterPositions, sampleValues, sampleSize, resultBuffer ) {

		super( parameterPositions, sampleValues, sampleSize, resultBuffer );

	}

	interpolate_( i1 /*, t0, t, t1 */ ) {

		return this.copySampleValue_( i1 - 1 );

	}

}

class KeyframeTrack {

	constructor( name, times, values, interpolation ) {

		if ( name === undefined ) throw new Error( 'THREE.KeyframeTrack: track name is undefined' );
		if ( times === undefined || times.length === 0 ) throw new Error( 'THREE.KeyframeTrack: no keyframes in track named ' + name );

		this.name = name;

		this.times = convertArray( times, this.TimeBufferType );
		this.values = convertArray( values, this.ValueBufferType );

		this.setInterpolation( interpolation || this.DefaultInterpolation );

	}

	// Serialization (in static context, because of constructor invocation
	// and automatic invocation of .toJSON):

	static toJSON( track ) {

		const trackType = track.constructor;

		let json;

		// derived classes can define a static toJSON method
		if ( trackType.toJSON !== this.toJSON ) {

			json = trackType.toJSON( track );

		} else {

			// by default, we assume the data can be serialized as-is
			json = {

				'name': track.name,
				'times': convertArray( track.times, Array ),
				'values': convertArray( track.values, Array )

			};

			const interpolation = track.getInterpolation();

			if ( interpolation !== track.DefaultInterpolation ) {

				json.interpolation = interpolation;

			}

		}

		json.type = track.ValueTypeName; // mandatory

		return json;

	}

	InterpolantFactoryMethodDiscrete( result ) {

		return new DiscreteInterpolant( this.times, this.values, this.getValueSize(), result );

	}

	InterpolantFactoryMethodLinear( result ) {

		return new LinearInterpolant( this.times, this.values, this.getValueSize(), result );

	}

	InterpolantFactoryMethodSmooth( result ) {

		return new CubicInterpolant( this.times, this.values, this.getValueSize(), result );

	}

	setInterpolation( interpolation ) {

		let factoryMethod;

		switch ( interpolation ) {

			case InterpolateDiscrete:

				factoryMethod = this.InterpolantFactoryMethodDiscrete;

				break;

			case InterpolateLinear:

				factoryMethod = this.InterpolantFactoryMethodLinear;

				break;

			case InterpolateSmooth:

				factoryMethod = this.InterpolantFactoryMethodSmooth;

				break;

		}

		if ( factoryMethod === undefined ) {

			const message = 'unsupported interpolation for ' +
				this.ValueTypeName + ' keyframe track named ' + this.name;

			if ( this.createInterpolant === undefined ) {

				// fall back to default, unless the default itself is messed up
				if ( interpolation !== this.DefaultInterpolation ) {

					this.setInterpolation( this.DefaultInterpolation );

				} else {

					throw new Error( message ); // fatal, in this case

				}

			}

			console.warn( 'THREE.KeyframeTrack:', message );
			return this;

		}

		this.createInterpolant = factoryMethod;

		return this;

	}

	getInterpolation() {

		switch ( this.createInterpolant ) {

			case this.InterpolantFactoryMethodDiscrete:

				return InterpolateDiscrete;

			case this.InterpolantFactoryMethodLinear:

				return InterpolateLinear;

			case this.InterpolantFactoryMethodSmooth:

				return InterpolateSmooth;

		}

	}

	getValueSize() {

		return this.values.length / this.times.length;

	}

	// move all keyframes either forwards or backwards in time
	shift( timeOffset ) {

		if ( timeOffset !== 0.0 ) {

			const times = this.times;

			for ( let i = 0, n = times.length; i !== n; ++ i ) {

				times[ i ] += timeOffset;

			}

		}

		return this;

	}

	// scale all keyframe times by a factor (useful for frame <-> seconds conversions)
	scale( timeScale ) {

		if ( timeScale !== 1.0 ) {

			const times = this.times;

			for ( let i = 0, n = times.length; i !== n; ++ i ) {

				times[ i ] *= timeScale;

			}

		}

		return this;

	}

	// removes keyframes before and after animation without changing any values within the range [startTime, endTime].
	// IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
	trim( startTime, endTime ) {

		const times = this.times,
			nKeys = times.length;

		let from = 0,
			to = nKeys - 1;

		while ( from !== nKeys && times[ from ] < startTime ) {

			++ from;

		}

		while ( to !== - 1 && times[ to ] > endTime ) {

			-- to;

		}

		++ to; // inclusive -> exclusive bound

		if ( from !== 0 || to !== nKeys ) {

			// empty tracks are forbidden, so keep at least one keyframe
			if ( from >= to ) {

				to = Math.max( to, 1 );
				from = to - 1;

			}

			const stride = this.getValueSize();
			this.times = times.slice( from, to );
			this.values = this.values.slice( from * stride, to * stride );

		}

		return this;

	}

	// ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
	validate() {

		let valid = true;

		const valueSize = this.getValueSize();
		if ( valueSize - Math.floor( valueSize ) !== 0 ) {

			console.error( 'THREE.KeyframeTrack: Invalid value size in track.', this );
			valid = false;

		}

		const times = this.times,
			values = this.values,

			nKeys = times.length;

		if ( nKeys === 0 ) {

			console.error( 'THREE.KeyframeTrack: Track is empty.', this );
			valid = false;

		}

		let prevTime = null;

		for ( let i = 0; i !== nKeys; i ++ ) {

			const currTime = times[ i ];

			if ( typeof currTime === 'number' && isNaN( currTime ) ) {

				console.error( 'THREE.KeyframeTrack: Time is not a valid number.', this, i, currTime );
				valid = false;
				break;

			}

			if ( prevTime !== null && prevTime > currTime ) {

				console.error( 'THREE.KeyframeTrack: Out of order keys.', this, i, currTime, prevTime );
				valid = false;
				break;

			}

			prevTime = currTime;

		}

		if ( values !== undefined ) {

			if ( isTypedArray( values ) ) {

				for ( let i = 0, n = values.length; i !== n; ++ i ) {

					const value = values[ i ];

					if ( isNaN( value ) ) {

						console.error( 'THREE.KeyframeTrack: Value is not a valid number.', this, i, value );
						valid = false;
						break;

					}

				}

			}

		}

		return valid;

	}

	// removes equivalent sequential keys as common in morph target sequences
	// (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
	optimize() {

		// times or values may be shared with other tracks, so overwriting is unsafe
		const times = this.times.slice(),
			values = this.values.slice(),
			stride = this.getValueSize(),

			smoothInterpolation = this.getInterpolation() === InterpolateSmooth,

			lastIndex = times.length - 1;

		let writeIndex = 1;

		for ( let i = 1; i < lastIndex; ++ i ) {

			let keep = false;

			const time = times[ i ];
			const timeNext = times[ i + 1 ];

			// remove adjacent keyframes scheduled at the same time

			if ( time !== timeNext && ( i !== 1 || time !== times[ 0 ] ) ) {

				if ( ! smoothInterpolation ) {

					// remove unnecessary keyframes same as their neighbors

					const offset = i * stride,
						offsetP = offset - stride,
						offsetN = offset + stride;

					for ( let j = 0; j !== stride; ++ j ) {

						const value = values[ offset + j ];

						if ( value !== values[ offsetP + j ] ||
							value !== values[ offsetN + j ] ) {

							keep = true;
							break;

						}

					}

				} else {

					keep = true;

				}

			}

			// in-place compaction

			if ( keep ) {

				if ( i !== writeIndex ) {

					times[ writeIndex ] = times[ i ];

					const readOffset = i * stride,
						writeOffset = writeIndex * stride;

					for ( let j = 0; j !== stride; ++ j ) {

						values[ writeOffset + j ] = values[ readOffset + j ];

					}

				}

				++ writeIndex;

			}

		}

		// flush last keyframe (compaction looks ahead)

		if ( lastIndex > 0 ) {

			times[ writeIndex ] = times[ lastIndex ];

			for ( let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++ j ) {

				values[ writeOffset + j ] = values[ readOffset + j ];

			}

			++ writeIndex;

		}

		if ( writeIndex !== times.length ) {

			this.times = times.slice( 0, writeIndex );
			this.values = values.slice( 0, writeIndex * stride );

		} else {

			this.times = times;
			this.values = values;

		}

		return this;

	}

	clone() {

		const times = this.times.slice();
		const values = this.values.slice();

		const TypedKeyframeTrack = this.constructor;
		const track = new TypedKeyframeTrack( this.name, times, values );

		// Interpolant argument to constructor is not saved, so copy the factory method directly.
		track.createInterpolant = this.createInterpolant;

		return track;

	}

}

KeyframeTrack.prototype.TimeBufferType = Float32Array;
KeyframeTrack.prototype.ValueBufferType = Float32Array;
KeyframeTrack.prototype.DefaultInterpolation = InterpolateLinear;

/**
 * A Track of Boolean keyframe values.
 */
class BooleanKeyframeTrack extends KeyframeTrack {}

BooleanKeyframeTrack.prototype.ValueTypeName = 'bool';
BooleanKeyframeTrack.prototype.ValueBufferType = Array;
BooleanKeyframeTrack.prototype.DefaultInterpolation = InterpolateDiscrete;
BooleanKeyframeTrack.prototype.InterpolantFactoryMethodLinear = undefined;
BooleanKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = undefined;

/**
 * A Track of keyframe values that represent color.
 */
class ColorKeyframeTrack extends KeyframeTrack {}

ColorKeyframeTrack.prototype.ValueTypeName = 'color';

/**
 * A Track of numeric keyframe values.
 */
class NumberKeyframeTrack extends KeyframeTrack {}

NumberKeyframeTrack.prototype.ValueTypeName = 'number';

/**
 * Spherical linear unit quaternion interpolant.
 */

class QuaternionLinearInterpolant extends Interpolant {

	constructor( parameterPositions, sampleValues, sampleSize, resultBuffer ) {

		super( parameterPositions, sampleValues, sampleSize, resultBuffer );

	}

	interpolate_( i1, t0, t, t1 ) {

		const result = this.resultBuffer,
			values = this.sampleValues,
			stride = this.valueSize,

			alpha = ( t - t0 ) / ( t1 - t0 );

		let offset = i1 * stride;

		for ( let end = offset + stride; offset !== end; offset += 4 ) {

			Quaternion.slerpFlat( result, 0, values, offset - stride, values, offset, alpha );

		}

		return result;

	}

}

/**
 * A Track of quaternion keyframe values.
 */
class QuaternionKeyframeTrack extends KeyframeTrack {

	InterpolantFactoryMethodLinear( result ) {

		return new QuaternionLinearInterpolant( this.times, this.values, this.getValueSize(), result );

	}

}

QuaternionKeyframeTrack.prototype.ValueTypeName = 'quaternion';
// ValueBufferType is inherited
QuaternionKeyframeTrack.prototype.DefaultInterpolation = InterpolateLinear;
QuaternionKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = undefined;

/**
 * A Track that interpolates Strings
 */
class StringKeyframeTrack extends KeyframeTrack {}

StringKeyframeTrack.prototype.ValueTypeName = 'string';
StringKeyframeTrack.prototype.ValueBufferType = Array;
StringKeyframeTrack.prototype.DefaultInterpolation = InterpolateDiscrete;
StringKeyframeTrack.prototype.InterpolantFactoryMethodLinear = undefined;
StringKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = undefined;

/**
 * A Track of vectored keyframe values.
 */
class VectorKeyframeTrack extends KeyframeTrack {}

VectorKeyframeTrack.prototype.ValueTypeName = 'vector';

class AnimationClip {

	constructor( name = '', duration = - 1, tracks = [], blendMode = NormalAnimationBlendMode ) {

		this.name = name;
		this.tracks = tracks;
		this.duration = duration;
		this.blendMode = blendMode;

		this.uuid = generateUUID();

		// this means it should figure out its duration by scanning the tracks
		if ( this.duration < 0 ) {

			this.resetDuration();

		}

	}


	static parse( json ) {

		const tracks = [],
			jsonTracks = json.tracks,
			frameTime = 1.0 / ( json.fps || 1.0 );

		for ( let i = 0, n = jsonTracks.length; i !== n; ++ i ) {

			tracks.push( parseKeyframeTrack( jsonTracks[ i ] ).scale( frameTime ) );

		}

		const clip = new this( json.name, json.duration, tracks, json.blendMode );
		clip.uuid = json.uuid;

		return clip;

	}

	static toJSON( clip ) {

		const tracks = [],
			clipTracks = clip.tracks;

		const json = {

			'name': clip.name,
			'duration': clip.duration,
			'tracks': tracks,
			'uuid': clip.uuid,
			'blendMode': clip.blendMode

		};

		for ( let i = 0, n = clipTracks.length; i !== n; ++ i ) {

			tracks.push( KeyframeTrack.toJSON( clipTracks[ i ] ) );

		}

		return json;

	}

	static CreateFromMorphTargetSequence( name, morphTargetSequence, fps, noLoop ) {

		const numMorphTargets = morphTargetSequence.length;
		const tracks = [];

		for ( let i = 0; i < numMorphTargets; i ++ ) {

			let times = [];
			let values = [];

			times.push(
				( i + numMorphTargets - 1 ) % numMorphTargets,
				i,
				( i + 1 ) % numMorphTargets );

			values.push( 0, 1, 0 );

			const order = getKeyframeOrder( times );
			times = sortedArray( times, 1, order );
			values = sortedArray( values, 1, order );

			// if there is a key at the first frame, duplicate it as the
			// last frame as well for perfect loop.
			if ( ! noLoop && times[ 0 ] === 0 ) {

				times.push( numMorphTargets );
				values.push( values[ 0 ] );

			}

			tracks.push(
				new NumberKeyframeTrack(
					'.morphTargetInfluences[' + morphTargetSequence[ i ].name + ']',
					times, values
				).scale( 1.0 / fps ) );

		}

		return new this( name, - 1, tracks );

	}

	static findByName( objectOrClipArray, name ) {

		let clipArray = objectOrClipArray;

		if ( ! Array.isArray( objectOrClipArray ) ) {

			const o = objectOrClipArray;
			clipArray = o.geometry && o.geometry.animations || o.animations;

		}

		for ( let i = 0; i < clipArray.length; i ++ ) {

			if ( clipArray[ i ].name === name ) {

				return clipArray[ i ];

			}

		}

		return null;

	}

	static CreateClipsFromMorphTargetSequences( morphTargets, fps, noLoop ) {

		const animationToMorphTargets = {};

		// tested with https://regex101.com/ on trick sequences
		// such flamingo_flyA_003, flamingo_run1_003, crdeath0059
		const pattern = /^([\w-]*?)([\d]+)$/;

		// sort morph target names into animation groups based
		// patterns like Walk_001, Walk_002, Run_001, Run_002
		for ( let i = 0, il = morphTargets.length; i < il; i ++ ) {

			const morphTarget = morphTargets[ i ];
			const parts = morphTarget.name.match( pattern );

			if ( parts && parts.length > 1 ) {

				const name = parts[ 1 ];

				let animationMorphTargets = animationToMorphTargets[ name ];

				if ( ! animationMorphTargets ) {

					animationToMorphTargets[ name ] = animationMorphTargets = [];

				}

				animationMorphTargets.push( morphTarget );

			}

		}

		const clips = [];

		for ( const name in animationToMorphTargets ) {

			clips.push( this.CreateFromMorphTargetSequence( name, animationToMorphTargets[ name ], fps, noLoop ) );

		}

		return clips;

	}

	// parse the animation.hierarchy format
	static parseAnimation( animation, bones ) {

		if ( ! animation ) {

			console.error( 'THREE.AnimationClip: No animation in JSONLoader data.' );
			return null;

		}

		const addNonemptyTrack = function ( trackType, trackName, animationKeys, propertyName, destTracks ) {

			// only return track if there are actually keys.
			if ( animationKeys.length !== 0 ) {

				const times = [];
				const values = [];

				flattenJSON( animationKeys, times, values, propertyName );

				// empty keys are filtered out, so check again
				if ( times.length !== 0 ) {

					destTracks.push( new trackType( trackName, times, values ) );

				}

			}

		};

		const tracks = [];

		const clipName = animation.name || 'default';
		const fps = animation.fps || 30;
		const blendMode = animation.blendMode;

		// automatic length determination in AnimationClip.
		let duration = animation.length || - 1;

		const hierarchyTracks = animation.hierarchy || [];

		for ( let h = 0; h < hierarchyTracks.length; h ++ ) {

			const animationKeys = hierarchyTracks[ h ].keys;

			// skip empty tracks
			if ( ! animationKeys || animationKeys.length === 0 ) continue;

			// process morph targets
			if ( animationKeys[ 0 ].morphTargets ) {

				// figure out all morph targets used in this track
				const morphTargetNames = {};

				let k;

				for ( k = 0; k < animationKeys.length; k ++ ) {

					if ( animationKeys[ k ].morphTargets ) {

						for ( let m = 0; m < animationKeys[ k ].morphTargets.length; m ++ ) {

							morphTargetNames[ animationKeys[ k ].morphTargets[ m ] ] = - 1;

						}

					}

				}

				// create a track for each morph target with all zero
				// morphTargetInfluences except for the keys in which
				// the morphTarget is named.
				for ( const morphTargetName in morphTargetNames ) {

					const times = [];
					const values = [];

					for ( let m = 0; m !== animationKeys[ k ].morphTargets.length; ++ m ) {

						const animationKey = animationKeys[ k ];

						times.push( animationKey.time );
						values.push( ( animationKey.morphTarget === morphTargetName ) ? 1 : 0 );

					}

					tracks.push( new NumberKeyframeTrack( '.morphTargetInfluence[' + morphTargetName + ']', times, values ) );

				}

				duration = morphTargetNames.length * fps;

			} else {

				// ...assume skeletal animation

				const boneName = '.bones[' + bones[ h ].name + ']';

				addNonemptyTrack(
					VectorKeyframeTrack, boneName + '.position',
					animationKeys, 'pos', tracks );

				addNonemptyTrack(
					QuaternionKeyframeTrack, boneName + '.quaternion',
					animationKeys, 'rot', tracks );

				addNonemptyTrack(
					VectorKeyframeTrack, boneName + '.scale',
					animationKeys, 'scl', tracks );

			}

		}

		if ( tracks.length === 0 ) {

			return null;

		}

		const clip = new this( clipName, duration, tracks, blendMode );

		return clip;

	}

	resetDuration() {

		const tracks = this.tracks;
		let duration = 0;

		for ( let i = 0, n = tracks.length; i !== n; ++ i ) {

			const track = this.tracks[ i ];

			duration = Math.max( duration, track.times[ track.times.length - 1 ] );

		}

		this.duration = duration;

		return this;

	}

	trim() {

		for ( let i = 0; i < this.tracks.length; i ++ ) {

			this.tracks[ i ].trim( 0, this.duration );

		}

		return this;

	}

	validate() {

		let valid = true;

		for ( let i = 0; i < this.tracks.length; i ++ ) {

			valid = valid && this.tracks[ i ].validate();

		}

		return valid;

	}

	optimize() {

		for ( let i = 0; i < this.tracks.length; i ++ ) {

			this.tracks[ i ].optimize();

		}

		return this;

	}

	clone() {

		const tracks = [];

		for ( let i = 0; i < this.tracks.length; i ++ ) {

			tracks.push( this.tracks[ i ].clone() );

		}

		return new this.constructor( this.name, this.duration, tracks, this.blendMode );

	}

	toJSON() {

		return this.constructor.toJSON( this );

	}

}

function getTrackTypeForValueTypeName( typeName ) {

	switch ( typeName.toLowerCase() ) {

		case 'scalar':
		case 'double':
		case 'float':
		case 'number':
		case 'integer':

			return NumberKeyframeTrack;

		case 'vector':
		case 'vector2':
		case 'vector3':
		case 'vector4':

			return VectorKeyframeTrack;

		case 'color':

			return ColorKeyframeTrack;

		case 'quaternion':

			return QuaternionKeyframeTrack;

		case 'bool':
		case 'boolean':

			return BooleanKeyframeTrack;

		case 'string':

			return StringKeyframeTrack;

	}

	throw new Error( 'THREE.KeyframeTrack: Unsupported typeName: ' + typeName );

}

function parseKeyframeTrack( json ) {

	if ( json.type === undefined ) {

		throw new Error( 'THREE.KeyframeTrack: track type undefined, can not parse' );

	}

	const trackType = getTrackTypeForValueTypeName( json.type );

	if ( json.times === undefined ) {

		const times = [], values = [];

		flattenJSON( json.keys, times, values, 'value' );

		json.times = times;
		json.values = values;

	}

	// derived classes can define a static parse method
	if ( trackType.parse !== undefined ) {

		return trackType.parse( json );

	} else {

		// by default, we assume a constructor compatible with the base
		return new trackType( json.name, json.times, json.values, json.interpolation );

	}

}

const Cache = {

	enabled: false,

	files: {},

	add: function ( key, file ) {

		if ( this.enabled === false ) return;

		// console.log( 'THREE.Cache', 'Adding key:', key );

		this.files[ key ] = file;

	},

	get: function ( key ) {

		if ( this.enabled === false ) return;

		// console.log( 'THREE.Cache', 'Checking key:', key );

		return this.files[ key ];

	},

	remove: function ( key ) {

		delete this.files[ key ];

	},

	clear: function () {

		this.files = {};

	}

};

class LoadingManager {

	constructor( onLoad, onProgress, onError ) {

		const scope = this;

		let isLoading = false;
		let itemsLoaded = 0;
		let itemsTotal = 0;
		let urlModifier = undefined;
		const handlers = [];

		// Refer to #5689 for the reason why we don't set .onStart
		// in the constructor

		this.onStart = undefined;
		this.onLoad = onLoad;
		this.onProgress = onProgress;
		this.onError = onError;

		this.itemStart = function ( url ) {

			itemsTotal ++;

			if ( isLoading === false ) {

				if ( scope.onStart !== undefined ) {

					scope.onStart( url, itemsLoaded, itemsTotal );

				}

			}

			isLoading = true;

		};

		this.itemEnd = function ( url ) {

			itemsLoaded ++;

			if ( scope.onProgress !== undefined ) {

				scope.onProgress( url, itemsLoaded, itemsTotal );

			}

			if ( itemsLoaded === itemsTotal ) {

				isLoading = false;

				if ( scope.onLoad !== undefined ) {

					scope.onLoad();

				}

			}

		};

		this.itemError = function ( url ) {

			if ( scope.onError !== undefined ) {

				scope.onError( url );

			}

		};

		this.resolveURL = function ( url ) {

			if ( urlModifier ) {

				return urlModifier( url );

			}

			return url;

		};

		this.setURLModifier = function ( transform ) {

			urlModifier = transform;

			return this;

		};

		this.addHandler = function ( regex, loader ) {

			handlers.push( regex, loader );

			return this;

		};

		this.removeHandler = function ( regex ) {

			const index = handlers.indexOf( regex );

			if ( index !== - 1 ) {

				handlers.splice( index, 2 );

			}

			return this;

		};

		this.getHandler = function ( file ) {

			for ( let i = 0, l = handlers.length; i < l; i += 2 ) {

				const regex = handlers[ i ];
				const loader = handlers[ i + 1 ];

				if ( regex.global ) regex.lastIndex = 0; // see #17920

				if ( regex.test( file ) ) {

					return loader;

				}

			}

			return null;

		};

	}

}

const DefaultLoadingManager = /*@__PURE__*/ new LoadingManager();

class Loader {

	constructor( manager ) {

		this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

		this.crossOrigin = 'anonymous';
		this.withCredentials = false;
		this.path = '';
		this.resourcePath = '';
		this.requestHeader = {};

	}

	load( /* url, onLoad, onProgress, onError */ ) {}

	loadAsync( url, onProgress ) {

		const scope = this;

		return new Promise( function ( resolve, reject ) {

			scope.load( url, resolve, onProgress, reject );

		} );

	}

	parse( /* data */ ) {}

	setCrossOrigin( crossOrigin ) {

		this.crossOrigin = crossOrigin;
		return this;

	}

	setWithCredentials( value ) {

		this.withCredentials = value;
		return this;

	}

	setPath( path ) {

		this.path = path;
		return this;

	}

	setResourcePath( resourcePath ) {

		this.resourcePath = resourcePath;
		return this;

	}

	setRequestHeader( requestHeader ) {

		this.requestHeader = requestHeader;
		return this;

	}

}

Loader.DEFAULT_MATERIAL_NAME = '__DEFAULT';

const loading = {};

class HttpError extends (/* unused pure expression or super */ null && (Error)) {

	constructor( message, response ) {

		super( message );
		this.response = response;

	}

}

class FileLoader extends (/* unused pure expression or super */ null && (Loader)) {

	constructor( manager ) {

		super( manager );

	}

	load( url, onLoad, onProgress, onError ) {

		if ( url === undefined ) url = '';

		if ( this.path !== undefined ) url = this.path + url;

		url = this.manager.resolveURL( url );

		const cached = Cache.get( url );

		if ( cached !== undefined ) {

			this.manager.itemStart( url );

			setTimeout( () => {

				if ( onLoad ) onLoad( cached );

				this.manager.itemEnd( url );

			}, 0 );

			return cached;

		}

		// Check if request is duplicate

		if ( loading[ url ] !== undefined ) {

			loading[ url ].push( {

				onLoad: onLoad,
				onProgress: onProgress,
				onError: onError

			} );

			return;

		}

		// Initialise array for duplicate requests
		loading[ url ] = [];

		loading[ url ].push( {
			onLoad: onLoad,
			onProgress: onProgress,
			onError: onError,
		} );

		// create request
		const req = new Request( url, {
			headers: new Headers( this.requestHeader ),
			credentials: this.withCredentials ? 'include' : 'same-origin',
			// An abort controller could be added within a future PR
		} );

		// record states ( avoid data race )
		const mimeType = this.mimeType;
		const responseType = this.responseType;

		// start the fetch
		fetch( req )
			.then( response => {

				if ( response.status === 200 || response.status === 0 ) {

					// Some browsers return HTTP Status 0 when using non-http protocol
					// e.g. 'file://' or 'data://'. Handle as success.

					if ( response.status === 0 ) {

						console.warn( 'THREE.FileLoader: HTTP Status 0 received.' );

					}

					// Workaround: Checking if response.body === undefined for Alipay browser #23548

					if ( typeof ReadableStream === 'undefined' || response.body === undefined || response.body.getReader === undefined ) {

						return response;

					}

					const callbacks = loading[ url ];
					const reader = response.body.getReader();

					// Nginx needs X-File-Size check
					// https://serverfault.com/questions/482875/why-does-nginx-remove-content-length-header-for-chunked-content
					const contentLength = response.headers.get( 'Content-Length' ) || response.headers.get( 'X-File-Size' );
					const total = contentLength ? parseInt( contentLength ) : 0;
					const lengthComputable = total !== 0;
					let loaded = 0;

					// periodically read data into the new stream tracking while download progress
					const stream = new ReadableStream( {
						start( controller ) {

							readData();

							function readData() {

								reader.read().then( ( { done, value } ) => {

									if ( done ) {

										controller.close();

									} else {

										loaded += value.byteLength;

										const event = new ProgressEvent( 'progress', { lengthComputable, loaded, total } );
										for ( let i = 0, il = callbacks.length; i < il; i ++ ) {

											const callback = callbacks[ i ];
											if ( callback.onProgress ) callback.onProgress( event );

										}

										controller.enqueue( value );
										readData();

									}

								} );

							}

						}

					} );

					return new Response( stream );

				} else {

					throw new HttpError( `fetch for "${response.url}" responded with ${response.status}: ${response.statusText}`, response );

				}

			} )
			.then( response => {

				switch ( responseType ) {

					case 'arraybuffer':

						return response.arrayBuffer();

					case 'blob':

						return response.blob();

					case 'document':

						return response.text()
							.then( text => {

								const parser = new DOMParser();
								return parser.parseFromString( text, mimeType );

							} );

					case 'json':

						return response.json();

					default:

						if ( mimeType === undefined ) {

							return response.text();

						} else {

							// sniff encoding
							const re = /charset="?([^;"\s]*)"?/i;
							const exec = re.exec( mimeType );
							const label = exec && exec[ 1 ] ? exec[ 1 ].toLowerCase() : undefined;
							const decoder = new TextDecoder( label );
							return response.arrayBuffer().then( ab => decoder.decode( ab ) );

						}

				}

			} )
			.then( data => {

				// Add to cache only on HTTP success, so that we do not cache
				// error response bodies as proper responses to requests.
				Cache.add( url, data );

				const callbacks = loading[ url ];
				delete loading[ url ];

				for ( let i = 0, il = callbacks.length; i < il; i ++ ) {

					const callback = callbacks[ i ];
					if ( callback.onLoad ) callback.onLoad( data );

				}

			} )
			.catch( err => {

				// Abort errors and other errors are handled the same

				const callbacks = loading[ url ];

				if ( callbacks === undefined ) {

					// When onLoad was called and url was deleted in `loading`
					this.manager.itemError( url );
					throw err;

				}

				delete loading[ url ];

				for ( let i = 0, il = callbacks.length; i < il; i ++ ) {

					const callback = callbacks[ i ];
					if ( callback.onError ) callback.onError( err );

				}

				this.manager.itemError( url );

			} )
			.finally( () => {

				this.manager.itemEnd( url );

			} );

		this.manager.itemStart( url );

	}

	setResponseType( value ) {

		this.responseType = value;
		return this;

	}

	setMimeType( value ) {

		this.mimeType = value;
		return this;

	}

}

class AnimationLoader extends (/* unused pure expression or super */ null && (Loader)) {

	constructor( manager ) {

		super( manager );

	}

	load( url, onLoad, onProgress, onError ) {

		const scope = this;

		const loader = new FileLoader( this.manager );
		loader.setPath( this.path );
		loader.setRequestHeader( this.requestHeader );
		loader.setWithCredentials( this.withCredentials );
		loader.load( url, function ( text ) {

			try {

				onLoad( scope.parse( JSON.parse( text ) ) );

			} catch ( e ) {

				if ( onError ) {

					onError( e );

				} else {

					console.error( e );

				}

				scope.manager.itemError( url );

			}

		}, onProgress, onError );

	}

	parse( json ) {

		const animations = [];

		for ( let i = 0; i < json.length; i ++ ) {

			const clip = AnimationClip.parse( json[ i ] );

			animations.push( clip );

		}

		return animations;

	}

}

/**
 * Abstract Base class to block based textures loader (dds, pvr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */

class CompressedTextureLoader extends (/* unused pure expression or super */ null && (Loader)) {

	constructor( manager ) {

		super( manager );

	}

	load( url, onLoad, onProgress, onError ) {

		const scope = this;

		const images = [];

		const texture = new CompressedTexture();

		const loader = new FileLoader( this.manager );
		loader.setPath( this.path );
		loader.setResponseType( 'arraybuffer' );
		loader.setRequestHeader( this.requestHeader );
		loader.setWithCredentials( scope.withCredentials );

		let loaded = 0;

		function loadTexture( i ) {

			loader.load( url[ i ], function ( buffer ) {

				const texDatas = scope.parse( buffer, true );

				images[ i ] = {
					width: texDatas.width,
					height: texDatas.height,
					format: texDatas.format,
					mipmaps: texDatas.mipmaps
				};

				loaded += 1;

				if ( loaded === 6 ) {

					if ( texDatas.mipmapCount === 1 ) texture.minFilter = LinearFilter;

					texture.image = images;
					texture.format = texDatas.format;
					texture.needsUpdate = true;

					if ( onLoad ) onLoad( texture );

				}

			}, onProgress, onError );

		}

		if ( Array.isArray( url ) ) {

			for ( let i = 0, il = url.length; i < il; ++ i ) {

				loadTexture( i );

			}

		} else {

			// compressed cubemap texture stored in a single DDS file

			loader.load( url, function ( buffer ) {

				const texDatas = scope.parse( buffer, true );

				if ( texDatas.isCubemap ) {

					const faces = texDatas.mipmaps.length / texDatas.mipmapCount;

					for ( let f = 0; f < faces; f ++ ) {

						images[ f ] = { mipmaps: [] };

						for ( let i = 0; i < texDatas.mipmapCount; i ++ ) {

							images[ f ].mipmaps.push( texDatas.mipmaps[ f * texDatas.mipmapCount + i ] );
							images[ f ].format = texDatas.format;
							images[ f ].width = texDatas.width;
							images[ f ].height = texDatas.height;

						}

					}

					texture.image = images;

				} else {

					texture.image.width = texDatas.width;
					texture.image.height = texDatas.height;
					texture.mipmaps = texDatas.mipmaps;

				}

				if ( texDatas.mipmapCount === 1 ) {

					texture.minFilter = LinearFilter;

				}

				texture.format = texDatas.format;
				texture.needsUpdate = true;

				if ( onLoad ) onLoad( texture );

			}, onProgress, onError );

		}

		return texture;

	}

}

class ImageLoader extends (/* unused pure expression or super */ null && (Loader)) {

	constructor( manager ) {

		super( manager );

	}

	load( url, onLoad, onProgress, onError ) {

		if ( this.path !== undefined ) url = this.path + url;

		url = this.manager.resolveURL( url );

		const scope = this;

		const cached = Cache.get( url );

		if ( cached !== undefined ) {

			scope.manager.itemStart( url );

			setTimeout( function () {

				if ( onLoad ) onLoad( cached );

				scope.manager.itemEnd( url );

			}, 0 );

			return cached;

		}

		const image = createElementNS( 'img' );

		function onImageLoad() {

			removeEventListeners();

			Cache.add( url, this );

			if ( onLoad ) onLoad( this );

			scope.manager.itemEnd( url );

		}

		function onImageError( event ) {

			removeEventListeners();

			if ( onError ) onError( event );

			scope.manager.itemError( url );
			scope.manager.itemEnd( url );

		}

		function removeEventListeners() {

			image.removeEventListener( 'load', onImageLoad, false );
			image.removeEventListener( 'error', onImageError, false );

		}

		image.addEventListener( 'load', onImageLoad, false );
		image.addEventListener( 'error', onImageError, false );

		if ( url.slice( 0, 5 ) !== 'data:' ) {

			if ( this.crossOrigin !== undefined ) image.crossOrigin = this.crossOrigin;

		}

		scope.manager.itemStart( url );

		image.src = url;

		return image;

	}

}

class CubeTextureLoader extends (/* unused pure expression or super */ null && (Loader)) {

	constructor( manager ) {

		super( manager );

	}

	load( urls, onLoad, onProgress, onError ) {

		const texture = new CubeTexture();
		texture.colorSpace = SRGBColorSpace;

		const loader = new ImageLoader( this.manager );
		loader.setCrossOrigin( this.crossOrigin );
		loader.setPath( this.path );

		let loaded = 0;

		function loadTexture( i ) {

			loader.load( urls[ i ], function ( image ) {

				texture.images[ i ] = image;

				loaded ++;

				if ( loaded === 6 ) {

					texture.needsUpdate = true;

					if ( onLoad ) onLoad( texture );

				}

			}, undefined, onError );

		}

		for ( let i = 0; i < urls.length; ++ i ) {

			loadTexture( i );

		}

		return texture;

	}

}

/**
 * Abstract Base class to load generic binary textures formats (rgbe, hdr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */

class DataTextureLoader extends (/* unused pure expression or super */ null && (Loader)) {

	constructor( manager ) {

		super( manager );

	}

	load( url, onLoad, onProgress, onError ) {

		const scope = this;

		const texture = new DataTexture();

		const loader = new FileLoader( this.manager );
		loader.setResponseType( 'arraybuffer' );
		loader.setRequestHeader( this.requestHeader );
		loader.setPath( this.path );
		loader.setWithCredentials( scope.withCredentials );
		loader.load( url, function ( buffer ) {

			let texData;

			try {

				texData = scope.parse( buffer );

			} catch ( error ) {

				if ( onError !== undefined ) {

					onError( error );

				} else {

					console.error( error );
					return;

				}

			}

			if ( texData.image !== undefined ) {

				texture.image = texData.image;

			} else if ( texData.data !== undefined ) {

				texture.image.width = texData.width;
				texture.image.height = texData.height;
				texture.image.data = texData.data;

			}

			texture.wrapS = texData.wrapS !== undefined ? texData.wrapS : ClampToEdgeWrapping;
			texture.wrapT = texData.wrapT !== undefined ? texData.wrapT : ClampToEdgeWrapping;

			texture.magFilter = texData.magFilter !== undefined ? texData.magFilter : LinearFilter;
			texture.minFilter = texData.minFilter !== undefined ? texData.minFilter : LinearFilter;

			texture.anisotropy = texData.anisotropy !== undefined ? texData.anisotropy : 1;

			if ( texData.colorSpace !== undefined ) {

				texture.colorSpace = texData.colorSpace;

			}

			if ( texData.flipY !== undefined ) {

				texture.flipY = texData.flipY;

			}

			if ( texData.format !== undefined ) {

				texture.format = texData.format;

			}

			if ( texData.type !== undefined ) {

				texture.type = texData.type;

			}

			if ( texData.mipmaps !== undefined ) {

				texture.mipmaps = texData.mipmaps;
				texture.minFilter = LinearMipmapLinearFilter; // presumably...

			}

			if ( texData.mipmapCount === 1 ) {

				texture.minFilter = LinearFilter;

			}

			if ( texData.generateMipmaps !== undefined ) {

				texture.generateMipmaps = texData.generateMipmaps;

			}

			texture.needsUpdate = true;

			if ( onLoad ) onLoad( texture, texData );

		}, onProgress, onError );


		return texture;

	}

}

class TextureLoader extends (/* unused pure expression or super */ null && (Loader)) {

	constructor( manager ) {

		super( manager );

	}

	load( url, onLoad, onProgress, onError ) {

		const texture = new Texture();

		const loader = new ImageLoader( this.manager );
		loader.setCrossOrigin( this.crossOrigin );
		loader.setPath( this.path );

		loader.load( url, function ( image ) {

			texture.image = image;
			texture.needsUpdate = true;

			if ( onLoad !== undefined ) {

				onLoad( texture );

			}

		}, onProgress, onError );

		return texture;

	}

}

class Light extends (/* unused pure expression or super */ null && (Object3D)) {

	constructor( color, intensity = 1 ) {

		super();

		this.isLight = true;

		this.type = 'Light';

		this.color = new Color( color );
		this.intensity = intensity;

	}

	dispose() {

		// Empty here in base class; some subclasses override.

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		this.color.copy( source.color );
		this.intensity = source.intensity;

		return this;

	}

	toJSON( meta ) {

		const data = super.toJSON( meta );

		data.object.color = this.color.getHex();
		data.object.intensity = this.intensity;

		if ( this.groundColor !== undefined ) data.object.groundColor = this.groundColor.getHex();

		if ( this.distance !== undefined ) data.object.distance = this.distance;
		if ( this.angle !== undefined ) data.object.angle = this.angle;
		if ( this.decay !== undefined ) data.object.decay = this.decay;
		if ( this.penumbra !== undefined ) data.object.penumbra = this.penumbra;

		if ( this.shadow !== undefined ) data.object.shadow = this.shadow.toJSON();

		return data;

	}

}

class HemisphereLight extends (/* unused pure expression or super */ null && (Light)) {

	constructor( skyColor, groundColor, intensity ) {

		super( skyColor, intensity );

		this.isHemisphereLight = true;

		this.type = 'HemisphereLight';

		this.position.copy( Object3D.DEFAULT_UP );
		this.updateMatrix();

		this.groundColor = new Color( groundColor );

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		this.groundColor.copy( source.groundColor );

		return this;

	}

}

const _projScreenMatrix$1 = /*@__PURE__*/ new Matrix4();
const _lightPositionWorld$1 = /*@__PURE__*/ new Vector3();
const _lookTarget$1 = /*@__PURE__*/ new Vector3();

class LightShadow {

	constructor( camera ) {

		this.camera = camera;

		this.bias = 0;
		this.normalBias = 0;
		this.radius = 1;
		this.blurSamples = 8;

		this.mapSize = new Vector2( 512, 512 );

		this.map = null;
		this.mapPass = null;
		this.matrix = new Matrix4();

		this.autoUpdate = true;
		this.needsUpdate = false;

		this._frustum = new Frustum();
		this._frameExtents = new Vector2( 1, 1 );

		this._viewportCount = 1;

		this._viewports = [

			new Vector4( 0, 0, 1, 1 )

		];

	}

	getViewportCount() {

		return this._viewportCount;

	}

	getFrustum() {

		return this._frustum;

	}

	updateMatrices( light ) {

		const shadowCamera = this.camera;
		const shadowMatrix = this.matrix;

		_lightPositionWorld$1.setFromMatrixPosition( light.matrixWorld );
		shadowCamera.position.copy( _lightPositionWorld$1 );

		_lookTarget$1.setFromMatrixPosition( light.target.matrixWorld );
		shadowCamera.lookAt( _lookTarget$1 );
		shadowCamera.updateMatrixWorld();

		_projScreenMatrix$1.multiplyMatrices( shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse );
		this._frustum.setFromProjectionMatrix( _projScreenMatrix$1 );

		shadowMatrix.set(
			0.5, 0.0, 0.0, 0.5,
			0.0, 0.5, 0.0, 0.5,
			0.0, 0.0, 0.5, 0.5,
			0.0, 0.0, 0.0, 1.0
		);

		shadowMatrix.multiply( _projScreenMatrix$1 );

	}

	getViewport( viewportIndex ) {

		return this._viewports[ viewportIndex ];

	}

	getFrameExtents() {

		return this._frameExtents;

	}

	dispose() {

		if ( this.map ) {

			this.map.dispose();

		}

		if ( this.mapPass ) {

			this.mapPass.dispose();

		}

	}

	copy( source ) {

		this.camera = source.camera.clone();

		this.bias = source.bias;
		this.radius = source.radius;

		this.mapSize.copy( source.mapSize );

		return this;

	}

	clone() {

		return new this.constructor().copy( this );

	}

	toJSON() {

		const object = {};

		if ( this.bias !== 0 ) object.bias = this.bias;
		if ( this.normalBias !== 0 ) object.normalBias = this.normalBias;
		if ( this.radius !== 1 ) object.radius = this.radius;
		if ( this.mapSize.x !== 512 || this.mapSize.y !== 512 ) object.mapSize = this.mapSize.toArray();

		object.camera = this.camera.toJSON( false ).object;
		delete object.camera.matrix;

		return object;

	}

}

class SpotLightShadow extends (/* unused pure expression or super */ null && (LightShadow)) {

	constructor() {

		super( new PerspectiveCamera( 50, 1, 0.5, 500 ) );

		this.isSpotLightShadow = true;

		this.focus = 1;

	}

	updateMatrices( light ) {

		const camera = this.camera;

		const fov = RAD2DEG * 2 * light.angle * this.focus;
		const aspect = this.mapSize.width / this.mapSize.height;
		const far = light.distance || camera.far;

		if ( fov !== camera.fov || aspect !== camera.aspect || far !== camera.far ) {

			camera.fov = fov;
			camera.aspect = aspect;
			camera.far = far;
			camera.updateProjectionMatrix();

		}

		super.updateMatrices( light );

	}

	copy( source ) {

		super.copy( source );

		this.focus = source.focus;

		return this;

	}

}

class SpotLight extends (/* unused pure expression or super */ null && (Light)) {

	constructor( color, intensity, distance = 0, angle = Math.PI / 3, penumbra = 0, decay = 2 ) {

		super( color, intensity );

		this.isSpotLight = true;

		this.type = 'SpotLight';

		this.position.copy( Object3D.DEFAULT_UP );
		this.updateMatrix();

		this.target = new Object3D();

		this.distance = distance;
		this.angle = angle;
		this.penumbra = penumbra;
		this.decay = decay;

		this.map = null;

		this.shadow = new SpotLightShadow();

	}

	get power() {

		// compute the light's luminous power (in lumens) from its intensity (in candela)
		// by convention for a spotlight, luminous power (lm) = π * luminous intensity (cd)
		return this.intensity * Math.PI;

	}

	set power( power ) {

		// set the light's intensity (in candela) from the desired luminous power (in lumens)
		this.intensity = power / Math.PI;

	}

	dispose() {

		this.shadow.dispose();

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		this.distance = source.distance;
		this.angle = source.angle;
		this.penumbra = source.penumbra;
		this.decay = source.decay;

		this.target = source.target.clone();

		this.shadow = source.shadow.clone();

		return this;

	}

}

const _projScreenMatrix = /*@__PURE__*/ new Matrix4();
const _lightPositionWorld = /*@__PURE__*/ new Vector3();
const _lookTarget = /*@__PURE__*/ new Vector3();

class PointLightShadow extends (/* unused pure expression or super */ null && (LightShadow)) {

	constructor() {

		super( new PerspectiveCamera( 90, 1, 0.5, 500 ) );

		this.isPointLightShadow = true;

		this._frameExtents = new Vector2( 4, 2 );

		this._viewportCount = 6;

		this._viewports = [
			// These viewports map a cube-map onto a 2D texture with the
			// following orientation:
			//
			//  xzXZ
			//   y Y
			//
			// X - Positive x direction
			// x - Negative x direction
			// Y - Positive y direction
			// y - Negative y direction
			// Z - Positive z direction
			// z - Negative z direction

			// positive X
			new Vector4( 2, 1, 1, 1 ),
			// negative X
			new Vector4( 0, 1, 1, 1 ),
			// positive Z
			new Vector4( 3, 1, 1, 1 ),
			// negative Z
			new Vector4( 1, 1, 1, 1 ),
			// positive Y
			new Vector4( 3, 0, 1, 1 ),
			// negative Y
			new Vector4( 1, 0, 1, 1 )
		];

		this._cubeDirections = [
			new Vector3( 1, 0, 0 ), new Vector3( - 1, 0, 0 ), new Vector3( 0, 0, 1 ),
			new Vector3( 0, 0, - 1 ), new Vector3( 0, 1, 0 ), new Vector3( 0, - 1, 0 )
		];

		this._cubeUps = [
			new Vector3( 0, 1, 0 ), new Vector3( 0, 1, 0 ), new Vector3( 0, 1, 0 ),
			new Vector3( 0, 1, 0 ), new Vector3( 0, 0, 1 ),	new Vector3( 0, 0, - 1 )
		];

	}

	updateMatrices( light, viewportIndex = 0 ) {

		const camera = this.camera;
		const shadowMatrix = this.matrix;

		const far = light.distance || camera.far;

		if ( far !== camera.far ) {

			camera.far = far;
			camera.updateProjectionMatrix();

		}

		_lightPositionWorld.setFromMatrixPosition( light.matrixWorld );
		camera.position.copy( _lightPositionWorld );

		_lookTarget.copy( camera.position );
		_lookTarget.add( this._cubeDirections[ viewportIndex ] );
		camera.up.copy( this._cubeUps[ viewportIndex ] );
		camera.lookAt( _lookTarget );
		camera.updateMatrixWorld();

		shadowMatrix.makeTranslation( - _lightPositionWorld.x, - _lightPositionWorld.y, - _lightPositionWorld.z );

		_projScreenMatrix.multiplyMatrices( camera.projectionMatrix, camera.matrixWorldInverse );
		this._frustum.setFromProjectionMatrix( _projScreenMatrix );

	}

}

class PointLight extends (/* unused pure expression or super */ null && (Light)) {

	constructor( color, intensity, distance = 0, decay = 2 ) {

		super( color, intensity );

		this.isPointLight = true;

		this.type = 'PointLight';

		this.distance = distance;
		this.decay = decay;

		this.shadow = new PointLightShadow();

	}

	get power() {

		// compute the light's luminous power (in lumens) from its intensity (in candela)
		// for an isotropic light source, luminous power (lm) = 4 π luminous intensity (cd)
		return this.intensity * 4 * Math.PI;

	}

	set power( power ) {

		// set the light's intensity (in candela) from the desired luminous power (in lumens)
		this.intensity = power / ( 4 * Math.PI );

	}

	dispose() {

		this.shadow.dispose();

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		this.distance = source.distance;
		this.decay = source.decay;

		this.shadow = source.shadow.clone();

		return this;

	}

}

class DirectionalLightShadow extends (/* unused pure expression or super */ null && (LightShadow)) {

	constructor() {

		super( new OrthographicCamera( - 5, 5, 5, - 5, 0.5, 500 ) );

		this.isDirectionalLightShadow = true;

	}

}

class DirectionalLight extends (/* unused pure expression or super */ null && (Light)) {

	constructor( color, intensity ) {

		super( color, intensity );

		this.isDirectionalLight = true;

		this.type = 'DirectionalLight';

		this.position.copy( Object3D.DEFAULT_UP );
		this.updateMatrix();

		this.target = new Object3D();

		this.shadow = new DirectionalLightShadow();

	}

	dispose() {

		this.shadow.dispose();

	}

	copy( source ) {

		super.copy( source );

		this.target = source.target.clone();
		this.shadow = source.shadow.clone();

		return this;

	}

}

class AmbientLight extends (/* unused pure expression or super */ null && (Light)) {

	constructor( color, intensity ) {

		super( color, intensity );

		this.isAmbientLight = true;

		this.type = 'AmbientLight';

	}

}

class RectAreaLight extends (/* unused pure expression or super */ null && (Light)) {

	constructor( color, intensity, width = 10, height = 10 ) {

		super( color, intensity );

		this.isRectAreaLight = true;

		this.type = 'RectAreaLight';

		this.width = width;
		this.height = height;

	}

	get power() {

		// compute the light's luminous power (in lumens) from its intensity (in nits)
		return this.intensity * this.width * this.height * Math.PI;

	}

	set power( power ) {

		// set the light's intensity (in nits) from the desired luminous power (in lumens)
		this.intensity = power / ( this.width * this.height * Math.PI );

	}

	copy( source ) {

		super.copy( source );

		this.width = source.width;
		this.height = source.height;

		return this;

	}

	toJSON( meta ) {

		const data = super.toJSON( meta );

		data.object.width = this.width;
		data.object.height = this.height;

		return data;

	}

}

/**
 * Primary reference:
 *   https://graphics.stanford.edu/papers/envmap/envmap.pdf
 *
 * Secondary reference:
 *   https://www.ppsloan.org/publications/StupidSH36.pdf
 */

// 3-band SH defined by 9 coefficients

class SphericalHarmonics3 {

	constructor() {

		this.isSphericalHarmonics3 = true;

		this.coefficients = [];

		for ( let i = 0; i < 9; i ++ ) {

			this.coefficients.push( new Vector3() );

		}

	}

	set( coefficients ) {

		for ( let i = 0; i < 9; i ++ ) {

			this.coefficients[ i ].copy( coefficients[ i ] );

		}

		return this;

	}

	zero() {

		for ( let i = 0; i < 9; i ++ ) {

			this.coefficients[ i ].set( 0, 0, 0 );

		}

		return this;

	}

	// get the radiance in the direction of the normal
	// target is a Vector3
	getAt( normal, target ) {

		// normal is assumed to be unit length

		const x = normal.x, y = normal.y, z = normal.z;

		const coeff = this.coefficients;

		// band 0
		target.copy( coeff[ 0 ] ).multiplyScalar( 0.282095 );

		// band 1
		target.addScaledVector( coeff[ 1 ], 0.488603 * y );
		target.addScaledVector( coeff[ 2 ], 0.488603 * z );
		target.addScaledVector( coeff[ 3 ], 0.488603 * x );

		// band 2
		target.addScaledVector( coeff[ 4 ], 1.092548 * ( x * y ) );
		target.addScaledVector( coeff[ 5 ], 1.092548 * ( y * z ) );
		target.addScaledVector( coeff[ 6 ], 0.315392 * ( 3.0 * z * z - 1.0 ) );
		target.addScaledVector( coeff[ 7 ], 1.092548 * ( x * z ) );
		target.addScaledVector( coeff[ 8 ], 0.546274 * ( x * x - y * y ) );

		return target;

	}

	// get the irradiance (radiance convolved with cosine lobe) in the direction of the normal
	// target is a Vector3
	// https://graphics.stanford.edu/papers/envmap/envmap.pdf
	getIrradianceAt( normal, target ) {

		// normal is assumed to be unit length

		const x = normal.x, y = normal.y, z = normal.z;

		const coeff = this.coefficients;

		// band 0
		target.copy( coeff[ 0 ] ).multiplyScalar( 0.886227 ); // π * 0.282095

		// band 1
		target.addScaledVector( coeff[ 1 ], 2.0 * 0.511664 * y ); // ( 2 * π / 3 ) * 0.488603
		target.addScaledVector( coeff[ 2 ], 2.0 * 0.511664 * z );
		target.addScaledVector( coeff[ 3 ], 2.0 * 0.511664 * x );

		// band 2
		target.addScaledVector( coeff[ 4 ], 2.0 * 0.429043 * x * y ); // ( π / 4 ) * 1.092548
		target.addScaledVector( coeff[ 5 ], 2.0 * 0.429043 * y * z );
		target.addScaledVector( coeff[ 6 ], 0.743125 * z * z - 0.247708 ); // ( π / 4 ) * 0.315392 * 3
		target.addScaledVector( coeff[ 7 ], 2.0 * 0.429043 * x * z );
		target.addScaledVector( coeff[ 8 ], 0.429043 * ( x * x - y * y ) ); // ( π / 4 ) * 0.546274

		return target;

	}

	add( sh ) {

		for ( let i = 0; i < 9; i ++ ) {

			this.coefficients[ i ].add( sh.coefficients[ i ] );

		}

		return this;

	}

	addScaledSH( sh, s ) {

		for ( let i = 0; i < 9; i ++ ) {

			this.coefficients[ i ].addScaledVector( sh.coefficients[ i ], s );

		}

		return this;

	}

	scale( s ) {

		for ( let i = 0; i < 9; i ++ ) {

			this.coefficients[ i ].multiplyScalar( s );

		}

		return this;

	}

	lerp( sh, alpha ) {

		for ( let i = 0; i < 9; i ++ ) {

			this.coefficients[ i ].lerp( sh.coefficients[ i ], alpha );

		}

		return this;

	}

	equals( sh ) {

		for ( let i = 0; i < 9; i ++ ) {

			if ( ! this.coefficients[ i ].equals( sh.coefficients[ i ] ) ) {

				return false;

			}

		}

		return true;

	}

	copy( sh ) {

		return this.set( sh.coefficients );

	}

	clone() {

		return new this.constructor().copy( this );

	}

	fromArray( array, offset = 0 ) {

		const coefficients = this.coefficients;

		for ( let i = 0; i < 9; i ++ ) {

			coefficients[ i ].fromArray( array, offset + ( i * 3 ) );

		}

		return this;

	}

	toArray( array = [], offset = 0 ) {

		const coefficients = this.coefficients;

		for ( let i = 0; i < 9; i ++ ) {

			coefficients[ i ].toArray( array, offset + ( i * 3 ) );

		}

		return array;

	}

	// evaluate the basis functions
	// shBasis is an Array[ 9 ]
	static getBasisAt( normal, shBasis ) {

		// normal is assumed to be unit length

		const x = normal.x, y = normal.y, z = normal.z;

		// band 0
		shBasis[ 0 ] = 0.282095;

		// band 1
		shBasis[ 1 ] = 0.488603 * y;
		shBasis[ 2 ] = 0.488603 * z;
		shBasis[ 3 ] = 0.488603 * x;

		// band 2
		shBasis[ 4 ] = 1.092548 * x * y;
		shBasis[ 5 ] = 1.092548 * y * z;
		shBasis[ 6 ] = 0.315392 * ( 3 * z * z - 1 );
		shBasis[ 7 ] = 1.092548 * x * z;
		shBasis[ 8 ] = 0.546274 * ( x * x - y * y );

	}

}

class LightProbe extends (/* unused pure expression or super */ null && (Light)) {

	constructor( sh = new SphericalHarmonics3(), intensity = 1 ) {

		super( undefined, intensity );

		this.isLightProbe = true;

		this.sh = sh;

	}

	copy( source ) {

		super.copy( source );

		this.sh.copy( source.sh );

		return this;

	}

	fromJSON( json ) {

		this.intensity = json.intensity; // TODO: Move this bit to Light.fromJSON();
		this.sh.fromArray( json.sh );

		return this;

	}

	toJSON( meta ) {

		const data = super.toJSON( meta );

		data.object.sh = this.sh.toArray();

		return data;

	}

}

class MaterialLoader extends (/* unused pure expression or super */ null && (Loader)) {

	constructor( manager ) {

		super( manager );
		this.textures = {};

	}

	load( url, onLoad, onProgress, onError ) {

		const scope = this;

		const loader = new FileLoader( scope.manager );
		loader.setPath( scope.path );
		loader.setRequestHeader( scope.requestHeader );
		loader.setWithCredentials( scope.withCredentials );
		loader.load( url, function ( text ) {

			try {

				onLoad( scope.parse( JSON.parse( text ) ) );

			} catch ( e ) {

				if ( onError ) {

					onError( e );

				} else {

					console.error( e );

				}

				scope.manager.itemError( url );

			}

		}, onProgress, onError );

	}

	parse( json ) {

		const textures = this.textures;

		function getTexture( name ) {

			if ( textures[ name ] === undefined ) {

				console.warn( 'THREE.MaterialLoader: Undefined texture', name );

			}

			return textures[ name ];

		}

		const material = MaterialLoader.createMaterialFromType( json.type );

		if ( json.uuid !== undefined ) material.uuid = json.uuid;
		if ( json.name !== undefined ) material.name = json.name;
		if ( json.color !== undefined && material.color !== undefined ) material.color.setHex( json.color );
		if ( json.roughness !== undefined ) material.roughness = json.roughness;
		if ( json.metalness !== undefined ) material.metalness = json.metalness;
		if ( json.sheen !== undefined ) material.sheen = json.sheen;
		if ( json.sheenColor !== undefined ) material.sheenColor = new Color().setHex( json.sheenColor );
		if ( json.sheenRoughness !== undefined ) material.sheenRoughness = json.sheenRoughness;
		if ( json.emissive !== undefined && material.emissive !== undefined ) material.emissive.setHex( json.emissive );
		if ( json.specular !== undefined && material.specular !== undefined ) material.specular.setHex( json.specular );
		if ( json.specularIntensity !== undefined ) material.specularIntensity = json.specularIntensity;
		if ( json.specularColor !== undefined && material.specularColor !== undefined ) material.specularColor.setHex( json.specularColor );
		if ( json.shininess !== undefined ) material.shininess = json.shininess;
		if ( json.clearcoat !== undefined ) material.clearcoat = json.clearcoat;
		if ( json.clearcoatRoughness !== undefined ) material.clearcoatRoughness = json.clearcoatRoughness;
		if ( json.iridescence !== undefined ) material.iridescence = json.iridescence;
		if ( json.iridescenceIOR !== undefined ) material.iridescenceIOR = json.iridescenceIOR;
		if ( json.iridescenceThicknessRange !== undefined ) material.iridescenceThicknessRange = json.iridescenceThicknessRange;
		if ( json.transmission !== undefined ) material.transmission = json.transmission;
		if ( json.thickness !== undefined ) material.thickness = json.thickness;
		if ( json.attenuationDistance !== undefined ) material.attenuationDistance = json.attenuationDistance;
		if ( json.attenuationColor !== undefined && material.attenuationColor !== undefined ) material.attenuationColor.setHex( json.attenuationColor );
		if ( json.anisotropy !== undefined ) material.anisotropy = json.anisotropy;
		if ( json.anisotropyRotation !== undefined ) material.anisotropyRotation = json.anisotropyRotation;
		if ( json.fog !== undefined ) material.fog = json.fog;
		if ( json.flatShading !== undefined ) material.flatShading = json.flatShading;
		if ( json.blending !== undefined ) material.blending = json.blending;
		if ( json.combine !== undefined ) material.combine = json.combine;
		if ( json.side !== undefined ) material.side = json.side;
		if ( json.shadowSide !== undefined ) material.shadowSide = json.shadowSide;
		if ( json.opacity !== undefined ) material.opacity = json.opacity;
		if ( json.transparent !== undefined ) material.transparent = json.transparent;
		if ( json.alphaTest !== undefined ) material.alphaTest = json.alphaTest;
		if ( json.alphaHash !== undefined ) material.alphaHash = json.alphaHash;
		if ( json.depthFunc !== undefined ) material.depthFunc = json.depthFunc;
		if ( json.depthTest !== undefined ) material.depthTest = json.depthTest;
		if ( json.depthWrite !== undefined ) material.depthWrite = json.depthWrite;
		if ( json.colorWrite !== undefined ) material.colorWrite = json.colorWrite;
		if ( json.blendSrc !== undefined ) material.blendSrc = json.blendSrc;
		if ( json.blendDst !== undefined ) material.blendDst = json.blendDst;
		if ( json.blendEquation !== undefined ) material.blendEquation = json.blendEquation;
		if ( json.blendSrcAlpha !== undefined ) material.blendSrcAlpha = json.blendSrcAlpha;
		if ( json.blendDstAlpha !== undefined ) material.blendDstAlpha = json.blendDstAlpha;
		if ( json.blendEquationAlpha !== undefined ) material.blendEquationAlpha = json.blendEquationAlpha;
		if ( json.blendColor !== undefined && material.blendColor !== undefined ) material.blendColor.setHex( json.blendColor );
		if ( json.blendAlpha !== undefined ) material.blendAlpha = json.blendAlpha;
		if ( json.stencilWriteMask !== undefined ) material.stencilWriteMask = json.stencilWriteMask;
		if ( json.stencilFunc !== undefined ) material.stencilFunc = json.stencilFunc;
		if ( json.stencilRef !== undefined ) material.stencilRef = json.stencilRef;
		if ( json.stencilFuncMask !== undefined ) material.stencilFuncMask = json.stencilFuncMask;
		if ( json.stencilFail !== undefined ) material.stencilFail = json.stencilFail;
		if ( json.stencilZFail !== undefined ) material.stencilZFail = json.stencilZFail;
		if ( json.stencilZPass !== undefined ) material.stencilZPass = json.stencilZPass;
		if ( json.stencilWrite !== undefined ) material.stencilWrite = json.stencilWrite;

		if ( json.wireframe !== undefined ) material.wireframe = json.wireframe;
		if ( json.wireframeLinewidth !== undefined ) material.wireframeLinewidth = json.wireframeLinewidth;
		if ( json.wireframeLinecap !== undefined ) material.wireframeLinecap = json.wireframeLinecap;
		if ( json.wireframeLinejoin !== undefined ) material.wireframeLinejoin = json.wireframeLinejoin;

		if ( json.rotation !== undefined ) material.rotation = json.rotation;

		if ( json.linewidth !== undefined ) material.linewidth = json.linewidth;
		if ( json.dashSize !== undefined ) material.dashSize = json.dashSize;
		if ( json.gapSize !== undefined ) material.gapSize = json.gapSize;
		if ( json.scale !== undefined ) material.scale = json.scale;

		if ( json.polygonOffset !== undefined ) material.polygonOffset = json.polygonOffset;
		if ( json.polygonOffsetFactor !== undefined ) material.polygonOffsetFactor = json.polygonOffsetFactor;
		if ( json.polygonOffsetUnits !== undefined ) material.polygonOffsetUnits = json.polygonOffsetUnits;

		if ( json.dithering !== undefined ) material.dithering = json.dithering;

		if ( json.alphaToCoverage !== undefined ) material.alphaToCoverage = json.alphaToCoverage;
		if ( json.premultipliedAlpha !== undefined ) material.premultipliedAlpha = json.premultipliedAlpha;
		if ( json.forceSinglePass !== undefined ) material.forceSinglePass = json.forceSinglePass;

		if ( json.visible !== undefined ) material.visible = json.visible;

		if ( json.toneMapped !== undefined ) material.toneMapped = json.toneMapped;

		if ( json.userData !== undefined ) material.userData = json.userData;

		if ( json.vertexColors !== undefined ) {

			if ( typeof json.vertexColors === 'number' ) {

				material.vertexColors = ( json.vertexColors > 0 ) ? true : false;

			} else {

				material.vertexColors = json.vertexColors;

			}

		}

		// Shader Material

		if ( json.uniforms !== undefined ) {

			for ( const name in json.uniforms ) {

				const uniform = json.uniforms[ name ];

				material.uniforms[ name ] = {};

				switch ( uniform.type ) {

					case 't':
						material.uniforms[ name ].value = getTexture( uniform.value );
						break;

					case 'c':
						material.uniforms[ name ].value = new Color().setHex( uniform.value );
						break;

					case 'v2':
						material.uniforms[ name ].value = new Vector2().fromArray( uniform.value );
						break;

					case 'v3':
						material.uniforms[ name ].value = new Vector3().fromArray( uniform.value );
						break;

					case 'v4':
						material.uniforms[ name ].value = new Vector4().fromArray( uniform.value );
						break;

					case 'm3':
						material.uniforms[ name ].value = new Matrix3().fromArray( uniform.value );
						break;

					case 'm4':
						material.uniforms[ name ].value = new Matrix4().fromArray( uniform.value );
						break;

					default:
						material.uniforms[ name ].value = uniform.value;

				}

			}

		}

		if ( json.defines !== undefined ) material.defines = json.defines;
		if ( json.vertexShader !== undefined ) material.vertexShader = json.vertexShader;
		if ( json.fragmentShader !== undefined ) material.fragmentShader = json.fragmentShader;
		if ( json.glslVersion !== undefined ) material.glslVersion = json.glslVersion;

		if ( json.extensions !== undefined ) {

			for ( const key in json.extensions ) {

				material.extensions[ key ] = json.extensions[ key ];

			}

		}

		if ( json.lights !== undefined ) material.lights = json.lights;
		if ( json.clipping !== undefined ) material.clipping = json.clipping;

		// for PointsMaterial

		if ( json.size !== undefined ) material.size = json.size;
		if ( json.sizeAttenuation !== undefined ) material.sizeAttenuation = json.sizeAttenuation;

		// maps

		if ( json.map !== undefined ) material.map = getTexture( json.map );
		if ( json.matcap !== undefined ) material.matcap = getTexture( json.matcap );

		if ( json.alphaMap !== undefined ) material.alphaMap = getTexture( json.alphaMap );

		if ( json.bumpMap !== undefined ) material.bumpMap = getTexture( json.bumpMap );
		if ( json.bumpScale !== undefined ) material.bumpScale = json.bumpScale;

		if ( json.normalMap !== undefined ) material.normalMap = getTexture( json.normalMap );
		if ( json.normalMapType !== undefined ) material.normalMapType = json.normalMapType;
		if ( json.normalScale !== undefined ) {

			let normalScale = json.normalScale;

			if ( Array.isArray( normalScale ) === false ) {

				// Blender exporter used to export a scalar. See #7459

				normalScale = [ normalScale, normalScale ];

			}

			material.normalScale = new Vector2().fromArray( normalScale );

		}

		if ( json.displacementMap !== undefined ) material.displacementMap = getTexture( json.displacementMap );
		if ( json.displacementScale !== undefined ) material.displacementScale = json.displacementScale;
		if ( json.displacementBias !== undefined ) material.displacementBias = json.displacementBias;

		if ( json.roughnessMap !== undefined ) material.roughnessMap = getTexture( json.roughnessMap );
		if ( json.metalnessMap !== undefined ) material.metalnessMap = getTexture( json.metalnessMap );

		if ( json.emissiveMap !== undefined ) material.emissiveMap = getTexture( json.emissiveMap );
		if ( json.emissiveIntensity !== undefined ) material.emissiveIntensity = json.emissiveIntensity;

		if ( json.specularMap !== undefined ) material.specularMap = getTexture( json.specularMap );
		if ( json.specularIntensityMap !== undefined ) material.specularIntensityMap = getTexture( json.specularIntensityMap );
		if ( json.specularColorMap !== undefined ) material.specularColorMap = getTexture( json.specularColorMap );

		if ( json.envMap !== undefined ) material.envMap = getTexture( json.envMap );
		if ( json.envMapRotation !== undefined ) material.envMapRotation.fromArray( json.envMapRotation );
		if ( json.envMapIntensity !== undefined ) material.envMapIntensity = json.envMapIntensity;

		if ( json.reflectivity !== undefined ) material.reflectivity = json.reflectivity;
		if ( json.refractionRatio !== undefined ) material.refractionRatio = json.refractionRatio;

		if ( json.lightMap !== undefined ) material.lightMap = getTexture( json.lightMap );
		if ( json.lightMapIntensity !== undefined ) material.lightMapIntensity = json.lightMapIntensity;

		if ( json.aoMap !== undefined ) material.aoMap = getTexture( json.aoMap );
		if ( json.aoMapIntensity !== undefined ) material.aoMapIntensity = json.aoMapIntensity;

		if ( json.gradientMap !== undefined ) material.gradientMap = getTexture( json.gradientMap );

		if ( json.clearcoatMap !== undefined ) material.clearcoatMap = getTexture( json.clearcoatMap );
		if ( json.clearcoatRoughnessMap !== undefined ) material.clearcoatRoughnessMap = getTexture( json.clearcoatRoughnessMap );
		if ( json.clearcoatNormalMap !== undefined ) material.clearcoatNormalMap = getTexture( json.clearcoatNormalMap );
		if ( json.clearcoatNormalScale !== undefined ) material.clearcoatNormalScale = new Vector2().fromArray( json.clearcoatNormalScale );

		if ( json.iridescenceMap !== undefined ) material.iridescenceMap = getTexture( json.iridescenceMap );
		if ( json.iridescenceThicknessMap !== undefined ) material.iridescenceThicknessMap = getTexture( json.iridescenceThicknessMap );

		if ( json.transmissionMap !== undefined ) material.transmissionMap = getTexture( json.transmissionMap );
		if ( json.thicknessMap !== undefined ) material.thicknessMap = getTexture( json.thicknessMap );

		if ( json.anisotropyMap !== undefined ) material.anisotropyMap = getTexture( json.anisotropyMap );

		if ( json.sheenColorMap !== undefined ) material.sheenColorMap = getTexture( json.sheenColorMap );
		if ( json.sheenRoughnessMap !== undefined ) material.sheenRoughnessMap = getTexture( json.sheenRoughnessMap );

		return material;

	}

	setTextures( value ) {

		this.textures = value;
		return this;

	}

	static createMaterialFromType( type ) {

		const materialLib = {
			ShadowMaterial,
			SpriteMaterial,
			RawShaderMaterial,
			ShaderMaterial,
			PointsMaterial,
			MeshPhysicalMaterial,
			MeshStandardMaterial,
			MeshPhongMaterial,
			MeshToonMaterial,
			MeshNormalMaterial,
			MeshLambertMaterial,
			MeshDepthMaterial,
			MeshDistanceMaterial,
			MeshBasicMaterial,
			MeshMatcapMaterial,
			LineDashedMaterial,
			LineBasicMaterial,
			Material
		};

		return new materialLib[ type ]();

	}

}

class LoaderUtils {

	static decodeText( array ) {

		if ( typeof TextDecoder !== 'undefined' ) {

			return new TextDecoder().decode( array );

		}

		// Avoid the String.fromCharCode.apply(null, array) shortcut, which
		// throws a "maximum call stack size exceeded" error for large arrays.

		let s = '';

		for ( let i = 0, il = array.length; i < il; i ++ ) {

			// Implicitly assumes little-endian.
			s += String.fromCharCode( array[ i ] );

		}

		try {

			// merges multi-byte utf-8 characters.

			return decodeURIComponent( escape( s ) );

		} catch ( e ) { // see #16358

			return s;

		}

	}

	static extractUrlBase( url ) {

		const index = url.lastIndexOf( '/' );

		if ( index === - 1 ) return './';

		return url.slice( 0, index + 1 );

	}

	static resolveURL( url, path ) {

		// Invalid URL
		if ( typeof url !== 'string' || url === '' ) return '';

		// Host Relative URL
		if ( /^https?:\/\//i.test( path ) && /^\//.test( url ) ) {

			path = path.replace( /(^https?:\/\/[^\/]+).*/i, '$1' );

		}

		// Absolute URL http://,https://,//
		if ( /^(https?:)?\/\//i.test( url ) ) return url;

		// Data URI
		if ( /^data:.*,.*$/i.test( url ) ) return url;

		// Blob URL
		if ( /^blob:.*$/i.test( url ) ) return url;

		// Relative URL
		return path + url;

	}

}

class InstancedBufferGeometry extends (/* unused pure expression or super */ null && (BufferGeometry)) {

	constructor() {

		super();

		this.isInstancedBufferGeometry = true;

		this.type = 'InstancedBufferGeometry';
		this.instanceCount = Infinity;

	}

	copy( source ) {

		super.copy( source );

		this.instanceCount = source.instanceCount;

		return this;

	}

	toJSON() {

		const data = super.toJSON();

		data.instanceCount = this.instanceCount;

		data.isInstancedBufferGeometry = true;

		return data;

	}

}

class BufferGeometryLoader extends (/* unused pure expression or super */ null && (Loader)) {

	constructor( manager ) {

		super( manager );

	}

	load( url, onLoad, onProgress, onError ) {

		const scope = this;

		const loader = new FileLoader( scope.manager );
		loader.setPath( scope.path );
		loader.setRequestHeader( scope.requestHeader );
		loader.setWithCredentials( scope.withCredentials );
		loader.load( url, function ( text ) {

			try {

				onLoad( scope.parse( JSON.parse( text ) ) );

			} catch ( e ) {

				if ( onError ) {

					onError( e );

				} else {

					console.error( e );

				}

				scope.manager.itemError( url );

			}

		}, onProgress, onError );

	}

	parse( json ) {

		const interleavedBufferMap = {};
		const arrayBufferMap = {};

		function getInterleavedBuffer( json, uuid ) {

			if ( interleavedBufferMap[ uuid ] !== undefined ) return interleavedBufferMap[ uuid ];

			const interleavedBuffers = json.interleavedBuffers;
			const interleavedBuffer = interleavedBuffers[ uuid ];

			const buffer = getArrayBuffer( json, interleavedBuffer.buffer );

			const array = getTypedArray( interleavedBuffer.type, buffer );
			const ib = new InterleavedBuffer( array, interleavedBuffer.stride );
			ib.uuid = interleavedBuffer.uuid;

			interleavedBufferMap[ uuid ] = ib;

			return ib;

		}

		function getArrayBuffer( json, uuid ) {

			if ( arrayBufferMap[ uuid ] !== undefined ) return arrayBufferMap[ uuid ];

			const arrayBuffers = json.arrayBuffers;
			const arrayBuffer = arrayBuffers[ uuid ];

			const ab = new Uint32Array( arrayBuffer ).buffer;

			arrayBufferMap[ uuid ] = ab;

			return ab;

		}

		const geometry = json.isInstancedBufferGeometry ? new InstancedBufferGeometry() : new BufferGeometry();

		const index = json.data.index;

		if ( index !== undefined ) {

			const typedArray = getTypedArray( index.type, index.array );
			geometry.setIndex( new BufferAttribute( typedArray, 1 ) );

		}

		const attributes = json.data.attributes;

		for ( const key in attributes ) {

			const attribute = attributes[ key ];
			let bufferAttribute;

			if ( attribute.isInterleavedBufferAttribute ) {

				const interleavedBuffer = getInterleavedBuffer( json.data, attribute.data );
				bufferAttribute = new InterleavedBufferAttribute( interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized );

			} else {

				const typedArray = getTypedArray( attribute.type, attribute.array );
				const bufferAttributeConstr = attribute.isInstancedBufferAttribute ? InstancedBufferAttribute : BufferAttribute;
				bufferAttribute = new bufferAttributeConstr( typedArray, attribute.itemSize, attribute.normalized );

			}

			if ( attribute.name !== undefined ) bufferAttribute.name = attribute.name;
			if ( attribute.usage !== undefined ) bufferAttribute.setUsage( attribute.usage );

			geometry.setAttribute( key, bufferAttribute );

		}

		const morphAttributes = json.data.morphAttributes;

		if ( morphAttributes ) {

			for ( const key in morphAttributes ) {

				const attributeArray = morphAttributes[ key ];

				const array = [];

				for ( let i = 0, il = attributeArray.length; i < il; i ++ ) {

					const attribute = attributeArray[ i ];
					let bufferAttribute;

					if ( attribute.isInterleavedBufferAttribute ) {

						const interleavedBuffer = getInterleavedBuffer( json.data, attribute.data );
						bufferAttribute = new InterleavedBufferAttribute( interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized );

					} else {

						const typedArray = getTypedArray( attribute.type, attribute.array );
						bufferAttribute = new BufferAttribute( typedArray, attribute.itemSize, attribute.normalized );

					}

					if ( attribute.name !== undefined ) bufferAttribute.name = attribute.name;
					array.push( bufferAttribute );

				}

				geometry.morphAttributes[ key ] = array;

			}

		}

		const morphTargetsRelative = json.data.morphTargetsRelative;

		if ( morphTargetsRelative ) {

			geometry.morphTargetsRelative = true;

		}

		const groups = json.data.groups || json.data.drawcalls || json.data.offsets;

		if ( groups !== undefined ) {

			for ( let i = 0, n = groups.length; i !== n; ++ i ) {

				const group = groups[ i ];

				geometry.addGroup( group.start, group.count, group.materialIndex );

			}

		}

		const boundingSphere = json.data.boundingSphere;

		if ( boundingSphere !== undefined ) {

			const center = new Vector3();

			if ( boundingSphere.center !== undefined ) {

				center.fromArray( boundingSphere.center );

			}

			geometry.boundingSphere = new Sphere( center, boundingSphere.radius );

		}

		if ( json.name ) geometry.name = json.name;
		if ( json.userData ) geometry.userData = json.userData;

		return geometry;

	}

}

class ObjectLoader extends (/* unused pure expression or super */ null && (Loader)) {

	constructor( manager ) {

		super( manager );

	}

	load( url, onLoad, onProgress, onError ) {

		const scope = this;

		const path = ( this.path === '' ) ? LoaderUtils.extractUrlBase( url ) : this.path;
		this.resourcePath = this.resourcePath || path;

		const loader = new FileLoader( this.manager );
		loader.setPath( this.path );
		loader.setRequestHeader( this.requestHeader );
		loader.setWithCredentials( this.withCredentials );
		loader.load( url, function ( text ) {

			let json = null;

			try {

				json = JSON.parse( text );

			} catch ( error ) {

				if ( onError !== undefined ) onError( error );

				console.error( 'THREE:ObjectLoader: Can\'t parse ' + url + '.', error.message );

				return;

			}

			const metadata = json.metadata;

			if ( metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry' ) {

				if ( onError !== undefined ) onError( new Error( 'THREE.ObjectLoader: Can\'t load ' + url ) );

				console.error( 'THREE.ObjectLoader: Can\'t load ' + url );
				return;

			}

			scope.parse( json, onLoad );

		}, onProgress, onError );

	}

	async loadAsync( url, onProgress ) {

		const scope = this;

		const path = ( this.path === '' ) ? LoaderUtils.extractUrlBase( url ) : this.path;
		this.resourcePath = this.resourcePath || path;

		const loader = new FileLoader( this.manager );
		loader.setPath( this.path );
		loader.setRequestHeader( this.requestHeader );
		loader.setWithCredentials( this.withCredentials );

		const text = await loader.loadAsync( url, onProgress );

		const json = JSON.parse( text );

		const metadata = json.metadata;

		if ( metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry' ) {

			throw new Error( 'THREE.ObjectLoader: Can\'t load ' + url );

		}

		return await scope.parseAsync( json );

	}

	parse( json, onLoad ) {

		const animations = this.parseAnimations( json.animations );
		const shapes = this.parseShapes( json.shapes );
		const geometries = this.parseGeometries( json.geometries, shapes );

		const images = this.parseImages( json.images, function () {

			if ( onLoad !== undefined ) onLoad( object );

		} );

		const textures = this.parseTextures( json.textures, images );
		const materials = this.parseMaterials( json.materials, textures );

		const object = this.parseObject( json.object, geometries, materials, textures, animations );
		const skeletons = this.parseSkeletons( json.skeletons, object );

		this.bindSkeletons( object, skeletons );

		//

		if ( onLoad !== undefined ) {

			let hasImages = false;

			for ( const uuid in images ) {

				if ( images[ uuid ].data instanceof HTMLImageElement ) {

					hasImages = true;
					break;

				}

			}

			if ( hasImages === false ) onLoad( object );

		}

		return object;

	}

	async parseAsync( json ) {

		const animations = this.parseAnimations( json.animations );
		const shapes = this.parseShapes( json.shapes );
		const geometries = this.parseGeometries( json.geometries, shapes );

		const images = await this.parseImagesAsync( json.images );

		const textures = this.parseTextures( json.textures, images );
		const materials = this.parseMaterials( json.materials, textures );

		const object = this.parseObject( json.object, geometries, materials, textures, animations );
		const skeletons = this.parseSkeletons( json.skeletons, object );

		this.bindSkeletons( object, skeletons );

		return object;

	}

	parseShapes( json ) {

		const shapes = {};

		if ( json !== undefined ) {

			for ( let i = 0, l = json.length; i < l; i ++ ) {

				const shape = new Shape().fromJSON( json[ i ] );

				shapes[ shape.uuid ] = shape;

			}

		}

		return shapes;

	}

	parseSkeletons( json, object ) {

		const skeletons = {};
		const bones = {};

		// generate bone lookup table

		object.traverse( function ( child ) {

			if ( child.isBone ) bones[ child.uuid ] = child;

		} );

		// create skeletons

		if ( json !== undefined ) {

			for ( let i = 0, l = json.length; i < l; i ++ ) {

				const skeleton = new Skeleton().fromJSON( json[ i ], bones );

				skeletons[ skeleton.uuid ] = skeleton;

			}

		}

		return skeletons;

	}

	parseGeometries( json, shapes ) {

		const geometries = {};

		if ( json !== undefined ) {

			const bufferGeometryLoader = new BufferGeometryLoader();

			for ( let i = 0, l = json.length; i < l; i ++ ) {

				let geometry;
				const data = json[ i ];

				switch ( data.type ) {

					case 'BufferGeometry':
					case 'InstancedBufferGeometry':

						geometry = bufferGeometryLoader.parse( data );
						break;

					default:

						if ( data.type in Geometries ) {

							geometry = Geometries[ data.type ].fromJSON( data, shapes );

						} else {

							console.warn( `THREE.ObjectLoader: Unsupported geometry type "${ data.type }"` );

						}

				}

				geometry.uuid = data.uuid;

				if ( data.name !== undefined ) geometry.name = data.name;
				if ( data.userData !== undefined ) geometry.userData = data.userData;

				geometries[ data.uuid ] = geometry;

			}

		}

		return geometries;

	}

	parseMaterials( json, textures ) {

		const cache = {}; // MultiMaterial
		const materials = {};

		if ( json !== undefined ) {

			const loader = new MaterialLoader();
			loader.setTextures( textures );

			for ( let i = 0, l = json.length; i < l; i ++ ) {

				const data = json[ i ];

				if ( cache[ data.uuid ] === undefined ) {

					cache[ data.uuid ] = loader.parse( data );

				}

				materials[ data.uuid ] = cache[ data.uuid ];

			}

		}

		return materials;

	}

	parseAnimations( json ) {

		const animations = {};

		if ( json !== undefined ) {

			for ( let i = 0; i < json.length; i ++ ) {

				const data = json[ i ];

				const clip = AnimationClip.parse( data );

				animations[ clip.uuid ] = clip;

			}

		}

		return animations;

	}

	parseImages( json, onLoad ) {

		const scope = this;
		const images = {};

		let loader;

		function loadImage( url ) {

			scope.manager.itemStart( url );

			return loader.load( url, function () {

				scope.manager.itemEnd( url );

			}, undefined, function () {

				scope.manager.itemError( url );
				scope.manager.itemEnd( url );

			} );

		}

		function deserializeImage( image ) {

			if ( typeof image === 'string' ) {

				const url = image;

				const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test( url ) ? url : scope.resourcePath + url;

				return loadImage( path );

			} else {

				if ( image.data ) {

					return {
						data: getTypedArray( image.type, image.data ),
						width: image.width,
						height: image.height
					};

				} else {

					return null;

				}

			}

		}

		if ( json !== undefined && json.length > 0 ) {

			const manager = new LoadingManager( onLoad );

			loader = new ImageLoader( manager );
			loader.setCrossOrigin( this.crossOrigin );

			for ( let i = 0, il = json.length; i < il; i ++ ) {

				const image = json[ i ];
				const url = image.url;

				if ( Array.isArray( url ) ) {

					// load array of images e.g CubeTexture

					const imageArray = [];

					for ( let j = 0, jl = url.length; j < jl; j ++ ) {

						const currentUrl = url[ j ];

						const deserializedImage = deserializeImage( currentUrl );

						if ( deserializedImage !== null ) {

							if ( deserializedImage instanceof HTMLImageElement ) {

								imageArray.push( deserializedImage );

							} else {

								// special case: handle array of data textures for cube textures

								imageArray.push( new DataTexture( deserializedImage.data, deserializedImage.width, deserializedImage.height ) );

							}

						}

					}

					images[ image.uuid ] = new Source( imageArray );

				} else {

					// load single image

					const deserializedImage = deserializeImage( image.url );
					images[ image.uuid ] = new Source( deserializedImage );


				}

			}

		}

		return images;

	}

	async parseImagesAsync( json ) {

		const scope = this;
		const images = {};

		let loader;

		async function deserializeImage( image ) {

			if ( typeof image === 'string' ) {

				const url = image;

				const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test( url ) ? url : scope.resourcePath + url;

				return await loader.loadAsync( path );

			} else {

				if ( image.data ) {

					return {
						data: getTypedArray( image.type, image.data ),
						width: image.width,
						height: image.height
					};

				} else {

					return null;

				}

			}

		}

		if ( json !== undefined && json.length > 0 ) {

			loader = new ImageLoader( this.manager );
			loader.setCrossOrigin( this.crossOrigin );

			for ( let i = 0, il = json.length; i < il; i ++ ) {

				const image = json[ i ];
				const url = image.url;

				if ( Array.isArray( url ) ) {

					// load array of images e.g CubeTexture

					const imageArray = [];

					for ( let j = 0, jl = url.length; j < jl; j ++ ) {

						const currentUrl = url[ j ];

						const deserializedImage = await deserializeImage( currentUrl );

						if ( deserializedImage !== null ) {

							if ( deserializedImage instanceof HTMLImageElement ) {

								imageArray.push( deserializedImage );

							} else {

								// special case: handle array of data textures for cube textures

								imageArray.push( new DataTexture( deserializedImage.data, deserializedImage.width, deserializedImage.height ) );

							}

						}

					}

					images[ image.uuid ] = new Source( imageArray );

				} else {

					// load single image

					const deserializedImage = await deserializeImage( image.url );
					images[ image.uuid ] = new Source( deserializedImage );

				}

			}

		}

		return images;

	}

	parseTextures( json, images ) {

		function parseConstant( value, type ) {

			if ( typeof value === 'number' ) return value;

			console.warn( 'THREE.ObjectLoader.parseTexture: Constant should be in numeric form.', value );

			return type[ value ];

		}

		const textures = {};

		if ( json !== undefined ) {

			for ( let i = 0, l = json.length; i < l; i ++ ) {

				const data = json[ i ];

				if ( data.image === undefined ) {

					console.warn( 'THREE.ObjectLoader: No "image" specified for', data.uuid );

				}

				if ( images[ data.image ] === undefined ) {

					console.warn( 'THREE.ObjectLoader: Undefined image', data.image );

				}

				const source = images[ data.image ];
				const image = source.data;

				let texture;

				if ( Array.isArray( image ) ) {

					texture = new CubeTexture();

					if ( image.length === 6 ) texture.needsUpdate = true;

				} else {

					if ( image && image.data ) {

						texture = new DataTexture();

					} else {

						texture = new Texture();

					}

					if ( image ) texture.needsUpdate = true; // textures can have undefined image data

				}

				texture.source = source;

				texture.uuid = data.uuid;

				if ( data.name !== undefined ) texture.name = data.name;

				if ( data.mapping !== undefined ) texture.mapping = parseConstant( data.mapping, TEXTURE_MAPPING );
				if ( data.channel !== undefined ) texture.channel = data.channel;

				if ( data.offset !== undefined ) texture.offset.fromArray( data.offset );
				if ( data.repeat !== undefined ) texture.repeat.fromArray( data.repeat );
				if ( data.center !== undefined ) texture.center.fromArray( data.center );
				if ( data.rotation !== undefined ) texture.rotation = data.rotation;

				if ( data.wrap !== undefined ) {

					texture.wrapS = parseConstant( data.wrap[ 0 ], TEXTURE_WRAPPING );
					texture.wrapT = parseConstant( data.wrap[ 1 ], TEXTURE_WRAPPING );

				}

				if ( data.format !== undefined ) texture.format = data.format;
				if ( data.internalFormat !== undefined ) texture.internalFormat = data.internalFormat;
				if ( data.type !== undefined ) texture.type = data.type;
				if ( data.colorSpace !== undefined ) texture.colorSpace = data.colorSpace;

				if ( data.minFilter !== undefined ) texture.minFilter = parseConstant( data.minFilter, TEXTURE_FILTER );
				if ( data.magFilter !== undefined ) texture.magFilter = parseConstant( data.magFilter, TEXTURE_FILTER );
				if ( data.anisotropy !== undefined ) texture.anisotropy = data.anisotropy;

				if ( data.flipY !== undefined ) texture.flipY = data.flipY;

				if ( data.generateMipmaps !== undefined ) texture.generateMipmaps = data.generateMipmaps;
				if ( data.premultiplyAlpha !== undefined ) texture.premultiplyAlpha = data.premultiplyAlpha;
				if ( data.unpackAlignment !== undefined ) texture.unpackAlignment = data.unpackAlignment;
				if ( data.compareFunction !== undefined ) texture.compareFunction = data.compareFunction;

				if ( data.userData !== undefined ) texture.userData = data.userData;

				textures[ data.uuid ] = texture;

			}

		}

		return textures;

	}

	parseObject( data, geometries, materials, textures, animations ) {

		let object;

		function getGeometry( name ) {

			if ( geometries[ name ] === undefined ) {

				console.warn( 'THREE.ObjectLoader: Undefined geometry', name );

			}

			return geometries[ name ];

		}

		function getMaterial( name ) {

			if ( name === undefined ) return undefined;

			if ( Array.isArray( name ) ) {

				const array = [];

				for ( let i = 0, l = name.length; i < l; i ++ ) {

					const uuid = name[ i ];

					if ( materials[ uuid ] === undefined ) {

						console.warn( 'THREE.ObjectLoader: Undefined material', uuid );

					}

					array.push( materials[ uuid ] );

				}

				return array;

			}

			if ( materials[ name ] === undefined ) {

				console.warn( 'THREE.ObjectLoader: Undefined material', name );

			}

			return materials[ name ];

		}

		function getTexture( uuid ) {

			if ( textures[ uuid ] === undefined ) {

				console.warn( 'THREE.ObjectLoader: Undefined texture', uuid );

			}

			return textures[ uuid ];

		}

		let geometry, material;

		switch ( data.type ) {

			case 'Scene':

				object = new Scene();

				if ( data.background !== undefined ) {

					if ( Number.isInteger( data.background ) ) {

						object.background = new Color( data.background );

					} else {

						object.background = getTexture( data.background );

					}

				}

				if ( data.environment !== undefined ) {

					object.environment = getTexture( data.environment );

				}

				if ( data.fog !== undefined ) {

					if ( data.fog.type === 'Fog' ) {

						object.fog = new Fog( data.fog.color, data.fog.near, data.fog.far );

					} else if ( data.fog.type === 'FogExp2' ) {

						object.fog = new FogExp2( data.fog.color, data.fog.density );

					}

					if ( data.fog.name !== '' ) {

						object.fog.name = data.fog.name;

					}

				}

				if ( data.backgroundBlurriness !== undefined ) object.backgroundBlurriness = data.backgroundBlurriness;
				if ( data.backgroundIntensity !== undefined ) object.backgroundIntensity = data.backgroundIntensity;
				if ( data.backgroundRotation !== undefined ) object.backgroundRotation.fromArray( data.backgroundRotation );

				if ( data.environmentIntensity !== undefined ) object.environmentIntensity = data.environmentIntensity;
				if ( data.environmentRotation !== undefined ) object.environmentRotation.fromArray( data.environmentRotation );

				break;

			case 'PerspectiveCamera':

				object = new PerspectiveCamera( data.fov, data.aspect, data.near, data.far );

				if ( data.focus !== undefined ) object.focus = data.focus;
				if ( data.zoom !== undefined ) object.zoom = data.zoom;
				if ( data.filmGauge !== undefined ) object.filmGauge = data.filmGauge;
				if ( data.filmOffset !== undefined ) object.filmOffset = data.filmOffset;
				if ( data.view !== undefined ) object.view = Object.assign( {}, data.view );

				break;

			case 'OrthographicCamera':

				object = new OrthographicCamera( data.left, data.right, data.top, data.bottom, data.near, data.far );

				if ( data.zoom !== undefined ) object.zoom = data.zoom;
				if ( data.view !== undefined ) object.view = Object.assign( {}, data.view );

				break;

			case 'AmbientLight':

				object = new AmbientLight( data.color, data.intensity );

				break;

			case 'DirectionalLight':

				object = new DirectionalLight( data.color, data.intensity );

				break;

			case 'PointLight':

				object = new PointLight( data.color, data.intensity, data.distance, data.decay );

				break;

			case 'RectAreaLight':

				object = new RectAreaLight( data.color, data.intensity, data.width, data.height );

				break;

			case 'SpotLight':

				object = new SpotLight( data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay );

				break;

			case 'HemisphereLight':

				object = new HemisphereLight( data.color, data.groundColor, data.intensity );

				break;

			case 'LightProbe':

				object = new LightProbe().fromJSON( data );

				break;

			case 'SkinnedMesh':

				geometry = getGeometry( data.geometry );
			 	material = getMaterial( data.material );

				object = new SkinnedMesh( geometry, material );

				if ( data.bindMode !== undefined ) object.bindMode = data.bindMode;
				if ( data.bindMatrix !== undefined ) object.bindMatrix.fromArray( data.bindMatrix );
				if ( data.skeleton !== undefined ) object.skeleton = data.skeleton;

				break;

			case 'Mesh':

				geometry = getGeometry( data.geometry );
				material = getMaterial( data.material );

				object = new Mesh( geometry, material );

				break;

			case 'InstancedMesh':

				geometry = getGeometry( data.geometry );
				material = getMaterial( data.material );
				const count = data.count;
				const instanceMatrix = data.instanceMatrix;
				const instanceColor = data.instanceColor;

				object = new InstancedMesh( geometry, material, count );
				object.instanceMatrix = new InstancedBufferAttribute( new Float32Array( instanceMatrix.array ), 16 );
				if ( instanceColor !== undefined ) object.instanceColor = new InstancedBufferAttribute( new Float32Array( instanceColor.array ), instanceColor.itemSize );

				break;

			case 'BatchedMesh':

				geometry = getGeometry( data.geometry );
				material = getMaterial( data.material );

				object = new BatchedMesh( data.maxGeometryCount, data.maxVertexCount, data.maxIndexCount, material );
				object.geometry = geometry;
				object.perObjectFrustumCulled = data.perObjectFrustumCulled;
				object.sortObjects = data.sortObjects;

				object._drawRanges = data.drawRanges;
				object._reservedRanges = data.reservedRanges;

				object._visibility = data.visibility;
				object._active = data.active;
				object._bounds = data.bounds.map( bound => {

					const box = new Box3();
					box.min.fromArray( bound.boxMin );
					box.max.fromArray( bound.boxMax );

					const sphere = new Sphere();
					sphere.radius = bound.sphereRadius;
					sphere.center.fromArray( bound.sphereCenter );

					return {
						boxInitialized: bound.boxInitialized,
						box: box,

						sphereInitialized: bound.sphereInitialized,
						sphere: sphere
					};

				} );

				object._maxGeometryCount = data.maxGeometryCount;
				object._maxVertexCount = data.maxVertexCount;
				object._maxIndexCount = data.maxIndexCount;

				object._geometryInitialized = data.geometryInitialized;
				object._geometryCount = data.geometryCount;

				object._matricesTexture = getTexture( data.matricesTexture.uuid );

				break;

			case 'LOD':

				object = new LOD();

				break;

			case 'Line':

				object = new Line( getGeometry( data.geometry ), getMaterial( data.material ) );

				break;

			case 'LineLoop':

				object = new LineLoop( getGeometry( data.geometry ), getMaterial( data.material ) );

				break;

			case 'LineSegments':

				object = new LineSegments( getGeometry( data.geometry ), getMaterial( data.material ) );

				break;

			case 'PointCloud':
			case 'Points':

				object = new Points( getGeometry( data.geometry ), getMaterial( data.material ) );

				break;

			case 'Sprite':

				object = new Sprite( getMaterial( data.material ) );

				break;

			case 'Group':

				object = new Group();

				break;

			case 'Bone':

				object = new Bone();

				break;

			default:

				object = new Object3D();

		}

		object.uuid = data.uuid;

		if ( data.name !== undefined ) object.name = data.name;

		if ( data.matrix !== undefined ) {

			object.matrix.fromArray( data.matrix );

			if ( data.matrixAutoUpdate !== undefined ) object.matrixAutoUpdate = data.matrixAutoUpdate;
			if ( object.matrixAutoUpdate ) object.matrix.decompose( object.position, object.quaternion, object.scale );

		} else {

			if ( data.position !== undefined ) object.position.fromArray( data.position );
			if ( data.rotation !== undefined ) object.rotation.fromArray( data.rotation );
			if ( data.quaternion !== undefined ) object.quaternion.fromArray( data.quaternion );
			if ( data.scale !== undefined ) object.scale.fromArray( data.scale );

		}

		if ( data.up !== undefined ) object.up.fromArray( data.up );

		if ( data.castShadow !== undefined ) object.castShadow = data.castShadow;
		if ( data.receiveShadow !== undefined ) object.receiveShadow = data.receiveShadow;

		if ( data.shadow ) {

			if ( data.shadow.bias !== undefined ) object.shadow.bias = data.shadow.bias;
			if ( data.shadow.normalBias !== undefined ) object.shadow.normalBias = data.shadow.normalBias;
			if ( data.shadow.radius !== undefined ) object.shadow.radius = data.shadow.radius;
			if ( data.shadow.mapSize !== undefined ) object.shadow.mapSize.fromArray( data.shadow.mapSize );
			if ( data.shadow.camera !== undefined ) object.shadow.camera = this.parseObject( data.shadow.camera );

		}

		if ( data.visible !== undefined ) object.visible = data.visible;
		if ( data.frustumCulled !== undefined ) object.frustumCulled = data.frustumCulled;
		if ( data.renderOrder !== undefined ) object.renderOrder = data.renderOrder;
		if ( data.userData !== undefined ) object.userData = data.userData;
		if ( data.layers !== undefined ) object.layers.mask = data.layers;

		if ( data.children !== undefined ) {

			const children = data.children;

			for ( let i = 0; i < children.length; i ++ ) {

				object.add( this.parseObject( children[ i ], geometries, materials, textures, animations ) );

			}

		}

		if ( data.animations !== undefined ) {

			const objectAnimations = data.animations;

			for ( let i = 0; i < objectAnimations.length; i ++ ) {

				const uuid = objectAnimations[ i ];

				object.animations.push( animations[ uuid ] );

			}

		}

		if ( data.type === 'LOD' ) {

			if ( data.autoUpdate !== undefined ) object.autoUpdate = data.autoUpdate;

			const levels = data.levels;

			for ( let l = 0; l < levels.length; l ++ ) {

				const level = levels[ l ];
				const child = object.getObjectByProperty( 'uuid', level.object );

				if ( child !== undefined ) {

					object.addLevel( child, level.distance, level.hysteresis );

				}

			}

		}

		return object;

	}

	bindSkeletons( object, skeletons ) {

		if ( Object.keys( skeletons ).length === 0 ) return;

		object.traverse( function ( child ) {

			if ( child.isSkinnedMesh === true && child.skeleton !== undefined ) {

				const skeleton = skeletons[ child.skeleton ];

				if ( skeleton === undefined ) {

					console.warn( 'THREE.ObjectLoader: No skeleton found with UUID:', child.skeleton );

				} else {

					child.bind( skeleton, child.bindMatrix );

				}

			}

		} );

	}

}

const TEXTURE_MAPPING = {
	UVMapping: UVMapping,
	CubeReflectionMapping: CubeReflectionMapping,
	CubeRefractionMapping: CubeRefractionMapping,
	EquirectangularReflectionMapping: EquirectangularReflectionMapping,
	EquirectangularRefractionMapping: EquirectangularRefractionMapping,
	CubeUVReflectionMapping: CubeUVReflectionMapping
};

const TEXTURE_WRAPPING = {
	RepeatWrapping: RepeatWrapping,
	ClampToEdgeWrapping: ClampToEdgeWrapping,
	MirroredRepeatWrapping: MirroredRepeatWrapping
};

const TEXTURE_FILTER = {
	NearestFilter: NearestFilter,
	NearestMipmapNearestFilter: NearestMipmapNearestFilter,
	NearestMipmapLinearFilter: NearestMipmapLinearFilter,
	LinearFilter: LinearFilter,
	LinearMipmapNearestFilter: LinearMipmapNearestFilter,
	LinearMipmapLinearFilter: LinearMipmapLinearFilter
};

class ImageBitmapLoader extends (/* unused pure expression or super */ null && (Loader)) {

	constructor( manager ) {

		super( manager );

		this.isImageBitmapLoader = true;

		if ( typeof createImageBitmap === 'undefined' ) {

			console.warn( 'THREE.ImageBitmapLoader: createImageBitmap() not supported.' );

		}

		if ( typeof fetch === 'undefined' ) {

			console.warn( 'THREE.ImageBitmapLoader: fetch() not supported.' );

		}

		this.options = { premultiplyAlpha: 'none' };

	}

	setOptions( options ) {

		this.options = options;

		return this;

	}

	load( url, onLoad, onProgress, onError ) {

		if ( url === undefined ) url = '';

		if ( this.path !== undefined ) url = this.path + url;

		url = this.manager.resolveURL( url );

		const scope = this;

		const cached = Cache.get( url );

		if ( cached !== undefined ) {

			scope.manager.itemStart( url );

			// If cached is a promise, wait for it to resolve
			if ( cached.then ) {

				cached.then( imageBitmap => {

					if ( onLoad ) onLoad( imageBitmap );

					scope.manager.itemEnd( url );

				} ).catch( e => {

					if ( onError ) onError( e );

				} );
				return;

			}

			// If cached is not a promise (i.e., it's already an imageBitmap)
			setTimeout( function () {

				if ( onLoad ) onLoad( cached );

				scope.manager.itemEnd( url );

			}, 0 );

			return cached;

		}

		const fetchOptions = {};
		fetchOptions.credentials = ( this.crossOrigin === 'anonymous' ) ? 'same-origin' : 'include';
		fetchOptions.headers = this.requestHeader;

		const promise = fetch( url, fetchOptions ).then( function ( res ) {

			return res.blob();

		} ).then( function ( blob ) {

			return createImageBitmap( blob, Object.assign( scope.options, { colorSpaceConversion: 'none' } ) );

		} ).then( function ( imageBitmap ) {

			Cache.add( url, imageBitmap );

			if ( onLoad ) onLoad( imageBitmap );

			scope.manager.itemEnd( url );

			return imageBitmap;

		} ).catch( function ( e ) {

			if ( onError ) onError( e );

			Cache.remove( url );

			scope.manager.itemError( url );
			scope.manager.itemEnd( url );

		} );

		Cache.add( url, promise );
		scope.manager.itemStart( url );

	}

}

let _context;

class AudioContext {

	static getContext() {

		if ( _context === undefined ) {

			_context = new ( window.AudioContext || window.webkitAudioContext )();

		}

		return _context;

	}

	static setContext( value ) {

		_context = value;

	}

}

class AudioLoader extends (/* unused pure expression or super */ null && (Loader)) {

	constructor( manager ) {

		super( manager );

	}

	load( url, onLoad, onProgress, onError ) {

		const scope = this;

		const loader = new FileLoader( this.manager );
		loader.setResponseType( 'arraybuffer' );
		loader.setPath( this.path );
		loader.setRequestHeader( this.requestHeader );
		loader.setWithCredentials( this.withCredentials );
		loader.load( url, function ( buffer ) {

			try {

				// Create a copy of the buffer. The `decodeAudioData` method
				// detaches the buffer when complete, preventing reuse.
				const bufferCopy = buffer.slice( 0 );

				const context = AudioContext.getContext();
				context.decodeAudioData( bufferCopy, function ( audioBuffer ) {

					onLoad( audioBuffer );

				} ).catch( handleError );

			} catch ( e ) {

				handleError( e );

			}

		}, onProgress, onError );

		function handleError( e ) {

			if ( onError ) {

				onError( e );

			} else {

				console.error( e );

			}

			scope.manager.itemError( url );

		}

	}

}

const _eyeRight = /*@__PURE__*/ new Matrix4();
const _eyeLeft = /*@__PURE__*/ new Matrix4();
const _projectionMatrix = /*@__PURE__*/ new Matrix4();

class StereoCamera {

	constructor() {

		this.type = 'StereoCamera';

		this.aspect = 1;

		this.eyeSep = 0.064;

		this.cameraL = new PerspectiveCamera();
		this.cameraL.layers.enable( 1 );
		this.cameraL.matrixAutoUpdate = false;

		this.cameraR = new PerspectiveCamera();
		this.cameraR.layers.enable( 2 );
		this.cameraR.matrixAutoUpdate = false;

		this._cache = {
			focus: null,
			fov: null,
			aspect: null,
			near: null,
			far: null,
			zoom: null,
			eyeSep: null
		};

	}

	update( camera ) {

		const cache = this._cache;

		const needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov ||
			cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near ||
			cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;

		if ( needsUpdate ) {

			cache.focus = camera.focus;
			cache.fov = camera.fov;
			cache.aspect = camera.aspect * this.aspect;
			cache.near = camera.near;
			cache.far = camera.far;
			cache.zoom = camera.zoom;
			cache.eyeSep = this.eyeSep;

			// Off-axis stereoscopic effect based on
			// http://paulbourke.net/stereographics/stereorender/

			_projectionMatrix.copy( camera.projectionMatrix );
			const eyeSepHalf = cache.eyeSep / 2;
			const eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
			const ymax = ( cache.near * Math.tan( DEG2RAD * cache.fov * 0.5 ) ) / cache.zoom;
			let xmin, xmax;

			// translate xOffset

			_eyeLeft.elements[ 12 ] = - eyeSepHalf;
			_eyeRight.elements[ 12 ] = eyeSepHalf;

			// for left eye

			xmin = - ymax * cache.aspect + eyeSepOnProjection;
			xmax = ymax * cache.aspect + eyeSepOnProjection;

			_projectionMatrix.elements[ 0 ] = 2 * cache.near / ( xmax - xmin );
			_projectionMatrix.elements[ 8 ] = ( xmax + xmin ) / ( xmax - xmin );

			this.cameraL.projectionMatrix.copy( _projectionMatrix );

			// for right eye

			xmin = - ymax * cache.aspect - eyeSepOnProjection;
			xmax = ymax * cache.aspect - eyeSepOnProjection;

			_projectionMatrix.elements[ 0 ] = 2 * cache.near / ( xmax - xmin );
			_projectionMatrix.elements[ 8 ] = ( xmax + xmin ) / ( xmax - xmin );

			this.cameraR.projectionMatrix.copy( _projectionMatrix );

		}

		this.cameraL.matrixWorld.copy( camera.matrixWorld ).multiply( _eyeLeft );
		this.cameraR.matrixWorld.copy( camera.matrixWorld ).multiply( _eyeRight );

	}

}

class Clock {

	constructor( autoStart = true ) {

		this.autoStart = autoStart;

		this.startTime = 0;
		this.oldTime = 0;
		this.elapsedTime = 0;

		this.running = false;

	}

	start() {

		this.startTime = now();

		this.oldTime = this.startTime;
		this.elapsedTime = 0;
		this.running = true;

	}

	stop() {

		this.getElapsedTime();
		this.running = false;
		this.autoStart = false;

	}

	getElapsedTime() {

		this.getDelta();
		return this.elapsedTime;

	}

	getDelta() {

		let diff = 0;

		if ( this.autoStart && ! this.running ) {

			this.start();
			return 0;

		}

		if ( this.running ) {

			const newTime = now();

			diff = ( newTime - this.oldTime ) / 1000;
			this.oldTime = newTime;

			this.elapsedTime += diff;

		}

		return diff;

	}

}

function now() {

	return ( typeof performance === 'undefined' ? Date : performance ).now(); // see #10732

}

const _position$1 = /*@__PURE__*/ new Vector3();
const _quaternion$1 = /*@__PURE__*/ new Quaternion();
const _scale$1 = /*@__PURE__*/ new Vector3();
const _orientation$1 = /*@__PURE__*/ new Vector3();

class AudioListener extends (/* unused pure expression or super */ null && (Object3D)) {

	constructor() {

		super();

		this.type = 'AudioListener';

		this.context = AudioContext.getContext();

		this.gain = this.context.createGain();
		this.gain.connect( this.context.destination );

		this.filter = null;

		this.timeDelta = 0;

		// private

		this._clock = new Clock();

	}

	getInput() {

		return this.gain;

	}

	removeFilter() {

		if ( this.filter !== null ) {

			this.gain.disconnect( this.filter );
			this.filter.disconnect( this.context.destination );
			this.gain.connect( this.context.destination );
			this.filter = null;

		}

		return this;

	}

	getFilter() {

		return this.filter;

	}

	setFilter( value ) {

		if ( this.filter !== null ) {

			this.gain.disconnect( this.filter );
			this.filter.disconnect( this.context.destination );

		} else {

			this.gain.disconnect( this.context.destination );

		}

		this.filter = value;
		this.gain.connect( this.filter );
		this.filter.connect( this.context.destination );

		return this;

	}

	getMasterVolume() {

		return this.gain.gain.value;

	}

	setMasterVolume( value ) {

		this.gain.gain.setTargetAtTime( value, this.context.currentTime, 0.01 );

		return this;

	}

	updateMatrixWorld( force ) {

		super.updateMatrixWorld( force );

		const listener = this.context.listener;
		const up = this.up;

		this.timeDelta = this._clock.getDelta();

		this.matrixWorld.decompose( _position$1, _quaternion$1, _scale$1 );

		_orientation$1.set( 0, 0, - 1 ).applyQuaternion( _quaternion$1 );

		if ( listener.positionX ) {

			// code path for Chrome (see #14393)

			const endTime = this.context.currentTime + this.timeDelta;

			listener.positionX.linearRampToValueAtTime( _position$1.x, endTime );
			listener.positionY.linearRampToValueAtTime( _position$1.y, endTime );
			listener.positionZ.linearRampToValueAtTime( _position$1.z, endTime );
			listener.forwardX.linearRampToValueAtTime( _orientation$1.x, endTime );
			listener.forwardY.linearRampToValueAtTime( _orientation$1.y, endTime );
			listener.forwardZ.linearRampToValueAtTime( _orientation$1.z, endTime );
			listener.upX.linearRampToValueAtTime( up.x, endTime );
			listener.upY.linearRampToValueAtTime( up.y, endTime );
			listener.upZ.linearRampToValueAtTime( up.z, endTime );

		} else {

			listener.setPosition( _position$1.x, _position$1.y, _position$1.z );
			listener.setOrientation( _orientation$1.x, _orientation$1.y, _orientation$1.z, up.x, up.y, up.z );

		}

	}

}

class Audio extends (/* unused pure expression or super */ null && (Object3D)) {

	constructor( listener ) {

		super();

		this.type = 'Audio';

		this.listener = listener;
		this.context = listener.context;

		this.gain = this.context.createGain();
		this.gain.connect( listener.getInput() );

		this.autoplay = false;

		this.buffer = null;
		this.detune = 0;
		this.loop = false;
		this.loopStart = 0;
		this.loopEnd = 0;
		this.offset = 0;
		this.duration = undefined;
		this.playbackRate = 1;
		this.isPlaying = false;
		this.hasPlaybackControl = true;
		this.source = null;
		this.sourceType = 'empty';

		this._startedAt = 0;
		this._progress = 0;
		this._connected = false;

		this.filters = [];

	}

	getOutput() {

		return this.gain;

	}

	setNodeSource( audioNode ) {

		this.hasPlaybackControl = false;
		this.sourceType = 'audioNode';
		this.source = audioNode;
		this.connect();

		return this;

	}

	setMediaElementSource( mediaElement ) {

		this.hasPlaybackControl = false;
		this.sourceType = 'mediaNode';
		this.source = this.context.createMediaElementSource( mediaElement );
		this.connect();

		return this;

	}

	setMediaStreamSource( mediaStream ) {

		this.hasPlaybackControl = false;
		this.sourceType = 'mediaStreamNode';
		this.source = this.context.createMediaStreamSource( mediaStream );
		this.connect();

		return this;

	}

	setBuffer( audioBuffer ) {

		this.buffer = audioBuffer;
		this.sourceType = 'buffer';

		if ( this.autoplay ) this.play();

		return this;

	}

	play( delay = 0 ) {

		if ( this.isPlaying === true ) {

			console.warn( 'THREE.Audio: Audio is already playing.' );
			return;

		}

		if ( this.hasPlaybackControl === false ) {

			console.warn( 'THREE.Audio: this Audio has no playback control.' );
			return;

		}

		this._startedAt = this.context.currentTime + delay;

		const source = this.context.createBufferSource();
		source.buffer = this.buffer;
		source.loop = this.loop;
		source.loopStart = this.loopStart;
		source.loopEnd = this.loopEnd;
		source.onended = this.onEnded.bind( this );
		source.start( this._startedAt, this._progress + this.offset, this.duration );

		this.isPlaying = true;

		this.source = source;

		this.setDetune( this.detune );
		this.setPlaybackRate( this.playbackRate );

		return this.connect();

	}

	pause() {

		if ( this.hasPlaybackControl === false ) {

			console.warn( 'THREE.Audio: this Audio has no playback control.' );
			return;

		}

		if ( this.isPlaying === true ) {

			// update current progress

			this._progress += Math.max( this.context.currentTime - this._startedAt, 0 ) * this.playbackRate;

			if ( this.loop === true ) {

				// ensure _progress does not exceed duration with looped audios

				this._progress = this._progress % ( this.duration || this.buffer.duration );

			}

			this.source.stop();
			this.source.onended = null;

			this.isPlaying = false;

		}

		return this;

	}

	stop() {

		if ( this.hasPlaybackControl === false ) {

			console.warn( 'THREE.Audio: this Audio has no playback control.' );
			return;

		}

		this._progress = 0;

		if ( this.source !== null ) {

			this.source.stop();
			this.source.onended = null;

		}

		this.isPlaying = false;

		return this;

	}

	connect() {

		if ( this.filters.length > 0 ) {

			this.source.connect( this.filters[ 0 ] );

			for ( let i = 1, l = this.filters.length; i < l; i ++ ) {

				this.filters[ i - 1 ].connect( this.filters[ i ] );

			}

			this.filters[ this.filters.length - 1 ].connect( this.getOutput() );

		} else {

			this.source.connect( this.getOutput() );

		}

		this._connected = true;

		return this;

	}

	disconnect() {

		if ( this._connected === false ) {

			return;

		}

		if ( this.filters.length > 0 ) {

			this.source.disconnect( this.filters[ 0 ] );

			for ( let i = 1, l = this.filters.length; i < l; i ++ ) {

				this.filters[ i - 1 ].disconnect( this.filters[ i ] );

			}

			this.filters[ this.filters.length - 1 ].disconnect( this.getOutput() );

		} else {

			this.source.disconnect( this.getOutput() );

		}

		this._connected = false;

		return this;

	}

	getFilters() {

		return this.filters;

	}

	setFilters( value ) {

		if ( ! value ) value = [];

		if ( this._connected === true ) {

			this.disconnect();
			this.filters = value.slice();
			this.connect();

		} else {

			this.filters = value.slice();

		}

		return this;

	}

	setDetune( value ) {

		this.detune = value;

		if ( this.isPlaying === true && this.source.detune !== undefined ) {

			this.source.detune.setTargetAtTime( this.detune, this.context.currentTime, 0.01 );

		}

		return this;

	}

	getDetune() {

		return this.detune;

	}

	getFilter() {

		return this.getFilters()[ 0 ];

	}

	setFilter( filter ) {

		return this.setFilters( filter ? [ filter ] : [] );

	}

	setPlaybackRate( value ) {

		if ( this.hasPlaybackControl === false ) {

			console.warn( 'THREE.Audio: this Audio has no playback control.' );
			return;

		}

		this.playbackRate = value;

		if ( this.isPlaying === true ) {

			this.source.playbackRate.setTargetAtTime( this.playbackRate, this.context.currentTime, 0.01 );

		}

		return this;

	}

	getPlaybackRate() {

		return this.playbackRate;

	}

	onEnded() {

		this.isPlaying = false;

	}

	getLoop() {

		if ( this.hasPlaybackControl === false ) {

			console.warn( 'THREE.Audio: this Audio has no playback control.' );
			return false;

		}

		return this.loop;

	}

	setLoop( value ) {

		if ( this.hasPlaybackControl === false ) {

			console.warn( 'THREE.Audio: this Audio has no playback control.' );
			return;

		}

		this.loop = value;

		if ( this.isPlaying === true ) {

			this.source.loop = this.loop;

		}

		return this;

	}

	setLoopStart( value ) {

		this.loopStart = value;

		return this;

	}

	setLoopEnd( value ) {

		this.loopEnd = value;

		return this;

	}

	getVolume() {

		return this.gain.gain.value;

	}

	setVolume( value ) {

		this.gain.gain.setTargetAtTime( value, this.context.currentTime, 0.01 );

		return this;

	}

}

const _position = /*@__PURE__*/ new Vector3();
const _quaternion = /*@__PURE__*/ new Quaternion();
const _scale = /*@__PURE__*/ new Vector3();
const _orientation = /*@__PURE__*/ new Vector3();

class PositionalAudio extends (/* unused pure expression or super */ null && (Audio)) {

	constructor( listener ) {

		super( listener );

		this.panner = this.context.createPanner();
		this.panner.panningModel = 'HRTF';
		this.panner.connect( this.gain );

	}

	connect() {

		super.connect();

		this.panner.connect( this.gain );

	}

	disconnect() {

		super.disconnect();

		this.panner.disconnect( this.gain );

	}

	getOutput() {

		return this.panner;

	}

	getRefDistance() {

		return this.panner.refDistance;

	}

	setRefDistance( value ) {

		this.panner.refDistance = value;

		return this;

	}

	getRolloffFactor() {

		return this.panner.rolloffFactor;

	}

	setRolloffFactor( value ) {

		this.panner.rolloffFactor = value;

		return this;

	}

	getDistanceModel() {

		return this.panner.distanceModel;

	}

	setDistanceModel( value ) {

		this.panner.distanceModel = value;

		return this;

	}

	getMaxDistance() {

		return this.panner.maxDistance;

	}

	setMaxDistance( value ) {

		this.panner.maxDistance = value;

		return this;

	}

	setDirectionalCone( coneInnerAngle, coneOuterAngle, coneOuterGain ) {

		this.panner.coneInnerAngle = coneInnerAngle;
		this.panner.coneOuterAngle = coneOuterAngle;
		this.panner.coneOuterGain = coneOuterGain;

		return this;

	}

	updateMatrixWorld( force ) {

		super.updateMatrixWorld( force );

		if ( this.hasPlaybackControl === true && this.isPlaying === false ) return;

		this.matrixWorld.decompose( _position, _quaternion, _scale );

		_orientation.set( 0, 0, 1 ).applyQuaternion( _quaternion );

		const panner = this.panner;

		if ( panner.positionX ) {

			// code path for Chrome and Firefox (see #14393)

			const endTime = this.context.currentTime + this.listener.timeDelta;

			panner.positionX.linearRampToValueAtTime( _position.x, endTime );
			panner.positionY.linearRampToValueAtTime( _position.y, endTime );
			panner.positionZ.linearRampToValueAtTime( _position.z, endTime );
			panner.orientationX.linearRampToValueAtTime( _orientation.x, endTime );
			panner.orientationY.linearRampToValueAtTime( _orientation.y, endTime );
			panner.orientationZ.linearRampToValueAtTime( _orientation.z, endTime );

		} else {

			panner.setPosition( _position.x, _position.y, _position.z );
			panner.setOrientation( _orientation.x, _orientation.y, _orientation.z );

		}

	}

}

class AudioAnalyser {

	constructor( audio, fftSize = 2048 ) {

		this.analyser = audio.context.createAnalyser();
		this.analyser.fftSize = fftSize;

		this.data = new Uint8Array( this.analyser.frequencyBinCount );

		audio.getOutput().connect( this.analyser );

	}


	getFrequencyData() {

		this.analyser.getByteFrequencyData( this.data );

		return this.data;

	}

	getAverageFrequency() {

		let value = 0;
		const data = this.getFrequencyData();

		for ( let i = 0; i < data.length; i ++ ) {

			value += data[ i ];

		}

		return value / data.length;

	}

}

class PropertyMixer {

	constructor( binding, typeName, valueSize ) {

		this.binding = binding;
		this.valueSize = valueSize;

		let mixFunction,
			mixFunctionAdditive,
			setIdentity;

		// buffer layout: [ incoming | accu0 | accu1 | orig | addAccu | (optional work) ]
		//
		// interpolators can use .buffer as their .result
		// the data then goes to 'incoming'
		//
		// 'accu0' and 'accu1' are used frame-interleaved for
		// the cumulative result and are compared to detect
		// changes
		//
		// 'orig' stores the original state of the property
		//
		// 'add' is used for additive cumulative results
		//
		// 'work' is optional and is only present for quaternion types. It is used
		// to store intermediate quaternion multiplication results

		switch ( typeName ) {

			case 'quaternion':
				mixFunction = this._slerp;
				mixFunctionAdditive = this._slerpAdditive;
				setIdentity = this._setAdditiveIdentityQuaternion;

				this.buffer = new Float64Array( valueSize * 6 );
				this._workIndex = 5;
				break;

			case 'string':
			case 'bool':
				mixFunction = this._select;

				// Use the regular mix function and for additive on these types,
				// additive is not relevant for non-numeric types
				mixFunctionAdditive = this._select;

				setIdentity = this._setAdditiveIdentityOther;

				this.buffer = new Array( valueSize * 5 );
				break;

			default:
				mixFunction = this._lerp;
				mixFunctionAdditive = this._lerpAdditive;
				setIdentity = this._setAdditiveIdentityNumeric;

				this.buffer = new Float64Array( valueSize * 5 );

		}

		this._mixBufferRegion = mixFunction;
		this._mixBufferRegionAdditive = mixFunctionAdditive;
		this._setIdentity = setIdentity;
		this._origIndex = 3;
		this._addIndex = 4;

		this.cumulativeWeight = 0;
		this.cumulativeWeightAdditive = 0;

		this.useCount = 0;
		this.referenceCount = 0;

	}

	// accumulate data in the 'incoming' region into 'accu<i>'
	accumulate( accuIndex, weight ) {

		// note: happily accumulating nothing when weight = 0, the caller knows
		// the weight and shouldn't have made the call in the first place

		const buffer = this.buffer,
			stride = this.valueSize,
			offset = accuIndex * stride + stride;

		let currentWeight = this.cumulativeWeight;

		if ( currentWeight === 0 ) {

			// accuN := incoming * weight

			for ( let i = 0; i !== stride; ++ i ) {

				buffer[ offset + i ] = buffer[ i ];

			}

			currentWeight = weight;

		} else {

			// accuN := accuN + incoming * weight

			currentWeight += weight;
			const mix = weight / currentWeight;
			this._mixBufferRegion( buffer, offset, 0, mix, stride );

		}

		this.cumulativeWeight = currentWeight;

	}

	// accumulate data in the 'incoming' region into 'add'
	accumulateAdditive( weight ) {

		const buffer = this.buffer,
			stride = this.valueSize,
			offset = stride * this._addIndex;

		if ( this.cumulativeWeightAdditive === 0 ) {

			// add = identity

			this._setIdentity();

		}

		// add := add + incoming * weight

		this._mixBufferRegionAdditive( buffer, offset, 0, weight, stride );
		this.cumulativeWeightAdditive += weight;

	}

	// apply the state of 'accu<i>' to the binding when accus differ
	apply( accuIndex ) {

		const stride = this.valueSize,
			buffer = this.buffer,
			offset = accuIndex * stride + stride,

			weight = this.cumulativeWeight,
			weightAdditive = this.cumulativeWeightAdditive,

			binding = this.binding;

		this.cumulativeWeight = 0;
		this.cumulativeWeightAdditive = 0;

		if ( weight < 1 ) {

			// accuN := accuN + original * ( 1 - cumulativeWeight )

			const originalValueOffset = stride * this._origIndex;

			this._mixBufferRegion(
				buffer, offset, originalValueOffset, 1 - weight, stride );

		}

		if ( weightAdditive > 0 ) {

			// accuN := accuN + additive accuN

			this._mixBufferRegionAdditive( buffer, offset, this._addIndex * stride, 1, stride );

		}

		for ( let i = stride, e = stride + stride; i !== e; ++ i ) {

			if ( buffer[ i ] !== buffer[ i + stride ] ) {

				// value has changed -> update scene graph

				binding.setValue( buffer, offset );
				break;

			}

		}

	}

	// remember the state of the bound property and copy it to both accus
	saveOriginalState() {

		const binding = this.binding;

		const buffer = this.buffer,
			stride = this.valueSize,

			originalValueOffset = stride * this._origIndex;

		binding.getValue( buffer, originalValueOffset );

		// accu[0..1] := orig -- initially detect changes against the original
		for ( let i = stride, e = originalValueOffset; i !== e; ++ i ) {

			buffer[ i ] = buffer[ originalValueOffset + ( i % stride ) ];

		}

		// Add to identity for additive
		this._setIdentity();

		this.cumulativeWeight = 0;
		this.cumulativeWeightAdditive = 0;

	}

	// apply the state previously taken via 'saveOriginalState' to the binding
	restoreOriginalState() {

		const originalValueOffset = this.valueSize * 3;
		this.binding.setValue( this.buffer, originalValueOffset );

	}

	_setAdditiveIdentityNumeric() {

		const startIndex = this._addIndex * this.valueSize;
		const endIndex = startIndex + this.valueSize;

		for ( let i = startIndex; i < endIndex; i ++ ) {

			this.buffer[ i ] = 0;

		}

	}

	_setAdditiveIdentityQuaternion() {

		this._setAdditiveIdentityNumeric();
		this.buffer[ this._addIndex * this.valueSize + 3 ] = 1;

	}

	_setAdditiveIdentityOther() {

		const startIndex = this._origIndex * this.valueSize;
		const targetIndex = this._addIndex * this.valueSize;

		for ( let i = 0; i < this.valueSize; i ++ ) {

			this.buffer[ targetIndex + i ] = this.buffer[ startIndex + i ];

		}

	}


	// mix functions

	_select( buffer, dstOffset, srcOffset, t, stride ) {

		if ( t >= 0.5 ) {

			for ( let i = 0; i !== stride; ++ i ) {

				buffer[ dstOffset + i ] = buffer[ srcOffset + i ];

			}

		}

	}

	_slerp( buffer, dstOffset, srcOffset, t ) {

		Quaternion.slerpFlat( buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t );

	}

	_slerpAdditive( buffer, dstOffset, srcOffset, t, stride ) {

		const workOffset = this._workIndex * stride;

		// Store result in intermediate buffer offset
		Quaternion.multiplyQuaternionsFlat( buffer, workOffset, buffer, dstOffset, buffer, srcOffset );

		// Slerp to the intermediate result
		Quaternion.slerpFlat( buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t );

	}

	_lerp( buffer, dstOffset, srcOffset, t, stride ) {

		const s = 1 - t;

		for ( let i = 0; i !== stride; ++ i ) {

			const j = dstOffset + i;

			buffer[ j ] = buffer[ j ] * s + buffer[ srcOffset + i ] * t;

		}

	}

	_lerpAdditive( buffer, dstOffset, srcOffset, t, stride ) {

		for ( let i = 0; i !== stride; ++ i ) {

			const j = dstOffset + i;

			buffer[ j ] = buffer[ j ] + buffer[ srcOffset + i ] * t;

		}

	}

}

// Characters [].:/ are reserved for track binding syntax.
const _RESERVED_CHARS_RE = '\\[\\]\\.:\\/';
const _reservedRe = new RegExp( '[' + _RESERVED_CHARS_RE + ']', 'g' );

// Attempts to allow node names from any language. ES5's `\w` regexp matches
// only latin characters, and the unicode \p{L} is not yet supported. So
// instead, we exclude reserved characters and match everything else.
const _wordChar = '[^' + _RESERVED_CHARS_RE + ']';
const _wordCharOrDot = '[^' + _RESERVED_CHARS_RE.replace( '\\.', '' ) + ']';

// Parent directories, delimited by '/' or ':'. Currently unused, but must
// be matched to parse the rest of the track name.
const _directoryRe = /*@__PURE__*/ /((?:WC+[\/:])*)/.source.replace( 'WC', _wordChar );

// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
const _nodeRe = /*@__PURE__*/ /(WCOD+)?/.source.replace( 'WCOD', _wordCharOrDot );

// Object on target node, and accessor. May not contain reserved
// characters. Accessor may contain any character except closing bracket.
const _objectRe = /*@__PURE__*/ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace( 'WC', _wordChar );

// Property and accessor. May not contain reserved characters. Accessor may
// contain any non-bracket characters.
const _propertyRe = /*@__PURE__*/ /\.(WC+)(?:\[(.+)\])?/.source.replace( 'WC', _wordChar );

const _trackRe = new RegExp( ''
	+ '^'
	+ _directoryRe
	+ _nodeRe
	+ _objectRe
	+ _propertyRe
	+ '$'
);

const _supportedObjectNames = [ 'material', 'materials', 'bones', 'map' ];

class Composite {

	constructor( targetGroup, path, optionalParsedPath ) {

		const parsedPath = optionalParsedPath || PropertyBinding.parseTrackName( path );

		this._targetGroup = targetGroup;
		this._bindings = targetGroup.subscribe_( path, parsedPath );

	}

	getValue( array, offset ) {

		this.bind(); // bind all binding

		const firstValidIndex = this._targetGroup.nCachedObjects_,
			binding = this._bindings[ firstValidIndex ];

		// and only call .getValue on the first
		if ( binding !== undefined ) binding.getValue( array, offset );

	}

	setValue( array, offset ) {

		const bindings = this._bindings;

		for ( let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++ i ) {

			bindings[ i ].setValue( array, offset );

		}

	}

	bind() {

		const bindings = this._bindings;

		for ( let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++ i ) {

			bindings[ i ].bind();

		}

	}

	unbind() {

		const bindings = this._bindings;

		for ( let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++ i ) {

			bindings[ i ].unbind();

		}

	}

}

// Note: This class uses a State pattern on a per-method basis:
// 'bind' sets 'this.getValue' / 'setValue' and shadows the
// prototype version of these methods with one that represents
// the bound state. When the property is not found, the methods
// become no-ops.
class PropertyBinding {

	constructor( rootNode, path, parsedPath ) {

		this.path = path;
		this.parsedPath = parsedPath || PropertyBinding.parseTrackName( path );

		this.node = PropertyBinding.findNode( rootNode, this.parsedPath.nodeName );

		this.rootNode = rootNode;

		// initial state of these methods that calls 'bind'
		this.getValue = this._getValue_unbound;
		this.setValue = this._setValue_unbound;

	}


	static create( root, path, parsedPath ) {

		if ( ! ( root && root.isAnimationObjectGroup ) ) {

			return new PropertyBinding( root, path, parsedPath );

		} else {

			return new PropertyBinding.Composite( root, path, parsedPath );

		}

	}

	/**
	 * Replaces spaces with underscores and removes unsupported characters from
	 * node names, to ensure compatibility with parseTrackName().
	 *
	 * @param {string} name Node name to be sanitized.
	 * @return {string}
	 */
	static sanitizeNodeName( name ) {

		return name.replace( /\s/g, '_' ).replace( _reservedRe, '' );

	}

	static parseTrackName( trackName ) {

		const matches = _trackRe.exec( trackName );

		if ( matches === null ) {

			throw new Error( 'PropertyBinding: Cannot parse trackName: ' + trackName );

		}

		const results = {
			// directoryName: matches[ 1 ], // (tschw) currently unused
			nodeName: matches[ 2 ],
			objectName: matches[ 3 ],
			objectIndex: matches[ 4 ],
			propertyName: matches[ 5 ], // required
			propertyIndex: matches[ 6 ]
		};

		const lastDot = results.nodeName && results.nodeName.lastIndexOf( '.' );

		if ( lastDot !== undefined && lastDot !== - 1 ) {

			const objectName = results.nodeName.substring( lastDot + 1 );

			// Object names must be checked against an allowlist. Otherwise, there
			// is no way to parse 'foo.bar.baz': 'baz' must be a property, but
			// 'bar' could be the objectName, or part of a nodeName (which can
			// include '.' characters).
			if ( _supportedObjectNames.indexOf( objectName ) !== - 1 ) {

				results.nodeName = results.nodeName.substring( 0, lastDot );
				results.objectName = objectName;

			}

		}

		if ( results.propertyName === null || results.propertyName.length === 0 ) {

			throw new Error( 'PropertyBinding: can not parse propertyName from trackName: ' + trackName );

		}

		return results;

	}

	static findNode( root, nodeName ) {

		if ( nodeName === undefined || nodeName === '' || nodeName === '.' || nodeName === - 1 || nodeName === root.name || nodeName === root.uuid ) {

			return root;

		}

		// search into skeleton bones.
		if ( root.skeleton ) {

			const bone = root.skeleton.getBoneByName( nodeName );

			if ( bone !== undefined ) {

				return bone;

			}

		}

		// search into node subtree.
		if ( root.children ) {

			const searchNodeSubtree = function ( children ) {

				for ( let i = 0; i < children.length; i ++ ) {

					const childNode = children[ i ];

					if ( childNode.name === nodeName || childNode.uuid === nodeName ) {

						return childNode;

					}

					const result = searchNodeSubtree( childNode.children );

					if ( result ) return result;

				}

				return null;

			};

			const subTreeNode = searchNodeSubtree( root.children );

			if ( subTreeNode ) {

				return subTreeNode;

			}

		}

		return null;

	}

	// these are used to "bind" a nonexistent property
	_getValue_unavailable() {}
	_setValue_unavailable() {}

	// Getters

	_getValue_direct( buffer, offset ) {

		buffer[ offset ] = this.targetObject[ this.propertyName ];

	}

	_getValue_array( buffer, offset ) {

		const source = this.resolvedProperty;

		for ( let i = 0, n = source.length; i !== n; ++ i ) {

			buffer[ offset ++ ] = source[ i ];

		}

	}

	_getValue_arrayElement( buffer, offset ) {

		buffer[ offset ] = this.resolvedProperty[ this.propertyIndex ];

	}

	_getValue_toArray( buffer, offset ) {

		this.resolvedProperty.toArray( buffer, offset );

	}

	// Direct

	_setValue_direct( buffer, offset ) {

		this.targetObject[ this.propertyName ] = buffer[ offset ];

	}

	_setValue_direct_setNeedsUpdate( buffer, offset ) {

		this.targetObject[ this.propertyName ] = buffer[ offset ];
		this.targetObject.needsUpdate = true;

	}

	_setValue_direct_setMatrixWorldNeedsUpdate( buffer, offset ) {

		this.targetObject[ this.propertyName ] = buffer[ offset ];
		this.targetObject.matrixWorldNeedsUpdate = true;

	}

	// EntireArray

	_setValue_array( buffer, offset ) {

		const dest = this.resolvedProperty;

		for ( let i = 0, n = dest.length; i !== n; ++ i ) {

			dest[ i ] = buffer[ offset ++ ];

		}

	}

	_setValue_array_setNeedsUpdate( buffer, offset ) {

		const dest = this.resolvedProperty;

		for ( let i = 0, n = dest.length; i !== n; ++ i ) {

			dest[ i ] = buffer[ offset ++ ];

		}

		this.targetObject.needsUpdate = true;

	}

	_setValue_array_setMatrixWorldNeedsUpdate( buffer, offset ) {

		const dest = this.resolvedProperty;

		for ( let i = 0, n = dest.length; i !== n; ++ i ) {

			dest[ i ] = buffer[ offset ++ ];

		}

		this.targetObject.matrixWorldNeedsUpdate = true;

	}

	// ArrayElement

	_setValue_arrayElement( buffer, offset ) {

		this.resolvedProperty[ this.propertyIndex ] = buffer[ offset ];

	}

	_setValue_arrayElement_setNeedsUpdate( buffer, offset ) {

		this.resolvedProperty[ this.propertyIndex ] = buffer[ offset ];
		this.targetObject.needsUpdate = true;

	}

	_setValue_arrayElement_setMatrixWorldNeedsUpdate( buffer, offset ) {

		this.resolvedProperty[ this.propertyIndex ] = buffer[ offset ];
		this.targetObject.matrixWorldNeedsUpdate = true;

	}

	// HasToFromArray

	_setValue_fromArray( buffer, offset ) {

		this.resolvedProperty.fromArray( buffer, offset );

	}

	_setValue_fromArray_setNeedsUpdate( buffer, offset ) {

		this.resolvedProperty.fromArray( buffer, offset );
		this.targetObject.needsUpdate = true;

	}

	_setValue_fromArray_setMatrixWorldNeedsUpdate( buffer, offset ) {

		this.resolvedProperty.fromArray( buffer, offset );
		this.targetObject.matrixWorldNeedsUpdate = true;

	}

	_getValue_unbound( targetArray, offset ) {

		this.bind();
		this.getValue( targetArray, offset );

	}

	_setValue_unbound( sourceArray, offset ) {

		this.bind();
		this.setValue( sourceArray, offset );

	}

	// create getter / setter pair for a property in the scene graph
	bind() {

		let targetObject = this.node;
		const parsedPath = this.parsedPath;

		const objectName = parsedPath.objectName;
		const propertyName = parsedPath.propertyName;
		let propertyIndex = parsedPath.propertyIndex;

		if ( ! targetObject ) {

			targetObject = PropertyBinding.findNode( this.rootNode, parsedPath.nodeName );

			this.node = targetObject;

		}

		// set fail state so we can just 'return' on error
		this.getValue = this._getValue_unavailable;
		this.setValue = this._setValue_unavailable;

		// ensure there is a value node
		if ( ! targetObject ) {

			console.warn( 'THREE.PropertyBinding: No target node found for track: ' + this.path + '.' );
			return;

		}

		if ( objectName ) {

			let objectIndex = parsedPath.objectIndex;

			// special cases were we need to reach deeper into the hierarchy to get the face materials....
			switch ( objectName ) {

				case 'materials':

					if ( ! targetObject.material ) {

						console.error( 'THREE.PropertyBinding: Can not bind to material as node does not have a material.', this );
						return;

					}

					if ( ! targetObject.material.materials ) {

						console.error( 'THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.', this );
						return;

					}

					targetObject = targetObject.material.materials;

					break;

				case 'bones':

					if ( ! targetObject.skeleton ) {

						console.error( 'THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.', this );
						return;

					}

					// potential future optimization: skip this if propertyIndex is already an integer
					// and convert the integer string to a true integer.

					targetObject = targetObject.skeleton.bones;

					// support resolving morphTarget names into indices.
					for ( let i = 0; i < targetObject.length; i ++ ) {

						if ( targetObject[ i ].name === objectIndex ) {

							objectIndex = i;
							break;

						}

					}

					break;

				case 'map':

					if ( 'map' in targetObject ) {

						targetObject = targetObject.map;
						break;

					}

					if ( ! targetObject.material ) {

						console.error( 'THREE.PropertyBinding: Can not bind to material as node does not have a material.', this );
						return;

					}

					if ( ! targetObject.material.map ) {

						console.error( 'THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.', this );
						return;

					}

					targetObject = targetObject.material.map;
					break;

				default:

					if ( targetObject[ objectName ] === undefined ) {

						console.error( 'THREE.PropertyBinding: Can not bind to objectName of node undefined.', this );
						return;

					}

					targetObject = targetObject[ objectName ];

			}


			if ( objectIndex !== undefined ) {

				if ( targetObject[ objectIndex ] === undefined ) {

					console.error( 'THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.', this, targetObject );
					return;

				}

				targetObject = targetObject[ objectIndex ];

			}

		}

		// resolve property
		const nodeProperty = targetObject[ propertyName ];

		if ( nodeProperty === undefined ) {

			const nodeName = parsedPath.nodeName;

			console.error( 'THREE.PropertyBinding: Trying to update property for track: ' + nodeName +
				'.' + propertyName + ' but it wasn\'t found.', targetObject );
			return;

		}

		// determine versioning scheme
		let versioning = this.Versioning.None;

		this.targetObject = targetObject;

		if ( targetObject.needsUpdate !== undefined ) { // material

			versioning = this.Versioning.NeedsUpdate;

		} else if ( targetObject.matrixWorldNeedsUpdate !== undefined ) { // node transform

			versioning = this.Versioning.MatrixWorldNeedsUpdate;

		}

		// determine how the property gets bound
		let bindingType = this.BindingType.Direct;

		if ( propertyIndex !== undefined ) {

			// access a sub element of the property array (only primitives are supported right now)

			if ( propertyName === 'morphTargetInfluences' ) {

				// potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.

				// support resolving morphTarget names into indices.
				if ( ! targetObject.geometry ) {

					console.error( 'THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.', this );
					return;

				}

				if ( ! targetObject.geometry.morphAttributes ) {

					console.error( 'THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.', this );
					return;

				}

				if ( targetObject.morphTargetDictionary[ propertyIndex ] !== undefined ) {

					propertyIndex = targetObject.morphTargetDictionary[ propertyIndex ];

				}

			}

			bindingType = this.BindingType.ArrayElement;

			this.resolvedProperty = nodeProperty;
			this.propertyIndex = propertyIndex;

		} else if ( nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined ) {

			// must use copy for Object3D.Euler/Quaternion

			bindingType = this.BindingType.HasFromToArray;

			this.resolvedProperty = nodeProperty;

		} else if ( Array.isArray( nodeProperty ) ) {

			bindingType = this.BindingType.EntireArray;

			this.resolvedProperty = nodeProperty;

		} else {

			this.propertyName = propertyName;

		}

		// select getter / setter
		this.getValue = this.GetterByBindingType[ bindingType ];
		this.setValue = this.SetterByBindingTypeAndVersioning[ bindingType ][ versioning ];

	}

	unbind() {

		this.node = null;

		// back to the prototype version of getValue / setValue
		// note: avoiding to mutate the shape of 'this' via 'delete'
		this.getValue = this._getValue_unbound;
		this.setValue = this._setValue_unbound;

	}

}

PropertyBinding.Composite = Composite;

PropertyBinding.prototype.BindingType = {
	Direct: 0,
	EntireArray: 1,
	ArrayElement: 2,
	HasFromToArray: 3
};

PropertyBinding.prototype.Versioning = {
	None: 0,
	NeedsUpdate: 1,
	MatrixWorldNeedsUpdate: 2
};

PropertyBinding.prototype.GetterByBindingType = [

	PropertyBinding.prototype._getValue_direct,
	PropertyBinding.prototype._getValue_array,
	PropertyBinding.prototype._getValue_arrayElement,
	PropertyBinding.prototype._getValue_toArray,

];

PropertyBinding.prototype.SetterByBindingTypeAndVersioning = [

	[
		// Direct
		PropertyBinding.prototype._setValue_direct,
		PropertyBinding.prototype._setValue_direct_setNeedsUpdate,
		PropertyBinding.prototype._setValue_direct_setMatrixWorldNeedsUpdate,

	], [

		// EntireArray

		PropertyBinding.prototype._setValue_array,
		PropertyBinding.prototype._setValue_array_setNeedsUpdate,
		PropertyBinding.prototype._setValue_array_setMatrixWorldNeedsUpdate,

	], [

		// ArrayElement
		PropertyBinding.prototype._setValue_arrayElement,
		PropertyBinding.prototype._setValue_arrayElement_setNeedsUpdate,
		PropertyBinding.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate,

	], [

		// HasToFromArray
		PropertyBinding.prototype._setValue_fromArray,
		PropertyBinding.prototype._setValue_fromArray_setNeedsUpdate,
		PropertyBinding.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate,

	]

];

/**
 *
 * A group of objects that receives a shared animation state.
 *
 * Usage:
 *
 *  - Add objects you would otherwise pass as 'root' to the
 *    constructor or the .clipAction method of AnimationMixer.
 *
 *  - Instead pass this object as 'root'.
 *
 *  - You can also add and remove objects later when the mixer
 *    is running.
 *
 * Note:
 *
 *    Objects of this class appear as one object to the mixer,
 *    so cache control of the individual objects must be done
 *    on the group.
 *
 * Limitation:
 *
 *  - The animated properties must be compatible among the
 *    all objects in the group.
 *
 *  - A single property can either be controlled through a
 *    target group or directly, but not both.
 */

class AnimationObjectGroup {

	constructor() {

		this.isAnimationObjectGroup = true;

		this.uuid = generateUUID();

		// cached objects followed by the active ones
		this._objects = Array.prototype.slice.call( arguments );

		this.nCachedObjects_ = 0; // threshold
		// note: read by PropertyBinding.Composite

		const indices = {};
		this._indicesByUUID = indices; // for bookkeeping

		for ( let i = 0, n = arguments.length; i !== n; ++ i ) {

			indices[ arguments[ i ].uuid ] = i;

		}

		this._paths = []; // inside: string
		this._parsedPaths = []; // inside: { we don't care, here }
		this._bindings = []; // inside: Array< PropertyBinding >
		this._bindingsIndicesByPath = {}; // inside: indices in these arrays

		const scope = this;

		this.stats = {

			objects: {
				get total() {

					return scope._objects.length;

				},
				get inUse() {

					return this.total - scope.nCachedObjects_;

				}
			},
			get bindingsPerObject() {

				return scope._bindings.length;

			}

		};

	}

	add() {

		const objects = this._objects,
			indicesByUUID = this._indicesByUUID,
			paths = this._paths,
			parsedPaths = this._parsedPaths,
			bindings = this._bindings,
			nBindings = bindings.length;

		let knownObject = undefined,
			nObjects = objects.length,
			nCachedObjects = this.nCachedObjects_;

		for ( let i = 0, n = arguments.length; i !== n; ++ i ) {

			const object = arguments[ i ],
				uuid = object.uuid;
			let index = indicesByUUID[ uuid ];

			if ( index === undefined ) {

				// unknown object -> add it to the ACTIVE region

				index = nObjects ++;
				indicesByUUID[ uuid ] = index;
				objects.push( object );

				// accounting is done, now do the same for all bindings

				for ( let j = 0, m = nBindings; j !== m; ++ j ) {

					bindings[ j ].push( new PropertyBinding( object, paths[ j ], parsedPaths[ j ] ) );

				}

			} else if ( index < nCachedObjects ) {

				knownObject = objects[ index ];

				// move existing object to the ACTIVE region

				const firstActiveIndex = -- nCachedObjects,
					lastCachedObject = objects[ firstActiveIndex ];

				indicesByUUID[ lastCachedObject.uuid ] = index;
				objects[ index ] = lastCachedObject;

				indicesByUUID[ uuid ] = firstActiveIndex;
				objects[ firstActiveIndex ] = object;

				// accounting is done, now do the same for all bindings

				for ( let j = 0, m = nBindings; j !== m; ++ j ) {

					const bindingsForPath = bindings[ j ],
						lastCached = bindingsForPath[ firstActiveIndex ];

					let binding = bindingsForPath[ index ];

					bindingsForPath[ index ] = lastCached;

					if ( binding === undefined ) {

						// since we do not bother to create new bindings
						// for objects that are cached, the binding may
						// or may not exist

						binding = new PropertyBinding( object, paths[ j ], parsedPaths[ j ] );

					}

					bindingsForPath[ firstActiveIndex ] = binding;

				}

			} else if ( objects[ index ] !== knownObject ) {

				console.error( 'THREE.AnimationObjectGroup: Different objects with the same UUID ' +
					'detected. Clean the caches or recreate your infrastructure when reloading scenes.' );

			} // else the object is already where we want it to be

		} // for arguments

		this.nCachedObjects_ = nCachedObjects;

	}

	remove() {

		const objects = this._objects,
			indicesByUUID = this._indicesByUUID,
			bindings = this._bindings,
			nBindings = bindings.length;

		let nCachedObjects = this.nCachedObjects_;

		for ( let i = 0, n = arguments.length; i !== n; ++ i ) {

			const object = arguments[ i ],
				uuid = object.uuid,
				index = indicesByUUID[ uuid ];

			if ( index !== undefined && index >= nCachedObjects ) {

				// move existing object into the CACHED region

				const lastCachedIndex = nCachedObjects ++,
					firstActiveObject = objects[ lastCachedIndex ];

				indicesByUUID[ firstActiveObject.uuid ] = index;
				objects[ index ] = firstActiveObject;

				indicesByUUID[ uuid ] = lastCachedIndex;
				objects[ lastCachedIndex ] = object;

				// accounting is done, now do the same for all bindings

				for ( let j = 0, m = nBindings; j !== m; ++ j ) {

					const bindingsForPath = bindings[ j ],
						firstActive = bindingsForPath[ lastCachedIndex ],
						binding = bindingsForPath[ index ];

					bindingsForPath[ index ] = firstActive;
					bindingsForPath[ lastCachedIndex ] = binding;

				}

			}

		} // for arguments

		this.nCachedObjects_ = nCachedObjects;

	}

	// remove & forget
	uncache() {

		const objects = this._objects,
			indicesByUUID = this._indicesByUUID,
			bindings = this._bindings,
			nBindings = bindings.length;

		let nCachedObjects = this.nCachedObjects_,
			nObjects = objects.length;

		for ( let i = 0, n = arguments.length; i !== n; ++ i ) {

			const object = arguments[ i ],
				uuid = object.uuid,
				index = indicesByUUID[ uuid ];

			if ( index !== undefined ) {

				delete indicesByUUID[ uuid ];

				if ( index < nCachedObjects ) {

					// object is cached, shrink the CACHED region

					const firstActiveIndex = -- nCachedObjects,
						lastCachedObject = objects[ firstActiveIndex ],
						lastIndex = -- nObjects,
						lastObject = objects[ lastIndex ];

					// last cached object takes this object's place
					indicesByUUID[ lastCachedObject.uuid ] = index;
					objects[ index ] = lastCachedObject;

					// last object goes to the activated slot and pop
					indicesByUUID[ lastObject.uuid ] = firstActiveIndex;
					objects[ firstActiveIndex ] = lastObject;
					objects.pop();

					// accounting is done, now do the same for all bindings

					for ( let j = 0, m = nBindings; j !== m; ++ j ) {

						const bindingsForPath = bindings[ j ],
							lastCached = bindingsForPath[ firstActiveIndex ],
							last = bindingsForPath[ lastIndex ];

						bindingsForPath[ index ] = lastCached;
						bindingsForPath[ firstActiveIndex ] = last;
						bindingsForPath.pop();

					}

				} else {

					// object is active, just swap with the last and pop

					const lastIndex = -- nObjects,
						lastObject = objects[ lastIndex ];

					if ( lastIndex > 0 ) {

						indicesByUUID[ lastObject.uuid ] = index;

					}

					objects[ index ] = lastObject;
					objects.pop();

					// accounting is done, now do the same for all bindings

					for ( let j = 0, m = nBindings; j !== m; ++ j ) {

						const bindingsForPath = bindings[ j ];

						bindingsForPath[ index ] = bindingsForPath[ lastIndex ];
						bindingsForPath.pop();

					}

				} // cached or active

			} // if object is known

		} // for arguments

		this.nCachedObjects_ = nCachedObjects;

	}

	// Internal interface used by befriended PropertyBinding.Composite:

	subscribe_( path, parsedPath ) {

		// returns an array of bindings for the given path that is changed
		// according to the contained objects in the group

		const indicesByPath = this._bindingsIndicesByPath;
		let index = indicesByPath[ path ];
		const bindings = this._bindings;

		if ( index !== undefined ) return bindings[ index ];

		const paths = this._paths,
			parsedPaths = this._parsedPaths,
			objects = this._objects,
			nObjects = objects.length,
			nCachedObjects = this.nCachedObjects_,
			bindingsForPath = new Array( nObjects );

		index = bindings.length;

		indicesByPath[ path ] = index;

		paths.push( path );
		parsedPaths.push( parsedPath );
		bindings.push( bindingsForPath );

		for ( let i = nCachedObjects, n = objects.length; i !== n; ++ i ) {

			const object = objects[ i ];
			bindingsForPath[ i ] = new PropertyBinding( object, path, parsedPath );

		}

		return bindingsForPath;

	}

	unsubscribe_( path ) {

		// tells the group to forget about a property path and no longer
		// update the array previously obtained with 'subscribe_'

		const indicesByPath = this._bindingsIndicesByPath,
			index = indicesByPath[ path ];

		if ( index !== undefined ) {

			const paths = this._paths,
				parsedPaths = this._parsedPaths,
				bindings = this._bindings,
				lastBindingsIndex = bindings.length - 1,
				lastBindings = bindings[ lastBindingsIndex ],
				lastBindingsPath = path[ lastBindingsIndex ];

			indicesByPath[ lastBindingsPath ] = index;

			bindings[ index ] = lastBindings;
			bindings.pop();

			parsedPaths[ index ] = parsedPaths[ lastBindingsIndex ];
			parsedPaths.pop();

			paths[ index ] = paths[ lastBindingsIndex ];
			paths.pop();

		}

	}

}

class AnimationAction {

	constructor( mixer, clip, localRoot = null, blendMode = clip.blendMode ) {

		this._mixer = mixer;
		this._clip = clip;
		this._localRoot = localRoot;
		this.blendMode = blendMode;

		const tracks = clip.tracks,
			nTracks = tracks.length,
			interpolants = new Array( nTracks );

		const interpolantSettings = {
			endingStart: ZeroCurvatureEnding,
			endingEnd: ZeroCurvatureEnding
		};

		for ( let i = 0; i !== nTracks; ++ i ) {

			const interpolant = tracks[ i ].createInterpolant( null );
			interpolants[ i ] = interpolant;
			interpolant.settings = interpolantSettings;

		}

		this._interpolantSettings = interpolantSettings;

		this._interpolants = interpolants; // bound by the mixer

		// inside: PropertyMixer (managed by the mixer)
		this._propertyBindings = new Array( nTracks );

		this._cacheIndex = null; // for the memory manager
		this._byClipCacheIndex = null; // for the memory manager

		this._timeScaleInterpolant = null;
		this._weightInterpolant = null;

		this.loop = LoopRepeat;
		this._loopCount = - 1;

		// global mixer time when the action is to be started
		// it's set back to 'null' upon start of the action
		this._startTime = null;

		// scaled local time of the action
		// gets clamped or wrapped to 0..clip.duration according to loop
		this.time = 0;

		this.timeScale = 1;
		this._effectiveTimeScale = 1;

		this.weight = 1;
		this._effectiveWeight = 1;

		this.repetitions = Infinity; // no. of repetitions when looping

		this.paused = false; // true -> zero effective time scale
		this.enabled = true; // false -> zero effective weight

		this.clampWhenFinished = false;// keep feeding the last frame?

		this.zeroSlopeAtStart = true;// for smooth interpolation w/o separate
		this.zeroSlopeAtEnd = true;// clips for start, loop and end

	}

	// State & Scheduling

	play() {

		this._mixer._activateAction( this );

		return this;

	}

	stop() {

		this._mixer._deactivateAction( this );

		return this.reset();

	}

	reset() {

		this.paused = false;
		this.enabled = true;

		this.time = 0; // restart clip
		this._loopCount = - 1;// forget previous loops
		this._startTime = null;// forget scheduling

		return this.stopFading().stopWarping();

	}

	isRunning() {

		return this.enabled && ! this.paused && this.timeScale !== 0 &&
			this._startTime === null && this._mixer._isActiveAction( this );

	}

	// return true when play has been called
	isScheduled() {

		return this._mixer._isActiveAction( this );

	}

	startAt( time ) {

		this._startTime = time;

		return this;

	}

	setLoop( mode, repetitions ) {

		this.loop = mode;
		this.repetitions = repetitions;

		return this;

	}

	// Weight

	// set the weight stopping any scheduled fading
	// although .enabled = false yields an effective weight of zero, this
	// method does *not* change .enabled, because it would be confusing
	setEffectiveWeight( weight ) {

		this.weight = weight;

		// note: same logic as when updated at runtime
		this._effectiveWeight = this.enabled ? weight : 0;

		return this.stopFading();

	}

	// return the weight considering fading and .enabled
	getEffectiveWeight() {

		return this._effectiveWeight;

	}

	fadeIn( duration ) {

		return this._scheduleFading( duration, 0, 1 );

	}

	fadeOut( duration ) {

		return this._scheduleFading( duration, 1, 0 );

	}

	crossFadeFrom( fadeOutAction, duration, warp ) {

		fadeOutAction.fadeOut( duration );
		this.fadeIn( duration );

		if ( warp ) {

			const fadeInDuration = this._clip.duration,
				fadeOutDuration = fadeOutAction._clip.duration,

				startEndRatio = fadeOutDuration / fadeInDuration,
				endStartRatio = fadeInDuration / fadeOutDuration;

			fadeOutAction.warp( 1.0, startEndRatio, duration );
			this.warp( endStartRatio, 1.0, duration );

		}

		return this;

	}

	crossFadeTo( fadeInAction, duration, warp ) {

		return fadeInAction.crossFadeFrom( this, duration, warp );

	}

	stopFading() {

		const weightInterpolant = this._weightInterpolant;

		if ( weightInterpolant !== null ) {

			this._weightInterpolant = null;
			this._mixer._takeBackControlInterpolant( weightInterpolant );

		}

		return this;

	}

	// Time Scale Control

	// set the time scale stopping any scheduled warping
	// although .paused = true yields an effective time scale of zero, this
	// method does *not* change .paused, because it would be confusing
	setEffectiveTimeScale( timeScale ) {

		this.timeScale = timeScale;
		this._effectiveTimeScale = this.paused ? 0 : timeScale;

		return this.stopWarping();

	}

	// return the time scale considering warping and .paused
	getEffectiveTimeScale() {

		return this._effectiveTimeScale;

	}

	setDuration( duration ) {

		this.timeScale = this._clip.duration / duration;

		return this.stopWarping();

	}

	syncWith( action ) {

		this.time = action.time;
		this.timeScale = action.timeScale;

		return this.stopWarping();

	}

	halt( duration ) {

		return this.warp( this._effectiveTimeScale, 0, duration );

	}

	warp( startTimeScale, endTimeScale, duration ) {

		const mixer = this._mixer,
			now = mixer.time,
			timeScale = this.timeScale;

		let interpolant = this._timeScaleInterpolant;

		if ( interpolant === null ) {

			interpolant = mixer._lendControlInterpolant();
			this._timeScaleInterpolant = interpolant;

		}

		const times = interpolant.parameterPositions,
			values = interpolant.sampleValues;

		times[ 0 ] = now;
		times[ 1 ] = now + duration;

		values[ 0 ] = startTimeScale / timeScale;
		values[ 1 ] = endTimeScale / timeScale;

		return this;

	}

	stopWarping() {

		const timeScaleInterpolant = this._timeScaleInterpolant;

		if ( timeScaleInterpolant !== null ) {

			this._timeScaleInterpolant = null;
			this._mixer._takeBackControlInterpolant( timeScaleInterpolant );

		}

		return this;

	}

	// Object Accessors

	getMixer() {

		return this._mixer;

	}

	getClip() {

		return this._clip;

	}

	getRoot() {

		return this._localRoot || this._mixer._root;

	}

	// Interna

	_update( time, deltaTime, timeDirection, accuIndex ) {

		// called by the mixer

		if ( ! this.enabled ) {

			// call ._updateWeight() to update ._effectiveWeight

			this._updateWeight( time );
			return;

		}

		const startTime = this._startTime;

		if ( startTime !== null ) {

			// check for scheduled start of action

			const timeRunning = ( time - startTime ) * timeDirection;
			if ( timeRunning < 0 || timeDirection === 0 ) {

				deltaTime = 0;

			} else {


				this._startTime = null; // unschedule
				deltaTime = timeDirection * timeRunning;

			}

		}

		// apply time scale and advance time

		deltaTime *= this._updateTimeScale( time );
		const clipTime = this._updateTime( deltaTime );

		// note: _updateTime may disable the action resulting in
		// an effective weight of 0

		const weight = this._updateWeight( time );

		if ( weight > 0 ) {

			const interpolants = this._interpolants;
			const propertyMixers = this._propertyBindings;

			switch ( this.blendMode ) {

				case AdditiveAnimationBlendMode:

					for ( let j = 0, m = interpolants.length; j !== m; ++ j ) {

						interpolants[ j ].evaluate( clipTime );
						propertyMixers[ j ].accumulateAdditive( weight );

					}

					break;

				case NormalAnimationBlendMode:
				default:

					for ( let j = 0, m = interpolants.length; j !== m; ++ j ) {

						interpolants[ j ].evaluate( clipTime );
						propertyMixers[ j ].accumulate( accuIndex, weight );

					}

			}

		}

	}

	_updateWeight( time ) {

		let weight = 0;

		if ( this.enabled ) {

			weight = this.weight;
			const interpolant = this._weightInterpolant;

			if ( interpolant !== null ) {

				const interpolantValue = interpolant.evaluate( time )[ 0 ];

				weight *= interpolantValue;

				if ( time > interpolant.parameterPositions[ 1 ] ) {

					this.stopFading();

					if ( interpolantValue === 0 ) {

						// faded out, disable
						this.enabled = false;

					}

				}

			}

		}

		this._effectiveWeight = weight;
		return weight;

	}

	_updateTimeScale( time ) {

		let timeScale = 0;

		if ( ! this.paused ) {

			timeScale = this.timeScale;

			const interpolant = this._timeScaleInterpolant;

			if ( interpolant !== null ) {

				const interpolantValue = interpolant.evaluate( time )[ 0 ];

				timeScale *= interpolantValue;

				if ( time > interpolant.parameterPositions[ 1 ] ) {

					this.stopWarping();

					if ( timeScale === 0 ) {

						// motion has halted, pause
						this.paused = true;

					} else {

						// warp done - apply final time scale
						this.timeScale = timeScale;

					}

				}

			}

		}

		this._effectiveTimeScale = timeScale;
		return timeScale;

	}

	_updateTime( deltaTime ) {

		const duration = this._clip.duration;
		const loop = this.loop;

		let time = this.time + deltaTime;
		let loopCount = this._loopCount;

		const pingPong = ( loop === LoopPingPong );

		if ( deltaTime === 0 ) {

			if ( loopCount === - 1 ) return time;

			return ( pingPong && ( loopCount & 1 ) === 1 ) ? duration - time : time;

		}

		if ( loop === LoopOnce ) {

			if ( loopCount === - 1 ) {

				// just started

				this._loopCount = 0;
				this._setEndings( true, true, false );

			}

			handle_stop: {

				if ( time >= duration ) {

					time = duration;

				} else if ( time < 0 ) {

					time = 0;

				} else {

					this.time = time;

					break handle_stop;

				}

				if ( this.clampWhenFinished ) this.paused = true;
				else this.enabled = false;

				this.time = time;

				this._mixer.dispatchEvent( {
					type: 'finished', action: this,
					direction: deltaTime < 0 ? - 1 : 1
				} );

			}

		} else { // repetitive Repeat or PingPong

			if ( loopCount === - 1 ) {

				// just started

				if ( deltaTime >= 0 ) {

					loopCount = 0;

					this._setEndings( true, this.repetitions === 0, pingPong );

				} else {

					// when looping in reverse direction, the initial
					// transition through zero counts as a repetition,
					// so leave loopCount at -1

					this._setEndings( this.repetitions === 0, true, pingPong );

				}

			}

			if ( time >= duration || time < 0 ) {

				// wrap around

				const loopDelta = Math.floor( time / duration ); // signed
				time -= duration * loopDelta;

				loopCount += Math.abs( loopDelta );

				const pending = this.repetitions - loopCount;

				if ( pending <= 0 ) {

					// have to stop (switch state, clamp time, fire event)

					if ( this.clampWhenFinished ) this.paused = true;
					else this.enabled = false;

					time = deltaTime > 0 ? duration : 0;

					this.time = time;

					this._mixer.dispatchEvent( {
						type: 'finished', action: this,
						direction: deltaTime > 0 ? 1 : - 1
					} );

				} else {

					// keep running

					if ( pending === 1 ) {

						// entering the last round

						const atStart = deltaTime < 0;
						this._setEndings( atStart, ! atStart, pingPong );

					} else {

						this._setEndings( false, false, pingPong );

					}

					this._loopCount = loopCount;

					this.time = time;

					this._mixer.dispatchEvent( {
						type: 'loop', action: this, loopDelta: loopDelta
					} );

				}

			} else {

				this.time = time;

			}

			if ( pingPong && ( loopCount & 1 ) === 1 ) {

				// invert time for the "pong round"

				return duration - time;

			}

		}

		return time;

	}

	_setEndings( atStart, atEnd, pingPong ) {

		const settings = this._interpolantSettings;

		if ( pingPong ) {

			settings.endingStart = ZeroSlopeEnding;
			settings.endingEnd = ZeroSlopeEnding;

		} else {

			// assuming for LoopOnce atStart == atEnd == true

			if ( atStart ) {

				settings.endingStart = this.zeroSlopeAtStart ? ZeroSlopeEnding : ZeroCurvatureEnding;

			} else {

				settings.endingStart = WrapAroundEnding;

			}

			if ( atEnd ) {

				settings.endingEnd = this.zeroSlopeAtEnd ? ZeroSlopeEnding : ZeroCurvatureEnding;

			} else {

				settings.endingEnd 	 = WrapAroundEnding;

			}

		}

	}

	_scheduleFading( duration, weightNow, weightThen ) {

		const mixer = this._mixer, now = mixer.time;
		let interpolant = this._weightInterpolant;

		if ( interpolant === null ) {

			interpolant = mixer._lendControlInterpolant();
			this._weightInterpolant = interpolant;

		}

		const times = interpolant.parameterPositions,
			values = interpolant.sampleValues;

		times[ 0 ] = now;
		values[ 0 ] = weightNow;
		times[ 1 ] = now + duration;
		values[ 1 ] = weightThen;

		return this;

	}

}

const _controlInterpolantsResultBuffer = new Float32Array( 1 );


class AnimationMixer extends EventDispatcher {

	constructor( root ) {

		super();

		this._root = root;
		this._initMemoryManager();
		this._accuIndex = 0;
		this.time = 0;
		this.timeScale = 1.0;

	}

	_bindAction( action, prototypeAction ) {

		const root = action._localRoot || this._root,
			tracks = action._clip.tracks,
			nTracks = tracks.length,
			bindings = action._propertyBindings,
			interpolants = action._interpolants,
			rootUuid = root.uuid,
			bindingsByRoot = this._bindingsByRootAndName;

		let bindingsByName = bindingsByRoot[ rootUuid ];

		if ( bindingsByName === undefined ) {

			bindingsByName = {};
			bindingsByRoot[ rootUuid ] = bindingsByName;

		}

		for ( let i = 0; i !== nTracks; ++ i ) {

			const track = tracks[ i ],
				trackName = track.name;

			let binding = bindingsByName[ trackName ];

			if ( binding !== undefined ) {

				++ binding.referenceCount;
				bindings[ i ] = binding;

			} else {

				binding = bindings[ i ];

				if ( binding !== undefined ) {

					// existing binding, make sure the cache knows

					if ( binding._cacheIndex === null ) {

						++ binding.referenceCount;
						this._addInactiveBinding( binding, rootUuid, trackName );

					}

					continue;

				}

				const path = prototypeAction && prototypeAction.
					_propertyBindings[ i ].binding.parsedPath;

				binding = new PropertyMixer(
					PropertyBinding.create( root, trackName, path ),
					track.ValueTypeName, track.getValueSize() );

				++ binding.referenceCount;
				this._addInactiveBinding( binding, rootUuid, trackName );

				bindings[ i ] = binding;

			}

			interpolants[ i ].resultBuffer = binding.buffer;

		}

	}

	_activateAction( action ) {

		if ( ! this._isActiveAction( action ) ) {

			if ( action._cacheIndex === null ) {

				// this action has been forgotten by the cache, but the user
				// appears to be still using it -> rebind

				const rootUuid = ( action._localRoot || this._root ).uuid,
					clipUuid = action._clip.uuid,
					actionsForClip = this._actionsByClip[ clipUuid ];

				this._bindAction( action,
					actionsForClip && actionsForClip.knownActions[ 0 ] );

				this._addInactiveAction( action, clipUuid, rootUuid );

			}

			const bindings = action._propertyBindings;

			// increment reference counts / sort out state
			for ( let i = 0, n = bindings.length; i !== n; ++ i ) {

				const binding = bindings[ i ];

				if ( binding.useCount ++ === 0 ) {

					this._lendBinding( binding );
					binding.saveOriginalState();

				}

			}

			this._lendAction( action );

		}

	}

	_deactivateAction( action ) {

		if ( this._isActiveAction( action ) ) {

			const bindings = action._propertyBindings;

			// decrement reference counts / sort out state
			for ( let i = 0, n = bindings.length; i !== n; ++ i ) {

				const binding = bindings[ i ];

				if ( -- binding.useCount === 0 ) {

					binding.restoreOriginalState();
					this._takeBackBinding( binding );

				}

			}

			this._takeBackAction( action );

		}

	}

	// Memory manager

	_initMemoryManager() {

		this._actions = []; // 'nActiveActions' followed by inactive ones
		this._nActiveActions = 0;

		this._actionsByClip = {};
		// inside:
		// {
		// 	knownActions: Array< AnimationAction > - used as prototypes
		// 	actionByRoot: AnimationAction - lookup
		// }


		this._bindings = []; // 'nActiveBindings' followed by inactive ones
		this._nActiveBindings = 0;

		this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >


		this._controlInterpolants = []; // same game as above
		this._nActiveControlInterpolants = 0;

		const scope = this;

		this.stats = {

			actions: {
				get total() {

					return scope._actions.length;

				},
				get inUse() {

					return scope._nActiveActions;

				}
			},
			bindings: {
				get total() {

					return scope._bindings.length;

				},
				get inUse() {

					return scope._nActiveBindings;

				}
			},
			controlInterpolants: {
				get total() {

					return scope._controlInterpolants.length;

				},
				get inUse() {

					return scope._nActiveControlInterpolants;

				}
			}

		};

	}

	// Memory management for AnimationAction objects

	_isActiveAction( action ) {

		const index = action._cacheIndex;
		return index !== null && index < this._nActiveActions;

	}

	_addInactiveAction( action, clipUuid, rootUuid ) {

		const actions = this._actions,
			actionsByClip = this._actionsByClip;

		let actionsForClip = actionsByClip[ clipUuid ];

		if ( actionsForClip === undefined ) {

			actionsForClip = {

				knownActions: [ action ],
				actionByRoot: {}

			};

			action._byClipCacheIndex = 0;

			actionsByClip[ clipUuid ] = actionsForClip;

		} else {

			const knownActions = actionsForClip.knownActions;

			action._byClipCacheIndex = knownActions.length;
			knownActions.push( action );

		}

		action._cacheIndex = actions.length;
		actions.push( action );

		actionsForClip.actionByRoot[ rootUuid ] = action;

	}

	_removeInactiveAction( action ) {

		const actions = this._actions,
			lastInactiveAction = actions[ actions.length - 1 ],
			cacheIndex = action._cacheIndex;

		lastInactiveAction._cacheIndex = cacheIndex;
		actions[ cacheIndex ] = lastInactiveAction;
		actions.pop();

		action._cacheIndex = null;


		const clipUuid = action._clip.uuid,
			actionsByClip = this._actionsByClip,
			actionsForClip = actionsByClip[ clipUuid ],
			knownActionsForClip = actionsForClip.knownActions,

			lastKnownAction =
				knownActionsForClip[ knownActionsForClip.length - 1 ],

			byClipCacheIndex = action._byClipCacheIndex;

		lastKnownAction._byClipCacheIndex = byClipCacheIndex;
		knownActionsForClip[ byClipCacheIndex ] = lastKnownAction;
		knownActionsForClip.pop();

		action._byClipCacheIndex = null;


		const actionByRoot = actionsForClip.actionByRoot,
			rootUuid = ( action._localRoot || this._root ).uuid;

		delete actionByRoot[ rootUuid ];

		if ( knownActionsForClip.length === 0 ) {

			delete actionsByClip[ clipUuid ];

		}

		this._removeInactiveBindingsForAction( action );

	}

	_removeInactiveBindingsForAction( action ) {

		const bindings = action._propertyBindings;

		for ( let i = 0, n = bindings.length; i !== n; ++ i ) {

			const binding = bindings[ i ];

			if ( -- binding.referenceCount === 0 ) {

				this._removeInactiveBinding( binding );

			}

		}

	}

	_lendAction( action ) {

		// [ active actions |  inactive actions  ]
		// [  active actions >| inactive actions ]
		//                 s        a
		//                  <-swap->
		//                 a        s

		const actions = this._actions,
			prevIndex = action._cacheIndex,

			lastActiveIndex = this._nActiveActions ++,

			firstInactiveAction = actions[ lastActiveIndex ];

		action._cacheIndex = lastActiveIndex;
		actions[ lastActiveIndex ] = action;

		firstInactiveAction._cacheIndex = prevIndex;
		actions[ prevIndex ] = firstInactiveAction;

	}

	_takeBackAction( action ) {

		// [  active actions  | inactive actions ]
		// [ active actions |< inactive actions  ]
		//        a        s
		//         <-swap->
		//        s        a

		const actions = this._actions,
			prevIndex = action._cacheIndex,

			firstInactiveIndex = -- this._nActiveActions,

			lastActiveAction = actions[ firstInactiveIndex ];

		action._cacheIndex = firstInactiveIndex;
		actions[ firstInactiveIndex ] = action;

		lastActiveAction._cacheIndex = prevIndex;
		actions[ prevIndex ] = lastActiveAction;

	}

	// Memory management for PropertyMixer objects

	_addInactiveBinding( binding, rootUuid, trackName ) {

		const bindingsByRoot = this._bindingsByRootAndName,
			bindings = this._bindings;

		let bindingByName = bindingsByRoot[ rootUuid ];

		if ( bindingByName === undefined ) {

			bindingByName = {};
			bindingsByRoot[ rootUuid ] = bindingByName;

		}

		bindingByName[ trackName ] = binding;

		binding._cacheIndex = bindings.length;
		bindings.push( binding );

	}

	_removeInactiveBinding( binding ) {

		const bindings = this._bindings,
			propBinding = binding.binding,
			rootUuid = propBinding.rootNode.uuid,
			trackName = propBinding.path,
			bindingsByRoot = this._bindingsByRootAndName,
			bindingByName = bindingsByRoot[ rootUuid ],

			lastInactiveBinding = bindings[ bindings.length - 1 ],
			cacheIndex = binding._cacheIndex;

		lastInactiveBinding._cacheIndex = cacheIndex;
		bindings[ cacheIndex ] = lastInactiveBinding;
		bindings.pop();

		delete bindingByName[ trackName ];

		if ( Object.keys( bindingByName ).length === 0 ) {

			delete bindingsByRoot[ rootUuid ];

		}

	}

	_lendBinding( binding ) {

		const bindings = this._bindings,
			prevIndex = binding._cacheIndex,

			lastActiveIndex = this._nActiveBindings ++,

			firstInactiveBinding = bindings[ lastActiveIndex ];

		binding._cacheIndex = lastActiveIndex;
		bindings[ lastActiveIndex ] = binding;

		firstInactiveBinding._cacheIndex = prevIndex;
		bindings[ prevIndex ] = firstInactiveBinding;

	}

	_takeBackBinding( binding ) {

		const bindings = this._bindings,
			prevIndex = binding._cacheIndex,

			firstInactiveIndex = -- this._nActiveBindings,

			lastActiveBinding = bindings[ firstInactiveIndex ];

		binding._cacheIndex = firstInactiveIndex;
		bindings[ firstInactiveIndex ] = binding;

		lastActiveBinding._cacheIndex = prevIndex;
		bindings[ prevIndex ] = lastActiveBinding;

	}


	// Memory management of Interpolants for weight and time scale

	_lendControlInterpolant() {

		const interpolants = this._controlInterpolants,
			lastActiveIndex = this._nActiveControlInterpolants ++;

		let interpolant = interpolants[ lastActiveIndex ];

		if ( interpolant === undefined ) {

			interpolant = new LinearInterpolant(
				new Float32Array( 2 ), new Float32Array( 2 ),
				1, _controlInterpolantsResultBuffer );

			interpolant.__cacheIndex = lastActiveIndex;
			interpolants[ lastActiveIndex ] = interpolant;

		}

		return interpolant;

	}

	_takeBackControlInterpolant( interpolant ) {

		const interpolants = this._controlInterpolants,
			prevIndex = interpolant.__cacheIndex,

			firstInactiveIndex = -- this._nActiveControlInterpolants,

			lastActiveInterpolant = interpolants[ firstInactiveIndex ];

		interpolant.__cacheIndex = firstInactiveIndex;
		interpolants[ firstInactiveIndex ] = interpolant;

		lastActiveInterpolant.__cacheIndex = prevIndex;
		interpolants[ prevIndex ] = lastActiveInterpolant;

	}

	// return an action for a clip optionally using a custom root target
	// object (this method allocates a lot of dynamic memory in case a
	// previously unknown clip/root combination is specified)
	clipAction( clip, optionalRoot, blendMode ) {

		const root = optionalRoot || this._root,
			rootUuid = root.uuid;

		let clipObject = typeof clip === 'string' ? AnimationClip.findByName( root, clip ) : clip;

		const clipUuid = clipObject !== null ? clipObject.uuid : clip;

		const actionsForClip = this._actionsByClip[ clipUuid ];
		let prototypeAction = null;

		if ( blendMode === undefined ) {

			if ( clipObject !== null ) {

				blendMode = clipObject.blendMode;

			} else {

				blendMode = NormalAnimationBlendMode;

			}

		}

		if ( actionsForClip !== undefined ) {

			const existingAction = actionsForClip.actionByRoot[ rootUuid ];

			if ( existingAction !== undefined && existingAction.blendMode === blendMode ) {

				return existingAction;

			}

			// we know the clip, so we don't have to parse all
			// the bindings again but can just copy
			prototypeAction = actionsForClip.knownActions[ 0 ];

			// also, take the clip from the prototype action
			if ( clipObject === null )
				clipObject = prototypeAction._clip;

		}

		// clip must be known when specified via string
		if ( clipObject === null ) return null;

		// allocate all resources required to run it
		const newAction = new AnimationAction( this, clipObject, optionalRoot, blendMode );

		this._bindAction( newAction, prototypeAction );

		// and make the action known to the memory manager
		this._addInactiveAction( newAction, clipUuid, rootUuid );

		return newAction;

	}

	// get an existing action
	existingAction( clip, optionalRoot ) {

		const root = optionalRoot || this._root,
			rootUuid = root.uuid,

			clipObject = typeof clip === 'string' ?
				AnimationClip.findByName( root, clip ) : clip,

			clipUuid = clipObject ? clipObject.uuid : clip,

			actionsForClip = this._actionsByClip[ clipUuid ];

		if ( actionsForClip !== undefined ) {

			return actionsForClip.actionByRoot[ rootUuid ] || null;

		}

		return null;

	}

	// deactivates all previously scheduled actions
	stopAllAction() {

		const actions = this._actions,
			nActions = this._nActiveActions;

		for ( let i = nActions - 1; i >= 0; -- i ) {

			actions[ i ].stop();

		}

		return this;

	}

	// advance the time and update apply the animation
	update( deltaTime ) {

		deltaTime *= this.timeScale;

		const actions = this._actions,
			nActions = this._nActiveActions,

			time = this.time += deltaTime,
			timeDirection = Math.sign( deltaTime ),

			accuIndex = this._accuIndex ^= 1;

		// run active actions

		for ( let i = 0; i !== nActions; ++ i ) {

			const action = actions[ i ];

			action._update( time, deltaTime, timeDirection, accuIndex );

		}

		// update scene graph

		const bindings = this._bindings,
			nBindings = this._nActiveBindings;

		for ( let i = 0; i !== nBindings; ++ i ) {

			bindings[ i ].apply( accuIndex );

		}

		return this;

	}

	// Allows you to seek to a specific time in an animation.
	setTime( timeInSeconds ) {

		this.time = 0; // Zero out time attribute for AnimationMixer object;
		for ( let i = 0; i < this._actions.length; i ++ ) {

			this._actions[ i ].time = 0; // Zero out time attribute for all associated AnimationAction objects.

		}

		return this.update( timeInSeconds ); // Update used to set exact time. Returns "this" AnimationMixer object.

	}

	// return this mixer's root target object
	getRoot() {

		return this._root;

	}

	// free all resources specific to a particular clip
	uncacheClip( clip ) {

		const actions = this._actions,
			clipUuid = clip.uuid,
			actionsByClip = this._actionsByClip,
			actionsForClip = actionsByClip[ clipUuid ];

		if ( actionsForClip !== undefined ) {

			// note: just calling _removeInactiveAction would mess up the
			// iteration state and also require updating the state we can
			// just throw away

			const actionsToRemove = actionsForClip.knownActions;

			for ( let i = 0, n = actionsToRemove.length; i !== n; ++ i ) {

				const action = actionsToRemove[ i ];

				this._deactivateAction( action );

				const cacheIndex = action._cacheIndex,
					lastInactiveAction = actions[ actions.length - 1 ];

				action._cacheIndex = null;
				action._byClipCacheIndex = null;

				lastInactiveAction._cacheIndex = cacheIndex;
				actions[ cacheIndex ] = lastInactiveAction;
				actions.pop();

				this._removeInactiveBindingsForAction( action );

			}

			delete actionsByClip[ clipUuid ];

		}

	}

	// free all resources specific to a particular root target object
	uncacheRoot( root ) {

		const rootUuid = root.uuid,
			actionsByClip = this._actionsByClip;

		for ( const clipUuid in actionsByClip ) {

			const actionByRoot = actionsByClip[ clipUuid ].actionByRoot,
				action = actionByRoot[ rootUuid ];

			if ( action !== undefined ) {

				this._deactivateAction( action );
				this._removeInactiveAction( action );

			}

		}

		const bindingsByRoot = this._bindingsByRootAndName,
			bindingByName = bindingsByRoot[ rootUuid ];

		if ( bindingByName !== undefined ) {

			for ( const trackName in bindingByName ) {

				const binding = bindingByName[ trackName ];
				binding.restoreOriginalState();
				this._removeInactiveBinding( binding );

			}

		}

	}

	// remove a targeted clip from the cache
	uncacheAction( clip, optionalRoot ) {

		const action = this.existingAction( clip, optionalRoot );

		if ( action !== null ) {

			this._deactivateAction( action );
			this._removeInactiveAction( action );

		}

	}

}

class Uniform {

	constructor( value ) {

		this.value = value;

	}

	clone() {

		return new Uniform( this.value.clone === undefined ? this.value : this.value.clone() );

	}

}

let _id = 0;

class UniformsGroup extends (/* unused pure expression or super */ null && (EventDispatcher)) {

	constructor() {

		super();

		this.isUniformsGroup = true;

		Object.defineProperty( this, 'id', { value: _id ++ } );

		this.name = '';

		this.usage = StaticDrawUsage;
		this.uniforms = [];

	}

	add( uniform ) {

		this.uniforms.push( uniform );

		return this;

	}

	remove( uniform ) {

		const index = this.uniforms.indexOf( uniform );

		if ( index !== - 1 ) this.uniforms.splice( index, 1 );

		return this;

	}

	setName( name ) {

		this.name = name;

		return this;

	}

	setUsage( value ) {

		this.usage = value;

		return this;

	}

	dispose() {

		this.dispatchEvent( { type: 'dispose' } );

		return this;

	}

	copy( source ) {

		this.name = source.name;
		this.usage = source.usage;

		const uniformsSource = source.uniforms;

		this.uniforms.length = 0;

		for ( let i = 0, l = uniformsSource.length; i < l; i ++ ) {

			const uniforms = Array.isArray( uniformsSource[ i ] ) ? uniformsSource[ i ] : [ uniformsSource[ i ] ];

			for ( let j = 0; j < uniforms.length; j ++ ) {

				this.uniforms.push( uniforms[ j ].clone() );

			}

		}

		return this;

	}

	clone() {

		return new this.constructor().copy( this );

	}

}

class InstancedInterleavedBuffer extends (/* unused pure expression or super */ null && (InterleavedBuffer)) {

	constructor( array, stride, meshPerAttribute = 1 ) {

		super( array, stride );

		this.isInstancedInterleavedBuffer = true;

		this.meshPerAttribute = meshPerAttribute;

	}

	copy( source ) {

		super.copy( source );

		this.meshPerAttribute = source.meshPerAttribute;

		return this;

	}

	clone( data ) {

		const ib = super.clone( data );

		ib.meshPerAttribute = this.meshPerAttribute;

		return ib;

	}

	toJSON( data ) {

		const json = super.toJSON( data );

		json.isInstancedInterleavedBuffer = true;
		json.meshPerAttribute = this.meshPerAttribute;

		return json;

	}

}

class GLBufferAttribute {

	constructor( buffer, type, itemSize, elementSize, count ) {

		this.isGLBufferAttribute = true;

		this.name = '';

		this.buffer = buffer;
		this.type = type;
		this.itemSize = itemSize;
		this.elementSize = elementSize;
		this.count = count;

		this.version = 0;

	}

	set needsUpdate( value ) {

		if ( value === true ) this.version ++;

	}

	setBuffer( buffer ) {

		this.buffer = buffer;

		return this;

	}

	setType( type, elementSize ) {

		this.type = type;
		this.elementSize = elementSize;

		return this;

	}

	setItemSize( itemSize ) {

		this.itemSize = itemSize;

		return this;

	}

	setCount( count ) {

		this.count = count;

		return this;

	}

}

const _matrix = /*@__PURE__*/ new Matrix4();

class Raycaster {

	constructor( origin, direction, near = 0, far = Infinity ) {

		this.ray = new Ray( origin, direction );
		// direction is assumed to be normalized (for accurate distance calculations)

		this.near = near;
		this.far = far;
		this.camera = null;
		this.layers = new Layers();

		this.params = {
			Mesh: {},
			Line: { threshold: 1 },
			LOD: {},
			Points: { threshold: 1 },
			Sprite: {}
		};

	}

	set( origin, direction ) {

		// direction is assumed to be normalized (for accurate distance calculations)

		this.ray.set( origin, direction );

	}

	setFromCamera( coords, camera ) {

		if ( camera.isPerspectiveCamera ) {

			this.ray.origin.setFromMatrixPosition( camera.matrixWorld );
			this.ray.direction.set( coords.x, coords.y, 0.5 ).unproject( camera ).sub( this.ray.origin ).normalize();
			this.camera = camera;

		} else if ( camera.isOrthographicCamera ) {

			this.ray.origin.set( coords.x, coords.y, ( camera.near + camera.far ) / ( camera.near - camera.far ) ).unproject( camera ); // set origin in plane of camera
			this.ray.direction.set( 0, 0, - 1 ).transformDirection( camera.matrixWorld );
			this.camera = camera;

		} else {

			console.error( 'THREE.Raycaster: Unsupported camera type: ' + camera.type );

		}

	}

	setFromXRController( controller ) {

		_matrix.identity().extractRotation( controller.matrixWorld );

		this.ray.origin.setFromMatrixPosition( controller.matrixWorld );
		this.ray.direction.set( 0, 0, - 1 ).applyMatrix4( _matrix );

		return this;

	}

	intersectObject( object, recursive = true, intersects = [] ) {

		intersect( object, this, intersects, recursive );

		intersects.sort( ascSort );

		return intersects;

	}

	intersectObjects( objects, recursive = true, intersects = [] ) {

		for ( let i = 0, l = objects.length; i < l; i ++ ) {

			intersect( objects[ i ], this, intersects, recursive );

		}

		intersects.sort( ascSort );

		return intersects;

	}

}

function ascSort( a, b ) {

	return a.distance - b.distance;

}

function intersect( object, raycaster, intersects, recursive ) {

	if ( object.layers.test( raycaster.layers ) ) {

		object.raycast( raycaster, intersects );

	}

	if ( recursive === true ) {

		const children = object.children;

		for ( let i = 0, l = children.length; i < l; i ++ ) {

			intersect( children[ i ], raycaster, intersects, true );

		}

	}

}

/**
 * Ref: https://en.wikipedia.org/wiki/Spherical_coordinate_system
 *
 * phi (the polar angle) is measured from the positive y-axis. The positive y-axis is up.
 * theta (the azimuthal angle) is measured from the positive z-axis.
 */
class Spherical {

	constructor( radius = 1, phi = 0, theta = 0 ) {

		this.radius = radius;
		this.phi = phi; // polar angle
		this.theta = theta; // azimuthal angle

		return this;

	}

	set( radius, phi, theta ) {

		this.radius = radius;
		this.phi = phi;
		this.theta = theta;

		return this;

	}

	copy( other ) {

		this.radius = other.radius;
		this.phi = other.phi;
		this.theta = other.theta;

		return this;

	}

	// restrict phi to be between EPS and PI-EPS
	makeSafe() {

		const EPS = 0.000001;
		this.phi = Math.max( EPS, Math.min( Math.PI - EPS, this.phi ) );

		return this;

	}

	setFromVector3( v ) {

		return this.setFromCartesianCoords( v.x, v.y, v.z );

	}

	setFromCartesianCoords( x, y, z ) {

		this.radius = Math.sqrt( x * x + y * y + z * z );

		if ( this.radius === 0 ) {

			this.theta = 0;
			this.phi = 0;

		} else {

			this.theta = Math.atan2( x, z );
			this.phi = Math.acos( clamp( y / this.radius, - 1, 1 ) );

		}

		return this;

	}

	clone() {

		return new this.constructor().copy( this );

	}

}

/**
 * Ref: https://en.wikipedia.org/wiki/Cylindrical_coordinate_system
 */

class Cylindrical {

	constructor( radius = 1, theta = 0, y = 0 ) {

		this.radius = radius; // distance from the origin to a point in the x-z plane
		this.theta = theta; // counterclockwise angle in the x-z plane measured in radians from the positive z-axis
		this.y = y; // height above the x-z plane

		return this;

	}

	set( radius, theta, y ) {

		this.radius = radius;
		this.theta = theta;
		this.y = y;

		return this;

	}

	copy( other ) {

		this.radius = other.radius;
		this.theta = other.theta;
		this.y = other.y;

		return this;

	}

	setFromVector3( v ) {

		return this.setFromCartesianCoords( v.x, v.y, v.z );

	}

	setFromCartesianCoords( x, y, z ) {

		this.radius = Math.sqrt( x * x + z * z );
		this.theta = Math.atan2( x, z );
		this.y = y;

		return this;

	}

	clone() {

		return new this.constructor().copy( this );

	}

}

const _vector$4 = /*@__PURE__*/ new Vector2();

class Box2 {

	constructor( min = new Vector2( + Infinity, + Infinity ), max = new Vector2( - Infinity, - Infinity ) ) {

		this.isBox2 = true;

		this.min = min;
		this.max = max;

	}

	set( min, max ) {

		this.min.copy( min );
		this.max.copy( max );

		return this;

	}

	setFromPoints( points ) {

		this.makeEmpty();

		for ( let i = 0, il = points.length; i < il; i ++ ) {

			this.expandByPoint( points[ i ] );

		}

		return this;

	}

	setFromCenterAndSize( center, size ) {

		const halfSize = _vector$4.copy( size ).multiplyScalar( 0.5 );
		this.min.copy( center ).sub( halfSize );
		this.max.copy( center ).add( halfSize );

		return this;

	}

	clone() {

		return new this.constructor().copy( this );

	}

	copy( box ) {

		this.min.copy( box.min );
		this.max.copy( box.max );

		return this;

	}

	makeEmpty() {

		this.min.x = this.min.y = + Infinity;
		this.max.x = this.max.y = - Infinity;

		return this;

	}

	isEmpty() {

		// this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes

		return ( this.max.x < this.min.x ) || ( this.max.y < this.min.y );

	}

	getCenter( target ) {

		return this.isEmpty() ? target.set( 0, 0 ) : target.addVectors( this.min, this.max ).multiplyScalar( 0.5 );

	}

	getSize( target ) {

		return this.isEmpty() ? target.set( 0, 0 ) : target.subVectors( this.max, this.min );

	}

	expandByPoint( point ) {

		this.min.min( point );
		this.max.max( point );

		return this;

	}

	expandByVector( vector ) {

		this.min.sub( vector );
		this.max.add( vector );

		return this;

	}

	expandByScalar( scalar ) {

		this.min.addScalar( - scalar );
		this.max.addScalar( scalar );

		return this;

	}

	containsPoint( point ) {

		return point.x < this.min.x || point.x > this.max.x ||
			point.y < this.min.y || point.y > this.max.y ? false : true;

	}

	containsBox( box ) {

		return this.min.x <= box.min.x && box.max.x <= this.max.x &&
			this.min.y <= box.min.y && box.max.y <= this.max.y;

	}

	getParameter( point, target ) {

		// This can potentially have a divide by zero if the box
		// has a size dimension of 0.

		return target.set(
			( point.x - this.min.x ) / ( this.max.x - this.min.x ),
			( point.y - this.min.y ) / ( this.max.y - this.min.y )
		);

	}

	intersectsBox( box ) {

		// using 4 splitting planes to rule out intersections

		return box.max.x < this.min.x || box.min.x > this.max.x ||
			box.max.y < this.min.y || box.min.y > this.max.y ? false : true;

	}

	clampPoint( point, target ) {

		return target.copy( point ).clamp( this.min, this.max );

	}

	distanceToPoint( point ) {

		return this.clampPoint( point, _vector$4 ).distanceTo( point );

	}

	intersect( box ) {

		this.min.max( box.min );
		this.max.min( box.max );

		if ( this.isEmpty() ) this.makeEmpty();

		return this;

	}

	union( box ) {

		this.min.min( box.min );
		this.max.max( box.max );

		return this;

	}

	translate( offset ) {

		this.min.add( offset );
		this.max.add( offset );

		return this;

	}

	equals( box ) {

		return box.min.equals( this.min ) && box.max.equals( this.max );

	}

}

const _startP = /*@__PURE__*/ new Vector3();
const _startEnd = /*@__PURE__*/ new Vector3();

class Line3 {

	constructor( start = new Vector3(), end = new Vector3() ) {

		this.start = start;
		this.end = end;

	}

	set( start, end ) {

		this.start.copy( start );
		this.end.copy( end );

		return this;

	}

	copy( line ) {

		this.start.copy( line.start );
		this.end.copy( line.end );

		return this;

	}

	getCenter( target ) {

		return target.addVectors( this.start, this.end ).multiplyScalar( 0.5 );

	}

	delta( target ) {

		return target.subVectors( this.end, this.start );

	}

	distanceSq() {

		return this.start.distanceToSquared( this.end );

	}

	distance() {

		return this.start.distanceTo( this.end );

	}

	at( t, target ) {

		return this.delta( target ).multiplyScalar( t ).add( this.start );

	}

	closestPointToPointParameter( point, clampToLine ) {

		_startP.subVectors( point, this.start );
		_startEnd.subVectors( this.end, this.start );

		const startEnd2 = _startEnd.dot( _startEnd );
		const startEnd_startP = _startEnd.dot( _startP );

		let t = startEnd_startP / startEnd2;

		if ( clampToLine ) {

			t = clamp( t, 0, 1 );

		}

		return t;

	}

	closestPointToPoint( point, clampToLine, target ) {

		const t = this.closestPointToPointParameter( point, clampToLine );

		return this.delta( target ).multiplyScalar( t ).add( this.start );

	}

	applyMatrix4( matrix ) {

		this.start.applyMatrix4( matrix );
		this.end.applyMatrix4( matrix );

		return this;

	}

	equals( line ) {

		return line.start.equals( this.start ) && line.end.equals( this.end );

	}

	clone() {

		return new this.constructor().copy( this );

	}

}

const _vector$3 = /*@__PURE__*/ new Vector3();

class SpotLightHelper extends (/* unused pure expression or super */ null && (Object3D)) {

	constructor( light, color ) {

		super();

		this.light = light;

		this.matrixAutoUpdate = false;

		this.color = color;

		this.type = 'SpotLightHelper';

		const geometry = new BufferGeometry();

		const positions = [
			0, 0, 0, 	0, 0, 1,
			0, 0, 0, 	1, 0, 1,
			0, 0, 0,	- 1, 0, 1,
			0, 0, 0, 	0, 1, 1,
			0, 0, 0, 	0, - 1, 1
		];

		for ( let i = 0, j = 1, l = 32; i < l; i ++, j ++ ) {

			const p1 = ( i / l ) * Math.PI * 2;
			const p2 = ( j / l ) * Math.PI * 2;

			positions.push(
				Math.cos( p1 ), Math.sin( p1 ), 1,
				Math.cos( p2 ), Math.sin( p2 ), 1
			);

		}

		geometry.setAttribute( 'position', new Float32BufferAttribute( positions, 3 ) );

		const material = new LineBasicMaterial( { fog: false, toneMapped: false } );

		this.cone = new LineSegments( geometry, material );
		this.add( this.cone );

		this.update();

	}

	dispose() {

		this.cone.geometry.dispose();
		this.cone.material.dispose();

	}

	update() {

		this.light.updateWorldMatrix( true, false );
		this.light.target.updateWorldMatrix( true, false );

		// update the local matrix based on the parent and light target transforms
		if ( this.parent ) {

			this.parent.updateWorldMatrix( true );

			this.matrix
				.copy( this.parent.matrixWorld )
				.invert()
				.multiply( this.light.matrixWorld );

		} else {

			this.matrix.copy( this.light.matrixWorld );

		}

		this.matrixWorld.copy( this.light.matrixWorld );

		const coneLength = this.light.distance ? this.light.distance : 1000;
		const coneWidth = coneLength * Math.tan( this.light.angle );

		this.cone.scale.set( coneWidth, coneWidth, coneLength );

		_vector$3.setFromMatrixPosition( this.light.target.matrixWorld );

		this.cone.lookAt( _vector$3 );

		if ( this.color !== undefined ) {

			this.cone.material.color.set( this.color );

		} else {

			this.cone.material.color.copy( this.light.color );

		}

	}

}

const _vector$2 = /*@__PURE__*/ new Vector3();
const _boneMatrix = /*@__PURE__*/ new Matrix4();
const _matrixWorldInv = /*@__PURE__*/ new Matrix4();


class SkeletonHelper extends (/* unused pure expression or super */ null && (LineSegments)) {

	constructor( object ) {

		const bones = getBoneList( object );

		const geometry = new BufferGeometry();

		const vertices = [];
		const colors = [];

		const color1 = new Color( 0, 0, 1 );
		const color2 = new Color( 0, 1, 0 );

		for ( let i = 0; i < bones.length; i ++ ) {

			const bone = bones[ i ];

			if ( bone.parent && bone.parent.isBone ) {

				vertices.push( 0, 0, 0 );
				vertices.push( 0, 0, 0 );
				colors.push( color1.r, color1.g, color1.b );
				colors.push( color2.r, color2.g, color2.b );

			}

		}

		geometry.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		geometry.setAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );

		const material = new LineBasicMaterial( { vertexColors: true, depthTest: false, depthWrite: false, toneMapped: false, transparent: true } );

		super( geometry, material );

		this.isSkeletonHelper = true;

		this.type = 'SkeletonHelper';

		this.root = object;
		this.bones = bones;

		this.matrix = object.matrixWorld;
		this.matrixAutoUpdate = false;

	}

	updateMatrixWorld( force ) {

		const bones = this.bones;

		const geometry = this.geometry;
		const position = geometry.getAttribute( 'position' );

		_matrixWorldInv.copy( this.root.matrixWorld ).invert();

		for ( let i = 0, j = 0; i < bones.length; i ++ ) {

			const bone = bones[ i ];

			if ( bone.parent && bone.parent.isBone ) {

				_boneMatrix.multiplyMatrices( _matrixWorldInv, bone.matrixWorld );
				_vector$2.setFromMatrixPosition( _boneMatrix );
				position.setXYZ( j, _vector$2.x, _vector$2.y, _vector$2.z );

				_boneMatrix.multiplyMatrices( _matrixWorldInv, bone.parent.matrixWorld );
				_vector$2.setFromMatrixPosition( _boneMatrix );
				position.setXYZ( j + 1, _vector$2.x, _vector$2.y, _vector$2.z );

				j += 2;

			}

		}

		geometry.getAttribute( 'position' ).needsUpdate = true;

		super.updateMatrixWorld( force );

	}

	dispose() {

		this.geometry.dispose();
		this.material.dispose();

	}

}


function getBoneList( object ) {

	const boneList = [];

	if ( object.isBone === true ) {

		boneList.push( object );

	}

	for ( let i = 0; i < object.children.length; i ++ ) {

		boneList.push.apply( boneList, getBoneList( object.children[ i ] ) );

	}

	return boneList;

}

class PointLightHelper extends (/* unused pure expression or super */ null && (Mesh)) {

	constructor( light, sphereSize, color ) {

		const geometry = new SphereGeometry( sphereSize, 4, 2 );
		const material = new MeshBasicMaterial( { wireframe: true, fog: false, toneMapped: false } );

		super( geometry, material );

		this.light = light;

		this.color = color;

		this.type = 'PointLightHelper';

		this.matrix = this.light.matrixWorld;
		this.matrixAutoUpdate = false;

		this.update();


		/*
	// TODO: delete this comment?
	const distanceGeometry = new THREE.IcosahedronGeometry( 1, 2 );
	const distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );

	this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
	this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );

	const d = light.distance;

	if ( d === 0.0 ) {

		this.lightDistance.visible = false;

	} else {

		this.lightDistance.scale.set( d, d, d );

	}

	this.add( this.lightDistance );
	*/

	}

	dispose() {

		this.geometry.dispose();
		this.material.dispose();

	}

	update() {

		this.light.updateWorldMatrix( true, false );

		if ( this.color !== undefined ) {

			this.material.color.set( this.color );

		} else {

			this.material.color.copy( this.light.color );

		}

		/*
		const d = this.light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.visible = true;
			this.lightDistance.scale.set( d, d, d );

		}
		*/

	}

}

const _vector$1 = /*@__PURE__*/ new Vector3();
const _color1 = /*@__PURE__*/ new Color();
const _color2 = /*@__PURE__*/ new Color();

class HemisphereLightHelper extends (/* unused pure expression or super */ null && (Object3D)) {

	constructor( light, size, color ) {

		super();

		this.light = light;

		this.matrix = light.matrixWorld;
		this.matrixAutoUpdate = false;

		this.color = color;

		this.type = 'HemisphereLightHelper';

		const geometry = new OctahedronGeometry( size );
		geometry.rotateY( Math.PI * 0.5 );

		this.material = new MeshBasicMaterial( { wireframe: true, fog: false, toneMapped: false } );
		if ( this.color === undefined ) this.material.vertexColors = true;

		const position = geometry.getAttribute( 'position' );
		const colors = new Float32Array( position.count * 3 );

		geometry.setAttribute( 'color', new BufferAttribute( colors, 3 ) );

		this.add( new Mesh( geometry, this.material ) );

		this.update();

	}

	dispose() {

		this.children[ 0 ].geometry.dispose();
		this.children[ 0 ].material.dispose();

	}

	update() {

		const mesh = this.children[ 0 ];

		if ( this.color !== undefined ) {

			this.material.color.set( this.color );

		} else {

			const colors = mesh.geometry.getAttribute( 'color' );

			_color1.copy( this.light.color );
			_color2.copy( this.light.groundColor );

			for ( let i = 0, l = colors.count; i < l; i ++ ) {

				const color = ( i < ( l / 2 ) ) ? _color1 : _color2;

				colors.setXYZ( i, color.r, color.g, color.b );

			}

			colors.needsUpdate = true;

		}

		this.light.updateWorldMatrix( true, false );

		mesh.lookAt( _vector$1.setFromMatrixPosition( this.light.matrixWorld ).negate() );

	}

}

class GridHelper extends (/* unused pure expression or super */ null && (LineSegments)) {

	constructor( size = 10, divisions = 10, color1 = 0x444444, color2 = 0x888888 ) {

		color1 = new Color( color1 );
		color2 = new Color( color2 );

		const center = divisions / 2;
		const step = size / divisions;
		const halfSize = size / 2;

		const vertices = [], colors = [];

		for ( let i = 0, j = 0, k = - halfSize; i <= divisions; i ++, k += step ) {

			vertices.push( - halfSize, 0, k, halfSize, 0, k );
			vertices.push( k, 0, - halfSize, k, 0, halfSize );

			const color = i === center ? color1 : color2;

			color.toArray( colors, j ); j += 3;
			color.toArray( colors, j ); j += 3;
			color.toArray( colors, j ); j += 3;
			color.toArray( colors, j ); j += 3;

		}

		const geometry = new BufferGeometry();
		geometry.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		geometry.setAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );

		const material = new LineBasicMaterial( { vertexColors: true, toneMapped: false } );

		super( geometry, material );

		this.type = 'GridHelper';

	}

	dispose() {

		this.geometry.dispose();
		this.material.dispose();

	}

}

class PolarGridHelper extends (/* unused pure expression or super */ null && (LineSegments)) {

	constructor( radius = 10, sectors = 16, rings = 8, divisions = 64, color1 = 0x444444, color2 = 0x888888 ) {

		color1 = new Color( color1 );
		color2 = new Color( color2 );

		const vertices = [];
		const colors = [];

		// create the sectors

		if ( sectors > 1 ) {

			for ( let i = 0; i < sectors; i ++ ) {

				const v = ( i / sectors ) * ( Math.PI * 2 );

				const x = Math.sin( v ) * radius;
				const z = Math.cos( v ) * radius;

				vertices.push( 0, 0, 0 );
				vertices.push( x, 0, z );

				const color = ( i & 1 ) ? color1 : color2;

				colors.push( color.r, color.g, color.b );
				colors.push( color.r, color.g, color.b );

			}

		}

		// create the rings

		for ( let i = 0; i < rings; i ++ ) {

			const color = ( i & 1 ) ? color1 : color2;

			const r = radius - ( radius / rings * i );

			for ( let j = 0; j < divisions; j ++ ) {

				// first vertex

				let v = ( j / divisions ) * ( Math.PI * 2 );

				let x = Math.sin( v ) * r;
				let z = Math.cos( v ) * r;

				vertices.push( x, 0, z );
				colors.push( color.r, color.g, color.b );

				// second vertex

				v = ( ( j + 1 ) / divisions ) * ( Math.PI * 2 );

				x = Math.sin( v ) * r;
				z = Math.cos( v ) * r;

				vertices.push( x, 0, z );
				colors.push( color.r, color.g, color.b );

			}

		}

		const geometry = new BufferGeometry();
		geometry.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		geometry.setAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );

		const material = new LineBasicMaterial( { vertexColors: true, toneMapped: false } );

		super( geometry, material );

		this.type = 'PolarGridHelper';

	}

	dispose() {

		this.geometry.dispose();
		this.material.dispose();

	}

}

const _v1 = /*@__PURE__*/ new Vector3();
const _v2 = /*@__PURE__*/ new Vector3();
const _v3 = /*@__PURE__*/ new Vector3();

class DirectionalLightHelper extends (/* unused pure expression or super */ null && (Object3D)) {

	constructor( light, size, color ) {

		super();

		this.light = light;

		this.matrix = light.matrixWorld;
		this.matrixAutoUpdate = false;

		this.color = color;

		this.type = 'DirectionalLightHelper';

		if ( size === undefined ) size = 1;

		let geometry = new BufferGeometry();
		geometry.setAttribute( 'position', new Float32BufferAttribute( [
			- size, size, 0,
			size, size, 0,
			size, - size, 0,
			- size, - size, 0,
			- size, size, 0
		], 3 ) );

		const material = new LineBasicMaterial( { fog: false, toneMapped: false } );

		this.lightPlane = new Line( geometry, material );
		this.add( this.lightPlane );

		geometry = new BufferGeometry();
		geometry.setAttribute( 'position', new Float32BufferAttribute( [ 0, 0, 0, 0, 0, 1 ], 3 ) );

		this.targetLine = new Line( geometry, material );
		this.add( this.targetLine );

		this.update();

	}

	dispose() {

		this.lightPlane.geometry.dispose();
		this.lightPlane.material.dispose();
		this.targetLine.geometry.dispose();
		this.targetLine.material.dispose();

	}

	update() {

		this.light.updateWorldMatrix( true, false );
		this.light.target.updateWorldMatrix( true, false );

		_v1.setFromMatrixPosition( this.light.matrixWorld );
		_v2.setFromMatrixPosition( this.light.target.matrixWorld );
		_v3.subVectors( _v2, _v1 );

		this.lightPlane.lookAt( _v2 );

		if ( this.color !== undefined ) {

			this.lightPlane.material.color.set( this.color );
			this.targetLine.material.color.set( this.color );

		} else {

			this.lightPlane.material.color.copy( this.light.color );
			this.targetLine.material.color.copy( this.light.color );

		}

		this.targetLine.lookAt( _v2 );
		this.targetLine.scale.z = _v3.length();

	}

}

const _vector = /*@__PURE__*/ new Vector3();
const _camera = /*@__PURE__*/ new Camera();

/**
 *	- shows frustum, line of sight and up of the camera
 *	- suitable for fast updates
 * 	- based on frustum visualization in lightgl.js shadowmap example
 *		https://github.com/evanw/lightgl.js/blob/master/tests/shadowmap.html
 */

class CameraHelper extends (/* unused pure expression or super */ null && (LineSegments)) {

	constructor( camera ) {

		const geometry = new BufferGeometry();
		const material = new LineBasicMaterial( { color: 0xffffff, vertexColors: true, toneMapped: false } );

		const vertices = [];
		const colors = [];

		const pointMap = {};

		// near

		addLine( 'n1', 'n2' );
		addLine( 'n2', 'n4' );
		addLine( 'n4', 'n3' );
		addLine( 'n3', 'n1' );

		// far

		addLine( 'f1', 'f2' );
		addLine( 'f2', 'f4' );
		addLine( 'f4', 'f3' );
		addLine( 'f3', 'f1' );

		// sides

		addLine( 'n1', 'f1' );
		addLine( 'n2', 'f2' );
		addLine( 'n3', 'f3' );
		addLine( 'n4', 'f4' );

		// cone

		addLine( 'p', 'n1' );
		addLine( 'p', 'n2' );
		addLine( 'p', 'n3' );
		addLine( 'p', 'n4' );

		// up

		addLine( 'u1', 'u2' );
		addLine( 'u2', 'u3' );
		addLine( 'u3', 'u1' );

		// target

		addLine( 'c', 't' );
		addLine( 'p', 'c' );

		// cross

		addLine( 'cn1', 'cn2' );
		addLine( 'cn3', 'cn4' );

		addLine( 'cf1', 'cf2' );
		addLine( 'cf3', 'cf4' );

		function addLine( a, b ) {

			addPoint( a );
			addPoint( b );

		}

		function addPoint( id ) {

			vertices.push( 0, 0, 0 );
			colors.push( 0, 0, 0 );

			if ( pointMap[ id ] === undefined ) {

				pointMap[ id ] = [];

			}

			pointMap[ id ].push( ( vertices.length / 3 ) - 1 );

		}

		geometry.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		geometry.setAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );

		super( geometry, material );

		this.type = 'CameraHelper';

		this.camera = camera;
		if ( this.camera.updateProjectionMatrix ) this.camera.updateProjectionMatrix();

		this.matrix = camera.matrixWorld;
		this.matrixAutoUpdate = false;

		this.pointMap = pointMap;

		this.update();

		// colors

		const colorFrustum = new Color( 0xffaa00 );
		const colorCone = new Color( 0xff0000 );
		const colorUp = new Color( 0x00aaff );
		const colorTarget = new Color( 0xffffff );
		const colorCross = new Color( 0x333333 );

		this.setColors( colorFrustum, colorCone, colorUp, colorTarget, colorCross );

	}

	setColors( frustum, cone, up, target, cross ) {

		const geometry = this.geometry;

		const colorAttribute = geometry.getAttribute( 'color' );

		// near

		colorAttribute.setXYZ( 0, frustum.r, frustum.g, frustum.b ); colorAttribute.setXYZ( 1, frustum.r, frustum.g, frustum.b ); // n1, n2
		colorAttribute.setXYZ( 2, frustum.r, frustum.g, frustum.b ); colorAttribute.setXYZ( 3, frustum.r, frustum.g, frustum.b ); // n2, n4
		colorAttribute.setXYZ( 4, frustum.r, frustum.g, frustum.b ); colorAttribute.setXYZ( 5, frustum.r, frustum.g, frustum.b ); // n4, n3
		colorAttribute.setXYZ( 6, frustum.r, frustum.g, frustum.b ); colorAttribute.setXYZ( 7, frustum.r, frustum.g, frustum.b ); // n3, n1

		// far

		colorAttribute.setXYZ( 8, frustum.r, frustum.g, frustum.b ); colorAttribute.setXYZ( 9, frustum.r, frustum.g, frustum.b ); // f1, f2
		colorAttribute.setXYZ( 10, frustum.r, frustum.g, frustum.b ); colorAttribute.setXYZ( 11, frustum.r, frustum.g, frustum.b ); // f2, f4
		colorAttribute.setXYZ( 12, frustum.r, frustum.g, frustum.b ); colorAttribute.setXYZ( 13, frustum.r, frustum.g, frustum.b ); // f4, f3
		colorAttribute.setXYZ( 14, frustum.r, frustum.g, frustum.b ); colorAttribute.setXYZ( 15, frustum.r, frustum.g, frustum.b ); // f3, f1

		// sides

		colorAttribute.setXYZ( 16, frustum.r, frustum.g, frustum.b ); colorAttribute.setXYZ( 17, frustum.r, frustum.g, frustum.b ); // n1, f1
		colorAttribute.setXYZ( 18, frustum.r, frustum.g, frustum.b ); colorAttribute.setXYZ( 19, frustum.r, frustum.g, frustum.b ); // n2, f2
		colorAttribute.setXYZ( 20, frustum.r, frustum.g, frustum.b ); colorAttribute.setXYZ( 21, frustum.r, frustum.g, frustum.b ); // n3, f3
		colorAttribute.setXYZ( 22, frustum.r, frustum.g, frustum.b ); colorAttribute.setXYZ( 23, frustum.r, frustum.g, frustum.b ); // n4, f4

		// cone

		colorAttribute.setXYZ( 24, cone.r, cone.g, cone.b ); colorAttribute.setXYZ( 25, cone.r, cone.g, cone.b ); // p, n1
		colorAttribute.setXYZ( 26, cone.r, cone.g, cone.b ); colorAttribute.setXYZ( 27, cone.r, cone.g, cone.b ); // p, n2
		colorAttribute.setXYZ( 28, cone.r, cone.g, cone.b ); colorAttribute.setXYZ( 29, cone.r, cone.g, cone.b ); // p, n3
		colorAttribute.setXYZ( 30, cone.r, cone.g, cone.b ); colorAttribute.setXYZ( 31, cone.r, cone.g, cone.b ); // p, n4

		// up

		colorAttribute.setXYZ( 32, up.r, up.g, up.b ); colorAttribute.setXYZ( 33, up.r, up.g, up.b ); // u1, u2
		colorAttribute.setXYZ( 34, up.r, up.g, up.b ); colorAttribute.setXYZ( 35, up.r, up.g, up.b ); // u2, u3
		colorAttribute.setXYZ( 36, up.r, up.g, up.b ); colorAttribute.setXYZ( 37, up.r, up.g, up.b ); // u3, u1

		// target

		colorAttribute.setXYZ( 38, target.r, target.g, target.b ); colorAttribute.setXYZ( 39, target.r, target.g, target.b ); // c, t
		colorAttribute.setXYZ( 40, cross.r, cross.g, cross.b ); colorAttribute.setXYZ( 41, cross.r, cross.g, cross.b ); // p, c

		// cross

		colorAttribute.setXYZ( 42, cross.r, cross.g, cross.b ); colorAttribute.setXYZ( 43, cross.r, cross.g, cross.b ); // cn1, cn2
		colorAttribute.setXYZ( 44, cross.r, cross.g, cross.b ); colorAttribute.setXYZ( 45, cross.r, cross.g, cross.b ); // cn3, cn4

		colorAttribute.setXYZ( 46, cross.r, cross.g, cross.b ); colorAttribute.setXYZ( 47, cross.r, cross.g, cross.b ); // cf1, cf2
		colorAttribute.setXYZ( 48, cross.r, cross.g, cross.b ); colorAttribute.setXYZ( 49, cross.r, cross.g, cross.b ); // cf3, cf4

		colorAttribute.needsUpdate = true;

	}

	update() {

		const geometry = this.geometry;
		const pointMap = this.pointMap;

		const w = 1, h = 1;

		// we need just camera projection matrix inverse
		// world matrix must be identity

		_camera.projectionMatrixInverse.copy( this.camera.projectionMatrixInverse );

		// center / target

		setPoint( 'c', pointMap, geometry, _camera, 0, 0, - 1 );
		setPoint( 't', pointMap, geometry, _camera, 0, 0, 1 );

		// near

		setPoint( 'n1', pointMap, geometry, _camera, - w, - h, - 1 );
		setPoint( 'n2', pointMap, geometry, _camera, w, - h, - 1 );
		setPoint( 'n3', pointMap, geometry, _camera, - w, h, - 1 );
		setPoint( 'n4', pointMap, geometry, _camera, w, h, - 1 );

		// far

		setPoint( 'f1', pointMap, geometry, _camera, - w, - h, 1 );
		setPoint( 'f2', pointMap, geometry, _camera, w, - h, 1 );
		setPoint( 'f3', pointMap, geometry, _camera, - w, h, 1 );
		setPoint( 'f4', pointMap, geometry, _camera, w, h, 1 );

		// up

		setPoint( 'u1', pointMap, geometry, _camera, w * 0.7, h * 1.1, - 1 );
		setPoint( 'u2', pointMap, geometry, _camera, - w * 0.7, h * 1.1, - 1 );
		setPoint( 'u3', pointMap, geometry, _camera, 0, h * 2, - 1 );

		// cross

		setPoint( 'cf1', pointMap, geometry, _camera, - w, 0, 1 );
		setPoint( 'cf2', pointMap, geometry, _camera, w, 0, 1 );
		setPoint( 'cf3', pointMap, geometry, _camera, 0, - h, 1 );
		setPoint( 'cf4', pointMap, geometry, _camera, 0, h, 1 );

		setPoint( 'cn1', pointMap, geometry, _camera, - w, 0, - 1 );
		setPoint( 'cn2', pointMap, geometry, _camera, w, 0, - 1 );
		setPoint( 'cn3', pointMap, geometry, _camera, 0, - h, - 1 );
		setPoint( 'cn4', pointMap, geometry, _camera, 0, h, - 1 );

		geometry.getAttribute( 'position' ).needsUpdate = true;

	}

	dispose() {

		this.geometry.dispose();
		this.material.dispose();

	}

}


function setPoint( point, pointMap, geometry, camera, x, y, z ) {

	_vector.set( x, y, z ).unproject( camera );

	const points = pointMap[ point ];

	if ( points !== undefined ) {

		const position = geometry.getAttribute( 'position' );

		for ( let i = 0, l = points.length; i < l; i ++ ) {

			position.setXYZ( points[ i ], _vector.x, _vector.y, _vector.z );

		}

	}

}

const _box = /*@__PURE__*/ new Box3();

class BoxHelper extends (/* unused pure expression or super */ null && (LineSegments)) {

	constructor( object, color = 0xffff00 ) {

		const indices = new Uint16Array( [ 0, 1, 1, 2, 2, 3, 3, 0, 4, 5, 5, 6, 6, 7, 7, 4, 0, 4, 1, 5, 2, 6, 3, 7 ] );
		const positions = new Float32Array( 8 * 3 );

		const geometry = new BufferGeometry();
		geometry.setIndex( new BufferAttribute( indices, 1 ) );
		geometry.setAttribute( 'position', new BufferAttribute( positions, 3 ) );

		super( geometry, new LineBasicMaterial( { color: color, toneMapped: false } ) );

		this.object = object;
		this.type = 'BoxHelper';

		this.matrixAutoUpdate = false;

		this.update();

	}

	update( object ) {

		if ( object !== undefined ) {

			console.warn( 'THREE.BoxHelper: .update() has no longer arguments.' );

		}

		if ( this.object !== undefined ) {

			_box.setFromObject( this.object );

		}

		if ( _box.isEmpty() ) return;

		const min = _box.min;
		const max = _box.max;

		/*
			5____4
		1/___0/|
		| 6__|_7
		2/___3/

		0: max.x, max.y, max.z
		1: min.x, max.y, max.z
		2: min.x, min.y, max.z
		3: max.x, min.y, max.z
		4: max.x, max.y, min.z
		5: min.x, max.y, min.z
		6: min.x, min.y, min.z
		7: max.x, min.y, min.z
		*/

		const position = this.geometry.attributes.position;
		const array = position.array;

		array[ 0 ] = max.x; array[ 1 ] = max.y; array[ 2 ] = max.z;
		array[ 3 ] = min.x; array[ 4 ] = max.y; array[ 5 ] = max.z;
		array[ 6 ] = min.x; array[ 7 ] = min.y; array[ 8 ] = max.z;
		array[ 9 ] = max.x; array[ 10 ] = min.y; array[ 11 ] = max.z;
		array[ 12 ] = max.x; array[ 13 ] = max.y; array[ 14 ] = min.z;
		array[ 15 ] = min.x; array[ 16 ] = max.y; array[ 17 ] = min.z;
		array[ 18 ] = min.x; array[ 19 ] = min.y; array[ 20 ] = min.z;
		array[ 21 ] = max.x; array[ 22 ] = min.y; array[ 23 ] = min.z;

		position.needsUpdate = true;

		this.geometry.computeBoundingSphere();

	}

	setFromObject( object ) {

		this.object = object;
		this.update();

		return this;

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		this.object = source.object;

		return this;

	}

	dispose() {

		this.geometry.dispose();
		this.material.dispose();

	}

}

class Box3Helper extends (/* unused pure expression or super */ null && (LineSegments)) {

	constructor( box, color = 0xffff00 ) {

		const indices = new Uint16Array( [ 0, 1, 1, 2, 2, 3, 3, 0, 4, 5, 5, 6, 6, 7, 7, 4, 0, 4, 1, 5, 2, 6, 3, 7 ] );

		const positions = [ 1, 1, 1, - 1, 1, 1, - 1, - 1, 1, 1, - 1, 1, 1, 1, - 1, - 1, 1, - 1, - 1, - 1, - 1, 1, - 1, - 1 ];

		const geometry = new BufferGeometry();

		geometry.setIndex( new BufferAttribute( indices, 1 ) );

		geometry.setAttribute( 'position', new Float32BufferAttribute( positions, 3 ) );

		super( geometry, new LineBasicMaterial( { color: color, toneMapped: false } ) );

		this.box = box;

		this.type = 'Box3Helper';

		this.geometry.computeBoundingSphere();

	}

	updateMatrixWorld( force ) {

		const box = this.box;

		if ( box.isEmpty() ) return;

		box.getCenter( this.position );

		box.getSize( this.scale );

		this.scale.multiplyScalar( 0.5 );

		super.updateMatrixWorld( force );

	}

	dispose() {

		this.geometry.dispose();
		this.material.dispose();

	}

}

class PlaneHelper extends (/* unused pure expression or super */ null && (Line)) {

	constructor( plane, size = 1, hex = 0xffff00 ) {

		const color = hex;

		const positions = [ 1, - 1, 0, - 1, 1, 0, - 1, - 1, 0, 1, 1, 0, - 1, 1, 0, - 1, - 1, 0, 1, - 1, 0, 1, 1, 0 ];

		const geometry = new BufferGeometry();
		geometry.setAttribute( 'position', new Float32BufferAttribute( positions, 3 ) );
		geometry.computeBoundingSphere();

		super( geometry, new LineBasicMaterial( { color: color, toneMapped: false } ) );

		this.type = 'PlaneHelper';

		this.plane = plane;

		this.size = size;

		const positions2 = [ 1, 1, 0, - 1, 1, 0, - 1, - 1, 0, 1, 1, 0, - 1, - 1, 0, 1, - 1, 0 ];

		const geometry2 = new BufferGeometry();
		geometry2.setAttribute( 'position', new Float32BufferAttribute( positions2, 3 ) );
		geometry2.computeBoundingSphere();

		this.add( new Mesh( geometry2, new MeshBasicMaterial( { color: color, opacity: 0.2, transparent: true, depthWrite: false, toneMapped: false } ) ) );

	}

	updateMatrixWorld( force ) {

		this.position.set( 0, 0, 0 );

		this.scale.set( 0.5 * this.size, 0.5 * this.size, 1 );

		this.lookAt( this.plane.normal );

		this.translateZ( - this.plane.constant );

		super.updateMatrixWorld( force );

	}

	dispose() {

		this.geometry.dispose();
		this.material.dispose();
		this.children[ 0 ].geometry.dispose();
		this.children[ 0 ].material.dispose();

	}

}

const _axis = /*@__PURE__*/ new Vector3();
let _lineGeometry, _coneGeometry;

class ArrowHelper extends (/* unused pure expression or super */ null && (Object3D)) {

	// dir is assumed to be normalized

	constructor( dir = new Vector3( 0, 0, 1 ), origin = new Vector3( 0, 0, 0 ), length = 1, color = 0xffff00, headLength = length * 0.2, headWidth = headLength * 0.2 ) {

		super();

		this.type = 'ArrowHelper';

		if ( _lineGeometry === undefined ) {

			_lineGeometry = new BufferGeometry();
			_lineGeometry.setAttribute( 'position', new Float32BufferAttribute( [ 0, 0, 0, 0, 1, 0 ], 3 ) );

			_coneGeometry = new CylinderGeometry( 0, 0.5, 1, 5, 1 );
			_coneGeometry.translate( 0, - 0.5, 0 );

		}

		this.position.copy( origin );

		this.line = new Line( _lineGeometry, new LineBasicMaterial( { color: color, toneMapped: false } ) );
		this.line.matrixAutoUpdate = false;
		this.add( this.line );

		this.cone = new Mesh( _coneGeometry, new MeshBasicMaterial( { color: color, toneMapped: false } ) );
		this.cone.matrixAutoUpdate = false;
		this.add( this.cone );

		this.setDirection( dir );
		this.setLength( length, headLength, headWidth );

	}

	setDirection( dir ) {

		// dir is assumed to be normalized

		if ( dir.y > 0.99999 ) {

			this.quaternion.set( 0, 0, 0, 1 );

		} else if ( dir.y < - 0.99999 ) {

			this.quaternion.set( 1, 0, 0, 0 );

		} else {

			_axis.set( dir.z, 0, - dir.x ).normalize();

			const radians = Math.acos( dir.y );

			this.quaternion.setFromAxisAngle( _axis, radians );

		}

	}

	setLength( length, headLength = length * 0.2, headWidth = headLength * 0.2 ) {

		this.line.scale.set( 1, Math.max( 0.0001, length - headLength ), 1 ); // see #17458
		this.line.updateMatrix();

		this.cone.scale.set( headWidth, headLength, headWidth );
		this.cone.position.y = length;
		this.cone.updateMatrix();

	}

	setColor( color ) {

		this.line.material.color.set( color );
		this.cone.material.color.set( color );

	}

	copy( source ) {

		super.copy( source, false );

		this.line.copy( source.line );
		this.cone.copy( source.cone );

		return this;

	}

	dispose() {

		this.line.geometry.dispose();
		this.line.material.dispose();
		this.cone.geometry.dispose();
		this.cone.material.dispose();

	}

}

class AxesHelper extends (/* unused pure expression or super */ null && (LineSegments)) {

	constructor( size = 1 ) {

		const vertices = [
			0, 0, 0,	size, 0, 0,
			0, 0, 0,	0, size, 0,
			0, 0, 0,	0, 0, size
		];

		const colors = [
			1, 0, 0,	1, 0.6, 0,
			0, 1, 0,	0.6, 1, 0,
			0, 0, 1,	0, 0.6, 1
		];

		const geometry = new BufferGeometry();
		geometry.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		geometry.setAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );

		const material = new LineBasicMaterial( { vertexColors: true, toneMapped: false } );

		super( geometry, material );

		this.type = 'AxesHelper';

	}

	setColors( xAxisColor, yAxisColor, zAxisColor ) {

		const color = new Color();
		const array = this.geometry.attributes.color.array;

		color.set( xAxisColor );
		color.toArray( array, 0 );
		color.toArray( array, 3 );

		color.set( yAxisColor );
		color.toArray( array, 6 );
		color.toArray( array, 9 );

		color.set( zAxisColor );
		color.toArray( array, 12 );
		color.toArray( array, 15 );

		this.geometry.attributes.color.needsUpdate = true;

		return this;

	}

	dispose() {

		this.geometry.dispose();
		this.material.dispose();

	}

}

class ShapePath {

	constructor() {

		this.type = 'ShapePath';

		this.color = new Color();

		this.subPaths = [];
		this.currentPath = null;

	}

	moveTo( x, y ) {

		this.currentPath = new Path();
		this.subPaths.push( this.currentPath );
		this.currentPath.moveTo( x, y );

		return this;

	}

	lineTo( x, y ) {

		this.currentPath.lineTo( x, y );

		return this;

	}

	quadraticCurveTo( aCPx, aCPy, aX, aY ) {

		this.currentPath.quadraticCurveTo( aCPx, aCPy, aX, aY );

		return this;

	}

	bezierCurveTo( aCP1x, aCP1y, aCP2x, aCP2y, aX, aY ) {

		this.currentPath.bezierCurveTo( aCP1x, aCP1y, aCP2x, aCP2y, aX, aY );

		return this;

	}

	splineThru( pts ) {

		this.currentPath.splineThru( pts );

		return this;

	}

	toShapes( isCCW ) {

		function toShapesNoHoles( inSubpaths ) {

			const shapes = [];

			for ( let i = 0, l = inSubpaths.length; i < l; i ++ ) {

				const tmpPath = inSubpaths[ i ];

				const tmpShape = new Shape();
				tmpShape.curves = tmpPath.curves;

				shapes.push( tmpShape );

			}

			return shapes;

		}

		function isPointInsidePolygon( inPt, inPolygon ) {

			const polyLen = inPolygon.length;

			// inPt on polygon contour => immediate success    or
			// toggling of inside/outside at every single! intersection point of an edge
			//  with the horizontal line through inPt, left of inPt
			//  not counting lowerY endpoints of edges and whole edges on that line
			let inside = false;
			for ( let p = polyLen - 1, q = 0; q < polyLen; p = q ++ ) {

				let edgeLowPt = inPolygon[ p ];
				let edgeHighPt = inPolygon[ q ];

				let edgeDx = edgeHighPt.x - edgeLowPt.x;
				let edgeDy = edgeHighPt.y - edgeLowPt.y;

				if ( Math.abs( edgeDy ) > Number.EPSILON ) {

					// not parallel
					if ( edgeDy < 0 ) {

						edgeLowPt = inPolygon[ q ]; edgeDx = - edgeDx;
						edgeHighPt = inPolygon[ p ]; edgeDy = - edgeDy;

					}

					if ( ( inPt.y < edgeLowPt.y ) || ( inPt.y > edgeHighPt.y ) ) 		continue;

					if ( inPt.y === edgeLowPt.y ) {

						if ( inPt.x === edgeLowPt.x )		return	true;		// inPt is on contour ?
						// continue;				// no intersection or edgeLowPt => doesn't count !!!

					} else {

						const perpEdge = edgeDy * ( inPt.x - edgeLowPt.x ) - edgeDx * ( inPt.y - edgeLowPt.y );
						if ( perpEdge === 0 )				return	true;		// inPt is on contour ?
						if ( perpEdge < 0 ) 				continue;
						inside = ! inside;		// true intersection left of inPt

					}

				} else {

					// parallel or collinear
					if ( inPt.y !== edgeLowPt.y ) 		continue;			// parallel
					// edge lies on the same horizontal line as inPt
					if ( ( ( edgeHighPt.x <= inPt.x ) && ( inPt.x <= edgeLowPt.x ) ) ||
						 ( ( edgeLowPt.x <= inPt.x ) && ( inPt.x <= edgeHighPt.x ) ) )		return	true;	// inPt: Point on contour !
					// continue;

				}

			}

			return	inside;

		}

		const isClockWise = ShapeUtils.isClockWise;

		const subPaths = this.subPaths;
		if ( subPaths.length === 0 ) return [];

		let solid, tmpPath, tmpShape;
		const shapes = [];

		if ( subPaths.length === 1 ) {

			tmpPath = subPaths[ 0 ];
			tmpShape = new Shape();
			tmpShape.curves = tmpPath.curves;
			shapes.push( tmpShape );
			return shapes;

		}

		let holesFirst = ! isClockWise( subPaths[ 0 ].getPoints() );
		holesFirst = isCCW ? ! holesFirst : holesFirst;

		// console.log("Holes first", holesFirst);

		const betterShapeHoles = [];
		const newShapes = [];
		let newShapeHoles = [];
		let mainIdx = 0;
		let tmpPoints;

		newShapes[ mainIdx ] = undefined;
		newShapeHoles[ mainIdx ] = [];

		for ( let i = 0, l = subPaths.length; i < l; i ++ ) {

			tmpPath = subPaths[ i ];
			tmpPoints = tmpPath.getPoints();
			solid = isClockWise( tmpPoints );
			solid = isCCW ? ! solid : solid;

			if ( solid ) {

				if ( ( ! holesFirst ) && ( newShapes[ mainIdx ] ) )	mainIdx ++;

				newShapes[ mainIdx ] = { s: new Shape(), p: tmpPoints };
				newShapes[ mainIdx ].s.curves = tmpPath.curves;

				if ( holesFirst )	mainIdx ++;
				newShapeHoles[ mainIdx ] = [];

				//console.log('cw', i);

			} else {

				newShapeHoles[ mainIdx ].push( { h: tmpPath, p: tmpPoints[ 0 ] } );

				//console.log('ccw', i);

			}

		}

		// only Holes? -> probably all Shapes with wrong orientation
		if ( ! newShapes[ 0 ] )	return	toShapesNoHoles( subPaths );


		if ( newShapes.length > 1 ) {

			let ambiguous = false;
			let toChange = 0;

			for ( let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx ++ ) {

				betterShapeHoles[ sIdx ] = [];

			}

			for ( let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx ++ ) {

				const sho = newShapeHoles[ sIdx ];

				for ( let hIdx = 0; hIdx < sho.length; hIdx ++ ) {

					const ho = sho[ hIdx ];
					let hole_unassigned = true;

					for ( let s2Idx = 0; s2Idx < newShapes.length; s2Idx ++ ) {

						if ( isPointInsidePolygon( ho.p, newShapes[ s2Idx ].p ) ) {

							if ( sIdx !== s2Idx )	toChange ++;

							if ( hole_unassigned ) {

								hole_unassigned = false;
								betterShapeHoles[ s2Idx ].push( ho );

							} else {

								ambiguous = true;

							}

						}

					}

					if ( hole_unassigned ) {

						betterShapeHoles[ sIdx ].push( ho );

					}

				}

			}

			if ( toChange > 0 && ambiguous === false ) {

				newShapeHoles = betterShapeHoles;

			}

		}

		let tmpHoles;

		for ( let i = 0, il = newShapes.length; i < il; i ++ ) {

			tmpShape = newShapes[ i ].s;
			shapes.push( tmpShape );
			tmpHoles = newShapeHoles[ i ];

			for ( let j = 0, jl = tmpHoles.length; j < jl; j ++ ) {

				tmpShape.holes.push( tmpHoles[ j ].h );

			}

		}

		//console.log("shape", shapes);

		return shapes;

	}

}

class WebGLMultipleRenderTargets extends (/* unused pure expression or super */ null && (WebGLRenderTarget)) { // @deprecated, r162

	constructor( width = 1, height = 1, count = 1, options = {} ) {

		console.warn( 'THREE.WebGLMultipleRenderTargets has been deprecated and will be removed in r172. Use THREE.WebGLRenderTarget and set the "count" parameter to enable MRT.' );

		super( width, height, { ...options, count } );

		this.isWebGLMultipleRenderTargets = true;

	}

	get texture() {

		return this.textures;

	}

}

if ( typeof __THREE_DEVTOOLS__ !== 'undefined' ) {

	__THREE_DEVTOOLS__.dispatchEvent( new CustomEvent( 'register', { detail: {
		revision: REVISION,
	} } ) );

}

if ( typeof window !== 'undefined' ) {

	if ( window.__THREE__ ) {

		console.warn( 'WARNING: Multiple instances of Three.js being imported.' );

	} else {

		window.__THREE__ = REVISION;

	}

}




/***/ }),

/***/ 5079:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var Stats = function () {

	var mode = 0;

	var container = document.createElement( 'div' );
	container.style.cssText = 'position:fixed;top:0;left:0;cursor:pointer;opacity:0.9;z-index:10000';
	container.addEventListener( 'click', function ( event ) {

		event.preventDefault();
		showPanel( ++ mode % container.children.length );

	}, false );

	//

	function addPanel( panel ) {

		container.appendChild( panel.dom );
		return panel;

	}

	function showPanel( id ) {

		for ( var i = 0; i < container.children.length; i ++ ) {

			container.children[ i ].style.display = i === id ? 'block' : 'none';

		}

		mode = id;

	}

	//

	var beginTime = ( performance || Date ).now(), prevTime = beginTime, frames = 0;

	var fpsPanel = addPanel( new Stats.Panel( 'FPS', '#0ff', '#002' ) );
	var msPanel = addPanel( new Stats.Panel( 'MS', '#0f0', '#020' ) );

	if ( self.performance && self.performance.memory ) {

		var memPanel = addPanel( new Stats.Panel( 'MB', '#f08', '#201' ) );

	}

	showPanel( 0 );

	return {

		REVISION: 16,

		dom: container,

		addPanel: addPanel,
		showPanel: showPanel,

		begin: function () {

			beginTime = ( performance || Date ).now();

		},

		end: function () {

			frames ++;

			var time = ( performance || Date ).now();

			msPanel.update( time - beginTime, 200 );

			if ( time >= prevTime + 1000 ) {

				fpsPanel.update( ( frames * 1000 ) / ( time - prevTime ), 100 );

				prevTime = time;
				frames = 0;

				if ( memPanel ) {

					var memory = performance.memory;
					memPanel.update( memory.usedJSHeapSize / 1048576, memory.jsHeapSizeLimit / 1048576 );

				}

			}

			return time;

		},

		update: function () {

			beginTime = this.end();

		},

		// Backwards Compatibility

		domElement: container,
		setMode: showPanel

	};

};

Stats.Panel = function ( name, fg, bg ) {

	var min = Infinity, max = 0, round = Math.round;
	var PR = round( window.devicePixelRatio || 1 );

	var WIDTH = 80 * PR, HEIGHT = 48 * PR,
		TEXT_X = 3 * PR, TEXT_Y = 2 * PR,
		GRAPH_X = 3 * PR, GRAPH_Y = 15 * PR,
		GRAPH_WIDTH = 74 * PR, GRAPH_HEIGHT = 30 * PR;

	var canvas = document.createElement( 'canvas' );
	canvas.width = WIDTH;
	canvas.height = HEIGHT;
	canvas.style.cssText = 'width:80px;height:48px';

	var context = canvas.getContext( '2d' );
	context.font = 'bold ' + ( 9 * PR ) + 'px Helvetica,Arial,sans-serif';
	context.textBaseline = 'top';

	context.fillStyle = bg;
	context.fillRect( 0, 0, WIDTH, HEIGHT );

	context.fillStyle = fg;
	context.fillText( name, TEXT_X, TEXT_Y );
	context.fillRect( GRAPH_X, GRAPH_Y, GRAPH_WIDTH, GRAPH_HEIGHT );

	context.fillStyle = bg;
	context.globalAlpha = 0.9;
	context.fillRect( GRAPH_X, GRAPH_Y, GRAPH_WIDTH, GRAPH_HEIGHT );

	return {

		dom: canvas,

		update: function ( value, maxValue ) {

			min = Math.min( min, value );
			max = Math.max( max, value );

			context.fillStyle = bg;
			context.globalAlpha = 1;
			context.fillRect( 0, 0, WIDTH, GRAPH_Y );
			context.fillStyle = fg;
			context.fillText( round( value ) + ' ' + name + ' (' + round( min ) + '-' + round( max ) + ')', TEXT_X, TEXT_Y );

			context.drawImage( canvas, GRAPH_X + PR, GRAPH_Y, GRAPH_WIDTH - PR, GRAPH_HEIGHT, GRAPH_X, GRAPH_Y, GRAPH_WIDTH - PR, GRAPH_HEIGHT );

			context.fillRect( GRAPH_X + GRAPH_WIDTH - PR, GRAPH_Y, PR, GRAPH_HEIGHT );

			context.fillStyle = bg;
			context.globalAlpha = 0.9;
			context.fillRect( GRAPH_X + GRAPH_WIDTH - PR, GRAPH_Y, PR, round( ( 1 - ( value / maxValue ) ) * GRAPH_HEIGHT ) );

		}

	};

};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Stats);


/***/ }),

/***/ 1764:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CSS2DObject: () => (/* binding */ CSS2DObject),
/* harmony export */   CSS2DRenderer: () => (/* binding */ CSS2DRenderer)
/* harmony export */ });
/* harmony import */ var three__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9477);


class CSS2DObject extends three__WEBPACK_IMPORTED_MODULE_0__/* .Object3D */ .Tme {

	constructor( element = document.createElement( 'div' ) ) {

		super();

		this.isCSS2DObject = true;

		this.element = element;

		this.element.style.position = 'absolute';
		this.element.style.userSelect = 'none';

		this.element.setAttribute( 'draggable', false );

		this.center = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector2 */ .FM8( 0.5, 0.5 ); // ( 0, 0 ) is the lower left; ( 1, 1 ) is the top right

		this.addEventListener( 'removed', function () {

			this.traverse( function ( object ) {

				if ( object.element instanceof Element && object.element.parentNode !== null ) {

					object.element.parentNode.removeChild( object.element );

				}

			} );

		} );

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		this.element = source.element.cloneNode( true );

		this.center = source.center;

		return this;

	}

}

//

const _vector = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const _viewMatrix = new three__WEBPACK_IMPORTED_MODULE_0__/* .Matrix4 */ .yGw();
const _viewProjectionMatrix = new three__WEBPACK_IMPORTED_MODULE_0__/* .Matrix4 */ .yGw();
const _a = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const _b = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();

class CSS2DRenderer {

	constructor( parameters = {} ) {

		const _this = this;

		let _width, _height;
		let _widthHalf, _heightHalf;

		const cache = {
			objects: new WeakMap()
		};

		const domElement = parameters.element !== undefined ? parameters.element : document.createElement( 'div' );

		domElement.style.overflow = 'hidden';

		this.domElement = domElement;

		this.getSize = function () {

			return {
				width: _width,
				height: _height
			};

		};

		this.render = function ( scene, camera ) {

			if ( scene.matrixWorldAutoUpdate === true ) scene.updateMatrixWorld();
			if ( camera.parent === null && camera.matrixWorldAutoUpdate === true ) camera.updateMatrixWorld();

			_viewMatrix.copy( camera.matrixWorldInverse );
			_viewProjectionMatrix.multiplyMatrices( camera.projectionMatrix, _viewMatrix );

			renderObject( scene, scene, camera );
			zOrder( scene );

		};

		this.setSize = function ( width, height ) {

			_width = width;
			_height = height;

			_widthHalf = _width / 2;
			_heightHalf = _height / 2;

			domElement.style.width = width + 'px';
			domElement.style.height = height + 'px';

		};

		function renderObject( object, scene, camera ) {

			if ( object.isCSS2DObject ) {

				_vector.setFromMatrixPosition( object.matrixWorld );
				_vector.applyMatrix4( _viewProjectionMatrix );

				const visible = ( object.visible === true ) && ( _vector.z >= - 1 && _vector.z <= 1 ) && ( object.layers.test( camera.layers ) === true );
				object.element.style.display = ( visible === true ) ? '' : 'none';

				if ( visible === true ) {

					object.onBeforeRender( _this, scene, camera );

					const element = object.element;

					element.style.transform = 'translate(' + ( - 100 * object.center.x ) + '%,' + ( - 100 * object.center.y ) + '%)' + 'translate(' + ( _vector.x * _widthHalf + _widthHalf ) + 'px,' + ( - _vector.y * _heightHalf + _heightHalf ) + 'px)';

					if ( element.parentNode !== domElement ) {

						domElement.appendChild( element );

					}

					object.onAfterRender( _this, scene, camera );

				}

				const objectData = {
					distanceToCameraSquared: getDistanceToSquared( camera, object )
				};

				cache.objects.set( object, objectData );

			}

			for ( let i = 0, l = object.children.length; i < l; i ++ ) {

				renderObject( object.children[ i ], scene, camera );

			}

		}

		function getDistanceToSquared( object1, object2 ) {

			_a.setFromMatrixPosition( object1.matrixWorld );
			_b.setFromMatrixPosition( object2.matrixWorld );

			return _a.distanceToSquared( _b );

		}

		function filterAndFlatten( scene ) {

			const result = [];

			scene.traverse( function ( object ) {

				if ( object.isCSS2DObject ) result.push( object );

			} );

			return result;

		}

		function zOrder( scene ) {

			const sorted = filterAndFlatten( scene ).sort( function ( a, b ) {

				if ( a.renderOrder !== b.renderOrder ) {

					return b.renderOrder - a.renderOrder;

				}

				const distanceA = cache.objects.get( a ).distanceToCameraSquared;
				const distanceB = cache.objects.get( b ).distanceToCameraSquared;

				return distanceA - distanceB;

			} );

			const zMax = sorted.length;

			for ( let i = 0, l = sorted.length; i < l; i ++ ) {

				sorted[ i ].element.style.zIndex = zMax - i;

			}

		}

	}

}




/***/ }),

/***/ 9471:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CSS3DObject: () => (/* binding */ CSS3DObject),
/* harmony export */   CSS3DRenderer: () => (/* binding */ CSS3DRenderer),
/* harmony export */   CSS3DSprite: () => (/* binding */ CSS3DSprite)
/* harmony export */ });
/* harmony import */ var three__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9477);


/**
 * Based on http://www.emagix.net/academic/mscs-project/item/camera-sync-with-css3-and-webgl-threejs
 */

const _position = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const _quaternion = new three__WEBPACK_IMPORTED_MODULE_0__/* .Quaternion */ ._fP();
const _scale = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();

class CSS3DObject extends three__WEBPACK_IMPORTED_MODULE_0__/* .Object3D */ .Tme {

	constructor( element = document.createElement( 'div' ) ) {

		super();

		this.isCSS3DObject = true;

		this.element = element;
		this.element.style.position = 'absolute';
		this.element.style.pointerEvents = 'auto';
		this.element.style.userSelect = 'none';

		this.element.setAttribute( 'draggable', false );

		this.addEventListener( 'removed', function () {

			this.traverse( function ( object ) {

				if ( object.element instanceof Element && object.element.parentNode !== null ) {

					object.element.parentNode.removeChild( object.element );

				}

			} );

		} );

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		this.element = source.element.cloneNode( true );

		return this;

	}

}

class CSS3DSprite extends CSS3DObject {

	constructor( element ) {

		super( element );

		this.isCSS3DSprite = true;

		this.rotation2D = 0;

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		this.rotation2D = source.rotation2D;

		return this;

	}

}

//

const _matrix = new three__WEBPACK_IMPORTED_MODULE_0__/* .Matrix4 */ .yGw();
const _matrix2 = new three__WEBPACK_IMPORTED_MODULE_0__/* .Matrix4 */ .yGw();

class CSS3DRenderer {

	constructor( parameters = {} ) {

		const _this = this;

		let _width, _height;
		let _widthHalf, _heightHalf;

		const cache = {
			camera: { style: '' },
			objects: new WeakMap()
		};

		const domElement = parameters.element !== undefined ? parameters.element : document.createElement( 'div' );

		domElement.style.overflow = 'hidden';

		this.domElement = domElement;

		const viewElement = document.createElement( 'div' );
		viewElement.style.transformOrigin = '0 0';
		viewElement.style.pointerEvents = 'none';
		domElement.appendChild( viewElement );

		const cameraElement = document.createElement( 'div' );

		cameraElement.style.transformStyle = 'preserve-3d';

		viewElement.appendChild( cameraElement );

		this.getSize = function () {

			return {
				width: _width,
				height: _height
			};

		};

		this.render = function ( scene, camera ) {

			const fov = camera.projectionMatrix.elements[ 5 ] * _heightHalf;

			if ( camera.view && camera.view.enabled ) {

				// view offset
				viewElement.style.transform = `translate( ${ - camera.view.offsetX * ( _width / camera.view.width ) }px, ${ - camera.view.offsetY * ( _height / camera.view.height ) }px )`;

				// view fullWidth and fullHeight, view width and height
				viewElement.style.transform += `scale( ${ camera.view.fullWidth / camera.view.width }, ${ camera.view.fullHeight / camera.view.height } )`;

			} else {

				viewElement.style.transform = '';

			}

			if ( scene.matrixWorldAutoUpdate === true ) scene.updateMatrixWorld();
			if ( camera.parent === null && camera.matrixWorldAutoUpdate === true ) camera.updateMatrixWorld();

			let tx, ty;

			if ( camera.isOrthographicCamera ) {

				tx = - ( camera.right + camera.left ) / 2;
				ty = ( camera.top + camera.bottom ) / 2;

			}

			const scaleByViewOffset = camera.view && camera.view.enabled ? camera.view.height / camera.view.fullHeight : 1;
			const cameraCSSMatrix = camera.isOrthographicCamera ?
				`scale( ${ scaleByViewOffset } )` + 'scale(' + fov + ')' + 'translate(' + epsilon( tx ) + 'px,' + epsilon( ty ) + 'px)' + getCameraCSSMatrix( camera.matrixWorldInverse ) :
				`scale( ${ scaleByViewOffset } )` + 'translateZ(' + fov + 'px)' + getCameraCSSMatrix( camera.matrixWorldInverse );
			const perspective = camera.isPerspectiveCamera ? 'perspective(' + fov + 'px) ' : '';

			const style = perspective + cameraCSSMatrix +
				'translate(' + _widthHalf + 'px,' + _heightHalf + 'px)';

			if ( cache.camera.style !== style ) {

				cameraElement.style.transform = style;

				cache.camera.style = style;

			}

			renderObject( scene, scene, camera, cameraCSSMatrix );

		};

		this.setSize = function ( width, height ) {

			_width = width;
			_height = height;
			_widthHalf = _width / 2;
			_heightHalf = _height / 2;

			domElement.style.width = width + 'px';
			domElement.style.height = height + 'px';

			viewElement.style.width = width + 'px';
			viewElement.style.height = height + 'px';

			cameraElement.style.width = width + 'px';
			cameraElement.style.height = height + 'px';

		};

		function epsilon( value ) {

			return Math.abs( value ) < 1e-10 ? 0 : value;

		}

		function getCameraCSSMatrix( matrix ) {

			const elements = matrix.elements;

			return 'matrix3d(' +
				epsilon( elements[ 0 ] ) + ',' +
				epsilon( - elements[ 1 ] ) + ',' +
				epsilon( elements[ 2 ] ) + ',' +
				epsilon( elements[ 3 ] ) + ',' +
				epsilon( elements[ 4 ] ) + ',' +
				epsilon( - elements[ 5 ] ) + ',' +
				epsilon( elements[ 6 ] ) + ',' +
				epsilon( elements[ 7 ] ) + ',' +
				epsilon( elements[ 8 ] ) + ',' +
				epsilon( - elements[ 9 ] ) + ',' +
				epsilon( elements[ 10 ] ) + ',' +
				epsilon( elements[ 11 ] ) + ',' +
				epsilon( elements[ 12 ] ) + ',' +
				epsilon( - elements[ 13 ] ) + ',' +
				epsilon( elements[ 14 ] ) + ',' +
				epsilon( elements[ 15 ] ) +
			')';

		}

		function getObjectCSSMatrix( matrix ) {

			const elements = matrix.elements;
			const matrix3d = 'matrix3d(' +
				epsilon( elements[ 0 ] ) + ',' +
				epsilon( elements[ 1 ] ) + ',' +
				epsilon( elements[ 2 ] ) + ',' +
				epsilon( elements[ 3 ] ) + ',' +
				epsilon( - elements[ 4 ] ) + ',' +
				epsilon( - elements[ 5 ] ) + ',' +
				epsilon( - elements[ 6 ] ) + ',' +
				epsilon( - elements[ 7 ] ) + ',' +
				epsilon( elements[ 8 ] ) + ',' +
				epsilon( elements[ 9 ] ) + ',' +
				epsilon( elements[ 10 ] ) + ',' +
				epsilon( elements[ 11 ] ) + ',' +
				epsilon( elements[ 12 ] ) + ',' +
				epsilon( elements[ 13 ] ) + ',' +
				epsilon( elements[ 14 ] ) + ',' +
				epsilon( elements[ 15 ] ) +
			')';

			return 'translate(-50%,-50%)' + matrix3d;

		}

		function renderObject( object, scene, camera, cameraCSSMatrix ) {

			if ( object.isCSS3DObject ) {

				const visible = ( object.visible === true ) && ( object.layers.test( camera.layers ) === true );
				object.element.style.display = ( visible === true ) ? '' : 'none';

				if ( visible === true ) {

					object.onBeforeRender( _this, scene, camera );

					let style;

					if ( object.isCSS3DSprite ) {

						// http://swiftcoder.wordpress.com/2008/11/25/constructing-a-billboard-matrix/

						_matrix.copy( camera.matrixWorldInverse );
						_matrix.transpose();

						if ( object.rotation2D !== 0 ) _matrix.multiply( _matrix2.makeRotationZ( object.rotation2D ) );

						object.matrixWorld.decompose( _position, _quaternion, _scale );
						_matrix.setPosition( _position );
						_matrix.scale( _scale );

						_matrix.elements[ 3 ] = 0;
						_matrix.elements[ 7 ] = 0;
						_matrix.elements[ 11 ] = 0;
						_matrix.elements[ 15 ] = 1;

						style = getObjectCSSMatrix( _matrix );

					} else {

						style = getObjectCSSMatrix( object.matrixWorld );

					}

					const element = object.element;
					const cachedObject = cache.objects.get( object );

					if ( cachedObject === undefined || cachedObject.style !== style ) {

						element.style.transform = style;

						const objectData = { style: style };
						cache.objects.set( object, objectData );

					}

					if ( element.parentNode !== cameraElement ) {

						cameraElement.appendChild( element );

					}

					object.onAfterRender( _this, scene, camera );

				}

			}

			for ( let i = 0, l = object.children.length; i < l; i ++ ) {

				renderObject( object.children[ i ], scene, camera, cameraCSSMatrix );

			}

		}

	}

}




/***/ }),

/***/ 140:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   computeMikkTSpaceTangents: () => (/* binding */ computeMikkTSpaceTangents),
/* harmony export */   computeMorphedAttributes: () => (/* binding */ computeMorphedAttributes),
/* harmony export */   deepCloneAttribute: () => (/* binding */ deepCloneAttribute),
/* harmony export */   deinterleaveAttribute: () => (/* binding */ deinterleaveAttribute),
/* harmony export */   deinterleaveGeometry: () => (/* binding */ deinterleaveGeometry),
/* harmony export */   estimateBytesUsed: () => (/* binding */ estimateBytesUsed),
/* harmony export */   interleaveAttributes: () => (/* binding */ interleaveAttributes),
/* harmony export */   mergeAttributes: () => (/* binding */ mergeAttributes),
/* harmony export */   mergeGeometries: () => (/* binding */ mergeGeometries),
/* harmony export */   mergeGroups: () => (/* binding */ mergeGroups),
/* harmony export */   mergeVertices: () => (/* binding */ mergeVertices),
/* harmony export */   toCreasedNormals: () => (/* binding */ toCreasedNormals),
/* harmony export */   toTrianglesDrawMode: () => (/* binding */ toTrianglesDrawMode)
/* harmony export */ });
/* harmony import */ var three__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9477);


function computeMikkTSpaceTangents( geometry, MikkTSpace, negateSign = true ) {

	if ( ! MikkTSpace || ! MikkTSpace.isReady ) {

		throw new Error( 'BufferGeometryUtils: Initialized MikkTSpace library required.' );

	}

	if ( ! geometry.hasAttribute( 'position' ) || ! geometry.hasAttribute( 'normal' ) || ! geometry.hasAttribute( 'uv' ) ) {

		throw new Error( 'BufferGeometryUtils: Tangents require "position", "normal", and "uv" attributes.' );

	}

	function getAttributeArray( attribute ) {

		if ( attribute.normalized || attribute.isInterleavedBufferAttribute ) {

			const dstArray = new Float32Array( attribute.count * attribute.itemSize );

			for ( let i = 0, j = 0; i < attribute.count; i ++ ) {

				dstArray[ j ++ ] = attribute.getX( i );
				dstArray[ j ++ ] = attribute.getY( i );

				if ( attribute.itemSize > 2 ) {

					dstArray[ j ++ ] = attribute.getZ( i );

				}

			}

			return dstArray;

		}

		if ( attribute.array instanceof Float32Array ) {

			return attribute.array;

		}

		return new Float32Array( attribute.array );

	}

	// MikkTSpace algorithm requires non-indexed input.

	const _geometry = geometry.index ? geometry.toNonIndexed() : geometry;

	// Compute vertex tangents.

	const tangents = MikkTSpace.generateTangents(

		getAttributeArray( _geometry.attributes.position ),
		getAttributeArray( _geometry.attributes.normal ),
		getAttributeArray( _geometry.attributes.uv )

	);

	// Texture coordinate convention of glTF differs from the apparent
	// default of the MikkTSpace library; .w component must be flipped.

	if ( negateSign ) {

		for ( let i = 3; i < tangents.length; i += 4 ) {

			tangents[ i ] *= - 1;

		}

	}

	//

	_geometry.setAttribute( 'tangent', new three__WEBPACK_IMPORTED_MODULE_0__/* .BufferAttribute */ .TlE( tangents, 4 ) );

	if ( geometry !== _geometry ) {

		geometry.copy( _geometry );

	}

	return geometry;

}

/**
 * @param  {Array<BufferGeometry>} geometries
 * @param  {Boolean} useGroups
 * @return {BufferGeometry}
 */
function mergeGeometries( geometries, useGroups = false ) {

	const isIndexed = geometries[ 0 ].index !== null;

	const attributesUsed = new Set( Object.keys( geometries[ 0 ].attributes ) );
	const morphAttributesUsed = new Set( Object.keys( geometries[ 0 ].morphAttributes ) );

	const attributes = {};
	const morphAttributes = {};

	const morphTargetsRelative = geometries[ 0 ].morphTargetsRelative;

	const mergedGeometry = new three__WEBPACK_IMPORTED_MODULE_0__/* .BufferGeometry */ .u9r();

	let offset = 0;

	for ( let i = 0; i < geometries.length; ++ i ) {

		const geometry = geometries[ i ];
		let attributesCount = 0;

		// ensure that all geometries are indexed, or none

		if ( isIndexed !== ( geometry.index !== null ) ) {

			console.error( 'THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. All geometries must have compatible attributes; make sure index attribute exists among all geometries, or in none of them.' );
			return null;

		}

		// gather attributes, exit early if they're different

		for ( const name in geometry.attributes ) {

			if ( ! attributesUsed.has( name ) ) {

				console.error( 'THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. All geometries must have compatible attributes; make sure "' + name + '" attribute exists among all geometries, or in none of them.' );
				return null;

			}

			if ( attributes[ name ] === undefined ) attributes[ name ] = [];

			attributes[ name ].push( geometry.attributes[ name ] );

			attributesCount ++;

		}

		// ensure geometries have the same number of attributes

		if ( attributesCount !== attributesUsed.size ) {

			console.error( 'THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. Make sure all geometries have the same number of attributes.' );
			return null;

		}

		// gather morph attributes, exit early if they're different

		if ( morphTargetsRelative !== geometry.morphTargetsRelative ) {

			console.error( 'THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. .morphTargetsRelative must be consistent throughout all geometries.' );
			return null;

		}

		for ( const name in geometry.morphAttributes ) {

			if ( ! morphAttributesUsed.has( name ) ) {

				console.error( 'THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '.  .morphAttributes must be consistent throughout all geometries.' );
				return null;

			}

			if ( morphAttributes[ name ] === undefined ) morphAttributes[ name ] = [];

			morphAttributes[ name ].push( geometry.morphAttributes[ name ] );

		}

		if ( useGroups ) {

			let count;

			if ( isIndexed ) {

				count = geometry.index.count;

			} else if ( geometry.attributes.position !== undefined ) {

				count = geometry.attributes.position.count;

			} else {

				console.error( 'THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. The geometry must have either an index or a position attribute' );
				return null;

			}

			mergedGeometry.addGroup( offset, count, i );

			offset += count;

		}

	}

	// merge indices

	if ( isIndexed ) {

		let indexOffset = 0;
		const mergedIndex = [];

		for ( let i = 0; i < geometries.length; ++ i ) {

			const index = geometries[ i ].index;

			for ( let j = 0; j < index.count; ++ j ) {

				mergedIndex.push( index.getX( j ) + indexOffset );

			}

			indexOffset += geometries[ i ].attributes.position.count;

		}

		mergedGeometry.setIndex( mergedIndex );

	}

	// merge attributes

	for ( const name in attributes ) {

		const mergedAttribute = mergeAttributes( attributes[ name ] );

		if ( ! mergedAttribute ) {

			console.error( 'THREE.BufferGeometryUtils: .mergeGeometries() failed while trying to merge the ' + name + ' attribute.' );
			return null;

		}

		mergedGeometry.setAttribute( name, mergedAttribute );

	}

	// merge morph attributes

	for ( const name in morphAttributes ) {

		const numMorphTargets = morphAttributes[ name ][ 0 ].length;

		if ( numMorphTargets === 0 ) break;

		mergedGeometry.morphAttributes = mergedGeometry.morphAttributes || {};
		mergedGeometry.morphAttributes[ name ] = [];

		for ( let i = 0; i < numMorphTargets; ++ i ) {

			const morphAttributesToMerge = [];

			for ( let j = 0; j < morphAttributes[ name ].length; ++ j ) {

				morphAttributesToMerge.push( morphAttributes[ name ][ j ][ i ] );

			}

			const mergedMorphAttribute = mergeAttributes( morphAttributesToMerge );

			if ( ! mergedMorphAttribute ) {

				console.error( 'THREE.BufferGeometryUtils: .mergeGeometries() failed while trying to merge the ' + name + ' morphAttribute.' );
				return null;

			}

			mergedGeometry.morphAttributes[ name ].push( mergedMorphAttribute );

		}

	}

	return mergedGeometry;

}

/**
 * @param {Array<BufferAttribute>} attributes
 * @return {BufferAttribute}
 */
function mergeAttributes( attributes ) {

	let TypedArray;
	let itemSize;
	let normalized;
	let gpuType = - 1;
	let arrayLength = 0;

	for ( let i = 0; i < attributes.length; ++ i ) {

		const attribute = attributes[ i ];

		if ( TypedArray === undefined ) TypedArray = attribute.array.constructor;
		if ( TypedArray !== attribute.array.constructor ) {

			console.error( 'THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.array must be of consistent array types across matching attributes.' );
			return null;

		}

		if ( itemSize === undefined ) itemSize = attribute.itemSize;
		if ( itemSize !== attribute.itemSize ) {

			console.error( 'THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.itemSize must be consistent across matching attributes.' );
			return null;

		}

		if ( normalized === undefined ) normalized = attribute.normalized;
		if ( normalized !== attribute.normalized ) {

			console.error( 'THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.normalized must be consistent across matching attributes.' );
			return null;

		}

		if ( gpuType === - 1 ) gpuType = attribute.gpuType;
		if ( gpuType !== attribute.gpuType ) {

			console.error( 'THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.gpuType must be consistent across matching attributes.' );
			return null;

		}

		arrayLength += attribute.count * itemSize;

	}

	const array = new TypedArray( arrayLength );
	const result = new three__WEBPACK_IMPORTED_MODULE_0__/* .BufferAttribute */ .TlE( array, itemSize, normalized );
	let offset = 0;

	for ( let i = 0; i < attributes.length; ++ i ) {

		const attribute = attributes[ i ];
		if ( attribute.isInterleavedBufferAttribute ) {

			const tupleOffset = offset / itemSize;
			for ( let j = 0, l = attribute.count; j < l; j ++ ) {

				for ( let c = 0; c < itemSize; c ++ ) {

					const value = attribute.getComponent( j, c );
					result.setComponent( j + tupleOffset, c, value );

				}

			}

		} else {

			array.set( attribute.array, offset );

		}

		offset += attribute.count * itemSize;

	}

	if ( gpuType !== undefined ) {

		result.gpuType = gpuType;

	}

	return result;

}

/**
 * @param {BufferAttribute}
 * @return {BufferAttribute}
 */
function deepCloneAttribute( attribute ) {

	if ( attribute.isInstancedInterleavedBufferAttribute || attribute.isInterleavedBufferAttribute ) {

		return deinterleaveAttribute( attribute );

	}

	if ( attribute.isInstancedBufferAttribute ) {

		return new three__WEBPACK_IMPORTED_MODULE_0__/* .InstancedBufferAttribute */ .lb7().copy( attribute );

	}

	return new three__WEBPACK_IMPORTED_MODULE_0__/* .BufferAttribute */ .TlE().copy( attribute );

}

/**
 * @param {Array<BufferAttribute>} attributes
 * @return {Array<InterleavedBufferAttribute>}
 */
function interleaveAttributes( attributes ) {

	// Interleaves the provided attributes into an InterleavedBuffer and returns
	// a set of InterleavedBufferAttributes for each attribute
	let TypedArray;
	let arrayLength = 0;
	let stride = 0;

	// calculate the length and type of the interleavedBuffer
	for ( let i = 0, l = attributes.length; i < l; ++ i ) {

		const attribute = attributes[ i ];

		if ( TypedArray === undefined ) TypedArray = attribute.array.constructor;
		if ( TypedArray !== attribute.array.constructor ) {

			console.error( 'AttributeBuffers of different types cannot be interleaved' );
			return null;

		}

		arrayLength += attribute.array.length;
		stride += attribute.itemSize;

	}

	// Create the set of buffer attributes
	const interleavedBuffer = new three__WEBPACK_IMPORTED_MODULE_0__/* .InterleavedBuffer */ .vpT( new TypedArray( arrayLength ), stride );
	let offset = 0;
	const res = [];
	const getters = [ 'getX', 'getY', 'getZ', 'getW' ];
	const setters = [ 'setX', 'setY', 'setZ', 'setW' ];

	for ( let j = 0, l = attributes.length; j < l; j ++ ) {

		const attribute = attributes[ j ];
		const itemSize = attribute.itemSize;
		const count = attribute.count;
		const iba = new three__WEBPACK_IMPORTED_MODULE_0__/* .InterleavedBufferAttribute */ .kB5( interleavedBuffer, itemSize, offset, attribute.normalized );
		res.push( iba );

		offset += itemSize;

		// Move the data for each attribute into the new interleavedBuffer
		// at the appropriate offset
		for ( let c = 0; c < count; c ++ ) {

			for ( let k = 0; k < itemSize; k ++ ) {

				iba[ setters[ k ] ]( c, attribute[ getters[ k ] ]( c ) );

			}

		}

	}

	return res;

}

// returns a new, non-interleaved version of the provided attribute
function deinterleaveAttribute( attribute ) {

	const cons = attribute.data.array.constructor;
	const count = attribute.count;
	const itemSize = attribute.itemSize;
	const normalized = attribute.normalized;

	const array = new cons( count * itemSize );
	let newAttribute;
	if ( attribute.isInstancedInterleavedBufferAttribute ) {

		newAttribute = new three__WEBPACK_IMPORTED_MODULE_0__/* .InstancedBufferAttribute */ .lb7( array, itemSize, normalized, attribute.meshPerAttribute );

	} else {

		newAttribute = new three__WEBPACK_IMPORTED_MODULE_0__/* .BufferAttribute */ .TlE( array, itemSize, normalized );

	}

	for ( let i = 0; i < count; i ++ ) {

		newAttribute.setX( i, attribute.getX( i ) );

		if ( itemSize >= 2 ) {

			newAttribute.setY( i, attribute.getY( i ) );

		}

		if ( itemSize >= 3 ) {

			newAttribute.setZ( i, attribute.getZ( i ) );

		}

		if ( itemSize >= 4 ) {

			newAttribute.setW( i, attribute.getW( i ) );

		}

	}

	return newAttribute;

}

// deinterleaves all attributes on the geometry
function deinterleaveGeometry( geometry ) {

	const attributes = geometry.attributes;
	const morphTargets = geometry.morphTargets;
	const attrMap = new Map();

	for ( const key in attributes ) {

		const attr = attributes[ key ];
		if ( attr.isInterleavedBufferAttribute ) {

			if ( ! attrMap.has( attr ) ) {

				attrMap.set( attr, deinterleaveAttribute( attr ) );

			}

			attributes[ key ] = attrMap.get( attr );

		}

	}

	for ( const key in morphTargets ) {

		const attr = morphTargets[ key ];
		if ( attr.isInterleavedBufferAttribute ) {

			if ( ! attrMap.has( attr ) ) {

				attrMap.set( attr, deinterleaveAttribute( attr ) );

			}

			morphTargets[ key ] = attrMap.get( attr );

		}

	}

}

/**
 * @param {BufferGeometry} geometry
 * @return {number}
 */
function estimateBytesUsed( geometry ) {

	// Return the estimated memory used by this geometry in bytes
	// Calculate using itemSize, count, and BYTES_PER_ELEMENT to account
	// for InterleavedBufferAttributes.
	let mem = 0;
	for ( const name in geometry.attributes ) {

		const attr = geometry.getAttribute( name );
		mem += attr.count * attr.itemSize * attr.array.BYTES_PER_ELEMENT;

	}

	const indices = geometry.getIndex();
	mem += indices ? indices.count * indices.itemSize * indices.array.BYTES_PER_ELEMENT : 0;
	return mem;

}

/**
 * @param {BufferGeometry} geometry
 * @param {number} tolerance
 * @return {BufferGeometry}
 */
function mergeVertices( geometry, tolerance = 1e-4 ) {

	tolerance = Math.max( tolerance, Number.EPSILON );

	// Generate an index buffer if the geometry doesn't have one, or optimize it
	// if it's already available.
	const hashToIndex = {};
	const indices = geometry.getIndex();
	const positions = geometry.getAttribute( 'position' );
	const vertexCount = indices ? indices.count : positions.count;

	// next value for triangle indices
	let nextIndex = 0;

	// attributes and new attribute arrays
	const attributeNames = Object.keys( geometry.attributes );
	const tmpAttributes = {};
	const tmpMorphAttributes = {};
	const newIndices = [];
	const getters = [ 'getX', 'getY', 'getZ', 'getW' ];
	const setters = [ 'setX', 'setY', 'setZ', 'setW' ];

	// Initialize the arrays, allocating space conservatively. Extra
	// space will be trimmed in the last step.
	for ( let i = 0, l = attributeNames.length; i < l; i ++ ) {

		const name = attributeNames[ i ];
		const attr = geometry.attributes[ name ];

		tmpAttributes[ name ] = new three__WEBPACK_IMPORTED_MODULE_0__/* .BufferAttribute */ .TlE(
			new attr.array.constructor( attr.count * attr.itemSize ),
			attr.itemSize,
			attr.normalized
		);

		const morphAttr = geometry.morphAttributes[ name ];
		if ( morphAttr ) {

			tmpMorphAttributes[ name ] = new three__WEBPACK_IMPORTED_MODULE_0__/* .BufferAttribute */ .TlE(
				new morphAttr.array.constructor( morphAttr.count * morphAttr.itemSize ),
				morphAttr.itemSize,
				morphAttr.normalized
			);

		}

	}

	// convert the error tolerance to an amount of decimal places to truncate to
	const halfTolerance = tolerance * 0.5;
	const exponent = Math.log10( 1 / tolerance );
	const hashMultiplier = Math.pow( 10, exponent );
	const hashAdditive = halfTolerance * hashMultiplier;
	for ( let i = 0; i < vertexCount; i ++ ) {

		const index = indices ? indices.getX( i ) : i;

		// Generate a hash for the vertex attributes at the current index 'i'
		let hash = '';
		for ( let j = 0, l = attributeNames.length; j < l; j ++ ) {

			const name = attributeNames[ j ];
			const attribute = geometry.getAttribute( name );
			const itemSize = attribute.itemSize;

			for ( let k = 0; k < itemSize; k ++ ) {

				// double tilde truncates the decimal value
				hash += `${ ~ ~ ( attribute[ getters[ k ] ]( index ) * hashMultiplier + hashAdditive ) },`;

			}

		}

		// Add another reference to the vertex if it's already
		// used by another index
		if ( hash in hashToIndex ) {

			newIndices.push( hashToIndex[ hash ] );

		} else {

			// copy data to the new index in the temporary attributes
			for ( let j = 0, l = attributeNames.length; j < l; j ++ ) {

				const name = attributeNames[ j ];
				const attribute = geometry.getAttribute( name );
				const morphAttr = geometry.morphAttributes[ name ];
				const itemSize = attribute.itemSize;
				const newarray = tmpAttributes[ name ];
				const newMorphArrays = tmpMorphAttributes[ name ];

				for ( let k = 0; k < itemSize; k ++ ) {

					const getterFunc = getters[ k ];
					const setterFunc = setters[ k ];
					newarray[ setterFunc ]( nextIndex, attribute[ getterFunc ]( index ) );

					if ( morphAttr ) {

						for ( let m = 0, ml = morphAttr.length; m < ml; m ++ ) {

							newMorphArrays[ m ][ setterFunc ]( nextIndex, morphAttr[ m ][ getterFunc ]( index ) );

						}

					}

				}

			}

			hashToIndex[ hash ] = nextIndex;
			newIndices.push( nextIndex );
			nextIndex ++;

		}

	}

	// generate result BufferGeometry
	const result = geometry.clone();
	for ( const name in geometry.attributes ) {

		const tmpAttribute = tmpAttributes[ name ];

		result.setAttribute( name, new three__WEBPACK_IMPORTED_MODULE_0__/* .BufferAttribute */ .TlE(
			tmpAttribute.array.slice( 0, nextIndex * tmpAttribute.itemSize ),
			tmpAttribute.itemSize,
			tmpAttribute.normalized,
		) );

		if ( ! ( name in tmpMorphAttributes ) ) continue;

		for ( let j = 0; j < tmpMorphAttributes[ name ].length; j ++ ) {

			const tmpMorphAttribute = tmpMorphAttributes[ name ][ j ];

			result.morphAttributes[ name ][ j ] = new three__WEBPACK_IMPORTED_MODULE_0__/* .BufferAttribute */ .TlE(
				tmpMorphAttribute.array.slice( 0, nextIndex * tmpMorphAttribute.itemSize ),
				tmpMorphAttribute.itemSize,
				tmpMorphAttribute.normalized,
			);

		}

	}

	// indices

	result.setIndex( newIndices );

	return result;

}

/**
 * @param {BufferGeometry} geometry
 * @param {number} drawMode
 * @return {BufferGeometry}
 */
function toTrianglesDrawMode( geometry, drawMode ) {

	if ( drawMode === three__WEBPACK_IMPORTED_MODULE_0__/* .TrianglesDrawMode */ .WwZ ) {

		console.warn( 'THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles.' );
		return geometry;

	}

	if ( drawMode === three__WEBPACK_IMPORTED_MODULE_0__/* .TriangleFanDrawMode */ .z$h || drawMode === three__WEBPACK_IMPORTED_MODULE_0__/* .TriangleStripDrawMode */ .UlW ) {

		let index = geometry.getIndex();

		// generate index if not present

		if ( index === null ) {

			const indices = [];

			const position = geometry.getAttribute( 'position' );

			if ( position !== undefined ) {

				for ( let i = 0; i < position.count; i ++ ) {

					indices.push( i );

				}

				geometry.setIndex( indices );
				index = geometry.getIndex();

			} else {

				console.error( 'THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible.' );
				return geometry;

			}

		}

		//

		const numberOfTriangles = index.count - 2;
		const newIndices = [];

		if ( drawMode === three__WEBPACK_IMPORTED_MODULE_0__/* .TriangleFanDrawMode */ .z$h ) {

			// gl.TRIANGLE_FAN

			for ( let i = 1; i <= numberOfTriangles; i ++ ) {

				newIndices.push( index.getX( 0 ) );
				newIndices.push( index.getX( i ) );
				newIndices.push( index.getX( i + 1 ) );

			}

		} else {

			// gl.TRIANGLE_STRIP

			for ( let i = 0; i < numberOfTriangles; i ++ ) {

				if ( i % 2 === 0 ) {

					newIndices.push( index.getX( i ) );
					newIndices.push( index.getX( i + 1 ) );
					newIndices.push( index.getX( i + 2 ) );

				} else {

					newIndices.push( index.getX( i + 2 ) );
					newIndices.push( index.getX( i + 1 ) );
					newIndices.push( index.getX( i ) );

				}

			}

		}

		if ( ( newIndices.length / 3 ) !== numberOfTriangles ) {

			console.error( 'THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.' );

		}

		// build final geometry

		const newGeometry = geometry.clone();
		newGeometry.setIndex( newIndices );
		newGeometry.clearGroups();

		return newGeometry;

	} else {

		console.error( 'THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:', drawMode );
		return geometry;

	}

}

/**
 * Calculates the morphed attributes of a morphed/skinned BufferGeometry.
 * Helpful for Raytracing or Decals.
 * @param {Mesh | Line | Points} object An instance of Mesh, Line or Points.
 * @return {Object} An Object with original position/normal attributes and morphed ones.
 */
function computeMorphedAttributes( object ) {

	const _vA = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
	const _vB = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
	const _vC = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();

	const _tempA = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
	const _tempB = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
	const _tempC = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();

	const _morphA = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
	const _morphB = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
	const _morphC = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();

	function _calculateMorphedAttributeData(
		object,
		attribute,
		morphAttribute,
		morphTargetsRelative,
		a,
		b,
		c,
		modifiedAttributeArray
	) {

		_vA.fromBufferAttribute( attribute, a );
		_vB.fromBufferAttribute( attribute, b );
		_vC.fromBufferAttribute( attribute, c );

		const morphInfluences = object.morphTargetInfluences;

		if ( morphAttribute && morphInfluences ) {

			_morphA.set( 0, 0, 0 );
			_morphB.set( 0, 0, 0 );
			_morphC.set( 0, 0, 0 );

			for ( let i = 0, il = morphAttribute.length; i < il; i ++ ) {

				const influence = morphInfluences[ i ];
				const morph = morphAttribute[ i ];

				if ( influence === 0 ) continue;

				_tempA.fromBufferAttribute( morph, a );
				_tempB.fromBufferAttribute( morph, b );
				_tempC.fromBufferAttribute( morph, c );

				if ( morphTargetsRelative ) {

					_morphA.addScaledVector( _tempA, influence );
					_morphB.addScaledVector( _tempB, influence );
					_morphC.addScaledVector( _tempC, influence );

				} else {

					_morphA.addScaledVector( _tempA.sub( _vA ), influence );
					_morphB.addScaledVector( _tempB.sub( _vB ), influence );
					_morphC.addScaledVector( _tempC.sub( _vC ), influence );

				}

			}

			_vA.add( _morphA );
			_vB.add( _morphB );
			_vC.add( _morphC );

		}

		if ( object.isSkinnedMesh ) {

			object.applyBoneTransform( a, _vA );
			object.applyBoneTransform( b, _vB );
			object.applyBoneTransform( c, _vC );

		}

		modifiedAttributeArray[ a * 3 + 0 ] = _vA.x;
		modifiedAttributeArray[ a * 3 + 1 ] = _vA.y;
		modifiedAttributeArray[ a * 3 + 2 ] = _vA.z;
		modifiedAttributeArray[ b * 3 + 0 ] = _vB.x;
		modifiedAttributeArray[ b * 3 + 1 ] = _vB.y;
		modifiedAttributeArray[ b * 3 + 2 ] = _vB.z;
		modifiedAttributeArray[ c * 3 + 0 ] = _vC.x;
		modifiedAttributeArray[ c * 3 + 1 ] = _vC.y;
		modifiedAttributeArray[ c * 3 + 2 ] = _vC.z;

	}

	const geometry = object.geometry;
	const material = object.material;

	let a, b, c;
	const index = geometry.index;
	const positionAttribute = geometry.attributes.position;
	const morphPosition = geometry.morphAttributes.position;
	const morphTargetsRelative = geometry.morphTargetsRelative;
	const normalAttribute = geometry.attributes.normal;
	const morphNormal = geometry.morphAttributes.position;

	const groups = geometry.groups;
	const drawRange = geometry.drawRange;
	let i, j, il, jl;
	let group;
	let start, end;

	const modifiedPosition = new Float32Array( positionAttribute.count * positionAttribute.itemSize );
	const modifiedNormal = new Float32Array( normalAttribute.count * normalAttribute.itemSize );

	if ( index !== null ) {

		// indexed buffer geometry

		if ( Array.isArray( material ) ) {

			for ( i = 0, il = groups.length; i < il; i ++ ) {

				group = groups[ i ];

				start = Math.max( group.start, drawRange.start );
				end = Math.min( ( group.start + group.count ), ( drawRange.start + drawRange.count ) );

				for ( j = start, jl = end; j < jl; j += 3 ) {

					a = index.getX( j );
					b = index.getX( j + 1 );
					c = index.getX( j + 2 );

					_calculateMorphedAttributeData(
						object,
						positionAttribute,
						morphPosition,
						morphTargetsRelative,
						a, b, c,
						modifiedPosition
					);

					_calculateMorphedAttributeData(
						object,
						normalAttribute,
						morphNormal,
						morphTargetsRelative,
						a, b, c,
						modifiedNormal
					);

				}

			}

		} else {

			start = Math.max( 0, drawRange.start );
			end = Math.min( index.count, ( drawRange.start + drawRange.count ) );

			for ( i = start, il = end; i < il; i += 3 ) {

				a = index.getX( i );
				b = index.getX( i + 1 );
				c = index.getX( i + 2 );

				_calculateMorphedAttributeData(
					object,
					positionAttribute,
					morphPosition,
					morphTargetsRelative,
					a, b, c,
					modifiedPosition
				);

				_calculateMorphedAttributeData(
					object,
					normalAttribute,
					morphNormal,
					morphTargetsRelative,
					a, b, c,
					modifiedNormal
				);

			}

		}

	} else {

		// non-indexed buffer geometry

		if ( Array.isArray( material ) ) {

			for ( i = 0, il = groups.length; i < il; i ++ ) {

				group = groups[ i ];

				start = Math.max( group.start, drawRange.start );
				end = Math.min( ( group.start + group.count ), ( drawRange.start + drawRange.count ) );

				for ( j = start, jl = end; j < jl; j += 3 ) {

					a = j;
					b = j + 1;
					c = j + 2;

					_calculateMorphedAttributeData(
						object,
						positionAttribute,
						morphPosition,
						morphTargetsRelative,
						a, b, c,
						modifiedPosition
					);

					_calculateMorphedAttributeData(
						object,
						normalAttribute,
						morphNormal,
						morphTargetsRelative,
						a, b, c,
						modifiedNormal
					);

				}

			}

		} else {

			start = Math.max( 0, drawRange.start );
			end = Math.min( positionAttribute.count, ( drawRange.start + drawRange.count ) );

			for ( i = start, il = end; i < il; i += 3 ) {

				a = i;
				b = i + 1;
				c = i + 2;

				_calculateMorphedAttributeData(
					object,
					positionAttribute,
					morphPosition,
					morphTargetsRelative,
					a, b, c,
					modifiedPosition
				);

				_calculateMorphedAttributeData(
					object,
					normalAttribute,
					morphNormal,
					morphTargetsRelative,
					a, b, c,
					modifiedNormal
				);

			}

		}

	}

	const morphedPositionAttribute = new three__WEBPACK_IMPORTED_MODULE_0__/* .Float32BufferAttribute */ .a$l( modifiedPosition, 3 );
	const morphedNormalAttribute = new three__WEBPACK_IMPORTED_MODULE_0__/* .Float32BufferAttribute */ .a$l( modifiedNormal, 3 );

	return {

		positionAttribute: positionAttribute,
		normalAttribute: normalAttribute,
		morphedPositionAttribute: morphedPositionAttribute,
		morphedNormalAttribute: morphedNormalAttribute

	};

}

function mergeGroups( geometry ) {

	if ( geometry.groups.length === 0 ) {

		console.warn( 'THREE.BufferGeometryUtils.mergeGroups(): No groups are defined. Nothing to merge.' );
		return geometry;

	}

	let groups = geometry.groups;

	// sort groups by material index

	groups = groups.sort( ( a, b ) => {

		if ( a.materialIndex !== b.materialIndex ) return a.materialIndex - b.materialIndex;

		return a.start - b.start;

	} );

	// create index for non-indexed geometries

	if ( geometry.getIndex() === null ) {

		const positionAttribute = geometry.getAttribute( 'position' );
		const indices = [];

		for ( let i = 0; i < positionAttribute.count; i += 3 ) {

			indices.push( i, i + 1, i + 2 );

		}

		geometry.setIndex( indices );

	}

	// sort index

	const index = geometry.getIndex();

	const newIndices = [];

	for ( let i = 0; i < groups.length; i ++ ) {

		const group = groups[ i ];

		const groupStart = group.start;
		const groupLength = groupStart + group.count;

		for ( let j = groupStart; j < groupLength; j ++ ) {

			newIndices.push( index.getX( j ) );

		}

	}

	geometry.dispose(); // Required to force buffer recreation
	geometry.setIndex( newIndices );

	// update groups indices

	let start = 0;

	for ( let i = 0; i < groups.length; i ++ ) {

		const group = groups[ i ];

		group.start = start;
		start += group.count;

	}

	// merge groups

	let currentGroup = groups[ 0 ];

	geometry.groups = [ currentGroup ];

	for ( let i = 1; i < groups.length; i ++ ) {

		const group = groups[ i ];

		if ( currentGroup.materialIndex === group.materialIndex ) {

			currentGroup.count += group.count;

		} else {

			currentGroup = group;
			geometry.groups.push( currentGroup );

		}

	}

	return geometry;

}


/**
 * Modifies the supplied geometry if it is non-indexed, otherwise creates a new,
 * non-indexed geometry. Returns the geometry with smooth normals everywhere except
 * faces that meet at an angle greater than the crease angle.
 *
 * @param {BufferGeometry} geometry
 * @param {number} [creaseAngle]
 * @return {BufferGeometry}
 */
function toCreasedNormals( geometry, creaseAngle = Math.PI / 3 /* 60 degrees */ ) {

	const creaseDot = Math.cos( creaseAngle );
	const hashMultiplier = ( 1 + 1e-10 ) * 1e2;

	// reusable vectors
	const verts = [ new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4(), new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4(), new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4() ];
	const tempVec1 = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
	const tempVec2 = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
	const tempNorm = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
	const tempNorm2 = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();

	// hashes a vector
	function hashVertex( v ) {

		const x = ~ ~ ( v.x * hashMultiplier );
		const y = ~ ~ ( v.y * hashMultiplier );
		const z = ~ ~ ( v.z * hashMultiplier );
		return `${x},${y},${z}`;

	}

	// BufferGeometry.toNonIndexed() warns if the geometry is non-indexed
	// and returns the original geometry
	const resultGeometry = geometry.index ? geometry.toNonIndexed() : geometry;
	const posAttr = resultGeometry.attributes.position;
	const vertexMap = {};

	// find all the normals shared by commonly located vertices
	for ( let i = 0, l = posAttr.count / 3; i < l; i ++ ) {

		const i3 = 3 * i;
		const a = verts[ 0 ].fromBufferAttribute( posAttr, i3 + 0 );
		const b = verts[ 1 ].fromBufferAttribute( posAttr, i3 + 1 );
		const c = verts[ 2 ].fromBufferAttribute( posAttr, i3 + 2 );

		tempVec1.subVectors( c, b );
		tempVec2.subVectors( a, b );

		// add the normal to the map for all vertices
		const normal = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4().crossVectors( tempVec1, tempVec2 ).normalize();
		for ( let n = 0; n < 3; n ++ ) {

			const vert = verts[ n ];
			const hash = hashVertex( vert );
			if ( ! ( hash in vertexMap ) ) {

				vertexMap[ hash ] = [];

			}

			vertexMap[ hash ].push( normal );

		}

	}

	// average normals from all vertices that share a common location if they are within the
	// provided crease threshold
	const normalArray = new Float32Array( posAttr.count * 3 );
	const normAttr = new three__WEBPACK_IMPORTED_MODULE_0__/* .BufferAttribute */ .TlE( normalArray, 3, false );
	for ( let i = 0, l = posAttr.count / 3; i < l; i ++ ) {

		// get the face normal for this vertex
		const i3 = 3 * i;
		const a = verts[ 0 ].fromBufferAttribute( posAttr, i3 + 0 );
		const b = verts[ 1 ].fromBufferAttribute( posAttr, i3 + 1 );
		const c = verts[ 2 ].fromBufferAttribute( posAttr, i3 + 2 );

		tempVec1.subVectors( c, b );
		tempVec2.subVectors( a, b );

		tempNorm.crossVectors( tempVec1, tempVec2 ).normalize();

		// average all normals that meet the threshold and set the normal value
		for ( let n = 0; n < 3; n ++ ) {

			const vert = verts[ n ];
			const hash = hashVertex( vert );
			const otherNormals = vertexMap[ hash ];
			tempNorm2.set( 0, 0, 0 );

			for ( let k = 0, lk = otherNormals.length; k < lk; k ++ ) {

				const otherNorm = otherNormals[ k ];
				if ( tempNorm.dot( otherNorm ) > creaseDot ) {

					tempNorm2.add( otherNorm );

				}

			}

			tempNorm2.normalize();
			normAttr.setXYZ( i3 + n, tempNorm2.x, tempNorm2.y, tempNorm2.z );

		}

	}

	resultGeometry.setAttribute( 'normal', normAttr );
	return resultGeometry;

}




/***/ }),

/***/ 1990:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   BooleanController: () => (/* binding */ BooleanController),
/* harmony export */   ColorController: () => (/* binding */ ColorController),
/* harmony export */   Controller: () => (/* binding */ Controller),
/* harmony export */   FunctionController: () => (/* binding */ FunctionController),
/* harmony export */   GUI: () => (/* binding */ GUI),
/* harmony export */   NumberController: () => (/* binding */ NumberController),
/* harmony export */   OptionController: () => (/* binding */ OptionController),
/* harmony export */   StringController: () => (/* binding */ StringController),
/* harmony export */   "default": () => (/* binding */ GUI)
/* harmony export */ });
/**
 * lil-gui
 * https://lil-gui.georgealways.com
 * @version 0.20.0
 * @author George Michael Brower
 * @license MIT
 */

/**
 * Base class for all controllers.
 */
class Controller {

	constructor( parent, object, property, className, elementType = 'div' ) {

		/**
		 * The GUI that contains this controller.
		 * @type {GUI}
		 */
		this.parent = parent;

		/**
		 * The object this controller will modify.
		 * @type {object}
		 */
		this.object = object;

		/**
		 * The name of the property to control.
		 * @type {string}
		 */
		this.property = property;

		/**
		 * Used to determine if the controller is disabled.
		 * Use `controller.disable( true|false )` to modify this value.
		 * @type {boolean}
		 */
		this._disabled = false;

		/**
		 * Used to determine if the Controller is hidden.
		 * Use `controller.show()` or `controller.hide()` to change this.
		 * @type {boolean}
		 */
		this._hidden = false;

		/**
		 * The value of `object[ property ]` when the controller was created.
		 * @type {any}
		 */
		this.initialValue = this.getValue();

		/**
		 * The outermost container DOM element for this controller.
		 * @type {HTMLElement}
		 */
		this.domElement = document.createElement( elementType );
		this.domElement.classList.add( 'controller' );
		this.domElement.classList.add( className );

		/**
		 * The DOM element that contains the controller's name.
		 * @type {HTMLElement}
		 */
		this.$name = document.createElement( 'div' );
		this.$name.classList.add( 'name' );

		Controller.nextNameID = Controller.nextNameID || 0;
		this.$name.id = `lil-gui-name-${++Controller.nextNameID}`;

		/**
		 * The DOM element that contains the controller's "widget" (which differs by controller type).
		 * @type {HTMLElement}
		 */
		this.$widget = document.createElement( 'div' );
		this.$widget.classList.add( 'widget' );

		/**
		 * The DOM element that receives the disabled attribute when using disable().
		 * @type {HTMLElement}
		 */
		this.$disable = this.$widget;

		this.domElement.appendChild( this.$name );
		this.domElement.appendChild( this.$widget );

		// Don't fire global key events while typing in a controller
		this.domElement.addEventListener( 'keydown', e => e.stopPropagation() );
		this.domElement.addEventListener( 'keyup', e => e.stopPropagation() );

		this.parent.children.push( this );
		this.parent.controllers.push( this );

		this.parent.$children.appendChild( this.domElement );

		this._listenCallback = this._listenCallback.bind( this );

		this.name( property );

	}

	/**
	 * Sets the name of the controller and its label in the GUI.
	 * @param {string} name
	 * @returns {this}
	 */
	name( name ) {
		/**
		 * The controller's name. Use `controller.name( 'Name' )` to modify this value.
		 * @type {string}
		 */
		this._name = name;
		this.$name.textContent = name;
		return this;
	}

	/**
	 * Pass a function to be called whenever the value is modified by this controller.
	 * The function receives the new value as its first parameter. The value of `this` will be the
	 * controller.
	 *
	 * For function controllers, the `onChange` callback will be fired on click, after the function
	 * executes.
	 * @param {Function} callback
	 * @returns {this}
	 * @example
	 * const controller = gui.add( object, 'property' );
	 *
	 * controller.onChange( function( v ) {
	 * 	console.log( 'The value is now ' + v );
	 * 	console.assert( this === controller );
	 * } );
	 */
	onChange( callback ) {
		/**
		 * Used to access the function bound to `onChange` events. Don't modify this value directly.
		 * Use the `controller.onChange( callback )` method instead.
		 * @type {Function}
		 */
		this._onChange = callback;
		return this;
	}

	/**
	 * Calls the onChange methods of this controller and its parent GUI.
	 * @protected
	 */
	_callOnChange() {

		this.parent._callOnChange( this );

		if ( this._onChange !== undefined ) {
			this._onChange.call( this, this.getValue() );
		}

		this._changed = true;

	}

	/**
	 * Pass a function to be called after this controller has been modified and loses focus.
	 * @param {Function} callback
	 * @returns {this}
	 * @example
	 * const controller = gui.add( object, 'property' );
	 *
	 * controller.onFinishChange( function( v ) {
	 * 	console.log( 'Changes complete: ' + v );
	 * 	console.assert( this === controller );
	 * } );
	 */
	onFinishChange( callback ) {
		/**
		 * Used to access the function bound to `onFinishChange` events. Don't modify this value
		 * directly. Use the `controller.onFinishChange( callback )` method instead.
		 * @type {Function}
		 */
		this._onFinishChange = callback;
		return this;
	}

	/**
	 * Should be called by Controller when its widgets lose focus.
	 * @protected
	 */
	_callOnFinishChange() {

		if ( this._changed ) {

			this.parent._callOnFinishChange( this );

			if ( this._onFinishChange !== undefined ) {
				this._onFinishChange.call( this, this.getValue() );
			}

		}

		this._changed = false;

	}

	/**
	 * Sets the controller back to its initial value.
	 * @returns {this}
	 */
	reset() {
		this.setValue( this.initialValue );
		this._callOnFinishChange();
		return this;
	}

	/**
	 * Enables this controller.
	 * @param {boolean} enabled
	 * @returns {this}
	 * @example
	 * controller.enable();
	 * controller.enable( false ); // disable
	 * controller.enable( controller._disabled ); // toggle
	 */
	enable( enabled = true ) {
		return this.disable( !enabled );
	}

	/**
	 * Disables this controller.
	 * @param {boolean} disabled
	 * @returns {this}
	 * @example
	 * controller.disable();
	 * controller.disable( false ); // enable
	 * controller.disable( !controller._disabled ); // toggle
	 */
	disable( disabled = true ) {

		if ( disabled === this._disabled ) return this;

		this._disabled = disabled;

		this.domElement.classList.toggle( 'disabled', disabled );
		this.$disable.toggleAttribute( 'disabled', disabled );

		return this;

	}

	/**
	 * Shows the Controller after it's been hidden.
	 * @param {boolean} show
	 * @returns {this}
	 * @example
	 * controller.show();
	 * controller.show( false ); // hide
	 * controller.show( controller._hidden ); // toggle
	 */
	show( show = true ) {

		this._hidden = !show;

		this.domElement.style.display = this._hidden ? 'none' : '';

		return this;

	}

	/**
	 * Hides the Controller.
	 * @returns {this}
	 */
	hide() {
		return this.show( false );
	}

	/**
	 * Changes this controller into a dropdown of options.
	 *
	 * Calling this method on an option controller will simply update the options. However, if this
	 * controller was not already an option controller, old references to this controller are
	 * destroyed, and a new controller is added to the end of the GUI.
	 * @example
	 * // safe usage
	 *
	 * gui.add( obj, 'prop1' ).options( [ 'a', 'b', 'c' ] );
	 * gui.add( obj, 'prop2' ).options( { Big: 10, Small: 1 } );
	 * gui.add( obj, 'prop3' );
	 *
	 * // danger
	 *
	 * const ctrl1 = gui.add( obj, 'prop1' );
	 * gui.add( obj, 'prop2' );
	 *
	 * // calling options out of order adds a new controller to the end...
	 * const ctrl2 = ctrl1.options( [ 'a', 'b', 'c' ] );
	 *
	 * // ...and ctrl1 now references a controller that doesn't exist
	 * assert( ctrl2 !== ctrl1 )
	 * @param {object|Array} options
	 * @returns {Controller}
	 */
	options( options ) {
		const controller = this.parent.add( this.object, this.property, options );
		controller.name( this._name );
		this.destroy();
		return controller;
	}

	/**
	 * Sets the minimum value. Only works on number controllers.
	 * @param {number} min
	 * @returns {this}
	 */
	min( min ) {
		return this;
	}

	/**
	 * Sets the maximum value. Only works on number controllers.
	 * @param {number} max
	 * @returns {this}
	 */
	max( max ) {
		return this;
	}

	/**
	 * Values set by this controller will be rounded to multiples of `step`. Only works on number
	 * controllers.
	 * @param {number} step
	 * @returns {this}
	 */
	step( step ) {
		return this;
	}

	/**
	 * Rounds the displayed value to a fixed number of decimals, without affecting the actual value
	 * like `step()`. Only works on number controllers.
	 * @example
	 * gui.add( object, 'property' ).listen().decimals( 4 );
	 * @param {number} decimals
	 * @returns {this}
	 */
	decimals( decimals ) {
		return this;
	}

	/**
	 * Calls `updateDisplay()` every animation frame. Pass `false` to stop listening.
	 * @param {boolean} listen
	 * @returns {this}
	 */
	listen( listen = true ) {

		/**
		 * Used to determine if the controller is currently listening. Don't modify this value
		 * directly. Use the `controller.listen( true|false )` method instead.
		 * @type {boolean}
		 */
		this._listening = listen;

		if ( this._listenCallbackID !== undefined ) {
			cancelAnimationFrame( this._listenCallbackID );
			this._listenCallbackID = undefined;
		}

		if ( this._listening ) {
			this._listenCallback();
		}

		return this;

	}

	_listenCallback() {

		this._listenCallbackID = requestAnimationFrame( this._listenCallback );

		// To prevent framerate loss, make sure the value has changed before updating the display.
		// Note: save() is used here instead of getValue() only because of ColorController. The !== operator
		// won't work for color objects or arrays, but ColorController.save() always returns a string.

		const curValue = this.save();

		if ( curValue !== this._listenPrevValue ) {
			this.updateDisplay();
		}

		this._listenPrevValue = curValue;

	}

	/**
	 * Returns `object[ property ]`.
	 * @returns {any}
	 */
	getValue() {
		return this.object[ this.property ];
	}

	/**
	 * Sets the value of `object[ property ]`, invokes any `onChange` handlers and updates the display.
	 * @param {any} value
	 * @returns {this}
	 */
	setValue( value ) {

		if ( this.getValue() !== value ) {

			this.object[ this.property ] = value;
			this._callOnChange();
			this.updateDisplay();

		}

		return this;

	}

	/**
	 * Updates the display to keep it in sync with the current value. Useful for updating your
	 * controllers when their values have been modified outside of the GUI.
	 * @returns {this}
	 */
	updateDisplay() {
		return this;
	}

	load( value ) {
		this.setValue( value );
		this._callOnFinishChange();
		return this;
	}

	save() {
		return this.getValue();
	}

	/**
	 * Destroys this controller and removes it from the parent GUI.
	 */
	destroy() {
		this.listen( false );
		this.parent.children.splice( this.parent.children.indexOf( this ), 1 );
		this.parent.controllers.splice( this.parent.controllers.indexOf( this ), 1 );
		this.parent.$children.removeChild( this.domElement );
	}

}

class BooleanController extends Controller {

	constructor( parent, object, property ) {

		super( parent, object, property, 'boolean', 'label' );

		this.$input = document.createElement( 'input' );
		this.$input.setAttribute( 'type', 'checkbox' );
		this.$input.setAttribute( 'aria-labelledby', this.$name.id );

		this.$widget.appendChild( this.$input );

		this.$input.addEventListener( 'change', () => {
			this.setValue( this.$input.checked );
			this._callOnFinishChange();
		} );

		this.$disable = this.$input;

		this.updateDisplay();

	}

	updateDisplay() {
		this.$input.checked = this.getValue();
		return this;
	}

}

function normalizeColorString( string ) {

	let match, result;

	if ( match = string.match( /(#|0x)?([a-f0-9]{6})/i ) ) {

		result = match[ 2 ];

	} else if ( match = string.match( /rgb\(\s*(\d*)\s*,\s*(\d*)\s*,\s*(\d*)\s*\)/ ) ) {

		result = parseInt( match[ 1 ] ).toString( 16 ).padStart( 2, 0 )
			+ parseInt( match[ 2 ] ).toString( 16 ).padStart( 2, 0 )
			+ parseInt( match[ 3 ] ).toString( 16 ).padStart( 2, 0 );

	} else if ( match = string.match( /^#?([a-f0-9])([a-f0-9])([a-f0-9])$/i ) ) {

		result = match[ 1 ] + match[ 1 ] + match[ 2 ] + match[ 2 ] + match[ 3 ] + match[ 3 ];

	}

	if ( result ) {
		return '#' + result;
	}

	return false;

}

const STRING = {
	isPrimitive: true,
	match: v => typeof v === 'string',
	fromHexString: normalizeColorString,
	toHexString: normalizeColorString
};

const INT = {
	isPrimitive: true,
	match: v => typeof v === 'number',
	fromHexString: string => parseInt( string.substring( 1 ), 16 ),
	toHexString: value => '#' + value.toString( 16 ).padStart( 6, 0 )
};

const ARRAY = {
	isPrimitive: false,

	// The arrow function is here to appease tree shakers like esbuild or webpack.
	// See https://esbuild.github.io/api/#tree-shaking
	match: v => Array.isArray( v ),

	fromHexString( string, target, rgbScale = 1 ) {

		const int = INT.fromHexString( string );

		target[ 0 ] = ( int >> 16 & 255 ) / 255 * rgbScale;
		target[ 1 ] = ( int >> 8 & 255 ) / 255 * rgbScale;
		target[ 2 ] = ( int & 255 ) / 255 * rgbScale;

	},
	toHexString( [ r, g, b ], rgbScale = 1 ) {

		rgbScale = 255 / rgbScale;

		const int = ( r * rgbScale ) << 16 ^
			( g * rgbScale ) << 8 ^
			( b * rgbScale ) << 0;

		return INT.toHexString( int );

	}
};

const OBJECT = {
	isPrimitive: false,
	match: v => Object( v ) === v,
	fromHexString( string, target, rgbScale = 1 ) {

		const int = INT.fromHexString( string );

		target.r = ( int >> 16 & 255 ) / 255 * rgbScale;
		target.g = ( int >> 8 & 255 ) / 255 * rgbScale;
		target.b = ( int & 255 ) / 255 * rgbScale;

	},
	toHexString( { r, g, b }, rgbScale = 1 ) {

		rgbScale = 255 / rgbScale;

		const int = ( r * rgbScale ) << 16 ^
			( g * rgbScale ) << 8 ^
			( b * rgbScale ) << 0;

		return INT.toHexString( int );

	}
};

const FORMATS = [ STRING, INT, ARRAY, OBJECT ];

function getColorFormat( value ) {
	return FORMATS.find( format => format.match( value ) );
}

class ColorController extends Controller {

	constructor( parent, object, property, rgbScale ) {

		super( parent, object, property, 'color' );

		this.$input = document.createElement( 'input' );
		this.$input.setAttribute( 'type', 'color' );
		this.$input.setAttribute( 'tabindex', -1 );
		this.$input.setAttribute( 'aria-labelledby', this.$name.id );

		this.$text = document.createElement( 'input' );
		this.$text.setAttribute( 'type', 'text' );
		this.$text.setAttribute( 'spellcheck', 'false' );
		this.$text.setAttribute( 'aria-labelledby', this.$name.id );

		this.$display = document.createElement( 'div' );
		this.$display.classList.add( 'display' );

		this.$display.appendChild( this.$input );
		this.$widget.appendChild( this.$display );
		this.$widget.appendChild( this.$text );

		this._format = getColorFormat( this.initialValue );
		this._rgbScale = rgbScale;

		this._initialValueHexString = this.save();
		this._textFocused = false;

		this.$input.addEventListener( 'input', () => {
			this._setValueFromHexString( this.$input.value );
		} );

		this.$input.addEventListener( 'blur', () => {
			this._callOnFinishChange();
		} );

		this.$text.addEventListener( 'input', () => {
			const tryParse = normalizeColorString( this.$text.value );
			if ( tryParse ) {
				this._setValueFromHexString( tryParse );
			}
		} );

		this.$text.addEventListener( 'focus', () => {
			this._textFocused = true;
			this.$text.select();
		} );

		this.$text.addEventListener( 'blur', () => {
			this._textFocused = false;
			this.updateDisplay();
			this._callOnFinishChange();
		} );

		this.$disable = this.$text;

		this.updateDisplay();

	}

	reset() {
		this._setValueFromHexString( this._initialValueHexString );
		return this;
	}

	_setValueFromHexString( value ) {

		if ( this._format.isPrimitive ) {

			const newValue = this._format.fromHexString( value );
			this.setValue( newValue );

		} else {

			this._format.fromHexString( value, this.getValue(), this._rgbScale );
			this._callOnChange();
			this.updateDisplay();

		}

	}

	save() {
		return this._format.toHexString( this.getValue(), this._rgbScale );
	}

	load( value ) {
		this._setValueFromHexString( value );
		this._callOnFinishChange();
		return this;
	}

	updateDisplay() {
		this.$input.value = this._format.toHexString( this.getValue(), this._rgbScale );
		if ( !this._textFocused ) {
			this.$text.value = this.$input.value.substring( 1 );
		}
		this.$display.style.backgroundColor = this.$input.value;
		return this;
	}

}

class FunctionController extends Controller {

	constructor( parent, object, property ) {

		super( parent, object, property, 'function' );

		// Buttons are the only case where widget contains name
		this.$button = document.createElement( 'button' );
		this.$button.appendChild( this.$name );
		this.$widget.appendChild( this.$button );

		this.$button.addEventListener( 'click', e => {
			e.preventDefault();
			this.getValue().call( this.object );
			this._callOnChange();
		} );

		// enables :active pseudo class on mobile
		this.$button.addEventListener( 'touchstart', () => {}, { passive: true } );

		this.$disable = this.$button;

	}

}

class NumberController extends Controller {

	constructor( parent, object, property, min, max, step ) {

		super( parent, object, property, 'number' );

		this._initInput();

		this.min( min );
		this.max( max );

		const stepExplicit = step !== undefined;
		this.step( stepExplicit ? step : this._getImplicitStep(), stepExplicit );

		this.updateDisplay();

	}

	decimals( decimals ) {
		this._decimals = decimals;
		this.updateDisplay();
		return this;
	}

	min( min ) {
		this._min = min;
		this._onUpdateMinMax();
		return this;
	}

	max( max ) {
		this._max = max;
		this._onUpdateMinMax();
		return this;
	}

	step( step, explicit = true ) {
		this._step = step;
		this._stepExplicit = explicit;
		return this;
	}

	updateDisplay() {

		const value = this.getValue();

		if ( this._hasSlider ) {

			let percent = ( value - this._min ) / ( this._max - this._min );
			percent = Math.max( 0, Math.min( percent, 1 ) );

			this.$fill.style.width = percent * 100 + '%';

		}

		if ( !this._inputFocused ) {
			this.$input.value = this._decimals === undefined ? value : value.toFixed( this._decimals );
		}

		return this;

	}

	_initInput() {

		this.$input = document.createElement( 'input' );
		this.$input.setAttribute( 'type', 'text' );
		this.$input.setAttribute( 'aria-labelledby', this.$name.id );

		// On touch devices only, use input[type=number] to force a numeric keyboard.
		// Ideally we could use one input type everywhere, but [type=number] has quirks
		// on desktop, and [inputmode=decimal] has quirks on iOS.
		// See https://github.com/georgealways/lil-gui/pull/16

		const isTouch = window.matchMedia( '(pointer: coarse)' ).matches;

		if ( isTouch ) {
			this.$input.setAttribute( 'type', 'number' );
			this.$input.setAttribute( 'step', 'any' );
		}

		this.$widget.appendChild( this.$input );

		this.$disable = this.$input;

		const onInput = () => {

			let value = parseFloat( this.$input.value );

			if ( isNaN( value ) ) return;

			if ( this._stepExplicit ) {
				value = this._snap( value );
			}

			this.setValue( this._clamp( value ) );

		};

		// Keys & mouse wheel
		// ---------------------------------------------------------------------

		const increment = delta => {

			const value = parseFloat( this.$input.value );

			if ( isNaN( value ) ) return;

			this._snapClampSetValue( value + delta );

			// Force the input to updateDisplay when it's focused
			this.$input.value = this.getValue();

		};

		const onKeyDown = e => {
			// Using `e.key` instead of `e.code` also catches NumpadEnter
			if ( e.key === 'Enter' ) {
				this.$input.blur();
			}
			if ( e.code === 'ArrowUp' ) {
				e.preventDefault();
				increment( this._step * this._arrowKeyMultiplier( e ) );
			}
			if ( e.code === 'ArrowDown' ) {
				e.preventDefault();
				increment( this._step * this._arrowKeyMultiplier( e ) * -1 );
			}
		};

		const onWheel = e => {
			if ( this._inputFocused ) {
				e.preventDefault();
				increment( this._step * this._normalizeMouseWheel( e ) );
			}
		};

		// Vertical drag
		// ---------------------------------------------------------------------

		let testingForVerticalDrag = false,
			initClientX,
			initClientY,
			prevClientY,
			initValue,
			dragDelta;

		// Once the mouse is dragged more than DRAG_THRESH px on any axis, we decide
		// on the user's intent: horizontal means highlight, vertical means drag.
		const DRAG_THRESH = 5;

		const onMouseDown = e => {

			initClientX = e.clientX;
			initClientY = prevClientY = e.clientY;
			testingForVerticalDrag = true;

			initValue = this.getValue();
			dragDelta = 0;

			window.addEventListener( 'mousemove', onMouseMove );
			window.addEventListener( 'mouseup', onMouseUp );

		};

		const onMouseMove = e => {

			if ( testingForVerticalDrag ) {

				const dx = e.clientX - initClientX;
				const dy = e.clientY - initClientY;

				if ( Math.abs( dy ) > DRAG_THRESH ) {

					e.preventDefault();
					this.$input.blur();
					testingForVerticalDrag = false;
					this._setDraggingStyle( true, 'vertical' );

				} else if ( Math.abs( dx ) > DRAG_THRESH ) {

					onMouseUp();

				}

			}

			// This isn't an else so that the first move counts towards dragDelta
			if ( !testingForVerticalDrag ) {

				const dy = e.clientY - prevClientY;

				dragDelta -= dy * this._step * this._arrowKeyMultiplier( e );

				// Clamp dragDelta so we don't have 'dead space' after dragging past bounds.
				// We're okay with the fact that bounds can be undefined here.
				if ( initValue + dragDelta > this._max ) {
					dragDelta = this._max - initValue;
				} else if ( initValue + dragDelta < this._min ) {
					dragDelta = this._min - initValue;
				}

				this._snapClampSetValue( initValue + dragDelta );

			}

			prevClientY = e.clientY;

		};

		const onMouseUp = () => {
			this._setDraggingStyle( false, 'vertical' );
			this._callOnFinishChange();
			window.removeEventListener( 'mousemove', onMouseMove );
			window.removeEventListener( 'mouseup', onMouseUp );
		};

		// Focus state & onFinishChange
		// ---------------------------------------------------------------------

		const onFocus = () => {
			this._inputFocused = true;
		};

		const onBlur = () => {
			this._inputFocused = false;
			this.updateDisplay();
			this._callOnFinishChange();
		};

		this.$input.addEventListener( 'input', onInput );
		this.$input.addEventListener( 'keydown', onKeyDown );
		this.$input.addEventListener( 'wheel', onWheel, { passive: false } );
		this.$input.addEventListener( 'mousedown', onMouseDown );
		this.$input.addEventListener( 'focus', onFocus );
		this.$input.addEventListener( 'blur', onBlur );

	}

	_initSlider() {

		this._hasSlider = true;

		// Build DOM
		// ---------------------------------------------------------------------

		this.$slider = document.createElement( 'div' );
		this.$slider.classList.add( 'slider' );

		this.$fill = document.createElement( 'div' );
		this.$fill.classList.add( 'fill' );

		this.$slider.appendChild( this.$fill );
		this.$widget.insertBefore( this.$slider, this.$input );

		this.domElement.classList.add( 'hasSlider' );

		// Map clientX to value
		// ---------------------------------------------------------------------

		const map = ( v, a, b, c, d ) => {
			return ( v - a ) / ( b - a ) * ( d - c ) + c;
		};

		const setValueFromX = clientX => {
			const rect = this.$slider.getBoundingClientRect();
			let value = map( clientX, rect.left, rect.right, this._min, this._max );
			this._snapClampSetValue( value );
		};

		// Mouse drag
		// ---------------------------------------------------------------------

		const mouseDown = e => {
			this._setDraggingStyle( true );
			setValueFromX( e.clientX );
			window.addEventListener( 'mousemove', mouseMove );
			window.addEventListener( 'mouseup', mouseUp );
		};

		const mouseMove = e => {
			setValueFromX( e.clientX );
		};

		const mouseUp = () => {
			this._callOnFinishChange();
			this._setDraggingStyle( false );
			window.removeEventListener( 'mousemove', mouseMove );
			window.removeEventListener( 'mouseup', mouseUp );
		};

		// Touch drag
		// ---------------------------------------------------------------------

		let testingForScroll = false, prevClientX, prevClientY;

		const beginTouchDrag = e => {
			e.preventDefault();
			this._setDraggingStyle( true );
			setValueFromX( e.touches[ 0 ].clientX );
			testingForScroll = false;
		};

		const onTouchStart = e => {

			if ( e.touches.length > 1 ) return;

			// If we're in a scrollable container, we should wait for the first
			// touchmove to see if the user is trying to slide or scroll.
			if ( this._hasScrollBar ) {

				prevClientX = e.touches[ 0 ].clientX;
				prevClientY = e.touches[ 0 ].clientY;
				testingForScroll = true;

			} else {

				// Otherwise, we can set the value straight away on touchstart.
				beginTouchDrag( e );

			}

			window.addEventListener( 'touchmove', onTouchMove, { passive: false } );
			window.addEventListener( 'touchend', onTouchEnd );

		};

		const onTouchMove = e => {

			if ( testingForScroll ) {

				const dx = e.touches[ 0 ].clientX - prevClientX;
				const dy = e.touches[ 0 ].clientY - prevClientY;

				if ( Math.abs( dx ) > Math.abs( dy ) ) {

					// We moved horizontally, set the value and stop checking.
					beginTouchDrag( e );

				} else {

					// This was, in fact, an attempt to scroll. Abort.
					window.removeEventListener( 'touchmove', onTouchMove );
					window.removeEventListener( 'touchend', onTouchEnd );

				}

			} else {

				e.preventDefault();
				setValueFromX( e.touches[ 0 ].clientX );

			}

		};

		const onTouchEnd = () => {
			this._callOnFinishChange();
			this._setDraggingStyle( false );
			window.removeEventListener( 'touchmove', onTouchMove );
			window.removeEventListener( 'touchend', onTouchEnd );
		};

		// Mouse wheel
		// ---------------------------------------------------------------------

		// We have to use a debounced function to call onFinishChange because
		// there's no way to tell when the user is "done" mouse-wheeling.
		const callOnFinishChange = this._callOnFinishChange.bind( this );
		const WHEEL_DEBOUNCE_TIME = 400;
		let wheelFinishChangeTimeout;

		const onWheel = e => {

			// ignore vertical wheels if there's a scrollbar
			const isVertical = Math.abs( e.deltaX ) < Math.abs( e.deltaY );
			if ( isVertical && this._hasScrollBar ) return;

			e.preventDefault();

			// set value
			const delta = this._normalizeMouseWheel( e ) * this._step;
			this._snapClampSetValue( this.getValue() + delta );

			// force the input to updateDisplay when it's focused
			this.$input.value = this.getValue();

			// debounce onFinishChange
			clearTimeout( wheelFinishChangeTimeout );
			wheelFinishChangeTimeout = setTimeout( callOnFinishChange, WHEEL_DEBOUNCE_TIME );

		};

		this.$slider.addEventListener( 'mousedown', mouseDown );
		this.$slider.addEventListener( 'touchstart', onTouchStart, { passive: false } );
		this.$slider.addEventListener( 'wheel', onWheel, { passive: false } );

	}

	_setDraggingStyle( active, axis = 'horizontal' ) {
		if ( this.$slider ) {
			this.$slider.classList.toggle( 'active', active );
		}
		document.body.classList.toggle( 'lil-gui-dragging', active );
		document.body.classList.toggle( `lil-gui-${axis}`, active );
	}

	_getImplicitStep() {

		if ( this._hasMin && this._hasMax ) {
			return ( this._max - this._min ) / 1000;
		}

		return 0.1;

	}

	_onUpdateMinMax() {

		if ( !this._hasSlider && this._hasMin && this._hasMax ) {

			// If this is the first time we're hearing about min and max
			// and we haven't explicitly stated what our step is, let's
			// update that too.
			if ( !this._stepExplicit ) {
				this.step( this._getImplicitStep(), false );
			}

			this._initSlider();
			this.updateDisplay();

		}

	}

	_normalizeMouseWheel( e ) {

		let { deltaX, deltaY } = e;

		// Safari and Chrome report weird non-integral values for a notched wheel,
		// but still expose actual lines scrolled via wheelDelta. Notched wheels
		// should behave the same way as arrow keys.
		if ( Math.floor( e.deltaY ) !== e.deltaY && e.wheelDelta ) {
			deltaX = 0;
			deltaY = -e.wheelDelta / 120;
			deltaY *= this._stepExplicit ? 1 : 10;
		}

		const wheel = deltaX + -deltaY;

		return wheel;

	}

	_arrowKeyMultiplier( e ) {

		let mult = this._stepExplicit ? 1 : 10;

		if ( e.shiftKey ) {
			mult *= 10;
		} else if ( e.altKey ) {
			mult /= 10;
		}

		return mult;

	}

	_snap( value ) {

		// Make the steps "start" at min or max.
		let offset = 0;
		if ( this._hasMin ) {
			offset = this._min;
		} else if ( this._hasMax ) {
			offset = this._max;
		}

		value -= offset;

		value = Math.round( value / this._step ) * this._step;

		value += offset;

		// Used to prevent "flyaway" decimals like 1.00000000000001
		value = parseFloat( value.toPrecision( 15 ) );

		return value;

	}

	_clamp( value ) {
		// either condition is false if min or max is undefined
		if ( value < this._min ) value = this._min;
		if ( value > this._max ) value = this._max;
		return value;
	}

	_snapClampSetValue( value ) {
		this.setValue( this._clamp( this._snap( value ) ) );
	}

	get _hasScrollBar() {
		const root = this.parent.root.$children;
		return root.scrollHeight > root.clientHeight;
	}

	get _hasMin() {
		return this._min !== undefined;
	}

	get _hasMax() {
		return this._max !== undefined;
	}

}

class OptionController extends Controller {

	constructor( parent, object, property, options ) {

		super( parent, object, property, 'option' );

		this.$select = document.createElement( 'select' );
		this.$select.setAttribute( 'aria-labelledby', this.$name.id );

		this.$display = document.createElement( 'div' );
		this.$display.classList.add( 'display' );

		this.$select.addEventListener( 'change', () => {
			this.setValue( this._values[ this.$select.selectedIndex ] );
			this._callOnFinishChange();
		} );

		this.$select.addEventListener( 'focus', () => {
			this.$display.classList.add( 'focus' );
		} );

		this.$select.addEventListener( 'blur', () => {
			this.$display.classList.remove( 'focus' );
		} );

		this.$widget.appendChild( this.$select );
		this.$widget.appendChild( this.$display );

		this.$disable = this.$select;

		this.options( options );

	}

	options( options ) {

		this._values = Array.isArray( options ) ? options : Object.values( options );
		this._names = Array.isArray( options ) ? options : Object.keys( options );

		this.$select.replaceChildren();

		this._names.forEach( name => {
			const $option = document.createElement( 'option' );
			$option.textContent = name;
			this.$select.appendChild( $option );
		} );

		this.updateDisplay();

		return this;

	}

	updateDisplay() {
		const value = this.getValue();
		const index = this._values.indexOf( value );
		this.$select.selectedIndex = index;
		this.$display.textContent = index === -1 ? value : this._names[ index ];
		return this;
	}

}

class StringController extends Controller {

	constructor( parent, object, property ) {

		super( parent, object, property, 'string' );

		this.$input = document.createElement( 'input' );
		this.$input.setAttribute( 'type', 'text' );
		this.$input.setAttribute( 'spellcheck', 'false' );
		this.$input.setAttribute( 'aria-labelledby', this.$name.id );

		this.$input.addEventListener( 'input', () => {
			this.setValue( this.$input.value );
		} );

		this.$input.addEventListener( 'keydown', e => {
			if ( e.code === 'Enter' ) {
				this.$input.blur();
			}
		} );

		this.$input.addEventListener( 'blur', () => {
			this._callOnFinishChange();
		} );

		this.$widget.appendChild( this.$input );

		this.$disable = this.$input;

		this.updateDisplay();

	}

	updateDisplay() {
		this.$input.value = this.getValue();
		return this;
	}

}

var stylesheet = `.lil-gui {
  font-family: var(--font-family);
  font-size: var(--font-size);
  line-height: 1;
  font-weight: normal;
  font-style: normal;
  text-align: left;
  color: var(--text-color);
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  --background-color: #1f1f1f;
  --text-color: #ebebeb;
  --title-background-color: #111111;
  --title-text-color: #ebebeb;
  --widget-color: #424242;
  --hover-color: #4f4f4f;
  --focus-color: #595959;
  --number-color: #2cc9ff;
  --string-color: #a2db3c;
  --font-size: 11px;
  --input-font-size: 11px;
  --font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
  --font-family-mono: Menlo, Monaco, Consolas, "Droid Sans Mono", monospace;
  --padding: 4px;
  --spacing: 4px;
  --widget-height: 20px;
  --title-height: calc(var(--widget-height) + var(--spacing) * 1.25);
  --name-width: 45%;
  --slider-knob-width: 2px;
  --slider-input-width: 27%;
  --color-input-width: 27%;
  --slider-input-min-width: 45px;
  --color-input-min-width: 45px;
  --folder-indent: 7px;
  --widget-padding: 0 0 0 3px;
  --widget-border-radius: 2px;
  --checkbox-size: calc(0.75 * var(--widget-height));
  --scrollbar-width: 5px;
}
.lil-gui, .lil-gui * {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.lil-gui.root {
  width: var(--width, 245px);
  display: flex;
  flex-direction: column;
  background: var(--background-color);
}
.lil-gui.root > .title {
  background: var(--title-background-color);
  color: var(--title-text-color);
}
.lil-gui.root > .children {
  overflow-x: hidden;
  overflow-y: auto;
}
.lil-gui.root > .children::-webkit-scrollbar {
  width: var(--scrollbar-width);
  height: var(--scrollbar-width);
  background: var(--background-color);
}
.lil-gui.root > .children::-webkit-scrollbar-thumb {
  border-radius: var(--scrollbar-width);
  background: var(--focus-color);
}
@media (pointer: coarse) {
  .lil-gui.allow-touch-styles, .lil-gui.allow-touch-styles .lil-gui {
    --widget-height: 28px;
    --padding: 6px;
    --spacing: 6px;
    --font-size: 13px;
    --input-font-size: 16px;
    --folder-indent: 10px;
    --scrollbar-width: 7px;
    --slider-input-min-width: 50px;
    --color-input-min-width: 65px;
  }
}
.lil-gui.force-touch-styles, .lil-gui.force-touch-styles .lil-gui {
  --widget-height: 28px;
  --padding: 6px;
  --spacing: 6px;
  --font-size: 13px;
  --input-font-size: 16px;
  --folder-indent: 10px;
  --scrollbar-width: 7px;
  --slider-input-min-width: 50px;
  --color-input-min-width: 65px;
}
.lil-gui.autoPlace {
  max-height: 100%;
  position: fixed;
  top: 0;
  right: 15px;
  z-index: 1001;
}

.lil-gui .controller {
  display: flex;
  align-items: center;
  padding: 0 var(--padding);
  margin: var(--spacing) 0;
}
.lil-gui .controller.disabled {
  opacity: 0.5;
}
.lil-gui .controller.disabled, .lil-gui .controller.disabled * {
  pointer-events: none !important;
}
.lil-gui .controller > .name {
  min-width: var(--name-width);
  flex-shrink: 0;
  white-space: pre;
  padding-right: var(--spacing);
  line-height: var(--widget-height);
}
.lil-gui .controller .widget {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  min-height: var(--widget-height);
}
.lil-gui .controller.string input {
  color: var(--string-color);
}
.lil-gui .controller.boolean {
  cursor: pointer;
}
.lil-gui .controller.color .display {
  width: 100%;
  height: var(--widget-height);
  border-radius: var(--widget-border-radius);
  position: relative;
}
@media (hover: hover) {
  .lil-gui .controller.color .display:hover:before {
    content: " ";
    display: block;
    position: absolute;
    border-radius: var(--widget-border-radius);
    border: 1px solid #fff9;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
}
.lil-gui .controller.color input[type=color] {
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.lil-gui .controller.color input[type=text] {
  margin-left: var(--spacing);
  font-family: var(--font-family-mono);
  min-width: var(--color-input-min-width);
  width: var(--color-input-width);
  flex-shrink: 0;
}
.lil-gui .controller.option select {
  opacity: 0;
  position: absolute;
  width: 100%;
  max-width: 100%;
}
.lil-gui .controller.option .display {
  position: relative;
  pointer-events: none;
  border-radius: var(--widget-border-radius);
  height: var(--widget-height);
  line-height: var(--widget-height);
  max-width: 100%;
  overflow: hidden;
  word-break: break-all;
  padding-left: 0.55em;
  padding-right: 1.75em;
  background: var(--widget-color);
}
@media (hover: hover) {
  .lil-gui .controller.option .display.focus {
    background: var(--focus-color);
  }
}
.lil-gui .controller.option .display.active {
  background: var(--focus-color);
}
.lil-gui .controller.option .display:after {
  font-family: "lil-gui";
  content: "↕";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  padding-right: 0.375em;
}
.lil-gui .controller.option .widget,
.lil-gui .controller.option select {
  cursor: pointer;
}
@media (hover: hover) {
  .lil-gui .controller.option .widget:hover .display {
    background: var(--hover-color);
  }
}
.lil-gui .controller.number input {
  color: var(--number-color);
}
.lil-gui .controller.number.hasSlider input {
  margin-left: var(--spacing);
  width: var(--slider-input-width);
  min-width: var(--slider-input-min-width);
  flex-shrink: 0;
}
.lil-gui .controller.number .slider {
  width: 100%;
  height: var(--widget-height);
  background: var(--widget-color);
  border-radius: var(--widget-border-radius);
  padding-right: var(--slider-knob-width);
  overflow: hidden;
  cursor: ew-resize;
  touch-action: pan-y;
}
@media (hover: hover) {
  .lil-gui .controller.number .slider:hover {
    background: var(--hover-color);
  }
}
.lil-gui .controller.number .slider.active {
  background: var(--focus-color);
}
.lil-gui .controller.number .slider.active .fill {
  opacity: 0.95;
}
.lil-gui .controller.number .fill {
  height: 100%;
  border-right: var(--slider-knob-width) solid var(--number-color);
  box-sizing: content-box;
}

.lil-gui-dragging .lil-gui {
  --hover-color: var(--widget-color);
}
.lil-gui-dragging * {
  cursor: ew-resize !important;
}

.lil-gui-dragging.lil-gui-vertical * {
  cursor: ns-resize !important;
}

.lil-gui .title {
  height: var(--title-height);
  font-weight: 600;
  padding: 0 var(--padding);
  width: 100%;
  text-align: left;
  background: none;
  text-decoration-skip: objects;
}
.lil-gui .title:before {
  font-family: "lil-gui";
  content: "▾";
  padding-right: 2px;
  display: inline-block;
}
.lil-gui .title:active {
  background: var(--title-background-color);
  opacity: 0.75;
}
@media (hover: hover) {
  body:not(.lil-gui-dragging) .lil-gui .title:hover {
    background: var(--title-background-color);
    opacity: 0.85;
  }
  .lil-gui .title:focus {
    text-decoration: underline var(--focus-color);
  }
}
.lil-gui.root > .title:focus {
  text-decoration: none !important;
}
.lil-gui.closed > .title:before {
  content: "▸";
}
.lil-gui.closed > .children {
  transform: translateY(-7px);
  opacity: 0;
}
.lil-gui.closed:not(.transition) > .children {
  display: none;
}
.lil-gui.transition > .children {
  transition-duration: 300ms;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.2, 0.6, 0.35, 1);
  overflow: hidden;
  pointer-events: none;
}
.lil-gui .children:empty:before {
  content: "Empty";
  padding: 0 var(--padding);
  margin: var(--spacing) 0;
  display: block;
  height: var(--widget-height);
  font-style: italic;
  line-height: var(--widget-height);
  opacity: 0.5;
}
.lil-gui.root > .children > .lil-gui > .title {
  border: 0 solid var(--widget-color);
  border-width: 1px 0;
  transition: border-color 300ms;
}
.lil-gui.root > .children > .lil-gui.closed > .title {
  border-bottom-color: transparent;
}
.lil-gui + .controller {
  border-top: 1px solid var(--widget-color);
  margin-top: 0;
  padding-top: var(--spacing);
}
.lil-gui .lil-gui .lil-gui > .title {
  border: none;
}
.lil-gui .lil-gui .lil-gui > .children {
  border: none;
  margin-left: var(--folder-indent);
  border-left: 2px solid var(--widget-color);
}
.lil-gui .lil-gui .controller {
  border: none;
}

.lil-gui label, .lil-gui input, .lil-gui button {
  -webkit-tap-highlight-color: transparent;
}
.lil-gui input {
  border: 0;
  outline: none;
  font-family: var(--font-family);
  font-size: var(--input-font-size);
  border-radius: var(--widget-border-radius);
  height: var(--widget-height);
  background: var(--widget-color);
  color: var(--text-color);
  width: 100%;
}
@media (hover: hover) {
  .lil-gui input:hover {
    background: var(--hover-color);
  }
  .lil-gui input:active {
    background: var(--focus-color);
  }
}
.lil-gui input:disabled {
  opacity: 1;
}
.lil-gui input[type=text],
.lil-gui input[type=number] {
  padding: var(--widget-padding);
  -moz-appearance: textfield;
}
.lil-gui input[type=text]:focus,
.lil-gui input[type=number]:focus {
  background: var(--focus-color);
}
.lil-gui input[type=checkbox] {
  appearance: none;
  width: var(--checkbox-size);
  height: var(--checkbox-size);
  border-radius: var(--widget-border-radius);
  text-align: center;
  cursor: pointer;
}
.lil-gui input[type=checkbox]:checked:before {
  font-family: "lil-gui";
  content: "✓";
  font-size: var(--checkbox-size);
  line-height: var(--checkbox-size);
}
@media (hover: hover) {
  .lil-gui input[type=checkbox]:focus {
    box-shadow: inset 0 0 0 1px var(--focus-color);
  }
}
.lil-gui button {
  outline: none;
  cursor: pointer;
  font-family: var(--font-family);
  font-size: var(--font-size);
  color: var(--text-color);
  width: 100%;
  border: none;
}
.lil-gui .controller button {
  height: var(--widget-height);
  text-transform: none;
  background: var(--widget-color);
  border-radius: var(--widget-border-radius);
}
@media (hover: hover) {
  .lil-gui .controller button:hover {
    background: var(--hover-color);
  }
  .lil-gui .controller button:focus {
    box-shadow: inset 0 0 0 1px var(--focus-color);
  }
}
.lil-gui .controller button:active {
  background: var(--focus-color);
}

@font-face {
  font-family: "lil-gui";
  src: url("data:application/font-woff;charset=utf-8;base64,d09GRgABAAAAAAUsAAsAAAAACJwAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABHU1VCAAABCAAAAH4AAADAImwmYE9TLzIAAAGIAAAAPwAAAGBKqH5SY21hcAAAAcgAAAD0AAACrukyyJBnbHlmAAACvAAAAF8AAACEIZpWH2hlYWQAAAMcAAAAJwAAADZfcj2zaGhlYQAAA0QAAAAYAAAAJAC5AHhobXR4AAADXAAAABAAAABMAZAAAGxvY2EAAANsAAAAFAAAACgCEgIybWF4cAAAA4AAAAAeAAAAIAEfABJuYW1lAAADoAAAASIAAAIK9SUU/XBvc3QAAATEAAAAZgAAAJCTcMc2eJxVjbEOgjAURU+hFRBK1dGRL+ALnAiToyMLEzFpnPz/eAshwSa97517c/MwwJmeB9kwPl+0cf5+uGPZXsqPu4nvZabcSZldZ6kfyWnomFY/eScKqZNWupKJO6kXN3K9uCVoL7iInPr1X5baXs3tjuMqCtzEuagm/AAlzQgPAAB4nGNgYRBlnMDAysDAYM/gBiT5oLQBAwuDJAMDEwMrMwNWEJDmmsJwgCFeXZghBcjlZMgFCzOiKOIFAB71Bb8AeJy1kjFuwkAQRZ+DwRAwBtNQRUGKQ8OdKCAWUhAgKLhIuAsVSpWz5Bbkj3dEgYiUIszqWdpZe+Z7/wB1oCYmIoboiwiLT2WjKl/jscrHfGg/pKdMkyklC5Zs2LEfHYpjcRoPzme9MWWmk3dWbK9ObkWkikOetJ554fWyoEsmdSlt+uR0pCJR34b6t/TVg1SY3sYvdf8vuiKrpyaDXDISiegp17p7579Gp3p++y7HPAiY9pmTibljrr85qSidtlg4+l25GLCaS8e6rRxNBmsnERunKbaOObRz7N72ju5vdAjYpBXHgJylOAVsMseDAPEP8LYoUHicY2BiAAEfhiAGJgZWBgZ7RnFRdnVJELCQlBSRlATJMoLV2DK4glSYs6ubq5vbKrJLSbGrgEmovDuDJVhe3VzcXFwNLCOILB/C4IuQ1xTn5FPilBTj5FPmBAB4WwoqAHicY2BkYGAA4sk1sR/j+W2+MnAzpDBgAyEMQUCSg4EJxAEAwUgFHgB4nGNgZGBgSGFggJMhDIwMqEAYAByHATJ4nGNgAIIUNEwmAABl3AGReJxjYAACIQYlBiMGJ3wQAEcQBEV4nGNgZGBgEGZgY2BiAAEQyQWEDAz/wXwGAAsPATIAAHicXdBNSsNAHAXwl35iA0UQXYnMShfS9GPZA7T7LgIu03SSpkwzYTIt1BN4Ak/gKTyAeCxfw39jZkjymzcvAwmAW/wgwHUEGDb36+jQQ3GXGot79L24jxCP4gHzF/EIr4jEIe7wxhOC3g2TMYy4Q7+Lu/SHuEd/ivt4wJd4wPxbPEKMX3GI5+DJFGaSn4qNzk8mcbKSR6xdXdhSzaOZJGtdapd4vVPbi6rP+cL7TGXOHtXKll4bY1Xl7EGnPtp7Xy2n00zyKLVHfkHBa4IcJ2oD3cgggWvt/V/FbDrUlEUJhTn/0azVWbNTNr0Ens8de1tceK9xZmfB1CPjOmPH4kitmvOubcNpmVTN3oFJyjzCvnmrwhJTzqzVj9jiSX911FjeAAB4nG3HMRKCMBBA0f0giiKi4DU8k0V2GWbIZDOh4PoWWvq6J5V8If9NVNQcaDhyouXMhY4rPTcG7jwYmXhKq8Wz+p762aNaeYXom2n3m2dLTVgsrCgFJ7OTmIkYbwIbC6vIB7WmFfAAAA==") format("woff");
}`;

function _injectStyles( cssContent ) {
	const injected = document.createElement( 'style' );
	injected.innerHTML = cssContent;
	const before = document.querySelector( 'head link[rel=stylesheet], head style' );
	if ( before ) {
		document.head.insertBefore( injected, before );
	} else {
		document.head.appendChild( injected );
	}
}


let stylesInjected = false;

class GUI {

	/**
	 * Creates a panel that holds controllers.
	 * @example
	 * new GUI();
	 * new GUI( { container: document.getElementById( 'custom' ) } );
	 *
	 * @param {object} [options]
	 * @param {boolean} [options.autoPlace=true]
	 * Adds the GUI to `document.body` and fixes it to the top right of the page.
	 *
	 * @param {HTMLElement} [options.container]
	 * Adds the GUI to this DOM element. Overrides `autoPlace`.
	 *
	 * @param {number} [options.width=245]
	 * Width of the GUI in pixels, usually set when name labels become too long. Note that you can make
	 * name labels wider in CSS with `.lil‑gui { ‑‑name‑width: 55% }`.
	 *
	 * @param {string} [options.title=Controls]
	 * Name to display in the title bar.
	 *
	 * @param {boolean} [options.closeFolders=false]
	 * Pass `true` to close all folders in this GUI by default.
	 *
	 * @param {boolean} [options.injectStyles=true]
	 * Injects the default stylesheet into the page if this is the first GUI.
	 * Pass `false` to use your own stylesheet.
	 *
	 * @param {number} [options.touchStyles=true]
	 * Makes controllers larger on touch devices. Pass `false` to disable touch styles.
	 *
	 * @param {GUI} [options.parent]
	 * Adds this GUI as a child in another GUI. Usually this is done for you by `addFolder()`.
	 */
	constructor( {
		parent,
		autoPlace = parent === undefined,
		container,
		width,
		title = 'Controls',
		closeFolders = false,
		injectStyles = true,
		touchStyles = true
	} = {} ) {

		/**
		 * The GUI containing this folder, or `undefined` if this is the root GUI.
		 * @type {GUI}
		 */
		this.parent = parent;

		/**
		 * The top level GUI containing this folder, or `this` if this is the root GUI.
		 * @type {GUI}
		 */
		this.root = parent ? parent.root : this;

		/**
		 * The list of controllers and folders contained by this GUI.
		 * @type {Array<GUI|Controller>}
		 */
		this.children = [];

		/**
		 * The list of controllers contained by this GUI.
		 * @type {Array<Controller>}
		 */
		this.controllers = [];

		/**
		 * The list of folders contained by this GUI.
		 * @type {Array<GUI>}
		 */
		this.folders = [];

		/**
		 * Used to determine if the GUI is closed. Use `gui.open()` or `gui.close()` to change this.
		 * @type {boolean}
		 */
		this._closed = false;

		/**
		 * Used to determine if the GUI is hidden. Use `gui.show()` or `gui.hide()` to change this.
		 * @type {boolean}
		 */
		this._hidden = false;

		/**
		 * The outermost container element.
		 * @type {HTMLElement}
		 */
		this.domElement = document.createElement( 'div' );
		this.domElement.classList.add( 'lil-gui' );

		/**
		 * The DOM element that contains the title.
		 * @type {HTMLElement}
		 */
		this.$title = document.createElement( 'button' );
		this.$title.classList.add( 'title' );
		this.$title.setAttribute( 'aria-expanded', true );

		this.$title.addEventListener( 'click', () => this.openAnimated( this._closed ) );

		// enables :active pseudo class on mobile
		this.$title.addEventListener( 'touchstart', () => {}, { passive: true } );

		/**
		 * The DOM element that contains children.
		 * @type {HTMLElement}
		 */
		this.$children = document.createElement( 'div' );
		this.$children.classList.add( 'children' );

		this.domElement.appendChild( this.$title );
		this.domElement.appendChild( this.$children );

		this.title( title );

		if ( this.parent ) {

			this.parent.children.push( this );
			this.parent.folders.push( this );

			this.parent.$children.appendChild( this.domElement );

			// Stop the constructor early, everything onward only applies to root GUI's
			return;

		}

		this.domElement.classList.add( 'root' );

		if ( touchStyles ) {
			this.domElement.classList.add( 'allow-touch-styles' );
		}

		// Inject stylesheet if we haven't done that yet
		if ( !stylesInjected && injectStyles ) {
			_injectStyles( stylesheet );
			stylesInjected = true;
		}

		if ( container ) {

			container.appendChild( this.domElement );

		} else if ( autoPlace ) {

			this.domElement.classList.add( 'autoPlace' );
			document.body.appendChild( this.domElement );

		}

		if ( width ) {
			this.domElement.style.setProperty( '--width', width + 'px' );
		}

		this._closeFolders = closeFolders;

	}

	/**
	 * Adds a controller to the GUI, inferring controller type using the `typeof` operator.
	 * @example
	 * gui.add( object, 'property' );
	 * gui.add( object, 'number', 0, 100, 1 );
	 * gui.add( object, 'options', [ 1, 2, 3 ] );
	 *
	 * @param {object} object The object the controller will modify.
	 * @param {string} property Name of the property to control.
	 * @param {number|object|Array} [$1] Minimum value for number controllers, or the set of
	 * selectable values for a dropdown.
	 * @param {number} [max] Maximum value for number controllers.
	 * @param {number} [step] Step value for number controllers.
	 * @returns {Controller}
	 */
	add( object, property, $1, max, step ) {

		if ( Object( $1 ) === $1 ) {

			return new OptionController( this, object, property, $1 );

		}

		const initialValue = object[ property ];

		switch ( typeof initialValue ) {

			case 'number':

				return new NumberController( this, object, property, $1, max, step );

			case 'boolean':

				return new BooleanController( this, object, property );

			case 'string':

				return new StringController( this, object, property );

			case 'function':

				return new FunctionController( this, object, property );

		}

		console.error( `gui.add failed
	property:`, property, `
	object:`, object, `
	value:`, initialValue );

	}

	/**
	 * Adds a color controller to the GUI.
	 * @example
	 * params = {
	 * 	cssColor: '#ff00ff',
	 * 	rgbColor: { r: 0, g: 0.2, b: 0.4 },
	 * 	customRange: [ 0, 127, 255 ],
	 * };
	 *
	 * gui.addColor( params, 'cssColor' );
	 * gui.addColor( params, 'rgbColor' );
	 * gui.addColor( params, 'customRange', 255 );
	 *
	 * @param {object} object The object the controller will modify.
	 * @param {string} property Name of the property to control.
	 * @param {number} rgbScale Maximum value for a color channel when using an RGB color. You may
	 * need to set this to 255 if your colors are too bright.
	 * @returns {Controller}
	 */
	addColor( object, property, rgbScale = 1 ) {
		return new ColorController( this, object, property, rgbScale );
	}

	/**
	 * Adds a folder to the GUI, which is just another GUI. This method returns
	 * the nested GUI so you can add controllers to it.
	 * @example
	 * const folder = gui.addFolder( 'Position' );
	 * folder.add( position, 'x' );
	 * folder.add( position, 'y' );
	 * folder.add( position, 'z' );
	 *
	 * @param {string} title Name to display in the folder's title bar.
	 * @returns {GUI}
	 */
	addFolder( title ) {
		const folder = new GUI( { parent: this, title } );
		if ( this.root._closeFolders ) folder.close();
		return folder;
	}

	/**
	 * Recalls values that were saved with `gui.save()`.
	 * @param {object} obj
	 * @param {boolean} recursive Pass false to exclude folders descending from this GUI.
	 * @returns {this}
	 */
	load( obj, recursive = true ) {

		if ( obj.controllers ) {

			this.controllers.forEach( c => {

				if ( c instanceof FunctionController ) return;

				if ( c._name in obj.controllers ) {
					c.load( obj.controllers[ c._name ] );
				}

			} );

		}

		if ( recursive && obj.folders ) {

			this.folders.forEach( f => {

				if ( f._title in obj.folders ) {
					f.load( obj.folders[ f._title ] );
				}

			} );

		}

		return this;

	}

	/**
	 * Returns an object mapping controller names to values. The object can be passed to `gui.load()` to
	 * recall these values.
	 * @example
	 * {
	 * 	controllers: {
	 * 		prop1: 1,
	 * 		prop2: 'value',
	 * 		...
	 * 	},
	 * 	folders: {
	 * 		folderName1: { controllers, folders },
	 * 		folderName2: { controllers, folders }
	 * 		...
	 * 	}
	 * }
	 *
	 * @param {boolean} recursive Pass false to exclude folders descending from this GUI.
	 * @returns {object}
	 */
	save( recursive = true ) {

		const obj = {
			controllers: {},
			folders: {}
		};

		this.controllers.forEach( c => {

			if ( c instanceof FunctionController ) return;

			if ( c._name in obj.controllers ) {
				throw new Error( `Cannot save GUI with duplicate property "${c._name}"` );
			}

			obj.controllers[ c._name ] = c.save();

		} );

		if ( recursive ) {

			this.folders.forEach( f => {

				if ( f._title in obj.folders ) {
					throw new Error( `Cannot save GUI with duplicate folder "${f._title}"` );
				}

				obj.folders[ f._title ] = f.save();

			} );

		}

		return obj;

	}

	/**
	 * Opens a GUI or folder. GUI and folders are open by default.
	 * @param {boolean} open Pass false to close.
	 * @returns {this}
	 * @example
	 * gui.open(); // open
	 * gui.open( false ); // close
	 * gui.open( gui._closed ); // toggle
	 */
	open( open = true ) {

		this._setClosed( !open );

		this.$title.setAttribute( 'aria-expanded', !this._closed );
		this.domElement.classList.toggle( 'closed', this._closed );

		return this;

	}

	/**
	 * Closes the GUI.
	 * @returns {this}
	 */
	close() {
		return this.open( false );
	}

	_setClosed( closed ) {
		if ( this._closed === closed ) return;
		this._closed = closed;
		this._callOnOpenClose( this );
	}

	/**
	 * Shows the GUI after it's been hidden.
	 * @param {boolean} show
	 * @returns {this}
	 * @example
	 * gui.show();
	 * gui.show( false ); // hide
	 * gui.show( gui._hidden ); // toggle
	 */
	show( show = true ) {

		this._hidden = !show;

		this.domElement.style.display = this._hidden ? 'none' : '';

		return this;

	}

	/**
	 * Hides the GUI.
	 * @returns {this}
	 */
	hide() {
		return this.show( false );
	}

	openAnimated( open = true ) {

		// set state immediately
		this._setClosed( !open );

		this.$title.setAttribute( 'aria-expanded', !this._closed );

		// wait for next frame to measure $children
		requestAnimationFrame( () => {

			// explicitly set initial height for transition
			const initialHeight = this.$children.clientHeight;
			this.$children.style.height = initialHeight + 'px';

			this.domElement.classList.add( 'transition' );

			const onTransitionEnd = e => {
				if ( e.target !== this.$children ) return;
				this.$children.style.height = '';
				this.domElement.classList.remove( 'transition' );
				this.$children.removeEventListener( 'transitionend', onTransitionEnd );
			};

			this.$children.addEventListener( 'transitionend', onTransitionEnd );

			// todo: this is wrong if children's scrollHeight makes for a gui taller than maxHeight
			const targetHeight = !open ? 0 : this.$children.scrollHeight;

			this.domElement.classList.toggle( 'closed', !open );

			requestAnimationFrame( () => {
				this.$children.style.height = targetHeight + 'px';
			} );

		} );

		return this;

	}

	/**
	 * Change the title of this GUI.
	 * @param {string} title
	 * @returns {this}
	 */
	title( title ) {
		/**
		 * Current title of the GUI. Use `gui.title( 'Title' )` to modify this value.
		 * @type {string}
		 */
		this._title = title;
		this.$title.textContent = title;
		return this;
	}

	/**
	 * Resets all controllers to their initial values.
	 * @param {boolean} recursive Pass false to exclude folders descending from this GUI.
	 * @returns {this}
	 */
	reset( recursive = true ) {
		const controllers = recursive ? this.controllersRecursive() : this.controllers;
		controllers.forEach( c => c.reset() );
		return this;
	}

	/**
	 * Pass a function to be called whenever a controller in this GUI changes.
	 * @param {function({object:object, property:string, value:any, controller:Controller})} callback
	 * @returns {this}
	 * @example
	 * gui.onChange( event => {
	 * 	event.object     // object that was modified
	 * 	event.property   // string, name of property
	 * 	event.value      // new value of controller
	 * 	event.controller // controller that was modified
	 * } );
	 */
	onChange( callback ) {
		/**
		 * Used to access the function bound to `onChange` events. Don't modify this value
		 * directly. Use the `gui.onChange( callback )` method instead.
		 * @type {Function}
		 */
		this._onChange = callback;
		return this;
	}

	_callOnChange( controller ) {

		if ( this.parent ) {
			this.parent._callOnChange( controller );
		}

		if ( this._onChange !== undefined ) {
			this._onChange.call( this, {
				object: controller.object,
				property: controller.property,
				value: controller.getValue(),
				controller
			} );
		}
	}

	/**
	 * Pass a function to be called whenever a controller in this GUI has finished changing.
	 * @param {function({object:object, property:string, value:any, controller:Controller})} callback
	 * @returns {this}
	 * @example
	 * gui.onFinishChange( event => {
	 * 	event.object     // object that was modified
	 * 	event.property   // string, name of property
	 * 	event.value      // new value of controller
	 * 	event.controller // controller that was modified
	 * } );
	 */
	onFinishChange( callback ) {
		/**
		 * Used to access the function bound to `onFinishChange` events. Don't modify this value
		 * directly. Use the `gui.onFinishChange( callback )` method instead.
		 * @type {Function}
		 */
		this._onFinishChange = callback;
		return this;
	}

	_callOnFinishChange( controller ) {

		if ( this.parent ) {
			this.parent._callOnFinishChange( controller );
		}

		if ( this._onFinishChange !== undefined ) {
			this._onFinishChange.call( this, {
				object: controller.object,
				property: controller.property,
				value: controller.getValue(),
				controller
			} );
		}
	}

	/**
	 * Pass a function to be called when this GUI or its descendants are opened or closed.
	 * @param {function(GUI)} callback
	 * @returns {this}
	 * @example
	 * gui.onOpenClose( changedGUI => {
	 * 	console.log( changedGUI._closed );
	 * } );
	 */
	onOpenClose( callback ) {
		this._onOpenClose = callback;
		return this;
	}

	_callOnOpenClose( changedGUI ) {
		if ( this.parent ) {
			this.parent._callOnOpenClose( changedGUI );
		}

		if ( this._onOpenClose !== undefined ) {
			this._onOpenClose.call( this, changedGUI );
		}
	}

	/**
	 * Destroys all DOM elements and event listeners associated with this GUI.
	 */
	destroy() {

		if ( this.parent ) {
			this.parent.children.splice( this.parent.children.indexOf( this ), 1 );
			this.parent.folders.splice( this.parent.folders.indexOf( this ), 1 );
		}

		if ( this.domElement.parentElement ) {
			this.domElement.parentElement.removeChild( this.domElement );
		}

		Array.from( this.children ).forEach( c => c.destroy() );

	}

	/**
	 * Returns an array of controllers contained by this GUI and its descendents.
	 * @returns {Controller[]}
	 */
	controllersRecursive() {
		let controllers = Array.from( this.controllers );
		this.folders.forEach( f => {
			controllers = controllers.concat( f.controllersRecursive() );
		} );
		return controllers;
	}

	/**
	 * Returns an array of folders contained by this GUI and its descendents.
	 * @returns {GUI[]}
	 */
	foldersRecursive() {
		let folders = Array.from( this.folders );
		this.folders.forEach( f => {
			folders = folders.concat( f.foldersRecursive() );
		} );
		return folders;
	}

}




/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/nonce */
/******/ 	(() => {
/******/ 		__webpack_require__.nc = undefined;
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(713);
/******/ 	
/******/ 	return __webpack_exports__;
/******/ })()
;
});